


  
  

  var faTurnUp = {
    prefix: 'fat',
    iconName: 'turn-up',
    icon: [
      384,
      512,
      [10548,"level-up-alt"],
      'f3bf',
      
      'M144 176H54.9c-3.8 0-6.9-3.1-6.9-6.9c0-1.8 .7-3.5 1.9-4.7L190.1 16.8c.5-.5 1.2-.8 1.9-.8s1.4 .3 1.9 .8L334.1 164.4c1.2 1.3 1.9 3 1.9 4.7c0 3.8-3.1 6.9-6.9 6.9H240c-8.8 0-16 7.2-16 16V400c0 53-43 96-96 96H40c-13.3 0-24-10.7-24-24V456c0-13.3 10.7-24 24-24l88 0c17.7 0 32-14.3 32-32V192c0-8.8-7.2-16-16-16zM178.5 5.8L38.3 153.4c-4 4.3-6.3 9.9-6.3 15.8C32 181.8 42.2 192 54.9 192H128h16v16V400c0 8.8-7.2 16-16 16l-88 0c-22.1 0-40 17.9-40 40v16c0 22.1 17.9 40 40 40h88c61.9 0 112-50.1 112-112V208 192h16 73.1c12.6 0 22.9-10.2 22.9-22.9c0-5.9-2.3-11.5-6.3-15.8L205.5 5.8C202 2.1 197.1 0 192 0s-10 2.1-13.5 5.8z'
      
    ]
  };

  
    var faLevelUpAlt = faTurnUp;
  

  
  

  var faMessageText = {
    prefix: 'fat',
    iconName: 'message-text',
    icon: [
      512,
      512,
      ["comment-alt-text"],
      'e1e6',
      
      'M176 416c0-8.8-7.2-16-16-16H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H309.3c-3.5 0-6.8 1.1-9.6 3.2L176 496V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h80 16v16 64c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM168 144c-4.4 0-8 3.6-8 8s3.6 8 8 8h80V296c0 4.4 3.6 8 8 8s8-3.6 8-8V160h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H256 168z'
      
    ]
  };

  
    var faCommentAltText = faMessageText;
  

  
  

  var faSquareZ = {
    prefix: 'fat',
    iconName: 'square-z',
    icon: [
      448,
      512,
      [],
      'e288',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 32H320c3.1 0 5.9 1.8 7.2 4.5s1 6.1-1 8.5L144.6 368H320c4.4 0 8 3.6 8 8s-3.6 8-8 8H128c-3.1 0-5.9-1.8-7.2-4.5s-1-6.1 1-8.5L303.4 144H128c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faPersonCircleCheck = {
    prefix: 'fat',
    iconName: 'person-circle-check',
    icon: [
      576,
      512,
      [],
      'e53e',
      
      'M160 16a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm0 96A56 56 0 1 0 160 0a56 56 0 1 0 0 112zm-18.9 32h37.8c21.5 0 41.1 12.3 50.4 31.7l50.3 104.2c3.1-5.4 6.5-10.6 10.2-15.6l-46.1-95.5c-12-24.9-37.2-40.7-64.8-40.7H141.1c-27.6 0-52.8 15.8-64.8 40.7L8.8 308.5c-1.9 4-.3 8.8 3.7 10.7s8.8 .3 10.7-3.7L90.7 175.7c9.3-19.4 28.9-31.7 50.4-31.7zM104 248c0-4.4-3.6-8-8-8s-8 3.6-8 8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V360c0-4.4 3.6-8 8-8s8 3.6 8 8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V248c0-4.4-3.6-8-8-8s-8 3.6-8 8V480c0 8.8-7.2 16-16 16s-16-7.2-16-16V360c0-13.3-10.7-24-24-24s-24 10.7-24 24V480c0 8.8-7.2 16-16 16s-16-7.2-16-16V248zm328-8a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm69.7-189.7c-3.1-3.1-8.2-3.1-11.3 0L416 396.7l-42.3-42.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l48 48c3.1 3.1 8.2 3.1 11.3 0l80-80c3.1-3.1 3.1-8.2 0-11.3z'
      
    ]
  };

  

  
  

  var faHandHoldingMedical = {
    prefix: 'fat',
    iconName: 'hand-holding-medical',
    icon: [
      543,
      512,
      [],
      'e05c',
      
      'M243.9 51.5c0-4.2 3.4-7.5 7.5-7.5h40.2c4.2 0 7.5 3.4 7.5 7.5v64c0 4.2 3.4 7.5 7.5 7.5h64c4.2 0 7.5 3.4 7.5 7.5v40.2c0 4.2-3.4 7.5-7.5 7.5h-64c-4.2 0-7.5 3.4-7.5 7.5v64c0 4.2-3.4 7.5-7.5 7.5H251.4c-4.2 0-7.5-3.4-7.5-7.5v-64c0-4.2-3.4-7.5-7.5-7.5h-64c-4.2 0-7.5-3.4-7.5-7.5V130.5c0-4.2 3.4-7.5 7.5-7.5h64c4.2 0 7.5-3.4 7.5-7.5v-64zm7.5-22.6c-12.5 0-22.6 10.1-22.6 22.6v56.5H172.4c-12.5 0-22.6 10.1-22.6 22.6v40.2c0 12.5 10.1 22.6 22.6 22.6h56.5v56.5c0 12.5 10.1 22.6 22.6 22.6h40.2c12.5 0 22.6-10.1 22.6-22.6V193.3h56.5c12.5 0 22.6-10.1 22.6-22.6V130.5c0-12.5-10.1-22.6-22.6-22.6H314.2V51.5c0-12.5-10.1-22.6-22.6-22.6H251.4zM491.5 350.8c10-7.4 24.2-5.3 31.6 4.8s5.3 24.2-4.8 31.6L399.2 474.9c-19.4 14.3-42.9 22-67 22H8c-4.2 0-7.5 3.4-7.5 7.5s3.4 7.5 7.5 7.5H332.2c27.3 0 53.9-8.7 75.9-25l119.2-87.8c16.7-12.3 20.3-35.9 8-52.6s-35.9-20.3-52.6-8L371.9 420.2c-1.3 1-2.9 1.5-4.5 1.5H252.7c-6.2 0-11.3-5.1-11.3-11.3s5.1-11.3 11.3-11.3H328c18.7 0 33.9-15.2 33.9-33.9s-15.2-33.9-33.9-33.9H182.7c-27.4 0-53.9 9.3-75.3 26.4L67.2 389.9c-1.3 1.1-3 1.7-4.7 1.7H8c-4.2 0-7.5 3.4-7.5 7.5s3.4 7.5 7.5 7.5H62.5c5.1 0 10.1-1.7 14.1-5l40.2-32.2c18.7-15 41.9-23.1 65.9-23.1H328c10.4 0 18.8 8.4 18.8 18.8s-8.4 18.8-18.8 18.8H252.7c-14.6 0-26.4 11.8-26.4 26.4s11.8 26.4 26.4 26.4H367.4c4.8 0 9.5-1.5 13.4-4.4l110.7-81.5z'
      
    ]
  };

  

  
  

  var faGraduationCap = {
    prefix: 'fat',
    iconName: 'graduation-cap',
    icon: [
      640,
      512,
      [127891,"mortar-board"],
      'f19d',
      
      'M301.8 51.2L21.3 152.5c-3.2 1.1-5.3 4.2-5.3 7.5s2.1 6.4 5.3 7.5L115 201.4c12.7-10.1 27-18.4 42.8-24.3l159.4-59.8c4.1-1.6 8.7 .5 10.3 4.7s-.5 8.7-4.7 10.3L163.4 192.1c-10.9 4.1-21 9.4-30.3 15.8l168.7 60.9c5.8 2.1 12 3.2 18.2 3.2s12.4-1.1 18.2-3.2L618.7 167.5c3.2-1.1 5.3-4.2 5.3-7.5s-2.1-6.4-5.3-7.5L338.2 51.2c-5.8-2.1-12-3.2-18.2-3.2s-12.4 1.1-18.2 3.2zm-5.4 232.7L118.3 219.6c-27.7 25.1-44.8 60.6-46.2 99.2l7.1 18.9c11.1 29.6 16.8 61 16.8 92.7V472c0 2.5-1.2 4.9-3.2 6.4s-4.7 2-7.1 1.2l-80-24c-2.6-.8-4.6-2.8-5.4-5.4s-.2-5.4 1.5-7.4l8.8-10.5c19.6-23.6 33.1-51.6 39.1-81.7l6.4-31.8c1.3-40.3 18-77.7 45.4-105.3L15.8 182.6C6.3 179.1 0 170.1 0 160s6.3-19.1 15.8-22.6L296.3 36.1c7.6-2.7 15.6-4.1 23.7-4.1s16.1 1.4 23.7 4.1L624.2 137.4c9.5 3.4 15.8 12.5 15.8 22.6s-6.3 19.1-15.8 22.6L343.7 283.9c-7.6 2.7-15.6 4.1-23.7 4.1s-16.1-1.4-23.7-4.1zM158.8 268.2L144 408.6c.2 2.4 2 7 9.5 13.5c7.9 6.8 20.1 13.9 36.5 20.3C222.7 455.1 268.6 464 320 464s97.3-8.9 129.9-21.6c16.4-6.4 28.6-13.5 36.5-20.3c7.5-6.5 9.3-11.2 9.5-13.5L481.2 268.2l15.5-5.6L512 408c0 35.3-86 72-192 72s-192-36.7-192-72l15.3-145.4 15.5 5.6zM65.4 353.8c-6.5 32.7-21.1 63.2-42.5 88.8l-1 1.2L80 461.2V430.4c0-27.7-4.6-55.1-13.7-81.2l-.9 4.6z'
      
    ]
  };

  
    var faMortarBoard = faGraduationCap;
  

  
  

  var faMessageMiddle = {
    prefix: 'fat',
    iconName: 'message-middle',
    icon: [
      512,
      512,
      ["comment-middle-alt"],
      'e1e1',
      
      'M343.5 400H448c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H64C37.5 16 16 37.5 16 64V352c0 26.5 21.5 48 48 48H168.5c4.7 0 9.3 2.1 12.3 5.8L256 496l75.2-90.2c3-3.6 7.5-5.8 12.3-5.8zm-175 16H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H343.5l-75.2 90.2c-3 3.6-7.5 5.8-12.3 5.8s-9.3-2.1-12.3-5.8L168.5 416z'
      
    ]
  };

  
    var faCommentMiddleAlt = faMessageMiddle;
  

  
  

  var faVideo = {
    prefix: 'fat',
    iconName: 'video',
    icon: [
      576,
      512,
      ["video-camera"],
      'f03d',
      
      'M64 80c-26.5 0-48 21.5-48 48V384c0 26.5 21.5 48 48 48H320c26.5 0 48-21.5 48-48V309.1 202.9 128c0-26.5-21.5-48-48-48H64zM384 336.8V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64v47.2 27.7V309.1v27.7zm135.4 74.5L416 354.4V336.1l111.1 61.1c3.3 1.8 7 2.7 10.7 2.7c12.3 0 22.2-9.9 22.2-22.2V134.2c0-12.3-9.9-22.2-22.2-22.2c-3.7 0-7.4 .9-10.7 2.7L416 175.9V157.6l103.4-56.9c5.6-3.1 12-4.7 18.4-4.7c21.1 0 38.2 17.1 38.2 38.2V377.8c0 21.1-17.1 38.2-38.2 38.2c-6.4 0-12.8-1.6-18.4-4.7z'
      
    ]
  };

  
    var faVideoCamera = faVideo;
  

  
  

  var faSquareSlidersVertical = {
    prefix: 'fat',
    iconName: 'square-sliders-vertical',
    icon: [
      448,
      512,
      ["sliders-v-square"],
      'f3f2',
      
      'M384 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm72 64c-4.4 0-8 3.6-8 8v56H104c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H144V104c0-4.4-3.6-8-8-8zm0 80h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H104c-8.8 0-16-7.2-16-16s7.2-16 16-16h32zm0 80c-4.4 0-8 3.6-8 8V408c0 4.4 3.6 8 8 8s8-3.6 8-8V264c0-4.4-3.6-8-8-8zM320 104c0-4.4-3.6-8-8-8s-8 3.6-8 8V256H280c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320V104zM280 272h32 32c8.8 0 16 7.2 16 16s-7.2 16-16 16H280c-8.8 0-16-7.2-16-16s7.2-16 16-16zm40 88c0-4.4-3.6-8-8-8s-8 3.6-8 8v48c0 4.4 3.6 8 8 8s8-3.6 8-8V360z'
      
    ]
  };

  
    var faSlidersVSquare = faSquareSlidersVertical;
  

  
  

  var faPlusMinus = {
    prefix: 'fat',
    iconName: 'plus-minus',
    icon: [
      384,
      512,
      [],
      'e43c',
      
      'M184 200V360c0 4.4 3.6 8 8 8s8-3.6 8-8V200H360c4.4 0 8-3.6 8-8s-3.6-8-8-8H200V24c0-4.4-3.6-8-8-8s-8 3.6-8 8V184H24c-4.4 0-8 3.6-8 8s3.6 8 8 8H184zM8 472c0 4.4 3.6 8 8 8H368c4.4 0 8-3.6 8-8s-3.6-8-8-8H16c-4.4 0-8 3.6-8 8z'
      
    ]
  };

  

  
  

  var faBulldozer = {
    prefix: 'fat',
    iconName: 'bulldozer',
    icon: [
      640,
      512,
      [],
      'e655',
      
      'M48 72c0-13.3 10.7-24 24-24H173.1c8.8 0 16.8 4.8 21 12.4L266.5 192H48V72zm0 136H279.9h.3H352h40c22.1 0 40 17.9 40 40v56 4.1c-18.1-12.7-40.2-20.1-64-20.1H112c-23.8 0-45.9 7.4-64 20.1V224 208zm400 96V248c0-30.9-25.1-56-56-56H360V128c0-4.4-3.6-8-8-8s-8 3.6-8 8v64H284.7L208.1 52.7c-7-12.8-20.5-20.7-35-20.7H72C49.9 32 32 49.9 32 72V192v8 24 96h1.6C12.9 340.3 0 368.7 0 400c0 61.9 50.1 112 112 112H368c61.9 0 112-50.1 112-112c0-31.3-12.9-59.7-33.6-80H448h88v56.6c0 17 6 33.5 17 46.5l72.9 86.1c2.9 3.4 7.9 3.8 11.3 .9s3.8-7.9 .9-11.3l-72.9-86.1c-8.6-10.1-13.3-22.9-13.3-36.2V263.4c0-13.2 4.7-26.1 13.3-36.2l72.9-86.1c2.9-3.4 2.4-8.4-.9-11.3s-8.4-2.4-11.3 .9L553 216.9c-11 13-17 29.5-17 46.5V304H448zm-336 0H368c53 0 96 43 96 96s-43 96-96 96H112c-53 0-96-43-96-96s43-96 96-96zM96 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm304-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM288 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faBarcode = {
    prefix: 'fat',
    iconName: 'barcode',
    icon: [
      512,
      512,
      [],
      'f02a',
      
      'M0 40c0-4.4 3.6-8 8-8s8 3.6 8 8V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V40zm256 0c0-4.4 3.6-8 8-8s8 3.6 8 8V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V40zm136-8c4.4 0 8 3.6 8 8V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V40c0-4.4 3.6-8 8-8zm-88 8c0-4.4 3.6-8 8-8s8 3.6 8 8V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V40zM56 32c4.4 0 8 3.6 8 8V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V40c0-4.4 3.6-8 8-8zm392 8c0-4.4 3.6-8 8-8s8 3.6 8 8V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V40zm56-8c4.4 0 8 3.6 8 8V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V40c0-4.4 3.6-8 8-8zM112 40c0-4.4 3.6-8 8-8s8 3.6 8 8V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V40zm80-8c4.4 0 8 3.6 8 8V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V40c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faFileMp4 = {
    prefix: 'fat',
    iconName: 'file-mp4',
    icon: [
      512,
      512,
      [],
      'e649',
      
      'M64 496H80v16H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H204.1c12.7 0 24.9 5.1 33.9 14.1L369.9 145.9c9 9 14.1 21.2 14.1 33.9V304H368V179.9c0-1.3-.1-2.6-.2-3.9H248c-22.1 0-40-17.9-40-40V16.2c-1.3-.2-2.6-.2-3.9-.2H64C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48zM361.1 160c-.8-1-1.6-1.9-2.4-2.7L226.7 25.4c-.9-.9-1.8-1.7-2.7-2.4V136c0 13.3 10.7 24 24 24H361.1zM150.7 371.6l41.3 62 41.3-62c2-2.9 5.6-4.2 9-3.2s5.7 4.1 5.7 7.7V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V402.4l-33.3 50c-1.5 2.2-4 3.6-6.7 3.6s-5.2-1.3-6.7-3.6l-33.3-50V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V376c0-3.5 2.3-6.6 5.7-7.7s7 .3 9 3.2zM304 368h32c26.5 0 48 21.5 48 48s-21.5 48-48 48H312v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V456 376c0-4.4 3.6-8 8-8zm32 80c17.7 0 32-14.3 32-32s-14.3-32-32-32H312v64h24zm90.3-2.3c-1.5-1.5-2.3-3.5-2.3-5.7V376c0-4.4 3.6-8 8-8s8 3.6 8 8v56h48V376c0-4.4 3.6-8 8-8s8 3.6 8 8v64 64c0 4.4-3.6 8-8 8s-8-3.6-8-8V448H432c-2.1 0-4.2-.8-5.7-2.3z'
      
    ]
  };

  

  
  

  var faShieldKeyhole = {
    prefix: 'fat',
    iconName: 'shield-keyhole',
    icon: [
      512,
      512,
      [],
      'e248',
      
      'M237.3 22.6c12-5.1 25.5-5.1 37.5 0l176.7 75c16.6 7.1 28.6 23.2 28.5 42.4c-.5 96.6-40.3 270.2-204.5 348.8c-12.3 5.9-26.7 5.9-39 0C72.3 410.1 32.5 236.5 32 139.9c-.1-19.1 11.9-35.3 28.5-42.4l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM256 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm48 32c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 23.8 17.3 43.5 40 47.3V328c0 4.4 3.6 8 8 8s8-3.6 8-8V255.3c22.7-3.8 40-23.6 40-47.3z'
      
    ]
  };

  

  
  

  var faReflectVertical = {
    prefix: 'fat',
    iconName: 'reflect-vertical',
    icon: [
      512,
      512,
      [],
      'e665',
      
      'M0 256c0 4.4 3.6 8 8 8l496 0c4.4 0 8-3.6 8-8s-3.6-8-8-8L8 248c-4.4 0-8 3.6-8 8zM128 496c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l128-128c6.2-6.2 16.4-6.2 22.6 0l128 128c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9l-256 0zM278.6 329.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128zM113.2 25.9c2.5-6 8.3-9.9 14.8-9.9l256 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-128 128c-6.2 6.2-16.4 6.2-22.6 0l-128-128c-4.6-4.6-5.9-11.5-3.5-17.4zM233.4 182.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9S396.9 0 384 0L128 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z'
      
    ]
  };

  

  
  

  var faSquareShareNodes = {
    prefix: 'fat',
    iconName: 'square-share-nodes',
    icon: [
      448,
      512,
      ["share-alt-square"],
      'f1e1',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm328 96a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm0 16c-19.1 0-35.9-9.5-46-24.1L173.2 238.4c1.8 5.5 2.8 11.5 2.8 17.6s-1 12.1-2.8 17.6L282 328.1c10.1-14.5 26.9-24.1 46-24.1c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56c0-6.2 1-12.1 2.8-17.6L166 287.9c-10.1 14.5-26.9 24.1-46 24.1c-30.9 0-56-25.1-56-56s25.1-56 56-56c19.1 0 35.9 9.5 46 24.1l108.8-54.4c-1.8-5.5-2.8-11.5-2.8-17.6c0-30.9 25.1-56 56-56s56 25.1 56 56s-25.1 56-56 56zm0 192a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM160 256a40 40 0 1 0 -80 0 40 40 0 1 0 80 0z'
      
    ]
  };

  
    var faShareAltSquare = faSquareShareNodes;
  

  
  

  var faComet = {
    prefix: 'fat',
    iconName: 'comet',
    icon: [
      512,
      512,
      [],
      'e003',
      
      'M320 23.7c0-19.7-22.4-31-38.2-19.3l4.7 6.4-4.7-6.4L81.1 152.2C30.1 189.8 0 249.8 0 313.1C0 422.4 88.6 512 197.9 512c64.1 0 124.2-31 161.4-83.3L500.6 229.9C511.9 214 500.5 192 481 192H445.9L509.3 47.8c1.8-4.1 2.7-8.5 2.7-12.9V32c0-17.7-14.3-32-32-32h-3c-4.4 0-8.8 .9-12.9 2.7l3.2 7.3-3.2-7.3L320 66.1V23.7zm-28.7-6.4c5.3-3.9 12.7-.1 12.7 6.4V78.4c0 2.7 1.4 5.2 3.6 6.7s5.1 1.7 7.6 .6L470.6 17.4c2-.9 4.2-1.4 6.4-1.4h3c8.8 0 16 7.2 16 16v3c0 2.2-.5 4.4-1.4 6.4L426.3 196.8c-1.1 2.5-.9 5.3 .6 7.6s4 3.6 6.7 3.6H481c6.5 0 10.3 7.3 6.5 12.6L346.3 419.4c-34.1 48-89.4 76.6-148.3 76.6C97.5 496 16 413.7 16 313.1c0-58.3 27.7-113.5 74.6-148L291.3 17.2zM166.8 267.9c5.2-.8 9.7-4 12-8.8L208 200l29.2 59.2c2.3 4.7 6.8 8 12 8.8l65.3 9.5-47.2 46c-3.8 3.7-5.5 9-4.6 14.2l11.2 65-58.4-30.7c-4.7-2.5-10.2-2.5-14.9 0l-58.4 30.7 11.2-65c.9-5.2-.8-10.5-4.6-14.2l-47.2-46 65.3-9.5zm55.6-75c-2.7-5.5-8.3-8.9-14.3-8.9s-11.7 3.5-14.3 8.9l-29.2 59.2-65.3 9.5c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l47.2 46-11.2 65c-1 6 1.4 12.1 6.4 15.7s11.5 4.1 16.8 1.2L208 386.1l58.4 30.7c5.4 2.8 11.9 2.4 16.9-1.2s7.4-9.6 6.4-15.7l-11.2-65 47.2-46c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-65.3-9.5-29.2-59.2z'
      
    ]
  };

  

  
  

  var faJetFighter = {
    prefix: 'fat',
    iconName: 'jet-fighter',
    icon: [
      640,
      512,
      ["fighter-jet"],
      'f0fb',
      
      'M208 16h36L368.1 184 208 184V16zM384.1 200H485c6.3 0 12.7 1.1 18.6 3.2l110.6 39c5.8 2.1 9.8 7.6 9.8 13.8s-3.9 11.7-9.8 13.8l-110.6 39c-6 2.1-12.3 3.2-18.6 3.2H384.1h-.2H152c-1.9 0-3.7 .7-5.1 1.9l-39.1 32.6C103.5 350 98 352 92.4 352H72c-13.3 0-24-10.7-24-24V264H152c4.4 0 8-3.6 8-8s-3.6-8-8-8H48V184c0-13.3 10.7-24 24-24H92.4c5.6 0 11.1 2 15.4 5.6l39.1 32.6c1.4 1.2 3.3 1.9 5.1 1.9H383.9h.2zM32 264v64c0 22.1 17.9 40 40 40H92.4c9.4 0 18.4-3.3 25.6-9.3L154.9 328l37.1 0V496c-4.4 0-8 3.6-8 8s3.6 8 8 8l8 0 47.9 0h.2H304c4.4 0 8-3.6 8-8s-3.6-8-8-8H263.9L388 328h97c8.2 0 16.3-1.4 24-4.1l110.6-39C631.8 280.5 640 269 640 256s-8.2-24.5-20.4-28.9L509 188.1c-7.7-2.7-15.8-4.1-24-4.1H388L263.9 16H304c4.4 0 8-3.6 8-8s-3.6-8-8-8H248.1h-.2H200h-8c-4.4 0-8 3.6-8 8s3.6 8 8 8V184l-37.1 0L118 153.3c-7.2-6-16.2-9.3-25.6-9.3H72c-22.1 0-40 17.9-40 40v64H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H32zm176 64l160.1 0L244 496H208V328z'
      
    ]
  };

  
    var faFighterJet = faJetFighter;
  

  
  

  var faPageCaretUp = {
    prefix: 'fat',
    iconName: 'page-caret-up',
    icon: [
      384,
      512,
      ["file-caret-up"],
      'e42a',
      
      'M320 496H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H245.5c12.7 0 24.9 5.1 33.9 14.1l74.5 74.5c9 9 14.1 21.2 14.1 33.9V448c0 26.5-21.5 48-48 48zM64 512H320c35.3 0 64-28.7 64-64V138.5c0-17-6.7-33.3-18.7-45.3L290.7 18.7C278.7 6.7 262.5 0 245.5 0H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64zm52.3-221.4L192 208l75.7 82.6c4.7 5.1 1.1 13.4-5.9 13.4H122.2c-7 0-10.6-8.3-5.9-13.4zm87.5-93.4c-3-3.3-7.3-5.2-11.8-5.2s-8.8 1.9-11.8 5.2l-75.7 82.6c-14.1 15.4-3.2 40.2 17.7 40.2H261.8c20.9 0 31.8-24.8 17.7-40.2l-75.7-82.6z'
      
    ]
  };

  
    var faFileCaretUp = faPageCaretUp;
  

  
  

  var faHandshakeSimple = {
    prefix: 'fat',
    iconName: 'handshake-simple',
    icon: [
      640,
      512,
      [129309,"handshake-alt"],
      'f4c6',
      
      'M255.9 64H294L277.1 80H255.9c-28.2 0-55.6 10-77.2 28.1l-40.5 34c-1.4 1.2-3.3 1.9-5.1 1.9H40c-4.4 0-8-3.6-8-8s3.6-8 8-8h90.2l38.2-32.1C192.9 75.3 223.9 64 255.9 64zm49.9 32.9C328.1 75.8 357.7 64 388.5 64c28.3 0 55.7 10 77.3 28.2L508.4 128H600c4.4 0 8 3.6 8 8s-3.6 8-8 8H505.5c-1.9 0-3.7-.7-5.1-1.9l-44.9-37.7C436.7 88.6 413 80 388.5 80c-26.7 0-52.3 10.2-71.6 28.5l-87.5 82.9c-18.3 17.4-17.9 46.7 1 63.5c16.5 14.7 41.6 14.5 57.8-.5l76-70.2c3.2-3 8.3-2.8 11.3 .5s2.8 8.3-.5 11.3L360.8 209l99.5 99.5c7.9 7.9 12.9 17.4 15.1 27.5H600c4.4 0 8 3.6 8 8s-3.6 8-8 8H476.6c-1 14-7.2 27.7-18.6 37.9c-17.9 15.9-43.4 18.3-63.6 7.5c-1.4 11-5.9 21.6-13.8 30.4c-21.5 24.2-59 25.3-81.9 2.4l-4.8-4.8c-1.1 1.1-2.2 2.2-3.4 3.3c-23.3 20.8-58.7 19.8-80.8-2.2l-24.4-24.4c0 0 0 0-.1-.1l-15.4-15.4-20.6-20.6c-9-9-21.2-14.1-33.9-14.1H48c-4.4 0-8-3.6-8-8s3.6-8 8-8h67.4c17 0 33.3 6.7 45.3 18.7l20.6 20.6L221 415.2c16.1 16.1 41.9 16.8 58.8 1.6c2.7-2.4 4.9-5 6.9-7.8c1.3-2 3.5-3.2 5.9-3.5s4.7 .6 6.4 2.3L310 418.9c16.4 16.4 43.2 15.6 58.6-1.7c8.7-9.8 11.8-22.7 9.4-34.7c-.7-3.5 1-7 4.1-8.6s6.9-1.1 9.4 1.4l1 1c15 15 39 15.7 54.8 1.6c17.2-15.3 18-41.9 1.7-58.1l-99.9-99.9L299 266.1c-22.3 20.6-56.6 20.9-79.3 .7c-25.9-23-26.5-63.2-1.4-87l87.5-82.9z'
      
    ]
  };

  
    var faHandshakeAlt = faHandshakeSimple;
  

  
  

  var faEyes = {
    prefix: 'fat',
    iconName: 'eyes',
    icon: [
      640,
      512,
      [],
      'e367',
      
      'M312 256c0 58.8-17.5 111.4-44.9 148.9C239.6 442.5 203 464 164 464s-75.6-21.5-103.1-59.1c-11.1-15.1-20.5-32.7-27.8-52.1C46.3 362.4 62.5 368 80 368c44.2 0 80-35.8 80-80s-35.8-80-80-80c-25.9 0-48.9 12.3-63.5 31.4c3-52.1 19.6-98.4 44.5-132.3C88.4 69.5 125 48 164 48s75.6 21.5 103.1 59.1C294.5 144.6 312 197.2 312 256zM16.8 277.8C21.7 247.3 48.1 224 80 224c35.3 0 64 28.7 64 64s-28.7 64-64 64c-25.5 0-47.5-14.9-57.8-36.5c-2.6-12.1-4.4-24.7-5.4-37.7zM320 186.7C298.6 96.9 236.9 32 164 32C73.4 32 0 132.3 0 256S73.4 480 164 480c72.9 0 134.6-64.9 156-154.7C341.4 415.1 403.1 480 476 480c90.6 0 164-100.3 164-224s-73.4-224-164-224c-72.9 0-134.6 64.9-156 154.7zm52.9 218.2c-13-17.7-23.7-38.9-31.5-62.4C356.1 358.2 376.9 368 400 368c44.2 0 80-35.8 80-80s-35.8-80-80-80c-31.7 0-59 18.4-72 45.1c.6-57.6 17.9-109.1 44.9-146C400.4 69.5 437 48 476 48s75.6 21.5 103.1 59.1C606.5 144.6 624 197.2 624 256s-17.5 111.4-44.9 148.9C551.6 442.5 515 464 476 464s-75.6-21.5-103.1-59.1zM400 352a64 64 0 1 1 0-128 64 64 0 1 1 0 128z'
      
    ]
  };

  

  
  

  var faCircleJ = {
    prefix: 'fat',
    iconName: 'circle-j',
    icon: [
      512,
      512,
      [],
      'e112',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm80-376c0-4.4-3.6-8-8-8s-8 3.6-8 8V296c0 39.8-32.2 72-72 72s-72-32.2-72-72V280c0-4.4-3.6-8-8-8s-8 3.6-8 8v16c0 48.6 39.4 88 88 88s88-39.4 88-88V136z'
      
    ]
  };

  

  
  

  var faGalleryThumbnails = {
    prefix: 'fat',
    iconName: 'gallery-thumbnails',
    icon: [
      576,
      512,
      [],
      'e3aa',
      
      'M512 16c26.5 0 48 21.5 48 48V288c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H512zM64 0C28.7 0 0 28.7 0 64V288c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm0 432c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H32c-8.8 0-16-7.2-16-16V448c0-8.8 7.2-16 16-16H64zM32 416c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V448c0-17.7-14.3-32-32-32H32zm160 16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16V448c0-8.8 7.2-16 16-16zm-32 16v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V448c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32zm224-16c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H352c-8.8 0-16-7.2-16-16V448c0-8.8 7.2-16 16-16h32zm-32-16c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V448c0-17.7-14.3-32-32-32H352zm160 16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H512c-8.8 0-16-7.2-16-16V448c0-8.8 7.2-16 16-16zm-32 16v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V448c0-17.7-14.3-32-32-32H512c-17.7 0-32 14.3-32 32z'
      
    ]
  };

  

  
  

  var faHandPointLeft = {
    prefix: 'fat',
    iconName: 'hand-point-left',
    icon: [
      512,
      512,
      [],
      'f0a5',
      
      'M48 128c-17.7 0-32 14.3-32 32s14.3 32 32 32l152 0h56l0-56c0-2.7 .1-5.4 .4-8L48 128zm224 64h0v16h0v32c0 17.7 14.3 32 32 32s32-14.3 32-32V168c0-4.4 3.6-8 8-8s8 3.6 8 8v72c0 18.5-10.5 34.6-25.9 42.6C337 291.4 344 304.9 344 320s-7 28.6-17.9 37.4c15.4 8 25.9 24.1 25.9 42.6c0 12.3-4.6 23.5-12.2 32H360c75.1 0 136-60.9 136-136l0-80c0-75.1-60.9-136-136-136H328c-30.9 0-56 25.1-56 56v56zm-16 16H200c-17.7 0-32 14.3-32 32s14.3 32 32 32h31.9c0 0 0 0 .1 0h36.2c-7.6-8.5-12.2-19.7-12.2-32V208zm-91.8 0L48 208c-26.5 0-48-21.5-48-48s21.5-48 48-48l212.1 0C270 84 296.7 64 328 64l32 0c83.9 0 152 68.1 152 152l0 80c0 83.9-68.1 152-152 152H304 280 248c-26.5 0-48-21.5-48-48c0-13.8 5.8-26.3 15.2-35C197 358.2 184 340.6 184 320c0-12.4 4.7-23.6 12.3-32.1C171.5 286 152 265.3 152 240c0-12.3 4.6-23.5 12.2-32zM272 288H232c-17.7 0-32 14.3-32 32c0 17.7 14.3 32 32 32h16 48c17.7 0 32-14.3 32-32s-14.3-32-32-32l-24 0zm8 144h24c17.7 0 32-14.3 32-32s-14.3-32-32-32h-8H248c-17.7 0-32 14.3-32 32s14.3 32 32 32h32z'
      
    ]
  };

  

  
  

  var faPineapple = {
    prefix: 'fat',
    iconName: 'pineapple',
    icon: [
      512,
      512,
      [],
      'e31f',
      
      'M419.6 30.3L416 16c-11.5 4.9-19.2 14-22.8 24.6c-1.8 5.2-6.1 9.2-11.5 10.4s-11-.4-15-4.3L352 32c-14.3 14.3-20.9 33.4-19.8 52.1c12 6.8 23.1 15.2 33 25.1l37.5 37.5c9.9 9.9 18.3 21 25.1 33c18.7 1.1 37.8-5.5 52.1-19.8l-14.7-14.7c-3.9-3.9-5.5-9.6-4.3-15s5.2-9.7 10.4-11.5C482 115.2 491.1 107.5 496 96l-14.3-3.6c-4.8-1.2-8.9-4.6-10.8-9.2s-1.7-9.8 .8-14.2c5.4-9.5 8.3-20.4 8.3-31.5V32h-5.5c-11.2 0-22 2.9-31.5 8.3c-4.3 2.5-9.6 2.8-14.2 .8s-8-6-9.2-10.8zm71.7 141c-15.4 15.4-35.3 23.6-55.5 24.5c8 18.9 12.2 39.3 12.2 60.2c0 41-16.3 80.3-45.3 109.3L298.2 469.8c-27 27-63.6 42.2-101.8 42.2h-8.7c-38.2 0-74.8-15.2-101.8-42.2L42.2 426.2C15.2 399.2 0 362.5 0 324.4v-8.7c0-38.2 15.2-74.8 42.2-101.8L146.7 109.3C175.7 80.3 215 64 256 64c20.9 0 41.3 4.2 60.2 12.2c.9-20.2 9.1-40.1 24.5-55.5c6.2-6.2 16.4-6.2 22.6 0l2.4 2.4 12.3 12.3c1.8-5.3 4.4-10.3 7.7-15c5.8-8.1 13.9-14.8 24-19.2c4.3-1.8 9.2-1.7 13.4 .4c3.7 1.8 6.5 5 7.9 8.8c.2 .6 .4 1.1 .5 1.7l3.6 14.3c4.7-2.7 9.7-4.9 14.9-6.5c7.9-2.5 16.1-3.9 24.6-3.9H480c8.8 0 16 7.2 16 16v5.5c0 8.4-1.3 16.7-3.9 24.6c-1.7 5.2-3.8 10.1-6.5 14.9l14.3 3.6c.6 .1 1.1 .3 1.7 .5c3.8 1.4 6.9 4.2 8.8 7.9c2.1 4.2 2.2 9.1 .4 13.4c-4.3 10.1-11.1 18.2-19.2 24c-4.6 3.3-9.7 5.9-15 7.7l12.3 12.3 2.4 2.4c6.2 6.2 6.2 16.4 0 22.6zM53.5 414.9l43.6 43.6c24 24 56.6 37.5 90.5 37.5h8.7c33.9 0 66.5-13.5 90.5-37.5L391.4 353.9c26-26 40.6-61.2 40.6-97.9s-14.6-72-40.6-97.9l-37.5-37.5C328 94.6 292.7 80 256 80s-72 14.6-97.9 40.6L53.5 225.1c-24 24-37.5 56.6-37.5 90.5v8.7c0 33.9 13.5 66.5 37.5 90.5zM165.7 218.3L192 244.7l26.3-26.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-32 32c-3.1 3.1-8.2 3.1-11.3 0l-32-32c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0zm-64 96L128 340.7l26.3-26.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-32 32c-3.1 3.1-8.2 3.1-11.3 0l-32-32c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0zm128 0L256 340.7l26.3-26.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-32 32c-3.1 3.1-8.2 3.1-11.3 0l-32-32c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0zm-64 96L192 436.7l26.3-26.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-32 32c-3.1 3.1-8.2 3.1-11.3 0l-32-32c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0z'
      
    ]
  };

  

  
  

  var faCloudQuestion = {
    prefix: 'fat',
    iconName: 'cloud-question',
    icon: [
      640,
      512,
      [],
      'e492',
      
      'M522.7 220.8c3.4-8.9 5.3-18.6 5.3-28.8c0-44.2-35.8-80-80-80c-16.5 0-31.7 5-44.4 13.5c-3.7 2.5-8.2 3.3-12.5 2.3s-8-3.8-10.2-7.6C355.9 77 309.3 48 256 48c-79.5 0-144 64.5-144 144c0 2.5 .1 4.9 .2 7.3c.4 7.1-4 13.5-10.7 15.9C51.7 232.7 16 280.2 16 336c0 70.7 57.3 128 128 128H512c61.9 0 112-50.1 112-112c0-54.2-38.5-99.4-89.6-109.8c-4.6-.9-8.6-3.9-10.9-8s-2.6-9.1-.9-13.4zM256 32c53.6 0 101 26.3 130 66.7c3.1 4.3 6 8.8 8.7 13.4c3.5-2.4 7.2-4.5 11-6.4C418.5 99.5 432.8 96 448 96c53 0 96 43 96 96c0 6.6-.7 13-1.9 19.2c-1.1 5.3-2.6 10.5-4.5 15.4c5.3 1.1 10.5 2.5 15.5 4.2C603.6 247.9 640 295.7 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160zM232 216c0-30.9 25.1-56 56-56h56.2c35.2 0 63.8 28.6 63.8 63.8c0 21.4-10.8 41.5-28.7 53.3L328 310.9V336c0 4.4-3.6 8-8 8s-8-3.6-8-8V306.5c0-2.7 1.4-5.2 3.6-6.7l54.9-36.2c13.4-8.8 21.5-23.8 21.5-39.9c0-26.4-21.4-47.8-47.8-47.8H288c-22.1 0-40 17.9-40 40l0 6.5c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-6.5zm72 168a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faFaceWoozy = {
    prefix: 'fat',
    iconName: 'face-woozy',
    icon: [
      512,
      512,
      [],
      'e3a2',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM198.7 116.4c-26.8 40.2-66.8 61.4-84.1 67.2c-4.2 1.4-8.7-.9-10.1-5.1s.9-8.7 5.1-10.1c14.7-4.9 51.5-24.2 75.9-60.8c2.5-3.7 7.4-4.7 11.1-2.2s4.7 7.4 2.2 11.1zm11.3 115.3l-64 16c-4.3 1.1-8.6-1.5-9.7-5.8s1.5-8.6 5.8-9.7l64-16c4.3-1.1 8.6 1.5 9.7 5.8s-1.5 8.6-5.8 9.7zM405.7 341.7l-39.3 39.3c-12.2 12.2-28.7 19.1-46 19.1c-12.2 0-24.1-3.4-34.5-9.9l-14.2-8.9c-20.4-12.7-45.6-15-67.9-6.1c-27.9 11.2-59.6 7.9-84.6-8.8l-11.5-7.7c-3.7-2.5-4.7-7.4-2.2-11.1s7.4-4.7 11.1-2.2l11.5 7.7c20.7 13.8 46.8 16.5 69.8 7.3c27.1-10.8 57.7-8.1 82.4 7.4l14.2 8.9c7.8 4.9 16.8 7.5 26 7.5c13 0 25.5-5.2 34.7-14.4l39.3-39.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3zM320.5 166.3c-5.1 10.3-8.5 25-8.5 41.7s3.4 31.4 8.5 41.7c5.4 10.7 11.3 14.3 15.5 14.3s10.1-3.6 15.5-14.3c5.1-10.3 8.5-25 8.5-41.7s-3.4-31.4-8.5-41.7C346.1 155.6 340.2 152 336 152s-10.1 3.6-15.5 14.3zm-14.3-7.2c6.2-12.4 16.3-23.2 29.8-23.2s23.6 10.7 29.8 23.2c6.5 12.9 10.2 30.2 10.2 48.8s-3.8 35.9-10.2 48.8C359.6 269.3 349.5 280 336 280s-23.6-10.7-29.8-23.2C299.8 243.9 296 226.6 296 208s3.8-35.9 10.2-48.8z'
      
    ]
  };

  

  
  

  var faKipSign = {
    prefix: 'fat',
    iconName: 'kip-sign',
    icon: [
      384,
      512,
      [],
      'e1c4',
      
      'M88 32c4.4 0 8 3.6 8 8V238.8L338.8 33.9c3.4-2.8 8.4-2.4 11.3 1s2.4 8.4-1 11.3L109.9 248H376c4.4 0 8 3.6 8 8s-3.6 8-8 8H109.9L349.2 465.9c3.4 2.9 3.8 7.9 1 11.3s-7.9 3.8-11.3 1L96 273.2V473c0 4.4-3.6 8-8 8s-8-3.6-8-8V264H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H80V40c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faFileGif = {
    prefix: 'fat',
    iconName: 'file-gif',
    icon: [
      512,
      512,
      [],
      'e645',
      
      'M176 496H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V304h16V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H176V496zM361.1 160H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3c.9 .9 1.7 1.8 2.4 2.7zM232 400v80c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V456c0-4.4-3.6-8-8-8H288c-4.4 0-8 3.6-8 8s3.6 8 8 8h8v16c0 8.8-7.2 16-16 16H264c-8.8 0-16-7.2-16-16V400c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v8c0 4.4 3.6 8 8 8s8-3.6 8-8v-8c0-17.7-14.3-32-32-32H264c-17.7 0-32 14.3-32 32zm144-24c0-4.4-3.6-8-8-8s-8 3.6-8 8V504c0 4.4 3.6 8 8 8s8-3.6 8-8V376zm56-8c-4.4 0-8 3.6-8 8v64 64c0 4.4 3.6 8 8 8s8-3.6 8-8V448h40c4.4 0 8-3.6 8-8s-3.6-8-8-8H440V384h40c4.4 0 8-3.6 8-8s-3.6-8-8-8H432z'
      
    ]
  };

  

  
  

  var faMasksTheater = {
    prefix: 'fat',
    iconName: 'masks-theater',
    icon: [
      640,
      512,
      [127917,"theater-masks"],
      'f630',
      
      'M248.9 428.7c3.1 4.5 6.4 9.1 9.8 13.7c-5.9 2.1-11.9 3.6-18 4.5c-58.2 8.8-124.5-37.5-166.1-73.7c-28.3-24.5-44.3-59.8-49.8-97.2L.6 111.8C-.8 102 0 91.9 5.7 83.9C20.5 63 63 22.7 175.7 5.6s164.9 8.9 185.1 24.5c.9 .7 1.7 1.4 2.4 2.1c-8.4 .8-16.3 1.8-23.8 3.1C316.4 22.7 268.2 7.8 178.1 21.4C68.6 38 30.5 76.6 18.7 93.1c-2.3 3.3-3.4 8.6-2.3 16.3L40.7 273.7c5.1 34.5 19.7 66 44.4 87.4c20.3 17.6 46.2 37.4 73.7 51.6c27.8 14.3 55.3 22.1 79.5 18.4c3.5-.5 7.1-1.3 10.6-2.3zM211.2 272.6l-.7 5.1c-.6 4.1-1.1 8.2-1.5 12.3c-24.1 7.6-46.7 19.7-66.4 35.7c-3.4 2.8-8.5 2.3-11.3-1.2s-2.3-8.5 1.2-11.3c23.2-18.8 50-32.6 78.7-40.6zm-70.7-63.5c-20.7 2-39.8-7.5-51-23.2c-2.6-3.6-1.7-8.6 1.9-11.2s8.6-1.7 11.2 1.9c8 11.2 21.7 18 36.4 16.6s26.8-10.7 32.6-23.2c1.8-4 6.6-5.8 10.6-4s5.8 6.6 4 10.6c-8 17.5-24.9 30.5-45.6 32.5zM401.7 493.8c24.3 3.7 51.8-4 79.5-18.4c27.5-14.2 53.4-33.9 73.7-51.6c24.7-21.5 39.3-52.9 44.4-87.4l24.2-164.3c1.1-7.8 0-13-2.3-16.3c-11.8-16.6-49.9-55.1-159.3-71.7s-157 9-173 21.3c-3.1 2.4-5.7 7.1-6.8 14.9L257.9 284.6c-5.1 34.5-.2 68.9 17.3 96.8c14.4 22.9 33.5 49.5 55.7 71.2c22.4 21.9 46.5 37.5 70.8 41.2zm-2.4 15.8c-58.2-8.8-108.2-72.8-137.6-119.7c-20-31.9-25.1-70.3-19.6-107.7L266.3 118c1.4-9.8 5.1-19.2 12.9-25.2c20.2-15.6 72.4-41.5 185.1-24.5s155.2 57.4 170 78.3c5.7 8 6.5 18.1 5.1 27.9L615.2 338.8c-5.5 37.3-21.5 72.6-49.8 97.2c-41.7 36.1-108 82.5-166.1 73.7zM523.1 351c-33 11.2-69.1 14.6-105.8 8.5s-69.8-21.2-97.3-42.5c10.6 41.9 45.1 75.7 90.5 83.3s89-13.1 112.7-49.3zm22.3-7.2c-23.8 51-79.4 82.1-137.6 72.3s-100.7-57.2-106.6-113.2c-1-9.6 10.7-13.8 17.9-7.4c27.4 24.4 61.9 41.7 100.8 48.2s77.1 1.4 111-12.7c8.9-3.7 18.6 4 14.5 12.8zm-168-151.5c20.5 3.4 36.4 17.6 43.2 35.6c1.5 4.1-.5 8.7-4.7 10.3s-8.7-.5-10.3-4.7c-4.8-12.9-16.3-23-30.9-25.4s-28.7 3.4-37.5 14c-2.8 3.4-7.9 3.9-11.3 1.1s-3.9-7.9-1.1-11.3c12.3-14.9 32-23 52.4-19.6zm94.1 50.9c-2.8 3.4-7.9 3.9-11.3 1.1s-3.9-7.9-1.1-11.3c12.3-14.9 32-23 52.4-19.6s36.5 17.6 43.2 35.6c1.6 4.1-.5 8.7-4.7 10.3s-8.7-.5-10.3-4.7c-4.8-12.9-16.3-23-30.9-25.4s-28.7 3.4-37.5 14z'
      
    ]
  };

  
    var faTheaterMasks = faMasksTheater;
  

  
  

  var faStapler = {
    prefix: 'fat',
    iconName: 'stapler',
    icon: [
      640,
      512,
      [],
      'e5af',
      
      'M448 352v64H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H592c26.5 0 48-21.5 48-48v-8-8V336 320v-4.7c0-36.4-20.5-69.6-53.1-85.9L260.7 66.4C236.6 54.3 209.9 48 182.9 48C128.2 48 76.7 73.8 43.8 117.6l-35.2 47C3 172 0 181 0 190.4c0 19.8 13.5 37 32.6 41.8L48 236v92c0 13.3 10.7 24 24 24H448zm0-16H72c-4.4 0-8-3.6-8-8V240l384 96zm176 80H464V336c0-7.3-5-13.7-12.1-15.5L36.5 216.6c-12.1-3-20.5-13.8-20.5-26.3c0-5.9 1.9-11.6 5.4-16.3l35.2-47C86.5 87.4 133.2 64 182.9 64c24.5 0 48.7 5.7 70.6 16.7L579.8 243.8C606.9 257.3 624 285 624 315.3V320v16 80zM464 432H624c0 17.7-14.3 32-32 32H64c-8.8 0-16-7.2-16-16s7.2-16 16-16H448h16z'
      
    ]
  };

  

  
  

  var faD = {
    prefix: 'fat',
    iconName: 'd',
    icon: [
      384,
      512,
      [100],
      '44',
      
      'M32 48c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H160c114.9 0 208-93.1 208-208s-93.1-208-208-208H32zM0 64C0 46.3 14.3 32 32 32H160c123.7 0 224 100.3 224 224s-100.3 224-224 224H32c-17.7 0-32-14.3-32-32V64z'
      
    ]
  };

  

  
  

  var faBedFront = {
    prefix: 'fat',
    iconName: 'bed-front',
    icon: [
      512,
      512,
      ["bed-alt"],
      'f8f7',
      
      'M48 88c0-22.1 17.9-40 40-40H424c22.1 0 40 17.9 40 40v56.8c-10.2-10.4-24.3-16.8-40-16.8H304c-20.4 0-38.2 10.9-48 27.1c-9.8-16.3-27.6-27.1-48-27.1H88c-15.7 0-29.8 6.4-40 16.8V88zm0 96c0-22.1 17.9-40 40-40H208c22.1 0 40 17.9 40 40v40H72c-8.4 0-16.5 1.4-24 4.1V184zM32 236.1C12.7 249 0 271 0 296V408v64c0 4.4 3.6 8 8 8s8-3.6 8-8V416H496v56c0 4.4 3.6 8 8 8s8-3.6 8-8V408 296c0-25-12.7-47-32-59.9V184 88c0-30.9-25.1-56-56-56H88C57.1 32 32 57.1 32 88v96 52.1zM264 184c0-22.1 17.9-40 40-40H424c22.1 0 40 17.9 40 40v44.1c-7.5-2.7-15.6-4.1-24-4.1H264V184zm0 56H440c30.9 0 56 25.1 56 56V400H16V296c0-30.9 25.1-56 56-56H248h16z'
      
    ]
  };

  
    var faBedAlt = faBedFront;
  

  
  

  var faHorizontalRule = {
    prefix: 'fat',
    iconName: 'horizontal-rule',
    icon: [
      640,
      512,
      [8213],
      'f86c',
      
      'M0 256c0-4.4 3.6-8 8-8H632c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faTrowel = {
    prefix: 'fat',
    iconName: 'trowel',
    icon: [
      512,
      512,
      [],
      'e589',
      
      'M310.2 126.9c-8.3 8.3-8.3 21.8 0 30.2l44.7 44.7c8.3 8.3 21.8 8.3 30.2 0l95.4-95.4c20.7-20.7 20.7-54.2 0-74.8s-54.2-20.7-74.8 0l-95.4 95.4zm-11.3 41.5c-14.6-14.6-14.6-38.2 0-52.8l95.4-95.4c26.9-26.9 70.5-26.9 97.5 0s26.9 70.5 0 97.5l-95.4 95.4c-14.6 14.6-38.2 14.6-52.8 0l-16.7-16.7L227.3 296l71.3 71.3c16.7 16.7 10.2 45-12.1 52.8L49.7 503.1C24.4 511.9 .1 487.6 8.9 462.3L91.8 225.4c7.8-22.3 36.2-28.7 52.8-12.1L216 284.7l99.6-99.6-16.7-16.7zm-192 62.3L24 467.6c-4.4 12.7 7.7 24.8 20.4 20.4l236.9-82.9c11.1-3.9 14.4-18.1 6-26.4l-154-154c-8.3-8.3-22.5-5.1-26.4 6z'
      
    ]
  };

  

  
  

  var faUmbrella = {
    prefix: 'fat',
    iconName: 'umbrella',
    icon: [
      576,
      512,
      [],
      'f0e9',
      
      'M296 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V48.1C137.2 51.8 19.2 153.5 2.1 285.9c-2 15.6 17.3 24.4 27.8 12.7C43.9 283 71.2 272 96 272c38.7 0 71 27.5 78.4 64.1c1.7 8.7 8.7 15.9 17.6 15.9s15.8-7.2 17.6-15.9C217 299.5 249.3 272 288 272s71 27.5 78.4 64.1c1.7 8.7 8.7 15.9 17.6 15.9s15.8-7.2 17.6-15.9C409 299.5 441.3 272 480 272c24.8 0 52.1 11 66.1 26.7c10.5 11.7 29.8 2.9 27.8-12.7C556.8 153.5 438.8 51.8 296 48.1V8zm89.9 324.9c-.2 1.2-.8 2.2-1.4 2.7c-.3 .2-.4 .3-.5 .3l0 0 0 0c0 0-.2-.1-.5-.3c-.6-.5-1.2-1.5-1.4-2.7C373.3 289.1 334.5 256 288 256s-85.3 33.1-94.1 76.9c-.2 1.2-.8 2.2-1.4 2.7c-.3 .2-.4 .3-.5 .3l0 0 0 0c0 0-.2-.1-.5-.3c-.6-.5-1.2-1.5-1.4-2.7C181.3 289.1 142.5 256 96 256c-28.4 0-60.4 12.4-78 32C34.3 161.8 149 64 288 64s253.7 97.8 270 224c-17.6-19.6-49.6-32-78-32c-46.5 0-85.3 33.1-94.1 76.9zM280 304.7V462.2c0 18.7-15.2 33.8-33.8 33.8c-14.6 0-27.5-9.3-32.1-23.1l-6.5-19.4c-1.4-4.2-5.9-6.5-10.1-5.1s-6.5 5.9-5.1 10.1l6.5 19.4c6.8 20.4 25.8 34.1 47.3 34.1c27.5 0 49.8-22.3 49.8-49.8V304.7c-2.6-.4-5.3-.7-8-.7s-5.4 .2-8 .7z'
      
    ]
  };

  

  
  

  var faCameraCctv = {
    prefix: 'fat',
    iconName: 'camera-cctv',
    icon: [
      576,
      512,
      ["cctv"],
      'f8ac',
      
      'M134.2 17.2l384 160c5.4 2.3 9.2 7.4 9.8 13.2s-2.1 11.6-7 14.9l-192 128c-4.5 3-10.1 3.5-15 1.5l-288-120c-4.2-1.8-7.5-5.3-9-9.6s-1-9.1 1.3-13.1l96-168c4-7 12.6-9.9 20-6.8zm6.2-14.8c-14.9-6.2-32.1-.3-40.1 13.7l-96 168c-4.6 8-5.5 17.5-2.5 26.2s9.5 15.7 18 19.2L200 304.6 154.5 424H16V360c0-4.4-3.6-8-8-8s-8 3.6-8 8v72 72c0 4.4 3.6 8 8 8s8-3.6 8-8V440H160c3.3 0 6.3-2.1 7.5-5.2l47.3-124 93 38.7c9.9 4.1 21.2 3 30.1-2.9l192-128c9.8-6.5 15.2-18 14.1-29.7s-8.6-21.9-19.5-26.5l-384-160zM513.4 398.6c7.9 3.6 18.1-.4 21.4-8.4l40-96c3.3-8-.3-17.2-8.3-20.8l-36.7-16.3-15.4 10.3 45.8 20.4c.1 0 .1 .1 .1 .1s0 .1 .1 .1s0 .1 0 .1c0 0 0 .1 0 .1l-39.9 95.8c-.1 .1-.2 .1-.3 .2s-.3 .1-.4 .1L412.3 335.4l-15.4 10.2 116.5 52.9z'
      
    ]
  };

  
    var faCctv = faCameraCctv;
  

  
  

  var faGrid2 = {
    prefix: 'fat',
    iconName: 'grid-2',
    icon: [
      512,
      512,
      [],
      'e196',
      
      'M80 48C62.3 48 48 62.3 48 80v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32H80zM32 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80zM80 304c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V336c0-17.7-14.3-32-32-32H80zM32 336c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V336zM432 48H336c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32zM336 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm0 272c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V336c0-17.7-14.3-32-32-32H336zm-48 32c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V336z'
      
    ]
  };

  

  
  

  var faSack = {
    prefix: 'fat',
    iconName: 'sack',
    icon: [
      512,
      512,
      [],
      'f81c',
      
      'M315.2 128H196.8l-9.2 5.9C131.8 169.6 16 259.6 16 416c0 44.2 35.8 80 80 80H416c44.2 0 80-35.8 80-80c0-156.4-115.8-246.4-171.6-282.1l-9.2-5.9zm4.6-16.7l57.1-82.8c3.7-5.3-.1-12.5-6.6-12.5H141.7c-6.4 0-10.2 7.2-6.6 12.5l57.1 82.8 .5 .7H319.3l.5-.7zM0 416C0 262.9 105.1 170.8 165.7 129.2c4.7-3.3 9.2-6.2 13.3-8.8l-9.1-13.2-48-69.6C111 21.7 122.4 0 141.7 0H370.3c19.3 0 30.7 21.7 19.8 37.6l-48 69.6L333 120.4c4.1 2.6 8.6 5.6 13.3 8.8C406.9 170.8 512 262.9 512 416c0 53-43 96-96 96H96c-53 0-96-43-96-96z'
      
    ]
  };

  

  
  

  var faCircleT = {
    prefix: 'fat',
    iconName: 'circle-t',
    icon: [
      512,
      512,
      [],
      'e124',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM136 144c-4.4 0-8 3.6-8 8s3.6 8 8 8H248V392c0 4.4 3.6 8 8 8s8-3.6 8-8V160H376c4.4 0 8-3.6 8-8s-3.6-8-8-8H256 136z'
      
    ]
  };

  

  
  

  var faBuildingColumns = {
    prefix: 'fat',
    iconName: 'building-columns',
    icon: [
      512,
      512,
      ["bank","institution","museum","university"],
      'f19c',
      
      'M252.7 .7c2.1-.9 4.5-.9 6.6 0L497.9 108.5c8.6 3.9 14.1 12.4 14.1 21.9V136c0 13.3-10.7 24-24 24H256 24c-13.3 0-24-10.7-24-24v-5.7c0-9.4 5.5-18 14.1-21.9L252.7 .7zM288 144H488c4.4 0 8-3.6 8-8v-5.7c0-3.1-1.8-6-4.7-7.3L256 16.8 20.7 123c-2.9 1.3-4.7 4.1-4.7 7.3V136c0 4.4 3.6 8 8 8H224c-5-6.7-8-15-8-24c0-22.1 17.9-40 40-40s40 17.9 40 40c0 9-3 17.3-8 24zm-32 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM72 192c4.4 0 8 3.6 8 8V368H184V200c0-4.4 3.6-8 8-8s8 3.6 8 8V368H312V200c0-4.4 3.6-8 8-8s8 3.6 8 8V368H432V200c0-4.4 3.6-8 8-8s8 3.6 8 8V376c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8V200c0-4.4 3.6-8 8-8zM32 440c0-4.4 3.6-8 8-8H472c4.4 0 8 3.6 8 8s-3.6 8-8 8H40c-4.4 0-8-3.6-8-8zM0 504c0-4.4 3.6-8 8-8H504c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  
    var faBank = faBuildingColumns;
  
    var faInstitution = faBuildingColumns;
  
    var faMuseum = faBuildingColumns;
  
    var faUniversity = faBuildingColumns;
  

  
  

  var faPersonMilitaryPointing = {
    prefix: 'fat',
    iconName: 'person-military-pointing',
    icon: [
      576,
      512,
      [],
      'e54a',
      
      'M400 18.1V64H248c-4.4 0-8-3.6-8-8V45.2c0-4 3-7.4 7-7.9L400 18.1zM245 21.4c-12 1.5-21 11.7-21 23.8V56c0 13.3 10.7 24 24 24H400c8.8 0 16-7.2 16-16V18.1c0-9.6-8.4-17.1-18-15.9L245 21.4zM389.1 248.3L240 418.7V304c0-8.8-7.2-16-16-16H72c-13.3 0-24-10.7-24-24s10.7-24 24-24H240 345.2c15.3 0 30.1 2.9 43.9 8.3zM224 440.4V480c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V401.2 369.7l16 27.1 37.6 63.6c11.2 19 35.8 25.3 54.8 14.1s25.3-35.8 14.1-54.8L462.3 290.8c-24.5-41.4-69-66.8-117.1-66.8H240 72c-22.1 0-40 17.9-40 40s17.9 40 40 40H208h16v16V439.6c0 .2 0 .5 0 .7zm16 7.6H400v32c0 8.8-7.2 16-16 16H256c-8.8 0-16-7.2-16-16V448zm160-16H249.6L404.1 255.4c18.1 10.2 33.5 25 44.4 43.5l76.1 128.8c6.7 11.4 3 26.1-8.5 32.9s-26.1 3-32.9-8.5l-53.6-90.6c-3.7-6.2-11-9.2-18-7.3s-11.8 8.2-11.8 15.4V432zM240 112c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H382c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-5.5 .7-10.9 2-16H241.6c-1 5.2-1.6 10.5-1.6 16z'
      
    ]
  };

  

  
  

  var faUsersGear = {
    prefix: 'fat',
    iconName: 'users-gear',
    icon: [
      640,
      512,
      ["users-cog"],
      'f509',
      
      'M208 80A64 64 0 1 0 80 80a64 64 0 1 0 128 0zM64 80a80 80 0 1 1 160 0A80 80 0 1 1 64 80zM320 304a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-176a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM261.3 368C196.5 368 144 420.5 144 485.3c0 5.9 4.8 10.7 10.7 10.7H401.2c12.6 8.5 27.4 11.5 41.3 10c.9 2 1.9 4.1 3 6H154.7c-14.7 0-26.7-11.9-26.7-26.7C128 411.7 187.7 352 261.3 352h98.7c.4 5.6 1.6 10.9 3.5 16H261.3zM536 192c54.1 0 98.6 41.3 103.5 94.1l-.8-1c-5.5-7-12-12.4-19-16.2c-11.4-35.4-44.6-61-83.8-61H447c-.7-5.4-1.7-10.8-3-16h92zm-24-48a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM193 208H104c-48.6 0-88 39.4-88 88c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-57.4 46.6-104 104-104h92c-1.3 5.2-2.4 10.6-3 16zm303 65.1v4.2c0 16.7-10.8 30.2-23.8 37.8c-13 7.5-30.1 10.1-44.6 1.7l-3.7-2.1c-2.9 3.7-5.6 7.5-8 11.5l-2.1 3.7c-2.2 4-4.2 8.2-5.9 12.5l3.6 2.1c14.6 8.4 20.4 24.6 20.4 39.5s-5.8 31.1-20.4 39.5l-3.6 2.1c1.7 4.3 3.7 8.4 5.9 12.4l2.2 3.8c2.4 4 5.1 7.8 7.9 11.5l3.7-2.1c14.5-8.3 31.6-5.8 44.6 1.7c13 7.5 23.8 21.1 23.8 37.8v4.2c5.2 .7 10.6 1.1 16 1.1s10.8-.4 16-1.1v-4.2c0-16.7 10.8-30.2 23.8-37.8c13-7.5 30.1-10.1 44.6-1.7l3.7 2.1c2.9-3.6 5.5-7.5 7.9-11.4l2.2-3.9c2.2-4 4.2-8.1 5.9-12.4l-3.6-2.1C597.8 415.1 592 398.9 592 384s5.8-31.1 20.4-39.5l3.6-2.1c-1.7-4.3-3.7-8.4-5.9-12.4l-2.2-3.7c-2.4-4-5.1-7.9-8-11.5l-3.7 2.1c-14.5 8.3-31.6 5.8-44.6-1.7c-13-7.5-23.8-21.1-23.8-37.8v-4.2c-5.2-.7-10.6-1.1-16-1.1s-10.8 .4-16 1.1zm-3.9-15.6c6.5-1 13.1-1.5 19.9-1.5s13.4 .5 19.9 1.5c7.1 1.1 12.1 7.5 12.1 14.9v4.9c0 9.4 6.2 18.4 15.8 23.9s20.4 6.4 28.6 1.7l4.3-2.5c6.4-3.7 14.5-2.5 19 3c3.7 4.6 7.1 9.4 10.1 14.5l.1 .1 0 0L624 322l.1 .1 0 0c2.8 5.1 5.3 10.3 7.4 15.8c2.6 6.7-.4 14.2-6.8 18l-4.2 2.4c-8 4.6-12.4 14.3-12.4 25.6s4.4 21 12.4 25.6l4.2 2.4c6.4 3.7 9.4 11.3 6.8 17.9c-2.1 5.4-4.5 10.7-7.3 15.7l-.1 .1 0 0-2.3 4-.1 .1 0 0c-3 5-6.4 9.8-10.1 14.4c-4.5 5.6-12.5 6.8-19 3l-4.3-2.5c-8.1-4.7-19-3.8-28.6 1.7s-15.8 14.5-15.8 23.9v4.9c0 7.4-5.1 13.8-12.1 14.9c-6.5 1-13.1 1.5-19.9 1.5s-13.4-.5-19.9-1.5c-7.1-1.1-12.1-7.5-12.1-14.9v-4.9c0-9.4-6.2-18.4-15.8-23.9s-20.4-6.4-28.6-1.7l-4.3 2.5c-6.4 3.7-14.5 2.5-19-3c-3.7-4.6-7.1-9.4-10.1-14.4l-.1-.1 0 0-2.3-4-.1-.1 0 0c-2.8-5-5.2-10.3-7.3-15.7c-2.6-6.7 .4-14.2 6.8-17.9l4.2-2.4c8-4.6 12.4-14.3 12.4-25.6s-4.4-21-12.4-25.6l-4.2-2.4c-6.4-3.7-9.4-11.3-6.8-17.9c2.1-5.5 4.6-10.8 7.4-15.8l.1-.1 0 0 2.2-3.8 .1-.1 0 0c3.1-5.1 6.5-9.9 10.2-14.5c4.5-5.6 12.5-6.8 19-3l4.3 2.5c8.2 4.7 19 3.8 28.6-1.7s15.8-14.5 15.8-23.9v-4.9c0-7.4 5.1-13.8 12.1-14.9zM512 408a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-64a40 40 0 1 1 0 80 40 40 0 1 1 0-80z'
      
    ]
  };

  
    var faUsersCog = faUsersGear;
  

  
  

  var faMagnifyingGlassDollar = {
    prefix: 'fat',
    iconName: 'magnifying-glass-dollar',
    icon: [
      512,
      512,
      ["search-dollar"],
      'f688',
      
      'M208 16a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 400c54.6 0 104.2-21 141.3-55.4l149 149c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-149-149C395 312.2 416 262.6 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm8-304c0-4.4-3.6-8-8-8s-8 3.6-8 8v16.4c-8.4 .7-16.2 2.6-23 5.7c-12.4 5.6-21.9 15.4-24.2 28.8c-1.4 8.2-.6 15.4 2.4 21.8c3 6.3 7.8 11 13.2 14.7c10 6.8 23.7 10.9 35.9 14.6l1.7 .5c13.4 4 25 7.8 32.9 13.5c3.7 2.7 6.3 5.7 7.7 9c1.4 3.3 2.1 7.6 1.1 13.5c-1.4 8.2-6.5 14.1-15.1 17.8c-8.8 3.8-21.1 5-35.4 2.7c-7.1-1.2-19.2-5.3-28.8-8.5l0 0 0 0 0 0c-2.1-.7-4-1.4-5.7-1.9c-4.2-1.4-8.7 .9-10.1 5.1s.9 8.7 5.1 10.1c1.4 .5 3.1 1 5 1.7l0 0 0 0c9.4 3.2 23.4 8 32 9.4l0 0c1.8 .3 3.7 .5 5.5 .7V304c0 4.4 3.6 8 8 8s8-3.6 8-8l0-16.1c8.3-.5 16-2.1 22.7-5c12.6-5.4 22.1-15.4 24.5-29.7c1.5-8.5 .7-16-2.1-22.6c-2.9-6.6-7.5-11.6-13-15.5c-10.5-7.6-24.9-12-37.6-15.8l-.3-.1 0 0 0 0c-13.4-4-25-7.5-32.9-12.9c-3.8-2.6-6.3-5.3-7.7-8.3c-1.4-2.9-2.1-6.8-1.1-12.2c1.2-6.8 6.2-12.9 15.1-17c9-4.1 21.4-5.7 35.4-3.5c4.5 .7 18.5 3.4 22.9 4.6c4.3 1.1 8.7-1.4 9.8-5.7s-1.4-8.7-5.7-9.8c-5.2-1.4-19.8-4.2-24.6-4.9c-1.8-.3-3.7-.5-5.5-.7V112z'
      
    ]
  };

  
    var faSearchDollar = faMagnifyingGlassDollar;
  

  
  

  var faX = {
    prefix: 'fat',
    iconName: 'x',
    icon: [
      384,
      512,
      [120],
      '58',
      
      'M382.1 45.2c2.9-3.4 2.5-8.4-.9-11.3s-8.4-2.5-11.3 .9L192 243.7 14.1 34.8c-2.9-3.4-7.9-3.8-11.3-.9S-1 41.8 1.9 45.2L181.5 256 1.9 466.8c-2.9 3.4-2.5 8.4 .9 11.3s8.4 2.5 11.3-.9L192 268.3 369.9 477.2c2.9 3.4 7.9 3.8 11.3 .9s3.8-7.9 .9-11.3L202.5 256 382.1 45.2z'
      
    ]
  };

  

  
  

  var faSkullCow = {
    prefix: 'fat',
    iconName: 'skull-cow',
    icon: [
      640,
      512,
      [],
      'f8de',
      
      'M43.8 17c3.4 1.9 5 5.9 3.8 9.6L36.4 59.9c-2.8 8.5-3.9 17.6-3 26.5C36.8 119.1 64.2 144 97 144h75.8c16.6-28.7 47.6-48 83.2-48H384c35.5 0 66.6 19.3 83.2 48H543c32.8 0 60.3-24.9 63.5-57.5c.9-9-.1-18-3-26.5L592.4 26.5c-1.2-3.7 .4-7.7 3.8-9.6s7.6-1 10.1 2l7.5 9.3c17 21.3 26.3 47.7 26.3 75V120c0 66.3-53.7 120-120 120H480v48c0 41.8-26.7 77.3-64 90.5l-26.4 87.9c-8.1 27.1-33 45.6-61.3 45.6H311.6c-28.3 0-53.2-18.5-61.3-45.6L224 378.5c-37.3-13.2-64-48.7-64-90.5V240H120C53.7 240 0 186.3 0 120V103.3C0 76 9.3 49.6 26.3 28.3L33.8 19c2.4-3 6.7-3.9 10.1-2zM480 224h40c57.4 0 104-46.6 104-104V103.3c0-5.7-.5-11.4-1.4-17c0 .6-.1 1.2-.2 1.8C618.3 128.9 584 160 543 160H474.5c3.5 10 5.5 20.8 5.5 32v32zM97 160c-41 0-75.4-31.1-79.5-71.9c-.1-.6-.1-1.2-.2-1.8c-.9 5.6-1.4 11.3-1.4 17V120c0 57.4 46.6 104 104 104h40V192c0-11.2 1.9-22 5.5-32H97zM229.3 363.4c4.8 1.7 8.5 5.6 10 10.5l26.4 87.9c6.1 20.3 24.8 34.2 46 34.2h16.8c21.2 0 39.9-13.9 46-34.2l26.4-87.9c1.5-4.9 5.2-8.8 10-10.5c31.1-11 53.3-40.6 53.3-75.4V192c0-44.2-35.8-80-80-80H256c-44.2 0-80 35.8-80 80v96c0 34.8 22.2 64.4 53.3 75.4zM256 232a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm40 24a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zm64 0a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 40a40 40 0 1 1 0-80 40 40 0 1 1 0 80z'
      
    ]
  };

  

  
  

  var faComputerSpeaker = {
    prefix: 'fat',
    iconName: 'computer-speaker',
    icon: [
      640,
      512,
      [],
      'f8b2',
      
      'M288 96L80 96c-8.8 0-16 7.2-16 16V336c0 8.8 7.2 16 16 16H288V336H80V112H288V96zm0 304H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H300.8c3.3-5.7 7.2-11.1 11.6-16H64C28.7 32 0 60.7 0 96V352c0 35.3 28.7 64 64 64H288V400zm12.8 64H104c-4.4 0-8 3.6-8 8s3.6 8 8 8H312.4c-4.4-4.9-8.3-10.3-11.6-16zM576 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H384c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H576zM384 32c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H384zm96 368a80 80 0 1 1 0-160 80 80 0 1 1 0 160zm-96-80a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zM496 128a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM480 96a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 240a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z'
      
    ]
  };

  

  
  

  var faFerrisWheel = {
    prefix: 'fat',
    iconName: 'ferris-wheel',
    icon: [
      512,
      512,
      [],
      'e174',
      
      'M224 48a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm78.7 11c21 5 40.8 13.4 58.6 24.5c-5.9 8-9.4 17.8-9.4 28.5c0 10.4 3.3 20 8.9 27.8l-77.1 77.1c-5.8-4.1-12.5-7-19.8-8.2V95.3c19.1-3.2 34.3-17.7 38.7-36.3zM248 95.3V208.7c-7.3 1.2-14 4.1-19.8 8.2l-77.1-77.1c5.6-7.8 8.9-17.4 8.9-27.8c0-10.7-3.5-20.5-9.4-28.5c17.9-11.1 37.6-19.4 58.6-24.5c4.4 18.6 19.6 33.1 38.7 36.3zM139.8 151.1l77.1 77.1c-4.1 5.8-7 12.5-8.2 19.8H95.3c-3.1-18.5-16.7-33.4-34.5-38.3c4.7-21 12.7-40.7 23.4-58.6c7.8 5.6 17.4 8.9 27.8 8.9s20-3.3 27.8-8.9zM95.3 264H208.7c2.3 13.7 10.4 25.4 21.7 32.6L153.9 478.7c-6.6 15.8 5 33.3 22.1 33.3H335.9c17.2 0 28.8-17.5 22.1-33.3L281.7 296.6c11.3-7.2 19.4-18.9 21.7-32.6H416.7c3 18.1 16.2 32.7 33.4 38c-5.1 20.6-13.4 40-24.4 57.5c-7.4-4.7-16.2-7.4-25.7-7.4c-26.5 0-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48c0-11.2-3.8-21.5-10.3-29.7c12.9-20.1 22.6-42.5 28.3-66.4c25.5-1.1 45.9-22.1 45.9-48c0-25.4-19.8-46.2-44.8-47.9c-5.3-24.7-14.8-47.9-27.8-68.7c5.4-7.8 8.6-17.2 8.6-27.4c0-26.5-21.5-48-48-48c-9.9 0-19.1 3-26.7 8.1c-21-13.6-44.4-23.6-69.5-29.3C301.2 18.8 280.8 0 256 0s-45.2 18.8-47.7 42.8c-25.1 5.7-48.6 15.7-69.5 29.3C131.1 67 121.9 64 112 64c-26.5 0-48 21.5-48 48c0 10.2 3.2 19.6 8.6 27.4c-13 20.8-22.5 44-27.8 68.7C19.8 209.8 0 230.6 0 256c0 25.8 20.4 46.9 45.9 48c5.7 23.9 15.4 46.3 28.3 66.4C67.8 378.5 64 388.8 64 400c0 26.5 21.5 48 48 48s48-21.5 48-48s-21.5-48-48-48c-9.5 0-18.3 2.7-25.7 7.4C75.3 341.9 67 322.6 61.9 302c17.3-5.2 30.4-19.9 33.4-38zm73.3 220.9l76.4-182.2c3.5 .8 7.2 1.2 10.9 1.2s7.4-.4 10.9-1.2l76.4 182.2c2.2 5.3-1.7 11.1-7.4 11.1H176.1c-5.7 0-9.6-5.8-7.4-11.1zM416.7 248H303.3c-1.2-7.3-4.1-14-8.2-19.8l77.1-77.1c7.8 5.6 17.4 8.9 27.8 8.9s20-3.3 27.8-8.9c10.7 17.9 18.7 37.6 23.4 58.6c-17.8 4.9-31.4 19.8-34.5 38.3zM80 112a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM400 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM16 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm448-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM368 400a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM112 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faDollarSign = {
    prefix: 'fat',
    iconName: 'dollar-sign',
    icon: [
      320,
      512,
      [61781,128178,"dollar","usd"],
      '24',
      
      'M168 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V63.5c-9.5-.2-18.9 .1-28.2 .8c-24.6 2-48.4 7.8-67.4 20.1C37.1 96.9 23 115.7 17.9 142.6c-3.8 19.8-1.7 36.6 5.3 50.8c7 14.1 18.5 25 32.3 33.7c27.1 17 65.2 26.8 101.6 36.2l0 0 .9 .2c37.5 9.7 73.2 18.9 98 34.5c12.2 7.7 21.2 16.5 26.5 27.2c5.2 10.6 7.2 23.7 3.9 40.7c-4.9 25.3-22.9 43.8-51.1 54.6c-28.4 10.9-66.4 13.9-108.8 7.9c-26.5-3.9-66.2-12.9-99.3-26.9c-4.1-1.7-8.8 .2-10.5 4.2s.2 8.8 4.2 10.5c34.8 14.8 75.9 24 103.3 28l0 0c9.4 1.3 18.7 2.2 27.8 2.7v1 56c0 4.4 3.6 8 8 8s8-3.6 8-8V448v-.5c27.2 0 52.1-3.9 73-12c31.9-12.3 54.9-34.4 61.1-66.5c3.8-19.8 1.7-36.6-5.3-50.8c-7-14.1-18.5-25-32.3-33.7c-27.1-17-65.2-26.8-101.6-36.2l0 0-.9-.2c-37.5-9.7-73.2-18.9-98-34.5c-12.2-7.7-21.2-16.5-26.5-27.2c-5.2-10.6-7.2-23.7-3.9-40.7c4.3-22.5 15.7-37.6 31.5-47.7c16-10.3 36.9-15.7 60.1-17.6c46.5-3.8 99.8 6.4 135 14.8c4.3 1 8.6-1.6 9.6-5.9s-1.6-8.6-5.9-9.6c-25.1-6-60.1-13.2-95.9-15.4V64 8z'
      
    ]
  };

  
    var faDollar = faDollarSign;
  
    var faUsd = faDollarSign;
  

  
  

  var faCircleWaveformLines = {
    prefix: 'fat',
    iconName: 'circle-waveform-lines',
    icon: [
      512,
      512,
      ["waveform-circle"],
      'e12d',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280 136V376c0 4.4-3.6 8-8 8s-8-3.6-8-8V136c0-4.4 3.6-8 8-8s8 3.6 8 8zM152 168V344c0 4.4-3.6 8-8 8s-8-3.6-8-8V168c0-4.4 3.6-8 8-8s8 3.6 8 8zm192 24V320c0 4.4-3.6 8-8 8s-8-3.6-8-8V192c0-4.4 3.6-8 8-8s8 3.6 8 8zM216 208v96c0 4.4-3.6 8-8 8s-8-3.6-8-8V208c0-4.4 3.6-8 8-8s8 3.6 8 8zm192 24v48c0 4.4-3.6 8-8 8s-8-3.6-8-8V232c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  
    var faWaveformCircle = faCircleWaveformLines;
  

  
  

  var faFaceNoseSteam = {
    prefix: 'fat',
    iconName: 'face-nose-steam',
    icon: [
      512,
      512,
      [],
      'e382',
      
      'M16 256C16 123.5 123.5 16 256 16s240 107.5 240 240c0 21.4-2.8 42.2-8.1 61.9c-1.1 4.3 1.4 8.7 5.7 9.8s8.7-1.4 9.8-5.7C509 301 512 278.8 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 22.8 3 45 8.6 66.1c1.1 4.3 5.5 6.8 9.8 5.7s6.8-5.5 5.7-9.8C18.8 298.2 16 277.4 16 256zM178.6 483.2c-4.2-1.4-8.7 .8-10.2 5s.8 8.7 5 10.2c25.9 8.8 53.7 13.6 82.6 13.6s56.7-4.8 82.6-13.6c4.2-1.4 6.4-6 5-10.2s-6-6.4-10.2-5C309.1 491.5 283.1 496 256 496s-53.1-4.5-77.4-12.8zm208-339.7c4.2-1.4 6.5-5.9 5.1-10.1s-5.9-6.5-10.1-5.1c-39.8 13.3-71.8 38.6-83.1 49.9c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0c10-10 39.9-33.7 76.9-46.1zM96 248c0 4.4 3.6 8 8 8H216c4.4 0 8-3.6 8-8s-3.6-8-8-8H104c-4.4 0-8 3.6-8 8zm192 0c0 4.4 3.6 8 8 8H408c4.4 0 8-3.6 8-8s-3.6-8-8-8H296c-4.4 0-8 3.6-8 8zm-92.1 58.3c-2.6-2.6-6.6-3.1-9.8-1.2l-73.7 44.2c-1.8-3.3-4.1-6.4-6.9-9.2c-15.6-15.6-40.9-15.6-56.6 0c-3.5 3.5-6.3 7.6-8.2 11.9c-12.9-2.9-27 .7-37 10.7c-15.6 15.6-15.6 40.9 0 56.6c.5 .5 1 1 1.5 1.5c-11.9 21.3-8.7 48.7 9.4 66.8s45.5 21.2 66.8 9.4c.5 .5 1 1 1.5 1.6c15.6 15.6 40.9 15.6 56.6 0c10.1-10.1 13.6-24.1 10.7-37c4.3-1.9 8.3-4.7 11.9-8.2c15.6-15.6 15.6-40.9 0-56.6c-2.8-2.8-5.9-5.1-9.2-6.9l44.2-73.7c1.9-3.1 1.4-7.2-1.2-9.8zm118.5 .9c-2.6 2.6-3.1 6.6-1.2 9.8l44.2 73.7c-3.3 1.8-6.4 4.1-9.2 6.9c-15.6 15.6-15.6 40.9 0 56.6c3.5 3.5 7.6 6.3 11.9 8.2c-2.9 12.9 .7 27 10.7 37c15.6 15.6 40.9 15.6 56.6 0c.5-.5 1-1 1.5-1.6c21.3 11.9 48.7 8.7 66.8-9.4s21.2-45.5 9.4-66.8c.5-.5 1-1 1.5-1.5c15.6-15.6 15.6-40.9 0-56.6c-10.1-10.1-24.1-13.6-37-10.7c-1.9-4.3-4.7-8.3-8.2-11.9c-15.6-15.6-41-15.6-56.6 0c-2.8 2.8-5.1 5.9-6.9 9.2L324.1 306c-3.1-1.9-7.2-1.4-9.8 1.2zM166.9 335.3l-32.6 54.4c-1.3 2.2-1.5 4.9-.5 7.2s3.1 4.1 5.5 4.7c4.2 1 8.2 3.1 11.5 6.4c9.4 9.4 9.4 24.6 0 33.9c-3.5 3.5-7.8 5.7-12.3 6.6c-2.4 .5-4.5 2.1-5.6 4.3s-1.1 4.8-.1 7c4.3 8.9 2.7 20-4.7 27.4c-9.4 9.4-24.6 9.4-33.9 0c-1.6-1.6-2.8-3.3-3.9-5.1c-1.1-2-3.1-3.4-5.4-3.9s-4.6 .1-6.4 1.5c-15.7 12-38.2 10.9-52.6-3.5s-15.5-36.9-3.5-52.6c1.4-1.8 2-4.2 1.5-6.4s-1.9-4.2-3.9-5.4c-1.8-1-3.5-2.3-5.1-3.9c-9.4-9.4-9.4-24.6 0-33.9c7.4-7.4 18.4-9 27.4-4.7c2.2 1.1 4.8 1 7-.1s3.8-3.2 4.3-5.6c.9-4.5 3.1-8.8 6.6-12.3c9.4-9.4 24.6-9.4 33.9 0c3.3 3.3 5.4 7.3 6.4 11.5c.6 2.5 2.3 4.6 4.7 5.5s5 .8 7.2-.5l54.4-32.6zm176.4 .9l54.4 32.6c2.2 1.3 4.9 1.5 7.2 .5s4.1-3.1 4.7-5.5c1-4.2 3.1-8.2 6.4-11.5c9.4-9.4 24.6-9.4 33.9 0c3.5 3.5 5.7 7.8 6.6 12.3c.5 2.4 2.1 4.5 4.3 5.6s4.8 1.1 7 .1c8.9-4.3 20-2.7 27.4 4.7c9.4 9.4 9.4 24.6 0 33.9c-1.6 1.6-3.3 2.8-5.1 3.9c-2 1.1-3.4 3.1-3.9 5.4s.1 4.6 1.5 6.4c12 15.7 10.9 38.2-3.5 52.6s-36.9 15.5-52.6 3.5c-1.8-1.4-4.2-2-6.4-1.5s-4.2 1.9-5.4 3.9c-1 1.8-2.3 3.5-3.9 5.1c-9.4 9.4-24.6 9.4-33.9 0c-7.4-7.4-9-18.4-4.7-27.4c1.1-2.2 1-4.8-.1-7s-3.2-3.8-5.6-4.3c-4.5-.9-8.8-3.1-12.3-6.6c-9.4-9.4-9.4-24.6 0-33.9c3.3-3.3 7.3-5.4 11.5-6.4c2.5-.6 4.6-2.3 5.5-4.7s.8-5-.5-7.2l-32.6-54.4zM120.4 133.5c-1.4 4.2 .9 8.7 5.1 10.1c37 12.3 66.9 36.1 76.9 46.1c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3c-11.3-11.3-43.3-36.7-83.1-49.9c-4.2-1.4-8.7 .9-10.1 5.1z'
      
    ]
  };

  

  
  

  var faTurkishLiraSign = {
    prefix: 'fat',
    iconName: 'turkish-lira-sign',
    icon: [
      384,
      512,
      ["try","turkish-lira"],
      'e2bb',
      
      'M88 32c4.4 0 8 3.6 8 8v91.1L278.2 88.2c4.3-1 8.6 1.7 9.6 6s-1.7 8.6-6 9.6L96 147.5v79.6l182.2-42.9c4.3-1 8.6 1.7 9.6 6s-1.7 8.6-6 9.6L96 243.5V440c0 13.3 10.7 24 24 24h78.6c90.3 0 164.4-71.3 167.9-161.5l1.5-38.8c.2-4.4 3.9-7.9 8.3-7.7s7.9 3.9 7.7 8.3l-1.5 38.8c-3.8 98.8-85 176.9-183.9 176.9H120c-22.1 0-40-17.9-40-40V247.3L9.8 263.8c-4.3 1-8.6-1.7-9.6-6s1.7-8.6 6-9.6L80 230.8V151.3L9.8 167.8c-4.3 1-8.6-1.7-9.6-6s1.7-8.6 6-9.6L80 134.8V40c0-4.4 3.6-8 8-8z'
      
    ]
  };

  
    var faTry = faTurkishLiraSign;
  
    var faTurkishLira = faTurkishLiraSign;
  

  
  

  var faPrint = {
    prefix: 'fat',
    iconName: 'print',
    icon: [
      512,
      512,
      [9113,128424,128438],
      'f02f',
      
      'M80 160H64V64C64 28.7 92.7 0 128 0H357.5c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 18.7 28.3 18.7 45.3V160H432V90.5c0-12.7-5.1-24.9-14.1-33.9L391.4 30.1c-9-9-21.2-14.1-33.9-14.1H128c-26.5 0-48 21.5-48 48v96zm368 48H64c-26.5 0-48 21.5-48 48V384c0 8.8 7.2 16 16 16H64V352c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32v48h32c8.8 0 16-7.2 16-16V256c0-26.5-21.5-48-48-48zm0 208v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V416H32c-17.7 0-32-14.3-32-32V256c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V384c0 17.7-14.3 32-32 32H448zM96 336c-8.8 0-16 7.2-16 16V480c0 8.8 7.2 16 16 16H416c8.8 0 16-7.2 16-16V352c0-8.8-7.2-16-16-16H96zm336-80a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faCommentXmark = {
    prefix: 'fat',
    iconName: 'comment-xmark',
    icon: [
      512,
      512,
      ["comment-times"],
      'f4b5',
      
      'M157.3 415c-5-1.8-10.6-1-14.9 2.1c-11 8-29.4 19.3-51.2 28.8C68.3 456 41.6 464 16 464l.1-.1 0 0 0 0 .3-.3 .1-.1c.4-.4 .9-.9 1.5-1.6c1.3-1.4 3.2-3.6 5.4-6.3l-12.2-10 12.2 10C28 450 34 442 40 432c10.7-17.9 21.4-42.1 23.6-69.9c.3-4.3-1.1-8.6-3.9-11.8C31.9 318.8 16 280.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-35.2 0-68.6-6.1-98.7-17zM4.7 452.7l0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0zM178.3 162.3c-3.1 3.1-3.1 8.2 0 11.3L244.7 240l-66.3 66.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L256 251.3l66.3 66.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L267.3 240l66.3-66.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L256 228.7l-66.3-66.3c-3.1-3.1-8.2-3.1-11.3 0z'
      
    ]
  };

  
    var faCommentTimes = faCommentXmark;
  

  
  

  var faFaceSmileRelaxed = {
    prefix: 'fat',
    iconName: 'face-smile-relaxed',
    icon: [
      512,
      512,
      [],
      'e392',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm150.6 67.4C171.4 353.2 206.6 384 256 384s84.6-30.8 105.4-60.6c2.5-3.6 7.5-4.5 11.1-2s4.5 7.5 2 11.1C352.1 364.6 312.7 400 256 400s-96.1-35.4-118.6-67.4c-2.5-3.6-1.7-8.6 2-11.1s8.6-1.7 11.1 2zM175.6 200c-14.6 0-30.2 8.6-41 27.9c-2.2 3.9-7 5.2-10.9 3.1s-5.2-7-3.1-10.9c13.1-23.4 33.6-36.1 55-36.1s41.8 12.7 55 36.1c2.2 3.9 .8 8.7-3.1 10.9s-8.7 .8-10.9-3.1c-10.9-19.3-26.4-27.9-41-27.9zm119 27.9c-2.2 3.9-7 5.2-10.9 3.1s-5.2-7-3.1-10.9c13.1-23.4 33.6-36.1 55-36.1s41.8 12.7 55 36.1c2.2 3.9 .8 8.7-3.1 10.9s-8.7 .8-10.9-3.1c-10.9-19.3-26.4-27.9-41-27.9s-30.2 8.6-41 27.9z'
      
    ]
  };

  

  
  

  var faArrowsSpin = {
    prefix: 'fat',
    iconName: 'arrows-spin',
    icon: [
      512,
      512,
      [],
      'e4bb',
      
      'M91.3 65.4c-7.1 0-10.7 8.6-5.7 13.7l32.6 32.6 0 0 .8 .9 44.6 44.6c5 5 13.7 1.5 13.7-5.7l0-86.1-86.1 0zm15.9 57.8L74.3 90.3c-15.1-15.1-4.4-41 17-41h86.1c8.8 0 16 7.2 16 16v86.1c0 21.4-25.9 32.1-41 17l-33.9-33.9c-28.3 32.3-45.4 74.7-45.4 121c0 11.1 1 21.9 2.9 32.5H59.8c-1.7-10.6-2.6-21.4-2.6-32.5c0-50.7 18.9-97.1 50-132.3zm150-51.7c-11.3 0-22.4 1-33.1 3V58.3c10.8-1.8 21.8-2.7 33.1-2.7c51.6 0 98.6 19.5 134 51.6l32.7-32.8c15.1-15.1 41-4.4 41 17l0 86.1c0 8.8-7.2 16-16 16l-86.1 0c-21.4 0-32.1-25.9-17-41l34-34c-32.6-29.2-75.6-46.9-122.7-46.9zm184 184c0-10.7-.9-21.3-2.7-31.5h16.2c1.6 10.3 2.5 20.8 2.5 31.5c0 51.6-19.5 98.6-51.6 134l34.4 34.4c15.1 15.1 4.4 41-17 41H336.9c-8.8 0-16-7.2-16-16V362.8c0-21.4 25.9-32.1 41-17l32.4 32.4c29.2-32.6 46.9-75.6 46.9-122.7zM394.3 401.1l-1.4-1.5-42.4-42.4c-5-5-13.7-1.5-13.7 5.7v86.1H423c7.1 0 10.7-8.6 5.7-13.7L394.4 401l-.1 .1zM288 437v16.2c-10.1 1.6-20.4 2.4-30.9 2.4c-50.7 0-97.1-18.9-132.3-50L90.3 439.9c-15.1 15.1-41 4.4-41-17V336.9c0-8.8 7.2-16 16-16l86.1 0c21.4 0 32.1 25.9 17 41l-32.3 32.3c32.3 28.3 74.7 45.4 121 45.4c10.5 0 20.8-.9 30.9-2.6zM65.4 336.9l0 86.1c0 7.1 8.6 10.7 13.7 5.7l78.1-78.1c5-5 1.5-13.7-5.7-13.7l-86.1 0zM448.9 91.3c0-7.1-8.6-10.7-13.7-5.7l-78.1 78.1c-5 5-1.5 13.7 5.7 13.7l86.1 0 0-86.1z'
      
    ]
  };

  

  
  

  var faExclamation = {
    prefix: 'fat',
    iconName: 'exclamation',
    icon: [
      64,
      512,
      [10069,10071,61738],
      '21',
      
      'M40 40c0-4.4-3.6-8-8-8s-8 3.6-8 8V368c0 4.4 3.6 8 8 8s8-3.6 8-8V40zM32 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faTentArrowsDown = {
    prefix: 'fat',
    iconName: 'tent-arrows-down',
    icon: [
      576,
      512,
      [],
      'e581',
      
      'M197.9 122.6c3 3.3 2.7 8.3-.6 11.3l-80 72c-3 2.7-7.7 2.7-10.7 0l-80-72c-3.3-3-3.6-8-.6-11.3s8-3.6 11.3-.6L104 182 104 8c0-4.4 3.6-8 8-8s8 3.6 8 8l0 174 66.6-60c3.3-3 8.3-2.7 11.3 .6zm85.4 38.8c2.8-2 6.5-2 9.2 0L473 289.3c9.2 6.5 15.2 16.7 16.6 27.9l18 150.1c2.9 23.8-15.7 44.8-39.7 44.8H400.1h-.3H108.1c-24 0-42.6-21-39.7-44.8l18-150.1c1.3-11.2 7.4-21.3 16.6-27.9L283.4 161.5zM467.9 496c14.4 0 25.5-12.6 23.8-26.9L473.7 319c-.8-6.7-4.4-12.8-10-16.7L296 183.5V317.8L404.5 496h63.4zM280 183.5L112.2 302.3c-5.5 3.9-9.1 10-10 16.7l-18 150.1c-1.7 14.3 9.4 26.9 23.8 26.9H280V320.1v-.3V183.5zm16 165.1V496h89.8L296 348.5zM549.4 133.9l-80 72c-3 2.7-7.7 2.7-10.7 0l-80-72c-3.3-3-3.6-8-.6-11.3s8-3.6 11.3-.6L456 182V8c0-4.4 3.6-8 8-8s8 3.6 8 8V182l66.6-60c3.3-3 8.3-2.7 11.3 .6s2.7 8.3-.6 11.3z'
      
    ]
  };

  

  
  

  var faPlane = {
    prefix: 'fat',
    iconName: 'plane',
    icon: [
      576,
      512,
      [],
      'f072',
      
      'M542.7 209.7C559.8 220.2 576 236.2 576 256c0 20.2-16.2 36.3-33.3 46.7c-17.6 10.7-39.3 17.3-55.8 17.3L368 320l-1.3 0L272.1 491.3c-7 12.8-20.5 20.7-35 20.7L189 512c-15.9 0-27.4-15.1-23.1-30.4L210.5 320 192 320H116L75.2 374.4c-4.5 6-11.6 9.6-19.2 9.6H21.9C9.8 384 0 374.2 0 362.1c0-2.2 .3-4.4 1-6.4L31.6 256 1 156.4c-.6-2.1-1-4.3-1-6.4C0 137.8 9.8 128 21.9 128L56 128c7.6 0 14.7 3.6 19.2 9.6L116 192l76 0h18.5L165.9 30.4C161.7 15.1 173.2 0 189 0h48.1c14.6 0 28 7.9 35 20.7L366.7 192l1.3 0H486.8c16.6 0 38.3 7 55.9 17.7zM368 208l-6.1 0-141 0H192l-80 0c-2.5 0-4.9-1.2-6.4-3.2L62.4 147.2c-1.5-2-3.9-3.2-6.4-3.2l-34.1 0c-3.3 0-5.9 2.6-5.9 5.9c0 .6 .1 1.2 .3 1.7L8.6 154l7.6-2.4 31.4 102c.5 1.5 .5 3.2 0 4.7l-31.4 102L8.6 358l7.6 2.4c-.2 .6-.3 1.1-.3 1.7c0 3.3 2.6 5.9 5.9 5.9H56c2.5 0 4.9-1.2 6.4-3.2l43.2-57.6c1.5-2 3.9-3.2 6.4-3.2h80 29H361.9l0 0 6.1 0 118.8 0c13 0 31.9-5.6 47.5-15c16-9.7 25.6-21.6 25.6-33c0-10.9-9.6-22.8-25.7-32.7c-15.7-9.6-34.5-15.3-47.5-15.3H368zm-19.6-16L258.1 28.4c-4.2-7.7-12.3-12.4-21-12.4L189 16c-5.3 0-9.1 5-7.7 10.1L227.1 192H348.4zM227.1 320L181.3 485.9c-1.4 5.1 2.4 10.1 7.7 10.1l48.1 0c8.7 0 16.8-4.8 21-12.4L348.4 320H227.1z'
      
    ]
  };

  

  
  

  var faFaceSadTear = {
    prefix: 'fat',
    iconName: 'face-sad-tear',
    icon: [
      512,
      512,
      [128546,"sad-tear"],
      'f5b4',
      
      'M256 496a240 240 0 1 0 0-480 240 240 0 1 0 0 480zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM176 309.3c-5.9 7.7-12.6 16.6-18.5 26.1C148.9 349.2 144 360.9 144 369c0 16.8 14 31 32 31s32-14.2 32-31c0-8.1-4.8-19.9-13.4-33.6c-6-9.5-12.7-18.5-18.5-26.1zm-6.4-18c3.2-4.4 9.6-4.4 12.8 0c1.2 1.6 2.5 3.3 3.9 5.1c14.2 18.4 37.7 49 37.7 72.7c0 26-21.5 47-48 47s-48-21-48-47c0-23.4 23.1-53.5 37.2-72c1.6-2.1 3.1-4 4.4-5.8zm166-99.3a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-144 16a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM256 320c46.3 0 87.7 26 118.4 67.2c2.6 3.5 1.9 8.6-1.6 11.2s-8.6 1.9-11.2-1.6C332.9 358.4 295.8 336 256 336c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  
    var faSadTear = faFaceSadTear;
  

  
  

  var faBlockBrickFire = {
    prefix: 'fat',
    iconName: 'block-brick-fire',
    icon: [
      640,
      512,
      ["firewall"],
      'e3dc',
      
      'M160 48v80h88 16 88V48H160zm-16 80V48H96C69.5 48 48 69.5 48 96v32h96zM48 144V248H248V144H48zm0 224h96V264H48V368zm0 16v32c0 26.5 21.5 48 48 48H248V384H160 144 48zm112-16H288.8c.5 5.4 1.2 10.7 2.1 16H264v80h60.8c4 5.6 8.3 10.9 12.8 16H96c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64v48.6c-1.7-1.5-3.3-3.1-5-4.6c-3.4-3-7.1-5.5-11-7.4V96c0-26.5-21.5-48-48-48H368v80 16H264V248h58c-3.1 5.2-6.1 10.6-8.9 16H160V368zM445.5 176c-1.5 0-3 .5-4.1 1.5c-23.7 21.3-50.3 48.5-70.8 78.7c-20.6 30.3-34.7 62.9-34.7 95.2c0 50 25.1 94.3 63.7 120.3c-9.9-14.1-15.7-31-15.7-49.2c0-57.4 63.8-110.5 87.4-128.2c5.2-3.9 12.1-3.9 17.3 0c23.6 17.7 87.4 70.8 87.4 128.2c0 17.9-5.7 34.7-15.4 48.7c38.3-26.1 63.4-70.1 63.4-119.8c0-25.8-9.7-53.6-24.5-79.7c-14.8-26.1-34.3-49.8-53.2-67.2c-2.3-2.1-5.9-2.1-8.2 0c-6.3 5.8-12.4 12.6-18.2 19.6c-6.4 7.8-18.2 7.9-24.8 .3c-14.3-16.7-29.5-32.3-45.6-46.8c-1.1-1-2.5-1.5-4-1.5zM480 496c2.8 0 5.6-.1 8.3-.2c41.1-3.9 71.7-36 71.7-73.2c0-23-13-47-31.1-68.7c-17.3-20.7-37.4-37.2-48.9-45.9c-11.5 8.7-31.6 25.2-48.9 45.9C413 375.5 400 399.5 400 422.6c0 37.2 30.6 69.4 71.8 73.2c2.7 .1 5.4 .2 8.2 .2zM320 351.4c0-36.8 16-72.6 37.4-104.2c21.5-31.7 49-59.8 73.3-81.6c4.2-3.8 9.6-5.6 14.9-5.6c5.2 0 10.5 1.9 14.6 5.7c16.6 15 32.3 31.1 47 48.3c0 0 0 0 .1 0l0 0c0 0 .1 0 .1 0s.1 0 .1 0s0 0 .1-.1c6-7.2 12.6-14.8 19.7-21.3c8.4-7.7 21.4-7.7 29.8 .1c20.1 18.5 40.7 43.5 56.3 71.1C629 291.3 640 321.9 640 351.4c0 85.1-66.3 155.4-150.6 160.3c-3.1 .3-6.2 .4-9.4 .4c-3.1 0-6.2-.1-9.2-.4C385.5 507 320 436.5 320 351.4z'
      
    ]
  };

  
    var faFirewall = faBlockBrickFire;
  

  
  

  var faUserInjured = {
    prefix: 'fat',
    iconName: 'user-injured',
    icon: [
      448,
      512,
      [],
      'f728',
      
      'M336 128c0-8.2-.9-16.3-2.6-24H192 114.6c-1.7 7.7-2.6 15.8-2.6 24c0 61.9 50.1 112 112 112s112-50.1 112-112zm-7.4-40c-10.3-26.8-30.6-48.7-56.3-61l-61 61H328.6zM256 20.6c-10.2-3-20.9-4.6-32-4.6c-47.8 0-88.5 29.9-104.6 72h69.3L256 20.6zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM16 482.3c0 7.6 6.1 13.7 13.7 13.7H80V353.1c-38.9 29.6-64 76.5-64 129.1zM96 344V496h72 16 43.7 21.5L137.8 325.1c-14.9 3.8-29 9.7-41.9 17.4c.1 .5 .1 1 .1 1.5zM296 496c22.1 0 40-17.9 40-40s-17.9-40-40-40H216.2l52.2 80H296zm0-96c30.9 0 56 25.1 56 56c0 15.7-6.4 29.8-16.8 40h83.1c7.6 0 13.7-6.1 13.7-13.7C432 392.7 359.3 320 269.7 320H178.3c-8 0-15.9 .6-23.6 1.7L205.7 400H296zM418.3 512H296 176h-8H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7z'
      
    ]
  };

  

  
  

  var faBrainCircuit = {
    prefix: 'fat',
    iconName: 'brain-circuit',
    icon: [
      512,
      512,
      [],
      'e0c6',
      
      'M137.9 48.3C145 20.5 170.1 0 200 0c24.1 0 45.1 13.3 56 33c10.9-19.7 31.9-33 56-33c29.9 0 55 20.5 62.1 48.3C406.6 51.3 432 78.7 432 112c0 6.7-1 13.1-2.9 19.1c29.5 9 50.9 36.4 50.9 68.9c0 12.4-3.1 24.1-8.7 34.3C495.6 248 512 274.1 512 304c0 33.3-20.4 61.9-49.4 73.9c.9 4.6 1.4 9.3 1.4 14.1c0 39.8-32.2 72-72 72c-3.7 0-7.2-.3-10.8-.8C373 491.4 346.9 512 316 512c-26 0-48.5-14.6-60-36c-11.5 21.4-34 36-60 36c-30.9 0-57-20.6-65.2-48.8c-3.5 .5-7.1 .8-10.8 .8c-39.8 0-72-32.2-72-72c0-4.8 .5-9.5 1.4-14.1C20.4 365.9 0 337.3 0 304c0-29.9 16.4-56 40.7-69.7C35.1 224.1 32 212.4 32 200c0-32.4 21.4-59.8 50.9-68.9C81 125.1 80 118.7 80 112c0-33.3 25.4-60.7 57.9-63.7zM200 16c-24.2 0-44.2 17.9-47.5 41.1c-.6 4-4 6.9-8 6.9l-.5 0c-26.5 0-48 21.5-48 48c0 7.7 1.8 14.9 5 21.3c1.1 2.3 1.1 5-.1 7.2s-3.3 3.8-5.8 4.2C68.4 149 48 172.1 48 200c0 12.3 4 23.6 10.7 32.9c1.4 2 1.9 4.5 1.2 6.9s-2.4 4.3-4.6 5.2C32.2 254.6 16 277.4 16 304c0 28.8 19 53.2 45.3 61.2c2 .6 3.7 2 4.7 3.9s1.2 4.1 .6 6.1C64.9 380.5 64 386.2 64 392c0 30.9 25.1 56 56 56c5.1 0 10-.7 14.7-1.9c2.2-.6 4.5-.2 6.4 1s3.2 3.2 3.6 5.4c4 24.7 25.5 43.5 51.3 43.5c27.6 0 50.1-21.4 51.9-48.5c0-.3 .1-.6 .1-.9V444 288H192c-13.3 0-24 10.7-24 24v9c13.8 3.6 24 16.1 24 31c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-14.9 10.2-27.4 24-31v-9c0-22.1 17.9-40 40-40h56V152H207c-3.6 13.8-16.1 24-31 24c-17.7 0-32-14.3-32-32s14.3-32 32-32c14.9 0 27.4 10.2 31 24h41V64c0-26.5-21.5-48-48-48zm64 136V360h73c3.6-13.8 16.1-24 31-24c17.7 0 32 14.3 32 32s-14.3 32-32 32c-14.9 0-27.4-10.2-31-24H264v68 2.6c.1 .3 .1 .6 .1 .9c1.8 27.1 24.3 48.5 51.9 48.5c25.8 0 47.3-18.8 51.3-43.5c.4-2.2 1.7-4.2 3.6-5.4s4.2-1.6 6.4-1c4.7 1.3 9.6 1.9 14.7 1.9c30.9 0 56-25.1 56-56c0-5.8-.9-11.5-2.5-16.7c-.6-2-.4-4.2 .6-6.1s2.7-3.3 4.7-3.9c26.2-8 45.3-32.4 45.3-61.2c0-26.6-16.2-49.4-39.3-59.1c-2.3-.9-4-2.9-4.6-5.2s-.2-4.9 1.2-6.9C460 223.6 464 212.3 464 200c0-27.9-20.4-51-47-55.3c-2.5-.4-4.7-2-5.8-4.2s-1.2-4.9-.1-7.2c3.2-6.4 5-13.6 5-21.3c0-26.5-21.5-48-48-48l-.5 0c-4 0-7.4-2.9-8-6.9C356.2 33.9 336.2 16 312 16c-26.5 0-48 21.5-48 48v72h56c22.1 0 40 17.9 40 40v17c13.8 3.6 24 16.1 24 31c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-14.9 10.2-27.4 24-31V176c0-13.3-10.7-24-24-24H264zm-88 8a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM160 368a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM368 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faSkiBootSki = {
    prefix: 'fat',
    iconName: 'ski-boot-ski',
    icon: [
      640,
      512,
      [],
      'e3cd',
      
      'M407.8 9.7c.9-4.3-1.8-8.6-6.1-9.5s-8.6 1.8-9.5 6.1L386.7 32H179.8c-15.3 0-28.5 10.8-31.4 25.9l-57 291.4c-6.8 34.6 19.7 66.8 55 66.8H440c22.1 0 40-17.9 40-40V308.4c0-15.5-9-29.7-23.1-36.2l-95.8-44.7L407.8 9.7zM279 48H383.2l-24 112H296c-4.4 0-8 3.6-8 8s3.6 8 8 8h59.8l-10.3 48H280c-4.4 0-8 3.6-8 8s3.6 8 8 8h70.2l99.9 46.6c8.4 3.9 13.8 12.4 13.8 21.7V376c0 13.3-10.7 24-24 24H146.3c-25.2 0-44.1-23-39.3-47.7l20.6-105.5c1.2 0 2.4-.2 3.6-.7c46.9-20.8 119.1-72.1 147.6-197.5c0-.2 .1-.4 .1-.6zm-16.4 0C236.3 159.8 174 207.8 131.3 228.5L164.1 60.9c1.5-7.5 8.1-12.9 15.7-12.9h82.8zM640 424c0-4.4-3.6-8-8-8s-8 3.6-8 8c0 39.8-32.2 72-72 72H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H552c48.6 0 88-39.4 88-88z'
      
    ]
  };

  

  
  

  var faKeyboardBrightnessLow = {
    prefix: 'fat',
    iconName: 'keyboard-brightness-low',
    icon: [
      640,
      512,
      [],
      'e1c1',
      
      'M320 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM200 400c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H200zM160 240a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm336 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM80 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faBenchTree = {
    prefix: 'fat',
    iconName: 'bench-tree',
    icon: [
      640,
      512,
      [],
      'e2e7',
      
      'M591 108.6c-.9 6 1.5 11.9 6.4 15.5C613.6 135.7 624 154.7 624 176c0 35.3-28.7 64-64 64H464c-35.3 0-64-28.7-64-64c0-21.3 10.4-40.3 26.6-51.9c4.9-3.5 7.4-9.5 6.4-15.5c-.6-4.1-1-8.3-1-12.6c0-44.2 35.8-80 80-80s80 35.8 80 80c0 4.3-.3 8.5-1 12.6zm15.8 2.5c.8-4.9 1.2-10 1.2-15.1c0-53-43-96-96-96s-96 43-96 96c0 5.1 .4 10.2 1.2 15.1C397.1 125.7 384 149.3 384 176c0 44.2 35.8 80 80 80h40V504c0 4.4 3.6 8 8 8s8-3.6 8-8V256h40c44.2 0 80-35.8 80-80c0-26.7-13.1-50.3-33.2-64.9zM64 208H320c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H304 80 64c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16zm8 112v64H48 8c-4.4 0-8 3.6-8 8s3.6 8 8 8H40V504c0 4.4 3.6 8 8 8s8-3.6 8-8V400H80 304h24V504c0 4.4 3.6 8 8 8s8-3.6 8-8V400h32c4.4 0 8-3.6 8-8s-3.6-8-8-8H336 312V320h8c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h8zm224 0v64H88V320H296z'
      
    ]
  };

  

  
  

  var faCircle3 = {
    prefix: 'fat',
    iconName: 'circle-3',
    icon: [
      512,
      512,
      [],
      'e0f0',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM168 128c-4.4 0-8 3.6-8 8s3.6 8 8 8H306.7l-112 98c-2.5 2.2-3.4 5.7-2.2 8.9s4.2 5.2 7.5 5.2l79.5-.4c31.1-.1 56.4 25.1 56.4 56.2c0 31-25.2 56.2-56.2 56.2H208.7c-12.1 0-23.2-6.8-28.6-17.7l-4.9-9.9c-2-4-6.8-5.6-10.7-3.6s-5.6 6.8-3.6 10.7l4.9 9.9c8.1 16.3 24.8 26.5 42.9 26.5h71.1c39.9 0 72.2-32.3 72.2-72.2c0-40-32.5-72.4-72.5-72.2l-58.1 .3L333.3 142c2.5-2.2 3.4-5.7 2.2-8.8s-4.2-5.2-7.5-5.2H168z'
      
    ]
  };

  

  
  

  var faCardsBlank = {
    prefix: 'fat',
    iconName: 'cards-blank',
    icon: [
      640,
      512,
      [],
      'e4df',
      
      'M36.1 132.5C17 143.6 10.4 168 21.5 187.2L188.2 475.9c11 19.1 35.5 25.7 54.6 14.6l192.3-111c19.1-11 25.7-35.5 14.6-54.6L283.1 36.1C272 17 247.6 10.4 228.4 21.5L36.1 132.5zM7.6 195.2c-15.5-26.8-6.3-61 20.5-76.5L220.4 7.6c26.8-15.5 61-6.3 76.5 20.5L463.6 316.9c15.5 26.8 6.3 61-20.5 76.5l-192.3 111c-26.8 15.5-61 6.3-76.5-20.5L7.6 195.2zM360 512c-13.6 0-26.2-4.9-35.9-13l15.2-8.8c6 3.7 13.1 5.8 20.7 5.8H584c22.1 0 40-17.9 40-40V120c0-22.1-17.9-40-40-40H363.8l-9.1-15.8c1.7-.2 3.5-.2 5.3-.2H584c30.9 0 56 25.1 56 56V456c0 30.9-25.1 56-56 56H360z'
      
    ]
  };

  

  
  

  var faBone = {
    prefix: 'fat',
    iconName: 'bone',
    icon: [
      576,
      512,
      [129460],
      'f5d7',
      
      'M408 192c13.6 0 23.2-10.8 24.3-22.4c3.2-32.3 30.5-57.6 63.7-57.6c35.3 0 64 28.7 64 64c0 24.7-14 46.2-34.6 56.9c-7.6 3.9-13.4 12-13.4 21.7v2.8c0 9.7 5.8 17.8 13.4 21.7C546 289.8 560 311.3 560 336c0 35.3-28.7 64-64 64c-33.2 0-60.5-25.3-63.7-57.6C431.2 330.8 421.6 320 408 320H168c-13.6 0-23.2 10.8-24.3 22.4C140.5 374.7 113.2 400 80 400c-35.3 0-64-28.7-64-64c0-24.7 14-46.2 34.6-56.9c7.6-3.9 13.4-12 13.4-21.7v-2.8c0-9.7-5.8-17.8-13.4-21.7C30 222.2 16 200.7 16 176c0-35.3 28.7-64 64-64c33.2 0 60.5 25.3 63.7 57.6c1.1 11.6 10.7 22.4 24.3 22.4H408zM168 176c-4.4 0-8-3.6-8.4-8c-4-40.4-38.1-72-79.6-72C35.8 96 0 131.8 0 176c0 30.9 17.6 57.8 43.3 71.1c2.8 1.5 4.7 4.3 4.7 7.5v2.8c0 3.2-1.9 6-4.7 7.5C17.6 278.2 0 305.1 0 336c0 44.2 35.8 80 80 80c41.5 0 75.6-31.6 79.6-72c.4-4.4 4-8 8.4-8H408c4.4 0 8 3.6 8.4 8c4 40.4 38.1 72 79.6 72c44.2 0 80-35.8 80-80c0-30.9-17.6-57.8-43.3-71.1c-2.8-1.5-4.7-4.3-4.7-7.5v-2.8c0-3.2 1.9-6 4.7-7.5C558.4 233.8 576 206.9 576 176c0-44.2-35.8-80-80-80c-41.5 0-75.6 31.6-79.6 72c-.4 4.4-4 8-8.4 8H168z'
      
    ]
  };

  

  
  

  var faFileCheck = {
    prefix: 'fat',
    iconName: 'file-check',
    icon: [
      384,
      512,
      [],
      'f316',
      
      'M64 496c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM277.7 280.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-101 101-47.7-47.7c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L159.7 387c3.1 3.1 8.2 3.1 11.3 0L277.7 280.3z'
      
    ]
  };

  

  
  

  var faArrowUpFromWaterPump = {
    prefix: 'fat',
    iconName: 'arrow-up-from-water-pump',
    icon: [
      576,
      512,
      [],
      'e4b6',
      
      'M112 16C94.3 16 80 30.3 80 48V256H272V48c0-17.7-14.3-32-32-32H112zM288 48V256H440l0-228.7-82.3 82.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l96-96c3.1-3.1 8.2-3.1 11.3 0l96 96c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L456 27.3 456 256h56c35.3 0 64 28.7 64 64V425c-4.9-2.8-10.3-5-16-6.5V320c0-26.5-21.5-48-48-48H288 272 80 64c-26.5 0-48 21.5-48 48v98.5C10.3 420 4.9 422.2 0 425V320c0-35.3 28.7-64 64-64V48C64 21.5 85.5 0 112 0H240c26.5 0 48 21.5 48 48zm6.6 387.4c8 11.2 17.5 21.4 27.6 30.7C339.5 481.8 361.5 496 384 496s44.6-14.2 61.8-29.9c10.1-9.2 19.7-19.5 27.6-30.7c1.5-2.1 3.9-3.4 6.6-3.4s5.1 1.3 6.6 3.4c7.3 10.3 15.9 19.6 25 28.3c15.7 14.8 36.1 29.2 57.4 31.9c4.4 .6 7.5 4.6 6.9 8.9s-4.6 7.5-8.9 6.9c-26.5-3.3-50-20.7-66.4-36.1c-8.8-8.3-15.9-16.4-20.6-22.2c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8l0 0 0 0c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-4.7 5.8-11.8 13.9-20.6 22.2C59 490.7 35.5 508.1 9 511.4c-4.4 .6-8.4-2.6-8.9-6.9s2.6-8.4 6.9-8.9c21.3-2.7 41.7-17.1 57.4-31.9c9.1-8.6 17.7-18 25-28.3c1.5-2.1 3.9-3.4 6.6-3.4s5.1 1.3 6.6 3.4c7.9 11.2 17.5 21.5 27.6 30.7C147.4 481.8 169.5 496 192 496s44.6-14.2 61.8-29.9c10.1-9.2 19.6-19.5 27.6-30.7c3-4.3 10.2-4.3 13.2 0z'
      
    ]
  };

  

  
  

  var faBoot = {
    prefix: 'fat',
    iconName: 'boot',
    icon: [
      512,
      512,
      [129406],
      'f782',
      
      'M32 16H352c8.8 0 16 7.2 16 16V96c0 8.8-7.2 16-16 16H16V32c0-8.8 7.2-16 16-16zM0 32v80 16H16 352c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32C14.3 0 0 14.3 0 32zM240 160c-4.4 0-8 3.6-8 8s3.6 8 8 8h96v48H240c-4.4 0-8 3.6-8 8s3.6 8 8 8H348.6l100.3 45.1c28.7 12.9 47.2 41.5 47.2 73V400H16V160H0V400v16 41.4c0 14.5 5.8 28.4 16 38.6s24.1 16 38.6 16H69.5c17 0 33.3-6.7 45.3-18.7l7.6-7.6c3.1-3.1 8.2-3.1 11.3 0l7.6 7.6c12 12 28.3 18.7 45.3 18.7h11c17 0 33.3-6.7 45.3-18.7l7.6-7.6c3.1-3.1 8.2-3.1 11.3 0l7.6 7.6c12 12 28.3 18.7 45.3 18.7h11c17 0 33.3-6.7 45.3-18.7l7.6-7.6c3.1-3.1 8.2-3.1 11.3 0l7.6 7.6c12 12 28.3 18.7 45.3 18.7h14.9c14.5 0 28.4-5.8 38.6-16s16-24.1 16-38.6V416 400 358.1c0-37.8-22.2-72-56.6-87.5L352 224V168c0-4.4-3.6-8-8-8H240zM16 416H496v41.4c0 10.2-4.1 20.1-11.3 27.3s-17.1 11.3-27.3 11.3H442.5c-12.7 0-24.9-5.1-33.9-14.1l-7.6-7.6c-9.4-9.4-24.6-9.4-33.9 0l-7.6 7.6c-9 9-21.2 14.1-33.9 14.1h-11c-12.7 0-24.9-5.1-33.9-14.1l-7.6-7.6c-9.4-9.4-24.6-9.4-33.9 0l-7.6 7.6c-9 9-21.2 14.1-33.9 14.1h-11c-12.7 0-24.9-5.1-33.9-14.1l-7.6-7.6c-9.4-9.4-24.6-9.4-33.9 0l-7.6 7.6c-9 9-21.2 14.1-33.9 14.1H54.6c-10.2 0-20.1-4.1-27.3-11.3S16 467.6 16 457.4V416z'
      
    ]
  };

  

  
  

  var faTruckContainer = {
    prefix: 'fat',
    iconName: 'truck-container',
    icon: [
      640,
      512,
      [],
      'f4dc',
      
      'M0 88C0 57.1 25.1 32 56 32H360c30.9 0 56 25.1 56 56V312c0 4.4-3.6 8-8 8s-8-3.6-8-8V88c0-22.1-17.9-40-40-40H56C33.9 48 16 65.9 16 88V312c0 4.4-3.6 8-8 8s-8-3.6-8-8V88zm448 72c0-13.3 10.7-24 24-24h72c12.6 0 24.4 5.9 32 16l56 74.7c5.2 6.9 8 15.3 8 24V304v72c0 17.7-14.3 32-32 32h-.4c-4 40.4-38.1 72-79.6 72c-44.2 0-80-35.8-80-80H304c0 44.2-35.8 80-80 80c-31.7 0-59-18.4-72-45.1C139 461.6 111.7 480 80 480c-44.2 0-80-35.8-80-80s35.8-80 80-80c31.7 0 59 18.4 72 45.1c13-26.7 40.3-45.1 72-45.1c38.7 0 71 27.5 78.4 64H448V352 160zM608 392c8.8 0 16-7.2 16-16V304 256H464v96c14.6-19.4 37.8-32 64-32c41.5 0 75.6 31.6 79.6 72h.4zm13.5-152c-.6-1.3-1.4-2.6-2.3-3.7l-56-74.7c-4.5-6-11.6-9.6-19.2-9.6H472c-4.4 0-8 3.6-8 8v80H621.5zM120 104V264c0 4.4-3.6 8-8 8s-8-3.6-8-8V104c0-4.4 3.6-8 8-8s8 3.6 8 8zm96 0V264c0 4.4-3.6 8-8 8s-8-3.6-8-8V104c0-4.4 3.6-8 8-8s8 3.6 8 8zm96 0V264c0 4.4-3.6 8-8 8s-8-3.6-8-8V104c0-4.4 3.6-8 8-8s8 3.6 8 8zM528 464a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM288 400a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM80 464a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  

  
  

  var faPenFancySlash = {
    prefix: 'fat',
    iconName: 'pen-fancy-slash',
    icon: [
      640,
      512,
      [],
      'e210',
      
      'M548.7 139.4c17.3-15.1 27.3-36.9 27.3-59.9C576 35.6 540.4 0 496.5 0c-23 0-44.8 9.9-59.9 27.3L318.4 163l12.6 9.9L448.7 37.8C460.7 23.9 478.2 16 496.5 16C531.6 16 560 44.4 560 79.5c0 18.4-7.9 35.8-21.8 47.9l-126 109.7L425 247.2 548.7 139.4zM158.5 273.3c-18 5.1-32.2 18.9-37.9 36.7L66.3 478.7c-6.1 18.9 12.2 36.6 30.9 29.9l170.8-61c16.6-5.9 29.5-19.4 34.7-36.3l19.1-62.2-13.5-10.6-20.9 68.1c-3.7 12.1-12.9 21.7-24.8 25.9L94.8 492.5l75.1-75.1c6.3 4.2 13.9 6.6 22.1 6.6c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 8.2 2.4 15.7 6.6 22.1L81.7 482.9l54-168.1c4.1-12.7 14.3-22.6 27.1-26.2l60.4-17.3-15.5-12.2-49.3 14.1zM168 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  

  
  

  var faToggleLargeOff = {
    prefix: 'fat',
    iconName: 'toggle-large-off',
    icon: [
      576,
      512,
      [],
      'e5b0',
      
      'M160 400a144 144 0 1 1 0-288 144 144 0 1 1 0 288zm0 16H416c88.4 0 160-71.6 160-160s-71.6-160-160-160H160C71.6 96 0 167.6 0 256s71.6 160 160 160zm69.8-16c53.4-25.9 90.2-80.7 90.2-144s-36.8-118.1-90.2-144H416c79.5 0 144 64.5 144 144s-64.5 144-144 144H229.8z'
      
    ]
  };

  

  
  

  var faLightSwitchOff = {
    prefix: 'fat',
    iconName: 'light-switch-off',
    icon: [
      384,
      512,
      [],
      'e018',
      
      'M64 496c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H320c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H64zM0 448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448zM272 248H112V144c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32V248zM112 264H272V368c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32V264zM96 368c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H144c-26.5 0-48 21.5-48 48V368zm96 72a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0-400a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM152 352V304h80v48H152zm-16 0c0 8.8 7.2 16 16 16h80c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H152c-8.8 0-16 7.2-16 16v48z'
      
    ]
  };

  

  
  

  var faCupcake = {
    prefix: 'fat',
    iconName: 'cupcake',
    icon: [
      448,
      512,
      [129473],
      'e402',
      
      'M208 0c-3 0-5.7 1.6-7.1 4.2s-1.2 5.8 .4 8.2l10.8 16.3c2.5 3.7 3.8 8.1 3.8 12.6C216 53.8 205.8 64 193.3 64H152c-35.3 0-64 28.7-64 64H80c-44.2 0-80 35.8-80 80s35.8 80 80 80H368c44.2 0 80-35.8 80-80s-35.8-80-80-80h-8.1c0-.9 .1-1.8 .1-2.7C360 56.1 303.9 0 234.7 0H208zm17.5 19.8L222.9 16h11.7C295 16 344 65 344 125.3c0 3.2-.3 6.2-.8 9.2c-.4 2.3 .2 4.7 1.7 6.6s3.8 2.9 6.1 2.9h17c35.3 0 64 28.7 64 64s-28.7 64-64 64H80c-35.3 0-64-28.7-64-64s28.7-64 64-64H96.6c2.3 0 4.5-1 6-2.8s2.2-4.1 1.9-6.4c-.3-2.2-.5-4.5-.5-6.9c0-26.5 21.5-48 48-48h41.3C214.7 80 232 62.7 232 41.3c0-7.6-2.3-15.1-6.5-21.5zM90.1 470.8c3.4 23.6 23.6 41.2 47.5 41.2H310.4c23.9 0 44.1-17.6 47.5-41.2L379.4 320H363.3L342 468.5c-2.3 15.8-15.8 27.5-31.7 27.5H272l14.7-176H270.6L256 495.3c0 .2 0 .4 0 .7H192c0-.2 0-.4 0-.7L177.4 320H161.3L176 496H137.6c-15.9 0-29.4-11.7-31.7-27.5L84.7 320H68.6L90.1 470.8z'
      
    ]
  };

  

  
  

  var faBugSlash = {
    prefix: 'fat',
    iconName: 'bug-slash',
    icon: [
      640,
      512,
      [],
      'e490',
      
      'M418.2 425.3c-23.9 22.3-55.4 36.6-90.2 38.5V354l-16-12.6V463.8c-75.8-4.2-136-66.9-136-143.8V288 264c0-9.3 1.4-18.3 4.1-26.7l-13.3-10.5c-4.4 11.5-6.8 24.1-6.8 37.2v16H72c-4.4 0-8 3.6-8 8s3.6 8 8 8h88v24c0 33.2 10.1 63.9 27.3 89.5c-.4 .3-.7 .5-1 .9l-88 88c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L197 422.3c29.3 35.2 73.6 57.7 123 57.7c43.1 0 82.2-17 110.9-44.7l-12.7-10zM387.6 128c15.7 0 28.4-12.7 28.4-28.4V96c0-53-43-96-96-96c-50.6 0-92 39.1-95.7 88.7l15.8 12.5c-.1-.5-.1-1.1-.1-1.6V96c0-44.2 35.8-80 80-80s80 35.8 80 80v3.6c0 6.9-5.6 12.4-12.4 12.4H253.8l20.3 16H387.6zM376 160H314.6l20.3 16H376c48.6 0 88 39.4 88 88v14l22.9 18H568c4.4 0 8-3.6 8-8s-3.6-8-8-8H480V264c0-25.8-9.4-49.5-25-67.7l86.7-86.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L443.7 185c-18.2-15.6-41.8-25-67.7-25zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  

  
  

  var faFaceSadSweat = {
    prefix: 'fat',
    iconName: 'face-sad-sweat',
    icon: [
      576,
      512,
      [],
      'e38a',
      
      'M288 16C166 16 65.2 107.1 50 225c-.6 4.4-4.6 7.5-9 6.9s-7.5-4.6-6.9-9C50.3 97.2 157.8 0 288 0C429.4 0 544 114.6 544 256s-114.6 256-256 256c-70.4 0-134.1-28.4-180.4-74.3c-3.1-3.1-3.2-8.2 0-11.3s8.2-3.2 11.3 0C162.3 469.4 222 496 288 496c132.5 0 240-107.5 240-240S420.5 16 288 16zm77.4 397.9c-3.3 3-8.3 2.7-11.3-.6C341.3 399.1 319.3 384 288 384s-53.3 15.1-66.1 29.4c-3 3.3-8 3.6-11.3 .6s-3.6-8-.6-11.3C225.1 386 251.1 368 288 368s62.9 18 77.9 34.6c3 3.3 2.7 8.3-.6 11.3zM197.7 173.7l-7.4 7.4c-22.4 22.4-51.2 37.2-82.5 42.5l-2.5 .4c-4.4 .7-8.5-2.2-9.2-6.6s2.2-8.5 6.6-9.2l2.5-.4c28-4.7 53.8-17.9 73.8-38l7.4-7.4c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3zm180.7-11.3c3.1-3.1 8.2-3.1 11.3 0l7.4 7.4c20 20 45.8 33.3 73.8 38l2.5 .4c4.4 .7 7.3 4.8 6.6 9.2s-4.8 7.3-9.2 6.6l-2.5-.4c-31.3-5.2-60.1-20.1-82.5-42.5l-7.4-7.4c-3.1-3.1-3.1-8.2 0-11.3zM93.3 316c-9.6-15.2-20.9-30.3-29.3-40.9c-8.4 10.7-19.7 25.7-29.3 40.9c-5.6 8.9-10.5 17.5-13.9 25.1c-3.6 8-4.8 13.3-4.8 16.1C16 379.6 36.2 400 64 400s48-20.4 48-42.7c0-2.8-1.2-8.2-4.8-16.2c-3.4-7.6-8.2-16.2-13.9-25.1zM72.5 260.1c17.6 21.7 55.5 72.2 55.5 97.2c0 32.5-28.7 58.7-64 58.7s-64-26.2-64-58.7c0-25 38.1-75.5 55.5-97.2c4.3-5.5 12.8-5.5 17.1 0zM383.6 272a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faLocationPinSlash = {
    prefix: 'fat',
    iconName: 'location-pin-slash',
    icon: [
      640,
      512,
      ["map-marker-slash"],
      'f60c',
      
      'M512 192C512 86 426 0 320 0C266.7 0 218.5 21.7 183.8 56.7l12.6 10C228.2 35.3 271.8 16 320 16c97.2 0 176 78.8 176 176c0 18.7-6.4 42.5-17.8 69.6c-2.8 6.6-5.9 13.4-9.2 20.3L481.9 292c18.1-36.9 30.1-72 30.1-100zm-383.9 4.2c3.6 88.1 117.7 239.8 168.2 302.9c12.3 15.3 35.1 15.3 47.4 0c16.2-20.3 39.1-49.7 62.6-83.3L393.8 406c-23.5 33.5-46.3 62.9-62.6 83.2c-5.9 7.3-16.6 7.3-22.4 0c-25.5-31.8-67.1-86.2-102.3-143.2c-17.6-28.5-33.4-57.4-44.7-84.3c-8-19-13.6-36.4-16.1-51.5l-17.6-13.9zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  
    var faMapMarkerSlash = faLocationPinSlash;
  

  
  

  var faWindWarning = {
    prefix: 'fat',
    iconName: 'wind-warning',
    icon: [
      640,
      512,
      ["wind-circle-exclamation"],
      'f776',
      
      'M224 464c86.5 0 160.7-52.8 192.1-128h17.2C401.1 420.2 319.5 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32s224 100.3 224 224H432c0-114.9-93.1-208-208-208S16 141.1 16 256s93.1 208 208 208zm0-336c4.4 0 8 3.6 8 8V296c0 4.4-3.6 8-8 8s-8-3.6-8-8V136c0-4.4 3.6-8 8-8zM208 352a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM480 472c0-4.4 3.6-8 8-8h56c44.2 0 80-35.8 80-80s-35.8-80-80-80H328c-4.4 0-8-3.6-8-8s3.6-8 8-8H544c53 0 96 43 96 96s-43 96-96 96H488c-4.4 0-8-3.6-8-8zm64-248H478c-.7-5.4-1.5-10.7-2.5-16H544c44.2 0 80-35.8 80-80s-35.8-80-80-80H488c-4.4 0-8-3.6-8-8s3.6-8 8-8h56c53 0 96 43 96 96s-43 96-96 96z'
      
    ]
  };

  
    var faWindCircleExclamation = faWindWarning;
  

  
  

  var faPaperclipVertical = {
    prefix: 'fat',
    iconName: 'paperclip-vertical',
    icon: [
      384,
      512,
      [],
      'e3c2',
      
      'M80 88c0-48.6 39.4-88 88-88s88 39.4 88 88V352c0 35.3-28.7 64-64 64s-64-28.7-64-64V136c0-4.4 3.6-8 8-8s8 3.6 8 8V352c0 26.5 21.5 48 48 48s48-21.5 48-48V88c0-39.8-32.2-72-72-72s-72 32.2-72 72V400c0 53 43 96 96 96s96-43 96-96V136c0-4.4 3.6-8 8-8s8 3.6 8 8V400c0 61.9-50.1 112-112 112s-112-50.1-112-112V88z'
      
    ]
  };

  

  
  

  var faHundredPoints = {
    prefix: 'fat',
    iconName: 'hundred-points',
    icon: [
      512,
      512,
      [128175,"100"],
      'e41c',
      
      'M179.5 86c3-30.6 28.7-54 59.5-54c35.3 0 62.9 30.4 59.5 65.5L284.5 242c-3 30.6-28.7 54-59.5 54c-35.3 0-62.9-30.4-59.5-65.5L179.5 86zM239 48c-22.5 0-41.4 17.1-43.6 39.5L181.5 232c-2.5 25.7 17.7 48 43.6 48c22.5 0 41.4-17.1 43.6-39.5L282.5 96C285 70.3 264.8 48 239 48zM124.8 33.5c2.3 1.7 3.5 4.4 3.2 7.3l-32 272c-.5 4.4-4.5 7.6-8.9 7.2s-7.5-4.4-7-8.8L110.4 53 51.2 79.3c-4.1 1.8-8.8 0-10.5-4s.1-8.8 4.2-10.6l72-32c2.6-1.2 5.7-.9 7.9 .8zM404 32c37.1 0 66.3 31.4 63.7 68.4l-8 112.3C457.3 246.1 429.5 272 396 272c-37.1 0-66.3-31.4-63.7-68.4l8-112.3C342.7 57.9 370.5 32 404 32zM356.3 92.4l-8 112.3c-2 27.7 20 51.3 47.7 51.3c25.1 0 45.9-19.4 47.7-44.4l8-112.3c2-27.7-20-51.3-47.7-51.3c-25.1 0-45.9 19.4-47.7 44.4zM511.9 326.7c.7 4.4-2.3 8.5-6.6 9.2l-496 80c-4.4 .7-8.5-2.3-9.2-6.6s2.3-8.5 6.6-9.2l496-80c4.4-.7 8.5 2.3 9.2 6.6zm-46.7 97.2l-272 40c-4.4 .6-8.4-2.4-9.1-6.7s2.4-8.4 6.8-9.1l272-40c4.4-.6 8.4 2.4 9.1 6.7s-2.4 8.4-6.8 9.1z'
      
    ]
  };

  
    var fa100 = faHundredPoints;
  

  
  

  var faDown = {
    prefix: 'fat',
    iconName: 'down',
    icon: [
      384,
      512,
      ["arrow-alt-down"],
      'f354',
      
      'M192 464c8.1 0 15.9-3.2 21.7-9L362.1 306.6c3.8-3.8 5.9-9 5.9-14.3c0-11.2-9.1-20.3-20.3-20.3H248c-4.4 0-8-3.6-8-8V72c0-13.3-10.7-24-24-24H168c-13.3 0-24 10.7-24 24V264c0 4.4-3.6 8-8 8H36.3C25.1 272 16 281.1 16 292.3c0 5.4 2.1 10.5 5.9 14.3L170.3 455c5.7 5.7 13.5 9 21.7 9zM384 292.3c0 9.6-3.8 18.9-10.6 25.7L225 466.4c-8.7 8.7-20.6 13.7-33 13.7s-24.2-4.9-33-13.7L10.6 317.9C3.8 311.1 0 301.9 0 292.3c0-20 16.2-36.3 36.3-36.3H128V72c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40V256h91.7c20 0 36.3 16.2 36.3 36.3z'
      
    ]
  };

  
    var faArrowAltDown = faDown;
  

  
  

  var faNoteSticky = {
    prefix: 'fat',
    iconName: 'note-sticky',
    icon: [
      448,
      512,
      [62026,"sticky-note"],
      'f249',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H284.1c1.3 0 2.6-.1 3.9-.2V368c0-26.5 21.5-48 48-48h95.8c.2-1.3 .2-2.6 .2-3.9V96c0-26.5-21.5-48-48-48H64zM304 457.1c1-.8 1.9-1.6 2.7-2.4L422.6 338.7c.9-.9 1.7-1.8 2.4-2.7H336c-17.7 0-32 14.3-32 32v89.1zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V316.1c0 12.7-5.1 24.9-14.1 33.9L318.1 465.9c-9 9-21.2 14.1-33.9 14.1H64c-35.3 0-64-28.7-64-64V96z'
      
    ]
  };

  
    var faStickyNote = faNoteSticky;
  

  
  

  var faDiceD12 = {
    prefix: 'fat',
    iconName: 'dice-d12',
    icon: [
      512,
      512,
      [],
      'f6ce',
      
      'M200.3 16c-5.6 0-11.1 1.5-16 4.3L93 73l163 46.7L419 73 327.7 20.3c-4.9-2.8-10.4-4.3-16-4.3L200.3 16zM77.6 85.2c-.6 .8-1.1 1.7-1.6 2.5L20.3 184.3c-2.3 3.9-3.7 8.2-4.1 12.7L129.6 314.7 248 251.2V134L77.6 85.2zM16 219.8l0 91.9c0 5.6 1.5 11.1 4.3 16L76 424.3c2.8 4.9 6.8 8.9 11.7 11.7l93.9 54.2L121.1 329 16 219.8zM200.9 496H311.1l63-167.7L256 265.1 138 328.3l63 167.7zm129.4-5.8L424.3 436c4.9-2.8 8.9-6.9 11.7-11.7l55.7-96.5c2.8-4.9 4.3-10.4 4.3-16v-96L390.9 328.9 330.3 490.2zM495.2 193.1c-.7-3.1-1.9-6.1-3.5-8.9L436 87.7c-.5-.9-1-1.7-1.6-2.5L264 134V251.2l118.3 63.4L495.2 193.1zM176.3 6.4c7.3-4.2 15.6-6.4 24-6.4H311.7c8.4 0 16.7 2.2 24 6.4l96.5 55.7c7.3 4.2 13.4 10.3 17.6 17.6l55.7 96.5c4.2 7.3 6.4 15.6 6.4 24V311.7c0 8.4-2.2 16.7-6.4 24l-55.7 96.5c-4.2 7.3-10.3 13.4-17.6 17.6l-96.5 55.7c-7.3 4.2-15.6 6.4-24 6.4H200.3c-8.4 0-16.7-2.2-24-6.4L79.7 449.8c-7.3-4.2-13.4-10.3-17.6-17.6L6.4 335.7c-4.2-7.3-6.4-15.6-6.4-24V200.3c0-8.4 2.2-16.7 6.4-24L62.2 79.7c4.2-7.3 10.3-13.4 17.6-17.6L176.3 6.4z'
      
    ]
  };

  

  
  

  var faGramophone = {
    prefix: 'fat',
    iconName: 'gramophone',
    icon: [
      384,
      512,
      [],
      'f8bd',
      
      'M116.7 22.4c.9-3.7 4.3-6.4 8.1-6.4c3.5 0 6.8 2.1 8.3 5.6c14.5 31.8 64.7 130.4 159.6 197.3c-49.1-4.3-126.1 10.8-221.7 78.2c-4.4 3.1-10.3 3.2-14.6 .3c-4.4-2.9-6.5-8.3-5.2-13.4L116.7 22.4zm31-7.4C143.7 6.1 134.8 0 124.8 0c-11.2 0-21 7.6-23.7 18.5L35.7 280c-2.9 11.7 1.8 23.9 11.8 30.6s23 6.3 32.7-.6c114.8-81 199-82.5 236.9-70.4c19.1 6.1 34.8 25.6 34.8 44.6c0 12.2-5.2 25.3-13.6 35.4c-8.4 10.1-19.3 16.2-30.1 16.2L168 336c-4.4 0-8 3.6-8 8s3.6 8 8 8l140.3 0c17.3 0 32.3-9.4 42.7-22.1s17-29.3 17-45.6c0-26.4-15.8-47.9-37.6-60.4c-109.8-63-167.2-174.8-182.7-209zM304 400c17.7 0 32 14.3 32 32v16H48V432c0-17.7 14.3-32 32-32H304zM80 384c-26.5 0-48 21.5-48 48v16c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32V432c0-26.5-21.5-48-48-48H80zM32 464H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H32c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faJar = {
    prefix: 'fat',
    iconName: 'jar',
    icon: [
      320,
      512,
      [],
      'e516',
      
      'M80 16c-8.8 0-16 7.2-16 16V64H256V32c0-8.8-7.2-16-16-16H80zM48 66V64 32C48 14.3 62.3 0 80 0H240c17.7 0 32 14.3 32 32V64v2c27.6 7.1 48 32.2 48 62V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128C0 98.2 20.4 73.1 48 66zM256 80H64c-26.5 0-48 21.5-48 48v64H304V128c0-26.5-21.5-48-48-48zM16 368H304V208H16V368zm0 16v64c0 26.5 21.5 48 48 48H256c26.5 0 48-21.5 48-48V384H16z'
      
    ]
  };

  

  
  

  var faMagnet = {
    prefix: 'fat',
    iconName: 'magnet',
    icon: [
      448,
      512,
      [129522],
      'f076',
      
      'M40 48C26.7 48 16 58.7 16 72v72H128V72c0-13.3-10.7-24-24-24H40zM16 256c0 114.9 93.1 208 208 208s208-93.1 208-208V160H320v96c0 53-43 96-96 96s-96-43-96-96V160H16v96zM432 144V72c0-13.3-10.7-24-24-24H344c-13.3 0-24 10.7-24 24v72H432zM0 72C0 49.9 17.9 32 40 32h64c22.1 0 40 17.9 40 40V256c0 44.2 35.8 80 80 80s80-35.8 80-80V72c0-22.1 17.9-40 40-40h64c22.1 0 40 17.9 40 40V256c0 123.7-100.3 224-224 224S0 379.7 0 256V72z'
      
    ]
  };

  

  
  

  var faCircle2 = {
    prefix: 'fat',
    iconName: 'circle-2',
    icon: [
      512,
      512,
      [],
      'e0ef',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM219.4 157.9c11.2-9 25.2-13.8 39.6-13.6l2.3 0c32.6 .5 58.8 27 58.8 59.6c0 15.8-6.3 31-17.5 42.2L178.3 370.3c-2.3 2.3-3 5.7-1.7 8.7s4.2 4.9 7.4 4.9H344c4.4 0 8-3.6 8-8s-3.6-8-8-8H203.3L313.9 257.5C328 243.3 336 224 336 204c0-41.3-33.2-75-74.5-75.6l-2.3 0c-18.1-.3-35.7 5.8-49.8 17.1L179 169.8c-3.5 2.8-4 7.8-1.2 11.2s7.8 4 11.2 1.2l30.4-24.3z'
      
    ]
  };

  

  
  

  var fa1 = {
    prefix: 'fat',
    iconName: '1',
    icon: [
      256,
      512,
      [],
      '31',
      
      'M136 40c0-2.8-1.5-5.4-3.9-6.9s-5.4-1.5-7.9-.2L20.2 89c-3.9 2.1-5.3 6.9-3.3 10.8s6.9 5.3 10.8 3.3L120 53.4V464H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H120 248c4.4 0 8-3.6 8-8s-3.6-8-8-8H136V40z'
      
    ]
  };

  

  
  

  var faFalafel = {
    prefix: 'fat',
    iconName: 'falafel',
    icon: [
      576,
      512,
      [129478],
      'e40a',
      
      'M178.3 176c-1-2.3-2.3-4.5-4-6.5c-8.3-10.1-8.3-24.9 0-34.9c5.5-6.7 7.6-15.7 5.4-24.2c-3.2-12.8 3-26.1 14.9-31.5c7.8-3.6 13.5-10.8 15.2-19.4c2.5-13 13.8-22.2 26.8-21.8c8.6 .2 16.8-3.8 21.9-10.8c7.8-10.6 21.9-13.8 33.4-7.8c7.6 4 16.7 4 24.4 0c11.5-6.1 25.6-2.8 33.4 7.8c5.2 7 13.4 11 21.9 10.8c12.9-.4 24.2 8.8 26.8 21.8c1.7 8.6 7.3 15.9 15.2 19.4c11.8 5.4 18.1 18.7 14.9 31.5c-2.1 8.5-.1 17.5 5.4 24.2c8.3 10.1 8.3 24.9 0 34.9c-5.5 6.7-7.6 15.7-5.4 24.2c.1 .3 .2 .6 .2 .9c1.2 .3 2.3 .7 3.5 1.1c4.1-1.4 8.3-2.4 12.5-3c-.2-1-.4-2-.6-3c-.9-3.6 0-7.4 2.2-10.1c13.2-16 13.2-39.3 0-55.3c-2.3-2.7-3.1-6.5-2.2-10.1c5.1-20.1-4.7-41.3-23.7-50c-3.1-1.4-5.4-4.3-6.1-7.9C410 35.9 392 21 371 21.6c-3.3 .1-6.5-1.4-8.6-4.3C350 .5 327.3-4.9 308.7 4.9c-3 1.6-6.5 1.6-9.4 0C280.7-4.9 258 .5 245.6 17.3c-2.1 2.9-5.3 4.4-8.6 4.3C216 21 198 35.9 194 56.3c-.7 3.6-3.1 6.5-6.1 7.9c-19 8.7-28.8 29.9-23.7 50c.9 3.6 0 7.4-2.2 10.1c-12.7 15.4-13.2 37.5-1.5 53.4c5.9-1.3 11.9-1.9 17.9-1.7zM240 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM368 384a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm41-207.9c-7.1-.4-14.3 1.1-21 4.6c-2.5 1.3-5.5 1.3-8 0c-17.9-9.4-39.8-4.2-51.8 12c-1.8 2.4-4.6 3.7-7.3 3.7c-20.2-.6-37.5 13.8-41.4 33.4c-.6 3.1-2.6 5.6-5.2 6.8c-18.3 8.4-27.7 28.8-22.8 48.1c.8 3.1 0 6.3-1.9 8.7c-12.8 15.4-12.8 37.9 0 53.3c1.9 2.3 2.7 5.6 1.9 8.7c-4.9 19.4 4.5 39.7 22.8 48.1c2.6 1.2 4.6 3.7 5.2 6.8c3.8 19.6 21.1 34 41.4 33.4c2.8-.1 5.5 1.2 7.3 3.7c12 16.2 33.8 21.4 51.8 12c2.5-1.3 5.5-1.3 8 0c17.9 9.4 39.8 4.2 51.8-12c1.8-2.4 4.6-3.7 7.3-3.7c20.2 .6 37.5-13.8 41.4-33.4c.6-3.1 2.6-5.6 5.2-6.8c18.3-8.4 27.7-28.8 22.8-48.1c-.8-3.1 0-6.3 1.9-8.7c9.3-11.2 11.8-26.2 7.6-39.4c3.1-10.5 2.4-22.5-.9-34.4c-5.3-19.3-17.7-40.1-35.8-58.2s-38.9-30.5-58.2-35.8c-7.5-2-15-3.1-22.1-2.8zM558.4 376.9c-1 2.7-2.4 5.3-4.3 7.6c-5.2 6.3-7.1 14.8-5.1 22.8c3 12-2.9 24.6-14 29.6c-7.4 3.4-12.7 10.2-14.3 18.3c-2.4 12.2-13 20.9-25.2 20.5c-8.1-.2-15.8 3.6-20.7 10.2c-7.3 9.9-20.6 13-31.4 7.3c-7.2-3.8-15.7-3.8-22.9 0c-10.8 5.7-24.1 2.6-31.4-7.3c-4.9-6.6-12.6-10.4-20.7-10.2c-12.2 .3-22.8-8.3-25.2-20.5c-1.6-8.1-6.9-14.9-14.3-18.3c-11.1-5.1-17-17.6-14-29.6c2-8 .1-16.5-5.1-22.8c-7.9-9.5-7.9-23.4 0-32.9c5.2-6.3 7.1-14.8 5.1-22.8c-3-12 2.9-24.6 14-29.6c7.4-3.4 12.7-10.2 14.3-18.3c2.4-12.2 13-20.9 25.2-20.5c8.1 .2 15.8-3.6 20.7-10.2c7.3-9.9 20.6-13 31.4-7.3c.5 .2 .9 .5 1.4 .7c-7.2 12.2-7.3 28.1-3.1 43.6c5.3 19.3 17.7 40.1 35.8 58.2s38.9 30.5 58.2 35.8c16.4 4.5 33.1 4 45.6-4.3zM268.7 432.5c-.5 .2-.9 .5-1.4 .7c-8 3.6-13.8 10.8-15.5 19.4c-2.6 13-14.2 22.2-27.4 21.8c-8.8-.2-17.2 3.8-22.5 10.8c-8 10.6-22.4 13.8-34.2 7.8c-7.8-4-17.1-4-24.9 0c-11.8 6.1-26.2 2.8-34.2-7.8c-5.3-7-13.7-11-22.5-10.8c-13.2 .4-24.8-8.8-27.4-21.8c-1.7-8.6-7.5-15.8-15.5-19.4c-12.1-5.4-18.5-18.7-15.2-31.5c2.2-8.5 .1-17.5-5.5-24.2c-8.5-10.1-8.5-24.9 0-34.9c5.7-6.7 7.7-15.7 5.5-24.2c-3.3-12.8 3.1-26.1 15.2-31.5c8-3.6 13.8-10.8 15.5-19.4c2.6-13 14.2-22.2 27.4-21.8c8.8 .2 17.2-3.8 22.5-10.8c8-10.6 22.4-13.8 34.2-7.8c7.8 4 17.1 4 24.9 0c11.8-6.1 26.2-2.8 34.2 7.8c5.3 7 13.7 11 22.5 10.8c13.2-.4 24.8 8.8 27.4 21.8c1.7 8.6 7.5 15.9 15.5 19.4c2.3 1 4.3 2.3 6.1 3.8c2.3-4.8 5.1-9.4 8.4-13.7c-2.5-1.8-5.2-3.4-8.1-4.7c-3.3-1.5-5.7-4.4-6.4-8c-4.1-20.6-22.5-35.2-43.5-34.6c-3.6 .1-7.1-1.6-9.2-4.4c-12.7-16.8-35.6-22-54.3-12.4c-3.2 1.7-7.1 1.7-10.3 0c-18.7-9.6-41.6-4.4-54.3 12.4c-2.2 2.9-5.6 4.5-9.2 4.4c-21-.6-39.4 14-43.5 34.6c-.7 3.5-3.1 6.5-6.4 8c-19.2 8.6-29.4 29.7-24.2 50.1c.9 3.5 .1 7.1-2.3 9.9c-13.6 16.1-13.6 39.6 0 55.6c2.3 2.7 3.2 6.4 2.3 9.9c-5.3 20.4 5 41.5 24.2 50.1c3.3 1.5 5.7 4.4 6.4 8c4.1 20.6 22.5 35.2 43.5 34.6c3.6-.1 7.1 1.6 9.2 4.4c12.7 16.8 35.6 22 54.3 12.4c3.2-1.7 7.1-1.7 10.3 0c18.7 9.6 41.6 4.4 54.3-12.4c2.2-2.9 5.6-4.5 9.2-4.4c21 .6 39.4-14 43.5-34.6c.7-3.5 3.1-6.5 6.4-8l.7-.3c-2.5-4.8-4.4-9.8-5.8-15zM96 368a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM439.2 247.2c7-7 19.3-9.4 35.8-4.9c16.2 4.4 34.6 15.2 51.1 31.7s27.3 34.9 31.7 51.1c4.5 16.5 2.1 28.8-4.9 35.8s-19.3 9.4-35.8 4.9c-16.2-4.4-34.6-15.2-51.1-31.7s-27.3-34.9-31.7-51.1c-4.5-16.5-2.1-28.8 4.9-35.8z'
      
    ]
  };

  

  
  

  var faPenSwirl = {
    prefix: 'fat',
    iconName: 'pen-swirl',
    icon: [
      512,
      512,
      [],
      'e214',
      
      'M468.5 31.8l11.9 11.9c15.6 15.6 15.6 40.9 0 56.6L440 140.7 371.7 72.4l40-40.5c15.6-15.8 41-15.8 56.7-.2zm-264 209.8l156-157.8L428.7 152 271.9 308.9c-5.5 5.5-12.5 9.3-20.1 10.9l-73.5 15.4 15.5-73.7c1.6-7.5 5.3-14.4 10.7-19.9zM400.4 20.7L193.1 230.3c-7.6 7.7-12.8 17.3-15 27.9l-18 85.6c-.6 2.6 .3 5.4 2.2 7.3s4.7 2.7 7.3 2.2l85.5-17.9c10.6-2.2 20.4-7.5 28.1-15.2L491.7 111.6c21.9-21.9 21.9-57.3 0-79.2L479.8 20.5c-22-22-57.6-21.9-79.4 .2zM325.1 51.3l12.4-12.6C312.2 29.2 284.7 24 256 24C127.9 24 24 127.9 24 256s103.9 232 232 232c4.4 0 8-3.6 8-8s-3.6-8-8-8C136.7 472 40 375.3 40 256S136.7 40 256 40c24.2 0 47.4 4 69.1 11.3zM461 187.6c7.2 21.5 11 44.5 11 68.4c0 66.3-53.7 120-120 120c-15.9 0-31.1-3.1-45-8.7c-4.1-1.7-8.8 .3-10.4 4.4s.3 8.8 4.4 10.4c15.8 6.4 33 9.9 51 9.9c75.1 0 136-60.9 136-136c0-28.5-5.1-55.7-14.5-80.9L461 187.6z'
      
    ]
  };

  

  
  

  var faCommentExclamation = {
    prefix: 'fat',
    iconName: 'comment-exclamation',
    icon: [
      512,
      512,
      [],
      'f4af',
      
      'M157.3 415c-5-1.8-10.6-1-14.9 2.1c-11 8-29.4 19.3-51.2 28.8C68.3 456 41.6 464 16 464l.1-.1 0 0 0 0 .3-.3 .1-.1c.4-.4 .9-.9 1.5-1.6c1.3-1.4 3.2-3.6 5.4-6.3l-12.2-10 12.2 10C28 450 34 442 40 432c10.7-17.9 21.4-42.1 23.6-69.9c.3-4.3-1.1-8.6-3.9-11.8C31.9 318.8 16 280.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-35.2 0-68.6-6.1-98.7-17zM4.7 452.7l0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0zM256 112c-4.4 0-8 3.6-8 8V280c0 4.4 3.6 8 8 8s8-3.6 8-8V120c0-4.4-3.6-8-8-8zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faGripDots = {
    prefix: 'fat',
    iconName: 'grip-dots',
    icon: [
      448,
      512,
      [],
      'e410',
      
      'M384 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM224 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM32 176a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm80 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM384 368a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM192 336a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm80 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM64 368a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  

  
  

  var faSquareFull = {
    prefix: 'fat',
    iconName: 'square-full',
    icon: [
      512,
      512,
      [11035,11036,128997,128998,128999,129000,129001,129002,129003],
      'f45c',
      
      'M496 16V496H16V16H496zM16 0H0V16 496v16H16 496h16V496 16 0H496 16z'
      
    ]
  };

  

  
  

  var faStopwatch20 = {
    prefix: 'fat',
    iconName: 'stopwatch-20',
    icon: [
      448,
      512,
      [],
      'e06f',
      
      'M152 0c-4.4 0-8 3.6-8 8s3.6 8 8 8h64V96.2C104.8 100.4 16 191.8 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-50.5-18-96.8-47.9-132.8l37.6-37.6c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-36.9 36.9c-36.1-37.2-86-61-141.4-63.1V16h64c4.4 0 8-3.6 8-8s-3.6-8-8-8H152zM32 304a192 192 0 1 1 384 0A192 192 0 1 1 32 304zm208-64V368c0 26.5 21.5 48 48 48s48-21.5 48-48V240c0-26.5-21.5-48-48-48s-48 21.5-48 48zm48-32c17.7 0 32 14.3 32 32V368c0 17.7-14.3 32-32 32s-32-14.3-32-32V240c0-17.7 14.3-32 32-32zM128.1 232.6c3.6-14.4 16.6-24.6 31.5-24.6c17.9 0 32.4 14.5 32.4 32.4v13c0 10-3.7 19.5-10.4 26.9L139 327.2c-17.4 19.1-27 44.1-27 70V408c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H128v-2.9c0-21.9 8.2-43 22.9-59.2l42.6-46.8c9.4-10.3 14.6-23.7 14.6-37.7v-13c0-26.7-21.7-48.4-48.4-48.4c-22.2 0-41.6 15.1-47 36.7l-.3 1.4c-1.1 4.3 1.5 8.6 5.8 9.7s8.6-1.5 9.7-5.8l.3-1.4z'
      
    ]
  };

  

  
  

  var faShieldExclamation = {
    prefix: 'fat',
    iconName: 'shield-exclamation',
    icon: [
      512,
      512,
      [],
      'e247',
      
      'M237.3 22.6c12-5.1 25.5-5.1 37.5 0l176.7 75c16.6 7.1 28.6 23.2 28.5 42.4c-.5 96.6-40.3 270.2-204.5 348.8c-12.3 5.9-26.7 5.9-39 0C72.3 410.1 32.5 236.5 32 139.9c-.1-19.1 11.9-35.3 28.5-42.4l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM256 128c-4.4 0-8 3.6-8 8V296c0 4.4 3.6 8 8 8s8-3.6 8-8V136c0-4.4-3.6-8-8-8zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faCloudSun = {
    prefix: 'fat',
    iconName: 'cloud-sun',
    icon: [
      640,
      512,
      [9925],
      'f6c4',
      
      'M137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1 13.4 112.2c-5.4 .9-10 4.5-12.1 9.6s-1.5 10.9 1.6 15.4L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6l24.4-17c1.3-8.2 3.3-16.2 6.1-23.8l-25.1 17.6L128 400l-2.9-17.5-11.2-67.2c-1.1-6.7-6.4-12-13.2-13.2L33.5 290.9 16 288l10.2-14.5 39.4-56.3c3.9-5.5 3.9-12.8 0-18.4L26.2 142.5 16 128l17.5-2.9 67.2-11.2c6.7-1.1 12-6.4 13.2-13.2l11.2-67.2L128 16l14.5 10.2 56.3 39.4c5.5 3.9 12.8 3.9 18.4 0l56.3-39.4L288 16l2.9 17.5 11.2 67.2c1.1 6.7 6.4 12 13.2 13.2l67.2 11.2L400 128l-10.2 14.5-35.1 50.1c4.3-.4 8.8-.7 13.2-.7c2.2 0 4.5 .1 6.7 .2l38.5-55c3.1-4.5 3.8-10.3 1.6-15.4s-6.7-8.7-12.1-9.6L317.9 98.1 303.8 13.4c-.9-5.4-4.5-10-9.6-12.1s-10.9-1.5-15.4 1.6L208 52.5 137.2 2.9zM304 208c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c8.1 0 15.9-1 23.4-2.9c3.5-1.7 7.1-3.3 10.7-4.7c1.2-6.4 2.8-12.6 4.9-18.6C235.5 284.3 222.2 288 208 288c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80c0 4.4-.4 8.7-1 12.9c5.3-4.4 11-8.3 17-11.8l0-1.1zM288 320c0-44.2 35.8-80 80-80c32 0 59.6 18.8 72.4 46c1.1 2.3 3.2 3.9 5.7 4.4s5.1-.2 6.9-1.9c11.4-10.3 26.4-16.5 42.9-16.5c35.3 0 64 28.7 64 64c0 7.5-1.3 14.7-3.7 21.4c-.8 2.4-.5 5 .9 7.1s3.7 3.4 6.2 3.5c33.7 1.8 60.5 29.7 60.5 63.9c0 35.3-28.7 64-64 64c-.7 0-1.5 0-2.2 0l0 0h-.3H291v0l-.3 0c-.9 0-1.8 0-2.8 0c-44.2 0-80-35.8-80-80c0-41.8 32.1-76.2 73.1-79.7c2.1-.2 4.1-1.2 5.5-2.8s2-3.8 1.8-5.9c-.2-2.5-.4-5-.4-7.6zm80-96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.7c0 53 43 96 96 96c1.1 0 2.1 0 3.2-.1H557.3c.9 0 1.8 0 2.6 0c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C433.4 242.6 402.8 224 368 224z'
      
    ]
  };

  

  
  

  var faSyringe = {
    prefix: 'fat',
    iconName: 'syringe',
    icon: [
      512,
      512,
      [128137],
      'f48e',
      
      'M402.3 2.3c-3.1 3.1-3.1 8.2 0 11.3L444.7 56 384 116.7 301.7 34.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l88 88 88 88c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L395.3 128 456 67.3l42.3 42.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-48-48-48-48c-3.1-3.1-8.2-3.1-11.3 0zm-264 232L80.4 292.3C69.9 302.8 64 317 64 331.9V436.7L2.3 498.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L75.3 448H180.1c14.9 0 29.1-5.9 39.6-16.4L425.4 225.9l-11.3-11.3L208.4 420.3c-7.5 7.5-17.7 11.7-28.3 11.7H80V331.9c0-10.6 4.2-20.8 11.7-28.3L144 251.3l58.3 58.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L155.3 240 208 187.3l58.3 58.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L219.3 176l78.1-78.1L286.1 86.6l-83.7 83.7s0 0 0 0s0 0 0 0l-64 64s0 0 0 0s0 0 0 0z'
      
    ]
  };

  

  
  

  var faBoombox = {
    prefix: 'fat',
    iconName: 'boombox',
    icon: [
      640,
      512,
      [128254],
      'f8a5',
      
      'M80 72v88H192c0-17.7 14.3-32 32-32s32 14.3 32 32h32c0-17.7 14.3-32 32-32s32 14.3 32 32h32c0-17.7 14.3-32 32-32s32 14.3 32 32H560V72c0-30.9-25.1-56-56-56H136c-30.9 0-56 25.1-56 56zM64 160V72C64 32.2 96.2 0 136 0H504c39.8 0 72 32.2 72 72v88c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64zm328 16H344 296 248 200 72 64c-26.5 0-48 21.5-48 48V448c0 26.5 21.5 48 48 48H576c26.5 0 48-21.5 48-48V224c0-26.5-21.5-48-48-48h-8H440 392zM224 144c-8.8 0-16 7.2-16 16h32c0-8.8-7.2-16-16-16zm192 0c-8.8 0-16 7.2-16 16h32c0-8.8-7.2-16-16-16zM304 160h32c0-8.8-7.2-16-16-16s-16 7.2-16 16zM176 432a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0-208a112 112 0 1 1 0 224 112 112 0 1 1 0-224zM560 336a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm-208 0a112 112 0 1 1 224 0 112 112 0 1 1 -224 0z'
      
    ]
  };

  

  
  

  var faUserNurse = {
    prefix: 'fat',
    iconName: 'user-nurse',
    icon: [
      448,
      512,
      [],
      'f82f',
      
      'M112 76.9V144H336V76.9c0-6.4-3.8-12.1-9.6-14.7l-96-42c-4.1-1.8-8.7-1.8-12.8 0l-96 42c-5.8 2.5-9.6 8.3-9.6 14.7zM96 144V76.9c0-12.7 7.5-24.2 19.2-29.3l96-42c8.2-3.6 17.5-3.6 25.7 0l96 42C344.5 52.7 352 64.2 352 76.9V144v16 0 16c0 70.7-57.3 128-128 128s-128-57.3-128-128V160v0V144zm240 16H112v0 16c0 61.9 50.1 112 112 112s112-50.1 112-112V160v0zM131.5 344.1c-4-4-8.9-5-12.5-3.9C59.4 358.2 16 413.7 16 479.2c0 8.1 6.6 14.7 14.7 14.7H417.3c8.1 0 14.7-6.6 14.7-14.7c0-65.5-43.4-121-103.1-139.1c-3.6-1.1-8.5-.1-12.5 3.9l-69.8 69.8c-12.5 12.5-32.8 12.5-45.3 0l-69.8-69.8zm-17.1-19.2c10.1-3.1 20.9 .4 28.4 7.9l69.8 69.8c6.2 6.2 16.4 6.2 22.6 0l69.8-69.8c7.5-7.5 18.3-11 28.4-7.9C399.8 344.9 448 406.4 448 479.2c0 17-13.8 30.7-30.7 30.7H30.7c-17 0-30.7-13.8-30.7-30.7c0-72.8 48.2-134.3 114.4-154.4zM224 40c4.4 0 8 3.6 8 8V72h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H232v24c0 4.4-3.6 8-8 8s-8-3.6-8-8V88H192c-4.4 0-8-3.6-8-8s3.6-8 8-8h24V48c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faTrashCheck = {
    prefix: 'fat',
    iconName: 'trash-check',
    icon: [
      448,
      512,
      [],
      'e2af',
      
      'M157.4 27.3L134.4 64H313.6l-23-36.7c-4.4-7-12.1-11.3-20.4-11.3H177.7c-8.3 0-16 4.3-20.4 11.3zM115.6 64l28.2-45.2C151.1 7.1 163.9 0 177.7 0h92.5c13.8 0 26.6 7.1 33.9 18.8L332.4 64H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H115.6zM39.3 112c4.4-.4 8.3 2.9 8.6 7.3l28.3 340C78 480.1 95.4 496 116.2 496H331.8c20.8 0 38.1-15.9 39.9-36.7l28.3-340c.4-4.4 4.2-7.7 8.6-7.3s7.7 4.2 7.3 8.6l-28.3 340c-2.4 29-26.7 51.4-55.8 51.4H116.2c-29.1 0-53.4-22.3-55.8-51.4L32 120.7c-.4-4.4 2.9-8.3 7.3-8.6zM325.7 229.7l-128 128c-3.1 3.1-8.2 3.1-11.3 0l-64-64c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L192 340.7 314.3 218.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3z'
      
    ]
  };

  

  
  

  var faBridgeSuspension = {
    prefix: 'fat',
    iconName: 'bridge-suspension',
    icon: [
      640,
      512,
      [],
      'e4cd',
      
      'M128 0c3.2 0 6 1.9 7.2 4.6l6.7 13.4C175.6 85.4 244.6 128 320 128s144.4-42.6 178.1-110.1l6.7-13.4c1.3-2.7 4-4.6 7.2-4.6c3.6 0 6.6 2.4 7.6 5.6c7.6 22.7 22.9 47.7 42.3 69.4c19.5 21.8 42.5 39.6 65 48.6c4.1 1.6 6.1 6.3 4.5 10.4s-6.3 6.1-10.4 4.5c-25.5-10.1-50.5-29.8-71-52.8c-11.5-12.8-21.7-26.9-30-41.2V256H632c4.4 0 8 3.6 8 8s-3.6 8-8 8H512 128 8c-4.4 0-8-3.6-8-8s3.6-8 8-8H120V44.5c-8.3 14.3-18.6 28.4-30 41.2c-20.5 23-45.5 42.7-71 52.8c-4.1 1.6-8.8-.4-10.4-4.5s.4-8.8 4.5-10.4c22.5-8.9 45.5-26.8 65-48.6c19.4-21.7 34.7-46.7 42.3-69.4c1-3.3 4-5.6 7.6-5.6zm8 256h80V120c0-.9 .1-1.8 .4-2.6c-32.7-18-60.6-44.3-80.4-77.1V256zm96 0h80V144l0-.1c-28.1-1-55.2-7.5-80-18.7V256zm96 0h80V125.2c-24.8 11.1-51.9 17.6-80 18.7l0 .1V256zm96 0h80V40.3c-19.8 32.8-47.7 59.1-80.4 77.1c.3 .8 .4 1.7 .4 2.6V256zM8 336H32c48.6 0 88 39.4 88 88v48c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V456c0-66.3 53.7-120 120-120s120 53.7 120 120v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V424c0-48.6 39.4-88 88-88h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H608c-39.8 0-72 32.2-72 72v48c0 22.1-17.9 40-40 40H464c-22.1 0-40-17.9-40-40V456c0-57.4-46.6-104-104-104s-104 46.6-104 104v16c0 22.1-17.9 40-40 40H144c-22.1 0-40-17.9-40-40V424c0-39.8-32.2-72-72-72H8c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faTrainTram = {
    prefix: 'fat',
    iconName: 'train-tram',
    icon: [
      448,
      512,
      [128650],
      'e5b4',
      
      'M78.8 16c-17 0-33.1 7.7-43.7 21L22.2 53c-2.8 3.5-7.8 4-11.2 1.2S7 46.5 9.8 43L22.5 27C36.2 9.9 56.9 0 78.8 0H369.2c21.9 0 42.6 9.9 56.2 27l12.8 16c2.8 3.4 2.2 8.5-1.2 11.2s-8.5 2.2-11.2-1.2L413 37c-10.6-13.3-26.7-21-43.7-21H232V96h56c53 0 96 43 96 96V352c0 31.8-15.4 60-39.2 77.4l68.9 68.9c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L330.7 438c-12.9 6.4-27.4 10-42.7 10H160c-15.3 0-29.8-3.6-42.7-10L45.7 509.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l68.9-68.9C79.4 412 64 383.8 64 352V192c0-53 43-96 96-96h56V16H78.8zM216 112H160c-44.2 0-80 35.8-80 80V352c0 44.2 35.8 80 80 80H288c44.2 0 80-35.8 80-80V192c0-44.2-35.8-80-80-80H232 216zM176 352a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 176c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16H160zm-32 16c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V192z'
      
    ]
  };

  

  
  

  var faStarshipFreighter = {
    prefix: 'fat',
    iconName: 'starship-freighter',
    icon: [
      576,
      512,
      [],
      'e03a',
      
      'M381.4 391.9l-69.3-97.8c5.1-11.7 7.9-24.6 7.9-38.1c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c3.7 0 7.4-.2 11.1-.6l68.6 96.8C279.1 458.4 252.2 464 224 464C109.1 464 16 370.9 16 256S109.1 48 224 48c112.6 0 204.4 89.5 207.9 201.3c.1 2.2 .1 4.5 .1 6.7c0 2.6 0 5.3-.1 7.9c-1.8 48.9-20.5 93.4-50.4 128zm47 16.3c-1.5-.1-3-.2-4.5-.2H392.8l-1.9-2.6c28.8-32.1 48.4-72.6 54.8-117.4h1.7H544c8.8 0 16 7.2 16 16v42.1c0 6.6-4.1 12.5-10.2 14.9L428.5 408.2zm22.8 8.3l104.3-40.6c12.3-4.8 20.4-16.6 20.4-29.8V304c0-17.7-14.3-32-32-32H463.5h-16c.4-5.3 .6-10.6 .6-16c0-5.3-.2-10.6-.6-15.8l0-.2h16H544c17.7 0 32-14.3 32-32V165.9c0-13.2-8.1-25-20.4-29.8L347.6 55.2C308.2 39.9 266.3 32 224 32C100.3 32 0 132.3 0 256S100.3 480 224 480c31.5 0 62.8-4.4 93-12.9l11.8 16.7c9 12.7 23.6 20.3 39.2 20.3h56c26.5 0 48-21.5 48-48c0-16.4-8.2-30.8-20.7-39.5zM447.4 224h-1.7c-8.6-60.3-41.3-112.9-88-147.7L549.8 151c6.2 2.4 10.2 8.3 10.2 14.9V208c0 8.8-7.2 16-16 16H447.4zM80 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM112 368a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm32-112a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM341.9 474.5L252.4 347.7c21.2-6.6 39.2-20.2 51.3-38.3L384.6 424H424c17.7 0 32 14.3 32 32s-14.3 32-32 32H368c-10.4 0-20.1-5.1-26.1-13.5z'
      
    ]
  };

  

  
  

  var faUserLarge = {
    prefix: 'fat',
    iconName: 'user-large',
    icon: [
      512,
      512,
      ["user-alt"],
      'f406',
      
      'M376 136a120 120 0 1 0 -240 0 120 120 0 1 0 240 0zm-256 0a136 136 0 1 1 272 0 136 136 0 1 1 -272 0zM16 481.3c0 8.1 6.6 14.7 14.7 14.7H481.3c8.1 0 14.7-6.6 14.7-14.7C496 401 431 336 350.7 336H161.3C81 336 16 401 16 481.3zm-16 0C0 392.2 72.2 320 161.3 320H350.7C439.8 320 512 392.2 512 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3z'
      
    ]
  };

  
    var faUserAlt = faUserLarge;
  

  
  

  var faCirclesOverlap = {
    prefix: 'fat',
    iconName: 'circles-overlap',
    icon: [
      640,
      512,
      [],
      'e600',
      
      'M243.6 431.1C211.4 392.3 192 342.4 192 288c0-105.8 73.3-194.4 171.9-217.9C327 36.5 277.9 16 224 16C109.1 16 16 109.1 16 224s93.1 208 208 208c6.6 0 13.2-.3 19.6-.9zm18.9-2.7C359 410.4 432 325.7 432 224c0-54.1-20.7-103.4-54.6-140.4C281 101.6 208 186.3 208 288c0 54.1 20.7 103.4 54.6 140.4zm-5.7 17.2c-10.7 1.6-21.7 2.4-32.8 2.4C100.3 448 0 347.7 0 224S100.3 0 224 0c62.3 0 118.6 25.4 159.2 66.4C393.9 64.8 404.8 64 416 64c123.7 0 224 100.3 224 224s-100.3 224-224 224c-62.3 0-118.6-25.4-159.2-66.4zM396.4 80.9C428.6 119.7 448 169.6 448 224c0 105.8-73.3 194.4-171.9 217.9C313 475.5 362.1 496 416 496c114.9 0 208-93.1 208-208s-93.1-208-208-208c-6.6 0-13.2 .3-19.6 .9z'
      
    ]
  };

  

  
  

  var faRulerVertical = {
    prefix: 'fat',
    iconName: 'ruler-vertical',
    icon: [
      256,
      512,
      [],
      'f548',
      
      'M192 16c26.5 0 48 21.5 48 48v40H160c-4.4 0-8 3.6-8 8s3.6 8 8 8h80v80H160c-4.4 0-8 3.6-8 8s3.6 8 8 8h80v80H160c-4.4 0-8 3.6-8 8s3.6 8 8 8h80v80H160c-4.4 0-8 3.6-8 8s3.6 8 8 8h80v40c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H192zm64 384V304 208 112 64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H192c35.3 0 64-28.7 64-64V400z'
      
    ]
  };

  

  
  

  var faRightLeftLarge = {
    prefix: 'fat',
    iconName: 'right-left-large',
    icon: [
      640,
      512,
      [],
      'e5e1',
      
      'M202.7 488c-8.8 0-17.3-3.1-24-8.8L47.1 368.4C37.5 360.4 32 348.5 32 336s5.5-24.4 15.1-32.4L178.7 192.8c6.7-5.7 15.2-8.8 24-8.8c20.6 0 37.3 16.7 37.3 37.3V248H408c4.4 0 8 3.6 8 8v34.7c0 11.8 9.5 21.3 21.3 21.3c5 0 9.9-1.8 13.7-5L582.6 196.2c6-5 9.4-12.4 9.4-20.2s-3.4-15.2-9.4-20.2L451 45c-3.8-3.2-8.7-5-13.7-5C425.5 40 416 49.5 416 61.3V96c0 4.4-3.6 8-8 8H264c-4.4 0-8-3.6-8-8s3.6-8 8-8H400V61.3C400 40.7 416.7 24 437.3 24c8.8 0 17.3 3.1 24 8.8L592.9 143.6c9.6 8.1 15.1 19.9 15.1 32.4s-5.5 24.4-15.1 32.4L461.3 319.2c-6.7 5.7-15.2 8.8-24 8.8c-20.6 0-37.3-16.7-37.3-37.3V264H232c-4.4 0-8-3.6-8-8V221.3c0-11.8-9.5-21.3-21.3-21.3c-5 0-9.9 1.8-13.7 5L57.4 315.8c-6 5-9.4 12.4-9.4 20.2s3.4 15.2 9.4 20.2L189 467c3.8 3.2 8.7 5 13.7 5c11.8 0 21.3-9.5 21.3-21.3V416c0-4.4 3.6-8 8-8H376c4.4 0 8 3.6 8 8s-3.6 8-8 8H240v26.7c0 20.6-16.7 37.3-37.3 37.3z'
      
    ]
  };

  

  
  

  var faArrowDownFromArc = {
    prefix: 'fat',
    iconName: 'arrow-down-from-arc',
    icon: [
      512,
      512,
      [],
      'e614',
      
      'M256 16C123.5 16 16 123.5 16 256c0 4.4-3.6 8-8 8s-8-3.6-8-8C0 114.6 114.6 0 256 0S512 114.6 512 256c0 4.4-3.6 8-8 8s-8-3.6-8-8C496 123.5 388.5 16 256 16zM121.9 357.2c-2.8-3.4-2.4-8.4 1-11.3s8.4-2.4 11.3 1L248 482.1 248 168c0-4.4 3.6-8 8-8s8 3.6 8 8l0 314.1L377.9 346.8c2.8-3.4 7.9-3.8 11.3-1s3.8 7.9 1 11.3l-128 152c-1.5 1.8-3.8 2.8-6.1 2.8s-4.6-1-6.1-2.8l-128-152z'
      
    ]
  };

  

  
  

  var faFlower = {
    prefix: 'fat',
    iconName: 'flower',
    icon: [
      448,
      512,
      [10047,127804],
      'f7ff',
      
      'M448 168c0 33.6-12.2 64.3-32.3 88c20.1 23.7 32.3 54.4 32.3 88c0 75.1-60.9 136-136 136c-33.6 0-64.3-12.2-88-32.3c-23.7 20.1-54.4 32.3-88 32.3C60.9 480 0 419.1 0 344c0-33.6 12.2-64.3 32.3-88C12.2 232.3 0 201.6 0 168C0 92.9 60.9 32 136 32c33.6 0 64.3 12.2 88 32.3C247.7 44.2 278.4 32 312 32c75.1 0 136 60.9 136 136zM213.6 76.5C192.7 58.7 165.6 48 136 48C69.7 48 16 101.7 16 168c0 29.6 10.7 56.7 28.5 77.6c5.1 6 5.1 14.7 0 20.7C26.7 287.3 16 314.4 16 344c0 66.3 53.7 120 120 120c29.6 0 56.7-10.7 77.6-28.5c6-5.1 14.7-5.1 20.7 0c20.9 17.8 48 28.5 77.6 28.5c66.3 0 120-53.7 120-120c0-29.6-10.7-56.7-28.5-77.6c-5.1-6-5.1-14.7 0-20.7c17.8-20.9 28.5-48 28.5-77.6c0-66.3-53.7-120-120-120c-29.6 0-56.7 10.7-77.6 28.5c-6 5.1-14.7 5.1-20.7 0zM288 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-144 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassMinus = {
    prefix: 'fat',
    iconName: 'magnifying-glass-minus',
    icon: [
      512,
      512,
      ["search-minus"],
      'f010',
      
      'M208 16a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 400c54.6 0 104.2-21 141.3-55.4l149 149c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-149-149C395 312.2 416 262.6 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM112 200c-4.4 0-8 3.6-8 8s3.6 8 8 8H304c4.4 0 8-3.6 8-8s-3.6-8-8-8H112z'
      
    ]
  };

  
    var faSearchMinus = faMagnifyingGlassMinus;
  

  
  

  var faCalendarHeart = {
    prefix: 'fat',
    iconName: 'calendar-heart',
    icon: [
      448,
      512,
      [],
      'e0d3',
      
      'M128 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H64C28.7 64 0 92.7 0 128v48 16V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 176 128c0-35.3-28.7-64-64-64H336V8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H128V8zM16 192H432V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V192zM112 80v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80H320v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80h48c26.5 0 48 21.5 48 48v48H16V128c0-26.5 21.5-48 48-48h48zm16 225.9c0-23.2 18.8-41.9 41.9-41.9c11.1 0 21.8 4.4 29.7 12.3L218.3 295c1.5 1.5 3.5 2.3 5.7 2.3s4.2-.8 5.7-2.3l18.7-18.7c7.9-7.9 18.5-12.3 29.7-12.3c23.2 0 41.9 18.8 41.9 41.9v.6c0 10.6-4 20.9-11.2 28.8l-78.9 86.1c-1.5 1.7-3.7 2.6-5.9 2.6s-4.4-.9-5.9-2.6l-78.9-86.1c-7.2-7.8-11.2-18.1-11.2-28.8v-.6zM169.9 248c-32 0-57.9 25.9-57.9 57.9v.6c0 14.7 5.5 28.8 15.4 39.6l78.9 86.1c4.5 5 11 7.8 17.7 7.8s13.1-2.8 17.7-7.8l78.9-86.1c9.9-10.8 15.4-24.9 15.4-39.6v-.6c0-32-25.9-57.9-57.9-57.9c-15.4 0-30.1 6.1-41 17L224 278.1 210.9 265c-10.9-10.9-25.6-17-41-17z'
      
    ]
  };

  

  
  

  var faMask = {
    prefix: 'fat',
    iconName: 'mask',
    icon: [
      576,
      512,
      [],
      'f6fa',
      
      'M70.5 138.1C31 172.2 16 219.1 16 272c0 52 18.4 91.6 46.9 118.3C91.6 417.2 131.5 432 176 432h8.4c18.2 0 34.8-10.3 42.9-26.5l23.2-46.3C257.6 345 272.1 336 288 336s30.4 9 37.5 23.2l23.2 46.3c8.1 16.3 24.8 26.5 42.9 26.5H400c44.5 0 84.4-14.8 113.1-41.7C541.6 363.6 560 324 560 272c0-52.9-15-99.8-54.5-133.9C465.6 103.6 398.1 80 288 80s-177.6 23.6-217.5 58.1zM0 272C0 160 64 64 288 64s288 96 288 208s-80 176-176 176h-8.4c-24.2 0-46.4-13.7-57.2-35.4l-23.2-46.3c-4.4-8.8-13.3-14.3-23.2-14.3s-18.8 5.5-23.2 14.3l-23.2 46.3c-10.8 21.7-33 35.4-57.2 35.4H176C80 448 0 384 0 272zm160 32a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-112a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm304 64a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-112 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  

  
  

  var faTreeDecorated = {
    prefix: 'fat',
    iconName: 'tree-decorated',
    icon: [
      448,
      512,
      [],
      'f7dc',
      
      'M229.8 2.5C228.3 .9 226.2 0 224 0s-4.3 .9-5.8 2.5L72.5 155.9C67 161.6 64 169.2 64 177.1c0 17 13.8 30.9 30.9 30.9h30.8L40.3 299.9C35 305.7 32 313.2 32 321c0 17.1 13.9 31 31 31H95.2L7.1 460.4C2.5 466.1 0 473.1 0 480.4C0 497.8 14.2 512 31.6 512H160 288 416.4c17.5 0 31.6-14.2 31.6-31.6c0-7.3-2.5-14.3-7.1-19.9L352.8 352H385c17.1 0 31-13.9 31-31c0-7.8-3-15.3-8.3-21.1L322.3 208h30.8c17 0 30.9-13.8 30.9-30.9c0-7.9-3-15.5-8.5-21.3L229.8 2.5zM416.4 496H288 160 31.6C23 496 16 489 16 480.4c0-3.6 1.2-7.1 3.5-9.8L118.2 349c1.9-2.4 2.3-5.7 1-8.5s-4.1-4.6-7.2-4.6H63c-8.3 0-15-6.7-15-15c0-3.8 1.4-7.4 4-10.2l97.9-105.4c2.2-2.3 2.7-5.7 1.5-8.6s-4.2-4.8-7.3-4.8H94.9c-8.2 0-14.9-6.7-14.9-14.9c0-3.8 1.5-7.5 4.1-10.2L224 19.6 363.9 166.9c2.6 2.8 4.1 6.4 4.1 10.2c0 8.2-6.7 14.9-14.9 14.9H304c-3.2 0-6.1 1.9-7.3 4.8s-.7 6.3 1.5 8.6L396 310.8c2.6 2.8 4 6.4 4 10.2c0 8.3-6.7 15-15 15H336c-3.1 0-5.9 1.8-7.2 4.6s-.9 6.1 1 8.5l98.7 121.5c2.3 2.8 3.5 6.3 3.5 9.8c0 8.6-7 15.6-15.6 15.6zM176 288a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm16 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faBrush = {
    prefix: 'fat',
    iconName: 'brush',
    icon: [
      384,
      512,
      [],
      'f55d',
      
      'M256 352c-8.8 0-16 7.2-16 16v80c0 26.5-21.5 48-48 48s-48-21.5-48-48V368c0-8.8-7.2-16-16-16H80c-35.3 0-64-28.7-64-64V272H368v16c0 35.3-28.7 64-64 64H256zm112-96H16V64c0-26.5 21.5-48 48-48H80V120c0 4.4 3.6 8 8 8s8-3.6 8-8V16h80V88c0 4.4 3.6 8 8 8s8-3.6 8-8V16h64v88c0 4.4 3.6 8 8 8s8-3.6 8-8V16h48c26.5 0 48 21.5 48 48V256zM80 368h32 16v16 64c0 35.3 28.7 64 64 64s64-28.7 64-64V384 368h16 32c44.2 0 80-35.8 80-80V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V288c0 44.2 35.8 80 80 80zm128 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faMugSaucer = {
    prefix: 'fat',
    iconName: 'mug-saucer',
    icon: [
      640,
      512,
      ["coffee"],
      'f0f4',
      
      'M440 48h24V288c0 44.2-35.8 80-80 80H192c-44.2 0-80-35.8-80-80V64c0-8.8 7.2-16 16-16H440zm40 176V48h24c48.6 0 88 39.4 88 88s-39.4 88-88 88H480zm0 64V240h24c57.4 0 104-46.6 104-104s-46.6-104-104-104H480 464 440 128c-17.7 0-32 14.3-32 32V288c0 53 43 96 96 96H384c53 0 96-43 96-96zM8 464c-4.4 0-8 3.6-8 8s3.6 8 8 8H568c4.4 0 8-3.6 8-8s-3.6-8-8-8H8z'
      
    ]
  };

  
    var faCoffee = faMugSaucer;
  

  
  

  var faGarlic = {
    prefix: 'fat',
    iconName: 'garlic',
    icon: [
      512,
      512,
      [129476],
      'e40e',
      
      'M176 48c0-17.7 14.3-32 32-32h48V70.2c0 49.5 17.7 97.4 49.9 135L323 225.1c18.7 21.8 29 49.6 29 78.4C352 370.1 298.1 424 231.5 424H221.3C152.1 424 96 367.9 96 298.7c0-26.1 8.2-51.6 23.3-72.8l15.2-21.2c24-33.7 38.2-73.3 41-114.4c.3-3 .5-6 .5-9V75.2 56 48zm-16 0v8V75.2c0 4.6-.2 9.1-.5 13.6c-2 16.6-10.4 31.8-23.6 42.4L52.7 197.8C19.4 224.5 0 264.8 0 307.5C0 385.1 62.9 448 140.5 448H152v56c0 4.4 3.6 8 8 8s8-3.6 8-8V448h48v56c0 4.4 3.6 8 8 8s8-3.6 8-8V448h48v56c0 4.4 3.6 8 8 8s8-3.6 8-8V448h48v56c0 4.4 3.6 8 8 8s8-3.6 8-8V448h11.5C449.1 448 512 385.1 512 307.5c0-42.7-19.4-83-52.7-109.7L376 131.2c-15.2-12.1-24-30.5-24-50V48c0-26.5-21.5-48-48-48H208c-26.5 0-48 21.5-48 48zm-14 95.7c1.1-.9 2.2-1.8 3.3-2.8c-6.5 19.3-15.8 37.7-27.8 54.4l-15.2 21.2C89.2 240.6 80 269.3 80 298.7c0 61.6 39.4 113.9 94.3 133.3H140.5C71.7 432 16 376.3 16 307.5c0-37.8 17.2-73.6 46.7-97.2L146 143.7zM371.5 432H277.7c52.7-18.9 90.3-69.3 90.3-128.5c0-32.6-11.7-64.1-32.9-88.8l-17.1-19.9C288.3 160.1 272 115.9 272 70.2V16h32c17.7 0 32 14.3 32 32V81.2c0 24.3 11 47.3 30 62.5l83.3 66.6c29.5 23.6 46.7 59.4 46.7 97.2C496 376.3 440.3 432 371.5 432z'
      
    ]
  };

  

  
  

  var faCommentArrowUp = {
    prefix: 'fat',
    iconName: 'comment-arrow-up',
    icon: [
      512,
      512,
      [],
      'e144',
      
      'M157.3 415c-5-1.8-10.6-1-14.9 2.1c-11 8-29.4 19.3-51.2 28.8C68.3 456 41.6 464 16 464l.1-.1 0 0 0 0 .3-.3 .1-.1c.4-.4 .9-.9 1.5-1.6c1.3-1.4 3.2-3.6 5.4-6.3l-12.2-10 12.2 10C28 450 34 442 40 432c10.7-17.9 21.4-42.1 23.6-69.9c.3-4.3-1.1-8.6-3.9-11.8C31.9 318.8 16 280.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-35.2 0-68.6-6.1-98.7-17zM4.7 452.7l0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0zM264 155.3l74.3 74.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-88-88c-3.1-3.1-8.2-3.1-11.3 0l-88 88c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L248 155.3V328c0 4.4 3.6 8 8 8s8-3.6 8-8V155.3z'
      
    ]
  };

  

  
  

  var faRectangleWide = {
    prefix: 'fat',
    iconName: 'rectangle-wide',
    icon: [
      640,
      512,
      [],
      'f2fc',
      
      'M576 80c26.5 0 48 21.5 48 48V384c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V128c0-26.5 21.5-48 48-48H576zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64z'
      
    ]
  };

  

  
  

  var faWindowMinimize = {
    prefix: 'fat',
    iconName: 'window-minimize',
    icon: [
      512,
      512,
      [128469],
      'f2d1',
      
      'M8 464c-4.4 0-8 3.6-8 8s3.6 8 8 8H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H8z'
      
    ]
  };

  

  
  

  var faFileInvoice = {
    prefix: 'fat',
    iconName: 'file-invoice',
    icon: [
      384,
      512,
      [],
      'f570',
      
      'M64 496c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm0 72c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H72c-4.4 0-8 3.6-8 8zm0 64c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H72c-4.4 0-8 3.6-8 8zM224 440c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H232c-4.4 0-8 3.6-8 8zm64-200c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V256c0-8.8 7.2-16 16-16H288zM96 224c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H96z'
      
    ]
  };

  

  
  

  var faHandDots = {
    prefix: 'fat',
    iconName: 'hand-dots',
    icon: [
      512,
      512,
      ["allergies"],
      'f461',
      
      'M264 16c17.7 0 32 14.3 32 32l0 24v8V248c0 4.4 3.6 8 8 8s8-3.6 8-8V80c0-17.7 14.3-32 32-32s32 14.3 32 32v56 8 56 48c0 4.4 3.6 8 8 8s8-3.6 8-8V200 144c0-17.7 14.3-32 32-32s32 14.3 32 32V344c0 83.9-68.1 152-152 152h-8.5c-59.4 0-116.4-23.6-158.4-65.6L25.4 318.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l67.7 67.7c2.3 2.3 5.7 3 8.7 1.7s4.9-4.2 4.9-7.4V80c0-17.7 14.3-32 32-32s32 14.3 32 32l0 0V248c0 4.4 3.6 8 8 8s8-3.6 8-8V72l0 0V48c0-17.7 14.3-32 32-32zm47.9 28.3C310 19.5 289.3 0 264 0s-46 19.5-47.9 44.3C207.6 36.7 196.4 32 184 32c-26.5 0-48 21.5-48 48V316.1L81.9 262.1c-18.7-18.7-49.1-18.7-67.9 0s-18.7 49.1 0 67.9L125.8 441.7c45 45 106.1 70.3 169.7 70.3H304c92.8 0 168-75.2 168-168V144c0-26.5-21.5-48-48-48c-12.3 0-23.5 4.6-32 12.2V80c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3zM208 348a12 12 0 1 0 0-24 12 12 0 1 0 0 24zm64 32a12 12 0 1 0 0-24 12 12 0 1 0 0 24zm140-12a12 12 0 1 0 -24 0 12 12 0 1 0 24 0zm-44 76a12 12 0 1 0 0-24 12 12 0 1 0 0 24zm-84-12a12 12 0 1 0 -24 0 12 12 0 1 0 24 0zM176 412a12 12 0 1 0 0-24 12 12 0 1 0 0 24zm172-76a12 12 0 1 0 -24 0 12 12 0 1 0 24 0z'
      
    ]
  };

  
    var faAllergies = faHandDots;
  

  
  

  var faArrowDownToDottedLine = {
    prefix: 'fat',
    iconName: 'arrow-down-to-dotted-line',
    icon: [
      448,
      512,
      [],
      'e095',
      
      'M365.7 213.7l-136 136c-3.1 3.1-8.2 3.1-11.3 0l-136-136c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L216 324.7V200 40c0-4.4 3.6-8 8-8s8 3.6 8 8V200 324.7L354.3 202.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3zM16 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm112-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm96 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm96 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faClockTwelveThirty = {
    prefix: 'fat',
    iconName: 'clock-twelve-thirty',
    icon: [
      512,
      512,
      [],
      'e359',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM264 144V408c0 4.4-3.6 8-8 8s-8-3.6-8-8V144c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faOnion = {
    prefix: 'fat',
    iconName: 'onion',
    icon: [
      448,
      512,
      [129477],
      'e427',
      
      'M209.7 39.2L198.9 17.6c-4 31.2-18.3 55.1-36.6 75.2c-1.7 3.3-3.9 7.5-6.3 12.5c-6.7 13.5-15.6 32.5-24.5 54.5C113.5 204 96 259.3 96 306.2c0 43.3 15.3 77.1 30.7 100.2c7.7 11.5 15.4 20.4 21.1 26.3c2.1 2.2 4 4 5.5 5.4c2.5 .7 4.9 1.3 7.4 1.9c.8 .1 1.5 .2 2.3 .5c19.8 4.6 40.4 7.1 61 7.4l1.8 0c-3.8-6.8-8.5-16.3-13.2-28.1C202.3 394.4 192 358 192 314.6c0-63.9 6-132.8 12.1-185.7c3-26.5 6-49 8.3-64.9c1.1-7.9 2.1-14.2 2.7-18.6l0-.1c-2.3-1.5-4.1-3.6-5.4-6.1zM148.9 453.5C67.1 431.3 0 374.4 0 288c0-84.5 51.3-124.3 99.7-162C139.3 95.2 177 65.9 183.1 14.9c1-8.1 7.5-14.9 15.7-14.9c5.6 0 10.8 3.2 13.3 8.2l3 5.9L224 32l8.9-17.9 3-5.9c2.5-5 7.6-8.2 13.3-8.2c8.2 0 14.7 6.7 15.7 14.9c6.1 51 43.8 80.3 83.4 111.2c48.4 37.7 99.7 77.5 99.7 162c0 86.4-67.1 143.3-148.9 165.5l20.3 47.3c1.7 4.1-.1 8.8-4.2 10.5s-8.8-.1-10.5-4.2l-21.3-49.8c-16.8 3.6-34 5.7-51.3 6.4V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V463.8c-17.3-.7-34.5-2.9-51.3-6.4l-21.3 49.8c-1.7 4.1-6.4 5.9-10.5 4.2s-5.9-6.4-4.2-10.5l20.3-47.3zM287.3 440c6-1.4 11.9-3.1 17.8-4.9c.7-.7 1.4-1.6 2.2-2.4c5.3-6.1 12.5-15 19.7-26.3c14.3-22.7 28.4-54.5 28.4-91.8c0-48.6-18.3-106.1-37.1-151.9c-9.3-22.8-18.7-42.5-25.7-56.5c-2.6-5.3-4.9-9.7-6.8-13.2c-18.4-20.1-32.8-44-36.8-75.3L238.3 39.2c-1.6 3.2-4.1 5.7-7.2 7.2l-.2 1.5c-.7 4.3-1.6 10.5-2.7 18.4c-2.2 15.8-5.2 38.1-8.2 64.4c-6 52.7-11.9 121-11.9 183.9c0 40.9 9.7 75.3 19.4 99.4c4.9 12 9.7 21.5 13.3 27.9c1.1 2 2.2 3.8 3 5.2c14-1.2 27.8-3.3 41.3-6.5c.8-.3 1.5-.5 2.3-.5zm45.8-283.5c18.9 46.3 38.3 106.1 38.3 158c0 41.4-15.6 76.2-30.9 100.4c-2 3.1-4 6.1-5.9 8.8c12.1-5.6 23.5-12.1 33.9-19.4C407.1 377 432 337.9 432 288c0-69-37.1-104.8-80.4-139.1c-4.1-3.3-8.4-6.6-12.6-9.9l0 0 0 0 0 0 0 0c-6.8-5.3-13.8-10.7-20.6-16.2c4.7 10.1 9.7 21.5 14.7 33.8zM113.3 415.3C96.7 390.3 80 353.5 80 306.2c0-50.1 18.5-107.9 36.6-152.5c4.6-11.3 9.2-21.9 13.5-31.3c-7 5.7-14.1 11.2-21 16.6c-4.3 3.3-8.5 6.6-12.7 9.9C53.1 183.2 16 219 16 288c0 49.9 24.9 89 63.5 116.3c12.9 9.1 27.2 16.9 42.6 23.2c-2.9-3.7-5.8-7.8-8.8-12.2z'
      
    ]
  };

  

  
  

  var faUserClock = {
    prefix: 'fat',
    iconName: 'user-clock',
    icon: [
      640,
      512,
      [],
      'f4fd',
      
      'M112 128a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm240 0A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM16 482.3C16 392.7 88.7 320 178.3 320h91.4c19.1 0 37.5 3.3 54.5 9.4c1.2-5.3 2.6-10.4 4.2-15.5c-18.4-6.4-38.2-9.9-58.8-9.9H178.3C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H394.8c-6.9-4.9-13.4-10.2-19.6-16H29.7c-7.6 0-13.7-6.1-13.7-13.7zM496 240a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-224c-4.4 0-8 3.6-8 8v72c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8s-3.6-8-8-8H504V296c0-4.4-3.6-8-8-8z'
      
    ]
  };

  

  
  

  var faCloudShowers = {
    prefix: 'fat',
    iconName: 'cloud-showers',
    icon: [
      512,
      512,
      [],
      'f73f',
      
      'M398.7 124.8c.8-4.1 1.3-8.4 1.3-12.8c0-35.3-28.7-64-64-64c-19.5 0-36.9 8.7-48.6 22.4c-3.5 4-8.7 6.1-13.9 5.5s-9.9-3.8-12.4-8.5C245 36.8 212.9 16 176 16c-53 0-96 43-96 96c0 6.1 .6 12.1 1.7 17.9c1.5 7.9-3.1 15.6-10.7 18.1C39 158.5 16 188.6 16 224c0 44.2 35.8 80 80 80H416c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.4 0-.9 0-1.3 0c-4.8 .1-9.5-2-12.6-5.8s-4.3-8.7-3.4-13.4zM176 0c37.1 0 70 18.1 90.4 45.9c3.3 4.5 6.2 9.2 8.8 14.1c3.6-4.2 7.6-8 12-11.4C300.7 38.2 317.6 32 336 32c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c4.9 0 9.8 .4 14.5 1.1c46.2 7 81.5 46.8 81.5 94.9c0 53-43 96-96 96H96c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0zM48 376v96c0 4.4-3.6 8-8 8s-8-3.6-8-8V376c0-4.4 3.6-8 8-8s8 3.6 8 8zm192 0v96c0 4.4-3.6 8-8 8s-8-3.6-8-8V376c0-4.4 3.6-8 8-8s8 3.6 8 8zm192 0v96c0 4.4-3.6 8-8 8s-8-3.6-8-8V376c0-4.4 3.6-8 8-8s8 3.6 8 8zM144 408v96c0 4.4-3.6 8-8 8s-8-3.6-8-8V408c0-4.4 3.6-8 8-8s8 3.6 8 8zm192 0v96c0 4.4-3.6 8-8 8s-8-3.6-8-8V408c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faThumbsUp = {
    prefix: 'fat',
    iconName: 'thumbs-up',
    icon: [
      512,
      512,
      [61575,128077],
      'f164',
      
      'M281.1 71.6c4.6-17.1 22.2-27.1 39.3-22.5s27.1 22.2 22.5 39.3l-4.5 16.4c-5.7 20.8-22.3 56.7-33.7 75c-1.5 2.5-1.6 5.6-.2 8.1s4.1 4.1 7 4.1H448c22.1 0 40 17.9 40 40c0 14.2-7.3 26.6-18.5 33.7c-3.6 2.3-4.7 7-2.7 10.7c3.3 5.8 5.1 12.5 5.1 19.6c0 15.5-8.8 28.9-21.7 35.6c-2.1 1.1-3.6 3.1-4.1 5.4s0 4.7 1.5 6.6c5.2 6.8 8.3 15.2 8.3 24.4c0 17.8-11.6 32.8-27.6 38c-3.9 1.3-6.2 5.3-5.3 9.3c.6 2.8 .9 5.7 .9 8.6c0 22.1-17.9 40-40 40H286.5c-17.4 0-34.4-5.1-48.8-14.8l-38.5-25.7c-10-6.6-18.3-15.1-24.7-24.8c-2.4-3.7-7.4-4.7-11.1-2.3s-4.7 7.4-2.3 11.1c7.6 11.5 17.4 21.5 29.2 29.3l38.5 25.7C245.9 473.9 266 480 286.5 480H384c30.9 0 56-25.1 56-56c0-1.8-.1-3.5-.2-5.3c19-8.9 32.2-28.3 32.2-50.7c0-9.7-2.5-18.9-6.9-26.9C479 331 488 314.5 488 296c0-7.4-1.4-14.5-4.1-21c12.3-10.3 20.1-25.7 20.1-43c0-30.9-25.1-56-56-56H325.4c10.9-20.3 23.4-48.5 28.5-67l4.5-16.4c7-25.6-8.1-52-33.7-58.9s-52 8.1-58.9 33.7l-4.5 16.4c-4.7 17.2-14.5 37.4-27.2 55.8c-12.7 18.4-27.7 34.5-42.5 43.8l-3.1 2c-10.9 6.9-20 15.8-27.2 26.1c-2.5 3.6-1.6 8.6 2 11.1s8.6 1.6 11.1-2c6-8.5 13.6-16 22.7-21.7l3.1-2c17.2-10.9 33.7-28.8 47.1-48.3c13.4-19.5 24.1-41.3 29.4-60.6l4.5-16.4zM32 208H96c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H32c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16zM0 224V448c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassPlus = {
    prefix: 'fat',
    iconName: 'magnifying-glass-plus',
    icon: [
      512,
      512,
      ["search-plus"],
      'f00e',
      
      'M208 16a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 400c54.6 0 104.2-21 141.3-55.4l149 149c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-149-149C395 312.2 416 262.6 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm-8-112c0 4.4 3.6 8 8 8s8-3.6 8-8V216h88c4.4 0 8-3.6 8-8s-3.6-8-8-8H216V112c0-4.4-3.6-8-8-8s-8 3.6-8 8v88H112c-4.4 0-8 3.6-8 8s3.6 8 8 8h88v88z'
      
    ]
  };

  
    var faSearchPlus = faMagnifyingGlassPlus;
  

  
  

  var faIdCardClip = {
    prefix: 'fat',
    iconName: 'id-card-clip',
    icon: [
      576,
      512,
      ["id-card-alt"],
      'f47f',
      
      'M256 16h64c8.8 0 16 7.2 16 16V96c0 8.8-7.2 16-16 16H256c-8.8 0-16-7.2-16-16V32c0-8.8 7.2-16 16-16zM224 32V96c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32zM192 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H384V80H512c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V128c0-26.5 21.5-48 48-48H192V64zm48 192a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM192 424c0-30.9 25.1-56 56-56h80c30.9 0 56 25.1 56 56c0 4.4 3.6 8 8 8s8-3.6 8-8c0-39.8-32.2-72-72-72H248c-39.8 0-72 32.2-72 72c0 4.4 3.6 8 8 8s8-3.6 8-8z'
      
    ]
  };

  
    var faIdCardAlt = faIdCardClip;
  

  
  

  var faEarthAsia = {
    prefix: 'fat',
    iconName: 'earth-asia',
    icon: [
      512,
      512,
      [127759,"globe-asia"],
      'f57e',
      
      'M496 256c0-104.9-67.3-194.1-161.1-226.7l-19.4 71.3c-3 11.2-11.9 19.8-23.1 22.6L277 127c-11.1 2.8-15.8 16-8.9 25.1l16.1 21.5c8.1 10.9 8.6 25.7 1 37l-10.7 16.1C265.6 240 250.6 248 234.6 248h-2.3c-10.7 0-18.4 10.3-15.3 20.6l6 19.9c5.9 19.7-8.8 39.5-29.4 39.5c-13.8 0-26.4-7.8-32.5-20.1l-9.3-18.5c-4.9-9.8-17.9-11.9-25.6-4.2l-15.6 15.6c-7.4 7.4-18 10.7-28.4 8.9L19.7 298.3C39.7 410.7 137.9 496 256 496c54.9 0 105.6-18.5 146-49.5l-23.3-20.1c-6.6-5.7-15.8-7.4-24-4.3l-.9 .3c-23.7 8.8-50.2-2.3-60.5-25.4l-5.5-12.4c-10.2-22.7-1.3-49.4 20.4-61.5L344.3 303c1.2-.6 2.1-1.6 2.8-2.7l6.1-9.5c7.5-11.7 20.4-18.8 34.3-18.8s26.8 7.1 34.3 18.8l2 3.1c1.8 2.9 5.3 4.2 8.6 3.3l14.7-4.1c8.4-2.4 17.5-1.1 25 3.4l18.3 11c3.6-16.6 5.5-33.7 5.5-51.4zm-32.1 54.2c-3.8-2.3-8.3-2.9-12.5-1.7l-14.7 4.1c-10.1 2.8-20.8-1.3-26.4-10.1l-2-3.1c-4.5-7.1-12.4-11.4-20.8-11.4s-16.3 4.3-20.8 11.4l-6.1 9.5c-2.1 3.3-5.1 6.1-8.5 8l-36.2 20.2c-14.5 8.1-20.4 25.9-13.6 41l5.5 12.4c6.9 15.4 24.6 22.8 40.4 16.9l.9-.3c13.7-5.1 29-2.3 40.1 7.2l25.4 21.9c33.6-29.6 58.9-68.5 71.8-112.6l-22.4-13.4zM319.6 24.5C299.3 19 278 16 256 16C123.5 16 16 123.5 16 256c0 8.6 .5 17.2 1.3 25.6l67.7 12.3c5.2 .9 10.5-.7 14.2-4.4l15.6-15.6c15.4-15.4 41.5-11.2 51.2 8.3l9.3 18.5c3.4 6.9 10.5 11.2 18.2 11.2c9.8 0 16.9-9.5 14.1-18.9l-6-19.9c-6.2-20.5 9.2-41.2 30.7-41.2h2.3c10.7 0 20.7-5.3 26.6-14.2l10.7-16.1c3.8-5.6 3.6-13-.5-18.5l-16.1-21.5c-13.7-18.3-4.4-44.7 17.8-50.2l15.3-3.8c5.6-1.4 10-5.7 11.6-11.3l19.6-71.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm161.9 88.2l32 8c4.3 1.1 6.9 5.4 5.8 9.7s-5.4 6.9-9.7 5.8l-32-8c-4.3-1.1-6.9-5.4-5.8-9.7s5.4-6.9 9.7-5.8zm88.1-4.5c-4.3-1.1-6.9-5.4-5.8-9.7l8-32c1.1-4.3 5.4-6.9 9.7-5.8s6.9 5.4 5.8 9.7l-8 32c-1.1 4.3-5.4 6.9-9.7 5.8zm93.1-208.2l-16 32c-2 4-6.8 5.6-10.7 3.6s-5.6-6.8-3.6-10.7l16-32c2-4 6.8-5.6 10.7-3.6s5.6 6.8 3.6 10.7z'
      
    ]
  };

  
    var faGlobeAsia = faEarthAsia;
  

  
  

  var faHotel = {
    prefix: 'fat',
    iconName: 'hotel',
    icon: [
      512,
      512,
      [127976],
      'f594',
      
      'M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8H32V496H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H208h8 80 8H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H480V16h24c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zM288 432v64H224V432c0-17.7 14.3-32 32-32s32 14.3 32 32zm16 0c0-26.5-21.5-48-48-48s-48 21.5-48 48v64H48V16H464V496H304V432zM328 96v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V96c0-13.3-10.7-24-24-24H352c-13.3 0-24 10.7-24 24zm24-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H352c-4.4 0-8-3.6-8-8V96c0-4.4 3.6-8 8-8zM240 72c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V96c0-13.3-10.7-24-24-24H240zm-8 24c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H240c-4.4 0-8-3.6-8-8V96zM216 224v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V224c0-13.3-10.7-24-24-24H240c-13.3 0-24 10.7-24 24zm24-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H240c-4.4 0-8-3.6-8-8V224c0-4.4 3.6-8 8-8zm112-16c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V224c0-13.3-10.7-24-24-24H352zm-8 24c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H352c-4.4 0-8-3.6-8-8V224zM104 96v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V96c0-13.3-10.7-24-24-24H128c-13.3 0-24 10.7-24 24zm24-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H128c-4.4 0-8-3.6-8-8V96c0-4.4 3.6-8 8-8zm0 112c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V224c0-13.3-10.7-24-24-24H128zm-8 24c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H128c-4.4 0-8-3.6-8-8V224zm70.4 141.3c16.1-18 39.5-29.3 65.6-29.3s49.5 11.3 65.6 29.3c2.9 3.3 8 3.6 11.3 .6s3.6-8 .6-11.3c-19-21.3-46.7-34.7-77.5-34.7s-58.5 13.4-77.5 34.7c-2.9 3.3-2.7 8.3 .6 11.3s8.3 2.7 11.3-.6z'
      
    ]
  };

  

  
  

  var fa9 = {
    prefix: 'fat',
    iconName: '9',
    icon: [
      320,
      512,
      [],
      '39',
      
      'M304 192A144 144 0 1 1 16 192a144 144 0 1 1 288 0zM219.4 340.6L98.2 466.5c-3.1 3.2-3 8.2 .2 11.3s8.2 3 11.3-.2L273.4 307.6C303.3 276.6 320 235.1 320 192c0-88.4-71.6-160-160-160S0 103.6 0 192s71.6 160 160 160c21 0 41.1-4 59.4-11.4z'
      
    ]
  };

  

  
  

  var faAlbumCollection = {
    prefix: 'fat',
    iconName: 'album-collection',
    icon: [
      512,
      512,
      [],
      'f8a0',
      
      'M64 0H448c17.7 0 32 14.3 32 32v8c0 4.4-3.6 8-8 8s-8-3.6-8-8V32c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16v8c0 4.4-3.6 8-8 8s-8-3.6-8-8V32C32 14.3 46.3 0 64 0zM16 112c0-17.7 14.3-32 32-32H464c17.7 0 32 14.3 32 32v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8zM4.2 212.6C1.5 184.4 23.7 160 52 160H460c28.3 0 50.5 24.4 47.8 52.6l-24.4 256c-2.3 24.6-23 43.4-47.8 43.4H76.4c-24.7 0-45.4-18.8-47.8-43.4L4.2 212.6zM52 176c-18.9 0-33.6 16.2-31.9 35L44.5 467c1.6 16.4 15.4 29 31.9 29H435.6c16.5 0 30.3-12.5 31.9-29l24.4-256c1.8-18.8-13-35-31.9-35H52zM416 340c0-30.3-16.3-58.9-45.1-80.5S301.5 224 256 224s-86 13.8-114.9 35.5S96 309.7 96 340s16.3 58.9 45.1 80.5S210.5 456 256 456s86-13.8 114.9-35.5S416 370.3 416 340zm16 0c0 72.9-78.8 132-176 132s-176-59.1-176-132s78.8-132 176-132s176 59.1 176 132zM281.8 368.6c-7.3 4.9-16.5 7.4-25.8 7.4s-18.5-2.5-25.8-7.4C223 363.8 216 355.4 216 344s7-19.8 14.2-24.6c7.3-4.9 16.5-7.4 25.8-7.4s18.5 2.5 25.8 7.4C289 324.2 296 332.6 296 344s-7 19.8-14.2 24.6zM256 360c13.3 0 24-7.2 24-16s-10.7-16-24-16s-24 7.2-24 16s10.7 16 24 16z'
      
    ]
  };

  

  
  

  var faGifts = {
    prefix: 'fat',
    iconName: 'gifts',
    icon: [
      640,
      512,
      [],
      'f79c',
      
      'M111.4 4.9c-1.7-4.1-6.4-6-10.5-4.3s-6 6.4-4.3 10.5l30.5 73.1-82.9-51c-3.8-2.3-8.7-1.1-11 2.6s-1.1 8.7 2.6 11L115.7 96H72C32.2 96 0 128.2 0 168V440c0 39.8 32.2 72 72 72H184c4.4 0 8-3.6 8-8s-3.6-8-8-8H72c-30.9 0-56-25.1-56-56V168c0-30.9 25.1-56 56-56h72 0H248c4.4 0 8-3.6 8-8s-3.6-8-8-8H172.3l79.9-49.2c3.8-2.3 4.9-7.2 2.6-11s-7.2-4.9-11-2.6L161.6 83.8l31.8-72.6c1.8-4-.1-8.8-4.1-10.5s-8.8 .1-10.5 4.1L144.2 83.6 111.4 4.9zM368.1 159.7L417.6 224H392 336c-22.1 0-40-17.9-40-40c0-22.1 18-40 40.2-40c12.5 0 24.4 5.8 32 15.7zM280 184c0 15.7 6.4 29.8 16.8 40H272c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H567.2c10.4-10.2 16.8-24.3 16.8-40c0-31-25.3-56-56.2-56c-17.4 0-34 8.1-44.7 22L432 216.5 380.8 150c-10.7-13.9-27.2-22-44.7-22c-30.9 0-56.2 25-56.2 56zm-8 56h64 56 32V352H240V272c0-17.7 14.3-32 32-32zM240 368H424V496H272c-17.7 0-32-14.3-32-32V368zm384 0v96c0 17.7-14.3 32-32 32H440V368H624zM440 352V240h32 56 64c17.7 0 32 14.3 32 32v80H440zm32-128H446.4l49.5-64.3c7.6-9.9 19.5-15.7 32-15.7c22.1 0 40.2 17.9 40.2 40c0 22.1-17.9 40-40 40H472z'
      
    ]
  };

  

  
  

  var faCircle4 = {
    prefix: 'fat',
    iconName: 'circle-4',
    icon: [
      512,
      512,
      [],
      'e0f1',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM235 128.6c4.1 1.7 6 6.3 4.4 10.4L171.9 304H304V200c0-4.4 3.6-8 8-8s8 3.6 8 8V304h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H320v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V320H160c-2.7 0-5.2-1.3-6.6-3.5s-1.8-5-.8-7.5l72-176c1.7-4.1 6.3-6 10.4-4.4z'
      
    ]
  };

  

  
  

  var faCircleXmark = {
    prefix: 'fat',
    iconName: 'circle-xmark',
    icon: [
      512,
      512,
      [61532,"times-circle","xmark-circle"],
      'f057',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM178.3 178.3c-3.1 3.1-3.1 8.2 0 11.3L244.7 256l-66.3 66.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L256 267.3l66.3 66.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L267.3 256l66.3-66.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L256 244.7l-66.3-66.3c-3.1-3.1-8.2-3.1-11.3 0z'
      
    ]
  };

  
    var faTimesCircle = faCircleXmark;
  
    var faXmarkCircle = faCircleXmark;
  

  
  

  var faCalendarMinus = {
    prefix: 'fat',
    iconName: 'calendar-minus',
    icon: [
      448,
      512,
      [],
      'f272',
      
      'M128 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H64C28.7 64 0 92.7 0 128v48 16V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 176 128c0-35.3-28.7-64-64-64H336V8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H128V8zM16 192H432V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V192zM112 80v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80H320v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80h48c26.5 0 48 21.5 48 48v48H16V128c0-26.5 21.5-48 48-48h48zM312 352c4.4 0 8-3.6 8-8s-3.6-8-8-8H136c-4.4 0-8 3.6-8 8s3.6 8 8 8H312z'
      
    ]
  };

  

  
  

  var faBandage = {
    prefix: 'fat',
    iconName: 'bandage',
    icon: [
      640,
      512,
      [129657,"band-aid"],
      'f462',
      
      'M480 112V400h80c35.3 0 64-28.7 64-64V176c0-35.3-28.7-64-64-64H480zm-16 0H176V400H464V112zM160 400V112H80c-35.3 0-64 28.7-64 64V336c0 35.3 28.7 64 64 64h80zm0-304h16H464h16 80c44.2 0 80 35.8 80 80V336c0 44.2-35.8 80-80 80H480 464 176 160 80c-44.2 0-80-35.8-80-80V176c0-44.2 35.8-80 80-80h80zm112 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-80 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  
    var faBandAid = faBandage;
  

  
  

  var faClapperboardPlay = {
    prefix: 'fat',
    iconName: 'clapperboard-play',
    icon: [
      512,
      512,
      [],
      'e132',
      
      'M496 176V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V176H496zm0-16H371.3L475 56.3C487.7 65 496 79.5 496 96v64zm-276.7 0L325.7 53.7l5.7-5.7H448c3.9 0 7.7 .5 11.3 1.3L348.7 160H219.3zm-22.6 0H67.3L173.7 53.7l5.7-5.7H308.7l-112 112zM64 48h92.7L44.7 160H16V96c0-26.5 21.5-48 48-48zM512 160V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v64 8 8V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176v-8-8zM204.2 225.2c-2.5-1.5-5.6-1.6-8.1-.2s-4.1 4.1-4.1 7V408c0 2.9 1.6 5.6 4.1 7s5.6 1.4 8.1-.2l144-88c2.4-1.5 3.8-4 3.8-6.8s-1.4-5.4-3.8-6.8l-144-88zM328.7 320L208 393.7V246.3L328.7 320z'
      
    ]
  };

  

  
  

  var faSensorCloud = {
    prefix: 'fat',
    iconName: 'sensor-cloud',
    icon: [
      640,
      512,
      ["sensor-smoke"],
      'e02c',
      
      'M64 48H384c26.5 0 48 21.5 48 48V226.4c5.5 1.1 10.8 2.6 16 4.4V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H237.8c-2.7-5.1-5.1-10.5-7-16H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48zm32 56c0-4.4-3.6-8-8-8s-8 3.6-8 8V280c0 4.4 3.6 8 8 8s8-3.6 8-8V104zm64 0c0-4.4-3.6-8-8-8s-8 3.6-8 8V280c0 4.4 3.6 8 8 8s8-3.6 8-8V104zM336 344c0-39.8 32.2-72 72-72c28.3 0 52.8 16.3 64.5 40c1.1 2.2 3.2 3.8 5.7 4.3s5-.3 6.9-1.9c7.1-6.5 16.5-10.4 26.9-10.4c22.1 0 40 17.9 40 40l0 .4c0 4.1 3.1 7.6 7.2 8C595.6 356 624 386.7 624 424c0 39.8-32.2 72-72 72H344c-39.8 0-72-32.2-72-72c0-34.8 24.7-63.9 57.6-70.6c3.8-.8 6.5-4.1 6.4-8c0-.5 0-1 0-1.4zm72-88c-47 0-85.4 36.9-87.9 83.3c-37 10.4-64.1 44.4-64.1 84.7c0 48.6 39.4 88 88 88H552c48.6 0 88-39.4 88-88c0-43.3-31.2-79.2-72.4-86.6C564.3 309.6 540.7 288 512 288c-11 0-21.2 3.2-29.8 8.6c-15.6-24.4-43-40.6-74.2-40.6z'
      
    ]
  };

  
    var faSensorSmoke = faSensorCloud;
  

  
  

  var faBookUser = {
    prefix: 'fat',
    iconName: 'book-user',
    icon: [
      448,
      512,
      [],
      'f7e7',
      
      'M0 56C0 25.1 25.1 0 56 0H408c22.1 0 40 17.9 40 40V376c0 19.4-13.7 35.5-32 39.2V496h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H56c-30.9 0-56-25.1-56-56V56zM56 416c-22.1 0-40 17.9-40 40s17.9 40 40 40H400V416H56zm-40 .8C26.2 406.4 40.3 400 56 400H408c13.3 0 24-10.7 24-24V40c0-13.3-10.7-24-24-24H56C33.9 16 16 33.9 16 56V416.8zM240 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-112a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM200 256c-30.9 0-56 25.1-56 56c0 4.4 3.6 8 8 8H328c4.4 0 8-3.6 8-8c0-30.9-25.1-56-56-56H200zm-72 56c0-39.8 32.2-72 72-72h80c39.8 0 72 32.2 72 72c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24z'
      
    ]
  };

  

  
  

  var faWatchSmart = {
    prefix: 'fat',
    iconName: 'watch-smart',
    icon: [
      384,
      512,
      [],
      'e2cc',
      
      'M80 40V64H304l0-24c0-13.3-10.7-24-24-24H104C90.7 16 80 26.7 80 40zM64 65.6V40C64 17.9 81.9 0 104 0H280c22.1 0 40 17.9 40 40V65.6c36.5 7.4 64 39.7 64 78.4V368c0 38.7-27.5 71-64 78.4V472c0 22.1-17.9 40-40 40l-176 0c-22.1 0-40-17.9-40-40l0-25.6C27.5 439 0 406.7 0 368V144c0-38.7 27.5-71 64-78.4zM80 472c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24V448H80l0 24zm224-40c35.3 0 64-28.7 64-64V144c0-35.3-28.7-64-64-64H80c-35.3 0-64 28.7-64 64V368c0 35.3 28.6 64 63.9 64l.1 0H304zM200 160v92l60.8 45.6c3.5 2.7 4.3 7.7 1.6 11.2s-7.7 4.3-11.2 1.6l-64-48c-2-1.5-3.2-3.9-3.2-6.4V160c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faBrain = {
    prefix: 'fat',
    iconName: 'brain',
    icon: [
      512,
      512,
      [129504],
      'f5dc',
      
      'M200 0c-29.9 0-55 20.5-62.1 48.3C105.4 51.3 80 78.7 80 112c0 6.7 1 13.1 2.9 19.1C53.4 140.2 32 167.6 32 200c0 12.4 3.1 24.1 8.7 34.3C16.4 248 0 274.1 0 304c0 33.3 20.4 61.9 49.4 73.9c-.9 4.6-1.4 9.3-1.4 14.1c0 39.8 32.2 72 72 72c3.7 0 7.2-.3 10.8-.8C139 491.4 165.1 512 196 512c26 0 48.5-14.6 60-36c11.5 21.4 34 36 60 36c30.9 0 57-20.6 65.2-48.8c3.5 .5 7.1 .8 10.8 .8c39.8 0 72-32.2 72-72c0-4.8-.5-9.5-1.4-14.1c29-12 49.4-40.6 49.4-73.9c0-29.9-16.4-56-40.7-69.7c5.5-10.2 8.7-21.9 8.7-34.3c0-32.4-21.4-59.8-50.9-68.9c1.9-6 2.9-12.5 2.9-19.1c0-33.3-25.4-60.7-57.9-63.7C367 20.5 341.9 0 312 0c-24.1 0-45.1 13.3-56 33C245.1 13.3 224.1 0 200 0zm48 64V444v2.6c-.1 .3-.1 .6-.1 .9C246.1 474.6 223.6 496 196 496c-25.8 0-47.3-18.8-51.3-43.5c-.4-2.2-1.7-4.2-3.6-5.4s-4.2-1.6-6.4-1c-4.7 1.3-9.6 1.9-14.7 1.9c-30.9 0-56-25.1-56-56c0-5.8 .9-11.5 2.5-16.7c.6-2 .4-4.2-.6-6.1s-2.7-3.3-4.7-3.9C35 357.2 16 332.8 16 304c0-26.6 16.2-49.4 39.3-59.1c2.3-.9 4-2.9 4.6-5.2s.2-4.9-1.2-6.9C52 223.6 48 212.3 48 200c0-27.9 20.4-51 47-55.3c2.5-.4 4.7-2 5.8-4.2s1.2-4.9 .1-7.2c-3.2-6.4-5-13.6-5-21.3c0-26.5 21.5-48 48-48l.5 0c4 0 7.4-2.9 8-6.9C155.8 33.9 175.8 16 200 16c26.5 0 48 21.5 48 48zm16 382.6V444 64c0-26.5 21.5-48 48-48c24.2 0 44.2 17.9 47.5 41.1c.6 4 4 6.9 8 6.9l.5 0c26.5 0 48 21.5 48 48c0 7.7-1.8 14.9-5 21.3c-1.1 2.3-1.1 5 .1 7.2s3.3 3.8 5.8 4.2c26.7 4.3 47 27.4 47 55.3c0 12.3-4 23.6-10.7 32.9c-1.4 2-1.9 4.5-1.2 6.9s2.4 4.3 4.6 5.2c23.1 9.7 39.3 32.5 39.3 59.1c0 28.8-19 53.2-45.3 61.2c-2 .6-3.7 2-4.7 3.9s-1.2 4.1-.6 6.1c1.7 5.3 2.5 10.9 2.5 16.7c0 30.9-25.1 56-56 56c-5.1 0-10-.7-14.7-1.9c-2.2-.6-4.5-.2-6.4 1s-3.2 3.2-3.6 5.4c-4 24.7-25.5 43.5-51.3 43.5c-27.6 0-50.1-21.4-51.9-48.5c0-.3-.1-.6-.1-.9z'
      
    ]
  };

  

  
  

  var faPompebled = {
    prefix: 'fat',
    iconName: 'pompebled',
    icon: [
      512,
      512,
      [],
      'e43d',
      
      'M252.4 21.9c50 34.5 56.3 111.9 19.6 178.5l-.2 .4-.2 .3c-3.3 4.7-2.1 11 2.4 14.3c4.4 3.2 10.3 2.2 13.5-2.4l.2-.3 .2-.3c48-58.2 121.1-80 170.8-44.3c61.5 43.5 70.5 136 23.9 204.9l0 0C398 497.8 223.7 558.4 101.3 470.6l4.7-6.5-4.6 6.5s0 0 0 0C-21.3 383-28 196.5 56.5 71.7c0 0 0 0 0 0l6.6 4.5 0 0 0 0-6.6-4.5s0 0 0 0C103.1 2.2 190.8-21.7 252.4 21.9zM243.2 35C190.6-2.3 112.6 16.7 69.8 80.7l0 0C-11.4 200.6-2.9 376.5 110.6 457.6l0 0C223.4 538.4 388 484 469.2 364.1c42.9-63.6 32.9-145.6-19.9-182.9l0 0c-39.8-28.6-103.6-13.5-148.9 41.2c-8.3 11.7-24.1 14.5-35.8 6c-11.5-8.3-14.3-24.2-6.4-36C292.6 129.5 283.6 62.9 243.3 35l-.1-.1z'
      
    ]
  };

  

  
  

  var faBowlingBall = {
    prefix: 'fat',
    iconName: 'bowling-ball',
    icon: [
      512,
      512,
      [],
      'f436',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm240-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm16 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM112 176a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM240 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm16 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faUnicorn = {
    prefix: 'fat',
    iconName: 'unicorn',
    icon: [
      640,
      512,
      [129412],
      'f727',
      
      'M448 16h8 16 21.8c28.9 0 53 21.9 55.7 50.7l7 73.8c1.8 18.5-8.1 36.2-24.7 44.6c-22.3 11.1-49.3 2.1-60.5-20.2l-8.3-16.5c-1.4-2.7-4.1-4.4-7.2-4.4H440c-4.4 0-8 3.6-8 8v87.5 .4l0 .1c-.2 25.4-11.6 47.6-29.2 62.5c-1.8 1.5-2.8 3.8-2.8 6.1V480c0 8.8-7.2 16-16 16H344c-8.8 0-16-7.2-16-16V325.7c0-3.8-2.6-7-6.3-7.8L198.3 290.8c-2.7-.6-5.5 .2-7.4 2.2s-2.7 4.8-2.1 7.5c2.1 9 3.2 18.1 3.2 27.4c0 16.1-3.3 32.1-9.6 46.9l-6.5 15.3c-3.6 8.4-4.2 17.7-1.8 26.5l16.5 59.3c2.8 10.2-4.8 20.3-15.4 20.3H125.3c-7.2 0-13.5-4.8-15.4-11.7L97 437.8c-7.3-26.3-5.4-54.3 5.3-79.4l6.5-15.3c2.1-4.8 3.2-10.1 3.2-15.3c0-5.1-1-10.2-3-15L77.1 236.3c-3.4-8.1-5.1-16.8-5.1-25.6c0-36.8 29.8-66.7 66.7-66.7h53.1H224h96c4.4 0 8-3.6 8-8c0-66.3 53.7-120 120-120zM553.7 32c-4.1-6.1-9-11.4-14.6-16H552c4.4 0 8-3.6 8-8s-3.6-8-8-8H493.8 472 456h-8C375.6 0 316.4 56.6 312.2 128H224 191.8 138.7c-26.6 0-50.2 12.5-65.3 32H72 64c-35.3 0-64 28.7-64 64v88c0 4.4 3.6 8 8 8s8-3.6 8-8V224c0-26.4 21.3-47.8 47.6-48c-4.9 10.5-7.6 22.3-7.6 34.7c0 10.9 2.2 21.7 6.4 31.8L94.2 319c1.2 2.8 1.8 5.8 1.8 8.8c0 3.1-.6 6.2-1.9 9l-6.5 15.3c-12.2 28.4-14.3 60.2-6 90l12.9 46.5c3.8 13.9 16.5 23.4 30.8 23.4h49.8c21.2 0 36.5-20.2 30.8-40.6l-16.5-59.3c-1.5-5.3-1.1-10.9 1.1-15.9l6.5-15.3c7.2-16.8 10.9-34.9 10.9-53.2c0-6.3-.4-12.6-1.3-18.8L312 332.1V480c0 17.7 14.3 32 32 32h40c17.7 0 32-14.3 32-32V312.1c19.3-17.7 31.8-43.1 32-71.9l0-.2v-.5V160h3.1l6.1 12.1c15.1 30.2 51.8 42.4 81.9 27.3c22.6-11.3 35.9-35.3 33.5-60.4l-5.1-53.6 65-28.9c4.6-2.1 7.6-6.7 7.6-11.7c0-7.1-5.8-12.8-12.8-12.8H553.7zm8 16h50.6L565.8 68.7l-.3-3.5c-.6-6-1.9-11.7-3.8-17.2zM496 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faDice = {
    prefix: 'fat',
    iconName: 'dice',
    icon: [
      640,
      512,
      [127922],
      'f522',
      
      'M263.6 45.7c-21.9-21.9-57.3-21.9-79.2 0L45.7 184.4c-21.9 21.9-21.9 57.3 0 79.2L184.4 402.3c21.9 21.9 57.3 21.9 79.2 0L402.3 263.6c21.9-21.9 21.9-57.3 0-79.2L263.6 45.7zM173.1 34.3c28.1-28.1 73.7-28.1 101.8 0L413.7 173.1c28.1 28.1 28.1 73.7 0 101.8L274.9 413.7c-28.1 28.1-73.7 28.1-101.8 0L34.3 274.9c-28.1-28.1-28.1-73.7 0-101.8L173.1 34.3zM320 448V413.8l16-16V448c0 26.5 21.5 48 48 48H576c26.5 0 48-21.5 48-48V256c0-26.5-21.5-48-48-48H465.5c-.8-5.4-2.1-10.8-3.8-16H576c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H384c-35.3 0-64-28.7-64-64zm144-96a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM208 120a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM104 224a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm88-32a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-16 72a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm88-72a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z'
      
    ]
  };

  

  
  

  var faSquareEnvelope = {
    prefix: 'fat',
    iconName: 'square-envelope',
    icon: [
      448,
      512,
      ["envelope-square"],
      'f199',
      
      'M384 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM352 160c8.8 0 16 7.2 16 16v6.7l-4 2.6L234.4 268.9c-3.1 2-6.7 3.1-10.4 3.1s-7.3-1.1-10.4-3.1L84 185.3l-4-2.6V176c0-8.8 7.2-16 16-16H352zm16 41.7V336c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V201.7l124.9 80.6c5.7 3.7 12.3 5.6 19.1 5.6s13.4-2 19.1-5.6L368 201.7zM96 144c-17.7 0-32 14.3-32 32V336c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V176c0-17.7-14.3-32-32-32H96z'
      
    ]
  };

  
    var faEnvelopeSquare = faSquareEnvelope;
  

  
  

  var faPersonWalkingArrowRight = {
    prefix: 'fat',
    iconName: 'person-walking-arrow-right',
    icon: [
      640,
      512,
      [],
      'e552',
      
      'M137.1 187.3c-4.6-4-11-5.1-16.6-2.8c-1.1 .5-2.2 .9-3.4 1.4l0 0-5.7 2.5c-21.6 9.6-37.9 28.3-44.4 51.1l-3.7 12.9c-2.4 8.5-11.3 13.4-19.8 11s-13.4-11.3-11-19.8l3.7-12.9c9.1-31.9 31.9-58.1 62.2-71.6l5.7-2.5c18.8-8.3 39-12.6 59.6-12.6c38.1 0 72.5 22.9 87.1 58.1l16.5 39.7c1.1 2.6 2.9 4.9 5.2 6.6l25 18.8c7.1 5.3 8.5 15.3 3.2 22.4s-15.3 8.5-22.4 3.2l-28.5-21.4c-4.6-3.4-8.1-8-10.3-13.3l-10.2-24.5c-2.6-6.3-8.9-10.2-15.6-9.8s-12.6 5-14.5 11.5L180 300.8c-1.6 5.4-.2 11.2 3.6 15.3l49.5 54c3.6 3.9 6.2 8.7 7.5 13.9l23 92.1c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6l-22-88.1c-.6-2.6-1.9-5-3.7-6.9l-70.7-77.1c-11.1-12.1-15.2-29-11-44.8L142 203.4c1.6-5.9-.3-12.1-4.9-16.1zM208 16a36 36 0 1 1 0 72 36 36 0 1 1 0-72zM107.4 209c3.3-2.3 6.8-4.3 10.6-6l5.7-2.5c1-.4 1.9-.8 2.9-1.2l-1.3 4.8-2.5 9.6-1.5 5.6-11.6 43.6c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 12.1-41.2 7.2-24.4 9.8 23.5 .4 1c3.3 7.9 8.7 14.8 15.5 19.9l28.5 21.4c14.1 10.6 34.2 7.7 44.8-6.4s7.7-34.2-6.4-44.8l-25-18.8-16.5-39.7C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14L92 144.5c-34.6 15.4-60.7 45.3-71.1 81.8l-3.7 12.9c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l3.7-12.9c4.1-14.3 13-26.6 24.9-34.9zM260 52A52 52 0 1 0 156 52a52 52 0 1 0 104 0zM99 343.9c-4.1-1.6-8.8 .4-10.4 4.5L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l61.7-61.7c4.6-4.6 8.2-10.1 10.6-16.1L142.1 387c1.6-4.1-.4-8.8-4.5-10.4s-8.8 .4-10.4 4.5l-15.1 37.9c-1.6 4-4 7.7-7.1 10.7L43.3 491.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l60.5-60.5 1.2-1.2 .6-1.5 20.5-51.1c1.6-4.1-.4-8.8-4.5-10.4zM541.1 169.9c-3.4-2.8-8.4-2.4-11.3 1s-2.4 8.4 1 11.3l79 65.9H392c-4.4 0-8 3.6-8 8s3.6 8 8 8H609.9l-79 65.9c-3.4 2.8-3.9 7.9-1 11.3s7.9 3.9 11.3 1l96-80c1.8-1.5 2.9-3.8 2.9-6.1s-1.1-4.6-2.9-6.1l-96-80z'
      
    ]
  };

  

  
  

  var faRectangleBarcode = {
    prefix: 'fat',
    iconName: 'rectangle-barcode',
    icon: [
      576,
      512,
      ["barcode-alt"],
      'f463',
      
      'M512 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM80 136V376c0 4.4 3.6 8 8 8s8-3.6 8-8V136c0-4.4-3.6-8-8-8s-8 3.6-8 8zm56-8c-4.4 0-8 3.6-8 8V376c0 4.4 3.6 8 8 8s8-3.6 8-8V136c0-4.4-3.6-8-8-8zm40 8V376c0 4.4 3.6 8 8 8s8-3.6 8-8V136c0-4.4-3.6-8-8-8s-8 3.6-8 8zm72-8c-4.4 0-8 3.6-8 8V376c0 4.4 3.6 8 8 8s8-3.6 8-8V136c0-4.4-3.6-8-8-8zm72 8V376c0 4.4 3.6 8 8 8s8-3.6 8-8V136c0-4.4-3.6-8-8-8s-8 3.6-8 8zm56-8c-4.4 0-8 3.6-8 8V376c0 4.4 3.6 8 8 8s8-3.6 8-8V136c0-4.4-3.6-8-8-8zm56 8V376c0 4.4 3.6 8 8 8s8-3.6 8-8V136c0-4.4-3.6-8-8-8s-8 3.6-8 8zm56-8c-4.4 0-8 3.6-8 8V376c0 4.4 3.6 8 8 8s8-3.6 8-8V136c0-4.4-3.6-8-8-8z'
      
    ]
  };

  
    var faBarcodeAlt = faRectangleBarcode;
  

  
  

  var faSquareS = {
    prefix: 'fat',
    iconName: 'square-s',
    icon: [
      448,
      512,
      [],
      'e27d',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm145 87.7c-2 10.6-.7 18.6 2.4 25c3.1 6.5 8.6 12 16.2 16.9c15.6 10 38.2 16.2 62.6 22.8l.9 .2c23.3 6.3 48.3 13 66.2 24.5c9.2 5.9 17.1 13.5 21.9 23.3c4.9 9.9 6.2 21.5 3.7 34.9c-4.2 22.2-20.2 37.1-41.5 45.1c-21.1 8-48.1 9.5-76.6 5.4l0 0c-17.9-2.7-49.4-11.6-65.9-16.7c-4.2-1.3-6.6-5.8-5.3-10s5.8-6.6 10-5.3c16.6 5.1 47 13.7 63.6 16.1c26.8 3.9 50.9 2.1 68.7-4.6c17.6-6.6 28.5-17.8 31.4-33.1c2-10.6 .7-18.6-2.4-25c-3.1-6.5-8.6-12-16.2-16.9c-15.6-10-38.2-16.2-62.6-22.8l-.9-.2c-23.3-6.3-48.3-13-66.2-24.5c-9.2-5.9-17.1-13.5-21.9-23.3c-4.9-9.9-6.2-21.5-3.7-34.9c4.2-22.2 20.2-37.1 41.5-45.1c21.1-8 48.1-9.5 76.6-5.4c8.8 1.3 27.7 5.2 36.5 7.3c4.3 1.1 6.9 5.4 5.9 9.7s-5.4 6.9-9.7 5.9c-8.5-2.1-26.9-5.9-35-7c-26.8-3.9-50.9-2.1-68.7 4.6c-17.6 6.6-28.5 17.8-31.4 33.1z'
      
    ]
  };

  

  
  

  var faTurnDown = {
    prefix: 'fat',
    iconName: 'turn-down',
    icon: [
      384,
      512,
      [10549,"level-down-alt"],
      'f3be',
      
      'M144 336H54.9c-3.8 0-6.9 3.1-6.9 6.9c0 1.8 .7 3.5 1.9 4.7L190.1 495.2c.5 .5 1.2 .8 1.9 .8s1.4-.3 1.9-.8L334.1 347.6c1.2-1.3 1.9-3 1.9-4.7c0-3.8-3.1-6.9-6.9-6.9H240c-8.8 0-16-7.2-16-16V112c0-53-43-96-96-96H40C26.7 16 16 26.7 16 40V56c0 13.3 10.7 24 24 24l88 0c17.7 0 32 14.3 32 32V320c0 8.8-7.2 16-16 16zm34.5 170.2L38.3 358.6c-4-4.2-6.3-9.9-6.3-15.8C32 330.2 42.2 320 54.9 320H128h16V304 112c0-8.8-7.2-16-16-16L40 96C17.9 96 0 78.1 0 56V40C0 17.9 17.9 0 40 0h88c61.9 0 112 50.1 112 112V304v16h16 73.1c12.6 0 22.9 10.2 22.9 22.9c0 5.9-2.3 11.5-6.3 15.8L205.5 506.2c-3.5 3.7-8.4 5.8-13.5 5.8s-10-2.1-13.5-5.8z'
      
    ]
  };

  
    var faLevelDownAlt = faTurnDown;
  

  
  

  var faWheelchairMove = {
    prefix: 'fat',
    iconName: 'wheelchair-move',
    icon: [
      448,
      512,
      ["wheelchair-alt"],
      'e2ce',
      
      'M400 52a36 36 0 1 0 -72 0 36 36 0 1 0 72 0zm-88 0a52 52 0 1 1 104 0A52 52 0 1 1 312 52zm-8 300A144 144 0 1 0 16 352a144 144 0 1 0 288 0zM0 352a160 160 0 1 1 320 0A160 160 0 1 1 0 352zm160-88a88 88 0 1 0 0 176 88 88 0 1 0 0-176zm104 88A104 104 0 1 1 56 352a104 104 0 1 1 208 0zm112.1-64c4.9 0 9.4 2.2 12.5 6s4.2 8.7 3.1 13.5L368.4 412.5c-1.9 8.6 3.5 17.2 12.1 19.1s17.2-3.5 19.1-12.1l32-144c1.1-4.7-.1-9.7-3.1-13.5s-7.6-6-12.5-6H326.3c-3.2-5.5-6.6-10.9-10.3-16H416c9.7 0 18.9 4.4 25 12s8.4 17.5 6.3 27l-32 144c-3.8 17.3-20.9 28.1-38.2 24.3s-28.1-20.9-24.3-38.2L372.6 320l3.6-16H359.7 346c-1.4-5.4-3-10.8-4.9-16h35zM337.4 181.4l-36.3 40.3c-3.6-3.9-7.4-7.7-11.3-11.3l35.8-39.7c14.4-15.9 9.3-41.2-10.2-50.4L198.8 65.5c-5.4-2.5-11.7-1.9-16.4 1.7l-64 48c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2l48.6-36.4c4.7-3.6 11.1-4.2 16.4-1.7l50.8 23.9c4.7 2.2 8.1 6.6 8.9 11.7s-.8 10.4-4.4 14.1l-22.9 22.9c-5.4-2.3-10.9-4.3-16.5-6.1l16-16 12-12-15.4-7.2-35.5-16.7-48.6 36.4c-14.1 10.6-34.2 7.7-44.8-6.4s-7.7-34.2 6.4-44.8l64-48c9.5-7.1 22.1-8.4 32.8-3.4l116.5 54.8c29.1 13.7 36.8 51.6 15.2 75.5z'
      
    ]
  };

  
    var faWheelchairAlt = faWheelchairMove;
  

  
  

  var faFaceGrimace = {
    prefix: 'fat',
    iconName: 'face-grimace',
    icon: [
      512,
      512,
      [128556,"grimace"],
      'f57f',
      
      'M256 16a240 240 0 1 0 0 480 240 240 0 1 0 0-480zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM168 304c-22.1 0-40 17.9-40 40s17.9 40 40 40h8V304h-8zm24 80h56V304H192v80zm128 0V304H264v80h56zm16 0h8c22.1 0 40-17.9 40-40s-17.9-40-40-40h-8v80zM168 288H344c30.9 0 56 25.1 56 56s-25.1 56-56 56H168c-30.9 0-56-25.1-56-56s25.1-56 56-56zm-7.6-80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  
    var faGrimace = faFaceGrimace;
  

  
  

  var faChessPawnPiece = {
    prefix: 'fat',
    iconName: 'chess-pawn-piece',
    icon: [
      256,
      512,
      ["chess-pawn-alt"],
      'f444',
      
      'M128 240a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm80-64c0 26.2-12.6 49.4-32 64h16c4.4 0 8 3.6 8 8s-3.6 8-8 8H178.9l15.4 128H178.1L162.8 256H128 93.2L77.9 384H61.8L77.1 256H64c-4.4 0-8-3.6-8-8s3.6-8 8-8H80c-19.4-14.6-32-37.8-32-64c0-44.2 35.8-80 80-80s80 35.8 80 80zM56.2 416H199.8c7.8 0 15 3.7 19.5 10.1l32.2 45.1c2.9 4.1 4.5 8.9 4.5 13.9V488c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24v-2.9c0-5 1.6-9.9 4.5-13.9l32.2-45.1c4.5-6.3 11.8-10.1 19.5-10.1zm-6.5 19.4L17.5 480.5c-1 1.4-1.5 3-1.5 4.6V488c0 4.4 3.6 8 8 8H232c4.4 0 8-3.6 8-8v-2.9c0-1.7-.5-3.3-1.5-4.6l-32.2-45.1c-1.5-2.1-3.9-3.4-6.5-3.4H56.2c-2.6 0-5 1.2-6.5 3.4z'
      
    ]
  };

  
    var faChessPawnAlt = faChessPawnPiece;
  

  
  

  var faArrowsUpDown = {
    prefix: 'fat',
    iconName: 'arrows-up-down',
    icon: [
      320,
      512,
      ["arrows-v"],
      'f07d',
      
      'M165.7 2.3c-3-3-7.9-3.1-11.1-.2l-112 104c-3.2 3-3.4 8.1-.4 11.3s8.1 3.4 11.3 .4L152 26.3V484.7L61.7 394.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l104 104c3.1 3.1 8.2 3.1 11.3 0l104-104c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L168 484.7V27.3l90.3 90.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-104-104z'
      
    ]
  };

  
    var faArrowsV = faArrowsUpDown;
  

  
  

  var faWaterLadder = {
    prefix: 'fat',
    iconName: 'water-ladder',
    icon: [
      576,
      512,
      ["ladder-water","swimming-pool"],
      'f5c5',
      
      'M128 112c0-44.2 35.8-80 80-80s80 35.8 80 80v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V112c0-35.3-28.7-64-64-64s-64 28.7-64 64V240.2H384V112c0-44.2 35.8-80 80-80s80 35.8 80 80v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V112c0-35.3-28.7-64-64-64s-64 28.7-64 64V248.2 382.8c-5.5 1.1-10.8 1.7-16 1.7h0V256.2H144V371c-3.8-2.1-7.6-4.4-11.1-6.8c-1.6-1.1-3.2-2.2-4.9-3.1V248.2 112zM294.6 403.4c8 11.2 17.5 21.4 27.6 30.7C339.5 449.8 361.5 464 384 464s44.6-14.2 61.8-29.9c10.1-9.2 19.7-19.5 27.6-30.7c1.5-2.1 3.9-3.4 6.6-3.4s5.1 1.3 6.6 3.4c7.3 10.3 15.9 19.6 25 28.3c15.7 14.8 36.1 29.2 57.4 31.9c4.4 .6 7.5 4.6 6.9 8.9s-4.6 7.5-8.9 6.9c-26.5-3.3-50-20.7-66.4-36.1c-8.8-8.3-15.9-16.4-20.6-22.2c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8l0 0 0 0c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-4.7 5.8-11.8 13.9-20.6 22.2C59 458.7 35.5 476.1 9 479.4c-4.4 .6-8.4-2.6-8.9-6.9s2.6-8.4 6.9-8.9c21.3-2.7 41.7-17.1 57.4-31.9c9.1-8.6 17.7-18 25-28.3c1.5-2.1 3.9-3.4 6.6-3.4s5.1 1.3 6.6 3.4c7.9 11.2 17.5 21.5 27.6 30.7C147.4 449.8 169.5 464 192 464s44.6-14.2 61.8-29.9c10.1-9.2 19.6-19.5 27.6-30.7c3-4.3 10.2-4.3 13.2 0z'
      
    ]
  };

  
    var faLadderWater = faWaterLadder;
  
    var faSwimmingPool = faWaterLadder;
  

  
  

  var faCalendarDay = {
    prefix: 'fat',
    iconName: 'calendar-day',
    icon: [
      448,
      512,
      [],
      'f783',
      
      'M128 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H64C28.7 64 0 92.7 0 128v48 16V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 176 128c0-35.3-28.7-64-64-64H336V8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H128V8zM16 192H432V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V192zM112 80v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80H320v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80h48c26.5 0 48 21.5 48 48v48H16V128c0-26.5 21.5-48 48-48h48zM80 288c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V288zm-16 0v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32z'
      
    ]
  };

  

  
  

  var faBellRing = {
    prefix: 'fat',
    iconName: 'bell-ring',
    icon: [
      512,
      512,
      [],
      'e62c',
      
      'M256 0c-4.4 0-8 3.6-8 8V32l0 .2C163.4 36.4 96 106.3 96 192v36.6c0 41.8-14.2 82.3-40.3 114.9L38.9 364.5c-4.5 5.6-6.9 12.6-6.9 19.8C32 401.8 46.2 416 63.7 416H448.3c17.5 0 31.7-14.2 31.7-31.7c0-7.2-2.4-14.2-6.9-19.8l-16.7-20.9C430.2 311 416 270.4 416 228.6V192c0-85.7-67.4-155.6-152-159.8l0-.2V8c0-4.4-3.6-8-8-8zM112 192c0-79.5 64.5-144 144-144s144 64.5 144 144v36.6c0 45.4 15.5 89.5 43.8 124.9l16.7 20.9c2.2 2.8 3.4 6.2 3.4 9.8c0 8.7-7 15.7-15.7 15.7H63.7C55 400 48 393 48 384.3c0-3.6 1.2-7 3.4-9.8l16.7-20.9C96.5 318.1 112 274.1 112 228.6V192zm88 248c-4.4 0-8 3.6-8 8c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3c0-4.4-3.6-8-8-8s-8 3.6-8 8c0 12.7-5.1 24.9-14.1 33.9s-21.2 14.1-33.9 14.1s-24.9-5.1-33.9-14.1s-14.1-21.2-14.1-33.9c0-4.4-3.6-8-8-8zM100.3 21.9c3.3-3 3.5-8 .5-11.3s-8-3.5-11.3-.5C44.4 51 16 110.2 16 176c0 4.4 3.6 8 8 8s8-3.6 8-8c0-61.1 26.3-116 68.3-154.1zM422.5 10.1c-3.3-3-8.3-2.7-11.3 .5s-2.7 8.3 .6 11.3C453.7 60 480 114.9 480 176c0 4.4 3.6 8 8 8s8-3.6 8-8c0-65.8-28.4-125-73.5-165.9z'
      
    ]
  };

  

  
  

  var faAudioDescriptionSlash = {
    prefix: 'fat',
    iconName: 'audio-description-slash',
    icon: [
      640,
      512,
      [],
      'e0a8',
      
      'M13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7zM487.5 480l-20.3-16H96c-26.5 0-48-21.5-48-48V133L32 120.4V416c0 35.3 28.7 64 64 64H487.5zM152.5 32l20.3 16H544c26.5 0 48 21.5 48 48V379l16 12.6V96c0-35.3-28.7-64-64-64H152.5zM344 183.2l16 12.6V176h56c44.2 0 80 35.8 80 80c0 14.2-3.7 27.6-10.2 39.1l12.7 10C507.1 290.8 512 274 512 256c0-53-43-96-96-96H352c-4.4 0-8 3.6-8 8v15.2zM180.3 237.5l-19.4 38.8-.1 .3-31.9 63.8c-2 4-.4 8.8 3.6 10.7s8.8 .4 10.7-3.6L172.9 288h71.4l-20.3-16H180.9l12.2-24.4-12.8-10.1z'
      
    ]
  };

  

  
  

  var faFileSpreadsheet = {
    prefix: 'fat',
    iconName: 'file-spreadsheet',
    icon: [
      384,
      512,
      [],
      'f65b',
      
      'M16 448V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM80 384h40v48H96c-8.8 0-16-7.2-16-16V384zm0-16V320h40v48H80zm56 64V384h48v48H136zm0-64V320h48v48H136zm64 64V384h48v48H200zm0-112h48v48H200V320zm64 112V384h40v32c0 8.8-7.2 16-16 16H264zm0-64V320h40v48H264zm56 8v-8V320v-8-8V256c0-17.7-14.3-32-32-32H192 96c-17.7 0-32 14.3-32 32v48 8 8 48 8 8 32c0 17.7 14.3 32 32 32h24 8 8 48 8 8 48 8 8 24c17.7 0 32-14.3 32-32V384v-8zM304 256v48H256 192 128 80V256c0-8.8 7.2-16 16-16h96 96c8.8 0 16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faWheat = {
    prefix: 'fat',
    iconName: 'wheat',
    icon: [
      512,
      512,
      [],
      'f72d',
      
      'M486.3 17.3c4.7-.2 8.6 3.7 8.4 8.4l-1.9 38.7c-1.8 36.9-31.4 66.5-68.3 68.3l-47.6 2.4 2.4-47.6c1.8-36.9 31.4-66.5 68.3-68.3l38.8-1.9zM376.1 151.2l49.2-2.5c45.1-2.3 81.2-38.4 83.5-83.5l1.9-38.7c.7-14.2-11-25.9-25.2-25.2L446.8 3.3c-45.1 2.3-81.2 38.4-83.5 83.5l-2.5 49.2-.2 4.2-23.7 23.7c5.7-38.7-6.4-79.4-36.1-109.1L289.5 43.3c-6.2-6.2-16.4-6.2-22.6 0L255.5 54.6c-37.5 37.5-37.5 98.3 0 135.8l27.4 27.4-47.8 47.8c5.7-38.7-6.4-79.4-36.1-109.1l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l27.4 27.4-47.8 47.8c5.7-38.6-6.4-79.4-36.1-109.1L85.8 247c-6.2-6.2-16.4-6.2-22.6 0L51.9 258.3c-37.5 37.5-37.5 98.3 0 135.8l27.4 27.4L2.3 498.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l76.9-76.9 29.2 29.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3C224.7 385.8 182 374 142.1 381.2l50.3-50.3 29.2 29.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-30.9-30.9-73.5-42.7-113.4-35.4l50.3-50.3 29.2 29.2c37.5 37.5 98.3 37.5 135.8 0L470.5 247c6.2-6.2 6.2-16.4 0-22.6L459.2 213c-30.9-30.9-73.5-42.7-113.4-35.4l26.2-26.2 4.2-.2zm-70.5 66.6L321.3 202c41.5-19.3 92.3-11.9 126.5 22.3l11.3 11.3L447.9 247c-31.2 31.2-81.9 31.2-113.1 0l-29.2-29.2zM203.7 319.6l15.8-15.8c41.5-19.3 92.3-11.9 126.5 22.3l11.3 11.3L346 348.8c-31.2 31.2-81.9 31.2-113.1 0l-29.2-29.2zM101.9 421.4l15.8-15.8c41.5-19.3 92.3-11.9 126.5 22.3l11.3 11.3-11.3 11.3c-31.2 31.2-81.9 31.2-113.1 0l-29.2-29.2zM289.5 65.9c32.5 32.5 40.9 80 25 120.2l-20.3 20.3-27.4-27.4c-31.2-31.2-31.2-81.9 0-113.1l11.3-11.3 11.3 11.3zM90.6 410.1L63.2 382.7C32 351.5 32 300.8 63.2 269.6l11.3-11.3 11.3 11.3c32.5 32.5 40.9 80 25 120.2L90.6 410.1zM192.4 308.3L165 280.9c-31.2-31.2-31.2-81.9 0-113.1l11.3-11.3 11.3 11.3c32.5 32.5 40.9 80 25 120.2l-20.3 20.3z'
      
    ]
  };

  

  
  

  var faTurnLeft = {
    prefix: 'fat',
    iconName: 'turn-left',
    icon: [
      512,
      512,
      [],
      'e636',
      
      'M176 272l0 89.1c0 3.8-3.1 6.9-6.9 6.9c-1.8 0-3.5-.7-4.7-1.9L16.8 225.9c-.5-.5-.8-1.2-.8-1.9s.3-1.4 .8-1.9L164.4 81.9c1.3-1.2 3-1.9 4.7-1.9c3.8 0 6.9 3.1 6.9 6.9l0 89.1c0 8.8 7.2 16 16 16l208 0c53 0 96 43 96 96l0 152c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24l0-152c0-17.7-14.3-32-32-32l-208 0c-8.8 0-16 7.2-16 16zM5.8 237.5L153.4 377.7c4.3 4 9.9 6.3 15.8 6.3c12.6 0 22.9-10.2 22.9-22.9l0-73.1 0-16 16 0 192 0c8.8 0 16 7.2 16 16l0 152c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-152c0-61.9-50.1-112-112-112l-192 0-16 0 0-16 0-73.1C192 74.2 181.8 64 169.1 64c-5.9 0-11.5 2.3-15.8 6.3L5.8 210.5C2.1 214 0 218.9 0 224s2.1 10 5.8 13.5z'
      
    ]
  };

  

  
  

  var faCircleCaretRight = {
    prefix: 'fat',
    iconName: 'circle-caret-right',
    icon: [
      512,
      512,
      ["caret-circle-right"],
      'f330',
      
      'M496 256A240 240 0 1 1 16 256a240 240 0 1 1 480 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm352 0c0-7.3-3-14.3-8.4-19.3L234.4 134.8c-4.7-4.4-10.8-6.8-17.2-6.8c-13.9 0-25.2 11.3-25.2 25.2l0 205.6c0 13.9 11.3 25.2 25.2 25.2c6.4 0 12.5-2.4 17.2-6.8L343.6 275.3c5.4-5 8.4-12 8.4-19.3zM208 153.2c0-5.1 4.1-9.2 9.2-9.2c2.3 0 4.6 .9 6.3 2.5L332.7 248.4c2.1 2 3.3 4.7 3.3 7.6s-1.2 5.6-3.3 7.6L223.5 365.5c-1.7 1.6-4 2.5-6.3 2.5c-5.1 0-9.2-4.1-9.2-9.2l0-205.6z'
      
    ]
  };

  
    var faCaretCircleRight = faCircleCaretRight;
  

  
  

  var faHands = {
    prefix: 'fat',
    iconName: 'hands',
    icon: [
      576,
      512,
      ["sign-language","signing"],
      'f2a7',
      
      'M560 136l0 90.5c0 56.5-29.9 108.8-78.6 137.5c-11.6 6.8-23.7 12-36.1 15.6c-1 5.9-2.2 11.8-3.8 17.6c16.5-4 32.6-10.4 47.9-19.4c53.6-31.5 86.5-89.1 86.5-151.3l0-90.5c0-22.1-17.9-40-40-40s-40 17.9-40 40l0 25.7L415.6 22.4C404.5 3.2 380-3.3 360.9 7.7c-7.8 4.5-13.5 11.2-16.8 18.9C333.1 7.5 308.6 1 289.5 12s-25.7 35.5-14.6 54.6c-8.3-1-17 .6-24.8 5.1c-19.1 11-25.7 35.5-14.6 54.6l1.6 2.8c5 .9 10 2.4 14.9 4.5l8.1 3.4-10.8-18.7c-6.6-11.5-2.7-26.2 8.8-32.8c11.5-6.6 26.1-2.7 32.8 8.8l0 0 42.5 73.7c9.6 4.4 18.7 9.5 27.3 15.3l-56-97 0 0-16-27.7c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8l16 27.7 0 0 64 110.9c2.2 3.8 7.1 5.1 10.9 2.9s5.1-7.1 2.9-10.9l-64-110.8 0 0c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8l95.4 165.2c1.8 3.1 5.5 4.7 9 3.7s5.9-4.1 5.9-7.7l0-55.5c0-13.3 10.7-24 24-24s24 10.7 24 24zM233.3 177.9l75.5 31.8C364.1 232.9 400 287 400 347c0 82.3-66.7 149-149 149H104c-13.3 0-24-10.7-24-24c0-13.2 10.7-24 24-24l0 0 96 0c4.4 0 8-3.6 8-8s-3.6-8-8-8H104l0 0H72c-13.3 0-24-10.7-24-24c0-13.2 10.7-24 24-24l0 0H200c4.4 0 8-3.6 8-8s-3.6-8-8-8H72l0 0H40c-13.3 0-24-10.7-24-24s10.7-24 24-24H72l0 0H200c4.4 0 8-3.6 8-8s-3.6-8-8-8H72l0 0c-13.3 0-24-10.7-24-24s10.7-24 24-24H255.5c3.8 0 7.1-2.7 7.8-6.4s-1.2-7.5-4.7-9l-44-18.5c-12.2-5.1-17.9-19.2-12.8-31.4s19.2-17.9 31.4-12.8zM72 448c-5 6.7-8 15-8 24c0 22.1 17.9 40 40 40H251c91.1 0 165-73.9 165-165c0-66.4-39.8-126.3-101-152.1l-75.5-31.8c-20.4-8.6-43.8 1-52.4 21.3s1 43.8 21.3 52.4l7.4 3.1H72c-22.1 0-40 17.9-40 40c0 9 3 17.3 8 24c-22.1 0-40 17.9-40 40s17.9 40 40 40c-5 6.7-8 15-8 24c0 22.1 17.9 40 40 40z'
      
    ]
  };

  
    var faSignLanguage = faHands;
  
    var faSigning = faHands;
  

  
  

  var faLifeRing = {
    prefix: 'fat',
    iconName: 'life-ring',
    icon: [
      512,
      512,
      [],
      'f1cd',
      
      'M420 431.3C377.1 471.4 319.4 496 256 496s-121.1-24.6-164-64.7l102-102c16.7 14.2 38.4 22.7 62 22.7s45.3-8.5 62-22.7l102 102zM431.3 420l-102-102c14.2-16.7 22.7-38.4 22.7-62s-8.5-45.3-22.7-62l102-102C471.4 134.9 496 192.6 496 256s-24.6 121.1-64.7 164zm11.3 11.3C485.6 385.5 512 323.8 512 256s-26.4-129.5-69.4-175.3l11.1-11.1c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L431.3 69.4C385.5 26.4 323.8 0 256 0S126.5 26.4 80.7 69.4L69.7 58.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L69.4 80.7C26.4 126.5 0 188.2 0 256s26.4 129.5 69.4 175.3L58.3 442.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l11.1-11.1C126.5 485.6 188.2 512 256 512s129.5-26.4 175.3-69.4l11.1 11.1c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-11.1-11.1zM420 80.7l-102 102c-16.7-14.2-38.4-22.7-62-22.7s-45.3 8.5-62 22.7L92 80.7C134.9 40.6 192.6 16 256 16s121.1 24.6 164 64.7zM182.7 318L80.7 420C40.6 377.1 16 319.4 16 256s24.6-121.1 64.7-164l102 102c-14.2 16.7-22.7 38.4-22.7 62s8.5 45.3 22.7 62zM176 256a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z'
      
    ]
  };

  

  
  

  var faMoneyBill1Wave = {
    prefix: 'fat',
    iconName: 'money-bill-1-wave',
    icon: [
      576,
      512,
      ["money-bill-wave-alt"],
      'f53b',
      
      'M16 112.5c0-11 13.2-22.1 28.4-17.9c84 22.9 167.6 1.6 246.3-18.5l0 0 0 0 0 0c4-1 8-2 12-3c83.9-21.3 162.6-38.8 240.7-9.6C553.1 67 560 77.2 560 89.7V399.5c0 11-13.2 22.1-28.4 17.9c-84-22.9-167.6-1.6-246.3 18.5c-4 1-8 2-12 3.1c-83.9 21.3-162.6 38.8-240.7 9.6C22.9 445 16 434.8 16 422.3V112.5zm-16 0V422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM384 256c0-59-40.4-112-96-112s-96 53-96 112s40.4 112 96 112s96-53 96-112zm-96 96c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96zM536 160c4.4 0 8-3.6 8-8s-3.6-8-8-8h-8c-30.9 0-56-25.1-56-56V80c0-4.4-3.6-8-8-8s-8 3.6-8 8v8c0 39.8 32.2 72 72 72h8zM32 208c0 4.4 3.6 8 8 8h8c39.8 0 72-32.2 72-72v-8c0-4.4-3.6-8-8-8s-8 3.6-8 8v8c0 30.9-25.1 56-56 56H40c-4.4 0-8 3.6-8 8zm504 88h-8c-39.8 0-72 32.2-72 72v8c0 4.4 3.6 8 8 8s8-3.6 8-8v-8c0-30.9 25.1-56 56-56h8c4.4 0 8-3.6 8-8s-3.6-8-8-8zM32 360c0 4.4 3.6 8 8 8h8c30.9 0 56 25.1 56 56v8c0 4.4 3.6 8 8 8s8-3.6 8-8v-8c0-39.8-32.2-72-72-72H40c-4.4 0-8 3.6-8 8zM272 200c-4.4 0-8 3.6-8 8s3.6 8 8 8h8v80H264c-4.4 0-8 3.6-8 8s3.6 8 8 8h24 24c4.4 0 8-3.6 8-8s-3.6-8-8-8H296V208c0-4.4-3.6-8-8-8H272z'
      
    ]
  };

  
    var faMoneyBillWaveAlt = faMoneyBill1Wave;
  

  
  

  var faEngine = {
    prefix: 'fat',
    iconName: 'engine',
    icon: [
      640,
      512,
      [],
      'e16e',
      
      'M416 72c0 4.4-3.6 8-8 8l-96 0v48h24 60.6c12.6 0 25 3.7 35.5 10.7L483.5 173c17.8 11.9 28.5 31.9 28.5 53.3V384c0 35.3-28.7 64-64 64H279.2c-15 0-29.5-5.2-41-14.8l-59-49.2H112c-26.5 0-48-21.5-48-48V264H16v80c0 4.4-3.6 8-8 8s-8-3.6-8-8V168c0-4.4 3.6-8 8-8s8 3.6 8 8v80H64V176c0-26.5 21.5-48 48-48h48H296V80l-96 0c-4.4 0-8-3.6-8-8s3.6-8 8-8H304 408c4.4 0 8 3.6 8 8zM80 248v16 72c0 17.7 14.3 32 32 32h67.2c3.7 0 7.4 1.3 10.2 3.7l59 49.2c8.6 7.2 19.5 11.1 30.7 11.1H448c26.5 0 48-21.5 48-48V226.3c0-16-8-31-21.4-39.9l-51.4-34.3c-7.9-5.3-17.1-8.1-26.6-8.1H336 304 160 112c-17.7 0-32 14.3-32 32v72zm176 8a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm96-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm16 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-240 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm384-64c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224c0-8.8-7.2-16-16-16H576zm-32 16c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H576c-17.7 0-32-14.3-32-32V224z'
      
    ]
  };

  

  
  

  var faTire = {
    prefix: 'fat',
    iconName: 'tire',
    icon: [
      512,
      512,
      [],
      'f631',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm304 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-40.1 63.5l0 80.3c57.7-3.2 106.3-40.2 126.3-91.6l-76.4-24.9c-9.2 19.4-27.8 33.5-50 36.2zm54.9-51.4L395.2 293c3.1-11.8 4.8-24.2 4.8-37c0-45-20.6-85.2-52.9-111.6l-47.2 65C312.3 221.1 320 237.6 320 256c0 4.1-.4 8.2-1.1 12.1zM334.1 135c-22.5-14.6-49.3-23-78.1-23s-55.6 8.5-78.1 23l38 52.3L225 200c9.2-5.1 19.7-8 31-8s21.8 2.9 31 8l47.1-65zm-169.2 9.4C132.6 170.8 112 211 112 256c0 12.8 1.7 25.2 4.8 37l76.4-24.9c-.8-3.9-1.1-8-1.1-12.1c0-18.4 7.7-34.9 20.1-46.6l-9.2-12.7-38-52.3zm33.2 138.9l-76.4 24.9c20 51.4 68.6 88.4 126.2 91.6l0-80.3c-22.1-2.8-40.7-16.8-49.8-36.2zM256 96a160 160 0 1 1 0 320 160 160 0 1 1 0-320z'
      
    ]
  };

  

  
  

  var faScannerGun = {
    prefix: 'fat',
    iconName: 'scanner-gun',
    icon: [
      576,
      512,
      ["scanner"],
      'f488',
      
      'M112 48c-53 0-96 43-96 96s43 96 96 96H253.4 272h32c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32H112zM81.1 251.7C34.3 238.3 0 195.1 0 144C0 82.1 50.1 32 112 32H304c26.5 0 48 21.5 48 48V208c0 26.5-21.5 48-48 48H262.5L144.4 454.9c-13.5 22.7-42.8 30.3-65.6 16.9L25.5 440.4C2.6 426.9-5 397.4 8.5 374.6L81.1 251.7zM243.9 256H112 97.1L22.2 382.7c-9 15.2-3.9 34.9 11.3 43.9L86.9 458c15.2 8.9 34.7 3.9 43.7-11.2L243.9 256zM424 32H568c4.4 0 8 3.6 8 8s-3.6 8-8 8H424c-4.4 0-8-3.6-8-8s3.6-8 8-8zm-8 56c0-4.4 3.6-8 8-8H568c4.4 0 8 3.6 8 8s-3.6 8-8 8H424c-4.4 0-8-3.6-8-8zm0 48c0-4.4 3.6-8 8-8H568c4.4 0 8 3.6 8 8s-3.6 8-8 8H424c-4.4 0-8-3.6-8-8zm8 56H568c4.4 0 8 3.6 8 8s-3.6 8-8 8H424c-4.4 0-8-3.6-8-8s3.6-8 8-8zm-8 88c0-4.4 3.6-8 8-8H568c4.4 0 8 3.6 8 8s-3.6 8-8 8H424c-4.4 0-8-3.6-8-8zm8 40H568c4.4 0 8 3.6 8 8s-3.6 8-8 8H424c-4.4 0-8-3.6-8-8s3.6-8 8-8zm-8 64c0-4.4 3.6-8 8-8H568c4.4 0 8 3.6 8 8s-3.6 8-8 8H424c-4.4 0-8-3.6-8-8zm8 80H568c4.4 0 8 3.6 8 8s-3.6 8-8 8H424c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  
    var faScanner = faScannerGun;
  

  
  

  var faAlignRight = {
    prefix: 'fat',
    iconName: 'align-right',
    icon: [
      448,
      512,
      [],
      'f038',
      
      'M440 56c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-4.4 0-8-3.6-8-8s3.6-8 8-8H440zm0 128c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H440zm8 136c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8s3.6-8 8-8H440c4.4 0 8 3.6 8 8zm-8 120c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H440z'
      
    ]
  };

  

  
  

  var faWindowFlip = {
    prefix: 'fat',
    iconName: 'window-flip',
    icon: [
      512,
      512,
      ["window-alt"],
      'f40f',
      
      'M448 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H448zm64 48c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96zm-96 48a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM304 128a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm-80 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  
    var faWindowAlt = faWindowFlip;
  

  
  

  var faInputText = {
    prefix: 'fat',
    iconName: 'input-text',
    icon: [
      640,
      512,
      [],
      'e1bf',
      
      'M64 80c-26.5 0-48 21.5-48 48V384c0 26.5 21.5 48 48 48H576c26.5 0 48-21.5 48-48V128c0-26.5-21.5-48-48-48H64zM0 128C0 92.7 28.7 64 64 64H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm160 32c3.2 0 6.2 2 7.4 5l72 176c1.7 4.1-.3 8.8-4.4 10.4s-8.8-.3-10.4-4.4l-14.3-35H109.7L95.4 347c-1.7 4.1-6.3 6-10.4 4.4s-6-6.3-4.4-10.4l72-176c1.2-3 4.2-5 7.4-5zm0 29.1L116.3 296h87.4L160 189.1zM272 168c0-4.4 3.6-8 8-8h52c28.7 0 52 23.3 52 52c0 15.7-6.9 29.7-17.9 39.2c19.8 7.4 33.9 26.4 33.9 48.8c0 28.7-23.3 52-52 52H280c-4.4 0-8-3.6-8-8V320 256 192 168zm16 24v56h44c19.9 0 36-16.1 36-36s-16.1-36-36-36H288v16zm44 72H288v56 16h60c19.9 0 36-16.1 36-36s-16.1-36-36-36H332z'
      
    ]
  };

  

  
  

  var faHandHoldingBox = {
    prefix: 'fat',
    iconName: 'hand-holding-box',
    icon: [
      576,
      512,
      [],
      'f47b',
      
      'M224 16H144c-17.7 0-32 14.3-32 32V208c0 17.7 14.3 32 32 32H432c17.7 0 32-14.3 32-32V48c0-17.7-14.3-32-32-32H352V136c0 2.9-1.5 5.5-4 6.9s-5.5 1.4-8 0l-52-29.7-52 29.7c-2.5 1.4-5.5 1.4-8 0s-4-4.1-4-6.9V16zm8-16H344h88c26.5 0 48 21.5 48 48V208c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48h88zm8 16V122.2l44-25.2c2.5-1.4 5.5-1.4 7.9 0l44 25.2V16H240zM555.3 345.8c-7.9-10.7-22.9-12.9-33.6-5.1L404.2 427.3c-4.1 3-9.1 4.7-14.2 4.7H268c-15.5 0-28-12.5-28-28s12.5-28 28-28h80c11 0 20-9 20-20s-9-20-20-20H193.7c-25.4 0-50.1 8.7-70 24.5L81 394.7c-4.3 3.4-9.5 5.3-15 5.3H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H66c1.8 0 3.6-.6 5-1.8L113.7 348c22.7-18.2 50.9-28 80-28H348c19.9 0 36 16.1 36 36s-16.1 36-36 36H268c-6.6 0-12 5.4-12 12s5.4 12 12 12H389.9c1.7 0 3.4-.5 4.7-1.6l117.6-86.6c17.8-13.1 42.8-9.3 55.9 8.5s9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H352.5c25.6 0 50.6-8.2 71.2-23.4l126.6-93.3c10.7-7.9 12.9-22.9 5.1-33.6z'
      
    ]
  };

  

  
  

  var faDungeon = {
    prefix: 'fat',
    iconName: 'dungeon',
    icon: [
      512,
      512,
      [],
      'f6d9',
      
      'M330.8 152.1c11.2 8.1 21 17.9 29.1 29.1c4.6 6.4 11.6 11.2 19.3 13.2c-3 7.4-3.3 15.8-1 23.4c3.8 12 5.8 24.9 5.8 38.2c0 9.6 4.2 18.1 10.8 24c-6.6 5.9-10.8 14.4-10.8 24v64c0 9.6 4.2 18.1 10.8 24c-6.6 5.9-10.8 14.4-10.8 24v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V416c0-9.6-4.2-18.1-10.8-24c6.6-5.9 10.8-14.4 10.8-24V304c0-9.6-4.2-18.1-10.8-24c6.6-5.9 10.8-14.4 10.8-24c0-31.9-5.8-62.4-16.5-90.6c-3.8-10-11.8-16.4-20.8-18.8c3.5-8.7 3.2-19-2.6-27.9C451.9 87 425 60.1 393.3 39.9c-9-5.7-19.2-6.1-27.9-2.6c-2.4-9.1-8.8-17.1-18.8-20.8C318.4 5.8 287.9 0 256 0s-62.4 5.8-90.6 16.5c-10 3.8-16.4 11.8-18.8 20.8c-8.7-3.5-19-3.2-27.9 2.6C87 60.1 60.1 87 39.9 118.7c-5.7 9-6.1 19.2-2.6 27.9c-9.1 2.4-17.1 8.8-20.8 18.8C5.8 193.6 0 224.1 0 256c0 9.6 4.2 18.1 10.8 24C4.2 285.9 0 294.4 0 304v64c0 9.6 4.2 18.1 10.8 24C4.2 397.9 0 406.4 0 416v64c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V416c0-9.6-4.2-18.1-10.8-24c6.6-5.9 10.8-14.4 10.8-24V304c0-9.6-4.2-18.1-10.8-24c6.6-5.9 10.8-14.4 10.8-24c0-13.3 2-26.2 5.8-38.2c2.4-7.6 2-16-1-23.4c7.7-2 14.7-6.8 19.3-13.2c8.1-11.2 17.9-21 29.1-29.1c6.4-4.6 11.2-11.6 13.2-19.3c7.4 3 15.8 3.3 23.4 1c12-3.8 24.9-5.8 38.2-5.8s26.2 2 38.2 5.8c7.6 2.4 16 2 23.4-1c2 7.7 6.8 14.7 13.2 19.3zm63.8 25.6l0 0c-7.6 3.8-16.7 .9-21.7-5.9c-9.1-12.6-20.1-23.6-32.7-32.7c-6.9-5-9.7-14.1-5.9-21.7l0 0L363 59.8c4-8.1 14-11.3 21.7-6.4c29.7 18.9 55 44.2 73.9 73.9c4.9 7.6 1.7 17.6-6.4 21.7l0 0-57.6 28.8 0 0zM393.5 213c-2.5-8.1 .7-17.1 8.3-21l0 0 57.6-28.8 0 0 0 0c8.1-4 18-.6 21.2 7.9c10 26.4 15.4 55 15.4 84.9c0 8.8-7.2 16-16 16H416c-8.8 0-16-7.2-16-16c0-15-2.3-29.4-6.5-43zM416 400h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H416c-8.8 0-16-7.2-16-16V416c0-8.8 7.2-16 16-16zM340.9 31.4c8.5 3.2 11.9 13.1 7.9 21.2l0 0-28.8 57.6c-3.8 7.6-12.9 10.8-21 8.3c-13.6-4.2-28-6.5-43-6.5s-29.4 2.3-43 6.5c-8.1 2.5-17.2-.7-21-8.3L163.3 52.6l0 0c-4-8.1-.6-18 7.9-21.2c26.4-10 55-15.4 84.9-15.4s58.5 5.5 84.9 15.4zM127.3 53.4c7.6-4.9 17.6-1.7 21.7 6.4l28.8 57.6 0 0c3.8 7.6 .9 16.7-5.9 21.7c-12.6 9.1-23.6 20.1-32.7 32.7c-5 6.9-14.1 9.7-21.7 5.9l0 0L59.8 149l0 0c-8.1-4.1-11.3-14-6.4-21.7c18.9-29.7 44.2-55 73.9-73.9zM52.6 163.3l57.6 28.8c7.6 3.8 10.8 12.9 8.3 21c-4.2 13.6-6.5 28-6.5 43c0 8.8-7.2 16-16 16H32c-8.8 0-16-7.2-16-16c0-29.9 5.5-58.5 15.4-84.9c3.2-8.5 13.1-11.9 21.2-7.9l0 0zM32 288H96c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H32c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16zm368 16c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H416c-8.8 0-16-7.2-16-16V304zM16 416c0-8.8 7.2-16 16-16H96c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H32c-8.8 0-16-7.2-16-16V416zM264 184c0-4.4-3.6-8-8-8s-8 3.6-8 8V472c0 4.4 3.6 8 8 8s8-3.6 8-8V184zm-72 32c0-4.4-3.6-8-8-8s-8 3.6-8 8V472c0 4.4 3.6 8 8 8s8-3.6 8-8V216zm144 0c0-4.4-3.6-8-8-8s-8 3.6-8 8V472c0 4.4 3.6 8 8 8s8-3.6 8-8V216z'
      
    ]
  };

  

  
  

  var faRoadCircleExclamation = {
    prefix: 'fat',
    iconName: 'road-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e565',
      
      'M217.4 32C194 32 173 46.6 164.9 68.6L40.4 404.6C26.9 441.1 54 480 93 480H360.2c-4.2-5.1-8.1-10.4-11.8-16H328V420.6c-2-6.5-3.7-13.2-5-20c-.9-.4-1.9-.6-3-.6c-4.4 0-8 3.6-8 8v56H93c-27.9 0-47.2-27.8-37.5-53.9l124.4-336C185.7 58.4 200.7 48 217.4 48H312v56c0 4.4 3.6 8 8 8s8-3.6 8-8V48h94.6c16.7 0 31.7 10.4 37.5 26.1l43.7 118.1c6 .3 11.9 .8 17.7 1.7L475.1 68.6C467 46.6 446 32 422.6 32H217.4zM328 200c0-4.4-3.6-8-8-8s-8 3.6-8 8V312c0 4.4 3.6 8 8 8s8-3.6 8-8V200zm40 168a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 448a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-168c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8s8-3.6 8-8V288c0-4.4-3.6-8-8-8z'
      
    ]
  };

  

  
  

  var faPaperPlane = {
    prefix: 'fat',
    iconName: 'paper-plane',
    icon: [
      512,
      512,
      [61913],
      'f1d8',
      
      'M403.7 477.5L289.5 429.9l-37.7 65.9c-7.2 12.6-22 18.8-36 15.1s-23.8-16.4-23.8-30.9V389.3L19.7 317.5C8.4 312.8 .8 302.2 .1 290s5.5-23.7 16.1-29.8l7.9 13.9c-5.3 3-8.4 8.8-8 14.9s4.2 11.4 9.8 13.8l168.9 70.4L479.6 16c-2.6 .1-5.2 .8-7.6 2.1l-448 256-7.9-13.9 448-256c8.3-4.7 18-5.5 26.7-2.3c2.5 .9 5 2.2 7.3 3.7c1.3 .9 2.5 1.8 3.6 2.8c.9 .8 1.7 1.6 2.4 2.5c6.1 7 9 16.5 7.5 25.9l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6zm-193.6-98l85.5 35.6c0 0 0 0 .1 0l114.2 47.6c4.5 1.9 9.7 1.6 14-.8s7.2-6.7 8-11.5l64-416c.6-3.7-.2-7.4-2-10.5L210.1 379.5zM208 396v84c0 7.3 4.9 13.6 11.9 15.5s14.4-1.2 18-7.5l36.7-64.2L208 396z'
      
    ]
  };

  

  
  

  var faColumns3 = {
    prefix: 'fat',
    iconName: 'columns-3',
    icon: [
      640,
      512,
      [],
      'e361',
      
      'M448 48V464H576c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H448zm-16 0H208V464H432V48zM192 464V48H64C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H192zM0 96C0 60.7 28.7 32 64 32H576c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z'
      
    ]
  };

  

  
  

  var faRightLeft = {
    prefix: 'fat',
    iconName: 'right-left',
    icon: [
      512,
      512,
      ["exchange-alt"],
      'f362',
      
      'M383.9 50.1l108.9 87.1c2.1 1.6 3.2 4.1 3.2 6.8s-1.2 5.1-3.2 6.8L383.9 237.9c-1.7 1.4-3.9 2.1-6.1 2.1c-5.4 0-9.8-4.4-9.8-9.8V144 57.8c0-5.4 4.4-9.8 9.8-9.8c2.2 0 4.4 .8 6.1 2.1zM352 152v78.2c0 14.2 11.5 25.8 25.8 25.8c5.9 0 11.5-2 16.1-5.6l108.9-87.1c5.8-4.7 9.2-11.8 9.2-19.2s-3.4-14.6-9.2-19.2L393.9 37.6C389.3 34 383.6 32 377.8 32C363.5 32 352 43.5 352 57.8V136H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H352zM144 281.8V368v86.2c0 5.4-4.4 9.8-9.8 9.8c-2.2 0-4.4-.8-6.1-2.1L19.2 374.8c-2.1-1.6-3.2-4.1-3.2-6.8s1.2-5.1 3.2-6.8l108.9-87.1c1.7-1.4 3.9-2.1 6.1-2.1c5.4 0 9.8 4.4 9.8 9.8zM160 360V281.8c0-14.2-11.5-25.8-25.8-25.8c-5.9 0-11.5 2-16.1 5.6L9.2 348.8C3.4 353.4 0 360.5 0 368s3.4 14.6 9.2 19.2l108.9 87.1c4.6 3.7 10.2 5.6 16.1 5.6c14.2 0 25.8-11.5 25.8-25.8V376H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H160z'
      
    ]
  };

  
    var faExchangeAlt = faRightLeft;
  

  
  

  var faMessageDollar = {
    prefix: 'fat',
    iconName: 'message-dollar',
    icon: [
      512,
      512,
      ["comment-alt-dollar"],
      'f650',
      
      'M176 416c0-8.8-7.2-16-16-16H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H309.3c-3.5 0-6.8 1.1-9.6 3.2L176 496V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h80 16v16 64c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM264 112c0-4.4-3.6-8-8-8s-8 3.6-8 8v16.4c-8.4 .7-16.2 2.6-23 5.7c-12.4 5.6-21.9 15.4-24.2 28.8c-1.4 8.2-.6 15.4 2.4 21.8c3 6.3 7.8 11 13.2 14.7c10 6.8 23.7 10.9 35.9 14.6l1.7 .5c13.4 4 25 7.8 32.9 13.5c3.7 2.7 6.3 5.7 7.7 9c1.4 3.3 2.1 7.6 1.1 13.5c-1.4 8.2-6.5 14.1-15.1 17.8c-8.8 3.8-21.1 5-35.4 2.7c-7.1-1.2-19.2-5.3-28.8-8.5l0 0 0 0 0 0c-2.1-.7-4-1.4-5.7-1.9c-4.2-1.4-8.7 .9-10.1 5.1s.9 8.7 5.1 10.1c1.4 .5 3.1 1 5 1.7l0 0 0 0c9.4 3.2 23.4 8 32 9.4l0 0c1.8 .3 3.7 .5 5.5 .7V304c0 4.4 3.6 8 8 8s8-3.6 8-8V287.9c8.3-.5 16-2.1 22.7-5c12.6-5.4 22.1-15.4 24.5-29.7c1.5-8.5 .7-16-2.1-22.6c-2.9-6.6-7.5-11.6-13-15.5c-10.5-7.6-24.9-12-37.6-15.8l-.3-.1 0 0c-13.4-4-25-7.5-32.9-12.9c-3.8-2.6-6.3-5.3-7.7-8.3c-1.4-2.9-2.1-6.8-1.1-12.2c1.2-6.8 6.2-12.9 15.1-17c9-4.1 21.4-5.7 35.4-3.5c4.5 .7 18.5 3.4 22.9 4.6c4.3 1.1 8.7-1.4 9.8-5.7s-1.4-8.7-5.7-9.8c-5.2-1.4-19.8-4.2-24.6-4.9c-1.8-.3-3.7-.5-5.5-.7V112z'
      
    ]
  };

  
    var faCommentAltDollar = faMessageDollar;
  

  
  

  var faGridHorizontal = {
    prefix: 'fat',
    iconName: 'grid-horizontal',
    icon: [
      448,
      512,
      [],
      'e307',
      
      'M40 144c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V168c0-13.3-10.7-24-24-24H40zM0 168c0-22.1 17.9-40 40-40H88c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V168zM40 304c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V328c0-13.3-10.7-24-24-24H40zM0 328c0-22.1 17.9-40 40-40H88c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V328zM248 144H200c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V168c0-13.3-10.7-24-24-24zm-48-16h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V168c0-22.1 17.9-40 40-40zm0 176c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V328c0-13.3-10.7-24-24-24H200zm-40 24c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V328zM408 144H360c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V168c0-13.3-10.7-24-24-24zm-48-16h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V168c0-22.1 17.9-40 40-40zm0 176c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V328c0-13.3-10.7-24-24-24H360zm-40 24c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V328z'
      
    ]
  };

  

  
  

  var faCircleO = {
    prefix: 'fat',
    iconName: 'circle-o',
    icon: [
      512,
      512,
      [],
      'e119',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM368 256a112 112 0 1 1 -224 0 112 112 0 1 1 224 0zM256 128a128 128 0 1 0 0 256 128 128 0 1 0 0-256z'
      
    ]
  };

  

  
  

  var faScannerKeyboard = {
    prefix: 'fat',
    iconName: 'scanner-keyboard',
    icon: [
      512,
      512,
      [],
      'f489',
      
      'M136 0c-4.4 0-8 3.6-8 8V56c0 4.4 3.6 8 8 8s8-3.6 8-8V8c0-4.4-3.6-8-8-8zM264 0c-4.4 0-8 3.6-8 8V56c0 4.4 3.6 8 8 8s8-3.6 8-8V8c0-4.4-3.6-8-8-8zM384 8V280c0 4.4 3.6 8 8 8s8-3.6 8-8V8c0-4.4-3.6-8-8-8s-8 3.6-8 8zm64 0V280c0 4.4 3.6 8 8 8s8-3.6 8-8V8c0-4.4-3.6-8-8-8s-8 3.6-8 8zM320 8V56c0 4.4 3.6 8 8 8s8-3.6 8-8V8c0-4.4-3.6-8-8-8s-8 3.6-8 8zM192 8V56c0 4.4 3.6 8 8 8s8-3.6 8-8V8c0-4.4-3.6-8-8-8s-8 3.6-8 8zM504 0c-4.4 0-8 3.6-8 8V280c0 4.4 3.6 8 8 8s8-3.6 8-8V8c0-4.4-3.6-8-8-8zM288 112c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V160c0-26.5 21.5-48 48-48H288zM64 96C28.7 96 0 124.7 0 160V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H64zm40 80H248c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V200c0-13.3 10.7-24 24-24zM64 200v16c0 22.1 17.9 40 40 40H248c22.1 0 40-17.9 40-40V200c0-22.1-17.9-40-40-40H104c-22.1 0-40 17.9-40 40zM96 400h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16zM64 416c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zm192-16c8.8 0 16 7.2 16 16s-7.2 16-16 16H224c-8.8 0-16-7.2-16-16s7.2-16 16-16h32zm-32-16c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H224zM96 304h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16zM64 320c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zm192-16c8.8 0 16 7.2 16 16s-7.2 16-16 16H224c-8.8 0-16-7.2-16-16s7.2-16 16-16h32zm-32-16c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H224z'
      
    ]
  };

  

  
  

  var faHillRockslide = {
    prefix: 'fat',
    iconName: 'hill-rockslide',
    icon: [
      576,
      512,
      [],
      'e508',
      
      'M160 40a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm40 24a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zm45.4 59.8c-4.1-7.3-4.1-16.2 0-23.5l27-48c4.3-7.6 12.2-12.2 20.9-12.2l53.3 0c8.7 0 16.7 4.7 20.9 12.2l27 48c4.1 7.3 4.1 16.2 0 23.5l-27 48c-4.3 7.6-12.2 12.2-20.9 12.2H293.4c-8.7 0-16.7-4.7-20.9-12.2l-27-48zm13.9-15.7c-1.4 2.4-1.4 5.4 0 7.8l27 48c1.4 2.5 4.1 4.1 7 4.1h53.3c2.9 0 5.6-1.6 7-4.1l27-48c1.4-2.4 1.4-5.4 0-7.8l-27-48c-1.4-2.5-4.1-4.1-7-4.1l-53.3 0c-2.9 0-5.6 1.6-7 4.1l-27 48zM29.7 97c-5-5-13.7-1.5-13.7 5.7V456c0 22.1 17.9 40 40 40H409.4c7.1 0 10.7-8.6 5.7-13.7L29.7 97zM0 102.6c0-21.4 25.9-32.1 41-17L426.3 471c15.1 15.1 4.4 41-17 41H56c-30.9 0-56-25.1-56-56V102.6zM484.2 426.6l-48-27c-7.6-4.3-12.2-12.2-12.2-20.9V325.4c0-8.7 4.7-16.7 12.2-20.9l48-27c7.3-4.1 16.2-4.1 23.5 0l48 27c7.6 4.3 12.2 12.2 12.2 20.9v53.3c0 8.7-4.7 16.7-12.2 20.9l-48 27c-7.3 4.1-16.2 4.1-23.5 0zm15.7-13.9l48-27c2.5-1.4 4.1-4.1 4.1-7V325.4c0-2.9-1.6-5.6-4.1-7l-48-27c-2.4-1.4-5.4-1.4-7.8 0l-48 27c-2.5 1.4-4.1 4.1-4.1 7v53.3c0 2.9 1.6 5.6 4.1 7l48 27c2.4 1.4 5.4 1.4 7.8 0zM328 288a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 40a40 40 0 1 1 0-80 40 40 0 1 1 0 80z'
      
    ]
  };

  

  
  

  var faMaskFace = {
    prefix: 'fat',
    iconName: 'mask-face',
    icon: [
      640,
      512,
      [],
      'e1d7',
      
      'M320 80c24 0 47.5 7.1 67.5 20.4l37.1 24.8c18.4 12.3 40 18.8 62.1 18.8H512h16v16 64c0 51-18.4 97.8-48.9 134l-.8 .2 .1 .6C440.3 403.6 383.5 432 320 432s-120.3-28.4-158.4-73.2l.1-.6-.8-.2C130.4 321.8 112 275 112 224V160 144h16 8 17.2c22.1 0 43.7-6.5 62.1-18.8l37.1-24.8C272.5 87.1 296 80 320 80zM153.2 128H136h-8H112 96 40c-22.1 0-40 17.9-40 40v85c0 47.7 32.5 89.3 78.8 100.9l71.3 17.8 2 .5C193.1 418.7 253.1 448 320 448s126.9-29.3 167.9-75.7l2-.5 71.3-17.8C607.5 342.4 640 300.8 640 253V168c0-22.1-17.9-40-40-40H544 528 512 486.8c-19 0-37.5-5.6-53.3-16.1L396.4 87.1C373.8 72 347.2 64 320 64s-53.8 8-76.4 23.1l-37.1 24.8c-15.8 10.5-34.3 16.1-53.3 16.1zM40 144H96v16 64c0 47.5 14.8 91.5 40 127.7L82.7 338.4C43.5 328.6 16 293.4 16 253V168c0-13.3 10.7-24 24-24zM557.3 338.4L504 351.7c25.2-36.2 40-80.3 40-127.7V160 144h56c13.3 0 24 10.7 24 24v85c0 40.4-27.5 75.6-66.7 85.4zM208 192c-4.4 0-8 3.6-8 8s3.6 8 8 8H432c4.4 0 8-3.6 8-8s-3.6-8-8-8H208zm-8 72c0 4.4 3.6 8 8 8H432c4.4 0 8-3.6 8-8s-3.6-8-8-8H208c-4.4 0-8 3.6-8 8zm40 56c-4.4 0-8 3.6-8 8s3.6 8 8 8H400c4.4 0 8-3.6 8-8s-3.6-8-8-8H240z'
      
    ]
  };

  

  
  

  var faBottleDroplet = {
    prefix: 'fat',
    iconName: 'bottle-droplet',
    icon: [
      320,
      512,
      [],
      'e4c4',
      
      'M88 8c0-4.4 3.6-8 8-8l8 0V0h16 80 16V0l8 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-8 0V140.9c42.6 20.8 72 64.5 72 115.1V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V256c0-50.6 29.4-94.4 72-115.1V16l-8 0c-4.4 0-8-3.6-8-8zm112 8l-80 0V140.9c0 6.1-3.5 11.7-9 14.4C73.7 173.4 48 211.7 48 256V448c0 26.5 21.5 48 48 48H224c26.5 0 48-21.5 48-48V256c0-44.3-25.7-82.6-63-100.7c-5.5-2.7-9-8.3-9-14.4V16zm8 321c0-10.5-6.4-25.5-17.2-42.2c-10-15.4-22-29.8-30.8-39.5c-8.8 9.7-20.9 24.1-30.8 39.5C118.4 311.5 112 326.5 112 337c0 25.7 21.3 47 48 47c14.6 0 26.5-4.3 34.5-11.6c7.8-7.1 13.5-18.3 13.5-35.4zm16 0c0 42-28.7 63-64 63s-64-28.2-64-63c0-31 34.9-73.5 53.2-93.6c5.9-6.5 15.8-6.5 21.6 0C189.1 263.5 224 306 224 337z'
      
    ]
  };

  

  
  

  var faTurnDownRight = {
    prefix: 'fat',
    iconName: 'turn-down-right',
    icon: [
      512,
      512,
      [],
      'e455',
      
      'M336 240l0-89.1c0-3.8 3.1-6.9 6.9-6.9c1.8 0 3.5 .7 4.7 1.9L495.2 286.1c.5 .5 .8 1.2 .8 1.9s-.3 1.4-.8 1.9L347.6 430.1c-1.3 1.2-3 1.9-4.7 1.9c-3.8 0-6.9-3.1-6.9-6.9l0-89.1c0-8.8-7.2-16-16-16l-208 0c-53 0-96-43-96-96L16 72c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24l0 152c0 17.7 14.3 32 32 32l208 0c8.8 0 16-7.2 16-16zm170.2 34.5L358.6 134.3c-4.2-4-9.9-6.3-15.8-6.3c-12.6 0-22.9 10.2-22.9 22.9l0 73.1 0 16-16 0-192 0c-8.8 0-16-7.2-16-16L96 72c0-22.1-17.9-40-40-40L40 32C17.9 32 0 49.9 0 72L0 224c0 61.9 50.1 112 112 112l192 0 16 0 0 16 0 73.1c0 12.6 10.2 22.9 22.9 22.9c5.9 0 11.5-2.3 15.8-6.3L506.2 301.5c3.7-3.5 5.8-8.4 5.8-13.5s-2.1-10-5.8-13.5z'
      
    ]
  };

  

  
  

  var faFaceThinking = {
    prefix: 'fat',
    iconName: 'face-thinking',
    icon: [
      512,
      512,
      [],
      'e39b',
      
      'M256 16C123.5 16 16 123.5 16 256c0 36.9 8.3 71.9 23.2 103.1c1.9 4 .2 8.8-3.8 10.7s-8.8 .2-10.7-3.8C8.9 332.7 0 295.4 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256c-4.4 0-8-3.6-8-8s3.6-8 8-8c132.5 0 240-107.5 240-240S388.5 16 256 16zM139 130.9l-7.1 4c-3.8 2.2-8.7 .9-10.9-3s-.9-8.7 3-10.9l7.1-4c32.3-18.5 72.7-14.6 100.9 9.6l13.2 11.3c3.4 2.9 3.7 7.9 .9 11.3s-7.9 3.7-11.3 .9l-13.2-11.3c-23.1-19.8-56.2-22.9-82.6-7.8zM176.4 176a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm17.6 88.2l81.4 20.4c30.5 7.6 52 34.7 52.6 66c.6 16.9-9.6 33-26.3 39l-42.8 15.6-23.5 64.7c-9.2 25.3-33.2 42.1-60.1 42.1H128c-35.3 0-64-28.7-64-64V328c0-22.1 17.9-40 40-40s40 17.9 40 40v33.8l130.3-47.4c6.7-2.4 13.7-3 20.3-1.9c-6.4-5.9-14.3-10.2-23.1-12.4l-81.4-20.4c-4.3-1.1-6.9-5.4-5.8-9.7s5.4-6.9 9.7-5.8zm118.1 87c-.1-2.5-.5-5-1.4-7.4c-4.5-12.5-18.3-18.9-30.8-14.4L138.7 380.7c-2.5 .9-5.2 .5-7.3-1s-3.4-3.9-3.4-6.6V328c0-13.3-10.7-24-24-24s-24 10.7-24 24V448c0 26.5 21.5 48 48 48h47.2c20.2 0 38.2-12.6 45.1-31.6l24.8-68.2c.8-2.2 2.6-4 4.8-4.8l46.3-16.8C306 371 312 361.8 312 352h0c0-.3 0-.5 0-.8zM320.4 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faShare = {
    prefix: 'fat',
    iconName: 'share',
    icon: [
      512,
      512,
      ["mail-forward"],
      'f064',
      
      'M288 144c8.8 0 16-7.2 16-16V64c0-6.3 3.7-12 9.5-14.6s12.5-1.5 17.2 2.7l160 144c3.4 3 5.3 7.4 5.3 11.9s-1.9 8.9-5.3 11.9l-160 144c-4.7 4.2-11.4 5.3-17.2 2.7s-9.5-8.3-9.5-14.6V288c0-8.8-7.2-16-16-16H192c-61.9 0-112 50.1-112 112c0 35.5 15.2 57.1 27.3 68.4c3.7 3.5 4.7 6.5 4.7 7.8c0 2.1-1.7 3.7-3.7 3.7c-.3 0-.5 0-.6 0C90.6 454.7 16 408.2 16 304c0-88.4 71.6-160 160-160H288zm0 160v48c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4s-19 16.6-19 29.2v48 16H272 176C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96h80 16v16z'
      
    ]
  };

  
    var faMailForward = faShare;
  

  
  

  var faDownLeft = {
    prefix: 'fat',
    iconName: 'down-left',
    icon: [
      384,
      512,
      [],
      'e16a',
      
      'M48 416c-8.8 0-16-7.2-16-16V164.3c0-11.2 9.1-20.3 20.3-20.3c5.4 0 10.5 2.1 14.3 5.9l75.7 75.7c3.1 3.1 8.2 3.1 11.3 0L290.3 89c5.7-5.7 13.5-9 21.7-9s15.9 3.2 21.7 9L359 114.4c5.7 5.7 9 13.5 9 21.7s-3.2 15.9-9 21.7L222.3 294.3c-1.5 1.5-2.3 3.5-2.3 5.7s.8 4.2 2.3 5.7l75.7 75.7c3.8 3.8 5.9 9 5.9 14.3c0 11.2-9.1 20.3-20.3 20.3H48zM16 400c0 17.7 14.3 32 32 32H283.7c20 0 36.3-16.2 36.3-36.3c0-9.6-3.8-18.9-10.6-25.7L239.3 300l131-131c8.7-8.7 13.7-20.6 13.7-33s-4.9-24.2-13.7-33L345 77.7C336.2 68.9 324.4 64 312 64s-24.2 4.9-33 13.7l-131 131L77.9 138.6c-6.8-6.8-16-10.6-25.7-10.6c-20 0-36.3 16.2-36.3 36.3V400z'
      
    ]
  };

  

  
  

  var faDatabase = {
    prefix: 'fat',
    iconName: 'database',
    icon: [
      448,
      512,
      [],
      'f1c0',
      
      'M432 432c0 4.5-2.5 11-11.9 18.9c-9.3 7.9-23.8 15.7-43.1 22.6C338.6 487.2 284.5 496 224 496s-114.6-8.8-153-22.5c-19.3-6.9-33.7-14.7-43.1-22.6C18.5 443 16 436.5 16 432V341.7c18.6 12 44.3 22 74.2 29.3c38.2 9.4 84.2 14.9 133.8 14.9s95.6-5.5 133.8-14.9c30-7.4 55.6-17.3 74.2-29.3V432zm0-234.3V322.1c-16.1 13.1-43.1 24.9-78.1 33.5c-36.8 9-81.5 14.4-129.9 14.4s-93.2-5.3-129.9-14.4c-35-8.6-61.9-20.4-78.1-33.5V197.7c18.6 12 44.3 22 74.2 29.3c38.2 9.4 84.2 14.9 133.8 14.9s95.6-5.5 133.8-14.9c30-7.4 55.6-17.3 74.2-29.3zm0-19.7c-16.1 13.1-43.1 24.9-78.1 33.5c-36.8 9-81.5 14.4-129.9 14.4s-93.2-5.3-129.9-14.4c-35-8.6-61.9-20.4-78.1-33.5V80c0-4.5 2.5-11 11.9-18.9C37.3 53.2 51.7 45.4 71 38.5C109.4 24.8 163.5 16 224 16s114.6 8.8 153 22.5c19.3 6.9 33.7 14.7 43.1 22.6C429.5 69 432 75.5 432 80v98.1zM448 432V80C448 35.8 347.7 0 224 0S0 35.8 0 80V432c0 44.2 100.3 80 224 80s224-35.8 224-80z'
      
    ]
  };

  

  
  

  var faNoteMedical = {
    prefix: 'fat',
    iconName: 'note-medical',
    icon: [
      448,
      512,
      [],
      'e200',
      
      'M384 48c26.5 0 48 21.5 48 48V316.1c0 1.3-.1 2.6-.2 3.9H336c-26.5 0-48 21.5-48 48v95.8c-1.3 .2-2.6 .2-3.9 .2H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H384zM306.7 454.6c-.9 .9-1.8 1.7-2.7 2.4V368c0-17.7 14.3-32 32-32h89.1c-.8 1-1.6 1.9-2.4 2.7L306.7 454.6zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H284.1c12.7 0 24.9-5.1 33.9-14.1L433.9 350.1c9-9 14.1-21.2 14.1-33.9V96c0-35.3-28.7-64-64-64H64zM200 136c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H256c-4.4 0-8 3.6-8 8v56c0 4.4-3.6 8-8 8H208c-4.4 0-8-3.6-8-8V256c0-4.4-3.6-8-8-8H136c-4.4 0-8-3.6-8-8V208c0-4.4 3.6-8 8-8h56c4.4 0 8-3.6 8-8V136zm8-24c-13.3 0-24 10.7-24 24v48H136c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h48v48c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V264h48c13.3 0 24-10.7 24-24V208c0-13.3-10.7-24-24-24H264V136c0-13.3-10.7-24-24-24H208z'
      
    ]
  };

  

  
  

  var faTriangleExclamation = {
    prefix: 'fat',
    iconName: 'triangle-exclamation',
    icon: [
      512,
      512,
      [9888,"exclamation-triangle","warning"],
      'f071',
      
      'M20.7 412.3c-3.1 5.3-4.7 11.2-4.7 17.3c0 19 15.4 34.4 34.4 34.4H461.6c19 0 34.4-15.4 34.4-34.4c0-6.1-1.6-12.1-4.7-17.3L290.3 67.7C283.2 55.5 270.1 48 256 48s-27.2 7.5-34.3 19.7L20.7 412.3zM6.9 404.2l201-344.6C217.9 42.5 236.2 32 256 32s38.1 10.5 48.1 27.6l201 344.6c4.5 7.7 6.9 16.5 6.9 25.4c0 27.8-22.6 50.4-50.4 50.4H50.4C22.6 480 0 457.4 0 429.6c0-8.9 2.4-17.7 6.9-25.4zM256 160c4.4 0 8 3.6 8 8V328c0 4.4-3.6 8-8 8s-8-3.6-8-8V168c0-4.4 3.6-8 8-8zM240 384a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  
    var faExclamationTriangle = faTriangleExclamation;
  
    var faWarning = faTriangleExclamation;
  

  
  

  var faSnake = {
    prefix: 'fat',
    iconName: 'snake',
    icon: [
      512,
      512,
      [128013],
      'f716',
      
      'M301.9 80h-9.3H172C103.5 80 48 135.5 48 204s55.5 124 124 124H348c28.7 0 52 23.3 52 52s-23.3 52-52 52H256.1h0l-.1 0 0 0-140.8 0c-10.6 0-21 2.1-30.8 6.2L22.4 464l62 25.8c9.7 4.1 20.2 6.2 30.8 6.2h60.7 0l.1 0h0H348c64.1 0 116-51.9 116-116s-51.9-116-116-116H172c-33.1 0-60-26.9-60-60s26.9-60 60-60H292.6h9.3l4.6 8.1 1.6 2.8c13.1 23 37.6 37.2 64 37.2c10.8 0 21.4-2.4 31.2-6.9L469 154.4c16.5-7.7 27-24.2 27-42.4s-10.5-34.7-27-42.4L403.3 38.9c-9.8-4.6-20.4-6.9-31.2-6.9c-26.5 0-50.9 14.2-64 37.2l-1.6 2.8L301.9 80zM176 512l-.1 0H115.2c-12.7 0-25.2-2.5-36.9-7.4L7.4 475.1C2.9 473.2 0 468.8 0 464s2.9-9.2 7.4-11.1l70.9-29.5c11.7-4.9 24.2-7.4 36.9-7.4H256l.1 0H348c19.9 0 36-16.1 36-36s-16.1-36-36-36H172C94.7 344 32 281.3 32 204S94.7 64 172 64H292.6l1.6-2.8c16-28 45.7-45.2 77.9-45.2c13.1 0 26.1 2.9 38 8.4l65.7 30.7C497.9 65.4 512 87.6 512 112s-14.1 46.6-36.2 56.9L410 199.6c-11.9 5.5-24.8 8.4-38 8.4c-32.2 0-61.9-17.3-77.9-45.2l-1.6-2.8H172c-24.3 0-44 19.7-44 44s19.7 44 44 44H348c72.9 0 132 59.1 132 132s-59.1 132-132 132H176zM352 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faHandcuffs = {
    prefix: 'fat',
    iconName: 'handcuffs',
    icon: [
      640,
      512,
      [],
      'e4f8',
      
      'M320 32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-64 8a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM184 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-8 48c0-8.8-7.2-16-16-16s-16 7.2-16 16H128c-17.7 0-32 14.3-32 32v29.3C39.5 230 0 286.4 0 352c0 88.4 71.6 160 160 160s160-71.6 160-160c0-65.6-39.5-122-96-146.7V176c0-17.7-14.3-32-32-32H176zm-48 16h32 32c8.8 0 16 7.2 16 16v23.3c-15.2-4.8-31.3-7.3-48-7.3s-32.8 2.6-48 7.3V176c0-8.8 7.2-16 16-16zm32 48a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM345.2 402.8c-2.1 7.6-4.6 15.1-7.6 22.3C364.2 476.7 418 512 480 512c88.4 0 160-71.6 160-160c0-65.6-39.5-122-96-146.7V176c0-17.7-14.3-32-32-32H496c0-8.8-7.2-16-16-16s-16 7.2-16 16H448c-17.7 0-32 14.3-32 32v29.3c-33.8 14.8-61.6 40.9-78.4 73.6c3 7.2 5.5 14.6 7.6 22.3C365.7 246.7 418.3 208 480 208c79.5 0 144 64.5 144 144s-64.5 144-144 144c-61.7 0-114.3-38.7-134.8-93.2zM432 176c0-8.8 7.2-16 16-16h32 32c8.8 0 16 7.2 16 16v23.3c-15.2-4.8-31.3-7.3-48-7.3s-32.8 2.6-48 7.3V176zM56 352a104 104 0 1 1 208 0A104 104 0 1 1 56 352zm224 0A120 120 0 1 0 40 352a120 120 0 1 0 240 0zM480 248a104 104 0 1 1 0 208 104 104 0 1 1 0-208zm0 224a120 120 0 1 0 0-240 120 120 0 1 0 0 240zM456 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM416 40a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faInhaler = {
    prefix: 'fat',
    iconName: 'inhaler',
    icon: [
      576,
      512,
      [],
      'f5f9',
      
      'M559.7 90.1c.6-2.1 .3-4.3-.8-6.1s-2.9-3.2-5-3.7l-128-32c-4.2-1.1-8.5 1.5-9.7 5.7l-16.4 60.7-13.1-13.1 14-51.8c3.4-12.6 16.3-20.2 29-17l128 32c6.3 1.6 11.6 5.6 14.9 11.2s4.1 12.2 2.4 18.4L533.2 248l-13-13L559.7 90.1zM519.3 301.9l-145-145-18.5 74.7C352.4 246 339.5 256 324.8 256H248c-22.1 0-40 17.9-40 40V424c0 22.1 17.9 40 40 40l190.9 0c21.7 0 40.7-14.6 46.4-35.5l34-126.5zm11.3-11.3c4 4 5.6 9.9 4.1 15.5l-34 126.5c-7.5 28-32.9 47.4-61.8 47.4L248 480c-30.9 0-56-25.1-56-56V296c0-30.9 25.1-56 56-56h76.8c7.4 0 13.8-5 15.5-12.2l18.5-74.7c3-12.1 18-16.3 26.8-7.5l145 145zM32 240a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16A32 32 0 1 1 0 256a32 32 0 1 1 64 0zm64 32a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM16 352a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM16 448a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z'
      
    ]
  };

  

  
  

  var faBookJournalWhills = {
    prefix: 'fat',
    iconName: 'book-journal-whills',
    icon: [
      448,
      512,
      ["journal-whills"],
      'f66a',
      
      'M0 56C0 25.1 25.1 0 56 0H408c22.1 0 40 17.9 40 40V376c0 19.4-13.7 35.5-32 39.2V496h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H56c-30.9 0-56-25.1-56-56V56zM56 416c-22.1 0-40 17.9-40 40s17.9 40 40 40H400V416H56zm-40 .8C26.2 406.4 40.3 400 56 400H408c13.3 0 24-10.7 24-24V40c0-13.3-10.7-24-24-24H56C33.9 16 16 33.9 16 56V416.8zM302.3 87.1C346.1 109.7 376 155.3 376 208c0 75.1-60.9 136-136 136s-136-60.9-136-136c0-52.7 30-98.3 73.7-120.9c3.3-1.7 7.3-.9 9.7 1.9s2.6 6.9 .5 9.9C180.4 109.3 176 122.1 176 136c0 17.3 6.9 33.1 18.1 44.6c2.7 2.8 3 7.2 .7 10.3C188 200.2 184 211.6 184 224c0 28.2 20.9 51.6 48 55.4V246.9l-11.6 7.7c-3.7 2.5-8.6 1.5-11.1-2.2s-1.5-8.6 2.2-11.1l14-9.3-14-9.3c-3.7-2.5-4.7-7.4-2.2-11.1s7.4-4.7 11.1-2.2l11.6 7.7V88c0-4.4 3.6-8 8-8s8 3.6 8 8V217.1l11.6-7.7c3.7-2.5 8.6-1.5 11.1 2.2s1.5 8.6-2.2 11.1l-14 9.3 14 9.3c3.7 2.5 4.7 7.4 2.2 11.1s-7.4 4.7-11.1 2.2L248 246.9v32.5c27.1-3.9 48-27.2 48-55.4c0-12.4-4-23.8-10.8-33.1c-2.3-3.1-2-7.5 .7-10.3C297.1 169.1 304 153.3 304 136c0-13.9-4.4-26.7-11.9-37.2c-2.1-3-2-7.1 .5-9.9s6.4-3.6 9.7-1.9zM168 224c0-13.6 3.8-26.3 10.3-37.1C166.9 173.1 160 155.3 160 136c0-6.7 .8-13.3 2.4-19.5c-15.2 12.9-27.1 29.4-34.4 48.3l21.6 21.6c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-15.5-15.5c-1.6 7.3-2.5 14.9-2.8 22.6l29.6 29.6c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-16.5-16.5C131.9 285.4 181 328 240 328s108.1-42.6 118.1-98.8l-16.5 16.5c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L360 204.7c-.2-7.7-1.1-15.3-2.8-22.6l-15.5 15.5c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L352 164.7c-7.3-18.9-19.2-35.4-34.4-48.3c1.6 6.3 2.4 12.8 2.4 19.5c0 19.3-6.9 37.1-18.3 50.9c6.5 10.8 10.3 23.5 10.3 37.1c0 39.8-32.2 72-72 72s-72-32.2-72-72z'
      
    ]
  };

  
    var faJournalWhills = faBookJournalWhills;
  

  
  

  var faBookOpen = {
    prefix: 'fat',
    iconName: 'book-open',
    icon: [
      576,
      512,
      [128214,128366],
      'f518',
      
      'M156 32c44.6 0 89.7 8.6 132 22.6C330.3 40.6 375.4 32 420 32c55.4 0 107.2 14.6 128.9 21.6C565.7 59 576 74.5 576 91.1V402.5c0 26.9-25.1 44.8-49 40.6c-18.5-3.2-51.3-7.2-99-7.2c-58.9 0-97.8 24.3-111.2 34.1c-7.7 5.7-17.9 9.9-29.3 9.9c-10.2 0-19.6-3.4-27-8.4C245.5 461.5 202 436 148 436c-45.2 0-80.1 4.4-100 7.7c-24 4-48-14.1-48-40.2V91.1C0 74.5 10.3 59 27.1 53.6C48.8 46.6 100.6 32 156 32zM280 68.8C239.9 55.8 197.6 48 156 48C103 48 53.1 62 32 68.8C22.2 72 16 81.1 16 91.1V403.5C16 419 30.4 430.5 45.4 428c20.6-3.4 56.4-8 102.6-8c58.7 0 105.4 27.5 121.4 38.3c3.2 2.1 6.8 3.8 10.6 4.8V68.8zm16 394c4.2-1.2 8-3.2 11.4-5.6c15-11.1 57.2-37.2 120.6-37.2c48.6 0 82.3 4.1 101.7 7.4c15.2 2.6 30.3-9 30.3-24.9V91.1c0-10-6.2-19.1-16-22.2C522.9 62 473 48 420 48c-41.6 0-83.9 7.8-124 20.8v394z'
      
    ]
  };

  

  
  

  var faChevronsRight = {
    prefix: 'fat',
    iconName: 'chevrons-right',
    icon: [
      512,
      512,
      ["chevron-double-right"],
      'f324',
      
      'M53.7 477.7l216-216c3.1-3.1 3.1-8.2 0-11.3l-216-216c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L252.7 256 42.3 466.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0zm192 0l216-216c3.1-3.1 3.1-8.2 0-11.3l-216-216c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L444.7 256 234.3 466.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0z'
      
    ]
  };

  
    var faChevronDoubleRight = faChevronsRight;
  

  
  

  var faCorner = {
    prefix: 'fat',
    iconName: 'corner',
    icon: [
      448,
      512,
      [],
      'e3fe',
      
      'M0 184c0-4.4 3.6-8 8-8H416c17.7 0 32 14.3 32 32V376c0 4.4-3.6 8-8 8s-8-3.6-8-8V208c0-8.8-7.2-16-16-16H8c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faBahtSign = {
    prefix: 'fat',
    iconName: 'baht-sign',
    icon: [
      320,
      512,
      [],
      'e0ac',
      
      'M136 0c-4.4 0-8 3.6-8 8V64H49.4C30.9 64 16 78.9 16 97.4V248v16V410.4C16 431.2 32.8 448 53.6 448H128v56c0 4.4 3.6 8 8 8s8-3.6 8-8V448h60c55.2 0 100-44.8 100-100c0-48.6-34.7-89.1-80.7-98.1C252.5 232.4 272 200.5 272 164c0-55.2-44.8-100-100-100H144V8c0-4.4-3.6-8-8-8zm-8 80V248H32V97.4C32 87.8 39.8 80 49.4 80H128zm16 168V80h28c46.4 0 84 37.6 84 84s-37.6 84-84 84H144zm-16 16V432H53.6C41.7 432 32 422.3 32 410.4V264h96zm16 168V264h28 32c46.4 0 84 37.6 84 84s-37.6 84-84 84H144z'
      
    ]
  };

  

  
  

  var faCowbell = {
    prefix: 'fat',
    iconName: 'cowbell',
    icon: [
      448,
      512,
      [],
      'f8b3',
      
      'M168 16H280c13.3 0 24 10.7 24 24V96H144V40c0-13.3 10.7-24 24-24zM128 40V96H112c-21.4 0-40.3 14.2-46.2 34.8l-64 224c-4.1 14.5-1.2 30.1 7.8 42.1S32.9 416 48 416H400c15.1 0 29.3-7.1 38.3-19.1s12-27.6 7.8-42.1l-64-224C376.3 110.2 357.4 96 336 96H320V40c0-22.1-17.9-40-40-40H168c-22.1 0-40 17.9-40 40zm8 72H312h24c14.3 0 26.8 9.5 30.8 23.2l64 224c2.8 9.7 .8 20-5.2 28.1s-15.5 12.7-25.5 12.7H48c-10 0-19.5-4.7-25.5-12.7s-8-18.4-5.2-28.1l64-224C85.2 121.5 97.7 112 112 112h24zm40 336c0-4.4-3.6-8-8-8s-8 3.6-8 8c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3c0-4.4-3.6-8-8-8s-8 3.6-8 8c0 12.7-5.1 24.9-14.1 33.9s-21.2 14.1-33.9 14.1s-24.9-5.1-33.9-14.1s-14.1-21.2-14.1-33.9z'
      
    ]
  };

  

  
  

  var faLightbulbDollar = {
    prefix: 'fat',
    iconName: 'lightbulb-dollar',
    icon: [
      384,
      512,
      [],
      'f670',
      
      'M352 176c0 33.9-10.5 65.3-28.5 91.2c-4.5 6.5-9.5 13.3-14.5 20.2c-12.5 17.2-25.9 35.5-36.3 54.4c-7.4 13.5-11.6 27.8-14 42.2H275c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8l0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0 0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5h16.2c-2.4-14.4-6.6-28.7-14-42.2c-10.4-19-23.7-37.3-36.3-54.4l0 0 0 0c-5-6.9-10-13.7-14.5-20.2C42.5 241.3 32 209.9 32 176C32 87.6 103.6 16 192 16s160 71.6 160 160zM128 432H256c0 35.3-28.7 64-64 64s-64-28.7-64-64zm-16 0c0 44.2 35.8 80 80 80s80-35.8 80-80v-5.3c0-5.9-4.8-10.7-10.7-10.7H122.7c-5.9 0-10.7 4.8-10.7 10.7V432zM200 96c0-4.4-3.6-8-8-8s-8 3.6-8 8v16.4c-8.4 .7-16.2 2.6-23 5.7c-12.4 5.6-21.9 15.4-24.2 28.8c-1.4 8.2-.6 15.4 2.4 21.8c3 6.3 7.8 11 13.2 14.7c10 6.8 23.7 10.9 35.9 14.6l1.7 .5c13.4 4 25 7.8 32.9 13.5c3.7 2.7 6.3 5.7 7.7 9c1.4 3.3 2.1 7.6 1.1 13.5c-1.4 8.2-6.5 14.1-15.1 17.8c-8.8 3.8-21.1 5-35.4 2.7c-7.1-1.2-19.2-5.3-28.8-8.5l0 0 0 0 0 0c-2.1-.7-4-1.4-5.7-1.9c-4.2-1.4-8.7 .9-10.1 5.1s.9 8.7 5.1 10.1c1.4 .5 3.1 1 5 1.7l0 0 0 0c9.4 3.2 23.4 8 32 9.4l0 0c1.8 .3 3.7 .5 5.5 .7V288c0 4.4 3.6 8 8 8s8-3.6 8-8l0-16.1c8.3-.5 16-2.1 22.7-5c12.6-5.4 22.1-15.4 24.5-29.7c1.5-8.5 .7-16-2.1-22.6c-2.9-6.6-7.5-11.6-13-15.5c-10.5-7.6-24.9-12-37.6-15.8l-.3-.1 0 0 0 0c-13.4-4-25-7.5-32.9-12.9c-3.8-2.6-6.3-5.3-7.7-8.3c-1.4-2.9-2.1-6.8-1.1-12.2c1.2-6.8 6.2-12.9 15.1-17c9-4.1 21.4-5.7 35.4-3.5c4.5 .7 18.5 3.4 22.9 4.6c4.3 1.1 8.7-1.4 9.8-5.7s-1.4-8.7-5.7-9.8c-5.2-1.4-19.8-4.2-24.6-4.9c-1.8-.3-3.7-.5-5.5-.7V96z'
      
    ]
  };

  

  
  

  var faTireRugged = {
    prefix: 'fat',
    iconName: 'tire-rugged',
    icon: [
      512,
      512,
      [],
      'f634',
      
      'M236.5 16c-17.5 0-32.1 13.6-33.3 31.1l-.1 1.1c-.2 3.4-2.6 6.3-5.8 7.2c-14.8 4.1-29 9.9-42.3 17c-2.9 1.6-6.6 1.2-9.1-1l-.5-.4 5.3-6-5.3 6c-13.2-11.6-33.1-10.9-45.5 1.5L72.5 100.1c-12.4 12.4-13.1 32.3-1.5 45.5l.4 .5c2.2 2.5 2.6 6.1 1 9.1c-7.2 13.3-12.9 27.4-17 42.3c-.9 3.3-3.8 5.6-7.2 5.8l-1.1 .1C29.6 204.4 16 219 16 236.5v38.9c0 17.5 13.6 32.1 31.1 33.3l3.5 .2c3.3 .2 6.1 2.4 7.1 5.5c4.4 13.7 10.2 26.8 17.3 39.1c1.7 3 1.3 6.7-.9 9.3L71 366.4c-11.6 13.2-10.9 33.1 1.5 45.5l27.5 27.5c12.4 12.4 32.3 13.1 45.5 1.5l6.2-5.4c2.4-2.1 5.9-2.6 8.9-1.1c11.5 5.8 23.6 10.5 36.2 14c3.3 .9 5.6 3.8 5.8 7.2l.6 9.3c1.2 17.5 15.7 31.1 33.3 31.1h38.9c17.5 0 32.1-13.6 33.3-31.1l.8-11.7c.2-3.3 2.4-6.1 5.5-7.1c11.6-3.7 22.6-8.5 33.2-14.2c2.9-1.6 6.5-1.2 9 1l9.2 8c13.2 11.6 33.1 10.9 45.5-1.5l27.5-27.5c12.4-12.4 13.1-32.3 1.5-45.5l-8-9.2c-2.2-2.5-2.6-6.1-1-9c5.6-10.5 10.4-21.6 14.1-33.2c1-3.1 3.8-5.3 7.1-5.5l11.7-.8c17.5-1.2 31.1-15.7 31.1-33.3V236.5c0-17.5-13.6-32.1-31.1-33.3l-9.3-.6c-3.4-.2-6.3-2.6-7.2-5.8c-3.5-12.6-8.2-24.7-14-36.2c-1.5-2.9-1-6.4 1.1-8.9l5.4-6.2c11.6-13.2 10.9-33.1-1.5-45.5L411.9 72.5c-12.4-12.4-32.3-13.1-45.5-1.5l-3.6 3.1c-2.6 2.3-6.3 2.6-9.3 .9c-12.3-7.1-25.4-12.9-39.1-17.3c-3.1-1-5.3-3.8-5.5-7.1l-.2-3.5C307.6 29.6 293 16 275.5 16H236.5zM187.8 41.5C191.6 17.8 212.1 0 236.5 0h38.9c25.4 0 46.5 19.2 49.1 44.2c11.1 3.9 21.8 8.6 32 14.2c19.5-16.5 48.5-15.3 66.7 2.8l27.5 27.5c18.4 18.4 19.3 47.8 2.2 67.4l-1.9 2.2c4.4 9.3 8.1 18.9 11.2 28.8l3.7 .2c25.9 1.7 46.1 23.3 46.1 49.2v38.9c0 26-20.1 47.5-46.1 49.2l-6.4 .4c-3.1 8.8-6.8 17.4-11 25.7l4.4 5.1c17.1 19.5 16.1 49-2.2 67.4l-27.5 27.5c-18.4 18.4-47.8 19.3-67.4 2.2l-5.1-4.4c-8.3 4.2-16.9 7.8-25.7 11l-.4 6.4C323 491.9 301.4 512 275.5 512H236.5c-26 0-47.5-20.1-49.2-46.1l-.2-3.7c-9.9-3.1-19.5-6.8-28.8-11.2l-2.2 1.9c-19.5 17.1-49 16.1-67.4-2.2L61.2 423.3c-18.2-18.2-19.3-47.1-2.8-66.7c-5.5-10.2-10.3-20.9-14.2-32C19.2 321.9 0 300.8 0 275.5V236.5c0-24.4 17.8-44.9 41.5-48.7c3.8-12.4 8.6-24.3 14.4-35.6C42.1 132.8 44 105.9 61.2 88.7L88.7 61.2c17.2-17.2 44.1-19.1 63.5-5.3c11.3-5.8 23.2-10.6 35.6-14.4zM112 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zM256 384a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-208a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-65.8 75.4a16 16 0 1 1 9.9-30.4 16 16 0 1 1 -9.9 30.4zM209 320.7a16 16 0 1 1 18.8-25.9A16 16 0 1 1 209 320.7zm97.6-22.3a16 16 0 1 1 -25.9 18.8 16 16 0 1 1 25.9-18.8zm25.5-67.1a16 16 0 1 1 -30.4 9.9 16 16 0 1 1 30.4-9.9z'
      
    ]
  };

  

  
  

  var faRectangleXmark = {
    prefix: 'fat',
    iconName: 'rectangle-xmark',
    icon: [
      512,
      512,
      [62164,"rectangle-times","times-rectangle","window-close"],
      'f410',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm178.3 82.3c3.1-3.1 8.2-3.1 11.3 0L256 244.7l66.3-66.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L267.3 256l66.3 66.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L256 267.3l-66.3 66.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L244.7 256l-66.3-66.3c-3.1-3.1-3.1-8.2 0-11.3z'
      
    ]
  };

  
    var faRectangleTimes = faRectangleXmark;
  
    var faTimesRectangle = faRectangleXmark;
  
    var faWindowClose = faRectangleXmark;
  

  
  

  var faHandBackPointRibbon = {
    prefix: 'fat',
    iconName: 'hand-back-point-ribbon',
    icon: [
      448,
      512,
      [],
      'e1a0',
      
      'M156 0c-28.7 0-52 23.3-52 52V64H32c-3.1 0-5.9 1.8-7.2 4.5s-1 6.1 1 8.5l28 35-28 35c-1.9 2.4-2.3 5.7-1 8.5s4.1 4.5 7.2 4.5h72v80 9.6c-6 3.7-11.8 7.8-17.3 12.5L57.5 286.7C41.3 300.4 32 320.5 32 341.7v24c0 48.8 26.2 93.9 68.5 118.1l18 10.3C139.1 505.8 162.3 512 186 512H328c57.4 0 104-46.6 104-104V392 308v-4c0-.8-.1-1.5-.3-2.2C428.5 271.5 403 248 372 248c-3.6 0-7.1 .3-10.5 .9C351.7 229.4 331.4 216 308 216c-6.1 0-12 .9-17.6 2.6C280.8 198.2 260.1 184 236 184c-10.1 0-19.6 2.5-28 6.9V152 72 52c0-28.7-23.3-52-52-52zm36 64H120V52c0-19.9 16.1-36 36-36s36 16.1 36 36V64zm0 16v64H48.6l21.6-27c2.3-2.9 2.3-7.1 0-10L48.6 80H192zm0 80v46.5c0 3.2 1.9 6.1 4.9 7.4s6.4 .6 8.7-1.6c7.9-7.6 18.6-12.2 30.5-12.2c19.9 0 36.7 13.2 42.1 31.3c.7 2.2 2.3 4.1 4.4 5s4.6 .9 6.7-.1c5.7-2.7 12-4.2 18.8-4.2c19 0 35.2 12.1 41.4 29c1.5 4 5.8 6.2 9.8 4.9c4-1.2 8.3-1.9 12.8-1.9c23.1 0 42.1 17.9 43.9 40.6c0 .3 .1 .6 .1 1V308v84 16c0 48.6-39.4 88-88 88H186c-20.9 0-41.4-5.4-59.5-15.8l-18-10.3C71.1 448.5 48 408.8 48 365.7v-24c0-16.5 7.3-32.1 19.8-42.7L97 274.2c2.3-1.9 4.6-3.7 7-5.5V344c0 4.4 3.6 8 8 8s8-3.6 8-8V254.2 240 160h72z'
      
    ]
  };

  

  
  

  var faCartFlatbedSuitcase = {
    prefix: 'fat',
    iconName: 'cart-flatbed-suitcase',
    icon: [
      640,
      512,
      ["luggage-cart"],
      'f59d',
      
      'M0 8C0 3.6 3.6 0 8 0H88c22.1 0 40 17.9 40 40V392c0 13.3 10.7 24 24 24h72H512 632c4.4 0 8 3.6 8 8s-3.6 8-8 8H547.8c7.6 8.5 12.2 19.7 12.2 32c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-12.3 4.6-23.5 12.2-32H259.8c7.6 8.5 12.2 19.7 12.2 32c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-12.3 4.6-23.5 12.2-32H152c-22.1 0-40-17.9-40-40V40c0-13.3-10.7-24-24-24H8c-4.4 0-8-3.6-8-8zM512 432a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM192 464a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM344 16c-13.3 0-24 10.7-24 24V80H448V40c0-13.3-10.7-24-24-24H344zM464 80h48c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V144c0-35.3 28.7-64 64-64h48V40c0-22.1 17.9-40 40-40h80c22.1 0 40 17.9 40 40V80zm0 16H448 320 304 288V336H480V96H464zM272 96H256c-26.5 0-48 21.5-48 48V288c0 26.5 21.5 48 48 48h16V96zM496 336h16c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H496V336z'
      
    ]
  };

  
    var faLuggageCart = faCartFlatbedSuitcase;
  

  
  

  var faEarthEurope = {
    prefix: 'fat',
    iconName: 'earth-europe',
    icon: [
      512,
      512,
      ["globe-europe"],
      'f7a2',
      
      'M256 496C123.5 496 16 388.5 16 256S123.5 16 256 16c14.9 0 29.5 1.4 43.6 4L228.8 67.2c-8 5.3-12.8 14.4-12.8 24v8.6c0 11.2 9.1 20.3 20.3 20.3c4 0 7.9-1.2 11.2-3.4l41.8-27.9c.7-.5 1.5-.7 2.4-.7h1c1.8 0 3.3 1.5 3.3 3.3c0 .9-.3 1.7-1 2.3l-19.9 19.9c-4.9 4.9-10.9 8.6-17.5 10.8l-26.5 8.8c-9 3-15.1 11.5-15.1 21c0 1.6-.6 3.2-1.8 4.3l-17.9 17.9c-7.9 7.9-12.3 18.5-12.3 29.7v4.3c0 20.9 17.2 37.7 37.9 37.7c13.9 0 26.9-7.9 33.2-20.4l4-8.1c1.1-2.1 3.3-3.5 5.6-3.5c2 0 3.9 .9 5 2.5l16.3 21.7c3.7 4.9 9.4 7.7 15.5 7.7c14.4 0 23.7-15.1 17.3-28l-2.2-4.3c-1.4-2.8-.5-6.3 2.1-8.1l33-22c4.1-2.7 7.4-6.5 9.6-10.9c2.1-4.1 6.3-6.8 11-6.8H400c4.4 0 8 3.6 8 8s-3.6 8-8 8H379.3c-9.4 0-18.3 3.7-25 10.3l-4.7 4.7c-3.6 3.6-5.7 8.5-5.7 13.7c0 10.7 8.6 19.3 19.3 19.3h11.3c3.9 0 7.6 1.5 10.3 4.3l6.5 6.5c.3 .3 .5 .7 .5 1.2s-.2 .9-.5 1.2l-7.5 7.5c-5.1 5.1-8 12.1-8 19.3s2.9 14.2 8 19.3l18.3 18.3C414.1 321.4 430 328 446.6 328H485c-6.8 21.7-16.7 42.1-29 60.7V374.6c0-16.9-13.7-30.6-30.6-30.6c-3.9 0-7.6-1.5-10.3-4.3l-13.4-13.4c-9.2-9.2-21.6-14.3-34.5-14.3c-7.8 0-15.4-2.8-21.4-7.9l-26.6-22.8c-13-11.2-29.7-17.3-46.9-17.3H251.4c-14.2 0-28.1 4.2-39.9 12.1l-27.4 18.3c-20 13.4-32.1 35.8-32.1 59.9v3.2c0 19.1 7.6 37.4 21.1 50.9l16 16c10 10 23.5 15.6 37.7 15.6c20.6 0 37.3 16.7 37.3 37.3v18.6c-2.7 .1-5.3 .1-8 .1zm24-18.7c0-29.4-23.8-53.3-53.3-53.3c-9.9 0-19.4-3.9-26.3-10.9l-16-16c-10.5-10.5-16.4-24.7-16.4-39.6v-3.2c0-18.7 9.4-36.2 24.9-46.6l27.4-18.3c9.2-6.1 20-9.4 31.1-9.4h20.9c13.4 0 26.3 4.8 36.4 13.5l26.6 22.8c8.8 7.6 20.1 11.8 31.8 11.8c8.7 0 17 3.5 23.2 9.6L403.7 351c5.7 5.7 13.5 9 21.7 9c8.1 0 14.6 6.6 14.6 14.6v35.5c-39.2 46.8-95.9 78.4-160 84.7V477.3zM256 512c80.8 0 152.9-37.5 199.9-96h.1v-.2c35-43.8 56-99.4 56-159.8C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM446.6 312c-12.4 0-24.2-4.9-33-13.7L395.3 280c-2.1-2.1-3.3-5-3.3-8s1.2-5.9 3.3-8l7.5-7.5c3.3-3.3 5.2-7.8 5.2-12.5s-1.9-9.2-5.2-12.5l-6.5-6.5c-5.7-5.7-13.5-9-21.7-9H363.3c-1.8 0-3.3-1.5-3.3-3.3c0-.9 .3-1.7 1-2.3l4.7-4.7c3.6-3.6 8.5-5.7 13.7-5.7H400c13.3 0 24-10.7 24-24s-10.7-24-24-24H372.5c-10.7 0-20.5 6-25.3 15.6c-1 1.9-2.4 3.5-4.2 4.7l-33 22c-9.4 6.2-12.6 18.5-7.6 28.5l2.2 4.3c1.1 2.2-.5 4.8-3 4.8c-1 0-2-.5-2.7-1.3l-16.3-21.7c-4.2-5.6-10.8-8.9-17.8-8.9c-8.5 0-16.2 4.8-20 12.3l-4 8.1c-3.5 7-10.9 11.6-18.9 11.6c-12.1 0-21.9-9.8-21.9-21.7v-4.3c0-6.9 2.7-13.5 7.6-18.3l17.9-17.9c4.1-4.1 6.5-9.8 6.5-15.6c0-2.6 1.7-5 4.2-5.8l26.5-8.8c9-3 17.1-8 23.8-14.7L306.3 105c3.6-3.6 5.7-8.5 5.7-13.7c0-10.7-8.6-19.3-19.3-19.3h-1c-4 0-7.9 1.2-11.2 3.4l-41.8 27.9c-.7 .5-1.5 .7-2.4 .7c-2.4 0-4.3-1.9-4.3-4.3V91.2c0-4.3 2.1-8.3 5.7-10.7L321 24.9C422 53.3 496 146 496 256c0 19.3-2.3 38-6.6 56H446.6zm-265-194.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-32 32c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l32-32z'
      
    ]
  };

  
    var faGlobeEurope = faEarthEurope;
  

  
  

  var faPrintSlash = {
    prefix: 'fat',
    iconName: 'print-slash',
    icon: [
      640,
      512,
      [],
      'f686',
      
      'M576 256c0-35.3-28.7-64-64-64H355.1l20.3 16H512c26.5 0 48 21.5 48 48v97.7l16 12.6V256zM123 192.2c-33 2.6-59 30.1-59 63.8V384c0 17.7 14.3 32 32 32h32v64c0 17.7 14.3 32 32 32H480c11.8 0 22.2-6.4 27.7-16H480 160c-8.8 0-16-7.2-16-16V352c0-8.8 7.2-16 16-16H305.1l-20.3-16H160c-17.7 0-32 14.3-32 32v48H96c-8.8 0-16-7.2-16-16V256c0-26.5 21.5-48 48-48h15l-20-15.8zM192 0c-20.1 0-38.1 9.3-49.8 23.9l12.6 9.9C163.5 22.9 176.9 16 192 16H421.5c12.7 0 24.9 5.1 33.9 14.1l26.5 26.5c9 9 14.1 21.2 14.1 33.9V160h16V90.5c0-17-6.7-33.3-18.7-45.3L466.7 18.7C454.7 6.7 438.5 0 421.5 0H192zM512 272a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  

  
  

  var faRug = {
    prefix: 'fat',
    iconName: 'rug',
    icon: [
      640,
      512,
      [],
      'e569',
      
      'M0 72c0-4.4 3.6-8 8-8H32h8 8H592h8 8 24c4.4 0 8 3.6 8 8s-3.6 8-8 8H608v80h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H608v72h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H608v72h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H608v80h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H608h-8-8H48 40 32 8c-4.4 0-8-3.6-8-8s3.6-8 8-8H32V352H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H32V264H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H32V176H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H32V80H8c-4.4 0-8-3.6-8-8zm48 96v88 88 88h80V80H48v88zm96 264H496V80H144V432zM512 80V432h80V344 256 168 80H512z'
      
    ]
  };

  

  
  

  var faUserTag = {
    prefix: 'fat',
    iconName: 'user-tag',
    icon: [
      640,
      512,
      [],
      'f507',
      
      'M112 128a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm240 0A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM16 482.3C16 392.7 88.7 320 178.3 320h91.4c17.6 0 34.5 2.8 50.3 7.9V311.2c-15.9-4.7-32.8-7.2-50.3-7.2H178.3C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c10 0 18.8-4.9 24.2-12.5l-11.7-11.7c-2.1 4.8-6.9 8.1-12.5 8.1H29.7c-7.6 0-13.7-6.1-13.7-13.7zM384 240h82.7c12.7 0 24.9 5.1 33.9 14.1L608 361.4c12.5 12.5 12.5 32.8 0 45.3L534.6 480c-12.5 12.5-32.8 12.5-45.3 0L382.1 372.7c-9-9-14.1-21.2-14.1-33.9V256c0-8.8 7.2-16 16-16zm-32 16v82.7c0 17 6.7 33.3 18.7 45.3L478.1 491.3c18.7 18.7 49.1 18.7 67.9 0l73.4-73.4c18.7-18.7 18.7-49.1 0-67.9L512 242.7c-12-12-28.3-18.7-45.3-18.7H384c-17.7 0-32 14.3-32 32zm88 40a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faImagePortrait = {
    prefix: 'fat',
    iconName: 'image-portrait',
    icon: [
      384,
      512,
      ["portrait"],
      'f3e0',
      
      'M64 16C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48H320c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM240 192a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM96 356.6c0 6.3 5.1 11.4 11.4 11.4H276.6c6.3 0 11.4-5.1 11.4-11.4c0-29-23.5-52.6-52.6-52.6H148.6c-29 0-52.6 23.5-52.6 52.6zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM148.6 288h86.9c37.9 0 68.6 30.7 68.6 68.6c0 15.1-12.3 27.4-27.4 27.4H107.4C92.3 384 80 371.7 80 356.6c0-37.9 30.7-68.6 68.6-68.6z'
      
    ]
  };

  
    var faPortrait = faImagePortrait;
  

  
  

  var faPersonFalling = {
    prefix: 'fat',
    iconName: 'person-falling',
    icon: [
      512,
      512,
      [],
      'e546',
      
      'M231.7 172.5c.8-4.3 3.3-8.1 7-10.5C278.9 135.9 304 91 304 41.8l0-9.8c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 9.8c0 45.5-27.7 86.4-69.9 103.3c-54.4 21.8-90.1 74.4-90.1 133V352c0 8.8 7.2 16 16 16s16-7.2 16-16l0-73.8c0-11.7 1.8-23.1 5.3-33.9c1.9-5.9 7-10.2 13.1-11s12.2 2 15.5 7.2L338.6 488.7c4.8 7.4 14.7 9.5 22.1 4.7s9.5-14.7 4.7-22.1L273.2 328.7c-3.2-4.9-3.4-11.2-.6-16.3s8.2-8.4 14.1-8.4H288l80 0c5 0 9.8 2.4 12.8 6.4l38.4 51.2c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4l-43.2-57.6c-6-8.1-15.5-12.8-25.6-12.8l-71.5 0c-5.2 0-10.1-2.5-13.1-6.7l-56.8-80.1 0 0-.2-.3c-2.6-3.6-3.5-8-2.7-12.3zm25 16L304.5 256l71.5 0c15.1 0 29.3 7.1 38.4 19.2l43.2 57.6c10.6 14.1 7.7 34.2-6.4 44.8s-34.2 7.7-44.8-6.4L368 320l-62.4 0H288h-1.4l1.4 2.2 8.9 13.8 81.9 126.6c9.6 14.8 5.4 34.6-9.5 44.3s-34.6 5.4-44.3-9.5L176.7 267.9l-12.1-18.8c-2.3 7.3-3.8 14.9-4.3 22.8c-.1 2.1-.2 4.1-.2 6.2l0 73.8c0 17.7-14.3 32-32 32s-32-14.3-32-32V278.2c0-65.1 39.6-123.7 100.1-147.9C232.3 115.8 256 80.8 256 41.8l0-9.8c0-17.7 14.3-32 32-32s32 14.3 32 32l0 9.8c0 49.4-22.9 95.1-60.3 124.8c-3.9 3.1-8 6-12.2 8.8l.2 .3 9 12.7zM120 128a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM64 88a56 56 0 1 1 112 0A56 56 0 1 1 64 88z'
      
    ]
  };

  

  
  

  var faBriefcase = {
    prefix: 'fat',
    iconName: 'briefcase',
    icon: [
      512,
      512,
      [128188],
      'f0b1',
      
      'M144 40V96H368V40c0-13.3-10.7-24-24-24H168c-13.3 0-24 10.7-24 24zM128 96V40c0-22.1 17.9-40 40-40H344c22.1 0 40 17.9 40 40V96h64c35.3 0 64 28.7 64 64V264 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V264 160c0-35.3 28.7-64 64-64h64zM16 272V416c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V272H336v48c0 17.7-14.3 32-32 32H208c-17.7 0-32-14.3-32-32V272H16zm160-16h16H320h16H496V160c0-26.5-21.5-48-48-48H376 136 64c-26.5 0-48 21.5-48 48v96H176zm16 16v48c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V272H192z'
      
    ]
  };

  

  
  

  var faPotFood = {
    prefix: 'fat',
    iconName: 'pot-food',
    icon: [
      640,
      512,
      [127858],
      'e43f',
      
      'M112 8c0-4.4-3.6-8-8-8s-8 3.6-8 8c0 27.4 5.1 46.4 13.3 61.1c8 14.4 18.6 23.9 28.3 32.6l.3 .3c9.9 8.9 18.7 16.9 25.3 28.7c6.5 11.7 11.2 27.9 11.2 53.3c0 4.4 3.6 8 8 8s8-3.6 8-8c0-27.4-5.1-46.4-13.3-61.1c-8-14.4-18.6-23.9-28.3-32.6l-.3-.3c-9.9-8.9-18.7-16.9-25.3-28.7C116.7 49.6 112 33.4 112 8zm97.6 0c0-4.4-3.6-8-8-8s-8 3.6-8 8c0 27.4 5.1 46.4 13.3 61.1c8 14.4 18.6 23.9 28.3 32.6l.3 .3c9.9 8.9 18.7 16.9 25.3 28.7c6.5 11.7 11.2 27.9 11.2 53.3c0 4.4 3.6 8 8 8s8-3.6 8-8c0-27.4-5.1-46.4-13.3-61.1c-8-14.4-18.6-23.9-28.3-32.6l-.3-.3c-9.9-8.9-18.7-16.9-25.3-28.7C214.3 49.6 209.6 33.4 209.6 8zM32 256c-4.4 0-8 3.6-8 8s3.6 8 8 8H66.8l.8 13.2c4.9 83.3 54.8 153.7 125.3 188.2c4.3 22 23.8 38.7 47.1 38.7H400c23.3 0 42.8-16.6 47.1-38.7c70.5-34.5 120.4-104.9 125.3-188.2l.8-13.2H608c4.4 0 8-3.6 8-8s-3.6-8-8-8H574.1c0-17.5-14.2-32-32-32H97.9c-17.8 0-32 14.5-32 32H32zm490.5-64h16.8c-13.8-46.3-56.6-80-107.4-80s-93.6 33.7-107.4 80h16.8c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64zM208.6 470.2c-1-4.9-4.2-9.1-8.7-11.3c-65.5-32-111.8-97.4-116.4-174.7L82 256.9c-.5-9.2 6.8-16.9 16-16.9H542.1c9.2 0 16.5 7.7 16 16.9l-1.6 27.3c-4.5 77.3-50.9 142.7-116.4 174.7c-4.5 2.2-7.7 6.4-8.7 11.3C428.5 484.9 415.5 496 400 496H240c-15.5 0-28.5-11.1-31.4-25.8z'
      
    ]
  };

  

  
  

  var faCloudMoon = {
    prefix: 'fat',
    iconName: 'cloud-moon',
    icon: [
      640,
      512,
      [],
      'f6c3',
      
      'M495.8 16c5 0 10 .2 14.9 .6c-49.3 27.9-82.5 80.9-82.5 141.7c0 89.8 72.6 162.6 162.2 162.6c9.5 0 18.8-.8 27.8-2.4c-31.7 30.8-74.9 49.8-122.5 49.8c-13.3 0-26.3-1.5-38.8-4.3c4.4 5.7 8.2 11.9 11.4 18.4c8.9 1.3 18.1 1.9 27.4 1.9c52 0 99.1-20.7 133.6-54.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-8.1 1.4-16.5 2.1-25.1 2.1c-80.7 0-146.2-65.6-146.2-146.6c0-54.8 30-102.6 74.4-127.8c6.1-3.5 9.2-10.5 7.7-17.3S519 1.3 512 .7c-5.4-.5-10.8-.7-16.3-.7C389.8 0 304 86.1 304 192.2c0 10.8 .9 21.5 2.6 31.8c5.6 .1 11.2 .7 16.5 1.6c-2.1-10.8-3.2-22-3.2-33.4C320 94.9 398.7 16 495.8 16zM96 320c0-44.2 35.8-80 80-80c32 0 59.6 18.8 72.4 46c1.1 2.3 3.2 3.9 5.7 4.4s5.1-.2 6.9-1.9c11.4-10.3 26.4-16.5 42.9-16.5c35.3 0 64 28.7 64 64c0 7.5-1.3 14.7-3.7 21.4c-.8 2.4-.5 5 .9 7.1s3.7 3.4 6.2 3.5c33.7 1.8 60.5 29.7 60.5 63.9c0 35.3-28.7 64-64 64c-.7 0-1.5 0-2.2 0l0 0h-.3H99v0l-.3 0c-.9 0-1.8 0-2.8 0c-44.2 0-80-35.8-80-80c0-41.8 32.1-76.2 73.1-79.7c2.1-.2 4.1-1.2 5.5-2.8s2-3.8 1.8-5.9c-.2-2.5-.4-5-.4-7.6zm80-96c-53 0-96 43-96 96l0 1.3C34.6 328.9 0 368.4 0 416c0 53 43 96 96 96c1.1 0 2.1 0 3.2-.1H365.3c.9 0 1.8 0 2.6 0c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C241.4 242.6 210.8 224 176 224z'
      
    ]
  };

  

  
  

  var faLocationPen = {
    prefix: 'fat',
    iconName: 'location-pen',
    icon: [
      384,
      512,
      ["map-marker-edit"],
      'f607',
      
      'M368 192c0-97.2-78.8-176-176-176S16 94.8 16 192c0 18.7 6.4 42.5 17.8 69.6c11.3 26.9 27.1 55.8 44.7 84.3c35.2 57 76.8 111.4 102.3 143.2c5.9 7.3 16.6 7.3 22.4 0c25.5-31.8 67.1-86.2 102.3-143.2c17.6-28.5 33.4-57.4 44.7-84.3C361.6 234.5 368 210.7 368 192zm16 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM100.6 283.4c-4-4-5.6-9.7-4.2-15.2l9.2-36.7c1.4-5.6 4.3-10.8 8.4-14.9L223.6 107c14.7-14.7 38.6-14.7 53.4 0s14.7 38.6 0 53.4L167.4 270c-4.1 4.1-9.2 7-14.9 8.4l-36.7 9.2c-5.5 1.4-11.2-.2-15.2-4.2zm15.7-28.9l-4.4 17.6 17.6-4.4 19.1-4.8c2.8-.7 5.4-2.2 7.4-4.2L241.7 173 211 142.3l-85.7 85.7c-2.1 2.1-3.5 4.6-4.2 7.4l-4.8 19.1zM265.7 149.1c8.5-8.5 8.5-22.3 0-30.7s-22.3-8.5-30.7 0L222.3 131 253 161.7l12.6-12.6z'
      
    ]
  };

  
    var faMapMarkerEdit = faLocationPen;
  

  
  

  var faSlashForward = {
    prefix: 'fat',
    iconName: 'slash-forward',
    icon: [
      320,
      512,
      [],
      '2f',
      
      'M316.2 1.2c3.8 2.3 5 7.2 2.6 11l-304 496c-2.3 3.8-7.2 4.9-11 2.6s-4.9-7.2-2.6-11l304-496c2.3-3.8 7.2-4.9 11-2.6z'
      
    ]
  };

  

  
  

  var faShieldQuartered = {
    prefix: 'fat',
    iconName: 'shield-quartered',
    icon: [
      512,
      512,
      [],
      'e575',
      
      'M274.8 22.6c-3.5-1.5-7.1-2.5-10.8-3.1V216H472.6c5.2-28 7.4-54.1 7.5-76.1c.1-19.1-11.9-35.3-28.5-42.4l-176.7-75zM469.3 232H264V492.4c3.9-.7 7.8-1.9 11.5-3.7C395.2 431.4 448.8 323.6 469.3 232zM248 216V19.4c-3.6 .6-7.2 1.7-10.7 3.1L60.5 97.5c-16.6 7.1-28.6 23.2-28.5 42.4c.1 22 2.3 48.1 7.5 76.1H248zM42.8 232c20.5 91.6 74.1 199.4 193.8 256.7c3.7 1.8 7.5 3 11.4 3.7V232H42.8zM231 7.8c16-6.8 34-6.8 50 0l176.7 75c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L231 7.8z'
      
    ]
  };

  

  
  

  var faHandFist = {
    prefix: 'fat',
    iconName: 'hand-fist',
    icon: [
      448,
      512,
      [9994,"fist-raised"],
      'f6de',
      
      'M240 48c0-17.7-14.3-32-32-32s-32 14.3-32 32V80v88c0 17.7 14.3 32 32 32s32-14.3 32-32V80 48zM208 0c25.3 0 46 19.5 47.9 44.3C264.4 36.7 275.6 32 288 32c25.3 0 46 19.5 47.9 44.3C344.4 68.7 355.6 64 368 64c26.5 0 48 21.5 48 48v80c0 1.9-.1 3.8-.3 5.7c.2 .7 .3 1.5 .3 2.3v64c0 46.8-23.7 88.1-59.7 112.6c-2.8 1.9-4.3 4.8-4.3 7.5V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V384.1c0-8.7 4.7-16.2 11.3-20.8c31.8-21.6 52.7-58 52.7-99.4V227.8c-8.5 7.6-19.7 12.2-32 12.2c-20.6 0-38.2-13-45-31.2c-8.8 9.3-21.2 15.2-35 15.2c-18.5 0-34.6-10.5-42.6-25.9c-4.2 5.2-9.4 9.4-15.3 12.5C241 219.4 248 232.9 248 248c0 26.5-21.5 48-48 48H136c-4.4 0-8-3.6-8-8s3.6-8 8-8h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H120c-38.5 0-70 30.3-71.9 68.4c1.9 46 33.7 84.3 76.4 96c10.6 2.9 19.5 12.3 19.5 24.4V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V404.7c0-3.8-2.9-7.7-7.7-9c-48.4-13.2-84.6-56-88-107.8H32c0-1.2 0-2.5 .1-3.7c-.1-1.4-.1-2.9-.1-4.3c0-1.2 .3-2.3 .7-3.3c4-31.2 24.3-57.2 52.1-69.4c-3.1-6.4-4.8-13.6-4.8-21V80c0-26.5 21.5-48 48-48c12.4 0 23.6 4.7 32.1 12.3C162 19.5 182.7 0 208 0zM100.2 202.2c6.4-1.5 13-2.2 19.8-2.2h37c1.9-4.1 3-8.7 3-13.7V168 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V186.3c0 5.7 1.5 11.1 4.2 15.9zM320 176V112 80c0-17.7-14.3-32-32-32s-32 14.3-32 32v88 8c0 17.7 14.3 32 32 32s32-14.3 32-32zm16-64v64 16c0 17.7 14.3 32 32 32s32-14.3 32-32V112c0-17.7-14.3-32-32-32s-32 14.3-32 32z'
      
    ]
  };

  
    var faFistRaised = faHandFist;
  

  
  

  var faAirplay = {
    prefix: 'fat',
    iconName: 'airplay',
    icon: [
      576,
      512,
      [],
      'e089',
      
      'M480 48H96c-44.2 0-80 35.8-80 80V320c0 44.2 35.8 80 80 80h21.5l-2.7 2.7c-4 4-7.4 8.5-10.2 13.3H96c-53 0-96-43-96-96V128C0 75 43 32 96 32H480c53 0 96 43 96 96V320c0 53-43 96-96 96h-8.6c-2.8-4.8-6.2-9.2-10.2-13.3l-2.7-2.7H480c44.2 0 80-35.8 80-80V128c0-44.2-35.8-80-80-80zM147.5 442.7c-2.2 2.3-3.5 5.4-3.5 8.7c0 7 5.6 12.6 12.6 12.6H419.4c7 0 12.6-5.6 12.6-12.6c0-3.2-1.2-6.3-3.5-8.7L303.4 310.6c-4-4.2-9.6-6.6-15.4-6.6s-11.4 2.4-15.4 6.6L147.5 442.7zm-11.6-11L261 299.6c7-7.4 16.8-11.6 27-11.6s20 4.2 27 11.6L440.2 431.7c5 5.3 7.8 12.4 7.8 19.7c0 15.8-12.8 28.6-28.6 28.6H156.6c-15.8 0-28.6-12.8-28.6-28.6c0-7.3 2.8-14.4 7.8-19.7z'
      
    ]
  };

  

  
  

  var faLamp = {
    prefix: 'fat',
    iconName: 'lamp',
    icon: [
      448,
      512,
      [],
      'f4ca',
      
      'M97.2 25.8l-80 192c-2.1 4.9-1.5 10.6 1.5 15s8 7.1 13.3 7.1H416c5.4 0 10.3-2.7 13.3-7.1s3.5-10.1 1.5-15l-80-192c-2.5-6-8.3-9.8-14.8-9.8H112c-6.5 0-12.3 3.9-14.8 9.8zM82.5 19.7C87.4 7.8 99.1 0 112 0H336c12.9 0 24.6 7.8 29.5 19.7l80 192c4.1 9.9 3 21.2-2.9 30.1s-15.9 14.2-26.6 14.2H32c-10.7 0-20.7-5.3-26.6-14.2s-7-20.2-2.9-30.1l80-192zM160 312.2V288h16v24.2c0 9.8-4.5 18.7-11.2 24.7c-7.4 6.6-20.9 19.9-32.4 37.1c-11.6 17.3-20.4 37.4-20.4 58c0 20.7 7 38.2 14.2 50.6c4.7 8.2 15 13.4 28.3 13.4h139c13.3 0 23.5-5.2 28.3-13.4C329 470.2 336 452.7 336 432c0-20.6-8.8-40.6-20.4-58c-11.5-17.2-25-30.4-32.4-37.1c-6.7-6-11.2-14.9-11.2-24.7V288h16v24.2c0 4.9 2.2 9.5 5.9 12.8C309.7 339.3 352 382 352 432c0 24.4-8.3 44.6-16.4 58.7c-8.5 14.7-25.2 21.3-42.1 21.3h-139c-17 0-33.6-6.6-42.1-21.3C104.3 476.6 96 456.4 96 432c0-50 42.3-92.7 58.1-107c3.6-3.3 5.9-7.9 5.9-12.8z'
      
    ]
  };

  

  
  

  var faArrowsSplitUpAndLeft = {
    prefix: 'fat',
    iconName: 'arrows-split-up-and-left',
    icon: [
      512,
      512,
      [],
      'e4bc',
      
      'M229.7 109.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l96-96c3.1-3.1 8.2-3.1 11.3 0l96 96c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L328 27.3V384v24c0 48.6 39.4 88 88 88h88c4.4 0 8 3.6 8 8s-3.6 8-8 8H416c-57.4 0-104-46.6-104-104V384c0-48.6-39.4-88-88-88H27.3l82.3 82.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-96-96C.8 292.2 0 290.1 0 288s.8-4.2 2.3-5.7l96-96c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L27.3 280H224c37.1 0 69.6 19.4 88 48.6V27.3l-82.3 82.3z'
      
    ]
  };

  

  
  

  var faSquareW = {
    prefix: 'fat',
    iconName: 'square-w',
    icon: [
      448,
      512,
      [],
      'e285',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm95.7 53.7L160 364l56.4-190.3c1-3.4 4.1-5.7 7.7-5.7s6.7 2.3 7.7 5.7L288 364l64.3-214.3c1.3-4.2 5.7-6.6 10-5.4s6.6 5.7 5.4 10l-72 240c-1 3.4-4.1 5.7-7.7 5.7s-6.7-2.3-7.7-5.7L224 204.2 167.7 394.3c-1 3.4-4.1 5.7-7.7 5.7s-6.7-2.3-7.7-5.7l-72-240c-1.3-4.2 1.1-8.7 5.4-10s8.7 1.1 10 5.4z'
      
    ]
  };

  

  
  

  var faTruckArrowRight = {
    prefix: 'fat',
    iconName: 'truck-arrow-right',
    icon: [
      640,
      512,
      [],
      'e58b',
      
      'M352 16c26.5 0 48 21.5 48 48V400H236.7c-10.4-36.9-44.4-64-84.7-64s-74.2 27.1-84.7 64H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H352zM64 416h.4c-.2 2.6-.4 5.3-.4 8c0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8H400h.4c-.2 2.6-.4 5.3-.4 8c0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8H632c4.4 0 8-3.6 8-8s-3.6-8-8-8H608V229.3c0-10.6-4.2-20.8-11.7-28.3L503 107.7c-7.5-7.5-17.7-11.7-28.3-11.7H416V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64zM416 112h58.7c6.4 0 12.5 2.5 17 7L585 212.3c1.1 1.1 2.2 2.4 3 3.7H416V112zm0 261.4V232H592V400H572.7c-10.4-36.9-44.4-64-84.7-64c-29.8 0-56.1 14.8-72 37.4zM152 352a72 72 0 1 1 0 144 72 72 0 1 1 0-144zm264 72a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zM237.7 82.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L292.7 160H104c-4.4 0-8 3.6-8 8s3.6 8 8 8H292.7l-66.3 66.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l80-80c3.1-3.1 3.1-8.2 0-11.3l-80-80z'
      
    ]
  };

  

  
  

  var faDiagramSuccessor = {
    prefix: 'fat',
    iconName: 'diagram-successor',
    icon: [
      512,
      512,
      [],
      'e47a',
      
      'M496 352c0-26.5-21.5-48-48-48L64 304c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l384 0c26.5 0 48-21.5 48-48l0-64zm16 64c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 64zM272 96c0-26.5-21.5-48-48-48l-32 0L64 48C37.5 48 16 69.5 16 96l0 64c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-64zm-5.7-48C279.6 59.7 288 76.9 288 96l0 64c0 35.3-28.7 64-64 64L64 224c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l128 0 32 0 144 0c30.9 0 56 25.1 56 56l0 116.7 50.3-50.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-64 64c-3.1 3.1-8.2 3.1-11.3 0l-64-64c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L408 204.7 408 88c0-22.1-17.9-40-40-40L266.3 48zM80 376l352 0c4.4 0 8 3.6 8 8s-3.6 8-8 8L80 392c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faCartFlatbedBoxes = {
    prefix: 'fat',
    iconName: 'cart-flatbed-boxes',
    icon: [
      640,
      512,
      ["dolly-flatbed-alt"],
      'f475',
      
      'M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8H88c13.3 0 24 10.7 24 24V392c0 22.1 17.9 40 40 40h36.2c-7.6 8.5-12.2 19.7-12.2 32c0 26.5 21.5 48 48 48s48-21.5 48-48c0-12.3-4.6-23.5-12.2-32H476.2c-7.6 8.5-12.2 19.7-12.2 32c0 26.5 21.5 48 48 48s48-21.5 48-48c0-12.3-4.6-23.5-12.2-32H632c4.4 0 8-3.6 8-8s-3.6-8-8-8H512 224 152c-13.3 0-24-10.7-24-24V40c0-22.1-17.9-40-40-40H8zM544 464a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 496a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-416H352c8.8 0 16 7.2 16 16V320c0 8.8-7.2 16-16 16H224c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16zM192 96V320c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H224c-17.7 0-32 14.3-32 32zM512 80c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H448c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h64zM448 64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H448zm0 176H576c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H448c-8.8 0-16-7.2-16-16V256c0-8.8 7.2-16 16-16zm-32 16v64c0 17.7 14.3 32 32 32H576c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32z'
      
    ]
  };

  
    var faDollyFlatbedAlt = faCartFlatbedBoxes;
  

  
  

  var faAngleLeft = {
    prefix: 'fat',
    iconName: 'angle-left',
    icon: [
      320,
      512,
      [8249],
      'f104',
      
      'M50.3 261.7c-3.1-3.1-3.1-8.2 0-11.3l176-176c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L67.3 256 237.7 426.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-176-176z'
      
    ]
  };

  

  
  

  var faBuildings = {
    prefix: 'fat',
    iconName: 'buildings',
    icon: [
      512,
      512,
      [],
      'e0cc',
      
      'M256 16c-26.5 0-48 21.5-48 48V448c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H256zM192 64c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V64zM56 128H160v16H56c-22.1 0-40 17.9-40 40V456c0 22.1 17.9 40 40 40H172.8c3.3 5.7 7.2 11.1 11.6 16H56c-30.9 0-56-25.1-56-56V184c0-30.9 25.1-56 56-56zm8 216c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V344zm24-8c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V344c0-4.4-3.6-8-8-8H88zm0-144h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V216c0-13.3 10.7-24 24-24zm-8 24v32c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V216c0-4.4-3.6-8-8-8H88c-4.4 0-8 3.6-8 8zM368 376V344c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H392c-13.3 0-24-10.7-24-24zm24 8h32c4.4 0 8-3.6 8-8V344c0-4.4-3.6-8-8-8H392c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8zm0-112c-13.3 0-24-10.7-24-24V216c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H392zm-8-24c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V216c0-4.4-3.6-8-8-8H392c-4.4 0-8 3.6-8 8v32zM256 376V344c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H280c-13.3 0-24-10.7-24-24zm24 8h32c4.4 0 8-3.6 8-8V344c0-4.4-3.6-8-8-8H280c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8zm0-312h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H280c-13.3 0-24-10.7-24-24V96c0-13.3 10.7-24 24-24zm-8 24v32c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V96c0-4.4-3.6-8-8-8H280c-4.4 0-8 3.6-8 8zM256 248V216c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H280c-13.3 0-24-10.7-24-24zm24 8h32c4.4 0 8-3.6 8-8V216c0-4.4-3.6-8-8-8H280c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8zM392 72h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H392c-13.3 0-24-10.7-24-24V96c0-13.3 10.7-24 24-24zm-8 24v32c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V96c0-4.4-3.6-8-8-8H392c-4.4 0-8 3.6-8 8z'
      
    ]
  };

  

  
  

  var faHouseCircleCheck = {
    prefix: 'fat',
    iconName: 'house-circle-check',
    icon: [
      640,
      512,
      [],
      'e509',
      
      'M282.7 2c3-2.7 7.6-2.7 10.6 0l215 190.4c-4.1-.3-8.2-.4-12.3-.4c-4 0-8 .1-11.9 .4L288 18.7 80 202.9V448c0 26.5 21.5 48 48 48h80V328c0-13.3 10.7-24 24-24H332c-2 5.2-3.8 10.6-5.4 16H256 232c-4.4 0-8 3.6-8 8V496h32 96 16 7.2c6.1 5.8 12.7 11.1 19.6 16H128c-35.3 0-64-28.7-64-64V217.1L13.3 262c-3.3 2.9-8.4 2.6-11.3-.7S-.6 252.9 2.7 250L282.7 2zM496 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm58.3 98.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-80 80c-3.1 3.1-8.2 3.1-11.3 0l-48-48c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L480 396.7l74.3-74.3z'
      
    ]
  };

  

  
  

  var faSwordLaser = {
    prefix: 'fat',
    iconName: 'sword-laser',
    icon: [
      512,
      512,
      [],
      'e03b',
      
      'M287.5 294.9L504.8 48.2c4.7-5.3 7.2-12.1 7.2-19.2c0-16-13-29-29-29c-7.1 0-13.9 2.6-19.2 7.2L217.1 224.5l11.3 11.3L474.3 19.3c2.4-2.1 5.4-3.3 8.6-3.3c7.2 0 13 5.8 13 13c0 3.2-1.2 6.2-3.3 8.6L276.1 283.6l11.3 11.3zM181.7 234.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L180.7 256 112 324.7l-2.3-2.3c-3.1-3.1-8.2-3.1-11.3 0L13.7 407C4.9 415.8 0 427.6 0 440s4.9 24.2 13.7 33L39 498.3c8.7 8.7 20.6 13.7 33 13.7s24.2-4.9 33-13.7l84.7-84.7c3.1-3.1 3.1-8.2 0-11.3l-2.3-2.3L256 331.3l10.3 10.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-16-16-64-64-16-16zm10.3 33L244.7 320 216 348.7l-2.3-2.3-48-48-2.3-2.3L192 267.3zM123.3 336L152 307.3l2.3 2.3 48 48 2.3 2.3L176 388.7 123.3 336zM25 418.3l79-79 2.3 2.3 64 64 2.3 2.3-79 79c-5.7 5.7-13.5 9-21.7 9s-15.9-3.2-21.7-9L25 461.7c-5.7-5.7-9-13.5-9-21.7s3.2-15.9 9-21.7z'
      
    ]
  };

  

  
  

  var faTomato = {
    prefix: 'fat',
    iconName: 'tomato',
    icon: [
      512,
      512,
      [],
      'e330',
      
      'M227.6 .8c-4-2-8.8-.4-10.7 3.6c-2 3.9-.4 8.7 3.5 10.7l0 0s0 0 0 0l0 0 0 0s0 0 0 0l0 0 .2 .1c.2 .1 .6 .3 1.1 .7c1 .7 2.5 1.7 4.4 3.3c3.7 3.1 8.6 8.2 13 15.8c6 10.2 11.5 25.4 12.1 47.3c-57.7 .6-112 13.9-157.7 39.1c-9.6 5.3-14.4 16.3-11.7 26.9s12.2 18 23.1 18.1l24.3 .2-11.4 18.6c-5.5 9-4.5 20.6 2.6 28.5s18.5 10.2 28.1 5.7l107.1-50.1 107.1 50.1c9.6 4.5 21 2.2 28.1-5.7s8.1-19.5 2.6-28.5L382 166.9h24.7c10.9 0 20.5-7.4 23.2-18s-2-21.7-11.6-27c-44-24.4-95.9-37.8-151.2-39.4c-.6-24.6-6.8-42.7-14.3-55.5c-5.5-9.4-11.6-15.8-16.5-19.9c-2.4-2.1-4.5-3.6-6.1-4.6c-.8-.5-1.4-.9-1.9-1.2c-.2-.1-.4-.2-.6-.3l-.2-.1-.1 0 0 0 0 0s0 0-3.6 7.1l3.6-7.2zm23.2 97.5c-.5 6.3-1.3 13-2.7 20.3c-.8 4.3 2.1 8.5 6.4 9.3s8.5-2.1 9.3-6.4c1.5-8.1 2.4-15.8 2.9-23c53 1.6 102.4 14.4 143.8 37.4c3.2 1.8 4.8 5.5 3.9 9s-4.1 6-7.7 6h-39c-2.9 0-5.6 1.6-7 4.1s-1.4 5.6 .1 8.1l18.6 30.5c1.8 3 1.5 6.9-.9 9.5s-6.2 3.4-9.4 1.9L258.9 153.3c-2.1-1-4.6-1-6.8 0L141.7 205c-3.2 1.5-7 .7-9.4-1.9s-2.7-6.5-.9-9.5l18.7-30.7c1.5-2.5 1.6-5.5 .2-8.1s-4.1-4.1-6.9-4.1l-38.4-.3c-3.6 0-6.8-2.5-7.7-6s.7-7.2 3.9-9c43-23.7 94.4-36.4 149.6-37.1zM220.4 15.1l0 0 0 0s0 0 0 0zm0 0l0 0 0 0s0 0 0 0zM61.8 184.4C33 215.3 16 255.5 16 304c0 60.2 26.1 107.6 68.7 140.4C127.7 477.4 188 496 256 496s128.3-18.6 171.3-51.6C469.8 411.6 496 364.2 496 304c0-48.5-17-88.7-45.8-119.6c3.5-4.2 6.4-9 8.7-14.1C492.2 204.5 512 249.6 512 304c0 130.9-114.6 208-256 208S0 434.9 0 304c0-54.4 19.8-99.6 53.1-133.7c.4 .9 .8 1.8 1.3 2.7c2.1 4.1 4.6 7.9 7.4 11.4z'
      
    ]
  };

  

  
  

  var faBatteryThreeQuarters = {
    prefix: 'fat',
    iconName: 'battery-three-quarters',
    icon: [
      576,
      512,
      ["battery-4"],
      'f241',
      
      'M448 112c35.3 0 64 28.7 64 64v16 16 96 16 16c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V176c0-35.3 28.7-64 64-64H448zm80 224V320h16c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H528V176c0-44.2-35.8-80-80-80H80C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H448c44.2 0 80-35.8 80-80zm0-32V208h16c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H528zM112 176H304c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V208c0-17.7 14.3-32 32-32zM64 208v96c0 26.5 21.5 48 48 48H304c26.5 0 48-21.5 48-48V208c0-26.5-21.5-48-48-48H112c-26.5 0-48 21.5-48 48z'
      
    ]
  };

  
    var faBattery4 = faBatteryThreeQuarters;
  

  
  

  var faCheck = {
    prefix: 'fat',
    iconName: 'check',
    icon: [
      448,
      512,
      [10003,10004],
      'f00c',
      
      'M437.7 106.3c3.1 3.1 3.1 8.2 0 11.3l-272 272c-3.1 3.1-8.2 3.1-11.3 0l-144-144c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L160 372.7 426.3 106.3c3.1-3.1 8.2-3.1 11.3 0z'
      
    ]
  };

  

  
  

  var faIceSkate = {
    prefix: 'fat',
    iconName: 'ice-skate',
    icon: [
      576,
      512,
      [9976],
      'f7ac',
      
      'M320 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V23.7l-2.1 .6L73.3 86.6C48.9 93.3 32 115.4 32 140.7V344c0 22.1 17.9 40 40 40H472c22.1 0 40-17.9 40-40V298c0-33-22.5-61.8-54.5-69.9L320 193.8V136 8zM77.5 102.1L304 40.3V128H248c-4.4 0-8 3.6-8 8s3.6 8 8 8h56v48H248c-4.4 0-8 3.6-8 8s3.6 8 8 8h63l142.6 35.6c24.9 6.2 42.4 28.6 42.4 54.3v46c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V140.7c0-18 12.1-33.8 29.5-38.6zM128 424v-8H112v8 72H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H120 408h96c39.8 0 72-32.2 72-72c0-4.4-3.6-8-8-8s-8 3.6-8 8c0 30.9-25.1 56-56 56H416V424v-8H400v8 72H128V424z'
      
    ]
  };

  

  
  

  var faUserPlus = {
    prefix: 'fat',
    iconName: 'user-plus',
    icon: [
      640,
      512,
      [],
      'f234',
      
      'M224 16a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 240A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 64h91.4C359.3 320 432 392.7 432 482.3c0 7.6-6.1 13.7-13.7 13.7H29.7c-7.6 0-13.7-6.1-13.7-13.7C16 392.7 88.7 320 178.3 320zm0-16C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3zM520 304c0 4.4 3.6 8 8 8s8-3.6 8-8V216h88c4.4 0 8-3.6 8-8s-3.6-8-8-8H536V112c0-4.4-3.6-8-8-8s-8 3.6-8 8v88H432c-4.4 0-8 3.6-8 8s3.6 8 8 8h88v88z'
      
    ]
  };

  

  
  

  var faBook = {
    prefix: 'fat',
    iconName: 'book',
    icon: [
      448,
      512,
      [128212],
      'f02d',
      
      'M0 56C0 25.1 25.1 0 56 0H408c22.1 0 40 17.9 40 40V376c0 19.4-13.7 35.5-32 39.2V496h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H56c-30.9 0-56-25.1-56-56V56zM56 416c-22.1 0-40 17.9-40 40s17.9 40 40 40H400V416H56zm-40 .8C26.2 406.4 40.3 400 56 400h56V16H56C33.9 16 16 33.9 16 56V416.8zM128 16V400H408c13.3 0 24-10.7 24-24V40c0-13.3-10.7-24-24-24H128zm48 120c0-4.4 3.6-8 8-8H376c4.4 0 8 3.6 8 8s-3.6 8-8 8H184c-4.4 0-8-3.6-8-8zm0 80c0-4.4 3.6-8 8-8H376c4.4 0 8 3.6 8 8s-3.6 8-8 8H184c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faTurkey = {
    prefix: 'fat',
    iconName: 'turkey',
    icon: [
      640,
      512,
      [],
      'f725',
      
      'M488 56c0 9.7-.2 21.3-2.6 32.1c-2.4 10.8-7.3 21.8-17.4 29L428.4 145l-13.2 9.3s0 0 0 0l-.9 .6s0 0 0 0c-27.1 18.6-62.1 16.7-91.4 13.6c-26.5-2.8-54 4.5-76.3 22.6c-44.6 36.1-51.6 101.6-15.4 146.3s101.6 51.6 146.3 15.4c18.2-14.8 30.2-34.4 35.4-55.5l0-.1 0 0c4.3-17.3 9.1-36.4 16.6-53.7c7.6-17.4 18.1-33.7 34.5-45.3l3.5-2.5 13.4-9.4 16.6-11.7c13.2-9.3 29.3-10.5 44.1-9.8c6.5 .3 13.2 1 19.5 1.6l0 0 2.7 .3c7.2 .7 14 1.3 20.2 1.3c22.1 0 40-17.9 40-40s-17.9-40-40-40c-1.1 0-2.1 0-3.2 .1c-4.8 .4-10-1.5-13.2-6c-2.9-4.1-3.2-9-1.8-13.2c1.4-4 2.1-8.4 2.1-12.9c0-22.1-17.9-40-40-40s-40 17.9-40 40zm-74.3 79.8L458.7 104c5.6-4 9.1-10.6 11.1-19.4c2-8.9 2.2-18.9 2.2-28.6c0-30.9 25.1-56 56-56s56 25.1 56 56c0 5.6-.8 11-2.3 16c.8 0 1.6 0 2.3 0c30.9 0 56 25.1 56 56s-25.1 56-56 56c-7.1 0-14.6-.7-21.8-1.4l-2.8-.3c-6.4-.6-12.5-1.3-18.5-1.5c-14-.6-25.5 .8-34.2 6.9l-33.5 23.6c-13.1 9.3-22.2 22.7-29 38.6c-6.9 15.9-11.4 33.7-15.8 51.3c-6.1 24.4-19.9 47-40.9 64C336 407 260.4 399 218.7 347.5S185 220.4 236.5 178.7c25.8-20.8 57.5-29.3 88.1-26.1c26.8 2.8 53.3 3.8 74.1-7C359.8 124 320.4 112 288 112c-50.9 0-119.2 29.6-175.3 79.9C56.8 242 16 310 16 384c0 28.3 8.7 48.3 22.6 63c14.3 15.1 35.3 26 61.8 33.6C153.8 495.9 223.3 496 288 496s134.2-.1 187.6-15.4c26.5-7.6 47.5-18.5 61.8-33.6c13.9-14.7 22.6-34.7 22.6-63c0-56.2-23.5-108.9-59.3-152.9l13.1-9.2C551 267.9 576 323.7 576 384c0 128-160 128-288 128S0 512 0 384C0 224 176 96 288 96c37.7 0 82.6 14.5 125.7 39.8z'
      
    ]
  };

  

  
  

  var faClipboardListCheck = {
    prefix: 'fat',
    iconName: 'clipboard-list-check',
    icon: [
      384,
      512,
      [],
      'f737',
      
      'M192 0c-37.1 0-67.6 28-71.6 64H112C91.1 64 73.3 77.4 66.7 96H64C28.7 96 0 124.7 0 160V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64h-2.7c-6.6-18.6-24.4-32-45.3-32h-8.4c-4-36-34.5-64-71.6-64zM16 160c0-26.5 21.5-48 48-48v16c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V112c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V160zM136 72c0-30.9 25.1-56 56-56s56 25.1 56 56c0 4.4 3.6 8 8 8h16c17.7 0 32 14.3 32 32v16c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V112c0-17.7 14.3-32 32-32h16c4.4 0 8-3.6 8-8zm56 24a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM157.7 237.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L96 276.7 77.7 258.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l24 24c3.1 3.1 8.2 3.1 11.3 0l56-56zM192 264c0 4.4 3.6 8 8 8H312c4.4 0 8-3.6 8-8s-3.6-8-8-8H200c-4.4 0-8 3.6-8 8zM160 384c0 4.4 3.6 8 8 8H312c4.4 0 8-3.6 8-8s-3.6-8-8-8H168c-4.4 0-8 3.6-8 8zM96 400a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faRectangle = {
    prefix: 'fat',
    iconName: 'rectangle',
    icon: [
      512,
      512,
      [9644,"rectangle-landscape"],
      'f2fa',
      
      'M448 80c26.5 0 48 21.5 48 48V384c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V128c0-26.5 21.5-48 48-48H448zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64z'
      
    ]
  };

  
    var faRectangleLandscape = faRectangle;
  

  
  

  var faCommentSms = {
    prefix: 'fat',
    iconName: 'comment-sms',
    icon: [
      512,
      512,
      ["sms"],
      'f7cd',
      
      'M157.3 415c-5-1.8-10.6-1-14.9 2.1c-11 8-29.4 19.3-51.2 28.8C68.3 456 41.6 464 16 464l.1-.1 0 0 0 0 .3-.3 .1-.1c.4-.4 .9-.9 1.5-1.6c1.3-1.4 3.2-3.6 5.4-6.3l-12.2-10 12.2 10C28 450 34 442 40 432c10.7-17.9 21.4-42.1 23.6-69.9c.3-4.3-1.1-8.6-3.9-11.8C31.9 318.8 16 280.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-35.2 0-68.6-6.1-98.7-17zM4.7 452.7l0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0zM104 212.8c0 9.6 4.8 18.7 12.8 24l29.4 19.6c3.6 2.4 5.7 6.4 5.7 10.7c0 7.1-5.8 12.8-12.8 12.8H112c-4.4 0-8 3.6-8 8s3.6 8 8 8h27.2c15.9 0 28.8-12.9 28.8-28.8c0-9.6-4.8-18.7-12.8-24l-29.4-19.6c-3.6-2.4-5.7-6.4-5.7-10.7c0-7.1 5.8-12.8 12.8-12.8H152c4.4 0 8-3.6 8-8s-3.6-8-8-8H132.8c-15.9 0-28.8 12.9-28.8 28.8zM372.8 184c-15.9 0-28.8 12.9-28.8 28.8c0 9.6 4.8 18.7 12.8 24l29.4 19.6c3.6 2.4 5.7 6.4 5.7 10.7c0 7.1-5.8 12.8-12.8 12.8H352c-4.4 0-8 3.6-8 8s3.6 8 8 8h27.2c15.9 0 28.8-12.9 28.8-28.8c0-9.6-4.8-18.7-12.8-24l-29.4-19.6c-3.6-2.4-5.7-6.4-5.7-10.7c0-7.1 5.8-12.8 12.8-12.8H392c4.4 0 8-3.6 8-8s-3.6-8-8-8H372.8zm-158.4 3.2c-2.1-2.8-5.7-3.9-8.9-2.8s-5.5 4.1-5.5 7.6v96c0 4.4 3.6 8 8 8s8-3.6 8-8V216l33.6 44.8c1.5 2 3.9 3.2 6.4 3.2s4.9-1.2 6.4-3.2L296 216v72c0 4.4 3.6 8 8 8s8-3.6 8-8V192c0-3.4-2.2-6.5-5.5-7.6s-6.9 0-8.9 2.8L256 242.7l-41.6-55.5z'
      
    ]
  };

  
    var faSms = faCommentSms;
  

  
  

  var faBasketShoppingMinus = {
    prefix: 'fat',
    iconName: 'basket-shopping-minus',
    icon: [
      576,
      512,
      [],
      'e652',
      
      'M340.2 1c-3.9 2.1-5.3 7-3.2 10.8L434.6 192H141.4L239 11.8c2.1-3.9 .7-8.7-3.2-10.8s-8.7-.7-10.8 3.2L123.2 192H48.5 32 8c-4.4 0-8 3.6-8 8s3.6 8 8 8H36L99.9 463.5C107 492 132.6 512 162 512H414c29.4 0 55-20 62.1-48.5L540 208h28c4.4 0 8-3.6 8-8s-3.6-8-8-8H544 527.5 452.8L351 4.2c-2.1-3.9-7-5.3-10.8-3.2zM52.5 208h471L460.6 459.6C455.3 481 436.1 496 414 496H162c-22 0-41.2-15-46.6-36.4L52.5 208zM208 344c-4.4 0-8 3.6-8 8s3.6 8 8 8H368c4.4 0 8-3.6 8-8s-3.6-8-8-8H208z'
      
    ]
  };

  

  
  

  var faTableList = {
    prefix: 'fat',
    iconName: 'table-list',
    icon: [
      512,
      512,
      ["th-list"],
      'f00b',
      
      'M160 48V176H496V96c0-26.5-21.5-48-48-48H160zm-16 0H64C37.5 48 16 69.5 16 96v80H144V48zM16 192V320H144V192H16zm0 144v80c0 26.5 21.5 48 48 48h80V336H16zM160 464H448c26.5 0 48-21.5 48-48V336H160V464zM496 320V192H160V320H496zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z'
      
    ]
  };

  
    var faThList = faTableList;
  

  
  

  var faHandBackPointDown = {
    prefix: 'fat',
    iconName: 'hand-back-point-down',
    icon: [
      448,
      512,
      [],
      'e19e',
      
      'M140 512c-28.7 0-52-23.3-52-52V272v-9.6c-6-3.7-11.8-7.8-17.3-12.5L41.5 225.3C25.3 211.6 16 191.5 16 170.3v-24C16 97.5 42.2 52.4 84.5 28.2l18-10.3C123.1 6.2 146.3 0 170 0H312c57.4 0 104 46.6 104 104v16 84 4c0 .8-.1 1.5-.3 2.2C412.5 240.5 387 264 356 264c-3.6 0-7.1-.3-10.5-.9C335.7 282.6 315.4 296 292 296c-6.1 0-12-.9-17.6-2.6C264.8 313.8 244.1 328 220 328c-10.1 0-19.6-2.5-28-6.9V460c0 28.7-23.3 52-52 52zM88 243.2V168c0-4.4 3.6-8 8-8s8 3.6 8 8v89.8V272 460c0 19.9 16.1 36 36 36s36-16.1 36-36V305.5c0-3.2 1.9-6.1 4.9-7.4s6.4-.6 8.7 1.6c7.9 7.6 18.6 12.2 30.5 12.2c19.9 0 36.7-13.2 42.1-31.3c.7-2.2 2.3-4.1 4.4-5s4.6-.9 6.7 .1c5.7 2.7 12 4.2 18.8 4.2c19 0 35.2-12.1 41.4-29c1.5-4 5.8-6.2 9.8-4.9c4 1.2 8.3 1.9 12.8 1.9c23.1 0 42.1-17.9 43.9-40.6c0-.3 .1-.6 .1-1V204 120 104c0-48.6-39.4-88-88-88H170c-20.9 0-41.4 5.4-59.5 15.8l-18 10.3C55.1 63.5 32 103.2 32 146.3v24c0 16.5 7.3 32.1 19.8 42.7L81 237.8c2.3 1.9 4.6 3.7 7 5.5z'
      
    ]
  };

  

  
  

  var faH5 = {
    prefix: 'fat',
    iconName: 'h5',
    icon: [
      640,
      512,
      [],
      'e412',
      
      'M16 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V248 440c0 4.4 3.6 8 8 8s8-3.6 8-8V256H304V440c0 4.4 3.6 8 8 8s8-3.6 8-8V248 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V240H16V72zm416-8c-3.7 0-7 2.6-7.8 6.2l-40 176c-.5 2.4 0 4.9 1.5 6.8s3.8 3 6.3 3H536c48.6 0 88 39.4 88 88s-39.4 88-88 88H448.4c-20.7 0-39-13.2-45.5-32.8l-3.2-9.7c-1.4-4.2-5.9-6.5-10.1-5.1s-6.5 5.9-5.1 10.1l3.2 9.7c8.7 26.1 33.2 43.8 60.7 43.8H536c57.4 0 104-46.6 104-104s-46.6-104-104-104H402L438.4 80H600c4.4 0 8-3.6 8-8s-3.6-8-8-8H432z'
      
    ]
  };

  

  
  

  var fa4 = {
    prefix: 'fat',
    iconName: '4',
    icon: [
      384,
      512,
      [],
      '34',
      
      'M159.2 43.4c1.9-4 .2-8.8-3.8-10.7s-8.8-.2-10.7 3.8L.8 340.6c-1.2 2.5-1 5.4 .5 7.7s4 3.7 6.8 3.7H304V472c0 4.4 3.6 8 8 8s8-3.6 8-8V352h56c4.4 0 8-3.6 8-8s-3.6-8-8-8H320V136c0-4.4-3.6-8-8-8s-8 3.6-8 8V336H20.6L159.2 43.4z'
      
    ]
  };

  

  
  

  var faSoftServe = {
    prefix: 'fat',
    iconName: 'soft-serve',
    icon: [
      384,
      512,
      [127846,"creemee"],
      'e400',
      
      'M200 0c-3 0-5.7 1.6-7.1 4.2s-1.2 5.8 .4 8.2l10.8 16.3c2.5 3.7 3.8 8.1 3.8 12.6C208 53.8 197.8 64 185.3 64H108c-33.1 0-60 26.9-60 60c0 13.6 4.5 26.1 12.1 36.1C26.6 162.1 0 190 0 224c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64s-28.7-64-64-64h-1.8c11.1-12.5 17.8-29 17.8-47C336 50.6 285.4 0 223 0H200zm93.6 160H232c-4.4 0-8 3.6-8 8s3.6 8 8 8h63.7H320c26.5 0 48 21.5 48 48s-21.5 48-48 48H64c-26.5 0-48-21.5-48-48s21.5-48 48-48H80.3 104c4.4 0 8-3.6 8-8s-3.6-8-8-8H82.7C71.4 152 64 138.9 64 124c0-24.3 19.7-44 44-44h77.3C206.7 80 224 62.7 224 41.3c0-7.6-2.3-15.1-6.5-21.5L214.9 16H223c53.6 0 97 43.4 97 97c0 19.9-10.6 37.3-26.4 47zM64 328c0-4.4-3.6-8-8-8s-8 3.6-8 8v16c0 22.1 17.9 40 40 40h.9l11.6 93c2.5 20 19.5 35 39.7 35H243.8c20.2 0 37.2-15 39.7-35l11.6-93h.9c22.1 0 40-17.9 40-40V328c0-4.4-3.6-8-8-8s-8 3.6-8 8v16c0 13.3-10.7 24-24 24h-8c-4 0-7.4 3-7.9 7L267.6 475c-1.5 12-11.7 21-23.8 21H140.2c-12.1 0-22.3-9-23.8-21L103.9 375c-.5-4-3.9-7-7.9-7H88c-13.3 0-24-10.7-24-24V328z'
      
    ]
  };

  
    var faCreemee = faSoftServe;
  

  
  

  var faFaceViewfinder = {
    prefix: 'fat',
    iconName: 'face-viewfinder',
    icon: [
      512,
      512,
      [],
      'e2ff',
      
      'M40-.2C17.8-.2-.2 17.8-.2 40V152c0 4.5 3.7 8.2 8.2 8.2s8.2-3.7 8.2-8.2V40c0-13.2 10.7-23.8 23.8-23.8H152c4.5 0 8.2-3.7 8.2-8.2s-3.7-8.2-8.2-8.2H40zm432 0H360c-4.5 0-8.2 3.7-8.2 8.2s3.7 8.2 8.2 8.2H472c13.2 0 23.8 10.7 23.8 23.8V152c0 4.5 3.7 8.2 8.2 8.2s8.2-3.7 8.2-8.2V40c0-22.2-18-40.2-40.2-40.2zM-.2 472c0 22.2 18 40.2 40.2 40.2H152c4.5 0 8.2-3.7 8.2-8.2s-3.7-8.2-8.2-8.2H40c-13.2 0-23.8-10.7-23.8-23.8V360c0-4.5-3.7-8.2-8.2-8.2s-8.2 3.7-8.2 8.2V472zM472 512c22.1 0 40-17.9 40-40V360c0-4.4-3.6-8-8-8s-8 3.6-8 8V472c0 13.3-10.7 24-24 24H360c-4.4 0-8 3.6-8 8s3.6 8 8 8H472zM224 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM256 112a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 304a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM207.5 292c-2.2-3.8-7.1-5.1-10.9-2.9s-5.1 7.1-2.9 10.9c12.4 21.5 35.7 36 62.4 36s49.9-14.5 62.4-36c2.2-3.8 .9-8.7-2.9-10.9s-8.7-.9-10.9 2.9c-9.7 16.8-27.8 28-48.5 28s-38.8-11.2-48.5-28z'
      
    ]
  };

  

  
  

  var faGripDotsVertical = {
    prefix: 'fat',
    iconName: 'grip-dots-vertical',
    icon: [
      256,
      512,
      [],
      'e411',
      
      'M80 96A32 32 0 1 0 16 96a32 32 0 1 0 64 0zM0 96a48 48 0 1 1 96 0A48 48 0 1 1 0 96zM80 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM0 256a48 48 0 1 1 96 0A48 48 0 1 1 0 256zM48 448a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM240 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm32 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  

  
  

  var faSpinnerScale = {
    prefix: 'fat',
    iconName: 'spinner-scale',
    icon: [
      512,
      512,
      [],
      'e62a',
      
      'M256 28a36 36 0 1 1 0 72 36 36 0 1 1 0-72zM204 64a52 52 0 1 0 104 0A52 52 0 1 0 204 64zm52 368a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-32 16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM448 272a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm32-16a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM88 256a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM64 216a40 40 0 1 0 0 80 40 40 0 1 0 0-80zm356-67.5A40 40 0 1 1 363.5 92 40 40 0 1 1 420 148.5zm11.3-67.9a56 56 0 1 0 -79.2 79.2 56 56 0 1 0 79.2-79.2zM131.5 380.5a16 16 0 1 1 -22.6 22.6 16 16 0 1 1 22.6-22.6zM97.6 369.1a32 32 0 1 0 45.3 45.3A32 32 0 1 0 97.6 369.1zm282.8 33.9a16 16 0 1 1 22.6-22.6 16 16 0 1 1 -22.6 22.6zm33.9 11.3a32 32 0 1 0 -45.3-45.3 32 32 0 1 0 45.3 45.3zM142.9 142.9A32 32 0 1 1 97.6 97.6a32 32 0 1 1 45.3 45.3zm11.3-56.6A48 48 0 1 0 86.3 154.2a48 48 0 1 0 67.9-67.9z'
      
    ]
  };

  

  
  

  var faM = {
    prefix: 'fat',
    iconName: 'm',
    icon: [
      448,
      512,
      [109],
      '4d',
      
      'M5.6 32.4c3.3-1.1 6.9 .1 9 3L224 330.2 433.5 35.4c2-2.8 5.6-4 9-3s5.6 4.1 5.6 7.6V464c0 4.4-3.6 8-8 8s-8-3.6-8-8V65.1L230.5 348.6c-1.5 2.1-3.9 3.4-6.5 3.4s-5-1.3-6.5-3.4L16 65.1V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V40c0-3.5 2.3-6.6 5.6-7.6z'
      
    ]
  };

  

  
  

  var faDesktop = {
    prefix: 'fat',
    iconName: 'desktop',
    icon: [
      576,
      512,
      [61704,128421,"desktop-alt"],
      'f390',
      
      'M512 16c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H344.2h-.3H232.1h-.3H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H512zM64 416H222.6l-13.3 80H136c-4.4 0-8 3.6-8 8s3.6 8 8 8h80H360h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H366.8l-13.3-80H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64zm161.4 80l13.3-80h98.4l13.3 80H225.4zM80 80H496V272H80L80 80zM64 80V272c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  
    var faDesktopAlt = faDesktop;
  

  
  

  var faDiceD8 = {
    prefix: 'fat',
    iconName: 'dice-d8',
    icon: [
      512,
      512,
      [],
      'f6d2',
      
      'M248 20.7L19.8 248.9 248 332.5V20.7zM24.2 267.5L248 491.3V349.6L24.2 267.5zM264 491.3L487.8 267.5 264 349.6V491.3zM492.2 248.9L264 20.7V332.5l228.2-83.7zM239 7c9.4-9.4 24.6-9.4 33.9 0L505 239c9.4 9.4 9.4 24.6 0 33.9L273 505c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L239 7z'
      
    ]
  };

  

  
  

  var faShower = {
    prefix: 'fat',
    iconName: 'shower',
    icon: [
      512,
      512,
      [128703],
      'f2cc',
      
      'M16 107.9C16 74.8 42.8 48 75.9 48c15.9 0 31.1 6.3 42.3 17.5l36.1 36.1c.3 .3 .7 .6 1.1 .9c-38.3 44-36.5 110.8 5.4 152.6l18.3 18.3-16.8 16.8c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l192-192c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-16.8 16.8L319.2 96.8c-41.9-41.9-108.6-43.7-152.6-5.4c-.3-.4-.6-.7-.9-1.1L129.5 54.2C115.3 40 96 32 75.9 32C34 32 0 66 0 107.9V472c0 4.4 3.6 8 8 8s8-3.6 8-8V107.9zm310.2 18.6L190.5 262.2l-18.3-18.3c-37.5-37.5-37.5-98.3 0-135.8s98.3-37.5 135.8 0l18.3 18.3zM416 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-48 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80 48a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-64 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM432 320a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faDoNotEnter = {
    prefix: 'fat',
    iconName: 'do-not-enter',
    icon: [
      512,
      512,
      [],
      'f5ec',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm96-16v32c0 8.8 7.2 16 16 16H400c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm-16 0c0-17.7 14.3-32 32-32H400c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V240z'
      
    ]
  };

  

  
  

  var faGaugeSimpleHigh = {
    prefix: 'fat',
    iconName: 'gauge-simple-high',
    icon: [
      512,
      512,
      [61668,"tachometer","tachometer-fast"],
      'f62a',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-208a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112c35.3 0 64-28.7 64-64c0-22.2-11.3-41.7-28.4-53.2l83.6-167.2c2-4 .4-8.8-3.6-10.7s-8.8-.4-10.7 3.6L277.2 291.6c-6.6-2.3-13.8-3.6-21.2-3.6c-35.3 0-64 28.7-64 64s28.7 64 64 64z'
      
    ]
  };

  
    var faTachometer = faGaugeSimpleHigh;
  
    var faTachometerFast = faGaugeSimpleHigh;
  

  
  

  var faArrowDownBigSmall = {
    prefix: 'fat',
    iconName: 'arrow-down-big-small',
    icon: [
      576,
      512,
      ["sort-size-down"],
      'f88c',
      
      'M165.7 477.7l104-104c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L168 452.7V40c0-4.4-3.6-8-8-8s-8 3.6-8 8V452.7L61.7 362.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l104 104c3.1 3.1 8.2 3.1 11.3 0zM336 432V368c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H368c-17.7 0-32-14.3-32-32zm-16 0c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48v64zM336 80c0-17.7 14.3-32 32-32H496c17.7 0 32 14.3 32 32V208c0 17.7-14.3 32-32 32H368c-17.7 0-32-14.3-32-32V80zm-16 0V208c0 26.5 21.5 48 48 48H496c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48z'
      
    ]
  };

  
    var faSortSizeDown = faArrowDownBigSmall;
  

  
  

  var faCalendarLines = {
    prefix: 'fat',
    iconName: 'calendar-lines',
    icon: [
      448,
      512,
      ["calendar-note"],
      'e0d5',
      
      'M120 0c4.4 0 8 3.6 8 8V64H320V8c0-4.4 3.6-8 8-8s8 3.6 8 8V64h48c35.3 0 64 28.7 64 64v48 16V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 176 128C0 92.7 28.7 64 64 64h48V8c0-4.4 3.6-8 8-8zM432 192H16V448c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V192zM112 120V80H64c-26.5 0-48 21.5-48 48v48H432V128c0-26.5-21.5-48-48-48H336v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V80H128v40c0 4.4-3.6 8-8 8s-8-3.6-8-8zM96 392c0-4.4 3.6-8 8-8H248c4.4 0 8 3.6 8 8s-3.6 8-8 8H104c-4.4 0-8-3.6-8-8zm8-104H344c4.4 0 8 3.6 8 8s-3.6 8-8 8H104c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  
    var faCalendarNote = faCalendarLines;
  

  
  

  var faScaleBalanced = {
    prefix: 'fat',
    iconName: 'scale-balanced',
    icon: [
      640,
      512,
      [9878,"balance-scale"],
      'f24e',
      
      'M384.7 64c0 32.6-24.4 59.6-56 63.5V496h208c4.4 0 8 3.6 8 8s-3.6 8-8 8h-216H104c-4.4 0-8-3.6-8-8s3.6-8 8-8H312.7V127.5c-31.6-3.9-56-30.9-56-63.5L104 64c-4.4 0-8-3.6-8-8s3.6-8 8-8l154.7 0c7.1-27.6 32.2-48 62-48s54.9 20.4 62 48L536 48c4.4 0 8 3.6 8 8s-3.6 8-8 8L384.7 64zm52 304c20.5 19.2 47.1 32 75.7 32s55.2-12.8 75.7-32c20.3-19 33.1-43.1 35.8-64h-223c2.7 20.9 15.5 44.9 35.8 64zm75.7-254.2L407.8 288H616.9L512.4 113.8zM635.8 288.4c3 5 4.7 10.7 4.1 16.4C634 356.2 579.2 416 512.4 416s-121.7-59.8-127.5-111.2c-.7-5.8 1.1-11.5 4-16.4L500.3 102.9c2.6-4.3 7.2-6.9 12.1-6.9s9.6 2.6 12.1 6.9L635.8 288.4zM16.2 304c2.7 20.9 15.5 44.9 35.8 64c20.5 19.2 47.1 32 75.7 32s55.2-12.8 75.7-32c20.3-19 33.1-43.1 35.8-64H16.2zm6.9-16H232.2L127.6 113.8 23.1 288zM139.7 102.9L251.1 288.4c3 5 4.7 10.7 4.1 16.4C249.3 356.2 194.4 416 127.6 416S6 356.2 .1 304.8c-.7-5.8 1.1-11.5 4.1-16.4L115.5 102.9c2.6-4.3 7.2-6.9 12.1-6.9s9.6 2.6 12.1 6.9zM320.7 112a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  
    var faBalanceScale = faScaleBalanced;
  

  
  

  var faDrawPolygon = {
    prefix: 'fat',
    iconName: 'draw-polygon',
    icon: [
      448,
      512,
      [],
      'f5ee',
      
      'M80 80A32 32 0 1 0 16 80a32 32 0 1 0 64 0zM56 127.3V384.7C76.1 388 92 403.9 95.3 424H352.7c1.8-10.9 7.3-20.5 15.2-27.6l-61.2-96.1c-5.7 2.4-12 3.8-18.7 3.8c-26.5 0-48-21.5-48-48s21.5-48 48-48c6.6 0 12.9 1.3 18.7 3.8l61.2-96.1c-7.9-7.1-13.3-16.7-15.2-27.6H95.3C92 108.1 76.1 124 56 127.3zM381.3 387.8c5.7-2.4 12-3.8 18.7-3.8c26.5 0 48 21.5 48 48s-21.5 48-48 48c-23.8 0-43.5-17.3-47.3-40H95.3c-3.8 22.7-23.6 40-47.3 40c-26.5 0-48-21.5-48-48c0-23.8 17.3-43.5 40-47.3V127.3C17.3 123.5 0 103.8 0 80C0 53.5 21.5 32 48 32c23.8 0 43.5 17.3 47.3 40H352.7c3.8-22.7 23.6-40 47.3-40c26.5 0 48 21.5 48 48s-21.5 48-48 48c-6.6 0-12.9-1.3-18.7-3.8l-61.2 96.1c9.7 8.8 15.8 21.5 15.8 35.6s-6.1 26.9-15.8 35.6l61.2 96.1zM432 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM48 464a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm384-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM288 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faFaceMonocle = {
    prefix: 'fat',
    iconName: 'face-monocle',
    icon: [
      512,
      512,
      [],
      'e380',
      
      'M448 400V232c0-4.4-3.6-8-8-8l-.3 0c-4.1-53.7-48.9-96-103.7-96c-57.4 0-104 46.6-104 104s46.6 104 104 104c43.2 0 80.3-26.4 96-63.9V401.9c0 5.4 .4 10.8 1.1 16.1c-43.9 47.9-107 78-177.1 78C123.5 496 16 388.5 16 256S123.5 16 256 16s240 107.5 240 240c0 54-17.9 103.9-48 144zm2.1 22.9C488.7 378.1 512 319.8 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c70.8 0 134.9-28.7 181.2-75.2c8.3 27.4 26.3 51.3 51.2 66.8l11.4 7.1c3.7 2.3 8.7 1.2 11-2.5s1.2-8.7-2.5-11l-11.4-7.1c-24.4-15.2-41.1-39.7-46.7-67.2zM160.4 176a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm144 48a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM336 144a88 88 0 1 1 0 176 88 88 0 1 1 0-176zM160 360c0 4.4 3.6 8 8 8c15.2 0 39.8 3.1 63.5 12.3c23.8 9.2 45.8 24.2 57.3 47.3c2 4 6.8 5.6 10.7 3.6s5.6-6.8 3.6-10.7c-14-28.1-40.1-45.1-65.9-55.1c-25.8-10-52.4-13.3-69.3-13.3c-4.4 0-8 3.6-8 8zM300.2 99.7c9.4-7.5 21.2-11.7 33.2-11.7c10.5 0 20.8 3.1 29.5 8.9l8.6 5.7c3.7 2.5 8.6 1.5 11.1-2.2s1.5-8.6-2.2-11.1l-8.6-5.7C360.5 76 347.1 72 333.5 72c-15.7 0-31 5.3-43.2 15.2L267 105.8c-3.5 2.8-4 7.8-1.2 11.2s7.8 4 11.2 1.2l23.2-18.6z'
      
    ]
  };

  

  
  

  var faRss = {
    prefix: 'fat',
    iconName: 'rss',
    icon: [
      448,
      512,
      ["feed"],
      'f09e',
      
      'M8 32c-4.4 0-8 3.6-8 8s3.6 8 8 8c234.2 0 424 189.8 424 424c0 4.4 3.6 8 8 8s8-3.6 8-8C448 229 251 32 8 32zM8 176c-4.4 0-8 3.6-8 8s3.6 8 8 8c154.6 0 280 125.4 280 280c0 4.4 3.6 8 8 8s8-3.6 8-8C304 308.5 171.5 176 8 176zm8 240a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0A64 64 0 1 0 0 416a64 64 0 1 0 128 0z'
      
    ]
  };

  
    var faFeed = faRss;
  

  
  

  var faArrowTrendDown = {
    prefix: 'fat',
    iconName: 'arrow-trend-down',
    icon: [
      576,
      512,
      [],
      'e097',
      
      'M368 408c0 4.4 3.6 8 8 8H568c4.4 0 8-3.6 8-8V216c0-4.4-3.6-8-8-8s-8 3.6-8 8V388.7L325.7 154.3c-3.1-3.1-8.2-3.1-11.3 0L192 276.7 13.7 98.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l184 184c3.1 3.1 8.2 3.1 11.3 0L320 171.3 548.7 400H376c-4.4 0-8 3.6-8 8z'
      
    ]
  };

  

  
  

  var faCookieBite = {
    prefix: 'fat',
    iconName: 'cookie-bite',
    icon: [
      512,
      512,
      [],
      'f564',
      
      'M190.3 42.5c15.9-8.5 33.9-11.9 51.7-10c10.4 60.4 58.4 108 119 117.7c1.2 .2 2.3 1.2 2.6 2.4c12.9 55.9 58.4 99.3 115.3 109.2c2.6 17.9-.2 36.3-8.1 52.6L434.2 390c-8.3 17.1-21.8 31.1-38.5 40l-74 39.5c-16.7 8.9-35.8 12.3-54.6 9.7l-83-11.7c-18.8-2.6-36.2-11.2-49.8-24.4L74 384.7c-13.6-13.2-22.8-30.4-26.1-49.2L33.4 252.7c-3.3-18.7-.6-38.1 7.7-55.2L77.8 122c8.3-17.1 21.8-31.1 38.5-40l74-39.5zm67.2-14.9c-.8-5.4-4.9-9.8-10.3-10.6c-22.1-3.1-44.6 .9-64.4 11.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9c-.9-5.3-5.3-9.3-10.6-10.1c-51.5-8.2-92.8-47.1-104.5-97.4c-1.8-7.6-8-13.4-15.7-14.6c-54.6-8.7-97.7-52-106.2-106.8zM208 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-32-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm192 16a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faPeopleSimple = {
    prefix: 'fat',
    iconName: 'people-simple',
    icon: [
      512,
      512,
      [],
      'e21b',
      
      'M128 16a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112A64 64 0 1 0 128 0a64 64 0 1 0 0 128zm-22.4 48h44.8c33.3 0 61 25.5 63.8 58.7l4.1 49.3c2.3 28-19.8 52-47.8 52H144 112 85.6c-28.1 0-50.2-24-47.8-52l4.1-49.3c2.8-33.2 30.5-58.7 63.8-58.7zM120 352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V344.8c22.1-11.5 36.4-35.4 34.2-62.1l-4.1-49.3C226.7 191.9 192 160 150.4 160H105.6c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3c-2.2 26.7 12.2 50.6 34.2 62.1V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352zm64 128c0 8.8-7.2 16-16 16s-16-7.2-16-16V352h18.4c4.7 0 9.2-.5 13.6-1.4V480zM104 352V480c0 8.8-7.2 16-16 16s-16-7.2-16-16V350.6c4.4 .9 8.9 1.4 13.6 1.4H104zM384 16a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112A64 64 0 1 0 384 0a64 64 0 1 0 0 128zm-15.7 48h31.4c21.4 0 40.3 14.2 46.2 34.8L485 347.6c2.9 10.2-4.8 20.4-15.4 20.4H448 400 368 320 298.4c-10.6 0-18.3-10.2-15.4-20.4l39.1-136.8c5.9-20.6 24.7-34.8 46.2-34.8zM376 384h16v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h13.6c21.3 0 36.6-20.3 30.8-40.8L461.3 206.4c-7.8-27.5-33-46.4-61.5-46.4H368.3c-28.6 0-53.7 18.9-61.5 46.4L267.7 343.2c-5.8 20.4 9.5 40.8 30.8 40.8H312v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384zm64 96c0 8.8-7.2 16-16 16s-16-7.2-16-16V384h32v96zm-80-96v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V384h32z'
      
    ]
  };

  

  
  

  var faFaceAngry = {
    prefix: 'fat',
    iconName: 'face-angry',
    icon: [
      512,
      512,
      [128544,"angry"],
      'f556',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm77.4-114.1c3.3-3 3.6-8 .6-11.3C318.9 370 292.9 352 256 352s-62.9 18-77.9 34.6c-3 3.3-2.7 8.3 .6 11.3s8.3 2.7 11.3-.6C202.7 383.1 224.7 368 256 368s53.3 15.1 66.1 29.4c3 3.3 8 3.6 11.3 .6zM176.4 256a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm176-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM130.5 168.4c-4.2-1.4-8.7 .9-10.1 5.1s.9 8.7 5.1 10.1l96 32c4.2 1.4 8.7-.9 10.1-5.1s-.9-8.7-5.1-10.1l-96-32zm256 15.2c4.2-1.4 6.5-5.9 5.1-10.1s-5.9-6.5-10.1-5.1l-96 32c-4.2 1.4-6.5 5.9-5.1 10.1s5.9 6.5 10.1 5.1l96-32z'
      
    ]
  };

  
    var faAngry = faFaceAngry;
  

  
  

  var faFunction = {
    prefix: 'fat',
    iconName: 'function',
    icon: [
      640,
      512,
      [],
      'f661',
      
      'M80 72c0-39.8 32.2-72 72-72h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H152c-30.9 0-56 25.1-56 56V192h88c4.4 0 8 3.6 8 8s-3.6 8-8 8H96V406.1c0 37-28 68-64.8 71.6L8.8 480c-4.4 .4-8.3-2.8-8.8-7.2s2.8-8.3 7.2-8.8l22.4-2.2c28.6-2.9 50.4-27 50.4-55.7V208H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H80V72zm206.8 84.3C257.2 203.1 240 259.4 240 320s17.2 116.9 46.8 163.7c2.4 3.7 1.2 8.7-2.5 11s-8.7 1.2-11-2.5C242.1 442.9 224 383.6 224 320s18.1-122.9 49.2-172.3c2.4-3.7 7.3-4.9 11-2.5s4.9 7.3 2.5 11zm290.5 0c-2.4-3.7-1.2-8.7 2.5-11s8.7-1.2 11 2.5C621.9 197.1 640 256.4 640 320s-18.1 122.9-49.2 172.3c-2.4 3.7-7.3 4.9-11 2.5s-4.9-7.3-2.5-11C606.8 436.9 624 380.6 624 320s-17.2-116.9-46.8-163.7zM365.7 242.3L432 308.7l66.3-66.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L443.3 320l66.3 66.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L432 331.3l-66.3 66.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L420.7 320l-66.3-66.3c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0z'
      
    ]
  };

  

  
  

  var faBorderAll = {
    prefix: 'fat',
    iconName: 'border-all',
    icon: [
      448,
      512,
      [],
      'f84c',
      
      'M384 48c26.5 0 48 21.5 48 48V240l-208 0V48H384zm48 208V416c0 26.5-21.5 48-48 48H224V256l208 0zM208 240H16V96c0-26.5 21.5-48 48-48H208V240zM16 256H208V464H64c-26.5 0-48-21.5-48-48V256zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z'
      
    ]
  };

  

  
  

  var faAnchor = {
    prefix: 'fat',
    iconName: 'anchor',
    icon: [
      576,
      512,
      [9875],
      'f13d',
      
      'M352 80A64 64 0 1 1 224 80a64 64 0 1 1 128 0zM288 0c-44.2 0-80 35.8-80 80c0 41.5 31.6 75.6 72 79.6c0 .1 0 .3 0 .4v48H200c-4.4 0-8 3.6-8 8s3.6 8 8 8h80V496h-8C170.4 496 88 413.6 88 312V284.8l58.1 64.5c3 3.3 8 3.6 11.3 .6s3.6-8 .6-11.3l-72-80C84.4 257 82.3 256 80 256s-4.4 1-5.9 2.6l-72 80c-3 3.3-2.7 8.3 .6 11.3s8.3 2.7 11.3-.6L72 284.8V312c0 110.5 89.5 200 200 200h16 16c110.5 0 200-89.5 200-200V284.8l58.1 64.5c3 3.3 8 3.6 11.3 .6s3.6-8 .6-11.3l-72-80c-1.5-1.7-3.7-2.6-5.9-2.6s-4.4 1-5.9 2.6l-72 80c-3 3.3-2.7 8.3 .6 11.3s8.3 2.7 11.3-.6L488 284.8V312c0 101.6-82.4 184-184 184h-8V224h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H296V160c0-.1 0-.3 0-.4c40.4-4 72-38.1 72-79.6c0-44.2-35.8-80-80-80z'
      
    ]
  };

  

  
  

  var faCircleQuarter = {
    prefix: 'fat',
    iconName: 'circle-quarter',
    icon: [
      512,
      512,
      [],
      'e11f',
      
      'M17.8 226C31.4 117.5 117.5 31.4 226 17.8c6.7-.8 14 4.7 14 14.1V224c0 8.8-7.2 16-16 16L32 240c-9.4 0-15-7.3-14.1-14zM2 224.1C-.2 241.6 14.3 256 32 256l192 0c17.7 0 32-14.3 32-32V32c0-17.7-14.4-32.2-31.9-30C108.2 16.4 16.4 108.2 2 224.1z'
      
    ]
  };

  

  
  

  var faBookQuran = {
    prefix: 'fat',
    iconName: 'book-quran',
    icon: [
      448,
      512,
      ["quran"],
      'f687',
      
      'M392 0c30.9 0 56 25.1 56 56V456c0 30.9-25.1 56-56 56H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H32V415.2C13.7 411.5 0 395.4 0 376V40C0 17.9 17.9 0 40 0H392zM48 416v80H392c22.1 0 40-17.9 40-40s-17.9-40-40-40H48zm344-16c15.7 0 29.8 6.4 40 16.8V56c0-22.1-17.9-40-40-40H40C26.7 16 16 26.7 16 40V376c0 13.3 10.7 24 24 24H392zM274.7 163.1c4.9-11.8 21.7-11.8 26.6 0l7 16.9 18.2 1.5c12.8 1 17.9 17 8.2 25.3l-13.9 11.9 4.2 17.8c3 12.5-10.6 22.3-21.5 15.6L288 242.6l-15.6 9.5c-10.9 6.7-24.5-3.2-21.5-15.6l4.2-17.8-13.9-11.9c-9.7-8.3-4.6-24.3 8.2-25.3l18.2-1.5 7-16.9zm13.3 9.7l-7.4 17.9c-1.2 2.8-3.8 4.7-6.7 4.9l-19.3 1.5 14.7 12.6c2.3 2 3.3 5 2.6 7.9l-4.5 18.8 16.5-10.1c2.6-1.6 5.8-1.6 8.3 0l16.5 10.1-4.5-18.8c-.7-2.9 .3-6 2.6-7.9l14.7-12.6-19.3-1.5c-3-.2-5.6-2.1-6.7-4.9L288 172.8zM120 208c0 66.3 53.7 120 120 120c24 0 46.4-7.1 65.1-19.2C242.8 321.5 181.7 272.3 181.7 208s61.1-113.5 123.4-100.8C286.4 95.1 264 88 240 88c-66.3 0-120 53.7-120 120zM240 72c27.2 0 52.6 8 73.8 21.8c7.4 4.8 8.5 13.3 6 19.4s-9.2 11.5-17.8 9.7c-52.5-10.7-104.2 31-104.2 85.1s51.7 95.8 104.2 85.1c8.7-1.8 15.3 3.6 17.8 9.7s1.5 14.6-6 19.4C292.6 336 267.2 344 240 344c-75.1 0-136-60.9-136-136s60.9-136 136-136z'
      
    ]
  };

  
    var faQuran = faBookQuran;
  

  
  

  var faDeleteRight = {
    prefix: 'fat',
    iconName: 'delete-right',
    icon: [
      576,
      512,
      [],
      'e154',
      
      'M16 128c0-26.5 21.5-48 48-48H370.7c12.7 0 24.9 5.1 33.9 14.1L555.3 244.7c3 3 4.7 7.1 4.7 11.3s-1.7 8.3-4.7 11.3L404.7 417.9c-9 9-21.2 14.1-33.9 14.1H64c-26.5 0-48-21.5-48-48V128zM566.6 233.4L416 82.7C404 70.7 387.7 64 370.7 64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H370.7c17 0 33.3-6.7 45.3-18.7L566.6 278.6c6-6 9.4-14.1 9.4-22.6s-3.4-16.6-9.4-22.6zm-420.3-55c-3.1 3.1-3.1 8.2 0 11.3L212.7 256l-66.3 66.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L224 267.3l66.3 66.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L235.3 256l66.3-66.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L224 244.7l-66.3-66.3c-3.1-3.1-8.2-3.1-11.3 0z'
      
    ]
  };

  

  
  

  var faFileCirclePlus = {
    prefix: 'fat',
    iconName: 'file-circle-plus',
    icon: [
      576,
      512,
      [58606],
      'e494',
      
      'M64 496H311.2c5.8 5.5 12 10.6 18.5 15.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H204.1c12.7 0 24.9 5.1 33.9 14.1L369.9 145.9c9 9 14.1 21.2 14.1 33.9v18.7c-5.4 1.5-10.8 3.3-16 5.4V179.9c0-1.3-.1-2.6-.2-3.9H248c-22.1 0-40-17.9-40-40V16.2c-1.3-.2-2.6-.2-3.9-.2H64C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48zM361.1 160c-.8-1-1.6-1.9-2.4-2.7L226.7 25.4c-.9-.9-1.8-1.7-2.7-2.4V136c0 13.3 10.7 24 24 24H361.1zM560 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm152-72v64h64c4.4 0 8 3.6 8 8s-3.6 8-8 8H440v64c0 4.4-3.6 8-8 8s-8-3.6-8-8V376H360c-4.4 0-8-3.6-8-8s3.6-8 8-8h64V296c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faTornado = {
    prefix: 'fat',
    iconName: 'tornado',
    icon: [
      448,
      512,
      [127786],
      'f76f',
      
      'M16 45.6C16 74.1 21.1 102 30.6 128H336.1c-.1-1.4-.1-2.9-.1-4.3c0-22.2 9.6-43.3 26.3-57.9l33.8-29.6c2.5-2.2 3.9-5.3 3.9-8.7c0-6.4-5.2-11.5-11.5-11.5H32c-8.8 0-16 7.2-16 16V45.6zM37.1 144c20.1 44.6 53.6 82.8 97.2 108.4L194.8 288H427.6c-4.4-16.7-11.9-32.4-22.4-46.4l-53.8-71.8c-5.8-7.8-10.1-16.6-12.7-25.9H37.1zM430.8 304H222l28.8 16.9c21.8 12.8 39.5 31.7 50.8 54.4c12.4 24.8 16.6 52.9 12.1 80.2l-5.9 35.7c-.4 2.5 1.5 4.7 4 4.7c1.1 0 2.1-.4 2.9-1.2l78.2-78.2c25.1-25.1 39.2-59.1 39.2-94.6c0-6-.4-12-1.2-17.9zM0 45.6V32C0 14.3 14.3 0 32 0H388.5C403.7 0 416 12.3 416 27.5c0 7.9-3.4 15.5-9.4 20.7L372.8 77.8C359.6 89.4 352 106.1 352 123.7c0 13.2 4.3 26 12.2 36.6L418 232c19.4 25.9 30 57.5 30 89.9c0 39.7-15.8 77.8-43.9 105.9l-78.2 78.2c-3.8 3.8-8.9 5.9-14.2 5.9c-12.4 0-21.8-11.1-19.8-23.4l5.9-35.7c4-24 .3-48.7-10.6-70.5c-10-19.9-25.5-36.5-44.6-47.8L126.2 266.2C48 220.2 0 136.3 0 45.6z'
      
    ]
  };

  

  
  

  var faFireFlameCurved = {
    prefix: 'fat',
    iconName: 'fire-flame-curved',
    icon: [
      384,
      512,
      ["fire-alt"],
      'f7e4',
      
      'M190.4 18.1c1-1.3 2.6-2.1 4.3-2.1c2.9 0 5.3 2.4 5.3 5.3l0 22.1c0 17.5 7.2 34.3 19.9 46.3l78.2 74.5C342.7 206.8 368 265.8 368 327.4C368 420.5 292.5 496 199.4 496l-15.1 0C91.4 496 16 420.6 16 327.7l0-11.5c0-44.6 17.7-87.3 49.2-118.8L83 179.6c2.3-2.3 5.4-3.6 8.7-3.6c6.8 0 12.3 5.5 12.3 12.3l0 99.7c0 30.9 25.1 56 56 56s56-25.1 56-56l0-14c0-15.1-4.9-29.9-14-42l-32-42.7c-16.5-21.9-24.3-49.2-22-76.5l.9-10.8c1.7-21 9.4-41.1 22-57.9l19.5-26zM177.6 8.5l-19.5 26c-14.4 19.3-23.2 42.2-25.2 66.2l-.9 10.8c-2.6 31.2 6.3 62.4 25.2 87.4l32 42.7c7 9.3 10.8 20.7 10.8 32.4l0 14c0 22.1-17.9 40-40 40s-40-17.9-40-40l0-99.7c0-15.6-12.7-28.3-28.3-28.3c-7.5 0-14.7 3-20 8.3L53.9 186.1C19.4 220.6 0 267.4 0 316.2l0 11.5C0 429.5 82.5 512 184.3 512l15.1 0C301.4 512 384 429.4 384 327.4c0-66.1-27.1-129.2-74.9-174.8L230.9 78.2C221.4 69.1 216 56.6 216 43.4l0-22.1C216 9.6 206.4 0 194.7 0c-6.7 0-13 3.2-17.1 8.5z'
      
    ]
  };

  
    var faFireAlt = faFireFlameCurved;
  

  
  

  var faArrowUpZA = {
    prefix: 'fat',
    iconName: 'arrow-up-z-a',
    icon: [
      576,
      512,
      ["sort-alpha-up-alt"],
      'f882',
      
      'M154.3 34.3c3.1-3.1 8.2-3.1 11.3 0l112 112c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L168 59.3V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V59.3L53.7 157.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l112-112zM336 40c0-4.4 3.6-8 8-8H488c3.1 0 5.9 1.8 7.2 4.6s.9 6.1-1 8.5L360.9 208H488c4.4 0 8 3.6 8 8s-3.6 8-8 8H344c-3.1 0-5.9-1.8-7.2-4.6s-.9-6.1 1-8.5L471.1 48H344c-4.4 0-8-3.6-8-8zm80 248c3 0 5.8 1.7 7.2 4.4l63.9 127.9 .2 .3 23.9 47.8c2 4 .4 8.8-3.6 10.7s-8.8 .4-10.7-3.6L475.1 432H356.9l-21.8 43.6c-2 4-6.8 5.6-10.7 3.6s-5.6-6.8-3.6-10.7l23.9-47.8 .1-.3 63.9-127.9c1.4-2.7 4.1-4.4 7.2-4.4zm0 25.9L364.9 416H467.1L416 313.9z'
      
    ]
  };

  
    var faSortAlphaUpAlt = faArrowUpZA;
  

  
  

  var faPersonWalkingArrowLoopLeft = {
    prefix: 'fat',
    iconName: 'person-walking-arrow-loop-left',
    icon: [
      640,
      512,
      [],
      'e551',
      
      'M137.1 187.3c-4.6-4-11-5.1-16.6-2.8c-1.1 .5-2.2 .9-3.4 1.4l0 0-5.7 2.5c-21.6 9.6-37.9 28.3-44.4 51.1l-3.7 12.9c-2.4 8.5-11.3 13.4-19.8 11s-13.4-11.3-11-19.8l3.7-12.9c9.1-31.9 31.9-58.1 62.2-71.6l5.7-2.5c18.8-8.3 39-12.6 59.6-12.6c38.1 0 72.5 22.9 87.1 58.1l16.5 39.7c1.1 2.6 2.9 4.9 5.2 6.6l25 18.8c7.1 5.3 8.5 15.3 3.2 22.4s-15.3 8.5-22.4 3.2l-28.5-21.4c-4.6-3.4-8.1-8-10.3-13.3l-10.2-24.5c-2.6-6.3-8.9-10.2-15.6-9.8s-12.6 5-14.5 11.5L180 300.8c-1.6 5.4-.2 11.2 3.6 15.3l49.5 54c3.6 3.9 6.2 8.7 7.5 13.9l23 92.1c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6l-22-88.1c-.6-2.6-1.9-5-3.7-6.9l-70.7-77.1c-11.1-12.1-15.2-29-11-44.8L142 203.4c1.6-5.9-.3-12.1-4.9-16.1zM208 16a36 36 0 1 1 0 72 36 36 0 1 1 0-72zM107.4 209c3.3-2.3 6.8-4.3 10.6-6l5.7-2.5c1-.4 1.9-.8 2.9-1.2l-1.3 4.8-2.5 9.6-1.5 5.6-11.6 43.6c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 12.1-41.2 7.2-24.4 9.8 23.5 .4 1c3.3 7.9 8.7 14.8 15.5 19.9l28.5 21.4c14.1 10.6 34.2 7.7 44.8-6.4s7.7-34.2-6.4-44.8l-25-18.8-16.5-39.7C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14L92 144.5c-34.6 15.4-60.7 45.3-71.1 81.8l-3.7 12.9c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l3.7-12.9c4.1-14.3 13-26.6 24.9-34.9zM260 52A52 52 0 1 0 156 52a52 52 0 1 0 104 0zM99 343.9c-4.1-1.6-8.8 .4-10.4 4.5L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l61.7-61.7c4.6-4.6 8.2-10.1 10.6-16.1L142.1 387c1.6-4.1-.4-8.8-4.5-10.4s-8.8 .4-10.4 4.5l-15.1 37.9c-1.6 4-4 7.7-7.1 10.7L43.3 491.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l60.5-60.5 1.2-1.2 .6-1.5 20.5-51.1c1.6-4.1-.4-8.8-4.5-10.4zm351.9 94.2c3.4 2.8 8.4 2.4 11.3-1s2.4-8.4-1-11.3l-79-65.9L492 360c81.7 0 148-66.3 148-148s-66.3-148-148-148L328 64c-4.4 0-8 3.6-8 8s3.6 8 8 8l164 0c72.9 0 132 59.1 132 132s-59.1 132-132 132l-109.9 0 79-65.9c3.4-2.8 3.9-7.9 1-11.3s-7.9-3.9-11.3-1l-96 80c-1.8 1.5-2.9 3.8-2.9 6.1s1.1 4.6 2.9 6.1l96 80z'
      
    ]
  };

  

  
  

  var faClone = {
    prefix: 'fat',
    iconName: 'clone',
    icon: [
      512,
      512,
      [],
      'f24d',
      
      'M64 496H288c26.5 0 48-21.5 48-48V384h16v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h64v16H64c-26.5 0-48 21.5-48 48V448c0 26.5 21.5 48 48 48zM176 288c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H224c-26.5 0-48 21.5-48 48V288zm-16 0V64c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64z'
      
    ]
  };

  

  
  

  var faLinkSlash = {
    prefix: 'fat',
    iconName: 'link-slash',
    icon: [
      640,
      512,
      ["chain-broken","chain-slash","unlink"],
      'f127',
      
      'M13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.8 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7zM580.2 244.7c50-50 50-131 0-181s-131-50-181 0l-17 17c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l17-17c43.7-43.7 114.7-43.7 158.4 0s43.7 114.7 0 158.4l-71.2 71.2 12.6 10 69.9-69.9zM398.7 409.9L383.6 398c-37.5 10.3-79.4 .7-108.9-28.8c-22.8-22.8-33.7-53.1-32.7-83l-15.1-11.9c-4.6 37.8 7.5 77.2 36.5 106.2c36.6 36.6 89.8 46.4 135.3 29.4zM376.6 131.6C340 95 286.8 85.2 241.3 102.1L256.4 114c37.5-10.3 79.4-.7 108.9 28.8c22.8 22.8 33.7 53.1 32.7 83l15.1 11.9c4.6-37.8-7.5-77.2-36.5-106.2zm-63.5 27.3l1.1 .8c-.3-.3-.7-.6-1.1-.8zM129.6 197.5L59.8 267.3c-50 50-50 131 0 181s131 50 181 0l17-17c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-17 17c-43.7 43.7-114.7 43.7-158.4 0s-43.7-114.7 0-158.4l71.2-71.2-12.6-10zM326.9 353.2l-1.1-.9c.3 .3 .7 .6 1.1 .9z'
      
    ]
  };

  
    var faChainBroken = faLinkSlash;
  
    var faChainSlash = faLinkSlash;
  
    var faUnlink = faLinkSlash;
  

  
  

  var faPlugCircleExclamation = {
    prefix: 'fat',
    iconName: 'plug-circle-exclamation',
    icon: [
      576,
      512,
      [],
      'e55d',
      
      'M112 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V112h16V8zM288 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V112h16V8zM8 144c-4.4 0-8 3.6-8 8s3.6 8 8 8H40v80c0 81.3 63.8 147.6 144 151.8V504c0 4.4 3.6 8 8 8s8-3.6 8-8V391.8c20-1 39-6 56.3-14c-.2-3.2-.3-6.5-.3-9.8c0-2.7 .1-5.4 .2-8.1c-19.1 10.3-41 16.1-64.2 16.1c-75.1 0-136-60.9-136-136V160H328v66c5.1-3.8 10.5-7.3 16-10.5V160h32c4.4 0 8-3.6 8-8s-3.6-8-8-8H344 328 56 40 8zM304 368a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM432 448a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-168c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8s8-3.6 8-8V288c0-4.4-3.6-8-8-8z'
      
    ]
  };

  

  
  

  var faHandHolding = {
    prefix: 'fat',
    iconName: 'hand-holding',
    icon: [
      576,
      512,
      [],
      'f4bd',
      
      'M555.3 345.8c-7.9-10.7-22.9-12.9-33.6-5.1L404.2 427.3c-4.1 3-9.1 4.7-14.2 4.7H268c-15.5 0-28-12.5-28-28s12.5-28 28-28h80c11 0 20-9 20-20s-9-20-20-20H193.7c-25.4 0-50.1 8.7-70 24.5L81 394.7c-4.3 3.4-9.5 5.3-15 5.3H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H66c1.8 0 3.6-.6 5-1.8L113.7 348c22.7-18.2 50.9-28 80-28H348c19.9 0 36 16.1 36 36s-16.1 36-36 36H268c-6.6 0-12 5.4-12 12s5.4 12 12 12H389.9c1.7 0 3.4-.5 4.7-1.6l117.6-86.6 0 0c17.8-13.1 42.8-9.3 55.9 8.5s9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H352.5c25.6 0 50.6-8.2 71.2-23.4l126.6-93.3c10.7-7.9 12.9-22.9 5.1-33.6z'
      
    ]
  };

  

  
  

  var faFaceGrinTongueWink = {
    prefix: 'fat',
    iconName: 'face-grin-tongue-wink',
    icon: [
      512,
      512,
      [128540,"grin-tongue-wink"],
      'f58b',
      
      'M16 256C16 123.5 123.5 16 256 16s240 107.5 240 240c0 99.6-60.7 185-147.1 221.4c-4.1 1.7-6 6.4-4.3 10.5s6.4 6 10.5 4.3C447.3 453.4 512 362.3 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256C0 362.3 64.7 453.4 156.9 492.1c4.1 1.7 8.8-.2 10.5-4.3s-.2-8.8-4.3-10.5C76.7 441 16 355.6 16 256zM225.9 368c-23.2 0-41.9 18.8-41.9 41.9V440c0 39.8 32.2 72 72 72s72-32.2 72-72V409.9c0-23.2-18.8-41.9-41.9-41.9c-11.1 0-21.8 4.4-29.7 12.3l-.4 .4-.4-.4c-7.9-7.9-18.5-12.3-29.7-12.3zm18.3 23.6l3.7 3.7V424c0 4.4 3.6 8 8 8s8-3.6 8-8V395.3l3.7-3.7c4.9-4.9 11.5-7.6 18.3-7.6c14.3 0 25.9 11.6 25.9 25.9V440c0 30.9-25.1 56-56 56s-56-25.1-56-56V409.9c0-14.3 11.6-25.9 25.9-25.9c6.9 0 13.5 2.7 18.3 7.6zM119.9 327.9c-3.7 3.4-6.5 7.8-7.5 13.1c-1 5.3 0 10.9 2.9 16.1c10 17.5 23.6 32.9 39.8 45.3c3.5 2.7 8.5 2 11.2-1.5s2-8.5-1.5-11.2c-14.6-11.2-26.7-25-35.7-40.6c-1.2-2.1-1.3-3.8-1.1-5.1c.3-1.4 1.1-2.9 2.6-4.3c3.1-2.9 8.8-4.7 14.9-3.2c33.9 8.4 71.3 13.1 110.4 13.1s76.5-4.7 110.4-13.1c6.1-1.5 11.7 .3 14.9 3.2c1.5 1.4 2.3 2.9 2.6 4.3c.2 1.3 .1 3-1.1 5.1c-8.9 15.6-21.1 29.4-35.7 40.6c-3.5 2.7-4.2 7.7-1.5 11.2s7.7 4.2 11.2 1.5c16.2-12.4 29.8-27.8 39.8-45.3c3-5.2 3.9-10.7 2.9-16.1c-1-5.2-3.8-9.7-7.5-13.1c-7.3-6.7-18.5-9.7-29.6-6.9c-32.6 8.1-68.6 12.6-106.6 12.6s-74-4.5-106.6-12.6c-11.1-2.8-22.3 .3-29.6 6.9zM272 208a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm144 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-256.4-8c14.6 0 30.2 8.6 41 27.9c2.2 3.9 7 5.2 10.9 3.1s5.2-7 3.1-10.9c-13.1-23.4-33.6-36.1-55-36.1s-41.8 12.7-55 36.1c-2.2 3.9-.8 8.7 3.1 10.9s8.7 .8 10.9-3.1c10.9-19.3 26.4-27.9 41-27.9zM320 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  
    var faGrinTongueWink = faFaceGrinTongueWink;
  

  
  

  var faCirclePlus = {
    prefix: 'fat',
    iconName: 'circle-plus',
    icon: [
      512,
      512,
      ["plus-circle"],
      'f055',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm-8-160c0 4.4 3.6 8 8 8s8-3.6 8-8V264h88c4.4 0 8-3.6 8-8s-3.6-8-8-8H264V160c0-4.4-3.6-8-8-8s-8 3.6-8 8v88H160c-4.4 0-8 3.6-8 8s3.6 8 8 8h88v88z'
      
    ]
  };

  
    var faPlusCircle = faCirclePlus;
  

  
  

  var faShoePrints = {
    prefix: 'fat',
    iconName: 'shoe-prints',
    icon: [
      640,
      512,
      [],
      'f54b',
      
      'M276.6 42.3c9.8-2.9 23.6-6.9 39.4-10.8C347.8 23.6 386.2 16 416 16c45.7 0 99.3 11.5 140.8 32.3C599.3 69.6 624 97.4 624 128c0 29.8-21.6 49.8-56.5 63c-34.4 13-76.3 17-103.5 17c-43.6 0-68.5-14.1-96.1-29.9l-.3-.2c-25.3-14.5-52.8-30.2-95.7-33.4V43.7c1.4-.4 3-.9 4.6-1.4zM256 160c48 0 76 16 104 32s56 32 104 32c56.4 0 176-16 176-96S512 0 416 0C352.3 0 256 32 256 32V144v16h0zm-64-16c-26.5 0-48-21.5-48-48s21.5-48 48-48h32V32H192c-35.3 0-64 28.7-64 64s28.7 64 64 64h32V144H192zM148.6 469.7c-1.7-.5-3.2-1-4.6-1.4V367.4c42.8-3.2 70.3-18.9 95.7-33.4l.3-.2C267.5 318.1 292.4 304 336 304c27.2 0 69 3.9 103.5 17c34.9 13.2 56.5 33.2 56.5 63c0 30.6-24.7 58.4-67.2 79.7C387.3 484.5 333.7 496 288 496c-29.8 0-68.2-7.6-100-15.5c-15.7-3.9-29.5-7.9-39.4-10.8zM128 352h0v16V480s96.3 32 160 32c96 0 224-48 224-128s-119.6-96-176-96c-48 0-76 16-104 32s-56 32-104 32zM64 368H96V352H64c-35.3 0-64 28.7-64 64s28.7 64 64 64H96V464H64c-26.5 0-48-21.5-48-48s21.5-48 48-48z'
      
    ]
  };

  

  
  

  var faDragon = {
    prefix: 'fat',
    iconName: 'dragon',
    icon: [
      640,
      512,
      [128009],
      'f6d5',
      
      'M288.4 5.5C289.5 2.2 292.6 0 296 0H424h16 44.2c30.2 0 58.8 13.1 78.6 35.9l63.9 73.7c8.6 9.9 13.3 22.6 13.3 35.8c0 30.2-24.5 54.6-54.6 54.6H562.5c-19.1 0-37.4-7.6-50.9-21.1L500.7 168H480v20c0 17.6 8.3 34.2 22.4 44.8l90.7 68C622.6 323 640 357.7 640 394.7c0 62.4-48.7 113.4-110.1 117.1c-.6 .1-1.2 .2-1.9 .2h-5.3H456 40.4c-20.4 .2-37.9-15-40.2-35.7c-2.4-22 13.5-41.7 35.4-44.1l403.1-44-50.9-64.7C364.6 293.9 352 257.4 352 219.7V188.3v0l0-.3v0l0-50.4-59.2-26.3c-2.6-1.2-4.4-3.6-4.7-6.4s.9-5.6 3.1-7.3L346.7 56 291.2 14.4c-2.8-2.1-3.9-5.7-2.8-8.9zM526.6 496c.3-.1 .7-.1 1-.1C581.3 493.3 624 449 624 394.7c0-31.9-15-61.9-40.5-81.1l-90.7-68C474.7 232 464 210.7 464 188V160c0-4.4 3.6-8 8-8h32c2.1 0 4.2 .8 5.7 2.3l13.3 13.3c10.5 10.5 24.7 16.4 39.6 16.4h22.9c21.3 0 38.6-17.3 38.6-38.6c0-9.3-3.4-18.3-9.4-25.3L550.7 46.4C533.9 27.1 509.7 16 484.2 16H440 424 320l44.8 33.6c2 1.5 3.2 3.9 3.2 6.4s-1.2 4.9-3.2 6.4l-53.1 39.8 51.5 22.9c2.9 1.3 4.8 4.1 4.8 7.3l0 55.5v0l0 .3v0 31.5c0 34.1 11.4 67.1 32.5 93.9l52.4 66.7c2 2.6 3.1 5.8 3.1 9c0 7.5-5.6 13.7-13 14.5L37.4 448.1c-13.2 1.4-22.7 13.3-21.3 26.5C17.5 487 28.1 496.2 40.3 496l.1 0v0H456h66.7 3.9zM320 193.1l0 19.2L176.8 116.8c-9.3-6.2-21.7-5.2-29.8 2.5L30.1 230l161.2-14c3.3-.3 6.5 1.5 7.9 4.6s.8 6.7-1.6 9L123.3 304H332.3c1.9 5.4 4.1 10.8 6.5 16H104c-3.2 0-6.2-1.9-7.4-4.9s-.6-6.4 1.7-8.7l72.5-72.5L8.7 248c-3.4 .3-6.6-1.6-8-4.7s-.7-6.7 1.8-9.1L136 107.7c13.5-12.8 34.2-14.6 49.7-4.2L320 193.1zM491.6 64.8l32 16c4 2 5.6 6.8 3.6 10.7s-6.8 5.6-10.7 3.6l-32-16c-4-2-5.6-6.8-3.6-10.7s6.8-5.6 10.7-3.6z'
      
    ]
  };

  

  
  

  var faWifiWeak = {
    prefix: 'fat',
    iconName: 'wifi-weak',
    icon: [
      640,
      512,
      ["wifi-1"],
      'f6aa',
      
      'M320 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  
    var faWifi1 = faWifiWeak;
  

  
  

  var faBorderBottom = {
    prefix: 'fat',
    iconName: 'border-bottom',
    icon: [
      448,
      512,
      [],
      'f84d',
      
      'M0 472c0 4.4 3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H8c-4.4 0-8 3.6-8 8zM16 352a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm416 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-224 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zM48 160a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm352 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm-160 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM16 256a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm416 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-224 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zM48 64A16 16 0 1 0 16 64a16 16 0 1 0 32 0zm352 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zM240 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM112 256a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zM144 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm160 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm32 192a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faVolumeSlash = {
    prefix: 'fat',
    iconName: 'volume-slash',
    icon: [
      640,
      512,
      [128263],
      'f2e2',
      
      'M13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7zM576 256c0-62.1-29.5-117.3-75.1-152.3c-3.5-2.7-8.5-2-11.2 1.5s-2 8.5 1.5 11.2C533 148.5 560 199.1 560 256c0 29.5-7.3 57.4-20.1 81.8l12.8 10.1C567.5 320.6 576 289.3 576 256zM352 61.8C352 45.3 338.7 32 322.2 32c-7.3 0-14.3 2.7-19.8 7.5l-66 58.7 12.8 10.1L313 51.5c2.5-2.2 5.8-3.5 9.2-3.5c7.6 0 13.8 6.2 13.8 13.8V176.9l16 12.6V61.8zM88 176h14.5L82.5 160.3C54.2 163 32 186.9 32 216v80c0 30.9 25.1 56 56 56h78.9L302.4 472.5c5.5 4.8 12.5 7.5 19.8 7.5c16.5 0 29.8-13.3 29.8-29.8V373l-16-12.6v89.8c0 7.6-6.2 13.8-13.8 13.8c-3.4 0-6.6-1.2-9.2-3.5L175.2 338c-1.5-1.3-3.4-2-5.3-2H88c-22.1 0-40-17.9-40-40V216c0-22.1 17.9-40 40-40zm376 80c0 6.9-.9 13.6-2.5 20L475 286.6c3.2-9.6 5-19.9 5-30.6c0-31.4-15.1-59.2-38.3-76.8c-3.5-2.7-8.5-1.9-11.2 1.6s-1.9 8.5 1.6 11.2c19.4 14.6 31.9 37.8 31.9 64z'
      
    ]
  };

  

  
  

  var faSdCard = {
    prefix: 'fat',
    iconName: 'sd-card',
    icon: [
      384,
      512,
      [],
      'f7c2',
      
      'M368 64V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V154.5c0-12.7 5.1-24.9 14.1-33.9l90.5-90.5c9-9 21.2-14.1 33.9-14.1H320c26.5 0 48 21.5 48 48zm16 384V64c0-35.3-28.7-64-64-64H154.5c-17 0-33.3 6.7-45.3 18.7L18.7 109.3C6.7 121.3 0 137.5 0 154.5V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64zM176 72c0-4.4-3.6-8-8-8s-8 3.6-8 8v80c0 4.4 3.6 8 8 8s8-3.6 8-8V72zm64 0c0-4.4-3.6-8-8-8s-8 3.6-8 8v80c0 4.4 3.6 8 8 8s8-3.6 8-8V72zm64 0c0-4.4-3.6-8-8-8s-8 3.6-8 8v80c0 4.4 3.6 8 8 8s8-3.6 8-8V72z'
      
    ]
  };

  

  
  

  var faAmpGuitar = {
    prefix: 'fat',
    iconName: 'amp-guitar',
    icon: [
      512,
      512,
      [],
      'f8a1',
      
      'M256 0c-43 0-82.8 25.6-111.2 49.9c-14.3 12.3-26.1 24.6-34.3 33.8c-4.1 4.6-7.3 8.4-9.5 11.2c-.3 .4-.6 .8-.9 1.2H64C28.7 96 0 124.7 0 160v96 8 8V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V272v-8-8V160c0-35.3-28.7-64-64-64H411.9c-.3-.4-.6-.7-.9-1.2c-2.2-2.7-5.4-6.6-9.5-11.2c-8.2-9.2-19.9-21.5-34.3-33.8C338.8 25.6 299 0 256 0zM407.9 112c.1 0 .1 0 .2 0H448c26.5 0 48 21.5 48 48v96H16V160c0-26.5 21.5-48 48-48H407.9zM391 96H121c.5-.5 1-1.1 1.5-1.7c7.8-8.8 19.1-20.5 32.7-32.2C182.8 38.4 219 16 256 16s73.2 22.4 100.8 46.1c13.7 11.7 24.9 23.4 32.7 32.2c.5 .6 1 1.1 1.5 1.7zM496 448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V272H496V448zM112 336a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm16-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM160 448a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm16-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm16-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM288 448a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-16-64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-48 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM80 192a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm112-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faLighthouse = {
    prefix: 'fat',
    iconName: 'lighthouse',
    icon: [
      640,
      512,
      [],
      'e612',
      
      'M11.3 .7l144 64c4 1.8 5.9 6.5 4.1 10.6s-6.5 5.9-10.6 4.1l-144-64C.7 13.5-1.1 8.8 .7 4.8S7.2-1.1 11.3 .7zm144 190.6l-144 64c-4 1.8-8.8 0-10.6-4.1s0-8.8 4.1-10.6l144-64c4-1.8 8.8 0 10.6 4.1s0 8.8-4.1 10.6zM315.7 1.3c2.6-1.7 6-1.7 8.7 0l112 72c3.7 2.4 4.8 7.3 2.4 11.1s-7.3 4.8-11.1 2.4L416 79.2V128H400V68.9L320 17.5 240 68.9V128H224V79.2l-11.7 7.5c-3.7 2.4-8.7 1.3-11.1-2.4s-1.3-8.7 2.4-11.1l112-72zM176.3 496H272V432c0-26.5 21.5-48 48-48s48 21.5 48 48v64h95.7l-61-320H237.2l-61 320zM419 176l61 320h16c4.4 0 8 3.6 8 8s-3.6 8-8 8H480 464 368 352 288 272 176 160 144c-4.4 0-8-3.6-8-8s3.6-8 8-8h16l61-320h-5c-4.4 0-8-3.6-8-8s3.6-8 8-8h8H416h8c4.4 0 8 3.6 8 8s-3.6 8-8 8h-5zM352 432c0-17.7-14.3-32-32-32s-32 14.3-32 32v64h64V432zM639.3 4.8c1.8 4 0 8.8-4.1 10.6l-144 64c-4 1.8-8.8 0-10.6-4.1s0-8.8 4.1-10.6l144-64c4-1.8 8.8 0 10.6 4.1zm-158.6 176c1.8-4 6.5-5.9 10.6-4.1l144 64c4 1.8 5.9 6.5 4.1 10.6s-6.5 5.9-10.6 4.1l-144-64c-4-1.8-5.9-6.5-4.1-10.6z'
      
    ]
  };

  

  
  

  var faBahai = {
    prefix: 'fat',
    iconName: 'bahai',
    icon: [
      576,
      512,
      ["haykal"],
      'f666',
      
      'M287.7 0c3.6 0 6.8 2.4 7.7 5.9l36.4 136.5L447.6 61.3c3-2.1 7-1.9 9.7 .4s3.6 6.2 2.1 9.5l-59.9 128 140.9 12.1c3.6 .3 6.6 3 7.2 6.6s-1.2 7.1-4.5 8.6L414.9 286.1 515 385.9c2.6 2.6 3.1 6.5 1.3 9.7s-5.5 4.7-9 3.7L370.7 362.6l12.5 140.7c.3 3.6-1.8 7-5.2 8.2s-7.2 0-9.3-2.9l-81-115.8-81 115.8c-2.1 3-5.9 4.2-9.3 2.9s-5.6-4.6-5.2-8.2l12.5-140.7L68.2 399.3c-3.5 .9-7.2-.6-9-3.7s-1.3-7.1 1.3-9.7l100.1-99.8L32.3 226.6c-3.3-1.5-5.1-5.1-4.5-8.6s3.6-6.3 7.2-6.6l140.9-12.1L116 71.2c-1.5-3.3-.7-7.2 2.1-9.5s6.8-2.5 9.7-.4l115.7 81.2L280 5.9c.9-3.5 4.1-5.9 7.7-5.9zm0 39L256.1 157.6c-.7 2.5-2.5 4.6-5 5.5s-5.2 .5-7.3-1L143.2 91.6l52 111.2c1.1 2.4 1 5.1-.3 7.4s-3.6 3.7-6.2 4L66.3 224.7l111.4 51.7c2.4 1.1 4.1 3.3 4.5 5.9s-.4 5.2-2.2 7.1L93 376l118.6-31.9c2.5-.7 5.2-.1 7.2 1.6s3.1 4.2 2.8 6.8L210.8 474.8l70.3-100.6c1.5-2.1 3.9-3.4 6.6-3.4s5.1 1.3 6.6 3.4l70.3 100.6L353.8 352.6c-.2-2.6 .8-5.2 2.8-6.8s4.7-2.3 7.2-1.6L482.4 376l-87-86.7c-1.9-1.8-2.7-4.5-2.2-7.1s2.1-4.8 4.5-5.9l111.4-51.7L386.7 214.1c-2.6-.2-4.9-1.7-6.2-4s-1.4-5-.3-7.4l52-111.2L331.7 162.1c-2.1 1.5-4.9 1.9-7.3 1s-4.3-2.9-5-5.5L287.7 39z'
      
    ]
  };

  
    var faHaykal = faBahai;
  

  
  

  var faUserDoctorMessage = {
    prefix: 'fat',
    iconName: 'user-doctor-message',
    icon: [
      640,
      512,
      ["user-md-chat"],
      'f82e',
      
      'M224 240a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zm46.8 320H177.2c-8.6 0-17 .7-25.2 2v46.7c22.7 3.8 40 23.6 40 47.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-23.8 17.3-43.5 40-47.3V325.3C66.9 343.5 16 406.4 16 481.2c0 8.2 6.6 14.8 14.8 14.8H417.2c8.2 0 14.8-6.6 14.8-14.8c0-74.8-50.9-137.7-120-155.9v43.4c22.7 3.8 40 23.6 40 47.3v40c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8s3.6-8 8-8h8V416c0-17.7-14.3-32-32-32s-32 14.3-32 32v32h8c4.4 0 8 3.6 8 8s-3.6 8-8 8H264c-4.4 0-8-3.6-8-8V416c0-23.8 17.3-43.5 40-47.3V322c-8.2-1.3-16.6-2-25.2-2zM0 481.2C0 383.3 79.3 304 177.2 304h93.6C368.7 304 448 383.3 448 481.2c0 17-13.8 30.8-30.8 30.8H30.8C13.8 512 0 498.2 0 481.2zM112 416a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM464 224v45.8l69.8-58.1c2.9-2.4 6.5-3.7 10.2-3.7h48c17.7 0 32-14.3 32-32V48c0-17.7-14.3-32-32-32H432c-17.7 0-32 14.3-32 32V176c0 17.7 14.3 32 32 32h16c8.8 0 16 7.2 16 16zm-80-48V48c0-26.5 21.5-48 48-48H592c26.5 0 48 21.5 48 48V176c0 26.5-21.5 48-48 48H544l-69.8 58.1c-10.4 8.7-26.2 1.3-26.2-12.3V240 224H432c-26.5 0-48-21.5-48-48z'
      
    ]
  };

  
    var faUserMdChat = faUserDoctorMessage;
  

  
  

  var faTrailer = {
    prefix: 'fat',
    iconName: 'trailer',
    icon: [
      640,
      512,
      [],
      'e041',
      
      'M48 48C30.3 48 16 62.3 16 80V336c0 17.7 14.3 32 32 32H64c4.4 0 8 3.6 8 8s-3.6 8-8 8H48c-26.5 0-48-21.5-48-48V80C0 53.5 21.5 32 48 32H480c26.5 0 48 21.5 48 48V368H632c4.4 0 8 3.6 8 8s-3.6 8-8 8H320c-4.4 0-8-3.6-8-8s3.6-8 8-8H512V80c0-17.7-14.3-32-32-32H48zM72 96c4.4 0 8 3.6 8 8V248c0 4.4-3.6 8-8 8s-8-3.6-8-8V104c0-4.4 3.6-8 8-8zm96 0c4.4 0 8 3.6 8 8V248c0 4.4-3.6 8-8 8s-8-3.6-8-8V104c0-4.4 3.6-8 8-8zm96 0c4.4 0 8 3.6 8 8V248c0 4.4-3.6 8-8 8s-8-3.6-8-8V104c0-4.4 3.6-8 8-8zm96 0c4.4 0 8 3.6 8 8V312c0 4.4-3.6 8-8 8s-8-3.6-8-8V104c0-4.4 3.6-8 8-8zm96 0c4.4 0 8 3.6 8 8V312c0 4.4-3.6 8-8 8s-8-3.6-8-8V104c0-4.4 3.6-8 8-8zM272 384a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 384a96 96 0 1 1 192 0A96 96 0 1 1 96 384z'
      
    ]
  };

  

  
  

  var faBoxHeart = {
    prefix: 'fat',
    iconName: 'box-heart',
    icon: [
      448,
      512,
      [],
      'f49d',
      
      'M232 48H342.4c19 0 36.2 11.2 43.9 28.5l41.6 93.6c.9 1.9 1.6 3.9 2.2 5.9H232V48zM16 192H432V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V192zm200-16H18c.6-2 1.3-4 2.2-5.9L61.7 76.5C69.4 59.2 86.6 48 105.6 48H216V176zM400.9 70c-10.3-23.1-33.2-38-58.5-38H105.6C80.3 32 57.4 46.9 47.1 70L5.5 163.6c-3.6 8.2-5.5 17-5.5 26V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V189.6c0-9-1.9-17.8-5.5-26L400.9 70zM141.1 258.8c17.4-17.4 45.6-17.4 63 0l14.3 14.3c1.5 1.5 3.5 2.3 5.7 2.3s4.2-.8 5.7-2.3l14.3-14.3c17.4-17.4 45.6-17.4 63 0s17.4 45.6 0 63L229.7 399c-3.1 3.1-8.2 3.1-11.3 0l-77.3-77.3c-17.4-17.4-17.4-45.6 0-63zm74.3-11.3c-23.6-23.6-62-23.6-85.6 0s-23.6 62 0 85.6L207 410.3c9.4 9.4 24.6 9.4 33.9 0l77.3-77.3c23.6-23.6 23.6-62 0-85.6s-62-23.6-85.6 0l-8.6 8.6-8.6-8.6z'
      
    ]
  };

  

  
  

  var faCalendar = {
    prefix: 'fat',
    iconName: 'calendar',
    icon: [
      448,
      512,
      [128197,128198],
      'f133',
      
      'M120 0c4.4 0 8 3.6 8 8V64H320V8c0-4.4 3.6-8 8-8s8 3.6 8 8V64h48c35.3 0 64 28.7 64 64v48 16V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 176 128C0 92.7 28.7 64 64 64h48V8c0-4.4 3.6-8 8-8zM432 192H16V448c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V192zM112 120V80H64c-26.5 0-48 21.5-48 48v48H432V128c0-26.5-21.5-48-48-48H336v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V80H128v40c0 4.4-3.6 8-8 8s-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faBoothCurtain = {
    prefix: 'fat',
    iconName: 'booth-curtain',
    icon: [
      512,
      512,
      [],
      'f734',
      
      'M16 40V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V40C0 17.9 17.9 0 40 0H64V16H40C26.7 16 16 26.7 16 40zM432 16V400c0 17.7 14.3 32 32 32s32-14.3 32-32V40c0-13.3-10.7-24-24-24H432zm64 419.8c-8.5 7.6-19.7 12.2-32 12.2c-16.7 0-31.4-8.5-40-21.5c-8.6 12.9-23.3 21.5-40 21.5s-31.4-8.5-40-21.5c-8.6 12.9-23.3 21.5-40 21.5s-31.4-8.5-40-21.5c-8.6 12.9-23.3 21.5-40 21.5s-31.4-8.5-40-21.5c-8.6 12.9-23.3 21.5-40 21.5c-26.5 0-48-21.5-48-48V32c0-17.7 14.3-32 32-32h48 16 64 16 64 16 64 16 40c22.1 0 40 17.9 40 40V400 504c0 4.4-3.6 8-8 8s-8-3.6-8-8V435.8zM128 16c-8.8 0-16 7.2-16 16V400c0 17.7 14.3 32 32 32s32-14.3 32-32V16H128zm64 0V400c0 17.7 14.3 32 32 32s32-14.3 32-32V16H192zm80 0V400c0 17.7 14.3 32 32 32s32-14.3 32-32V16H272zm80 0V400c0 17.7 14.3 32 32 32s32-14.3 32-32V16H352z'
      
    ]
  };

  

  
  

  var faCloudMoonRain = {
    prefix: 'fat',
    iconName: 'cloud-moon-rain',
    icon: [
      576,
      512,
      [],
      'f73c',
      
      'M345.5 104c17.6-49.9 65.6-85.7 122.1-85.7c3.7 0 7.4 .2 11 .5c-36.2 20.3-60.7 58.8-60.7 103c0 65.3 53.4 118.2 119.4 118.2c7 0 13.8-.6 20.5-1.7c-21.4 20.6-50.1 34-81.9 35.9c1.4 5.1 2.5 10.4 3.2 15.8c34.8-2.7 66.2-17.5 89.8-40.2c5.1-4.9 6.4-12.5 3.2-18.7s-10.1-9.7-17-8.6c-5.8 1-11.7 1.5-17.8 1.5c-57.2 0-103.4-45.9-103.4-102.2c0-38.1 21.1-71.4 52.5-89c6.1-3.4 9.3-10.5 7.8-17.4s-7.3-12-14.3-12.6c-4.1-.3-8.2-.5-12.3-.5C404.1 2.3 350 42.7 330.3 99.1c5.2 1.3 10.3 2.9 15.3 4.9zM92.2 417.2c-3.8-2.3-8.7-1-11 2.7l-48 80c-2.3 3.8-1 8.7 2.7 11s8.7 1 11-2.7l48-80c2.3-3.8 1-8.7-2.7-11zm96 0c-3.8-2.3-8.7-1-11 2.7l-48 80c-2.3 3.8-1 8.7 2.7 11s8.7 1 11-2.7l48-80c2.3-3.8 1-8.7-2.7-11zm96 0c-3.8-2.3-8.7-1-11 2.7l-48 80c-2.3 3.8-1 8.7 2.7 11s8.7 1 11-2.7l48-80c2.3-3.8 1-8.7-2.7-11zm96 0c-3.8-2.3-8.7-1-11 2.7l-48 80c-2.3 3.8-1 8.7 2.7 11s8.7 1 11-2.7l48-80c2.3-3.8 1-8.7-2.7-11zM96 192c0-44.2 35.8-80 80-80c32 0 59.6 18.8 72.4 46c1.1 2.3 3.2 3.9 5.7 4.4s5.1-.2 6.9-1.9c11.4-10.3 26.4-16.5 42.9-16.5c35.3 0 64 28.7 64 64c0 7.5-1.3 14.7-3.7 21.4c-.8 2.4-.5 5 .9 7.1s3.7 3.4 6.2 3.5c33.7 1.8 60.5 29.7 60.5 63.9c0 35.3-28.7 64-64 64c-.7 0-1.5 0-2.2 0l0 0h-.3H99v0l-.3 0c-.9 0-1.8 0-2.8 0c-44.2 0-80-35.8-80-80c0-41.8 32.1-76.2 73.1-79.7c2.1-.2 4.1-1.2 5.5-2.8s2-3.8 1.8-5.9c-.2-2.5-.4-5-.4-7.6zm80-96c-53 0-96 43-96 96l0 1.3C34.6 200.9 0 240.4 0 288c0 53 43 96 96 96c1.1 0 2.1 0 3.2-.1H365.3c.9 0 1.8 0 2.6 0c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C241.4 114.6 210.8 96 176 96z'
      
    ]
  };

  

  
  

  var faUpDown = {
    prefix: 'fat',
    iconName: 'up-down',
    icon: [
      256,
      512,
      [8597,11021,"arrows-alt-v"],
      'f338',
      
      'M108.7 8c5.1-5.1 12.1-8 19.3-8s14.2 2.9 19.3 8L247 107.7c5.7 5.7 9 13.5 9 21.7c0 16.9-13.7 30.6-30.6 30.6H176V352h49.4c16.9 0 30.6 13.7 30.6 30.6c0 8.1-3.2 15.9-9 21.7L147.3 504c-5.1 5.1-12.1 8-19.3 8s-14.2-2.9-19.3-8L9 404.3c-5.7-5.7-9-13.5-9-21.7C0 365.7 13.7 352 30.6 352H80V160H30.6C13.7 160 0 146.3 0 129.4c0-8.1 3.2-15.9 9-21.7L108.7 8zM128 16c-3 0-5.9 1.2-8 3.3L20.3 119c-2.7 2.7-4.3 6.5-4.3 10.3c0 8.1 6.5 14.6 14.6 14.6H88c4.4 0 8 3.6 8 8V360c0 4.4-3.6 8-8 8H30.6c-8.1 0-14.6 6.6-14.6 14.6c0 3.9 1.5 7.6 4.3 10.3L120 492.7l-5.7 5.7 5.7-5.7c2.1 2.1 5 3.3 8 3.3s5.9-1.2 8-3.3l5.7 5.7-5.7-5.7L235.7 393c2.7-2.7 4.3-6.5 4.3-10.3c0-8.1-6.5-14.6-14.6-14.6H168c-4.4 0-8-3.6-8-8V152c0-4.4 3.6-8 8-8h57.4c8.1 0 14.6-6.5 14.6-14.6c0-3.9-1.5-7.6-4.3-10.3L136 19.3c-2.1-2.1-5-3.3-8-3.3z'
      
    ]
  };

  
    var faArrowsAltV = faUpDown;
  

  
  

  var faPencilMechanical = {
    prefix: 'fat',
    iconName: 'pencil-mechanical',
    icon: [
      512,
      512,
      [],
      'e5ca',
      
      'M448 0c-7.2 0-14.2 2.9-19.3 8L384.8 51.9C379.6 49.3 373.9 48 368 48c-10.2 0-20.1 4.1-27.3 11.3l-35 35L276.3 65c-15.6-15.6-40.9-15.6-56.6 0L114.3 170.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L231 76.3c9.4-9.4 24.6-9.4 33.9 0l29.4 29.4L80.9 319.1c-5.9 5.9-10.1 13.1-12.3 21.1L33.3 467.4 2.3 498.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l30.9-30.9 127.2-35.3c8-2.2 15.2-6.5 21.1-12.3L452.7 171.3c7.2-7.2 11.3-17.1 11.3-27.3c0-5.9-1.3-11.6-3.9-16.8L504 83.3c5.1-5.1 8-12.1 8-19.3s-2.9-14.2-8-19.3L467.3 8c-5.1-5.1-12.1-8-19.3-8zm2.3 114.3L397.7 61.7 440 19.3c2.1-2.1 5-3.3 8-3.3s5.9 1.2 8 3.3L492.7 56c2.1 2.1 3.3 5 3.3 8s-1.2 5.9-3.3 8l-42.3 42.3zm-9 13.7c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16l-247 247L105 317.7l247-247c4.2-4.2 10-6.6 16-6.6s11.8 2.4 16 6.6L441.4 128zM92.2 330.4l1.4-1.4L183 418.3l-1.4 1.4c-3.9 3.9-8.7 6.7-14.1 8.2L51.9 460.1 84 344.5c1.5-5.3 4.3-10.2 8.2-14.1z'
      
    ]
  };

  

  
  

  var faTurtle = {
    prefix: 'fat',
    iconName: 'turtle',
    icon: [
      576,
      512,
      [128034],
      'f726',
      
      'M208 48C119.6 48 48 119.6 48 208v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V208c0-97.2 78.8-176 176-176s176 78.8 176 176v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V208c0-88.4-71.6-160-160-160zM416 200c0-39.8 32.2-72 72-72c48.6 0 88 39.4 88 88v16c0 30.9-25.1 56-56 56H485.8l-1 3c-18.5 55.5-70.5 93-129 93H336v56c0 22.1-17.9 40-40 40H280c-22.1 0-40-17.9-40-40V384H176v56c0 22.1-17.9 40-40 40H120c-22.1 0-40-17.9-40-40V384H40c-22.1 0-40-17.9-40-40s17.9-40 40-40H368c26.5 0 48-21.5 48-48V200zM240 368h16v16 32 24c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V416 384 368h16 19.7c51.7 0 97.5-33.1 113.8-82.1l2.8-8.5c1.1-3.3 4.1-5.5 7.6-5.5h40c22.1 0 40-17.9 40-40V216c0-39.8-32.2-72-72-72c-30.9 0-56 25.1-56 56v56c0 35.3-28.7 64-64 64H320 256 160 96 40c-13.3 0-24 10.7-24 24s10.7 24 24 24H80 96v16 32 24c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V416 384 368h16 64zM496 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faCaravanSimple = {
    prefix: 'fat',
    iconName: 'caravan-simple',
    icon: [
      640,
      512,
      ["caravan-alt"],
      'e000',
      
      'M80 48c-35.3 0-64 28.7-64 64V336c0 35.3 28.7 64 64 64H97.3c7.6-45.4 47.1-80 94.7-80s87.1 34.6 94.7 80l0 0H288 560V192c0-79.5-64.5-144-144-144H80zM96 416H80c-44.2 0-80-35.8-80-80V112C0 67.8 35.8 32 80 32H416c88.4 0 160 71.6 160 160V400l56 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-56 0H560 288c0 53-43 96-96 96s-96-43-96-96zM224 144H96c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H224c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zM96 128H224c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32zm256 16c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16H352zm-32 16c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V160zM272 416a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z'
      
    ]
  };

  
    var faCaravanAlt = faCaravanSimple;
  

  
  

  var faPersonWalkingLuggage = {
    prefix: 'fat',
    iconName: 'person-walking-luggage',
    icon: [
      576,
      512,
      [],
      'e554',
      
      'M361.1 187.3c-4.6-4-11-5.1-16.6-2.8c-1.1 .5-2.2 .9-3.4 1.4l-5.7 2.5c-21.6 9.6-37.9 28.3-44.4 51.1l-3.7 12.9c-2.4 8.5-11.3 13.4-19.8 11s-13.4-11.3-11-19.8l3.7-12.9c9.1-31.9 31.9-58.1 62.2-71.6l5.7-2.5c18.8-8.3 39-12.6 59.6-12.6c38.1 0 72.5 22.9 87.1 58.1l16.5 39.7c1.1 2.6 2.9 4.9 5.2 6.6l25 18.8c7.1 5.3 8.5 15.3 3.2 22.4s-15.3 8.5-22.4 3.2l-28.5-21.4c-4.6-3.4-8.1-8-10.3-13.3l-10.2-24.5c-2.6-6.3-8.9-10.2-15.6-9.8s-12.6 5-14.5 11.5L404 300.8c-1.6 5.4-.2 11.2 3.6 15.3l49.5 54c3.6 3.9 6.2 8.7 7.5 13.9l23 92.1c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6l-22-88.1c-.6-2.6-1.9-5-3.7-6.9l-70.7-77.1c-11.1-12.1-15.2-29-11-44.8L366 203.4c1.6-5.9-.3-12.1-4.9-16.1zM432 16a36 36 0 1 1 0 72 36 36 0 1 1 0-72zM331.4 209c3.3-2.3 6.8-4.3 10.6-6l5.7-2.5c1-.4 1.9-.8 2.9-1.2l-1.3 4.8-2.6 9.6-1.5 5.6-11.6 43.6c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 12.1-41.2 7.2-24.4 9.8 23.5 .4 1c3.3 7.9 8.7 14.8 15.5 19.9l28.5 21.4c14.1 10.6 34.2 7.7 44.8-6.4s7.7-34.2-6.4-44.8l-25-18.8-16.5-39.7C472.5 154.8 432.3 128 387.7 128c-22.8 0-45.3 4.8-66.1 14l-5.7 2.5c-34.6 15.4-60.7 45.3-71.1 81.8l-3.7 12.9c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l3.7-12.9c4.1-14.3 13-26.6 24.9-34.9zM484 52A52 52 0 1 0 380 52a52 52 0 1 0 104 0zM323 343.9c-4.1-1.6-8.8 .4-10.4 4.5L292.7 398l-59.4 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l61.7-61.7c4.6-4.6 8.2-10.1 10.6-16.1L366.1 387c1.6-4.1-.4-8.8-4.5-10.4s-8.8 .4-10.4 4.5l-15.1 37.9c-1.6 4-4 7.7-7.1 10.7l-61.7 61.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l60.5-60.5 1.2-1.2 .6-1.5 20.5-51.1c1.6-4.1-.4-8.8-4.5-10.4zm-60.1-51.9c2.3-3.8 1-8.7-2.8-11s-8.7-1-11 2.8L213.4 344 144 304c-15.3-8.8-34.9-3.6-43.7 11.7l-64 110.9c-8.8 15.3-3.6 34.9 11.7 43.7l55.4 32c15.3 8.8 34.9 3.6 43.7-11.7l76-131.6 39.8-66.9zM136 317.9l69.3 40-72 124.7c-4.4 7.7-14.2 10.3-21.9 5.9L56 456.4c-7.7-4.4-10.3-14.2-5.9-21.9l64-110.9c4.4-7.7 14.2-10.3 21.9-5.9z'
      
    ]
  };

  

  
  

  var faParagraphLeft = {
    prefix: 'fat',
    iconName: 'paragraph-left',
    icon: [
      384,
      512,
      ["paragraph-rtl"],
      'f878',
      
      'M304 16h40c4.4 0 8-3.6 8-8s-3.6-8-8-8H208h-8H184 136C78.6 0 32 46.6 32 104s46.6 104 104 104h56V312c0 4.4 3.6 8 8 8s8-3.6 8-8l0-104v-8V24 16h80V312c0 4.4 3.6 8 8 8s8-3.6 8-8V16zM192 24V192H136c-48.6 0-88-39.4-88-88s39.4-88 88-88h48 8v8zM109.1 342.1c3.4-2.8 3.9-7.9 1-11.3s-7.9-3.9-11.3-1l-96 80C1.1 411.4 0 413.6 0 416s1.1 4.6 2.9 6.1l96 80c3.4 2.8 8.4 2.4 11.3-1s2.4-8.4-1-11.3L30.1 424H376c4.4 0 8-3.6 8-8s-3.6-8-8-8H30.1l79-65.9z'
      
    ]
  };

  
    var faParagraphRtl = faParagraphLeft;
  

  
  

  var faBagsShopping = {
    prefix: 'fat',
    iconName: 'bags-shopping',
    icon: [
      576,
      512,
      [128717],
      'f847',
      
      'M144 96c0-44.2 35.8-80 80-80s80 35.8 80 80v64H144V96zm-16 64H64c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64h96V464H64c-26.5 0-48-21.5-48-48V224c0-26.5 21.5-48 48-48H384c26.5 0 48 21.5 48 48h16c0-35.3-28.7-64-64-64H320V96c0-53-43-96-96-96s-96 43-96 96v64zM512 272c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H256c-26.5 0-48-21.5-48-48V320c0-26.5 21.5-48 48-48H512zM192 320V448c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H256c-35.3 0-64 28.7-64 64zm128 8c0-4.4-3.6-8-8-8s-8 3.6-8 8v40c0 44.2 35.8 80 80 80s80-35.8 80-80V328c0-4.4-3.6-8-8-8s-8 3.6-8 8v40c0 35.3-28.7 64-64 64s-64-28.7-64-64V328z'
      
    ]
  };

  

  
  

  var faFan = {
    prefix: 'fat',
    iconName: 'fan',
    icon: [
      512,
      512,
      [],
      'f863',
      
      'M288 32l-10.6 95.7-2.1 18.8c5.5-2.8 11.1-5.4 16.9-7.6c9.7-3.7 19.8-6.5 30.4-8.3c87.1-15 172.3 37.5 188.9 122.9c.3 1.7 .5 3.4 .5 5.1c0 16.2-13.2 29.4-29.4 29.4H480l-95.7-10.6-18.8-2.1c2.8 5.5 5.4 11.1 7.6 16.9c3.7 9.7 6.5 19.8 8.3 30.4c15 87.1-37.5 172.3-123 188.9c-1.7 .3-3.4 .5-5.1 .5c-16.2 0-29.4-13.2-29.4-29.4V480l10.6-95.7 2.1-18.8c-5.5 2.8-11.1 5.4-16.9 7.6c-9.7 3.7-19.8 6.5-30.4 8.3C102.3 396.4 17 344 .5 258.5c-.3-1.7-.5-3.4-.5-5.1C0 237.2 13.2 224 29.4 224H32l95.7 10.6 18.8 2.1c-2.8-5.5-5.4-11.1-7.6-16.9c-3.7-9.7-6.5-19.8-8.3-30.4C115.6 102.3 168 17 253.5 .5c1.7-.3 3.4-.5 5.1-.5C274.8 0 288 13.2 288 29.4V32zM482.6 272c7.4 0 13.4-6 13.4-13.4c0-.8-.1-1.5-.2-2.1c-14.7-75.9-90.9-123.9-170.4-110.2c-15.3 2.6-29.7 7.6-42.7 14.3c-5.2 2.7-11.6 2.3-16.4-1s-7.5-9.1-6.8-15L272 31.1V29.4C272 22 266 16 258.6 16c-.8 0-1.5 .1-2.1 .2c-75.9 14.7-123.9 90.9-110.2 170.4c2.6 15.3 7.6 29.7 14.3 42.7c2.7 5.2 2.3 11.6-1 16.4s-9.1 7.5-15 6.8L31.1 240H29.4C22 240 16 246 16 253.4c0 .8 .1 1.5 .2 2.1c14.7 75.9 90.9 123.9 170.4 110.2c15.3-2.6 29.7-7.6 42.7-14.3c5.2-2.7 11.6-2.3 16.4 1s7.5 9.1 6.8 15L240 480.9v1.7c0 7.4 6 13.4 13.4 13.4c.8 0 1.5-.1 2.1-.2c75.9-14.7 123.9-90.9 110.2-170.4c-2.6-15.3-7.6-29.7-14.3-42.7c-2.7-5.2-2.3-11.6 1-16.4s9.1-7.5 15-6.8L480.9 272h1.7zM272 256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faBlockBrick = {
    prefix: 'fat',
    iconName: 'block-brick',
    icon: [
      448,
      512,
      ["wall-brick"],
      'e3db',
      
      'M128 48v80h88 16 88V48H128zm-16 80V48H64C37.5 48 16 69.5 16 96v32h96zM16 144V248H216V144H16zm0 224h96V264H16V368zm0 16v32c0 26.5 21.5 48 48 48H216V384H128 112 16zm112-16H320V264H128V368zm208 0h96V264H336V368zm96 16H336 320 232v80H384c26.5 0 48-21.5 48-48V384zm0-240H232V248H432V144zm0-16V96c0-26.5-21.5-48-48-48H336v80h96zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z'
      
    ]
  };

  
    var faWallBrick = faBlockBrick;
  

  
  

  var faVoicemail = {
    prefix: 'fat',
    iconName: 'voicemail',
    icon: [
      640,
      512,
      [],
      'f897',
      
      'M144 368a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM288 240c0 55.7-31.7 104.1-78 128H430c-46.3-23.9-78-72.3-78-128c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144H144C64.5 384 0 319.5 0 240S64.5 96 144 96s144 64.5 144 144zM496 368a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM144 304a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-144a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm416 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-144 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z'
      
    ]
  };

  

  
  

  var faPersonArrowDownToLine = {
    prefix: 'fat',
    iconName: 'person-arrow-down-to-line',
    icon: [
      640,
      512,
      [],
      'e538',
      
      'M232 56a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm-96 0a56 56 0 1 1 112 0A56 56 0 1 1 136 56zM122.7 175.7L55.2 315.5c-1.9 4-6.7 5.6-10.7 3.7s-5.6-6.7-3.7-10.7l67.5-139.8c12-24.9 37.2-40.7 64.8-40.7h37.8c27.6 0 52.8 15.8 64.8 40.7l67.5 139.8c1.9 4 .3 8.8-3.7 10.7s-8.8 .3-10.7-3.7L261.3 175.7C252 156.3 232.4 144 210.9 144H173.1c-21.5 0-41.1 12.3-50.4 31.7zM128 240c4.4 0 8 3.6 8 8V480c0 8.8 7.2 16 16 16s16-7.2 16-16V360c0-13.3 10.7-24 24-24s24 10.7 24 24V480c0 8.8 7.2 16 16 16s16-7.2 16-16V248c0-4.4 3.6-8 8-8s8 3.6 8 8V480c0 5.8-1.6 11.3-4.3 16H632c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H124.3c-2.7-4.7-4.3-10.2-4.3-16V248c0-4.4 3.6-8 8-8zm51.7 256h24.6c-2.7-4.7-4.3-10.2-4.3-16V360c0-4.4-3.6-8-8-8s-8 3.6-8 8V480c0 5.8-1.6 11.3-4.3 16zM488 40c0-4.4 3.6-8 8-8s8 3.6 8 8l0 347.5 82.1-89c3-3.2 8.1-3.4 11.3-.5s3.4 8.1 .5 11.3l-96 104c-1.5 1.6-3.6 2.6-5.9 2.6s-4.4-.9-5.9-2.6l-96-104c-3-3.2-2.8-8.3 .5-11.3s8.3-2.8 11.3 .5l82.1 89L488 40z'
      
    ]
  };

  

  
  

  var faObjectIntersect = {
    prefix: 'fat',
    iconName: 'object-intersect',
    icon: [
      512,
      512,
      [],
      'e49d',
      
      'M128 0h96V16H128V0zM96 0V16H64C37.5 16 16 37.5 16 64V96H0V64C0 28.7 28.7 0 64 0H96zM0 128H16v96H0V128zM256 16V0h32c35.3 0 64 28.7 64 64v64H336V64c0-26.5-21.5-48-48-48H256zm80 144h16v16 80 32c0 35.3-28.7 64-64 64H224 176 160V336 256 224c0-35.3 28.7-64 64-64h64 48zM160 384h16v64c0 26.5 21.5 48 48 48h32v16H224c-35.3 0-64-28.7-64-64V384zm-32-32H64c-35.3 0-64-28.7-64-64V256H16v32c0 26.5 21.5 48 48 48h64v16zM384 176V160h64c35.3 0 64 28.7 64 64v32H496V224c0-26.5-21.5-48-48-48H384zm32 336V496h32c26.5 0 48-21.5 48-48V416h16v32c0 35.3-28.7 64-64 64H416zm80-224h16v96H496V288zM288 512V496h96v16H288zm48-336H224c-26.5 0-48 21.5-48 48V336H288c26.5 0 48-21.5 48-48V176z'
      
    ]
  };

  

  
  

  var faChimney = {
    prefix: 'fat',
    iconName: 'chimney',
    icon: [
      448,
      512,
      [],
      'f78b',
      
      'M32 48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H416c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H32zM0 64C0 46.3 14.3 32 32 32H416c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32l0 104V376v96c0 4.4-3.6 8-8 8s-8-3.6-8-8V384H280 176v88c0 4.4-3.6 8-8 8s-8-3.6-8-8V384H48v88c0 4.4-3.6 8-8 8s-8-3.6-8-8V376 264l0-104c-17.7 0-32-14.3-32-32V64zm48 96v96H160V160H48zm128 0v96H280 400V160l-224 0zm-8 208H272V272H168 48v96H168zm120 0H400V272H288v96z'
      
    ]
  };

  

  
  

  var faVialCircleCheck = {
    prefix: 'fat',
    iconName: 'vial-circle-check',
    icon: [
      512,
      512,
      [],
      'e596',
      
      'M0 40c0-4.4 3.6-8 8-8H32 48 208h16 24c4.4 0 8 3.6 8 8s-3.6 8-8 8H224V266.8c-6.1 8.7-11.5 18-16 27.8V208H48V384c0 44.2 35.8 80 80 80c31.4 0 58.6-18.1 71.7-44.4c2 6.6 4.4 13 7.1 19.2C189.5 463.7 160.6 480 128 480c-53 0-96-43-96-96V48H8c-4.4 0-8-3.6-8-8zm48 8V192H208V48H48zM368 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm69.7 98.3c3.1 3.1 3.1 8.2 0 11.3l-80 80c-3.1 3.1-8.2 3.1-11.3 0l-48-48c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L352 396.7l74.3-74.3c3.1-3.1 8.2-3.1 11.3 0z'
      
    ]
  };

  

  
  

  var faInfinity = {
    prefix: 'fat',
    iconName: 'infinity',
    icon: [
      640,
      512,
      [8734,9854],
      'f534',
      
      'M0 240.2C0 169.4 57.4 112 128.2 112c32.7 0 64.2 12.5 88 35L320 245l103.8-98c23.8-22.5 55.3-35 88-35C582.6 112 640 169.4 640 240.2v31.6C640 342.6 582.6 400 511.8 400c-32.7 0-64.2-12.5-88-35L320 267 216.2 365c-23.8 22.5-55.3 35-88 35C57.4 400 0 342.6 0 271.8V240.2zM308.3 256L205.3 158.6c-20.8-19.7-48.4-30.6-77-30.6C66.2 128 16 178.2 16 240.2v31.6C16 333.8 66.2 384 128.2 384c28.7 0 56.2-11 77-30.6L308.3 256zm23.3 0l103.1 97.4c20.8 19.7 48.4 30.6 77 30.6c62 0 112.2-50.2 112.2-112.2V240.2c0-62-50.2-112.2-112.2-112.2c-28.6 0-56.2 11-77 30.6L331.7 256z'
      
    ]
  };

  

  
  

  var faCassetteVhs = {
    prefix: 'fat',
    iconName: 'cassette-vhs',
    icon: [
      576,
      512,
      [128252,"vhs"],
      'f8ec',
      
      'M16 160V416c0 26.5 21.5 48 48 48H512c26.5 0 48-21.5 48-48V160H16zm0-16H560V96c0-26.5-21.5-48-48-48H64C37.5 48 16 69.5 16 96v48zM576 96v48 8 8V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160v-8-8V96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64zM109.9 228.8C99.1 240.2 80 265.6 80 304s19.1 63.8 29.9 75.2c3 3.1 7.5 4.8 12.9 4.8H208V224H122.8c-5.3 0-9.9 1.7-12.9 4.8zM352 384V224H224V384H352zm103.7 0c4.2 0 7.6-1.1 9.9-3c10-8.4 30.5-31.2 30.5-77s-20.5-68.6-30.5-77c-2.3-1.9-5.6-3-9.9-3H368V384h87.7zM122.8 208H216 360h95.7c6.7 0 14.2 1.7 20.2 6.8C488.7 225.7 512 252.6 512 304s-23.3 78.3-36.1 89.2c-6 5.1-13.5 6.8-20.2 6.8H360 216 122.8c-8.6 0-17.8-2.8-24.4-9.8C85.9 377.2 64 348 64 304s21.9-73.2 34.3-86.2c6.7-7 15.8-9.8 24.4-9.8zM176 264c-22.1 0-40 17.9-40 40s17.9 40 40 40c4.4 0 8 3.6 8 8s-3.6 8-8 8c-30.9 0-56-25.1-56-56s25.1-56 56-56c4.4 0 8 3.6 8 8s-3.6 8-8 8zm264 40c0-22.1-17.9-40-40-40c-4.4 0-8-3.6-8-8s3.6-8 8-8c30.9 0 56 25.1 56 56s-25.1 56-56 56c-4.4 0-8-3.6-8-8s3.6-8 8-8c22.1 0 40-17.9 40-40z'
      
    ]
  };

  
    var faVhs = faCassetteVhs;
  

  
  

  var faChartColumn = {
    prefix: 'fat',
    iconName: 'chart-column',
    icon: [
      512,
      512,
      [],
      'e0e3',
      
      'M16 40c0-4.4-3.6-8-8-8s-8 3.6-8 8V408c0 39.8 32.2 72 72 72H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H72c-30.9 0-56-25.1-56-56V40zm416 72c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16s-16-7.2-16-16V128c0-8.8 7.2-16 16-16zM240 176c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16zm-96 96c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16zm192-32c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V256c0-8.8 7.2-16 16-16zM464 128c0-17.7-14.3-32-32-32s-32 14.3-32 32V352c0 17.7 14.3 32 32 32s32-14.3 32-32V128zM272 192c0-17.7-14.3-32-32-32s-32 14.3-32 32V352c0 17.7 14.3 32 32 32s32-14.3 32-32V192zm-96 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V288zm160-64c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32z'
      
    ]
  };

  

  
  

  var faHippo = {
    prefix: 'fat',
    iconName: 'hippo',
    icon: [
      640,
      512,
      [129435],
      'f6ed',
      
      'M411 108.1c-7 10.2-11 22.6-11 35.9v16c0 15.5-7.7 28.3-15.8 37.4C374.1 208.8 368 223.6 368 240c0 30.9 22 56.8 51.2 62.7l6.3 1.3H432h40 16 48 16 8c9.1 0 17.8-1.9 25.6-5.3l6.8-3 6-4.5C614 279.5 624 260.9 624 240c0-9.2-1.9-17.9-5.4-25.8c-5.7-8.5-15.5-14.2-26.6-14.2c-17.7 0-32 14.3-32 32c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-26.2 21-47.5 47-48c-1.6-.9-3.2-1.7-4.9-2.4C573 175.7 560 162.4 560 144c0-10-2.3-19.4-6.3-27.8l-5-10.2 8-8 6.6-6.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L530.6 78.8l-6.8 6.8-9.2-2.8C508.8 81 502.5 80 496 80H464c-2.8 0-5.5 .2-8.1 .5l-7.8 1-5.5-5.5L427.3 60.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l4.4 4.4 9.4 9.4L411 108.1zM639.8 233.9c.2 2 .2 4 .2 6.1c0 26.2-12.6 49.4-32 64v9.3V336c0 13.3-10.7 24-24 24H560c-13.3 0-24-10.7-24-24V320H520 504 488v16c0 13.3-10.7 24-24 24H440c-13.3 0-24-10.7-24-24V320v-1.6c-36.5-7.4-64-39.7-64-78.4c0-20.4 7.7-39.1 20.3-53.2c6.7-7.5 11.7-16.7 11.7-26.8V144c0-15.1 4.2-29.2 11.4-41.2l-24.2-9.1C347 84.7 321.3 80 295.4 80H216C123.2 80 48 155.2 48 248v8 0l0 35.1c0 30.9-10.5 60.9-29.8 85L14.2 381c-2.8 3.4-7.8 4-11.2 1.2s-4-7.8-1.2-11.2l3.9-4.9c17-21.3 26.3-47.7 26.3-75L32 256v0-8C32 146.4 114.4 64 216 64h79.4c27.8 0 55.4 5 81.5 14.8l8.8 3.3c-3.7-11.1-1.1-23.8 7.8-32.7c12.5-12.5 32.8-12.5 45.3 0l15.3 15.3c3.3-.4 6.7-.6 10.1-.6h32c8.1 0 15.9 1.2 23.3 3.4l10.1-10.1c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-6.6 6.6c5.1 10.5 7.9 22.3 7.9 34.8c0 10.2 7.4 18.8 16.7 23c17.6 7.9 31.8 22 39.9 39.5c4.7 7.4 7.3 16.1 7.3 25.5c0 .7-.1 1.3-.2 1.9zM592 313.3c-5.1 2.2-10.4 3.9-16 5.1c-5.2 1-10.5 1.6-16 1.6h-8v16c0 4.4 3.6 8 8 8h24c4.4 0 8-3.6 8-8v-5.5V313.3zM440 344h24c4.4 0 8-3.6 8-8V320H456h-8H432v16c0 4.4 3.6 8 8 8zm-8 39.3c2.6 .4 5.3 .7 8 .7h8v56c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V371.1l-5.8 1.9c-37.8 12.6-78.6 12.6-116.4 0l-5.8-1.9V440c0 22.1-17.9 40-40 40H104c-22.1 0-40-17.9-40-40V344c0-4.4 3.6-8 8-8s8 3.6 8 8v96c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V360c0-2.6 1.2-5 3.3-6.5s4.8-1.9 7.2-1.1l16.3 5.4c34.5 11.5 71.8 11.5 106.3 0l16.3-5.4c2.4-.8 5.1-.4 7.2 1.1s3.3 3.9 3.3 6.5v80c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V383.3zM464 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-56 56c-17.7 0-32 14.3-32 32c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-26.5 21.5-48 48-48s48 21.5 48 48c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-17.7-14.3-32-32-32z'
      
    ]
  };

  

  
  

  var faTransformerBolt = {
    prefix: 'fat',
    iconName: 'transformer-bolt',
    icon: [
      384,
      512,
      [],
      'e2a4',
      
      'M112 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V48H48c-4.4 0-8 3.6-8 8s3.6 8 8 8H96V96H48c-4.4 0-8 3.6-8 8s3.6 8 8 8H96v48H40 8c-4.4 0-8 3.6-8 8s3.6 8 8 8H32V496H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H40 344h32c4.4 0 8-3.6 8-8s-3.6-8-8-8H352V176h24c4.4 0 8-3.6 8-8s-3.6-8-8-8H344 288V112h48c4.4 0 8-3.6 8-8s-3.6-8-8-8H288V64h48c4.4 0 8-3.6 8-8s-3.6-8-8-8H288V8c0-4.4-3.6-8-8-8s-8 3.6-8 8V48H224c-4.4 0-8 3.6-8 8s3.6 8 8 8h48V96H224c-4.4 0-8 3.6-8 8s3.6 8 8 8h48v48H112V112h48c4.4 0 8-3.6 8-8s-3.6-8-8-8H112V64h48c4.4 0 8-3.6 8-8s-3.6-8-8-8H112V8zM280 176h56V496H48V176h56H280zM116.2 336l104.1-90.2-20.1 80.3c-.6 2.4-.1 4.9 1.5 6.9s3.8 3.1 6.3 3.1h59.8L163.7 426.2l20.1-80.3c.6-2.4 .1-4.9-1.5-6.9s-3.8-3.1-6.3-3.1H116.2zM225.8 224c-3.1 0-6.1 1.1-8.4 3.1L100.7 328.3c-3 2.6-4.7 6.3-4.7 10.2c0 7.4 6 13.5 13.5 13.5h56.3l-20 80c-2 8.1 4.1 16 12.5 16c3.1 0 6.1-1.1 8.4-3.1L283.3 343.7c3-2.6 4.7-6.3 4.7-10.2c0-7.4-6-13.5-13.5-13.5H218.2l20-80c2-8.1-4.1-16-12.5-16z'
      
    ]
  };

  

  
  

  var faT = {
    prefix: 'fat',
    iconName: 't',
    icon: [
      384,
      512,
      [116],
      '54',
      
      'M8 32c-4.4 0-8 3.6-8 8s3.6 8 8 8H184V472c0 4.4 3.6 8 8 8s8-3.6 8-8V48H376c4.4 0 8-3.6 8-8s-3.6-8-8-8H192 8z'
      
    ]
  };

  

  
  

  var faOilCan = {
    prefix: 'fat',
    iconName: 'oil-can',
    icon: [
      640,
      512,
      [],
      'f613',
      
      'M344 80c4.4 0 8-3.6 8-8s-3.6-8-8-8H168c-4.4 0-8 3.6-8 8s3.6 8 8 8h80v80H112 96 48c-26.5 0-48 21.5-48 48v64.3c0 19.2 11.4 36.6 29.1 44.1L96 345.1V368c0 26.5 21.5 48 48 48H403.1c18.4 0 35.8-7.9 48-21.7L633.5 187.7c12.3-13.9-.3-35.4-18.4-31.5L448 192l-50.5-25.2c-8.9-4.4-18.7-6.8-28.6-6.8H264V80h80zm96.8 126.3c3.2 1.6 7 2.1 10.5 1.3l167-35.8c1.1-.2 1.6 0 2 .1c.5 .2 1 .7 1.4 1.4s.5 1.4 .5 1.9c0 .4-.2 1-.9 1.8L439.1 383.8c-9.1 10.3-22.2 16.2-36 16.2H144c-17.7 0-32-14.3-32-32V352 334.6 176H368.9c7.4 0 14.8 1.7 21.5 5.1l50.5 25.2zM96 327.7l-60.6-26c-11.8-5-19.4-16.6-19.4-29.4V208c0-17.7 14.3-32 32-32H96V327.7z'
      
    ]
  };

  

  
  

  var faUpRightAndDownLeftFromCenter = {
    prefix: 'fat',
    iconName: 'up-right-and-down-left-from-center',
    icon: [
      512,
      512,
      ["expand-alt"],
      'f424',
      
      'M305.4 236.7c12.5 12.5 32.8 12.5 45.3 0L432 155.3l25.4 25.4c12.5 12.5 32.8 12.5 45.3 0c6-6 9.4-14.1 9.4-22.6V32c0-17.7-14.3-32-32-32H353.9c-8.5 0-16.6 3.4-22.6 9.4c-12.5 12.5-12.5 32.8 0 45.3L356.7 80l-81.4 81.4c-12.5 12.5-12.5 32.8 0 45.3l30.1 30.1zm33.9-11.3c-6.2 6.2-16.4 6.2-22.6 0l-30.1-30.1c-6.2-6.2-6.2-16.4 0-22.6l87-87c3.1-3.1 3.1-8.2 0-11.3l-31-31c-6.2-6.2-6.2-16.4 0-22.6c3-3 7.1-4.7 11.3-4.7H480c8.8 0 16 7.2 16 16V158.1c0 4.2-1.7 8.3-4.7 11.3c-6.2 6.2-16.4 6.2-22.6 0l-31-31c-3.1-3.1-8.2-3.1-11.3 0l-87 87zM206.6 275.3c-12.5-12.5-32.8-12.5-45.3 0L80 356.7 54.6 331.3c-12.5-12.5-32.8-12.5-45.3 0c-6 6-9.4 14.1-9.4 22.6V480c0 17.7 14.3 32 32 32H158.1c8.5 0 16.6-3.4 22.6-9.4c12.5-12.5 12.5-32.8 0-45.3L155.3 432l81.4-81.4c12.5-12.5 12.5-32.8 0-45.3l-30.1-30.1zm-33.9 11.3c6.2-6.2 16.4-6.2 22.6 0l30.1 30.1c6.2 6.2 6.2 16.4 0 22.6l-87 87c-3.1 3.1-3.1 8.2 0 11.3l31 31c6.2 6.2 6.2 16.4 0 22.6c-3 3-7.1 4.7-11.3 4.7H32c-8.8 0-16-7.2-16-16V353.9c0-4.2 1.7-8.3 4.7-11.3c6.2-6.2 16.4-6.2 22.6 0l31 31c3.1 3.1 8.2 3.1 11.3 0l87-87z'
      
    ]
  };

  
    var faExpandAlt = faUpRightAndDownLeftFromCenter;
  

  
  

  var faHashtag = {
    prefix: 'fat',
    iconName: 'hashtag',
    icon: [
      448,
      512,
      [62098],
      '23',
      
      'M169.7 32.2c4.3 1 7 5.2 6.1 9.5L153.1 144H328.7L352.2 38.3c1-4.3 5.2-7 9.5-6.1s7 5.2 6.1 9.5L345.1 144H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H341.5L298.9 352H408c4.4 0 8 3.6 8 8s-3.6 8-8 8H295.3L271.8 473.7c-1 4.3-5.2 7-9.5 6.1s-7-5.2-6.1-9.5L278.9 368H103.3L79.8 473.7c-1 4.3-5.2 7-9.5 6.1s-7-5.2-6.1-9.5L86.9 368H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H90.5l42.7-192H40c-4.4 0-8-3.6-8-8s3.6-8 8-8h96.7L160.2 38.3c1-4.3 5.2-7 9.5-6.1zM149.5 160L106.9 352H282.5l42.7-192H149.5z'
      
    ]
  };

  

  
  

  var faFaceExplode = {
    prefix: 'fat',
    iconName: 'face-explode',
    icon: [
      512,
      512,
      ["exploding-head"],
      'e2fe',
      
      'M297.8 16c-14.1 0-26.9 5.8-36.1 15.2c-1.5 1.5-3.6 2.4-5.7 2.4s-4.2-.9-5.7-2.4c-9.2-9.4-22-15.2-36.1-15.2c-27.9 0-50.5 22.6-50.5 50.5V71c0 3.2-1.9 6-4.7 7.3s-6.2 .8-8.6-1.3c-7.5-6.7-17.3-10.7-28.1-10.7C98.9 66.2 80 85.1 80 108.4c0 23.9 18 43.6 40.7 43.6H144h24 64c4.4 0 8 3.6 8 8s-3.6 8-8 8H200c5 6.7 8 15 8 24v8.7c0 4.4-3.6 8-8 8s-8-3.6-8-8V192c0-13.3-10.7-24-24-24H144 120.7C88 168 64 139.9 64 108.4c0-32.1 26-58.2 58.2-58.2c9.4 0 18.3 2.2 26.2 6.2C153.3 24.5 180.9 0 214.2 0C230 0 244.6 5.5 256 14.8C267.4 5.5 282 0 297.8 0c33.3 0 60.9 24.5 65.8 56.4c7.9-4 16.8-6.2 26.2-6.2c32.1 0 58.2 26 58.2 58.2c0 31.8-25.8 59.6-58.2 59.6H344c-13.3 0-24 10.7-24 24v8.7c0 4.4-3.6 8-8 8s-8-3.6-8-8V192c0-22.1 17.9-40 40-40h45.8c23 0 42.2-20 42.2-43.6c0-23.3-18.9-42.2-42.2-42.2c-10.8 0-20.6 4.1-28.1 10.7c-2.4 2.1-5.7 2.6-8.6 1.3s-4.7-4.1-4.7-7.3V66.5c0-27.9-22.6-50.5-50.5-50.5zM0 256c0-3.3 .1-6.5 .2-9.8L16 251.7l.8 .3c7.5 2.6 15.6 2.3 22.9-.8l33.1-14c8-3.4 16.9-3.4 24.9 0L91.6 252c-4-1.7-8.5-1.7-12.4 0L46 266c-9.4 4-19.8 4.8-29.7 2.5C22.8 395.2 127.6 496 256 496s233.2-100.8 239.7-227.5c-9.9 2.3-20.2 1.5-29.7-2.5l-33.1-14c-4-1.7-8.5-1.7-12.4 0l-32 13.5c-11.9 5-25.4 5-37.3 0l-32-13.5c-4-1.7-8.5-1.7-12.4 0l-30.9 13c-12.9 5.5-27.6 5-40.1-1.3l-34.5-17.3c-5.1-2.5-11.1-2.2-15.8 .9l-20.3 13c-13.3 8.6-30 10-44.6 3.8L91.6 252l6.2-14.7 28.9 12.2c9.7 4.1 20.9 3.1 29.7-2.6l20.3-13c9.5-6.1 21.5-6.8 31.6-1.7l34.5 17.3c8.4 4.2 18.1 4.5 26.8 .9l30.9-13c8-3.4 16.9-3.4 24.9 0l32 13.5c8 3.4 16.9 3.4 24.9 0l32-13.5c8-3.4 16.9-3.4 24.9 0l33.1 14c7.3 3.1 15.4 3.3 22.9 .8l.8-.3 15.9-5.5c.1 3.2 .2 6.5 .2 9.8c0 2.4 0 4.8-.1 7.1C508.1 401.2 395 512 256 512S3.9 401.2 .1 263.1C0 260.8 0 258.4 0 256zm176.4 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm160 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM311.9 432c-1.4-26.7-23.5-48-50.6-48H250.7c-27.1 0-49.2 21.3-50.6 48H311.9zm-61.3-64h10.7c36.8 0 66.7 29.8 66.7 66.7c0 7.4-6 13.3-13.3 13.3H197.3c-7.4 0-13.3-6-13.3-13.3c0-36.8 29.8-66.7 66.7-66.7z'
      
    ]
  };

  
    var faExplodingHead = faFaceExplode;
  

  
  

  var faSquareXmark = {
    prefix: 'fat',
    iconName: 'square-xmark',
    icon: [
      448,
      512,
      [10062,"times-square","xmark-square"],
      'f2d3',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm146.3 82.3c3.1-3.1 8.2-3.1 11.3 0L224 244.7l66.3-66.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L235.3 256l66.3 66.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L224 267.3l-66.3 66.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L212.7 256l-66.3-66.3c-3.1-3.1-3.1-8.2 0-11.3z'
      
    ]
  };

  
    var faTimesSquare = faSquareXmark;
  
    var faXmarkSquare = faSquareXmark;
  

  
  

  var faFacePouting = {
    prefix: 'fat',
    iconName: 'face-pouting',
    icon: [
      512,
      512,
      [],
      'e387',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm80.4-109c3.3-2.6 6-6.2 7.1-10.7c1.1-4.6 .4-9.4-2-13.8c-16-30.1-48.3-50.5-85.5-50.5c-37.1 0-69.4 20.4-85.4 50.4c-2.4 4.5-3.1 9.3-2 13.8c1.1 4.5 3.8 8.1 7.1 10.7c6.5 5 16 6.6 24.7 3.3c17.1-6.4 35.9-9.9 55.7-9.9c19.8 0 38.6 3.6 55.7 10c8.7 3.3 18.2 1.7 24.7-3.3zm-8.5-14.4c-.1 .4-.4 1.1-1.3 1.8c-1.9 1.5-5.5 2.4-9.3 .9c-18.9-7.1-39.6-11-61.3-11c-21.7 0-42.4 3.9-61.3 11c-3.8 1.4-7.4 .5-9.3-1c-.9-.7-1.2-1.4-1.3-1.8c-.1-.4-.2-1.2 .6-2.6c13.2-24.8 40.1-42 71.3-42c31.2 0 58.1 17.1 71.3 42c.7 1.4 .7 2.2 .6 2.6zM176.4 256a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm176-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM130.5 168.4c-4.2-1.4-8.7 .9-10.1 5.1s.9 8.7 5.1 10.1l96 32c4.2 1.4 8.7-.9 10.1-5.1s-.9-8.7-5.1-10.1l-96-32zm256 15.2c4.2-1.4 6.5-5.9 5.1-10.1s-5.9-6.5-10.1-5.1l-96 32c-4.2 1.4-6.5 5.9-5.1 10.1s5.9 6.5 10.1 5.1l96-32z'
      
    ]
  };

  

  
  

  var faContainerStorage = {
    prefix: 'fat',
    iconName: 'container-storage',
    icon: [
      640,
      512,
      [],
      'f4b7',
      
      'M8 32c-4.4 0-8 3.6-8 8s3.6 8 8 8H32V464H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H40 600h32c4.4 0 8-3.6 8-8s-3.6-8-8-8H608V48h24c4.4 0 8-3.6 8-8s-3.6-8-8-8H600 40 8zM48 464V48H592V464H48zm88-360c0-4.4-3.6-8-8-8s-8 3.6-8 8V408c0 4.4 3.6 8 8 8s8-3.6 8-8V104zm96 0c0-4.4-3.6-8-8-8s-8 3.6-8 8V408c0 4.4 3.6 8 8 8s8-3.6 8-8V104zm96 0c0-4.4-3.6-8-8-8s-8 3.6-8 8V408c0 4.4 3.6 8 8 8s8-3.6 8-8V104zm96 0c0-4.4-3.6-8-8-8s-8 3.6-8 8V408c0 4.4 3.6 8 8 8s8-3.6 8-8V104zm96 0c0-4.4-3.6-8-8-8s-8 3.6-8 8V408c0 4.4 3.6 8 8 8s8-3.6 8-8V104z'
      
    ]
  };

  

  
  

  var faEarthOceania = {
    prefix: 'fat',
    iconName: 'earth-oceania',
    icon: [
      512,
      512,
      ["globe-oceania"],
      'e47b',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm14.7-295.8c-2.5-.6-5.2 0-7.1 1.7l-25.2 21.5c-3.8 3.2-8.8 4.5-13.6 3.5l-.3-.1c-1.9-.4-3.6-1.5-4.8-3l-4-5.3c-8.7-11.6-22.4-18.5-37-18.5s-28.3 6.8-37 18.5l-5.3 7c-.8 1-1.8 1.9-3 2.4L98.2 260.7c-24.6 11.7-34.6 41.5-21.9 65.7l3.3 6.2c10.8 20.6 34.8 30.4 57 23.4l22.9-7.3 49.3 17 27.8 18c8.3 5.4 18.1 8.2 28 8.2c15.9 0 30.9-7.3 40.7-19.8l12.1-15.4c6.9-8.8 10.7-19.7 10.7-30.9s-3.8-22.1-10.7-30.9l-17.9-22.9c-4.3-5.5-7.8-11.6-10.3-18.1l-12.8-32.7c-.9-2.4-3-4.2-5.5-4.8zM178.7 232c9.5 0 18.5 4.5 24.2 12.1l4 5.3c3.5 4.7 8.6 7.9 14.4 9.1l.3 .1c9.7 2 19.7-.6 27.2-7l16.7-14.2 8.7 22.3c3.1 8 7.4 15.4 12.6 22.2l17.9 22.9c4.7 6 7.3 13.4 7.3 21.1s-2.6 15.1-7.3 21.1l-12.1 15.4c-6.8 8.6-17.1 13.7-28.1 13.7c-6.9 0-13.6-2-19.3-5.7l-28.7-18.5c-.5-.3-1.1-.6-1.7-.8l-52.7-18.2c-1.6-.6-3.4-.6-5-.1l-25.4 8.1c-14.8 4.7-30.8-1.9-38-15.6l-3.3-6.2c-8.5-16.1-1.8-36 14.6-43.8l35.3-16.8c3.5-1.7 6.6-4.2 8.9-7.3l5.3-7c5.7-7.6 14.7-12.1 24.2-12.1zm95.1-89.5c-9.5-9.5-23-13.6-36.1-10.9l-38.5 7.7c-15.3 3.1-17.6 24-3.4 30.3l42.8 19c5.1 2.3 10.6 3.4 16.2 3.4h29.9c14.3 0 21.4-17.2 11.3-27.3l-22.2-22.2zm-33 4.8c7.9-1.6 16 .9 21.7 6.6L284.7 176H254.8c-3.4 0-6.7-.7-9.7-2.1l-42.8-19 38.5-7.7zM256 432c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8s-3.6-8-8-8H264c-4.4 0-8 3.6-8 8zM423.6 309.5c-1.4-4.2-5.9-6.5-10.1-5.1s-6.5 5.9-5.1 10.1l8 24c1.4 4.2 5.9 6.5 10.1 5.1s6.5-5.9 5.1-10.1l-8-24zM373.7 413.7l32-32c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-32 32c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0z'
      
    ]
  };

  
    var faGlobeOceania = faEarthOceania;
  

  
  

  var faGopuram = {
    prefix: 'fat',
    iconName: 'gopuram',
    icon: [
      512,
      512,
      [],
      'f664',
      
      'M104 0c4.4 0 8 3.6 8 8V32h80V8c0-4.4 3.6-8 8-8s8 3.6 8 8V32h96V8c0-4.4 3.6-8 8-8s8 3.6 8 8V32h80V8c0-4.4 3.6-8 8-8s8 3.6 8 8V32 48 80v32 .8c18.3 3.7 32 19.8 32 39.2v72 .8c18.3 3.7 32 19.8 32 39.2v88 .8c18.3 3.7 32 19.8 32 39.2v80c0 22.1-17.9 40-40 40H320 304 208 192 40c-22.1 0-40-17.9-40-40V392c0-19.4 13.7-35.5 32-39.2V352 264c0-19.4 13.7-35.5 32-39.2V224 152c0-19.4 13.7-35.5 32-39.2V112 80 48 32 8c0-4.4 3.6-8 8-8zM208 496h96V464c0-26.5-21.5-48-48-48s-48 21.5-48 48v32zm112 0h80V368H384 304 288 224 208 128 112V496h80V464c0-35.3 28.7-64 64-64s64 28.7 64 64v32zM112 80v32H400V80 48H312 200 112V80zm-8 48c-13.3 0-24 10.7-24 24v72h32 16 32V128H112h-8zm72 0v96h48V192c0-17.7 14.3-32 32-32s32 14.3 32 32v32h48V128H176zm96 64c0-8.8-7.2-16-16-16s-16 7.2-16 16v32h32V192zM128 352h80V320c0-26.5 21.5-48 48-48s48 21.5 48 48v32h80V240H288 272 240 224 128V352zM384 224h16 32V152c0-13.3-10.7-24-24-24h-8H352v96h32zM288 352V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v32h64zM400 240V352h64V264c0-13.3-10.7-24-24-24h-8H400zM80 240H72c-13.3 0-24 10.7-24 24v88h64V240H80zM40 368c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24H96V368H48 40zM472 496c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24h-8H416V496h56z'
      
    ]
  };

  

  
  

  var faMelon = {
    prefix: 'fat',
    iconName: 'melon',
    icon: [
      512,
      512,
      [],
      'e310',
      
      'M496 256c0-47.7-13.9-92.1-37.9-129.5c3.9 59.8-37.6 145.8-111.7 219.9S186.4 462 126.5 458.1c37.4 24 81.8 37.9 129.5 37.9c132.5 0 240-107.5 240-240zM53.9 385.5C50 325.7 91.5 239.7 165.6 165.6S325.7 50 385.5 53.9C348.1 29.9 303.7 16 256 16C123.5 16 16 123.5 16 256c0 47.7 13.9 92.1 37.9 129.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM425.7 86.3C407.3 68 372.4 63.5 325.1 79.3c-46.3 15.4-99.6 49-148.2 97.6s-82.2 101.9-97.6 148.2C63.5 372.4 68 407.3 86.3 425.7s53.2 22.8 100.6 7.1c46.3-15.4 99.6-49 148.2-97.6s82.2-101.9 97.6-148.2c15.8-47.3 11.3-82.2-7.1-100.6z'
      
    ]
  };

  

  
  

  var faLightbulbCflOn = {
    prefix: 'fat',
    iconName: 'lightbulb-cfl-on',
    icon: [
      640,
      512,
      [],
      'e5a7',
      
      'M281.7 17.8L199.4 38.4c-13.7 3.4-23.3 15.8-23.3 29.9c0 20 18.8 34.7 38.2 29.9l0 0 82.2-20.6 .1 0C310.4 74.1 320 61.8 320 47.7c0-20-18.8-34.7-38.3-29.9zm-99.1 90.4c-13.3-8.1-22.5-22.8-22.5-40c0-21.5 14.6-40.2 35.5-45.4L277.8 2.3c29.5-7.4 58.2 15 58.2 45.4c0 7.6-1.8 14.9-5.1 21.3l90.9-22.7c29.5-7.4 58.2 15 58.2 45.4c0 16.7-8.8 31.7-22.5 40c13.3 8.1 22.5 22.8 22.5 40c0 16.7-8.8 31.7-22.5 40c13.3 8.1 22.5 22.8 22.5 40c0 21.5-14.6 40.2-35.5 45.4l-70.5 17.6c-3.6 .9-6.1 4.1-6.1 7.8V352H384c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32H368c0 26.5-21.5 48-48 48s-48-21.5-48-48H256c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32h16V289.2l16-4V352h63.9V322.5c0-11 7.5-20.6 18.2-23.3l70.5-17.6c13.7-3.4 23.3-15.8 23.3-29.9c0-20-18.8-34.7-38.2-29.9l-.1 0L313.9 249.8l0 0-95.6 23.9c-29.5 7.4-58.2-15-58.2-45.4c0-16.7 8.8-31.7 22.5-40c-13.3-8.1-22.5-22.8-22.5-40c0-16.7 8.8-31.7 22.5-40zm35.6 5.4l-18.8 4.7c-13.7 3.4-23.3 15.8-23.3 29.9c0 20 18.8 34.7 38.3 29.9l207.4-51.8 18.8-4.7c13.7-3.4 23.3-15.8 23.3-29.9c0-20-18.8-34.7-38.3-29.9l-125 31.3-.1 0-82.2 20.6-.1 0zM256 368c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h24 80 24c8.8 0 16-7.2 16-16V384c0-8.8-7.2-16-16-16H359.9l0 0 0 0H256zM440.6 201.6c13.7-3.4 23.3-15.8 23.3-29.9c0-20-18.8-34.7-38.3-29.9L218.3 193.7l-18.8 4.7c-13.7 3.4-23.3 15.8-23.3 29.9c0 20 18.8 34.7 38.3 29.9L310 234.2l111.7-27.9 .1 0 18.7-4.7zM352 464H288c0 17.7 14.3 32 32 32s32-14.3 32-32zM12.1 17.1l80 48c3.8 2.3 5 7.2 2.7 11s-7.2 5-11 2.7l-80-48c-3.8-2.3-5-7.2-2.7-11s7.2-5 11-2.7zm624 13.7l-80 48c-3.8 2.3-8.7 1-11-2.7s-1-8.7 2.7-11l80-48c3.8-2.3 8.7-1 11 2.7s1 8.7-2.7 11zM8 176H88c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8zm544 0h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H552c-4.4 0-8-3.6-8-8s3.6-8 8-8zM92.1 286.9l-80 48c-3.8 2.3-8.7 1-11-2.7s-1-8.7 2.7-11l80-48c3.8-2.3 8.7-1 11 2.7s1 8.7-2.7 11zm464-13.7l80 48c3.8 2.3 5 7.2 2.7 11s-7.2 5-11 2.7l-80-48c-3.8-2.3-5-7.2-2.7-11s7.2-5 11-2.7z'
      
    ]
  };

  

  
  

  var faCardHeart = {
    prefix: 'fat',
    iconName: 'card-heart',
    icon: [
      384,
      512,
      [],
      'e3eb',
      
      'M64 16C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48H320c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM96 217.9v.6c0 10.6 4 20.9 11.2 28.8l78.9 86.1c1.5 1.7 3.7 2.6 5.9 2.6s4.4-.9 5.9-2.6l78.9-86.1c7.2-7.8 11.2-18.1 11.2-28.8v-.6c0-23.2-18.8-41.9-41.9-41.9c-11.1 0-21.8 4.4-29.7 12.3L197.7 207c-1.5 1.5-3.5 2.3-5.7 2.3s-4.2-.8-5.7-2.3l-18.7-18.7c-7.9-7.9-18.5-12.3-29.7-12.3C114.8 176 96 194.8 96 217.9zM137.9 160c15.4 0 30.1 6.1 41 17L192 190.1 205.1 177c10.9-10.9 25.6-17 41-17c32 0 57.9 25.9 57.9 57.9v.6c0 14.7-5.5 28.8-15.4 39.6l-78.9 86.1c-4.5 5-11 7.8-17.7 7.8s-13.1-2.8-17.7-7.8L95.4 258.1C85.5 247.3 80 233.2 80 218.6v-.6c0-32 25.9-57.9 57.9-57.9z'
      
    ]
  };

  

  
  

  var faShieldHeart = {
    prefix: 'fat',
    iconName: 'shield-heart',
    icon: [
      512,
      512,
      [],
      'e574',
      
      'M237.3 22.6c12-5.1 25.5-5.1 37.5 0l176.7 75c16.6 7.1 28.6 23.2 28.5 42.4c-.5 96.6-40.3 270.2-204.5 348.8c-12.3 5.9-26.7 5.9-39 0C72.3 410.1 32.5 236.5 32 139.9c-.1-19.1 11.9-35.3 28.5-42.4l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM160 217.9c0-23.2 18.8-41.9 41.9-41.9c11.1 0 21.8 4.4 29.7 12.3L250.3 207c1.5 1.5 3.5 2.3 5.7 2.3s4.2-.8 5.7-2.3l18.7-18.7c7.9-7.9 18.5-12.3 29.7-12.3c23.2 0 41.9 18.8 41.9 41.9v.6c0 10.6-4 20.9-11.2 28.8l-78.9 86.1c-1.5 1.7-3.7 2.6-5.9 2.6s-4.4-.9-5.9-2.6l-78.9-86.1c-7.2-7.8-11.2-18.1-11.2-28.8v-.6zM201.9 160c-32 0-57.9 25.9-57.9 57.9v.6c0 14.7 5.5 28.8 15.4 39.6l78.9 86.1c4.5 5 11 7.8 17.7 7.8s13.1-2.8 17.7-7.8l78.9-86.1c9.9-10.8 15.4-24.9 15.4-39.6v-.6c0-32-25.9-57.9-57.9-57.9c-15.4 0-30.1 6.1-41 17L256 190.1 242.9 177c-10.9-10.9-25.6-17-41-17z'
      
    ]
  };

  

  
  

  var faVacuum = {
    prefix: 'fat',
    iconName: 'vacuum',
    icon: [
      640,
      512,
      [],
      'e04d',
      
      'M207 80.6C217.9 33.4 259.9 0 308.4 0H528c61.9 0 112 50.1 112 112c0 44.8-26.3 83.5-64.3 101.4C596.1 243.9 608 280.5 608 320V448c0 35.3-28.7 64-64 64H468.7c5.5-4.9 10.6-10.2 15.3-16H544c26.5 0 48-21.5 48-48V320c0-97.2-78.8-176-176-176c-26.5 0-48 21.5-48 48v97c-5.4 .7-10.8 1.7-16 3V192c0-35.3 28.7-64 64-64c60.7 0 114.8 28.2 150 72.2c34.1-14.7 58-48.7 58-88.2c0-53-43-96-96-96H308.4c-41 0-76.5 28.3-85.7 68.2L190.4 224H173.9L207 80.6zM166.6 256H183L146.1 416H176c26.5 0 48 21.5 48 48s-21.5 48-48 48H21.7C9.7 512 0 502.3 0 490.3c0-6.7 1.6-13.4 4.6-19.4L6.5 467c15.6-31.3 47.6-51 82.5-51h40.6l36.9-160zM136.2 432h-.3H89c-28.9 0-55.3 16.3-68.2 42.2L18.9 478c-1.9 3.8-2.9 8-2.9 12.3c0 3.2 2.6 5.7 5.7 5.7H176c17.7 0 32-14.3 32-32s-14.3-32-32-32H136.2zM464 416a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-176 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm96 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faBroom = {
    prefix: 'fat',
    iconName: 'broom',
    icon: [
      576,
      512,
      [129529],
      'f51a',
      
      'M573.7 13.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L332 232.7 289.3 190c-3.8-3.8-9-6-14.4-6c-10.3 0-18.9 7.6-20.2 17.8L250 239.5 217.3 237c-41.4-3.2-82.2 11.9-111.6 41.3L97 287c-21.1 21.1-33 49.8-33 79.7c0 9.6 7.8 17.3 17.3 17.3l6.1 0 24.6 0L93.3 400 7.7 473.4C2.8 477.6 0 483.7 0 490.1C0 502.2 9.8 512 21.9 512L197 512c37.8 0 74-15 100.7-41.7c29.4-29.4 44.5-70.2 41.3-111.6L336.5 326l37.7-4.7c10.2-1.3 17.8-9.9 17.8-20.2c0-5.4-2.1-10.6-6-14.4L343.3 244 573.7 13.7zM274.9 200c1.2 0 2.3 .5 3.1 1.3L374.7 298c.8 .8 1.3 1.9 1.3 3.1c0 2.2-1.6 4-3.8 4.3l-45.1 5.6-62.1-62.1 5.6-45.1c.3-2.2 2.1-3.8 4.3-3.8zm-26 55.5l71.6 71.6 2.5 32.8c2.8 36.8-10.6 73-36.6 99c-23.7 23.7-55.8 37-89.4 37L21.9 496c-3.3 0-5.9-2.6-5.9-5.9c0-1.7 .8-3.4 2.1-4.5l104.3-89.4c5.1-4.4 6.9-11.4 4.6-17.7s-8.3-10.4-15-10.4H81.3c-.7 0-1.3-.6-1.3-1.3c0-25.6 10.2-50.2 28.3-68.4l8.7-8.7c26.1-26.1 62.3-39.5 99-36.6l32.8 2.5z'
      
    ]
  };

  

  
  

  var faCoinBlank = {
    prefix: 'fat',
    iconName: 'coin-blank',
    icon: [
      512,
      512,
      [],
      'e3fb',
      
      'M82.8 295.9C38.8 271.1 16 239.4 16 208s22.8-63.1 66.8-87.9C126.3 95.6 187.5 80 256 80s129.7 15.6 173.2 40.1c44 24.8 66.8 56.5 66.8 87.9s-22.8 63.1-66.8 87.9C385.7 320.4 324.5 336 256 336s-129.7-15.6-173.2-40.1zM256 64C114.6 64 0 128.5 0 208l0 16 0 96c0 70.7 114.6 128 256 128s256-57.3 256-128l0-96 0-16c0-79.5-114.6-144-256-144zm-8 287.9l0 80c-28.2-.4-55.2-3.2-80-8l0-80.7c25.1 5.2 52 8.2 80 8.7zM88 316.7c19.1 9.3 40.6 17.1 64 23l0 81c-23.8-5.5-45.4-12.8-64-21.6l0-82.4zm-16-8.5l0 82.7C34.2 369.5 16 344 16 320l0-61.8C28.4 277 47.7 294 72 308.1zM264 431.9l0-80c28-.5 54.9-3.5 80-8.7l0 80.7c-24.8 4.7-51.8 7.5-80 8zm96-11.3l0-81c23.4-5.9 44.9-13.6 64-23l0 82.4c-18.6 8.7-40.2 16-64 21.6zm80-29.8l0-82.7c24.3-14.1 43.6-31.1 56-49.9l0 61.8c0 24-18.2 49.5-56 70.8z'
      
    ]
  };

  

  
  

  var faCircleArrowUpLeft = {
    prefix: 'fat',
    iconName: 'circle-arrow-up-left',
    icon: [
      512,
      512,
      [],
      'e0fb',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm56-352H168c-4.4 0-8 3.6-8 8V312c0 4.4 3.6 8 8 8s8-3.6 8-8V187.3L338.3 349.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L187.3 176H312c4.4 0 8-3.6 8-8s-3.6-8-8-8z'
      
    ]
  };

  

  
  

  var faCircleG = {
    prefix: 'fat',
    iconName: 'circle-g',
    icon: [
      512,
      512,
      [],
      'e10f',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM144 256c0-61.9 50.1-112 112-112c28.7 0 54.8 10.8 74.7 28.5c3.3 2.9 8.3 2.7 11.3-.6s2.7-8.4-.6-11.3C318.7 140.3 288.8 128 256 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c67.8 0 123.3-52.8 127.7-119.5c.6-9.4-7-16.5-15.7-16.5H290.3c-4.4 0-8 3.6-8 8s3.6 8 8 8h77.4c-4.1 58.1-52.6 104-111.7 104c-61.9 0-112-50.1-112-112z'
      
    ]
  };

  

  
  

  var faSkeleton = {
    prefix: 'fat',
    iconName: 'skeleton',
    icon: [
      512,
      512,
      [],
      'f620',
      
      'M256 0c4.4 0 8 3.6 8 8V80H416c4.4 0 8 3.6 8 8s-3.6 8-8 8H264v80H480c4.4 0 8 3.6 8 8s-3.6 8-8 8H264v80H384c4.4 0 8 3.6 8 8s-3.6 8-8 8H264v77.7c.3-.1 .5-.1 .8-.2l93.8-26.8c6.3-1.8 12.8-2.7 19.3-2.7c38.8 0 70.2 31.4 70.2 70.2v5.2c0 18.5-6.8 36.3-19 50.1l-26.9 30.2c-11.5 12.9-28 20.3-45.3 20.3H155.2c-17.3 0-33.8-7.4-45.3-20.3L83 461.4c-12.3-13.8-19-31.6-19-50.1v-5.2c0-38.8 31.4-70.2 70.2-70.2c6.5 0 13 .9 19.3 2.7l93.8 26.8c.3 .1 .5 .1 .8 .2V288H128c-4.4 0-8-3.6-8-8s3.6-8 8-8H248V192H32c-4.4 0-8-3.6-8-8s3.6-8 8-8H248V96H96c-4.4 0-8-3.6-8-8s3.6-8 8-8H248V8c0-4.4 3.6-8 8-8zm0 384c-1.7 0-3.4-.6-4.7-1.5c-2.9-.3-5.7-.8-8.5-1.6l-93.8-26.8c-4.8-1.4-9.8-2.1-14.9-2.1C104.3 352 80 376.3 80 406.2v5.2c0 14.5 5.3 28.6 15 39.4L121.9 481c8.5 9.5 20.6 15 33.3 15H356.8c12.7 0 24.9-5.4 33.3-15L417 450.8c9.7-10.9 15-24.9 15-39.4v-5.2c0-29.9-24.3-54.2-54.2-54.2c-5 0-10 .7-14.9 2.1l-93.8 26.8c-2.8 .8-5.6 1.3-8.5 1.6c-1.3 1-2.9 1.5-4.7 1.5zm-88 48a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm136-32a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z'
      
    ]
  };

  

  
  

  var faDisplayChartUpCircleCurrency = {
    prefix: 'fat',
    iconName: 'display-chart-up-circle-currency',
    icon: [
      640,
      512,
      [],
      'e5e5',
      
      'M512 16H64C37.5 16 16 37.5 16 64V352c0 26.5 21.5 48 48 48H231.8h.3 90.8c1 5.4 2.2 10.8 3.7 16H238.8l-13.3 80H288h62.6 16.2 8.4c6.1 5.8 12.7 11.1 19.6 16H360 216 136c-4.4 0-8-3.6-8-8s3.6-8 8-8h73.2l13.3-80H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V211.2c-5.2-2.7-10.5-5.1-16-7.2V64c0-26.5-21.5-48-48-48zm0 176.7c-5.3-.5-10.6-.7-16-.7V80H80l0 256H322.9c-1 5.3-1.7 10.6-2.2 16H80c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16V192.7zm-64 5.9c-5.4 1.5-10.8 3.3-16 5.4V155.3L325.7 261.7c-1.5 1.5-3.5 2.3-5.7 2.3s-4.2-.8-5.7-2.3L240 187.3 133.7 293.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l112-112c3.1-3.1 8.2-3.1 11.3 0L320 244.7 420.7 144H352c-4.4 0-8-3.6-8-8s3.6-8 8-8h88c4.4 0 8 3.6 8 8v62.6zM496 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 200a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm56.3-11.1l21.4 21.4-11.3 11.3-21.4-21.4C528.6 434.1 513 440 496 440s-32.6-5.9-44.9-15.7l-21.4 21.4-11.3-11.3 21.4-21.4C429.9 400.6 424 385 424 368s5.9-32.6 15.7-44.9l-21.4-21.4 11.3-11.3 21.4 21.4C463.4 301.9 479 296 496 296s32.6 5.9 44.9 15.7l21.4-21.4 11.3 11.3-21.4 21.4C562.1 335.4 568 351 568 368s-5.9 32.6-15.7 44.9z'
      
    ]
  };

  

  
  

  var faPersonBiking = {
    prefix: 'fat',
    iconName: 'person-biking',
    icon: [
      640,
      512,
      [128692,"biking"],
      'f84a',
      
      'M392 16a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm0 96A56 56 0 1 0 392 0a56 56 0 1 0 0 112zM240 384A112 112 0 1 1 16 384a112 112 0 1 1 224 0zM128 256a128 128 0 1 0 0 256 128 128 0 1 0 0-256zM624 384a112 112 0 1 1 -224 0 112 112 0 1 1 224 0zM512 256a128 128 0 1 0 0 256 128 128 0 1 0 0-256zM304.9 151.5c8.8-7.6 21.8-7.7 30.8-.4l67.3 55c1.4 1.2 3.2 1.8 5.1 1.8h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H410.9l-65-53.2c-15-12.3-36.6-12-51.4 .6L235.3 190c-20.3 17.4-18.1 49.4 4.3 64L336 316.4V416c0 4.4 3.6 8 8 8s8-3.6 8-8V312c0-2.7-1.4-5.2-3.7-6.7l-100-64.7c-13.5-8.7-14.8-27.9-2.6-38.4l59.1-50.7z'
      
    ]
  };

  
    var faBiking = faPersonBiking;
  

  
  

  var faTemperatureLow = {
    prefix: 'fat',
    iconName: 'temperature-low',
    icon: [
      512,
      512,
      [],
      'f76b',
      
      'M416 16a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112A64 64 0 1 0 416 0a64 64 0 1 0 0 128zM112 80c0-35.3 28.7-64 64-64s64 28.7 64 64V243.8c0 8.4 4.4 15.7 10.7 20.3C283 287.3 304 325.2 304 368c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-42.8 21-80.7 53.3-104c6.3-4.6 10.7-11.9 10.7-20.3V80zM176 0C131.8 0 96 35.8 96 80V243.8c0 2.7-1.4 5.4-4 7.3c-36.3 26.1-60 68.8-60 117c0 79.5 64.5 144 144 144s144-64.5 144-144c0-48.2-23.7-90.8-60-117c-2.6-1.9-4-4.6-4-7.3V80c0-44.2-35.8-80-80-80zM128 368a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0c0-32.6-24.4-59.6-56-63.5V264c0-4.4-3.6-8-8-8s-8 3.6-8 8v40.5c-31.6 3.9-56 30.9-56 63.5c0 35.3 28.7 64 64 64s64-28.7 64-64z'
      
    ]
  };

  

  
  

  var faCodeCommit = {
    prefix: 'fat',
    iconName: 'code-commit',
    icon: [
      640,
      512,
      [],
      'f386',
      
      'M320 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM447.8 264C443.6 331 388 384 320 384s-123.6-53-127.8-120H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H192.2C196.4 181 252 128 320 128s123.6 53 127.8 120H632c4.4 0 8 3.6 8 8s-3.6 8-8 8H447.8z'
      
    ]
  };

  

  
  

  var faFileMusic = {
    prefix: 'fat',
    iconName: 'file-music',
    icon: [
      384,
      512,
      [],
      'f8b6',
      
      'M64 496c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM300.6 225.4c-2.2-1.5-4.9-1.8-7.4-.9l-128 48c-3.1 1.2-5.2 4.2-5.2 7.5V386.2c-8.5-6.3-19.7-10.2-32-10.2c-26.5 0-48 17.9-48 40s21.5 40 48 40c26.5 0 48-17.9 48-40l0 0V285.5l112-42V354.2c-8.5-6.3-19.7-10.2-32-10.2c-26.5 0-48 17.9-48 40s21.5 40 48 40c26.5 0 48-17.9 48-40l0 0V232c0-2.6-1.3-5.1-3.4-6.6zM256 360c20.5 0 32 13.4 32 24s-11.5 24-32 24s-32-13.4-32-24s11.5-24 32-24zM128 392c20.5 0 32 13.4 32 24s-11.5 24-32 24s-32-13.4-32-24s11.5-24 32-24z'
      
    ]
  };

  

  
  

  var faClockOne = {
    prefix: 'fat',
    iconName: 'clock-one',
    icon: [
      512,
      512,
      [],
      'e34e',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM264 104V229.6l49.3-74c2.5-3.7 7.4-4.7 11.1-2.2s4.7 7.4 2.2 11.1l-64 96c-2 2.9-5.6 4.2-9 3.2s-5.7-4.1-5.7-7.7V104c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faCompassSlash = {
    prefix: 'fat',
    iconName: 'compass-slash',
    icon: [
      640,
      512,
      [],
      'f5e9',
      
      'M455.1 454.4C416.6 480.6 370.1 496 320 496C187.5 496 80 388.5 80 256c0-30.1 5.5-58.9 15.6-85.4L82.5 160.2C70.6 189.8 64 222.1 64 256c0 141.4 114.6 256 256 256c55.2 0 106.4-17.5 148.2-47.2l-13.1-10.4zM320 0C264.8 0 213.6 17.5 171.8 47.2l13.1 10.4C223.4 31.4 269.9 16 320 16c132.5 0 240 107.5 240 240c0 30.1-5.5 58.9-15.6 85.4l13.1 10.4C569.4 322.2 576 289.9 576 256C576 114.6 461.4 0 320 0zM194.5 351.1c-6.3 18.8 11.6 36.6 30.4 30.4l96.9-32.3-15-11.9-87 29c-6.3 2.1-12.2-3.9-10.1-10.1l25.2-75.6L221.6 270l-27 81.1zM318.2 162.8l15 11.9 87-29c6.3-2.1 12.2 3.9 10.1 10.1l-25.2 75.6L418.4 242l27-81.1c6.3-18.8-11.6-36.6-30.4-30.4l-96.9 32.3zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  

  
  

  var faMusic = {
    prefix: 'fat',
    iconName: 'music',
    icon: [
      512,
      512,
      [127925],
      'f001',
      
      'M197.6 108.2c-3.4 1-5.6 4.1-5.6 7.6v99.8l304-93.5V16.4L197.6 108.2zM512 15V127.8v.4V368c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c33.4 0 62.8 14.2 80 35.8V138.8L194.4 231.6c-.8 .2-1.6 .4-2.4 .4V432c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c33.4 0 62.8 14.2 80 35.8V224 115.8c0-10.5 6.9-19.8 16.9-22.9L492.6 .7c1.4-.4 2.9-.7 4.4-.7c8.3 0 15 6.7 15 15zM176 432c0-32.7-33-64-80-64s-80 31.3-80 64s33 64 80 64s80-31.3 80-64zm320-64c0-32.7-33-64-80-64s-80 31.3-80 64s33 64 80 64s80-31.3 80-64z'
      
    ]
  };

  

  
  

  var faYinYang = {
    prefix: 'fat',
    iconName: 'yin-yang',
    icon: [
      512,
      512,
      [9775],
      'f6ad',
      
      'M496 256c0 132.5-107.5 240-240 240c-66.5 0-120-52.2-120-116s53.5-116 120-116c74.9 0 136-58.9 136-132c0-39.1-17.4-74.1-45.1-98.2C434.4 69.6 496 155.6 496 256zM256 16c66.5 0 120 52.2 120 116s-53.5 116-120 116c-74.9 0-136 58.9-136 132c0 39.1 17.4 74.1 45.1 98.2C77.6 442.4 16 356.4 16 256C16 123.5 123.5 16 256 16zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-104a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-40-24a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm64-256a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM256 88a40 40 0 1 0 0 80 40 40 0 1 0 0-80z'
      
    ]
  };

  

  
  

  var faSendBackward = {
    prefix: 'fat',
    iconName: 'send-backward',
    icon: [
      512,
      512,
      [],
      'f87f',
      
      'M288 16H64C37.5 16 16 37.5 16 64V288c0 26.5 21.5 48 48 48h64v16H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H288c35.3 0 64 28.7 64 64v64H336V64c0-26.5-21.5-48-48-48zm0 112H272V96c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16V256c0 8.8 7.2 16 16 16h32v16H96c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H256c17.7 0 32 14.3 32 32v32zM176 224V448c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V224c0-26.5-21.5-48-48-48H224c-26.5 0-48 21.5-48 48zm-16 0c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V224z'
      
    ]
  };

  

  
  

  var faCheese = {
    prefix: 'fat',
    iconName: 'cheese',
    icon: [
      512,
      512,
      [],
      'f7ef',
      
      'M495.9 240H27.3l263-189.9c1.9-1.3 4.1-2.1 6.4-2.1C404.3 48 492 133.3 495.9 240zM16 256.4c0-.1 0-.2 0-.4H496V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V256.4zm496-.4v-8.7C512 128.4 415.6 32 296.7 32c-5.7 0-11.2 1.8-15.8 5.1L13.3 230.4C4.9 236.4 0 246.1 0 256.4V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V256z'
      
    ]
  };

  

  
  

  var faSquareStar = {
    prefix: 'fat',
    iconName: 'square-star',
    icon: [
      448,
      512,
      [],
      'e27f',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM175.7 202.2L94.7 214l58.6 57.2c3.8 3.7 5.5 9 4.6 14.2L144.1 366l72.5-38.1c4.7-2.5 10.2-2.5 14.9 0L303.9 366l-13.8-80.7c-.9-5.2 .8-10.5 4.6-14.2L353.3 214l-81-11.8c-5.2-.8-9.7-4-12-8.8L224 120l-36.2 73.4c-2.3 4.7-6.8 8-12 8.8zm179.9-4.1c6 .9 11 5.1 12.9 10.9s.3 12.2-4 16.4l-58.6 57.2 13.8 80.7c1 6-1.4 12.1-6.4 15.6s-11.5 4.1-16.8 1.2L224 342.1l-72.5 38.1c-5.4 2.8-11.9 2.4-16.9-1.2s-7.4-9.6-6.4-15.6l13.8-80.7L83.5 225.4c-4.4-4.3-5.9-10.6-4-16.4s6.9-10 12.9-10.9l81.1-11.8 36.2-73.4c2.7-5.5 8.3-8.9 14.3-8.9s11.7 3.5 14.3 8.9l36.2 73.4 81 11.8z'
      
    ]
  };

  

  
  

  var faWineGlassEmpty = {
    prefix: 'fat',
    iconName: 'wine-glass-empty',
    icon: [
      320,
      512,
      ["wine-glass-alt"],
      'f5ce',
      
      'M37.5 195.6C27.3 269.9 85.1 336 160 336s132.7-66.1 122.5-140.4L259.9 29.8c-1.1-7.9-7.9-13.8-15.9-13.8H75.9c-8 0-14.8 5.9-15.9 13.8L37.5 195.6zm-15.9-2.2L44.2 27.7C46.4 11.8 59.9 0 75.9 0H244.1c16 0 29.5 11.8 31.7 27.7l22.6 165.8c11.1 81.2-49.7 153.8-130.4 158.3V496h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H160 72c-4.4 0-8-3.6-8-8s3.6-8 8-8h80V351.8C71.3 347.3 10.5 274.7 21.6 193.5z'
      
    ]
  };

  
    var faWineGlassAlt = faWineGlassEmpty;
  

  
  

  var faPenSlash = {
    prefix: 'fat',
    iconName: 'pen-slash',
    icon: [
      640,
      512,
      [],
      'e213',
      
      'M13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7zM561.4 128.3c18.7-18.7 18.7-49.1 0-67.9L515.5 14.6c-18.7-18.7-49.1-18.7-67.9 0L307.7 154.6l12.6 10 60.4-60.4 91.1 91.1-49.7 49.7 12.6 10L561.4 128.3zM137.6 347.3l80.2-80.2-12.6-10L126.3 336c-12.3 12.3-21.3 27.5-26.2 44.2L64.3 501.7c-.8 2.8-.1 5.8 2 7.9s5.1 2.8 7.9 2l121.6-35.8c16.7-4.9 31.9-13.9 44.2-26.2l92.2-92.2-12.6-10-90.9 90.9c-10.4 10.4-23.3 18-37.4 22.2L83.8 492.2l31.6-107.5c4.2-14.1 11.8-27 22.2-37.4zM459 25.9c12.5-12.5 32.8-12.5 45.3 0l45.8 45.8c12.5 12.5 12.5 32.8 0 45.3l-66.9 66.9L392.1 92.8 459 25.9z'
      
    ]
  };

  

  
  

  var faMoon = {
    prefix: 'fat',
    iconName: 'moon',
    icon: [
      384,
      512,
      [9214,127769],
      'f186',
      
      'M223.5 48C108.9 48 16 141.1 16 256s92.9 208 207.5 208c56.2 0 107.2-22.4 144.6-58.8c-10.7 1.9-21.7 2.8-32.9 2.8c-105.8 0-191.5-86-191.5-192c0-71.7 39.3-134.3 97.4-167.3c-5.8-.5-11.7-.7-17.6-.7zM0 256C0 132.3 100 32 223.5 32c6.4 0 12.7 .3 19 .8c7 .6 12.8 5.7 14.3 12.5s-1.6 13.9-7.7 17.3c-53.3 30.2-89.3 87.6-89.3 153.3c0 97.2 78.6 176 175.5 176c10.3 0 20.4-.9 30.1-2.6c6.9-1.2 13.8 2.2 17 8.5s1.9 13.8-3.1 18.7C339 455.8 284 480 223.5 480C100 480 0 379.7 0 256z'
      
    ]
  };

  

  
  

  var faArrowUpFromLine = {
    prefix: 'fat',
    iconName: 'arrow-up-from-line',
    icon: [
      384,
      512,
      [8613,"arrow-from-bottom"],
      'f342',
      
      'M197.7 34.3c-3.1-3.1-8.2-3.1-11.3 0l-136 136c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L184 59.3 184 376c0 4.4 3.6 8 8 8s8-3.6 8-8l0-316.7L322.3 181.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-136-136zM8 464c-4.4 0-8 3.6-8 8s3.6 8 8 8l368 0c4.4 0 8-3.6 8-8s-3.6-8-8-8L8 464z'
      
    ]
  };

  
    var faArrowFromBottom = faArrowUpFromLine;
  

  
  

  var faCarrot = {
    prefix: 'fat',
    iconName: 'carrot',
    icon: [
      512,
      512,
      [129365],
      'f787',
      
      'M331.1 19.6C321.6 31.2 304 56.7 304 86c0 20.5 3.9 34.1 10.6 45.5c5.4 9.3 12.8 17.6 22.3 27.3c5.9 4.9 11.4 10.4 16.3 16.3c9.7 9.5 18 16.9 27.3 22.3c11.5 6.7 25 10.6 45.5 10.6c29.3 0 54.8-17.6 66.4-27.1c2.2-1.8 3.6-4.7 3.6-8.2s-1.4-6.4-3.5-8.1c-11.7-9.3-39.1-27.3-75.2-27.3c-16.7 0-26.6 2.1-32.1 3.9c-2.7 .9-4.4 1.8-5.2 2.2c-.3 .2-.6 .4-.6 .4c-3.1 2.9-8 2.8-11-.3s-3.1-7.9-.3-11c.1-.1 .2-.3 .4-.6c.5-.8 1.3-2.4 2.2-5.2c1.8-5.5 3.9-15.4 3.9-32.1c0-36.1-17.9-63.4-27.3-75.2c-1.7-2.2-4.6-3.5-8.1-3.5s-6.4 1.4-8.2 3.6zm-32 117C291.8 123 288 107.3 288 86c0-35 20.6-64.3 30.8-76.6C324 3 331.7 0 339.3 0s15.4 3 20.6 9.6c10.3 13 30.7 43.8 30.7 85.1c0 12.6-1.1 22.1-2.6 29.3c7.2-1.5 16.7-2.6 29.3-2.6c41.3 0 72.1 20.4 85.1 30.7c6.5 5.2 9.6 13 9.6 20.6s-3 15.3-9.4 20.6C490.3 203.4 461 224 426 224c-21.3 0-37-3.8-50.6-11.1c5.6 14.6 8.6 30.4 8.6 46.9c0 50.9-29.3 97.2-75.2 119.1L34.3 509.7C25.1 514 14.2 512.2 7 505s-9.1-18.1-4.7-27.3L133 203.2c21.9-45.9 68.2-75.2 119.1-75.2c16.5 0 32.4 3 46.9 8.6zm26.9 34C305.9 154 280.2 144 252.1 144c-42.2 0-80.9 23-101.3 59.5l46.8 46.8c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-43-43L16.8 484.6c-1.5 3.1-.8 6.7 1.6 9.1s6 3 9.1 1.6l135.8-64.7-40.9-40.9c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l44.9 44.9 123.4-58.7c40.4-19.2 66.1-59.9 66.1-104.6c0-28.1-10-53.8-26.6-73.9c-2.4-2.3-4.8-4.8-7.3-7.2l-.5-.5-.5-.5 0 0c-2.5-2.5-4.9-4.9-7.2-7.3z'
      
    ]
  };

  

  
  

  var faAmpersand = {
    prefix: 'fat',
    iconName: 'ampersand',
    icon: [
      448,
      512,
      [],
      '26',
      
      'M175.6 48h33.3c39.3 0 71.1 31.8 71.1 71.1c0 23-11.2 44.7-30 58l-70 49.6-55.7-57.2c-13-13.4-20.3-31.3-20.3-50C104 80.1 136.1 48 175.6 48zm15.8 190.4l67.9-48.2c23-16.3 36.7-42.8 36.7-71.1C296 71 257 32 208.9 32H175.6C127.2 32 88 71.2 88 119.6c0 22.9 8.9 44.8 24.9 61.2l54 55.4L73.1 302.7C47.3 321 32 350.7 32 382.3c0 53.9 43.7 97.7 97.7 97.7h77.6c33.2 0 64.4-15.8 84-42.6L322 395.3l80.3 82.3c3.1 3.2 8.2 3.2 11.3 .1s3.2-8.2 .1-11.3l-82.2-84.3 82.9-113.4c2.6-3.6 1.8-8.6-1.7-11.2s-8.6-1.8-11.2 1.7L320.2 370.5 191.4 238.4zm-13.2 9.4L310.7 383.6l-32.4 44.3c-16.6 22.7-43 36.1-71.1 36.1H129.7C84.6 464 48 427.4 48 382.3c0-26.5 12.8-51.3 34.4-66.6l95.8-68z'
      
    ]
  };

  

  
  

  var faAtomSimple = {
    prefix: 'fat',
    iconName: 'atom-simple',
    icon: [
      512,
      512,
      ["atom-alt"],
      'f5d3',
      
      'M180.1 453.3C127.6 470.8 88.1 466.1 67 445s-25.8-60.5-8.3-113.1c6.4-19.3 15.7-39.8 27.7-60.6c18.8 28.7 42.1 57.5 69.5 84.9s56.2 50.7 84.9 69.5c-20.8 11.9-41.2 21.2-60.6 27.7zM55.7 55.7C16.5 94.9 27.6 173.9 76.8 256C27.6 338.1 16.5 417.1 55.7 456.3s118.2 28.1 200.3-21.1c82.1 49.2 161.1 60.3 200.3 21.1s28.1-118.2-21.1-200.3c49.2-82.1 60.3-161.1 21.1-200.3S338.1 27.6 256 76.8C173.9 27.6 94.9 16.5 55.7 55.7zm3 124.4C41.2 127.6 45.9 88.1 67 67s60.5-25.8 113.1-8.3c19.3 6.4 39.8 15.7 60.6 27.7c-28.7 18.8-57.5 42.1-84.9 69.5s-50.7 56.2-69.5 84.9c-11.9-20.8-21.2-41.2-27.7-60.6zm108.4-13c28.8-28.8 59-52.8 88.8-71.6c29.8 18.8 60.1 42.8 88.8 71.6s52.8 59 71.6 88.8c-18.8 29.8-42.8 60.1-71.6 88.8s-59 52.8-88.8 71.6c-29.8-18.8-60.1-42.8-88.8-71.6s-52.8-59-71.6-88.8c18.8-29.8 42.8-60.1 71.6-88.8zM331.9 453.3c-19.3-6.4-39.8-15.7-60.6-27.7c28.7-18.8 57.5-42.1 84.9-69.5s50.7-56.2 69.5-84.9c11.9 20.8 21.2 41.2 27.7 60.6c17.5 52.6 12.8 92.1-8.3 113.1s-60.5 25.8-113.1 8.3zM453.3 180.1c-6.4 19.3-15.7 39.8-27.7 60.6c-18.8-28.7-42.1-57.5-69.5-84.9s-56.2-50.7-84.9-69.5c20.8-11.9 41.2-21.2 60.6-27.7C384.4 41.2 423.9 45.9 445 67s25.8 60.5 8.3 113.1zM256 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-32-48a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  
    var faAtomAlt = faAtomSimple;
  

  
  

  var faPenLine = {
    prefix: 'fat',
    iconName: 'pen-line',
    icon: [
      576,
      512,
      [],
      'e212',
      
      'M440.2 25.9c-12.5-12.5-32.8-12.5-45.3 0L328.1 92.8l91.1 91.1L486.1 117c12.5-12.5 12.5-32.8 0-45.3L440.2 25.9zM73.6 347.3c-10.4 10.4-18 23.3-22.2 37.4L19.8 492.2l107.5-31.6c14.1-4.2 27-11.8 37.4-22.2L407.9 195.2l-91.1-91.1L73.6 347.3zm310-332.7c18.7-18.7 49.1-18.7 67.9 0l45.8 45.8c18.7 18.7 18.7 49.1 0 67.9L176 449.7c-12.3 12.3-27.5 21.3-44.2 26.2L10.3 511.7c-2.8 .8-5.8 .1-7.9-2s-2.8-5.1-2-7.9L36.1 380.2C41 363.5 50 348.3 62.3 336L383.7 14.6zM232 496H568c4.4 0 8 3.6 8 8s-3.6 8-8 8H232c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faDog = {
    prefix: 'fat',
    iconName: 'dog',
    icon: [
      576,
      512,
      [128021],
      'f6d3',
      
      'M412 246.9l4 2.4V464c0 17.7-14.3 32-32 32H368c-17.7 0-32-14.3-32-32V369.4c0-5.4-2.7-10.4-7.2-13.3s-10.1-3.5-15.1-1.4C293.6 363.2 271.4 368 248 368s-45.6-4.8-65.7-13.3c-4.9-2.1-10.6-1.6-15.1 1.4s-7.2 8-7.2 13.3V464c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V233.8c0-6.7-4.1-12.6-10.3-15c-24-9.1-42.8-29.4-49.3-55.4l-3.9-15.5c-2.1-8.6 3.1-17.3 11.6-19.4s17.3 3.1 19.4 11.6l3.9 15.5C56.7 177 75.9 192 98 192h46 8H314.7c.9 0 1.9-.1 2.8-.2L412 246.9zm13.6-57.5l-7.1 42.8L330 180.6c.2-.6 .3-1.3 .4-1.9l26-155.9c.6-3.9 4-6.7 7.9-6.7h.8c2.3 0 4.5 1 6 2.7L392 42.5c3 3.5 7.4 5.5 12 5.5h40.1c8.5 0 16.6 3.4 22.6 9.4l17.9 17.9c3 3 7.1 4.7 11.3 4.7h48c8.8 0 16 7.2 16 16v24c0 30.9-25.1 56-56 56H464 441.3c-7.8 0-14.5 5.7-15.8 13.4zM320 386.6V464c0 26.5 21.5 48 48 48h16c26.5 0 48-21.5 48-48V248l9.3-56H464h40c39.8 0 72-32.2 72-72V96c0-17.7-14.3-32-32-32H496L478.1 46.1c-9-9-21.2-14.1-33.9-14.1H404L383.2 8.2C378.6 3 372 0 365.1 0h-.8c-11.7 0-21.7 8.5-23.7 20.1L314.7 176H152h-8H98c-14.7 0-27.5-10-31-24.2L63 136.2c-4.3-17.1-21.7-27.6-38.8-23.3S-3.3 134.6 1 151.8l3.9 15.5c7.8 31.2 30.4 55.6 59.2 66.5V464c0 26.5 21.5 48 48 48h16c26.5 0 48-21.5 48-48V386.6 369.4c5.2 2.2 10.6 4.2 16 5.9c17.7 5.6 36.5 8.7 56 8.7s38.3-3 56-8.7c5.4-1.7 10.8-3.7 16-5.9v17.3zM444 104a12 12 0 1 0 0-24 12 12 0 1 0 0 24z'
      
    ]
  };

  

  
  

  var faWandMagic = {
    prefix: 'fat',
    iconName: 'wand-magic',
    icon: [
      512,
      512,
      ["magic"],
      'f0d0',
      
      'M292.9 153.7c.3 .2 .5 .4 .7 .6l64 64c.2 .2 .4 .5 .6 .7L488.4 89c9.4-9.4 9.4-24.6 0-33.9L457 23.6c-9.4-9.4-24.6-9.4-33.9 0L292.9 153.7zm-11.2 11.2L23.6 423c-9.4 9.4-9.4 24.6 0 33.9L55 488.4c9.4 9.4 24.6 9.4 33.9 0L347.1 230.3c-.3-.2-.5-.4-.7-.6l-64-64c-.2-.2-.4-.5-.6-.7zM12.3 411.7L411.7 12.3c15.6-15.6 40.9-15.6 56.6 0l31.4 31.4c15.6 15.6 15.6 40.9 0 56.6L100.3 499.7c-15.6 15.6-40.9 15.6-56.6 0L12.3 468.3c-15.6-15.6-15.6-40.9 0-56.6z'
      
    ]
  };

  
    var faMagic = faWandMagic;
  

  
  

  var faTents = {
    prefix: 'fat',
    iconName: 'tents',
    icon: [
      640,
      512,
      [],
      'e582',
      
      'M420.6 1.5c-2.8-2-6.6-2-9.4 .1l-173 127.8-.2 .1c6.1 1.4 12.1 3.7 17.7 6.8L416.1 17.9 591.9 142.4c5.5 3.9 9.1 9.9 9.9 16.6l17.8 142c1.8 14.3-9.4 27-23.8 27H457.9l2.4 16H595.8c24.1 0 42.7-21.1 39.7-45L617.7 157c-1.4-11.1-7.4-21.2-16.6-27.7L420.6 1.5zm-192 160c-2.8-2-6.5-2-9.2 0L39 289.3c-9.2 6.5-15.2 16.7-16.6 27.9L4.4 467.2C1.5 491 20.1 512 44.1 512H335.9h.3 67.8c24 0 42.6-21 39.7-44.8l-18-150.1c-1.3-11.2-7.4-21.3-16.6-27.9L228.6 161.5zM340.5 496L232 317.8V183.5L399.8 302.3c5.5 3.9 9.1 10 10 16.7l18 150.1c1.7 14.3-9.4 26.9-23.8 26.9H340.5zM48.2 302.3L216 183.5V319.9v.3V496H44.1c-14.4 0-25.5-12.6-23.8-26.9L38.3 319c.8-6.7 4.4-12.8 10-16.7zM232 496V348.5L321.8 496H232z'
      
    ]
  };

  

  
  

  var faCricketBatBall = {
    prefix: 'fat',
    iconName: 'cricket-bat-ball',
    icon: [
      512,
      512,
      [127951,"cricket"],
      'f449',
      
      'M509.7 2.3c3.1 3.1 3.1 8.2 0 11.3L351.3 172l36.4 36.4c21.9 21.9 21.9 57.3 0 79.2L175 500.3c-7.5 7.5-17.7 11.7-28.3 11.7H136C60.9 512 0 451.1 0 376V365.3c0-10.6 4.2-20.8 11.7-28.3L224.4 124.3c21.9-21.9 57.3-21.9 79.2 0L340 160.7 498.3 2.3c3.1-3.1 8.2-3.1 11.3 0zM235.7 135.6L216 155.3V272c0 13.3 10.7 24 24 24H356.7l19.7-19.7c15.6-15.6 15.6-40.9 0-56.6l-84.1-84.1c-15.6-15.6-40.9-15.6-56.6 0zM200 171.3L23 348.3c-4.5 4.5-7 10.6-7 17V376c0 66.3 53.7 120 120 120h10.7c6.4 0 12.5-2.5 17-7l177-177H240c-22.1 0-40-17.9-40-40V171.3zM496 432a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-144 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z'
      
    ]
  };

  
    var faCricket = faCricketBatBall;
  

  
  

  var faDiagramCells = {
    prefix: 'fat',
    iconName: 'diagram-cells',
    icon: [
      512,
      512,
      [],
      'e475',
      
      'M496 160c0 26.5-21.5 48-48 48L64 208c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48l384 0c26.5 0 48 21.5 48 48v64zm-48 64c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64l384 0zm64 192V352c0-35.3-28.7-64-64-64L64 288c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64zm-64 48L64 464c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48l384 0c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48z'
      
    ]
  };

  

  
  

  var faFaceDiagonalMouth = {
    prefix: 'fat',
    iconName: 'face-diagonal-mouth',
    icon: [
      512,
      512,
      [129764],
      'e47e',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm370.2 55.7l-224 64c-4.2 1.2-8.7-1.2-9.9-5.5s1.2-8.7 5.5-9.9l224-64c4.2-1.2 8.7 1.2 9.9 5.5s-1.2 8.7-5.5 9.9zM160.4 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faTentArrowTurnLeft = {
    prefix: 'fat',
    iconName: 'tent-arrow-turn-left',
    icon: [
      576,
      512,
      [],
      'e580',
      
      'M109.4 13.9c3.3-3 3.5-8 .5-11.3s-8-3.5-11.3-.5l-96 88C.9 91.6 0 93.8 0 96s.9 4.4 2.6 5.9l96 88c3.3 3 8.3 2.8 11.3-.5s2.8-8.3-.5-11.3L28.6 104H472c48.6 0 88 39.4 88 88v56c0 4.4 3.6 8 8 8s8-3.6 8-8V192c0-57.4-46.6-104-104-104H28.6l80.8-74.1zM288.6 161.5c-2.8-2-6.5-2-9.2 0L98.9 289.3c-9.2 6.5-15.2 16.7-16.6 27.9l-18 150.1C61.4 491 80 512 104 512H395.8h.3 67.8c24 0 42.6-21 39.7-44.8l-18-150.1c-1.3-11.2-7.4-21.3-16.6-27.9L288.6 161.5zm3.4 156.3V183.5L459.7 302.3c5.5 3.9 9.1 10 10 16.7l18 150.1c1.7 14.3-9.4 26.9-23.8 26.9H400.4L291.9 317.8zm0 30.8L381.7 496H291.9V348.5zm-16-28.4V496H104c-14.4 0-25.5-12.6-23.8-26.9L98.2 319c.8-6.7 4.4-12.8 10-16.7L275.9 183.5V319.9c0 .1 0 .2 0 .3z'
      
    ]
  };

  

  
  

  var faBanParking = {
    prefix: 'fat',
    iconName: 'ban-parking',
    icon: [
      512,
      512,
      ["parking-circle-slash"],
      'f616',
      
      'M420 431.3L80.7 92C40.6 134.9 16 192.6 16 256c0 132.5 107.5 240 240 240c63.4 0 121.1-24.6 164-64.7zM431.3 420C471.4 377.1 496 319.4 496 256C496 123.5 388.5 16 256 16C192.6 16 134.9 40.6 92 80.7l84 84V144c0-8.8 7.2-16 16-16h96c48.6 0 88 39.4 88 88c0 40.3-27.1 74.2-64 84.7L431.3 420zM192 180.7L298.5 287.2c34.8-5.1 61.5-35.1 61.5-71.2c0-39.8-32.2-72-72-72H192v36.7zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176 40V249.9l16 16V288h22.1l16 16H192v72c0 4.4-3.6 8-8 8s-8-3.6-8-8V296z'
      
    ]
  };

  
    var faParkingCircleSlash = faBanParking;
  

  
  

  var faPenNib = {
    prefix: 'fat',
    iconName: 'pen-nib',
    icon: [
      512,
      512,
      [10001],
      'f5ad',
      
      'M379.7 31.6L307.3 104 408 204.7l72.4-72.4c15.6-15.6 15.6-40.9 0-56.6L436.3 31.6c-15.6-15.6-40.9-15.6-56.6 0zm-88 65.3l76.6-76.6c21.9-21.9 57.3-21.9 79.2 0l44.1 44.1c21.9 21.9 21.9 57.3 0 79.2l-76.6 76.6L369.5 370.1c-6.9 22.7-24.5 40.5-47.1 47.7L37.2 508.2c-9.5 3-19.8 .5-26.9-6.6s-9.6-17.4-6.5-26.9L94.2 189.7c7.2-22.6 25-40.2 47.7-47.1L291.8 96.9zm2 16.1L146.5 157.9c-17.6 5.4-31.5 19.1-37.1 36.6L19 479.6c-.3 .8-.4 1.6-.5 2.5L163.1 337.5c-7-9.4-11.1-21-11.1-33.5c0-30.9 25.1-56 56-56s56 25.1 56 56s-25.1 56-56 56c-12.6 0-24.2-4.1-33.5-11.1L29.9 493.4c.8-.1 1.7-.2 2.5-.5l285.1-90.4c17.6-5.6 31.3-19.4 36.6-37.1L399 218.3 293.7 113.1zM208 264a40 40 0 1 0 0 80 40 40 0 1 0 0-80z'
      
    ]
  };

  

  
  

  var faScythe = {
    prefix: 'fat',
    iconName: 'scythe',
    icon: [
      640,
      512,
      [],
      'f710',
      
      'M522.3 355.4l-26 121.3c-1.9 8.6 3.7 17.1 12.3 19s17.1-3.7 19-12.3l34.3-160 61.7-288c1.9-8.6-3.7-17.1-12.3-19s-17.1 3.7-19 12.3L536.1 291.4c-1.6 7.4-8.1 12.6-15.6 12.6H416c-8.8 0-16 7.2-16 16s7.2 16 16 16h90.7c4.8 0 9.4 2.2 12.4 5.9s4.2 8.7 3.2 13.4zM416 288H520.4L576.7 25.3C580.4 8 597.4-3 614.7 .7s28.3 20.7 24.6 38l-61.7 288-34.3 160c-3.7 17.3-20.7 28.3-38 24.6s-28.3-20.7-24.6-38L503.3 368l3.4-16H490.3 416c-17.7 0-32-14.3-32-32s14.3-32 32-32zM352 0H552.6c-2.8 4.9-5 10.3-6.5 16H352C110.2 16 27 179.3 16 203.2l0 0c0 .1 0 .2 0 .6c0 2.3 1.8 4.1 4.1 4.1H504.8l-3.4 16H20.1C9 224 0 215 0 203.9c0-2.6 .4-5 1.5-7.3C13.6 170.2 101.1 0 352 0z'
      
    ]
  };

  

  
  

  var faHouseChimneyWindow = {
    prefix: 'fat',
    iconName: 'house-chimney-window',
    icon: [
      576,
      512,
      [],
      'e00d',
      
      'M282.7 2c3-2.7 7.6-2.7 10.6 0L384 82.3V56c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V195.7L573.3 250c3.3 2.9 3.6 8 .7 11.3s-8 3.6-11.3 .7L512 217.1V448c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V217.1L13.3 262c-3.3 2.9-8.4 2.6-11.3-.7S-.6 252.9 2.7 250L282.7 2zM384 104v-.3l-96-85L80 202.9V448c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V202.9L384.3 104H384zm16-48V96.5l96 85V56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8zM240 184h96c13.3 0 24 10.7 24 24v96c0 13.3-10.7 24-24 24H240c-13.3 0-24-10.7-24-24V208c0-13.3 10.7-24 24-24zm-8 24v96c0 4.4 3.6 8 8 8h96c4.4 0 8-3.6 8-8V208c0-4.4-3.6-8-8-8H240c-4.4 0-8 3.6-8 8z'
      
    ]
  };

  

  
  

  var faCircleChevronLeft = {
    prefix: 'fat',
    iconName: 'circle-chevron-left',
    icon: [
      512,
      512,
      ["chevron-circle-left"],
      'f137',
      
      'M16 256a240 240 0 1 1 480 0A240 240 0 1 1 16 256zm496 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM290.3 130.3l-120 120c-3.1 3.1-3.1 8.2 0 11.3l120 120c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L187.3 256 301.7 141.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0z'
      
    ]
  };

  
    var faChevronCircleLeft = faCircleChevronLeft;
  

  
  

  var faGolfBallTee = {
    prefix: 'fat',
    iconName: 'golf-ball-tee',
    icon: [
      384,
      512,
      ["golf-ball"],
      'f450',
      
      'M312.8 320c34-32.1 55.2-77.6 55.2-128c0-97.2-78.8-176-176-176S16 94.8 16 192c0 50.4 21.2 95.9 55.2 128H48.9C18.5 286 0 241.2 0 192C0 86 86 0 192 0S384 86 384 192c0 49.2-18.5 94-48.9 128H312.8zM78.6 368c-3.7 0-6.6 3-6.6 6.6c0 2.6 1.5 4.9 3.9 6l86.2 39.8c8.5 3.9 13.9 12.4 13.9 21.8V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V442.2c0-3.1-1.8-6-4.6-7.3L69.2 395.2c-8-3.7-13.2-11.7-13.2-20.6C56 362.1 66.1 352 78.6 352H305.4c12.5 0 22.6 10.1 22.6 22.6c0 8.8-5.1 16.9-13.2 20.6L228.6 435c-2.8 1.3-4.6 4.1-4.6 7.3V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V442.2c0-9.4 5.4-17.9 13.9-21.8l86.2-39.8c2.4-1.1 3.9-3.4 3.9-6c0-3.7-3-6.6-6.6-6.6H78.6zM224 176c0 22.1-17.9 40-40 40c-4.4 0-8-3.6-8-8s3.6-8 8-8c13.3 0 24-10.7 24-24c0-4.4 3.6-8 8-8s8 3.6 8 8zm72 8c4.4 0 8 3.6 8 8c0 22.1-17.9 40-40 40c-4.4 0-8-3.6-8-8s3.6-8 8-8c13.3 0 24-10.7 24-24c0-4.4 3.6-8 8-8zm-56 72c0 22.1-17.9 40-40 40c-4.4 0-8-3.6-8-8s3.6-8 8-8c13.3 0 24-10.7 24-24c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  
    var faGolfBall = faGolfBallTee;
  

  
  

  var faHouseMedical = {
    prefix: 'fat',
    iconName: 'house-medical',
    icon: [
      576,
      512,
      [],
      'e3b2',
      
      'M293.3 2c-3-2.7-7.6-2.7-10.6 0L2.7 250c-3.3 2.9-3.6 8-.7 11.3s8 3.6 11.3 .7L64 217.1V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V217.1L562.7 262c3.3 2.9 8.4 2.6 11.3-.7s2.6-8.4-.7-11.3L293.3 2zM80 448V202.9L288 18.7 496 202.9V448c0 26.5-21.5 48-48 48H128c-26.5 0-48-21.5-48-48zM264 200c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H320c-4.4 0-8 3.6-8 8v56c0 4.4-3.6 8-8 8H272c-4.4 0-8-3.6-8-8V320c0-4.4-3.6-8-8-8H200c-4.4 0-8-3.6-8-8V272c0-4.4 3.6-8 8-8h56c4.4 0 8-3.6 8-8V200zm8-24c-13.3 0-24 10.7-24 24v48H200c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h48v48c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V328h48c13.3 0 24-10.7 24-24V272c0-13.3-10.7-24-24-24H328V200c0-13.3-10.7-24-24-24H272z'
      
    ]
  };

  

  
  

  var faPersonSeat = {
    prefix: 'fat',
    iconName: 'person-seat',
    icon: [
      384,
      512,
      [],
      'e21e',
      
      'M192 240h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H189.3c-6.8 0-12.8-4.3-15.1-10.7C169.8 184.9 157.9 176 144 176c-17.7 0-32 14.3-32 32v96c0 26.5 21.5 48 48 48h86.4c15.9 0 29.4 11.7 31.7 27.5l10.1 70.8c1.1 7.9 7.9 13.7 15.8 13.7h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H331.8c-8 0-14.7-5.9-15.8-13.7L309.7 375c-4.5-31.5-31.5-55-63.4-55H192c-8.8 0-16-7.2-16-16V256c0-8.8 7.2-16 16-16zM176 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm16 224h16 38.4c39.8 0 73.6 29.3 79.2 68.7l6.2 43.3H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H304c-15.9 0-29.4-11.7-31.7-27.5l-10.1-70.8c-1.1-7.9-7.9-13.7-15.8-13.7H160c-35.3 0-64-28.7-64-64V208c0-26.5 21.5-48 48-48c20.9 0 38.7 13.4 45.3 32H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H208 192v16 16 16zM96 80a48 48 0 1 1 96 0A48 48 0 1 1 96 80zM16 136V344c0 48.6 39.4 88 88 88H216c4.4 0 8 3.6 8 8s-3.6 8-8 8H104C46.6 448 0 401.4 0 344V136c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faDitto = {
    prefix: 'fat',
    iconName: 'ditto',
    icon: [
      320,
      512,
      [],
      '22',
      
      'M16 103.9c0 4.2 .5 8.3 1.4 12.4L50.3 261.1C51.7 267.5 57.4 272 64 272s12.3-4.5 13.7-10.9l32.9-144.7c.9-4.1 1.4-8.2 1.4-12.4V96c0-26.5-21.5-48-48-48S16 69.5 16 96v7.9zm-16 0V96C0 60.7 28.7 32 64 32s64 28.7 64 64v7.9c0 5.4-.6 10.7-1.8 15.9L93.3 264.6C90.2 278.3 78 288 64 288s-26.2-9.7-29.3-23.4L1.8 119.9C.6 114.6 0 109.3 0 103.9zm208 0c0 4.2 .5 8.3 1.4 12.4l32.9 144.7c1.5 6.4 7.1 10.9 13.7 10.9s12.3-4.5 13.7-10.9l32.9-144.7c.9-4.1 1.4-8.2 1.4-12.4V96c0-26.5-21.5-48-48-48s-48 21.5-48 48v7.9zm-16 0V96c0-35.3 28.7-64 64-64s64 28.7 64 64v7.9c0 5.4-.6 10.7-1.8 15.9L285.3 264.6C282.2 278.3 270 288 256 288s-26.2-9.7-29.3-23.4L193.8 119.9c-1.2-5.2-1.8-10.6-1.8-15.9z'
      
    ]
  };

  

  
  

  var faPhonePlus = {
    prefix: 'fat',
    iconName: 'phone-plus',
    icon: [
      640,
      512,
      [],
      'f4d2',
      
      'M464 200c0 4.4 3.6 8 8 8s8-3.6 8-8V112h88c4.4 0 8-3.6 8-8s-3.6-8-8-8H480V8c0-4.4-3.6-8-8-8s-8 3.6-8 8V96H376c-4.4 0-8 3.6-8 8s3.6 8 8 8h88v88zM361.8 382.5c6.6 3.1 14.6 1.3 19.2-4.3l40.4-49.3c6.7-8.2 18-11 27.8-7l96 40c11.1 4.6 17.1 16.8 13.9 28.5l-24 88C532.3 488.8 522.8 496 512 496C273.4 496 80 302.6 80 64c0-10.8 7.2-20.3 17.7-23.2l88-24c11.6-3.2 23.8 2.8 28.5 13.9l40 96c4.1 9.8 1.3 21.1-7 27.8l-49.3 40.4c-5.7 4.7-7.5 12.6-4.3 19.2c34.8 73.8 94.5 133.5 168.3 168.3zM409 318.7L368.7 368C298.2 334.7 241.2 277.7 208 207.3L257.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96c-7.7-18.6-28-28.5-47.4-23.2l-88 24C76.1 30.2 64 46 64 64c0 247.4 200.6 448 448 448c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6z'
      
    ]
  };

  

  
  

  var faGlassesRound = {
    prefix: 'fat',
    iconName: 'glasses-round',
    icon: [
      576,
      512,
      [128083,"glasses-alt"],
      'f5f5',
      
      'M109 48C91.1 48 75.5 60.4 71.5 77.9L30.3 258.4C55.2 227.7 93.3 208 136 208c55.1 0 102.6 32.8 124 80H316c21.3-47.2 68.8-80 124-80c42.7 0 80.8 19.7 105.7 50.4L504.5 77.9C500.5 60.4 484.9 48 467 48c-6 0-11.9 1.4-17.2 4.1L427.6 63.2c-4 2-8.8 .4-10.7-3.6s-.4-8.8 3.6-10.7l22.2-11.1C450.2 34 458.5 32 467 32c25.4 0 47.4 17.6 53.1 42.3l52.2 228.3c2.5 11 3.8 22.1 3.8 33.4h-.2c.2 2.6 .2 5.3 .2 8c0 75.1-60.9 136-136 136s-136-60.9-136-136c0-13.9 2.1-27.4 6-40H266c3.9 12.6 6 26.1 6 40c0 75.1-60.9 136-136 136S0 419.1 0 344c0-2.7 .1-5.4 .2-8H0c0-11.2 1.3-22.4 3.8-33.4L55.9 74.3C61.6 49.6 83.6 32 109 32c8.5 0 16.8 2 24.4 5.7l22.2 11.1c4 2 5.6 6.8 3.6 10.7s-6.8 5.6-10.7 3.6L126.2 52.1C120.9 49.4 115 48 109 48zm27 416a120 120 0 1 0 0-240 120 120 0 1 0 0 240zm304 0a120 120 0 1 0 0-240 120 120 0 1 0 0 240z'
      
    ]
  };

  
    var faGlassesAlt = faGlassesRound;
  

  
  

  var faBinary = {
    prefix: 'fat',
    iconName: 'binary',
    icon: [
      384,
      512,
      [],
      'e33b',
      
      'M312 8c0-2.6-1.3-5.1-3.4-6.6s-4.9-1.8-7.4-.9l-64 24c-4.1 1.6-6.2 6.2-4.7 10.3s6.2 6.2 10.3 4.7L296 19.5V208H232c-4.4 0-8 3.6-8 8s3.6 8 8 8h72 72c4.4 0 8-3.6 8-8s-3.6-8-8-8H312V8zM88 296c0-2.6-1.3-5.1-3.4-6.6s-4.9-1.8-7.4-.9l-64 24c-4.1 1.6-6.2 6.2-4.7 10.3s6.2 6.2 10.3 4.7L72 307.5V496H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H80h72c4.4 0 8-3.6 8-8s-3.6-8-8-8H88V296zM16 64v96c0 35.3 28.7 64 64 64h32c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H80C44.7 0 16 28.7 16 64zM80 16h32c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48zM272 288c-35.3 0-64 28.7-64 64v96c0 35.3 28.7 64 64 64h32c35.3 0 64-28.7 64-64V352c0-35.3-28.7-64-64-64H272zm-48 64c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V352z'
      
    ]
  };

  

  
  

  var faAvocado = {
    prefix: 'fat',
    iconName: 'avocado',
    icon: [
      512,
      512,
      [],
      'e0aa',
      
      'M496 144c0 39.8-18.2 75.4-46.8 98.9c-20.4 16.8-38.1 40.2-43.6 68.4c-9.8 49.8-32.5 99.1-61.9 128.5c-75 75-196.5 75-271.5 0s-75-196.5 0-271.5c29.4-29.4 78.7-52.1 128.5-61.9c28.2-5.5 51.6-23.2 68.4-43.6C292.6 34.2 328.2 16 368 16c70.7 0 128 57.3 128 128zM421.3 314.3c4.6-23.5 19.6-43.9 38.1-59.1C491.5 228.9 512 188.8 512 144C512 64.5 447.5 0 368 0c-44.8 0-84.9 20.5-111.3 52.6c-15.2 18.5-35.6 33.5-59.1 38.1c-51.9 10.2-104.5 34-136.7 66.3c-81.2 81.2-81.2 212.9 0 294.2s212.9 81.2 294.2 0c32.3-32.3 56.1-84.9 66.3-136.7zM170.5 234.5c40-40 95.1-44.8 123.4-16.4s23.6 83.5-16.4 123.4s-95.1 44.8-123.4 16.4s-23.6-83.5 16.4-123.4zm134.8-27.7c-37-37-102.6-27.1-146.1 16.4s-53.4 109.1-16.4 146.1s102.6 27.1 146.1-16.4s53.4-109.1 16.4-146.1z'
      
    ]
  };

  

  
  

  var faGunSlash = {
    prefix: 'fat',
    iconName: 'gun-slash',
    icon: [
      640,
      512,
      [],
      'e19c',
      
      'M13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7zM473.4 240c6.4 0 12.5-2.5 17-7L513 210.3c1.5-1.5 3.5-2.3 5.7-2.3H568c22.1 0 40-17.9 40-40V104c0-22.1-17.9-40-40-40H544V40c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H193l20.3 16H536h32c13.3 0 24 10.7 24 24v64c0 13.3-10.7 24-24 24H518.6c-6.4 0-12.5 2.5-17 7L479 221.7c-1.5 1.5-3.5 2.3-5.7 2.3H395.7l20.3 16h57.4zM48 200V133L32 120.4V200c0 22.1 17.9 40 40 40h2c20.8 0 36.1 19.6 31 39.8L65 440.2c-2.4 9.6-.2 19.7 5.8 27.5S86.1 480 96 480H208c14.7 0 27.5-10 31-24.2l35.9-143.6-13.8-10.9L223.5 451.9C221.7 459 215.3 464 208 464H96c-4.9 0-9.6-2.3-12.6-6.2s-4.1-8.9-2.9-13.7l40.1-160.5c4.1-16.3-.7-32.3-10.8-43.6h73.7l-20.3-16H72c-13.3 0-24-10.7-24-24zm488-56c4.4 0 8-3.6 8-8s-3.6-8-8-8H274.1l20.3 16H536z'
      
    ]
  };

  

  
  

  var faArrowsRepeat1 = {
    prefix: 'fat',
    iconName: 'arrows-repeat-1',
    icon: [
      512,
      512,
      ["repeat-1-alt"],
      'f366',
      
      'M8 272c-4.4 0-8-3.6-8-8v-8C0 163.2 75.2 88 168 88H419.4L338.6 13.9c-3.3-3-3.5-8-.5-11.3s8-3.5 11.3-.5l96 88c1.7 1.5 2.6 3.7 2.6 5.9s-.9 4.4-2.6 5.9l-96 88c-3.3 3-8.3 2.8-11.3-.5s-2.8-8.3 .5-11.3L419.4 104H168C84.1 104 16 172.1 16 256v8c0 4.4-3.6 8-8 8zm496-32c4.4 0 8 3.6 8 8v8c0 92.8-75.2 168-168 168H92.6l80.8 74.1c3.3 3 3.5 8 .5 11.3s-8 3.5-11.3 .5l-96-88c-1.7-1.5-2.6-3.7-2.6-5.9s.9-4.4 2.6-5.9l96-88c3.3-3 8.3-2.8 11.3 .5s2.8 8.3-.5 11.3L92.6 408H344c83.9 0 152-68.1 152-152v-8c0-4.4 3.6-8 8-8zM280 200V312c0 4.4-3.6 8-8 8s-8-3.6-8-8V214.1l-27.9 16.7c-3.8 2.3-8.7 1-11-2.7s-1-8.7 2.7-11l40-24c2.5-1.5 5.5-1.5 8.1-.1s4.1 4.1 4.1 7z'
      
    ]
  };

  
    var faRepeat1Alt = faArrowsRepeat1;
  

  
  

  var faArrowUpShortWide = {
    prefix: 'fat',
    iconName: 'arrow-up-short-wide',
    icon: [
      576,
      512,
      ["sort-amount-up-alt"],
      'f885',
      
      'M133.7 34.3c-3.1-3.1-8.2-3.1-11.3 0l-104 104c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L120 59.3V472c0 4.4 3.6 8 8 8s8-3.6 8-8V59.3l90.3 90.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-104-104zM296 48c-4.4 0-8 3.6-8 8s3.6 8 8 8h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H296zm0 144c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H296zm0 128c-4.4 0-8 3.6-8 8s3.6 8 8 8H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H296zm0 128c-4.4 0-8 3.6-8 8s3.6 8 8 8H568c4.4 0 8-3.6 8-8s-3.6-8-8-8H296z'
      
    ]
  };

  
    var faSortAmountUpAlt = faArrowUpShortWide;
  

  
  

  var faShield = {
    prefix: 'fat',
    iconName: 'shield',
    icon: [
      512,
      512,
      [128737,"shield-blank"],
      'f132',
      
      'M274.8 22.6c-12-5.1-25.5-5.1-37.5 0L60.5 97.5c-16.6 7.1-28.6 23.2-28.5 42.4c.5 96.6 40.3 270.2 204.6 348.8c12.3 5.9 26.7 5.9 39 0c164.2-78.6 204-252.2 204.5-348.8c.1-19.1-11.9-35.3-28.5-42.4l-176.7-75zM231 7.8c16-6.8 34-6.8 50 0l176.7 75c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L231 7.8z'
      
    ]
  };

  
    var faShieldBlank = faShield;
  

  
  

  var faFileExport = {
    prefix: 'fat',
    iconName: 'file-export',
    icon: [
      576,
      512,
      ["arrow-right-from-file"],
      'f56e',
      
      'M368 448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V256h16V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V352H368v96zm-6.9-288H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3c.9 .9 1.7 1.8 2.4 2.7zm100.6 26.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L548.7 296H200c-4.4 0-8 3.6-8 8s3.6 8 8 8H548.7l-98.3 98.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l112-112c3.1-3.1 3.1-8.2 0-11.3l-112-112z'
      
    ]
  };

  
    var faArrowRightFromFile = faFileExport;
  

  
  

  var faPhoneMissed = {
    prefix: 'fat',
    iconName: 'phone-missed',
    icon: [
      640,
      512,
      [],
      'e226',
      
      'M104 0c-4.4 0-8 3.6-8 8V152c0 4.4 3.6 8 8 8s8-3.6 8-8V27.3L259.7 175c16 16 37.7 25 60.3 25s44.3-9 60.3-25L517.7 37.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L369 163.7c-13 13-30.6 20.3-49 20.3s-36-7.3-49-20.3L123.3 16H248c4.4 0 8-3.6 8-8s-3.6-8-8-8H104zM432 384c0-6.9-4.4-13-10.9-15.2c-65.6-21.9-136.5-21.9-202.1 0C212.4 371 208 377.1 208 384v69.8c0 7.6-5.4 14.2-12.9 15.7L84.8 491.5c-7.1 1.4-14.2-2.1-17.4-8.5L27.8 403.9c-5.7-11.4-3.9-23.6 3.6-31C79.9 324.5 182.1 256 320 256s240.1 68.5 288.6 116.9c7.5 7.4 9.3 19.7 3.6 31L572.6 483c-3.2 6.5-10.4 9.9-17.4 8.5L444.9 469.5c-7.5-1.5-12.9-8.1-12.9-15.7V384zm-208 0c62.3-20.8 129.7-20.8 192 0v69.8c0 15.3 10.8 28.4 25.7 31.4L552 507.2c14.2 2.8 28.4-4.2 34.9-17.1l39.5-79.1c8.3-16.5 6.5-36.5-6.6-49.5C569.3 311.1 463.2 240 320 240S70.7 311.1 20.1 361.5c-13.1 13-14.9 33-6.6 49.5l39.5 79.1C59.5 503 73.8 510 88 507.2l110.3-22.1c15-3 25.7-16.1 25.7-31.4V384z'
      
    ]
  };

  

  
  

  var faFireSmoke = {
    prefix: 'fat',
    iconName: 'fire-smoke',
    icon: [
      640,
      512,
      [],
      'f74b',
      
      'M285.5 16c1.5 0 2.9 .5 4 1.5c16.1 14.6 31.3 30.1 45.6 46.8c6.6 7.6 18.4 7.5 24.8-.3c5.8-7 11.9-13.9 18.2-19.6c2.3-2.1 5.9-2.1 8.2 0c18.9 17.4 38.4 41.2 53.2 67.2c14.8 26.1 24.5 54 24.5 79.7c0 29.5-8.8 56.9-24 79.9c3 2.8 5.8 5.6 8.6 8.6c2.6-1.7 5.3-3.4 8.1-5c14.8-24.4 23.3-53 23.3-83.5c0-29.5-11-60.1-26.6-87.6c-15.6-27.6-36.2-52.6-56.3-71.1c-8.4-7.7-21.4-7.8-29.8-.1c-7.1 6.5-13.8 14-19.7 21.3c0 0-.1 0-.1 .1s-.1 0-.1 0s-.1 0-.1 0c0 0 0 0 0 0l-.1 0c-14.8-17.2-30.5-33.2-47-48.3C296.1 1.9 290.8 0 285.6 0c-5.3 0-10.6 1.8-14.9 5.6c-24.3 21.8-51.8 50-73.3 81.6C176 118.8 160 154.6 160 191.4c0 30.4 8.4 58.9 23 83.3c2.9 1.6 5.6 3.3 8.4 5.1c2.7-2.9 5.5-5.7 8.4-8.4c-15.1-23-23.8-50.5-23.8-80c0-32.3 14.1-64.9 34.7-95.2c20.5-30.2 47-57.4 70.8-78.7c1.1-1 2.6-1.5 4.1-1.5zM415.3 252c-7-53.2-64.5-101-86.6-117.7c-5.2-3.9-12.1-3.9-17.3 0C289.2 151 231.7 198.8 224.7 252c6-3.9 12.2-7.4 18.6-10.5c5-16.3 15.1-32.6 27.8-47.7c17.3-20.7 37.4-37.2 48.9-45.9c11.5 8.7 31.6 25.2 48.9 45.9c12.6 15.2 22.8 31.4 27.8 47.7c6.4 3.1 12.7 6.6 18.6 10.5zM204.7 344.3C225.4 301.5 269.3 272 320 272s94.6 29.5 115.3 72.3c1.2 2.6 3.7 4.3 6.6 4.5s5.6-1.1 7.2-3.4c17.3-25 46.2-41.4 78.9-41.4c53 0 96 43 96 96s-43 96-96 96l-416 0c-53 0-96-43-96-96s43-96 96-96c32.7 0 61.6 16.4 78.9 41.4c1.6 2.3 4.4 3.6 7.2 3.4s5.3-1.9 6.6-4.5zM320 256c-52.6 0-98.6 28.2-123.7 70.3C175.8 302.8 145.6 288 112 288C50.1 288 0 338.1 0 400s50.1 112 112 112l416 0c61.9 0 112-50.1 112-112s-50.1-112-112-112c-33.6 0-63.8 14.8-84.3 38.3C418.6 284.2 372.6 256 320 256z'
      
    ]
  };

  

  
  

  var faFaceGrinBeamSweat = {
    prefix: 'fat',
    iconName: 'face-grin-beam-sweat',
    icon: [
      512,
      512,
      [128517,"grin-beam-sweat"],
      'f583',
      
      'M418.7 60c-5.6 8.9-10.5 17.5-13.9 25.1c-3.6 8-4.8 13.3-4.8 16.2c0 22.4 20.2 42.7 48 42.7s48-20.4 48-42.7c0-2.8-1.2-8.1-4.8-16.1c-3.4-7.6-8.3-16.2-13.9-25.1c-9.6-15.2-20.9-30.2-29.3-40.9c-8.4 10.7-19.7 25.7-29.3 40.9zM439.5 4.1c4.3-5.5 12.8-5.5 17.1 0C473.9 25.8 512 76.3 512 101.3c0 32.5-28.7 58.7-64 58.7s-64-26.2-64-58.7c0-25 37.9-75.5 55.5-97.2zM256 16C123.5 16 16 123.5 16 256s107.5 240 240 240s240-107.4 240-240c0-22.2-3-43.6-8.6-64c-1.2-4.3 1.3-8.7 5.6-9.8s8.7 1.3 9.8 5.6c6 21.7 9.2 44.6 9.2 68.3c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0c43.1 0 83.8 10.7 119.5 29.5c3.9 2.1 5.4 6.9 3.3 10.8s-6.9 5.4-10.8 3.3C334.6 26 296.5 16 256 16zM377.7 332.4c-37.4 9.9-78.4 15.4-121.5 15.4s-84.1-5.5-121.5-15.4c-3.9-1-7.1 .3-8.7 1.8c-.7 .7-.9 1.2-.9 1.4l0 0c0 .1-.1 .7 .5 1.9c25 46.8 74.1 78.5 130.5 78.5s105.5-31.7 130.5-78.5c.7-1.2 .6-1.8 .5-1.9l0 0c0-.2-.2-.7-.9-1.4c-1.6-1.5-4.8-2.8-8.7-1.8zm-4.1-15.5c18.6-4.9 36.4 11.2 27.3 28.2C373.2 396.8 318.8 432 256.3 432s-116.9-35.2-144.6-86.9c-9.1-17 8.7-33.1 27.3-28.2c36 9.6 75.6 14.9 117.3 14.9s81.4-5.3 117.3-14.9zM135.7 225.5c-.8 4.3-5 7.2-9.3 6.4s-7.2-5-6.4-9.3c2.8-15 8.7-32 17.6-45.6c8.7-13.3 21.5-25 38.3-25s29.6 11.7 38.3 25c8.8 13.5 14.8 30.6 17.6 45.6c.8 4.3-2 8.5-6.4 9.3s-8.5-2-9.3-6.4c-2.5-13.5-7.8-28.4-15.2-39.8c-7.6-11.6-16.1-17.7-24.9-17.7s-17.3 6.1-24.9 17.7c-7.4 11.4-12.7 26.3-15.2 39.8zm175.2-39.8c-7.4 11.4-12.7 26.3-15.2 39.8c-.8 4.3-5 7.2-9.3 6.4s-7.2-5-6.4-9.3c2.8-15 8.7-32 17.6-45.6c8.7-13.3 21.5-25 38.3-25s29.6 11.7 38.3 25c8.8 13.5 14.8 30.6 17.6 45.6c.8 4.3-2 8.5-6.4 9.3s-8.5-2-9.3-6.4c-2.5-13.5-7.8-28.4-15.2-39.8c-7.6-11.6-16.1-17.7-24.9-17.7s-17.3 6.1-24.9 17.7z'
      
    ]
  };

  
    var faGrinBeamSweat = faFaceGrinBeamSweat;
  

  
  

  var faTrumpet = {
    prefix: 'fat',
    iconName: 'trumpet',
    icon: [
      640,
      512,
      [127930],
      'f8e3',
      
      'M617.2 80c-2.6 0-5.2 1.5-6.8 4.1C593.2 112.6 526.6 208 400 208H360 272 184 16v48H144h40 88 88 40c126.6 0 193.2 95.4 210.4 123.9c1.6 2.6 4.2 4.1 6.8 4.1c3.8 0 6.8-3.1 6.8-6.8V224 86.8c0-3.8-3.1-6.8-6.8-6.8zM96 272H16v8c0 4.4-3.6 8-8 8s-8-3.6-8-8V184c0-4.4 3.6-8 8-8s8 3.6 8 8v8H176V160c0-4.4 3.6-8 8-8s8 3.6 8 8v32h72V160c0-4.4 3.6-8 8-8s8 3.6 8 8v32h72V160c0-4.4 3.6-8 8-8s8 3.6 8 8v32h32c117.7 0 180.2-88.8 196.7-116.2c4.2-7 11.9-11.8 20.5-11.8C629.8 64 640 74.2 640 86.8V224 377.2c0 12.6-10.2 22.8-22.8 22.8c-8.6 0-16.3-4.8-20.5-11.8C580.2 360.8 517.7 272 400 272H368V400h32c35.3 0 64-28.7 64-64c0-7.8-1.4-15.2-3.9-22.1c6.5 2.2 12.7 4.8 18.6 7.6c.9 4.7 1.3 9.6 1.3 14.6c0 44.2-35.8 80-80 80H360 272 184 144c-44.2 0-80-35.8-80-80c0-26.2 12.6-49.4 32-64zm48 0c-35.3 0-64 28.7-64 64s28.7 64 64 64h32V272H144zm48 0V400h72V272H192zm88 0V400h72V272H280z'
      
    ]
  };

  

  
  

  var faClockRotateLeft = {
    prefix: 'fat',
    iconName: 'clock-rotate-left',
    icon: [
      512,
      512,
      ["history"],
      'f1da',
      
      'M16 166.7V56c0-4.4-3.6-8-8-8s-8 3.6-8 8V184c0 4.4 3.6 8 8 8H136c4.4 0 8-3.6 8-8s-3.6-8-8-8H29.7C62.6 82.8 151.5 16 256 16c132.5 0 240 107.5 240 240s-107.5 240-240 240c-73.5 0-139.3-33.1-183.4-85.2c-2.9-3.4-7.9-3.8-11.3-.9s-3.8 7.9-.9 11.3C107.3 476.7 177.6 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C146 0 52.2 69.4 16 166.7zM256 128c-4.4 0-8 3.6-8 8V256c0 2.1 .8 4.2 2.3 5.7l88 88c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L264 252.7V136c0-4.4-3.6-8-8-8z'
      
    ]
  };

  
    var faHistory = faClockRotateLeft;
  

  
  

  var faNestingDolls = {
    prefix: 'fat',
    iconName: 'nesting-dolls',
    icon: [
      640,
      512,
      [],
      'e3ba',
      
      'M80 128v96H64V128C64 57.3 121.3 0 192 0s128 57.3 128 128v96H304V128c0-61.9-50.1-112-112-112S80 66.1 80 128zM190.7 72c-1.3 0-2.1 .5-2.3 .9c-15.7 20.4-40.3 33.7-67.9 34.2c7.3 32.1 36 56 70.2 56s63-23.9 70.2-56c-27.6-.5-52.1-13.8-67.9-34.2c-.2-.3-1-.9-2.3-.9zm0-16c5.3 0 11.2 2.1 15 7.1c13.2 17.1 33.8 28 57 28c7.9 0 16.3 6.9 14.4 16.7c-7.8 40.6-43.5 71.3-86.4 71.3s-78.6-30.7-86.4-71.3c-1.9-9.9 6.5-16.7 14.4-16.7c23.2 0 43.8-11 57-28c3.8-5 9.7-7.1 15-7.1zM464 324.9c-1.3 0-2.1 .5-2.3 .9c-15.7 20.4-40.3 33.7-67.9 34.2c7.3 32.1 36 56 70.2 56s63-23.9 70.2-56c-27.6-.6-52.1-13.8-67.9-34.2c-.2-.3-1-.9-2.3-.9zm0-16c5.3 0 11.2 2.1 15 7.1c13.2 17.1 33.8 28 57 28c7.9 0 16.3 6.9 14.4 16.7C542.6 401.3 506.9 432 464 432s-78.6-30.7-86.4-71.3c-1.9-9.9 6.5-16.7 14.4-16.7c23.2 0 43.8-11 57-28c3.8-5 9.7-7.1 15-7.1zM622.4 483.2c-7.7-11.1-13.8-22.9-19.1-34.5C590.4 420.4 584 391 584 360c0-66.3-53.7-120-120-120s-120 53.7-120 120c0 31-6.4 60.4-19.3 88.7c-5.3 11.6-11.4 23.4-19.1 34.5l-.1 .1 0 0 0 0-.1 .1c-1.7 2.4-2 5.6-.6 8.3s4.1 4.3 7.1 4.3H616c3 0 5.7-1.7 7.1-4.3s1.1-5.9-.6-8.3l-.1-.2 0 0zM290.7 499c-4.1-8-3.4-17.6 1.8-24.9l0 0c7-10 12.6-20.9 17.7-32C322.1 415.9 328 388.7 328 360c0-75.1 60.9-136 136-136s136 60.9 136 136c0 28.7 5.9 55.9 17.8 82.1c5 11.1 10.7 22 17.7 32c5.2 7.3 5.9 16.9 1.8 24.9s-12.4 13-21.3 13H312c-9 0-17.2-5-21.3-13zm-34.1-3c.8 5.5 2.4 10.9 4.8 16H74.5c-17 0-33.4-6.7-42.7-20.9C17.9 469.7 0 432.8 0 384c0-44.4 20.2-84.4 37.9-119.4c2.7-5.3 8.1-8.6 14-8.6H332.1c-4 5.1-7.8 10.4-11.2 16H52.1C34.1 307.5 16 344.1 16 384c0 44.8 16.4 78.7 29.2 98.3c5.6 8.6 16.2 13.7 29.3 13.7H256.6z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassMusic = {
    prefix: 'fat',
    iconName: 'magnifying-glass-music',
    icon: [
      512,
      512,
      [],
      'e65f',
      
      'M400 208A192 192 0 1 0 16 208a192 192 0 1 0 384 0zM349.3 360.6C312.2 395 262.6 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 54.6-21 104.2-55.4 141.3l149 149c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-149-149zM288 104c0-2.5-1.1-4.8-3.1-6.3s-4.5-2.1-6.9-1.5l-64 16c-3.6 .9-6.1 4.1-6.1 7.8v64 54.4c-10.2-8.9-24.3-14.4-40-14.4c-30.9 0-56 21.5-56 48s25.1 48 56 48s56-21.5 56-48V190.2l57.9-14.5c3.6-.9 6.1-4.1 6.1-7.8V104zM208 272c0 15.4-15.5 32-40 32s-40-16.6-40-32s15.5-32 40-32s40 16.6 40 32zm64-110.2l-48 12V126.2l48-12v47.5z'
      
    ]
  };

  

  
  

  var faChairOffice = {
    prefix: 'fat',
    iconName: 'chair-office',
    icon: [
      448,
      512,
      [],
      'f6c1',
      
      'M288 16c26.5 0 48 21.5 48 48V256h16V64c0-35.3-28.7-64-64-64H160C124.7 0 96 28.7 96 64V256h16V64c0-26.5 21.5-48 48-48H288zM48 168c0-4.4-3.6-8-8-8s-8 3.6-8 8v80c0 4.4 3.6 8 8 8s8-3.6 8-8V168zm368 0c0-4.4-3.6-8-8-8s-8 3.6-8 8v80c0 4.4 3.6 8 8 8s8-3.6 8-8V168zM80 304H368c6.1 0 11.6 3.4 14.3 8.8l16 32c2.5 5 2.2 10.9-.7 15.6s-8.1 7.6-13.6 7.6H224 64c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6l16-32c2.7-5.4 8.3-8.8 14.3-8.8zm152 80H384c11.1 0 21.4-5.7 27.2-15.2s6.4-21.2 1.4-31.1l-16-32C391.2 294.8 380.1 288 368 288H80c-12.1 0-23.2 6.8-28.6 17.7l-16 32c-5 9.9-4.4 21.7 1.4 31.1S52.9 384 64 384H216v64H184c-30.9 0-56 25.1-56 56c0 4.4 3.6 8 8 8s8-3.6 8-8c0-22.1 17.9-40 40-40h32v40c0 4.4 3.6 8 8 8s8-3.6 8-8V464h32c22.1 0 40 17.9 40 40c0 4.4 3.6 8 8 8s8-3.6 8-8c0-30.9-25.1-56-56-56H232V384z'
      
    ]
  };

  

  
  

  var faFishCooked = {
    prefix: 'fat',
    iconName: 'fish-cooked',
    icon: [
      576,
      512,
      [],
      'f7fe',
      
      'M130.3 183.2c22.6-25.4 52.5-51.3 85.7-70.8C249.1 92.8 285 80 319.9 80c55.9 0 116.2 28.8 162.9 66.2c23.2 18.6 42.7 39.1 56.4 58.6C552.9 224.5 560 242.4 560 256s-7.1 31.5-20.9 51.2c-13.6 19.5-33.1 40-56.4 58.6C436.1 403.2 375.8 432 319.9 432c-34.8 0-70.7-12.8-103.9-32.4c-33.1-19.5-63-45.4-85.7-70.8c-2.8-3.2-7.6-3.6-11-.9L31.2 398.4c-1.3 1-2.8 1.6-4.5 1.6c-4.5 0-7.9-4.2-7-8.6L46.4 264.2c1.1-5.4 1.1-11 0-16.5L19.7 120.6c-.9-4.4 2.5-8.6 7-8.6c1.6 0 3.2 .6 4.5 1.6l88.1 70.5c3.3 2.7 8.1 2.3 11-.9zM319.9 64c-38.6 0-77.4 14.2-112 34.6c-32.3 19-61.5 43.7-84.4 68.3L41.2 101.1C37 97.8 31.9 96 26.7 96C12 96 1 109.5 4 123.9L30.8 251.1c.7 3.3 .7 6.6 0 9.9L4 388.1C1 402.5 12 416 26.7 416c5.3 0 10.4-1.8 14.5-5.1l82.3-65.8c22.9 24.6 52.1 49.3 84.4 68.3c34.7 20.4 73.4 34.6 112 34.6c60.9 0 124.7-31.1 172.9-69.7c24.2-19.4 44.8-40.9 59.5-61.9C566.7 295.6 576 274.5 576 256s-9.3-39.6-23.8-60.4c-14.6-21-35.3-42.5-59.5-61.9C444.5 95.1 380.8 64 319.9 64zM309.7 165.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-64 64c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l64-64zm112 16c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-160 160c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l160-160zm16 112c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-64 64c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l64-64z'
      
    ]
  };

  

  
  

  var faPenPaintbrush = {
    prefix: 'fat',
    iconName: 'pen-paintbrush',
    icon: [
      576,
      512,
      ["pencil-paintbrush"],
      'f618',
      
      'M320 410.6c1.3 45.1 36.5 81.7 81.1 85.2c.7 .1 1.3 .1 1.9 .3h5 136c8.8 0 16-7.2 16-16s-7.2-16-16-16h-4c-14.6 0-26.2-7.7-33.6-17.4c-7.3-9.6-11.2-22-10.6-34.3c.1-1.4 .1-2.8 .1-4.3c0-47.7-38-86.6-85.4-88l14.6-14.6c49.3 8.2 86.8 51 86.8 102.6c0 1.7 0 3.4-.1 5c-.8 17.1 11 35 28.2 35h4c17.7 0 32 14.3 32 32s-14.3 32-32 32h-136-7.8c-.1 0-.2-.1-.2-.2s-.1-.2-.1-.2c-47.9-3.7-86.7-39.9-94.4-86.5L320 410.6zM139.1 218.3L16.4 95.6c-21.9-21.9-21.9-57.3 0-79.2s57.3-21.9 79.2 0L218.3 139.1 207 150.5 84.3 27.7c-15.6-15.6-40.9-15.6-56.6 0s-15.6 40.9 0 56.6L150.5 207l-11.3 11.3zM472.2 25.9c-12.5-12.5-32.8-12.5-45.3 0L360.1 92.8l91.1 91.1L518.1 117c12.5-12.5 12.5-32.8 0-45.3L472.2 25.9zM105.6 347.3c-10.4 10.4-18 23.3-22.2 37.4L51.8 492.2l107.5-31.6c14.1-4.2 27-11.8 37.4-22.2L439.9 195.2l-91.1-91.1L105.6 347.3zm310-332.7c18.7-18.7 49.1-18.7 67.9 0l45.8 45.8c18.7 18.7 18.7 49.1 0 67.9L208 449.7c-12.3 12.3-27.5 21.3-44.2 26.2L42.3 511.7c-2.8 .8-5.8 .1-7.9-2s-2.8-5.1-2-7.9L68.1 380.2C73 363.5 82 348.3 94.3 336L415.7 14.6z'
      
    ]
  };

  
    var faPencilPaintbrush = faPenPaintbrush;
  

  
  

  var faBrowser = {
    prefix: 'fat',
    iconName: 'browser',
    icon: [
      512,
      512,
      [128468],
      'f37e',
      
      'M128 48V96v48H496V96c0-26.5-21.5-48-48-48H128zm-16 0H64C37.5 48 16 69.5 16 96v48h96V96 48zM16 160V416c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V160H120 16zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z'
      
    ]
  };

  

  
  

  var faFireplace = {
    prefix: 'fat',
    iconName: 'fireplace',
    icon: [
      640,
      512,
      [],
      'f79a',
      
      'M624 16V80H16l0-64H624zM16 0C7.2 0 0 7.2 0 16V80c0 8.8 7.2 16 16 16H32V488c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V352c0-88.4 71.6-160 160-160s160 71.6 160 160V488c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V96h16c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H16zM48 488V96H592V488c0 4.4-3.6 8-8 8H504c-4.4 0-8-3.6-8-8V352c0-97.2-78.8-176-176-176s-176 78.8-176 176V488c0 4.4-3.6 8-8 8H56c-4.4 0-8-3.6-8-8zM295.8 271.2c.5 0 .9 .2 1.2 .5c11.2 10.1 21.8 21 31.7 32.6c5.6 6.5 15.6 6.3 21-.2c4-4.9 8.2-9.6 12.5-13.5c.7-.6 1.8-.6 2.5 0c13.1 12 26.6 28.5 36.8 46.5c10.3 18.1 16.8 37.2 16.8 54.6c0 31.9-15.1 60.4-38.6 78.5c4.7-8.6 7.4-18.3 7.4-28.7c0-40.2-44.6-77.3-61.1-89.7c-3.6-2.7-8.5-2.7-12.1 0c-16.5 12.4-61.1 49.6-61.1 89.7c0 10.5 2.8 20.3 7.6 29c-23.7-18.1-38.8-46.7-38.8-78.8c0-21.9 9.6-44.3 23.8-65.3c14.2-20.9 32.6-39.8 49.2-54.7c.3-.3 .7-.5 1.2-.4zm-11.9-11.5c-17.1 15.3-36.5 35.2-51.7 57.6c-15.2 22.3-26.6 47.8-26.6 74.3c0 63 50.2 114.8 114.4 114.8c63.5 0 114.4-51.8 114.4-114.8c0-21.2-7.9-43.1-18.9-62.5c-11.1-19.5-25.7-37.2-39.9-50.4c-6.8-6.3-17.3-6.3-24.1 0c-4.4 4-8.6 8.6-12.3 13.1c-9.9-11.3-20.4-22-31.4-32c-3.4-3-7.6-4.6-11.8-4.6c-4.3 0-8.6 1.5-12 4.5zM320 488.1c-29.3 0-51.2-21.9-51.2-46.7c0-14.4 8.2-30.1 20.7-45c10.4-12.5 22.4-22.8 30.5-29.2c8.1 6.3 20.1 16.7 30.5 29.2c12.4 14.9 20.7 30.6 20.7 45c0 24.8-21.9 46.7-51.2 46.7z'
      
    ]
  };

  

  
  

  var faDiceD10 = {
    prefix: 'fat',
    iconName: 'dice-d10',
    icon: [
      512,
      512,
      [],
      'f6cd',
      
      'M243.2 26.4L21.7 278.5l132.5-29.4L243.2 26.4zM20.2 295.3L248 491.7V324.3l-89.6-59.7L20.2 295.3zM264 491.7L491.8 295.3 353.6 264.6 264 324.3V491.7zM490.3 278.5L268.8 26.4l89.1 222.7 132.5 29.4zM256 0c6.9 0 13.5 3 18 8.2l232 264c4.2 4.8 6.4 11.1 5.9 17.5s-3.4 12.3-8.3 16.5l-232 200c-9 7.8-22.3 7.8-31.3 0l-232-200C3.5 302 .5 296 .1 289.7S1.7 277 6 272.2L238 8.2C242.5 3 249.1 0 256 0zm0 310.4l86.2-57.4L256 37.5 169.8 252.9 256 310.4z'
      
    ]
  };

  

  
  

  var faQrcode = {
    prefix: 'fat',
    iconName: 'qrcode',
    icon: [
      448,
      512,
      [],
      'f029',
      
      'M144 48c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V80c0-17.7 14.3-32 32-32h96zM48 32C21.5 32 0 53.5 0 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zm96 272c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V336c0-17.7 14.3-32 32-32h96zM48 288c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H48zM304 48h96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H304c-17.7 0-32-14.3-32-32V80c0-17.7 14.3-32 32-32zM256 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48zm0 216V472c0 4.4 3.6 8 8 8s8-3.6 8-8V304h32V408c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V304h32V408c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8s-3.6-8-8-8H416V296c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8V400H320V296c0-4.4-3.6-8-8-8H264c-4.4 0-8 3.6-8 8zm80-184h32v32H336V112zm-16 0v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16zm-208 0v32H80V112h32zM80 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80zm0 272h32v32H80V368zm-16 0v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm256 96a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm112-16a16 16 0 1 0 0 32 16 16 0 1 0 0-32z'
      
    ]
  };

  

  
  

  var faSubtitlesSlash = {
    prefix: 'fat',
    iconName: 'subtitles-slash',
    icon: [
      640,
      512,
      [],
      'e610',
      
      'M13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7zM467.3 464H96c-26.5 0-48-21.5-48-48V133L32 120.4V416c0 35.3 28.7 64 64 64H487.5l-20.3-16zM544 32H152.5l20.3 16H544c26.5 0 48 21.5 48 48V379l16 12.6V96c0-35.3-28.7-64-64-64zM456.5 272l20.3 16H496c4.4 0 8-3.6 8-8s-3.6-8-8-8H456.5zM144 272c-4.4 0-8 3.6-8 8s3.6 8 8 8H244.3l-20.3-16H144zm160 96c-4.4 0-8 3.6-8 8s3.6 8 8 8h61.9l-20.3-16H304zm-160 0c-4.4 0-8 3.6-8 8s3.6 8 8 8h96c4.4 0 8-3.6 8-8s-3.6-8-8-8H144z'
      
    ]
  };

  

  
  

  var faAlbumCircleUser = {
    prefix: 'fat',
    iconName: 'album-circle-user',
    icon: [
      576,
      512,
      [],
      'e48d',
      
      'M384 48H64C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H284.5c3.6 5.6 7.6 10.9 11.8 16H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64v96.7c-5.3-.5-10.6-.7-16-.7V96c0-26.5-21.5-48-48-48zM224 96c69.3 0 128.3 44 150.5 105.6c-5.1 1.8-10 3.7-14.9 5.9C339.7 151.8 286.5 112 224 112c-79.5 0-144 64.5-144 144s64.5 144 144 144c11.8 0 23.2-1.4 34.2-4.1c.8 5.3 1.9 10.5 3.2 15.7c-12 2.9-24.5 4.4-37.4 4.4c-88.4 0-160-71.6-160-160s71.6-160 160-160zm16 160a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM509.9 469.6l-3.3-6.6c-9.5-19-28.9-31-50.1-31H407.6c-21.2 0-40.6 12-50.1 31l-3.3 6.6C375.7 486.2 402.7 496 432 496s56.3-9.8 77.9-26.4zm12.4-10.9C545.6 435.5 560 403.5 560 368c0-70.7-57.3-128-128-128s-128 57.3-128 128c0 35.5 14.4 67.5 37.7 90.7l1.5-2.9c12.2-24.4 37.1-39.8 64.4-39.8h48.9c27.3 0 52.2 15.4 64.4 39.8l1.5 2.9zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  

  
  

  var faPancakes = {
    prefix: 'fat',
    iconName: 'pancakes',
    icon: [
      512,
      512,
      [129374],
      'e42d',
      
      'M61.9 90.3c9.9-7.8 24.8-15.2 43.9-21.6c16.7-5.6 36.3-10.2 58-13.7c-2.4 5.2-3.8 10.9-3.8 17c0 22.1 17.9 40 40 40H312c22.1 0 40-17.9 40-40c0-6.1-1.4-11.9-3.8-17c21.7 3.5 41.3 8.1 58 13.7c19.1 6.4 33.9 13.8 43.9 21.6c10 7.9 13.9 15.3 13.9 21.7c0 5.7-3 12.2-10.8 19.1c-7.7 6.9-19.4 13.7-34.7 19.7c-30.5 12.1-73.7 20.9-123.4 24c-21.5 1.3-39.1 18.8-39.1 40.8V288c0 8.8-7.2 16-16 16s-16-7.2-16-16V212.8c0-21.2-16.5-38.3-37-40.6c-3.6-.4-7.1-.8-10.6-1.3C151.7 167.6 128 186 128 211.8V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V178.7c0-16.4-10.1-30.1-23.3-37.7C55 130.7 48 120.5 48 112c0-6.4 3.9-13.8 13.9-21.7zM187 51.8c21.6-2.5 44.8-3.8 69-3.8s47.4 1.3 69 3.8c6.6 4.3 11 11.7 11 20.2c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24c0-8.5 4.4-15.9 11-20.2zm-86.3 1.7C80.7 60.2 64 68.3 52 77.7C40.2 87 32 98.6 32 112c0 17.6 13.9 31.9 32.7 42.8c9.3 5.4 15.3 14.4 15.3 23.9V336c0 17.7 14.3 32 32 32s32-14.3 32-32V211.8c0-15.2 14.3-27.2 30.2-25.1c3.6 .5 7.2 .9 10.9 1.4c13 1.5 22.9 12.2 22.9 24.7V288c0 17.7 14.3 32 32 32s32-14.3 32-32V215.6c0-13 10.6-24 24.1-24.8c50.7-3.1 95.7-12.1 128.3-25c16.3-6.4 29.8-14 39.5-22.7c9.7-8.7 16.1-19.1 16.1-31c0-13.4-8.2-25-20-34.3c-11.9-9.4-28.7-17.5-48.7-24.2C371.2 40.1 316.3 32 256 32s-115.2 8.1-155.3 21.5zm404.5 88.2c-2.9 6.2-6.6 11.7-10.6 16.5c.9 3.2 1.3 6.5 1.3 9.8c0 22.1-18.8 42.5-64.1 57.9c-33.6 11.4-77.7 18.3-127.9 20.9v16c81-4.2 148.6-19.4 183.1-47.5c6.1 7.9 8.9 16.2 8.9 24.7c0 22.1-18.8 42.5-64.1 57.9c-35.4 12-82.5 19-136 21.3c-3.5 6.2-7.9 11.8-13.2 16.5c90.4-2.5 166.8-17.8 204.4-48.3c6.1 7.9 8.9 16.2 8.9 24.7c0 22.1-18.8 42.5-64.1 57.9c-44 14.9-106 22.1-175.9 22.1c-37.3 0-72.4-2.1-103.7-6.3c-7.1 5.8-15.5 10.1-24.7 12.4c37.7 6.7 81.6 9.9 128.4 9.9c101.9 0 189.9-15.2 231.1-48.7c6.1 7.9 8.9 16.2 8.9 24.7c0 22.1-18.8 42.5-64.1 57.9c-44 14.9-106 22.1-175.9 22.1s-131.9-7.3-175.9-22.1C34.8 426.5 16 406.1 16 384c0-8.5 2.8-16.8 8.9-24.7c11.2 9.1 25.8 16.8 43.3 23.3c-7.2-6.8-12.8-15.2-16.3-24.6C26.8 344.6 16 328.8 16 312c0-8.5 2.8-16.8 8.9-24.7c6.6 5.3 14.3 10.2 23.1 14.6V283.8C25.7 270.9 16 255.9 16 240c0-8.5 2.8-16.8 8.9-24.7c6.6 5.3 14.3 10.2 23.1 14.6V211.8C25.7 198.9 16 183.9 16 168c0-3.3 .4-6.5 1.3-9.7c-4.1-4.9-7.7-10.4-10.6-16.4C2.3 149.8 0 158.5 0 168c0 13.5 4.7 25.5 13.4 36C4.7 214.5 0 226.5 0 240s4.7 25.5 13.4 36C4.7 286.5 0 298.5 0 312s4.7 25.5 13.4 36C4.7 358.5 0 370.5 0 384c0 66.7 114.6 96 256 96s256-29.3 256-96c0-13.5-4.7-25.5-13.4-36c8.7-10.5 13.4-22.5 13.4-36s-4.7-25.5-13.4-36c8.7-10.5 13.4-22.5 13.4-36s-4.7-25.5-13.4-36c8.7-10.5 13.4-22.5 13.4-36c0-9.5-2.3-18.3-6.7-26.3z'
      
    ]
  };

  

  
  

  var faCamcorder = {
    prefix: 'fat',
    iconName: 'camcorder',
    icon: [
      576,
      512,
      [128249,"video-handheld"],
      'f8a8',
      
      'M64 104c0-30.9 25.1-56 56-56H312c4.4 0 8-3.6 8-8s-3.6-8-8-8H120c-39.8 0-72 32.2-72 72v58c-27.6 7.1-48 32.2-48 62V416c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V399 371.3 268.7 241 224c0-35.3-28.7-64-64-64H64V104zm0 72H320c26.5 0 48 21.5 48 48v44.7V371.3 416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V224c0-26.5 21.5-48 48-48zM526.8 445.9L416 396.1v17.5l104.3 46.9c5.1 2.3 10.6 3.5 16.2 3.5c21.8 0 39.5-17.7 39.5-39.5v-209c0-21.8-17.7-39.5-39.5-39.5c-5.6 0-11.1 1.2-16.2 3.5L416 226.4v17.5l110.8-49.9c3-1.4 6.3-2.1 9.7-2.1c13 0 23.5 10.5 23.5 23.5v209c0 13-10.5 23.5-23.5 23.5c-3.3 0-6.6-.7-9.7-2.1zM64 248c0 4.4 3.6 8 8 8H312c4.4 0 8-3.6 8-8s-3.6-8-8-8H72c-4.4 0-8 3.6-8 8z'
      
    ]
  };

  
    var faVideoHandheld = faCamcorder;
  

  
  

  var faAnglesLeft = {
    prefix: 'fat',
    iconName: 'angles-left',
    icon: [
      512,
      512,
      [171,"angle-double-left"],
      'f100',
      
      'M50.3 250.3c-3.1 3.1-3.1 8.2 0 11.3l176 176c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L67.3 256 237.7 85.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-176 176zm368-176l-176 176c-3.1 3.1-3.1 8.2 0 11.3l176 176c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L259.3 256 429.7 85.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0z'
      
    ]
  };

  
    var faAngleDoubleLeft = faAnglesLeft;
  

  
  

  var faBuilding = {
    prefix: 'fat',
    iconName: 'building',
    icon: [
      384,
      512,
      [61687,127970],
      'f1ad',
      
      'M48 16C30.3 16 16 30.3 16 48V464c0 17.7 14.3 32 32 32h96V416c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c17.7 0 32-14.3 32-32V48c0-17.7-14.3-32-32-32H48zM160 496h64V416c0-17.7-14.3-32-32-32s-32 14.3-32 32v80zm-16 16H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H240 224 160 144zM104 232h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V256c0-13.3 10.7-24 24-24zm-8 24v32c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V256c0-4.4-3.6-8-8-8H104c-4.4 0-8 3.6-8 8zm128 0c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H248c-13.3 0-24-10.7-24-24V256zm24-8c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V256c0-4.4-3.6-8-8-8H248zM104 104h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V128c0-13.3 10.7-24 24-24zm-8 24v32c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V128c0-4.4-3.6-8-8-8H104c-4.4 0-8 3.6-8 8zm128 0c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H248c-13.3 0-24-10.7-24-24V128zm24-8c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V128c0-4.4-3.6-8-8-8H248z'
      
    ]
  };

  

  
  

  var faTicketSimple = {
    prefix: 'fat',
    iconName: 'ticket-simple',
    icon: [
      576,
      512,
      ["ticket-alt"],
      'f3ff',
      
      'M0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64v72.6c0 4-2.9 7.4-6.9 7.9C545.9 211.8 528 231.8 528 256s17.9 44.2 41.1 47.5c3.9 .6 6.9 3.9 6.9 7.9V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V311.4c0-4 2.9-7.4 6.9-7.9C30.1 300.2 48 280.2 48 256s-17.9-44.2-41.1-47.5c-3.9-.6-6.9-3.9-6.9-7.9V128zM64 80c-26.5 0-48 21.5-48 48v66c27.6 7.1 48 32.2 48 62s-20.4 54.9-48 62v66c0 26.5 21.5 48 48 48H512c26.5 0 48-21.5 48-48V318c-27.6-7.1-48-32.2-48-62s20.4-54.9 48-62V128c0-26.5-21.5-48-48-48H64z'
      
    ]
  };

  
    var faTicketAlt = faTicketSimple;
  

  
  

  var faAward = {
    prefix: 'fat',
    iconName: 'award',
    icon: [
      384,
      512,
      [],
      'f559',
      
      'M214.1 6.2c-13.6-8.3-30.7-8.3-44.3 0L152.7 16.6c-4.3 2.6-9.3 4-14.4 3.9L118.3 20c-15.9-.4-30.7 8.2-38.3 22.1L70.3 59.8c-2.4 4.5-6.1 8.1-10.6 10.6L42.2 79.9c-14 7.6-22.5 22.4-22.1 38.3l.5 20.1c.1 5.1-1.2 10.1-3.9 14.4L6.2 169.9c-8.3 13.6-8.3 30.7 0 44.3l10.4 17.1c2.6 4.3 4 9.3 3.9 14.4L20 265.7c-.4 15.9 8.2 30.7 22.1 38.3l17.6 9.6c4.5 2.4 8.1 6.1 10.6 10.6l9.6 17.6c7.6 14 22.4 22.5 38.3 22.1l20.1-.5c5.1-.1 10.1 1.2 14.4 3.9l17.1 10.4c13.6 8.3 30.7 8.3 44.3 0l17.1-10.4c4.3-2.6 9.3-4 14.4-3.9l20.1 .5c15.9 .4 30.7-8.2 38.3-22.1l9.6-17.6c2.4-4.5 6.1-8.1 10.6-10.6l17.6-9.6c14-7.6 22.5-22.4 22.1-38.3l-.5-20.1c-.1-5.1 1.2-10.1 3.9-14.4l10.4-17.1c8.3-13.6 8.3-30.7 0-44.3l-10.4-17.1c-2.6-4.3-4-9.3-3.9-14.4l.5-20.1c.4-15.9-8.2-30.7-22.1-38.3l-17.6-9.6c-4.5-2.4-8.1-6.1-10.6-10.6l-9.6-17.6c-7.6-14-22.4-22.5-38.3-22.1l-20.1 .5c-5.1 .1-10.1-1.2-14.4-3.9L214.1 6.2zM178.2 19.9c8.5-5.2 19.1-5.2 27.6 0l17.1 10.4c7 4.2 15 6.4 23.1 6.2l20.1-.5c9.9-.2 19.1 5.1 23.9 13.8l9.6 17.6c3.9 7.1 9.8 13 16.9 16.9L334.2 94c8.7 4.8 14 14 13.8 23.9l-.5 20.1c-.2 8.1 2 16.2 6.2 23.1l10.4 17.1c5.2 8.5 5.2 19.1 0 27.6l-10.4 17.1c-4.2 7-6.4 15-6.2 23.1l.5 20.1c.2 9.9-5.1 19.1-13.8 23.9l-17.6 9.6c-7.1 3.9-13 9.8-16.9 16.9L290 334.2c-4.8 8.7-14 14-23.9 13.8l-20.1-.5c-8.1-.2-16.2 2-23.1 6.2l-17.1 10.4c-8.5 5.2-19.1 5.2-27.6 0l-17.1-10.4c-7-4.2-15-6.4-23.1-6.2l-20.1 .5c-9.9 .2-19.1-5.1-23.9-13.8l-9.6-17.6c-3.9-7.1-9.8-13-16.9-16.9L49.8 290c-8.7-4.8-14-14-13.8-23.9l.5-20.1c.2-8.1-2-16.2-6.2-23.1L19.9 205.8c-5.2-8.5-5.2-19.1 0-27.6l10.4-17.1c4.2-7 6.4-15 6.2-23.1L36 117.9C35.8 108 41.1 98.7 49.8 94l17.6-9.6c7.1-3.9 13-9.8 16.9-16.9L94 49.8c4.8-8.7 14-14 23.9-13.8l20.1 .5c8.1 .2 16.2-2 23.1-6.2l17.1-10.4zM264 192a72 72 0 1 1 -144 0 72 72 0 1 1 144 0zm-72-88a88 88 0 1 0 0 176 88 88 0 1 0 0-176zM39 340.6L2.7 439.4c-2.1 5.8-1.8 12.3 1 17.8c4.7 9.4 15.3 14.3 25.6 11.8l46.1-11.5 18.2 42.4C96.7 507.2 104 512 112 512c8.1 0 15.4-4.8 18.5-12.3l36.9-87.5c-5-1.6-10-3.7-14.7-6.3l-36.9 87.7c-.6 1.5-2.1 2.5-3.8 2.5s-3.1-1-3.8-2.5L87.4 444.8c-1.5-3.6-5.5-5.6-9.3-4.6L25.3 453.4c-2.9 .7-6-.7-7.4-3.4c-.8-1.6-.9-3.5-.3-5.1l32.6-88.6c-.3-.5-.6-1.1-.9-1.6c-4.2-7.7-6.5-10.5-8.1-12c-.5-.5-1.3-1.2-2.3-2zm177.6 71.5l36.9 87.5c3.1 7.4 10.4 12.3 18.5 12.3c8 0 15.3-4.8 18.5-12.2l18.2-42.4 46.1 11.5c10.2 2.6 20.9-2.3 25.6-11.8c2.8-5.6 3.1-12 1-17.8L345 340.6c-1.1 .8-1.8 1.5-2.3 2c-1.5 1.5-3.8 4.3-8.1 12c-.3 .5-.6 1.1-.9 1.6l32.6 88.6c.6 1.7 .5 3.5-.3 5.1c-1.4 2.7-4.4 4.1-7.4 3.4l-52.7-13.2c-3.8-1-7.7 1-9.3 4.6l-20.9 48.7c-.6 1.5-2.1 2.5-3.8 2.5s-3.1-1-3.8-2.5l-36.9-87.7c-4.7 2.6-9.6 4.7-14.7 6.4z'
      
    ]
  };

  

  
  

  var faUserGroupSimple = {
    prefix: 'fat',
    iconName: 'user-group-simple',
    icon: [
      640,
      512,
      [],
      'e603',
      
      'M248 136A88 88 0 1 0 72 136a88 88 0 1 0 176 0zM56 136a104 104 0 1 1 208 0A104 104 0 1 1 56 136zm512 0a88 88 0 1 0 -176 0 88 88 0 1 0 176 0zm-192 0a104 104 0 1 1 208 0 104 104 0 1 1 -208 0zM128 304C66.1 304 16 354.1 16 416v16c0 17.7 14.3 32 32 32H272c17.7 0 32-14.3 32-32V416c0-61.9-50.1-112-112-112H128zm0-16h64c48.2 0 90.2 26.6 112 66c9.2 16.6 14.8 35.4 15.8 55.4c.1 1.5 .1 3 .2 4.6c0 .7 0 1.3 0 2v16c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V416c0-70.7 57.3-128 128-128zM432 480c-31.2 0-59.9-11.2-82.1-29.8c1.4-5.8 2.1-11.9 2.1-18.2v-1.6c20.3 20.7 48.7 33.6 80 33.6h80c61.9 0 112-50.1 112-112V336c0-17.7-14.3-32-32-32H352c-13.2 0-24.6 8-29.5 19.5c-3.4-4.7-7-9.3-10.8-13.6c8.6-13.2 23.4-21.9 40.3-21.9H592c26.5 0 48 21.5 48 48v16c0 70.7-57.3 128-128 128H432z'
      
    ]
  };

  

  
  

  var faConveyorBeltEmpty = {
    prefix: 'fat',
    iconName: 'conveyor-belt-empty',
    icon: [
      640,
      512,
      [],
      'e150',
      
      'M96 336c-44.2 0-80 35.8-80 80s35.8 80 80 80H544c44.2 0 80-35.8 80-80s-35.8-80-80-80H96zM0 416c0-53 43-96 96-96H544c53 0 96 43 96 96s-43 96-96 96H96c-53 0-96-43-96-96zm144 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm256 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm240 48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  

  
  

  var faFlagPennant = {
    prefix: 'fat',
    iconName: 'flag-pennant',
    icon: [
      448,
      512,
      [128681,"pennant"],
      'f456',
      
      'M16 8c0-4.4-3.6-8-8-8S0 3.6 0 8V40 344 504c0 4.4 3.6 8 8 8s8-3.6 8-8V349.7L442.7 199.5c3.2-1.1 5.3-4.2 5.3-7.5s-2.1-6.4-5.3-7.5L16 34.3V8zm0 43.3L415.9 192 16 332.7V51.3z'
      
    ]
  };

  
    var faPennant = faFlagPennant;
  

  
  

  var faPersonFallingBurst = {
    prefix: 'fat',
    iconName: 'person-falling-burst',
    icon: [
      640,
      512,
      [],
      'e547',
      
      'M174.7 162c-3.7 2.4-6.2 6.2-7 10.5s.2 8.7 2.7 12.3l.2 .3 0 0 56.8 80.1c3 4.2 7.9 6.7 13.1 6.7l71.5 0c10.1 0 19.6 4.7 25.6 12.8l43.2 57.6c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2l-38.4-51.2c-3-4-7.8-6.4-12.8-6.4l-80 0h-1.4c-5.9 0-11.3 3.2-14.1 8.4s-2.6 11.4 .6 16.3l92.3 142.6c4.8 7.4 2.7 17.3-4.7 22.1s-17.3 2.7-22.1-4.7L114 240.5c-3.4-5.2-9.4-8-15.5-7.2s-11.2 5.1-13.1 11c-3.4 10.8-5.3 22.2-5.3 33.9L80 352c0 8.8-7.2 16-16 16s-16-7.2-16-16V278.2c0-58.6 35.7-111.3 90.1-133C180.3 128.2 208 87.3 208 41.8l0-9.8c0-8.8 7.2-16 16-16s16 7.2 16 16l0 9.8c0 49.1-25.1 94.1-65.3 120.2zm65.8 94l-47.8-67.5-9-12.7-.2-.3c4.2-2.7 8.3-5.7 12.2-8.8C233.1 136.9 256 91.3 256 41.8l0-9.8c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 9.8c0 39-23.7 74-59.9 88.4C71.6 154.5 32 213 32 278.2V352c0 17.7 14.3 32 32 32s32-14.3 32-32l0-73.8c0-2.1 .1-4.2 .2-6.2c.5-7.8 2-15.5 4.3-22.8l12.1 18.8L261.1 497.4c9.6 14.8 29.4 19.1 44.3 9.5s19.1-29.4 9.5-44.3L232.9 336 224 322.2l-1.4-2.2H224h17.6l62.4 0 38.4 51.2c10.6 14.1 30.7 17 44.8 6.4s17-30.7 6.4-44.8l-43.2-57.6C341.3 263.1 327.1 256 312 256l-71.5 0zM16 88a40 40 0 1 1 80 0A40 40 0 1 1 16 88zm40 56A56 56 0 1 0 56 32a56 56 0 1 0 0 112zM449.5 20.5L418.1 88.7l-72.9-18c-13.3-3.3-24.3 10.5-18.1 22.7L361 160.8l-53.7 46c-10 8.5-6 24.8 6.8 27.8l67.2 15.3-.4 23.9 15.6 21.9 .9-51.9c.1-3.8-2.5-7.1-6.2-7.9l-73.5-16.8 58.5-50.1c2.8-2.4 3.6-6.4 1.9-9.7l-36.8-73 79.3 19.6c3.7 .9 7.6-.9 9.2-4.4L464 27.2l34.1 74.2c1.6 3.5 5.5 5.3 9.2 4.4l79.3-19.6-36.8 73c-1.7 3.3-.9 7.3 1.9 9.7l58.5 50.1-73.5 16.8c-3.7 .8-6.3 4.2-6.2 7.9l1.5 81.7-63-52.1c-3-2.4-7.2-2.4-10.2 0L409.7 314l3.9 5.5c1.9 2.6 3.5 5.3 4.8 8.1L464 289.8l57.9 47.9c10.5 8.7 26.4 1.1 26.2-12.6l-1.4-75.2 67.2-15.3c12.8-2.9 16.8-19.2 6.8-27.8l-53.7-46 33.9-67.4c6.2-12.2-4.9-26-18.1-22.7l-72.9 18L478.5 20.5c-5.7-12.4-23.4-12.4-29.1 0z'
      
    ]
  };

  

  
  

  var faArrowRightToLine = {
    prefix: 'fat',
    iconName: 'arrow-right-to-line',
    icon: [
      448,
      512,
      [8677,"arrow-to-right"],
      'f340',
      
      'M448 72c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 368c0 4.4 3.6 8 8 8s8-3.6 8-8l0-368zM349.7 261.7c3.1-3.1 3.1-8.2 0-11.3l-136-136c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L324.7 248 8 248c-4.4 0-8 3.6-8 8s3.6 8 8 8l316.7 0L202.3 386.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l136-136z'
      
    ]
  };

  
    var faArrowToRight = faArrowRightToLine;
  

  
  

  var faAnt = {
    prefix: 'fat',
    iconName: 'ant',
    icon: [
      640,
      512,
      [],
      'e680',
      
      'M505 11.7C512.5 4.2 522.6 0 533.3 0L600 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-66.7 0c-6.4 0-12.5 2.5-17 7L490.6 48.7C556.6 55.3 608 111 608 178.7c0 38.3-31 69.3-69.3 69.3L468 248c-7.9 0-15.6-.9-23-2.7c7 12.6 11 27.2 11 42.7c0 8.8-1.3 17.3-3.7 25.3c.1 .1 .3 .2 .4 .3l103.6 76c12 8.8 21 21.1 25.7 35.3l25.6 76.7c1.4 4.2-.9 8.7-5.1 10.1s-8.7-.9-10.1-5.1l-25.6-76.7c-3.7-11-10.7-20.6-20-27.4L446.1 328.5c-6.5 12.4-15.8 23.1-27.1 31.2l49.3 49.3c6.9 6.9 12.3 15.1 15.9 24.2L511.4 501c1.6 4.1-.4 8.8-4.5 10.4s-8.8-.4-10.4-4.5l-27.1-67.8c-2.8-7-7-13.4-12.4-18.8L404.7 368c-11.2 5.1-23.6 8-36.7 8c-16.7 0-32.4-4.7-45.7-12.8l-13.2 22.1L238.9 508c-2.2 3.8-7.1 5.2-10.9 3s-5.2-7.1-3-10.9l70.2-122.8s0 0 0 0l.1-.1 14.1-23.5c-10.5-9.4-18.7-21.2-23.7-34.5c-10.1 21.8-27.1 39.8-48.1 51.3L158.9 508c-2.2 3.8-7.1 5.2-10.9 3s-5.2-7.1-3-10.9l68.6-120c-9.4 2.6-19.4 4-29.6 4l-34.2 0L78.9 508c-2.2 3.8-7.1 5.2-10.9 3s-5.2-7.1-3-10.9l66.3-116-48.7 0C37 384 0 347 0 301.3C0 214.4 70.4 144 157.3 144l18.7 0c58.3 0 106.9 41.6 117.7 96.7c15.6-24.5 43-40.7 74.3-40.7c5.3 0 10.4 .5 15.4 1.3C373.6 185.9 368 167.6 368 148c0-55.2 44.8-100 100-100l.9 0c.3-.4 .6-.8 1-1.2L505 11.7zM384 148c0 46.4 37.6 84 84 84l70.7 0c29.5 0 53.3-23.9 53.3-53.3C592 115.3 540.7 64 477.3 64L468 64c-46.4 0-84 37.6-84 84zm112-20a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM368 216a72 72 0 1 0 0 144 72 72 0 1 0 0-144zM16 301.3C16 338.2 45.8 368 82.7 368L184 368c53 0 96-43 96-96l0-8c0-57.4-46.6-104-104-104l-18.7 0C79.3 160 16 223.3 16 301.3z'
      
    ]
  };

  

  
  

  var faLineColumns = {
    prefix: 'fat',
    iconName: 'line-columns',
    icon: [
      512,
      512,
      [],
      'f870',
      
      'M8 56c-4.4 0-8 3.6-8 8s3.6 8 8 8H216c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zM8 184c-4.4 0-8 3.6-8 8s3.6 8 8 8H216c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zM0 320c0 4.4 3.6 8 8 8H216c4.4 0 8-3.6 8-8s-3.6-8-8-8H8c-4.4 0-8 3.6-8 8zM8 440c-4.4 0-8 3.6-8 8s3.6 8 8 8H216c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zM288 192c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H296c-4.4 0-8 3.6-8 8zm8-136c-4.4 0-8 3.6-8 8s3.6 8 8 8H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H296zm-8 264c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H296c-4.4 0-8 3.6-8 8zm8 120c-4.4 0-8 3.6-8 8s3.6 8 8 8H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H296z'
      
    ]
  };

  

  
  

  var faCardSpade = {
    prefix: 'fat',
    iconName: 'card-spade',
    icon: [
      384,
      512,
      [],
      'e3ec',
      
      'M64 16C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48H320c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm186.3 62.5c3.1-3.1 8.2-3.1 11.3 0l39.6 39.6L297 225.9c25 25 25 65.5 0 90.5s-65.5 25-90.5 0l-6.5-6.5V366h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H160c-4.4 0-8-3.6-8-8s3.6-8 8-8h24V309.9l-6.5 6.5c-25 25-65.5 25-90.5 0s-25-65.5 0-90.5l59.7-59.7 39.6-39.6zM192 301.9l-.1 .1h.2l-.1-.1zm0-158.4l-33.9 33.9L98.3 237.2c-18.7 18.7-18.7 49.1 0 67.9s49.1 18.7 67.9 0l20.1-20.1c3.1-3.1 8.2-3.1 11.3 0l20.1 20.1c18.7 18.7 49.1 18.7 67.9 0s18.7-49.1 0-67.9l-59.7-59.7L192 143.5z'
      
    ]
  };

  

  
  

  var faSpade = {
    prefix: 'fat',
    iconName: 'spade',
    icon: [
      512,
      512,
      [9824],
      'f2f4',
      
      'M460.7 220.6l0 0L268 21c-7-6.9-17.4-6.2-22.8-.4l0 0-.3 .3L51.2 220.6l0 0C1.6 272.1 4.3 357.3 60.1 405.2l0 0 .1 .1c46.6 40.6 119.9 33.7 164.8-12l19.9-20.9c3.1-3.2 7.3-5 11.8-5s8.7 2 11.7 5.3l18.8 20.7c44.7 45.4 117 52.6 165.7 11.8c54.8-47.9 57.5-133.1 7.9-184.5zM233.5 9.7c12-13 33-13 45.9 0L472.2 209.5c55.9 57.9 52.9 153.8-9 207.8c-55.9 47-137.8 38-187.8-13l-8.2-9.1-3.2-3.5V496h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-4.4 0-8-3.6-8-8s3.6-8 8-8h80V392.2l-2.6 2.7-8.9 9.4c-49.9 51-132.8 59.9-186.8 13c-62.9-53.9-65.9-149.8-10-207.8L233.5 9.7z'
      
    ]
  };

  

  
  

  var faArrowTurnDown = {
    prefix: 'fat',
    iconName: 'arrow-turn-down',
    icon: [
      384,
      512,
      ["level-down"],
      'f149',
      
      'M8 16c-4.4 0-8-3.6-8-8S3.6 0 8 0L128 0c39.8 0 72 32.2 72 72l0 412.7L338.3 346.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-152 152c-3.1 3.1-8.2 3.1-11.3 0l-152-152c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L184 484.7 184 72c0-30.9-25.1-56-56-56L8 16z'
      
    ]
  };

  
    var faLevelDown = faArrowTurnDown;
  

  
  

  var faBorderRight = {
    prefix: 'fat',
    iconName: 'border-right',
    icon: [
      448,
      512,
      [],
      'f852',
      
      'M440 32c4.4 0 8 3.6 8 8l0 432c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-432c0-4.4 3.6-8 8-8zM320 80a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm0 352a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0-160a16 16 0 1 1 0-32 16 16 0 1 1 0 32zM128 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 416a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm0-224a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM224 80a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm0 352a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0-160a16 16 0 1 1 0-32 16 16 0 1 1 0 32zM32 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 416a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm0-224a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm192-64a16 16 0 1 1 0-32 16 16 0 1 1 0 32zM32 144a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 224a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm192-32a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faKnifeKitchen = {
    prefix: 'fat',
    iconName: 'knife-kitchen',
    icon: [
      576,
      512,
      [128298],
      'f6f5',
      
      'M479.8 19.6L313 186.3c-3.1 3.1-3.1 8.2 0 11.3l85 85c2.3 2.3 5.8 3 8.8 1.7L433.5 273c8.8-3.8 14.5-12.5 14.5-22.1V220.6c0-10.1 3.8-19.9 10.8-27.3L557 88c1.9-2 3-4.7 3-7.5c0-3.1-1.3-6.1-3.7-8.2L496.4 19.1c-2.2-2-5.1-3.1-8.1-3.1c-3.2 0-6.3 1.3-8.6 3.6zM488.3 0c6.9 0 13.5 2.5 18.7 7.1l59.9 53.3c5.8 5.1 9.1 12.5 9.1 20.2c0 6.8-2.6 13.4-7.3 18.4L470.5 204.2c-4.1 4.4-6.5 10.3-6.5 16.4v30.3c0 16-9.5 30.5-24.2 36.8l-26.6 11.4c-9 3.9-19.5 1.9-26.4-5.1l-85-85c-9.4-9.4-9.4-24.6 0-33.9L468.4 8.2C473.7 3 480.9 0 488.3 0zM4.7 468.7L242.7 230.6l11.3 11.3L16.1 479.9c0 .1 .1 .2 .1 .2C47.1 490.1 80.1 496 112 496c105.7 0 175.4-42.9 244.2-107.5c6-5.7 6.3-15.6 0-21.9l-9.4-9.4c-6.2-6.2-6.2-16.4 0-22.6l21.7 21.7c11.5 12.6 11.3 32.2-1.3 43.9C296.6 466.3 223.2 512 112 512c-33.9 0-68.6-6.3-100.8-16.8C0 491.5-3.7 477.1 4.7 468.7zM416 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faUpFromBracket = {
    prefix: 'fat',
    iconName: 'up-from-bracket',
    icon: [
      448,
      512,
      [],
      'e590',
      
      'M216 19.3c2.1-2.1 5-3.3 8-3.3s5.9 1.2 8 3.3L363.8 151.4c2.7 2.7 4.2 6.4 4.2 10.2c0 8-6.5 14.4-14.4 14.4L280 176c-4.4 0-8 3.6-8 8l0 136c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-136c0-4.4-3.6-8-8-8l-73.6 0c-8 0-14.4-6.5-14.4-14.4c0-3.8 1.5-7.5 4.2-10.2L216 19.3zM224 0c-7.2 0-14.2 2.9-19.3 8L72.9 140.1c-5.7 5.7-8.9 13.4-8.9 21.5C64 178.4 77.6 192 94.4 192l65.6 0 0 128c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-128 65.6 0c16.8 0 30.4-13.6 30.4-30.4c0-8.1-3.2-15.8-8.9-21.5L243.3 8c-5.1-5.1-12.1-8-19.3-8zM16 328c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 96c0 48.6 39.4 88 88 88l272 0c48.6 0 88-39.4 88-88l0-96c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 96c0 39.8-32.2 72-72 72L88 496c-39.8 0-72-32.2-72-72l0-96z'
      
    ]
  };

  

  
  

  var faMercury = {
    prefix: 'fat',
    iconName: 'mercury',
    icon: [
      384,
      512,
      [9791],
      'f223',
      
      'M83.5 2.4C80.4-.8 75.3-.8 72.1 2.3S68.9 10.4 72 13.6c18.7 19.1 42 33.7 68 42.2C68.2 78 16 144.9 16 224c0 94.5 74.5 171.6 168 175.8V448H128c-4.4 0-8 3.6-8 8s3.6 8 8 8h56v40c0 4.4 3.6 8 8 8s8-3.6 8-8V464h56c4.4 0 8-3.6 8-8s-3.6-8-8-8H200V399.8c93.5-4.2 168-81.3 168-175.8c0-79.1-52.2-146-124-168.2c26-8.5 49.3-23.1 68-42.2c3.1-3.2 3-8.2-.1-11.3s-8.2-3-11.3 .1C273 30.5 234.5 48 192 48S111 30.5 83.5 2.4zM192 64a160 160 0 1 1 0 320 160 160 0 1 1 0-320z'
      
    ]
  };

  

  
  

  var faTransgender = {
    prefix: 'fat',
    iconName: 'transgender',
    icon: [
      512,
      512,
      [9895,"transgender-alt"],
      'f225',
      
      'M136 16c4.4 0 8-3.6 8-8s-3.6-8-8-8H24c-4.4 0-8 3.6-8 8V120c0 4.4 3.6 8 8 8s8-3.6 8-8V27.3L92.7 88 74.3 106.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L104 99.3l26 26c-21.3 27.2-34 61.4-34 98.7c0 85.7 67.4 155.6 152 159.8V432H200c-4.4 0-8 3.6-8 8s3.6 8 8 8h48v56c0 4.4 3.6 8 8 8s8-3.6 8-8V448h48c4.4 0 8-3.6 8-8s-3.6-8-8-8H264V383.8c84.6-4.2 152-74.1 152-159.8c0-37.2-12.7-71.5-34-98.7l98-98V120c0 4.4 3.6 8 8 8s8-3.6 8-8V8c0-4.4-3.6-8-8-8H376c-4.4 0-8 3.6-8 8s3.6 8 8 8h92.7l-97.2 97.2C342.3 82.9 301.4 64 256 64s-86.3 18.9-115.5 49.2L115.3 88l18.3-18.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L104 76.7 43.3 16H136zM256 80a144 144 0 1 1 0 288 144 144 0 1 1 0-288z'
      
    ]
  };

  
    var faTransgenderAlt = faTransgender;
  

  
  

  var faSimCard = {
    prefix: 'fat',
    iconName: 'sim-card',
    icon: [
      384,
      512,
      [],
      'f7c4',
      
      'M16 64V448c0 26.5 21.5 48 48 48H320c26.5 0 48-21.5 48-48V154.5c0-12.7-5.1-24.9-14.1-33.9L263.4 30.1c-9-9-21.2-14.1-33.9-14.1H64C37.5 16 16 37.5 16 64zM0 448V64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zM80 288v64h72 80 72V288H232 152 80zM272 432c17.7 0 32-14.3 32-32V368H240v64h32zM112 208c-17.7 0-32 14.3-32 32v32h64V208H112zm112 64V208H160v64h64zm0 160V368H160v64h64zM80 400c0 17.7 14.3 32 32 32h32V368H80v32zM240 272h64V240c0-17.7-14.3-32-32-32H240v64zM64 400V240c0-26.5 21.5-48 48-48h32 8 8 64 8 8 32c26.5 0 48 21.5 48 48V400c0 26.5-21.5 48-48 48H240h-8-8H160h-8-8H112c-26.5 0-48-21.5-48-48z'
      
    ]
  };

  

  
  

  var faDiceFour = {
    prefix: 'fat',
    iconName: 'dice-four',
    icon: [
      448,
      512,
      [9859],
      'f524',
      
      'M384 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM112 352a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 144a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM304 352a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faMandolin = {
    prefix: 'fat',
    iconName: 'mandolin',
    icon: [
      512,
      512,
      [],
      'f6f9',
      
      'M447.1 16c-2.9 0-5.7 .9-8 2.7L386.5 58.1c-1.8 1.4-3 3.4-3.2 5.7l-6.5 71.4 71.4-6.5c2.3-.2 4.3-1.4 5.7-3.2l39.4-52.6c1.7-2.3 2.7-5.1 2.7-8c0-3.6-1.4-7-3.9-9.5L456.6 19.9c-2.5-2.5-5.9-3.9-9.5-3.9zM360.3 140.4l7.1-78c.6-6.8 4.1-13 9.5-17L429.5 5.9C434.6 2.1 440.8 0 447.1 0c7.8 0 15.3 3.1 20.8 8.6l35.5 35.5c5.5 5.5 8.6 13 8.6 20.8c0 6.4-2.1 12.6-5.9 17.6l-39.4 52.6c-4.1 5.4-10.3 8.9-17 9.5l-78 7.1-50.8 50.8C324.5 257.7 332.9 512 176 512C78.8 512 0 433.2 0 336C0 179.1 254.3 187.5 309.5 191.2l50.8-50.8zm-129 129l63.1-63.1c-7-.3-15.2-.5-24.4-.6c-29.4-.2-68.4 1.2-107.1 8c-39 6.8-76.2 18.8-103.4 38.4C33 271.4 16 297.8 16 336c0 88.4 71.6 160 160 160c38.2 0 64.6-17 83.8-43.4c19.7-27.2 31.6-64.4 38.4-103.4c6.8-38.7 8.3-77.7 8-107.1c-.1-9.2-.3-17.5-.6-24.4l-63.1 63.1C251 291.6 256 305.2 256 320c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c14.8 0 28.4 5 39.2 13.4zM240 320a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  

  
  

  var faMeter = {
    prefix: 'fat',
    iconName: 'meter',
    icon: [
      512,
      512,
      [],
      'e1e8',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176-96c0-8.8-7.2-16-16-16s-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V160zm-48 0c0-17.7 14.3-32 32-32s32 14.3 32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160zm144 32V160c0-8.8-7.2-16-16-16s-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16zm-16-64c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32zm112 32c0-8.8-7.2-16-16-16s-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V160zm-48 0c0-17.7 14.3-32 32-32s32 14.3 32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160z'
      
    ]
  };

  

  
  

  var faFaceGrinHearts = {
    prefix: 'fat',
    iconName: 'face-grin-hearts',
    icon: [
      512,
      512,
      [128525,"grin-hearts"],
      'f584',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256.3 91.8c-43 0-84.1-5.5-121.5-15.4c-3.9-1-7.1 .3-8.7 1.8c-.7 .7-.9 1.2-.9 1.4l0 0c0 .1-.1 .7 .5 1.9c25 46.8 74.1 78.5 130.5 78.5s105.5-31.7 130.5-78.5c.7-1.2 .6-1.8 .5-1.9l0 0c0-.2-.2-.7-.9-1.4c-1.6-1.5-4.8-2.8-8.7-1.8c-37.4 9.9-78.4 15.4-121.5 15.4zm144.6-2.7C373.2 396.8 318.8 432 256.3 432s-116.9-35.2-144.6-86.9c-9.1-17 8.7-33.1 27.3-28.2c36 9.6 75.6 14.9 117.3 14.9s81.4-5.3 117.3-14.9c18.6-4.9 36.4 11.2 27.3 28.2zM197.2 136.9c-13.5-3.6-27.4 4.4-31.1 17.9l-4.3 16.1c-1.1 4.3-5.5 6.8-9.8 5.7l-16.1-4.3c-13.5-3.6-27.4 4.4-31.1 17.9s4.4 27.4 17.9 31.1l65.1 17.4c4.3 1.1 8.7-1.4 9.8-5.7l17.4-65c3.6-13.5-4.4-27.4-17.9-31.1zm-46.5 13.8c5.9-22.1 28.6-35.2 50.6-29.2s35.2 28.6 29.2 50.6l-17.4 65c-3.4 12.8-16.6 20.4-29.4 17l-65.1-17.4C96.6 230.7 83.5 208 89.4 186s28.6-35.2 50.6-29.2l8.4 2.2 2.2-8.3zm210.6 0l2.2 8.3 8.4-2.2c22.1-5.9 44.7 7.2 50.6 29.2s-7.2 44.7-29.2 50.6l-65.1 17.4c-12.8 3.4-26-4.2-29.4-17l-17.4-65c-5.9-22.1 7.2-44.7 29.2-50.6s44.7 7.2 50.6 29.2zm-46.5-13.8c-13.5 3.6-21.6 17.5-17.9 31.1l17.4 65c1.1 4.3 5.5 6.8 9.8 5.7l65.1-17.4c13.5-3.6 21.6-17.5 17.9-31.1s-17.5-21.6-31.1-17.9L360 176.5c-4.3 1.1-8.7-1.4-9.8-5.7l-4.3-16.1c-3.6-13.5-17.5-21.6-31.1-17.9z'
      
    ]
  };

  
    var faGrinHearts = faFaceGrinHearts;
  

  
  

  var faSplotch = {
    prefix: 'fat',
    iconName: 'splotch',
    icon: [
      512,
      512,
      [],
      'f5bc',
      
      'M190.6 432.1L87.8 441.4c-30 2.7-55.8-20.9-55.8-51c0-11.1 3.6-21.9 10.2-30.7l18.8-25c12.4-16.5 18.9-36.7 18.4-57.3c-.4-17.2-5.6-33.9-15-48.2L23.9 167.2c-5.1-7.8-7.9-17-7.9-26.4c0-30 27.2-52.7 56.8-47.4l42.8 7.8c41.3 7.5 83.4-7.8 110.3-40l22.3-26.8C257.9 22.8 272.3 16 287.5 16c22.1 0 41.7 14.1 48.6 35.1l15 45.1c12.7 38 41.8 68.3 79.4 82.4l32.3 12.1c19.9 7.5 33.1 26.5 33.1 47.8c0 16.1-7.6 31.2-20.4 40.8l-62 46.5c-28.8 21.6-44.1 56.9-40.1 92.7l2.5 22.7c3.3 29.3-19.7 54.8-49.1 54.8c-11.2 0-22.1-3.8-30.9-10.8L259 455.5c-19-15.2-42.6-23.5-67-23.5c-.5 0-1 0-1.4 .1zM51 237.8c7.8 11.9 12.1 25.7 12.4 39.8c.4 17-4.9 33.7-15.2 47.4l-18.8 25C20.7 361.7 16 375.9 16 390.4c0 39.5 33.9 70.5 73.3 66.9L192 448c20.7 0 40.8 7 57 20l37.1 29.7c11.6 9.3 26 14.3 40.8 14.3c39 0 69.3-33.9 65-72.6l-2.5-22.7c-3.4-30.2 9.5-59.9 33.8-78.1l62-46.5c16.9-12.7 26.8-32.5 26.8-53.6c0-28-17.3-53-43.5-62.8l-32.3-12.1c-33-12.4-58.7-39-69.8-72.4L351.3 46c-9.2-27.5-34.9-46-63.8-46c-20 0-38.9 8.9-51.7 24.2L213.5 51C190.3 78.8 154 92 118.4 85.5L75.6 77.7C36.2 70.6 0 100.8 0 140.9c0 12.5 3.6 24.7 10.5 35.1L51 237.8z'
      
    ]
  };

  

  
  

  var faSquareN = {
    prefix: 'fat',
    iconName: 'square-n',
    icon: [
      448,
      512,
      [],
      'e277',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm126 34.8L320 354.6V136c0-4.4 3.6-8 8-8s8 3.6 8 8V376c0 3.3-2.1 6.3-5.2 7.5s-6.7 .3-8.8-2.3L128 157.4V376c0 4.4-3.6 8-8 8s-8-3.6-8-8V136c0-3.3 2.1-6.3 5.2-7.5s6.7-.3 8.8 2.3z'
      
    ]
  };

  

  
  

  var faArrowUpRightDots = {
    prefix: 'fat',
    iconName: 'arrow-up-right-dots',
    icon: [
      576,
      512,
      [],
      'e4b7',
      
      'M144 8c0 4.4 3.6 8 8 8H292.7L18.3 290.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L304 27.3V168c0 4.4 3.6 8 8 8s8-3.6 8-8V8c0-4.4-3.6-8-8-8H152c-4.4 0-8 3.6-8 8zM528 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM400 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-32 80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-48 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm128-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM240 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-48 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM112 464a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM528 304a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM496 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  

  
  

  var faSquareFragile = {
    prefix: 'fat',
    iconName: 'square-fragile',
    icon: [
      448,
      512,
      ["box-fragile","square-wine-glass-crack"],
      'f49b',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm305.1 16H219.3l34.3 34.3c1.7 1.7 2.5 4.1 2.3 6.4s-1.5 4.5-3.5 5.9l-39.1 26.1 39.8 33.1c3.4 2.8 3.9 7.9 1 11.3s-7.9 3.9-11.3 1l-48-40c-1.9-1.6-3-4.1-2.9-6.6s1.5-4.8 3.6-6.2l39.9-26.6L196.7 112H142.9c-8.2 0-14.9 6.7-14.9 14.9V208c0 53 43 96 96 96s96-43 96-96V126.9c0-8.2-6.7-14.9-14.9-14.9zM142.9 96H305.1c17.1 0 30.9 13.8 30.9 30.9V208c0 59.2-45.9 107.6-104 111.7V400h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-4.4 0-8-3.6-8-8s3.6-8 8-8h48V319.7c-58.1-4.1-104-52.6-104-111.7V126.9c0-17.1 13.8-30.9 30.9-30.9z'
      
    ]
  };

  
    var faBoxFragile = faSquareFragile;
  
    var faSquareWineGlassCrack = faSquareFragile;
  

  
  

  var faLockKeyholeOpen = {
    prefix: 'fat',
    iconName: 'lock-keyhole-open',
    icon: [
      576,
      512,
      ["lock-open-alt"],
      'f3c2',
      
      'M448 16c-61.9 0-112 50.1-112 112v64h48c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H320V128C320 57.3 377.3 0 448 0s128 57.3 128 128v88c0 4.4-3.6 8-8 8s-8-3.6-8-8V128c0-61.9-50.1-112-112-112zM64 208c-26.5 0-48 21.5-48 48V448c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V256c0-26.5-21.5-48-48-48H336 320 64zM256 368c8.8 0 16-7.2 16-16s-7.2-16-16-16H192c-8.8 0-16 7.2-16 16s7.2 16 16 16h64zm0-48c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32h64z'
      
    ]
  };

  
    var faLockOpenAlt = faLockKeyholeOpen;
  

  
  

  var faConveyorBeltArm = {
    prefix: 'fat',
    iconName: 'conveyor-belt-arm',
    icon: [
      640,
      512,
      [],
      'e5f8',
      
      'M128 8c0 4.4 3.6 8 8 8h94.7l-7.4 48c-26.2 .4-47.3 21.7-47.3 48c0 26.5 21.5 48 48 48c21.6 0 39.8-14.2 45.9-33.8L456 151v57c0 4.4 3.6 8 8 8s8-3.6 8-8V144c0-4-3-7.4-6.9-7.9L272 110.3c-.7-20.5-14.3-37.7-32.9-43.9L246.9 16H344c4.4 0 8-3.6 8-8s-3.6-8-8-8H136c-4.4 0-8 3.6-8 8zm64 104a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM496 280v40H432V280c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8zm-80 0v40H352V280c0-13.3-10.7-24-24-24H280c-13.3 0-24 10.7-24 24v40H192V280c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24l0 40c-53 0-96 43-96 96s43 96 96 96H544c53 0 96-43 96-96s-43-96-96-96H512V280c0-13.3-10.7-24-24-24H440c-13.3 0-24 10.7-24 24zM176 336h16 64 16 64 16 64 16 64 16 32c44.2 0 80 35.8 80 80s-35.8 80-80 80H96c-44.2 0-80-35.8-80-80s35.8-80 80-80h16 64zm0-56v40H112V280c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8zm96 40V280c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v40H272zM80 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm176-48a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  

  
  

  var faWarehouse = {
    prefix: 'fat',
    iconName: 'warehouse',
    icon: [
      640,
      512,
      [],
      'f494',
      
      'M329.1 20.4c-5.8-2.4-12.4-2.4-18.2 0L40.8 131.2c-15 6.2-24.8 20.8-24.8 37V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V168.2c0-22.7 13.7-43.2 34.7-51.8L304.8 5.6c9.7-4 20.6-4 30.4 0L605.3 116.4c21 8.6 34.7 29.1 34.7 51.8V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V168.2c0-16.2-9.8-30.8-24.8-37L329.1 20.4zM120 208c-4.4 0-8 3.6-8 8v72H528V216c0-4.4-3.6-8-8-8H120zm408 96H112v96H528V304zm0 192V416H112v80H528zm8 16v0H104v0c-4.4 0-8-3.6-8-8V216c0-13.3 10.7-24 24-24H520c13.3 0 24 10.7 24 24V504c0 4.4-3.6 8-8 8z'
      
    ]
  };

  

  
  

  var faSunBright = {
    prefix: 'fat',
    iconName: 'sun-bright',
    icon: [
      512,
      512,
      ["sun-alt"],
      'e28f',
      
      'M256 0c4.4 0 8 3.6 8 8v96c0 4.4-3.6 8-8 8s-8-3.6-8-8V8c0-4.4 3.6-8 8-8zM0 256c0-4.4 3.6-8 8-8h96c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8zm400 0c0-4.4 3.6-8 8-8h96c4.4 0 8 3.6 8 8s-3.6 8-8 8H408c-4.4 0-8-3.6-8-8zM256 400c4.4 0 8 3.6 8 8v96c0 4.4-3.6 8-8 8s-8-3.6-8-8V408c0-4.4 3.6-8 8-8zM75 75c3.1-3.1 8.2-3.1 11.3 0l67.9 67.9c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L75 86.3c-3.1-3.1-3.1-8.2 0-11.3zm0 362c-3.1-3.1-3.1-8.2 0-11.3l67.9-67.9c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L86.3 437c-3.1 3.1-8.2 3.1-11.3 0zM357.8 154.2c-3.1-3.1-3.1-8.2 0-11.3L425.7 75c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-67.9 67.9c-3.1 3.1-8.2 3.1-11.3 0zm0 203.6c3.1-3.1 8.2-3.1 11.3 0L437 425.7c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-67.9-67.9c-3.1-3.1-3.1-8.2 0-11.3zM360 256a104 104 0 1 0 -208 0 104 104 0 1 0 208 0zm-224 0a120 120 0 1 1 240 0 120 120 0 1 1 -240 0z'
      
    ]
  };

  
    var faSunAlt = faSunBright;
  

  
  

  var faGears = {
    prefix: 'fat',
    iconName: 'gears',
    icon: [
      640,
      512,
      ["cogs"],
      'f085',
      
      'M156.6 8V8h7.1 .2l0 0c6.2 .1 12.3 .6 18.4 1.4c6.5 .9 11.5 5.6 13.1 11.7l9.1 34.8c13.7 5.1 26.3 12.4 37.3 21.5l34.7-9.5c6-1.7 12.7 .3 16.7 5.5c3.7 4.8 7.2 9.9 10.4 15.1l.1 .2 0 0 3.7 6.4 .1 .2 0 0c2.9 5.4 5.6 11 8 16.8c2.5 6.1 .9 12.8-3.6 17.2l-25.6 25.3c1.2 7 1.8 14.2 1.8 21.5s-.6 14.5-1.8 21.5l25.6 25.2c4.5 4.4 6.1 11.2 3.6 17.2c-2.7 6.6-5.8 12.9-9.3 19.1l0 0-1 1.8 0 0c-3.6 6.1-7.5 12-11.9 17.6c-4 5.2-10.7 7.2-16.7 5.5l-34.7-9.5c-11 9.1-23.6 16.5-37.3 21.5l-9.1 34.8c-1.6 6-6.6 10.8-13.1 11.7c-6.2 .8-12.5 1.3-18.6 1.5l-.2 0v0h-7.1-.2l0 0c-6.2-.1-12.4-.6-18.4-1.4c-6.5-.9-11.5-5.6-13.1-11.7l-9.1-34.8c-13.7-5.1-26.3-12.4-37.3-21.5l-34.7 9.5c-6 1.7-12.7-.3-16.7-5.5c-3.8-4.9-7.3-10-10.5-15.4l-.1-.1 0 0-3.4-5.9-.1-.1 0 0c-3-5.5-5.7-11.1-8.1-17c-2.5-6.1-.9-12.8 3.6-17.2l5.6 5.7-5.6-5.7 25.6-25.3c-1.2-7-1.8-14.2-1.8-21.5s.6-14.5 1.8-21.5L8.2 129.2c-4.5-4.4-6.1-11.2-3.6-17.2c5.7-13.8 13.2-26.7 22.3-38.5c4-5.2 10.7-7.2 16.7-5.5l34.7 9.5c11-9.1 23.6-16.5 37.3-21.5l9.1-34.8c1.6-6 6.6-10.8 13.1-11.7c6.2-.8 12.5-1.3 18.7-1.5l.2 0zm.1 16c-5.5 .1-11 .6-16.6 1.3L129.9 64.1c-.7 2.6-2.7 4.7-5.2 5.6c-14.6 4.8-27.9 12.6-39.1 22.6c-2 1.8-4.8 2.5-7.4 1.7L39.5 83.4C31.3 94 24.6 105.6 19.5 117.9l28.5 28.2c1.9 1.9 2.8 4.6 2.2 7.3C48.8 160.7 48 168.2 48 176s.8 15.3 2.3 22.6c.5 2.7-.3 5.4-2.2 7.3L19.5 234.1c2.1 5.2 4.6 10.3 7.2 15.1l3.3 5.8c2.9 4.7 6 9.3 9.3 13.6L78.1 258c2.6-.7 5.4-.1 7.4 1.7c11.3 10 24.5 17.8 39.1 22.6c2.6 .9 4.5 3 5.2 5.6l10.1 38.8c5.4 .7 10.9 1.1 16.4 1.3h6.9c5.5-.1 11-.6 16.6-1.3L190 287.9c.7-2.6 2.7-4.7 5.2-5.6c14.6-4.8 27.9-12.6 39.2-22.6c2-1.8 4.8-2.5 7.4-1.7l38.7 10.6c3.9-5 7.4-10.3 10.6-15.7l0 0 1-1.7 0 0c3.1-5.5 5.9-11.2 8.3-17l-28.5-28.2c-1.9-1.9-2.8-4.6-2.2-7.3c1.5-7.3 2.3-14.9 2.3-22.6s-.8-15.3-2.3-22.6c-.5-2.7 .3-5.4 2.2-7.3l28.5-28.2c-2.1-5.1-4.5-10.1-7.1-14.9l-3.6-6.2c-2.8-4.7-5.9-9.1-9.2-13.4L241.9 94c-2.6 .7-5.4 .1-7.4-1.7c-11.3-10-24.5-17.8-39.1-22.6c-2.6-.9-4.5-3-5.2-5.6L179.9 25.3c-5.4-.7-10.9-1.1-16.3-1.3h-6.9zM104 176a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm56 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM296 355.4h0v-7.1-.2l0 0c.1-6.2 .6-12.4 1.4-18.4c.9-6.5 5.6-11.5 11.7-13.1l34.8-9.1c5.1-13.7 12.4-26.3 21.5-37.3l-9.5-34.7c-1.7-6 .3-12.7 5.5-16.7c4.8-3.7 9.9-7.2 15.1-10.4l.2-.1 0 0 6.4-3.7 .2-.1 0 0c5.4-2.9 11-5.6 16.8-8c6.1-2.5 12.8-.9 17.2 3.6l25.3 25.6c7-1.2 14.2-1.8 21.5-1.8s14.5 .6 21.5 1.8l25.3-25.6c4.4-4.5 11.2-6.1 17.2-3.6c6.6 2.7 12.9 5.8 19.1 9.3l0 0 1.8 1 0 0c6.1 3.6 12 7.5 17.6 11.9c5.2 4 7.2 10.7 5.5 16.7l-9.5 34.7c9.1 11 16.5 23.6 21.5 37.3l34.8 9.1c6 1.6 10.8 6.6 11.7 13.1c.8 6.2 1.3 12.5 1.5 18.6l0 .2h0v7.1 .2l0 0c-.1 6.2-.6 12.4-1.4 18.4c-.9 6.5-5.6 11.5-11.7 13.1l-34.8 9.1c-5.1 13.7-12.4 26.3-21.5 37.3l9.5 34.7c1.7 6-.3 12.7-5.5 16.7c-4.9 3.8-10 7.3-15.4 10.5l-.1 .1 0 0-5.9 3.4-.2 .1 0 0c-5.5 3-11.1 5.7-17 8.1c-6.1 2.5-12.8 .9-17.2-3.6l-25.3-25.6c-7 1.2-14.2 1.8-21.5 1.8s-14.5-.6-21.5-1.8l-25.3 25.6c-4.4 4.5-11.2 6.1-17.2 3.6c-13.8-5.7-26.7-13.2-38.5-22.3c-5.2-4-7.2-10.7-5.5-16.7l9.5-34.7c-9.1-11-16.5-23.6-21.5-37.3l-34.8-9.1c-6-1.6-10.8-6.6-11.7-13.1c-.8-6.2-1.3-12.5-1.5-18.7l0-.2zm16-.1c.1 5.5 .6 11 1.3 16.6l38.8 10.1c2.6 .7 4.7 2.6 5.6 5.2c4.8 14.6 12.6 27.9 22.6 39.1c1.8 2 2.5 4.8 1.7 7.4l-10.6 38.7c10.6 8.1 22.2 14.8 34.5 19.9l28.2-28.5c1.9-1.9 4.6-2.8 7.3-2.2c7.3 1.5 14.9 2.3 22.6 2.3s15.3-.8 22.6-2.3c2.7-.5 5.4 .3 7.3 2.2l28.2 28.5c5.2-2.1 10.3-4.6 15.1-7.2l5.8-3.3c4.7-2.9 9.3-6 13.6-9.3L546 433.9c-.7-2.6-.1-5.4 1.7-7.4c10-11.3 17.8-24.5 22.6-39.1c.9-2.6 3-4.5 5.6-5.2l38.8-10.1c.7-5.4 1.1-10.9 1.3-16.4v-6.9c-.1-5.5-.6-11-1.3-16.6L575.9 322c-2.6-.7-4.7-2.7-5.6-5.2c-4.8-14.6-12.6-27.9-22.6-39.2c-1.8-2-2.5-4.8-1.7-7.4l10.6-38.7c-5-3.9-10.3-7.4-15.7-10.6l0 0-1.7-1 0 0c-5.5-3.1-11.2-5.9-17-8.3l-28.2 28.5c-1.9 1.9-4.6 2.8-7.3 2.2c-7.3-1.5-14.9-2.3-22.6-2.3s-15.3 .8-22.6 2.3c-2.7 .5-5.4-.3-7.3-2.2l-28.2-28.5c-5.1 2.1-10.1 4.5-14.9 7.1l-6.2 3.6c-4.7 2.8-9.1 5.9-13.4 9.2L382 270.1c.7 2.6 .1 5.4-1.7 7.4c-10 11.3-17.8 24.5-22.6 39.1c-.9 2.6-3 4.5-5.6 5.2l-38.8 10.1c-.7 5.4-1.1 10.8-1.3 16.3v6.9zM464 408a56 56 0 1 1 0-112 56 56 0 1 1 0 112zm40-56a40 40 0 1 0 -80 0 40 40 0 1 0 80 0z'
      
    ]
  };

  
    var faCogs = faGears;
  

  
  

  var faPartyHorn = {
    prefix: 'fat',
    iconName: 'party-horn',
    icon: [
      512,
      512,
      [],
      'e31b',
      
      'M163.1 145.7c-3.5 2.7-4.1 7.7-1.4 11.2s7.7 4.1 11.2 1.4l6.2-4.8c43.7-34 71.4-84.6 76.4-139.8l.5-5c.4-4.4-2.8-8.3-7.2-8.7s-8.3 2.8-8.7 7.2l-.5 5C235 63 209.5 109.6 169.3 140.9l-6.2 4.8zM48 32a16 16 0 1 1 32 0A16 16 0 1 1 48 32zm48 0A32 32 0 1 0 32 32a32 32 0 1 0 64 0zM17 474.4l34.4-91.7 77.9 77.9L37.7 495c-12.4 4.6-25.3-8.3-20.6-20.6zm128.7-19.9L57.6 366.3l28.7-76.6L222.4 425.7l-76.6 28.7zM93.7 274.3c-.4-.4-.8-.7-1.2-1l20.7-55.1c3.9-10.5 18.4-13.7 26.3-5.7L299.5 372.6c8 8 4.8 22.4-5.7 26.3l-55.2 20.7c-.3-.4-.6-.9-1-1.3l-144-144zm57.1-73.2c-16.2-16.2-44.6-10-52.6 11.4L2 468.8C-7.4 494 18 519.4 43.3 510l256.2-96.1c21.4-8 27.6-36.4 11.4-52.6L150.7 201.2zM480 144a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM464 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM355.1 350.3c3.5 2.7 8.5 2.1 11.2-1.4l21.9-28.1c20.4-26.2 50.8-42.8 83.9-45.8l32.7-3c4.4-.4 7.6-4.3 7.2-8.7s-4.3-7.6-8.7-7.2l-32.7 3c-37.5 3.4-71.9 22.2-95 51.9l-21.9 28.1c-2.7 3.5-2.1 8.5 1.4 11.2zM509.3 14c3.3-2.9 3.6-8 .7-11.3s-8-3.6-11.3-.7L481.9 16.8c-9.5 8.4-21.9 12.9-34.6 12.5c-33.2-.9-62 23-67.2 55.9l-6.9 43.9c-4.7 30.1-29.6 52.9-59.9 55.1c-17.2 1.3-33.5 7.9-46.7 19.1l-7.7 6.6c-3.4 2.9-3.8 7.9-.9 11.3s7.9 3.8 11.3 .9l7.7-6.6c10.6-8.9 23.7-14.3 37.5-15.3c37.8-2.8 68.6-31.2 74.6-68.6l6.9-43.9c3.9-24.9 25.7-43 51-42.4c16.7 .5 33-5.5 45.6-16.5L509.3 14z'
      
    ]
  };

  

  
  

  var faPeace = {
    prefix: 'fat',
    iconName: 'peace',
    icon: [
      512,
      512,
      [9774],
      'f67c',
      
      'M248 495.9V273.1L76.8 415.7C119.2 463.1 180 493.6 248 495.9zM66.6 403.4L248 252.3V16.1C119.2 20.4 16 126.1 16 256c0 55.6 18.9 106.7 50.6 147.4zM256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm179.2-96.3L264 273.1V495.9c68-2.2 128.8-32.7 171.2-80.2zm10.2-12.3C477.1 362.7 496 311.6 496 256C496 126.1 392.8 20.4 264 16.1V252.3L445.4 403.4z'
      
    ]
  };

  

  
  

  var faRobot = {
    prefix: 'fat',
    iconName: 'robot',
    icon: [
      640,
      512,
      [129302],
      'f544',
      
      'M320 0c4.4 0 8 3.6 8 8V96H448c53 0 96 43 96 96V416c0 53-43 96-96 96H192c-53 0-96-43-96-96V192c0-53 43-96 96-96H312V8c0-4.4 3.6-8 8-8zM192 112c-44.2 0-80 35.8-80 80V416c0 44.2 35.8 80 80 80H448c44.2 0 80-35.8 80-80V192c0-44.2-35.8-80-80-80H320 192zm8 288h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H200c-4.4 0-8-3.6-8-8s3.6-8 8-8zm96 0h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H296c-4.4 0-8-3.6-8-8s3.6-8 8-8zm96 0h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H392c-4.4 0-8-3.6-8-8s3.6-8 8-8zM224 216a40 40 0 1 0 0 80 40 40 0 1 0 0-80zm56 40a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zm96 0a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm40 56a56 56 0 1 1 0-112 56 56 0 1 1 0 112zM48 224H64v16H48c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32H64v16H48c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48zM592 400c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32H576V224h16c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H576V400h16z'
      
    ]
  };

  

  
  

  var faWhale = {
    prefix: 'fat',
    iconName: 'whale',
    icon: [
      640,
      512,
      [128011],
      'f72c',
      
      'M174.1 100.7L160 16 119.3 56.7C104.7 71.3 98 92.1 101.4 112.5l7.9 47.4c.8 5.1-.8 10.3-4.5 13.9L54.9 223.7C30 248.6 16 282.4 16 317.6C16 398.5 81.5 464 162.4 464H544c44.2 0 80-35.8 80-80V272.1C624 201.3 566.7 144 495.9 144c-78.7 0-154.9 28.2-214.6 79.4L166.8 321.6C155.9 330.9 142 336 127.7 336h-1.1c-25.2 0-47.5-16.1-55.5-40c-5.5-16.5-3.4-34.7 5.9-49.5l37.6-60.1c3.4-5.5 9.8-8.4 16.2-7.3l44.7 7.5c20.4 3.4 41.2-3.3 55.8-17.9L272 128l-84.7-14.1c-6.7-1.1-12-6.4-13.2-13.2zm1.7-87.4l14.1 84.7 84.7 14.1c5.9 1 10.8 5.2 12.6 10.9s.3 12-3.9 16.2L242.6 180c-18.3 18.3-44.2 26.6-69.7 22.3l-44.7-7.5L90.6 255c-6.7 10.7-8.3 23.9-4.3 35.9c5.8 17.3 22 29 40.3 29h1.1c10.5 0 20.7-3.8 28.6-10.6l114.5-98.2c62.7-53.7 142.5-83.2 225-83.2C575.5 128 640 192.5 640 272.1V384c0 53-43 96-96 96H162.4C72.7 480 0 407.3 0 317.6c0-39.5 15.7-77.3 43.6-105.2l49.9-49.9-7.9-47.4C81.4 89.6 89.7 63.7 108 45.4L148.7 4.7c4.2-4.2 10.5-5.8 16.2-3.9s9.9 6.7 10.9 12.6zM400 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faArrowUpTriangleSquare = {
    prefix: 'fat',
    iconName: 'arrow-up-triangle-square',
    icon: [
      576,
      512,
      ["sort-shapes-up"],
      'f88a',
      
      'M165.7 34.3c-3.1-3.1-8.2-3.1-11.3 0l-104 104c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L152 59.3V472c0 4.4 3.6 8 8 8s8-3.6 8-8V59.3l90.3 90.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-104-104zM416 32c-9.9 0-19.1 5.2-24.2 13.7L307.6 186c-2.3 3.9-3.6 8.4-3.6 12.9c0 13.8 11.2 25.1 25.1 25.1H502.9c13.8 0 25.1-11.2 25.1-25.1c0-4.5-1.2-9-3.6-12.9L440.2 45.7C435.1 37.2 425.9 32 416 32zM336 432V336c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H368c-17.7 0-32-14.3-32-32zM321.3 194.3L405.5 54c2.2-3.7 6.2-6 10.5-6s8.3 2.3 10.5 6l84.2 140.3c.8 1.4 1.3 3 1.3 4.7c0 5-4.1 9.1-9.1 9.1H329.1c-5 0-9.1-4.1-9.1-9.1c0-1.6 .4-3.3 1.3-4.7zM320 432c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48v96z'
      
    ]
  };

  
    var faSortShapesUp = faArrowUpTriangleSquare;
  

  
  

  var faTowerControl = {
    prefix: 'fat',
    iconName: 'tower-control',
    icon: [
      448,
      512,
      [],
      'e2a2',
      
      'M169 0c-4.4 0-8 3.6-8 8s3.6 8 8 8h48V80H161c-17.7 0-32 14.3-32 32v16H40c-21 0-36.3 19.8-31 40.1L49 321c-9.8 3-17 12.1-17 23v16c0 13.3 10.7 24 24 24H81V504c0 4.4 3.6 8 8 8s8-3.6 8-8V384H353V504c0 4.4 3.6 8 8 8s8-3.6 8-8V384h23c13.3 0 24-10.7 24-24V344c0-10.2-6.3-18.8-15.2-22.3l40.1-153.6c5.3-20.3-10-40.1-31-40.1H321V112c0-17.7-14.3-32-32-32H233V16h48c4.4 0 8-3.6 8-8s-3.6-8-8-8H225 169zM384.7 320H321V168.1l0-.1V144h88.9c10.5 0 18.1 9.9 15.5 20L385.2 318l-.5 2zM305 320H145V168.1l0-.1V144H305v15.9l0 .1V320zm-176 0H65.2l-.5-2L24.5 164c-2.6-10.1 5-20 15.5-20H129v15.9l0 .1V320zm232 48H89 56c-4.4 0-8-3.6-8-8V344c0-4.4 3.6-8 8-8h81H313h79c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H361zM305 128H145V112c0-8.8 7.2-16 16-16H289c8.8 0 16 7.2 16 16v16z'
      
    ]
  };

  

  
  

  var faSpinner = {
    prefix: 'fat',
    iconName: 'spinner',
    icon: [
      512,
      512,
      [],
      'f110',
      
      'M256 80a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 496a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM80 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM0 256a48 48 0 1 1 96 0A48 48 0 1 1 0 256zm464 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM131.5 380.5A32 32 0 1 0 86.3 425.7a32 32 0 1 0 45.3-45.3zM75 437a48 48 0 1 1 67.9-67.9A48 48 0 1 1 75 437zM86.3 131.5a32 32 0 1 0 45.3-45.3A32 32 0 1 0 86.3 131.5zM142.9 75A48 48 0 1 1 75 142.9 48 48 0 1 1 142.9 75zM425.7 425.7a32 32 0 1 0 -45.3-45.3 32 32 0 1 0 45.3 45.3zm-56.6-56.6A48 48 0 1 1 437 437a48 48 0 1 1 -67.9-67.9z'
      
    ]
  };

  

  
  

  var faCircleQuarters = {
    prefix: 'fat',
    iconName: 'circle-quarters',
    icon: [
      512,
      512,
      [],
      'e3f8',
      
      'M420 431.3l-164-164L92 431.3C134.9 471.4 192.6 496 256 496s121.1-24.6 164-64.7zM431.3 420C471.4 377.1 496 319.4 496 256s-24.6-121.1-64.7-164l-164 164 164 164zM420 80.7C377.1 40.6 319.4 16 256 16S134.9 40.6 92 80.7l164 164 164-164zM80.7 92C40.6 134.9 16 192.6 16 256s24.6 121.1 64.7 164l164-164L80.7 92zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  

  
  

  var faRotate = {
    prefix: 'fat',
    iconName: 'rotate',
    icon: [
      512,
      512,
      [128260,"sync-alt"],
      'f2f1',
      
      'M43.6 224c-4.9 0-8.7-4.3-7.8-9.2c9.7-51.8 37.5-100.4 82.3-135.3c88.3-69 212.1-61.3 291.3 13.2L455 47c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2V168c0 13.3-10.7 24-24 24H368c-9.7 0-18.5-5.8-22.2-14.8s-1.7-19.3 5.2-26.2l47-47C324.5 35.1 209.8 28.1 127.9 92.1c-41.4 32.3-67.2 77.2-76.3 125.1c-.7 3.9-4.1 6.8-8.1 6.8zm423.7 64c4.9 0 8.7 4.3 7.8 9.2c-9.7 51.8-37.5 100.4-82.3 135.4c-88.1 68.8-211.5 61.3-290.7-12.7L57 465c-6.9 6.9-17.2 8.9-26.2 5.2S16 457.7 16 448V344c0-13.3 10.7-24 24-24H144c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-47.6 47.6c73.5 68.4 187.9 75.1 269.5 11.4c41.4-32.4 67.2-77.3 76.3-125.1c.7-3.9 4.1-6.8 8.1-6.8zM368 176H472c4.4 0 8-3.6 8-8V64c0-3.2-1.9-6.2-4.9-7.4s-6.4-.6-8.7 1.7l-104 104c-2.3 2.3-3 5.7-1.7 8.7s4.2 4.9 7.4 4.9zM144 336H40c-4.4 0-8 3.6-8 8V448c0 3.2 1.9 6.2 4.9 7.4s6.4 .6 8.7-1.7l104-104c2.3-2.3 3-5.7 1.7-8.7s-4.2-4.9-7.4-4.9z'
      
    ]
  };

  
    var faSyncAlt = faRotate;
  

  
  

  var faCircleTrash = {
    prefix: 'fat',
    iconName: 'circle-trash',
    icon: [
      512,
      512,
      ["trash-circle"],
      'e126',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm160-96h8 16 12l21.6-28.8c1.5-2 3.9-3.2 6.4-3.2h64c2.5 0 4.9 1.2 6.4 3.2L316 160h12 16 8c4.4 0 8 3.6 8 8s-3.6 8-8 8h-9.1L330.1 354.3C328.9 371 315 384 298.2 384H213.8c-16.8 0-30.7-13-31.9-29.7L169.1 176H160c-4.4 0-8-3.6-8-8s3.6-8 8-8zm56 0h80l-12-16H228l-12 16zm110.8 16H185.2l12.7 177.1c.6 8.4 7.6 14.9 16 14.9h84.4c8.4 0 15.4-6.5 16-14.9L326.8 176z'
      
    ]
  };

  
    var faTrashCircle = faCircleTrash;
  

  
  

  var faHandPeace = {
    prefix: 'fat',
    iconName: 'hand-peace',
    icon: [
      512,
      512,
      [9996],
      'f25b',
      
      'M246.1 16c-17 0-31.1 13.4-31.9 30.4L204.1 253.1l1.2 2.9H240c10.2 0 19.7 3.2 27.5 8.6L278 49.5c.9-18.2-13.7-33.5-31.9-33.5zM187.1 272H136c-30.9 0-56 25.1-56 56v32c0 75.1 60.9 136 136 136h80c75.1 0 136-60.9 136-136V339.8c-8.5 7.6-19.7 12.2-32 12.2c-18.5 0-34.6-10.5-42.6-25.9C348.6 337 335.1 344 320 344s-28.6-7-37.4-17.9c-8 15.4-24.1 25.9-42.6 25.9H168c-4.4 0-8-3.6-8-8s3.6-8 8-8h72c17.7 0 32-14.3 32-32s-14.3-32-32-32H203.1l0 0h-16l0 0zm2.6-52.4l8.5-174C199.4 20.1 220.5 0 246.1 0c27.4 0 49.2 22.9 47.9 50.3l-7.2 147.1c8.6-8.3 20.3-13.4 33.2-13.4c20.6 0 38.2 13 45 31.2c8.8-9.3 21.2-15.2 35-15.2c26.5 0 48 21.5 48 48v32 24 56c0 83.9-68.1 152-152 152H216c-83.9 0-152-68.1-152-152V328c0-29.5 17.8-54.9 43.2-66L37.8 94.4C25.5 64.7 47.4 32 79.5 32c18 0 34.4 10.8 41.5 27.3l68.7 160.2zM52.6 88.2l69.9 169c4.4-.8 8.8-1.3 13.4-1.3h51.9L106.3 65.6C101.7 54.9 91.2 48 79.5 48C58.8 48 44.7 69.1 52.6 88.2zM432 280V248c0-17.7-14.3-32-32-32s-32 14.3-32 32v48 8c0 17.7 14.3 32 32 32s32-14.3 32-32V280zM320 200c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V248 232c0-17.7-14.3-32-32-32z'
      
    ]
  };

  

  
  

  var faDial = {
    prefix: 'fat',
    iconName: 'dial',
    icon: [
      576,
      512,
      ["dial-med-high"],
      'e15b',
      
      'M272 32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM186.2 186.2c54.3-54.3 141.3-56.2 197.8-5.5L282.3 282.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L395.3 192c50.7 56.5 48.8 143.5-5.5 197.8c-56.2 56.2-147.4 56.2-203.6 0s-56.2-147.4 0-203.6zm215-11.3A160 160 0 1 0 174.9 401.1 160 160 0 1 0 401.1 174.9zM544 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM16 288a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0A32 32 0 1 0 0 288a32 32 0 1 0 64 0zM96 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM464 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 464a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm368-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  
    var faDialMedHigh = faDial;
  

  
  

  var faAlt = {
    prefix: 'fat',
    iconName: 'alt',
    icon: [
      640,
      512,
      [],
      'e08a',
      
      'M463.8 94.5c7.6-9.2 18.9-14.5 30.8-14.5H632c4.4 0 8-3.6 8-8s-3.6-8-8-8H494.6c-16.7 0-32.5 7.5-43.2 20.3L176.2 417.5c-7.6 9.2-18.9 14.5-30.8 14.5H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H145.4c16.7 0 32.5-7.5 43.2-20.3L463.8 94.5zM424 432c-4.4 0-8 3.6-8 8s3.6 8 8 8H632c4.4 0 8-3.6 8-8s-3.6-8-8-8H424z'
      
    ]
  };

  

  
  

  var faDiagramLeanCanvas = {
    prefix: 'fat',
    iconName: 'diagram-lean-canvas',
    icon: [
      640,
      512,
      [],
      'e156',
      
      'M512 48V336H624V96c0-26.5-21.5-48-48-48H512zm-16 0H384V192H496V48zM368 48H272V336h96V48zM256 48H144V192H256V48zM128 48H64C37.5 48 16 69.5 16 96V336H128V48zM16 352v64c0 26.5 21.5 48 48 48H312V352H16zM328 464H576c26.5 0 48-21.5 48-48V352H328V464zM0 96C0 60.7 28.7 32 64 32H576c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM256 336V208H144V336H256zM496 208H384V336H496V208z'
      
    ]
  };

  

  
  

  var faMugTeaSaucer = {
    prefix: 'fat',
    iconName: 'mug-tea-saucer',
    icon: [
      640,
      512,
      [],
      'e1f5',
      
      'M232 48V85l46.1 52.7c6.4 7.3 9.9 16.7 9.9 26.3v52c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V164c0-9.7 3.5-19 9.9-26.3L216 85V48H128c-8.8 0-16 7.2-16 16V288c0 44.2 35.8 80 80 80H384c44.2 0 80-35.8 80-80V48H440 232zm248 0V224h24c48.6 0 88-39.4 88-88s-39.4-88-88-88H480zm0 192v48c0 53-43 96-96 96H192c-53 0-96-43-96-96V64c0-17.7 14.3-32 32-32H440h24 16 24c57.4 0 104 46.6 104 104s-46.6 104-104 104H480zM0 472c0-4.4 3.6-8 8-8H568c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8zM181.9 148.2c-3.8 4.4-5.9 10-5.9 15.8v52c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V164c0-5.8-2.1-11.4-5.9-15.8L224 100.1l-42.1 48.1z'
      
    ]
  };

  

  
  

  var faTtyAnswer = {
    prefix: 'fat',
    iconName: 'tty-answer',
    icon: [
      640,
      512,
      ["teletype-answer"],
      'e2b9',
      
      'M297.8 382.5c6.6 3.1 14.6 1.3 19.2-4.3l40.4-49.3c6.7-8.2 18-11 27.8-7l96 40c11.1 4.6 17.1 16.8 13.9 28.5l-24 88C468.3 488.8 458.8 496 448 496C209.4 496 16 302.6 16 64c0-10.8 7.2-20.3 17.7-23.2l88-24c11.6-3.2 23.8 2.8 28.5 13.9l40 96c4.1 9.8 1.3 21.1-7 27.8l-49.3 40.4c-5.7 4.7-7.5 12.6-4.3 19.2c34.8 73.8 94.5 133.5 168.3 168.3zM345 318.7L304.7 368C234.2 334.7 177.2 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6zM312 80h16c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H312c-4.4 0-8-3.6-8-8V88c0-4.4 3.6-8 8-8zm-24 8v16c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24H312c-13.3 0-24 10.7-24 24zm40 88c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H312c-4.4 0-8-3.6-8-8V184c0-4.4 3.6-8 8-8h16zm-16-16c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V184c0-13.3-10.7-24-24-24H312zm96-80h16c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H408c-4.4 0-8-3.6-8-8V88c0-4.4 3.6-8 8-8zm-24 8v16c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24H408c-13.3 0-24 10.7-24 24zm136-8c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H504c-4.4 0-8-3.6-8-8V88c0-4.4 3.6-8 8-8h16zM504 64c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24H504zm96 16h16c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H600c-4.4 0-8-3.6-8-8V88c0-4.4 3.6-8 8-8zm-24 8v16c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24H600c-13.3 0-24 10.7-24 24zm40 88c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H600c-4.4 0-8-3.6-8-8V184c0-4.4 3.6-8 8-8h16zm-16-16c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V184c0-13.3-10.7-24-24-24H600zM408 176H520c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H408c-4.4 0-8-3.6-8-8V184c0-4.4 3.6-8 8-8zm-24 8v16c0 13.3 10.7 24 24 24H520c13.3 0 24-10.7 24-24V184c0-13.3-10.7-24-24-24H408c-13.3 0-24 10.7-24 24z'
      
    ]
  };

  
    var faTeletypeAnswer = faTtyAnswer;
  

  
  

  var faSpeakers = {
    prefix: 'fat',
    iconName: 'speakers',
    icon: [
      640,
      512,
      [],
      'f8e0',
      
      'M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H280.4c-4.4-4.9-8.3-10.3-11.6-16H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H268.8c3.3-5.7 7.2-11.1 11.6-16H64zM176 224c-61.9 0-112 50.1-112 112s50.1 112 112 112c31.3 0 59.7-12.9 80-33.6V389.1C238.8 415 209.4 432 176 432c-53 0-96-43-96-96s43-96 96-96c33.4 0 62.8 17 80 42.9V257.6c-20.3-20.7-48.7-33.6-80-33.6zM144 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM176 80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM576 16c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H352c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H576zM352 0c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H352zM464 240a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 208a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM432 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM464 80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  

  
  

  var faFaceVomit = {
    prefix: 'fat',
    iconName: 'face-vomit',
    icon: [
      576,
      512,
      [],
      'e3a0',
      
      'M288 16C155.5 16 48 123.5 48 256c0 61.5 23.1 117.5 61.1 160c2.9 3.3 2.7 8.4-.6 11.3s-8.3 2.7-11.3-.6C56.7 381.4 32 321.6 32 256C32 114.6 146.6 0 288 0S544 114.6 544 256c0 65.6-24.7 125.4-65.2 170.7c-2.9 3.3-8 3.6-11.3 .6s-3.6-8-.6-11.3c38-42.5 61.1-98.5 61.1-160C528 123.5 420.5 16 288 16zM160.8 164.4c2-4 6.8-5.6 10.7-3.6l80 40c2.7 1.4 4.4 4.1 4.4 7.2s-1.7 5.8-4.4 7.2l-80 40c-4 2-8.8 .4-10.7-3.6s-.4-8.8 3.6-10.7L230.1 208l-65.7-32.8c-4-2-5.6-6.8-3.6-10.7zm243.6-3.6c4-2 8.8-.4 10.7 3.6s.4 8.8-3.6 10.7L345.9 208l65.7 32.8c4 2 5.6 6.8 3.6 10.7s-6.8 5.6-10.7 3.6l-80-40c-2.7-1.4-4.4-4.1-4.4-7.2s1.7-5.8 4.4-7.2l80-40zM32 496a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm496-48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM304 400a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-48 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm120-40c4.4 0 8 3.6 8 8v7c0 38.2 27.6 70.8 65.3 77.1l13.1 2.2C472.6 472 480 480.7 480 491c0 11.6-9.4 21-21 21H117c-11.6 0-21-9.4-21-21c0-10.3 7.4-19 17.5-20.7l13.1-2.2c37.7-6.3 65.3-38.9 65.3-77.1v-7c0-4.4 3.6-8 8-8s8 3.6 8 8v7c0 46-33.3 85.3-78.7 92.9l-13.1 2.2c-2.4 .4-4.2 2.5-4.2 4.9c0 2.8 2.2 5 5 5H459c2.8 0 5-2.2 5-5c0-2.4-1.8-4.5-4.2-4.9l-13.1-2.2C401.3 476.3 368 437 368 391v-7c0-4.4 3.6-8 8-8zm-208.3-5.8c-1.2 4.2-5.6 6.7-9.9 5.5s-6.7-5.6-5.5-9.9c4.8-17 21.2-34.4 44.3-47.4C220 305.3 251.3 296 288 296s68 9.3 91.4 22.5c23.1 13 39.4 30.4 44.3 47.4c1.2 4.3-1.3 8.7-5.5 9.9s-8.7-1.3-9.9-5.5c-3.2-11.2-15.5-25.8-36.7-37.8C350.7 320.6 322 312 288 312s-62.7 8.6-83.6 20.4c-21.3 12-33.5 26.6-36.7 37.8z'
      
    ]
  };

  

  
  

  var faHammer = {
    prefix: 'fat',
    iconName: 'hammer',
    icon: [
      576,
      512,
      [128296],
      'f6e3',
      
      'M424.8 226.2l17.5 17.5c6.2 6.2 6.2 16.4 0 22.6l-8 8c-3.1 3.1-3.1 8.2 0 11.3l24 24c3.1 3.1 8.2 3.1 11.3 0l88-88c3.1-3.1 3.1-8.2 0-11.3l-24-24c-3.1-3.1-8.2-3.1-11.3 0l-8 8c-6.2 6.2-16.4 6.2-22.6 0l-15.9-15.9c-3.9-3.9-5.5-9.4-4.3-14.7c5.5-25-2-52.2-21.9-71L405 50.8C381.2 28.4 349.8 16 317.2 16H299.2c-17.9 0-35.6 3.8-52 11L200 48l79.7 43.5c5.1 2.8 8.3 8.2 8.3 14v12.1c0 16.9 6.7 33.1 18.6 45l38.1 38.1c18 18 42.7 24.9 66 21c5.1-.9 10.3 .8 14 4.5zM460.5 81.1c24.2 22.8 33.2 55.7 26.6 86l4.6 4.6L503 183l8-8c9.4-9.4 24.6-9.4 33.9 0l24 24c9.4 9.4 9.4 24.6 0 33.9l-88 88c-9.4 9.4-24.6 9.4-33.9 0l-24-24c-9.4-9.4-9.4-24.6 0-33.9l8-8-11.3-11.3-6.2-6.2c-28.2 4.8-58.2-3.6-80-25.4l-38.1-38.1C280.4 159 272 138.8 272 117.6V105.5L192.3 62c-5.3-2.9-8.6-8.6-8.3-14.7s3.9-11.5 9.5-14l47.2-21C259.1 4.2 279 0 299.2 0h18.1c36.7 0 72 14 98.7 39.1l44.6 42zM27.4 377.1L260.9 182.6c3.1 4.3 6.5 8.4 10.2 12.3L37.7 389.4 27.4 377.1zm0 0l10.2 12.3C23.9 400.9 16 417.8 16 435.7C16 469 43 496 76.3 496c17.9 0 34.9-7.9 46.3-21.7L317.3 240.7c4.1 3.5 8.3 6.8 12.7 9.7L134.9 484.6c-14.5 17.4-36 27.4-58.6 27.4C34.1 512 0 477.8 0 435.7c0-22.6 10.1-44.1 27.4-58.6z'
      
    ]
  };

  

  
  

  var faPersonPraying = {
    prefix: 'fat',
    iconName: 'person-praying',
    icon: [
      448,
      512,
      [128720,"pray"],
      'f683',
      
      'M288 16a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm64 48A64 64 0 1 1 224 64a64 64 0 1 1 128 0zM202 160c-24.9 0-47.8 13.8-59.4 35.9L94 288.4c-16.6 31.5-7.7 70.3 20.9 91.4l72.8 53.8c2.8 2.1 3.9 5.7 2.8 8.9s-4.1 5.5-7.6 5.5H72c-13.3 0-24 10.7-24 24s10.7 24 24 24H280c10.4 0 19.6-6.6 22.8-16.5s-.2-20.7-8.5-26.8L172.8 362.9c-3.1-2.3-4.1-6.5-2.4-10l53.9-107.8c1.2-2.5 3.7-4.2 6.5-4.4s5.5 1 7.1 3.3l30.7 42.2c3.9 5.3 9.8 8.8 16.3 9.7s13.2-1 18.3-5.2l88-72c10.3-8.4 11.8-23.5 3.4-33.8s-23.5-11.8-33.8-3.4L299 232c-1.7 1.4-3.9 2-6.1 1.7s-4.2-1.4-5.4-3.2l-31.2-42.8C243.7 170.3 223.5 160 202 160zm-73.6 28.4C142.9 161.1 171.2 144 202 144c26.6 0 51.6 12.7 67.2 34.2l26.2 36L350.7 169c17.1-14 42.3-11.5 56.3 5.6s11.5 42.3-5.6 56.3l-88 72c-8.5 7-19.5 10.1-30.4 8.7s-20.8-7.2-27.2-16.1L232.7 264l-45 90 116.1 85.8c13.9 10.3 19.6 28.3 14.2 44.7s-20.7 27.5-38 27.5H72c-22.1 0-40-17.9-40-40s17.9-40 40-40h86.6l-53.2-39.3c-34.9-25.8-45.8-73.3-25.6-111.8l48.7-92.5z'
      
    ]
  };

  
    var faPray = faPersonPraying;
  

  
  

  var faCloudsSun = {
    prefix: 'fat',
    iconName: 'clouds-sun',
    icon: [
      640,
      512,
      [],
      'f746',
      
      'M137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1 13.4 112.2c-5.4 .9-10 4.5-12.1 9.6s-1.5 10.9 1.6 15.4L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6l24.4-17c1.3-8.2 3.3-16.2 6.1-23.8l-25.1 17.6L128 400l-2.9-17.5-11.2-67.2c-1.1-6.7-6.4-12-13.2-13.2L33.5 290.9 16 288l10.2-14.5 39.4-56.3c3.9-5.5 3.9-12.8 0-18.4L26.2 142.5 16 128l17.5-2.9 67.2-11.2c6.7-1.1 12-6.4 13.2-13.2l11.2-67.2L128 16l14.5 10.2 56.3 39.4c5.5 3.9 12.8 3.9 18.4 0l56.3-39.4L288 16l2.9 17.5 11.2 67.2c1.1 6.7 6.4 12 13.2 13.2l11.2 1.9c7.4-5 15.4-9.1 23.8-12.3l-32.3-5.4L303.8 13.4c-.9-5.4-4.5-10-9.6-12.1s-10.9-1.5-15.4 1.6L208 52.5 137.2 2.9zM247.1 277.8C235.5 284.3 222.2 288 208 288c-44.2 0-80-35.8-80-80s35.8-80 80-80c33.7 0 62.5 20.8 74.3 50.2c1.6-7.3 4-14.3 7.3-20.9C272.6 130.1 242.4 112 208 112c-53 0-96 43-96 96s43 96 96 96c8.1 0 15.9-1 23.4-2.9c3.5-1.7 7.1-3.3 10.7-4.7c1.2-6.4 2.8-12.6 4.9-18.6zm338.7-8.6c3.3 4.4 6.2 9 8.8 13.8c26.6-10.6 45.4-36.5 45.4-66.9c0-39.8-32.2-72-72-72c-3.2 0-6.4 .2-9.5 .6C551.4 107.9 519 80.1 480 80.1c-34.2 0-63.3 21.4-74.8 51.6c-6.6-2.3-13.8-3.6-21.2-3.6c-35.3 0-64 28.6-64 64c0 3 .2 6 .6 8.9c5-2 10.2-3.7 15.5-5c-.1-1.3-.2-2.6-.2-3.9c0-26.5 21.5-48 48-48c5.6 0 10.9 1 15.9 2.7c8.2 2.9 17.2-1.3 20.3-9.4c9.2-24.1 32.5-41.3 59.8-41.3c31.1 0 57.1 22.2 62.8 51.7c1.6 8.3 9.4 13.9 17.8 12.8c2.4-.3 4.9-.5 7.4-.5c30.9 0 56 25.1 56 56c0 24.7-16 45.7-38.2 53.1zM288 320c0-44.2 35.8-80 80-80c32 0 59.6 18.8 72.4 46c1.1 2.3 3.2 3.9 5.7 4.4s5.1-.2 6.9-1.9c11.4-10.3 26.4-16.5 42.9-16.5c35.3 0 64 28.7 64 64c0 7.5-1.3 14.7-3.7 21.4c-.8 2.4-.5 5 .9 7.1s3.7 3.4 6.2 3.5c33.7 1.8 60.5 29.7 60.5 63.9c0 35.3-28.7 64-64 64c-.7 0-1.5 0-2.2 0l0 0h-.3H291v0l-.3 0c-.9 0-1.8 0-2.8 0c-44.2 0-80-35.8-80-80c0-41.8 32.1-76.2 73.1-79.7c2.1-.2 4.1-1.2 5.5-2.8s2-3.8 1.8-5.9c-.2-2.5-.4-5-.4-7.6zm80-96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.7c0 53 43 96 96 96c1.1 0 2.1 0 3.2-.1H557.3c.9 0 1.8 0 2.6 0c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C433.4 242.6 402.8 224 368 224z'
      
    ]
  };

  

  
  

  var faTrophy = {
    prefix: 'fat',
    iconName: 'trophy',
    icon: [
      576,
      512,
      [127942],
      'f091',
      
      'M176 16H400c17.7 0 31.8 14.5 31.1 31.6c-6.3 165.9-45.5 245.5-80.2 283.6c-17.3 19-33.8 28.1-45.5 32.5c-5.9 2.2-10.6 3.3-13.7 3.8c-1.5 .2-2.7 .4-3.3 .4l-.4 0-.4 0c-.6-.1-1.8-.2-3.3-.4c-3.1-.5-7.8-1.6-13.7-3.8c-11.7-4.4-28.2-13.5-45.5-32.5c-34.7-38.1-73.9-117.8-80.2-283.6C144.2 30.5 158.3 16 176 16zM400 0H176c-26.5 0-48.1 21.8-47.1 48.2c.2 5.3 .4 10.6 .7 15.8H40C18.2 64-.7 82 1.8 104.9c10.2 92 62.3 158.4 119 202.8c56.5 44.3 118.4 67.5 149.8 73l0 0c3.6 1.1 6.8 1.9 9.4 2.3V496H168c-4.4 0-8 3.6-8 8s3.6 8 8 8H288 408c4.4 0 8-3.6 8-8s-3.6-8-8-8H296V383c2.6-.5 5.8-1.2 9.4-2.3l0 0c31.5-5.5 93.3-28.7 149.8-73c56.7-44.5 108.8-110.8 119-202.8C576.7 82 557.8 64 536 64H446.4c.3-5.2 .5-10.4 .7-15.8C448.1 21.8 426.5 0 400 0zm45.4 80H536c13.5 0 23.7 10.9 22.3 23.1c-9.6 86.5-58.5 149.3-113 192c-29.5 23.2-60.5 40.2-87.2 51.8c37.1-37.7 77-113.7 87.3-266.9zM217.9 346.9c-26.7-11.6-57.7-28.6-87.2-51.8c-54.4-42.7-103.4-105.5-113-192C16.3 90.9 26.5 80 40 80h90.6c10.3 153.2 50.3 229.2 87.3 266.9z'
      
    ]
  };

  

  
  

  var faWheatSlash = {
    prefix: 'fat',
    iconName: 'wheat-slash',
    icon: [
      640,
      512,
      [],
      'e339',
      
      'M13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7zM523.2 258.3L534.5 247c6.2-6.2 6.2-16.4 0-22.6L523.2 213c-30.9-30.9-73.5-42.7-113.4-35.4l26.2-26.2 4.2-.2 49.2-2.5c45.1-2.3 81.2-38.4 83.5-83.5l1.9-38.7c.7-14.2-11-25.9-25.2-25.2L510.8 3.3c-45.1 2.3-81.2 38.4-83.5 83.5l-2.5 49.2-.2 4.2-23.7 23.7c5.7-38.7-6.4-79.4-36.1-109.1L353.5 43.3c-6.2-6.2-16.4-6.2-22.6 0L319.5 54.6c-26.2 26.2-34.1 63.8-23.6 96.9l35.2 27.8-.3-.3c-31.2-31.2-31.2-81.9 0-113.1l11.3-11.3 11.3 11.3c32.5 32.5 40.9 80 25 120.2l-17.1 17.1 12.6 10L385.3 202c41.5-19.3 92.3-11.9 126.5 22.3l11.3 11.3L511.9 247c-18.1 18.1-42.6 25.7-66.2 22.9l20.2 16c20.9-2.3 41.2-11.5 57.2-27.5zM197.3 367.4c5.7-38.7-6.4-79.4-36.1-109.1L149.8 247c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l27.4 27.4L66.3 498.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l76.9-76.9 29.2 29.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3C288.7 385.8 246 374 206.1 381.2l65.5-65.5-12.6-10-61.6 61.6zm353-350.1c4.7-.2 8.6 3.7 8.4 8.4l-1.9 38.7c-1.8 36.9-31.4 66.5-68.3 68.3l-47.6 2.4 2.4-47.6c1.8-36.9 31.4-66.5 68.3-68.3l38.8-1.9zM165.9 421.4l15.8-15.8c41.5-19.3 92.3-11.9 126.5 22.3l11.3 11.3-11.3 11.3c-31.2 31.2-81.9 31.2-113.1 0l-29.2-29.2zm9-31.6l-20.3 20.3-27.4-27.4c-31.2-31.2-31.2-81.9 0-113.1l11.3-11.3 11.3 11.3c32.5 32.5 40.9 80 25 120.2z'
      
    ]
  };

  

  
  

  var faThumbtack = {
    prefix: 'fat',
    iconName: 'thumbtack',
    icon: [
      384,
      512,
      [128204,128392,"thumb-tack"],
      'f08d',
      
      'M110.3 17.6L92.4 197c-.5 4.8-3.1 9.1-7.2 11.8c-30.5 20-53.7 50.8-63.6 88l-5.1 19c-1.3 4.8-.3 9.9 2.8 13.9L6.7 339.4l12.6-9.7c3 3.9 7.7 6.3 12.7 6.3H184V232c0-4.4 3.6-8 8-8s8 3.6 8 8V336H352c5 0 9.7-2.3 12.7-6.3s4.1-9.1 2.8-13.9l-5.1-19c-9.9-37.2-33.1-68-63.6-88c-4-2.6-6.7-7-7.2-11.8L273.7 17.6c-.1-.5-.1-1.1-.1-1.6H110.4c0 .5 0 1.1-.1 1.6zM184 352H32c-9.9 0-19.3-4.6-25.4-12.5s-8.1-18.1-5.5-27.7l5.1-19c11-41.1 36.6-75.2 70.3-97.3L92.8 32l1.6-16H78.3 48c-4.4 0-8-3.6-8-8s3.6-8 8-8H94.4 96 288h1.6H336c4.4 0 8 3.6 8 8s-3.6 8-8 8H305.7 289.6l1.6 16 16.3 163.4c33.7 22.1 59.3 56.2 70.3 97.3l5.1 19c2.6 9.6 .5 19.9-5.5 27.7s-15.4 12.5-25.4 12.5H200V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V352z'
      
    ]
  };

  
    var faThumbTack = faThumbtack;
  

  
  

  var faSignatureSlash = {
    prefix: 'fat',
    iconName: 'signature-slash',
    icon: [
      640,
      512,
      [],
      'e3cb',
      
      'M13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7zM598.3 384H632c4.4 0 8-3.6 8-8s-3.6-8-8-8H578.1l20.3 16zM275.5 312.6L262 302c-9.4 31.6-22 62.2-37.4 91.3l-27 51c-6.4 12.1-19 19.7-32.6 19.7c-20.4 0-36.9-16.5-36.9-36.9V319.8c0-24.8 16.3-46.7 40.1-53.7l35.3-10.4L188 243.6l-24.4 7.2c-30.6 9-51.6 37.1-51.6 69V427.1c0 29.2 23.7 52.9 52.9 52.9c19.6 0 37.6-10.8 46.8-28.2l27-51c14.9-28.2 27.2-57.8 36.8-88.2zM216 32c-17.1 0-33.1 4.9-46.6 13.4L182.9 56c9.9-5.1 21.2-8 33.1-8c39.8 0 72 32.2 72 72v15.9c0 1 0 2.1 0 3.1l15.8 12.5c.2-5.2 .2-10.4 .2-15.6V120c0-48.6-39.4-88-88-88zM469.7 160.3L357.1 193.6l15.4 12.1L454 181.6l-37 59.2 12.6 10 49.1-78.6c1.8-2.8 1.6-6.4-.4-9.1s-5.4-3.8-8.6-2.8zM497 304h71c4.4 0 8-3.6 8-8s-3.6-8-8-8H476.7L497 304zM8 368c-4.4 0-8 3.6-8 8s3.6 8 8 8H56c4.4 0 8-3.6 8-8s-3.6-8-8-8H8z'
      
    ]
  };

  

  
  

  var faPhoneHangup = {
    prefix: 'fat',
    iconName: 'phone-hangup',
    icon: [
      640,
      512,
      [],
      'e225',
      
      'M421.1 240.8c6.5 2.2 10.9 8.3 10.9 15.2v69.8c0 7.6 5.4 14.2 12.9 15.7l110.3 22.1c7.1 1.4 14.2-2.1 17.4-8.5l39.5-79.1c5.7-11.4 3.9-23.6-3.6-31C560.1 196.5 457.9 128 320 128S79.9 196.5 31.4 244.9c-7.5 7.4-9.3 19.7-3.6 31L67.4 355c3.2 6.5 10.4 9.9 17.4 8.5l110.3-22.1c7.5-1.5 12.9-8.1 12.9-15.7V256c0-6.9 4.4-13 10.9-15.2c65.6-21.9 136.5-21.9 202.1 0zM416 256c-62.3-20.8-129.7-20.8-192 0v69.8c0 15.3-10.8 28.4-25.7 31.4L88 379.2C73.8 382 59.5 375 53.1 362.1L13.5 283.1c-8.3-16.5-6.5-36.5 6.6-49.5C70.7 183.1 176.8 112 320 112s249.3 71.1 299.9 121.5c13.1 13 14.9 33 6.6 49.5l-39.5 79.1C580.5 375 566.2 382 552 379.2L441.7 357.1c-15-3-25.7-16.1-25.7-31.4V256z'
      
    ]
  };

  

  
  

  var faFaceSmile = {
    prefix: 'fat',
    iconName: 'face-smile',
    icon: [
      512,
      512,
      [128578,"smile"],
      'f118',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm150.6 67.4C171.4 353.2 206.6 384 256 384s84.6-30.8 105.4-60.6c2.5-3.6 7.5-4.5 11.1-2s4.5 7.5 2 11.1C352.1 364.6 312.7 400 256 400s-96.1-35.4-118.6-67.4c-2.5-3.6-1.7-8.6 2-11.1s8.6-1.7 11.1 2zM160.4 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  
    var faSmile = faFaceSmile;
  

  
  

  var faPersonSign = {
    prefix: 'fat',
    iconName: 'person-sign',
    icon: [
      512,
      512,
      [],
      'f757',
      
      'M128 352V480c0 8.8-7.2 16-16 16s-16-7.2-16-16V263.6c0-7.4-5.1-13.9-12.3-15.6s-14.7 1.8-18 8.4L46.3 295.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5L64 188.2c13.6-27.1 41.3-44.2 71.6-44.2h27.7c22.9 0 44.6 9.8 59.8 26.9l29.1 32.8c8.6 9.7 19.5 17.2 31.7 21.8L325.6 241c8.3 3.1 12.5 12.3 9.4 20.6s-12.3 12.5-20.6 9.4l-41.7-15.7c-17.1-6.4-32.3-16.8-44.4-30.5l0 0-.3-.3c-4.4-5-11.4-6.7-17.6-4.3s-10.3 8.3-10.3 15v77.3c0 2.5 .6 4.9 1.7 7.2l33.2 66.5c3.3 6.7 5.1 14 5.1 21.5V480c0 8.8-7.2 16-16 16s-16-7.2-16-16V407.6c0-2.5-.6-4.9-1.7-7.2l-27.8-55.6c-2.7-5.4-8.3-8.8-14.3-8.8H144c-8.8 0-16 7.2-16 16zm88-94.2V235.8v-.6l.3 .3c4.8 5.4 10.1 10.4 15.7 14.9c10.5 8.4 22.3 15.1 35 19.9l41.1 15.4-11.6 31.5c-1.5 4.1 .6 8.7 4.7 10.3s8.7-.6 10.3-4.7l12.9-35.1c11.2-1.6 21.3-9.1 25.5-20.5c4.5-11.9 1.4-24.8-6.8-33.4c.3 .3 .6 .6 .8 .9l17-46 78.4 28.6c12.5 4.5 26.2-1.9 30.8-14.3L508.4 97.7c4.5-12.5-1.9-26.2-14.3-30.8L416.2 38.6l10.2-27.7c1.5-4.1-.6-8.7-4.7-10.3s-8.7 .6-10.3 4.7L401.2 33.1 328.7 6.7c-12.5-4.5-26.2 1.9-30.8 14.3L259.6 126.3c-4.5 12.5 1.9 26.2 14.3 30.8l71.9 26.2-15.6 42.4-40.7-15.3c-9.7-3.7-18.4-9.6-25.4-17.4L235 160.2c-18.2-20.5-44.3-32.2-71.8-32.2H135.6c-36.4 0-69.6 20.5-85.9 53.1L3.4 273.7c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l3.4-6.8 16-32v35.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V368 352h16 4.2L192 407.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V407.6c0-9.9-2.3-19.7-6.8-28.6L216 312.4V257.8zM144 16a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM488.6 82c4.2 1.5 6.3 6.1 4.8 10.3L455.1 197.5c-1.5 4.2-6.1 6.3-10.3 4.8L279.4 142c-4.2-1.5-6.3-6.1-4.8-10.3L312.9 26.5c1.5-4.2 6.1-6.3 10.3-4.8L488.6 82z'
      
    ]
  };

  

  
  

  var faDisplay = {
    prefix: 'fat',
    iconName: 'display',
    icon: [
      576,
      512,
      [],
      'e163',
      
      'M512 16c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H344.2h-.3H232.1h-.3H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H512zM64 416H222.6l-13.3 80H136c-4.4 0-8 3.6-8 8s3.6 8 8 8h80H360h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H366.8l-13.3-80H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64zm161.4 80l13.3-80h98.4l13.3 80H225.4zM80 80H496V336H80L80 80zM64 80V336c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faCoinVertical = {
    prefix: 'fat',
    iconName: 'coin-vertical',
    icon: [
      384,
      512,
      [],
      'e3fd',
      
      'M272 256c0-68.5-15.6-129.7-40.1-173.2C207.1 38.8 175.4 16 144 16s-63.1 22.8-87.9 66.8C31.6 126.3 16 187.5 16 256s15.6 129.7 40.1 173.2c24.8 44 56.5 66.8 87.9 66.8s63.1-22.8 87.9-66.8C256.4 385.7 272 324.5 272 256zM144 512C64.5 512 0 397.4 0 256S64.5 0 144 0h16 96c70.7 0 128 114.6 128 256s-57.3 256-128 256H160 144zM279.3 344H360c4.7-24.8 7.5-51.8 8-80h-80c-.5 28-3.5 54.9-8.7 80zm-3.6 16c-5.9 23.4-13.6 44.9-23 64H335c8.7-18.6 16-40.2 21.6-64h-81zM194.2 496H256c24 0 49.5-18.2 70.8-56H244.1c-14.1 24.3-31.1 43.6-49.9 56zM360 168H279.3c5.2 25.1 8.2 52 8.7 80h80c-.4-28.2-3.2-55.2-8-80zm-84.3-16h81c-5.5-23.8-12.8-45.4-21.6-64H252.7c9.3 19.1 17.1 40.6 23 64zM256 16H194.2C213 28.4 230 47.7 244.1 72h82.7C305.5 34.2 280 16 256 16zM64 256c0 49.9 9.3 94.8 23.9 126.8c14.9 32.7 34 49.2 52.1 49.2s37.2-16.5 52.1-49.2c14.6-32 23.9-76.9 23.9-126.8s-9.3-94.8-23.9-126.8C177.2 96.5 158.1 80 140 80s-37.2 16.5-52.1 49.2C73.3 161.2 64 206.1 64 256zM140 64c28.2 0 51.2 24.7 66.7 58.6C222.5 157.1 232 204.3 232 256s-9.5 98.9-25.3 133.4C191.2 423.3 168.2 448 140 448s-51.2-24.7-66.7-58.6C57.5 354.9 48 307.7 48 256s9.5-98.9 25.3-133.4C88.8 88.7 111.8 64 140 64z'
      
    ]
  };

  

  
  

  var faLocationCheck = {
    prefix: 'fat',
    iconName: 'location-check',
    icon: [
      384,
      512,
      ["map-marker-check"],
      'f606',
      
      'M368 192c0-97.2-78.8-176-176-176S16 94.8 16 192c0 18.7 6.4 42.5 17.8 69.6c11.3 26.9 27.1 55.8 44.7 84.3c35.2 57 76.8 111.4 102.3 143.2c5.9 7.3 16.6 7.3 22.4 0c25.5-31.8 67.1-86.2 102.3-143.2c17.6-28.5 33.4-57.4 44.7-84.3C361.6 234.5 368 210.7 368 192zm16 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM277.7 144.3L171 251c-3.1 3.1-8.2 3.1-11.3 0l-53.3-53.3c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L165.3 234l101-101c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3z'
      
    ]
  };

  
    var faMapMarkerCheck = faLocationCheck;
  

  
  

  var faConveyorBelt = {
    prefix: 'fat',
    iconName: 'conveyor-belt',
    icon: [
      640,
      512,
      [],
      'f46e',
      
      'M464 16c17.7 0 32 14.3 32 32V240c0 17.7-14.3 32-32 32H176c-17.7 0-32-14.3-32-32V48c0-17.7 14.3-32 32-32h80V136c0 3.1 1.8 6 4.7 7.3s6.2 .8 8.5-1.2L320 98.5l50.8 43.5c2.4 2 5.7 2.5 8.6 1.2s4.7-4.1 4.7-7.3V16h80zM272 16h96V118.6L325.2 81.9c-3-2.6-7.4-2.6-10.4 0L272 118.6V16zM176 0c-26.5 0-48 21.5-48 48V240c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H176zM624 416c0 44.2-35.8 80-80 80H96c-44.2 0-80-35.8-80-80s35.8-80 80-80H544c44.2 0 80 35.8 80 80zM96 320c-53 0-96 43-96 96s43 96 96 96H544c53 0 96-43 96-96s-43-96-96-96H96zm16 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm176-48a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faGlassWaterDroplet = {
    prefix: 'fat',
    iconName: 'glass-water-droplet',
    icon: [
      384,
      512,
      [],
      'e4f5',
      
      'M16.1 33.3C15.4 24 22.7 16 32.1 16H352c9.4 0 16.7 8 15.9 17.3L345.7 306.1l-24.9 11.1c-24.6 10.9-53.2 7.9-75-7.9c-32.1-23.3-75.5-23.3-107.5 0c-21.8 15.8-50.4 18.9-75 7.9L38.4 306.1 16.1 33.3zM39.9 324.2l16.9 7.5c29.8 13.3 64.5 9.6 90.9-9.6c26.4-19.2 62.3-19.2 88.7 0c26.4 19.2 61.1 22.9 90.9 9.6l16.9-7.5-11 135c-1.7 20.8-19 36.8-39.9 36.8H90.7c-20.8 0-38.2-16-39.9-36.8l-11-135zM32.1 0C13.4 0-1.3 16 .2 34.6l34.7 426C37.3 489.6 61.6 512 90.7 512H293.3c29.2 0 53.4-22.4 55.8-51.4l34.7-426C385.4 16 370.7 0 352 0H32.1zM192 224c-27.5 0-48-20.7-48-44c0-2.8 1.1-7.8 4.3-15.2c3-7.1 7.4-15.1 12.5-23.4c10-16.2 22.2-32.6 31.2-44c9 11.5 21.2 27.8 31.2 44c5.1 8.3 9.5 16.4 12.5 23.4c3.2 7.4 4.3 12.4 4.3 15.2c0 23.3-20.5 44-48 44zm0 16c35.3 0 64-26.9 64-60c0-24-33.7-70.1-52.2-93.5c-6.1-7.7-17.5-7.7-23.6 0C161.7 109.9 128 156 128 180c0 33.1 28.7 60 64 60z'
      
    ]
  };

  

  
  

  var faTruckMoving = {
    prefix: 'fat',
    iconName: 'truck-moving',
    icon: [
      640,
      512,
      [],
      'f4df',
      
      'M72 48c-30.9 0-56 25.1-56 56V304v48c14.6-19.4 37.8-32 64-32c31.7 0 59 18.4 72 45.1c13-26.7 40.3-45.1 72-45.1c38.7 0 71 27.5 78.4 64H448V104c0-30.9-25.1-56-56-56H72zM224 480c-31.7 0-59-18.4-72-45.1C139 461.6 111.7 480 80 480c-44.2 0-80-35.8-80-80V384 304 104C0 64.2 32.2 32 72 32H392c39.8 0 72 32.2 72 72v32h80c12.6 0 24.4 5.9 32 16l56 74.7c5.2 6.9 8 15.3 8 24V304v72c0 17.7-14.3 32-32 32h-.4c-4 40.4-38.1 72-79.6 72s-75.6-31.6-79.6-72H448v-8H304c0 44.2-35.8 80-80 80zm383.6-88h.4c8.8 0 16-7.2 16-16V304 256H464v96c14.6-19.4 37.8-32 64-32c41.5 0 75.6 31.6 79.6 72zm11.6-155.7l-56-74.7c-4.5-6-11.6-9.6-19.2-9.6H464v88H621.5c-.6-1.3-1.4-2.6-2.3-3.7zM528 464a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM288 400a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM80 464a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  

  
  

  var faPercent = {
    prefix: 'fat',
    iconName: 'percent',
    icon: [
      384,
      512,
      [62101,62785,"percentage"],
      '25',
      
      'M64 80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112A64 64 0 1 0 64 64a64 64 0 1 0 0 128zM320 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM373.7 85.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-352 352c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l352-352z'
      
    ]
  };

  
    var faPercentage = faPercent;
  

  
  

  var faHandMiddleFinger = {
    prefix: 'fat',
    iconName: 'hand-middle-finger',
    icon: [
      448,
      512,
      [128405],
      'f806',
      
      'M200 52c0-19.9 16.1-36 36-36s36 16.1 36 36V232.2c0 2.9 1.6 5.6 4.2 7s5.7 1.3 8.2-.3c6.8-4.4 15-6.9 23.7-6.9c19 0 35.2 12.1 41.4 29c1.5 4 5.8 6.2 9.8 4.9c4-1.2 8.3-1.9 12.8-1.9c23.1 0 42.1 17.9 43.9 40.6c0 .3 .1 .6 .1 1V308v84 16c0 48.6-39.4 88-88 88H186c-20.9 0-41.4-5.4-59.5-15.8l-18-10.3C71.1 448.5 48 408.8 48 365.7v-24c0-16.5 7.3-32.1 19.8-42.7L97 274.2c2.3-1.9 4.6-3.7 7-5.5V344c0 4.4 3.6 8 8 8s8-3.6 8-8V256c0-.3 0-.6-.1-.9c0-.3 .1-.6 .1-.9V252c0-24.3 19.7-44 44-44c8.7 0 16.9 2.5 23.7 6.9c2.5 1.6 5.6 1.7 8.2 .3s4.2-4.1 4.2-7V52zM236 0c-28.7 0-52 23.3-52 52V195.4c-6.3-2.2-13-3.4-20-3.4c-32.3 0-58.7 25.5-60 57.5c-6.1 3.7-11.9 7.8-17.4 12.5L57.5 286.7C41.3 300.4 32 320.5 32 341.7v24c0 48.8 26.2 93.9 68.5 118.1l18 10.3C139.1 505.8 162.3 512 186 512H328c57.4 0 104-46.6 104-104V392 308v-4c0-.8-.1-1.5-.3-2.2C428.5 271.5 403 248 372 248c-3.6 0-7.1 .3-10.5 .9C351.7 229.4 331.4 216 308 216c-7 0-13.7 1.2-20 3.4V52c0-28.7-23.3-52-52-52z'
      
    ]
  };

  

  
  

  var faBrightnessLow = {
    prefix: 'fat',
    iconName: 'brightness-low',
    icon: [
      512,
      512,
      [],
      'e0ca',
      
      'M272 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 176a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM432 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM64 256a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm80-128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM400 384a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0-256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM112 384a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z'
      
    ]
  };

  

  
  

  var faGaugeCircleMinus = {
    prefix: 'fat',
    iconName: 'gauge-circle-minus',
    icon: [
      640,
      512,
      [],
      'e497',
      
      'M256 496c35.6 0 69.4-7.7 99.8-21.6c3.3 4.4 6.9 8.6 10.6 12.7C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-2.9 0-5.7 .1-8.6 .2C459.5 90.6 366.5 16 256 16C123.5 16 16 123.5 16 256s107.5 240 240 240zm0-96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 16c-35.3 0-64-28.7-64-64c0-32.6 24.4-59.6 56-63.5V80c0-4.4 3.6-8 8-8s8 3.6 8 8V288.5c31.6 3.9 56 30.9 56 63.5c0 35.3-28.7 64-64 64zM144 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM80 240a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM352 128a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM496 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm80 144c0 4.4-3.6 8-8 8l-144 0c-4.4 0-8-3.6-8-8s3.6-8 8-8H568c4.4 0 8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faCarTilt = {
    prefix: 'fat',
    iconName: 'car-tilt',
    icon: [
      640,
      512,
      [],
      'f5e5',
      
      'M88.1 138.4L86.2 250.3c7.9-5 16.7-8.9 26.3-11.4l278.2-74.5c9.5-2.6 19.1-3.6 28.5-3.2l-57.6-96C348.7 43.7 323.2 33.4 299 39.8L129.6 85.2c-24.2 6.5-41.1 28.2-41.5 53.2zM70 263.2l2.1-125c.5-32.1 22.3-60 53.4-68.4L294.9 24.4c31.1-8.3 63.9 5 80.4 32.5l64.3 107.2c32.4 8.4 59.4 33.5 68.7 68.1L529 309.5l4.1 15.5 8.3 30.9c4.6 17.1-5.6 34.6-22.6 39.2l-30.9 8.3c-17.1 4.6-34.6-5.6-39.2-22.6l-8.3-30.9L162.2 424.4l8.3 30.9c4.6 17.1-5.6 34.6-22.6 39.2l-5.7 1.5H632c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H87.7c-4.7-4-8.2-9.5-9.9-15.9l-8.3-30.9-4.1-15.5L44.6 356.5c-9.3-34.6 1.6-69.9 25.4-93.3zM84.9 445.1L93.2 476c2.3 8.5 11.1 13.6 19.6 11.3l30.9-8.3c8.5-2.3 13.6-11.1 11.3-19.6l-8.3-30.9L84.9 445.1zM436.2 334.4l15.5-4.1 61.8-16.6-20.7-77.3c-11.4-42.7-55.3-68-98-56.6L116.6 254.4c-42.7 11.4-68 55.3-56.6 98l20.7 77.3L142.6 413l15.5-4.1 278.2-74.5zm27.9 42.2c2.3 8.5 11.1 13.6 19.6 11.3l30.9-8.3c8.5-2.3 13.6-11.1 11.3-19.6l-8.3-30.9-61.8 16.6 8.3 30.9zM152.8 327.5a16 16 0 1 0 -30.9 8.3 16 16 0 1 0 30.9-8.3zm-46.4 12.4a32 32 0 1 1 61.8-16.6 32 32 0 1 1 -61.8 16.6zm313.2-67.4a16 16 0 1 0 -8.3-30.9 16 16 0 1 0 8.3 30.9zm-12.4-46.4A32 32 0 1 1 423.8 288a32 32 0 1 1 -16.6-61.8z'
      
    ]
  };

  

  
  

  var faVrCardboard = {
    prefix: 'fat',
    iconName: 'vr-cardboard',
    icon: [
      640,
      512,
      [],
      'f729',
      
      'M576 80H64c-26.5 0-48 21.5-48 48V384c0 26.5 21.5 48 48 48H200.4c18.2 0 34.8-10.3 42.9-26.5l39.2-78.3C289.6 313 304.1 304 320 304s30.4 9 37.5 23.2l39.2 78.3c8.1 16.3 24.8 26.5 42.9 26.5H576c26.5 0 48-21.5 48-48V128c0-26.5-21.5-48-48-48zM64 64H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H439.6c-24.2 0-46.4-13.7-57.2-35.4l-39.2-78.3c-4.4-8.8-13.4-14.3-23.2-14.3s-18.8 5.5-23.2 14.3l-39.2 78.3c-10.8 21.7-33 35.4-57.2 35.4H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64zM176 304a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-144a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm352 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-144 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z'
      
    ]
  };

  

  
  

  var faShieldMinus = {
    prefix: 'fat',
    iconName: 'shield-minus',
    icon: [
      512,
      512,
      [],
      'e249',
      
      'M237.3 22.6c12-5.1 25.5-5.1 37.5 0l176.7 75c16.6 7.1 28.6 23.2 28.5 42.4c-.5 96.6-40.3 270.2-204.5 348.8c-12.3 5.9-26.7 5.9-39 0C72.3 410.1 32.5 236.5 32 139.9c-.1-19.1 11.9-35.3 28.5-42.4l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM160 248c-4.4 0-8 3.6-8 8s3.6 8 8 8H352c4.4 0 8-3.6 8-8s-3.6-8-8-8H160z'
      
    ]
  };

  

  
  

  var faThermometer = {
    prefix: 'fat',
    iconName: 'thermometer',
    icon: [
      512,
      512,
      [],
      'f491',
      
      'M355.1 40.2L299.3 96l50.3 50.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L288 107.3 235.3 160l50.3 50.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L224 171.3 171.3 224l50.3 50.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L160 235.3l-36.3 36.3c-7.5 7.5-11.7 17.7-11.7 28.3V400H212.1c10.6 0 20.8-4.2 28.3-11.7L471.8 156.9c15.5-15.5 24.2-36.5 24.2-58.3C496 52.9 459.1 16 413.5 16c-21.9 0-42.9 8.7-58.3 24.2zM282.4 90.3l61.5-61.5C362.3 10.4 387.4 0 413.5 0C467.9 0 512 44.1 512 98.5c0 26.1-10.4 51.2-28.9 69.7L251.7 399.6C241.2 410.1 227 416 212.1 416H107.3L13.7 509.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L96 404.7V299.9c0-14.9 5.9-29.1 16.4-39.6l41.9-41.9s0 0 0 0s0 0 0 0l64-64s0 0 0 0s0 0 0 0l64-64s0 0 0 0s0 0 0 0z'
      
    ]
  };

  

  
  

  var faCloudMinus = {
    prefix: 'fat',
    iconName: 'cloud-minus',
    icon: [
      640,
      512,
      [],
      'e35d',
      
      'M522.7 220.8c3.4-8.9 5.3-18.6 5.3-28.8c0-44.2-35.8-80-80-80c-16.5 0-31.7 5-44.4 13.5c-3.7 2.5-8.2 3.3-12.5 2.3s-8-3.8-10.2-7.6C355.9 77 309.3 48 256 48c-79.5 0-144 64.5-144 144c0 2.5 .1 4.9 .2 7.3c.4 7.1-4 13.5-10.7 15.9C51.7 232.7 16 280.2 16 336c0 70.7 57.3 128 128 128H512c61.9 0 112-50.1 112-112c0-54.2-38.5-99.4-89.6-109.8c-4.6-.9-8.6-3.9-10.9-8s-2.6-9.1-.9-13.4zM256 32c53.6 0 101 26.3 130 66.7c3.1 4.3 6 8.8 8.7 13.4c3.5-2.4 7.2-4.5 11-6.4C418.5 99.5 432.8 96 448 96c53 0 96 43 96 96c0 6.6-.7 13-1.9 19.2c-1.1 5.3-2.6 10.5-4.5 15.4c5.3 1.1 10.5 2.5 15.5 4.2C603.6 247.9 640 295.7 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160zM224 280H416c4.4 0 8 3.6 8 8s-3.6 8-8 8H224c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faTrafficLight = {
    prefix: 'fat',
    iconName: 'traffic-light',
    icon: [
      320,
      512,
      [128678],
      'f637',
      
      'M64 16C37.5 16 16 37.5 16 64V352c0 79.5 64.5 144 144 144s144-64.5 144-144V64c0-26.5-21.5-48-48-48H64zM0 64C0 28.7 28.7 0 64 0H256c35.3 0 64 28.7 64 64V352c0 88.4-71.6 160-160 160S0 440.4 0 352V64zM120 392a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm96 0a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zM160 216a40 40 0 1 0 0 80 40 40 0 1 0 0-80zm0 96a56 56 0 1 1 0-112 56 56 0 1 1 0 112zM120 120a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm96 0a56 56 0 1 1 -112 0 56 56 0 1 1 112 0z'
      
    ]
  };

  

  
  

  var faCloudMusic = {
    prefix: 'fat',
    iconName: 'cloud-music',
    icon: [
      640,
      512,
      [],
      'f8ae',
      
      'M522.7 220.8c3.4-8.9 5.3-18.6 5.3-28.8c0-44.2-35.8-80-80-80c-16.5 0-31.7 5-44.4 13.5c-3.7 2.5-8.2 3.3-12.5 2.3s-8-3.8-10.2-7.6C355.9 77 309.3 48 256 48c-79.5 0-144 64.5-144 144c0 2.5 .1 4.9 .2 7.3c.4 7.1-4 13.5-10.7 15.9C51.7 232.7 16 280.2 16 336c0 70.7 57.3 128 128 128H512c61.9 0 112-50.1 112-112c0-54.2-38.5-99.4-89.6-109.8c-4.6-.9-8.6-3.9-10.9-8s-2.6-9.1-.9-13.4zM256 32c53.6 0 101 26.3 130 66.7c3.1 4.3 6 8.8 8.7 13.4c3.5-2.4 7.2-4.5 11-6.4C418.5 99.5 432.8 96 448 96c53 0 96 43 96 96c0 6.6-.7 13-1.9 19.2c-1.1 5.3-2.6 10.5-4.5 15.4c5.3 1.1 10.5 2.5 15.5 4.2C603.6 247.9 640 295.7 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160zM412.6 185.4c2.2 1.5 3.4 4 3.4 6.6V344l0 0c0 22.1-21.5 40-48 40s-48-17.9-48-40s21.5-40 48-40c12.3 0 23.5 3.9 32 10.2V203.5l-112 42V376l0 0c0 22.1-21.5 40-48 40c-26.5 0-48-17.9-48-40s21.5-40 48-40c12.3 0 23.5 3.9 32 10.2V240c0-3.3 2.1-6.3 5.2-7.5l128-48c2.5-.9 5.2-.6 7.4 .9zM368 320c-20.5 0-32 13.4-32 24s11.5 24 32 24s32-13.4 32-24s-11.5-24-32-24zM240 352c-20.5 0-32 13.4-32 24s11.5 24 32 24s32-13.4 32-24s-11.5-24-32-24z'
      
    ]
  };

  

  
  

  var faDownToDottedLine = {
    prefix: 'fat',
    iconName: 'down-to-dotted-line',
    icon: [
      448,
      512,
      [],
      'e408',
      
      'M216 368.3c2.1 2.1 5 3.3 8 3.3s5.9-1.2 8-3.3L363.8 236.2c2.7-2.7 4.2-6.4 4.2-10.2c0-8-6.5-14.4-14.4-14.4l-73.6 0c-4.4 0-8-3.6-8-8l0-136c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16l0 136c0 4.4-3.6 8-8 8l-73.6 0c-8 0-14.4 6.5-14.4 14.4c0 3.8 1.5 7.5 4.2 10.2L216 368.3zm8 19.3c-7.2 0-14.2-2.9-19.3-8L72.9 247.5C67.2 241.8 64 234.1 64 226c0-16.8 13.6-30.4 30.4-30.4l65.6 0 0-128c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 128 65.6 0c16.8 0 30.4 13.6 30.4 30.4c0 8.1-3.2 15.8-8.9 21.5L243.3 379.6c-5.1 5.1-12.1 8-19.3 8zM416 448a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM32 448a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm304 16a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM224 448a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-80 16a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z'
      
    ]
  };

  

  
  

  var faFaceExpressionless = {
    prefix: 'fat',
    iconName: 'face-expressionless',
    icon: [
      512,
      512,
      [],
      'e373',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm160 80H352c4.4 0 8 3.6 8 8s-3.6 8-8 8H160c-4.4 0-8-3.6-8-8s3.6-8 8-8zM128 200c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H136c-4.4 0-8-3.6-8-8zm168-8h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H296c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faBabyCarriage = {
    prefix: 'fat',
    iconName: 'baby-carriage',
    icon: [
      512,
      512,
      ["carriage-baby"],
      'f77d',
      
      'M122.1 24c-2.4-3.4-6.5-4.2-9.5-2.4C60.9 52.3 24.5 106 17.3 168.6c-.5 4.2-3.9 7.4-8.1 7.4c-4.7 0-8.3-4-7.8-8.6C8.9 99.5 48.4 41.2 104.5 7.8c10.8-6.4 24.1-2.7 30.8 7.1L238.2 163.4c3.7 5.3-.1 12.6-6.6 12.6c-2.6 0-5.1-1.3-6.6-3.4L122.1 24zM80 496a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm288 80a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm96-288c-8.8 0-16 7.2-16 16l0 64c0 5.3-.2 10.7-.7 16c-4.2 49-27.4 96.2-64.9 131.1C340.8 393.7 282.8 416 224 416s-116.8-22.3-158.4-60.9C28.1 320.2 4.9 273 .7 224c-.8-8.8 6.5-16 15.3-16l208 0 208 0 0-64c0-17.7 14.3-32 32-32l40 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-40 0zM76.5 343.4C115 379.1 169 400 224 400s109-20.9 147.5-56.6c34.4-31.9 55.6-74.9 59.8-119.4L224 224 16.7 224c4.1 44.5 25.4 87.5 59.7 119.4z'
      
    ]
  };

  
    var faCarriageBaby = faBabyCarriage;
  

  
  

  var faRadio = {
    prefix: 'fat',
    iconName: 'radio',
    icon: [
      512,
      512,
      [128251],
      'f8d7',
      
      'M506.1 15.7c4.3-1.2 6.8-5.6 5.6-9.8s-5.6-6.8-9.8-5.6L53 123.4c-26.4 7.2-46 28.7-51.4 54.7C.5 182.6 0 187.2 0 192v.8V240 448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H96.6L506.1 15.7zM16 192.8c0-3.8 .4-7.6 1.1-11.2C21.9 160.1 41.1 144 64 144H448c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V240 192.8zM352 400a80 80 0 1 1 0-160 80 80 0 1 1 0 160zm0-176a96 96 0 1 0 0 192 96 96 0 1 0 0-192zM88 240c-4.4 0-8 3.6-8 8s3.6 8 8 8H200c4.4 0 8-3.6 8-8s-3.6-8-8-8H88zM72 312c-4.4 0-8 3.6-8 8s3.6 8 8 8H216c4.4 0 8-3.6 8-8s-3.6-8-8-8H72zm16 72c-4.4 0-8 3.6-8 8s3.6 8 8 8H200c4.4 0 8-3.6 8-8s-3.6-8-8-8H88z'
      
    ]
  };

  

  
  

  var faEllipsisStroke = {
    prefix: 'fat',
    iconName: 'ellipsis-stroke',
    icon: [
      512,
      512,
      ["ellipsis-h-alt"],
      'f39b',
      
      'M416 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-80a48 48 0 1 0 0 96 48 48 0 1 0 0-96zM256 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-80a48 48 0 1 0 0 96 48 48 0 1 0 0-96zM128 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-80 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z'
      
    ]
  };

  
    var faEllipsisHAlt = faEllipsisStroke;
  

  
  

  var faBatteryQuarter = {
    prefix: 'fat',
    iconName: 'battery-quarter',
    icon: [
      576,
      512,
      ["battery-2"],
      'f243',
      
      'M448 112c35.3 0 64 28.7 64 64v16 16 96 16 16c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V176c0-35.3 28.7-64 64-64H448zm80 224V320h16c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H528V176c0-44.2-35.8-80-80-80H80C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H448c44.2 0 80-35.8 80-80zm0-32V208h16c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H528zM112 176h32c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V208c0-17.7 14.3-32 32-32zM64 208v96c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V208c0-26.5-21.5-48-48-48H112c-26.5 0-48 21.5-48 48z'
      
    ]
  };

  
    var faBattery2 = faBatteryQuarter;
  

  
  

  var faVideoSlash = {
    prefix: 'fat',
    iconName: 'video-slash',
    icon: [
      640,
      512,
      [],
      'f4e2',
      
      'M13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7zM416 202.9V175.2 128c0-35.3-28.7-64-64-64H180.1l20.3 16H352c26.5 0 48 21.5 48 48v74.9 34.7l16 12.6V202.9zM48 128c0-1.7 .1-3.4 .3-5L34.1 111.8C32.7 117 32 122.4 32 128V384c0 35.3 28.7 64 64 64H352c26.4 0 49-16 58.8-38.8l-13.2-10.4C391.4 418.1 373.3 432 352 432H96c-26.5 0-48-21.5-48-48V128zM592 377.8c0 3.5-.8 6.7-2.2 9.6l12.7 10.1c3.5-5.8 5.5-12.5 5.5-19.7V134.2c0-21.1-17.1-38.2-38.2-38.2c-6.4 0-12.8 1.6-18.4 4.7L448 157.6v18.3l111.1-61.1c3.3-1.8 7-2.7 10.7-2.7c12.3 0 22.2 9.9 22.2 22.2V377.8z'
      
    ]
  };

  

  
  

  var faFrame = {
    prefix: 'fat',
    iconName: 'frame',
    icon: [
      448,
      512,
      [],
      'e495',
      
      'M448 104c0-4.4-3.6-8-8-8l-56 0 0-56c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 56L80 96l0-56c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 56L8 96c-4.4 0-8 3.6-8 8s3.6 8 8 8l56 0 0 288L8 400c-4.4 0-8 3.6-8 8s3.6 8 8 8l56 0 0 56c0 4.4 3.6 8 8 8s8-3.6 8-8l0-56 288 0 0 56c0 4.4 3.6 8 8 8s8-3.6 8-8l0-56 56 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-56 0 0-288 56 0c4.4 0 8-3.6 8-8zM80 400l0-288 288 0 0 288L80 400z'
      
    ]
  };

  

  
  

  var faComputerClassic = {
    prefix: 'fat',
    iconName: 'computer-classic',
    icon: [
      448,
      512,
      [],
      'f8b1',
      
      'M384 16c26.5 0 48 21.5 48 48V368c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H384zM64 0C28.7 0 0 28.7 0 64V368c0 23.7 12.9 44.4 32 55.4V480c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V423.4c19.1-11.1 32-31.7 32-55.4V64c0-35.3-28.7-64-64-64H64zM400 430v50c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V430c5.1 1.3 10.5 2 16 2H384c5.5 0 10.9-.7 16-2zM352 80c8.8 0 16 7.2 16 16V240c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H352zM96 64C78.3 64 64 78.3 64 96V240c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H96zM224 344c0 4.4 3.6 8 8 8H376c4.4 0 8-3.6 8-8s-3.6-8-8-8H232c-4.4 0-8 3.6-8 8zM80 368a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faPumpSoap = {
    prefix: 'fat',
    iconName: 'pump-soap',
    icon: [
      448,
      512,
      [],
      'e06b',
      
      'M128 40c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40V56h60.1c14.9 0 29.1 5.9 39.6 16.4l41.9 41.9c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L344.4 83.7C336.9 76.2 326.7 72 316.1 72H256v56H240V40c0-13.3-10.7-24-24-24H168c-13.3 0-24 10.7-24 24v88H128V40zM69.6 220L50.9 444c-2.3 28 19.8 52 47.8 52H285.2c28.1 0 50.2-24 47.8-52L314.4 220c-2.1-24.9-22.9-44-47.8-44H117.4c-25 0-45.8 19.1-47.8 44zm-15.9-1.3c2.8-33.2 30.5-58.7 63.8-58.7H266.6c33.3 0 61 25.5 63.8 58.7l18.7 224c3.1 37.3-26.3 69.3-63.8 69.3H98.8c-37.4 0-66.9-32-63.8-69.3l18.7-224zm133.8 48.1l-38.4 74.7c-3.3 6.5-5.1 13.6-5.1 20.9c0 25.2 20.4 45.7 45.7 45.7h4.7c25.2 0 45.7-20.4 45.7-45.7c0-7.3-1.7-14.4-5.1-20.9l-38.4-74.7c-.9-1.7-2.6-2.8-4.5-2.8s-3.7 1.1-4.5 2.8zM192 248c7.9 0 15.2 4.4 18.8 11.5l38.4 74.7c4.5 8.7 6.8 18.4 6.8 28.2c0 34.1-27.6 61.7-61.7 61.7h-4.7c-34.1 0-61.7-27.6-61.7-61.7c0-9.8 2.3-19.5 6.8-28.2l38.4-74.7c3.6-7 10.9-11.5 18.8-11.5z'
      
    ]
  };

  

  
  

  var faCarRear = {
    prefix: 'fat',
    iconName: 'car-rear',
    icon: [
      512,
      512,
      ["car-alt"],
      'f5de',
      
      'M167.6 48H344.4c24.7 0 46.5 16.2 53.6 39.9L429.2 192H82.8L114 87.9C121.1 64.2 142.9 48 167.6 48zm-69 35.3l-33 110C28.3 200 0 232.7 0 272v80c0 20.9 13.4 38.7 32 45.3V400v48c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V400H384v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V400v-2.7c18.6-6.6 32-24.4 32-45.3V272c0-39.3-28.3-72-65.7-78.7l-33-110c-9.1-30.5-37.2-51.3-69-51.3H167.6c-31.8 0-59.8 20.9-69 51.3zM464 384H400 384 128 112 48c-17.7 0-32-14.3-32-32V336H72c13.3 0 24-10.7 24-24V280c0-13.3-10.7-24-24-24H18c7.1-27.6 32.2-48 62-48H432c29.8 0 54.9 20.4 62 48H440c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h56v16c0 17.7-14.3 32-32 32zm-64 16h64v48c0 8.8-7.2 16-16 16H416c-8.8 0-16-7.2-16-16V400zM48 448V400h64v48c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM496 272v48H440c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h56zM16 320V272H72c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H16zm200-16h80c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H216c-4.4 0-8-3.6-8-8V312c0-4.4 3.6-8 8-8zm-24 8v16c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V312c0-13.3-10.7-24-24-24H216c-13.3 0-24 10.7-24 24z'
      
    ]
  };

  
    var faCarAlt = faCarRear;
  

  
  

  var faRetweet = {
    prefix: 'fat',
    iconName: 'retweet',
    icon: [
      576,
      512,
      [],
      'f079',
      
      'M176 164.7c0 6.2-5.1 11.3-11.3 11.3L104 176H88l-60.7 0c-6.2 0-11.3-5.1-11.3-11.3c0-3 1.2-5.9 3.3-8L96 80l76.7 76.7c2.1 2.1 3.3 5 3.3 8zM27.3 192L88 192V344c0 39.8 32.2 72 72 72H312c4.4 0 8-3.6 8-8s-3.6-8-8-8H160c-30.9 0-56-25.1-56-56V192l60.7 0c15.1 0 27.3-12.2 27.3-27.3c0-7.2-2.9-14.2-8-19.3L107.3 68.7c-3-3-7.1-4.7-11.3-4.7s-8.3 1.7-11.3 4.7L8 145.4c-5.1 5.1-8 12.1-8 19.3C0 179.8 12.2 192 27.3 192zM400 347.3c0-6.2 5.1-11.3 11.3-11.3H472h16l60.7 0c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8L480 432l-76.7-76.7c-2.1-2.1-3.3-5-3.3-8zM548.7 320L488 320V168c0-39.8-32.2-72-72-72H264c-4.4 0-8 3.6-8 8s3.6 8 8 8H416c30.9 0 56 25.1 56 56V320H411.3c-15.1 0-27.3 12.2-27.3 27.3c0 7.2 2.9 14.2 8 19.3l76.7 76.7c3 3 7.1 4.7 11.3 4.7s8.3-1.7 11.3-4.7L568 366.6c5.1-5.1 8-12.1 8-19.3c0-15.1-12.2-27.3-27.3-27.3z'
      
    ]
  };

  

  
  

  var faClockFive = {
    prefix: 'fat',
    iconName: 'clock-five',
    icon: [
      512,
      512,
      [],
      'e349',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM264 104V253.6l62.7 94c2.5 3.7 1.5 8.6-2.2 11.1s-8.6 1.5-11.1-2.2l-64-96c-.9-1.3-1.3-2.9-1.3-4.4V104c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faSignalWeak = {
    prefix: 'fat',
    iconName: 'signal-weak',
    icon: [
      640,
      512,
      ["signal-1"],
      'f68c',
      
      'M64 384c4.4 0 8 3.6 8 8V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V392c0-4.4 3.6-8 8-8z'
      
    ]
  };

  
    var faSignal1 = faSignalWeak;
  

  
  

  var faChevronRight = {
    prefix: 'fat',
    iconName: 'chevron-right',
    icon: [
      320,
      512,
      [9002],
      'f054',
      
      'M301.7 250.3c3.1 3.1 3.1 8.2 0 11.3l-216 216c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L284.7 256 74.3 45.7c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l216 216z'
      
    ]
  };

  

  
  

  var faGenderless = {
    prefix: 'fat',
    iconName: 'genderless',
    icon: [
      384,
      512,
      [],
      'f22d',
      
      'M192 96a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 336a176 176 0 1 0 0-352 176 176 0 1 0 0 352z'
      
    ]
  };

  

  
  

  var faBriefcaseMedical = {
    prefix: 'fat',
    iconName: 'briefcase-medical',
    icon: [
      512,
      512,
      [],
      'f469',
      
      'M168 16H344c13.3 0 24 10.7 24 24V96H144V40c0-13.3 10.7-24 24-24zM128 40V96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H384V40c0-22.1-17.9-40-40-40H168c-22.1 0-40 17.9-40 40zm8 72H376h72c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V160c0-26.5 21.5-48 48-48h72zm96 88c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H288c-4.4 0-8 3.6-8 8v56c0 4.4-3.6 8-8 8H240c-4.4 0-8-3.6-8-8V320c0-4.4-3.6-8-8-8H168c-4.4 0-8-3.6-8-8V272c0-4.4 3.6-8 8-8h56c4.4 0 8-3.6 8-8V200zm8-24c-13.3 0-24 10.7-24 24v48H168c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h48v48c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V328h48c13.3 0 24-10.7 24-24V272c0-13.3-10.7-24-24-24H296V200c0-13.3-10.7-24-24-24H240z'
      
    ]
  };

  

  
  

  var faTurntable = {
    prefix: 'fat',
    iconName: 'turntable',
    icon: [
      576,
      512,
      [],
      'f8e4',
      
      'M512 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 400a144 144 0 1 1 0-288 144 144 0 1 1 0 288zM64 256a160 160 0 1 0 320 0A160 160 0 1 0 64 256zm144 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM512 104c0-4.4-3.6-8-8-8s-8 3.6-8 8V256.4c0 3.7-.9 7.4-2.5 10.7l-22.8 45.5c-13.9-3-28.7 3.6-35.3 17l-16 32c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l16-32c7.9-15.8 1.5-35-14.3-42.9c-.9-.5-1.9-.9-2.8-1.2c.9 .4 1.9 .8 2.8 1.2c2.5 1.2 4.7 2.7 6.7 4.5l22.8-45.5c2.8-5.6 4.2-11.7 4.2-17.9V104zM471.2 329.7c7.9 4 11.1 13.6 7.2 21.5l-16 32c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l16-32c4-7.9 13.6-11.1 21.5-7.2z'
      
    ]
  };

  

  
  

  var faPersonToDoor = {
    prefix: 'fat',
    iconName: 'person-to-door',
    icon: [
      576,
      512,
      [58704],
      'e433',
      
      'M172.2 148.1c4.2 1.2 7.7 4.1 9.8 7.9s2.4 8.4 1 12.5L152.8 259c-7 21 1.3 44.1 20.1 55.9l86.2 53.9c6 3.8 8.9 11.1 6.9 18l-25.4 88.8c-2.4 8.5 2.5 17.4 11 19.8s17.4-2.5 19.8-11l25.4-88.8c5.9-20.6-2.6-42.6-20.7-53.9l-47.9-30c-6.5-4.1-9.2-12.2-6.4-19.4l30-77.3c2.3-5.9 7.8-9.9 14.2-10.2s12.2 3.2 15.1 8.8l15.9 31.7c8.1 16.3 24.8 26.5 42.9 26.5H384c8.8 0 16-7.2 16-16s-7.2-16-16-16H339.8c-6.1 0-11.6-3.4-14.3-8.8l-32.9-65.7c-6-12-16.8-21-29.7-24.7l-90.7-25.9c-6.6-1.9-13.4-2.8-20.3-2.8c-19.6 0-38.3 7.8-52.1 21.6L68.7 164.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l31.1-31.1c7.8-7.8 18.4-12.2 29.5-12.2c3.9 0 7.7 .5 11.5 1.6l8.8 2.5zM57.4 153.4l31.1-31.1C105.3 105.5 128.1 96 151.9 96c8.3 0 16.6 1.2 24.7 3.5l90.7 25.9c17.2 4.9 31.6 16.9 39.7 32.9L339.8 224H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H339.8c-24.2 0-46.4-13.7-57.2-35.4l-6.2-12.4-9.7-19.3L258.8 241l-22.2 57.1 47.9 30c24.2 15.1 35.5 44.4 27.6 71.9l-25.4 88.8c-4.9 17-22.6 26.8-39.6 22s-26.8-22.6-22-39.6l25.4-88.8-86.2-53.9c-25.1-15.7-36.1-46.5-26.8-74.5l25.1-75.3 5.1-15.2L159 161c-2.2-.6-4.6-1-6.9-1l-.2 0c-6.8 0-13.4 2.7-18.2 7.5l-31.1 31.1c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3zM272 80a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM224 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM111.3 314.8c2.9 6.2 6.4 12.1 10.6 17.6l-9.2 25.2L108.8 368H97.6 32c-8.8 0-16 7.2-16 16s7.2 16 16 16H97.6c20.1 0 38.1-12.6 45.1-31.5l4.7-12.9 0 0 13.9 8.7-3.6 9.7c-9.2 25.2-33.2 42-60.1 42H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H97.6l13.7-37.2zM528 16H432c-17.7 0-32 14.3-32 32V192H384V48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H432c-26.5 0-48-21.5-48-48V320h16V464c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V48c0-17.7-14.3-32-32-32z'
      
    ]
  };

  

  
  

  var faDisease = {
    prefix: 'fat',
    iconName: 'disease',
    icon: [
      512,
      512,
      [],
      'f7fa',
      
      'M240.3 84.4c-24.8 37.2-69.1 56.4-113.2 49.1l-59.6-9.9C40.6 119 16 139.8 16.1 167.1c0 11.7 4.7 22.9 12.9 31.2l29.2 29.2c14 14 21.9 33 21.9 52.8c0 20.1-8.1 39.4-22.5 53.4L44.5 346.5C36.5 354.3 32 365 32 376.2c0 26.6 24.6 46.3 50.6 40.6L144.9 403c8.9-2 18-3 27.1-3h10c30.9 0 60.8 10.5 85 29.8l30.9 24.7c7.7 6.1 17.2 9.5 27 9.5c23.9 0 43.3-19.4 43.3-43.3l0-25.2c0-41.5 25.5-78.7 64.1-93.7L469 287.5c16.3-6.3 27-22 27-39.4c0-20.4-14.6-37.9-34.7-41.6l-28-5.1c-42.8-7.8-76.8-40.5-86.3-82.9L340 87c-5.1-22.8-25.4-39-48.7-39c-16.7 0-32.3 8.3-41.5 22.2l-9.4 14.1zM227 75.5l9.4-14.1C248.7 43 269.2 32 291.3 32c30.9 0 57.6 21.4 64.3 51.5l7.1 31.5c8.1 36.2 37.1 64 73.6 70.7l28 5.1c27.7 5.1 47.8 29.2 47.8 57.3c0 24.1-14.8 45.6-37.2 54.3L438 316.7c-32.5 12.6-53.9 43.9-53.9 78.8l0 25.2c0 32.7-26.5 59.3-59.3 59.3c-13.5 0-26.5-4.6-37-13l-30.9-24.7c-21.3-17-47.7-26.3-75-26.3h-10c-7.9 0-15.8 .9-23.6 2.6L86.1 432.4c-36 8-70.1-19.4-70.1-56.2c0-15.5 6.2-30.3 17.3-41.2l13.1-12.8c11.3-11 17.7-26.2 17.7-42c0-15.6-6.2-30.5-17.2-41.5L17.7 209.6C6.4 198.3 .1 183 .1 167.1c0-37.2 33.4-65.5 70.1-59.4l59.6 9.9c37.9 6.3 76-10.2 97.3-42.1zM304 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM120 224a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm40 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm128 32a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faNotdef = {
    prefix: 'fat',
    iconName: 'notdef',
    icon: [
      384,
      512,
      [],
      'e1fe',
      
      'M32 16c-1.9 0-3.7 .3-5.4 .9L192 242.5 357.4 16.9c-1.7-.6-3.5-.9-5.4-.9H32zM367.8 29.7L201.9 256 367.8 482.3c.1-.7 .2-1.5 .2-2.3V32c0-.8-.1-1.5-.2-2.3zM182.1 256L16.2 29.7c-.1 .7-.2 1.5-.2 2.3V480c0 .8 .1 1.5 .2 2.3L182.1 256zM26.6 495.1c1.7 .6 3.5 .9 5.4 .9H352c1.9 0 3.7-.3 5.4-.9L192 269.5 26.6 495.1zM0 32C0 14.3 14.3 0 32 0H352c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V32z'
      
    ]
  };

  

  
  

  var faTrashCanUndo = {
    prefix: 'fat',
    iconName: 'trash-can-undo',
    icon: [
      448,
      512,
      ["trash-can-arrow-turn-left","trash-undo-alt"],
      'f896',
      
      'M157.4 27.3L134.4 64H313.6l-23-36.7c-4.4-7-12.1-11.3-20.4-11.3H177.7c-8.3 0-16 4.3-20.4 11.3zM115.6 64l28.2-45.2C151.1 7.1 163.9 0 177.7 0h92.5c13.8 0 26.6 7.1 33.9 18.8L332.4 64H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H115.6zM40 112c4.4 0 8 3.6 8 8V440c0 30.9 25.1 56 56 56H344c30.9 0 56-25.1 56-56V120c0-4.4 3.6-8 8-8s8 3.6 8 8V440c0 39.8-32.2 72-72 72H104c-39.8 0-72-32.2-72-72V120c0-4.4 3.6-8 8-8zm173.9 74.6c3 3.3 2.7 8.3-.5 11.3L140.7 264H248c39.8 0 72 32.2 72 72v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V336c0-30.9-25.1-56-56-56H140.7l72.7 66.1c3.3 3 3.5 8 .5 11.3s-8 3.5-11.3 .5l-88-80c-1.7-1.5-2.6-3.7-2.6-5.9s1-4.4 2.6-5.9l88-80c3.3-3 8.3-2.7 11.3 .5z'
      
    ]
  };

  
    var faTrashCanArrowTurnLeft = faTrashCanUndo;
  
    var faTrashUndoAlt = faTrashCanUndo;
  

  
  

  var faFilterSlash = {
    prefix: 'fat',
    iconName: 'filter-slash',
    icon: [
      640,
      512,
      [],
      'e17d',
      
      'M13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7zM567.8 93.1c5.3-6.7 8.2-15 8.2-23.5C576 48.8 559.2 32 538.4 32H152.5l20.3 16H538.4c11.9 0 21.6 9.7 21.6 21.6c0 4.9-1.7 9.7-4.7 13.5L424.4 246.7l12.6 9.9L567.8 93.1zM368 385.6v68.3c0 5.6-4.5 10.1-10.1 10.1c-2.1 0-4.2-.7-5.9-1.9l-70.1-51c-6.2-4.5-9.9-11.7-9.9-19.4V309.8l-16-12.6v94.5c0 12.8 6.1 24.8 16.5 32.3l70.1 51c4.5 3.2 9.8 5 15.4 5c14.4 0 26.1-11.7 26.1-26.1V398.3l-16-12.6z'
      
    ]
  };

  

  
  

  var faTablePivot = {
    prefix: 'fat',
    iconName: 'table-pivot',
    icon: [
      512,
      512,
      [],
      'e291',
      
      'M64 48C37.5 48 16 69.5 16 96v64H128V48H64zM16 176V416c0 26.5 21.5 48 48 48h64V176H16zm128 0V464H448c26.5 0 48-21.5 48-48V176H144zm352-16V96c0-26.5-21.5-48-48-48H144V160H496zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM445.7 285.7c-3.1 3.1-8.2 3.1-11.3 0L408 259.3V336c0 22.1-17.9 40-40 40H291.3l26.3 26.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-40-40c-3.1-3.1-3.1-8.2 0-11.3l40-40c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L291.3 360H368c13.3 0 24-10.7 24-24V259.3l-26.3 26.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l40-40c3.1-3.1 8.2-3.1 11.3 0l40 40c3.1 3.1 3.1 8.2 0 11.3z'
      
    ]
  };

  

  
  

  var faHandLizard = {
    prefix: 'fat',
    iconName: 'hand-lizard',
    icon: [
      512,
      512,
      [],
      'f258',
      
      'M0 112C0 85.5 21.5 64 48 64H293.6c34.2 0 66.2 16.8 85.6 45L493.6 274.8c12 17.4 18.4 38 18.4 59V440c0 4.4-3.6 8-8 8s-8-3.6-8-8V333.9c0-17.8-5.4-35.3-15.6-50L366 118c-16.4-23.8-43.5-38-72.4-38H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H240c35.3 0 64 28.7 64 64s-28.7 64-64 64H112c-17.7 0-32 14.3-32 32s14.3 32 32 32H266.8c5.1 0 10 1.6 14.1 4.6l77.2 56.2c6.2 4.5 9.9 11.7 9.9 19.4V440c0 4.4-3.6 8-8 8s-8-3.6-8-8V416.1c0-2.6-1.2-5-3.3-6.5l-77.2-56.1c-1.4-1-3-1.5-4.7-1.5H112c-26.5 0-48-21.5-48-48s21.5-48 48-48H240c26.5 0 48-21.5 48-48s-21.5-48-48-48H48c-26.5 0-48-21.5-48-48z'
      
    ]
  };

  

  
  

  var faMoneyBillSimple = {
    prefix: 'fat',
    iconName: 'money-bill-simple',
    icon: [
      576,
      512,
      [],
      'e1f1',
      
      'M64 80c-26.5 0-48 21.5-48 48V384c0 26.5 21.5 48 48 48H512c26.5 0 48-21.5 48-48V128c0-26.5-21.5-48-48-48H64zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM368 256a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-176 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z'
      
    ]
  };

  

  
  

  var faClouds = {
    prefix: 'fat',
    iconName: 'clouds',
    icon: [
      640,
      512,
      [],
      'f744',
      
      'M312.8 72.4C324.8 67 338 64 352 64c53 0 96 43 96 96c0 11.3-1.9 22.1-5.5 32.1c-6.2 .3-12.2 1-18.1 2.1c4.9-10.4 7.6-22 7.6-34.2c0-44.2-35.8-80-80-80c-14.5 0-28.2 3.9-39.9 10.6c-2.1 1.2-4.7 1.4-7 .5s-4-2.9-4.7-5.2C289 45.5 252 16 208 16c-50.7 0-92.1 39.2-95.7 89c-.2 2.1-1.2 4.1-2.8 5.5s-3.8 2.1-5.9 1.9c-2.5-.2-5-.3-7.5-.3c-44.2 0-80 35.8-80 80s35.8 80 80 80h67.6c-1.2 5.2-2.1 10.6-2.7 16H96c-53 0-96-43-96-96s43-96 96-96l1.1 0C104.9 41.7 151.6 0 208 0c47.9 0 88.8 30.1 104.8 72.4zM526.7 316.8c.8-4.1 1.3-8.4 1.3-12.8c0-35.3-28.7-64-64-64c-19.5 0-36.9 8.7-48.6 22.4c-3.4 4-8.7 6.1-13.9 5.5s-9.9-3.8-12.4-8.5C373 228.8 340.9 208 304 208c-53 0-96 43-96 96c0 6.1 .6 12.1 1.7 17.8c1.5 7.9-3.1 15.6-10.7 18.2C167 350.5 144 380.6 144 416c0 44.2 35.8 80 80 80H544c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.4 0-.9 0-1.3 0c-4.8 .1-9.5-2-12.6-5.8s-4.3-8.7-3.4-13.4zM304 192c37.1 0 70 18.1 90.4 45.9c3.3 4.5 6.2 9.2 8.8 14.1c3.6-4.2 7.6-8 12-11.4C428.7 230.2 445.6 224 464 224c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c4.9 0 9.8 .4 14.5 1.1c46.2 7 81.5 46.8 81.5 94.9c0 53-43 96-96 96H224c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2c-1.3-6.7-1.9-13.7-1.9-20.8c0-61.9 50.1-112 112-112z'
      
    ]
  };

  

  
  

  var faBacteria = {
    prefix: 'fat',
    iconName: 'bacteria',
    icon: [
      640,
      512,
      [],
      'e059',
      
      'M311.3 19.2l-4.6 10.6c21.2 8.4 38.8 25.3 47.5 47.5l10.6-4.6c4.1-1.8 8.8 .1 10.5 4.1s-.1 8.8-4.1 10.5l-12.6 5.5c4.8 25.9-3 51.5-19.1 70.2l6.7 4.2c3.8 2.3 4.9 7.3 2.6 11s-7.3 4.9-11 2.6l-10.3-6.4c-9.3 7.2-20.3 12.6-32.6 15.4c-9.9 2.3-18.7 5-26.7 8.1l3.6 16.3c1 4.3-1.8 8.6-6.1 9.5s-8.6-1.8-9.5-6.1l-2.9-13c-25.5 13.2-39.5 30.2-47.8 44c-.8 1.4-1.6 2.7-2.4 4.1l8.3 3.9c4 1.9 5.7 6.7 3.8 10.7s-6.7 5.7-10.7 3.8l-8.2-3.9c-2.2 5.8-3.9 11.8-4.8 17.8c-1.9 17-8.7 32.3-18.9 44.6l9.2 9.8c3 3.2 2.9 8.3-.3 11.3s-8.3 2.9-11.3-.3l-9-9.5c-16.4 13.5-38 20.7-60.8 18.7c-2.6-.2-5.1-.6-7.6-1l-5.5 12.6c-1.8 4.1-6.5 5.9-10.5 4.1s-5.9-6.5-4.1-10.5l4.6-10.6c-21.9-8.6-39-26-47.5-47.5l-10.6 4.6c-4.1 1.8-8.8-.1-10.5-4.1s.1-8.8 4.1-10.5l12.6-5.5c-1.3-7.3-1.7-15-1-22.8c1.1-12.1 3.8-24.2 7-35.9c.9-3.3 1.9-6.7 3.1-10.4l-14-7c-4-2-5.6-6.8-3.6-10.7s6.8-5.6 10.7-3.6l12.2 6.1C45 193.3 52 178.1 61.5 162.3c3.2-5.4 6.8-10.8 10.5-16.3l-4.8-3.6c-3.5-2.7-4.3-7.7-1.6-11.2s7.7-4.3 11.2-1.6l4.7 3.6c13.4-17.1 29.8-33.8 49.5-49l-9.8-16c-2.3-3.8-1.1-8.7 2.6-11s8.7-1.1 11 2.6L144 74.7c18.1-12.5 38.8-23.7 62.4-32.9l-3.7-8.6c-1.7-4.1 .1-8.8 4.2-10.5s8.8 .1 10.5 4.2l4 9.4c11.3-3.8 23.2-7.2 35.7-10.1c11.6-2.7 23.1-2.8 34.1-.8l5.5-12.6c1.8-4.1 6.5-5.9 10.5-4.1s5.9 6.5 4.1 10.5zM192 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-80 80a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm47.6 27.4c0-.2 .1-.5 .1-.7c2.4-15.5 8.8-30.1 16.1-42.2c14-23.3 41.3-52.8 99.5-66.2c36.6-8.4 59.4-45 51-81.5s-45-59.4-81.5-51C163 64.3 106.2 118.8 75.2 170.5c-15 25.1-23.6 48.7-28.4 66.2c-3.1 11.1-5.5 22.3-6.5 33.1c-3.4 37.4 24.2 70.4 61.6 73.8c37 3.4 69.8-23.6 73.8-60.3zm157.2 220c-4.1-1.8-5.9-6.5-4.1-10.5l4.6-10.6c-21.2-8.4-38.8-25.3-47.5-47.5l-10.6 4.6c-4.1 1.8-8.8-.1-10.5-4.1s.1-8.8 4.1-10.5l12.6-5.5c-4.8-25.9 3-51.5 19.1-70.2l-6.7-4.2c-3.8-2.3-4.9-7.3-2.6-11s7.3-4.9 11-2.6l10.3 6.4c9.3-7.2 20.3-12.6 32.6-15.4c9.9-2.3 18.7-5 26.7-8.1l-3.6-16.3c-1-4.3 1.8-8.6 6.1-9.5s8.6 1.8 9.5 6.1l2.9 13c25.5-13.2 39.5-30.2 47.8-44c.8-1.4 1.6-2.7 2.4-4.1l-8.3-3.9c-4-1.9-5.7-6.7-3.8-10.7s6.7-5.7 10.7-3.8l8.2 3.9c2.2-5.8 3.9-11.8 4.8-17.8c1.8-17 8.7-32.3 18.9-44.6l-9.2-9.8c-3-3.2-2.9-8.3 .3-11.3s8.3-2.9 11.3 .3l9 9.5c16.4-13.5 38-20.7 60.8-18.7c2.6 .2 5.1 .6 7.6 1l5.5-12.6c1.8-4.1 6.5-5.9 10.5-4.1s5.9 6.5 4.1 10.5l-4.6 10.6c21.9 8.6 39 26 47.5 47.5l10.6-4.6c4.1-1.8 8.8 .1 10.5 4.1s-.1 8.8-4.1 10.5l-12.6 5.5c1.3 7.3 1.7 15 1 22.8c-1.1 12.1-3.8 24.2-7 35.9c-.9 3.3-1.9 6.7-3.1 10.4l14 7c4 2 5.6 6.8 3.6 10.7s-6.8 5.6-10.7 3.6l-12.2-6.1C595 318.7 588 334 578.5 349.7c-3.2 5.4-6.8 10.8-10.5 16.3l4.8 3.6c3.5 2.6 4.3 7.7 1.6 11.2s-7.7 4.3-11.2 1.6l-4.7-3.6c-13.4 17.1-29.8 33.8-49.5 49l9.8 16c2.3 3.8 1.1 8.7-2.6 11s-8.7 1.1-11-2.6L496 437.3c-18.1 12.5-38.8 23.7-62.4 32.9l3.7 8.6c1.7 4.1-.1 8.8-4.2 10.5s-8.8-.1-10.5-4.2l-4-9.4c-11.3 3.8-23.2 7.2-35.7 10.1c-11.6 2.7-23.1 2.8-34.1 .8l-5.5 12.6c-1.8 4.1-6.5 5.9-10.5 4.1zM432 384a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm48.4-123.4c0 .2-.1 .5-.1 .7c-2.4 15.5-8.8 30.1-16.1 42.2c-14 23.3-41.3 52.8-99.5 66.2c-36.6 8.4-59.4 45-51 81.5s45 59.4 81.5 51c97.7-22.6 154.5-77.1 185.5-128.8c15-25.1 23.6-48.7 28.4-66.2c3.1-11.1 5.5-22.3 6.5-33.1c3.4-37.4-24.2-70.4-61.6-73.8c-37-3.4-69.8 23.6-73.8 60.3z'
      
    ]
  };

  

  
  

  var faChevronLeft = {
    prefix: 'fat',
    iconName: 'chevron-left',
    icon: [
      320,
      512,
      [9001],
      'f053',
      
      'M18.3 250.3c-3.1 3.1-3.1 8.2 0 11.3l216 216c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L35.3 256 245.7 45.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-216 216z'
      
    ]
  };

  

  
  

  var faArrowLeftToArc = {
    prefix: 'fat',
    iconName: 'arrow-left-to-arc',
    icon: [
      512,
      512,
      [],
      'e616',
      
      'M16 256C16 123.5 123.5 16 256 16c4.4 0 8-3.6 8-8s-3.6-8-8-8C114.6 0 0 114.6 0 256S114.6 512 256 512c4.4 0 8-3.6 8-8s-3.6-8-8-8C123.5 496 16 388.5 16 256zM314.8 121.9l-152 128c-1.8 1.5-2.8 3.8-2.8 6.1s1 4.6 2.8 6.1l152 128c3.4 2.8 8.4 2.4 11.3-1s2.4-8.4-1-11.3L189.9 264H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H189.9L325.2 134.1c3.4-2.8 3.8-7.9 1-11.3s-7.9-3.8-11.3-1z'
      
    ]
  };

  

  
  

  var faNose = {
    prefix: 'fat',
    iconName: 'nose',
    icon: [
      448,
      512,
      [],
      'e5bd',
      
      'M183.1 4.3c-2-3.9-6.9-5.4-10.8-3.4s-5.4 6.9-3.4 10.8c71.9 138.2 170.2 242.2 224.9 293.9C417.4 328 432 358.5 432 390.5C432 448.8 384.8 496 326.5 496H291.3l-5.7-5.7-46.1-46.1c-18.1-18.1-42.6-28.2-68.2-28.2c-24 0-43.4 19.4-43.4 43.4V464c0 26.5 21.5 48 48 48H326.5C393.6 512 448 457.6 448 390.5c0-36.9-16.8-71.5-43.2-96.6c-54-51.1-150.9-153.6-221.7-289.7zm45.1 451.2L268.7 496H176c-17.7 0-32-14.3-32-32v-4.6c0-15.1 12.3-27.4 27.4-27.4c21.3 0 41.8 8.5 56.9 23.6zM121.7 303.8c4.3-.9 7.1-5.2 6.1-9.5s-5.2-7.1-9.5-6.1l-22.8 4.9C39.8 305 0 354.2 0 411.2C0 447 15.9 481 43.5 504l7.4 6.2c3.4 2.8 8.4 2.4 11.3-1s2.4-8.4-1-11.3l-7.4-6.2C29.8 471.8 16 442.3 16 411.2c0-49.4 34.5-92.1 82.8-102.5l22.8-4.9z'
      
    ]
  };

  

  
  

  var faHollyBerry = {
    prefix: 'fat',
    iconName: 'holly-berry',
    icon: [
      512,
      512,
      [],
      'f7aa',
      
      'M208 64a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 64A64 64 0 1 1 256 0a64 64 0 1 1 0 128zM112 257.3V312c0 30.9-25.1 56-56 56H45.1c-7.2 0-13.1 5.9-13.1 13.1c0 .9 .1 1.7 .3 2.6l3 15c3.4 17 2.8 34.7-1.8 51.4l-7 25.6c-1.6 6 3.9 11.5 9.8 9.8l25.6-7c16.8-4.6 34.4-5.2 51.4-1.8l9.9 2c4.2 .8 8.4 1.3 12.7 1.3c4.4 0 8-3.6 8-8V446.7c0-43.5 35.2-78.7 78.7-78.7c5.5 0 9.3-5.4 7.6-10.5L226 344.6c-7-21-7.6-43.6-1.8-64.9l5.3-19.4c1.6-6-3.9-11.5-9.8-9.8l-19.4 5.3c-21.3 5.8-43.9 5.2-64.9-1.8l-12.8-4.3c-5.2-1.7-10.5 2.1-10.5 7.6zm15.6-22.8l12.8 4.3c18 6 37.3 6.5 55.6 1.5l19.4-5.3c17.9-4.9 34.4 11.6 29.5 29.5L239.6 284c-5 18.3-4.4 37.6 1.5 55.6l4.3 12.8c5.2 15.5-6.4 31.6-22.8 31.6c-34.6 0-62.7 28.1-62.7 62.7V472c0 13.3-10.7 24-24 24c-5.3 0-10.6-.5-15.8-1.6l-9.9-2c-14.6-2.9-29.7-2.4-44.1 1.5l-25.6 7c-17.9 4.9-34.4-11.6-29.5-29.5l7-25.6c3.9-14.4 4.4-29.5 1.5-44.1l-3-15c-.4-1.9-.6-3.8-.6-5.7C16 365 29 352 45.1 352H56c22.1 0 40-17.9 40-40V257.3c0-16.4 16-27.9 31.6-22.8zM169.5 80.3c1 5.4 2.5 10.7 4.5 15.7c-25.6 1-46 22.1-46 48c0 26.5 21.5 48 48 48c25.8 0 46.9-20.4 48-46c5 2 10.3 3.5 15.7 4.5C236.4 182.8 209.2 208 176 208c-35.3 0-64-28.7-64-64c0-33.2 25.2-60.4 57.5-63.7zm102.8 70.2c5.4-1 10.7-2.5 15.7-4.5c1 25.6 22.1 46 48 46c26.5 0 48-21.5 48-48c0-25.8-20.4-46.9-46-48c2-5 3.5-10.3 4.5-15.7C374.8 83.6 400 110.8 400 144c0 35.3-28.7 64-64 64c-33.2 0-60.4-25.2-63.7-57.5zM400.9 257.3c0-5.5-5.4-9.3-10.5-7.6L377.5 254c-21 7-43.6 7.6-64.9 1.8l-19.4-5.3c-6-1.6-11.5 3.9-9.8 9.8l5.3 19.4c5.8 21.3 5.2 43.9-1.8 64.9l-4.3 12.8c-1.7 5.2 2.1 10.5 7.6 10.5c43.5 0 78.7 35.2 78.7 78.7V472c0 4.4 3.6 8 8 8c4.3 0 8.5-.4 12.7-1.3l9.9-2c17-3.4 34.7-2.8 51.4 1.8l25.6 7c6 1.6 11.5-3.8 9.8-9.8l-7-25.6c-4.6-16.8-5.2-34.4-1.8-51.4l3-15c.2-.8 .3-1.7 .3-2.6c0-7.2-5.9-13.1-13.1-13.1H456.9c-30.9 0-56-25.1-56-56V257.3zm-15.6-22.8c15.5-5.2 31.6 6.4 31.6 22.8V312c0 22.1 17.9 40 40 40h10.9c16.1 0 29.1 13 29.1 29.1c0 1.9-.2 3.8-.6 5.7l-3 15c-2.9 14.6-2.4 29.7 1.5 44.1l7 25.6c4.9 17.9-11.6 34.4-29.5 29.5l-25.6-7c-14.4-3.9-29.5-4.4-44.1-1.5l-9.9 2c-5.2 1-10.5 1.6-15.8 1.6c-13.3 0-24-10.7-24-24V446.7c0-34.6-28.1-62.7-62.7-62.7c-16.4 0-27.9-16-22.8-31.6l4.3-12.8c6-18 6.5-37.3 1.5-55.6L268 264.5c-4.9-17.9 11.6-34.4 29.5-29.5l19.4 5.3c18.3 5 37.6 4.4 55.6-1.5l12.8-4.3z'
      
    ]
  };

  

  
  

  var faLinkHorizontalSlash = {
    prefix: 'fat',
    iconName: 'link-horizontal-slash',
    icon: [
      640,
      512,
      ["chain-horizontal-slash"],
      'e1cc',
      
      'M13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7zM406.5 416H320c-61.9 0-112-50.1-112-112c0-13.8 2.5-27 7-39.1l-13.1-10.4c-6.4 15.2-9.9 31.9-9.9 49.5c0 70.7 57.3 128 128 128H426.7l-20.3-16zM432 208c0 13.8-2.5 27-7 39.1l13.1 10.4c6.4-15.2 9.9-31.9 9.9-49.5c0-70.7-57.3-128-128-128H213.3l20.3 16H320c61.9 0 112 50.1 112 112zM46.2 131.5l-12.6-9.9C12.7 144.4 0 174.7 0 208c0 70.7 57.3 128 128 128h24c4.4 0 8-3.6 8-8s-3.6-8-8-8H128C66.1 320 16 269.9 16 208c0-29.6 11.5-56.4 30.2-76.5zM640 304c0-70.7-57.3-128-128-128H488c-4.4 0-8 3.6-8 8s3.6 8 8 8h24c61.9 0 112 50.1 112 112c0 29.6-11.4 56.4-30.2 76.5l12.6 9.9C627.3 367.6 640 337.3 640 304z'
      
    ]
  };

  
    var faChainHorizontalSlash = faLinkHorizontalSlash;
  

  
  

  var faDrumstickBite = {
    prefix: 'fat',
    iconName: 'drumstick-bite',
    icon: [
      512,
      512,
      [],
      'f6d7',
      
      'M345.9 0C243.2 0 160 83.2 160 185.9v97c0 .6 0 1.2 0 1.8l-45.8 45.8c-3.1 3.1-9.6 3.6-15.7-.3C88.6 323.7 76.7 320 64 320c-35.3 0-64 28.7-64 64s28.7 64 64 64c0 35.3 28.7 64 64 64s64-28.7 64-64c0-12.7-3.7-24.6-10.1-34.6c-3.9-6.1-3.4-12.6-.3-15.7L227.3 352c.6 0 1.2 0 1.8 0h97c17 0 33.6-2.3 49.3-6.6c2.5-.7 4.6-2.6 5.4-5.1s.5-5.2-1.1-7.3c-12.4-17.1-19.7-38.2-19.7-61c0-57.4 46.6-104 104-104c13.1 0 25.6 2.4 37.1 6.8c2.4 .9 5.2 .6 7.4-.9s3.5-3.9 3.5-6.6l0-1.3C512 74.4 437.6 0 345.9 0zM208 348.7l-37.7 37.7c-10.3 10.3-8.2 25.8-1.8 35.6c4.8 7.5 7.6 16.4 7.6 25.9c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-8.7-7.3-16-16-16c-26.5 0-48-21.5-48-48s21.5-48 48-48c9.6 0 18.5 2.8 25.9 7.6c9.8 6.3 25.3 8.5 35.6-1.8L163.3 304c6.8 21.2 23.5 37.9 44.7 44.7zM176 185.9C176 92.1 252.1 16 345.9 16c79.6 0 144.7 61.9 149.8 140.2C485.6 153.5 475 152 464 152c-66.3 0-120 53.7-120 120c0 22.1 6 42.8 16.4 60.5c-11.1 2.3-22.5 3.5-34.3 3.5h-97c-29.3 0-53.1-23.8-53.1-53.1v-97z'
      
    ]
  };

  

  
  

  var faDinosaur = {
    prefix: 'fat',
    iconName: 'dinosaur',
    icon: [
      640,
      512,
      [],
      'e5fe',
      
      'M414.9 24.2C422.4 9.4 437.5 0 454.2 0h4.6C558.9 0 640 81.1 640 181.2v41.7c0 73.4-36.1 142.1-96.6 183.7L512 428.2V472c0 22.1-17.9 40-40 40H424c-22.1 0-40-17.9-40-40V459.1c-4.7 1.4-10.8 3.1-18.3 4.7c-12 2.7-27.5 5.3-45.9 6.9c-.3-5.4-1.3-10.8-2.8-15.8c18.2-1.4 33.4-4.1 45.2-6.7c8.8-1.9 15.5-3.9 20.1-5.3c2.3-.7 4-1.3 5.1-1.7c.6-.2 1-.4 1.2-.5l.2-.1c.9-.4 2-.6 3.1-.6c4.4 0 8 3.6 8 8v24c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V424c0-2.6 1.3-5.1 3.5-6.6l34.8-23.9C590.5 354.9 624 291.1 624 222.9V181.2C624 90 550 16 458.8 16h-4.6c-10.5 0-20.2 6-24.9 15.4c-4.8 9.6-13 17.1-22.9 21.1L403 53.8c-11.4 4.6-19 15.7-19 28c0 16.7 13.5 30.2 30.2 30.2H488c39.8 0 72 32.2 72 72v17.1c0 34.8-28.2 62.9-62.9 62.9c-12.7 0-25.2-3.9-35.7-11.1l-58.3-40.1c-34.9-24-76.2-36.8-118.6-36.8c-52.4 0-102.8 19.6-141.4 55L49.4 316.9C28.1 336.4 16 364 16 392.9C16 449.8 62.2 496 119.1 496H250.7c11.8 0 21.3-9.5 21.3-21.3c0-10.2-7.2-18.9-17.2-20.9L154.1 434C120.3 427.4 96 397.8 96 363.4V360c0-4.4 3.6-8 8-8s8 3.6 8 8v3.4c0 26.8 18.9 49.8 45.2 54.9l100.7 19.8c17.5 3.4 30.1 18.8 30.1 36.6c0 20.6-16.7 37.3-37.3 37.3H119.1C53.3 512 0 458.7 0 392.9c0-33.4 14-65.2 38.6-87.8l93.7-85.9c41.5-38.1 95.9-59.2 152.2-59.2c45.6 0 90.1 13.8 127.6 39.6l58.3 40.1c7.8 5.4 17.1 8.3 26.6 8.3c25.9 0 46.9-21 46.9-46.9V184c0-30.9-25.1-56-56-56H414.2c-25.5 0-46.2-20.7-46.2-46.2C368 63 379.5 46 397 39l3.4-1.3c6.3-2.5 11.5-7.3 14.6-13.4zM448 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faAngleUp = {
    prefix: 'fat',
    iconName: 'angle-up',
    icon: [
      448,
      512,
      [8963],
      'f106',
      
      'M218.3 146.3c3.1-3.1 8.2-3.1 11.3 0l176 176c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L224 163.3 53.7 333.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l176-176z'
      
    ]
  };

  

  
  

  var faMessageMinus = {
    prefix: 'fat',
    iconName: 'message-minus',
    icon: [
      512,
      512,
      ["comment-alt-minus"],
      'f4a7',
      
      'M176 416c0-8.8-7.2-16-16-16H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H309.3c-3.5 0-6.8 1.1-9.6 3.2L176 496V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h80 16v16 64c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm96 208c-4.4 0-8 3.6-8 8s3.6 8 8 8H352c4.4 0 8-3.6 8-8s-3.6-8-8-8H160z'
      
    ]
  };

  
    var faCommentAltMinus = faMessageMinus;
  

  
  

  var faFill = {
    prefix: 'fat',
    iconName: 'fill',
    icon: [
      512,
      512,
      [],
      'f575',
      
      'M45.7 2.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L139.7 119 30.6 228.1c-37.5 37.5-37.5 98.3 0 135.8L148.1 481.4c37.5 37.5 98.3 37.5 135.8 0L485.7 279.6c21.9-21.9 21.9-57.3 0-79.2L311.6 26.3c-21.9-21.9-57.3-21.9-79.2 0L151 107.7 45.7 2.3zM151 130.3l91.3 91.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L162.3 119l81.4-81.4c15.6-15.6 40.9-15.6 56.6 0L474.3 211.7c15.6 15.6 15.6 40.9 0 56.6L454.6 288H18.9c1.8-17.7 9.4-35 23-48.6L151 130.3zM41.9 352.6C28.4 339 20.7 321.7 18.9 304H438.6L272.6 470.1c-31.2 31.2-81.9 31.2-113.1 0L41.9 352.6z'
      
    ]
  };

  

  
  

  var faGlassHalf = {
    prefix: 'fat',
    iconName: 'glass-half',
    icon: [
      384,
      512,
      ["glass-half-empty","glass-half-full"],
      'e192',
      
      'M16.1 33.3C15.4 24 22.7 16 32.1 16H352c9.4 0 16.7 8 15.9 17.3L351.1 240H33L16.1 33.3zM34.3 256H349.7L333.2 459.2c-1.7 20.8-19 36.8-39.9 36.8H90.7c-20.8 0-38.2-16-39.9-36.8L34.3 256zM32.1 0C13.4 0-1.3 16 .2 34.6l34.7 426C37.3 489.6 61.6 512 90.7 512H293.3c29.2 0 53.4-22.4 55.8-51.4l34.7-426C385.4 16 370.7 0 352 0H32.1z'
      
    ]
  };

  
    var faGlassHalfEmpty = faGlassHalf;
  
    var faGlassHalfFull = faGlassHalf;
  

  
  

  var faMessageCode = {
    prefix: 'fat',
    iconName: 'message-code',
    icon: [
      512,
      512,
      [],
      'e1df',
      
      'M176 416c0-8.8-7.2-16-16-16H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H309.3c-3.5 0-6.8 1.1-9.6 3.2L176 496V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h80 16v16 64c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM213.7 141.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-72 72c-3.1 3.1-3.1 8.2 0 11.3l72 72c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L147.3 208l66.3-66.3zm96-11.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L364.7 208l-66.3 66.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l72-72c3.1-3.1 3.1-8.2 0-11.3l-72-72z'
      
    ]
  };

  

  
  

  var faSchoolFlag = {
    prefix: 'fat',
    iconName: 'school-flag',
    icon: [
      576,
      512,
      [],
      'e56e',
      
      'M400 16V80H296V32 16H400zM280 83.9L173.4 160H56c-30.9 0-56 25.1-56 56V456c0 30.9 25.1 56 56 56H224h16 96 16H520c30.9 0 56-25.1 56-56V216c0-30.9-25.1-56-56-56H402.6L313 96h87c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H296c-8.8 0-16 7.2-16 16V32 80v3.9zM288 368c26.5 0 48 21.5 48 48v80H240V416c0-26.5 21.5-48 48-48zM520 496H352V416c0-35.3-28.7-64-64-64s-64 28.7-64 64v80H56c-22.1 0-40-17.9-40-40V216c0-22.1 17.9-40 40-40H176c1.7 0 3.3-.5 4.6-1.5L288 97.8l107.4 76.7c1.4 1 3 1.5 4.6 1.5H520c22.1 0 40 17.9 40 40V456c0 22.1-17.9 40-40 40zM328 240a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zm-40-56a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM88 224c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H88zm-8 24c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H88c-4.4 0-8-3.6-8-8V248zm336 0v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H440c-13.3 0-24 10.7-24 24zm24-8h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H440c-4.4 0-8-3.6-8-8V248c0-4.4 3.6-8 8-8zM88 352c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V376c0-13.3-10.7-24-24-24H88zm-8 24c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H88c-4.4 0-8-3.6-8-8V376zm336 0v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V376c0-13.3-10.7-24-24-24H440c-13.3 0-24 10.7-24 24zm24-8h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H440c-4.4 0-8-3.6-8-8V376c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faTablet = {
    prefix: 'fat',
    iconName: 'tablet',
    icon: [
      448,
      512,
      ["tablet-android"],
      'f3fb',
      
      'M64 16C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H64zM0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM176 432h96c4.4 0 8 3.6 8 8s-3.6 8-8 8H176c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  
    var faTabletAndroid = faTablet;
  

  
  

  var faCommentQuote = {
    prefix: 'fat',
    iconName: 'comment-quote',
    icon: [
      512,
      512,
      [],
      'e14c',
      
      'M157.3 415c-5-1.8-10.6-1-14.9 2.1c-11 8-29.4 19.3-51.2 28.8C68.3 456 41.6 464 16 464l.1-.1 0 0 0 0 .3-.3 .1-.1c.4-.4 .9-.9 1.5-1.6c1.3-1.4 3.2-3.6 5.4-6.3l-12.2-10 12.2 10C28 450 34 442 40 432c10.7-17.9 21.4-42.1 23.6-69.9c.3-4.3-1.1-8.6-3.9-11.8C31.9 318.8 16 280.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-35.2 0-68.6-6.1-98.7-17zM4.7 452.7l0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0zM208 160c8.8 0 16 7.2 16 16v24 24c0 8.8-7.2 16-16 16H160c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48zm0 96c5.8 0 11.3-1.6 16-4.3V262c0 25.7-17.5 48.1-42.4 54.3l-15.5 3.9c-4.3 1.1-6.9 5.4-5.8 9.7s5.4 6.9 9.7 5.8l15.5-3.9c32.1-8 54.5-36.8 54.5-69.9V224 200 176c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32h48zm96-96h48c8.8 0 16 7.2 16 16v24 24c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16zm64 91.7V262c0 25.7-17.5 48.1-42.4 54.3l-15.5 3.9c-4.3 1.1-6.9 5.4-5.8 9.7s5.4 6.9 9.7 5.8l15.5-3.9c32.1-8 54.5-36.8 54.5-69.9V224 200 176c0-17.7-14.3-32-32-32H304c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32h48c5.8 0 11.3-1.6 16-4.3z'
      
    ]
  };

  

  
  

  var faCameraSlash = {
    prefix: 'fat',
    iconName: 'camera-slash',
    icon: [
      640,
      512,
      [],
      'e0d9',
      
      'M13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7zM576 366.4V160c0-35.3-28.7-64-64-64H435.1L424.7 64.8C418.2 45.2 399.8 32 379.2 32H260.8c-20.7 0-39 13.2-45.5 32.8l-4.4 13.3 13.4 10.5 6.3-18.8C234.8 56.8 247.1 48 260.8 48H379.2c13.8 0 26 8.8 30.4 21.9l12.2 36.6c1.1 3.3 4.1 5.5 7.6 5.5H512c26.5 0 48 21.5 48 48V353.7l16 12.6zM80 158.3L65.4 146.7C64.5 151 64 155.4 64 160V416c0 35.3 28.7 64 64 64H487.5l-20.3-16H128c-26.5 0-48-21.5-48-48V160c0-.6 0-1.1 0-1.7zM370.8 387.8l-14.1-11.1C345.4 381.4 333 384 320 384c-53 0-96-43-96-96c0-5.1 .4-10.2 1.2-15.1l-14.1-11.1c-2 8.4-3.1 17.2-3.1 26.2c0 61.9 50.1 112 112 112c18.3 0 35.6-4.4 50.8-12.2z'
      
    ]
  };

  

  
  

  var faCloudBoltSun = {
    prefix: 'fat',
    iconName: 'cloud-bolt-sun',
    icon: [
      640,
      512,
      ["thunderstorm-sun"],
      'f76e',
      
      'M137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1 13.4 112.2c-5.4 .9-10 4.5-12.1 9.6s-1.5 10.9 1.6 15.4L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6l56-39.2c-3.6-4-6.9-8.1-10-12.5l-40.6 28.5L128 400l-2.9-17.5-11.2-67.2c-1.1-6.7-6.4-12-13.2-13.2L33.5 290.9 16 288l10.2-14.5 39.4-56.3c3.9-5.5 3.9-12.8 0-18.4L26.2 142.5 16 128l17.5-2.9 67.2-11.2c6.7-1.1 12-6.4 13.2-13.2l11.2-67.2L128 16l14.5 10.2 56.3 39.4c5.5 3.9 12.8 3.9 18.4 0l56.3-39.4L288 16l2.9 17.5 8.4 50.4c4.8-3 9.7-5.7 14.9-8.1L303.8 13.4c-.9-5.4-4.5-10-9.6-12.1s-10.9-1.5-15.4 1.6L208 52.5 137.2 2.9zM208 112c-53 0-96 43-96 96c0 35.6 19.3 66.6 48 83.2c0-1.1 0-2.2 0-3.2c0-5.2 .3-10.3 .9-15.3C141 258.1 128 234.6 128 208c0-44.2 35.8-80 80-80c15.7 0 30.4 4.5 42.8 12.4c2.2-4.9 4.6-9.7 7.4-14.3c-14.6-9-31.8-14.1-50.2-14.1zm80 80c0-44.2 35.8-80 80-80c32 0 59.6 18.8 72.4 46c1.1 2.3 3.2 3.9 5.7 4.4s5.1-.2 6.9-1.9c11.4-10.3 26.4-16.5 42.9-16.5c35.3 0 64 28.7 64 64c0 7.5-1.3 14.7-3.7 21.4c-.8 2.4-.5 5 .9 7.1s3.7 3.4 6.2 3.5c33.7 1.8 60.5 29.7 60.5 63.9c0 35.3-28.7 64-64 64c-.7 0-1.5 0-2.2 0l0 0h-.3H544c0 5.5-.9 10.9-2.7 16h16c.9 0 1.8 0 2.6 0c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C433.4 114.6 402.8 96 368 96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.7c0 42.3 27.3 78.2 65.3 91c-1.4-5.8-1.6-11.7-.8-17.4C228 349.3 208 320.9 208 288c0-41.8 32.1-76.2 73.1-79.7c2.1-.2 4.1-1.2 5.5-2.8s2-3.8 1.8-5.9c-.2-2.5-.4-5-.4-7.6zM411.6 344.8c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6H496L336 496l52.4-104.8c2.5-5 2.2-10.9-.7-15.6s-8.1-7.6-13.6-7.6H304L464 240 411.6 344.8zm66.7-97.7c3.4-6.7 1.6-14.9-4.2-19.6s-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7h52.2 17.9l-8 16-44.4 88.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7H443.8 425.9l8-16 44.4-88.8z'
      
    ]
  };

  
    var faThunderstormSun = faCloudBoltSun;
  

  
  

  var faBellSlash = {
    prefix: 'fat',
    iconName: 'bell-slash',
    icon: [
      640,
      512,
      [61943,128277],
      'f1f6',
      
      'M386.2 400H127.7c-8.7 0-15.7-7-15.7-15.7c0-3.6 1.2-7 3.4-9.8l16.7-20.9c27.3-34.1 42.6-76.1 43.8-119.6L160 221.4v7.2c0 41.8-14.2 82.3-40.3 114.9l-16.7 20.9c-4.5 5.6-6.9 12.6-6.9 19.8c0 17.5 14.2 31.7 31.7 31.7H406.5l-20.3-16zM312 32.2c-39.9 2-76 18.5-102.9 44.5l12.7 10C247.5 62.7 282 48 320 48c79.5 0 144 64.5 144 144v36.6c0 18.9 2.7 37.6 7.9 55.5L495.7 303c-10.3-23.3-15.7-48.5-15.7-74.3V192c0-85.7-67.4-155.6-152-159.8l0-.2V8c0-4.4-3.6-8-8-8s-8 3.6-8 8V32l0 .2zM272 448c0-4.4-3.6-8-8-8s-8 3.6-8 8c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3c0-4.4-3.6-8-8-8s-8 3.6-8 8c0 12.7-5.1 24.9-14.1 33.9s-21.2 14.1-33.9 14.1s-24.9-5.1-33.9-14.1s-14.1-21.2-14.1-33.9zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  

  
  

  var faStoreLock = {
    prefix: 'fat',
    iconName: 'store-lock',
    icon: [
      640,
      512,
      [],
      'e4a6',
      
      'M534.1 112.4l0 0c9.7 15.4 11.9 32.8 8.3 48.6c5.3 .7 10.6 1.7 15.6 3.2c4.4-19.8 1.5-41.5-10.4-60.3L490.3 13.1C485.2 5 476.1 0 466.4 0H109.6C99.9 0 90.8 5 85.7 13.1L28.3 103.8c-26.5 42-8.2 98.6 35.7 115.3V264 376v64c0 39.8 32.2 72 72 72H392.6c-2.9-5-5.1-10.3-6.5-16H136c-30.9 0-56-25.1-56-56V376 264 223.2l.2 0c4 .5 8.1 .8 12.1 .8c20.3 0 38.7-6.8 53.4-18.1c4.3-3.3 8.2-6.9 11.8-10.9c3.6 3.9 7.5 7.6 11.8 10.8C184 217.2 202.5 224 222.7 224c20.3 0 38.7-6.8 53.4-18.1c4.3-3.3 8.2-6.9 11.8-10.9c3.6 3.9 7.5 7.6 11.8 10.8c14.7 11.3 33.2 18.1 53.4 18.1c20.3 0 38.8-6.8 53.4-18.1c4.3-3.3 8.2-6.9 11.8-10.9c3.6 3.9 7.5 7.6 11.8 10.8c1.6 1.3 3.3 2.5 5 3.6c3-4.5 6.3-8.7 9.9-12.6c-5.5-3.5-10.5-7.7-14.9-12.5c-3-3.3-7.3-5.2-11.9-5.2s-8.8 1.9-11.8 5.3c-13 14.4-31.9 23.7-53.3 23.7c-21.3 0-40.3-9.3-53.3-23.7c-3-3.4-7.3-5.3-11.9-5.3s-8.8 1.9-11.9 5.3c-13 14.4-31.9 23.7-53.3 23.7c-21.3 0-40.3-9.3-53.3-23.7c-3-3.4-7.3-5.3-11.9-5.3s-8.8 1.9-11.9 5.3c-13 14.4-31.9 23.7-53.3 23.7c-3.3 0-6.7-.2-10-.7c-42.3-5.7-64.6-56.8-40.5-95l0 0L99.2 21.7l0 0 0-.1c2.1-3.4 6.1-5.6 10.4-5.6H466.4c4.3 0 8.2 2.2 10.4 5.6l0 .1 57.3 90.7zM384 384V368H152c-4.4 0-8-3.6-8-8V256c0-4.4-3.6-8-8-8s-8 3.6-8 8V360c0 13.3 10.7 24 24 24H384zM528 208c26.5 0 48 21.5 48 48v64H480V256c0-26.5 21.5-48 48-48zm-64 48v64H448c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H592V256c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-16 80h16 16 96 16 16c8.8 0 16 7.2 16 16V480c0 8.8-7.2 16-16 16H448c-8.8 0-16-7.2-16-16V352c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faEyeDropperHalf = {
    prefix: 'fat',
    iconName: 'eye-dropper-half',
    icon: [
      512,
      512,
      [],
      'e173',
      
      'M211.8 159.1l11.3 11.3L341.6 288.9l11.3 11.3 25.4 25.4 0 0c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-14.1-14.1-11.3-11.3 11.3-11.3L482.8 170.4c39-39 39-102.2 0-141.1s-102.2-39-141.1 0L234.4 136.5l-11.3 11.3-11.3-11.3-14.1-14.1c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l25.4 25.4zm259.7 0L352.9 277.6 234.4 159.1 352.9 40.5c32.7-32.7 85.8-32.7 118.5 0l11-11-11 11c32.7 32.7 32.7 85.8 0 118.5zM197.7 205.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L53.1 327.6C39.6 341.1 32 359.4 32 378.5v51.1L4.4 470.9C1.5 475.3 0 480.4 0 485.6C0 500.2 11.8 512 26.4 512c5.2 0 10.3-1.5 14.7-4.4L82.4 480h51.1c19.1 0 37.4-7.6 50.9-21.1L317.7 325.7c2.3-2.3 3-5.7 1.7-8.7s-4.2-4.9-7.4-4.9H91.3L197.7 205.7zM64.4 338.9L75.3 328H292.7L173.1 447.6c-10.5 10.5-24.7 16.4-39.6 16.4H80 77.6l-2 1.3L32.2 494.2c-1.7 1.1-3.7 1.8-5.8 1.8c-5.8 0-10.4-4.7-10.4-10.4c0-2.1 .6-4.1 1.8-5.8l28.9-43.4 1.3-2V432 378.5c0-14.9 5.9-29.1 16.4-39.6z'
      
    ]
  };

  

  
  

  var faBezierCurve = {
    prefix: 'fat',
    iconName: 'bezier-curve',
    icon: [
      640,
      512,
      [],
      'f55b',
      
      'M344 80c13.3 0 24 10.7 24 24v17.4 16.1V152c0 13.3-10.7 24-24 24H296c-13.3 0-24-10.7-24-24V137.5 121.4 104c0-13.3 10.7-24 24-24h48zm80.1 56H528c.2 0 .4 0 .6 0c3.9 27.1 27.2 48 55.4 48c30.9 0 56-25.1 56-56s-25.1-56-56-56c-28.2 0-51.6 20.9-55.4 48c-.2 0-.4 0-.6 0H384V104c0-22.1-17.9-40-40-40H296c-22.1 0-40 17.9-40 40v16H112c-.2 0-.4 0-.6 0C107.6 92.9 84.2 72 56 72C25.1 72 0 97.1 0 128s25.1 56 56 56c28.2 0 51.6-20.9 55.4-48c.2 0 .4 0 .6 0H215.9C143.1 166.4 91.3 237 88.2 320H72c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V360c0-22.1-17.9-40-40-40H104.2c3.6-88.7 67.5-162 151.8-179.8V152c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V140.2C468.3 158 532.2 231.3 535.8 320H520c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V360c0-22.1-17.9-40-40-40H551.8c-3.1-83-54.9-153.6-127.7-184zM16 128a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm528 0a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM72 336h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V360c0-13.3 10.7-24 24-24zm424 24c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H520c-13.3 0-24-10.7-24-24V360z'
      
    ]
  };

  

  
  

  var faSignalStreamSlash = {
    prefix: 'fat',
    iconName: 'signal-stream-slash',
    icon: [
      640,
      512,
      [],
      'e250',
      
      'M13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7zM576 256c0-72.5-26.8-138.7-71-189.3c-2.9-3.3-8-3.7-11.3-.8s-3.7 8-.8 11.3C534.7 125 560 187.5 560 256c0 30.3-4.9 59.4-14.1 86.6l13.3 10.5c10.9-30.3 16.8-63 16.8-97.1zm-96 0c0-47.9-17.5-91.7-46.5-125.3c-2.9-3.3-7.9-3.7-11.3-.8s-3.7 7.9-.8 11.3C447.9 172 464 212.1 464 256c0 7.1-.4 14.1-1.2 21l14.5 11.5c1.8-10.5 2.7-21.4 2.7-32.4zM123.7 192.8l-13.1-10.3C101.2 205.1 96 229.9 96 256c0 47.9 17.5 91.7 46.5 125.3c2.9 3.3 7.9 3.7 11.3 .8s3.7-7.9 .8-11.3C128.1 340 112 299.9 112 256c0-22.3 4.1-43.6 11.7-63.2zM46.1 131.5L33.3 121.4C12 161.6 0 207.4 0 256c0 72.5 26.8 138.7 71 189.3c2.9 3.3 8 3.7 11.3 .8s3.7-8 .8-11.3C41.3 387 16 324.5 16 256c0-44.9 10.9-87.2 30.1-124.5z'
      
    ]
  };

  

  
  

  var faFolderCheck = {
    prefix: 'fat',
    iconName: 'folder-check',
    icon: [
      512,
      512,
      [],
      'e64e',
      
      'M448 464H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H197.5c12.7 0 24.9 5.1 33.9 14.1l35.9 35.9c9 9 21.2 14.1 33.9 14.1H448c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48zM64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H301.3c-8.5 0-16.6-3.4-22.6-9.4L242.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64zM357.7 229.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L224 340.7l-58.3-58.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l64 64c3.1 3.1 8.2 3.1 11.3 0l128-128z'
      
    ]
  };

  

  
  

  var faSquareDivide = {
    prefix: 'fat',
    iconName: 'square-divide',
    icon: [
      448,
      512,
      [],
      'e26a',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm240 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-72 88H328c4.4 0 8 3.6 8 8s-3.6 8-8 8H120c-4.4 0-8-3.6-8-8s3.6-8 8-8zM224 368a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faSignHanging = {
    prefix: 'fat',
    iconName: 'sign-hanging',
    icon: [
      512,
      512,
      ["sign"],
      'f4d9',
      
      'M72 0c4.4 0 8 3.6 8 8V64l424 0c4.4 0 8 3.6 8 8s-3.6 8-8 8L80 80V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V80H8c-4.4 0-8-3.6-8-8s3.6-8 8-8l56 0V8c0-4.4 3.6-8 8-8zm88 144c-8.8 0-16 7.2-16 16V352c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16H160zm-32 16c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160z'
      
    ]
  };

  
    var faSign = faSignHanging;
  

  
  

  var faVacuumRobot = {
    prefix: 'fat',
    iconName: 'vacuum-robot',
    icon: [
      512,
      512,
      [],
      'e04e',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM202.3 234.3c-3.1 3.1-3.1 8.2 0 11.3l64 64c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-64-64c-3.1-3.1-8.2-3.1-11.3 0zm-72 8c-3.1 3.1-3.1 8.2 0 11.3l128 128c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-128-128c-3.1-3.1-8.2-3.1-11.3 0zm-8 83.3l64 64c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-64-64c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3zM151.3 148c28.2-28.2 66.5-44 106.3-44C340.7 104 408 171.3 408 254.4c0 39.9-15.8 78.1-44 106.3l-9.6 9.6c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l9.6-9.6c31.2-31.2 48.7-73.5 48.7-117.7C424 162.5 349.5 88 257.6 88c-44.1 0-86.5 17.5-117.7 48.7l-9.6 9.6c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l9.6-9.6z'
      
    ]
  };

  

  
  

  var faAngle = {
    prefix: 'fat',
    iconName: 'angle',
    icon: [
      448,
      512,
      [],
      'e08c',
      
      'M231.2 43.6c2-4 .4-8.8-3.6-10.7s-8.8-.4-10.7 3.6L.8 468.4c-1.2 2.5-1.1 5.4 .4 7.8s4 3.8 6.8 3.8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H20.9L231.2 43.6zM294 250.7c-19.4-25.8-42.6-48.6-68.7-67.7c-3.9-2.9-9.5-1.4-11.7 2.9c-1.8 3.6-.7 7.9 2.5 10.2c24.6 18 46.4 39.5 64.8 63.8c2.6 3.4 7.3 4.3 10.9 2c3.9-2.5 4.9-7.7 2.1-11.3zm19.6 63c14.1 29.5 23.7 61.5 27.9 95.2c.5 4.1 3.9 7.2 8.1 7.2c4.7 0 8.4-4.1 7.9-8.8c-4.4-35.7-14.6-69.7-29.6-100.9c-2-4.3-7.4-5.7-11.3-3.1c-3.5 2.2-4.7 6.7-2.9 10.4z'
      
    ]
  };

  

  
  

  var faOliveBranch = {
    prefix: 'fat',
    iconName: 'olive-branch',
    icon: [
      640,
      512,
      [],
      'e317',
      
      'M204.2 103.2c4-1.8 7.8-3.6 11.5-5.5L334.9 40.4C368.4 24.3 405.1 16 442.3 16H632c4.4 0 8-3.6 8-8s-3.6-8-8-8H442.3C402.7 0 363.7 8.9 328 26L259.2 59c-1.4-1.4-3.2-3.1-5.2-5l-1.4-1.3C232.4 34.4 186.6 0 128 0C59 0 13.8 41.6 2.7 53.1C.9 55 0 57.4 0 60s.9 5 2.7 6.9c9.4 9.6 42.7 40.5 93.9 50.2C39.8 141.6 0 198.2 0 264v16c0 8.8 7.2 16 16 16H32c88.4 0 160-71.6 160-160V120 109l12.2-5.9zm-6.7-14.5C177.9 97.3 154.3 104 128 104C72.3 104 33.4 73.9 18.5 60C33.4 46.1 72.3 16 128 16c35.7 0 66.6 14.3 89.1 29.3c9.5 6.3 17.3 12.7 23.2 17.9c-5.7 4.4-13.3 9.7-22.4 15c-3 1.7-6.1 3.5-9.4 5.2l-11.1 5.3zM425 446.2c-23.8 31.7-55.4 49.8-89 49.8s-65.2-18.1-89-49.8s-39-76.3-39-126.2s15.2-94.4 39-126.2s55.4-49.8 89-49.8s65.2 18.1 89 49.8s39 76.3 39 126.2s-15.2 94.4-39 126.2zM336 512c79.5 0 144-86 144-192s-64.5-192-144-192s-144 86-144 192s64.5 192 144 192zm129.7-40.2c52.9 16.5 105.5 8.4 139.6-27c56.2-58.3 41-168.6-33.9-246.4c-42.9-44.5-96.1-68.7-144.2-70.3c7.2 5.5 14 11.6 20.3 18.2c37.9 6.7 78.3 27.9 112.4 63.2c35.3 36.6 56.2 80.6 61.8 121.6c5.7 41-4 77.8-27.9 102.6c-23.8 24.7-58.9 34.5-97.9 28.7c-6.9-1-13.9-2.5-20.9-4.5c-2.9 4.8-6 9.4-9.3 13.9zM16 280V264c0-79.5 64.5-144 144-144h16v16c0 79.5-64.5 144-144 144H16z'
      
    ]
  };

  

  
  

  var faPlugCircleMinus = {
    prefix: 'fat',
    iconName: 'plug-circle-minus',
    icon: [
      576,
      512,
      [],
      'e55e',
      
      'M112 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V112h16V8zM288 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V112h16V8zM8 144c-4.4 0-8 3.6-8 8s3.6 8 8 8H40v80c0 81.3 63.8 147.6 144 151.8V504c0 4.4 3.6 8 8 8s8-3.6 8-8V391.8c20-1 39-6 56.3-14c-.2-3.2-.3-6.5-.3-9.8c0-2.7 .1-5.4 .2-8.1c-19.1 10.3-41 16.1-64.2 16.1c-75.1 0-136-60.9-136-136V160H328v66c5.1-3.8 10.5-7.3 16-10.5V160h32c4.4 0 8-3.6 8-8s-3.6-8-8-8H344 328 56 40 8zm424 96a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm80-144c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8s3.6 8 8 8H504c4.4 0 8-3.6 8-8z'
      
    ]
  };

  

  
  

  var faArrowTrendUp = {
    prefix: 'fat',
    iconName: 'arrow-trend-up',
    icon: [
      576,
      512,
      [],
      'e098',
      
      'M368 104c0-4.4 3.6-8 8-8H568c4.4 0 8 3.6 8 8V296c0 4.4-3.6 8-8 8s-8-3.6-8-8V123.3L325.7 357.7c-3.1 3.1-8.2 3.1-11.3 0L192 235.3 13.7 413.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l184-184c3.1-3.1 8.2-3.1 11.3 0L320 340.7 548.7 112H376c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faStore = {
    prefix: 'fat',
    iconName: 'store',
    icon: [
      576,
      512,
      [],
      'f54e',
      
      'M534.1 112.4L476.8 21.7l0-.1c-2.1-3.4-6.1-5.6-10.4-5.6H109.6c-4.3 0-8.2 2.2-10.4 5.6l0 .1 0 0L41.9 112.4l0 0c-24.1 38.2-1.8 89.3 40.5 95c3.3 .4 6.7 .7 10 .7c21.4 0 40.3-9.3 53.3-23.7c3-3.4 7.3-5.3 11.9-5.3s8.8 1.9 11.9 5.3c13 14.4 32 23.7 53.3 23.7c21.4 0 40.3-9.3 53.3-23.7c3-3.4 7.3-5.3 11.9-5.3s8.8 1.9 11.9 5.3c13 14.4 32 23.7 53.3 23.7c21.4 0 40.3-9.3 53.3-23.7c3-3.4 7.3-5.3 11.8-5.3s8.8 1.9 11.9 5.2c13.1 14.5 32.1 23.7 53.3 23.7c3.4 0 6.7-.2 10-.7c42.5-5.6 64.9-56.7 40.7-95l0 0zM483.4 224c-20.2 0-38.7-6.9-53.4-18.1c-4.3-3.3-8.2-6.9-11.8-10.8c-3.6 4-7.5 7.6-11.8 10.9c-14.7 11.3-33.1 18.1-53.4 18.1c-20.2 0-38.7-6.8-53.4-18.1c-4.3-3.3-8.2-6.9-11.8-10.8c-3.6 3.9-7.5 7.6-11.8 10.9C261.5 217.2 243 224 222.7 224c-20.2 0-38.7-6.8-53.4-18.1c-4.3-3.3-8.2-6.9-11.8-10.8c-3.6 3.9-7.5 7.6-11.8 10.9C131.1 217.2 112.6 224 92.4 224c-4.1 0-8.2-.3-12.1-.8l-.2 0V264 376v64c0 30.9 25.1 56 56 56H440c30.9 0 56-25.1 56-56V376 264 223.1l-.5 .1c-4 .5-7.9 .8-12.1 .8zm64.2-120.2c26.6 42 8.3 98.6-35.6 115.3V264 376v64c0 39.8-32.2 72-72 72H136c-39.8 0-72-32.2-72-72V376 264 219.1C20.1 202.4 1.8 145.8 28.3 103.8L85.7 13.1C90.8 5 99.9 0 109.6 0H466.4c9.7 0 18.8 5 23.9 13.1l57.3 90.7zM144 256V360c0 4.4 3.6 8 8 8H424c4.4 0 8-3.6 8-8V256c0-4.4 3.6-8 8-8s8 3.6 8 8V360c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24V256c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faDisplayArrowDown = {
    prefix: 'fat',
    iconName: 'display-arrow-down',
    icon: [
      576,
      512,
      [],
      'e164',
      
      'M64 0H248V16H64C37.5 16 16 37.5 16 64V352c0 26.5 21.5 48 48 48H231.8h.3H343.9h.3H512c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H328V0H512c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H353.4l13.3 80H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H360 216 136c-4.4 0-8-3.6-8-8s3.6-8 8-8h73.2l13.3-80H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0zM80 64H248V80H80l0 256H496V80H328V64H496c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zM225.4 496H350.6l-13.3-80H238.8l-13.3 80zM296 8V244.7l74.3-74.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-88 88c-3.1 3.1-8.2 3.1-11.3 0l-88-88c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L280 244.7V8c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faCircleGf = {
    prefix: 'fat',
    iconName: 'circle-gf',
    icon: [
      512,
      512,
      [],
      'e67f',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM192 144c35.3 0 64 28.7 64 64l0 8c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-8c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48s48-21.5 48-48l0-16-40 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l48 0c4.4 0 8 3.6 8 8l0 24c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-96c0-35.3 28.7-64 64-64zm96 8c0-4.4 3.6-8 8-8l80 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-72 0 0 96 56 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-56 0 0 88c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-96 0-112z'
      
    ]
  };

  

  
  

  var faChartScatter = {
    prefix: 'fat',
    iconName: 'chart-scatter',
    icon: [
      512,
      512,
      [],
      'f7ee',
      
      'M16 40c0-4.4-3.6-8-8-8s-8 3.6-8 8V408c0 39.8 32.2 72 72 72H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H72c-30.9 0-56-25.1-56-56V40zM216 160a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-24-40a40 40 0 1 0 0 80 40 40 0 1 0 0-80zm96 160a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-40-24a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm160 64a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-24-40a40 40 0 1 0 0 80 40 40 0 1 0 0-80zm32-128a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-40-24a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zM184 320a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-24-40a40 40 0 1 0 0 80 40 40 0 1 0 0-80z'
      
    ]
  };

  

  
  

  var faFaceEyesXmarks = {
    prefix: 'fat',
    iconName: 'face-eyes-xmarks',
    icon: [
      512,
      512,
      [],
      'e374',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm251.8 48h8.4c46.3 0 83.8 37.5 83.8 83.8c0 6.7-5.5 12.2-12.2 12.2H180.2c-6.7 0-12.2-5.5-12.2-12.2c0-46.3 37.5-83.8 83.8-83.8zm8.4 16h-8.4c-36.2 0-65.7 28.3-67.7 64H327.9c-2-35.7-31.5-64-67.7-64zM106.3 138.3c3.1-3.1 8.2-3.1 11.3 0L160 180.7l42.3-42.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L171.3 192l42.3 42.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L160 203.3l-42.3 42.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L148.7 192l-42.3-42.3c-3.1-3.1-3.1-8.2 0-11.3zm192 0c3.1-3.1 8.2-3.1 11.3 0L352 180.7l42.3-42.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L363.3 192l42.3 42.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L352 203.3l-42.3 42.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L340.7 192l-42.3-42.3c-3.1-3.1-3.1-8.2 0-11.3z'
      
    ]
  };

  

  
  

  var faPlanetMoon = {
    prefix: 'fat',
    iconName: 'planet-moon',
    icon: [
      576,
      512,
      [],
      'e01f',
      
      'M512 16a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112A64 64 0 1 0 512 0a64 64 0 1 0 0 128zM224 496C109.1 496 16 402.9 16 288c0-16.3 1.9-32.1 5.4-47.3l2.2 2.2C37.1 256.4 55.4 264 74.5 264h33.6c10.6 0 20.8 4.2 28.3 11.7L184 323.3V352c0 19.4 13.7 35.5 32 39.2V431c0 18.2 14.8 33 33 33c12.2 0 23.3-6.7 29.1-17.4L319.4 370c5.6-10.5 8.6-22.2 8.6-34.1V320c0-22.1-17.9-40-40-40H222.1c-6.9 0-13.6-2.7-18.4-7.6c-9.5-9.5-10.2-24.8-1.6-35.2L254.7 174c6-7.2 9.3-16.2 9.3-25.6V83.8c95.7 18.6 168 103 168 204.2c0 114.9-93.1 208-208 208zM8.2 227.6C2.9 246.8 0 267.1 0 288C0 411.7 100.3 512 224 512s224-100.3 224-224S347.7 64 224 64C127.4 64 45 125.2 13.6 211c-2 5.4-3.8 11-5.3 16.6zM26.3 223C53.6 140 131.8 80 224 80c8.1 0 16.1 .5 24 1.4v67c0 5.6-2 11.1-5.6 15.4L189.8 227c-13.9 16.7-12.8 41.3 2.6 56.7c7.9 7.9 18.6 12.3 29.8 12.3H288c13.3 0 24 10.7 24 24v15.9c0 9.3-2.3 18.4-6.7 26.6L264 439c-3 5.5-8.7 9-15 9c-9.4 0-17-7.6-17-17V384c0-4.4-3.6-8-8-8c-13.3 0-24-10.7-24-24V320c0-2.1-.8-4.2-2.3-5.7l-49.9-49.9C137.2 253.9 123 248 108.1 248H74.5c-14.9 0-29.1-5.9-39.6-16.4L26.3 223z'
      
    ]
  };

  

  
  

  var faFolderMinus = {
    prefix: 'fat',
    iconName: 'folder-minus',
    icon: [
      512,
      512,
      [],
      'f65d',
      
      'M448 464H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H197.5c12.7 0 24.9 5.1 33.9 14.1l35.9 35.9c9 9 21.2 14.1 33.9 14.1H448c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48zM64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H301.3c-8.5 0-16.6-3.4-22.6-9.4L242.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64zm96-192c-4.4 0-8 3.6-8 8s3.6 8 8 8H352c4.4 0 8-3.6 8-8s-3.6-8-8-8H160z'
      
    ]
  };

  

  
  

  var faFloppyDiskCircleArrowRight = {
    prefix: 'fat',
    iconName: 'floppy-disk-circle-arrow-right',
    icon: [
      576,
      512,
      ["save-circle-arrow-right"],
      'e180',
      
      'M16 96V416c0 26.5 21.5 48 48 48H284.5c3.6 5.6 7.6 10.9 11.8 16H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H309.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3v22.2c-5.3-.5-10.6-.7-16-.7V170.5c0-12.7-5.1-24.9-14.1-33.9L343.4 62.1C337 55.6 328.8 51.1 320 49.2V160c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32L64 48C37.5 48 16 69.5 16 96zM224 240c25 0 47.6 10.5 63.7 27.3c-3.2 4.5-6.1 9.2-8.9 14C265.6 265.8 245.9 256 224 256c-39.8 0-72 32.2-72 72s32.2 72 72 72c12.1 0 23.6-3 33.6-8.3c.7 5.5 1.7 11 3 16.4c-11.1 5.1-23.5 7.9-36.6 7.9c-48.6 0-88-39.4-88-88s39.4-88 88-88zM80 48V160c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16V48H80zM432 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm2.3 74.3c3.1-3.1 8.2-3.1 11.3 0l64 64c3.1 3.1 3.1 8.2 0 11.3l-64 64c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L484.7 376H360c-4.4 0-8-3.6-8-8s3.6-8 8-8H484.7l-50.3-50.3c-3.1-3.1-3.1-8.2 0-11.3z'
      
    ]
  };

  
    var faSaveCircleArrowRight = faFloppyDiskCircleArrowRight;
  

  
  

  var faPhotoFilm = {
    prefix: 'fat',
    iconName: 'photo-film',
    icon: [
      640,
      512,
      ["photo-video"],
      'f87c',
      
      'M256 16c-26.5 0-48 21.5-48 48V260.7l95-95c9.4-9.4 24.6-9.4 33.9 0l47 47 111-111c9.4-9.4 24.6-9.4 33.9 0l95 95V64c0-26.5-21.5-48-48-48H256zM208 283.3V288c0 26.5 21.5 48 48 48h4.7l112-112-47-47c-3.1-3.1-8.2-3.1-11.3 0L208 283.3zM283.3 336H576c26.5 0 48-21.5 48-48V219.3L517.7 113c-3.1-3.1-8.2-3.1-11.3 0L389.7 229.7 283.3 336zM192 64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V64zm96 8a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm40 24a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zM128 160h32v16H128v80 80 72 88H384V408 384h16v16h64V384h16v16 8 8 32c0 35.3-28.7 64-64 64H400h-8-8H128h-8-8H64c-35.3 0-64-28.7-64-64V416v-8-8V344v-8-8V264v-8-8V224c0-35.3 28.7-64 64-64h48 8 8zM112 400V344H16v56h96zm0 16H16v32c0 26.5 21.5 48 48 48h48V416zm288 80h16c26.5 0 48-21.5 48-48V416H400v80zM112 176H64c-26.5 0-48 21.5-48 48v24h96V176zM16 264v64h96V264H16z'
      
    ]
  };

  
    var faPhotoVideo = faPhotoFilm;
  

  
  

  var faVideoArrowDownLeft = {
    prefix: 'fat',
    iconName: 'video-arrow-down-left',
    icon: [
      576,
      512,
      [],
      'e2c8',
      
      'M320 80c26.5 0 48 21.5 48 48v74.9V309.1 384c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V128c0-26.5 21.5-48 48-48H320zm64 304V336.8 309.1 202.9 175.2 128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64zm32-29.6l103.4 56.9c5.6 3.1 12 4.7 18.4 4.7c21.1 0 38.2-17.1 38.2-38.2V134.2c0-21.1-17.1-38.2-38.2-38.2c-6.4 0-12.8 1.6-18.4 4.7L416 157.6v18.3l111.1-61.1c3.3-1.8 7-2.7 10.7-2.7c12.3 0 22.2 9.9 22.2 22.2V377.8c0 12.3-9.9 22.2-22.2 22.2c-3.7 0-7.4-.9-10.7-2.7L416 336.1v18.3zM232 352c4.4 0 8-3.6 8-8s-3.6-8-8-8H123.3L285.7 173.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L112 324.7V216c0-4.4-3.6-8-8-8s-8 3.6-8 8V344c0 4.4 3.6 8 8 8H232z'
      
    ]
  };

  

  
  

  var faCandleHolder = {
    prefix: 'fat',
    iconName: 'candle-holder',
    icon: [
      448,
      512,
      [128367],
      'f6bc',
      
      'M96 112c0-14.3 9.4-33.2 23.6-52.5C133.2 40.9 149 24.9 157.3 17c.5-.5 1.4-1 2.7-1s2.2 .5 2.7 1c8.3 7.9 24.1 23.9 37.7 42.5C214.6 78.8 224 97.7 224 112c0 35.3-28.7 64-64 64s-64-28.7-64-64zm64 80c44.2 0 80-35.8 80-80c0-39.6-49.1-90.1-66.2-106.6C170.1 1.9 165.2 0 160 0s-10.1 1.9-13.8 5.4C129.1 21.9 80 72.4 80 112c0 44.2 35.8 80 80 80zm-48 48h16v48c0 4.4 3.6 8 8 8s8-3.6 8-8V240h64c17.7 0 32 14.3 32 32V496H80V272c0-17.7 14.3-32 32-32zM256 496V272c0-26.5-21.5-48-48-48H112c-26.5 0-48 21.5-48 48V496H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H64 80 240h16H384c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64c0 19.1 8.4 36.3 21.7 48H256zm80-48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  

  
  

  var faClockTen = {
    prefix: 'fat',
    iconName: 'clock-ten',
    icon: [
      512,
      512,
      [],
      'e354',
      
      'M496 256A240 240 0 1 1 16 256a240 240 0 1 1 480 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM248 104V241.1l-83.6-55.7c-3.7-2.5-8.6-1.5-11.1 2.2s-1.5 8.6 2.2 11.1l96 64c2.5 1.6 5.6 1.8 8.2 .4s4.2-4.1 4.2-7.1V104c0-4.4-3.6-8-8-8s-8 3.6-8 8z'
      
    ]
  };

  

  
  

  var faSirenOn = {
    prefix: 'fat',
    iconName: 'siren-on',
    icon: [
      640,
      512,
      [],
      'e02e',
      
      'M44.1 33.1c-3.8-2.3-8.7-1-11 2.7s-1 8.7 2.7 11l80 48c3.8 2.3 8.7 1 11-2.7s1-8.7-2.7-11l-80-48zm560 13.7c3.8-2.3 5-7.2 2.7-11s-7.2-5-11-2.7l-80 48c-3.8 2.3-5 7.2-2.7 11s7.2 5 11 2.7l80-48zM8 192c-4.4 0-8 3.6-8 8s3.6 8 8 8H88c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zm544 0c-4.4 0-8 3.6-8 8s3.6 8 8 8h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H552zM492 320L471 152.1C467 120 439.8 96 407.5 96h-175c-32.3 0-59.5 24-63.5 56.1L148 320h16.1l20.7-166c3-24 23.4-42 47.6-42h175c24.2 0 44.6 18 47.6 42l20.7 166H492zm-271 0l18.9-151.3c.5-4.4-2.6-8.4-6.9-8.9s-8.4 2.6-8.9 6.9L204.9 320H221zm275 48c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32V400c0-17.7 14.3-32 32-32H496zM144 352c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48H496c26.5 0 48-21.5 48-48V400c0-26.5-21.5-48-48-48H144z'
      
    ]
  };

  

  
  

  var faRocket = {
    prefix: 'fat',
    iconName: 'rocket',
    icon: [
      512,
      512,
      [],
      'f135',
      
      'M127.1 332.8l50.7 50.7c4.6 4.6 11.3 5.9 17 3.4c42.4-17.8 140.5-60.7 191.5-95.4C499.6 214.7 503.8 100.7 491 31c-.9-5.1-4.8-9-9.9-9.9C411.3 8.2 297.3 12.4 220.5 125.7c-34.5 50.9-78.3 147.8-96.7 189.9c-2.5 5.8-1.3 12.5 3.4 17.2zm39.3 62l-50.7-50.7c-9.2-9.2-11.9-23-6.7-34.9c2.6-6 5.8-13.2 9.4-21.2H25.9C8 288-3.6 269.2 4.4 253.3L51.6 159c9.5-19 28.9-31 50.1-31l98.2 0c2.5-4 4.9-7.7 7.3-11.3C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8c13.4 72.9 9.3 194.8-111.4 276.7c-3.6 2.4-7.3 4.9-11.3 7.3l0 98.2c0 21.2-12 40.6-31 50.1l-94.3 47.2c-16 8-34.7-3.6-34.7-21.5l0-94.3c-8.8 3.8-16.6 7.1-23 9.8c-11.8 5-25.4 2.2-34.5-6.9zM25.9 272l99.8 0c17.5-38.3 41.6-88.8 64.5-128H101.7c-15.2 0-29 8.6-35.8 22.1L18.7 260.4c-2.7 5.3 1.2 11.6 7.2 11.6zM240 384.8V486.1c0 5.9 6.3 9.8 11.6 7.2l94.3-47.2c13.6-6.8 22.1-20.6 22.1-35.8V321.7c-39.1 22.6-89.5 46.1-128 63.1zM328 144a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm40 56a56 56 0 1 1 0-112 56 56 0 1 1 0 112z'
      
    ]
  };

  

  
  

  var faClockEleven = {
    prefix: 'fat',
    iconName: 'clock-eleven',
    icon: [
      512,
      512,
      [],
      'e347',
      
      'M496 256A240 240 0 1 1 16 256a240 240 0 1 1 480 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM248 104V229.6l-49.3-74c-2.5-3.7-7.4-4.7-11.1-2.2s-4.7 7.4-2.2 11.1l64 96c2 2.9 5.6 4.2 9 3.2s5.7-4.1 5.7-7.7V104c0-4.4-3.6-8-8-8s-8 3.6-8 8z'
      
    ]
  };

  

  
  

  var faLassoSparkles = {
    prefix: 'fat',
    iconName: 'lasso-sparkles',
    icon: [
      576,
      512,
      [],
      'e1c9',
      
      'M0 176C0 78.8 128.9 0 288 0V16C137.8 16 16 87.6 16 176c0 53.9 45.3 101.6 114.7 130.6l0 0c5.9 2.5 12 4.8 18.3 7l0 0c40.7 14.2 88.2 22.4 139 22.4c150.2 0 272-71.6 272-160c0-68.5-73.2-126.9-176-149.7V10C495.9 34.2 576 99.4 576 176c0 97.2-128.9 176-288 176c-30.4 0-59.6-2.9-87.1-8.2C220.4 361.9 232 387.6 232 415c0 53.6-43.4 97-97 97H40c-4.4 0-8-3.6-8-8s3.6-8 8-8h95c44.7 0 81-36.3 81-81c0-30.7-17.3-58.7-44.8-72.4l-30.7-15.3C56.4 296.5 0 240.3 0 176zM336 8c4.4 0 8 3.6 8 8V72h56c4.4 0 8 3.6 8 8s-3.6 8-8 8H344v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V88H272c-4.4 0-8-3.6-8-8s3.6-8 8-8h56V16c0-4.4 3.6-8 8-8zM504 368v56h56c4.4 0 8 3.6 8 8s-3.6 8-8 8H504v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V440H432c-4.4 0-8-3.6-8-8s3.6-8 8-8h56V368c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faFaceDisappointed = {
    prefix: 'fat',
    iconName: 'face-disappointed',
    icon: [
      512,
      512,
      [],
      'e36f',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM322.1 413.4C309.3 399.1 287.3 384 256 384s-53.3 15.1-66.1 29.4c-3 3.3-8 3.6-11.3 .6s-3.6-8-.6-11.3C193.1 386 219.1 368 256 368s62.9 18 77.9 34.6c3 3.3 2.7 8.3-.6 11.3s-8.3 2.7-11.3-.6zm-116.4-171c3.1 3.1 3.1 8.2 0 11.3l-7.4 7.4c-22.4 22.4-51.2 37.2-82.5 42.5l-2.5 .4c-4.4 .7-8.5-2.2-9.2-6.6s2.2-8.5 6.6-9.2l2.5-.4c28-4.7 53.8-17.9 73.8-38l7.4-7.4c3.1-3.1 8.2-3.1 11.3 0zm100.7 11.3c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l7.4 7.4c20 20 45.8 33.3 73.8 38l2.5 .4c4.4 .7 7.3 4.8 6.6 9.2s-4.8 7.3-9.2 6.6l-2.5-.4c-31.3-5.2-60.1-20.1-82.5-42.5l-7.4-7.4z'
      
    ]
  };

  

  
  

  var faFileCircleInfo = {
    prefix: 'fat',
    iconName: 'file-circle-info',
    icon: [
      576,
      512,
      [58604],
      'e493',
      
      'M64 496H311.2c5.8 5.5 12 10.6 18.5 15.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H204.1c12.7 0 24.9 5.1 33.9 14.1L369.9 145.9c9 9 14.1 21.2 14.1 33.9v18.7c-5.4 1.5-10.8 3.3-16 5.4V179.9c0-1.3-.1-2.6-.2-3.9H248c-22.1 0-40-17.9-40-40V16.2c-1.3-.2-2.6-.2-3.9-.2H64C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48zM361.1 160c-.8-1-1.6-1.9-2.4-2.7L226.7 25.4c-.9-.9-1.8-1.7-2.7-2.4V136c0 13.3 10.7 24 24 24H361.1zM560 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-48a16 16 0 1 1 0-32 16 16 0 1 1 0 32zM408 440c0-4.4 3.6-8 8-8h8V360h-8c-4.4 0-8-3.6-8-8s3.6-8 8-8h16c4.4 0 8 3.6 8 8v80h8c4.4 0 8 3.6 8 8s-3.6 8-8 8H432 416c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faArrowLeftFromArc = {
    prefix: 'fat',
    iconName: 'arrow-left-from-arc',
    icon: [
      512,
      512,
      [],
      'e615',
      
      'M496 256C496 123.5 388.5 16 256 16c-4.4 0-8-3.6-8-8s3.6-8 8-8C397.4 0 512 114.6 512 256s-114.6 256-256 256c-4.4 0-8-3.6-8-8s3.6-8 8-8c132.5 0 240-107.5 240-240zM154.8 121.9c3.4-2.8 8.4-2.4 11.3 1s2.4 8.4-1 11.3L29.9 248H344c4.4 0 8 3.6 8 8s-3.6 8-8 8H29.9L165.2 377.9c3.4 2.8 3.8 7.9 1 11.3s-7.9 3.8-11.3 1l-152-128C1 260.6 0 258.4 0 256s1-4.6 2.8-6.1l152-128z'
      
    ]
  };

  

  
  

  var faMap = {
    prefix: 'fat',
    iconName: 'map',
    icon: [
      576,
      512,
      [62072,128506],
      'f279',
      
      'M181.3 32.5c1.6-.6 3.4-.6 5.1-.1L391.8 95.6 533.1 44.2c20.9-7.6 42.9 7.9 42.9 30.1V391.2c0 13.5-8.4 25.5-21.1 30.1L394.7 479.5c-1.6 .6-3.4 .6-5.1 .1L184.2 416.4 42.9 467.8C22.1 475.4 0 459.9 0 437.7V120.8c0-13.5 8.4-25.5 21.1-30.1L181.3 32.5zM26.5 105.8c-6.3 2.3-10.5 8.3-10.5 15V437.7c0 11.1 11 18.8 21.5 15L176 402.4V51.4L26.5 105.8zM384 461.2V109.9L192 50.8V402.1l192 59.1zm16-.6l149.5-54.4c6.3-2.3 10.5-8.3 10.5-15V74.3c0-11.1-11-18.8-21.5-15L400 109.6v351z'
      
    ]
  };

  

  
  

  var faUserHairLong = {
    prefix: 'fat',
    iconName: 'user-hair-long',
    icon: [
      448,
      512,
      [],
      'e45b',
      
      'M336 144v-8-8c0-5.4-.4-10.8-1.1-16H312c-22.1 0-43-10.2-56.6-27.5L251 89.9C231.2 114 201.7 128 170.5 128L112 128v8 8c0 61.9 50.1 112 112 112s112-50.1 112-112zM292.4 39.3L265.8 71.8l1.4 1.8C277.8 87.7 294.4 96 312 96h19.4c-6.8-22.8-20.6-42.5-39-56.7zM113.1 112h57.4c26.4 0 51.4-11.8 68.1-32.3L279 30.4C262.7 21.2 244 16 224 16c-56.4 0-103.1 41.7-110.9 96zM390.4 244.8c-20.6-15.4-36.1-36.2-45.2-59.6C328.1 235.7 280.3 272 224 272s-104.1-36.3-121.2-86.8c-9.1 23.4-24.6 44.1-45.2 59.6L53.3 248c-3.4 2.5-5.3 6.5-5.3 10.7C48 266 54 272 61.3 272H120c4.4 0 8 3.6 8 8s-3.6 8-8 8H61.3C45.1 288 32 274.9 32 258.7c0-9.2 4.3-17.9 11.7-23.5L48 232c30.2-22.7 48-58.2 48-96v-8C96 57.3 153.3 0 224 0s128 57.3 128 128v8c0 37.8 17.8 73.3 48 96l4.3 3.2c7.4 5.5 11.7 14.2 11.7 23.5c0 16.2-13.1 29.3-29.3 29.3H328c-4.4 0-8-3.6-8-8s3.6-8 8-8h58.7c7.4 0 13.3-6 13.3-13.3c0-4.2-2-8.1-5.3-10.7l-4.3-3.2zM16 483.6c0 6.9 5.6 12.4 12.4 12.4H419.6c6.9 0 12.4-5.6 12.4-12.4C432 402.1 365.9 336 284.4 336H163.6C82.1 336 16 402.1 16 483.6zm-16 0C0 393.2 73.2 320 163.6 320H284.4C374.8 320 448 393.2 448 483.6c0 15.7-12.7 28.4-28.4 28.4H28.4C12.7 512 0 499.3 0 483.6z'
      
    ]
  };

  

  
  

  var faAxeBattle = {
    prefix: 'fat',
    iconName: 'axe-battle',
    icon: [
      512,
      512,
      [],
      'f6b3',
      
      'M120.8 70.4c13.9 18.6 36 37.9 71.2 48.8v16.7c-41.1-11.5-67.4-33.7-84-55.9C94.8 62.4 83.5 39.8 80 16.3l0-.2 0 0C40.3 64 16 130.2 16 192c0 61.6 24.2 128.3 64 176l0 0 .1-.4 0 0c6.6-23.5 19.2-45.5 33.9-63.6c17.2-21.1 42.2-42.3 78-54.2v17c-29.9 11.1-50.9 29.3-65.6 47.3c-13.6 16.8-25 36.8-30.9 57.8c-1.5 5.8-6.1 10.4-11.9 11.7s-12-.7-15.8-5.3C25.5 327.7 0 257.4 0 192C0 126.4 25.6 56.5 67.7 5.7C71.8 .9 78.4-1.1 84.5 .7c6.1 1.8 10.5 7 11.3 13.3c2.9 20.2 12.8 40.3 24.9 56.4zM398.1 304c14.7 18.1 27.3 40.1 33.9 63.6l.1 .4 0 0 0 0c33.6-40.2 56.1-94 62.3-147l-17.7-17.7c-6.2-6.2-6.2-16.4 0-22.6L494.4 163c-6.2-53-28.8-106.5-62.2-147l0 0 0 .2 0 0c-3.4 23.6-14.7 46.1-28 63.7c-16.6 22.2-42.9 44.3-84.1 55.9V119.2c35.3-10.9 57.3-30.2 71.3-48.8c12.1-16.1 22-36.2 24.9-56.4c.8-6.3 5.3-11.5 11.3-13.3c6.1-1.8 12.7 .2 16.8 5.1c37.2 44.9 61.5 104.6 66.7 163.2l-11.7 11.7L488 192l11.3 11.3 11.7 11.7c-5.2 58.5-29.4 118.6-66.7 163.2c-3.9 4.6-10 6.6-15.8 5.3s-10.5-5.9-11.9-11.7c-5.9-21-17.3-41-30.9-57.8C371 296 350 277.8 320 266.8v-17c35.8 11.9 60.9 33.1 78.1 54.2zM272 64c0-8.8-7.2-16-16-16s-16 7.2-16 16V480c0 8.8 7.2 16 16 16s16-7.2 16-16V64zm-48 0c0-17.7 14.3-32 32-32s32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V64z'
      
    ]
  };

  

  
  

  var faCars = {
    prefix: 'fat',
    iconName: 'cars',
    icon: [
      640,
      512,
      [],
      'f85b',
      
      'M124.2 16H259.8c17.9 0 33.6 11.8 38.5 29l19.5 68.2c-4.5-.8-9-1.2-13.7-1.2H80c-4.7 0-9.3 .4-13.7 1.2L85.7 45c4.9-17.2 20.6-29 38.5-29zM48.3 117.8l1 .3C20.4 130.1 0 158.7 0 192v64 16 32c0 17.7 14.3 32 32 32H48c17.7 0 32-14.3 32-32V272H271.2l4.6-16H80 64 16V192c0-35.3 28.7-64 64-64H304c18.6 0 35.3 7.9 47 20.5c5.7-1.8 11.5-3.1 17.5-3.8c-8.6-11.7-20.3-21-33.9-26.6l1-.3L313.6 40.6C306.8 16.6 284.8 0 259.8 0H124.2c-25 0-47 16.6-53.8 40.6L48.3 117.8zM16 272H64v32c0 8.8-7.2 16-16 16H32c-8.8 0-16-7.2-16-16V272zm80-80a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM80 160a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm261.7 61l-19.5 68.2c4.5-.8 9-1.2 13.7-1.2H560c4.7 0 9.3 .4 13.7 1.2L554.3 221c-4.9-17.2-20.6-29-38.5-29H380.2c-17.9 0-33.6 11.8-38.5 29zm-36.4 73.1l-1-.3 22.1-77.2c6.9-24 28.8-40.6 53.8-40.6H515.8c25 0 47 16.6 53.8 40.6l22.1 77.2-1 .3c29 12 49.3 40.6 49.3 73.9v64 16 32c0 17.7-14.3 32-32 32H592c-17.7 0-32-14.3-32-32V448H336v32c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V448 432 368c0-33.3 20.4-61.9 49.3-73.9zM560 432h16 48V368c0-35.3-28.7-64-64-64H336c-35.3 0-64 28.7-64 64v64h48 16H560zm16 16v32c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V448H576zm-304 0v32c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V448H272zm64-96a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm176 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z'
      
    ]
  };

  

  
  

  var faShekelSign = {
    prefix: 'fat',
    iconName: 'shekel-sign',
    icon: [
      448,
      512,
      [8362,"ils","shekel","sheqel","sheqel-sign"],
      'f20b',
      
      'M56 32C33.9 32 16 49.9 16 72V472c0 4.4 3.6 8 8 8s8-3.6 8-8V72c0-13.3 10.7-24 24-24H192c48.6 0 88 39.4 88 88V352c0 4.4 3.6 8 8 8s8-3.6 8-8V136c0-57.4-46.6-104-104-104H56zM328 480c57.4 0 104-46.6 104-104V40c0-4.4-3.6-8-8-8s-8 3.6-8 8V376c0 48.6-39.4 88-88 88H192c-13.3 0-24-10.7-24-24V168c0-4.4-3.6-8-8-8s-8 3.6-8 8V440c0 22.1 17.9 40 40 40H328z'
      
    ]
  };

  
    var faIls = faShekelSign;
  
    var faShekel = faShekelSign;
  
    var faSheqel = faShekelSign;
  
    var faSheqelSign = faShekelSign;
  

  
  

  var faTally2 = {
    prefix: 'fat',
    iconName: 'tally-2',
    icon: [
      640,
      512,
      [],
      'e295',
      
      'M136 40c0-4.4-3.6-8-8-8s-8 3.6-8 8V472c0 4.4 3.6 8 8 8s8-3.6 8-8V40zm128 0c0-4.4-3.6-8-8-8s-8 3.6-8 8V472c0 4.4 3.6 8 8 8s8-3.6 8-8V40z'
      
    ]
  };

  

  
  

  var faTeeth = {
    prefix: 'fat',
    iconName: 'teeth',
    icon: [
      576,
      512,
      [],
      'f62e',
      
      'M96 48c-44.2 0-80 35.8-80 80V384c0 44.2 35.8 80 80 80H480c44.2 0 80-35.8 80-80V128c0-44.2-35.8-80-80-80H96zM0 128C0 75 43 32 96 32H480c53 0 96 43 96 96V384c0 53-43 96-96 96H96c-53 0-96-43-96-96V128zm168 92c0-24.3-19.7-44-44-44s-44 19.7-44 44v44h88V220zM80 280v44c0 24.3 19.7 44 44 44s44-19.7 44-44V280H80zm92.4 79.4C161.5 374.3 143.9 384 124 384c-33.1 0-60-26.9-60-60V272 220c0-33.1 26.9-60 60-60c17.9 0 34.1 7.9 45.1 20.4c5.5-29.8 31.6-52.4 62.9-52.4c24.1 0 45.1 13.3 56 33c10.9-19.7 31.9-33 56-33c31.4 0 57.5 22.6 62.9 52.4c11-12.5 27.1-20.4 45.1-20.4c33.1 0 60 26.9 60 60v52 52c0 33.1-26.9 60-60 60c-19.9 0-37.5-9.7-48.4-24.6C394.2 383.2 371.1 400 344 400c-24.1 0-45.1-13.3-56-33c-10.9 19.7-31.9 33-56 33c-27.1 0-50.2-16.8-59.6-40.6zM232 144c-26.5 0-48 21.5-48 48v28 44h96V192c0-26.5-21.5-48-48-48zM184 324v12c0 26.5 21.5 48 48 48s48-21.5 48-48V280H184v44zm224-60h88V220c0-24.3-19.7-44-44-44s-44 19.7-44 44v44zm0 60c0 24.3 19.7 44 44 44s44-19.7 44-44V280H408v44zm-64 60c26.5 0 48-21.5 48-48V324 280H296v56c0 26.5 21.5 48 48 48zm48-120V220 192c0-26.5-21.5-48-48-48s-48 21.5-48 48v72h96z'
      
    ]
  };

  

  
  

  var faBlender = {
    prefix: 'fat',
    iconName: 'blender',
    icon: [
      512,
      512,
      [],
      'f517',
      
      'M64 0C28.7 0 0 28.7 0 64V176c0 35.3 28.7 64 64 64h84l9.5 114.1C122.2 362.5 96 394.2 96 432v32c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V432c0-36.1-24-66.7-56.9-76.6L502.1 39.8C507.1 19.6 491.8 0 471 0H160 145.4 64zm65.4 16c0 .4 0 .9 .1 1.3L146.7 224H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48h65.4zm278 336.3c-2.4-.2-4.9-.3-7.4-.3H176c-.9 0-1.7 0-2.6 0l-28-336H160 471c10.4 0 18 9.8 15.5 19.9L471.5 96H296c-4.4 0-8 3.6-8 8s3.6 8 8 8H467.5l-20 80H296c-4.4 0-8 3.6-8 8s3.6 8 8 8H443.5L407.4 352.3zM176 368H400c35.3 0 64 28.7 64 64v32c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32V432c0-35.3 28.7-64 64-64zm112 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faWrenchSimple = {
    prefix: 'fat',
    iconName: 'wrench-simple',
    icon: [
      384,
      512,
      [],
      'e2d1',
      
      'M384 172.4c0 71-38.7 132.8-96 166V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V338.5c0-5.9 3.3-11.1 8.3-14.1c54.1-31.5 87.7-89.7 87.7-152c0-66.1-36.6-126.1-95.6-156.4L272 160c0 4.2-1.7 8.3-4.7 11.3l-64 64c-6.3 6.3-16.4 6.3-22.6 0l-64-64c-3-3-4.7-7.1-4.7-11.3l-.4-143.9C52.6 46.4 16 106.3 16 172.4c0 62.2 33.6 120.4 87.7 152c5.1 3 8.3 8.2 8.3 14.1V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V338.5c-57.3-33.2-96-95-96-166C0 64.8 90.1 0 111.8 0C120.3 0 128 6.7 128 16.1V160l64 64 64-64V16.1C256 6.7 263.7 0 272.2 0C293.9 0 384 64.8 384 172.4z'
      
    ]
  };

  

  
  

  var faPeanut = {
    prefix: 'fat',
    iconName: 'peanut',
    icon: [
      512,
      512,
      [],
      'e430',
      
      'M124.3 234.1l0 0 .2 0c25.2-5 53.8-13.5 74.9-34.6s29.7-49.7 34.6-74.9l0 0 0-.2c1.7-9.3 4.3-18.2 7.9-26.8l0 0c6.3-15.3 15.6-29.6 27.9-42.1l0 0C293.9 31.1 327.2 16 364 16h68c35.3 0 64 28.7 64 64v68c0 17.9-3.6 35-10 50.5l0 0c-6.4 15.5-16 30.1-28.6 42.8C444.6 254 430 263.6 414.5 270l0 0c-8.5 3.5-17.4 6.2-26.7 7.9l0 0-.2 0c-25.2 5-53.8 13.5-74.9 34.6s-29.7 49.7-34.6 74.9l0 0 0 .2c-1.7 9.3-4.3 18.2-7.9 26.8l0 0c-6.3 15.3-15.6 29.6-27.9 42.1l0 0c-24 24.4-57.3 39.4-94.1 39.4H80c-35.3 0-64-28.7-64-64V364c0-17.9 3.6-35 10-50.5l0 0c6.4-15.5 16-30.1 28.6-42.8C67.4 258 82 248.4 97.5 242l0 0c8.5-3.5 17.4-6.2 26.7-7.9zM43.3 259.3c-14.2 14.2-24.9 30.5-32.1 48C4 324.8 0 343.9 0 364v68c0 44.2 35.8 80 80 80h68c41.3 0 78.7-16.9 105.5-44.2c13.8-14 24.2-30.1 31.3-47.2c4-9.5 6.9-19.6 8.8-30c4.8-24.5 12.6-49.1 30.3-66.7s42.2-25.4 66.7-30.3c10.4-1.9 20.5-4.9 30-8.8c17.5-7.2 33.9-17.9 48.1-32.1c14.2-14.2 24.9-30.5 32.1-48C508 187.2 512 168.1 512 148V80c0-44.2-35.8-80-80-80H364c-41.3 0-78.7 16.9-105.5 44.2c-13.8 14-24.2 30.1-31.3 47.2c-4 9.5-6.9 19.6-8.8 30c-4.8 24.5-12.6 49.1-30.3 66.7s-42.2 25.4-66.7 30.3c-10.4 1.9-20.5 4.9-30 8.8c-17.5 7.2-33.9 17.9-48.1 32.1zM432 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM208 352a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM416 208a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faBuildingMagnifyingGlass = {
    prefix: 'fat',
    iconName: 'building-magnifying-glass',
    icon: [
      603,
      512,
      [],
      'e61c',
      
      'M45.5 15.1H316.6c16.6 0 30.1 13.5 30.1 30.1V170.7c4.9-2.8 9.9-5.4 15.1-7.6V45.2c0-25-20.2-45.2-45.2-45.2H45.5C20.5 0 .3 20.2 .3 45.2V436.7c0 24.9 20.2 45.2 45.2 45.2h90.4 15.1 60.2 15.1 90.4c24.1 0 43.8-18.9 45.1-42.7c-5.2-2.3-10.2-4.8-15-7.6v5.1c0 16.6-13.5 30.1-30.1 30.1H226.2V391.5c0-24.9-20.2-45.2-45.2-45.2s-45.2 20.2-45.2 45.2v75.3H45.5c-16.6 0-30.1-13.5-30.1-30.1V45.2c0-16.6 13.5-30.1 30.1-30.1zM263.9 218.4H233.7c-12.5 0-22.6 10.1-22.6 22.6v30.1c0 12.5 10.1 22.6 22.6 22.6h30.1c2.7 0 5.4-.5 7.8-1.4c1.2-19.9 6.2-38.8 14.3-55.9c-2.1-10.3-11.2-18.1-22.1-18.1zM211.1 466.8H150.9V391.5c0-16.6 13.5-30.1 30.1-30.1s30.1 13.5 30.1 30.1v75.3zM98.2 218.4c-12.5 0-22.6 10.1-22.6 22.6v30.1c0 12.5 10.1 22.6 22.6 22.6h30.1c12.5 0 22.6-10.1 22.6-22.6V240.9c0-12.5-10.1-22.6-22.6-22.6H98.2zm-7.5 22.6c0-4.2 3.4-7.5 7.5-7.5h30.1c4.2 0 7.5 3.4 7.5 7.5v30.1c0 4.2-3.4 7.5-7.5 7.5H98.2c-4.2 0-7.5-3.4-7.5-7.5V240.9zm143.1-7.5h30.1c4.2 0 7.5 3.4 7.5 7.5v30.1c0 4.2-3.4 7.5-7.5 7.5H233.7c-4.2 0-7.5-3.4-7.5-7.5V240.9c0-4.2 3.4-7.5 7.5-7.5zM98.2 97.9c-12.5 0-22.6 10.1-22.6 22.6v30.1c0 12.5 10.1 22.6 22.6 22.6h30.1c12.5 0 22.6-10.1 22.6-22.6V120.5c0-12.5-10.1-22.6-22.6-22.6H98.2zm-7.5 22.6c0-4.2 3.4-7.5 7.5-7.5h30.1c4.2 0 7.5 3.4 7.5 7.5v30.1c0 4.2-3.4 7.5-7.5 7.5H98.2c-4.2 0-7.5-3.4-7.5-7.5V120.5zm120.5 0v30.1c0 12.5 10.1 22.6 22.6 22.6h30.1c12.5 0 22.6-10.1 22.6-22.6V120.5c0-12.5-10.1-22.6-22.6-22.6H233.7c-12.5 0-22.6 10.1-22.6 22.6zm22.6-7.5h30.1c4.2 0 7.5 3.4 7.5 7.5v30.1c0 4.2-3.4 7.5-7.5 7.5H233.7c-4.2 0-7.5-3.4-7.5-7.5V120.5c0-4.2 3.4-7.5 7.5-7.5zm188.2 83a105.4 105.4 0 1 1 0 210.8 105.4 105.4 0 1 1 0-210.8zm0 225.9c30.6 0 58.5-11.4 79.7-30.1l88.2 88.2c2.9 2.9 7.7 2.9 10.6 0s2.9-7.7 0-10.6L512.3 381c18.7-21.2 30.1-49.1 30.1-79.7c0-66.5-53.9-120.5-120.5-120.5s-120.5 53.9-120.5 120.5s53.9 120.5 120.5 120.5z'
      
    ]
  };

  

  
  

  var faCakeSlice = {
    prefix: 'fat',
    iconName: 'cake-slice',
    icon: [
      512,
      512,
      [127856,"shortcake"],
      'e3e5',
      
      'M294.3 51.3c2.8-2.1 6.2-3.3 9.7-3.3c79.5 0 192 69.9 192 208H26.6L294.3 51.3zM16 272H496v.4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3H16V272zm480 96v.1 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .2 .3 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V368H496zM304 32c-7 0-13.9 2.3-19.4 6.6l-272 208C4.6 252.6 0 262 0 272V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.6 64-64v-.2-.2-.2-.2-.2V415v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V413v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V411v-.2-.2-.2-.2V410v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V406v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V401v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V398v-.2-.2-.2-.2-.2-.2-.2-.2V396v-.2-.2-.2-.2-.2-.2-.2-.2V394v-.2-.2-.2V393v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V390v-.2-.2-.2V389v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.3-.2-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V379v-.3-.3-.3V378v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V374v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V371v-.3-.3-.3-.3-.3-.3V369v-.3-.3-.3-.3-.3-.3V367v-.3-.3-.3-.3-.3-.3V365v-.3-.3-.3-.3-.3-.3V363v-.3-.3-.3-.3-.3-.3-.3-.3-.3V360v-.3-.3-.3-.3-.3-.3-.3-.3-.3V357v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V353v-.3-.3V352v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V346v-.3-.3V345v-.3-.3V344v-.3-.3V343v-.3-.3V342v-.3-.3V341v-.3-.3V340v-.3-.3V339v-.3-.3V338v-.3-.3V337v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.4-.4-.4V330v-.4-.4V329v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V325v-.4-.4V324v-.4-.4-.4-.4-.4-.4-.4V321v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V312v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V307v-.4-.4-.4-.4V305v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V297v-.4-.4-.4-.4V295v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V290v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V285v-.4-.4-.4-.4-.4-.4V282v-.4-.4-.4-.4-.4-.4V279v-.4-.4-.4-.4-.4-.4-.4-.4V275v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.5V267v-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5V262v-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5V256C512 107.7 390.9 32 304 32z'
      
    ]
  };

  
    var faShortcake = faCakeSlice;
  

  
  

  var faEquals = {
    prefix: 'fat',
    iconName: 'equals',
    icon: [
      448,
      512,
      [62764],
      '3d',
      
      'M24 160c-4.4 0-8 3.6-8 8s3.6 8 8 8H424c4.4 0 8-3.6 8-8s-3.6-8-8-8H24zm0 176c-4.4 0-8 3.6-8 8s3.6 8 8 8H424c4.4 0 8-3.6 8-8s-3.6-8-8-8H24z'
      
    ]
  };

  

  
  

  var faH2 = {
    prefix: 'fat',
    iconName: 'h2',
    icon: [
      640,
      512,
      [],
      'f314',
      
      'M16 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V248 440c0 4.4 3.6 8 8 8s8-3.6 8-8V256H304V440c0 4.4 3.6 8 8 8s8-3.6 8-8V248 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V240H16V72zm410.9 35.5c20.7-17.7 47-27.5 74.2-27.5h4.2c52.2 0 94.6 42.4 94.6 94.6c0 24.5-9.5 48-26.5 65.7L386.2 434.4c-2.2 2.3-2.9 5.7-1.6 8.7s4.2 4.9 7.4 4.9H624c4.4 0 8-3.6 8-8s-3.6-8-8-8H410.8L585 251.4c19.9-20.6 31-48.1 31-76.8C616 113.5 566.5 64 505.4 64h-4.2c-31.1 0-61.1 11.1-84.7 31.3l-21.7 18.6c-3.4 2.9-3.7 7.9-.9 11.3s7.9 3.7 11.3 .9l21.7-18.6z'
      
    ]
  };

  

  
  

  var faArrowRightFromLine = {
    prefix: 'fat',
    iconName: 'arrow-right-from-line',
    icon: [
      448,
      512,
      [8614,"arrow-from-left"],
      'f343',
      
      'M445.7 261.7c3.1-3.1 3.1-8.2 0-11.3l-136-136c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L420.7 248 104 248c-4.4 0-8 3.6-8 8s3.6 8 8 8l316.7 0L298.3 386.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l136-136zM16 72c0-4.4-3.6-8-8-8s-8 3.6-8 8L0 440c0 4.4 3.6 8 8 8s8-3.6 8-8L16 72z'
      
    ]
  };

  
    var faArrowFromLeft = faArrowRightFromLine;
  

  
  

  var faIslandTropical = {
    prefix: 'fat',
    iconName: 'island-tropical',
    icon: [
      512,
      512,
      [127965,"island-tree-palm"],
      'f811',
      
      'M168 16C94.1 16 58.2 58.5 49.9 90.2c-.4 1.4 0 2.6 .9 3.7C51.9 95.1 53.7 96 56 96h56V72c0-4.4 3.6-8 8-8s8 3.6 8 8V96h35c8.3-6.8 16.7-12.5 25.1-17.1c3.9-2.1 8.7-.7 10.9 3.1s.7 8.7-3.1 10.9c-11.8 6.5-23.8 15.4-35.7 27.3l-.1 .1c-52.2 52.2-47.6 107.6-31 135.9c.8 1.3 1.9 1.9 3.3 1.9c1.6 .1 3.5-.6 5.1-2.2l69.5-69.5-12.7-12.7c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l12.7 12.7 44.7-44.7c1.5-1.5 3.5-2.3 5.7-2.3H400V104c0-4.4 3.6-8 8-8s8 3.6 8 8v24h40c2.3 0 4.1-.9 5.2-2.1c1-1 1.3-2.2 .9-3.7C453.8 90.5 417.9 48 344 48c-26 0-47.3 5.3-64.2 13.4c-3.4 1.6-7.4 .7-9.7-2.2C252 36.3 219.1 16 168 16zM34.4 86.2C44.6 47.1 87.1 0 168 0c52.4 0 88.7 19.7 110.6 44.4C296.8 36.7 318.5 32 344 32c80.9 0 123.4 47.1 133.6 86.2c3.9 15-9 25.8-21.6 25.8H306.8c2 10.3 4 22.1 5.5 35.3c5.2 45.4 5 106.7-15.6 173C363.4 356.8 416 412.2 416 480c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32c0-70.7 57.3-128 128-128h42.5c26-58.4 37.4-113.8 42.3-154.9c1.2-10.5 2.1-20 2.6-28.4l-98.6 98.6c-8.9 8.9-25.7 10.3-33.5-3c-20-34.2-23.6-95.9 30.4-152.3H56c-12.6 0-25.5-10.8-21.6-25.8zM272.1 144l-7.9 7.9c-.3 12-1.2 28.1-3.5 47.1c-4.9 40.7-16 95.2-40.7 153h60.1c21.1-65.3 21.5-126.1 16.4-170.9c-1.6-14.1-3.7-26.6-5.9-37.1H272.1zM160 368C98.1 368 48 418.1 48 480c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16c0-61.9-50.1-112-112-112H160z'
      
    ]
  };

  
    var faIslandTreePalm = faIslandTropical;
  

  
  

  var faBracketSquare = {
    prefix: 'fat',
    iconName: 'bracket-square',
    icon: [
      192,
      512,
      ["bracket","bracket-left"],
      '5b',
      
      'M0 72C0 49.9 17.9 32 40 32H152c4.4 0 8 3.6 8 8s-3.6 8-8 8H40C26.7 48 16 58.7 16 72V440c0 13.3 10.7 24 24 24H152c4.4 0 8 3.6 8 8s-3.6 8-8 8H40c-22.1 0-40-17.9-40-40V72z'
      
    ]
  };

  
    var faBracket = faBracketSquare;
  
    var faBracketLeft = faBracketSquare;
  

  
  

  var faHighlighterLine = {
    prefix: 'fat',
    iconName: 'highlighter-line',
    icon: [
      576,
      512,
      [],
      'e1af',
      
      'M139.3 323.9l-35.7 35.7c-9.4 9.4-9.4 24.6 0 33.9l46.8 46.8c9.4 9.4 24.6 9.4 33.9 0l35.7-35.7c3-3 7.1-4.7 11.3-4.7h64c10.3 0 20-5 26-13.3l22.6-31.4L188.8 200.1l-31.4 22.6c-8.4 6-13.3 15.7-13.3 26v64c0 4.2-1.7 8.3-4.7 11.3zm214.1 18.1L520.8 108.9c4.7-6.5 7.2-14.3 7.2-22.4c0-10.2-4-19.9-11.2-27.1L484.6 27.2C477.4 20 467.7 16 457.5 16c-8 0-15.8 2.5-22.4 7.2L201.9 190.6 353.4 342.1zm-58 73.9h-64l-35.7 35.7c-15.6 15.6-40.9 15.6-56.6 0L92.3 404.9c-15.6-15.6-15.6-40.9 0-56.6L128 312.6v-64c0-15.5 7.4-30 20-39L425.8 10.2C435 3.6 446.1 0 457.5 0c14.4 0 28.2 5.7 38.4 15.9l32.2 32.2c10.2 10.2 15.9 24 15.9 38.4c0 11.4-3.6 22.5-10.2 31.7L334.4 396c-9 12.6-23.5 20-39 20zM70.7 417.3c3.1 3.1 3.1 8.2 0 11.3L18.6 480.7c-1.7 1.7-2.6 4-2.6 6.3c0 5 4 9 9 9H82.7c6.4 0 12.5-2.5 17-7l15.7-15.7c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L111 500.3c-7.5 7.5-17.7 11.7-28.3 11.7H25c-13.8 0-25-11.2-25-25c0-6.6 2.6-13 7.3-17.7l52.1-52.1c3.1-3.1 8.2-3.1 11.3 0zM232 496H568c4.4 0 8 3.6 8 8s-3.6 8-8 8H232c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faFlaskGear = {
    prefix: 'fat',
    iconName: 'flask-gear',
    icon: [
      640,
      512,
      [],
      'e5f1',
      
      'M313.5 230.4c-6.2-10.1-9.5-21.7-9.5-33.5V16l24 0c4.4 0 8-3.6 8-8s-3.6-8-8-8H304 288 160 144 120c-4.4 0-8 3.6-8 8s3.6 8 8 8l24 0V196.8c0 11.8-3.3 23.5-9.5 33.5L10.3 406.2C3.6 417.2 0 429.7 0 442.6C0 480.9 31.1 512 69.4 512H378.6c10.6 0 20.7-2.4 29.7-6.6c-2.3-5-3.6-10.4-4.1-15.9c-7.6 4.1-16.3 6.5-25.6 6.5H69.4C39.9 496 16 472.1 16 442.6c0-9.7 2.7-19.3 7.7-27.6l44.5-63H72 325.8c-6.2-4-11.5-9.5-15.4-16H79.5l68.1-96.4c.2-.3 .4-.6 .6-.8c7.8-12.6 11.9-27.1 11.9-41.9V16H288V196.8c0 14.8 4.1 29.3 11.9 41.9c.2 .3 .4 .6 .6 .8l19.1 27c1-1.8 1.9-3.6 3-5.3c1.9-3.3 3.9-6.6 6-9.7l-15-21.2zM452 218.5c9-2 18.4-3 28.1-3s19 1 28.1 3v18.1c0 13.8 8.3 25.5 19.4 31.8c11 6.3 25.2 7.7 37.1 .8l14.1-8.1c6.4 7 12.2 14.9 17.2 23.5c5 8.6 8.9 17.5 11.8 26.6l-14.6 8.4c-11.8 6.8-17.2 19.5-17.2 31.8s5.5 25 17.2 31.8l14.6 8.4c-2.9 9.1-6.8 18-11.8 26.6c-5 8.6-10.8 16.5-17.2 23.5l-14.1-8.2c-11.9-6.9-26.1-5.5-37.1 .8c-11.1 6.4-19.4 18-19.4 31.8l0 18.1c-9 2-18.4 3-28.1 3s-19-1-28.1-3V466.7c0-13.9-8.4-25.7-19.6-32.1c-11.1-6.3-25.3-7.7-37.3-.8l-13.9 8c-6.4-7-12.2-14.9-17.2-23.5s-8.9-17.5-11.8-26.6l14.3-8.2c11.8-6.8 17.3-19.6 17.3-32c0-12.4-5.5-25.2-17.3-32l-14.3-8.3c2.9-9.1 6.8-18 11.8-26.6s10.8-16.5 17.2-23.5l13.9 8c12 6.9 26.2 5.6 37.3-.8c11.2-6.4 19.6-18.1 19.6-32.1V218.5zm-4.7-15.4c-6.7 1.5-11.3 7.7-11.3 14.8v18.4c0 7.2-4.4 14.1-11.5 18.2c-7.1 4-15.2 4.4-21.4 .8L388.7 247c-6.1-3.5-13.8-2.7-18.5 2.4c-7.5 8.1-14.3 17.2-20.1 27.2s-10.3 20.4-13.5 31c-2 6.6 1 13.7 7.2 17.2l14.8 8.5c5.8 3.4 9.3 10.2 9.3 18.1c0 8-3.5 14.8-9.3 18.2l-14.8 8.5c-6.1 3.5-9.2 10.6-7.2 17.2c3.3 10.6 7.8 21 13.5 31s12.5 19.1 20.1 27.2c4.7 5.1 12.4 5.9 18.5 2.4l14.4-8.3c6.2-3.5 14.3-3.2 21.3 .8c7.1 4.1 11.5 11 11.5 18.2V485c0 7.1 4.6 13.3 11.3 14.8c10.5 2.4 21.5 3.7 32.7 3.7s22.2-1.3 32.7-3.7c6.7-1.5 11.3-7.7 11.3-14.8V466.4c0-7.1 4.3-13.9 11.4-18c7-4 15.1-4.4 21.2-.8l14.6 8.4c6.1 3.5 13.8 2.6 18.5-2.4c7.6-8.1 14.3-17.2 20.1-27.2s10.3-20.4 13.5-31c2-6.6-1-13.7-7.2-17.2l-15.1-8.7c-5.8-3.3-9.2-10.1-9.2-18s3.5-14.6 9.2-18l15.1-8.7c6.1-3.5 9.2-10.6 7.2-17.2c-3.3-10.6-7.8-21-13.5-31s-12.5-19.1-20.1-27.2c-4.7-5.1-12.4-5.9-18.5-2.4l-14.6 8.4c-6.1 3.5-14.2 3.2-21.2-.8c-7-4-11.4-10.9-11.4-18V218c0-7.1-4.6-13.3-11.3-14.8c-10.5-2.4-21.5-3.7-32.7-3.7s-22.2 1.3-32.7 3.7zM480 319.7a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faCopyright = {
    prefix: 'fat',
    iconName: 'copyright',
    icon: [
      512,
      512,
      [169],
      'f1f9',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm73.5-182.5c-40.6 40.6-106.5 40.6-147.1 0s-40.6-106.5 0-147.1s106.5-40.6 147.1 0c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3c-46.9-46.9-122.8-46.9-169.7 0s-46.9 122.8 0 169.7s122.8 46.9 169.7 0c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0z'
      
    ]
  };

  

  
  

  var faSymbols = {
    prefix: 'fat',
    iconName: 'symbols',
    icon: [
      512,
      512,
      [128291,"icons-alt"],
      'f86e',
      
      'M8 0H216c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8S3.6 0 8 0zM8 80H112 216c4.4 0 8 3.6 8 8s-3.6 8-8 8H120V216c0 4.4-3.6 8-8 8s-8-3.6-8-8V96H8c-4.4 0-8-3.6-8-8s3.6-8 8-8zM496 27.5c0-5-4.6-8.8-9.6-7.8l-128 25.6c-3.7 .7-6.4 4-6.4 7.8V208v0c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c19.1 0 36.3 6.3 48 16.2V53.1c0-11.4 8.1-21.3 19.3-23.5L483.3 4C498.1 1 512 12.4 512 27.5V176v0c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c19.1 0 36.3 6.3 48 16.3V27.5zM323.7 186.9c-8.6-6.4-21.1-10.9-35.7-10.9s-27.1 4.4-35.7 10.9s-12.3 14.1-12.3 21.1s3.8 14.7 12.3 21.1s21.1 10.9 35.7 10.9s27.1-4.4 35.7-10.9s12.3-14.1 12.3-21.1v0c0-7.1-3.8-14.7-12.3-21.1zm160-32c-8.6-6.4-21.1-10.9-35.7-10.9s-27.1 4.4-35.7 10.9s-12.3 14.1-12.3 21.1s3.8 14.7 12.3 21.1s21.1 10.9 35.7 10.9s27.1-4.4 35.7-10.9s12.3-14.1 12.3-21.1v0c0-7.1-3.8-14.7-12.3-21.1zM328 352a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-64a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm181.7 2.3c3.1 3.1 3.1 8.2 0 11.3l-208 208c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l208-208c3.1-3.1 8.2-3.1 11.3 0zM496 472a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-64 0a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM77.3 256h5.5c29.4 0 53.3 23.8 53.3 53.3c0 14.1-5.6 27.7-15.6 37.7L91.3 376l57.3 57.3L202.7 386c3.3-2.9 8.4-2.6 11.3 .8s2.6 8.4-.8 11.3L160 444.7l53.7 53.7c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-54.4-54.4L98.4 498.5C88.5 507.2 75.7 512 62.5 512H61.3C31.8 512 8 488.2 8 458.7c0-14.1 5.6-27.7 15.6-37.7L68.7 376 39.6 346.9c-10-10-15.6-23.5-15.6-37.7C24 279.8 47.8 256 77.3 256zm31.8 79.6c7-7 10.9-16.5 10.9-26.3c0-20.6-16.7-37.3-37.3-37.3H77.3C56.7 272 40 288.7 40 309.3c0 9.9 3.9 19.4 10.9 26.3L80 364.7l29.1-29.1zM34.9 432.4c-7 7-10.9 16.5-10.9 26.3C24 479.3 40.7 496 61.3 496h1.3c9.3 0 18.3-3.4 25.4-9.5l48.7-42.6L80 387.3 34.9 432.4z'
      
    ]
  };

  
    var faIconsAlt = faSymbols;
  

  
  

  var faRulerCombined = {
    prefix: 'fat',
    iconName: 'ruler-combined',
    icon: [
      512,
      512,
      [],
      'f546',
      
      'M192 208H104c-4.4 0-8 3.6-8 8s3.6 8 8 8h88l0 80H104c-4.4 0-8 3.6-8 8s3.6 8 8 8h88l0 88c0 4.4 3.6 8 8 8s8-3.6 8-8l0-88h80v88c0 4.4 3.6 8 8 8s8-3.6 8-8V320h80v88c0 4.4 3.6 8 8 8s8-3.6 8-8V320h48c26.5 0 48 21.5 48 48l0 80c0 26.5-21.5 48-48 48l-304 0H64c-23.2 0-42.6-16.4-47-38.3c-.6-3.1-1-6.4-1-9.7l0-80L16 64c0-26.5 21.5-48 48-48l80 0c26.5 0 48 21.5 48 48v48l-88 0c-4.4 0-8 3.6-8 8s3.6 8 8 8l88 0 0 80zm200 96H296 224 208V288l0-72 0-96 0 0 0 0V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V368v80c0 4.4 .4 8.7 1.3 12.9C7.3 490.1 33.1 512 64 512h80l304 0c35.3 0 64-28.7 64-64V368c0-35.3-28.7-64-64-64H392z'
      
    ]
  };

  

  
  

  var faSquareQ = {
    prefix: 'fat',
    iconName: 'square-q',
    icon: [
      448,
      512,
      [],
      'e27b',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM112 256c0 61.9 50.1 112 112 112c28 0 53.7-10.3 73.3-27.3l-61.9-61.9c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l61.9 61.9C325.7 309.7 336 284 336 256c0-61.9-50.1-112-112-112s-112 50.1-112 112zm240 0c0 32.5-12.1 62.1-32 84.7l29.7 29.7c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L308.7 352c-22.6 19.9-52.2 32-84.7 32c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128z'
      
    ]
  };

  

  
  

  var faLinesLeaning = {
    prefix: 'fat',
    iconName: 'lines-leaning',
    icon: [
      384,
      512,
      [],
      'e51e',
      
      'M376 32c-4.4 0-8 3.6-8 8V472c0 4.4 3.6 8 8 8s8-3.6 8-8V40c0-4.4-3.6-8-8-8zm-94 .3c-4.3-1.1-8.6 1.5-9.8 5.7l-112 432c-1.1 4.3 1.5 8.6 5.7 9.8s8.6-1.5 9.8-5.7l112-432c1.1-4.3-1.5-8.6-5.7-9.8zM175.5 42.8c1.5-4.1-.6-8.7-4.7-10.3s-8.7 .6-10.3 4.7L.5 469.2c-1.5 4.1 .6 8.7 4.7 10.3s8.7-.6 10.3-4.7l160-432z'
      
    ]
  };

  

  
  

  var faArrowDownToBracket = {
    prefix: 'fat',
    iconName: 'arrow-down-to-bracket',
    icon: [
      448,
      512,
      [],
      'e094',
      
      'M365.7 213.7l-136 136c-3.1 3.1-8.2 3.1-11.3 0l-136-136c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L216 324.7 216 8c0-4.4 3.6-8 8-8s8 3.6 8 8l0 316.7L354.3 202.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3zM16 328l0 96c0 39.8 32.2 72 72 72l272 0c39.8 0 72-32.2 72-72l0-96c0-4.4 3.6-8 8-8s8 3.6 8 8l0 96c0 48.6-39.4 88-88 88L88 512c-48.6 0-88-39.4-88-88l0-96c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faArrowDownUpLock = {
    prefix: 'fat',
    iconName: 'arrow-down-up-lock',
    icon: [
      640,
      512,
      [],
      'e4b0',
      
      'M133.7 509.7l96-96c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L136 484.7V264H416.3c.4-5.5 1.2-10.8 2.3-16H328V27.3l82.3 82.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-96-96c-3.1-3.1-8.2-3.1-11.3 0l-96 96c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L312 27.3V248H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H120V484.7L37.7 402.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l96 96c3.1 3.1 8.2 3.1 11.3 0zM136 192V40c0-4.4-3.6-8-8-8s-8 3.6-8 8V192h16zM328 320H312V472c0 4.4 3.6 8 8 8s8-3.6 8-8V320zM528 208c26.5 0 48 21.5 48 48v64H480V256c0-26.5 21.5-48 48-48zm-64 48v64H448c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H592V256c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-16 80h16 16 96 16 16c8.8 0 16 7.2 16 16V480c0 8.8-7.2 16-16 16H448c-8.8 0-16-7.2-16-16V352c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faTrashArrowUp = {
    prefix: 'fat',
    iconName: 'trash-arrow-up',
    icon: [
      448,
      512,
      ["trash-restore"],
      'f829',
      
      'M157.4 27.3L134.4 64H313.6l-23-36.7c-4.4-7-12.1-11.3-20.4-11.3H177.7c-8.3 0-16 4.3-20.4 11.3zM115.6 64l28.2-45.2C151.1 7.1 163.9 0 177.7 0h92.5c13.8 0 26.6 7.1 33.9 18.8L332.4 64H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H115.6zM39.3 112c4.4-.4 8.3 2.9 8.6 7.3l28.3 340C78 480.1 95.4 496 116.2 496H331.8c20.8 0 38.1-15.9 39.9-36.7l28.3-340c.4-4.4 4.2-7.7 8.6-7.3s7.7 4.2 7.3 8.6l-28.3 340c-2.4 29-26.7 51.4-55.8 51.4H116.2c-29.1 0-53.4-22.3-55.8-51.4L32 120.7c-.4-4.4 2.9-8.3 7.3-8.6zM224 176c2.1 0 4.2 .8 5.7 2.3l80 80c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L232 203.3V392c0 4.4-3.6 8-8 8s-8-3.6-8-8V203.3l-66.3 66.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l80-80c1.5-1.5 3.5-2.3 5.7-2.3z'
      
    ]
  };

  
    var faTrashRestore = faTrashArrowUp;
  

  
  

  var faKeySkeleton = {
    prefix: 'fat',
    iconName: 'key-skeleton',
    icon: [
      448,
      512,
      [128477],
      'f6f3',
      
      'M304 16a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272c79.5 0 144-64.5 144-144S383.5 0 304 0S160 64.5 160 144c0 36.9 13.9 70.5 36.7 96L2.3 434.3c-3.1 3.1-3.1 8.2 0 11.3l64 64c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L19.3 440 72 387.3l58.3 58.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L83.3 376 208 251.3c25.5 22.8 59.1 36.7 96 36.7z'
      
    ]
  };

  

  
  

  var faDownFromBracket = {
    prefix: 'fat',
    iconName: 'down-from-bracket',
    icon: [
      448,
      512,
      [],
      'e66b',
      
      'M232 492.7c-2.1 2.1-5 3.3-8 3.3s-5.9-1.2-8-3.3L84.2 360.6c-2.7-2.7-4.2-6.4-4.2-10.2c0-8 6.5-14.4 14.4-14.4l73.6 0c4.4 0 8-3.6 8-8l0-136c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 136c0 4.4 3.6 8 8 8l73.6 0c8 0 14.4 6.5 14.4 14.4c0 3.8-1.5 7.5-4.2 10.2L232 492.7zM224 512c7.2 0 14.2-2.9 19.3-8L375.1 371.9c5.7-5.7 8.9-13.4 8.9-21.5c0-16.8-13.6-30.4-30.4-30.4L288 320l0-128c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 128-65.6 0C77.6 320 64 333.6 64 350.4c0 8.1 3.2 15.8 8.9 21.5L204.7 504c5.1 5.1 12.1 8 19.3 8zM432 184c0 4.4 3.6 8 8 8s8-3.6 8-8l0-96c0-48.6-39.4-88-88-88L88 0C39.4 0 0 39.4 0 88l0 96c0 4.4 3.6 8 8 8s8-3.6 8-8l0-96c0-39.8 32.2-72 72-72l272 0c39.8 0 72 32.2 72 72l0 96z'
      
    ]
  };

  

  
  

  var faTractor = {
    prefix: 'fat',
    iconName: 'tractor',
    icon: [
      640,
      512,
      [128668],
      'f722',
      
      'M112 40c0-13.3 10.7-24 24-24H267.3c9.4 0 18 5.5 21.9 14.2L347.6 160h-.4-.8-.8-.8-.8-.8-.8-.8-.8-.8-.8-.8-.8-.8-.8-.8-.8-.8-.8-.8H332h-.8-.8-.8H329h-.8-.8-.8H326h-.8-.8-.8-.8-.8-.8-.8-.8-.8-.8-.8-.8-.8-.8-.8-.8H313h-.8-.8-.8H310h-.8-.8-.8H307h-.8-.8-.8-.8-.8-.8-.8-.8-.8-.8-.8-.8-.8-.8-.8-.8-.8-.8-.8-.8H291h-.8-.8-.8H288c-4.4 0-8 3.6-8 8s3.6 8 8 8h.8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .5 .4 .6 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .7 .8 .8 .7 .7 .8 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .1 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .4 .5 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3c8.8 0 16 7.2 16 16v63c0 3.9-1.4 7.6-4 10.5l-35.7 40.8c-7.6 8.7-18.6 13.7-30.1 13.7H352v-.9c0-20.6-15.6-37.8-36-39.8l-2.6-.3 1.6-2c13-15.9 11.9-39.1-2.7-53.6l-23.8-23.8c-14.5-14.5-37.7-15.7-53.6-2.7l-2 1.6-.3-2.6c-2-20.4-19.3-36-39.8-36H159.1c-20.6 0-37.8 15.6-39.8 36l-.3 2.6-2-1.6c-15.9-13-39.1-11.9-53.6 2.7L39.6 223.5C25.1 238 23.9 261.2 37 277.1l1.6 2-2.6 .3c-20.4 2-36 19.3-36 39.8v33.7c0 20.6 15.6 37.8 36 39.8l2.6 .3-1.6 2c-13 15.9-11.9 39.1 2.7 53.6l23.8 23.8c14.5 14.5 37.7 15.7 53.6 2.7l2-1.6 .3 2.6c2 20.4 19.3 36 39.8 36h33.7c20.6 0 37.8-15.6 39.8-36l.3-2.6 2 1.6c15.9 13 39.1 11.9 53.6-2.7l23.8-23.8c14.5-14.5 15.7-37.7 2.7-53.6l-1.6-2 2.6-.3c20.4-2 36-19.3 36-39.8V336H554.2c16.2 0 31.5-7 42.1-19.1l35.7-40.8c5.1-5.8 7.9-13.3 7.9-21.1V192c0-17.7-14.3-32-32-32h-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3H602h-.4-.4H601h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H595h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H587h-.4-.4-.4-.4-.4-.4H584h-.4-.4-.4-.4-.4-.4H581h-.4-.4-.4-.4-.5-.4-.5-.5H577h-.5H576h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H569h-.5H568h-.5H567h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H558h-.5H557h-.5H556h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H548h-.5-.5-.5-.5-.5-.5-.5-.6-.6-.6H542h-.6-.6-.6-.6-.6-.6-.6-.6H537h-.6-.6-.6-.6-.6-.6H533h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H526h-.6-.6-.6-.6H523h-.6-.6-.6-.6H520h-.6-.6-.6-.6H517h-.6-.6-.6-.6H514h-.6-.6-.6H512V111.8c0-23.3 9.3-45.7 25.8-62.2l3.9-3.9c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-3.9 3.9C507 57.7 496 84.2 496 111.8V160h-.2-.6-.6-.6-.6-.6-.6-.6-.6H490h-.6-.7H488h-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7H468h-.7-.7H466h-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7H455h-.7-.7-.7-.7-.7-.7-.7-.7-.7H448h-.7-.7-.7-.7-.7-.7-.7-.7-.7H441h-.7-.7-.7-.7-.7-.7H436h-.7-.7-.7-.7-.7-.7H431h-.7-.7-.7-.7-.7-.7H426h-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7H418h-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7H410h-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7H399h-.7-.7-.7H396h-.7-.7-.7H393h-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.8-.7-.7-.8-.8-.7-.8-.8-.8-.8-.8-.8-.8-.8-.8-.2L303.8 23.6C297.3 9.2 283 0 267.3 0H136C113.9 0 96 17.9 96 40V160c0 4.4 3.6 8 8 8s8-3.6 8-8V40zM336 328v24.9c0 12.3-9.3 22.7-21.6 23.9l-11 1.1c-3 .3-5.6 2.3-6.7 5.1c-.7 1.8-1.4 3.5-2.2 5.3c-1.2 2.8-.8 6 1.1 8.3l7 8.6c7.8 9.5 7.1 23.4-1.6 32.2l-23.8 23.8c-8.7 8.7-22.6 9.4-32.2 1.6l-8.6-7c-2.3-1.9-5.5-2.3-8.3-1.1c-1.7 .8-3.5 1.5-5.3 2.2c-2.8 1.1-4.8 3.7-5.1 6.7l-1.1 11c-1.2 12.3-11.6 21.6-23.9 21.6H159.1c-12.3 0-22.7-9.3-23.9-21.6l-1.1-11c-.3-3-2.3-5.6-5.1-6.7c-1.8-.7-3.5-1.4-5.3-2.2c-2.8-1.2-6-.8-8.3 1.1l-8.6 7c-9.5 7.8-23.4 7.1-32.2-1.6L50.9 437.2c-8.7-8.7-9.4-22.6-1.6-32.2l7-8.6c1.9-2.3 2.3-5.5 1.1-8.3c-.8-1.7-1.5-3.5-2.2-5.3c-1.1-2.8-3.7-4.8-6.7-5.1l-11-1.1C25.3 375.5 16 365.2 16 352.9V319.1c0-12.3 9.3-22.7 21.6-23.9l11-1.1c3-.3 5.6-2.3 6.7-5.1c.7-1.8 1.4-3.5 2.2-5.3c1.2-2.8 .8-6-1.1-8.3l-7-8.6c-7.8-9.5-7.1-23.4 1.6-32.2l23.8-23.8c8.7-8.7 22.6-9.4 32.2-1.6l8.6 7c2.3 1.9 5.5 2.3 8.3 1.1c1.7-.8 3.5-1.5 5.3-2.2c2.8-1.1 4.8-3.7 5.1-6.7l1.1-11c1.2-12.3 11.6-21.6 23.9-21.6h33.7c12.3 0 22.7 9.3 23.9 21.6l1.1 11c.3 3 2.3 5.6 5.1 6.7c1.8 .7 3.5 1.4 5.3 2.2c2.8 1.2 6 .8 8.3-1.1l8.6-7c9.5-7.8 23.4-7.1 32.2 1.6l23.8 23.8c8.7 8.7 9.4 22.6 1.6 32.2l-7 8.6c-1.9 2.3-2.3 5.5-1.1 8.3c.8 1.7 1.5 3.5 2.2 5.3c1.1 2.8 3.7 4.8 6.7 5.1l11 1.1c12.3 1.2 21.6 11.6 21.6 23.9V328zm200 56a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm0 128a72 72 0 1 0 0-144 72 72 0 1 0 0 144zM240 336a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zm-64-80a80 80 0 1 0 0 160 80 80 0 1 0 0-160z'
      
    ]
  };

  

  
  

  var faQuoteLeft = {
    prefix: 'fat',
    iconName: 'quote-left',
    icon: [
      448,
      512,
      [8220,"quote-left-alt"],
      'f10d',
      
      'M0 216C0 149.7 53.7 96 120 96h16c4.4 0 8 3.6 8 8s-3.6 8-8 8H120C62.6 112 16 158.6 16 216v34.7C29.2 234.4 49.4 224 72 224h48c39.8 0 72 32.2 72 72v48c0 39.8-32.2 72-72 72H72c-39.8 0-72-32.2-72-72V312 296 216zm16 96v32c0 30.9 25.1 56 56 56h48c30.9 0 56-25.1 56-56V296c0-30.9-25.1-56-56-56H72c-30.9 0-56 25.1-56 56v16zm240-96c0-66.3 53.7-120 120-120h16c4.4 0 8 3.6 8 8s-3.6 8-8 8H376c-57.4 0-104 46.6-104 104v34.7c13.2-16.3 33.4-26.7 56-26.7h48c39.8 0 72 32.2 72 72v48c0 39.8-32.2 72-72 72H328c-39.8 0-72-32.2-72-72V312 296 216zm16 96v32c0 30.9 25.1 56 56 56h48c30.9 0 56-25.1 56-56V296c0-30.9-25.1-56-56-56H328c-30.9 0-56 25.1-56 56v16z'
      
    ]
  };

  
    var faQuoteLeftAlt = faQuoteLeft;
  

  
  

  var faUsersLine = {
    prefix: 'fat',
    iconName: 'users-line',
    icon: [
      640,
      512,
      [],
      'e592',
      
      'M147.2 48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm110.4-16a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm144 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm48 208c0 8.8-7.2 16-16 16h-224c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80h96c44.2 0 80 35.8 80 80zm-176-96c-53 0-96 43-96 96c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32c0-53-43-96-96-96h-96zM0 456c0 4.4 3.6 8 8 8H632c4.4 0 8-3.6 8-8s-3.6-8-8-8H8c-4.4 0-8 3.6-8 8zM48 256c0-26.5 21.5-48 48-48h96c4.8 0 9.4 .7 13.7 2c4.2 1.3 8.7-1.2 9.9-5.4s-1.2-8.7-5.4-9.9c-5.8-1.7-11.9-2.7-18.3-2.7H96c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32h88c4.4 0 8-3.6 8-8s-3.6-8-8-8H64c-8.8 0-16-7.2-16-16zM496 48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm99.2 96c0 8.8-7.2 16-16 16h-88c-4.4 0-8 3.6-8 8s3.6 8 8 8h88c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64h-96c-6.3 0-12.5 .9-18.3 2.7c-4.2 1.3-6.6 5.7-5.4 9.9s5.7 6.6 9.9 5.4c4.3-1.3 8.9-2 13.7-2h96c26.5 0 48 21.5 48 48z'
      
    ]
  };

  

  
  

  var faBaby = {
    prefix: 'fat',
    iconName: 'baby',
    icon: [
      448,
      512,
      [],
      'f77c',
      
      'M313.5 237c14.2-6.3 27.7-14.1 40.4-23.3l36.2-26.4c10.7-7.8 13.1-22.8 5.3-33.5s-22.8-13.1-33.5-5.3l-36.2 26.4C296.1 196.4 260.5 208 224 208s-72.1-11.6-101.6-33.1L86.1 148.6c-10.7-7.8-25.7-5.4-33.5 5.3s-5.4 25.7 5.3 33.5l36.2 26.4c12.7 9.2 26.2 17 40.4 23.3c5.8 2.6 9.5 8.3 9.5 14.6V288l160 0V251.7c0-6.3 3.7-12.1 9.5-14.6zM144 304v16.7L198 368h52l54-47.3V304H144zm162.4 35.9L269.7 372c.9 .8 1.8 1.8 2.5 2.8l24.8 35.4c4.5 6.4 3.7 15-1.8 20.5L271 455c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c8.2-8.2 9.4-21.2 2.7-30.7l-48.8-69.7c-.2-.2-.3-.5-.5-.7zM178.3 372l-36.7-32.1c-.1 .2-.3 .5-.5 .7L92.3 410.2c-6.7 9.5-5.5 22.5 2.7 30.7l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-24.3-24.3c-5.5-5.5-6.2-14.1-1.8-20.5l24.8-35.4c.7-1.1 1.6-2 2.5-2.8zM320 288l0 16v24 3.4l48.8 69.7c11.1 15.9 9.2 37.5-4.5 51.2l-48 48c-15.6 15.6-40.9 15.6-56.6 0s-15.6-40.9 0-56.6L284 419.4 259.2 384H256 192h-3.2L164 419.4l24.3 24.3c15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-48-48C70 438.6 68.1 417 79.2 401.1L128 331.4V328 304l0-16V251.7c-15.2-6.7-29.7-15.1-43.3-25L48.5 200.3c-17.9-13-21.8-38-8.8-55.9s38-21.8 55.9-8.8L131.8 162c26.8 19.5 59.1 30 92.2 30s65.4-10.5 92.2-30l36.2-26.4c17.9-13 42.9-9 55.9 8.8s9 42.9-8.8 55.9l-36.2 26.4c-13.6 9.9-28.1 18.2-43.3 25V288zM280 88A56 56 0 1 0 168 88a56 56 0 1 0 112 0zM152 88a72 72 0 1 1 144 0A72 72 0 1 1 152 88z'
      
    ]
  };

  

  
  

  var faCirclePhoneFlip = {
    prefix: 'fat',
    iconName: 'circle-phone-flip',
    icon: [
      512,
      512,
      ["phone-circle-alt"],
      'e11c',
      
      'M256 496a240 240 0 1 0 0-480 240 240 0 1 0 0 480zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm67.2 136.4c-5.8-1.6-11.9 1.4-14.2 7l-20 48c-2 4.9-.6 10.5 3.5 13.9l24.7 20.2c2.8 2.3 3.7 6.3 2.2 9.6c-17.4 36.9-47.3 66.7-84.2 84.2c-3.3 1.6-7.3 .7-9.6-2.2l-20.2-24.7c-3.4-4.1-9-5.5-13.9-3.5l-48 20c-5.6 2.3-8.5 8.4-7 14.2l12 44c1.4 5.2 6.2 8.8 11.6 8.8c119.3 0 216-96.7 216-216c0-5.4-3.6-10.2-8.8-11.6l-44-12zm-29 .8c5.4-13 19.6-19.9 33.2-16.2l44 12c12.2 3.3 20.6 14.4 20.6 27c0 128.1-103.9 232-232 232c-12.6 0-23.7-8.5-27-20.6l-12-44c-3.7-13.6 3.3-27.8 16.2-33.2l48-20c11.4-4.8 24.6-1.5 32.4 8.1L233.8 302c29.1-15.2 53-39.1 68.2-68.2l-19.7-16.1c-9.6-7.8-12.9-21-8.1-32.4l20-48z'
      
    ]
  };

  
    var faPhoneCircleAlt = faCirclePhoneFlip;
  

  
  

  var faBuildingShield = {
    prefix: 'fat',
    iconName: 'building-shield',
    icon: [
      576,
      512,
      [],
      'e4d8',
      
      'M48 16H336c17.7 0 32 14.3 32 32V213.4l16-6.4V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96 16 64 16 96c6.7 0 13.1-1.4 18.9-3.9c-5.2-4-10.2-8.1-15-12.4c-1.3 .2-2.6 .2-4 .2H240V416c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-17.7 0-32-14.3-32-32V48c0-17.7 14.3-32 32-32zM280 232H248c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h8.5c-.3-5.5-.5-10.8-.5-15.8l0-.2h-8c-4.4 0-8-3.6-8-8V256c0-4.4 3.6-8 8-8h32c.9 0 1.8 .2 2.7 .5c2.7-1.7 5.5-3.1 8.5-4.3l7.6-3c-4.4-5.5-11.2-9.1-18.8-9.1zM224 496H160V416c0-17.7 14.3-32 32-32s32 14.3 32 32v80zM104 232c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V256c0-13.3-10.7-24-24-24H104zm-8 24c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8V256zm8-152c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V128c0-13.3-10.7-24-24-24H104zm-8 24c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8V128zm128 0v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V128c0-13.3-10.7-24-24-24H248c-13.3 0-24 10.7-24 24zm24-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H248c-4.4 0-8-3.6-8-8V128c0-4.4 3.6-8 8-8zm61 168.6l115-46V493.3c-96.1-42.9-120-138-120-197.3c0-3.3 2-6.2 5-7.4zM560 296c0 59.3-23.9 154.4-120 197.3V242.6l115 46c3 1.2 5 4.2 5 7.4zM440.9 225.7c-5.7-2.3-12.1-2.3-17.8 0l-120 48C294 277.4 288 286.2 288 296c0 63.3 25.9 168.8 134.8 214.2c5.9 2.5 12.6 2.5 18.5 0C550.1 464.8 576 359.3 576 296c0-9.8-6-18.6-15.1-22.3l-120-48z'
      
    ]
  };

  

  
  

  var faCartCircleXmark = {
    prefix: 'fat',
    iconName: 'cart-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e3f4',
      
      'M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8H45.7C57.1 16 67 24.1 69.2 35.4l59.4 303.4c5.1 26.3 28.2 45.2 55 45.2H320.7c-.5-5.3-.7-10.6-.7-16H183.5c-19.1 0-35.6-13.5-39.3-32.3L134.9 288H339.2c2.8-5.5 5.9-10.8 9.3-16H131.8L88 48H527.7c15.5 0 26.9 14.4 23.4 29.5L523.8 194.2c5.3 .8 10.5 1.9 15.7 3.2L566.6 81.1C572.5 56 553.4 32 527.7 32H84.8C81 13.4 64.7 0 45.7 0H8zM144 464a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm144-96a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-82.3-50.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L496 356.7l-50.3-50.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L484.7 368l-50.3 50.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L496 379.3l50.3 50.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L507.3 368l50.3-50.3z'
      
    ]
  };

  

  
  

  var faFaceSmileTongue = {
    prefix: 'fat',
    iconName: 'face-smile-tongue',
    icon: [
      512,
      512,
      [],
      'e394',
      
      'M16 256C16 123.5 123.5 16 256 16s240 107.5 240 240c0 10.5-.7 20.8-2 31c-.6 4.4 2.5 8.4 6.9 9s8.4-2.5 9-6.9c1.4-10.8 2.1-21.8 2.1-33C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c48.3 0 93.6-13.4 132.1-36.7c3.8-2.3 5-7.2 2.7-11s-7.2-5-11-2.7C343.7 483.4 301.3 496 256 496C123.5 496 16 388.5 16 256zm134.9-70.3c7.6-11.6 16.1-17.7 24.9-17.7s17.3 6.1 24.9 17.7c7.4 11.4 12.7 26.3 15.2 39.8c.8 4.3 5 7.2 9.3 6.4s7.2-5 6.4-9.3c-2.8-15-8.7-32-17.6-45.6c-8.7-13.3-21.5-25-38.3-25s-29.6 11.7-38.3 25c-8.8 13.5-14.8 30.6-17.6 45.6c-.8 4.3 2 8.5 6.4 9.3s8.5-2 9.3-6.4c2.5-13.5 7.8-28.4 15.2-39.8zm160 0c7.6-11.6 16.1-17.7 24.9-17.7s17.3 6.1 24.9 17.7c7.4 11.4 12.7 26.3 15.2 39.8c.8 4.3 5 7.2 9.3 6.4s7.2-5 6.4-9.3c-2.8-15-8.7-32-17.6-45.6c-8.7-13.3-21.5-25-38.3-25s-29.6 11.7-38.3 25c-8.8 13.5-14.8 30.6-17.6 45.6c-.8 4.3 2 8.5 6.4 9.3s8.5-2 9.3-6.4c2.5-13.5 7.8-28.4 15.2-39.8zM103.7 285.9c-1.1-4.3-5.5-6.8-9.8-5.7s-6.8 5.5-5.7 9.8C108.8 367.1 175.9 424 256 424c31.3 0 60.6-8.7 85.9-23.8l56.4 34.3c33.8 20.6 78 9.3 97.8-25c19.7-34.1 8.6-78.4-25.5-98.5l-50.3-29.6c-.7-.4-1.4-.7-2.2-.9c-4.3-1.1-8.7 1.4-9.8 5.7C389.4 356.7 328.1 408 256 408s-133.4-51.3-152.3-122.1zM406.6 420.7l-50.1-30.4c29.5-22.1 52.2-53.6 64.2-90.2l41.7 24.5c26.4 15.6 35.2 50 19.8 76.7c-15.3 26.5-49.4 35.3-75.6 19.4z'
      
    ]
  };

  

  
  

  var faPesoSign = {
    prefix: 'fat',
    iconName: 'peso-sign',
    icon: [
      384,
      512,
      [],
      'e222',
      
      'M48 63.3C48 46 62 32 79.3 32H184c70.1 0 129.1 47.5 146.7 112H376c4.4 0 8 3.6 8 8s-3.6 8-8 8H334.1c1.2 7.8 1.9 15.8 1.9 24c0 13.8-1.8 27.3-5.3 40H376c4.4 0 8 3.6 8 8s-3.6 8-8 8H325.4c-22.3 56.2-77.2 96-141.4 96H64V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V328 240H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H48V160H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H48V63.3zM64 240v80H184c55.1 0 102.6-32.8 124-80H64zm250-16c3.9-12.6 6-26.1 6-40c0-8.2-.7-16.2-2.1-24H64v64H314zM184 48H79.3C70.9 48 64 54.9 64 63.3V144H314c-17.1-55.6-68.8-96-130-96z'
      
    ]
  };

  

  
  

  var faClawMarks = {
    prefix: 'fat',
    iconName: 'claw-marks',
    icon: [
      576,
      512,
      [],
      'f6c2',
      
      'M34.3 2.3c3.1-3.1 8.2-3.1 11.3 0L165.3 121.9c12 12 18.7 28.3 18.7 45.3V200h32.8c17 0 33.3 6.7 45.3 18.7l95.2 95.2c12 12 18.7 28.3 18.7 45.3V392h32.8c17 0 33.3 6.7 45.3 18.7l87.6 87.6c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-87.6-87.6c-9-9-21.2-14.1-33.9-14.1H368c-4.4 0-8-3.6-8-8V359.2c0-12.7-5.1-24.9-14.1-33.9l-95.2-95.2c-9-9-21.2-14.1-33.9-14.1H176c-4.4 0-8-3.6-8-8V167.2c0-12.7-5.1-24.9-14.1-33.9L34.3 13.7c-3.1-3.1-3.1-8.2 0-11.3zm0 224c3.1-3.1 8.2-3.1 11.3 0l89.9 89.9C146.1 326.8 152 341 152 355.9V392h36.1c14.9 0 29.1 5.9 39.6 16.4l89.9 89.9c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-89.9-89.9c-7.5-7.5-17.7-11.7-28.3-11.7H144c-4.4 0-8-3.6-8-8V355.9c0-10.6-4.2-20.8-11.7-28.3L34.3 237.7c-3.1-3.1-3.1-8.2 0-11.3zM269.7 2.3l25.9 25.9C306.1 38.8 312 53 312 67.9V104h36.1c14.9 0 29.1 5.9 39.6 16.4l35.9 35.9C434.1 166.8 440 181 440 195.9V232h36.1c14.9 0 29.1 5.9 39.6 16.4l25.9 25.9c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-25.9-25.9c-7.5-7.5-17.7-11.7-28.3-11.7H432c-4.4 0-8-3.6-8-8V195.9c0-10.6-4.2-20.8-11.7-28.3l-35.9-35.9c-7.5-7.5-17.7-11.7-28.3-11.7H304c-4.4 0-8-3.6-8-8V67.9c0-10.6-4.2-20.8-11.7-28.3L258.3 13.7c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0z'
      
    ]
  };

  

  
  

  var faRhombus = {
    prefix: 'fat',
    iconName: 'rhombus',
    icon: [
      448,
      512,
      [],
      'e23b',
      
      'M242.3 24.4C237.7 19.1 231 16 224 16s-13.7 3.1-18.3 8.4l-184 216c-7.6 9-7.6 22.2 0 31.1l184 216c4.6 5.4 11.2 8.4 18.3 8.4s13.7-3.1 18.3-8.4l184-216c7.6-9 7.6-22.2 0-31.1l-184-216zM224 0c11.7 0 22.8 5.1 30.4 14.1l184 216c12.7 14.9 12.7 36.9 0 51.9l-184 216c-7.6 8.9-18.7 14.1-30.4 14.1s-22.8-5.1-30.4-14.1l-184-216C-3.2 267-3.2 245 9.6 230.1l184-216C201.2 5.1 212.3 0 224 0z'
      
    ]
  };

  

  
  

  var faChalkboardUser = {
    prefix: 'fat',
    iconName: 'chalkboard-user',
    icon: [
      640,
      512,
      ["chalkboard-teacher"],
      'f51c',
      
      'M576 16H224c-26.5 0-48 21.5-48 48V97c-5.2-.7-10.6-1-16-1V64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H544h-8H392h-8H336.8c-2.5-5.5-5.4-10.8-8.5-16H384V360c0-22.1 17.9-40 40-40h80c22.1 0 40 17.9 40 40v40h32c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48zM528 400V360c0-13.3-10.7-24-24-24H424c-13.3 0-24 10.7-24 24v40H528zM240 224A80 80 0 1 0 80 224a80 80 0 1 0 160 0zM64 224a96 96 0 1 1 192 0A96 96 0 1 1 64 224zM16 485.3c0 5.9 4.8 10.7 10.7 10.7H293.3c5.9 0 10.7-4.8 10.7-10.7C304 420.5 251.5 368 186.7 368H133.3C68.5 368 16 420.5 16 485.3zm-16 0C0 411.7 59.7 352 133.3 352h53.3C260.3 352 320 411.7 320 485.3c0 14.7-11.9 26.7-26.7 26.7H26.7C11.9 512 0 500.1 0 485.3z'
      
    ]
  };

  
    var faChalkboardTeacher = faChalkboardUser;
  

  
  

  var faArrowsUpDownLeftRight = {
    prefix: 'fat',
    iconName: 'arrows-up-down-left-right',
    icon: [
      512,
      512,
      ["arrows"],
      'f047',
      
      'M173.7 410.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l88 88c3.1 3.1 8.2 3.1 11.3 0l88-88c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L264 484.7V264H484.7l-74.3 74.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l88-88c3.1-3.1 3.1-8.2 0-11.3l-88-88c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L484.7 248H264V27.3l74.3 74.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-88-88c-3.1-3.1-8.2-3.1-11.3 0l-88 88c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L248 27.3V248H27.3l74.3-74.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-88 88c-3.1 3.1-3.1 8.2 0 11.3l88 88c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L27.3 264H248l0 220.7-74.3-74.3z'
      
    ]
  };

  
    var faArrows = faArrowsUpDownLeftRight;
  

  
  

  var faFaceSmirking = {
    prefix: 'fat',
    iconName: 'face-smirking',
    icon: [
      512,
      512,
      [],
      'e397',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm383.9 89.3l-.2 1.2c-5.1 30.9-31.8 53.5-63.1 53.5H200c-4.4 0-8-3.6-8-8s3.6-8 8-8H320.6c23.5 0 43.5-17 47.3-40.1l.2-1.2c.7-4.4 4.8-7.3 9.2-6.6s7.3 4.8 6.6 9.2zM104 192h72c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32c0-5.8 1.6-11.3 4.3-16H104c-4.4 0-8-3.6-8-8s3.6-8 8-8zm72 16a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm112-8c0-4.4 3.6-8 8-8h72c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32c0-5.8 1.6-11.3 4.3-16H296c-4.4 0-8-3.6-8-8zm64 24a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z'
      
    ]
  };

  

  
  

  var faXmark = {
    prefix: 'fat',
    iconName: 'xmark',
    icon: [
      384,
      512,
      [215,10005,10006,10060,128473,"close","multiply","remove","times"],
      'f00d',
      
      'M338.1 413.4c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L203.3 256 349.4 109.9c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L192 244.7 45.9 98.6c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L180.7 256 34.6 402.1c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L192 267.3 338.1 413.4z'
      
    ]
  };

  
    var faClose = faXmark;
  
    var faMultiply = faXmark;
  
    var faRemove = faXmark;
  
    var faTimes = faXmark;
  

  
  

  var faCloudCheck = {
    prefix: 'fat',
    iconName: 'cloud-check',
    icon: [
      640,
      512,
      [],
      'e35c',
      
      'M522.7 220.8c3.4-8.9 5.3-18.6 5.3-28.8c0-44.2-35.8-80-80-80c-16.5 0-31.7 5-44.4 13.5c-3.7 2.5-8.2 3.3-12.5 2.3s-8-3.8-10.2-7.6C355.9 77 309.3 48 256 48c-79.5 0-144 64.5-144 144c0 2.5 .1 4.9 .2 7.3c.4 7.1-4 13.5-10.7 15.9C51.7 232.7 16 280.2 16 336c0 70.7 57.3 128 128 128H512c61.9 0 112-50.1 112-112c0-54.2-38.5-99.4-89.6-109.8c-4.6-.9-8.6-3.9-10.9-8s-2.6-9.1-.9-13.4zM256 32c53.6 0 101 26.3 130 66.7c3.1 4.3 6 8.8 8.7 13.4c3.5-2.4 7.2-4.5 11-6.4C418.5 99.5 432.8 96 448 96c53 0 96 43 96 96c0 6.6-.7 13-1.9 19.2c-1.1 5.3-2.6 10.5-4.5 15.4c5.3 1.1 10.5 2.5 15.5 4.2C603.6 247.9 640 295.7 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160zM421.7 229.7l-128 128c-3.1 3.1-8.2 3.1-11.3 0l-64-64c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L288 340.7 410.3 218.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3z'
      
    ]
  };

  

  
  

  var faFort = {
    prefix: 'fat',
    iconName: 'fort',
    icon: [
      640,
      512,
      [],
      'e486',
      
      'M176 72H160 144 128V56 24c0-4.4-3.6-8-8-8H104c-4.4 0-8 3.6-8 8V56 72H80 64 48V56 24c0-4.4-3.6-8-8-8H24c-4.4 0-8 3.6-8 8V88v16 40c0 17.7 14.3 32 32 32H176c17.7 0 32-14.3 32-32V104 88 24c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8V56 72zM160 24c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24V88v16 40c0 20.9-13.4 38.7-32 45.3V208H448V189.3c-18.6-6.6-32-24.4-32-45.3V104 88 24c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24V40 56h16V40 24c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24V40 56h16V40 24c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24V88v16 40c0 20.9-13.4 38.7-32 45.3V456c0 30.9-25.1 56-56 56H400 384 256 240 88c-30.9 0-56-25.1-56-56V189.3C13.4 182.7 0 164.9 0 144V104 88 24C0 10.7 10.7 0 24 0H40C53.3 0 64 10.7 64 24V40 56H80V40 24C80 10.7 90.7 0 104 0h16c13.3 0 24 10.7 24 24V40 56h16V40 24zM448 224H192V496h48V392c0-44.2 35.8-80 80-80s80 35.8 80 80V496h48V224zM176 192H48l0 264c0 22.1 17.9 40 40 40h88V192zm96 304h96 16V480 392c0-35.3-28.7-64-64-64s-64 28.7-64 64v88 16h16zm280 0c22.1 0 40-17.9 40-40V192H464V496h88zM464 72V56 24c0-4.4-3.6-8-8-8H440c-4.4 0-8 3.6-8 8V88v16 40c0 17.7 14.3 32 32 32H592c17.7 0 32-14.3 32-32V104 88 24c0-4.4-3.6-8-8-8H600c-4.4 0-8 3.6-8 8V56 72H576 560 544V56 24c0-4.4-3.6-8-8-8H520c-4.4 0-8 3.6-8 8V56 72H496 480 464z'
      
    ]
  };

  

  
  

  var faComputer = {
    prefix: 'fat',
    iconName: 'computer',
    icon: [
      640,
      512,
      [],
      'e4e5',
      
      'M64 48C37.5 48 16 69.5 16 96V320c0 26.5 21.5 48 48 48H178.2 184h80 5.8H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM172.9 384H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V320c0 35.3-28.7 64-64 64H275.1l26.7 80H376c4.4 0 8 3.6 8 8s-3.6 8-8 8H307.1 296 152 140.9 72c-4.4 0-8-3.6-8-8s3.6-8 8-8h74.2l26.7-80zm16.9 0l-26.7 80H284.9l-26.7-80H189.8zM592 48H528c-17.7 0-32 14.3-32 32V432c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32zM528 32h64c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H528c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm-8 104c0-4.4 3.6-8 8-8h64c4.4 0 8 3.6 8 8s-3.6 8-8 8H528c-4.4 0-8-3.6-8-8zm8 56h64c4.4 0 8 3.6 8 8s-3.6 8-8 8H528c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM72 96c-4.4 0-8 3.6-8 8V312c0 4.4 3.6 8 8 8H376c4.4 0 8-3.6 8-8V104c0-4.4-3.6-8-8-8H72zm-24 8c0-13.3 10.7-24 24-24H376c13.3 0 24 10.7 24 24V312c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V104z'
      
    ]
  };

  

  
  

  var faExpand = {
    prefix: 'fat',
    iconName: 'expand',
    icon: [
      448,
      512,
      [],
      'f065',
      
      'M152 32c4.4 0 8 3.6 8 8s-3.6 8-8 8H16V184c0 4.4-3.6 8-8 8s-8-3.6-8-8V40c0-4.4 3.6-8 8-8H152zM0 328c0-4.4 3.6-8 8-8s8 3.6 8 8V464H152c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8V328zM296 32H440c4.4 0 8 3.6 8 8V184c0 4.4-3.6 8-8 8s-8-3.6-8-8V48H296c-4.4 0-8-3.6-8-8s3.6-8 8-8zM448 328V472c0 4.4-3.6 8-8 8H296c-4.4 0-8-3.6-8-8s3.6-8 8-8H432V328c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faPlus = {
    prefix: 'fat',
    iconName: 'plus',
    icon: [
      448,
      512,
      [10133,61543,"add"],
      '2b',
      
      'M232 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V248H40c-4.4 0-8 3.6-8 8s3.6 8 8 8H216V440c0 4.4 3.6 8 8 8s8-3.6 8-8V264H408c4.4 0 8-3.6 8-8s-3.6-8-8-8H232V72z'
      
    ]
  };

  
    var faAdd = faPlus;
  

  
  

  var faHatBeach = {
    prefix: 'fat',
    iconName: 'hat-beach',
    icon: [
      640,
      512,
      [],
      'e606',
      
      'M176 224c0 3 1.5 7.5 7.6 13.3c6.1 5.8 15.9 11.8 29.2 17.1C239.4 265.1 277.3 272 320 272c23.3 0 45.2-2.1 64.6-5.7c-.4-2.5-.6-5-.6-7.6c0-12 4.8-23.5 13.3-32L400 224l-2.7-2.7c-2-2-3.7-4.1-5.3-6.3c-24.8 6.4-50.4 9.1-72 9.1c-23 0-50.4-3.1-76.8-10.4c-22.3-6.2-44.2-15.6-61.8-29.1c-3.6 12.5-5.5 25.8-5.5 39.5zm208-34.7c0-25 20.3-45.3 45.3-45.3c3.9 0 7.8 .5 11.5 1.5C415 106.1 370.6 80 320 80c-59.8 0-111.2 36.5-132.9 88.5c15.9 13.6 37.3 23.3 60.4 29.8c24.8 6.9 50.8 9.8 72.5 9.8c19.6 0 42.8-2.4 65.3-7.9c-.9-3.5-1.3-7.2-1.3-10.8zM320 64c64.9 0 120.8 38.6 145.9 94.1l.9-.9c8.5-8.5 20-13.3 32-13.3c25 0 45.3 20.3 45.3 45.3c0 12-4.8 23.5-13.3 32L528 224l2.7 2.7c6.2 6.2 10.4 14 12.2 22.4l67.3 26.9c17.9 7.2 29.7 24.6 29.7 43.9c0 17.7-9 34.5-25.1 49.8s-39.6 29.1-68.6 40.7C488.4 433.7 408.4 448 320 448s-168.4-14.3-226.3-37.5c-29-11.6-52.4-25.4-68.6-40.7S0 337.7 0 320c0-19.3 11.8-36.7 29.7-43.9L160 224c0-88.4 71.6-160 160-160zM498.7 304c-12 0-23.5-4.8-32-13.3L464 288l-2.7 2.7c-8.5 8.5-20 13.3-32 13.3c-16.7 0-31.3-9-39.1-22.5c-21.2 4.1-45 6.5-70.2 6.5c-44.2 0-84.2-7.2-113.1-18.7c-14.5-5.8-26.2-12.7-34.3-20.3c-3.2-3.1-5.9-6.3-7.9-9.5L35.7 291C23.8 295.7 16 307.2 16 320c0 11.9 5.9 24.8 20.1 38.2c14.2 13.5 35.7 26.3 63.5 37.5C155.3 417.9 233.1 432 320 432s164.7-14.1 220.3-36.3c27.8-11.1 49.3-24 63.5-37.5C618.1 344.8 624 331.9 624 320c0-12.8-7.8-24.3-19.7-29l-61-24.4c-3.7 21.3-22.3 37.4-44.6 37.4zM429.3 160c-16.2 0-29.3 13.1-29.3 29.3c0 7.8 3.1 15.2 8.6 20.7l8.4 8.4c1.5 1.5 2.3 3.5 2.3 5.7s-.8 4.2-2.3 5.7l-8.4 8.4c-5.5 5.5-8.6 12.9-8.6 20.7c0 16.2 13.1 29.3 29.3 29.3c7.8 0 15.2-3.1 20.7-8.6l8.4-8.4c3.1-3.1 8.2-3.1 11.3 0l8.4 8.4c5.5 5.5 12.9 8.6 20.7 8.6c16.2 0 29.3-13.1 29.3-29.3c0-7.8-3.1-15.2-8.6-20.7l-8.4-8.4c-3.1-3.1-3.1-8.2 0-11.3l8.4-8.4c5.5-5.5 8.6-12.9 8.6-20.7c0-16.2-13.1-29.3-29.3-29.3c-7.8 0-15.2 3.1-20.7 8.6l-8.4 8.4c-1.5 1.5-3.5 2.3-5.7 2.3s-4.2-.8-5.7-2.3l-8.4-8.4c-5.5-5.5-12.9-8.6-20.7-8.6zM440 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24-8a8 8 0 1 0 0 16 8 8 0 1 0 0-16z'
      
    ]
  };

  

  
  

  var faSquarePhone = {
    prefix: 'fat',
    iconName: 'square-phone',
    icon: [
      448,
      512,
      ["phone-square"],
      'f098',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm156.8 40.4l-44 12c-5.2 1.4-8.8 6.2-8.8 11.6c0 119.3 96.7 216 216 216c5.4 0 10.2-3.6 11.6-8.8l12-44c1.6-5.8-1.4-11.9-7-14.2l-48-20c-4.9-2-10.5-.6-13.9 3.5l-20.2 24.7c-2.3 2.8-6.3 3.7-9.6 2.2c-36.9-17.4-66.7-47.3-84.2-84.2c-1.6-3.3-.7-7.3 2.2-9.6l24.7-20.2c4.1-3.4 5.5-9 3.5-13.9l-20-48c-2.3-5.6-8.4-8.5-14.2-7zm29 .8l20 48c4.8 11.4 1.5 24.6-8.1 32.4L178 233.8c15.2 29.1 39.1 53 68.2 68.2l16.1-19.7c7.8-9.6 21-12.9 32.4-8.1l48 20c13 5.4 19.9 19.6 16.2 33.2l-12 44c-3.3 12.2-14.4 20.6-27 20.6C191.9 392 88 288.1 88 160c0-12.6 8.5-23.7 20.6-27l44-12c13.6-3.7 27.8 3.3 33.2 16.2z'
      
    ]
  };

  
    var faPhoneSquare = faSquarePhone;
  

  
  

  var fa2 = {
    prefix: 'fat',
    iconName: '2',
    icon: [
      320,
      512,
      [],
      '32',
      
      'M147 48c-30.7 0-60.6 11.3-83.5 31.7L29.3 110c-3.3 2.9-8.4 2.6-11.3-.7s-2.6-8.4 .7-11.3L52.8 67.7C78.7 44.7 112.4 32 147 32c77.4 0 141 62.8 141 140.3c0 40.3-17.3 78.6-47.5 105.2L29.2 464H312c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-3.3 0-6.3-2.1-7.5-5.2s-.3-6.6 2.2-8.8L229.9 265.5C256.7 241.9 272 208 272 172.3C272 103.7 215.7 48 147 48z'
      
    ]
  };

  

  
  

  var faGun = {
    prefix: 'fat',
    iconName: 'gun',
    icon: [
      576,
      512,
      [],
      'e19b',
      
      'M504 32c4.4 0 8 3.6 8 8V64h24c22.1 0 40 17.9 40 40v64c0 22.1-17.9 40-40 40H486.6c-2.1 0-4.2 .8-5.7 2.3L458.3 233c-4.5 4.5-10.6 7-17 7H381.8l-22.9 68.6C353.4 325 338.2 336 320.9 336H237L207 455.8C203.5 470 190.7 480 176 480H64c-9.9 0-19.2-4.5-25.2-12.3s-8.2-17.9-5.8-27.5L73.1 279.8c5-20.2-10.2-39.8-31-39.8H40c-22.1 0-40-17.9-40-40V104C0 81.9 17.9 64 40 64H496V40c0-4.4 3.6-8 8-8zM320.9 320c10.3 0 19.5-6.6 22.8-16.4L364.9 240H261l-20 80h80zM77.8 240c10.1 11.3 14.9 27.3 10.8 43.6L48.5 444.1c-1.2 4.8-.1 9.8 2.9 13.7s7.7 6.2 12.6 6.2H176c7.3 0 13.7-5 15.5-12.1l53-211.9H77.8zM40 80c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24H441.4c2.1 0 4.2-.8 5.7-2.3L469.7 199c4.5-4.5 10.6-7 17-7H536c13.3 0 24-10.7 24-24V104c0-13.3-10.7-24-24-24H504 40zm32 48H504c4.4 0 8 3.6 8 8s-3.6 8-8 8H72c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faChildCombatant = {
    prefix: 'fat',
    iconName: 'child-combatant',
    icon: [
      576,
      512,
      ["child-rifle"],
      'e4e0',
      
      'M224 64a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM112 64a64 64 0 1 1 128 0A64 64 0 1 1 112 64zM96.9 222.5L47.1 315.8c-2.1 3.9-6.9 5.4-10.8 3.3s-5.4-6.9-3.3-10.8L82.7 215c18.1-33.9 53.3-55 91.7-55h3c38.4 0 73.6 21.1 91.7 55l49.8 93.2c2.1 3.9 .6 8.7-3.3 10.8s-8.7 .6-10.8-3.3l-49.8-93.2C239.8 193.9 210 176 177.5 176h-3c-32.5 0-62.3 17.9-77.6 46.5zM104 280c4.4 0 8 3.6 8 8V476c0 11 9 20 20 20s20-9 20-20V392c0-13.3 10.7-24 24-24s24 10.7 24 24v84c0 11 9 20 20 20s20-9 20-20V288c0-4.4 3.6-8 8-8s8 3.6 8 8V476c0 19.9-16.1 36-36 36s-36-16.1-36-36V392c0-4.4-3.6-8-8-8s-8 3.6-8 8v84c0 19.9-16.1 36-36 36s-36-16.1-36-36V288c0-4.4 3.6-8 8-8zM456 146.1c-4.9-2.9-8-8.1-8-13.8V16h-8-8V132.3c0 5.7-3 11-8 13.8c-4.8 2.8-8 8-8 13.9v32V384h54 2 56V368H480c-8.8 0-16-7.2-16-16V325.3v-56V256 160c0-5.9-3.2-11.1-8-13.9zM416 496h72.9L455 405.6c-.7-1.8-1-3.7-1-5.6H416v96zm56-96h-2l6 16 27.9 74.4c3.9 10.5-3.8 21.6-15 21.6H416c-8.8 0-16-7.2-16-16V416 400H384c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32h16V176 160c0-11.8 6.4-22.2 16-27.7V32 16h-8c-4.4 0-8-3.6-8-8s3.6-8 8-8h8 24 8c8.8 0 16 7.2 16 16V132.3c9.6 5.5 16 15.9 16 27.7v48 44.5V256v8 5.3l16-5.3V208c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v84.5c0 6.9-4.4 13-10.9 15.2L480 325.3V336v16h16 32c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H487.1 472zm8-91.5l48-16V208H512v56c0 6.9-4.4 13-10.9 15.2l-16 5.3c-1.7 .6-3.4 .8-5.1 .8v23.1zM384 208c-8.8 0-16 7.2-16 16V368c0 8.8 7.2 16 16 16h16V208H384z'
      
    ]
  };

  
    var faChildRifle = faChildCombatant;
  

  
  

  var faKeynote = {
    prefix: 'fat',
    iconName: 'keynote',
    icon: [
      512,
      512,
      [],
      'f66c',
      
      'M312 16c13.3 0 24 10.7 24 24s-10.7 24-24 24H232c-13.3 0-24-10.7-24-24s10.7-24 24-24h80zM232 0c-19.4 0-35.5 13.7-39.2 32H184c-39.8 0-72 32.2-72 72v40H93.7c-18.2 0-34.8 10.3-42.9 26.5L5.1 261.9c-3.3 6.7-5.1 14-5.1 21.5V296v40c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V296 283.3c0-7.5-1.7-14.8-5.1-21.5l-45.7-91.3c-8.1-16.3-24.8-26.5-42.9-26.5H128V104c0-30.9 25.1-56 56-56h8.8c3.7 18.3 19.8 32 39.2 32h80c22.1 0 40-17.9 40-40s-17.9-40-40-40H232zM16 336V304H496v32c0 8.8-7.2 16-16 16H32c-8.8 0-16-7.2-16-16zm0-48v-4.7c0-5 1.2-9.9 3.4-14.3L65 177.7C70.5 166.8 81.5 160 93.7 160H112h16H418.3c12.1 0 23.2 6.8 28.6 17.7L492.6 269c2.2 4.4 3.4 9.3 3.4 14.3V288H16zM136 496c-4.4 0-8 3.6-8 8s3.6 8 8 8H256 376c4.4 0 8-3.6 8-8s-3.6-8-8-8H264V400H248v96H136z'
      
    ]
  };

  

  
  

  var faShareFromSquare = {
    prefix: 'fat',
    iconName: 'share-from-square',
    icon: [
      576,
      512,
      [61509,"share-square"],
      'f14d',
      
      'M400 240c0-8.8-7.2-16-16-16H352 313.5c-45 0-81.5 36.5-81.5 81.5c0 12.4 5.6 23.4 11.1 31.5c5.7 8.3 12.6 15.3 17.8 20c2.3 2.1 3.1 4.3 3.1 5.8v.9c0 2.4-1.9 4.3-4.3 4.3c-.3 0-.5 0-.6 0l-.1 0 0 0c-8-3.5-31.1-14.8-52.1-35.8c-20.7-20.8-39-50.6-39-92.1c0-79.5 64.5-144 144-144h72c8.8 0 16-7.2 16-16V28.3c0-6.8 5.5-12.3 12.3-12.3c3.3 0 6.4 1.3 8.7 3.6L559 157.7c.6 .6 1 1.5 1 2.3s-.3 1.7-1 2.3L421 300.4c-2.3 2.3-5.4 3.6-8.7 3.6c-6.8 0-12.3-5.5-12.3-12.3V240zm-48 0h16 16v16 35.7c0 15.6 12.7 28.3 28.3 28.3c7.5 0 14.7-3 20-8.3L570.3 173.7c3.6-3.6 5.7-8.5 5.7-13.7s-2-10-5.7-13.7L432.3 8.3C427 3 419.8 0 412.3 0C396.7 0 384 12.7 384 28.3V64 80H368 312c-88.4 0-160 71.6-160 160c0 93.4 82.8 134.8 100.6 142.6c2.2 1 4.6 1.4 7.1 1.4c11.2 0 20.3-9.1 20.3-20.3v-.9c0-6.8-3.3-13.1-8.3-17.7c-9.5-8.6-23.7-24.1-23.7-39.7c0-36.1 29.3-65.5 65.5-65.5H352zM56 32C25.1 32 0 57.1 0 88V456c0 30.9 25.1 56 56 56H424c30.9 0 56-25.1 56-56V392c0-4.4-3.6-8-8-8s-8 3.6-8 8v64c0 22.1-17.9 40-40 40H56c-22.1 0-40-17.9-40-40V88c0-22.1 17.9-40 40-40h96c4.4 0 8-3.6 8-8s-3.6-8-8-8H56z'
      
    ]
  };

  
    var faShareSquare = faShareFromSquare;
  

  
  

  var faGrip = {
    prefix: 'fat',
    iconName: 'grip',
    icon: [
      448,
      512,
      ["grip-horizontal"],
      'f58d',
      
      'M408 400c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0zm40-24c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48zM408 208c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0zm40-24c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48zM200 400l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24zm48 16l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40zm0-208c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0zm40-24c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48zM40 400l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24zm48 16l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40zm0-208c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0zm40-24c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48z'
      
    ]
  };

  
    var faGripHorizontal = faGrip;
  

  
  

  var faJackOLantern = {
    prefix: 'fat',
    iconName: 'jack-o-lantern',
    icon: [
      576,
      512,
      [127875],
      'f30e',
      
      'M291.3 16c-.5 0-1 .3-1.2 .8L254.4 98.5c-6.5 1-12.8 2.2-19.1 3.7l40.2-91.9c2.8-6.3 9-10.4 15.8-10.4h1.2c2.3 0 4.7 .5 6.8 1.4l42.3 18.1c6.4 2.7 10.5 9 10.5 15.9v69.9c-5.2-1.6-10.6-3-16-4.1V35.4c0-.5-.3-1-.8-1.2L293 16.1c-.2-.1-.3-.1-.5-.1h-1.2zM188.4 119.5c-6.5 3.3-12.9 7-19 10.9c-7-1.6-14.2-2.4-21.5-2.4c-35.5 0-68.3 19.7-92.5 52.9S16 260.5 16 312s15.2 97.8 39.5 131c24.2 33.2 57.1 53 92.5 53c23.5 0 45.7-8.6 65-24c2.9-2.3 7-2.3 9.9 0c19.4 15.4 41.6 24 65 24s45.7-8.6 65-24c2.9-2.3 7-2.3 9.9 0c19.4 15.4 41.6 24 65 24c35.5 0 68.3-19.7 92.5-53c24.2-33.2 39.5-79.5 39.5-131s-15.2-97.8-39.5-131.1S463.5 128 428 128c-7.3 0-14.5 .8-21.5 2.4c-6.1-3.9-12.4-7.6-19-10.9c12.8-4.9 26.4-7.5 40.4-7.5c41.8 0 79 23.3 105.5 59.5S576 257.5 576 312s-16.1 104.2-42.5 140.5S469.8 512 428 512c-25.5 0-49.3-8.7-70-23.6c-20.7 15-44.5 23.6-70 23.6s-49.3-8.7-70-23.6c-20.7 15-44.5 23.6-70 23.6c-41.8 0-79-23.3-105.5-59.5S0 366.5 0 312s16.1-104.2 42.5-140.5S106.2 112 148 112c14.1 0 27.6 2.6 40.4 7.5zm-30.1 85.4c-2.7 3.5-7.7 4.2-11.2 1.5s-4.2-7.7-1.5-11.2C176.8 154.4 229.1 128 288 128s111.2 26.4 142.3 67.1c2.7 3.5 2 8.5-1.5 11.2s-8.5 2-11.2-1.5C389.6 168.3 342.2 144 288 144s-101.6 24.3-129.7 60.9zM448 326.7c-23.1 13.6-76.7 39.5-152 41.2V376c0 13.3-10.7 24-24 24H256c-13.3 0-24-10.7-24-24V363.4c-50.1-8.4-86.2-26.2-104-36.7c-4.3-2.5-9.5-1.8-12.5 1.1c-2 2-2.4 4.2-1.9 6c3.6 12.4 14 38.7 42.5 60.9c4.3-6.4 11.6-10.7 20-10.7h16c13.3 0 24 10.7 24 24v15.4c19.9 5.3 43.6 8.6 72 8.6s52.1-3.3 72-8.6V408c0-13.3 10.7-24 24-24h16c8.3 0 15.7 4.2 20 10.7c28.4-22.2 38.9-48.5 42.5-60.9c.5-1.7 0-4-1.9-6c-3-3-8.2-3.7-12.5-1.1zm23.8-10.2c5.4 5.4 8.4 13.5 6 21.7c-4.6 15.9-18.4 49.8-57.4 75.9c-2.4 1.6-5.5 1.8-8.1 .5s-4.2-3.9-4.4-6.8c-.2-4.3-3.7-7.7-8-7.7H384c-4.4 0-8 3.6-8 8v21.5c0 3.5-2.3 6.7-5.7 7.7C347.6 443.9 320.5 448 288 448s-59.6-4.1-82.3-10.8c-3.4-1-5.7-4.1-5.7-7.7V408c0-4.4-3.6-8-8-8H176c-4.3 0-7.8 3.4-8 7.7c-.1 2.9-1.8 5.5-4.3 6.8s-5.7 1.1-8.1-.5c-39-26-52.8-60-57.4-75.9c-2.4-8.2 .6-16.3 6-21.7c8.7-8.7 22-9.5 31.9-3.6c17.4 10.2 53.9 28.3 105 35.7c3.9 .6 6.8 3.9 6.8 7.9V376c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V360c0-4.4 3.6-8 8-8c75.8 0 129.6-26 151.9-39.1c9.9-5.8 23.3-5 31.9 3.6zM240 272l-32-48-32 48h64zm-18.7-56.9l32 48c3.3 4.9 3.6 11.2 .8 16.4s-8.2 8.5-14.1 8.5H176c-5.9 0-11.3-3.2-14.1-8.5s-2.5-11.5 .8-16.4l32-48c3-4.5 8-7.1 13.3-7.1s10.3 2.7 13.3 7.1zM368 224l-32 48h64l-32-48zm0-16c5.4 0 10.3 2.7 13.3 7.1l32 48c3.3 4.9 3.6 11.2 .8 16.4s-8.2 8.5-14.1 8.5H336c-5.9 0-11.3-3.2-14.1-8.5s-2.5-11.5 .8-16.4l32-48c3-4.5 8-7.1 13.3-7.1z'
      
    ]
  };

  

  
  

  var faUserVneckHair = {
    prefix: 'fat',
    iconName: 'user-vneck-hair',
    icon: [
      448,
      512,
      [],
      'e462',
      
      'M336 128c0-5.4-.4-10.8-1.1-16H312c-22.1 0-43-10.2-56.6-27.5L251 89.9C231.2 114 201.7 128 170.5 128L112 128v16c0 61.9 50.1 112 112 112s112-50.1 112-112V128zM267.2 73.6C277.8 87.7 294.4 96 312 96h19.4c-6.8-22.8-20.6-42.5-39-56.7L265.8 71.8l1.4 1.8zM279 30.4C262.7 21.2 244 16 224 16c-56.4 0-103.1 41.7-110.9 96h57.4c26.4 0 51.4-11.8 68.1-32.3L279 30.4zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V128zM198.4 408.5l-63.7-84.9C66.8 338.8 16 399.5 16 472v8c0 8.8 7.2 16 16 16H416c8.8 0 16-7.2 16-16v-8c0-72.5-50.8-133.2-118.7-148.4l-63.7 84.9c-12.8 17.1-38.4 17.1-51.2 0zM132.1 307.8c5.8-1.3 11.7 1.2 15.3 5.9l63.9 85.2c6.4 8.5 19.2 8.5 25.6 0l63.9-85.2c3.6-4.7 9.5-7.2 15.3-5.9C391.4 324.3 448 391.5 448 472v8c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-8c0-80.5 56.6-147.7 132.1-164.2z'
      
    ]
  };

  

  
  

  var faPartyBell = {
    prefix: 'fat',
    iconName: 'party-bell',
    icon: [
      512,
      512,
      [],
      'e31a',
      
      'M355.1 161.7c3.5-2.7 8.5-2.1 11.2 1.4l4.8 6.2c31.3 40.2 77.8 65.7 128.6 70.3l5 .5c4.4 .4 7.6 4.3 7.2 8.7s-4.3 7.6-8.7 7.2l-5-.5c-55.2-5-105.8-32.7-139.8-76.4l-4.8-6.2c-2.7-3.5-2.1-8.5 1.4-11.2zM480 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM336 480a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm48 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM48 480a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm48 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm76.9-126.3l28.1 21.9c29.7 23.1 48.5 57.5 51.9 95l3 32.7c.4 4.4-2.8 8.3-7.2 8.7s-8.3-2.8-8.7-7.2l-3-32.7c-3-33.1-19.6-63.5-45.8-83.9l-28.1-21.9c-3.5-2.7-4.1-7.7-1.4-11.2s7.7-4.1 11.2-1.4zM509.3 510c-3.3 2.9-8.4 2.6-11.3-.7l-14.8-16.8c-11.1-12.6-17-28.9-16.5-45.6c.7-25.2-17.4-47-42.4-51L380.3 389c-37.4-5.9-65.8-36.8-68.6-74.6c-1-13.8-6.4-27-15.3-37.5l-6.6-7.7c-2.9-3.4-2.4-8.4 .9-11.3s8.4-2.4 11.3 .9l6.6 7.7c11.1 13.2 17.8 29.5 19.1 46.7c2.2 30.4 25.1 55.2 55.1 59.9l43.9 6.9c32.9 5.2 56.8 33.9 55.9 67.2c-.3 12.7 4.1 25.1 12.5 34.6L510 498.7c2.9 3.3 2.6 8.4-.7 11.3zM224 0c35.3 0 68.9 8.2 98.7 22.8C341.9 32.3 352 51.7 352 70.7c0 14.5-5.7 28.3-16 38.5L324.7 97.9c7.2-7.2 11.3-17 11.3-27.2c0-13.6-7.2-27-20.4-33.5C287.9 23.6 256.8 16 224 16C109.1 16 16 109.1 16 224c0 32.8 7.6 63.9 21.2 91.6C43.7 328.8 57.1 336 70.7 336c10.2 0 20-4.1 27.2-11.3L324.7 97.9 336 109.2 109.2 336C99 346.3 85.1 352 70.7 352c-19 0-38.4-10.1-47.8-29.3C8.2 292.9 0 259.3 0 224C0 100.3 100.3 0 224 0z'
      
    ]
  };

  

  
  

  var faPaintbrushPencil = {
    prefix: 'fat',
    iconName: 'paintbrush-pencil',
    icon: [
      576,
      512,
      [],
      'e206',
      
      'M548.2 84.3L353.9 278.6 297.3 222 491.6 27.7c15.6-15.6 41-15.6 56.6 0s15.6 40.9 0 56.6zM342.6 289.9l-26.3 26.3-52.1 52.1 0 0-2.3 2.3L205.3 314l54.4-54.4 0 0L286 233.3l56.6 56.6zM168 320c8.3 0 16.4 1.2 24 3.3L252.7 384c2.2 7.6 3.3 15.7 3.3 24c0 46.3-35.7 84.2-81.1 87.7c-.7 .1-1.3 .1-1.9 .3h-5H32c-8.8 0-16-7.2-16-16s7.2-16 16-16h4c14.6 0 26.2-7.7 33.6-17.4c7.3-9.6 11.2-22 10.6-34.3c-.1-1.4-.1-2.8-.1-4.3c0-48.6 39.4-88 88-88zm101.6 65.5L559.5 95.6c21.9-21.9 21.9-57.3 0-79.2s-57.3-21.9-79.2 0l-290 290c-7.2-1.6-14.7-2.4-22.3-2.4c-57.4 0-104 46.6-104 104c0 1.7 0 3.4 .1 5c.8 17.1-11 35-28.2 35H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H168h7.8c.1 0 .2-.1 .2-.2s.1-.2 .1-.2c53.6-4.2 95.9-49 95.9-103.7c0-7.7-.8-15.2-2.4-22.5zM160.3 14.6c-18.7-18.7-49.1-18.7-67.9 0L46.6 60.5c-18.7 18.7-18.7 49.1 0 67.9L179.2 260.9l11.3-11.3-54.4-54.4 91.1-91.1 54.4 54.4 11.3-11.3L160.3 14.6zm257 279.7l53 53c10.4 10.4 18 23.3 22.2 37.4l31.6 107.5L416.7 460.6c-14.1-4.2-27-11.8-37.4-22.2l-53-53L315 396.7l53 53c12.3 12.3 27.5 21.3 44.2 26.2l121.6 35.8c2.8 .8 5.8 .1 7.9-2s2.8-5.1 2-7.9L507.9 380.2C503 363.5 494 348.3 481.7 336l-53-53-11.3 11.3zM149 25.9l66.9 66.9-91.1 91.1L57.9 117c-12.5-12.5-12.5-32.8 0-45.3l45.8-45.8c12.5-12.5 32.8-12.5 45.3 0z'
      
    ]
  };

  

  
  

  var faBarsFilter = {
    prefix: 'fat',
    iconName: 'bars-filter',
    icon: [
      448,
      512,
      [],
      'e0ad',
      
      'M0 88c0-4.4 3.6-8 8-8H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8zM64 248c0-4.4 3.6-8 8-8H376c4.4 0 8 3.6 8 8s-3.6 8-8 8H72c-4.4 0-8-3.6-8-8zM288 408c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8s3.6-8 8-8H280c4.4 0 8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faHandSparkles = {
    prefix: 'fat',
    iconName: 'hand-sparkles',
    icon: [
      640,
      512,
      [],
      'e05d',
      
      'M296 48c0-17.7 14.3-32 32-32s32 14.3 32 32l0 24v8V248c0 4.4 3.6 8 8 8s8-3.6 8-8V80c0-17.7 14.3-32 32-32s32 14.3 32 32v56 8 56 48c0 4.4 3.6 8 8 8s8-3.6 8-8V200 144c0-17.7 14.3-32 32-32s32 14.3 32 32V328.8c4.6-4.7 10-8.6 16-11.4V144c0-26.5-21.5-48-48-48c-12.3 0-23.5 4.6-32 12.2V80c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3C374 19.5 353.3 0 328 0s-46 19.5-47.9 44.3C271.6 36.7 260.4 32 248 32c-26.5 0-48 21.5-48 48V316.1l-54.1-54.1c-18.7-18.7-49.1-18.7-67.9 0s-18.7 49.1 0 67.9L189.8 441.7c45 45 106.1 70.3 169.7 70.3H368c37 0 71.1-11.9 98.9-32.2c-4.7-2.9-9-6.5-12.7-10.6C429.7 486.1 400 496 368 496h-8.5c-59.4 0-116.4-23.6-158.4-65.6L89.4 318.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l67.7 67.7c2.3 2.3 5.7 3 8.7 1.7s4.9-4.2 4.9-7.4V80c0-17.7 14.3-32 32-32s32 14.3 32 32l0 0V248c0 4.4 3.6 8 8 8s8-3.6 8-8V72l0 0V48zM88 80c0-4.4-3.6-8-8-8s-8 3.6-8 8v56H16c-4.4 0-8 3.6-8 8s3.6 8 8 8H72v56c0 4.4 3.6 8 8 8s8-3.6 8-8V152h56c4.4 0 8-3.6 8-8s-3.6-8-8-8H88V80zM328 304c0-4.4-3.6-8-8-8s-8 3.6-8 8v40H272c-4.4 0-8 3.6-8 8s3.6 8 8 8h40v40c0 4.4 3.6 8 8 8s8-3.6 8-8V360h40c4.4 0 8-3.6 8-8s-3.6-8-8-8H328V304zm240 64c0-4.4-3.6-8-8-8s-8 3.6-8 8v56H496c-4.4 0-8 3.6-8 8s3.6 8 8 8h56v56c0 4.4 3.6 8 8 8s8-3.6 8-8V440h56c4.4 0 8-3.6 8-8s-3.6-8-8-8H568V368z'
      
    ]
  };

  

  
  

  var faVolumeXmark = {
    prefix: 'fat',
    iconName: 'volume-xmark',
    icon: [
      576,
      512,
      ["volume-mute","volume-times"],
      'f6a9',
      
      'M281 51.5c2.5-2.2 5.8-3.5 9.2-3.5c7.6 0 13.8 6.2 13.8 13.8V450.2c0 7.6-6.2 13.8-13.8 13.8c-3.4 0-6.6-1.2-9.2-3.5L143.2 338c-1.5-1.3-3.4-2-5.3-2H56c-22.1 0-40-17.9-40-40V216c0-22.1 17.9-40 40-40h81.9c2 0 3.9-.7 5.3-2L281 51.5zM290.2 32c-7.3 0-14.3 2.7-19.8 7.5L134.9 160H56c-30.9 0-56 25.1-56 56v80c0 30.9 25.1 56 56 56h78.9L270.4 472.5c5.5 4.8 12.5 7.5 19.8 7.5c16.5 0 29.8-13.3 29.8-29.8V61.8C320 45.3 306.7 32 290.2 32zM413.7 178.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L468.7 256l-66.3 66.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L480 267.3l66.3 66.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L491.3 256l66.3-66.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L480 244.7l-66.3-66.3z'
      
    ]
  };

  
    var faVolumeMute = faVolumeXmark;
  
    var faVolumeTimes = faVolumeXmark;
  

  
  

  var faBurgerGlass = {
    prefix: 'fat',
    iconName: 'burger-glass',
    icon: [
      640,
      512,
      [],
      'e0ce',
      
      'M16.1 33.3L26.5 160H357.6L367.9 33.3C368.7 24 361.3 16 352 16H32.1c-9.3 0-16.7 8-15.9 17.3zM27.8 176L50.9 459.2C52.6 480 69.9 496 90.7 496H283.6c3.2 5.7 6.9 11.1 11.2 16c-.5 0-1 0-1.5 0H90.7c-29.2 0-53.4-22.4-55.8-51.4L.2 34.6C-1.3 16 13.4 0 32.1 0H352c18.7 0 33.4 16 31.9 34.6L371.4 187.4c-5.9 2.8-11.5 5.7-16.8 8.9l1.6-20.2H27.8zM464 215.8c-95.1 0-131.4 62.2-141.6 85.1c-1.6 3.5-2.4 7.8-2.4 13.2c0 12 9.8 21.8 21.8 21.8H586.2c12 0 21.8-9.7 21.8-21.8c0-5.3-.8-9.7-2.3-13.2C595.4 278 559.1 215.8 464 215.8zM304 314c0-6.8 1-13.5 3.8-19.7c11.5-25.7 52.1-94.5 156.2-94.5s144.7 68.8 156.2 94.5c2.8 6.2 3.8 12.9 3.8 19.7c0 10.4-4.2 19.8-11 26.6c16 7.8 27 24.2 27 43.2c0 18.5-10.4 34.5-25.8 42.6c6 6.2 9.8 14.7 9.8 24.1c0 33.9-27.5 61.3-61.3 61.3H365.3c-33.9 0-61.3-27.5-61.3-61.3c0-9.4 3.7-17.9 9.8-24.1c-15.3-8-25.8-24.1-25.8-42.6c0-19 11-35.4 27-43.2c-6.8-6.8-11-16.2-11-26.6zm32 37.8c-17.7 0-32 14.3-32 32s14.3 32 32 32h2.7H589.3 592c17.7 0 32-14.3 32-32s-14.3-32-32-32h-5.8H341.8 336zm2.7 80c-10.3 0-18.7 8.4-18.7 18.7c0 25 20.3 45.3 45.3 45.3H562.7c25 0 45.3-20.3 45.3-45.3c0-10.3-8.4-18.7-18.7-18.7H338.7zm55.3-168a10 10 0 1 1 -20 0 10 10 0 1 1 20 0zm70-6a10 10 0 1 1 0-20 10 10 0 1 1 0 20zm90 6a10 10 0 1 1 -20 0 10 10 0 1 1 20 0z'
      
    ]
  };

  

  
  

  var faCopy = {
    prefix: 'fat',
    iconName: 'copy',
    icon: [
      448,
      512,
      [],
      'f0c5',
      
      'M384 368H224c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H332.1c8.5 0 16.6 3.4 22.6 9.4l67.9 67.9c6 6 9.4 14.1 9.4 22.6V320c0 26.5-21.5 48-48 48zM224 384H384c35.3 0 64-28.7 64-64V115.9c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1H224c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H224c35.3 0 64-28.7 64-64V416H272v32c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V192c0-26.5 21.5-48 48-48h64V128H64z'
      
    ]
  };

  

  
  

  var faSnowmanHead = {
    prefix: 'fat',
    iconName: 'snowman-head',
    icon: [
      448,
      512,
      ["frosty-head"],
      'f79b',
      
      'M128 16H320c26.5 0 48 21.5 48 48V176h16V64c0-35.3-28.7-64-64-64H128C92.7 0 64 28.7 64 64V176H80V64c0-26.5 21.5-48 48-48zM368 224h5.9c26.4 32.9 42.1 74.6 42.1 120c0 56.8-24.6 107.8-63.8 142.9c-6.6 5.9-15.9 9.1-26.4 9.1H122.2c-10.5 0-19.9-3.2-26.4-9.1C56.6 451.8 32 400.8 32 344c0-45.4 15.8-87.1 42.1-120H80 368zM8 208c-4.4 0-8 3.6-8 8s3.6 8 8 8H54.1C30.1 257.9 16 299.3 16 344c0 61.5 26.7 116.8 69.1 154.8c10.1 9.1 23.6 13.2 37.1 13.2H325.8c13.6 0 27-4.1 37.1-13.2C405.3 460.8 432 405.5 432 344c0-44.7-14.1-86.1-38.1-120H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H384 368 80 64 8zM144 320a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm176-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-97.2 16C197 320 176 341 176 366.8c0 7.3 1.7 14.4 4.9 20.9l35.9 71.8c1.4 2.7 4.1 4.4 7.2 4.4s5.8-1.7 7.2-4.4l35.9-71.8c3.3-6.5 4.9-13.7 4.9-20.9c0-25.9-21-46.8-46.8-46.8h-2.3zM192 366.8c0-17 13.8-30.8 30.8-30.8h2.3c17 0 30.8 13.8 30.8 30.8c0 4.8-1.1 9.5-3.3 13.8L224 438.1l-28.7-57.5c-2.1-4.3-3.3-9-3.3-13.8z'
      
    ]
  };

  
    var faFrostyHead = faSnowmanHead;
  

  
  

  var faSidebar = {
    prefix: 'fat',
    iconName: 'sidebar',
    icon: [
      512,
      512,
      [],
      'e24e',
      
      'M448 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H224V48H448zM64 48H208V464H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48zm0-16C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm8 64c-4.4 0-8 3.6-8 8s3.6 8 8 8h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H72zm-8 72c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H72c-4.4 0-8 3.6-8 8zm8 56c-4.4 0-8 3.6-8 8s3.6 8 8 8h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H72z'
      
    ]
  };

  

  
  

  var faChartPyramid = {
    prefix: 'fat',
    iconName: 'chart-pyramid',
    icon: [
      512,
      512,
      [],
      'e0e6',
      
      'M276.7 67.8c-9.3-15.9-32.2-15.9-41.5 0L162.8 192H349.2L276.7 67.8zM88.1 320H423.9L358.5 208h-205L88.1 320zm-9.3 16L25.2 427.9c-9.3 16 2.2 36.1 20.7 36.1H466.1c18.5 0 30.1-20.1 20.7-36.1L433.2 336H78.8zM221.4 59.7c15.4-26.5 53.7-26.5 69.1 0L500.6 419.8c15.6 26.7-3.7 60.2-34.6 60.2H45.9c-30.9 0-50.1-33.5-34.6-60.2L221.4 59.7z'
      
    ]
  };

  

  
  

  var faPedestal = {
    prefix: 'fat',
    iconName: 'pedestal',
    icon: [
      448,
      512,
      [],
      'e20d',
      
      'M352 16H96C69.5 16 48 37.5 48 64V464H32V64C32 28.7 60.7 0 96 0H352c35.3 0 64 28.7 64 64V464H400V64c0-26.5-21.5-48-48-48zM8 496H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8zM96 96a32 32 0 1 1 64 0A32 32 0 1 1 96 96zm32 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM320 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm16 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faDiagramProject = {
    prefix: 'fat',
    iconName: 'diagram-project',
    icon: [
      576,
      512,
      ["project-diagram"],
      'f542',
      
      'M136 48c22.1 0 40 17.9 40 40v80c0 22.1-17.9 40-40 40H56c-22.1 0-40-17.9-40-40V88c0-22.1 17.9-40 40-40h80zM56 32C25.1 32 0 57.1 0 88v80c0 30.9 25.1 56 56 56h80c11.9 0 23-3.7 32.1-10.1l68.1 95.3c-7.6 9.6-12.1 21.7-12.1 34.8v80c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56V344c0-30.9-25.1-56-56-56H280c-11.9 0-23 3.7-32.1 10.1l-68.1-95.3c7.6-9.6 12.1-21.7 12.1-34.8V136H384v32c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56V88c0-30.9-25.1-56-56-56H440c-30.9 0-56 25.1-56 56v32H192V88c0-30.9-25.1-56-56-56H56zM360 304c22.1 0 40 17.9 40 40v80c0 22.1-17.9 40-40 40H280c-22.1 0-40-17.9-40-40V344c0-22.1 17.9-40 40-40h80zM440 48h80c22.1 0 40 17.9 40 40v80c0 22.1-17.9 40-40 40H440c-22.1 0-40-17.9-40-40V88c0-22.1 17.9-40 40-40z'
      
    ]
  };

  
    var faProjectDiagram = faDiagramProject;
  

  
  

  var faJetFighterUp = {
    prefix: 'fat',
    iconName: 'jet-fighter-up',
    icon: [
      512,
      512,
      [],
      'e518',
      
      'M263.2 4.6C261.9 1.8 259.1 0 256 0s-5.9 1.8-7.2 4.6L190.9 127.6c-4.5 9.6-6.9 20.1-6.9 30.7V216c-1.4 0-2.8 .4-4.1 1.1L16 314V264c0-4.4-3.6-8-8-8s-8 3.6-8 8v64l0 0v48l0 32c0 4.4 3.6 8 8 8s8-3.6 8-8V384H184v5.1l-50.5 61.4c-3.5 4.3-5.5 9.7-5.5 15.3V488c0 13.3 10.7 24 24 24H256 360c13.3 0 24-10.7 24-24V465.7c0-5.6-1.9-11-5.5-15.3L328 389.1V384H496v24c0 4.4 3.6 8 8 8s8-3.6 8-8V376 328 264c0-4.4-3.6-8-8-8s-8 3.6-8 8v50L332.1 217.1c-1.3-.8-2.7-1.1-4.1-1.1V158.3c0-10.6-2.3-21.1-6.9-30.7L263.2 4.6zM264 496V416c0-4.4-3.6-8-8-8s-8 3.6-8 8v80H152c-4.4 0-8-3.6-8-8V465.7c0-1.9 .6-3.7 1.8-5.1l52.4-63.6c1.2-1.4 1.8-3.2 1.8-5.1V158.3c0-8.2 1.8-16.4 5.3-23.8L256 26.8l50.7 107.7c3.5 7.5 5.3 15.6 5.3 23.8V392c0 1.9 .6 3.7 1.8 5.1l52.4 63.6c1.2 1.4 1.8 3.2 1.8 5.1V488c0 4.4-3.6 8-8 8H264zM496 368H328V233.3l168 99.3V368zm-312 0H16V332.6l168-99.3V368z'
      
    ]
  };

  

  
  

  var faAwardSimple = {
    prefix: 'fat',
    iconName: 'award-simple',
    icon: [
      384,
      512,
      [],
      'e0ab',
      
      'M169.9 6.2c13.6-8.3 30.7-8.3 44.3 0l17.1 10.4c4.3 2.6 9.3 4 14.4 3.9l20.1-.5c15.9-.4 30.7 8.2 38.3 22.1l9.6 17.6c2.4 4.5 6.1 8.1 10.6 10.6l17.6 9.6c14 7.6 22.5 22.4 22.1 38.3l-.5 20.1c-.1 5.1 1.2 10.1 3.9 14.4l10.4 17.1c8.3 13.6 8.3 30.7 0 44.3l-10.4 17.1c-2.6 4.3-4 9.3-3.9 14.4l.5 20.1c.4 15.9-8.2 30.7-22.1 38.3l-17.6 9.6c-4.5 2.4-8.1 6.1-10.6 10.6l-9.6 17.6c-7.6 14-22.4 22.5-38.3 22.1l-20.1-.5c-5.1-.1-10.1 1.2-14.4 3.9l-17.1 10.4c-13.6 8.3-30.7 8.3-44.3 0l-17.1-10.4c-4.3-2.6-9.3-4-14.4-3.9l-20.1 .5c-15.9 .4-30.7-8.2-38.3-22.1l-9.6-17.6c-2.4-4.5-6.1-8.1-10.6-10.6l-17.6-9.6c-14-7.6-22.5-22.4-22.1-38.3l.5-20.1c.1-5.1-1.2-10.1-3.9-14.4L6.2 214.1c-8.3-13.6-8.3-30.7 0-44.3l10.4-17.1c2.6-4.3 4-9.3 3.9-14.4L20 118.3c-.4-15.9 8.2-30.7 22.1-38.3l17.6-9.6c4.5-2.4 8.1-6.1 10.6-10.6l9.6-17.6c7.6-14 22.4-22.5 38.3-22.1l20.1 .5c5.1 .1 10.1-1.2 14.4-3.9L169.9 6.2zm35.9 13.7c-8.5-5.2-19.1-5.2-27.6 0L161.1 30.3c-7 4.2-15 6.4-23.1 6.2L117.9 36C108 35.8 98.7 41.1 94 49.8L84.4 67.4c-3.9 7.1-9.8 13-16.9 16.9L49.8 94c-8.7 4.8-14 14-13.8 23.9l.5 20.1c.2 8.1-2 16.2-6.2 23.1L19.9 178.2c-5.2 8.5-5.2 19.1 0 27.6l10.4 17.1c4.2 7 6.4 15 6.2 23.1L36 266.1c-.2 9.9 5.1 19.1 13.8 23.9l17.6 9.6c7.1 3.9 13 9.8 16.9 16.9L94 334.2c4.8 8.7 14 14 23.9 13.8l20.1-.5c8.1-.2 16.2 2 23.1 6.2l17.1 10.4c8.5 5.2 19.1 5.2 27.6 0l17.1-10.4c7-4.2 15-6.4 23.1-6.2l20.1 .5c9.9 .2 19.1-5.1 23.9-13.8l9.6-17.6c3.9-7.1 9.8-13 16.9-16.9l17.6-9.6c8.7-4.8 14-14 13.8-23.9l-.5-20.1c-.2-8.1 2-16.2 6.2-23.1l10.4-17.1c5.2-8.5 5.2-19.1 0-27.6l-10.4-17.1c-4.2-7-6.4-15-6.2-23.1l.5-20.1c.2-9.9-5.1-19.1-13.8-23.9l-17.6-9.6c-7.1-3.9-13-9.8-16.9-16.9L290 49.8c-4.8-8.7-14-14-23.9-13.8l-20.1 .5c-8.1 .2-16.2-2-23.1-6.2L205.8 19.9zM192 120a72 72 0 1 0 0 144 72 72 0 1 0 0-144zm88 72a88 88 0 1 1 -176 0 88 88 0 1 1 176 0zM89 390.5c4.9 2.1 10.1 3.7 15.3 4.7L84.1 486.5c-1.1 4.9 2.6 9.5 7.6 9.5c1.4 0 2.7-.4 3.9-1.1L188 441.1c2.5-1.5 5.6-1.5 8.1 0l92.3 53.8c1.2 .7 2.6 1.1 3.9 1.1c5 0 8.7-4.6 7.6-9.5l-20.3-91.3c5.3-1.1 10.4-2.7 15.3-4.7L315.5 483c3.3 14.9-8 29-23.3 29c-4.2 0-8.4-1.1-12-3.2L192 457.3l-88.3 51.5c-3.6 2.1-7.8 3.2-12 3.2c-15.2 0-26.6-14.1-23.3-29L89 390.5z'
      
    ]
  };

  

  
  

  var faCircleP = {
    prefix: 'fat',
    iconName: 'circle-p',
    icon: [
      512,
      512,
      [],
      'e11a',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128c-13.3 0-24 10.7-24 24V296v80c0 4.4 3.6 8 8 8s8-3.6 8-8V304h96c48.6 0 88-39.4 88-88s-39.4-88-88-88H184zm88 160H176V152c0-4.4 3.6-8 8-8h88c39.8 0 72 32.2 72 72s-32.2 72-72 72z'
      
    ]
  };

  

  
  

  var faBaseball = {
    prefix: 'fat',
    iconName: 'baseball',
    icon: [
      512,
      512,
      [9918,129358,"baseball-ball"],
      'f433',
      
      'M266.5 495.8c-1.7-10.3-2.5-21-2.5-31.8c0-5.6 .2-11.2 .7-16.7c.4-4.4 4.2-7.7 8.6-7.3s7.7 4.2 7.3 8.6c-.4 5.1-.6 10.2-.6 15.3c0 10.4 .9 20.6 2.5 30.6c111.4-12.2 199.8-100.7 212-212c-9.9-1.7-20.1-2.5-30.6-2.5c-5.2 0-10.3 .2-15.3 .6c-4.4 .4-8.3-2.9-8.6-7.3s2.9-8.3 7.3-8.6c5.5-.5 11.1-.7 16.7-.7c10.8 0 21.4 .9 31.8 2.5c.2-3.5 .2-7 .2-10.5C496 123.5 388.5 16 256 16c-3.5 0-7 .1-10.5 .2c1.7 10.3 2.5 21 2.5 31.8c0 5.6-.2 11.2-.7 16.7c-.4 4.4-4.2 7.7-8.6 7.3s-7.7-4.2-7.3-8.6c.4-5.1 .6-10.2 .6-15.3c0-10.4-.9-20.6-2.5-30.6c-111.4 12.2-199.8 100.7-212 212c9.9 1.7 20.1 2.5 30.6 2.5c5.2 0 10.3-.2 15.3-.6c4.4-.4 8.3 2.9 8.6 7.3s-2.9 8.3-7.3 8.6c-5.5 .5-11 .7-16.7 .7c-10.8 0-21.4-.9-31.8-2.5c-.2 3.5-.2 7-.2 10.5c0 132.5 107.5 240 240 240c3.5 0 7-.1 10.5-.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm124.7-40.7c40-18.4 72.3-50.7 90.7-90.7c1.8-4 6.6-5.8 10.6-3.9s5.8 6.6 3.9 10.6c-20 43.5-55 78.6-98.5 98.5c-4 1.8-8.8 .1-10.6-3.9s-.1-8.8 3.9-10.6zm262.7 81.4c-40 18.4-72.3 50.7-90.7 90.7c-1.8 4-6.6 5.8-10.6 3.9s-5.8-6.6-3.9-10.6c20-43.5 55-78.6 98.5-98.5c4-1.8 8.8-.1 10.6 3.9s.1 8.8-3.9 10.6z'
      
    ]
  };

  
    var faBaseballBall = faBaseball;
  

  
  

  var faGlobeStand = {
    prefix: 'fat',
    iconName: 'globe-stand',
    icon: [
      448,
      512,
      [],
      'f5f6',
      
      'M34.3 354.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L61 350.3c43.5 40.4 99.5 59.6 155 57.6V496H72c-4.4 0-8 3.6-8 8s3.6 8 8 8H376c4.4 0 8-3.6 8-8s-3.6-8-8-8H232V406.7c47-5.2 92.7-25.9 128.7-61.9c82.5-82.5 84.3-215 5.6-299.7l15.4-15.4c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L349.4 39.3c-3.1 3.1-3.1 8.2 0 11.3c78.1 78.1 78.1 204.7 0 282.8s-204.7 78.1-282.8 0c-3.1-3.1-8.2-3.1-11.3 0L34.3 354.3zM64 192a144 144 0 1 1 288 0A144 144 0 1 1 64 192zm304 0A160 160 0 1 0 48 192a160 160 0 1 0 320 0z'
      
    ]
  };

  

  
  

  var faFaceTongueSweat = {
    prefix: 'fat',
    iconName: 'face-tongue-sweat',
    icon: [
      576,
      512,
      [],
      'e39e',
      
      'M50 225C65.2 107.1 166 16 288 16c132.5 0 240 107.5 240 240c0 99.6-60.7 185-147.1 221.4c-4.1 1.7-6 6.4-4.3 10.5s6.4 6 10.5 4.3C479.3 453.4 544 362.3 544 256C544 114.6 429.4 0 288 0C157.8 0 50.3 97.2 34.1 223c-.6 4.4 2.5 8.4 6.9 9s8.4-2.5 9-6.9zm68.9 201.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3c23.2 23 50.7 41.6 81.3 54.4c4.1 1.7 8.8-.2 10.5-4.3s-.2-8.8-4.3-10.5c-28.6-12-54.5-29.5-76.2-51zm78.7-252.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-7.4 7.4c-20 20-45.8 33.3-73.8 38l-2.5 .4c-4.4 .7-7.3 4.8-6.6 9.2s4.8 7.3 9.2 6.6l2.5-.4c31.2-5.2 60.1-20.1 82.5-42.5l7.4-7.4zm180.7-11.3c-3.1 3.1-3.1 8.2 0 11.3l7.4 7.4c22.4 22.4 51.2 37.2 82.5 42.5l2.5 .4c4.4 .7 8.5-2.2 9.2-6.6s-2.2-8.5-6.6-9.2l-2.5-.4c-28-4.7-53.8-17.9-73.8-38l-7.4-7.4c-3.1-3.1-8.2-3.1-11.3 0zM93.3 316c5.6 8.9 10.5 17.5 13.9 25.1c3.6 8 4.8 13.3 4.8 16.2c0 22.4-20.2 42.7-48 42.7s-48-20.4-48-42.7c0-2.8 1.2-8.1 4.8-16.1c3.4-7.6 8.3-16.2 13.9-25.1c9.6-15.2 20.9-30.2 29.3-40.9c8.4 10.7 19.7 25.7 29.3 40.9zM72.5 260.1c-4.3-5.5-12.8-5.5-17.1 0C38.1 281.8 0 332.3 0 357.3C0 389.8 28.7 416 64 416s64-26.2 64-58.7c0-25-37.9-75.5-55.5-97.2zM351.6 272a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm-144 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM216 417.9V440c0 39.8 32.2 72 72 72s72-32.2 72-72V417.9c0-23.2-18.8-41.9-41.9-41.9c-11.1 0-21.8 4.4-29.7 12.3l-.4 .4-.4-.4c-7.9-7.9-18.5-12.3-29.7-12.3c-23.2 0-41.9 18.8-41.9 41.9zm64-14.6V432c0 4.4 3.6 8 8 8s8-3.6 8-8V403.3l3.7-3.7c4.9-4.9 11.5-7.6 18.3-7.6c14.3 0 25.9 11.6 25.9 25.9V440c0 30.9-25.1 56-56 56s-56-25.1-56-56V417.9c0-14.3 11.6-25.9 25.9-25.9c6.9 0 13.5 2.7 18.3 7.6l3.7 3.7zM184 392c0-3.9 1.8-8.3 6.5-13.1c4.7-4.8 11.9-9.4 21.5-13.5c19.1-8.2 45.9-13.4 76-13.4s57 5.2 76 13.4c9.5 4.1 16.8 8.8 21.5 13.5c4.7 4.7 6.5 9.1 6.5 13.1c0 5.1-3.2 11.2-11.7 17.6c-3.5 2.6-4.3 7.6-1.7 11.2s7.6 4.3 11.2 1.7c10.5-7.8 18.2-18.1 18.2-30.4c0-9.3-4.4-17.6-11.1-24.3c-6.6-6.7-15.8-12.4-26.5-17C348.9 341.5 319.7 336 288 336s-60.9 5.5-82.3 14.7c-10.7 4.6-19.9 10.3-26.5 17c-6.7 6.7-11.1 15-11.1 24.3c0 12.3 7.7 22.6 18.2 30.4c3.6 2.6 8.6 1.9 11.2-1.7s1.9-8.6-1.7-11.2c-8.5-6.3-11.7-12.4-11.7-17.6z'
      
    ]
  };

  

  
  

  var faCircleRadiation = {
    prefix: 'fat',
    iconName: 'circle-radiation',
    icon: [
      512,
      512,
      [9762,"radiation-alt"],
      'f7ba',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM155.3 142.1c8.6-7.6 22.8-4.9 29.7 7L217.3 205c4.2-3.2 8.9-5.9 13.8-8l-32.2-55.8c-10.8-18.7-36.3-26.8-54.2-11c-26.9 23.7-46.1 56-53.4 92.5C86.6 246 106.5 264 128 264h64.5c-.3-2.6-.5-5.3-.5-8s.2-5.4 .5-8H128c-13.8 0-23.3-10.9-21-22.2c6.7-33 24-62.2 48.3-83.7zm62 164.9L185 362.9c-10.8 18.6-5.1 44.8 17.5 52.4c16.8 5.6 34.8 8.7 53.5 8.7s36.7-3.1 53.5-8.7c22.6-7.6 28.2-33.8 17.5-52.4L294.7 307c-4.2 3.2-8.9 5.9-13.8 8l32.3 55.9c6.9 12 2.2 25.6-8.7 29.2c-15.2 5.1-31.5 7.9-48.4 7.9s-33.2-2.8-48.4-7.9c-10.9-3.7-15.6-17.3-8.7-29.2L231.2 315c-5-2.1-9.6-4.8-13.8-8zm102.2-43H384c21.5 0 41.4-18 36.7-41.4c-7.4-36.5-26.6-68.8-53.4-92.5c-17.9-15.8-43.4-7.6-54.2 11L280.8 197c5 2.1 9.6 4.8 13.8 8l32.2-55.9c6.9-12 21.1-14.7 29.7-7c24.3 21.5 41.7 50.7 48.3 83.7c2.3 11.3-7.2 22.2-21 22.2H319.5c.3 2.6 .5 5.3 .5 8s-.2 5.4-.5 8zM272 256a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64z'
      
    ]
  };

  
    var faRadiationAlt = faCircleRadiation;
  

  
  

  var faMusicNoteSlash = {
    prefix: 'fat',
    iconName: 'music-note-slash',
    icon: [
      640,
      512,
      ["music-alt-slash"],
      'f8d0',
      
      'M354 190.4l139.9-35.6c10.6-2.7 18.1-12.3 18.1-23.3V15.1C512 6.8 505.2 0 496.9 0c-1.3 0-2.6 .2-3.8 .5L353.9 37.1C343.3 39.9 336 49.4 336 60.3V176.9l17.3 13.7c.2 0 .4-.1 .7-.1zM336 360.4v30.4c-19.6-23.2-55.3-38.8-96-38.8c-61.9 0-112 35.8-112 80s50.1 80 112 80s112-35.8 112-80V373l-16-12.6zM358 52.6L496 16.3V131.6c0 3.7-2.5 6.9-6 7.8L352 174.4V60.3c0-3.6 2.4-6.8 6-7.7zM336 432c0 15.6-8.8 31.2-26.1 43.5C292.6 487.9 268 496 240 496s-52.6-8.1-69.9-20.5c-17.3-12.3-26.1-28-26.1-43.5s8.8-31.2 26.1-43.5C187.4 376.1 212 368 240 368s52.6 8.1 69.9 20.5c17.3 12.3 26.1 28 26.1 43.5zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  
    var faMusicAltSlash = faMusicNoteSlash;
  

  
  

  var faMango = {
    prefix: 'fat',
    iconName: 'mango',
    icon: [
      512,
      512,
      [],
      'e30f',
      
      'M408 96c-29.8 0-56.1-14.8-72-37.4v70 16.1V168c0 4.4-3.6 8-8 8s-8-3.6-8-8V144c-45.2 0-90.5 15.9-124.9 47.7l-.6 .6-.6 .5c-41.6 31.2-62.3 64-82 96.6l-2.6 4.3C90.4 324.7 71 356.7 33.9 382.4c-7.2 5.2-12.7 12.2-15.6 20.4c-7.7 21.4 4.4 46.1 30.2 54l.6 .2 .6 .2 0 0 0 0 0 0 0 0 0 0 .2 .1 .7 .3c.7 .3 1.8 .7 3.2 1.2c2.8 1 7.1 2.5 12.8 4.3c11.3 3.6 27.8 8.5 48.9 13.4C157.7 486.2 217.5 496 288 496c78.3 0 129.8-31.8 162.1-71c32.8-39.9 45.9-88 45.9-119.7c0-40.9-16.9-82-51.1-113.6c-22.1-20.4-48.7-34.3-76.9-41.6V134.7c8.9 3.6 18.3 6.2 28.1 7.8c21.7 8.6 42 21.1 59.7 37.4c37.5 34.6 56.2 80 56.2 125.3C512 375.9 454.5 512 288 512c-144 0-244.1-39.9-244.1-39.9C10.3 461.8-7.9 428.4 3.3 397.4c4.1-11.5 11.8-21.1 21.4-28c34.3-23.8 52.1-53.2 71.2-84.7c20.6-34 42.6-70.4 88.4-104.8C221.7 145.3 270.9 128 320 128V8c0-4.4 3.6-8 8-8h24 60.7c46 0 83.3 37.3 83.3 83.3c0 7-5.7 12.7-12.7 12.7H464 408zm16 224c0 57.4-46.6 104-104 104c-4.4 0-8-3.6-8-8s3.6-8 8-8c48.6 0 88-39.4 88-88c0-4.4 3.6-8 8-8s8 3.6 8 8zM336.4 16c4 36 34.5 64 71.6 64h56 15.9c-1.7-35.6-31.2-64-67.2-64H352 336.4z'
      
    ]
  };

  

  
  

  var faLinkHorizontal = {
    prefix: 'fat',
    iconName: 'link-horizontal',
    icon: [
      640,
      512,
      ["chain-horizontal"],
      'e1cb',
      
      'M512 432c70.7 0 128-57.3 128-128s-57.3-128-128-128H488c-4.4 0-8 3.6-8 8s3.6 8 8 8h24c61.9 0 112 50.1 112 112s-50.1 112-112 112H320c-61.9 0-112-50.1-112-112s50.1-112 112-112h56c4.4 0 8-3.6 8-8s-3.6-8-8-8H320c-70.7 0-128 57.3-128 128s57.3 128 128 128H512zM128 80C57.3 80 0 137.3 0 208s57.3 128 128 128h24c4.4 0 8-3.6 8-8s-3.6-8-8-8H128C66.1 320 16 269.9 16 208S66.1 96 128 96H320c61.9 0 112 50.1 112 112s-50.1 112-112 112H264c-4.4 0-8 3.6-8 8s3.6 8 8 8h56c70.7 0 128-57.3 128-128s-57.3-128-128-128H128z'
      
    ]
  };

  
    var faChainHorizontal = faLinkHorizontal;
  

  
  

  var faPhoneIntercom = {
    prefix: 'fat',
    iconName: 'phone-intercom',
    icon: [
      512,
      512,
      [],
      'e434',
      
      'M80 48c17.7 0 32 14.3 32 32V432c0 17.7-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V80c0-17.7 14.3-32 32-32H80zM48 32C21.5 32 0 53.5 0 80V432c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zM448 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H224c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H448zM224 32c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H224zm16 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm32-24c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H360c-4.4 0-8 3.6-8 8zm0 48c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H360c-4.4 0-8 3.6-8 8zM256 112H416c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H256c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16zm-32 16v96c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32z'
      
    ]
  };

  

  
  

  var faSquareChevronLeft = {
    prefix: 'fat',
    iconName: 'square-chevron-left',
    icon: [
      448,
      512,
      ["chevron-square-left"],
      'f32a',
      
      'M16 416c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-320c0-26.5-21.5-48-48-48L64 48C37.5 48 16 69.5 16 96l0 320zm48 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zm74.3-229.7l120-120c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L155.3 256 269.7 370.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-120-120c-3.1-3.1-3.1-8.2 0-11.3z'
      
    ]
  };

  
    var faChevronSquareLeft = faSquareChevronLeft;
  

  
  

  var faClapperboard = {
    prefix: 'fat',
    iconName: 'clapperboard',
    icon: [
      512,
      512,
      [],
      'e131',
      
      'M16 192V416c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V192H16zm339.3-16H496V96c0-16.5-8.3-31-21-39.7L355.3 176zm-22.6 0l5.7-5.7 121-121c-3.6-.9-7.4-1.3-11.3-1.3H331.3l-5.7 5.7L203.3 176H332.7zm-152 0l5.7-5.7L308.7 48H179.3l-5.7 5.7L51.3 176H180.7zm-152 0l5.7-5.7L156.7 48H64C37.5 48 16 69.5 16 96v80H28.7zM512 96v80 8 8V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192v-8-8V96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64z'
      
    ]
  };

  

  
  

  var faDiamondHalfStroke = {
    prefix: 'fat',
    iconName: 'diamond-half-stroke',
    icon: [
      512,
      512,
      [],
      'e5b8',
      
      'M248 17.4c-3.3 1.2-6.4 3-9 5.7L23 239c-9.4 9.4-9.4 24.6 0 33.9L239 489c2.6 2.6 5.7 4.5 9 5.7V17.4zm16 0V494.6c3.3-1.2 6.4-3 9-5.7L489 273c9.4-9.4 9.4-24.6 0-33.9L273 23c-2.6-2.6-5.7-4.5-9-5.7zm-36.3-5.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216z'
      
    ]
  };

  

  
  

  var faSquareArrowDown = {
    prefix: 'fat',
    iconName: 'square-arrow-down',
    icon: [
      448,
      512,
      ["arrow-square-down"],
      'f339',
      
      'M64 464c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H384c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64zM0 416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416zm229.7-34.3l104-104c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L232 356.7V136c0-4.4-3.6-8-8-8s-8 3.6-8 8V356.7l-90.3-90.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l104 104c3.1 3.1 8.2 3.1 11.3 0z'
      
    ]
  };

  
    var faArrowSquareDown = faSquareArrowDown;
  

  
  

  var faArrowRightLongToLine = {
    prefix: 'fat',
    iconName: 'arrow-right-long-to-line',
    icon: [
      640,
      512,
      [],
      'e3d5',
      
      'M640 72V440c0 4.4-3.6 8-8 8s-8-3.6-8-8V72c0-4.4 3.6-8 8-8s8 3.6 8 8zM509.7 250.3c3.1 3.1 3.1 8.2 0 11.3l-152 152c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L484.7 264 8 264c-4.4 0-8-3.6-8-8s3.6-8 8-8l476.7 0L346.3 109.7c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l152 152z'
      
    ]
  };

  

  
  

  var faCircleHalfStroke = {
    prefix: 'fat',
    iconName: 'circle-half-stroke',
    icon: [
      512,
      512,
      [9680,"adjust"],
      'f042',
      
      'M264 495.9c128.8-4.2 232-110 232-239.9S392.8 20.4 264 16.1V495.9zm-16 0V16.1C119.2 20.4 16 126.1 16 256s103.2 235.6 232 239.9zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  
    var faAdjust = faCircleHalfStroke;
  

  
  

  var faStarfighter = {
    prefix: 'fat',
    iconName: 'starfighter',
    icon: [
      640,
      512,
      [],
      'e037',
      
      'M277.1 27.3L240.3 277.7c-.2 1.2-.3 2.3-.3 3.5V440c0 22.1 17.9 40 40 40h80c22.1 0 40-17.9 40-40V281.2c0-1.2-.1-2.3-.3-3.5L362.9 27.3C360.6 11.6 347.1 0 331.3 0H308.7c-15.9 0-29.3 11.6-31.7 27.3zM308.7 16h22.5c7.9 0 14.7 5.8 15.8 13.7L383.9 280c.1 .4 .1 .8 .1 1.2V440c0 13.3-10.7 24-24 24H280c-13.3 0-24-10.7-24-24V281.2c0-.4 0-.8 .1-1.2L292.9 29.7c1.2-7.9 7.9-13.7 15.8-13.7zM608 96c0-4.4-3.6-8-8-8s-8 3.6-8 8v32H576c-4.4 0-8 3.6-8 8s3.6 8 8 8h16V320H512v-8c0-22.1-17.9-40-40-40H440c-4.4 0-8 3.6-8 8s3.6 8 8 8h32c13.3 0 24 10.7 24 24v8 16V440c0 13.3-10.7 24-24 24H440c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8s8-3.6 8-8V480h24c17 0 31.5-10.6 37.3-25.5L592 420v28c0 4.4 3.6 8 8 8s8-3.6 8-8V144h16c4.4 0 8-3.6 8-8s-3.6-8-8-8H608V96zM512 336h80v66.7L512 436V336zM320 232c13.3 0 24 10.7 24 24v48c0 4.4-3.6 8-8 8H304c-4.4 0-8-3.6-8-8V256c0-13.3 10.7-24 24-24zm-40 24v48c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V256c0-22.1-17.9-40-40-40s-40 17.9-40 40zM32 96v32H16c-4.4 0-8 3.6-8 8s3.6 8 8 8H32V448c0 4.4 3.6 8 8 8s8-3.6 8-8V420l82.7 34.5C136.5 469.4 151 480 168 480h24v24c0 4.4 3.6 8 8 8s8-3.6 8-8V472c0-4.4-3.6-8-8-8H168c-13.3 0-24-10.7-24-24V336 320v-8c0-13.3 10.7-24 24-24h32c4.4 0 8-3.6 8-8s-3.6-8-8-8H168c-22.1 0-40 17.9-40 40v8H48V144H64c4.4 0 8-3.6 8-8s-3.6-8-8-8H48V96c0-4.4-3.6-8-8-8s-8 3.6-8 8zm96 240V436L48 402.7V336h80z'
      
    ]
  };

  

  
  

  var faUserGraduate = {
    prefix: 'fat',
    iconName: 'user-graduate',
    icon: [
      448,
      512,
      [],
      'f501',
      
      'M228.7 17.8c-3.1-.9-6.3-.9-9.4 0L43.2 72l176.1 54.2c3.1 .9 6.3 .9 9.4 0L404.8 72 228.7 17.8zM214.6 2.5c6.1-1.9 12.7-1.9 18.8 0L434.4 64.4c3.4 1 5.6 4.1 5.6 7.6s-2.3 6.6-5.6 7.6L233.4 141.5c-6.1 1.9-12.7 1.9-18.8 0L48 90.2v76.5l31.6 94.8c.8 2.4 .4 5.1-1.1 7.2S74.6 272 72 272H8c-2.6 0-5-1.2-6.5-3.3s-1.9-4.8-1.1-7.2L32 166.7V88c0-.9 .1-1.8 .4-2.6L13.6 79.6C10.3 78.6 8 75.5 8 72s2.3-6.6 5.6-7.6L214.6 2.5zM216 447.1l-4-4.5L122 341.4C60.9 358.5 16 414.7 16 481.3c0 8.1 6.6 14.7 14.7 14.7H216V447.1zm16 0V496H417.3c8.1 0 14.7-6.6 14.7-14.7c0-66.6-44.9-122.8-106-139.9L236 442.6l-4 4.5zm88.4-123.6C393.3 339 448 403.8 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3C0 403.8 54.7 339 127.6 323.5L213.3 420 224 432l10.7-12 85.7-96.4zM19.1 256H60.9L40 193.3 19.1 256zM96 176V138.1l16 4.9v33c0 61.9 50.1 112 112 112s112-50.1 112-112V143l16-4.9V176c0 70.7-57.3 128-128 128s-128-57.3-128-128z'
      
    ]
  };

  

  
  

  var faObjectUnion = {
    prefix: 'fat',
    iconName: 'object-union',
    icon: [
      512,
      512,
      [],
      'e49f',
      
      'M160 336c8.8 0 16 7.2 16 16v96c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V224c0-26.5-21.5-48-48-48H352c-8.8 0-16-7.2-16-16V64c0-26.5-21.5-48-48-48H64C37.5 16 16 37.5 16 64V288c0 26.5 21.5 48 48 48h96zm-16 16H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H288c35.3 0 64 28.7 64 64v80 16h16 80c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V368 352H144z'
      
    ]
  };

  

  
  

  var faCartShoppingFast = {
    prefix: 'fat',
    iconName: 'cart-shopping-fast',
    icon: [
      640,
      512,
      [],
      'e0dc',
      
      'M64 8c0-4.4 3.6-8 8-8h37.7c19 0 35.4 13.4 39.2 32H591.7c25.8 0 44.8 24 39 49.1L592.4 244.7c-5.9 25.3-28.5 43.3-54.5 43.3h-339l9.3 47.7c3.7 18.8 20.1 32.3 39.3 32.3H568c4.4 0 8 3.6 8 8s-3.6 8-8 8H247.5c-26.8 0-49.8-19-55-45.2L133.2 35.4C131 24.1 121.1 16 109.7 16H72c-4.4 0-8-3.6-8-8zM195.8 272H537.9c18.6 0 34.7-12.8 39-30.9L615 77.5c3.5-15.1-7.9-29.5-23.4-29.5H152l43.8 224zM240 496a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm320 48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM8 128H120c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 64H136c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 64H152c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faHexagonExclamation = {
    prefix: 'fat',
    iconName: 'hexagon-exclamation',
    icon: [
      512,
      512,
      [],
      'e417',
      
      'M400.8 450.8l0 0L497.1 284c2.5-4.3 4.4-8.9 5.6-13.6c2-7.7 2.4-15.7 1.1-23.6c-1.1-6.5-3.3-12.9-6.7-18.8L400.8 61.2c-10-17.3-28.5-28-48.5-28H159.7c-20 0-38.5 10.7-48.5 28L14.9 228c-3.9 6.7-6.3 14.1-7.1 21.6c-1.4 11.8 1 23.9 7.1 34.4l96.3 166.8c10 17.3 28.5 28 48.5 28H352.3c20 0 38.5-10.7 48.5-28zM483.2 236c2.7 4.6 4.4 9.7 5 14.8l-2.7 20.4c-.7 1.6-1.4 3.2-2.3 4.8L386.9 442.8c-7.1 12.4-20.4 20-34.6 20H159.7c-14.3 0-27.5-7.6-34.6-20L28.8 276c-3.6-6.2-5.4-13.1-5.4-20c0-3.4 .4-6.8 1.3-10.1c.9-3.4 2.2-6.8 4.1-9.9L125.1 69.2c7.1-12.4 20.4-20 34.6-20l192.6 0c14.3 0 27.5 7.6 34.6 20L483.2 236zM256 128c-4.4 0-8 3.6-8 8V296c0 4.4 3.6 8 8 8s8-3.6 8-8V136c0-4.4-3.6-8-8-8zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faMusicNote = {
    prefix: 'fat',
    iconName: 'music-note',
    icon: [
      384,
      512,
      ["music-alt"],
      'f8cf',
      
      'M230 52.6L368 16.3V131.6c0 3.7-2.5 6.9-6 7.8L224 174.4V60.3c0-3.6 2.4-6.8 6-7.7zM224 432V190.7c.7 0 1.3-.1 2-.2l139.9-35.6c10.6-2.7 18.1-12.3 18.1-23.3V15.1C384 6.8 377.2 0 368.9 0c-1.3 0-2.6 .2-3.8 .5L225.9 37.1C215.3 39.9 208 49.4 208 60.3V390.8c-19.6-23.2-55.3-38.8-96-38.8C50.1 352 0 387.8 0 432s50.1 80 112 80s112-35.8 112-80zm-16 0c0 15.6-8.8 31.2-26.1 43.5C164.6 487.9 140 496 112 496s-52.6-8.1-69.9-20.5C24.8 463.2 16 447.6 16 432s8.8-31.2 26.1-43.5C59.4 376.1 84 368 112 368s52.6 8.1 69.9 20.5c17.3 12.3 26.1 28 26.1 43.5z'
      
    ]
  };

  
    var faMusicAlt = faMusicNote;
  

  
  

  var faWaffle = {
    prefix: 'fat',
    iconName: 'waffle',
    icon: [
      512,
      512,
      [129479],
      'e466',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM264 72v80h80V104c0-4.4 3.6-8 8-8s8 3.6 8 8v48h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H360v80h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H360v80h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H360v48c0 4.4-3.6 8-8 8s-8-3.6-8-8V360H264v80c0 4.4-3.6 8-8 8s-8-3.6-8-8V360H168v48c0 4.4-3.6 8-8 8s-8-3.6-8-8V360H104c-4.4 0-8-3.6-8-8s3.6-8 8-8h48V264H72c-4.4 0-8-3.6-8-8s3.6-8 8-8h80V168H104c-4.4 0-8-3.6-8-8s3.6-8 8-8h48V104c0-4.4 3.6-8 8-8s8 3.6 8 8v48l80 0V72c0-4.4 3.6-8 8-8s8 3.6 8 8zm-96 96v80h80V168l-80 0zm0 96v80h80V264H168zm96 0v80h80V264H264zm0-16h80V168H264v80z'
      
    ]
  };

  

  
  

  var faCloudFog = {
    prefix: 'fat',
    iconName: 'cloud-fog',
    icon: [
      640,
      512,
      [127787,"fog"],
      'f74e',
      
      'M462.7 124.8c.8-4.1 1.3-8.4 1.3-12.8c0-35.3-28.7-64-64-64c-19.5 0-36.9 8.7-48.6 22.4c-3.4 4-8.7 6.1-13.9 5.5s-9.9-3.8-12.4-8.5C309 36.8 276.9 16 240 16c-53 0-96 43-96 96c0 6.1 .6 12.1 1.7 17.9c1.5 7.9-3.1 15.6-10.7 18.1C103 158.5 80 188.6 80 224c0 44.2 35.8 80 80 80H480c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.4 0-.9 0-1.3 0c-4.8 .1-9.5-2-12.6-5.8s-4.3-8.7-3.4-13.4zM240 0c37.1 0 70 18.1 90.4 45.9c3.3 4.5 6.2 9.2 8.8 14.1c3.6-4.2 7.6-8 12-11.4C364.7 38.2 381.6 32 400 32c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c4.9 0 9.8 .4 14.5 1.1c46.2 7 81.5 46.8 81.5 94.9c0 53-43 96-96 96H160c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2c-1.3-6.7-1.9-13.7-1.9-20.8C128 50.1 178.1 0 240 0zM0 408c0-4.4 3.6-8 8-8H568c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8zm64 96c0-4.4 3.6-8 8-8H216c4.4 0 8 3.6 8 8s-3.6 8-8 8H72c-4.4 0-8-3.6-8-8zm224 0c0-4.4 3.6-8 8-8H632c4.4 0 8 3.6 8 8s-3.6 8-8 8H296c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  
    var faFog = faCloudFog;
  

  
  

  var faFish = {
    prefix: 'fat',
    iconName: 'fish',
    icon: [
      576,
      512,
      [128031],
      'f578',
      
      'M141.5 306.7l-11.7 6.8L40.1 365.8c-6.3 3.6-14.2 2.6-19.3-2.5s-6.2-13-2.6-19.3l45.8-80.1 4.5-7.9-4.5-7.9L18.1 167.9c-3.6-6.3-2.5-14.2 2.6-19.3s13.1-6.1 19.3-2.5l89.7 52.3 11.7 6.8 8.7-10.4c11.6-14 25.3-28.1 40.7-41.2C228.2 122.2 277.5 96 336 96s107.8 26.2 145.1 57.8c37.3 31.5 63.8 69.2 77.1 94.9c2.4 4.6 2.4 10.1 0 14.7c-13.2 25.7-39.8 63.4-77.1 94.9C443.8 389.8 394.5 416 336 416s-107.8-26.2-145.2-57.8c-15.4-13-29.1-27.2-40.7-41.2l-8.7-10.4zm-3.6 20.6c12.2 14.6 26.5 29.4 42.7 43.1c39.2 33.1 92 61.5 155.5 61.5s116.3-28.5 155.5-61.5c39.1-33 66.9-72.4 81-99.8c4.7-9.2 4.7-20.1 0-29.3c-14.1-27.4-41.9-66.8-81-99.8C452.3 108.5 399.4 80 336 80s-116.3 28.5-155.5 61.5c-16.2 13.7-30.5 28.5-42.7 43.1L48.1 132.4c-12.5-7.3-28.4-5.3-38.7 4.9S-3 163.3 4.2 175.9L50 256 4.2 336.1c-7.2 12.6-5 28.4 5.3 38.6s26.1 12.2 38.7 4.9l89.7-52.3zM448 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-32-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faCircleStar = {
    prefix: 'fat',
    iconName: 'circle-star',
    icon: [
      512,
      512,
      ["star-circle"],
      'e123',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM207.7 202.2c5.2-.8 9.7-4 12-8.8L256 120l36.2 73.4c2.3 4.7 6.8 8 12 8.8L385.3 214l-58.6 57.2c-3.8 3.7-5.5 9-4.6 14.2L335.9 366l-72.5-38.1c-4.7-2.5-10.2-2.5-14.9 0L176.1 366l13.8-80.7c.9-5.2-.8-10.5-4.6-14.2L126.7 214l81-11.8zm179.9-4.1l-81.1-11.8-36.2-73.4c-2.7-5.5-8.3-8.9-14.3-8.9s-11.7 3.5-14.3 8.9l-36.2 73.4-81 11.8c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l58.6 57.2-13.8 80.7c-1 6 1.4 12.1 6.4 15.6s11.5 4.1 16.8 1.2L256 342.1l72.5 38.1c5.4 2.8 11.9 2.4 16.9-1.2s7.4-9.6 6.4-15.6l-13.8-80.7 58.6-57.2c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9z'
      
    ]
  };

  
    var faStarCircle = faCircleStar;
  

  
  

  var faCircle1 = {
    prefix: 'fat',
    iconName: 'circle-1',
    icon: [
      512,
      512,
      [],
      'e0ee',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM260 129.1c2.5 1.4 4 4.1 4 6.9V368h56c4.4 0 8 3.6 8 8s-3.6 8-8 8H256 192c-4.4 0-8-3.6-8-8s3.6-8 8-8h56V149.8l-44 25.2c-3.8 2.2-8.7 .9-10.9-3s-.9-8.7 3-10.9l56-32c2.5-1.4 5.5-1.4 8 0z'
      
    ]
  };

  

  
  

  var faCommentHeart = {
    prefix: 'fat',
    iconName: 'comment-heart',
    icon: [
      512,
      512,
      [],
      'e5c8',
      
      'M157.3 415c-5-1.8-10.6-1-14.9 2.1c-11 8-29.4 19.3-51.2 28.8C68.3 456 41.6 464 16 464l.1-.1 0 0 0 0 .3-.3 .1-.1c.4-.4 .9-.9 1.5-1.6c1.3-1.4 3.2-3.6 5.4-6.3l-12.2-10 12.2 10C28 450 34 442 40 432c10.7-17.9 21.4-42.1 23.6-69.9c.3-4.3-1.1-8.6-3.9-11.8C31.9 318.8 16 280.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-35.2 0-68.6-6.1-98.7-17zM4.7 452.7l0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0zM160 217.9c0-23.2 18.8-41.9 41.9-41.9c11.1 0 21.8 4.4 29.7 12.3L250.3 207c1.5 1.5 3.5 2.3 5.7 2.3s4.2-.8 5.7-2.3l18.7-18.7c7.9-7.9 18.5-12.3 29.7-12.3c23.2 0 41.9 18.8 41.9 41.9v.6c0 10.6-4 20.9-11.2 28.8l-78.9 86.1c-1.5 1.7-3.7 2.6-5.9 2.6s-4.4-.9-5.9-2.6l-78.9-86.1c-7.2-7.8-11.2-18.1-11.2-28.8v-.6zM201.9 160c-32 0-57.9 25.9-57.9 57.9v.6c0 14.7 5.5 28.8 15.4 39.6l78.9 86.1c4.5 5 11 7.8 17.7 7.8s13.1-2.8 17.7-7.8l78.9-86.1c9.9-10.8 15.4-24.9 15.4-39.6v-.6c0-32-25.9-57.9-57.9-57.9c-15.4 0-30.1 6.1-41 17L256 190.1 242.9 177c-10.9-10.9-25.6-17-41-17z'
      
    ]
  };

  

  
  

  var faStarSharp = {
    prefix: 'fat',
    iconName: 'star-sharp',
    icon: [
      576,
      512,
      [],
      'e28b',
      
      'M288 16c-1.3 0-2.4 .8-2.8 2L231.6 186.4c-1.1 3.3-4.1 5.6-7.6 5.6H50.9c-1.6 0-2.9 1.3-2.9 2.9c0 .9 .4 1.7 1 2.2L189.1 313.9c2.5 2.1 3.5 5.4 2.5 8.5L139.4 494.1c-.3 .9 .4 1.9 1.4 1.9c.3 0 .6-.1 .9-.3l141.4-110c2.9-2.2 6.9-2.2 9.8 0l141.4 110c.3 .2 .6 .3 .9 .3c1 0 1.7-.9 1.4-1.9L384.3 322.3c-.9-3.1 .1-6.4 2.5-8.5L527 197.1c.7-.6 1-1.4 1-2.2c0-1.6-1.3-2.9-2.9-2.9H352c-3.5 0-6.6-2.3-7.6-5.6L290.8 18c-.4-1.2-1.5-2-2.8-2zm-18-2.8C272.5 5.3 279.8 0 288 0s15.5 5.3 18 13.2L357.8 176H525.1c10.4 0 18.9 8.5 18.9 18.9c0 5.6-2.5 10.9-6.8 14.5l-136 113.3 50.7 166.7c3.4 11.2-5 22.5-16.7 22.5c-3.9 0-7.7-1.3-10.7-3.7L288 402.1 151.5 508.3c-3.1 2.4-6.8 3.7-10.7 3.7c-11.7 0-20.1-11.3-16.7-22.5l50.7-166.7L38.8 209.4c-4.3-3.6-6.8-8.9-6.8-14.5c0-10.4 8.5-18.9 18.9-18.9H218.2L270 13.2z'
      
    ]
  };

  

  
  

  var faUserMagnifyingGlass = {
    prefix: 'fat',
    iconName: 'user-magnifying-glass',
    icon: [
      640,
      512,
      [],
      'e5c5',
      
      'M112 128a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm240 0A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM16 482.3C16 392.7 88.7 320 178.3 320h91.4c6.2 0 12.3 .3 18.3 1l0-1c0-5.1 .2-10.1 .7-15c-6.2-.7-12.6-1-19-1H178.3C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7c0-.8 0-1.5 0-2.3c-5.4 0-10.7-.3-16-.8c0 1 0 2.1 0 3.1c0 7.6-6.1 13.7-13.7 13.7H29.7c-7.6 0-13.7-6.1-13.7-13.7zM448 208.1a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 240c32.5 0 62.1-12.1 84.7-32l93.7 93.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L544 404.8c19.9-22.6 32-52.2 32-84.7c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128z'
      
    ]
  };

  

  
  

  var faTruckFast = {
    prefix: 'fat',
    iconName: 'truck-fast',
    icon: [
      640,
      512,
      ["shipping-fast"],
      'f48b',
      
      'M128 16H352c26.5 0 48 21.5 48 48V400H236.7c-10.4-36.9-44.4-64-84.7-64c-29.8 0-56.1 14.8-72 37.4V288H64V400v16h.4c-.2 2.6-.4 5.3-.4 8c0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8H400h.4c-.2 2.6-.4 5.3-.4 8c0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8H632c4.4 0 8-3.6 8-8s-3.6-8-8-8H608V229.3c0-10.6-4.2-20.8-11.7-28.3L503 107.7c-7.5-7.5-17.7-11.7-28.3-11.7H416V64c0-35.3-28.7-64-64-64H128C92.7 0 64 28.7 64 64V96H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H216c4.4 0 8-3.6 8-8s-3.6-8-8-8H80V64c0-26.5 21.5-48 48-48zM416 216V112h58.7c6.4 0 12.5 2.5 17 7L585 212.3c1.1 1.1 2.2 2.4 3 3.7H416zm0 16H592V400H572.7c-10.4-36.9-44.4-64-84.7-64c-29.8 0-56.1 14.8-72 37.4V232zM80 424a72 72 0 1 1 144 0A72 72 0 1 1 80 424zm408-72a72 72 0 1 1 0 144 72 72 0 1 1 0-144zM40 160c-4.4 0-8 3.6-8 8s3.6 8 8 8H280c4.4 0 8-3.6 8-8s-3.6-8-8-8H40zM8 224c-4.4 0-8 3.6-8 8s3.6 8 8 8H216c4.4 0 8-3.6 8-8s-3.6-8-8-8H8z'
      
    ]
  };

  
    var faShippingFast = faTruckFast;
  

  
  

  var faLacrosseStickBall = {
    prefix: 'fat',
    iconName: 'lacrosse-stick-ball',
    icon: [
      576,
      512,
      [],
      'e3b6',
      
      'M344.1 16l.3 0c34.8 0 72.6 21.6 101.3 50.3C474.4 95 496 132.9 496 167.7l0 .1 0 .2v0c0 51.2-32.8 96.7-81.4 112.9l-.8 .3 0 0-1.1 .4c-19.1 6.4-40.8 13.6-59.6 29l-42 34.4c-18.3 15-41.2 23.1-64.8 23.1C189.8 368 144 322.2 144 265.7c0-23.6 8.2-46.5 23.1-64.8l34.4-42c15.4-18.8 22.6-40.5 29-59.7l.6-1.8C247.3 48.8 292.8 16 344 16l.1 0zm.2-16L344 0C285.9 0 234.3 37.2 215.9 92.3l-.3 .8 0 0c-6.6 19.8-13 39.1-26.5 55.6l-34.4 42c-17.3 21.1-26.7 47.6-26.7 74.9c0 29.8 11 57 29.2 77.8L2.3 498.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L168.5 354.8c20.8 18.2 48 29.2 77.8 29.2c27.3 0 53.8-9.4 74.9-26.7l42-34.4c16.5-13.5 35.8-19.9 55.6-26.5l.8-.3c55.1-18.4 92.3-70 92.3-128.1l0-.3c0-40.8-24.8-82.5-55-112.7S385.1 0 344.3 0zM432 432a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm144 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z'
      
    ]
  };

  

  
  

  var faSquareChevronRight = {
    prefix: 'fat',
    iconName: 'square-chevron-right',
    icon: [
      448,
      512,
      ["chevron-square-right"],
      'f32b',
      
      'M432 96c0-26.5-21.5-48-48-48L64 48C37.5 48 16 69.5 16 96l0 320c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM309.7 261.7l-120 120c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L292.7 256 178.3 141.7c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l120 120c3.1 3.1 3.1 8.2 0 11.3z'
      
    ]
  };

  
    var faChevronSquareRight = faSquareChevronRight;
  

  
  

  var faPersonSnowboarding = {
    prefix: 'fat',
    iconName: 'person-snowboarding',
    icon: [
      512,
      512,
      [127938,"snowboarding"],
      'f7ce',
      
      'M279.7 146.3l-45.2 22.6C218.3 177 208 193.6 208 211.8l0 53.2c0 6.9-4.4 13-10.9 15.2l-74.1 24.7c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l85.1-28.4c13.1-4.4 21.9-16.6 21.9-30.4V257.7c0-6.2 3.6-11.9 9.2-14.5s12.3-1.8 17 2.2l54.7 45.6c8.6 7.2 12.8 18.4 11.1 29.4l-11.9 77.2c-1.3 8.7 4.6 16.9 13.4 18.2s16.9-4.6 18.2-13.4l11.9-77.2c3.4-22.2-5-44.5-22.3-58.9l-34.9-29.1c-4.2-3.5-6.4-9-5.6-14.5s4.3-10.2 9.3-12.4l71.5-31.8c5.4-2.4 11.7-1.6 16.3 2l72.1 56.1c7 5.4 17 4.2 22.5-2.8s4.2-17-2.8-22.5L363.7 113.3c-13.7-10.7-29.7-18-46.8-21.4l-42.4-8.5c-4.8-1-9-4.1-11.2-8.5l-25-50c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5l25 50c6.6 13.2 19 22.7 33.5 25.6l7.5 1.5c6.7 1.3 11.8 6.8 12.7 13.6s-2.6 13.4-8.7 16.4zm108.5 46.9L333 217.7l-16.3 7.2 13.7 11.4 21.2 17.7c21.6 18 32.1 45.9 27.9 73.6l-11.9 77.2c-2.7 17.5-19 29.4-36.5 26.8s-29.4-19-26.8-36.5l11.9-77.2c.9-5.5-1.3-11.1-5.6-14.7L272 271l-16-13.3v18.8c0 .7 0 1.3 0 2c-.8 19.8-13.8 37.2-32.8 43.6l-85.1 28.4c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5L192 264.9l0-53.2c0-24.2 13.7-46.4 35.4-57.2L250.5 143l13.4-6.7 8.6-4.3-7.5-1.5c-5.3-1.1-10.4-2.8-15.2-5.1c-12.7-6.1-23.1-16.2-29.5-29.1l-25-50c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l25 50 42.4 8.5c19.5 3.9 37.8 12.3 53.5 24.5l126.1 98.1c14 10.9 16.5 31 5.6 44.9s-31 16.5-44.9 5.6l-72.1-56.1zM464 48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM14.9 292l20.9 36.5c6.3 11 16.2 19.6 28 24.3L415.6 492.1c6.6 2.6 13.6 3.9 20.6 3.9H488c4.4 0 8 3.6 8 8s-3.6 8-8 8H436.2c-9.1 0-18.1-1.7-26.5-5.1L57.9 367.7c-15.2-6-27.9-17-36-31.2L1.1 300c-2.2-3.8-.9-8.7 3-10.9s8.7-.9 10.9 3z'
      
    ]
  };

  
    var faSnowboarding = faPersonSnowboarding;
  

  
  

  var faArrowsRetweet = {
    prefix: 'fat',
    iconName: 'arrows-retweet',
    icon: [
      640,
      512,
      ["retweet-alt"],
      'f361',
      
      'M133.7 66.3c-3.1-3.1-8.2-3.1-11.3 0l-96 96c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L120 91.3V344c0 39.8 32.2 72 72 72H344c4.4 0 8-3.6 8-8s-3.6-8-8-8H192c-30.9 0-56-25.1-56-56V91.3l82.3 82.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-96-96zM498.3 445.7c3.1 3.1 8.2 3.1 11.3 0l96-96c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L512 420.7V168c0-39.8-32.2-72-72-72H288c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c30.9 0 56 25.1 56 56V420.7l-82.3-82.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l96 96z'
      
    ]
  };

  
    var faRetweetAlt = faArrowsRetweet;
  

  
  

  var faUserHeadset = {
    prefix: 'fat',
    iconName: 'user-headset',
    icon: [
      448,
      512,
      [],
      'f82d',
      
      'M224 32C135.6 32 64 103.6 64 192v16c0 4.4-3.6 8-8 8s-8-3.6-8-8V192C48 94.8 126.8 16 224 16s176 78.8 176 176v24c0 57.4-46.6 104-104 104H240 224 208c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32c0 5.8-1.6 11.3-4.3 16H296c48.6 0 88-39.4 88-88V192c0-88.4-71.6-160-160-160zm32 256c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16s7.2 16 16 16h16 16c8.8 0 16-7.2 16-16zm96-96c0 25.5-7.5 49.3-20.3 69.3c-7.6 4-16.2 6.4-25.4 6.7c18.4-20 29.7-46.6 29.7-76c0-61.9-50.1-112-112-112s-112 50.1-112 112c0 31.5 13 60 33.9 80.3c-1.3 5-1.9 10.3-1.9 15.7c0 1.4 0 2.7 .1 4C114.8 268.6 96 232.5 96 192c0-70.7 57.3-128 128-128s128 57.3 128 128zM208 352h32 73.6C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4C0 412.2 60.2 352 134.4 352H208zM16 486.4c0 5.3 4.3 9.6 9.6 9.6H422.4c5.3 0 9.6-4.3 9.6-9.6C432 421 379 368 313.6 368H134.4C69 368 16 421 16 486.4z'
      
    ]
  };

  

  
  

  var faY = {
    prefix: 'fat',
    iconName: 'y',
    icon: [
      384,
      512,
      [121],
      '59',
      
      'M14.4 35.2c-2.6-3.5-7.6-4.3-11.2-1.7s-4.3 7.6-1.7 11.2L184 290.6V472c0 4.4 3.6 8 8 8s8-3.6 8-8V290.6L382.4 44.8c2.6-3.5 1.9-8.6-1.7-11.2s-8.6-1.9-11.2 1.7L192 274.6 14.4 35.2z'
      
    ]
  };

  

  
  

  var faCarBurst = {
    prefix: 'fat',
    iconName: 'car-burst',
    icon: [
      640,
      512,
      ["car-crash"],
      'f5e1',
      
      'M161.5 20.5c5.7-12.4 23.4-12.4 29.1 0l31.4 68.2 58.9-14.6L269.1 93.5l-49.8 12.3c-3.7 .9-7.6-.9-9.2-4.4L176 27.2l-34.1 74.2c-1.6 3.5-5.5 5.3-9.2 4.4L53.4 86.2l36.8 73c1.7 3.3 .9 7.3-1.9 9.7L29.7 218.9l73.5 16.8c3.7 .8 6.3 4.2 6.2 7.9l-1.5 81.7L142.1 297 135 323.7l-16.8 13.9c-10.5 8.7-26.4 1.1-26.2-12.6l1.4-75.2L26.1 234.5c-12.8-2.9-16.8-19.2-6.8-27.8l53.7-46L39.1 93.4c-6.2-12.2 4.9-26 18.1-22.7l72.9 18 31.4-68.2zm146.8 70c16.5-27.6 49.3-40.8 80.4-32.5l154 41.3c31.1 8.3 52.8 36.2 53.4 68.4l1.7 100.9c23 23.5 33.4 58.1 24.3 92.2l-18.6 69.5-4.1 15.5L591 476.5c-4.6 17.1-22.1 27.2-39.2 22.6l-30.9-8.3c-17.1-4.6-27.2-22.1-22.6-39.2l8.3-30.9L259.2 354.5 251 385.4c-4.6 17.1-22.1 27.2-39.2 22.6l-30.9-8.3c-17.1-4.6-27.2-22.1-22.6-39.2l8.3-30.9 4.1-15.5 18.6-69.5c9.1-34.1 35.5-58.9 67.1-67.7l51.9-86.5zm271.8 77.4c-.4-25-17.4-46.7-41.5-53.2l-154-41.3c-24.2-6.5-49.7 3.9-62.5 25.3l-44.9 75c9.8-.5 19.8 .5 29.8 3.2L554.1 243c10 2.7 19.1 6.8 27.4 12.1l-1.4-87.4zM587.9 426l18.6-69.5c11.4-42.7-13.9-86.5-56.6-98L302.7 192.2c-42.7-11.4-86.5 13.9-98 56.6l-18.6 69.5 61.8 16.6 15.5 4.1 247.3 66.3 15.5 4.1L587.9 426zm-66-1.1l-8.3 30.9c-2.3 8.5 2.8 17.3 11.3 19.6l30.9 8.3c8.5 2.3 17.3-2.8 19.6-11.3l8.3-30.9L522 424.9zM243.8 350.4L182 333.8l-8.3 30.9c-2.3 8.5 2.8 17.3 11.3 19.6l30.9 8.3c8.5 2.3 17.3-2.8 19.6-11.3l8.3-30.9zm48-86.5a16 16 0 1 0 -30.9-8.3 16 16 0 1 0 30.9 8.3zm-46.4-12.4A32 32 0 1 1 307.3 268a32 32 0 1 1 -61.8-16.6zm289.5 94.1a16 16 0 1 0 8.3-30.9 16 16 0 1 0 -8.3 30.9zm12.4-46.4A32 32 0 1 1 530.8 361a32 32 0 1 1 16.6-61.8z'
      
    ]
  };

  
    var faCarCrash = faCarBurst;
  

  
  

  var faBoxDollar = {
    prefix: 'fat',
    iconName: 'box-dollar',
    icon: [
      448,
      512,
      ["box-usd"],
      'f4a0',
      
      'M232 48H342.4c19 0 36.2 11.2 43.9 28.5l41.6 93.6c.9 1.9 1.6 3.9 2.2 5.9H232V48zM16 192H432V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V192zm200-16H18c.6-2 1.3-4 2.2-5.9L61.7 76.5C69.4 59.2 86.6 48 105.6 48H216V176zM400.9 70c-10.3-23.1-33.2-38-58.5-38H105.6C80.3 32 57.4 46.9 47.1 70L5.5 163.6c-3.6 8.2-5.5 17-5.5 26V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V189.6c0-9-1.9-17.8-5.5-26L400.9 70zM232 232c0-4.4-3.6-8-8-8s-8 3.6-8 8v16.4c-8.4 .7-16.2 2.6-23 5.7c-12.4 5.6-21.9 15.4-24.2 28.8c-1.4 8.2-.6 15.4 2.4 21.8c3 6.3 7.8 11 13.2 14.7c10 6.8 23.7 10.9 35.9 14.6l1.7 .5c13.4 4 25 7.8 32.9 13.5c3.7 2.7 6.3 5.7 7.7 9c1.4 3.3 2.1 7.6 1.1 13.5c-1.4 8.2-6.5 14.1-15.1 17.8c-8.8 3.8-21.1 5-35.4 2.7c-7.1-1.2-19.2-5.3-28.8-8.5l0 0 0 0 0 0c-2.1-.7-4-1.4-5.7-1.9c-4.2-1.4-8.7 .9-10.1 5.1s.9 8.7 5.1 10.1c1.4 .5 3.1 1 5 1.7l0 0 0 0c9.4 3.2 23.4 8 32 9.4l0 0c1.8 .3 3.7 .5 5.5 .7V424c0 4.4 3.6 8 8 8s8-3.6 8-8l0-16.1c8.3-.5 16-2.1 22.7-5c12.6-5.4 22.1-15.4 24.5-29.7c1.5-8.5 .7-16-2.1-22.6c-2.9-6.6-7.5-11.6-13-15.5c-10.5-7.6-24.9-12-37.6-15.8l-.3-.1c-13.4-4-25-7.5-32.9-12.9c-3.8-2.6-6.3-5.3-7.7-8.3c-1.4-2.9-2.1-6.8-1.1-12.2c1.2-6.8 6.2-12.9 15.1-17c9-4.1 21.4-5.7 35.4-3.5c4.5 .7 18.5 3.4 22.9 4.6c4.3 1.1 8.7-1.4 9.8-5.7s-1.4-8.7-5.7-9.8c-5.2-1.4-19.8-4.2-24.6-4.9c-1.8-.3-3.7-.5-5.5-.7V232z'
      
    ]
  };

  
    var faBoxUsd = faBoxDollar;
  

  
  

  var faWind = {
    prefix: 'fat',
    iconName: 'wind',
    icon: [
      512,
      512,
      [],
      'f72e',
      
      'M288 8c0 4.4 3.6 8 8 8h64c39.8 0 72 32.2 72 72s-32.2 72-72 72H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H360c48.6 0 88-39.4 88-88s-39.4-88-88-88H296c-4.4 0-8 3.6-8 8zm64 400c0 4.4 3.6 8 8 8h68c46.4 0 84-37.6 84-84s-37.6-84-84-84H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H428c37.6 0 68 30.4 68 68s-30.4 68-68 68H360c-4.4 0-8 3.6-8 8zM104 512h64c48.6 0 88-39.4 88-88s-39.4-88-88-88H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H168c39.8 0 72 32.2 72 72s-32.2 72-72 72H104c-4.4 0-8 3.6-8 8s3.6 8 8 8z'
      
    ]
  };

  

  
  

  var faCircleExclamationCheck = {
    prefix: 'fat',
    iconName: 'circle-exclamation-check',
    icon: [
      640,
      512,
      [],
      'e10d',
      
      'M16 256C16 123.5 123.5 16 256 16c99.6 0 185 60.7 221.4 147.1c1.7 4.1 6.4 6 10.5 4.3s6-6.4 4.3-10.5C453.4 64.7 362.3 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c93 0 174.5-49.7 219.3-123.9c2.3-3.8 1.1-8.7-2.7-11s-8.7-1.1-11 2.7C419.6 449.5 343.2 496 256 496C123.5 496 16 388.5 16 256zM264 136c0-4.4-3.6-8-8-8s-8 3.6-8 8V296c0 4.4 3.6 8 8 8s8-3.6 8-8V136zm-8 232a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM613.7 186.3c-3.1-3.1-8.2-3.1-11.3 0L480 308.7l-58.3-58.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l64 64c3.1 3.1 8.2 3.1 11.3 0l128-128c3.1-3.1 3.1-8.2 0-11.3z'
      
    ]
  };

  

  
  

  var faWreathLaurel = {
    prefix: 'fat',
    iconName: 'wreath-laurel',
    icon: [
      640,
      512,
      [],
      'e5d2',
      
      'M272 16H256c-53 0-96 43-96 96v16h16c53 0 96-43 96-96V16zM160 144c-1.4 0-2.7-.2-4-.5c-28.2 30.6-44 70.7-44 112.5c0 114.9 93.1 208 208 208h27.6c41 0 81.4 9.5 118.1 27.9l9.9 5c4 2 5.6 6.8 3.6 10.7s-6.8 5.6-10.7 3.6l-9.9-5C424 489 386.1 480 347.6 480H320.2l-.2 0H292.4c-38.5 0-76.5 9-110.9 26.2l-9.9 5c-4 2-8.8 .4-10.7-3.6s-.4-8.8 3.6-10.7l9.9-5c23.1-11.5 47.6-19.6 72.8-24c-25.5-8.8-49-22-69.4-38.8c-58.3 23.7-126.6 1.4-158.9-54.6L10 359c-3.9-6.8-1.6-15.5 5.2-19.4c18.7-10.8 39.3-15.7 59.4-15.2C30.6 304.1 0 259.6 0 208V190.2C0 182.4 6.4 176 14.2 176c21.6 0 41.9 6 59.1 16.5C45.3 153 41 99.2 66.9 54.4L75.8 39c3.9-6.8 12.6-9.1 19.4-5.2c24.3 14 41.5 35.7 50.2 60.2C154 40.7 200.3 0 256 0h16c8.8 0 16 7.2 16 16V32c0 61.9-50.1 112-112 112H160zm-24.5-1.2c3.9-36.7-13.3-74-46.8-94.2l-8 13.8C53.5 109.6 64.5 168.3 104 202.7c6.6-21.7 17.3-42.1 31.6-60zM117.3 351.4c-28.2-14.6-62.8-15.3-92.6 1.2l8 13.8C59.6 413.1 115 433 164.3 417c-19.4-18.7-35.3-40.9-47-65.6zM96 256c0-6.2 .3-12.3 .9-18.4c-17-26.9-46.9-45-80.9-45.6v16c0 53.8 38 98.8 88.6 109.5C99 298 96 277.3 96 256zM480 128V112c0-53-43-96-96-96H368V32c0 53 43 96 96 96h16zm24.5 14.8c14.2 17.9 24.9 38.3 31.6 60c39.5-34.5 50.5-93.2 23.2-140.3l-8-13.8c-33.6 20.2-50.7 57.5-46.8 94.2zm62.2 49.7C583.9 182 604.1 176 625.8 176c7.9 0 14.2 6.4 14.2 14.2V208c0 51.6-30.6 96.1-74.6 116.4c20.2-.5 40.7 4.4 59.4 15.2c6.8 3.9 9.1 12.6 5.2 19.4l-8.9 15.4c-32.3 56-100.6 78.3-158.9 54.6c-7.6 6.2-15.6 12-23.9 17.2c-7.1-2.3-14.3-4.3-21.6-6.1C482.9 405.4 528 336 528 256c0-41.8-15.8-81.9-44-112.5c-1.3 .3-2.6 .5-4 .5H464c-61.9 0-112-50.1-112-112V16c0-8.8 7.2-16 16-16h16c55.7 0 102 40.7 110.6 94c8.8-24.5 25.9-46.2 50.2-60.2c6.8-3.9 15.5-1.6 19.4 5.2l8.9 15.4c25.8 44.7 21.6 98.6-6.4 138.1zm-44 158.9c-11.6 24.7-27.6 46.8-47 65.6c49.2 16 104.6-3.9 131.5-50.6l8-13.8c-29.7-16.5-64.4-15.8-92.6-1.2zm20.4-113.8c.6 6.1 .9 12.2 .9 18.4c0 21.3-3 42-8.6 61.5C586 306.8 624 261.8 624 208V192c-34.1 .6-63.9 18.7-80.9 45.6z'
      
    ]
  };

  

  
  

  var faMegaphone = {
    prefix: 'fat',
    iconName: 'megaphone',
    icon: [
      576,
      512,
      [128227],
      'f675',
      
      'M560 64V448c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-8.8 7.2-16 16-16s16 7.2 16 16zm-48 0V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-32 1.8L16 181.8V168c0-4.4-3.6-8-8-8s-8 3.6-8 8v17.8V192 320v6.2V344c0 4.4 3.6 8 8 8s8-3.6 8-8V330.2l145.6 36.4c-1 5.6-1.6 11.4-1.6 17.4c0 53 43 96 96 96c42.9 0 79.1-28.1 91.5-66.8l-1.7-.5L480 446.2V429.8L16 313.8V198.2l464-116V65.8zM176 384c0-4.6 .4-9.1 1.1-13.5l154.8 38.7C321.4 441 291.4 464 256 464c-44.2 0-80-35.8-80-80zm80-96l-.4 0h.7l-.4 0z'
      
    ]
  };

  

  
  

  var faUserShield = {
    prefix: 'fat',
    iconName: 'user-shield',
    icon: [
      640,
      512,
      [],
      'f505',
      
      'M112 128a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm240 0A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM16 482.3C16 392.7 88.7 320 178.3 320h91.4c18.3 0 35.8 3 52.2 8.6c-.7-6-1.2-11.7-1.5-17.3c-16.1-4.8-33.1-7.3-50.7-7.3H178.3C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c1.8 0 3.5-.2 5.3-.5c-6.8-4.9-13.3-10.1-19.3-15.5H29.7c-7.6 0-13.7-6.1-13.7-13.7zM373 288.6l115-46V493.3c-96.1-42.9-120-138-120-197.3c0-3.3 2-6.2 5-7.4zM624 296c0 59.3-23.9 154.4-120 197.3V242.6l115 46c3 1.2 5 4.2 5 7.4zM504.9 225.7c-5.7-2.3-12.1-2.3-17.8 0l-120 48C358 277.4 352 286.2 352 296c0 63.3 25.9 168.8 134.8 214.2c5.9 2.5 12.6 2.5 18.5 0C614.1 464.8 640 359.3 640 296c0-9.8-6-18.6-15.1-22.3l-120-48z'
      
    ]
  };

  

  
  

  var faMushroom = {
    prefix: 'fat',
    iconName: 'mushroom',
    icon: [
      512,
      512,
      [127812],
      'e425',
      
      'M135.5 82c12.8 27.2 40.4 46 72.5 46c43.6 0 79.1-35 80-78.4c-8.5-1.1-17.3-1.6-26.1-1.6H250.1c-42.3 0-81.6 12.5-114.6 34zm-13.2 9.4C72.3 129.7 40 190.1 40 258.1C40 283.5 60.5 304 85.9 304H426.1c25.3 0 45.9-20.5 45.9-45.9c0-19.5-2.6-38.3-7.6-56.2C452.7 215.4 435.3 224 416 224c-35.3 0-64-28.7-64-64c0-29.3 19.6-53.9 46.5-61.6c-26.6-22.8-58.9-39-94.6-46.2C301.7 103.3 259.6 144 208 144c-37.4 0-69.9-21.4-85.7-52.7zM413 112.1c-25.1 1.6-45 22.4-45 47.9c0 26.5 21.5 48 48 48c18.2 0 34-10.1 42.2-25c-10.2-26.7-25.7-50.7-45.2-70.9zM24 258.1C24 133.2 125.2 32 250.1 32h11.8C386.8 32 488 133.2 488 258.1c0 34.2-27.7 61.9-61.9 61.9H85.9C51.7 320 24 292.3 24 258.1zm144.5 184L185.4 352h16.3l-17.4 93.1c-.9 4.7 .4 9.5 3.4 13.2s7.6 5.8 12.3 5.8H312c4.8 0 9.3-2.1 12.3-5.8s4.3-8.5 3.4-13.2L310.3 352h16.3l16.9 90.1c1.8 9.4-.7 19-6.8 26.3s-15.1 11.6-24.6 11.6H200c-9.5 0-18.5-4.2-24.6-11.6s-8.6-17-6.8-26.3zM128 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  

  
  

  var faPlanetRinged = {
    prefix: 'fat',
    iconName: 'planet-ringed',
    icon: [
      512,
      512,
      [129680],
      'e020',
      
      'M493.7 48.6c4.7-19.1 1.4-26.7-1.1-29.2s-10.1-5.7-29.2-1.1c-18 4.4-41.4 14.8-69 31.1c-2.7 1.6-5.4 3.2-8.1 4.9c-5.1-3.3-10.2-6.3-15.5-9.2c63.8-40.5 113.9-56.2 133.1-37c22.1 22.1-2.3 85.6-57.6 163.7C457.7 197.6 464 226 464 256c0 114.9-93.1 208-208 208c-30 0-58.4-6.3-84.2-17.7C93.7 501.6 30.3 526 8.1 503.9c-19.2-19.2-3.4-69.3 37-133.1c2.9 5.2 5.9 10.4 9.2 15.5c-1.7 2.7-3.3 5.5-4.9 8.1c-16.3 27.6-26.7 51-31.1 69c-4.7 19.1-1.4 26.7 1.1 29.2s10.1 5.7 29.2 1.1c18-4.4 41.5-14.8 69-31.1c12-7.1 24.7-15.3 37.9-24.4C91.4 402.7 48 334.4 48 256C48 141.1 141.1 48 256 48c78.4 0 146.7 43.4 182.2 107.5c9.1-13.2 17.3-25.9 24.4-37.9c16.3-27.6 26.7-51 31.1-69zM427.8 170.2C396.3 107.2 331.2 64 256 64C150 64 64 150 64 256c0 75.2 43.2 140.3 106.2 171.8c43.1-31.3 90.7-71.9 138.2-119.4s88.1-95.1 119.4-138.2zM187 435.2c21.4 8.2 44.6 12.8 69 12.8c106 0 192-86 192-192c0-24.3-4.5-47.6-12.8-69c-31.1 41.9-70.3 87.4-115.6 132.6S229 404.2 187 435.2z'
      
    ]
  };

  

  
  

  var faUserDoctorHair = {
    prefix: 'fat',
    iconName: 'user-doctor-hair',
    icon: [
      448,
      512,
      [],
      'e458',
      
      'M336 128c0-5.4-.4-10.8-1.1-16H312c-22.1 0-43-10.2-56.6-27.5L251 89.9C231.2 114 201.7 128 170.5 128L112 128v16c0 61.9 50.1 112 112 112s112-50.1 112-112V128zM267.2 73.6C277.8 87.7 294.4 96 312 96h19.4c-6.8-22.8-20.6-42.5-39-56.7L265.8 71.8l1.4 1.8zM279 30.4C262.7 21.2 244 16 224 16c-56.4 0-103.1 41.7-110.9 96h57.4c26.4 0 51.4-11.8 68.1-32.3L279 30.4zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V128zm56 194v46.7c22.7 3.8 40 23.6 40 47.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-23.8 17.3-43.5 40-47.3V325.3C66.9 343.5 16 406.4 16 481.2c0 8.2 6.6 14.8 14.8 14.8H417.2c8.2 0 14.8-6.6 14.8-14.8c0-74.8-50.9-137.7-120-155.9v43.4c22.7 3.8 40 23.6 40 47.3v40c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8s3.6-8 8-8h8V416c0-17.7-14.3-32-32-32s-32 14.3-32 32v32h8c4.4 0 8 3.6 8 8s-3.6 8-8 8H264c-4.4 0-8-3.6-8-8V416c0-23.8 17.3-43.5 40-47.3V322c-8.2-1.3-16.6-2-25.2-2H177.2c-8.6 0-17 .7-25.2 2zm-40 94a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM0 481.2C0 383.3 79.3 304 177.2 304h93.6C368.7 304 448 383.3 448 481.2c0 17-13.8 30.8-30.8 30.8H30.8C13.8 512 0 498.2 0 481.2z'
      
    ]
  };

  

  
  

  var faSquareY = {
    prefix: 'fat',
    iconName: 'square-y',
    icon: [
      448,
      512,
      [],
      'e287',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm110 34.7L224 259.9 338 130.7c2.9-3.3 8-3.6 11.3-.7s3.6 8 .7 11.3L232 275V376c0 4.4-3.6 8-8 8s-8-3.6-8-8V275L98 141.3c-2.9-3.3-2.6-8.4 .7-11.3s8.4-2.6 11.3 .7z'
      
    ]
  };

  

  
  

  var faCircleUser = {
    prefix: 'fat',
    iconName: 'circle-user',
    icon: [
      512,
      512,
      [62142,"user-circle"],
      'f2bd',
      
      'M256 496c-54 0-103.9-17.9-144-48v0c0-61.9 50.1-112 112-112h64c61.9 0 112 50.1 112 112v0c5.3-4 10.4-8.2 15.4-12.6C409.1 370.6 354.5 320 288 320H224c-66.5 0-121.1 50.6-127.4 115.4C47.2 391.5 16 327.4 16 256C16 123.5 123.5 16 256 16s240 107.5 240 240s-107.5 240-240 240zm0 16A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm80-304a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-80-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
      
    ]
  };

  
    var faUserCircle = faCircleUser;
  

  
  

  var faJugDetergent = {
    prefix: 'fat',
    iconName: 'jug-detergent',
    icon: [
      384,
      512,
      [],
      'e519',
      
      'M120 16h80c4.4 0 8 3.6 8 8V80H112V24c0-4.4 3.6-8 8-8zM96 80H72c-4.4 0-8 3.6-8 8s3.6 8 8 8H96h16 96 16 24c4.4 0 8-3.6 8-8s-3.6-8-8-8H224V24c0-13.3-10.7-24-24-24H120C106.7 0 96 10.7 96 24V80zm160 64c61.9 0 112 50.1 112 112V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V256c0-61.9 50.1-112 112-112H256zM128 128C57.3 128 0 185.3 0 256V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V256c0-70.7-57.3-128-128-128H128zm152 80c-22.1 0-40 17.9-40 40v80c0 22.1 17.9 40 40 40s40-17.9 40-40V248c0-22.1-17.9-40-40-40zm-24 40c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V248z'
      
    ]
  };

  

  
  

  var faDiagramSubtask = {
    prefix: 'fat',
    iconName: 'diagram-subtask',
    icon: [
      512,
      512,
      [],
      'e479',
      
      'M448 48c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H448zM64 32C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64h56v96c0 39.8 32.2 72 72 72h32v24c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V352c0-35.3-28.7-64-64-64H288c-35.3 0-64 28.7-64 64v24H192c-30.9 0-56-25.1-56-56V224H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM448 304c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H288c-26.5 0-48-21.5-48-48V352c0-26.5 21.5-48 48-48H448z'
      
    ]
  };

  

  
  

  var faListCheck = {
    prefix: 'fat',
    iconName: 'list-check',
    icon: [
      512,
      512,
      ["tasks"],
      'f0ae',
      
      'M157.7 53.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L63.5 125.2 21.1 89.9c-3.4-2.8-8.4-2.4-11.3 1s-2.4 8.4 1 11.3l48 40c3.2 2.6 7.9 2.4 10.8-.5l88-88zm0 160c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L63.5 285.2 21.1 249.9c-3.4-2.8-8.4-2.4-11.3 1s-2.4 8.4 1 11.3l48 40c3.2 2.6 7.9 2.4 10.8-.5l88-88zM200 96c0 4.4 3.6 8 8 8H496c4.4 0 8-3.6 8-8s-3.6-8-8-8H208c-4.4 0-8 3.6-8 8zm0 160c0 4.4 3.6 8 8 8H496c4.4 0 8-3.6 8-8s-3.6-8-8-8H208c-4.4 0-8 3.6-8 8zM168 416c0 4.4 3.6 8 8 8H496c4.4 0 8-3.6 8-8s-3.6-8-8-8H176c-4.4 0-8 3.6-8 8zm-88 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  
    var faTasks = faListCheck;
  

  
  

  var faShrimp = {
    prefix: 'fat',
    iconName: 'shrimp',
    icon: [
      512,
      512,
      [129424],
      'e448',
      
      'M0 88C0 57.1 25.1 32 56 32H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H56C33.9 48 16 65.9 16 88s17.9 40 40 40H336c97.2 0 176 78.8 176 176s-78.8 176-176 176H232c-4.4 0-8-3.6-8-8c0-2.7 1.4-5.1 3.4-6.6l47.6-34-48.2-41.4c-2.7-2.3-3.5-6.1-2.1-9.3s4.8-5.1 8.4-4.7l110.6 14.7c5.4 .7 10.8 .5 16.2-.5c14.1-2.8 24.2-15.2 24.2-29.6V356c0-19.9-16.1-36-36-36H240c-97.2 0-176-78.8-176-176H56C25.1 144 0 118.9 0 88zM336 464c2.7 0 5.4-.1 8-.2V432c0-4.4 3.6-8 8-8s8 3.6 8 8v30.2c46.8-7 87-34.3 111.3-72.7l-41.8-13.9c-4.2-1.4-6.5-5.9-5.1-10.1s5.9-6.5 10.1-5.1l44.7 14.9C490 353.8 496 329.6 496 304c0-24.7-5.6-48.2-15.6-69.1l-42.7 42.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l46-46C444.2 174.5 393.7 144 336 144V248c0 4.4-3.6 8-8 8s-8-3.6-8-8V144H80c0 88.4 71.6 160 160 160H348c28.7 0 52 23.3 52 52v4.8c0 22-15.5 40.9-37.1 45.2c-7 1.4-14.3 1.6-21.4 .7l-83.8-11.2 35.5 30.4c1.9 1.6 2.9 4 2.8 6.4s-1.3 4.7-3.3 6.2L257 464h79zM192 176a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faCircleDivide = {
    prefix: 'fat',
    iconName: 'circle-divide',
    icon: [
      512,
      512,
      [],
      'e106',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM240 160a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM152 248c-4.4 0-8 3.6-8 8s3.6 8 8 8H360c4.4 0 8-3.6 8-8s-3.6-8-8-8H152zm104 88a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faBorderLeft = {
    prefix: 'fat',
    iconName: 'border-left',
    icon: [
      448,
      512,
      [],
      'f84f',
      
      'M8 480c-4.4 0-8-3.6-8-8L0 40c0-4.4 3.6-8 8-8s8 3.6 8 8l0 432c0 4.4-3.6 8-8 8zm120-48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0-352a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm0 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM320 464a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm0-416a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 224a16 16 0 1 1 0-32 16 16 0 1 1 0 32zM224 432a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0-352a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm0 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM416 464a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm0-416a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 224a16 16 0 1 1 0-32 16 16 0 1 1 0 32zM224 336a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm192 32a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm0-224a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM224 176a16 16 0 1 1 0-32 16 16 0 1 1 0 32z'
      
    ]
  };

  

  
  

  var faTv = {
    prefix: 'fat',
    iconName: 'tv',
    icon: [
      640,
      512,
      [63717,"television","tv-alt"],
      'f26c',
      
      'M576 16c26.5 0 48 21.5 48 48V384c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H576zM64 0C28.7 0 0 28.7 0 64V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM96 504c0 4.4 3.6 8 8 8H536c4.4 0 8-3.6 8-8s-3.6-8-8-8H104c-4.4 0-8 3.6-8 8zM80 80H560V368H80V80zM64 80V368c0 8.8 7.2 16 16 16H560c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  
    var faTelevision = faTv;
  
    var faTvAlt = faTv;
  

  
  

  var faDownFromDottedLine = {
    prefix: 'fat',
    iconName: 'down-from-dotted-line',
    icon: [
      448,
      512,
      [],
      'e407',
      
      'M216 460.7c2.1 2.1 5 3.3 8 3.3s5.9-1.2 8-3.3L363.8 328.6c2.7-2.7 4.2-6.4 4.2-10.2c0-8-6.5-14.4-14.4-14.4H280c-4.4 0-8-3.6-8-8V160c0-8.8-7.2-16-16-16H192c-8.8 0-16 7.2-16 16V296c0 4.4-3.6 8-8 8H94.4c-8 0-14.4 6.5-14.4 14.4c0 3.8 1.5 7.5 4.2 10.2L216 460.7zm8 19.3c-7.2 0-14.2-2.9-19.3-8L72.9 339.9c-5.7-5.7-8.9-13.4-8.9-21.5C64 301.6 77.6 288 94.4 288H160V160c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V288h65.6c16.8 0 30.4 13.6 30.4 30.4c0 8.1-3.2 15.8-8.9 21.5L243.3 472c-5.1 5.1-12.1 8-19.3 8zM32 64a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm96 0a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm80-16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM320 64a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm80-16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faArrowUp = {
    prefix: 'fat',
    iconName: 'arrow-up',
    icon: [
      384,
      512,
      [8593],
      'f062',
      
      'M197.8 34.5c-1.5-1.6-3.6-2.5-5.8-2.5s-4.3 .9-5.8 2.5l-184 192c-3.1 3.2-2.9 8.3 .2 11.3s8.3 2.9 11.3-.2L184 59.9V472c0 4.4 3.6 8 8 8s8-3.6 8-8V59.9L370.2 237.5c3.1 3.2 8.1 3.3 11.3 .2s3.3-8.1 .2-11.3l-184-192z'
      
    ]
  };

  

  
  

  var faBoneBreak = {
    prefix: 'fat',
    iconName: 'bone-break',
    icon: [
      640,
      512,
      [],
      'f5d8',
      
      'M320 0c-4.4 0-8 3.6-8 8V120c0 4.4 3.6 8 8 8s8-3.6 8-8V8c0-4.4-3.6-8-8-8zM162.3 66.3c-3.1 3.1-3.1 8.2 0 11.3l80 80c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-80-80c-3.1-3.1-8.2-3.1-11.3 0zm315.3 0c-3.1-3.1-8.2-3.1-11.3 0l-80 80c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l80-80c3.1-3.1 3.1-8.2 0-11.3zM268.4 236c-1.1-4.3-5.5-6.8-9.8-5.7L167 254.9c-4.3 1.1-8.6-1.4-10.2-5.5c-14.3-38-55.5-59.7-95.5-49c-42.7 11.4-68 55.3-56.6 98c8 29.9 31.9 51.3 60.2 57.5c3.1 .7 5.7 2.9 6.5 6l.7 2.7c.8 3.1-.3 6.3-2.6 8.5c-21.4 19.5-31.4 50-23.4 79.9c11.4 42.7 55.3 68 98 56.6c40.1-10.7 64.8-50.1 58.3-90.2c-.7-4.4 1.8-8.7 6-9.9L300 384.9c4.3-1.1 6.8-5.5 5.7-9.8s-5.5-6.8-9.8-5.7L204.3 394c-13.2 3.5-19.6 16.5-17.7 27.9C191.8 454 172 485.4 140 494c-34.1 9.1-69.2-11.1-78.4-45.3c-6.4-23.9 1.6-48.3 18.7-63.9c6.3-5.8 9.8-15 7.3-24.4l-.7-2.7c-2.5-9.4-10.2-15.7-18.5-17.5c-22.7-5-41.8-22.1-48.2-46C11 260.1 31.3 225 65.4 215.8c32-8.6 65 8.7 76.4 39.1c4.1 10.9 16.1 18.9 29.3 15.4l91.6-24.6c4.3-1.1 6.8-5.5 5.7-9.8zm114.9-5.7c-4.3-1.1-8.7 1.4-9.8 5.7s1.4 8.7 5.7 9.8l91.6 24.6c13.2 3.5 25.2-4.5 29.3-15.4c11.5-30.4 44.4-47.7 76.4-39.1c34.1 9.1 54.4 44.2 45.3 78.4c-6.4 23.9-25.5 41-48.2 46c-8.4 1.8-16 8.1-18.5 17.5l-.7 2.7c-2.5 9.4 1 18.7 7.3 24.4c17.1 15.6 25.1 40 18.7 63.9c-9.1 34.1-44.2 54.4-78.4 45.3c-32.1-8.6-51.9-40.1-46.6-72.1c1.9-11.5-4.5-24.4-17.7-27.9l-91.6-24.6c-4.3-1.1-8.7 1.4-9.8 5.7s1.4 8.7 5.7 9.8l91.6 24.6c4.3 1.1 6.8 5.5 6 9.9c-6.6 40.1 18.2 79.4 58.3 90.2c42.7 11.4 86.5-13.9 98-56.6c8-29.9-2-60.4-23.4-79.9c-2.3-2.1-3.4-5.4-2.6-8.5l.7-2.7c.8-3.1 3.4-5.3 6.5-6c28.3-6.2 52.2-27.6 60.2-57.5c11.4-42.7-13.9-86.5-56.6-98c-40.1-10.7-81.2 10.9-95.5 49c-1.6 4.1-5.9 6.7-10.2 5.5l-91.6-24.6z'
      
    ]
  };

  

  
  

  var faLandmarkDome = {
    prefix: 'fat',
    iconName: 'landmark-dome',
    icon: [
      512,
      512,
      ["landmark-alt"],
      'f752',
      
      'M256 0c4.4 0 8 3.6 8 8v8.2c97 4 175.4 79.9 183.3 175.8H464c4.4 0 8 3.6 8 8s-3.6 8-8 8H448 432 80 64 48c-4.4 0-8-3.6-8-8s3.6-8 8-8H64.7C72.6 96.1 151 20.1 248 16.2V8c0-4.4 3.6-8 8-8zM80.7 192H431.3C423.2 102.3 347.8 32 256 32S88.8 102.3 80.7 192zM80 248V368H184V248c0-4.4 3.6-8 8-8s8 3.6 8 8V368H312V248c0-4.4 3.6-8 8-8s8 3.6 8 8V368H432V248c0-4.4 3.6-8 8-8s8 3.6 8 8V376c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8V248c0-4.4 3.6-8 8-8s8 3.6 8 8zM40 432H472c4.4 0 8 3.6 8 8s-3.6 8-8 8H40c-4.4 0-8-3.6-8-8s3.6-8 8-8zM8 496H504c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  
    var faLandmarkAlt = faLandmarkDome;
  

  
  

  var faBrazilianRealSign = {
    prefix: 'fat',
    iconName: 'brazilian-real-sign',
    icon: [
      512,
      512,
      [],
      'e46c',
      
      'M400 0c4.4 0 8 3.6 8 8V64.1c18.5 .6 36.7 4.6 53.8 11.7l13.3 5.6c4.1 1.7 6 6.4 4.3 10.5s-6.4 6-10.5 4.3l-13.3-5.6C439 83.6 421.1 80 403 80h-20c-43.7 0-79.1 35.4-79.1 79.1c0 34.3 22.1 64.7 54.8 75.3l87.3 28.1c39.3 12.7 65.9 49.2 65.9 90.5c0 52.5-42.6 95.1-95.1 95.1H408v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V448c-23.4-.6-46.3-7.2-66.5-19.3l-25.6-15.3c-3.8-2.3-5-7.2-2.8-11s7.2-5 11-2.8L333.7 415c18.6 11.2 39.9 17 61.6 17h21.5c43.7 0 79.1-35.4 79.1-79.1c0-34.3-22.1-64.7-54.8-75.3l-87.3-28.1c-39.3-12.7-65.9-49.2-65.9-90.5c0-52.5 42.6-95.1 95.1-95.1H392V8c0-4.4 3.6-8 8-8zM0 72C0 49.9 17.9 32 40 32h80c75.1 0 136 60.9 136 136c0 68.7-50.9 125.5-117.1 134.7l60.6 166.6c1.5 4.2-.6 8.7-4.8 10.2s-8.7-.6-10.3-4.8L122.4 304c-.8 0-1.6 0-2.4 0H16V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V296 72zM16 288H120c66.3 0 120-53.7 120-120s-53.7-120-120-120H40C26.7 48 16 58.7 16 72V288z'
      
    ]
  };

  

  
  

  var faHatWinter = {
    prefix: 'fat',
    iconName: 'hat-winter',
    icon: [
      512,
      512,
      [],
      'f7a8',
      
      'M269.5 23.4c3.6 5.7 10.4 8.5 16.9 7c5.2-1.2 10.8 .3 14.8 4.3s5.5 9.6 4.3 14.8c-1.5 6.6 1.4 13.3 7 16.9c4.5 2.9 7.4 7.9 7.4 13.5s-2.9 10.6-7.4 13.5c-5.7 3.6-8.5 10.4-7 16.9c1.2 5.2-.3 10.8-4.3 14.8s-9.6 5.5-14.8 4.3c-6.6-1.5-13.3 1.4-16.9 7c-2.9 4.5-7.9 7.4-13.5 7.4s-10.6-2.9-13.5-7.4c-3.6-5.7-10.4-8.5-16.9-7c-5.2 1.2-10.8-.3-14.8-4.3s-5.5-9.6-4.3-14.8c1.5-6.6-1.4-13.3-7-16.9c-4.5-2.9-7.4-7.9-7.4-13.5s2.9-10.6 7.4-13.5c5.7-3.6 8.5-10.4 7-16.9c-1.2-5.2 .3-10.8 4.3-14.8s9.6-5.5 14.8-4.3c6.6 1.5 13.3-1.4 16.9-7c2.9-4.5 7.9-7.4 13.5-7.4s10.6 2.9 13.5 7.4zM336 80c0-11.3-5.9-21.3-14.8-27c2.3-10.3-.6-21.5-8.6-29.6s-19.3-10.9-29.6-8.6C277.3 5.9 267.3 0 256 0s-21.3 5.9-27 14.8c-10.3-2.3-21.5 .6-29.6 8.6s-10.9 19.3-8.6 29.6C181.9 58.7 176 68.7 176 80s5.9 21.3 14.8 27c-2.3 10.3 .6 21.5 8.6 29.6s19.3 10.9 29.6 8.6c5.7 8.9 15.7 14.8 27 14.8s21.3-5.9 27-14.8c10.3 2.3 21.5-.6 29.6-8.6s10.9-19.3 8.6-29.6c8.9-5.7 14.8-15.7 14.8-27zM16 456c0-22.1 17.9-40 40-40H456c22.1 0 40 17.9 40 40s-17.9 40-40 40H56c-22.1 0-40-17.9-40-40zM0 456c0 30.9 25.1 56 56 56H456c30.9 0 56-25.1 56-56s-25.1-56-56-56H56c-30.9 0-56 25.1-56 56zM162.5 134.6C64.3 188.2 39.4 321.8 33.6 368H49.7c.8-6.4 2-14.4 3.7-23.6c.9-5 2-10.4 3.3-16l2.5-1.1 58.2-25.9c6.6-2.9 14.1-2.7 20.5 .5L174.1 320c11.3 5.6 24.5 5.6 35.8 0l35.4-17.7c6.8-3.4 14.7-3.4 21.5 0L302.1 320c11.3 5.6 24.5 5.6 35.8 0l36.2-18.1c6.4-3.2 13.9-3.4 20.5-.5l58.2 25.9 2.5 1.1c1.3 5.6 2.3 11 3.3 16c1.7 9.1 2.9 17.1 3.7 23.6h16.1c-5.8-46.2-30.7-179.8-128.8-233.4c-1.4 5.1-3.6 10.1-6.5 14.7c42.3 23.5 70 63.5 88.3 105.1c8.2 18.5 14.4 37.1 19 54.3L401 286.8c-10.9-4.9-23.4-4.6-34.1 .8l-36.2 18.1c-6.8 3.4-14.7 3.4-21.5 0L273.9 288c-11.3-5.6-24.5-5.6-35.8 0l-35.4 17.7c-6.8 3.4-14.7 3.4-21.5 0l-36.2-18.1c-10.7-5.3-23.2-5.6-34.1-.8L61.6 308.7c4.7-17.2 10.8-35.8 19-54.3c18.3-41.6 46-81.6 88.3-105.1c-2.9-4.6-5.1-9.6-6.5-14.7z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassPlay = {
    prefix: 'fat',
    iconName: 'magnifying-glass-play',
    icon: [
      512,
      512,
      [],
      'e660',
      
      'M208 16a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 400c54.6 0 104.2-21 141.3-55.4l149 149c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-149-149C395 312.2 416 262.6 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm64-208L161.8 272V144L272 208zM169.8 130.2c-10.5-6.1-24 1.7-24 13.8V272c0 12.1 13.6 19.9 24 13.8l110.2-64c10.4-6.1 10.4-21.6 0-27.7l-110.2-64z'
      
    ]
  };

  

  
  

  var faPersonHarassing = {
    prefix: 'fat',
    iconName: 'person-harassing',
    icon: [
      576,
      512,
      [],
      'e549',
      
      'M232 56a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm-96 0a56 56 0 1 1 112 0A56 56 0 1 1 136 56zM104 248V480c0 8.8 7.2 16 16 16s16-7.2 16-16V360c0-13.3 10.7-24 24-24s24 10.7 24 24V480c0 8.8 7.2 16 16 16s16-7.2 16-16V248c0-4.4 3.6-8 8-8s8 3.6 8 8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V360c0-4.4-3.6-8-8-8s-8 3.6-8 8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V248c0-4.4 3.6-8 8-8s8 3.6 8 8zm37.1-104c-21.5 0-41.1 12.3-50.4 31.7L23.2 315.5c-1.9 4-6.7 5.6-10.7 3.7s-5.6-6.7-3.7-10.7L76.3 168.7c12-24.9 37.2-40.7 64.8-40.7h43.6c24.1 0 46.6 12.1 60 32.2l81.9 123.4c2.4 3.7 1.4 8.6-2.2 11.1s-8.6 1.4-11.1-2.2L231.4 169c-10.4-15.6-27.9-25-46.7-25H141.1zM452.7 414.1l-41.4-41.4c-3.6-3.6-8.8-5.3-13.9-4.5s-9.4 4-11.7 8.6l-48 96c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l28.1-56.3c2.3-4.6 6.7-7.8 11.7-8.6s10.2 .8 13.9 4.5l54.7 54.7c9.4 9.4 22.1 14.6 35.3 14.6c27.6 0 49.9-22.4 49.9-49.9V344c0-22.1-17.9-40-40-40s-40 17.9-40 40v58.7c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5zM464 240a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-.6 252.7l-42.7-42.7L408.8 438l-7.5 15.1-20.6 41.2c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l48-96c4.6-9.2 13.3-15.6 23.5-17.3s20.5 1.7 27.8 9L448 386.7l16 16V380.1 344c0-30.9 25.1-56 56-56s56 25.1 56 56V446.1c0 36.4-29.5 65.9-65.9 65.9c-17.5 0-34.3-6.9-46.6-19.3zM432 192a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM296 48c0-4.4 3.6-8 8-8h56c4.4 0 8 3.6 8 8s-3.6 8-8 8H304c-4.4 0-8-3.6-8-8zm-12.4 56.8l48 24c4 2 5.6 6.8 3.6 10.7s-6.8 5.6-10.7 3.6l-48-24c-4-2-5.6-6.8-3.6-10.7s6.8-5.6 10.7-3.6z'
      
    ]
  };

  

  
  

  var faNfcPen = {
    prefix: 'fat',
    iconName: 'nfc-pen',
    icon: [
      576,
      512,
      [],
      'e1fa',
      
      'M384 48H64C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H262.2l-4 16H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V235.3l-16 16V96c0-26.5-21.5-48-48-48zm-16 88V315.3l-16 16V136c0-4.4-3.6-8-8-8H240c-4.4 0-8 3.6-8 8v80.8c18.3 3.7 32 19.8 32 39.2c0 22.1-17.9 40-40 40s-40-17.9-40-40c0-19.4 13.7-35.5 32-39.2V136c0-13.3 10.7-24 24-24H344c13.3 0 24 10.7 24 24zM289 394.3c-1.8 1.8-3.5 3.7-5 5.7H104c-13.3 0-24-10.7-24-24V136c0-13.3 10.7-24 24-24h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H104c-4.4 0-8 3.6-8 8V376c0 4.4 3.6 8 8 8H299.3L289 394.3zM224 232a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm68.7 275.2c-4-4-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9L493.2 235.7c15.6-15.6 40.9-15.6 56.6 0l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6L382.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-3.4-13.6 3.4 13.6-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2zm15.7-28.9L304 495.8l17.6-4.4 42.5-10.6c2.8-.7 5.4-2.2 7.4-4.2L514.4 333.7l-48.3-48.3L323.2 428.3c-2 2.1-3.5 4.6-4.2 7.4l-10.6 42.5zM552.8 295.4c9.4-9.4 9.4-24.6 0-33.9L538.4 247c-9.4-9.4-24.6-9.4-33.9 0l-27.1 27.1 48.3 48.3 27.1-27.1z'
      
    ]
  };

  

  
  

  var faChessKing = {
    prefix: 'fat',
    iconName: 'chess-king',
    icon: [
      448,
      512,
      [9818],
      'f43f',
      
      'M224 0c4.4 0 8 3.6 8 8V56h56c4.4 0 8 3.6 8 8s-3.6 8-8 8H232v88H408c22.1 0 40 17.9 40 40v1.9c0 5-.9 10-2.8 14.6L379.5 384H362.3l68.1-173.3c1.1-2.8 1.7-5.8 1.7-8.8V200c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24v1.9c0 3 .6 6 1.7 8.8L85.7 384H68.5L2.8 216.6C.9 211.9 0 206.9 0 201.9V200c0-22.1 17.9-40 40-40H216V72H160c-4.4 0-8-3.6-8-8s3.6-8 8-8h56V8c0-4.4 3.6-8 8-8zM94.3 432c-4.5 0-8.9 1.9-11.9 5.3L51.8 471.2c-2.5 2.7-3.8 6.3-3.8 9.9c0 8.2 6.6 14.8 14.8 14.8H385.2c8.2 0 14.8-6.6 14.8-14.8c0-3.7-1.4-7.2-3.8-9.9l-30.6-33.9c-3-3.4-7.4-5.3-11.9-5.3H94.3zm313.8 28.5c5.1 5.7 7.9 13 7.9 20.6c0 17-13.8 30.8-30.8 30.8H62.8c-17 0-30.8-13.8-30.8-30.8c0-7.6 2.8-15 7.9-20.6l30.6-33.9c6.1-6.7 14.7-10.6 23.8-10.6H353.7c9.1 0 17.7 3.8 23.8 10.6l30.6 33.9z'
      
    ]
  };

  

  
  

  var faRankingStar = {
    prefix: 'fat',
    iconName: 'ranking-star',
    icon: [
      640,
      512,
      [],
      'e561',
      
      'M317 17.9L293.3 65.7l-1.9 3.8-4.2 .6-52.2 7.5c-2.9 .5-4.1 4-2 6.2l37.9 37 3 2.9-.7 4.1-8.9 52c-.4 2.9 2.6 5.1 5.3 3.8l46.8-24.7 3.7-2 3.7 2 46.5 24.4c2.7 1.3 5.7-.9 5.3-3.8l-8.9-52-.7-4.2 3-2.9 37.9-36.6c2.1-2.1 .9-5.7-2-6.2L352.7 70l-4.2-.6-1.9-3.8L323 17.9l-.1-.1 0 0c-1.1-2.3-4.7-2.5-6 .1l0 0zm-14.3-7.1c7.3-14.6 28-14.1 34.8 .1l21.8 44 48.1 6.9 .1 0 0 0c15.7 2.4 22.4 21.8 10.9 33.3l-.1 .1 0 0-34.9 33.7 8.2 47.9 0 .1 0 0c2.4 15.7-13.9 27.8-28.3 20.6l-.1-.1 0 0L320.2 175 277 197.8l-.2 .1 0 0c-14.5 7.3-30.7-4.9-28.3-20.6l0-.1 0 0 8.2-47.9L221.8 95.1l-.1-.1 0 0c-11.5-11.5-4.8-30.9 10.9-33.3l.1 0 0 0 48.1-6.9 21.8-44 0 0zM272 272c-17.7 0-32 14.3-32 32V464c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V304c0-17.7-14.3-32-32-32H272zm-48 32c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V304zM48 336c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V368c0-17.7-14.3-32-32-32H48zM0 368c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368zm592 32H496c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V432c0-17.7-14.3-32-32-32zm-96-16h96c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H496c-26.5 0-48-21.5-48-48V432c0-26.5 21.5-48 48-48z'
      
    ]
  };

  

  
  

  var faPhoneOffice = {
    prefix: 'fat',
    iconName: 'phone-office',
    icon: [
      576,
      512,
      [],
      'f67d',
      
      'M176 16c26.5 0 48 21.5 48 48V384c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48h32zM144 0C120.3 0 99.6 12.9 88.6 32H64C28.7 32 0 60.7 0 96V448c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H231.4C220.4 12.9 199.7 0 176 0H144zM64 48H82c-1.3 5.1-2 10.5-2 16V384c0 35.3 28.7 64 64 64h32c35.3 0 64-28.7 64-64V64c0-5.5-.7-10.9-2-16H512c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48zm272 64H464c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16zm-32 16v48c0 17.7 14.3 32 32 32H464c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H336c-17.7 0-32 14.3-32 32zm0 168a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm40 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm112-64a40 40 0 1 0 0 80 40 40 0 1 0 0-80zm24 40a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM416 408a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm40 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM344 368a40 40 0 1 0 0 80 40 40 0 1 0 0-80zm24 40a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z'
      
    ]
  };

  

  
  

  var faEnvelopes = {
    prefix: 'fat',
    iconName: 'envelopes',
    icon: [
      576,
      512,
      [],
      'e170',
      
      'M512 48c26.5 0 48 21.5 48 48v17.8l-4.7 3.5L369.1 253.8c-19.7 14.5-46.5 14.5-66.2 0L116.7 117.3l-4.7-3.5V96c0-26.5 21.5-48 48-48H512zM112 320V133.7l181.4 133c25.3 18.6 59.8 18.6 85.2 0L560 133.7V320c0 26.5-21.5 48-48 48H160c-26.5 0-48-21.5-48-48zM160 32c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zM0 192V416c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64H464c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V192c0-26.5 21.5-48 48-48V128c-35.3 0-64 28.7-64 64z'
      
    ]
  };

  

  
  

  var faDownLong = {
    prefix: 'fat',
    iconName: 'down-long',
    icon: [
      320,
      512,
      ["long-arrow-alt-down"],
      'f309',
      
      'M216 336l81.1 0c3.8 0 6.9 3.1 6.9 6.9c0 1.8-.7 3.5-1.9 4.7L161.9 495.2c-.5 .5-1.2 .8-1.9 .8s-1.4-.3-1.9-.8L17.9 347.6c-1.2-1.3-1.9-3-1.9-4.7c0-3.8 3.1-6.9 6.9-6.9l81.1 0c8.8 0 16-7.2 16-16l0-280c0-13.3 10.7-24 24-24l32 0c13.3 0 24 10.7 24 24l0 280c0 8.8 7.2 16 16 16zM173.5 506.2L313.7 358.6c4-4.2 6.3-9.9 6.3-15.8c0-12.6-10.2-22.9-22.9-22.9L232 320l-16 0 0-16 0-264c0-22.1-17.9-40-40-40L144 0c-22.1 0-40 17.9-40 40l0 264 0 16-16 0-65.1 0C10.2 320 0 330.2 0 342.9c0 5.9 2.3 11.5 6.3 15.8L146.5 506.2c3.5 3.7 8.4 5.8 13.5 5.8s10-2.1 13.5-5.8z'
      
    ]
  };

  
    var faLongArrowAltDown = faDownLong;
  

  
  

  var faJugBottle = {
    prefix: 'fat',
    iconName: 'jug-bottle',
    icon: [
      640,
      512,
      [],
      'e5fb',
      
      'M120 16h80c4.4 0 8 3.6 8 8V80H112V24c0-4.4 3.6-8 8-8zM96 80H72c-4.4 0-8 3.6-8 8s3.6 8 8 8H96h16 96 16 24c4.4 0 8-3.6 8-8s-3.6-8-8-8H224V24c0-13.3-10.7-24-24-24H120C106.7 0 96 10.7 96 24V80zm160 64c61.9 0 112 50.1 112 112V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V256c0-61.9 50.1-112 112-112H256zM128 128C57.3 128 0 185.3 0 256V448c0 35.3 28.7 64 64 64H320c29.7 0 54.7-20.2 61.9-47.6l0 0c1.4-5.2 2.1-10.7 2.1-16.4V402.9l0 0V267.7l0 0V256c0-11.2-1.4-22-4.1-32.4l0 0C365.5 168.6 315.5 128 256 128H128zm152 80c-22.1 0-40 17.9-40 40v80c0 22.1 17.9 40 40 40s40-17.9 40-40V248c0-22.1-17.9-40-40-40zm-24 40c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V248zM404 494.6c13.2 10.9 30.1 17.4 48.4 17.4H564c42 0 76-34 76-76c0-19.5-7.4-37.3-19.5-50.8C632.6 372.3 640 355 640 336c0-18.8-7.2-35.9-19-48.8c11.8-13.2 19-30.6 19-49.7c0-28.9-16.7-55.2-42.9-67.5l-4.7-2.2c-11-5.1-23-7.8-35.1-7.8H468.8c-13.5 0-26.9 3-39.1 8.7l-9.6 4.5c-7.4 3.5-14.1 8.1-19.8 13.7c2.5 5.3 4.8 10.7 6.7 16.3c5.3-6.5 12-11.8 19.9-15.5l9.6-4.5c10.1-4.7 21.1-7.2 32.3-7.2h88.5c9.8 0 19.4 2.2 28.3 6.3l4.7 2.2c20.6 9.6 33.7 30.3 33.7 53c0 15-5.6 28.7-14.9 39.1c-5.5 6.1-5.4 15.5 .1 21.5c9.2 10 14.8 23.3 14.8 37.9c0 14.8-5.7 28.3-15.1 38.3c-5.7 6.1-5.8 15.5-.2 21.6c9.6 10.6 15.4 24.7 15.4 40.1c0 33.1-26.9 60-60 60H452.4c-16.1 0-30.8-6.3-41.6-16.8c-1.8 5.3-4.1 10.5-6.8 15.3zM464 96c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v32h16V96c0-17.7-14.3-32-32-32H480c-17.7 0-32 14.3-32 32v32h16V96z'
      
    ]
  };

  

  
  

  var faSdCards = {
    prefix: 'fat',
    iconName: 'sd-cards',
    icon: [
      448,
      512,
      [],
      'e240',
      
      'M432 368V64c0-26.5-21.5-48-48-48H234.5c-12.7 0-24.9 5.1-33.9 14.1l-90.5 90.5c-9 9-14.1 21.2-14.1 33.9V368c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48zM448 64V368c0 35.3-28.7 64-64 64H144c-35.3 0-64-28.7-64-64V154.5c0-17 6.7-33.3 18.7-45.3l90.5-90.5C201.3 6.7 217.5 0 234.5 0H384c35.3 0 64 28.7 64 64zM240 72c4.4 0 8 3.6 8 8v64c0 4.4-3.6 8-8 8s-8-3.6-8-8V80c0-4.4 3.6-8 8-8zm64 0c4.4 0 8 3.6 8 8v64c0 4.4-3.6 8-8 8s-8-3.6-8-8V80c0-4.4 3.6-8 8-8zm64 0c4.4 0 8 3.6 8 8v64c0 4.4-3.6 8-8 8s-8-3.6-8-8V80c0-4.4 3.6-8 8-8zM18.7 189.3L48 160v22.6L30.1 200.6c-9 9-14.1 21.2-14.1 33.9V448c0 26.5 21.5 48 48 48H304c20.9 0 38.7-13.4 45.3-32H366c-7.1 27.6-32.2 48-62 48H64c-35.3 0-64-28.7-64-64V234.5c0-17 6.7-33.3 18.7-45.3z'
      
    ]
  };

  

  
  

  var faTowerCell = {
    prefix: 'fat',
    iconName: 'tower-cell',
    icon: [
      576,
      512,
      [],
      'e585',
      
      'M46.1 16.5c-4.1-1.6-8.8 .5-10.3 4.6C23 54.2 16 90.2 16 128s7 73.9 19.7 106.9c1.6 4.1 6.2 6.2 10.3 4.6s6.2-6.2 4.6-10.3C38.6 197.9 32 163.8 32 128s6.6-69.9 18.7-101.1c1.6-4.1-.5-8.8-4.6-10.3zm483.9 0c-4.1 1.6-6.2 6.2-4.6 10.3C537.4 58.1 544 92.2 544 128s-6.6 69.9-18.7 101.1c-1.6 4.1 .5 8.8 4.6 10.3s8.8-.5 10.3-4.6C553 201.9 560 165.8 560 128s-7-73.9-19.7-106.9c-1.6-4.1-6.2-6.2-10.3-4.6zM288 80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm41.3 96.9C343.2 165.2 352 147.6 352 128c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 19.6 8.8 37.2 22.7 48.9L96.7 500.6c-1.9 4-.1 8.8 3.9 10.6s8.8 .1 10.6-3.9L161 400H415l49.8 107.4c1.9 4 6.6 5.8 10.6 3.9s5.8-6.6 3.9-10.6l-150-323.7zM407.6 384H168.4l37.1-80h165l37.1 80zM315.7 185.7L363.1 288H212.9l47.4-102.3c8.4 4 17.8 6.3 27.7 6.3s19.3-2.3 27.7-6.3zM140.6 67.2c1.8-4-.1-8.8-4.1-10.5s-8.8 .1-10.5 4.1c-9 20.6-14 43.3-14 67.2s5 46.6 14 67.2c1.8 4 6.5 5.9 10.5 4.1s5.9-6.5 4.1-10.5C132.5 170.2 128 149.6 128 128s4.5-42.2 12.6-60.8zM450 60.8c-1.8-4-6.5-5.9-10.5-4.1s-5.9 6.5-4.1 10.5C443.5 85.8 448 106.4 448 128s-4.5 42.2-12.6 60.8c-1.8 4 .1 8.8 4.1 10.5s8.8-.1 10.5-4.1c9-20.6 14-43.3 14-67.2s-5-46.6-14-67.2z'
      
    ]
  };

  

  
  

  var faSchoolLock = {
    prefix: 'fat',
    iconName: 'school-lock',
    icon: [
      640,
      512,
      [],
      'e56f',
      
      'M324.6 1.4c-2.8-1.9-6.4-1.9-9.2 0L157.5 112H56c-30.9 0-56 25.1-56 56V456c0 30.9 25.1 56 56 56H256h16 96 16 8.6c-2.9-5-5.1-10.3-6.5-16h-2V480 384c0-35.3-28.7-64-64-64s-64 28.7-64 64V496H56c-22.1 0-40-17.9-40-40V168c0-22.1 17.9-40 40-40H160c1.6 0 3.2-.5 4.6-1.4L320 17.8 475.4 126.6c1.3 .9 2.9 1.4 4.6 1.4H584c22.1 0 40 17.9 40 40v88 34c5.7 1.5 11 3.7 16 6.5V168c0-30.9-25.1-56-56-56H482.5L324.6 1.4zM368 496H272V384c0-26.5 21.5-48 48-48s48 21.5 48 48V496zM64 216v48c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V216c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm24-8h32c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H88c-4.4 0-8-3.6-8-8V216c0-4.4 3.6-8 8-8zm232-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 144a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm8-112c0-4.4-3.6-8-8-8s-8 3.6-8 8v32c0 4.4 3.6 8 8 8h24c4.4 0 8-3.6 8-8s-3.6-8-8-8H328V144zM64 344v48c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V344c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm24-8h32c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H88c-4.4 0-8-3.6-8-8V344c0-4.4 3.6-8 8-8zM528 208c26.5 0 48 21.5 48 48v64H480V256c0-26.5 21.5-48 48-48zm-64 48v64H448c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H592V256c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-16 80h16 16 96 16 16c8.8 0 16 7.2 16 16V480c0 8.8-7.2 16-16 16H448c-8.8 0-16-7.2-16-16V352c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faCircleEllipsis = {
    prefix: 'fat',
    iconName: 'circle-ellipsis',
    icon: [
      512,
      512,
      [],
      'e10a',
      
      'M256 496a240 240 0 1 0 0-480 240 240 0 1 0 0 480zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm16 256a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM176 256a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z'
      
    ]
  };

  

  
  

  var faWatermelonSlice = {
    prefix: 'fat',
    iconName: 'watermelon-slice',
    icon: [
      512,
      512,
      [],
      'e337',
      
      'M415.7 2.3c3.1-3.1 8.2-3.1 11.3 0c54.4 54.4 85 128.3 85 205.2v4.2C512 377.6 377.6 512 211.7 512h-4.2c-77 0-150.8-30.6-205.2-85c-3.1-3.1-3.1-8.2 0-11.3L415.7 2.3zm5.6 17.1L384.3 56.3C423.8 97.9 448 154.1 448 216c0 128.1-103.9 232-232 232c-61.9 0-118.1-24.2-159.7-63.7L19.4 421.3C70.2 469.2 137.5 496 207.6 496h4.2C368.7 496 496 368.7 496 211.7v-4.2c0-70.1-26.8-137.4-74.7-188.2zM67.7 373c38.7 36.6 90.9 59 148.4 59c119.3 0 216-96.7 216-216c0-57.4-22.4-109.7-59-148.4L67.7 373zm266-210.7l24 24c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-24-24c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0zm-80 80l24 24c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-24-24c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0zm88 8l24 24c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-24-24c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0zm-168 72l24 24c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-24-24c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0zm88 8l24 24c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-24-24c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0z'
      
    ]
  };

  

  
  

  var faHandHoldingMagic = {
    prefix: 'fat',
    iconName: 'hand-holding-magic',
    icon: [
      576,
      512,
      [],
      'f6e5',
      
      'M144 80c0-35.3 28.7-64 64-64H328c57.4 0 104 46.6 104 104s-46.6 104-104 104H270.2c-12.2 0-22.2 9.9-22.2 22.2V272c0 4.4 3.6 8 8 8s8-3.6 8-8V246.2c0-3.4 2.8-6.2 6.2-6.2H328c66.3 0 120-53.7 120-120S394.3 0 328 0H208c-44.2 0-80 35.8-80 80s35.8 80 80 80h88c4.4 0 8-3.6 8-8s-3.6-8-8-8H208c-35.3 0-64-28.7-64-64zM521.8 340.7c10.7-7.9 25.7-5.6 33.6 5.1s5.6 25.7-5.1 33.6L423.6 472.6C403 487.8 378.1 496 352.5 496H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L394.7 414.4c-1.4 1-3 1.6-4.7 1.6H268c-6.6 0-12-5.4-12-12s5.4-12 12-12h80c19.9 0 36-16.1 36-36s-16.1-36-36-36H193.7c-29.1 0-57.3 9.9-80 28L71 382.2c-1.4 1.1-3.2 1.8-5 1.8H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H66c5.4 0 10.7-1.9 15-5.3l42.7-34.2c19.9-15.9 44.5-24.5 70-24.5H348c11 0 20 9 20 20s-9 20-20 20H268c-15.5 0-28 12.5-28 28s12.5 28 28 28H389.9c5.1 0 10.1-1.6 14.2-4.7l117.6-86.6z'
      
    ]
  };

  

  
  

  var faListUl = {
    prefix: 'fat',
    iconName: 'list-ul',
    icon: [
      512,
      512,
      ["list-dots"],
      'f0ca',
      
      'M64 80a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 160a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM80 416a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM176 88c-4.4 0-8 3.6-8 8s3.6 8 8 8H496c4.4 0 8-3.6 8-8s-3.6-8-8-8H176zm0 160c-4.4 0-8 3.6-8 8s3.6 8 8 8H496c4.4 0 8-3.6 8-8s-3.6-8-8-8H176zm0 160c-4.4 0-8 3.6-8 8s3.6 8 8 8H496c4.4 0 8-3.6 8-8s-3.6-8-8-8H176z'
      
    ]
  };

  
    var faListDots = faListUl;
  

  
  

  var faCodeCompare = {
    prefix: 'fat',
    iconName: 'code-compare',
    icon: [
      512,
      512,
      [],
      'e13a',
      
      'M194.1 10.6c-3 3.3-2.7 8.3 .5 11.3L267.3 88H176C118.6 88 72 134.6 72 192V384.5c-31.6 3.9-56 30.9-56 63.5c0 35.3 28.7 64 64 64s64-28.7 64-64c0-32.6-24.4-59.6-56-63.5V192c0-48.6 39.4-88 88-88h91.3l-72.7 66.1c-3.3 3-3.5 8-.5 11.3s8 3.5 11.3 .5l88-80c1.7-1.5 2.6-3.7 2.6-5.9s-1-4.4-2.6-5.9l-88-80c-3.3-3-8.3-2.7-11.3 .5zM80 400a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM317.9 501.4c3-3.3 2.7-8.3-.5-11.3L244.7 424H336c57.4 0 104-46.6 104-104V127.5c31.6-3.9 56-30.9 56-63.5c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 32.6 24.4 59.6 56 63.5V320c0 48.6-39.4 88-88 88H244.7l72.7-66.1c3.3-3 3.5-8 .5-11.3s-8-3.5-11.3-.5l-88 80c-1.7 1.5-2.6 3.7-2.6 5.9s1 4.4 2.6 5.9l88 80c3.3 3 8.3 2.7 11.3-.5zM432 112a48 48 0 1 1 0-96 48 48 0 1 1 0 96z'
      
    ]
  };

  

  
  

  var faDropletDegree = {
    prefix: 'fat',
    iconName: 'droplet-degree',
    icon: [
      512,
      512,
      ["dewpoint"],
      'f748',
      
      'M192 496C94.8 496 16 417.2 16 320c0-19.5 7.1-44.9 19.6-73.8c12.4-28.6 29.3-59.2 47.7-88.8c36.6-59.2 77.9-112.9 95.9-135.7c2.8-3.5 7-5.6 11.9-5.6h1.8c4.9 0 9.1 2.1 11.9 5.6c18.1 22.8 59.3 76.6 95.9 135.7c18.3 29.6 35.3 60.2 47.7 88.8C360.9 275.1 368 300.5 368 320c0 97.2-78.8 176-176 176zM0 320C0 426 86 512 192 512s192-86 192-192c0-91.2-130.2-262.3-166.6-308.3C211.4 4.2 202.5 0 192.9 0h-1.8c-9.6 0-18.5 4.2-24.5 11.7C130.2 57.7 0 228.8 0 320zM400 96a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0A64 64 0 1 0 384 96a64 64 0 1 0 128 0z'
      
    ]
  };

  
    var faDewpoint = faDropletDegree;
  

  
  

  var faSkullCrossbones = {
    prefix: 'fat',
    iconName: 'skull-crossbones',
    icon: [
      448,
      512,
      [9760,128369],
      'f714',
      
      'M295.8 220.7C330.3 200.2 352 165.9 352 128c0-60.1-55.5-112-128-112S96 67.9 96 128c0 37.9 21.7 72.2 56.2 92.7c4.8 2.9 7.8 8.1 7.8 13.8V256c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V234.4c0-5.6 3-10.9 7.8-13.8zM304 256c0 17.7-14.3 32-32 32H176c-17.7 0-32-14.3-32-32V234.4c-38.6-23-64-62.1-64-106.4C80 57.3 144.5 0 224 0s144 57.3 144 128c0 44.4-25.4 83.5-64 106.4V256zM176 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-80 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM1 260.1c2.1-3.9 7-5.3 10.9-3.1L224 374.8 436.1 257c3.9-2.1 8.7-.8 10.9 3.1s.8 8.7-3.1 10.9L240.5 384 443.9 497c3.9 2.1 5.3 7 3.1 10.9s-7 5.3-10.9 3.1L224 393.2 11.9 511c-3.9 2.1-8.7 .8-10.9-3.1s-.8-8.7 3.1-10.9L207.5 384 4.1 271c-3.9-2.1-5.3-7-3.1-10.9z'
      
    ]
  };

  

  
  

  var faClub = {
    prefix: 'fat',
    iconName: 'club',
    icon: [
      512,
      512,
      [9827],
      'f327',
      
      'M372.5 164.7c-1.1 4.5-.2 9.3 2.5 13.1s7 6.2 11.6 6.6C447.9 189.9 496 241.3 496 304c0 66.3-53.7 120-120 120c-45.8 0-85.7-25.7-105.9-63.5c-2.8-5.2-8.2-8.5-14.1-8.5s-11.3 3.2-14.1 8.5C221.7 398.3 181.8 424 136 424C69.7 424 16 370.3 16 304c0-62.7 48.1-114.1 109.3-119.5c4.7-.4 8.9-2.8 11.6-6.6s3.6-8.6 2.5-13.1c-2.3-9.2-3.5-18.8-3.5-28.7c0-66.3 53.7-120 120-120s120 53.7 120 120c0 9.9-1.2 19.5-3.5 28.7zm31.4 6.2c-5.2-1.1-10.5-1.9-15.9-2.4c1.3-5.2 2.2-10.4 2.9-15.8c.7-5.5 1-11.1 1-16.7C392 60.9 331.1 0 256 0S120 60.9 120 136c0 5.7 .3 11.2 1 16.7c.7 5.4 1.6 10.6 2.9 15.8c-5.4 .5-10.7 1.3-15.9 2.4C46.3 183.8 0 238.5 0 304c0 75.1 60.9 136 136 136c45.5 0 85.7-22.3 110.4-56.6c.5-.8 1.1-1.5 1.6-2.3V496H168c-4.4 0-8 3.6-8 8s3.6 8 8 8H344c4.4 0 8-3.6 8-8s-3.6-8-8-8H264V381.2c.5 .8 1.1 1.5 1.6 2.3C290.3 417.7 330.5 440 376 440c75.1 0 136-60.9 136-136c0-65.5-46.3-120.2-108-133.1z'
      
    ]
  };

  

  
  

  var faHospitals = {
    prefix: 'fat',
    iconName: 'hospitals',
    icon: [
      576,
      512,
      [],
      'f80e',
      
      'M256 56c0-30.9 25.1-56 56-56H520c30.9 0 56 25.1 56 56V456c0 30.9-25.1 56-56 56H304c3.7-4.9 6.8-10.3 9.3-16H520c22.1 0 40-17.9 40-40V400H328c-4.4 0-8-3.6-8-8s3.6-8 8-8H560V304H328c-4.4 0-8-3.6-8-8s3.6-8 8-8H560V56c0-22.1-17.9-40-40-40H312c-22.1 0-40 17.9-40 40v8c0 2.2-.9 4.2-2.4 5.7c-4.3-1.7-8.8-3.1-13.5-4c-.1-.5-.2-1.1-.2-1.6V56zM64 112c-26.5 0-48 21.5-48 48V352H272V160c0-26.5-21.5-48-48-48H64zM16 368v48H272V368H16zm256 64H16v16c0 26.5 21.5 48 48 48H224c26.5 0 48-21.5 48-48V432zM0 160c0-35.3 28.7-64 64-64H224c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160zm112 32c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v16h16c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H176v16c0 13.3-10.7 24-24 24H136c-13.3 0-24-10.7-24-24V272H96c-13.3 0-24-10.7-24-24V232c0-13.3 10.7-24 24-24h16V192zm24-8c-4.4 0-8 3.6-8 8v24c0 4.4-3.6 8-8 8H96c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h24c4.4 0 8 3.6 8 8v24c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V264c0-4.4 3.6-8 8-8h24c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8H168c-4.4 0-8-3.6-8-8V192c0-4.4-3.6-8-8-8H136zM424 72h16c13.3 0 24 10.7 24 24v16h16c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H464v16c0 13.3-10.7 24-24 24H424c-13.3 0-24-10.7-24-24V176H384c-13.3 0-24-10.7-24-24V136c0-13.3 10.7-24 24-24h16V96c0-13.3 10.7-24 24-24zm-8 24v24c0 4.4-3.6 8-8 8H384c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h24c4.4 0 8 3.6 8 8v24c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V168c0-4.4 3.6-8 8-8h24c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8H456c-4.4 0-8-3.6-8-8V96c0-4.4-3.6-8-8-8H424c-4.4 0-8 3.6-8 8z'
      
    ]
  };

  

  
  

  var faBookArrowRight = {
    prefix: 'fat',
    iconName: 'book-arrow-right',
    icon: [
      640,
      512,
      [],
      'e0b9',
      
      'M56 0C25.1 0 0 25.1 0 56V456c0 30.9 25.1 56 56 56H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H416V415.2c18.3-3.7 32-19.8 32-39.2V256H432V376c0 13.3-10.7 24-24 24H56c-15.7 0-29.8 6.4-40 16.8V56c0-22.1 17.9-40 40-40H408c13.3 0 24 10.7 24 24V160h16V40c0-22.1-17.9-40-40-40H56zM400 416v80H56c-22.1 0-40-17.9-40-40s17.9-40 40-40H400zM533.7 98.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L612.7 200H264c-4.4 0-8 3.6-8 8s3.6 8 8 8H612.7l-90.3 90.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l104-104c3.1-3.1 3.1-8.2 0-11.3l-104-104z'
      
    ]
  };

  

  
  

  var faBellPlus = {
    prefix: 'fat',
    iconName: 'bell-plus',
    icon: [
      448,
      512,
      [],
      'f849',
      
      'M216 8c0-4.4 3.6-8 8-8s8 3.6 8 8V32l0 .2c84.6 4.2 152 74.1 152 159.8v36.6c0 41.8 14.2 82.3 40.3 114.9l16.7 20.9c4.5 5.6 6.9 12.6 6.9 19.8c0 17.5-14.2 31.7-31.7 31.7H31.7C14.2 416 0 401.8 0 384.3c0-7.2 2.4-14.2 6.9-19.8l16.7-20.9C49.8 311 64 270.4 64 228.6V192c0-85.7 67.4-155.6 152-159.8l0-.2V8zm8 40C144.5 48 80 112.5 80 192v36.6c0 45.4-15.5 89.5-43.8 124.9L19.4 374.5c-2.2 2.8-3.4 6.2-3.4 9.8C16 393 23 400 31.7 400H416.3c8.7 0 15.7-7 15.7-15.7c0-3.6-1.2-7-3.4-9.8l-16.7-20.9C383.5 318.1 368 274.1 368 228.6V192c0-79.5-64.5-144-144-144zM176 448c0 12.7 5.1 24.9 14.1 33.9s21.2 14.1 33.9 14.1s24.9-5.1 33.9-14.1s14.1-21.2 14.1-33.9c0-4.4 3.6-8 8-8s8 3.6 8 8c0 17-6.7 33.3-18.7 45.3s-28.3 18.7-45.3 18.7s-33.3-6.7-45.3-18.7s-18.7-28.3-18.7-45.3c0-4.4 3.6-8 8-8s8 3.6 8 8zm48-288c4.4 0 8 3.6 8 8v64h64c4.4 0 8 3.6 8 8s-3.6 8-8 8H232v64c0 4.4-3.6 8-8 8s-8-3.6-8-8V248H152c-4.4 0-8-3.6-8-8s3.6-8 8-8h64V168c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faBatteryFull = {
    prefix: 'fat',
    iconName: 'battery-full',
    icon: [
      576,
      512,
      [128267,"battery","battery-5"],
      'f240',
      
      'M448 112c35.3 0 64 28.7 64 64v16 16 96 16 16c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V176c0-35.3 28.7-64 64-64H448zm80 224V320h16c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H528V176c0-44.2-35.8-80-80-80H80C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H448c44.2 0 80-35.8 80-80zm0-32V208h16c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H528zM112 176H416c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V208c0-17.7 14.3-32 32-32zM64 208v96c0 26.5 21.5 48 48 48H416c26.5 0 48-21.5 48-48V208c0-26.5-21.5-48-48-48H112c-26.5 0-48 21.5-48 48z'
      
    ]
  };

  
    var faBattery = faBatteryFull;
  
    var faBattery5 = faBatteryFull;
  

  
  

  var faChevronDown = {
    prefix: 'fat',
    iconName: 'chevron-down',
    icon: [
      512,
      512,
      [],
      'f078',
      
      'M250.3 397.7c3.1 3.1 8.2 3.1 11.3 0l216-216c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L256 380.7 45.7 170.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l216 216z'
      
    ]
  };

  

  
  

  var faMoneyBillSimpleWave = {
    prefix: 'fat',
    iconName: 'money-bill-simple-wave',
    icon: [
      576,
      512,
      [],
      'e1f2',
      
      'M16 422.3c0 12.4 6.9 22.7 16.6 26.3c78.1 29.1 156.8 11.7 240.7-9.6c4-1 8-2 12-3.1c78.7-20.1 162.3-41.4 246.3-18.5c15.2 4.2 28.4-6.9 28.4-17.9V89.7c0-12.4-6.9-22.7-16.6-26.3C465.3 34.2 386.7 51.7 302.8 73c-4 1-8 2-12 3.1l0 0C212 96.2 128.4 117.5 44.4 94.6C29.2 90.4 16 101.5 16 112.5V422.3zm-16 0V112.5C0 88.6 25.6 72.8 48.7 79.1c79.8 21.8 159.6 1.5 239.3-18.9c87-22.2 174-44.4 261-11.9c16.9 6.3 27 23.2 27 41.3V399.5c0 23.9-25.6 39.7-48.7 33.4c-79.8-21.8-159.6-1.5-239.3 18.9c-87 22.2-174 44.4-261 11.9c-16.9-6.3-27-23.2-27-41.3zM216 256c0 50 33.5 88 72 88s72-38 72-88s-33.5-88-72-88s-72 38-72 88zm72-104c49.9 0 88 48 88 104s-38.1 104-88 104s-88-48-88-104s38.1-104 88-104z'
      
    ]
  };

  

  
  

  var faHandsHoldingDiamond = {
    prefix: 'fat',
    iconName: 'hands-holding-diamond',
    icon: [
      640,
      512,
      ["hand-receiving"],
      'f47c',
      
      'M308.7 20.7c6.2-6.2 16.4-6.2 22.6 0l96 96c6.2 6.2 6.2 16.4 0 22.6l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96-10.9 10.9 10.9-10.9c-6.2-6.2-6.2-16.4 0-22.6l96-96zM342.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96zM96 112c0-26.5-21.5-48-48-48S0 85.5 0 112V344.2c0 27.6 11 54 30.5 73.5l91.9 91.9c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L41.8 406.5C25.3 390 16 367.6 16 344.2V112c0-17.7 14.3-32 32-32s32 14.3 32 32V259c0 20.7 8.2 40.6 22.9 55.2l19.5 19.5 55.9 55.9 0 0 8 8c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-8-8 0 0-55.9-55.9 0 0c-10.6-10.6-11.3-27.6-1.5-39.1c10.9-12.7 30.3-13.5 42.2-1.6l92.8 92.7c13.3 13.3 20.8 31.4 20.8 50.3V504c0 4.4 3.6 8 8 8s8-3.6 8-8V424.8c0-23.1-9.2-45.3-25.5-61.6l-92.8-92.8c-18.4-18.4-48.7-17.3-65.6 2.5c-6.2 7.2-9.7 15.9-10.6 24.7C100.8 286.7 96 273.1 96 259V112zM592 64c-26.5 0-48 21.5-48 48V259c0 14.1-4.8 27.8-13.5 38.7c-.9-8.8-4.4-17.5-10.6-24.7c-17-19.8-47.2-21-65.6-2.5l-92.7 92.8c-16.3 16.3-25.5 38.5-25.5 61.6V504c0 4.4 3.6 8 8 8s8-3.6 8-8V424.8c0-18.9 7.5-37 20.8-50.3l92.8-92.7c11.8-11.9 31.3-11.1 42.2 1.6c9.8 11.4 9.1 28.4-1.5 39.1l0 0-55.9 55.9 0 0-8 8c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l8-8 55.9-55.9 19.5-19.5C551.8 299.5 560 279.7 560 259V112c0-17.7 14.3-32 32-32s32 14.3 32 32V344.2c0 23.3-9.3 45.7-25.8 62.2l-91.9 91.9c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l91.9-91.9c19.5-19.5 30.5-46 30.5-73.5V112c0-26.5-21.5-48-48-48z'
      
    ]
  };

  
    var faHandReceiving = faHandsHoldingDiamond;
  

  
  

  var faTransporter2 = {
    prefix: 'fat',
    iconName: 'transporter-2',
    icon: [
      512,
      512,
      [],
      'e044',
      
      'M48 0c-4.4 0-8 3.6-8 8V40H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H40V88c0 4.4 3.6 8 8 8s8-3.6 8-8V56H88c4.4 0 8-3.6 8-8s-3.6-8-8-8H56V8c0-4.4-3.6-8-8-8zM464 320c-4.4 0-8 3.6-8 8v32H424c-4.4 0-8 3.6-8 8s3.6 8 8 8h32v32c0 4.4 3.6 8 8 8s8-3.6 8-8V376h32c4.4 0 8-3.6 8-8s-3.6-8-8-8H472V328c0-4.4-3.6-8-8-8zM144 464H368c17.7 0 32 14.3 32 32v8c0 4.4 3.6 8 8 8s8-3.6 8-8v-8c0-26.5-21.5-48-48-48H144c-26.5 0-48 21.5-48 48v8c0 4.4 3.6 8 8 8s8-3.6 8-8v-8c0-17.7 14.3-32 32-32zM288 48c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-17.2 13.6-31.3 30.6-32c.3 0 .6 0 .9 0l.4 0c17.7 0 32 14.3 32 32zm16 0c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48h0c26.5 0 48-21.5 48-48zM173.2 174c15.2-18.9 38.1-30 62.4-30h40.7c24.3 0 47.2 11 62.4 30l40.1 50h20.5l-48.1-60c-18.2-22.7-45.8-36-74.9-36H235.6c-29.1 0-56.7 13.2-74.9 36l-48.1 60h20.5l40.1-50zm.9 50H200v-9.5c0-3.4-2.1-6.4-5.3-7.5s-6.8-.1-8.9 2.5L174.1 224zM312 224h25.9l-11.6-14.5c-2.1-2.7-5.7-3.7-8.9-2.5s-5.3 4.2-5.3 7.5V224zM168 384c-4.4 0-8 3.6-8 8s3.6 8 8 8H344c4.4 0 8-3.6 8-8s-3.6-8-8-8H168zm-8-56c0 4.4 3.6 8 8 8H344c4.4 0 8-3.6 8-8s-3.6-8-8-8H168c-4.4 0-8 3.6-8 8zm-56-72c-4.4 0-8 3.6-8 8s3.6 8 8 8H408c4.4 0 8-3.6 8-8s-3.6-8-8-8H104z'
      
    ]
  };

  

  
  

  var faPersonCircleExclamation = {
    prefix: 'fat',
    iconName: 'person-circle-exclamation',
    icon: [
      576,
      512,
      [],
      'e53f',
      
      'M160 96a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm0-96a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM141.1 144c-21.5 0-41.1 12.3-50.4 31.7L23.2 315.5c-1.9 4-6.7 5.6-10.7 3.7s-5.6-6.7-3.7-10.7L76.3 168.7c12-24.9 37.2-40.7 64.8-40.7h37.8c27.6 0 52.8 15.8 64.8 40.7l46.1 95.5c-3.7 5-7.1 10.2-10.2 15.6L229.3 175.7C220 156.3 200.4 144 178.9 144H141.1zM104 248V480c0 8.8 7.2 16 16 16s16-7.2 16-16V360c0-13.3 10.7-24 24-24s24 10.7 24 24V480c0 8.8 7.2 16 16 16s16-7.2 16-16V248c0-4.4 3.6-8 8-8s8 3.6 8 8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V360c0-4.4-3.6-8-8-8s-8 3.6-8 8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V248c0-4.4 3.6-8 8-8s8 3.6 8 8zM560 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0-136c4.4 0 8 3.6 8 8v96c0 4.4-3.6 8-8 8s-8-3.6-8-8V288c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faSuitcaseRolling = {
    prefix: 'fat',
    iconName: 'suitcase-rolling',
    icon: [
      384,
      512,
      [],
      'f5c1',
      
      'M112 40v88H272V40c0-13.3-10.7-24-24-24H136c-13.3 0-24 10.7-24 24zM96 128V40c0-22.1 17.9-40 40-40H248c22.1 0 40 17.9 40 40v88h32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64c0 17.7-14.3 32-32 32s-32-14.3-32-32H128c0 17.7-14.3 32-32 32s-32-14.3-32-32c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64H96zM80 480c0 8.8 7.2 16 16 16s16-7.2 16-16H80zm-8-16h48H264h48 8c26.5 0 48-21.5 48-48V192c0-26.5-21.5-48-48-48H280 104 64c-26.5 0-48 21.5-48 48V416c0 26.5 21.5 48 48 48h8zm200 16c0 8.8 7.2 16 16 16s16-7.2 16-16H272zM80 248c0-4.4 3.6-8 8-8H296c4.4 0 8 3.6 8 8s-3.6 8-8 8H88c-4.4 0-8-3.6-8-8zm0 112c0-4.4 3.6-8 8-8H296c4.4 0 8 3.6 8 8s-3.6 8-8 8H88c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faDisplaySlash = {
    prefix: 'fat',
    iconName: 'display-slash',
    icon: [
      640,
      512,
      ["desktop-slash"],
      'e2fa',
      
      'M544 16c26.5 0 48 21.5 48 48V352c0 11.1-3.8 21.3-10.1 29.4l12.6 9.9C603 380.5 608 366.8 608 352V64c0-35.3-28.7-64-64-64H96c-1.5 0-3 .1-4.4 .2H99L119.1 16H544zM32 110.3V352c0 35.3 28.7 64 64 64H254.6l-13.3 80H168c-4.4 0-8 3.6-8 8s3.6 8 8 8h80H392h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H398.8l-13.3-80h33.7l-20.3-16H376.2h-.3H264.1h-.3H96c-26.5 0-48-21.5-48-48V123L32 110.3zM112 352H338.1l-20.3-16H112l0-162.5L96 160.8V336c0 8.8 7.2 16 16 16zm432-16V80c0-8.8-7.2-16-16-16H179.9l20.3 16H528V336h-3.6l14.6 11.6c3-2.9 4.9-7 4.9-11.6zM257.4 496l13.3-80h98.4l13.3 80H257.4zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  
    var faDesktopSlash = faDisplaySlash;
  

  
  

  var faCircleMicrophoneLines = {
    prefix: 'fat',
    iconName: 'circle-microphone-lines',
    icon: [
      512,
      512,
      ["microphone-circle-alt"],
      'e117',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 96c35.3 0 64 28.7 64 64v96c0 35.3-28.7 64-64 64s-64-28.7-64-64V160c0-35.3 28.7-64 64-64zm-48 64v96c0 26.5 21.5 48 48 48s48-21.5 48-48V240H264c-4.4 0-8-3.6-8-8s3.6-8 8-8h40V176H264c-4.4 0-8-3.6-8-8s3.6-8 8-8h40c0-26.5-21.5-48-48-48s-48 21.5-48 48zm-72 64c4.4 0 8 3.6 8 8v24c0 61.9 50.1 112 112 112s112-50.1 112-112V232c0-4.4 3.6-8 8-8s8 3.6 8 8v24c0 68-53 123.6-120 127.8V408c0 4.4-3.6 8-8 8s-8-3.6-8-8V383.8C181 379.6 128 324 128 256V232c0-4.4 3.6-8 8-8z'
      
    ]
  };

  
    var faMicrophoneCircleAlt = faCircleMicrophoneLines;
  

  
  

  var faSquarePen = {
    prefix: 'fat',
    iconName: 'square-pen',
    icon: [
      448,
      512,
      ["pen-square","pencil-square"],
      'f14b',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM100.7 379.2c-4-4-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9L275.4 133.5c15.6-15.6 40.9-15.6 56.6 0l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6L190.9 359.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2zM335 193.1c9.4-9.4 9.4-24.6 0-33.9l-14.4-14.4c-9.4-9.4-24.6-9.4-33.9 0l-25.3 25.3 48.3 48.3L335 193.1zM179.6 348.6L298.4 229.7l-48.3-48.3L131.2 300.3c-2.1 2.1-3.5 4.6-4.2 7.4l-10.6 42.5L112 367.9l17.6-4.4 42.5-10.6c2.8-.7 5.4-2.2 7.4-4.2z'
      
    ]
  };

  
    var faPenSquare = faSquarePen;
  
    var faPencilSquare = faSquarePen;
  

  
  

  var faTablePicnic = {
    prefix: 'fat',
    iconName: 'table-picnic',
    icon: [
      512,
      512,
      [],
      'e32d',
      
      'M64 72c0-4.4 3.6-8 8-8H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H328.7L403 256H504c4.4 0 8 3.6 8 8s-3.6 8-8 8l-94.2 0H392.4l-272.8 0 0 0H102.2l0 0H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H109L183.3 80H72c-4.4 0-8-3.6-8-8zm136 8c0 1-.2 2.1-.6 3.1L126.4 256H385.6l-73-172.9c-.4-1-.6-2.1-.6-3.1H200zM88.7 304h17.4L47.4 443.1c-1.7 4.1-6.4 6-10.5 4.3s-6-6.4-4.3-10.5L88.7 304zm334.5 0l56.1 132.9c1.7 4.1-.2 8.8-4.3 10.5s-8.8-.2-10.5-4.3L405.9 304h17.4z'
      
    ]
  };

  

  
  

  var faReceipt = {
    prefix: 'fat',
    iconName: 'receipt',
    icon: [
      384,
      512,
      [129534],
      'f543',
      
      'M13.3 2C10.9-.1 7.6-.6 4.7 .7S0 4.9 0 8V504c0 3.1 1.8 6 4.7 7.3s6.2 .8 8.6-1.3L71.6 459l50.7 50.7c3 3 7.8 3.1 10.9 .4L192 458.6 250.7 510c3.2 2.8 7.9 2.6 10.9-.4L312.4 459 370.7 510c2.4 2.1 5.7 2.6 8.6 1.3s4.7-4.1 4.7-7.3V8c0-3.1-1.8-6-4.7-7.3s-6.2-.8-8.6 1.3L312.4 53.1 261.7 2.3c-3-3-7.8-3.1-10.9-.4L192.4 53.1 141.7 2.3c-3-3-7.8-3.1-10.9-.4L72 53.4 13.3 2zM16 486.4V25.6L66.7 70c3 2.6 7.5 2.6 10.5 0l58.4-51.1 50.7 50.7c3 3 7.8 3.1 10.9 .4l58.4-51.1 50.7 50.7c3 3 7.8 3.1 10.9 .4L368 25.6V486.4L317.3 442c-3.2-2.8-7.9-2.6-10.9 .4L255.6 493 197.3 442c-3-2.6-7.5-2.6-10.5 0L128.4 493 77.7 442.3c-3-3-7.8-3.1-10.9-.4L16 486.4zM96 152c-4.4 0-8 3.6-8 8s3.6 8 8 8H288c4.4 0 8-3.6 8-8s-3.6-8-8-8H96zM88 352c0 4.4 3.6 8 8 8H288c4.4 0 8-3.6 8-8s-3.6-8-8-8H96c-4.4 0-8 3.6-8 8zm8-104c-4.4 0-8 3.6-8 8s3.6 8 8 8H288c4.4 0 8-3.6 8-8s-3.6-8-8-8H96z'
      
    ]
  };

  

  
  

  var faFilePen = {
    prefix: 'fat',
    iconName: 'file-pen',
    icon: [
      576,
      512,
      [128221,"file-edit"],
      'f31c',
      
      'M64 496H255.7c0 5.5 1 10.9 2.8 16H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H204.1c12.7 0 24.9 5.1 33.9 14.1L369.9 145.9c9 9 14.1 21.2 14.1 33.9V299.3l-16 16V179.9c0-1.3-.1-2.6-.2-3.9H248c-22.1 0-40-17.9-40-40V16.2c-1.3-.2-2.6-.2-3.9-.2H64C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48zM361.1 160c-.8-1-1.6-1.9-2.4-2.7L226.7 25.4c-.9-.9-1.8-1.7-2.7-2.4V136c0 13.3 10.7 24 24 24H361.1zM292.7 507.2c-4-4-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9L493.2 235.7c15.6-15.6 40.9-15.6 56.6 0l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6L382.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-3.4-13.6 3.4 13.6-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2zm15.7-28.9L304 495.8l17.6-4.4 42.5-10.6c2.8-.7 5.4-2.2 7.4-4.2L514.4 333.7l-48.3-48.3L323.2 428.3c-2 2.1-3.5 4.6-4.2 7.4l-10.6 42.5zM552.8 295.4c9.4-9.4 9.4-24.6 0-33.9L538.4 247c-9.4-9.4-24.6-9.4-33.9 0l-27.1 27.1 48.3 48.3 27.1-27.1z'
      
    ]
  };

  
    var faFileEdit = faFilePen;
  

  
  

  var faWalkieTalkie = {
    prefix: 'fat',
    iconName: 'walkie-talkie',
    icon: [
      384,
      512,
      [],
      'f8ef',
      
      'M96 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V96H48C21.5 96 0 117.5 0 144V298.7c0 10.6 4.2 20.8 11.7 28.3L25 340.3c4.5 4.5 7 10.6 7 17V464c0 26.5 21.5 48 48 48H304c26.5 0 48-21.5 48-48V357.3c0-6.4 2.5-12.5 7-17L372.3 327c7.5-7.5 11.7-17.7 11.7-28.3V144c0-26.5-21.5-48-48-48H320V88c0-17.7-14.3-32-32-32s-32 14.3-32 32v8H224V88c0-17.7-14.3-32-32-32s-32 14.3-32 32v8H96V8zM272 96V88c0-8.8 7.2-16 16-16s16 7.2 16 16v8H272zm-64-8v8H176V88c0-8.8 7.2-16 16-16s16 7.2 16 16zM88 112H336c17.7 0 32 14.3 32 32V298.7c0 6.4-2.5 12.5-7 17L347.7 329c-7.5 7.5-11.7 17.7-11.7 28.3V464c0 17.7-14.3 32-32 32H80c-17.7 0-32-14.3-32-32V357.3c0-10.6-4.2-20.8-11.7-28.3L23 315.7c-4.5-4.5-7-10.6-7-17V144c0-17.7 14.3-32 32-32H88zm8 72c0 4.4 3.6 8 8 8H280c4.4 0 8-3.6 8-8s-3.6-8-8-8H104c-4.4 0-8 3.6-8 8zm0 64c0 4.4 3.6 8 8 8H280c4.4 0 8-3.6 8-8s-3.6-8-8-8H104c-4.4 0-8 3.6-8 8zm0 64c0 4.4 3.6 8 8 8H280c4.4 0 8-3.6 8-8s-3.6-8-8-8H104c-4.4 0-8 3.6-8 8z'
      
    ]
  };

  

  
  

  var faWand = {
    prefix: 'fat',
    iconName: 'wand',
    icon: [
      512,
      512,
      [],
      'f72a',
      
      'M469.8 6.2c4.6-4 10.6-6.2 16.7-6.2C500.6 0 512 11.4 512 25.5v.4c0 5.7-1.9 11.3-5.4 15.8l-74.6 97V168c0 13.3-10.7 24-24 24H379.6L105 497c-8.6 9.5-20.8 15-33.6 15c-12 0-23.5-4.8-32-13.2L13.3 472.6C4.8 464.1 0 452.6 0 440.5c0-12.8 5.4-25 14.9-33.6L112 318.7V280c0-13.3 10.7-24 24-24h45L469.8 6.2zM486.5 16c-2.3 0-4.5 .8-6.2 2.3L189.2 270.1c-1.5 1.3-3.3 1.9-5.2 1.9H136c-4.4 0-8 3.6-8 8v42.3c0 2.3-1 4.4-2.6 5.9L25.6 418.8c-6.1 5.6-9.6 13.4-9.6 21.7c0 7.8 3.1 15.2 8.6 20.7l26.2 26.2c5.5 5.5 12.9 8.6 20.7 8.6c8.3 0 16.2-3.5 21.7-9.7L370.1 178.6c1.5-1.7 3.7-2.6 5.9-2.6h32c4.4 0 8-3.6 8-8V136c0-1.8 .6-3.5 1.7-4.9L493.9 32c1.3-1.7 2.1-3.9 2.1-6v-.4c0-5.2-4.2-9.5-9.5-9.5z'
      
    ]
  };

  

  
  

  var faCartArrowDown = {
    prefix: 'fat',
    iconName: 'cart-arrow-down',
    icon: [
      576,
      512,
      [],
      'f218',
      
      'M0 8C0 3.6 3.6 0 8 0H45.7C64.8 0 81.2 13.5 84.9 32.3L131.8 272H473.9c18.6 0 34.7-12.8 39-30.9L560.2 38.2c1-4.3 5.3-7 9.6-6s7 5.3 6 9.6L528.4 244.7c-5.9 25.3-28.5 43.3-54.5 43.3h-339l9.3 47.7c3.7 18.8 20.1 32.3 39.3 32.3H504c4.4 0 8 3.6 8 8s-3.6 8-8 8H183.5c-26.8 0-49.8-19-55-45.2L69.2 35.4C67 24.1 57.1 16 45.7 16H8c-4.4 0-8-3.6-8-8zM176 496a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm320 48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM328 8l0 172.7 66.3-66.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-80 80c-3.1 3.1-8.2 3.1-11.3 0l-80-80c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L312 180.7 312 8c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faColon = {
    prefix: 'fat',
    iconName: 'colon',
    icon: [
      192,
      512,
      [],
      '3a',
      
      'M144 128a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM32 128a64 64 0 1 1 128 0A64 64 0 1 1 32 128zM144 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM32 384a64 64 0 1 1 128 0A64 64 0 1 1 32 384z'
      
    ]
  };

  

  
  

  var faCartFlatbedEmpty = {
    prefix: 'fat',
    iconName: 'cart-flatbed-empty',
    icon: [
      640,
      512,
      ["dolly-flatbed-empty"],
      'f476',
      
      'M0 8C0 3.6 3.6 0 8 0H88c22.1 0 40 17.9 40 40V392c0 13.3 10.7 24 24 24h72H512 632c4.4 0 8 3.6 8 8s-3.6 8-8 8H547.8c7.6 8.5 12.2 19.7 12.2 32c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-12.3 4.6-23.5 12.2-32H259.8c7.6 8.5 12.2 19.7 12.2 32c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-12.3 4.6-23.5 12.2-32H152c-22.1 0-40-17.9-40-40V40c0-13.3-10.7-24-24-24H8c-4.4 0-8-3.6-8-8zM512 432a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM192 464a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z'
      
    ]
  };

  
    var faDollyFlatbedEmpty = faCartFlatbedEmpty;
  

  
  

  var faLobster = {
    prefix: 'fat',
    iconName: 'lobster',
    icon: [
      512,
      512,
      [129438],
      'e421',
      
      'M72 16C41.1 16 16 41.1 16 72v56c0 26.5 21.5 48 48 48s48-21.5 48-48V80c0-4.4 3.6-8 8-8s8 3.6 8 8v48c0 18.6-7.9 35.4-20.6 47.1l23.9 20c10.1 8.4 22.8 13 35.9 13H184c0-26.4 10.4-50.2 23.4-68.9c2.8-4 5.7-7.8 8.6-11.3V64c0-17.7-14.3-32-32-32h-8c-4.4 0-8-3.6-8-8s3.6-8 8-8h8c26.5 0 48 21.5 48 48v47.3c5.8-5.1 11.4-9.3 16.4-12.3c4.7-2.8 10.5-2.8 15.1 0c5 3 10.6 7.1 16.4 12.3V64c0-26.5 21.5-48 48-48h8c4.4 0 8 3.6 8 8s-3.6 8-8 8h-8c-17.7 0-32 14.3-32 32v63.8c3 3.6 5.9 7.3 8.6 11.3c13 18.7 23.4 42.5 23.4 68.9h16.8c13.1 0 25.8-4.6 35.8-13l23.9-20C391.9 163.4 384 146.6 384 128V80c0-4.4 3.6-8 8-8s8 3.6 8 8v48c0 26.5 21.5 48 48 48s48-21.5 48-48V72c0-30.9-25.1-56-56-56h-5.9l21.7 94.2c1 4.3-1.7 8.6-6 9.6s-8.6-1.7-9.6-6l-24-104c-.5-2.4 0-4.9 1.5-6.8s3.8-3 6.3-3h16c39.8 0 72 32.2 72 72v56c0 35.3-28.7 64-64 64c-10.8 0-20.9-2.7-29.9-7.4l-27.2 22.7C378 218.1 361.7 224 344.8 224H328v32h40.9c8.7 0 17.3-2 25-5.9l34.5-17.2c4-2 8.8-.4 10.7 3.6s.4 8.8-3.6 10.7l-34.5 17.2c-10 5-21 7.6-32.2 7.6H328v32h59.7c7.1 0 14.2-1.4 20.8-4L437 288.6c4.1-1.6 8.8 .4 10.4 4.5s-.4 8.8-4.5 10.4l-28.6 11.4c-8.5 3.4-17.6 5.1-26.7 5.1H328v32h4.6c14.2 0 28.1 4.2 39.9 12.1l7.9 5.3c3.7 2.5 4.7 7.4 2.2 11.1s-7.4 4.7-11.1 2.2l-7.9-5.3c-9.2-6.1-20-9.4-31.1-9.4h-6.5l-19.3 72.5c25.6 3.7 45.2 25.7 45.2 52.3c0 10.6-8.6 19.2-19.2 19.2H179.2c-10.6 0-19.2-8.6-19.2-19.2c0-26.6 19.6-48.6 45.2-52.3L185.9 368h-6.5c-11.1 0-21.9 3.3-31.1 9.4l-7.9 5.3c-3.7 2.5-8.6 1.5-11.1-2.2s-1.5-8.6 2.2-11.1l7.9-5.3c11.8-7.9 25.7-12.1 39.9-12.1H184V320H124.3c-9.2 0-18.2-1.7-26.7-5.1L69 303.4c-4.1-1.6-6.1-6.3-4.5-10.4s6.3-6.1 10.4-4.5L103.5 300c6.6 2.6 13.7 4 20.8 4H184V272H143.1c-11.2 0-22.2-2.6-32.2-7.6L76.4 247.2c-4-2-5.6-6.8-3.6-10.7s6.8-5.6 10.7-3.6l34.5 17.2c7.8 3.9 16.4 5.9 25 5.9H184V224H167.2c-16.8 0-33.2-5.9-46.1-16.7L93.9 184.6C84.9 189.3 74.8 192 64 192c-35.3 0-64-28.7-64-64V72C0 32.2 32.2 0 72 0H88c2.4 0 4.7 1.1 6.3 3s2.1 4.4 1.5 6.8l-24 104c-1 4.3-5.3 7-9.6 6s-7-5.3-6-9.6L77.9 16H72zM200 216v48 33.8l26.9 6.7c19.1 4.8 39.1 4.8 58.2 0l26.9-6.7V264 216v-8c0-22.2-8.8-42.8-20.5-59.8c-11.5-16.6-25.5-29-35.5-35.1c-10 6.1-23.9 18.5-35.5 35.1C208.8 165.2 200 185.8 200 208v8zm0 129.8l26.9 6.7c19.1 4.8 39.1 4.8 58.2 0l26.9-6.7V314.2L289 320c-21.7 5.4-44.3 5.4-66 0l-23-5.8v31.5zm.9 16.7l8.5 31.9 13.6 3.9c21.5 6.2 44.4 6.2 65.9 0l13.6-3.9 8.5-31.9L289 368c-21.7 5.4-44.3 5.4-66 0l-22.1-5.5zm22.3 83.5c.6 2.4 .1 5-1.4 6.9s-3.9 3.1-6.3 3.1h-2.7c-20.3 0-36.8 16.5-36.8 36.8c0 1.8 1.4 3.2 3.2 3.2H332.8c1.8 0 3.2-1.4 3.2-3.2c0-20.3-16.5-36.8-36.8-36.8h-2.7c-2.5 0-4.8-1.2-6.3-3.1s-2-4.5-1.4-6.9l8.9-33.5-4.4 1.3c-24.4 7-50.3 7-74.7 0l-4.4-1.3 8.9 33.5z'
      
    ]
  };

  

  
  

  var faBracketCurly = {
    prefix: 'fat',
    iconName: 'bracket-curly',
    icon: [
      256,
      512,
      ["bracket-curly-left"],
      '7b',
      
      'M64 88c0-30.9 25.1-56 56-56h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H120C97.9 48 80 65.9 80 88v77.5c0 19.1-7.6 37.4-21.1 50.9L19.3 256l39.6 39.6C72.4 309.1 80 327.4 80 346.5V424c0 22.1 17.9 40 40 40h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H120c-30.9 0-56-25.1-56-56V346.5c0-14.9-5.9-29.1-16.4-39.6L2.3 261.7c-3.1-3.1-3.1-8.2 0-11.3l45.3-45.3C58.1 194.6 64 180.3 64 165.5V88z'
      
    ]
  };

  
    var faBracketCurlyLeft = faBracketCurly;
  

  
  

  var faTaxiBus = {
    prefix: 'fat',
    iconName: 'taxi-bus',
    icon: [
      640,
      512,
      [],
      'e298',
      
      'M32.8 58.5C57.3 38.7 106.8 16 192 16s134.7 22.7 159.2 42.5c10.7 8.7 15.4 22.5 16.5 38.3c2.7-.6 5.4-.9 8.3-.9h7.7c-1.3-18.1-6.8-37.2-22.4-49.9C333.3 23.4 280 0 192 0S50.7 23.4 22.7 46.1C4.4 61 0 84.5 0 105.1V361.5c0 22.3 13.1 41.6 32 50.6V416v32c0 17.7 14.3 32 32 32H80c17.7 0 32-14.3 32-32V417.5H224v-16H112V400H96 48 45.3C28.4 395.3 16 379.8 16 361.5V248H192h86.1l4.6-16H200V120H339.3c2.8-6.4 7.2-11.9 12.7-16H192 16c.2-18.7 4.5-35.5 16.8-45.5zM16 120H184V232H16V120zM48 416.9c2.6 .4 5.3 .6 8 .6H96V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V416.9zM96 336a16 16 0 1 1 0-32 16 16 0 1 1 0 32zM64 320a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM408 144c-13.3 0-24 10.7-24 24v8H512v-8c0-13.3-10.7-24-24-24H408zm-39.9 33.3c0-.4-.1-.9-.1-1.3v-8c0-22.1 17.9-40 40-40h80c22.1 0 40 17.9 40 40v8c0 .4 0 .9-.1 1.3c19.7 4.4 36 19.2 41.7 39.3l22.1 77.2-1 .3c29 12 49.3 40.6 49.3 73.9v64 16 32c0 17.7-14.3 32-32 32H592c-17.7 0-32-14.3-32-32V448H336v32c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V448 432 368c0-33.3 20.4-61.9 49.3-73.9l-1-.3 22.1-77.2c5.7-20 22-34.9 41.7-39.3zM560 432h16 48V368c0-35.3-28.7-64-64-64H336c-35.3 0-64 28.7-64 64v64h48 16H560zm16 16v32c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V448H576zm-304 0v32c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V448H272zM512 192H384h-3.8c-17.9 0-33.6 11.8-38.5 29l-19.5 68.2c4.5-.8 9-1.2 13.7-1.2H560c4.7 0 9.3 .4 13.7 1.2L554.3 221c-4.9-17.2-20.6-29-38.5-29H512zM320 368a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm224-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z'
      
    ]
  };

  

  
  

  var faPeach = {
    prefix: 'fat',
    iconName: 'peach',
    icon: [
      512,
      512,
      [],
      'e20b',
      
      'M120 0h40c43.2 0 80.3 26.4 96 63.9C271.7 26.4 308.8 0 352 0h40c17.7 0 32 14.3 32 32v8c0 18.7-4.9 36.2-13.5 51.3c-5.2-1.8-10.4-3.4-15.8-4.8C403.1 73 408 57.1 408 40V32c0-8.8-7.2-16-16-16H352c-45.1 0-82.2 33.9-87.4 77.5c-5.7 .6-11.5 .6-17.2 0C242.2 49.9 205.1 16 160 16H120c-8.8 0-16 7.2-16 16v8c0 17.1 4.9 33 13.3 46.5c-5.3 1.4-10.6 3-15.7 4.8C92.9 76.2 88 58.7 88 40V32c0-17.7 14.3-32 32-32zm48 128C84.1 128 16 196.1 16 280c0 59.9 44 109.4 98 147.2c53.3 37.3 111.8 60 132 67.2c3.1 1.1 6.3 1.6 10 1.6s7-.5 10-1.6c20.1-7.2 78.7-29.9 132-67.2c54-37.8 98-87.3 98-147.2c0-83.9-68.1-152-152-152c-16.6 0-32.5 2.6-47.3 7.5c-10.2 3.3-20.8 5.4-31.5 6.1c7.2 4.4 14.1 9.2 20.6 14.3C319.1 182.1 344 218.1 344 256c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-30.9-20.7-62.8-52.1-87.5C244.6 144 204.3 128 168 128zM0 280c0-92.8 75.2-168 168-168c18.3 0 35.9 2.9 52.3 8.3c23 7.5 48.4 7.5 71.4 0c16.5-5.4 34-8.3 52.3-8.3c92.8 0 168 75.2 168 168c0 136.2-199.3 214.6-240.6 229.4c-5 1.8-10.1 2.6-15.4 2.6s-10.4-.8-15.4-2.6C199.3 494.6 0 416.2 0 280z'
      
    ]
  };

  

  
  

  var faNairaSign = {
    prefix: 'fat',
    iconName: 'naira-sign',
    icon: [
      448,
      512,
      [],
      'e1f6',
      
      'M78.5 35.4c-2-2.9-5.6-4.1-9-3S64 36.5 64 40V256H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H64V472c0 4.4 3.6 8 8 8s8-3.6 8-8V272H225.5l144 204.6c2 2.9 5.6 4.1 9 3s5.6-4.1 5.6-7.6V272h56c4.4 0 8-3.6 8-8s-3.6-8-8-8H384V40c0-4.4-3.6-8-8-8s-8 3.6-8 8V256H233.8L78.5 35.4zM245 272H368V446.7L245 272zm-30.8-16H80V65.3L214.2 256z'
      
    ]
  };

  

  
  

  var faFloppyDiskCircleXmark = {
    prefix: 'fat',
    iconName: 'floppy-disk-circle-xmark',
    icon: [
      576,
      512,
      ["floppy-disk-times","save-circle-xmark","save-times"],
      'e181',
      
      'M16 96V416c0 26.5 21.5 48 48 48H284.5c3.6 5.6 7.6 10.9 11.8 16H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H309.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3v22.2c-5.3-.5-10.6-.7-16-.7V170.5c0-12.7-5.1-24.9-14.1-33.9L343.4 62.1C337 55.6 328.8 51.1 320 49.2V160c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32L64 48C37.5 48 16 69.5 16 96zM224 240c25 0 47.6 10.5 63.7 27.3c-3.2 4.5-6.1 9.2-8.9 14C265.6 265.8 245.9 256 224 256c-39.8 0-72 32.2-72 72s32.2 72 72 72c12.1 0 23.6-3 33.6-8.3c.7 5.5 1.7 11 3 16.4c-11.1 5.1-23.5 7.9-36.6 7.9c-48.6 0-88-39.4-88-88s39.4-88 88-88zM80 48V160c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16V48H80zM560 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm205.7-50.3L443.3 368l50.3 50.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L432 379.3l-50.3 50.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L420.7 368l-50.3-50.3c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L432 356.7l50.3-50.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3z'
      
    ]
  };

  
    var faFloppyDiskTimes = faFloppyDiskCircleXmark;
  
    var faSaveCircleXmark = faFloppyDiskCircleXmark;
  
    var faSaveTimes = faFloppyDiskCircleXmark;
  

  
  

  var faLocationQuestion = {
    prefix: 'fat',
    iconName: 'location-question',
    icon: [
      384,
      512,
      ["map-marker-question"],
      'f60b',
      
      'M368 192c0-97.2-78.8-176-176-176S16 94.8 16 192c0 18.7 6.4 42.5 17.8 69.6c11.3 26.9 27.1 55.8 44.7 84.3c35.2 57 76.8 111.4 102.3 143.2c5.9 7.3 16.6 7.3 22.4 0c25.5-31.8 67.1-86.2 102.3-143.2c17.6-28.5 33.4-57.4 44.7-84.3C361.6 234.5 368 210.7 368 192zm16 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM104 152c0-30.9 25.1-56 56-56h56.2c35.2 0 63.8 28.6 63.8 63.8c0 21.4-10.8 41.5-28.7 53.3L200 246.9V272c0 4.4-3.6 8-8 8s-8-3.6-8-8V242.5c0-2.7 1.4-5.2 3.6-6.7l54.9-36.2c13.4-8.8 21.5-23.8 21.5-39.9c0-26.4-21.4-47.8-47.8-47.8H160c-22.1 0-40 17.9-40 40l0 6.5c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-6.5zm72 168a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  
    var faMapMarkerQuestion = faLocationQuestion;
  

  
  

  var faSignalGood = {
    prefix: 'fat',
    iconName: 'signal-good',
    icon: [
      640,
      512,
      ["signal-3"],
      'f68e',
      
      'M328 200c0-4.4-3.6-8-8-8s-8 3.6-8 8V504c0 4.4 3.6 8 8 8s8-3.6 8-8V200zM192 288c-4.4 0-8 3.6-8 8V504c0 4.4 3.6 8 8 8s8-3.6 8-8V296c0-4.4-3.6-8-8-8zM64 384c-4.4 0-8 3.6-8 8V504c0 4.4 3.6 8 8 8s8-3.6 8-8V392c0-4.4-3.6-8-8-8z'
      
    ]
  };

  
    var faSignal3 = faSignalGood;
  

  
  

  var faTrashCanArrowUp = {
    prefix: 'fat',
    iconName: 'trash-can-arrow-up',
    icon: [
      448,
      512,
      ["trash-restore-alt"],
      'f82a',
      
      'M157.4 27.3L134.4 64H313.6l-23-36.7c-4.4-7-12.1-11.3-20.4-11.3H177.7c-8.3 0-16 4.3-20.4 11.3zM115.6 64l28.2-45.2C151.1 7.1 163.9 0 177.7 0h92.5c13.8 0 26.6 7.1 33.9 18.8L332.4 64H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H115.6zM40 112c4.4 0 8 3.6 8 8V440c0 30.9 25.1 56 56 56H344c30.9 0 56-25.1 56-56V120c0-4.4 3.6-8 8-8s8 3.6 8 8V440c0 39.8-32.2 72-72 72H104c-39.8 0-72-32.2-72-72V120c0-4.4 3.6-8 8-8zm184 64c2.1 0 4.2 .8 5.7 2.3l80 80c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L232 203.3V392c0 4.4-3.6 8-8 8s-8-3.6-8-8V203.3l-66.3 66.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l80-80c1.5-1.5 3.5-2.3 5.7-2.3z'
      
    ]
  };

  
    var faTrashRestoreAlt = faTrashCanArrowUp;
  

  
  

  var faChevronsDown = {
    prefix: 'fat',
    iconName: 'chevrons-down',
    icon: [
      512,
      512,
      ["chevron-double-down"],
      'f322',
      
      'M34.3 53.7l216 216c3.1 3.1 8.2 3.1 11.3 0l216-216c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L256 252.7 45.7 42.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3zm0 192l216 216c3.1 3.1 8.2 3.1 11.3 0l216-216c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L256 444.7 45.7 234.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3z'
      
    ]
  };

  
    var faChevronDoubleDown = faChevronsDown;
  

  
  

  var faPersonDotsFromLine = {
    prefix: 'fat',
    iconName: 'person-dots-from-line',
    icon: [
      576,
      512,
      ["diagnoses"],
      'f470',
      
      'M360 88A72 72 0 1 0 216 88a72 72 0 1 0 144 0zM200 88a88 88 0 1 1 176 0A88 88 0 1 1 200 88zm-8 212.5v22.2V464H176V339.6 322.7c-5.5 1.8-10.8 3.8-16 5.7c-39.2 15-68.1 33.4-81.3 44.4c-20.4 17-50.6 14.2-67.6-6.1s-14.2-50.6 6.1-67.6C56.1 266.8 159.4 208 288 208s231.9 58.8 270.7 91.1c20.4 17 23.1 47.2 6.1 67.6s-47.2 23.1-67.6 6.1c-13.2-11-42.1-29.4-81.3-44.4c-5.2-2-10.5-3.9-16-5.7v16.9V464H384V322.7 300.5l21.1 7c49 16.3 85.8 39.2 102.5 53c13.6 11.3 33.8 9.5 45.1-4.1s9.5-33.8-4.1-45.1C512 281 412.1 224 288 224s-224 57-260.5 87.4c-13.6 11.3-15.4 31.5-4.1 45.1s31.5 15.4 45.1 4.1c16.6-13.9 53.5-36.7 102.5-53l21.1-7zM0 504c0-4.4 3.6-8 8-8H568c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8zM80 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM304 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM464 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  
    var faDiagnoses = faPersonDotsFromLine;
  

  
  

  var faTableTennisPaddleBall = {
    prefix: 'fat',
    iconName: 'table-tennis-paddle-ball',
    icon: [
      512,
      512,
      [127955,"ping-pong-paddle-ball","table-tennis"],
      'f45d',
      
      'M435.1 76.9c61.6 61.6 76.5 152.4 44.6 228c4.7 2.7 9.2 5.7 13.6 9c35.9-82 20.3-181.2-46.8-248.3c-87.5-87.5-229.3-87.5-316.8 0L69.5 125.7c-24 24-37.5 56.6-37.5 90.5V219c0 33.9 13.5 66.5 37.5 90.5l9.8 9.8c13.1 13.1 12.4 34.6-1.7 46.8L11 423.8C4.3 429.6 .3 438 0 446.9s3.1 17.5 9.4 23.8l32 32c6.3 6.3 14.9 9.7 23.8 9.4s17.2-4.3 23-11l57.7-66.6c12.2-14 33.7-14.8 46.8-1.7l9.8 9.8c24 24 56.6 37.5 90.5 37.5h2.7c3.1 0 6.1-.1 9.2-.3c-2.9-5-5.4-10.3-7.6-15.7c-.3 0-.6 0-.9 0c-.2 0-.4 0-.6 0H293c-29.7 0-58.2-11.8-79.2-32.8l-9.8-9.8c-19.7-19.7-52-18.5-70.2 2.5L76.1 490.5c-2.9 3.4-7.1 5.4-11.5 5.5s-8.7-1.5-11.9-4.7l-32-32c-3.1-3.1-4.8-7.4-4.7-11.9s2.2-8.6 5.5-11.5l66.6-57.7c21.1-18.2 22.2-50.5 2.5-70.2l-9.8-9.8C59.8 277.2 48 248.7 48 219v-2.7c0-25.2 8.5-49.5 23.8-69.1L296 371.3c2-5.4 4.4-10.6 7-15.6L82.6 135.3l58.3-58.3c81.2-81.2 212.9-81.2 294.2 0zM336 416a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm176 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z'
      
    ]
  };

  
    var faPingPongPaddleBall = faTableTennisPaddleBall;
  
    var faTableTennis = faTableTennisPaddleBall;
  

  
  

  var faMagnifyingGlass = {
    prefix: 'fat',
    iconName: 'magnifying-glass',
    icon: [
      512,
      512,
      [128269,"search"],
      'f002',
      
      'M400 208A192 192 0 1 0 16 208a192 192 0 1 0 384 0zM349.3 360.6C312.2 395 262.6 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 54.6-21 104.2-55.4 141.3l149 149c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-149-149z'
      
    ]
  };

  
    var faSearch = faMagnifyingGlass;
  

  
  

  var faRupiahSign = {
    prefix: 'fat',
    iconName: 'rupiah-sign',
    icon: [
      512,
      512,
      [],
      'e23d',
      
      'M0 72C0 49.9 17.9 32 40 32h80c75.1 0 136 60.9 136 136c0 68.7-50.9 125.5-117.1 134.7l60.6 166.6c1.5 4.2-.6 8.7-4.8 10.2s-8.7-.6-10.3-4.8L122.4 304c-.8 0-1.6 0-2.4 0H16V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V296 72zM16 288H120c66.3 0 120-53.7 120-120s-53.7-120-120-120H40C26.7 48 16 58.7 16 72V288zm288-88V368h96c53 0 96-43 96-96s-43-96-96-96H328c-13.3 0-24 10.7-24 24zm96 184H304V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V200c0-22.1 17.9-40 40-40h72c61.9 0 112 50.1 112 112s-50.1 112-112 112z'
      
    ]
  };

  

  
  

  var faTableCellsRowLock = {
    prefix: 'fat',
    iconName: 'table-cells-row-lock',
    icon: [
      640,
      512,
      [],
      'e67a',
      
      'M64 48l384 0c26.5 0 48 21.5 48 48l0 69.5c5.1-1.8 10.5-3.2 16-4.1L512 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0 0-16-32 0 0-128 34 0c1.5-5.7 3.7-11 6.5-16L352 320l0-128 104.4 0c5.4-6.1 11.7-11.5 18.5-16L16 176l0-80c0-26.5 21.5-48 48-48zM16 192l144 0 0 128L16 320l0-128zm0 144l144 0 0 128-96 0c-26.5 0-48-21.5-48-48l0-80zM176 464l0-128 160 0 0 128-160 0zm0-144l0-128 160 0 0 128-160 0zM528 208c26.5 0 48 21.5 48 48l0 64-96 0 0-64c0-26.5 21.5-48 48-48zm-64 48l0 64-16 0c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-16 0 0-64c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-16 80l16 0 16 0 96 0 16 0 16 0c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faBurgerLettuce = {
    prefix: 'fat',
    iconName: 'burger-lettuce',
    icon: [
      512,
      512,
      [],
      'e3e3',
      
      'M450.9 208H61.1c-7.2 0-13.1-5.9-13.1-13.1c0-1 .1-1.4 .2-1.7c2.3-9.2 13-45.7 43.6-79.7C121.9 80 172.1 48 256 48s134.1 32 164.3 65.5c30.6 34 41.3 70.5 43.6 79.7c.1 .3 .2 .7 .2 1.7c0 7.2-5.9 13.1-13.1 13.1zM61.1 224H450.9c16.1 0 29.1-13 29.1-29.1c0-1.9-.2-3.7-.6-5.6C474.1 168.3 433.2 32 256 32S37.9 168.3 32.6 189.3c-.5 1.9-.6 3.7-.6 5.6C32 211 45 224 61.1 224zM59.4 400H452.6c6.3 0 11.4 5.1 11.4 11.4c0 29-23.5 52.6-52.6 52.6H100.6c-29 0-52.6-23.5-52.6-52.6c0-6.3 5.1-11.4 11.4-11.4zm0-16C44.3 384 32 396.3 32 411.4c0 37.9 30.7 68.6 68.6 68.6H411.4c37.9 0 68.6-30.7 68.6-68.6c0-15.1-12.3-27.4-27.4-27.4H59.4zM144 144a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm240-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM256 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM124.5 312l1.8-1.1c13.5-8 25.8-14.9 41.6-14.9c15.5 0 25.6 6.5 38.1 14.5l.3 .2c12.6 8.1 27.1 17.3 49.6 17.3s37.1-9.2 49.6-17.3l.3-.2c12.4-8 22.5-14.5 38.1-14.5c15.8 0 28.1 6.8 41.6 14.9l1.8 1.1c12.5 7.5 26.8 16 44.5 16c17.4 0 30.6-4.4 39.6-8.8c4.5-2.2 7.9-4.5 10.2-6.3c1.2-.9 2.1-1.6 2.7-2.2c.3-.3 .6-.5 .8-.7l.2-.2 .1-.1 0 0 0 0 0 0s0 0-5.7-5.7l5.7 5.7c3.1-3.1 3.1-8.2 0-11.3c-3.1-3.1-8.1-3.1-11.3 0l0 0c-.1 .1-.2 .2-.4 .3c-.4 .3-1 .8-1.8 1.4c-1.7 1.2-4.3 3-7.8 4.7c-7 3.5-17.8 7.2-32.4 7.2c-13.2 0-24-6.4-37.7-14.6l-.5-.3c-13.4-8-29.1-17.1-49.8-17.1c-20.3 0-33.9 8.8-45.9 16.5l-1.2 .8c-12.3 7.9-23.5 14.7-41 14.7s-28.7-6.8-41-14.7l-1.2-.8c-12-7.7-25.6-16.5-45.9-16.5c-20.7 0-36.4 9.2-49.8 17.1l-.5 .3C104 305.6 93.2 312 80 312c-14.6 0-25.4-3.6-32.4-7.2c-3.5-1.8-6.1-3.5-7.8-4.7c-.8-.6-1.4-1.1-1.8-1.4c-.2-.2-.3-.3-.4-.3l0 0c-3.1-3.1-8.2-3.1-11.3 0c-3.1 3.1-3.1 8.2 0 11.3L32 304c-5.7 5.7-5.7 5.7-5.7 5.7l0 0 0 0 0 0 .1 .1 .2 .2c.2 .2 .4 .4 .8 .7c.6 .6 1.5 1.3 2.7 2.2c2.3 1.8 5.7 4 10.2 6.3c9 4.5 22.2 8.8 39.6 8.8c17.7 0 32-8.5 44.5-16z'
      
    ]
  };

  

  
  

  var faSquareDownLeft = {
    prefix: 'fat',
    iconName: 'square-down-left',
    icon: [
      448,
      512,
      [],
      'e26b',
      
      'M64 464c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H384c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64zM0 416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416zm128-72V217c0-5 4-9 9-9c2.4 0 4.7 .9 6.3 2.6l35 35c3.1 3.1 8.2 3.1 11.3 0L272 163.3c2.1-2.1 5-3.3 8-3.3s5.9 1.2 8 3.3L316.7 192c2.1 2.1 3.3 5 3.3 8s-1.2 5.9-3.3 8l-82.3 82.3c-3.1 3.1-3.1 8.2 0 11.3l35 35c1.7 1.7 2.6 4 2.6 6.3c0 5-4 9-9 9H136c-4.4 0-8-3.6-8-8zm8 24H263c13.8 0 25-11.2 25-25c0-6.6-2.6-13-7.3-17.7L251.3 296 328 219.3c5.1-5.1 8-12.1 8-19.3s-2.9-14.2-8-19.3L299.3 152c-5.1-5.1-12.1-8-19.3-8s-14.2 2.9-19.3 8L184 228.7l-29.4-29.4c-4.7-4.7-11-7.3-17.7-7.3c-13.8 0-25 11.2-25 25V344c0 13.3 10.7 24 24 24z'
      
    ]
  };

  

  
  

  var faCupTogo = {
    prefix: 'fat',
    iconName: 'cup-togo',
    icon: [
      448,
      512,
      ["coffee-togo"],
      'f6c5',
      
      'M32 80c5.5 0 10.6-2.8 13.6-7.5l30.6-49c2.9-4.7 8.1-7.5 13.6-7.5l268.5 0c5.5 0 10.6 2.8 13.6 7.5l30.6 49c2.9 4.7 8.1 7.5 13.6 7.5c8.8 0 16 7.2 16 16s-7.2 16-16 16L32 112c-8.8 0-16-7.2-16-16s7.2-16 16-16zM385.4 15c-5.8-9.4-16.1-15-27.1-15L89.7 0c-11 0-21.3 5.7-27.1 15L32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L385.4 15zM47.4 160L74.6 453.9c3 32.9 30.7 58.1 63.7 58.1l171.3 0c33.1 0 60.7-25.2 63.7-58.1L400.6 160l-16.1 0-5.9 64L69.4 224l-5.9-64-16.1 0zm23.5 80l306.2 0L363.8 384 84.2 384 70.9 240zM85.7 400l276.6 0-4.9 52.4c-2.3 24.7-23 43.6-47.8 43.6l-171.3 0c-24.8 0-45.5-18.9-47.8-43.6L85.7 400z'
      
    ]
  };

  
    var faCoffeeTogo = faCupTogo;
  

  
  

  var faFont = {
    prefix: 'fat',
    iconName: 'font',
    icon: [
      448,
      512,
      [],
      'f031',
      
      'M231.4 37c-1.2-3-4.2-5-7.4-5s-6.2 2-7.4 5L42.6 464H8c-4.4 0-8 3.6-8 8s3.6 8 8 8h96c4.4 0 8-3.6 8-8s-3.6-8-8-8H59.9L112 336H336l52.1 128H344c-4.4 0-8 3.6-8 8s3.6 8 8 8h96c4.4 0 8-3.6 8-8s-3.6-8-8-8H405.4L231.4 37zm98 283H118.6L224 61.2 329.4 320z'
      
    ]
  };

  

  
  

  var faPlay = {
    prefix: 'fat',
    iconName: 'play',
    icon: [
      384,
      512,
      [9654],
      'f04b',
      
      'M64.7 52.7c-9.9-6-22.2-6.3-32.3-.6S16 68.4 16 80V432c0 11.6 6.3 22.2 16.3 27.9s22.5 5.4 32.3-.6l288-176c9.5-5.8 15.3-16.2 15.3-27.3s-5.8-21.5-15.3-27.3l-288-176zM24.5 38.1C39.7 29.6 58.2 30 73 39L361 215c14.3 8.7 23 24.2 23 41s-8.7 32.2-23 41L73 473c-14.8 9.1-33.4 9.4-48.5 .9S0 449.4 0 432V80C0 62.6 9.4 46.6 24.5 38.1z'
      
    ]
  };

  

  
  

  var faTreeCity = {
    prefix: 'fat',
    iconName: 'tree-city',
    icon: [
      640,
      512,
      [],
      'e587',
      
      'M304 40c0-13.3 10.7-24 24-24H472c13.3 0 24 10.7 24 24V200c0 4.4 3.6 8 8 8h64 32c13.3 0 24 10.7 24 24V504c0 4.4 3.6 8 8 8s8-3.6 8-8V232c0-22.1-17.9-40-40-40H576V104c0-4.4-3.6-8-8-8s-8 3.6-8 8v88H512V40c0-22.1-17.9-40-40-40H328c-22.1 0-40 17.9-40 40V504c0 4.4 3.6 8 8 8s8-3.6 8-8V40zM128 224c-4.4 0-8 3.6-8 8v72H80c-35.3 0-64-28.7-64-64c0-22.6 11.8-41.3 30.5-54.8c2.4-1.8 3.7-4.8 3.2-7.7c-1-6.2-1.8-11.8-1.8-17.5c0-44.2 35.8-80 80-80s80 35.8 80 80c0 5.6-.8 11.3-1.8 17.5c-.5 3 .8 6 3.2 7.7C228.2 198.7 240 217.4 240 240c0 35.3-28.7 64-64 64H136V232c0-4.4-3.6-8-8-8zm-8 96V504c0 4.4 3.6 8 8 8s8-3.6 8-8V320h40c44.2 0 80-35.8 80-80c0-27.1-13.5-49.1-33.2-64.8c.7-4.9 1.2-10 1.2-15.2c0-53-43-96-96-96s-96 43-96 96c0 5.3 .5 10.4 1.2 15.2C13.5 190.9 0 212.9 0 240c0 44.2 35.8 80 80 80h40zM360 96v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V96c0-13.3-10.7-24-24-24H384c-13.3 0-24 10.7-24 24zm24-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H384c-4.4 0-8-3.6-8-8V96c0-4.4 3.6-8 8-8zM512 264c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V288c0-13.3-10.7-24-24-24H512zm-8 24c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H512c-4.4 0-8-3.6-8-8V288zM488 416v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V416c0-13.3-10.7-24-24-24H512c-13.3 0-24 10.7-24 24zm24-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H512c-4.4 0-8-3.6-8-8V416c0-4.4 3.6-8 8-8zM384 200c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V224c0-13.3-10.7-24-24-24H384zm-8 24c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H384c-4.4 0-8-3.6-8-8V224zM360 352v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V352c0-13.3-10.7-24-24-24H384c-13.3 0-24 10.7-24 24zm24-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H384c-4.4 0-8-3.6-8-8V352c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faFileMinus = {
    prefix: 'fat',
    iconName: 'file-minus',
    icon: [
      384,
      512,
      [],
      'f318',
      
      'M64 496c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM96 304c-4.4 0-8 3.6-8 8s3.6 8 8 8H288c4.4 0 8-3.6 8-8s-3.6-8-8-8H96z'
      
    ]
  };

  

  
  

  var faEarListen = {
    prefix: 'fat',
    iconName: 'ear-listen',
    icon: [
      512,
      512,
      ["assistive-listening-systems"],
      'f2a2',
      
      'M365 4.1c2.1-3.9 7-5.3 10.9-3.1C457.1 46 512 132.6 512 232c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-93.4-51.6-174.7-127.8-217c-3.9-2.1-5.3-7-3.1-10.9zM160 336a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM32 464a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16A32 32 0 1 1 0 480a32 32 0 1 1 64 0zm69.7-37.7c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-64-64c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l64 64zM240 80C151.6 80 80 150.9 80 238.2c0 4.4-3.6 8-8 8s-8-3.6-8-8C64 141.9 142.9 64 240 64s176 77.9 176 174.2c0 51-22.2 96.8-57.4 128.7c-6.1 5.6-9.8 12.9-9.8 20.4V392c0 66.3-53.7 120-120 120H206.4c-4.4 0-8-3.6-8-8s3.6-8 8-8h22.4c57.4 0 104-46.6 104-104v-4.8c0-12.8 6.2-24.2 15.1-32.2C379.9 326 400 284.4 400 238.2C400 150.9 328.4 80 240 80zm0 64c-53 0-96 43-96 96c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-61.9 50.1-112 112-112s112 50.1 112 112c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-53-43-96-96-96z'
      
    ]
  };

  
    var faAssistiveListeningSystems = faEarListen;
  

  
  

  var faLink = {
    prefix: 'fat',
    iconName: 'link',
    icon: [
      640,
      512,
      [128279,"chain"],
      'f0c1',
      
      'M580.2 244.7c50-50 50-131 0-181s-131-50-181 0l-17 17c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l17-17c43.7-43.7 114.7-43.7 158.4 0s43.7 114.7 0 158.4L433.1 369.1c-43.7 43.7-114.7 43.7-158.4 0s-43.7-114.7 0-158.4l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-39.6 39.6c-50 50-50 131 0 181s131 50 181 0L580.2 244.7zM59.8 267.3c-50 50-50 131 0 181s131 50 181 0l17-17c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-17 17c-43.7 43.7-114.7 43.7-158.4 0s-43.7-114.7 0-158.4L206.9 142.9c43.7-43.7 114.7-43.7 158.4 0s43.7 114.7 0 158.4l-39.6 39.6c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l39.6-39.6c50-50 50-131 0-181s-131-50-181 0L59.8 267.3z'
      
    ]
  };

  
    var faChain = faLink;
  

  
  

  var faBallotCheck = {
    prefix: 'fat',
    iconName: 'ballot-check',
    icon: [
      448,
      512,
      [],
      'f733',
      
      'M384 16c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H384zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM192 128c0 4.4 3.6 8 8 8H376c4.4 0 8-3.6 8-8s-3.6-8-8-8H200c-4.4 0-8 3.6-8 8zm0 128c0 4.4 3.6 8 8 8H376c4.4 0 8-3.6 8-8s-3.6-8-8-8H200c-4.4 0-8 3.6-8 8zm0 128c0 4.4 3.6 8 8 8H376c4.4 0 8-3.6 8-8s-3.6-8-8-8H200c-4.4 0-8 3.6-8 8zm-56-8c0-17.7-14.3-32-32-32H88c-17.7 0-32 14.3-32 32v16c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V376zm-64 0c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H88c-8.8 0-16-7.2-16-16V376zM88 88c-17.7 0-32 14.3-32 32v16c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V120c0-17.7-14.3-32-32-32H88zm0 16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H88c-8.8 0-16-7.2-16-16V120c0-8.8 7.2-16 16-16zm69.7 125.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L96 268.7 69.7 242.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l32 32c3.1 3.1 8.2 3.1 11.3 0l56-56z'
      
    ]
  };

  

  
  

  var faGrillHot = {
    prefix: 'fat',
    iconName: 'grill-hot',
    icon: [
      448,
      512,
      [],
      'e5a5',
      
      'M104 0c4.4 0 8 3.6 8 8v9.4c0 11.2 5.9 21.7 15.5 27.4l41.2 24.7c14.5 8.7 23.3 24.3 23.3 41.2V120c0 4.4-3.6 8-8 8s-8-3.6-8-8v-9.4c0-11.2-5.9-21.7-15.5-27.4L119.3 58.5C104.8 49.8 96 34.2 96 17.4V8c0-4.4 3.6-8 8-8zm96 0c4.4 0 8 3.6 8 8v9.4c0 11.2 5.9 21.7 15.5 27.4l41.2 24.7c14.5 8.7 23.3 24.3 23.3 41.2V120c0 4.4-3.6 8-8 8s-8-3.6-8-8v-9.4c0-11.2-5.9-21.7-15.5-27.4L215.3 58.5C200.8 49.8 192 34.2 192 17.4V8c0-4.4 3.6-8 8-8zM32 176c-8.8 0-16 7.2-16 16c0 97.2 78.8 176 176 176h64c97.2 0 176-78.8 176-176c0-8.8-7.2-16-16-16H32zM0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32c0 81.9-51.3 151.8-123.5 179.4l58.8 129.3c1.8 4 0 8.8-4 10.6s-8.8 0-10.6-4L345.4 456H159.5c-3.9 31.6-30.9 56-63.5 56c-35.3 0-64-28.7-64-64s28.7-64 64-64c7.1 0 13.9 1.2 20.3 3.3l7.2-15.9C51.3 343.8 0 273.9 0 192zM309.3 376.5c-16.9 4.9-34.8 7.5-53.3 7.5H192c-18.5 0-36.4-2.6-53.3-7.5l-8 17.7c15.5 10 26.4 26.6 28.8 45.8H338.1l-28.9-63.5zM144 448a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  

  
  

  var faLandmarkMagnifyingGlass = {
    prefix: 'fat',
    iconName: 'landmark-magnifying-glass',
    icon: [
      640,
      512,
      [],
      'e622',
      
      'M448 288c-5.4 0-10.7-.3-16-.8V368H328V233.8c-5.9-6.7-11.3-13.9-16-21.5V368H200V200c0-4.4-3.6-8-8-8s-8 3.6-8 8V368H80V200c0-4.4-3.6-8-8-8s-8 3.6-8 8V376c0 4.4 3.6 8 8 8H440c4.4 0 8-3.6 8-8V288zM259.3 .7c-2.1-.9-4.5-.9-6.6 0L14.1 108.5C5.5 112.3 0 120.9 0 130.3V136c0 13.3 10.7 24 24 24H291.2c-1.1-5.2-1.9-10.6-2.4-16H24c-4.4 0-8-3.6-8-8v-5.7c0-3.1 1.8-6 4.7-7.3L256 16.8l56.8 25.6c2.9-4.6 6.1-9 9.4-13.3L259.3 .7zM40 432c-4.4 0-8 3.6-8 8s3.6 8 8 8H472c4.4 0 8-3.6 8-8s-3.6-8-8-8H40zM8 496c-4.4 0-8 3.6-8 8s3.6 8 8 8H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zM448 16.1a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 240c32.5 0 62.1-12.1 84.7-32l93.7 93.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L544 212.8c19.9-22.6 32-52.2 32-84.7c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128z'
      
    ]
  };

  

  
  

  var faBoxesStacked = {
    prefix: 'fat',
    iconName: 'boxes-stacked',
    icon: [
      576,
      512,
      [62625,"boxes","boxes-alt"],
      'f468',
      
      'M368 16c26.5 0 48 21.5 48 48V192c0 5.6-1 11-2.7 16H430c1.3-5.1 2-10.5 2-16V64c0-35.3-28.7-64-64-64H320 256 208c-35.3 0-64 28.7-64 64V192c0 5.5 .7 10.9 2 16h16.7c-1.8-5-2.7-10.4-2.7-16V64c0-26.5 21.5-48 48-48h32V80c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V16l32 0zM256 16l64 0V80c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V16zm52 478.5c11.5 10.9 27 17.5 44 17.5H512c35.3 0 64-28.7 64-64V304c0-35.3-28.7-64-64-64H480 464 400 384 352c-20.2 0-38.3 9.4-50 24c3.4 4.7 6.4 9.8 8.9 15.1c8.4-13.9 23.7-23.2 41.1-23.2h32v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V256h32c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H352c-14.9 0-28.2-6.8-37-17.4c-1.9 5.5-4.2 10.9-7 15.9zM400 256h64v64c0 8.8-7.2 16-16 16H416c-8.8 0-16-7.2-16-16V256zM272 304V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V304c0-26.5 21.5-48 48-48H96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V256h32c26.5 0 48 21.5 48 48zM112 320V256h64v64c0 8.8-7.2 16-16 16H128c-8.8 0-16-7.2-16-16zm112-80H192 176 112 96 64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H224c35.3 0 64-28.7 64-64V304c0-35.3-28.7-64-64-64z'
      
    ]
  };

  
    var faBoxes = faBoxesStacked;
  
    var faBoxesAlt = faBoxesStacked;
  

  
  

  var faTimer = {
    prefix: 'fat',
    iconName: 'timer',
    icon: [
      512,
      512,
      [],
      'e29e',
      
      'M256 0c-4.4 0-8 3.6-8 8V120c0 4.4 3.6 8 8 8s8-3.6 8-8V16.1c128.8 4.2 232 110 232 239.9c0 132.5-107.5 240-240 240S16 388.5 16 256c0-66.3 26.9-126.3 70.3-169.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0C28.7 121.3 0 185.3 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0zM165.7 154.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l96 96c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-96-96z'
      
    ]
  };

  

  
  

  var faSpeaker = {
    prefix: 'fat',
    iconName: 'speaker',
    icon: [
      384,
      512,
      [],
      'f8df',
      
      'M64 16C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48H320c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM288 336A96 96 0 1 0 96 336a96 96 0 1 0 192 0zM80 336a112 112 0 1 1 224 0A112 112 0 1 1 80 336zm112 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm32-176a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  

  
  

  var faCarBus = {
    prefix: 'fat',
    iconName: 'car-bus',
    icon: [
      640,
      512,
      [],
      'f85a',
      
      'M32.8 58.5C20.5 68.5 16.2 85.3 16 104H192 368c-.2-18.7-4.5-35.5-16.8-45.5C326.7 38.7 277.2 16 192 16S57.3 38.7 32.8 58.5zM16 120V232H184V120H16zm0 128V360c0 22.1 17.9 40 40 40H96h16H224v16H112v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V416v-5.4c-18.9-9-32-28.3-32-50.6V105.1C0 84.5 4.4 61 22.7 46.1C50.7 23.4 104 0 192 0s141.3 23.4 169.3 46.1C379.6 61 384 84.5 384 105.1V144h-3.8c-4.1 0-8.2 .3-12.2 .8V120H200V232h82.7l-4.6 16H192 16zM96 416H56 48v32c0 8.8 7.2 16 16 16H80c8.8 0 16-7.2 16-16V416zm0-112a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM380.2 192c-17.9 0-33.6 11.8-38.5 29l-19.5 68.2c4.5-.8 9-1.2 13.7-1.2H560c4.7 0 9.3 .4 13.7 1.2L554.3 221c-4.9-17.2-20.6-29-38.5-29H380.2zM304.3 293.8l22.1-77.2c6.9-24 28.8-40.6 53.8-40.6H515.8c25 0 47 16.6 53.8 40.6l22.1 77.2-1 .3c29 12 49.3 40.6 49.3 73.9v64 16 32c0 17.7-14.3 32-32 32H592c-17.7 0-32-14.3-32-32V448H336v32c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V448 432 368c0-33.3 20.4-61.9 49.3-73.9l-1-.3zM576 432h48V368c0-35.3-28.7-64-64-64H336c-35.3 0-64 28.7-64 64v64h48 16H560h16zm16 64h16c8.8 0 16-7.2 16-16V448H576v32c0 8.8 7.2 16 16 16zM320 448H272v32c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V448zm0-80a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm224-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z'
      
    ]
  };

  

  
  

  var faStarHalf = {
    prefix: 'fat',
    iconName: 'star-half',
    icon: [
      576,
      512,
      [61731],
      'f089',
      
      'M212.1 161.8c-2.3 4.8-6.8 8.1-12.1 8.8L46.8 193.3c-3 .4-5.5 2.5-6.4 5.4s-.2 6 2 8.2L31.1 218.3c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5c4.9-10.1 16.1-15.4 27-12.9s18.6 12.2 18.6 23.4V408.7c0 8.9-4.9 17-12.7 21.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.3l11.3-11.4L153.5 317c3.7 3.7 5.4 8.9 4.5 14L131.8 486.6c-.5 3 .7 6 3.2 7.8s5.8 2 8.4 .6l148.3-79.2c2.6-1.4 4.2-4.1 4.2-7.1V24c0-3.7-2.6-7-6.2-7.8s-7.4 .9-9 4.3L212.1 161.8z'
      
    ]
  };

  

  
  

  var faMoneyFromBracket = {
    prefix: 'fat',
    iconName: 'money-from-bracket',
    icon: [
      640,
      512,
      [],
      'e312',
      
      'M72 16C41.1 16 16 41.1 16 72v80c0 4.4-3.6 8-8 8s-8-3.6-8-8V72C0 32.2 32.2 0 72 0H568c39.8 0 72 32.2 72 72v80c0 4.4-3.6 8-8 8s-8-3.6-8-8V72c0-30.9-25.1-56-56-56H72zM504 80c4.4 0 8 3.6 8 8l0 376c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48l0-376c0-4.4 3.6-8 8-8s8 3.6 8 8l0 376c0 17.7 14.3 32 32 32H464c17.7 0 32-14.3 32-32l0-376c0-4.4 3.6-8 8-8zM320 200c-50 0-88 33.5-88 72s38 72 88 72s88-33.5 88-72s-38-72-88-72zm104 72c0 49.9-48 88-104 88s-104-38.1-104-88s48-88 104-88s104 38.1 104 88zm48 120c0 4.4-3.6 8-8 8h-8c-30.9 0-56 25.1-56 56v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-39.8 32.2-72 72-72h8c4.4 0 8 3.6 8 8zm-296-8h8c39.8 0 72 32.2 72 72v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-30.9-25.1-56-56-56h-8c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faCheckToSlot = {
    prefix: 'fat',
    iconName: 'check-to-slot',
    icon: [
      576,
      512,
      ["vote-yea"],
      'f772',
      
      'M144 48c-17.7 0-32 14.3-32 32V408H464V80c0-17.7-14.3-32-32-32H144zM480 80V408h32c4.4 0 8 3.6 8 8s-3.6 8-8 8H480 464 112 96 64c-4.4 0-8-3.6-8-8s3.6-8 8-8H96V80c0-26.5 21.5-48 48-48H432c26.5 0 48 21.5 48 48zM48 352H64v16H48c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32H528c17.7 0 32-14.3 32-32V400c0-17.7-14.3-32-32-32H512V352h16c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V400c0-26.5 21.5-48 48-48zM373.7 176.3L267 283c-3.1 3.1-8.2 3.1-11.3 0l-53.3-53.3c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L261.3 266l101-101c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3z'
      
    ]
  };

  
    var faVoteYea = faCheckToSlot;
  

  
  

  var faCloudHail = {
    prefix: 'fat',
    iconName: 'cloud-hail',
    icon: [
      512,
      512,
      [],
      'f739',
      
      'M398.7 124.8c.8-4.1 1.3-8.4 1.3-12.8c0-35.3-28.7-64-64-64c-19.5 0-36.9 8.7-48.6 22.4c-3.5 4-8.7 6.1-13.9 5.5s-9.9-3.8-12.4-8.5C245 36.8 212.9 16 176 16c-53 0-96 43-96 96c0 6.1 .6 12.1 1.7 17.9c1.5 7.9-3.1 15.6-10.7 18.1C39 158.5 16 188.6 16 224c0 44.2 35.8 80 80 80H416c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.4 0-.9 0-1.3 0c-4.8 .1-9.5-2-12.6-5.8s-4.3-8.7-3.4-13.4zM176 0c37.1 0 70 18.1 90.4 45.9c3.3 4.5 6.2 9.2 8.8 14.1c3.6-4.2 7.6-8 12-11.4C300.7 38.2 317.6 32 336 32c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c4.9 0 9.8 .4 14.5 1.1c46.2 7 81.5 46.8 81.5 94.9c0 53-43 96-96 96H96c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0zM128 368a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM64 464a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm144-96a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-64 48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm144-96a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-64 48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z'
      
    ]
  };

  

  
  

  var faMeterFire = {
    prefix: 'fat',
    iconName: 'meter-fire',
    icon: [
      640,
      512,
      [],
      'e1eb',
      
      'M256 16c86.9 0 163 46.2 205.1 115.4c5 2 9.6 4.9 13.8 8.6c5.6 5.1 11.1 10.2 16.6 15.5C452.5 64.1 361.7 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c33.6 0 65.7-6.5 95.1-18.3c-4.3-3.9-8.4-8.1-12.3-12.4C313 490.8 285.1 496 256 496C123.5 496 16 388.5 16 256S123.5 16 256 16zM384 160c0-17.7-14.3-32-32-32s-32 14.3-32 32v32c0 13.2 7.9 24.5 19.3 29.4c3.2-4.5 6.6-9.1 10-13.6c-7.6-1.3-13.3-7.9-13.3-15.8V160c0-8.8 7.2-16 16-16s16 7.2 16 16v24.9c5.1-5.9 10.5-11.8 16-17.5V160zm-208 0v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V160c0-8.8 7.2-16 16-16s16 7.2 16 16zm-48 0v32c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-17.7-14.3-32-32-32s-32 14.3-32 32zm144 32c0 8.8-7.2 16-16 16s-16-7.2-16-16V160c0-8.8 7.2-16 16-16s16 7.2 16 16v32zm-16-64c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-17.7-14.3-32-32-32zm189.5 48c1.5 0 2.9 .5 4 1.5c16.1 14.6 31.3 30.1 45.6 46.8c6.6 7.6 18.4 7.5 24.8-.3c5.8-7 11.9-13.9 18.2-19.6c2.3-2.1 5.9-2.1 8.2 0c18.9 17.4 38.4 41.2 53.2 67.2c14.8 26.1 24.5 54 24.5 79.7c0 49.7-25.1 93.7-63.4 119.8c9.7-14 15.4-30.7 15.4-48.7c0-57.4-63.8-110.5-87.4-128.2c-5.2-3.9-12.1-3.9-17.3 0C447.8 312.1 384 365.2 384 422.6c0 18.2 5.8 35 15.7 49.2c-38.7-26-63.7-70.3-63.7-120.3c0-32.3 14.1-64.9 34.7-95.2c20.5-30.2 47-57.4 70.8-78.7c1.1-1 2.6-1.5 4.1-1.5zM480 496c-2.7 0-5.5-.1-8.2-.2c-41.2-3.8-71.8-36-71.8-73.2c0-23 13-47 31.1-68.7c17.3-20.7 37.4-37.2 48.9-45.9c11.5 8.7 31.6 25.2 48.9 45.9C547 375.5 560 399.5 560 422.6c0 37.2-30.6 69.4-71.7 73.2c-2.7 .2-5.5 .2-8.3 .2zM320 351.4c0 85.1 65.5 155.6 150.8 160.3c3 .3 6.1 .4 9.2 .4c3.2 0 6.3-.1 9.4-.4C573.7 506.9 640 436.5 640 351.4c0-29.5-11-60.1-26.6-87.6c-15.6-27.6-36.2-52.6-56.3-71.1c-8.4-7.7-21.4-7.8-29.8-.1c-7.1 6.5-13.8 14-19.7 21.3c0 0-.1 0-.1 .1s-.1 0-.1 0s-.1 0-.1 0l0 0s0 0 0 0s0 0 0 0c-14.8-17.2-30.5-33.2-47-48.3c-4.2-3.8-9.4-5.6-14.6-5.7c-5.3 0-10.6 1.8-14.9 5.6c-24.3 21.8-51.8 50-73.3 81.6C336 278.8 320 314.6 320 351.4z'
      
    ]
  };

  

  
  

  var faSquareE = {
    prefix: 'fat',
    iconName: 'square-e',
    icon: [
      448,
      512,
      [],
      'e26d',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm152 32H312c4.4 0 8 3.6 8 8s-3.6 8-8 8H152c-4.4 0-8 3.6-8 8v96H272c4.4 0 8 3.6 8 8s-3.6 8-8 8H144v96c0 4.4 3.6 8 8 8H312c4.4 0 8 3.6 8 8s-3.6 8-8 8H152c-13.3 0-24-10.7-24-24V256 152c0-13.3 10.7-24 24-24z'
      
    ]
  };

  

  
  

  var faHeadSideHeart = {
    prefix: 'fat',
    iconName: 'head-side-heart',
    icon: [
      512,
      512,
      [],
      'e1aa',
      
      'M16 222.9C16 108.6 108.6 16 222.9 16h16.8c71.6 0 137.5 43.3 166.4 105c3.5 7.4 6.9 15.1 10.4 22.9c6.4 14.3 12.9 28.9 20.1 42.7c11.3 21.6 24.8 42.2 43.5 58.9l3.8 3.4c7.7 6.9 12.1 16.7 12.1 27c0 20-16.2 36.2-36.2 36.2H440c-4.4 0-8 3.6-8 8v72c0 22.1-17.9 40-40 40H312c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8s8-3.6 8-8V448h72c30.9 0 56-25.1 56-56V328h11.8c28.8 0 52.2-23.4 52.2-52.2c0-14.9-6.4-29.1-17.5-39l-3.8-3.4c-16.7-14.9-29.2-33.6-40-54.4c-7-13.4-13.1-27.1-19.3-41c-3.5-7.9-7.1-15.9-10.8-23.9C389.1 46.9 317.6 0 239.7 0H222.9C99.8 0 0 99.8 0 222.9c0 52.8 16.9 101.5 47.4 139.9C57.5 375.5 64 390.2 64 405.3V504c0 4.4 3.6 8 8 8s8-3.6 8-8V405.3c0-19.8-8.5-37.8-20.1-52.4C31.8 317.5 16 272.3 16 222.9zm112-37c0-23.2 18.8-41.9 41.9-41.9c11.1 0 21.8 4.4 29.7 12.3L218.3 175c1.5 1.5 3.5 2.3 5.7 2.3s4.2-.8 5.7-2.3l18.7-18.7c7.9-7.9 18.5-12.3 29.7-12.3c23.2 0 41.9 18.8 41.9 41.9v.6c0 10.6-4 20.9-11.2 28.8l-78.9 86.1c-1.5 1.7-3.7 2.6-5.9 2.6s-4.4-.9-5.9-2.6l-78.9-86.1c-7.2-7.8-11.2-18.1-11.2-28.8v-.6zM169.9 128c-32 0-57.9 25.9-57.9 57.9v.6c0 14.7 5.5 28.8 15.4 39.6l78.9 86.1c4.5 5 11 7.8 17.7 7.8s13.1-2.8 17.7-7.8l78.9-86.1c9.9-10.8 15.4-24.9 15.4-39.6v-.6c0-32-25.9-57.9-57.9-57.9c-15.4 0-30.1 6.1-41 17L224 158.1 210.9 145c-10.9-10.9-25.6-17-41-17z'
      
    ]
  };

  

  
  

  var faParagraph = {
    prefix: 'fat',
    iconName: 'paragraph',
    icon: [
      448,
      512,
      [182],
      'f1dd',
      
      'M32 176C32 96.5 96.5 32 176 32h72 8H432c4.4 0 8 3.6 8 8s-3.6 8-8 8H368l0 424c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-424H272V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V320H176C96.5 320 32 255.5 32 176zM256 304l0-256h-8H176C105.3 48 48 105.3 48 176s57.3 128 128 128h80z'
      
    ]
  };

  

  
  

  var faFax = {
    prefix: 'fat',
    iconName: 'fax',
    icon: [
      512,
      512,
      [128224,128439],
      'f1ac',
      
      'M160 56c0-22.1 17.9-40 40-40H380.1c10.6 0 20.8 4.2 28.3 11.7l27.9 27.9c7.5 7.5 11.7 17.7 11.7 28.3V160h16V83.9c0-14.9-5.9-29.1-16.4-39.6L419.7 16.4C409.2 5.9 395 0 380.1 0H200c-30.9 0-56 25.1-56 56v93.7C132.3 136.4 115.1 128 96 128H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H96c22.9 0 43-12 54.3-30.1c9.3 17.9 28.1 30.1 49.7 30.1H456c30.9 0 56-25.1 56-56V248c0-30.9-25.1-56-56-56H160V56zm0 152H456c22.1 0 40 17.9 40 40V456c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40v-7.9l0-.1V208zM144 448.1c0 26.5-21.5 47.9-48 47.9H64c-26.5 0-48-21.5-48-48V192c0-26.5 21.5-48 48-48H96c26.5 0 48 21.5 48 48v8V448l0 .1zM232 320a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm144 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 48a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-48 96a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 48a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-144 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64z'
      
    ]
  };

  

  
  

  var faDeerRudolph = {
    prefix: 'fat',
    iconName: 'deer-rudolph',
    icon: [
      576,
      512,
      [],
      'f78f',
      
      'M240 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V32c0 26.5 21.5 48 48 48h24 8 6.1l-41.5 20.7c-7.7 3.9-12.6 11.8-12.6 20.4c0 12.6 10.2 22.8 22.8 22.8H312h6.5l-11.3 32H112h0H88c-48.6 0-88 39.4-88 88v48c0 4.4 3.6 8 8 8s8-3.6 8-8V264c0-39.8 32.2-72 72-72h24 0H312.9c3.4 0 6.4-2.1 7.5-5.3l15-42.7h.6c4.4 0 8-3.6 8-8s-3.6-8-8-8h-6.2H312 278.8c-3.8 0-6.8-3.1-6.8-6.8c0-2.6 1.5-5 3.8-6.1l51-25.5c12.6-6.3 26.4-9.5 40.4-9.5c24 0 47 9.5 63.9 26.5l49 49c1 11.6 7 21.8 15.8 28.5c-1 13.4-12.2 24-25.9 24H400c-3.6 0-6.8 2.4-7.7 5.9L370 295.7c-1.3 4.8-2 9.8-2 14.7V480c0 8.8-7.2 16-16 16H312c-8.8 0-16-7.2-16-16V352c0-4.4-3.6-8-8-8H263.7c-29.1 0-57.3-9.9-80-28l-2.7-2.2c-2.6-2.1-6.2-2.3-9-.7s-4.4 4.9-3.8 8.2l3.6 21.6c2.2 13-3.5 26-14.4 33.3c-18.2 12.1-26.3 34.8-19.8 55.7l13.4 43.4c3.2 10.3-4.5 20.7-15.3 20.7H97.7c-7 0-13.2-4.6-15.3-11.3L60.2 412.3c-2.5-8-2.4-16.5 .3-24.4l8.8-26.3c1.8-5.5 2.8-11.2 2.8-17v-4.1c0-15.4-7.7-29.9-20.6-38.4c-8.6-5.7-15.2-13.5-19.4-22.5v27.2c3.2 3.2 6.7 6 10.6 8.6c8.4 5.6 13.4 15 13.4 25.1v4.1c0 4.1-.7 8.1-1.9 12l-8.8 26.3c-3.7 11.1-3.8 23-.4 34.2l22.3 72.4C71.3 502.8 83.7 512 97.7 512h37.8c21.5 0 36.9-20.8 30.6-41.4l-13.4-43.4c-4.3-14.1 1.1-29.4 13.4-37.7c16.2-10.8 24.5-30.1 21.3-49.3l-.4-2.3C210 352.3 236.5 360 263.7 360H280V480c0 17.7 14.3 32 32 32h40c17.7 0 32-14.3 32-32V310.4c0-3.6 .5-7.1 1.4-10.5L406.1 224h63.9c20.1 0 36.9-14.1 41-33c2.9 .7 5.9 1 9 1c22.1 0 40-17.9 40-40s-17.9-40-40-40c-16.4 0-30.5 9.9-36.7 24L442.5 95.2c-5.8-5.8-12.2-10.9-19.1-15.2h.6c26.5 0 48-21.5 48-48V8c0-4.4-3.6-8-8-8s-8 3.6-8 8V32c0 17.7-14.3 32-32 32h-8H367.2 339.8c7.6-8.5 12.2-19.7 12.2-32V8c0-4.4-3.6-8-8-8s-8 3.6-8 8V32c0 17.7-14.3 32-32 32h-8H272c-17.7 0-32-14.3-32-32V8zM520 128a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM416 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faFishBones = {
    prefix: 'fat',
    iconName: 'fish-bones',
    icon: [
      576,
      512,
      [],
      'e304',
      
      'M27.5 120c-4.2 0-7.1 4.1-5.8 8l39 120H144V160c0-4.4 3.6-8 8-8s8 3.6 8 8v88h80V160c0-4.4 3.6-8 8-8s8 3.6 8 8v88h80V160c0-4.4 3.6-8 8-8s8 3.6 8 8v88h64V130.9c0-16.9 17.1-28.4 31.8-20c16 9.1 30.6 19.7 43.7 30.7c39.1 33 66.9 72.4 81 99.8c4.7 9.2 4.7 20.1 0 29.3c-14.1 27.4-41.9 66.8-81 99.8c-13.1 11-27.7 21.6-43.7 30.7c-14.7 8.4-31.8-3.1-31.8-20V264H352v88c0 4.4-3.6 8-8 8s-8-3.6-8-8V264H256v88c0 4.4-3.6 8-8 8s-8-3.6-8-8V264H160v88c0 4.4-3.6 8-8 8s-8-3.6-8-8V264H60.7l-39 120c-1.3 4 1.7 8 5.8 8c1.3 0 2.5-.4 3.6-1.1l4.7 6.5L31 390.9l52.3-37.4c3.6-2.6 8.6-1.7 11.2 1.9s1.7 8.6-1.9 11.2L40.3 403.9c-3.8 2.7-8.3 4.1-12.9 4.1c-15 0-25.7-14.7-21.1-29l7.6 2.5L6.4 379l40-123L6.4 133c-4.7-14.3 6-29 21.1-29c4.6 0 9.1 1.4 12.9 4.1l52.3 37.4c3.6 2.6 4.4 7.6 1.9 11.2s-7.6 4.4-11.2 1.9L31 121.1c-1-.7-2.3-1.1-3.6-1.1zM432 256V381.1c0 2.9 1.4 5 3 6c1.4 .9 3 1.1 4.8 .1c15.1-8.6 28.9-18.5 41.3-29c37.3-31.5 63.8-69.2 77.1-94.9c2.4-4.6 2.4-10.1 0-14.7c-13.2-25.7-39.8-63.4-77.1-94.9c-12.4-10.5-26.2-20.4-41.3-29c-1.8-1-3.4-.9-4.8 .1c-1.6 1-3 3.1-3 6V256z'
      
    ]
  };

  

  
  

  var faHeartCircleBolt = {
    prefix: 'fat',
    iconName: 'heart-circle-bolt',
    icon: [
      576,
      512,
      [],
      'e4fc',
      
      'M393.6 57.7c-42.9-5.6-85.8 12.6-111.2 47.6l-20 27.5c-1.5 2.1-3.9 3.3-6.5 3.3s-5-1.2-6.5-3.3l-20-27.5c-25.4-34.9-68.3-53.2-111.2-47.6C60.1 65.3 16 114.9 16 173.5c0 30.3 11.8 59.4 32.9 81.2L248 460.4c2.2 2.3 5.2 3.6 8.4 3.6s6.2-1.3 8.4-3.6l11-11.4c2.6 4.9 5.4 9.7 8.4 14.4l-7.8 8.1c-5.2 5.4-12.4 8.5-19.9 8.5c-7.5 0-14.7-3-19.9-8.4L37.4 265.8C13.4 241.1 0 208 0 173.5C0 106.8 50.2 50.4 116.3 41.8c48.6-6.3 97.4 14.3 126.2 54L256 114.4l13.5-18.6c28.9-39.7 77.6-60.4 126.2-54c66.1 8.6 116.3 65 116.3 131.8c0 12-1.6 23.9-4.8 35.3c-4.9-2.3-9.8-4.4-14.9-6.2c2.4-9.4 3.7-19.2 3.7-29C496 115 451.9 65.3 393.6 57.7zM432 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm36.5 57.4c3 2 4.3 5.8 3.1 9.2L453.8 344H512c3.3 0 6.3 2.1 7.5 5.2s.2 6.7-2.3 8.8l-112 96c-2.7 2.3-6.7 2.6-9.7 .6s-4.3-5.8-3.1-9.2L410.2 392H352c-3.3 0-6.3-2.1-7.5-5.2s-.2-6.7 2.3-8.9l112-96c2.7-2.3 6.7-2.6 9.7-.6zM373.6 376h47.7c2.6 0 5 1.2 6.5 3.3s1.9 4.8 1.1 7.2l-12.2 36.6L490.4 360H442.7c-2.6 0-5-1.2-6.5-3.3s-1.9-4.8-1.1-7.2l12.2-36.6L373.6 376z'
      
    ]
  };

  

  
  

  var faIceCream = {
    prefix: 'fat',
    iconName: 'ice-cream',
    icon: [
      448,
      512,
      [127848],
      'f810',
      
      'M224 0C135.6 0 64 71.6 64 160c0 5.6 .3 11 .8 16.5C37.3 180 16 203.5 16 232c0 30.9 25.1 56 56 56h58.7H317.3 376c30.9 0 56-25.1 56-56c0-28.5-21.3-52-48.8-55.5c.6-5.4 .8-10.9 .8-16.5C384 71.6 312.4 0 224 0zM80 160C80 80.5 144.5 16 224 16s144 64.5 144 144c0 7.7-.6 15.3-1.8 22.7c-.4 2.3 .3 4.7 1.8 6.4s3.7 2.8 6.1 2.8H376c22.1 0 40 17.9 40 40s-17.9 40-40 40H317.3 130.7 72c-22.1 0-40-17.9-40-40s17.9-40 40-40h1.9c2.3 0 4.6-1 6.1-2.8s2.2-4.1 1.8-6.4c-1.2-7.4-1.8-15-1.8-22.7zM200.1 498.1c4.9 8.6 14 13.9 23.9 13.9s19-5.3 23.9-13.9L349.7 320H331.3L234 490.2c-2.1 3.6-5.9 5.8-10 5.8s-8-2.2-10-5.8L116.7 320H98.3L200.1 498.1z'
      
    ]
  };

  

  
  

  var faScrubber = {
    prefix: 'fat',
    iconName: 'scrubber',
    icon: [
      512,
      512,
      [],
      'f2f8',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-144 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z'
      
    ]
  };

  

  
  

  var faDrum = {
    prefix: 'fat',
    iconName: 'drum',
    icon: [
      512,
      512,
      [129345],
      'f569',
      
      'M508.3 46.7c3.7-2.4 4.8-7.4 2.4-11.1s-7.4-4.8-11.1-2.4l-114.4 74C347.4 99.6 303.2 96 256 96C114.6 96 0 128 0 208V368c0 32 28.6 60 75 80c5.8 2.5 12 4.9 18.3 7.2C137.5 470.8 194.2 480 256 480s118.5-9.2 162.7-24.8c6.4-2.3 12.5-4.6 18.4-7.2c46.3-20 75-48 75-80V208c0-48.1-41.4-78.8-105-95.7L508.3 46.7zM365.7 120L227.7 209.3c-3.7 2.4-4.8 7.4-2.4 11.1s7.4 4.8 11.1 2.4l152.1-98.4c15.6 3.4 30 7.6 42.8 12.6C475 153.9 496 177.8 496 208c0 21.6-20 45.7-65.3 65.3C386.8 292.2 325.1 304 256 304s-130.8-11.8-174.7-30.7C36 253.7 16 229.6 16 208c0-30.2 21-54.1 64.8-71.1C124.4 120 186.1 112 256 112c39.8 0 77 2.6 109.7 8zM424 293.2c32-12 56.9-27.4 72-45.3V368c0 21.6-20 45.8-65.3 65.3c-2.2 .9-4.4 1.9-6.7 2.8V293.2zM264 319.9c53.8-.7 103.5-8.4 144-21.2V441.9c-39.5 13.2-89.3 21.3-144 22v-144zM104 298.8c40.5 12.8 90.2 20.5 144 21.2v144c-54.7-.7-104.5-8.8-144-22V298.8zM16 247.9c15.1 17.9 40 33.3 72 45.3V436.1c-2.3-.9-4.5-1.8-6.7-2.8C36 413.8 16 389.6 16 368V247.9z'
      
    ]
  };

  

  
  

  var faKite = {
    prefix: 'fat',
    iconName: 'kite',
    icon: [
      640,
      512,
      [129665],
      'f6f4',
      
      'M361.7 16c-4.3 0-8.5 .7-12.4 2L480 148.7 606.1 22.6C599.7 18.4 592.2 16 584 16H361.7zm-39 31.3L248.7 380l220-220L334.9 26.2c-6 5.4-10.5 12.7-12.3 21.1zm-81 364.5l-2.7 .6-87.3 87.3c-7.9 7.9-18.5 12.3-29.7 12.3C98.8 512 80 493.2 80 470.1V318.1L12.1 358.9c-2.5 1.5-5.5 1.5-8.1 .1s-4.1-4.1-4.1-7V256c0-2.9 1.6-5.5 4.1-7s5.6-1.4 8.1 .1L80 289.9V216c0-30.9-25.1-56-56-56H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H24c39.8 0 72 32.2 72 72v73.9l67.9-40.7c2.5-1.5 5.5-1.5 8.1-.1s4.1 4.1 4.1 7v96c0 2.9-1.6 5.5-4.1 7s-5.6 1.4-8.1-.1L96 318.1V470.1c0 14.3 11.6 25.9 25.9 25.9c6.9 0 13.5-2.7 18.3-7.6l87.3-87.3 .6-2.7L307 43.9C312.7 18.2 335.4 0 361.7 0H584c30.9 0 56 25.1 56 56V278.3c0 26.2-18.2 49-43.9 54.7L241.6 411.8zM480 171.3l-220 220 332.7-73.9c8.4-1.9 15.7-6.3 21.1-12.3L480 171.3zm144 107V56c0-8.2-2.4-15.7-6.6-22.1L491.3 160 622 290.7c1.3-3.9 2-8.1 2-12.4zM16 270.1v67.7L72.5 304 16 270.1zm144 67.7V270.1L103.5 304 160 337.9z'
      
    ]
  };

  

  
  

  var faRectangleTerminal = {
    prefix: 'fat',
    iconName: 'rectangle-terminal',
    icon: [
      512,
      512,
      [],
      'e236',
      
      'M448 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H448zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM97.9 154.8c-2.9 3.4-2.5 8.4 .9 11.3L203.7 256 98.8 345.9c-3.4 2.9-3.7 7.9-.9 11.3s7.9 3.7 11.3 .9l112-96c1.8-1.5 2.8-3.7 2.8-6.1s-1-4.6-2.8-6.1l-112-96c-3.4-2.9-8.4-2.5-11.3 .9zM200 368c-4.4 0-8 3.6-8 8s3.6 8 8 8H408c4.4 0 8-3.6 8-8s-3.6-8-8-8H200z'
      
    ]
  };

  

  
  

  var faAngle90 = {
    prefix: 'fat',
    iconName: 'angle-90',
    icon: [
      448,
      512,
      [],
      'e08d',
      
      'M16 40c0-4.4-3.6-8-8-8s-8 3.6-8 8V472c0 4.4 3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H16V40zM183.8 154c-34.2-15.7-72-24.8-111.8-25.9c-4.4-.1-8 3.5-8 7.9s3.6 8 8 8.1c37.3 1.1 72.7 9.7 104.8 24.3c3.8 1.7 8.2 .4 10.4-3.1c2.5-4 1-9.3-3.3-11.3zM288.4 262.2c2.5 3.6 7.3 4.7 11 2.4c3.8-2.4 5-7.4 2.4-11.1c-20.2-29.6-45.8-55.2-75.4-75.4c-3.7-2.5-8.7-1.4-11.1 2.4c-2.3 3.7-1.2 8.6 2.4 11c27.7 19 51.6 43 70.6 70.6zm23.2 41c14.6 32.1 23.2 67.5 24.3 104.8c.1 4.4 3.7 8 8.1 8s8-3.6 7.9-8c-1.1-39.8-10.3-77.6-25.9-111.8c-2-4.3-7.3-5.8-11.3-3.3c-3.5 2.2-4.8 6.6-3.1 10.4z'
      
    ]
  };

  

  
  

  var faPersonWalkingWithCane = {
    prefix: 'fat',
    iconName: 'person-walking-with-cane',
    icon: [
      512,
      512,
      ["blind"],
      'f29d',
      
      'M131.7 216c-7.2-1.7-14.7 1.8-18 8.4L78.3 295.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5L96 188.2c13.6-27.1 41.3-44.2 71.6-44.2H192c25.2 0 48.9 11.9 64 32l76.8 102.4c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2l-70.4-93.9c-4.1-5.5-11.3-7.8-17.9-5.6s-10.9 8.3-10.9 15.2v93.4c0 4.2 1.7 8.3 4.7 11.3L262.6 368c6 6 9.4 14.1 9.4 22.6V480c0 8.8-7.2 16-16 16s-16-7.2-16-16V397.3c0-4.2-1.7-8.3-4.7-11.3l-77.3-77.3c-9-9-14.1-21.2-14.1-33.9V231.6c0-7.4-5.1-13.9-12.3-15.6zM176 16a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 218.7l54.4 72.5c10.6 14.1 30.7 17 44.8 6.4s17-30.7 6.4-44.8L268.8 166.4C250.7 142.2 222.2 128 192 128H167.6c-36.4 0-69.6 20.5-85.9 53.1L35.4 273.7c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3L112 263.6l16-32v35.8 7.4c0 17 6.7 33.3 18.7 45.3L224 397.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V390.6c0-12.7-5.1-24.9-14.1-33.9L224 306.7V240 213.3l16 21.3zM224 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM128.3 346.8L97 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l22-88.2-13.2-13.2-24.4 97.5c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4l29-116.1-13.2-13.2zM465.5 508.6c2.5 3.6 7.5 4.5 11.1 1.9s4.5-7.5 1.9-11.1L363.1 335.3c-1.5 1.4-3 2.6-4.7 3.9c-2.7 2-5.5 3.8-8.4 5.3L465.5 508.6z'
      
    ]
  };

  
    var faBlind = faPersonWalkingWithCane;
  

  
  

  var faTransporterEmpty = {
    prefix: 'fat',
    iconName: 'transporter-empty',
    icon: [
      512,
      512,
      [],
      'e046',
      
      'M144 464c-17.7 0-32 14.3-32 32v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-26.5 21.5-48 48-48H368c26.5 0 48 21.5 48 48v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-17.7-14.3-32-32-32H144z'
      
    ]
  };

  

  
  

  var faHotdog = {
    prefix: 'fat',
    iconName: 'hotdog',
    icon: [
      512,
      512,
      [127789],
      'f80f',
      
      'M474.9 138.9l-336 336c-28.1 28.1-73.7 28.1-101.8 0S9 401.2 37.1 373.1l336-336C401.2 9 446.8 9 474.9 37.1s28.1 73.7 0 101.8zm11.3 11.3c34.4-34.4 34.4-90.1 0-124.5s-90.1-34.4-124.5 0l-336 336c-34.4 34.4-34.4 90.1 0 124.5s90.1 34.4 124.5 0l336-336zm-80.6-27.9c-3.1-3.1-8.2-3.1-11.3 0c-7.5 7.5-13.7 11.8-19 14.5s-10.1 4.1-15.3 5.3l-1.5 .4c-4.8 1.2-10.2 2.5-15.9 5.1c-6.5 2.9-13.1 7.4-20.4 14.6c-14.8 14.8-18.6 27.7-22 39.4l0 0c-3.2 11-6.1 20.7-18 32.6c-6.1 6.1-10.9 9.1-14.9 10.8c-4.1 1.7-7.8 2.3-12.5 3l-.2 0c-4.6 .6-10.1 1.4-16.2 4c-6.3 2.6-12.8 7-20.1 14.2c-14.8 14.8-18.6 27.7-22 39.4l0 0c-3.2 11-6.1 20.7-18 32.6c-6.1 6.1-11.1 9.3-15.7 11.4c-4.3 2-8.3 3-13.2 4.2l0 0-1.4 .3c-5.5 1.4-11.7 3-18.7 6.6s-14.5 9-23 17.5c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0c7.5-7.5 13.7-11.8 19-14.5s10.1-4.1 15.3-5.3l1.5-.4c4.8-1.2 10.2-2.5 15.9-5.1c6.5-2.9 13.1-7.4 20.4-14.6c14.8-14.8 18.6-27.7 22-39.4l0 0c3.2-11 6.1-20.7 18-32.6c6.1-6.1 10.9-9.1 14.9-10.8c4.1-1.7 7.8-2.3 12.5-3l.2 0c4.6-.7 10.1-1.4 16.2-4c6.3-2.6 12.8-7 20.1-14.2c14.8-14.8 18.6-27.7 22-39.4l0 0c3.2-11 6.1-20.7 18-32.6c6.1-6.1 11.1-9.3 15.7-11.4c4.3-2 8.3-3 13.2-4.2l1.4-.3c5.5-1.4 11.7-3 18.7-6.6c7-3.6 14.5-9 23-17.5c3.1-3.1 3.1-8.2 0-11.3zM305 17C294.1 6.1 279.4 0 264 0s-30.1 6.1-41 17L17 223C6.1 233.9 0 248.6 0 264s6.1 30.1 17 41l7.3 7.3L35.6 301l-7.3-7.3C20.4 285.8 16 275.1 16 264s4.4-21.8 12.3-29.7L17.1 223.2l11.2 11.2L234.3 28.3C242.2 20.4 252.9 16 264 16s21.8 4.4 29.7 12.3l7.3 7.3 11.3-11.3L305 17zM199.7 487.7L207 495c10.9 10.9 25.6 17 41 17s30.1-6.1 41-17L495 289c10.9-10.9 17-25.6 17-41s-6.1-30.1-17-41l-7.4-7.3L476.4 211l7.3 7.3c7.9 7.9 12.3 18.5 12.3 29.7s-4.4 21.8-12.3 29.7L277.7 483.7c-7.9 7.9-18.5 12.3-29.7 12.3s-21.8-4.4-29.7-12.3l-7.3-7.3-11.3 11.3z'
      
    ]
  };

  

  
  

  var faEarMuffs = {
    prefix: 'fat',
    iconName: 'ear-muffs',
    icon: [
      640,
      512,
      [],
      'f795',
      
      'M320 16C219.2 16 136.6 93.6 128.6 192.3c-5.6 .5-11 1.4-16.2 2.9C119 86.3 209.4 0 320 0S521 86.3 527.6 195.2c-5.2-1.5-10.7-2.4-16.2-2.9C503.4 93.6 420.8 16 320 16zM528 229.4c2.2 1 4.2 2.2 6.2 3.5c3.2-.6 6.4-.8 9.8-.8c25.6 0 47.2 17.2 53.9 40.6C613.6 282.5 624 300 624 320c0 2.8-.2 5.5-.6 8.2C633.7 338.4 640 352.4 640 368s-6.3 29.6-16.6 39.8c.4 2.7 .6 5.4 .6 8.2c0 19.9-10.4 37.5-26.1 47.4C591.2 486.8 569.6 504 544 504c-3.3 0-6.6-.3-9.8-.9c-8.7 5.6-19.1 8.9-30.2 8.9c-30.9 0-56-25.1-56-56c0-10.2 2.7-19.8 7.5-28c-4.8-8.2-7.5-17.8-7.5-28c0-11.9 3.7-22.9 10-32c-6.3-9.1-10-20.1-10-32c0-10.2 2.7-19.8 7.5-28c-4.8-8.2-7.5-17.8-7.5-28c0-30.9 25.1-56 56-56c2.7 0 5.4 .2 8 .6c5.6 .8 11 2.5 16 4.8zm-416 0c5-2.4 10.4-4 16-4.8c2.6-.4 5.3-.6 8-.6c30.9 0 56 25.1 56 56c0 10.2-2.7 19.8-7.5 28c4.8 8.2 7.5 17.8 7.5 28c0 11.9-3.7 22.9-10 32c6.3 9.1 10 20.1 10 32c0 10.2-2.7 19.8-7.5 28c4.8 8.2 7.5 17.8 7.5 28c0 30.9-25.1 56-56 56c-11.1 0-21.5-3.2-30.2-8.9c-3.2 .6-6.4 .9-9.8 .9c-25.6 0-47.2-17.2-53.9-40.6C26.4 453.5 16 435.9 16 416c0-2.8 .2-5.5 .6-8.2C6.3 397.6 0 383.6 0 368s6.3-29.6 16.6-39.8c-.4-2.7-.6-5.4-.6-8.2c0-20 10.4-37.5 26.1-47.4C48.8 249.2 70.4 232 96 232c3.3 0 6.6 .3 9.8 .8c2-1.3 4.1-2.4 6.2-3.5zM170.7 316c-2.9-5-2.9-11.1 0-16c3.4-5.9 5.3-12.7 5.3-20c0-22.1-17.9-40-40-40c-8 0-15.4 2.3-21.6 6.3c-3.4 2.2-7.5 3-11.4 2.3c-2.3-.4-4.6-.6-7-.6c-18.3 0-33.7 12.2-38.5 29c-1.1 3.8-3.5 7-6.8 9.1C39.4 293.3 32 305.8 32 320c0 2 .1 4 .4 5.9c.7 5-1 10.1-4.6 13.7C20.5 346.8 16 356.9 16 368s4.5 21.2 11.9 28.4c3.6 3.6 5.3 8.7 4.6 13.7c-.3 1.9-.4 3.9-.4 5.9c0 14.2 7.4 26.7 18.7 33.9c3.3 2.1 5.8 5.4 6.8 9.1c4.8 16.8 20.2 29 38.5 29c2.4 0 4.7-.2 7-.6c4-.7 8 .1 11.4 2.3c6.2 4 13.6 6.3 21.6 6.3c22.1 0 40-17.9 40-40c0-7.3-1.9-14.1-5.3-20c-2.9-5-2.9-11.1 0-16c3.4-5.9 5.3-12.7 5.3-20c0-8.5-2.6-16.4-7.2-22.8c-3.8-5.5-3.8-12.8 0-18.3c4.5-6.5 7.2-14.3 7.2-22.8c0-7.3-1.9-14.1-5.3-20zM464 280c0 7.3 1.9 14.1 5.3 20c2.9 5 2.9 11.1 0 16c-3.4 5.9-5.3 12.7-5.3 20c0 8.5 2.6 16.4 7.2 22.8c3.8 5.5 3.8 12.8 0 18.3c-4.5 6.5-7.2 14.3-7.2 22.8c0 7.3 1.9 14.1 5.3 20c2.9 5 2.9 11.1 0 16c-3.4 5.9-5.3 12.7-5.3 20c0 22.1 17.9 40 40 40c8 0 15.4-2.3 21.6-6.3c3.4-2.2 7.5-3 11.4-2.3c2.3 .4 4.6 .6 7 .6c18.3 0 33.7-12.2 38.5-29c1.1-3.8 3.5-7 6.8-9.1c11.3-7.1 18.7-19.6 18.7-33.9c0-2-.1-4-.4-5.9c-.7-5 1-10.1 4.6-13.7c7.3-7.3 11.9-17.3 11.9-28.4s-4.5-21.2-11.9-28.4c-3.6-3.6-5.3-8.7-4.6-13.7c.3-1.9 .4-3.9 .4-5.9c0-14.2-7.4-26.7-18.7-33.9c-3.3-2.1-5.8-5.4-6.8-9.1c-4.8-16.8-20.2-29-38.5-29c-2.4 0-4.7 .2-7 .6c-4 .7-8-.1-11.4-2.3c-6.2-4-13.6-6.3-21.6-6.3c-22.1 0-40 17.9-40 40z'
      
    ]
  };

  

  
  

  var faRouteInterstate = {
    prefix: 'fat',
    iconName: 'route-interstate',
    icon: [
      512,
      512,
      [],
      'f61b',
      
      'M256.1 17.2c.1 0 .2 0 .2 0C338.6 61 422 71.1 480.4 44.8c.2-.1 .5-.1 .7 0c.1 0 .1 .1 .2 .1l0 0c4 41 5.7 79.3 4.4 115H256 25.9c-1-35.9 .8-74.2 4.8-115l0 0c0 0 .1-.1 .2-.1c.3-.1 .6-.1 .8 0c59 26.2 148.7 16.3 224.4-27.6zM26.5 176H484.9c-3.2 51.4-13.1 97.3-31.7 138.5C420.2 387.6 359 447 255.8 495.3l0 0c-105-44.1-166-103.3-198.5-177.4C38.8 275.7 29.3 228.5 26.5 176zM263.8 3.1c-5-2.6-10.9-2.5-15.8 .3C175.4 45.6 91.1 53.8 38.2 30.2c-9.7-4.3-22.2 1.5-23.4 13.2C4.1 152.1 8.2 246 42.6 324.2c34.5 78.6 99.1 140.4 207 185.8c4.1 1.7 8.9 1.6 13-.3c105.7-49.4 170.2-111.2 205.2-188.7c34.9-77.2 40-169 29.4-277.6c-1.1-11.7-13.6-17.6-23.4-13.2c-52.1 23.5-130.1 15.4-210-27.1z'
      
    ]
  };

  

  
  

  var faBroccoli = {
    prefix: 'fat',
    iconName: 'broccoli',
    icon: [
      512,
      512,
      [129382],
      'e3e2',
      
      'M256 0c-37.8 0-70.4 21.8-86.1 53.5C160.6 49.9 150.5 48 140 48c-46.4 0-84 37.6-84 84c0 12 2.5 23.4 7.1 33.8C26.3 179.2 0 214.5 0 256c0 53 43 96 96 96h8s47.7 54.5 80.2 138.3c5 12.8 17.1 21.7 30.9 21.7h81.9c13.8 0 25.9-8.9 30.9-21.7C360.3 406.5 408 352 408 352h8c53 0 96-43 96-96c0-41.5-26.3-76.8-63.1-90.2c4.6-10.3 7.1-21.8 7.1-33.8c0-46.4-37.6-84-84-84c-10.5 0-20.6 1.9-29.9 5.5C326.4 21.8 293.8 0 256 0zM387.4 352l0 0c-5.2 6.7-12.4 16.4-20.6 28.9c-16.4 24.8-37.1 60.4-53.9 103.6c-2.8 7.1-9.3 11.5-16 11.5H215.1c-6.7 0-13.2-4.4-16-11.5c-16.8-43.2-37.4-78.8-53.9-103.6c-8.2-12.4-15.4-22.2-20.6-28.9l0 0h88.6l28 69.9c2.4 6.1 8.3 10.1 14.9 10.1s12.4-4 14.9-10.1l28-69.9h88.6zm-157 0h51.2l-17 42.5L256 416l-8.6-21.5-17-42.5zm-49-285.1C193.1 37.1 222.1 16 256 16s62.9 21.1 74.6 50.9c.8 2.1 2.5 3.8 4.6 4.6s4.4 .7 6.5-.3c9.1-4.6 19.5-7.2 30.4-7.2c37.6 0 68 30.4 68 68c0 12.6-3.4 24.4-9.4 34.6c-1.3 2.2-1.5 4.8-.5 7.2s3 4.1 5.4 4.7c34.8 8.7 60.5 40.2 60.5 77.6c0 44.2-35.8 80-80 80H96c-44.2 0-80-35.8-80-80c0-37.4 25.7-68.9 60.5-77.6c2.4-.6 4.5-2.3 5.4-4.7s.8-5-.5-7.2c-6-10.1-9.4-21.9-9.4-34.6c0-37.6 30.4-68 68-68c10.9 0 21.3 2.6 30.4 7.2c2 1 4.4 1.1 6.5 .3s3.8-2.5 4.6-4.6z'
      
    ]
  };

  

  
  

  var faFaceSmilingHands = {
    prefix: 'fat',
    iconName: 'face-smiling-hands',
    icon: [
      640,
      512,
      [],
      'e396',
      
      'M320 16c116.6 0 213.9 83.2 235.5 193.5c.9 4.3 5.1 7.2 9.4 6.3s7.2-5.1 6.3-9.4C548.1 88.8 444.4 0 320 0S91.9 88.8 68.8 206.5c-.9 4.3 2 8.5 6.3 9.4s8.5-2 9.4-6.3C106.1 99.2 203.4 16 320 16zM249.5 494c-1.1 4.3 1.4 8.6 5.7 9.8c20.7 5.4 42.4 8.3 64.7 8.3s44.1-2.9 64.7-8.3c4.3-1.1 6.8-5.5 5.7-9.8s-5.5-6.8-9.8-5.7c-19.4 5-39.7 7.7-60.7 7.7s-41.3-2.7-60.7-7.7c-4.3-1.1-8.6 1.4-9.8 5.7zM256 364.5V314.4c0-19.9-16.1-36-36-36s-36 16.1-36 36v.3l-65.4-65.4c-12.5-12.5-32.8-12.5-45.3 0c-3.5 3.5-6 7.6-7.6 12c-12.4-8.3-29.4-7-40.4 4s-12.3 28-4 40.4c-4.4 1.5-8.5 4.1-12 7.6c-12.5 12.5-12.5 32.8 0 45.3L20.8 370c-4.2 1.6-8.1 4-11.4 7.3c-12.5 12.5-12.5 32.8 0 45.3l56.8 56.8C87 500.3 115.3 512 144.8 512C206.2 512 256 462.2 256 400.8V383.2c18.1 10.1 39.4 16.8 64 16.8s45.9-6.6 64-16.8v17.6C384 462.2 433.8 512 495.2 512c29.5 0 57.8-11.7 78.6-32.6l56.8-56.8c12.5-12.5 12.5-32.8 0-45.3c-3.3-3.3-7.2-5.8-11.4-7.3l11.4-11.4c12.5-12.5 12.5-32.8 0-45.3c-3.5-3.5-7.6-6-12-7.6c8.3-12.4 7-29.4-4-40.4s-28-12.3-40.4-4c-1.5-4.4-4.1-8.5-7.6-12c-12.5-12.5-32.8-12.5-45.3 0L456 314.7v-.3c0-19.9-16.1-36-36-36s-36 16.1-36 36v50.1c-17.7 11.6-39 19.5-64 19.5s-46.3-7.9-64-19.5zm-56.3-139c2.5-13.5 7.8-28.4 15.2-39.8c7.6-11.6 16.1-17.7 24.9-17.7s17.3 6.1 24.9 17.7c7.4 11.4 12.7 26.3 15.2 39.8c.8 4.3 5 7.2 9.3 6.4s7.2-5 6.4-9.3c-2.8-15-8.7-32-17.6-45.6c-8.7-13.3-21.5-25-38.3-25s-29.6 11.7-38.3 25c-8.8 13.5-14.8 30.6-17.6 45.6c-.8 4.3 2 8.5 6.4 9.3s8.5-2 9.3-6.4zm175.2-39.8c7.6-11.6 16.1-17.7 24.9-17.7s17.3 6.1 24.9 17.7c7.4 11.4 12.7 26.3 15.2 39.8c.8 4.3 5 7.2 9.3 6.4s7.2-5 6.4-9.3c-2.8-15-8.7-32-17.6-45.6c-8.7-13.3-21.5-25-38.3-25s-29.6 11.7-38.3 25c-8.8 13.5-14.8 30.6-17.6 45.6c-.8 4.3 2 8.5 6.4 9.3s8.5-2 9.3-6.4c2.5-13.5 7.8-28.4 15.2-39.8zm-253 153.6l4.7 4.7c2.6 2.6 6.8 2.6 9.4 0s2.6-6.8 0-9.4l-4.7-4.7L84.7 283.3c-2.3-2.3-3.8-5.2-4.4-8.3c-1-5 .5-10.4 4.4-14.3c6.2-6.2 16.4-6.2 22.6 0l79 79c5 5 13.7 1.5 13.7-5.7V314.4c0-11 9-20 20-20s20 9 20 20V368v32.8c0 52.6-42.6 95.2-95.2 95.2c-25.2 0-49.5-10-67.3-27.9L20.7 411.3c-6.2-6.2-6.2-16.4 0-22.6c3.9-3.9 9.3-5.4 14.3-4.4c3 .6 5.9 2 8.3 4.4l14.6 14.6 4.7 4.7c2.6 2.6 6.8 2.6 9.4 0s2.6-6.8 0-9.4l-4.7-4.7L52.7 379.3l-9.2-9.2L20.7 347.3c-6.2-6.2-6.2-16.4 0-22.6c3.9-3.9 9.3-5.4 14.3-4.4c3 .6 5.9 2 8.3 4.4l46.6 46.6 4.7 4.7c2.6 2.6 6.8 2.6 9.4 0s2.6-6.8 0-9.4l-4.7-4.7L52.7 315.3l-9.2-9.2-6.8-6.8c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l6.8 6.8 9.2 9.2 46.6 46.6zm396.1 0l46.6-46.6 9.2-9.2 6.8-6.8c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-6.8 6.8-9.2 9.2-46.6 46.6-4.7 4.7c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l4.7-4.7 46.6-46.6c2.3-2.3 5.2-3.8 8.3-4.4c5-1 10.4 .5 14.3 4.4c6.2 6.2 6.2 16.4 0 22.6l-22.8 22.8-9.2 9.2-14.6 14.6-4.7 4.7c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l4.7-4.7 14.6-14.6c2.3-2.3 5.2-3.8 8.3-4.4c5-1 10.4 .5 14.3 4.4c6.2 6.2 6.2 16.4 0 22.6l-56.8 56.8C544.7 486 520.4 496 495.2 496c-52.6 0-95.2-42.6-95.2-95.2V368 314.4c0-11 9-20 20-20s20 9 20 20v19.7c0 7.1 8.6 10.7 13.7 5.7l79-79c6.2-6.2 16.4-6.2 22.6 0c3.9 3.9 5.4 9.3 4.4 14.3c-.6 3-2 5.9-4.4 8.3l-46.6 46.6-4.7 4.7c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l4.7-4.7z'
      
    ]
  };

  

  
  

  var faOilCanDrip = {
    prefix: 'fat',
    iconName: 'oil-can-drip',
    icon: [
      640,
      512,
      [],
      'e205',
      
      'M352 72c0 4.4-3.6 8-8 8H264v80H368.9c9.9 0 19.7 2.3 28.6 6.8L448 192l167-35.8c18.1-3.9 30.7 17.6 18.4 31.5L451.1 394.3c-12.1 13.8-29.6 21.7-48 21.7H144c-26.5 0-48-21.5-48-48V345.1L29.1 316.5C11.4 308.9 0 291.6 0 272.3V208c0-26.5 21.5-48 48-48H96h16H248V80H168c-4.4 0-8-3.6-8-8s3.6-8 8-8H344c4.4 0 8 3.6 8 8zm99.4 135.6c-3.6 .8-7.3 .3-10.5-1.3l-50.5-25.2c-6.7-3.3-14-5.1-21.5-5.1H112V334.6 352v16c0 17.7 14.3 32 32 32H403.1c13.8 0 26.9-5.9 36-16.2L621.5 177.1c.7-.8 .8-1.4 .9-1.8c0-.5-.1-1.2-.5-1.9s-1-1.2-1.4-1.4c-.4-.2-.9-.4-2-.1l-167 35.8zM96 176H48c-17.7 0-32 14.3-32 32v64.3c0 12.8 7.6 24.4 19.4 29.4l60.6 26V176zM624 400c0-6.8-3.8-19.7-10.8-36.2c-6.4-15-14.4-30.7-21.2-43.3c-6.8 12.6-14.8 28.3-21.2 43.3c-7 16.5-10.8 29.3-10.8 36.2c0 17.7 14.3 32 32 32c10.1 0 18-3 23.1-7.8c4.9-4.5 8.9-12 8.9-24.2zm16 0c0 32-21.5 48-48 48s-48-21.5-48-48c0-21 20.6-62.6 34.9-88.8c5.8-10.6 20.5-10.6 26.3 0C619.4 337.4 640 379 640 400z'
      
    ]
  };

  

  
  

  var faObjectsAlignLeft = {
    prefix: 'fat',
    iconName: 'objects-align-left',
    icon: [
      512,
      512,
      [],
      'e3be',
      
      'M0 8C0 3.6 3.6 0 8 0s8 3.6 8 8l0 496c0 4.4-3.6 8-8 8s-8-3.6-8-8L0 8zM112 176c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L144 80c-17.7 0-32 14.3-32 32l0 64zM96 112c0-26.5 21.5-48 48-48l320 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-320 0c-26.5 0-48-21.5-48-48l0-64zm16 288c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-192 0c-17.7 0-32 14.3-32 32l0 64zM96 336c0-26.5 21.5-48 48-48l192 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-192 0c-26.5 0-48-21.5-48-48l0-64z'
      
    ]
  };

  

  
  

  var faDharmachakra = {
    prefix: 'fat',
    iconName: 'dharmachakra',
    icon: [
      512,
      512,
      [9784],
      'f655',
      
      'M256 0c4.4 0 8 3.6 8 8V48.2c51.4 1.9 98 22.5 133.3 55.2L425.7 75c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-28.4 28.4c32.7 35.3 53.3 81.9 55.2 133.3H504c4.4 0 8 3.6 8 8s-3.6 8-8 8H463.8c-1.9 51.4-22.5 98-55.2 133.3L437 425.7c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-28.4-28.4C362 441.3 315.4 461.9 264 463.8V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V463.8c-51.4-1.9-98-22.5-133.3-55.2L86.3 437c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l28.4-28.4C70.7 362 50.1 315.4 48.2 264H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H48.2c1.9-51.4 22.5-98 55.2-133.3L75 86.3c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l28.4 28.4C150 70.7 196.6 50.1 248 48.2V8c0-4.4 3.6-8 8-8zM114.7 126c-29.8 32.4-48.6 75-50.5 122h96.2c1.7-20.5 9.8-39.2 22.4-54l-68-68zM194 182.7c14.8-12.5 33.5-20.7 54-22.4V64.2c-47 1.9-89.6 20.7-122 50.5l68 68zm5.4 16.7C185 213.9 176 233.9 176 256s9 42.1 23.4 56.6S233.9 336 256 336c22.1 0 42.1-8.9 56.5-23.4c0 0 0 0 .1-.1C327.1 298.1 336 278.1 336 256s-8.9-42.1-23.4-56.5c0 0 0 0 0 0C298.1 184.9 278.1 176 256 176c-22.1 0-42.1 9-56.6 23.4zM329.3 194c12.5 14.8 20.7 33.5 22.4 54h96.2c-1.9-47-20.7-89.6-50.5-122l-68 68zM386 114.7c-32.4-29.8-75-48.6-122-50.5v96.2c20.5 1.7 39.2 9.8 54 22.4l68-68zM318 329.3c-14.8 12.5-33.5 20.7-54 22.4v96.2c47-1.9 89.6-20.7 122-50.5l-68-68zM397.3 386c29.8-32.4 48.6-75 50.5-122H351.7c-1.7 20.5-9.8 39.2-22.4 54l68 68zM182.7 318c-12.5-14.8-20.7-33.5-22.4-54H64.2c1.9 47 20.7 89.6 50.5 122l68-68zM126 397.3c32.4 29.8 75 48.6 122 50.5V351.7c-20.5-1.7-39.2-9.8-54-22.4l-68 68z'
      
    ]
  };

  

  
  

  var faCircleUpLeft = {
    prefix: 'fat',
    iconName: 'circle-up-left',
    icon: [
      512,
      512,
      [],
      'e128',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 168c0-4.4 3.6-8 8-8H295c5 0 9 4 9 9c0 2.4-.9 4.7-2.6 6.3l-35 35c-3.1 3.1-3.1 8.2 0 11.3L348.7 304c2.1 2.1 3.3 5 3.3 8s-1.2 5.9-3.3 8L320 348.7c-2.1 2.1-5 3.3-8 3.3s-5.9-1.2-8-3.3l-82.3-82.3c-3.1-3.1-8.2-3.1-11.3 0l-35 35c-1.7 1.7-4 2.6-6.3 2.6c-5 0-9-4-9-9V168zm8-24c-13.3 0-24 10.7-24 24V295c0 13.8 11.2 25 25 25c6.6 0 13-2.6 17.7-7.3L216 283.3 292.7 360c5.1 5.1 12.1 8 19.3 8s14.2-2.9 19.3-8L360 331.3c5.1-5.1 8-12.1 8-19.3s-2.9-14.2-8-19.3L283.3 216l29.4-29.4c4.7-4.7 7.3-11 7.3-17.7c0-13.8-11.2-25-25-25H168z'
      
    ]
  };

  

  
  

  var faCloudHailMixed = {
    prefix: 'fat',
    iconName: 'cloud-hail-mixed',
    icon: [
      512,
      512,
      [],
      'f73a',
      
      'M398.7 124.8c.8-4.1 1.3-8.4 1.3-12.8c0-35.3-28.7-64-64-64c-19.5 0-36.9 8.7-48.6 22.4c-3.5 4-8.7 6.1-13.9 5.5s-9.9-3.8-12.4-8.5C245 36.8 212.9 16 176 16c-53 0-96 43-96 96c0 6.1 .6 12.1 1.7 17.9c1.5 7.9-3.1 15.6-10.7 18.1C39 158.5 16 188.6 16 224c0 44.2 35.8 80 80 80H416c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.4 0-.9 0-1.3 0c-4.8 .1-9.5-2-12.6-5.8s-4.3-8.7-3.4-13.4zM176 0c37.1 0 70 18.1 90.4 45.9c3.3 4.5 6.2 9.2 8.8 14.1c3.6-4.2 7.6-8 12-11.4C300.7 38.2 317.6 32 336 32c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c4.9 0 9.8 .4 14.5 1.1c46.2 7 81.5 46.8 81.5 94.9c0 53-43 96-96 96H96c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0zM16 480a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm192-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm144 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM188.2 369.2c3.7 2.3 4.9 7.3 2.5 11l-80 128c-2.3 3.7-7.3 4.9-11 2.5s-4.9-7.3-2.5-11l80-128c2.3-3.7 7.3-4.9 11-2.5zm192 0c3.7 2.3 4.9 7.3 2.5 11l-80 128c-2.3 3.7-7.3 4.9-11 2.5s-4.9-7.3-2.5-11l80-128c2.3-3.7 7.3-4.9 11-2.5zm-285.5 11l-24 38.4c-2.3 3.7-7.3 4.9-11 2.5s-4.9-7.3-2.5-11l24-38.4c2.3-3.7 7.3-4.9 11-2.5s4.9 7.3 2.5 11zm192 0l-24 38.4c-2.3 3.7-7.3 4.9-11 2.5s-4.9-7.3-2.5-11l24-38.4c2.3-3.7 7.3-4.9 11-2.5s4.9 7.3 2.5 11zm192 0l-24 38.4c-2.3 3.7-7.3 4.9-11 2.5s-4.9-7.3-2.5-11l24-38.4c2.3-3.7 7.3-4.9 11-2.5s4.9 7.3 2.5 11z'
      
    ]
  };

  

  
  

  var faDiagramSankey = {
    prefix: 'fat',
    iconName: 'diagram-sankey',
    icon: [
      576,
      512,
      [],
      'e158',
      
      'M355 48c-8.8 0-16.9 4.8-21.1 12.5L256.1 203.2C249.1 216 235.6 224 221 224H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H221c8.8 0 16.9-4.8 21.1-12.5L319.9 52.8C326.9 40 340.4 32 355 32H568c4.4 0 8 3.6 8 8s-3.6 8-8 8H355zM174.6 304l94.7 148.9c4.4 6.9 12 11.1 20.2 11.1H568c4.4 0 8 3.6 8 8s-3.6 8-8 8H289.6c-13.7 0-26.4-7-33.7-18.5L155.6 304H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H568c4.4 0 8 3.6 8 8s-3.6 8-8 8H174.6z'
      
    ]
  };

  

  
  

  var faBarsStaggered = {
    prefix: 'fat',
    iconName: 'bars-staggered',
    icon: [
      512,
      512,
      ["reorder","stream"],
      'f550',
      
      'M0 88c0-4.4 3.6-8 8-8H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8zM64 248c0-4.4 3.6-8 8-8H504c4.4 0 8 3.6 8 8s-3.6 8-8 8H72c-4.4 0-8-3.6-8-8zM448 408c0 4.4-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H440c4.4 0 8 3.6 8 8z'
      
    ]
  };

  
    var faReorder = faBarsStaggered;
  
    var faStream = faBarsStaggered;
  

  
  

  var faUserBountyHunter = {
    prefix: 'fat',
    iconName: 'user-bounty-hunter',
    icon: [
      448,
      512,
      [],
      'e2bf',
      
      'M72 0c-4.4 0-8 3.6-8 8V254c0 3.9 .6 7.7 1.6 11.2c1.3 13.8 11.4 25.5 25.3 28.4l117.3 24.7c4.9 1 9.9 1.6 15 1.6l.9 .2 .9-.2c5-.1 10-.6 15-1.6l117.3-24.7c15.5-3.3 26.2-17.3 25.4-33.1l-.2-3c.1-1.8 .2-3.7 .1-5.6L376 143.1C372.9 90.8 343.5 45.9 301.2 21C278.5 7.6 252.1 0 224 0C157.7 0 100.6 42.6 80 102.6V16H96c4.4 0 8-3.6 8-8s-3.6-8-8-8H72zm28.6 277.8c-10.2-2.2-17.7-10.6-18.9-20.6l4.3-78.1c5.3 2.5 12.6 6.6 20.4 12.8c15.6 12.3 33.3 32.8 41.2 66c1 4.3 5.3 6.9 9.6 5.9s6.9-5.3 5.9-9.6c-8.9-37.3-29-60.7-46.9-74.8c-8.9-7-17.3-11.7-23.5-14.7c-2.3-1.1-4.2-1.9-5.9-2.6l.4-7.8L192 182.1V297.1l-91.4-19.2 0 0zM208 300.5V176c0-3.6-2.4-6.8-5.9-7.7L88.5 138c.4-3.4 .8-6.7 1.4-10H96 224 352h6.1c.6 3.3 1.1 6.6 1.4 10L245.9 168.3c-3.5 .9-5.9 4.1-5.9 7.7V300.5l-16 3.4-16-3.4zm-50.7-267C177.1 22.3 199.8 16 224 16c61 0 113 40.1 130.2 96H352 224 96 93.8c10.4-33.7 33.4-61.7 63.5-78.6zM256 297.1V182.1l104.5-27.9 .3 6.2-.6 .2c-.5 .2-1.3 .4-2.2 .8c-1.8 .7-4.4 1.7-7.5 3.2c-6.2 3-14.6 7.7-23.5 14.7c-17.9 14.1-38 37.6-46.9 74.8c-1 4.3 1.6 8.6 5.9 9.6s8.6-1.6 9.6-5.9c7.9-33.1 25.6-53.7 41.2-66c7.8-6.2 15.2-10.3 20.5-12.8c1.6-.8 3.1-1.4 4.3-1.9l4.4 80.1c-1.2 10-8.7 18.5-18.9 20.6L256 297.1zM134.4 368H313.6C379 368 432 421 432 486.4c0 5.3-4.3 9.6-9.6 9.6H315.3l-80-80c-6.2-6.2-16.4-6.2-22.6 0l-80 80H25.6c-5.3 0-9.6-4.3-9.6-9.6C16 421 69 368 134.4 368zM292.7 496H155.3L224 427.3 292.7 496zM134.4 352C60.2 352 0 412.2 0 486.4C0 500.5 11.5 512 25.6 512H422.4c14.1 0 25.6-11.5 25.6-25.6C448 412.2 387.8 352 313.6 352H134.4z'
      
    ]
  };

  

  
  

  var faChessRook = {
    prefix: 'fat',
    iconName: 'chess-rook',
    icon: [
      448,
      512,
      [9820],
      'f447',
      
      'M48 56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8V80c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8V80c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8V186.7c0 6.4-2.5 12.5-7 17l-46.6 46.6c-1.6 1.6-2.5 3.8-2.3 6.1L351.1 384h16l-6.9-124.9L404.3 215c7.5-7.5 11.7-17.7 11.7-28.3V56c0-13.3-10.7-24-24-24H344c-13.3 0-24 10.7-24 24V80c0 4.4-3.6 8-8 8H280c-4.4 0-8-3.6-8-8V56c0-13.3-10.7-24-24-24H200c-13.3 0-24 10.7-24 24V80c0 4.4-3.6 8-8 8H136c-4.4 0-8-3.6-8-8V56c0-13.3-10.7-24-24-24H56C42.7 32 32 42.7 32 56V186.7c0 10.6 4.2 20.8 11.7 28.3l44.1 44.1L80.9 384h16L104 256.4c.1-2.3-.7-4.5-2.3-6.1L55 203.7c-4.5-4.5-7-10.6-7-17V56zM184 216v64c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V216c0-22.1-17.9-40-40-40s-40 17.9-40 40zm40-24c13.3 0 24 10.7 24 24v56H200V216c0-13.3 10.7-24 24-24zM94.3 432H353.7c4.5 0 8.9 1.9 11.9 5.3l30.6 33.9c2.5 2.7 3.8 6.3 3.8 9.9c0 8.2-6.6 14.8-14.8 14.8H62.8c-8.2 0-14.8-6.6-14.8-14.8c0-3.7 1.4-7.2 3.8-9.9l30.6-33.9c3-3.4 7.4-5.3 11.9-5.3zm313.8 28.5l-30.6-33.9c-6.1-6.7-14.7-10.6-23.8-10.6H94.3c-9.1 0-17.7 3.8-23.8 10.6L39.9 460.5c-5.1 5.7-7.9 13-7.9 20.6c0 17 13.8 30.8 30.8 30.8H385.2c17 0 30.8-13.8 30.8-30.8c0-7.6-2.8-15-7.9-20.6z'
      
    ]
  };

  

  
  

  var faWineBottle = {
    prefix: 'fat',
    iconName: 'wine-bottle',
    icon: [
      512,
      512,
      [],
      'f72f',
      
      'M402.3 2.3c3.1-3.1 8.2-3.1 11.3 0l96 96c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L484.3 95.6l-83.1 83.1c-9.2 9.2-11.5 22.9-8.6 35.6c9.4 40.9-1.9 85.6-33.8 117.5L197.3 493.3c-25 25-65.5 25-90.5 0l-88-88c-25-25-25-65.5 0-90.5l11.3 11.3c-18.7 18.7-18.7 49.1 0 67.9l88 88c18.7 18.7 49.1 18.7 67.9 0l30.3-30.3L60.4 295.7 30.1 326.1 18.7 314.7 180.2 153.3c31.9-31.9 76.6-43.1 117.5-33.8c12.6 2.9 26.4 .5 35.5-8.6l83.1-83.1L402.3 13.7c-3.1-3.1-3.1-8.2 0-11.3zM71.7 284.4L227.6 440.3 328.3 339.6 172.4 183.7 71.7 284.4zm112-112L339.6 328.3l7.8-7.8c27.8-27.8 37.7-66.8 29.5-102.6c-3.8-16.5-1.1-36.4 12.9-50.4L401 156.3 355.7 111l-11.1 11.1c-14.1 14.1-34 16.7-50.4 12.9c-35.8-8.2-74.8 1.7-102.6 29.5l-7.8 7.8zM367 99.7L412.3 145 473 84.3 427.7 39 367 99.7z'
      
    ]
  };

  

  
  

  var faWhiskeyGlassIce = {
    prefix: 'fat',
    iconName: 'whiskey-glass-ice',
    icon: [
      512,
      512,
      ["glass-whiskey-rocks"],
      'f7a1',
      
      'M32 48H480c4.6 0 9.1 2 12.1 5.5s4.4 8.2 3.7 12.8l-50 342.9c-4.6 31.4-31.6 54.8-63.3 54.8h-253c-31.8 0-58.7-23.3-63.3-54.8L16.2 66.3c-.7-4.6 .7-9.3 3.7-12.8S27.4 48 32 48zm0-16c-9.3 0-18.1 4-24.2 11.1S-1 59.4 .3 68.6l50 342.9c5.7 39.3 39.4 68.5 79.2 68.5h253c39.7 0 73.4-29.1 79.2-68.5l50-342.9c1.3-9.2-1.4-18.5-7.5-25.5S489.3 32 480 32H32zM255.4 195.3l.6-.6c-5-1.8-10.4-2.7-16-2.7H144c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h73.8l-16-16H144c-17.7 0-32-14.3-32-32V240c0-17.7 14.3-32 32-32h96c.9 0 1.8 0 2.6 .1l12.8-12.8zm79.2 33.9l56.6 56.6c12.5 12.5 12.5 32.8 0 45.3l-56.6 56.6c-12.5 12.5-32.8 12.5-45.3 0l-56.6-56.6c-12.5-12.5-12.5-32.8 0-45.3l56.6-56.6c12.5-12.5 32.8-12.5 45.3 0zm-56.6-11.3l-56.6 56.6c-18.7 18.7-18.7 49.1 0 67.9L278.1 399c18.7 18.7 49.1 18.7 67.9 0l56.6-56.6c18.7-18.7 18.7-49.1 0-67.9l-56.6-56.6c-18.7-18.7-49.1-18.7-67.9 0z'
      
    ]
  };

  
    var faGlassWhiskeyRocks = faWhiskeyGlassIce;
  

  
  

  var faPollPeople = {
    prefix: 'fat',
    iconName: 'poll-people',
    icon: [
      640,
      512,
      [],
      'f759',
      
      'M112 48A32 32 0 1 0 48 48a32 32 0 1 0 64 0zM32 48a48 48 0 1 1 96 0A48 48 0 1 1 32 48zm480 0V176h80c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32H512zm-16 0H272c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H496V48zM224 80c0-26.5 21.5-48 48-48H592c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V80zM384 336V464H592c17.7 0 32-14.3 32-32V368c0-17.7-14.3-32-32-32H384zm-16 0H272c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h96V336zM224 368c0-26.5 21.5-48 48-48H592c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V368zM112 336a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM64 144c-26.5 0-48 21.5-48 48c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16c0-26.5-21.5-48-48-48H64zm0-16H96c35.3 0 64 28.7 64 64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32c0-35.3 28.7-64 64-64zM16 480c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16c0-26.5-21.5-48-48-48H64c-26.5 0-48 21.5-48 48zM0 480c0-35.3 28.7-64 64-64H96c35.3 0 64 28.7 64 64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z'
      
    ]
  };

  

  
  

  var faHospital = {
    prefix: 'fat',
    iconName: 'hospital',
    icon: [
      640,
      512,
      [62589,127973,"hospital-alt","hospital-wide"],
      'f0f8',
      
      'M160 64c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64V96H584c30.9 0 56 25.1 56 56V456c0 30.9-25.1 56-56 56H416v0H384h-8H264h-8H224v0H56c-30.9 0-56-25.1-56-56V152c0-30.9 25.1-56 56-56H160V64zm304 0c0-26.5-21.5-48-48-48H224c-26.5 0-48 21.5-48 48V96v16V496h80V416c0-35.3 28.7-64 64-64s64 28.7 64 64v80h80V336 112 96 64zm120 48H480V336 496H584c22.1 0 40-17.9 40-40V304H520c-4.4 0-8-3.6-8-8s3.6-8 8-8H624V208H520c-4.4 0-8-3.6-8-8s3.6-8 8-8H624V152c0-22.1-17.9-40-40-40zm-424 0H56c-22.1 0-40 17.9-40 40v40H120c4.4 0 8 3.6 8 8s-3.6 8-8 8H16v80H120c4.4 0 8 3.6 8 8s-3.6 8-8 8H16V456c0 22.1 17.9 40 40 40H160V112zM368 416c0-26.5-21.5-48-48-48s-48 21.5-48 48v80h96V416zM312 56h16c13.3 0 24 10.7 24 24V96h16c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H352v16c0 13.3-10.7 24-24 24H312c-13.3 0-24-10.7-24-24V160H272c-13.3 0-24-10.7-24-24V120c0-13.3 10.7-24 24-24h16V80c0-13.3 10.7-24 24-24zm-8 24v24c0 4.4-3.6 8-8 8H272c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h24c4.4 0 8 3.6 8 8v24c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V152c0-4.4 3.6-8 8-8h24c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8H344c-4.4 0-8-3.6-8-8V80c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8z'
      
    ]
  };

  
    var faHospitalAlt = faHospital;
  
    var faHospitalWide = faHospital;
  

  
  

  var faLampDesk = {
    prefix: 'fat',
    iconName: 'lamp-desk',
    icon: [
      512,
      512,
      [],
      'e014',
      
      'M381.3 80H480c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-192 192c-4.6 4.6-11.5 5.9-17.4 3.5s-9.9-8.3-9.9-14.8V189.3c0-4.2-1.7-8.3-4.7-11.3l-38.1-38.1C215.6 126.3 208 107.8 208 88.6C208 48.5 240.5 16 280.6 16c19.2 0 37.7 7.6 51.3 21.3l38.1 38.1c3 3 7.1 4.7 11.3 4.7zm0-16L343.2 25.9C326.6 9.3 304.1 0 280.6 0C231.7 0 192 39.7 192 88.6c0 23.5 9.3 46 25.9 62.6l1.8 1.8-97.4 97.4c-2 2-2.8 4.9-2.1 7.7l61.4 238H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H192 376c4.4 0 8-3.6 8-8s-3.6-8-8-8H198.2L136.9 258.4 231 164.3l25 25V288c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l192-192c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H381.3zM386 280.5c9 4.8 19.2 7.5 30 7.5c35.3 0 64-28.7 64-64c0-10.9-2.7-21.1-7.5-30l-12 12c2.2 5.6 3.5 11.6 3.5 18c0 26.5-21.5 48-48 48c-6.4 0-12.4-1.2-18-3.5l-12 12z'
      
    ]
  };

  

  
  

  var faEnvelopeOpenText = {
    prefix: 'fat',
    iconName: 'envelope-open-text',
    icon: [
      512,
      512,
      [],
      'f658',
      
      'M256 16c-8.6 0-17 2.8-24 7.9L177.9 64H334.1L280 23.9C273 18.8 264.6 16 256 16zM120 64h31l71.5-53C232.2 3.9 243.9 0 256 0s23.8 3.9 33.5 11L361 64h31c30.9 0 56 25.1 56 56v8.5l38.1 28.2c16.3 12.1 25.9 31.1 25.9 51.4V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V208.1c0-20.3 9.6-39.4 25.9-51.4L64 128.5V120c0-30.9 25.1-56 56-56zM448 214.5l-16 13.1V120c0-22.1-17.9-40-40-40H120c-22.1 0-40 17.9-40 40V227.7L64 214.5V148.4L35.4 169.5C23.2 178.6 16 192.9 16 208.1v8.4l1.6 1.3L232.7 394.5c6.6 5.4 14.8 8.3 23.3 8.3s16.7-2.9 23.3-8.3L494.4 217.8l1.6-1.3v-8.4c0-15.2-7.2-29.5-19.4-38.6L448 148.4v66.1zM16 448c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V237.2L289.4 406.9c-9.4 7.7-21.2 12-33.4 12s-24-4.2-33.4-12L16 237.2V448zM168 160H344c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 80H344c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faSquareAmpersand = {
    prefix: 'fat',
    iconName: 'square-ampersand',
    icon: [
      448,
      512,
      [],
      'e260',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 85.3c0 9.9 3.9 19.4 10.9 26.3l25 25 38.5-27.2c8.5-6 13.5-15.7 13.5-26.1V176c0-17.7-14.3-32-32-32H197.3c-20.6 0-37.3 16.7-37.3 37.3zm83.7 37.2l-36.3 25.6L278 314.7l43.7-55.6c2.7-3.5 7.8-4.1 11.2-1.3s4.1 7.8 1.3 11.2l-44.9 57.1 44.3 44.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-42.9-42.9-16.3 20.8C251 375 232.4 384 212.8 384H172.7c-33.5 0-60.7-27.2-60.7-60.7c0-19.7 9.6-38.2 25.7-49.6l45-31.7-23.1-23.1c-10-10-15.6-23.5-15.6-37.7c0-29.4 23.8-53.3 53.3-53.3H216c26.5 0 48 21.5 48 48v3.3c0 15.6-7.6 30.2-20.3 39.2zm-96.8 68.3c-11.9 8.4-18.9 22-18.9 36.5c0 24.7 20 44.7 44.7 44.7h40.1c14.7 0 28.6-6.8 37.7-18.3L268 327.4l-73.9-73.9-47.2 33.3z'
      
    ]
  };

  

  
  

  var faGaugeHigh = {
    prefix: 'fat',
    iconName: 'gauge-high',
    icon: [
      512,
      512,
      [62461,"tachometer-alt","tachometer-alt-fast"],
      'f625',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM272 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM208 352a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0c0-22.2-11.3-41.7-28.4-53.2l83.6-167.2c2-4 .4-8.8-3.6-10.7s-8.8-.4-10.7 3.6L277.2 291.6c-6.6-2.3-13.8-3.6-21.2-3.6c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64zM160 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM96 256a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm336-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  
    var faTachometerAlt = faGaugeHigh;
  
    var faTachometerAltFast = faGaugeHigh;
  

  
  

  var faSquareThisWayUp = {
    prefix: 'fat',
    iconName: 'square-this-way-up',
    icon: [
      448,
      512,
      ["box-up"],
      'f49f',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM104 384H344c4.4 0 8 3.6 8 8s-3.6 8-8 8H104c-4.4 0-8-3.6-8-8s3.6-8 8-8zm18.3-261.7c3.1-3.1 8.2-3.1 11.3 0l64 64c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L136 147.3V312c0 4.4-3.6 8-8 8s-8-3.6-8-8V147.3L69.7 197.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l64-64zm192 0c3.1-3.1 8.2-3.1 11.3 0l64 64c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L328 147.3V312c0 4.4-3.6 8-8 8s-8-3.6-8-8V147.3l-50.3 50.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l64-64z'
      
    ]
  };

  
    var faBoxUp = faSquareThisWayUp;
  

  
  

  var faSection = {
    prefix: 'fat',
    iconName: 'section',
    icon: [
      256,
      512,
      [],
      'e447',
      
      'M16.6 78.8C21 54.3 37 36.8 61.5 26.5c24.8-10.4 58.2-13.3 95.6-7.5c11.6 1.8 47.2 8.6 58.8 11.6c4.3 1.1 8.6-1.4 9.8-5.7s-1.4-8.6-5.7-9.8c-12.4-3.2-48.5-10.1-60.4-11.9c-39.3-6-75.8-3.3-104.2 8.6C26.7 23.7 6.3 45.3 .8 76.2l0 0-.1 .4c-2.2 18.5 .5 34.2 7.3 47.5c6.8 13.2 17.4 23.5 29.9 31.8c7.3 4.8 15.4 9.1 24 12.9c-2 .7-4 1.4-5.9 2.2C27.7 182.4 7.2 202.9 1.7 232.4c0 .1-.1 .3-.1 .4c-2.2 17.7 .5 32.7 7.4 45.4c6.8 12.6 17.4 22.4 29.9 30.2c23.8 15 56.3 24.1 87.2 32.7l2.9 .8c32.6 9.1 63.1 17.9 84.1 32.3c10.3 7.1 17.9 15.2 22.4 25c4.4 9.7 6 21.8 3.1 37.2c-4.3 23-20 39.6-44.6 49.4c-24.8 9.9-58.1 12.6-95.4 7.1c-18.9-2.9-50.7-13-74.5-20.5l0 0 0 0c-5-1.6-9.6-3.1-13.7-4.3c-4.2-1.3-8.7 1-10 5.3s1 8.7 5.3 10c3.8 1.2 8.2 2.6 13 4.1l0 0 0 0c23.6 7.5 57.2 18.2 77.5 21.3l0 0c39.1 5.7 75.5 3.1 103.7-8.1c28.4-11.4 48.9-31.8 54.4-61.4c3.4-18.1 1.7-33.6-4.3-46.8c-6-13.1-15.9-23.4-27.9-31.6c-3.7-2.6-7.7-4.9-11.9-7.2c23-12.6 39.3-32.3 44.1-59.5c3.3-19 1.7-35.1-4.3-48.9c-5.9-13.8-15.8-24.5-27.9-33.2c-23.7-17.1-57.2-27.1-89.2-36.5l-1.6-.5c-32.2-9.5-62.7-18.4-84.6-33c-10.9-7.3-19.3-15.7-24.5-25.8c-5.1-10-7.5-22.3-5.7-38.1zM191.3 345.3c-18.2-7.4-38.4-13.1-58-18.5l-1.5-.4c-32-9-62.6-17.5-84.4-31.2c-10.9-6.9-19.2-14.8-24.3-24.3c-5.1-9.4-7.4-20.9-5.6-35.6c4.3-22.8 20.1-39.4 44.6-49.2c7.7-3.1 16.3-5.5 25.6-7.1c12.4 4.3 25.3 8 37.9 11.7l2.9 .9c32.7 9.6 63.3 18.9 84.4 34.1c10.3 7.4 18 16.1 22.5 26.5c4.5 10.4 6.1 23.3 3.2 39.8c-4.4 25.1-21.3 43.3-47.2 53.5z'
      
    ]
  };

  

  
  

  var faSquare0 = {
    prefix: 'fat',
    iconName: 'square-0',
    icon: [
      448,
      512,
      [],
      'e255',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 32c53 0 96 43 96 96v64c0 53-43 96-96 96s-96-43-96-96V224c0-53 43-96 96-96zm-80 96v64c0 44.2 35.8 80 80 80s80-35.8 80-80V224c0-44.2-35.8-80-80-80s-80 35.8-80 80z'
      
    ]
  };

  

  
  

  var faInbox = {
    prefix: 'fat',
    iconName: 'inbox',
    icon: [
      512,
      512,
      [],
      'f01c',
      
      'M16 416V327.9c0-2.6 .2-5.3 .7-7.9H118.1c3 0 5.8 1.7 7.2 4.4l23.2 46.3c4.1 8.1 12.4 13.3 21.5 13.3H342.1c9.1 0 17.4-5.1 21.5-13.3l23.2-46.3c1.4-2.7 4.1-4.4 7.2-4.4H495.4c.4 2.6 .6 5.2 .6 7.9V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48zM491.5 304H393.9c-9.1 0-17.4 5.1-21.5 13.3l-23.2 46.3c-1.4 2.7-4.1 4.4-7.2 4.4H169.9c-3 0-5.8-1.7-7.2-4.4l-23.2-46.3c-4.1-8.1-12.4-13.3-21.5-13.3H20.5L75.4 84.4C80.7 63 99.9 48 122 48H390c22 0 41.2 15 46.6 36.4L491.5 304zM0 327.9V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V327.9c0-5.2-.6-10.4-1.9-15.5l-58-231.9C445 52 419.4 32 390 32H122C92.6 32 67 52 59.9 80.5L1.9 312.4C.6 317.4 0 322.6 0 327.9z'
      
    ]
  };

  

  
  

  var faFaceSunglasses = {
    prefix: 'fat',
    iconName: 'face-sunglasses',
    icon: [
      512,
      512,
      [],
      'e398',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM139.4 337.4c-3.6 2.5-4.5 7.5-2 11.1c22.4 32 61.9 67.4 118.6 67.4s96.1-35.4 118.6-67.4c2.5-3.6 1.7-8.6-2-11.1s-8.6-1.7-11.1 2C340.6 369.2 305.4 400 256 400s-84.6-30.8-105.4-60.6c-2.5-3.6-7.5-4.5-11.1-2zM265.2 176c-.8 5.5-.8 11.3 .2 17.2l8 48c4.5 27 27.9 46.8 55.2 46.8h78.7c27.4 0 50.7-19.8 55.2-46.8l8-48c5.7-34.1-20.6-65.2-55.2-65.2H320.7C298 128 279 141.3 270 160H242c-8.9-18.7-28-32-50.6-32H96.7c-34.6 0-60.9 31.1-55.2 65.2l8 48c4.5 27 27.9 46.8 55.2 46.8h78.7c27.4 0 50.7-19.8 55.2-46.8l8-48c1-5.9 1-11.7 .2-17.2h18.4zm16 14.6c-4.1-24.4 14.7-46.6 39.5-46.6h60l-50.3 50.3c-2.3 2.3-3 5.7-1.7 8.7s4.2 4.9 7.4 4.9h44.7l-62.6 62.6c-14.7-4-26.3-16.3-28.9-32l-8-48zM339.3 272l66.3-66.3c2.3-2.3 3-5.7 1.7-8.7s-4.2-4.9-7.4-4.9H355.3l48-48h12c24.7 0 43.5 22.2 39.5 46.6l-8 48c-3.2 19.3-19.9 33.4-39.5 33.4h-68zM96.7 144h60l-50.3 50.3c-2.3 2.3-3 5.7-1.7 8.7s4.2 4.9 7.4 4.9h44.7L94.1 270.6c-14.7-4-26.3-16.3-28.9-32l-8-48C53.1 166.2 71.9 144 96.7 144zm85 61.7c2.3-2.3 3-5.7 1.7-8.7s-4.2-4.9-7.4-4.9H131.3l48-48h12c24.7 0 43.5 22.2 39.5 46.6l-8 48c-3.2 19.3-19.9 33.4-39.5 33.4h-68l66.3-66.3z'
      
    ]
  };

  

  
  

  var faSocks = {
    prefix: 'fat',
    iconName: 'socks',
    icon: [
      512,
      512,
      [129510],
      'f696',
      
      'M168.4 461.7c2 5.1 4.2 10.1 6.8 14.9l-21.6 16.2C137 505.3 116.8 512 96 512c-53 0-96-43-96-96c0-30.2 14.2-58.7 38.4-76.8l64-48C118.5 279.1 128 260.1 128 240V112v-8V96 48c0-26.5 21.5-48 48-48h96c9.9 0 19 3 26.7 8.1c-2.7 4.7-5 9.7-6.7 14.9c-5.5-4.4-12.4-7-20-7H176c-17.7 0-32 14.3-32 32V96H288v16H144V240c0 25.2-11.9 48.9-32 64L48 352c-20.1 15.1-32 38.8-32 64c0 44.2 35.8 80 80 80c17.3 0 34.2-5.6 48-16l24.4-18.3zM336 112V240c0 25.2-11.9 48.9-32 64l-64 48c-20.1 15.1-32 38.8-32 64c0 44.2 35.8 80 80 80c17.3 0 34.2-5.6 48-16l115.2-86.4C479.4 372.4 496 339.3 496 304V112H336zm0-16H496V48c0-17.7-14.3-32-32-32H368c-17.7 0-32 14.3-32 32V96zM512 48V96v8 8V304c0 40.3-19 78.2-51.2 102.4L345.6 492.8C329 505.3 308.8 512 288 512c-53 0-96-43-96-96c0-30.2 14.2-58.7 38.4-76.8l64-48C310.5 279.1 320 260.1 320 240V112v-8V96 48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48z'
      
    ]
  };

  

  
  

  var faGrid4 = {
    prefix: 'fat',
    iconName: 'grid-4',
    icon: [
      448,
      512,
      [],
      'e198',
      
      'M16 105.6V48l57.6 0v57.6H16zm0 119.5V167.5l57.6 0v57.6H16zm0 61.9l57.6 0 0 57.6-57.6 0 0-57.6zM16 464V406.4l57.6 0V464H16zM16 32C7.2 32 0 39.2 0 48v57.6c0 8.8 7.2 16 16 16H73.6c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H16zm0 119.5c-8.8 0-16 7.2-16 16v57.6c0 8.8 7.2 16 16 16H73.6c8.8 0 16-7.2 16-16V167.5c0-8.8-7.2-16-16-16H16zM0 286.9v57.6c0 8.8 7.2 16 16 16H73.6c8.8 0 16-7.2 16-16V286.9c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zM16 390.4c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16H73.6c8.8 0 16-7.2 16-16V406.4c0-8.8-7.2-16-16-16H16zM135.5 105.6V48l57.6 0v57.6H135.5zm0 119.5V167.5l57.6 0v57.6H135.5zm0 61.9l57.6 0 0 57.6-57.6 0 0-57.6zm0 177.1V406.4l57.6 0V464H135.5zm0-432c-8.8 0-16 7.2-16 16v57.6c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H135.5zm0 119.5c-8.8 0-16 7.2-16 16v57.6c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16V167.5c0-8.8-7.2-16-16-16H135.5zm-16 135.5v57.6c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16V286.9c0-8.8-7.2-16-16-16H135.5c-8.8 0-16 7.2-16 16zm16 103.5c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16V406.4c0-8.8-7.2-16-16-16H135.5zM254.9 48l57.6 0v57.6H254.9V48zm0 119.5l57.6 0v57.6H254.9V167.5zm57.6 119.5l0 57.6-57.6 0 0-57.6 57.6 0zM254.9 406.4l57.6 0V464H254.9V406.4zM238.9 48v57.6c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H254.9c-8.8 0-16 7.2-16 16zm0 119.5v57.6c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16V167.5c0-8.8-7.2-16-16-16H254.9c-8.8 0-16 7.2-16 16zm16 103.5c-8.8 0-16 7.2-16 16v57.6c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16V286.9c0-8.8-7.2-16-16-16H254.9zm-16 135.5V464c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16V406.4c0-8.8-7.2-16-16-16H254.9c-8.8 0-16 7.2-16 16zM374.4 105.6V48L432 48v57.6H374.4zm0 119.5V167.5l57.6 0v57.6H374.4zm0 61.9l57.6 0v57.6l-57.6 0 0-57.6zm0 177.1V406.4l57.6 0V464H374.4zm0-432c-8.8 0-16 7.2-16 16v57.6c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H374.4zm0 119.5c-8.8 0-16 7.2-16 16v57.6c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V167.5c0-8.8-7.2-16-16-16H374.4zm-16 135.5v57.6c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V286.9c0-8.8-7.2-16-16-16H374.4c-8.8 0-16 7.2-16 16zm16 103.5c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V406.4c0-8.8-7.2-16-16-16H374.4z'
      
    ]
  };

  

  
  

  var faBatteryEmpty = {
    prefix: 'fat',
    iconName: 'battery-empty',
    icon: [
      576,
      512,
      ["battery-0"],
      'f244',
      
      'M80 112c-35.3 0-64 28.7-64 64V336c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V320 304 208 192 176c0-35.3-28.7-64-64-64H80zM528 320v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V176c0-44.2 35.8-80 80-80H448c44.2 0 80 35.8 80 80v16h16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H528zm0-112v96h16c8.8 0 16-7.2 16-16V224c0-8.8-7.2-16-16-16H528z'
      
    ]
  };

  
    var faBattery0 = faBatteryEmpty;
  

  
  

  var faSnowflakeDroplets = {
    prefix: 'fat',
    iconName: 'snowflake-droplets',
    icon: [
      640,
      512,
      [],
      'e5c1',
      
      'M328 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V108.7L261.7 58.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L312 131.3V242.1l-96-55.4-22.6-84.2c-1.1-4.3-5.5-6.8-9.8-5.7s-6.8 5.5-5.7 9.8l18.4 68.8-87.2-50.3c-3.8-2.2-8.7-.9-10.9 2.9s-.9 8.7 2.9 10.9l87.2 50.3-68.8 18.4c-4.3 1.1-6.8 5.5-5.7 9.8s5.5 6.8 9.8 5.7L208 200.6 304 256l-96 55.4-84.2-22.6c-4.3-1.1-8.7 1.4-9.8 5.7s1.4 8.7 5.7 9.8l68.8 18.4-62.2 35.9 7.3 14.2 62.8-36.3L178 405.4c-1.1 4.3 1.4 8.7 5.7 9.8s8.7-1.4 9.8-5.7L216 325.3l96-55.4V380.7l-61.7 61.7c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L312 403.3V504c0 4.4 3.6 8 8 8s8-3.6 8-8V403.3l50.3 50.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L328 380.7V269.9l96 55.4 22.6 84.2c1.1 4.3 5.5 6.8 9.8 5.7s6.8-5.5 5.7-9.8l-18.4-68.8 62.9 36.3 7.3-14.2-62.2-35.9 68.8-18.4c4.3-1.1 6.8-5.5 5.7-9.8s-5.5-6.8-9.8-5.7L432 311.4 336 256l96-55.4 84.2 22.6c4.3 1.1 8.7-1.4 9.8-5.7s-1.4-8.7-5.7-9.8l-68.8-18.4 87.2-50.3c3.8-2.2 5.1-7.1 2.9-10.9s-7.1-5.1-10.9-2.9l-87.2 50.3L462 106.6c1.1-4.3-1.4-8.7-5.7-9.8s-8.7 1.4-9.8 5.7L424 186.7l-96 55.4V131.3l61.7-61.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L328 108.7V8zM576 342.5l42.6 82.9c3.5 6.8 5.4 14.5 5.4 22.2c0 26.6-21.6 48.3-48 48.3s-48-21.7-48-48.3c0-7.7 1.8-15.4 5.4-22.2L576 342.5zm-9.3-16.8l-47.5 92.4c-4.7 9.1-7.1 19.3-7.1 29.5c0 35.3 28.7 64.3 64 64.3s64-29 64-64.3c0-10.2-2.4-20.4-7.1-29.5l-47.5-92.4c-1.8-3.5-5.4-5.7-9.3-5.7s-7.5 2.2-9.3 5.7zM21.4 425.5L64 342.5l42.6 82.9c3.5 6.8 5.4 14.5 5.4 22.2c0 26.6-21.6 48.3-48 48.3s-48-21.7-48-48.3c0-7.7 1.8-15.4 5.4-22.2zM7.1 418.1C2.4 427.2 0 437.4 0 447.7C0 483 28.7 512 64 512s64-29 64-64.3c0-10.2-2.4-20.4-7.1-29.5L73.3 325.7c-1.8-3.5-5.4-5.7-9.3-5.7s-7.5 2.2-9.3 5.7L7.1 418.1z'
      
    ]
  };

  

  
  

  var faDove = {
    prefix: 'fat',
    iconName: 'dove',
    icon: [
      512,
      512,
      [128330],
      'f4ba',
      
      'M164.3 111.8c-4.2-4.6-8.2-9.3-11.9-14.4c16.7-45.8 37.8-76.2 51.2-90.9c3.6-4 9.5-4.6 14.2-2c4.3 2.4 6.8 7.1 6.7 12c-1.1 54.5 23 99.2 55.4 134l0 22.8C242 137 210.4 87.7 208.6 25.6c-12.8 16.4-30.5 45.3-44.3 86.3zM63.5 38.4c2.6-4.2 7.1-6.4 11.7-6.4c6.7 0 12.3 4.8 13.7 11c13.4 59.3 53.5 99.2 98.5 125.1c45 25.8 94.3 37.3 125 39.9H320V136c0-39.8 32.2-72 72-72h99.7c11.2 0 20.3 9.1 20.3 20.3c0 4-1.2 7.9-3.4 11.2L480 138.4V296c0 83.9-68.1 152-152 152H237.9l-81 62.3c-1.4 1.1-3.1 1.7-4.9 1.7C72.3 512 18.8 467.8 1.6 444.8c-1.5-2-2-4.7-1.3-7.1s2.6-4.4 5-5.2l159.5-57.4C121.1 351.5 32 292.5 32 176C32 101.6 51.6 57.5 63.5 38.4zm10.9 13C63.9 70.4 48 110.4 48 176c0 122.4 106.9 176.5 139.4 192.8c2.7 1.3 4.6 4 4.6 7.2v.6c0 3.4-2.1 6.4-5.3 7.5L21.6 443.6c20 20.8 64.6 51.5 127.7 52.4l81-62.3c1.4-1.1 3.1-1.7 4.9-1.7H328c75.1 0 136-60.9 136-136V136c0-1.6 .5-3.1 1.3-4.4l29.9-44.9c.5-.7 .7-1.5 .7-2.4c0-2.4-1.9-4.3-4.3-4.3H392c-30.9 0-56 25.1-56 56v80c0 4.4-3.6 8-8 8H312l-.3 0-.3 0c-32.6-2.7-84.5-14.7-132-42C133 155.3 90.2 113.7 74.4 51.5zM384 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faHandBackPointRight = {
    prefix: 'fat',
    iconName: 'hand-back-point-right',
    icon: [
      544,
      512,
      [],
      'e1a1',
      
      'M516 172c0-28.7-23.3-52-52-52l-188 0-9.6 0c-3.7-6-7.8-11.8-12.5-17.3L229.3 73.5C215.6 57.3 195.5 48 174.3 48l-24 0c-48.8 0-93.9 26.2-118.1 68.5l-10.3 18C10.2 155.1 4 178.3 4 202L4 344c0 57.4 46.6 104 104 104l16 0 84 0 4 0c.8 0 1.5-.1 2.2-.3C244.5 444.5 268 419 268 388c0-3.6-.3-7.1-.9-10.5c19.5-9.9 32.9-30.2 32.9-53.5c0-6.1-.9-12-2.6-17.6c20.5-9.6 34.6-30.3 34.6-54.4c0-10.1-2.5-19.6-6.9-28L464 224c28.7 0 52-23.3 52-52zM247.2 120L172 120c-4.4 0-8 3.6-8 8s3.6 8 8 8l89.8 0 14.2 0 188 0c19.9 0 36 16.1 36 36s-16.1 36-36 36l-154.5 0c-3.2 0-6.1 1.9-7.4 4.9s-.6 6.4 1.6 8.7c7.6 7.9 12.2 18.6 12.2 30.5c0 19.9-13.2 36.7-31.3 42.1c-2.2 .7-4.1 2.3-5 4.4s-.9 4.6 .1 6.7c2.7 5.7 4.2 12 4.2 18.8c0 19-12.1 35.2-29 41.4c-4 1.5-6.2 5.8-4.9 9.8c1.2 4 1.9 8.3 1.9 12.8c0 23.1-17.9 42.1-40.6 43.9c-.3 0-.6 .1-1 .1l-2.5 0-84 0-16 0c-48.6 0-88-39.4-88-88l0-142c0-20.9 5.4-41.4 15.8-59.5l10.3-18C67.5 87.1 107.2 64 150.3 64l24 0c16.5 0 32.1 7.3 42.7 19.8L241.8 113c1.9 2.3 3.7 4.6 5.5 7z'
      
    ]
  };

  

  
  

  var faHatChef = {
    prefix: 'fat',
    iconName: 'hat-chef',
    icon: [
      512,
      512,
      [],
      'f86b',
      
      'M161.9 67.2c-1.3 2-3.4 3.3-5.7 3.6s-4.7-.4-6.4-2C135.6 55.9 116.7 48 96 48c-44.2 0-80 35.8-80 80c0 7.5 1 14.7 2.9 21.6c0 .2 .1 .3 .1 .5c11.3 51.9 49.6 146.1 63.4 179.2c1.7 4.1 5.7 6.7 10.2 6.7h57.8L120.1 169.4c-.8-4.3 2.1-8.5 6.4-9.3s8.5 2.1 9.3 6.4L166.7 336H248V136c0-4.4 3.6-8 8-8s8 3.6 8 8V336h81.3l30.8-169.4c.8-4.3 5-7.2 9.3-6.4s7.2 5 6.4 9.3L361.6 336h57.8c4.5 0 8.5-2.7 10.2-6.7c13.8-33.1 52.1-127.4 63.4-179.2c0-.1 0-.2 .1-.2c0-.1 0-.1 .1-.2c1.9-6.9 2.9-14.1 2.9-21.6c0-44.2-35.8-80-80-80c-20.7 0-39.6 7.9-53.8 20.8c-1.7 1.6-4.1 2.3-6.4 2s-4.4-1.6-5.7-3.6C330.1 36.4 295.4 16 256 16s-74.1 20.4-94.1 51.2zM159.8 352H92.7c-10.9 0-20.7-6.4-24.9-16.6C54.1 302.8 15.2 207.3 3.5 153.7C1.2 145.5 0 136.9 0 128C0 75 43 32 96 32c21.6 0 41.6 7.1 57.6 19.2C176.9 20.1 214.1 0 256 0s79.1 20.1 102.4 51.2c16-12 36-19.2 57.6-19.2c53 0 96 43 96 96c0 8.9-1.2 17.5-3.5 25.7c-11.7 53.6-50.6 149.1-64.2 181.8c-4.2 10.1-14.1 16.6-24.9 16.6H352.2c-.1 0-.2 0-.3 0H256 160.1c-.1 0-.2 0-.3 0zM64 384H80v80c0 17.7 14.3 32 32 32H400c17.7 0 32-14.3 32-32V384h16v80c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V384z'
      
    ]
  };

  

  
  

  var faGameBoard = {
    prefix: 'fat',
    iconName: 'game-board',
    icon: [
      448,
      512,
      [],
      'f867',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm136 0v56h80V96c0-4.4 3.6-8 8-8s8 3.6 8 8v56h80V96c0-4.4 3.6-8 8-8s8 3.6 8 8v56h56c4.4 0 8 3.6 8 8s-3.6 8-8 8H328v80h56c4.4 0 8 3.6 8 8s-3.6 8-8 8H328v80h56c4.4 0 8 3.6 8 8s-3.6 8-8 8H328v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V360H232v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V360H136v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V360H64c-4.4 0-8-3.6-8-8s3.6-8 8-8h56V264H64c-4.4 0-8-3.6-8-8s3.6-8 8-8h56V168H64c-4.4 0-8-3.6-8-8s3.6-8 8-8h56V96c0-4.4 3.6-8 8-8s8 3.6 8 8zm0 152h80V168H136v80zm96 0h80V168H232v80zm0 16v80h80V264H232zm-16 0H136v80h80V264z'
      
    ]
  };

  

  
  

  var faPersonBurst = {
    prefix: 'fat',
    iconName: 'person-burst',
    icon: [
      640,
      512,
      [],
      'e53b',
      
      'M440 56a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm96 0A56 56 0 1 0 424 56a56 56 0 1 0 112 0zM410.7 175.7c9.3-19.4 28.9-31.7 50.4-31.7h37.8c21.5 0 41.1 12.3 50.4 31.7l67.5 139.8c1.9 4 6.7 5.6 10.7 3.7s5.6-6.7 3.7-10.7L563.7 168.7c-12-24.9-37.2-40.7-64.8-40.7H461.1c-27.6 0-52.8 15.8-64.8 40.7L328.8 308.5c-1.9 4-.2 8.8 3.7 10.7s8.8 .3 10.7-3.7l67.5-139.8zM416 240c-4.4 0-8 3.6-8 8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V360c0-4.4 3.6-8 8-8s8 3.6 8 8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V248c0-4.4-3.6-8-8-8s-8 3.6-8 8V480c0 8.8-7.2 16-16 16s-16-7.2-16-16V360c0-13.3-10.7-24-24-24s-24 10.7-24 24V480c0 8.8-7.2 16-16 16s-16-7.2-16-16V248c0-4.4-3.6-8-8-8zM190.5 20.5c-5.7-12.4-23.4-12.4-29.1 0L130.1 88.7l-72.9-18C43.9 67.4 32.9 81.2 39.1 93.4L73 160.8l-53.7 46c-10 8.5-6 24.8 6.8 27.8l67.2 15.3L92 325c-.2 13.7 15.7 21.3 26.2 12.6L176 289.8l57.9 47.9c10.5 8.7 26.4 1.1 26.2-12.6l-1.4-75.2 67.2-15.3c12.8-2.9 16.8-19.2 6.8-27.8l-53.7-46 33.9-67.4c6.2-12.2-4.9-26-18.1-22.7l-72.9 18L190.5 20.5zM176 27.2l34.1 74.2c1.6 3.5 5.5 5.3 9.2 4.4l79.3-19.6-36.8 73c-1.7 3.3-.9 7.3 1.9 9.7l58.5 50.1-73.5 16.8c-3.7 .8-6.3 4.2-6.2 7.9l1.5 81.7-63-52.1c-3-2.4-7.2-2.4-10.2 0l-63 52.1 1.5-81.7c.1-3.8-2.5-7.1-6.2-7.9L29.7 218.9l58.5-50.1c2.8-2.4 3.6-6.4 1.9-9.7l-36.8-73 79.3 19.6c3.7 .9 7.6-.9 9.2-4.4L176 27.2z'
      
    ]
  };

  

  
  

  var faCrateApple = {
    prefix: 'fat',
    iconName: 'crate-apple',
    icon: [
      512,
      512,
      ["apple-crate"],
      'f6b1',
      
      'M213.7 21.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-32 32c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l32-32zm192 0c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-32 32c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l32-32zm-344.3 96C69.8 103.8 81.1 96 96 96c12.4 0 28.6 4.9 41.4 9.9c14.5 5.6 30.7 5.6 45.1 0c12.8-5 29-9.9 41.4-9.9c14.9 0 26.2 7.8 34.7 21.7c8.7 14.3 13.3 34.1 13.3 53.8c0 7.1-.5 14-1.4 20.6h16.1c.8-6.7 1.2-13.5 1.2-20.6c0-43.6-20.4-91.4-64-91.4c-15.6 0-34.1 5.9-47.2 11c-10.7 4.2-22.8 4.2-33.5 0C130.1 85.9 111.6 80 96 80c-43.6 0-64 47.8-64 91.4c0 7 .4 13.9 1.2 20.6H49.4c-.9-6.6-1.4-13.5-1.4-20.6c0-19.6 4.7-39.4 13.3-53.8zM478.8 192c.8-6.7 1.2-13.5 1.2-20.6c0-43.6-20.4-91.4-64-91.4c-15.6 0-34.1 5.9-47.2 11c-10.7 4.2-22.8 4.2-33.5 0c-12.4-4.8-29.6-10.3-44.6-11c3.4 4 6.4 8.3 9 12.7c1 1.6 1.9 3.2 2.8 4.9c9.1 1.9 18.7 5 26.9 8.2c14.5 5.6 30.7 5.6 45.1 0c12.8-5 29-9.9 41.4-9.9c14.9 0 26.2 7.8 34.7 21.7c8.7 14.3 13.3 34.1 13.3 53.8c0 7.1-.5 14-1.4 20.6h16.1zM496 376v80c0 22.1-17.9 40-40 40H56c-22.1 0-40-17.9-40-40V376H496zm0-16H16V280c0-22.1 17.9-40 40-40H456c22.1 0 40 17.9 40 40v80zm16 0V280c0-30.9-25.1-56-56-56H56c-30.9 0-56 25.1-56 56v80 8 8 80c0 30.9 25.1 56 56 56H456c30.9 0 56-25.1 56-56V376v-8-8zM96 304a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm336 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM96 432a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm336 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  
    var faAppleCrate = faCrateApple;
  

  
  

  var faFileSvg = {
    prefix: 'fat',
    iconName: 'file-svg',
    icon: [
      512,
      512,
      [],
      'e64b',
      
      'M64 496h48v16H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H204.1c12.7 0 24.9 5.1 33.9 14.1L369.9 145.9c9 9 14.1 21.2 14.1 33.9V304H368V179.9c0-1.3-.1-2.6-.2-3.9H248c-22.1 0-40-17.9-40-40V16.2c-1.3-.2-2.6-.2-3.9-.2H64C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48zM361.1 160c-.8-1-1.6-1.9-2.4-2.7L226.7 25.4c-.9-.9-1.8-1.7-2.7-2.4V136c0 13.3 10.7 24 24 24H361.1zM205.7 368H232c4.4 0 8 3.6 8 8s-3.6 8-8 8H205.7c-12 0-21.7 9.7-21.7 21.7c0 8.2 4.6 15.7 12 19.4l31.2 15.6c12.8 6.4 20.8 19.4 20.8 33.7c0 20.8-16.9 37.7-37.7 37.7H176c-4.4 0-8-3.6-8-8s3.6-8 8-8h34.3c12 0 21.7-9.7 21.7-21.7c0-8.2-4.6-15.7-12-19.4l-31.2-15.6C176.1 433 168 419.9 168 405.7c0-20.8 16.9-37.7 37.7-37.7zM456 368h16c17.7 0 32 14.3 32 32v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-8.8-7.2-16-16-16H456c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V464h-8c-4.4 0-8-3.6-8-8s3.6-8 8-8h16c4.4 0 8 3.6 8 8v24c0 17.7-14.3 32-32 32H456c-17.7 0-32-14.3-32-32V400c0-17.7 14.3-32 32-32zm-152 0c4.4 0 8 3.6 8 8v31.6c0 29.1 8.3 57.5 24 82c15.7-24.5 24-52.9 24-82V376c0-4.4 3.6-8 8-8s8 3.6 8 8v31.6c0 33.2-9.8 65.6-28.2 93.2l-5.1 7.7c-1.5 2.2-4 3.6-6.7 3.6s-5.2-1.3-6.7-3.6l-5.1-7.7c-18.4-27.6-28.2-60-28.2-93.2V376c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faEarthAmericas = {
    prefix: 'fat',
    iconName: 'earth-americas',
    icon: [
      512,
      512,
      [127758,"earth","earth-america","globe-americas"],
      'f57d',
      
      'M256 496C123.5 496 16 388.5 16 256c0-23.3 3.3-45.8 9.5-67.1l19.2 38.3c8.8 17.5 24.2 30.7 42.9 36.5l68.8 21.5c16.4 5.1 27.6 20.3 27.6 37.5v11.3c0 14 7.9 26.8 20.4 33c7.1 3.5 11.6 10.8 11.6 18.7v39c0 21.6 17.5 39.1 39.1 39.1c18.3 0 34.2-12.7 38.1-30.6l4.9-22.1c3.1-14.1 12.1-26.2 24.6-33.4l9-5.2c17.4-10 28.2-28.5 28.2-48.6v-8.3c0-14.9-5.9-29.1-16.4-39.6l-3.9-3.9C329.2 261.9 315 256 300.1 256H251.3c-6.2 0-12.3-1.4-17.9-4.2l-45.9-22.9c-3.6-1.8-6.6-4.8-8.4-8.4l-.7-1.4c-4.3-8.5-.8-18.9 7.7-23.2c4.1-2.1 8.9-2.4 13.2-.9l24.2 8.1c11.6 3.9 24.3-.5 31.1-10.7c6.7-10 6-23.2-1.7-32.4l-17.9-21.5c-5-6-4.9-14.7 .1-20.7l21-24.5c10.5-12.2 12.6-29.5 5.4-43.9L245.1 16.2c3.6-.2 7.3-.2 10.9-.2c87.2 0 163.5 46.5 205.5 116l-54.6 24.8c-18.6 8.5-27.9 29.6-21.4 49.1L403 258.3c4.2 12.7 14.5 22.4 27.4 25.9L491.8 301C470.7 412 373.2 496 256 496zM32.8 167.7C64.7 87.2 138.8 28 227.9 17.6l19.5 38.9c4.3 8.6 3 19-3.2 26.4l-21 24.5c-10.2 11.9-10.3 29.3-.3 41.3l17.9 21.5c3.1 3.8 3.4 9.2 .7 13.3c-2.8 4.2-8 6-12.7 4.4l-24.2-8.1c-8.4-2.8-17.5-2.1-25.4 1.8c-16.4 8.2-23.1 28.2-14.9 44.7l.7 1.4c3.4 6.7 8.8 12.2 15.6 15.6l45.9 22.9c7.8 3.9 16.4 5.9 25 5.9h48.8c10.6 0 20.8 4.2 28.3 11.7l3.9 3.9c7.5 7.5 11.7 17.7 11.7 28.3v8.3c0 14.4-7.7 27.6-20.2 34.7l-9.1 5.2c-16.5 9.4-28.2 25.3-32.3 43.8l-4.9 22.1c-2.3 10.6-11.7 18.1-22.5 18.1c-12.7 0-23.1-10.3-23.1-23.1v-39c0-14-7.9-26.8-20.4-33c-7.1-3.5-11.6-10.8-11.6-18.7V322.8c0-24.2-15.7-45.6-38.8-52.8L92.4 248.5c-14.5-4.5-26.6-14.8-33.4-28.4L32.8 167.7zM434.6 268.8c-7.7-2.1-13.9-8-16.5-15.6l-17.5-52.4c-3.9-11.7 1.7-24.4 12.8-29.4L469.4 146c17 33 26.6 70.4 26.6 110c0 9.8-.6 19.5-1.7 29.1l-59.6-16.3zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z'
      
    ]
  };

  
    var faEarth = faEarthAmericas;
  
    var faEarthAmerica = faEarthAmericas;
  
    var faGlobeAmericas = faEarthAmericas;
  

  
  

  var faHexagonImage = {
    prefix: 'fat',
    iconName: 'hexagon-image',
    icon: [
      512,
      512,
      [],
      'e504',
      
      'M400.8 450.8l0 0L497.1 284c2.5-4.3 4.4-8.9 5.6-13.6c2-7.7 2.4-15.7 1.1-23.6c-1.1-6.5-3.3-12.9-6.7-18.8L400.8 61.2c-10-17.3-28.5-28-48.5-28H159.7c-20 0-38.5 10.7-48.5 28L14.9 228c-3.9 6.7-6.3 14.1-7.1 21.6c-1.4 11.8 1 23.9 7.1 34.4l96.3 166.8c10 17.3 28.5 28 48.5 28H352.3c20 0 38.5-10.7 48.5-28zM483.2 236c2.7 4.6 4.4 9.7 5 14.8l-2.7 20.4c-.7 1.6-1.5 3.2-2.3 4.8l-21.2 36.6-70.7-75.4c-12.6-13.5-34-13.5-46.7 0l-101 107.7-61.1-59.1c-12.6-12.1-32.5-12-44.9 .4L72.4 351.5 28.8 276c-3.6-6.2-5.4-13.1-5.4-20c0-3.4 .4-6.8 1.3-10.1c.9-3.4 2.2-6.8 4.1-9.9L125.1 69.2c7.1-12.4 20.4-20 34.6-20l192.6 0c14.3 0 27.5 7.6 34.6 20L483.2 236zM80.7 365.9L149 297.5c6.2-6.2 16.2-6.3 22.4-.2l61.3 59.3-94 100.2c-5.6-3.4-10.3-8.2-13.7-14.1L80.7 365.9zm306.3 76.9c-7.1 12.4-20.4 20-34.6 20H159.7c-1.5 0-2.9-.1-4.4-.2l201-214.4c6.3-6.7 17-6.7 23.3 0l74 79L386.9 442.8zM192 208a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-32-48a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faEraser = {
    prefix: 'fat',
    iconName: 'eraser',
    icon: [
      576,
      512,
      [],
      'f12d',
      
      'M364.3 63c-15.6-15.6-40.9-15.6-56.6 0L191 179.7 396.3 385 513 268.3c15.6-15.6 15.6-40.9 0-56.6L364.3 63zM63 307.7c-15.6 15.6-15.6 40.9 0 56.6l88 88c7.5 7.5 17.7 11.7 28.3 11.7H300.7c10.6 0 20.8-4.2 28.3-11.7l56-56L179.7 191 63 307.7zm233.4-256c21.9-21.9 57.3-21.9 79.2 0L524.3 200.4c21.9 21.9 21.9 57.3 0 79.2l-184 184c-.1 .1-.3 .3-.4 .4H536c4.4 0 8 3.6 8 8s-3.6 8-8 8H288v0H179.3c-14.9 0-29.1-5.9-39.6-16.4l-88-88c-21.9-21.9-21.9-57.3 0-79.2L296.4 51.7z'
      
    ]
  };

  

  
  

  var faBullseyePointer = {
    prefix: 'fat',
    iconName: 'bullseye-pointer',
    icon: [
      512,
      512,
      [],
      'f649',
      
      'M496 256c0 132.5-107.5 240-240 240c-9 0-18-.5-26.7-1.5c-2.2 5.8-5.7 10.8-10.1 14.8c12 1.7 24.3 2.6 36.8 2.6c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256c0 12.5 .9 24.8 2.6 36.8c4-4.4 9.1-7.9 14.8-10.1C16.5 274 16 265 16 256C16 123.5 123.5 16 256 16s240 107.5 240 240zM249.6 423.9c2.1 .1 4.2 .1 6.4 .1c92.8 0 168-75.2 168-168s-75.2-168-168-168S88 163.2 88 256c0 2.1 0 4.3 .1 6.4l15.9-4.5c0-.6 0-1.2 0-1.8c0-83.9 68.1-152 152-152s152 68.1 152 152s-68.1 152-152 152c-.6 0-1.2 0-1.8 0l-4.5 15.9zM278 324.6c29-9.3 50-36.5 50-68.6c0-39.8-32.2-72-72-72c-32.1 0-59.3 21-68.6 50l19.9-5.7C217 211.4 235.1 200 256 200c30.9 0 56 25.1 56 56c0 20.9-11.4 39-28.3 48.7L278 324.6zm-14.3-66.4c.8-2.8 0-5.8-2-7.9s-5.1-2.8-7.9-2l-224 64c-3.4 1-5.7 4-5.8 7.6s2.2 6.7 5.6 7.7l108.7 34.8L2.3 498.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L149.6 373.7l34.8 108.7c1.1 3.4 4.2 5.6 7.7 5.6s6.6-2.4 7.6-5.8l64-224zM59.6 320.4l184.8-52.8L191.6 452.4l-30.7-96c-.8-2.5-2.7-4.4-5.2-5.2l-96-30.7z'
      
    ]
  };

  

  
  

  var faDroplet = {
    prefix: 'fat',
    iconName: 'droplet',
    icon: [
      384,
      512,
      [128167,"tint"],
      'f043',
      
      'M192 496C94.8 496 16 417.2 16 320c0-19.5 7.1-44.9 19.6-73.8c12.4-28.6 29.3-59.2 47.7-88.8c36.6-59.2 77.9-112.9 95.9-135.7c2.8-3.5 7-5.6 11.9-5.6h1.8c4.9 0 9.1 2.1 11.9 5.6c18.1 22.8 59.3 76.6 95.9 135.7c18.3 29.6 35.3 60.2 47.7 88.8C360.9 275.1 368 300.5 368 320c0 97.2-78.8 176-176 176zM0 320C0 426 86 512 192 512s192-86 192-192c0-91.2-130.2-262.3-166.6-308.3C211.4 4.2 202.5 0 192.9 0h-1.8c-9.6 0-18.5 4.2-24.5 11.7C130.2 57.7 0 228.8 0 320zm104 0c0-4.4-3.6-8-8-8s-8 3.6-8 8c0 57.4 46.6 104 104 104c4.4 0 8-3.6 8-8s-3.6-8-8-8c-48.6 0-88-39.4-88-88z'
      
    ]
  };

  
    var faTint = faDroplet;
  

  
  

  var faCircleWifi = {
    prefix: 'fat',
    iconName: 'circle-wifi',
    icon: [
      512,
      512,
      [],
      'e67d',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm116.8-42.6c-3.3 3-8.3 2.7-11.3-.6s-2.7-8.3 .6-11.3C145.8 165.8 198.4 144 256 144s110.2 21.8 149.9 57.5c3.3 3 3.5 8 .6 11.3s-8 3.5-11.3 .6C358.3 180.2 309.5 160 256 160s-102.3 20.2-139.2 53.4zM272 352a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32-96c-26.8 0-51.3 10.2-69.7 26.8c-3.3 3-8.3 2.7-11.3-.6s-2.7-8.3 .6-11.3c21.3-19.2 49.5-31 80.5-31s59.2 11.7 80.5 31c3.3 3 3.5 8 .6 11.3s-8 3.5-11.3 .6C307.3 266.1 282.8 256 256 256z'
      
    ]
  };

  

  
  

  var faNotebook = {
    prefix: 'fat',
    iconName: 'notebook',
    icon: [
      512,
      512,
      [],
      'e201',
      
      'M208 16H416c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H208V16zm-16 0V496H128c-26.5 0-48-21.5-48-48V392h40c4.4 0 8-3.6 8-8s-3.6-8-8-8H80V264h40c4.4 0 8-3.6 8-8s-3.6-8-8-8H80V136h40c4.4 0 8-3.6 8-8s-3.6-8-8-8H80V64c0-26.5 21.5-48 48-48h64zM64 392v56c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H128C92.7 0 64 28.7 64 64v56H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H64V248H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H64V376H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H64z'
      
    ]
  };

  

  
  

  var faFolderMagnifyingGlass = {
    prefix: 'fat',
    iconName: 'folder-magnifying-glass',
    icon: [
      512,
      512,
      ["folder-search"],
      'e18b',
      
      'M448 464H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H197.5c12.7 0 24.9 5.1 33.9 14.1l35.9 35.9c9 9 21.2 14.1 33.9 14.1H448c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48zM64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H301.3c-8.5 0-16.6-3.4-22.6-9.4L242.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64zM240 192a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 176c23.6 0 45.3-8.5 62-22.7l52.4 52.4c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L313.3 334c14.2-16.7 22.7-38.4 22.7-62c0-53-43-96-96-96s-96 43-96 96s43 96 96 96z'
      
    ]
  };

  
    var faFolderSearch = faFolderMagnifyingGlass;
  

  
  

  var faCandyCorn = {
    prefix: 'fat',
    iconName: 'candy-corn',
    icon: [
      640,
      512,
      [],
      'f6bd',
      
      'M480 0c44.1 0 90.4 4.2 132.6 18.1C629 23.5 640 38.8 640 56c0 20.1-7 52-15.6 84c-9.1 33.8-21.4 73-34.7 110.4c-13.2 37.2-27.9 73.6-41.6 101.3c-13.4 27-32.9 64.3-68.1 64.3s-54.6-37.3-68.1-64.3c-13.8-27.7-28.4-64.1-41.6-101.3C357 213 344.7 173.8 335.6 140C327 108 320 76.1 320 56c0-17.2 11.4-32.6 27.8-38.1C390 4.4 436 0 480 0zM607.6 33.2C567.7 20.2 523.2 16 480 16c-43.1 0-87.2 4.3-127.3 17.1C342.8 36.5 336 45.9 336 56c0 16 5.3 42.1 12.7 70.8c1.6-.3 3.5-.7 5.7-1.2c7.7-1.5 18.5-3.5 31.5-5.6c25.9-4 60.4-8.1 94.1-8.1s68.2 4.1 94.1 8.1c13 2 23.9 4 31.5 5.6c2.2 .4 4.1 .8 5.7 1.2C618.7 98.1 624 72 624 56c0-10.3-6.6-19.5-16.4-22.8zm-254.8 109c8.7 31.8 20.2 68.1 32.6 102.8c2.2 6.1 4.4 12.1 6.6 18.1c25.1-3.7 56.8-7.2 88-7.2s62.9 3.5 88 7.2c2.2-6 4.4-12 6.6-18.1c12.3-34.7 23.8-70.9 32.6-102.8c-1.4-.3-2.9-.6-4.7-.9c-7.5-1.5-18.1-3.5-30.9-5.4c-25.5-4-59-7.9-91.7-7.9s-66.2 3.9-91.7 7.9c-12.7 2-23.4 4-30.9 5.4c-1.7 .3-3.3 .7-4.7 .9zm73.4 202.3c6.8 13.7 14.2 28 23.7 39c9.3 10.8 18.9 16.5 30.1 16.5s20.8-5.7 30.1-16.5c9.4-11 16.9-25.3 23.7-39c9.3-18.6 19-41.5 28.5-66.1c-24-3.4-53.5-6.5-82.2-6.5s-58.2 3.1-82.2 6.5c9.5 24.6 19.2 47.5 28.5 66.1zM84.7 204.5c31-31 66.6-60.7 106.1-80.6c15.3-7.7 33.8-4.7 46 7.5c14.1 14.1 31.7 41.6 48.1 70.1c17.4 30.1 36.4 66.4 53.3 102.1c16.9 35.5 32.2 71.4 42 100.5c9.5 28.4 22.1 68.4-2.6 93.1s-64.7 12.2-93.2 2.6c-29.1-9.8-65.1-25.1-100.6-42c-35.7-16.9-72-35.9-102.2-53.3c-28.5-16.5-56-34-70.1-48.1c-12.1-12.1-14.9-31-7.3-46.3c20.2-39.2 49.5-74.7 80.5-105.7zM198 138.1c-37.3 18.9-71.6 47.3-102 77.7c-30.3 30.3-58.4 64.4-77.5 101.6c-4.6 9.4-2.8 20.8 4.3 27.9c11.3 11.2 33.3 25.9 58.8 40.9c.9-1.4 2-3 3.2-4.8c4.3-6.5 10.6-15.5 18.3-26.1c15.4-21.1 36.8-48.2 60.6-71.9s50.9-45.1 71.9-60.5c10.6-7.7 19.6-14 26.1-18.3c1.8-1.2 3.4-2.3 4.8-3.2c-15-25.4-29.7-47.5-40.9-58.7c-7.3-7.3-18.4-9.1-27.5-4.5zM95.4 394.1c28.6 16.2 62.2 33.7 95.3 49.4c5.8 2.8 11.6 5.5 17.4 8.1c15-20.3 35-45 56.9-67s46.7-41.8 67-56.9c-2.6-5.8-5.4-11.6-8.1-17.4c-15.7-33.1-33.2-66.7-49.4-95.2c-1.2 .8-2.5 1.6-3.9 2.6c-6.3 4.2-15.2 10.3-25.6 17.9c-20.7 15.1-47.1 36-70.1 58.9s-43.8 49.3-59 70.1c-7.6 10.3-13.7 19.2-17.9 25.5c-1 1.5-1.8 2.8-2.6 3.9zm194.1 90.7c14.4 4.8 29.7 9.7 44.1 10.8c14.1 1.1 24.9-1.7 32.8-9.6s10.6-18.7 9.6-32.7c-1.1-14.4-5.9-29.7-10.8-44.1c-6.6-19.6-15.8-42.6-26.5-66.5c-19.3 14.5-42.2 33.1-62.4 53.3s-38.8 43.1-53.3 62.4c24 10.6 46.9 19.9 66.6 26.4z'
      
    ]
  };

  

  
  

  var faMessageQuote = {
    prefix: 'fat',
    iconName: 'message-quote',
    icon: [
      512,
      512,
      ["comment-alt-quote"],
      'e1e4',
      
      'M176 416c0-8.8-7.2-16-16-16H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H309.3c-3.5 0-6.8 1.1-9.6 3.2L176 496V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h80 16v16 64c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM208 128c8.8 0 16 7.2 16 16v24 24c0 8.8-7.2 16-16 16H160c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h48zm0 96c5.8 0 11.3-1.6 16-4.3V230c0 25.7-17.5 48.1-42.4 54.3l-15.5 3.9c-4.3 1.1-6.9 5.4-5.8 9.7s5.4 6.9 9.7 5.8l15.5-3.9c32.1-8 54.5-36.8 54.5-69.9V192 168 144c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32h48zm96-96h48c8.8 0 16 7.2 16 16v24 24c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm64 91.7V230c0 25.7-17.5 48.1-42.4 54.3l-15.5 3.9c-4.3 1.1-6.9 5.4-5.8 9.7s5.4 6.9 9.7 5.8l15.5-3.9c32.1-8 54.5-36.8 54.5-69.9V192 168 144c0-17.7-14.3-32-32-32H304c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32h48c5.8 0 11.3-1.6 16-4.3z'
      
    ]
  };

  
    var faCommentAltQuote = faMessageQuote;
  

  
  

  var faUserRobotXmarks = {
    prefix: 'fat',
    iconName: 'user-robot-xmarks',
    icon: [
      448,
      512,
      [],
      'e4a7',
      
      'M224 0c4.4 0 8 3.6 8 8V64h72c44.2 0 80 35.8 80 80v96c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V144c0-44.2 35.8-80 80-80h72V8c0-4.4 3.6-8 8-8zM144 80c-35.3 0-64 28.7-64 64v96c0 35.3 28.7 64 64 64H304c35.3 0 64-28.7 64-64V144c0-35.3-28.7-64-64-64H144zM16 136c0-4.4 3.6-8 8-8s8 3.6 8 8V248c0 4.4-3.6 8-8 8s-8-3.6-8-8V136zm408-8c4.4 0 8 3.6 8 8V248c0 4.4-3.6 8-8 8s-8-3.6-8-8V136c0-4.4 3.6-8 8-8zM16 448v16c0 17.7 14.3 32 32 32H80V448c0-17.7 14.3-32 32-32H336c17.7 0 32 14.3 32 32v48h32c17.7 0 32-14.3 32-32V448c0-44.2-35.8-80-80-80H96c-44.2 0-80 35.8-80 80zm384 64H368 352 96 80 48c-26.5 0-48-21.5-48-48V448c0-53 43-96 96-96H352c53 0 96 43 96 96v16c0 26.5-21.5 48-48 48zm-48-64c0-8.8-7.2-16-16-16H296v64h56V448zm-72-16H232v64h48V432zm-64 0H168v64h48V432zm-64 0H112c-8.8 0-16 7.2-16 16v48h56V432zm0-192c0-4.4 3.6-8 8-8s8 3.6 8 8v32c0 4.4-3.6 8-8 8s-8-3.6-8-8V240zm72-8c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8s-8-3.6-8-8V240c0-4.4 3.6-8 8-8zm56 8c0-4.4 3.6-8 8-8s8 3.6 8 8v32c0 4.4-3.6 8-8 8s-8-3.6-8-8V240zM197.7 133.7L171.3 160l26.3 26.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L160 171.3l-26.3 26.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L148.7 160l-26.3-26.3c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L160 148.7l26.3-26.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3zm52.7-11.3c3.1-3.1 8.2-3.1 11.3 0L288 148.7l26.3-26.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L299.3 160l26.3 26.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L288 171.3l-26.3 26.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L276.7 160l-26.3-26.3c-3.1-3.1-3.1-8.2 0-11.3z'
      
    ]
  };

  

  
  

  var faArrowDown = {
    prefix: 'fat',
    iconName: 'arrow-down',
    icon: [
      384,
      512,
      [8595],
      'f063',
      
      'M197.8 477.5c-1.5 1.6-3.6 2.5-5.8 2.5s-4.3-.9-5.8-2.5l-184-192c-3.1-3.2-2.9-8.3 .2-11.3s8.3-2.9 11.3 .2L184 452.1V40c0-4.4 3.6-8 8-8s8 3.6 8 8V452.1L370.2 274.5c3.1-3.2 8.1-3.3 11.3-.2s3.3 8.1 .2 11.3l-184 192z'
      
    ]
  };

  

  
  

  var faPersonSwimming = {
    prefix: 'fat',
    iconName: 'person-swimming',
    icon: [
      576,
      512,
      [127946,"swimmer"],
      'f5c4',
      
      'M314.4 203.7L433.8 306c3.2-1.8 6.4-3.8 9.4-5.9c1.6-1.1 3.1-2.1 4.8-3L338.2 203l-13.4-11.4c5.3-2.6 10.8-4.9 16.5-6.9c15.8-5.6 32.9-8.6 50.7-8.6h64c22.1 0 40-17.9 40-40s-17.9-40-40-40H392c-123.6 0-224.5 96.6-231.6 218.4c5.3 1.9 10.6 3.4 15.8 4.5C181 203.8 275.8 112 392 112h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H392c-26.6 0-51.8 6.2-74.2 17.2c-4.8 2.4-8.1 7-8.8 12.4s1.4 10.6 5.5 14.1zM144 160a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM96 224A64 64 0 1 0 96 96a64 64 0 1 0 0 128zM294.6 339.4c-3-4.3-10.2-4.3-13.2 0c-8 11.2-17.5 21.4-27.6 30.7C236.6 385.8 214.5 400 192 400s-44.6-14.2-61.8-29.9c-10.1-9.2-19.7-19.5-27.6-30.7c-1.5-2.1-3.9-3.4-6.6-3.4s-5.1 1.3-6.6 3.4c-7.3 10.3-15.9 19.6-25 28.3C48.7 382.5 28.3 396.9 7 399.6c-4.4 .6-7.5 4.6-6.9 8.9s4.6 7.5 8.9 6.9c26.5-3.3 50-20.7 66.4-36.1c8.8-8.3 15.9-16.4 20.6-22.2c5.2 6.4 13.2 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8l0 0 0 0c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c4.7 5.8 11.8 13.9 20.6 22.2c16.4 15.4 39.9 32.8 66.4 36.1c4.4 .6 8.4-2.6 8.9-6.9s-2.6-8.4-6.9-8.9c-21.3-2.7-41.7-17.1-57.4-31.9c-9.1-8.6-17.7-18-25-28.3c-1.5-2.1-3.9-3.4-6.6-3.4s-5.1 1.3-6.6 3.4c-7.9 11.2-17.5 21.5-27.6 30.7C428.6 385.8 406.5 400 384 400s-44.6-14.2-61.8-29.9c-10.1-9.2-19.6-19.5-27.6-30.7z'
      
    ]
  };

  
    var faSwimmer = faPersonSwimming;
  

  
  

  var faTRex = {
    prefix: 'fat',
    iconName: 't-rex',
    icon: [
      640,
      512,
      [],
      'e629',
      
      'M440.7 16c-26.5 0-50.6 15.5-61.5 39.6L359.3 99.3c-.5 1.1-1.2 2.1-2.2 2.8l-48 40c-1.4 1.2-3.3 1.9-5.1 1.9H271.7c-44 0-82.8 28.5-96.1 70.4l-13.2 41.9C154.9 279.9 133 296 108.2 296c-15.1 0-29.5-6-40.2-16.6l-1.7-1.7C54.6 265.9 48 250 48 233.4V203.2c0-4-5.3-5.5-7.4-2l-6.6 11c-11.8 19.7-18 42.2-18 65.1v3.4C16 351 73 408 143.4 408h64.8c-.1-1.3-.1-2.6-.1-3.9V368c0-4.4 3.6-8 8-8s8 3.6 8 8v36.1c0 10.6 4.2 20.8 11.7 28.3L292.3 489c4.5 4.5 10.6 7 17 7H392c4.4 0 8-3.6 8-8v-8c0-17.7-14.3-32-32-32h-8c-3.6 0-6.7-2.4-7.7-5.8l-16-56c-.9-3.2 .2-6.6 2.9-8.6C356.7 364.5 368 343.6 368 320c0-39.8-32.2-72-72-72c-4.4 0-8-3.6-8-8s3.6-8 8-8c48.6 0 88 39.4 88 88c0 26.8-12 50.8-30.8 66.9L366 432h2c26.5 0 48 21.5 48 48v8c0 13.3-10.7 24-24 24H309.3c-10.6 0-20.8-4.2-28.3-11.7l-56.6-56.6c-5.7-5.7-10-12.4-12.8-19.7H143.4C64.2 424 0 359.8 0 280.6v-3.4c0-25.8 7-51.2 20.3-73.3l6.6-11c10.4-17.4 37.1-10 37.1 10.3v30.2c0 12.4 4.9 24.2 13.7 33l1.7 1.7c7.7 7.7 18 12 28.9 12c17.8 0 33.6-11.5 38.9-28.5l13.2-41.9C175.7 161 220.8 128 271.7 128h29.4l44.4-37 19.1-42c13.6-29.8 43.3-49 76.1-49c14.1 0 27.8 3.5 39.9 10.1C485.5 8.7 490.7 8 496 8c22.3 0 41.6 13.1 50.6 32H568c39.8 0 72 32.2 72 72v40c0 20.9-16.1 38.1-36.5 39.9l-15.7 15.7C577.2 218.1 563 224 548.1 224h-73l-51.5 47.7 28.2 16.1c12.5 7.1 20.2 20.4 20.2 34.7V336c0 4.4-3.6 8-8 8s-8-3.6-8-8V322.6c0-8.6-4.6-16.6-12.1-20.8l-32.6-18.6-.8 .8c-1.7-5.5-3.9-10.8-6.3-15.9l62.4-57.8c1.5-1.4 3.4-2.1 5.4-2.1h76.1c10.6 0 20.8-4.2 28.3-11.7l4.3-4.3H557.3c-10.6 0-20.8-4.2-28.3-11.7L515.7 167c-4.5-4.5-10.6-7-17-7H480c-4.4 0-8-3.6-8-8s3.6-8 8-8h18.7c10.6 0 20.8 4.2 28.3 11.7L540.3 169c4.5 4.5 10.6 7 17 7H600c13.3 0 24-10.7 24-24V112c0-30.9-25.1-56-56-56H541.3c-3.4 0-6.4-2.1-7.5-5.3C528.2 35.1 513.4 24 496 24c-4.8 0-9.4 .8-13.6 2.4c-2.3 .8-4.8 .6-6.8-.7c-10.4-6.3-22.5-9.7-34.9-9.7zM480 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faPretzel = {
    prefix: 'fat',
    iconName: 'pretzel',
    icon: [
      512,
      512,
      [129384],
      'e441',
      
      'M16 178.6C16 106.5 74.5 48 146.6 48H152c38.6 0 73.5 16.1 98.2 41.9c1.5 1.6 3.6 2.5 5.8 2.5s4.3-.9 5.8-2.5C286.5 64.1 321.4 48 360 48h5.4C437.5 48 496 106.5 496 178.6c0 76.7-36.4 144.9-92.9 188.4c-3.4 2.6-4.1 7.4-1.7 10.9l24.9 35.9c10.1 14.5 6.4 34.5-8.1 44.5s-34.5 6.4-44.5-8.1l-30.1-43.4c0 0-.1-.1-.1-.1l-48.4-69.9c0 0-.1-.1-.1-.1l-32.5-46.9c-1.5-2.2-4-3.4-6.6-3.4s-5.1 1.3-6.6 3.4l-32.6 47c-1.5 2.2-1.9 5.1-.8 7.6s3.3 4.3 6 4.8c10.2 1.9 20.7 2.8 31.4 2.8H256h2.6c8.9 0 17.7-.7 26.3-2l39.3 56.8c-20.8 6-42.8 9.2-65.6 9.2H256h-2.6c-26.5 0-52-4.3-75.8-12.4c-3.4-1.1-7.1 .1-9.1 3l-30.1 43.5c-10.1 14.5-30 18.2-44.5 8.1s-18.2-30-8.1-44.5l24.8-35.9c0 0 0 0 0-.1l45.6-65.9 0 0c0 0 0 0 0-.1L210.2 234c9-13 13.8-28.4 13.8-44.2V184c0-39.8-32.2-72-72-72h-5.4C109.8 112 80 141.8 80 178.6c0 51.9 22.8 98.5 58.9 130.2l-36.6 52.9C49.6 318.1 16 252.3 16 178.6zM146.6 32C65.6 32 0 97.6 0 178.6c0 79.2 36.3 149.9 93.1 196.3L72.5 404.7c-15.1 21.8-9.7 51.7 12.1 66.8s51.7 9.7 66.8-12.1l26.8-38.7c23.8 7.4 49 11.3 75.2 11.3H256h2.6c26.2 0 51.4-4 75.2-11.3l26.8 38.7c15.1 21.8 45 27.2 66.8 12.1s27.2-45 12.1-66.8l-20.6-29.8C475.7 328.4 512 257.8 512 178.6C512 97.6 446.4 32 365.4 32H360c-40.2 0-76.8 15.6-104 41.1C228.8 47.6 192.2 32 152 32h-5.4zM96 178.6c0-27.9 22.7-50.6 50.6-50.6H152c30.9 0 56 25.1 56 56v5.7c0 12.6-3.8 24.8-11 35.1l-49 70.7C116.1 266.7 96 225 96 178.6zM304 184c0-30.9 25.1-56 56-56h5.4c27.9 0 50.6 22.7 50.6 50.6c0 46.4-20.1 88.2-52.1 117l-49-70.7c-7.1-10.3-11-22.6-11-35.1V184zm56-72c-39.8 0-72 32.2-72 72v5.7c0 15.8 4.8 31.2 13.8 44.2l54 78c1.3 1.8 3.2 3 5.4 3.4s4.4-.3 6.2-1.7c39.4-31.8 64.6-80.5 64.6-135c0-36.8-29.8-66.6-66.6-66.6H360zM253.4 336c-5.4 0-10.7-.3-16-.8L256 308.3l18.6 26.9c-5.3 .5-10.6 .8-16 .8H256h-2.6z'
      
    ]
  };

  

  
  

  var faQuotes = {
    prefix: 'fat',
    iconName: 'quotes',
    icon: [
      576,
      512,
      [],
      'e234',
      
      'M0 80C0 35.8 35.8 0 80 0h8c4.4 0 8 3.6 8 8s-3.6 8-8 8H80C44.7 16 16 44.7 16 80v28.2C24.5 100.6 35.7 96 48 96H80c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V160 144 80zm16 64v16 16c0 17.7 14.3 32 32 32H80c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32H48c-17.7 0-32 14.3-32 32zM160 80c0-44.2 35.8-80 80-80h8c4.4 0 8 3.6 8 8s-3.6 8-8 8h-8c-35.3 0-64 28.7-64 64v28.2c8.5-7.6 19.7-12.2 32-12.2h32c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V160 144 80zm16 80v16c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32H208c-17.7 0-32 14.3-32 32v16zM576 432c0 44.2-35.8 80-80 80h-8c-4.4 0-8-3.6-8-8s3.6-8 8-8h8c35.3 0 64-28.7 64-64V403.8c-8.5 7.6-19.7 12.2-32 12.2H496c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v16 16 64zm-16-64V352 336c0-17.7-14.3-32-32-32H496c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32zM416 432c0 44.2-35.8 80-80 80h-8c-4.4 0-8-3.6-8-8s3.6-8 8-8h8c35.3 0 64-28.7 64-64V403.8c-8.5 7.6-19.7 12.2-32 12.2H336c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48l0 16v16 64zm-16-80l0-16c0-17.7-14.3-32-32-32H336c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V352z'
      
    ]
  };

  

  
  

  var faGreaterThan = {
    prefix: 'fat',
    iconName: 'greater-than',
    icon: [
      384,
      512,
      [62769],
      '3e',
      
      'M8.8 76.4c-2 4-.4 8.8 3.6 10.7L350.1 256 12.4 424.8c-4 2-5.6 6.8-3.6 10.7s6.8 5.6 10.7 3.6l352-176c2.7-1.4 4.4-4.1 4.4-7.2s-1.7-5.8-4.4-7.2l-352-176c-4-2-8.8-.4-10.7 3.6z'
      
    ]
  };

  

  
  

  var faFile = {
    prefix: 'fat',
    iconName: 'file',
    icon: [
      384,
      512,
      [61462,128196,128459],
      'f15b',
      
      'M320 496c26.5 0 48-21.5 48-48V179.9c0-1.3-.1-2.6-.2-3.9H248c-22.1 0-40-17.9-40-40V16.2c-1.3-.2-2.6-.2-3.9-.2H64C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48H320zm41.1-336c-.8-1-1.6-1.9-2.4-2.7L226.7 25.4c-.9-.9-1.8-1.7-2.7-2.4V136c0 13.3 10.7 24 24 24H361.1zM0 64C0 28.7 28.7 0 64 0H204.1c12.7 0 24.9 5.1 33.9 14.1L369.9 145.9c9 9 14.1 21.2 14.1 33.9V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64z'
      
    ]
  };

  

  
  

  var faBoxOpenFull = {
    prefix: 'fat',
    iconName: 'box-open-full',
    icon: [
      640,
      512,
      ["box-full"],
      'f49c',
      
      'M510.9 12.1c2.3-3.8 1-8.7-2.7-11s-8.7-1-11 2.7l-72 120c-2.3 3.8-1 8.7 2.7 11s8.7 1 11-2.7l72-120zM256 16c61.9 0 112 50.1 112 112c0 4.4 3.6 8 8 8s8-3.6 8-8C384 57.3 326.7 0 256 0S128 57.3 128 128c0 4.4 3.6 8 8 8s8-3.6 8-8c0-61.9 50.1-112 112-112zM61.4 174.6c1.4-3.4 4.9-5.5 8.6-4.9l236.3 33.8L232.7 312.7c-5.7 8.4-16.1 12.4-25.9 9.8L39.1 279.1c-9.3-2.4-14.4-12.5-10.8-21.4l33.2-83zm10.8-20.8c-11-1.6-21.6 4.6-25.7 14.8l-33.2 83c-7.2 17.9 3 38 21.7 42.9l167.7 43.5c16.4 4.3 33.7-2.3 43.2-16.4l74-110 74 110c9.5 14.1 26.8 20.6 43.2 16.4L605 294.6c18.7-4.8 28.8-25 21.7-42.9l-33.2-83c-4.1-10.3-14.7-16.4-25.7-14.8L320 189.3 72.2 153.9zM560 336.1v74.4c0 14.7-10 27.5-24.2 31L328 493.5V296c0-4.4-3.6-8-8-8s-8 3.6-8 8V493.5L104.2 441.6C90 438 80 425.2 80 410.5V336.1l-16-4.6v79c0 22 15 41.2 36.4 46.6l208 52c7.6 1.9 15.6 1.9 23.3 0l208-52c21.4-5.3 36.4-24.5 36.4-46.6v-79l-16 4.6zm10-166.4c3.7-.5 7.2 1.5 8.6 4.9l33.2 83c3.6 9-1.5 19-10.8 21.4L433.3 322.6c-9.9 2.6-20.2-1.4-25.9-9.8L333.8 203.4 570 169.7z'
      
    ]
  };

  
    var faBoxFull = faBoxOpenFull;
  

  
  

  var faCrab = {
    prefix: 'fat',
    iconName: 'crab',
    icon: [
      512,
      512,
      [129408],
      'e3ff',
      
      'M104 16c-48.6 0-88 39.4-88 88v8H122.7c6.4 0 12.5-2.5 17-7l6.6-6.6c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-6.6 6.6c-7.5 7.5-17.7 11.7-28.3 11.7H16v12.1c0 14.4 7.7 27.6 20.2 34.7l86.7 49.5C145.5 204.3 175.3 192 208 192V136c0-4.4 3.6-8 8-8s8 3.6 8 8v56h64V136c0-4.4 3.6-8 8-8s8 3.6 8 8v56c32.7 0 62.5 12.3 85.1 32.4l86.7-49.5c12.5-7.1 20.2-20.4 20.2-34.7V128H389.3c-10.6 0-20.8-4.2-28.3-11.7l-6.6-6.6c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l6.6 6.6c4.5 4.5 10.6 7 17 7H496v-8c0-48.6-39.4-88-88-88H356.9l55.2 33.1c3.8 2.3 5 7.2 2.7 11s-7.2 5-11 2.7l-80-48c-3.1-1.9-4.6-5.5-3.6-9s4.1-5.9 7.7-5.9h80c57.4 0 104 46.6 104 104v16 20.1c0 20.1-10.8 38.7-28.2 48.6l-83 47.4C413.5 250.9 423 268.6 428 288h28.9c8.7 0 17.3-2 25-5.9l18.5-9.2c4-2 8.8-.4 10.7 3.6s.4 8.8-3.6 10.7l-18.5 9.2c-10 5-21 7.6-32.2 7.6H431c.7 5.2 1 10.6 1 16v13.3l12 5c11.2 4.7 21 12 28.5 21.5L494.2 387c2.8 3.4 2.2 8.5-1.3 11.2s-8.5 2.2-11.2-1.2L460 369.8c-5.9-7.3-13.5-13.1-22.2-16.7l-15.1-6.3-44 51.4 35.4 13.5c9.5 3.6 18.1 9.2 25.3 16.4l22.3 22.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L428 439.3c-5.6-5.6-12.3-9.9-19.7-12.7l-40.7-15.5-22.4 26.1L372 458.5c7.6 6.1 12 15.3 12 25V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V483.5c0-4.9-2.2-9.5-6-12.5l-28.8-23H178.8L150 471c-3.8 3-6 7.6-6 12.5V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V483.5c0-9.7 4.4-18.9 12-25l26.7-21.4-22.4-26.1-40.7 15.5c-7.4 2.8-14.1 7.2-19.7 12.7L61.7 461.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L72.7 428c7.2-7.2 15.8-12.8 25.3-16.4l35.4-13.5-44-51.4-15.1 6.3c-8.7 3.6-16.3 9.4-22.2 16.7L30.2 397c-2.8 3.4-7.8 4-11.2 1.2s-4-7.8-1.2-11.2l21.8-27.2c7.6-9.4 17.4-16.8 28.5-21.5l12-5V320c0-5.4 .3-10.8 1-16H55.1c-11.2 0-22.2-2.6-32.2-7.6L4.4 287.2c-4-2-5.6-6.8-3.6-10.7s6.8-5.6 10.7-3.6l18.5 9.2c7.8 3.9 16.4 5.9 25 5.9H84c5-19.4 14.5-37.1 27.2-51.8l-83-47.4C10.8 178.8 0 160.2 0 140.1V120 104C0 46.6 46.6 0 104 0h80c3.6 0 6.7 2.4 7.7 5.9s-.5 7.1-3.6 9l-80 48c-3.8 2.3-8.7 1-11-2.7s-1-8.7 2.7-11L155.1 16H104zM296 208H216h-8c-61.9 0-112 50.1-112 112v10.1L183.4 432H328.6L416 330.1V320c0-61.9-50.1-112-112-112h-8z'
      
    ]
  };

  

  
  

  var faLocationDot = {
    prefix: 'fat',
    iconName: 'location-dot',
    icon: [
      384,
      512,
      ["map-marker-alt"],
      'f3c5',
      
      'M368 192c0-97.2-78.8-176-176-176S16 94.8 16 192c0 18.7 6.4 42.5 17.8 69.6c11.3 26.9 27.1 55.8 44.7 84.3c35.2 57 76.8 111.4 102.3 143.2c5.9 7.3 16.6 7.3 22.4 0c25.5-31.8 67.1-86.2 102.3-143.2c17.6-28.5 33.4-57.4 44.7-84.3C361.6 234.5 368 210.7 368 192zm16 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM192 112a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm64 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z'
      
    ]
  };

  
    var faMapMarkerAlt = faLocationDot;
  

  
  

  var faDialMedLow = {
    prefix: 'fat',
    iconName: 'dial-med-low',
    icon: [
      576,
      512,
      [],
      'e160',
      
      'M272 32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM186.2 186.2l.4-.4-.8 .8 .4-.4zm0 203.6C131.8 335.5 130 248.5 180.7 192L282.3 293.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L192 180.7c56.5-50.7 143.5-48.8 197.8 5.5c56.2 56.2 56.2 147.4 0 203.6s-147.4 56.2-203.6 0zm-11.3-215A160 160 0 1 0 401.1 401.1 160 160 0 1 0 174.9 174.9zM544 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM16 288a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0A32 32 0 1 0 0 288a32 32 0 1 0 64 0zM96 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM464 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 464a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm368-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faCircle0 = {
    prefix: 'fat',
    iconName: 'circle-0',
    icon: [
      512,
      512,
      [],
      'e0ed',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-53 0-96 43-96 96v64c0 53 43 96 96 96s96-43 96-96V224c0-53-43-96-96-96zm-80 96c0-44.2 35.8-80 80-80s80 35.8 80 80v64c0 44.2-35.8 80-80 80s-80-35.8-80-80V224z'
      
    ]
  };

  

  
  

  var faHandshakeAngle = {
    prefix: 'fat',
    iconName: 'handshake-angle',
    icon: [
      640,
      512,
      ["hands-helping"],
      'f4c4',
      
      'M493.7 2.3c3.1 3.1 3.1 8.2 0 11.3L439 68.3C431.5 75.8 421.4 80 410.7 80H296c-39.8 0-72 32.2-72 72v96c0 22.1 17.9 40 40 40s40-17.9 40-40V160c0-4.4 3.6-8 8-8s8 3.6 8 8v48H456c30.9 0 56 25.1 56 56c0 23.7-14.8 44-35.6 52.2c2.3 6.2 3.6 12.9 3.6 19.8c0 28.2-20.9 51.6-48 55.4l0 .6c0 30.9-25.1 56-56 56H245.3c-6.4 0-12.5 2.5-17 7l-54.6 54.6c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L217 443.7c7.5-7.5 17.7-11.7 28.3-11.7H376c22.1 0 40-17.9 40-40c0-2.3-.2-4.5-.6-6.7c-.4-2.3 .3-4.7 1.8-6.5s3.8-2.8 6.2-2.8l.6 0c22.1 0 40-17.9 40-40c0-7.6-2.1-14.7-5.8-20.7c-1.4-2.2-1.5-5-.5-7.4s3.2-4.1 5.8-4.6C482 299.8 496 283.5 496 264c0-22.1-17.9-40-40-40H320v24c0 30.9-25.1 56-56 56s-56-25.1-56-56V152c0-48.6 39.4-88 88-88H410.7c6.4 0 12.5-2.5 17-7L482.3 2.3c3.1-3.1 8.2-3.1 11.3 0zM125 201.1c9-24.1 27.9-42.5 51-51.3v17.4c-16.3 7.9-29.3 21.8-36 39.5l-26.1 69.6c-2 5.3-5.1 10.2-9.2 14.2L13.7 381.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l91.1-91.1c2.4-2.4 4.3-5.3 5.5-8.5L125 201.1zm512.6-70.8c3.1 3.1 3.1 8.2 0 11.3l-97.3 97.3c-1.7-5.6-3.9-11-6.6-16.1l92.5-92.5c3.1-3.1 8.2-3.1 11.3 0z'
      
    ]
  };

  
    var faHandsHelping = faHandshakeAngle;
  

  
  

  var faAccentGrave = {
    prefix: 'fat',
    iconName: 'accent-grave',
    icon: [
      192,
      512,
      [],
      '60',
      
      'M55.6 86.6c-5-7.4-7.6-16.3-7.6-25.3C48 36.4 68.2 16 93 16c21.8 0 40.4 15.6 44.3 37.1l24.2 135.7c1.8 10-5.9 19.3-16.1 19.3c-5.5 0-10.6-2.7-13.6-7.3L55.6 86.6zM42.3 95.5l76.1 114.1c6 9 16.1 14.4 26.9 14.4c20.2 0 35.4-18.2 31.9-38.1L153 50.2C147.8 21.2 122.5 0 93 0C59.3 0 32 27.6 32 61.3c0 12.1 3.6 24.1 10.3 34.2z'
      
    ]
  };

  

  
  

  var faPaintRoller = {
    prefix: 'fat',
    iconName: 'paint-roller',
    icon: [
      512,
      512,
      [],
      'f5aa',
      
      'M352 16c26.5 0 48 21.5 48 48V96c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H352zM64 0C28.7 0 0 28.7 0 64V96c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V88 72 64c0-35.3-28.7-64-64-64H64zM240 336c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H208c-17.7 0-32-14.3-32-32V368c0-17.7 14.3-32 32-32h32zm-32-16c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48h-8V288c0-22.1 17.9-40 40-40H448c30.9 0 56-25.1 56-56V128c0-30.9-25.1-56-56-56V88c22.1 0 40 17.9 40 40v64c0 22.1-17.9 40-40 40H272c-30.9 0-56 25.1-56 56v32h-8z'
      
    ]
  };

  

  
  

  var faTrafficLightStop = {
    prefix: 'fat',
    iconName: 'traffic-light-stop',
    icon: [
      320,
      512,
      [],
      'f63a',
      
      'M256 16c26.5 0 48 21.5 48 48V352c0 79.5-64.5 144-144 144S16 431.5 16 352V64c0-26.5 21.5-48 48-48H256zM64 0C28.7 0 0 28.7 0 64V352c0 88.4 71.6 160 160 160s160-71.6 160-160V64c0-35.3-28.7-64-64-64H64zm96 432a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm0-96a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm40-80a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zm-96 0a56 56 0 1 0 112 0 56 56 0 1 0 -112 0zm56-96a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm0-96a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0 40a16 16 0 1 0 0 32 16 16 0 1 0 0-32z'
      
    ]
  };

  

  
  

  var faPhoneSlash = {
    prefix: 'fat',
    iconName: 'phone-slash',
    icon: [
      640,
      512,
      [],
      'f3dd',
      
      'M64 64C64 46 76 30.2 93.5 25.4l88-24c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L208 207.3c5.2 10.9 10.9 21.6 17.2 31.8l-12.6 10c-7-11.2-13.3-22.9-19-35c-3.1-6.6-1.3-14.6 4.3-19.2l49.3-40.4c8.2-6.7 11-18 7-27.8l-40-96c-4.6-11.1-16.8-17.1-28.5-13.9l-88 24C87.2 43.7 80 53.2 80 64c0 86.6 25.5 167.3 69.4 235l-12.6 10C90.7 238.5 64 154.4 64 64zM512 496c10.8 0 20.3-7.2 23.2-17.7l24-88c3.2-11.6-2.8-23.8-13.9-28.5l-96-40c-9.8-4.1-21.1-1.3-27.8 7L381 378.1c-4.6 5.7-12.6 7.5-19.2 4.3c-17.4-8.2-33.9-17.8-49.6-28.6l13.2-10.4c13.7 9.2 28.2 17.4 43.3 24.5L409 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C545.8 499.9 530 512 512 512c-104.9 0-201.5-36.1-277.8-96.5l12.9-10.2C320.2 462.2 412.2 496 512 496zM627 1.7C630.5-1 635.5-.4 638.3 3s2.2 8.5-1.3 11.2L13 510.3C9.5 513 4.5 512.4 1.7 509S-.4 500.5 3 497.7L627 1.7z'
      
    ]
  };

  

  
  

  var faStarOfLife = {
    prefix: 'fat',
    iconName: 'star-of-life',
    icon: [
      512,
      512,
      [],
      'f621',
      
      'M208 32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V172.9l122-70.4c15.3-8.8 34.9-3.6 43.7 11.7l16 27.7c8.8 15.3 3.6 34.9-11.7 43.7L352 256l122 70.4c15.3 8.8 20.5 28.4 11.7 43.7l-16 27.7c-8.8 15.3-28.4 20.6-43.7 11.7L304 339.1V480c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V339.1L86 409.6c-15.3 8.8-34.9 3.6-43.7-11.7l-16-27.7c-8.8-15.3-3.6-34.9 11.7-43.7L160 256 38 185.6c-15.3-8.8-20.5-28.4-11.7-43.7l16-27.7C51.1 98.8 70.7 93.6 86 102.4l122 70.4V32zm32-16c-8.8 0-16 7.2-16 16V186.7c0 2.9-1.5 5.5-4 6.9s-5.5 1.4-8 0L78 116.3c-7.7-4.4-17.4-1.8-21.9 5.9l-16 27.7c-4.4 7.7-1.8 17.4 5.9 21.9l134 77.4c2.5 1.4 4 4.1 4 6.9s-1.5 5.5-4 6.9L46 340.3c-7.7 4.4-10.3 14.2-5.9 21.9l16 27.7c4.4 7.7 14.2 10.3 21.9 5.9l134-77.4c2.5-1.4 5.5-1.4 8 0s4 4.1 4 6.9V480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V325.3c0-2.9 1.5-5.5 4-6.9s5.5-1.4 8 0l134 77.4c7.7 4.4 17.4 1.8 21.9-5.9l16-27.7c4.4-7.7 1.8-17.4-5.9-21.9L332 262.9c-2.5-1.4-4-4.1-4-6.9s1.5-5.5 4-6.9l134-77.4c7.7-4.4 10.3-14.2 5.9-21.9l-16-27.7c-4.4-7.7-14.2-10.3-21.9-5.9L300 193.6c-2.5 1.4-5.5 1.4-8 0s-4-4.1-4-6.9V32c0-8.8-7.2-16-16-16H240z'
      
    ]
  };

  

  
  

  var faPlugCircleXmark = {
    prefix: 'fat',
    iconName: 'plug-circle-xmark',
    icon: [
      576,
      512,
      [],
      'e560',
      
      'M112 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V112h16V8zM288 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V112h16V8zM8 144c-4.4 0-8 3.6-8 8s3.6 8 8 8H40v80c0 81.3 63.8 147.6 144 151.8V504c0 4.4 3.6 8 8 8s8-3.6 8-8V391.8c20-1 39-6 56.3-14c-.2-3.2-.3-6.5-.3-9.8c0-2.7 .1-5.4 .2-8.1c-19.1 10.3-41 16.1-64.2 16.1c-75.1 0-136-60.9-136-136V160H328v66c5.1-3.8 10.5-7.3 16-10.5V160h32c4.4 0 8-3.6 8-8s-3.6-8-8-8H344 328 56 40 8zM304 368a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-82.3-50.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L432 356.7l-50.3-50.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L420.7 368l-50.3 50.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L432 379.3l50.3 50.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L443.3 368l50.3-50.3z'
      
    ]
  };

  

  
  

  var faHexagonCheck = {
    prefix: 'fat',
    iconName: 'hexagon-check',
    icon: [
      512,
      512,
      [],
      'e416',
      
      'M400.8 450.8l0 0L497.1 284c2.5-4.3 4.4-8.9 5.6-13.6c2-7.7 2.4-15.7 1.1-23.6c-1.1-6.5-3.3-12.9-6.7-18.8L400.8 61.2c-10-17.3-28.5-28-48.5-28H159.7c-20 0-38.5 10.7-48.5 28L14.9 228c-3.9 6.7-6.3 14.1-7.1 21.6c-1.4 11.8 1 23.9 7.1 34.4l96.3 166.8c10 17.3 28.5 28 48.5 28H352.3c20 0 38.5-10.7 48.5-28zM483.2 236c2.7 4.6 4.4 9.7 5 14.8l-2.7 20.4c-.7 1.6-1.5 3.2-2.3 4.8L386.9 442.8c-7.1 12.4-20.4 20-34.6 20H159.7c-14.3 0-27.5-7.6-34.6-20L28.8 276c-3.6-6.2-5.4-13.1-5.4-20c0-3.4 .4-6.8 1.3-10.1c.9-3.4 2.2-6.8 4.1-9.9L125.1 69.2c7.1-12.4 20.4-20 34.6-20l192.6 0c14.3 0 27.5 7.6 34.6 20L483.2 236zM357.7 197.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L224 308.7l-58.3-58.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l64 64c3.1 3.1 8.2 3.1 11.3 0l128-128z'
      
    ]
  };

  

  
  

  var faBowlSpoon = {
    prefix: 'fat',
    iconName: 'bowl-spoon',
    icon: [
      512,
      512,
      [129379],
      'e3e0',
      
      'M217.6 112c-6.5 0-12.3 3.9-14.8 9.9C190.3 152.3 155.3 176 112 176c-55.4 0-96-38-96-80s40.6-80 96-80c43.3 0 78.3 23.7 90.8 54.1c2.5 6 8.3 9.9 14.8 9.9H480c8.8 0 16 7.2 16 16s-7.2 16-16 16H217.6zM112 0C50.1 0 0 43 0 96s50.1 96 112 96c48.8 0 90.3-26.7 105.6-64H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H217.6C202.3 26.7 160.8 0 112 0zm32.6 470.2c-1-4.9-4.2-9.1-8.7-11.3c-65.5-32-111.8-97.4-116.4-174.7L18 256.9c-.5-9.2 6.8-16.9 16-16.9H478.1c9.2 0 16.5 7.7 16 16.9l-1.6 27.3c-4.5 77.3-50.9 142.7-116.4 174.7c-4.5 2.2-7.7 6.4-8.7 11.3C364.5 484.9 351.5 496 336 496H176c-15.5 0-28.5-11.1-31.4-25.8zM33.9 224C15.5 224 .9 239.5 2 257.9l1.6 27.3c4.9 83.3 54.8 153.7 125.3 188.2c4.3 22 23.8 38.7 47.1 38.7H336c23.3 0 42.8-16.6 47.1-38.7c70.5-34.5 120.4-104.9 125.3-188.2l1.6-27.3c1.1-18.4-13.5-33.9-31.9-33.9H33.9z'
      
    ]
  };

  

  
  

  var faSuperscript = {
    prefix: 'fat',
    iconName: 'superscript',
    icon: [
      512,
      512,
      [],
      'f12b',
      
      'M464 8c0-2.7-1.3-5.1-3.5-6.6s-5-1.8-7.5-.8l-40 16c-4.1 1.6-6.1 6.3-4.5 10.4s6.3 6.1 10.4 4.5l29-11.6V144H416c-4.4 0-8 3.6-8 8s3.6 8 8 8h40 40c4.4 0 8-3.6 8-8s-3.6-8-8-8H464V8zM8 64c-4.4 0-8 3.6-8 8s3.6 8 8 8H36L166.1 256 36 432H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H40c2.5 0 4.9-1.2 6.4-3.2L176 269.5 305.6 444.8c1.5 2 3.9 3.2 6.4 3.2h32c4.4 0 8-3.6 8-8s-3.6-8-8-8H316L185.9 256 316 80h28c4.4 0 8-3.6 8-8s-3.6-8-8-8H312c-2.5 0-4.9 1.2-6.4 3.2L176 242.5 46.4 67.2c-1.5-2-3.9-3.2-6.4-3.2H8z'
      
    ]
  };

  

  
  

  var faArrowsFromLine = {
    prefix: 'fat',
    iconName: 'arrows-from-line',
    icon: [
      448,
      512,
      [],
      'e0a4',
      
      'M218.3 2.3c3.1-3.1 8.2-3.1 11.3 0l88 88c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L232 27.3V184c0 4.4-3.6 8-8 8s-8-3.6-8-8V27.3l-74.3 74.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l88-88zm11.3 507.3c-3.1 3.1-8.2 3.1-11.3 0l-88-88c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L216 484.7V328c0-4.4 3.6-8 8-8s8 3.6 8 8V484.7l74.3-74.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-88 88zM8 248H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faFilePpt = {
    prefix: 'fat',
    iconName: 'file-ppt',
    icon: [
      512,
      512,
      [],
      'e64a',
      
      'M64 496h48v16H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H204.1c12.7 0 24.9 5.1 33.9 14.1L369.9 145.9c9 9 14.1 21.2 14.1 33.9V304H368V179.9c0-1.3-.1-2.6-.2-3.9H248c-22.1 0-40-17.9-40-40V16.2c-1.3-.2-2.6-.2-3.9-.2H64C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48zM361.1 160c-.8-1-1.6-1.9-2.4-2.7L226.7 25.4c-.9-.9-1.8-1.7-2.7-2.4V136c0 13.3 10.7 24 24 24H361.1zM304 368h32c26.5 0 48 21.5 48 48s-21.5 48-48 48H312v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V456 376c0-4.4 3.6-8 8-8zm32 80c17.7 0 32-14.3 32-32s-14.3-32-32-32H312v64h24zM176 368h32c26.5 0 48 21.5 48 48s-21.5 48-48 48H184v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V456 376c0-4.4 3.6-8 8-8zm32 80c17.7 0 32-14.3 32-32s-14.3-32-32-32H184v64h24zm208-72c0-4.4 3.6-8 8-8h40 40c4.4 0 8 3.6 8 8s-3.6 8-8 8H472V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V384H424c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faPinata = {
    prefix: 'fat',
    iconName: 'pinata',
    icon: [
      512,
      512,
      [],
      'e3c3',
      
      'M176 40c0-22.1 17.9-40 40-40s40 17.9 40 40V232H424c48.6 0 88 39.4 88 88V472c0 22.1-17.9 40-40 40H440c-22.1 0-40-17.9-40-40V448c0-17.6-11.3-32.5-27.1-37.9c-5-1.4-10.1-2.1-15.3-2.1H264c-22.1 0-40 17.9-40 40v24c0 22.1-17.9 40-40 40H136c-22.1 0-40-17.9-40-40V220.9L37.2 191.6C14.4 180.1 0 156.8 0 131.3C0 94.1 30.1 64 67.3 64H176V40zm88 352h93.6H360c6.2 0 12.2 1 17.8 2.9c.9 .3 1.7 .5 2.6 .8l33.1 11c1.6 .5 3.4 .5 5.1 0l37.4-12.5c5.4-1.8 11.2-1.6 16.5 .5l23.6 9.4V331.6l-3.8 1.5c-6.1 2.3-12.9 2.1-18.8-.8L452 322.2c-2-.9-4.2-1-6.3-.3l-29.3 11.1c-6.1 2.3-12.9 2.1-18.8-.8l-21.4-10.1c-2-.9-4.2-1-6.3-.3l-29.3 11.1c-6.1 2.3-12.9 2.1-18.8-.8l-21.4-10.1c-2-.9-4.2-1-6.3-.3l-29.3 11.1c-6.1 2.3-12.9 2.1-18.8-.8l-21.4-10.1c-2-.9-4.2-1-6.3-.3L189 333.1c-6.1 2.3-12.9 2.1-18.8-.8l-21.4-10.1c-2-.9-4.2-1-6.3-.3L112 333.5v70.7l23.6-9.4c5.3-2.1 11.1-2.3 16.5-.5l37.4 12.5c1.6 .5 3.4 .5 5.1 0l33.1-11c7.3-2.4 15-3.7 22.8-3.7H264zM112 316.4l24.9-9.5c6.1-2.3 12.9-2.1 18.8 .8l21.4 10.1c2 .9 4.2 1 6.3 .3l29.3-11.1c6.1-2.3 12.9-2.1 18.8 .8l21.4 10.1c2 .9 4.2 1 6.3 .3l29.3-11.1c6.1-2.3 12.9-2.1 18.8 .8l21.4 10.1c2 .9 4.2 1 6.3 .3l29.3-11.1c6.1-2.3 12.9-2.1 18.8 .8l21.4 10.1c2 .9 4.2 1 6.3 .3L440 306.9c6.1-2.3 12.9-2.1 18.8 .8l21.4 10.1c2 .9 4.2 1 6.3 .3l9.3-3.5C493 277.3 461.9 248 424 248H249.4l-38.8 13.8c-4.8 1.7-10 1.8-14.9 .4l-44-13c-1.6-.5-3.4-.4-5 .1L112 261.6v54.8zM240 40c0-13.3-10.7-24-24-24s-24 10.7-24 24V72c0 4.4-3.6 8-8 8H67.3C39 80 16 103 16 131.3c0 19.4 11 37.2 28.4 45.9l63.2 31.6c2.7 1.4 4.4 4.1 4.4 7.2v28.7l29.4-10.5c4.8-1.7 10-1.8 14.9-.4l44 13c1.6 .5 3.4 .4 5-.1L240 234.4V40zM112 421.4V472c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V448c0-12 3.8-23.2 10.3-32.3l-18.7 6.2c-4.9 1.6-10.3 1.6-15.2 0L147 409.4c-1.8-.6-3.7-.5-5.5 .2L112 421.4zm384 0l-29.5-11.8c-1.8-.7-3.7-.8-5.5-.2l-37.4 12.5c-4.5 1.5-9.3 1.6-13.8 .4c4 7.7 6.2 16.4 6.2 25.7v24c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V421.4zM176 128a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z'
      
    ]
  };

  

  
  

  var faXmarkLarge = {
    prefix: 'fat',
    iconName: 'xmark-large',
    icon: [
      448,
      512,
      [],
      'e59b',
      
      'M13.7 34.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L212.7 256 2.3 466.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L224 267.3 434.3 477.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L235.3 256 445.7 45.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L224 244.7 13.7 34.3z'
      
    ]
  };

  

  
  

  var faCandyBar = {
    prefix: 'fat',
    iconName: 'candy-bar',
    icon: [
      640,
      512,
      [127851,"chocolate-bar"],
      'e3e8',
      
      'M165.2 70c.9-3.5 4.1-6 7.7-6H320h8 8H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H336h-8-8H56c-30.9 0-56-25.1-56-56V237c0-3.7 2.5-6.8 6-7.7C44 219.5 72 185 72 144c0-4.4 3.6-8 8-8c41 0 75.5-28 85.2-66zM184 80V192H320V80H184zm-16 23.4c-17.1 27.1-46.5 45.8-80.3 48.3c-1.1 14.4-5.1 28.1-11.4 40.3H168V103.4zM66 208c-12.7 16.2-30 28.5-50 35v77H168V208H66zM16 336v56c0 22.1 17.9 40 40 40H168V336H16zm168 96H320V336H184v96zM336 320v16 96H576c26.5 0 48-21.5 48-48V128c0-26.5-21.5-48-48-48H336V192v16V320zM320 208H184V320H320V208z'
      
    ]
  };

  
    var faChocolateBar = faCandyBar;
  

  
  

  var faBell = {
    prefix: 'fat',
    iconName: 'bell',
    icon: [
      448,
      512,
      [61602,128276],
      'f0f3',
      
      'M216 8c0-4.4 3.6-8 8-8s8 3.6 8 8V32l0 .2c84.6 4.2 152 74.1 152 159.8v36.6c0 41.8 14.2 82.3 40.3 114.9l16.7 20.9c4.5 5.6 6.9 12.6 6.9 19.8c0 17.5-14.2 31.7-31.7 31.7H31.7C14.2 416 0 401.8 0 384.3c0-7.2 2.4-14.2 6.9-19.8l16.7-20.9C49.8 311 64 270.4 64 228.6V192c0-85.7 67.4-155.6 152-159.8l0-.2V8zm8 40C144.5 48 80 112.5 80 192v36.6c0 45.4-15.5 89.5-43.8 124.9L19.4 374.5c-2.2 2.8-3.4 6.2-3.4 9.8C16 393 23 400 31.7 400H416.3c8.7 0 15.7-7 15.7-15.7c0-3.6-1.2-7-3.4-9.8l-16.7-20.9C383.5 318.1 368 274.1 368 228.6V192c0-79.5-64.5-144-144-144zM176 448c0 12.7 5.1 24.9 14.1 33.9s21.2 14.1 33.9 14.1s24.9-5.1 33.9-14.1s14.1-21.2 14.1-33.9c0-4.4 3.6-8 8-8s8 3.6 8 8c0 17-6.7 33.3-18.7 45.3s-28.3 18.7-45.3 18.7s-33.3-6.7-45.3-18.7s-18.7-28.3-18.7-45.3c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faTemperatureFull = {
    prefix: 'fat',
    iconName: 'temperature-full',
    icon: [
      320,
      512,
      ["temperature-4","thermometer-4","thermometer-full"],
      'f2c7',
      
      'M160 16c-35.3 0-64 28.7-64 64V243.8c0 8.4-4.4 15.7-10.7 20.3C53 287.3 32 325.2 32 368c0 70.7 57.3 128 128 128s128-57.3 128-128c0-42.8-21-80.7-53.3-104c-6.3-4.6-10.7-11.9-10.7-20.3V80c0-35.3-28.7-64-64-64zM80 80c0-44.2 35.8-80 80-80s80 35.8 80 80V243.8c0 2.7 1.4 5.4 4 7.3c36.3 26.1 60 68.8 60 117c0 79.5-64.5 144-144 144S16 447.5 16 368c0-48.2 23.7-90.8 60-117c2.6-1.9 4-4.6 4-7.3V80zm80 336a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 16c-35.3 0-64-28.7-64-64c0-32.6 24.4-59.6 56-63.5V72c0-4.4 3.6-8 8-8s8 3.6 8 8V304.5c31.6 3.9 56 30.9 56 63.5c0 35.3-28.7 64-64 64z'
      
    ]
  };

  
    var faTemperature4 = faTemperatureFull;
  
    var faThermometer4 = faTemperatureFull;
  
    var faThermometerFull = faTemperatureFull;
  

  
  

  var faBee = {
    prefix: 'fat',
    iconName: 'bee',
    icon: [
      576,
      512,
      [],
      'e0b2',
      
      'M205.7 2.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l39.5 39.5C217.9 67.8 208 88.7 208 112c0 3 .2 6 .5 8.9C185.7 105 157 96 128 96C63 96 0 140.9 0 208c0 61.9 53.6 104.9 112.9 111.2c-.6-5.1-.9-10.2-.9-15.2l0-1c-52.4-6.5-96-44.6-96-95c0-55.4 52.8-96 112-96c45.2 0 86.6 23.6 103.7 59.4C180.2 193.3 144 244.4 144 304c0 83.8 103.6 179.7 129.9 202.8c3.9 3.4 8.9 5.2 14.1 5.2s10.2-1.8 14.1-5.2C328.4 483.7 432 387.8 432 304c0-59.6-36.2-110.7-87.7-132.6C361.4 135.6 402.8 112 448 112c59.2 0 112 40.6 112 96c0 50.4-43.6 88.5-96 95l0 1c0 5-.3 10.1-.9 15.2C522.4 312.9 576 269.9 576 208c0-67.1-63-112-128-112c-29 0-57.7 9-80.5 24.9c.3-2.9 .5-5.9 .5-8.9c0-23.3-9.9-44.2-25.8-58.9l39.5-39.5c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-40 40c-.4 .4-.7 .8-1 1.2C317.3 36.2 303.1 32 288 32s-29.3 4.2-41.4 11.5c-.3-.4-.6-.8-1-1.2l-40-40zM324.4 164.6c-11.6-3-23.8-4.6-36.4-4.6s-24.8 1.6-36.4 4.6C234.9 153.1 224 133.8 224 112c0-35.3 28.7-64 64-64s64 28.7 64 64c0 21.8-10.9 41.1-27.6 52.6zM406.7 256c6 14.8 9.3 31 9.3 48H160c0-17 3.3-33.2 9.3-48H406.7zm-7.8-16H177.1c22.1-38.3 63.5-64 110.9-64s88.7 25.7 110.9 64zM161.4 320H414.6c-2.6 15.6-8.7 31.8-17.2 48H178.6c-8.5-16.2-14.6-32.4-17.2-48zm226.9 64c-7.1 11.7-15.3 23.2-24 34.3c-4.1 5.2-8.2 10.2-12.3 15.1V432H224v1.4c-4.1-4.9-8.3-9.9-12.3-15.1c-8.7-11.1-16.9-22.7-24-34.3H388.3zm-49.2 64c-20.1 22-38.5 38.8-47.6 46.8c-.8 .7-2 1.2-3.5 1.2s-2.7-.5-3.5-1.2c-9.1-7.9-27.6-24.8-47.6-46.8H339.2z'
      
    ]
  };

  

  
  

  var faPodcast = {
    prefix: 'fat',
    iconName: 'podcast',
    icon: [
      448,
      512,
      [],
      'f2ce',
      
      'M316.8 410.2C385.1 376.1 432 305.5 432 224c0-114.9-93.1-208-208-208S16 109.1 16 224c0 81.5 46.9 152.1 115.2 186.2c.8 5.2 1.6 10.3 2.4 15.4l.6 3.7C55.2 394.6 0 315.8 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224c0 91.8-55.2 170.7-134.2 205.3l.6-3.8c.8-5 1.6-10.1 2.4-15.2zm-2.2-95.8C337.7 291.3 352 259.3 352 224c0-70.7-57.3-128-128-128S96 153.3 96 224c0 35.3 14.3 67.3 37.4 90.4c-2.7 5.2-4.6 10.7-5.9 16.4C98.3 304.5 80 266.4 80 224c0-79.5 64.5-144 144-144s144 64.5 144 144c0 42.4-18.3 80.5-47.5 106.9c-1.3-5.7-3.3-11.2-5.9-16.4zM224 272a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-112a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM173.4 349.5c0 40.4 13 104.9 20.9 134l0 0c1.2 4.6 4 7.5 8.7 9.4c5.1 2.1 12.2 3.1 21 3.1s15.9-.9 21-3c4.7-2 7.5-4.8 8.7-9.4c3.8-14.2 9.1-39.8 13.4-65.9c4.3-26.2 7.5-52.4 7.5-68.1c0-6.4-1.6-11.1-4.1-14.6c-2.5-3.6-6.2-6.5-10.9-8.7c-9.8-4.6-23-6.1-35.6-6.1s-25.8 1.5-35.6 6.1c-4.8 2.3-8.4 5.2-10.9 8.7c-2.4 3.5-4.1 8.2-4.1 14.6zM224 304c13.3 0 29.4 1.5 42.4 7.7c6.6 3.2 12.7 7.7 17.2 14.1c4.5 6.5 6.9 14.4 6.9 23.7c0 17.1-3.4 44.4-7.7 70.7c-4.3 26.4-9.7 52.5-13.7 67.5l0 0c-2.7 10.1-9.5 16.5-18 20c-8 3.4-17.7 4.3-27.1 4.3s-19.1-.9-27.1-4.3c-8.4-3.5-15.2-9.9-18-20c-8.1-29.6-21.5-95.8-21.5-138.2c0-9.4 2.4-17.3 6.9-23.7c4.4-6.4 10.6-10.9 17.2-14.1c13-6.2 29.1-7.7 42.4-7.7z'
      
    ]
  };

  

  
  

  var faCalendarUsers = {
    prefix: 'fat',
    iconName: 'calendar-users',
    icon: [
      640,
      512,
      [],
      'e5e2',
      
      'M216 0c4.4 0 8 3.6 8 8V64H416V8c0-4.4 3.6-8 8-8s8 3.6 8 8V64h48c35.3 0 64 28.7 64 64v48 16H528 480 160 112 96V176 128c0-35.3 28.7-64 64-64h48V8c0-4.4 3.6-8 8-8zm31.4 512c2.9-5 5.1-10.3 6.5-16H386c1.5 5.7 3.7 11 6.5 16H247.4zM208 120V80H160c-26.5 0-48 21.5-48 48v48H528V128c0-26.5-21.5-48-48-48H432v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V80H224v40c0 4.4-3.6 8-8 8s-8-3.6-8-8zM528 368a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-48 64c-26.5 0-48 21.5-48 48c0 8.8 7.2 16 16 16H608c8.8 0 16-7.2 16-16c0-26.5-21.5-48-48-48H480zM448 304a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM416 480c0-35.3 28.7-64 64-64h96c35.3 0 64 28.7 64 64c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32zM176 304A64 64 0 1 0 48 304a64 64 0 1 0 128 0zM16 480c0 8.8 7.2 16 16 16H192c8.8 0 16-7.2 16-16c0-26.5-21.5-48-48-48H64c-26.5 0-48 21.5-48 48zm96-256a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM64 416h96c35.3 0 64 28.7 64 64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32c0-35.3 28.7-64 64-64z'
      
    ]
  };

  

  
  

  var faSquareEllipsisVertical = {
    prefix: 'fat',
    iconName: 'square-ellipsis-vertical',
    icon: [
      448,
      512,
      [],
      'e26f',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM224 240a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16-80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 176a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faClockTwo = {
    prefix: 'fat',
    iconName: 'clock-two',
    icon: [
      512,
      512,
      [],
      'e35a',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM264 104V241.1l83.6-55.7c3.7-2.5 8.6-1.5 11.1 2.2s1.5 8.6-2.2 11.1l-96 64c-2.5 1.6-5.6 1.8-8.2 .4s-4.2-4.1-4.2-7.1V104c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faSquareC = {
    prefix: 'fat',
    iconName: 'square-c',
    icon: [
      448,
      512,
      [],
      'e266',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144.8 80.8c-43.7 43.7-43.7 114.7 0 158.4s114.7 43.7 158.4 0c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3c-50 50-131 50-181 0s-50-131 0-181s131-50 181 0c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0c-43.7-43.7-114.7-43.7-158.4 0z'
      
    ]
  };

  

  
  

  var faSquareH = {
    prefix: 'fat',
    iconName: 'square-h',
    icon: [
      448,
      512,
      ["h-square"],
      'f0fd',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm304 40c0-4.4 3.6-8 8-8s8 3.6 8 8V256 376c0 4.4-3.6 8-8 8s-8-3.6-8-8V264H144l0 112c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-240c0-4.4 3.6-8 8-8s8 3.6 8 8V248H304V136z'
      
    ]
  };

  
    var faHSquare = faSquareH;
  

  
  

  var faBookCopy = {
    prefix: 'fat',
    iconName: 'book-copy',
    icon: [
      576,
      512,
      [],
      'e0be',
      
      'M208 56c0-22.1 17.9-40 40-40H544c8.8 0 16 7.2 16 16V288c0 8.8-7.2 16-16 16h-8H248c-15.7 0-29.8 6.4-40 16.8V56zM192 359.6l0 .1 0 .3c0 30.9 25.1 56 56 56H536h32c4.4 0 8-3.6 8-8s-3.6-8-8-8H544V320c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H248c-30.9 0-56 25.1-56 56V359.6zM528 320v80H248c-22.1 0-40-17.9-40-40s17.9-40 40-40H528zM352 496V448H336v48H56c-22.1 0-40-17.9-40-40s17.9-40 40-40H180.1c-4.1-4.9-7.6-10.3-10.5-16H56c-15.7 0-29.8 6.4-40 16.8V152c0-22.1 17.9-40 40-40H160V96H56C25.1 96 0 121.1 0 152V455.6l0 .1 0 .3c0 30.9 25.1 56 56 56H344h32c4.4 0 8-3.6 8-8s-3.6-8-8-8H352z'
      
    ]
  };

  

  
  

  var faBed = {
    prefix: 'fat',
    iconName: 'bed',
    icon: [
      640,
      512,
      [128716],
      'f236',
      
      'M16 40c0-4.4-3.6-8-8-8s-8 3.6-8 8V328v80 64c0 4.4 3.6 8 8 8s8-3.6 8-8V416H624v56c0 4.4 3.6 8 8 8s8-3.6 8-8V408 328 232c0-57.4-46.6-104-104-104H312c-22.1 0-40 17.9-40 40V320H16V40zM624 400H16V336H280 624v64zm0-168v88H288V168c0-13.3 10.7-24 24-24H536c48.6 0 88 39.4 88 88zM80 208a64 64 0 1 1 128 0A64 64 0 1 1 80 208zm144 0A80 80 0 1 0 64 208a80 80 0 1 0 160 0z'
      
    ]
  };

  

  
  

  var faPersonFairy = {
    prefix: 'fat',
    iconName: 'person-fairy',
    icon: [
      640,
      512,
      [],
      'e608',
      
      'M320 112a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM320 0a64 64 0 1 1 0 128A64 64 0 1 1 320 0zM297.6 176c-33.3 0-61 25.5-63.8 58.7L229.7 284c-2.3 28 19.8 52 47.8 52H304h32 26.4c28.1 0 50.2-24 47.8-52l-4.1-49.3c-2.8-33.2-30.5-58.7-63.8-58.7H297.6zM312 352V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V344.8c-22.1-11.5-36.4-35.4-34.2-62.1l4.1-49.3c3.5-41.5 38.1-73.4 79.7-73.4h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.2 26.7-12.2 50.6-34.2 62.1V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H312zm64 128V350.6c-4.4 .9-8.9 1.4-13.6 1.4H344V480c0 8.8 7.2 16 16 16s16-7.2 16-16zM296 352H277.6c-4.7 0-9.2-.5-13.6-1.4V480c0 8.8 7.2 16 16 16s16-7.2 16-16V352zM112 464c38.3 0 74-11.2 104-30.6v18.7C185.4 469.9 149.9 480 112 480H96c-17.7 0-32-14.3-32-32c0-45.7 14.7-88 39.7-122.3C40.6 275.9 0 198.7 0 112V64C0 46.3 14.3 32 32 32c89.4 0 169.4 40.8 222.2 104.7c-5.1 2.1-10 4.6-14.6 7.5C189.7 85.4 115.2 48 32 48c-8.8 0-16 7.2-16 16v48c0 81.6 38.1 154.2 97.6 201.2l6 4.8c3.4 2.7 4 7.5 1.5 11l-4.5 6.2C93.6 366.8 80 405.8 80 448c0 8.8 7.2 16 16 16h16zm312-11.8V433.4c30 19.4 65.7 30.6 104 30.6h16c8.8 0 16-7.2 16-16c0-42.2-13.6-81.2-36.7-112.9l-4.5-6.2c-2.5-3.5-1.9-8.3 1.5-11l6-4.8C585.9 266.2 624 193.6 624 112V64c0-8.8-7.2-16-16-16c-83.2 0-157.7 37.4-207.6 96.2c-4.7-2.8-9.5-5.3-14.6-7.5C438.6 72.8 518.6 32 608 32c17.7 0 32 14.3 32 32v48c0 86.7-40.6 163.9-103.7 213.7C561.3 360 576 402.3 576 448c0 17.7-14.3 32-32 32H528c-37.9 0-73.4-10.1-104-27.8z'
      
    ]
  };

  

  
  

  var faMedal = {
    prefix: 'fat',
    iconName: 'medal',
    icon: [
      512,
      512,
      [127941],
      'f5a2',
      
      'M106.4 191.5c3.8-3.9 7.7-7.6 11.7-11.2L17.4 29.3c-.9-1.4-1.4-3.1-1.4-4.7c0-4.7 3.8-8.6 8.6-8.6H141.9c5.6 0 10.8 2.9 13.7 7.8L220 131.1c5.7-1 11.5-1.8 17.3-2.3l-68-113.3C163.5 5.9 153.1 0 141.9 0H24.6C11 0 0 11 0 24.6c0 4.8 1.4 9.6 4.1 13.6L106.4 191.5zm168.3-62.7c5.8 .5 11.6 1.3 17.3 2.3L356.4 23.8c2.9-4.8 8.1-7.8 13.7-7.8H487.4c4.7 0 8.6 3.8 8.6 8.6c0 1.7-.5 3.3-1.4 4.7l-100.7 151c4.1 3.6 8 7.3 11.7 11.2L507.9 38.2c2.7-4 4.1-8.8 4.1-13.6C512 11 501 0 487.4 0H370.1c-11.2 0-21.7 5.9-27.4 15.5l-68 113.3zM256 176a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 336a176 176 0 1 0 0-352 176 176 0 1 0 0 352zm33.5-222.1L270.3 251c-5.9-11.9-22.8-11.9-28.7 0l-19.2 38.9-42.9 6.2c-13.1 1.9-18.4 18-8.9 27.3l31 30.2-7.3 42.7c-2.2 13.1 11.5 23 23.2 16.9L256 393l38.4 20.2c11.7 6.2 25.5-3.8 23.2-16.9l-7.3-42.7 31-30.2c9.5-9.3 4.3-25.4-8.9-27.3l-42.9-6.2zM256 258.1l19.2 38.9c2.3 4.7 6.8 8 12 8.8l42.9 6.2-31 30.2c-3.8 3.7-5.5 9-4.6 14.2l7.3 42.7-38.4-20.2c-4.7-2.5-10.2-2.5-14.9 0L210.2 399l7.3-42.7c.9-5.2-.8-10.5-4.6-14.2l-31-30.2 42.9-6.2c5.2-.8 9.7-4 12-8.8L256 258.1z'
      
    ]
  };

  

  
  

  var faTemperatureArrowUp = {
    prefix: 'fat',
    iconName: 'temperature-arrow-up',
    icon: [
      576,
      512,
      ["temperature-up"],
      'e040',
      
      'M112 80c0-35.3 28.7-64 64-64s64 28.7 64 64V243.8c0 8.4 4.4 15.7 10.7 20.3C283 287.3 304 325.2 304 368c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-42.8 21-80.7 53.3-104c6.3-4.6 10.7-11.9 10.7-20.3V80zM176 0C131.8 0 96 35.8 96 80V243.8c0 2.7-1.4 5.4-4 7.3c-36.3 26.1-60 68.8-60 117c0 79.5 64.5 144 144 144s144-64.5 144-144c0-48.2-23.7-90.8-60-117c-2.6-1.9-4-4.6-4-7.3V80c0-44.2-35.8-80-80-80zM128 368a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0c0-32.6-24.4-59.6-56-63.5V72c0-4.4-3.6-8-8-8s-8 3.6-8 8V304.5c-31.6 3.9-56 30.9-56 63.5c0 35.3 28.7 64 64 64s64-28.7 64-64zM450.3 34.3l-80 80c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L448 59.3V472c0 4.4 3.6 8 8 8s8-3.6 8-8V59.3l66.3 66.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-80-80c-3.1-3.1-8.2-3.1-11.3 0z'
      
    ]
  };

  
    var faTemperatureUp = faTemperatureArrowUp;
  

  
  

  var faFileCircleXmark = {
    prefix: 'fat',
    iconName: 'file-circle-xmark',
    icon: [
      576,
      512,
      [],
      'e5a1',
      
      'M64 496H311.2c5.8 5.5 12 10.6 18.5 15.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H204.1c12.7 0 24.9 5.1 33.9 14.1L369.9 145.9c9 9 14.1 21.2 14.1 33.9v18.7c-5.4 1.5-10.8 3.3-16 5.4V179.9c0-1.3-.1-2.6-.2-3.9H248c-22.1 0-40-17.9-40-40V16.2c-1.3-.2-2.6-.2-3.9-.2H64C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48zM361.1 160c-.8-1-1.6-1.9-2.4-2.7L226.7 25.4c-.9-.9-1.8-1.7-2.7-2.4V136c0 13.3 10.7 24 24 24H361.1zM560 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm205.7-50.3L443.3 368l50.3 50.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L432 379.3l-50.3 50.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L420.7 368l-50.3-50.3c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L432 356.7l50.3-50.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3z'
      
    ]
  };

  

  
  

  var faTruckDroplet = {
    prefix: 'fat',
    iconName: 'truck-droplet',
    icon: [
      640,
      512,
      [],
      'e58c',
      
      'M352 16c26.5 0 48 21.5 48 48V400H236.7c-10.4-36.9-44.4-64-84.7-64s-74.2 27.1-84.7 64H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H352zM64 416h.4c-.2 2.6-.4 5.3-.4 8c0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8H400h.4c-.2 2.6-.4 5.3-.4 8c0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8H632c4.4 0 8-3.6 8-8s-3.6-8-8-8H608V229.3c0-10.6-4.2-20.8-11.7-28.3L503 107.7c-7.5-7.5-17.7-11.7-28.3-11.7H416V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64zM416 112h58.7c6.4 0 12.5 2.5 17 7L585 212.3c1.1 1.1 2.2 2.4 3 3.7H416V112zm0 261.4V232H592V400H572.7c-10.4-36.9-44.4-64-84.7-64c-29.8 0-56.1 14.8-72 37.4zM152 352a72 72 0 1 1 0 144 72 72 0 1 1 0-144zm264 72a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zM272 211c0 33.1-28.1 61-64 61s-64-27.9-64-61c0-4.8 1.9-12.7 6.2-23.4c4.2-10.4 10.2-22 17.1-34c13.4-23.5 29.6-47.1 40.7-62.6c11.1 15.5 27.3 39.1 40.7 62.6c6.9 12 12.8 23.6 17.1 34c4.4 10.7 6.2 18.6 6.2 23.4zm16 0c0-32-45.2-98.9-67.6-130.2c-6.1-8.6-18.6-8.6-24.8 0C173.2 112.1 128 179 128 211c0 42.5 35.8 77 80 77s80-34.5 80-77z'
      
    ]
  };

  

  
  

  var faDrone = {
    prefix: 'fat',
    iconName: 'drone',
    icon: [
      512,
      512,
      [],
      'f85f',
      
      'M112 16c-53 0-96 43-96 96c0 48 35.2 87.8 81.2 94.9c4.8 .7 9.7 1.1 14.8 1.1c4.4 0 8 3.6 8 8s-3.6 8-8 8c-5.9 0-11.6-.4-17.2-1.3C41.1 214.4 0 168 0 112C0 50.1 50.1 0 112 0c56 0 102.4 41.1 110.7 94.8c.9 5.6 1.3 11.4 1.3 17.2c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-5-.4-10-1.1-14.8C199.8 51.2 160 16 112 16zm0 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM72 112c0-22.1 17.9-40 40-40s40 17.9 40 40c0 8.2-2.4 15.7-6.6 22.1L171.3 160H340.7l25.9-25.9c-4.2-6.3-6.6-13.9-6.6-22.1c0-22.1 17.9-40 40-40s40 17.9 40 40s-17.9 40-40 40c-8.2 0-15.7-2.4-22.1-6.6L352 171.3V340.7l25.9 25.9c6.3-4.2 13.9-6.6 22.1-6.6c22.1 0 40 17.9 40 40s-17.9 40-40 40s-40-17.9-40-40c0-8.2 2.4-15.7 6.6-22.1L340.7 352H171.3l-25.9 25.9c4.2 6.3 6.6 13.9 6.6 22.1c0 22.1-17.9 40-40 40s-40-17.9-40-40s17.9-40 40-40c8.2 0 15.7 2.4 22.1 6.6L160 340.7V171.3l-25.9-25.9c-6.3 4.2-13.9 6.6-22.1 6.6c-22.1 0-40-17.9-40-40zm40 264a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm264 24a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM400 88a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM176 336H336V176H176V336zM496 112c0-53-43-96-96-96c-48 0-87.8 35.2-94.9 81.2c-.7 4.8-1.1 9.7-1.1 14.8c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-5.9 .4-11.6 1.3-17.2C297.6 41.1 344 0 400 0c61.9 0 112 50.1 112 112c0 56-41.1 102.4-94.8 110.7c-5.6 .9-11.4 1.3-17.2 1.3c-4.4 0-8-3.6-8-8s3.6-8 8-8c5 0 10-.4 14.8-1.1c46-7.1 81.2-46.9 81.2-94.9zM112 496c48 0 87.8-35.2 94.9-81.2c.7-4.8 1.1-9.8 1.1-14.8c0-4.4 3.6-8 8-8s8 3.6 8 8c0 5.9-.4 11.6-1.3 17.2C214.4 470.9 168 512 112 512C50.1 512 0 461.9 0 400c0-56 41.1-102.4 94.8-110.7c5.6-.9 11.4-1.3 17.2-1.3c4.4 0 8 3.6 8 8s-3.6 8-8 8c-5 0-10 .4-14.8 1.1C51.2 312.2 16 352 16 400c0 53 43 96 96 96zm384-96c0-48-35.2-87.8-81.2-94.9c-4.8-.7-9.8-1.1-14.8-1.1c-4.4 0-8-3.6-8-8s3.6-8 8-8c5.9 0 11.6 .4 17.2 1.3C470.9 297.6 512 344 512 400c0 61.9-50.1 112-112 112c-56 0-102.4-41.1-110.7-94.8c-.9-5.6-1.3-11.4-1.3-17.2c0-4.4 3.6-8 8-8s8 3.6 8 8c0 5 .4 10 1.1 14.8c7.1 46 46.9 81.2 94.9 81.2c53 0 96-43 96-96z'
      
    ]
  };

  

  
  

  var faDiceD20 = {
    prefix: 'fat',
    iconName: 'dice-d20',
    icon: [
      512,
      512,
      [],
      'f6cf',
      
      'M242.9 22.5L58 133.5l83.6 62.7L242.9 22.5zM48 146V359.9l85.6-149.7L48 146zM68.4 384.8L248 492.5V391.7L68.4 384.8zM264 492.5L443.6 384.8 264 391.7V492.5zM464 359.9V146l-85.5 64.2L464 359.9zM454 133.5l-185-111L370.4 196.2 454 133.5zM243.7 3.4c7.6-4.6 17.1-4.6 24.7 0l200 120c7.2 4.3 11.7 12.1 11.7 20.6V368c0 8.4-4.4 16.2-11.7 20.6l-200 120c-7.6 4.6-17.1 4.6-24.7 0l-200-120C36.4 384.2 32 376.4 32 368V144c0-8.4 4.4-16.2 11.7-20.6l200-120zm-2.6 372L144.4 223.5l-82.9 145 179.6 6.9zM353.4 216H158.6L256 369.1 353.4 216zM256 31.9L157.9 200H354.1L256 31.9zm14.9 343.5l179.6-6.9-82.9-145L270.9 375.4z'
      
    ]
  };

  

  
  

  var faBeerMug = {
    prefix: 'fat',
    iconName: 'beer-mug',
    icon: [
      512,
      512,
      ["beer-foam"],
      'e0b3',
      
      'M208 0c28.1 0 53.2 13.2 69.3 33.7c.2 .3 .7 .6 1.5 .7s1.4-.2 1.8-.5C293.2 22.8 309.8 16 328 16c39.8 0 72 32.2 72 72s-32.2 72-72 72c-18.2 0-34.8-6.8-47.5-17.9c-.4-.3-1-.6-1.8-.5s-1.3 .4-1.5 .7C261.2 162.8 236.1 176 208 176s-53.2-13.2-69.3-33.7c-.2-.3-.7-.6-1.5-.7s-1.4 .2-1.8 .5C122.8 153.2 106.2 160 88 160c-39.8 0-72-32.2-72-72s32.2-72 72-72c18.2 0 34.8 6.8 47.5 17.9c.4 .3 1 .6 1.8 .5s1.3-.4 1.5-.7C154.8 13.2 179.9 0 208 0zM151.3 43.6c-6.5 8.2-18.8 9-26.4 2.3C115.1 37.2 102.2 32 88 32C57.1 32 32 57.1 32 88s25.1 56 56 56c14.2 0 27.1-5.2 36.9-13.9c7.6-6.7 19.9-5.9 26.4 2.3C164.5 149.2 185 160 208 160s43.5-10.8 56.7-27.6c6.5-8.2 18.8-9 26.4-2.3c9.9 8.7 22.8 13.9 36.9 13.9c30.9 0 56-25.1 56-56s-25.1-56-56-56c-14.2 0-27.1 5.2-36.9 13.9c-7.6 6.7-19.9 5.9-26.4-2.3C251.5 26.8 231 16 208 16s-43.5 10.8-56.7 27.6zM368 448V432.2v-.4V184v0c0-4.4 3.6-8 8-8h7.4l.6-.3v.3h72c30.9 0 56 25.1 56 56V334.1c0 28.6-16.9 54.5-43.1 66L384 437.2V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V175.7c5.1 3.2 10.4 6 16 8.4V448c0 26.5 21.5 48 48 48H320c26.5 0 48-21.5 48-48zm94.4-62.6c20.4-8.9 33.6-29.1 33.6-51.3V232c0-22.1-17.9-40-40-40H384V419.8l78.4-34.3zM144 232V440c0 4.4-3.6 8-8 8s-8-3.6-8-8V232c0-4.4 3.6-8 8-8s8 3.6 8 8zm72 0V440c0 4.4-3.6 8-8 8s-8-3.6-8-8V232c0-4.4 3.6-8 8-8s8 3.6 8 8zm72 0V440c0 4.4-3.6 8-8 8s-8-3.6-8-8V232c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  
    var faBeerFoam = faBeerMug;
  

  
  

  var faFileHeart = {
    prefix: 'fat',
    iconName: 'file-heart',
    icon: [
      384,
      512,
      [],
      'e176',
      
      'M16 448V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm44.6 304.6c0-20.2 16.4-36.6 36.6-36.6h.6c9.7 0 19 3.8 26 10.5l14.6 14.2c3.1 3 8 3 11.2 0l14.6-14.2c7-6.8 16.3-10.5 26-10.5h.6c20.2 0 36.6 16.4 36.6 36.6c0 9.3-3.6 18.3-10 25.1l-67.6 71.7c-1.5 1.6-3.6 2.5-5.8 2.5s-4.3-.9-5.8-2.5l-67.6-71.7c-6.4-6.8-10-15.8-10-25.1zM145.2 252c-29.1 0-52.6 23.6-52.6 52.6c0 13.4 5.1 26.3 14.3 36.1l67.6 71.7c4.5 4.8 10.9 7.5 17.5 7.5s12.9-2.7 17.5-7.5l67.6-71.7c9.2-9.8 14.3-22.7 14.3-36.1c0-29.1-23.6-52.6-52.6-52.6h-.6c-13.9 0-27.2 5.4-37.1 15.1l-9 8.8-9-8.8c-9.9-9.7-23.3-15.1-37.1-15.1h-.6z'
      
    ]
  };

  

  
  

  var faMessageDots = {
    prefix: 'fat',
    iconName: 'message-dots',
    icon: [
      512,
      512,
      ["comment-alt-dots","messaging"],
      'f4a3',
      
      'M176 416c0-8.8-7.2-16-16-16H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H309.3c-3.5 0-6.8 1.1-9.6 3.2L176 496V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h80 16v16 64c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm80 208a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm144 32a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm128 48a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z'
      
    ]
  };

  
    var faCommentAltDots = faMessageDots;
  
    var faMessaging = faMessageDots;
  

  
  

  var faHandBackPointLeft = {
    prefix: 'fat',
    iconName: 'hand-back-point-left',
    icon: [
      512,
      512,
      [],
      'e19f',
      
      'M0 172c0-28.7 23.3-52 52-52l188 0 9.6 0c3.7-6 7.8-11.8 12.5-17.3l24.7-29.2c13.7-16.2 33.8-25.5 55-25.5l24 0c48.8 0 93.9 26.2 118.1 68.5l10.3 18C505.8 155.1 512 178.3 512 202l0 142c0 57.4-46.6 104-104 104l-16 0-84 0-4 0c-.8 0-1.5-.1-2.2-.3C271.5 444.5 248 419 248 388c0-3.6 .3-7.1 .9-10.5C229.4 367.7 216 347.4 216 324c0-6.1 .9-12 2.6-17.6C198.2 296.8 184 276.1 184 252c0-10.1 2.5-19.6 6.9-28L52 224c-28.7 0-52-23.3-52-52zm268.8-52l75.2 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-89.8 0L240 136 52 136c-19.9 0-36 16.1-36 36s16.1 36 36 36l154.5 0c3.2 0 6.1 1.9 7.4 4.9s.6 6.4-1.6 8.7c-7.6 7.9-12.2 18.6-12.2 30.5c0 19.9 13.2 36.7 31.3 42.1c2.2 .7 4.1 2.3 5 4.4s.9 4.6-.1 6.7c-2.7 5.7-4.2 12-4.2 18.8c0 19 12.1 35.2 29 41.4c4 1.5 6.2 5.8 4.9 9.8c-1.2 4-1.9 8.3-1.9 12.8c0 23.1 17.9 42.1 40.6 43.9c.3 0 .6 .1 1 .1l2.5 0 84 0 16 0c48.6 0 88-39.4 88-88l0-142c0-20.9-5.4-41.4-15.8-59.5l-10.3-18C448.5 87.1 408.8 64 365.7 64l-24 0c-16.5 0-32.1 7.3-42.7 19.8L274.2 113c-1.9 2.3-3.7 4.6-5.5 7z'
      
    ]
  };

  

  
  

  var faArrowsLeftRightToLine = {
    prefix: 'fat',
    iconName: 'arrows-left-right-to-line',
    icon: [
      640,
      512,
      [],
      'e4ba',
      
      'M8 64c4.4 0 8 3.6 8 8l0 368c0 4.4-3.6 8-8 8s-8-3.6-8-8V72c0-4.4 3.6-8 8-8zm197.7 90.3c3.1 3.1 3.1 8.2 0 11.3L123.3 248l393.4 0-82.3-82.3c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l96 96c3.1 3.1 3.1 8.2 0 11.3l-96 96c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L516.7 264l-393.4 0 82.3 82.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-96-96c-3.1-3.1-3.1-8.2 0-11.3l96-96c3.1-3.1 8.2-3.1 11.3 0zM640 72V440c0 4.4-3.6 8-8 8s-8-3.6-8-8V72c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faBluetooth = {
    prefix: 'fat',
    iconName: 'bluetooth',
    icon: [
      384,
      512,
      [],
      'f293',
      
      'M188.6 .7c2.8-1.3 6.1-.9 8.5 1.1l152 128c1.8 1.5 2.9 3.8 2.8 6.2s-1.2 4.7-3 6.2L202.3 258.1 349.1 377.8c1.9 1.5 3 3.8 2.9 6.3s-1.1 4.7-3 6.2l-152 120c-2.4 1.9-5.7 2.3-8.4 .9s-4.5-4.1-4.5-7.2V272.5L45 382.3c-3.5 2.7-8.5 2.1-11.2-1.3s-2.1-8.5 1.3-11.2L176.7 257.9 34.9 142.2c-3.4-2.8-3.9-7.8-1.1-11.3s7.8-3.9 11.3-1.1L184 243.1V8c0-3.1 1.8-5.9 4.6-7.3zM200 276.9V487.5L331.2 383.9 200 276.9zm0-37.4L331.3 135.8 200 25.2V239.5z'
      
    ]
  };

  

  
  

  var faChartSimpleHorizontal = {
    prefix: 'fat',
    iconName: 'chart-simple-horizontal',
    icon: [
      448,
      512,
      [],
      'e474',
      
      'M432 240c0-17.7-14.3-32-32-32L48 208c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l352 0c17.7 0 32-14.3 32-32l0-32zm16 32c0 26.5-21.5 48-48 48L48 320c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48l352 0c26.5 0 48 21.5 48 48l0 32zM240 400c0-17.7-14.3-32-32-32L48 368c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-32zm16 32c0 26.5-21.5 48-48 48L48 480c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48l160 0c26.5 0 48 21.5 48 48l0 32zM368 112l0-32c0-17.7-14.3-32-32-32L48 48C30.3 48 16 62.3 16 80l0 32c0 17.7 14.3 32 32 32l288 0c17.7 0 32-14.3 32-32zm-32 48L48 160c-26.5 0-48-21.5-48-48L0 80C0 53.5 21.5 32 48 32l288 0c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48z'
      
    ]
  };

  

  
  

  var faMountainSun = {
    prefix: 'fat',
    iconName: 'mountain-sun',
    icon: [
      640,
      512,
      [],
      'e52f',
      
      'M560 144a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM560 0a80 80 0 1 1 0 160A80 80 0 1 1 560 0zM412.7 281.7l48.2-79C465 196.1 472.2 192 480 192s15 4.1 19.1 10.7l132 216.3c5.8 9.6 8.9 20.6 8.9 31.8c0 33.8-27.4 61.1-61.1 61.1H456.1h0H55.9C25 512 0 487 0 456.1c0-10.5 3-20.8 8.6-29.7L225.2 81c6.6-10.6 18.3-17 30.8-17s24.1 6.4 30.8 17l126 200.7zm9.5 15.1l81.2 129.5c5.6 8.9 8.6 19.2 8.6 29.7c0 15.6-6.4 29.8-16.8 39.9h83.6c24.9 0 45.1-20.2 45.1-45.1c0-8.3-2.3-16.4-6.6-23.5L485.4 211c-1.2-1.9-3.2-3-5.4-3s-4.3 1.2-5.4 3l-52.4 85.8zM456.1 496c22 0 39.9-17.9 39.9-39.9c0-7.5-2.1-14.9-6.1-21.2L273.2 89.5C269.5 83.6 263 80 256 80s-13.5 3.6-17.2 9.5L22.1 434.9c-4 6.4-6.1 13.7-6.1 21.2c0 22 17.9 39.9 39.9 39.9H456.1z'
      
    ]
  };

  

  
  

  var faCabin = {
    prefix: 'fat',
    iconName: 'cabin',
    icon: [
      512,
      512,
      [],
      'e46d',
      
      'M271.1 22.4l216 174.2c5.6 4.6 8.9 11.4 8.9 18.7l0 .7c0 13.3-10.7 24-24 24H448 352 160 64 40c-13.3 0-24-10.7-24-24v-.7c0-7.3 3.3-14.1 8.9-18.7l216-174.2c8.8-7.1 21.3-7.1 30.1 0zM475.6 255.8C496 254 512 236.9 512 216v-.7c0-12.1-5.5-23.5-14.9-31.1L480 170.4V56c0-13.3-10.7-24-24-24H392c-13.3 0-24 10.7-24 24V80L281.1 10c-14.7-11.8-35.6-11.8-50.2 0L14.9 184.2C5.5 191.8 0 203.2 0 215.3v.7c0 20.9 16 38 36.4 39.8C33.6 260.6 32 266.1 32 272v16c0 9.6 4.2 18.1 10.8 24C36.2 317.9 32 326.4 32 336v16c0 9.6 4.2 18.1 10.8 24C36.2 381.9 32 390.4 32 400v16c0 9.6 4.2 18.1 10.8 24C36.2 445.9 32 454.4 32 464v16c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V464c0-9.6-4.2-18.1-10.8-24c6.6-5.9 10.8-14.4 10.8-24V400c0-9.6-4.2-18.1-10.8-24c6.6-5.9 10.8-14.4 10.8-24V336c0-9.6-4.2-18.1-10.8-24c6.6-5.9 10.8-14.4 10.8-24V272c0-5.8-1.6-11.3-4.3-16H324.3c-2.7 4.7-4.3 10.2-4.3 16v16c0 9.6 4.2 18.1 10.8 24c-6.6 5.9-10.8 14.4-10.8 24v16c0 9.6 4.2 18.1 10.8 24c-6.6 5.9-10.8 14.4-10.8 24v16c0 9.6 4.2 18.1 10.8 24c-6.6 5.9-10.8 14.4-10.8 24v16c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V464c0-9.6-4.2-18.1-10.8-24c6.6-5.9 10.8-14.4 10.8-24V400c0-9.6-4.2-18.1-10.8-24c6.6-5.9 10.8-14.4 10.8-24V336c0-9.6-4.2-18.1-10.8-24c6.6-5.9 10.8-14.4 10.8-24V272c0-5.9-1.6-11.4-4.4-16.2zM448 432H352c-8.8 0-16-7.2-16-16V400c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16zm-96 16h96c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H352c-8.8 0-16-7.2-16-16V464c0-8.8 7.2-16 16-16zm96-80H352c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16zm0-112c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H352c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h96zM160 432H64c-8.8 0-16-7.2-16-16V400c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16zM64 448h96c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V464c0-8.8 7.2-16 16-16zm96-80H64c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16zm0-112c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h96zm304-98.5L384 92.9V56c0-4.4 3.6-8 8-8h64c4.4 0 8 3.6 8 8V157.5zM256 168a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-40-24a40 40 0 1 0 80 0 40 40 0 1 0 -80 0z'
      
    ]
  };

  

  
  

  var faCircleX = {
    prefix: 'fat',
    iconName: 'circle-x',
    icon: [
      512,
      512,
      [],
      'e12e',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM158 130.8c-2.9-3.3-7.9-3.7-11.3-.8s-3.7 7.9-.8 11.3L245.4 256 146 370.8c-2.9 3.3-2.5 8.4 .8 11.3s8.4 2.5 11.3-.8l98-113 98 113c2.9 3.3 7.9 3.7 11.3 .8s3.7-7.9 .8-11.3L266.6 256 366 141.2c2.9-3.3 2.5-8.4-.8-11.3s-8.4-2.5-11.3 .8l-98 113-98-113z'
      
    ]
  };

  

  
  

  var faFamilyDress = {
    prefix: 'fat',
    iconName: 'family-dress',
    icon: [
      512,
      512,
      [],
      'e301',
      
      'M176 64A48 48 0 1 0 80 64a48 48 0 1 0 96 0zM64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zm2.1 146.8L27 347.6C24.1 357.8 31.8 368 42.4 368H64h48 32 16v16h-8v96c0 8.8 7.2 16 16 16c2.9 0 5.6-.8 8-2.1V511c-2.6 .7-5.2 1-8 1c-17.7 0-32-14.3-32-32V384H120v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H42.4c-21.3 0-36.6-20.3-30.8-40.8L50.7 206.4c7.8-27.5 33-46.4 61.5-46.4h31.4c9.3 0 18.1 2 26.2 5.6c-1.2 5.5-1.8 11.2-1.9 17c-7.2-4.2-15.5-6.6-24.3-6.6H112.3c-21.4 0-40.3 14.2-46.2 34.8zM344 512c-2.8 0-5.4-.3-8-1V493.9c2.4 1.4 5.1 2.1 8 2.1c8.8 0 16-7.2 16-16V384h-8V368h16 32 48 21.6c10.6 0 18.3-10.2 15.4-20.4L445.9 210.8C440 190.2 421.2 176 399.7 176H368.3c-8.8 0-17.1 2.4-24.3 6.6c-.1-5.8-.7-11.5-1.9-17c8.1-3.6 17-5.6 26.2-5.6h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H456v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H376v96c0 17.7-14.3 32-32 32zM72 384v96c0 8.8 7.2 16 16 16s16-7.2 16-16V384H72zM432 64a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM320 64a64 64 0 1 1 128 0A64 64 0 1 1 320 64zM440 384H408v96c0 8.8 7.2 16 16 16s16-7.2 16-16V384zM296 184a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm-96 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM320 336c0-35.3-28.7-64-64-64s-64 28.7-64 64v32c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V336zm-144 0c0-44.2 35.8-80 80-80s80 35.8 80 80v32c0 20.9-13.4 38.7-32 45.3V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V416H224v88c0 4.4-3.6 8-8 8s-8-3.6-8-8V413.3c-18.6-6.6-32-24.4-32-45.3V336z'
      
    ]
  };

  

  
  

  var faBookOpenReader = {
    prefix: 'fat',
    iconName: 'book-open-reader',
    icon: [
      512,
      512,
      ["book-reader"],
      'f5da',
      
      'M256 16a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 176A96 96 0 1 0 256 0a96 96 0 1 0 0 192zm0 48s-56.8-42.6-224-47.5C14.4 191.9 0 206.3 0 224V432c0 17.7 14.4 31.9 32 32.7c114.9 4.7 186.9 33.7 208.8 43.8c4.8 2.2 9.9 3.5 15.1 3.5s10.4-1.3 15.1-3.5c21.9-10.1 93.9-39.1 208.8-43.8c17.7-.7 32-15 32-32.7V224c0-17.7-14.4-32.1-32-31.5C312.8 197.4 256 240 256 240zm-8 14V494.2c-.1-.1-.3-.1-.4-.2c-23.5-10.9-97.6-40.5-214.9-45.3c-9.5-.4-16.7-8-16.7-16.7V224c0-8.9 7.2-15.8 15.6-15.5c82.3 2.4 136.8 14.1 170.2 24.9c16.7 5.4 28.3 10.5 35.4 14.2c3.6 1.8 6 3.3 7.5 4.2c.7 .5 1.2 .8 1.5 1l.2 .2L248 254zm16 240.2V254l1.5-1.1 .2-.2c.3-.2 .8-.5 1.5-1c1.5-.9 4-2.4 7.5-4.2c7.1-3.7 18.7-8.8 35.4-14.2c33.5-10.8 88-22.4 170.2-24.9c8.4-.2 15.6 6.6 15.6 15.5V432c0 8.7-7.2 16.3-16.7 16.7C362 453.5 287.9 483.1 264.4 494c-.1 .1-.3 .1-.4 .2z'
      
    ]
  };

  
    var faBookReader = faBookOpenReader;
  

  
  

  var faMicrophoneStand = {
    prefix: 'fat',
    iconName: 'microphone-stand',
    icon: [
      512,
      512,
      [127908],
      'f8cb',
      
      'M468.9 212.9l5.7-5.7 2.3-2.3c46.9-46.9 46.9-122.8 0-169.7S354-11.7 307.1 35.1l-2.3 2.3-5.7 5.7-5.7 5.7L283.1 59.1c-26.5 26.5-38 62.4-34.5 97L12.9 407.1C4.6 415.9 0 427.6 0 439.6c0 12.6 5 24.7 13.9 33.6l24.9 24.9c8.9 8.9 21 13.9 33.6 13.9c12.1 0 23.7-4.6 32.5-12.9L248 364.7V504c0 4.4 3.6 8 8 8s8-3.6 8-8V352c0-.7-.1-1.4-.3-2.1l92.1-86.5c34.6 3.5 70.5-8 97-34.5l10.3-10.3 5.7-5.7zM354.4 247.1l-89.5-89.5c-4-30.9 5.8-63.3 29.6-87.1l10.3-10.3L451.9 207.2l-10.3 10.3c-23.8 23.8-56.2 33.6-87.1 29.6zm-36-200.7c40.6-40.6 106.5-40.6 147.1 0s40.6 106.5 0 147.1l-2.3 2.3L316.1 48.8l2.3-2.3zM72.4 496c-8.4 0-16.4-3.3-22.3-9.2L25.2 461.9C19.3 456 16 448 16 439.6c0-8 3.1-15.7 8.5-21.6L256.2 171.5l84.3 84.3L93.9 487.5c-5.8 5.5-13.6 8.5-21.6 8.5z'
      
    ]
  };

  

  
  

  var faUserHairMullet = {
    prefix: 'fat',
    iconName: 'user-hair-mullet',
    icon: [
      448,
      512,
      ["business-front","party-back","trian-balbot"],
      'e45c',
      
      'M224 256c-61.9 0-112-50.1-112-112V128c0-8.2 .9-16.3 2.6-24h26c32.9 0 63.8-15.6 83.4-41.8c19.6 26.2 50.4 41.8 83.4 41.8h26c1.7 7.7 2.6 15.8 2.6 24v16c0 61.9-50.1 112-112 112zM102.4 88H96c-4.4 0-8 3.6-8 8s3.6 8 8 8h2.2c-1.5 7.8-2.2 15.8-2.2 24v16c0 16 0 39.6-2.9 63c-3 23.7-8.8 45.9-19.5 60.2c-1.9 2.6-2.1 6.1-.5 8.9s4.8 4.3 8 3.8l50.3-7.2 13.4 26.8c1.8 3.6 5.9 5.3 9.7 4l24-8c4.2-1.4 6.5-5.9 5.1-10.1s-5.9-6.5-10.1-5.1l-17.4 5.8-12.9-25.8c-1.5-3.1-4.9-4.8-8.3-4.3l-39.6 5.7c7.4-15.8 11.4-34.7 13.6-52.7c.3-2.4 .6-4.8 .8-7.2C130.9 243.4 174.1 272 224 272s93.1-28.6 114.2-70.2c.2 2.4 .5 4.8 .8 7.2c2.3 18.1 6.3 36.9 13.6 52.7l-39.6-5.7c-3.4-.5-6.7 1.3-8.3 4.3l-12.9 25.8-17.4-5.8c-4.2-1.4-8.7 .9-10.1 5.1s.9 8.7 5.1 10.1l24 8c3.8 1.3 7.9-.5 9.7-4l13.4-26.8 50.3 7.2c3.2 .5 6.4-1.1 8-3.8s1.5-6.3-.5-8.9c-10.7-14.2-16.5-36.5-19.5-60.2c-2.9-23.4-2.9-47-2.9-63V128c0-8.2-.8-16.2-2.2-24H352c4.4 0 8-3.6 8-8s-3.6-8-8-8h-6.4C328.8 36.9 280.7 0 224 0S119.2 36.9 102.4 88zm17 0C135.5 45.9 176.2 16 224 16s88.5 29.9 104.6 72H307.4c-29.4 0-56.9-14.7-73.2-39.2l-3.5-5.3c-1.5-2.2-4-3.6-6.7-3.6s-5.2 1.3-6.7 3.6l-3.5 5.3C197.5 73.3 170 88 140.6 88H119.4zm44.2 248H284.4C365.9 336 432 402.1 432 483.6c0 6.9-5.6 12.4-12.4 12.4H28.4c-6.9 0-12.4-5.6-12.4-12.4C16 402.1 82.1 336 163.6 336zm0-16C73.2 320 0 393.2 0 483.6C0 499.3 12.7 512 28.4 512H419.6c15.7 0 28.4-12.7 28.4-28.4C448 393.2 374.8 320 284.4 320H163.6z'
      
    ]
  };

  
    var faBusinessFront = faUserHairMullet;
  
    var faPartyBack = faUserHairMullet;
  
    var faTrianBalbot = faUserHairMullet;
  

  
  

  var faPodiumStar = {
    prefix: 'fat',
    iconName: 'podium-star',
    icon: [
      448,
      512,
      [],
      'f758',
      
      'M224 16h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 80h64c26.5 0 48-21.5 48-48s-21.5-48-48-48H224c-23.8 0-43.5 17.3-47.3 40H168c-39.8 0-72 32.2-72 72v48H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H112V112c0-30.9 25.1-56 56-56h8.7c3.8 22.7 23.6 40 47.3 40zM45.5 208L73.6 455.2c3.7 32.3 31 56.8 63.6 56.8H310.9c32.6 0 59.9-24.4 63.6-56.8L402.5 208H386.4L358.6 453.4c-2.8 24.3-23.3 42.6-47.7 42.6H137.1c-24.4 0-44.9-18.3-47.7-42.6L61.6 208H45.5zM261 291.6L239.2 242c-5.9-13.4-24.5-13.4-30.4 0L187 291.6c-.2 .4-.4 .5-.5 .5l-51.8 6.4c-14.5 1.8-19.3 19.8-9.4 29.3l38.3 37.1c.2 .2 .4 .7 .3 1.2l-10.2 53.6c-2.5 13.4 11.5 25.8 24.6 18.1l45.5-26.7c.1 0 .1-.1 .2-.1s.1 0 .2 .1l45.5 26.7c13.2 7.7 27.2-4.6 24.6-18.1l-10.2-53.6c-.1-.5 .1-1 .3-1.2l38.3-37.1c9.9-9.5 5.1-27.5-9.4-29.3l-51.8-6.4c-.1 0-.3-.1-.5-.5zm-37.6-43.1c.1-.3 .3-.4 .3-.4l0 0c.1 0 .1-.1 .2-.1s.2 0 .2 .1l0 0c0 0 .2 .1 .3 .4l21.9 49.6c2.3 5.3 7.3 9.2 13.2 9.9l51.8 6.4c.2 0 .2 .1 .3 .1c.1 .1 .2 .2 .3 .5s.1 .6 0 .8c0 .2-.1 .4-.3 .5l-38.3 37.1c-4.2 4.1-6 10-4.9 15.7l10.2 53.6c.1 .4 0 .6 0 .8c-.1 .2-.2 .3-.3 .4s-.2 .1-.2 .1l0 0s-.1 0-.2-.1l-45.5-26.7c-5.1-3-11.4-3-16.5 0l-45.5 26.7c-.1 .1-.2 .1-.2 .1l0 0s-.1 0-.2-.1s-.3-.3-.3-.4c-.1-.2-.1-.4 0-.8l10.2-53.6c1.1-5.7-.7-11.6-4.9-15.7l-38.3-37.1c-.2-.2-.3-.4-.3-.5c0-.2 0-.5 0-.8s.2-.5 .3-.5c0 0 .1-.1 .3-.1l51.8-6.4c5.9-.7 10.8-4.6 13.2-9.9l21.9-49.6z'
      
    ]
  };

  

  
  

  var faUserTieHair = {
    prefix: 'fat',
    iconName: 'user-tie-hair',
    icon: [
      448,
      512,
      [],
      'e45f',
      
      'M336 128c0-5.4-.4-10.8-1.1-16H312c-22.1 0-43-10.2-56.6-27.5L251 89.9C231.2 114 201.7 128 170.5 128L112 128v16c0 61.9 50.1 112 112 112s112-50.1 112-112V128zM267.2 73.6C277.8 87.7 294.4 96 312 96h19.4c-6.8-22.8-20.6-42.5-39-56.7L265.8 71.8l1.4 1.8zM279 30.4C262.7 21.2 244 16 224 16c-56.4 0-103.1 41.7-110.9 96h57.4c26.4 0 51.4-11.8 68.1-32.3L279 30.4zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V128zm80.9 180.3c1.4-2.7 4.1-4.3 7.1-4.3h80c3 0 5.7 1.7 7.1 4.3s1.1 5.9-.6 8.3l-37.2 52.1 23.2 46.3 47.1-94.2c81.2 8.4 144.4 77 144.4 160.4c0 17-13.8 30.7-30.7 30.7H225.9h-3.8H30.7C13.8 512 0 498.2 0 481.3c0-83.4 63.3-152 144.4-160.4l47.1 94.2 23.2-46.3-37.2-52.1c-1.7-2.4-2-5.6-.6-8.3zM199.5 320L224 354.2 248.5 320H199.5zm10.1 167.2L135.3 338.3C67.5 350.6 16 409.9 16 481.3c0 8.1 6.6 14.7 14.7 14.7H214.1l-4.4-8.8zm-9.2-54.2l14.6 29.2L224 480l8.9-17.9 14.6-29.2L224 385.9l-23.5 47.1zM432 481.3c0-71.4-51.5-130.7-119.3-143L238.3 487.2l-4.4 8.8H417.3c8.1 0 14.7-6.6 14.7-14.7z'
      
    ]
  };

  

  
  

  var faHandHoldingHand = {
    prefix: 'fat',
    iconName: 'hand-holding-hand',
    icon: [
      576,
      512,
      [],
      'e4f7',
      
      'M54.2 203.3c-10.7 7.9-25.7 5.6-33.6-5.1s-5.6-25.7 5.1-33.6L152.4 71.4C173 56.2 197.9 48 223.5 48H568c4.4 0 8-3.6 8-8s-3.6-8-8-8H223.5c-29 0-57.3 9.3-80.7 26.5L16.3 151.8c-17.8 13.1-21.6 38.1-8.5 55.9s38.1 21.6 55.9 8.5l117.6-86.6c1.4-1 3-1.6 4.7-1.6H308c6.6 0 12 5.4 12 12s-5.4 12-12 12H228c-19.9 0-36 16.1-36 36s16.1 36 36 36H382.3c29.1 0 57.3-9.9 80-28L505 161.8c1.4-1.1 3.2-1.8 5-1.8h58c4.4 0 8-3.6 8-8s-3.6-8-8-8H510c-5.4 0-10.7 1.9-15 5.3l-42.7 34.2c-19.9 15.9-44.5 24.5-70 24.5H228c-11 0-20-9-20-20s9-20 20-20h80c15.5 0 28-12.5 28-28s-12.5-28-28-28H186.1c-5.1 0-10.1 1.6-14.2 4.7L54.2 203.3zM521.8 308.7c10.7-7.9 25.7-5.6 33.6 5.1s5.6 25.7-5.1 33.6L423.6 440.6C403 455.8 378.1 464 352.5 464H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L394.7 382.4c-1.4 1-3 1.6-4.7 1.6H268c-6.6 0-12-5.4-12-12s5.4-12 12-12h80c19.9 0 36-16.1 36-36s-16.1-36-36-36H193.7c-29.1 0-57.3 9.9-80 28L71 350.2c-1.4 1.1-3.2 1.8-5 1.8H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H66c5.4 0 10.7-1.9 15-5.3l42.7-34.2c19.9-15.9 44.5-24.5 70-24.5H348c11 0 20 9 20 20s-9 20-20 20H268c-15.5 0-28 12.5-28 28s12.5 28 28 28H389.9c5.1 0 10.1-1.6 14.2-4.7l117.6-86.6z'
      
    ]
  };

  

  
  

  var faCar = {
    prefix: 'fat',
    iconName: 'car',
    icon: [
      512,
      512,
      [128664,"automobile"],
      'f1b9',
      
      'M106.4 88.6L76.3 194c6.4-1.3 12.9-2 19.7-2H416c6.7 0 13.3 .7 19.7 2L405.6 88.6c-6.9-24-28.8-40.6-53.8-40.6H160.3c-25 0-47 16.6-53.8 40.6zM58 199.8L91 84.2C99.9 53.3 128.1 32 160.3 32H351.7c32.1 0 60.4 21.3 69.2 52.2l33 115.6c34.1 14.7 58 48.7 58 88.2v96 16 48c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V400H96v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V400 384 288c0-39.5 23.9-73.5 58-88.2zM416 384h16 64V288c0-44.2-35.8-80-80-80H96c-44.2 0-80 35.8-80 80v96H80 96 416zm16 16v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400H432zM16 400v48c0 8.8 7.2 16 16 16H64c8.8 0 16-7.2 16-16V400H16zm96-112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm352 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  
    var faAutomobile = faCar;
  

  
  

  var faBoxBallot = {
    prefix: 'fat',
    iconName: 'box-ballot',
    icon: [
      576,
      512,
      [128499],
      'f735',
      
      'M160 16c-8.8 0-16 7.2-16 16V224c0 8.8 7.2 16 16 16H416c8.8 0 16-7.2 16-16V32c0-8.8-7.2-16-16-16H160zM128 32c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32V224c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V32zM48 160H96v16H48c-17.7 0-32 14.3-32 32V320H560V208c0-17.7-14.3-32-32-32H480V160h48c26.5 0 48 21.5 48 48V320v8 8V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336v-8-8V208c0-26.5 21.5-48 48-48zM560 336H16V464c0 17.7 14.3 32 32 32H528c17.7 0 32-14.3 32-32V336z'
      
    ]
  };

  

  
  

  var faCircleS = {
    prefix: 'fat',
    iconName: 'circle-s',
    icon: [
      512,
      512,
      [],
      'e121',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM177 183.7c2.9-15.3 13.7-26.4 31.4-33.1c17.8-6.7 41.9-8.4 68.7-4.6c8.1 1.2 26.5 5 35 7c4.3 1.1 8.6-1.6 9.7-5.9s-1.6-8.6-5.9-9.7c-8.8-2.2-27.7-6.1-36.5-7.3c-28.5-4.1-55.5-2.5-76.6 5.4c-21.3 8-37.3 22.9-41.5 45.1c-2.5 13.4-1.1 25 3.7 34.9c4.8 9.9 12.7 17.4 21.9 23.3c17.9 11.5 42.9 18.2 66.2 24.5l0 0 .9 .2c24.4 6.6 47 12.8 62.6 22.8c7.6 4.9 13 10.4 16.2 16.9c3.1 6.4 4.3 14.4 2.4 25c-2.9 15.3-13.7 26.4-31.4 33.1c-17.8 6.7-41.8 8.4-68.7 4.6c-16.5-2.5-46.9-11-63.6-16.1c-4.2-1.3-8.7 1.1-10 5.3s1.1 8.7 5.3 10c16.5 5.1 48 14 65.9 16.7l0 0c28.5 4.1 55.5 2.5 76.6-5.4c21.3-8 37.3-22.9 41.5-45.1c2.5-13.4 1.1-25-3.7-34.9c-4.8-9.9-12.7-17.4-21.9-23.3c-17.9-11.5-42.9-18.2-66.2-24.5l-.9-.2c-24.4-6.6-47-12.8-62.6-22.8c-7.6-4.9-13-10.4-16.2-16.9c-3.1-6.4-4.3-14.4-2.4-25z'
      
    ]
  };

  

  
  

  var faCreditCard = {
    prefix: 'fat',
    iconName: 'credit-card',
    icon: [
      576,
      512,
      [62083,128179,"credit-card-alt"],
      'f09d',
      
      'M64 48C37.5 48 16 69.5 16 96v32H560V96c0-26.5-21.5-48-48-48H64zM16 144v96H560V144H16zm0 112V416c0 26.5 21.5 48 48 48H512c26.5 0 48-21.5 48-48V256H16zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM96 360c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H104c-4.4 0-8-3.6-8-8zm128 0c0-4.4 3.6-8 8-8H376c4.4 0 8 3.6 8 8s-3.6 8-8 8H232c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  
    var faCreditCardAlt = faCreditCard;
  

  
  

  var faBowlChopsticks = {
    prefix: 'fat',
    iconName: 'bowl-chopsticks',
    icon: [
      512,
      512,
      [],
      'e2e9',
      
      'M505.6 15.8l-496 104c-4.3 .9-8.6-1.9-9.5-6.2s1.9-8.6 6.2-9.5l496-104c4.3-.9 8.6 1.9 9.5 6.2s-1.9 8.6-6.2 9.5zM512 127.5c.3 4.4-3.1 8.2-7.5 8.5L8.5 168c-4.4 .3-8.2-3.1-8.5-7.5s3.1-8.2 7.5-8.5l496-32c4.4-.3 8.2 3.1 8.5 7.5zm-376 331.5c4.5 2.2 7.7 6.4 8.7 11.3c2.9 14.7 15.9 25.8 31.4 25.8H336c15.5 0 28.5-11.1 31.4-25.8c1-4.9 4.2-9.1 8.7-11.3c65.5-32 111.8-97.4 116.4-174.7l1.6-27.3c.5-9.2-6.8-16.9-16-16.9H33.9c-9.2 0-16.5 7.7-16 16.9l1.6 27.3c4.5 77.3 50.9 142.7 116.4 174.7zM2 257.9C.9 239.5 15.5 224 33.9 224H478.1c18.4 0 33 15.5 31.9 33.9l-1.6 27.3c-4.9 83.3-54.8 153.7-125.3 188.2c-4.3 22-23.8 38.7-47.1 38.7H176c-23.3 0-42.8-16.6-47.1-38.7C58.4 438.9 8.5 368.4 3.6 285.2L2 257.9z'
      
    ]
  };

  

  
  

  var faBug = {
    prefix: 'fat',
    iconName: 'bug',
    icon: [
      512,
      512,
      [],
      'f188',
      
      'M336 96c0-44.2-35.8-80-80-80s-80 35.8-80 80v3.6c0 6.9 5.6 12.4 12.4 12.4H323.6c6.9 0 12.4-5.6 12.4-12.4V96zM160 96c0-53 43-96 96-96s96 43 96 96v3.6c0 15.7-12.7 28.4-28.4 28.4H188.4c-15.7 0-28.4-12.7-28.4-28.4V96zM34.3 98.3c3.1-3.1 8.2-3.1 11.3 0L132.3 185c18.2-15.6 41.8-25 67.7-25H312c25.8 0 49.5 9.4 67.7 25l86.7-86.7c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L391 196.3c15.6 18.2 25 41.8 25 67.7v16h88c4.4 0 8 3.6 8 8s-3.6 8-8 8H416v24c0 33.2-10.1 63.9-27.3 89.5c.4 .3 .7 .5 1 .9l88 88c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L379 422.3C349.7 457.6 305.4 480 256 480s-93.7-22.4-123-57.7L45.7 509.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l88-88c.3-.3 .7-.6 1-.9C106.1 383.9 96 353.2 96 320V296H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H96V264c0-25.8 9.4-49.5 25-67.7L34.3 109.7c-3.1-3.1-3.1-8.2 0-11.3zM264 232V463.8c75.8-4.2 136-66.9 136-143.8V288 264c0-48.6-39.4-88-88-88H200c-48.6 0-88 39.4-88 88v24 32c0 76.8 60.2 139.6 136 143.8V232c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faHandsHoldingCircle = {
    prefix: 'fat',
    iconName: 'hands-holding-circle',
    icon: [
      640,
      512,
      [],
      'e4fb',
      
      'M208 128a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm240 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zM96 112c0-26.5-21.5-48-48-48S0 85.5 0 112V344.2c0 27.6 11 54 30.5 73.5l91.9 91.9c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L41.8 406.5C25.3 390 16 367.6 16 344.2V112c0-17.7 14.3-32 32-32s32 14.3 32 32V259c0 20.7 8.2 40.6 22.9 55.2l19.5 19.5 55.9 55.9 0 0 8 8c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-8-8 0 0-55.9-55.9 0 0c-10.6-10.6-11.3-27.6-1.5-39.1c10.9-12.7 30.3-13.5 42.2-1.6l92.8 92.7c13.3 13.3 20.8 31.4 20.8 50.3V504c0 4.4 3.6 8 8 8s8-3.6 8-8V424.8c0-23.1-9.2-45.3-25.5-61.6l-92.8-92.8c-18.4-18.4-48.7-17.3-65.6 2.5c-6.2 7.2-9.7 15.9-10.6 24.7C100.8 286.7 96 273.1 96 259V112zM592 64c-26.5 0-48 21.5-48 48V259c0 14.1-4.8 27.8-13.5 38.7c-.9-8.8-4.4-17.5-10.6-24.7c-17-19.8-47.2-21-65.6-2.5l-92.7 92.8c-16.3 16.3-25.5 38.5-25.5 61.6V504c0 4.4 3.6 8 8 8s8-3.6 8-8V424.8c0-18.9 7.5-37 20.8-50.3l92.8-92.7c11.8-11.9 31.3-11.1 42.2 1.6c9.8 11.4 9.1 28.4-1.5 39.1l0 0-55.9 55.9 0 0-8 8c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l8-8 55.9-55.9 19.5-19.5C551.8 299.5 560 279.7 560 259V112c0-17.7 14.3-32 32-32s32 14.3 32 32V344.2c0 23.3-9.3 45.7-25.8 62.2l-91.9 91.9c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l91.9-91.9c19.5-19.5 30.5-46 30.5-73.5V112c0-26.5-21.5-48-48-48z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassWaveform = {
    prefix: 'fat',
    iconName: 'magnifying-glass-waveform',
    icon: [
      512,
      512,
      [],
      'e661',
      
      'M208 16a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 400c54.6 0 104.2-21 141.3-55.4l149 149c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-149-149C395 312.2 416 262.6 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM192 104c0-4.4-3.6-8-8-8s-8 3.6-8 8V312c0 4.4 3.6 8 8 8s8-3.6 8-8V104zm-64 32c0-4.4-3.6-8-8-8s-8 3.6-8 8V280c0 4.4 3.6 8 8 8s8-3.6 8-8V136zm128 0c0-4.4-3.6-8-8-8s-8 3.6-8 8V280c0 4.4 3.6 8 8 8s8-3.6 8-8V136zm64 32c0-4.4-3.6-8-8-8s-8 3.6-8 8v80c0 4.4 3.6 8 8 8s8-3.6 8-8V168z'
      
    ]
  };

  

  
  

  var faEnvelopeDot = {
    prefix: 'fat',
    iconName: 'envelope-dot',
    icon: [
      576,
      512,
      ["envelope-badge"],
      'e16f',
      
      'M464 64a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0A64 64 0 1 0 448 64a64 64 0 1 0 128 0zM512 384V160c-6.3 0-12.5-.6-18.5-1.8L291.2 321.4c-20.5 16.5-49.8 16.5-70.3 0L16 156.2V128c0-26.5 21.5-48 48-48H417.3c-.9-5.2-1.3-10.5-1.3-16H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64zM16 176.7L210.8 333.8c26.4 21.3 64 21.3 90.4 0L496 176.7V384c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V176.7z'
      
    ]
  };

  
    var faEnvelopeBadge = faEnvelopeDot;
  

  
  

  var faToolbox = {
    prefix: 'fat',
    iconName: 'toolbox',
    icon: [
      512,
      512,
      [129520],
      'f552',
      
      'M176 56l160 0c13.3 0 24 10.7 24 24l0 48-208 0 0-48c0-13.3 10.7-24 24-24zM136 80l0 48-29.5 0c-17 0-33.3 6.7-45.3 18.7L18.7 189.3C6.7 201.3 0 217.5 0 234.5L0 336l0 80c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-80 0-101.5c0-17-6.7-33.3-18.7-45.3l-42.5-42.5c-12-12-28.3-18.7-45.3-18.7L376 128l0-48c0-22.1-17.9-40-40-40L176 40c-22.1 0-40 17.9-40 40zM496 328l-144 0 0-48c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 48-160 0 0-48c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 48L16 328l0-93.5c0-12.7 5.1-24.9 14.1-33.9l42.5-42.5c9-9 21.2-14.1 33.9-14.1l37.5 0 224 0 37.5 0c12.7 0 24.9 5.1 33.9 14.1l42.5 42.5c9 9 14.1 21.2 14.1 33.9l0 93.5zM16 344l144 0 0 48c0 4.4 3.6 8 8 8s8-3.6 8-8l0-48 160 0 0 48c0 4.4 3.6 8 8 8s8-3.6 8-8l0-48 144 0 0 72c0 26.5-21.5 48-48 48L64 464c-26.5 0-48-21.5-48-48l0-72z'
      
    ]
  };

  

  
  

  var faPersonThroughWindow = {
    prefix: 'fat',
    iconName: 'person-through-window',
    icon: [
      640,
      512,
      [],
      'e5a9',
      
      'M48 16H592c17.7 0 32 14.3 32 32V400c0 17.7-14.3 32-32 32H411.2l10.7 16H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48V400c0 26.5 21.5 48 48 48H308.2l33.2 49.8c9.8 14.7 29.7 18.7 44.4 8.9s18.7-29.7 8.9-44.4L321.1 352l-10.7-16 19.2 0 55.3 0 40 48H379.2l10.7 16H568c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H352 336 304 288 72C58.7 48 48 58.7 48 72V376c0 13.3 10.7 24 24 24H96V384H72c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8H288v9.8c0 39-23.7 74-59.9 88.4c-10.9 4.4-21.1 9.8-30.5 16.3c-5.8 3.9-11.3 8.2-16.4 12.8C148 221 128 264 128 310.2l0 73.8c0 17.7 14.3 32 32 32s32-14.3 32-32l0-73.8c0-2.4 .1-4.8 .3-7.2c.6-7.7 2.1-15.1 4.4-22.3l12.1 18.2L265.5 384H224v16h52.2l21.3 32H200 120 48c-17.7 0-32-14.3-32-32V48c0-17.7 14.3-32 32-32zM304 64h32v9.8c0 49.1-25.1 94.1-65.3 120.2c-3.7 2.4-6.2 6.2-7 10.5s.2 8.8 2.8 12.3c.2 .2 .3 .5 .5 .7l41 63.1c2.9 4.5 8 7.3 13.4 7.3l71.1 0c9.5 0 18.5 4.2 24.6 11.5L487.5 384H445.8l-48.5-58.2c-3-3.6-7.5-5.8-12.3-5.8l-74.6 0c-5.9 0-11.3 3.2-14.1 8.4s-2.5 11.5 .8 16.4l84.2 126.2c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4L210 271.8c-3.4-5.1-9.4-7.8-15.5-7s-11.1 5.1-13 10.9c-3.6 10.9-5.5 22.5-5.5 34.4l0 73.8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-73.8c0-58.6 35.7-111.3 90.1-133C276.3 160.2 304 119.3 304 73.8V64zm48 0H568c4.4 0 8 3.6 8 8V376c0 4.4-3.6 8-8 8H508.3l-3.7-4.5-75.2-90.2c-9.1-10.9-22.6-17.3-36.9-17.3l-71.1 0-33.2-51.2-7.8-12c-.3-.5-.6-1-1-1.4c4.5-2.9 8.8-6 13-9.4C329.4 168.3 352 123 352 73.8V64zM171.9 178.2A52 52 0 1 0 124 85.8a52 52 0 1 0 47.9 92.4zM148 96a36 36 0 1 1 0 72 36 36 0 1 1 0-72z'
      
    ]
  };

  

  
  

  var faBells = {
    prefix: 'fat',
    iconName: 'bells',
    icon: [
      640,
      512,
      [],
      'f77f',
      
      'M282.6 40.1C214 15.1 138 50.4 112.8 119L98.2 159C84 197.8 57.6 231 23 253.7L14.9 259C4.7 265.7-.8 277.5 .6 289.5s9.4 22.2 20.8 26.3l230.5 83.9 1.1-3.9c1.1-3.8 2.1-7.7 2.9-11.6l-229-83.4c-5.7-2.1-9.7-7.2-10.4-13.2s2.1-11.9 7.1-15.2l8.2-5.4c37.5-24.6 66-60.5 81.4-102.5l14.7-40C150 64.2 216.8 33.1 277.1 55.1c1.6 .6 3.1 1.2 4.7 1.8c4.7-3.9 9.6-7.5 14.7-10.9c-4.5-2.2-9.1-4.2-13.9-6zm1.2 364.5l-4.6 15.8c-3.3 11.6 .1 24 9 32.2s21.5 10.8 32.8 6.7L618.6 351.1c11.3-4.1 19.4-14.2 20.8-26.2s-4-23.7-14-30.4l-13.7-9.2c-33.8-22.7-59.6-55.4-73.6-93.6l-18.8-51.2C493.2 69.2 414.1 32.5 342.8 58.4s-108 104.8-81.9 176.2l18.8 51.2c14 38.2 15.5 79.8 4.3 118.9zM348.3 73.5c63.1-23 132.9 9.5 156 72.5L523 197.2c15.2 41.4 43.1 76.9 79.7 101.4l13.7 9.2c5 3.4 7.7 9.2 7 15.2s-4.7 11-10.4 13.1L315.6 444.4c-5.7 2.1-12 .8-16.4-3.3s-6.1-10.3-4.5-16.1l4.6-15.8c12.2-42.3 10.5-87.4-4.6-128.8l-18.8-51.2c-23.1-63 9.3-132.7 72.4-155.7zM440 443.7c-3.3 2.9-3.7 7.9-.8 11.3c15.1 17.4 40.1 24.3 62.8 15.4s36.3-31 35.5-54.1c-.2-4.4-3.9-7.9-8.3-7.7s-7.9 3.9-7.7 8.3c.6 16.5-9.1 32.3-25.3 38.6s-34.1 1.5-44.9-11c-2.9-3.3-7.9-3.7-11.3-.8zM185.9 411.9c-10.8 12.5-28.7 17.4-44.9 11s-25.9-22.2-25.3-38.6c.2-4.4-3.3-8.1-7.7-8.3s-8.1 3.3-8.3 7.7c-.8 23 12.8 45.1 35.5 54.1s47.7 2 62.8-15.4c2.9-3.3 2.5-8.4-.8-11.3s-8.4-2.5-11.3 .8z'
      
    ]
  };

  

  
  

  var faGrid2Plus = {
    prefix: 'fat',
    iconName: 'grid-2-plus',
    icon: [
      512,
      512,
      [],
      'e197',
      
      'M176 48H80C62.3 48 48 62.3 48 80v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32zM80 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm96 272H80c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V336c0-17.7-14.3-32-32-32zM80 288h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48zM336 48c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32H336zM288 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V80zm96 192c4.4 0 8 3.6 8 8v96h96c4.4 0 8 3.6 8 8s-3.6 8-8 8H392v96c0 4.4-3.6 8-8 8s-8-3.6-8-8V392H280c-4.4 0-8-3.6-8-8s3.6-8 8-8h96V280c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faKitMedical = {
    prefix: 'fat',
    iconName: 'kit-medical',
    icon: [
      576,
      512,
      ["first-aid"],
      'f479',
      
      'M112 464H464V48H112V464zm-16 0V48H64C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H96zM64 32H96h8 8H464h8 8 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H480h-8-8H112h-8H96 64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32zM480 464h32c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H480V464zM264 168v56c0 4.4-3.6 8-8 8H200c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h56c4.4 0 8 3.6 8 8v56c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V288c0-4.4 3.6-8 8-8h56c4.4 0 8-3.6 8-8V240c0-4.4-3.6-8-8-8H320c-4.4 0-8-3.6-8-8V168c0-4.4-3.6-8-8-8H272c-4.4 0-8 3.6-8 8zm8-24h32c13.3 0 24 10.7 24 24v48h48c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H328v48c0 13.3-10.7 24-24 24H272c-13.3 0-24-10.7-24-24V296H200c-13.3 0-24-10.7-24-24V240c0-13.3 10.7-24 24-24h48V168c0-13.3 10.7-24 24-24z'
      
    ]
  };

  
    var faFirstAid = faKitMedical;
  

  
  

  var faChessPawn = {
    prefix: 'fat',
    iconName: 'chess-pawn',
    icon: [
      320,
      512,
      [9823],
      'f443',
      
      'M256 144A96 96 0 1 0 64 144a96 96 0 1 0 192 0zm16 0c0 40.7-21.8 76.4-54.3 96h4.9H256c4.4 0 8 3.6 8 8s-3.6 8-8 8H225.7l24.8 128H234.2L209.4 256H160 110.6L85.8 384H69.5L94.3 256H64c-4.4 0-8-3.6-8-8s3.6-8 8-8H97.4h4.9C69.8 220.4 48 184.7 48 144C48 82.1 98.1 32 160 32s112 50.1 112 112zM50.4 437.3L19.8 471.2c-2.5 2.7-3.8 6.3-3.8 9.9c0 8.2 6.6 14.8 14.8 14.8H289.2c8.2 0 14.8-6.6 14.8-14.8c0-3.7-1.4-7.2-3.8-9.9l-30.6-33.9c-3-3.4-7.4-5.3-11.9-5.3H62.3c-4.5 0-8.9 1.9-11.9 5.3zm261.7 23.2c5.1 5.7 7.9 13 7.9 20.6c0 17-13.8 30.8-30.8 30.8H30.8C13.8 512 0 498.2 0 481.2c0-7.6 2.8-15 7.9-20.6l30.6-33.9c6.1-6.7 14.7-10.6 23.8-10.6H257.7c9.1 0 17.7 3.8 23.8 10.6l30.6 33.9z'
      
    ]
  };

  

  
  

  var faNfcSlash = {
    prefix: 'fat',
    iconName: 'nfc-slash',
    icon: [
      640,
      512,
      [],
      'e1fc',
      
      'M13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7zM544 96V341.1l-16-12.6V96c0-26.5-21.5-48-48-48H172.7L152.9 32.4c2.3-.3 4.7-.4 7.1-.4H480c35.3 0 64 28.7 64 64zM312 158l16 12.6V136c0-4.4 3.6-8 8-8H440c4.4 0 8 3.6 8 8V265.3L464 278V136c0-13.3-10.7-24-24-24H336c-13.3 0-24 10.7-24 24v22zM192 376V246.7L176 234V376c0 13.3 10.7 24 24 24H386.2l-20.3-16H200c-4.4 0-8-3.6-8-8zM96 170.9V416c0 35.3 28.7 64 64 64H480c2.4 0 4.7-.1 7.1-.4L467.3 464H160c-26.5 0-48-21.5-48-48V183.5L96 170.9z'
      
    ]
  };

  

  
  

  var faEllipsis = {
    prefix: 'fat',
    iconName: 'ellipsis',
    icon: [
      448,
      512,
      ["ellipsis-h"],
      'f141',
      
      'M368 256a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-128 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM96 272a16 16 0 1 1 0-32 16 16 0 1 1 0 32z'
      
    ]
  };

  
    var faEllipsisH = faEllipsis;
  

  
  

  var faAnchorCircleXmark = {
    prefix: 'fat',
    iconName: 'anchor-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e4ac',
      
      'M352 80A64 64 0 1 1 224 80a64 64 0 1 1 128 0zM288 0c-44.2 0-80 35.8-80 80c0 41.5 31.6 75.6 72 79.6c0 .1 0 .3 0 .4v48H200c-4.4 0-8 3.6-8 8s3.6 8 8 8h80V496h-8C170.4 496 88 413.6 88 312V284.8l58.1 64.5c3 3.3 8 3.6 11.3 .6s3.6-8 .6-11.3l-72-80C84.4 257 82.3 256 80 256s-4.4 1-5.9 2.6l-72 80c-3 3.3-2.7 8.3 .6 11.3s8.3 2.7 11.3-.6L72 284.8V312c0 110.5 89.5 200 200 200h16 16c25.9 0 50.7-4.9 73.4-13.9c-4.3-3.9-8.5-8.1-12.4-12.5C346 492.3 325.4 496 304 496h-8V224h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H296V160c0-.1 0-.3 0-.4c40.4-4 72-38.1 72-79.6c0-44.2-35.8-80-80-80zm80 368a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-132.7 0l50.3-50.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L496 356.7l-50.3-50.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L484.7 368l-50.3 50.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L496 379.3l50.3 50.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L507.3 368z'
      
    ]
  };

  

  
  

  var faTentDoublePeak = {
    prefix: 'fat',
    iconName: 'tent-double-peak',
    icon: [
      576,
      512,
      [],
      'e627',
      
      'M16 480c0 8.8 7.2 16 16 16H272V208H16V480zm272 16H426.7L288 232.4V496zM560 192V160c0-5-2.4-9.8-6.4-12.8l-33.3-24.9c-12.9-9.7-24.7-20.8-35-33.2l-56-67.3c-3-3.6-7.5-5.8-12.3-5.8h-3.8c-4.2 0-8.3 1.7-11.3 4.7L380.1 42.5c-24 24-56.6 37.5-90.5 37.5h-3.2c-33.9 0-66.5-13.5-90.5-37.5L174.1 20.7c-3-3-7.1-4.7-11.3-4.7H159c-4.7 0-9.3 2.1-12.3 5.8L90.6 89c-10.3 12.4-22.1 23.6-35 33.2L22.4 147.2c-4 3-6.4 7.8-6.4 12.8v32H560zM293.3 208L444.8 496H544c8.8 0 16-7.2 16-16V208H293.3zM0 480V160c0-10.1 4.7-19.6 12.8-25.6l33.3-24.9C58 100.5 68.8 90.2 78.4 78.8l56-67.3C140.5 4.2 149.5 0 159 0h3.8c8.5 0 16.6 3.4 22.6 9.4l21.8 21.8c21 21 49.5 32.8 79.2 32.8h3.2c29.7 0 58.2-11.8 79.2-32.8L390.6 9.4c6-6 14.1-9.4 22.6-9.4H417c9.5 0 18.5 4.2 24.6 11.5l56 67.3c9.5 11.4 20.4 21.7 32.3 30.7l33.3 24.9c8.1 6 12.8 15.5 12.8 25.6V480c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z'
      
    ]
  };

  

  
  

  var faTicketsAirline = {
    prefix: 'fat',
    iconName: 'tickets-airline',
    icon: [
      640,
      512,
      ["tickets-perforated-plane","tickets-plane"],
      'e29b',
      
      'M112 96V320c0 26.5 21.5 48 48 48H576c26.5 0 48-21.5 48-48V270.1c-.3-.1-.6-.3-.9-.4C596 262.4 576 237.5 576 208s20-54.4 47.1-61.8c.3-.1 .6-.2 .9-.4V96c0-26.5-21.5-48-48-48H160c-26.5 0-48 21.5-48 48zm48-64H576c35.3 0 64 28.7 64 64v51.2c0 7.1-5.8 12.6-12.7 14.5C607 167.2 592 185.9 592 208s15 40.8 35.3 46.3c6.8 1.9 12.7 7.4 12.7 14.5V320c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64zm320 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM8 88c4.4 0 8 3.6 8 8V376c0 48.6 39.4 88 88 88H552c4.4 0 8 3.6 8 8s-3.6 8-8 8H104C46.6 480 0 433.4 0 376V96c0-4.4 3.6-8 8-8zm240.9 0H280c11.4 0 21.9 6 27.6 15.9L345 168h45.9c18.2 0 35.6 7.2 48.5 20.1c11 11 11 28.8 0 39.9c-12.9 12.9-30.3 20.1-48.5 20.1H339.3l-37.4 64.1c-5.7 9.8-16.3 15.9-27.6 15.9H243.1c-10.9 0-18.6-10.7-15.2-21.1L247.6 248H217.8L201 270.4c-4.5 6-11.6 9.6-19.2 9.6H168c-10.4 0-18-9.8-15.5-19.9L165 209.9c.3-1.3 .3-2.6 0-3.9l-12.5-50.2C150 145.8 157.6 136 168 136h13.8c7.6 0 14.7 3.6 19.2 9.6L217.8 168h35.6l-19.6-58.9C230.2 98.7 237.9 88 248.9 88zm0 16L272 173.5c.8 2.4 .4 5.1-1.1 7.2s-3.9 3.3-6.5 3.3H213.8c-2.5 0-4.9-1.2-6.4-3.2l-19.2-25.6 6.2-4.7-6.2 4.7c-1.5-2-3.9-3.2-6.4-3.2H168l12.5 50.2c1 3.8 1 7.8 0 11.6L168 264l13.8 0c2.5 0 4.9-1.2 6.4-3.2l19.2-25.6c1.5-2 3.9-3.2 6.4-3.2h44.9c2.6 0 5 1.2 6.5 3.3s1.9 4.8 1.1 7.2L243.1 312h31.1c5.7 0 11-3 13.8-7.9L327.8 236c1.4-2.5 4.1-4 6.9-4h56.3c13.9 0 27.3-5.5 37.1-15.4c4.8-4.8 4.8-12.5 0-17.2c-9.9-9.9-23.2-15.4-37.1-15.4H340.4c-2.8 0-5.5-1.5-6.9-4l-39.7-68.1c-2.9-4.9-8.1-7.9-13.8-7.9l-31.1 0z'
      
    ]
  };

  
    var faTicketsPerforatedPlane = faTicketsAirline;
  
    var faTicketsPlane = faTicketsAirline;
  

  
  

  var faArrowRightLong = {
    prefix: 'fat',
    iconName: 'arrow-right-long',
    icon: [
      512,
      512,
      ["long-arrow-right"],
      'f178',
      
      'M509.7 261.7c3.1-3.1 3.1-8.2 0-11.3l-152-152c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L484.7 248 8 248c-4.4 0-8 3.6-8 8s3.6 8 8 8l476.7 0L346.3 402.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l152-152z'
      
    ]
  };

  
    var faLongArrowRight = faArrowRightLong;
  

  
  

  var faUserLock = {
    prefix: 'fat',
    iconName: 'user-lock',
    icon: [
      640,
      512,
      [],
      'f502',
      
      'M112 128a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm240 0A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM16 482.3C16 392.7 88.7 320 178.3 320h91.4c44.6 0 85 18 114.3 47.1V352c0-2.1 .1-4.2 .3-6.3c-31-26-71-41.7-114.6-41.7H178.3C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H392.6c-2.9-5-5.1-10.3-6.5-16H29.7c-7.6 0-13.7-6.1-13.7-13.7zM528 208c26.5 0 48 21.5 48 48v64H480V256c0-26.5 21.5-48 48-48zm-64 48v64H448c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H592V256c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-16 80h16 16 96 16 16c8.8 0 16 7.2 16 16V480c0 8.8-7.2 16-16 16H448c-8.8 0-16-7.2-16-16V352c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faThumbsDown = {
    prefix: 'fat',
    iconName: 'thumbs-down',
    icon: [
      512,
      512,
      [61576,128078],
      'f165',
      
      'M281.1 440.4c4.6 17 22.2 27.1 39.3 22.5s27.1-22.2 22.5-39.3l-4.5-16.4c-5.7-20.8-22.3-56.7-33.7-75c-1.5-2.5-1.6-5.6-.2-8.1s4.1-4.1 7-4.1H448c22.1 0 40-17.9 40-40c0-14.2-7.3-26.6-18.5-33.7c-3.6-2.3-4.7-7-2.7-10.7c3.3-5.8 5.1-12.5 5.1-19.6c0-15.5-8.8-28.9-21.7-35.6c-2.1-1.1-3.6-3.1-4.1-5.4s0-4.7 1.5-6.6c5.2-6.8 8.3-15.2 8.3-24.4c0-17.8-11.6-32.8-27.6-38c-3.9-1.3-6.2-5.3-5.3-9.3c.6-2.8 .9-5.7 .9-8.6c0-22.1-17.9-40-40-40H286.5c-17.4 0-34.4 5.1-48.8 14.8L199.2 88.5c-10 6.6-18.3 15.1-24.7 24.8c-2.4 3.7-7.4 4.7-11.1 2.3s-4.7-7.4-2.3-11.1C168.7 93 178.6 83 190.3 75.1l38.5-25.7C245.9 38.1 266 32 286.5 32H384c30.9 0 56 25.1 56 56c0 1.8-.1 3.5-.2 5.3c19 8.9 32.2 28.3 32.2 50.7c0 9.7-2.5 18.9-6.9 26.9C479 181 488 197.5 488 216c0 7.4-1.4 14.5-4.1 21c12.3 10.3 20.1 25.7 20.1 43c0 30.9-25.1 56-56 56H325.4c10.9 20.3 23.4 48.5 28.5 67l4.5 16.4c7 25.6-8.1 52-33.7 58.9s-52-8.1-58.9-33.7l-4.5-16.4c-4.7-17.2-14.5-37.4-27.2-55.8c-12.7-18.4-27.7-34.5-42.5-43.8l-3.1-2c-10.9-6.9-20-15.8-27.2-26.1c-2.5-3.6-1.6-8.6 2-11.1s8.6-1.6 11.1 2c6 8.5 13.6 16 22.7 21.7l3.1 2c17.2 10.9 33.7 28.8 47.1 48.3c13.4 19.5 24.1 41.3 29.4 60.6l4.5 16.4zM32 368H96c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H32c-8.8 0-16 7.2-16 16V352c0 8.8 7.2 16 16 16zM0 352V128c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z'
      
    ]
  };

  

  
  

  var faGripLines = {
    prefix: 'fat',
    iconName: 'grip-lines',
    icon: [
      448,
      512,
      [],
      'f7a4',
      
      'M448 192c0-4.4-3.6-8-8-8L8 184c-4.4 0-8 3.6-8 8s3.6 8 8 8l432 0c4.4 0 8-3.6 8-8zm0 128c0-4.4-3.6-8-8-8L8 312c-4.4 0-8 3.6-8 8s3.6 8 8 8l432 0c4.4 0 8-3.6 8-8z'
      
    ]
  };

  

  
  

  var faHeadSideCough = {
    prefix: 'fat',
    iconName: 'head-side-cough',
    icon: [
      640,
      512,
      [],
      'e061',
      
      'M222.9 16C108.6 16 16 108.6 16 222.9c0 49.4 15.8 94.6 43.9 130C71.5 367.5 80 385.5 80 405.3V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V405.3c0-15.1-6.5-29.8-16.6-42.5C16.9 324.5 0 275.8 0 222.9C0 99.8 99.8 0 222.9 0h16.8c77.9 0 149.4 46.9 180.9 114.2c3.8 8 7.3 16 10.8 23.9c6.2 13.9 12.3 27.6 19.3 41c10.8 20.7 23.3 39.5 40 54.4l3.8 3.4c11.1 9.9 17.5 24.1 17.5 39c0 28.8-23.4 52.2-52.2 52.2H448v0 8 24c0 4-2.9 7.4-6.9 7.9l-92.8 13.3c-7.1 1-12.3 7.1-12.3 14.2c0 7.5 5.7 13.7 13.2 14.3l75.5 6.3c4.1 .3 7.3 3.8 7.3 8v8c0 26.5-21.5 48-48 48H320v24c0 4.4-3.6 8-8 8s-8-3.6-8-8V472c0-4.4 3.6-8 8-8h72c17.7 0 32-14.3 32-32v-.6l-68.1-5.7c-15.7-1.3-27.9-14.5-27.9-30.3c0-15.1 11.1-27.9 26.1-30.1L432 353.1V336v-8-8c0-4.4 3.6-8 8-8h19.8c20 0 36.2-16.2 36.2-36.2c0-10.3-4.4-20.2-12.1-27l-3.8-3.4c-18.8-16.7-32.3-37.3-43.5-58.9c-7.2-13.8-13.7-28.4-20.1-42.7c-3.5-7.8-6.9-15.5-10.4-22.9C377.2 59.3 311.4 16 239.7 16H222.9zM320 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm304 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-80 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-64 48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm128 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-80-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faPanFood = {
    prefix: 'fat',
    iconName: 'pan-food',
    icon: [
      640,
      512,
      [129368],
      'e42b',
      
      'M560 256A240 240 0 1 0 80 256a240 240 0 1 0 480 0zm-2.6 96c-38 93.8-130 160-237.4 160s-199.4-66.2-237.4-160H40c-22.1 0-40-17.9-40-40V200c0-22.1 17.9-40 40-40H82.6C120.6 66.2 212.6 0 320 0S519.4 66.2 557.4 160H600c22.1 0 40 17.9 40 40V312c0 22.1-17.9 40-40 40H557.4zm5.9-16H600c13.3 0 24-10.7 24-24V200c0-13.3-10.7-24-24-24H563.3c8.3 25.2 12.7 52.1 12.7 80s-4.5 54.8-12.7 80zM76.7 176H40c-13.3 0-24 10.7-24 24V312c0 13.3 10.7 24 24 24H76.7C68.5 310.8 64 283.9 64 256s4.5-54.8 12.7-80zM417.6 320l2.1 0c10.5 0 20.8-2.7 29.9-7.9c18.8-10.7 30.4-30.7 30.4-52.3v-2.4c0-15.6-5.8-30.8-16.1-42.6l-89.2 89.2c11.8 10.4 27.1 16.1 42.9 16.1zM496 257.3v2.4c0 27.4-14.7 52.6-38.4 66.2c-11.5 6.6-24.6 10-37.8 10l-2.1 0c-21.5 0-42.2-8.6-57.4-23.8c-4.5-4.5-4.5-11.9 0-16.4l95.6-95.6c4.5-4.5 11.9-4.5 16.5 .1C487.4 215.4 496 236 496 257.3zM197.7 197.7l-32 32c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l32-32c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3zM304 224a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM416 368a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM229.7 293.7c-5.7 5.7-5.7 15 0 20.7l2.3 2.3c2.1 2.1 5 3.3 8 3.3h48c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64V336c0-3-1.2-5.9-3.3-8l-2.3-2.3c-5.7-5.7-15-5.7-20.7 0c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l16-16 16-16c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3zM336 384c0-26.5-21.5-48-48-48H256c-8.8 0-16 7.2-16 16v32c0 26.5 21.5 48 48 48s48-21.5 48-48zM320 80c-35.3 0-64 28.7-64 64H384c0-35.3-28.7-64-64-64zm-80 64c0-44.2 35.8-80 80-80s80 35.8 80 80c0 8.8-7.2 16-16 16H256c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faPersonDollyEmpty = {
    prefix: 'fat',
    iconName: 'person-dolly-empty',
    icon: [
      512,
      512,
      [],
      'f4d1',
      
      'M109.3 232.8l16.6 24.9c5.9 8.9 15.9 14.3 26.6 14.3H224c.6 0 1.3 0 1.9-.1L218.5 240H161.1c-5.3 0-10.3-2.7-13.3-7.1l-42.6-64C94.8 153.3 77.3 144 58.6 144C35.1 144 16 163.1 16 186.6v88.1c0 12.7 5.1 24.9 14.1 33.9l79.4 79.4c2.4 2.4 3.9 5.4 4.5 8.7l14.3 85.9c1.5 8.7 9.7 14.6 18.4 13.2s14.6-9.7 13.2-18.4l-15.2-90.9c-1.1-6.6-4.2-12.7-8.9-17.4l-51-51c-3-3-4.7-7.1-4.7-11.3V241.7c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zm120.2 54.7c-1.8 .3-3.7 .5-5.5 .5H152.6c-16 0-31-8-39.9-21.4l-.6-.9-16-24v28.8 36.2l51 51c7.1 7.1 11.8 16.2 13.4 26.1l15.2 90.9c2.9 17.4-8.9 33.9-26.3 36.8s-33.9-8.9-36.8-26.3L98.1 399.4 18.7 320C6.7 308 0 291.7 0 274.7V186.6C0 154.2 26.2 128 58.6 128c24.1 0 46.5 12 59.9 32l42.6 64h53.6l-14.5-62.2c-1-4.3 1.7-8.6 6-9.6s8.6 1.7 9.6 6l53.3 228.6c6-1.8 12.3-2.8 18.9-2.8c31.3 0 57.4 22.5 62.9 52.2l151.2-36c4.3-1 8.6 1.6 9.6 5.9s-1.6 8.6-5.9 9.6l-154 36.7c-2.3 33.3-30 59.5-63.8 59.5c-35.3 0-64-28.7-64-64c0-23 12.1-43.1 30.3-54.4L229.5 287.5zM112 48A32 32 0 1 0 48 48a32 32 0 1 0 64 0zM80 0a48 48 0 1 1 0 96A48 48 0 1 1 80 0zM0 480L0 346.5l16 16L16 480c0 8.8 7.2 16 16 16s16-7.2 16-16l0-85.5 16 16L64 480c0 17.7-14.3 32-32 32s-32-14.3-32-32zm288 16a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faCarTunnel = {
    prefix: 'fat',
    iconName: 'car-tunnel',
    icon: [
      512,
      512,
      [],
      'e4de',
      
      'M256 16C123.5 16 16 123.5 16 256V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V256C0 114.6 114.6 0 256 0S512 114.6 512 256V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V256C496 123.5 388.5 16 256 16zM161 258.4L146.2 320H365.8L351 258.4c-2.6-10.8-12.2-18.4-23.3-18.4H184.3c-11.1 0-20.7 7.6-23.3 18.4zm-31.9 64l16.3-67.7c4.3-18 20.4-30.6 38.9-30.6H327.7c18.5 0 34.6 12.7 38.9 30.6l16.3 67.7c19.2 6.3 33.1 24.3 33.1 45.7v80 8 8 16c0 17.7-14.3 32-32 32H368c-17.7 0-32-14.3-32-32V464H176v16c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V464v-8-8V368c0-21.3 13.9-39.4 33.1-45.7zM336 448h16 48V368c0-17.7-14.3-32-32-32H144c-17.7 0-32 14.3-32 32v80h48 16H336zm16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V464H352zm-240 0v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V464H112zm64-88a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm112 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z'
      
    ]
  };

  

  
  

  var faOmega = {
    prefix: 'fat',
    iconName: 'omega',
    icon: [
      448,
      512,
      [],
      'f67a',
      
      'M224 48C109.1 48 16 141.1 16 256c0 75.3 40 141.3 100 177.8c7.4 4.5 12.4 12.5 12.4 21.6c0 13.6-11 24.6-24.6 24.6H8c-4.4 0-8-3.6-8-8s3.6-8 8-8h95.7c4.8 0 8.6-3.9 8.6-8.6c0-3.1-1.7-6.1-4.7-7.9C43.1 408.1 0 337.1 0 256C0 132.3 100.3 32 224 32s224 100.3 224 224c0 81.1-43.1 152.1-107.6 191.4c-3 1.8-4.7 4.9-4.7 7.9c0 4.8 3.9 8.6 8.6 8.6H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H344.3c-13.6 0-24.6-11-24.6-24.6c0-9.1 5-17.1 12.4-21.6C392 397.3 432 331.3 432 256c0-114.9-93.1-208-208-208z'
      
    ]
  };

  

  
  

  var faMountains = {
    prefix: 'fat',
    iconName: 'mountains',
    icon: [
      640,
      512,
      [9968],
      'f6fd',
      
      'M496 424.1c0 22-17.9 39.9-39.9 39.9H55.9c-22 0-39.9-17.9-39.9-39.9c0-7.5 2.1-14.9 6.1-21.2L238.8 57.5C242.5 51.6 249 48 256 48s13.5 3.6 17.2 9.5L489.9 402.9c4 6.4 6.1 13.7 6.1 21.2zm-496 0C0 455 25 480 55.9 480H456.1 578.9c33.8 0 61.1-27.4 61.1-61.1c0-11.2-3.1-22.2-8.9-31.8l-132-216.3C495 164.1 487.8 160 480 160s-15 4.1-19.1 10.7l-48.2 79L286.8 49c-6.6-10.6-18.3-17-30.8-17s-24.1 6.4-30.8 17L8.6 394.4C3 403.3 0 413.6 0 424.1zM422.2 264.9L474.6 179c1.2-1.9 3.2-3 5.4-3s4.3 1.2 5.4 3l132 216.3c4.3 7.1 6.6 15.2 6.6 23.5c0 24.9-20.2 45.1-45.1 45.1H495.2c10.3-10.1 16.8-24.3 16.8-39.9c0-10.5-3-20.8-8.6-29.7L422.2 264.9z'
      
    ]
  };

  

  
  

  var faAngleDown = {
    prefix: 'fat',
    iconName: 'angle-down',
    icon: [
      448,
      512,
      [8964],
      'f107',
      
      'M218.3 365.7c3.1 3.1 8.2 3.1 11.3 0l176-176c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L224 348.7 53.7 178.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l176 176z'
      
    ]
  };

  

  
  

  var faAirConditioner = {
    prefix: 'fat',
    iconName: 'air-conditioner',
    icon: [
      576,
      512,
      [],
      'f8f4',
      
      'M64 16C37.5 16 16 37.5 16 64v96c0 26.5 21.5 48 48 48H512c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H64zM0 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64v96c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM256 424c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-28.8 13.9-54.4 35.3-70.4c3.5-2.7 8.5-1.9 11.2 1.6s1.9 8.6-1.6 11.2C107.3 379.5 96 400.4 96 424c0 39.8 32.2 72 72 72s72-32.2 72-72V256h16V424zm64-168h16V392c0 39.8 32.2 72 72 72s72-32.2 72-72c0-23.6-11.3-44.5-28.8-57.6c-3.5-2.7-4.3-7.7-1.6-11.2s7.7-4.3 11.2-1.6c21.4 16 35.2 41.6 35.2 70.4c0 48.6-39.4 88-88 88s-88-39.4-88-88V256zM104 128H472c4.4 0 8 3.6 8 8s-3.6 8-8 8H104c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faSquareQuestion = {
    prefix: 'fat',
    iconName: 'square-question',
    icon: [
      448,
      512,
      ["question-square"],
      'f2fd',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM136 200c0-30.9 25.1-56 56-56h56.2c35.2 0 63.8 28.6 63.8 63.8c0 21.4-10.8 41.5-28.7 53.3L232 294.9V320c0 4.4-3.6 8-8 8s-8-3.6-8-8V290.5c0-2.7 1.4-5.2 3.6-6.7l54.9-36.2c13.4-8.8 21.5-23.8 21.5-39.9c0-26.4-21.4-47.8-47.8-47.8H192c-22.1 0-40 17.9-40 40l0 6.5c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-6.5zm72 168a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  
    var faQuestionSquare = faSquareQuestion;
  

  
  

  var faOilTemperature = {
    prefix: 'fat',
    iconName: 'oil-temperature',
    icon: [
      576,
      512,
      ["oil-temp"],
      'f614',
      
      'M280 24c0-13.3 10.7-24 24-24h72c4.4 0 8 3.6 8 8s-3.6 8-8 8H304c-4.4 0-8 3.6-8 8V96h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H296V224.4c40.4 4 72 38.1 72 79.6c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-41.5 31.6-75.6 72-79.6V104 24zM224 304a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm156 63.9c3.5-5.1 6.7-10.5 9.3-16.1c20.6-2 40.6-15.2 56.5-29.7c10.1-9.2 19.7-19.5 27.6-30.7c1.5-2.1 3.9-3.4 6.6-3.4s5.1 1.3 6.6 3.4c7.3 10.3 15.9 19.6 25 28.3c15.7 14.8 36.1 29.2 57.4 31.9c4.4 .6 7.5 4.6 6.9 8.9s-4.6 7.5-8.9 6.9c-26.5-3.3-50-20.7-66.4-36.1c-8.8-8.3-15.9-16.4-20.6-22.2c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1c-1.3 0-2.7 0-4-.1zM192 368c-28.7 0-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-4.7 5.8-11.8 13.9-20.6 22.2C59 346.7 35.5 364.1 9 367.4c-4.4 .6-8.4-2.6-8.9-6.9s2.6-8.4 6.9-8.9c21.3-2.7 41.7-17.1 57.4-31.9c9.1-8.6 17.7-18 25-28.3c1.5-2.1 3.9-3.4 6.6-3.4s5.1 1.3 6.6 3.4c7.9 11.2 17.5 21.5 27.6 30.7c15.9 14.4 35.9 27.7 56.5 29.7c2.7 5.7 5.8 11.1 9.3 16.1c-1.3 .1-2.7 .1-4 .1zm102.6 67.4c8 11.2 17.5 21.4 27.6 30.7C339.5 481.8 361.5 496 384 496s44.6-14.2 61.8-29.9c10.1-9.2 19.7-19.5 27.6-30.7c1.5-2.1 3.9-3.4 6.6-3.4s5.1 1.3 6.6 3.4c7.3 10.3 15.9 19.6 25 28.3c15.7 14.8 36.1 29.2 57.4 31.9c4.4 .6 7.5 4.6 6.9 8.9s-4.6 7.5-8.9 6.9c-26.5-3.3-50-20.7-66.4-36.1c-8.8-8.3-15.9-16.4-20.6-22.2c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8l0 0 0 0c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-4.7 5.8-11.8 13.9-20.6 22.2C59 490.7 35.5 508.1 9 511.4c-4.4 .6-8.4-2.6-8.9-6.9s2.6-8.4 6.9-8.9c21.3-2.7 41.7-17.1 57.4-31.9c9.1-8.6 17.7-18 25-28.3c1.5-2.1 3.9-3.4 6.6-3.4s5.1 1.3 6.6 3.4c7.9 11.2 17.5 21.5 27.6 30.7C147.4 481.8 169.5 496 192 496s44.6-14.2 61.8-29.9c10.1-9.2 19.6-19.5 27.6-30.7c3-4.3 10.2-4.3 13.2 0z'
      
    ]
  };

  
    var faOilTemp = faOilTemperature;
  

  
  

  var faFaceDrooling = {
    prefix: 'fat',
    iconName: 'face-drooling',
    icon: [
      512,
      512,
      [],
      'e372',
      
      'M16 256C16 123.5 123.5 16 256 16s240 107.5 240 240c0 61.5-23.1 117.5-61.1 160c-2.9 3.3-2.7 8.4 .6 11.3s8.3 2.7 11.3-.6C487.3 381.4 512 321.6 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c4.4 0 8-3.6 8-8s-3.6-8-8-8C123.5 496 16 388.5 16 256zm352 92.5V504c0 4.4 3.6 8 8 8s8-3.6 8-8V332.4c2.2-2.5 4.3-5 6.2-7.4c2.8-3.4 2.2-8.5-1.2-11.2s-8.5-2.2-11.2 1.2C354 344.7 313.4 376 256 376s-98-31.3-121.8-61c-2.8-3.5-7.8-4-11.2-1.2s-4 7.8-1.2 11.2c25.7 32.1 70.5 67 134.2 67c17.4 0 33.4-2.6 48-7v87c0 4.4 3.6 8 8 8s8-3.6 8-8V379.2c18.7-7.9 34.7-18.8 48-30.7zM208 168c4.4 0 8-3.6 8-8s-3.6-8-8-8c-52.7 0-80.3 40.9-87.5 61.3c-1.5 4.2 .7 8.7 4.8 10.2s8.7-.7 10.2-4.8c6.1-17 29.2-50.7 72.5-50.7zm168.5 50.7c1.5 4.2 6.1 6.3 10.2 4.8s6.3-6.1 4.8-10.2C384.3 192.9 356.7 152 304 152c-4.4 0-8 3.6-8 8s3.6 8 8 8c43.3 0 66.4 33.7 72.5 50.7z'
      
    ]
  };

  

  
  

  var faDisplayCode = {
    prefix: 'fat',
    iconName: 'display-code',
    icon: [
      576,
      512,
      ["desktop-code"],
      'e165',
      
      'M64 16C37.5 16 16 37.5 16 64V352c0 26.5 21.5 48 48 48H231.8h.3H343.9h.3H512c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H64zM222.6 416H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H353.4l13.3 80H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H360 216 136c-4.4 0-8-3.6-8-8s3.6-8 8-8h73.2l13.3-80zm16.2 0l-13.3 80H350.6l-13.3-80H238.8zM496 80H80l0 256H496V80zM80 64H496c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm165.7 77.7L179.3 208l66.3 66.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-72-72c-3.1-3.1-3.1-8.2 0-11.3l72-72c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3zm96-11.3l72 72c3.1 3.1 3.1 8.2 0 11.3l-72 72c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L396.7 208l-66.3-66.3c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0z'
      
    ]
  };

  
    var faDesktopCode = faDisplayCode;
  

  
  

  var faLessThan = {
    prefix: 'fat',
    iconName: 'less-than',
    icon: [
      384,
      512,
      [62774],
      '3c',
      
      'M375.2 76.4c2 4 .4 8.8-3.6 10.7L33.9 256 371.6 424.8c4 2 5.6 6.8 3.6 10.7s-6.8 5.6-10.7 3.6l-352-176C9.7 261.8 8 259 8 256s1.7-5.8 4.4-7.2l352-176c4-2 8.8-.4 10.7 3.6z'
      
    ]
  };

  

  
  

  var faArrowDownShortWide = {
    prefix: 'fat',
    iconName: 'arrow-down-short-wide',
    icon: [
      576,
      512,
      ["sort-amount-desc","sort-amount-down-alt"],
      'f884',
      
      'M237.7 373.7l-104 104c-3.1 3.1-8.2 3.1-11.3 0l-104-104c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L120 452.7V40c0-4.4 3.6-8 8-8s8 3.6 8 8V452.7l90.3-90.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3zM296 48h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H296c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 144H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H296c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 128H504c4.4 0 8 3.6 8 8s-3.6 8-8 8H296c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 128H568c4.4 0 8 3.6 8 8s-3.6 8-8 8H296c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  
    var faSortAmountDesc = faArrowDownShortWide;
  
    var faSortAmountDownAlt = faArrowDownShortWide;
  

  
  

  var faFlorinSign = {
    prefix: 'fat',
    iconName: 'florin-sign',
    icon: [
      384,
      512,
      [],
      'e184',
      
      'M323 32c-29.3 0-55.6 17.7-66.7 44.8L189.9 240H40c-4.4 0-8 3.6-8 8s3.6 8 8 8H183.4L112.8 429.1C104.2 450.2 83.7 464 61 464H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H61c29.3 0 55.6-17.7 66.7-44.8l73-179.2H344c4.4 0 8-3.6 8-8s-3.6-8-8-8H207.2l64-157.1C279.8 61.8 300.3 48 323 48h53c4.4 0 8-3.6 8-8s-3.6-8-8-8H323z'
      
    ]
  };

  

  
  

  var faChartMixed = {
    prefix: 'fat',
    iconName: 'chart-mixed',
    icon: [
      512,
      512,
      ["analytics"],
      'f643',
      
      'M510 34.8c2.9 3.3 2.5 8.4-.8 11.3l-184 160c-3.2 2.8-7.9 2.6-10.9-.4l-123-123L12.9 222.3c-3.5 2.7-8.5 2.1-11.2-1.4s-2.1-8.5 1.4-11.2l184-144c3.2-2.5 7.7-2.2 10.6 .6L320.4 189.1 498.8 34c3.3-2.9 8.4-2.5 11.3 .8zM80 448V352c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16zM64 320c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-17.7 14.3-32 32-32zm128-80c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16s16-7.2 16-16V256c0-8.8-7.2-16-16-16zm-32 16c0-17.7 14.3-32 32-32s32 14.3 32 32V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V256zM336 448V320c0-8.8-7.2-16-16-16s-16 7.2-16 16V448c0 8.8 7.2 16 16 16s16-7.2 16-16zM320 288c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32zm128-48c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16s16-7.2 16-16V256c0-8.8-7.2-16-16-16zm-32 16c0-17.7 14.3-32 32-32s32 14.3 32 32V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V256z'
      
    ]
  };

  
    var faAnalytics = faChartMixed;
  

  
  

  var faArrowsTurnToDots = {
    prefix: 'fat',
    iconName: 'arrows-turn-to-dots',
    icon: [
      512,
      512,
      [],
      'e4c1',
      
      'M274.3 34.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L211.3 120 440 120c39.8 0 72 32.2 72 72v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V192c0-30.9-25.1-56-56-56l-228.7 0 74.3 74.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-88-88c-3.1-3.1-3.1-8.2 0-11.3l88-88zm-36.7 256l88 88c3.1 3.1 3.1 8.2 0 11.3l-88 88c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L300.7 392 72 392c-30.9 0-56 25.1-56 56l0 56c0 4.4-3.6 8-8 8s-8-3.6-8-8V448c0-39.8 32.2-72 72-72l228.7 0-74.3-74.3c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0zM448 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-112a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM16 128a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm112 0A64 64 0 1 1 0 128a64 64 0 1 1 128 0z'
      
    ]
  };

  

  
  

  var faGrill = {
    prefix: 'fat',
    iconName: 'grill',
    icon: [
      448,
      512,
      [],
      'e5a3',
      
      'M408 48c13.3 0 24 10.7 24 24V96c0 114.9-93.1 208-208 208S16 210.9 16 96V72c0-13.3 10.7-24 24-24H408zM40 32C17.9 32 0 49.9 0 72V96c0 93.9 57.8 174.3 139.8 207.6l-23.5 51.7c-6.4-2.1-13.2-3.3-20.3-3.3c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64c0-5.5-.7-10.9-2-16H334.5l34.2 75.3c1.8 4 6.6 5.8 10.6 4s5.8-6.6 4-10.6l-75-165.1C390.2 270.3 448 189.9 448 96V72c0-22.1-17.9-40-40-40H40zM327.2 384H151.4c-5.1-8.8-12.2-16.3-20.7-21.8l24.1-53.1c21.8 7.1 45 10.9 69.2 10.9s47.4-3.8 69.2-10.9l34 74.9zM96 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  

  
  

  var faCircleDown = {
    prefix: 'fat',
    iconName: 'circle-down',
    icon: [
      512,
      512,
      [61466,"arrow-alt-circle-down"],
      'f358',
      
      'M256 16a240 240 0 1 0 0 480 240 240 0 1 0 0-480zm0 496A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm0-112c-7.2 0-14.2-2.9-19.3-8L137 292.3c-5.7-5.7-9-13.5-9-21.7c0-16.9 13.7-30.6 30.6-30.6H208V152c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40v88h49.4c16.9 0 30.6 13.7 30.6 30.6c0 8.1-3.2 15.9-9 21.7L275.3 392c-5.1 5.1-12.1 8-19.3 8zm-8-19.3c2.1 2.1 5 3.3 8 3.3s5.9-1.2 8-3.3L363.7 281c2.7-2.7 4.3-6.5 4.3-10.3c0-8.1-6.6-14.6-14.6-14.6H296c-4.4 0-8-3.6-8-8V152c0-13.3-10.7-24-24-24H248c-13.3 0-24 10.7-24 24v96c0 4.4-3.6 8-8 8H158.6c-8.1 0-14.6 6.5-14.6 14.6c0 3.9 1.5 7.6 4.3 10.3L248 380.7z'
      
    ]
  };

  
    var faArrowAltCircleDown = faCircleDown;
  

  
  

  var faPersonRunningFast = {
    prefix: 'fat',
    iconName: 'person-running-fast',
    icon: [
      512,
      512,
      [],
      'e5ff',
      
      'M268.2 148.1c4.2 1.2 7.7 4.1 9.8 7.9s2.4 8.4 1 12.5L248.8 259c-7 21 1.3 44.1 20.1 55.9l86.2 53.9c6 3.8 8.9 11.1 6.9 18l-25.4 88.8c-2.4 8.5 2.5 17.4 11 19.8s17.4-2.5 19.8-11l25.4-88.8c5.9-20.6-2.6-42.6-20.7-53.9l-47.9-30c-6.5-4.1-9.2-12.2-6.4-19.4l30-77.3c2.3-5.9 7.8-9.9 14.2-10.2s12.2 3.2 15.1 8.8l15.9 31.7c8.1 16.3 24.8 26.5 42.9 26.5H480c8.8 0 16-7.2 16-16s-7.2-16-16-16H435.8c-6.1 0-11.6-3.4-14.3-8.8l-32.9-65.7c-6-12-16.8-21-29.7-24.7l-90.7-25.9c-6.6-1.9-13.4-2.8-20.3-2.8c-19.6 0-38.3 7.8-52.1 21.6l-31.1 31.1c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l31.1-31.1c7.8-7.8 18.4-12.2 29.5-12.2c3.9 0 7.7 .5 11.5 1.6l8.8 2.5zm-114.8 5.3l31.1-31.1C201.3 105.5 224.1 96 247.9 96c8.3 0 16.6 1.2 24.7 3.5l90.7 25.9c17.3 4.9 31.6 16.9 39.7 32.9L435.8 224H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H435.8c-24.2 0-46.4-13.7-57.2-35.4l-6.2-12.4-9.7-19.3L354.8 241l-22.2 57.1 47.9 30c24.2 15.1 35.5 44.4 27.6 71.9l-25.4 88.8c-4.9 17-22.6 26.8-39.6 22s-26.8-22.6-22-39.6l25.4-88.8-86.2-53.9c-25.1-15.7-36.1-46.5-26.8-74.5l25.1-75.3 5.1-15.2L255 161c-2.2-.6-4.6-1-6.9-1l-.2 0c-6.8 0-13.4 2.7-18.2 7.5l-31.1 31.1c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3zM368 80a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM320 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM207.3 314.8c2.9 6.2 6.4 12.1 10.6 17.6l-9.2 25.2L204.8 368H193.6 128c-8.8 0-16 7.2-16 16s7.2 16 16 16h65.6c20.1 0 38.1-12.6 45.1-31.5l4.7-12.9 0 0 13.9 8.7-3.6 9.7c-9.2 25.2-33.2 42-60.1 42H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h65.6l13.7-37.2zM8 95.8H152c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8zm-8 72c0-4.4 3.6-8 8-8H88c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8zm8 56H152c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faTurnLeftDown = {
    prefix: 'fat',
    iconName: 'turn-left-down',
    icon: [
      384,
      512,
      [],
      'e637',
      
      'M240 336h89.1c3.8 0 6.9 3.1 6.9 6.9c0 1.8-.7 3.5-1.9 4.7L193.9 495.2c-.5 .5-1.2 .8-1.9 .8s-1.4-.3-1.9-.8L49.9 347.6c-1.2-1.3-1.9-3-1.9-4.7c0-3.8 3.1-6.9 6.9-6.9H144c8.8 0 16-7.2 16-16V112c0-53 43-96 96-96h88c13.3 0 24 10.7 24 24V56c0 13.3-10.7 24-24 24l-88 0c-17.7 0-32 14.3-32 32V320c0 8.8 7.2 16 16 16zM205.5 506.2L345.7 358.6c4-4.2 6.3-9.9 6.3-15.8c0-12.6-10.2-22.9-22.9-22.9H256 240V304 112c0-8.8 7.2-16 16-16l88 0c22.1 0 40-17.9 40-40V40c0-22.1-17.9-40-40-40H256C194.1 0 144 50.1 144 112V304v16H128 54.9C42.2 320 32 330.2 32 342.9c0 5.9 2.3 11.5 6.3 15.8L178.5 506.2c3.5 3.7 8.4 5.8 13.5 5.8s10-2.1 13.5-5.8z'
      
    ]
  };

  

  
  

  var faWaveTriangle = {
    prefix: 'fat',
    iconName: 'wave-triangle',
    icon: [
      640,
      512,
      [],
      'f89a',
      
      'M176.1 32c2.6 0 5.1 1.4 6.6 3.6L464.2 457.8 625.4 227.4c2.5-3.6 7.5-4.5 11.1-2s4.5 7.5 2 11.1l-168 240c-1.5 2.2-4 3.4-6.6 3.4s-5.1-1.4-6.6-3.6L175.8 54.2 14.6 284.6c-2.5 3.6-7.5 4.5-11.1 2s-4.5-7.5-2-11.1l168-240c1.5-2.2 4-3.4 6.6-3.4z'
      
    ]
  };

  

  
  

  var faImagePolaroid = {
    prefix: 'fat',
    iconName: 'image-polaroid',
    icon: [
      448,
      512,
      [],
      'f8c4',
      
      'M432 352v64c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V352H432zm-11.3-16H155.3l42.3-42.3L282.3 209c3.1-3.1 8.2-3.1 11.3 0l127 127zm-282.3-5.7l-5.7 5.7H27.3l95-95c3.1-3.1 8.2-3.1 11.3 0l47 47-42.3 42.3zM16 96c0-26.5 21.5-48 48-48H384c26.5 0 48 21.5 48 48V324.7l-127-127c-9.4-9.4-24.6-9.4-33.9 0l-79 79-47-47c-9.4-9.4-24.6-9.4-33.9 0l-95 95V96zM448 336V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V336v8 8 64c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V352v-8-8zM136 144a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-24-40a40 40 0 1 0 0 80 40 40 0 1 0 0-80z'
      
    ]
  };

  

  
  

  var faIndustry = {
    prefix: 'fat',
    iconName: 'industry',
    icon: [
      576,
      512,
      [],
      'f275',
      
      'M72 48C58.7 48 48 58.7 48 72V304v48 72c0 22.1 17.9 40 40 40H488c22.1 0 40-17.9 40-40V320 304 152.9c0-12.2-13.2-19.9-23.8-14L363.9 217.5c-2.5 1.4-5.5 1.4-8-.1s-4-4.1-4-6.9V153.8c0-12.3-13.4-20-24.1-13.8L188 221.6c-2.5 1.4-5.5 1.5-8 0s-4-4.1-4-6.9V72c0-13.3-10.7-24-24-24H72zM32 72c0-22.1 17.9-40 40-40h80c22.1 0 40 17.9 40 40V200.7l127.9-74.6c21.3-12.4 48.1 2.9 48.1 27.6v43.1L496.4 125c21.3-11.9 47.6 3.5 47.6 27.9V304v16V424c0 30.9-25.1 56-56 56H88c-30.9 0-56-25.1-56-56V352 304 72z'
      
    ]
  };

  

  
  

  var faBoreHole = {
    prefix: 'fat',
    iconName: 'bore-hole',
    icon: [
      512,
      512,
      [],
      'e4c3',
      
      'M256 0c4.4 0 8 3.6 8 8V272.5c31.6 3.9 56 30.9 56 63.5c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-32.6 24.4-59.6 56-63.5V8c0-4.4 3.6-8 8-8zm0 288a48 48 0 1 0 0 96 48 48 0 1 0 0-96zM64 144c-26.5 0-48 21.5-48 48V448c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V192c0-26.5-21.5-48-48-48H384c-8.8 0-16 7.2-16 16V352c0 61.9-50.1 112-112 112s-112-50.1-112-112V160c0-8.8-7.2-16-16-16H64zM0 192c0-35.3 28.7-64 64-64h64c17.7 0 32 14.3 32 32V352c0 53 43 96 96 96s96-43 96-96V160c0-17.7 14.3-32 32-32h64c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192z'
      
    ]
  };

  

  
  

  var faArrowsRepeat = {
    prefix: 'fat',
    iconName: 'arrows-repeat',
    icon: [
      512,
      512,
      ["repeat-alt"],
      'f364',
      
      'M0 264c0 4.4 3.6 8 8 8s8-3.6 8-8v-8c0-83.9 68.1-152 152-152H419.4l-80.8 74.1c-3.3 3-3.5 8-.5 11.3s8 3.5 11.3 .5l96-88c1.7-1.5 2.6-3.7 2.6-5.9s-.9-4.4-2.6-5.9l-96-88c-3.3-3-8.3-2.8-11.3 .5s-2.8 8.3 .5 11.3L419.4 88H168C75.2 88 0 163.2 0 256v8zm512-16c0-4.4-3.6-8-8-8s-8 3.6-8 8v8c0 83.9-68.1 152-152 152H92.6l80.8-74.1c3.3-3 3.5-8 .5-11.3s-8-3.5-11.3-.5l-96 88c-1.7 1.5-2.6 3.7-2.6 5.9s.9 4.4 2.6 5.9l96 88c3.3 3 8.3 2.8 11.3-.5s2.8-8.3-.5-11.3L92.6 424H344c92.8 0 168-75.2 168-168v-8z'
      
    ]
  };

  
    var faRepeatAlt = faArrowsRepeat;
  

  
  

  var faHorseHead = {
    prefix: 'fat',
    iconName: 'horse-head',
    icon: [
      640,
      512,
      [],
      'f7ab',
      
      'M414.9 20.5c12.2-4.4 25.1 4.6 25.1 17.6c0 4.5-1.6 8.8-4.5 12.2L393.9 98.8c-1.8 2.1-2.4 5-1.5 7.6s3 4.7 5.7 5.3l6.8 1.7c34.4 8.6 63.6 31 80.8 62l62.7 112.9c15.5 27.9 11.7 62.6-9.5 86.4c-14.3 16-34.7 25.2-56.2 25.2h-8.4c-24.3 0-47.3-11-62.5-30l-34-42.5c-4.7-5.9-13.3-6.9-19.2-2.3c-34.8 27.1-84.6 22.9-114.5-9.6l-30.2-33c-3-3.3-8-3.5-11.3-.5s-3.5 8-.5 11.3l30.2 33c21.7 23.7 52.3 34.7 82.2 32.3l38.6 70.8c4.5 8.2 6.8 17.3 6.8 26.7c0 22-17.8 39.8-39.8 39.8H120c-22.1 0-40-17.9-40-40V315.6c0-104.4 65.4-197.7 163.6-233.2L414.9 20.5zM367.2 421.9l-36-65.9c12.5-3.1 24.5-8.7 35.4-16.8L399.3 380c18.2 22.8 45.8 36 75 36h8.4c26 0 50.8-11.1 68.1-30.6c25.7-28.9 30.4-71 11.6-104.8L499.6 167.7c-18.4-33.1-49-57.6-85.2-68.2l33.2-38.8c5.4-6.3 8.4-14.3 8.4-22.6C456 14 432.1-2.8 409.4 5.4L238.2 67.4C133.7 105.2 64 204.5 64 315.6V456c0 30.9 25.1 56 56 56H320.2c30.8 0 55.8-25 55.8-55.8c0-12-3-23.8-8.8-34.3zM416 208a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64z'
      
    ]
  };

  

  
  

  var faCircleDollar = {
    prefix: 'fat',
    iconName: 'circle-dollar',
    icon: [
      512,
      512,
      ["dollar-circle","usd-circle"],
      'f2e8',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM255.5 96c4.4 0 8 3.6 8 8v35.2c6.5 .1 13.2 .6 20 1.6c9.6 1.4 19 4.1 28.4 6.8l0 0 0 0c2.8 .8 5.5 1.6 8.3 2.3c4.3 1.2 6.8 5.6 5.6 9.9s-5.6 6.8-9.8 5.6c-2.8-.8-5.5-1.6-8.3-2.4l0 0c-8.7-2.5-17.6-5.1-26.5-6.4c-22.9-3.4-44.4-.5-60.4 6.4c-16.2 7-25.8 17.5-27.9 29.1c-2.7 14.8 3.4 26.4 15.8 34.4c13.2 8.4 32.1 13.8 52.9 19.7l4.6 1.3c18.8 5.3 38.3 10.8 54.5 21.9c18.1 12.4 26.2 31.7 22.2 53.3c-3.7 20.1-17.5 33.9-36.2 41.4c-12.4 5-27.2 7.4-43.1 7.3l0 36.7c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-37.6c-2.7-.3-5.4-.6-8.1-1l0 0c-8.2-1.3-22.9-5.5-35.1-9.1c-7.6-2.3-15.3-4.7-22.9-7.2c-4.2-1.4-6.5-5.9-5.1-10.1s5.9-6.5 10.1-5.1c7.5 2.4 15 4.8 22.5 7.1c12.4 3.8 26 7.6 32.8 8.6c23.3 3.4 43.8 1.7 58.9-4.4c14.9-6 24-15.9 26.5-29.4c2.8-15.5-2.6-28.3-15.5-37.2c-14.5-9.9-32.1-14.8-49-19.5l0 0 0 0c-2.3-.6-4.6-1.3-6.8-1.9c-19.6-5.6-40.5-11.5-55.7-21.2c-17.9-11.4-26.8-29.6-22.9-50.7c3.4-18.7 18.3-32.7 37.3-40.9c9.8-4.2 21.1-7.1 33.1-8.4V104c0-4.4 3.6-8 8-8z'
      
    ]
  };

  
    var faDollarCircle = faCircleDollar;
  
    var faUsdCircle = faCircleDollar;
  

  
  

  var faFaceLaughWink = {
    prefix: 'fat',
    iconName: 'face-laugh-wink',
    icon: [
      512,
      512,
      ["laugh-wink"],
      'f59c',
      
      'M335.8 168c-.1 0-.1 0-.2 0c-8 0-15.8 1.8-23.1 5.2c-10.5 4.8-19.7 12.6-26.7 22.9c-1.8 2.5-3.5 5.2-5.1 8.1c-2.2 3.9-.8 8.7 3.1 10.9c1.3 .7 2.7 1.1 4.1 1c3 .1 5.9-1.6 7.3-4.4c1.2-2.4 2.5-4.7 4-6.8c6.6-9.1 14.4-15 22.5-18.1c4.5-1.7 9.3-2.6 14.2-2.7c14.5 .1 30 8.7 40.8 27.9c1.5 2.7 4.3 4.2 7.2 4.1c.1 0 .1 0 .2 0c1.2 0 2.4-.3 3.6-.8c4-2 5.5-6.8 3.6-10.7C379.9 182 358.8 168 336 168c-.1 0-.1 0-.2 0zM176 208l.2 0 .2 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-.2 0-.2 0c-8.8 0-16 7.1-16 16s7.2 16 16 16zm-55.9 80c-9.6 0-17.2 8.5-16 18l0 .3c-.3 2.5-.2 5.1 .5 7.7c.8 2.8 1.6 5.6 2.5 8.4C122.7 385.3 179.9 432 248 432H264c68.1 0 125.2-46.7 140.8-109.6c.9-2.8 1.7-5.6 2.5-8.4c.7-2.7 .9-5.3 .5-7.7l0-.3c1.2-9.6-6.3-18-16-18h-6.4H126.5h-6.4zm6.4 16H385.5c2.4 0 4.4 1.1 5.4 2.3c.2 .2 .4 .5 .5 .7c-.6 4.1-1.4 8.1-2.4 12C370 375.6 317.4 416 256 416c-61.5 0-114.1-40.5-133.2-97.2c-1-3.9-1.7-7.8-2.3-11.8c.1-.2 .3-.5 .5-.7c1.1-1.2 3-2.3 5.4-2.3zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zm0 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480z'
      
    ]
  };

  
    var faLaughWink = faFaceLaughWink;
  

  
  

  var faSignalFair = {
    prefix: 'fat',
    iconName: 'signal-fair',
    icon: [
      640,
      512,
      ["signal-2"],
      'f68d',
      
      'M200 296c0-4.4-3.6-8-8-8s-8 3.6-8 8V504c0 4.4 3.6 8 8 8s8-3.6 8-8V296zM72 392c0-4.4-3.6-8-8-8s-8 3.6-8 8V504c0 4.4 3.6 8 8 8s8-3.6 8-8V392z'
      
    ]
  };

  
    var faSignal2 = faSignalFair;
  

  
  

  var faHouseTree = {
    prefix: 'fat',
    iconName: 'house-tree',
    icon: [
      640,
      512,
      [],
      'e1b3',
      
      'M404.1 25c6.4-7 17.4-7 23.7 0l131.2 145c.6 .7 .9 1.5 .9 2.4c0 2-1.6 3.6-3.5 3.6H488c-3.1 0-5.9 1.8-7.2 4.6s-.9 6.1 1 8.5L590 321.5c1.3 1.6 2 3.6 2 5.6c0 4.9-4 8.9-8.9 8.9H504c-3.2 0-6 1.9-7.3 4.8s-.7 6.3 1.4 8.6L622.3 485.3c1.1 1.2 1.7 2.7 1.7 4.3c0 3.5-2.9 6.4-6.4 6.4H409.3c-2.5 5.7-5.6 11.1-9.3 16H617.6c12.4 0 22.4-10 22.4-22.4c0-5.6-2.1-11-5.9-15.1L522.2 352h61c13.7 0 24.9-11.1 24.9-24.9c0-5.7-2-11.3-5.6-15.7L504.9 192h51.6c10.8 0 19.5-8.8 19.5-19.6c0-4.8-1.8-9.5-5.1-13.1L439.7 14.3c-12.7-14-34.8-14-47.5 0L290.5 126.8l11.8 10.8L404.1 25zM16 280.6c0-11.2 4.7-21.9 13-29.5L165 126.5c15.3-14 38.8-14 54.1 0L355 251.1c8.3 7.6 13 18.3 13 29.5V456c0 22.1-17.9 40-40 40H56c-22.1 0-40-17.9-40-40V280.6zM0 456c0 30.9 25.1 56 56 56H328c30.9 0 56-25.1 56-56V280.6c0-15.7-6.6-30.7-18.2-41.3l-136-124.7c-21.4-19.6-54.3-19.6-75.7 0L18.2 239.4C6.6 250 0 264.9 0 280.6V456zM224 280c4.4 0 8 3.6 8 8v64c0 4.4-3.6 8-8 8H160c-4.4 0-8-3.6-8-8V288c0-4.4 3.6-8 8-8h64zm-64-16c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24h64c13.3 0 24-10.7 24-24V288c0-13.3-10.7-24-24-24H160z'
      
    ]
  };

  

  
  

  var faHockeyStickPuck = {
    prefix: 'fat',
    iconName: 'hockey-stick-puck',
    icon: [
      640,
      512,
      [],
      'e3ae',
      
      'M507.7 .9c3.9 2 5.5 6.9 3.4 10.8l-242.9 470c-9.6 18.6-28.8 30.3-49.8 30.3H48c-26.5 0-48-21.5-48-48V378.7c0-26.5 21.5-48 48-48H328.3L496.9 4.3c2-3.9 6.9-5.5 10.8-3.4zM320 346.7H112V496H218.5c15 0 28.7-8.3 35.5-21.6l66-127.7zm-272 0c-17.7 0-32 14.3-32 32V464c0 17.7 14.3 32 32 32H96V346.7H48zM432 416c-17.7 0-32 14.3-32 32v16c0 17.7 14.3 32 32 32H592c17.7 0 32-14.3 32-32V448c0-17.7-14.3-32-32-32H432zm-48 32c0-26.5 21.5-48 48-48H592c26.5 0 48 21.5 48 48v16c0 26.5-21.5 48-48 48H432c-26.5 0-48-21.5-48-48V448z'
      
    ]
  };

  

  
  

  var faLaptopArrowDown = {
    prefix: 'fat',
    iconName: 'laptop-arrow-down',
    icon: [
      640,
      512,
      [],
      'e1c6',
      
      'M128 32H280V48H128c-26.5 0-48 21.5-48 48V352H64V96c0-35.3 28.7-64 64-64zM512 48H360V32H512c35.3 0 64 28.7 64 64V352H560V96c0-26.5-21.5-48-48-48zM16 403.2C16 436.8 43.2 464 76.8 464H563.2c33.6 0 60.8-27.2 60.8-60.8c0-1.8-1.4-3.2-3.2-3.2H19.2c-1.8 0-3.2 1.4-3.2 3.2zm-16 0C0 392.6 8.6 384 19.2 384H620.8c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2zM328 40V292.7l74.3-74.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-88 88c-3.1 3.1-8.2 3.1-11.3 0l-88-88c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L312 292.7V40c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faBracketsSquare = {
    prefix: 'fat',
    iconName: 'brackets-square',
    icon: [
      448,
      512,
      ["brackets"],
      'f7e9',
      
      'M408 32c22.1 0 40 17.9 40 40V440c0 22.1-17.9 40-40 40H296c-4.4 0-8-3.6-8-8s3.6-8 8-8H408c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H296c-4.4 0-8-3.6-8-8s3.6-8 8-8H408zM40 32H152c4.4 0 8 3.6 8 8s-3.6 8-8 8H40C26.7 48 16 58.7 16 72V440c0 13.3 10.7 24 24 24H152c4.4 0 8 3.6 8 8s-3.6 8-8 8H40c-22.1 0-40-17.9-40-40V72C0 49.9 17.9 32 40 32z'
      
    ]
  };

  
    var faBrackets = faBracketsSquare;
  

  
  

  var faFaceSmileHearts = {
    prefix: 'fat',
    iconName: 'face-smile-hearts',
    icon: [
      640,
      512,
      [],
      'e390',
      
      'M489 25.1c12-12.1 31.5-12.1 43.6 0l13.7 13.8c1.5 1.5 3.5 2.4 5.7 2.4s4.2-.8 5.7-2.4l13.7-13.8c12-12.1 31.5-12.1 43.6 0C627 37.3 627 57 615 69.1l-55.4 55.8c-4.1 4.2-10.8 4.2-15 0L489 69.1c-12.1-12.1-12.1-31.8 0-44zM544 13.8c-18.3-18.4-48-18.4-66.3 0c-18.3 18.4-18.3 48.2 0 66.5l55.5 55.8c10.4 10.5 27.3 10.5 37.7 0l55.4-55.8c18.3-18.4 18.3-48.2 0-66.5c-18.3-18.4-48-18.4-66.3 0l-8 8.1L544 13.8zM434.6 27C400.1 9.7 361.2 0 320 0C178.6 0 64 114.6 64 256c0 17.5 1.8 34.7 5.1 51.2c6.3 1.9 12.5 4.5 18.2 8C82.6 296.3 80 276.4 80 256C80 123.5 187.5 16 320 16c40.5 0 78.6 10 112.1 27.7c.2-5.6 1.1-11.2 2.5-16.7zM546.2 175.7c8.9 25.1 13.8 52.1 13.8 80.3c0 30.7-5.8 60.1-16.3 87.2c2.9 1.3 5.7 2.8 8.4 4.5c2.9-1.8 5.8-3.3 8.8-4.7c9.8-27.2 15.2-56.4 15.2-87c0-28.3-4.6-55.6-13.1-81c-5.5 1-11.1 1.3-16.7 .7zM446.1 460.2C409.5 482.9 366.3 496 320 496c-54 0-103.9-17.9-144-48l-11.4 11.4c43.1 33 97 52.5 155.4 52.5c50.2 0 97.1-14.5 136.6-39.5l-1.6-1.6c-3.3-3.3-6.3-6.9-8.9-10.7zM203.4 321.4c-3.6 2.5-4.5 7.5-2 11.1c22.4 32 61.9 67.4 118.6 67.4s96.1-35.4 118.6-67.4c2.5-3.6 1.7-8.6-2-11.1s-8.6-1.7-11.1 2C404.6 353.2 369.4 384 320 384s-84.6-30.8-105.4-60.6c-2.5-3.6-7.5-4.5-11.1-2zm-4.8-93.5c10.9-19.3 26.4-27.9 41-27.9s30.2 8.6 41 27.9c2.2 3.9 7 5.2 10.9 3.1s5.2-7 3.1-10.9c-13.1-23.4-33.6-36.1-55-36.1s-41.8 12.7-55 36.1c-2.2 3.9-.8 8.7 3.1 10.9s8.7 .8 10.9-3.1zm201-27.9c14.6 0 30.2 8.6 41 27.9c2.2 3.9 7 5.2 10.9 3.1s5.2-7 3.1-10.9c-13.1-23.4-33.6-36.1-55-36.1s-41.8 12.7-55 36.1c-2.2 3.9-.8 8.7 3 10.9s8.7 .8 10.9-3.1c10.9-19.3 26.4-27.9 41-27.9zm133 193.1l13.7 13.8c1.5 1.5 3.5 2.4 5.7 2.4s4.2-.9 5.7-2.4l13.7-13.8c12-12.1 31.5-12.1 43.6 0c12.1 12.1 12.1 31.8 0 44l-55.4 55.8c-4.1 4.2-10.8 4.2-15 0L489 437c-12.1-12.1-12.1-31.8 0-44c12-12.1 31.5-12.1 43.6 0zm-54.9-11.3c-18.3 18.4-18.3 48.2 0 66.5l55.5 55.8c10.4 10.5 27.3 10.5 37.7 0l55.4-55.8c18.3-18.4 18.3-48.2 0-66.5c-18.3-18.4-48-18.4-66.3 0l-8 8.1-8.1-8.1c-18.3-18.4-48-18.4-66.3 0zM25 361.1c12-12.1 31.5-12.1 43.6 0l13.7 13.8c1.5 1.5 3.5 2.4 5.7 2.4s4.2-.9 5.7-2.4l13.7-13.8c12-12.1 31.5-12.1 43.6 0c12.1 12.1 12.1 31.8 0 44L95.5 460.9c-4.1 4.2-10.8 4.2-15 0L25 405c-12.1-12.1-12.1-31.8 0-44zM80 349.8c-18.3-18.4-48-18.4-66.3 0c-18.3 18.4-18.3 48.2 0 66.5l55.5 55.8c10.4 10.5 27.3 10.5 37.7 0l55.4-55.8c18.3-18.4 18.3-48.2 0-66.5c-18.3-18.4-48-18.4-66.3 0l-8 8.1L80 349.8z'
      
    ]
  };

  

  
  

  var faSquare8 = {
    prefix: 'fat',
    iconName: 'square-8',
    icon: [
      448,
      512,
      [],
      'e25d',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm232 32c35.3 0 64 28.7 64 64c0 22.3-11.4 41.9-28.7 53.4C293.5 256.1 312 281.9 312 312c0 39.8-32.2 72-72 72H208c-39.8 0-72-32.2-72-72c0-30.1 18.5-55.9 44.7-66.6C163.4 233.9 152 214.3 152 192c0-35.3 28.7-64 64-64h16zm0 128H216l0 0h-8c-30.9 0-56 25.1-56 56s25.1 56 56 56h32c30.9 0 56-25.1 56-56s-25.1-56-56-56h-8l0 0zm48-64c0-26.5-21.5-48-48-48H216c-26.5 0-48 21.5-48 48c0 26.5 21.5 48 48 48l0 0h16l0 0c26.5 0 48-21.5 48-48z'
      
    ]
  };

  

  
  

  var faSquareArrowLeft = {
    prefix: 'fat',
    iconName: 'square-arrow-left',
    icon: [
      448,
      512,
      ["arrow-square-left"],
      'f33a',
      
      'M16 416c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-320c0-26.5-21.5-48-48-48L64 48C37.5 48 16 69.5 16 96l0 320zm48 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zM98.3 250.3l104-104c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L123.3 248 344 248c4.4 0 8 3.6 8 8s-3.6 8-8 8l-220.7 0 90.3 90.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-104-104c-3.1-3.1-3.1-8.2 0-11.3z'
      
    ]
  };

  
    var faArrowSquareLeft = faSquareArrowLeft;
  

  
  

  var faGuitar = {
    prefix: 'fat',
    iconName: 'guitar',
    icon: [
      512,
      512,
      [],
      'f7a6',
      
      'M440 19.3c2.1-2.1 5-3.3 8-3.3s5.9 1.2 8 3.3L492.7 56c2.1 2.1 3.3 5 3.3 8s-1.2 5.9-3.3 8l-46.9 46.9c-1.1 1.1-2.5 1.9-4.1 2.2l-63.5 12.7 12.7-63.5c.3-1.5 1.1-3 2.2-4.1L440 19.3zM375.2 67.2l-14.6 72.9-56.9 56.9c-47.9-43.3-113.8-49.6-150.2-13.2c-11 11-18 24.6-21.4 39.6c-3.7 16.6-19.1 30.7-36.1 31.6c-25.6 1.3-49.3 10.7-67.3 28.6C-16 328.4-7.6 409.4 47.5 464.5s136.1 63.5 180.9 18.7c17.9-17.9 27.4-41.7 28.6-67.3c.9-17 15-32.3 31.6-36.1c15-3.4 28.6-10.5 39.6-21.4c36.4-36.4 30.1-102.3-13.2-150.2l56.9-56.9 72.9-14.6c4.6-.9 8.9-3.2 12.3-6.6L504 83.3c5.1-5.1 8-12.1 8-19.3s-2.9-14.2-8-19.3L467.3 8c-5.1-5.1-12.1-8-19.3-8s-14.2 2.9-19.3 8L381.8 54.9c-3.4 3.4-5.6 7.6-6.6 12.3zM292.4 208.3l-56.6 56.6c-7.8-5.6-17.4-8.9-27.8-8.9c-26.5 0-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48c0-10.4-3.3-20-8.9-27.8l56.6-56.6c39.4 43.9 41.2 99.5 13.2 127.5c-8.6 8.6-19.5 14.4-31.8 17.1c-22.9 5.2-42.8 26-44.1 50.9c-1.1 22.1-9.2 42-24 56.8C180.7 508.3 110 504.4 58.8 453.2S3.7 331.3 40.1 294.9c14.8-14.8 34.6-22.9 56.8-24c24.9-1.3 45.7-21.2 50.9-44.1c2.8-12.3 8.5-23.1 17.1-31.8c28-28 83.6-26.2 127.5 13.2zM208 272a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faScreenUsers = {
    prefix: 'fat',
    iconName: 'screen-users',
    icon: [
      640,
      512,
      ["users-class"],
      'f63d',
      
      'M544 16H96C69.5 16 48 37.5 48 64V236.8c-5.7 3.3-11.1 7.2-16 11.6V64C32 28.7 60.7 0 96 0H544c35.3 0 64 28.7 64 64V248.4c-4.9-4.4-10.3-8.3-16-11.6V64c0-26.5-21.5-48-48-48zM96 368a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-112a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM320 368a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-112a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm272 64a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-112 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM16 488v16c0 4.4-3.6 8-8 8s-8-3.6-8-8V488c0-39.8 32.2-72 72-72h48c39.8 0 72 32.2 72 72v16c0 4.4-3.6 8-8 8s-8-3.6-8-8V488c0-30.9-25.1-56-56-56H72c-30.9 0-56 25.1-56 56zm280-56c-30.9 0-56 25.1-56 56v16c0 4.4-3.6 8-8 8s-8-3.6-8-8V488c0-39.8 32.2-72 72-72h48c39.8 0 72 32.2 72 72v16c0 4.4-3.6 8-8 8s-8-3.6-8-8V488c0-30.9-25.1-56-56-56H296zm168 56v16c0 4.4-3.6 8-8 8s-8-3.6-8-8V488c0-39.8 32.2-72 72-72h48c39.8 0 72 32.2 72 72v16c0 4.4-3.6 8-8 8s-8-3.6-8-8V488c0-30.9-25.1-56-56-56H520c-30.9 0-56 25.1-56 56z'
      
    ]
  };

  
    var faUsersClass = faScreenUsers;
  

  
  

  var faTrashCanSlash = {
    prefix: 'fat',
    iconName: 'trash-can-slash',
    icon: [
      640,
      512,
      ["trash-alt-slash"],
      'e2ad',
      
      'M482.7 476.2C472.5 488.3 457.1 496 440 496H200c-30.9 0-56-25.1-56-56V208.8l-16-12.6V440c0 39.8 32.2 72 72 72H440c22.2 0 42.1-10.1 55.3-25.9l-12.6-9.9zM211.6 64H193l20.3 16H536c4.4 0 8-3.6 8-8s-3.6-8-8-8H428.4L400.2 18.8C392.9 7.1 380.1 0 366.3 0H273.7c-13.8 0-26.6 7.1-33.9 18.8L211.6 64zM232 278.3l-16-12.6V416c0 4.4 3.6 8 8 8s8-3.6 8-8V278.3zM328 416V354l-16-12.6V416c0 4.4 3.6 8 8 8s8-3.6 8-8zm80-256v73.7l16 12.6V160c0-4.4-3.6-8-8-8s-8 3.6-8 8zm88-40V303.2l16 12.6V120c0-4.4-3.6-8-8-8s-8 3.6-8 8zM253.4 27.3c4.4-7 12.1-11.3 20.4-11.3h92.5c8.3 0 16 4.3 20.4 11.3L409.6 64H230.4l23-36.7zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  
    var faTrashAltSlash = faTrashCanSlash;
  

  
  

  var faSun = {
    prefix: 'fat',
    iconName: 'sun',
    icon: [
      512,
      512,
      [9728],
      'f185',
      
      'M165.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L121 121 13.1 140.8c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L65.1 256 2.8 346.3c-3.1 4.5-3.7 10.2-1.6 15.2s6.6 8.6 11.9 9.6L121 391l19.8 107.9c1 5.3 4.6 9.8 9.6 11.9l3.1-7.4-3.1 7.4c5 2.1 10.7 1.5 15.2-1.6L256 446.9l90.3 62.3c4.5 3.1 10.2 3.7 15.2 1.6s8.6-6.6 9.6-11.9L391 391l107.9-19.8c5.3-1 9.8-4.6 11.9-9.6s1.5-10.7-1.6-15.2L446.9 256l62.3-90.3c3.1-4.5 3.7-10.2 1.6-15.2l-7.4 3.1 7.4-3.1c-2.1-5-6.6-8.6-11.9-9.6L391 121 371.1 13.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L256 65.1 165.7 2.8zm94.9 78.6L355.4 16l20.8 113.3c.6 3.3 3.2 5.8 6.4 6.4L496 156.6l-65.4 94.9c-1.9 2.7-1.9 6.3 0 9.1L496 355.4 382.7 376.2c-3.3 .6-5.8 3.2-6.4 6.4L355.4 496l-94.9-65.4c-2.7-1.9-6.3-1.9-9.1 0L156.6 496 135.8 382.7c-.6-3.3-3.2-5.8-6.4-6.4L16 355.4l65.4-94.9c1.9-2.7 1.9-6.3 0-9.1L16 156.6l113.3-20.8c3.3-.6 5.8-3.2 6.4-6.4L156.6 16l94.9 65.4c2.7 1.9 6.3 1.9 9.1 0zM256 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM160 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z'
      
    ]
  };

  

  
  

  var faObjectsAlignCenterHorizontal = {
    prefix: 'fat',
    iconName: 'objects-align-center-horizontal',
    icon: [
      512,
      512,
      [],
      'e3bc',
      
      'M264 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64L80 64c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H248v64H144c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H248v56c0 4.4 3.6 8 8 8s8-3.6 8-8V448H368c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H264V224H432c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48L264 64V8zm-8 296H368c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H256 144c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32H256zm0-96L80 208c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l352 0c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H256z'
      
    ]
  };

  

  
  

  var faChampagneGlass = {
    prefix: 'fat',
    iconName: 'champagne-glass',
    icon: [
      320,
      512,
      ["glass-champagne"],
      'f79e',
      
      'M54.1 144H265.9l9.7 53.4C288.8 269.6 233.3 336 160 336S31.2 269.6 44.4 197.4L54.1 144zM57 128L75 29.1C76.3 21.5 83 16 90.7 16H229.3c7.7 0 14.4 5.5 15.7 13.1L263 128H57zM59.2 26.3L28.6 194.6C14.2 273.9 72.7 347.1 152 351.8V496H72c-4.4 0-8 3.6-8 8s3.6 8 8 8h88 88c4.4 0 8-3.6 8-8s-3.6-8-8-8H168V351.8c79.3-4.6 137.8-77.9 123.4-157.2L260.8 26.3C258 11.1 244.8 0 229.3 0H90.7C75.2 0 62 11.1 59.2 26.3z'
      
    ]
  };

  
    var faGlassChampagne = faChampagneGlass;
  

  
  

  var faTrashUndo = {
    prefix: 'fat',
    iconName: 'trash-undo',
    icon: [
      448,
      512,
      ["trash-arrow-turn-left"],
      'f895',
      
      'M177.7 16h92.5c8.3 0 16 4.3 20.4 11.3l23 36.7H134.4l23-36.7c4.4-7 12.1-11.3 20.4-11.3zm-33.9 2.8L115.6 64H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H332.4L304.2 18.8C296.9 7.1 284.1 0 270.3 0H177.7c-13.8 0-26.6 7.1-33.9 18.8zM48 119.3c-.4-4.4-4.2-7.7-8.6-7.3s-7.7 4.2-7.3 8.6l28.3 340c2.4 29 26.7 51.4 55.8 51.4H331.8c29.1 0 53.4-22.3 55.8-51.4l28.3-340c.4-4.4-2.9-8.3-7.3-8.6s-8.3 2.9-8.6 7.3l-28.3 340C370 480.1 352.6 496 331.8 496H116.2c-20.8 0-38.1-15.9-39.9-36.7L48 119.3zm165.9 67.3c-3-3.3-8-3.5-11.3-.5l-88 80c-1.7 1.5-2.6 3.7-2.6 5.9s1 4.4 2.6 5.9l88 80c3.3 3 8.3 2.7 11.3-.5s2.7-8.3-.5-11.3L140.7 280H248c30.9 0 56 25.1 56 56v40c0 4.4 3.6 8 8 8s8-3.6 8-8V336c0-39.8-32.2-72-72-72H140.7l72.7-66.1c3.3-3 3.5-8 .5-11.3z'
      
    ]
  };

  
    var faTrashArrowTurnLeft = faTrashUndo;
  

  
  

  var faRubleSign = {
    prefix: 'fat',
    iconName: 'ruble-sign',
    icon: [
      384,
      512,
      [8381,"rouble","rub","ruble"],
      'f158',
      
      'M96.7 32C78.6 32 64 46.6 64 64.7V288H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H64v64H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H64v80c0 4.4 3.6 8 8 8s8-3.6 8-8V384H312c4.4 0 8-3.6 8-8s-3.6-8-8-8H80V304H232c75.1 0 136-60.9 136-136s-60.9-136-136-136H96.7zM232 288H80V64.7C80 55.5 87.5 48 96.7 48H232c66.3 0 120 53.7 120 120s-53.7 120-120 120z'
      
    ]
  };

  
    var faRouble = faRubleSign;
  
    var faRub = faRubleSign;
  
    var faRuble = faRubleSign;
  

  
  

  var faNotes = {
    prefix: 'fat',
    iconName: 'notes',
    icon: [
      512,
      512,
      [],
      'e202',
      
      'M112 96c0-26.5 21.5-48 48-48H416c26.5 0 48 21.5 48 48V277.5c0 3.6-.4 7.1-1.2 10.5H392c-22.1 0-40 17.9-40 40v70.8c-3.4 .8-6.9 1.2-10.5 1.2H160c-26.5 0-48-21.5-48-48V96zM456 304c-1.8 2.7-3.8 5.1-6.1 7.4l-74.5 74.5c-2.3 2.3-4.8 4.3-7.4 6.1V328c0-13.3 10.7-24 24-24h64zM96 96V352c0 35.3 28.7 64 64 64H341.5c17 0 33.3-6.7 45.3-18.7l74.5-74.5c12-12 18.7-28.3 18.7-45.3V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64H368c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V192c0-26.5 21.5-48 48-48V128z'
      
    ]
  };

  

  
  

  var faGearCode = {
    prefix: 'fat',
    iconName: 'gear-code',
    icon: [
      512,
      512,
      [],
      'e5e8',
      
      'M211.6 28.5c1.6-7.3 8.1-12.5 15.6-12.5h57.6c7.5 0 14 5.2 15.6 12.5l12.9 57.1c.6 2.6 2.5 4.8 5 5.7c17.9 6.8 34.5 16.4 49.1 28.4c2.1 1.7 4.9 2.2 7.4 1.4l56-17.4c7.1-2.2 14.9 .8 18.6 7.3L478.3 161c3.7 6.5 2.5 14.7-3 19.8l-43.1 39.8c-2 1.8-2.9 4.5-2.5 7.2c1.5 9.2 2.3 18.7 2.3 28.4s-.8 19.1-2.3 28.4c-.4 2.6 .5 5.3 2.5 7.2l43.1 39.8c5.5 5.1 6.7 13.3 3 19.8L449.4 401c-3.7 6.5-11.5 9.5-18.6 7.3l-56-17.4c-2.6-.8-5.4-.3-7.4 1.4c-14.6 11.9-31.2 21.6-49.1 28.4c-2.5 1-4.4 3.1-5 5.7l-12.9 57.1c-1.6 7.3-8.1 12.5-15.6 12.5H227.2c-7.5 0-14-5.2-15.6-12.5l-12.9-57.1c-.6-2.6-2.5-4.8-5-5.7c-17.9-6.8-34.5-16.4-49.1-28.4c-2.1-1.7-4.9-2.2-7.4-1.4l-56 17.4c-7.1 2.2-14.9-.8-18.6-7.3L33.7 351c-3.7-6.5-2.5-14.7 3-19.8l43.1-39.8c2-1.8 2.9-4.5 2.5-7.2C80.8 275.1 80 265.7 80 256s.8-19.1 2.3-28.4c.4-2.6-.5-5.3-2.5-7.2L36.7 180.7c-5.5-5.1-6.7-13.3-3-19.8L62.6 111c3.7-6.5 11.5-9.5 18.6-7.3l56 17.4c2.6 .8 5.4 .3 7.4-1.4c14.6-12 31.2-21.6 49.1-28.4c2.5-1 4.4-3.1 5-5.7l12.9-57.1zM227.2 0c-15 0-27.9 10.4-31.2 25L184 78c-16.7 6.8-32.2 15.8-46.1 26.7L85.9 88.5C71.6 84 56.2 90.1 48.7 103L19.9 153c-7.5 13-5 29.4 6 39.5l39.9 36.9C64.6 238.1 64 247 64 256s.6 17.9 1.8 26.6L25.9 319.5c-11 10.1-13.5 26.6-6 39.5L48.7 409c7.5 13 22.9 19 37.2 14.6l51.9-16.2c14 10.9 29.5 19.9 46.1 26.7l12 53c3.3 14.6 16.3 25 31.2 25h57.6c15 0 27.9-10.4 31.2-25l12-53c16.7-6.7 32.2-15.8 46.1-26.7l51.9 16.2c14.3 4.4 29.7-1.6 37.2-14.6L492.1 359c7.5-13 5-29.4-6-39.5l-39.9-36.9c1.2-8.7 1.8-17.6 1.8-26.6s-.6-17.9-1.8-26.6l39.9-36.9c11-10.1 13.5-26.6 6-39.5L463.3 103c-7.5-13-22.9-19-37.2-14.6l-51.9 16.2C360.2 93.7 344.7 84.7 328 78L316 25c-3.3-14.6-16.3-25-31.2-25H227.2zm52.7 161.3c.7-4.4-2.2-8.5-6.6-9.2s-8.5 2.2-9.2 6.6l-32 192c-.7 4.4 2.2 8.5 6.6 9.2s8.5-2.2 9.2-6.6l32-192zm-98.2 60.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-40 40c-3.1 3.1-3.1 8.2 0 11.3l40 40c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L147.3 256l34.3-34.3zm160-11.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L364.7 256l-34.3 34.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l40-40c3.1-3.1 3.1-8.2 0-11.3l-40-40z'
      
    ]
  };

  

  
  

  var faYenSign = {
    prefix: 'fat',
    iconName: 'yen-sign',
    icon: [
      320,
      512,
      [165,"cny","jpy","rmb","yen"],
      'f157',
      
      'M14.5 35.3c-2.6-3.6-7.6-4.3-11.2-1.7s-4.3 7.6-1.7 11.2L144.2 240H40c-4.4 0-8 3.6-8 8s3.6 8 8 8H152v80H40c-4.4 0-8 3.6-8 8s3.6 8 8 8H152V472c0 4.4 3.6 8 8 8s8-3.6 8-8V352H280c4.4 0 8-3.6 8-8s-3.6-8-8-8H168V256H280c4.4 0 8-3.6 8-8s-3.6-8-8-8H175.8L318.5 44.7c2.6-3.6 1.8-8.6-1.7-11.2s-8.6-1.8-11.2 1.7L160 234.4 14.5 35.3z'
      
    ]
  };

  
    var faCny = faYenSign;
  
    var faJpy = faYenSign;
  
    var faRmb = faYenSign;
  
    var faYen = faYenSign;
  

  
  

  var faPlaneCircleXmark = {
    prefix: 'fat',
    iconName: 'plane-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e557',
      
      'M256 0c-19.8 0-35.8 16.2-46.3 33.3C199 50.8 192 72.6 192 89.2l0 86.8 0 1.3L20.7 271.9C7.9 278.9 0 292.3 0 306.9V355c0 15.9 15.1 27.4 30.4 23.1L192 333.5V352l0 44-54.4 40.8c-6 4.5-9.6 11.6-9.6 19.2v34.1c0 12.1 9.8 21.9 21.9 21.9c2.2 0 4.4-.3 6.4-1L256 480.4 355.6 511c2.1 .6 4.3 1 6.4 1c2 0 4-.3 5.9-.8l0-21.1c0 3.3-2.6 5.9-5.9 5.9c-.6 0-1.2-.1-1.7-.3l-2.4 7.6 2.4-7.6-102-31.4c-1.5-.5-3.2-.5-4.7 0l-102 31.4c-.6 .2-1.1 .3-1.7 .3c-3.3 0-5.9-2.6-5.9-5.9V456c0-2.5 1.2-4.9 3.2-6.4l57.6-43.2c2-1.5 3.2-3.9 3.2-6.4l0-48V323l0-141 0-6.1 0-86.8c0-13 5.7-31.9 15.3-47.5C233.2 25.6 245.1 16 256 16c11.3 0 23.2 9.6 33 25.6c9.5 15.6 15 34.5 15 47.5l0 86.8 0 6.1 0 0V323v29l0 48c0 2.5 1.2 4.9 3.2 6.4l32.3 24.2c-3.2-8.3-5.7-16.9-7.6-25.7L320 396l0-44 0-18.5 10.8 3c1-5.3 2.1-10.5 3.6-15.6l-14.4-4V195.6l69.8 38.5c4.4-3.8 9-7.3 13.8-10.7L320 177.3l0-1.3 0-86.8c0-16.6-6.7-38.3-17.3-55.8C292.3 16.2 276.2 0 256 0zM28.4 285.9L192 195.6V316.9L26.1 362.7C21 364.1 16 360.3 16 355V306.9c0-8.7 4.8-16.8 12.4-21zM368 368a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-82.3-50.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L496 356.7l-50.3-50.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L484.7 368l-50.3 50.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L496 379.3l50.3 50.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L507.3 368l50.3-50.3z'
      
    ]
  };

  

  
  

  var faToilet = {
    prefix: 'fat',
    iconName: 'toilet',
    icon: [
      448,
      512,
      [128701],
      'f7d8',
      
      'M8 0H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8S3.6 0 8 0zM48 202.6c9-3.5 19-6.6 29.5-9.4C120.2 182.1 174.9 176 224 176s103.8 6.1 146.5 17.3c10.6 2.8 20.5 5.9 29.5 9.4V48h16V209.7c2.9 1.5 5.6 3 8.1 4.6c13.3 8.3 23.9 19.4 23.9 33.7c0 67-32.9 117.2-77.2 150.4c-1.7 1.2-3.3 2.5-5 3.7l17 64.3c.8 3 1.2 6.2 1.2 9.3c0 20.1-16.3 36.3-36.3 36.3H100.3C80.3 512 64 495.7 64 475.7c0-3.1 .4-6.3 1.2-9.3l17-64.3c-1.7-1.2-3.4-2.4-5-3.7C32.9 365.2 0 315 0 248c0-14.3 10.6-25.4 23.9-33.7c2.5-1.6 5.3-3.1 8.1-4.6V48H48V202.6zM18.5 278.1c8 46.2 34.3 82 68.3 107.5C128.1 416.5 180.4 432 224 432s95.9-15.5 137.2-46.4c34-25.5 60.3-61.3 68.3-107.5c-1.7 1.2-3.5 2.4-5.3 3.6c-13.6 8.5-32.4 15.5-53.7 21.1C327.8 313.9 273.1 320 224 320s-103.8-6.1-146.5-17.3c-21.3-5.6-40-12.6-53.7-21.1c-1.8-1.1-3.6-2.3-5.3-3.6zM432 248c0-5.7-4.3-12.6-16.3-20.1c-11.7-7.3-28.7-13.8-49.3-19.2C325.4 197.9 272.1 192 224 192s-101.4 5.9-142.4 16.7C61 214.1 44 220.7 32.3 227.9C20.3 235.4 16 242.3 16 248s4.3 12.6 16.3 20.1C44 275.3 61 281.9 81.6 287.3C122.6 298.1 175.9 304 224 304s101.4-5.9 142.4-16.7c20.6-5.4 37.6-11.9 49.3-19.2c12-7.5 16.3-14.4 16.3-20.1zM104 80h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H104c-4.4 0-8-3.6-8-8s3.6-8 8-8zM367.3 470.5l-15.7-59.2C311.3 435.8 264.4 448 224 448s-87.3-12.2-127.6-36.7L80.7 470.5c-.4 1.7-.7 3.4-.7 5.2c0 11.2 9.1 20.3 20.3 20.3H347.7c11.2 0 20.3-9.1 20.3-20.3c0-1.8-.2-3.5-.7-5.2z'
      
    ]
  };

  

  
  

  var faMars = {
    prefix: 'fat',
    iconName: 'mars',
    icon: [
      448,
      512,
      [9794],
      'f222',
      
      'M288 40c0 4.4 3.6 8 8 8H420.7l-126 126c-31.3-28.6-72.9-46-118.7-46C78.8 128 0 206.8 0 304s78.8 176 176 176s176-78.8 176-176c0-45.7-17.4-87.4-46-118.7l126-126V184c0 4.4 3.6 8 8 8s8-3.6 8-8V40c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8zM16 304a160 160 0 1 1 320 0A160 160 0 1 1 16 304z'
      
    ]
  };

  

  
  

  var faVault = {
    prefix: 'fat',
    iconName: 'vault',
    icon: [
      576,
      512,
      [],
      'e2c5',
      
      'M64 16C37.5 16 16 37.5 16 64V416c0 26.5 21.5 48 48 48H512c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H64zM0 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64v24c0 4.4-3.6 8-8 8s-8-3.6-8-8V480H80v24c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-24c-35.3 0-64-28.7-64-64V64zM368 240A144 144 0 1 0 80 240a144 144 0 1 0 288 0zM64 240a160 160 0 1 1 320 0A160 160 0 1 1 64 240zm160 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-112a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm272 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm16 0c0 23.8-17.3 43.5-40 47.3V344c0 4.4-3.6 8-8 8s-8-3.6-8-8V223.3c-22.7-3.8-40-23.6-40-47.3c0-26.5 21.5-48 48-48s48 21.5 48 48z'
      
    ]
  };

  

  
  

  var faArrowTurnLeftUp = {
    prefix: 'fat',
    iconName: 'arrow-turn-left-up',
    icon: [
      384,
      512,
      [],
      'e634',
      
      'M349.7 154.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L200 27.3 200 440c0 30.9 25.1 56 56 56l120 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-120 0c-39.8 0-72-32.2-72-72l0-412.7L45.7 165.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l152-152c3.1-3.1 8.2-3.1 11.3 0l152 152z'
      
    ]
  };

  

  
  

  var faPersonSimple = {
    prefix: 'fat',
    iconName: 'person-simple',
    icon: [
      256,
      512,
      [],
      'e220',
      
      'M176 64A48 48 0 1 0 80 64a48 48 0 1 0 96 0zM64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM41.8 234.7L37.7 284c-2.3 28 19.8 52 47.8 52H112h32 26.4c28.1 0 50.2-24 47.8-52l-4.1-49.3c-2.8-33.2-30.5-58.7-63.8-58.7H105.6c-33.3 0-61 25.5-63.8 58.7zM136 352H120V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V344.8c-22.1-11.5-36.4-35.4-34.2-62.1l4.1-49.3C29.3 191.9 64 160 105.6 160h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.2 26.7-12.2 50.6-34.2 62.1V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352zm48-1.4c-4.4 .9-8.9 1.4-13.6 1.4H152V480c0 8.8 7.2 16 16 16s16-7.2 16-16V350.6zM85.6 352c-4.7 0-9.2-.5-13.6-1.4V480c0 8.8 7.2 16 16 16s16-7.2 16-16V352H85.6z'
      
    ]
  };

  

  
  

  var faOilWell = {
    prefix: 'fat',
    iconName: 'oil-well',
    icon: [
      576,
      512,
      [],
      'e532',
      
      'M512.9 65.4c-9.1-34.1-44.2-54.4-78.4-45.3L419 24.3c-8.5 2.3-13.6 11.1-11.3 19.6L474 291.2c2.3 8.5 11.1 13.6 19.6 11.3l15.5-4.1c34.1-9.1 54.4-44.2 45.3-78.4L512.9 65.4zM430.4 4.7c42.7-11.4 86.5 13.9 98 56.6l41.4 154.5c11.4 42.7-13.9 86.5-56.6 98l-15.5 4.1c-17.1 4.6-34.6-5.6-39.2-22.6L428.6 183.7 80 274V496h50.3L202 285l18.5-4.8L196.1 352H347.9l-32.7-96.3 15.5-4L413.7 496H568c4.4 0 8 3.6 8 8s-3.6 8-8 8H72 8c-4.4 0-8-3.6-8-8s3.6-8 8-8H64V168c0-4.4 3.6-8 8-8s8 3.6 8 8v89.5l144.1-37.3 40.4-118.7c1.1-3.2 4.1-5.4 7.6-5.4s6.5 2.2 7.6 5.4l32.6 95.9 112.3-29.1L392.3 48c-4.6-17.1 5.6-34.6 22.6-39.2l15.5-4.1zM296.6 201.3L272 128.9l-29.4 86.5 54.1-14zM396.8 496L353.3 368H190.7L147.2 496H396.8z'
      
    ]
  };

  

  
  

  var faGlassWater = {
    prefix: 'fat',
    iconName: 'glass-water',
    icon: [
      384,
      512,
      [],
      'e4f4',
      
      'M16.1 33.3C15.4 24 22.7 16 32.1 16H352c9.4 0 16.7 8 15.9 17.3l-9.3 114.2-37.8 17.2c-24.6 11.2-53.3 8.3-75.2-7.6c-31.9-23.2-75.2-23.2-107.1 0c-21.9 15.9-50.6 18.8-75.2 7.6L25.4 147.5 16.1 33.3zM26.9 165.8l29.7 13.5c29.9 13.6 64.7 10 91.2-9.3c26.3-19.1 62-19.1 88.3 0c26.5 19.3 61.4 22.8 91.2 9.3l29.7-13.5L333.2 459.2c-1.7 20.8-19 36.8-39.9 36.8H90.7c-20.8 0-38.2-16-39.9-36.8L26.9 165.8zM32.1 0C13.4 0-1.3 16 .2 34.6l34.7 426C37.3 489.6 61.6 512 90.7 512H293.3c29.2 0 53.4-22.4 55.8-51.4l34.7-426C385.4 16 370.7 0 352 0H32.1z'
      
    ]
  };

  

  
  

  var faTrashCanCheck = {
    prefix: 'fat',
    iconName: 'trash-can-check',
    icon: [
      448,
      512,
      [],
      'e2a9',
      
      'M157.4 27.3L134.4 64H313.6l-23-36.7c-4.4-7-12.1-11.3-20.4-11.3H177.7c-8.3 0-16 4.3-20.4 11.3zM115.6 64l28.2-45.2C151.1 7.1 163.9 0 177.7 0h92.5c13.8 0 26.6 7.1 33.9 18.8L332.4 64H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H115.6zM40 112c4.4 0 8 3.6 8 8V440c0 30.9 25.1 56 56 56H344c30.9 0 56-25.1 56-56V120c0-4.4 3.6-8 8-8s8 3.6 8 8V440c0 39.8-32.2 72-72 72H104c-39.8 0-72-32.2-72-72V120c0-4.4 3.6-8 8-8zM325.7 229.7l-128 128c-3.1 3.1-8.2 3.1-11.3 0l-64-64c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L192 340.7 314.3 218.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3z'
      
    ]
  };

  

  
  

  var faBolt = {
    prefix: 'fat',
    iconName: 'bolt',
    icon: [
      448,
      512,
      [9889,"zap"],
      'f0e7',
      
      'M309.9 6.3C314.4 2.2 320.3 0 326.4 0c17.8 0 29.9 18.3 22.9 34.7L268.1 224H391.4c13.6 0 24.6 11 24.6 24.6c0 7-3 13.7-8.3 18.4L138.1 505.7c-4.6 4-10.4 6.3-16.5 6.3c-17.9 0-29.9-18.3-22.9-34.7L179.9 288H55.3C42.5 288 32 277.5 32 264.7c0-6.7 2.8-13 7.8-17.4L309.9 6.3zM326.4 16c-2.2 0-4.3 .8-5.9 2.2L50.5 259.2c-1.6 1.4-2.5 3.4-2.5 5.5c0 4.1 3.3 7.3 7.3 7.3H192c2.7 0 5.2 1.4 6.7 3.6s1.7 5.1 .7 7.6L113.4 483.6c-2.5 5.9 1.8 12.4 8.2 12.4c2.2 0 4.3-.8 5.9-2.2L397.1 255c1.8-1.6 2.9-4 2.9-6.4c0-4.7-3.8-8.6-8.6-8.6H256c-2.7 0-5.2-1.4-6.7-3.6s-1.7-5.1-.7-7.6L334.6 28.4c2.5-5.8-1.8-12.4-8.1-12.4z'
      
    ]
  };

  
    var faZap = faBolt;
  

  
  

  var faMessageSlash = {
    prefix: 'fat',
    iconName: 'message-slash',
    icon: [
      640,
      512,
      ["comment-alt-slash"],
      'f4a9',
      
      'M386.2 400H373.3c-3.5 0-6.8 1.1-9.6 3.2L240 496V416c0-8.8-7.2-16-16-16H128c-26.5 0-48-21.5-48-48V158.3L64 145.6V352c0 35.3 28.7 64 64 64h80 16v16 64c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L373.3 416h33.1l-20.3-16zM128 0c-4.8 0-9.6 .5-14.1 1.6L132.2 16H512c26.5 0 48 21.5 48 48V352c0 .6 0 1.1 0 1.7l14.6 11.6c.9-4.3 1.4-8.7 1.4-13.3V64c0-35.3-28.7-64-64-64H128zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  
    var faCommentAltSlash = faMessageSlash;
  

  
  

  var faShieldCat = {
    prefix: 'fat',
    iconName: 'shield-cat',
    icon: [
      512,
      512,
      [],
      'e572',
      
      'M237.3 22.6c12-5.1 25.5-5.1 37.5 0l176.7 75c16.6 7.1 28.6 23.2 28.5 42.4c-.5 96.6-40.3 270.2-204.5 348.8c-12.3 5.9-26.7 5.9-39 0C72.3 410.1 32.5 236.5 32 139.9c-.1-19.1 11.9-35.3 28.5-42.4l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM165.7 138.3c-2.3-2.3-5.7-3-8.7-1.7s-4.9 4.2-4.9 7.4V272c0 57.4 46.6 104 104 104s104-46.6 104-104V144c0-3.2-1.9-6.2-4.9-7.4s-6.4-.6-8.7 1.7L284.7 200H227.3l-61.7-61.7zM168 272V163.3l50.3 50.3c1.5 1.5 3.5 2.3 5.7 2.3h64c2.1 0 4.2-.8 5.7-2.3L344 163.3V272c0 48.6-39.4 88-88 88s-88-39.4-88-88zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faCaravan = {
    prefix: 'fat',
    iconName: 'caravan',
    icon: [
      640,
      512,
      [],
      'f8ff',
      
      'M416 48c79.5 0 144 64.5 144 144V400H288h-1.3l0 0c-7.6-45.4-47.1-80-94.7-80s-87.1 34.6-94.7 80H80c-35.3 0-64-28.7-64-64V112c0-35.3 28.7-64 64-64H416zM80 416H96c0 53 43 96 96 96s96-43 96-96H560h16l56 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-56 0V192c0-88.4-71.6-160-160-160H80C35.8 32 0 67.8 0 112V336c0 44.2 35.8 80 80 80zM96 144H224c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16zM64 160v64c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zm352-16c8.8 0 16 7.2 16 16v64H392c-4.4 0-8 3.6-8 8s3.6 8 8 8h40v80c0 8.8-7.2 16-16 16H352c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16h64zm32 88V160c0-17.7-14.3-32-32-32H352c-17.7 0-32 14.3-32 32V320c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V232zM192 336a80 80 0 1 1 0 160 80 80 0 1 1 0-160z'
      
    ]
  };

  

  
  

  var faArrowUpArrowDown = {
    prefix: 'fat',
    iconName: 'arrow-up-arrow-down',
    icon: [
      576,
      512,
      ["sort-up-down"],
      'e099',
      
      'M165.7 34.3c-3.1-3.1-8.2-3.1-11.3 0l-112 112c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L152 59.3V472c0 4.4 3.6 8 8 8s8-3.6 8-8V59.3l98.3 98.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-112-112zm368 331.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L424 452.7V40c0-4.4-3.6-8-8-8s-8 3.6-8 8V452.7l-98.3-98.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l112 112c3.1 3.1 8.2 3.1 11.3 0l112-112z'
      
    ]
  };

  
    var faSortUpDown = faArrowUpArrowDown;
  

  
  

  var faHandWave = {
    prefix: 'fat',
    iconName: 'hand-wave',
    icon: [
      482,
      512,
      [],
      'e1a7',
      
      'M340.7 90.1c4-1 6.5-5.1 5.5-9.1l-4.9-19.6c-6.9-27.5-30.1-47.8-58.3-50.9L256.9 7.6c-4.1-.5-7.9 2.5-8.3 6.7s2.5 7.9 6.7 8.3l26.1 2.9c21.9 2.4 40 18.2 45.3 39.6l4.9 19.6c1 4 5.1 6.5 9.1 5.5zM6.7 353.9c-4.1 .5-7.1 4.3-6.5 8.4l1.7 13.7c3.8 30.8 28.1 55 58.8 58.8l13.7 1.7c4.1 .5 7.9-2.4 8.4-6.5s-2.4-7.9-6.5-8.4L62.5 420c-23.9-3-42.8-21.8-45.8-45.8l-1.7-13.7c-.5-4.1-4.3-7.1-8.4-6.5zM139.5 78.9C121.8 63.6 95 64.4 78.2 81.2S60.6 124.8 75.8 142.6c-10.8 .6-21.4 4.9-29.6 13.2c-17.6 17.6-17.6 46.2 0 63.9L65 238.5c-10.7 .6-21.3 5-29.5 13.2c-17.6 17.6-17.7 46.2-.1 63.9L151.2 432.4c29.4 29.7 68.8 47.2 110.3 49.2c.5 .1 1.1 .2 1.7 .2l14.1 .1c96.1 .7 174.5-77 174.5-173.2l0-173.3c0-25-20.2-45.2-45.2-45.2s-45.2 20.2-45.2 45.2l0 58.6L216.6 49.3c-17.6-17.6-46.2-17.6-63.9 0c-8.2 8.2-12.6 18.8-13.2 29.6zm125.2 388c-.4-.1-.8-.1-1.2-.1c-38.3-1.6-74.6-17.5-101.7-44.9L46.1 304.9c-11.7-11.8-11.7-30.9 .1-42.6c11.7-11.7 30.8-11.8 42.6-.1l0 0 73.7 73.7c2.9 2.9 7.7 2.9 10.6 0s2.9-7.7 0-10.6L86.6 238.7l-.1-.1L56.9 209c-11.8-11.8-11.8-30.8 0-42.6c11.7-11.7 30.8-11.8 42.6 0l0 0 64.8 64.8 51.4 51.4c2.9 2.9 7.7 2.9 10.6 0s2.9-7.7 0-10.6L175 220.6l-.1-.1L88.8 134.5C77 122.7 77 103.6 88.8 91.9s30.8-11.8 42.6 0l8.4 8.4 .1 .1L268.9 229.4l.1 .1 1.8 1.8c1.4 1.4 3.3 2.2 5.3 2.2h0c3 0 5.8-1.8 7-4.6s.5-6.1-1.6-8.2l-118-118c-11.8-11.8-11.8-30.8 0-42.6s30.8-11.8 42.6 0L363.7 217.7c2.2 2.2 5.4 2.8 8.2 1.6s4.7-3.9 4.7-7l0-76.8c0-16.6 13.5-30.1 30.1-30.1s30.1 13.5 30.1 30.1l0 173.3c0 87.8-71.5 158.8-159.3 158.1l-12.7-.1z'
      
    ]
  };

  

  
  

  var faFolderGear = {
    prefix: 'fat',
    iconName: 'folder-gear',
    icon: [
      512,
      512,
      ["folder-cog"],
      'e187',
      
      'M496 416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H197.5c12.7 0 24.9 5.1 33.9 14.1l35.9 35.9c9 9 21.2 14.1 33.9 14.1H448c26.5 0 48 21.5 48 48V416zM64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H301.3c-8.5 0-16.6-3.4-22.6-9.4L242.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64zM240 177.1c5.2-.7 10.6-1.1 16-1.1s10.8 .4 16 1.1v4.2c0 16.7 10.8 30.2 23.8 37.8c13 7.5 30.1 10.1 44.6 1.7l3.7-2.1c2.9 3.7 5.6 7.5 8 11.5l2.2 3.7c2.2 4 4.2 8.2 5.9 12.4l-3.6 2.1C341.8 256.9 336 273.1 336 288s5.8 31.1 20.4 39.5l3.6 2.1c-1.7 4.3-3.7 8.4-5.9 12.4l-2.2 3.9c-2.4 4-5.1 7.8-7.9 11.4l-3.7-2.1c-14.5-8.3-31.6-5.8-44.6 1.7c-13 7.5-23.8 21.1-23.8 37.8v4.2c-5.2 .7-10.6 1.1-16 1.1s-10.8-.4-16-1.1v-4.2c0-16.7-10.8-30.2-23.8-37.8c-13-7.5-30.1-10.1-44.6-1.7l-3.7 2.1c-2.9-3.6-5.5-7.5-7.9-11.5l-2.2-3.8c-2.2-4-4.2-8.1-5.9-12.4l3.6-2.1c14.6-8.4 20.4-24.6 20.4-39.5s-5.8-31.1-20.4-39.5l-3.6-2.1c1.7-4.3 3.7-8.5 5.9-12.5l2.1-3.7c2.4-4 5.1-7.9 8-11.5l3.7 2.1c14.5 8.3 31.6 5.8 44.6-1.7c13-7.5 23.8-21.1 23.8-37.8v-4.2zm-3.9-15.6c-7.1 1.1-12.1 7.5-12.1 14.9v4.9c0 9.4-6.2 18.4-15.8 23.9s-20.4 6.4-28.6 1.7l-4.3-2.5c-6.4-3.7-14.5-2.5-19 3c-3.7 4.6-7.1 9.4-10.2 14.5l0 0-.1 .1L144 226l0 0-.1 .1c-2.8 5.1-5.3 10.4-7.4 15.8c-2.6 6.7 .4 14.2 6.8 18l4.2 2.4c8 4.6 12.4 14.3 12.4 25.6s-4.4 21-12.4 25.6l-4.2 2.4c-6.4 3.7-9.4 11.3-6.8 17.9c2.1 5.4 4.6 10.7 7.3 15.7l0 0 .1 .1 2.3 4 0 0 .1 .1c3 5 6.4 9.9 10.1 14.4c4.5 5.6 12.5 6.8 19 3l4.3-2.5c8.2-4.7 19-3.8 28.6 1.7s15.8 14.5 15.8 23.9v4.9c0 7.4 5.1 13.8 12.1 14.9c6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.1-1.1 12.1-7.5 12.1-14.9v-4.9c0-9.4 6.2-18.4 15.8-23.9s20.4-6.4 28.6-1.7l4.3 2.5c6.4 3.7 14.5 2.5 19-3c3.7-4.5 7.1-9.4 10.1-14.4l0 0 .1-.1 2.3-4 0 0 .1-.1c2.8-5 5.2-10.3 7.3-15.7c2.6-6.7-.4-14.2-6.8-17.9l-4.2-2.4c-8-4.6-12.4-14.3-12.4-25.6s4.4-21 12.4-25.6l4.2-2.4c6.4-3.7 9.4-11.3 6.8-18c-2.1-5.5-4.6-10.7-7.4-15.8l0 0-.1-.1-2.2-3.9 0 0-.1-.1c-3.1-5.1-6.4-9.9-10.1-14.5c-4.5-5.6-12.5-6.8-19-3l-4.3 2.5c-8.1 4.7-19 3.8-28.6-1.7s-15.8-14.5-15.8-23.9v-4.9c0-7.4-5.1-13.8-12.1-14.9c-6.5-1-13.1-1.5-19.9-1.5s-13.4 .5-19.9 1.5zM256 264a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 64a40 40 0 1 0 0-80 40 40 0 1 0 0 80z'
      
    ]
  };

  
    var faFolderCog = faFolderGear;
  

  
  

  var faFolderMedical = {
    prefix: 'fat',
    iconName: 'folder-medical',
    icon: [
      512,
      512,
      [],
      'e18c',
      
      'M448 464H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H197.5c12.7 0 24.9 5.1 33.9 14.1l35.9 35.9c9 9 21.2 14.1 33.9 14.1H448c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48zM64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H301.3c-8.5 0-16.6-3.4-22.6-9.4L242.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64zM232 200c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H288c-4.4 0-8 3.6-8 8v56c0 4.4-3.6 8-8 8H240c-4.4 0-8-3.6-8-8V320c0-4.4-3.6-8-8-8H168c-4.4 0-8-3.6-8-8V272c0-4.4 3.6-8 8-8h56c4.4 0 8-3.6 8-8V200zm8-24c-13.3 0-24 10.7-24 24v48H168c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h48v48c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V328h48c13.3 0 24-10.7 24-24V272c0-13.3-10.7-24-24-24H296V200c0-13.3-10.7-24-24-24H240z'
      
    ]
  };

  

  
  

  var faCameraWebSlash = {
    prefix: 'fat',
    iconName: 'camera-web-slash',
    icon: [
      640,
      512,
      ["webcam-slash"],
      'f833',
      
      'M432 496l-280 0c-3 0-5.8-1.7-7.2-4.5s-1-6 .8-8.4l54-70.2C234.4 435.1 275.7 448 320 448c35.3 0 68.6-8.1 98.3-22.7l-14.1-11.1C378.5 425.7 350 432 320 432c-114.9 0-208-93.1-208-208c0-12.9 1.2-25.5 3.4-37.8l-14.1-11.1C97.8 190.9 96 207.2 96 224c0 73.7 35.6 139 90.5 179.9L133 473.4c-5.6 7.2-6.5 17-2.5 25.2s12.4 13.4 21.5 13.4H488c9.1 0 17.5-5.2 21.5-13.4c.1-.3 .3-.6 .4-.9l-2.2-1.7H432zM320 0C265.7 0 215.9 19.3 177.1 51.5L190 61.6C225.6 33.1 270.8 16 320 16c114.9 0 208 93.1 208 208c0 31.8-7.1 61.9-19.9 88.8L521 323c14.7-29.8 23-63.4 23-99C544 100.3 443.7 0 320 0zm0 368c7.9 0 15.7-.6 23.3-1.9l-18-14.2c-1.7 .1-3.5 .1-5.3 .1c-62.3 0-114.2-44.5-125.7-103.5l-18-14.2C181.7 309 243.9 368 320 368zM242.2 102.8l13.4 10.6C274.5 102.3 296.5 96 320 96c70.7 0 128 57.3 128 128c0 12.9-1.9 25.3-5.4 37l13.4 10.6c5.2-14.9 8.1-30.9 8.1-47.6c0-79.5-64.5-144-144-144c-28.7 0-55.4 8.4-77.8 22.8zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  
    var faWebcamSlash = faCameraWebSlash;
  

  
  

  var faSaxophoneFire = {
    prefix: 'fat',
    iconName: 'saxophone-fire',
    icon: [
      640,
      512,
      ["sax-hot"],
      'f8db',
      
      'M153.6 72.2l11.3-11.3 9.1-9.1c3.8-3.8 8.7-3.2 11.3-.8C230 95.4 240 133.2 240 153.6c0 7.7-.8 15.2-2.2 22.4H254c1.3-7.3 2-14.8 2-22.4c0-25.5-12.4-67.2-59.5-113.9c-9.4-9.3-24.5-8.6-33.8 .8l-9.1 9.1L142.3 38.2 116.8 12.7C112 7.9 105.6 5.3 99.2 5.4c-4.7 0-9.4 1.6-13.4 4.7C50 37.9 0 92.3 0 153.6c0 7.6 .7 15.1 2 22.4H18.2c-1.5-7.2-2.2-14.7-2.2-22.4c0-26.3 10.8-52.1 26.7-75.3c15.8-23.1 36-42.5 52.9-55.6c1.1-.9 2.4-1.3 3.8-1.3c1.9 0 4.2 .8 6.1 2.7l36.8 36.8 11.3 11.3zm15.5 73.5c-9.7-13.2-21.1-24-28.4-30.3c-7.3-6.3-18-6.3-25.3 0c-7.3 6.4-18.8 17.2-28.4 30.3c-6.5 8.8-12.5 19.2-15.7 30.3H88c2.7-7 6.8-14.1 11.8-20.8c8.7-11.8 19.2-21.8 26-27.7c1.3-1.1 3-1.1 4.3 0c6.9 6 17.3 15.9 26 27.7c5 6.8 9.1 13.8 11.8 20.8h16.9c-3.2-11.1-9.3-21.5-15.7-30.3zM538.5 64c-19.1 0-37.4 7.6-50.9 21.1L452 120.7 429.7 98.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L440.7 132 404 168.7l-22.3-22.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L392.7 180 356 216.6l-22.3-22.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L344.6 228l-134 133.9c-3.8 3.8-9 5.9-14.3 5.9h-2c-10.1 0-18.3-8.2-18.3-18.3c0-2.5 .5-5 1.5-7.3L229.2 224H248c4.4 0 8-3.6 8-8s-3.6-8-8-8H224 40 8c-4.4 0-8 3.6-8 8s3.6 8 8 8H29.4L6.2 305C2.1 319.5 0 334.5 0 349.6v2.1C0 440.2 71.8 512 160.3 512c47.8 0 93.1-21.3 123.6-58.2L532.6 152.7c4.6-5.5 11.3-8.7 18.5-8.7h64c13.8 0 25-11.2 25-25c0-6.6-2.6-13-7.3-17.7L616.4 85.1C602.9 71.6 584.6 64 565.5 64h-27zM46 224H211.8L162.9 335.7c-1.9 4.3-2.9 9-2.9 13.8c0 19 15.4 34.3 34.3 34.3h2c9.6 0 18.8-3.8 25.7-10.6l277-276.8C509.4 85.9 523.7 80 538.5 80h27c14.9 0 29.1 5.9 39.6 16.4l16.3 16.3c1.7 1.7 2.6 4 2.6 6.3c0 5-4 9-9 9h-64c-11.9 0-23.2 5.3-30.8 14.5L271.5 443.6C244.1 476.8 203.3 496 160.3 496C80.6 496 16 431.4 16 351.7v-2.1c0-13.6 1.9-27.1 5.6-40.2L46 224zM80 384a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  
    var faSaxHot = faSaxophoneFire;
  

  
  

  var faFileArrowDown = {
    prefix: 'fat',
    iconName: 'file-arrow-down',
    icon: [
      384,
      512,
      ["file-download"],
      'f56d',
      
      'M16 448V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM200 232c0-4.4-3.6-8-8-8s-8 3.6-8 8V420.7l-74.3-74.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l88 88c3.1 3.1 8.2 3.1 11.3 0l88-88c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L200 420.7V232z'
      
    ]
  };

  
    var faFileDownload = faFileArrowDown;
  

  
  

  var faCompactDisc = {
    prefix: 'fat',
    iconName: 'compact-disc',
    icon: [
      512,
      512,
      [128191,128192,128440],
      'f51f',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm336 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-176 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm80 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM88 256c0 4.4-3.6 8-8 8s-8-3.6-8-8C72 154.4 154.4 72 256 72c4.4 0 8 3.6 8 8s-3.6 8-8 8C163.2 88 88 163.2 88 256z'
      
    ]
  };

  

  
  

  var faToiletPortable = {
    prefix: 'fat',
    iconName: 'toilet-portable',
    icon: [
      320,
      512,
      [],
      'e583',
      
      'M32 56c0-22.1 17.9-40 40-40H248c22.1 0 40 17.9 40 40V96H32V56zm272 56V96 56c0-30.9-25.1-56-56-56H72C41.1 0 16 25.1 16 56V96v16V448v16 40c0 4.4 3.6 8 8 8s8-3.6 8-8V464H288v40c0 4.4 3.6 8 8 8s8-3.6 8-8V464 448 112zM32 448V112H288V448H32zM248 216c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24h16c4.4 0 8-3.6 8-8s-3.6-8-8-8H248c-4.4 0-8-3.6-8-8V240c0-4.4 3.6-8 8-8h16c4.4 0 8-3.6 8-8s-3.6-8-8-8H248z'
      
    ]
  };

  

  
  

  var faBrakeWarning = {
    prefix: 'fat',
    iconName: 'brake-warning',
    icon: [
      640,
      512,
      [],
      'e0c7',
      
      'M320 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 432a224 224 0 1 0 0-448 224 224 0 1 0 0 448zm8-344c0-4.4-3.6-8-8-8s-8 3.6-8 8V296c0 4.4 3.6 8 8 8s8-3.6 8-8V136zm-8 232a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM62.7 96.3c2.4-3.7 1.3-8.7-2.4-11.1s-8.7-1.3-11.1 2.4C18.1 136.2 0 194 0 256s18.1 119.8 49.3 168.3c2.4 3.7 7.3 4.8 11.1 2.4s4.8-7.3 2.4-11.1C33.2 369.6 16 314.8 16 256s17.2-113.6 46.7-159.7zm528-8.6c-2.4-3.7-7.3-4.8-11.1-2.4s-4.8 7.3-2.4 11.1C606.8 142.4 624 197.2 624 256s-17.2 113.6-46.7 159.7c-2.4 3.7-1.3 8.7 2.4 11.1s8.7 1.3 11.1-2.4C621.9 375.8 640 318 640 256s-18.1-119.8-49.3-168.3z'
      
    ]
  };

  

  
  

  var faCircleHalf = {
    prefix: 'fat',
    iconName: 'circle-half',
    icon: [
      512,
      512,
      [],
      'e110',
      
      'M226 17.9C107.6 32.6 16 133.6 16 256s91.6 223.4 210 238.1c6.7 .8 14-4.7 14-14.2V32c0-9.4-7.3-15-14-14.1zM224.1 2C241.6-.2 256 14.3 256 32V480c0 17.7-14.4 32.2-31.9 30C97.8 494.3 0 386.6 0 256S97.8 17.7 224.1 2z'
      
    ]
  };

  

  
  

  var faWindsock = {
    prefix: 'fat',
    iconName: 'windsock',
    icon: [
      512,
      512,
      [],
      'f777',
      
      'M8 0c4.4 0 8 3.6 8 8V128H96V86.7c0-20.1 18.3-35.2 38-31.4L486 123c15.1 2.9 26 16.1 26 31.4V261.6c0 15.3-10.9 28.5-26 31.4L134 360.7c-19.7 3.8-38-11.3-38-31.4V288H16V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V280 136 8C0 3.6 3.6 0 8 0zm8 144V272H96V144H16zm96 185.3c0 10 9.2 17.6 19 15.7l85-16.3V87.4L131 71c-9.9-1.9-19 5.7-19 15.7V128v16V272v16 41.3zm120-3.7l144-27.7V118.1L232 90.4V325.6zM392 121.2V294.8l91-17.5c7.5-1.4 13-8 13-15.7V154.4c0-7.7-5.4-14.3-13-15.7l-91-17.5z'
      
    ]
  };

  

  
  

  var faMound = {
    prefix: 'fat',
    iconName: 'mound',
    icon: [
      576,
      512,
      [],
      'e52d',
      
      'M526.6 376c6.1 10.7-1.6 24-13.9 24H63.3c-12.3 0-20-13.3-13.9-24L158 187.2c26.7-46.5 76.3-75.2 130-75.2s103.2 28.7 130 75.2L526.6 376zM288 96c-59.4 0-114.2 31.7-143.9 83.2L35.6 368c-12.3 21.3 3.1 48 27.7 48H512.7c24.6 0 40-26.6 27.7-48L431.9 179.2C402.2 127.7 347.4 96 288 96z'
      
    ]
  };

  

  
  

  var faPeoplePants = {
    prefix: 'fat',
    iconName: 'people-pants',
    icon: [
      640,
      512,
      [],
      'e219',
      
      'M120 56a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm96 0A56 56 0 1 0 104 56a56 56 0 1 0 112 0zM90.7 175.7c9.3-19.4 28.9-31.7 50.4-31.7h37.8c21.5 0 41.1 12.3 50.4 31.7l67.5 139.8c1.9 4 6.7 5.6 10.7 3.7s5.6-6.7 3.7-10.7L243.7 168.7c-12-24.9-37.2-40.7-64.8-40.7H141.1c-27.6 0-52.8 15.8-64.8 40.7L8.8 308.5c-1.9 4-.3 8.8 3.7 10.7s8.8 .3 10.7-3.7L90.7 175.7zM96 240c-4.4 0-8 3.6-8 8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V360c0-4.4 3.6-8 8-8s8 3.6 8 8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V248c0-4.4-3.6-8-8-8s-8 3.6-8 8V480c0 8.8-7.2 16-16 16s-16-7.2-16-16V360c0-13.3-10.7-24-24-24s-24 10.7-24 24V480c0 8.8-7.2 16-16 16s-16-7.2-16-16V248c0-4.4-3.6-8-8-8zM440 56a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm96 0A56 56 0 1 0 424 56a56 56 0 1 0 112 0zM410.7 175.7c9.3-19.4 28.9-31.7 50.4-31.7h37.8c21.5 0 41.1 12.3 50.4 31.7l67.5 139.8c1.9 4 6.7 5.6 10.7 3.7s5.6-6.7 3.7-10.7L563.7 168.7c-12-24.9-37.2-40.7-64.8-40.7H461.1c-27.6 0-52.8 15.8-64.8 40.7L328.8 308.5c-1.9 4-.2 8.8 3.7 10.7s8.8 .3 10.7-3.7l67.5-139.8zM416 240c-4.4 0-8 3.6-8 8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V360c0-4.4 3.6-8 8-8s8 3.6 8 8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V248c0-4.4-3.6-8-8-8s-8 3.6-8 8V480c0 8.8-7.2 16-16 16s-16-7.2-16-16V360c0-13.3-10.7-24-24-24s-24 10.7-24 24V480c0 8.8-7.2 16-16 16s-16-7.2-16-16V248c0-4.4-3.6-8-8-8z'
      
    ]
  };

  

  
  

  var faGridRound2Plus = {
    prefix: 'fat',
    iconName: 'grid-round-2-plus',
    icon: [
      512,
      512,
      [],
      'e5dc',
      
      'M48 128a80 80 0 1 0 160 0A80 80 0 1 0 48 128zm80 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM48 384a80 80 0 1 0 160 0A80 80 0 1 0 48 384zm80 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM384 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm96-80a96 96 0 1 1 -192 0 96 96 0 1 1 192 0zM384 272c4.4 0 8 3.6 8 8v96h96c4.4 0 8 3.6 8 8s-3.6 8-8 8H392v96c0 4.4-3.6 8-8 8s-8-3.6-8-8V392H280c-4.4 0-8-3.6-8-8s3.6-8 8-8h96V280c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faHurricane = {
    prefix: 'fat',
    iconName: 'hurricane',
    icon: [
      384,
      512,
      [],
      'f751',
      
      'M200 24c0-4.6-3.6-7.7-7.4-7.4C93.8 24.4 16 107.1 16 208c0 91 63.4 167.3 148.4 187c10.9 2.5 19.6 12.1 19.6 24.1v68.3c0 4.6 3.6 7.7 7.4 7.4C290.2 487 368 404.3 368 303.4c0-91-63.4-167.3-148.4-187c-10.9-2.5-19.6-12.1-19.6-24.1V24zM191.4 .7C205.2-.4 216 10.9 216 24V92.3c0 3.8 2.8 7.5 7.2 8.5C315.3 122.2 384 204.7 384 303.4c0 109.3-84.3 198.9-191.4 207.3c-13.9 1.1-24.6-10.3-24.6-23.3V419.1c0-3.8-2.8-7.5-7.2-8.5C68.7 389.2 0 306.7 0 208C0 98.7 84.3 9.1 191.4 .7zM192 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-176a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm16 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faUpload = {
    prefix: 'fat',
    iconName: 'upload',
    icon: [
      512,
      512,
      [],
      'f093',
      
      'M264 27.3V376c0 4.4-3.6 8-8 8s-8-3.6-8-8V27.3L133.7 141.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l128-128c3.1-3.1 8.2-3.1 11.3 0l128 128c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L264 27.3zM216 336H64c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V384c0-26.5-21.5-48-48-48H296V320H448c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V384c0-35.3 28.7-64 64-64H216v16zm216 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z'
      
    ]
  };

  

  
  

  var faUpFromLine = {
    prefix: 'fat',
    iconName: 'up-from-line',
    icon: [
      384,
      512,
      ["arrow-alt-from-bottom"],
      'f346',
      
      'M184 51.3c2.1-2.1 5-3.3 8-3.3s5.9 1.2 8 3.3L331.8 183.4c2.7 2.7 4.2 6.4 4.2 10.2c0 8-6.5 14.4-14.4 14.4L248 208c-4.4 0-8 3.6-8 8l0 136c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-136c0-4.4-3.6-8-8-8l-73.6 0c-8 0-14.4-6.5-14.4-14.4c0-3.8 1.5-7.5 4.2-10.2L184 51.3zM192 32c-7.2 0-14.2 2.9-19.3 8L40.9 172.1c-5.7 5.7-8.9 13.4-8.9 21.5C32 210.4 45.6 224 62.4 224l65.6 0 0 128c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-128 65.6 0c16.8 0 30.4-13.6 30.4-30.4c0-8.1-3.2-15.8-8.9-21.5L211.3 40c-5.1-5.1-12.1-8-19.3-8zM8 480l368 0c4.4 0 8-3.6 8-8s-3.6-8-8-8L8 464c-4.4 0-8 3.6-8 8s3.6 8 8 8z'
      
    ]
  };

  
    var faArrowAltFromBottom = faUpFromLine;
  

  
  

  var faMoneyCheckDollarPen = {
    prefix: 'fat',
    iconName: 'money-check-dollar-pen',
    icon: [
      640,
      512,
      ["money-check-edit-alt"],
      'f873',
      
      'M512 80H64c-26.5 0-48 21.5-48 48V384c0 26.5 21.5 48 48 48H334.5l-4 16H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64v64.6c-5.4 .7-10.8 2.1-16 4V128c0-26.5-21.5-48-48-48zM256 312c0-4.4 3.6-8 8-8H376c4.4 0 8 3.6 8 8s-3.6 8-8 8H264c-4.4 0-8-3.6-8-8zm8-104H472c4.4 0 8 3.6 8 8s-3.6 8-8 8H264c-4.4 0-8-3.6-8-8s3.6-8 8-8zM144 152c4.4 0 8 3.6 8 8v16.6c1.8 .2 3.6 .4 5.5 .7c4.8 .8 19.4 3.6 24.6 4.9c4.3 1.1 6.8 5.5 5.7 9.8s-5.5 6.8-9.8 5.7c-4.4-1.2-18.4-3.9-22.9-4.6c-14.1-2.2-26.5-.5-35.4 3.5c-8.9 4-13.9 10.1-15.1 17c-.9 5.4-.3 9.3 1.1 12.2c1.4 3 3.9 5.7 7.7 8.3c7.9 5.4 19.5 8.9 32.9 12.9l0 0 .3 .1c12.7 3.8 27.2 8.2 37.6 15.8c5.4 3.9 10.1 9 13 15.5c2.9 6.6 3.6 14.1 2.1 22.6c-2.5 14.4-11.9 24.3-24.5 29.7c-6.8 2.9-14.5 4.5-22.7 5l0 16.1c0 4.4-3.6 8-8 8s-8-3.6-8-8V335.4c-1.8-.2-3.6-.4-5.5-.7l0 0c-8.6-1.4-22.6-6.2-32-9.4l0 0 0 0c-1.9-.6-3.5-1.2-5-1.7c-4.2-1.4-6.5-5.9-5.1-10.1s5.9-6.5 10.1-5.1c1.7 .6 3.7 1.2 5.7 1.9l0 0 0 0 0 0 0 0c9.5 3.2 21.6 7.4 28.8 8.5c14.3 2.2 26.6 1 35.4-2.7c8.5-3.7 13.7-9.6 15.1-17.8c1-5.9 .4-10.2-1.1-13.5c-1.4-3.3-4-6.3-7.7-9c-7.8-5.7-19.5-9.4-32.9-13.5l-1.7-.5c-12.2-3.7-25.9-7.8-35.9-14.6c-5.4-3.7-10.2-8.4-13.2-14.7c-3-6.4-3.8-13.6-2.4-21.8c2.3-13.4 11.9-23.2 24.2-28.8c6.8-3.1 14.6-5 23-5.7V160c0-4.4 3.6-8 8-8zM356.7 507.2c-4-4-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9L557.2 235.7c15.6-15.6 40.9-15.6 56.6 0l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6L446.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-3.4-13.6 3.4 13.6-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2zm15.7-28.9L368 495.8l17.6-4.4 42.5-10.6c2.8-.7 5.4-2.2 7.4-4.2L578.4 333.7l-48.3-48.3L387.2 428.3c-2 2.1-3.5 4.6-4.2 7.4l-10.6 42.5zM616.8 295.4c9.4-9.4 9.4-24.6 0-33.9L602.4 247c-9.4-9.4-24.6-9.4-33.9 0l-27.1 27.1 48.3 48.3 27.1-27.1z'
      
    ]
  };

  
    var faMoneyCheckEditAlt = faMoneyCheckDollarPen;
  

  
  

  var faCodeMerge = {
    prefix: 'fat',
    iconName: 'code-merge',
    icon: [
      448,
      512,
      [],
      'f387',
      
      'M80 16a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm8 111.5c31.6-3.9 56-30.9 56-63.5c0-35.3-28.7-64-64-64S16 28.7 16 64c0 32.6 24.4 59.6 56 63.5V144 384.5c-31.6 3.9-56 30.9-56 63.5c0 35.3 28.7 64 64 64s64-28.7 64-64c0-32.6-24.4-59.6-56-63.5V208.1c22.9 42.8 68 71.9 120 71.9H320.5c3.9 31.6 30.9 56 63.5 56c35.3 0 64-28.7 64-64s-28.7-64-64-64c-32.6 0-59.6 24.4-63.5 56H208c-66.3 0-120-53.7-120-120V127.5zM80 400a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM336 272a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  

  
  

  var faStop = {
    prefix: 'fat',
    iconName: 'stop',
    icon: [
      384,
      512,
      [9209],
      'f04d',
      
      'M320 80c26.5 0 48 21.5 48 48V384c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V128c0-26.5 21.5-48 48-48H320zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64z'
      
    ]
  };

  

  
  

  var faUpLong = {
    prefix: 'fat',
    iconName: 'up-long',
    icon: [
      320,
      512,
      ["long-arrow-alt-up"],
      'f30c',
      
      'M104 176H22.9c-3.8 0-6.9-3.1-6.9-6.9c0-1.8 .7-3.5 1.9-4.7L158.1 16.8c.5-.5 1.2-.8 1.9-.8s1.4 .3 1.9 .8L302.1 164.4c1.2 1.3 1.9 3 1.9 4.7c0 3.8-3.1 6.9-6.9 6.9H216c-8.8 0-16 7.2-16 16V472c0 13.3-10.7 24-24 24H144c-13.3 0-24-10.7-24-24V192c0-8.8-7.2-16-16-16zM146.5 5.8L6.3 153.4c-4 4.3-6.3 9.9-6.3 15.8C0 181.8 10.2 192 22.9 192H88h16v16V472c0 22.1 17.9 40 40 40h32c22.1 0 40-17.9 40-40V208 192h16 65.1c12.6 0 22.9-10.2 22.9-22.9c0-5.9-2.3-11.5-6.3-15.8L173.5 5.8C170 2.1 165.1 0 160 0s-10 2.1-13.5 5.8z'
      
    ]
  };

  
    var faLongArrowAltUp = faUpLong;
  

  
  

  var faBlockQuote = {
    prefix: 'fat',
    iconName: 'block-quote',
    icon: [
      448,
      512,
      [],
      'e0b5',
      
      'M8 88c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zM136 248c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H136zm-8 168c0 4.4 3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H136c-4.4 0-8 3.6-8 8zM0 440c0 4.4 3.6 8 8 8s8-3.6 8-8l0-208c0-4.4-3.6-8-8-8s-8 3.6-8 8V440z'
      
    ]
  };

  

  
  

  var faTruckPickup = {
    prefix: 'fat',
    iconName: 'truck-pickup',
    icon: [
      640,
      512,
      [128763],
      'f63c',
      
      'M240 72V192H493.8L387.3 57.1c-4.6-5.8-11.5-9.1-18.8-9.1H264c-13.3 0-24 10.7-24 24zM510.3 187l3.9 5H552c30.9 0 56 25.1 56 56V368h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H608 592 560c0 53-43 96-96 96s-96-43-96-96H272c0 53-43 96-96 96s-96-43-96-96H48 32 8c-4.4 0-8-3.6-8-8s3.6-8 8-8H32V248c0-30.9 25.1-56 56-56H224V72c0-22.1 17.9-40 40-40H368.5c12.2 0 23.8 5.6 31.4 15.2L510.3 187zM48 368H81.3c7.6-45.4 47.1-80 94.7-80s87.1 34.6 94.7 80h98.7c7.6-45.4 47.1-80 94.7-80s87.1 34.6 94.7 80H592V248c0-22.1-17.9-40-40-40H88c-22.1 0-40 17.9-40 40V368zm208 16A80 80 0 1 0 96 384a80 80 0 1 0 160 0zm208 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160z'
      
    ]
  };

  

  
  

  var faTowerBroadcast = {
    prefix: 'fat',
    iconName: 'tower-broadcast',
    icon: [
      576,
      512,
      ["broadcast-tower"],
      'f519',
      
      'M42.2 11.4C25.4 46.7 16 86.3 16 128s9.4 81.3 26.2 116.6c1.9 4 .2 8.8-3.8 10.7s-8.8 .2-10.7-3.8C9.9 214 0 172.2 0 128S9.9 42 27.7 4.5c1.9-4 6.7-5.7 10.7-3.8s5.7 6.7 3.8 10.7zM548.3 4.5C566.1 42 576 83.8 576 128s-9.9 86-27.7 123.5c-1.9 4-6.7 5.7-10.7 3.8s-5.7-6.7-3.8-10.7C550.6 209.3 560 169.7 560 128s-9.4-81.3-26.2-116.6c-1.9-4-.2-8.8 3.8-10.7s8.8-.2 10.7 3.8zM336 128a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm16 0c0 32.6-24.4 59.6-56 63.5V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V191.5c-31.6-3.9-56-30.9-56-63.5c0-35.3 28.7-64 64-64s64 28.7 64 64zM125.9 59.2C117 80.4 112 103.6 112 128s5 47.7 13.9 68.8c1.7 4.1-.2 8.8-4.2 10.5s-8.8-.2-10.5-4.2C101.4 180 96 154.6 96 128s5.4-52 15.2-75c1.7-4.1 6.4-6 10.5-4.2s6 6.4 4.2 10.5zM464.8 53C474.6 76 480 101.4 480 128s-5.4 52-15.2 75c-1.7 4.1-6.4 6-10.5 4.2s-6-6.4-4.2-10.5c9-21.1 13.9-44.3 13.9-68.8s-5-47.6-13.9-68.8c-1.7-4.1 .2-8.8 4.2-10.5s8.8 .2 10.5 4.2z'
      
    ]
  };

  
    var faBroadcastTower = faTowerBroadcast;
  

  
  

  var faLoveseat = {
    prefix: 'fat',
    iconName: 'loveseat',
    icon: [
      512,
      512,
      ["couch-small"],
      'f4cc',
      
      'M320 48H192C130.1 48 80 98.1 80 160v33.3c-5.2-.9-10.5-1.3-16-1.3V160C64 89.3 121.3 32 192 32H320c70.7 0 128 57.3 128 128v32c-5.5 0-10.8 .5-16 1.3V160c0-61.9-50.1-112-112-112zM112 288c0-26.5-21.5-48-48-48s-48 21.5-48 48V432c0 17.7 14.3 32 32 32H80c17.7 0 32-14.3 32-32V288zM0 288c0-35.3 28.7-64 64-64s64 28.7 64 64H384c0-35.3 28.7-64 64-64s64 28.7 64 64V432c0 26.5-21.5 48-48 48H432c-26.5 0-48-21.5-48-48H128c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V288zM128 416H384V304H128V416zM496 288c0-26.5-21.5-48-48-48s-48 21.5-48 48V432c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V288z'
      
    ]
  };

  
    var faCouchSmall = faLoveseat;
  

  
  

  var faPeopleDress = {
    prefix: 'fat',
    iconName: 'people-dress',
    icon: [
      640,
      512,
      [],
      'e217',
      
      'M120 56a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm96 0A56 56 0 1 0 104 56a56 56 0 1 0 112 0zM119.6 210.5c1.4-4.2-.9-8.7-5.1-10.1s-8.7 .9-10.1 5.1l-56 168c-.8 2.4-.4 5.1 1.1 7.2s3.9 3.3 6.5 3.3H88v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h16v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h32c2.6 0 5-1.2 6.5-3.3s1.9-4.8 1.1-7.2l-56-168c-1.4-4.2-5.9-6.5-10.1-5.1s-6.5 5.9-5.1 10.1L252.9 368H224 176 144 96 67.1l52.5-157.5zM104 480V384h32v96c0 8.8-7.2 16-16 16s-16-7.2-16-16zm80-96h32v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V384zM156.2 144h7.7c30.7 0 58.7 17.6 72.1 45.2l60.9 126.2c1.9 4 6.7 5.6 10.7 3.7s5.6-6.7 3.7-10.7L250.3 182.3c-16-33.2-49.6-54.3-86.5-54.3h-7.7c-36.8 0-70.4 21.1-86.5 54.3L8.8 308.5c-1.9 4-.3 8.8 3.7 10.7s8.8 .3 10.7-3.7L84.1 189.2c13.3-27.7 41.3-45.2 72.1-45.2zM440 56a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm96 0A56 56 0 1 0 424 56a56 56 0 1 0 112 0zM439.6 210.5c1.4-4.2-.9-8.7-5.1-10.1s-8.7 .9-10.1 5.1l-56 168c-.8 2.4-.4 5.1 1.1 7.2s3.9 3.3 6.5 3.3h32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h16v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h32c2.6 0 5-1.2 6.5-3.3s1.9-4.8 1.1-7.2l-56-168c-1.4-4.2-5.9-6.5-10.1-5.1s-6.5 5.9-5.1 10.1L572.9 368H544 496 464 416 387.1l52.5-157.5zM424 480V384h32v96c0 8.8-7.2 16-16 16s-16-7.2-16-16zm80-96h32v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V384zM476.2 144h7.7c30.7 0 58.7 17.6 72.1 45.2l60.9 126.2c1.9 4 6.7 5.6 10.7 3.7s5.6-6.7 3.7-10.7L570.3 182.3c-16-33.2-49.6-54.3-86.5-54.3h-7.7c-36.9 0-70.4 21.1-86.5 54.3L328.8 308.5c-1.9 4-.2 8.8 3.7 10.7s8.8 .3 10.7-3.7l60.9-126.2c13.3-27.7 41.3-45.2 72.1-45.2z'
      
    ]
  };

  

  
  

  var faHandHoldingSkull = {
    prefix: 'fat',
    iconName: 'hand-holding-skull',
    icon: [
      576,
      512,
      [],
      'e1a4',
      
      'M416 128c0 36.8-20.4 70-53 90.7c-10.9 6.9-18 20.2-15.1 34.4l3.8 18.9H224.3l3.8-18.9c2.8-14.2-4.2-27.4-15.1-34.4c-32.6-20.7-53-54-53-90.7c0-60.1 55.5-112 128-112s128 51.9 128 112zM363.6 250c-1.4-7 2-13.9 8-17.7C408.2 209 432 171 432 128C432 57.3 367.5 0 288 0S144 57.3 144 128c0 43 23.8 81 60.4 104.2c6 3.8 9.4 10.8 8 17.7l-4.1 20.6c-.2 .9-.3 1.9-.3 2.9c0 8 6.5 14.6 14.6 14.6H353.4c8 0 14.6-6.5 14.6-14.6c0-1-.1-1.9-.3-2.9L363.6 250zm158.2 90.7c10.7-7.9 25.7-5.6 33.6 5.1s5.6 25.7-5.1 33.6L423.6 472.6C403 487.8 378.1 496 352.5 496H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L394.7 414.4c-1.4 1-3 1.6-4.7 1.6H268c-6.6 0-12-5.4-12-12s5.4-12 12-12h80c19.9 0 36-16.1 36-36s-16.1-36-36-36H193.7c-29.1 0-57.3 9.9-80 28L71 382.2c-1.4 1.1-3.2 1.8-5 1.8H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H66c5.4 0 10.7-1.9 15-5.3l42.7-34.2c19.9-15.9 44.5-24.5 70-24.5H348c11 0 20 9 20 20s-9 20-20 20H268c-15.5 0-28 12.5-28 28s12.5 28 28 28H389.9c5.1 0 10.1-1.6 14.2-4.7l117.6-86.6zM240 160a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm144 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64z'
      
    ]
  };

  

  
  

  var faBanana = {
    prefix: 'fat',
    iconName: 'banana',
    icon: [
      576,
      512,
      [],
      'e2e5',
      
      'M320 144c0-33.3-6-65.2-16.9-94.6c-5.9-15.8 5.5-33.4 23-33.4c5.9 0 11.8 2.2 16.3 6.3C397.4 72 432 144 432 224c0 17.4-1.6 34.4-4.8 50.9l7.4-3.2c3.3-1.4 6.6-2.6 10-3.6c2.2-14.4 3.4-29.1 3.4-44.1c0-84.7-36.6-160.9-94.8-213.6C345.6 3.6 335.9 0 326.1 0c-29.4 0-47.5 29.4-38 55c10.3 27.7 15.9 57.7 15.9 89c0 37.8-8.2 73.7-22.9 106c2.9 2.1 5.7 4.3 8.3 6.8l4.3 3.9C310.6 225.3 320 185.8 320 144zM265.8 278.7c-14.2-9.5-31.1-14.7-48.4-14.7c-18.2 0-35.9 5.7-50.7 16.2l-35.3 25.2c-3.6 2.6-4.4 7.6-1.9 11.2s7.6 4.4 11.2 1.9L176 293.3c12.1-8.6 26.5-13.3 41.4-13.3c14.2 0 27.9 4.2 39.5 12C210.5 357.3 134.2 400 48 400c-26.5 0-48 21.5-48 48v16c0 26.5 21.5 48 48 48l112 0c125.5 0 232.3-80.3 271.7-192.3l4.4-1.9c8.9-3.8 18.5-5.8 28.3-5.8c26.4 0 50.7 14.5 63.2 37.7L561 411.8c2.1 3.9 6.9 5.3 10.8 3.3s5.3-6.9 3.3-10.8l-33.4-62.1c-15.3-28.4-45-46.1-77.3-46.1c-11.9 0-23.6 2.4-34.6 7.1L347 338.6c-5.8 2.5-12.4 1.3-17.1-2.9l-53.9-49c-3.1-2.8-6.4-5.4-9.9-7.7c-.1-.1-.3-.2-.4-.3c0 0 0 0 0 0zm145.4 49.8C370.3 426.8 273.2 496 160 496L48 496c-17.7 0-32-14.3-32-32V448c0-17.7 14.3-32 32-32c91.2 0 172-44.9 221.3-113.8l49.9 45.4c9.3 8.4 22.6 10.7 34.1 5.7l57.9-24.8z'
      
    ]
  };

  

  
  

  var faHouseTurret = {
    prefix: 'fat',
    iconName: 'house-turret',
    icon: [
      640,
      512,
      [],
      'e1b4',
      
      'M272 456V280.6c0-11.2 4.7-21.9 13-29.5L421 126.5c15.3-14 38.8-14 54.1 0L611 251.1c8.3 7.6 13 18.3 13 29.5V456c0 22.1-17.9 40-40 40H312c-22.1 0-40-17.9-40-40zM256 280.6V456c0 30.9 25.1 56 56 56H584c30.9 0 56-25.1 56-56V280.6c0-15.7-6.6-30.7-18.2-41.3l-136-124.7c-21.4-19.6-54.3-19.6-75.7 0l-136 124.7C262.6 250 256 264.9 256 280.6zm160-.6h64c4.4 0 8 3.6 8 8v64c0 4.4-3.6 8-8 8H416c-4.4 0-8-3.6-8-8V288c0-4.4 3.6-8 8-8zm-24 8v64c0 13.3 10.7 24 24 24h64c13.3 0 24-10.7 24-24V288c0-13.3-10.7-24-24-24H416c-13.3 0-24 10.7-24 24zM16 40c0-13.3 10.7-24 24-24H96V88c0 4.4 3.6 8 8 8s8-3.6 8-8V16H240V88c0 4.4 3.6 8 8 8s8-3.6 8-8V16h56c13.3 0 24 10.7 24 24v99.3l16-14.7V40c0-22.1-17.9-40-40-40H40C17.9 0 0 17.9 0 40V203.8c0 9.8 3.6 19.3 10.1 26.6L64 291V496c0 4.4 3.6 8 8 8s8-3.6 8-8V288c0-2-.7-3.9-2-5.3L22.1 219.8c-3.9-4.4-6.1-10.1-6.1-15.9V40zM208 224H144V176c0-17.7 14.3-32 32-32s32 14.3 32 32v48zm-32-96c-26.5 0-48 21.5-48 48v48c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V176c0-26.5-21.5-48-48-48z'
      
    ]
  };

  

  
  

  var faChartScatterBubble = {
    prefix: 'fat',
    iconName: 'chart-scatter-bubble',
    icon: [
      512,
      512,
      [],
      'e0e9',
      
      'M8 32c4.4 0 8 3.6 8 8V408c0 30.9 25.1 56 56 56H504c4.4 0 8 3.6 8 8s-3.6 8-8 8H72c-39.8 0-72-32.2-72-72V40c0-4.4 3.6-8 8-8zM176 336a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm224 32a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-112 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm-48-80a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm192 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-112 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  

  
  

  var faCircleVideo = {
    prefix: 'fat',
    iconName: 'circle-video',
    icon: [
      512,
      512,
      ["video-circle"],
      'e12b',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-336c8.8 0 16 7.2 16 16V320c0 8.8-7.2 16-16 16H160c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16H288zM160 160c-17.7 0-32 14.3-32 32V320c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V301.2l60.7 18.2c1.4 .4 2.8 .6 4.3 .6c8.3 0 15-6.7 15-15V207c0-8.3-6.7-15-15-15c-1.5 0-2.9 .2-4.3 .6L320 210.8V192c0-17.7-14.3-32-32-32H160zm160 67.6l64-19.2v95.3l-64-19.2V227.6z'
      
    ]
  };

  
    var faVideoCircle = faCircleVideo;
  

  
  

  var faGameBoardSimple = {
    prefix: 'fat',
    iconName: 'game-board-simple',
    icon: [
      448,
      512,
      ["game-board-alt"],
      'f868',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm72 16V240c0 4.4 3.6 8 8 8H216V112c0-4.4-3.6-8-8-8H80c-4.4 0-8 3.6-8 8zm160 0V248H368c13.3 0 24 10.7 24 24V400c0 13.3-10.7 24-24 24H240c-13.3 0-24-10.7-24-24V264H80c-13.3 0-24-10.7-24-24V112c0-13.3 10.7-24 24-24H208c13.3 0 24 10.7 24 24zm0 288c0 4.4 3.6 8 8 8H368c4.4 0 8-3.6 8-8V272c0-4.4-3.6-8-8-8H232V400z'
      
    ]
  };

  
    var faGameBoardAlt = faGameBoardSimple;
  

  
  

  var faSkull = {
    prefix: 'fat',
    iconName: 'skull',
    icon: [
      512,
      512,
      [128128],
      'f54c',
      
      'M406.8 385.8c54.9-38.5 89.2-97 89.2-161.8C496 111.1 390.6 16 256 16S16 111.1 16 224c0 64.8 34.3 123.3 89.2 161.8c4.4 3.1 6.9 8.1 6.8 13.5l0 .8v64c0 17.7 14.3 32 32 32h40V448c0-4.4 3.6-8 8-8s8 3.6 8 8v48h48V448c0-4.4 3.6-8 8-8s8 3.6 8 8v48h48V448c0-4.4 3.6-8 8-8s8 3.6 8 8v48h40c17.7 0 32-14.3 32-32V400l0-.8c-.1-5.3 2.4-10.4 6.8-13.5zM312 512H264 248 200 184 144c-26.5 0-48-21.5-48-48V400c0-.4 0-.7 0-1.1C37.5 357.8 0 294.7 0 224C0 100.3 114.6 0 256 0S512 100.3 512 224c0 70.7-37.5 133.8-96 174.9c0 .4 0 .7 0 1.1v64c0 26.5-21.5 48-48 48H328 312zM208 256a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM96 256a64 64 0 1 1 128 0A64 64 0 1 1 96 256zm256 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-112a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
      
    ]
  };

  

  
  

  var faTimelineArrow = {
    prefix: 'fat',
    iconName: 'timeline-arrow',
    icon: [
      640,
      512,
      [],
      'e29d',
      
      'M128 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm8 111.5c31.6-3.9 56-30.9 56-63.5c0-35.3-28.7-64-64-64S64 44.7 64 80c0 32.6 24.4 59.6 56 63.5V248H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H120h16 80V368.5c-31.6 3.9-56 30.9-56 63.5c0 35.3 28.7 64 64 64s64-28.7 64-64c0-32.6-24.4-59.6-56-63.5V264H611.3l-72.7 66.1c-3.3 3-3.5 8-.5 11.3s8 3.5 11.3 .5l88-80c1.7-1.5 2.6-3.7 2.6-5.9s-1-4.4-2.6-5.9l-88-80c-3.3-3-8.3-2.7-11.3 .5s-2.7 8.3 .5 11.3L611.3 248H360V143.5c31.6-3.9 56-30.9 56-63.5c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 32.6 24.4 59.6 56 63.5V248H136V143.5zM304 80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM176 432a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  

  
  

  var faBowlRice = {
    prefix: 'fat',
    iconName: 'bowl-rice',
    icon: [
      512,
      512,
      [],
      'e2eb',
      
      'M192 56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8s-3.6 8-8 8H200c-4.4 0-8-3.6-8-8zm0 72c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8s-3.6 8-8 8H200c-4.4 0-8-3.6-8-8zM48 200c0-4.4 3.6-8 8-8H72c4.4 0 8 3.6 8 8s-3.6 8-8 8H56c-4.4 0-8-3.6-8-8zm192 0c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8s-3.6 8-8 8H248c-4.4 0-8-3.6-8-8zm-96 0c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8s-3.6 8-8 8H152c-4.4 0-8-3.6-8-8zM96 128c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8s-3.6 8-8 8H104c-4.4 0-8-3.6-8-8zm240 72c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8s-3.6 8-8 8H344c-4.4 0-8-3.6-8-8zm-48-72c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8s-3.6 8-8 8H296c-4.4 0-8-3.6-8-8zm144 72c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8s-3.6 8-8 8H440c-4.4 0-8-3.6-8-8zm-48-72c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8s-3.6 8-8 8H392c-4.4 0-8-3.6-8-8zM288 56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8s-3.6 8-8 8H296c-4.4 0-8-3.6-8-8zM176 56c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H200c-13.3 0-24 10.7-24 24zm24 48c-13.3 0-24 10.7-24 24s10.7 24 24 24h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H200zM32 200c0 13.3 10.7 24 24 24H72c13.3 0 24-10.7 24-24s-10.7-24-24-24H56c-13.3 0-24 10.7-24 24zm192 0c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H248c-13.3 0-24 10.7-24 24zm-96 0c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H152c-13.3 0-24 10.7-24 24zm-24-96c-13.3 0-24 10.7-24 24s10.7 24 24 24h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H104zm216 96c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H344c-13.3 0-24 10.7-24 24zm-24-96c-13.3 0-24 10.7-24 24s10.7 24 24 24h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H296zm120 96c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H440c-13.3 0-24 10.7-24 24zm-24-96c-13.3 0-24 10.7-24 24s10.7 24 24 24h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H392zM296 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H296zM112 432.7c-.1-6.1-3.8-11.6-9.3-14.2C51.5 395.1 16 343.4 16 283.4c0-6.3 5.1-11.4 11.4-11.4H484.6c6.3 0 11.4 5.1 11.4 11.4c0 59.9-35.5 111.6-86.7 135.1c-5.6 2.6-9.2 8.1-9.3 14.2c-.4 17.3-14.6 31.3-32 31.3H144c-17.4 0-31.6-13.9-32-31.3zM27.4 256C12.3 256 0 268.3 0 283.4c0 66.4 39.4 123.7 96 149.7c.6 26 21.8 46.9 48 46.9H368c26.1 0 47.4-20.9 48-46.9c56.7-26 96-83.2 96-149.7c0-15.1-12.3-27.4-27.4-27.4H27.4z'
      
    ]
  };

  

  
  

  var faMillSign = {
    prefix: 'fat',
    iconName: 'mill-sign',
    icon: [
      384,
      512,
      [],
      'e1ed',
      
      'M287.5 10.7c1.5-4.2-.7-8.7-4.9-10.2s-8.7 .7-10.2 4.9L228.7 128.7c-16.1 10.7-29 26-36.7 44.1C176.7 137 141.3 112 100 112c-35.2 0-66.2 18.2-84 45.7V120c0-4.4-3.6-8-8-8s-8 3.6-8 8v92 4V440c0 4.4 3.6 8 8 8s8-3.6 8-8V216v-4c0-46.4 37.6-84 84-84s84 37.6 84 84v42.6L96.5 501.3c-1.5 4.2 .7 8.7 4.9 10.2s8.7-.7 10.2-4.9L184 302.5V440c0 4.4 3.6 8 8 8s8-3.6 8-8V257.4l41.9-118.1c12.4-7.2 26.8-11.3 42.1-11.3c46.4 0 84 37.6 84 84V440c0 4.4 3.6 8 8 8s8-3.6 8-8V212c0-55.2-44.8-100-100-100c-12.2 0-23.8 2.2-34.6 6.1L287.5 10.7zM200 209.4l17.2-48.4c-10.3 13.5-16.6 30.2-17.2 48.4z'
      
    ]
  };

  

  
  

  var faBalloons = {
    prefix: 'fat',
    iconName: 'balloons',
    icon: [
      640,
      512,
      [],
      'e2e4',
      
      'M182.9 346.8l0 0 0 0-7.5 5.2H144.6l-7.5-5.2 0 0 0 0 0 0 0 0-.2-.1-.9-.7c-.8-.6-2.1-1.5-3.8-2.8c-3.3-2.5-8.1-6.2-13.9-11c-11.6-9.6-26.9-23.6-42.3-40.8c-31.1-35-60-81.3-60-131.4C16 80.5 80.5 16 160 16s144 64.5 144 144c0 50.1-28.8 96.4-60 131.4c-15.3 17.3-30.7 31.2-42.3 40.8c-5.8 4.8-10.6 8.5-13.9 11c-1.7 1.2-2.9 2.2-3.8 2.8l-.9 .7-.2 .1 0 0 0 0zM113.5 432L142 368h2 32 2l28.4 64h-93zM192 360s128-88 128-200C320 71.6 248.4 0 160 0S0 71.6 0 160C0 272 128 360 128 360L97.1 429.4c-.8 1.7-1.1 3.5-1.1 5.4c0 7.3 5.9 13.2 13.2 13.2H210.8c7.3 0 13.2-5.9 13.2-13.2c0-1.8-.4-3.7-1.1-5.4L192 360zm132.7-98.2C347.9 355.2 448 424 448 424l-30.9 69.4c-.7 1.7-1.1 3.5-1.1 5.4c0 7.3 5.9 13.2 13.2 13.2H530.8c7.3 0 13.2-5.9 13.2-13.2c0-1.8-.4-3.7-1.1-5.4L512 424s128-88 128-200c0-88.4-71.6-160-160-160c-53.7 0-101.2 26.4-130.2 67c1.3 8.8 2.1 17.8 2.2 27c23.9-46.3 72.3-78 128-78c79.5 0 144 64.5 144 144c0 50.1-28.8 96.4-60 131.4c-15.3 17.3-30.7 31.2-42.3 40.8c-5.8 4.8-10.6 8.5-13.9 11c-1.7 1.2-2.9 2.2-3.8 2.8l-.9 .7-.2 .1 0 0 0 0 0 0 0 0-7.5 5.2H464.6l-7.5-5.2 0 0 0 0 0 0 0 0-.2-.1-.9-.7c-.8-.6-2.1-1.5-3.8-2.8c-3.3-2.5-8.1-6.2-13.9-11c-11.6-9.6-26.9-23.6-42.3-40.8c-28.6-32.2-55.3-73.8-59.4-119.2c-3.5 8.9-7.5 17.4-11.8 25.6zM462 432h2 32 2l28.4 64h-93L462 432zM96 152c0-30.9 25.1-56 56-56c4.4 0 8-3.6 8-8s-3.6-8-8-8c-39.8 0-72 32.2-72 72c0 4.4 3.6 8 8 8s8-3.6 8-8zm320 64c0-30.9 25.1-56 56-56c4.4 0 8-3.6 8-8s-3.6-8-8-8c-39.8 0-72 32.2-72 72c0 4.4 3.6 8 8 8s8-3.6 8-8z'
      
    ]
  };

  

  
  

  var faChartPieSimpleCircleDollar = {
    prefix: 'fat',
    iconName: 'chart-pie-simple-circle-dollar',
    icon: [
      640,
      512,
      [],
      'e605',
      
      'M272 240H375.2c-5.3 5-10.3 10.4-15 16H272c-8.8 0-16-7.2-16-16V17.7C256 8.1 263.4 0 273.1 0c116 0 212.7 82.7 234.4 192.4c-3.8-.2-7.6-.4-11.5-.4c-1.7 0-3.3 0-4.9 .1C469.5 91.4 380.1 16 273.1 16c-.1 0-.2 0-.3 0c-.1 0-.2 .1-.3 .2c-.3 .3-.5 .8-.5 1.4V240zm-32 48h99.2c-2.7 5.2-5.1 10.5-7.2 16H224c-8.8 0-16-7.2-16-16V66.7c0-10-8-15.3-14.5-13.9C92.1 74.2 16 164.3 16 272c0 123.7 100.3 224 224 224c40.1 0 77.8-10.6 110.4-29.1c3 4.5 6.3 8.8 9.7 12.9C324.8 500.3 283.8 512 240 512C107.5 512 0 404.5 0 272C0 156.5 81.5 60.1 190.2 37.2c18.1-3.8 33.8 11 33.8 29.5V272v16h16zM496 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm-28.2 93.9c-8 4.1-12.3 9.7-11.7 17.6c.4 5.2 3.6 9.5 11.5 13.5c7.9 4 18.3 6.8 30 10l1 .3c11.5 3.1 24.3 6.6 34.1 12.1c10.2 5.7 18.8 14.5 19.2 28.4c.5 16.4-8.9 27-20.4 33c-8.5 4.4-18.5 6.5-27.6 7.1v17.7c0 4.4-3.6 8-8 8s-8-3.6-8-8V439.4c-12.6-1.4-24.7-5.1-35.9-8.5l0 0c-2.1-.7-4.3-1.3-6.3-1.9c-4.2-1.3-6.7-5.7-5.4-9.9s5.7-6.7 9.9-5.4c2.3 .7 4.5 1.3 6.7 2l0 0 0 0c13.6 4.1 26.1 7.9 39.2 8.3c9.4 .3 20.1-1.4 28-5.5c7.6-3.9 12-9.6 11.7-18.3c-.2-6.2-3.6-10.7-11.1-14.9c-7.8-4.4-18.5-7.4-30.5-10.6l-1.8-.5c-11-2.9-22.9-6.1-32.3-11c-10.1-5.2-19.3-13.3-20.2-26.7c-1.1-16.5 8.9-27.1 20.4-32.9c8.5-4.3 18.5-6.5 27.4-7.3V280c0-4.4 3.6-8 8-8s8 3.6 8 8v16.4c10.2 .8 20.4 2.8 29.8 5c4.3 1 7 5.3 5.9 9.6s-5.3 7-9.6 5.9c-11.4-2.7-23.1-4.8-34.3-5c-8.8-.1-19.8 1.6-28.1 5.8z'
      
    ]
  };

  

  
  

  var faArrowUpWideShort = {
    prefix: 'fat',
    iconName: 'arrow-up-wide-short',
    icon: [
      576,
      512,
      ["sort-amount-up"],
      'f161',
      
      'M133.7 34.3c-3.1-3.1-8.2-3.1-11.3 0l-104 104c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L120 59.3V472c0 4.4 3.6 8 8 8s8-3.6 8-8V59.3l90.3 90.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-104-104zM296 464h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H296c-4.4 0-8 3.6-8 8s3.6 8 8 8zm0-144H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H296c-4.4 0-8 3.6-8 8s3.6 8 8 8zm0-128H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H296c-4.4 0-8 3.6-8 8s3.6 8 8 8zm0-128H568c4.4 0 8-3.6 8-8s-3.6-8-8-8H296c-4.4 0-8 3.6-8 8s3.6 8 8 8z'
      
    ]
  };

  
    var faSortAmountUp = faArrowUpWideShort;
  

  
  

  var faUtensils = {
    prefix: 'fat',
    iconName: 'utensils',
    icon: [
      448,
      512,
      [61685,127860,"cutlery"],
      'f2e7',
      
      'M41.3 .1c4.4 .7 7.3 4.8 6.6 9.2L24.8 148.1c-.5 3-.8 6.1-.8 9.2V168c0 30.9 25.1 56 56 56h64c30.9 0 56-25.1 56-56V157.3c0-3.1-.3-6.2-.8-9.2L176.1 9.3c-.7-4.4 2.2-8.5 6.6-9.2s8.5 2.2 9.2 6.6L215 145.5c.7 3.9 1 7.9 1 11.8V168c0 39.8-32.2 72-72 72H120V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V240H80c-39.8 0-72-32.2-72-72V157.3c0-4 .3-7.9 1-11.8L32.1 6.7C32.8 2.3 37-.6 41.3 .1zM88.4 0c4.4 .2 7.8 4 7.6 8.4l-8 160c-.2 4.4-4 7.8-8.4 7.6s-7.8-4-7.6-8.4l8-160c.2-4.4 4-7.8 8.4-7.6zm47.2 0c4.4-.2 8.2 3.2 8.4 7.6l8 160c.2 4.4-3.2 8.2-7.6 8.4s-8.2-3.2-8.4-7.6l-8-160c-.2-4.4 3.2-8.2 7.6-8.4zM304 176V304c0 17.7 14.3 32 32 32h80V24c0-4.4-3.6-8-8-8l0 0c-.1 0-1.9 .1-5.7 1.1c-3.5 .9-8.1 2.5-13.4 4.8c-10.6 4.6-23.5 12.2-36 23.8C328.2 68.6 304 108.3 304 176zM408 0c13.3 0 24 10.7 24 24V336v8 8V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V352H336c-26.5 0-48-21.5-48-48V176C288 32 392 0 408 0z'
      
    ]
  };

  
    var faCutlery = faUtensils;
  

  
  

  var faRotateRight = {
    prefix: 'fat',
    iconName: 'rotate-right',
    icon: [
      512,
      512,
      ["redo-alt","rotate-forward"],
      'f2f9',
      
      'M92.1 384.1c70.7 90.5 201.4 106.6 292 35.8c22.9-17.9 41.1-39.7 54.2-63.7c2.1-3.9 7-5.3 10.9-3.2s5.3 7 3.2 10.9c-14.2 25.8-33.7 49.3-58.4 68.6c-97.5 76.2-238.3 58.9-314.4-38.6S20.6 155.7 118.1 79.5c89.8-70.2 216.4-61 295.3 17.1l-11.3 11.3c-73.3-72.5-190.8-81-274.2-15.8c-90.5 70.7-106.6 201.4-35.8 292zM480 192c4.4 0 8-3.6 8-8V64c0-3.2-1.9-6.2-4.9-7.4s-6.4-.6-8.7 1.7l-120 120c-2.3 2.3-3 5.7-1.7 8.7s4.2 4.9 7.4 4.9H480zM360 208c-9.7 0-18.5-5.8-22.2-14.8s-1.7-19.3 5.2-26.2L463 47c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2V184c0 13.3-10.7 24-24 24H360z'
      
    ]
  };

  
    var faRedoAlt = faRotateRight;
  
    var faRotateForward = faRotateRight;
  

  
  

  var faArrowRightArrowLeft = {
    prefix: 'fat',
    iconName: 'arrow-right-arrow-left',
    icon: [
      448,
      512,
      [8644,"exchange"],
      'f0ec',
      
      'M445.7 133.7c3.1-3.1 3.1-8.2 0-11.3l-104-104c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L420.7 120 8 120c-4.4 0-8 3.6-8 8s3.6 8 8 8l412.7 0-90.3 90.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l104-104zM2.3 389.7l104 104c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L27.3 392 440 392c4.4 0 8-3.6 8-8s-3.6-8-8-8L27.3 376l90.3-90.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-104 104c-3.1 3.1-3.1 8.2 0 11.3z'
      
    ]
  };

  
    var faExchange = faArrowRightArrowLeft;
  

  
  

  var faGolfClub = {
    prefix: 'fat',
    iconName: 'golf-club',
    icon: [
      512,
      512,
      [],
      'f451',
      
      'M511.2 11.6c2-4 .4-8.8-3.6-10.7s-8.8-.4-10.7 3.6L309.6 378.8 50.4 308.8C25 301.9 0 321.1 0 347.4V384v64 24c0 22.1 17.9 40 40 40H226.3c21.2 0 40.6-12 50.1-31L321 391.8 511.2 11.6zM16 456H80c4.4 0 8-3.6 8-8s-3.6-8-8-8H16V392H80c4.4 0 8-3.6 8-8s-3.6-8-8-8H16V347.4c0-15.8 15-27.3 30.3-23.2l256.1 69.2-40.2 80.5c-6.8 13.6-20.6 22.1-35.8 22.1H40c-13.3 0-24-10.7-24-24V456z'
      
    ]
  };

  

  
  

  var faCastle = {
    prefix: 'fat',
    iconName: 'castle',
    icon: [
      640,
      512,
      [],
      'e0de',
      
      'M128 24c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24V72h24V24c0-13.3 10.7-24 24-24h24c13.3 0 24 10.7 24 24V72h32V24c0-13.3 10.7-24 24-24h24c13.3 0 24 10.7 24 24V72h24V24c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24V224h48V184c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24V440c0 39.8-32.2 72-72 72H72c-39.8 0-72-32.2-72-72V184c0-13.3 10.7-24 24-24H56c13.3 0 24 10.7 24 24v40h48V24zm8 216h-8H72c-4.4 0-8-3.6-8-8V184c0-4.4-3.6-8-8-8H24c-4.4 0-8 3.6-8 8V440c0 30.9 25.1 56 56 56H240V392c0-44.2 35.8-80 80-80s80 35.8 80 80V496H568c30.9 0 56-25.1 56-56V184c0-4.4-3.6-8-8-8H584c-4.4 0-8 3.6-8 8v48c0 4.4-3.6 8-8 8H512h-8H136zm360-16V24c0-4.4-3.6-8-8-8H456c-4.4 0-8 3.6-8 8V80c0 4.4-3.6 8-8 8H400c-4.4 0-8-3.6-8-8V24c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8V80c0 4.4-3.6 8-8 8H296c-4.4 0-8-3.6-8-8V24c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8V80c0 4.4-3.6 8-8 8H200c-4.4 0-8-3.6-8-8V24c0-4.4-3.6-8-8-8H152c-4.4 0-8 3.6-8 8V224H496zM384 392c0-35.3-28.7-64-64-64s-64 28.7-64 64V496H384V392z'
      
    ]
  };

  

  
  

  var faKiwiBird = {
    prefix: 'fat',
    iconName: 'kiwi-bird',
    icon: [
      576,
      512,
      [],
      'f535',
      
      'M192 400c-22.6 0-44.2-4.3-64-12V328c0-4.4-3.6-8-8-8s-8 3.6-8 8v52.8C55 351.7 16 292.4 16 224C16 126.8 94.8 48 192 48c37.3 0 71.8 11.6 100.3 31.4c33.8 23.5 74.6 48.6 121.3 48.6H464c53 0 96 43 96 96s-43 96-96 96H413.6c-46.7 0-87.5 25.2-121.3 48.6C263.8 388.4 229.3 400 192 400zM0 224c0 77.5 45.9 144.3 112 174.6V472c0 4.4 3.6 8 8 8s8-3.6 8-8V405.1c20 7.1 41.6 10.9 64 10.9c10.9 0 21.6-.9 32-2.7V472c0 4.4 3.6 8 8 8s8-3.6 8-8V410c22.3-5.7 43-15.4 61.4-28.2c33.8-23.5 71-45.8 112.1-45.8H464c6.3 0 12.4-.5 18.5-1.5L561 475.9c1.8 3.2 5.5 4.8 9 3.9s6-4.1 6-7.7V232h-.3c.2-2.6 .3-5.3 .3-8c0-61.9-50.1-112-112-112H413.6c-41.2 0-78.3-22.3-112.1-45.8C270.4 44.6 232.7 32 192 32C86 32 0 118 0 224zM560 441.1L498.6 330.6c25.9-8.4 47.6-25.9 61.4-48.8V441.1zM448 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faBlanketFire = {
    prefix: 'fat',
    iconName: 'blanket-fire',
    icon: [
      640,
      512,
      [],
      'e3da',
      
      'M16 88c0-39.8 32.2-72 72-72H360c39.8 0 72 32.2 72 72v41.5c5.2-1.3 10.6-1.8 16-1.3V88c0-48.6-39.4-88-88-88H88C39.4 0 0 39.4 0 88V352H.4c-.2 2.6-.4 5.3-.4 8c0 48.6 39.4 88 88 88H314.4c-3-5.2-5.8-10.5-8.3-16H88c-39.8 0-72-32.2-72-72s32.2-72 72-72H301.8c2.2-5.4 4.6-10.7 7.2-16H88c-29.8 0-56.1 14.8-72 37.4V88zM288 352H88c-4.4 0-8 3.6-8 8s3.6 8 8 8H288.8c-.5-5.3-.8-10.6-.8-16zM445.5 176c1.5 0 2.9 .5 4 1.5c16.1 14.6 31.3 30.1 45.6 46.8c6.6 7.6 18.4 7.5 24.8-.3c5.8-7 11.9-13.9 18.2-19.6c2.3-2.1 5.9-2.1 8.2 0c18.9 17.4 38.4 41.2 53.2 67.2c14.8 26.1 24.5 54 24.5 79.7c0 49.7-25.1 93.7-63.4 119.8c9.7-14 15.4-30.7 15.4-48.7c0-57.4-63.8-110.5-87.4-128.2c-5.2-3.9-12.1-3.9-17.3 0C447.8 312.1 384 365.2 384 422.6c0 18.2 5.8 35 15.7 49.2c-38.7-26-63.7-70.3-63.7-120.3c0-32.3 14.1-64.9 34.7-95.2c20.5-30.2 47-57.4 70.8-78.7c1.1-1 2.6-1.5 4.1-1.5zM480 496c-2.7 0-5.5-.1-8.2-.2c-41.2-3.8-71.8-36-71.8-73.2c0-23 13-47 31.1-68.7c17.3-20.7 37.4-37.2 48.9-45.9c11.5 8.7 31.6 25.2 48.9 45.9C547 375.5 560 399.5 560 422.6c0 37.2-30.6 69.4-71.7 73.2c-2.7 .2-5.5 .2-8.3 .2zM320 351.4c0 85.1 65.5 155.6 150.8 160.3c3 .3 6.1 .4 9.2 .4c3.2 0 6.3-.1 9.4-.4C573.7 506.9 640 436.5 640 351.4c0-29.5-11-60.1-26.6-87.6c-15.6-27.6-36.2-52.6-56.3-71.1c-8.4-7.7-21.4-7.8-29.8-.1c-7.1 6.5-13.8 14-19.7 21.3c0 0-.1 0-.1 .1s-.1 0-.1 0s-.1 0-.1 0l0 0s0 0 0 0s0 0 0 0c-14.8-17.2-30.5-33.2-47-48.3c-4.2-3.8-9.4-5.6-14.6-5.7c-5.3 0-10.6 1.8-14.9 5.6c-24.3 21.8-51.8 50-73.3 81.6C336 278.8 320 314.6 320 351.4z'
      
    ]
  };

  

  
  

  var faButter = {
    prefix: 'fat',
    iconName: 'butter',
    icon: [
      640,
      512,
      [129480],
      'e3e4',
      
      'M480 80V288H464V80H128c-26.5 0-48 21.5-48 48V288H64V128c0-35.3 28.7-64 64-64H464h8 8 32c35.3 0 64 28.7 64 64V288H560V128c0-26.5-21.5-48-48-48H480zM0 328c0-4.4 3.6-8 8-8H32 48 592h16 24c4.4 0 8 3.6 8 8s-3.6 8-8 8H608v64c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V336H8c-4.4 0-8-3.6-8-8zm48 8v64c0 17.7 14.3 32 32 32H560c17.7 0 32-14.3 32-32V336H48z'
      
    ]
  };

  

  
  

  var faHelmetBattle = {
    prefix: 'fat',
    iconName: 'helmet-battle',
    icon: [
      576,
      512,
      [],
      'f6eb',
      
      'M.8 218.8c-.5 2.2-.8 4.5-.8 6.8C0 242.4 13.6 256 30.4 256h2.2c17.1 0 31.3-13.2 32.5-30.2L80 17.1c.6-8.3-5.3-15.7-13.6-17s-16.1 4.1-18 12.2L.8 218.8zM64 16L49.1 224.6c-.6 8.7-7.8 15.4-16.5 15.4H30.4c-7.9 0-14.4-6.4-14.4-14.4c0-1.1 .1-2.2 .4-3.2L64 16zM224.6 507.7c4.8 2.8 10.3 4.3 15.9 4.3c17.4 0 31.5-14.1 31.5-31.5V296.4c0-19.6-11.9-37.2-30.1-44.5l-59.5-23.9c-3.9-1.6-6.5-5.4-6.5-9.6c0-5.7 4.6-10.3 10.3-10.3H389.7c5.7 0 10.3 4.6 10.3 10.3c0 4.2-2.6 8-6.5 9.6l-59.5 23.9c-18.2 7.3-30.1 24.9-30.1 44.5V480.5c0 17.4 14.1 31.5 31.5 31.5c5.6 0 11.1-1.5 15.9-4.3l149.2-87.2c9.2-5.6 13.5-16.7 10.6-27.1C494.1 333.6 480 270.2 480 208c0-85-89.1-149.2-153.1-189c-1.9-1.2-4-2.6-6.3-4.1C311.2 8.4 298.7 0 288 0s-23.2 8.4-32.7 14.9c-2.3 1.5-4.4 3-6.3 4.1C185.1 58.8 96 123 96 208c0 62.2-14.1 125.6-31.1 185.4c-3 10.4 1.4 21.4 10.6 27.1l149.2 87.2zM83.7 406.8c-3-1.9-4.4-5.5-3.4-9l0 0C97.4 337.6 112 272.4 112 208c0-36.7 19.2-70.2 48.1-100.4c28.8-30.1 65.7-55.3 97.4-75c2.2-1.3 4.6-3 6.9-4.6l0 0 0 0 1.8-1.2c3-2 6-4 8.9-5.7c6.5-3.8 10.7-5.1 12.8-5.1s6.3 1.3 12.8 5.1c3 1.7 5.9 3.7 8.9 5.7l1.8 1.2c2.3 1.6 4.8 3.2 6.9 4.6c31.7 19.8 68.6 44.9 97.4 75C444.8 137.8 464 171.3 464 208c0 64.4 14.6 129.6 31.7 189.8l0 0c1 3.4-.4 7.1-3.4 9l-149 87.1c-2.4 1.4-5.1 2.1-7.8 2.1c-8.5 0-15.5-6.9-15.5-15.5V296.4c0-13.1 7.9-24.8 20-29.7l59.5-23.9c10-4 16.5-13.7 16.5-24.4c0-14.6-11.8-26.3-26.3-26.3H186.3c-14.6 0-26.3 11.8-26.3 26.3c0 10.8 6.5 20.4 16.5 24.4L236 266.7c12.1 4.9 20 16.6 20 29.7V480.5c0 8.5-6.9 15.5-15.5 15.5c-2.7 0-5.4-.7-7.8-2.1l-149-87.1zM576 225.6c0-2.3-.3-4.6-.8-6.8L527.6 12.4c-1.9-8.1-9.7-13.5-18-12.2s-14.2 8.6-13.6 17l14.9 208.6c1.2 17 15.4 30.2 32.5 30.2h2.2c16.8 0 30.4-13.6 30.4-30.4zm-16.4-3.2c.2 1.1 .4 2.1 .4 3.2c0 7.9-6.4 14.4-14.4 14.4h-2.2c-8.7 0-15.9-6.7-16.5-15.4L512 16l47.6 206.4z'
      
    ]
  };

  

  
  

  var faCircleA = {
    prefix: 'fat',
    iconName: 'circle-a',
    icon: [
      512,
      512,
      [],
      'e0f7',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-400c-3 0-5.8 1.7-7.2 4.4l-120 240c-2 4-.4 8.8 3.6 10.7s8.8 .4 10.7-3.6L172.9 304H339.1l29.8 59.6c2 4 6.8 5.6 10.7 3.6s5.6-6.8 3.6-10.7l-120-240c-1.4-2.7-4.1-4.4-7.2-4.4zm0 25.9L331.1 288H180.9L256 137.9z'
      
    ]
  };

  

  
  

  var faDiceOne = {
    prefix: 'fat',
    iconName: 'dice-one',
    icon: [
      448,
      512,
      [9856],
      'f525',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM240 256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faPotato = {
    prefix: 'fat',
    iconName: 'potato',
    icon: [
      512,
      512,
      [129364],
      'e440',
      
      'M496 144c0-70.7-57.3-128-128-128c-35.4 0-67.5 14.4-90.6 37.6c-28.5 28.6-63.4 54.7-98.8 74c-21.4 11.8-39.2 29.5-50.9 50.9c-19.4 35.4-45.4 70.2-74 98.8C30.4 300.5 16 332.6 16 368c0 70.7 57.3 128 128 128c26.9 0 51.9-8.3 72.5-22.5c29.3-20.2 62.8-36.8 96.4-48.2c39.2-13.3 71.2-45.2 82.7-88.2c9.9-37.1 31.8-73.4 59.8-99.6c25-23.4 40.6-56.6 40.6-93.5zm16 0c0 41.5-17.6 78.9-45.7 105.2c-25.8 24.2-46.1 57.9-55.2 92.1c-12.9 48.3-49 84.3-93.1 99.2c-32.3 10.9-64.4 26.9-92.5 46.2C202.4 502.7 174.3 512 144 512C64.5 512 0 447.5 0 368c0-39.8 16.2-75.9 42.3-102C69.8 238.6 95 205 113.6 170.9c13.2-24.1 33.1-44 57.3-57.3C205 95 238.6 69.8 266 42.3C292.1 16.2 328.2 0 368 0c79.5 0 144 64.5 144 144zM176 256a16 16 0 1 1 0-32 16 16 0 1 1 0 32zM160 400a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM368 192a16 16 0 1 1 0-32 16 16 0 1 1 0 32z'
      
    ]
  };

  

  
  

  var faFileMedical = {
    prefix: 'fat',
    iconName: 'file-medical',
    icon: [
      384,
      512,
      [],
      'f477',
      
      'M64 496c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM168 232c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H224c-4.4 0-8 3.6-8 8v56c0 4.4-3.6 8-8 8H176c-4.4 0-8-3.6-8-8V352c0-4.4-3.6-8-8-8H104c-4.4 0-8-3.6-8-8V304c0-4.4 3.6-8 8-8h56c4.4 0 8-3.6 8-8V232zm8-24c-13.3 0-24 10.7-24 24v48H104c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h48v48c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V360h48c13.3 0 24-10.7 24-24V304c0-13.3-10.7-24-24-24H232V232c0-13.3-10.7-24-24-24H176z'
      
    ]
  };

  

  
  

  var faPipe = {
    prefix: 'fat',
    iconName: 'pipe',
    icon: [
      64,
      512,
      [],
      '7c',
      
      'M32 0c4.4 0 8 3.6 8 8V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V8c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faMoonOverSun = {
    prefix: 'fat',
    iconName: 'moon-over-sun',
    icon: [
      512,
      512,
      ["eclipse-alt"],
      'f74a',
      
      'M150.5 1.2c5-2.1 10.7-1.5 15.2 1.6L256 65.1 346.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6s8.6 6.6 9.6 11.9L391 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6l-7.4 3.1 7.4-3.1c2.1 5 1.5 10.7-1.6 15.2L446.9 256l62.3 90.3c3.1 4.5 3.7 10.2 1.6 15.2s-6.6 8.6-11.9 9.6L391 391 371.1 498.9c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6l3.1-7.4-3.1 7.4c-5-2.1-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121 140.9 13.1c1-5.3 4.6-9.8 9.6-11.9zM355.4 16L260.5 81.4c-2.7 1.9-6.3 1.9-9.1 0L156.6 16 135.8 129.3c-.6 3.3-3.2 5.8-6.4 6.4L16 156.6l65.4 94.9c1.9 2.7 1.9 6.3 0 9.1L16 355.4l113.3 20.8c3.3 .6 5.8 3.2 6.4 6.4L156.6 496l94.9-65.4c2.7-1.9 6.3-1.9 9.1 0L355.4 496l20.8-113.3c.6-3.3 3.2-5.8 6.4-6.4L496 355.4l-65.4-94.9c-1.9-2.7-1.9-6.3 0-9.1L496 156.6 382.7 135.8c-3.3-.6-5.8-3.2-6.4-6.4L355.4 16zM251.2 174.4c-43 2.9-77 38.3-77 81.6c0 45.1 36.9 81.8 82.6 81.8c17.8 0 34.3-5.6 47.8-15.1l-1.2 0c-46.3 0-83.9-37.2-83.9-83.2c0-26.4 12.4-49.8 31.7-65.1zm-93 81.6c0-54.1 44.3-97.8 98.6-97.8c2.8 0 5.6 .1 8.4 .3c5.3 .4 9.6 4.3 10.7 9.4s-1.3 10.4-5.9 13c-20.7 11.6-34.5 33.5-34.5 58.5c0 37 30.3 67.2 67.9 67.2c4 0 7.9-.3 11.7-1c5.2-.9 10.4 1.7 12.7 6.4s1.4 10.4-2.4 14.1c-17.8 17.1-42 27.6-68.7 27.6c-54.3 0-98.6-43.7-98.6-97.8zM256 112a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM384 256a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z'
      
    ]
  };

  
    var faEclipseAlt = faMoonOverSun;
  

  
  

  var faSeatAirline = {
    prefix: 'fat',
    iconName: 'seat-airline',
    icon: [
      448,
      512,
      [],
      'e244',
      
      'M16 8c0-4.4-3.6-8-8-8S0 3.6 0 8V142.8c0 12.5 2.7 24.8 7.8 36.2L95.7 373.6C107.3 399.4 133 416 161.3 416H232v80H104c-4.4 0-8 3.6-8 8s3.6 8 8 8H240 376c4.4 0 8-3.6 8-8s-3.6-8-8-8H248V416H364.7c24.5 0 46.1-15.9 53.5-39.3l29.5-94.3c.8-2.4 .3-5.1-1.2-7.1s-3.9-3.3-6.4-3.3H72c-1.5 0-2.9 .4-4.1 1.1L38.5 208H344c4.4 0 8-3.6 8-8s-3.6-8-8-8H32c-.3 0-.5 0-.8 0l-8.9-19.6C18.2 163.1 16 153 16 142.8V8zm94.3 359L74.6 288H429.1l-26.2 83.9c-5.2 16.7-20.7 28.1-38.2 28.1H161.3c-22 0-42-12.9-51-33z'
      
    ]
  };

  

  
  

  var faB = {
    prefix: 'fat',
    iconName: 'b',
    icon: [
      320,
      512,
      [98],
      '42',
      
      'M32 32C14.3 32 0 46.3 0 64V248 448c0 17.7 14.3 32 32 32H200c66.3 0 120-53.7 120-120c0-56.7-39.3-104.2-92.1-116.7C263.6 224.5 288 187.1 288 144c0-61.9-50.1-112-112-112H32zM176 240H16V64c0-8.8 7.2-16 16-16H176c53 0 96 43 96 96s-43 96-96 96zM16 256H176h24c57.4 0 104 46.6 104 104s-46.6 104-104 104H32c-8.8 0-16-7.2-16-16V256z'
      
    ]
  };

  

  
  

  var faSquareDownRight = {
    prefix: 'fat',
    iconName: 'square-down-right',
    icon: [
      448,
      512,
      [],
      'e26c',
      
      'M384 464c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384zm64-48c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416zM320 344V217c0-5-4-9-9-9c-2.4 0-4.7 .9-6.3 2.6l-35 35c-3.1 3.1-8.2 3.1-11.3 0L176 163.3c-2.1-2.1-5-3.3-8-3.3s-5.9 1.2-8 3.3L131.3 192c-2.1 2.1-3.3 5-3.3 8s1.2 5.9 3.3 8l82.3 82.3c3.1 3.1 3.1 8.2 0 11.3l-35 35c-1.7 1.7-2.6 4-2.6 6.3c0 5 4 9 9 9H312c4.4 0 8-3.6 8-8zm-8 24H185c-13.8 0-25-11.2-25-25c0-6.6 2.6-13 7.3-17.7L196.7 296 120 219.3c-5.1-5.1-8-12.1-8-19.3s2.9-14.2 8-19.3L148.7 152c5.1-5.1 12.1-8 19.3-8s14.2 2.9 19.3 8L264 228.7l29.4-29.4c4.7-4.7 11-7.3 17.7-7.3c13.8 0 25 11.2 25 25V344c0 13.3-10.7 24-24 24z'
      
    ]
  };

  

  
  

  var faLaptopMedical = {
    prefix: 'fat',
    iconName: 'laptop-medical',
    icon: [
      640,
      512,
      [],
      'f812',
      
      'M128 48H512c26.5 0 48 21.5 48 48V352h16V96c0-35.3-28.7-64-64-64H128C92.7 32 64 60.7 64 96V352H80V96c0-26.5 21.5-48 48-48zM620.8 400c1.8 0 3.2 1.4 3.2 3.2c0 33.6-27.2 60.8-60.8 60.8H76.8C43.2 464 16 436.8 16 403.2c0-1.8 1.4-3.2 3.2-3.2H620.8zM19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480H563.2c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2H19.2zM296 128c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H352c-4.4 0-8 3.6-8 8v56c0 4.4-3.6 8-8 8H304c-4.4 0-8-3.6-8-8V248c0-4.4-3.6-8-8-8H232c-4.4 0-8-3.6-8-8V200c0-4.4 3.6-8 8-8h56c4.4 0 8-3.6 8-8V128zm8-24c-13.3 0-24 10.7-24 24v48H232c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h48v48c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V256h48c13.3 0 24-10.7 24-24V200c0-13.3-10.7-24-24-24H360V128c0-13.3-10.7-24-24-24H304z'
      
    ]
  };

  

  
  

  var faFlyingDisc = {
    prefix: 'fat',
    iconName: 'flying-disc',
    icon: [
      448,
      512,
      [],
      'e3a9',
      
      'M413 67c21.1 21.1 25.8 60.5 8.3 113.1c-17.2 51.6-54.5 110.8-108.4 164.7s-113.2 91.3-164.7 108.4C95.5 470.8 56.1 466.1 35 445s-25.8-60.5-8.3-113.1c.2-.7 .5-1.5 .7-2.2c.8 15.3 5.7 32.9 20.3 47.5c20 20 45.9 21.8 63.4 19.8c18.1-2 36.3-8.8 52.8-17c33.6-16.6 70.7-44.5 105.1-78.9s62.2-71.5 78.9-105.1c8.2-16.6 14.9-34.7 17-52.8c2-17.5 .2-43.4-19.8-63.4c-14.5-14.5-32.2-19.4-47.5-20.3c.7-.3 1.5-.5 2.2-.7C352.4 41.2 391.9 45.9 413 67zM105.1 175.5C8.3 282-28.4 404.2 23.7 456.3C79 511.6 213.5 466.8 324.1 356.2S479.6 111 424.3 55.7C372.2 3.6 250 40.3 143.6 137c-6.7 6-13.3 12.3-19.8 18.8c-6.5 6.5-12.8 13.1-18.7 19.7zm11.9 10.7c5.8-6.4 11.9-12.8 18.2-19.1c6.3-6.3 12.7-12.4 19.1-18.3C182 124 210.3 104 236 91.3c15.7-7.8 32-13.7 47.5-15.4c15.2-1.7 35.2 .1 50.3 15.2s16.9 35.1 15.2 50.3c-1.8 15.5-7.7 31.8-15.4 47.5c-15.7 31.6-42.4 67.4-75.9 100.9s-69.2 60.2-100.9 75.9c-15.7 7.8-32 13.7-47.5 15.4c-15.2 1.7-35.2-.1-50.3-15.2S42.1 330.7 43.8 315.5c1.8-15.5 7.7-31.8 15.4-47.5C72 242.3 92 213.9 116.9 186.3z'
      
    ]
  };

  

  
  

  var faCalendarWeek = {
    prefix: 'fat',
    iconName: 'calendar-week',
    icon: [
      448,
      512,
      [],
      'f784',
      
      'M128 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H64C28.7 64 0 92.7 0 128v48 16V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 176 128c0-35.3-28.7-64-64-64H336V8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H128V8zM16 192H432V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V192zM112 80v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80H320v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80h48c26.5 0 48 21.5 48 48v48H16V128c0-26.5 21.5-48 48-48h48zM96 272H352c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V288c0-8.8 7.2-16 16-16zM64 288v64c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32z'
      
    ]
  };

  

  
  

  var faCarCircleBolt = {
    prefix: 'fat',
    iconName: 'car-circle-bolt',
    icon: [
      640,
      512,
      [],
      'e342',
      
      'M160.3 48H351.7c25 0 47 16.6 53.8 40.6L435.7 194c-6.4-1.3-12.9-2-19.7-2H96c-6.7 0-13.3 .7-19.7 2L106.4 88.6c6.9-24 28.8-40.6 53.8-40.6zM91 84.2L58 199.8C23.9 214.5 0 248.5 0 288v96 16 48c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V400H322.9c-1-5.3-1.7-10.6-2.2-16H96 80 16V288c0-44.2 35.8-80 80-80H416c2 0 4.1 .1 6.1 .2c9.9-4.6 20.3-8.3 31.2-11L421 84.2C412.1 53.3 383.9 32 351.7 32H160.3C128.1 32 99.9 53.3 91 84.2zM80 400v48c0 8.8-7.2 16-16 16H32c-8.8 0-16-7.2-16-16V400H80zM96 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm400-80a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm36.5-230.6c-3-2-6.9-1.8-9.7 .6l-112 96c-2.5 2.2-3.5 5.7-2.3 8.8s4.2 5.2 7.5 5.2h58.2l-17.8 53.5c-1.1 3.4 .1 7.2 3.1 9.2s6.9 1.8 9.7-.6l112-96c2.5-2.2 3.5-5.7 2.3-8.8s-4.2-5.2-7.5-5.2H517.8l17.8-53.5c1.1-3.4-.1-7.2-3.1-9.2zM437.6 376l73.7-63.1-12.2 36.6c-.8 2.4-.4 5.1 1.1 7.2s3.9 3.3 6.5 3.3h47.7l-73.7 63.1 12.2-36.6c.8-2.4 .4-5.1-1.1-7.2s-3.9-3.3-6.5-3.3H437.6z'
      
    ]
  };

  

  
  

  var faVectorCircle = {
    prefix: 'fat',
    iconName: 'vector-circle',
    icon: [
      512,
      512,
      [],
      'e2c6',
      
      'M272 16H240c-8.8 0-16 7.2-16 16V42.4s0 0 0 0V58.5s0 0 0 0V64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32c0-8.8-7.2-16-16-16zM208 45.4V32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V45.4C384.8 63.7 448.3 127.2 466.6 208H480c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H466.6C448.3 384.8 384.8 448.3 304 466.6V480c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V466.6C127.2 448.3 63.7 384.8 45.4 304H32c-17.7 0-32-14.3-32-32V240c0-17.7 14.3-32 32-32H45.4C63.7 127.2 127.2 63.7 208 45.4zM61.8 208H64c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H61.8C79.5 375.9 136.1 432.5 208 450.2V448c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v2.2c71.9-17.7 128.5-74.3 146.2-146.2H448c-17.7 0-32-14.3-32-32V240c0-17.7 14.3-32 32-32h2.2C432.5 136.1 375.9 79.5 304 61.8V64c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V61.8C136.1 79.5 79.5 136.1 61.8 208zm-3.3 80H64c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16H42.4s0 0 0 0H58.5s0 0 0 0zM224 469.6V480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V448c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v5.5s0 0 0 0v16.2s0 0 0 0zM469.6 288H480c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H448c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h5.5s0 0 0 0h16.2s0 0 0 0z'
      
    ]
  };

  

  
  

  var faHouse = {
    prefix: 'fat',
    iconName: 'house',
    icon: [
      576,
      512,
      [63498,63500,127968,"home","home-alt","home-lg-alt"],
      'f015',
      
      'M293.3 2c-3-2.7-7.6-2.7-10.6 0L2.7 250c-3.3 2.9-3.6 8-.7 11.3s8 3.6 11.3 .7L64 217.1V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V217.1L562.7 262c3.3 2.9 8.4 2.6 11.3-.7s2.6-8.4-.7-11.3L293.3 2zM80 448V202.9L288 18.7 496 202.9V448c0 26.5-21.5 48-48 48H368V328c0-13.3-10.7-24-24-24H232c-13.3 0-24 10.7-24 24V496H128c-26.5 0-48-21.5-48-48zm144 48V328c0-4.4 3.6-8 8-8H344c4.4 0 8 3.6 8 8V496H224z'
      
    ]
  };

  
    var faHome = faHouse;
  
    var faHomeAlt = faHouse;
  
    var faHomeLgAlt = faHouse;
  

  
  

  var faHeartCircleExclamation = {
    prefix: 'fat',
    iconName: 'heart-circle-exclamation',
    icon: [
      576,
      512,
      [],
      'e4fe',
      
      'M393.6 57.7c-42.9-5.6-85.8 12.6-111.2 47.6l-20 27.5c-1.5 2.1-3.9 3.3-6.5 3.3s-5-1.2-6.5-3.3l-20-27.5c-25.4-34.9-68.3-53.2-111.2-47.6C60.1 65.3 16 114.9 16 173.5c0 30.3 11.8 59.4 32.9 81.2L248 460.4c2.2 2.3 5.2 3.6 8.4 3.6s6.2-1.3 8.4-3.6l11-11.4c2.6 4.9 5.4 9.7 8.4 14.4l-7.8 8.1c-5.2 5.4-12.4 8.5-19.9 8.5c-7.5 0-14.7-3-19.9-8.4L37.4 265.8C13.4 241.1 0 208 0 173.5C0 106.8 50.2 50.4 116.3 41.8c48.6-6.3 97.4 14.3 126.2 54L256 114.4l13.5-18.6c28.9-39.7 77.6-60.4 126.2-54c66.1 8.6 116.3 65 116.3 131.8c0 12-1.6 23.9-4.8 35.3c-4.9-2.3-9.8-4.4-14.9-6.2c2.4-9.4 3.7-19.2 3.7-29C496 115 451.9 65.3 393.6 57.7zM560 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0-136c4.4 0 8 3.6 8 8v96c0 4.4-3.6 8-8 8s-8-3.6-8-8V288c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faCourtSport = {
    prefix: 'fat',
    iconName: 'court-sport',
    icon: [
      640,
      512,
      [],
      'e643',
      
      'M64 48C37.5 48 16 69.5 16 96v32H64c35.3 0 64 28.7 64 64V320c0 35.3-28.7 64-64 64H16v32c0 26.5 21.5 48 48 48H312V351.7c-49.3-4.1-88-45.3-88-95.7s38.7-91.6 88-95.7V48H64zM328 351.7V464H576c26.5 0 48-21.5 48-48V384H576c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64h48V96c0-26.5-21.5-48-48-48H328V160.3c49.3 4.1 88 45.3 88 95.7s-38.7 91.6-88 95.7zm0-175.3V335.6c40.4-4 72-38.1 72-79.6s-31.6-75.6-72-79.6zm-16 0c-40.4 4-72 38.1-72 79.6s31.6 75.6 72 79.6V176.4zM16 144V368H64c26.5 0 48-21.5 48-48V192c0-26.5-21.5-48-48-48H16zM576 368h48V144H576c-26.5 0-48 21.5-48 48V320c0 26.5 21.5 48 48 48zM0 96C0 60.7 28.7 32 64 32H576c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z'
      
    ]
  };

  

  
  

  var faOutdent = {
    prefix: 'fat',
    iconName: 'outdent',
    icon: [
      448,
      512,
      ["dedent"],
      'f03b',
      
      'M0 64c0 4.4 3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H8c-4.4 0-8 3.6-8 8zM192 192c0 4.4 3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H200c-4.4 0-8 3.6-8 8zm8 120c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H200zM0 448c0 4.4 3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H8c-4.4 0-8 3.6-8 8zM17.2 256L112 177.9l0 156.2L17.2 256zM7 243.6C-.8 250-.8 262 7 268.4l94.8 78.1c10.4 8.6 26.2 1.2 26.2-12.4V177.9c0-13.5-15.7-20.9-26.2-12.4L7 243.6z'
      
    ]
  };

  
    var faDedent = faOutdent;
  

  
  

  var faFaceWorried = {
    prefix: 'fat',
    iconName: 'face-worried',
    icon: [
      512,
      512,
      [],
      'e3a3',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM311.7 422.3c-17.1-6.4-35.9-10-55.7-10c-19.8 0-38.6 3.6-55.7 9.9c-8.7 3.3-18.2 1.7-24.7-3.3c-3.3-2.6-6-6.2-7.1-10.7c-1.1-4.6-.4-9.4 2-13.8c16-30 48.3-50.4 85.4-50.4c37.1 0 69.5 20.4 85.5 50.5c2.4 4.5 3.1 9.3 2 13.8c-1.1 4.5-3.8 8.1-7.1 10.7c-6.5 5-16 6.6-24.7 3.3zM327.4 402c-13.2-24.9-40.1-42-71.3-42c-31.2 0-58.1 17.1-71.3 42c-.7 1.4-.7 2.2-.6 2.6c.1 .4 .4 1.1 1.3 1.8c1.9 1.5 5.5 2.4 9.3 1c18.9-7.1 39.6-11 61.3-11c21.7 0 42.5 3.9 61.3 11c3.8 1.4 7.4 .5 9.3-.9c.9-.7 1.2-1.4 1.3-1.8c.1-.4 .2-1.2-.6-2.6zm-167-130a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM200 135.5c.3 4.4-3.1 8.2-7.5 8.5c-32.5 2-61.6 16.5-82.7 38.7c-3 3.2-8.1 3.3-11.3 .3s-3.3-8.1-.3-11.3c23.7-25.1 56.6-41.4 93.3-43.7c4.4-.3 8.2 3.1 8.5 7.5zM319.5 144c-4.4-.3-7.8-4.1-7.5-8.5s4.1-7.8 8.5-7.5c36.7 2.3 69.6 18.6 93.3 43.7c3 3.2 2.9 8.3-.3 11.3s-8.3 2.9-11.3-.3C381.1 160.5 352 146 319.5 144z'
      
    ]
  };

  

  
  

  var faFaceDotted = {
    prefix: 'fat',
    iconName: 'face-dotted',
    icon: [
      512,
      512,
      [129765],
      'e47f',
      
      'M256 0c-19.6 0-38.7 2.2-57 6.4c-4.3 1-7 5.3-6 9.6s5.3 7 9.6 6c17.2-3.9 35.1-6 53.4-6s36.3 2.1 53.4 6c4.3 1 8.6-1.7 9.6-6s-1.7-8.6-6-9.6C294.7 2.2 275.6 0 256 0zM128.3 52.8c3.7-2.4 4.9-7.3 2.5-11s-7.3-4.9-11-2.5C87.3 59.7 59.7 87.3 39.2 119.8c-2.4 3.7-1.2 8.7 2.5 11s8.7 1.2 11-2.5c19.2-30.5 45.1-56.4 75.5-75.5zM392.2 39.2c-3.7-2.4-8.7-1.2-11 2.5s-1.2 8.7 2.5 11c30.5 19.2 56.4 45.1 75.6 75.5c2.4 3.7 7.3 4.9 11 2.5s4.9-7.3 2.5-11c-20.5-32.5-48.1-60.1-80.6-80.6zM22 202.6c1-4.3-1.7-8.6-6-9.6s-8.6 1.7-9.6 6C2.2 217.3 0 236.4 0 256s2.2 38.7 6.4 57c1 4.3 5.3 7 9.6 6s7-5.3 6-9.6c-3.9-17.2-6-35.1-6-53.4s2.1-36.3 6-53.4zM505.6 199c-1-4.3-5.3-7-9.6-6s-7 5.3-6 9.6c3.9 17.2 6 35.1 6 53.4s-2.1 36.3-6 53.4c-1 4.3 1.7 8.6 6 9.6s8.6-1.7 9.6-6c4.2-18.3 6.4-37.4 6.4-57s-2.2-38.7-6.4-57zM52.8 383.7c-2.4-3.7-7.3-4.9-11-2.5s-4.9 7.3-2.5 11c20.5 32.5 48.1 60.1 80.6 80.6c3.7 2.4 8.7 1.2 11-2.5s1.2-8.7-2.5-11c-30.5-19.2-56.4-45.1-75.5-75.6zm420 8.5c2.4-3.7 1.2-8.7-2.5-11s-8.7-1.2-11 2.5c-19.2 30.5-45.1 56.4-75.6 75.6c-3.7 2.4-4.9 7.3-2.5 11s7.3 4.9 11 2.5c32.5-20.5 60.1-48.1 80.6-80.6zM202.6 490c-4.3-1-8.6 1.7-9.6 6s1.7 8.6 6 9.6c18.3 4.2 37.4 6.4 57 6.4s38.7-2.2 57-6.4c4.3-1 7-5.3 6-9.6s-5.3-7-9.6-6c-17.2 3.9-35.1 6-53.4 6s-36.3-2.1-53.4-6zM176.4 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm176-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM184 344c-4.4 0-8 3.6-8 8s3.6 8 8 8H328c4.4 0 8-3.6 8-8s-3.6-8-8-8H184z'
      
    ]
  };

  

  
  

  var faIdCard = {
    prefix: 'fat',
    iconName: 'id-card',
    icon: [
      576,
      512,
      [62147,"drivers-license"],
      'f2c2',
      
      'M64 48C37.5 48 16 69.5 16 96v16H560V96c0-26.5-21.5-48-48-48H64zM16 128V416c0 26.5 21.5 48 48 48H512c26.5 0 48-21.5 48-48V128H16zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM192 288a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-112a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM152 352c-30.9 0-56 25.1-56 56c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-39.8 32.2-72 72-72h80c39.8 0 72 32.2 72 72c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-30.9-25.1-56-56-56H152zM352 232c0-4.4 3.6-8 8-8H504c4.4 0 8 3.6 8 8s-3.6 8-8 8H360c-4.4 0-8-3.6-8-8zm0 64c0-4.4 3.6-8 8-8H504c4.4 0 8 3.6 8 8s-3.6 8-8 8H360c-4.4 0-8-3.6-8-8zm0 64c0-4.4 3.6-8 8-8H504c4.4 0 8 3.6 8 8s-3.6 8-8 8H360c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  
    var faDriversLicense = faIdCard;
  

  
  

  var faBookSkull = {
    prefix: 'fat',
    iconName: 'book-skull',
    icon: [
      448,
      512,
      ["book-dead"],
      'f6b7',
      
      'M56 0C25.1 0 0 25.1 0 56V456c0 30.9 25.1 56 56 56H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H416V415.2c18.3-3.7 32-19.8 32-39.2V40c0-22.1-17.9-40-40-40H56zM400 416v80H56c-22.1 0-40-17.9-40-40s17.9-40 40-40H400zM56 400c-15.7 0-29.8 6.4-40 16.8V56c0-22.1 17.9-40 40-40H408c13.3 0 24 10.7 24 24V376c0 13.3-10.7 24-24 24H56zm73-171.8c-2.1 3.9-.6 8.7 3.3 10.8l90.9 49-90.9 49c-3.9 2.1-5.3 6.9-3.3 10.8s6.9 5.3 10.8 3.3l100.2-54 100.2 54c3.9 2.1 8.7 .6 10.8-3.3s.6-8.7-3.3-10.8l-90.9-49 90.9-49c3.9-2.1 5.3-6.9 3.3-10.8s-6.9-5.3-10.8-3.3L240 278.9 139.8 225c-3.9-2.1-8.7-.6-10.8 3.3zM168 136c0-29.4 30.5-56 72-56s72 26.6 72 56c0 17.5-10.5 33.8-28.1 44.3c-2.4 1.4-3.9 4-3.9 6.9V200c0 4.4-3.6 8-8 8H208c-4.4 0-8-3.6-8-8V187.2c0-2.8-1.5-5.4-3.9-6.9C178.5 169.8 168 153.5 168 136zm72-72c-46.8 0-88 30.7-88 72c0 22.9 12.9 42.7 32 55.6V200c0 13.3 10.7 24 24 24h64c13.3 0 24-10.7 24-24v-8.4c19.1-12.9 32-32.7 32-55.6c0-41.3-41.2-72-88-72zm-32 88a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  
    var faBookDead = faBookSkull;
  

  
  

  var faAlignCenter = {
    prefix: 'fat',
    iconName: 'align-center',
    icon: [
      448,
      512,
      [],
      'f037',
      
      'M104 56c-4.4 0-8 3.6-8 8s3.6 8 8 8H344c4.4 0 8-3.6 8-8s-3.6-8-8-8H104zM8 184c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zM96 320c0 4.4 3.6 8 8 8H344c4.4 0 8-3.6 8-8s-3.6-8-8-8H104c-4.4 0-8 3.6-8 8zM8 440c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H8z'
      
    ]
  };

  

  
  

  var faFaceMeh = {
    prefix: 'fat',
    iconName: 'face-meh',
    icon: [
      512,
      512,
      [128528,"meh"],
      'f11a',
      
      'M496 256A240 240 0 1 1 16 256a240 240 0 1 1 480 0zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM176.4 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm176-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM168 344c-4.4 0-8 3.6-8 8s3.6 8 8 8H344c4.4 0 8-3.6 8-8s-3.6-8-8-8H168z'
      
    ]
  };

  
    var faMeh = faFaceMeh;
  

  
  

  var faCodePullRequestClosed = {
    prefix: 'fat',
    iconName: 'code-pull-request-closed',
    icon: [
      512,
      512,
      [],
      'e3f9',
      
      'M112 16a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm8 111.5c31.6-3.9 56-30.9 56-63.5c0-35.3-28.7-64-64-64S48 28.7 48 64c0 32.6 24.4 59.6 56 63.5v257c-31.6 3.9-56 30.9-56 63.5c0 35.3 28.7 64 64 64s64-28.7 64-64c0-32.6-24.4-59.6-56-63.5v-257zM330.3 10.3c-3.1 3.1-3.1 8.2 0 11.3L388.7 80l-58.3 58.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L400 91.3l58.3 58.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L411.3 80l58.3-58.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L400 68.7 341.7 10.3c-3.1-3.1-8.2-3.1-11.3 0zM64 448a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112c35.3 0 64-28.7 64-64c0-32.6-24.4-59.6-56-63.5V200c0-4.4-3.6-8-8-8s-8 3.6-8 8V384.5c-31.6 3.9-56 30.9-56 63.5c0 35.3 28.7 64 64 64z'
      
    ]
  };

  

  
  

  var faMobile = {
    prefix: 'fat',
    iconName: 'mobile',
    icon: [
      384,
      512,
      [128241,"mobile-android","mobile-phone"],
      'f3ce',
      
      'M96 16C69.5 16 48 37.5 48 64V448c0 26.5 21.5 48 48 48H288c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H96zM32 64C32 28.7 60.7 0 96 0H288c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V64zM144 432h96c4.4 0 8 3.6 8 8s-3.6 8-8 8H144c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  
    var faMobileAndroid = faMobile;
  
    var faMobilePhone = faMobile;
  

  
  

  var faUserPilot = {
    prefix: 'fat',
    iconName: 'user-pilot',
    icon: [
      448,
      512,
      [],
      'e2c0',
      
      'M222.1 16.2L62.2 52.1c-2.8 .6-5.1 2.8-5.9 5.6s-.1 5.8 2 7.9L87.5 95.1c1.5 1.5 2.3 3.5 2.3 5.6v26.9c18.1 11.7 55.9 32.2 134.1 32.2s116.1-20.5 134.1-32.2V100.7c0-2.1 .8-4.1 2.3-5.6l29.1-29.5c2-2.1 2.8-5.1 2-7.9s-3.1-4.9-5.9-5.6l-159.9-36c-1.2-.3-2.4-.3-3.5 0zm7-15.6L389 36.5c8.5 1.9 15.3 8.3 17.8 16.7s.2 17.4-6 23.6L374 104v23.6c0 5.3-2.6 10.3-7.2 13.3c-20.4 13.3-61.3 34.9-142.9 34.9s-122.5-21.6-142.9-34.9c-4.6-3-7.2-8-7.2-13.3V104L46.9 76.8c-6.1-6.2-8.4-15.2-6-23.6s9.3-14.8 17.8-16.7L218.6 .6c3.5-.8 7.1-.8 10.5 0zM213.5 444l-86.6-75.8C65 372.1 16 423.5 16 486.4c0 5.3 4.3 9.6 9.6 9.6H216V446.3l-2.5-2.2zm208.9 68H224.2l-.2 0-.2 0H25.6C11.5 512 0 500.5 0 486.4C0 412.8 59.2 353 132.6 352L224 432l91.4-80C388.8 353 448 412.8 448 486.4c0 14.1-11.5 25.6-25.6 25.6zM232 446.3V496H422.4c5.3 0 9.6-4.3 9.6-9.6c0-62.8-49-114.3-110.8-118.2L234.5 444l-2.5 2.2zm88-6.3c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H328c-4.4 0-8-3.6-8-8zM96 192c0-2.9 .1-5.8 .3-8.7c4.8 2.3 10.1 4.5 15.7 6.7c0 .7 0 1.3 0 2c0 61.9 50.1 112 112 112s112-50.1 112-112c0-.7 0-1.3 0-2c5.7-2.2 10.9-4.4 15.7-6.7c.2 2.9 .3 5.8 .3 8.7c0 70.7-57.3 128-128 128s-128-57.3-128-128zM163.6 64.8L224 95.1l60.4-30.2c4-2 8.8-.4 10.7 3.6s.4 8.8-3.6 10.7l-64 32c-2.3 1.1-4.9 1.1-7.2 0l-64-32c-4-2-5.6-6.8-3.6-10.7s6.8-5.6 10.7-3.6z'
      
    ]
  };

  

  
  

  var faForward = {
    prefix: 'fat',
    iconName: 'forward',
    icon: [
      512,
      512,
      [9193],
      'f04e',
      
      'M254 80c3 0 5.8 .9 8.2 2.7L492.7 249.5c2.1 1.5 3.3 3.9 3.3 6.5s-1.2 5-3.3 6.5L262.3 429.3c-2.4 1.7-5.3 2.7-8.2 2.7c-7.8 0-14-6.3-14-14V94c0-7.8 6.3-14 14-14zm0-16c-16.6 0-30 13.5-30 30V197.4L47.7 69.7C42.5 66 36.4 64 30 64C13.5 64 0 77.5 0 94V418c0 16.6 13.5 30 30 30c6.3 0 12.5-2 17.6-5.7L224 314.6V418c0 16.6 13.5 30 30 30c6.3 0 12.5-2 17.6-5.7L502.1 275.4c6.2-4.5 9.9-11.7 9.9-19.4s-3.7-14.9-9.9-19.4L271.7 69.7C266.5 66 260.4 64 254 64zM224 294.8L38.3 429.3C35.9 431.1 33 432 30 432c-7.8 0-14-6.3-14-14V94c0-7.8 6.3-14 14-14c3 0 5.8 .9 8.2 2.7L224 217.2v77.7z'
      
    ]
  };

  

  
  

  var faLoader = {
    prefix: 'fat',
    iconName: 'loader',
    icon: [
      512,
      512,
      [],
      'e1d4',
      
      'M264 8V96c0 4.4-3.6 8-8 8s-8-3.6-8-8V8c0-4.4 3.6-8 8-8s8 3.6 8 8zm0 408v88c0 4.4-3.6 8-8 8s-8-3.6-8-8V416c0-4.4 3.6-8 8-8s8 3.6 8 8zM-8 256c0-4.4 3.6-8 8-8H96c4.4 0 8 3.6 8 8s-3.6 8-8 8H0c-4.4 0-8-3.6-8-8zm424-8h88c4.4 0 8 3.6 8 8s-3.6 8-8 8H416c-4.4 0-8-3.6-8-8s3.6-8 8-8zM435.8 77.8c3.1 3.1 3.1 8.2 0 11.3l-62.2 62.2c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l62.2-62.2c3.1-3.1 8.2-3.1 11.3 0zM147.3 377.6L85.1 439.8c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L136 366.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3zM68.2 72.2c3.1-3.1 8.2-3.1 11.3 0L147.3 140c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L68.2 83.5c-3.1-3.1-3.1-8.2 0-11.3zM373.6 366.3l62.2 62.2c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-62.2-62.2c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0z'
      
    ]
  };

  

  
  

  var faGlass = {
    prefix: 'fat',
    iconName: 'glass',
    icon: [
      384,
      512,
      [129371],
      'f804',
      
      'M16.1 33.3C15.4 24 22.7 16 32.1 16H352c9.4 0 16.7 8 15.9 17.3L361.5 112H22.6L16.1 33.3zM23.9 128H360.2l-27 331.2c-1.7 20.8-19 36.8-39.9 36.8H90.7c-20.8 0-38.2-16-39.9-36.8L23.9 128zM32.1 0C13.4 0-1.3 16 .2 34.6l34.7 426C37.3 489.6 61.6 512 90.7 512H293.3c29.2 0 53.4-22.4 55.8-51.4l34.7-426C385.4 16 370.7 0 352 0H32.1z'
      
    ]
  };

  

  
  

  var faFileCircleCheck = {
    prefix: 'fat',
    iconName: 'file-circle-check',
    icon: [
      576,
      512,
      [],
      'e5a0',
      
      'M64 496H311.2c5.8 5.5 12 10.6 18.5 15.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H204.1c12.7 0 24.9 5.1 33.9 14.1L369.9 145.9c9 9 14.1 21.2 14.1 33.9v18.7c-5.4 1.5-10.8 3.3-16 5.4V179.9c0-1.3-.1-2.6-.2-3.9H248c-22.1 0-40-17.9-40-40V16.2c-1.3-.2-2.6-.2-3.9-.2H64C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48zM361.1 160c-.8-1-1.6-1.9-2.4-2.7L226.7 25.4c-.9-.9-1.8-1.7-2.7-2.4V136c0 13.3 10.7 24 24 24H361.1zM432 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm69.7 98.3c3.1 3.1 3.1 8.2 0 11.3l-80 80c-3.1 3.1-8.2 3.1-11.3 0l-48-48c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L416 396.7l74.3-74.3c3.1-3.1 8.2-3.1 11.3 0z'
      
    ]
  };

  

  
  

  var faRotateExclamation = {
    prefix: 'fat',
    iconName: 'rotate-exclamation',
    icon: [
      512,
      512,
      [],
      'e23c',
      
      'M256 48c65.3 0 123.6 30.1 161.7 77.2L456 176H376c-4.4 0-8 3.6-8 8s3.6 8 8 8h96c4.4 0 8-3.6 8-8V88c0-4.4-3.6-8-8-8s-8 3.6-8 8v72.1l-33.6-44.6 0 0-.2-.2C389.2 64.5 326.4 32 256 32C155.4 32 70.3 98.3 42 189.6c-1.3 4.2 1.1 8.7 5.3 10s8.7-1.1 10-5.3C83.5 109.6 162.6 48 256 48zm8 88c0-4.4-3.6-8-8-8s-8 3.6-8 8V296c0 4.4 3.6 8 8 8s8-3.6 8-8V136zm-8 232a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM32 424c0 4.4 3.6 8 8 8s8-3.6 8-8V349.8l35.2 46.8 0 0 .2 .2C124.4 447.5 187.2 480 257.6 480c100.6 0 185.7-66.3 214-157.6c1.3-4.2-1.1-8.7-5.3-10s-8.7 1.1-10 5.3C430.1 402.4 351 464 257.6 464c-65.3 0-123.6-30.1-161.7-77.2L57.7 336H136c4.4 0 8-3.6 8-8s-3.6-8-8-8H40c-4.4 0-8 3.6-8 8v96z'
      
    ]
  };

  

  
  

  var faScribble = {
    prefix: 'fat',
    iconName: 'scribble',
    icon: [
      512,
      512,
      [],
      'e23f',
      
      'M210 17.5C222.1 6.2 238 0 254.6 0h.9C291.1 0 320 28.9 320 64.6c0 17.1-6.8 33.5-18.9 45.7L62.2 349.1C53.1 358.2 48 370.6 48 383.4C48 410.3 69.7 432 96.6 432c12.9 0 25.2-5.1 34.3-14.2L401.8 146.9c12.1-12.1 28.5-18.9 45.7-18.9c35.7 0 64.6 28.9 64.6 64.6c0 17.1-6.8 33.5-18.9 45.7L356.9 374.5c-13.4 13.4-20.9 31.5-20.9 50.3v2.6c0 37.9 30.7 68.6 68.6 68.6c11.2 0 22.3-3.1 31.9-8.8l63.4-38c3.8-2.3 8.7-1 11 2.7s1 8.7-2.7 11l-63.4 38c-12.1 7.3-26 11.1-40.2 11.1c-46.7 0-84.6-37.9-84.6-84.6v-2.6c0-23.1 9.2-45.3 25.5-61.7L481.8 226.9c9.1-9.1 14.2-21.5 14.2-34.3c0-26.8-21.7-48.6-48.6-48.6c-12.9 0-25.2 5.1-34.3 14.2L142.2 429.1C130.1 441.2 113.7 448 96.6 448C60.9 448 32 419.1 32 383.4c0-17.1 6.8-33.5 18.9-45.7L289.8 98.9c9.1-9.1 14.2-21.5 14.2-34.3C304 37.7 282.3 16 255.4 16h-.9c-12.5 0-24.5 4.7-33.6 13.2L13.4 221.9c-3.2 3-8.3 2.8-11.3-.4s-2.8-8.3 .4-11.3L210 17.5z'
      
    ]
  };

  

  
  

  var faCommentsQuestion = {
    prefix: 'fat',
    iconName: 'comments-question',
    icon: [
      640,
      512,
      [],
      'e14e',
      
      'M208 16C99.4 16 16 90 16 176c0 36.1 15.1 68.8 38.9 96.5c1.9 2.2 2.4 5.3 1.4 8c-8 21.5-21.4 41.2-40.2 55.4L16 336c28.8 0 57.3-10.1 83.4-23.9c2.3-1.2 5-1.2 7.3-.1c31.7 15.7 65.9 24 101.3 24c108.6 0 192-74 192-160s-83.4-160-192-160zM0 176C0 78.8 93.1 0 208 0S416 78.8 416 176s-93.1 176-208 176c-36.5 0-71.9-8.4-104.7-23.9C76.8 341.7 47 352 16 352c-6.9 0-13.1-4.5-15.2-11.1c-2.1-6.6 .2-13.7 5.7-17.8c14.7-11.2 25.9-26.6 33.1-43.9C15.7 250.1 0 215.2 0 176zm448 0c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 39.2-15.7 74.1-39.6 103.2c7.2 17.3 18.4 32.7 33.1 43.9c5.5 4.1 7.9 11.3 5.7 17.8c-2.1 6.6-8.3 11.1-15.2 11.1c-31 0-60.8-10.3-87.3-23.9C503.9 503.6 468.5 512 432 512c-95.7 0-176.2-54.6-200.5-129c5.5-.5 10.9-1.1 16.3-1.9C271 446.3 343 496 432 496c35.3 0 69.6-8.4 101.3-24c2.3-1.1 5-1.1 7.3 .1C566.7 485.9 595.2 496 624 496l-.1-.1c-18.7-14.2-32.2-33.9-40.2-55.4c-1-2.7-.5-5.8 1.4-8C608.9 404.9 624 372.1 624 336c0-81.7-75.3-152.6-176-159.5l0-.5zM143.3 125c0-23.2 18.8-42 42-42h39.8c26.2 0 47.5 21.3 47.5 47.5c0 16-8 30.9-21.4 39.7L216 193.4V210c0 4.4-3.6 8-8 8s-8-3.6-8-8V189.1c0-2.7 1.4-5.2 3.6-6.7l38.9-25.6c8.8-5.8 14.2-15.7 14.2-26.3c0-17.4-14.1-31.5-31.5-31.5H185.3c-14.4 0-26 11.6-26 26l0 4.6c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-4.6zm53.3 119a11.3 11.3 0 1 1 22.7 0 11.3 11.3 0 1 1 -22.7 0z'
      
    ]
  };

  

  
  

  var faCommentCaptions = {
    prefix: 'fat',
    iconName: 'comment-captions',
    icon: [
      512,
      512,
      [],
      'e146',
      
      'M157.3 415c-5-1.8-10.6-1-14.9 2.1c-11 8-29.4 19.3-51.2 28.8C68.3 456 41.6 464 16 464l.1-.1 0 0 0 0 .3-.3 .1-.1c.4-.4 .9-.9 1.5-1.6c1.3-1.4 3.2-3.6 5.4-6.3l-12.2-10 12.2 10C28 450 34 442 40 432c10.7-17.9 21.4-42.1 23.6-69.9c.3-4.3-1.1-8.6-3.9-11.8C31.9 318.8 16 280.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-35.2 0-68.6-6.1-98.7-17zM4.7 452.7l0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0zM72 240c-4.4 0-8 3.6-8 8s3.6 8 8 8H312c4.4 0 8-3.6 8-8s-3.6-8-8-8H72zm304 0c-4.4 0-8 3.6-8 8s3.6 8 8 8h64c4.4 0 8-3.6 8-8s-3.6-8-8-8H376zM104 304c-4.4 0-8 3.6-8 8s3.6 8 8 8h64c4.4 0 8-3.6 8-8s-3.6-8-8-8H104zm128 0c-4.4 0-8 3.6-8 8s3.6 8 8 8H408c4.4 0 8-3.6 8-8s-3.6-8-8-8H232z'
      
    ]
  };

  

  
  

  var faEyeDropper = {
    prefix: 'fat',
    iconName: 'eye-dropper',
    icon: [
      512,
      512,
      ["eye-dropper-empty","eyedropper"],
      'f1fb',
      
      'M211.8 159.1l11.3 11.3L341.6 288.9l11.3 11.3 25.4 25.4 0 0c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-14.1-14.1-11.3-11.3 11.3-11.3L482.8 170.4c39-39 39-102.2 0-141.1s-102.2-39-141.1 0L234.4 136.5l-11.3 11.3-11.3-11.3-14.1-14.1c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l25.4 25.4zm259.7 0L352.9 277.6 234.4 159.1 352.9 40.5c32.7-32.7 85.8-32.7 118.5 0l11-11-11 11c32.7 32.7 32.7 85.8 0 118.5zM197.7 205.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L53.1 327.6C39.6 341.1 32 359.4 32 378.5v51.1L4.4 470.9C1.5 475.3 0 480.4 0 485.6C0 500.2 11.8 512 26.4 512c5.2 0 10.3-1.5 14.7-4.4L82.4 480h51.1c19.1 0 37.4-7.6 50.9-21.1L317.7 325.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L173.1 447.6c-10.5 10.5-24.7 16.4-39.6 16.4H80 77.6l-2 1.3L32.2 494.2c-1.7 1.1-3.7 1.8-5.8 1.8c-5.8 0-10.4-4.7-10.4-10.4c0-2.1 .6-4.1 1.8-5.8l28.9-43.4 1.3-2V432 378.5c0-14.9 5.9-29.1 16.4-39.6L197.7 205.7z'
      
    ]
  };

  
    var faEyeDropperEmpty = faEyeDropper;
  
    var faEyedropper = faEyeDropper;
  

  
  

  var faCloudBinary = {
    prefix: 'fat',
    iconName: 'cloud-binary',
    icon: [
      640,
      512,
      [],
      'e601',
      
      'M522.7 220.8c3.4-8.9 5.3-18.6 5.3-28.8c0-44.2-35.8-80-80-80c-16.5 0-31.7 5-44.4 13.5c-3.7 2.5-8.2 3.3-12.5 2.3s-8-3.8-10.2-7.6C355.9 77 309.3 48 256 48c-79.5 0-144 64.5-144 144c0 2.5 .1 4.9 .2 7.3c.4 7.1-4 13.5-10.7 15.9C51.7 232.7 16 280.2 16 336c0 70.7 57.3 128 128 128H512c61.9 0 112-50.1 112-112c0-54.2-38.5-99.4-89.6-109.8c-4.6-.9-8.6-3.9-10.9-8s-2.6-9.1-.9-13.4zM256 32c53.6 0 101 26.3 130 66.7c3.1 4.3 6 8.8 8.7 13.4c3.5-2.4 7.2-4.5 11-6.4C418.5 99.5 432.8 96 448 96c53 0 96 43 96 96c0 6.6-.7 13-1.9 19.2c-1.1 5.3-2.6 10.5-4.5 15.4c5.3 1.1 10.5 2.5 15.5 4.2C603.6 247.9 640 295.7 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160zM168 224c0-17.7 14.3-32 32-32h16c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H200c-17.7 0-32-14.3-32-32V224zm32-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V224c0-8.8-7.2-16-16-16H200zm96-8c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8s-8-3.6-8-8V208h-8c-4.4 0-8-3.6-8-8zm128-8h16c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H424c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32zm-16 32v32c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V224c0-8.8-7.2-16-16-16H424c-8.8 0-16 7.2-16 16zM184 328c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8s-8-3.6-8-8V336h-8c-4.4 0-8-3.6-8-8zm224 0c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8s-8-3.6-8-8V336h-8c-4.4 0-8-3.6-8-8zm-96-8h16c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H312c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32zm-16 32v32c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V352c0-8.8-7.2-16-16-16H312c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faOven = {
    prefix: 'fat',
    iconName: 'oven',
    icon: [
      448,
      512,
      [],
      'e01d',
      
      'M96 16C51.8 16 16 51.8 16 96v64H432V96c0-44.2-35.8-80-80-80H96zM0 168V96C0 43 43 0 96 0H352c53 0 96 43 96 96v72V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V168zm432 8H16V448c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V176zM80 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM272 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM96 240c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16V256c0-8.8-7.2-16-16-16H96zM64 256c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V256zm64 40c0-4.4 3.6-8 8-8H312c4.4 0 8 3.6 8 8s-3.6 8-8 8H136c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faDeleteLeft = {
    prefix: 'fat',
    iconName: 'delete-left',
    icon: [
      576,
      512,
      [9003,"backspace"],
      'f55a',
      
      'M560 128c0-26.5-21.5-48-48-48H205.3c-12.7 0-24.9 5.1-33.9 14.1L20.7 244.7c-3 3-4.7 7.1-4.7 11.3s1.7 8.3 4.7 11.3L171.3 417.9c9 9 21.2 14.1 33.9 14.1H512c26.5 0 48-21.5 48-48V128zM9.4 233.4L160 82.7c12-12 28.3-18.7 45.3-18.7H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H205.3c-17 0-33.3-6.7-45.3-18.7L9.4 278.6c-6-6-9.4-14.1-9.4-22.6s3.4-16.6 9.4-22.6zm420.3-55c3.1 3.1 3.1 8.2 0 11.3L363.3 256l66.3 66.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L352 267.3l-66.3 66.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L340.7 256l-66.3-66.3c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L352 244.7l66.3-66.3c3.1-3.1 8.2-3.1 11.3 0z'
      
    ]
  };

  
    var faBackspace = faDeleteLeft;
  

  
  

  var faFaceGrin = {
    prefix: 'fat',
    iconName: 'face-grin',
    icon: [
      512,
      512,
      [128512,"grin"],
      'f580',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256.3 91.8c-43 0-84.1-5.5-121.5-15.4c-3.9-1-7.1 .3-8.7 1.8c-.7 .7-.9 1.2-.9 1.4l0 0c0 .1-.1 .7 .5 1.9c25 46.8 74.1 78.5 130.5 78.5s105.5-31.7 130.5-78.5c.7-1.2 .6-1.8 .5-1.9l0 0c0-.2-.2-.7-.9-1.4c-1.6-1.5-4.8-2.8-8.7-1.8c-37.4 9.9-78.4 15.4-121.5 15.4zm144.6-2.7C373.2 396.8 318.8 432 256.3 432s-116.9-35.2-144.6-86.9c-9.1-17 8.7-33.1 27.3-28.2c36 9.6 75.6 14.9 117.3 14.9s81.4-5.3 117.3-14.9c18.6-4.9 36.4 11.2 27.3 28.2zM160.4 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  
    var faGrin = faFaceGrin;
  

  
  

  var faCloudSnow = {
    prefix: 'fat',
    iconName: 'cloud-snow',
    icon: [
      512,
      512,
      [127784],
      'f742',
      
      'M398.7 124.8c.8-4.1 1.3-8.4 1.3-12.8c0-35.3-28.7-64-64-64c-19.5 0-36.9 8.7-48.6 22.4c-3.5 4-8.7 6.1-13.9 5.5s-9.9-3.8-12.4-8.5C245 36.8 212.9 16 176 16c-53 0-96 43-96 96c0 6.1 .6 12.1 1.7 17.9c1.5 7.9-3.1 15.6-10.7 18.1C39 158.5 16 188.6 16 224c0 44.2 35.8 80 80 80H416c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.4 0-.9 0-1.3 0c-4.8 .1-9.5-2-12.6-5.8s-4.3-8.7-3.4-13.4zM176 0c37.1 0 70 18.1 90.4 45.9c3.3 4.5 6.2 9.2 8.8 14.1c3.6-4.2 7.6-8 12-11.4C300.7 38.2 317.6 32 336 32c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c4.9 0 9.8 .4 14.5 1.1c46.2 7 81.5 46.8 81.5 94.9c0 53-43 96-96 96H96c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0zM64 360c4.4 0 8 3.6 8 8v40l40 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-40 0v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V424l-40 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l40 0V368c0-4.4 3.6-8 8-8zm392 8v40l40 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-40 0v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V424l-40 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l40 0V368c0-4.4 3.6-8 8-8s8 3.6 8 8zM256 392c4.4 0 8 3.6 8 8v40l40 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-40 0v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V456l-40 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l40 0V400c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faShelves = {
    prefix: 'fat',
    iconName: 'shelves',
    icon: [
      640,
      512,
      ["inventory"],
      'f480',
      
      'M8 0c4.4 0 8 3.6 8 8V176H624V8c0-4.4 3.6-8 8-8s8 3.6 8 8V184 440v64c0 4.4-3.6 8-8 8s-8-3.6-8-8V448H16v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V440 184 8C0 3.6 3.6 0 8 0zm8 432H624V192H16V432zM448 16H384c-8.8 0-16 7.2-16 16V96c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V32c0-8.8-7.2-16-16-16zM384 0h64c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM128 272c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V288c0-8.8-7.2-16-16-16H128zM96 288c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V288zm192-16c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V288c0-8.8-7.2-16-16-16H288zm-32 16c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V288z'
      
    ]
  };

  
    var faInventory = faShelves;
  

  
  

  var faAnglesUpDown = {
    prefix: 'fat',
    iconName: 'angles-up-down',
    icon: [
      448,
      512,
      [],
      'e60d',
      
      'M229.1 486.2l176-144c3.4-2.8 3.9-7.8 1.1-11.3s-7.8-3.9-11.3-1.1L224 469.7 53.1 329.8c-3.4-2.8-8.5-2.3-11.3 1.1s-2.3 8.5 1.1 11.3l176 144c2.9 2.4 7.2 2.4 10.1 0zm176-316.4l-176-144c-2.9-2.4-7.2-2.4-10.1 0l-176 144c-3.4 2.8-3.9 7.8-1.1 11.3s7.8 3.9 11.3 1.1L224 42.3 394.9 182.2c3.4 2.8 8.5 2.3 11.3-1.1s2.3-8.5-1.1-11.3z'
      
    ]
  };

  

  
  

  var faDownload = {
    prefix: 'fat',
    iconName: 'download',
    icon: [
      512,
      512,
      [],
      'f019',
      
      'M264 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V356.7L133.7 242.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l128 128c3.1 3.1 8.2 3.1 11.3 0l128-128c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L264 356.7V8zM143.4 320H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V384c0-35.3-28.7-64-64-64H368.6l-16 16H448c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V384c0-26.5 21.5-48 48-48h95.4l-16-16zM432 432a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z'
      
    ]
  };

  

  
  

  var faArrowsDownToLine = {
    prefix: 'fat',
    iconName: 'arrows-down-to-line',
    icon: [
      576,
      512,
      [],
      'e4b8',
      
      'M568 464L8 464c-4.4 0-8 3.6-8 8s3.6 8 8 8l560 0c4.4 0 8-3.6 8-8s-3.6-8-8-8zm5.7-194.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L456 364.7 456 40c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 324.7L333.7 258.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l120 120c3.1 3.1 8.2 3.1 11.3 0l120-120zm-320-11.3c-3.1-3.1-8.2-3.1-11.3 0L136 364.7 136 40c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 324.7L13.7 258.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l120 120c3.1 3.1 8.2 3.1 11.3 0l120-120c3.1-3.1 3.1-8.2 0-11.3z'
      
    ]
  };

  

  
  

  var faTugrikSign = {
    prefix: 'fat',
    iconName: 'tugrik-sign',
    icon: [
      384,
      512,
      [],
      'e2ba',
      
      'M8 32c-4.4 0-8 3.6-8 8s3.6 8 8 8H184V217.8L62.1 248.2c-4.3 1.1-6.9 5.4-5.8 9.7s5.4 6.9 9.7 5.8L184 234.2v79.5L62.1 344.2c-4.3 1.1-6.9 5.4-5.8 9.7s5.4 6.9 9.7 5.8L184 330.2V472c0 4.4 3.6 8 8 8s8-3.6 8-8V326.2l121.9-30.5c4.3-1.1 6.9-5.4 5.8-9.7s-5.4-6.9-9.7-5.8L200 309.8V230.2l121.9-30.5c4.3-1.1 6.9-5.4 5.8-9.7s-5.4-6.9-9.7-5.8L200 213.8V48H376c4.4 0 8-3.6 8-8s-3.6-8-8-8H192 8z'
      
    ]
  };

  

  
  

  var faBatterySlash = {
    prefix: 'fat',
    iconName: 'battery-slash',
    icon: [
      640,
      512,
      [],
      'f377',
      
      'M13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7zM386.2 400H112c-35.3 0-64-28.7-64-64V176c0-12.9 3.8-24.8 10.3-34.9l-12.6-9.9C37.1 144 32 159.4 32 176V336c0 44.2 35.8 80 80 80H406.5l-20.3-16zM480 96H233.5l20.3 16H480c35.3 0 64 28.7 64 64v16 16 96 16 16c0 1.7-.1 3.3-.2 5l14.5 11.4c1.1-5.3 1.7-10.8 1.7-16.4V320h16c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H560V176c0-44.2-35.8-80-80-80zm80 112h16c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H560V208z'
      
    ]
  };

  

  
  

  var faClockSixThirty = {
    prefix: 'fat',
    iconName: 'clock-six-thirty',
    icon: [
      512,
      512,
      [],
      'e353',
      
      'M16 256a240 240 0 1 1 480 0A240 240 0 1 1 16 256zm496 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM264 408V256c0-4.4-3.6-8-8-8s-8 3.6-8 8V408c0 4.4 3.6 8 8 8s8-3.6 8-8z'
      
    ]
  };

  

  
  

  var faShip = {
    prefix: 'fat',
    iconName: 'ship',
    icon: [
      576,
      512,
      [128674],
      'f21a',
      
      'M232 0c-22.1 0-40 17.9-40 40V64H136c-22.1 0-40 17.9-40 40V229.7L57 242.3C30.6 250.9 20.7 283 37.7 305l84 108c2.7 3.5 7.7 4.1 11.2 1.4s4.1-7.7 1.4-11.2l-84-108c-10.2-13.1-4.3-32.4 11.6-37.6L280 187V376c0 4.4 3.6 8 8 8s8-3.6 8-8V187l218.1 70.6c15.8 5.1 21.8 24.4 11.6 37.6l-84 108c-2.7 3.5-2.1 8.5 1.4 11.2s8.5 2.1 11.2-1.4l84-108c17-21.9 7.1-54.1-19.3-62.6l-39-12.6V104c0-22.1-17.9-40-40-40H384V40c0-22.1-17.9-40-40-40H232zM368 64H208V40c0-13.3 10.7-24 24-24H344c13.3 0 24 10.7 24 24V64zM192 80h8H376h8 56c13.3 0 24 10.7 24 24V224.5l-163.7-53c-8-2.6-16.6-2.6-24.6 0L112 224.5V104c0-13.3 10.7-24 24-24h56zM322.2 466.1c-10.1-9.2-19.6-19.5-27.6-30.7c-3-4.3-10.2-4.3-13.2 0c-8 11.2-17.5 21.4-27.6 30.7C236.6 481.8 214.5 496 192 496s-44.6-14.2-61.8-29.9c-10.1-9.2-19.7-19.5-27.6-30.7c-1.5-2.1-3.9-3.4-6.6-3.4s-5.1 1.3-6.6 3.4c-7.3 10.3-15.9 19.6-25 28.3C48.7 478.5 28.3 492.9 7 495.6c-4.4 .6-7.5 4.6-6.9 8.9s4.6 7.5 8.9 6.9c26.5-3.3 50-20.7 66.4-36.1c8.8-8.3 15.9-16.4 20.6-22.2c5.2 6.4 13.2 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8l0 0 0 0c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c4.7 5.8 11.8 13.9 20.6 22.2c16.4 15.4 39.9 32.8 66.4 36.1c4.4 .6 8.4-2.6 8.9-6.9s-2.6-8.4-6.9-8.9c-21.3-2.7-41.7-17.1-57.4-31.9c-9.1-8.6-17.7-18-25-28.3c-1.5-2.1-3.9-3.4-6.6-3.4s-5.1 1.3-6.6 3.4c-7.9 11.2-17.5 21.5-27.6 30.7C428.6 481.8 406.5 496 384 496s-44.6-14.2-61.8-29.9z'
      
    ]
  };

  

  
  

  var faGameConsoleHandheld = {
    prefix: 'fat',
    iconName: 'game-console-handheld',
    icon: [
      384,
      512,
      [],
      'f8bb',
      
      'M64 16C37.5 16 16 37.5 16 64V416c0 44.2 35.8 80 80 80H288c44.2 0 80-35.8 80-80V64c0-26.5-21.5-48-48-48H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V416c0 53-43 96-96 96H96c-53 0-96-43-96-96V64zM80 80V224c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16V80H80zM64 80c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16V224c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V80zM232 344a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm16-48a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM104 296c0-4.4 3.6-8 8-8s8 3.6 8 8v32h32c4.4 0 8 3.6 8 8s-3.6 8-8 8H120v32c0 4.4-3.6 8-8 8s-8-3.6-8-8V344H72c-4.4 0-8-3.6-8-8s3.6-8 8-8h32V296z'
      
    ]
  };

  

  
  

  var faPersonSledding = {
    prefix: 'fat',
    iconName: 'person-sledding',
    icon: [
      512,
      512,
      ["sledding"],
      'f7cb',
      
      'M289.9 244.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9H336c17.7 0 32 14.3 32 32v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V320c0-8.8-7.2-16-16-16H211.9c-31.5 0-44-40.7-18-58.4L253 205.2c5.8-4 8.3-11.2 6.3-17.9S251 176 244 176H160c-8.8 0-16-7.2-16-16s7.2-16 16-16H332.7c21.4 0 32.1 25.9 17 41l-59.7 59.7zm71-48.4c25.2-25.2 7.4-68.3-28.3-68.3H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h55.6H244l-23.5 16-35.7 24.3c-39 26.6-20.2 87.7 27 87.7H304h16v16 32c0 17.7 14.3 32 32 32s32-14.3 32-32V304c0-26.5-21.5-48-48-48H323.9 301.3l16-16L361 196.3zM368 80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM11.5 256.8c-4-2-8.8-.3-10.7 3.6s-.3 8.8 3.6 10.7L410 471.3c18.8 9.3 40.5 10.8 60.5 4.2l36-11.9c4.2-1.4 6.5-5.9 5.1-10.1s-5.9-6.5-10.1-5.1l-36 11.9c-15.9 5.3-33.3 4-48.4-3.4L11.5 256.8z'
      
    ]
  };

  
    var faSledding = faPersonSledding;
  

  
  

  var faBuildingCircleXmark = {
    prefix: 'fat',
    iconName: 'building-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e4d4',
      
      'M48 16H336c17.7 0 32 14.3 32 32V247.2c5-5.3 10.4-10.3 16-15V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96 16 64 16 96c15.1 0 28.5-6.9 37.3-17.8c-3.9-3.8-7.6-7.7-11.1-11.8c-5.8 8.2-15.4 13.6-26.2 13.6H240V416c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-17.7 0-32-14.3-32-32V48c0-17.7 14.3-32 32-32zM224 496H160V416c0-17.7 14.3-32 32-32s32 14.3 32 32v80zM104 232c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V256c0-13.3-10.7-24-24-24H104zm-8 24c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8V256zm128 0v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V256c0-13.3-10.7-24-24-24H248c-13.3 0-24 10.7-24 24zm24-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H248c-4.4 0-8-3.6-8-8V256c0-4.4 3.6-8 8-8zM104 104c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V128c0-13.3-10.7-24-24-24H104zm-8 24c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8V128zm128 0v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V128c0-13.3-10.7-24-24-24H248c-13.3 0-24 10.7-24 24zm24-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H248c-4.4 0-8-3.6-8-8V128c0-4.4 3.6-8 8-8zM368 368a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-132.7 0l50.3-50.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L496 356.7l-50.3-50.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L484.7 368l-50.3 50.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L496 379.3l50.3 50.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L507.3 368z'
      
    ]
  };

  

  
  

  var faSprinkler = {
    prefix: 'fat',
    iconName: 'sprinkler',
    icon: [
      512,
      512,
      [],
      'e035',
      
      'M496 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM432 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM32 144A16 16 0 1 1 0 144a16 16 0 1 1 32 0zm128 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm192 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm144-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-64 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM96 208a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm400 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM32 272A16 16 0 1 1 0 272a16 16 0 1 1 32 0zM96 80A16 16 0 1 1 64 80a16 16 0 1 1 32 0zM32 16A16 16 0 1 1 0 16a16 16 0 1 1 32 0zM256 64c4.4 0 8 3.6 8 8V256H392c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-89 89V472c0 22.1-17.9 40-40 40H232c-22.1 0-40-17.9-40-40V385.9l-89-89c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8H248V72c0-4.4 3.6-8 8-8zM120 272c-3.2 0-6.2 1.9-7.4 4.9s-.6 6.4 1.7 8.7l89 89c3 3 4.7 7.1 4.7 11.3V472c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V385.9c0-4.2 1.7-8.3 4.7-11.3l89-89c2.3-2.3 3-5.7 1.7-8.7s-4.2-4.9-7.4-4.9H256 120z'
      
    ]
  };

  

  
  

  var faFaceLying = {
    prefix: 'fat',
    iconName: 'face-lying',
    icon: [
      512,
      512,
      [],
      'e37e',
      
      'M256 16C123.5 16 16 123.5 16 256s107.5 240 240 240c85.5 0 160.5-44.7 203.1-112c2.4-3.7 7.3-4.9 11-2.5s4.9 7.3 2.5 11C427.3 464.3 347.2 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C373.8 0 472.9 79.5 502.8 187.7c1.2 4.3-1.3 8.7-5.6 9.8s-8.7-1.3-9.8-5.6C459.4 90.5 366.4 16 256 16zM160.4 176a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm160 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-154 220.8c-2.7 3.5-7.7 4.2-11.2 1.6s-4.2-7.7-1.6-11.2C173.3 361 204.7 344 240 344c15.3 0 30 3.2 43.2 9c4 1.8 5.9 6.5 4.1 10.5s-6.5 5.9-10.5 4.1c-11.3-4.9-23.7-7.7-36.8-7.7c-30.1 0-56.8 14.4-73.6 36.8zM288 232H448c30.9 0 56 25.1 56 56s-25.1 56-56 56H352c-4.4 0-8-3.6-8-8s3.6-8 8-8h96c22.1 0 40-17.9 40-40s-17.9-40-40-40H288c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faCloudRain = {
    prefix: 'fat',
    iconName: 'cloud-rain',
    icon: [
      512,
      512,
      [9926,127783],
      'f73d',
      
      'M398.7 124.8c.8-4.1 1.3-8.4 1.3-12.8c0-35.3-28.7-64-64-64c-19.5 0-36.9 8.7-48.6 22.4c-3.5 4-8.7 6.1-13.9 5.5s-9.9-3.8-12.4-8.5C245 36.8 212.9 16 176 16c-53 0-96 43-96 96c0 6.1 .6 12.1 1.7 17.9c1.5 7.9-3.1 15.6-10.7 18.1C39 158.5 16 188.6 16 224c0 44.2 35.8 80 80 80H416c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.4 0-.9 0-1.3 0c-4.8 .1-9.5-2-12.6-5.8s-4.3-8.7-3.4-13.4zM176 0c37.1 0 70 18.1 90.4 45.9c3.3 4.5 6.2 9.2 8.8 14.1c3.6-4.2 7.6-8 12-11.4C300.7 38.2 317.6 32 336 32c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c4.9 0 9.8 .4 14.5 1.1c46.2 7 81.5 46.8 81.5 94.9c0 53-43 96-96 96H96c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0zM68.2 444.2C65.5 449.4 64 455.1 64 461v3c0 17.7 14.3 32 32 32s32-14.3 32-32v-3c0-5.8-1.5-11.6-4.2-16.7L96 393.1 68.2 444.2zm-14.1-7.6L89.2 372c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3zm174.1 7.6c-2.8 5.1-4.2 10.9-4.2 16.7v3c0 17.7 14.3 32 32 32s32-14.3 32-32v-3c0-5.8-1.5-11.6-4.2-16.7L256 393.1l-27.8 51.1zm-14.1-7.6L249.2 372c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3zM416 393.1l-27.8 51.1c-2.8 5.1-4.2 10.9-4.2 16.7v3c0 17.7 14.3 32 32 32s32-14.3 32-32v-3c0-5.8-1.5-11.6-4.2-16.7L416 393.1zM409.2 372c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3L409.2 372z'
      
    ]
  };

  

  
  

  var faShovelSnow = {
    prefix: 'fat',
    iconName: 'shovel-snow',
    icon: [
      512,
      512,
      [],
      'f7c3',
      
      'M421.7 2.3c-3.1-3.1-8.2-3.1-11.3 0L372.6 40.1C359.4 53.3 352 71.1 352 89.8c0 16.5 5.7 31.7 15.2 43.7L276 224.7l-51.3-51.3c-13.8-13.8-35.5-15.6-51.4-4.4L16.9 279.9C6.3 287.4 0 299.6 0 312.5v2.2c0 10.6 4.2 20.8 11.7 28.3L169 500.3c7.5 7.5 17.7 11.7 28.3 11.7h2.2c13 0 25.1-6.3 32.6-16.9L342.9 338.7c11.3-15.9 9.4-37.6-4.4-51.4L287.3 236l91.2-91.2c12 9.5 27.2 15.2 43.7 15.2c18.6 0 36.5-7.4 49.7-20.6l37.8-37.8c3.1-3.1 3.1-8.2 0-11.3l-88-88zM383.9 51.4L416 19.3 492.7 96l-32.1 32.1c-10.2 10.2-24 15.9-38.3 15.9c-29.9 0-54.2-24.3-54.2-54.2c0-14.4 5.7-28.2 15.9-38.3zM182.6 182.1c9.5-6.8 22.6-5.7 30.8 2.6L327.3 298.6c8.3 8.3 9.4 21.3 2.6 30.8L219 485.9c-4.5 6.4-11.8 10.1-19.6 10.1h-2.2c-6.4 0-12.5-2.5-17-7L23 331.7c-4.5-4.5-7-10.6-7-17v-2.2c0-7.8 3.8-15.1 10.1-19.6L182.6 182.1zm15.1 79.5c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-80 80c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l80-80zm64 64c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-80 80c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l80-80z'
      
    ]
  };

  

  
  

  var faCableCar = {
    prefix: 'fat',
    iconName: 'cable-car',
    icon: [
      512,
      512,
      [57551,128673,"tram"],
      'f7da',
      
      'M272 32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM192 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM416 240c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H96c-26.5 0-48-21.5-48-48V288c0-26.5 21.5-48 48-48H248h16H416zm0-16H264V126.4L505.8 71.8c4.3-1 7-5.3 6-9.6s-5.3-7-9.6-6l-248 56-248 56c-4.3 1-7 5.3-6 9.6s5.3 7 9.6 6L248 130v94H96c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V288c0-35.3-28.7-64-64-64zM96 304c0-8.8 7.2-16 16-16h80v96H112c-8.8 0-16-7.2-16-16V304zm112 80V288h96v96H208zm112 0V288h80c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H320zM80 304v64c0 17.7 14.3 32 32 32H400c17.7 0 32-14.3 32-32V304c0-17.7-14.3-32-32-32H112c-17.7 0-32 14.3-32 32z'
      
    ]
  };

  
    var faTram = faCableCar;
  

  
  

  var faGarage = {
    prefix: 'fat',
    iconName: 'garage',
    icon: [
      640,
      512,
      [],
      'e009',
      
      'M329.1 20.4c-5.8-2.4-12.4-2.4-18.2 0L40.8 131.2c-15 6.2-24.8 20.8-24.8 37V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V168.2c0-22.7 13.7-43.2 34.7-51.8L304.8 5.6c9.7-4 20.6-4 30.4 0L605.3 116.4c21 8.6 34.7 29.1 34.7 51.8V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V168.2c0-16.2-9.8-30.8-24.8-37L329.1 20.4zM120 208c-4.4 0-8 3.6-8 8V320H528V216c0-4.4-3.6-8-8-8H120zM528 336H112V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V216c0-13.3 10.7-24 24-24H520c13.3 0 24 10.7 24 24V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V336zM264 416H376c4.4 0 8 3.6 8 8s-3.6 8-8 8H264c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faSwap = {
    prefix: 'fat',
    iconName: 'swap',
    icon: [
      640,
      512,
      [],
      'e609',
      
      'M200 118.3c0 14.2-11.5 25.7-25.7 25.7H120V368c0 53 43 96 96 96s96-43 96-96V144c0-61.9 50.1-112 112-112s112 50.1 112 112V368h54.3c14.2 0 25.7 11.5 25.7 25.7c0 5.9-2.1 11.7-5.8 16.3l-62.9 76.9c-4.7 5.8-11.8 9.1-19.3 9.1s-14.5-3.4-19.3-9.1L445.8 410c-3.8-4.6-5.8-10.3-5.8-16.3c0-14.2 11.5-25.7 25.7-25.7H520V144c0-53-43-96-96-96s-96 43-96 96V368c0 61.9-50.1 112-112 112s-112-50.1-112-112V144l-54.3 0C35.5 144 24 132.5 24 118.3c0-5.9 2.1-11.7 5.8-16.3L92.7 25.1C97.5 19.3 104.5 16 112 16s14.5 3.4 19.3 9.1L194.2 102c3.8 4.6 5.8 10.3 5.8 16.3zm-16 0c0-2.2-.8-4.4-2.2-6.1L118.9 35.3c-1.7-2.1-4.2-3.3-6.9-3.3s-5.2 1.2-6.9 3.3L42.2 112.2c-1.4 1.7-2.2 3.9-2.2 6.1c0 5.3 4.3 9.7 9.7 9.7l124.6 0c5.3 0 9.7-4.3 9.7-9.7zM600 393.7c0-5.4-4.3-9.7-9.7-9.7H465.7c-5.4 0-9.7 4.3-9.7 9.7c0 2.2 .8 4.4 2.2 6.1l62.9 76.9c1.7 2.1 4.2 3.3 6.9 3.3s5.2-1.2 6.9-3.3l62.9-76.9c1.4-1.7 2.2-3.9 2.2-6.1z'
      
    ]
  };

  

  
  

  var faN = {
    prefix: 'fat',
    iconName: 'n',
    icon: [
      384,
      512,
      [110],
      '4e',
      
      'M5.2 32.5c3.1-1.2 6.7-.2 8.9 2.3L368 450.3V40c0-4.4 3.6-8 8-8s8 3.6 8 8V472c0 3.4-2.1 6.3-5.2 7.5s-6.7 .2-8.9-2.3L16 61.7V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V40c0-3.4 2.1-6.3 5.2-7.5z'
      
    ]
  };

  

  
  

  var faPeoplePulling = {
    prefix: 'fat',
    iconName: 'people-pulling',
    icon: [
      576,
      512,
      [],
      'e535',
      
      'M56 52a36 36 0 1 1 72 0A36 36 0 1 1 56 52zm88 0A52 52 0 1 0 40 52a52 52 0 1 0 104 0zM64 128c-35.3 0-64 28.7-64 64V320c0 17.7 14.3 32 32 32c10.9 0 20.5-5.4 26.3-13.7L84.7 486.2c2.7 14.9 15.7 25.8 30.8 25.8c19.8 0 34.6-18.1 30.7-37.5l-22.6-113c-1-5 2.8-9.6 7.8-9.6c3.7 0 6.9 2.5 7.8 6.1l32.5 130.1c3.5 14 16.1 23.8 30.5 23.8c20.3 0 35.3-19 30.6-38.7L171.3 213.2 237 239.4c4.1 1.6 8.8-.4 10.4-4.5s-.4-8.8-4.5-10.4l-80-32c-2.8-1.1-5.9-.6-8.2 1.4s-3.2 5-2.6 7.9L217.4 477c2.3 9.7-5.1 19-15.1 19c-7.1 0-13.3-4.8-15-11.7L154.8 354.2c-2.7-10.7-12.3-18.2-23.3-18.2c-15.1 0-26.5 13.9-23.5 28.7l22.6 113c1.9 9.5-5.4 18.3-15 18.3c-7.4 0-13.8-5.3-15.1-12.6L64 279.3V232c0-4.4-3.6-8-8-8s-8 3.6-8 8v88c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-26.5 21.5-48 48-48h53.5c11.2 0 22.3 2.1 32.7 6.3L253 191.4c4.1 1.6 8.8-.4 10.4-4.5s-.4-8.8-4.5-10.4L156.1 135.4c-12.3-4.9-25.4-7.4-38.6-7.4H64zm329.1 59.3c-4.6-4-11-5.1-16.6-2.8c-1.1 .5-2.2 .9-3.4 1.4l-5.7 2.5c-21.6 9.6-37.9 28.3-44.4 51.1l-3.7 12.9c-2.4 8.5-11.3 13.4-19.8 11s-13.4-11.3-11-19.8l3.7-12.9c9.1-31.9 31.9-58.1 62.2-71.6l5.7-2.5c18.8-8.3 39-12.6 59.6-12.6c38.1 0 72.5 22.9 87.1 58.1l16.5 39.7c1.1 2.6 2.9 4.9 5.2 6.6l25 18.8c7.1 5.3 8.5 15.3 3.2 22.4s-15.3 8.5-22.4 3.2l-28.5-21.4c-4.6-3.4-8.1-8-10.3-13.3l-10.2-24.5c-2.6-6.3-8.9-10.2-15.6-9.8s-12.6 5-14.5 11.5L436 300.8c-1.6 5.4-.2 11.2 3.6 15.3l49.5 54c3.6 3.9 6.2 8.7 7.5 13.9l23 92.1c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6l-22-88.1c-.6-2.6-1.9-5-3.7-6.9l-70.7-77.1c-11.1-12.1-15.2-29-11-44.8L398 203.4c1.6-5.9-.3-12.1-4.9-16.1zM464 16a36 36 0 1 1 0 72 36 36 0 1 1 0-72zM363.4 209c3.3-2.3 6.8-4.3 10.6-6l5.7-2.5c1-.4 1.9-.8 2.9-1.2l-1.3 4.8-2.6 9.6-1.5 5.6-11.6 43.6c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 12.1-41.2 7.2-24.4 9.8 23.5 .4 1c3.3 7.9 8.7 14.8 15.5 19.9l28.5 21.4c14.1 10.6 34.2 7.7 44.8-6.4s7.7-34.2-6.4-44.8l-25-18.8-16.5-39.7C504.5 154.8 464.3 128 419.7 128c-22.8 0-45.3 4.8-66.1 14l-5.7 2.5c-34.6 15.4-60.7 45.3-71.1 81.8l-3.7 12.9c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l3.7-12.9c4.1-14.3 13-26.6 24.9-34.9zM516 52A52 52 0 1 0 412 52a52 52 0 1 0 104 0zM355 343.9c-4.1-1.6-8.8 .4-10.4 4.5L324.7 398l-59.4 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l61.7-61.7c4.6-4.6 8.2-10.1 10.6-16.1L398.1 387c1.6-4.1-.4-8.8-4.5-10.4s-8.8 .4-10.4 4.5l-15.1 37.9c-1.6 4-4 7.7-7.1 10.7l-61.7 61.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l60.5-60.5 1.2-1.2 .6-1.5 20.5-51.1c1.6-4.1-.4-8.8-4.5-10.4z'
      
    ]
  };

  

  
  

  var faEyeEvil = {
    prefix: 'fat',
    iconName: 'eye-evil',
    icon: [
      640,
      512,
      [],
      'f6db',
      
      'M258.4 103.8c-13.4 3.5-26.2 8.1-38.1 13.6c-3.7 1.7-7.9 1.9-11.8 .6L101.8 82.2c-2.6-.9-5.4 0-7.1 2.2c-1.6 2.2-1.7 5.1-.2 7.4l48.4 72.1c3.6 5.4 3.6 12.3 .1 17.7c-4.9 7.5-9.1 15.3-12.5 23.3c-1.7 4.1-5.1 7.3-9.4 8.8L20.4 249.7c-2.7 1-4.4 3.5-4.4 6.3s1.8 5.4 4.4 6.3l100.6 35.9c4.2 1.5 7.6 4.7 9.4 8.8c3.4 8.1 7.6 15.8 12.5 23.3c3.6 5.4 3.5 12.4-.1 17.7L94.5 420.3c-1.5 2.2-1.4 5.2 .2 7.4c1.6 2.2 4.5 3.1 7.1 2.2L208.4 394c3.9-1.3 8.1-1.1 11.8 .6c12 5.5 24.7 10.1 38.1 13.6c4.2 1.1 7.8 3.8 9.9 7.6l41.8 74.3c2 3.6 5.8 5.8 9.9 5.8s7.9-2.2 9.9-5.8l41.8-74.3c2.1-3.8 5.7-6.6 9.9-7.6c13.4-3.5 26.2-8.1 38.1-13.6c3.7-1.7 7.9-1.9 11.8-.6l106.6 35.8c2.6 .9 5.4 0 7.1-2.2c1.6-2.2 1.7-5.1 .2-7.4l-48.4-72.1c-3.6-5.4-3.6-12.3-.1-17.7c4.9-7.5 9.1-15.3 12.5-23.3c1.7-4.1 5.1-7.3 9.4-8.8l100.6-35.9c2.7-1 4.4-3.5 4.4-6.3s-1.8-5.4-4.4-6.3L518.9 213.7c-4.2-1.5-7.6-4.7-9.4-8.8c-3.4-8.1-7.6-15.8-12.5-23.3c-3.6-5.4-3.5-12.4 .1-17.7l48.4-72.1c1.5-2.2 1.4-5.2-.2-7.4c-1.6-2.2-4.5-3.1-7.1-2.2L431.6 118c-3.9 1.3-8.1 1.1-11.8-.6c-12-5.5-24.7-10.1-38.1-13.6c-4.2-1.1-7.8-3.9-9.9-7.6L329.9 21.8c-2-3.6-5.8-5.8-9.9-5.8s-7.9 2.2-9.9 5.8L268.3 96.1c-2.1 3.8-5.7 6.5-9.9 7.6zm85.5-89.8l41.8 74.3c14.3 3.7 28 8.6 40.8 14.6L533.1 67c9.1-3.1 19.2 .1 25 7.7c5.7 7.6 6 18 .7 25.9l-48.4 72.1c5.5 8.3 10.1 16.9 13.9 25.9l100.6 35.9c9 3.2 15.1 11.8 15.1 21.4s-6 18.2-15.1 21.4L524.3 313.3c-3.8 9-8.5 17.6-13.9 25.9l48.4 72.1c5.3 7.9 5 18.3-.7 25.9c-5.8 7.7-15.8 10.8-25 7.7L426.5 409.2c-12.8 5.9-26.5 10.8-40.8 14.6l-41.8 74.3c-4.8 8.6-14 13.9-23.8 13.9s-19-5.3-23.8-13.9l-41.8-74.3c-14.3-3.7-28-8.6-40.8-14.6L106.9 445c-9.1 3.1-19.2-.1-25-7.7c-5.7-7.6-6-18-.7-25.9l48.4-72.1c-5.5-8.3-10.1-16.9-13.9-25.9L15.1 277.4C6 274.2 0 265.6 0 256s6-18.2 15.1-21.4l100.6-35.9c3.8-9 8.5-17.6 13.9-25.9L81.2 100.7c-5.3-7.9-5-18.3 .7-25.9c5.8-7.7 15.8-10.8 25-7.7l106.6 35.8C226.4 96.9 240 92 254.3 88.3l41.8-74.3C301 5.3 310.1 0 320 0s19 5.3 23.8 13.9zM232 248c0 48.6 39.4 88 88 88s88-39.4 88-88c0-12.3-2.5-24.1-7.1-34.7c-13 6.4-26.8 11.2-41.3 14.4c-2.6 39-17.9 61.3-25.4 70c-3.8 4.4-9.2 6.2-14.2 6.2s-10.3-1.8-14.2-6.2c-7.6-8.8-22.8-31.1-25.4-70c-14.5-3.2-28.3-8.1-41.3-14.4c-4.6 10.6-7.1 22.4-7.1 34.7zm85.9 39.3c.2 .3 .8 .7 2.1 .7s1.8-.4 2.1-.7c5.4-6.3 18.2-24.2 21.3-56.8c-7.4 .9-14.9 1.4-22.5 1.5c-.3 0-.6 0-.8 0s-.6 0-.8 0c-7.6 0-15.1-.5-22.5-1.5c3.1 32.6 15.8 50.5 21.3 56.8zm96.9-82.1c.1 .1 .1 .2 .2 .4c5.8 12.9 9 27.3 9 42.4c0 57.4-46.6 104-104 104s-104-46.6-104-104c0-15.1 3.2-29.4 9-42.4c.1-.1 .1-.2 .2-.4c-4.8-3-9.5-6.1-14-9.5c-3.5-2.7-4.2-7.7-1.6-11.2s7.7-4.2 11.2-1.6c27.4 20.6 61.5 32.9 98.4 33.1c.3 0 .5 0 .8 0s.5 0 .8 0c36.9-.2 71-12.4 98.4-33.1c3.5-2.7 8.6-1.9 11.2 1.6s1.9 8.5-1.6 11.2c-4.5 3.4-9.2 6.6-14 9.5z'
      
    ]
  };

  

  
  

  var faUserHair = {
    prefix: 'fat',
    iconName: 'user-hair',
    icon: [
      448,
      512,
      [],
      'e45a',
      
      'M336 128c0-5.4-.4-10.8-1.1-16H312c-22.1 0-43-10.2-56.6-27.5L251 89.9C231.2 114 201.7 128 170.5 128L112 128v16c0 61.9 50.1 112 112 112s112-50.1 112-112V128zm-4.6-32c-6.8-22.8-20.6-42.5-39-56.7L265.8 71.8l1.4 1.8C277.8 87.7 294.4 96 312 96h19.4zM170.5 112c26.4 0 51.4-11.8 68.1-32.3L279 30.4C262.7 21.2 244 16 224 16c-56.4 0-103.1 41.7-110.9 96h57.4zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V128zM16 483.6c0 6.9 5.6 12.4 12.4 12.4H419.6c6.9 0 12.4-5.6 12.4-12.4C432 402.1 365.9 336 284.4 336H163.6C82.1 336 16 402.1 16 483.6zm-16 0C0 393.2 73.2 320 163.6 320H284.4C374.8 320 448 393.2 448 483.6c0 15.7-12.7 28.4-28.4 28.4H28.4C12.7 512 0 499.3 0 483.6z'
      
    ]
  };

  

  
  

  var faShuttlecock = {
    prefix: 'fat',
    iconName: 'shuttlecock',
    icon: [
      512,
      512,
      [],
      'f45b',
      
      'M226.8 20.5c1.3-2.8 4.1-4.5 7.2-4.5h46c4.4 0 8 3.6 8 8V93.8c0 3.1-1.8 5.9-4.6 7.2L159.6 159.2 226.8 20.5zm63.4 95.1c.7-.3 1.4-.7 2.1-1.1L249 251.7l-78.6 78.6-63-63-.1-.1L148.5 182l141.7-66.5zM303.9 96c.1-.7 .1-1.4 .1-2.2V24c0-13.3-10.7-24-24-24H234c-9.2 0-17.6 5.3-21.6 13.5L93.8 258.2l-9.1 9.1L33.1 318.9C11.9 340.1 0 368.9 0 398.9C0 461.3 50.7 512 113.1 512c30 0 58.8-11.9 80-33.1l51.5-51.5 9.1-9.1L498.5 299.6c8.3-4 13.5-12.4 13.5-21.6V232c0-13.3-10.7-24-24-24H418.2c-.7 0-1.4 0-2.2 .1l0-.1V120c0-13.3-10.7-24-24-24H304l-.1 0zM330 363.5l-85.2 41.3-.1-.1-63-63L260.3 263l137.3-43.4c-.4 .7-.8 1.4-1.1 2.1L330 363.5zM268.3 243.7L309.9 112H392c4.4 0 8 3.6 8 8v82.1L268.3 243.7zM53 321.7l43-43L233.4 416l-43 43L53 321.7zM179 470.3c-17.9 16.5-41.4 25.7-65.8 25.7C59.5 496 16 452.5 16 398.9c0-24.4 9.2-47.9 25.7-65.8L179 470.3zM496 278c0 3.1-1.8 5.9-4.5 7.2L352.8 352.4l58.1-123.8c1.3-2.8 4.1-4.6 7.2-4.6H488c4.4 0 8 3.6 8 8v46z'
      
    ]
  };

  

  
  

  var faCalculator = {
    prefix: 'fat',
    iconName: 'calculator',
    icon: [
      384,
      512,
      [128425],
      'f1ec',
      
      'M64 16C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48H320c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM96 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H96zM64 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96zM80 224a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm32-16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64 80H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16zM96 384h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32s14.3-32 32-32zm96-144a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm32-16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-48 96a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96-112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm32-16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-48 96a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm32-16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z'
      
    ]
  };

  

  
  

  var faImages = {
    prefix: 'fat',
    iconName: 'images',
    icon: [
      576,
      512,
      [],
      'f302',
      
      'M512 48c26.5 0 48 21.5 48 48V228.7l-79-79c-9.4-9.4-24.6-9.4-33.9 0l-143 143-79-79c-9.4-9.4-24.6-9.4-33.9 0l-79 79V96c0-26.5 21.5-48 48-48H512zM112 320v-4.7L202.3 225c3.1-3.1 8.2-3.1 11.3 0l79 79L229 367.7c-.1 .1-.2 .2-.3 .3H160c-26.5 0-48-21.5-48-48zm400 48H251.3l58.3-58.3L458.3 161c3.1-3.1 8.2-3.1 11.3 0L560 251.3V320c0 26.5-21.5 48-48 48zM160 32c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zm88 96a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM224 88a40 40 0 1 0 0 80 40 40 0 1 0 0-80zM0 192V416c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64H464c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V192c0-26.5 21.5-48 48-48V128c-35.3 0-64 28.7-64 64z'
      
    ]
  };

  

  
  

  var faVenusDouble = {
    prefix: 'fat',
    iconName: 'venus-double',
    icon: [
      640,
      512,
      [9890],
      'f226',
      
      'M192 336a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM368 176c0 94.5-74.5 171.6-168 175.8V416h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H200v72c0 4.4-3.6 8-8 8s-8-3.6-8-8V432H104c-4.4 0-8-3.6-8-8s3.6-8 8-8h80V351.8C90.5 347.6 16 270.5 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176zM354.5 305.9c26.3 19 58.6 30.1 93.5 30.1c88.4 0 160-71.6 160-160s-71.6-160-160-160c-34.9 0-67.2 11.2-93.5 30.1C351.2 42 347.6 37.9 344 34C373.1 12.6 409.1 0 448 0c97.2 0 176 78.8 176 176c0 94.5-74.5 171.6-168 175.8V416h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H456v72c0 4.4-3.6 8-8 8s-8-3.6-8-8V432H360c-4.4 0-8-3.6-8-8s3.6-8 8-8h80V351.8c-35.8-1.6-68.9-13.9-96-33.8c3.7-3.9 7.2-8 10.5-12.1z'
      
    ]
  };

  

  
  

  var faRightFromLine = {
    prefix: 'fat',
    iconName: 'right-from-line',
    icon: [
      448,
      512,
      ["arrow-alt-from-left"],
      'f347',
      
      'M428.7 248c2.1 2.1 3.3 5 3.3 8s-1.2 5.9-3.3 8L296.6 395.8c-2.7 2.7-6.4 4.2-10.2 4.2c-8 0-14.4-6.5-14.4-14.4l0-73.6c0-4.4-3.6-8-8-8l-136 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16l136 0c4.4 0 8-3.6 8-8l0-73.6c0-8 6.5-14.4 14.4-14.4c3.8 0 7.5 1.5 10.2 4.2L428.7 248zm19.3 8c0-7.2-2.9-14.2-8-19.3L307.9 104.9c-5.7-5.7-13.4-8.9-21.5-8.9c-16.8 0-30.4 13.6-30.4 30.4l0 65.6-128 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l128 0 0 65.6c0 16.8 13.6 30.4 30.4 30.4c8.1 0 15.8-3.2 21.5-8.9L440 275.3c5.1-5.1 8-12.1 8-19.3zM0 72L0 440c0 4.4 3.6 8 8 8s8-3.6 8-8L16 72c0-4.4-3.6-8-8-8s-8 3.6-8 8z'
      
    ]
  };

  
    var faArrowAltFromLeft = faRightFromLine;
  

  
  

  var faPersonHiking = {
    prefix: 'fat',
    iconName: 'person-hiking',
    icon: [
      384,
      512,
      ["hiking"],
      'f6ec',
      
      'M208 48a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 48a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-70.9 86.7l-20.4 84c-3.9 16.3 .9 33.4 12.7 45.3l76.3 76.3c1.5 1.5 2.3 3.5 2.3 5.7V480c0 8.8 7.2 16 16 16s16-7.2 16-16V390.6c0-8.5-3.4-16.6-9.4-22.6l-52.9-52.9c-2-2-2.8-4.9-2.1-7.6l24.6-98.3c.8-3.1 3.3-5.4 6.4-5.9s6.3 .8 8 3.4l23.3 35c5.9 8.9 15.9 14.2 26.6 14.2H352c8.8 0 15.9-7.1 16-15.9v-.3c-.1-8.8-7.2-15.9-16-15.9H300.8c-2.7 0-5.2-1.3-6.7-3.6l-30.8-46.3c-8.7-13-21.9-22.3-37-26.1c-25.4-6.4-51.1 9.2-57.3 34.7zm198.9 85c-4.7 2.7-10.2 4.3-16 4.3H296.6c-16 0-31-8-39.9-21.4l-13.3-20L224.2 307l49.7 49.7c9 9 14.1 21.2 14.1 33.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V397.3l-73.9-73.9c-15.8-15.8-22.2-38.6-16.9-60.3l20.4-84c8.3-34.1 42.7-54.9 76.7-46.4c19 4.8 35.6 16.4 46.4 32.7L305.1 208H352c5.8 0 11.3 1.6 16 4.3V168c0-4.4 3.6-8 8-8s8 3.6 8 8v71.8l0 .2 0 .2V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V267.7zM117.3 334c3 4.2 6.4 8.2 10.1 11.9l2.6 2.6L96.5 475.9c-2.2 8.5 2.9 17.3 11.4 19.5s17.3-2.9 19.5-11.4l28.8-109.3 13.1 13.1L142.9 488.1c-4.5 17.1-22 27.3-39.1 22.8s-27.3-22-22.8-39.1L117.3 334zM109.1 88h4.2c20.8 0 36.1 19.6 31 39.8L109.1 268.4c-4 16.2-19.8 26.5-36.3 23.8l-47.9-8c-18.7-3.1-30.6-21.7-25.6-40l24.9-91.4C34.6 114.6 69.4 88 109.1 88zM39.6 157.1L14.7 248.5c-2.5 9.1 3.5 18.4 12.8 20l47.9 8c8.2 1.4 16.1-3.8 18.2-11.9l35.2-140.7c2.5-10.1-5.1-19.9-15.5-19.9h-4.2c-32.5 0-60.9 21.7-69.5 53.1z'
      
    ]
  };

  
    var faHiking = faPersonHiking;
  

  
  

  var faClosedCaptioning = {
    prefix: 'fat',
    iconName: 'closed-captioning',
    icon: [
      576,
      512,
      [],
      'f20a',
      
      'M512 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM192 176c24.8 0 47 11.3 61.6 29c2.8 3.4 7.9 3.9 11.3 1.1s3.9-7.9 1.1-11.3c-17.6-21.2-44.2-34.8-74-34.8c-53 0-96 43-96 96s43 96 96 96c29.8 0 56.4-13.6 74-34.8c2.8-3.4 2.3-8.4-1.1-11.3s-8.4-2.3-11.3 1.1c-14.7 17.7-36.8 29-61.6 29c-44.2 0-80-35.8-80-80s35.8-80 80-80zm128 80c0-44.2 35.8-80 80-80c24.8 0 47 11.3 61.6 29c2.8 3.4 7.9 3.9 11.3 1.1s3.9-7.9 1.1-11.3c-17.6-21.2-44.2-34.8-74-34.8c-53 0-96 43-96 96s43 96 96 96c29.8 0 56.4-13.6 74-34.8c2.8-3.4 2.3-8.4-1.1-11.3s-8.4-2.3-11.3 1.1c-14.7 17.7-36.8 29-61.6 29c-44.2 0-80-35.8-80-80z'
      
    ]
  };

  

  
  

  var faBadminton = {
    prefix: 'fat',
    iconName: 'badminton',
    icon: [
      576,
      512,
      [],
      'e33a',
      
      'M349 16c39.2 0 77 13.5 105.3 41.8S496 123.8 496 163c0 49.6-21.5 101.9-62.3 142.7c-72.2 72.2-183.4 85.1-248 20.5C157.5 297.9 144 260.2 144 221c0-49.6 21.5-101.9 62.3-142.7S299.3 16 349 16zm0-16c-54.2 0-110.5 23.4-154 66.9s-67 99.8-66.9 154c0 40.3 13.1 79.8 40.9 110.8l-32 32-10.3-10.3c-12.5-12.5-32.8-12.5-45.3 0l-72 72c-12.5 12.5-12.5 32.8 0 45.3l32 32c12.5 12.5 32.8 12.5 45.3 0l72-72c12.5-12.5 12.5-32.8 0-45.3L148.3 375l32-32c73.3 66.3 190.4 48.3 264.8-26c43.6-43.6 67-99.8 66.9-154c0-42.8-14.8-84.9-46.5-116.6S391.8 0 349 0zM92.7 364.7c6.2-6.2 16.4-6.2 22.6 0l32 32c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6l72-72zm367 99.3l-11.3 37.7c-1.3 4.2 1.1 8.7 5.4 10s8.7-1.1 10-5.4L476.4 464H459.6zm44.4 0v40c0 4.4 3.6 8 8 8s8-3.6 8-8V464H504zm43.6 0l12.7 42.3c1.3 4.2 5.7 6.6 10 5.4s6.6-5.7 5.4-10L564.4 464H547.6zM480 400c0-17.7 14.3-32 32-32s32 14.3 32 32v32H480V400zm80 0c0-26.5-21.5-48-48-48s-48 21.5-48 48v32 16h16 64 16V432 400z'
      
    ]
  };

  

  
  

  var faHouseMedicalCircleExclamation = {
    prefix: 'fat',
    iconName: 'house-medical-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e512',
      
      'M282.7 2c3-2.7 7.6-2.7 10.6 0l215 190.4c-4.1-.3-8.2-.4-12.3-.4c-4 0-8 .1-11.9 .4L288 18.7 80 202.9V448c0 26.5 21.5 48 48 48H375.2c6.1 5.8 12.7 11.1 19.6 16H128c-35.3 0-64-28.7-64-64V217.1L13.3 262c-3.3 2.9-8.4 2.6-11.3-.7S-.6 252.9 2.7 250L282.7 2zm84.6 246c-4.7 5.1-9.1 10.4-13.3 16H320c-4.4 0-8-3.6-8-8V200c0-4.4-3.6-8-8-8H272c-4.4 0-8 3.6-8 8v56c0 4.4-3.6 8-8 8H200c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h56c4.4 0 8 3.6 8 8v56c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8h8.2c.2 5.5 .7 10.9 1.5 16.3C317.3 397 311 400 304 400H272c-13.3 0-24-10.7-24-24V328H200c-13.3 0-24-10.7-24-24V272c0-13.3 10.7-24 24-24h48V200c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v48h39.3zM624 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0-136c4.4 0 8 3.6 8 8v96c0 4.4-3.6 8-8 8s-8-3.6-8-8V288c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faGearComplexCode = {
    prefix: 'fat',
    iconName: 'gear-complex-code',
    icon: [
      512,
      512,
      [],
      'e5eb',
      
      'M436.6 74.5l0 0c-8.3-8.2-17.1-15.9-26.4-22.9c-13.6-10.3-31.6-9.6-44.7-.9l-19.5 13c-2.2 1.5-5.7 2-9.4 .4l-1.8-.7c-3.7-1.5-5.8-4.3-6.3-6.9l-4.6-23c-3.1-15.5-15.4-28.6-32.2-31C279.9 .8 268.1 0 256 0s-23.9 .8-35.6 2.5c-16.9 2.3-29.1 15.5-32.2 31l-4.6 23c-.5 2.6-2.6 5.4-6.3 6.9l-1.8 .7c-3.7 1.5-7.1 1-9.4-.4l-19.5-13c-13.1-8.8-31.1-9.4-44.7 .9c-9.3 7.1-18.2 14.7-26.5 23l0 0-.8 .8 0 0c-8.2 8.3-15.9 17.1-23 26.5c-10.3 13.6-9.6 31.6-.9 44.7l13 19.5c1.5 2.2 2 5.7 .4 9.4l-.7 1.8c-1.5 3.7-4.3 5.8-6.9 6.3l-23 4.6c-15.5 3.1-28.6 15.4-31 32.2C.8 232.1 0 243.9 0 256s.8 23.9 2.5 35.6c2.3 16.9 15.5 29.1 31 32.2l23 4.6c2.6 .5 5.4 2.6 6.9 6.3l.7 1.8c1.5 3.7 1 7.1-.4 9.4l-13 19.5c-8.8 13.1-9.4 31.1 .9 44.7c14.4 19 31.3 36 50.3 50.3c13.6 10.3 31.6 9.6 44.7 .9l19.5-13c2.2-1.5 5.7-2 9.4-.4l1.8 .7c3.7 1.5 5.8 4.3 6.3 6.9l4.6 23c3.1 15.5 15.4 28.6 32.2 31c11.6 1.6 23.5 2.5 35.6 2.5s23.9-.8 35.6-2.5c16.9-2.3 29.1-15.5 32.2-31l4.6-23c.5-2.6 2.6-5.4 6.3-6.9l1.8-.7c3.7-1.5 7.1-1 9.4 .4l19.5 13c13.1 8.8 31.1 9.4 44.7-.9c19-14.4 36-31.3 50.3-50.3c10.3-13.6 9.6-31.6 .9-44.7l-13-19.5c-1.5-2.2-2-5.7-.4-9.4l.7-1.8c1.5-3.7 4.3-5.8 6.9-6.3l23-4.6c15.5-3.1 28.6-15.4 31-32.2c1.6-11.6 2.4-23.4 2.5-35.3v0-.4 0c0-12-.8-23.8-2.5-35.3c-2.3-16.9-15.5-29.1-31-32.2l-23-4.6c-2.6-.5-5.4-2.6-6.9-6.3l-.7-1.8c-1.5-3.7-1-7.1 .4-9.4l13-19.5c8.8-13.1 9.4-31.1-.9-44.7c-7-9.3-14.7-18.2-22.9-26.4l0 0-.9-.9zm11.1 37c5.8 7.7 5.7 18.2 .3 26.2l-13 19.5c-4.8 7.2-5.2 16.4-1.9 24.4l.7 1.7c3.3 8 10.1 14.2 18.6 15.9l23 4.6c9.4 1.9 16.9 9.2 18.3 18.8c1.5 10.8 2.3 21.9 2.3 33.1v.4c0 11.2-.8 22.3-2.3 33.1c-1.3 9.5-8.8 16.9-18.3 18.8l-23 4.6c-8.5 1.7-15.3 7.9-18.6 15.9l-.7 1.7c-3.4 8-2.9 17.2 1.9 24.4l13 19.5c5.3 8 5.5 18.5-.3 26.2c-13.5 17.8-29.4 33.7-47.2 47.2c-7.7 5.8-18.2 5.7-26.2 .3l-19.5-13c-7.2-4.8-16.4-5.2-24.4-1.9l-1.7 .7c-8 3.3-14.2 10.1-15.9 18.6l-4.6 23c-1.9 9.4-9.2 16.9-18.8 18.3c-10.9 1.5-22 2.3-33.4 2.3s-22.5-.8-33.4-2.3c-9.5-1.3-16.9-8.8-18.8-18.3l-4.6-23c-1.7-8.5-7.9-15.3-15.9-18.6l-1.7-.7c-8-3.4-17.2-2.9-24.4 1.9l-19.5 13c-8 5.3-18.5 5.5-26.2-.3c-17.8-13.5-33.7-29.4-47.2-47.2c-5.8-7.7-5.7-18.2-.3-26.2l13-19.5c4.8-7.2 5.2-16.4 1.9-24.4l-.7-1.7c-3.3-8-10.1-14.2-18.6-15.9l-23-4.6c-9.4-1.9-16.9-9.2-18.3-18.8c-1.5-10.9-2.3-22-2.3-33.4s.8-22.5 2.3-33.4c1.3-9.5 8.8-16.9 18.3-18.8l23-4.6c8.5-1.7 15.3-7.9 18.6-15.9l.7-1.7c3.4-8 2.9-17.2-1.9-24.4L64 137.7c-5.3-8-5.5-18.5 .3-26.2c6.6-8.8 13.8-17.1 21.5-24.8l.8-.8c7.8-7.7 16.1-14.9 24.8-21.5c7.7-5.8 18.2-5.7 26.2-.3l19.5 13c7.2 4.8 16.4 5.2 24.4 1.9l1.7-.7c8-3.3 14.2-10.1 15.9-18.6l4.6-23c1.9-9.4 9.2-16.9 18.8-18.3c10.9-1.5 22-2.3 33.4-2.3s22.5 .8 33.4 2.3c9.5 1.3 16.9 8.8 18.8 18.3l4.6 23c1.7 8.5 7.9 15.3 15.9 18.6l1.7 .7c8 3.4 17.2 2.9 24.4-1.9l19.5-13c8-5.3 18.5-5.5 26.2 .3c8.7 6.6 17 13.8 24.8 21.5l.9 .9c7.7 7.8 14.9 16 21.5 24.8zM279.9 161.3c.7-4.4-2.2-8.5-6.6-9.2s-8.5 2.2-9.2 6.6l-32 192c-.7 4.4 2.2 8.5 6.6 9.2s8.5-2.2 9.2-6.6l32-192zm-98.2 60.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-40 40c-3.1 3.1-3.1 8.2 0 11.3l40 40c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L147.3 256l34.3-34.3zm160-11.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L364.7 256l-34.3 34.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l40-40c3.1-3.1 3.1-8.2 0-11.3l-40-40z'
      
    ]
  };

  

  
  

  var faCirclePhoneHangup = {
    prefix: 'fat',
    iconName: 'circle-phone-hangup',
    icon: [
      512,
      512,
      ["phone-circle-down"],
      'e11d',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM105.6 254.6c-2.7-4.4-2-10 2.1-13.7c81.8-75.8 214.8-75.8 296.6 0c4.1 3.8 4.8 9.3 2.1 13.7l-21.7 35.2c-3.2 5.1-10.4 7.7-17 5.2l-46.2-17.6c-5.7-2.2-8.5-7.2-8-11.9l2.9-26.7c.4-3.8-1.9-7.3-5.5-8.5c-35.4-11.4-74.1-11.4-109.4 0c-3.6 1.2-5.9 4.7-5.5 8.5l2.9 26.7c.5 4.8-2.4 9.8-8 11.9L144.4 295c-6.6 2.5-13.9-.1-17-5.2l-21.7-35.2zm309.5-25.5c-88-81.5-230.4-81.5-318.3 0c-9.5 8.8-11.7 22.8-4.8 33.9l21.7 35.2c7.5 12.1 23.1 16.8 36.4 11.8l46.2-17.6c11.8-4.5 19.6-16 18.2-28.6l-2.2-20c28.4-7.9 58.8-7.9 87.2 0l-2.2 20c-1.4 12.7 6.4 24.1 18.2 28.6L361.9 310c13.3 5.1 28.9 .4 36.4-11.8L420 263c6.9-11.1 4.7-25.1-4.8-33.9z'
      
    ]
  };

  
    var faPhoneCircleDown = faCirclePhoneHangup;
  

  
  

  var faCompressWide = {
    prefix: 'fat',
    iconName: 'compress-wide',
    icon: [
      512,
      512,
      [],
      'f326',
      
      'M144 72c0-4.4 3.6-8 8-8s8 3.6 8 8V216c0 4.4-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H144V72zm8 216c4.4 0 8 3.6 8 8V440c0 4.4-3.6 8-8 8s-8-3.6-8-8V304H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H152zM368 72V208H504c4.4 0 8 3.6 8 8s-3.6 8-8 8H360c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8s8 3.6 8 8zm-8 216H504c4.4 0 8 3.6 8 8s-3.6 8-8 8H368V440c0 4.4-3.6 8-8 8s-8-3.6-8-8V296c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faFaceSpiralEyes = {
    prefix: 'fat',
    iconName: 'face-spiral-eyes',
    icon: [
      512,
      512,
      [],
      'e485',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM317.3 381.5l14.8-9.9c11.9-8 27.2-8.9 40.1-2.5l15.4 7.7c4 2 5.6 6.8 3.6 10.7s-6.8 5.6-10.7 3.6L365 383.5c-7.7-3.8-16.9-3.3-24 1.5l-14.8 9.9c-13.4 9-30.9 9-44.4 0l-12.5-8.3c-8.1-5.4-18.6-5.4-26.6 0l-12.5 8.3c-13.4 9-30.9 9-44.4 0L171 385c-7.2-4.8-16.3-5.3-24-1.5l-15.4 7.7c-4 2-8.8 .4-10.7-3.6s-.4-8.8 3.6-10.7l15.4-7.7c12.8-6.4 28.1-5.5 40.1 2.5l14.8 9.9c8.1 5.4 18.6 5.4 26.6 0l12.5-8.3c13.4-9 30.9-9 44.4 0l12.5 8.3c8.1 5.4 18.6 5.4 26.6 0zM169.9 111.7c.2 4.4-3.3 8.1-7.7 8.3c-49.1 2-86.3 47-81.9 88.7l0 .2 0 .2c2.1 42.5 43 74.7 80.6 70.5l.4 0 0 0c38.5-2.2 66.2-37.7 62.1-69l0-.2 0-.2c-2.3-32.2-33.5-55-60.5-51.2l-.4 .1 0 0c-27.9 2.3-46.1 28.4-42.5 49.2l0 .2 0 .2c2.4 21.8 23.9 35.3 40.2 32l.2 0 .2 0c17.3-2.4 25.9-18.8 23.2-29l-.1-.2 0-.2c-1.1-5.5-4.4-9.5-8.4-11.9c-4.2-2.5-8.3-2.6-10.7-1.7l-.3 .1-.3 .1c-3 .9-4.6 2.8-5.4 4.5c.7-.3 1.5-.5 2.3-.6c4.4-.4 8.3 2.8 8.7 7.2c.7 8-6.4 11.6-10.6 12.1c-5.1 .6-10.5-1.7-13.9-6.8c-4-5.4-3.6-12.5-1.4-18c2.4-5.9 7.6-11.3 15.3-13.7c7.8-2.8 16.9-1.2 24.2 3c7.5 4.4 13.9 12 16 22.3c5.2 20.3-10.7 45-36.3 48.7c-25.4 4.9-55.5-15-59-45.8c-5.1-30.6 20.5-64.4 56.8-67.6c36-4.9 75.4 24.4 78.5 65.7c5.1 40.9-29.9 84-76.9 86.8c-46.6 5.1-95.5-33.7-98.2-85.4c-5.3-51.4 39.4-103.8 97.2-106.2c4.4-.2 8.1 3.3 8.3 7.7zM349.8 296c49.1-2 86.3-47 81.9-88.7l0-.2 0-.2c-2.1-42.5-43-74.7-80.6-70.5l-.4 0 0 0c-38.5 2.2-66.2 37.7-62.1 69l0 .2 0 .2c2.3 32.2 33.5 55 60.5 51.2l.4-.1 0 0c27.9-2.3 46.1-28.4 42.5-49.2l0-.2 0-.2c-2.4-21.8-24-35.3-40.2-32l-.2 0-.2 0c-17.3 2.4-25.9 18.8-23.2 29l.1 .2 0 .2c1.1 5.5 4.5 9.5 8.4 11.9c4.2 2.5 8.3 2.6 10.7 1.7l.3-.1 .3-.1c3-.9 4.6-2.8 5.4-4.5c-.7 .3-1.5 .5-2.3 .6c-4.4 .4-8.3-2.8-8.7-7.2c-.7-8 6.4-11.6 10.6-12.1c5.1-.6 10.5 1.7 13.9 6.8c4 5.4 3.6 12.5 1.4 18c-2.4 5.9-7.6 11.3-15.3 13.7c-7.8 2.8-16.9 1.2-24.2-3c-7.5-4.4-13.9-12-16-22.3c-5.2-20.3 10.7-45 36.3-48.7c25.4-4.9 55.5 15 59 45.8c5.1 30.6-20.5 64.4-56.8 67.6c-36 4.9-75.4-24.4-78.5-65.7c-5.1-40.9 29.9-84 76.9-86.8c46.6-5.1 95.5 33.7 98.2 85.4c5.3 51.4-39.4 103.8-97.2 106.2c-4.4 .2-8.1-3.3-8.3-7.7s3.3-8.1 7.7-8.3z'
      
    ]
  };

  

  
  

  var faArrowUpFromArc = {
    prefix: 'fat',
    iconName: 'arrow-up-from-arc',
    icon: [
      512,
      512,
      [],
      'e4b4',
      
      'M256 496C123.5 496 16 388.5 16 256c0-4.4-3.6-8-8-8s-8 3.6-8 8C0 397.4 114.6 512 256 512s256-114.6 256-256c0-4.4-3.6-8-8-8s-8 3.6-8 8c0 132.5-107.5 240-240 240zM121.9 154.8c-2.8 3.4-2.4 8.4 1 11.3s8.4 2.4 11.3-1L248 29.9 248 344c0 4.4 3.6 8 8 8s8-3.6 8-8l0-314.1L377.9 165.2c2.8 3.4 7.9 3.8 11.3 1s3.8-7.9 1-11.3l-128-152C260.6 1 258.4 0 256 0s-4.6 1-6.1 2.8l-128 152z'
      
    ]
  };

  

  
  

  var faPipeValve = {
    prefix: 'fat',
    iconName: 'pipe-valve',
    icon: [
      512,
      512,
      [],
      'e439',
      
      'M264 40c0-4.4-3.6-8-8-8s-8 3.6-8 8V70.6L144.8 54.3C119.2 50.3 96 70.1 96 96s23.2 45.7 48.8 41.7L248 121.4V192H64c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32H448c0 17.7 14.3 32 32 32s32-14.3 32-32V192c0-17.7-14.3-32-32-32s-32 14.3-32 32H264V121.4l103.2 16.3c25.6 4 48.8-15.7 48.8-41.7s-23.2-45.7-48.8-41.7L264 70.6V40zM448 208V432H64V208H256 448zM248 86.8v18.3L142.3 121.9C126.4 124.4 112 112.1 112 96s14.4-28.4 30.3-25.9L248 86.8zm16 0L369.7 70.1C385.6 67.6 400 79.9 400 96s-14.4 28.4-30.3 25.9L264 105.2V86.8zM48 448c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16V448zM496 192V448c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faClockFiveThirty = {
    prefix: 'fat',
    iconName: 'clock-five-thirty',
    icon: [
      512,
      512,
      [],
      'e34a',
      
      'M16 256a240 240 0 1 1 480 0A240 240 0 1 1 16 256zm496 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM264 408V282.4l49.3 74c2.5 3.7 7.4 4.7 11.1 2.2s4.7-7.4 2.2-11.1l-64-96c-2-2.9-5.6-4.2-9-3.2s-5.7 4.1-5.7 7.7V408c0 4.4 3.6 8 8 8s8-3.6 8-8z'
      
    ]
  };

  

  
  

  var faPersonRifle = {
    prefix: 'fat',
    iconName: 'person-rifle',
    icon: [
      576,
      512,
      [],
      'e54e',
      
      'M265.2 192c25.4 0 49.8 7.1 70.8 19.9v19.2c-20.2-14.8-44.9-23.1-70.8-23.1H214.8c-42.4 0-81.7 22.4-103.3 59L35.3 395.8c-6.7 11.4-3 26.1 8.5 32.9s26.1 3 32.9-8.5l53.6-90.6c3.7-6.2 11-9.2 18-7.3s11.8 8.2 11.8 15.4V480c0 8.8 7.2 16 16 16H304c8.8 0 16-7.2 16-16V337.7c0-7.2 4.8-13.5 11.8-15.4c1.4-.4 2.8-.6 4.2-.6V480.6c-.3 17.4-14.5 31.4-32 31.4H176c-17.7 0-32-14.3-32-32V369.2 337.7l-16 27.1L90.4 428.3c-11.2 19-35.8 25.3-54.8 14.1s-25.3-35.8-14.1-54.8L97.7 258.8c24.5-41.4 69-66.8 117.1-66.8h50.4zM240 144a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM240 0a80 80 0 1 1 0 160A80 80 0 1 1 240 0zM456 146.1c-4.9-2.9-8-8.1-8-13.8V16h-8-8V132.3c0 5.7-3 11-8 13.8c-4.8 2.8-8 8-8 13.9v32V384h54 2 56V368H480c-8.8 0-16-7.2-16-16V325.3v-56V256 160c0-5.9-3.2-11.1-8-13.9zM416 496h72.9L455 405.6c-.7-1.8-1-3.7-1-5.6H416v96zm56-96h-2l6 16 27.9 74.4c3.9 10.5-3.8 21.6-15 21.6H416c-8.8 0-16-7.2-16-16V416 400c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32V176 160c0-11.8 6.4-22.2 16-27.7V32 16h-8c-4.4 0-8-3.6-8-8s3.6-8 8-8h8 24 8c8.8 0 16 7.2 16 16V132.3c9.6 5.5 16 15.9 16 27.7v48 44.5V256v8 5.3l16-5.3V208c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v84.5c0 6.9-4.4 13-10.9 15.2L480 325.3V336v16h16 32c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H487.1 472zm8-91.5l48-16V208H512v56c0 6.9-4.4 13-10.9 15.2l-16 5.3c-1.7 .6-3.4 .8-5.1 .8v23.1zM384 224V368c0 8.8 7.2 16 16 16V208c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faDiagramNext = {
    prefix: 'fat',
    iconName: 'diagram-next',
    icon: [
      512,
      512,
      [],
      'e476',
      
      'M496 160c0 26.5-21.5 48-48 48L64 208c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48l384 0c26.5 0 48 21.5 48 48v64zm-48 64c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64H248V348.7l-50.3-50.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l64 64c3.1 3.1 8.2 3.1 11.3 0l64-64c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L264 348.7V224H448zm64 192V352c0-35.3-28.7-64-64-64H400c-4.4 0-8 3.6-8 8s3.6 8 8 8h48c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48L64 464c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48h48c4.4 0 8-3.6 8-8s-3.6-8-8-8H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64z'
      
    ]
  };

  

  
  

  var faChartTreeMap = {
    prefix: 'fat',
    iconName: 'chart-tree-map',
    icon: [
      512,
      512,
      [],
      'e0ea',
      
      'M176 48c17.7 0 32 14.3 32 32V192c0 17.7-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V80c0-17.7 14.3-32 32-32H176zM48 32C21.5 32 0 53.5 0 80V192c0 26.5 21.5 48 48 48H176c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zM176 288c17.7 0 32 14.3 32 32V432c0 17.7-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32H176zM48 272c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48H176c26.5 0 48-21.5 48-48V320c0-26.5-21.5-48-48-48H48zM304 48H464c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H304c-17.7 0-32-14.3-32-32V80c0-17.7 14.3-32 32-32zM256 80v32c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48zM464 208c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H304c-17.7 0-32-14.3-32-32V240c0-17.7 14.3-32 32-32H464zM304 192c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H304zm0 176H464c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H304c-17.7 0-32-14.3-32-32V400c0-17.7 14.3-32 32-32zm-48 32v32c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V400c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48z'
      
    ]
  };

  

  
  

  var faTty = {
    prefix: 'fat',
    iconName: 'tty',
    icon: [
      512,
      512,
      ["teletype"],
      'f1e4',
      
      'M354 148.8c0-6.9-4.4-13.1-11-15.2c-56.5-18.5-117.4-18.5-173.9 0c-6.6 2.2-11 8.3-11 15.2v53.4c0 12-8.9 22.2-20.8 23.8L61.1 236c-11 1.5-21.5-4.8-25.5-15.1L23.1 188.7c-8.3-21.3-4.3-43.5 10.4-56.5C77.2 93.7 154.9 48 256 48s178.8 45.7 222.4 84.3c14.7 13 18.7 35.2 10.4 56.5l-12.4 32.1c-4 10.3-14.6 16.6-25.5 15.1l-76.1-10.1c-11.9-1.6-20.8-11.8-20.8-23.8V148.8zm-180 0c53.3-17.4 110.7-17.4 164 0v53.4c0 20.1 14.9 37 34.7 39.7l76.1 10.1c18.3 2.4 35.9-8 42.6-25.2l12.4-32.1c10.1-26 6.2-55.8-14.8-74.2C443.3 79.9 362 32 256 32S68.7 79.9 23 120.3C2 138.7-1.9 168.5 8.2 194.5l12.4 32.1c6.7 17.2 24.3 27.6 42.6 25.2l76.1-10.1c19.9-2.6 34.7-19.6 34.7-39.7V148.8zM72 288c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V312c0-13.3-10.7-24-24-24H72zm-8 24c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8V312zm8 88c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V424c0-13.3-10.7-24-24-24H72zm-8 24c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8V424zm344-24c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V424c0-13.3-10.7-24-24-24H408zm-8 24c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H408c-4.4 0-8-3.6-8-8V424zm-240 0v32c0 13.3 10.7 24 24 24H328c13.3 0 24-10.7 24-24V424c0-13.3-10.7-24-24-24H184c-13.3 0-24 10.7-24 24zm24-8H328c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H184c-4.4 0-8-3.6-8-8V424c0-4.4 3.6-8 8-8zM160 312v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V312c0-13.3-10.7-24-24-24H184c-13.3 0-24 10.7-24 24zm24-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H184c-4.4 0-8-3.6-8-8V312c0-4.4 3.6-8 8-8zm112-16c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V312c0-13.3-10.7-24-24-24H296zm-8 24c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H296c-4.4 0-8-3.6-8-8V312zm96 0v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V312c0-13.3-10.7-24-24-24H408c-13.3 0-24 10.7-24 24zm24-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H408c-4.4 0-8-3.6-8-8V312c0-4.4 3.6-8 8-8z'
      
    ]
  };

  
    var faTeletype = faTty;
  

  
  

  var faLaptopFile = {
    prefix: 'fat',
    iconName: 'laptop-file',
    icon: [
      640,
      512,
      [],
      'e51d',
      
      'M448 16H128c-26.5 0-48 21.5-48 48V288H320v16H80 64 19.2c-1.8 0-3.2 1.4-3.2 3.2C16 340.8 43.2 368 76.8 368H320v16H76.8C34.4 384 0 349.6 0 307.2C0 296.6 8.6 288 19.2 288H64V64C64 28.7 92.7 0 128 0H448c35.3 0 64 28.7 64 64V96H496V64c0-26.5-21.5-48-48-48zM624 464V259.9c0-1.3-.1-2.6-.2-3.9H552c-22.1 0-40-17.9-40-40V144.2c-1.3-.2-2.6-.2-3.9-.2H400c-17.7 0-32 14.3-32 32V464c0 17.7 14.3 32 32 32H592c17.7 0 32-14.3 32-32zM528 150.9V216c0 13.3 10.7 24 24 24h65.1c-.8-1-1.6-1.9-2.4-2.7l-83.9-83.9c-.9-.9-1.8-1.7-2.7-2.4zM592 512H400c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48H508.1c12.7 0 24.9 5.1 33.9 14.1l83.9 83.9c9 9 14.1 21.2 14.1 33.9V464c0 26.5-21.5 48-48 48z'
      
    ]
  };

  

  
  

  var faFlagUsa = {
    prefix: 'fat',
    iconName: 'flag-usa',
    icon: [
      448,
      512,
      [],
      'f74d',
      
      'M16 8c0-4.4-3.6-8-8-8S0 3.6 0 8V64 383.5 400 504c0 4.4 3.6 8 8 8s8-3.6 8-8V396l112.3-28.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30V54.8c0-17.8-18.8-29.4-34.7-21.5l-19.7 9.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L16 60V8zm0 301.9l121.4-26c35.2-7.5 71.7-4.6 105.2 8.4l25.8 10c43.5 16.9 91.5 18.1 135.7 3.3l27.7-9.2v49.4c0 6.7-4.1 12.6-10.4 15l-34.7 13c-42.1 15.8-88.8 13.3-129-6.8c-41.3-20.7-88.7-25.9-133.5-14.7L16 379.5V309.9zm0-16.4V237.9l116.6-25c38.1-8.2 77.7-4 113.3 11.8l13.8 6.2c48.7 21.6 104 23 153.7 3.6l18.6-7.2v52.3l-32.8 10.9c-40.7 13.6-84.9 12.5-124.9-3.1l-25.8-10c-36.4-14.2-76.2-17.3-114.4-9.2L16 293.5zm0-72V76.5L136.8 46.3c7.6-1.9 15.4-3.2 23.2-3.9V193.1c-10.3 .6-20.6 1.9-30.8 4.1L16 221.5zm160-28.6v-64c24 .6 47.7 5.9 69.9 15.8l13.8 6.2c48.7 21.6 104 23 153.7 3.6l18.6-7.2v62.8l-24.4 9.5c-45.7 17.8-96.6 16.6-141.4-3.3l-13.8-6.2c-24.2-10.8-50.2-16.5-76.4-17.2zm0-80v-71c21.8 .5 43.5 5.7 63.3 15.6c50.8 25.4 110.6 25.4 161.5 0l19.7-9.8c5.3-2.7 11.6 1.2 11.6 7.2v75.2l-24.4 9.5c-45.7 17.8-96.6 16.6-141.4-3.3l-13.8-6.2c-24.2-10.8-50.2-16.5-76.4-17.2zM72 108a12 12 0 1 0 -24 0 12 12 0 1 0 24 0zm44-4a12 12 0 1 0 0-24 12 12 0 1 0 0 24zM72 164a12 12 0 1 0 -24 0 12 12 0 1 0 24 0zm44-4a12 12 0 1 0 0-24 12 12 0 1 0 0 24z'
      
    ]
  };

  

  
  

  var faCitrus = {
    prefix: 'fat',
    iconName: 'citrus',
    icon: [
      512,
      512,
      [],
      'e2f4',
      
      'M384 112c44.2 0 80-35.8 80-80V16H384c-44.2 0-80 35.8-80 80v16h80zm0 16H304c-8.8 0-16-7.2-16-16V96c0-15.8 3.8-30.8 10.6-43.9C284.8 49.4 270.6 48 256 48C132.3 48 32 148.3 32 272s100.3 224 224 224s224-100.3 224-224c0-46.6-14.2-89.8-38.5-125.6c4.8-2.4 9.4-5.1 13.8-8.1C481 176.5 496 222.5 496 272c0 132.5-107.5 240-240 240S16 404.5 16 272S123.5 32 256 32c17.8 0 35.1 1.9 51.8 5.6C325.3 14.7 353 0 384 0h80c8.8 0 16 7.2 16 16V32c0 53-43 96-96 96z'
      
    ]
  };

  

  
  

  var faLightsHoliday = {
    prefix: 'fat',
    iconName: 'lights-holiday',
    icon: [
      640,
      512,
      [],
      'f7b2',
      
      'M12.2 65.2c-3.8-2.3-8.7-1.1-11 2.7s-1.1 8.7 2.7 11l5.7 3.5c91.7 56 197.1 85.7 304.5 85.7H320h5.9c107.5 0 212.8-29.6 304.5-85.7l5.7-3.5c3.8-2.3 5-7.2 2.7-11s-7.2-5-11-2.7l-5.7 3.5C532.9 123.2 430.4 152 325.9 152H320h-5.9c-104.5 0-207-28.8-296.2-83.3l-5.7-3.5zM128.1 248.7c-31-7.2-62.8 8.7-73.5 38.2c-17.3 47.4 3 122.9 21 129.4s82-38.3 99.3-85.7c10.7-29.5-3.4-62.2-31.7-76.5l28.8-79.1c-5.2-1.3-10.4-2.6-15.6-4l-28.2 77.6zM312 272.5c-31.6 3.8-56 29.7-56 61.1C256 384 300.8 448 320 448s64-64 64-114.5c0-31.4-24.4-57.3-56-61.1V192l-2.1 0H320h-5.9l-2.1 0v80.5zm184.9-18.3c-28.4 14.4-42.5 47-31.7 76.5c17.3 47.4 81.2 92.2 99.3 85.7s38.2-82 21-129.4c-10.7-29.5-42.5-45.5-73.5-38.2l-28.2-77.6c-5.2 1.4-10.4 2.7-15.6 4l28.8 79.1zM69.6 292.4c8.4-23.1 35.2-35.6 60.7-26.4s37.9 36.1 29.5 59.2c-7.2 19.9-25.1 40.7-44.3 56.1c-9.5 7.6-18.6 13.2-25.9 16.6c-3.7 1.7-6.5 2.6-8.4 3c-1.2-1.5-2.8-4-4.5-7.7c-3.5-7.3-6.8-17.5-9.2-29.4c-4.8-24.1-5.1-51.5 2.1-71.4zM320 288c27.1 0 48 21 48 45.5c0 21.2-9.7 46.8-22.5 67.8c-6.3 10.3-12.9 18.8-18.7 24.4c-2.9 2.8-5.2 4.6-6.9 5.6c-1.7-1-4-2.8-6.9-5.6c-5.7-5.6-12.4-14.1-18.7-24.4c-12.8-21-22.5-46.7-22.5-67.8c0-24.6 20.9-45.5 48-45.5zm189.7-21.9c25.5-9.3 52.3 3.3 60.7 26.4c7.2 19.9 6.9 47.3 2.1 71.4c-2.4 11.9-5.7 22.1-9.2 29.4c-1.7 3.6-3.3 6.1-4.5 7.7c-1.9-.4-4.7-1.3-8.4-3c-7.3-3.3-16.4-9-25.9-16.6c-19.2-15.3-37.1-36.2-44.3-56.1c-8.4-23.1 4.1-49.9 29.5-59.2z'
      
    ]
  };

  

  
  

  var faPipeCollar = {
    prefix: 'fat',
    iconName: 'pipe-collar',
    icon: [
      512,
      512,
      [],
      'e437',
      
      'M56.5 382.1c5-5 6.1-12.7 2.7-19C41.9 331.3 32 294.8 32 256s9.9-75.3 27.2-107.1c3.4-6.2 2.3-14-2.7-19L31.2 104.6C21.5 94.8 16 81.6 16 67.9C16 39.2 39.2 16 67.9 16c13.8 0 27 5.5 36.7 15.2l25.3 25.3c5 5 12.7 6.1 19 2.7C180.7 41.9 217.2 32 256 32s75.3 9.9 107.1 27.2c6.2 3.4 14 2.3 19-2.7l25.3-25.3c9.7-9.7 22.9-15.2 36.7-15.2C472.8 16 496 39.2 496 67.9c0 13.8-5.5 27-15.2 36.7l-25.3 25.3c-5 5-6.1 12.7-2.7 19C470.1 180.7 480 217.2 480 256s-9.9 75.3-27.2 107.1c-3.4 6.2-2.3 14 2.7 19l25.3 25.3c9.7 9.7 15.2 22.9 15.2 36.7c0 28.7-23.2 51.9-51.9 51.9c-13.8 0-27-5.5-36.7-15.2l-25.3-25.3c-5-5-12.7-6.1-19-2.7C331.3 470.1 294.8 480 256 480s-75.3-9.9-107.1-27.2c-6.2-3.4-14-2.3-19 2.7l-25.3 25.3C94.8 490.5 81.6 496 67.9 496C39.2 496 16 472.8 16 444.1c0-13.8 5.5-27 15.2-36.7l25.3-25.3zM496 256c0-41.6-10.6-80.7-29.2-114.8l25.3-25.3c12.7-12.7 19.9-30 19.9-48C512 30.4 481.6 0 444.1 0c-18 0-35.3 7.2-48 19.9L370.8 45.2C336.7 26.6 297.6 16 256 16s-80.7 10.6-114.8 29.2L115.9 19.9C103.2 7.2 85.9 0 67.9 0C30.4 0 0 30.4 0 67.9c0 18 7.2 35.3 19.9 48l25.3 25.3C26.6 175.3 16 214.4 16 256s10.6 80.7 29.2 114.8L19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9l25.3-25.3C175.3 485.4 214.4 496 256 496s80.7-10.6 114.8-29.2l25.3 25.3c12.7 12.7 30 19.9 48 19.9c37.5 0 67.9-30.4 67.9-67.9c0-18-7.2-35.3-19.9-48l-25.3-25.3C485.4 336.7 496 297.6 496 256zM64 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM80 448a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM448 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 368a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM112 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm304 0A160 160 0 1 0 96 256a160 160 0 1 0 320 0z'
      
    ]
  };

  

  
  

  var faPersonDressSimple = {
    prefix: 'fat',
    iconName: 'person-dress-simple',
    icon: [
      256,
      512,
      [],
      'e21c',
      
      'M176 64A48 48 0 1 0 80 64a48 48 0 1 0 96 0zM64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zm2.1 146.8L27 347.6C24.1 357.8 31.8 368 42.4 368H64h48 32 48 21.6c10.6 0 18.3-10.2 15.4-20.4L189.9 210.8C184 190.2 165.2 176 143.7 176H112.3c-21.4 0-40.3 14.2-46.2 34.8zM136 384H120v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H42.4c-21.3 0-36.6-20.3-30.8-40.8L50.7 206.4c7.8-27.5 33-46.4 61.5-46.4h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H200v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384zm48 0H152v96c0 8.8 7.2 16 16 16s16-7.2 16-16V384zM72 384v96c0 8.8 7.2 16 16 16s16-7.2 16-16V384H72z'
      
    ]
  };

  

  
  

  var faCircleB = {
    prefix: 'fat',
    iconName: 'circle-b',
    icon: [
      512,
      512,
      [],
      'e0fd',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 152V256 360c0 13.3 10.7 24 24 24H292c37.6 0 68-30.4 68-68c0-31.6-21.6-58.2-50.9-65.8C325.4 237.8 336 218.1 336 196c0-37.6-30.4-68-68-68H184c-13.3 0-24 10.7-24 24zm160 44c0 28.7-23.3 52-52 52H176V152c0-4.4 3.6-8 8-8h84c28.7 0 52 23.3 52 52zM176 360V264h92 24c28.7 0 52 23.3 52 52s-23.3 52-52 52H184c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faRightLong = {
    prefix: 'fat',
    iconName: 'right-long',
    icon: [
      512,
      512,
      ["long-arrow-alt-right"],
      'f30b',
      
      'M336 200l0-81.1c0-3.8 3.1-6.9 6.9-6.9c1.8 0 3.5 .7 4.7 1.9L495.2 254.1c.5 .5 .8 1.2 .8 1.9s-.3 1.4-.8 1.9L347.6 398.1c-1.3 1.2-3 1.9-4.7 1.9c-3.8 0-6.9-3.1-6.9-6.9l0-81.1c0-8.8-7.2-16-16-16L40 296c-13.3 0-24-10.7-24-24l0-32c0-13.3 10.7-24 24-24l280 0c8.8 0 16-7.2 16-16zm170.2 42.5L358.6 102.3c-4.2-4-9.9-6.3-15.8-6.3c-12.6 0-22.9 10.2-22.9 22.9l0 65.1 0 16-16 0L40 200c-22.1 0-40 17.9-40 40l0 32c0 22.1 17.9 40 40 40l264 0 16 0 0 16 0 65.1c0 12.6 10.2 22.9 22.9 22.9c5.9 0 11.5-2.3 15.8-6.3L506.2 269.5c3.7-3.5 5.8-8.4 5.8-13.5s-2.1-10-5.8-13.5z'
      
    ]
  };

  
    var faLongArrowAltRight = faRightLong;
  

  
  

  var faLaptopSlash = {
    prefix: 'fat',
    iconName: 'laptop-slash',
    icon: [
      640,
      512,
      [],
      'e1c7',
      
      'M13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7zM487.3 480l-20.3-16H76.8C43.2 464 16 436.8 16 403.2c0-1.8 1.4-3.2 3.2-3.2H386l-20.3-16H19.2C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480H487.3zM560 352h16V96c0-35.3-28.7-64-64-64H152.3l20.3 16H512c26.5 0 48 21.5 48 48V352zM64 145.8V352H80V158.4L64 145.8z'
      
    ]
  };

  

  
  

  var faCoin = {
    prefix: 'fat',
    iconName: 'coin',
    icon: [
      512,
      512,
      [129689],
      'f85c',
      
      'M256 336c68.5 0 129.7-15.6 173.2-40.1c44-24.8 66.8-56.5 66.8-87.9s-22.8-63.1-66.8-87.9C385.7 95.6 324.5 80 256 80s-129.7 15.6-173.2 40.1C38.8 144.9 16 176.6 16 208s22.8 63.1 66.8 87.9C126.3 320.4 187.5 336 256 336zM0 208C0 128.5 114.6 64 256 64s256 64.5 256 144l0 16 0 96c0 70.7-114.6 128-256 128S0 390.7 0 320l0-96 0-16zM168 343.3l0 80.7c24.8 4.7 51.8 7.5 80 8l0-80c-28-.5-54.9-3.5-80-8.7zm-16-3.6c-23.4-5.9-44.9-13.6-64-23L88 399c18.6 8.7 40.2 16 64 21.6l0-81zM16 258.2L16 320c0 24 18.2 49.5 56 70.8l0-82.7C47.7 294 28.4 277 16 258.2zM344 424l0-80.7c-25.1 5.2-52 8.2-80 8.7l0 80c28.2-.4 55.2-3.2 80-8zm16-84.3l0 81c23.8-5.5 45.4-12.8 64-21.6l0-82.4c-19.1 9.3-40.6 17.1-64 23zM496 320l0-61.8c-12.4 18.8-31.7 35.7-56 49.9l0 82.7c37.8-21.3 56-46.8 56-70.8zM256 128c-49.9 0-94.8 9.3-126.8 23.9C96.5 166.8 80 185.9 80 204s16.5 37.2 49.2 52.1c32 14.6 76.9 23.9 126.8 23.9s94.8-9.3 126.8-23.9c32.7-14.9 49.2-34 49.2-52.1s-16.5-37.2-49.2-52.1C350.8 137.3 305.9 128 256 128zm192 76c0 28.2-24.7 51.2-58.6 66.7C354.9 286.5 307.7 296 256 296s-98.9-9.5-133.4-25.3C88.7 255.2 64 232.2 64 204s24.7-51.2 58.6-66.7C157.1 121.5 204.3 112 256 112s98.9 9.5 133.4 25.3C423.3 152.8 448 175.8 448 204z'
      
    ]
  };

  

  
  

  var faPowerOff = {
    prefix: 'fat',
    iconName: 'power-off',
    icon: [
      512,
      512,
      [9211],
      'f011',
      
      'M264 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V248c0 4.4 3.6 8 8 8s8-3.6 8-8V8zM157 71.1c3.9-2 5.5-6.9 3.4-10.8s-6.9-5.5-10.8-3.4C75 95.5 24 173.3 24 263.1c0 128.1 103.9 232 232 232s232-103.9 232-232c0-89.8-51-167.7-125.6-206.2c-3.9-2-8.8-.5-10.8 3.4s-.5 8.8 3.4 10.8c69.5 35.9 117 108.4 117 192c0 119.3-96.7 216-216 216s-216-96.7-216-216c0-83.6 47.5-156.1 117-192z'
      
    ]
  };

  

  
  

  var faTicket = {
    prefix: 'fat',
    iconName: 'ticket',
    icon: [
      576,
      512,
      [127903],
      'f145',
      
      'M64 64C28.7 64 0 92.7 0 128v72.6c0 4 2.9 7.4 6.9 7.9C30.1 211.8 48 231.8 48 256s-17.9 44.2-41.1 47.5c-3.9 .6-6.9 3.9-6.9 7.9V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V311.4c0-4-2.9-7.4-6.9-7.9C545.9 300.2 528 280.2 528 256s17.9-44.2 41.1-47.5c3.9-.6 6.9-3.9 6.9-7.9V128c0-35.3-28.7-64-64-64H64zM16 128c0-26.5 21.5-48 48-48H512c26.5 0 48 21.5 48 48v66c-27.6 7.1-48 32.2-48 62s20.4 54.9 48 62v66c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V318c27.6-7.1 48-32.2 48-62s-20.4-54.9-48-62V128zm144 48H416c8.8 0 16 7.2 16 16V320c0 8.8-7.2 16-16 16H160c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16zm-32 16V320c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32z'
      
    ]
  };

  

  
  

  var faSwordLaserAlt = {
    prefix: 'fat',
    iconName: 'sword-laser-alt',
    icon: [
      512,
      512,
      [],
      'e03c',
      
      'M349.9 224L504.8 48.2c4.7-5.3 7.2-12.1 7.2-19.2c0-16-13-29-29-29c-7.1 0-13.9 2.6-19.2 7.2L217.7 224h24.2L474.3 19.3c2.4-2.1 5.4-3.3 8.6-3.3c7.2 0 13 5.8 13 13c0 3.2-1.2 6.2-3.3 8.6L328.6 224h21.3zM181.3 272H308.7L184 396.7l-34.3-34.3L115.3 328l49-49c4.5-4.5 10.6-7 17-7zM98.3 322.3l0 0L10.8 409.9C3.9 416.8 0 426.2 0 436s3.9 19.2 10.8 26.1l39 39C56.8 508.1 66.2 512 76 512s19.2-3.9 26.1-10.8l87.5-87.5 0 0 0 0 144-144c2.3-2.3 3-5.7 1.7-8.7s-4.2-4.9-7.4-4.9H181.3c-10.6 0-20.8 4.2-28.3 11.7L98.3 322.3zm45.7 57L172.7 408 90.8 489.9c-3.9 3.9-9.3 6.1-14.8 6.1s-10.9-2.2-14.8-6.1L47.3 476 144 379.3zM22.1 450.8c-3.9-3.9-6.1-9.3-6.1-14.8s2.2-10.9 6.1-14.8L104 339.3 132.7 368 36 464.7 22.1 450.8z'
      
    ]
  };

  

  
  

  var faEllipsisVertical = {
    prefix: 'fat',
    iconName: 'ellipsis-vertical',
    icon: [
      128,
      512,
      ["ellipsis-v"],
      'f142',
      
      'M64 400a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm0-128a16 16 0 1 1 0-32 16 16 0 1 1 0 32zM48 128a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  
    var faEllipsisV = faEllipsisVertical;
  

  
  

  var faRouter = {
    prefix: 'fat',
    iconName: 'router',
    icon: [
      576,
      512,
      [],
      'f8da',
      
      'M173.2 83c-3.3 2.9-8.4 2.6-11.3-.8s-2.6-8.4 .8-11.3C213.3 26.8 279.5 0 352 0s138.7 26.8 189.3 70.9c3.3 2.9 3.7 8 .8 11.3s-8 3.7-11.3 .8C483 41.3 420.4 16 352 16s-131 25.3-178.8 67zm79.9 79.2c-3.5 2.7-8.5 2.1-11.2-1.3s-2.1-8.5 1.3-11.2C273.1 126.1 310.9 112 352 112s78.9 14.1 108.8 37.6c3.5 2.7 4.1 7.8 1.3 11.2s-7.8 4.1-11.2 1.3C423.7 140.8 389.3 128 352 128s-71.7 12.8-98.9 34.2zM352 224c4.4 0 8 3.6 8 8v88H512c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V384c0-35.3 28.7-64 64-64H344V232c0-4.4 3.6-8 8-8zM64 336c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H512c26.5 0 48-21.5 48-48V384c0-26.5-21.5-48-48-48H352 64zm112 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM96 400a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faWandSparkles = {
    prefix: 'fat',
    iconName: 'wand-sparkles',
    icon: [
      512,
      512,
      [],
      'f72b',
      
      'M486.5 0c-6.1 0-12 2.2-16.7 6.2L181 256H136c-13.3 0-24 10.7-24 24v38.7L14.9 407C5.4 415.6 0 427.7 0 440.5c0 12 4.8 23.6 13.3 32.1l26.2 26.2c8.5 8.5 20 13.2 32 13.2c12.8 0 25-5.4 33.6-15L379.6 192H408c13.3 0 24-10.7 24-24V138.7l74.6-97c3.5-4.5 5.4-10.1 5.4-15.8v-.4C512 11.4 500.6 0 486.5 0zm-6.2 18.3c1.7-1.5 3.9-2.3 6.2-2.3c5.2 0 9.5 4.2 9.5 9.5v.4c0 2.2-.7 4.3-2.1 6l-76.3 99.2c-1.1 1.4-1.7 3.1-1.7 4.9v32c0 4.4-3.6 8-8 8H376c-2.3 0-4.4 1-5.9 2.6L93.1 486.3c-5.5 6.2-13.4 9.7-21.7 9.7c-7.8 0-15.2-3.1-20.7-8.6L24.6 461.3c-5.5-5.5-8.6-13-8.6-20.7c0-8.3 3.5-16.2 9.6-21.7l99.8-90.6c1.7-1.5 2.6-3.7 2.6-5.9V280c0-4.4 3.6-8 8-8h48c1.9 0 3.8-.7 5.2-1.9L480.3 18.3zM248 32c0-4.4-3.6-8-8-8s-8 3.6-8 8V72H192c-4.4 0-8 3.6-8 8s3.6 8 8 8h40v40c0 4.4 3.6 8 8 8s8-3.6 8-8V88h40c4.4 0 8-3.6 8-8s-3.6-8-8-8H248V32zM88 80c0-4.4-3.6-8-8-8s-8 3.6-8 8v56H16c-4.4 0-8 3.6-8 8s3.6 8 8 8H72v56c0 4.4 3.6 8 8 8s8-3.6 8-8V152h56c4.4 0 8-3.6 8-8s-3.6-8-8-8H88V80zM440 304c0-4.4-3.6-8-8-8s-8 3.6-8 8v56H368c-4.4 0-8 3.6-8 8s3.6 8 8 8h56v56c0 4.4 3.6 8 8 8s8-3.6 8-8V376h56c4.4 0 8-3.6 8-8s-3.6-8-8-8H440V304z'
      
    ]
  };

  

  
  

  var faSquareU = {
    prefix: 'fat',
    iconName: 'square-u',
    icon: [
      448,
      512,
      [],
      'e281',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 56V288c0 53 43 96 96 96s96-43 96-96V152c0-4.4 3.6-8 8-8s8 3.6 8 8V288c0 61.9-50.1 112-112 112s-112-50.1-112-112V152c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faPersonPregnant = {
    prefix: 'fat',
    iconName: 'person-pregnant',
    icon: [
      384,
      512,
      [],
      'e31e',
      
      'M192.5 144l-.5 0H177.1c-28.1 0-54.1 14.7-68.6 38.8l-58.3 97c-4.6 7.6-2.1 17.4 5.5 22s17.4 2.1 22-5.5l28.6-47.5c3.7-6.2 11.1-9.1 18-7.2s11.7 8.2 11.7 15.4v31 0l0 .1 0 0v80h48 8 8 64 8 32 16c8.8 0 16-7.2 16-16V320c0-38.9-27.8-71.4-64.7-78.5c-6.4-1.2-11.5-6.3-12.7-12.8l-7-37.1C246.5 164 222.4 144 194.3 144c-.4 0-.7 0-1.1 0c-.2 0-.5 0-.7 0zM136 384l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16V384H136zm48 0v16 80c0 17.7-14.3 32-32 32s-32-14.3-32-32V288v0l0-.1v-31l-16 26.6L91.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6H192h0c.3 0 .6 0 .9 0c.5 0 .9 0 1.4 0c35.8 0 66.5 25.5 73 60.6l7 37.1c44.3 8.6 77.7 47.5 77.7 94.3v32c0 17.7-14.3 32-32 32H304 280h-8-8v16 80c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-80V384h-8-8zm32 0v96c0 8.8 7.2 16 16 16s16-7.2 16-16V384H216zM248 56c0 30.9-25.1 56-56 56h0c-30.9 0-56-25.1-56-56s25.1-56 56-56s56 25.1 56 56zm-16 0a40 40 0 1 0 -80 0 40 40 0 1 0 80 0z'
      
    ]
  };

  

  
  

  var faFlask = {
    prefix: 'fat',
    iconName: 'flask',
    icon: [
      448,
      512,
      [],
      'f0c3',
      
      'M313.5 230.4c-6.2-10.1-9.5-21.7-9.5-33.5V16l24 0c4.4 0 8-3.6 8-8s-3.6-8-8-8H304 288 160 144 120c-4.4 0-8 3.6-8 8s3.6 8 8 8l24 0V196.8c0 11.8-3.3 23.5-9.5 33.5L10.3 406.2C3.6 417.2 0 429.7 0 442.6C0 480.9 31.1 512 69.4 512H378.6c38.3 0 69.4-31.1 69.4-69.4c0-12.8-3.6-25.4-10.3-36.4L313.5 230.4zM160 16H288V196.8c0 14.8 4.1 29.3 11.9 41.9c.2 .3 .4 .6 .6 .8L357.2 320H90.8l56.8-80.4c.2-.3 .4-.6 .6-.8c7.8-12.6 11.9-27.1 11.9-41.9V16zM424.3 415c5 8.3 7.7 17.9 7.7 27.6c0 29.5-23.9 53.4-53.4 53.4H69.4C39.9 496 16 472.1 16 442.6c0-9.7 2.7-19.3 7.7-27.6l55.8-79H80 368h.5l55.8 79z'
      
    ]
  };

  

  
  

  var faSwordsLaser = {
    prefix: 'fat',
    iconName: 'swords-laser',
    icon: [
      640,
      512,
      [],
      'e03d',
      
      'M384 184v6.3L176.2 7.2C170.9 2.6 164.1 0 157 0c-16 0-29 13-29 29c0 7.1 2.6 13.9 7.2 19.2L384 330.6v.2c0 10.6 4.2 20.8 11.7 28.3l54.6 54.6 0 0 87.5 87.5c6.9 6.9 16.3 10.8 26.1 10.8s19.2-3.9 26.1-10.8l39-39c6.9-6.9 10.8-16.3 10.8-26.1s-3.9-19.2-10.8-26.1l-87.5-87.5 0 0 0 0-144-144c-2.3-2.3-5.7-3-8.7-1.7s-4.9 4.2-4.9 7.4zM147.3 37.7c-2.1-2.4-3.3-5.4-3.3-8.6c0-7.2 5.8-13 13-13c3.2 0 6.2 1.2 8.6 3.3L384 211.6v94.8L147.3 37.7zM407 347.7c-4.5-4.5-7-10.6-7-17V203.3L524.7 328l-34.3 34.3L456 396.7l-49-49zm129-8.4l81.9 81.9c3.9 3.9 6.1 9.3 6.1 14.8s-2.2 10.9-6.1 14.8L604 464.7 507.3 368 536 339.3zM592.7 476l-13.9 13.9c-3.9 3.9-9.3 6.1-14.8 6.1s-10.9-2.2-14.8-6.1L467.3 408 496 379.3 592.7 476zM193.1 245.7l-11.4-11.4c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L180.7 256 112 324.7l-2.3-2.3c-3.1-3.1-8.2-3.1-11.3 0L13.7 407C4.9 415.8 0 427.6 0 440s4.9 24.2 13.7 33L39 498.3c8.7 8.7 20.6 13.7 33 13.7s24.2-4.9 33-13.7l84.7-84.7c3.1-3.1 3.1-8.2 0-11.3l-2.3-2.3L256 331.3l10.3 10.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-11.4-11.4 38.9-44.2-10.5-12.2-39.7 45.1-50.5-50.5 48.7-42.9L242.7 202l-49.6 43.7zM492.7 37.7L392 152c6 0 11.9 1.7 17 4.9L504.8 48.2c4.7-5.3 7.2-12.1 7.2-19.2c0-16-13-29-29-29c-7.1 0-13.9 2.6-19.2 7.2L336 119.8l12.2 10.5L474.3 19.3c2.4-2.1 5.4-3.3 8.6-3.3c7.2 0 13 5.8 13 13c0 3.2-1.2 6.2-3.3 8.6zM192 267.3L244.7 320 216 348.7l-2.3-2.3-48-48-2.3-2.3L192 267.3zM123.3 336L152 307.3l2.3 2.3 48 48 2.3 2.3L176 388.7 123.3 336zM25 418.3l79-79 2.3 2.3 64 64 2.3 2.3-79 79c-5.7 5.7-13.5 9-21.7 9s-15.9-3.2-21.7-9L25 461.7c-5.7-5.7-9-13.5-9-21.7s3.2-15.9 9-21.7z'
      
    ]
  };

  

  
  

  var faCentSign = {
    prefix: 'fat',
    iconName: 'cent-sign',
    icon: [
      384,
      512,
      [],
      'e3f5',
      
      'M224 0c4.4 0 8 3.6 8 8V64c43.7 .4 84.1 14.6 116.7 38.3c3.6 2.6 4.4 7.6 1.8 11.2s-7.6 4.4-11.2 1.8C308.9 93.1 271 80 230 80C129.2 80 48 159 48 256s81.2 176 182 176c41.1 0 78.9-13.1 109.3-35.3c3.6-2.6 8.6-1.8 11.2 1.8s1.8 8.6-1.8 11.2c-32.6 23.7-73 37.9-116.7 38.3v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V447.5C113.4 440.6 32 357.7 32 256S113.4 71.4 216 64.5V8c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faHamsa = {
    prefix: 'fat',
    iconName: 'hamsa',
    icon: [
      512,
      512,
      [],
      'f665',
      
      'M256 16c22.1 0 40 17.9 40 40V96 208v8c0 4.4 3.6 8 8 8s8-3.6 8-8v-8V96c0-22.1 17.9-40 40-40s40 17.9 40 40V280c0 4.4 3.6 8 8 8h64.4c17.4 0 31.6 14.1 31.6 31.6c0 8.4-3.3 16.4-9.3 22.3l-99.8 99.8C352.2 476.5 305.1 496 256 496s-96.2-19.5-130.9-54.2L25.3 341.9C19.3 336 16 328 16 319.6C16 302.1 30.1 288 47.6 288H112c4.4 0 8-3.6 8-8V96c0-22.1 17.9-40 40-40s40 17.9 40 40V208v8c0 4.4 3.6 8 8 8s8-3.6 8-8v-8V96 56c0-22.1 17.9-40 40-40zM200 56v.8C189.8 46.4 175.7 40 160 40c-30.9 0-56 25.1-56 56V272H47.6C21.3 272 0 293.3 0 319.6c0 12.6 5 24.7 13.9 33.7l99.8 99.8C151.5 490.8 202.7 512 256 512s104.5-21.2 142.2-58.9l99.8-99.8c8.9-8.9 13.9-21 13.9-33.7c0-26.3-21.3-47.6-47.6-47.6H408V96c0-30.9-25.1-56-56-56c-15.7 0-29.8 6.4-40 16.8V56c0-30.9-25.1-56-56-56s-56 25.1-56 56zM171.2 343.7c6.7-7 19.3-19.1 34.8-29.4C221.5 303.9 239.1 296 256 296s34.5 7.9 50.1 18.3c15.5 10.3 28.1 22.4 34.8 29.4c2 2.1 3.2 5 3.2 8.3s-1.2 6.2-3.2 8.3c-6.7 7-19.3 19.1-34.8 29.4C290.5 400.1 272.9 408 256 408s-34.5-7.9-50.1-18.3c-15.5-10.3-28.1-22.4-34.8-29.4c-2-2.1-3.2-5-3.2-8.3s1.2-6.2 3.2-8.3zM256 280c-21.5 0-42.3 10-58.9 21c-16.8 11.2-30.3 24.2-37.4 31.6c-5.2 5.3-7.6 12.4-7.6 19.4s2.5 14.1 7.6 19.4c7.1 7.4 20.6 20.4 37.4 31.6c16.6 11.1 37.4 21 58.9 21s42.3-10 58.9-21c16.8-11.2 30.3-24.2 37.4-31.6c5.2-5.3 7.6-12.4 7.6-19.4s-2.5-14.1-7.6-19.4c-7.1-7.4-20.6-20.4-37.4-31.6c-16.6-11.1-37.4-21-58.9-21zm-16 72a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faMapPin = {
    prefix: 'fat',
    iconName: 'map-pin',
    icon: [
      320,
      512,
      [128205],
      'f276',
      
      'M160 272a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM304 144c0 76.8-60.2 139.6-136 143.8V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V287.8C76.2 283.6 16 220.8 16 144C16 64.5 80.5 0 160 0s144 64.5 144 144zM80 136c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-48.6 39.4-88 88-88c4.4 0 8 3.6 8 8s-3.6 8-8 8c-39.8 0-72 32.2-72 72z'
      
    ]
  };

  

  
  

  var faCroissant = {
    prefix: 'fat',
    iconName: 'croissant',
    icon: [
      512,
      512,
      [129360],
      'f7f6',
      
      'M16 288c0-17.7 1.7-34.9 4.9-51.7c2.4 1.6 5 2.9 7.7 4l194.1 78.2L82.4 427.7c-11 8.6-24.8 5.4-30.2-4C29.2 383.8 16 337.4 16 288zM7.4 222.9C2.6 243.8 0 265.6 0 288c0 52.3 14 101.4 38.4 143.7c9.3 16.2 28.9 20.8 45.3 13.7c25.7 27.9 57.4 50 93.2 64.3c3.9 1.5 8 2.3 12.2 2.3h5.4c16.3 0 29.6-13.2 29.6-29.6c0-1.6-.1-3.3-.4-4.9l-12.1-72.7c-2.3-13.9-3.5-28-3.5-42.1V350.2l34.1-26.5c18.9 2 38.1-4.5 51.9-18.4L305.3 294c13.9-13.9 20.4-33 18.4-51.9L350.2 208h12.6c14.1 0 28.2 1.2 42.1 3.5l72.7 12.1c1.6 .3 3.2 .4 4.9 .4c16.3 0 29.6-13.2 29.6-29.6V189c0-4.2-.7-8.3-2.3-12.2c-14.3-35.8-36.5-67.5-64.3-93.2c7.1-16.4 2.5-36-13.7-45.3C389.4 14 340.3 0 288 0c-22.4 0-44.2 2.6-65.1 7.4C215.6 2.7 207 0 197.9 0c-5 0-10 .8-14.6 2.5C99.6 33.2 33.2 99.6 2.5 183.3C.8 188 0 193 0 197.9c0 9.1 2.7 17.7 7.4 24.9zm228.9-202c16.7-3.2 34-4.9 51.7-4.9c49.4 0 95.8 13.2 135.7 36.2c9.4 5.4 12.5 19.2 4 30.2L318.5 222.7 240.3 28.6c-1.1-2.7-2.4-5.3-4-7.7zM223.6 477.6l-15.8 2.6c.1 .7 .2 1.5 .2 2.2c0 7.5-6.1 13.6-13.6 13.6H189c-2.3 0-4.4-.4-6.2-1.1c-32.7-13.1-61.9-33.2-85.6-58.5L192 362.7v.1c0 15 1.2 29.9 3.7 44.7l12.1 72.7 15.8-2.6zM362.7 192l73.8-94.8c25.2 23.7 45.3 52.9 58.5 85.6c.7 1.8 1.1 3.9 1.1 6.2v5.4c0 7.5-6.1 13.6-13.6 13.6c-.7 0-1.5-.1-2.2-.2l-72.7-12.1c-14.8-2.5-29.7-3.7-44.7-3.7h-.1zM17.5 188.8c29.1-79.3 92-142.2 171.3-171.3c2.7-1 5.8-1.5 9.1-1.5c12.1 0 23 7.4 27.5 18.6l79.1 196.2c7.2 17.9 3 38.3-10.6 51.9L282.7 294c-13.6 13.6-34 17.8-51.9 10.6L34.6 225.5C23.4 221 16 210.1 16 197.9c0-3.3 .5-6.4 1.5-9.1z'
      
    ]
  };

  

  
  

  var faNetworkWired = {
    prefix: 'fat',
    iconName: 'network-wired',
    icon: [
      640,
      512,
      [],
      'f6ff',
      
      'M400 16c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V48c0-17.7 14.3-32 32-32H400zM240 0c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h72v56H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H152v56H80c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H240c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H168V264H472v56H400c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H560c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H488V264H632c4.4 0 8-3.6 8-8s-3.6-8-8-8H328V192h72c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H240zM80 336H240c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H80c-17.7 0-32-14.3-32-32V368c0-17.7 14.3-32 32-32zm480 0c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H400c-17.7 0-32-14.3-32-32V368c0-17.7 14.3-32 32-32H560z'
      
    ]
  };

  

  
  

  var faFolderTree = {
    prefix: 'fat',
    iconName: 'folder-tree',
    icon: [
      576,
      512,
      [],
      'f802',
      
      'M16 8c0-4.4-3.6-8-8-8S0 3.6 0 8V128 384c0 22.1 17.9 40 40 40H256V408H40c-13.3 0-24-10.7-24-24V136H256V120H16V8zM304 32c0-8.8 7.2-16 16-16h74.7c4.2 0 8.3 1.7 11.3 4.7l21.7 21.7c3.6 3.6 8.5 5.6 13.6 5.6H544c8.8 0 16 7.2 16 16V192c0 8.8-7.2 16-16 16H320c-8.8 0-16-7.2-16-16V32zm-16 0V192c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H441.3c-.8 0-1.7-.3-2.3-.9L417.4 9.4c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32zm16 288c0-8.8 7.2-16 16-16h74.7c4.2 0 8.3 1.7 11.3 4.7l21.7 21.7c3.6 3.6 8.5 5.6 13.6 5.6H544c8.8 0 16 7.2 16 16V480c0 8.8-7.2 16-16 16H320c-8.8 0-16-7.2-16-16V320zm-16 0V480c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H441.3c-.8 0-1.7-.3-2.3-.9l-21.7-21.7c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32z'
      
    ]
  };

  

  
  

  var faPeople = {
    prefix: 'fat',
    iconName: 'people',
    icon: [
      640,
      512,
      [],
      'e216',
      
      'M120 56a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm96 0A56 56 0 1 0 104 56a56 56 0 1 0 112 0zM90.7 175.7c9.3-19.4 28.9-31.7 50.4-31.7h37.8c21.5 0 41.1 12.3 50.4 31.7l67.5 139.8c1.9 4 6.7 5.6 10.7 3.7s5.6-6.7 3.7-10.7L243.7 168.7c-12-24.9-37.2-40.7-64.8-40.7H141.1c-27.6 0-52.8 15.8-64.8 40.7L8.8 308.5c-1.9 4-.3 8.8 3.7 10.7s8.8 .3 10.7-3.7L90.7 175.7zM96 240c-4.4 0-8 3.6-8 8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V360c0-4.4 3.6-8 8-8s8 3.6 8 8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V248c0-4.4-3.6-8-8-8s-8 3.6-8 8V480c0 8.8-7.2 16-16 16s-16-7.2-16-16V360c0-13.3-10.7-24-24-24s-24 10.7-24 24V480c0 8.8-7.2 16-16 16s-16-7.2-16-16V248c0-4.4-3.6-8-8-8zM440 56a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm96 0A56 56 0 1 0 424 56a56 56 0 1 0 112 0zM439.6 210.5c1.4-4.2-.9-8.7-5.1-10.1s-8.7 .9-10.1 5.1l-56 168c-.8 2.4-.4 5.1 1.1 7.2s3.9 3.3 6.5 3.3h32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h16v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h32c2.6 0 5-1.2 6.5-3.3s1.9-4.8 1.1-7.2l-56-168c-1.4-4.2-5.9-6.5-10.1-5.1s-6.5 5.9-5.1 10.1L572.9 368H544 496 464 416 387.1l52.5-157.5zM424 480V384h32v96c0 8.8-7.2 16-16 16s-16-7.2-16-16zm80-96h32v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V384zM476.2 144h7.7c30.7 0 58.7 17.6 72.1 45.2l60.9 126.2c1.9 4 6.7 5.6 10.7 3.7s5.6-6.7 3.7-10.7L570.3 182.3c-16-33.2-49.6-54.3-86.5-54.3h-7.7c-36.9 0-70.4 21.1-86.5 54.3L328.8 308.5c-1.9 4-.2 8.8 3.7 10.7s8.8 .3 10.7-3.7l60.9-126.2c13.3-27.7 41.3-45.2 72.1-45.2z'
      
    ]
  };

  

  
  

  var faCauldron = {
    prefix: 'fat',
    iconName: 'cauldron',
    icon: [
      448,
      512,
      [],
      'f6bf',
      
      'M144 32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm48 48a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM46.1 237.2c14.4-26.5 30.7-48.7 41.2-61.2H224 360.7c10.5 12.5 26.8 34.7 41.2 61.2c16.9 31 30.1 65.9 30.1 97.2c0 50.9-24.5 90.8-62.7 118.4C330.7 480.7 278.1 496 224 496s-106.7-15.3-145.3-43.2c-18.3-13.2-33.4-29.2-44.2-47.9L32 400v.5c-10.3-19.3-16-41.4-16-66.1c0-31.2 13.2-66.2 30.1-97.2zM0 334.4c0 37.4 11.9 69.4 32 95.5V504c0 4.4 3.6 8 8 8s8-3.6 8-8V447.9C90.7 489.6 156.7 512 224 512s133.3-22.4 176-64.1V504c0 4.4 3.6 8 8 8s8-3.6 8-8V429.9c20.1-26.1 32-58.1 32-95.5c0-58.8-40.9-124.6-66.8-158.4H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H368 224 80 8c-4.4 0-8 3.6-8 8s3.6 8 8 8H66.8C40.9 209.8 0 275.6 0 334.4z'
      
    ]
  };

  

  
  

  var faSliders = {
    prefix: 'fat',
    iconName: 'sliders',
    icon: [
      512,
      512,
      ["sliders-h"],
      'f1de',
      
      'M0 416c0 4.4 3.6 8 8 8l88.5 0c3.9 31.6 30.9 56 63.5 56s59.6-24.4 63.5-56L504 424c4.4 0 8-3.6 8-8s-3.6-8-8-8l-280.5 0c-3.9-31.6-30.9-56-63.5-56s-59.6 24.4-63.5 56L8 408c-4.4 0-8 3.6-8 8zm112 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM304 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48-64c-32.6 0-59.6 24.4-63.5 56L8 248c-4.4 0-8 3.6-8 8s3.6 8 8 8l280.5 0c3.9 31.6 30.9 56 63.5 56s59.6-24.4 63.5-56l88.5 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-88.5 0c-3.9-31.6-30.9-56-63.5-56zM192 144a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm63.5-56c-3.9-31.6-30.9-56-63.5-56s-59.6 24.4-63.5 56L8 88c-4.4 0-8 3.6-8 8s3.6 8 8 8l120.5 0c3.9 31.6 30.9 56 63.5 56s59.6-24.4 63.5-56L504 104c4.4 0 8-3.6 8-8s-3.6-8-8-8L255.5 88z'
      
    ]
  };

  
    var faSlidersH = faSliders;
  

  
  

  var faOutlet = {
    prefix: 'fat',
    iconName: 'outlet',
    icon: [
      448,
      512,
      [],
      'e01c',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM80 256c0 55.2 27.7 89.2 44.6 104.8c5 4.6 12.5 7.2 21.8 7.2H301.6c9.3 0 16.8-2.6 21.8-7.2C340.3 345.2 368 311.2 368 256s-27.7-89.2-44.6-104.8c-5-4.6-12.5-7.2-21.8-7.2H146.4c-9.3 0-16.8 2.6-21.8 7.2C107.7 166.8 80 200.8 80 256zm-16 0c0-61.1 30.8-99.1 49.7-116.6c8.8-8.2 20.7-11.4 32.6-11.4H301.6c12 0 23.9 3.3 32.6 11.4C353.2 156.9 384 194.9 384 256s-30.8 99-49.7 116.6c-8.8 8.2-20.7 11.4-32.6 11.4H146.4c-12 0-23.9-3.3-32.6-11.4C94.8 355 64 317.1 64 256zm96-64c4.4 0 8 3.6 8 8v64c0 4.4-3.6 8-8 8s-8-3.6-8-8V200c0-4.4 3.6-8 8-8zm128 0c4.4 0 8 3.6 8 8v64c0 4.4-3.6 8-8 8s-8-3.6-8-8V200c0-4.4 3.6-8 8-8zM240 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h32V304zm-48 0c0-17.7 14.3-32 32-32s32 14.3 32 32v16c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V304z'
      
    ]
  };

  

  
  

  var faFilterList = {
    prefix: 'fat',
    iconName: 'filter-list',
    icon: [
      512,
      512,
      [],
      'e17c',
      
      'M25.4 64C11.4 64 0 75.4 0 89.4c0 6.2 2.2 12.1 6.3 16.8L112 227V368c0 7.5 3.5 14.6 9.5 19.2l73 55.1c4.9 3.7 10.9 5.7 17.1 5.7c15.7 0 28.4-12.7 28.4-28.4V227L345.7 106.2c4.1-4.6 6.3-10.6 6.3-16.8C352 75.4 340.6 64 326.6 64H25.4zM16 89.4c0-5.2 4.2-9.4 9.4-9.4H326.6c5.2 0 9.4 4.2 9.4 9.4c0 2.3-.8 4.5-2.3 6.2L226 218.7c-1.3 1.5-2 3.3-2 5.3V419.6c0 6.8-5.5 12.4-12.4 12.4c-2.7 0-5.3-.9-7.5-2.5l-73-55.1c-2-1.5-3.2-3.9-3.2-6.4V224c0-1.9-.7-3.8-2-5.3L18.3 95.7c-1.5-1.7-2.3-3.9-2.3-6.2zM328 400c-4.4 0-8 3.6-8 8s3.6 8 8 8H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H328zm-8-152c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H328c-4.4 0-8 3.6-8 8zM392 80c-4.4 0-8 3.6-8 8s3.6 8 8 8H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H392z'
      
    ]
  };

  

  
  

  var faKhanda = {
    prefix: 'fat',
    iconName: 'khanda',
    icon: [
      512,
      512,
      [9772],
      'f66d',
      
      'M251.2 1.6c2.8-2.1 6.8-2.1 9.6 0l64 48c2.8 2.1 3.9 5.7 2.8 8.9l-11 32.9C342.9 110.4 360 141.2 360 176s-17.1 65.6-43.4 84.5l11 32.9c1.1 3.3 0 6.9-2.8 8.9L264 348v23.8l52.6-32.3c56.8-34.8 91.4-96.6 91.4-163.2c0-20.6-3.3-41-9.8-60.5L384.4 74.5c-1-3-.1-6.3 2.2-8.4s5.7-2.7 8.6-1.5l1.4 .6C466.6 95.3 512 164.1 512 240.4c0 62.5-30.7 121.1-82.1 156.7l-25.4 17.6c-2.6 1.8-6.1 1.9-8.8 .2l-84-53.4-40.4 24.8 67.9 41.6c3.7-2.3 8.1-3.7 12.8-3.7c13.3 0 24 10.7 24 24s-10.7 24-24 24s-24-10.7-24-24c0-2.7 .4-5.3 1.2-7.7l-65.2-40V449c13.8 3.6 24 16.1 24 31c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-14.9 10.2-27.4 24-31V400.4l-65.2 40c.8 2.4 1.2 5 1.2 7.7c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24c4.7 0 9.1 1.4 12.8 3.7l67.9-41.6-40.4-24.8-84 53.4c-2.7 1.7-6.2 1.7-8.8-.2L82.1 397C30.7 361.4 0 302.9 0 240.4C0 164.1 45.4 95.3 115.5 65.2l1.4-.6c2.9-1.2 6.2-.7 8.6 1.5s3.2 5.4 2.2 8.4l-13.8 41.3c-6.5 19.5-9.8 39.9-9.8 60.5c0 66.6 34.6 128.4 91.4 163.2L248 371.8V348l-60.8-45.6c-2.8-2.1-3.9-5.7-2.8-8.9l11-32.9C169.1 241.6 152 210.8 152 176s17.1-65.6 43.4-84.5l-11-32.9c-1.1-3.3 0-6.9 2.8-8.9l64-48zM200.7 107.5c-20 16.1-32.7 40.8-32.7 68.5s12.8 52.4 32.7 68.5l10.2-30.5c8.2-24.6 8.2-51.3 0-75.9l-10.2-30.5zm110.5 137c20-16.1 32.7-40.8 32.7-68.5s-12.8-52.4-32.7-68.5l-10.2 30.5c-8.2 24.6-8.2 51.3 0 75.9l10.2 30.5zM201.4 58.9L226.1 133c9.3 27.9 9.3 58.1 0 86l-24.7 74.1L256 334l54.6-40.9L285.9 219c-9.3-27.9-9.3-58.1 0-86l24.7-74.1L256 18 201.4 58.9zM112.2 398.4L185.1 352C124.7 314.1 88 247.8 88 176.4c0-22.3 3.6-44.4 10.6-65.6l7.8-23.3C51 117.9 16 176.3 16 240.4c0 57.3 28.1 110.9 75.2 143.5l21 14.5zM326.9 352l72.9 46.4 21-14.5c47.1-32.6 75.2-86.2 75.2-143.5c0-64.1-35-122.5-90.4-152.9l7.8 23.3c7 21.1 10.6 43.3 10.6 65.6c0 71.4-36.7 137.7-97.1 175.6zM272 480a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM160 456a8 8 0 1 0 0-16 8 8 0 1 0 0 16zm200-8a8 8 0 1 0 -16 0 8 8 0 1 0 16 0z'
      
    ]
  };

  

  
  

  var faOlive = {
    prefix: 'fat',
    iconName: 'olive',
    icon: [
      448,
      512,
      [],
      'e316',
      
      'M160 464C80.5 464 16 399.5 16 320c0-90.4 42.6-158.1 97.4-203.7C168.7 70.3 235.2 48 280 48c23.2 0 47.9 11.8 68.1 25.3c9.8 6.6 18.1 13.1 23.8 18.1c2.9 2.5 5.1 4.5 6.6 5.9c.7 .7 1.3 1.2 1.7 1.6l.4 .4 .1 .1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 .1 .1 .4 .4c.3 .4 .9 .9 1.6 1.7c1.4 1.5 3.4 3.7 5.9 6.6c4.9 5.8 11.5 14 18.1 23.8C420.2 152.1 432 176.8 432 200c0 44.8-22.3 111.3-68.3 166.6C318.1 421.4 250.4 464 160 464zM0 320c0 88.4 71.6 160 160 160c192 0 288-181.9 288-280c0-56-56-112-56-112s-56-56-112-56C181.9 32 0 128 0 320zM247.9 119.9c7.5-7.5 20.2-10.1 36.7-6c16.2 4.1 34.6 14.5 50.8 30.7s26.6 34.5 30.7 50.8c4.1 16.4 1.5 29.2-6 36.7s-20.2 10.1-36.7 6c-16.2-4.1-34.6-14.5-50.8-30.7s-26.6-34.5-30.7-50.8c-4.1-16.4-1.5-29.2 6-36.7zm98.8 13.4c-17.9-17.9-38.7-30-58.2-34.9c-19.3-4.8-38.9-2.8-51.9 10.2s-15 32.5-10.2 51.9c4.9 19.5 17 40.3 34.9 58.2s38.7 30 58.2 34.9c19.3 4.8 38.9 2.8 51.9-10.2s15-32.5 10.2-51.9c-4.9-19.5-17-40.3-34.9-58.2z'
      
    ]
  };

  

  
  

  var faHoneyPot = {
    prefix: 'fat',
    iconName: 'honey-pot',
    icon: [
      448,
      512,
      [127855],
      'e418',
      
      'M376 48c13.3 0 24 10.7 24 24s-10.7 24-24 24H320 240v16h80c61.9 0 112 50.1 112 112c0 5.4-.1 10.8-.4 16H16.4c-.2-5.2-.4-10.6-.4-16c0-61.9 50.1-112 112-112V96H72C58.7 96 48 85.3 48 72s10.7-24 24-24h80v92c0 15.5 12.5 28 28 28s28-12.5 28-28V48H376zm54.5 208c-2.9 30-9.7 56.6-18.7 80H36.3c-9-23.4-15.8-50-18.7-80h413zM405 352c-24.9 54.7-60.9 89-80.4 104.7c-5.9 4.8-13.9 7.3-23 7.3H146.4c-9.1 0-17.1-2.5-23-7.3C103.9 441 67.9 406.7 43 352H405zM168 48h24v92c0 6.6-5.4 12-12 12s-12-5.4-12-12V48zM32 72c0 20.3 15.1 37 34.6 39.6C26.9 133.4 0 175.5 0 224C0 362.8 79.6 441.9 113.3 469.1c9.3 7.5 21.1 10.9 33.1 10.9H301.6c12 0 23.7-3.3 33.1-10.9C368.4 441.9 448 362.8 448 224c0-48.5-26.9-90.6-66.6-112.4C400.9 109 416 92.3 416 72c0-22.1-17.9-40-40-40H72C49.9 32 32 49.9 32 72z'
      
    ]
  };

  

  
  

  var faCoins = {
    prefix: 'fat',
    iconName: 'coins',
    icon: [
      512,
      512,
      [],
      'f51e',
      
      'M144 80c0 7 3.6 14.5 11.9 22.2c3.8 3.5 8.5 7 14 10.3c-8.4 .3-16.7 .8-24.8 1.5l-.1-.1c-10.3-9.5-17-21-17-33.9s6.7-24.4 17-33.9c10.3-9.5 24.8-17.7 42-24.5C221.4 8.2 268.5 0 320 0s98.6 8.2 133 21.6c17.2 6.7 31.7 14.9 41.9 24.5c10.3 9.5 17 21 17 33.9V184l0 105.9c0 12.7-6.8 24-17.1 33.2s-24.8 17.3-41.9 23.8c-11.1 4.2-23.5 7.9-37 11V341.5c11.4-2.7 21.9-5.9 31.3-9.5c16.1-6.1 28.6-13.3 36.9-20.7s11.8-14.7 11.8-21.3V216.2c-.4 .3-.7 .7-1.1 1c-10.3 9.3-24.8 17.3-41.9 23.8c-11.1 4.2-23.5 7.9-37 11V235.6c11.4-2.7 21.9-5.9 31.3-9.5c16.1-6.1 28.6-13.3 36.9-20.7s11.8-14.7 11.8-21.3l0-71.1c-.3 .3-.7 .6-1 1c-10.3 9.5-24.8 17.7-41.9 24.5c-20.1 7.9-44.6 13.9-71.7 17.6c-7.1-5-15-9.5-23.4-13.5c34.7-2.9 65.5-9.7 89.3-19c16.1-6.3 28.6-13.6 36.9-21.3C492.4 94.5 496 87 496 80s-3.6-14.5-11.9-22.2c-8.3-7.7-20.8-15-36.9-21.3C415 24 370.1 16 320 16s-95 8-127.2 20.5c-16.1 6.3-28.6 13.6-36.9 21.3C147.6 65.5 144 73 144 80zM16 224c0 7 3.6 14.5 11.9 22.2c8.3 7.7 20.8 15 36.9 21.3C97 280 141.9 288 192 288s95-8 127.2-20.5c16.1-6.3 28.6-13.6 36.9-21.3C364.4 238.5 368 231 368 224s-3.6-14.5-11.9-22.2c-8.3-7.7-20.8-15-36.9-21.3C287 168 242.1 160 192 160s-95 8-127.2 20.5c-16.1 6.3-28.6 13.6-36.9 21.3C19.6 209.5 16 217 16 224zM0 224c0-12.9 6.7-24.4 17-33.9c10.3-9.5 24.8-17.7 42-24.5C93.4 152.2 140.5 144 192 144s98.6 8.2 133 21.6c17.2 6.7 31.7 14.9 41.9 24.5c10.3 9.5 17 21 17 33.9V328l0 105.9c0 12.7-6.8 24-17.1 33.2s-24.8 17.3-41.9 23.8C290.5 504.1 243.5 512 192 512s-98.5-7.9-133-21.1c-17.2-6.5-31.6-14.5-41.9-23.8S0 446.6 0 433.9V328 224zm368 32.9c-.3 .3-.7 .6-1 1c-10.3 9.5-24.8 17.7-41.9 24.5C290.6 295.8 243.5 304 192 304s-98.6-8.2-133-21.6c-17.2-6.7-31.7-14.9-42-24.5c-.3-.3-.7-.6-1-1V328c0 6.6 3.5 13.8 11.8 21.3s20.8 14.6 36.9 20.7c32.2 12.3 77.2 20 127.3 20s95.1-7.8 127.3-20c16.1-6.1 28.6-13.3 36.9-20.7s11.8-14.7 11.8-21.3l0-71.1zM17.1 361.2c-.4-.3-.7-.7-1.1-1v73.7c0 6.6 3.5 13.8 11.8 21.3s20.8 14.6 36.9 20.7c32.2 12.3 77.2 20 127.3 20s95.1-7.7 127.3-20c16.1-6.1 28.6-13.3 36.9-20.7s11.8-14.7 11.8-21.3V360.2c-.4 .3-.7 .7-1.1 1c-10.3 9.3-24.8 17.3-41.9 23.8c-34.4 13.1-81.4 21.1-133 21.1s-98.5-7.9-133-21.1c-17.2-6.5-31.6-14.5-41.9-23.8z'
      
    ]
  };

  

  
  

  var faMountainCity = {
    prefix: 'fat',
    iconName: 'mountain-city',
    icon: [
      640,
      512,
      [],
      'e52e',
      
      'M304 40c0-13.3 10.7-24 24-24H472c13.3 0 24 10.7 24 24V200c0 4.4 3.6 8 8 8h64 32c13.3 0 24 10.7 24 24V496c0 4.4 3.6 8 8 8s8-3.6 8-8V232c0-22.1-17.9-40-40-40H576V104c0-4.4-3.6-8-8-8s-8 3.6-8 8v88H512V40c0-22.1-17.9-40-40-40H328c-22.1 0-40 17.9-40 40V140.1l16 26.5V40zM239.7 153l81.5 135H223c-2.5 0-4.9 1.2-6.4 3.2L174.8 347l-47.8-59.1L208.3 153c3.4-5.6 9.4-9 15.7-9s12.3 3.3 15.7 9zM18.8 467.2l99.4-164.7L168.8 365c1.6 1.9 3.9 3 6.4 3s4.8-1.2 6.3-3.2L227 304H330.8l98.4 163.2c3.5 5.9 3.7 13.3 .4 19.3c-3.3 6-9.5 9.6-16.1 9.6H34.5c-6.6 0-12.7-3.6-16.1-9.6c-3.3-6-3.2-13.4 .4-19.3zM253.4 144.7C247.1 134.3 236 128 224 128s-23.1 6.3-29.4 16.7L5.1 458.9c-6.5 10.8-6.7 24.3-.7 35.3S22 512 34.5 512H413.5c12.5 0 24-6.8 30.1-17.8s5.8-24.5-.7-35.3L253.4 144.7zM360 96v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V96c0-13.3-10.7-24-24-24H384c-13.3 0-24 10.7-24 24zm24-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H384c-4.4 0-8-3.6-8-8V96c0-4.4 3.6-8 8-8zm0 112c-4.4 0-8 3.6-8 8s3.6 8 8 8h32c4.4 0 8 3.6 8 8v32c0 4.4 3.6 8 8 8s8-3.6 8-8V224c0-13.3-10.7-24-24-24H384zm104 88v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V288c0-13.3-10.7-24-24-24H512c-13.3 0-24 10.7-24 24zm24-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H512c-4.4 0-8-3.6-8-8V288c0-4.4 3.6-8 8-8zm0 112c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V416c0-13.3-10.7-24-24-24H512zm-8 24c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H512c-4.4 0-8-3.6-8-8V416z'
      
    ]
  };

  

  
  

  var faFluxCapacitor = {
    prefix: 'fat',
    iconName: 'flux-capacitor',
    icon: [
      448,
      512,
      [],
      'f8ba',
      
      'M384 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM312 96c39.8 0 72 32.2 72 72s-32.2 72-72 72c-4.4 0-8 3.6-8 8s3.6 8 8 8c48.6 0 88-39.4 88-88s-39.4-88-88-88c-32.6 0-61 17.7-76.2 44c-2.2 3.8-.9 8.7 2.9 10.9s8.7 .9 10.9-2.9c12.5-21.5 35.7-36 62.4-36zM198.5 132c2.2 3.8 7.1 5.1 10.9 2.9s5.1-7.1 2.9-10.9c-15.2-26.3-43.6-44-76.2-44c-48.6 0-88 39.4-88 88s39.4 88 88 88c4.4 0 8-3.6 8-8s-3.6-8-8-8c-39.8 0-72-32.2-72-72s32.2-72 72-72c26.6 0 49.9 14.5 62.4 36zm-26 150.3c-3.2-3.1-8.2-3-11.3 .1C145.6 298.3 136 320 136 344c0 48.6 39.4 88 88 88s88-39.4 88-88c0-24-9.6-45.7-25.2-61.6c-3.1-3.2-8.2-3.2-11.3-.1s-3.2 8.2-.1 11.3c12.7 13 20.6 30.8 20.6 50.4c0 39.8-32.2 72-72 72s-72-32.2-72-72c0-19.6 7.8-37.4 20.6-50.4c3.1-3.2 3-8.2-.1-11.3zM133.7 154.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L216 259.3V352c0 4.4 3.6 8 8 8s8-3.6 8-8V259.3l93.7-93.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L224 244.7l-90.3-90.3z'
      
    ]
  };

  

  
  

  var faBatteryHalf = {
    prefix: 'fat',
    iconName: 'battery-half',
    icon: [
      576,
      512,
      ["battery-3"],
      'f242',
      
      'M448 112c35.3 0 64 28.7 64 64v16 16 96 16 16c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V176c0-35.3 28.7-64 64-64H448zm80 224V320h16c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H528V176c0-44.2-35.8-80-80-80H80C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H448c44.2 0 80-35.8 80-80zm0-32V208h16c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H528zM112 176H240c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V208c0-17.7 14.3-32 32-32zM64 208v96c0 26.5 21.5 48 48 48H240c26.5 0 48-21.5 48-48V208c0-26.5-21.5-48-48-48H112c-26.5 0-48 21.5-48 48z'
      
    ]
  };

  
    var faBattery3 = faBatteryHalf;
  

  
  

  var faBoltAuto = {
    prefix: 'fat',
    iconName: 'bolt-auto',
    icon: [
      576,
      512,
      [],
      'e0b6',
      
      'M294.4 0c-6.1 0-12 2.2-16.6 6.3L7.8 247.2C2.8 251.7 0 258 0 264.7C0 277.5 10.5 288 23.3 288H147.9L66.7 477.3c-7 16.4 5 34.7 22.9 34.7c6.1 0 11.9-2.2 16.5-6.3L375.7 266.9c5.3-4.7 8.3-11.4 8.3-18.4c0-13.6-11-24.6-24.6-24.6H236.1L317.3 34.7c7-16.4-5-34.7-22.9-34.7zm-5.9 18.2c1.6-1.4 3.7-2.2 5.9-2.2c6.4 0 10.7 6.5 8.1 12.4L216.6 228.8c-1.1 2.5-.8 5.3 .7 7.6s4 3.6 6.7 3.6H359.4c4.7 0 8.6 3.8 8.6 8.6c0 2.4-1 4.8-2.9 6.4L95.5 493.8c-1.6 1.4-3.7 2.2-5.9 2.2c-6.4 0-10.7-6.5-8.2-12.4l85.9-200.5c1.1-2.5 .8-5.3-.7-7.6s-4-3.6-6.7-3.6H23.3c-4.1 0-7.3-3.3-7.3-7.3c0-2.1 .9-4.1 2.5-5.5L288.5 18.2zM464 288c-3 0-5.8 1.7-7.2 4.4l-104 208c-2 4-.4 8.8 3.6 10.7s8.8 .4 10.7-3.6L388.9 464H539.1l21.8 43.6c2 4 6.8 5.6 10.7 3.6s5.6-6.8 3.6-10.7l-104-208c-1.4-2.7-4.1-4.4-7.2-4.4zm0 25.9L531.1 448H396.9L464 313.9z'
      
    ]
  };

  

  
  

  var faIndustryWindows = {
    prefix: 'fat',
    iconName: 'industry-windows',
    icon: [
      576,
      512,
      [127981,"industry-alt"],
      'f3b3',
      
      'M48 72c0-13.3 10.7-24 24-24h64c13.3 0 24 10.7 24 24V211.6c0 2.8 1.5 5.4 3.8 6.8s5.4 1.6 7.8 .3l157-81.4c10.7-5.5 23.4 2.2 23.4 14.2v59.1c0 2.8 1.5 5.5 4 6.9s5.5 1.5 8 .1L504.2 139c10.7-6 23.8 1.7 23.8 14V304v16V424c0 22.1-17.9 40-40 40H88c-22.1 0-40-17.9-40-40V352 304 72zM72 32C49.9 32 32 49.9 32 72V304v48 72c0 30.9 25.1 56 56 56H488c30.9 0 56-25.1 56-56V320 304 152.9c0-24.4-26.3-39.9-47.6-27.9L368 196.9V151.5c0-24-25.4-39.5-46.7-28.4L176 198.4V72c0-22.1-17.9-40-40-40H72zm72 272c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V328c0-13.3-10.7-24-24-24H144zm-8 24c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H144c-4.4 0-8-3.6-8-8V328zm112 0v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V328c0-13.3-10.7-24-24-24H272c-13.3 0-24 10.7-24 24zm24-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H272c-4.4 0-8-3.6-8-8V328c0-4.4 3.6-8 8-8zm128-16c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V328c0-13.3-10.7-24-24-24H400zm-8 24c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H400c-4.4 0-8-3.6-8-8V328z'
      
    ]
  };

  
    var faIndustryAlt = faIndustryWindows;
  

  
  

  var faCarMirrors = {
    prefix: 'fat',
    iconName: 'car-mirrors',
    icon: [
      576,
      512,
      [],
      'e343',
      
      'M138.4 88.6c6.9-24 28.8-40.6 53.8-40.6H383.7c25 0 47 16.6 53.8 40.6L467.7 194c-6.4-1.3-12.9-2-19.7-2H128c-6.7 0-13.3 .7-19.7 2L138.4 88.6zM88 200v.7c-4.6 2.1-8.9 4.5-13.1 7.3H32c-8.8 0-16-7.2-16-16s7.2-16 16-16H64c13.3 0 24 10.7 24 24zM123 84.2L96.6 176.8C89.3 166.6 77.4 160 64 160H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H56.4C41.2 241 32 263.4 32 288v96 16 48c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V400H448v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V400 384 288c0-24.6-9.2-47-24.4-64H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H512c-13.4 0-25.3 6.6-32.6 16.8L453 84.2C444.1 53.3 415.9 32 383.7 32H192.3c-32.1 0-60.4 21.3-69.2 52.2zM528 384H464 448 128 112 48V288c0-26.2 12.6-49.4 32-64h0v0c13.4-10 30-16 48-16H448c18 0 34.6 6 48 16v0h0c19.4 14.6 32 37.8 32 64v96zm-64 16h64v48c0 8.8-7.2 16-16 16H480c-8.8 0-16-7.2-16-16V400zM48 448V400h64v48c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM488 200.7V200c0-13.3 10.7-24 24-24h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H501.1c-4.1-2.8-8.5-5.2-13.1-7.3zM112 288a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faRacquet = {
    prefix: 'fat',
    iconName: 'racquet',
    icon: [
      512,
      512,
      [],
      'f45a',
      
      'M349 16c39.2 0 77 13.5 105.3 41.8S496 123.8 496 163c0 49.6-21.5 101.9-62.3 142.7c-72.2 72.2-183.4 85.1-248 20.5C157.5 297.9 144 260.2 144 221c0-49.6 21.5-101.9 62.3-142.7S299.3 16 349 16zm0-16c-54.2 0-110.5 23.4-154 66.9s-67 99.8-66.9 154c0 40.3 13.1 79.8 40.9 110.8l-32 32-10.3-10.3c-12.5-12.5-32.8-12.5-45.3 0l-72 72c-12.5 12.5-12.5 32.8 0 45.3l32 32c12.5 12.5 32.8 12.5 45.3 0l72-72c12.5-12.5 12.5-32.8 0-45.3L148.3 375l32-32c73.3 66.3 190.4 48.3 264.8-26c43.6-43.6 67-99.8 66.9-154c0-42.8-14.8-84.9-46.5-116.6S391.8 0 349 0zM92.7 364.7c6.2-6.2 16.4-6.2 22.6 0l32 32c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6l72-72z'
      
    ]
  };

  

  
  

  var faPiggyBank = {
    prefix: 'fat',
    iconName: 'piggy-bank',
    icon: [
      576,
      512,
      [],
      'f4d3',
      
      'M272 16c-53 0-96 43-96 96c0 4.4-3.6 8-8 8s-8-3.6-8-8C160 50.1 210.1 0 272 0c56 0 102.4 41.1 110.7 94.8c.7 4.4-2.3 8.5-6.7 9.1s-8.5-2.3-9.1-6.7C359.8 51.2 320 16 272 16zM52 200c-19.9 0-36 16.1-36 36s16.1 36 36 36H64.8c8-80.9 76.2-144 159.2-144H381c18.9-19.7 45.6-32 75-32h11.2c15.8 0 27.3 14.9 23.2 30.2l-9.2 34.7c21.4 16.4 38.6 38.1 49.6 63.2H544c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H512c-16.5 22-38.5 39.5-64 50.7V464c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V448H256v16c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48V416c-38.8-29.2-64-75.7-64-128H52c-28.7 0-52-23.3-52-52s23.3-52 52-52h4c4.4 0 8 3.6 8 8s-3.6 8-8 8H52zM248 432h80 16c4.4 0 8 3.6 8 8s-3.6 8-8 8h-8v16c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V429.4c0-3.3 2-6.2 5.1-7.4c26-10.3 48.4-28 64.4-50.6c1.5-2.1 3.9-3.4 6.5-3.4H544c8.8 0 16-7.2 16-16V256c0-8.8-7.2-16-16-16H525.4c-3.3 0-6.2-2-7.4-5.1c-10.3-26-28-48.4-50.6-64.4c-2.7-1.9-4-5.4-3.1-8.6l10.6-39.9c1.4-5.1-2.5-10.1-7.7-10.1H456c-26.1 0-49.5 11.3-65.6 29.3c-1.5 1.7-3.7 2.7-6 2.7l-.4 0h0H224c-79.5 0-144 64.5-144 144c0 48.5 23.9 91.3 60.6 117.4c2.1 1.5 3.4 3.9 3.4 6.5V464c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V448h-8c-4.4 0-8-3.6-8-8s3.6-8 8-8h16zM416 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faCarBump = {
    prefix: 'fat',
    iconName: 'car-bump',
    icon: [
      640,
      512,
      [],
      'f5e0',
      
      'M88.1 130.4L86.2 242.3c7.9-5 16.7-8.9 26.3-11.4l278.2-74.5c9.5-2.6 19.1-3.6 28.5-3.2l-57.6-96C348.7 35.7 323.2 25.4 299 31.8L129.6 77.2c-24.2 6.5-41.1 28.2-41.5 53.2zM70 255.2l2.1-125c.5-32.1 22.3-60 53.4-68.4L294.9 16.4c31.1-8.3 63.9 5 80.4 32.5l64.3 107.2c32.4 8.4 59.4 33.5 68.7 68.1L529 301.5l4.1 15.5 8.3 30.9c4.6 17.1-5.6 34.6-22.6 39.2l-30.9 8.3c-17.1 4.6-34.6-5.6-39.2-22.6l-8.3-30.9L162.2 416.4l8.3 30.9c4.6 17.1-5.6 34.6-22.6 39.2l-30.9 8.3c-17.1 4.6-34.6-5.6-39.2-22.6l-8.3-30.9-4.1-15.5L44.6 348.5c-9.3-34.6 1.6-69.9 25.4-93.3zM84.9 437.1L93.2 468c2.3 8.5 11.1 13.6 19.6 11.3l30.9-8.3c8.5-2.3 13.6-11.1 11.3-19.6l-8.3-30.9L84.9 437.1zM436.2 326.4l15.5-4.1 61.8-16.6-20.7-77.3c-11.4-42.7-55.3-68-98-56.6L116.6 246.4c-42.7 11.4-68 55.3-56.6 98l20.7 77.3L142.6 405l15.5-4.1 278.2-74.5zm27.9 42.2c2.3 8.5 11.1 13.6 19.6 11.3l30.9-8.3c8.5-2.3 13.6-11.1 11.3-19.6l-8.3-30.9-61.8 16.6 8.3 30.9zM152.8 319.5a16 16 0 1 0 -30.9 8.3 16 16 0 1 0 30.9-8.3zm-46.4 12.4a32 32 0 1 1 61.8-16.6 32 32 0 1 1 -61.8 16.6zm313.2-67.4a16 16 0 1 0 -8.3-30.9 16 16 0 1 0 8.3 30.9zm-12.4-46.4A32 32 0 1 1 423.8 280a32 32 0 1 1 -16.6-61.8zm16.7 286.9c-.6 4.4-4.7 7.4-9.1 6.8s-7.4-4.7-6.8-9c7-49.1 49.3-86.9 100.3-86.9s93.3 37.8 100.3 86.9c.6 4.4-2.4 8.4-6.8 9s-8.4-2.4-9-6.8c-5.9-41.3-41.5-73.1-84.5-73.1s-78.6 31.8-84.5 73.1z'
      
    ]
  };

  

  
  

  var faSushiRoll = {
    prefix: 'fat',
    iconName: 'sushi-roll',
    icon: [
      448,
      512,
      ["maki-roll","makizushi"],
      'e48b',
      
      'M448 128v-2 0 0c0-17-9.2-31.3-21.7-42.3c-12.5-11.1-29.7-20.4-49.6-27.8C336.8 40.9 282.8 32 224 32s-112.8 8.9-152.7 23.9C51.4 63.3 34.2 72.6 21.7 83.7C9.2 94.7 0 109 0 126v0 0 0 0 0 0 0 0 2V360v0c0 38 30.4 68.2 69.8 87.8C110.1 468 164.6 480 224 480s113.9-12 154.2-32.2C417.6 428.2 448 398 448 360v0V128zM224 48l.2 0c.7 10.2 2.7 20.3 6 30.1c-20.8 4.1-49.5 12.6-78.3 27.1c-32.4 16.3-65.5 40.3-87.3 74.3C34.3 165.5 16 147.6 16 128c0-44.2 93.1-80 208-80zM79.7 185.6c19.8-29.5 49.4-51.1 79.4-66.2c29-14.5 57.8-22.8 77.3-26.3c21.8 45.1 70.8 81.8 135.6 91C334.3 198.9 281.9 208 224 208c-56 0-106.9-8.5-144.3-22.4zM432 128c0 15.6-11.6 30.1-31.6 42.4c-93.9-1.6-155.2-62-160.1-122.2C347.6 51.4 432 85.9 432 128zM16 165.4c1.8 1.9 3.6 3.8 5.6 5.5c12.5 11.4 29.7 20.9 49.6 28.5C111.1 214.8 165.1 224 224 224s112.9-9.2 152.8-24.5c19.9-7.7 37.1-17.2 49.6-28.5c2-1.8 3.8-3.6 5.6-5.5V360v0c0 57.4-93.1 104-208 104S16 417.4 16 360v0V165.4z'
      
    ]
  };

  
    var faMakiRoll = faSushiRoll;
  
    var faMakizushi = faSushiRoll;
  

  
  

  var faFaceHeadBandage = {
    prefix: 'fat',
    iconName: 'face-head-bandage',
    icon: [
      576,
      512,
      [],
      'e37a',
      
      'M288 16c-59 0-113 21.3-154.8 56.6c-3.4 2.9-8.4 2.4-11.3-.9s-2.4-8.4 .9-11.3C167.4 22.7 225.1 0 288 0c16.9 0 33.5 1.6 49.5 4.8c4.3 .9 7.2 5.1 6.3 9.4s-5.1 7.2-9.4 6.3c-15-2.9-30.6-4.5-46.5-4.5zM536 248c4.4 0 8 3.6 8 8c0 141.4-114.6 256-256 256c-93.1 0-174.5-49.7-219.3-123.9c-2.3-3.8-1.1-8.7 2.7-11s8.7-1.1 11 2.7C124.4 449.5 200.8 496 288 496c132.5 0 240-107.5 240-240c0-4.4 3.6-8 8-8zm-343.6-8a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM389.9 391.1c-3 3.3-8 3.5-11.3 .5c-18-16.4-45.5-31.6-82.6-31.6c-13.9 0-26.4 2.1-37.6 5.6c-4.2 1.3-8.7-1-10-5.2s1-8.7 5.2-10c12.7-4 26.8-6.4 42.4-6.4c41.8 0 73 17.2 93.4 35.8c3.3 3 3.5 8 .5 11.3zM368.4 224a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM406 103.4C367.3 98.5 328 96 288 96c-23.1 0-46.1 .8-68.8 2.5c-13.4 1-26.8 2.3-40.1 3.8c-37.1 4.3-73.6 10.9-109.2 19.4c-10.8 17.5-19.6 36.5-26 56.5c-1.9 6-3.6 12-5 18.2c5.9-1.8 11.9-3.5 17.9-5.2c2.6-.7 5.2-1.4 7.8-2.1c10.7-2.9 21.6-5.5 32.5-8c45.4-10.2 92.2-16.9 140-19.7c12.8-.7 25.6-1.2 38.5-1.4c4.1-.1 8.3-.1 12.4-.1c80.1 0 157.6 10.9 231.2 31.3c6 1.7 11.9 3.4 17.9 5.2c-1.5-6.1-3.2-12.2-5-18.2c-6.4-20-15.1-39-26-56.5c-13.5-3.3-27.1-6.2-40.8-8.9c-19.5-3.8-39.3-6.9-59.2-9.5zM72.7 203.6C58.5 217.3 45 231.8 32.2 246.9c-.1 3-.2 6.1-.2 9.1c0 20.7 2.5 40.8 7.1 60.1c1.6 6.7 3.5 13.4 5.7 19.9c3.8-5.6 7.7-11.2 11.7-16.6c40.4-55.3 91-102.7 149.1-139.5c-45.4 4.4-89.8 12.3-132.8 23.6zM20 236.6c7.1-8.3 14.3-16.4 21.8-24.4c-4.9 .9-10.1-.6-13.8-4.1c-4.2-3.9-5.9-9.8-4.6-15.3c6.8-28.5 18-55.2 33-79.4c2.2-3.6 5.8-6.2 9.9-7.2c48.2-11.6 97.8-19.5 148.6-23.4c62.5-31.6 131-53 203.3-62c3.6-.4 7.2 .3 10.2 2.2c27.6 16.6 51.9 38 72 63.1c3.8 4.8 4.6 11.3 2 16.8c-.2 .5-.5 .9-.7 1.4c2.7 .6 5.4 1.3 8.1 1.9c4.1 1 7.7 3.6 9.9 7.2c14.9 24.2 26.2 50.9 33 79.4c1.3 5.6-.4 11.4-4.6 15.3s-10.1 5.3-15.6 3.7C455 188.5 373 176 288 176c-15.6 0-31.1 .4-46.4 1.3C167.9 217.9 104.9 275.6 58 345c-3.4 5.1-9.4 7.7-15.5 6.9s-11.1-5-13-10.8C20.8 314.3 16 285.7 16 256c0-3.2 .1-6.4 .2-9.7c.1-3.6 1.5-7 3.8-9.8zM288 80c60.9 0 120.5 5.8 178.3 16.8l1.3-.1c6.8-.3 13.5-.6 20.4-.7c-4.3-5.4-8.9-10.6-13.6-15.6c-15.9-16.9-34.2-31.6-54.2-43.7c-57 7.1-111.5 22.1-162.4 43.8c10.1-.3 20.1-.5 30.3-.5z'
      
    ]
  };

  

  
  

  var faCircleLocationArrow = {
    prefix: 'fat',
    iconName: 'circle-location-arrow',
    icon: [
      512,
      512,
      ["location-circle"],
      'f602',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm127.7 27c-11.7 0-21.9-8.3-24.2-19.8c-2.4-11.4 3.7-23.1 14.5-27.7L338.5 141c9.5-3.9 20.2-1.9 27.3 5.3c7.2 7.1 9.2 17.8 5.2 27.2L276.5 394c-3.9 9.1-12.9 15-22.8 15c-1.6 0-3.3-.1-4.9-.5C237.3 406.2 229 396 229 384.2V299 283H213 127.7zm-3.4-32.8l0 0c-3.8 1.6-5.9 5.8-5.1 9.8l0 0c.8 4.1 4.5 7 8.6 7H229c8.8 0 16 7.2 16 16V384.2c0 4.1 2.9 7.7 6.9 8.6c.5 .1 1.1 .2 1.8 .2c3.5 0 6.7-2.1 8.1-5.3l0 0 94.5-220.5 0 0c1.4-3.4 .7-7.1-1.8-9.6l-.1-.1 0 0c-2.3-2.4-6-3.3-9.7-1.8L124.3 250.2z'
      
    ]
  };

  
    var faLocationCircle = faCircleLocationArrow;
  

  
  

  var faFolderHeart = {
    prefix: 'fat',
    iconName: 'folder-heart',
    icon: [
      512,
      512,
      [],
      'e189',
      
      'M496 416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H197.5c12.7 0 24.9 5.1 33.9 14.1l35.9 35.9c9 9 21.2 14.1 33.9 14.1H448c26.5 0 48 21.5 48 48V416zM64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H301.3c-8.5 0-16.6-3.4-22.6-9.4L242.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64zm96-230.1c0-23.2 18.8-41.9 41.9-41.9c11.1 0 21.8 4.4 29.7 12.3L250.3 239c1.5 1.5 3.5 2.3 5.7 2.3s4.2-.8 5.7-2.3l18.7-18.7c7.9-7.9 18.5-12.3 29.7-12.3c23.2 0 41.9 18.8 41.9 41.9v.6c0 10.6-4 20.9-11.2 28.8l-78.9 86.1c-1.5 1.7-3.7 2.6-5.9 2.6s-4.4-.9-5.9-2.6l-78.9-86.1c-7.2-7.8-11.2-18.1-11.2-28.8v-.6zM201.9 192c-32 0-57.9 25.9-57.9 57.9v.6c0 14.7 5.5 28.8 15.4 39.6l78.9 86.1c4.5 5 11 7.8 17.7 7.8s13.1-2.8 17.7-7.8l78.9-86.1c9.9-10.8 15.4-24.9 15.4-39.6v-.6c0-32-25.9-57.9-57.9-57.9c-15.4 0-30.1 6.1-41 17L256 222.1 242.9 209c-10.9-10.9-25.6-17-41-17z'
      
    ]
  };

  

  
  

  var faPlaneUp = {
    prefix: 'fat',
    iconName: 'plane-up',
    icon: [
      512,
      512,
      [],
      'e22d',
      
      'M209.7 33.3C220.2 16.2 236.2 0 256 0c20.2 0 36.3 16.2 46.7 33.3C313.3 50.9 320 72.6 320 89.2l0 86.8 0 1.3 171.3 94.5c12.8 7 20.7 20.5 20.7 35l0 48.1c0 15.9-15.1 27.4-30.4 23.1L320 333.5l0 18.5 0 44 54.4 40.8c6 4.5 9.6 11.6 9.6 19.2l0 34.1c0 12.1-9.8 21.9-21.9 21.9c-2.2 0-4.4-.3-6.4-1L256 480.4 156.4 511c-2.1 .6-4.3 1-6.4 1c-12.1 0-21.9-9.8-21.9-21.9l0-34.1c0-7.6 3.6-14.7 9.6-19.2L192 396l0-44 0-18.5L30.4 378.1C15.1 382.3 0 370.8 0 355l0-48.1c0-14.6 7.9-28 20.7-35L192 177.3l0-1.3 0-86.8c0-16.6 7-38.3 17.7-55.9zM208 176l0 6.1 0 141 0 29 0 48c0 2.5-1.2 4.9-3.2 6.4l-57.6 43.2c-2 1.5-3.2 3.9-3.2 6.4l0 34.1c0 3.3 2.6 5.9 5.9 5.9c.6 0 1.2-.1 1.7-.3l102-31.4c1.5-.5 3.2-.5 4.7 0l102 31.4-2.3 7.5 2.3-7.5c.6 .2 1.1 .3 1.7 .3c3.3 0 5.9-2.6 5.9-5.9l0-34.1c0-2.5-1.2-4.9-3.2-6.4l-57.6-43.2c-2-1.5-3.2-3.9-3.2-6.4l0-48 0-29 0-140.9 0 0 0-6.1 0-86.8c0-13-5.6-31.9-15-47.5c-9.7-16-21.6-25.6-33-25.6c-10.9 0-22.8 9.6-32.7 25.7C213.7 57.3 208 76.2 208 89.2l0 86.8zm-16 19.6L28.4 285.9c-7.7 4.2-12.4 12.3-12.4 21L16 355c0 5.3 5 9.1 10.1 7.7L192 316.9l0-121.3zM320 316.9l165.9 45.8c5.1 1.4 10.1-2.4 10.1-7.7l0-48.1c0-8.7-4.8-16.8-12.4-21L320 195.6l0 121.3z'
      
    ]
  };

  

  
  

  var faMobileScreen = {
    prefix: 'fat',
    iconName: 'mobile-screen',
    icon: [
      384,
      512,
      ["mobile-android-alt"],
      'f3cf',
      
      'M288 16c26.5 0 48 21.5 48 48V384H48V64c0-26.5 21.5-48 48-48H288zm48 384v48c0 26.5-21.5 48-48 48H96c-26.5 0-48-21.5-48-48V400H336zM96 0C60.7 0 32 28.7 32 64V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H96zm40 448c0 4.4 3.6 8 8 8h96c4.4 0 8-3.6 8-8s-3.6-8-8-8H144c-4.4 0-8 3.6-8 8z'
      
    ]
  };

  
    var faMobileAndroidAlt = faMobileScreen;
  

  
  

  var faBellSchool = {
    prefix: 'fat',
    iconName: 'bell-school',
    icon: [
      512,
      512,
      [],
      'f5d5',
      
      'M208 400a192 192 0 1 0 0-384 192 192 0 1 0 0 384zm0 16c-48.3 0-92.7-16.4-128-44v92c0 17.7 14.3 32 32 32H272h32c17.7 0 32-14.3 32-32V372c-35.3 27.6-79.7 44-128 44zm64 96H112c-26.5 0-48-21.5-48-48V358.1C24.6 320.2 0 267 0 208C0 93.1 93.1 0 208 0S416 93.1 416 208c0 59-24.6 112.2-64 150.1V464c0 12.3-4.6 23.5-12.2 32H432c13.3 0 24-10.7 24-24V447.3c-22.7-3.8-40-23.6-40-47.3c0-26.5 21.5-48 48-48s48 21.5 48 48c0 23.8-17.3 43.5-40 47.3V472c0 22.1-17.9 40-40 40H304 272zM208 272a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-144a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM496 400a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faTemperatureThreeQuarters = {
    prefix: 'fat',
    iconName: 'temperature-three-quarters',
    icon: [
      320,
      512,
      ["temperature-3","thermometer-3","thermometer-three-quarters"],
      'f2c8',
      
      'M160 16c-35.3 0-64 28.7-64 64V243.8c0 8.4-4.4 15.7-10.7 20.3C53 287.3 32 325.2 32 368c0 70.7 57.3 128 128 128s128-57.3 128-128c0-42.8-21-80.7-53.3-104c-6.3-4.6-10.7-11.9-10.7-20.3V80c0-35.3-28.7-64-64-64zM80 80c0-44.2 35.8-80 80-80s80 35.8 80 80V243.8c0 2.7 1.4 5.4 4 7.3c36.3 26.1 60 68.8 60 117c0 79.5-64.5 144-144 144S16 447.5 16 368c0-48.2 23.7-90.8 60-117c2.6-1.9 4-4.6 4-7.3V80zm80 336a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 16c-35.3 0-64-28.7-64-64c0-32.6 24.4-59.6 56-63.5V136c0-4.4 3.6-8 8-8s8 3.6 8 8V304.5c31.6 3.9 56 30.9 56 63.5c0 35.3-28.7 64-64 64z'
      
    ]
  };

  
    var faTemperature3 = faTemperatureThreeQuarters;
  
    var faThermometer3 = faTemperatureThreeQuarters;
  
    var faThermometerThreeQuarters = faTemperatureThreeQuarters;
  

  
  

  var faBoxingGlove = {
    prefix: 'fat',
    iconName: 'boxing-glove',
    icon: [
      448,
      512,
      [129354,"glove-boxing"],
      'f438',
      
      'M16 104c0-48.6 39.4-88 88-88H280c48.6 0 88 39.4 88 88v24H336c-38.7 0-71 27.5-78.4 64H136c-30.9 0-56-25.1-56-56v-8c0-4.4-3.6-8-8-8s-8 3.6-8 8v8c0 39.8 32.2 72 72 72H256c0 44.2 35.8 80 80 80c4.4 0 8-3.6 8-8s-3.6-8-8-8c-35.3 0-64-28.7-64-64s28.7-64 64-64h38c.3 0 .7 0 1-.1c.3 0 .7 .1 1 .1c30.9 0 56 25.1 56 56v48.7c0 18.1-6.8 35.5-19.1 48.8l-64.2 69.5c-8.2 8.9-12.7 20.5-12.7 32.6V464c0 17.7-14.3 32-32 32H80c-17.7 0-32-14.3-32-32V359.6c0-2.3-1-4.4-2.7-6C27.3 337.5 16 314.1 16 288V104zM104 0C46.6 0 0 46.6 0 104V288c0 29.5 12.3 56.1 32 75V464c0 26.5 21.5 48 48 48H304c26.5 0 48-21.5 48-48V399.6c0-8 3-15.8 8.5-21.7l64.2-69.5c15-16.3 23.3-37.6 23.3-59.7V200c0-37.1-28-67.6-64-71.6V104C384 46.6 337.4 0 280 0H104zm36.6 337.5c-3.6-2.6-8.6-1.7-11.2 1.9s-1.7 8.6 1.9 11.2L178.2 384l-46.9 33.5c-3.6 2.6-4.4 7.6-1.9 11.2s7.6 4.4 11.2 1.9L192 393.8l51.4 36.7c3.6 2.6 8.6 1.7 11.2-1.9s1.7-8.6-1.9-11.2L205.8 384l46.9-33.5c3.6-2.6 4.4-7.6 1.9-11.2s-7.6-4.4-11.2-1.9L192 374.2l-51.4-36.7z'
      
    ]
  };

  
    var faGloveBoxing = faBoxingGlove;
  

  
  

  var faHouseChimneyMedical = {
    prefix: 'fat',
    iconName: 'house-chimney-medical',
    icon: [
      576,
      512,
      ["clinic-medical"],
      'f7f2',
      
      'M282.7 2c3-2.7 7.6-2.7 10.6 0L384 82.3V56c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V195.7L573.3 250c3.3 2.9 3.6 8 .7 11.3s-8 3.6-11.3 .7L512 217.1V448c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V217.1L13.3 262c-3.3 2.9-8.4 2.6-11.3-.7S-.6 252.9 2.7 250L282.7 2zM496 181.5V56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8V96.5l96 85zM384 103.7l-96-85L80 202.9V448c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V202.9L384.3 104H384v-.3zM272 192c-4.4 0-8 3.6-8 8v56c0 4.4-3.6 8-8 8H200c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h56c4.4 0 8 3.6 8 8v56c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V320c0-4.4 3.6-8 8-8h56c4.4 0 8-3.6 8-8V272c0-4.4-3.6-8-8-8H320c-4.4 0-8-3.6-8-8V200c0-4.4-3.6-8-8-8H272zm-24 8c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v48h48c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H328v48c0 13.3-10.7 24-24 24H272c-13.3 0-24-10.7-24-24V328H200c-13.3 0-24-10.7-24-24V272c0-13.3 10.7-24 24-24h48V200z'
      
    ]
  };

  
    var faClinicMedical = faHouseChimneyMedical;
  

  
  

  var faCards = {
    prefix: 'fat',
    iconName: 'cards',
    icon: [
      640,
      512,
      [],
      'e3ed',
      
      'M228.4 21.5c19.1-11 43.6-4.5 54.6 14.6L449.8 324.9c11 19.1 4.5 43.6-14.6 54.6l-192.3 111c-19.1 11-43.6 4.5-54.6-14.6L21.5 187.2c-11-19.1-4.5-43.6 14.6-54.6l192.3-111zM28.1 118.7c-26.8 15.5-36 49.7-20.5 76.5L174.3 483.9c15.5 26.8 49.7 36 76.5 20.5l192.3-111c26.8-15.5 36-49.7 20.5-76.5L296.9 28.1c-15.5-26.8-49.7-36-76.5-20.5L28.1 118.7zM253.3 358.3c2.2 3.8 7.1 5.1 10.9 2.9l48.2-27.8c3.8-2.2 5.1-7.1 2.9-10.9s-7.1-5.1-10.9-2.9L288.1 329l-18.1-29.2 .1 0 0 0 .1 0c28 7.8 59.1-6 68.5-33.5c11.2-31.9-7.3-66.4-38.8-75.4l0 0L190.6 159.9c-6.7-2-14.1 2-16.1 9.3l0 0-.1 .2L147.2 279.2c-7.9 31.8 12.6 65.1 45.5 71.5l0 0 .2 0c29.1 5.1 56.1-14.6 63.5-42.5L274.2 337l-18 10.4c-3.8 2.2-5.1 7.1-2.9 10.9zm-12.5-54.2c-5.5 20.8-25.1 34.3-45.2 30.8C172 330.2 157 306.1 162.7 283l0 0 26.6-106.9 106.2 30.2 0 0c22.8 6.6 36.2 31.7 28.1 54.8l0 .1c-6.3 18.4-28.1 29.1-49.1 23.3l-19.5-5.7c-2.1-.6-4.4-.3-6.3 .8s-3.3 3-3.7 5.2l-4.2 19.4zM324.1 499c9.7 8.1 22.2 13 35.9 13H584c30.9 0 56-25.1 56-56V120c0-30.9-25.1-56-56-56H360c-1.8 0-3.5 .1-5.3 .2L363.8 80H584c22.1 0 40 17.9 40 40V456c0 22.1-17.9 40-40 40H360c-7.6 0-14.7-2.1-20.7-5.8L324.1 499zM502 151.1l4.3 4.5c1.5 1.6 3.7 2.5 5.9 2.5s4.3-1 5.8-2.6l4-4.5c8.3-8.4 21.4-9.5 30.1-2.3c10 8.8 10.5 24.4 1.4 33.8l0 0-41.4 42.9-41.7-42.9 0 0c-9.1-9.4-8.6-25.1 1.6-33.8l0 0 0 0c8.1-7.1 21.5-6.2 29.9 2.4zm10-12.6c-13.6-12.5-35.4-14.8-50.3-1.9c-17.3 14.8-18.1 41.1-2.7 57.1l0 0 42.3 43.6c5.9 6.3 15.7 6 21.5 .1l0 0 .1-.1L565 193.7l0 0c15.4-15.9 14.6-42.2-2.5-57l0 0-.1-.1c-15.2-12.8-36.8-10.6-50.5 2z'
      
    ]
  };

  

  
  

  var faLocationDotSlash = {
    prefix: 'fat',
    iconName: 'location-dot-slash',
    icon: [
      640,
      512,
      ["map-marker-alt-slash"],
      'f605',
      
      'M393.8 406c-23.5 33.5-46.3 62.9-62.6 83.2c-5.9 7.3-16.6 7.3-22.4 0c-25.5-31.8-67.1-86.2-102.3-143.2c-17.6-28.5-33.4-57.4-44.7-84.3c-8-19-13.6-36.4-16.1-51.5l-17.6-13.9c3.6 88.1 117.7 239.8 168.2 302.9c12.3 15.3 35.1 15.3 47.4 0c16.2-20.3 39.1-49.7 62.6-83.3L393.8 406zM320 0C266.7 0 218.5 21.7 183.8 56.7l12.6 10C228.2 35.3 271.8 16 320 16c97.2 0 176 78.8 176 176c0 18.7-6.4 42.5-17.8 69.6c-2.8 6.6-5.9 13.4-9.2 20.3L481.9 292c18.1-36.9 30.1-72 30.1-100C512 86 426 0 320 0zm80 192c0-44.2-35.8-80-80-80c-17.5 0-33.8 5.6-46.9 15.2l13.2 10.4c9.8-6.1 21.4-9.6 33.8-9.6c35.3 0 64 28.7 64 64c0 7.1-1.1 13.9-3.3 20.2l13.2 10.4c3.9-9.4 6.1-19.8 6.1-30.6zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  
    var faMapMarkerAltSlash = faLocationDotSlash;
  

  
  

  var faCaretDown = {
    prefix: 'fat',
    iconName: 'caret-down',
    icon: [
      320,
      512,
      [],
      'f0d7',
      
      'M144.6 361.4c4 4.2 9.6 6.6 15.4 6.6s11.4-2.4 15.4-6.6L300.5 229.3c2.2-2.3 3.5-5.4 3.5-8.7c0-7-5.6-12.6-12.6-12.6H28.6c-7 0-12.6 5.6-12.6 12.6c0 3.2 1.2 6.3 3.5 8.7L144.6 361.4zm-11.6 11L7.8 240.3C2.8 235 0 227.9 0 220.6C0 204.8 12.8 192 28.6 192H291.4c15.8 0 28.6 12.8 28.6 28.6c0 7.3-2.8 14.4-7.8 19.7L187 372.4c-7 7.4-16.8 11.6-27 11.6s-20-4.2-27-11.6z'
      
    ]
  };

  

  
  

  var faBallot = {
    prefix: 'fat',
    iconName: 'ballot',
    icon: [
      448,
      512,
      [],
      'f732',
      
      'M384 16c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H384zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM192 128c0 4.4 3.6 8 8 8H376c4.4 0 8-3.6 8-8s-3.6-8-8-8H200c-4.4 0-8 3.6-8 8zm0 128c0 4.4 3.6 8 8 8H376c4.4 0 8-3.6 8-8s-3.6-8-8-8H200c-4.4 0-8 3.6-8 8zm0 128c0 4.4 3.6 8 8 8H376c4.4 0 8-3.6 8-8s-3.6-8-8-8H200c-4.4 0-8 3.6-8 8zm-88-40H88c-17.7 0-32 14.3-32 32v16c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V376c0-17.7-14.3-32-32-32zM72 376c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H88c-8.8 0-16-7.2-16-16V376zM88 216c-17.7 0-32 14.3-32 32v16c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V248c0-17.7-14.3-32-32-32H88zm0 16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H88c-8.8 0-16-7.2-16-16V248c0-8.8 7.2-16 16-16zM104 88H88c-17.7 0-32 14.3-32 32v16c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V120c0-17.7-14.3-32-32-32zM72 120c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H88c-8.8 0-16-7.2-16-16V120z'
      
    ]
  };

  

  
  

  var faUsbDrive = {
    prefix: 'fat',
    iconName: 'usb-drive',
    icon: [
      640,
      512,
      [],
      'f8e9',
      
      'M64 112c-26.5 0-48 21.5-48 48V352c0 26.5 21.5 48 48 48H416c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H64zM0 160c0-35.3 28.7-64 64-64H416c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H64c-35.3 0-64-28.7-64-64V160zM480 384V368H608c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16H480V128H608c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H480zm64-80a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm32-16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z'
      
    ]
  };

  

  
  

  var faArrowsFromDottedLine = {
    prefix: 'fat',
    iconName: 'arrows-from-dotted-line',
    icon: [
      448,
      512,
      [],
      'e0a3',
      
      'M218.3 2.3c3.1-3.1 8.2-3.1 11.3 0l88 88c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L232 27.3V184c0 4.4-3.6 8-8 8s-8-3.6-8-8V27.3l-74.3 74.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l88-88zM32 240a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm96 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm96 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm112-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM317.7 421.7l-88 88c-3.1 3.1-8.2 3.1-11.3 0l-88-88c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L216 484.7V328c0-4.4 3.6-8 8-8s8 3.6 8 8V484.7l74.3-74.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3z'
      
    ]
  };

  

  
  

  var faKeyboard = {
    prefix: 'fat',
    iconName: 'keyboard',
    icon: [
      576,
      512,
      [9000],
      'f11c',
      
      'M64 80c-26.5 0-48 21.5-48 48V384c0 26.5 21.5 48 48 48H512c26.5 0 48-21.5 48-48V128c0-26.5-21.5-48-48-48H64zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM88 336c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V344c0-4.4-3.6-8-8-8H88zm-24 8c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V344zm328-8H184c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8H392c4.4 0 8-3.6 8-8V344c0-4.4-3.6-8-8-8zM184 320H392c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H184c-13.3 0-24-10.7-24-24V344c0-13.3 10.7-24 24-24zM88 240c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V248c0-4.4-3.6-8-8-8H88zm-24 8c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V248zm136-8H184c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V248c0-4.4-3.6-8-8-8zm-16-16h16c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H184c-13.3 0-24-10.7-24-24V248c0-13.3 10.7-24 24-24zm96 16c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V248c0-4.4-3.6-8-8-8H280zm-24 8c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H280c-13.3 0-24-10.7-24-24V248zm136-8H376c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V248c0-4.4-3.6-8-8-8zm-16-16h16c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H376c-13.3 0-24-10.7-24-24V248c0-13.3 10.7-24 24-24zm96 16c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V248c0-4.4-3.6-8-8-8H472zm-24 8c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H472c-13.3 0-24-10.7-24-24V248zm40 88H472c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V344c0-4.4-3.6-8-8-8zm-16-16h16c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H472c-13.3 0-24-10.7-24-24V344c0-13.3 10.7-24 24-24zM88 144c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8H88zm-24 8c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V152zm136-8H184c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm-16-16h16c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H184c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm96 16c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8H280zm-24 8c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H280c-13.3 0-24-10.7-24-24V152zm136-8H376c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm-16-16h16c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H376c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm96 16c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8H472zm-24 8c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H472c-13.3 0-24-10.7-24-24V152z'
      
    ]
  };

  

  
  

  var faTimeline = {
    prefix: 'fat',
    iconName: 'timeline',
    icon: [
      640,
      512,
      [],
      'e29c',
      
      'M160 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm8 111.5c31.6-3.9 56-30.9 56-63.5c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 32.6 24.4 59.6 56 63.5V256H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H312v96.5c-31.6 3.9-56 30.9-56 63.5c0 35.3 28.7 64 64 64s64-28.7 64-64c0-32.6-24.4-59.6-56-63.5V272H632c4.4 0 8-3.6 8-8s-3.6-8-8-8H488V143.5c31.6-3.9 56-30.9 56-63.5c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 32.6 24.4 59.6 56 63.5V256H168V143.5zM432 80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM272 432a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  

  
  

  var faS = {
    prefix: 'fat',
    iconName: 's',
    icon: [
      320,
      512,
      [115],
      '53',
      
      'M75.7 60.9C44.1 73.7 23.4 95.7 17.8 126.2c-3.7 20.3-1.5 36.1 4.5 48.9c6.1 12.9 16.3 23.5 30.1 32.5c27.8 18.4 67.9 29.3 109.7 40.6l.9 .2c40.8 11 83.2 22.6 113.4 42.5c15.4 10.2 28.1 22.8 35.7 39.1c7.7 16.4 10 35.7 5.8 58.6c-6.8 37.1-32.1 62.8-67.6 77.2c-35.3 14.3-80.9 17.6-130.3 10.3l0 0c-25.6-3.9-67.9-17.6-97.8-27.3c-6.1-2-11.7-3.8-16.6-5.3c-4.2-1.3-6.6-5.8-5.2-10s5.8-6.6 10-5.2c5.1 1.6 11 3.5 17.3 5.5c30 9.7 70.5 22.8 94.7 26.5c47.5 7 90.1 3.6 121.9-9.3c31.6-12.8 52.3-34.8 57.9-65.3c3.7-20.2 1.5-36.1-4.5-48.9c-6.1-12.9-16.3-23.5-30.1-32.5c-27.8-18.4-67.9-29.3-109.7-40.6l-.9-.2c-40.8-11-83.2-22.6-113.4-42.5c-15.4-10.2-28.1-22.8-35.7-39.1c-7.7-16.4-9.9-35.7-5.8-58.6C8.8 86.2 34.2 60.5 69.7 46.1c35.3-14.3 80.9-17.6 130.3-10.3c14.9 2.2 60.5 10.6 76 14.5c4.3 1.1 6.9 5.4 5.8 9.7s-5.4 6.9-9.7 5.8c-14.8-3.7-59.8-12-74.5-14.2c-47.5-7-90.1-3.6-121.9 9.3z'
      
    ]
  };

  

  
  

  var faOverline = {
    prefix: 'fat',
    iconName: 'overline',
    icon: [
      448,
      512,
      [],
      'f876',
      
      'M8 48H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H8c-4.4 0-8 3.6-8 8s3.6 8 8 8zm216 80c-88.4 0-160 71.6-160 160v32c0 88.4 71.6 160 160 160s160-71.6 160-160V288c0-88.4-71.6-160-160-160zM80 288c0-79.5 64.5-144 144-144s144 64.5 144 144v32c0 79.5-64.5 144-144 144s-144-64.5-144-144V288z'
      
    ]
  };

  

  
  

  var faSquareUpLeft = {
    prefix: 'fat',
    iconName: 'square-up-left',
    icon: [
      448,
      512,
      [],
      'e282',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 72V295c0 5 4 9 9 9c2.4 0 4.7-.9 6.3-2.6l35-35c3.1-3.1 8.2-3.1 11.3 0L272 348.7c2.1 2.1 5 3.3 8 3.3s5.9-1.2 8-3.3L316.7 320c2.1-2.1 3.3-5 3.3-8s-1.2-5.9-3.3-8l-82.3-82.3c-3.1-3.1-3.1-8.2 0-11.3l35-35c1.7-1.7 2.6-4 2.6-6.3c0-5-4-9-9-9H136c-4.4 0-8 3.6-8 8zm8-24H263c13.8 0 25 11.2 25 25c0 6.6-2.6 13-7.3 17.7L251.3 216 328 292.7c5.1 5.1 8 12.1 8 19.3s-2.9 14.2-8 19.3L299.3 360c-5.1 5.1-12.1 8-19.3 8s-14.2-2.9-19.3-8L184 283.3l-29.4 29.4c-4.7 4.7-11 7.3-17.7 7.3c-13.8 0-25-11.2-25-25V168c0-13.3 10.7-24 24-24z'
      
    ]
  };

  

  
  

  var faBaseballBatBall = {
    prefix: 'fat',
    iconName: 'baseball-bat-ball',
    icon: [
      512,
      512,
      [],
      'f432',
      
      'M424 0c-12.4 0-24.2 4.9-33 13.7L233.5 171.2c-10.5 10.5-19.8 22.1-27.7 34.6L132.7 321.6c-7.3 11.5-15.8 22.2-25.5 31.9L28 432.7 13.7 418.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l80 80c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L79.3 484l79.2-79.2c9.6-9.6 20.3-18.2 31.9-25.5l115.8-73.1c12.5-7.9 24.1-17.2 34.6-27.7L498.3 121c8.7-8.7 13.7-20.6 13.7-33s-4.9-24.2-13.7-33L457 13.7C448.2 4.9 436.4 0 424 0zM68 472.7L39.3 444l79.2-79.2c1.8-1.8 3.6-3.7 5.4-5.6l28.9 28.9c-1.9 1.8-3.8 3.5-5.6 5.4L68 472.7zm97-95L134.3 347c4.2-5.4 8.2-11 11.9-16.8l73.1-115.8c7.3-11.5 15.8-22.2 25.5-31.9L402.3 25c5.7-5.7 13.5-9 21.7-9s15.9 3.2 21.7 9L487 66.3c5.7 5.7 9 13.5 9 21.7s-3.2 15.9-9 21.7L329.5 267.2c-9.6 9.6-20.3 18.2-31.9 25.5L181.8 365.8c-5.8 3.7-11.4 7.6-16.8 11.9zM368 432a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm144 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z'
      
    ]
  };

  

  
  

  var faPenNibSlash = {
    prefix: 'fat',
    iconName: 'pen-nib-slash',
    icon: [
      640,
      512,
      [],
      'e4a1',
      
      'M13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7zM479.1 220.2l76.6-76.6c21.9-21.9 21.9-57.3 0-79.2L511.6 20.3c-21.9-21.9-57.3-21.9-79.2 0L355.8 96.9l-87.4 26.6 15.3 12.1 74.1-22.5L463 218.3l-14.4 47.5L462 276.4l17.1-56.1zM386.9 400.5c-1.7 .8-3.5 1.4-5.4 2L96.4 493c-.8 .3-1.6 .4-2.5 .5L238.5 348.9c9.3 7 21 11.1 33.5 11.1c16.2 0 30.7-6.9 41-17.8l-12.6-10c-7.2 7.3-17.3 11.8-28.3 11.8c-22.1 0-40-17.9-40-40c0-7.7 2.2-14.9 6-21l-12.6-10c-5.9 8.9-9.4 19.5-9.4 31c0 12.6 4.1 24.2 11.1 33.5L82.6 482.1c.1-.8 .2-1.7 .5-2.5l80.9-255.1-13.4-10.6L67.8 474.8c-3 9.5-.5 19.8 6.5 26.9s17.4 9.6 26.9 6.6l285.1-90.4c5.1-1.6 9.9-3.7 14.4-6.4l-13.8-10.9zM443.7 31.6c15.6-15.6 40.9-15.6 56.6 0l44.1 44.1c15.6 15.6 15.6 40.9 0 56.6L472 204.7 371.3 104l72.4-72.4z'
      
    ]
  };

  

  
  

  var faListRadio = {
    prefix: 'fat',
    iconName: 'list-radio',
    icon: [
      512,
      512,
      [],
      'e1d0',
      
      'M64 56a40 40 0 1 0 0 80 40 40 0 1 0 0-80zm0 96A56 56 0 1 1 64 40a56 56 0 1 1 0 112zM168 96c0-4.4 3.6-8 8-8H496c4.4 0 8 3.6 8 8s-3.6 8-8 8H176c-4.4 0-8-3.6-8-8zm0 160c0-4.4 3.6-8 8-8H496c4.4 0 8 3.6 8 8s-3.6 8-8 8H176c-4.4 0-8-3.6-8-8zm0 160c0-4.4 3.6-8 8-8H496c4.4 0 8 3.6 8 8s-3.6 8-8 8H176c-4.4 0-8-3.6-8-8zM64 216a40 40 0 1 0 0 80 40 40 0 1 0 0-80zm0 96a56 56 0 1 1 0-112 56 56 0 1 1 0 112zm40 104a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM8 416a56 56 0 1 1 112 0A56 56 0 1 1 8 416zM64 112a16 16 0 1 1 0-32 16 16 0 1 1 0 32z'
      
    ]
  };

  

  
  

  var faLampStreet = {
    prefix: 'fat',
    iconName: 'lamp-street',
    icon: [
      512,
      512,
      [],
      'e1c5',
      
      'M16 164C16 82.3 82.3 16 164 16h4c79.5 0 144 64.5 144 144h8c-95.2 0-174.2 69.3-189.4 160.1C127.7 337.6 142.3 352 160 352H480c17.7 0 32.3-14.4 29.4-31.9C494.2 229.3 415.2 160 320 160h8C328 71.6 256.4 0 168 0h-4C73.4 0 0 73.4 0 164V504c0 4.4 3.6 8 8 8s8-3.6 8-8V164zm304 12c87.2 0 159.7 63.5 173.6 146.8c1 5.9-3.9 13.2-13.6 13.2H160c-9.7 0-14.6-7.4-13.6-13.2C160.3 239.5 232.8 176 320 176zM241.6 384c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64H382c-7.1 27.6-32.2 48-62 48s-54.9-20.4-62-48H241.6z'
      
    ]
  };

  

  
  

  var faCloudSleet = {
    prefix: 'fat',
    iconName: 'cloud-sleet',
    icon: [
      512,
      512,
      [],
      'f741',
      
      'M398.7 124.8c.8-4.1 1.3-8.4 1.3-12.8c0-35.3-28.7-64-64-64c-19.5 0-36.9 8.7-48.6 22.4c-3.5 4-8.7 6.1-13.9 5.5s-9.9-3.8-12.4-8.5C245 36.8 212.9 16 176 16c-53 0-96 43-96 96c0 6.1 .6 12.1 1.7 17.9c1.5 7.9-3.1 15.6-10.7 18.1C39 158.5 16 188.6 16 224c0 44.2 35.8 80 80 80H416c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.5 0-.9 0-1.3 0c-4.8 .1-9.5-2-12.6-5.8s-4.3-8.7-3.4-13.4zM176 0c37.1 0 70 18.1 90.4 45.9c3.3 4.5 6.2 9.2 8.8 14.1c3.6-4.2 7.6-8 12-11.4C300.7 38.2 317.6 32 336 32c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c4.9 0 9.8 .4 14.5 1.1c46.1 7 81.5 46.8 81.5 94.9c0 53-43 96-96 96H96c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0zM79.2 379.6l-64 128c-2 4-6.8 5.6-10.7 3.6s-5.6-6.8-3.6-10.7l64-128c2-4 6.8-5.6 10.7-3.6s5.6 6.8 3.6 10.7zm256 0l-64 128c-2 4-6.8 5.6-10.7 3.6s-5.6-6.8-3.6-10.7l64-128c2-4 6.8-5.6 10.7-3.6s5.6 6.8 3.6 10.7zM184 368v40l40 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-40 0v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V424l-40 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l40 0V368c0-4.4 3.6-8 8-8s8 3.6 8 8zm248-8c4.4 0 8 3.6 8 8v40l40 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-40 0v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V424l-40 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l40 0V368c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faFaucet = {
    prefix: 'fat',
    iconName: 'faucet',
    icon: [
      512,
      512,
      [],
      'e005',
      
      'M224 64c4.4 0 8 3.6 8 8v46.6l103.2-16.3c25.6-4 48.8 15.7 48.8 41.7s-23.2 45.7-48.8 41.7L232 169.4V208h26.7c10.6 0 20.8 4.2 28.3 11.7L323.3 256H376c75.1 0 136 60.9 136 136v16c0 22.1-17.9 40-40 40H424c-22.1 0-40-17.9-40-40c0-13.3-10.8-24-24-24l-40.1 .1C298 413.2 263.2 432 224 432s-74-18.8-95.9-47.8L8 384c-4.4 0-8-3.6-8-8s3.6-8 8-8l124.2 .2c2.6 0 5 1.3 6.5 3.4c18.8 26.9 50 44.4 85.3 44.4s66.4-17.5 85.3-44.4c1.5-2.1 3.9-3.4 6.5-3.4l44.2-.1c22.1 0 40 17.9 40 40c0 13.2 10.7 24 24 24h48c13.3 0 24-10.7 24-24V392c0-66.3-53.7-120-120-120H320c-2.1 0-4.2-.8-5.7-2.3L275.7 231c-4.5-4.5-10.6-7-17-7H189.3c-6.4 0-12.5 2.5-17 7l-38.6 38.6c-1.5 1.5-3.5 2.3-5.7 2.3H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H124.7L161 219.7c7.5-7.5 17.7-11.7 28.3-11.7H216V169.4L112.8 185.7C87.2 189.7 64 169.9 64 144s23.2-45.7 48.8-41.7L216 118.6V72c0-4.4 3.6-8 8-8zM110.3 118.1C94.4 115.6 80 127.9 80 144s14.4 28.4 30.3 25.9L216 153.2V134.8L110.3 118.1zm227.5 0L232 134.8v18.3l105.7 16.7c15.9 2.5 30.3-9.8 30.3-25.9s-14.4-28.4-30.3-25.9z'
      
    ]
  };

  

  
  

  var faArrowsMaximize = {
    prefix: 'fat',
    iconName: 'arrows-maximize',
    icon: [
      512,
      512,
      ["expand-arrows"],
      'f31d',
      
      'M328 32c-4.4 0-8 3.6-8 8s3.6 8 8 8H452.7L256 244.7 59.3 48H184c4.4 0 8-3.6 8-8s-3.6-8-8-8H40c-4.4 0-8 3.6-8 8V184c0 4.4 3.6 8 8 8s8-3.6 8-8V59.3L244.7 256 48 452.7V328c0-4.4-3.6-8-8-8s-8 3.6-8 8V472c0 4.4 3.6 8 8 8H184c4.4 0 8-3.6 8-8s-3.6-8-8-8H59.3L256 267.3 452.7 464H328c-4.4 0-8 3.6-8 8s3.6 8 8 8H472c4.4 0 8-3.6 8-8V328c0-4.4-3.6-8-8-8s-8 3.6-8 8V452.7L267.3 256 464 59.3V184c0 4.4 3.6 8 8 8s8-3.6 8-8V40c0-4.4-3.6-8-8-8H328z'
      
    ]
  };

  
    var faExpandArrows = faArrowsMaximize;
  

  
  

  var faCarBolt = {
    prefix: 'fat',
    iconName: 'car-bolt',
    icon: [
      512,
      512,
      [],
      'e341',
      
      'M106.4 88.6L76.3 194c6.4-1.3 12.9-2 19.7-2h32v16H96c-44.2 0-80 35.8-80 80v96H64 80 432h16 48V288c0-44.2-35.8-80-80-80H384V192h32c6.7 0 13.3 .7 19.7 2L405.6 88.6c-6.9-24-28.8-40.6-53.8-40.6H160.3c-25 0-47 16.6-53.8 40.6zM58 199.8L91 84.2C99.9 53.3 128.1 32 160.3 32H351.7c32.1 0 60.4 21.3 69.2 52.2l33 115.6c34.1 14.7 58 48.7 58 88.2v96 16 48c0 17.7-14.3 32-32 32H464c-17.7 0-32-14.3-32-32V400H80v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V400 384 288c0-39.5 23.9-73.5 58-88.2zM448 400v48c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V400H448zM16 400v48c0 8.8 7.2 16 16 16H48c8.8 0 16-7.2 16-16V400H16zm96-112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm352 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM315.4 120l-32 55.9h45.6c16 0 22.1 20.9 8.6 29.5L212.1 285.3c-14.1 9-30.8-6.9-22.5-21.4l32-55.9H176c-16 0-22.1-20.9-8.6-29.5L293 98.6c14.1-9 30.8 6.9 22.5 21.4zM176 191.9l59.4 0c2.9 0 5.5 1.5 6.9 4s1.4 5.5 0 8l-38.8 67.9 125.5-79.9H269.7c-2.9 0-5.5-1.5-6.9-4s-1.4-5.5 0-8l38.8-67.9L176 191.9z'
      
    ]
  };

  

  
  

  var faPallet = {
    prefix: 'fat',
    iconName: 'pallet',
    icon: [
      640,
      512,
      [],
      'f482',
      
      'M8 352c-4.4 0-8 3.6-8 8s3.6 8 8 8H80V496H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H88 320 552h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H560V368h72c4.4 0 8-3.6 8-8s-3.6-8-8-8H552 320 88 8zm88 16H312V496H96V368zm232 0H544V496H328V368z'
      
    ]
  };

  

  
  

  var faBackwardStep = {
    prefix: 'fat',
    iconName: 'backward-step',
    icon: [
      320,
      512,
      ["step-backward"],
      'f048',
      
      'M48 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V256 440c0 4.4 3.6 8 8 8s8-3.6 8-8V277.6L239.8 441c5.3 4.5 12 7 19 7c16.1 0 29.2-13.1 29.2-29.2V93.2C288 77.1 274.9 64 258.8 64c-6.9 0-13.7 2.5-19 7L48 234.4V72zm0 184c0-.4 .2-.8 .5-1L250.2 83.2c2.4-2 5.4-3.2 8.6-3.2c7.3 0 13.2 5.9 13.2 13.2V418.8c0 7.3-5.9 13.2-13.2 13.2c-3.1 0-6.2-1.1-8.6-3.2L48.5 257c-.3-.3-.5-.6-.5-1z'
      
    ]
  };

  
    var faStepBackward = faBackwardStep;
  

  
  

  var faTruckTow = {
    prefix: 'fat',
    iconName: 'truck-tow',
    icon: [
      640,
      512,
      [],
      'e2b8',
      
      'M209.9 256H366.1L157.6 21.4c-3-3.4-7.4-5.4-12-5.4H96c-2 0-3.9 .4-5.6 1l3.9 7.8L209.9 256zM384 252V152c0-22.1 17.9-40 40-40h66.3c16.1 0 31.4 6.9 42 18.9L630 241.6c6.4 7.3 10 16.7 10 26.5V376c0 22.1-17.9 40-40 40H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H40c-22.1 0-40-17.9-40-40V296c0-22.1 17.9-40 40-40H192L80 32V168c0 22.1-17.9 40-40 40s-40-17.9-40-40V152c0-4.4 3.6-8 8-8s8 3.6 8 8v16c0 13.3 10.7 24 24 24s24-10.7 24-24V32c0-5.8 1.6-11.3 4.3-16C73.8 6.4 84.2 0 96 0h49.6c9.1 0 17.8 3.9 23.9 10.7L384 252zm1.3 148c7.6-45.4 47.1-80 94.7-80s87.1 34.6 94.7 80H600c13.3 0 24-10.7 24-24V272H40c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24H65.3c7.6-45.4 47.1-80 94.7-80s87.1 34.6 94.7 80H385.3zM620.7 256c-.8-1.3-1.7-2.6-2.7-3.8L520.3 141.5c-7.6-8.6-18.5-13.5-30-13.5H424c-13.3 0-24 10.7-24 24V256H620.7zM240 416A80 80 0 1 0 80 416a80 80 0 1 0 160 0zm240 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160z'
      
    ]
  };

  

  
  

  var faInputNumeric = {
    prefix: 'fat',
    iconName: 'input-numeric',
    icon: [
      640,
      512,
      [],
      'e1bd',
      
      'M576 80c26.5 0 48 21.5 48 48V384c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V128c0-26.5 21.5-48 48-48H576zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm40 112c0 4.4 3.6 8 8 8h24V328H112c-4.4 0-8 3.6-8 8s3.6 8 8 8h64c4.4 0 8-3.6 8-8s-3.6-8-8-8H152V176c0-4.4-3.6-8-8-8H112c-4.4 0-8 3.6-8 8zm154.5 22.3c12.3-14.7 34.2-16.4 48.7-3.8c14.1 12.4 15.6 33.8 3.3 48L234 330.8c-2.1 2.4-2.5 5.7-1.2 8.6s4.1 4.7 7.3 4.7h96c4.4 0 8-3.6 8-8s-3.6-8-8-8H257.5l65.1-75.1c18.1-20.8 15.9-52.4-4.9-70.5c-21.2-18.5-53.5-16-71.5 5.6l-12.4 14.9c-2.8 3.4-2.4 8.4 1 11.3s8.4 2.4 11.3-1l12.4-14.9z'
      
    ]
  };

  

  
  

  var faClock = {
    prefix: 'fat',
    iconName: 'clock',
    icon: [
      512,
      512,
      [128339,"clock-four"],
      'f017',
      
      'M496 256A240 240 0 1 1 16 256a240 240 0 1 1 480 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM248 104V256c0 2.7 1.3 5.2 3.6 6.7l96 64c3.7 2.5 8.6 1.5 11.1-2.2s1.5-8.6-2.2-11.1L264 251.7V104c0-4.4-3.6-8-8-8s-8 3.6-8 8z'
      
    ]
  };

  
    var faClockFour = faClock;
  

  
  

  var faDash = {
    prefix: 'fat',
    iconName: 'dash',
    icon: [
      512,
      512,
      ["minus-large"],
      'e404',
      
      'M0 256c0-4.4 3.6-8 8-8H504c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  
    var faMinusLarge = faDash;
  

  
  

  var faRaindrops = {
    prefix: 'fat',
    iconName: 'raindrops',
    icon: [
      448,
      512,
      [],
      'f75c',
      
      'M160 51.2l-42 80c-3.9 7.5-6 15.9-6 24.4V160c0 26.5 21.5 48 48 48s48-21.5 48-48v-4.5c0-8.5-2.1-16.9-6-24.4l-42-80zM148.3 39.1c2.3-4.4 6.8-7.1 11.7-7.1s9.4 2.7 11.7 7.1l44.4 84.6c5.2 9.8 7.8 20.7 7.8 31.8V160c0 35.3-28.7 64-64 64s-64-28.7-64-64v-4.5c0-11.1 2.7-22 7.8-31.8l44.4-84.6zM64 243.2l-42 80c-3.9 7.5-6 15.9-6 24.4V352c0 26.5 21.5 48 48 48s48-21.5 48-48v-4.5c0-8.5-2.1-16.9-6-24.4l-42-80zM52.3 231.1c2.3-4.4 6.8-7.1 11.7-7.1s9.4 2.7 11.7 7.1l44.4 84.6c5.2 9.8 7.8 20.7 7.8 31.8V352c0 35.3-28.7 64-64 64s-64-28.7-64-64v-4.5c0-11.1 2.7-22 7.8-31.8l44.4-84.6zm173.3 61.7c-11.5 17.9-17.5 38.7-17.5 59.9C208 414.1 258.4 464 320 464s112-49.9 112-111.2c0-21.2-6.1-42-17.5-59.9L320 145.2 225.5 292.8zm-13.5-8.6l95.6-149.5c2.7-4.2 7.3-6.7 12.3-6.7s9.6 2.5 12.3 6.7l95.6 149.5C441 304.7 448 328.5 448 352.8C448 423 390.3 480 320 480s-128-57-128-127.2c0-24.3 7-48.1 20.1-68.6z'
      
    ]
  };

  

  
  

  var faArrowDownArrowUp = {
    prefix: 'fat',
    iconName: 'arrow-down-arrow-up',
    icon: [
      576,
      512,
      ["sort-alt"],
      'f883',
      
      'M421.7 34.3l112 112c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L424 59.3V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V59.3l-98.3 98.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l112-112c3.1-3.1 8.2-3.1 11.3 0zm-144 331.3l-112 112c-3.1 3.1-8.2 3.1-11.3 0l-112-112c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L152 452.7V40c0-4.4 3.6-8 8-8s8 3.6 8 8V452.7l98.3-98.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3z'
      
    ]
  };

  
    var faSortAlt = faArrowDownArrowUp;
  

  
  

  var faLightSwitchOn = {
    prefix: 'fat',
    iconName: 'light-switch-on',
    icon: [
      384,
      512,
      [],
      'e019',
      
      'M64 16C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48H320c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM272 264H112V368c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V264zM112 248H272V144c0-17.7-14.3-32-32-32H144c-17.7 0-32 14.3-32 32V248zM96 144c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V368c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V144zM192 40a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 400a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM152 160v48h80V160H152zm-16 0c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H152c-8.8 0-16-7.2-16-16V160z'
      
    ]
  };

  

  
  

  var faSquareRootVariable = {
    prefix: 'fat',
    iconName: 'square-root-variable',
    icon: [
      576,
      512,
      ["square-root-alt"],
      'f698',
      
      'M386.6 48c-17.2 0-32.5 11-37.9 27.4L215.6 474.5c-1 3.1-3.8 5.2-7 5.4s-6.3-1.5-7.7-4.4L89.7 253.3C85.6 245.1 77.3 240 68.2 240H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H68.2c15.2 0 29 8.6 35.8 22.1l102.5 205 127-380.9c7.6-22.9 29-38.3 53.1-38.3H568c4.4 0 8 3.6 8 8s-3.6 8-8 8H386.6zm7.7 186.3c3.1-3.1 8.2-3.1 11.3 0L480 308.7l74.3-74.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L491.3 320l74.3 74.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L480 331.3l-74.3 74.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L468.7 320l-74.3-74.3c-3.1-3.1-3.1-8.2 0-11.3z'
      
    ]
  };

  
    var faSquareRootAlt = faSquareRootVariable;
  

  
  

  var faArrowUpFromDottedLine = {
    prefix: 'fat',
    iconName: 'arrow-up-from-dotted-line',
    icon: [
      448,
      512,
      [],
      'e09b',
      
      'M229.7 34.3c-3.1-3.1-8.2-3.1-11.3 0l-136 136c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L216 59.3V184 344c0 4.4 3.6 8 8 8s8-3.6 8-8V184 59.3L354.3 181.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-136-136zM48 448a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm96 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm96 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm112-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faU = {
    prefix: 'fat',
    iconName: 'u',
    icon: [
      384,
      512,
      [117],
      '55',
      
      'M8 32c4.4 0 8 3.6 8 8V288c0 97.2 78.8 176 176 176s176-78.8 176-176V40c0-4.4 3.6-8 8-8s8 3.6 8 8V288c0 106-86 192-192 192S0 394 0 288V40c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faArrowTurnUp = {
    prefix: 'fat',
    iconName: 'arrow-turn-up',
    icon: [
      384,
      512,
      ["level-up"],
      'f148',
      
      'M8 496c-4.4 0-8 3.6-8 8s3.6 8 8 8l120 0c39.8 0 72-32.2 72-72l0-412.7L338.3 165.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-152-152c-3.1-3.1-8.2-3.1-11.3 0l-152 152c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L184 27.3 184 440c0 30.9-25.1 56-56 56L8 496z'
      
    ]
  };

  
    var faLevelUp = faArrowTurnUp;
  

  
  

  var faMobileSignalOut = {
    prefix: 'fat',
    iconName: 'mobile-signal-out',
    icon: [
      512,
      512,
      [],
      'e1f0',
      
      'M96 16H224V0H96C60.7 0 32 28.7 32 64V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V288H336V448c0 26.5-21.5 48-48 48H96c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48zm48 416c-4.4 0-8 3.6-8 8s3.6 8 8 8h96c4.4 0 8-3.6 8-8s-3.6-8-8-8H144zM264 0c-4.4 0-8 3.6-8 8s3.6 8 8 8c128.1 0 232 103.9 232 232c0 4.4 3.6 8 8 8s8-3.6 8-8C512 111 401 0 264 0zm8 224a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 104c0 4.4 3.6 8 8 8c75.1 0 136 60.9 136 136c0 4.4 3.6 8 8 8s8-3.6 8-8c0-83.9-68.1-152-152-152c-4.4 0-8 3.6-8 8z'
      
    ]
  };

  

  
  

  var faGripVertical = {
    prefix: 'fat',
    iconName: 'grip-vertical',
    icon: [
      320,
      512,
      [],
      'f58e',
      
      'M16 440l0-48c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zm24 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40zm168-40l0-48c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zm24 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40zM16 232c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48zM0 280c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48zm208 0l0-48c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zm24 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40zM16 72c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48zM0 120c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40L40 32C17.9 32 0 49.9 0 72l0 48zm208 0l0-48c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zm24 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40z'
      
    ]
  };

  

  
  

  var faSquareD = {
    prefix: 'fat',
    iconName: 'square-d',
    icon: [
      448,
      512,
      [],
      'e268',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 54.9V361.1c0 3.8 3.1 6.9 6.9 6.9H224c61.9 0 112-50.1 112-112s-50.1-112-112-112H150.9c-3.8 0-6.9 3.1-6.9 6.9zm6.9-22.9H224c70.7 0 128 57.3 128 128s-57.3 128-128 128H150.9c-12.6 0-22.9-10.2-22.9-22.9V150.9c0-12.6 10.2-22.9 22.9-22.9z'
      
    ]
  };

  

  
  

  var faAxe = {
    prefix: 'fat',
    iconName: 'axe',
    icon: [
      640,
      512,
      [129683],
      'f6b2',
      
      'M491.3 44.7l-24-24c-6.2-6.2-16.4-6.2-22.6 0L415.3 50.1l46.6 46.6 29.4-29.4c6.2-6.2 6.2-16.4 0-22.6l11.3-11.3c12.5 12.5 12.5 32.8 0 45.3L473.3 108l52 52H608c17.7 0 32 14.3 32 32c0 123.7-100.3 224-224 224c-17.7 0-32-14.3-32-32V301.3L233.4 150.6c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0L404 38.7 433.4 9.4c12.5-12.5 32.8-12.5 45.3 0l24 24L491.3 44.7zM240.1 202.6l11.3 11.3L20.7 444.7c-6.2 6.2-6.2 16.4 0 22.6l24 24L33.4 502.6l-24-24c-12.5-12.5-12.5-32.8 0-45.3L240.1 202.6zM33.4 502.6l11.3-11.3c6.2 6.2 16.4 6.2 22.6 0L298.1 260.6l11.3 11.3L78.6 502.6c-12.5 12.5-32.8 12.5-45.3 0zM525.3 176c-4.2 0-8.3-1.7-11.3-4.7L363.3 20.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6L395.3 289.9c3 3 4.7 7.1 4.7 11.3V384c0 8.8 7.2 16 16 16c114.9 0 208-93.1 208-208c0-8.8-7.2-16-16-16H525.3zM584 224.5c-4.8 72.7-62.7 130.6-135.4 135.4c-4.4 .3-8.2-3-8.5-7.4s3-8.2 7.4-8.5c64.7-4.3 116.2-55.8 120.6-120.6c.3-4.4 4.1-7.7 8.5-7.5s7.7 4.1 7.4 8.5z'
      
    ]
  };

  

  
  

  var faChessClock = {
    prefix: 'fat',
    iconName: 'chess-clock',
    icon: [
      640,
      512,
      [],
      'f43d',
      
      'M248 32c4.4 0 8 3.6 8 8s-3.6 8-8 8H184v80H576c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64H168V48H104c-4.4 0-8-3.6-8-8s3.6-8 8-8h72 72zM176 144H64c-26.5 0-48 21.5-48 48V416c0 26.5 21.5 48 48 48H576c26.5 0 48-21.5 48-48V192c0-26.5-21.5-48-48-48H176zM544 88c0 4.4-3.6 8-8 8H392c-4.4 0-8-3.6-8-8s3.6-8 8-8H536c4.4 0 8 3.6 8 8zM176 400a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0-208a112 112 0 1 1 0 224 112 112 0 1 1 0-224zM531.9 371.9A96 96 0 1 0 396.1 236.1 96 96 0 1 0 531.9 371.9zM384.8 224.8A112 112 0 1 1 543.2 383.2 112 112 0 1 1 384.8 224.8zM176 240c4.4 0 8 3.6 8 8v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V248c0-4.4 3.6-8 8-8zm333.3 30.1l-39.6 39.6c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l39.6-39.6c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3z'
      
    ]
  };

  

  
  

  var faPeapod = {
    prefix: 'fat',
    iconName: 'peapod',
    icon: [
      512,
      512,
      [],
      'e31c',
      
      'M416 16C195.1 16 16 195.1 16 416v48c0 17.7 14.3 32 32 32H96c220.9 0 400-179.1 400-400V48c0-17.7-14.3-32-32-32H416zm0-16h48c26.5 0 48 21.5 48 48V96c0 229.8-186.2 416-416 416H48c-26.5 0-48-21.5-48-48V416C0 186.2 186.2 0 416 0zM304 144a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm64 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-112 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm48 64a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM144 304a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm48 64a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  

  
  

  var faShareAll = {
    prefix: 'fat',
    iconName: 'share-all',
    icon: [
      576,
      512,
      [],
      'f367',
      
      'M272 128c0 8.8-7.2 16-16 16H176C87.6 144 16 215.6 16 304c0 104.2 74.6 150.7 91.8 160c.1 0 .2 0 .6 0c2 0 3.7-1.6 3.7-3.7c0-1.4-1-4.4-4.7-7.8C95.2 441.1 80 419.5 80 384c0-61.9 50.1-112 112-112h64c8.8 0 16 7.2 16 16v64c0 6.3 3.7 12 9.5 14.6s12.5 1.5 17.2-2.7l160-144c3.4-3 5.3-7.4 5.3-11.9s-1.9-8.9-5.3-11.9l-160-144c-4.7-4.2-11.4-5.3-17.2-2.7S272 57.7 272 64v64zM256 352V304 288H240 192c-53 0-96 43-96 96c0 30.4 12.8 47.9 22.2 56.7c5.5 5.1 9.8 12 9.8 19.5c0 10.9-8.8 19.7-19.7 19.7c-2.8 0-5.6-.6-8.1-1.9C81.5 467.9 0 417.3 0 304c0-97.2 78.8-176 176-176h64 16V112 64c0-12.6 7.4-24.1 19-29.2s25-3 34.4 5.4l160 144c6.7 6.1 10.6 14.7 10.6 23.8s-3.8 17.7-10.6 23.8l-160 144c-9.4 8.5-22.9 10.6-34.4 5.4s-19-16.6-19-29.2zM378.6 53.9c-3.3-3-3.5-8-.5-11.3s8-3.5 11.3-.5L545.8 184.3c14 12.7 14 34.7 0 47.4L389.4 373.9c-3.3 3-8.3 2.7-11.3-.5s-2.7-8.3 .5-11.3L535.1 219.8c7-6.3 7-17.3 0-23.7L378.6 53.9z'
      
    ]
  };

  

  
  

  var faDisplayMedical = {
    prefix: 'fat',
    iconName: 'display-medical',
    icon: [
      576,
      512,
      ["desktop-medical"],
      'e166',
      
      'M64 16C37.5 16 16 37.5 16 64V352c0 26.5 21.5 48 48 48H231.8h.3H343.9h.3H512c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H64zM222.6 416H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H353.4l13.3 80H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H360 216 136c-4.4 0-8-3.6-8-8s3.6-8 8-8h73.2l13.3-80zm16.2 0l-13.3 80H350.6l-13.3-80H238.8zM496 80H80l0 256H496V80zM80 64H496c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm189.3 73.3v44c0 2.1-.8 4.2-2.3 5.7s-3.5 2.3-5.7 2.3h-44c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h44c4.4 0 8 3.6 8 8v44c0 4.4 3.6 8 8 8h21.3c4.4 0 8-3.6 8-8v-44c0-4.4 3.6-8 8-8h44c4.4 0 8-3.6 8-8V197.3c0-4.4-3.6-8-8-8h-44c-4.4 0-8-3.6-8-8v-44c0-4.4-3.6-8-8-8H277.3c-4.4 0-8 3.6-8 8zm8-24h21.3c13.3 0 24 10.7 24 24v36h36c13.3 0 24 10.7 24 24v21.3c0 13.3-10.7 24-24 24h-36v36c0 13.3-10.7 24-24 24H277.3c-13.3 0-24-10.7-24-24v-36h-36c-13.3 0-24-10.7-24-24V197.3c0-13.3 10.7-24 24-24h36v-36c0-13.3 10.7-24 24-24z'
      
    ]
  };

  
    var faDesktopMedical = faDisplayMedical;
  

  
  

  var faFolderMusic = {
    prefix: 'fat',
    iconName: 'folder-music',
    icon: [
      512,
      512,
      [],
      'e18d',
      
      'M496 416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H197.5c12.7 0 24.9 5.1 33.9 14.1l35.9 35.9c9 9 21.2 14.1 33.9 14.1H448c26.5 0 48 21.5 48 48V416zM64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H301.3c-8.5 0-16.6-3.4-22.6-9.4L242.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64zM348.6 185.4c-2.2-1.5-4.9-1.8-7.4-.9l-128 48c-3.1 1.2-5.2 4.2-5.2 7.5V346.2c-8.5-6.3-19.7-10.2-32-10.2c-26.5 0-48 17.9-48 40s21.5 40 48 40c26.5 0 48-17.9 48-40l0 0V245.5l112-42V314.2c-8.5-6.3-19.7-10.2-32-10.2c-26.5 0-48 17.9-48 40s21.5 40 48 40c26.5 0 48-17.9 48-40l0 0V192c0-2.6-1.3-5.1-3.4-6.6zM304 320c20.5 0 32 13.4 32 24s-11.5 24-32 24s-32-13.4-32-24s11.5-24 32-24zM176 352c20.5 0 32 13.4 32 24s-11.5 24-32 24s-32-13.4-32-24s11.5-24 32-24z'
      
    ]
  };

  

  
  

  var faHexagonVerticalNftSlanted = {
    prefix: 'fat',
    iconName: 'hexagon-vertical-nft-slanted',
    icon: [
      448,
      512,
      [],
      'e506',
      
      'M418.8 119.2l0 0c17.3 10 28 28.5 28 48.5V360.3c0 20-10.7 38.5-28 48.5L252 505.1c-10.6 6.1-22.7 8.5-34.4 7.1c-7.5-.9-14.8-3.2-21.6-7.1L29.2 408.8c-17.3-10-28-28.5-28-48.5l0-192.6c0-20 10.7-38.5 28-48.5L196 22.9c5.9-3.4 12.3-5.7 18.8-6.7c7.8-1.3 15.9-.9 23.6 1.1c4.7 1.3 9.3 3.1 13.6 5.6l166.8 96.3zM218.8 31.8c-5.1 .7-10.2 2.3-14.8 5L37.2 133.1c-12.4 7.1-20 20.4-20 34.6l0 192.6c0 14.3 7.6 27.5 20 34.6L204 491.2c3.2 1.8 6.5 3.2 9.9 4.1c3.3 .9 6.7 1.3 10.1 1.3c6.9 0 13.8-1.8 20-5.4l166.8-96.3c12.4-7.1 20-20.4 20-34.6V167.7c0-14.3-7.6-27.5-20-34.6L244 36.8c-1.5-.9-3.1-1.7-4.8-2.3l-20.4-2.7zm-75 104.8c4.4 0 8 3.6 8 8v224c0 3.9-2.8 7.3-6.7 7.9s-7.6-1.6-8.9-5.4L87.8 225.9V336.6c0 4.4-3.6 8-8 8s-8-3.6-8-8v-160c0-3.9 2.8-7.3 6.7-7.9s7.6 1.6 8.9 5.4l48.4 145.2V144.6c0-4.4 3.6-8 8-8zM208.3 88c1.4 .1 2.7 .5 3.8 1.2L268 121.1c2.5 1.4 4 4.1 4 6.9c0 6.1-6.6 10-12 6.9l-44.2-25.2V248.6h40c4.4 0 8 3.6 8 8s-3.6 8-8 8h-40v136c0 4.4-3.6 8-8 8s-8-3.6-8-8v-144V96.2c0-1.4 .3-2.9 1-4.2c.7-1.3 1.7-2.3 2.9-3s2.6-1.1 4-1.1c.1 0 .3 0 .4 0zm135.6 94.8V352.6c0 4.4-3.6 8-8 8s-8-3.6-8-8V173.7L292 153.3c-2.5-1.4-4-4.1-4-6.9c0-6.1 6.6-10 12-6.9l80 45.7c3.8 2.2 5.2 7.1 3 10.9s-7.1 5.2-10.9 3l-28.2-16.1z'
      
    ]
  };

  

  
  

  var faTabletScreen = {
    prefix: 'fat',
    iconName: 'tablet-screen',
    icon: [
      448,
      512,
      ["tablet-android-alt"],
      'f3fc',
      
      'M384 16c26.5 0 48 21.5 48 48V384H16V64c0-26.5 21.5-48 48-48H384zm48 384v48c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V400H432zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM168 448c0 4.4 3.6 8 8 8h96c4.4 0 8-3.6 8-8s-3.6-8-8-8H176c-4.4 0-8 3.6-8 8z'
      
    ]
  };

  
    var faTabletAndroidAlt = faTabletScreen;
  

  
  

  var faToiletPaperBlank = {
    prefix: 'fat',
    iconName: 'toilet-paper-blank',
    icon: [
      640,
      512,
      ["toilet-paper-alt"],
      'f71f',
      
      'M20.5 463.6c-1.4 2.3-2.5 4.8-3.2 7.3c-2.4 8.2-1.5 17.1 2.9 24.8C25.8 505.8 36.5 512 48 512H301.9c22.3 0 45.4-12.1 55.4-36.1c12.2-29.3 31.8-90.6 39.5-193.7c.1-.7 .1-1.4 .2-2.1c1.9-26.6 3.1-55.9 3.1-88.2c0-97.2 43-176 96-176s96 78.8 96 176s-43 176-96 176c-27.5 0-52.3-21.2-69.8-55.1c-.9 9-1.9 17.8-3 26.1c18.2 26.4 43 45 72.8 45c35.1 0 63.4-25.9 81.9-59.9C596.8 289.5 608 242.8 608 192s-11.2-97.5-30.1-132.1C559.4 25.9 531.1 0 496 0H480 160C107 0 64 86 64 192c0 82.7-.4 187.2-39.7 264.5c-1.2 2.4-2.5 4.7-3.7 7.1l0 .1zM450.4 16c-14.4 10.8-26.7 26.2-36.3 43.9C395.2 94.5 384 141.2 384 192c0 156.9-27 243-41.5 277.8c-7.1 17.1-23.8 26.2-40.6 26.2H48c-5.8 0-11.1-3.1-13.9-8.1c-2.9-5-2.8-11.1 .2-16.1c.1-.2 .2-.3 .3-.5c22.9-41.5 34.2-90.5 39.8-138.9C79.9 283.8 80 234.5 80 192c0-51.1 10.4-96.5 26.4-128.6C123 30.3 142.8 16 160 16H450.4zm66.2 239c4.8-4.8 8.4-10.8 11.1-17.1c5.4-12.6 8.3-28.8 8.3-45.9s-2.9-33.3-8.3-45.9c-2.7-6.3-6.3-12.3-11.1-17.1c-4.9-4.8-11.9-9-20.6-9s-15.7 4.2-20.6 9c-4.8 4.8-8.4 10.8-11.1 17.1c-5.4 12.6-8.3 28.8-8.3 45.9s2.9 33.3 8.3 45.9c2.7 6.3 6.3 12.3 11.1 17.1c4.9 4.8 11.9 9 20.6 9s15.7-4.2 20.6-9zM496 248c-13.3 0-24-25.1-24-56s10.7-56 24-56s24 25.1 24 56s-10.7 56-24 56z'
      
    ]
  };

  
    var faToiletPaperAlt = faToiletPaperBlank;
  

  
  

  var faFolderXmark = {
    prefix: 'fat',
    iconName: 'folder-xmark',
    icon: [
      512,
      512,
      ["folder-times"],
      'f65f',
      
      'M448 464H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H197.5c12.7 0 24.9 5.1 33.9 14.1l35.9 35.9c9 9 21.2 14.1 33.9 14.1H448c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48zM64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H301.3c-8.5 0-16.6-3.4-22.6-9.4L242.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64zM178.3 210.3c-3.1 3.1-3.1 8.2 0 11.3L244.7 288l-66.3 66.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L256 299.3l66.3 66.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L267.3 288l66.3-66.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L256 276.7l-66.3-66.3c-3.1-3.1-8.2-3.1-11.3 0z'
      
    ]
  };

  
    var faFolderTimes = faFolderXmark;
  

  
  

  var faFilmCanister = {
    prefix: 'fat',
    iconName: 'film-canister',
    icon: [
      576,
      512,
      ["film-cannister"],
      'f8b7',
      
      'M104 40v8H248V40c0-13.3-10.7-24-24-24H128c-13.3 0-24 10.7-24 24zM88 48V40c0-22.1 17.9-40 40-40h96c22.1 0 40 17.9 40 40v8h48 32c4.4 0 8 3.6 8 8s-3.6 8-8 8H320V496h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H312 40 8c-4.4 0-8-3.6-8-8s3.6-8 8-8H32V64H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H40 88zm0 16H48V496H304V64H264 248 104 88zM408 176c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H392c-13.3 0-24-10.7-24-24V200c0-13.3 10.7-24 24-24h16zm-24 24v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V200c0-4.4-3.6-8-8-8H392c-4.4 0-8 3.6-8 8zm8 136h16c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H392c-13.3 0-24-10.7-24-24V360c0-13.3 10.7-24 24-24zm0 16c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8H392zM504 176c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H488c-13.3 0-24-10.7-24-24V200c0-13.3 10.7-24 24-24h16zm-24 24v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V200c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8zm56-56H352V128H536c22.1 0 40 17.9 40 40V304c0 22.1-17.9 40-40 40c-13.3 0-24 10.7-24 24v40c0 22.1-17.9 40-40 40H352V432H472c13.3 0 24-10.7 24-24V368c0-22.1 17.9-40 40-40c13.3 0 24-10.7 24-24V168c0-13.3-10.7-24-24-24z'
      
    ]
  };

  
    var faFilmCannister = faFilmCanister;
  

  
  

  var faSplit = {
    prefix: 'fat',
    iconName: 'split',
    icon: [
      512,
      512,
      [],
      'e254',
      
      'M410.3 45.7c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l88 88c3.1 3.1 3.1 8.2 0 11.3l-88 88c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L484.7 136H339.9c-10.6 0-20.8 4.2-28.3 11.7L207 252.3c-1.3 1.3-2.8 2.6-4.3 3.7c1.5 1.1 2.9 2.4 4.3 3.7L311.6 364.3c7.5 7.5 17.7 11.7 28.3 11.7H484.7l-74.3-74.3c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l88 88c3.1 3.1 3.1 8.2 0 11.3l-88 88c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L484.7 392H339.9c-14.9 0-29.1-5.9-39.6-16.4L195.7 271c-4.5-4.5-10.6-7-17-7H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H178.7c6.4 0 12.5-2.5 17-7L300.3 136.4C310.8 125.9 325 120 339.9 120H484.7L410.3 45.7z'
      
    ]
  };

  

  
  

  var faWaveformLines = {
    prefix: 'fat',
    iconName: 'waveform-lines',
    icon: [
      640,
      512,
      ["waveform-path"],
      'f8f2',
      
      'M320 0c4.4 0 8 3.6 8 8V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V8c0-4.4 3.6-8 8-8zM512 64c4.4 0 8 3.6 8 8V440c0 4.4-3.6 8-8 8s-8-3.6-8-8V72c0-4.4 3.6-8 8-8zM224 96c4.4 0 8 3.6 8 8V408c0 4.4-3.6 8-8 8s-8-3.6-8-8V104c0-4.4 3.6-8 8-8zm192 32c4.4 0 8 3.6 8 8V376c0 4.4-3.6 8-8 8s-8-3.6-8-8V136c0-4.4 3.6-8 8-8zM128 192c4.4 0 8 3.6 8 8V312c0 4.4-3.6 8-8 8s-8-3.6-8-8V200c0-4.4 3.6-8 8-8zM32 224c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8s-8-3.6-8-8V232c0-4.4 3.6-8 8-8zm576 0c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8s-8-3.6-8-8V232c0-4.4 3.6-8 8-8z'
      
    ]
  };

  
    var faWaveformPath = faWaveformLines;
  

  
  

  var faWaterArrowUp = {
    prefix: 'fat',
    iconName: 'water-arrow-up',
    icon: [
      576,
      512,
      ["water-rise"],
      'f775',
      
      'M296 248V27.3l74.3 74.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-88-88c-3.1-3.1-8.2-3.1-11.3 0l-88 88c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L280 27.3V248c0 4.4 3.6 8 8 8s8-3.6 8-8zm26.2 90.1c-10.1-9.2-19.6-19.5-27.6-30.7c-3-4.3-10.2-4.3-13.2 0c-8 11.2-17.5 21.4-27.6 30.7C236.6 353.8 214.5 368 192 368s-44.6-14.2-61.8-29.9c-10.1-9.2-19.7-19.5-27.6-30.7c-1.5-2.1-3.9-3.4-6.6-3.4s-5.1 1.3-6.6 3.4c-7.3 10.3-15.9 19.6-25 28.3C48.7 350.5 28.3 364.9 7 367.6c-4.4 .6-7.5 4.6-6.9 8.9s4.6 7.5 8.9 6.9c26.5-3.3 50-20.7 66.4-36.1c8.8-8.3 15.9-16.4 20.6-22.2c5.2 6.4 13.2 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8l0 0 0 0c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c4.7 5.8 11.8 13.9 20.6 22.2c16.4 15.4 39.9 32.8 66.4 36.1c4.4 .6 8.4-2.6 8.9-6.9s-2.6-8.4-6.9-8.9c-21.3-2.7-41.7-17.1-57.4-31.9c-9.1-8.6-17.7-18-25-28.3c-1.5-2.1-3.9-3.4-6.6-3.4s-5.1 1.3-6.6 3.4c-7.9 11.2-17.5 21.5-27.6 30.7C428.6 353.8 406.5 368 384 368s-44.6-14.2-61.8-29.9zm-27.6 97.3c-3-4.3-10.2-4.3-13.2 0c-8 11.2-17.5 21.4-27.6 30.7C236.6 481.8 214.5 496 192 496s-44.6-14.2-61.8-29.9c-10.1-9.2-19.7-19.5-27.6-30.7c-1.5-2.1-3.9-3.4-6.6-3.4s-5.1 1.3-6.6 3.4c-7.3 10.3-15.9 19.6-25 28.3C48.7 478.5 28.3 492.9 7 495.6c-4.4 .6-7.5 4.6-6.9 8.9s4.6 7.5 8.9 6.9c26.5-3.3 50-20.7 66.4-36.1c8.8-8.3 15.9-16.4 20.6-22.2c5.2 6.4 13.2 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8l0 0 0 0c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c4.7 5.8 11.8 13.9 20.6 22.2c16.4 15.4 39.9 32.8 66.4 36.1c4.4 .6 8.4-2.6 8.9-6.9s-2.6-8.4-6.9-8.9c-21.3-2.7-41.7-17.1-57.4-31.9c-9.1-8.6-17.7-18-25-28.3c-1.5-2.1-3.9-3.4-6.6-3.4s-5.1 1.3-6.6 3.4c-7.9 11.2-17.5 21.5-27.6 30.7C428.6 481.8 406.5 496 384 496s-44.6-14.2-61.8-29.9c-10.1-9.2-19.6-19.5-27.6-30.7z'
      
    ]
  };

  
    var faWaterRise = faWaterArrowUp;
  

  
  

  var faPlaceOfWorship = {
    prefix: 'fat',
    iconName: 'place-of-worship',
    icon: [
      640,
      512,
      [],
      'f67f',
      
      'M314.3 2.3c3.1-3.1 8.2-3.1 11.3 0L409 85.7c4.5 4.5 7 10.6 7 17V206.3l44 25.5c12.4 7.2 20 20.3 20 34.6V496H584c22.1 0 40-17.9 40-40V385.7c0-13.4-6.7-25.9-17.8-33.3l-98.6-65.8c-3.7-2.5-4.7-7.4-2.2-11.1s7.4-4.7 11.1-2.2l98.6 65.8C630.6 349.5 640 367 640 385.7V456c0 30.9-25.1 56-56 56H472.3c-.1 0-.2 0-.3 0H384 368 272 256 208.2c-.1 0-.1 0-.2 0H56c-30.9 0-56-25.1-56-56V385.7c0-18.7 9.4-36.2 24.9-46.6l98.6-65.8c3.7-2.5 8.6-1.5 11.1 2.2s1.5 8.6-2.2 11.1L33.8 352.4C22.7 359.8 16 372.3 16 385.7V456c0 22.1 17.9 40 40 40H160V266.4c0-14.3 7.6-27.5 20-34.6l44-25.5V102.6c0-6.4 2.5-12.5 7-17L314.3 2.3zM464 496V266.4c0-8.6-4.6-16.5-12-20.8l-48-27.8c-2.5-1.4-4-4.1-4-6.9V102.6c0-2.1-.8-4.2-2.3-5.7L320 19.3 242.3 97c-1.5 1.5-2.3 3.5-2.3 5.7V210.9c0 2.9-1.5 5.5-4 6.9l-48 27.8c-7.4 4.3-12 12.2-12 20.8V496h80V384c0-35.3 28.7-64 64-64s64 28.7 64 64V496h47.7c.1 0 .2 0 .3 0h32zM368 384c0-26.5-21.5-48-48-48s-48 21.5-48 48V496h96V384z'
      
    ]
  };

  

  
  

  var faPersonSkiJumping = {
    prefix: 'fat',
    iconName: 'person-ski-jumping',
    icon: [
      512,
      512,
      ["ski-jump"],
      'f7c7',
      
      'M244.3 170.4l-56.8 66.3c-6.3 7.4-11.2 15.8-14.5 24.9l-52 144.2c-3 8.3 1.3 17.5 9.6 20.5s17.5-1.3 20.5-9.6l52-144.2c2-5.5 4.9-10.5 8.7-14.9l6.1-7.2L219 249l1.4-1 103.4-78.5c24.4-18.5 11.3-57.5-19.4-57.5H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h72.1 34.8l-22.6 26.4zM432 48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM175.3 226.3L218.4 176l13.7-16H211.1 160c-17.7 0-32-14.3-32-32s14.3-32 32-32H304.5c46 0 65.7 58.4 29 86.2L230.1 260.8l-6.1 7.2c-2.5 2.9-4.5 6.3-5.8 10L168.8 414.7 456.2 271c24.4-12.2 39.8-37.1 39.8-64.4V184c0-4.4 3.6-8 8-8s8 3.6 8 8v22.6c0 33.3-18.8 63.8-48.6 78.7L11.6 511.2c-4 2-8.8 .4-10.7-3.6s-.4-8.8 3.6-10.7L120.1 439c-13.3-7.6-19.6-23.8-14.2-38.7l52-144.2c3.9-10.9 9.8-21.1 17.4-29.9zM400 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  
    var faSkiJump = faPersonSkiJumping;
  

  
  

  var faPlugCirclePlus = {
    prefix: 'fat',
    iconName: 'plug-circle-plus',
    icon: [
      576,
      512,
      [],
      'e55f',
      
      'M432 240a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-224c-4.4 0-8 3.6-8 8v64H360c-4.4 0-8 3.6-8 8s3.6 8 8 8h64v64c0 4.4 3.6 8 8 8s8-3.6 8-8V376h64c4.4 0 8-3.6 8-8s-3.6-8-8-8H440V296c0-4.4-3.6-8-8-8zM104 0c4.4 0 8 3.6 8 8V112H96V8c0-4.4 3.6-8 8-8zM280 0c4.4 0 8 3.6 8 8V112H272V8c0-4.4 3.6-8 8-8zM0 152c0-4.4 3.6-8 8-8H40 56 328h16 32c4.4 0 8 3.6 8 8s-3.6 8-8 8H344v55.5c-5.5 3.2-10.9 6.7-16 10.5V160H56v80c0 75.1 60.9 136 136 136c23.2 0 45.1-5.8 64.2-16.1c-.1 2.7-.2 5.4-.2 8.1c0 3.3 .1 6.5 .3 9.8c-17.2 8.1-36.2 13-56.3 14V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V391.8C103.8 387.6 40 321.3 40 240V160H8c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faCircle7 = {
    prefix: 'fat',
    iconName: 'circle-7',
    icon: [
      512,
      512,
      [],
      'e0f4',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM168 128c-4.4 0-8 3.6-8 8s3.6 8 8 8H329.9L193.1 371.9c-2.3 3.8-1 8.7 2.7 11s8.7 1 11-2.7l144-240c1.5-2.5 1.5-5.5 .1-8.1s-4.1-4.1-7-4.1H168z'
      
    ]
  };

  

  
  

  var faScannerTouchscreen = {
    prefix: 'fat',
    iconName: 'scanner-touchscreen',
    icon: [
      512,
      512,
      [],
      'f48a',
      
      'M136 0c-4.4 0-8 3.6-8 8V56c0 4.4 3.6 8 8 8s8-3.6 8-8V8c0-4.4-3.6-8-8-8zM264 0c-4.4 0-8 3.6-8 8V56c0 4.4 3.6 8 8 8s8-3.6 8-8V8c0-4.4-3.6-8-8-8zM384 8V280c0 4.4 3.6 8 8 8s8-3.6 8-8V8c0-4.4-3.6-8-8-8s-8 3.6-8 8zm64 0V280c0 4.4 3.6 8 8 8s8-3.6 8-8V8c0-4.4-3.6-8-8-8s-8 3.6-8 8zM320 8V56c0 4.4 3.6 8 8 8s8-3.6 8-8V8c0-4.4-3.6-8-8-8s-8 3.6-8 8zM192 8V56c0 4.4 3.6 8 8 8s8-3.6 8-8V8c0-4.4-3.6-8-8-8s-8 3.6-8 8zM504 0c-4.4 0-8 3.6-8 8V280c0 4.4 3.6 8 8 8s8-3.6 8-8V8c0-4.4-3.6-8-8-8zM288 112c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V160c0-26.5 21.5-48 48-48H288zM64 96C28.7 96 0 124.7 0 160V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H64zm40 80H248c13.3 0 24 10.7 24 24V408c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V200c0-13.3 10.7-24 24-24zM64 200V408c0 22.1 17.9 40 40 40H248c22.1 0 40-17.9 40-40V200c0-22.1-17.9-40-40-40H104c-22.1 0-40 17.9-40 40z'
      
    ]
  };

  

  
  

  var faWaterArrowDown = {
    prefix: 'fat',
    iconName: 'water-arrow-down',
    icon: [
      576,
      512,
      ["water-lower"],
      'f774',
      
      'M288 0c4.4 0 8 3.6 8 8V228.7l74.3-74.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-88 88c-3.1 3.1-8.2 3.1-11.3 0l-88-88c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L280 228.7V8c0-4.4 3.6-8 8-8zm34.2 338.1C339.5 353.8 361.5 368 384 368s44.6-14.2 61.8-29.9c10.1-9.2 19.7-19.5 27.6-30.7c1.5-2.1 3.9-3.4 6.6-3.4s5.1 1.3 6.6 3.4c7.3 10.3 15.9 19.6 25 28.3c15.7 14.8 36.1 29.2 57.4 31.9c4.4 .6 7.5 4.6 6.9 8.9s-4.6 7.5-8.9 6.9c-26.5-3.3-50-20.7-66.4-36.1c-8.8-8.3-15.9-16.4-20.6-22.2c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8l0 0 0 0c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-4.7 5.8-11.8 13.9-20.6 22.2C59 362.7 35.5 380.1 9 383.4c-4.4 .6-8.4-2.6-8.9-6.9s2.6-8.4 6.9-8.9c21.3-2.7 41.7-17.1 57.4-31.9c9.1-8.6 17.7-18 25-28.3c1.5-2.1 3.9-3.4 6.6-3.4s5.1 1.3 6.6 3.4c7.9 11.2 17.5 21.5 27.6 30.7C147.4 353.8 169.5 368 192 368s44.6-14.2 61.8-29.9c10.1-9.2 19.6-19.5 27.6-30.7c3-4.3 10.2-4.3 13.2 0c8 11.2 17.5 21.4 27.6 30.7zm-27.6 97.3c8 11.2 17.5 21.4 27.6 30.7C339.5 481.8 361.5 496 384 496s44.6-14.2 61.8-29.9c10.1-9.2 19.7-19.5 27.6-30.7c1.5-2.1 3.9-3.4 6.6-3.4s5.1 1.3 6.6 3.4c7.3 10.3 15.9 19.6 25 28.3c15.7 14.8 36.1 29.2 57.4 31.9c4.4 .6 7.5 4.6 6.9 8.9s-4.6 7.5-8.9 6.9c-26.5-3.3-50-20.7-66.4-36.1c-8.8-8.3-15.9-16.4-20.6-22.2c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8l0 0 0 0c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-4.7 5.8-11.8 13.9-20.6 22.2C59 490.7 35.5 508.1 9 511.4c-4.4 .6-8.4-2.6-8.9-6.9s2.6-8.4 6.9-8.9c21.3-2.7 41.7-17.1 57.4-31.9c9.1-8.6 17.7-18 25-28.3c1.5-2.1 3.9-3.4 6.6-3.4s5.1 1.3 6.6 3.4c7.9 11.2 17.5 21.5 27.6 30.7C147.4 481.8 169.5 496 192 496s44.6-14.2 61.8-29.9c10.1-9.2 19.6-19.5 27.6-30.7c3-4.3 10.2-4.3 13.2 0z'
      
    ]
  };

  
    var faWaterLower = faWaterArrowDown;
  

  
  

  var faFaceSwear = {
    prefix: 'fat',
    iconName: 'face-swear',
    icon: [
      640,
      512,
      [],
      'e399',
      
      'M557.9 224C542.2 106.6 441.7 16 320 16S97.8 106.6 82.1 224H66C81.7 97.7 189.5 0 320 0S558.3 97.7 574 224H557.9zM224.4 176a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-216-50.5c1.4-4.2 5.9-6.5 10.1-5.1l96 32c4.2 1.4 6.5 5.9 5.1 10.1s-5.9 6.5-10.1 5.1l-96-32c-4.2-1.4-6.5-5.9-5.1-10.1zm271.2 0c1.4 4.2-.9 8.7-5.1 10.1l-96 32c-4.2 1.4-8.7-.9-10.1-5.1s.9-8.7 5.1-10.1l96-32c4.2-1.4 8.7 .9 10.1 5.1zM16 320V448c0 26.5 21.5 48 48 48H576c26.5 0 48-21.5 48-48V320c0-26.5-21.5-48-48-48H64c-26.5 0-48 21.5-48 48zM0 320c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V320zM408 432H384v24c0 4.4-3.6 8-8 8s-8-3.6-8-8V432H304v24c0 4.4-3.6 8-8 8s-8-3.6-8-8V432H264c-4.4 0-8-3.6-8-8s3.6-8 8-8h24V352H264c-4.4 0-8-3.6-8-8s3.6-8 8-8h24V312c0-4.4 3.6-8 8-8s8 3.6 8 8v24h64V312c0-4.4 3.6-8 8-8s8 3.6 8 8v24h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H384v64h24c4.4 0 8 3.6 8 8s-3.6 8-8 8zm-40-80H304v64h64V352zm196.4-46.7c3.7 2.5 4.7 7.4 2.2 11.1l-96 144c-2.5 3.7-7.4 4.7-11.1 2.2s-4.7-7.4-2.2-11.1l96-144c2.5-3.7 7.4-4.7 11.1-2.2zM472 320a8 8 0 1 0 0 16 8 8 0 1 0 0-16zm0-16a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 136a8 8 0 1 0 16 0 8 8 0 1 0 -16 0zm-16 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM208 304c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8s-8-3.6-8-8V312c0-4.4 3.6-8 8-8zm0 144a8 8 0 1 0 0-16 8 8 0 1 0 0 16zm0-32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM120 312v8.5c9 .8 17.5 2.5 23.9 4.1c4.3 1.1 6.9 5.4 5.8 9.7s-5.4 6.9-9.7 5.8c-10.5-2.6-25.5-5.1-38.1-3.8c-6.3 .7-11.4 2.2-15 4.6c-3.3 2.2-5.7 5.3-6.6 10.2c-.7 3.9-.2 6.4 .8 8.2c1 2 2.8 3.9 5.9 5.8c6.5 4.1 16 6.8 27.3 10l0 0 0 0 0 0c10.5 3 22.8 6.4 31.7 12.5c4.6 3.2 8.8 7.3 11.4 12.8c2.6 5.6 3.2 11.9 1.9 18.9c-2 10.8-7.7 18.5-15.8 23c-7.3 4.2-16.1 5.5-24.5 5.5v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-9.3c-12.8-2-25.2-5.7-33.5-8.3c-4.2-1.3-6.6-5.8-5.3-10s5.8-6.6 10-5.3c11.6 3.6 28.9 8.7 43.7 8.9c7.4 .1 13.4-1 17.6-3.4c3.8-2.2 6.8-5.6 7.9-12c.8-4.3 .3-7.2-.7-9.3c-1-2.2-2.9-4.3-5.9-6.3c-6.3-4.3-15.8-7.2-27-10.3l-1.5-.4c-10.1-2.9-21.6-6.1-30.1-11.5c-4.6-2.9-8.9-6.8-11.6-12.1c-2.7-5.4-3.5-11.6-2.2-18.3c1.7-9.3 6.7-16.1 13.5-20.6c6.5-4.4 14.5-6.4 22.2-7.2c1.2-.1 2.5-.2 3.7-.3V312c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faRadioTuner = {
    prefix: 'fat',
    iconName: 'radio-tuner',
    icon: [
      512,
      512,
      ["radio-alt"],
      'f8d8',
      
      'M506.1 15.7c4.3-1.2 6.8-5.6 5.6-9.8s-5.6-6.8-9.8-5.6L53 123.4c-26.4 7.2-46 28.7-51.4 54.7C.5 182.6 0 187.2 0 192v.8V240 448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H96.6L506.1 15.7zM16 192.8c0-3.8 .4-7.6 1.1-11.2C21.9 160.1 41.1 144 64 144H448c26.5 0 48 21.5 48 48v48H16V192.8zM16 256H496V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V256zM424 376a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zm-128 0a72 72 0 1 0 144 0 72 72 0 1 0 -144 0zM64 344c0 4.4 3.6 8 8 8H216c4.4 0 8-3.6 8-8s-3.6-8-8-8H72c-4.4 0-8 3.6-8 8zm16 64c0 4.4 3.6 8 8 8H200c4.4 0 8-3.6 8-8s-3.6-8-8-8H88c-4.4 0-8 3.6-8 8z'
      
    ]
  };

  
    var faRadioAlt = faRadioTuner;
  

  
  

  var faFaceSmilePlus = {
    prefix: 'fat',
    iconName: 'face-smile-plus',
    icon: [
      640,
      512,
      ["smile-plus"],
      'f5b9',
      
      'M552 8V88h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H552v80c0 4.4-3.6 8-8 8s-8-3.6-8-8V104H456c-4.4 0-8-3.6-8-8s3.6-8 8-8h80V8c0-4.4 3.6-8 8-8s8 3.6 8 8zM432 288A208 208 0 1 0 16 288a208 208 0 1 0 416 0zM0 288a224 224 0 1 1 448 0A224 224 0 1 1 0 288zm144.4-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm144 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM119.4 341c4.9 12.3 16.2 31.2 33.9 47c17.6 15.7 41.1 28 70.7 28s53.1-12.3 70.7-28c17.7-15.8 29-34.7 33.9-47c1.6-4.1 6.3-6.1 10.4-4.5s6.1 6.3 4.5 10.4c-5.8 14.4-18.4 35.4-38.1 53c-19.8 17.7-46.9 32-81.3 32s-61.6-14.4-81.3-32c-19.7-17.6-32.3-38.6-38.1-53c-1.6-4.1 .4-8.8 4.5-10.4s8.8 .4 10.4 4.5z'
      
    ]
  };

  
    var faSmilePlus = faFaceSmilePlus;
  

  
  

  var faMoped = {
    prefix: 'fat',
    iconName: 'moped',
    icon: [
      640,
      512,
      [],
      'e3b9',
      
      'M328 32c-4.4 0-8 3.6-8 8s3.6 8 8 8h56.1c10.6 0 20 7 23 17.2l54.5 183.9c-34.3 12.8-62.5 38.4-78.6 70.9H288c-17.7 0-32-14.3-32-32V224c0-17.7-14.3-32-32-32H128C57.3 192 0 249.3 0 320v32c0 17.7 14.3 32 32 32H64c0 53 43 96 96 96s96-43 96-96h80 36 4.2c4.2 0 7.7-3.3 8-7.5C388.1 309.3 443.8 256 512 256c35.4 0 67.5 14.4 90.7 37.6c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3C587.9 256.2 551.9 240 512 240c-12.1 0-23.9 1.5-35.1 4.3L445.9 139.9l49.9 24.9c4.1 2.1 8.7 3.1 13.3 3.1c10.4 0 18.9-8.4 18.9-18.9V74.9c0-10.4-8.4-18.9-18.9-18.9c-4.6 0-9.2 1.1-13.3 3.1L436.4 88.8l-4.9 2.4-9.1-30.6c-5-17-20.6-28.6-38.4-28.6H328zm40.9 336H336 32c-8.8 0-16-7.2-16-16V320c0-61.9 50.1-112 112-112h96c8.8 0 16 7.2 16 16v64c0 26.5 21.5 48 48 48h88.2c-3.6 10.2-6.1 20.9-7.3 32zm74.7-247.2c-1.1-.6-2.3-.8-3.5-.8l-4.4-14.8 .8 1.5 7.2-3.6L503 73.5c1.9-1 4-1.5 6.1-1.5c1.6 0 2.9 1.3 2.9 2.9v74.3c0 1.6-1.3 2.9-2.9 2.9c-2.1 0-4.2-.5-6.1-1.5l-59.4-29.7zM224 128c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h96zm-96-16c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H128zM80 384H240c0 44.2-35.8 80-80 80s-80-35.8-80-80zm432-80a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 176a96 96 0 1 0 0-192 96 96 0 1 0 0 192z'
      
    ]
  };

  

  
  

  var faTemperatureSnow = {
    prefix: 'fat',
    iconName: 'temperature-snow',
    icon: [
      576,
      512,
      ["temperature-frigid"],
      'f768',
      
      'M368 80c0-35.3 28.7-64 64-64s64 28.7 64 64V243.8c0 8.4 4.4 15.7 10.7 20.3C539 287.3 560 325.2 560 368c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-42.8 21-80.7 53.3-104c6.3-4.6 10.7-11.9 10.7-20.3V80zM432 0c-44.2 0-80 35.8-80 80V243.8c0 2.7-1.4 5.4-4 7.3c-36.3 26.1-60 68.8-60 117c0 79.5 64.5 144 144 144s144-64.5 144-144c0-48.2-23.7-90.8-60-117c-2.6-1.9-4-4.6-4-7.3V80c0-44.2-35.8-80-80-80zM384 368a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0c0-32.6-24.4-59.6-56-63.5V264c0-4.4-3.6-8-8-8s-8 3.6-8 8v40.5c-31.6 3.9-56 30.9-56 63.5c0 35.3 28.7 64 64 64s64-28.7 64-64zM271.9 159.4l15.5-57.8c1.1-4.3-1.4-8.7-5.7-9.8s-8.7 1.4-9.8 5.7l-19.6 73.3L184 210.1V131.3l53.7-53.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L184 108.7V40c0-4.4-3.6-8-8-8s-8 3.6-8 8v68.7L125.7 66.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L168 131.3v78.8L99.7 170.7 80.1 97.4c-1.1-4.3-5.5-6.8-9.8-5.7s-6.8 5.5-5.7 9.8l15.5 57.8L20.7 125.1c-3.8-2.2-8.7-.9-10.9 2.9s-.9 8.7 2.9 10.9l59.5 34.3L14.3 188.8c-4.3 1.1-6.8 5.5-5.7 9.8s5.5 6.8 9.8 5.7l73.3-19.6L160 224 91.7 263.4 18.4 243.8c-4.3-1.1-8.7 1.4-9.8 5.7s1.4 8.7 5.7 9.8l57.8 15.5L12.7 309.1c-3.8 2.2-5.1 7.1-2.9 10.9s7.1 5.1 10.9 2.9l59.5-34.3L64.6 346.4c-1.1 4.3 1.4 8.7 5.7 9.8s8.7-1.4 9.8-5.7l19.6-73.3L168 237.9v78.8l-53.7 53.7c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L168 339.3V408c0 4.4 3.6 8 8 8s8-3.6 8-8V339.3l42.3 42.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L184 316.7V237.9l68.3 39.4 10.9 40.8c2.6-8.8 5.9-17.3 9.7-25.5l-1.1-4 2.4 1.4c2.4-4.8 5-9.5 7.8-14l-2.1-1.2 3.5-.9c4.6-7.3 9.8-14.2 15.4-20.7l-38.4 10.3L192 224l68.3-39.4 59.7 16V184l-40.1-10.8L320 150.1V131.6l-48.1 27.8z'
      
    ]
  };

  
    var faTemperatureFrigid = faTemperatureSnow;
  

  
  

  var faTabletRugged = {
    prefix: 'fat',
    iconName: 'tablet-rugged',
    icon: [
      448,
      512,
      [],
      'f48f',
      
      'M48.6 49C51.9 30.3 68.3 16 88 16H360c19.7 0 36.1 14.3 39.4 33c.4 2.5 2 4.6 4.3 5.8l23.9 11.9c2.7 1.4 4.4 4.1 4.4 7.2v76.2c0 3-1.7 5.8-4.4 7.2l-23.2 11.6c-2.7 1.4-4.4 4.1-4.4 7.2v16c0 3 1.7 5.8 4.4 7.2l23.2 11.6c2.7 1.4 4.4 4.1 4.4 7.2v76.2c0 3-1.7 5.8-4.4 7.2l-23.2 11.6c-2.7 1.4-4.4 4.1-4.4 7.2v16c0 3 1.7 5.8 4.4 7.2l23.2 11.6c2.7 1.4 4.4 4.1 4.4 7.2v76.2c0 3-1.7 5.8-4.4 7.2l-23.9 11.9c-2.3 1.1-3.9 3.3-4.3 5.8c-3.3 18.8-19.7 33-39.4 33H88c-19.7 0-36.1-14.3-39.4-33c-.4-2.5-2-4.6-4.3-5.8L20.4 445.3c-2.7-1.4-4.4-4.1-4.4-7.2V361.9c0-3 1.7-5.8 4.4-7.2l23.2-11.6c2.7-1.4 4.4-4.1 4.4-7.2V320c0-3-1.7-5.8-4.4-7.2L20.4 301.3c-2.7-1.4-4.4-4.1-4.4-7.2V217.9c0-3 1.7-5.8 4.4-7.2l-3.6-7.2 3.6 7.2 23.2-11.6c2.7-1.4 4.4-4.1 4.4-7.2V176c0-3-1.7-5.8-4.4-7.2L20.4 157.3l-3.5 7 3.5-7c-2.7-1.4-4.4-4.1-4.4-7.2V73.9c0-3 1.7-5.8 4.4-7.2L44.3 54.8c2.3-1.1 3.9-3.3 4.3-5.8zM88 0C61.8 0 39.9 17.9 33.7 42.2L13.3 52.4C5.1 56.5 0 64.8 0 73.9v76.2c0 9.1 5.1 17.4 13.3 21.5L32 180.9v6.1l-18.7 9.4C5.1 200.5 0 208.8 0 217.9v76.2c0 9.1 5.1 17.4 13.3 21.5L32 324.9v6.1l-18.7 9.4 3.6 7.2-3.6-7.2C5.1 344.5 0 352.8 0 361.9v76.2c0 9.1 5.1 17.4 13.3 21.5l20.4 10.2C39.9 494.1 61.8 512 88 512H360c26.2 0 48.1-17.9 54.3-42.2l20.4-10.2c8.1-4.1 13.3-12.4 13.3-21.5V361.9c0-9.1-5.1-17.4-13.3-21.5L416 331.1v-6.1l18.7-9.4c8.1-4.1 13.3-12.4 13.3-21.5V217.9c0-9.1-5.1-17.4-13.3-21.5L416 187.1v-6.1l18.7-9.4c8.1-4.1 13.3-12.4 13.3-21.5V73.9c0-9.1-5.1-17.4-13.3-21.5L414.3 42.2C408.1 17.9 386.2 0 360 0H88zm40 80H320c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H128c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16zM96 96V416c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32z'
      
    ]
  };

  

  
  

  var faDistributeSpacingHorizontal = {
    prefix: 'fat',
    iconName: 'distribute-spacing-horizontal',
    icon: [
      512,
      512,
      [],
      'e365',
      
      'M40 512c4.4 0 8-3.6 8-8L48 8c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 496c0 4.4 3.6 8 8 8zM144 144c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32l0 224c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-224zM128 368c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48L176 96c-26.5 0-48 21.5-48 48l0 224zM464 504c0 4.4 3.6 8 8 8s8-3.6 8-8L480 8c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 496z'
      
    ]
  };

  

  
  

  var faEyeDropperFull = {
    prefix: 'fat',
    iconName: 'eye-dropper-full',
    icon: [
      512,
      512,
      [],
      'e172',
      
      'M211.8 159.1l11.3 11.3L341.6 288.9l11.3 11.3 25.4 25.4 0 0c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-14.1-14.1-11.3-11.3 11.3-11.3L482.8 170.4c39-39 39-102.2 0-141.1s-102.2-39-141.1 0L234.4 136.5l-11.3 11.3-11.3-11.3-14.1-14.1c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l25.4 25.4zm259.7 0L352.9 277.6 234.4 159.1 352.9 40.5c32.7-32.7 85.8-32.7 118.5 0l11-11-11 11c32.7 32.7 32.7 85.8 0 118.5zM197.7 194.3c-3.1-3.1-8.2-3.1-11.3 0L53.1 327.6C39.6 341.1 32 359.4 32 378.5v51.1L4.4 470.9C1.5 475.3 0 480.4 0 485.6C0 500.2 11.8 512 26.4 512c5.2 0 10.3-1.5 14.7-4.4L82.4 480h51.1c19.1 0 37.4-7.6 50.9-21.1L317.7 325.7c3.1-3.1 3.1-8.2 0-11.3l-120-120zM64.4 338.9L192 211.3 300.7 320 173.1 447.6c-10.5 10.5-24.7 16.4-39.6 16.4H80 77.6l-2 1.3L32.2 494.2c-1.7 1.1-3.7 1.8-5.8 1.8c-5.8 0-10.4-4.7-10.4-10.4c0-2.1 .6-4.1 1.8-5.8l28.9-43.4 1.3-2V432 378.5c0-14.9 5.9-29.1 16.4-39.6z'
      
    ]
  };

  

  
  

  var faVials = {
    prefix: 'fat',
    iconName: 'vials',
    icon: [
      512,
      512,
      [],
      'f493',
      
      'M16 32c-4.4 0-8 3.6-8 8s3.6 8 8 8H32V264 400c0 44.2 35.8 80 80 80s80-35.8 80-80V264 48h16c4.4 0 8-3.6 8-8s-3.6-8-8-8H184 40 16zM48 256V48H176V256H48zm0 16H176V400c0 35.3-28.7 64-64 64s-64-28.7-64-64V272zM304 32c-4.4 0-8 3.6-8 8s3.6 8 8 8h16V264 400c0 44.2 35.8 80 80 80s80-35.8 80-80V264 48h16c4.4 0 8-3.6 8-8s-3.6-8-8-8H472 328 304zm32 224V48H464V256H336zm0 16H464V400c0 35.3-28.7 64-64 64s-64-28.7-64-64V272z'
      
    ]
  };

  

  
  

  var faShieldPlus = {
    prefix: 'fat',
    iconName: 'shield-plus',
    icon: [
      512,
      512,
      [],
      'e24a',
      
      'M237.3 22.6c12-5.1 25.5-5.1 37.5 0l176.7 75c16.6 7.1 28.6 23.2 28.5 42.4c-.5 96.6-40.3 270.2-204.5 348.8c-12.3 5.9-26.7 5.9-39 0C72.3 410.1 32.5 236.5 32 139.9c-.1-19.1 11.9-35.3 28.5-42.4l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM248 352c0 4.4 3.6 8 8 8s8-3.6 8-8V264h88c4.4 0 8-3.6 8-8s-3.6-8-8-8H264V160c0-4.4-3.6-8-8-8s-8 3.6-8 8v88H160c-4.4 0-8 3.6-8 8s3.6 8 8 8h88v88z'
      
    ]
  };

  

  
  

  var faBookFont = {
    prefix: 'fat',
    iconName: 'book-font',
    icon: [
      448,
      512,
      [],
      'e0bf',
      
      'M0 56C0 25.1 25.1 0 56 0H408c22.1 0 40 17.9 40 40V376c0 19.4-13.7 35.5-32 39.2V496h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H56c-30.9 0-56-25.1-56-56V56zM56 416c-22.1 0-40 17.9-40 40s17.9 40 40 40H400V416H56zm-40 .8C26.2 406.4 40.3 400 56 400H408c13.3 0 24-10.7 24-24V40c0-13.3-10.7-24-24-24H56C33.9 16 16 33.9 16 56V416.8zM247.2 100.4l71.9 143.9 .1 .3 31.9 63.8c2 4 .4 8.8-3.6 10.7s-8.8 .4-10.7-3.6L307.1 256H172.9l-29.8 59.6c-2 4-6.8 5.6-10.7 3.6s-5.6-6.8-3.6-10.7l31.9-63.8 .1-.3 71.9-143.9c1.4-2.7 4.1-4.4 7.2-4.4s5.8 1.7 7.2 4.4zM299.1 240L240 121.9 180.9 240H299.1z'
      
    ]
  };

  

  
  

  var faCartShopping = {
    prefix: 'fat',
    iconName: 'cart-shopping',
    icon: [
      576,
      512,
      [128722,"shopping-cart"],
      'f07a',
      
      'M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8H45.7C57.1 16 67 24.1 69.2 35.4l59.4 303.4c5.1 26.3 28.2 45.2 55 45.2H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H183.5c-19.1 0-35.6-13.5-39.3-32.3L134.9 288h339c26 0 48.6-17.9 54.5-43.3L566.6 81.1C572.5 56 553.4 32 527.7 32H84.8C81 13.4 64.7 0 45.7 0H8zM88 48H527.7c15.5 0 26.9 14.4 23.4 29.5L512.9 241.1c-4.2 18.1-20.4 30.9-39 30.9H131.8L88 48zm56 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm240-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  
    var faShoppingCart = faCartShopping;
  

  
  

  var faCarGarage = {
    prefix: 'fat',
    iconName: 'car-garage',
    icon: [
      640,
      512,
      [],
      'f5e2',
      
      'M323.9 1c-2.4-1.4-5.4-1.4-7.9 0L4.1 177c-3.8 2.2-5.2 7-3 10.9s7.1 5.2 10.9 3L320 17.2 628.1 191c3.8 2.2 8.7 .8 10.9-3s.8-8.7-3-10.9L323.9 1zM252.2 192H387.8c17.9 0 33.6 11.8 38.5 29l19.5 68.2c-4.5-.8-9-1.2-13.7-1.2H208c-4.7 0-9.3 .4-13.7 1.2L213.7 221c4.9-17.2 20.6-29 38.5-29zM176.3 293.8l-.2 .8C147.8 307 128 335.2 128 368v64 16 32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V448H432v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V448 432 368c0-32.8-19.8-61-48.1-73.4l-.2-.8-22.1-77.2c-6.9-24-28.8-40.6-53.8-40.6H252.2c-25 0-47 16.6-53.8 40.6l-22.1 77.2zM448 432H432 208 192 144V368c0-35.3 28.7-64 64-64H432c35.3 0 64 28.7 64 64v64H448zm0 48V448h48v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16zM192 448v32c0 8.8-7.2 16-16 16H160c-8.8 0-16-7.2-16-16V448h48zm32-80a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm224 48a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z'
      
    ]
  };

  

  
  

  var faPersonMilitaryRifle = {
    prefix: 'fat',
    iconName: 'person-military-rifle',
    icon: [
      512,
      512,
      [],
      'e54b',
      
      'M336 18.1V64H184c-4.4 0-8-3.6-8-8V45.2c0-4 3-7.4 7-7.9L336 18.1zM181 21.4c-12 1.5-21 11.7-21 23.8V56c0 13.3 10.7 24 24 24H336c8.8 0 16-7.2 16-16V18.1c0-9.6-8.4-17.1-18-15.9L181 21.4zM176 112c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H318c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-5.5 .7-10.9 2-16H177.6c-1 5.2-1.6 10.5-1.6 16zM347.8 354.3c-7 1.9-11.8 8.2-11.8 15.4V480c0 .4 0 .8 0 1.2L186 248.7c14-5.7 29.2-8.7 44.8-8.7h50.4c42.4 0 81.7 22.4 103.3 59l76.1 128.8c6.7 11.4 3 26.1-8.5 32.9s-26.1 3-32.9-8.5l-53.6-90.6c-3.7-6.2-11-9.2-18-7.3zm-22 140.7c-1.8 .7-3.7 1.1-5.8 1.1H192c-8.8 0-16-7.2-16-16V369.7c0-7.2-4.8-13.5-11.8-15.4s-14.3 1.1-18 7.3L92.7 452.2c-6.7 11.4-21.5 15.2-32.9 8.5s-15.2-21.5-8.5-32.9L127.5 299c10.8-18.3 26.1-33.1 44-43.3L325.8 494.9zM368 396.8l37.6 63.6c11.2 19 35.8 25.3 54.8 14.1s25.3-35.8 14.1-54.8L398.3 290.8c-4.8-8.2-10.5-15.7-16.7-22.6l33.3-57.6c5.9-10.3 5.5-22.4 0-32L473 77.9c4.4-7.7 1.8-17.4-5.9-21.9l-6.9-4L439.4 40l-6.9-4c-3.8-2.2-8.7-.9-10.9 2.9s-.9 8.7 2.9 10.9l6.9 4-8 13.9-50.1 86.8c-11 0-21.8 5.7-27.7 16l-33 57.1c-10.2-2.4-20.7-3.7-31.4-3.7H230.8c-48.1 0-92.6 25.4-117.1 66.8L37.6 419.7c-11.2 19-4.9 43.5 14.1 54.8s43.5 4.9 54.8-14.1L144 396.8l16-27.1v31.5V480c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V401.2 369.7l16 27.1zM328.3 232.4l31.1-53.9c3-5.1 8.3-8 13.9-8c5.7 0 11-3.1 13.8-8L445.3 61.9l6.9 4 6.9 4L401 170.6c-2.9 4.9-2.9 11 0 16c2.8 4.8 3 10.9 0 16l-31.3 54.2c-12.2-10.5-26.3-18.7-41.4-24.3zM304 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faFlagSwallowtail = {
    prefix: 'fat',
    iconName: 'flag-swallowtail',
    icon: [
      448,
      512,
      ["flag-alt"],
      'f74c',
      
      'M16 8c0-4.4-3.6-8-8-8S0 3.6 0 8V32 48 336v16V504c0 4.4 3.6 8 8 8s8-3.6 8-8V352H436.1c6.6 0 11.9-5.3 11.9-11.9c0-2.6-.9-5.2-2.5-7.3L336 192 445.5 51.2c1.6-2.1 2.5-4.7 2.5-7.3c0-6.6-5.3-11.9-11.9-11.9H16V8zm0 40H427.7L323.4 182.2c-4.5 5.8-4.5 13.9 0 19.6L427.7 336H16V48z'
      
    ]
  };

  
    var faFlagAlt = faFlagSwallowtail;
  

  
  

  var faStarOfDavid = {
    prefix: 'fat',
    iconName: 'star-of-david',
    icon: [
      512,
      512,
      [10017],
      'f69a',
      
      'M256 0c14.9 0 28.8 7.7 36.6 20.5L348.7 112H458.6c20.7 0 37.4 16.8 37.4 37.4c0 6.9-1.9 13.7-5.5 19.6l-53.4 87 53.4 87c3.6 5.9 5.5 12.7 5.5 19.6c0 20.7-16.8 37.4-37.4 37.4H348.7l-56.2 91.5C284.8 504.3 270.9 512 256 512s-28.8-7.7-36.6-20.5L163.3 400H53.4C32.8 400 16 383.2 16 362.6c0-6.9 1.9-13.7 5.5-19.6l53.4-87L21.5 169c-3.6-5.9-5.5-12.7-5.5-19.6C16 128.8 32.8 112 53.4 112H163.3l56.2-91.5C227.2 7.7 241.1 0 256 0zM153.5 128H53.4C41.6 128 32 137.6 32 149.4c0 4 1.1 7.8 3.2 11.2l49.1 80.1L153.5 128zM93.7 256l78.5 128H339.8l78.5-128L339.8 128H172.2L93.7 256zm-9.4 15.3L35.2 351.4c-2.1 3.4-3.2 7.3-3.2 11.2c0 11.8 9.6 21.4 21.4 21.4h100L84.3 271.3zM182 400l51 83.2c4.9 8 13.6 12.8 22.9 12.8s18-4.9 22.9-12.8L330 400H182zm176.5-16h100c11.8 0 21.4-9.6 21.4-21.4c0-4-1.1-7.8-3.2-11.2l-49.1-80.1L358.5 384zm69.2-143.3l49.1-80.1c2.1-3.4 3.2-7.3 3.2-11.2c0-11.8-9.6-21.4-21.4-21.4h-100l69.2 112.7zM330 112l-51-83.2C274 20.9 265.3 16 256 16s-18 4.9-22.9 12.8L182 112H330z'
      
    ]
  };

  

  
  

  var faMosquito = {
    prefix: 'fat',
    iconName: 'mosquito',
    icon: [
      640,
      512,
      [],
      'e52b',
      
      'M187.5 1.4C184 4 183 9 185.5 12.7l45.3 68L201 140.4c-1.9 3.8-.6 8.6 3 10.7l73.7 44.2L79.3 226.4C34 232.4 0 272.8 0 320.8C0 405.5 97.6 447.9 154.6 388L288 266.1V298l-54 64.7c-1.2 1.5-1.9 3.3-1.9 5.3v61.5l-46.6 69.9c-2.5 3.7-1.6 8.7 2 11.3s8.5 1.6 11-2.1l48-72c.9-1.4 1.4-3 1.4-4.6V371L288 322.9l0 77.1c0 17.7 14.3 32 32 32s32-14.3 32-32l0-77.1L392.1 371v61c0 1.6 .5 3.2 1.4 4.6l48 72c2.5 3.7 7.4 4.6 11 2.1s4.5-7.6 2-11.3l-46.6-69.9 0-61.5c0-1.9-.7-3.8-1.9-5.3L352 298V266.1L485.4 388C542.4 447.9 640 405.5 640 320.8c0-47.9-34-88.4-79.4-94.3L362.3 195.4 436 151.1c3.6-2.2 5-6.9 3-10.7L409.2 80.7l45.3-68C457 9 456 4 452.5 1.4s-8.5-1.6-11 2.1l-48 72c-1.6 2.5-1.8 5.7-.5 8.3L421.6 141 352 182.7v-6.6c0-14.9-10.1-27.3-23.8-31V63.8c0-4.5-3.7-8.2-8.2-8.2s-8.2 3.7-8.2 8.2v81.4c-13.7 3.6-23.8 16.1-23.8 31v6.6L218.4 141 247 83.8c1.3-2.7 1.1-5.8-.5-8.3l-48-72c-2.5-3.7-7.4-4.6-11-2.1zM496.2 376.2L352 244.4l0-34.5 206.2 32.3 0 0 .4 .1c36.8 4.8 65.4 38 65.4 78.5c0 71.9-81.1 104.4-127.1 56.2c-.3-.3-.5-.5-.8-.8zM288 244.4L143.8 376.2c-.3 .2-.5 .5-.8 .8C97.1 425.2 16 392.7 16 320.8c0-40.5 28.6-73.6 65.4-78.5l0 0 .4-.1L288 209.9l0 34.5zM304 400l0-223.9c0-8.8 7.2-16 16-16s16 7.2 16 16L336 400c0 8.8-7.2 16-16 16s-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faDuck = {
    prefix: 'fat',
    iconName: 'duck',
    icon: [
      512,
      512,
      [129414],
      'f6d8',
      
      'M384 259V224.7c0-13.4 5.7-25 12.7-33.7c12.1-15.1 19.3-34.2 19.3-55c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 25.8 11.1 49.1 28.9 65.2c6.4 5.8 12.2 13.3 15.6 22.1c1.7 4.2 1.5 8.9-.5 13s-5.7 7.1-10 8.3L92.3 295.4c-3.5 1-7.3 .7-10.6-.7l-51-21.9c-1.3-.6-2.7-.9-4.2-.9c-5.7 0-10.6 4.8-10.6 10.7C16 382.3 96.7 464 196 464H312c61.9 0 112-50.1 112-112c0-32-13.4-60.9-35-81.3c-3.2-3-5-7.2-5-11.6zm16-27v27c24.6 23.3 40 56.3 40 93c0 70.7-57.3 128-128 128H196C87.8 480 0 391 0 282.7C0 268.1 11.9 256 26.6 256c3.6 0 7.2 .7 10.5 2.1L88 280l166.1-46.5 15.6-4.4c-2.1-5.2-5.3-9.9-9.3-14c-.7-.7-1.4-1.4-2.2-2.1c-21-19-34.1-46.5-34.1-77c0-57.4 46.6-104 104-104c54.5 0 99.3 42 103.6 95.4c13 2.7 26.4 3.3 39.7 1.7l20.5-2.6c10.7-1.3 20.2 7 20.2 17.8c0 48.4-39.3 87.7-87.7 87.7H400zm1.2-16h23.1c39.6 0 71.7-32.1 71.7-71.7c0-1.2-1-2.1-2.2-1.9l-20.5 2.6c-13.9 1.7-27.9 1.3-41.6-1.2c-1.6 21.6-9.8 41.4-22.5 57.3c-3.6 4.5-6.4 9.6-8 15zM320 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-2.7 166.7c-5.8 43.4-38.5 81.1-84.7 92.6c-37.8 9.4-75.9-.9-102.5-24.5c-3.3-2.9-3.6-8-.7-11.3s8-3.6 11.3-.7c22.6 20.1 55.3 29 88 20.9c39.9-10 67.8-42.4 72.7-79.2c.6-4.4 4.6-7.5 9-6.9s7.5 4.6 6.9 9z'
      
    ]
  };

  

  
  

  var faMosque = {
    prefix: 'fat',
    iconName: 'mosque',
    icon: [
      640,
      512,
      [128332],
      'f678',
      
      'M400 0c2.5 0 4.9 1.2 6.4 3.2c19.4 25.8 44.3 46.4 72.9 65.9c18 12.3 37.1 23.8 57.1 35.9c12 7.3 24.3 14.7 37 22.6c27.2 17.1 42.6 47.3 42.6 79c0 19.9-6 38.4-16.2 53.9c-2.4 3.7-7.4 4.7-11.1 2.2s-4.7-7.4-2.2-11.1c8.6-12.9 13.6-28.4 13.6-45c0-26.6-12.9-51.5-35.1-65.4c-12.1-7.6-24.2-14.9-36.1-22.1c-20.3-12.3-40.1-24.3-58.5-36.7C443.9 64.4 419.8 44.9 400 20.9c-19.8 24-43.9 43.4-70.3 61.4c-18.3 12.4-38.1 24.4-58.5 36.7l0 0 0 0 0 0c-11.9 7.2-24 14.5-36.1 22.1c-22.2 13.9-35.1 38.8-35.1 65.4c0 16.7 5 32.1 13.6 45c2.4 3.7 1.4 8.6-2.2 11.1s-8.6 1.4-11.1-2.2C190 245 184 226.5 184 206.6c0-31.7 15.4-61.9 42.6-79c12.6-7.9 24.9-15.4 37-22.6l0 0c20-12.1 39.1-23.6 57.1-35.9C349.3 49.6 374.2 29 393.6 3.2c1.5-2 3.9-3.2 6.4-3.2zM640 344V456c0 30.9-25.1 56-56 56h-8H560 528 512 464 448 352 336 288 272 240 224h-8c-30.9 0-56-25.1-56-56V344c0-30.9 25.1-56 56-56H584c30.9 0 56 25.1 56 56zM464 496h48V416c0-17.7 14.3-32 32-32s32 14.3 32 32v80h8c22.1 0 40-17.9 40-40V344c0-22.1-17.9-40-40-40H216c-22.1 0-40 17.9-40 40V456c0 22.1 17.9 40 40 40h8V416c0-17.7 14.3-32 32-32s32 14.3 32 32v80h48V416c0-20.1 9.5-39.1 25.6-51.2L400 336l38.4 28.8C454.5 376.9 464 395.9 464 416v80zm-16-80c0-15.1-7.1-29.3-19.2-38.4L400 356l-28.8 21.6C359.1 386.7 352 400.9 352 416v80h96V416zm96-16c-8.8 0-16 7.2-16 16v80h32V416c0-8.8-7.2-16-16-16zM272 416c0-8.8-7.2-16-16-16s-16 7.2-16 16v80h32V416zM73.5 3.4c2.7-1.8 6.2-1.9 9-.1L101 15.7c35.6 23.7 57 63.7 57 106.5V280c0 4.4-3.6 8-8 8s-8-3.6-8-8V160H16v16V456c0 22.1 17.9 40 40 40h64c4.4 0 8 3.6 8 8s-3.6 8-8 8H56c-30.9 0-56-25.1-56-56V176 121.2C0 79 20.8 39.5 55.6 15.7L73.5 3.4zM16 144H142V122.2c0-37.4-18.7-72.4-49.9-93.2L78.1 19.7 64.7 28.8C34.2 49.7 16 84.3 16 121.2V144z'
      
    ]
  };

  

  
  

  var faBookHeart = {
    prefix: 'fat',
    iconName: 'book-heart',
    icon: [
      448,
      512,
      [],
      'f499',
      
      'M0 56C0 25.1 25.1 0 56 0H408c22.1 0 40 17.9 40 40V376c0 19.4-13.7 35.5-32 39.2V496h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H56c-30.9 0-56-25.1-56-56V56zM56 416c-22.1 0-40 17.9-40 40s17.9 40 40 40H400V416H56zm-40 .8C26.2 406.4 40.3 400 56 400H408c13.3 0 24-10.7 24-24V40c0-13.3-10.7-24-24-24H56C33.9 16 16 33.9 16 56V416.8zM144 169.9v.6c0 10.6 4 20.9 11.2 28.8l78.9 86.1c1.5 1.7 3.7 2.6 5.9 2.6s4.4-.9 5.9-2.6l78.9-86.1c7.2-7.8 11.2-18.1 11.2-28.8v-.6c0-23.2-18.8-41.9-41.9-41.9c-11.1 0-21.8 4.4-29.7 12.3L245.7 159c-1.5 1.5-3.5 2.3-5.7 2.3s-4.2-.8-5.7-2.3l-18.7-18.7c-7.9-7.9-18.5-12.3-29.7-12.3c-23.2 0-41.9 18.8-41.9 41.9zM185.9 112c15.4 0 30.1 6.1 41 17L240 142.1 253.1 129c10.9-10.9 25.6-17 41-17c32 0 57.9 25.9 57.9 57.9v.6c0 14.7-5.5 28.8-15.4 39.6l-78.9 86.1c-4.5 5-11 7.8-17.7 7.8s-13.1-2.8-17.7-7.8l-78.9-86.1c-9.9-10.8-15.4-24.9-15.4-39.6v-.6c0-32 25.9-57.9 57.9-57.9z'
      
    ]
  };

  

  
  

  var faDropletSlash = {
    prefix: 'fat',
    iconName: 'droplet-slash',
    icon: [
      640,
      512,
      ["tint-slash"],
      'f5c7',
      
      'M320 496c-97.2 0-176-78.8-176-176c0-19.5 7.1-44.9 19.6-73.8c2.3-5.3 4.7-10.7 7.3-16.1l-12.9-10.2C140.2 256.8 128 292.1 128 320c0 106 86 192 192 192c53.3 0 101.5-21.7 136.2-56.7l-12.6-10C411.8 476.7 368.2 496 320 496zM345.4 11.7C339.4 4.2 330.5 0 320.9 0h-1.8c-9.6 0-18.5 4.2-24.5 11.7c-12.5 15.9-36.2 46.6-61.9 83.7l12.6 9.9c25.6-37.1 49.3-67.9 61.8-83.7c2.8-3.5 7-5.6 11.9-5.6h1.8c4.9 0 9.1 2.1 11.9 5.6c18.1 22.8 59.3 76.6 95.9 135.7c18.3 29.6 35.3 60.2 47.7 88.8c8.9 20.7 15.1 39.5 17.9 55.7l17.6 13.9C508.1 223.6 381.2 57 345.4 11.7zM232 320c0-4.4-3.6-8-8-8s-8 3.6-8 8c0 57.4 46.6 104 104 104c4.4 0 8-3.6 8-8s-3.6-8-8-8c-48.6 0-88-39.4-88-88zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  
    var faTintSlash = faDropletSlash;
  

  
  

  var faGear = {
    prefix: 'fat',
    iconName: 'gear',
    icon: [
      512,
      512,
      [9881,"cog"],
      'f013',
      
      'M211.6 28.5c1.6-7.3 8.1-12.5 15.6-12.5h57.6c7.5 0 14 5.2 15.6 12.5l12.9 57.1c.6 2.6 2.5 4.8 5 5.7c17.9 6.8 34.5 16.4 49.1 28.4c2.1 1.7 4.9 2.2 7.4 1.4l56-17.4c7.1-2.2 14.9 .8 18.6 7.3L478.3 161c3.7 6.5 2.5 14.7-3 19.8l-43.1 39.8c-2 1.8-2.9 4.5-2.5 7.2c1.5 9.2 2.3 18.7 2.3 28.4s-.8 19.1-2.3 28.4c-.4 2.6 .5 5.3 2.5 7.2l43.1 39.8c5.5 5.1 6.7 13.3 3 19.8L449.4 401c-3.7 6.5-11.5 9.5-18.6 7.3l-56-17.4c-2.6-.8-5.4-.3-7.4 1.4c-14.6 11.9-31.2 21.6-49.1 28.4c-2.5 1-4.4 3.1-5 5.7l-12.9 57.1c-1.6 7.3-8.1 12.5-15.6 12.5H227.2c-7.5 0-14-5.2-15.6-12.5l-12.9-57.1c-.6-2.6-2.5-4.8-5-5.7c-17.9-6.8-34.5-16.4-49.1-28.4c-2.1-1.7-4.9-2.2-7.4-1.4l-56 17.4c-7.1 2.2-14.9-.8-18.6-7.3L33.7 351c-3.7-6.5-2.5-14.7 3-19.8l43.1-39.8c2-1.8 2.9-4.5 2.5-7.2C80.8 275.1 80 265.7 80 256s.8-19.1 2.3-28.4c.4-2.6-.5-5.3-2.5-7.2L36.7 180.7c-5.5-5.1-6.7-13.3-3-19.8L62.6 111c3.7-6.5 11.5-9.5 18.6-7.3l2.4-7.6-2.4 7.6 56 17.4c2.6 .8 5.4 .3 7.4-1.4c14.6-12 31.2-21.6 49.1-28.4c2.5-1 4.4-3.1 5-5.7l12.9-57.1zM227.2 0c-15 0-27.9 10.4-31.2 25L184 78c-16.7 6.8-32.2 15.8-46.1 26.7L85.9 88.5C71.6 84 56.2 90.1 48.7 103L19.9 153c-7.5 13-5 29.4 6 39.5l39.9 36.9C64.6 238.1 64 247 64 256s.6 17.9 1.8 26.6L25.9 319.5l5.4 5.9-5.4-5.9c-11 10.1-13.5 26.6-6 39.5L48.7 409c7.5 13 22.9 19 37.2 14.6l51.9-16.2c14 10.9 29.5 19.9 46.1 26.7l12 53c3.3 14.6 16.3 25 31.2 25h57.6c15 0 27.9-10.4 31.2-25l12-53c16.7-6.7 32.2-15.8 46.1-26.7l51.9 16.2c14.3 4.4 29.7-1.6 37.2-14.6L492.1 359c7.5-13 5-29.4-6-39.5l-39.9-36.9c1.2-8.7 1.8-17.6 1.8-26.6s-.6-17.9-1.8-26.6l39.9-36.9c11-10.1 13.5-26.6 6-39.5L463.3 103c-7.5-13-22.9-19-37.2-14.6l-51.9 16.2C360.2 93.7 344.7 84.7 328 78L316 25c-3.3-14.6-16.3-25-31.2-25H227.2zM192 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm144 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z'
      
    ]
  };

  
    var faCog = faGear;
  

  
  

  var faCameraSecurity = {
    prefix: 'fat',
    iconName: 'camera-security',
    icon: [
      448,
      512,
      ["camera-home"],
      'f8fe',
      
      'M384 16c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H334 315.2 132.8 114 64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H384zM343.9 416H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h40.1L67.6 475.4c-4.6 7.4-4.8 16.7-.5 24.3s12.3 12.3 21 12.3H360c8.7 0 16.7-4.7 21-12.3s4-16.9-.5-24.3L343.9 416zm-18.8 0l41.7 67.8c1.5 2.5 1.6 5.6 .2 8.1s-4.1 4.1-7 4.1H88c-2.9 0-5.6-1.6-7-4.1s-1.3-5.6 .2-8.1L122.9 416H325.1zM352 208A128 128 0 1 0 96 208a128 128 0 1 0 256 0zM224 96a112 112 0 1 1 0 224 112 112 0 1 1 0-224z'
      
    ]
  };

  
    var faCameraHome = faCameraSecurity;
  

  
  

  var faUserDoctorHairLong = {
    prefix: 'fat',
    iconName: 'user-doctor-hair-long',
    icon: [
      448,
      512,
      [],
      'e459',
      
      'M336 144v-8-8c0-5.4-.4-10.8-1.1-16H312c-22.1 0-43-10.2-56.6-27.5L251 89.9C231.2 114 201.7 128 170.5 128L112 128v8 8c0 61.9 50.1 112 112 112s112-50.1 112-112zM292.4 39.3L265.8 71.8l1.4 1.8C277.8 87.7 294.4 96 312 96h19.4c-6.8-22.8-20.6-42.5-39-56.7zM113.1 112h57.4c26.4 0 51.4-11.8 68.1-32.3L279 30.4C262.7 21.2 244 16 224 16c-56.4 0-103.1 41.7-110.9 96zM390.4 244.8c-20.6-15.4-36.1-36.2-45.2-59.6C328.1 235.7 280.3 272 224 272s-104.1-36.3-121.2-86.8c-9.1 23.4-24.6 44.1-45.2 59.6L53.3 248c-3.4 2.5-5.3 6.5-5.3 10.7C48 266 54 272 61.3 272H120c4.4 0 8 3.6 8 8s-3.6 8-8 8H61.3C45.1 288 32 274.9 32 258.7c0-9.2 4.3-17.9 11.7-23.5L48 232c30.2-22.7 48-58.2 48-96v-8C96 57.3 153.3 0 224 0s128 57.3 128 128v8c0 37.8 17.8 73.3 48 96l4.3 3.2c7.4 5.5 11.7 14.2 11.7 23.5c0 16.2-13.1 29.3-29.3 29.3H328c-4.4 0-8-3.6-8-8s3.6-8 8-8h58.7c7.4 0 13.3-6 13.3-13.3c0-4.2-2-8.1-5.3-10.7l-4.3-3.2zM152 322v46.7c22.7 3.8 40 23.6 40 47.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-23.8 17.3-43.5 40-47.3V325.3C66.9 343.5 16 406.4 16 481.2c0 8.2 6.6 14.8 14.8 14.8H417.2c8.2 0 14.8-6.6 14.8-14.8c0-74.8-50.9-137.7-120-155.9v43.4c22.7 3.8 40 23.6 40 47.3v40c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8s3.6-8 8-8h8V416c0-17.7-14.3-32-32-32s-32 14.3-32 32v32h8c4.4 0 8 3.6 8 8s-3.6 8-8 8H264c-4.4 0-8-3.6-8-8V416c0-23.8 17.3-43.5 40-47.3V322c-8.2-1.3-16.6-2-25.2-2H177.2c-8.6 0-17 .7-25.2 2zm-40 94a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM0 481.2C0 383.3 79.3 304 177.2 304h93.6C368.7 304 448 383.3 448 481.2c0 17-13.8 30.8-30.8 30.8H30.8C13.8 512 0 498.2 0 481.2z'
      
    ]
  };

  

  
  

  var faFileCertificate = {
    prefix: 'fat',
    iconName: 'file-certificate',
    icon: [
      512,
      512,
      ["file-award"],
      'f5f3',
      
      'M144 129.1V64c0-26.5 21.5-48 48-48H332.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H495.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H224c0 5.5-1 10.9-2.7 16H448c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-35.3 0-64 28.7-64 64v71.1l.1-.1c1.5-.7 4-2 6.6-3c3-1.2 6.2-2.2 9.3-2.9zm342.6 28.2c.9 .9 1.7 1.8 2.4 2.7H376c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L486.6 157.3zm-377.5 4.3c-10-4.1-21.5-1-28.1 7.5L70.6 182.6c-1.3 1.7-3.2 2.7-5.2 3l-16.9 2.3c-10.7 1.5-19.1 9.9-20.5 20.5l-2.3 16.9c-.3 2.1-1.4 4-3 5.2L9.1 241.1c-8.5 6.6-11.6 18.1-7.5 28.1L8 285c.8 1.9 .8 4.1 0 6.1L1.6 306.8c-4.1 10-1 21.5 7.5 28.1l13.5 10.5c1.7 1.3 2.7 3.2 3 5.2l2.3 16.9c1.5 10.7 9.9 19.1 20.5 20.5L64 390.2V504c0 2.9 1.5 5.5 4 6.9s5.5 1.4 8 0l52-29.7 52 29.7c2.5 1.4 5.5 1.4 8 0s4-4.1 4-6.9V390.2l15.5-2.1c10.7-1.5 19.1-9.9 20.5-20.5l2.3-16.9c.3-2.1 1.4-4 3-5.2l13.5-10.5c8.5-6.6 11.6-18.1 7.5-28.1L248 291c-.8-1.9-.8-4.1 0-6.1l6.5-15.8c4.1-10 1-21.5-7.5-28.1l-13.5-10.5c-1.7-1.3-2.7-3.2-3-5.2l-2.3-16.9c-1.5-10.7-9.9-19.1-20.5-20.5l-16.9-2.3c-2.1-.3-4-1.4-5.2-3l-10.5-13.5c-6.6-8.5-18.1-11.6-28.1-7.5L131 168c-1.9 .8-4.1 .8-6.1 0l-15.8-6.5zm73.3 214.6c-1.6 .3-3 1.1-4.1 2.2c-2.1 1.4-4 3.2-5.6 5.2l-10.5 13.5c-2.2 2.8-6 3.9-9.4 2.5l-15.8-6.5c-5.8-2.4-12.4-2.4-18.2 0l-15.8 6.5c-3.3 1.4-7.2 .3-9.4-2.5L83.3 383.6c-1.6-2.1-3.5-3.8-5.6-5.2c-1.1-1.1-2.5-1.9-4.1-2.2c-1.9-.8-3.9-1.3-6-1.6l-16.9-2.3c-3.6-.5-6.4-3.3-6.8-6.9l-2.3-16.9c-.8-6.2-4.1-11.9-9.1-15.7L18.9 322.2c-2.8-2.2-3.9-6-2.5-9.4l6.5-15.8c2.4-5.8 2.4-12.4 0-18.2l-6.5-15.8c-1.4-3.3-.3-7.2 2.5-9.4l13.5-10.5c5-3.9 8.2-9.5 9.1-15.7l2.3-16.9c.5-3.6 3.3-6.4 6.8-6.8l16.9-2.3c6.2-.8 11.9-4.1 15.7-9.1l10.5-13.5c2.2-2.8 6-3.9 9.4-2.5l15.8 6.5c5.8 2.4 12.4 2.4 18.2 0l15.8-6.5c3.3-1.4 7.2-.3 9.4 2.5l10.5 13.5c3.9 5 9.5 8.2 15.7 9.1l16.9 2.3c3.6 .5 6.4 3.3 6.8 6.8l2.3 16.9c.8 6.2 4.1 11.9 9.1 15.7l13.5 10.5c2.8 2.2 3.9 6 2.5 9.4l-6.5 15.8c-2.4 5.8-2.4 12.4 0 18.2l6.5 15.8c1.4 3.3 .3 7.2-2.5 9.4l-13.5 10.5c-5 3.9-8.2 9.5-9.1 15.7l-2.3 16.9c-.5 3.6-3.3 6.4-6.8 6.9l-16.9 2.3c-2.1 .3-4.1 .8-6 1.6zM80 405.5l1.1 1.4c6.6 8.5 18.1 11.6 28.1 7.5L125 408c1.9-.8 4.1-.8 6.1 0l15.8 6.5c10 4.1 21.5 1 28.1-7.5l1.1-1.4v84.7l-44-25.2c-2.5-1.4-5.5-1.4-7.9 0L80 490.2V405.5zM80 288a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0A64 64 0 1 0 64 288a64 64 0 1 0 128 0z'
      
    ]
  };

  
    var faFileAward = faFileCertificate;
  

  
  

  var faMessageXmark = {
    prefix: 'fat',
    iconName: 'message-xmark',
    icon: [
      512,
      512,
      ["comment-alt-times","message-times"],
      'f4ab',
      
      'M176 416c0-8.8-7.2-16-16-16H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H309.3c-3.5 0-6.8 1.1-9.6 3.2L176 496V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h80 16v16 64c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM178.3 130.3c-3.1 3.1-3.1 8.2 0 11.3L244.7 208l-66.3 66.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L256 219.3l66.3 66.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L267.3 208l66.3-66.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L256 196.7l-66.3-66.3c-3.1-3.1-8.2-3.1-11.3 0z'
      
    ]
  };

  
    var faCommentAltTimes = faMessageXmark;
  
    var faMessageTimes = faMessageXmark;
  

  
  

  var faHousePersonReturn = {
    prefix: 'fat',
    iconName: 'house-person-return',
    icon: [
      640,
      512,
      ["house-person-arrive","house-return"],
      'e011',
      
      'M245.2 1.9c-3-2.6-7.4-2.6-10.4 0l-232 200c-3.3 2.9-3.7 7.9-.8 11.3s7.9 3.7 11.3 .8L64 170.3V360c0 30.9 25.1 56 56 56H342l4-16H120c-22.1 0-40-17.9-40-40V156.5L240 18.6 376.8 136.5c3.9-3.8 7.9-7.3 12.2-10.6L245.2 1.9zM224 184c4.4 0 8 3.6 8 8v64c0 4.4-3.6 8-8 8H160c-4.4 0-8-3.6-8-8V192c0-4.4 3.6-8 8-8h64zm-64-16c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24h64c13.3 0 24-10.7 24-24V192c0-13.3-10.7-24-24-24H160zm342.9 19.3c-4.6 4-6.4 10.3-4.9 16.1l16.9 63.5c4.2 15.8 .1 32.7-11 44.8l-70.7 77.1c-1.8 2-3.1 4.3-3.7 6.9l-22 88.1c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4l23-92.1c1.3-5.2 3.9-9.9 7.5-13.9l49.5-54c3.8-4.1 5.1-9.9 3.6-15.3l-19.3-65.5c-1.9-6.5-7.7-11.1-14.5-11.5s-13 3.6-15.6 9.8l-10.2 24.5c-2.2 5.3-5.8 9.9-10.3 13.3l-28.5 21.4c-7.1 5.3-17.1 3.9-22.4-3.2s-3.9-17.1 3.2-22.4l25-18.8c2.3-1.7 4.1-4 5.2-6.6l16.5-39.7c14.7-35.2 49-58.1 87.1-58.1c20.5 0 40.8 4.3 59.6 12.6l5.7 2.5c30.3 13.5 53.1 39.7 62.2 71.6l3.7 12.9c2.4 8.5-2.5 17.4-11 19.8s-17.4-2.5-19.8-11l-3.7-12.9c-6.5-22.8-22.8-41.5-44.4-51.1l-5.7-2.5c-1.1-.5-2.2-1-3.4-1.4c-5.6-2.3-12.1-1.2-16.6 2.8zM432 16a36 36 0 1 1 0 72 36 36 0 1 1 0-72zM532.6 209c12 8.3 20.9 20.6 24.9 34.9l3.7 12.9c4.9 17 22.6 26.8 39.6 22s26.8-22.6 22-39.6l-3.7-12.9c-10.4-36.4-36.4-66.4-71.1-81.8l-5.7-2.5c-20.8-9.2-43.3-14-66.1-14c-44.6 0-84.8 26.8-101.9 67.9l-16.5 39.7-25 18.8c-14.1 10.6-17 30.7-6.4 44.8s30.7 17 44.8 6.4l28.5-21.4c6.9-5.1 12.2-12 15.5-19.9l.4-1 9.8-23.5 7.2 24.4 12.1 41.2-49.5 54c-5.4 5.9-9.2 13-11.2 20.8l-23 92.1c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l22-88.1 70.7-77.1c14.8-16.1 20.3-38.6 14.7-59.7l-11.6-43.6-1.5-5.6-2.6-9.6-1.3-4.8c1 .4 1.9 .8 2.9 1.2L522 203c3.7 1.7 7.3 3.7 10.6 6zM380 52a52 52 0 1 0 104 0A52 52 0 1 0 380 52zM541 343.9c-4.1 1.6-6.1 6.3-4.5 10.4L557 405.5l.6 1.5 1.2 1.2 60.5 60.5c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L535 429.6c-3.1-3.1-5.5-6.7-7.1-10.7L512.8 381c-1.6-4.1-6.3-6.1-10.4-4.5s-6.1 6.3-4.5 10.4l15.1 37.9c2.4 6 6 11.5 10.6 16.1l61.7 61.7c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L571.3 398l-19.8-49.6c-1.6-4.1-6.3-6.1-10.4-4.5z'
      
    ]
  };

  
    var faHousePersonArrive = faHousePersonReturn;
  
    var faHouseReturn = faHousePersonReturn;
  

  
  

  var faCartCircleArrowDown = {
    prefix: 'fat',
    iconName: 'cart-circle-arrow-down',
    icon: [
      640,
      512,
      [],
      'e3ef',
      
      'M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8H45.7C57.1 16 67 24.1 69.2 35.4l59.4 303.4c5.1 26.3 28.2 45.2 55 45.2H320.7c-.5-5.3-.7-10.6-.7-16H183.5c-19.1 0-35.6-13.5-39.3-32.3L134.9 288H339.2c2.8-5.5 5.9-10.8 9.3-16H131.8L88 48H527.7c15.5 0 26.9 14.4 23.4 29.5L523.8 194.2c5.3 .8 10.5 1.9 15.7 3.2L566.6 81.1C572.5 56 553.4 32 527.7 32H84.8C81 13.4 64.7 0 45.7 0H8zM144 464a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm400-96a128 128 0 1 1 -256 0 128 128 0 1 1 256 0zm-272 0a144 144 0 1 0 288 0 144 144 0 1 0 -288 0zm213.7 2.3c-3.1-3.1-8.2-3.1-11.3 0L504 420.7V296c0-4.4-3.6-8-8-8s-8 3.6-8 8V420.7l-50.3-50.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l64 64c3.1 3.1 8.2 3.1 11.3 0l64-64c3.1-3.1 3.1-8.2 0-11.3z'
      
    ]
  };

  

  
  

  var faFaceSmileHalo = {
    prefix: 'fat',
    iconName: 'face-smile-halo',
    icon: [
      512,
      512,
      [],
      'e38f',
      
      'M496 80c0 3.6-2.4 9.9-13.6 18.3c-11 8.1-27.8 16.1-50.1 23C387.8 135.2 325.5 144 256 144s-131.9-8.8-176.2-22.7c-22.3-7-39.2-14.9-50.1-23C18.4 89.9 16 83.6 16 80s2.4-9.9 13.6-18.3c11-8.1 27.8-16.1 50.1-23C124.1 24.8 186.5 16 256 16s131.8 8.8 176.2 22.7c22.3 7 39.2 14.9 50.1 23C493.6 70.1 496 76.4 496 80zm16 0C512 35.8 397.4 0 256 0S0 35.8 0 80s114.6 80 256 80s256-35.8 256-80zM45.6 156.5C26.7 190.7 16 230.1 16 272c0 132.5 107.5 240 240 240s240-107.5 240-240c0-41.9-10.7-81.3-29.6-115.5c-4.8 2-9.9 4-15.1 5.8C469.6 194.7 480 232.1 480 272c0 123.7-100.3 224-224 224S32 395.7 32 272c0-39.9 10.4-77.3 28.7-109.7c-5.2-1.9-10.2-3.8-15.1-5.8zm105.3 85.2c7.6-11.6 16.1-17.7 24.9-17.7s17.3 6.1 24.9 17.7c7.4 11.4 12.7 26.3 15.2 39.8c.8 4.3 5 7.2 9.3 6.4s7.2-5 6.4-9.3c-2.8-15-8.7-32-17.6-45.6c-8.7-13.3-21.5-25-38.3-25s-29.6 11.7-38.3 25c-8.8 13.5-14.8 30.6-17.6 45.6c-.8 4.3 2 8.5 6.4 9.3s8.5-2 9.3-6.4c2.5-13.5 7.8-28.4 15.2-39.8zm-11.5 95.7c-3.6 2.5-4.5 7.5-2 11.1c22.4 32 61.9 67.4 118.6 67.4s96.1-35.4 118.6-67.4c2.5-3.6 1.7-8.6-2-11.1s-8.6-1.7-11.1 2C340.6 369.2 305.4 400 256 400s-84.6-30.8-105.4-60.6c-2.5-3.6-7.5-4.5-11.1-2zm156.3-56c2.5-13.5 7.8-28.4 15.2-39.8c7.6-11.6 16.1-17.7 24.9-17.7s17.3 6.1 24.9 17.7c7.4 11.4 12.7 26.3 15.2 39.8c.8 4.3 5 7.2 9.3 6.4s7.2-5 6.4-9.3c-2.8-15-8.7-32-17.6-45.6c-8.7-13.3-21.5-25-38.3-25s-29.6 11.7-38.3 25c-8.8 13.5-14.8 30.6-17.6 45.6c-.8 4.3 2 8.5 6.4 9.3s8.5-2 9.3-6.4z'
      
    ]
  };

  

  
  

  var faCircleBolt = {
    prefix: 'fat',
    iconName: 'circle-bolt',
    icon: [
      512,
      512,
      [],
      'e0fe',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm267.6-23.2L320 128 160 256h70.1c5.5 0 10.7 2.9 13.6 7.6s3.2 10.6 .7 15.6L192 384 352 256H281.9c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6zm66.7-97.7L289.9 224l-8 16h17.9H352c6.8 0 12.9 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L222.1 288l8-16H212.2 160c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1s7.6 12.9 4.2 19.6z'
      
    ]
  };

  

  
  

  var faPresentationScreen = {
    prefix: 'fat',
    iconName: 'presentation-screen',
    icon: [
      576,
      512,
      ["presentation"],
      'f685',
      
      'M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8H568c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zM32 48V288c0 35.3 28.7 64 64 64H280v52.7l-93.7 93.7c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L288 419.3l90.3 90.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L296 404.7V352H480c35.3 0 64-28.7 64-64V48H528V288c0 26.5-21.5 48-48 48H288 96c-26.5 0-48-21.5-48-48V48H32z'
      
    ]
  };

  
    var faPresentation = faPresentationScreen;
  

  
  

  var faHandsAslInterpreting = {
    prefix: 'fat',
    iconName: 'hands-asl-interpreting',
    icon: [
      640,
      512,
      ["american-sign-language-interpreting","asl-interpreting","hands-american-sign-language-interpreting"],
      'f2a3',
      
      'M143.1 3C122.6-5.4 99.3 4.5 91 24.9L8.4 227.6C2.9 241.2 0 255.7 0 270.4C0 333.1 50.9 384 113.6 384H204h4c2.1 0 4.1-.2 6.2-.5c35.7-3.3 66.4-24.1 83.4-53.5c10.9-18.8 4.8-42.7-13.6-54c18.3-11.3 24.4-35.3 13.6-54c-9.8-16.9-24.1-31-41.2-40.5l51.1-15.1c21.2-6.3 33.3-28.5 27-49.7s-28.5-33.3-49.7-27l-44.4 13.2 35.5-33.9c16-15.3 16.5-40.6 1.3-56.6s-40.6-16.5-56.6-1.3L159.1 69.7 165 55.1c8.3-20.5-1.5-43.8-22-52.1zM228.3 262c3.4 5.9 8.1 10.6 13.5 14c-5.4 3.4-10.1 8.1-13.5 14c-4.9 8.5-14 14-24.3 14c-15.5 0-28-12.5-28-28s12.5-28 28-28c10.3 0 19.4 5.6 24.3 14zM105.8 30.9c5-12.3 19-18.2 31.3-13.2s18.2 19 13.2 31.3L130.1 98.3c-1.4 3.5-.2 7.5 2.9 9.6s7.3 1.8 10-.8l88.3-84.5c9.6-9.2 24.8-8.8 33.9 .8s8.8 24.8-.8 33.9l-59.3 56.7c-2.7 2.6-3.2 6.6-1.4 9.8s5.7 4.7 9.2 3.7L289.2 105c12.7-3.8 26.1 3.5 29.8 16.2s-3.5 26.1-16.2 29.8l-72.5 21.5c-3.4 1-5.7 4.1-5.7 7.7s2.3 6.7 5.7 7.7c22.7 6.8 41.7 22.1 53.4 42.2c6.6 11.5 2.7 26.2-8.8 32.8s-26.2 2.7-32.8-8.8c-7.7-13.2-21.9-22-38.1-22c-24.3 0-44 19.7-44 44s19.7 44 44 44c16.2 0 30.5-8.8 38.1-22c6.6-11.5 21.3-15.4 32.8-8.8s15.4 21.3 8.8 32.8c-14.5 25.1-40.7 42.8-71.2 45.6c-.2 0-.4 0-.6 .1c-1.3 .2-2.6 .3-3.9 .3h-4H113.6C59.7 368 16 324.3 16 270.4c0-12.6 2.4-25.1 7.2-36.8L105.8 30.9zM496.9 509c20.5 8.3 43.8-1.5 52.1-22l82.6-202.6c5.5-13.6 8.4-28.2 8.4-42.9C640 178.9 589.2 128 526.4 128H436h-4c-2.1 0-4.1 .2-6.2 .5c-35.7 3.3-66.4 24.1-83.4 53.5c-10.9 18.8-4.8 42.7 13.6 54c-18.3 11.3-24.4 35.3-13.6 54c9.8 16.9 24.1 31 41.2 40.5l-51.1 15.1c-21.2 6.3-33.3 28.5-27 49.7s28.5 33.3 49.7 27l44.4-13.2-35.5 33.9c-16 15.3-16.5 40.6-1.3 56.6s40.6 16.5 56.6 1.3l61.3-58.6L475 456.9c-8.3 20.5 1.5 43.8 22 52.1zM411.7 250c-3.4-5.9-8.1-10.6-13.5-14c5.4-3.4 10.1-8.1 13.5-14c4.9-8.5 14-14 24.3-14c15.5 0 28 12.5 28 28s-12.5 28-28 28c-10.3 0-19.4-5.6-24.3-14zM534.2 481.1c-5 12.3-19 18.2-31.3 13.2s-18.2-19-13.2-31.3l20.1-49.3c1.4-3.5 .2-7.5-2.9-9.6s-7.3-1.8-10 .8l-88.3 84.5c-9.6 9.2-24.8 8.8-33.9-.8s-8.8-24.8 .8-33.9l59.3-56.7c2.7-2.6 3.2-6.6 1.4-9.8s-5.7-4.7-9.2-3.7L350.8 407c-12.7 3.8-26.1-3.5-29.8-16.2s3.5-26.1 16.2-29.8l72.5-21.5c3.4-1 5.7-4.1 5.7-7.7s-2.3-6.7-5.7-7.7c-22.7-6.8-41.7-22.1-53.4-42.2c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8c7.6 13.2 21.9 22 38.1 22c24.3 0 44-19.7 44-44s-19.7-44-44-44c-16.2 0-30.5 8.8-38.1 22c-6.6 11.5-21.3 15.4-32.8 8.8s-15.4-21.3-8.8-32.8c14.5-25.2 40.7-42.8 71.2-45.6c.2 0 .4 0 .6-.1c1.3-.2 2.6-.3 3.9-.3h4 90.4c53.9 0 97.6 43.7 97.6 97.6c0 12.6-2.5 25.1-7.2 36.8L534.2 481.1z'
      
    ]
  };

  
    var faAmericanSignLanguageInterpreting = faHandsAslInterpreting;
  
    var faAslInterpreting = faHandsAslInterpreting;
  
    var faHandsAmericanSignLanguageInterpreting = faHandsAslInterpreting;
  

  
  

  var faChartUser = {
    prefix: 'fat',
    iconName: 'chart-user',
    icon: [
      640,
      512,
      ["user-chart"],
      'f6a3',
      
      'M224 16H576c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H328.3c3.1 5.2 6 10.5 8.5 16H576c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H224c-35.3 0-64 28.7-64 64V96c5.4 0 10.8 .3 16 1V64c0-26.5 21.5-48 48-48zM416 120c0 4.4 3.6 8 8 8h76.7L384 244.7l-74.3-74.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l80 80c3.1 3.1 8.2 3.1 11.3 0L512 139.3V216c0 4.4 3.6 8 8 8s8-3.6 8-8V120c0-4.4-3.6-8-8-8H424c-4.4 0-8 3.6-8 8zM133.3 368h53.3C251.5 368 304 420.5 304 485.3c0 5.9-4.8 10.7-10.7 10.7H26.7c-5.9 0-10.7-4.8-10.7-10.7C16 420.5 68.5 368 133.3 368zm0-16C59.7 352 0 411.7 0 485.3C0 500.1 11.9 512 26.7 512H293.3c14.7 0 26.7-11.9 26.7-26.7C320 411.7 260.3 352 186.7 352H133.3zM80 224a80 80 0 1 1 160 0A80 80 0 1 1 80 224zm176 0A96 96 0 1 0 64 224a96 96 0 1 0 192 0z'
      
    ]
  };

  
    var faUserChart = faChartUser;
  

  
  

  var faBookCircleArrowRight = {
    prefix: 'fat',
    iconName: 'book-circle-arrow-right',
    icon: [
      640,
      512,
      [],
      'e0bc',
      
      'M56 0C25.1 0 0 25.1 0 56V456c0 30.9 25.1 56 56 56H394.8c-6.9-4.9-13.4-10.2-19.6-16H56c-22.1 0-40-17.9-40-40s17.9-40 40-40H326.6c-1.5-5.2-2.7-10.6-3.7-16H56c-15.7 0-29.8 6.4-40 16.8V56c0-22.1 17.9-40 40-40H408c13.3 0 24 10.7 24 24V204c5.2-2 10.6-3.8 16-5.4V40c0-22.1-17.9-40-40-40H56zM496 240a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm2.3-213.7c-3.1 3.1-3.1 8.2 0 11.3L548.7 360H424c-4.4 0-8 3.6-8 8s3.6 8 8 8H548.7l-50.3 50.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l64-64c3.1-3.1 3.1-8.2 0-11.3l-64-64c-3.1-3.1-8.2-3.1-11.3 0z'
      
    ]
  };

  

  
  

  var faVolumeOff = {
    prefix: 'fat',
    iconName: 'volume-off',
    icon: [
      320,
      512,
      [],
      'f026',
      
      'M290.2 48c-3.4 0-6.6 1.2-9.2 3.5L143.2 174c-1.5 1.3-3.4 2-5.3 2H56c-22.1 0-40 17.9-40 40v80c0 22.1 17.9 40 40 40h81.9c2 0 3.9 .7 5.3 2L281 460.5c2.5 2.2 5.8 3.5 9.2 3.5c7.6 0 13.8-6.2 13.8-13.8V61.8c0-7.6-6.2-13.8-13.8-13.8zm-19.8-8.5c5.5-4.8 12.5-7.5 19.8-7.5C306.7 32 320 45.3 320 61.8V450.2c0 16.5-13.3 29.8-29.8 29.8c-7.3 0-14.3-2.7-19.8-7.5L134.9 352H56c-30.9 0-56-25.1-56-56V216c0-30.9 25.1-56 56-56h78.9L270.4 39.5z'
      
    ]
  };

  

  
  

  var faFlaskRoundPoison = {
    prefix: 'fat',
    iconName: 'flask-round-poison',
    icon: [
      448,
      512,
      ["flask-poison"],
      'f6e0',
      
      'M160 16H288V149.3c0 13.1 7.9 24.2 18.8 29.5C371.4 209.7 416 275.6 416 352c0 51.7-20.4 98.6-53.7 133.2c-6.7 7-17 10.8-28.5 10.8H114.2c-11.6 0-21.8-3.9-28.5-10.8C52.4 450.6 32 403.7 32 352c0-76.4 44.6-142.3 109.2-173.3c10.9-5.2 18.8-16.4 18.8-29.5V16zM304 149.3V16h24c4.4 0 8-3.6 8-8s-3.6-8-8-8H288 160 120c-4.4 0-8 3.6-8 8s3.6 8 8 8l24 0V149.3c0 6.5-3.9 12.2-9.7 15C64.3 197.8 16 269.3 16 352c0 56 22.1 106.9 58.2 144.3C84.5 507 99.3 512 114.2 512H333.8c15 0 29.7-5 40.1-15.7C409.9 458.9 432 408 432 352c0-82.7-48.3-154.2-118.3-187.7c-5.8-2.8-9.7-8.6-9.7-15zM120 312c0-42.5 44.7-80 104-80s104 37.5 104 80c0 23.7-13.6 45.6-36.3 60.7c-6.8 4.5-11.7 12.2-11.7 21V408c0 4.4-3.6 8-8 8H176c-4.4 0-8-3.6-8-8V393.7c0-8.9-4.9-16.5-11.7-21c-22.7-15-36.3-36.9-36.3-60.7zm104-96c-64.4 0-120 41.3-120 96c0 30.3 17.4 56.7 43.5 74c3 2 4.5 4.9 4.5 7.7V408c0 13.3 10.7 24 24 24h96c13.3 0 24-10.7 24-24V393.7c0-2.8 1.6-5.7 4.5-7.7c26.1-17.3 43.5-43.7 43.5-74c0-54.7-55.6-96-120-96zm40 112a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-32 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64z'
      
    ]
  };

  
    var faFlaskPoison = faFlaskRoundPoison;
  

  
  

  var faFrancSign = {
    prefix: 'fat',
    iconName: 'franc-sign',
    icon: [
      320,
      512,
      [],
      'e18f',
      
      'M96 32C78.3 32 64 46.3 64 64V216 336H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H64V472c0 4.4 3.6 8 8 8s8-3.6 8-8V352H216c4.4 0 8-3.6 8-8s-3.6-8-8-8H80V224H280c4.4 0 8-3.6 8-8s-3.6-8-8-8H80V64c0-8.8 7.2-16 16-16H312c4.4 0 8-3.6 8-8s-3.6-8-8-8H96z'
      
    ]
  };

  

  
  

  var faArrowDownLeft = {
    prefix: 'fat',
    iconName: 'arrow-down-left',
    icon: [
      384,
      512,
      [],
      'e091',
      
      'M40 416c-4.4 0-8-3.6-8-8V168c0-4.4 3.6-8 8-8s8 3.6 8 8V388.7L338.3 98.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L59.3 400H280c4.4 0 8 3.6 8 8s-3.6 8-8 8H40z'
      
    ]
  };

  

  
  

  var faStreetView = {
    prefix: 'fat',
    iconName: 'street-view',
    icon: [
      512,
      512,
      [],
      'f21d',
      
      'M318.2 288c-8.2 0-15 6.1-15.9 14.2l-11.1 99.5c-.9 8.1-7.7 14.2-15.9 14.2H236.6c-8.2 0-15-6.1-15.9-14.2l-11.1-99.5c-.9-8.1-7.7-14.2-15.9-14.2H192c-8.8 0-16-7.2-16-16V224c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v48c0 8.8-7.2 16-16 16h-1.8zM208 64a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM320 304c17.7 0 32-14.3 32-32V224c0-35.3-28.7-64-64-64H224c-35.3 0-64 28.7-64 64v48c0 17.7 14.3 32 32 32h1.8l11.1 99.5c1.8 16.2 15.5 28.5 31.8 28.5h38.7c16.3 0 30-12.3 31.8-28.5L318.2 304H320zM256 128A64 64 0 1 0 256 0a64 64 0 1 0 0 128zM120.8 367.8c4.3-.9 7.1-5.1 6.2-9.5s-5.1-7.1-9.5-6.2c-33.9 7.1-62.6 16.9-83.1 28.7C14.6 392.3 0 407.2 0 425.5c0 14.5 9.3 26.9 22.7 37c13.5 10.1 32.6 18.9 55.5 26.2C124.1 503.1 186.9 512 256 512s131.9-8.9 177.8-23.4c22.9-7.2 42-16 55.5-26.2c13.4-10 22.7-22.4 22.7-37c0-18.3-14.6-33.2-34.5-44.7c-20.4-11.8-49.1-21.5-83.1-28.7c-4.3-.9-8.6 1.9-9.5 6.2s1.9 8.6 6.2 9.5c33.1 6.9 60 16.2 78.4 26.9c18.9 10.9 26.5 21.7 26.5 30.8c0 7.2-4.6 15.4-16.3 24.2c-11.6 8.6-28.8 16.8-50.8 23.7C385 487.3 323.9 496 256 496s-129-8.7-172.9-22.6c-22-7-39.2-15.1-50.8-23.7c-11.7-8.8-16.3-17-16.3-24.2c0-9.1 7.5-19.9 26.5-30.8c18.4-10.6 45.3-19.9 78.4-26.9z'
      
    ]
  };

  

  
  

  var faFontCase = {
    prefix: 'fat',
    iconName: 'font-case',
    icon: [
      640,
      512,
      [],
      'f866',
      
      'M183.5 37.1C182.3 34 179.3 32 176 32s-6.3 2-7.5 5.1L.6 469.1c-1.6 4.1 .4 8.8 4.6 10.4s8.8-.4 10.4-4.6L63.3 352c.2 0 .5 0 .7 0H288c.2 0 .5 0 .7 0l47.8 122.9c1.6 4.1 6.2 6.2 10.4 4.6s6.2-6.2 4.6-10.4l-168-432zM282.5 336H69.5L176 62.1 282.5 336zM632 160c-4.4 0-8 3.6-8 8v49.2C603.8 183 566.6 160 524 160c-64.1 0-116 51.9-116 116v88c0 64.1 51.9 116 116 116c42.6 0 79.8-23 100-57.2V472c0 4.4 3.6 8 8 8s8-3.6 8-8V364 276 168c0-4.4-3.6-8-8-8zm-8 116v88c0 55.2-44.8 100-100 100s-100-44.8-100-100V276c0-55.2 44.8-100 100-100s100 44.8 100 100z'
      
    ]
  };

  

  
  

  var faPlugCircleCheck = {
    prefix: 'fat',
    iconName: 'plug-circle-check',
    icon: [
      576,
      512,
      [],
      'e55c',
      
      'M112 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V112h16V8zM288 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V112h16V8zM8 144c-4.4 0-8 3.6-8 8s3.6 8 8 8H40v80c0 81.3 63.8 147.6 144 151.8V504c0 4.4 3.6 8 8 8s8-3.6 8-8V391.8c20-1 39-6 56.3-14c-.2-3.2-.3-6.5-.3-9.8c0-2.7 .1-5.4 .2-8.1c-19.1 10.3-41 16.1-64.2 16.1c-75.1 0-136-60.9-136-136V160H328v66c5.1-3.8 10.5-7.3 16-10.5V160h32c4.4 0 8-3.6 8-8s-3.6-8-8-8H344 328 56 40 8zm424 96a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm69.7-189.7c-3.1-3.1-8.2-3.1-11.3 0L416 396.7l-42.3-42.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l48 48c3.1 3.1 8.2 3.1 11.3 0l80-80c3.1-3.1 3.1-8.2 0-11.3z'
      
    ]
  };

  

  
  

  var faArrowLeftLong = {
    prefix: 'fat',
    iconName: 'arrow-left-long',
    icon: [
      512,
      512,
      ["long-arrow-left"],
      'f177',
      
      'M2.3 250.3c-3.1 3.1-3.1 8.2 0 11.3l152 152c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L27.3 264 504 264c4.4 0 8-3.6 8-8s-3.6-8-8-8L27.3 248 165.7 109.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-152 152z'
      
    ]
  };

  
    var faLongArrowLeft = faArrowLeftLong;
  

  
  

  var faTrashSlash = {
    prefix: 'fat',
    iconName: 'trash-slash',
    icon: [
      640,
      512,
      [],
      'e2b3',
      
      'M512 120.7c.4-4.4-2.9-8.3-7.3-8.6s-8.3 2.9-8.6 7.3L481.6 291.9l15.1 11.9L512 120.7zM467.1 463.8c-3.7 18.5-20 32.2-39.2 32.2H212.2c-20.8 0-38.1-15.9-39.9-36.7L151.9 215.1l-17.2-13.6 21.6 259.2c2.4 29 26.7 51.4 55.8 51.4H427.8c24.3 0 45.1-15.5 52.8-37.4l-13.6-10.7zM211.6 64H193l20.3 16H536c4.4 0 8-3.6 8-8s-3.6-8-8-8H428.4L400.2 18.8C392.9 7.1 380.1 0 366.3 0H273.7c-13.8 0-26.6 7.1-33.9 18.8L211.6 64zm62.2-48h92.5c8.3 0 16 4.3 20.4 11.3L409.6 64H230.4l23-36.7c4.4-7 12.1-11.3 20.4-11.3zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  

  
  

  var faChess = {
    prefix: 'fat',
    iconName: 'chess',
    icon: [
      512,
      512,
      [],
      'f439',
      
      'M128 0c4.4 0 8 3.6 8 8V32h32c4.4 0 8 3.6 8 8s-3.6 8-8 8H136V96h48c17.7 0 32 14.3 32 32v1.6c0 4.2-.8 8.4-2.5 12.3L179.3 224H192c4.4 0 8 3.6 8 8s-3.6 8-8 8H177.3l23 144H184.1l-23-144H94.9l-23 144H55.7l23-144H64c-4.4 0-8-3.6-8-8s3.6-8 8-8H76.7L42.5 141.9c-1.6-3.9-2.5-8.1-2.5-12.3V128c0-17.7 14.3-32 32-32h48V48H88c-4.4 0-8-3.6-8-8s3.6-8 8-8h32V8c0-4.4 3.6-8 8-8zm34 224l36.8-88.2c.8-2 1.2-4 1.2-6.2V128c0-8.8-7.2-16-16-16H72c-8.8 0-16 7.2-16 16v1.6c0 2.1 .4 4.2 1.2 6.2L94 224h68zM36.7 426.1c4.5-6.3 11.8-10.1 19.5-10.1H199.8c7.8 0 15 3.7 19.5 10.1l32.2 45.1c2.9 4.1 4.5 8.9 4.5 13.9V488c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24v-2.9c0-5 1.6-9.9 4.5-13.9l32.2-45.1zM56.2 432c-2.6 0-5 1.2-6.5 3.4L17.5 480.5c-1 1.4-1.5 3-1.5 4.6V488c0 4.4 3.6 8 8 8H232c4.4 0 8-3.6 8-8v-2.9c0-1.7-.5-3.3-1.5-4.6l-32.2-45.1c-1.5-2.1-3.9-3.4-6.5-3.4H56.2zM296 200c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v16c0 4.4 3.6 8 8 8s8-3.6 8-8V200c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v16c0 4.4 3.6 8 8 8s8-3.6 8-8V200c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v81.4c0 6.4-2.5 12.5-7 17L466.3 329c-1.5 1.5-2.3 3.5-2.3 5.7V384H448V334.6c0-6.4 2.5-12.5 7-17L485.7 287c1.5-1.5 2.3-3.5 2.3-5.7V208H464v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H384v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H312v73.4c0 2.1 .8 4.2 2.3 5.7L345 317.7c4.5 4.5 7 10.6 7 17V384H336V334.6c0-2.1-.8-4.2-2.3-5.7L303 298.3c-4.5-4.5-7-10.6-7-17V200zm28.7 226.1c4.5-6.3 11.8-10.1 19.5-10.1H455.8c7.8 0 15 3.7 19.5 10.1l32.2 45.1c2.9 4.1 4.5 8.9 4.5 13.9V488c0 13.3-10.7 24-24 24H312c-13.3 0-24-10.7-24-24v-2.9c0-5 1.6-9.9 4.5-13.9l32.2-45.1zm19.5 5.9c-2.6 0-5 1.2-6.5 3.4l-32.2 45.1c-1 1.4-1.5 3-1.5 4.6V488c0 4.4 3.6 8 8 8H488c4.4 0 8-3.6 8-8v-2.9c0-1.7-.5-3.3-1.5-4.6l-32.2-45.1c-1.5-2.1-3.9-3.4-6.5-3.4H344.2z'
      
    ]
  };

  

  
  

  var faGif = {
    prefix: 'fat',
    iconName: 'gif',
    icon: [
      576,
      512,
      [],
      'e190',
      
      'M512 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM296 160c-4.4 0-8 3.6-8 8V344c0 4.4 3.6 8 8 8s8-3.6 8-8V168c0-4.4-3.6-8-8-8zm72 8v96 80c0 4.4 3.6 8 8 8s8-3.6 8-8V272h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H384V176h96c4.4 0 8-3.6 8-8s-3.6-8-8-8H376c-4.4 0-8 3.6-8 8zM96 256c0-44.2 35.8-80 80-80c19.3 0 37.1 6.9 50.9 18.3c3.4 2.8 8.4 2.3 11.3-1.1s2.3-8.4-1.1-11.3C220.5 168.2 199.2 160 176 160c-53 0-96 43-96 96s43 96 96 96c23.2 0 44.5-8.2 61.1-21.9c1.8-1.5 2.9-3.8 2.9-6.2V256c0-4.4-3.6-8-8-8H160c-4.4 0-8 3.6-8 8s3.6 8 8 8h64v56c-13.4 10-30 16-48 16c-44.2 0-80-35.8-80-80z'
      
    ]
  };

  

  
  

  var faRightToLine = {
    prefix: 'fat',
    iconName: 'right-to-line',
    icon: [
      448,
      512,
      ["arrow-alt-to-right"],
      'f34c',
      
      'M432 72l0 368c0 4.4 3.6 8 8 8s8-3.6 8-8l0-368c0-4.4-3.6-8-8-8s-8 3.6-8 8zM332.7 248c2.1 2.1 3.3 5 3.3 8s-1.2 5.9-3.3 8L200.6 395.8c-2.7 2.7-6.4 4.2-10.2 4.2c-8 0-14.4-6.5-14.4-14.4l0-73.6c0-4.4-3.6-8-8-8L32 304c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16l136 0c4.4 0 8-3.6 8-8l0-73.6c0-8 6.5-14.4 14.4-14.4c3.8 0 7.5 1.5 10.2 4.2L332.7 248zm19.3 8c0-7.2-2.9-14.2-8-19.3L211.9 104.9c-5.7-5.7-13.4-8.9-21.5-8.9c-16.8 0-30.4 13.6-30.4 30.4l0 65.6L32 192c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l128 0 0 65.6c0 16.8 13.6 30.4 30.4 30.4c8.1 0 15.8-3.2 21.5-8.9L344 275.3c5.1-5.1 8-12.1 8-19.3z'
      
    ]
  };

  
    var faArrowAltToRight = faRightToLine;
  

  
  

  var faFireFlame = {
    prefix: 'fat',
    iconName: 'fire-flame',
    icon: [
      384,
      512,
      ["flame"],
      'f6df',
      
      'M209.1 8.5c72.9 68 128.7 152.4 162.7 246.1l.7 1.9c7.6 20.9 11.5 42.9 11.5 65.1C384 426.7 297.2 512 192 512S0 426.7 0 321.6c0-22.2 3.9-44.2 11.5-65.1l.7-1.9C46.2 160.8 102 76.5 174.9 8.5l3.3-3C181.9 2 186.9 0 192 0s10.1 2 13.8 5.5l3.3 3zM356.8 260C323.6 168.7 269.2 86.5 198.2 20.2l-3.3-3c-.8-.7-1.8-1.2-2.9-1.2s-2.1 .4-2.9 1.2l-3.3 3C114.8 86.5 60.4 168.7 27.2 260l-.7 1.9C19.6 281 16 301.2 16 321.6C16 417.7 95.5 496 192 496s176-78.3 176-174.4c0-20.3-3.6-40.5-10.5-59.6l-.7-1.9zM187.4 206v.6c0 16.1 6.3 31.6 17.5 43.3l8.2 8.5c9.9 10.3 15.5 24.1 15.5 38.4c0 30.5-24.7 55.3-55.3 55.3h-2.5c-31.9 0-57.7-25.8-57.7-57.7V272.1c-11 12.2-17.1 28.1-17.1 44.7V320c0 53 43 96 96 96h7.3c49 0 88.7-39.7 88.7-88.7c0-27.9-12.2-54.3-33.4-72.4l-44.6-38.1c-9.7-8.3-16.4-19.6-19-31.9c-2.4 6.8-3.6 13.9-3.6 21.1zm-8.6-33.5l10.9-23.6c1.4-3 4.3-4.9 7.6-4.9c4.6 0 8.4 3.7 8.4 8.4v20.2c0 12.3 5.4 24 14.7 32L265 242.7c24.7 21.1 39 52 39 84.6C304 385.1 257.1 432 199.3 432H192c-61.9 0-112-50.1-112-112v-3.2c0-23.4 9.9-45.8 27.3-61.5l5.3-4.8c1.8-1.6 4.2-2.6 6.6-2.6c5.5 0 9.9 4.4 9.9 9.9v36.4c0 23 18.7 41.7 41.7 41.7h2.5c21.7 0 39.3-17.6 39.3-39.3c0-10.2-3.9-19.9-11-27.3l-8.2-8.5c-14.1-14.6-21.9-34.1-21.9-54.4V206c0-11.6 2.5-23 7.4-33.5z'
      
    ]
  };

  
    var faFlame = faFireFlame;
  

  
  

  var faMinus = {
    prefix: 'fat',
    iconName: 'minus',
    icon: [
      448,
      512,
      [8211,8722,10134,"subtract"],
      'f068',
      
      'M424 256c0 4.4-3.6 8-8 8L32 264c-4.4 0-8-3.6-8-8s3.6-8 8-8l384 0c4.4 0 8 3.6 8 8z'
      
    ]
  };

  
    var faSubtract = faMinus;
  

  
  

  var faCircle5 = {
    prefix: 'fat',
    iconName: 'circle-5',
    icon: [
      512,
      512,
      [],
      'e0f2',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM200 128c-3.7 0-7 2.6-7.8 6.2l-24 104c-.5 2.3 0 4.6 1.3 6.5s3.5 3.1 5.8 3.3l110.7 10.1c28.4 2.6 50.1 26.4 50.1 54.9c0 30.4-24.7 55.1-55.1 55.1H227.9c-21.3 0-41.3-10.7-53.2-28.5l-13.3 8.9c14.8 22.1 39.8 35.5 66.5 35.5h53.1c39.3 0 71.1-31.8 71.1-71.1c0-36.8-28-67.4-64.6-70.8l-101.5-9.3L206.4 144H328c4.4 0 8-3.6 8-8s-3.6-8-8-8H200z'
      
    ]
  };

  

  
  

  var faCircleSterling = {
    prefix: 'fat',
    iconName: 'circle-sterling',
    icon: [
      512,
      512,
      [],
      'e5cf',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM267.6 136c-24.7 0-44.6 20.1-44.4 44.7l.4 59.3H280c4.4 0 8 3.6 8 8s-3.6 8-8 8H223.6l0 2.7c.2 34.6-12.8 68-36.2 93.3H344c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-3.3 0-6.2-2-7.4-5s-.5-6.5 1.8-8.7l8.8-8.6c23.4-22.8 36.6-54.1 36.4-86.8l0-2.8H168c-4.4 0-8-3.6-8-8s3.6-8 8-8h39.5l-.4-59.2c-.2-33.5 26.9-60.8 60.4-60.8c9.4 0 18.6 2.2 27 6.4l20.9 10.5c4 2 5.6 6.8 3.6 10.7s-6.8 5.6-10.7 3.6l-20.9-10.5c-6.2-3.1-13-4.7-19.9-4.7z'
      
    ]
  };

  

  
  

  var faBracketRoundRight = {
    prefix: 'fat',
    iconName: 'bracket-round-right',
    icon: [
      192,
      512,
      [],
      '29',
      
      'M32.8 36.4c-2 4-.4 8.8 3.6 10.7c23.1 11.5 58.2 36.1 87.4 71.7C153 154.5 176 200.7 176 256s-23 101.5-52.2 137.1c-29.2 35.7-64.3 60.2-87.4 71.7c-4 2-5.6 6.8-3.6 10.7s6.8 5.6 10.7 3.6c24.9-12.5 61.8-38.3 92.6-75.9C167 365.7 192 315.9 192 256s-25-109.7-55.8-147.3C105.4 71.2 68.5 45.3 43.6 32.8c-4-2-8.8-.4-10.7 3.6z'
      
    ]
  };

  

  
  

  var faVirusSlash = {
    prefix: 'fat',
    iconName: 'virus-slash',
    icon: [
      640,
      512,
      [],
      'e075',
      
      'M386 399.9c-27.7 9-50 34.2-50 68.6V480c0 8.8-7.2 16-16 16s-16-7.2-16-16V468.5c0-64.1-77.6-96.3-122.9-50.9l-8.2 8.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l8.2-8.2C203.8 349.6 171.7 272 107.5 272H96c-8.8 0-16-7.2-16-16s7.2-16 16-16h11.5c20.6 0 37.8-8 50.3-20.3l-12.7-10c-9.6 8.7-22.4 14.3-37.6 14.3H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h11.5c49.9 0 74.9 60.3 39.6 95.6l-8.2 8.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V468.5c0-31.3 23.8-52.9 50.3-55.8L386 399.9zM288 43.5c0 31.3-23.8 52.9-50.3 55.8L254 112.1c27.7-9 50-34.2 50-68.6V32c0-8.8 7.2-16 16-16s16 7.2 16 16V43.5c0 64.1 77.6 96.3 122.9 50.9l8.2-8.2c6.2-6.2 16.4-6.2 22.6 0L501 75 489.7 86.3c6.2 6.2 6.2 16.4 0 22.6l-8.2 8.2C436.2 162.4 468.3 240 532.5 240H544c8.8 0 16 7.2 16 16s-7.2 16-16 16H532.5c-20.6 0-37.8 8-50.3 20.3l12.7 10c9.6-8.7 22.4-14.3 37.6-14.3H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H532.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C412.3 118.4 352 93.4 352 43.5V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43.5zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  

  
  

  var faDna = {
    prefix: 'fat',
    iconName: 'dna',
    icon: [
      448,
      512,
      [129516],
      'f471',
      
      'M408 0c4.4 0 8 3.6 8 8c0 60.3-24.1 107.6-59.5 147.9c-35.1 40-81.7 73.5-127.4 106.3l-.4 .3C188.5 291.4 149 319.8 117.2 352H330.8c-21.7-22-47-42.2-73.7-62.1l2.6-1.9 0 0 0 0c3.7-2.6 7.4-5.3 11-7.9c31.4 23.5 61.4 48.2 85.8 76C391.9 396.4 416 443.7 416 504c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-14.1-1.4-27.4-4.1-40H52.1c-2.7 12.6-4.1 25.9-4.1 40c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-60.3 24.1-107.6 59.5-147.9c32.9-37.4 75.9-69.2 118.8-100.1c-42.9-30.9-85.9-62.7-118.8-100.1C56.1 115.6 32 68.3 32 8c0-4.4 3.6-8 8-8s8 3.6 8 8c0 14.1 1.4 27.4 4.1 40H395.9c2.6-12.6 4.1-25.9 4.1-40c0-4.4 3.6-8 8-8zM391.8 64H56.2c9.1 29.9 25.4 56.1 46.3 80.1c.5-.1 1-.1 1.5-.1H344c.5 0 1 0 1.5 .1c20.9-24 37.2-50.2 46.3-80.1zm-61 96H117.2c30.6 31 68.2 58.4 106.8 86.1c38.6-27.7 76.2-55.2 106.8-86.1zM56.2 448H391.8c-9.1-29.9-25.4-56.1-46.3-80.1c-.5 .1-1 .1-1.5 .1H104c-.5 0-1 0-1.5-.1c-20.9 24-37.2 50.2-46.3 80.1z'
      
    ]
  };

  

  
  

  var faTurnLeftUp = {
    prefix: 'fat',
    iconName: 'turn-left-up',
    icon: [
      384,
      512,
      [],
      'e638',
      
      'M208 176h89.1c3.8 0 6.9-3.1 6.9-6.9c0-1.8-.7-3.5-1.9-4.7L161.9 16.8c-.5-.5-1.2-.8-1.9-.8s-1.4 .3-1.9 .8L17.9 164.4c-1.2 1.3-1.9 3-1.9 4.7c0 3.8 3.1 6.9 6.9 6.9H112c8.8 0 16 7.2 16 16V400c0 53 43 96 96 96h88c13.3 0 24-10.7 24-24V456c0-13.3-10.7-24-24-24l-88 0c-17.7 0-32-14.3-32-32V192c0-8.8 7.2-16 16-16zM173.5 5.8L313.7 153.4c4 4.3 6.3 9.9 6.3 15.8c0 12.6-10.2 22.9-22.9 22.9H224 208v16V400c0 8.8 7.2 16 16 16l88 0c22.1 0 40 17.9 40 40v16c0 22.1-17.9 40-40 40H224c-61.9 0-112-50.1-112-112V208 192H96 22.9C10.2 192 0 181.8 0 169.1c0-5.9 2.3-11.5 6.3-15.8L146.5 5.8C150 2.1 154.9 0 160 0s10 2.1 13.5 5.8z'
      
    ]
  };

  

  
  

  var faCloudBoltMoon = {
    prefix: 'fat',
    iconName: 'cloud-bolt-moon',
    icon: [
      576,
      512,
      ["thunderstorm-moon"],
      'f76d',
      
      'M374.9 89.4C390.8 46.5 432.4 16 481.2 16c3.2 0 6.4 .1 9.6 .4c-31.7 17.8-53.1 51.4-53.1 90.1c0 57.1 46.7 103.4 104.4 103.4c6.1 0 12.1-.5 17.9-1.5c-20.4 19.6-48.2 31.7-78.8 31.7c-2 0-4-.1-5.9-.2c1.6 5.2 2.7 10.6 3.5 16.1c.8 0 1.6 0 2.4 0c34.9 0 66.7-13.8 89.9-36.1c5.1-4.9 6.4-12.5 3.2-18.7s-10.1-9.7-17-8.6c-4.9 .8-10 1.3-15.2 1.3c-49 0-88.4-39.3-88.4-87.4c0-32.6 18-61.1 44.9-76.1c6.1-3.4 9.3-10.5 7.8-17.4s-7.3-12-14.3-12.6c-3.6-.3-7.3-.5-10.9-.5C427.1 0 380.6 33 361.4 79.9c4.7 2.8 9.2 6 13.5 9.5zM96 160c0-44.2 35.8-80 80-80c32 0 59.6 18.8 72.4 46c1.1 2.3 3.2 3.9 5.7 4.4s5.1-.2 6.9-1.9c11.4-10.3 26.4-16.5 42.9-16.5c35.3 0 64 28.7 64 64c0 7.5-1.3 14.7-3.7 21.4c-.8 2.4-.5 5 .9 7.1s3.7 3.4 6.2 3.5c33.7 1.8 60.5 29.7 60.5 63.9c0 35.3-28.7 64-64 64c-.7 0-1.5 0-2.2 0l0 0h-.3H339.7c4.1 4.6 7.4 10 9.5 16h16.1c.9 0 1.8 0 2.6 0c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C241.4 82.6 210.8 64 176 64c-53 0-96 43-96 96l0 1.3C34.6 168.9 0 208.4 0 256c0 43.4 28.8 80.1 68.4 92c2.4-5.1 5.6-9.9 9.8-14C42.6 325.8 16 294 16 256c0-41.8 32.1-76.2 73.1-79.7c2.1-.2 4.1-1.2 5.5-2.8s2-3.8 1.8-5.9c-.2-2.5-.4-5-.4-7.6zM219.6 344.8c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6H304L144 496l52.4-104.8c2.5-5 2.2-10.8-.7-15.6s-8.1-7.6-13.6-7.6H112L272 240 219.6 344.8zm66.7-97.7c3.4-6.7 1.6-14.9-4.3-19.6s-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7h52.2 17.9l-8 16-44.4 88.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7H251.8 233.9l8-16 44.4-88.8z'
      
    ]
  };

  
    var faThunderstormMoon = faCloudBoltMoon;
  

  
  

  var faCircleUpRight = {
    prefix: 'fat',
    iconName: 'circle-up-right',
    icon: [
      512,
      512,
      [],
      'e129',
      
      'M256 496a240 240 0 1 0 0-480 240 240 0 1 0 0 480zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm96 168c0-4.4-3.6-8-8-8H217c-5 0-9 4-9 9c0 2.4 .9 4.7 2.6 6.3l35 35c3.1 3.1 3.1 8.2 0 11.3L163.3 304c-2.1 2.1-3.3 5-3.3 8s1.2 5.9 3.3 8L192 348.7c2.1 2.1 5 3.3 8 3.3s5.9-1.2 8-3.3l82.3-82.3c3.1-3.1 8.2-3.1 11.3 0l35 35c1.7 1.7 4 2.6 6.3 2.6c5 0 9-4 9-9V168zm-8-24c13.3 0 24 10.7 24 24V295c0 13.8-11.2 25-25 25c-6.6 0-13-2.6-17.7-7.3L296 283.3 219.3 360c-5.1 5.1-12.1 8-19.3 8s-14.2-2.9-19.3-8L152 331.3c-5.1-5.1-8-12.1-8-19.3s2.9-14.2 8-19.3L228.7 216l-29.4-29.4c-4.7-4.7-7.3-11-7.3-17.7c0-13.8 11.2-25 25-25H344z'
      
    ]
  };

  

  
  

  var faKeyboardDown = {
    prefix: 'fat',
    iconName: 'keyboard-down',
    icon: [
      576,
      512,
      [],
      'e1c2',
      
      'M64 16C37.5 16 16 37.5 16 64V224c0 26.5 21.5 48 48 48H512c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H64zM0 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V224c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM88 176c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8H88zm-24 8c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V184zM200 80H184c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V88c0-4.4-3.6-8-8-8zM184 64h16c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H184c-13.3 0-24-10.7-24-24V88c0-13.3 10.7-24 24-24zm0 112c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8H392c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8H184zm-24 8c0-13.3 10.7-24 24-24H392c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H184c-13.3 0-24-10.7-24-24V184zm328-8H472c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8zm-16-16h16c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H472c-13.3 0-24-10.7-24-24V184c0-13.3 10.7-24 24-24zM88 80c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V88c0-4.4-3.6-8-8-8H88zM64 88c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V88zm232-8H280c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V88c0-4.4-3.6-8-8-8zM280 64h16c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H280c-13.3 0-24-10.7-24-24V88c0-13.3 10.7-24 24-24zm96 16c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V88c0-4.4-3.6-8-8-8H376zm-24 8c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H376c-13.3 0-24-10.7-24-24V88zm136-8H472c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V88c0-4.4-3.6-8-8-8zM472 64h16c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H472c-13.3 0-24-10.7-24-24V88c0-13.3 10.7-24 24-24zM149.7 354.3L288 492.7 426.3 354.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-144 144c-3.1 3.1-8.2 3.1-11.3 0l-144-144c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0z'
      
    ]
  };

  

  
  

  var faLeftLong = {
    prefix: 'fat',
    iconName: 'left-long',
    icon: [
      512,
      512,
      ["long-arrow-alt-left"],
      'f30a',
      
      'M176 312l0 81.1c0 3.8-3.1 6.9-6.9 6.9c-1.8 0-3.5-.7-4.7-1.9L16.8 257.9c-.5-.5-.8-1.2-.8-1.9s.3-1.4 .8-1.9L164.4 113.9c1.3-1.2 3-1.9 4.7-1.9c3.8 0 6.9 3.1 6.9 6.9l0 81.1c0 8.8 7.2 16 16 16l280 0c13.3 0 24 10.7 24 24l0 32c0 13.3-10.7 24-24 24l-280 0c-8.8 0-16 7.2-16 16zM5.8 269.5L153.4 409.7c4.3 4 9.9 6.3 15.8 6.3c12.6 0 22.9-10.2 22.9-22.9l0-65.1 0-16 16 0 264 0c22.1 0 40-17.9 40-40l0-32c0-22.1-17.9-40-40-40l-264 0-16 0 0-16 0-65.1c0-12.6-10.2-22.9-22.9-22.9c-5.9 0-11.5 2.3-15.8 6.3L5.8 242.5C2.1 246 0 250.9 0 256s2.1 10 5.8 13.5z'
      
    ]
  };

  
    var faLongArrowAltLeft = faLeftLong;
  

  
  

  var faMoneyBill1 = {
    prefix: 'fat',
    iconName: 'money-bill-1',
    icon: [
      576,
      512,
      ["money-bill-alt"],
      'f3d1',
      
      'M512 80c26.5 0 48 21.5 48 48V384c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V128c0-26.5 21.5-48 48-48H512zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zM544 176c0-4.4-3.6-8-8-8h-8c-30.9 0-56-25.1-56-56v-8c0-4.4-3.6-8-8-8s-8 3.6-8 8v8c0 39.8 32.2 72 72 72h8c4.4 0 8-3.6 8-8zM40 184h8c39.8 0 72-32.2 72-72v-8c0-4.4-3.6-8-8-8s-8 3.6-8 8v8c0 30.9-25.1 56-56 56H40c-4.4 0-8 3.6-8 8s3.6 8 8 8zM544 336c0-4.4-3.6-8-8-8h-8c-39.8 0-72 32.2-72 72v8c0 4.4 3.6 8 8 8s8-3.6 8-8v-8c0-30.9 25.1-56 56-56h8c4.4 0 8-3.6 8-8zM40 328c-4.4 0-8 3.6-8 8s3.6 8 8 8h8c30.9 0 56 25.1 56 56v8c0 4.4 3.6 8 8 8s8-3.6 8-8v-8c0-39.8-32.2-72-72-72H40zM288 144a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 240a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM272 200c-4.4 0-8 3.6-8 8s3.6 8 8 8h8v80H264c-4.4 0-8 3.6-8 8s3.6 8 8 8h24 24c4.4 0 8-3.6 8-8s-3.6-8-8-8H296V208c0-4.4-3.6-8-8-8H272z'
      
    ]
  };

  
    var faMoneyBillAlt = faMoneyBill1;
  

  
  

  var faCropSimple = {
    prefix: 'fat',
    iconName: 'crop-simple',
    icon: [
      512,
      512,
      ["crop-alt"],
      'f565',
      
      'M112 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V96H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H96V376c0 22.1 17.9 40 40 40H352V400H136c-13.3 0-24-10.7-24-24V8zM400 504c0 4.4 3.6 8 8 8s8-3.6 8-8V416h88c4.4 0 8-3.6 8-8s-3.6-8-8-8H416l0-264c0-22.1-17.9-40-40-40L160 96v16l216 0c13.3 0 24 10.7 24 24l0 368z'
      
    ]
  };

  
    var faCropAlt = faCropSimple;
  

  
  

  var faIndianRupeeSign = {
    prefix: 'fat',
    iconName: 'indian-rupee-sign',
    icon: [
      320,
      512,
      ["indian-rupee","inr"],
      'e1bc',
      
      'M0 40c0-4.4 3.6-8 8-8H112c2.2 0 4.3 0 6.5 .1c.5-.1 1-.1 1.5-.1H312c4.4 0 8 3.6 8 8s-3.6 8-8 8H178c44.1 22.8 74.9 67.7 77.7 120H312c4.4 0 8 3.6 8 8s-3.6 8-8 8H255.8c-4.2 75.8-66.9 136-143.8 136H34.4l218 145.3c3.7 2.5 4.7 7.4 2.2 11.1s-7.4 4.7-11.1 2.2l-240-160c-2.9-2-4.2-5.6-3.2-9s4.1-5.7 7.7-5.7H112c68 0 123.6-53 127.8-120H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H239.8C235.6 101 180 48 112 48H8c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  
    var faIndianRupee = faIndianRupeeSign;
  
    var faInr = faIndianRupeeSign;
  

  
  

  var faListTimeline = {
    prefix: 'fat',
    iconName: 'list-timeline',
    icon: [
      512,
      512,
      [],
      'e1d1',
      
      'M158.6 96l43.3 43.3c3 3 7.1 4.7 11.3 4.7H416c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H213.3c-4.2 0-8.3 1.7-11.3 4.7L158.6 96zm32-54.6c6-6 14.1-9.4 22.6-9.4H416c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H213.3c-8.5 0-16.6-3.4-22.6-9.4l-43.3-43.3c-6.2-6.2-6.2-16.4 0-22.6l43.3-43.3zM96 96A32 32 0 1 0 32 96a32 32 0 1 0 64 0zM16 96a48 48 0 1 1 96 0A48 48 0 1 1 16 96zM96 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM64 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 80a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm94.6-48l43.3 43.3c3 3 7.1 4.7 11.3 4.7H416c8.8 0 16-7.2 16-16V384c0-8.8-7.2-16-16-16H213.3c-4.2 0-8.3 1.7-11.3 4.7L158.6 416zm32-54.6c6-6 14.1-9.4 22.6-9.4H416c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H213.3c-8.5 0-16.6-3.4-22.6-9.4l-43.3-43.3c-6.2-6.2-6.2-16.4 0-22.6l43.3-43.3zm11.3-148.7L158.6 256l43.3 43.3c3 3 7.1 4.7 11.3 4.7H480c8.8 0 16-7.2 16-16V224c0-8.8-7.2-16-16-16H213.3c-4.2 0-8.3 1.7-11.3 4.7zm-54.6 32l43.3-43.3c6-6 14.1-9.4 22.6-9.4H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H213.3c-8.5 0-16.6-3.4-22.6-9.4l-43.3-43.3c-6.2-6.2-6.2-16.4 0-22.6z'
      
    ]
  };

  

  
  

  var faMoneyBillsSimple = {
    prefix: 'fat',
    iconName: 'money-bills-simple',
    icon: [
      640,
      512,
      ["money-bills-alt"],
      'e1f4',
      
      'M576 48c26.5 0 48 21.5 48 48V320c0 26.5-21.5 48-48 48H160c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H576zM160 32c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zM64 128c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H480c35.3 0 64-28.7 64-64H528c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V192c0-26.5 21.5-48 48-48V128zm224 80a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm176 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z'
      
    ]
  };

  
    var faMoneyBillsAlt = faMoneyBillsSimple;
  

  
  

  var faBadgeDollar = {
    prefix: 'fat',
    iconName: 'badge-dollar',
    icon: [
      512,
      512,
      [],
      'f645',
      
      'M180.8 61.2C195.1 34.3 223.4 16 256 16s60.9 18.3 75.2 45.2c1.8 3.4 5.7 5 9.4 3.9c29.1-8.9 62.1-1.9 85.1 21.1s30.1 56 21.1 85.1c-1.1 3.7 .5 7.6 3.9 9.4C477.7 195.1 496 223.4 496 256s-18.3 60.9-45.2 75.2c-3.4 1.8-5 5.8-3.9 9.4c8.9 29.1 1.9 62.1-21.1 85.1s-56 30.1-85.1 21.1c-3.7-1.1-7.6 .5-9.4 3.9C316.9 477.7 288.6 496 256 496s-60.9-18.3-75.2-45.2c-1.8-3.4-5.7-5-9.4-3.9c-29.1 8.9-62.1 1.9-85.1-21.1s-30.1-56-21.1-85.1c1.1-3.7-.5-7.6-3.9-9.4C34.3 316.9 16 288.6 16 256s18.3-60.9 45.2-75.2c3.4-1.8 5-5.7 3.9-9.4c-8.9-29.1-1.9-62.1 21.1-85.1s56-30.1 85.1-21.1c3.7 1.1 7.6-.5 9.4-3.9zM256 0c-36.4 0-68.3 19.3-86.1 48.2c-33-7.9-69.2 1.1-94.9 26.8s-34.7 61.9-26.8 94.9C19.3 187.7 0 219.6 0 256s19.3 68.3 48.2 86.1c-7.9 33 1.1 69.2 26.8 94.9s61.9 34.7 94.9 26.8C187.7 492.7 219.6 512 256 512s68.3-19.3 86.1-48.2c33 7.9 69.2-1.1 94.9-26.8s34.7-61.9 26.8-94.9C492.7 324.3 512 292.4 512 256s-19.3-68.3-48.2-86.1c7.9-33-1.1-69.2-26.8-94.9s-62-34.7-94.9-26.8C324.3 19.3 292.4 0 256 0zm8.9 149.3c0-4.4-3.6-8-8-8s-8 3.6-8 8v19.1c-9.6 .7-18.4 2.8-26.1 6.3c-13.6 6.1-23.9 16.8-26.4 31.4c-1.5 8.9-.6 16.8 2.6 23.7c3.2 6.8 8.4 12 14.4 16c11 7.5 26 12 39.6 16.1l1.8 .5c14.9 4.5 27.9 8.6 36.8 15.1c4.2 3.1 7.2 6.5 8.8 10.3c1.7 3.8 2.4 8.8 1.2 15.5c-1.6 9.4-7.6 16.2-17.3 20.4c-10 4.3-23.8 5.6-39.8 3.1c-8-1.3-21.6-5.9-32.1-9.5l0 0c-2.3-.8-4.4-1.5-6.3-2.1c-4.2-1.4-8.7 .9-10.1 5.1s.9 8.7 5.1 10.1c1.6 .5 3.5 1.2 5.6 1.9l0 0 0 0c10.4 3.6 25.9 8.8 35.4 10.4l0 0c2.3 .4 4.6 .7 6.8 .9v19.2c0 4.4 3.6 8 8 8s8-3.6 8-8V343.9c9.4-.5 18.2-2.3 25.8-5.5c13.8-5.9 24-16.8 26.7-32.4c1.6-9.3 .8-17.5-2.3-24.6c-3.1-7.1-8.2-12.6-14.1-16.9c-11.5-8.3-27.4-13.2-41.6-17.5l-.4-.1c-14.8-4.5-27.8-8.4-36.7-14.4c-4.3-2.9-7.2-6.1-8.9-9.6c-1.6-3.4-2.4-7.9-1.3-14.1c1.4-8 7.2-14.9 17.3-19.5c10.1-4.6 24.1-6.4 39.9-4c5.1 .8 20.6 3.8 25.6 5.1c4.3 1.1 8.7-1.4 9.8-5.7s-1.4-8.7-5.7-9.8c-5.7-1.5-21.9-4.6-27.2-5.5c-2.3-.4-4.6-.6-6.8-.9V149.3z'
      
    ]
  };

  

  
  

  var faBallPile = {
    prefix: 'fat',
    iconName: 'ball-pile',
    icon: [
      576,
      512,
      [],
      'f77e',
      
      'M368 96A80 80 0 1 0 208 96a80 80 0 1 0 160 0zm-51.4 91.7c-9 2.8-18.6 4.3-28.6 4.3s-19.5-1.5-28.6-4.3C277.1 205.1 288 229.3 288 256s-10.9 50.9-28.6 68.3c9-2.8 18.6-4.3 28.6-4.3s19.5 1.5 28.6 4.3C298.9 306.9 288 282.7 288 256s10.9-50.9 28.6-68.3zM384 352c-9.9 0-19.5-1.5-28.6-4.3C373.1 365.1 384 389.3 384 416c0 53-43 96-96 96s-96-43-96-96c0-26.7 10.9-50.9 28.6-68.3c-9 2.8-18.6 4.3-28.6 4.3s-19.5-1.5-28.6-4.3C181.1 365.1 192 389.3 192 416c0 53-43 96-96 96s-96-43-96-96s43-96 96-96c9.9 0 19.5 1.5 28.6 4.3C106.9 306.9 96 282.7 96 256c0-53 43-96 96-96c9.9 0 19.5 1.5 28.6 4.3C202.9 146.9 192 122.7 192 96c0-53 43-96 96-96s96 43 96 96c0 26.7-10.9 50.9-28.6 68.3c9-2.8 18.6-4.3 28.6-4.3c53 0 96 43 96 96c0 26.7-10.9 50.9-28.6 68.3c9-2.8 18.6-4.3 28.6-4.3c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96c0-26.7 10.9-50.9 28.6-68.3c-9 2.8-18.6 4.3-28.6 4.3zM272 256a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM176 416A80 80 0 1 0 16 416a80 80 0 1 0 160 0zm208-80a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM288 496a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm272-80a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z'
      
    ]
  };

  

  
  

  var faFaceSmileUpsideDown = {
    prefix: 'fat',
    iconName: 'face-smile-upside-down',
    icon: [
      512,
      512,
      [],
      'e395',
      
      'M16 256a240 240 0 1 1 480 0A240 240 0 1 1 16 256zm496 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM150.6 188.6C171.4 158.8 206.6 128 256 128s84.6 30.8 105.4 60.6c2.5 3.6 7.5 4.5 11.1 2s4.5-7.5 2-11.1C352.1 147.4 312.7 112 256 112s-96.1 35.4-118.6 67.4c-2.5 3.6-1.7 8.6 2 11.1s8.6 1.7 11.1-2zM192.4 304a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm144-16a16 16 0 1 0 0 32 16 16 0 1 0 0-32z'
      
    ]
  };

  

  
  

  var faChartGantt = {
    prefix: 'fat',
    iconName: 'chart-gantt',
    icon: [
      512,
      512,
      [],
      'e0e4',
      
      'M16 40c0-4.4-3.6-8-8-8s-8 3.6-8 8V408c0 39.8 32.2 72 72 72H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H72c-30.9 0-56-25.1-56-56V40zM144 144c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zm64 96c0-8.8 7.2-16 16-16H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H224c-8.8 0-16-7.2-16-16zm128 96c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H352c-8.8 0-16-7.2-16-16zM160 112c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0zm64 96c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H224zm128 96c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H352z'
      
    ]
  };

  

  
  

  var faTrainSubway = {
    prefix: 'fat',
    iconName: 'train-subway',
    icon: [
      448,
      512,
      ["subway"],
      'f239',
      
      'M352 16c44.2 0 80 35.8 80 80V352c0 44.2-35.8 80-80 80H96c-44.2 0-80-35.8-80-80V96c0-44.2 35.8-80 80-80H352zM96 0C43 0 0 43 0 96V352c0 49.4 37.3 90.1 85.3 95.4L34.3 498.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L107.3 448H340.7l61.7 61.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-50.9-50.9c48-5.3 85.3-46 85.3-95.4V96c0-53-43-96-96-96H96zM216 80l0 160H96c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H216zm16 0H352c8.8 0 16 7.2 16 16V224c0 8.8-7.2 16-16 16H232l0-160zM96 64C78.3 64 64 78.3 64 96V224c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H96zm0 272a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm192-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  
    var faSubway = faTrainSubway;
  

  
  

  var faGameConsoleHandheldCrank = {
    prefix: 'fat',
    iconName: 'game-console-handheld-crank',
    icon: [
      576,
      512,
      [],
      'e5b9',
      
      'M384 48H64C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V280 96c0-26.5-21.5-48-48-48zm64 48V272h32V200 152c0-13.3 10.7-24 24-24h47.9c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H496v72c0 4.4-3.6 8-8 8H448V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64zm-96 16H96c-8.8 0-16 7.2-16 16V240c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16zM96 96H352c17.7 0 32 14.3 32 32V240c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32zm24 232v32h32c4.4 0 8 3.6 8 8s-3.6 8-8 8H120v32c0 4.4-3.6 8-8 8s-8-3.6-8-8V376H72c-4.4 0-8-3.6-8-8s3.6-8 8-8h32V328c0-4.4 3.6-8 8-8s8 3.6 8 8zm120 8a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm32 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM504 144c-4.4 0-8 3.6-8 8v40h55.9c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8H504z'
      
    ]
  };

  

  
  

  var faSportsball = {
    prefix: 'fat',
    iconName: 'sportsball',
    icon: [
      512,
      512,
      [],
      'e44b',
      
      'M266.8 37.6c53.1-10.3 116.6-10.6 192 2c.6 .1 1.2 .2 1.8 .4L331.1 169.6c-33.5-35.7-56.5-81.3-64.2-132zm-1.9-15.9s0 0 0 0c-5.3 1-10.6 2.1-15.8 3.4c0 0 0 0 0 0c-14.1 3.3-27.5 7.4-40.3 12.1C169 52 136.3 73.2 110 98.6l0 0c-3.9 3.7-7.6 7.6-11.2 11.5l0 0C86.3 123.7 75.4 138.3 66 153.6c-18.4 29.9-31 62.5-39.2 95.7c0 0 0 0 0 0c-1.3 5.2-2.5 10.5-3.6 15.7c0 0 0 0 0 0c-14.6 70.8-10.1 143.1 1.2 198c.7 3.4 1.9 6.6 3.6 9.5l0 0c1.9 3.3 4.4 6.2 7.3 8.6c.7 .5 1.3 1.1 2 1.6c3.8 2.7 8.3 4.6 13.1 5.4c103.9 17.4 187 11 252.6-13.3c66-24.5 112.2-66.5 142.9-116.5c60.2-98.2 59.1-224.7 41.6-309.5c-1.5-7.3-5.4-13.6-10.9-18.2c-.7-.6-1.4-1.1-2.2-1.6c-.6-.4-1.2-.8-1.8-1.1l0 0c-3.4-2-7.2-3.5-11.2-4.1c-76.3-12.7-141.4-12.7-196.6-2.2zM471.8 51.6c.1 .2 .1 .4 .1 .6c11.1 53.9 15.3 124.4 1 192.8c-50-7.9-95.1-30.8-130.5-64L471.8 51.6zm-2.5 209c-7.9 31.2-19.8 61.6-36.9 89.5c-8.8 14.3-18.9 27.9-30.4 40.5L267.3 256l63.8-63.8c37.4 35.2 85.1 59.7 138.2 68.3zM390.7 402c-24.8 23.9-55.5 43.8-93.2 57.8c-11.6 4.3-23.8 8-36.7 11.1c-8.4-53.7-33-102.1-68.6-139.9L256 267.3 390.7 402zM245.2 474.4c-53.1 10.3-116.6 10.6-192-2c-.6-.1-1.2-.2-1.8-.4L180.9 342.4c33.5 35.7 56.5 81.3 64.2 132zm-204.9-14c0-.2-.1-.4-.1-.6c-11.1-53.9-15.3-124.4-1-192.8c50 7.9 95.1 30.8 130.5 64L40.2 460.4zm2.5-209c7.9-31.2 19.8-61.6 36.9-89.5c8.8-14.3 18.9-27.9 30.4-40.5L244.7 256l-63.8 63.8c-37.4-35.2-85.1-59.7-138.2-68.3zM121.3 110c24.8-23.9 55.5-43.8 93.2-57.8c11.6-4.3 23.8-8 36.7-11.1c8.4 53.7 33 102.1 68.6 139.9L256 244.7 121.3 110z'
      
    ]
  };

  

  
  

  var faSignalBarsFair = {
    prefix: 'fat',
    iconName: 'signal-bars-fair',
    icon: [
      640,
      512,
      ["signal-alt-2"],
      'f692',
      
      'M240 272c-17.7 0-32 14.3-32 32V464c0 17.7 14.3 32 32 32s32-14.3 32-32V304c0-17.7-14.3-32-32-32zm-48 32c0-26.5 21.5-48 48-48s48 21.5 48 48V464c0 26.5-21.5 48-48 48s-48-21.5-48-48V304zM112 432c0-17.7-14.3-32-32-32s-32 14.3-32 32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V432zm-80 0c0-26.5 21.5-48 48-48s48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V432z'
      
    ]
  };

  
    var faSignalAlt2 = faSignalBarsFair;
  

  
  

  var faDistributeSpacingVertical = {
    prefix: 'fat',
    iconName: 'distribute-spacing-vertical',
    icon: [
      512,
      512,
      [],
      'e366',
      
      'M512 472c0-4.4-3.6-8-8-8L8 464c-4.4 0-8 3.6-8 8s3.6 8 8 8l496 0c4.4 0 8-3.6 8-8zM144 368c-17.7 0-32-14.3-32-32l0-160c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32l-224 0zm224 16c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-224 0c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48l224 0zM504 48c4.4 0 8-3.6 8-8s-3.6-8-8-8L8 32c-4.4 0-8 3.6-8 8s3.6 8 8 8l496 0z'
      
    ]
  };

  

  
  

  var faCircleLeft = {
    prefix: 'fat',
    iconName: 'circle-left',
    icon: [
      512,
      512,
      [61840,"arrow-alt-circle-left"],
      'f359',
      
      'M16 256a240 240 0 1 1 480 0A240 240 0 1 1 16 256zm496 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zm-400 0c0 7.2 2.9 14.2 8 19.3L219.7 375c5.7 5.7 13.5 9 21.7 9c16.9 0 30.6-13.7 30.6-30.6l0-49.4 88 0c22.1 0 40-17.9 40-40l0-16c0-22.1-17.9-40-40-40l-88 0 0-49.4c0-16.9-13.7-30.6-30.6-30.6c-8.1 0-15.9 3.2-21.7 9L120 236.7c-5.1 5.1-8 12.1-8 19.3zm19.3 8c-2.1-2.1-3.3-5-3.3-8s1.2-5.9 3.3-8L231 148.3c2.7-2.7 6.5-4.3 10.3-4.3c8.1 0 14.6 6.5 14.6 14.6l0 57.4c0 4.4 3.6 8 8 8l96 0c13.3 0 24 10.7 24 24l0 16c0 13.3-10.7 24-24 24l-96 0c-4.4 0-8 3.6-8 8l0 57.4c0 8.1-6.5 14.6-14.6 14.6c-3.9 0-7.6-1.5-10.3-4.3L131.3 264z'
      
    ]
  };

  
    var faArrowAltCircleLeft = faCircleLeft;
  

  
  

  var faCowbellCirclePlus = {
    prefix: 'fat',
    iconName: 'cowbell-circle-plus',
    icon: [
      576,
      512,
      ["cowbell-more"],
      'f8b4',
      
      'M168 16H280c13.3 0 24 10.7 24 24V96H144V40c0-13.3 10.7-24 24-24zM128 40V96H112c-21.4 0-40.3 14.2-46.2 34.8l-64 224c-4.1 14.5-1.2 30.1 7.8 42.1S32.9 416 48 416H262.6c-1.5-5.2-2.7-10.6-3.7-16H48c-10 0-19.5-4.7-25.5-12.7s-8-18.4-5.2-28.1l64-224C85.1 121.5 97.7 112 112 112h24H312h24c14.3 0 26.8 9.5 30.8 23.2l18.1 63.2c5.1-1.4 10.3-2.6 15.6-3.6l-18.3-64C376.3 110.2 357.4 96 336 96H320V40c0-22.1-17.9-40-40-40H168c-22.1 0-40 17.9-40 40zM272 448c0 12.7-5.1 24.9-14.1 33.9s-21.2 14.1-33.9 14.1s-24.9-5.1-33.9-14.1s-14.1-21.2-14.1-33.9c0-4.4-3.6-8-8-8s-8 3.6-8 8c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7c7.8-7.8 13.3-17.3 16.3-27.6c-4.6-6.9-8.8-14.2-12.4-21.7c-.7 1.2-1.2 2.6-1.2 4.1zm32-80a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM440 296c0-4.4-3.6-8-8-8s-8 3.6-8 8v64H360c-4.4 0-8 3.6-8 8s3.6 8 8 8h64v64c0 4.4 3.6 8 8 8s8-3.6 8-8V376h64c4.4 0 8-3.6 8-8s-3.6-8-8-8H440V296z'
      
    ]
  };

  
    var faCowbellMore = faCowbellCirclePlus;
  

  
  

  var faPlaneArrival = {
    prefix: 'fat',
    iconName: 'plane-arrival',
    icon: [
      640,
      512,
      [128748],
      'f5af',
      
      'M223.8 198.4c5.6 1.7 11.7 .1 15.8-4s5.7-10.1 4.1-15.8L197.2 16l40.1 0c5.8 0 11.1 3.1 13.9 8.2l119.8 213c2 3.6 5.4 6.3 9.4 7.5l96.5 28.5c13.9 4.1 26.9 10.9 38.3 20l27.4 21.9c14.9 12 9.8 35.8-8.8 40.6c-31.6 8.1-64.8 8-96.4-.2L125.7 274.3c-8.3-2.2-15.9-6.5-22-12.6L20.9 178.1c-3-3-4.6-7-4.6-11.2L16 68l34.2 7.6c5.7 1.3 10.2 5.5 11.9 11l18.6 62c1.6 5.2 5.6 9.2 10.8 10.7l132.3 39.1zm4.5-15.3l-18.2-5.4L96 144 77.4 82C74.1 70.9 65 62.4 53.7 59.9L19.5 52.3C9.5 50.1 0 57.7 0 68l.2 98.9c0 8.4 3.4 16.5 9.3 22.5l82.9 83.5c8.1 8.1 18.2 14 29.3 16.9l311.7 81.1c34.2 8.9 70.1 9 104.4 .2c31.3-8 40-48.4 14.8-68.6l-27.4-21.9c-13-10.4-27.8-18.1-43.7-22.8L385 229.3 265.2 16.3C259.5 6.2 248.8 0 237.3 0L197.2 0c-10.6 0-18.3 10.2-15.4 20.4l41.3 144.5 5.2 18.2zM8 496c-4.4 0-8 3.6-8 8s3.6 8 8 8H632c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zM160 352a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm80-16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faPersonFromPortal = {
    prefix: 'fat',
    iconName: 'person-from-portal',
    icon: [
      512,
      512,
      ["portal-exit"],
      'e023',
      
      'M121.5 449.6l.6-1.6H139c-14.6 45.4-35.6 64-59 64C35.8 512 0 445.4 0 256S35.8 0 80 0c34.8 0 64.4 41.3 75.4 151.3l29.1-29.1C201.3 105.5 224.1 96 247.9 96c8.3 0 16.6 1.2 24.7 3.5l90.7 25.9c17.3 4.9 31.6 16.9 39.7 32.9L435.8 224H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H435.8c-24.2 0-46.4-13.7-57.2-35.4l-6.2-12.4-9.7-19.3L354.8 241l-22.2 57.1 47.9 30c24.2 15.1 35.5 44.4 27.6 71.9l-25.4 88.8c-4.9 17-22.6 26.8-39.6 22s-26.8-22.6-22-39.6l25.4-88.8-86.2-53.9c-25.1-15.7-36.1-46.5-26.8-74.5l25.1-75.3 5.1-15.2L255 161c-2.2-.6-4.6-1-6.9-1l-.2 0c-6.8 0-13.4 2.7-18.2 7.5l-31.1 31.1c-10.8 10.8-27.3 12.3-39.7 4.5c.7 16.5 1 34.1 1 52.9c0 36.4-1.3 68.3-3.8 96h37.4l13.7-37.2c2.9 6.2 6.4 12.1 10.6 17.6l-9.2 25.2L204.8 368H193.6 128c-8.8 0-16 7.2-16 16s7.2 16 16 16h65.6c20.1 0 38.1-12.6 45.1-31.5l4.7-12.9 0 0 13.9 8.7-3.6 9.7c-9.2 25.2-33.2 42-60.1 42H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h12.2c2.5-27.4 3.8-59.2 3.8-96c0-94.1-8.9-155.9-22.5-193.6C107.8 24.3 91.8 16 80 16s-27.8 8.3-41.5 46.4C24.9 100.1 16 161.9 16 256s8.9 155.9 22.5 193.6C52.2 487.7 68.2 496 80 496s27.8-8.3 41.5-46.4zM268.2 148.1c4.2 1.2 7.7 4.1 9.8 7.9s2.4 8.4 1 12.5L248.8 259c-7 21 1.3 44.1 20.1 55.9l86.2 53.9c6 3.8 8.9 11.1 6.9 18l-25.4 88.8c-2.4 8.5 2.5 17.4 11 19.8s17.4-2.5 19.8-11l25.4-88.8c5.9-20.6-2.6-42.6-20.7-53.9l-47.9-30c-6.5-4.1-9.2-12.2-6.4-19.4l30-77.3c2.3-5.9 7.8-9.9 14.2-10.2s12.2 3.2 15.1 8.8l15.9 31.7c8.1 16.3 24.8 26.5 42.9 26.5H480c8.8 0 16-7.2 16-16s-7.2-16-16-16H435.8c-6.1 0-11.6-3.4-14.3-8.8l-32.9-65.7c-6-12-16.8-21-29.7-24.7l-90.7-25.9c-6.6-1.9-13.4-2.8-20.3-2.8c-19.6 0-38.3 7.8-52.1 21.6l-31.1 31.1c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l31.1-31.1c7.8-7.8 18.4-12.2 29.5-12.2c3.9 0 7.7 .5 11.5 1.6l8.8 2.5zM368 80a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM320 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  
    var faPortalExit = faPersonFromPortal;
  

  
  

  var faCalendarPlus = {
    prefix: 'fat',
    iconName: 'calendar-plus',
    icon: [
      448,
      512,
      [],
      'f271',
      
      'M120 0c4.4 0 8 3.6 8 8V64H320V8c0-4.4 3.6-8 8-8s8 3.6 8 8V64h48c35.3 0 64 28.7 64 64v48 16V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 176 128C0 92.7 28.7 64 64 64h48V8c0-4.4 3.6-8 8-8zM432 192H16V448c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V192zM112 120V80H64c-26.5 0-48 21.5-48 48v48H432V128c0-26.5-21.5-48-48-48H336v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V80H128v40c0 4.4-3.6 8-8 8s-8-3.6-8-8zM320 344c0 4.4-3.6 8-8 8H232v80c0 4.4-3.6 8-8 8s-8-3.6-8-8V352H136c-4.4 0-8-3.6-8-8s3.6-8 8-8h80V256c0-4.4 3.6-8 8-8s8 3.6 8 8v80h80c4.4 0 8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faPersonSkiingNordic = {
    prefix: 'fat',
    iconName: 'person-skiing-nordic',
    icon: [
      576,
      512,
      ["skiing-nordic"],
      'f7ca',
      
      'M236.2 148.1l-8.8-2.5c-3.7-1.1-7.6-1.6-11.5-1.6c-11.1 0-21.7 4.4-29.5 12.2l-31.1 31.1c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l31.1-31.1c13.8-13.8 32.6-21.6 52.1-21.6c6.9 0 13.7 1 20.3 2.8l90.7 25.9c12.9 3.7 23.7 12.7 29.7 24.7l32.9 65.7c2.7 5.4 8.2 8.8 14.3 8.8H448c8.8 0 16 7.2 16 16s-7.2 16-16 16H403.8c-18.2 0-34.8-10.3-42.9-26.5L345 213.7c-2.8-5.7-8.7-9.1-15.1-8.8s-11.9 4.3-14.2 10.2l-30 77.3c-2.8 7.2-.1 15.3 6.4 19.4l47.9 30c18.1 11.3 26.6 33.3 20.7 53.9l-25.4 88.8c-2 6.9-8.2 11.4-15 11.6h-.7c-1.3 0-2.7-.2-4-.6c-8.5-2.4-13.4-11.3-11-19.8L330 386.8c2-6.9-.9-14.2-6.9-18l-86.2-53.9c-18.8-11.8-27.1-34.8-20.1-55.9l30.2-90.5c1.4-4.1 1-8.7-1-12.5s-5.6-6.7-9.8-7.9zm53.1 323.1c-2.5 8.7-1.1 17.5 3.1 24.8H187.7c.5-.8 .9-1.6 1.3-2.5l54.9-117.6-13.7-8.5L174.5 486.8c-2.7 5.7-8.3 9.1-14.2 9.2h-.7c-2.2 0-4.3-.5-6.4-1.5c-8-3.7-11.5-13.3-7.7-21.3l57.6-123.4c-4.5-3.5-8.6-7.4-12.3-11.5L131 466.5c-4.6 9.8-3.8 20.8 1.3 29.5H80.2l60.7-288.2c9.2 .9 18.7-2.2 25.8-9.2l31.1-31.1c4.8-4.8 11.4-7.5 18.2-7.5l.2 0c2.3 0 4.7 .3 6.9 1l8.8 2.5-5.1 15.2L201.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-25.4 88.8zm-163.6-269L64.2 494.4c-.1 .6-.2 1.1-.2 1.6H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H159.3c.5 0 .9 0 1.4 0H319.3c.5 0 1 0 1.4 0H520c30.9 0 56-25.1 56-56V440c0-4.4-3.6-8-8-8s-8 3.6-8 8v16c0 22.1-17.9 40-40 40H432.1l31.4-212c9.8-5.5 16.5-16 16.5-28c0-17.7-14.3-32-32-32H403.8l-32.9-65.7c-8-16-22.4-28-39.7-32.9L240.6 99.5c-8-2.3-16.3-3.5-24.7-3.5c-23.8 0-46.6 9.5-63.5 26.3l-31.1 31.1c-12.5 12.5-12.5 32.8 0 45.3c1.3 1.3 2.8 2.6 4.3 3.6zM416.1 494.8c-.1 .4-.1 .8-.1 1.2H347.7c1.3-2.2 2.3-4.6 3-7.2L376.2 400c7.8-27.4-3.4-56.7-27.6-71.9l-47.9-30L322.8 241l7.8-20.1 9.7 19.3 6.2 12.4c10.8 21.7 33 35.4 57.2 35.4h43L416.1 494.8zM336 16a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm48 32a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  
    var faSkiingNordic = faPersonSkiingNordic;
  

  
  

  var faArrowDownRight = {
    prefix: 'fat',
    iconName: 'arrow-down-right',
    icon: [
      384,
      512,
      [],
      'e093',
      
      'M344 416c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8s-8 3.6-8 8V388.7L45.7 98.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L324.7 400H104c-4.4 0-8 3.6-8 8s3.6 8 8 8H344z'
      
    ]
  };

  

  
  

  var faGrate = {
    prefix: 'fat',
    iconName: 'grate',
    icon: [
      448,
      512,
      [],
      'e193',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm88 0h64 72 72 64c13.3 0 24 10.7 24 24V256 392c0 13.3-10.7 24-24 24H296 224 152 88c-13.3 0-24-10.7-24-24V256 120c0-13.3 10.7-24 24-24zm-8 24V248h64V112H88c-4.4 0-8 3.6-8 8zm80 128h56V112H160V248zm72 0h56V112H232V248zm72 0h64V120c0-4.4-3.6-8-8-8H304V248zm0 16V400h56c4.4 0 8-3.6 8-8V264H304zm-16 0H232V400h56V264zm-72 0H160V400h56V264zm-72 0H80V392c0 4.4 3.6 8 8 8h56V264z'
      
    ]
  };

  

  
  

  var faTrafficCone = {
    prefix: 'fat',
    iconName: 'traffic-cone',
    icon: [
      512,
      512,
      [],
      'f636',
      
      'M232.9 16h46.2c6.8 0 12.8 4.3 15.1 10.6L341.8 160H170.2L217.8 26.6c2.3-6.4 8.3-10.6 15.1-10.6zM347.5 176l51.4 144H113.1l51.4-144h183zm57.1 160l43.8 122.7c1.5 4.2 6.1 6.3 10.2 4.8s6.3-6.1 4.8-10.2L309.2 21.2C304.7 8.5 292.6 0 279.1 0H232.9c-13.5 0-25.6 8.5-30.1 21.2L48.5 453.3c-1.5 4.2 .7 8.7 4.8 10.2s8.7-.7 10.2-4.8L107.4 336H404.6zM0 504c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H8c-4.4 0-8 3.6-8 8z'
      
    ]
  };

  

  
  

  var faHouseMedicalCircleCheck = {
    prefix: 'fat',
    iconName: 'house-medical-circle-check',
    icon: [
      640,
      512,
      [],
      'e511',
      
      'M282.7 2c3-2.7 7.6-2.7 10.6 0l215 190.4c-4.1-.3-8.2-.4-12.3-.4c-4 0-8 .1-11.9 .4L288 18.7 80 202.9V448c0 26.5 21.5 48 48 48H375.2c6.1 5.8 12.7 11.1 19.6 16H128c-35.3 0-64-28.7-64-64V217.1L13.3 262c-3.3 2.9-8.4 2.6-11.3-.7S-.6 252.9 2.7 250L282.7 2zm84.6 246c-4.7 5.1-9.1 10.4-13.3 16H320c-4.4 0-8-3.6-8-8V200c0-4.4-3.6-8-8-8H272c-4.4 0-8 3.6-8 8v56c0 4.4-3.6 8-8 8H200c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h56c4.4 0 8 3.6 8 8v56c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8h8.2c.2 5.5 .7 10.9 1.5 16.3C317.3 397 311 400 304 400H272c-13.3 0-24-10.7-24-24V328H200c-13.3 0-24-10.7-24-24V272c0-13.3 10.7-24 24-24h48V200c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v48h39.3zM496 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm58.3 98.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-80 80c-3.1 3.1-8.2 3.1-11.3 0l-48-48c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L480 396.7l74.3-74.3z'
      
    ]
  };

  

  
  

  var faAlarmExclamation = {
    prefix: 'fat',
    iconName: 'alarm-exclamation',
    icon: [
      512,
      512,
      [],
      'f843',
      
      'M93.7 0C42 0 0 42 0 93.7c0 18.5 5.4 35.8 14.6 50.3c2.4 3.7 7.3 4.8 11 2.4s4.8-7.3 2.4-11C20.4 123.4 16 109.1 16 93.7C16 50.8 50.8 16 93.7 16c20.4 0 39 7.9 52.8 20.7c3.2 3 8.3 2.8 11.3-.4s2.8-8.3-.4-11.3C140.7 9.5 118.3 0 93.7 0zM45.7 509.7l57.7-57.7C143.4 489.2 197 512 256 512s112.6-22.8 152.6-60.1l57.7 57.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-57.7-57.7C457.2 400.6 480 347 480 288C480 164.3 379.7 64 256 64S32 164.3 32 288c0 59 22.8 112.6 60.1 152.6L34.3 498.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0zM256 80a208 208 0 1 1 0 416 208 208 0 1 1 0-416zM418.3 0c-24.6 0-47 9.5-63.7 25c-3.2 3-3.4 8.1-.4 11.3s8.1 3.4 11.3 .4C379.3 23.9 397.9 16 418.3 16C461.2 16 496 50.8 496 93.7c0 15.4-4.4 29.7-12.1 41.7c-2.4 3.7-1.3 8.7 2.4 11s8.7 1.3 11-2.4c9.3-14.5 14.6-31.8 14.6-50.3C512 42 470 0 418.3 0zM272 384a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-8-216c0-4.4-3.6-8-8-8s-8 3.6-8 8V328c0 4.4 3.6 8 8 8s8-3.6 8-8V168z'
      
    ]
  };

  

  
  

  var faTarpDroplet = {
    prefix: 'fat',
    iconName: 'tarp-droplet',
    icon: [
      576,
      512,
      [],
      'e57c',
      
      'M344 113.5c0-3.6-1.4-9.8-5.2-18.4c-3.6-8.3-8.8-17.7-14.8-27.4C312.2 48.8 298 30 288 17.3C278 30 263.8 48.8 252 67.7c-6 9.7-11.2 19-14.8 27.4c-3.8 8.7-5.2 14.8-5.2 18.4c0 27.5 24.1 51.5 56 51.5s56-24 56-51.5zm16 0c0 37.3-32.2 67.5-72 67.5s-72-30.2-72-67.5c0-27.7 39.7-81.3 60.2-107c6.1-7.7 17.5-7.7 23.7 0c20.4 25.7 60.2 79.3 60.2 107zM64 128H193.3c.9 5.5 2.3 10.9 4.1 16H64c-26.5 0-48 21.5-48 48l0 256c0 26.5 21.5 48 48 48l332.1 0c1.3 0 2.6-.1 3.9-.2L400 376c0-22.1 17.9-40 40-40H559.8c.2-1.3 .2-2.6 .2-3.9V192c0-26.5-21.5-48-48-48H378.5c1.8-5.1 3.2-10.5 4.1-16H512c35.3 0 64 28.7 64 64V332.1c0 12.7-5.1 24.9-14.1 33.9L430.1 497.9c-9 9-21.2 14.1-33.9 14.1L64 512c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64zM418.7 486.6L550.6 354.7c.9-.9 1.7-1.8 2.4-2.7H440c-13.3 0-24 10.7-24 24l0 113.1c1-.8 1.9-1.6 2.7-2.4zM72 216a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z'
      
    ]
  };

  

  
  

  var faRectangleList = {
    prefix: 'fat',
    iconName: 'rectangle-list',
    icon: [
      576,
      512,
      ["list-alt"],
      'f022',
      
      'M512 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM192 160c0 4.4 3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H200c-4.4 0-8 3.6-8 8zm0 96c0 4.4 3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H200c-4.4 0-8 3.6-8 8zm0 96c0 4.4 3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H200c-4.4 0-8 3.6-8 8zM128 144a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm16 112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0 32 16 16 0 1 0 0-32z'
      
    ]
  };

  
    var faListAlt = faRectangleList;
  

  
  

  var faDumbbell = {
    prefix: 'fat',
    iconName: 'dumbbell',
    icon: [
      640,
      512,
      [],
      'f44b',
      
      'M184 48c13.3 0 24 10.7 24 24V256 440c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24V376 136 72c0-13.3 10.7-24 24-24h32zM112 408v32c0 22.1 17.9 40 40 40h32c22.1 0 40-17.9 40-40V264H416V440c0 22.1 17.9 40 40 40h32c22.1 0 40-17.9 40-40V408c6.7 5 15 8 24 8h16c22.1 0 40-17.9 40-40V264h24c4.4 0 8-3.6 8-8s-3.6-8-8-8H608V136c0-22.1-17.9-40-40-40H552c-9 0-17.3 3-24 8V72c0-22.1-17.9-40-40-40H456c-22.1 0-40 17.9-40 40V248H224V72c0-22.1-17.9-40-40-40H152c-22.1 0-40 17.9-40 40v32c-6.7-5-15-8-24-8H72c-22.1 0-40 17.9-40 40V248H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H32V376c0 22.1 17.9 40 40 40H88c9 0 17.3-3 24-8zM528 136c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24V256 376c0 13.3-10.7 24-24 24H552c-13.3 0-24-10.7-24-24V136zM512 376v64c0 13.3-10.7 24-24 24H456c-13.3 0-24-10.7-24-24V256 72c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v64V376zM112 136V376c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V256 136c0-13.3 10.7-24 24-24H88c13.3 0 24 10.7 24 24z'
      
    ]
  };

  

  
  

  var faFaceGrinSquintTears = {
    prefix: 'fat',
    iconName: 'face-grin-squint-tears',
    icon: [
      512,
      512,
      [129315,"grin-squint-tears"],
      'f586',
      
      'M401.2 110.8c1.9-12.3 4.8-28.3 8.7-43.5c2.4-9.6 5.2-18.4 8.2-25.7c3.1-7.7 6-12.1 7.9-14c15.5-15.5 41.3-15.5 57.7 .9S500 70.5 484.5 86c-1.9 1.9-6.4 4.8-14 7.9c-7.3 3-16.2 5.7-25.7 8.2c-15.2 3.9-31.3 6.8-43.5 8.7zm93.7-93.7c-22.4-22.4-58.3-22.8-80.3-.9c-16.9 16.9-26.9 75.2-30.5 100.9c-1 6.4 4.4 11.8 10.8 10.8c25.8-3.5 84-13.6 100.9-30.5c22-22 21.5-57.9-.9-80.3zM16 256C16 123.5 123.5 16 256 16c33.6 0 65.6 6.9 94.6 19.4c4.1 1.7 8.8-.1 10.5-4.2s-.1-8.8-4.2-10.5C326 7.4 291.8 0 256 0C114.6 0 0 114.6 0 256c0 36.4 7.6 71 21.3 102.4c1.8 4 6.5 5.9 10.5 4.1s5.9-6.5 4.1-10.5c-12.8-29.4-20-61.8-20-96zM490.7 153.6c-1.8-4-6.5-5.9-10.5-4.1s-5.9 6.5-4.1 10.5c12.8 29.4 20 61.8 20 96c0 132.5-107.5 240-240 240c-34.7 0-67.6-7.4-97.4-20.6c-4-1.8-8.8 0-10.6 4.1s0 8.8 4.1 10.6C183.9 504.2 219 512 256 512c141.4 0 256-114.6 256-256c0-36.4-7.6-71-21.3-102.4zM321.1 320.7c30.4-30.4 55.6-63.3 75-96.8c2-3.5 5.2-4.8 7.4-4.9c1 0 1.5 .3 1.7 .4l0 0c.1 .1 .6 .4 1 1.7c15.4 50.8 3.1 107.9-36.8 147.8s-97 52.2-147.8 36.8c-1.3-.4-1.7-.9-1.7-1l0 0c-.1-.2-.4-.7-.4-1.7c0-2.2 1.4-5.4 4.9-7.4c33.4-19.4 66.4-44.6 96.8-75zM421.5 216.5c-5.6-18.4-29.6-17.3-39.2-.6c-18.7 32.2-43 64-72.5 93.5s-61.3 53.8-93.5 72.5c-16.6 9.6-17.8 33.6 .6 39.2c56.2 17 119.5 3.4 163.7-40.8s57.8-107.6 40.8-163.7zM101.3 281.2c1.4 4.2 5.9 6.5 10.1 5.1L181.1 263l-23.2 69.7c-1.4 4.2 .9 8.7 5.1 10.1s8.7-.9 10.1-5.1l28.3-84.9c1-2.9 .2-6-1.9-8.2s-5.3-2.9-8.2-1.9L106.4 271c-4.2 1.4-6.5 5.9-5.1 10.1zM271 106.4l-28.3 84.9c-1 2.9-.2 6 1.9 8.2s5.3 2.9 8.2 1.9l84.9-28.3c4.2-1.4 6.5-5.9 5.1-10.1s-5.9-6.5-10.1-5.1L263 181.1l23.2-69.7c1.4-4.2-.9-8.7-5.1-10.1s-8.7 .9-10.1 5.1zM67.3 409.9c15.2-3.9 31.3-6.8 43.5-8.7c-1.9 12.3-4.8 28.3-8.7 43.5c-2.4 9.6-5.2 18.4-8.2 25.7c-3.1 7.7-6 12.1-7.9 14C70.5 500 44.7 500 28.4 483.6S12 441.4 27.5 426c1.9-1.9 6.4-4.8 14-7.9c7.3-3 16.2-5.7 25.7-8.2zm30.1 85.9c16.9-16.9 26.9-75.2 30.5-100.9c1-6.4-4.4-11.8-10.8-10.8c-25.8 3.5-84 13.6-100.9 30.5c-22 22-21.5 57.9 .9 80.3s58.3 22.8 80.3 .9z'
      
    ]
  };

  
    var faGrinSquintTears = faFaceGrinSquintTears;
  

  
  

  var faReel = {
    prefix: 'fat',
    iconName: 'reel',
    icon: [
      448,
      512,
      [],
      'e238',
      
      'M0 8C0 3.6 3.6 0 8 0H72 376h64c4.4 0 8 3.6 8 8s-3.6 8-8 8H384V96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8V16H8c-4.4 0-8-3.6-8-8zm80 8V88H368V16H80zM64 160c0-4.4 3.6-8 8-8H376c4.4 0 8 3.6 8 8s-3.6 8-8 8H72c-4.4 0-8-3.6-8-8zm0 64c0-4.4 3.6-8 8-8H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H72c-4.4 0-8-3.6-8-8zm0 64c0-4.4 3.6-8 8-8H376c4.4 0 8 3.6 8 8s-3.6 8-8 8H72c-4.4 0-8-3.6-8-8zm0 64c0-4.4 3.6-8 8-8H376c4.4 0 8 3.6 8 8s-3.6 8-8 8H72c-4.4 0-8-3.6-8-8zM8 512c-4.4 0-8-3.6-8-8s3.6-8 8-8H64V416c0-4.4 3.6-8 8-8H376c4.4 0 8 3.6 8 8v80h56c4.4 0 8 3.6 8 8s-3.6 8-8 8H376 72 8zm72-88v72H368V424H80z'
      
    ]
  };

  

  
  

  var faHardDrive = {
    prefix: 'fat',
    iconName: 'hard-drive',
    icon: [
      512,
      512,
      [128436,"hdd"],
      'f0a0',
      
      'M64 48C37.5 48 16 69.5 16 96V309.7C27.7 296.4 44.9 288 64 288H448c19.1 0 36.3 8.4 48 21.7V96c0-26.5-21.5-48-48-48H64zM16 352v64c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V352c0-26.5-21.5-48-48-48H64c-26.5 0-48 21.5-48 48zM0 352V96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V352v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V352zm320 16a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm48 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z'
      
    ]
  };

  
    var faHdd = faHardDrive;
  

  
  

  var faTvMusic = {
    prefix: 'fat',
    iconName: 'tv-music',
    icon: [
      640,
      512,
      [],
      'f8e6',
      
      'M64 16C37.5 16 16 37.5 16 64V384c0 26.5 21.5 48 48 48H576c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H64zM0 64C0 28.7 28.7 0 64 0H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM104 496H536c4.4 0 8 3.6 8 8s-3.6 8-8 8H104c-4.4 0-8-3.6-8-8s3.6-8 8-8zM560 80H80V368H560V80zM80 64H560c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm332.6 41.4c2.2 1.5 3.4 4 3.4 6.6V264l0 0c0 22.1-21.5 40-48 40s-48-17.9-48-40s21.5-40 48-40c12.3 0 23.5 3.9 32 10.2V123.5l-112 42V296l0 0c0 22.1-21.5 40-48 40c-26.5 0-48-17.9-48-40s21.5-40 48-40c12.3 0 23.5 3.9 32 10.2V160c0-3.3 2.1-6.3 5.2-7.5l128-48c2.5-.9 5.2-.6 7.4 .9zM368 240c-20.5 0-32 13.4-32 24s11.5 24 32 24s32-13.4 32-24s-11.5-24-32-24zM240 272c-20.5 0-32 13.4-32 24s11.5 24 32 24s32-13.4 32-24s-11.5-24-32-24z'
      
    ]
  };

  

  
  

  var faArrowRotateLeft = {
    prefix: 'fat',
    iconName: 'arrow-rotate-left',
    icon: [
      512,
      512,
      [8634,"arrow-left-rotate","arrow-rotate-back","arrow-rotate-backward","undo"],
      'f0e2',
      
      'M127.9 419.9c90.5 70.7 221.2 54.7 292-35.8s54.7-221.2-35.8-292C293.6 21.4 162.9 37.4 92.1 127.9L56 176H184c4.4 0 8 3.6 8 8s-3.6 8-8 8H40c-4.4 0-8-3.6-8-8V40c0-4.4 3.6-8 8-8s8 3.6 8 8V160l31.4-41.8 0 0 .1-.1C155.6 20.6 296.4 3.3 393.9 79.5s114.8 216.9 38.6 314.4s-216.9 114.8-314.4 38.6C93.4 413.2 73.9 389.8 59.7 364c-2.1-3.9-.7-8.7 3.2-10.9s8.7-.7 10.9 3.2c13.2 24 31.3 45.7 54.2 63.7z'
      
    ]
  };

  
    var faArrowLeftRotate = faArrowRotateLeft;
  
    var faArrowRotateBack = faArrowRotateLeft;
  
    var faArrowRotateBackward = faArrowRotateLeft;
  
    var faUndo = faArrowRotateLeft;
  

  
  

  var faCookie = {
    prefix: 'fat',
    iconName: 'cookie',
    icon: [
      512,
      512,
      [127850],
      'f563',
      
      'M244.9 32.9c-18.8-2.6-37.9 .7-54.6 9.7L116.4 82c-16.7 8.9-30.2 22.9-38.5 40L41.1 197.6c-8.3 17.1-11 36.4-7.7 55.2l14.5 82.8c3.3 18.7 12.4 36 26.1 49.2L134.2 443c13.6 13.2 31.1 21.7 49.8 24.4l83 11.7c18.8 2.6 37.9-.7 54.6-9.7l74-39.5c16.7-8.9 30.2-22.9 38.5-40l36.7-75.5c8.3-17.1 11-36.4 7.7-55.2l-14.5-82.8c-3.3-18.7-12.4-36-26.1-49.2L377.8 69c-13.6-13.2-31.1-21.7-49.8-24.4l-83-11.7zm-62.1-4.5c19.7-10.5 42.3-14.5 64.4-11.4l83 11.7c22.1 3.1 42.7 13.2 58.7 28.7l60.3 58.4c16.1 15.6 26.8 35.8 30.7 57.9l14.6 82.8c3.9 22.1 .7 44.8-9.1 64.9L448.6 397c-9.8 20.1-25.7 36.6-45.4 47.2l-74 39.5c-19.7 10.5-42.3 14.5-64.4 11.4l-83-11.7c-22.1-3.1-42.7-13.2-58.7-28.7L62.8 396.2C46.8 380.6 36 360.3 32.2 338.3L17.6 255.5c-3.9-22.1-.7-44.8 9.1-64.9L63.4 115c9.8-20.1 25.7-36.6 45.4-47.2l74-39.5zM208 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm16 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM144 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm192-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm16 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faOctagonDivide = {
    prefix: 'fat',
    iconName: 'octagon-divide',
    icon: [
      512,
      512,
      [],
      'e203',
      
      'M191.5 16.1c-14.9 0-29.1 5.9-39.6 16.4L32.5 151.9C22 162.4 16.1 176.7 16.1 191.5v129c0 14.9 5.9 29.1 16.4 39.6L151.9 479.5c10.5 10.5 24.7 16.4 39.6 16.4h129c14.9 0 29.1-5.9 39.6-16.4L479.5 360.1c10.5-10.5 16.4-24.7 16.4-39.6v-129c0-14.9-5.9-29.1-16.4-39.6L360.1 32.5C349.6 22 335.3 16.1 320.5 16.1h-129zm-50.9 5.1C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM272 160a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-72 88H360c4.4 0 8 3.6 8 8s-3.6 8-8 8H152c-4.4 0-8-3.6-8-8s3.6-8 8-8zM256 368a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faCommentArrowUpRight = {
    prefix: 'fat',
    iconName: 'comment-arrow-up-right',
    icon: [
      512,
      512,
      [],
      'e145',
      
      'M157.3 415c-5-1.8-10.6-1-14.9 2.1c-11 8-29.4 19.3-51.2 28.8C68.3 456 41.6 464 16 464l.1-.1 0 0 0 0 .3-.3 .1-.1c.4-.4 .9-.9 1.5-1.6c1.3-1.4 3.2-3.6 5.4-6.3l-12.2-10 12.2 10C28 450 34 442 40 432c10.7-17.9 21.4-42.1 23.6-69.9c.3-4.3-1.1-8.6-3.9-11.8C31.9 318.8 16 280.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-35.2 0-68.6-6.1-98.7-17zM4.7 452.7l0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0zM200 152c-4.4 0-8 3.6-8 8s3.6 8 8 8H308.7L170.3 306.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L320 179.3V288c0 4.4 3.6 8 8 8s8-3.6 8-8V160c0-4.4-3.6-8-8-8H200z'
      
    ]
  };

  

  
  

  var faOctagon = {
    prefix: 'fat',
    iconName: 'octagon',
    icon: [
      512,
      512,
      [128721],
      'f306',
      
      'M151.9 32.5c10.5-10.5 24.7-16.4 39.6-16.4h129c14.9 0 29.1 5.9 39.6 16.4L479.5 151.9c10.5 10.5 16.4 24.7 16.4 39.6v129c0 14.9-5.9 29.1-16.4 39.6L360.1 479.5c-10.5 10.5-24.7 16.4-39.6 16.4h-129c-14.9 0-29.1-5.9-39.6-16.4L32.5 360.1C22 349.6 16.1 335.3 16.1 320.5v-129c0-14.9 5.9-29.1 16.4-39.6L151.9 32.5zM191.5 .1c-19.1 0-37.4 7.6-50.9 21.1L21.2 140.6C7.7 154.1 .1 172.4 .1 191.5v129c0 19.1 7.6 37.4 21.1 50.9L140.6 490.8c13.5 13.5 31.8 21.1 50.9 21.1h129c19.1 0 37.4-7.6 50.9-21.1L490.8 371.4c13.5-13.5 21.1-31.8 21.1-50.9v-129c0-19.1-7.6-37.4-21.1-50.9L371.4 21.2C357.9 7.7 339.6 .1 320.5 .1h-129z'
      
    ]
  };

  

  
  

  var faBorderBottomRight = {
    prefix: 'fat',
    iconName: 'border-bottom-right',
    icon: [
      448,
      512,
      ["border-style-alt"],
      'f854',
      
      'M448 56c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 368c0 22.1-17.9 40-40 40L24 464c-4.4 0-8 3.6-8 8s3.6 8 8 8l368 0c30.9 0 56-25.1 56-56l0-368zM320 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM128 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm96-32a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM32 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0 160a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0-64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0 160a16 16 0 1 0 0 32 16 16 0 1 0 0-32z'
      
    ]
  };

  
    var faBorderStyleAlt = faBorderBottomRight;
  

  
  

  var faCarBuilding = {
    prefix: 'fat',
    iconName: 'car-building',
    icon: [
      640,
      512,
      [],
      'f859',
      
      'M272 16H48C30.3 16 16 30.3 16 48V432c0 17.7 14.3 32 32 32H224v16H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0H272c26.5 0 48 21.5 48 48V165.2c-5.9 4.8-11.3 10.3-16 16.4V48c0-17.7-14.3-32-32-32zM232 288c7.2 0 13.7 3.2 18.1 8.2c-3.8 4.5-7.2 9.3-10.2 14.3c-.7-3.7-4-6.5-7.9-6.5H200c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h25.1c-.7 5.2-1.1 10.6-1.1 16H200c-13.3 0-24-10.7-24-24V312c0-13.3 10.7-24 24-24h32zM64 200c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V200zm24-8c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V200c0-4.4-3.6-8-8-8H88zm112-16h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V200c0-13.3 10.7-24 24-24zm-8 24v32c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V200c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8zM64 88c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V88zm24-8c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V88c0-4.4-3.6-8-8-8H88zM200 64h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V88c0-13.3 10.7-24 24-24zm-8 24v32c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V88c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8zM64 312c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V312zm24-8c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V312c0-4.4-3.6-8-8-8H88zM380.2 192c-17.9 0-33.6 11.8-38.5 29l-19.5 68.2c4.5-.8 9-1.2 13.7-1.2H560c4.7 0 9.3 .4 13.7 1.2L554.3 221c-4.9-17.2-20.6-29-38.5-29H380.2zM304.3 293.8l22.1-77.2c6.9-24 28.8-40.6 53.8-40.6H515.8c25 0 47 16.6 53.8 40.6l22.1 77.2-1 .3c29 12 49.3 40.6 49.3 73.9v64 16 32c0 17.7-14.3 32-32 32H592c-17.7 0-32-14.3-32-32V448H336v32c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V448 432 368c0-33.3 20.4-61.9 49.3-73.9l-1-.3zM576 432h48V368c0-35.3-28.7-64-64-64H336c-35.3 0-64 28.7-64 64v64h48 16H560h16zm16 64h16c8.8 0 16-7.2 16-16V448H576v32c0 8.8 7.2 16 16 16zM320 448H272v32c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V448zm0-80a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm224-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z'
      
    ]
  };

  

  
  

  var faMessageMusic = {
    prefix: 'fat',
    iconName: 'message-music',
    icon: [
      512,
      512,
      ["comment-alt-music"],
      'f8af',
      
      'M176 416c0-8.8-7.2-16-16-16H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H309.3c-3.5 0-6.8 1.1-9.6 3.2L176 496V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h80 16v16 64c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM348.6 89.4c-2.2-1.5-4.9-1.8-7.4-.9l-128 48c-3.1 1.2-5.2 4.2-5.2 7.5V250.2c-8.5-6.3-19.7-10.2-32-10.2c-26.5 0-48 17.9-48 40s21.5 40 48 40c26.5 0 48-17.9 48-40l0 0V149.5l112-42V218.2c-8.5-6.3-19.7-10.2-32-10.2c-26.5 0-48 17.9-48 40s21.5 40 48 40c26.5 0 48-17.9 48-40l0 0V96c0-2.6-1.3-5.1-3.4-6.6zM304 224c20.5 0 32 13.4 32 24s-11.5 24-32 24s-32-13.4-32-24s11.5-24 32-24zM176 256c20.5 0 32 13.4 32 24s-11.5 24-32 24s-32-13.4-32-24s11.5-24 32-24z'
      
    ]
  };

  
    var faCommentAltMusic = faMessageMusic;
  

  
  

  var faCameraViewfinder = {
    prefix: 'fat',
    iconName: 'camera-viewfinder',
    icon: [
      512,
      512,
      ["screenshot"],
      'e0da',
      
      'M0 40V152c0 4.4 3.6 8 8 8s8-3.6 8-8V40c0-13.3 10.7-24 24-24H152c4.4 0 8-3.6 8-8s-3.6-8-8-8H40C17.9 0 0 17.9 0 40zM472 0H360c-4.4 0-8 3.6-8 8s3.6 8 8 8H472c13.3 0 24 10.7 24 24V152c0 4.4 3.6 8 8 8s8-3.6 8-8V40c0-22.1-17.9-40-40-40zM208 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM40 512H152c4.4 0 8-3.6 8-8s-3.6-8-8-8H40c-13.3 0-24-10.7-24-24V360c0-4.4-3.6-8-8-8s-8 3.6-8 8V472c0 22.1 17.9 40 40 40zm472-40V360c0-4.4-3.6-8-8-8s-8 3.6-8 8V472c0 13.3-10.7 24-24 24H360c-4.4 0-8 3.6-8 8s3.6 8 8 8H472c22.1 0 40-17.9 40-40zM211.1 96c-10 0-19 6.2-22.5 15.6L182.5 128H144c-26.5 0-48 21.5-48 48V336c0 26.5 21.5 48 48 48H368c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H329.5l-6.2-16.4c-3.5-9.4-12.5-15.6-22.5-15.6H211.1zm-7.5 21.2c1.2-3.1 4.2-5.2 7.5-5.2h89.8c3.3 0 6.3 2.1 7.5 5.2l8.1 21.6c1.2 3.1 4.2 5.2 7.5 5.2h44c17.7 0 32 14.3 32 32V336c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32V176c0-17.7 14.3-32 32-32h44c3.3 0 6.3-2.1 7.5-5.2l8.1-21.6z'
      
    ]
  };

  
    var faScreenshot = faCameraViewfinder;
  

  
  

  var faMoneyBillWheat = {
    prefix: 'fat',
    iconName: 'money-bill-wheat',
    icon: [
      512,
      512,
      [],
      'e52a',
      
      'M218.3 32C207.1 22 192.2 16 176 16c0 35.3 28.7 64 64 64c0-19.1-8.4-36.3-21.7-48zm112 0C319.1 22 304.2 16 288 16c0 35.3 28.7 64 64 64c0-19.1-8.4-36.3-21.7-48zm112 0C431 22 416.2 16 400 16c0 35.3 28.7 64 64 64c0-19.1-8.4-36.3-21.7-48zM352 144c-35.3 0-64 28.7-64 64c16.2 0 31.1-6 42.3-16c13.3-11.7 21.7-28.9 21.7-48zm-112 0c-35.3 0-64 28.7-64 64c16.2 0 31.1-6 42.3-16c13.3-11.7 21.7-28.9 21.7-48zm224 0c-35.3 0-64 28.7-64 64c16.2 0 31-6 42.3-16c13.3-11.7 21.7-28.9 21.7-48zM160 16c0-8.8 7.2-16 16-16c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80zm112 0c0-8.8 7.2-16 16-16c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80zM400 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80c0-8.8 7.2-16 16-16zM368 144c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM240 128c8.8 0 16 7.2 16 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm240 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM8 104H152c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8zM32 40c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H40c-4.4 0-8-3.6-8-8zm8 136h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H40c-4.4 0-8-3.6-8-8s3.6-8 8-8zM16 328c30.9 0 56-25.1 56-56H48c-17.7 0-32 14.3-32 32v24zm0 16v80c39.8 0 72 32.2 72 72H424c0-39.8 32.2-72 72-72V344c-39.8 0-72-32.2-72-72H88c0 39.8-32.2 72-72 72zm424-72c0 30.9 25.1 56 56 56V304c0-17.7-14.3-32-32-32H440zm56 168c-30.9 0-56 25.1-56 56h24c17.7 0 32-14.3 32-32V440zM72 496c0-30.9-25.1-56-56-56v24c0 17.7 14.3 32 32 32H72zm184-64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-112a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM0 304c0-26.5 21.5-48 48-48H464c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V304z'
      
    ]
  };

  

  
  

  var faPlusLarge = {
    prefix: 'fat',
    iconName: 'plus-large',
    icon: [
      512,
      512,
      [],
      'e59e',
      
      'M264 8c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 240H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H248V504c0 4.4 3.6 8 8 8s8-3.6 8-8V264l240 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-240 0L264 8z'
      
    ]
  };

  

  
  

  var faBellSchoolSlash = {
    prefix: 'fat',
    iconName: 'bell-school-slash',
    icon: [
      640,
      512,
      [],
      'f5d6',
      
      'M480 208C480 93.1 386.9 0 272 0c-42.8 0-82.6 12.9-115.6 35.1l13.3 10.5C199.3 26.8 234.4 16 272 16c106 0 192 86 192 192c0 21.7-3.6 42.5-10.2 61.9l13.3 10.5c8.4-22.5 12.9-46.9 12.9-72.4zM349.3 187.4c-8.9-33.6-39.1-58.5-75.2-59.4l75.2 59.4zM225.2 272.9l-5.3-4.2c1.7 1.5 3.5 2.9 5.3 4.2zM80 208c0-15.7 1.9-30.9 5.4-45.5L71.7 151.7c-5 17.9-7.7 36.8-7.7 56.3c0 59 24.6 112.2 64 150.1V464c0 26.5 21.5 48 48 48H336h32H496c8.5 0 16.4-2.7 22.9-7.2l-13.5-10.7c-2.9 1.2-6.1 1.9-9.4 1.9H403.8c7.6-8.5 12.2-19.7 12.2-32V423.5l-16-12.6V464c0 17.7-14.3 32-32 32H336 176c-17.7 0-32-14.3-32-32V372c35.3 27.6 79.7 44 128 44c36.7 0 71.3-9.5 101.2-26.2l-13.7-10.8c-26.2 13.5-56 21.1-87.5 21.1C166 400 80 314 80 208zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  

  
  

  var faBowlingBallPin = {
    prefix: 'fat',
    iconName: 'bowling-ball-pin',
    icon: [
      576,
      512,
      [],
      'e0c3',
      
      'M464 16c26.5 0 48 21.5 48 48v1.4c0 8.8-1.4 17.5-4.2 25.8l-13.6 40.8c-3 9.1-5 18.4-5.8 27.9H439.6c-.8-9.5-2.7-18.9-5.8-27.9L420.2 91.3C417.4 83 416 74.2 416 65.4V64c0-26.5 21.5-48 48-48zm39.6 213.8l38.2 67.9c12 21.3 18.3 45.3 18.3 69.8c0 25.2-6.7 49.9-19.4 71.7L507.4 496H420.6l-24.8-42.5c-3.5 4.4-7.2 8.7-11 12.9l22 37.7c2.9 4.9 8.1 7.9 13.8 7.9h86.8c5.7 0 11-3 13.8-7.9l33.2-56.9c14.1-24.2 21.6-51.7 21.6-79.8c0-27.2-7-53.9-20.3-77.6l-38.2-67.9c-8.9-15.7-13.5-33.5-13.5-51.5c0-11.3 1.8-22.5 5.4-33.3L523 96.3c3.3-10 5-20.4 5-30.9V64c0-35.3-28.7-64-64-64s-64 28.7-64 64v1.4c0 10.5 1.7 20.9 5 30.9l13.6 40.8c3.6 10.7 5.4 21.9 5.4 33.3c0 8-.9 15.9-2.7 23.6c3.6 7 6.9 14.3 9.9 21.7c5.1-12.6 8-26 8.7-39.7h48.3c.9 18.8 6.2 37.3 15.4 53.8zM208 112a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 400a208 208 0 1 0 0-416 208 208 0 1 0 0 416zm0-224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-80-48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faArrowDownAZ = {
    prefix: 'fat',
    iconName: 'arrow-down-a-z',
    icon: [
      576,
      512,
      ["sort-alpha-asc","sort-alpha-down"],
      'f15d',
      
      'M165.7 477.7l112-112c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L168 452.7V40c0-4.4-3.6-8-8-8s-8 3.6-8 8V452.7L53.7 354.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l112 112c3.1 3.1 8.2 3.1 11.3 0zM336 296c0 4.4 3.6 8 8 8H471.1L337.8 466.9c-2 2.4-2.4 5.7-1 8.5s4.1 4.6 7.2 4.6H488c4.4 0 8-3.6 8-8s-3.6-8-8-8H360.9L494.2 301.1c2-2.4 2.4-5.7 1-8.5s-4.1-4.6-7.2-4.6H344c-4.4 0-8 3.6-8 8zM416 32c-3 0-5.8 1.7-7.2 4.4L344.9 164.3l-.1 .3-23.9 47.8c-2 4-.4 8.8 3.6 10.7s8.8 .4 10.7-3.6L356.9 176H475.1l21.8 43.6c2 4 6.8 5.6 10.7 3.6s5.6-6.8 3.6-10.7l-23.9-47.8-.1-.3L423.2 36.4C421.8 33.7 419 32 416 32zm0 25.9L467.1 160H364.9L416 57.9z'
      
    ]
  };

  
    var faSortAlphaAsc = faArrowDownAZ;
  
    var faSortAlphaDown = faArrowDownAZ;
  

  
  

  var faCheckDouble = {
    prefix: 'fat',
    iconName: 'check-double',
    icon: [
      448,
      512,
      [],
      'f560',
      
      'M325.7 69.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L160 212.7 85.7 138.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l80 80c3.1 3.1 8.2 3.1 11.3 0l160-160zm112 112c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L160 436.7 21.7 298.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l144 144c3.1 3.1 8.2 3.1 11.3 0l272-272z'
      
    ]
  };

  

  
  

  var faPeopleDressSimple = {
    prefix: 'fat',
    iconName: 'people-dress-simple',
    icon: [
      512,
      512,
      [],
      'e218',
      
      'M128 16a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112A64 64 0 1 0 128 0a64 64 0 1 0 0 128zm-15.7 48h31.4c21.4 0 40.3 14.2 46.2 34.8L229 347.6c2.9 10.2-4.8 20.4-15.4 20.4H192 144 112 64 42.4c-10.6 0-18.3-10.2-15.4-20.4L66.1 210.8C72 190.2 90.8 176 112.3 176zM120 384h16v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h13.6c21.3 0 36.6-20.3 30.8-40.8L205.3 206.4c-7.9-27.5-33-46.4-61.5-46.4H112.3c-28.6 0-53.7 18.9-61.5 46.4L11.7 343.2C5.8 363.7 21.2 384 42.4 384H56v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384zm64 96c0 8.8-7.2 16-16 16s-16-7.2-16-16V384h32v96zm-80-96v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V384h32zM384 16a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112A64 64 0 1 0 384 0a64 64 0 1 0 0 128zm-15.7 48h31.4c21.4 0 40.3 14.2 46.2 34.8L485 347.6c2.9 10.2-4.8 20.4-15.4 20.4H448 400 368 320 298.4c-10.6 0-18.3-10.2-15.4-20.4l39.1-136.8c5.9-20.6 24.7-34.8 46.2-34.8zM376 384h16v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h13.6c21.3 0 36.6-20.3 30.8-40.8L461.3 206.4c-7.8-27.5-33-46.4-61.5-46.4H368.3c-28.6 0-53.7 18.9-61.5 46.4L267.7 343.2c-5.8 20.4 9.5 40.8 30.8 40.8H312v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384zm64 96c0 8.8-7.2 16-16 16s-16-7.2-16-16V384h32v96zm-80-96v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V384h32z'
      
    ]
  };

  

  
  

  var faVestPatches = {
    prefix: 'fat',
    iconName: 'vest-patches',
    icon: [
      448,
      512,
      [],
      'e086',
      
      'M120.4 0h-1.1H104 88C65.9 0 48 17.9 48 40V186.7c0 7.2-2 14.4-5.7 20.6L8 264.5c-5.2 8.7-8 18.7-8 28.8V472c0 22.1 17.9 40 40 40H176c-3.7-4.9-6.8-10.3-9.3-16H40c-13.3 0-24-10.7-24-24V293.3c0-7.2 2-14.4 5.7-20.6L56 215.5c5.2-8.7 8-18.7 8-28.8V40c0-13.3 10.7-24 24-24h16 15.3c6.7 0 12.7 4.2 15 10.4l60.3 162.3 8.7-22.6-46.8-126C170.2 52.5 191.7 64 224 64c31.1 0 52.2-10.7 66-22.5l-94 235c-2.6 6.6-4 13.7-4 20.8V472c0 22.1 17.9 40 40 40H408c22.1 0 40-17.9 40-40V293.3c0-10.1-2.8-20.1-8-28.8l-34.3-57.2c-3.7-6.2-5.7-13.3-5.7-20.6V40c0-22.1-17.9-40-40-40H344 328.2h-.7c-17 0-31.2 10.9-40.6 21.9C276.8 33.8 257.7 48 224 48s-52.8-14.2-63-26.1C151.6 10.9 137.4 0 120.4 0zm193 26.1C315.8 20 321.7 16 328.2 16H344h16c13.3 0 24 10.7 24 24V186.7c0 10.1 2.8 20.1 8 28.8l34.3 57.2c3.7 6.2 5.7 13.3 5.7 20.6V472c0 13.3-10.7 24-24 24H232c-13.3 0-24-10.7-24-24V297.2c0-5.1 1-10.1 2.9-14.9L313.4 26.1zM80 400a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM93.7 242.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L100.7 272 82.3 290.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L112 283.3l18.3 18.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L123.3 272l18.3-18.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L112 260.7 93.7 242.3zM320 256c-17.7 0-32 14.3-32 32v8 48c0 4.4 3.6 8 8 8h48 8c17.7 0 32-14.3 32-32s-14.3-32-32-32c0-17.7-14.3-32-32-32zm-16 32c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 4.4 3.6 8 8 8h8c8.8 0 16 7.2 16 16s-7.2 16-16 16h-8H304V296v-8z'
      
    ]
  };

  

  
  

  var faLaptopBinary = {
    prefix: 'fat',
    iconName: 'laptop-binary',
    icon: [
      640,
      512,
      [],
      'e5e7',
      
      'M128 48H512c26.5 0 48 21.5 48 48V352h16V96c0-35.3-28.7-64-64-64H128C92.7 32 64 60.7 64 96V352H80V96c0-26.5 21.5-48 48-48zM624 403.2c0 33.6-27.2 60.8-60.8 60.8H76.8C43.2 464 16 436.8 16 403.2c0-1.8 1.4-3.2 3.2-3.2H620.8c1.8 0 3.2 1.4 3.2 3.2zM19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480H563.2c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2H19.2zM200 120c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V152c0-17.7-14.3-32-32-32H200zm-16 32c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H200c-8.8 0-16-7.2-16-16V152zm120-32c-4.4 0-8 3.6-8 8s3.6 8 8 8h8v88c0 4.4 3.6 8 8 8s8-3.6 8-8V128c0-4.4-3.6-8-8-8H304zm88 32v48c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V152c0-17.7-14.3-32-32-32H424c-17.7 0-32 14.3-32 32zm32-16h16c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H424c-8.8 0-16-7.2-16-16V152c0-8.8 7.2-16 16-16zM192 280c-4.4 0-8 3.6-8 8s3.6 8 8 8h8v56h16V288c0-4.4-3.6-8-8-8H192zm248 8c0-4.4-3.6-8-8-8H416c-4.4 0-8 3.6-8 8s3.6 8 8 8h8v56h16V288zm-80 24c0-17.7-14.3-32-32-32H312c-17.7 0-32 14.3-32 32v40h16V312c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v40h16V312z'
      
    ]
  };

  

  
  

  var faTent = {
    prefix: 'fat',
    iconName: 'tent',
    icon: [
      576,
      512,
      [],
      'e57d',
      
      'M283.3 1.5c2.8-2 6.6-2 9.4 0L513.8 161.6c8.7 6.3 14.6 15.9 16.1 26.6l40.7 278c3.5 24.1-15.2 45.8-39.6 45.8H45c-24.4 0-43.1-21.7-39.6-45.8l40.7-278c1.6-10.7 7.4-20.3 16.1-26.6L283.3 1.5zM71.6 174.6c-5.2 3.8-8.7 9.6-9.7 16l-40.7 278C19.2 483 30.4 496 45 496H280V23.7L71.6 174.6zM426.6 496L296 255.5V496H426.6zm18.2 0H531c14.6 0 25.9-13 23.7-27.5L514 190.5c-.9-6.4-4.4-12.2-9.7-16L296 23.7V222L444.8 496z'
      
    ]
  };

  

  
  

  var faAlien = {
    prefix: 'fat',
    iconName: 'alien',
    icon: [
      448,
      512,
      [128125],
      'f8f5',
      
      'M224 16C109.1 16 16 109.1 16 224c0 61.9 34.2 120.2 76.1 168c41.7 47.5 89.1 82.6 111.6 98c5.7 3.9 12.7 6 20.3 6s14.6-2.1 20.3-6c22.4-15.4 69.9-50.5 111.6-98c42-47.8 76.2-106.1 76.2-168c0-114.9-93.1-208-208-208zM0 224C0 100.3 100.3 0 224 0S448 100.3 448 224c0 135.3-148.8 247.7-194.7 279.2c-8.6 5.9-18.9 8.8-29.3 8.8s-20.7-2.9-29.3-8.8C148.8 471.7 0 359.3 0 224zm368 0H336c-44.2 0-80 35.8-80 80h32c44.2 0 80-35.8 80-80zm-32-16h32c8.8 0 16 7.2 16 16c0 53-43 96-96 96H256c-8.8 0-16-7.2-16-16c0-53 43-96 96-96zM112 224H80c0 44.2 35.8 80 80 80h32c0-44.2-35.8-80-80-80zm96 80c0 8.8-7.2 16-16 16H160c-53 0-96-43-96-96c0-8.8 7.2-16 16-16h32c53 0 96 43 96 96z'
      
    ]
  };

  

  
  

  var faPersonCane = {
    prefix: 'fat',
    iconName: 'person-cane',
    icon: [
      448,
      512,
      [],
      'e53c',
      
      'M184 56a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm96 0A56 56 0 1 0 168 56a56 56 0 1 0 112 0zM136 248c0-4.4-3.6-8-8-8s-8 3.6-8 8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V360c0-4.4 3.6-8 8-8s8 3.6 8 8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V248c0-4.4-3.6-8-8-8s-8 3.6-8 8V480c0 8.8-7.2 16-16 16s-16-7.2-16-16V360c0-13.3-10.7-24-24-24s-24 10.7-24 24V480c0 8.8-7.2 16-16 16s-16-7.2-16-16V248zm224 88c13.3 0 24 10.7 24 24V504c0 4.4 3.6 8 8 8s8-3.6 8-8V360c0-22.1-17.9-40-40-40s-40 17.9-40 40v16c0 4.4 3.6 8 8 8s8-3.6 8-8V360c0-13.3 10.7-24 24-24zM122.7 175.7c9.3-19.4 28.9-31.7 50.4-31.7h43.6c18.8 0 36.3 9.4 46.7 25l81.9 123.4c2.4 3.7 7.4 4.7 11.1 2.2s4.7-7.4 2.2-11.1L276.7 160.2c-13.3-20.1-35.9-32.2-60-32.2H173.1c-27.6 0-52.8 15.8-64.8 40.7L40.8 308.5c-1.9 4-.3 8.8 3.7 10.7s8.8 .3 10.7-3.7l67.5-139.8z'
      
    ]
  };

  

  
  

  var faCloudRainbow = {
    prefix: 'fat',
    iconName: 'cloud-rainbow',
    icon: [
      576,
      512,
      [],
      'f73e',
      
      'M568 16C439.2 16 328.2 92.1 277.4 201.8c-3.9-3.9-8.1-7.6-12.5-11C319.1 77.9 434.5 0 568 0c4.4 0 8 3.6 8 8s-3.6 8-8 8zM447.8 292l-.4-.1c-.9-8.7-2.9-17.1-5.7-25C466.2 222.2 513.6 192 568 192c4.4 0 8 3.6 8 8s-3.6 8-8 8c-55.2 0-102.3 35-120.2 84zm-76-94.1C415.2 136.2 486.9 96 568 96c4.4 0 8 3.6 8 8s-3.6 8-8 8c-74.4 0-140.4 36.3-181.1 92.2c-4.8-2.5-9.9-4.6-15.1-6.4zm27 119c.8-4.1 1.3-8.4 1.3-12.8c0-35.3-28.7-64-64-64c-19.5 0-36.9 8.7-48.6 22.4c-3.5 4-8.7 6.1-13.9 5.5s-9.9-3.8-12.4-8.5C245 228.8 212.9 208 176 208c-53 0-96 43-96 96c0 6.1 .6 12.1 1.7 17.8c1.5 7.9-3.1 15.6-10.7 18.2C39 350.5 16 380.6 16 416c0 44.2 35.8 80 80 80H416c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.1 0-.3 0-.4 0c-.3 0-.6 0-.9 0c-4.8 .1-9.5-2-12.6-5.8s-4.3-8.7-3.4-13.4zM176 192c37.1 0 70 18.1 90.4 45.9c3.3 4.5 6.2 9.2 8.8 14.1c3.6-4.2 7.6-8 12-11.4C300.7 230.2 317.6 224 336 224c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c4.9 0 9.8 .4 14.5 1.1c46.2 7 81.5 46.8 81.5 94.9c0 53-43 96-96 96H96c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 318.1 64 311.1 64 304c0-61.9 50.1-112 112-112z'
      
    ]
  };

  

  
  

  var faCrosshairs = {
    prefix: 'fat',
    iconName: 'crosshairs',
    icon: [
      512,
      512,
      [],
      'f05b',
      
      'M264 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V48.2C139.5 52.3 52.3 139.5 48.2 248H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H48.2C52.3 372.5 139.5 459.7 248 463.8V504c0 4.4 3.6 8 8 8s8-3.6 8-8V463.8c108.5-4.1 195.7-91.3 199.8-199.8H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H463.8C459.7 139.5 372.5 52.3 264 48.2V8zM120 264c4.4 0 8-3.6 8-8s-3.6-8-8-8H64.2C68.2 148.3 148.3 68.2 248 64.2V120c0 4.4 3.6 8 8 8s8-3.6 8-8V64.2c99.7 4.1 179.8 84.2 183.8 183.8H392c-4.4 0-8 3.6-8 8s3.6 8 8 8h55.8c-4.1 99.7-84.2 179.8-183.8 183.8V392c0-4.4-3.6-8-8-8s-8 3.6-8 8v55.8C148.3 443.8 68.2 363.7 64.2 264H120zm112-8a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm64 0a40 40 0 1 0 -80 0 40 40 0 1 0 80 0z'
      
    ]
  };

  

  
  

  var faMusicMagnifyingGlass = {
    prefix: 'fat',
    iconName: 'music-magnifying-glass',
    icon: [
      640,
      512,
      [],
      'e662',
      
      'M352 399.3c98.6-8.1 176-90.7 176-191.3c0-106-86-192-192-192c-96.9 0-177 71.7-190.1 165l-16.8 5.6C139.8 81.8 228.4 0 336 0C450.9 0 544 93.1 544 208c0 54.6-21 104.2-55.4 141.3l149 149c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-149-149c-33.9 31.4-78.2 51.6-127.1 54.9c1.2-5 1.8-10.3 1.8-15.8v-.4zM293.5 182.6l-160 53.3c-3.3 1.1-5.5 4.1-5.5 7.6v49.4l176-58.7v-44c0-5.5-5.3-9.3-10.5-7.6zM304 368.2V251.1L128 309.8V464c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c19.1 0 36.3 6.3 48 16.2V304 243.5c0-10.3 6.6-19.5 16.4-22.8l160-53.3c15.5-5.2 31.6 6.4 31.6 22.8V240 392c0 .9-.1 1.7-.4 2.5c.3 1.8 .4 3.6 .4 5.5c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c19.1 0 36.3 6.3 48 16.2zm-12.3 52.9c8.6-6.4 12.3-14.1 12.3-21.1s-3.8-14.7-12.3-21.1s-21.1-10.9-35.7-10.9s-27.1 4.4-35.7 10.9s-12.3 14.1-12.3 21.1s3.8 14.7 12.3 21.1s21.1 10.9 35.7 10.9s27.1-4.4 35.7-10.9zm-192 64c8.6-6.4 12.3-14.1 12.3-21.1s-3.8-14.7-12.3-21.1S78.5 432 64 432s-27.1 4.4-35.7 10.9S16 456.9 16 464s3.8 14.7 12.3 21.1S49.5 496 64 496s27.1-4.4 35.7-10.9z'
      
    ]
  };

  

  
  

  var faTruck = {
    prefix: 'fat',
    iconName: 'truck',
    icon: [
      640,
      512,
      [9951,128666],
      'f0d1',
      
      'M64 16C37.5 16 16 37.5 16 64V352c0 26.5 21.5 48 48 48h3.3c10.4-36.9 44.4-64 84.7-64s74.2 27.1 84.7 64H400V64c0-26.5-21.5-48-48-48H64zm.4 400H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H352c35.3 0 64 28.7 64 64V96h58.7c10.6 0 20.8 4.2 28.3 11.7L596.3 201c7.5 7.5 11.7 17.7 11.7 28.3V400h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H575.6c.2 2.6 .4 5.3 .4 8c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-2.7 .1-5.4 .4-8H400 239.6c.2 2.6 .4 5.3 .4 8c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-2.7 .1-5.4 .4-8zM416 216H588c-.9-1.3-1.9-2.6-3-3.7L491.7 119c-4.5-4.5-10.6-7-17-7H416V216zm0 16V373.4c15.9-22.6 42.2-37.4 72-37.4c40.3 0 74.2 27.1 84.7 64H592V232H416zM224 424A72 72 0 1 0 80 424a72 72 0 1 0 144 0zm264 72a72 72 0 1 0 0-144 72 72 0 1 0 0 144z'
      
    ]
  };

  

  
  

  var faLandmark = {
    prefix: 'fat',
    iconName: 'landmark',
    icon: [
      512,
      512,
      [127963],
      'f66f',
      
      'M259.3 .7c-2.1-.9-4.5-.9-6.6 0L14.1 108.5C5.5 112.3 0 120.9 0 130.3V136c0 13.3 10.7 24 24 24H488c13.3 0 24-10.7 24-24v-5.7c0-9.4-5.5-18-14.1-21.9L259.3 .7zM20.7 123L256 16.8 491.3 123c2.9 1.3 4.7 4.1 4.7 7.3V136c0 4.4-3.6 8-8 8H24c-4.4 0-8-3.6-8-8v-5.7c0-3.1 1.8-6 4.7-7.3zM80 200c0-4.4-3.6-8-8-8s-8 3.6-8 8V376c0 4.4 3.6 8 8 8H440c4.4 0 8-3.6 8-8V200c0-4.4-3.6-8-8-8s-8 3.6-8 8V368H328V200c0-4.4-3.6-8-8-8s-8 3.6-8 8V368H200V200c0-4.4-3.6-8-8-8s-8 3.6-8 8V368H80V200zM40 432c-4.4 0-8 3.6-8 8s3.6 8 8 8H472c4.4 0 8-3.6 8-8s-3.6-8-8-8H40zM8 496c-4.4 0-8 3.6-8 8s3.6 8 8 8H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H8z'
      
    ]
  };

  

  
  

  var faHouseWindow = {
    prefix: 'fat',
    iconName: 'house-window',
    icon: [
      576,
      512,
      [],
      'e3b3',
      
      'M293.3 2c-3-2.7-7.6-2.7-10.6 0L2.7 250c-3.3 2.9-3.6 8-.7 11.3s8 3.6 11.3 .7L64 217.1V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V217.1L562.7 262c3.3 2.9 8.4 2.6 11.3-.7s2.6-8.4-.7-11.3L293.3 2zM80 448V202.9L288 18.7 496 202.9V448c0 26.5-21.5 48-48 48H128c-26.5 0-48-21.5-48-48zM240 184c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24h96c13.3 0 24-10.7 24-24V208c0-13.3-10.7-24-24-24H240zm-8 24c0-4.4 3.6-8 8-8h96c4.4 0 8 3.6 8 8v96c0 4.4-3.6 8-8 8H240c-4.4 0-8-3.6-8-8V208z'
      
    ]
  };

  

  
  

  var faHoseReel = {
    prefix: 'fat',
    iconName: 'hose-reel',
    icon: [
      640,
      512,
      [],
      'e41a',
      
      'M80 256C80 123.5 187.5 16 320 16s240 107.5 240 240v96H536.1c-.1 0-.1 0-.2 0H520c-4.4 0-8 3.6-8 8s3.6 8 8 8h8.8l14.2 128.1c-4 .5-7.1 3.8-7.1 7.9c0 4.4 3.6 8 8 8h7.9c.1 0 .1 0 .2 0h31.8c.1 0 .1 0 .2 0H592c4.4 0 8-3.6 8-8c0-4.1-3.1-7.5-7.1-7.9L607.2 368H616c4.4 0 8-3.6 8-8s-3.6-8-8-8H600.1c-.1 0-.1 0-.2 0H576V256C576 114.6 461.4 0 320 0S64 114.6 64 256s114.6 256 256 256c59.2 0 113.7-20.1 157.1-53.8c3.5-2.7 4.1-7.7 1.4-11.2s-7.7-4.1-11.2-1.4C426.6 477.2 375.5 496 320 496C187.5 496 80 388.5 80 256zM591.1 368L576.8 496H559.2L544.9 368H568h23.1zM320 408a152 152 0 1 1 0-304 152 152 0 1 1 0 304zM152 256a168 168 0 1 0 336 0 168 168 0 1 0 -336 0zm232 0a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zm-64-80a80 80 0 1 0 0 160 80 80 0 1 0 0-160z'
      
    ]
  };

  

  
  

  var faFamilyPants = {
    prefix: 'fat',
    iconName: 'family-pants',
    icon: [
      512,
      512,
      [],
      'e302',
      
      'M80 64a48 48 0 1 1 96 0A48 48 0 1 1 80 64zm112 0A64 64 0 1 0 64 64a64 64 0 1 0 128 0zM41.8 234.7c2.8-33.2 30.5-58.7 63.8-58.7h44.8c6.2 0 12.1 .9 17.8 2.5c.3-5.5 1.2-10.8 2.5-15.9c-6.5-1.7-13.3-2.6-20.2-2.6H105.6c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3c-2.2 26.7 12.2 50.6 34.2 62.1V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16V480c0 17.7 14.3 32 32 32c2.8 0 5.4-.3 8-1V493.9c-2.4 1.4-5.1 2.1-8 2.1c-8.8 0-16-7.2-16-16V352h8V336H144 112 85.6c-28.1 0-50.2-24-47.8-52l4.1-49.3zM344 512c17.7 0 32-14.3 32-32V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V344.8c22.1-11.5 36.4-35.4 34.2-62.1l-4.1-49.3C482.7 191.9 448 160 406.4 160H361.6c-7 0-13.8 .9-20.2 2.6c1.3 5.1 2.1 10.5 2.5 15.9c5.7-1.6 11.6-2.5 17.8-2.5h44.8c33.3 0 61 25.5 63.8 58.7l4.1 49.3c2.3 28-19.8 52-47.8 52H400 368 352v16h8V480c0 8.8-7.2 16-16 16c-2.9 0-5.6-.8-8-2.1V511c2.6 .7 5.2 1 8 1zM85.6 352H104V480c0 8.8-7.2 16-16 16s-16-7.2-16-16V350.6c4.4 .9 8.9 1.4 13.6 1.4zM336 64a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0A64 64 0 1 0 320 64a64 64 0 1 0 128 0zm-8 286.6V480c0 8.8-7.2 16-16 16s-16-7.2-16-16V352h18.4c4.7 0 9.2-.5 13.6-1.4zM216 184a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm96 0a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm-56 88c35.3 0 64 28.7 64 64v32c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V336c0-35.3 28.7-64 64-64zm-80 64v32c0 20.9 13.4 38.7 32 45.3V504c0 4.4 3.6 8 8 8s8-3.6 8-8V416h64v88c0 4.4 3.6 8 8 8s8-3.6 8-8V413.3c18.6-6.6 32-24.4 32-45.3V336c0-44.2-35.8-80-80-80s-80 35.8-80 80z'
      
    ]
  };

  

  
  

  var faPlateUtensils = {
    prefix: 'fat',
    iconName: 'plate-utensils',
    icon: [
      640,
      512,
      [58713],
      'e43b',
      
      'M8 16c-4.4 0-8 3.6-8 8V184c0 22.1 17.9 40 40 40H64V488c0 4.4 3.6 8 8 8s8-3.6 8-8V224h24c22.1 0 40-17.9 40-40V24c0-4.4-3.6-8-8-8s-8 3.6-8 8V184c0 13.3-10.7 24-24 24H80V24c0-4.4-3.6-8-8-8s-8 3.6-8 8V208H40c-13.3 0-24-10.7-24-24V24c0-4.4-3.6-8-8-8zM498 78.9C455.3 39.8 398.4 16 336 16c-61.5 0-117.5 23.1-160 61.1V99.2C216.7 57.7 273.3 32 336 32c60.3 0 115 23.8 155.3 62.5c2-5.5 4.3-10.7 6.7-15.6zm40.6 272.9C502.6 427.6 425.4 480 336 480c-91.4 0-170.1-54.8-204.9-133.3c-4.9 2-10.1 3.5-15.6 4.4C152.4 436.3 237.2 496 336 496c98.4 0 183-59.2 220-144H544c-1.8 0-3.7-.1-5.4-.2zM480 256a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-272 0a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zM618.6 32l0 0c.1 0 .2 0 .5 0c2.7 0 4.9 2.2 4.9 4.9V304H544c-8.8 0-16-7.2-16-16V160c0-89.7 74.6-122.1 90.6-128zM640 304V36.9c0-11.5-9.3-20.9-20.9-20.9c-2.1 0-4.1 .3-6.1 1C596.2 23.2 512 59.2 512 160V288c0 17.7 14.3 32 32 32h80V488c0 4.4 3.6 8 8 8s8-3.6 8-8V320v-8-8z'
      
    ]
  };

  

  
  

  var faPrescriptionBottleMedical = {
    prefix: 'fat',
    iconName: 'prescription-bottle-medical',
    icon: [
      384,
      512,
      ["prescription-bottle-alt"],
      'f486',
      
      'M344 16c13.3 0 24 10.7 24 24V88c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24V40c0-13.3 10.7-24 24-24H344zM40 0C17.9 0 0 17.9 0 40V88c0 22.1 17.9 40 40 40H344c22.1 0 40-17.9 40-40V40c0-22.1-17.9-40-40-40H40zM32 160V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V160H336V448c0 26.5-21.5 48-48 48H96c-26.5 0-48-21.5-48-48V160H32zm141.3 57.3c0-4.4 3.6-8 8-8h21.3c4.4 0 8 3.6 8 8v44c0 4.4 3.6 8 8 8l44 0c4.4 0 8 3.6 8 8v21.3c0 4.4-3.6 8-8 8h-44c-4.4 0-8 3.6-8 8v44c0 4.4-3.6 8-8 8H181.3c-4.4 0-8-3.6-8-8v-44c0-4.4-3.6-8-8-8h-44c-4.4 0-8-3.6-8-8V277.3c0-4.4 3.6-8 8-8h44c2.1 0 4.2-.8 5.7-2.3s2.3-3.5 2.3-5.7v-44zm8-24c-13.3 0-24 10.7-24 24v36h-36c-13.3 0-24 10.7-24 24v21.3c0 13.3 10.7 24 24 24h36v36c0 13.3 10.7 24 24 24h21.3c13.3 0 24-10.7 24-24v-36h36c13.3 0 24-10.7 24-24V277.3c0-13.3-10.7-24-24-24h-36v-36c0-13.3-10.7-24-24-24H181.3z'
      
    ]
  };

  
    var faPrescriptionBottleAlt = faPrescriptionBottleMedical;
  

  
  

  var faBraille = {
    prefix: 'fat',
    iconName: 'braille',
    icon: [
      640,
      512,
      [],
      'f2a1',
      
      'M64 48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112A64 64 0 1 0 64 32a64 64 0 1 0 0 128zm160 48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM16 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0A64 64 0 1 0 0 416a64 64 0 1 0 128 0zm48 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM16 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0A64 64 0 1 0 0 256a64 64 0 1 0 128 0zM176 96a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0A64 64 0 1 0 160 96a64 64 0 1 0 128 0zM416 48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM528 96a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0A64 64 0 1 0 512 96a64 64 0 1 0 128 0zM576 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-48 96a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM416 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-48 96a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM240 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM64 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM80 256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM416 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faCalendarClock = {
    prefix: 'fat',
    iconName: 'calendar-clock',
    icon: [
      576,
      512,
      ["calendar-time"],
      'e0d2',
      
      'M120 0c4.4 0 8 3.6 8 8V64H320V8c0-4.4 3.6-8 8-8s8 3.6 8 8V64h48c35.3 0 64 28.7 64 64v48 16 .7c-5.3-.5-10.6-.7-16-.7H16V448c0 26.5 21.5 48 48 48H311.2c6.1 5.8 12.7 11.1 19.6 16H64c-35.3 0-64-28.7-64-64V192 176 128C0 92.7 28.7 64 64 64h48V8c0-4.4 3.6-8 8-8zm-8 120V80H64c-26.5 0-48 21.5-48 48v48H432V128c0-26.5-21.5-48-48-48H336v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V80H128v40c0 4.4-3.6 8-8 8s-8-3.6-8-8zM432 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 64c4.4 0 8 3.6 8 8v64h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H432c-4.4 0-8-3.6-8-8V296c0-4.4 3.6-8 8-8z'
      
    ]
  };

  
    var faCalendarTime = faCalendarClock;
  

  
  

  var faClockDesk = {
    prefix: 'fat',
    iconName: 'clock-desk',
    icon: [
      448,
      512,
      [],
      'e134',
      
      'M16 224a208 208 0 1 1 416 0A208 208 0 1 1 16 224zm416 83.3V456c0 22.1-17.9 40-40 40H56c-22.1 0-40-17.9-40-40V307.3C49.1 389.8 129.7 448 224 448s174.9-58.2 208-140.7zM0 224V456c0 30.9 25.1 56 56 56H392c30.9 0 56-25.1 56-56V224C448 100.3 347.7 0 224 0S0 100.3 0 224zM224 96c-4.4 0-8 3.6-8 8V224c0 2.1 .8 4.2 2.3 5.7l56 56c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L232 220.7V104c0-4.4-3.6-8-8-8z'
      
    ]
  };

  

  
  

  var faCalendarCheck = {
    prefix: 'fat',
    iconName: 'calendar-check',
    icon: [
      448,
      512,
      [],
      'f274',
      
      'M128 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H64C28.7 64 0 92.7 0 128v48 16V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 176 128c0-35.3-28.7-64-64-64H336V8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H128V8zM16 192H432V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V192zM112 80v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80H320v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80h48c26.5 0 48 21.5 48 48v48H16V128c0-26.5 21.5-48 48-48h48zM333.7 285.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L208 388.7l-66.3-66.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l72 72c3.1 3.1 8.2 3.1 11.3 0l120-120z'
      
    ]
  };

  

  
  

  var faPlaneProp = {
    prefix: 'fat',
    iconName: 'plane-prop',
    icon: [
      576,
      512,
      [],
      'e22b',
      
      'M269.5 0c-11.7 0-21.7 8.4-23.7 20l-6.2 36H224c-22.1 0-40 17.9-40 40s17.9 40 40 40h2l-8.9 52.1L135.2 199l-14-58.7c-1.7-7.2-8.2-12.3-15.6-12.3H70.4c-7.5 0-14 5.2-15.6 12.5L38.7 211.8l0 0C16.5 214.8 0 233.7 0 256s16.5 41.2 38.7 44.2l0 0 16.1 71.4c1.6 7.3 8.1 12.5 15.6 12.5h35.3c7.4 0 13.8-5.1 15.6-12.3l14-58.7 81.9 10.9L226 376h-2c-22.1 0-40 17.9-40 40s17.9 40 40 40h15.7l6.2 36c2 11.5 12 20 23.7 20h37c11.7 0 21.7-8.4 23.7-20l6.2-36H384v16c0 4.4 3.6 8 8 8s8-3.6 8-8V424h8c4.4 0 8-3.6 8-8s-3.6-8-8-8h-8V360c0-4.4-3.6-8-8-8s-8 3.6-8 8v16H350l8.2-48 116.1 0c18.8 0 43.6-7.6 63.8-19.6C557.8 296.5 576 278.5 576 256c0-11.1-4.7-21.2-11.6-29.8s-16.2-16.1-26.3-22.2c-20.1-12.2-44.9-20-63.8-20H358.2L350 136h34v16c0 4.4 3.6 8 8 8s8-3.6 8-8V104h8c4.4 0 8-3.6 8-8s-3.6-8-8-8h-8V40c0-4.4-3.6-8-8-8s-8 3.6-8 8V56H336.3l-6.2-36c-2-11.5-12-20-23.7-20h-37zm69.6 72H384v48H347.3l-8.2-48zM236.9 72l-8.2 48H224c-13.3 0-24-10.7-24-24s10.7-24 24-24h12.9zM339.1 440l8.2-48H384v48H339.1zM228.7 392l8.2 48H224c-13.3 0-24-10.7-24-24s10.7-24 24-24h4.7zM342 184H248c-.4 0-.7 0-1.1 .1l-13.2 1.8L261.6 22.7c.7-3.8 4-6.7 7.9-6.7h37c3.9 0 7.2 2.8 7.9 6.7L342 184zm0 144L314.4 489.3c-.7 3.8-4 6.7-7.9 6.7h-37c-3.9 0-7.2-2.8-7.9-6.7L233.7 326.2l13.2 1.8c.4 0 .7 .1 1.1 .1h94zM70.4 144h35.3l15.7 65.7c1 4 4.8 6.6 8.8 6.1L248.5 200H474.3c15.3 0 37.3 6.7 55.5 17.7c9 5.5 16.7 11.8 22.1 18.5s8.1 13.4 8.1 19.8c0 13.5-11.5 27.5-30.2 38.6c-18.2 10.9-40.2 17.4-55.5 17.4l-225.8 0L130.2 296.2c-4.1-.5-7.9 2.1-8.8 6.1L105.7 368H70.4L53.1 291.2c-.7-3.3-3.4-5.7-6.7-6.2l-5.6-.7C26.6 282.4 16 270.3 16 256s10.6-26.4 24.8-28.3l5.6-.7c3.3-.4 6-2.9 6.7-6.2L70.4 144z'
      
    ]
  };

  

  
  

  var faNfcSignal = {
    prefix: 'fat',
    iconName: 'nfc-signal',
    icon: [
      512,
      512,
      [],
      'e1fb',
      
      'M384 48H64C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H225.1c-.5 5.3-.8 10.6-1 16H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V227c-5.4 .8-10.7 1.8-16 2.9V96c0-26.5-21.5-48-48-48zm-16 88V252.8c-5.4 2.8-10.8 5.8-16 8.9V136c0-4.4-3.6-8-8-8H240c-4.4 0-8 3.6-8 8v80.8c18.3 3.7 32 19.8 32 39.2c0 22.1-17.9 40-40 40s-40-17.9-40-40c0-19.4 13.7-35.5 32-39.2V136c0-13.3 10.7-24 24-24H344c13.3 0 24 10.7 24 24zM239 400H104c-13.3 0-24-10.7-24-24V136c0-13.3 10.7-24 24-24h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H104c-4.4 0-8 3.6-8 8V376c0 4.4 3.6 8 8 8H245.3c-2.3 5.2-4.3 10.6-6.3 16zM224 232a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm280 24c4.4 0 8 3.6 8 8s-3.6 8-8 8c-128.1 0-232 103.9-232 232c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-137 111-248 248-248zM464 480a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm48 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm0-120c0 4.4-3.6 8-8 8c-75.1 0-136 60.9-136 136c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-83.9 68.1-152 152-152c4.4 0 8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faStarSharpHalfStroke = {
    prefix: 'fat',
    iconName: 'star-sharp-half-stroke',
    icon: [
      576,
      512,
      ["star-sharp-half-alt"],
      'e28d',
      
      'M280 34.4V388.1L141.6 495.7c-.3 .2-.6 .3-.9 .3c-1 0-1.7-.9-1.4-1.9l52.3-171.8c.9-3.1-.1-6.4-2.5-8.5L49 197.1c-.7-.6-1-1.4-1-2.2c0-1.6 1.3-2.9 2.9-2.9H224c3.5 0 6.6-2.3 7.6-5.6L280 34.4zm16 353.7V34.4l48.4 152c1.1 3.3 4.1 5.6 7.6 5.6H525.1c1.6 0 2.9 1.3 2.9 2.9c0 .9-.4 1.7-1 2.2L386.9 313.9c-2.5 2.1-3.5 5.4-2.5 8.5l52.3 171.8c.3 .9-.4 1.9-1.4 1.9c-.3 0-.6-.1-.9-.3L296 388.1zM288 0c-8.2 0-15.5 5.3-18 13.2L218.2 176H50.9C40.5 176 32 184.5 32 194.9c0 5.6 2.5 10.9 6.8 14.5l136 113.3L124.1 489.5c-3.4 11.2 5 22.5 16.7 22.5c3.9 0 7.7-1.3 10.7-3.7L288 402.1 424.5 508.3c3.1 2.4 6.8 3.7 10.7 3.7c11.7 0 20.1-11.3 16.7-22.5L401.2 322.7l136-113.3c4.3-3.6 6.8-8.9 6.8-14.5c0-10.4-8.5-18.9-18.9-18.9H357.8L306 13.2C303.5 5.3 296.2 0 288 0z'
      
    ]
  };

  
    var faStarSharpHalfAlt = faStarSharpHalfStroke;
  

  
  

  var faWater = {
    prefix: 'fat',
    iconName: 'water',
    icon: [
      576,
      512,
      [],
      'f773',
      
      'M322.2 114.1c-10.1-9.2-19.6-19.5-27.6-30.7c-3-4.3-10.2-4.3-13.2 0c-8 11.2-17.5 21.4-27.6 30.7C236.6 129.8 214.5 144 192 144s-44.6-14.2-61.8-29.9c-10.1-9.2-19.7-19.5-27.6-30.7C101 81.3 98.6 80 96 80s-5.1 1.3-6.6 3.4c-7.3 10.3-15.9 19.6-25 28.3C48.7 126.5 28.3 140.9 7 143.6c-4.4 .6-7.5 4.6-6.9 8.9s4.6 7.5 8.9 6.9c26.5-3.3 50-20.7 66.4-36.1c8.8-8.3 15.9-16.4 20.6-22.2c5.2 6.4 13.2 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8l0 0 0 0c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c4.7 5.8 11.8 13.9 20.6 22.2c16.4 15.4 39.9 32.8 66.4 36.1c4.4 .6 8.4-2.6 8.9-6.9s-2.6-8.4-6.9-8.9c-21.3-2.7-41.7-17.1-57.4-31.9c-9.1-8.6-17.7-18-25-28.3c-1.5-2.1-3.9-3.4-6.6-3.4s-5.1 1.3-6.6 3.4c-7.9 11.2-17.5 21.5-27.6 30.7C428.6 129.8 406.5 144 384 144s-44.6-14.2-61.8-29.9zm0 288c-10.1-9.2-19.6-19.5-27.6-30.7c-3-4.3-10.2-4.3-13.2 0c-8 11.2-17.5 21.4-27.6 30.7C236.6 417.8 214.5 432 192 432s-44.6-14.2-61.8-29.9c-10.1-9.2-19.7-19.5-27.6-30.7c-1.5-2.1-3.9-3.4-6.6-3.4s-5.1 1.3-6.6 3.4c-7.3 10.3-15.9 19.6-25 28.3C48.7 414.5 28.3 428.9 7 431.6c-4.4 .6-7.5 4.6-6.9 8.9s4.6 7.5 8.9 6.9c26.5-3.3 50-20.7 66.4-36.1c8.8-8.3 15.9-16.4 20.6-22.2c5.2 6.4 13.2 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8l0 0 0 0c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c4.7 5.8 11.8 13.9 20.6 22.2c16.4 15.4 39.9 32.8 66.4 36.1c4.4 .6 8.4-2.6 8.9-6.9s-2.6-8.4-6.9-8.9c-21.3-2.7-41.7-17.1-57.4-31.9c-9.1-8.6-17.7-18-25-28.3c-1.5-2.1-3.9-3.4-6.6-3.4s-5.1 1.3-6.6 3.4c-7.9 11.2-17.5 21.5-27.6 30.7C428.6 417.8 406.5 432 384 432s-44.6-14.2-61.8-29.9zM294.6 227.4c-3-4.3-10.2-4.3-13.2 0c-8 11.2-17.5 21.4-27.6 30.7C236.6 273.8 214.5 288 192 288s-44.6-14.2-61.8-29.9c-10.1-9.2-19.7-19.5-27.6-30.7c-1.5-2.1-3.9-3.4-6.6-3.4s-5.1 1.3-6.6 3.4c-7.3 10.3-15.9 19.6-25 28.3C48.7 270.5 28.3 284.9 7 287.6c-4.4 .6-7.5 4.6-6.9 8.9s4.6 7.5 8.9 6.9c26.5-3.3 50-20.7 66.4-36.1c8.8-8.3 15.9-16.4 20.6-22.2c5.2 6.4 13.2 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8l0 0 0 0c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c4.7 5.8 11.8 13.9 20.6 22.2c16.4 15.4 39.9 32.8 66.4 36.1c4.4 .6 8.4-2.6 8.9-6.9s-2.6-8.4-6.9-8.9c-21.3-2.7-41.7-17.1-57.4-31.9c-9.1-8.6-17.7-18-25-28.3c-1.5-2.1-3.9-3.4-6.6-3.4s-5.1 1.3-6.6 3.4c-7.9 11.2-17.5 21.5-27.6 30.7C428.6 273.8 406.5 288 384 288s-44.6-14.2-61.8-29.9c-10.1-9.2-19.6-19.5-27.6-30.7z'
      
    ]
  };

  

  
  

  var faWaveform = {
    prefix: 'fat',
    iconName: 'waveform',
    icon: [
      640,
      512,
      [],
      'f8f1',
      
      'M320 0c4 0 7.4 3 7.9 7l56.6 438.7L440.1 70.8c.6-3.9 4-6.9 8-6.8s7.3 3 7.9 7l41.3 316.3 38.9-220.6c.7-3.7 3.8-6.4 7.5-6.6s7.1 2.3 8.1 5.9L582.1 280H632c4.4 0 8 3.6 8 8s-3.6 8-8 8H576c-3.6 0-6.8-2.4-7.7-5.9l-22.7-85L503.9 441.4c-.7 3.9-4.1 6.7-8.1 6.6s-7.2-3-7.8-7L447.5 130 391.9 505.2c-.6 4-4 6.9-8 6.8s-7.4-3-7.9-7L320 70.5 263.9 505c-.5 4-3.9 6.9-7.9 7s-7.4-2.9-8-6.8L192.5 130 151.9 441c-.5 3.9-3.8 6.9-7.8 7s-7.4-2.7-8.1-6.6L94.4 205l-22.7 85c-.9 3.5-4.1 5.9-7.7 5.9H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H57.9L88.3 165.9c1-3.6 4.3-6.1 8.1-5.9s6.9 2.9 7.5 6.6l38.9 220.6L184.1 71c.5-4 3.9-6.9 7.9-7s7.4 2.9 8 6.8l55.5 374.9L312.1 7c.5-4 3.9-7 7.9-7z'
      
    ]
  };

  

  
  

  var faTricycleAdult = {
    prefix: 'fat',
    iconName: 'tricycle-adult',
    icon: [
      640,
      512,
      [],
      'e5c4',
      
      'M296 64c-4.4 0-8 3.6-8 8s3.6 8 8 8h39.1c7.9 0 15.3 3.9 19.8 10.4l94.2 137.4L393.5 302c-8.5 11.3-21.8 18-36 18c-3.1 0-6.2-.3-9.2-1L158.8 279.4C142 264.8 120 256 96 256c-9.9 0-19.5 1.5-28.5 4.3L9.6 248.2c-4.3-.9-8.6 1.9-9.5 6.2s1.9 8.6 6.2 9.5l37.2 7.8C17.3 288.7 0 318.4 0 352c0 53 43 96 96 96s96-43 96-96c0-19.4-5.8-37.5-15.7-52.6l88 18.4c4.9 10.4 7.6 21.9 7.6 34.2c0 44.2-35.8 80-80 80c-11.9 0-23.2-2.6-33.3-7.3c-4.5 3.9-9.4 7.4-14.7 10.4c14.1 8.2 30.5 12.8 48 12.8c53 0 96-43 96-96c0-10.6-1.7-20.7-4.9-30.2L345 334.7c4.1 .9 8.3 1.3 12.5 1.3c19.2 0 37.3-9 48.8-24.4l52.4-69.8 24.6 35.9C461.8 295.2 448 322 448 352c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-17.3 0-33.5 4.6-47.5 12.6L368.1 81.4c-7.5-10.9-19.8-17.4-33-17.4H296zM464 352c0-24.5 11-46.4 28.4-61.1l45 65.6c2.5 3.6 7.5 4.6 11.1 2.1s4.6-7.5 2.1-11.1l-45-65.7c11.4-6.3 24.5-9.8 38.4-9.8c44.2 0 80 35.8 80 80s-35.8 80-80 80s-80-35.8-80-80zM95 432c-.8 0-1.5 0-2.3-.1C50 430.2 16 395.1 16 352c0-44.2 35.8-80 80-80c21.4 0 40.9 8.4 55.3 22.2l0 0C166.5 308.7 176 329.3 176 352c0 44.2-35.8 80-80 80c-.3 0-.7 0-1 0zM55.5 109.3c-1.5-4.2-6.1-6.3-10.3-4.8s-6.3 6.1-4.8 10.3l23 63.2c6.5 18 21.8 31.4 40.5 35.5l86.3 19.1c4.3 1 8.6-1.8 9.5-6.1s-1.8-8.6-6.1-9.5l-86.3-19.1c-13.4-3-24.3-12.5-29-25.4l-23-63.2z'
      
    ]
  };

  

  
  

  var faFileEps = {
    prefix: 'fat',
    iconName: 'file-eps',
    icon: [
      512,
      512,
      [],
      'e644',
      
      'M64 496h48v16H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H204.1c12.7 0 24.9 5.1 33.9 14.1L369.9 145.9c9 9 14.1 21.2 14.1 33.9V304H368V179.9c0-1.3-.1-2.6-.2-3.9H248c-22.1 0-40-17.9-40-40V16.2c-1.3-.2-2.6-.2-3.9-.2H64C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48zM361.1 160c-.8-1-1.6-1.9-2.4-2.7L226.7 25.4c-.9-.9-1.8-1.7-2.7-2.4V136c0 13.3 10.7 24 24 24H361.1zM168 376c0-4.4 3.6-8 8-8h64c4.4 0 8 3.6 8 8s-3.6 8-8 8H184v48h40c4.4 0 8 3.6 8 8s-3.6 8-8 8H184v48h56c4.4 0 8 3.6 8 8s-3.6 8-8 8H176c-4.4 0-8-3.6-8-8V440 376zm136-8h32c26.5 0 48 21.5 48 48s-21.5 48-48 48H312v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V456 376c0-4.4 3.6-8 8-8zm32 80c17.7 0 32-14.3 32-32s-14.3-32-32-32H312v64h24zm117.7-80H480c4.4 0 8 3.6 8 8s-3.6 8-8 8H453.7c-12 0-21.7 9.7-21.7 21.7c0 8.2 4.6 15.7 12 19.4l31.2 15.6c12.8 6.4 20.8 19.4 20.8 33.7c0 20.8-16.9 37.7-37.7 37.7H424c-4.4 0-8-3.6-8-8s3.6-8 8-8h34.3c12 0 21.7-9.7 21.7-21.7c0-8.2-4.6-15.7-12-19.4l-31.2-15.6C424.1 433 416 419.9 416 405.7c0-20.8 16.9-37.7 37.7-37.7z'
      
    ]
  };

  

  
  

  var faHandHoldingDroplet = {
    prefix: 'fat',
    iconName: 'hand-holding-droplet',
    icon: [
      576,
      512,
      ["hand-holding-water"],
      'f4c1',
      
      'M222.4 112.1L288 16.6l65.6 95.5c9.4 13.6 14.4 29.7 14.4 46.3V160c0 44.2-35.8 80-80 80s-80-35.8-80-80v-1.7c0-16.5 5-32.7 14.4-46.3zM209.2 103C198 119.3 192 138.6 192 158.3V160c0 53 43 96 96 96s96-43 96-96v-1.7c0-19.8-6-39-17.2-55.3L300.5 6.6C297.7 2.5 293 0 288 0s-9.7 2.5-12.5 6.6L209.2 103zM521.8 340.7c10.7-7.9 25.7-5.6 33.6 5.1s5.6 25.7-5.1 33.6L423.6 472.6C403 487.8 378.1 496 352.5 496H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L394.7 414.4c-1.4 1-3 1.6-4.7 1.6H268c-6.6 0-12-5.4-12-12s5.4-12 12-12h80c19.9 0 36-16.1 36-36s-16.1-36-36-36H193.7c-29.1 0-57.3 9.9-80 28L71 382.2c-1.4 1.1-3.2 1.8-5 1.8H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H66c5.4 0 10.7-1.9 15-5.3l42.7-34.2c19.9-15.9 44.5-24.5 70-24.5H348c11 0 20 9 20 20s-9 20-20 20H268c-15.5 0-28 12.5-28 28s12.5 28 28 28H389.9c5.1 0 10.1-1.6 14.2-4.7l117.6-86.6z'
      
    ]
  };

  
    var faHandHoldingWater = faHandHoldingDroplet;
  

  
  

  var faSquare4 = {
    prefix: 'fat',
    iconName: 'square-4',
    icon: [
      448,
      512,
      [],
      'e259',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm203 32.6c4.1 1.7 6 6.3 4.4 10.4L139.9 304H272V200c0-4.4 3.6-8 8-8s8 3.6 8 8V304h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H288v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V320H128c-2.7 0-5.2-1.3-6.6-3.5s-1.8-5-.8-7.5l72-176c1.7-4.1 6.3-6 10.4-4.4z'
      
    ]
  };

  

  
  

  var faBuoyMooring = {
    prefix: 'fat',
    iconName: 'buoy-mooring',
    icon: [
      576,
      512,
      [],
      'e5b6',
      
      'M280 8c0-4.4 3.6-8 8-8s8 3.6 8 8V48.3c51.3 3.6 94.2 41.7 103.3 93l45.2 254c-.4 .3-.9 .6-1.3 .9c-4.3 2.9-8.8 5.6-13.4 8L412 304H164L146.2 404.1c-4.6-2.4-9.1-5.1-13.4-8c-.4-.3-.9-.6-1.3-.9l45.2-254c9.1-51.3 52-89.4 103.3-93V8zm8 56c-47 0-87.3 33.7-95.5 80L166.9 288H409.1L383.5 144C375.3 97.7 335 64 288 64zm6.6 371.4c8 11.2 17.5 21.4 27.6 30.7C339.5 481.8 361.5 496 384 496s44.6-14.2 61.8-29.9c10.1-9.2 19.7-19.5 27.6-30.7c1.5-2.1 3.9-3.4 6.6-3.4s5.1 1.3 6.6 3.4c7.3 10.3 15.9 19.6 25 28.3c15.7 14.8 36.1 29.2 57.4 31.9c4.4 .6 7.5 4.6 6.9 8.9s-4.6 7.5-8.9 6.9c-26.5-3.3-50-20.7-66.4-36.1c-8.8-8.3-15.9-16.4-20.6-22.2c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8l0 0 0 0c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-4.7 5.8-11.8 13.9-20.6 22.2C59 490.7 35.5 508.1 9 511.4c-4.4 .6-8.4-2.6-8.9-6.9s2.6-8.4 6.9-8.9c21.3-2.7 41.7-17.1 57.4-31.9c9.1-8.6 17.7-18 25-28.3c1.5-2.1 3.9-3.4 6.6-3.4s5.1 1.3 6.6 3.4c7.9 11.2 17.5 21.5 27.6 30.7C147.4 481.8 169.5 496 192 496s44.6-14.2 61.8-29.9c10.1-9.2 19.6-19.5 27.6-30.7c3-4.3 10.2-4.3 13.2 0z'
      
    ]
  };

  

  
  

  var faArrowDown19 = {
    prefix: 'fat',
    iconName: 'arrow-down-1-9',
    icon: [
      576,
      512,
      ["sort-numeric-asc","sort-numeric-down"],
      'f162',
      
      'M436.4 33.3c-2.2-1.5-5.1-1.7-7.6-.7l-56 24c-4.1 1.7-5.9 6.4-4.2 10.5s6.4 5.9 10.5 4.2L424 52.1V208H376c-4.4 0-8 3.6-8 8s3.6 8 8 8h56 56c4.4 0 8-3.6 8-8s-3.6-8-8-8H440V40c0-2.7-1.4-5.2-3.6-6.7zM154.3 477.7c3.1 3.1 8.2 3.1 11.3 0l112-112c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L168 452.7V40c0-4.4-3.6-8-8-8s-8 3.6-8 8V452.7L53.7 354.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l112 112zm273.5-69.6A68 68 0 1 1 428 272a68 68 0 1 1 -.1 136.1zM428 424c7.5 0 14.8-1 21.7-2.8L410 466.7c-2.9 3.3-2.6 8.4 .8 11.3s8.4 2.6 11.3-.8l65-74.6c6.3-7.3 11.6-15.4 15.6-24c6-11.6 9.4-24.7 9.4-38.7c0-.6 0-1.3 0-1.9c0-.7 0-1.4 0-2.1h-.1c-2.1-44.5-38.9-80-83.9-80c-46.4 0-84 37.6-84 84s37.6 84 84 84z'
      
    ]
  };

  
    var faSortNumericAsc = faArrowDown19;
  
    var faSortNumericDown = faArrowDown19;
  

  
  

  var faSleigh = {
    prefix: 'fat',
    iconName: 'sleigh',
    icon: [
      640,
      512,
      [],
      'f7cc',
      
      'M8 32c-4.4 0-8 3.6-8 8s3.6 8 8 8H32V256c0 70.7 57.3 128 128 128v80H40c-4.4 0-8 3.6-8 8s3.6 8 8 8H576c35.3 0 64-28.7 64-64V392c0-4.4-3.6-8-8-8s-8 3.6-8 8v24c0 26.5-21.5 48-48 48H432V384h16c70.7 0 128-57.3 128-128V112h24c4.4 0 8-3.6 8-8s-3.6-8-8-8H576 560h-8H504c-22.1 0-40 17.9-40 40v47.3c0 31.3-25.5 56.7-56.8 56.7c-83.1 0-159.8-45.7-199.2-118.9C178.4 66.2 121.1 32 58.8 32H48 32 8zM416 464H176V384H416v80zM552 112h8V256c0 61.9-50.1 112-112 112H160C98.1 368 48 317.9 48 256V48H58.8c56.5 0 108.4 31 135.2 80.7C236.1 207.1 318.2 256 407.2 256c40.1 0 72.8-32.5 72.8-72.7V136c0-13.3 10.7-24 24-24h48z'
      
    ]
  };

  

  
  

  var faCarOn = {
    prefix: 'fat',
    iconName: 'car-on',
    icon: [
      512,
      512,
      [],
      'e4dd',
      
      'M264 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V120c0 4.4 3.6 8 8 8s8-3.6 8-8V8zM188.2 192H323.8c17.9 0 33.6 11.8 38.5 29l19.5 68.2c-4.5-.8-9-1.2-13.7-1.2H144c-4.7 0-9.3 .4-13.7 1.2L149.7 221c4.9-17.2 20.6-29 38.5-29zM112.3 293.8l-.2 .8C83.8 307 64 335.2 64 368v64 16 32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V448H368v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V448 432 368c0-32.8-19.8-61-48.1-73.4l-.2-.8-22.1-77.2c-6.9-24-28.8-40.6-53.8-40.6H188.2c-25 0-47 16.6-53.8 40.6l-22.1 77.2zM432 432H384 368 144 128 80V368c0-35.3 28.7-64 64-64H368c35.3 0 64 28.7 64 64v64zm-48 16h48v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V448zM80 448h48v32c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V448zm80-80a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm224 48a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM34.3 34.3c-3.1 3.1-3.1 8.2 0 11.3l80 80c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-80-80c-3.1-3.1-8.2-3.1-11.3 0zm432 0l-80 80c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l80-80c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0z'
      
    ]
  };

  

  
  

  var faMeteor = {
    prefix: 'fat',
    iconName: 'meteor',
    icon: [
      512,
      512,
      [9732],
      'f753',
      
      'M320 23.7c0-19.7-22.4-31-38.2-19.3l4.7 6.4-4.7-6.4L81.1 152.2C30.1 189.8 0 249.8 0 313.1C0 422.4 88.6 512 197.9 512c64.1 0 124.2-31 161.4-83.3L500.6 229.9C511.9 214 500.5 192 481 192H445.9L509.3 47.8c1.8-4.1 2.7-8.5 2.7-12.9V32c0-17.7-14.3-32-32-32h-3c-4.4 0-8.8 .9-12.9 2.7l3.2 7.3-3.2-7.3L320 66.1V23.7zm-28.7-6.4c5.3-3.9 12.7-.1 12.7 6.4V78.4c0 2.7 1.4 5.2 3.6 6.7s5.1 1.7 7.6 .6L470.6 17.4c2-.9 4.2-1.4 6.4-1.4h3c8.8 0 16 7.2 16 16v3c0 2.2-.5 4.4-1.4 6.4L426.3 196.8c-1.1 2.5-.9 5.3 .6 7.6s4 3.6 6.7 3.6H481c6.5 0 10.3 7.3 6.5 12.6L346.3 419.4c-34.1 48-89.4 76.6-148.3 76.6C97.5 496 16 413.7 16 313.1c0-58.3 27.7-113.5 74.6-148L291.3 17.2zM64 320a128 128 0 1 0 256 0A128 128 0 1 0 64 320zm16 0a112 112 0 1 1 224 0A112 112 0 1 1 80 320zm144 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48-80a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64z'
      
    ]
  };

  

  
  

  var faCartArrowUp = {
    prefix: 'fat',
    iconName: 'cart-arrow-up',
    icon: [
      576,
      512,
      [],
      'e3ee',
      
      'M0 8C0 3.6 3.6 0 8 0H45.7C64.8 0 81.2 13.5 84.9 32.3L131.8 272H473.9c18.6 0 34.7-12.8 39-30.9L560.2 38.2c1-4.3 5.3-7 9.6-6s7 5.3 6 9.6L528.4 244.7c-5.9 25.3-28.5 43.3-54.5 43.3h-339l9.3 47.7c3.7 18.8 20.1 32.3 39.3 32.3H504c4.4 0 8 3.6 8 8s-3.6 8-8 8H183.5c-26.8 0-49.8-19-55-45.2L69.2 35.4C67 24.1 57.1 16 45.7 16H8c-4.4 0-8-3.6-8-8zM176 496a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm320 48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM312 232V59.3l-66.3 66.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l80-80c3.1-3.1 8.2-3.1 11.3 0l80 80c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L328 59.3V232c0 4.4-3.6 8-8 8s-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faSquareVirus = {
    prefix: 'fat',
    iconName: 'square-virus',
    icon: [
      448,
      512,
      [],
      'e578',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM345.5 227.1c4.5 2.4 9.7 3.8 15.5 3.8c13.3 0 24 10.7 24 24s-10.7 24-24 24c-29.3 0-43.9 35.4-23.2 56.1c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-20.7-20.7-56.1-6-56.1 23.2c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-29.3-35.4-43.9-56.1-23.2c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c20.7-20.7 6-56.1-23.2-56.1c-13.3 0-24-10.7-24-24s10.7-24 24-24c29.3 0 43.9-35.4 23.2-56.1c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0c20.7 20.7 56.1 6 56.1-23.2c0-13.3 10.7-24 24-24s24 10.7 24 24c0 29.3 35.4 43.9 56.1 23.2c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-16.6 16.6-10.5 42.6 7.7 52.3zM223.8 109.6c-4.4 0-8 3.6-8 8c0 43.5-52.6 65.3-83.4 34.5c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3c30.8 30.8 9 83.4-34.5 83.4c-4.4 0-8 3.6-8 8s3.6 8 8 8c43.5 0 65.3 52.6 34.5 83.4c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0c30.8-30.8 83.4-9 83.4 34.5c0 4.4 3.6 8 8 8s8-3.6 8-8c0-43.5 52.6-65.3 83.4-34.5c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3c-30.8-30.8-9-83.4 34.5-83.4c4.4 0 8-3.6 8-8s-3.6-8-8-8c-43.5 0-65.3-52.6-34.5-83.4c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0c-30.8 30.8-83.4 9-83.4-34.5c0-4.4-3.6-8-8-8zM192 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm72 96a8 8 0 1 0 -16 0 8 8 0 1 0 16 0zm-32 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faCamera = {
    prefix: 'fat',
    iconName: 'camera',
    icon: [
      512,
      512,
      [62258,"camera-alt"],
      'f030',
      
      'M196.8 32c-20.7 0-39 13.2-45.5 32.8L140.9 96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H371.1L360.7 64.8C354.2 45.2 335.8 32 315.2 32H196.8zM166.5 69.9C170.8 56.8 183.1 48 196.8 48H315.2c13.8 0 26 8.8 30.4 21.9l12.2 36.6c1.1 3.3 4.1 5.5 7.6 5.5H448c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V160c0-26.5 21.5-48 48-48h82.7c3.4 0 6.5-2.2 7.6-5.5l12.2-36.6zM256 400a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM160 288a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z'
      
    ]
  };

  
    var faCameraAlt = faCamera;
  

  
  

  var faCameraPolaroid = {
    prefix: 'fat',
    iconName: 'camera-polaroid',
    icon: [
      576,
      512,
      [],
      'f8aa',
      
      'M64 464H512c26.5 0 48-21.5 48-48V371.4c0-6.7-1.4-13.3-4.1-19.4H20.1c-2.7 6.1-4.1 12.7-4.1 19.4V416c0 26.5 21.5 48 48 48zM546.1 336l-44.7-67.1c-3.5-5.3-5.4-11.4-5.4-17.8V96c0-26.5-21.5-48-48-48H128c-26.5 0-48 21.5-48 48V251.2c0 6.3-1.9 12.5-5.4 17.8L29.9 336H546.1zM512 480H64c-35.3 0-64-28.7-64-64V371.4c0-12.6 3.7-25 10.7-35.5L61.3 260c1.8-2.6 2.7-5.7 2.7-8.9V96c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V251.2c0 3.2 .9 6.2 2.7 8.9l50.6 75.8c7 10.5 10.7 22.9 10.7 35.5V416c0 35.3-28.7 64-64 64zM416 160a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-16-32a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zM208 192a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm80 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM104 400H472c4.4 0 8 3.6 8 8s-3.6 8-8 8H104c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faCloudMeatball = {
    prefix: 'fat',
    iconName: 'cloud-meatball',
    icon: [
      512,
      512,
      [],
      'f73b',
      
      'M398.7 131.4c-.9 4.7 .4 9.6 3.5 13.3s7.7 5.8 12.5 5.7c.4 0 .9 0 1.3 0c43.5 0 80 37.2 80 84.8s-36.5 84.8-80 84.8H372.8c2.3 5.2 3.9 10.5 4.9 16H416c53 0 96-45.1 96-100.8c0-50.5-35.4-92.3-81.5-99.7c-4.7-.7-9.5-1.1-14.5-1.1c-.5 0-1.1 0-1.6 0c1-5.2 1.6-10.5 1.6-16l0-.8c0-46.4-35.8-84-80-84c-18.4 0-35.4 6.5-48.9 17.5c-4.3 3.5-8.3 7.5-11.8 11.8c-2.5-5.1-5.4-9.9-8.6-14.5C246.3 19.1 213.3 0 176 0C114.1 0 64 52.7 64 117.6c0 7.5 .7 14.8 1.9 21.8C27.6 152.7 0 190.6 0 235.2C0 290.9 43 336 96 336h38.3c1-5.5 2.6-10.8 4.9-16H96c-43.5 0-80-37.2-80-84.8c0-38 23.5-69.7 55.2-80.6c7.4-2.6 11.9-10.2 10.5-17.9c-1.1-6.2-1.7-12.5-1.7-19C80 60.7 123.7 16 176 16c36.5 0 68.6 21.6 84.9 54.1c2.4 4.9 7.2 8.1 12.5 8.7s10.7-1.6 14.2-5.8c11.9-14.6 29.2-23.5 48.4-23.5c34.6 0 64 29.7 64 68c0 4.7-.5 9.3-1.3 13.8zM232.2 324.6C233.9 313 243.9 304 256 304s22.1 9 23.8 20.6c.4 2.8 2.2 5.2 4.9 6.3s5.6 .7 7.9-1c9.4-7.1 22.8-6.3 31.4 2.2s9.3 22 2.2 31.4c-1.7 2.3-2.1 5.3-1 7.9s3.5 4.5 6.3 4.9C343 377.9 352 387.9 352 400s-9 22.1-20.6 23.8c-2.8 .4-5.2 2.2-6.3 4.9s-.7 5.6 1 7.9c7.1 9.4 6.3 22.8-2.2 31.4s-22 9.3-31.4 2.2c-2.3-1.7-5.3-2.1-7.9-1s-4.5 3.5-4.9 6.3C278.1 487 268.1 496 256 496s-22.1-9-23.8-20.6c-.4-2.8-2.2-5.2-4.9-6.3s-5.6-.7-7.9 1c-9.4 7.1-22.8 6.3-31.4-2.2s-9.3-22-2.2-31.4c1.7-2.3 2.1-5.3 1-7.9s-3.5-4.5-6.3-4.9C169 422.1 160 412.1 160 400s9-22.1 20.6-23.8c2.8-.4 5.2-2.2 6.3-4.9s.7-5.6-1-7.9c-7.1-9.4-6.3-22.8 2.2-31.4s22-9.3 31.4-2.2c2.3 1.7 5.3 2.1 7.9 1s4.5-3.5 4.9-6.3zM256 288c-16.3 0-30.3 9.8-36.6 23.7c-14.3-5.5-31.1-2.5-42.6 9.1s-14.5 28.3-9.1 42.6c-14 6.2-23.7 20.2-23.7 36.6s9.8 30.3 23.7 36.6c-5.5 14.3-2.5 31.1 9.1 42.6s28.3 14.5 42.6 9.1c6.2 14 20.3 23.7 36.6 23.7s30.3-9.8 36.6-23.7c14.3 5.5 31.1 2.5 42.6-9.1s14.5-28.3 9.1-42.6c14-6.2 23.7-20.2 23.7-36.6s-9.8-30.3-23.7-36.6c5.5-14.3 2.5-31.1-9.1-42.6s-28.3-14.5-42.6-9.1c-6.2-14-20.3-23.7-36.6-23.7zM16 400a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0A48 48 0 1 0 0 400a48 48 0 1 0 96 0zm368-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faMessageHeart = {
    prefix: 'fat',
    iconName: 'message-heart',
    icon: [
      512,
      512,
      [],
      'e5c9',
      
      'M176 416c0-8.8-7.2-16-16-16H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H309.3c-3.5 0-6.8 1.1-9.6 3.2L176 496V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h80 16v16 64c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm96 169.9c0-23.2 18.8-41.9 41.9-41.9c11.1 0 21.8 4.4 29.7 12.3L250.3 159c1.5 1.5 3.5 2.3 5.7 2.3s4.2-.8 5.7-2.3l18.7-18.7c7.9-7.9 18.5-12.3 29.7-12.3c23.2 0 41.9 18.8 41.9 41.9v.6c0 10.6-4 20.9-11.2 28.8l-78.9 86.1c-1.5 1.7-3.7 2.6-5.9 2.6s-4.4-.9-5.9-2.6l-78.9-86.1c-7.2-7.8-11.2-18.1-11.2-28.8v-.6zM201.9 112c-32 0-57.9 25.9-57.9 57.9v.6c0 14.7 5.5 28.8 15.4 39.6l78.9 86.1c4.5 5 11 7.8 17.7 7.8s13.1-2.8 17.7-7.8l78.9-86.1c9.9-10.8 15.4-24.9 15.4-39.6v-.6c0-32-25.9-57.9-57.9-57.9c-15.4 0-30.1 6.1-41 17L256 142.1 242.9 129c-10.9-10.9-25.6-17-41-17z'
      
    ]
  };

  

  
  

  var faHammerCrash = {
    prefix: 'fat',
    iconName: 'hammer-crash',
    icon: [
      640,
      512,
      [],
      'e414',
      
      'M72 32c-6.1 0-11.6 3.4-14.3 8.8l-40 80c-4 7.9-.7 17.5 7.2 21.5l288 144c7.9 4 17.5 .7 21.5-7.2l64-128c4-7.9 .7-17.5-7.2-21.5l-192-96c-2.2-1.1-4.7-1.7-7.2-1.7H72zM43.4 33.7C48.8 22.8 59.9 16 72 16H192c5 0 9.9 1.2 14.3 3.4l192 96c15.8 7.9 22.2 27.1 14.3 42.9l-64 128c-7.9 15.8-27.1 22.2-42.9 14.3l-97.9-48.9 0 0-14.3-7.2 0 0-57.2-28.6 0 0L122 208.8l0 0L17.7 156.6C1.9 148.7-4.5 129.5 3.4 113.7l40-80zM5.1 442.5L107.7 237.4l14.3 7.2L19.4 449.7c-7.9 15.8-1.5 35 14.3 42.9l-7.2 14.3C2.8 495.1-6.8 466.3 5.1 442.5zm21.5 64.4l7.2-14.3c15.8 7.9 35 1.5 42.9-14.3L179.2 273.2l14.3 7.2L90.9 485.5c-11.9 23.7-40.7 33.3-64.4 21.5zM282.9 380.3L295.1 331c5 2.1 10.2 3.6 15.4 4.3l-12.1 48.8 97.1-48.9c3.3-1.7 7.3-.9 9.7 1.9l66.5 77.8 22.3-97.8c.8-3.7 4.2-6.3 7.9-6.2l108.7 2-69.3-83.8c-2.4-3-2.4-7.2 0-10.2l69.3-83.8-108.7 2c-3.8 .1-7.1-2.5-7.9-6.2L471.8 33.1 421.3 92c-2.7-1.9-5.6-3.7-8.7-5.3L407.1 84l52.5-61.3c8.6-10 24.8-6 27.8 6.8L508.2 121l102.2-1.8c13.7-.2 21.3 15.7 12.6 26.2L558 224l65.1 78.7c8.7 10.5 1.1 26.4-12.6 26.2L508.2 327l-20.9 91.4c-2.9 12.8-19.2 16.8-27.8 6.8l-62.4-73-91.5 46.1c-12.2 6.2-26-4.9-22.7-18.1z'
      
    ]
  };

  

  
  

  var faFishingRod = {
    prefix: 'fat',
    iconName: 'fishing-rod',
    icon: [
      448,
      512,
      [],
      'e3a8',
      
      'M296.7 16c-4.9 0-9.8 .8-14.5 2.3L199.7 44.8C123.6 69.2 72 140 72 220v68H88c22.1 0 40 17.9 40 40V472c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V328c0-22.1 17.9-40 40-40H56V220c0-86.9 56.1-163.8 138.8-190.4L277.3 3c6.3-2 12.8-3 19.4-3c35 0 63.3 28.4 63.3 63.3V152c0 4.4-3.6 8-8 8s-8-3.6-8-8V63.3C344 37.2 322.8 16 296.7 16zm51.5 193c2.4-1.3 5.3-1.3 7.7 0c30.1 16.4 92.2 61.7 92.2 143c0 33-14.5 73.3-56.1 106l25.6 41.8c1.5 2.5 1.6 5.6 .2 8.1s-4.1 4.1-7 4.1H293.3c-2.9 0-5.6-1.6-7-4.1s-1.4-5.6 .2-8.1L312.1 458C270.5 425.3 256 385 256 352c0-81.3 62.1-126.6 92.2-143zM272 352c0 29.4 13.4 67 55.4 97.5c3.4 2.5 4.3 7.1 2.1 10.6L307.6 496h88.8l-21.9-35.8c-2.2-3.6-1.3-8.2 2.1-10.6C418.6 419 432 381.4 432 352c0-69.1-50.6-109.8-80-126.8c-29.4 17-80 57.7-80 126.8zM88 304H40c-13.3 0-24 10.7-24 24V472c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V328c0-13.3-10.7-24-24-24zm280-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faCircleInfo = {
    prefix: 'fat',
    iconName: 'circle-info',
    icon: [
      512,
      512,
      ["info-circle"],
      'f05a',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 352c-4.4 0-8 3.6-8 8s3.6 8 8 8h96c4.4 0 8-3.6 8-8s-3.6-8-8-8H264V216c0-4.4-3.6-8-8-8H224c-4.4 0-8 3.6-8 8s3.6 8 8 8h24V352H208zm48-176a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  
    var faInfoCircle = faCircleInfo;
  

  
  

  var faSlashBack = {
    prefix: 'fat',
    iconName: 'slash-back',
    icon: [
      320,
      512,
      [],
      '5c',
      
      'M3.8 1.2C0 3.5-1.1 8.4 1.2 12.2l304 496c2.3 3.8 7.2 4.9 11 2.6s4.9-7.2 2.6-11L14.8 3.8C12.5 0 7.6-1.1 3.8 1.2z'
      
    ]
  };

  

  
  

  var faUserDoctor = {
    prefix: 'fat',
    iconName: 'user-doctor',
    icon: [
      448,
      512,
      ["user-md"],
      'f0f0',
      
      'M224 240a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM352 128A128 128 0 1 1 96 128a128 128 0 1 1 256 0zM152 322v46.7c22.7 3.8 40 23.6 40 47.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-23.8 17.3-43.5 40-47.3V325.3C66.9 343.5 16 406.4 16 481.2c0 8.2 6.6 14.8 14.8 14.8H417.2c8.2 0 14.8-6.6 14.8-14.8c0-74.8-50.9-137.7-120-155.9v43.4c22.7 3.8 40 23.6 40 47.3v40c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8s3.6-8 8-8h8V416c0-17.7-14.3-32-32-32s-32 14.3-32 32v32h8c4.4 0 8 3.6 8 8s-3.6 8-8 8H264c-4.4 0-8-3.6-8-8V416c0-23.8 17.3-43.5 40-47.3V322c-8.2-1.3-16.6-2-25.2-2H177.2c-8.6 0-17 .7-25.2 2zm-8 62a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM0 481.2C0 383.3 79.3 304 177.2 304h93.6C368.7 304 448 383.3 448 481.2c0 17-13.8 30.8-30.8 30.8H30.8C13.8 512 0 498.2 0 481.2z'
      
    ]
  };

  
    var faUserMd = faUserDoctor;
  

  
  

  var faMeterBolt = {
    prefix: 'fat',
    iconName: 'meter-bolt',
    icon: [
      640,
      512,
      [],
      'e1e9',
      
      'M256 496c71.1 0 134.9-30.9 178.9-80h15.4l-7.5 15c-46.7 49.8-113.1 81-186.8 81C114.6 512 0 397.4 0 256S114.6 0 256 0C393 0 504.8 107.5 511.7 242.8L496 255.3C495.6 123.1 388.3 16 256 16C123.5 16 16 123.5 16 256s107.5 240 240 240zM176 160c0-8.8-7.2-16-16-16s-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V160zm-48 0c0-17.7 14.3-32 32-32s32 14.3 32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160zm144 32V160c0-8.8-7.2-16-16-16s-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16zm-16-64c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32zm112 32c0-8.8-7.2-16-16-16s-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V160zm-48 0c0-17.7 14.3-32 32-32s32 14.3 32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160zM539.6 344.8L592 240 432 368h70.1c5.5 0 10.7 2.9 13.6 7.6s3.2 10.6 .7 15.6L464 496 624 368H553.9c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6zm66.7-97.7L561.9 336l-8 16h17.9H624c6.8 0 12.9 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L494.1 400l8-16H484.2 432c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1s7.6 12.9 4.2 19.6z'
      
    ]
  };

  

  
  

  var faHouseChimneyBlank = {
    prefix: 'fat',
    iconName: 'house-chimney-blank',
    icon: [
      576,
      512,
      [],
      'e3b0',
      
      'M293.3 2c-3-2.7-7.6-2.7-10.6 0L2.7 250c-3.3 2.9-3.6 8-.7 11.3s8 3.6 11.3 .7L64 217.1V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V217.1L562.7 262c3.3 2.9 8.4 2.6 11.3-.7s2.6-8.4-.7-11.3L512 195.7V56c0-13.3-10.7-24-24-24H408c-13.3 0-24 10.7-24 24V82.3L293.3 2zM384 103.7v.3h.3L496 202.9V448c0 26.5-21.5 48-48 48H128c-26.5 0-48-21.5-48-48V202.9L288 18.7l96 85zm16-7.2V56c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8V181.5l-96-85z'
      
    ]
  };

  

  
  

  var faHouseHeart = {
    prefix: 'fat',
    iconName: 'house-heart',
    icon: [
      576,
      512,
      ["home-heart"],
      'f4c9',
      
      'M293.3 2c-3-2.7-7.6-2.7-10.6 0L2.7 250c-3.3 2.9-3.6 8-.7 11.3s8 3.6 11.3 .7L64 217.1V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V217.1L562.7 262c3.3 2.9 8.4 2.6 11.3-.7s2.6-8.4-.7-11.3L293.3 2zM80 448V202.9L288 18.7 496 202.9V448c0 26.5-21.5 48-48 48H128c-26.5 0-48-21.5-48-48zM192 281.9c0-23.2 18.8-41.9 41.9-41.9c11.1 0 21.8 4.4 29.7 12.3L282.3 271c1.5 1.5 3.5 2.3 5.7 2.3s4.2-.8 5.7-2.3l18.7-18.7c7.9-7.9 18.5-12.3 29.7-12.3c23.2 0 41.9 18.8 41.9 41.9v.6c0 10.6-4 20.9-11.2 28.8l-78.9 86.1c-1.5 1.7-3.7 2.6-5.9 2.6s-4.4-.9-5.9-2.6l-78.9-86.1c-7.2-7.8-11.2-18.1-11.2-28.8v-.6zM233.9 224c-32 0-57.9 25.9-57.9 57.9v.6c0 14.7 5.5 28.8 15.4 39.6l78.9 86.1c4.5 5 11 7.8 17.7 7.8s13.1-2.8 17.7-7.8l78.9-86.1c9.9-10.8 15.4-24.9 15.4-39.6v-.6c0-32-25.9-57.9-57.9-57.9c-15.4 0-30.1 6.1-41 17L288 254.1 274.9 241c-10.9-10.9-25.6-17-41-17z'
      
    ]
  };

  
    var faHomeHeart = faHouseHeart;
  

  
  

  var faFileXmark = {
    prefix: 'fat',
    iconName: 'file-xmark',
    icon: [
      384,
      512,
      ["file-times"],
      'f317',
      
      'M64 496c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm50.3 242.3c-3.1 3.1-3.1 8.2 0 11.3L180.7 320l-66.3 66.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L192 331.3l66.3 66.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L203.3 320l66.3-66.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L192 308.7l-66.3-66.3c-3.1-3.1-8.2-3.1-11.3 0z'
      
    ]
  };

  
    var faFileTimes = faFileXmark;
  

  
  

  var faMountain = {
    prefix: 'fat',
    iconName: 'mountain',
    icon: [
      512,
      512,
      [127956],
      'f6fc',
      
      'M496 424.1c0 22-17.9 39.9-39.9 39.9H55.9c-22 0-39.9-17.9-39.9-39.9c0-7.5 2.1-14.9 6.1-21.2L130.6 229.9l55.7 55.7c3.1 3.1 8.2 3.1 11.3 0L259.3 224H377.7L489.9 402.9c4 6.4 6.1 13.7 6.1 21.2zM367.6 208H256c-2.1 0-4.2 .8-5.7 2.3L192 268.7l-50.3-50.3-2.3-2.3L238.8 57.5C242.5 51.6 249 48 256 48s13.5 3.6 17.2 9.5L367.6 208zM55.9 480H456.1c30.9 0 55.9-25 55.9-55.9c0-10.5-3-20.8-8.6-29.7L286.8 49c-6.6-10.6-18.3-17-30.8-17s-24.1 6.4-30.8 17L8.6 394.4C3 403.3 0 413.6 0 424.1C0 455 25 480 55.9 480z'
      
    ]
  };

  

  
  

  var faHourglass = {
    prefix: 'fat',
    iconName: 'hourglass',
    icon: [
      384,
      512,
      [9203,62032,"hourglass-empty"],
      'f254',
      
      'M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8H32V71.2c0 48.3 23 93.7 61.8 122.4L178.5 256 93.8 318.4C55 347 32 392.5 32 440.8V496H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H376c4.4 0 8-3.6 8-8s-3.6-8-8-8H352V440.8c0-48.3-23-93.7-61.8-122.4L205.5 256l84.7-62.4C329 165 352 119.5 352 71.2V16h24c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zM336 16V71.2c0 43.2-20.5 83.9-55.3 109.5L192 246.1l-88.7-65.3C68.5 155.1 48 114.4 48 71.2V16H336zM192 265.9l88.7 65.3c34.8 25.6 55.3 66.3 55.3 109.5V496H48V440.8c0-43.2 20.5-83.9 55.3-109.5L192 265.9z'
      
    ]
  };

  
    var faHourglassEmpty = faHourglass;
  

  
  

  var faNfcTrash = {
    prefix: 'fat',
    iconName: 'nfc-trash',
    icon: [
      640,
      512,
      [],
      'e1fd',
      
      'M64 48H384c26.5 0 48 21.5 48 48v80c4.2-5.6 9.7-9.9 16-12.7V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H381.6l-1.1-16H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48zM368 216V136c0-13.3-10.7-24-24-24H240c-13.3 0-24 10.7-24 24v80.8c-18.3 3.7-32 19.8-32 39.2c0 22.1 17.9 40 40 40s40-17.9 40-40c0-19.4-13.7-35.5-32-39.2V136c0-4.4 3.6-8 8-8H344c4.4 0 8 3.6 8 8v80h16l0 0zM352 376c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8V136c0-4.4 3.6-8 8-8h48c4.4 0 8-3.6 8-8s-3.6-8-8-8H104c-13.3 0-24 10.7-24 24V376c0 13.3 10.7 24 24 24H344c13.3 0 24-10.7 24-24V289.1l-.7-9.1H352v96zM248 256a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm208.8-59.6L435.1 240H392c-4.4 0-8 3.6-8 8s3.6 8 8 8h48H584h48c4.4 0 8-3.6 8-8s-3.6-8-8-8H588.9l-21.8-43.6c-1.4-2.7-4.1-4.4-7.2-4.4H464c-3 0-5.8 1.7-7.2 4.4zM452.9 240l16-32h86.1l16 32H452.9zM400 288.1l13.9 194.2C415.1 499 429 512 445.8 512H578.2c16.8 0 30.7-13 31.9-29.7L624 288.1H608l-13.8 193c-.6 8.4-7.6 14.9-16 14.9H445.8c-8.4 0-15.4-6.5-16-14.9L416 288.1H400z'
      
    ]
  };

  

  
  

  var faTruckFieldUn = {
    prefix: 'fat',
    iconName: 'truck-field-un',
    icon: [
      640,
      512,
      [],
      'e58e',
      
      'M96 48C69.5 48 48 69.5 48 96v32 16V272v16 80H75.3c10.4-36.9 44.4-64 84.7-64s74.2 27.1 84.7 64H368V224 208 104 96c0-26.5-21.5-48-48-48H96zM32 368V288c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32V96c0-35.3 28.7-64 64-64H320c35.3 0 64 28.7 64 64h52.2c15.1 0 29 8.6 35.8 22.1L516.9 208H544c35.3 0 64 28.7 64 64v96h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H608 592 567.6c.2 2.6 .4 5.3 .4 8c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-2.7 .1-5.4 .4-8H384 368 247.6c.2 2.6 .4 5.3 .4 8c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-2.7 .1-5.4 .4-8H48 32 8c-4.4 0-8-3.6-8-8s3.6-8 8-8H32zm0-224c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16V144zm352 64H499.1l-41.4-82.7c-4.1-8.1-12.4-13.3-21.5-13.3H384v96zm0 16V368h11.3c10.4-36.9 44.4-64 84.7-64s74.2 27.1 84.7 64H592V272c0-26.5-21.5-48-48-48H512.2h-.3H384zM238.5 131.4L304 223V136c0-4.4 3.6-8 8-8s8 3.6 8 8V248c0 3.5-2.2 6.6-5.6 7.6s-6.9-.1-9-3L240 161v87c0 4.4-3.6 8-8 8s-8-3.6-8-8V136c0-3.5 2.2-6.6 5.6-7.6s6.9 .1 9 3zM112 136v72c0 17.7 14.3 32 32 32s32-14.3 32-32V136c0-4.4 3.6-8 8-8s8 3.6 8 8v72c0 26.5-21.5 48-48 48s-48-21.5-48-48V136c0-4.4 3.6-8 8-8s8 3.6 8 8zM232 392A72 72 0 1 0 88 392a72 72 0 1 0 144 0zm248 72a72 72 0 1 0 0-144 72 72 0 1 0 0 144z'
      
    ]
  };

  

  
  

  var faPuzzlePieceSimple = {
    prefix: 'fat',
    iconName: 'puzzle-piece-simple',
    icon: [
      640,
      512,
      ["puzzle-piece-alt"],
      'e231',
      
      'M168 80c-13.3 0-24 10.7-24 24v96.8c0 17.2-14 31.2-31.2 31.2c-12.7 0-22.8-7.8-29.2-16.4C76 205.5 66.2 200 56 200c-10.2 0-20 5.5-27.5 15.5S16 239.9 16 256s4.9 30.4 12.5 40.5S45.8 312 56 312c10.2 0 20-5.5 27.6-15.6c6.4-8.5 16.5-16.4 29.2-16.4c17.2 0 31.2 14 31.2 31.2V408c0 13.3 10.7 24 24 24H273.5c3.6 0 6.5-2.9 6.5-6.6c0-2.3-1.4-4.9-4.2-6.9C259.1 407 248 388.8 248 368c0-36.3 33.3-64 72-64s72 27.7 72 64c0 20.8-11.1 39-27.8 50.5c-2.9 2-4.2 4.6-4.2 6.9c0 3.6 2.9 6.6 6.6 6.6H472c13.3 0 24-10.7 24-24V311.2c0-17.2 14-31.2 31.2-31.2c12.7 0 22.8 7.8 29.2 16.4C564 306.5 573.8 312 584 312c10.2 0 20-5.5 27.5-15.5s12.5-24.3 12.5-40.5s-4.9-30.4-12.5-40.5S594.2 200 584 200c-10.2 0-20 5.5-27.6 15.6c-6.4 8.5-16.5 16.4-29.2 16.4C510 232 496 218 496 200.8V104c0-13.3-10.7-24-24-24H366.6c-3.6 0-6.6 2.9-6.6 6.5c0 2.3 1.4 4.9 4.2 6.9C380.9 105 392 123.2 392 144c0 36.3-33.3 64-72 64s-72-27.7-72-64c0-20.8 11.1-39 27.8-50.5c2.9-2 4.2-4.6 4.2-6.9c0-3.6-2.9-6.5-6.5-6.5H168zm-40 24c0-22.1 17.9-40 40-40H273.5C285.9 64 296 74.1 296 86.5c0 8.7-5 15.8-11.1 20.1c-13 9-20.9 22.5-20.9 37.4c0 25.5 24 48 56 48s56-22.5 56-48c0-14.8-7.9-28.4-20.9-37.4C349 102.4 344 95.2 344 86.5C344 74.1 354.1 64 366.6 64H472c22.1 0 40 17.9 40 40v96.8c0 8.4 6.8 15.2 15.2 15.2c5.8 0 11.7-3.7 16.4-10c9.8-13.2 24-22 40.4-22c16.3 0 30.5 8.8 40.3 21.9S640 236.8 640 256s-5.8 37-15.7 50.1s-24 21.9-40.3 21.9c-16.4 0-30.6-8.9-40.4-22c-4.7-6.3-10.6-10-16.4-10c-8.4 0-15.2 6.8-15.2 15.2V408c0 22.1-17.9 40-40 40H366.6c-12.5 0-22.6-10.1-22.6-22.6c0-8.7 5-15.8 11.1-20.1c13-9 20.9-22.6 20.9-37.4c0-25.5-24-48-56-48s-56 22.5-56 48c0 14.8 7.9 28.4 20.9 37.4c6.2 4.3 11.1 11.4 11.1 20.1c0 12.5-10.1 22.6-22.5 22.6H168c-22.1 0-40-17.9-40-40V311.2c0-8.4-6.8-15.2-15.2-15.2c-5.8 0-11.7 3.7-16.4 10c-9.8 13.2-24 22-40.4 22c-16.3 0-30.5-8.8-40.3-21.9S0 275.2 0 256s5.8-37 15.7-50.1S39.7 184 56 184c16.4 0 30.6 8.9 40.4 22c4.7 6.3 10.6 10 16.4 10c8.4 0 15.2-6.8 15.2-15.2V104z'
      
    ]
  };

  
    var faPuzzlePieceAlt = faPuzzlePieceSimple;
  

  
  

  var faTreeDeciduous = {
    prefix: 'fat',
    iconName: 'tree-deciduous',
    icon: [
      512,
      512,
      [127795,"tree-alt"],
      'f400',
      
      'M168.7 92.9c-.3 2.4-1.6 4.5-3.6 5.8s-4.5 1.6-6.8 .9c-7-2.3-14.5-3.5-22.3-3.5c-39.8 0-72 32.2-72 72c0 12.2 3 23.7 8.4 33.7c1.1 2 1.2 4.4 .4 6.6s-2.5 3.9-4.7 4.7C37.7 224.3 16 253.6 16 288c0 44.2 35.8 80 80 80H248V320 256 136c0-4.4 3.6-8 8-8s8 3.6 8 8V256v64 48H416c44.2 0 80-35.8 80-80c0-34.4-21.7-63.7-52.1-75c-2.2-.8-3.9-2.5-4.7-4.7s-.7-4.6 .4-6.6c5.3-10.1 8.4-21.5 8.4-33.7c0-39.8-32.2-72-72-72c-7.8 0-15.3 1.2-22.3 3.5c-2.3 .7-4.7 .4-6.8-.9s-3.4-3.4-3.6-5.8C337.9 49.5 300.8 16 256 16s-81.9 33.5-87.3 76.9zM248 384H96c-53 0-96-43-96-96c0-38.2 22.3-71.2 54.6-86.6C50.3 191.1 48 179.8 48 168c0-48.6 39.4-88 88-88c6.3 0 12.4 .7 18.4 1.9C164.5 35.1 206.1 0 256 0s91.5 35.1 101.6 81.9c5.9-1.3 12.1-1.9 18.4-1.9c48.6 0 88 39.4 88 88c0 11.8-2.3 23.1-6.6 33.4C489.7 216.8 512 249.8 512 288c0 53-43 96-96 96H264V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V384z'
      
    ]
  };

  
    var faTreeAlt = faTreeDeciduous;
  

  
  

  var faIndent = {
    prefix: 'fat',
    iconName: 'indent',
    icon: [
      448,
      512,
      [],
      'f03c',
      
      'M0 64c0-4.4 3.6-8 8-8H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8zM192 192c0-4.4 3.6-8 8-8H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H200c-4.4 0-8-3.6-8-8zm8 120H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H200c-4.4 0-8-3.6-8-8s3.6-8 8-8zM0 448c0-4.4 3.6-8 8-8H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8zM110.8 256L16 177.9l0 156.2L110.8 256zM121 243.6c7.8 6.4 7.8 18.3 0 24.7L26.2 346.4C15.7 355 0 347.6 0 334.1V177.9c0-13.5 15.7-20.9 26.2-12.4L121 243.6z'
      
    ]
  };

  

  
  

  var faCommentMusic = {
    prefix: 'fat',
    iconName: 'comment-music',
    icon: [
      512,
      512,
      [],
      'f8b0',
      
      'M157.3 415c-5-1.8-10.6-1-14.9 2.1c-11 8-29.4 19.3-51.2 28.8C68.3 456 41.6 464 16 464l.1-.1 0 0 0 0 .3-.3 .1-.1c.4-.4 .9-.9 1.5-1.6c1.3-1.4 3.2-3.6 5.4-6.3l-12.2-10 12.2 10C28 450 34 442 40 432c10.7-17.9 21.4-42.1 23.6-69.9c.3-4.3-1.1-8.6-3.9-11.8C31.9 318.8 16 280.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-35.2 0-68.6-6.1-98.7-17zM4.7 452.7l0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0zM348.6 121.4c-2.2-1.5-4.9-1.8-7.4-.9l-128 48c-3.1 1.2-5.2 4.2-5.2 7.5V282.2c-8.5-6.3-19.7-10.2-32-10.2c-26.5 0-48 17.9-48 40s21.5 40 48 40c26.5 0 48-17.9 48-40l0 0V181.5l112-42V250.2c-8.5-6.3-19.7-10.2-32-10.2c-26.5 0-48 17.9-48 40s21.5 40 48 40c26.5 0 48-17.9 48-40l0 0V128c0-2.6-1.3-5.1-3.4-6.6zM304 256c20.5 0 32 13.4 32 24s-11.5 24-32 24s-32-13.4-32-24s11.5-24 32-24zM176 288c20.5 0 32 13.4 32 24s-11.5 24-32 24s-32-13.4-32-24s11.5-24 32-24z'
      
    ]
  };

  

  
  

  var faRugbyBall = {
    prefix: 'fat',
    iconName: 'rugby-ball',
    icon: [
      512,
      512,
      [],
      'e3c6',
      
      'M336 32C168.1 32 32 168.1 32 336v32c0 13.4 2.4 26.3 6.7 38.2c0-.8 0-1.6 0-2.4c.5-20.6 6.7-44.3 17.5-69.6c21.6-50.6 62.2-109 116.6-163.3s112.7-95 163.3-116.6c23.3-9.9 45.3-16 64.7-17.3C390.5 33.7 379.5 32 368 32H336zM105.1 473.1c12.1 4.5 25.2 6.9 38.9 6.9h32c167.9 0 304-136.1 304-304V144c0-11.7-1.8-23-5.1-33.6c-1.2 19.5-7.3 41.7-17.3 65.2c-21.6 50.6-62.2 109-116.6 163.3s-112.7 95-163.3 116.6c-25.3 10.8-49 17-69.6 17.5c-1 0-1.9 0-2.8 0zM336 16h32c70.7 0 128 57.3 128 128v32c0 176.7-143.3 320-320 320H144C73.3 496 16 438.7 16 368V336C16 159.3 159.3 16 336 16zM67.6 444.2c8.8 8.8 22.1 13.3 40 12.8c17.9-.5 39.6-5.9 63.8-16.2c48.3-20.6 105-59.9 158.3-113.2s92.6-110 113.2-158.3c10.3-24.2 15.8-45.9 16.2-63.8c.5-17.9-4.1-31.2-12.8-40s-22.1-13.3-40-12.8c-17.9 .5-39.6 5.9-63.8 16.2c-48.3 20.6-105 59.9-158.3 113.2S91.6 292.1 71 340.4c-10.3 24.2-15.8 45.9-16.2 63.8c-.5 17.9 4.1 31.2 12.8 40z'
      
    ]
  };

  

  
  

  var faMessageMedical = {
    prefix: 'fat',
    iconName: 'message-medical',
    icon: [
      512,
      512,
      ["comment-alt-medical"],
      'f7f4',
      
      'M176 416c0-8.8-7.2-16-16-16H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H309.3c-3.5 0-6.8 1.1-9.6 3.2L176 496V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h80 16v16 64c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM232 112c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H288c-4.4 0-8 3.6-8 8v56c0 4.4-3.6 8-8 8H240c-4.4 0-8-3.6-8-8V232c0-4.4-3.6-8-8-8H168c-4.4 0-8-3.6-8-8V184c0-4.4 3.6-8 8-8h56c4.4 0 8-3.6 8-8V112zm8-24c-13.3 0-24 10.7-24 24v48H168c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h48v48c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V240h48c13.3 0 24-10.7 24-24V184c0-13.3-10.7-24-24-24H296V112c0-13.3-10.7-24-24-24H240z'
      
    ]
  };

  
    var faCommentAltMedical = faMessageMedical;
  

  
  

  var faReflectHorizontal = {
    prefix: 'fat',
    iconName: 'reflect-horizontal',
    icon: [
      512,
      512,
      [],
      'e664',
      
      'M256 0c-4.4 0-8 3.6-8 8l0 496c0 4.4 3.6 8 8 8s8-3.6 8-8L264 8c0-4.4-3.6-8-8-8zM16 128c0-6.5 3.9-12.3 9.9-14.8s12.9-1.1 17.4 3.5l128 128c6.2 6.2 6.2 16.4 0 22.6l-128 128c-4.6 4.6-11.5 5.9-17.4 3.5s-9.9-8.3-9.9-14.8l0-256zM182.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9S0 115.1 0 128L0 384c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128zM486.1 113.2c6 2.5 9.9 8.3 9.9 14.8l0 256c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-128-128c-6.2-6.2-6.2-16.4 0-22.6l128-128c4.6-4.6 11.5-5.9 17.4-3.5zM329.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l128 128c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-256c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-128 128z'
      
    ]
  };

  

  
  

  var faParachuteBox = {
    prefix: 'fat',
    iconName: 'parachute-box',
    icon: [
      512,
      512,
      [],
      'f4cd',
      
      'M256.1 0H256C86.6 0 8.7 114.4 .7 208c-.8 8.8 6.5 16 15.3 16H52.7L168.9 340.2c-5.6 7.8-8.9 17.4-8.9 27.8v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V368c0-10.4-3.3-20-8.9-27.8L459.3 224H496c8.8 0 16.1-7.2 15.3-16c-8-93.6-85.8-208-255.2-208zM436.7 224L331.8 328.9c-7.8-5.6-17.4-8.9-27.8-8.9H264V224H383.6h16 37.1zM248 224v96H208c-10.4 0-20 3.3-27.8 8.9L75.3 224h37.1 16H248zM190.6 22.6C144 57 112 127.1 112 208H16.8C23.6 134.9 76.6 47.1 190.6 22.6zM167.3 70c24-34.7 55.6-54 88.7-54s64.6 19.3 88.7 54c24 34.6 39.3 83.4 39.3 138H128c0-54.6 15.3-103.3 39.3-138zM495.2 208H400c0-80.9-32-151-78.6-185.4C435.4 47.1 488.4 134.9 495.2 208zM304 336c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H208c-17.7 0-32-14.3-32-32V368c0-17.7 14.3-32 32-32h96z'
      
    ]
  };

  

  
  

  var faCircleNodes = {
    prefix: 'fat',
    iconName: 'circle-nodes',
    icon: [
      512,
      512,
      [],
      'e4e2',
      
      'M464 80A64 64 0 1 0 336 80a64 64 0 1 0 128 0zm16 0c0 44.2-35.8 80-80 80c-2.1 0-4.3-.1-6.4-.2L358.1 355.1c33.4 9.6 57.9 40.4 57.9 76.9c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-17.3 5.5-33.3 14.8-46.4L134.6 266.4C120.3 279.8 101.1 288 80 288c-44.2 0-80-35.8-80-80s35.8-80 80-80c30.8 0 57.6 17.4 70.9 43l172.2-68.9c-2-7-3.1-14.5-3.1-22.1c0-44.2 35.8-80 80-80s80 35.8 80 80zM329 117L156.9 185.9c2 7 3.1 14.5 3.1 22.1c0 17.3-5.5 33.3-14.8 46.4L281.4 373.6C295.7 360.2 314.9 352 336 352c2.1 0 4.3 .1 6.4 .2l35.5-195.3c-21.2-6.1-38.8-20.7-48.8-39.9zm71 315a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM80 272a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  

  
  

  var faCircleWifiCircleWifi = {
    prefix: 'fat',
    iconName: 'circle-wifi-circle-wifi',
    icon: [
      640,
      512,
      ["circle-wifi-group"],
      'e67e',
      
      'M256 496c35.6 0 69.4-7.7 99.8-21.6c3.3 4.4 6.9 8.6 10.6 12.7C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-2.9 0-5.7 .1-8.6 .2C459.5 90.6 366.5 16 256 16C123.5 16 16 123.5 16 256s107.5 240 240 240zM116.8 213.4c-3.3 3-8.3 2.7-11.3-.6s-2.7-8.3 .6-11.3C145.8 165.8 198.4 144 256 144s110.2 21.8 149.9 57.5c3.3 3 3.5 8 .6 11.3s-8 3.5-11.3 .6C358.3 180.2 309.5 160 256 160s-102.3 20.2-139.2 53.4zM272 352a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32-96c-26.8 0-51.3 10.2-69.7 26.8c-3.3 3-8.3 2.7-11.3-.6s-2.7-8.3 .6-11.3c21.3-19.2 49.5-31 80.5-31s59.2 11.7 80.5 31c3.3 3 3.5 8 .6 11.3s-8 3.5-11.3 .6C307.3 266.1 282.8 256 256 256zM496 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 96c-29.2 0-55.8 11-75.9 29.1c-3.3 3-8.3 2.7-11.3-.6s-2.7-8.3 .6-11.3C432.3 316.6 462.7 304 496 304s63.7 12.6 86.6 33.3c3.3 3 3.5 8 .6 11.3s-8 3.5-11.3 .6C551.8 331 525.2 320 496 320zM480 432a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-20.9-41.8c-3.3 3-8.3 2.7-11.3-.6s-2.7-8.3 .6-11.3C461 366.9 477.7 360 496 360s35 6.9 47.6 18.3c3.3 3 3.5 8 .6 11.3s-8 3.5-11.3 .6c-9.8-8.8-22.7-14.2-36.9-14.2s-27.1 5.4-36.9 14.2z'
      
    ]
  };

  
    var faCircleWifiGroup = faCircleWifiCircleWifi;
  

  
  

  var faArrowTurnDownLeft = {
    prefix: 'fat',
    iconName: 'arrow-turn-down-left',
    icon: [
      512,
      512,
      [],
      'e2e1',
      
      'M496 40c0-4.4 3.6-8 8-8s8 3.6 8 8V224c0 39.8-32.2 72-72 72H27.3L165.7 434.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-152-152c-3.1-3.1-3.1-8.2 0-11.3l152-152c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L27.3 280H440c30.9 0 56-25.1 56-56V40z'
      
    ]
  };

  

  
  

  var faBorderNone = {
    prefix: 'fat',
    iconName: 'border-none',
    icon: [
      448,
      512,
      [],
      'f850',
      
      'M32 432a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM128 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0 384a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-224a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM320 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-416a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM224 432a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0-352a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0 160a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM416 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-384a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM32 48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM416 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM32 240a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM224 368a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm192-32a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM32 368a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM416 144a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM32 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm192-32a16 16 0 1 0 0 32 16 16 0 1 0 0-32z'
      
    ]
  };

  

  
  

  var faCircleSmall = {
    prefix: 'fat',
    iconName: 'circle-small',
    icon: [
      320,
      512,
      [],
      'e122',
      
      'M160 112a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 304a160 160 0 1 0 0-320 160 160 0 1 0 0 320z'
      
    ]
  };

  

  
  

  var faBottleBaby = {
    prefix: 'fat',
    iconName: 'bottle-baby',
    icon: [
      512,
      512,
      [],
      'e673',
      
      'M204.5 61L224 48l0-16c0-17.7 14.3-32 32-32s32 14.3 32 32l0 16 19.5 13c17.2 11.5 27.7 30.5 28.5 51c0 .7 0 1.5 0 2.3l0 2c9.6 5.5 16 15.9 16 27.7l0 16 21.8 21.8c27 27 42.2 63.6 42.2 101.8L416 448c0 35.3-28.7 64-64 64l-192 0c-35.3 0-64-28.7-64-64l0-40 0-96 0-28.4c0-38.2 15.2-74.8 42.2-101.8L160 160l0-16c0-11.8 6.4-22.2 16-27.7l0-2c0-.8 0-1.5 0-2.3c.7-20.5 11.3-39.5 28.5-51zM112 416l0 32c0 26.5 21.5 48 48 48l192 0c26.5 0 48-21.5 48-48l0-164.4c0-33.9-13.5-66.5-37.5-90.5L345.4 176l-9.4 0-160 0-9.4 0-17.1 17.1c-24 24-37.5 56.6-37.5 90.5l0 20.4 136 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-136 0 0 80 136 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-136 0zM319.9 112c-.7-15.2-8.6-29.2-21.3-37.7l-19.5-13c-4.5-3-7.1-8-7.1-13.3l0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16c0 5.3-2.7 10.3-7.1 13.3l-19.5 13c-12.7 8.5-20.6 22.5-21.3 37.7l127.9 0zM192 128c-8.8 0-16 7.2-16 16l0 16 160 0 0-16c0-8.8-7.2-16-16-16l-128 0z'
      
    ]
  };

  

  
  

  var faLitecoinSign = {
    prefix: 'fat',
    iconName: 'litecoin-sign',
    icon: [
      384,
      512,
      [],
      'e1d3',
      
      'M96 40c0-4.4-3.6-8-8-8s-8 3.6-8 8V230.8L6.2 248.2c-4.3 1-7 5.3-6 9.6s5.3 7 9.6 6L80 247.3V440c0 22.1 17.9 40 40 40H376c4.4 0 8-3.6 8-8s-3.6-8-8-8H120c-13.3 0-24-10.7-24-24V243.5l185.8-43.7c4.3-1 7-5.3 6-9.6s-5.3-7-9.6-6L96 227.1V40z'
      
    ]
  };

  

  
  

  var faH6 = {
    prefix: 'fat',
    iconName: 'h6',
    icon: [
      640,
      512,
      [],
      'e413',
      
      'M16 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V248 440c0 4.4 3.6 8 8 8s8-3.6 8-8V256H304V440c0 4.4 3.6 8 8 8s8-3.6 8-8V248 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V240H16V72zm492.9-6.3c-3.5-2.7-8.5-2.1-11.2 1.4L383.3 213.3C363 239.2 352 271.1 352 304v0c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144c-22 0-42.8 4.9-61.5 13.7l75.8-96.8c2.7-3.5 2.1-8.5-1.4-11.2zM368 304c0-.7 0-1.3 0-2c1.1-69.8 58-126 128-126c70.7 0 128 57.3 128 128s-57.3 128-128 128s-128-57.3-128-128v0z'
      
    ]
  };

  

  
  

  var faCircleY = {
    prefix: 'fat',
    iconName: 'circle-y',
    icon: [
      512,
      512,
      [],
      'e12f',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM142 130.7c-2.9-3.3-8-3.6-11.3-.7s-3.6 8-.7 11.3L248 275V376c0 4.4 3.6 8 8 8s8-3.6 8-8V275L382 141.3c2.9-3.3 2.6-8.4-.7-11.3s-8.4-2.6-11.3 .7L256 259.9 142 130.7z'
      
    ]
  };

  

  
  

  var faAppleCore = {
    prefix: 'fat',
    iconName: 'apple-core',
    icon: [
      384,
      512,
      [],
      'e08f',
      
      'M208 96c35.3 0 64-28.7 64-64V16H256c-35.3 0-64 28.7-64 64V96h16zm0 16H192c-8.8 0-16-7.2-16-16V80c0-44.2 35.8-80 80-80h16c8.8 0 16 7.2 16 16V32c0 44.2-35.8 80-80 80zM42.8 451.6c-.2 .2-.4 .4-.5 .6l0 .1C68.3 480.8 99 496 128 496c9.5 0 22.2-2.8 34.1-6.4c19.4-5.8 40.3-5.8 59.7 0c11.9 3.6 24.7 6.4 34.1 6.4c29 0 59.7-15.2 85.7-43.7l0-.1c-.1-.2-.3-.4-.5-.6C298.9 416.4 272 363.3 272 304c0-60.3 27.8-114.2 71.3-149.3C332.2 147.9 319.2 144 304 144c-24.1 0-54.2 9.4-76.9 18.2c-22.5 8.8-47.8 8.8-70.3 0C134.2 153.4 104.1 144 80 144c-15.2 0-28.2 3.9-39.3 10.7C84.2 189.8 112 243.7 112 304c0 59.3-26.9 112.4-69.2 147.6zM29.9 462.4c-6.2-6.8-4.4-17.3 2.7-23.1C71.3 407 96 358.4 96 304c0-55.4-25.6-104.7-65.5-137c-8-6.5-9.3-18.7-.7-24.3C43.9 133.4 60.7 128 80 128c27.3 0 59.7 10.3 82.7 19.3c18.8 7.3 39.9 7.3 58.7 0c22.9-8.9 55.4-19.3 82.7-19.3c19.3 0 36.1 5.4 50.3 14.7c8.6 5.6 7.3 17.9-.7 24.3c-40 32.3-65.5 81.7-65.5 137c0 54.4 24.7 103 63.4 135.3c7 5.9 8.8 16.3 2.7 23.1C325.8 493.7 290.9 512 256 512c-11.9 0-26.5-3.4-38.8-7.1c-16.4-4.9-34.1-4.9-50.5 0c-12.2 3.7-26.8 7.1-38.8 7.1c-34.9 0-69.8-18.3-98.1-49.6z'
      
    ]
  };

  

  
  

  var faArrowUp91 = {
    prefix: 'fat',
    iconName: 'arrow-up-9-1',
    icon: [
      576,
      512,
      ["sort-numeric-up-alt"],
      'f887',
      
      'M428 48a68 68 0 1 0 -.1 136.1A68 68 0 1 0 428 48zm0 152c-46.4 0-84-37.6-84-84s37.6-84 84-84c45 0 81.8 35.5 83.9 80h.1c0 .7 0 1.4 0 2.1c0 .6 0 1.3 0 1.9c0 13.9-3.4 27.1-9.4 38.7c-4 8.6-9.2 16.7-15.6 24l-65 74.6c-2.9 3.3-8 3.7-11.3 .8s-3.7-8-.8-11.3l39.7-45.6c-6.9 1.8-14.2 2.8-21.7 2.8zM154.3 34.3c3.1-3.1 8.2-3.1 11.3 0l112 112c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L168 59.3V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V59.3L53.7 157.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l112-112zm282.1 255c2.2 1.5 3.6 4 3.6 6.7V464h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H432 376c-4.4 0-8-3.6-8-8s3.6-8 8-8h48V308.1l-44.8 19.2c-4.1 1.7-8.8-.1-10.5-4.2s.1-8.8 4.2-10.5l56-24c2.5-1.1 5.3-.8 7.6 .7z'
      
    ]
  };

  
    var faSortNumericUpAlt = faArrowUp91;
  

  
  

  var faPersonPinball = {
    prefix: 'fat',
    iconName: 'person-pinball',
    icon: [
      640,
      512,
      [],
      'e21d',
      
      'M91.4 226.4c-6.7 2-11.4 8.3-11.4 15.3v65.1c0 4.2 1.7 8.3 4.7 11.3L134.6 368c6 6 9.4 14.1 9.4 22.6V480c0 8.8-7.2 16-16 16s-16-7.2-16-16V397.3c0-4.2-1.7-8.3-4.7-11.3L30.1 308.7c-9-9-14.1-21.2-14.1-33.9V186.6C16 163.1 35.1 144 58.6 144c18.7 0 36.2 9.3 46.5 24.9l42.6 64c3 4.5 8 7.1 13.3 7.1H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H152.6c-10.7 0-20.7-5.3-26.6-14.3l-16.6-24.9c-3.9-5.9-11.2-8.5-17.9-6.4zM112 265.7l.6 .9c8.9 13.4 23.9 21.4 39.9 21.4H208V408v96c0 4.4 3.6 8 8 8s8-3.6 8-8V416H624v88c0 4.4 3.6 8 8 8s8-3.6 8-8V408 200 24c0-13.3-10.7-24-24-24H504c-13.3 0-24 10.7-24 24V61.5c0 2.5 .4 4.9 1.1 7.2l45.3 143.4L237.8 267.7c1.4-3.6 2.2-7.5 2.2-11.7c0-17.7-14.3-32-32-32H161.1l-42.6-64c-13.3-20-35.8-32-59.9-32C26.2 128 0 154.2 0 186.6v88.1c0 17 6.7 33.3 18.7 45.3L96 397.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V390.6c0-12.7-5.1-24.9-14.1-33.9L96 306.7V270.5 241.7l16 24zM80 16a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm48 32A48 48 0 1 0 32 48a48 48 0 1 0 96 0zM624 193.4l-81.8 15.7L496.4 63.9c-.2-.8-.4-1.6-.4-2.4V24c0-4.4 3.6-8 8-8H616c4.4 0 8 3.6 8 8V193.4zM224 400V286.6l400-76.9V400H224zm96-80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM0 480c0 17.7 14.3 32 32 32s32-14.3 32-32v0V410.5l-16-16L48 480c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-117.5-16-16L0 480z'
      
    ]
  };

  

  
  

  var faLungs = {
    prefix: 'fat',
    iconName: 'lungs',
    icon: [
      640,
      512,
      [129729],
      'f604',
      
      'M312 8c0-4.4 3.6-8 8-8s8 3.6 8 8v8V180.1c0 24.6 12.6 47.5 33.3 60.7L384 255.2V165.3C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8c15.4 22.1 44.3 65.4 71 116.9c26.5 50.9 52.4 112.5 59.6 170.3c.2 1.3 .2 2.6 .2 4v7c0 49.1-39.8 89-89 89c-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2C414 480.5 384 442.1 384 398V305.6l16 10.2V398c0 36.7 25 68.7 60.6 77.6l72.7 18.2c5.8 1.4 11.7 2.2 17.7 2.2c40.3 0 73-32.7 73-73v-7c0-.7 0-1.3-.1-2c-6.9-55-31.7-114.5-57.9-164.9c-26.4-50.6-54.8-93.4-70-115.1c-9.8-14.1-25.9-22-42.6-22c-29.5 0-53.3 23.9-53.3 53.3V265.4l100.3 63.8c3.7 2.4 4.8 7.3 2.5 11s-7.3 4.8-11 2.5l-139-88.4c-14.5-9.3-25.8-22.4-32.8-37.6c-7 15.2-18.2 28.3-32.8 37.6l-139 88.4c-3.7 2.4-8.7 1.3-11-2.5s-1.3-8.7 2.5-11L240 265.4V165.3c0-29.5-23.9-53.3-53.3-53.3c-16.8 0-32.8 7.9-42.6 22c-15.2 21.7-43.6 64.5-70 115.1C47.9 299.5 23 359 16.1 414c-.1 .7-.1 1.3-.1 2v7c0 40.3 32.7 73 73 73c6 0 11.9-.7 17.7-2.2l72.7-18.2C215 466.7 240 434.7 240 398V315.8l16-10.2V398c0 44.1-30 82.5-72.7 93.1l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7c-49.1 0-89-39.8-89-89v-7c0-1.3 .1-2.7 .2-4c7.2-57.9 33.1-119.4 59.6-170.3c26.8-51.5 55.6-94.8 71-116.9c13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3v89.9l22.7-14.4c20.8-13.2 33.3-36.1 33.3-60.7V16 8z'
      
    ]
  };

  

  
  

  var faRibbon = {
    prefix: 'fat',
    iconName: 'ribbon',
    icon: [
      448,
      512,
      [127895],
      'f4d6',
      
      'M228 0c-1.3 0-2.6 0-4 0V.1c-13.2 .2-28.8 .7-37.7 1.4c-1.6 .1-3.2 .3-4.7 .4c-27.9 2.6-51 19.2-66.7 41.1L75.4 98.3C62.8 116 56.1 137.2 56.1 158.9c0 26.4 10.1 52 28.1 71.3L346.2 509.5c2.7 2.9 7.2 3.4 10.4 1.1l80-56c1.9-1.3 3.1-3.4 3.4-5.7s-.5-4.6-2-6.3L166.5 144.9c-4.1-4.5-6.4-10.4-6.4-16.5c0-13.5 10.9-24.4 24.4-24.4H224h16 23.6c13.5 0 24.4 10.9 24.4 24.4c0 6.1-2.3 12-6.4 16.5l-30.5 33.5 10.8 11.9 31.5-34.6c6.8-7.5 10.6-17.2 10.6-27.3c0-22.3-18.1-40.4-40.4-40.4H240 224 184.5c-22.3 0-40.4 18.1-40.4 40.4c0 10.1 3.8 19.8 10.6 27.3L420 446.7l-66.9 46.8L95.9 219.2c-15.3-16.3-23.8-38-23.8-60.4c0-18.3 5.7-36.3 16.4-51.2l39.5-55.3c13.6-19.1 32.9-32.4 55.1-34.5c1.5-.1 3-.3 4.5-.4c9.2-.8 26.7-1.3 40.3-1.4c12.3 .1 23.2 .6 32.5 1.4c1.6 .1 3.1 .3 4.5 .4c22.2 2.1 41.5 15.4 55.1 34.5l39.5 55.3c10.6 14.9 16.4 32.9 16.4 51.2c0 22.4-8.5 44.1-23.8 60.4l-32.4 34.5 10.8 11.9 33.2-35.4c18.1-19.3 28.1-44.9 28.1-71.3c0-21.6-6.8-42.9-19.3-60.5L333.2 43C317.5 21.1 294.4 4.5 266.5 1.9c-1.5-.1-3.1-.3-4.7-.4C253.1 .8 243.1 .2 232 .1V0c-1.3 0-2.6 0-4 0zM117.9 324.5L10.2 442.6c-1.6 1.7-2.3 4-2 6.3s1.5 4.4 3.4 5.7l80 56c3.3 2.3 7.7 1.8 10.4-1.1l94.7-101-11-11.7L95 493.5 28.1 446.7 128.8 336.2l-11-11.7z'
      
    ]
  };

  

  
  

  var faLockA = {
    prefix: 'fat',
    iconName: 'lock-a',
    icon: [
      448,
      512,
      [],
      'e422',
      
      'M224 16c61.9 0 112 50.1 112 112v64H112V128c0-61.9 50.1-112 112-112zM96 128v64H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H352V128C352 57.3 294.7 0 224 0S96 57.3 96 128zM64 208H96h16H336h16 32c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V256c0-26.5 21.5-48 48-48zm88.9 180.3c-.1 .1-.1 .2-.1 .3l-23.9 47.8c-2 4-.4 8.8 3.6 10.7s8.8 .4 10.7-3.6L164.9 400H283.1l21.8 43.6c2 4 6.8 5.6 10.7 3.6s5.6-6.8 3.6-10.7l-23.9-47.8c0-.1-.1-.2-.1-.3L231.2 260.5c-.3-.6-.6-1.1-1-1.6c-.2-.2-.4-.4-.6-.6c-1.5-1.4-3.5-2.2-5.5-2.2c-1.1 0-2.1 .2-3.2 .7c-.7 .3-1.3 .7-1.9 1.2c-.2 .2-.5 .4-.7 .6c-.6 .6-1.1 1.3-1.4 2L152.9 388.3zm20-4.3L224 281.9 275.1 384H172.9z'
      
    ]
  };

  

  
  

  var faArrowRightToCity = {
    prefix: 'fat',
    iconName: 'arrow-right-to-city',
    icon: [
      640,
      512,
      [],
      'e4b3',
      
      'M304 40c0-13.3 10.7-24 24-24H472c13.3 0 24 10.7 24 24V200c0 4.4 3.6 8 8 8h64 32c13.3 0 24 10.7 24 24V504c0 4.4 3.6 8 8 8s8-3.6 8-8V232c0-22.1-17.9-40-40-40H576V104c0-4.4-3.6-8-8-8s-8 3.6-8 8v88H512V40c0-22.1-17.9-40-40-40H328c-22.1 0-40 17.9-40 40V504c0 4.4 3.6 8 8 8s8-3.6 8-8V40zm56 56v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V96c0-13.3-10.7-24-24-24H384c-13.3 0-24 10.7-24 24zm24-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H384c-4.4 0-8-3.6-8-8V96c0-4.4 3.6-8 8-8zM512 264c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V288c0-13.3-10.7-24-24-24H512zm-8 24c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H512c-4.4 0-8-3.6-8-8V288zM488 416v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V416c0-13.3-10.7-24-24-24H512c-13.3 0-24 10.7-24 24zm24-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H512c-4.4 0-8-3.6-8-8V416c0-4.4 3.6-8 8-8zM384 200c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V224c0-13.3-10.7-24-24-24H384zm-8 24c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H384c-4.4 0-8-3.6-8-8V224zM360 352v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V352c0-13.3-10.7-24-24-24H384c-13.3 0-24 10.7-24 24zm24-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H384c-4.4 0-8-3.6-8-8V352c0-4.4 3.6-8 8-8zM157.7 154.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L228.7 248H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H228.7l-82.3 82.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l96-96c3.1-3.1 3.1-8.2 0-11.3l-96-96z'
      
    ]
  };

  

  
  

  var faChartLineDown = {
    prefix: 'fat',
    iconName: 'chart-line-down',
    icon: [
      512,
      512,
      [128201],
      'f64d',
      
      'M16 40c0-4.4-3.6-8-8-8s-8 3.6-8 8V408c0 39.8 32.2 72 72 72H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H72c-30.9 0-56-25.1-56-56V40zM352 352H472c4.4 0 8-3.6 8-8V224c0-4.4-3.6-8-8-8s-8 3.6-8 8V324.7L293.7 154.3c-3.1-3.1-8.2-3.1-11.3 0L192 244.7l-90.3-90.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l96 96c3.1 3.1 8.2 3.1 11.3 0L288 171.3 452.7 336H352c-4.4 0-8 3.6-8 8s3.6 8 8 8z'
      
    ]
  };

  

  
  

  var faPaperclip = {
    prefix: 'fat',
    iconName: 'paperclip',
    icon: [
      448,
      512,
      [128206],
      'f0c6',
      
      'M386.3 61.7c-32.2-32.2-84.5-32.2-116.7 0l-192 192c-49.9 49.9-49.9 130.8 0 180.7s130.8 49.9 180.7 0l152-152c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-152 152c-56.1 56.1-147.2 56.1-203.3 0s-56.1-147.2 0-203.3l192-192c38.5-38.5 100.8-38.5 139.3 0s38.5 100.8 0 139.3L213.9 373.4c-24.8 24.8-65.7 22.6-87.7-4.9c-18.8-23.4-16.9-57.2 4.3-78.5L282.3 138.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L141.9 301.4c-15.5 15.5-16.8 40.1-3.2 57.2c16 20 45.8 21.6 63.9 3.5L386.3 178.3c32.2-32.2 32.2-84.5 0-116.7z'
      
    ]
  };

  

  
  

  var faBinRecycle = {
    prefix: 'fat',
    iconName: 'bin-recycle',
    icon: [
      576,
      512,
      [],
      'e5f7',
      
      'M536 48c13.3 0 24 10.7 24 24V88c0 13.3-10.7 24-24 24h-8.1H48.1 40c-13.3 0-24-10.7-24-24V72c0-13.3 10.7-24 24-24H536zM0 88c0 19.8 14.4 36.3 33.3 39.4l0 .6L58.9 421.5c2.9 33.1 30.6 58.5 63.8 58.5H453.3c33.2 0 60.9-25.4 63.8-58.5L542.6 128l0-.6C561.6 124.3 576 107.8 576 88V72c0-22.1-17.9-40-40-40H40C17.9 32 0 49.9 0 72V88zM74.9 420.2L49.5 128H526.5L501.1 420.2C499 445 478.2 464 453.3 464H122.7c-24.9 0-45.7-19-47.8-43.8zM288 192c7.5 0 14.6 3.6 19.1 9.6l35.8 48.5c2.5 3.4 7.1 4.3 10.7 2c3.9-2.5 5-7.8 2.2-11.5l-35.8-48.5C312.5 182 300.6 176 288 176s-24.5 6-31.9 16.1l-35.8 48.5c-2.8 3.8-1.8 9.1 2.2 11.5c3.5 2.2 8.2 1.3 10.7-2l35.8-48.5c4.5-6.1 11.5-9.6 19.1-9.6zm-85.6 85.4c-3.5-2.2-8.2-1.3-10.7 2l-32.3 43.9c-4.8 6.5-7.4 14.5-7.4 22.6c0 21 17.1 38.1 38.1 38.1H264c4.4 0 8-3.6 8-8s-3.6-8-8-8H190.1c-12.2 0-22.1-9.9-22.1-22.1c0-4.7 1.5-9.3 4.3-13.1l32.3-43.9c2.8-3.8 1.8-9.1-2.2-11.5zM304 376c0 4.4 3.6 8 8 8h73.9c21 0 38.1-17.1 38.1-38.1c0-8.1-2.6-16.1-7.4-22.6l-32.3-43.9c-2.5-3.4-7.1-4.3-10.7-2c-4 2.5-5 7.8-2.2 11.5l32.3 43.9c2.8 3.8 4.3 8.4 4.3 13.1c0 12.2-9.9 22.1-22.1 22.1H312c-4.4 0-8 3.6-8 8z'
      
    ]
  };

  

  
  

  var faAnglesUp = {
    prefix: 'fat',
    iconName: 'angles-up',
    icon: [
      448,
      512,
      ["angle-double-up"],
      'f102',
      
      'M229.7 50.3c-3.1-3.1-8.2-3.1-11.3 0l-176 176c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L224 67.3 394.3 237.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-176-176zm176 368l-176-176c-3.1-3.1-8.2-3.1-11.3 0l-176 176c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L224 259.3 394.3 429.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3z'
      
    ]
  };

  
    var faAngleDoubleUp = faAnglesUp;
  

  
  

  var faFaceTissue = {
    prefix: 'fat',
    iconName: 'face-tissue',
    icon: [
      512,
      512,
      [],
      'e39c',
      
      'M256 16C123.5 16 16 123.5 16 256c0 10.5 .7 20.8 2 31c.6 4.4-2.5 8.4-6.9 9s-8.4-2.5-9-6.9C.7 278.2 0 267.2 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256c-11.2 0-22.2-.7-33-2.1c-4.4-.6-7.5-4.6-6.9-9s4.6-7.5 9-6.9c10.1 1.3 20.5 2 31 2c132.5 0 240-107.5 240-240S388.5 16 256 16zm43.6 329.3c2.7-1.8 6.2-1.8 8.9 0l44.1 29.4 27.8-13.9c4-2 8.8-.4 10.7 3.6s.4 8.8-3.6 10.7l-32 16c-2.6 1.3-5.6 1.1-8-.5l-43.6-29-43.6 29c-3.7 2.5-8.6 1.5-11.1-2.2s-1.5-8.6 2.2-11.1l48-32zm-160-184.5l80 40c2.7 1.4 4.4 4.1 4.4 7.2s-1.7 5.8-4.4 7.2l-80 40c-4 2-8.8 .4-10.7-3.6s-.4-8.8 3.6-10.7L198.1 208l-65.7-32.8c-4-2-5.6-6.8-3.6-10.7s6.8-5.6 10.7-3.6zm243.6 3.6c2 4 .4 8.8-3.6 10.7L313.9 208l65.7 32.8c4 2 5.6 6.8 3.6 10.7s-6.8 5.6-10.7 3.6l-80-40c-2.7-1.4-4.4-4.1-4.4-7.2s1.7-5.8 4.4-7.2l80-40c4-2 8.8-.4 10.7 3.6zM223.9 297.2l-32 208c-.5 3.1-2.7 5.6-5.7 6.5s-6.2-.1-8.3-2.5l-38.3-44.7c-3.9-4.6-10.1-6.6-16-5.1L41.9 479.8c-2.7 .7-5.6-.1-7.6-2.1s-2.8-4.9-2.1-7.6l20.4-81.6c1.5-5.9-.5-12.1-5.1-16L2.8 334.1c-2.4-2-3.3-5.3-2.5-8.3s3.4-5.2 6.5-5.7l208-32c2.5-.4 5.1 .4 6.9 2.2s2.6 4.4 2.2 6.9zm-166 63.1c9.2 7.9 13.2 20.3 10.2 32.1L51 461l68.7-17.2c11.8-2.9 24.2 1 32.1 10.2l27 31.5 27.7-180-180 27.7 31.5 27z'
      
    ]
  };

  

  
  

  var faDollyEmpty = {
    prefix: 'fat',
    iconName: 'dolly-empty',
    icon: [
      576,
      512,
      [],
      'f473',
      
      'M0 8C0 3.6 3.6 0 8 0H96.5c17.5 0 32.9 11.3 38.2 28L247 384.6c3-.4 6-.6 9-.6c23.2 0 43.5 12.3 54.7 30.8l254.9-78.4c4.2-1.3 8.7 1.1 10 5.3s-1.1 8.7-5.3 10L317.3 429.5c1.8 5.9 2.7 12.1 2.7 18.5c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.7 16.3-49.5 39.5-59.1L119.4 32.8C116.3 22.8 107 16 96.5 16H8c-4.4 0-8-3.6-8-8zM304 448a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  

  
  

  var faEnvelope = {
    prefix: 'fat',
    iconName: 'envelope',
    icon: [
      512,
      512,
      [9993,61443,128386],
      'f0e0',
      
      'M64 80c-26.5 0-48 21.5-48 48v28.2L220.8 321.4c20.5 16.5 49.8 16.5 70.3 0L496 156.2V128c0-26.5-21.5-48-48-48H64zM16 176.7V384c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V176.7L301.2 333.8c-26.4 21.3-64 21.3-90.4 0L16 176.7zM0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z'
      
    ]
  };

  

  
  

  var faTruckLadder = {
    prefix: 'fat',
    iconName: 'truck-ladder',
    icon: [
      640,
      512,
      [],
      'e657',
      
      'M8 32H344c4.4 0 8 3.6 8 8s-3.6 8-8 8H328V160h16c4.4 0 8 3.6 8 8s-3.6 8-8 8H232 216 136 120 40 24 8c-4.4 0-8-3.6-8-8s3.6-8 8-8H24V48H8c-4.4 0-8-3.6-8-8s3.6-8 8-8zM312 48H232V160h80V48zm-96 0H136V160h80V48zm-96 0H40V160h80V48zm264 80c0-17.7 14.3-32 32-32h74.7c10.6 0 20.8 4.2 28.3 11.7L633 221.7c4.5 4.5 7 10.6 7 17V376c0 22.1-17.9 40-40 40H575.6c.2 2.6 .4 5.3 .4 8c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-2.7 .1-5.4 .4-8H239.6c.2 2.6 .4 5.3 .4 8c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-2.7 .1-5.4 .4-8H40c-22.1 0-40-17.9-40-40V264c0-22.1 17.9-40 40-40H384V128zm16 112H384 40c-13.3 0-24 10.7-24 24V376c0 13.3 10.7 24 24 24H67.3c10.4-36.9 44.4-64 84.7-64s74.2 27.1 84.7 64H403.3c10.4-36.9 44.4-64 84.7-64s74.2 27.1 84.7 64H600c13.3 0 24-10.7 24-24V240H400zm212.7-16l-105-105c-4.5-4.5-10.6-7-17-7H416c-8.8 0-16 7.2-16 16v96H612.7zM224 424A72 72 0 1 0 80 424a72 72 0 1 0 144 0zm264 72a72 72 0 1 0 0-144 72 72 0 1 0 0 144z'
      
    ]
  };

  

  
  

  var faHeadSide = {
    prefix: 'fat',
    iconName: 'head-side',
    icon: [
      512,
      512,
      [],
      'f6e9',
      
      'M16 222.9C16 108.6 108.6 16 222.9 16h16.8c71.6 0 137.5 43.3 166.4 105c3.5 7.4 6.9 15.1 10.4 22.9c6.4 14.3 12.9 28.9 20.1 42.7c11.3 21.6 24.8 42.2 43.5 58.9l3.8 3.4c7.7 6.9 12.1 16.7 12.1 27c0 20-16.2 36.2-36.2 36.2H440c-4.4 0-8 3.6-8 8v72c0 22.1-17.9 40-40 40H312c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8s8-3.6 8-8V448h72c30.9 0 56-25.1 56-56V328h11.8c28.8 0 52.2-23.4 52.2-52.2c0-14.9-6.4-29.1-17.5-39l-3.8-3.4c-16.7-14.9-29.2-33.6-40-54.4c-7-13.4-13.1-27.1-19.3-41c-3.5-7.9-7.1-15.9-10.8-23.9C389.1 46.9 317.6 0 239.7 0H222.9C99.8 0 0 99.8 0 222.9c0 52.8 16.9 101.5 47.4 139.9C57.5 375.5 64 390.2 64 405.3V504c0 4.4 3.6 8 8 8s8-3.6 8-8V405.3c0-19.8-8.5-37.8-20.1-52.4C31.8 317.5 16 272.3 16 222.9zM336 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faCakeCandles = {
    prefix: 'fat',
    iconName: 'cake-candles',
    icon: [
      448,
      512,
      [127874,"birthday-cake","cake"],
      'f1fd',
      
      'M69 62.3c-3.3 5.2-5 11.2-5 17.4C64 97.5 78.4 112 96 112s32-14.5 32-32.3c0-6.2-1.8-12.3-5-17.4L96 19.8 69 62.3zM55.5 53.7L86.2 5.4C88.3 2 92 0 96 0s7.7 2 9.8 5.4l30.7 48.3c4.9 7.7 7.5 16.8 7.5 26c0 26.5-21.5 48.3-48 48.3s-48-21.8-48-48.3c0-9.2 2.6-18.2 7.5-26zM384 240H360v24c0 4.4-3.6 8-8 8s-8-3.6-8-8V240H232v24c0 4.4-3.6 8-8 8s-8-3.6-8-8V240H104v24c0 4.4-3.6 8-8 8s-8-3.6-8-8V240H64c-26.5 0-48 21.5-48 48v94.4c25.8 5.9 54.7-7.9 74.3-28c1.6-1.6 3.7-2.5 5.9-2.4s4.3 1 5.8 2.7c32.3 36.8 83.7 36.8 116 0c1.5-1.7 3.7-2.7 6-2.7s4.5 1 6 2.7c32.3 36.8 83.7 36.8 116 0c1.5-1.7 3.6-2.7 5.8-2.7s4.4 .8 5.9 2.4c19.7 20.1 48.4 33.8 74.3 28V288c0-26.5-21.5-48-48-48zM16 398.7V480c0 8.8 7.2 16 16 16H416c8.8 0 16-7.2 16-16V398.7c-29.3 5.1-58.9-8.8-79.7-27.4c-36.8 35.9-91.4 36-128.3 .3c-36.9 35.7-91.4 35.7-128.3-.3C75 389.9 45.3 403.9 16 398.7zM64 224H88V168c0-4.4 3.6-8 8-8s8 3.6 8 8v56H216V168c0-4.4 3.6-8 8-8s8 3.6 8 8v56H344V168c0-4.4 3.6-8 8-8s8 3.6 8 8v56h24c35.3 0 64 28.7 64 64V480c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V288c0-35.3 28.7-64 64-64zM224 19.8L197 62.3c-3.3 5.2-5 11.2-5 17.4c0 17.8 14.4 32.3 32 32.3s32-14.5 32-32.3c0-6.2-1.8-12.3-5-17.4L224 19.8zM214.2 5.4C216.3 2 220 0 224 0s7.7 2 9.8 5.4l30.7 48.3c4.9 7.7 7.5 16.8 7.5 26c0 26.5-21.5 48.3-48 48.3s-48-21.8-48-48.3c0-9.2 2.6-18.2 7.5-26L214.2 5.4zM325 62.3c-3.3 5.2-5 11.2-5 17.4c0 17.8 14.4 32.3 32 32.3s32-14.5 32-32.3c0-6.2-1.8-12.3-5-17.4L352 19.8 325 62.3zm-13.5-8.6L342.2 5.4C344.3 2 348 0 352 0s7.7 2 9.8 5.4l30.7 48.3c4.9 7.7 7.5 16.8 7.5 26c0 26.5-21.5 48.3-48 48.3s-48-21.8-48-48.3c0-9.2 2.6-18.2 7.5-26z'
      
    ]
  };

  
    var faBirthdayCake = faCakeCandles;
  
    var faCake = faCakeCandles;
  

  
  

  var faSquare1 = {
    prefix: 'fat',
    iconName: 'square-1',
    icon: [
      448,
      512,
      [],
      'e256',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm228 33.1c2.5 1.4 4 4.1 4 6.9V368h56c4.4 0 8 3.6 8 8s-3.6 8-8 8H224 160c-4.4 0-8-3.6-8-8s3.6-8 8-8h56V149.8l-44 25.2c-3.8 2.2-8.7 .9-10.9-3s-.9-8.7 3-10.9l56-32c2.5-1.4 5.5-1.4 8 0z'
      
    ]
  };

  

  
  

  var faComment = {
    prefix: 'fat',
    iconName: 'comment',
    icon: [
      512,
      512,
      [61669,128489],
      'f075',
      
      'M142.4 417.2c4.3-3.1 9.9-3.9 14.9-2.1c30 10.9 63.4 17 98.7 17c135.8 0 240-88.9 240-192S391.8 48 256 48S16 136.9 16 240c0 40.7 15.9 78.8 43.7 110.3c2.9 3.2 4.3 7.5 3.9 11.8c-2.2 27.7-12.9 52-23.6 69.9c-6 10-12 18-16.5 23.5l-12.2-10 12.2 10c-2.2 2.7-4.1 4.9-5.4 6.3c-.7 .7-1.2 1.3-1.5 1.6l-.1 .1-.3 .3 0 0 0 0L16 464c25.6 0 52.3-8 75.2-18c21.8-9.5 40.3-20.9 51.2-28.8zM4.7 452.7l0 0 0 0 .3-.3c.3-.3 .7-.7 1.3-1.4c1.1-1.2 2.8-3.1 4.9-5.7c4.1-5 9.6-12.4 15.2-21.6c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208s-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4l0 0 0 0z'
      
    ]
  };

  

  
  

  var faEllipsisStrokeVertical = {
    prefix: 'fat',
    iconName: 'ellipsis-stroke-vertical',
    icon: [
      192,
      512,
      ["ellipsis-v-alt"],
      'f39c',
      
      'M96 64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 80a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm32 112a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm80 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  
    var faEllipsisVAlt = faEllipsisStrokeVertical;
  

  
  

  var faBracketsCurly = {
    prefix: 'fat',
    iconName: 'brackets-curly',
    icon: [
      576,
      512,
      [],
      'f7ea',
      
      'M424 32H352c-4.4 0-8 3.6-8 8s3.6 8 8 8h72c22.1 0 40 17.9 40 40v77.5c0 19.1 7.6 37.4 21.1 50.9L524.7 256l-39.6 39.6c-13.5 13.5-21.1 31.8-21.1 50.9V424c0 22.1-17.9 40-40 40H352c-4.4 0-8 3.6-8 8s3.6 8 8 8h72c30.9 0 56-25.1 56-56V346.5c0-14.9 5.9-29.1 16.4-39.6l45.3-45.3c3.1-3.1 3.1-8.2 0-11.3l-45.3-45.3c-10.5-10.5-16.4-24.7-16.4-39.6V88c0-30.9-25.1-56-56-56zM152 32c-30.9 0-56 25.1-56 56v77.5c0 14.9-5.9 29.1-16.4 39.6L34.3 250.3c-3.1 3.1-3.1 8.2 0 11.3l45.3 45.3C90.1 317.4 96 331.7 96 346.5V424c0 30.9 25.1 56 56 56h72c4.4 0 8-3.6 8-8s-3.6-8-8-8H152c-22.1 0-40-17.9-40-40V346.5c0-19.1-7.6-37.4-21.1-50.9L51.3 256l39.6-39.6c13.5-13.5 21.1-31.8 21.1-50.9V88c0-22.1 17.9-40 40-40h72c4.4 0 8-3.6 8-8s-3.6-8-8-8H152z'
      
    ]
  };

  

  
  

  var faCircleYen = {
    prefix: 'fat',
    iconName: 'circle-yen',
    icon: [
      512,
      512,
      [],
      'e5d0',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM349.1 153.9c3.4 2.8 3.8 7.9 1 11.3l-77.5 92.3H320c4.4 0 8 3.6 8 8s-3.6 8-8 8H264V319h56c4.4 0 8 3.6 8 8s-3.6 8-8 8H264v41c0 4.4-3.6 8-8 8s-8-3.6-8-8V335H192c-4.4 0-8-3.6-8-8s3.6-8 8-8h56V273.4H192c-4.4 0-8-3.6-8-8s3.6-8 8-8h47.4l-77.6-92.3c-2.8-3.4-2.4-8.4 1-11.3s8.4-2.4 11.3 1L256 252.3l81.9-97.4c2.8-3.4 7.9-3.8 11.3-1z'
      
    ]
  };

  

  
  

  var faCoffeeBean = {
    prefix: 'fat',
    iconName: 'coffee-bean',
    icon: [
      448,
      512,
      [],
      'e13e',
      
      'M389.6 85.8c-.1-.1-.2-.2-.4-.4c-1.7 4.2-3.5 8.6-5.3 13c-14.5 34.4-35 75.8-58.2 99.2C293 230.5 259.9 247 227.8 263l-.3 .1c-32.1 16-63.2 31.5-93.9 62.5c-21 21.1-42.5 59.9-59 94.4c-2.3 4.8-4.4 9.4-6.5 13.9c31.7 23.5 73.9 32.2 119.6 25.6c53-7.6 109.7-35.5 157-82.8s75.2-104 82.8-157s-5.3-101.2-38-133.9zM376.4 74.3c-31.9-24.2-74.5-33.1-120.8-26.5c-53 7.6-109.7 35.5-157 82.8s-75.2 104-82.8 157s5.3 101.2 38 133.9c.6 .6 1.1 1.1 1.7 1.7c1.5-3.3 3.1-6.7 4.7-10.1c16.5-34.4 39-75.6 62.1-98.8c32.7-32.9 65.8-49.4 97.8-65.4l.3-.1c32.1-16 63.2-31.5 93.9-62.5c20.8-20.9 40.3-59.6 54.8-94.1c2.6-6.2 5-12.2 7.3-17.9zm24.5 .2c74.2 74.2 54.2 214.6-44.8 313.6C265 479.2 138.9 503.4 61.5 448.9c-.1-.1-.3-.2-.4-.3c-4.3-3.1-8.5-6.4-12.5-10c-2.1-1.8-4.1-3.7-6-5.7c-74.2-74.2-54.2-214.6 44.8-313.6s239.4-119 313.6-44.8z'
      
    ]
  };

  

  
  

  var faInboxes = {
    prefix: 'fat',
    iconName: 'inboxes',
    icon: [
      512,
      512,
      [],
      'e1bb',
      
      'M21.5 160H124.2c15.2 0 29 8.6 35.8 22.1l14.3 28.6c4.1 8.1 12.4 13.3 21.5 13.3H316.2c9.1 0 17.4-5.1 21.5-13.3L352 182.1c6.8-13.6 20.6-22.1 35.8-22.1H490.5L430.6 34.2C425.3 23.1 414 16 401.7 16H110.3C98 16 86.7 23.1 81.4 34.2L21.5 160zm474.3 16H387.8c-9.1 0-17.4 5.1-21.5 13.3L352 217.9c-6.8 13.6-20.6 22.1-35.8 22.1H195.8c-15.2 0-29-8.6-35.8-22.1l-14.3-28.6c-4.1-8.1-12.4-13.3-21.5-13.3H16.1c-.1 .9-.1 1.9-.1 2.8V272c0 17.7 14.3 32 32 32H464c17.7 0 32-14.3 32-32V178.8c0-1 0-1.9-.1-2.8zM4.7 158.2L67 27.4C74.9 10.6 91.8 0 110.3 0H401.7c18.5 0 35.4 10.6 43.3 27.4l62.3 130.8c3.1 6.4 4.7 13.5 4.7 20.6V272c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V178.8c0-7.1 1.6-14.2 4.7-20.6zM122.3 368H48c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H464c17.7 0 32-14.3 32-32V400c0-17.7-14.3-32-32-32H389.7c-12.1 0-23.2 6.8-28.6 17.7l-9.9 19.8C343 421.7 326.4 432 308.2 432H203.8c-18.2 0-34.8-10.3-42.9-26.5L151 385.7c-5.4-10.8-16.5-17.7-28.6-17.7zm214.5 30.3l9.9-19.8c8.1-16.3 24.8-26.5 42.9-26.5H464c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V400c0-26.5 21.5-48 48-48h74.3c18.2 0 34.8 10.3 42.9 26.5l9.9 19.8c5.4 10.8 16.5 17.7 28.6 17.7H308.2c12.1 0 23.2-6.8 28.6-17.7z'
      
    ]
  };

  

  
  

  var faBookSection = {
    prefix: 'fat',
    iconName: 'book-section',
    icon: [
      448,
      512,
      ["book-law"],
      'e0c1',
      
      'M0 56C0 25.1 25.1 0 56 0H408c22.1 0 40 17.9 40 40V376c0 19.4-13.7 35.5-32 39.2V496h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H56c-30.9 0-56-25.1-56-56V56zM56 416c-22.1 0-40 17.9-40 40s17.9 40 40 40H400V416H56zm-40 .8C26.2 406.4 40.3 400 56 400H408c13.3 0 24-10.7 24-24V40c0-13.3-10.7-24-24-24H56C33.9 16 16 33.9 16 56V416.8zM318.9 222c-3.3 16-14.9 28.1-32.5 35.3c22.4 9.6 38.1 24.4 32.5 52.1c-5.5 27-33.7 42.6-74.4 42.6c-7.6 0-15.6-.5-24-1.7c-15.6-2-32.5-7.2-47.5-11.8l-7.3-2.2c-4.2-1.3-6.6-5.7-5.3-10c1.2-4.2 5.6-6.6 10-5.3l7.4 2.3 .1 0c14.3 4.4 30.6 9.4 44.8 11.2c43.4 5.8 75.9-5.5 80.5-28.3c5.5-27.4-20.9-35.9-65.1-46.7l-9.6-2.4-.1 0c-28.5-7.2-76.2-19.2-67.3-63c3.3-16.1 15-28.1 32.5-35.4c-20.8-9.1-38.2-24-32.5-52c6.5-32 45.1-48.2 98.3-41c10 1.3 21.7 4 36.8 8.5c4.2 1.2 6.7 5.7 5.4 9.9c-1.2 4.2-5.7 6.7-9.9 5.4c-14.3-4.2-25.3-6.7-34.4-8c-43.7-5.8-75.9 5.6-80.5 28.3c-4.9 24.4 14.8 34.1 55.6 44.3l9.5 2.3 0 0c40.3 9.9 86 21 77 65.4zm-86.5 19.6l9.5 2.3c5.7 1.4 11.5 2.9 17.3 4.4c18.8-3.5 40-9.5 44.1-29.5c5.5-27.4-20.9-35.9-65.1-46.7c0 0-14.6-3.7-17.2-4.3c-19.2 3.6-40 9.6-44.1 29.5c-4.9 24.4 14.9 34.1 55.6 44.3z'
      
    ]
  };

  
    var faBookLaw = faBookSection;
  

  
  

  var faStretcher = {
    prefix: 'fat',
    iconName: 'stretcher',
    icon: [
      640,
      512,
      [],
      'f825',
      
      'M177.1 202.9L71.3 90.1C59.3 77.2 39 76.6 26.1 88.7s-13.5 32.3-1.5 45.2L135.2 251.8c12.1 12.9 29 20.2 46.7 20.2H592c17.7 0 32-14.3 32-32s-14.3-32-32-32H188.8c-4.4 0-8.6-1.8-11.7-5.1zM83 79.2L188.8 192H592c26.5 0 48 21.5 48 48s-21.5 48-48 48H181.9c-22.1 0-43.2-9.2-58.4-25.3L13 144.8C-5.1 125.5-4.2 95.1 15.2 77S64.9 59.8 83 79.2zM272 464a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm16 0c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48c14.2 0 27 6.2 35.7 16L353 383.2 253 320h30l85 53.7L453 320h30L383 383.2 460.3 432c8.8-9.8 21.5-16 35.7-16c26.5 0 48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48c0-6.6 1.3-12.8 3.7-18.5L368 392.6l-83.7 52.9c2.4 5.7 3.7 12 3.7 18.5zm208 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faTag = {
    prefix: 'fat',
    iconName: 'tag',
    icon: [
      448,
      512,
      [127991],
      'f02b',
      
      'M16 229.5c0 12.7 5.1 24.9 14.1 33.9l176 176c18.7 18.7 49.1 18.7 67.9 0L407.4 305.9c18.7-18.7 18.7-49.1 0-67.9l-176-176c-9-9-21.2-14.1-33.9-14.1H48C30.3 48 16 62.3 16 80V229.5zm-16 0V80C0 53.5 21.5 32 48 32H197.5c17 0 33.3 6.7 45.3 18.7l176 176c25 25 25 65.5 0 90.5L285.3 450.7c-25 25-65.5 25-90.5 0l-176-176C6.7 262.7 0 246.5 0 229.5zM112 104a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faSteeringWheel = {
    prefix: 'fat',
    iconName: 'steering-wheel',
    icon: [
      512,
      512,
      [],
      'f622',
      
      'M248 385.9V495.9C129.9 492 33.4 402.8 18.1 288H145.6c2 5.1 5 9.9 9.1 14L227.7 375c5.8 5.8 12.9 9.4 20.3 10.9zm16 0c7.4-1.5 14.5-5.1 20.3-10.9L357.3 302c4.1-4.1 7.1-8.8 9.1-14H493.9C478.6 402.8 382.1 492 264 495.9V385.9zM369 272c-.2-5.5-1.6-11-4.2-16.2L352 230.1c-6.8-13.6-20.6-22.1-35.8-22.1H195.8c-15.2 0-29 8.6-35.8 22.1l-12.8 25.7c-2.6 5.2-4 10.7-4.2 16.2H16.5c-.3-5.3-.5-10.6-.5-16C16 123.5 123.5 16 256 16s240 107.5 240 240c0 5.4-.2 10.7-.5 16H369zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM174.3 237.3c4.1-8.1 12.4-13.3 21.5-13.3H316.2c9.1 0 17.4 5.1 21.5 13.3l12.8 25.7c4.6 9.2 2.8 20.4-4.5 27.7L273 363.7c-9.4 9.4-24.6 9.4-33.9 0L166 290.7c-7.3-7.3-9.1-18.5-4.5-27.7l12.8-25.7z'
      
    ]
  };

  

  
  

  var faPlaneLock = {
    prefix: 'fat',
    iconName: 'plane-lock',
    icon: [
      640,
      512,
      [],
      'e558',
      
      'M256 0c-19.8 0-35.8 16.2-46.3 33.3C199 50.8 192 72.6 192 89.2l0 86.8 0 1.3L20.7 271.9C7.9 278.9 0 292.3 0 306.9V355c0 15.9 15.1 27.4 30.4 23.1L192 333.5V352l0 44-54.4 40.8c-6 4.5-9.6 11.6-9.6 19.2v34.1c0 12.1 9.8 21.9 21.9 21.9c2.2 0 4.4-.3 6.4-1L256 480.4 355.6 511c2.1 .6 4.3 1 6.4 1c2 0 4-.3 5.9-.8l0-21.1c0 3.3-2.6 5.9-5.9 5.9c-.6 0-1.2-.1-1.7-.3l-2.4 7.6 2.4-7.6-102-31.4c-1.5-.5-3.2-.5-4.7 0l-102 31.4c-.6 .2-1.1 .3-1.7 .3c-3.3 0-5.9-2.6-5.9-5.9V456c0-2.5 1.2-4.9 3.2-6.4l57.6-43.2c2-1.5 3.2-3.9 3.2-6.4l0-48V323l0-141 0-6.1 0-86.8c0-13 5.7-31.9 15.3-47.5C233.2 25.6 245.1 16 256 16c11.3 0 23.2 9.6 33 25.6c9.5 15.6 15 34.5 15 47.5l0 86.8 0 6.1 0 0V323v29l0 48c0 2.5 1.2 4.9 3.2 6.4l57.6 43.2c2 1.5 3.2 3.9 3.2 6.4l0-24-48-36 0-44 0-18.5 64 17.7c.1-5.5 .8-10.9 2.2-16L320 316.9V195.6l98.2 54.2c1.1-5.4 2.6-10.7 4.4-15.8L320 177.3l0-1.3 0-86.8c0-16.6-6.7-38.3-17.3-55.8C292.3 16.2 276.2 0 256 0zM28.4 285.9L192 195.6V316.9L26.1 362.7C21 364.1 16 360.3 16 355V306.9c0-8.7 4.8-16.8 12.4-21zM528 208c26.5 0 48 21.5 48 48v64H480V256c0-26.5 21.5-48 48-48zm-64 48v64H448c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H592V256c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-16 80h16 16 96 16 16c8.8 0 16 7.2 16 16V480c0 8.8-7.2 16-16 16H448c-8.8 0-16-7.2-16-16V352c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faTruckFire = {
    prefix: 'fat',
    iconName: 'truck-fire',
    icon: [
      640,
      512,
      [],
      'e65a',
      
      'M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8H80V96H48C21.5 96 0 117.5 0 144V368c0 26.5 21.5 48 48 48H64.4c-.2 2.6-.4 5.3-.4 8c0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8H400.4c-.2 2.6-.4 5.3-.4 8c0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8H592c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H560V88c0-22.1-17.9-40-40-40s-40 17.9-40 40v8H384V16H632c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zM368 16V96H288V16h80zm-96 0V96H192V16h80zm-96 0V96H96V16h80zM544 96H496V88c0-13.3 10.7-24 24-24s24 10.7 24 24v8zm0 16h16 32c17.7 0 32 14.3 32 32V368c0 17.7-14.3 32-32 32H572.7c-10.4-36.9-44.4-64-84.7-64s-74.2 27.1-84.7 64H236.7c-10.4-36.9-44.4-64-84.7-64s-74.2 27.1-84.7 64H48c-17.7 0-32-14.3-32-32V272H400c17.7 0 32-14.3 32-32V112h48 16 48zm-128 0V240c0 8.8-7.2 16-16 16H16V144c0-17.7 14.3-32 32-32H416zm152 48c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8H488c-4.4 0-8-3.6-8-8V168c0-4.4 3.6-8 8-8h80zm-80-16c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V168c0-13.3-10.7-24-24-24H488zM152 352a72 72 0 1 1 0 144 72 72 0 1 1 0-144zm264 72a72 72 0 1 1 144 0 72 72 0 1 1 -144 0z'
      
    ]
  };

  

  
  

  var faSatellite = {
    prefix: 'fat',
    iconName: 'satellite',
    icon: [
      512,
      512,
      [128752],
      'f7bf',
      
      'M229.7 18.3l68 68-91.3 91.3-68-68c-3.1-3.1-3.1-8.2 0-11.3l80-80c3.1-3.1 8.2-3.1 11.3 0zM309 75L241 7c-9.4-9.4-24.6-9.4-33.9 0L127 87c-9.4 9.4-9.4 24.6 0 33.9l68 68-18 18c-55.2-16.2-117-4.5-163.1 35.9c-3.8 3.3-5.9 8-5.9 13v.5c0 4.9 1.9 9.6 5.4 13L122.3 378.3l-20.3 20.3C95.7 394.4 88.2 392 80 392c-22.1 0-40 17.9-40 40s17.9 40 40 40s40-17.9 40-40c0-8.2-2.4-15.7-6.6-22.1l20.3-20.3L242.6 498.6c3.5 3.5 8.1 5.4 13 5.4h.5c5 0 9.8-2.2 13-5.9c40.4-46.1 52.1-107.9 35.9-163.1l18-18 68 68c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-68-68L463 177c10.9-10.9 17-25.6 17-41s-6.1-30.1-17-41L417 49c-10.9-10.9-25.6-17-41-17s-30.1 6.1-41 17L309 75zM425.7 214.3l68 68c3.1 3.1 3.1 8.2 0 11.3l-80 80c-3.1 3.1-8.2 3.1-11.3 0l-68-68 91.3-91.3zm26.1-48.7L299.2 318.2c-8.5-20.7-21.1-40.1-37.9-56.9l-10.6-10.6c-16.8-16.8-36.2-29.4-56.9-37.9L346.3 60.3C354.2 52.4 364.9 48 376 48s21.8 4.4 29.7 12.3l46.1 46.1c7.9 7.9 12.3 18.5 12.3 29.7s-4.4 21.8-12.3 29.7zm-427 92.4L13.8 269l10.9-10.9c-.5-.5-.7-1.1-.7-1.7v-.5c0-.4 .2-.8 .5-1c62.4-54.6 156.3-51.4 214.9 7.2L250 272.6c58.6 58.6 61.7 152.6 7.2 214.9c-.3 .3-.6 .5-1 .5h-.5c-.6 0-1.3-.3-1.7-.7L24.7 258.1zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faChessClockFlip = {
    prefix: 'fat',
    iconName: 'chess-clock-flip',
    icon: [
      640,
      512,
      ["chess-clock-alt"],
      'f43e',
      
      'M392 32c-4.4 0-8 3.6-8 8s3.6 8 8 8h64v80H64c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H472V48h64c4.4 0 8-3.6 8-8s-3.6-8-8-8H464 392zm72 112H576c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V192c0-26.5 21.5-48 48-48H464zM96 88c0 4.4 3.6 8 8 8H248c4.4 0 8-3.6 8-8s-3.6-8-8-8H104c-4.4 0-8 3.6-8 8zM464 208a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 208a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM108.1 236.1A96 96 0 1 1 243.9 371.9 96 96 0 1 1 108.1 236.1zM255.2 383.2A112 112 0 1 0 96.8 224.8 112 112 0 1 0 255.2 383.2zM464 240c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8s8-3.6 8-8V248c0-4.4-3.6-8-8-8zM221.3 270.1c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-39.6 39.6c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l39.6-39.6z'
      
    ]
  };

  
    var faChessClockAlt = faChessClockFlip;
  

  
  

  var faFilePlusMinus = {
    prefix: 'fat',
    iconName: 'file-plus-minus',
    icon: [
      384,
      512,
      [],
      'e177',
      
      'M16 448V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM200 232c0-4.4-3.6-8-8-8s-8 3.6-8 8v56H128c-4.4 0-8 3.6-8 8s3.6 8 8 8h56v56c0 4.4 3.6 8 8 8s8-3.6 8-8V304h56c4.4 0 8-3.6 8-8s-3.6-8-8-8H200V232zM128 416c-4.4 0-8 3.6-8 8s3.6 8 8 8H256c4.4 0 8-3.6 8-8s-3.6-8-8-8H128z'
      
    ]
  };

  

  
  

  var faUserVisor = {
    prefix: 'fat',
    iconName: 'user-visor',
    icon: [
      448,
      512,
      [],
      'e04c',
      
      'M331.4 160c-13.8 46.3-56.6 80-107.4 80s-93.6-33.7-107.4-80H331.4zm17.2-2.6C360 152.5 368 141.2 368 128V96c0-17.7-14.3-32-32-32h-1.1C312.7 25.7 271.4 0 224 0s-88.7 25.7-110.9 64H112C94.3 64 80 78.3 80 96v32c0 13.2 8 24.5 19.4 29.4c13.3 56.5 64 98.6 124.6 98.6s111.3-42.1 124.6-98.6zM315.9 64H132.1c20.2-29 53.9-48 91.9-48s71.7 19 91.9 48zM269.7 320C359.3 320 432 392.7 432 482.3c0 7.6-6.1 13.7-13.7 13.7H29.7c-7.6 0-13.7-6.1-13.7-13.7C16 392.7 88.7 320 178.3 320h91.4zm-91.4-16C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3zM112 80H336c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16zm8 32c0 4.4 3.6 8 8 8H320c4.4 0 8-3.6 8-8s-3.6-8-8-8H128c-4.4 0-8 3.6-8 8zM293.3 449.6c4.4-28.5 14.3-52.2 29.3-71c13.5 19.1 21.8 41.8 24.5 67.9c-6.9-9.1-10.7-13.1-12.9-15.1c-1.5-1.3-3.4-2-5.3-2c-4.9 0-9.7 1.8-13.7 3.9c-4.1 2.2-8.2 5-11.9 7.9c-3.6 2.8-7.1 5.8-10.1 8.4zm29.6-89.4c-3 0-6.7 1.1-9.2 4.1l6.1 5.2-6.1-5.2c0 0 0 0 0 0c-21.1 24.5-33.6 56.1-37.7 93.9l0 0 0 .2c-.9 11.2 11.5 16.2 19.2 10.6l0 0 .2-.2c2-1.6 4.5-3.7 7-5.9l0 0 1.2-1c3-2.7 6.3-5.5 9.6-8c3.3-2.6 6.6-4.8 9.5-6.4c1.3-.7 2.5-1.2 3.4-1.5c2.8 3.1 7.7 9.2 16.1 21.1l0 0 .1 .2c7.4 9.9 21.7 3.6 21.7-7.3h0l0-.3c-1.2-36.6-11.7-68.6-31.6-94.6c-2.5-3.7-6.5-4.8-9.5-4.8z'
      
    ]
  };

  

  
  

  var faLiraSign = {
    prefix: 'fat',
    iconName: 'lira-sign',
    icon: [
      320,
      512,
      [8356],
      'f195',
      
      'M80 143.2C80 90.6 122.6 48 175.2 48c10.2 0 20.4 1.7 30.1 4.9l80.1 26.7c4.2 1.4 8.7-.9 10.1-5.1s-.9-8.7-5.1-10.1L210.4 37.7c-11.3-3.8-23.2-5.7-35.2-5.7C113.8 32 64 81.8 64 143.2V224H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H64v20.6c0 20-1.6 39.8-4.8 59.4H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H56.3c-9.6 46.7-28.2 91.4-54.9 131.5C.5 468.8 0 470.3 0 472c0 4.4 3.6 8 8 8H312c4.4 0 8-3.6 8-8s-3.6-8-8-8H22.6c24.2-39.5 41.1-82.9 50-128H248c4.4 0 8-3.6 8-8s-3.6-8-8-8H75.4c3-19.6 4.6-39.4 4.6-59.4V240H248c4.4 0 8-3.6 8-8s-3.6-8-8-8H80V143.2z'
      
    ]
  };

  

  
  

  var faChild = {
    prefix: 'fat',
    iconName: 'child',
    icon: [
      320,
      512,
      [],
      'f1ae',
      
      'M160 112a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM160 0a64 64 0 1 1 0 128A64 64 0 1 1 160 0zm-1.5 176c-32.5 0-62.3 17.9-77.6 46.5L31.1 315.8c-2.1 3.9-6.9 5.4-10.8 3.3s-5.4-6.9-3.3-10.8L66.7 215c18.1-33.9 53.3-55 91.7-55h3c38.4 0 73.6 21.1 91.7 55l49.8 93.2c2.1 3.9 .6 8.7-3.3 10.8s-8.7 .6-10.8-3.3l-49.8-93.2C223.8 193.9 194 176 161.5 176h-3zM96 288V480c0 8.8 7.2 16 16 16s16-7.2 16-16V400c0-17.7 14.3-32 32-32s32 14.3 32 32v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-4.4 3.6-8 8-8s8 3.6 8 8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V400c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 17.7-14.3 32-32 32s-32-14.3-32-32V288c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faWashingMachine = {
    prefix: 'fat',
    iconName: 'washing-machine',
    icon: [
      448,
      512,
      ["washer"],
      'f898',
      
      'M384 16c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H384zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM96 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm80-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM351.6 314.3c-14.3 3.4-30.4 5.7-47.6 5.7c-32 0-56-16-80-32s-48-32-80-32c-13.4 0-27.4 2.2-40.7 5.4c17.6-49.7 65-85.4 120.7-85.4c70.7 0 128 57.3 128 128c0 3.5-.1 6.9-.4 10.3zm-2.5 16.9C336.6 388.8 285.3 432 224 432c-70.7 0-128-57.3-128-128c0-8.5 .8-16.8 2.4-24.9c15-4.2 30.9-7.1 45.6-7.1c26.5 0 46.6 13 71.1 29.3l1.2 .8C239.6 317.6 267.1 336 304 336c16.2 0 31.3-1.9 45.1-4.8zM224 448a144 144 0 1 0 0-288 144 144 0 1 0 0 288z'
      
    ]
  };

  
    var faWasher = faWashingMachine;
  

  
  

  var faBookSparkles = {
    prefix: 'fat',
    iconName: 'book-sparkles',
    icon: [
      448,
      512,
      ["book-spells"],
      'f6b8',
      
      'M56 0C25.1 0 0 25.1 0 56V456c0 30.9 25.1 56 56 56H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H416V415.2c18.3-3.7 32-19.8 32-39.2V40c0-22.1-17.9-40-40-40H56zM400 416v80H56c-22.1 0-40-17.9-40-40s17.9-40 40-40H400zM56 400c-15.7 0-29.8 6.4-40 16.8V56c0-22.1 17.9-40 40-40H408c13.3 0 24 10.7 24 24V376c0 13.3-10.7 24-24 24H56zM273.3 174l-20.2 47.1L206 241.3c-12.9 5.5-12.9 23.9 0 29.4l47.1 20.2L273.3 338c5.5 12.9 23.9 12.9 29.4 0l20.2-47.1L370 270.7c12.9-5.5 12.9-23.9 0-29.4l-47.1-20.2L302.7 174c-5.5-12.9-23.9-12.9-29.4 0zm14.7 6.3l21.4 50c.8 1.9 2.3 3.4 4.2 4.2l50 21.4-50 21.4c-1.9 .8-3.4 2.3-4.2 4.2l-21.4 50-21.4-50c-.8-1.9-2.3-3.4-4.2-4.2l-50-21.4 50-21.4c1.9-.8 3.4-2.3 4.2-4.2l21.4-50zM182.3 82.7c-5.9-11.8-22.7-11.8-28.6 0l-13 26-26 13c-11.8 5.9-11.8 22.7 0 28.6l26 13 13 26c5.9 11.8 22.7 11.8 28.6 0l13-26 26-13c11.8-5.9 11.8-22.7 0-28.6l-26-13-13-26zm-28.5 35.5L168 89.9l14.2 28.4c.8 1.5 2 2.8 3.6 3.6L214.1 136l-28.4 14.2c-1.5 .8-2.8 2-3.6 3.6L168 182.1l-14.2-28.4c-.8-1.5-2-2.8-3.6-3.6L121.9 136l28.4-14.2c1.5-.8 2.8-2 3.6-3.6z'
      
    ]
  };

  
    var faBookSpells = faBookSparkles;
  

  
  

  var faSquareArrowDownRight = {
    prefix: 'fat',
    iconName: 'square-arrow-down-right',
    icon: [
      448,
      512,
      [],
      'e262',
      
      'M384 464c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384zm64-48c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416zM168 352c-4.4 0-8-3.6-8-8s3.6-8 8-8H292.7L130.3 173.7c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L304 324.7V200c0-4.4 3.6-8 8-8s8 3.6 8 8V344c0 4.4-3.6 8-8 8H168z'
      
    ]
  };

  

  
  

  var faFilmSlash = {
    prefix: 'fat',
    iconName: 'film-slash',
    icon: [
      640,
      512,
      [],
      'e179',
      
      'M13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7zM467.3 464H464v-2.6l-16-12.6V464H192V400 304 246.7L176 234v62H80V216h73.1l-20.3-16H80V158.3L64 145.6V200v8 8 80 8 8 80 8 8 8c0 35.3 28.7 64 64 64h48 8 8H448h8 8 23.5l-20.3-16zM176 32H152.5l20.3 16H176v2.6l16 12.6V48H448v64 96 57.3L464 278V216h96v80H486.9l20.3 16H560v41.7l16 12.6V312v-8-8V216v-8-8V120v-8-8V96c0-35.3-28.7-64-64-64H464h-8-8H192h-8-8zM80 312h96v80H80V312zm0 96h96v56H128c-26.5 0-48-21.5-48-48v-8zM464 48h48c26.5 0 48 21.5 48 48v8H464V48zm96 72v80H464V120h96z'
      
    ]
  };

  

  
  

  var faBusSchool = {
    prefix: 'fat',
    iconName: 'bus-school',
    icon: [
      512,
      512,
      [],
      'f5dd',
      
      'M82.9 69C81 71.2 80 74.6 80 79V96H432V79c0-4.3-1-7.9-2.9-10.3C413.9 49.3 368 16 256 16C151.7 16 99.3 49.4 82.9 69zM80 112V249.6c12-6.1 25.6-9.6 40-9.6H248V112H80zM432 249.6V112H264V240H392c14.4 0 28 3.5 40 9.6zM448 79V260.1c19.5 16.1 32 40.6 32 67.9v72c0 20.9-13.4 38.7-32 45.3V448v32c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V448H160v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V448v-2.7c-18.6-6.6-32-24.4-32-45.3V328c0-27.3 12.5-51.7 32-67.9V79c0-6.6 1.5-14.2 6.7-20.3C91.1 34.3 148.8 0 256 0C370.9 0 422.4 34.2 441.7 58.8C446.5 65 448 72.4 448 79zM352 432h16 64c17.7 0 32-14.3 32-32V328c0-39.8-32.2-72-72-72H120c-39.8 0-72 32.2-72 72v72c0 17.7 14.3 32 32 32h64 16H352zm16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V448H368zM80 448v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V448H80zm8-104a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm40 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm40 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM192 48H320c4.4 0 8 3.6 8 8s-3.6 8-8 8H192c-4.4 0-8-3.6-8-8s3.6-8 8-8zM0 120c0-13.3 10.7-24 24-24h8c4.4 0 8 3.6 8 8s-3.6 8-8 8H24c-4.4 0-8 3.6-8 8V232c0 4.4 3.6 8 8 8h8c4.4 0 8 3.6 8 8s-3.6 8-8 8H24c-13.3 0-24-10.7-24-24V120zM488 96c13.3 0 24 10.7 24 24V232c0 13.3-10.7 24-24 24h-8c-4.4 0-8-3.6-8-8s3.6-8 8-8h8c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8h-8c-4.4 0-8-3.6-8-8s3.6-8 8-8h8z'
      
    ]
  };

  

  
  

  var faClipboardUser = {
    prefix: 'fat',
    iconName: 'clipboard-user',
    icon: [
      384,
      512,
      [],
      'f7f3',
      
      'M192 0c-37.1 0-67.6 28-71.6 64H112C91.1 64 73.3 77.4 66.7 96H64C28.7 96 0 124.7 0 160V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64h-2.7c-6.6-18.6-24.4-32-45.3-32h-8.4c-4-36-34.5-64-71.6-64zM16 160c0-26.5 21.5-48 48-48v16c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V112c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V160zM136 72c0-30.9 25.1-56 56-56s56 25.1 56 56c0 4.4 3.6 8 8 8h16c17.7 0 32 14.3 32 32v16c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V112c0-17.7 14.3-32 32-32h16c4.4 0 8-3.6 8-8zm56 24a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0 112a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-40 48h80c30.9 0 56 25.1 56 56c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8c0-30.9 25.1-56 56-56zM80 424c0 13.3 10.7 24 24 24H280c13.3 0 24-10.7 24-24c0-39.8-32.2-72-72-72H152c-39.8 0-72 32.2-72 72z'
      
    ]
  };

  

  
  

  var faFaceFearful = {
    prefix: 'fat',
    iconName: 'face-fearful',
    icon: [
      512,
      512,
      [],
      'e375',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm251.8 64h8.4c46.3 0 83.8 37.5 83.8 83.8c0 6.7-5.5 12.2-12.2 12.2H180.2c-6.7 0-12.2-5.5-12.2-12.2c0-46.3 37.5-83.8 83.8-83.8zm8.4 16h-8.4c-36.2 0-65.7 28.3-67.7 64H327.9c-2-35.7-31.5-64-67.7-64zM144.4 224a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm208-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM200 87.5c.3 4.4-3.1 8.2-7.5 8.5c-32.5 2-61.6 16.5-82.7 38.7c-3 3.2-8.1 3.3-11.3 .3s-3.3-8.1-.3-11.3c23.7-25.1 56.6-41.4 93.3-43.7c4.4-.3 8.2 3.1 8.5 7.5zM319.5 96c-4.4-.3-7.8-4.1-7.5-8.5s4.1-7.8 8.5-7.5c36.7 2.3 69.6 18.6 93.3 43.7c3 3.2 2.9 8.3-.3 11.3s-8.3 2.9-11.3-.3C381.1 112.5 352 98 319.5 96zM160 168a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm72 56A72 72 0 1 1 88 224a72 72 0 1 1 144 0zm64 0a56 56 0 1 0 112 0 56 56 0 1 0 -112 0zm56 72a72 72 0 1 1 0-144 72 72 0 1 1 0 144z'
      
    ]
  };

  

  
  

  var faLocationExclamation = {
    prefix: 'fat',
    iconName: 'location-exclamation',
    icon: [
      384,
      512,
      ["map-marker-exclamation"],
      'f608',
      
      'M368 192c0-97.2-78.8-176-176-176S16 94.8 16 192c0 18.7 6.4 42.5 17.8 69.6c11.3 26.9 27.1 55.8 44.7 84.3c35.2 57 76.8 111.4 102.3 143.2c5.9 7.3 16.6 7.3 22.4 0c25.5-31.8 67.1-86.2 102.3-143.2c17.6-28.5 33.4-57.4 44.7-84.3C361.6 234.5 368 210.7 368 192zm16 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM192 96c4.4 0 8 3.6 8 8V264c0 4.4-3.6 8-8 8s-8-3.6-8-8V104c0-4.4 3.6-8 8-8zM176 320a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  
    var faMapMarkerExclamation = faLocationExclamation;
  

  
  

  var faTableRows = {
    prefix: 'fat',
    iconName: 'table-rows',
    icon: [
      512,
      512,
      ["rows"],
      'e292',
      
      'M16 96c0-26.5 21.5-48 48-48l64 0 0 416-64 0c-26.5 0-48-21.5-48-48L16 96zM448 464l-304 0 0-200 352 0 0 152c0 26.5-21.5 48-48 48zm48-216l-352 0 0-200 304 0c26.5 0 48 21.5 48 48l0 152zM0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416z'
      
    ]
  };

  
    var faRows = faTableRows;
  

  
  

  var faHatCowboySide = {
    prefix: 'fat',
    iconName: 'hat-cowboy-side',
    icon: [
      640,
      512,
      [],
      'f8c1',
      
      'M388.4 49l-200 46.7c-17.1 4-29.7 18.7-30.8 36.3l-5.1 76.4c3.7-.2 7.4-.4 11.2-.4c35.7 0 70.4 11.6 98.8 33.2L303.3 272H473.5L439.2 80.9c-3.4-19.1-20-32.9-39.4-32.9h-2.3c-3.1 0-6.1 .4-9.1 1zM136.4 210.3l5.3-79.3c1.6-24.6 19.2-45.2 43.2-50.8l200-46.7c4.2-1 8.4-1.5 12.7-1.5h2.3C427 32 450.2 51.4 455 78.1l23.7 132c1 .4 2.1 .9 3.5 1.5c4.5 2 10.8 4.9 18.5 8.7c15.2 7.6 35.6 18.8 56 33.1c20.4 14.3 41.1 31.8 56.8 52.2C629 326 640 349.7 640 376c0 39.8-32.2 72-72 72H512 472 52.8C23.6 448 0 424.4 0 395.2V371.7c0-81.1 59-148.4 136.4-161.4zm345.7 18.9l21.8 121.4c.8 4.3-2.1 8.5-6.5 9.3s-8.5-2.1-9.3-6.5L476.4 288h-152L514.7 432H568c30.9 0 56-25.1 56-56c0-21.7-9-42-23.3-60.6c-14.3-18.6-33.6-35.1-53.2-48.8c-19.6-13.7-39.2-24.5-54-31.9c-4.2-2.1-8-3.9-11.3-5.5zM16 371.7v23.5C16 415.5 32.5 432 52.8 432H472h16.2L297.9 288H296v-1.4l-43.1-32.6c-25.7-19.4-57-29.9-89.1-29.9C82.1 224 16 290.1 16 371.7z'
      
    ]
  };

  

  
  

  var faDiscDrive = {
    prefix: 'fat',
    iconName: 'disc-drive',
    icon: [
      512,
      512,
      [],
      'f8b5',
      
      'M104 48H408c30.9 0 56 25.1 56 56V464H48V104c0-30.9 25.1-56 56-56zM480 464V104c0-39.8-32.2-72-72-72H104c-39.8 0-72 32.2-72 72V464H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H40 472h32c4.4 0 8-3.6 8-8s-3.6-8-8-8H480zM416 256A160 160 0 1 0 96 256a160 160 0 1 0 320 0zM256 112a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM240 256a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faPhoneVolume = {
    prefix: 'fat',
    iconName: 'phone-volume',
    icon: [
      512,
      512,
      ["volume-control-phone"],
      'f2a0',
      
      'M264 0c-4.4 0-8 3.6-8 8s3.6 8 8 8c128.1 0 232 103.9 232 232c0 4.4 3.6 8 8 8s8-3.6 8-8C512 111 401 0 264 0zm8 224a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 104c0 4.4 3.6 8 8 8c75.1 0 136 60.9 136 136c0 4.4 3.6 8 8 8s8-3.6 8-8c0-83.9-68.1-152-152-152c-4.4 0-8 3.6-8 8zm41.8 278.5c6.6 3.1 14.6 1.3 19.2-4.3l40.4-49.3c6.7-8.2 18-11 27.8-7l96 40c11.1 4.6 17.1 16.8 13.9 28.5l-24 88C468.3 488.8 458.8 496 448 496C209.4 496 16 302.6 16 64c0-10.8 7.2-20.3 17.7-23.2l88-24c11.6-3.2 23.8 2.8 28.5 13.9l40 96c4.1 9.8 1.3 21.1-7 27.8l-49.3 40.4c-5.7 4.7-7.5 12.6-4.3 19.2c34.8 73.8 94.5 133.5 168.3 168.3zM345 318.7L304.7 368C234.2 334.7 177.2 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6z'
      
    ]
  };

  
    var faVolumeControlPhone = faPhoneVolume;
  

  
  

  var faSealQuestion = {
    prefix: 'fat',
    iconName: 'seal-question',
    icon: [
      512,
      512,
      [],
      'e243',
      
      'M75.3 187.3c3-3 4.7-7.1 4.7-11.3l0-64c0-17.7 14.3-32 32-32l64 0c4.2 0 8.3-1.7 11.3-4.7L240 22.6c4.2-4.2 10-6.6 16-6.6s11.8 2.4 16 6.6l52.7 52.7c3 3 7.1 4.7 11.3 4.7l64 0c17.7 0 32 14.3 32 32l0 64c0 4.2 1.7 8.3 4.7 11.3L489.4 240c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16l-52.7 52.7c-3 3-4.7 7.1-4.7 11.3l0 64c0 17.7-14.3 32-32 32l-64 0c-4.2 0-8.3 1.7-11.3 4.7L272 489.4c-4.2 4.2-10 6.6-16 6.6s-11.8-2.4-16-6.6l-52.7-52.7c-3-3-7.1-4.7-11.3-4.7l-64 0c-17.7 0-32-14.3-32-32l0-64c0-4.2-1.7-8.3-4.7-11.3L22.6 272c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16l52.7-52.7zM64 112l0 64L11.3 228.7C4.1 235.9 0 245.8 0 256s4.1 20.1 11.3 27.3L64 336l0 64c0 26.5 21.5 48 48 48l64 0 52.7 52.7c7.2 7.2 17.1 11.3 27.3 11.3s20.1-4.1 27.3-11.3L336 448l64 0c26.5 0 48-21.5 48-48l0-64 52.7-52.7c7.2-7.2 11.3-17.1 11.3-27.3s-4.1-20.1-11.3-27.3L448 176l0-64c0-26.5-21.5-48-48-48l-64 0L283.3 11.3C276.1 4.1 266.2 0 256 0s-20.1 4.1-27.3 11.3L176 64l-64 0c-26.5 0-48 21.5-48 48zm104 72l0 6.5c0 4.4 3.6 8 8 8s8-3.6 8-8l0-6.5c0-22.1 17.9-40 40-40l56.2 0c26.4 0 47.8 21.4 47.8 47.8c0 16.1-8.1 31.1-21.5 39.9l-54.9 36.2c-2.2 1.5-3.6 4-3.6 6.7l0 29.5c0 4.4 3.6 8 8 8s8-3.6 8-8l0-25.1L315.3 245c17.9-11.8 28.7-31.8 28.7-53.3c0-35.2-28.6-63.8-63.8-63.8L224 128c-30.9 0-56 25.1-56 56zM272 352a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faSolarSystem = {
    prefix: 'fat',
    iconName: 'solar-system',
    icon: [
      512,
      512,
      [],
      'e02f',
      
      'M362.3 471.3c-26.8 13.3-56.6 21.7-88.3 24.1C141.8 505.2 26.6 406.1 16.7 273.9C12.5 218 27.8 165.2 56.8 122.1c6.9 3.8 14.8 5.9 23.2 5.9c26.5 0 48-21.5 48-48c0-13.3-5.4-25.4-14.2-34.1c-.6-.6-1.2-1.1-1.8-1.7l0 0 0 0C103.5 36.6 92.3 32 80 32C53.5 32 32 53.5 32 80c0 12.3 4.6 23.6 12.3 32.1C12.8 158.3-3.8 215.1 .7 275.1c10.6 141 133.4 246.7 274.4 236.2c34.7-2.6 67.3-12 96.5-26.8c-3.6-4.2-6.7-8.6-9.3-13.2zM236.9 .7c-34.7 2.6-67.3 12-96.5 26.8c3.6 4.1 6.7 8.6 9.3 13.2c26.8-13.3 56.6-21.7 88.3-24.1c132.2-9.9 247.4 89.2 257.3 221.4c4.2 55.9-11.1 108.7-40.2 151.9c-6.9-3.8-14.8-5.9-23.2-5.9c-26.5 0-48 21.5-48 48c0 8.4 2.2 16.3 6 23.2l0 0c2.1 3.9 4.8 7.5 8.1 10.8c.6 .6 1.3 1.2 1.9 1.8l0 0c8.5 7.6 19.7 12.3 32 12.3c26.5 0 48-21.5 48-48c0-12.3-4.6-23.6-12.3-32.1c31.5-46.2 48.1-103 43.6-163.1C500.7 95.9 377.9-9.9 236.9 .7zM112 256c0-79.5 64.5-144 144-144c22.7 0 44.2 5.3 63.3 14.6c-4.6 7.4-7.3 16.1-7.3 25.4c0 26.5 21.5 48 48 48c9.3 0 18-2.7 25.4-7.3c9.4 19.1 14.6 40.6 14.6 63.3c0 79.5-64.5 144-144 144s-144-64.5-144-144zM330.3 114.3C308.1 102.6 282.8 96 256 96C167.6 96 96 167.6 96 256s71.6 160 160 160s160-71.6 160-160c0-26.8-6.6-52.1-18.3-74.3c6.4-8.2 10.3-18.5 10.3-29.7c0-26.5-21.5-48-48-48c-11.2 0-21.5 3.8-29.7 10.3zM208 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM48 80a32 32 0 1 1 64 0A32 32 0 1 1 48 80zm312 40a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm40 312a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faBookTanakh = {
    prefix: 'fat',
    iconName: 'book-tanakh',
    icon: [
      448,
      512,
      ["tanakh"],
      'f827',
      
      'M392 0c30.9 0 56 25.1 56 56V456c0 30.9-25.1 56-56 56H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H32V415.2C13.7 411.5 0 395.4 0 376V40C0 17.9 17.9 0 40 0H392zM48 416v80H392c22.1 0 40-17.9 40-40s-17.9-40-40-40H48zm344-16c15.7 0 29.8 6.4 40 16.8V56c0-22.1-17.9-40-40-40H40C26.7 16 16 26.7 16 40V376c0 13.3 10.7 24 24 24H392zM239.1 136L216 96l-23.1 40h46.2zm18.5 0H313c12.3 0 20 13.3 13.9 24l-27.7 48 27.7 48c6.2 10.7-1.5 24-13.9 24H257.6l-27.7 48c-6.2 10.7-21.6 10.7-27.7 0l-27.7-48H119c-12.3 0-20-13.3-13.9-24l27.7-48-27.7-48c-6.2-10.7 1.5-24 13.9-24h55.4l27.7-48c6.2-10.7 21.6-10.7 27.7 0l27.7 48zm-9.2 16l-64.7 0-32.3 56 32.3 56h64.7l32.3-56-32.3-56zm41.6 40L313 152H266.8l23.1 40zm0 32l-23.1 40H313l-23.1-40zm-50.8 56H192.9L216 320l23.1-40zm-73.9-16l-23.1-40L119 264h46.2zm-23.1-72l23.1-40H119l23.1 40z'
      
    ]
  };

  
    var faTanakh = faBookTanakh;
  

  
  

  var faTableCellsLarge = {
    prefix: 'fat',
    iconName: 'table-cells-large',
    icon: [
      512,
      512,
      ["th-large"],
      'f009',
      
      'M264 48V248H496V96c0-26.5-21.5-48-48-48H264zm-16 0H64C37.5 48 16 69.5 16 96V248H248V48zM16 264V416c0 26.5 21.5 48 48 48H248V264H16zM264 464H448c26.5 0 48-21.5 48-48V264H264V464zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z'
      
    ]
  };

  
    var faThLarge = faTableCellsLarge;
  

  
  

  var faCloudDrizzle = {
    prefix: 'fat',
    iconName: 'cloud-drizzle',
    icon: [
      512,
      512,
      [],
      'f738',
      
      'M398.7 124.8c.8-4.1 1.3-8.4 1.3-12.8c0-35.3-28.7-64-64-64c-19.5 0-36.9 8.7-48.6 22.4c-3.5 4-8.7 6.1-13.9 5.5s-9.9-3.8-12.4-8.5C245 36.8 212.9 16 176 16c-53 0-96 43-96 96c0 6.1 .6 12.1 1.7 17.9c1.5 7.9-3.1 15.6-10.7 18.1C39 158.5 16 188.6 16 224c0 44.2 35.8 80 80 80H416c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.4 0-.9 0-1.3 0c-4.8 .1-9.5-2-12.6-5.8s-4.3-8.7-3.4-13.4zM176 0c37.1 0 70 18.1 90.4 45.9c3.3 4.5 6.2 9.2 8.8 14.1c3.6-4.2 7.6-8 12-11.4C300.7 38.2 317.6 32 336 32c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c4.9 0 9.8 .4 14.5 1.1c46.2 7 81.5 46.8 81.5 94.9c0 53-43 96-96 96H96c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0zM64 368v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V368c0-4.4 3.6-8 8-8s8 3.6 8 8zm192 0v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V368c0-4.4 3.6-8 8-8s8 3.6 8 8zm192 0v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V368c0-4.4 3.6-8 8-8s8 3.6 8 8zM160 448v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V448c0-4.4 3.6-8 8-8s8 3.6 8 8zm192 0v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V448c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faPeoplePantsSimple = {
    prefix: 'fat',
    iconName: 'people-pants-simple',
    icon: [
      512,
      512,
      [],
      'e21a',
      
      'M128 16a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112A64 64 0 1 0 128 0a64 64 0 1 0 0 128zm-22.4 48h44.8c33.3 0 61 25.5 63.8 58.7l4.1 49.3c2.3 28-19.8 52-47.8 52H144 112 85.6c-28.1 0-50.2-24-47.8-52l4.1-49.3c2.8-33.2 30.5-58.7 63.8-58.7zM120 352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V344.8c22.1-11.5 36.4-35.4 34.2-62.1l-4.1-49.3C226.7 191.9 192 160 150.4 160H105.6c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3c-2.2 26.7 12.2 50.6 34.2 62.1V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352zm64 128c0 8.8-7.2 16-16 16s-16-7.2-16-16V352h18.4c4.7 0 9.2-.5 13.6-1.4V480zM104 352V480c0 8.8-7.2 16-16 16s-16-7.2-16-16V350.6c4.4 .9 8.9 1.4 13.6 1.4H104zM384 16a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112A64 64 0 1 0 384 0a64 64 0 1 0 0 128zm-22.4 48h44.8c33.3 0 61 25.5 63.8 58.7l4.1 49.3c2.3 28-19.8 52-47.8 52H400 368 341.6c-28.1 0-50.2-24-47.8-52l4.1-49.3c2.8-33.2 30.5-58.7 63.8-58.7zM376 352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V344.8c22.1-11.5 36.4-35.4 34.2-62.1l-4.1-49.3C482.7 191.9 448 160 406.4 160H361.6c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3c-2.2 26.7 12.2 50.6 34.2 62.1V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352zm64 128c0 8.8-7.2 16-16 16s-16-7.2-16-16V352h18.4c4.7 0 9.2-.5 13.6-1.4V480zM360 352V480c0 8.8-7.2 16-16 16s-16-7.2-16-16V350.6c4.4 .9 8.9 1.4 13.6 1.4H360z'
      
    ]
  };

  

  
  

  var faFlowerTulip = {
    prefix: 'fat',
    iconName: 'flower-tulip',
    icon: [
      512,
      512,
      [127799],
      'f801',
      
      'M262 2.7C260.5 1 258.3 0 256 0s-4.5 1-6 2.7L191 69.1 124.9 17.7c-2.4-1.9-5.7-2.2-8.4-.9s-4.5 4.1-4.5 7.2V136c0 66.3 53.7 120 120 120h16V422.6C220.2 362 159 320 88 320H29.5C13.2 320 0 333.2 0 349.5C0 439.3 72.7 512 162.5 512H248h16 85.5C439.3 512 512 439.3 512 349.5c0-16.3-13.2-29.5-29.5-29.5H424c-71 0-132.2 42-160 102.6V256h16c66.3 0 120-53.7 120-120V24c0-3.1-1.7-5.8-4.5-7.2s-6-1-8.4 .9L321 69.1 262 2.7zM198 85.3L256 20l58 65.3c2.8 3.2 7.6 3.6 10.9 1l59.1-46V136c0 57.4-46.6 104-104 104H232c-57.4 0-104-46.6-104-104V40.4l59.1 46c3.3 2.6 8.1 2.2 10.9-1zM88 336c88.4 0 160 71.6 160 160H162.5C81.6 496 16 430.4 16 349.5c0-7.5 6.1-13.5 13.5-13.5H88zM264 496c0-88.4 71.6-160 160-160h58.5c7.5 0 13.5 6.1 13.5 13.5C496 430.4 430.4 496 349.5 496H264z'
      
    ]
  };

  

  
  

  var faBusinessTime = {
    prefix: 'fat',
    iconName: 'business-time',
    icon: [
      640,
      512,
      ["briefcase-clock"],
      'f64a',
      
      'M144 40V96H368V40c0-13.3-10.7-24-24-24H168c-13.3 0-24 10.7-24 24zM128 96V40c0-22.1 17.9-40 40-40H344c22.1 0 40 17.9 40 40V96h64c35.3 0 64 28.7 64 64v32.7c-5.3-.5-10.6-.7-16-.7V160c0-26.5-21.5-48-48-48H376 136 64c-26.5 0-48 21.5-48 48v96H176h16H352h8.2c-4.2 5.1-8.1 10.4-11.8 16H192v48c0 8.8 7.2 16 16 16H322.9c-1 5.3-1.7 10.6-2.2 16H208c-17.7 0-32-14.3-32-32V272H16V416c0 26.5 21.5 48 48 48H348.5c3.6 5.6 7.6 10.9 11.8 16H64c-35.3 0-64-28.7-64-64V264 160c0-35.3 28.7-64 64-64h64zM496 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 64c4.4 0 8 3.6 8 8v64h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H496c-4.4 0-8-3.6-8-8V296c0-4.4 3.6-8 8-8z'
      
    ]
  };

  
    var faBriefcaseClock = faBusinessTime;
  

  
  

  var faCommentDollar = {
    prefix: 'fat',
    iconName: 'comment-dollar',
    icon: [
      512,
      512,
      [],
      'f651',
      
      'M157.3 415c-5-1.8-10.6-1-14.9 2.1c-11 8-29.4 19.3-51.2 28.8C68.3 456 41.6 464 16 464l.1-.1 0 0 0 0 .3-.3 .1-.1c.4-.4 .9-.9 1.5-1.6c1.3-1.4 3.2-3.6 5.4-6.3l-12.2-10 12.2 10C28 450 34 442 40 432c10.7-17.9 21.4-42.1 23.6-69.9c.3-4.3-1.1-8.6-3.9-11.8C31.9 318.8 16 280.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-35.2 0-68.6-6.1-98.7-17zM4.7 452.7l0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0zM264 144c0-4.4-3.6-8-8-8s-8 3.6-8 8v16.4c-8.4 .7-16.2 2.6-23 5.7c-12.4 5.6-21.9 15.4-24.2 28.8c-1.4 8.2-.6 15.4 2.4 21.8c3 6.3 7.8 11 13.2 14.7c10 6.8 23.7 10.9 35.9 14.6l1.7 .5c13.4 4 25 7.8 32.9 13.5c3.7 2.7 6.3 5.7 7.7 9c1.4 3.3 2.1 7.6 1.1 13.5c-1.4 8.2-6.5 14.1-15.1 17.8c-8.8 3.8-21.1 5-35.4 2.7c-7.1-1.2-19.2-5.3-28.8-8.5l0 0 0 0 0 0c-2.1-.7-4-1.4-5.7-1.9c-4.2-1.4-8.7 .9-10.1 5.1s.9 8.7 5.1 10.1c1.4 .5 3.1 1 5 1.7l0 0 0 0c9.4 3.2 23.4 8 32 9.4l0 0c1.8 .3 3.7 .5 5.5 .7V336c0 4.4 3.6 8 8 8s8-3.6 8-8V319.9c8.3-.5 16-2.1 22.7-5c12.6-5.4 22.1-15.4 24.5-29.7c1.5-8.5 .7-16-2.1-22.6c-2.9-6.6-7.5-11.6-13-15.5c-10.5-7.6-24.9-12-37.6-15.8l-.3-.1 0 0c-13.4-4-25-7.5-32.9-12.9c-3.8-2.6-6.3-5.3-7.7-8.3c-1.4-2.9-2.1-6.8-1.1-12.2c1.2-6.8 6.2-12.9 15.1-17c9-4.1 21.4-5.7 35.4-3.5c4.5 .7 18.5 3.4 22.9 4.6c4.3 1.1 8.7-1.4 9.8-5.7s-1.4-8.7-5.7-9.8c-5.2-1.4-19.8-4.2-24.6-4.9c-1.8-.3-3.7-.5-5.5-.7V144z'
      
    ]
  };

  

  
  

  var faPersonDress = {
    prefix: 'fat',
    iconName: 'person-dress',
    icon: [
      320,
      512,
      ["female"],
      'f182',
      
      'M160 96a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm0-96a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM114.5 200.4c4.2 1.4 6.5 5.9 5.1 10.1L67.1 368H96h48 32 48 28.9L200.4 210.5c-1.4-4.2 .9-8.7 5.1-10.1s8.7 .9 10.1 5.1l56 168c.8 2.4 .4 5.1-1.1 7.2s-3.9 3.3-6.5 3.3H232v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H152v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H56c-2.6 0-5-1.2-6.5-3.3s-1.9-4.8-1.1-7.2l56-168c1.4-4.2 5.9-6.5 10.1-5.1zM104 384v96c0 8.8 7.2 16 16 16s16-7.2 16-16V384H104zm80 96c0 8.8 7.2 16 16 16s16-7.2 16-16V384H184v96zM84.1 189.2L23.2 315.5c-1.9 4-6.7 5.6-10.7 3.7s-5.6-6.7-3.7-10.7L69.7 182.3c16-33.2 49.6-54.3 86.5-54.3h7.7c36.8 0 70.4 21.1 86.5 54.3l60.9 126.2c1.9 4 .3 8.8-3.7 10.7s-8.8 .3-10.7-3.7L235.9 189.2c-13.3-27.7-41.3-45.2-72.1-45.2h-7.7c-30.7 0-58.7 17.6-72.1 45.2z'
      
    ]
  };

  
    var faFemale = faPersonDress;
  

  
  

  var faDreidel = {
    prefix: 'fat',
    iconName: 'dreidel',
    icon: [
      448,
      512,
      [],
      'f792',
      
      'M445.7 45.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L305 163.7l-79-79c-18.7-18.7-49.1-18.7-67.9 0L18.7 224C6.7 236 0 252.3 0 269.3V416c0 35.3 28.7 64 64 64H210.7c17 0 33.3-6.7 45.3-18.7L395.3 321.9c18.7-18.7 18.7-49.1 0-67.9l-79-79L445.7 45.7zM214.6 96L384 265.4c12.5 12.5 12.5 32.8 0 45.3l-55 55L114.3 151l55-55c12.5-12.5 32.8-12.5 45.3 0zM30.1 235.3l73-73L317.7 377l-73 73c-9 9-21.2 14.1-33.9 14.1H64c-26.5 0-48-21.5-48-48V269.3c0-12.7 5.1-24.9 14.1-33.9z'
      
    ]
  };

  

  
  

  var faOtter = {
    prefix: 'fat',
    iconName: 'otter',
    icon: [
      640,
      512,
      [129446],
      'f700',
      
      'M170.8 204.1l22.1-14.7c4.5-3 7.1-8 7.1-13.3v-8c0-13.3-10.7-24-24-24H144c-13.3 0-24 10.7-24 24v8c0 5.3 2.7 10.3 7.1 13.3l22.1 14.7-8.4 6.3C129 219.2 114.7 224 100 224c-37.6 0-68-30.4-68-68V136c0-48.6 39.4-88 88-88h80c48.6 0 88 39.4 88 88v20c0 37.6-30.4 68-68 68c-14.7 0-29-4.8-40.8-13.6l-8.4-6.3zM160 216l9.6 7.2C184.1 234.1 201.8 240 220 240c16.2 0 31.3-4.6 44.1-12.5c1.8 29.3 26.1 52.5 55.9 52.5h77.4c-22.6 15.9-37.4 42.2-37.4 72H256c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40H104c-30.9 0-56-25.1-56-56V222c14.3 11.3 32.4 18 52 18c18.2 0 35.9-5.9 50.4-16.8L160 216zm200-56c-22.6 0-43.3 7.8-59.7 20.8c2.4-7.9 3.7-16.2 3.7-24.8V136c0-2.7-.1-5.4-.3-8H312c4.4 0 8-3.6 8-8s-3.6-8-8-8H301.2c-10.8-45.9-52-80-101.2-80H120C70.8 32 29.6 66.1 18.8 112H8c-4.4 0-8 3.6-8 8s3.6 8 8 8h8.3c-.2 2.6-.3 5.3-.3 8v20c0 18.4 5.9 35.5 16 49.3V216v16 26.9C32 381 131 480 253.1 480H416.9C540.1 480 640 380.1 640 256.9c0-84.4-56.5-158.4-138-180.6l-43.9-12c-3.7-1-7.6 .7-9.3 4.2s-.7 7.6 2.3 9.9l66.3 51c21.8 16.8 34.6 42.7 34.6 70.2c0 20.3-9.4 38.4-24 50.2V208c0-8.8-3.6-17.1-9.7-22.5c-6.3-5.6-15.1-8.2-24.4-5C465.3 190.4 440 216.1 440 248v16H344v-8c0-8.8 7.2-16 16-16h8c22.1 0 40-17.9 40-40s-17.9-40-40-40h-8zm-77.8 77.2c8.5-35.1 40.1-61.2 77.8-61.2h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8c-17.7 0-32 14.3-32 32v8h-8c-17.5 0-32.3-11.2-37.8-26.8zM512 335.1c0 18.1-8.7 35.1-23.4 45.6l-29.2 20.9c-3.6 2.6-4.4 7.6-1.9 11.2s7.6 4.4 11.2 1.9l29.2-20.9c18.9-13.5 30.2-35.3 30.2-58.6v-66c23.9-13.9 40-39.9 40-69.6c0-32.5-15.1-63.1-40.8-82.9L493 90.4l4.8 1.3C572.3 112 624 179.7 624 256.9C624 371.3 531.3 464 416.9 464H253.1C146.4 464 58.7 382.5 48.9 278.4C62.1 294 81.9 304 104 304H224c13.3 0 24 10.7 24 24s-10.7 24-24 24H208 160c-4.4 0-8 3.6-8 8s3.6 8 8 8h48 16H368c4.4 0 8-3.6 8-8v-8c0-39.7 32.1-71.8 71.7-72h.3v0c4.4 0 8-3.6 8-8V248c0-23 18.8-44 43.1-52.4c3.3-1.1 6.2-.4 8.5 1.8c2.5 2.3 4.4 6.1 4.4 10.6v51.2 17 58.8zM112 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm112 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-88 16v-8c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v8l-24 16-24-16z'
      
    ]
  };

  

  
  

  var faUserSecret = {
    prefix: 'fat',
    iconName: 'user-secret',
    icon: [
      448,
      512,
      [128373],
      'f21b',
      
      'M176 16c-5.2 0-11.5 2.7-18.9 11.2c-7.4 8.4-14.5 21-20.9 36.3c-7.4 17.6-13.4 37.6-18.1 56.6C145.5 128.8 181.1 136 224 136c41.2 0 77.3-7.7 105.7-16.9C325 100.4 319 80.8 311.8 63.5c-6.4-15.3-13.5-27.9-20.9-36.3C283.5 18.7 277.2 16 272 16c-11.9 0-16.9 2.8-20.9 5.4c-.5 .3-1.1 .8-1.8 1.2C244.8 25.9 236.2 32 224 32s-20.8-6.1-25.4-9.4l0 0c-.7-.5-1.3-.9-1.8-1.2c-3.9-2.6-8.9-5.4-20.9-5.4zM272 0c36 0 59.3 60.7 72.8 113.8c1.1-.4 2.2-.8 3.3-1.2c15.2-5.9 27.1-11.7 35.2-16.1c4.1-2.2 7.2-4 9.2-5.2c1-.6 1.8-1.1 2.3-1.4l.6-.4 .1-.1 0 0c3.7-2.5 8.6-1.5 11.1 2.2s1.5 8.6-2.2 11.1L400 96c4.4 6.7 4.4 6.7 4.4 6.7l0 0 0 0-.1 0-.2 .1-.7 .4c-.6 .4-1.5 .9-2.6 1.6c-2.3 1.4-5.6 3.3-9.9 5.6c-8.6 4.6-21.2 10.8-37 16.9C322.2 139.7 277.2 152 224 152c-57.2 0-102.2-12.3-133-24.6c-15.4-6.2-27.2-12.3-35.3-17c-4-2.3-7.1-4.3-9.2-5.7c-1-.7-1.9-1.3-2.4-1.7l-.6-.5-.2-.1-.1 0 0 0 0 0s0 0 4.8-6.4l-4.8 6.4c-3.5-2.7-4.3-7.7-1.6-11.2s7.7-4.2 11.2-1.6l0 0 .1 .1 .5 .3c.4 .3 1.1 .8 2 1.4c1.8 1.2 4.6 3 8.4 5.2c7.5 4.3 18.6 10.1 33.2 16c1.9 .8 3.9 1.5 5.9 2.3C116.4 61.5 139.8 0 176 0c18 0 25.9 5.4 32.5 9.9c4.7 3.3 8.8 6.1 15.5 6.1s10.8-2.8 15.5-6.1C246.1 5.4 254 0 272 0zM100 224c-2.6-10.2-4-21-4-32c0-9.5 1-18.7 3-27.6c4.9 1.6 10 3.2 15.4 4.7c-1.5 7.4-2.3 15-2.3 22.9c0 61.9 50.1 112 112 112s112-50.1 112-112c0-8.2-.9-16.2-2.5-23.9c5.3-1.6 10.4-3.2 15.3-4.8c2.1 9.2 3.2 18.8 3.2 28.7c0 11-1.4 21.8-4 32h71.2c7.1 0 12.8 5.7 12.8 12.8c0 2.1-.5 4.1-1.5 6l-45.7 86.8C423.6 364.8 448 415.5 448 472v8c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-8c0-56.5 24.4-107.2 63.2-142.4L17.5 242.8c-1-1.8-1.5-3.9-1.5-6c0-7.1 5.7-12.8 12.8-12.8H100zm242.7 16c-19 46.9-65 80-118.7 80s-99.7-33.1-118.7-80H34.1l43.3 82.2c3.4 6.5 2 14.4-3.4 19.3C38.3 373.7 16 420.2 16 472v8c0 8.8 7.2 16 16 16H167.7L136.3 386.2c-1.2-4.2 1.2-8.7 5.5-9.9s8.7 1.2 9.9 5.5l29.1 101.9 33.8-74.4-36.8-44.1c-2-2.4-2.4-5.7-1.1-8.5s4.1-4.6 7.2-4.6h80c3.1 0 5.9 1.8 7.2 4.6s.9 6.1-1.1 8.5l-36.8 44.1 33.8 74.4 29.1-101.9c1.2-4.2 5.6-6.7 9.9-5.5s6.7 5.6 5.5 9.9L280.3 496H416c8.8 0 16-7.2 16-16v-8c0-51.8-22.3-98.3-57.9-130.5c-5.4-4.9-6.8-12.8-3.4-19.3L413.9 240H342.7zM224 427.3L192.8 496h62.4L224 427.3zM128 172.7c5.2 1.3 10.5 2.4 16 3.5v10.4c0 17.7 14.3 32 32 32h4.5c13.8 0 26-8.8 30.4-21.9l4.3-12.9c2.9 .1 5.9 .1 8.8 .1s5.9 0 8.8-.1l4.3 12.9c4.4 13.1 16.6 21.9 30.4 21.9H272c17.7 0 32-14.3 32-32V175.6c5.5-1.2 10.8-2.4 16-3.7v14.8c0 26.5-21.5 48-48 48h-4.5c-18.8 0-35.7-11-43.5-27.7c-7.8 16.7-24.7 27.7-43.5 27.7H176c-26.5 0-48-21.5-48-48v-14zm96 222.8L246.9 368H201.1L224 395.5z'
      
    ]
  };

  

  
  

  var faRv = {
    prefix: 'fat',
    iconName: 'rv',
    icon: [
      640,
      512,
      [],
      'f7be',
      
      'M248 16c-4.4 0-8 3.6-8 8v8H368V24c0-4.4-3.6-8-8-8H248zM224 32V24c0-13.3 10.7-24 24-24H360c13.3 0 24 10.7 24 24v8H510.4c53.9 0 97.6 43.7 97.6 97.6c0 16.8-13.6 30.4-30.4 30.4H408c-13.3 0-24 10.7-24 24V392c0 4.4-3.6 8-8 8H284.7c2.2 7.6 3.3 15.7 3.3 24c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-10.5 1.8-20.6 5.2-30L22.9 324.8C8.5 314.3 0 297.5 0 279.7V88C0 57.1 25.1 32 56 32H224zM384 48H368 240 224 56C33.9 48 16 65.9 16 88V279.7c0 12.7 6.1 24.7 16.3 32.3l91.8 67.4C139.5 353.4 167.7 336 200 336c34.2 0 63.8 19.5 78.4 48H368V184c0-22.1 17.9-40 40-40H577.6c8 0 14.4-6.4 14.4-14.4C592 84.5 555.5 48 510.4 48H384zM200 496a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm288 0a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm0-160a88 88 0 1 1 0 176 88 88 0 1 1 0-176zM272 128H112c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H272c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16zM112 112H272c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32zm304 88c0-4.4 3.6-8 8-8h93.1c8.8 0 17.4 2.9 24.4 8.3l82.9 63.8c9.8 7.6 15.6 19.3 15.6 31.7V360c0 22.1-17.9 40-40 40h-8c-4.4 0-8-3.6-8-8s3.6-8 8-8h8c13.3 0 24-10.7 24-24V295.8c0-2.7-.4-5.3-1.3-7.8H424c-4.4 0-8-3.6-8-8s3.6-8 8-8H608.5l-76.7-59c-4.2-3.2-9.3-5-14.6-5H424c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faClockElevenThirty = {
    prefix: 'fat',
    iconName: 'clock-eleven-thirty',
    icon: [
      512,
      512,
      [],
      'e348',
      
      'M16 256a240 240 0 1 0 480 0A240 240 0 1 0 16 256zm496 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM248 408V258.4l-62.7-94c-2.5-3.7-1.5-8.6 2.2-11.1s8.6-1.5 11.1 2.2l64 96c.9 1.3 1.3 2.9 1.3 4.4V408c0 4.4-3.6 8-8 8s-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faExpandWide = {
    prefix: 'fat',
    iconName: 'expand-wide',
    icon: [
      512,
      512,
      [],
      'f320',
      
      'M120 64c4.4 0 8 3.6 8 8s-3.6 8-8 8H16V184c0 4.4-3.6 8-8 8s-8-3.6-8-8V72c0-4.4 3.6-8 8-8H120zM0 328c0-4.4 3.6-8 8-8s8 3.6 8 8V432H120c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8V328zM392 64H504c4.4 0 8 3.6 8 8V184c0 4.4-3.6 8-8 8s-8-3.6-8-8V80H392c-4.4 0-8-3.6-8-8s3.6-8 8-8zM512 328V440c0 4.4-3.6 8-8 8H392c-4.4 0-8-3.6-8-8s3.6-8 8-8H496V328c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faBriefcaseArrowRight = {
    prefix: 'fat',
    iconName: 'briefcase-arrow-right',
    icon: [
      512,
      512,
      [],
      'e2f2',
      
      'M168 16H344c13.3 0 24 10.7 24 24V96H144V40c0-13.3 10.7-24 24-24zM128 40V96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H384V40c0-22.1-17.9-40-40-40H168c-22.1 0-40 17.9-40 40zm8 72H376h72c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V160c0-26.5 21.5-48 48-48h72zm157.7 82.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L356.7 280H136c-4.4 0-8 3.6-8 8s3.6 8 8 8H356.7l-74.3 74.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l88-88c3.1-3.1 3.1-8.2 0-11.3l-88-88z'
      
    ]
  };

  

  
  

  var faSuitcaseMedical = {
    prefix: 'fat',
    iconName: 'suitcase-medical',
    icon: [
      512,
      512,
      ["medkit"],
      'f0fa',
      
      'M168 16H344c13.3 0 24 10.7 24 24V96H144V40c0-13.3 10.7-24 24-24zM128 40V96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H384V40c0-22.1-17.9-40-40-40H168c-22.1 0-40 17.9-40 40zm8 72H376h32V464H104V112h32zM88 464H64c-26.5 0-48-21.5-48-48V160c0-26.5 21.5-48 48-48H88V464zM424 112h24c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H424V112zM232 200c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H288c-4.4 0-8 3.6-8 8v56c0 4.4-3.6 8-8 8H240c-4.4 0-8-3.6-8-8V320c0-4.4-3.6-8-8-8H168c-4.4 0-8-3.6-8-8V272c0-4.4 3.6-8 8-8h56c4.4 0 8-3.6 8-8V200zm8-24c-13.3 0-24 10.7-24 24v48H168c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h48v48c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V328h48c13.3 0 24-10.7 24-24V272c0-13.3-10.7-24-24-24H296V200c0-13.3-10.7-24-24-24H240z'
      
    ]
  };

  
    var faMedkit = faSuitcaseMedical;
  

  
  

  var faO = {
    prefix: 'fat',
    iconName: 'o',
    icon: [
      448,
      512,
      [111],
      '4f',
      
      'M224 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zM448 256A224 224 0 1 1 0 256a224 224 0 1 1 448 0z'
      
    ]
  };

  

  
  

  var faBookBible = {
    prefix: 'fat',
    iconName: 'book-bible',
    icon: [
      448,
      512,
      ["bible"],
      'f647',
      
      'M0 56C0 25.1 25.1 0 56 0H408c22.1 0 40 17.9 40 40V376c0 19.4-13.7 35.5-32 39.2V496h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H56c-30.9 0-56-25.1-56-56V56zM56 416c-22.1 0-40 17.9-40 40s17.9 40 40 40H400V416H56zm-40 .8C26.2 406.4 40.3 400 56 400H408c13.3 0 24-10.7 24-24V40c0-13.3-10.7-24-24-24H56C33.9 16 16 33.9 16 56V416.8zM224 80h32c13.3 0 24 10.7 24 24v40h40c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H280v88c0 13.3-10.7 24-24 24H224c-13.3 0-24-10.7-24-24V224H160c-13.3 0-24-10.7-24-24V168c0-13.3 10.7-24 24-24h40V104c0-13.3 10.7-24 24-24zm-8 24v48c0 4.4-3.6 8-8 8H160c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h48c4.4 0 8 3.6 8 8v96c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V216c0-4.4 3.6-8 8-8h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H272c-4.4 0-8-3.6-8-8V104c0-4.4-3.6-8-8-8H224c-4.4 0-8 3.6-8 8z'
      
    ]
  };

  
    var faBible = faBookBible;
  

  
  

  var faMessagesQuestion = {
    prefix: 'fat',
    iconName: 'messages-question',
    icon: [
      640,
      512,
      [],
      'e1e7',
      
      'M193.1 307.2L112 368V320c0-8.8-7.2-16-16-16H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H352c26.5 0 48 21.5 48 48V256c0 26.5-21.5 48-48 48H202.7c-3.5 0-6.8 1.1-9.6 3.2zm9.6 12.8H352c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V256c0 35.3 28.7 64 64 64H80 96v16 32c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 320zM256 384c0 35.3 28.7 64 64 64H437.3l81.1 60.8c4.8 3.6 11.3 4.2 16.8 1.5s8.8-8.2 8.8-14.3V464 448h16 16c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H448v16H576c26.5 0 48 21.5 48 48V384c0 26.5-21.5 48-48 48H544c-8.8 0-16 7.2-16 16v48l-81.1-60.8c-2.8-2.1-6.1-3.2-9.6-3.2H320c-26.5 0-48-21.5-48-48V352H256v32zM143.3 125l0 4.6c0 4.4 3.6 8 8 8s8-3.6 8-8l0-4.6c0-14.4 11.6-26 26-26h39.8c17.4 0 31.5 14.1 31.5 31.5c0 10.6-5.3 20.5-14.2 26.3l-38.9 25.6c-2.2 1.5-3.6 4-3.6 6.7V210c0 4.4 3.6 8 8 8s8-3.6 8-8V193.4l35.3-23.3c13.3-8.8 21.4-23.7 21.4-39.7c0-26.2-21.3-47.5-47.5-47.5H185.3c-23.2 0-42 18.8-42 42zm76 119a11.3 11.3 0 1 0 -22.7 0 11.3 11.3 0 1 0 22.7 0z'
      
    ]
  };

  

  
  

  var faGamepadModern = {
    prefix: 'fat',
    iconName: 'gamepad-modern',
    icon: [
      640,
      512,
      [63676,127918,"gamepad-alt"],
      'e5a2',
      
      'M216 368H424c7.3 0 13.7 5 15.5 12.1l3.6 14.3C453.3 435.3 490 464 532.2 464c50.7 0 91.8-41.1 91.8-91.8v-2.8c0-5.4-.5-10.7-1.4-16L589.9 162.5c-7.8-45.5-36.6-82.3-78.4-92.7C466.8 58.7 402.5 48 320 48s-146.8 10.7-191.5 21.8c-41.9 10.4-70.6 47.3-78.4 92.7L17.4 353.4c-.9 5.3-1.4 10.6-1.4 16v2.8c0 50.7 41.1 91.8 91.8 91.8c42.1 0 78.9-28.7 89.1-69.5l3.6-14.3c1.8-7.1 8.2-12.1 15.5-12.1zm211.6 30.3L424 384H216l-3.6 14.3c-12 48-55.1 81.7-104.6 81.7C48.3 480 0 431.7 0 372.2v-2.8c0-6.3 .5-12.5 1.6-18.7L34.3 159.8c8.6-50.2 40.9-93.2 90.3-105.5C170.5 42.9 236.2 32 320 32s149.5 10.9 195.3 22.3c49.4 12.3 81.7 55.3 90.3 105.5l32.7 190.9c1.1 6.2 1.6 12.4 1.6 18.7v2.8C640 431.7 591.7 480 532.2 480c-49.5 0-92.6-33.7-104.6-81.7zM200 160v56h56c4.4 0 8 3.6 8 8s-3.6 8-8 8H200v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V232H128c-4.4 0-8-3.6-8-8s3.6-8 8-8h56V160c0-4.4 3.6-8 8-8s8 3.6 8 8zM392 272a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm40 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm64-160a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  
    var faGamepadAlt = faGamepadModern;
  

  
  

  var faCurlingStone = {
    prefix: 'fat',
    iconName: 'curling-stone',
    icon: [
      576,
      512,
      [129356,"curling"],
      'f44a',
      
      'M192 104c0-30.9 25.1-56 56-56H408c4.4 0 8-3.6 8-8s-3.6-8-8-8H248c-39.8 0-72 32.2-72 72v56H152c-30.9 0-56 25.1-56 56v9.1C41.7 232.9 0 279.6 0 336v32c0 61.9 50.1 112 112 112H464c61.9 0 112-50.1 112-112V336c0-56.4-41.7-103.1-96-110.9V216c0-30.9-25.1-56-56-56H192V104zM464 224H112l0-8c0-22.1 17.9-40 40-40h32H424c22.1 0 40 17.9 40 40v8zM112 464c-53 0-96-43-96-96v-8H560v8c0 53-43 96-96 96H112zM16 344v-8c0-53 43-96 96-96H464c53 0 96 43 96 96v8H16z'
      
    ]
  };

  
    var faCurling = faCurlingStone;
  

  
  

  var faTankWater = {
    prefix: 'fat',
    iconName: 'tank-water',
    icon: [
      448,
      512,
      [],
      'e452',
      
      'M384 48H279.4l-9.8-16H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H178.4l-9.8 16H64C37.5 48 16 69.5 16 96V336c28.1 0 54.3-14.7 74.1-30.3c11.5-9 22.5-19.2 31.6-30.7c1.5-1.9 3.9-3.1 6.4-3s4.9 1.3 6.4 3.3c8.5 11.1 18.3 21.4 28.8 30.7c17.8 15.8 39.8 30 60.7 30s42.9-14.2 60.7-30c10.5-9.3 20.3-19.6 28.8-30.7c1.5-2 3.9-3.3 6.4-3.3s4.8 1.1 6.4 3c9.1 11.4 20.1 21.6 31.6 30.7c19.8 15.6 46 30.3 74.1 30.3V96c0-26.5-21.5-48-48-48zm48 304c-33.4 0-63.2-17.3-84-33.7c-12.4-9.7-21.9-19.4-27.8-25.8c-5.4 6.4-14.1 15.9-24.9 25.5c-18.2 16.2-44.2 34-71.3 34s-53.1-17.8-71.3-34c-10.8-9.6-19.5-19.2-24.9-25.5c-5.8 6.4-15.4 16.1-27.8 25.8C79.2 334.7 49.4 352 16 352v64c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V352zM152 150.3c0-14.5 4.3-28.8 12.4-40.9l47.2-70.8C214.3 34.5 219 32 224 32s9.7 2.5 12.4 6.7l47.2 70.8c8.1 12.1 12.4 26.3 12.4 40.9V152c0 39.8-32.2 72-72 72s-72-32.2-72-72v-1.7zm25.7-32c-6.3 9.5-9.7 20.6-9.7 32V152c0 30.9 25.1 56 56 56s56-25.1 56-56v-1.7c0-11.4-3.4-22.5-9.7-32L224 48.8l-46.3 69.5z'
      
    ]
  };

  

  
  

  var faImageLandscape = {
    prefix: 'fat',
    iconName: 'image-landscape',
    icon: [
      576,
      512,
      ["landscape"],
      'e1b5',
      
      'M64 80c-26.5 0-48 21.5-48 48V384c0 18.6 10.6 34.7 26 42.7L172.7 267c10-12.2 28.7-11.6 38 1.1l33.4 46 89.1-111.4c9.6-12 27.9-12 37.5 0L544.3 419.5c9.7-8.8 15.7-21.4 15.7-35.5V128c0-26.5-21.5-48-48-48H64zM58.6 431.7c1.8 .2 3.6 .3 5.4 .3h85.8l4-5 80-100-36-49.5c-3.1-4.2-9.3-4.4-12.7-.4L58.6 431.7zm111.7 .3H512c6.6 0 13-1.4 18.7-3.8L358.2 212.6c-3.2-4-9.3-4-12.5 0L250.1 332.2 170.2 432zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm128 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  
    var faLandscape = faImageLandscape;
  

  
  

  var faArrowUpToDottedLine = {
    prefix: 'fat',
    iconName: 'arrow-up-to-dotted-line',
    icon: [
      448,
      512,
      [],
      'e0a1',
      
      'M48 64A16 16 0 1 0 16 64a16 16 0 1 0 32 0zm80 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm96 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm96 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM432 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM365.7 298.3l-136-136c-3.1-3.1-8.2-3.1-11.3 0l-136 136c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L216 187.3V312 472c0 4.4 3.6 8 8 8s8-3.6 8-8V312 187.3L354.3 309.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3z'
      
    ]
  };

  

  
  

  var faSiren = {
    prefix: 'fat',
    iconName: 'siren',
    icon: [
      448,
      512,
      [],
      'e02d',
      
      'M375 152.1L396 320H379.9L359.1 154c-3-24-23.4-42-47.6-42h-175c-24.2 0-44.6 18-47.6 42L68.1 320H52L73 152.1C77 120 104.2 96 136.5 96h175c32.3 0 59.5 24 63.5 56.1zM143.9 168.7L125 320H108.9l19.2-153.3c.5-4.4 4.5-7.5 8.9-6.9s7.5 4.5 6.9 8.9zM48 368c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32H400c17.7 0 32-14.3 32-32V400c0-17.7-14.3-32-32-32H48zM0 400c0-26.5 21.5-48 48-48H400c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V400z'
      
    ]
  };

  

  
  

  var faFilePdf = {
    prefix: 'fat',
    iconName: 'file-pdf',
    icon: [
      512,
      512,
      [],
      'f1c1',
      
      'M64 496l48 0 0 16-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L204.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 145.9c9 9 14.1 21.2 14.1 33.9L384 304l-16 0 0-124.1c0-1.3-.1-2.6-.2-3.9L248 176c-22.1 0-40-17.9-40-40l0-119.8c-1.3-.2-2.6-.2-3.9-.2L64 16C37.5 16 16 37.5 16 64l0 384c0 26.5 21.5 48 48 48zM361.1 160c-.8-1-1.6-1.9-2.4-2.7L226.7 25.4c-.9-.9-1.8-1.7-2.7-2.4L224 136c0 13.3 10.7 24 24 24l113.1 0zM176 368l32 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-24 0 0 40c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-48 0-80c0-4.4 3.6-8 8-8zm32 80c17.7 0 32-14.3 32-32s-14.3-32-32-32l-24 0 0 64 24 0zm96-80l32 0c22.1 0 40 17.9 40 40l0 64c0 22.1-17.9 40-40 40l-32 0c-4.4 0-8-3.6-8-8l0-128c0-4.4 3.6-8 8-8zm8 128l24 0c13.3 0 24-10.7 24-24l0-64c0-13.3-10.7-24-24-24l-24 0 0 112zM424 376c0-4.4 3.6-8 8-8l48 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-40 0 0 48 40 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-40 0 0 56c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-64 0-64z'
      
    ]
  };

  

  
  

  var faBagShoppingMinus = {
    prefix: 'fat',
    iconName: 'bag-shopping-minus',
    icon: [
      448,
      512,
      [],
      'e650',
      
      'M224 16c44.2 0 80 35.8 80 80v32H144V96c0-44.2 35.8-80 80-80zM128 96v32H48c-26.5 0-48 21.5-48 48V416c0 53 43 96 96 96H352c53 0 96-43 96-96V176c0-26.5-21.5-48-48-48H320V96c0-53-43-96-96-96s-96 43-96 96zM48 144h88H312h88c17.7 0 32 14.3 32 32V416c0 44.2-35.8 80-80 80H96c-44.2 0-80-35.8-80-80V176c0-17.7 14.3-32 32-32zm96 168c-4.4 0-8 3.6-8 8s3.6 8 8 8H304c4.4 0 8-3.6 8-8s-3.6-8-8-8H144z'
      
    ]
  };

  

  
  

  var faTableCells = {
    prefix: 'fat',
    iconName: 'table-cells',
    icon: [
      512,
      512,
      ["th"],
      'f00a',
      
      'M352 48V176H496V96c0-26.5-21.5-48-48-48H352zm-16 0H176V176H336V48zM160 48H64C37.5 48 16 69.5 16 96v80H160V48zM16 192V320H160V192H16zm0 144v80c0 26.5 21.5 48 48 48h96V336H16zM176 464H336V336H176V464zm176 0h96c26.5 0 48-21.5 48-48V336H352V464zM496 320V192H352V320H496zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM176 320H336V192H176V320z'
      
    ]
  };

  
    var faTh = faTableCells;
  

  
  

  var faCircleSort = {
    prefix: 'fat',
    iconName: 'circle-sort',
    icon: [
      512,
      512,
      ["sort-circle"],
      'e030',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM267.3 411.3c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9H352c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-96 96zM352 304H160l96 96 96-96zM267.3 100.7l96 96c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9H160c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l96-96c6.2-6.2 16.4-6.2 22.6 0zM256 112l-96 96H352l-96-96z'
      
    ]
  };

  
    var faSortCircle = faCircleSort;
  

  
  

  var faUpRightFromSquare = {
    prefix: 'fat',
    iconName: 'up-right-from-square',
    icon: [
      512,
      512,
      ["external-link-alt"],
      'f35d',
      
      'M345 16H472c13.3 0 24 10.7 24 24V167c0 13.8-11.2 25-25 25c-6.6 0-13-2.6-17.7-7.3L396 127.3 213.7 309.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L384.7 116 327.3 58.6c-4.7-4.7-7.3-11-7.3-17.7c0-13.8 11.2-25 25-25zm-9 25c0 2.4 .9 4.7 2.6 6.3L464.7 173.4c1.7 1.7 4 2.6 6.3 2.6c5 0 9-4 9-9V40c0-4.4-3.6-8-8-8H345c-5 0-9 4-9 9zM0 88C0 57.1 25.1 32 56 32H200c4.4 0 8 3.6 8 8s-3.6 8-8 8H56C33.9 48 16 65.9 16 88V456c0 22.1 17.9 40 40 40H424c22.1 0 40-17.9 40-40V312c0-4.4 3.6-8 8-8s8 3.6 8 8V456c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V88z'
      
    ]
  };

  
    var faExternalLinkAlt = faUpRightFromSquare;
  

  
  

  var faCherries = {
    prefix: 'fat',
    iconName: 'cherries',
    icon: [
      640,
      512,
      [],
      'e0ec',
      
      'M288 8l3.9-7c-2.5-1.4-5.5-1.3-7.9 .1S280 5.2 280 8l11.9-7L280 8V8l0 0 0 .1 0 .3 0 1.2c0 1.1-.1 2.7-.2 4.8c-.2 4.2-.5 10.4-1.3 18.2c-1.5 15.6-4.4 37.5-10.3 62.5c-11.8 50.3-35.4 112.8-82.1 163.4c0 0-.1 .1-.1 .1C172.9 247.8 139.2 224 96 224c0 0-96 0-96 112C0 480 144 512 192 512s192-32 192-176c0-79.9-56.7-103.2-83-109.6c-8.6-2.1-17.5-2.6-26.3-1.6c-22.4 2.5-41.6 10.9-55.8 19.3c35.5-47.8 54.6-101.4 64.9-145.2c6.1-25.9 9.1-48.5 10.7-64.7c.4-4.6 .7-8.7 1-12.2c3.6 2.4 8 5.3 12.9 8.9c14.7 10.6 34.3 26.6 53.8 47.6c37.9 40.7 75.3 100.2 77.7 177.7c-1.5-.6-2.9-1.4-4.1-2.3c-12.8-9.5-34.9-22.9-62.5-27.9c6.8 6.2 13.1 13.5 18.7 21.8c14.3 5.5 26.1 12.9 34.2 18.9c12.8 9.5 30.8 9.5 43.6 0c14.7-10.9 41.6-26.6 74.1-26.6l0 0 .5 0c.5 0 1.3 .1 2.3 .1c2.1 .2 5.3 .5 9.1 1.3c7.8 1.5 18 4.5 28 10.4C603 262.9 624 285.6 624 336c0 74-32.7 112.8-69.9 134.1C515.6 492.1 470.8 496 448 496c-17.3 0-49.6-4.8-81.8-19.1c-3.9 4.2-8 8.2-12.2 12C390.4 506.3 427.7 512 448 512c48 0 192-16 192-176c0-112-96-112-96-112c-37.5 0-67.8 17.9-83.7 29.8c-1.4 1-2.8 1.8-4.4 2.4c-2.4-82.9-42.4-146.1-82-188.7C353.4 45.6 333 29 317.7 17.9c-7.7-5.6-14.1-9.8-18.6-12.6c-2.3-1.4-4-2.5-5.3-3.2c-.6-.4-1.1-.6-1.4-.8l-.4-.2-.1-.1 0 0 0 0s0 0-3.9 7zM180.7 275.3l0 0 0 0 0 0c3 3 7.1 4.7 11.3 4.7s8.3-1.7 11.3-4.7l0 0 0 0 .2-.2c.2-.2 .5-.5 .9-.8c.8-.8 2.1-1.9 3.9-3.4c3.5-2.9 8.7-6.9 15.3-11c13.3-8.3 31.7-16.9 53-19.3c7-.8 14.1-.4 20.7 1.3c11.7 2.9 29.4 9.4 44.1 23.3C355.5 278.7 368 300.3 368 336c0 65.5-32.2 104.8-70.4 128.4c-39 24.2-84 31.6-105.6 31.6s-66.5-7.4-105.6-31.6C48.2 440.8 16 401.5 16 336c0-50.4 21-73.1 40.1-84.2c10-5.9 20.2-8.9 28-10.4c3.9-.7 7-1.1 9.1-1.3c1.1-.1 1.9-.1 2.3-.1l.5 0 0 0c24.2 0 45.3 8.7 60.8 17.8c7.7 4.5 13.8 9 17.9 12.4c2.1 1.7 3.6 3 4.6 3.9c.5 .5 .9 .8 1.1 1l.2 .2z'
      
    ]
  };

  

  
  

  var faFileVideo = {
    prefix: 'fat',
    iconName: 'file-video',
    icon: [
      384,
      512,
      [],
      'f1c8',
      
      'M64 496c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM224 272c8.8 0 16 7.2 16 16v24 48 24c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V288c0-8.8 7.2-16 16-16H224zm32 112V373.8l42.6 24.3c2.2 1.2 4.6 1.9 7.1 1.9c7.9 0 14.3-6.4 14.3-14.3V286.3c0-7.9-6.4-14.3-14.3-14.3c-2.5 0-4.9 .7-7.1 1.9L256 298.2V288c0-17.7-14.3-32-32-32H112c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32zm48-1.2l-48-27.4V316.6l48-27.4v93.6z'
      
    ]
  };

  

  
  

  var faUsersViewfinder = {
    prefix: 'fat',
    iconName: 'users-viewfinder',
    icon: [
      640,
      512,
      [],
      'e595',
      
      'M0 16V120c0 4.4 3.6 8 8 8s8-3.6 8-8V16l104 0c4.4 0 8-3.6 8-8s-3.6-8-8-8H16C7.2 0 0 7.2 0 16zm640 0c0-8.8-7.2-16-16-16H520c-4.4 0-8 3.6-8 8s3.6 8 8 8l104 0V120c0 4.4 3.6 8 8 8s8-3.6 8-8V16zM16 512H120c4.4 0 8-3.6 8-8s-3.6-8-8-8H16V392c0-4.4-3.6-8-8-8s-8 3.6-8 8V496c0 8.8 7.2 16 16 16zm624-16V392c0-4.4-3.6-8-8-8s-8 3.6-8 8V496H520c-4.4 0-8 3.6-8 8s3.6 8 8 8H624c8.8 0 16-7.2 16-16zM272 192a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM224 360c0-30.9 25.1-56 56-56h80c30.9 0 56 25.1 56 56c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8zm96-104a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-40 32c-39.8 0-72 32.2-72 72c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-39.8-32.2-72-72-72H280zM112 312c0-22.1 17.9-40 40-40h64c4.4 0 8-3.6 8-8s-3.6-8-8-8H152c-30.9 0-56 25.1-56 56c0 17.7 14.3 32 32 32h32c4.4 0 8-3.6 8-8s-3.6-8-8-8H128c-8.8 0-16-7.2-16-16zm64-168a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm352 88c0 8.8-7.2 16-16 16H480c-4.4 0-8 3.6-8 8s3.6 8 8 8h32c17.7 0 32-14.3 32-32c0-30.9-25.1-56-56-56H424c-4.4 0-8 3.6-8 8s3.6 8 8 8h64c22.1 0 40 17.9 40 40zM464 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faGalaxy = {
    prefix: 'fat',
    iconName: 'galaxy',
    icon: [
      512,
      512,
      [],
      'e008',
      
      'M128 184c0-92.8 75.2-168 168-168h37.4c1.4 0 2.6 1.2 2.6 2.6c0 .8-.4 1.6-1.1 2.1l-8.2 6c-35.4 25.7-60.5 62.5-71.8 103.8c-.8 2.9 .1 6.1 2.4 8.1s5.5 2.6 8.3 1.5c19.3-7.7 40.4-12 62.4-12c92.8 0 168 75.2 168 168v37.4c0 1.4-1.2 2.6-2.6 2.6c-.8 0-1.6-.4-2.1-1.1l-6-8.2c-25.8-35.4-62.5-60.5-103.8-71.8c-2.9-.8-6.1 .1-8.1 2.4s-2.6 5.5-1.5 8.3c7.7 19.3 12 40.4 12 62.4c0 92.8-75.2 168-168 168H178.6c-1.4 0-2.6-1.2-2.6-2.6c0-.8 .4-1.6 1.1-2.1l8.2-6c35.4-25.8 60.5-62.5 71.8-103.8c.8-2.9-.1-6.1-2.4-8.1s-5.5-2.6-8.3-1.5c-19.3 7.7-40.4 12-62.4 12C91.2 384 16 308.8 16 216V178.6c0-1.4 1.2-2.6 2.6-2.6c.8 0 1.6 .4 2.1 1.1l6 8.2c25.7 35.4 62.5 60.5 103.8 71.8c2.9 .8 6.1-.1 8.1-2.4s2.6-5.5 1.5-8.3c-7.7-19.3-12-40.4-12-62.4zM296 0C194.4 0 112 82.4 112 184c0 18.4 2.7 36.1 7.7 52.8C88 224.9 60 204 39.6 175.9l-6-8.2c-3.5-4.8-9.1-7.7-15-7.7C8.3 160 0 168.3 0 178.6V216C0 317.6 82.4 400 184 400c18.4 0 36.1-2.7 52.8-7.7c-11.9 31.7-32.9 59.7-61 80.1l-8.2 6c-4.8 3.5-7.7 9.1-7.7 15c0 10.3 8.3 18.6 18.6 18.6H216c101.6 0 184-82.4 184-184c0-18.4-2.7-36.1-7.7-52.8c31.7 11.9 59.7 32.9 80.1 61l6 8.2c3.5 4.8 9.1 7.7 15 7.7c10.3 0 18.6-8.3 18.6-18.6V296c0-101.6-82.4-184-184-184c-18.4 0-36.1 2.7-52.8 7.7C287.1 88 308 60 336.1 39.6l8.2-6c4.8-3.5 7.7-9.1 7.7-15C352 8.3 343.7 0 333.4 0H296zM256 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-32-48a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faJ = {
    prefix: 'fat',
    iconName: 'j',
    icon: [
      320,
      512,
      [106],
      '4a',
      
      'M312 32c4.4 0 8 3.6 8 8V320c0 88.4-71.6 160-160 160S0 408.4 0 320V264c0-4.4 3.6-8 8-8s8 3.6 8 8v56c0 79.5 64.5 144 144 144s144-64.5 144-144V40c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faHighDefinition = {
    prefix: 'fat',
    iconName: 'high-definition',
    icon: [
      576,
      512,
      ["rectangle-hd"],
      'e1ae',
      
      'M512 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM320 168V344c0 4.4 3.6 8 8 8h56c53 0 96-43 96-96s-43-96-96-96H328c-4.4 0-8 3.6-8 8zm64 8c44.2 0 80 35.8 80 80s-35.8 80-80 80H336V176h48zm-256-8c0-4.4-3.6-8-8-8s-8 3.6-8 8v88 88c0 4.4 3.6 8 8 8s8-3.6 8-8V264H256v80c0 4.4 3.6 8 8 8s8-3.6 8-8V256 168c0-4.4-3.6-8-8-8s-8 3.6-8 8v80H128V168z'
      
    ]
  };

  
    var faRectangleHd = faHighDefinition;
  

  
  

  var faRestroom = {
    prefix: 'fat',
    iconName: 'restroom',
    icon: [
      640,
      512,
      [],
      'f7bd',
      
      'M144 96a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm0-96a56 56 0 1 1 0 112A56 56 0 1 1 144 0zM126.8 144c-22.3 0-42.4 13.2-51.3 33.6L15.3 315.2c-1.8 4-6.5 5.9-10.5 4.1s-5.9-6.5-4.1-10.5L60.8 171.2c11.5-26.2 37.4-43.2 66-43.2h34.4c28.6 0 54.5 16.9 66 43.2l60.2 137.6c1.8 4-.1 8.8-4.1 10.5s-8.8-.1-10.5-4.1L212.5 177.6c-8.9-20.4-29.1-33.6-51.3-33.6H126.8zM88 248V480c0 8.8 7.2 16 16 16s16-7.2 16-16V360c0-13.3 10.7-24 24-24s24 10.7 24 24V480c0 8.8 7.2 16 16 16s16-7.2 16-16V248c0-4.4 3.6-8 8-8s8 3.6 8 8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V360c0-4.4-3.6-8-8-8s-8 3.6-8 8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V248c0-4.4 3.6-8 8-8s8 3.6 8 8zM496 96a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm0-96a56 56 0 1 1 0 112A56 56 0 1 1 496 0zM450.5 200.4c4.2 1.4 6.5 5.9 5.1 10.1L403.1 368H432h48 32 48 28.9L536.4 210.5c-1.4-4.2 .9-8.7 5.1-10.1s8.7 .9 10.1 5.1l56 168c.8 2.4 .4 5.1-1.1 7.2s-3.9 3.3-6.5 3.3H568v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H488v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H392c-2.6 0-5-1.2-6.5-3.3s-1.9-4.8-1.1-7.2l56-168c1.4-4.2 5.9-6.5 10.1-5.1zM440 384v96c0 8.8 7.2 16 16 16s16-7.2 16-16V384H440zm80 96c0 8.8 7.2 16 16 16s16-7.2 16-16V384H520v96zM421.2 192L367.3 315.2c-1.8 4-6.5 5.9-10.5 4.1s-5.9-6.5-4.1-10.5l53.9-123.2c15.3-35 49.8-57.6 88-57.6h3c38.2 0 72.7 22.6 88 57.6l53.9 123.2c1.8 4-.1 8.8-4.1 10.5s-8.8-.1-10.5-4.1L570.8 192c-12.7-29.1-41.5-48-73.3-48h-3c-31.8 0-60.6 18.8-73.3 48zM328 8V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V8c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faDiceD6 = {
    prefix: 'fat',
    iconName: 'dice-d6',
    icon: [
      448,
      512,
      [],
      'f6d1',
      
      'M224 0c5.2 0 10.4 1.4 14.9 4.1L436.2 121c7.3 4.3 11.8 12.2 11.8 20.6V370.3c0 8.5-4.5 16.3-11.8 20.6L237.7 508.6c-3.7 2.2-7.9 3.4-12.2 3.4h-2.8c-4.3 0-8.5-1.2-12.2-3.4L11.8 391C4.5 386.6 0 378.8 0 370.3V141.7c0-8.5 4.5-16.3 11.8-20.6L209.1 4.1C213.6 1.4 218.8 0 224 0zM27.4 130.4L223.9 246.7l193.9-118L230.7 17.8c-2-1.2-4.4-1.8-6.7-1.8s-4.7 .6-6.7 1.8L27.4 130.4zM16 142.2V370.3c0 2.8 1.5 5.4 3.9 6.9L216 493.4V260.6L16 142.2zM222.5 496c0 0 0 0 .1 0h2.8c0 0 0 0 .1 0h-3zm9.5-2.6L428.1 377.2c2.4-1.4 3.9-4.1 3.9-6.9V141.7c0-.9-.2-1.8-.4-2.6L232 260.5V493.4z'
      
    ]
  };

  

  
  

  var faAlignLeft = {
    prefix: 'fat',
    iconName: 'align-left',
    icon: [
      448,
      512,
      [],
      'f036',
      
      'M8 56c-4.4 0-8 3.6-8 8s3.6 8 8 8H280c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zM8 184c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zM0 320c0 4.4 3.6 8 8 8H280c4.4 0 8-3.6 8-8s-3.6-8-8-8H8c-4.4 0-8 3.6-8 8zM8 440c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H8z'
      
    ]
  };

  

  
  

  var faTemperatureSun = {
    prefix: 'fat',
    iconName: 'temperature-sun',
    icon: [
      640,
      512,
      ["temperature-hot"],
      'f76a',
      
      'M348.8 103.3l-30.9-5.1L303.8 13.4c-.9-5.4-4.5-10-9.6-12.1s-10.9-1.5-15.4 1.6L208 52.5 137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1 13.4 112.2c-5.4 .9-10 4.5-12.1 9.6s-1.5 10.9 1.6 15.4L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6L208 363.5l70.8 49.6c4.5 3.2 10.3 3.8 15.4 1.6l.1 0c-2.1-7.7-3.7-15.6-4.8-23.7l-1.5 9-14.5-10.2-56.3-39.4c-5.5-3.9-12.8-3.9-18.4 0l-56.3 39.4L128 400l-2.9-17.5-11.2-67.2c-1.1-6.7-6.4-12-13.2-13.2L33.5 290.9 16 288l10.2-14.5 39.4-56.3c3.9-5.5 3.9-12.8 0-18.4L26.2 142.5 16 128l17.5-2.9 67.2-11.2c6.7-1.1 12-6.4 13.2-13.2l11.2-67.2L128 16l14.5 10.2 56.3 39.4c5.5 3.9 12.8 3.9 18.4 0l56.3-39.4L288 16l2.9 17.5 11.2 67.2c1.1 6.7 6.4 12 13.2 13.2l33.5 5.6V103.3zm42.1 202.5c7-8.2 15.4-15.3 24.8-20.7c-.1-.4-.2-.9-.3-1.3c-2.3 2.3-4.8 4.5-7.4 6.3l-9.3-13 9.3 13c-6.3 4.5-12.1 9.8-17.1 15.7l0 0zM304 208a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm-96-80a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM400 80c0-35.3 28.7-64 64-64s64 28.7 64 64V243.8c0 8.4 4.4 15.7 10.7 20.3C571 287.3 592 325.2 592 368c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-42.8 21-80.7 53.3-104c6.3-4.6 10.7-11.9 10.7-20.3V80zM464 0c-44.2 0-80 35.8-80 80V243.8c0 2.7-1.4 5.4-4 7.3c-36.3 26.1-60 68.8-60 117c0 79.5 64.5 144 144 144s144-64.5 144-144c0-48.2-23.7-90.8-60-117c-2.6-1.9-4-4.6-4-7.3V80c0-44.2-35.8-80-80-80zM416 368a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0c0-32.6-24.4-59.6-56-63.5V72c0-4.4-3.6-8-8-8s-8 3.6-8 8V304.5c-31.6 3.9-56 30.9-56 63.5c0 35.3 28.7 64 64 64s64-28.7 64-64z'
      
    ]
  };

  
    var faTemperatureHot = faTemperatureSun;
  

  
  

  var faCupStrawSwoosh = {
    prefix: 'fat',
    iconName: 'cup-straw-swoosh',
    icon: [
      384,
      512,
      [],
      'e364',
      
      'M210.2 30.3C214.6 12.5 230.6 0 249 0h31c4.4 0 8 3.6 8 8s-3.6 8-8 8H249c-11 0-20.6 7.5-23.3 18.2L202.2 128H376c4.4 0 8 3.6 8 8s-3.6 8-8 8H192.2h-.3H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H185.8l24.4-97.7zM60.3 468L36 176H52.1L68.7 375.8c40.3-2.1 66.6-10.2 85.5-20.8c19.7-11 32.2-25.2 44.6-40.2l2.9-3.5c11.4-13.9 23.4-28.5 41.3-40.1c19.3-12.5 44.8-21.2 82.9-23.1l6-72.1H348L323.7 468c-2.1 24.9-22.9 44-47.8 44H108.2c-25 0-45.8-19.1-47.8-44zM324.6 264.2c-34.7 2-56.8 10-72.9 20.4c-15.7 10.2-26.2 23-37.9 37.1l-2.7 3.3c-12.6 15.3-26.6 31.4-49.1 44c-21.5 12-50.2 20.5-92 22.7l6.2 74.9c1.4 16.6 15.2 29.3 31.9 29.3H275.8c16.6 0 30.5-12.8 31.9-29.3l16.9-202.5z'
      
    ]
  };

  

  
  

  var faArrowLeftFromBracket = {
    prefix: 'fat',
    iconName: 'arrow-left-from-bracket',
    icon: [
      512,
      512,
      [],
      'e668',
      
      'M2.3 261.7c-3.1-3.1-3.1-8.2 0-11.3l136-136c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L27.3 248 344 248c4.4 0 8 3.6 8 8s-3.6 8-8 8L27.3 264 149.7 386.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-136-136zM328 48c-4.4 0-8-3.6-8-8s3.6-8 8-8l96 0c48.6 0 88 39.4 88 88l0 272c0 48.6-39.4 88-88 88l-96 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l96 0c39.8 0 72-32.2 72-72l0-272c0-39.8-32.2-72-72-72l-96 0z'
      
    ]
  };

  

  
  

  var faRuler = {
    prefix: 'fat',
    iconName: 'ruler',
    icon: [
      512,
      512,
      [128207],
      'f545',
      
      'M40.6 401.9c-18.7-18.7-18.7-49.1 0-67.9L85.7 289l52.7 52.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L97 277.7 149.7 225l52.7 52.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L161 213.7 213.7 161l52.7 52.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L225 149.7 277.7 97l52.7 52.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L289 85.7l45.1-45.1c18.7-18.7 49.1-18.7 67.9 0l69.5 69.5c18.7 18.7 18.7 49.1 0 67.9L177.9 471.4c-18.7 18.7-49.1 18.7-67.9 0L40.6 401.9zm58.2 80.8c25 25 65.5 25 90.5 0L482.7 189.3c25-25 25-65.5 0-90.5L413.3 29.3c-25-25-65.5-25-90.5 0L29.3 322.7c-25 25-25 65.5 0 90.5l69.5 69.5z'
      
    ]
  };

  

  
  

  var faPersonCircleXmark = {
    prefix: 'fat',
    iconName: 'person-circle-xmark',
    icon: [
      576,
      512,
      [],
      'e543',
      
      'M160 96a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm0-96a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM141.1 144c-21.5 0-41.1 12.3-50.4 31.7L23.2 315.5c-1.9 4-6.7 5.6-10.7 3.7s-5.6-6.7-3.7-10.7L76.3 168.7c12-24.9 37.2-40.7 64.8-40.7h37.8c27.6 0 52.8 15.8 64.8 40.7l46.1 95.5c-3.7 5-7.1 10.2-10.2 15.6L229.3 175.7C220 156.3 200.4 144 178.9 144H141.1zM104 248V480c0 8.8 7.2 16 16 16s16-7.2 16-16V360c0-13.3 10.7-24 24-24s24 10.7 24 24V480c0 8.8 7.2 16 16 16s16-7.2 16-16V248c0-4.4 3.6-8 8-8s8 3.6 8 8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V360c0-4.4-3.6-8-8-8s-8 3.6-8 8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V248c0-4.4 3.6-8 8-8s8 3.6 8 8zM560 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm205.7-50.3L443.3 368l50.3 50.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L432 379.3l-50.3 50.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L420.7 368l-50.3-50.3c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L432 356.7l50.3-50.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3z'
      
    ]
  };

  

  
  

  var faArrowLeft = {
    prefix: 'fat',
    iconName: 'arrow-left',
    icon: [
      448,
      512,
      [8592],
      'f060',
      
      'M2.5 250.2C.9 251.7 0 253.8 0 256s.9 4.3 2.5 5.8l192 184c3.2 3.1 8.3 3 11.3-.2s2.9-8.3-.2-11.3L27.9 264 440 264c4.4 0 8-3.6 8-8s-3.6-8-8-8L27.9 248 205.5 77.8c3.2-3.1 3.3-8.1 .2-11.3s-8.1-3.3-11.3-.2l-192 184z'
      
    ]
  };

  

  
  

  var faLeafMaple = {
    prefix: 'fat',
    iconName: 'leaf-maple',
    icon: [
      512,
      512,
      [127809],
      'f6f6',
      
      'M353.2 24C344 9.5 323.1 9 313.3 23l-64.9 92.4-.8-40.9c-.3-15.5-15-26.6-30-22.8l-35.8 9.2-32-37.3c-9.1-10.6-25.2-11.2-35.1-1.4L75 61.4 40.4 57.1C23.6 55 9.9 70.6 14.2 87L52.1 232.3c.8 3-.2 6.1-2.6 8.1L29 257.7c-13 11-10.7 31.7 4.3 39.6l111.5 58.5L2.3 498.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l145-145 64 122c7.9 15.1 28.6 17.4 39.6 4.3l17.3-20.5c2-2.4 5.1-3.4 8.1-2.6L433 505.8c16.4 4.3 32-9.4 29.9-26.2l-2.9-23c-.9-7.3 1.6-14.6 6.8-19.9l31.1-31.4c9.8-9.9 9.1-26-1.4-35.1l-37.3-32 9.2-35.8c3.8-15-7.3-29.7-22.8-30l-40.9-.8 88.8-62.4c15.3-10.7 13-34.1-4.1-41.6l-17.5-7.7c-11.4-5-17-17.8-13.1-29.6l20.2-60c6.2-18.3-10.8-36-29.3-30.7l-56 16c-10.2 2.9-21.2-1.2-26.9-10.2L353.2 24zM170.5 352.8L317.7 205.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L156.7 344 40.8 283.2c-5-2.6-5.8-9.5-1.4-13.2l20.5-17.3c7.1-6 10.1-15.4 7.7-24.4L29.7 83c-1.4-5.5 3.1-10.7 8.7-10l38.4 4.8c2.4 .3 4.9-.5 6.6-2.3l42.4-42c3.3-3.3 8.7-3 11.7 .5l35.2 41.1c2 2.3 5.1 3.3 8.1 2.5l40.7-10.4c5-1.3 9.9 2.4 10 7.6l1.2 65.4c.1 3.5 2.3 6.5 5.7 7.5s6.9-.2 8.9-3l79-112.4c3.3-4.7 10.2-4.5 13.3 .3l13.6 21.4C362.7 68.9 381 75.9 398 71l56-16c6.2-1.8 11.8 4.1 9.8 10.2l-20.2 60c-6.6 19.6 2.8 41 21.8 49.4l17.5 7.7c5.7 2.5 6.5 10.3 1.4 13.9L375.4 272.7c-2.8 2-4.1 5.6-3 8.9s4 5.6 7.5 5.7l65.4 1.2c5.2 .1 8.9 5 7.6 10l-10.4 40.7c-.8 3 .2 6.1 2.5 8.1L486 382.4c3.5 3 3.7 8.4 .5 11.7l-31.1 31.4c-8.6 8.7-12.8 20.9-11.3 33.1l2.9 23c.7 5.6-4.5 10.2-10 8.7L291.8 452.4c-8.9-2.3-18.4 .7-24.4 7.7L250 480.7c-3.7 4.3-10.6 3.6-13.2-1.4L170.6 352.8c0 0 0 0 0 0z'
      
    ]
  };

  

  
  

  var faRepublican = {
    prefix: 'fat',
    iconName: 'republican',
    icon: [
      640,
      512,
      [],
      'f75e',
      
      'M0 168C0 92.9 60.9 32 136 32H376c75.1 0 136 60.9 136 136V280v64 8 24c0 13.3 10.7 24 24 24s24-10.7 24-24V312c0-22.1 17.9-40 40-40s40 17.9 40 40v64c0 57.4-46.6 104-104 104c-37.1 0-69.6-19.4-88-48.6V440c0 22.1-17.9 40-40 40H328c-22.1 0-40-17.9-40-40V368H160v72c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V280 168zM496 288H16V440c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V360c0-4.4 3.6-8 8-8H296c4.4 0 8 3.6 8 8v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V376v-8c0-4.4 3.6-8 8-8s8 3.6 8 8v8c0 48.6 39.4 88 88 88s88-39.4 88-88V312c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 22.1-17.9 40-40 40s-40-17.9-40-40V352v-8V288zm0-16V168c0-66.3-53.7-120-120-120H136C69.7 48 16 101.7 16 168V272H496zM136 128v24h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H136v24c0 4.4-3.6 8-8 8s-8-3.6-8-8V168H96c-4.4 0-8-3.6-8-8s3.6-8 8-8h24V128c0-4.4 3.6-8 8-8s8 3.6 8 8zm120-8c4.4 0 8 3.6 8 8v24h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H264v24c0 4.4-3.6 8-8 8s-8-3.6-8-8V168H224c-4.4 0-8-3.6-8-8s3.6-8 8-8h24V128c0-4.4 3.6-8 8-8zm136 8v24h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H392v24c0 4.4-3.6 8-8 8s-8-3.6-8-8V168H352c-4.4 0-8-3.6-8-8s3.6-8 8-8h24V128c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faHandsClapping = {
    prefix: 'fat',
    iconName: 'hands-clapping',
    icon: [
      512,
      512,
      [],
      'e1a8',
      
      'M328 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V80c0 4.4 3.6 8 8 8s8-3.6 8-8V8zM219.4 25.5c-3.6 2.6-4.4 7.6-1.9 11.2l40 56c2.6 3.6 7.6 4.4 11.2 1.9s4.4-7.6 1.9-11.2l-40-56c-2.6-3.6-7.6-4.4-11.2-1.9zm201.3 0c-3.6-2.6-8.6-1.7-11.2 1.9l-40 56c-2.6 3.6-1.7 8.6 1.9 11.2s8.6 1.7 11.2-1.9l40-56c2.6-3.6 1.7-8.6-1.9-11.2zM153.9 144c6.9 0 13.5 2.7 18.3 7.6L306.3 285.7c1.4 1.4 3.4 2.3 5.7 2.3c4.4 0 8-3.6 8-8V200c0-13.3 10.7-24 24-24s24 10.7 24 24V345.6C368 428.7 300.7 496 217.6 496c-39.9 0-78.1-15.8-106.3-44L69.7 410.3l0 0-16-16L31.6 372.3c-4.9-4.9-7.6-11.5-7.6-18.3C24 339.6 35.6 328 49.9 328c6.9 0 13.5 2.7 18.3 7.6l0 0 38.1 38.1c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L79.6 324.3l-48-48c-4.9-4.9-7.6-11.5-7.6-18.3C24 243.6 35.6 232 49.9 232c6.9 0 13.5 2.7 18.3 7.6l0 0 86.1 86.1c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L79.6 228.3l-24-24c-4.9-4.9-7.6-11.5-7.6-18.3C48 171.6 59.6 160 73.9 160c6.9 0 13.5 2.7 18.3 7.6l32 32 78.1 78.1c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-78.1-78.1c-4.9-4.9-7.6-11.5-7.6-18.3c0-14.3 11.6-25.9 25.9-25.9zM45 216.3c-20.8 2.5-37 20.2-37 41.7c0 11.1 4.4 21.8 12.3 29.7L45 312.3c-20.8 2.5-37 20.2-37 41.7c0 11.1 4.4 21.8 12.3 29.7l22.1 22.1 16 16 0 0L100 463.3c31.2 31.2 73.5 48.7 117.7 48.7C309.5 512 384 437.5 384 345.6V200c0-22.1-17.9-40-40-40s-40 17.9-40 40v60.7L183.6 140.3c-7.9-7.9-18.5-12.3-29.7-12.3c-21.5 0-39.2 16.2-41.7 37l-8.7-8.7C95.7 148.4 85.1 144 73.9 144C50.8 144 32 162.8 32 185.9c0 11.1 4.4 21.8 12.3 29.7l.7 .7zM432 280c0 4.4 3.6 8 8 8s8-3.6 8-8V200c0-13.3 10.7-24 24-24s24 10.7 24 24V345.6c0 73.8-53.1 135.2-123.2 147.9c-6.2 6.5-12.8 12.6-19.8 18.3C441.5 508 512 435 512 345.6V200c0-22.1-17.9-40-40-40s-40 17.9-40 40v80z'
      
    ]
  };

  

  
  

  var faSnowflakes = {
    prefix: 'fat',
    iconName: 'snowflakes',
    icon: [
      640,
      512,
      [],
      'f7cf',
      
      'M232 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V108.7L165.6 58.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L216 131.3V242.1l-96-55.4L97.4 102.5c-1.1-4.3-5.5-6.8-9.8-5.7s-6.8 5.5-5.7 9.8l18.4 68.8L13.2 125.1c-3.8-2.2-8.7-.9-10.9 2.9s-.9 8.7 2.9 10.9l87.2 50.3L23.6 207.7c-4.3 1.1-6.8 5.5-5.7 9.8s5.5 6.8 9.8 5.7L112 200.6 208 256l-96 55.4L27.8 288.8c-4.3-1.1-8.7 1.4-9.8 5.7s1.4 8.7 5.7 9.8l68.8 18.4L5.2 373.1c-3.8 2.2-5.1 7.1-2.9 10.9s7.1 5.1 10.9 2.9l87.2-50.3L82 405.4c-1.1 4.3 1.4 8.7 5.7 9.8s8.7-1.4 9.8-5.7L120 325.3l96-55.4V380.7l-61.7 61.7c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L216 403.3V504c0 4.4 3.6 8 8 8s8-3.6 8-8V403.3l50.3 50.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L232 380.7V269.9l96 55.4 22.6 84.2c1.1 4.3 5.5 6.8 9.8 5.7s6.8-5.5 5.7-9.8l-18.4-68.8 87.2 50.3c3.8 2.2 8.7 .9 10.9-2.9s.9-8.7-2.9-10.9l-87.2-50.3 68.8-18.4c4.3-1.1 6.8-5.5 5.7-9.8s-5.5-6.8-9.8-5.7L336 311.4 240 256l96-55.4 84.2 22.6c4.3 1.1 8.7-1.4 9.8-5.7s-1.4-8.7-5.7-9.8l-68.8-18.4 87.2-50.3c3.8-2.2 5.1-7.1 2.9-10.9s-7.1-5.1-10.9-2.9l-87.2 50.3L366 106.6c1.1-4.3-1.4-8.7-5.7-9.8s-8.7 1.4-9.8 5.7L328 186.7l-96 55.4V131.3l61.7-61.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L232 108.7V8zm258.4 2.3c-3.1 3.1-3.1 8.2 0 11.3L532.7 64l-42.3 42.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L544 75.3l42.3 42.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L555.3 64l42.3-42.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L544 52.7 501.7 10.3c-3.1-3.1-8.2-3.1-11.3 0zm32 192c-3.1 3.1-3.1 8.2 0 11.3L564.7 256l-42.3 42.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L576 267.3l42.3 42.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L587.3 256l42.3-42.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L576 244.7l-42.3-42.3c-3.1-3.1-8.2-3.1-11.3 0z'
      
    ]
  };

  

  
  

  var faCircleAmpersand = {
    prefix: 'fat',
    iconName: 'circle-ampersand',
    icon: [
      512,
      512,
      [],
      'e0f8',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 181.3c0-20.6 16.7-37.3 37.3-37.3H248c17.7 0 32 14.3 32 32v3.3c0 10.4-5.1 20.1-13.5 26.1l-38.5 27.2-25-25c-7-7-10.9-16.5-10.9-26.3zm83.7 37.2c12.7-9 20.3-23.6 20.3-39.2V176c0-26.5-21.5-48-48-48H229.3c-29.4 0-53.3 23.8-53.3 53.3c0 14.1 5.6 27.7 15.6 37.7L214.7 242l-45 31.7c-16.1 11.4-25.7 29.9-25.7 49.6c0 33.5 27.2 60.7 60.7 60.7h40.1c19.6 0 38.2-9 50.3-24.5l16.3-20.8 42.9 42.9c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-44.3-44.3 44.9-57.1c2.7-3.5 2.1-8.5-1.3-11.2s-8.5-2.1-11.2 1.3L310 314.7l-70.6-70.6 36.3-25.6zm-96.8 68.3l47.2-33.3L300 327.4l-17.5 22.3c-9.1 11.6-23 18.3-37.7 18.3H204.7C180 368 160 348 160 323.3c0-14.5 7.1-28.1 18.9-36.5z'
      
    ]
  };

  

  
  

  var faCampfire = {
    prefix: 'fat',
    iconName: 'campfire',
    icon: [
      512,
      512,
      [],
      'f6ba',
      
      'M224.9 14.5c1.3 0 2.5 .5 3.5 1.4c14.5 13.2 28.1 27.3 41 42.5c6 7 16.8 6.9 22.6-.3c5.2-6.3 10.6-12.5 16.3-17.8c2-1.9 5.2-1.8 7.2 0c17 15.9 34.6 37.4 47.9 61.1c13.3 23.8 22.1 49.1 22.1 72.5c0 43.3-20.7 81.9-52.8 105.9c7.6-12.1 12-26.2 12-41.2c0-52.2-58-100.4-79.4-116.5c-4.7-3.5-11-3.5-15.7 0c-21.5 16.1-79.4 64.4-79.4 116.5c0 16.9 5.5 32.6 14.9 45.6c-35.5-23.5-58.6-64.2-58.6-110.2c0-29.4 12.7-59 31.2-86.6C176.1 60 200 35.3 221.4 15.9c1-.9 2.3-1.4 3.6-1.4zM256 305.5c-1.4 0-2.9 0-4.3-.1c-38.3-2.7-66.9-32.4-66.9-66.7c0-20.9 11.8-42.7 28.3-62.5c15.7-18.8 34-33.9 44.4-41.8c10.5 7.9 28.7 22.9 44.4 41.8c16.4 19.7 28.3 41.5 28.3 62.5c0 32.9-26.3 61.5-62.1 66.2c-4 .4-8 .6-12 .6zM111.9 174c0 78.4 60.6 143.2 139.1 145.9c2.1 .1 4.3 .2 6.5 .2c4.1 0 8-.3 11.9-.8C343 312.5 400.1 249.6 400.1 174c0-26.8-9.9-54.6-23.9-79.6c-14.1-25.1-32.6-47.8-50.7-64.6c-7.6-7.1-19.4-7.1-27-.1c-6.4 5.9-12.3 12.7-17.7 19.3c0 0 0 0-.1 .1s-.1 0-.1 0s-.1 0-.1 0l0 0s0 0-.1 0c-13.3-15.6-27.4-30.2-42.3-43.8C234.5 1.8 229.8 0 225.1 0c-4.8 0-9.6 1.7-13.5 5.1c-21.8 19.8-46.6 45.4-66 74.2c-19.3 28.7-33.7 61.2-33.7 94.7zM11.1 288.6c-4.1-1.7-8.8 .2-10.5 4.3s.2 8.8 4.3 10.5L235.3 400 4.9 496.6c-4.1 1.7-6 6.4-4.3 10.5s6.4 6 10.5 4.3L256 408.7 500.9 511.4c4.1 1.7 8.8-.2 10.5-4.3s-.2-8.8-4.3-10.5L276.7 400l230.4-96.6c4.1-1.7 6-6.4 4.3-10.5s-6.4-6-10.5-4.3L256 391.3 11.1 288.6z'
      
    ]
  };

  

  
  

  var faHandsHolding = {
    prefix: 'fat',
    iconName: 'hands-holding',
    icon: [
      640,
      512,
      [],
      'f4c2',
      
      'M48 64c26.5 0 48 21.5 48 48V259c0 14.1 4.8 27.8 13.5 38.7c.9-8.8 4.4-17.5 10.6-24.7c17-19.8 47.2-21 65.6-2.5l92.8 92.8c16.3 16.3 25.5 38.5 25.5 61.6V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V424.8c0-18.9-7.5-37-20.8-50.3l-92.8-92.7c-11.8-11.9-31.3-11.1-42.2 1.6c-9.8 11.4-9.1 28.4 1.5 39.1l0 0 55.9 55.9 0 0 8 8c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-8-8 0 0-55.9-55.9-19.5-19.5C88.2 299.5 80 279.7 80 259V112c0-17.7-14.3-32-32-32s-32 14.3-32 32V344.2c0 23.3 9.3 45.7 25.8 62.2l91.9 91.9c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L30.5 417.8C11 398.3 0 371.8 0 344.2V112C0 85.5 21.5 64 48 64zm496 48c0-26.5 21.5-48 48-48s48 21.5 48 48V344.2c0 27.6-11 54-30.5 73.5l-91.9 91.9c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l91.9-91.9C614.7 390 624 367.6 624 344.2V112c0-17.7-14.3-32-32-32s-32 14.3-32 32V259c0 20.7-8.2 40.6-22.9 55.2l-19.5 19.5-55.9 55.9-8 8c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l8-8s0 0 0 0l55.9-55.9s0 0 0 0c10.6-10.6 11.3-27.6 1.5-39.1c-10.9-12.7-30.3-13.5-42.2-1.6l-92.8 92.7c-13.3 13.3-20.8 31.4-20.8 50.3V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V424.8c0-23.1 9.2-45.3 25.5-61.6l92.7-92.8c18.4-18.4 48.7-17.3 65.6 2.5c6.2 7.2 9.7 15.9 10.6 24.7c8.7-10.9 13.5-24.6 13.5-38.7V112z'
      
    ]
  };

  

  
  

  var faHeadphones = {
    prefix: 'fat',
    iconName: 'headphones',
    icon: [
      512,
      512,
      [127911],
      'f025',
      
      'M16 288C16 155.4 123.5 48 256 48s240 107.4 240 240c-14.6-19.4-37.8-32-64-32c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48c44.2 0 80-35.8 80-80V368 336 288C512 146.6 397.4 32 256 32S0 146.6 0 288v48 32 32c0 44.2 35.8 80 80 80c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48c-26.2 0-49.4 12.6-64 32zm0 48c0-35.3 28.7-64 64-64c17.7 0 32 14.3 32 32V432c0 17.7-14.3 32-32 32c-35.3 0-64-28.7-64-64V368 336zm480 0v32 32c0 35.3-28.7 64-64 64c-17.7 0-32-14.3-32-32V304c0-17.7 14.3-32 32-32c35.3 0 64 28.7 64 64z'
      
    ]
  };

  

  
  

  var faTengeSign = {
    prefix: 'fat',
    iconName: 'tenge-sign',
    icon: [
      384,
      512,
      [8376,"tenge"],
      'f7d7',
      
      'M0 40c0-4.4 3.6-8 8-8H376c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8zM0 168c0-4.4 3.6-8 8-8H192 376c4.4 0 8 3.6 8 8s-3.6 8-8 8H200V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V176H8c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  
    var faTenge = faTengeSign;
  

  
  

  var faSquare7 = {
    prefix: 'fat',
    iconName: 'square-7',
    icon: [
      448,
      512,
      [],
      'e25c',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm136 32H312c2.9 0 5.5 1.6 7 4.1s1.4 5.6-.1 8.1l-144 240c-2.3 3.8-7.2 5-11 2.7s-5-7.2-2.7-11L297.9 144H136c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faLampFloor = {
    prefix: 'fat',
    iconName: 'lamp-floor',
    icon: [
      640,
      512,
      [],
      'e015',
      
      'M209.1 26.1l-64 160c-2 4.9-1.4 10.5 1.6 14.9s7.9 7 13.2 7H480c5.3 0 10.3-2.6 13.2-7s3.6-10 1.6-14.9l-64-160C428.4 20 422.5 16 416 16H224c-6.5 0-12.4 4-14.9 10.1zm-14.9-5.9C199.1 8 210.9 0 224 0H416c13.1 0 24.9 8 29.7 20.1l64 160c3.9 9.9 2.7 21-3.2 29.8s-15.9 14.1-26.5 14.1H160c-10.6 0-20.5-5.3-26.5-14.1s-7.2-20-3.2-29.8l64-160zM200 496H312V256h16V496H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H320 200c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faSunCloud = {
    prefix: 'fat',
    iconName: 'sun-cloud',
    icon: [
      640,
      512,
      [127780],
      'f763',
      
      'M165.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L121 121 13.1 140.8c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L65.1 256 2.8 346.3c-3.1 4.5-3.7 10.2-1.6 15.2s6.6 8.6 11.9 9.6L121 391l19.8 107.9c1 5.3 4.6 9.8 9.6 11.9l3.1-7.4-3.1 7.4c5 2.1 10.7 1.5 15.2-1.6L256 446.9l90.3 62.3c4.5 3.1 10.2 3.7 15.2 1.6s8.6-6.6 9.6-11.9l9.4-50.9c-5.4-.2-10.8-.8-15.9-1.9l-9.2 50-94.9-65.4c-2.7-1.9-6.3-1.9-9.1 0L156.6 496 135.8 382.7c-.6-3.3-3.2-5.8-6.4-6.4L16 355.4l65.4-94.9c1.9-2.7 1.9-6.3 0-9.1L16 156.6l113.3-20.8c3.3-.6 5.8-3.2 6.4-6.4L156.6 16l94.9 65.4c2.7 1.9 6.3 1.9 9.1 0L355.4 16l20.8 113.3c.6 3.3 3.2 5.8 6.4 6.4L496 156.6l-24.6 35.7c6 .4 11.9 1.3 17.7 2.6l20.1-29.2c3.1-4.5 3.7-10.2 1.6-15.2l-7.4 3.1 7.4-3.1c-2.1-5-6.6-8.6-11.9-9.6L391 121 371.1 13.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L256 65.1 165.7 2.8zM256 144c-61.9 0-112 50.1-112 112s50.1 112 112 112c11.4 0 22.3-1.7 32.6-4.8c-.4-3.7-.6-7.4-.6-11.2c0-1.9 .1-3.7 .2-5.5C278.1 350 267.3 352 256 352c-53 0-96-43-96-96s43-96 96-96s96 43 96 96c0 1.9-.1 3.7-.2 5.5c3.2-1.1 6.4-2.1 9.7-2.9c1.8-4 3.8-8 6.1-11.7C363 189.3 314.8 144 256 144zM400.3 297.4c3.3-32.3 30.5-57.4 63.7-57.4c30.9 0 56.7 21.9 62.7 51c.5 2.6 2.3 4.7 4.7 5.7s5.1 .8 7.4-.5c8.5-5.2 18.5-8.3 29.3-8.3c30.9 0 56 25.1 56 56s-25.1 56-56 56H384c-26.5 0-48-21.5-48-48s21.5-48 48-48c2.4 0 4.8 .2 7.2 .5c2.2 .3 4.4-.3 6.1-1.6s2.8-3.3 3.1-5.5zM464 224c-38.7 0-71 27.5-78.4 64c-.5 0-1.1 0-1.6 0c-35.3 0-64 28.7-64 64s28.7 64 64 64H568c39.8 0 72-32.2 72-72s-32.2-72-72-72c-10.1 0-19.7 2.1-28.4 5.8C528.8 246.5 499 224 464 224z'
      
    ]
  };

  

  
  

  var faDivide = {
    prefix: 'fat',
    iconName: 'divide',
    icon: [
      448,
      512,
      [247,10135],
      'f529',
      
      'M224 80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0 144a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM424 264c4.4 0 8-3.6 8-8s-3.6-8-8-8H24c-4.4 0-8 3.6-8 8s3.6 8 8 8H424z'
      
    ]
  };

  

  
  

  var faEnvelopeOpenDollar = {
    prefix: 'fat',
    iconName: 'envelope-open-dollar',
    icon: [
      512,
      512,
      [],
      'f657',
      
      'M256 16c-8.6 0-17 2.8-24 7.9L177.9 64H334.1L280 23.9C273 18.8 264.6 16 256 16zM120 64h31l71.5-53C232.2 3.9 243.9 0 256 0s23.8 3.9 33.5 11L361 64h31c30.9 0 56 25.1 56 56v8.5l38.1 28.2c16.3 12.1 25.9 31.1 25.9 51.4V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V208.1c0-20.3 9.6-39.4 25.9-51.4L64 128.5V120c0-30.9 25.1-56 56-56zM448 214.5l-16 13.1V120c0-22.1-17.9-40-40-40H120c-22.1 0-40 17.9-40 40V227.7L64 214.5V148.4L35.4 169.5C23.2 178.6 16 192.9 16 208.1v8.4l1.6 1.3L232.7 394.5c6.6 5.4 14.8 8.3 23.3 8.3s16.7-2.9 23.3-8.3L494.4 217.8l1.6-1.3v-8.4c0-15.2-7.2-29.5-19.4-38.6L448 148.4v66.1zM16 448c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V237.2L289.4 406.9c-9.4 7.7-21.2 12-33.4 12s-24-4.2-33.4-12L16 237.2V448zM264 128v16.6c1.8 .2 3.6 .4 5.5 .7c4.8 .8 19.4 3.6 24.6 4.9c4.3 1.1 6.8 5.5 5.7 9.8s-5.5 6.8-9.8 5.7c-4.4-1.2-18.4-3.9-22.9-4.6c-14.1-2.2-26.5-.5-35.4 3.5c-8.9 4-13.9 10.1-15.1 17c-.9 5.4-.3 9.3 1.1 12.2c1.4 3 3.9 5.7 7.7 8.3c7.9 5.4 19.5 8.9 32.9 12.9l0 0 .3 .1c12.7 3.8 27.2 8.2 37.6 15.8c5.4 3.9 10.1 9 13 15.5c2.9 6.6 3.6 14.1 2.1 22.6c-2.5 14.4-11.9 24.3-24.5 29.7c-6.8 2.9-14.5 4.5-22.7 5V320c0 4.4-3.6 8-8 8s-8-3.6-8-8V303.4c-1.8-.2-3.6-.4-5.5-.7l0 0c-8.6-1.4-22.6-6.2-32-9.4l0 0 0 0c-1.9-.6-3.5-1.2-5-1.7c-4.2-1.4-6.5-5.9-5.1-10.1s5.9-6.5 10.1-5.1c1.7 .6 3.7 1.2 5.7 1.9l0 0 0 0 0 0c9.5 3.2 21.6 7.4 28.8 8.5c14.3 2.2 26.6 1 35.4-2.7c8.5-3.7 13.7-9.6 15.1-17.8c1-5.9 .4-10.2-1.1-13.5c-1.4-3.3-4-6.3-7.7-9c-7.8-5.7-19.5-9.4-32.9-13.5l-1.7-.5c-12.2-3.7-25.9-7.8-35.9-14.6c-5.4-3.7-10.2-8.4-13.2-14.7c-3-6.4-3.8-13.6-2.4-21.8c2.3-13.4 11.9-23.2 24.2-28.8c6.8-3.1 14.6-5 23-5.7V128c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faCubes = {
    prefix: 'fat',
    iconName: 'cubes',
    icon: [
      576,
      512,
      [],
      'f1b3',
      
      'M279.9 17.4c5.2-1.9 10.9-1.9 16.1 0L407.2 57 288 102.7 168.8 57 279.9 17.4zM144 218.5l-127.7 43C6.6 264.8 0 274 0 284.3V434.5c0 13.2 8.1 25 20.3 29.8l112.2 43.9c7.3 2.9 15.4 2.9 22.8 .2l132.7-49 132.7 49c7.4 2.7 15.5 2.6 22.8-.2l112.2-43.9c12.3-4.8 20.3-16.6 20.3-29.8V284.3c0-10.3-6.6-19.5-16.3-22.7L432 218.5V65.8c0-10.1-6.4-19.2-15.9-22.6L301.4 2.3c-8.7-3.1-18.2-3.1-26.9 0L159.9 43.2C150.4 46.6 144 55.7 144 65.8V218.5zm16 .4V70.8l120 46v152L160 218.9zm136 72.9l128 49.8v151L296 445.3V291.8zm-144.3-59l114.1 47.4L144.2 327.5 24.8 275.6l126.9-42.8zM16 434.5V289.2l120 52.2v151l-109.8-43C20 447 16 441.1 16 434.5zm136 58.1v-151l128-49.8V445.3L152 492.6zM296 116.8l120-46V218.9L296 268.8v-152zm14.2 163.4l114.1-47.4 126.9 42.8L431.8 327.5 310.2 280.2zM549.8 449.4L440 492.4v-151l120-52.2V434.5c0 6.6-4 12.5-10.2 14.9z'
      
    ]
  };

  

  
  

  var faSquareR = {
    prefix: 'fat',
    iconName: 'square-r',
    icon: [
      448,
      512,
      [],
      'e27c',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm152 32h88c44.2 0 80 35.8 80 80c0 38.8-27.6 71.1-64.2 78.4l70.4 84.4c2.8 3.4 2.4 8.4-1 11.3s-8.4 2.4-11.3-1L236.3 288H144v88c0 4.4-3.6 8-8 8s-8-3.6-8-8V280 152c0-13.3 10.7-24 24-24zm88 144c35.3 0 64-28.7 64-64s-28.7-64-64-64H152c-4.4 0-8 3.6-8 8V272h96z'
      
    ]
  };

  

  
  

  var faBillboard = {
    prefix: 'fat',
    iconName: 'billboard',
    icon: [
      640,
      512,
      [],
      'e5cd',
      
      'M424 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V32H232V8c0-4.4-3.6-8-8-8s-8 3.6-8 8V32H80C53.5 32 32 53.5 32 80V368H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H32 48 312V504c0 4.4 3.6 8 8 8s8-3.6 8-8V384H592h16 24c4.4 0 8-3.6 8-8s-3.6-8-8-8H608V80c0-26.5-21.5-48-48-48H424V8zM320 368H48V80c0-17.7 14.3-32 32-32H216v80H192c-4.4 0-8 3.6-8 8s3.6 8 8 8h32 32c4.4 0 8-3.6 8-8s-3.6-8-8-8H232V48H408v80H384c-4.4 0-8 3.6-8 8s3.6 8 8 8h32 32c4.4 0 8-3.6 8-8s-3.6-8-8-8H424V48H560c17.7 0 32 14.3 32 32V368H320z'
      
    ]
  };

  

  
  

  var fa0 = {
    prefix: 'fat',
    iconName: '0',
    icon: [
      320,
      512,
      [],
      '30',
      
      'M0 192C0 103.6 71.6 32 160 32s160 71.6 160 160V320c0 88.4-71.6 160-160 160S0 408.4 0 320V192zM160 48C80.5 48 16 112.5 16 192V320c0 79.5 64.5 144 144 144s144-64.5 144-144V192c0-79.5-64.5-144-144-144z'
      
    ]
  };

  

  
  

  var faShirt = {
    prefix: 'fat',
    iconName: 'shirt',
    icon: [
      640,
      512,
      [128085,"t-shirt","tshirt"],
      'f553',
      
      'M142.6 37.7L63.5 102.5 26.3 132.9c-6.8 5.6-7.8 15.7-2.3 22.5l60.8 74.3c5.6 6.8 15.7 7.8 22.5 2.3l37.2-30.4 18.4-15.1c2.4-2 5.7-2.4 8.5-1s4.6 4.1 4.6 7.2V464c0 17.7 14.3 32 32 32H432c17.7 0 32-14.3 32-32V192.7c0-3.1 1.8-5.9 4.6-7.2s6.1-.9 8.5 1l18.4 15.1 37.1 30.4c6.8 5.6 16.9 4.6 22.5-2.3l60.8-74.3c5.6-6.8 4.6-16.9-2.2-22.5l-37.1-30.4L497.4 37.7C480.2 23.7 458.7 16 436.6 16H416h-.3c-4.1 49.3-45.3 88-95.7 88s-91.6-38.7-95.7-88H224 203.4c-22.2 0-43.6 7.7-60.8 21.7zM416 0h20.6c25.9 0 50.9 8.9 70.9 25.3l79.2 64.8 37.1 30.4c13.7 11.2 15.7 31.4 4.5 45l-60.8 74.3c-11.2 13.7-31.4 15.7-45 4.5l-37.1-30.4-5.3-4.4V464c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V209.5l-5.3 4.4-37.2 30.4c-13.7 11.2-33.8 9.2-45-4.5L11.7 165.5c-11.2-13.7-9.2-33.8 4.5-45L53.3 90.1l79.2-64.8C152.5 8.9 177.6 0 203.4 0H224h8H408h8zM399.6 16H240.4c4 40.4 38.1 72 79.6 72s75.6-31.6 79.6-72z'
      
    ]
  };

  
    var faTShirt = faShirt;
  
    var faTshirt = faShirt;
  

  
  

  var faClockSix = {
    prefix: 'fat',
    iconName: 'clock-six',
    icon: [
      512,
      512,
      [],
      'e352',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM264 104V376c0 4.4-3.6 8-8 8s-8-3.6-8-8V104c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faHose = {
    prefix: 'fat',
    iconName: 'hose',
    icon: [
      448,
      512,
      [],
      'e419',
      
      'M304 103.2V112c0 4.4-3.6 8-8 8s-8-3.6-8-8V96.1v-.2V32.1v-.2V16c0-4.4 3.6-8 8-8s8 3.6 8 8v8.8L432.1 39.1c.5-4 3.8-7.1 7.9-7.1c4.4 0 8 3.6 8 8v7.9 .2V79.9v.2V88c0 4.4-3.6 8-8 8c-4.1 0-7.5-3.1-7.9-7.1L304 103.2zm0-16.1L432 72.8V55.2L304 40.9V87.1zM56 432H392c13.3 0 24-10.7 24-24s-10.7-24-24-24H56c-13.3 0-24 10.7-24 24s10.7 24 24 24zM16 408c0-13.1 6.3-24.7 16-32c-9.7-7.3-16-18.9-16-32c0-22.1 17.9-40 40-40H97c-48.1-24.4-81-74.4-81-132C16 90.3 82.3 24 164 24h92V40H164C91.1 40 32 99.1 32 172s59.1 132 132 132H392c13.3 0 24-10.7 24-24s-10.7-24-24-24H164c-46.4 0-84-37.6-84-84s37.6-84 84-84h92v16H164c-37.6 0-68 30.4-68 68s30.4 68 68 68H392c22.1 0 40 17.9 40 40c0 13.1-6.3 24.7-16 32c9.7 7.3 16 18.9 16 32s-6.3 24.7-16 32c9.7 7.3 16 18.9 16 32s-6.3 24.7-16 32c9.7 7.3 16 18.9 16 32c0 22.1-17.9 40-40 40H56c-22.1 0-40-17.9-40-40c0-13.1 6.3-24.7 16-32c-9.7-7.3-16-18.9-16-32zm376-88H164 56c-13.3 0-24 10.7-24 24s10.7 24 24 24H392c13.3 0 24-10.7 24-24s-10.7-24-24-24zm0 128H56c-13.3 0-24 10.7-24 24s10.7 24 24 24H392c13.3 0 24-10.7 24-24s-10.7-24-24-24z'
      
    ]
  };

  

  
  

  var faPhoneXmark = {
    prefix: 'fat',
    iconName: 'phone-xmark',
    icon: [
      640,
      512,
      [],
      'e227',
      
      'M361.8 382.5c6.6 3.1 14.6 1.3 19.2-4.3l40.4-49.3c6.7-8.2 18-11 27.8-7l96 40c11.1 4.6 17.1 16.8 13.9 28.5l-24 88C532.3 488.8 522.8 496 512 496C273.4 496 80 302.6 80 64c0-10.8 7.2-20.3 17.7-23.2l88-24c11.6-3.2 23.8 2.8 28.5 13.9l40 96c4.1 9.8 1.3 21.1-7 27.8l-49.3 40.4c-5.7 4.7-7.5 12.6-4.3 19.2c34.8 73.8 94.5 133.5 168.3 168.3zM409 318.7L368.7 368C298.2 334.7 241.2 277.7 208 207.3L257.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96c-7.7-18.6-28-28.5-47.4-23.2l-88 24C76.1 30.2 64 46 64 64c0 247.4 200.6 448 448 448c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6zM402.3 18.3c-3.1 3.1-3.1 8.2 0 11.3L468.7 96l-66.3 66.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L480 107.3l66.3 66.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L491.3 96l66.3-66.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L480 84.7 413.7 18.3c-3.1-3.1-8.2-3.1-11.3 0z'
      
    ]
  };

  

  
  

  var faGuitars = {
    prefix: 'fat',
    iconName: 'guitars',
    icon: [
      512,
      512,
      [],
      'f8bf',
      
      'M80 24V82.9c0 5 1.6 9.9 4.5 13.9L120 146.6v29.7C61.9 179.4 16 217.5 16 264c0 14 4.2 27.3 11.6 39.1c8.2 13 7.5 32-2.9 43.4C9.2 363.7 0 385 0 408c0 57.4 57.3 104 128 104c41.3 0 77.9-15.9 101.4-40.5c-2.1-6.3-3.6-12.9-4.5-19.6C206 477.5 171 496 128 496c-65.1 0-112-42.3-112-88c0-18.6 7.4-36.1 20.6-50.8c15.6-17.3 16.2-44.2 4.5-62.7c-6-9.4-9.2-19.8-9.2-30.6c0-34.7 35.5-68.6 88-71.8v88.6c-18.3 3.7-32 19.8-32 39.2c0 22.1 17.9 40 40 40s40-17.9 40-40c0-19.4-13.7-35.5-32-39.2V192.2c52.5 3.2 88 37.1 88 71.8c0 10.8-3.2 21.1-9.2 30.6c-11.7 18.5-11.1 45.4 4.5 62.7c8 8.8 13.8 18.7 17.2 29.2c.8-1.6 1.6-3.2 2.4-4.8c2.3-4.3 4.7-9 7-13.9c-3.9-7.6-8.9-14.7-14.8-21.3c-10.3-11.4-11.1-30.4-2.9-43.4C235.8 291.3 240 278 240 264c0-46.5-45.9-84.6-104-87.8V146.6l35.5-49.7c2.9-4.1 4.5-8.9 4.5-13.9V24c0-13.3-10.7-24-24-24H104C90.7 0 80 10.7 80 24zm48 106.2L97.5 87.5c-1-1.4-1.5-3-1.5-4.6V24c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8V82.9c0 1.7-.5 3.3-1.5 4.6L128 130.2zM104 320a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM379.1 0c-19.6 0-36.2 14.1-39.5 33.4l-9.1 54.5c-1.9 11.7 1.4 23.6 9.1 32.6L376 163v77h0c-39.4 0-51.5-24.2-55-42.9c-2.1-11.1-11-21.1-22.2-21.1c-10.4 0-18.8 8.4-18.8 18.8v34.7c0 12.9 4.3 25.4 8.5 37.8l0 0c1.4 4 2.7 7.9 3.9 11.8c2.1 6.8 3.6 15.1 3.6 24.8c0 33.5-17 70.9-28.8 92.9c-6.9 12.7-11.2 26.9-11.2 41.3c0 40.8 33 73.8 73.8 73.8H438.2c40.8 0 73.8-33 73.8-73.8c0-14.5-4.3-28.6-11.2-41.3C489 374.9 472 337.5 472 304c0-9.8 1.5-18 3.6-24.8c1.2-3.9 2.6-7.9 3.9-11.8l0 0 0 0c4.2-12.4 8.5-25 8.5-37.8V209.3c0-9.6-7.8-17.3-17.3-17.3c-8.5 0-15.8 6.2-19.5 13.8C444.3 220 428.2 240 392 240V160 79.2c18.3-3.7 32-19.8 32-39.2c0-22.1-17.9-40-40-40h-4.9zM376 256h16 0c21.2 0 37.6-5.9 49.9-14.8c12.1-8.7 19.4-19.6 23.7-28.4c.8-1.7 2-3.1 3.1-4c1.1-.8 1.7-.9 1.9-.9c.7 0 1.3 .6 1.3 1.3v20.2c0 6.2-1.4 12.9-3.7 20.5c-1.1 3.8-2.5 7.7-3.9 11.8l-.2 .5 0 0c-1.3 3.9-2.8 8.1-4 12.3c-2.5 8.2-4.3 18.1-4.3 29.5c0 37.8 18.7 78.2 30.7 100.4c5.9 11 9.3 22.5 9.3 33.8c0 31.9-25.9 57.8-57.8 57.8H329.8c-31.9 0-57.8-25.9-57.8-57.8c0-11.3 3.4-22.8 9.3-33.8c12-22.2 30.7-62.6 30.7-100.4c0-11.4-1.7-21.3-4.3-29.5c-1.3-4.2-2.7-8.4-4-12.3l-.2-.5c-1.4-4.1-2.7-8-3.9-11.8c-2.3-7.7-3.7-14.3-3.7-20.5V194.8c0-1.5 1.2-2.8 2.8-2.8c.6 0 1.8 .2 3.3 1.7c1.5 1.5 2.8 3.9 3.3 6.4c2.1 11.2 7 25.3 18.5 36.8c11.8 11.8 29 19.1 52.3 19.1h0zm0-184v66.4l-24.2-28.2c-4.6-5.4-6.6-12.6-5.4-19.6l9.1-54.5C357.4 24.5 367.4 16 379.1 16H384c13.3 0 24 10.7 24 24s-10.7 24-24 24c-4.4 0-8 3.6-8 8zM344 328c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8s-3.6-8-8-8H352c-4.4 0-8 3.6-8 8zm0 64c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8s-3.6-8-8-8H352c-4.4 0-8 3.6-8 8z'
      
    ]
  };

  

  
  

  var faScrollOld = {
    prefix: 'fat',
    iconName: 'scroll-old',
    icon: [
      576,
      512,
      [],
      'f70f',
      
      'M16 104c0-30.9 25.1-56 56-56s56 25.1 56 56v81.4c0 6.4 2.5 12.5 7 17l16 16c3.1 3.1 3.1 8.2 0 11.3l-16 16c-4.5 4.5-7 10.6-7 17V400c0 44.2 35.8 80 80 80H496c44.2 0 80-35.8 80-80V368c0-17.7-14.3-32-32-32H423.7c-7.3 0-14.2 3.3-18.7 9l-14.7 18.4c-3.2 4-9.3 4-12.5 0L363 345c-4.6-5.7-11.4-9-18.7-9H304c-17.7 0-32 14.3-32 32v32c0 35.3-28.7 64-64 64s-64-28.7-64-64V262.6c0-2.1 .8-4.2 2.3-5.7l16-16c9.4-9.4 9.4-24.6 0-33.9l-16-16c-1.5-1.5-2.3-3.5-2.3-5.7V104c0-22.6-10.4-42.8-26.7-56H408c30.9 0 56 25.1 56 56v17.4c0 2.1-.8 4.2-2.3 5.7l-16 16c-9.4 9.4-9.4 24.6 0 33.9l16 16c1.5 1.5 2.3 3.5 2.3 5.7v18.7c0 2.1-.8 4.2-2.3 5.7l-16 16c-9.4 9.4-9.4 24.6 0 33.9l16 16c1.5 1.5 2.3 3.5 2.3 5.7V304h16v-9.4c0-6.4-2.5-12.5-7-17l-16-16c-3.1-3.1-3.1-8.2 0-11.3l16-16c4.5-4.5 7-10.6 7-17V198.6c0-6.4-2.5-12.5-7-17l-16-16c-3.1-3.1-3.1-8.2 0-11.3l16-16c4.5-4.5 7-10.6 7-17V104c0-39.8-32.2-72-72-72H72C32.2 32 0 64.2 0 104v72c0 17.7 14.3 32 32 32H96V192H32c-8.8 0-16-7.2-16-16V104zM496 464H256c19.4-14.6 32-37.8 32-64V368c0-8.8 7.2-16 16-16h40.3c2.4 0 4.7 1.1 6.2 3l14.7 18.4c9.6 12 27.9 12 37.5 0L417.4 355c1.5-1.9 3.8-3 6.2-3H544c8.8 0 16 7.2 16 16v32c0 35.3-28.7 64-64 64z'
      
    ]
  };

  

  
  

  var faQuoteRight = {
    prefix: 'fat',
    iconName: 'quote-right',
    icon: [
      448,
      512,
      [8221,"quote-right-alt"],
      'f10e',
      
      'M448 296c0 66.3-53.7 120-120 120H312c-4.4 0-8-3.6-8-8s3.6-8 8-8h16c57.4 0 104-46.6 104-104V261.3c-13.2 16.3-33.4 26.7-56 26.7H328c-39.8 0-72-32.2-72-72V168c0-39.8 32.2-72 72-72h48c39.8 0 72 32.2 72 72v32 16 80zm-16-96V168c0-30.9-25.1-56-56-56H328c-30.9 0-56 25.1-56 56v48c0 30.9 25.1 56 56 56h48c30.9 0 56-25.1 56-56V200zM192 296c0 66.3-53.7 120-120 120H56c-4.4 0-8-3.6-8-8s3.6-8 8-8H72c57.4 0 104-46.6 104-104V261.3c-13.2 16.3-33.4 26.7-56 26.7H72c-39.8 0-72-32.2-72-72V168c0-39.8 32.2-72 72-72h48c39.8 0 72 32.2 72 72v32 16 80zm-16-96V168c0-30.9-25.1-56-56-56H72c-30.9 0-56 25.1-56 56v48c0 30.9 25.1 56 56 56h48c30.9 0 56-25.1 56-56V200z'
      
    ]
  };

  
    var faQuoteRightAlt = faQuoteRight;
  

  
  

  var faPenClipSlash = {
    prefix: 'fat',
    iconName: 'pen-clip-slash',
    icon: [
      640,
      512,
      ["pen-alt-slash"],
      'e20f',
      
      'M13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7zM556.7 149.3c25-25 25-65.5 0-90.5L517.3 19.3c-25-25-65.5-25-90.5 0L372.7 73.4 359.6 60.3c-21.9-21.9-57.3-21.9-79.2 0l-40.6 40.6 12.6 10 39.3-39.3c15.6-15.6 40.9-15.6 56.6 0l13.1 13.1-62.7 62.7 12.6 10L372.7 96 480 203.3l-48.8 48.8 12.6 10L556.7 149.3zM174.9 293.8l33.9-33.9-12.6-10-32.6 32.6c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9 .9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1l47.9-47.9-12.6-10-46.5 46.5c-45.8 45.8-104.1 77-167.6 89.7l-25 5c-2.6 .5-5.3-.3-7.2-2.2s-2.7-4.6-2.2-7.2l5-25c12.7-63.5 43.9-121.8 89.7-167.6zM438.1 30.6c18.7-18.7 49.1-18.7 67.9 0l39.4 39.4c18.7 18.7 18.7 49.1 0 67.9L491.3 192 384 84.7l54.1-54.1z'
      
    ]
  };

  
    var faPenAltSlash = faPenClipSlash;
  

  
  

  var faPoo = {
    prefix: 'fat',
    iconName: 'poo',
    icon: [
      512,
      512,
      [128169],
      'f2fe',
      
      'M224 0c-3.2 0-6.2 1.9-7.4 4.9s-.6 6.4 1.7 8.7l5.3 5.3C234.1 29.4 240 43.7 240 58.5V74.7c0 25-20.3 45.3-45.3 45.3H183.2 160c-39.8 0-72 32.2-72 72c0 11.9 2.9 23.1 8 32.9c-36.3 5.8-64 37.2-64 75.1c0 22 9.3 41.7 24.2 55.6C23.6 365.7 0 396.1 0 432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80c0-35.9-23.6-66.3-56.2-76.4C470.7 341.7 480 322 480 300c0-37.9-27.7-69.3-64-75.1c5.1-9.9 8-21.1 8-32.9c0-37.1-28-67.6-64-71.6C359.5 53.8 305.4 0 238.6 0H224zm32 58.5c0-15.4-4.9-30.2-13.8-42.5C298.7 17.9 344 64.4 344 121.4c0 1.9-.1 3.8-.3 5.7c-.3 2.3 .4 4.5 2 6.2s3.7 2.7 6 2.7h.4c30.9 0 56 25.1 56 56c0 13.3-4.6 25.4-12.3 35c-1.9 2.4-2.3 5.7-1 8.5s4.1 4.5 7.2 4.5h2c33.1 0 60 26.9 60 60c0 23-12.9 42.9-31.9 53c-3.2 1.7-4.8 5.3-4.1 8.8s3.8 6.1 7.4 6.3c33.8 1.8 60.6 29.7 60.6 63.9c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64c0-34.2 26.8-62.1 60.6-63.9c3.6-.2 6.6-2.7 7.4-6.3s-.9-7.1-4.1-8.8C60.9 342.9 48 323 48 300c0-33.1 26.9-60 60-60h2c3.1 0 5.9-1.8 7.2-4.5s1-6.1-1-8.5c-7.7-9.6-12.3-21.7-12.3-35c0-30.9 25.1-56 56-56h23.2 11.5c33.9 0 61.3-27.5 61.3-61.3V58.5zM192 304a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm144-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM172.3 368c-11.2 0-20.3 9.1-20.3 20.3c0 4 1.2 8.1 3.9 11.6C164.7 411.1 198 448 256 448s91.3-36.9 100.1-48.1c2.8-3.5 3.9-7.7 3.9-11.6c0-11.2-9.1-20.3-20.3-20.3H172.3zM168 388.3c0-2.4 1.9-4.3 4.3-4.3H339.7c2.4 0 4.3 1.9 4.3 4.3c0 .9-.3 1.4-.5 1.7c-7.6 9.7-36.8 42-87.5 42s-79.9-32.2-87.5-42c-.2-.3-.5-.9-.5-1.7z'
      
    ]
  };

  

  
  

  var faFaceMelting = {
    prefix: 'fat',
    iconName: 'face-melting',
    icon: [
      640,
      512,
      [129760],
      'e483',
      
      'M560 256c0 15.6-1.5 30.9-4.3 45.7c-6 30.9 15.4 66.3 51.1 66.3H608c8.8 0 16 7.2 16 16s-7.2 16-16 16H544c-17.7 0-32 14.3-32 32s14.3 32 32 32c8.8 0 16 7.2 16 16s-7.2 16-16 16H320 32c-8.8 0-16-7.2-16-16s7.2-16 16-16H44.9c26.6 0 45.8-18.3 55.5-38.6c9.7-20.3 12-46.4 1.9-68.2C88 326.4 80 292.2 80 256C80 123.5 187.5 16 320 16s240 107.5 240 240zm46.7 96c-23.6 0-39.8-24.1-35.4-47.2c3-15.8 4.6-32.1 4.6-48.8C576 114.6 461.4 0 320 0S64 114.6 64 256c0 38.5 8.5 75.1 23.8 107.9c15.5 33.4-6 84.1-42.9 84.1H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H320 544c17.7 0 32-14.3 32-32s-14.3-32-32-32c-8.8 0-16-7.2-16-16s7.2-16 16-16h64c17.7 0 32-14.3 32-32s-14.3-32-32-32h-1.3zM251.4 204.5a16 16 0 1 0 8.3-30.9 16 16 0 1 0 -8.3 30.9zm174.1 30.1a16 16 0 1 0 -30.9-8.3 16 16 0 1 0 30.9 8.3zM206 286.9c-1.9-4-6.7-5.6-10.7-3.7s-5.6 6.7-3.7 10.7c14.1 29.1 42.8 64 93.2 77.5s92.7-2.4 119.4-20.6c3.7-2.5 4.6-7.4 2.1-11.1s-7.5-4.6-11.1-2.1c-24.1 16.3-61.6 30.3-106.3 18.3s-70.2-42.9-82.9-69.1z'
      
    ]
  };

  

  
  

  var faBookMedical = {
    prefix: 'fat',
    iconName: 'book-medical',
    icon: [
      448,
      512,
      [],
      'f7e6',
      
      'M0 56C0 25.1 25.1 0 56 0H408c22.1 0 40 17.9 40 40V376c0 19.4-13.7 35.5-32 39.2V496h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H56c-30.9 0-56-25.1-56-56V56zM56 416c-22.1 0-40 17.9-40 40s17.9 40 40 40H400V416H56zm-40 .8C26.2 406.4 40.3 400 56 400H408c13.3 0 24-10.7 24-24V40c0-13.3-10.7-24-24-24H56C33.9 16 16 33.9 16 56V416.8zM208 120v56c0 4.4-3.6 8-8 8H144c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h56c4.4 0 8 3.6 8 8v56c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V240c0-4.4 3.6-8 8-8h56c4.4 0 8-3.6 8-8V192c0-4.4-3.6-8-8-8H264c-4.4 0-8-3.6-8-8V120c0-4.4-3.6-8-8-8H216c-4.4 0-8 3.6-8 8zm8-24h32c13.3 0 24 10.7 24 24v48h48c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H272v48c0 13.3-10.7 24-24 24H216c-13.3 0-24-10.7-24-24V248H144c-13.3 0-24-10.7-24-24V192c0-13.3 10.7-24 24-24h48V120c0-13.3 10.7-24 24-24z'
      
    ]
  };

  

  
  

  var faArrowDownSmallBig = {
    prefix: 'fat',
    iconName: 'arrow-down-small-big',
    icon: [
      576,
      512,
      ["sort-size-down-alt"],
      'f88d',
      
      'M165.7 477.7l104-104c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L168 452.7V40c0-4.4-3.6-8-8-8s-8 3.6-8 8V452.7L61.7 362.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l104 104c3.1 3.1 8.2 3.1 11.3 0zM336 80c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H368c-17.7 0-32-14.3-32-32V80zm-16 0v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48zm16 352V304c0-17.7 14.3-32 32-32H496c17.7 0 32 14.3 32 32V432c0 17.7-14.3 32-32 32H368c-17.7 0-32-14.3-32-32zm-16 0c0 26.5 21.5 48 48 48H496c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48V432z'
      
    ]
  };

  
    var faSortSizeDownAlt = faArrowDownSmallBig;
  

  
  

  var faGaugeSimple = {
    prefix: 'fat',
    iconName: 'gauge-simple',
    icon: [
      512,
      512,
      ["gauge-simple-med","tachometer-average"],
      'f629',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-208a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112c35.3 0 64-28.7 64-64c0-32.6-24.4-59.6-56-63.5V80c0-4.4-3.6-8-8-8s-8 3.6-8 8V288.5c-31.6 3.9-56 30.9-56 63.5c0 35.3 28.7 64 64 64z'
      
    ]
  };

  
    var faGaugeSimpleMed = faGaugeSimple;
  
    var faTachometerAverage = faGaugeSimple;
  

  
  

  var faTrash = {
    prefix: 'fat',
    iconName: 'trash',
    icon: [
      448,
      512,
      [],
      'f1f8',
      
      'M177.7 16h92.5c8.3 0 16 4.3 20.4 11.3l23 36.7H134.4l23-36.7c4.4-7 12.1-11.3 20.4-11.3zm-33.9 2.8L115.6 64H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H332.4L304.2 18.8C296.9 7.1 284.1 0 270.3 0H177.7c-13.8 0-26.6 7.1-33.9 18.8zM48 119.3c-.4-4.4-4.2-7.7-8.6-7.3s-7.7 4.2-7.3 8.6l28.3 340c2.4 29 26.7 51.4 55.8 51.4H331.8c29.1 0 53.4-22.3 55.8-51.4l28.3-340c.4-4.4-2.9-8.3-7.3-8.6s-8.3 2.9-8.6 7.3l-28.3 340C370 480.1 352.6 496 331.8 496H116.2c-20.8 0-38.1-15.9-39.9-36.7L48 119.3z'
      
    ]
  };

  

  
  

  var faHandFingersCrossed = {
    prefix: 'fat',
    iconName: 'hand-fingers-crossed',
    icon: [
      384,
      512,
      [],
      'e1a3',
      
      'M158 34.1l-90.2 222c1.4-.1 2.8-.1 4.2-.1h58.6L211.9 56c7.8-19.1-6.3-40-26.9-40c-11.8 0-22.5 7.2-26.9 18.1zM226.7 62L147.9 256H176c12.3 0 23.5 4.6 32 12.2V232c0-26.5 21.5-48 48-48c20.6 0 38.2 13 45 31.2c8.8-9.3 21.2-15.2 35-15.2c26.5 0 48 21.5 48 48v32 24 56c0 83.9-68.1 152-152 152H152C68.1 512 0 443.9 0 360V328c0-31.8 20.6-58.7 49.1-68.3l22.3-55L19 61.2C8.1 31.5 30.1 0 61.7 0C80.9 0 98 11.9 104.5 29.9l18 49.1 20.7-50.9C150.1 11.1 166.6 0 184.9 0c32 0 53.8 32.4 41.7 62zM113.5 101.1l-.9-2.4L89.5 35.4C85.2 23.8 74.2 16 61.7 16C41.2 16 26.9 36.4 34 55.7L80.4 182.6l33.1-81.5zM176 352H104c-4.4 0-8-3.6-8-8s3.6-8 8-8h72c17.7 0 32-14.3 32-32s-14.3-32-32-32H72c-30.9 0-56 25.1-56 56v32c0 75.1 60.9 136 136 136h80c75.1 0 136-60.9 136-136V339.8c-8.5 7.6-19.7 12.2-32 12.2c-18.5 0-34.6-10.5-42.6-25.9C284.6 337 271.1 344 256 344s-28.6-7-37.4-17.9c-8 15.4-24.1 25.9-42.6 25.9zm192-72V248c0-17.7-14.3-32-32-32s-32 14.3-32 32v48 8c0 17.7 14.3 32 32 32s32-14.3 32-32V280zM256 200c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V248 232c0-17.7-14.3-32-32-32z'
      
    ]
  };

  

  
  

  var faCloudWord = {
    prefix: 'fat',
    iconName: 'cloud-word',
    icon: [
      640,
      512,
      [],
      'e138',
      
      'M523.6 234.2c2.3 4.1 6.2 7.1 10.9 8C585.5 252.6 624 297.8 624 352c0 61.9-50.1 112-112 112H144C73.3 464 16 406.7 16 336c0-55.8 35.7-103.3 85.5-120.8c6.7-2.4 11-8.8 10.7-15.9c-.1-2.4-.2-4.9-.2-7.3c0-79.5 64.5-144 144-144c53.3 0 99.9 29 124.8 72.2c2.2 3.8 5.9 6.6 10.2 7.6s8.8 .2 12.5-2.3c12.7-8.5 28-13.5 44.4-13.5c44.2 0 80 35.8 80 80c0 10.2-1.9 19.9-5.3 28.8c-1.7 4.4-1.4 9.3 .9 13.4zM386 98.7C357 58.3 309.6 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144H512c70.7 0 128-57.3 128-128c0-56.3-36.4-104.1-86.9-121.3c-5-1.7-10.2-3.1-15.5-4.2c1.9-5 3.4-10.1 4.5-15.4c1.3-6.2 1.9-12.6 1.9-19.2c0-53-43-96-96-96c-15.2 0-29.5 3.5-42.3 9.8c-3.8 1.9-7.5 4-11 6.4c-2.7-4.6-5.6-9.1-8.7-13.4zM512 376c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8s3.6 8 8 8H504c4.4 0 8-3.6 8-8zm-264-8H136c-4.4 0-8 3.6-8 8s3.6 8 8 8H248c4.4 0 8-3.6 8-8s-3.6-8-8-8zM128 312c0 4.4 3.6 8 8 8H344c4.4 0 8-3.6 8-8s-3.6-8-8-8H136c-4.4 0-8 3.6-8 8zm264-8c-4.4 0-8 3.6-8 8s3.6 8 8 8H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H392z'
      
    ]
  };

  

  
  

  var faPhoneArrowDownLeft = {
    prefix: 'fat',
    iconName: 'phone-arrow-down-left',
    icon: [
      512,
      512,
      ["phone-arrow-down","phone-incoming"],
      'e223',
      
      'M509.7 13.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L304 196.7V72c0-4.4-3.6-8-8-8s-8 3.6-8 8V216c0 4.4 3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H315.3L509.7 13.7zM297.8 382.5c6.6 3.1 14.6 1.3 19.2-4.3l40.4-49.3c6.7-8.2 18-11 27.8-7l96 40c11.1 4.6 17.1 16.8 13.9 28.5l-24 88C468.3 488.8 458.8 496 448 496C209.4 496 16 302.6 16 64c0-10.8 7.2-20.3 17.7-23.2l88-24c11.6-3.2 23.8 2.8 28.5 13.9l40 96c4.1 9.8 1.3 21.1-7 27.8l-49.3 40.4c-5.7 4.7-7.5 12.6-4.3 19.2c34.8 73.8 94.5 133.5 168.3 168.3zM345 318.7L304.7 368C234.2 334.7 177.2 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6z'
      
    ]
  };

  
    var faPhoneArrowDown = faPhoneArrowDownLeft;
  
    var faPhoneIncoming = faPhoneArrowDownLeft;
  

  
  

  var faOrnament = {
    prefix: 'fat',
    iconName: 'ornament',
    icon: [
      384,
      512,
      [],
      'f7b8',
      
      'M192 16a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm35.8 64c7.6-8.5 12.2-19.7 12.2-32c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 12.3 4.6 23.5 12.2 32H128c-17.7 0-32 14.3-32 32v32 9.7C38.6 186.9 0 248.9 0 320C0 426 86 512 192 512s192-86 192-192c0-71.1-38.6-133.1-96-166.3V144 112c0-17.7-14.3-32-32-32H227.8zm37.6 80c38.7 17.8 69.8 49.1 87.2 88H31.4c17.4-38.9 48.6-70.2 87.2-88H265.4zM192 96h64c8.8 0 16 7.2 16 16v32H112V112c0-8.8 7.2-16 16-16h64zM16 320c0-19.6 3.2-38.4 9.1-56H358.9c5.9 17.6 9.1 36.4 9.1 56s-3.2 38.4-9.1 56H25.1c-5.9-17.6-9.1-36.4-9.1-56zM192 496c-71.6 0-133.1-42.7-160.6-104H352.6C325.1 453.3 263.6 496 192 496z'
      
    ]
  };

  

  
  

  var faFileXml = {
    prefix: 'fat',
    iconName: 'file-xml',
    icon: [
      512,
      512,
      [],
      'e654',
      
      'M64 496h48v16H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H204.1c12.7 0 24.9 5.1 33.9 14.1L369.9 145.9c9 9 14.1 21.2 14.1 33.9V320H368V179.9c0-1.3-.1-2.6-.2-3.9H248c-22.1 0-40-17.9-40-40V16.2c-1.3-.2-2.6-.2-3.9-.2H64C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48zM361.1 160c-.8-1-1.6-1.9-2.4-2.7L226.7 25.4c-.9-.9-1.8-1.7-2.7-2.4V136c0 13.3 10.7 24 24 24H361.1zM184 376c0 8.9 2.6 17.5 7.5 24.9L208 425.6l16.5-24.7c4.9-7.4 7.5-16 7.5-24.9c0-4.4 3.6-8 8-8s8 3.6 8 8c0 12-3.6 23.8-10.2 33.8L217.6 440l20.2 30.2c6.7 10 10.2 21.7 10.2 33.8c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-8.9-2.6-17.5-7.5-24.9L208 454.4l-16.5 24.7c-4.9 7.4-7.5 16-7.5 24.9c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-12 3.6-23.8 10.2-33.8L198.4 440l-20.2-30.2C171.6 399.8 168 388 168 376c0-4.4 3.6-8 8-8s8 3.6 8 8zM456 504V376c0-4.4 3.6-8 8-8s8 3.6 8 8V496h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H464c-4.4 0-8-3.6-8-8zM301.9 368.3c3.5-1 7.1 .5 9 3.6L352 440.5l41.1-68.6c1.8-3.1 5.5-4.6 9-3.6s5.9 4.1 5.9 7.7V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V404.9l-33.1 55.2c-1.4 2.4-4.1 3.9-6.9 3.9s-5.4-1.5-6.9-3.9L312 404.9V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V376c0-3.6 2.4-6.8 5.9-7.7z'
      
    ]
  };

  

  
  

  var faCarSideBolt = {
    prefix: 'fat',
    iconName: 'car-side-bolt',
    icon: [
      640,
      512,
      [],
      'e344',
      
      'M119.3 83.2L75.8 192H128v16H64c-26.5 0-48 21.5-48 48V368c0 8.8 7.2 16 16 16H64c0-53 43-96 96-96s96 43 96 96H384c0-53 43-96 96-96s96 43 96 96h32c8.8 0 16-7.2 16-16V320c0-61.9-50.1-112-112-112H448V192h47.4L397 69c-10.6-13.3-26.7-21-43.7-21H171.3c-22.9 0-43.5 13.9-52 35.2zm-60.8 109l46-115C115.4 49.9 141.9 32 171.3 32H353.2c21.9 0 42.6 9.9 56.2 27l106.4 133C584.8 194.1 640 250.6 640 320v48c0 17.7-14.3 32-32 32H574.7c-7.6 45.4-47.1 80-94.7 80s-87.1-34.6-94.7-80H254.7c-7.6 45.4-47.1 80-94.7 80s-87.1-34.6-94.7-80H32c-17.7 0-32-14.3-32-32V256c0-33.5 25.7-61 58.5-63.8zM160 464a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm400-80a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM355.4 112l-32 55.9h45.6c16 0 22.1 20.9 8.6 29.5L252.1 277.3c-14.1 9-30.8-6.9-22.5-21.4l32-55.9H216c-16 0-22.1-20.9-8.6-29.5L333 90.6c14.1-9 30.8 6.9 22.5 21.4zM216 183.9l59.4 0c2.9 0 5.5 1.5 6.9 4s1.4 5.5 0 8l-38.8 67.9 125.5-79.9H309.7c-2.9 0-5.5-1.5-6.9-4s-1.4-5.5 0-8l38.8-67.9L216 183.9z'
      
    ]
  };

  

  
  

  var faBrightness = {
    prefix: 'fat',
    iconName: 'brightness',
    icon: [
      512,
      512,
      [],
      'e0c9',
      
      'M248 104c0 4.4 3.6 8 8 8s8-3.6 8-8V8c0-4.4-3.6-8-8-8s-8 3.6-8 8v96zm8 72a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 176a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0 160c4.4 0 8-3.6 8-8V408c0-4.4-3.6-8-8-8s-8 3.6-8 8v96c0 4.4 3.6 8 8 8zM0 256c0 4.4 3.6 8 8 8h96c4.4 0 8-3.6 8-8s-3.6-8-8-8H8c-4.4 0-8 3.6-8 8zm408-8c-4.4 0-8 3.6-8 8s3.6 8 8 8h96c4.4 0 8-3.6 8-8s-3.6-8-8-8H408zM75 437c3.1 3.1 8.2 3.1 11.3 0l67.9-67.9c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L75 425.7c-3.1 3.1-3.1 8.2 0 11.3zM357.8 142.9c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L437 86.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-67.9 67.9zM75 75c-3.1 3.1-3.1 8.2 0 11.3l67.9 67.9c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L86.3 75c-3.1-3.1-8.2-3.1-11.3 0zM369.1 357.8c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L425.7 437c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-67.9-67.9z'
      
    ]
  };

  

  
  

  var faBoxCircleCheck = {
    prefix: 'fat',
    iconName: 'box-circle-check',
    icon: [
      576,
      512,
      [],
      'e0c4',
      
      'M232 48H342.4c19 0 36.2 11.2 43.9 28.5l41.6 93.6c.9 1.9 1.6 3.9 2.2 5.9H232V48zM16 192H352h80 16v-2.4c0-9-1.9-17.8-5.5-26L400.9 70c-10.3-23.1-33.2-38-58.5-38H105.6C80.3 32 57.4 46.9 47.1 70L5.5 163.6c-3.6 8.2-5.5 17-5.5 26V416c0 35.3 28.7 64 64 64H296.2c-4.2-5.1-8.1-10.4-11.8-16H64c-26.5 0-48-21.5-48-48V192zm200-16H18c.6-2 1.3-4 2.2-5.9L61.7 76.5C69.4 59.2 86.6 48 105.6 48H216V176zm216 64a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm69.7-189.7c-3.1-3.1-8.2-3.1-11.3 0L416 396.7l-42.3-42.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l48 48c3.1 3.1 8.2 3.1 11.3 0l80-80c3.1-3.1 3.1-8.2 0-11.3z'
      
    ]
  };

  

  
  

  var faShowerDown = {
    prefix: 'fat',
    iconName: 'shower-down',
    icon: [
      384,
      512,
      ["shower-alt"],
      'e24d',
      
      'M144 39c.6-21.6 18.2-39 40-39h16c21.7 0 39.4 17.3 40 39c69.4 20.6 120 84.9 120 161v24h16c4.4 0 8 3.6 8 8s-3.6 8-8 8H352 32 8c-4.4 0-8-3.6-8-8s3.6-8 8-8H24V200C24 123.9 74.6 59.6 144 39zM344 200c0-70.8-48.4-130.3-114-147.2c-3.5-.9-6-4.1-6-7.7V40c0-13.3-10.7-24-24-24H184c-13.3 0-24 10.7-24 24v5c0 3.7-2.5 6.8-6 7.7C88.4 69.7 40 129.2 40 200v24H344V200zM241.4 472c-.9 2.1-1.4 4.4-1.4 6.8V480c0 8.8 7.2 16 16 16s16-7.2 16-16v-1.2c0-2.3-.5-4.6-1.4-6.8L256 438 241.4 472zm-14.7-6.3l18.2-42.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5 .9-8.9 2.7-13.1zM320 310L305.4 344c-.9 2.1-1.4 4.4-1.4 6.8V352c0 8.8 7.2 16 16 16s16-7.2 16-16v-1.2c0-2.3-.5-4.6-1.4-6.8L320 310zm-11.2-14.6c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V352c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5 .9-8.9 2.7-13.1l18.2-42.4zM113.4 472c-.9 2.1-1.4 4.4-1.4 6.8V480c0 8.8 7.2 16 16 16s16-7.2 16-16v-1.2c0-2.3-.5-4.6-1.4-6.8L128 438 113.4 472zm-14.7-6.3l18.2-42.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5 .9-8.9 2.7-13.1zM192 310L177.4 344c-.9 2.1-1.4 4.4-1.4 6.8V352c0 8.8 7.2 16 16 16s16-7.2 16-16v-1.2c0-2.3-.5-4.6-1.4-6.8L192 310zm-11.2-14.6c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V352c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5 .9-8.9 2.7-13.1l18.2-42.4zM49.4 344c-.9 2.1-1.4 4.4-1.4 6.8V352c0 8.8 7.2 16 16 16s16-7.2 16-16v-1.2c0-2.3-.5-4.6-1.4-6.8L64 310 49.4 344zm-14.7-6.3l18.2-42.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V352c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5 .9-8.9 2.7-13.1z'
      
    ]
  };

  
    var faShowerAlt = faShowerDown;
  

  
  

  var faPersonDigging = {
    prefix: 'fat',
    iconName: 'person-digging',
    icon: [
      576,
      512,
      ["digging"],
      'f85e',
      
      'M256 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm92.8 409.6c-3 4-7.8 6.4-12.8 6.4H304c-6.1 0-11.6 3.4-14.3 8.8l-16 32c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6H544c5.8 0 11.1-3.1 13.9-8.1s2.8-11.2-.2-16.1l-96-160c-2.7-4.6-7.6-7.5-12.9-7.7s-10.4 2.1-13.6 6.4L348.8 425.6zM449.6 288c10.6 .5 20.3 6.4 25.8 15.5l96 160c5.9 9.9 6.1 22.2 .4 32.2s-16.3 16.2-27.8 16.2H288c-11.1 0-21.4-5.7-27.2-15.2s-6.4-21.2-1.4-31.1l16-32c5.4-10.8 16.5-17.7 28.6-17.7h32l26.2-35L20.1 191c-3.9-2.1-5.3-7-3.1-10.9s7-5.3 10.9-3.1l39.4 21.9 16.3-27.1C99.9 144.6 129.3 128 161 128c51.4 0 97 32.9 113.3 81.7l39 117 3.6 10.9 55 30.5 50.5-67.3c6.4-8.5 16.6-13.3 27.2-12.8zm-153.4 38L259.1 214.7C245 172.5 205.5 144 161 144c-26.1 0-50.3 13.7-63.7 36.1l-16 26.6L296.2 326.1zM55.9 288.9l10.6-35.5 14.3 8-9.6 32.1L40.7 395.4l-24 80c-2.5 8.5 2.3 17.4 10.7 19.9s17.4-2.3 19.9-10.7l24-80 19-63.3c1.4-4.7 4.9-8.4 9.4-10.3s9.6-1.5 13.9 1L167.9 363c5 2.8 8.1 8.2 8.1 13.9V480c0 8.8 7.2 16 16 16s16-7.2 16-16V358.3 332l16 8.9v17.5V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V376.9L119.9 354l-14.3-8.1-4.7 15.7L86.7 409.2l-24 80c-5.1 16.9-22.9 26.5-39.8 21.5S-3.7 487.7 1.4 470.8l24-80L55.9 288.9z'
      
    ]
  };

  
    var faDigging = faPersonDigging;
  

  
  

  var faMouseField = {
    prefix: 'fat',
    iconName: 'mouse-field',
    icon: [
      512,
      512,
      [],
      'e5a8',
      
      'M402.7 16.2C390.6 17.4 379.6 22.4 371 30l0 0c-.6 .5-1.1 1-1.6 1.5C383.4 47.7 392 68.8 392 92v12.6l.8 .1c17 1.2 32.9 5.9 47.2 13.4c1.8-1.2 3.5-2.6 5.1-4l0 0c2.9-2.6 5.5-5.4 7.9-8.5c.9-1.2 1.7-2.4 2.5-3.6C460.8 93.2 464 83 464 72c0-30.9-25.1-56-56-56c-1.8 0-3.5 .1-5.3 .2zM408 0c39.8 0 72 32.2 72 72c0 2.7-.1 5.3-.4 8c-1.2 10.9-4.8 21.1-10.3 29.9c-3.7 6-8.3 11.5-13.6 16.1l0 0c-.4 .3-.8 .7-1.2 1c30.1 21.8 49.6 57.3 49.6 97c0 22.1-17.9 39.9-39.9 39.9H373.2l-35.8 78.8 40.8 12.5c13 4 21.9 16 21.9 29.6c0 17.1-13.9 31-31 31H336 168 56c-22.1 0-40 17.9-40 40s17.9 40 40 40H472c4.4 0 8 3.6 8 8s-3.6 8-8 8H56c-30.9 0-56-25.1-56-56s25.1-56 56-56h66.7C106.4 386.8 96 366.6 96 344v-8c0-87.3 66.6-159 151.7-167.2C223.4 153.9 208 127.3 208 98V92c0-50.8 41.2-92 92-92c21.9 0 42 7.6 57.8 20.4c.8-.8 1.7-1.6 2.6-2.4l0 0c3.8-3.4 8-6.4 12.5-8.9C383.3 3.3 395.3 0 408 0zM328 88c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H296c-4.4 0-8-3.6-8-8s3.6-8 8-8h24V96c0-4.4 3.6-8 8-8zm88 88a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM112 344c0 30.9 25.1 56 56 56H336h33c8.3 0 15-6.7 15-15c0-6.6-4.3-12.4-10.6-14.3l-87.8-27c-4.2-1.3-6.6-5.8-5.3-10s5.8-6.6 10-5.3l31.6 9.7 38.8-85.4c1.3-2.9 4.1-4.7 7.3-4.7h96.1c13.2 0 23.9-10.7 23.9-23.9c0-54.4-42.1-99.6-96.4-103.5l-8.2-.6c-4.2-.3-7.4-3.8-7.4-8V92c0-42-34-76-76-76s-76 34-76 76v6c0 28.8 18.4 54.4 45.8 63.5l20.7 6.9c3.7 1.2 6 5 5.4 8.9s-4 6.7-7.9 6.7H264c-83.9 0-152 68.1-152 152v8z'
      
    ]
  };

  

  
  

  var faCoffeePot = {
    prefix: 'fat',
    iconName: 'coffee-pot',
    icon: [
      512,
      512,
      [],
      'e002',
      
      'M72 48c-30.9 0-56 25.1-56 56V216c0 4.4-3.6 8-8 8s-8-3.6-8-8V104C0 64.2 32.2 32 72 32h37.2H120 454.1C468.4 32 480 43.6 480 57.9c0 4-.9 8-2.7 11.6L421.5 181c54.3 33.9 90.5 94.2 90.5 163c0 55.5-34.6 99.4-55.9 121.2C446.2 475.3 432.3 480 418 480H158c-14.2 0-28.1-4.7-38.1-14.8C98.6 443.4 64 399.5 64 344c0-69 36.4-129.5 91-163.3L97.1 50.6c-.4-.8-.6-1.7-.8-2.6H72zm98.4 128H406.1L463 62.3c.7-1.4 1-2.9 1-4.4c0-5.5-4.4-9.9-9.9-9.9H120h-6.5l56.9 128zM416 192H160v0h7.2c-41.1 24.1-71.6 64.3-82.7 112H491.4c-11.1-47.7-41.6-87.9-82.7-112H416v0zm78.4 128H81.6c-1.1 7.8-1.6 15.9-1.6 24c0 49.1 30.9 89.1 51.3 110c6.3 6.5 15.8 10 26.6 10H418c10.9 0 20.3-3.6 26.6-10c20.4-20.9 51.3-60.9 51.3-110c0-8.1-.6-16.2-1.6-24z'
      
    ]
  };

  

  
  

  var faPenFancy = {
    prefix: 'fat',
    iconName: 'pen-fancy',
    icon: [
      512,
      512,
      [10002,128395],
      'f5ac',
      
      'M384.7 37.8C396.7 23.9 414.2 16 432.5 16C467.6 16 496 44.4 496 79.5c0 18.4-7.9 35.8-21.8 47.9L256.4 317.1l-61.4-61.4L384.7 37.8zM432.5 0c-23 0-44.8 9.9-59.9 27.3L179.5 249 94.5 273.3c-18 5.1-32.2 18.9-37.9 36.7L2.3 478.7c-6.1 18.9 12.2 36.6 30.9 29.9l170.8-61c16.6-5.9 29.5-19.4 34.7-36.3L263 332.5 484.7 139.4c17.3-15.1 27.3-36.9 27.3-59.9C512 35.6 476.4 0 432.5 0zM246.9 330.2l-23.5 76.4c-3.7 12.1-12.9 21.7-24.8 25.9L30.8 492.5l75.1-75.1c6.3 4.2 13.9 6.6 22.1 6.6c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 8.2 2.4 15.7 6.6 22.1L17.7 482.9l54-168.1c4.1-12.7 14.3-22.6 27.1-26.2L181.7 265l65.3 65.3zM104 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faChartKanban = {
    prefix: 'fat',
    iconName: 'chart-kanban',
    icon: [
      448,
      512,
      [],
      'e64f',
      
      'M368 464c-17.7 0-32-14.3-32-32l0-352c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32l0 352c0 17.7-14.3 32-32 32H368zm-48-32c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48l0-352c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48l0 352zM80 400H48c-17.7 0-32-14.3-32-32L16 80c0-17.7 14.3-32 32-32H80c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32zM48 416H80c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80L0 368c0 26.5 21.5 48 48 48zM240 272H208c-17.7 0-32-14.3-32-32l0-160c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V240c0 17.7-14.3 32-32 32zm-32 16h32c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H208c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48z'
      
    ]
  };

  

  
  

  var faHatWizard = {
    prefix: 'fat',
    iconName: 'hat-wizard',
    icon: [
      512,
      512,
      [],
      'f6e8',
      
      'M442.7 368L371.6 208.1c-2.4-5.4-3.6-11.1-3.6-17c0-4.7 .8-9.4 2.4-13.8l52.5-150c.8-2.2 1.2-4.5 1.2-6.8V19c0-10.5-8.5-19-19-19c-3.3 0-6.5 .9-9.4 2.5l-165 94.3c-35.5 20.3-63.6 51.4-80.2 88.7L69.3 368H86.8l78.2-176c15.2-34.2 41-62.7 73.5-81.3l165-94.3c.4-.3 1-.4 1.5-.4c1.6 0 3 1.3 3 3v1.5c0 .5-.1 1-.3 1.5l15.1 5.3L407.7 22 355.2 172c-2.2 6.1-3.2 12.6-3.2 19.1c0 8.1 1.7 16.1 5 23.5L425.2 368h17.5zM456 416c22.1 0 40 17.9 40 40s-17.9 40-40 40H56c-22.1 0-40-17.9-40-40s17.9-40 40-40H456zM56 400c-30.9 0-56 25.1-56 56s25.1 56 56 56H456c30.9 0 56-25.1 56-56s-25.1-56-56-56H56zM280 144c0-4.4-3.6-8-8-8s-8 3.6-8 8v24H240c-4.4 0-8 3.6-8 8s3.6 8 8 8h24v24c0 4.4 3.6 8 8 8s8-3.6 8-8V184h24c4.4 0 8-3.6 8-8s-3.6-8-8-8H280V144zM232 272c0-4.4-3.6-8-8-8s-8 3.6-8 8v40H176c-4.4 0-8 3.6-8 8s3.6 8 8 8h40v40h16V328h40c4.4 0 8-3.6 8-8s-3.6-8-8-8H232V272z'
      
    ]
  };

  

  
  

  var faSquareKanban = {
    prefix: 'fat',
    iconName: 'square-kanban',
    icon: [
      448,
      512,
      [],
      'e488',
      
      'M64 464c-26.5 0-48-21.5-48-48L16 96c0-26.5 21.5-48 48-48l320 0c26.5 0 48 21.5 48 48l0 320c0 26.5-21.5 48-48 48L64 464zM0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zM128 144c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm208 16l0 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16s16 7.2 16 16zm-96 0l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16zM96 160l0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128c0-17.7-14.3-32-32-32s-32 14.3-32 32zm256 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192zm-96 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64z'
      
    ]
  };

  

  
  

  var faGarageCar = {
    prefix: 'fat',
    iconName: 'garage-car',
    icon: [
      640,
      512,
      [],
      'e00a',
      
      'M329.1 20.4c-5.8-2.4-12.4-2.4-18.2 0L40.8 131.2c-15 6.2-24.8 20.8-24.8 37V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V168.2c0-22.7 13.7-43.2 34.7-51.8L304.8 5.6c9.7-4 20.6-4 30.4 0L605.3 116.4c21 8.6 34.7 29.1 34.7 51.8V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V168.2c0-16.2-9.8-30.8-24.8-37L329.1 20.4zM120 208c-4.4 0-8 3.6-8 8V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V216c0-13.3 10.7-24 24-24H520c13.3 0 24 10.7 24 24V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V216c0-4.4-3.6-8-8-8H120zm111.5 64.6L211 336H429l-20.5-63.4c-3.2-9.9-12.4-16.6-22.8-16.6H254.4c-10.4 0-19.6 6.7-22.8 16.6zm-38.1 65.6l22.9-70.6c5.3-16.5 20.7-27.7 38.1-27.7H385.6c17.3 0 32.7 11.2 38.1 27.7l22.9 70.6c19.4 6.2 33.5 24.3 33.5 45.8V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V464H176v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V384c0-21.4 14.1-39.6 33.5-45.8zM432 352H208c-17.7 0-32 14.3-32 32v64H464V384c0-17.7-14.3-32-32-32zM224 384a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm176 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faTextWidth = {
    prefix: 'fat',
    iconName: 'text-width',
    icon: [
      448,
      512,
      [],
      'f035',
      
      'M16 56c0-4.4 3.6-8 8-8H216l0 224H160c-4.4 0-8 3.6-8 8s3.6 8 8 8h64 64c4.4 0 8-3.6 8-8s-3.6-8-8-8H232l0-224H424c4.4 0 8 3.6 8 8v48c0 4.4 3.6 8 8 8s8-3.6 8-8V56c0-13.3-10.7-24-24-24H224 24C10.7 32 0 42.7 0 56v48c0 4.4 3.6 8 8 8s8-3.6 8-8V56zM445.7 389.7c3.1-3.1 3.1-8.2 0-11.3l-80-80c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L420.7 376 27.3 376l66.3-66.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-80 80c-3.1 3.1-3.1 8.2 0 11.3l80 80c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L27.3 392l393.4 0-66.3 66.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l80-80z'
      
    ]
  };

  

  
  

  var faPersonBooth = {
    prefix: 'fat',
    iconName: 'person-booth',
    icon: [
      576,
      512,
      [],
      'f756',
      
      'M264 16c-13.3 0-24 10.7-24 24V192H224V40c0-22.1 17.9-40 40-40h24H536c22.1 0 40 17.9 40 40V392 504c0 4.4-3.6 8-8 8s-8-3.6-8-8V431.2c-10.2 10.4-24.3 16.8-40 16.8s-29.8-6.4-40-16.8c-10.2 10.4-24.3 16.8-40 16.8s-29.8-6.4-40-16.8c-10.2 10.4-24.3 16.8-40 16.8c-30.9 0-56-25.1-56-56v-7c0-6.7 .9-13.3 2.8-19.8l29-101.4L281.6 16H264zm33.9 0l53.9 246.3c.3 1.3 .2 2.6-.1 3.9L322.2 369.6c-1.4 5-2.2 10.2-2.2 15.4v7c0 22.1 17.9 40 40 40c13.9 0 26.2-7.1 33.3-17.9c1.5-2.2 4-3.6 6.7-3.6s5.2 1.3 6.7 3.6c7.2 10.8 19.4 17.9 33.3 17.9s26.2-7.1 33.3-17.9c1.5-2.2 4-3.6 6.7-3.6s5.2 1.3 6.7 3.6c7.2 10.8 19.4 17.9 33.3 17.9c22.1 0 40-17.9 40-40V40c0-13.3-10.7-24-24-24H297.9zM240 320V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V320h16zM99.2 350.9c-2.1-2.8-3.2-6.1-3.2-9.6V269.3c0-6.5 3.9-12.3 9.9-14.8s12.9-1.1 17.4 3.5l4.7 4.7c6 6 14.1 9.4 22.6 9.4H224c8.8 0 16-7.2 16-16s-7.2-16-16-16H157.3c-4.2 0-8.3-1.7-11.3-4.7l-41.6-41.6C93 182.4 77.6 176 61.6 176C36.4 176 16 196.4 16 221.6v55.7l0 .9 0 .1L16 480c0 8.8 7.2 16 16 16s16-7.2 16-16V384c0-6.9 4.4-13 10.9-15.2s13.7 .1 17.9 5.6l32 42.7c2.1 2.8 3.2 6.1 3.2 9.6V480c0 8.8 7.2 16 16 16s16-7.2 16-16V421.3c0-6.9-2.2-13.7-6.4-19.2L99.2 350.9zM0 277.3V221.6c0-34 27.6-61.6 61.6-61.6c20.3 0 39.7 8.1 54 22.4L157.3 224H224c17.7 0 32 14.3 32 32s-14.3 32-32 32H150.6c-8 0-15.7-2-22.6-5.7c-4.1-2.2-7.9-5-11.3-8.4l-4.7-4.7v9.4V291v50.3l38.4 51.2c6.2 8.3 9.6 18.4 9.6 28.8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V426.7L80 405.3 64 384v26.7V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V278.3l0-.9zM64 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM16 80a48 48 0 1 1 96 0A48 48 0 1 1 16 80z'
      
    ]
  };

  

  
  

  var faBanBug = {
    prefix: 'fat',
    iconName: 'ban-bug',
    icon: [
      512,
      512,
      ["debug"],
      'f7f9',
      
      'M256 496C123.5 496 16 388.5 16 256c0-63.4 24.6-121.1 64.7-164L420 431.3C377.1 471.4 319.4 496 256 496zM92 80.7C134.9 40.6 192.6 16 256 16c132.5 0 240 107.5 240 240c0 63.4-24.6 121.1-64.7 164L92 80.7zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm40.8-158.7C285.7 362.5 271.5 368 256 368c-35.3 0-64-28.7-64-64V288.2v-.3V248.6l-31.6-31.6-30.2-8.6c-4.2-1.2-8.7 1.2-9.9 5.5s1.2 8.7 5.5 9.9L176 238v43l-49.1 7c-4.4 .6-7.4 4.7-6.8 9.1s4.7 7.4 9.1 6.8l46.9-6.7V304c0 10.4 2 20.3 5.6 29.3l-42 28c-3.7 2.5-4.7 7.4-2.2 11.1s7.4 4.7 11.1 2.2l40.5-27c14.3 21.9 39 36.3 67.1 36.3c19.9 0 38.1-7.3 52.1-19.3l-11.4-11.4zM256 128c-19.9 0-38.1 7.3-52.1 19.3l11.4 11.4c11.1-9.2 25.3-14.7 40.8-14.7c35.3 0 64 28.7 64 64v23.9 .2 31.4l16 16V238l50.2-14.3c4.2-1.2 6.7-5.6 5.5-9.9s-5.6-6.7-9.9-5.5L336 221.4V208c0-10.4-2-20.3-5.6-29.3l42-28c3.7-2.5 4.7-7.4 2.2-11.1s-7.4-4.7-11.1-2.2l-40.5 27c-14.3-21.9-39-36.3-67.1-36.3zM385.1 288.1l-47.2-6.7 18.9 18.9 26.1 3.7c4.4 .6 8.4-2.4 9.1-6.8s-2.4-8.4-6.8-9.1z'
      
    ]
  };

  
    var faDebug = faBanBug;
  

  
  

  var faBridgeWater = {
    prefix: 'fat',
    iconName: 'bridge-water',
    icon: [
      576,
      512,
      [],
      'e4ce',
      
      'M544 80H32c-8.8 0-16 7.2-16 16v67.6c0 6.9 5.6 12.4 12.4 12.4c46.1 0 83.6 37.4 83.6 83.6v94.9c-5.3-1.4-10.6-2-16-2V259.6C96 222.2 65.8 192 28.4 192C12.7 192 0 179.3 0 163.6V96C0 78.3 14.3 64 32 64H544c17.7 0 32 14.3 32 32v67.6c0 15.7-12.7 28.4-28.4 28.4c-37.3 0-67.6 30.2-67.6 67.6v92.9c-5.4 0-10.7 .7-16 2V259.6c0-46.1 37.4-83.6 83.6-83.6c6.9 0 12.4-5.6 12.4-12.4V96c0-8.8-7.2-16-16-16zM192 384.5h0V272c0-53 43-96 96-96s96 43 96 96V384.5c-5.2 0-10.6-.6-16-1.6V272c0-44.2-35.8-80-80-80s-80 35.8-80 80V382.9c-5.3 1-10.6 1.6-16 1.6zm102.6 19c8 11.2 17.5 21.4 27.6 30.7C339.5 449.8 361.5 464 384 464s44.6-14.2 61.8-29.9c10.1-9.2 19.7-19.5 27.6-30.7c1.5-2.1 3.9-3.4 6.6-3.4s5.1 1.3 6.6 3.4c7.3 10.3 15.9 19.6 25 28.3c15.7 14.8 36.1 29.2 57.4 31.9c4.4 .6 7.5 4.6 6.9 8.9s-4.6 7.5-8.9 6.9c-26.5-3.3-50-20.7-66.4-36.1c-8.8-8.3-15.9-16.4-20.6-22.2c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8l0 0 0 0c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-4.7 5.8-11.8 13.9-20.6 22.2C59 458.7 35.5 476.1 9 479.4c-4.4 .6-8.4-2.6-8.9-6.9s2.6-8.4 6.9-8.9c21.3-2.7 41.7-17.1 57.4-31.9c9.1-8.6 17.7-18 25-28.3c1.5-2.1 3.9-3.4 6.6-3.4s5.1 1.3 6.6 3.4c7.9 11.2 17.5 21.5 27.6 30.7C147.4 449.8 169.5 464 192 464s44.6-14.2 61.8-29.9c10.1-9.2 19.6-19.5 27.6-30.7c3-4.3 10.2-4.3 13.2 0z'
      
    ]
  };

  

  
  

  var faVentDamper = {
    prefix: 'fat',
    iconName: 'vent-damper',
    icon: [
      640,
      512,
      [],
      'e465',
      
      'M128 80c-26.5 0-48 21.5-48 48v8V376v8c0 26.5 21.5 48 48 48H512c26.5 0 48-21.5 48-48v-8V136v-8c0-26.5-21.5-48-48-48H128zM512 64c35.3 0 64 28.7 64 64h24c22.1 0 40 17.9 40 40V344c0 22.1-17.9 40-40 40H576c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64H40c-22.1 0-40-17.9-40-40V168c0-22.1 17.9-40 40-40l24 0c0-35.3 28.7-64 64-64H512zm88 304c13.3 0 24-10.7 24-24V168c0-13.3-10.7-24-24-24H576V368h24zM64 144H40c-13.3 0-24 10.7-24 24V344c0 13.3 10.7 24 24 24H64V144zm80-16c-8.8 0-16 7.2-16 16V368c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H144zm-32 16c0-17.7 14.3-32 32-32H496c17.7 0 32 14.3 32 32V368c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32V144zm72 32H456c4.4 0 8 3.6 8 8s-3.6 8-8 8H184c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 72H456c4.4 0 8 3.6 8 8s-3.6 8-8 8H184c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 72H456c4.4 0 8 3.6 8 8s-3.6 8-8 8H184c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faMosquitoNet = {
    prefix: 'fat',
    iconName: 'mosquito-net',
    icon: [
      640,
      512,
      [],
      'e52c',
      
      'M411.9 1c3.9 2.1 5.3 7 3.1 10.9L376.7 80.8l14.9 44.7c1.1 3.4-.2 7.2-3.2 9.2l-62.3 41.5 173.5 25.9c5 .6 10 1.7 14.7 3.1c4.2 1.3 6.6 5.8 5.3 10s-5.8 6.6-10 5.3c-3.9-1.2-7.9-2.1-12.1-2.6l-.2 0 0 0L320 191.4v44.5l37.3 32.4c3.3 2.9 3.7 8 .8 11.3s-8 3.7-11.3 .8L320 257.1v19.6l29.7 29.7c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L320 299.3v61.3c0 17.7-14.3 32-32 32s-32-14.3-32-32V299.3l-40 40V384c0 1.4-.3 2.7-1 3.9l-40 72c-2.1 3.9-7 5.3-10.9 3.1s-5.3-7-3.1-10.9l39-70.2V336c0-2.1 .8-4.2 2.3-5.7L256 276.7V257.1L148.8 350.5C93.8 405.1 0 366.2 0 288.6c0-44 32.7-81 76.3-86.5l173.5-25.9-62.3-41.5c-3-2-4.3-5.8-3.2-9.2l14.9-44.7L161 11.9c-2.1-3.9-.8-8.7 3.1-10.9s8.7-.8 10.9 3.1l40 72c1.1 2 1.3 4.3 .6 6.4l-14.1 42.2L256 161V137.9c0-14.9 10.1-27.3 23.8-31V63.7c0-4.5 3.7-8.2 8.2-8.2s8.2 3.7 8.2 8.2V107c13.7 3.6 23.8 16.1 23.8 31v23.1l54.5-36.3L360.4 82.5c-.7-2.1-.5-4.5 .6-6.4l40-72c2.1-3.9 7-5.3 10.9-3.1zM256 191.4L78.6 217.9l-.2 0 0 0C42.8 222.4 16 252.7 16 288.6c0 63.5 76.8 95.3 121.7 50.4c.1-.1 .3-.3 .4-.4L256 235.9V191.4zM392 376h32V312H392c-4.4 0-8-3.6-8-8s3.6-8 8-8h32V264c0-4.4 3.6-8 8-8s8 3.6 8 8v32h64V264c0-4.4 3.6-8 8-8s8 3.6 8 8v32h64V264c0-4.4 3.6-8 8-8s8 3.6 8 8v32h32c4.4 0 8 3.6 8 8s-3.6 8-8 8H600v64h32c4.4 0 8 3.6 8 8s-3.6 8-8 8H600v64h32c4.4 0 8 3.6 8 8s-3.6 8-8 8H600v32c0 4.4-3.6 8-8 8s-8-3.6-8-8V472H520v32c0 4.4-3.6 8-8 8s-8-3.6-8-8V472H440v32c0 4.4-3.6 8-8 8s-8-3.6-8-8V472H392c-4.4 0-8-3.6-8-8s3.6-8 8-8h32V392H392c-4.4 0-8-3.6-8-8s3.6-8 8-8zm192 16H520v64h64V392zm0-80H520v64h64V312zM440 392v64h64V392H440zm0-16h64V312H440v64zM272 360.6c0 8.8 7.2 16 16 16s16-7.2 16-16l0-222.7c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 222.7z'
      
    ]
  };

  

  
  

  var faRocketLaunch = {
    prefix: 'fat',
    iconName: 'rocket-launch',
    icon: [
      512,
      512,
      [128640],
      'e027',
      
      'M209.7 302.3c-15.3-15.3-34.9-25.3-55.9-28.9c31-125.8 90-191.8 150.9-225.1C367.6 14 435 13.2 481.2 21.1c5 .9 8.8 4.7 9.7 9.7c8 46.1 7.2 113.5-27.2 176.5c-33.3 60.9-99.3 119.9-225.1 150.9c-3.6-21-13.6-40.6-28.9-55.9zM240 375.6l0-1.2c51.4-12.5 93.6-29.6 128-49.8l0 85.7c0 15.2-8.6 29-22.1 35.8l-94.3 47.2c-5.3 2.7-11.6-1.2-11.6-7.2l0-110.5zm144 34.7l0-95.7C510.9 230.8 519.5 102.5 506.6 28.1c-2-11.6-11.1-20.7-22.7-22.7C409.5-7.5 281.3 1.1 197.4 128H101.7c-21.2 0-40.6 12-50.1 31L4.4 253.3c-8 16 3.6 34.7 21.5 34.7l110.5 0c23.2 0 45.5 9.2 61.9 25.7s25.7 38.7 25.7 61.9l0 110.5c0 17.8 18.8 29.4 34.7 21.5L353 460.4c19-9.5 31-28.9 31-50.1zM137.7 272l-1.2 0H25.9c-5.9 0-9.8-6.3-7.2-11.6l47.2-94.3c6.8-13.6 20.6-22.1 35.8-22.1h85.7c-20.2 34.4-37.3 76.6-49.8 128zm17.5 186.7c-14.1 14.1-35.8 23.4-60.2 29.2c-24.1 5.7-48.8 7.6-67 8c-6.8 .2-12-5-11.8-11.8c.4-18.2 2.3-43 8-67c5.8-24.4 15.1-46.1 29.2-60.2c28.1-28.1 73.8-28.1 101.9 0s28.1 73.8 0 101.9zM166.5 470c34.4-34.4 34.4-90.1 0-124.5s-90.1-34.4-124.5 0C7.7 379.7 1 446 .1 483.7c-.4 16 12.2 28.6 28.2 28.2C66 511 132.3 504.3 166.5 470zM408 144a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zM368 88a56 56 0 1 0 0 112 56 56 0 1 0 0-112z'
      
    ]
  };

  

  
  

  var faStarfighterTwinIonEngine = {
    prefix: 'fat',
    iconName: 'starfighter-twin-ion-engine',
    icon: [
      576,
      512,
      ["starfighter-alt"],
      'e038',
      
      'M16 40c0-4.4-3.6-8-8-8s-8 3.6-8 8V209.6 216v80 6.4V472c0 4.4 3.6 8 8 8s8-3.6 8-8V306l133.2 29.6C176.8 383.6 228.6 416 288 416s111.2-32.4 138.8-80.4L560 306V472c0 4.4 3.6 8 8 8s8-3.6 8-8V302.4 296 216v-6.4V40c0-4.4-3.6-8-8-8s-8 3.6-8 8V206L426.8 176.4C399.2 128.4 347.4 96 288 96s-111.2 32.4-138.8 80.4L16 206V40zM435.9 194.8L560 222.4v67.2L435.9 317.2c7.8-18.8 12.1-39.5 12.1-61.2s-4.3-42.3-12.1-61.2zM140.1 317.2L16 289.6V222.4l124.1-27.6C132.3 213.7 128 234.3 128 256s4.3 42.3 12.1 61.2zM288 112a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM257 263.9a32 32 0 1 1 62-15.9 32 32 0 1 1 -62 15.9zm3.2 31.2c5.8 4.1 12.5 7 19.8 8.2v48.3c-20.5-1.7-39.2-9.8-54-22.4l34.2-34.2zM350 329.3c-14.8 12.5-33.5 20.7-54 22.4V303.3c7.3-1.2 14-4.1 19.8-8.2L350 329.3zM383.7 264c-1.7 20.5-9.8 39.2-22.4 54l-34.2-34.2c4.1-5.8 7-12.5 8.2-19.8h48.3zm-48.3-16c-1.2-7.3-4.1-14-8.2-19.8L361.3 194c12.5 14.8 20.7 33.5 22.4 54H335.3zM296 160.3c20.5 1.7 39.2 9.8 54 22.4l-34.2 34.2c-5.8-4.1-12.5-7-19.8-8.2V160.3zm-16 48.3c-7.3 1.2-14 4.1-19.8 8.2L226 182.7c14.8-12.5 33.5-20.7 54-22.4v48.3zm-31.1 19.5c-4.1 5.8-7 12.5-8.2 19.8H192.3c1.7-20.5 9.8-39.2 22.4-54l34.2 34.2zm0 55.6L214.7 318c-12.5-14.8-20.7-33.5-22.4-54h48.3c1.2 7.3 4.1 14 8.2 19.8zM288 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224z'
      
    ]
  };

  
    var faStarfighterAlt = faStarfighterTwinIonEngine;
  

  
  

  var faDiceSix = {
    prefix: 'fat',
    iconName: 'dice-six',
    icon: [
      448,
      512,
      [9861],
      'f526',
      
      'M384 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-32 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM304 160a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-32 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faStarfighterTwinIonEngineAdvanced = {
    prefix: 'fat',
    iconName: 'starfighter-twin-ion-engine-advanced',
    icon: [
      640,
      512,
      ["starfighter-alt-advanced"],
      'e28e',
      
      'M146.3 2.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L23 148.3c-4.5 4.5-7 10.6-7 17v41.2l165.2-30C208.8 128.3 260.6 96 320 96s111.2 32.3 138.8 80.4l165.2 30V165.3c0-6.4-2.5-12.5-7-17L482.3 13.7c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L628.3 137c7.5 7.5 11.7 17.7 11.7 28.3v44.1V216v80 6.7 44.1c0 10.6-4.2 20.8-11.7 28.3L493.7 509.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L617 363.7c4.5-4.5 7-10.6 7-17V305.6l-165.2 30C431.2 383.7 379.4 416 320 416s-111.2-32.3-138.8-80.4L16 305.6v41.2c0 6.4 2.5 12.5 7 17L157.7 498.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L11.7 375C4.2 367.5 0 357.4 0 346.7V302.7 296 216v-6.7V165.3c0-10.6 4.2-20.8 11.7-28.3L146.3 2.3zM467.6 194.2c8 19 12.4 39.9 12.4 61.8s-4.4 42.8-12.4 61.8L624 289.3V222.7L467.6 194.2zM16 289.3l156.4 28.4c-8-19-12.4-39.9-12.4-61.8s4.4-42.8 12.4-61.8L16 222.7v66.6zM464 256a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-113-7.9a32 32 0 1 0 -62 15.9 32 32 0 1 0 62-15.9zM272.7 264H224.3c1.7 20.5 9.8 39.2 22.4 54l34.2-34.2c-4.1-5.8-7-12.5-8.2-19.8zM312 351.7V303.3c-7.3-1.2-14-4.1-19.8-8.2L258 329.3c14.8 12.5 33.5 20.7 54 22.4zm70-22.4l-34.2-34.2c-5.8 4.1-12.5 7-19.8 8.2v48.3c20.5-1.7 39.2-9.8 54-22.4zM415.7 264H367.3c-1.2 7.3-4.1 14-8.2 19.8L393.3 318c12.5-14.8 20.7-33.5 22.4-54zm-22.4-70l-34.2 34.2c4.1 5.8 7 12.5 8.2 19.8h48.3c-1.7-20.5-9.8-39.2-22.4-54zM328 160.3v48.3c7.3 1.2 14 4.1 19.8 8.2L382 182.7c-14.8-12.5-33.5-20.7-54-22.4zm-70 22.4l34.2 34.2c5.8-4.1 12.5-7 19.8-8.2V160.3c-20.5 1.7-39.2 9.8-54 22.4zM224.3 248h48.3c1.2-7.3 4.1-14 8.2-19.8L246.7 194c-12.5 14.8-20.7 33.5-22.4 54zM320 144a112 112 0 1 1 0 224 112 112 0 1 1 0-224z'
      
    ]
  };

  
    var faStarfighterAltAdvanced = faStarfighterTwinIonEngineAdvanced;
  

  
  

  var faShieldVirus = {
    prefix: 'fat',
    iconName: 'shield-virus',
    icon: [
      512,
      512,
      [],
      'e06c',
      
      'M237.3 22.6c12-5.1 25.5-5.1 37.5 0l176.7 75c16.6 7.1 28.6 23.2 28.5 42.4c-.5 96.6-40.3 270.2-204.5 348.8c-12.3 5.9-26.7 5.9-39 0C72.3 410.1 32.5 236.5 32 139.9c-.1-19.1 11.9-35.3 28.5-42.4l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM248 119.1c0-4.4 3.6-8 8-8s8 3.6 8 8c0 37.5 45.3 56.3 71.9 29.8c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3C320.7 186.7 339.5 232 377 232c4.4 0 8 3.6 8 8s-3.6 8-8 8c-37.5 0-56.3 45.3-29.8 71.9c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0C309.4 304.7 264 323.5 264 361c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-37.5-45.3-56.3-71.9-29.8c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3c26.5-26.5 7.7-71.9-29.8-71.9c-4.4 0-8-3.6-8-8s3.6-8 8-8c37.5 0 56.3-45.3 29.8-71.9c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0c26.5 26.5 71.9 7.7 71.9-29.8zm8-24c-13.3 0-24 10.7-24 24c0 23.2-28.1 34.9-44.5 18.4c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c16.4 16.4 4.8 44.5-18.4 44.5c-13.3 0-24 10.7-24 24s10.7 24 24 24c23.2 0 34.9 28.1 18.4 44.5c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0c16.4-16.4 44.5-4.8 44.5 18.4c0 13.3 10.7 24 24 24s24-10.7 24-24c0-23.2 28.1-34.9 44.5-18.4c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9C342.1 292.1 353.7 264 377 264c13.3 0 24-10.7 24-24s-10.7-24-24-24c-23.2 0-34.9-28.1-18.4-44.5c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0C308.1 154 280 142.3 280 119.1c0-13.3-10.7-24-24-24zM224 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faConveyorBeltBoxes = {
    prefix: 'fat',
    iconName: 'conveyor-belt-boxes',
    icon: [
      640,
      512,
      ["conveyor-belt-alt"],
      'f46f',
      
      'M304 16c17.7 0 32 14.3 32 32V240c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V48c0-17.7 14.3-32 32-32H304zM112 0C85.5 0 64 21.5 64 48V240c0 26.5 21.5 48 48 48H304c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H112zM528 80c17.7 0 32 14.3 32 32V240c0 17.7-14.3 32-32 32H432c-17.7 0-32-14.3-32-32V112c0-17.7 14.3-32 32-32h96zM432 64c-26.5 0-48 21.5-48 48V240c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H432zM544 336c44.2 0 80 35.8 80 80s-35.8 80-80 80H96c-44.2 0-80-35.8-80-80s35.8-80 80-80H544zM96 320c-53 0-96 43-96 96s43 96 96 96H544c53 0 96-43 96-96s-43-96-96-96H96zm16 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm176-48a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  
    var faConveyorBeltAlt = faConveyorBeltBoxes;
  

  
  

  var faLaptopMobile = {
    prefix: 'fat',
    iconName: 'laptop-mobile',
    icon: [
      640,
      512,
      ["phone-laptop"],
      'f87a',
      
      'M128 16H448c26.5 0 48 21.5 48 48V96h16V64c0-35.3-28.7-64-64-64H128C92.7 0 64 28.7 64 64V288H19.2C8.6 288 0 296.6 0 307.2C0 349.6 34.4 384 76.8 384H352V368H76.8C43.2 368 16 340.8 16 307.2c0-1.8 1.4-3.2 3.2-3.2H64 80 352V288H80V64c0-26.5 21.5-48 48-48zM400 176c0-17.7 14.3-32 32-32H592c17.7 0 32 14.3 32 32V464c0 17.7-14.3 32-32 32H432c-17.7 0-32-14.3-32-32V176zm-16 0V464c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H432c-26.5 0-48 21.5-48 48z'
      
    ]
  };

  
    var faPhoneLaptop = faLaptopMobile;
  

  
  

  var faDoorClosed = {
    prefix: 'fat',
    iconName: 'door-closed',
    icon: [
      576,
      512,
      [128682],
      'f52a',
      
      'M416 16c26.5 0 48 21.5 48 48V496H112V64c0-26.5 21.5-48 48-48H416zM96 64V496H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H96h16H464h16 88c4.4 0 8-3.6 8-8s-3.6-8-8-8H480V64c0-35.3-28.7-64-64-64H160C124.7 0 96 28.7 96 64zM408 256a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-24-40a40 40 0 1 0 0 80 40 40 0 1 0 0-80z'
      
    ]
  };

  

  
  

  var faDialLow = {
    prefix: 'fat',
    iconName: 'dial-low',
    icon: [
      576,
      512,
      [],
      'e15d',
      
      'M272 32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM288 432c-76.8 0-139.6-60.2-143.8-136H288c4.4 0 8-3.6 8-8s-3.6-8-8-8H144.2c4.2-75.8 66.9-136 143.8-136c79.5 0 144 64.5 144 144s-64.5 144-144 144zM128 288a160 160 0 1 0 320 0 160 160 0 1 0 -320 0zm416-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM16 288a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0A32 32 0 1 0 0 288a32 32 0 1 0 64 0zM96 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM464 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 464a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm368-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faOctagonExclamation = {
    prefix: 'fat',
    iconName: 'octagon-exclamation',
    icon: [
      512,
      512,
      [],
      'e204',
      
      'M191.5 16.1c-14.9 0-29.1 5.9-39.6 16.4L32.5 151.9C22 162.4 16.1 176.7 16.1 191.5v129c0 14.9 5.9 29.1 16.4 39.6L151.9 479.5c10.5 10.5 24.7 16.4 39.6 16.4h129c14.9 0 29.1-5.9 39.6-16.4L479.5 360.1c10.5-10.5 16.4-24.7 16.4-39.6v-129c0-14.9-5.9-29.1-16.4-39.6L360.1 32.5C349.6 22 335.3 16.1 320.5 16.1h-129zm-50.9 5.1C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM256 128c4.4 0 8 3.6 8 8V296c0 4.4-3.6 8-8 8s-8-3.6-8-8V136c0-4.4 3.6-8 8-8zM240 352a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faArrowUp19 = {
    prefix: 'fat',
    iconName: 'arrow-up-1-9',
    icon: [
      576,
      512,
      ["sort-numeric-up"],
      'f163',
      
      'M436.4 33.3c2.2 1.5 3.6 4 3.6 6.7V208h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H432 376c-4.4 0-8-3.6-8-8s3.6-8 8-8h48V52.1L379.2 71.4c-4.1 1.7-8.8-.1-10.5-4.2s.1-8.8 4.2-10.5l56-24c2.5-1.1 5.3-.8 7.6 .7zm-282.1 1c3.1-3.1 8.2-3.1 11.3 0l112 112c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L168 59.3V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V59.3L53.7 157.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l112-112zM428 272a68 68 0 1 0 -.1 136.1A68 68 0 1 0 428 272zm0 152c-46.4 0-84-37.6-84-84s37.6-84 84-84c45 0 81.8 35.5 83.9 80h.1c0 .7 0 1.4 0 2.1c0 .6 0 1.3 0 1.9c0 13.9-3.4 27.1-9.4 38.7c-4 8.6-9.2 16.7-15.6 24l-65 74.6c-2.9 3.3-8 3.7-11.3 .8s-3.7-8-.8-11.3l39.7-45.6c-6.9 1.8-14.2 2.8-21.7 2.8z'
      
    ]
  };

  
    var faSortNumericUp = faArrowUp19;
  

  
  

  var faPipeCircleCheck = {
    prefix: 'fat',
    iconName: 'pipe-circle-check',
    icon: [
      640,
      512,
      [],
      'e436',
      
      'M48 384c0 8.8-7.2 16-16 16s-16-7.2-16-16V128c0-8.8 7.2-16 16-16s16 7.2 16 16V384zM32 96C14.3 96 0 110.3 0 128V384c0 17.7 14.3 32 32 32s32-14.3 32-32H320.7c-.5-5.3-.7-10.6-.7-16H64V144H448v54.6c5.2-1.5 10.6-2.7 16-3.7V128c0-8.8 7.2-16 16-16s16 7.2 16 16v64c5.4 0 10.7 .2 16 .7V128c0-17.7-14.3-32-32-32s-32 14.3-32 32L64 128c0-17.7-14.3-32-32-32zM496 240a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm69.7-189.7c-3.1-3.1-8.2-3.1-11.3 0L480 396.7l-42.3-42.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l48 48c3.1 3.1 8.2 3.1 11.3 0l80-80c3.1-3.1 3.1-8.2 0-11.3z'
      
    ]
  };

  

  
  

  var faUserGear = {
    prefix: 'fat',
    iconName: 'user-gear',
    icon: [
      640,
      512,
      ["user-cog"],
      'f4fe',
      
      'M336 128a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM16 482.3c0 7.6 6.1 13.7 13.7 13.7H405.1c1.3 5.7 3.5 11.1 6.7 16H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304h91.4c11.8 0 23.4 1.2 34.5 3.3c-.7 5.7-.2 11.3 1.2 16.6c-11.5-2.6-23.5-3.9-35.7-3.9H178.3C88.7 320 16 392.7 16 482.3zM452 218.5v17.8c0 13.9-8.4 25.7-19.6 32.1c-11.1 6.3-25.3 7.7-37.3 .8l-13.9-8c-6.4 7-12.2 14.9-17.2 23.5s-8.9 17.5-11.8 26.6l14.3 8.3c11.8 6.8 17.3 19.6 17.3 32c0 12.4-5.5 25.2-17.3 32l-14.3 8.2c2.9 9.1 6.8 18 11.8 26.6s10.8 16.5 17.2 23.5l13.9-8c11.9-6.9 26.2-5.5 37.3 .8c11.2 6.4 19.6 18.1 19.6 32.1v17.8c9 2 18.4 3 28.1 3s19-1 28.1-3l0-18.1c0-13.8 8.3-25.5 19.4-31.8c11-6.3 25.2-7.7 37.1-.8l14.1 8.2c6.4-7 12.2-14.9 17.2-23.5c5-8.6 8.9-17.5 11.8-26.6l-14.6-8.4c-11.8-6.8-17.2-19.5-17.2-31.8s5.5-25 17.2-31.8l14.6-8.4c-2.9-9.1-6.8-18-11.8-26.6c-5-8.6-10.8-16.5-17.2-23.5l-14.1 8.1c-11.9 6.9-26.1 5.5-37.1-.8c-11.1-6.4-19.4-18-19.4-31.8V218.5c-9-2-18.4-3-28.1-3s-19 1-28.1 3zm-4.7-15.4c10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.7 1.5 11.3 7.7 11.3 14.8v18.7c0 7.1 4.3 13.9 11.4 18c7 4 15.1 4.4 21.2 .8l14.6-8.4c6.1-3.5 13.8-2.6 18.5 2.4c7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2 6.6-1 13.7-7.2 17.2l-15.1 8.7c-5.8 3.3-9.2 10.1-9.2 18s3.5 14.6 9.2 18l15.1 8.7c6.1 3.5 9.2 10.6 7.2 17.2c-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.7 5.1-12.4 5.9-18.5 2.4l-14.6-8.4c-6.1-3.5-14.2-3.2-21.2 .8c-7 4-11.4 10.9-11.4 18V485c0 7.1-4.6 13.3-11.3 14.8c-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.7-1.5-11.3-7.7-11.3-14.8V466.7c0-7.2-4.4-14.1-11.5-18.2c-7.1-4-15.2-4.4-21.3-.8L388.8 456c-6.1 3.5-13.8 2.6-18.5-2.4c-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2-6.6 1-13.7 7.2-17.2l14.8-8.5c5.8-3.4 9.3-10.2 9.3-18.2c0-8-3.5-14.8-9.3-18.1l-14.8-8.5c-6.1-3.5-9.2-10.6-7.2-17.2c3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.7-5.1 12.4-5.9 18.5-2.4l14.4 8.3c6.2 3.6 14.3 3.2 21.4-.8c7.1-4.1 11.5-11 11.5-18.2V218c0-7.1 4.6-13.3 11.3-14.8zM480 383.7a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  
    var faUserCog = faUserGear;
  

  
  

  var faPuzzle = {
    prefix: 'fat',
    iconName: 'puzzle',
    icon: [
      512,
      512,
      [],
      'e443',
      
      'M304 24c0-4.4 3.6-8 8-8H456c22.1 0 40 17.9 40 40V176c0 4.4-3.6 8-8 8H424c-4.4 0-8 3.6-8 8v24c0 13.3-10.7 24-24 24s-24-10.7-24-24V192c0-4.4-3.6-8-8-8H312c-4.4 0-8-3.6-8-8V152c0-4.4 3.6-8 8-8h16c22.1 0 40-17.9 40-40s-17.9-40-40-40H312c-4.4 0-8-3.6-8-8V24zm8-24c-13.3 0-24 10.7-24 24V56c0 13.3 10.7 24 24 24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H312c-13.3 0-24 10.7-24 24v24c0 13.3 10.7 24 24 24h40v16c0 22.1 17.9 40 40 40s40-17.9 40-40V200h56c13.3 0 24-10.7 24-24V56c0-30.9-25.1-56-56-56H312zM56 64C25.1 64 0 89.1 0 120V288 456c0 30.9 25.1 56 56 56H224 392c30.9 0 56-25.1 56-56V304c0-13.3-10.7-24-24-24H368c-13.3 0-24 10.7-24 24v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V304c0-13.3-10.7-24-24-24H232V88c0-13.3-10.7-24-24-24H56zM216 88V280H176c-4.4 0-8-3.6-8-8V256c0-22.1-17.9-40-40-40s-40 17.9-40 40v16c0 4.4-3.6 8-8 8H16V120c0-22.1 17.9-40 40-40H208c4.4 0 8 3.6 8 8zM80 296c13.3 0 24-10.7 24-24V256c0-13.3 10.7-24 24-24s24 10.7 24 24v16c0 13.3 10.7 24 24 24h40v40c0 4.4-3.6 8-8 8H192c-22.1 0-40 17.9-40 40s17.9 40 40 40h16c4.4 0 8 3.6 8 8v64H56c-22.1 0-40-17.9-40-40V296H80zM232 432c0-13.3-10.7-24-24-24H192c-13.3 0-24-10.7-24-24s10.7-24 24-24h16c13.3 0 24-10.7 24-24V296h40c4.4 0 8 3.6 8 8v16c0 22.1 17.9 40 40 40s40-17.9 40-40V304c0-4.4 3.6-8 8-8h56c4.4 0 8 3.6 8 8V456c0 22.1-17.9 40-40 40H232V432z'
      
    ]
  };

  

  
  

  var faSquareHeart = {
    prefix: 'fat',
    iconName: 'square-heart',
    icon: [
      448,
      512,
      [128159,"heart-square"],
      'f4c8',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 78.9l17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L246.5 368.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L99.9 264.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18zm5.7 17c-3.1 3.2-8.3 3.2-11.4 0l-23.4-23.8c-23.1-23.5-60.5-23.5-83.6 0c-23.2 23.6-23.2 61.9 0 85.5L212.9 356.9c3.1 3.1 7.1 4.7 11.1 4.7s8-1.5 11.1-4.7L336.7 253.7c23.2-23.6 23.2-61.9 0-85.5c-23.1-23.5-60.5-23.5-83.6 0l-23.4 23.8z'
      
    ]
  };

  
    var faHeartSquare = faSquareHeart;
  

  
  

  var faSquare5 = {
    prefix: 'fat',
    iconName: 'square-5',
    icon: [
      448,
      512,
      [],
      'e25a',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm168 32H296c4.4 0 8 3.6 8 8s-3.6 8-8 8H174.4l-20.5 88.9 101.5 9.3c36.6 3.3 64.6 34 64.6 70.8c0 39.3-31.8 71.1-71.1 71.1H195.9c-26.7 0-51.7-13.4-66.5-35.5l13.3-8.9c11.9 17.7 31.9 28.5 53.2 28.5h53.1c30.4 0 55.1-24.7 55.1-55.1c0-28.5-21.7-52.3-50.1-54.9L143.3 248c-2.3-.2-4.4-1.4-5.8-3.3s-1.8-4.2-1.3-6.5l24-104c.8-3.6 4.1-6.2 7.8-6.2z'
      
    ]
  };

  

  
  

  var faHouseBlank = {
    prefix: 'fat',
    iconName: 'house-blank',
    icon: [
      576,
      512,
      ["home-blank"],
      'e487',
      
      'M282.7 2c3-2.7 7.6-2.7 10.6 0l280 248c3.3 2.9 3.6 8 .7 11.3s-8 3.6-11.3 .7L512 217.1V448c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V217.1L13.3 262c-3.3 2.9-8.4 2.6-11.3-.7S-.6 252.9 2.7 250L282.7 2zM80 202.9V448c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V202.9L288 18.7 80 202.9z'
      
    ]
  };

  
    var faHomeBlank = faHouseBlank;
  

  
  

  var faLightbulbSlash = {
    prefix: 'fat',
    iconName: 'lightbulb-slash',
    icon: [
      640,
      512,
      [],
      'f673',
      
      'M451.5 267.2c-2.1 3.1-4.3 6.2-6.6 9.3l12.6 9.9c2.4-3.4 4.8-6.7 7.2-10.1c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0C263.5 0 213.1 26.7 180.9 68.1L193.5 78c29.3-37.7 75-62 126.5-62c88.4 0 160 71.6 160 160c0 33.9-10.5 65.3-28.5 91.2zM228.7 105.8l12.6 9.9C257.3 94 283 80 312 80c4.4 0 8-3.6 8-8s-3.6-8-8-8c-34.1 0-64.4 16.4-83.3 41.8zM399.7 424.3L389.2 416H250.7c-5.9 0-10.7 4.8-10.7 10.7V432c0 44.2 35.8 80 80 80s80-35.8 80-80v-5.3c0-.8-.1-1.6-.3-2.4zM152 228.8c5.4 17.1 13.3 33.1 23.3 47.6c5 7.2 10.2 14.3 15.4 21.4l0 0 0 0 0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5h16.2c-2.4-14.4-6.6-28.7-14-42.2c-10.4-19-23.7-37.3-36.3-54.4l0 0 0 0 0 0 0 0c-5-6.9-10-13.7-14.5-20.2c-4.1-5.8-7.7-12-11-18.3L152 228.8zM256 432H384c0 35.3-28.7 64-64 64s-64-28.7-64-64zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  

  
  

  var faBooksMedical = {
    prefix: 'fat',
    iconName: 'books-medical',
    icon: [
      576,
      512,
      [],
      'f7e8',
      
      'M192 464c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V416H192v48zm-32 48c16.7 0 31.4-8.5 40-21.5c8.6 12.9 23.3 21.5 40 21.5h48c26.5 0 48-21.5 48-48V416v-8-8V132.2l1.5 6 2 7.7 65.9 253.8 2 7.7 18 69.2c6.6 25.5 32 40.6 56.7 33.8l59.6-16.5c24.7-6.8 39.3-33 32.7-58.5l-16-61.5-2-7.7L490.6 112.4l-2-7.7-18-69.2C464 9.9 438.6-5.2 413.9 1.6L354.3 18.1c-8.4 2.3-15.7 6.9-21.4 13C326.1 12.9 308.6 0 288 0H240c-16.7 0-31.4 8.5-40 21.5C191.4 8.5 176.7 0 160 0H112C85.5 0 64 21.5 64 48V96v8 8H80h96 16v56h16V112H320V400H208V344H192v56H176 80 64v8 8 48c0 26.5 21.5 48 48 48h48zM336 64.8V63.6c.3-14 9.5-26.4 22.6-30l59.6-16.5c15.7-4.3 32.5 5.1 36.9 22.4l16 61.7L353 133.8 337.1 72.6c-.7-2.6-1-5.2-1.1-7.8zm-16-.6v0V96H208V48c0-17.7 14.3-32 32-32h48c17.7 0 32 14.3 32 32V64.2zM240 496c-17.7 0-32-14.3-32-32V416H320v48c0 17.7-14.3 32-32 32H240zM192 48V96H80V48c0-17.7 14.3-32 32-32h48c17.7 0 32 14.3 32 32zm283.2 68.7l63.9 246L420.8 395.3 357 149.3l118.2-32.7zM543 378.2l15.9 61.2c4.5 17.4-5.6 34.7-21.5 39.1l-59.6 16.5c-15.7 4.3-32.5-5.1-36.9-22.4l-16-61.7L543 378.2zM80 168c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H136c-4.4 0-8 3.6-8 8v56c0 4.4-3.6 8-8 8H88c-4.4 0-8-3.6-8-8V288c0-4.4-3.6-8-8-8H16c-4.4 0-8-3.6-8-8V240c0-4.4 3.6-8 8-8H72c4.4 0 8-3.6 8-8V168zm8-24c-13.3 0-24 10.7-24 24v48H16C2.7 216-8 226.7-8 240v32c0 13.3 10.7 24 24 24H64v48c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V296h48c13.3 0 24-10.7 24-24V240c0-13.3-10.7-24-24-24H144V168c0-13.3-10.7-24-24-24H88z'
      
    ]
  };

  

  
  

  var faKeyboardBrightness = {
    prefix: 'fat',
    iconName: 'keyboard-brightness',
    icon: [
      640,
      512,
      [],
      'e1c0',
      
      'M101.7 178.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l104 104c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-104-104zM312 240c0 4.4 3.6 8 8 8s8-3.6 8-8V96c0-4.4-3.6-8-8-8s-8 3.6-8 8V240zm122.3 42.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l104-104c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-104 104zM0 408c0 4.4 3.6 8 8 8H120c4.4 0 8-3.6 8-8s-3.6-8-8-8H8c-4.4 0-8 3.6-8 8zm200-8c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H200zm320 0c-4.4 0-8 3.6-8 8s3.6 8 8 8H632c4.4 0 8-3.6 8-8s-3.6-8-8-8H520z'
      
    ]
  };

  

  
  

  var faHeadSideVirus = {
    prefix: 'fat',
    iconName: 'head-side-virus',
    icon: [
      512,
      512,
      [],
      'e064',
      
      'M16 222.9C16 108.6 108.6 16 222.9 16h16.8c71.6 0 137.5 43.3 166.4 105c3.5 7.4 6.9 15.1 10.4 22.9c6.4 14.3 12.9 28.9 20.1 42.7c11.3 21.6 24.8 42.2 43.5 58.9l3.8 3.4c7.7 6.9 12.1 16.7 12.1 27c0 20-16.2 36.2-36.2 36.2H440c-4.4 0-8 3.6-8 8v72c0 22.1-17.9 40-40 40H312c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8s8-3.6 8-8V448h72c30.9 0 56-25.1 56-56V328h11.8c28.8 0 52.2-23.4 52.2-52.2c0-14.9-6.4-29.1-17.5-39l-3.8-3.4c-16.7-14.9-29.2-33.6-40-54.4c-7-13.4-13.1-27.1-19.3-41c-3.5-7.9-7.1-15.9-10.8-23.9C389.1 46.9 317.6 0 239.7 0H222.9C99.8 0 0 99.8 0 222.9c0 52.8 16.9 101.5 47.4 139.9C57.5 375.5 64 390.2 64 405.3V504c0 4.4 3.6 8 8 8s8-3.6 8-8V405.3c0-19.8-8.5-37.8-20.1-52.4C31.8 317.5 16 272.3 16 222.9zM216.2 87.1c0-4.3 3.5-7.8 7.8-7.8s7.8 3.5 7.8 7.8c0 37.6 45.5 56.5 72.1 29.9c3.1-3.1 8-3.1 11.1 0s3.1 8 0 11.1c-26.6 26.6-7.8 72.1 29.9 72.1c4.3 0 7.8 3.5 7.8 7.8s-3.5 7.8-7.8 7.8c-37.6 0-56.5 45.5-29.9 72.1c3.1 3.1 3.1 8 0 11.1s-8 3.1-11.1 0c-26.6-26.6-72.1-7.8-72.1 29.9c0 4.3-3.5 7.8-7.8 7.8s-7.8-3.5-7.8-7.8c0-37.6-45.5-56.5-72.1-29.9c-3.1 3.1-8 3.1-11.1 0s-3.1-8 0-11.1c26.6-26.6 7.8-72.1-29.9-72.1c-4.3 0-7.8-3.5-7.8-7.8s3.5-7.8 7.8-7.8c37.6 0 56.5-45.5 29.9-72.1c-3.1-3.1-3.1-8 0-11.1s8-3.1 11.1 0c26.6 26.6 72.1 7.8 72.1-29.9zM224 63.3c-13.2 0-23.8 10.7-23.8 23.8c0 23.4-28.3 35.1-44.8 18.6c-9.3-9.3-24.4-9.3-33.7 0s-9.3 24.4 0 33.7c16.5 16.5 4.8 44.8-18.6 44.8c-13.2 0-23.8 10.7-23.8 23.8s10.7 23.8 23.8 23.8c23.4 0 35.1 28.3 18.6 44.8c-9.3 9.3-9.3 24.4 0 33.7s24.4 9.3 33.7 0c16.5-16.5 44.8-4.8 44.8 18.6c0 13.2 10.7 23.8 23.8 23.8s23.8-10.7 23.8-23.8c0-23.4 28.3-35.1 44.8-18.6c9.3 9.3 24.4 9.3 33.7 0s9.3-24.4 0-33.7c-16.5-16.5-4.8-44.8 18.6-44.8c13.2 0 23.8-10.7 23.8-23.8s-10.7-23.8-23.8-23.8c-23.4 0-35.1-28.3-18.6-44.8c9.3-9.3 9.3-24.4 0-33.7s-24.4-9.3-33.7 0c-16.5 16.5-44.8 4.8-44.8-18.6c0-13.2-10.7-23.8-23.8-23.8zM192 192a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faRectangleCode = {
    prefix: 'fat',
    iconName: 'rectangle-code',
    icon: [
      512,
      512,
      [],
      'e322',
      
      'M448 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H448zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM298.3 170.3c-3.1 3.1-3.1 8.2 0 11.3L372.7 256l-74.3 74.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l80-80c3.1-3.1 3.1-8.2 0-11.3l-80-80c-3.1-3.1-8.2-3.1-11.3 0zm-84.7 11.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-80 80c-3.1 3.1-3.1 8.2 0 11.3l80 80c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L139.3 256l74.3-74.3z'
      
    ]
  };

  

  
  

  var faTrafficLightSlow = {
    prefix: 'fat',
    iconName: 'traffic-light-slow',
    icon: [
      320,
      512,
      [],
      'f639',
      
      'M256 16c26.5 0 48 21.5 48 48V352c0 79.5-64.5 144-144 144S16 431.5 16 352V64c0-26.5 21.5-48 48-48H256zM64 0C28.7 0 0 28.7 0 64V352c0 88.4 71.6 160 160 160s160-71.6 160-160V64c0-35.3-28.7-64-64-64H64zm96 432a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm0-96a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm40-80a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zm-96 0a56 56 0 1 0 112 0 56 56 0 1 0 -112 0zm56-96a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm0-96a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0 176a16 16 0 1 0 0 32 16 16 0 1 0 0-32z'
      
    ]
  };

  

  
  

  var faKiwiFruit = {
    prefix: 'fat',
    iconName: 'kiwi-fruit',
    icon: [
      448,
      512,
      [],
      'e30c',
      
      'M432 176c0-32.5-20.5-64.1-58.3-88.4C336.2 63.5 283.3 48 224 48S111.9 63.5 74.3 87.6C36.5 111.9 16 143.5 16 176s20.5 64.1 58.3 88.4C111.9 288.5 164.7 304 224 304s112.2-15.5 149.7-39.6C411.5 240.1 432 208.5 432 176zm16 0v80c0 123.7-100.3 224-224 224S0 379.7 0 256V176C0 96.5 100.3 32 224 32s224 64.5 224 144zm-16 53.5c-33.1 53-113.7 90.5-208 90.5s-174.9-37.4-208-90.5V256c0 114.9 93.1 208 208 208s208-93.1 208-208V229.5zM178.1 172.3c-1.8 1.9-2.1 3.1-2.1 3.7s.3 1.9 2.1 3.7c1.9 1.9 5 4 9.5 5.9c8.9 3.8 21.8 6.4 36.4 6.4s27.5-2.6 36.4-6.4c4.5-1.9 7.6-4 9.5-5.9c1.8-1.9 2.1-3.1 2.1-3.7s-.3-1.9-2.1-3.7c-1.9-1.9-5-4-9.5-5.9c-8.9-3.8-21.8-6.4-36.4-6.4s-27.5 2.6-36.4 6.4c-4.5 1.9-7.6 4-9.5 5.9zm3.2-20.6c11.3-4.9 26.5-7.7 42.7-7.7s31.4 2.8 42.7 7.7c5.7 2.4 10.8 5.5 14.5 9.4c3.8 3.9 6.7 8.9 6.7 15s-2.9 11.1-6.7 15c-3.8 3.8-8.9 6.9-14.5 9.4c-11.3 4.9-26.5 7.7-42.7 7.7s-31.4-2.8-42.7-7.7c-5.7-2.4-10.8-5.5-14.5-9.4c-3.8-3.9-6.7-8.9-6.7-15s2.9-11.1 6.7-15c3.8-3.8 8.9-6.9 14.5-9.4zM232 88v24c0 4.4-3.6 8-8 8s-8-3.6-8-8V88c0-4.4 3.6-8 8-8s8 3.6 8 8zm-82.3 18.3l16 16c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-16-16c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0zm160 0c3.1 3.1 3.1 8.2 0 11.3l-16 16c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l16-16c3.1-3.1 8.2-3.1 11.3 0zM96 168h32c4.4 0 8 3.6 8 8s-3.6 8-8 8H96c-4.4 0-8-3.6-8-8s3.6-8 8-8zm224 0h32c4.4 0 8 3.6 8 8s-3.6 8-8 8H320c-4.4 0-8-3.6-8-8s3.6-8 8-8zM165.7 229.7l-16 16c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l16-16c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3zm128-11.3l16 16c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-16-16c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0zM232 240v24c0 4.4-3.6 8-8 8s-8-3.6-8-8V240c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faPawClaws = {
    prefix: 'fat',
    iconName: 'paw-claws',
    icon: [
      512,
      512,
      [],
      'f702',
      
      'M179.6 23.2c4-2 5.6-6.8 3.6-10.7s-6.8-5.6-10.7-3.6C148.3 20.9 112 61.1 112 128h0c-.2 11.3 1.5 23.2 5.5 35.1c14.3 42.9 52.1 69.1 84.4 58.5s46.9-53.9 32.6-96.8S182.4 55.8 150.1 66.3c-4 1.3-7.8 3.1-11.2 5.4c11.3-26.6 28.9-42.7 40.7-48.6zM328.8 12.4c-2 4-.4 8.8 3.6 10.7c11.8 5.9 29.4 22 40.7 48.6c-3.5-2.3-7.2-4.1-11.2-5.4c-32.3-10.6-70.1 15.6-84.4 58.5s.3 86.2 32.6 96.8s70.1-15.6 84.4-58.5c4-11.9 5.7-23.9 5.5-35.1h0c0-66.9-36.3-107.1-60.4-119.2c-4-2-8.8-.4-10.7 3.6zM220.5 180.3c-4.7 13.9-13.3 22.8-23.6 26.2c-10.3 3.4-22.7 1.3-34.9-7.1s-23.2-22.7-29.4-41.2s-5.9-36.4-1.2-50.3c4.7-13.9 13.3-22.8 23.6-26.2c10.3-3.4 22.7-1.3 34.9 7.1s23.2 22.7 29.4 41.2s5.9 36.4 1.2 50.3zM95.6 277.6c-1.4 11.4-6.5 19.3-13.4 23.2c-6.9 4-16.4 4.5-27.2-.1s-21.7-13.9-29.6-27.4s-10.5-27.6-9.1-39c1.4-11.4 6.5-19.3 13.4-23.2c6.9-4 16.4-4.5 27.2 .1s21.7 13.9 29.6 27.4s10.5 27.6 9.1 39zm-5.5 37.1c24.5-14 29.1-51.7 10.2-84.1C81.6 198.2 46.5 183.3 22 197.2c10.4-34.7 31.9-55.2 45.5-62c4-2 5.6-6.8 3.6-10.7s-6.8-5.6-10.7-3.6C36.3 132.9 0 173.1 0 240H0c-.1 13.3 3.7 27.8 11.6 41.4c18.9 32.4 54 47.3 78.5 33.3zM256 272c33.5 0 121.3 30.7 171.8 166.8c2.9 7.7 4.2 16.2 4.2 24.9v4.4c0 15.4-12.5 27.9-27.9 27.9c-11.7 0-23.3-1.8-34.5-5.3l-80.2-25.1c-21.8-6.8-45.1-6.8-66.8 0l-80.2 25.1c-11.2 3.5-22.8 5.3-34.5 5.3C92.5 496 80 483.5 80 468.1v-4.4c0-8.8 1.3-17.2 4.2-24.9C134.7 302.7 222.5 272 256 272zm0-16c-41.3 0-134.4 35.9-186.8 177.2c-3.6 9.7-5.2 20.1-5.2 30.5v4.4c0 24.2 19.7 43.9 43.9 43.9c13.3 0 26.6-2 39.3-6L227.4 481c18.6-5.8 38.6-5.8 57.3 0L364.8 506c12.7 4 26 6 39.3 6c24.2 0 43.9-19.7 43.9-43.9v-4.4c0-10.4-1.6-20.7-5.2-30.5C390.4 291.9 297.3 256 256 256zm169.5-17.4c7.9-13.5 18.8-22.8 29.6-27.4s20.2-4 27.2-.1c6.9 4 12.1 11.8 13.4 23.2c1.4 11.4-1.2 25.5-9.1 39s-18.8 22.8-29.6 27.4s-20.2 4-27.2 .1c-6.9-4-12.1-11.8-13.4-23.2c-1.4-11.4 1.2-25.5 9.1-39zm-13.8-8c-18.9 32.4-14.3 70.1 10.2 84.1s59.7-.9 78.5-33.3c7.9-13.6 11.7-28.1 11.6-41.4h0c0-66.9-36.3-107.1-60.4-119.2c-4-2-8.8-.4-10.7 3.6s-.4 8.8 3.6 10.7c13.6 6.8 35.1 27.3 45.5 62c-24.5-13.9-59.5 1.1-78.3 33.4zm-119-100.7c6.2-18.5 17.2-32.8 29.4-41.2s24.5-10.5 34.9-7.1c10.3 3.4 18.9 12.3 23.6 26.2c4.7 13.9 5 31.9-1.2 50.3s-17.2 32.8-29.4 41.2s-24.5 10.5-34.9 7.1c-10.3-3.4-18.9-12.3-23.6-26.2c-4.7-13.9-5-31.9 1.2-50.3z'
      
    ]
  };

  

  
  

  var faBorderInner = {
    prefix: 'fat',
    iconName: 'border-inner',
    icon: [
      448,
      512,
      [],
      'f84e',
      
      'M216 472c0 4.4 3.6 8 8 8s8-3.6 8-8l0-208 208 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-208 0 0-208c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 208L8 248c-4.4 0-8 3.6-8 8s3.6 8 8 8l208 0 0 208zM32 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm384 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM32 368a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm384 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16-208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM32 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM432 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM48 64A16 16 0 1 0 16 64a16 16 0 1 0 32 0zm288 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM320 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM144 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM128 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faToothbrush = {
    prefix: 'fat',
    iconName: 'toothbrush',
    icon: [
      576,
      512,
      [129701],
      'f635',
      
      'M64 208c-26.5 0-48-21.5-48-48s21.5-48 48-48H288c20.2 0 35.1-7.8 44.3-21.7c8.3-12.5 10.5-28.2 11.3-41.4l0-.1c23.4 2.6 45.7 10.8 61.9 24C421.7 86 432 104.1 432 128c0 44.2-35.8 80-80 80H64zM0 160c0 35.3 28.7 64 64 64H352c53 0 96-43 96-96c0-58.5-51.6-89.9-104-95.2c-8.8-.9-15.8 6.4-16.4 15.2c-1.5 25.3-8.4 48-39.6 48H64C28.7 96 0 124.7 0 160zM64 264c0-4.4-3.6-8-8-8s-8 3.6-8 8V416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H568c4.4 0 8-3.6 8-8s-3.6-8-8-8H32c-8.8 0-16-7.2-16-16s7.2-16 16-16H56h64 64 64 64 64H568c4.4 0 8-3.6 8-8s-3.6-8-8-8H384V264c0-4.4-3.6-8-8-8s-8 3.6-8 8V416H320V264c0-4.4-3.6-8-8-8s-8 3.6-8 8V416H256V264c0-4.4-3.6-8-8-8s-8 3.6-8 8V416H192V264c0-4.4-3.6-8-8-8s-8 3.6-8 8V416H128V264c0-4.4-3.6-8-8-8s-8 3.6-8 8V416H64V264z'
      
    ]
  };

  

  
  

  var faCalendarCirclePlus = {
    prefix: 'fat',
    iconName: 'calendar-circle-plus',
    icon: [
      576,
      512,
      [],
      'e470',
      
      'M128 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H64C28.7 64 0 92.7 0 128v48 16V448c0 35.3 28.7 64 64 64H330.8c-6.9-4.9-13.5-10.2-19.6-16H64c-26.5 0-48-21.5-48-48V192H352h80 16V176 128c0-35.3-28.7-64-64-64H336V8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H128V8zM112 80v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80H320v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80h48c26.5 0 48 21.5 48 48v48H16V128c0-26.5 21.5-48 48-48h48zM304 368a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM440 296c0-4.4-3.6-8-8-8s-8 3.6-8 8v64H360c-4.4 0-8 3.6-8 8s3.6 8 8 8h64v64c0 4.4 3.6 8 8 8s8-3.6 8-8V376h64c4.4 0 8-3.6 8-8s-3.6-8-8-8H440V296z'
      
    ]
  };

  

  
  

  var faRampLoading = {
    prefix: 'fat',
    iconName: 'ramp-loading',
    icon: [
      448,
      512,
      [],
      'f4d4',
      
      'M96 16H352c26.5 0 48 21.5 48 48V387.8l16 29.3 0-1.1V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64V416l0 1.1 16-29.3V64c0-26.5 21.5-48 48-48zm67.1 272c-14.7 0-28.2 8.1-35.2 21L37.7 476.6c-8.6 16 3 35.4 21.1 35.4H389.2c18.2 0 29.7-19.4 21.1-35.4L320.1 309c-7-13-20.5-21-35.2-21H163.1zM142 316.6c4.2-7.8 12.3-12.6 21.1-12.6H284.9c8.8 0 16.9 4.8 21.1 12.6l90.2 167.6c2.9 5.3-1 11.8-7 11.8H58.8c-6.1 0-9.9-6.5-7-11.8L142 316.6z'
      
    ]
  };

  

  
  

  var faNarwhal = {
    prefix: 'fat',
    iconName: 'narwhal',
    icon: [
      640,
      512,
      [],
      'f6fe',
      
      'M639.7 10.2c1-3.6-.6-7.5-3.9-9.2s-7.4-1-9.9 1.9L490.5 162.1c-8.9-1.4-18.1-2.1-27.4-2.1c-50.9 0-100.7 17.5-140.2 49.6L154.1 346.8c-10.5 8.5-26.1 1.1-26.1-12.4V255.5l25.2-15.1c24.1-14.5 38.8-40.5 38.8-68.6l0-59.8c0-6-3.3-11.4-8.6-14.2s-11.7-2.3-16.6 1.1L96 148.5 25.2 98.9c-4.9-3.4-11.3-3.8-16.6-1.1S0 106 0 112l0 59.8c0 28.1 14.7 54.1 38.8 68.6L64 255.5V352c0 88.4 71.6 160 160 160H464c97.2 0 176-78.8 176-176c0-50.4-21.5-95.9-55.7-128L639.7 10.2zM570.9 196.6c-18.4-14.1-39.6-24.7-62.6-30.7L614.5 41 570.9 196.6zM96 168l9.2-6.4L176 112l0 59.8c0 22.5-11.8 43.3-31.1 54.9l-25.2 15.1-7.8 4.7v9.1 78.9c0 26.9 31.3 41.8 52.2 24.8L333 222c36.6-29.8 82.8-46 130.1-46C551.6 176 624 247.7 624 336c0 88.4-71.6 160-160 160H224c-79.5 0-144-64.5-144-144V255.5v-9.1l-7.8-4.7L47.1 226.6C27.8 215.1 16 194.2 16 171.8L16 112l70.8 49.6L96 168zM512 304a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faTableLayout = {
    prefix: 'fat',
    iconName: 'table-layout',
    icon: [
      512,
      512,
      [],
      'e290',
      
      'M16 96c0-26.5 21.5-48 48-48l384 0c26.5 0 48 21.5 48 48l0 64L16 160l0-64zm0 320l0-240 128 0 0 288-80 0c-26.5 0-48-21.5-48-48zm144 48l0-288 336 0 0 240c0 26.5-21.5 48-48 48l-288 0zM0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416z'
      
    ]
  };

  

  
  

  var faChildReaching = {
    prefix: 'fat',
    iconName: 'child-reaching',
    icon: [
      384,
      512,
      [],
      'e59d',
      
      'M192 16a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112A64 64 0 1 0 192 0a64 64 0 1 0 0 128zm0 48c-49.6 0-96.1-23.9-125-64.2L46.5 83.3c-2.6-3.6-7.6-4.4-11.2-1.8s-4.4 7.6-1.8 11.2L54 121.2C85.9 165.6 137.3 192 192 192s106.1-26.4 138-70.8l20.5-28.5c2.6-3.6 1.8-8.6-1.8-11.2s-8.6-1.8-11.2 1.8L317 111.8C288.1 152.1 241.6 176 192 176zm-64 56c0-4.4-3.6-8-8-8s-8 3.6-8 8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V400c0-8.8 7.2-16 16-16s16 7.2 16 16v80c0 17.7 14.3 32 32 32s32-14.3 32-32V232c0-4.4-3.6-8-8-8s-8 3.6-8 8V480c0 8.8-7.2 16-16 16s-16-7.2-16-16V400c0-17.7-14.3-32-32-32s-32 14.3-32 32v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V232z'
      
    ]
  };

  

  
  

  var faCalendarXmark = {
    prefix: 'fat',
    iconName: 'calendar-xmark',
    icon: [
      448,
      512,
      ["calendar-times"],
      'f273',
      
      'M120 0c4.4 0 8 3.6 8 8V64H320V8c0-4.4 3.6-8 8-8s8 3.6 8 8V64h48c35.3 0 64 28.7 64 64v48 16V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 176 128C0 92.7 28.7 64 64 64h48V8c0-4.4 3.6-8 8-8zM432 192H16V448c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V192zM112 120V80H64c-26.5 0-48 21.5-48 48v48H432V128c0-26.5-21.5-48-48-48H336v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V80H128v40c0 4.4-3.6 8-8 8s-8-3.6-8-8zM301.7 413.7c-3.1 3.1-8.2 3.1-11.3 0L224 347.3l-66.3 66.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L212.7 336l-66.3-66.3c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L224 324.7l66.3-66.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L235.3 336l66.3 66.3c3.1 3.1 3.1 8.2 0 11.3z'
      
    ]
  };

  
    var faCalendarTimes = faCalendarXmark;
  

  
  

  var faComputerMouseScrollwheel = {
    prefix: 'fat',
    iconName: 'computer-mouse-scrollwheel',
    icon: [
      384,
      512,
      ["mouse-alt"],
      'f8cd',
      
      'M368 352V160c0-79.5-64.5-144-144-144H160C80.5 16 16 80.5 16 160V352c0 79.5 64.5 144 144 144h64c79.5 0 144-64.5 144-144zM0 160C0 71.6 71.6 0 160 0h64c88.4 0 160 71.6 160 160V352c0 88.4-71.6 160-160 160H160C71.6 512 0 440.4 0 352V160zm208-32c0-8.8-7.2-16-16-16s-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V128zm-48 0c0-17.7 14.3-32 32-32s32 14.3 32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V128z'
      
    ]
  };

  
    var faMouseAlt = faComputerMouseScrollwheel;
  

  
  

  var faPhone = {
    prefix: 'fat',
    iconName: 'phone',
    icon: [
      512,
      512,
      [128222,128379],
      'f095',
      
      'M317.1 378.1c-4.7 5.7-12.6 7.5-19.2 4.3c-73.8-34.8-133.5-94.5-168.3-168.3c-3.1-6.6-1.3-14.6 4.3-19.2l49.3-40.4c8.2-6.7 11-18 7-27.8l-40-96c-4.6-11.1-16.8-17.1-28.5-13.9l-88 24C23.2 43.7 16 53.2 16 64c0 238.6 193.4 432 432 432c10.8 0 20.3-7.2 23.2-17.7l24-88c3.2-11.6-2.8-23.8-13.9-28.5l-96-40c-9.8-4.1-21.1-1.3-27.8 7l-40.4 49.3zM304.7 368L345 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512C200.6 512 0 311.4 0 64C0 46 12.1 30.2 29.5 25.4l88-24c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7z'
      
    ]
  };

  

  
  

  var faFaceGrinTears = {
    prefix: 'fat',
    iconName: 'face-grin-tears',
    icon: [
      640,
      512,
      [128514,"grin-tears"],
      'f588',
      
      'M88.1 194.1C115.4 91.5 208.9 16 320 16s204.6 75.5 231.9 178.1c1.1 4.3 5.5 6.8 9.8 5.7s6.8-5.5 5.7-9.8C538.3 80.6 438.6 0 320 0S101.7 80.6 72.6 189.9c-1.1 4.3 1.4 8.7 5.7 9.8s8.7-1.4 9.8-5.7zm26.3 185.8c-2.3-3.8-7.2-5-11-2.7s-5 7.2-2.7 11C145.5 462.3 226.9 512 320 512s174.5-49.7 219.3-123.9c2.3-3.8 1.1-8.7-2.7-11s-8.7-1.1-11 2.7C483.6 449.5 407.2 496 320 496s-163.6-46.5-205.6-116.1zm205.9-32.1c43 0 84.1-5.5 121.5-15.4c3.9-1 7.1 .3 8.7 1.8c.7 .7 .9 1.2 .9 1.4l0 0c0 .1 .1 .7-.5 1.9c-25 46.8-74.1 78.5-130.5 78.5s-105.5-31.7-130.5-78.5c-.7-1.2-.6-1.8-.5-1.9l0 0c0-.2 .2-.7 .9-1.4c1.6-1.5 4.8-2.8 8.7-1.8c37.4 9.9 78.4 15.4 121.5 15.4zm144.6-2.7c9.1-17-8.7-33.1-27.3-28.2c-36 9.6-75.6 14.9-117.3 14.9s-81.4-5.3-117.3-14.9c-18.6-4.9-36.4 11.2-27.3 28.2c27.7 51.8 82.1 86.9 144.6 86.9s116.9-35.2 144.6-86.9zm-250-159.4c7.6-11.6 16.1-17.7 24.9-17.7s17.3 6.1 24.9 17.7c7.4 11.4 12.7 26.3 15.2 39.8c.8 4.3 5 7.2 9.3 6.4s7.2-5 6.4-9.3c-2.8-15-8.7-32-17.6-45.6c-8.7-13.3-21.5-25-38.3-25s-29.6 11.7-38.3 25c-8.8 13.5-14.8 30.6-17.6 45.6c-.8 4.3 2 8.5 6.4 9.3s8.5-2 9.3-6.4c2.5-13.5 7.8-28.4 15.2-39.8zm144.8 39.8c2.5-13.5 7.8-28.4 15.2-39.8c7.6-11.6 16.1-17.7 24.9-17.7s17.3 6.1 24.9 17.7c7.4 11.4 12.7 26.3 15.2 39.8c.8 4.3 5 7.2 9.3 6.4s7.2-5 6.4-9.3c-2.8-15-8.7-32-17.6-45.6c-8.7-13.3-21.5-25-38.3-25s-29.6 11.7-38.3 25c-8.8 13.5-14.8 30.6-17.6 45.6c-.8 4.3 2 8.5 6.4 9.3s8.5-2 9.3-6.4zm169.1 15.3c12.6 1.5 29.4 4 45.3 7.6c9.6 2.2 18.5 4.6 25.8 7.4c7.6 2.9 11.9 5.6 13.6 7.3c14.4 14.4 14.6 40.8-3.5 58.9s-44.5 17.9-58.9 3.5c-1.7-1.7-4.4-5.9-7.3-13.6c-2.8-7.3-5.3-16.2-7.4-25.8c-3.6-15.9-6-32.8-7.6-45.3zm-16.7-5.4c2.9 26 11.1 84.8 27.7 101.4c21.6 21.6 58.1 19.9 81.5-3.5s25.1-60 3.5-81.5c-16.6-16.6-75.3-24.9-101.4-27.7c-6.5-.8-12.1 4.9-11.3 11.3zM103.6 286.1c-2.2 9.6-4.6 18.5-7.4 25.8c-2.9 7.7-5.6 11.9-7.3 13.6C74.5 339.9 48.1 340.1 30 322s-17.9-44.5-3.5-58.9c1.7-1.7 5.9-4.4 13.6-7.3c7.3-2.8 16.2-5.3 25.8-7.4c15.9-3.6 32.8-6.1 45.3-7.6c-1.5 12.6-4 29.4-7.6 45.3zm-3.4 50.7c16.6-16.6 24.8-75.4 27.7-101.4c.8-6.5-4.9-12.1-11.3-11.3c-26.1 2.8-84.8 11.1-101.4 27.7c-21.6 21.6-19.9 58.1 3.5 81.5s60 25.1 81.5 3.5z'
      
    ]
  };

  
    var faGrinTears = faFaceGrinTears;
  

  
  

  var faSpinnerThird = {
    prefix: 'fat',
    iconName: 'spinner-third',
    icon: [
      512,
      512,
      [],
      'f3f4',
      
      'M470.8 380c3.8 2.2 8.7 .9 10.8-3C501 341 512 299.8 512 256C512 117.3 401.7 4.4 264 .1c-4.4-.1-8 3.5-8 7.9s3.6 8 8 8.1c128.8 4.2 232 110 232 239.9c0 40.9-10.2 79.3-28.2 113c-2.1 3.9-.8 8.8 3 11z'
      
    ]
  };

  

  
  

  var faLungsVirus = {
    prefix: 'fat',
    iconName: 'lungs-virus',
    icon: [
      640,
      512,
      [],
      'e067',
      
      'M320 0c4.4 0 8 3.6 8 8v8V144.7c-2.6-.4-5.3-.7-8-.7s-5.4 .2-8 .7V16 8c0-4.4 3.6-8 8-8zM256 165.3v24.1c-5-3.3-10.4-5.6-16-6.8V165.3c0-29.5-23.9-53.3-53.3-53.3c-16.8 0-32.8 7.9-42.6 22c-15.2 21.7-43.6 64.5-70 115.1C47.9 299.5 23 359 16.1 414c-.1 .7-.1 1.3-.1 2v7c0 40.3 32.7 73 73 73c6 0 11.9-.7 17.7-2.2l72.7-18.2c13.7-3.4 25.8-10.2 35.5-19.4c6.4 2.1 13.2 2.7 19.9 2c-12.8 15.9-30.6 27.7-51.5 32.9l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7c-49.1 0-89-39.8-89-89v-7c0-1.3 .1-2.7 .2-4c7.2-57.9 33.1-119.4 59.6-170.3c26.8-51.5 55.6-94.8 71-116.9c13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3zM460.6 475.6l72.7 18.2c5.8 1.4 11.7 2.2 17.7 2.2c40.3 0 73-32.7 73-73v-7c0-.7 0-1.3-.1-2c-6.9-55-31.7-114.5-57.9-164.9c-26.4-50.6-54.8-93.4-70-115.1c-9.8-14.1-25.9-22-42.6-22c-29.5 0-53.3 23.9-53.3 53.3v17.3c-5.6 1.3-11 3.5-16 6.8V165.3C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8c15.4 22.1 44.3 65.4 71 116.9c26.5 50.9 52.4 112.5 59.6 170.3c.2 1.3 .2 2.6 .2 4v7c0 49.1-39.8 89-89 89c-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2c-20.9-5.2-38.7-17.1-51.5-32.9c6.7 .7 13.5 .1 19.9-2c9.7 9.2 21.8 16 35.5 19.4zM312 199.1c0 37.5-45.3 56.3-71.9 29.8c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3c26.5 26.5 7.7 71.9-29.8 71.9c-4.4 0-8 3.6-8 8s3.6 8 8 8c37.5 0 56.3 45.3 29.8 71.9c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0c26.5-26.5 71.9-7.7 71.9 29.8c0 4.4 3.6 8 8 8s8-3.6 8-8c0-37.5 45.3-56.3 71.9-29.8c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3C384.7 373.4 403.5 328 441 328c4.4 0 8-3.6 8-8s-3.6-8-8-8c-37.5 0-56.3-45.3-29.8-71.9c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0c-26.5 26.5-71.9 7.7-71.9-29.8c0-4.4-3.6-8-8-8s-8 3.6-8 8zm8-24c13.3 0 24 10.7 24 24c0 23.2 28.1 34.9 44.5 18.4c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9C406.1 267.9 417.7 296 441 296c13.3 0 24 10.7 24 24s-10.7 24-24 24c-23.2 0-34.9 28.1-18.4 44.5c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0C372.1 406.1 344 417.7 344 441c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-23.2-28.1-34.9-44.5-18.4c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c16.4-16.4 4.8-44.5-18.4-44.5c-13.3 0-24-10.7-24-24s10.7-24 24-24c23.2 0 34.9-28.1 18.4-44.5c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0c16.4 16.4 44.5 4.8 44.5-18.4c0-13.3 10.7-24 24-24zM288 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faUsersBetweenLines = {
    prefix: 'fat',
    iconName: 'users-between-lines',
    icon: [
      640,
      512,
      [],
      'e591',
      
      'M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8H632c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zM8 496c-4.4 0-8 3.6-8 8s3.6 8 8 8H632c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zM449.6 384c0 8.8-7.2 16-16 16h-224c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80h96c44.2 0 80 35.8 80 80zm-176-96c-53 0-96 43-96 96c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32c0-53-43-96-96-96h-96zm-16-112a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm144 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM147.2 112a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM48 320c0-26.5 21.5-48 48-48h96c4.8 0 9.4 .7 13.7 2c4.2 1.3 8.7-1.2 9.9-5.4s-1.2-8.7-5.4-9.9c-5.8-1.7-11.9-2.7-18.3-2.7H96c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32h88c4.4 0 8-3.6 8-8s-3.6-8-8-8H64c-8.8 0-16-7.2-16-16zM496 112a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm99.2 96c0 8.8-7.2 16-16 16h-88c-4.4 0-8 3.6-8 8s3.6 8 8 8h88c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64h-96c-6.3 0-12.5 .9-18.3 2.7c-4.2 1.3-6.6 5.7-5.4 9.9s5.7 6.6 9.9 5.4c4.3-1.3 8.9-2 13.7-2h96c26.5 0 48 21.5 48 48z'
      
    ]
  };

  

  
  

  var faChildDress = {
    prefix: 'fat',
    iconName: 'child-dress',
    icon: [
      320,
      512,
      [],
      'e59c',
      
      'M160 112a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM160 0a64 64 0 1 1 0 128A64 64 0 1 1 160 0zM107.4 248.8c4 1.9 5.7 6.6 3.8 10.6L52.6 384H88h48 48 48 35.4L208.8 259.4c-1.9-4-.2-8.8 3.8-10.6s8.8-.2 10.6 3.8l64 136c1.2 2.5 1 5.4-.5 7.7s-4 3.7-6.8 3.7H240v80c0 17.7-14.3 32-32 32s-32-14.3-32-32V400H144v80c0 17.7-14.3 32-32 32s-32-14.3-32-32V400H40c-2.7 0-5.3-1.4-6.8-3.7s-1.7-5.2-.5-7.7l64-136c1.9-4 6.6-5.7 10.6-3.8zM96 400v80c0 8.8 7.2 16 16 16s16-7.2 16-16V400H96zm96 80c0 8.8 7.2 16 16 16s16-7.2 16-16V400H192v80zM90.3 215.4L30.9 316.1c-2.2 3.8-7.1 5.1-11 2.8s-5.1-7.1-2.8-11L76.5 207.2C93.8 178 125.2 160 159.2 160h1.6c34 0 65.4 18 82.7 47.2l59.4 100.7c2.2 3.8 1 8.7-2.8 11s-8.7 1-11-2.8L229.7 215.4C215.3 191 189.1 176 160.8 176h-1.6c-28.3 0-54.5 15-68.9 39.4z'
      
    ]
  };

  

  
  

  var faCardClub = {
    prefix: 'fat',
    iconName: 'card-club',
    icon: [
      384,
      512,
      [],
      'e3e9',
      
      'M320 16c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H320zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM200 326.6c10.2 6 22.1 9.4 34.9 9.4c38.2 0 69.1-30.9 69.1-69.1c0-29-17.8-53.8-43.1-64c.2-1.9 .2-3.8 .2-5.8c0-38.2-30.9-69.1-69.1-69.1s-69.1 30.9-69.1 69.1c0 1.9 .1 3.9 .2 5.8C97.8 213.1 80 237.9 80 266.9c0 38.2 30.9 69.1 69.1 69.1c12.7 0 24.7-3.4 34.9-9.5V368H160c-4.4 0-8 3.6-8 8s3.6 8 8 8h64c4.4 0 8-3.6 8-8s-3.6-8-8-8H200V326.6zM138.9 197.1c0-29.3 23.8-53.1 53.1-53.1s53.1 23.8 53.1 53.1c0 3.3-.3 6.6-.9 9.7c-.7 4 1.7 8 5.6 9.1c22.1 6.5 38.1 26.8 38.1 51c0 29.3-23.8 53.1-53.1 53.1c-14.5 0-27.7-5.8-37.3-15.3c-3.1-3.1-8.1-3.1-11.2 0c-9.6 9.5-22.7 15.3-37.3 15.3C119.8 320 96 296.2 96 266.9c0-24.1 16.1-44.5 38.1-51c3.9-1.2 6.4-5.1 5.6-9.1c-.6-3.1-.9-6.4-.9-9.7z'
      
    ]
  };

  

  
  

  var faRulerTriangle = {
    prefix: 'fat',
    iconName: 'ruler-triangle',
    icon: [
      512,
      512,
      [128208],
      'f61c',
      
      'M16 45.3V448c0 26.5 21.5 48 48 48H466.7c16.2 0 29.3-13.1 29.3-29.3c0-7.8-3.1-15.2-8.6-20.7L442.3 401l-28.7 28.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L431 389.7 362.3 321l-28.7 28.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L351 309.7 282.3 241l-28.7 28.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L271 229.7 202.3 161l-28.7 28.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L191 149.7 122.3 81 93.7 109.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L111 69.7 65.9 24.6C60.5 19.1 53 16 45.3 16C29.1 16 16 29.1 16 45.3zM0 448V45.3C0 20.3 20.3 0 45.3 0c12 0 23.5 4.8 32 13.3L498.7 434.7c8.5 8.5 13.3 20 13.3 32c0 25-20.3 45.3-45.3 45.3H64c-35.3 0-64-28.7-64-64zM124.9 248.6c3-1.2 6.4-.6 8.7 1.7l128 128c2.3 2.3 3 5.7 1.7 8.7s-4.2 4.9-7.4 4.9H128c-4.4 0-8-3.6-8-8V256c0-3.2 1.9-6.2 4.9-7.4zM136 275.3V376H236.7L136 275.3z'
      
    ]
  };

  

  
  

  var faHousePersonLeave = {
    prefix: 'fat',
    iconName: 'house-person-leave',
    icon: [
      640,
      512,
      ["house-leave","house-person-depart"],
      'e00f',
      
      'M245.2 1.9c-3-2.6-7.4-2.6-10.4 0l-232 200c-3.3 2.9-3.7 7.9-.8 11.3s7.9 3.7 11.3 .8L64 170.3V360c0 30.9 25.1 56 56 56H314.2l16-16H120c-22.1 0-40-17.9-40-40V156.5L240 18.6 370.9 131.4c4.5-3.2 9.2-6.2 14.1-9L245.2 1.9zM224 184c4.4 0 8 3.6 8 8v64c0 4.4-3.6 8-8 8H160c-4.4 0-8-3.6-8-8V192c0-4.4 3.6-8 8-8h64zm-64-16c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24h64c13.3 0 24-10.7 24-24V192c0-13.3-10.7-24-24-24H160zm297.1 19.3c-4.6-4-11-5.1-16.6-2.8c-1.1 .5-2.2 .9-3.4 1.4l-5.7 2.5c-21.6 9.6-37.9 28.3-44.4 51.1l-3.7 12.9c-2.4 8.5-11.3 13.4-19.8 11s-13.4-11.3-11-19.8l3.7-12.9c9.1-31.9 31.9-58.1 62.2-71.6l5.7-2.5c18.8-8.3 39-12.6 59.6-12.6c38.1 0 72.5 22.9 87.1 58.1l16.5 39.7c1.1 2.6 2.9 4.9 5.2 6.6l25 18.8c7.1 5.3 8.5 15.3 3.2 22.4s-15.3 8.5-22.4 3.2l-28.5-21.4c-4.6-3.4-8.1-8-10.3-13.3l-10.2-24.5c-2.6-6.3-8.9-10.2-15.6-9.8s-12.6 5-14.5 11.5L500 300.8c-1.6 5.4-.2 11.2 3.6 15.3l49.5 54c3.6 3.9 6.2 8.7 7.5 13.9l23 92.1c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6l-22-88.1c-.6-2.6-1.9-5-3.7-6.9l-70.7-77.1c-11.1-12.1-15.2-29-11-44.8L462 203.4c1.6-5.9-.3-12.1-4.9-16.1zM528 16a36 36 0 1 1 0 72 36 36 0 1 1 0-72zM427.4 209c3.3-2.3 6.8-4.3 10.6-6l5.7-2.5c1-.4 1.9-.8 2.9-1.2l-1.3 4.8-2.6 9.6-1.5 5.6-11.6 43.6c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 12.1-41.2 7.2-24.4 9.8 23.5 .4 1c3.3 7.9 8.7 14.8 15.5 19.9l28.5 21.4c14.1 10.6 34.2 7.7 44.8-6.4s7.7-34.2-6.4-44.8l-25-18.8-16.5-39.7C568.5 154.8 528.3 128 483.7 128c-22.8 0-45.3 4.8-66.1 14l-5.7 2.5c-34.6 15.4-60.7 45.3-71.1 81.8l-3.7 12.9c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l3.7-12.9c4.1-14.3 13-26.6 24.9-34.9zM580 52A52 52 0 1 0 476 52a52 52 0 1 0 104 0zM419 343.9c-4.1-1.6-8.8 .4-10.4 4.5L388.7 398l-59.4 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l61.7-61.7c4.6-4.6 8.2-10.1 10.6-16.1L462.1 387c1.6-4.1-.4-8.8-4.5-10.4s-8.8 .4-10.4 4.5l-15.1 37.9c-1.6 4-4 7.7-7.1 10.7l-61.7 61.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l60.5-60.5 1.2-1.2 .6-1.5 20.5-51.1c1.6-4.1-.4-8.8-4.5-10.4z'
      
    ]
  };

  
    var faHouseLeave = faHousePersonLeave;
  
    var faHousePersonDepart = faHousePersonLeave;
  

  
  

  var faLeftFromBracket = {
    prefix: 'fat',
    iconName: 'left-from-bracket',
    icon: [
      512,
      512,
      [],
      'e66c',
      
      'M19.3 264c-2.1-2.1-3.3-5-3.3-8s1.2-5.9 3.3-8L151.4 116.2c2.7-2.7 6.4-4.2 10.2-4.2c8 0 14.4 6.5 14.4 14.4l0 73.6c0 4.4 3.6 8 8 8l136 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-136 0c-4.4 0-8 3.6-8 8l0 73.6c0 8-6.5 14.4-14.4 14.4c-3.8 0-7.5-1.5-10.2-4.2L19.3 264zM0 256c0 7.2 2.9 14.2 8 19.3L140.1 407.1c5.7 5.7 13.4 8.9 21.5 8.9c16.8 0 30.4-13.6 30.4-30.4l0-65.6 128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-128 0 0-65.6c0-16.8-13.6-30.4-30.4-30.4c-8.1 0-15.8 3.2-21.5 8.9L8 236.7c-5.1 5.1-8 12.1-8 19.3zM328 464c-4.4 0-8 3.6-8 8s3.6 8 8 8l96 0c48.6 0 88-39.4 88-88l0-272c0-48.6-39.4-88-88-88l-96 0c-4.4 0-8 3.6-8 8s3.6 8 8 8l96 0c39.8 0 72 32.2 72 72l0 272c0 39.8-32.2 72-72 72l-96 0z'
      
    ]
  };

  

  
  

  var faMarsDouble = {
    prefix: 'fat',
    iconName: 'mars-double',
    icon: [
      640,
      512,
      [9891],
      'f227',
      
      'M637.7 34.3c1.5 1.5 2.3 3.5 2.3 5.7V184c0 4.4-3.6 8-8 8s-8-3.6-8-8V59.3l-126 126c63.1 69.1 61.3 176.3-5.5 243.1c-48.6 48.6-118.5 62.8-179.6 42.7c4.8-4 9.5-8.2 14-12.5c53.3 14.1 112.5 .3 154.3-41.5c62.5-62.5 62.5-163.8 0-226.3c-3.1-3.1-3.1-8.2 0-11.3L612.7 48 488 48c-4.4 0-8-3.6-8-8s3.6-8 8-8H632c2.1 0 4.2 .8 5.7 2.3zM296 48c-4.4 0-8-3.6-8-8s3.6-8 8-8H440c4.4 0 8 3.6 8 8V184c0 4.4-3.6 8-8 8s-8-3.6-8-8V59.3l-126 126c28.6 31.3 46 72.9 46 118.7c0 97.2-78.8 176-176 176S0 401.2 0 304s78.8-176 176-176c45.7 0 87.4 17.4 118.7 46l126-126H296zM176 464a160 160 0 1 0 0-320 160 160 0 1 0 0 320z'
      
    ]
  };

  

  
  

  var faLocationCrosshairs = {
    prefix: 'fat',
    iconName: 'location-crosshairs',
    icon: [
      512,
      512,
      ["location"],
      'f601',
      
      'M256 0c4.4 0 8 3.6 8 8V64.2c99.7 4.1 179.8 84.2 183.8 183.8H504c4.4 0 8 3.6 8 8s-3.6 8-8 8H447.8c-4.1 99.7-84.2 179.8-183.8 183.8V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V447.8C148.3 443.8 68.2 363.7 64.2 264H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H64.2C68.2 148.3 148.3 68.2 248 64.2V8c0-4.4 3.6-8 8-8zM80 256a176 176 0 1 0 352 0A176 176 0 1 0 80 256zm256 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-176 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z'
      
    ]
  };

  
    var faLocation = faLocationCrosshairs;
  

  
  

  var faChessQueenPiece = {
    prefix: 'fat',
    iconName: 'chess-queen-piece',
    icon: [
      256,
      512,
      ["chess-queen-alt"],
      'f446',
      
      'M144 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM96 32a32 32 0 1 1 64 0A32 32 0 1 1 96 32zm74.6 48c3.2 .4 5.8 2.7 6.7 5.8c4.3 15.2 18.2 26.3 34.7 26.3c5.2 0 10.1-1.1 14.5-3c3.1-1.4 6.8-.6 9.1 1.9s2.8 6.2 1.2 9.2L181.3 224H192c4.4 0 8 3.6 8 8s-3.6 8-8 8H177.1l18.8 144H179.8L161 240H95L76.2 384H60.1L78.9 240H64c-4.4 0-8-3.6-8-8s3.6-8 8-8H74.7L19.2 120.1c-1.6-3-1.1-6.7 1.2-9.2s6-3.3 9.1-1.9c4.4 1.9 9.3 3 14.5 3c16.5 0 30.4-11.1 34.7-26.3c.9-3.1 3.5-5.4 6.7-5.8s6.3 1.2 7.9 3.9c6.9 12 19.9 20.1 34.7 20.1s27.8-8.1 34.7-20.1c1.6-2.8 4.7-4.3 7.9-3.9zm43.8 48c-.8 0-1.6 .1-2.4 .1c-18.7 0-35-9.8-44.2-24.6C157.7 113.6 143.6 120 128 120s-29.7-6.4-39.8-16.6C79 118.2 62.7 128 44 128c-.8 0-1.6 0-2.4-.1L92.8 224h70.4l51.2-96.1zM55.4 432L19.2 474.2c-2.1 2.4-3.2 5.4-3.2 8.6c0 7.3 5.9 13.2 13.2 13.2H226.8c7.3 0 13.2-5.9 13.2-13.2c0-3.1-1.1-6.2-3.2-8.6L200.6 432H55.4zm0-16H200.6c4.7 0 9.1 2 12.1 5.6L249 463.8c4.5 5.3 7 12 7 19c0 16.1-13.1 29.2-29.2 29.2H29.2C13.1 512 0 498.9 0 482.8c0-7 2.5-13.7 7-19l36.2-42.2c3-3.5 7.5-5.6 12.1-5.6z'
      
    ]
  };

  
    var faChessQueenAlt = faChessQueenPiece;
  

  
  

  var faBiohazard = {
    prefix: 'fat',
    iconName: 'biohazard',
    icon: [
      576,
      512,
      [9763],
      'f780',
      
      'M153.6 11.2c1.5-2 3.9-3.2 6.4-3.2h.9c2.3 0 4.4 1 6 2.7s2.2 4 2 6.2c-3.7 32.6 4.6 66.5 24.4 92c19.6 25.4 51 43.1 94.8 43.1s75.2-17.7 94.8-43.1c19.8-25.6 28-59.4 24.4-92c-.3-2.3 .5-4.5 2-6.2s3.7-2.7 6-2.7h.9c2.5 0 4.9 1.2 6.4 3.2C443.5 39.3 456 74.2 456 112c0 20.8-3.8 40.7-10.7 59.1c17.7 3.5 35.1 9.9 51.6 19.4c32.7 18.9 56.7 47.2 70.5 79.5c1 2.3 .8 5-.4 7.1l-.5 .8c-1.1 2-3.1 3.4-5.3 3.8s-4.6 0-6.4-1.4c-26.4-19.5-59.9-29.3-91.9-24.9c-31.8 4.3-62.8 22.6-84.7 60.6s-22.3 74-10.1 103.6c12.3 29.9 37.5 54 67.5 67.1c2.1 .9 3.7 2.7 4.4 4.8s.5 4.5-.7 6.5l-.5 .8c-1.3 2.2-3.5 3.6-6 3.9c-34.9 4.2-71.4-2.4-104.1-21.3c-15.7-9.1-29.3-20.3-40.9-33c-11.5 12.8-25.2 24-40.9 33c-32.7 18.9-69.2 25.5-104.1 21.3c-2.5-.3-4.7-1.8-6-3.9l-.5-.8c-1.1-2-1.4-4.3-.7-6.5s2.3-3.9 4.4-4.8c30.1-13.1 55.3-37.2 67.5-67.1C220 390 219.7 354 197.8 316s-52.9-56.3-84.7-60.6c-32-4.3-65.5 5.5-91.9 24.9c-1.8 1.4-4.2 1.9-6.4 1.4s-4.2-1.9-5.3-3.8l-.5-.8c-1.3-2.2-1.4-4.8-.4-7.1c13.8-32.3 37.8-60.6 70.5-79.5c16.5-9.5 33.9-15.9 51.6-19.4C123.8 152.7 120 132.8 120 112c0-37.8 12.5-72.7 33.6-100.8zm-1.2 32C141.9 63.9 136 87.2 136 112c0 22.1 4.7 43.2 13.2 62.1c1 2.3 .9 5-.3 7.2s-3.4 3.7-5.9 4c-19.1 2.5-38.1 8.8-55.8 19.1C65.7 216.8 48.4 233.6 35.8 253c24.5-11.8 52.2-17.1 79.5-13.4c36.9 5 72.1 26.3 96.4 68.4s25.1 83.3 11 117.7c-10.4 25.4-28.8 46.8-51.3 62.1c23.1-1.2 46.3-7.8 67.8-20.2c16.9-9.7 31.1-22.2 42.6-36.5c1.5-1.9 3.8-3 6.2-3s4.7 1.1 6.2 3c11.5 14.3 25.8 26.8 42.6 36.5c21.4 12.4 44.6 18.9 67.8 20.2c-22.5-15.3-40.9-36.7-51.3-62.1c-14.1-34.4-13.3-75.6 11-117.7s59.6-63.4 96.4-68.4c27.2-3.7 54.9 1.6 79.5 13.4c-12.6-19.4-29.9-36.2-51.4-48.6c-17.8-10.3-36.7-16.5-55.8-19.1c-2.5-.3-4.7-1.8-5.9-4s-1.3-4.9-.3-7.2c8.5-19 13.2-40 13.2-62.1c0-24.8-5.9-48.1-16.4-68.8c-2 27.1-11.3 53.8-28.1 75.5C372.7 148.1 336.6 168 288 168s-84.7-19.9-107.5-49.3C163.8 97 154.4 70.4 152.4 43.2zm2.1 388.3c-40.1-33.6-67.4-82.1-73.3-136.9c5.3-1.1 10.7-1.7 15.9-1.7c5.5 50.6 30.6 95.3 67.6 126.3c-3 4.3-6.4 8.5-10.2 12.3zM288 80c-21.2 0-41.7 3.4-60.7 9.8c-1.3-1.4-2.5-2.9-3.7-4.4c-2.2-2.9-4.2-6-6.1-9.2C239.5 68.3 263.3 64 288 64s48.5 4.3 70.5 12.2c-1.8 3.2-3.8 6.3-6.1 9.2c-1.2 1.5-2.4 2.9-3.7 4.4C329.7 83.4 309.2 80 288 80zM478.9 292.9c5.3 .1 10.6 .6 15.9 1.7c-5.9 54.9-33.2 103.3-73.3 136.9c-3.8-3.8-7.3-8-10.2-12.3c37-31 62.1-75.7 67.6-126.3zM288 232a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faWebAwesome = {
    prefix: 'fat',
    iconName: 'web-awesome',
    icon: [
      640,
      512,
      [],
      'e682',
      
      'M284.2 52a36 36 0 1 1 72 0 36 36 0 1 1 -72 0zM323 103.9L437.5 204c3.7 3.3 8.8 4.6 13.7 3.6l115.3-23.1c3.3 2.1 6.9 3.8 10.7 5L466.4 435.7c-7.8 17.2-24.9 28.3-43.8 28.3l-205.2 0c-18.9 0-36-11.1-43.8-28.3L62.9 189.6c3.8-1.2 7.4-2.9 10.7-5l115.3 23.1c4.9 1 9.9-.4 13.7-3.6L317 103.9c1.1 .1 2.1 .1 3.2 .1c1 0 1.9 0 2.9-.1zM46.4 192L159 442.3c10.3 23 33.2 37.7 58.4 37.7l205.2 0c25.2 0 48-14.8 58.4-37.7L593.6 192c25.8-.9 46.4-22 46.4-48c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 10.1 3.1 19.4 8.4 27.1L448 192 342 99.2C359.8 91 372.2 72.9 372.2 52c0-28.7-23.3-52-52-52s-52 23.3-52 52c0 20.8 12.3 38.8 30 47.1L192 192 87.6 171.1c5.3-7.7 8.4-17.1 8.4-27.1c0-26.5-21.5-48-48-48S0 117.5 0 144c0 26 20.6 47.1 46.4 48zM592 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM16 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faBalloon = {
    prefix: 'fat',
    iconName: 'balloon',
    icon: [
      384,
      512,
      [],
      'e2e3',
      
      'M214.4 427.2l0 0L208 432H176l-6.4-4.8 0 0 0 0 0 0-.1 0-.3-.2L168 426c-1.1-.9-2.7-2.1-4.8-3.8c-4.2-3.4-10.3-8.4-17.6-14.9c-14.6-12.9-34.1-31.4-53.5-53.8C52.6 308.1 16 249.9 16 192C16 94.8 94.8 16 192 16s176 78.8 176 176c0 57.9-36.6 116.1-76.1 161.5c-19.4 22.3-38.9 40.8-53.5 53.8c-7.3 6.5-13.4 11.5-17.6 14.9c-2.1 1.7-3.7 3-4.8 3.8l-1.2 .9-.3 .2-.1 0 0 0 0 0zM210.1 448l27.4 48H146.4l27.4-48h36.3zm13.9-8s160-120 160-248C384 86 298 0 192 0S0 86 0 192C0 320 160 440 160 440l-30.3 53.1c-1.1 1.9-1.7 4.1-1.7 6.3c0 7 5.7 12.6 12.6 12.6H243.4c7 0 12.6-5.7 12.6-12.6c0-2.2-.6-4.4-1.7-6.3L224 440zM168 96c4.4 0 8-3.6 8-8s-3.6-8-8-8c-48.6 0-88 39.4-88 88c0 4.4 3.6 8 8 8s8-3.6 8-8c0-39.8 32.2-72 72-72z'
      
    ]
  };

  

  
  

  var faSensorOn = {
    prefix: 'fat',
    iconName: 'sensor-on',
    icon: [
      640,
      512,
      [],
      'e02b',
      
      'M384 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM88 96c-4.4 0-8 3.6-8 8V280c0 4.4 3.6 8 8 8s8-3.6 8-8V104c0-4.4-3.6-8-8-8zm64 0c-4.4 0-8 3.6-8 8V280c0 4.4 3.6 8 8 8s8-3.6 8-8V104c0-4.4-3.6-8-8-8zM604.1 78.9c3.8-2.3 5-7.2 2.7-11s-7.2-5-11-2.7l-80 48c-3.8 2.3-5 7.2-2.7 11s7.2 5 11 2.7l80-48zM520 248c-4.4 0-8 3.6-8 8s3.6 8 8 8H632c4.4 0 8-3.6 8-8s-3.6-8-8-8H520zm4.1 137.1c-3.8-2.3-8.7-1-11 2.7s-1 8.7 2.7 11l80 48c3.8 2.3 8.7 1 11-2.7s1-8.7-2.7-11l-80-48z'
      
    ]
  };

  

  
  

  var faMessagesDollar = {
    prefix: 'fat',
    iconName: 'messages-dollar',
    icon: [
      640,
      512,
      ["comments-alt-dollar"],
      'f652',
      
      'M193.1 307.2L112 368V320c0-8.8-7.2-16-16-16H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H352c26.5 0 48 21.5 48 48V256c0 26.5-21.5 48-48 48H202.7c-3.5 0-6.8 1.1-9.6 3.2zm9.6 12.8H352c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V256c0 35.3 28.7 64 64 64H80 96v16 32c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 320zM256 384c0 35.3 28.7 64 64 64H437.3l81.1 60.8c4.8 3.6 11.3 4.2 16.8 1.5s8.8-8.2 8.8-14.3V464 448h16 16c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H448v16H576c26.5 0 48 21.5 48 48V384c0 26.5-21.5 48-48 48H544c-8.8 0-16 7.2-16 16v48l-81.1-60.8c-2.8-2.1-6.1-3.2-9.6-3.2H320c-26.5 0-48-21.5-48-48V352H256v32zM215.1 85.3c0-3.9-3.2-7.1-7.1-7.1s-7.1 3.2-7.1 7.1V97.3c-6.5 .6-12.6 2-17.9 4.4c-10 4.4-17.9 12.2-19.9 23.1c-1.2 6.5-.5 12.4 2 17.6c2.5 5.1 6.4 8.9 10.8 11.8c8.1 5.3 19.1 8.6 28.8 11.4l1.4 .4c10.8 3.2 19.9 6 26.1 10.4c2.9 2.1 4.8 4.2 5.9 6.6c1 2.3 1.6 5.5 .8 9.9c-1.1 5.9-4.9 10.4-11.6 13.2c-6.9 2.9-16.7 3.8-28 2.1c-5.6-.9-15.3-4.1-22.9-6.6l0 0 0 0 0 0c-1.7-.5-3.2-1.1-4.6-1.5c-3.7-1.2-7.7 .8-9 4.6s.8 7.7 4.6 9c1.1 .4 2.5 .8 3.9 1.3l0 0 0 0 0 0c7.5 2.5 18.8 6.2 25.7 7.3l0 0c1.3 .2 2.5 .4 3.8 .5v12.1c0 3.9 3.2 7.1 7.1 7.1s7.1-3.2 7.1-7.1V223c6.4-.4 12.4-1.7 17.7-3.9c10.3-4.3 18.1-12.2 20.1-23.8c1.2-6.8 .6-12.8-1.8-18.2c-2.4-5.3-6.3-9.3-10.7-12.4c-8.5-6-20.2-9.4-30.3-12.4l-.1 0c-10.8-3.2-20-5.9-26.3-10c-3-2-4.8-4-5.9-6.1c-1-2.1-1.5-4.8-.8-8.9c.9-4.9 4.6-9.4 11.6-12.5c7-3.1 16.9-4.4 28-2.7c3.6 .6 14.8 2.7 18.3 3.6c3.8 1 7.7-1.3 8.7-5.1s-1.3-7.7-5.1-8.7c-4.2-1.1-15.9-3.3-19.7-3.9c-1.3-.2-2.5-.4-3.8-.5V85.3z'
      
    ]
  };

  
    var faCommentsAltDollar = faMessagesDollar;
  

  
  

  var faArrowRotateRight = {
    prefix: 'fat',
    iconName: 'arrow-rotate-right',
    icon: [
      512,
      512,
      [8635,"arrow-right-rotate","arrow-rotate-forward","redo"],
      'f01e',
      
      'M384.1 419.9c-90.5 70.7-221.2 54.7-292-35.8s-54.7-221.2 35.8-292c90.5-70.7 221.2-54.7 291.9 35.8L456 176H328c-4.4 0-8 3.6-8 8s3.6 8 8 8H472c4.4 0 8-3.6 8-8V40c0-4.4-3.6-8-8-8s-8 3.6-8 8V160l-31.4-41.8 0 0-.1-.1C356.4 20.6 215.6 3.3 118.1 79.5S3.3 296.4 79.5 393.9s216.9 114.8 314.4 38.6c24.7-19.3 44.2-42.7 58.4-68.6c2.1-3.9 .7-8.7-3.2-10.9s-8.7-.7-10.9 3.2c-13.2 24-31.3 45.7-54.3 63.7z'
      
    ]
  };

  
    var faArrowRightRotate = faArrowRotateRight;
  
    var faArrowRotateForward = faArrowRotateRight;
  
    var faRedo = faArrowRotateRight;
  

  
  

  var faUserMusic = {
    prefix: 'fat',
    iconName: 'user-music',
    icon: [
      640,
      512,
      [],
      'f8eb',
      
      'M112 128a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm240 0A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM16 482.3C16 392.7 88.7 320 178.3 320h91.4c53 0 100.1 25.4 129.7 64.8l.6 .1V360.6C367.5 325.8 321.1 304 269.7 304H178.3C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H307.2c-4.3-4.8-8.1-10.2-11.2-16H29.7c-7.6 0-13.7-6.1-13.7-13.7zM624 190.2v44L448 292.9V243.5c0-3.4 2.2-6.5 5.5-7.6l160-53.3c5.2-1.7 10.5 2.1 10.5 7.6zm0 60.9V368.2c-11.7-10-28.9-16.2-48-16.2c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48c0-1.8-.1-3.7-.4-5.5c.3-.8 .4-1.6 .4-2.5V240 190.2c0-16.4-16-27.9-31.6-22.8l-160 53.3c-9.8 3.3-16.4 12.4-16.4 22.8V304 432.2c-11.7-10-28.9-16.2-48-16.2c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48V309.8l176-58.7zM624 400c0 7.1-3.8 14.7-12.3 21.1s-21.1 10.9-35.7 10.9s-27.1-4.4-35.7-10.9s-12.3-14.1-12.3-21.1s3.8-14.7 12.3-21.1s21.1-10.9 35.7-10.9s27.1 4.4 35.7 10.9s12.3 14.1 12.3 21.1zM432 464c0 7.1-3.8 14.7-12.3 21.1s-21.1 10.9-35.7 10.9s-27.1-4.4-35.7-10.9s-12.3-14.1-12.3-21.1s3.8-14.7 12.3-21.1s21.1-10.9 35.7-10.9s27.1 4.4 35.7 10.9s12.3 14.1 12.3 21.1z'
      
    ]
  };

  

  
  

  var faFacePensive = {
    prefix: 'fat',
    iconName: 'face-pensive',
    icon: [
      512,
      512,
      [],
      'e384',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM208 392h96c4.4 0 8 3.6 8 8s-3.6 8-8 8H208c-4.4 0-8-3.6-8-8s3.6-8 8-8zm143.6-88c14.6 0 30.2-8.6 41-27.9c2.2-3.9 7-5.2 10.9-3.1s5.2 7 3.1 10.9c-13.1 23.4-33.6 36.1-55 36.1s-41.8-12.7-55-36.1c-2.2-3.9-.8-8.7 3.1-10.9s8.7-.8 10.9 3.1c10.9 19.3 26.4 27.9 41 27.9zm-233-27.9c10.9 19.3 26.4 27.9 41 27.9s30.2-8.6 41-27.9c2.2-3.9 7-5.2 10.9-3.1s5.2 7 3.1 10.9c-13.1 23.4-33.6 36.1-55 36.1s-41.8-12.7-55-36.1c-2.2-3.9-.8-8.7 3.1-10.9s8.7-.8 10.9 3.1zM80.5 218.8c-1.6-4.1 .5-8.7 4.7-10.3l20.7-7.8c26.2-9.8 48.2-28.5 62.1-52.8l9.1-15.9c2.2-3.8 7.1-5.2 10.9-3s5.2 7.1 3 10.9l-9.1 15.9c-15.7 27.5-40.6 48.7-70.3 59.9l-20.7 7.8c-4.1 1.6-8.7-.5-10.3-4.7zm346.3-10.3c4.1 1.6 6.2 6.2 4.7 10.3s-6.2 6.2-10.3 4.7l-20.7-7.8c-29.7-11.1-54.6-32.3-70.3-59.9L321.1 140c-2.2-3.8-.9-8.7 3-10.9s8.7-.9 10.9 3l9.1 15.9c13.9 24.3 35.8 43 62.1 52.8l20.7 7.8z'
      
    ]
  };

  

  
  

  var faHandsPraying = {
    prefix: 'fat',
    iconName: 'hands-praying',
    icon: [
      640,
      512,
      ["praying-hands"],
      'f684',
      
      'M283.5 16c-9.5 0-18.4 4.8-23.7 12.7L164.2 172.2C151 191.9 144 215.1 144 238.8v51.1c0 16.7-10.3 31.6-26 37.5L10.8 367.5c-4.1 1.6-8.7-.5-10.3-4.7s.5-8.7 4.7-10.3l107.2-40.2c9.4-3.5 15.6-12.5 15.6-22.5V238.8c0-26.8 7.9-53.1 22.8-75.4L246.5 19.8C254.8 7.4 268.7 0 283.5 0C298.6 0 312 7.5 320 19c8-11.5 21.4-19 36.5-19c14.9 0 28.8 7.4 37 19.8l95.7 143.5c14.9 22.3 22.8 48.6 22.8 75.4v51.1c0 10 6.2 19 15.6 22.5l107.2 40.2c4.1 1.6 6.2 6.2 4.7 10.3s-6.2 6.2-10.3 4.7L522 327.3c-15.6-5.9-26-20.8-26-37.5V238.8c0-23.7-7-46.9-20.2-66.6L380.2 28.7C374.9 20.8 366 16 356.5 16c-15.7 0-28.4 12.7-28.5 28.4c0 0 0 .1 0 .1v2c0 0 0 .1 0 .1c0 4.9 1.2 9.8 3.5 14.1l52.7 99.5c10.4 19.6 15.8 41.5 15.8 63.6V228v76c0 4.4-3.6 8-8 8s-8-3.6-8-8V228c0-15.5-12.5-28-28-28c-15.4 0-27.9 12.5-28 27.9c0 0 0 .1 0 .1v79.7c0 .1 0 .2 0 .2c.1 51.6 33.1 97.3 82.1 113.6l224.5 74.8c4.2 1.4 6.5 5.9 5.1 10.1s-5.9 6.5-10.1 5.1L405 436.8c-40.4-13.5-71.2-44.6-85-83c-13.8 38.5-44.6 69.6-85 83L10.5 511.6c-4.2 1.4-8.7-.9-10.1-5.1s.9-8.7 5.1-10.1l224.5-74.8c48.9-16.3 82-62.1 82.1-113.6c0-.1 0-.2 0-.2V228c0 0 0-.1 0-.1c-.1-15.4-12.6-27.9-28-27.9c-15.5 0-28 12.5-28 28v76c0 4.4-3.6 8-8 8s-8-3.6-8-8V228v-4.2c0-22.2 5.4-44 15.8-63.6l52.7-99.5c2.3-4.4 3.5-9.2 3.5-14.1c0 0 0-.1 0-.1v-2c0 0 0-.1 0-.1C311.9 28.7 299.2 16 283.5 16zM320 73.1l-50.1 94.5c-3.9 7.4-7 15.1-9.3 23.1c6.8-4.2 14.8-6.7 23.3-6.7c14.9 0 28 7.4 36 18.7c8-11.3 21.1-18.7 36-18.7c8.6 0 16.6 2.5 23.3 6.7c-2.3-8-5.4-15.7-9.3-23.1L320 73.1z'
      
    ]
  };

  
    var faPrayingHands = faHandsPraying;
  

  
  

  var faHandScissors = {
    prefix: 'fat',
    iconName: 'hand-scissors',
    icon: [
      512,
      512,
      [],
      'f257',
      
      'M21.3 118.5c-5.3 19.2 6 39 25.2 44.3l190.5 52.4c3.8 1 6.2 4.6 5.8 8.5s-3.5 6.9-7.4 7.2l-182 13.3c-19.8 1.5-34.7 18.7-33.3 38.5s18.7 34.7 38.5 33.3l154.9-11.3c2.9-.2 5.8 1.2 7.3 3.7s1.7 5.6 .2 8.2c-3.2 5.8-5.1 12.4-5.1 19.5c0 21.7 17.2 39.3 38.7 40c2.8 .1 5.4 1.7 6.7 4.1s1.3 5.5-.1 7.9c-3.4 5.9-5.4 12.7-5.4 20c0 22.1 17.9 40 40 40l16 0 32 0 32 0c66.3 0 120-53.7 120-120l0-102c0-30.2-11.4-59.2-31.8-81.4l-24.1-26.1C417.4 94 385.5 80 352 80c-17.6 0-34.2 8.3-44.8 22.4l-17.5 23.3c-2.8 3.8-5.4 7.7-7.7 11.7l80.2 22.9c4.2 1.2 6.7 5.6 5.5 9.9s-5.6 6.7-9.9 5.5L168.1 121.5 65.5 93.3c-19.2-5.3-39 6-44.3 25.2zm20.9 59.7c-27.7-7.6-44-36.2-36.4-63.9s36.2-44 63.9-36.4L266.6 132c3-5.5 6.5-10.8 10.3-15.9l17.5-23.3C308 74.7 329.3 64 352 64c37.9 0 74.2 15.9 99.9 43.7l24.1 26.1C499.1 158.9 512 191.9 512 226l0 102c0 75.1-60.9 136-136 136l-32 0-32 0-16 0c-30.9 0-56-25.1-56-56c0-6.1 1-12 2.8-17.6C218.2 384.5 200 362.4 200 336c0-5 .7-9.9 1.9-14.5L59.8 331.9C31.2 334 6.2 312.4 4.1 283.8S23.6 230.2 52.2 228.1l135.7-9.9L42.2 178.1z'
      
    ]
  };

  

  
  

  var faDrumSteelpan = {
    prefix: 'fat',
    iconName: 'drum-steelpan',
    icon: [
      576,
      512,
      [],
      'f56a',
      
      'M560 160c0-30-24.1-58-74.6-79.3c-26.6-11.2-59-19.8-95.5-25.4c-21.5 64.4-15.4 150.1 24.5 203.9c.2 .3 .4 .6 .6 1c26.3-5.3 50-12.4 70.4-21C535.9 218 560 190 560 160zm-197.1-.3c-4 2.3-8.7 4.9-14 7.5C332.4 175.3 309.9 184 288 184s-44.4-8.7-60.9-16.8c-5.2-2.6-9.9-5.2-14-7.5c-3.5 37.6-14.8 74.3-34.9 103.7C211.7 269 248.8 272 288 272s76.3-3 109.8-8.6c-20.1-29.5-31.4-66.1-34.9-103.7zm-1.1-18c-.9-30.7 3.3-61.4 12-88.6C346.9 49.8 318.1 48 288 48s-58.9 1.8-85.8 5.1c8.7 27.2 12.9 57.8 12 88.6c.3 .2 .6 .4 .9 .5c4.7 2.9 11.3 6.8 19.1 10.6C250 160.7 269.9 168 288 168s38-7.3 53.9-15.2c7.8-3.9 14.4-7.7 19.1-10.6c.3-.2 .6-.4 .9-.5zM90.6 239.3c20.3 8.6 44.1 15.6 70.4 21c.2-.3 .4-.7 .6-1c39.9-53.8 46-139.5 24.5-203.9c-36.5 5.6-68.9 14.2-95.5 25.4C40.1 102 16 130 16 160s24.1 58 74.6 79.3zM576 160V352c0 40-32.2 72-84.4 94c-52.1 22-124.1 34-203.6 34s-151.5-12-203.6-34C32.2 424 0 392 0 352V160C0 80 128.9 32 288 32s288 48 288 128zm-16 45.8C520.8 258 413.8 288 288 288s-232.8-30-272-82.2V352c0 30 24.2 58 74.6 79.3C140.1 452.2 209.8 464 288 464s147.9-11.8 197.4-32.7C535.8 410 560 382 560 352V205.8z'
      
    ]
  };

  

  
  

  var faHandPointer = {
    prefix: 'fat',
    iconName: 'hand-pointer',
    icon: [
      448,
      512,
      [],
      'f25a',
      
      'M128 52c0-19.9 16.1-36 36-36s36 16.1 36 36V192.2c0 2.9 1.6 5.6 4.2 7s5.7 1.3 8.2-.3c6.8-4.4 15-6.9 23.7-6.9c19 0 35.3 12.1 41.4 29c.9 2.4 2.8 4.2 5.2 4.9s5.1 .3 7.1-1.3c7.3-5.5 16.4-8.7 26.3-8.7c19.9 0 36.7 13.2 42.1 31.3c.7 2.2 2.3 4.1 4.4 5s4.6 .9 6.7-.1c5.7-2.7 12.1-4.2 18.8-4.2c24.3 0 44 19.7 44 44l0 28v88c0 48.6-39.4 88-88 88H272 256 207c-39.5 0-76.8-18.2-101-49.4L22.7 339.6c-10.9-13.9-8.3-34.1 5.6-44.9s34.1-8.3 44.9 5.6l40.4 52c2.1 2.7 5.7 3.8 8.9 2.7s5.4-4.2 5.4-7.6V52zM164 0c-28.7 0-52 23.3-52 52V324.1L85.9 290.5c-16.3-20.9-46.4-24.7-67.4-8.4s-24.7 46.4-8.4 67.4L93.3 456.4C120.6 491.5 162.5 512 207 512h49 16 72c57.4 0 104-46.6 104-104V320l0-28c0-33.1-26.9-60-60-60c-6.1 0-12 .9-17.6 2.6C360.8 214.2 340.1 200 316 200c-10 0-19.3 2.4-27.6 6.7C278.1 188.4 258.5 176 236 176c-7 0-13.7 1.2-20 3.4V52c0-28.7-23.3-52-52-52zm60 312c0-4.4-3.6-8-8-8s-8 3.6-8 8V424c0 4.4 3.6 8 8 8s8-3.6 8-8V312zm64 0c0-4.4-3.6-8-8-8s-8 3.6-8 8V424c0 4.4 3.6 8 8 8s8-3.6 8-8V312zm64 0c0-4.4-3.6-8-8-8s-8 3.6-8 8V424c0 4.4 3.6 8 8 8s8-3.6 8-8V312z'
      
    ]
  };

  

  
  

  var faBacterium = {
    prefix: 'fat',
    iconName: 'bacterium',
    icon: [
      512,
      512,
      [],
      'e05a',
      
      'M402.2 8.3c4.2 1.2 6.7 5.6 5.5 9.9l-5.5 19.1c31.2 10 57.3 33.5 69.8 65.2l21.8-6.2c4.2-1.2 8.7 1.2 9.9 5.5s-1.2 8.7-5.5 9.9l-21.3 6.1 .2 1c7.9 34.2-.8 68.4-20.9 94.1l13.4 13.4c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-12.8-12.8c-14.1 13.5-31.9 23.6-52.3 28.3c-13.9 3.2-26.2 7.1-37.2 11.5l3.8 13.2c1.2 4.2-1.2 8.7-5.5 9.9s-8.7-1.2-9.9-5.5l-3.1-11c-36.3 17.9-55.7 41.4-67.1 60.4c-.9 1.5-1.8 3-2.6 4.6l19.8 8.5c4.1 1.7 5.9 6.4 4.2 10.5s-6.4 5.9-10.5 4.2l-20.6-8.8c-4.2 9.5-7.3 19.5-8.9 29.6c-2.8 25.5-13.9 48.1-30.5 65.4l12.8 12.8c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-13.4-13.4c-21.7 16.9-49.6 26-79.1 23.3c-5.5-.5-10.9-1.4-16.1-2.6l-6.1 21.3c-1.2 4.2-5.6 6.7-9.9 5.5s-6.7-5.6-5.5-9.9l6.2-21.7c-28.7-11.4-51.3-34.3-62.6-62.6l-21.7 6.2c-4.2 1.2-8.7-1.2-9.9-5.5s1.2-8.7 5.5-9.9l21.3-6.1c-2.8-11.6-3.8-23.8-2.6-36.4c2.2-21.3 7-42.7 13.8-63.5L29 287.4c-4.1-1.6-6.1-6.3-4.5-10.4s6.3-6.1 10.4-4.5l16.6 6.6c8.3-22 18.6-43.2 30.4-62.8c4.6-7.6 9.6-15.3 15-23L83 182.2c-3.5-2.8-4-7.8-1.2-11.2s7.8-4 11.2-1.2l13.4 10.7c19.5-25.3 43.7-50 73.5-72.2L169.3 92.4c-2.5-3.7-1.5-8.6 2.2-11.1s8.6-1.5 11.1 2.2L192.9 99c25.4-17.3 54.4-32.8 87.6-45.3l-7.9-18.5c-1.7-4.1 .1-8.8 4.2-10.5s8.8 .1 10.5 4.2l8.3 19.4c14.9-5.1 30.6-9.5 47.2-13.3c14.9-3.4 29.7-3.7 43.9-1.3l5.6-19.7c1.2-4.2 5.6-6.7 9.9-5.5zM239.5 378.1l.1-.4c3-19.8 11.3-38.5 20.8-54.3c18-30 53.2-68.3 129.3-85.9c51.7-11.9 83.9-63.5 72-115.1s-63.5-83.9-115.1-72C214.5 80.9 137.7 154.5 95.7 224.6c-24.4 40.7-42.4 88.2-47.3 134.8c-4.7 52.8 34.2 99.4 86.9 104.2c52.2 4.7 98.5-33.3 104.1-85.2l0-.3zM240 192a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM160 272a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm32 48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faGridDividers = {
    prefix: 'fat',
    iconName: 'grid-dividers',
    icon: [
      512,
      512,
      [],
      'e3ad',
      
      'M0 8C0 3.6 3.6 0 8 0H504c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8zM64 112c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H64zM32 128c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128zM64 400c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16H64zM32 416c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V416zM288 112H224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16zM224 96h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32zm0 304c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16H224zm-32 16c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V416zM448 112H384c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16zM384 96h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32zm0 304c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16H384zm-32 16c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V416zM8 288H504c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faHandHoldingDollar = {
    prefix: 'fat',
    iconName: 'hand-holding-dollar',
    icon: [
      576,
      512,
      ["hand-holding-usd"],
      'f4c0',
      
      'M296 32c0-4.4-3.6-8-8-8s-8 3.6-8 8V48.4c-8.4 .7-16.2 2.6-23 5.7c-12.4 5.6-21.9 15.4-24.2 28.8c-1.4 8.2-.6 15.4 2.4 21.8c3 6.3 7.8 11 13.2 14.7c10 6.8 23.7 10.9 35.9 14.6l1.7 .5c13.4 4 25 7.8 32.9 13.5c3.7 2.7 6.3 5.7 7.7 9c1.4 3.3 2.1 7.6 1.1 13.5c-1.4 8.2-6.5 14.1-15.1 17.8c-8.8 3.8-21.1 5-35.4 2.7c-7.1-1.2-19.2-5.3-28.8-8.5l0 0 0 0c-2.1-.7-4-1.4-5.7-1.9c-4.2-1.4-8.7 .9-10.1 5.1s.9 8.7 5.1 10.1c1.4 .5 3.1 1 5 1.7l0 0c9.4 3.2 23.4 8 32 9.4l0 0c1.8 .3 3.7 .5 5.5 .7V224c0 4.4 3.6 8 8 8s8-3.6 8-8V207.9c8.3-.5 16-2.1 22.7-5c12.6-5.4 22.1-15.4 24.5-29.7c1.5-8.5 .7-16-2.1-22.6c-2.9-6.6-7.5-11.6-13-15.5c-10.5-7.6-24.9-12-37.6-15.8l-.3-.1 0 0c-13.4-4-25-7.5-32.9-12.9c-3.8-2.6-6.3-5.3-7.7-8.3c-1.4-2.9-2.1-6.8-1.1-12.2c1.2-6.8 6.2-12.9 15.1-17c9-4.1 21.4-5.7 35.4-3.5c4.5 .7 18.5 3.4 22.9 4.6c4.3 1.1 8.7-1.4 9.8-5.7s-1.4-8.7-5.7-9.8c-5.2-1.4-19.8-4.2-24.6-4.9c-1.8-.3-3.7-.5-5.5-.7V32zM521.8 340.7c10.7-7.9 25.7-5.6 33.6 5.1s5.6 25.7-5.1 33.6L423.6 472.6C403 487.8 378.1 496 352.5 496H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L394.7 414.4c-1.4 1-3 1.6-4.7 1.6H268c-6.6 0-12-5.4-12-12s5.4-12 12-12h80c19.9 0 36-16.1 36-36s-16.1-36-36-36H193.7c-29.1 0-57.3 9.9-80 28L71 382.2c-1.4 1.1-3.2 1.8-5 1.8H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H66c5.4 0 10.7-1.9 15-5.3l42.7-34.2c19.9-15.9 44.5-24.5 70-24.5H348c11 0 20 9 20 20s-9 20-20 20H268c-15.5 0-28 12.5-28 28s12.5 28 28 28H389.9c5.1 0 10.1-1.6 14.2-4.7l117.6-86.6z'
      
    ]
  };

  
    var faHandHoldingUsd = faHandHoldingDollar;
  

  
  

  var faCircleEllipsisVertical = {
    prefix: 'fat',
    iconName: 'circle-ellipsis-vertical',
    icon: [
      512,
      512,
      [],
      'e10b',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16-80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 176a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faFaceGrinSquint = {
    prefix: 'fat',
    iconName: 'face-grin-squint',
    icon: [
      512,
      512,
      [128518,"grin-squint"],
      'f585',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256.3 91.8c-43 0-84.1-5.5-121.5-15.4c-3.9-1-7.1 .3-8.7 1.8c-.7 .7-.9 1.2-.9 1.4l0 0c0 .1-.1 .7 .5 1.9c25 46.8 74.1 78.5 130.5 78.5s105.5-31.7 130.5-78.5c.7-1.2 .6-1.8 .5-1.9l0 0c0-.2-.2-.7-.9-1.4c-1.6-1.5-4.8-2.8-8.7-1.8c-37.4 9.9-78.4 15.4-121.5 15.4zm144.6-2.7C373.2 396.8 318.8 432 256.3 432s-116.9-35.2-144.6-86.9c-9.1-17 8.7-33.1 27.3-28.2c36 9.6 75.6 14.9 117.3 14.9s81.4-5.3 117.3-14.9c18.6-4.9 36.4 11.2 27.3 28.2zM128.8 164.4c2-4 6.8-5.6 10.7-3.6l80 40c2.7 1.4 4.4 4.1 4.4 7.2s-1.7 5.8-4.4 7.2l-80 40c-4 2-8.8 .4-10.7-3.6s-.4-8.8 3.6-10.7L198.1 208l-65.7-32.8c-4-2-5.6-6.8-3.6-10.7zm243.6-3.6c4-2 8.8-.4 10.7 3.6s.4 8.8-3.6 10.7L313.9 208l65.7 32.8c4 2 5.6 6.8 3.6 10.7s-6.8 5.6-10.7 3.6l-80-40c-2.7-1.4-4.4-4.1-4.4-7.2s1.7-5.8 4.4-7.2l80-40z'
      
    ]
  };

  
    var faGrinSquint = faFaceGrinSquint;
  

  
  

  var faSquareLeft = {
    prefix: 'fat',
    iconName: 'square-left',
    icon: [
      448,
      512,
      [11013,"arrow-alt-square-left"],
      'f351',
      
      'M16 416c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-320c0-26.5-21.5-48-48-48L64 48C37.5 48 16 69.5 16 96l0 320zm48 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zM80 256c0-7.2 2.9-14.2 8-19.3L187.7 137c5.7-5.7 13.5-9 21.7-9c16.9 0 30.6 13.7 30.6 30.6l0 49.4 88 0c22.1 0 40 17.9 40 40l0 16c0 22.1-17.9 40-40 40l-88 0 0 49.4c0 16.9-13.7 30.6-30.6 30.6c-8.1 0-15.9-3.2-21.7-9L88 275.3c-5.1-5.1-8-12.1-8-19.3zm19.3 8L199 363.7c2.7 2.7 6.5 4.3 10.3 4.3c8.1 0 14.6-6.6 14.6-14.6l0-57.4c0-4.4 3.6-8 8-8l96 0c13.3 0 24-10.7 24-24l0-16c0-13.3-10.7-24-24-24l-96 0c-4.4 0-8-3.6-8-8l0-57.4c0-8.1-6.5-14.6-14.6-14.6c-3.9 0-7.6 1.5-10.3 4.3L99.3 248c-2.1 2.1-3.3 5-3.3 8s1.2 5.9 3.3 8z'
      
    ]
  };

  
    var faArrowAltSquareLeft = faSquareLeft;
  

  
  

  var faDiamond = {
    prefix: 'fat',
    iconName: 'diamond',
    icon: [
      512,
      512,
      [9830],
      'f219',
      
      'M239 23c9.4-9.4 24.6-9.4 33.9 0L489 239c9.4 9.4 9.4 24.6 0 33.9L273 489c-9.4 9.4-24.6 9.4-33.9 0L23 273c-9.4-9.4-9.4-24.6 0-33.9L239 23zm45.3-11.3c-15.6-15.6-40.9-15.6-56.6 0l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c15.6 15.6 40.9 15.6 56.6 0l216-216c15.6-15.6 15.6-40.9 0-56.6l-216-216z'
      
    ]
  };

  

  
  

  var faUserNurseHairLong = {
    prefix: 'fat',
    iconName: 'user-nurse-hair-long',
    icon: [
      448,
      512,
      [],
      'e45e',
      
      'M112 76.9V144H336V76.9c0-6.4-3.8-12.1-9.6-14.7l-96-42c-4.1-1.8-8.7-1.8-12.8 0l-96 42c-5.8 2.5-9.6 8.3-9.6 14.7zM96 144V76.9c0-12.7 7.5-24.2 19.2-29.3l96-42c8.2-3.6 17.5-3.6 25.7 0l96 42C344.5 52.7 352 64.2 352 76.9V144v8 8 0 8c0 37.8 17.8 73.3 48 96l4.3 3.2c7.4 5.5 11.7 14.2 11.7 23.5c0 16.2-13.1 29.3-29.3 29.3H328c-4.4 0-8-3.6-8-8s3.6-8 8-8h58.7c7.4 0 13.3-6 13.3-13.3c0-4.2-2-8.1-5.3-10.7l-4.3-3.2c-20.6-15.4-36.1-36.2-45.2-59.6C328.1 267.7 280.3 304 224 304s-104.1-36.3-121.2-86.8c-9.1 23.4-24.6 44.1-45.2 59.6L53.3 280c-3.4 2.5-5.3 6.5-5.3 10.7C48 298 54 304 61.3 304H120c4.4 0 8 3.6 8 8s-3.6 8-8 8H61.3C45.1 320 32 306.9 32 290.7c0-9.2 4.3-17.9 11.7-23.5L48 264c30.2-22.7 48-58.2 48-96v-8 0-8-8zm148.8 16c-16.8 29.6-48.2 48-82.5 48H116.6c13.8 46.3 56.6 80 107.4 80c61.9 0 112-50.1 112-112v-8-8 0H244.8zM112 160v0 8 8c0 5.4 .4 10.8 1.1 16h49.2c25.3 0 48.7-12.1 63.4-32H112zM232 48V72h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H232v24c0 4.4-3.6 8-8 8s-8-3.6-8-8V88H192c-4.4 0-8-3.6-8-8s3.6-8 8-8h24V48c0-4.4 3.6-8 8-8s8 3.6 8 8zM137.4 365.9h-3C69 365.9 16 418.9 16 484.3c0 5.3 4.3 9.6 9.6 9.6H422.4c5.3 0 9.6-4.3 9.6-9.6c0-65.4-53-118.4-118.4-118.4h-3l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-64-64zm0-16c4.2 0 8.3 1.7 11.3 4.7l64 64c6.2 6.2 16.4 6.2 22.6 0l64-64c3-3 7.1-4.7 11.3-4.7h3c74.2 0 134.4 60.2 134.4 134.4c0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 509.9 0 498.5 0 484.3c0-74.2 60.2-134.4 134.4-134.4h3z'
      
    ]
  };

  

  
  

  var faAlbumCirclePlus = {
    prefix: 'fat',
    iconName: 'album-circle-plus',
    icon: [
      576,
      512,
      [],
      'e48c',
      
      'M384 48H64C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H284.5c3.6 5.6 7.6 10.9 11.8 16H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64v96.7c-5.3-.5-10.6-.7-16-.7V96c0-26.5-21.5-48-48-48zM224 96c69.3 0 128.3 44 150.5 105.6c-5.1 1.8-10 3.7-14.9 5.9C339.7 151.8 286.5 112 224 112c-79.5 0-144 64.5-144 144s64.5 144 144 144c11.8 0 23.2-1.4 34.2-4.1c.8 5.3 1.9 10.5 3.2 15.7c-12 2.9-24.5 4.4-37.4 4.4c-88.4 0-160-71.6-160-160s71.6-160 160-160zm16 160a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM560 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm152-72v64h64c4.4 0 8 3.6 8 8s-3.6 8-8 8H440v64c0 4.4-3.6 8-8 8s-8-3.6-8-8V376H360c-4.4 0-8-3.6-8-8s3.6-8 8-8h64V296c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faScarf = {
    prefix: 'fat',
    iconName: 'scarf',
    icon: [
      512,
      512,
      [129507],
      'f7c1',
      
      'M214.5 16c-20.7 0-39.8 11.5-49.5 29.8l-42.9 81.1c-6.6 12.5-10.1 26.5-10.1 40.7c0 23.6 9.6 46.3 26.6 62.7L327.9 412.8l42.4-42.4L412.7 328l-66.3-66.3L208 123.3C197.9 113.2 205.1 96 219.3 96H296c4.4 0 8 3.6 8 8s-3.6 8-8 8H219.3L352.4 245.1 371.2 229c18.3-15.6 28.8-38.5 28.8-62.5c0-13.4-3.3-26.7-9.6-38.5L347 45.8C337.3 27.5 318.2 16 297.5 16H214.5zM450.3 461.7L376 387.3 339.3 424l74.3 74.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-79.9-79.9L127.5 241.8C107.4 222.4 96 195.6 96 167.6c0-16.8 4.1-33.4 12-48.2l42.9-81.1C163.4 14.7 187.9 0 214.5 0h82.9c26.7 0 51.2 14.7 63.6 38.3l43.5 82.1c7.5 14.2 11.4 30 11.4 46c0 28.7-12.5 56-34.3 74.7l-17.9 15.3 65.9 65.9 5.7 5.7 74.3 74.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L424 339.3 387.3 376l74.3 74.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0zM227.7 391.6L109.7 509.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L216.4 380.3l11.3 11.3zm-48-48L61.7 461.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L168.4 332.3l11.3 11.3zm-48-48L13.7 413.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L120.4 284.3l11.3 11.3z'
      
    ]
  };

  

  
  

  var faPlantWilt = {
    prefix: 'fat',
    iconName: 'plant-wilt',
    icon: [
      512,
      512,
      [],
      'e5aa',
      
      'M280 88c0-39.8 32.2-72 72-72s72 32.2 72 72v40.3c-42.8 3-72 30.2-72 74.8c0 27.9 25.3 74.8 66 111.6c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-44.6-29.2-71.8-72-74.8V88c0-48.6-39.4-88-88-88s-88 39.4-88 88v88.5c-18.4-29.2-50.9-48.5-88-48.5c-57.4 0-104 46.6-104 104v24.3c-42.8 3-72 30.2-72 74.8C0 359 25.3 405.9 66 442.7c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-44.6-29.2-71.8-72-74.8V232c0-48.6 39.4-88 88-88s88 39.4 88 88v48V504c0 4.4 3.6 8 8 8s8-3.6 8-8V280 232 88zm144 56.3V200c0 4.4 3.6 8 8 8s8-3.6 8-8V144.3c16.6 1.4 29.7 7 38.9 15.3c10.4 9.5 17.1 23.7 17.1 43.4c0 9.9-4.8 25.7-15.6 44.5c-10.6 18.3-26 38-45.1 55.3c-.7 .6-1.8 1.1-3.3 1.1s-2.6-.5-3.3-1.1c-19.1-17.3-34.6-36.9-45.1-55.3C372.8 228.8 368 213 368 203.1c0-19.7 6.7-34 17.1-43.4c9.1-8.3 22.3-13.9 38.9-15.3zM33.1 287.6c9.1-8.3 22.3-13.9 38.9-15.3v55.9c0 4.4 3.6 8 8 8s8-3.6 8-8V272.3c16.6 1.4 29.7 7 38.9 15.3c10.4 9.5 17.1 23.7 17.1 43.4c0 9.9-4.8 25.7-15.6 44.5c-10.6 18.3-26 38-45.1 55.3c-.7 .6-1.8 1.1-3.3 1.1s-2.6-.5-3.3-1.1c-19.1-17.3-34.6-36.9-45.1-55.3C20.8 356.8 16 341 16 331.1c0-19.7 6.7-34 17.1-43.4z'
      
    ]
  };

  

  
  

  var faCommentDots = {
    prefix: 'fat',
    iconName: 'comment-dots',
    icon: [
      512,
      512,
      [62075,128172,"commenting"],
      'f4ad',
      
      'M157.3 415c-5-1.8-10.6-1-14.9 2.1c-11 8-29.4 19.3-51.2 28.8C68.3 456 41.6 464 16 464l.1-.1 0 0 0 0 .3-.3 .1-.1c.4-.4 .9-.9 1.5-1.6c1.3-1.4 3.2-3.6 5.4-6.3l-12.2-10 12.2 10C28 450 34 442 40 432c10.7-17.9 21.4-42.1 23.6-69.9c.3-4.3-1.1-8.6-3.9-11.8C31.9 318.8 16 280.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-35.2 0-68.6-6.1-98.7-17zM4.7 452.7l0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0zM144 240a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm144 32a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm128 48a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z'
      
    ]
  };

  
    var faCommenting = faCommentDots;
  

  
  

  var faCalendarArrowUp = {
    prefix: 'fat',
    iconName: 'calendar-arrow-up',
    icon: [
      448,
      512,
      ["calendar-upload"],
      'e0d1',
      
      'M128 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H64C28.7 64 0 92.7 0 128v48 16V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 176 128c0-35.3-28.7-64-64-64H336V8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H128V8zM16 192H432V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V192zM112 80v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80H320v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80h48c26.5 0 48 21.5 48 48v48H16V128c0-26.5 21.5-48 48-48h48zM216 424c0 4.4 3.6 8 8 8s8-3.6 8-8l0-156.7 74.3 74.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-88-88c-3.1-3.1-8.2-3.1-11.3 0l-88 88c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L216 267.3 216 424z'
      
    ]
  };

  
    var faCalendarUpload = faCalendarArrowUp;
  

  
  

  var faSortUp = {
    prefix: 'fat',
    iconName: 'sort-up',
    icon: [
      320,
      512,
      ["sort-asc"],
      'f0de',
      
      'M144.6 54.6c4-4.2 9.6-6.6 15.4-6.6s11.4 2.4 15.4 6.6L300.5 186.7c2.2 2.3 3.5 5.4 3.5 8.7c0 7-5.6 12.6-12.6 12.6H28.6c-7 0-12.6-5.6-12.6-12.6c0-3.2 1.2-6.3 3.5-8.7L144.6 54.6zM133 43.6L7.8 175.7C2.8 181 0 188.1 0 195.4C0 211.2 12.8 224 28.6 224H291.4c15.8 0 28.6-12.8 28.6-28.6c0-7.3-2.8-14.4-7.8-19.7L187 43.6C180 36.2 170.2 32 160 32s-20 4.2-27 11.6z'
      
    ]
  };

  
    var faSortAsc = faSortUp;
  

  
  

  var faSquareL = {
    prefix: 'fat',
    iconName: 'square-l',
    icon: [
      448,
      512,
      [],
      'e275',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 40V360c0 4.4 3.6 8 8 8H312c4.4 0 8 3.6 8 8s-3.6 8-8 8H152c-13.3 0-24-10.7-24-24V136c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faTennisBall = {
    prefix: 'fat',
    iconName: 'tennis-ball',
    icon: [
      512,
      512,
      [127934],
      'f45e',
      
      'M266.5 495.8c-9.8-61.2 8.9-126 56.1-173.2s112-65.8 173.2-56.1c.2-3.5 .2-7 .2-10.5C496 123.5 388.5 16 256 16c-3.5 0-7 .1-10.5 .2c9.8 61.2-8.9 126-56.1 173.2s-112 65.8-173.2 56.1c-.2 3.5-.2 7-.2 10.5c0 132.5 107.5 240 240 240c3.5 0 7-.1 10.5-.2zm16-1.2c111.3-12.2 199.8-100.7 212-212c-56.7-9.5-116.9 7.6-160.7 51.4s-60.8 104-51.4 160.7zM229.5 17.5c-111.3 12.2-199.8 100.7-212 212c56.7 9.5 116.9-7.6 160.7-51.4s60.8-104 51.4-160.7zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  

  
  

  var faFaceTongueMoney = {
    prefix: 'fat',
    iconName: 'face-tongue-money',
    icon: [
      512,
      512,
      [],
      'e39d',
      
      'M256 16C123.5 16 16 123.5 16 256c0 85.5 44.7 160.5 112 203.1c3.7 2.4 4.9 7.3 2.5 11s-7.3 4.9-11 2.5C47.7 427.3 0 347.2 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 91.2-47.7 171.3-119.5 216.6c-3.7 2.4-8.7 1.2-11-2.5s-1.2-8.7 2.5-11C451.3 416.5 496 341.5 496 256C496 123.5 388.5 16 256 16zm96 288h32c13 0 24.6 10.7 23.1 24.8c-4.5 41.2-25.5 77.4-56.2 101.9C343.8 476.8 304 512 256 512s-87.8-35.2-94.9-81.2c-30.7-24.5-51.7-60.7-56.2-101.9C103.4 314.7 115 304 128 304h32 16H336h16zM160 408.3V320H128c-4.7 0-7.6 3.6-7.2 7.1c3.5 31.6 17.8 59.9 39.2 81.2zM176 320v16 80c0 44.2 35.8 80 80 80s80-35.8 80-80V336 320H320 192 176zm176 0v88.3c21.4-21.3 35.7-49.6 39.2-81.2c.4-3.5-2.5-7.1-7.2-7.1H352zM236.2 385.1c-.5 2.7-.1 4.2 .3 5.2c.5 1 1.4 2.1 3.2 3.4c4.1 2.7 10.3 4.5 18.3 6.7l.7 .2c7.1 1.9 15.8 4.3 22.3 8.6c3.5 2.3 6.8 5.5 8.9 9.9c2.1 4.5 2.5 9.4 1.6 14.8c-1.5 8.3-5.9 14.4-12.2 18c-4.7 2.7-10.1 3.8-15.3 4.1v5.4c0 4.4-3.6 8-8 8s-8-3.6-8-8v-6.6c-8.7-1.5-17-4-22.4-5.8c-4.2-1.3-6.5-5.8-5.2-10s5.8-6.5 10-5.2c8.2 2.6 19.9 6.1 29.9 6.2c5 .1 8.6-.7 11-2.1c2-1.2 3.7-3 4.4-7c.5-2.7 .1-4.2-.3-5.2c-.5-1-1.4-2.1-3.2-3.4c-4.1-2.7-10.3-4.5-18.3-6.7l-.7-.2c-7.1-1.9-15.8-4.3-22.3-8.6c-3.5-2.3-6.8-5.5-8.9-9.9c-2.1-4.5-2.5-9.5-1.6-14.8c1.3-7.2 5.1-12.7 10.3-16.3c5-3.5 11-5 16.6-5.6l.6-.1V352c0-4.4 3.6-8 8-8s8 3.6 8 8v8.7c5.6 .7 10.9 1.8 15 2.9c4.3 1.1 6.9 5.4 5.8 9.7s-5.4 6.9-9.7 5.8c-7.5-1.9-17.6-3.7-25.9-2.8c-4.1 .4-7.2 1.4-9.2 2.8c-1.8 1.2-3.1 3-3.7 6zM176 93.3c4.4 0 8 3.6 8 8v11.3c1 .1 2 .2 3 .4c3.9 .6 15.6 2.8 19.8 3.9c4.3 1.1 6.8 5.5 5.7 9.7s-5.5 6.8-9.7 5.7c-3.5-.9-14.6-3-18.2-3.6c-11-1.7-20.7-.4-27.5 2.6c-6.8 3-10.3 7.4-11.1 11.9c-.7 3.9-.2 6.5 .7 8.3c1 2 2.7 3.9 5.6 5.8c6.1 4.1 15.2 6.7 26.1 9.9l.1 0c10.1 3 21.9 6.4 30.5 12.5c4.5 3.2 8.5 7.3 11 12.8c2.5 5.5 3.1 11.8 1.9 18.7c-2.1 12-10.2 20.1-20.6 24.5c-5.2 2.1-11 3.4-17.1 3.9l0 10.9c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-11.3c-1-.1-2-.3-3-.4l0 0c-7-1.1-18.4-4.9-25.9-7.4c-1.5-.5-2.8-.9-3.9-1.3c-4.2-1.4-6.5-5.9-5.1-10.1s5.9-6.5 10.1-5.1c1.4 .5 3 1 4.6 1.5l0 0 0 0 0 0c7.6 2.5 17.1 5.7 22.7 6.6c11.3 1.7 20.8 .8 27.6-2c6.5-2.7 10.1-6.9 11-12.5c.8-4.3 .3-7.2-.7-9.4c-1-2.2-2.7-4.3-5.6-6.3c-6-4.3-15-7.1-25.8-10.2l-1.4-.4c-9.7-2.8-20.8-6.1-29-11.5c-4.5-3-8.6-6.8-11.2-12.1c-2.6-5.4-3.3-11.5-2.1-18.1c2-11.2 10.2-19.2 20.4-23.7c5.2-2.3 11.1-3.8 17.4-4.4V101.3c0-4.4 3.6-8 8-8zm168 8v11.3c1 .1 2 .2 3 .4c3.9 .6 15.6 2.8 19.8 3.9c4.3 1.1 6.8 5.5 5.7 9.7s-5.5 6.8-9.7 5.7c-3.5-.9-14.6-3-18.2-3.6c-11-1.7-20.7-.4-27.5 2.6c-6.8 3-10.3 7.4-11.1 11.9c-.7 3.9-.2 6.5 .7 8.3c1 2 2.7 3.9 5.6 5.8c6.1 4.1 15.2 6.7 26.1 9.9l.1 0c10.1 3 21.9 6.4 30.5 12.5c4.5 3.2 8.5 7.3 11 12.8c2.5 5.5 3.1 11.8 1.9 18.7c-2.1 12-10.2 20.1-20.6 24.5c-5.2 2.1-11 3.4-17.1 3.9v10.9c0 4.4-3.6 8-8 8s-8-3.6-8-8V239.4c-1-.1-2-.3-3-.4l0 0c-7-1.1-18.4-4.9-25.9-7.4c-1.5-.5-2.8-.9-3.9-1.3c-4.2-1.4-6.5-5.9-5.1-10.1s5.9-6.5 10.1-5.1c1.4 .5 3 1 4.6 1.5l0 0 0 0c7.6 2.5 17.1 5.7 22.7 6.6c11.3 1.7 20.8 .8 27.6-2c6.5-2.7 10.1-6.9 11-12.5c.8-4.3 .3-7.2-.7-9.4c-1-2.2-2.7-4.3-5.6-6.3c-6-4.3-15-7.1-25.8-10.2l-1.4-.4c-9.7-2.8-20.8-6.1-29-11.5c-4.5-3-8.6-6.8-11.2-12.1c-2.6-5.4-3.3-11.5-2.1-18.1c2-11.2 10.2-19.2 20.4-23.7c5.2-2.3 11.1-3.8 17.4-4.4V101.3c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faUserPoliceTie = {
    prefix: 'fat',
    iconName: 'user-police-tie',
    icon: [
      448,
      512,
      [],
      'e334',
      
      'M222.1 16.2L62.2 52.1c-2.8 .6-5.1 2.8-5.9 5.6s-.1 5.8 2 7.9L87.5 95.1c1.5 1.5 2.3 3.5 2.3 5.6v26.9c15.7 10.2 46.4 27 105.5 31.3C173.9 138.5 168 110.1 168 91.2c0-3.3 2-6.2 5-7.4l48-19.2c1.9-.8 4-.8 5.9 0l48 19.2c3 1.2 5 4.2 5 7.4c0 18.9-5.9 47.3-27.2 67.6c59-4.3 89.6-21.1 105.2-31.2V100.7c0-2.1 .8-4.1 2.3-5.6l29.1-29.5c2-2.1 2.8-5.1 2-7.9s-3.1-4.9-5.9-5.6l-159.9-36c-1.2-.3-2.4-.3-3.5 0zm.2 159.6c-80.6-.3-121-21.7-141.3-34.9c-4.6-3-7.2-8-7.2-13.3V104L46.9 76.8c-6.1-6.2-8.4-15.2-6-23.6s9.3-14.8 17.8-16.7L218.6 .6c3.5-.8 7.1-.8 10.5 0L389 36.5c8.5 1.9 15.3 8.3 17.8 16.7s.2 17.4-6 23.6L374 104v23.6c0 5.3-2.6 10.3-7.2 13.3c-20.3 13.2-60.7 34.6-141.1 34.9c-1.1 .2-2.3 .2-3.4 0zM128.1 352.1l69.4 92.5 17-28.3-37-51.7c-1.7-2.4-2-5.6-.6-8.3s4.1-4.3 7.1-4.3h80c3 0 5.7 1.7 7.1 4.3s1.1 5.9-.6 8.3l-37 51.7 17 28.3 69.4-92.5C391.2 355.4 448 414.3 448 486.4c0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4c0-72.1 56.8-131 128.1-134.3zM214 466.7L224 480l10-13.3 6.2-8.2L224 431.6l-16.2 26.9 6.2 8.2zm22.8 22.9L232 496H422.4c5.3 0 9.6-4.3 9.6-9.6c0-60.7-45.7-110.8-104.6-117.6L236.8 489.6zm-25.6 0L120.6 368.8C61.7 375.6 16 425.7 16 486.4c0 5.3 4.3 9.6 9.6 9.6H216l-4.8-6.4zM96 192c0-2.9 .1-5.8 .3-8.7c4.8 2.3 10.1 4.5 15.7 6.7c0 .7 0 1.3 0 2c0 61.9 50.1 112 112 112s112-50.1 112-112c0-.7 0-1.3 0-2c5.7-2.2 10.9-4.4 15.7-6.7c.2 2.9 .3 5.8 .3 8.7c0 70.7-57.3 128-128 128s-128-57.3-128-128zm128-32.7c29-13.7 38.5-41.8 39.8-62.7L224 80.6 184.2 96.5c1.3 20.9 10.8 49 39.8 62.7zm0 243L248.5 368H199.5L224 402.2z'
      
    ]
  };

  

  
  

  var faFileUser = {
    prefix: 'fat',
    iconName: 'file-user',
    icon: [
      384,
      512,
      [],
      'f65c',
      
      'M16 448V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM192 224a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-40 48h80c30.9 0 56 25.1 56 56c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8c0-30.9 25.1-56 56-56zM80 440c0 13.3 10.7 24 24 24H280c13.3 0 24-10.7 24-24c0-39.8-32.2-72-72-72H152c-39.8 0-72 32.2-72 72z'
      
    ]
  };

  

  
  

  var faScaleUnbalanced = {
    prefix: 'fat',
    iconName: 'scale-unbalanced',
    icon: [
      640,
      512,
      ["balance-scale-left"],
      'f515',
      
      'M544.2 5.5c1.4 4.2-.9 8.7-5.1 10.1L384.6 67.1c-1.5 31.2-25.4 56.6-55.9 60.4V496h208c4.4 0 8 3.6 8 8s-3.6 8-8 8h-216c-4.4 0-8-3.6-8-8V127.5c-16.5-2.1-31.1-10.4-41.3-22.7L107.2 159.6c-4.2 1.4-8.7-.9-10.1-5.1s.9-8.7 5.1-10.1L262.6 90.9c-3.8-8.2-5.9-17.3-5.9-26.9c0-35.3 28.7-64 64-64c30.8 0 56.5 21.7 62.6 50.7L534.1 .4c4.2-1.4 8.7 .9 10.1 5.1zM52.7 464c20.5 19.2 47.1 32 75.7 32s55.2-12.8 75.7-32c20.3-19 33.1-43.1 35.8-64H16.9c2.7 20.9 15.5 44.9 35.8 64zm75.7-254.2L23.8 384H232.9L128.4 209.8zM251.8 384.4c3 5 4.7 10.7 4.1 16.4C250 452.2 195.2 512 128.4 512S6.7 452.2 .9 400.8c-.7-5.8 1.1-11.5 4.1-16.4L116.3 198.9c2.6-4.3 7.2-6.9 12.1-6.9s9.6 2.6 12.1 6.9L251.8 384.4zM400.9 272c2.7 20.9 15.5 44.9 35.8 64c20.5 19.2 47.1 32 75.7 32s55.2-12.8 75.7-32c20.3-19 33.1-43.1 35.8-64h-223zm6.9-16H616.9L512.4 81.8 407.8 256zM524.5 70.9L635.8 256.4c3 5 4.7 10.7 4.1 16.4C634 324.2 579.2 384 512.4 384s-121.7-59.8-127.5-111.2c-.7-5.8 1.1-11.5 4-16.4L500.3 70.9c2.6-4.3 7.2-6.9 12.1-6.9s9.6 2.6 12.1 6.9zM320.7 112a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  
    var faBalanceScaleLeft = faScaleUnbalanced;
  

  
  

  var faFaceKissClosedEyes = {
    prefix: 'fat',
    iconName: 'face-kiss-closed-eyes',
    icon: [
      512,
      512,
      [],
      'e37d',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm241.4 16.1c11.4 2.1 22.8 5.4 33.6 9.8c8.4 3.4 17.2 7.9 24.2 13.7c6.9 5.9 12.8 14 12.8 24.4c0 10.2-6.4 17.5-13.4 22.4c-5.9 4.1-13.2 7.3-20.3 9.6c7.1 2.4 14.4 5.5 20.3 9.6c7 4.9 13.4 12.2 13.4 22.4c0 11-5.6 19.5-12.7 25.8c-7 6.2-16 10.6-24.5 13.7c-10.8 4.1-22.3 6.9-33.7 8.4l-.1 0c-4.4 .5-8.4-2.6-9-6.9s2.6-8.4 6.9-8.9c10.3-1.4 20.5-3.9 30.2-7.6c7.6-2.8 14.6-6.4 19.5-10.8c4.9-4.3 7.3-8.7 7.3-13.7c0-2.6-1.6-5.7-6.6-9.2c-5-3.5-12-6.4-19.7-8.7c-7.6-2.3-15.2-3.8-21-4.8c-2.2-.4-4-.5-5.5-.7c-2.3-.2-4.1-.4-5.9-1.1c-3.1-1.1-5.3-4.2-5.3-7.5s2.2-6.4 5.3-7.5c1.8-.6 3.6-.8 5.9-1.1l0 0 0 0c1.6-.2 3.3-.3 5.5-.7c5.8-1 13.4-2.5 21-4.8c7.7-2.3 14.7-5.2 19.7-8.7c5-3.5 6.6-6.6 6.6-9.2c0-3.8-2.1-7.9-7.2-12.2c-5.1-4.3-12.2-8-19.8-11.1c-7.6-3-15.2-5.3-21-6.7c-4.3-1.1-6.9-1.7-9.4-2.1c-4.3-.8-7.3-4.9-6.5-9.3s4.9-7.2 9.3-6.5zM175.6 200c-14.6 0-30.2 8.6-41 27.9c-2.2 3.9-7 5.2-10.9 3.1s-5.2-7-3.1-10.9c13.1-23.4 33.6-36.1 55-36.1s41.8 12.7 55 36.1c2.2 3.9 .8 8.7-3.1 10.9s-8.7 .8-10.9-3.1c-10.9-19.3-26.4-27.9-41-27.9zm119 27.9c-2.2 3.9-7 5.2-10.9 3.1s-5.2-7-3.1-10.9c13.1-23.4 33.6-36.1 55-36.1s41.8 12.7 55 36.1c2.2 3.9 .8 8.7-3.1 10.9s-8.7 .8-10.9-3.1c-10.9-19.3-26.4-27.9-41-27.9s-30.2 8.6-41 27.9z'
      
    ]
  };

  

  
  

  var faVihara = {
    prefix: 'fat',
    iconName: 'vihara',
    icon: [
      640,
      512,
      [],
      'f6a7',
      
      'M326 2.7C324.5 1 322.3 0 320 0s-4.5 1-6 2.7c-43.2 48.7-90.4 76.2-148.7 98.4l-.3 .1c-10.2 3.9-20.7 7.6-31.5 11.2c-4.2 1.4-6.5 5.9-5.1 10.1s5.9 6.5 10.1 5.1c7.3-2.4 14.5-4.9 21.5-7.4v61.6c-11.1 17.6-28.9 32.1-50.2 44.4c-22.1 12.6-47.5 22.4-72.2 30.3c-3.8 1.2-6.1 5-5.5 8.9s4 6.8 7.9 6.8H96v55.2c-3.7 17.3-15.8 33.8-32.8 49.3C46 392 24.6 405.6 4.1 417c-3.2 1.8-4.8 5.5-3.9 9s4.1 6 7.7 6H64v72c0 4.4 3.6 8 8 8s8-3.6 8-8V432H224v72c0 4.4 3.6 8 8 8s8-3.6 8-8V432H400v72c0 4.4 3.6 8 8 8s8-3.6 8-8V432H560v72c0 4.4 3.6 8 8 8s8-3.6 8-8V432h56c3.6 0 6.8-2.5 7.7-6s-.7-7.2-3.9-9c-20.5-11.4-41.9-25-59.1-40.6c-17-15.4-29.1-32-32.8-49.3V272h56c3.9 0 7.3-2.9 7.9-6.8s-1.7-7.7-5.5-8.9c-24.7-7.9-50.2-17.7-72.2-30.3c-21.4-12.2-39.1-26.8-50.2-44.4V120.1c7 2.5 14.2 5 21.5 7.4c4.2 1.4 8.7-.9 10.1-5.1s-.9-8.7-5.1-10.1c-10.9-3.6-21.4-7.3-31.5-11.2l-.3-.1C416.4 78.9 369.1 51.4 326 2.7zM176 176V114.1c55-21.5 101.5-48.5 144-94.2c42.5 45.7 89 72.8 144 94.2V176H176zm-58.3 64c22-12.6 41.6-28.2 54.7-48H467.6c13.1 19.8 32.7 35.4 54.7 48c10.4 5.9 21.4 11.3 32.6 16H536 104 85.1c11.2-4.8 22.2-10.1 32.6-16zM112 320V272H528v48H112zM73.9 388.3c16.6-15 30.5-32.5 36.4-52.3H529.7c5.8 19.8 19.8 37.3 36.4 52.3c11.2 10.1 23.9 19.4 36.8 27.7H568 72 37.1c12.9-8.3 25.6-17.6 36.8-27.7z'
      
    ]
  };

  

  
  

  var faFloppyDisk = {
    prefix: 'fat',
    iconName: 'floppy-disk',
    icon: [
      448,
      512,
      [128190,128426,"save"],
      'f0c7',
      
      'M16 96c0-26.5 21.5-48 48-48l0 112c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V49.2c8.8 2 17 6.4 23.4 12.9l74.5 74.5c9 9 14.1 21.2 14.1 33.9V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96zM80 48H304V160c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V48zM0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V170.5c0-17-6.7-33.3-18.7-45.3L354.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96zM296 328a72 72 0 1 1 -144 0 72 72 0 1 1 144 0zm-72-88a88 88 0 1 0 0 176 88 88 0 1 0 0-176z'
      
    ]
  };

  
    var faSave = faFloppyDisk;
  

  
  

  var faShop = {
    prefix: 'fat',
    iconName: 'shop',
    icon: [
      640,
      512,
      ["store-alt"],
      'f54f',
      
      'M0 185.8c0-6.4 1.6-12.7 4.7-18.3L82.4 25C90.8 9.6 106.9 0 124.5 0h391c17.6 0 33.7 9.6 42.1 25l77.7 142.4c3.1 5.6 4.7 11.9 4.7 18.3c0 21.1-17.1 38.2-38.2 38.2H576V488c0 13.3-10.7 24-24 24H520c-13.3 0-24-10.7-24-24V256c0-4.4 3.6-8 8-8s8 3.6 8 8V488c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V224H80V464c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V256c0-4.4 3.6-8 8-8s8 3.6 8 8V464c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V224H38.2C17.1 224 0 206.9 0 185.8zM72 208H568h33.8c12.3 0 22.2-10 22.2-22.2c0-3.7-.9-7.4-2.7-10.7L543.6 32.7C538 22.4 527.2 16 515.5 16h-391c-11.7 0-22.5 6.4-28.1 16.7L18.7 175.1c-1.8 3.3-2.7 6.9-2.7 10.7C16 198 26 208 38.2 208H72zm64 40c4.4 0 8 3.6 8 8V360c0 4.4 3.6 8 8 8H296c4.4 0 8-3.6 8-8V256c0-4.4 3.6-8 8-8s8 3.6 8 8V360c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24V256c0-4.4 3.6-8 8-8z'
      
    ]
  };

  
    var faStoreAlt = faShop;
  

  
  

  var faPrescription = {
    prefix: 'fat',
    iconName: 'prescription',
    icon: [
      448,
      512,
      [],
      'f5b1',
      
      'M24 0C10.7 0 0 10.7 0 24V216v96c0 4.4 3.6 8 8 8s8-3.6 8-8V224H148.7l128 128L130.3 498.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L288 363.3 434.3 509.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L299.3 352 445.7 205.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L288 340.7 171.3 224H176c61.9 0 112-50.1 112-112S237.9 0 176 0H24zM152 208s0 0 0 0H16V24c0-4.4 3.6-8 8-8H176c53 0 96 43 96 96s-43 96-96 96H152z'
      
    ]
  };

  

  
  

  var faWalker = {
    prefix: 'fat',
    iconName: 'walker',
    icon: [
      448,
      512,
      [],
      'f831',
      
      'M185.6 16H328c30.9 0 56 25.1 56 56V192H96.8L131.4 58c6.4-24.7 28.7-42 54.2-42zM384 208V418.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48s-21.5-48-48-48l0-344c0-39.8-32.2-72-72-72H185.6c-32.8 0-61.5 22.2-69.7 54L.3 502c-1.1 4.3 1.5 8.6 5.7 9.7s8.6-1.5 9.7-5.7L92.7 208H384zm16 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faScreencast = {
    prefix: 'fat',
    iconName: 'screencast',
    icon: [
      576,
      512,
      [],
      'e23e',
      
      'M512 48H64C37.5 48 16 69.5 16 96v96H0V96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H288V464H512c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48zM8 224c137 0 248 111 248 248c0 4.4-3.6 8-8 8s-8-3.6-8-8C240 343.9 136.1 240 8 240c-4.4 0-8-3.6-8-8s3.6-8 8-8zM48 448a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM0 448a32 32 0 1 1 64 0A32 32 0 1 1 0 448zM0 328c0-4.4 3.6-8 8-8c83.9 0 152 68.1 152 152c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-75.1-60.9-136-136-136c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faDiploma = {
    prefix: 'fat',
    iconName: 'diploma',
    icon: [
      640,
      512,
      ["scroll-ribbon"],
      'f5ea',
      
      'M246.8 66.6C237.6 54.9 223.4 48 208.4 48C181.8 48 160 69.6 160 96c0 26.5 21.5 48 48 48h40 59.7L246.8 66.6zM165.7 144C152.4 132.3 144 115.1 144 96c0-35.3 29.1-64 64.4-64c19.8 0 38.7 9.1 51 24.7L320 133.8l60.6-77.1c12.2-15.6 31.2-24.7 51-24.7C466.9 32 496 60.7 496 96c0 19.1-8.4 36.3-21.7 48H544c65.1 .3 96 71.5 96 128c0 56.9-24.1 119.2-81 140.7c-10.5 4-22.5 4.2-33.4 1.8L400 386.6V472c0 2.7-1.4 5.2-3.6 6.7s-5.1 1.7-7.6 .6L320 448.8l-68.8 30.6c-2.5 1.1-5.3 .9-7.6-.6s-3.6-4-3.6-6.7V386.6L114.4 414.5c-10.9 2.4-22.9 2.2-33.4-1.8C24.1 391.2 0 328.9 0 272c0-56.5 30.9-127.7 96-128h69.7zM240 370.2V160H208 96c-25.7 .1-45.2 14-59 35.5C23.1 217.5 16 246.3 16 272c0 53.8 22.7 107.6 70.6 125.7c7 2.7 15.8 3 24.3 1.1L240 370.2zM400 160V370.2l129.1 28.7c8.5 1.9 17.3 1.5 24.3-1.1C601.3 379.6 624 325.8 624 272c0-25.7-7.1-54.5-21.1-76.5c-13.7-21.6-33.2-35.4-59-35.5H432 400zm32-16c26.5 0 48-21.5 48-48c0-26.4-21.8-48-48.4-48c-15 0-29.2 6.9-38.4 18.6L332.3 144H392h40zM328 160H312 256V459.7l60.8-27c2.1-.9 4.4-.9 6.5 0l60.8 27V160H328z'
      
    ]
  };

  
    var faScrollRibbon = faDiploma;
  

  
  

  var faShirtTankTop = {
    prefix: 'fat',
    iconName: 'shirt-tank-top',
    icon: [
      384,
      512,
      [],
      'e3c9',
      
      'M72 16c-4.3 0-8 3.6-8.1 8.2c-1.2 118-15.2 177.5-28.4 207.7c-1.4 3.1-2.8 6.2-4.2 9.3c-3.1 6.8-6.2 13.6-8.9 20.7C18.6 272 16 281.7 16 290.6V464c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V290.6c0-8.9-2.6-18.6-6.4-28.8c-2.7-7.1-5.8-13.9-8.9-20.7c-1.4-3.1-2.8-6.2-4.2-9.3c-13.2-30.1-27.3-89.7-28.4-207.7c0-4.6-3.8-8.2-8.1-8.2H296c-4.4 0-8 3.6-8 8V80c0 53-43 96-96 96s-96-43-96-96V24c0-4.4-3.6-8-8-8H72zM47.9 24C48.1 10.9 58.7 0 72 0H88c13.3 0 24 10.7 24 24V80c0 44.2 35.8 80 80 80s80-35.8 80-80V24c0-13.3 10.7-24 24-24h16c13.4 0 23.9 10.9 24.1 24c1.2 117.2 15.2 174.2 27.1 201.4c1.2 2.7 2.5 5.5 3.8 8.5c3.2 7 6.6 14.6 9.5 22.2c4.1 10.9 7.5 22.7 7.5 34.5V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V290.6c0-11.8 3.4-23.6 7.5-34.5c2.9-7.6 6.3-15.2 9.5-22.2c1.3-3 2.6-5.8 3.8-8.5C32.8 198.2 46.7 141.2 47.9 24z'
      
    ]
  };

  

  
  

  var faChessBishopPiece = {
    prefix: 'fat',
    iconName: 'chess-bishop-piece',
    icon: [
      256,
      512,
      ["chess-bishop-alt"],
      'f43b',
      
      'M96 32c-4.4 0-8 3.6-8 8s3.6 8 8 8h9.7c-7 6.4-15.4 14.8-23.9 24.9C61.3 97.6 40 133.3 40 176c0 21.4 8 37 17.8 48H56c-4.4 0-8 3.6-8 8s3.6 8 8 8H68.3L51.6 384H67.7L84.4 240h87.3l16.6 144h16.1L187.7 240H200c4.4 0 8-3.6 8-8s-3.6-8-8-8h-1.8c9.8-11 17.8-26.6 17.8-48c0-42.7-21.3-78.4-41.9-103.1c-8.4-10.1-16.8-18.5-23.9-24.9H160c4.4 0 8-3.6 8-8s-3.6-8-8-8H128h0H96zm78.1 192l0 0H81.9l0 0C69.7 215.7 56 201 56 176c0-37.3 18.7-69.6 38.1-92.9c9.7-11.6 19.3-20.8 26.6-27.1c2.9-2.5 5.3-4.5 7.3-6c1.9 1.5 4.4 3.5 7.3 6c7.3 6.3 16.9 15.5 26.6 27.1c4.6 5.6 9.2 11.6 13.5 18.2l-45.1 45.1c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l42.2-42.2c9.5 17.8 16.1 38.3 16.1 60.5c0 25-13.7 39.7-25.9 48zM56.2 416c-7.8 0-15 3.7-19.5 10.1L4.5 471.2C1.6 475.2 0 480.1 0 485.1V488c0 13.3 10.7 24 24 24H232c13.3 0 24-10.7 24-24v-2.9c0-5-1.6-9.9-4.5-13.9l-32.2-45.1c-4.5-6.3-11.8-10.1-19.5-10.1H56.2zm-6.5 19.4c1.5-2.1 3.9-3.4 6.5-3.4H199.8c2.6 0 5 1.2 6.5 3.4l32.2 45.1c1 1.4 1.5 3 1.5 4.6V488c0 4.4-3.6 8-8 8H24c-4.4 0-8-3.6-8-8v-2.9c0-1.7 .5-3.3 1.5-4.6l32.2-45.1z'
      
    ]
  };

  
    var faChessBishopAlt = faChessBishopPiece;
  

  
  

  var faFaceFrown = {
    prefix: 'fat',
    iconName: 'face-frown',
    icon: [
      512,
      512,
      [9785,"frown"],
      'f119',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM151.6 378.4c-1.3 4.2-5.8 6.6-10 5.3s-6.6-5.8-5.3-10C151.8 323.9 199.7 288 256 288s104.2 35.9 119.6 85.6c1.3 4.2-1 8.7-5.3 10s-8.7-1-10-5.3C347.1 335.5 305.5 304 256 304s-91.1 31.5-104.4 74.4zM160.4 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  
    var faFrown = faFaceFrown;
  

  
  

  var faDryer = {
    prefix: 'fat',
    iconName: 'dryer',
    icon: [
      448,
      512,
      [],
      'f861',
      
      'M384 16c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H384zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM96 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm80-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 336c-68 0-123.6-53-127.8-120H184c4.4 0 8-3.6 8-8s-3.6-8-8-8H96.2C100.4 229 156 176 224 176c70.7 0 128 57.3 128 128s-57.3 128-128 128zm0 16a144 144 0 1 0 0-288 144 144 0 1 0 0 288z'
      
    ]
  };

  

  
  

  var faWindowMaximize = {
    prefix: 'fat',
    iconName: 'window-maximize',
    icon: [
      512,
      512,
      [128470],
      'f2d0',
      
      'M64 51.2C39.3 51.2 19.2 71.3 19.2 96v80H492.8V96c0-24.7-20.1-44.8-44.8-44.8H64zM19.2 192V416c0 24.7 20.1 44.8 44.8 44.8H448c24.7 0 44.8-20.1 44.8-44.8V192H19.2zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z'
      
    ]
  };

  

  
  

  var faHouseChimney = {
    prefix: 'fat',
    iconName: 'house-chimney',
    icon: [
      576,
      512,
      [63499,"home-lg"],
      'e3af',
      
      'M282.7 2c3-2.7 7.6-2.7 10.6 0L384 82.3V56c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V195.7L573.3 250c3.3 2.9 3.6 8 .7 11.3s-8 3.6-11.3 .7L512 217.1V448c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V217.1L13.3 262c-3.3 2.9-8.4 2.6-11.3-.7S-.6 252.9 2.7 250L282.7 2zM496 181.5V56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8V96.5l96 85zM384 103.7l-96-85L80 202.9V448c0 26.5 21.5 48 48 48h80V328c0-13.3 10.7-24 24-24H344c13.3 0 24 10.7 24 24V496h80c26.5 0 48-21.5 48-48V202.9L384.3 104H384v-.3zM352 496V328c0-4.4-3.6-8-8-8H232c-4.4 0-8 3.6-8 8V496H352z'
      
    ]
  };

  
    var faHomeLg = faHouseChimney;
  

  
  

  var faArrowUpLeftFromCircle = {
    prefix: 'fat',
    iconName: 'arrow-up-left-from-circle',
    icon: [
      512,
      512,
      [],
      'e09e',
      
      'M184 0H8C3.6 0 0 3.6 0 8V184c0 4.4 3.6 8 8 8s8-3.6 8-8V27.3L314.3 325.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L27.3 16H184c4.4 0 8-3.6 8-8s-3.6-8-8-8zM288 64c-4.4 0-8 3.6-8 8s3.6 8 8 8c114.9 0 208 93.1 208 208s-93.1 208-208 208S80 402.9 80 288c0-4.4-3.6-8-8-8s-8 3.6-8 8c0 123.7 100.3 224 224 224s224-100.3 224-224S411.7 64 288 64z'
      
    ]
  };

  

  
  

  var faHeartCircleXmark = {
    prefix: 'fat',
    iconName: 'heart-circle-xmark',
    icon: [
      576,
      512,
      [],
      'e501',
      
      'M393.6 57.7c-42.9-5.6-85.8 12.6-111.2 47.6l-20 27.5c-1.5 2.1-3.9 3.3-6.5 3.3s-5-1.2-6.5-3.3l-20-27.5c-25.4-34.9-68.3-53.2-111.2-47.6C60.1 65.3 16 114.9 16 173.5c0 30.3 11.8 59.4 32.9 81.2L248 460.4c2.2 2.3 5.2 3.6 8.4 3.6s6.2-1.3 8.4-3.6l11-11.4c2.6 4.9 5.4 9.7 8.4 14.4l-7.8 8.1c-5.2 5.4-12.4 8.5-19.9 8.5c-7.5 0-14.7-3-19.9-8.4L37.4 265.8C13.4 241.1 0 208 0 173.5C0 106.8 50.2 50.4 116.3 41.8c48.6-6.3 97.4 14.3 126.2 54L256 114.4l13.5-18.6c28.9-39.7 77.6-60.4 126.2-54c66.1 8.6 116.3 65 116.3 131.8c0 12-1.6 23.9-4.8 35.3c-4.9-2.3-9.8-4.4-14.9-6.2c2.4-9.4 3.7-19.2 3.7-29C496 115 451.9 65.3 393.6 57.7zM560 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm205.7-50.3L443.3 368l50.3 50.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L432 379.3l-50.3 50.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L420.7 368l-50.3-50.3c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L432 356.7l50.3-50.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3z'
      
    ]
  };

  

  
  

  var faBus = {
    prefix: 'fat',
    iconName: 'bus',
    icon: [
      576,
      512,
      [128653],
      'f207',
      
      'M288 16C163.5 16 101.6 56.5 82.9 79.7C81 82.1 80 85.5 80 89.9V96H496l0-6.1c0-4.3-1-7.9-3-10.5C475.7 56.4 421.7 16 288 16zM80 256H280V112H80V256zm216 0H496V112H296V256zM80 392c0 22.1 17.9 40 40 40l0 0 56 0h16l178.3 0 13.7 0h16l56 0c0 0 0 0 .1 0c22.1 0 39.9-17.9 39.9-40l0-120H80V392zm304 56l-13.7 0L192 448v32c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V448v-5.4c-18.9-9-32-28.3-32-50.6V89.9c0-6.6 1.5-14.1 6.5-20.2C93.2 41.4 160.6 0 288 0C424.6 0 484.4 41.3 505.8 69.8c4.6 6.2 6.2 13.5 6.2 20.1V392c0 22.3-13.1 41.6-32 50.6V448v32c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V448zm72.1 0c0 0 0 0-.1 0l-56 0v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V448h-7.9zM120 448l-.1 0H112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V448l-56 0zm0-96a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm40 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm256-64a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM224 48H352c4.4 0 8 3.6 8 8s-3.6 8-8 8H224c-4.4 0-8-3.6-8-8s3.6-8 8-8zM0 136c0-13.3 10.7-24 24-24h8c4.4 0 8 3.6 8 8s-3.6 8-8 8H24c-4.4 0-8 3.6-8 8V248c0 4.4 3.6 8 8 8h8c4.4 0 8 3.6 8 8s-3.6 8-8 8H24c-13.3 0-24-10.7-24-24V136zm552-24c13.3 0 24 10.7 24 24V248c0 13.3-10.7 24-24 24h-8c-4.4 0-8-3.6-8-8s3.6-8 8-8h8c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8h-8c-4.4 0-8-3.6-8-8s3.6-8 8-8h8z'
      
    ]
  };

  

  
  

  var faPump = {
    prefix: 'fat',
    iconName: 'pump',
    icon: [
      640,
      512,
      [],
      'e442',
      
      'M128 48c-8.8 0-16-7.2-16-16s7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L128 48zM320 32c0-17.7-14.3-32-32-32H128C110.3 0 96 14.3 96 32s14.3 32 32 32V224H64c0-17.7-14.3-32-32-32s-32 14.3-32 32V384c0 17.7 14.3 32 32 32s32-14.3 32-32H320V368H64V240h72c4.4 0 8-3.6 8-8V64H272V232c0 4.4 3.6 8 8 8h40V224H288V64c17.7 0 32-14.3 32-32zm120.8 88.1c7.9-5.3 17.1-8.1 26.6-8.1H576c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H467.4c-9.5 0-18.7-2.8-26.6-8.1l-51.4-34.3C376 444.8 368 429.8 368 413.7V194.3c0-16 8-31 21.4-39.9l51.4-34.3zM380.5 141c-17.8 11.9-28.5 31.9-28.5 53.3V413.7c0 21.4 10.7 41.4 28.5 53.3l51.4 34.3c10.5 7 22.9 10.7 35.5 10.7H576c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H467.4c-12.6 0-25 3.7-35.5 10.7L380.5 141zM448 232c0 4.4 3.6 8 8 8H568c4.4 0 8-3.6 8-8s-3.6-8-8-8H456c-4.4 0-8 3.6-8 8zm0 72c0 4.4 3.6 8 8 8H568c4.4 0 8-3.6 8-8s-3.6-8-8-8H456c-4.4 0-8 3.6-8 8zm0 72c0 4.4 3.6 8 8 8H568c4.4 0 8-3.6 8-8s-3.6-8-8-8H456c-4.4 0-8 3.6-8 8zM48 224V384c0 8.8-7.2 16-16 16s-16-7.2-16-16V224c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faSignal = {
    prefix: 'fat',
    iconName: 'signal',
    icon: [
      640,
      512,
      [128246,"signal-5","signal-perfect"],
      'f012',
      
      'M584 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V504c0 4.4 3.6 8 8 8s8-3.6 8-8V8zM448 96c-4.4 0-8 3.6-8 8V504c0 4.4 3.6 8 8 8s8-3.6 8-8V104c0-4.4-3.6-8-8-8zM328 200c0-4.4-3.6-8-8-8s-8 3.6-8 8V504c0 4.4 3.6 8 8 8s8-3.6 8-8V200zM192 288c-4.4 0-8 3.6-8 8V504c0 4.4 3.6 8 8 8s8-3.6 8-8V296c0-4.4-3.6-8-8-8zM64 384c-4.4 0-8 3.6-8 8V504c0 4.4 3.6 8 8 8s8-3.6 8-8V392c0-4.4-3.6-8-8-8z'
      
    ]
  };

  
    var faSignal5 = faSignal;
  
    var faSignalPerfect = faSignal;
  

  
  

  var faFileCode = {
    prefix: 'fat',
    iconName: 'file-code',
    icon: [
      384,
      512,
      [],
      'f1c9',
      
      'M64 496c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm85.7 269.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-56 56c-3.1 3.1-3.1 8.2 0 11.3l56 56c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L99.3 320l50.3-50.3zm96-11.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L284.7 320l-50.3 50.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l56-56c3.1-3.1 3.1-8.2 0-11.3l-56-56z'
      
    ]
  };

  

  
  

  var faToiletPaperBlankUnder = {
    prefix: 'fat',
    iconName: 'toilet-paper-blank-under',
    icon: [
      512,
      512,
      ["toilet-paper-reverse-alt"],
      'e29f',
      
      'M45.4 65.8C63.6 33.7 87.4 16 112 16H354.8c-13.6 10.2-25.5 24.7-35.3 42C299.9 92.7 288 140.1 288 192s11.9 99.3 31.5 134c9.8 17.3 21.7 31.8 35.3 42H112c-24.6 0-48.4-17.7-66.6-49.8C27.4 286.3 16 241.7 16 192s11.4-94.3 29.4-126.2zM400 16c24.6 0 48.4 17.7 66.6 49.8C484.6 97.7 496 142.3 496 192s-11.4 94.3-29.4 126.2c-18.2 32.1-42 49.8-66.6 49.8s-48.4-17.7-66.6-49.8C315.4 286.3 304 241.7 304 192s11.4-94.3 29.4-126.2C351.6 33.7 375.4 16 400 16zm96 275.5V472c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V416H160v56c0 22.1 17.9 40 40 40H472c22.1 0 40-17.9 40-40V192c0-51.9-11.9-99.3-31.5-134C461 23.5 432.9 0 400 0H112C79.1 0 51 23.5 31.5 58C11.9 92.7 0 140.1 0 192s11.9 99.3 31.5 134C51 360.5 79.1 384 112 384H400c32.9 0 61-23.5 80.5-58c5.9-10.4 11.1-22 15.5-34.6zM420.6 255c4.8-4.8 8.4-10.8 11.1-17.1c5.4-12.6 8.3-28.8 8.3-45.9s-2.9-33.3-8.3-45.9c-2.7-6.3-6.3-12.3-11.1-17.1c-4.9-4.8-11.9-9-20.6-9s-15.7 4.2-20.6 9c-4.8 4.8-8.4 10.8-11.1 17.1c-5.4 12.6-8.3 28.8-8.3 45.9s2.9 33.3 8.3 45.9c2.7 6.3 6.3 12.3 11.1 17.1c4.9 4.8 11.9 9 20.6 9s15.7-4.2 20.6-9zM400 248c-13.3 0-24-25.1-24-56s10.7-56 24-56s24 25.1 24 56s-10.7 56-24 56z'
      
    ]
  };

  
    var faToiletPaperReverseAlt = faToiletPaperBlankUnder;
  

  
  

  var faFloppyDisks = {
    prefix: 'fat',
    iconName: 'floppy-disks',
    icon: [
      512,
      512,
      [],
      'e183',
      
      'M112 352V64c0-26.5 21.5-48 48-48v96c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V17.2c8.8 2 17 6.4 23.4 12.9l74.5 74.5c9 9 14.1 21.2 14.1 33.9V352c0 26.5-21.5 48-48 48H160c-26.5 0-48-21.5-48-48zM176 0H160C124.7 0 96 28.7 96 64V352c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V138.5c0-17-6.7-33.3-18.7-45.3L418.7 18.7C406.7 6.7 390.5 0 373.5 0H176zm16 128c-8.8 0-16-7.2-16-16V16H368v96c0 8.8-7.2 16-16 16H192zm48 144a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm144 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM0 160V448c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64H400c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V160c0-26.5 21.5-48 48-48V96C28.7 96 0 124.7 0 160z'
      
    ]
  };

  

  
  

  var faTowerObservation = {
    prefix: 'fat',
    iconName: 'tower-observation',
    icon: [
      512,
      512,
      [],
      'e586',
      
      'M252.3 .9c2.3-1.2 5.1-1.2 7.4 0l184 96c3.9 2 5.4 6.9 3.4 10.8s-6.9 5.4-10.8 3.4L416 100.5V184c0 22.1-17.9 40-40 40H345.7l52.9 272H504c4.4 0 8 3.6 8 8s-3.6 8-8 8H392.1h-.3H120.2h-.3H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H113.4l52.9-272H136c-22.1 0-40-17.9-40-40V100.5L75.7 111.1c-3.9 2-8.7 .5-10.8-3.4s-.5-8.7 3.4-10.8l184-96zM256 17L112 92.2V184c0 13.3 10.7 24 24 24h39.8 .3H335.9h.3H376c13.3 0 24-10.7 24-24V92.2L256 17zM382.3 496L377 468.7 256 373.6 135 468.7 129.7 496H382.3zM170.5 286.1L256 353.3l85.5-67.2L329.4 224H182.6l-12.1 62.1zm-3.4 17.7L139.7 444.6l103.4-81.2-76-59.7zm101.9 59.7l103.4 81.2L344.9 303.7l-76 59.7zM168 112c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8H344c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8H168zm-24 8c0-13.3 10.7-24 24-24H344c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H168c-13.3 0-24-10.7-24-24V120z'
      
    ]
  };

  

  
  

  var faPen = {
    prefix: 'fat',
    iconName: 'pen',
    icon: [
      512,
      512,
      [128394],
      'f304',
      
      'M395 25.9c12.5-12.5 32.8-12.5 45.3 0l45.8 45.8c12.5 12.5 12.5 32.8 0 45.3l-66.9 66.9L328.1 92.8 395 25.9zm-78.2 78.2l91.1 91.1L164.7 438.4c-10.4 10.4-23.3 18-37.4 22.2L19.8 492.2 51.4 384.7c4.2-14.1 11.8-27 22.2-37.4L316.8 104.1zM451.5 14.6c-18.7-18.7-49.1-18.7-67.9 0L62.3 336C50 348.3 41 363.5 36.1 380.2L.3 501.7c-.8 2.8-.1 5.8 2 7.9s5.1 2.8 7.9 2l121.6-35.8c16.7-4.9 31.9-13.9 44.2-26.2L497.4 128.3c18.7-18.7 18.7-49.1 0-67.9L451.5 14.6z'
      
    ]
  };

  

  
  

  var faUserSlash = {
    prefix: 'fat',
    iconName: 'user-slash',
    icon: [
      640,
      512,
      [],
      'f506',
      
      'M448 128C448 57.3 390.7 0 320 0c-51 0-95 29.8-115.6 73l12.9 10.2C234.6 43.6 274.1 16 320 16c61.9 0 112 50.1 112 112c0 36.6-17.5 69-44.6 89.5l12.9 10.2C429.4 204.2 448 168.3 448 128zm59.8 368H125.7c-7.6 0-13.7-6.1-13.7-13.7C112 392.7 184.7 320 274.3 320h10.6l-20-15.8C170.8 309.1 96 387 96 482.3c0 16.4 13.3 29.7 29.7 29.7H514.3c3.9 0 7.7-.8 11.1-2.1L507.8 496zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  

  
  

  var faManhole = {
    prefix: 'fat',
    iconName: 'manhole',
    icon: [
      512,
      512,
      [],
      'e1d6',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM80 256c0 75.9 48 140.5 115.3 165.2c15.9 5.9 30-3.1 37.2-10.9C238.3 404 246.7 400 256 400s17.7 4 23.6 10.4c7.2 7.8 21.2 16.7 37.2 10.9C384 396.5 432 331.9 432 256s-48-140.5-115.3-165.2c-15.9-5.9-30 3.1-37.2 10.9C273.7 108 265.3 112 256 112s-17.7-4-23.6-10.4c-7.2-7.8-21.2-16.7-37.2-10.9C128 115.5 80 180.1 80 256zM200.8 105.8c7.1-2.6 14.7 1.1 19.9 6.7C229.4 122 242 128 256 128s26.6-6 35.3-15.5c5.1-5.6 12.7-9.3 19.9-6.7C372.4 128.3 416 187 416 256s-43.6 127.7-104.8 150.2c-7.1 2.6-14.7-1.1-19.9-6.7C282.6 390 270 384 256 384s-26.6 6-35.3 15.5c-5.1 5.6-12.7 9.3-19.9 6.7C139.6 383.7 96 325 96 256s43.6-127.7 104.8-150.2zM176 192a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm0 64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm48-112a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-16 80a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm80-144a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-16 80a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 48a16 16 0 1 0 0 32 16 16 0 1 0 0-32z'
      
    ]
  };

  

  
  

  var faHexagon = {
    prefix: 'fat',
    iconName: 'hexagon',
    icon: [
      512,
      512,
      [11043],
      'f312',
      
      'M30.9 228c-10 17.3-10 38.7 0 56l88.3 152.9c10 17.3 28.5 28 48.5 28H344.3c20 0 38.5-10.7 48.5-28L481.1 284c10-17.3 10-38.7 0-56L392.8 75.1c-10-17.3-28.5-28-48.5-28H167.7c-20 0-38.5 10.7-48.5 28L30.9 228zM17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36H344.3c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36H167.7c-25.7 0-49.5-13.7-62.4-36L17.1 292z'
      
    ]
  };

  

  
  

  var faFileShield = {
    prefix: 'fat',
    iconName: 'file-shield',
    icon: [
      576,
      512,
      [],
      'e4f0',
      
      'M320 496H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9v33.6l16-6.4V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c10.9 0 21.2-2.7 30.2-7.6c-4.6-3.7-9.1-7.6-13.3-11.5c-5.3 2-11 3.1-16.9 3.1zm41.1-336H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3c.9 .9 1.7 1.8 2.4 2.7zM309 288.6l115-46V493.3c-96.1-42.9-120-138-120-197.3c0-3.3 2-6.2 5-7.4zM560 296c0 59.3-23.9 154.4-120 197.3V242.6l115 46c3 1.2 5 4.2 5 7.4zM440.9 225.7c-5.7-2.3-12.1-2.3-17.8 0l-120 48C294 277.4 288 286.2 288 296c0 63.3 25.9 168.8 134.8 214.2c5.9 2.5 12.6 2.5 18.5 0C550.1 464.8 576 359.3 576 296c0-9.8-6-18.6-15.1-22.3l-120-48z'
      
    ]
  };

  

  
  

  var faPersonMilitaryToPerson = {
    prefix: 'fat',
    iconName: 'person-military-to-person',
    icon: [
      512,
      512,
      [],
      'e54c',
      
      'M69.9 34.6C66.5 35 64 37.9 64 41.3C64 45 67 48 70.7 48H192V18.3L69.9 34.6zM48 41.3c0-11.4 8.4-21 19.7-22.5L189.9 2.4C199.5 1.1 208 8.6 208 18.3V48c0 8.8-7.2 16-16 16H70.7C58.2 64 48 53.8 48 41.3zM432 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM304 256v32c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V256c0-26.5-21.5-48-48-48H352c-26.5 0-48 21.5-48 48zM384 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM352 192h64c35.3 0 64 28.7 64 64v32c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V256c0-35.3 28.7-64 64-64zM64 96c0-5.5 .7-10.9 2-16H82.7C81 85 80 90.4 80 96c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H190c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64s-64-28.7-64-64zM48 256v32c0 8.8 7.2 16 16 16H192c.7 0 1.3 0 2-.1L69.5 216C56.5 224.6 48 239.3 48 256zm48-48c-3.1 0-6 .3-8.9 .8l120 84.7c.6-1.7 1-3.6 1-5.5V256c0-26.5-21.5-48-48-48H96zM32 256c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V256zM138 362.7c2.9-3.3 8-3.6 11.3-.7l72 64c1.7 1.5 2.7 3.7 2.7 6s-1 4.5-2.7 6l-72 64c-3.3 2.9-8.4 2.6-11.3-.7s-2.6-8.4 .7-11.3L195 440H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H195l-56.3-50c-3.3-2.9-3.6-8-.7-11.3zm224.7-.7c3.3-2.9 8.4-2.6 11.3 .7s2.6 8.4-.7 11.3L317 424H504c4.4 0 8 3.6 8 8s-3.6 8-8 8H317l56.3 50c3.3 2.9 3.6 8 .7 11.3s-8 3.6-11.3 .7l-72-64c-1.7-1.5-2.7-3.7-2.7-6s1-4.5 2.7-6l72-64z'
      
    ]
  };

  

  
  

  var faAudioDescription = {
    prefix: 'fat',
    iconName: 'audio-description',
    icon: [
      576,
      512,
      [],
      'f29e',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H512c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm192 64c3 0 5.8 1.7 7.2 4.4l55.9 111.9 .1 .3 31.9 63.8c2 4 .4 8.8-3.6 10.7s-8.8 .4-10.7-3.6L243.1 288H140.9l-29.8 59.6c-2 4-6.8 5.6-10.7 3.6s-5.6-6.8-3.6-10.7l31.9-63.8 .1-.3 55.9-111.9c1.4-2.7 4.1-4.4 7.2-4.4zm43.1 112L192 185.9 148.9 272h86.1zM312 168c0-4.4 3.6-8 8-8h64c53 0 96 43 96 96s-43 96-96 96H320c-4.4 0-8-3.6-8-8V168zm16 8V336h56c44.2 0 80-35.8 80-80s-35.8-80-80-80H328z'
      
    ]
  };

  

  
  

  var faArrowsMinimize = {
    prefix: 'fat',
    iconName: 'arrows-minimize',
    icon: [
      512,
      512,
      ["compress-arrows"],
      'e0a5',
      
      'M34.3 34.3c3.1-3.1 8.2-3.1 11.3 0L208 196.7V72c0-4.4 3.6-8 8-8s8 3.6 8 8V216c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8s3.6-8 8-8H196.7L34.3 45.7c-3.1-3.1-3.1-8.2 0-11.3zm443.3 0c3.1 3.1 3.1 8.2 0 11.3L315.3 208H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H296c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8s8 3.6 8 8V196.7L466.3 34.3c3.1-3.1 8.2-3.1 11.3 0zM72 304c-4.4 0-8-3.6-8-8s3.6-8 8-8H216c4.4 0 8 3.6 8 8V440c0 4.4-3.6 8-8 8s-8-3.6-8-8V315.3L45.7 477.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L196.7 304H72zm216-8c0-4.4 3.6-8 8-8H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H315.3L477.7 466.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L304 315.3V440c0 4.4-3.6 8-8 8s-8-3.6-8-8V296z'
      
    ]
  };

  
    var faCompressArrows = faArrowsMinimize;
  

  
  

  var faBootHeeled = {
    prefix: 'fat',
    iconName: 'boot-heeled',
    icon: [
      512,
      512,
      [],
      'e33f',
      
      'M29.1 0C13 0 0 13 0 29.1c0 2.6 .3 5.2 1 7.7C5.8 54.9 32 156.6 32 232c0 16.9-4.2 41.6-9.7 66.4c-5.4 24.7-12 48.9-16.6 64.9c-3.7 13-5.8 26.4-5.8 40V440v48c0 13.3 10.7 24 24 24H96c13.3 0 24-10.7 24-24V448h7c9.9 0 19.7 2.3 28.6 6.8L248.2 501c14.4 7.2 30.4 11 46.5 11H472h32c4.4 0 8-3.6 8-8s-3.6-8-8-8H480V458.8c0-19.4-10.1-37.5-26.6-47.7L313.9 325.3c-26-16-41.9-44.4-41.9-74.9V24c0-13.3-10.7-24-24-24H29.1zM16 448h88v40c0 4.4-3.6 8-8 8H24c-4.4 0-8-3.6-8-8V448zm96-16H16V403.3c0-12 1.8-24 5.1-35.6C25.7 351.6 32.4 327 38 301.9c5.5-24.9 10-51.1 10-69.9C48 154.3 21.2 50.6 16.5 32.7c-.3-1.2-.5-2.4-.5-3.5C16 21.9 21.9 16 29.1 16H112V248c0 4.4 3.6 8 8 8s8-3.6 8-8V16H248c4.4 0 8 3.6 8 8V250.4c0 36.1 18.7 69.6 49.5 88.6L445 424.8c11.8 7.3 19 20.2 19 34.1V496H294.7c-13.7 0-27.1-3.2-39.4-9.3l-92.5-46.3c-11.1-5.6-23.4-8.4-35.8-8.4H112z'
      
    ]
  };

  

  
  

  var faTicketAirline = {
    prefix: 'fat',
    iconName: 'ticket-airline',
    icon: [
      640,
      512,
      ["ticket-perforated-plane","ticket-plane"],
      'e29a',
      
      'M64 80c-26.5 0-48 21.5-48 48V384c0 26.5 21.5 48 48 48H576c26.5 0 48-21.5 48-48V320c-35.3 0-64-28.7-64-64s28.7-64 64-64V128c0-26.5-21.5-48-48-48H64zM0 128C0 92.7 28.7 64 64 64H576c35.3 0 64 28.7 64 64v66.4c0 8-8 13.6-16 13.6c-26.5 0-48 21.5-48 48s21.5 48 48 48c8 0 16 5.6 16 13.6V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm464 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM187.1 128h31.1c11.4 0 21.9 6 27.6 15.9L287.9 216h39c18.2 0 35.6 7.2 48.5 20.1c11 11 11 28.8 0 39.9c-12.9 12.9-30.3 20.1-48.5 20.1h-39l-42.1 72.1c-5.7 9.8-16.3 15.9-27.6 15.9H187.1c-10.9 0-18.6-10.7-15.2-21.1L194.2 296H156l-16.8 22.4c-4.5 6-11.6 9.6-19.2 9.6H106.2c-10.4 0-18-9.8-15.5-19.9l12.5-50.2c.3-1.3 .3-2.6 0-3.9L90.7 203.9c-2.5-10.1 5.1-19.9 15.5-19.9H120c7.6 0 14.7 3.6 19.2 9.6L156 216h38.2l-22.3-66.9c-3.5-10.4 4.3-21.1 15.2-21.1zm0 16l25.8 77.5c.8 2.4 .4 5.1-1.1 7.2s-3.9 3.3-6.5 3.3H152c-2.5 0-4.9-1.2-6.4-3.2l-19.2-25.6c-1.5-2-3.9-3.2-6.4-3.2H106.2l12.5 50.2c1 3.8 1 7.8 0 11.6L106.2 312l13.8 0c2.5 0 4.9-1.2 6.4-3.2l19.2-25.6c1.5-2 3.9-3.2 6.4-3.2h53.3c2.6 0 5 1.2 6.5 3.3s1.9 4.8 1.1 7.2L187.1 368h31.1c5.7 0 11-3 13.8-7.9L276.4 284c1.4-2.5 4.1-4 6.9-4h43.6c13.9 0 27.3-5.5 37.1-15.4c4.8-4.8 4.8-12.5 0-17.2c-9.9-9.9-23.2-15.4-37.1-15.4H283.3c-2.8 0-5.5-1.5-6.9-4L232 151.9c-2.9-4.9-8.1-7.9-13.8-7.9l-31.1 0z'
      
    ]
  };

  
    var faTicketPerforatedPlane = faTicketAirline;
  
    var faTicketPlane = faTicketAirline;
  

  
  

  var faHeat = {
    prefix: 'fat',
    iconName: 'heat',
    icon: [
      448,
      512,
      [],
      'e00c',
      
      'M176 32c4.4 0 8 3.6 8 8V144c0 39.8 12.9 78.6 36.8 110.4L240 280c26 34.6 40 76.7 40 120v72c0 4.4-3.6 8-8 8s-8-3.6-8-8V400c0-39.8-12.9-78.6-36.8-110.4L208 264c-26-34.6-40-76.7-40-120V40c0-4.4 3.6-8 8-8zM8 96c4.4 0 8 3.6 8 8v53.9c0 36.3 10.8 71.8 30.9 102.1l31.5 47.3C100.3 340 112 378.6 112 418.1V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V418.1c0-36.3-10.8-71.8-30.9-102.1L33.6 268.8C11.7 236 0 197.4 0 157.9V104c0-4.4 3.6-8 8-8zm344 8v53.9c0 36.3 10.8 71.8 30.9 102.1l31.5 47.3C436.3 340 448 378.6 448 418.1V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V418.1c0-36.3-10.8-71.8-30.9-102.1l-31.5-47.3C347.7 236 336 197.4 336 157.9V104c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faFaceSadCry = {
    prefix: 'fat',
    iconName: 'face-sad-cry',
    icon: [
      512,
      512,
      [128557,"sad-cry"],
      'f5b3',
      
      'M384 459.1V264c0-4.4-3.6-8-8-8s-8 3.6-8 8V468.3C334.6 486 296.5 496 256 496s-78.6-10-112-27.7V264c0-4.4-3.6-8-8-8s-8 3.6-8 8V459.1C60.7 416.5 16 341.5 16 256C16 123.5 123.5 16 256 16s240 107.5 240 240c0 85.5-44.7 160.5-112 203.1zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm48-128c0 26.5-21.5 48-48 48s-48-21.5-48-48V352c0-26.5 21.5-48 48-48s48 21.5 48 48v32zm-48-96c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64s64-28.7 64-64V352c0-35.3-28.7-64-64-64zM118.6 227.9c10.9-19.3 26.4-27.9 41-27.9s30.2 8.6 41 27.9c2.2 3.9 7 5.2 10.9 3.1s5.2-7 3.1-10.9c-13.1-23.4-33.6-36.1-55-36.1s-41.8 12.7-55 36.1c-2.2 3.9-.8 8.7 3.1 10.9s8.7 .8 10.9-3.1zm233-27.9c14.6 0 30.2 8.6 41 27.9c2.2 3.9 7 5.2 10.9 3.1s5.2-7 3.1-10.9c-13.1-23.4-33.6-36.1-55-36.1s-41.8 12.7-55 36.1c-2.2 3.9-.8 8.7 3.1 10.9s8.7 .8 10.9-3.1c10.9-19.3 26.4-27.9 41-27.9z'
      
    ]
  };

  
    var faSadCry = faFaceSadCry;
  

  
  

  var faEye = {
    prefix: 'fat',
    iconName: 'eye',
    icon: [
      576,
      512,
      [128065],
      'f06e',
      
      'M106.3 124.3C151.4 82.4 212.4 48 288 48s136.6 34.4 181.7 76.3c44.9 41.7 75 91.7 89.1 125.6c1.6 3.9 1.6 8.4 0 12.3C544.7 296 514.6 346 469.7 387.7C424.6 429.6 363.6 464 288 464s-136.6-34.4-181.7-76.3C61.4 346 31.3 296 17.2 262.2c-1.6-3.9-1.6-8.4 0-12.3C31.3 216 61.4 166 106.3 124.3zM288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM192 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm208 0a112 112 0 1 0 -224 0 112 112 0 1 0 224 0z'
      
    ]
  };

  

  
  

  var faBusSimple = {
    prefix: 'fat',
    iconName: 'bus-simple',
    icon: [
      448,
      512,
      ["bus-alt"],
      'f55e',
      
      'M18.9 79.7C37.6 56.5 99.5 16 224 16c133.7 0 187.7 40.4 205 63.4c1.9 2.6 3 6.2 3 10.5l0 6.1H16V89.9c0-4.3 1-7.8 2.9-10.2zM16 112H432V256H16V112zm0 160H432l0 120c0 22.1-17.9 40-39.9 40c0 0 0 0-.1 0l-56 0H320l-13.7 0L128 432H112l-56 0 0 0c-22.1 0-40-17.9-40-40V272zM416 442.6c18.9-9 32-28.3 32-50.6V89.9c0-6.6-1.5-13.9-6.2-20.1C420.4 41.3 360.6 0 224 0C96.6 0 29.2 41.4 6.5 69.7C1.5 75.8 0 83.3 0 89.9V392c0 22.3 13.1 41.6 32 50.6V448v32c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V448l178.3 0 13.7 0v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V448v-5.4zM392.1 448H400v32c0 8.8-7.2 16-16 16H352c-8.8 0-16-7.2-16-16V448l56 0c0 0 0 0 .1 0zM48 448h7.9l.1 0 56 0v32c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V448zm48-56a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM72 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm320 0a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm-40-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  
    var faBusAlt = faBusSimple;
  

  
  

  var faChestnut = {
    prefix: 'fat',
    iconName: 'chestnut',
    icon: [
      448,
      512,
      [127792],
      'e3f6',
      
      'M340 152c-14.8-14.8-30.9-28.3-47.6-42c-2.8-2.3-5.6-4.6-8.5-7l0 0c-13.9-11.4-28.2-23-41.8-35.4C234.3 60.5 228 54 224 48c-4 6-10.3 12.5-18.1 19.6C192.2 80 177.9 91.6 164 103l0 0c-2.8 2.3-5.7 4.6-8.5 7c-16.7 13.7-32.7 27.2-47.6 42C60 200 16 264 16 352c0 5.4 .4 10.8 1.1 16H430.9c.7-5.2 1.1-10.6 1.1-16c0-88-44-152-92-200zM20.6 384c13.8 46.3 56.6 80 107.4 80H320c50.7 0 93.6-33.7 107.4-80H20.6zM351.3 140.7C400.8 190.2 448 258 448 352c0 70.7-57.3 128-128 128H128C57.3 480 0 422.7 0 352c0-94 47.2-161.8 96.7-211.3c18.1-18.1 37.7-34.1 57.3-50.2c13.9-11.4 27.8-22.7 41.1-34.8c7.6-6.9 12.7-12.3 15.5-16.6c3-4.5 8-7.1 13.3-7.1s10.3 2.7 13.3 7.1c2.9 4.3 7.9 9.7 15.5 16.6c13.3 12.1 27.2 23.4 41.1 34.8c19.6 16.1 39.3 32.1 57.3 50.2z'
      
    ]
  };

  

  
  

  var faTape = {
    prefix: 'fat',
    iconName: 'tape',
    icon: [
      576,
      512,
      [],
      'f4db',
      
      'M224 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm83.3 416C389.8 430.9 448 350.3 448 256C448 132.3 347.7 32 224 32S0 132.3 0 256S100.3 480 224 480H568c4.4 0 8-3.6 8-8s-3.6-8-8-8H307.3zM224 176a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 176a96 96 0 1 0 0-192 96 96 0 1 0 0 192z'
      
    ]
  };

  

  
  

  var faBasketShopping = {
    prefix: 'fat',
    iconName: 'basket-shopping',
    icon: [
      576,
      512,
      ["shopping-basket"],
      'f291',
      
      'M340.2 1c-3.9 2.1-5.3 7-3.2 10.8L434.6 192H141.4L239 11.8c2.1-3.9 .7-8.7-3.2-10.8s-8.7-.7-10.8 3.2L123.2 192H48.5 32 8c-4.4 0-8 3.6-8 8s3.6 8 8 8H36L99.9 463.5C107 492 132.6 512 162 512H414c29.4 0 55-20 62.1-48.5L540 208h28c4.4 0 8-3.6 8-8s-3.6-8-8-8H544 527.5 452.8L351 4.2c-2.1-3.9-7-5.3-10.8-3.2zM52.5 208h471L460.6 459.6C455.3 481 436.1 496 414 496H162c-22 0-41.2-15-46.6-36.4L52.5 208zM208 296c0-4.4-3.6-8-8-8s-8 3.6-8 8V408c0 4.4 3.6 8 8 8s8-3.6 8-8V296zm80-8c-4.4 0-8 3.6-8 8V408c0 4.4 3.6 8 8 8s8-3.6 8-8V296c0-4.4-3.6-8-8-8zm96 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V408c0 4.4 3.6 8 8 8s8-3.6 8-8V296z'
      
    ]
  };

  
    var faShoppingBasket = faBasketShopping;
  

  
  

  var faHouseMedicalFlag = {
    prefix: 'fat',
    iconName: 'house-medical-flag',
    icon: [
      640,
      512,
      [],
      'e514',
      
      'M464 8V32H624c8.8 0 16 7.2 16 16V176c0 8.8-7.2 16-16 16H464V512H448V192h0V176 48 32h0V8c0-4.4 3.6-8 8-8s8 3.6 8 8zM624 176V48H464V176H624zM276.8 33.6L416 138v20L272 50 80 194V448c0 26.5 21.5 48 48 48l288 0v16H128c-35.3 0-64-28.7-64-64V206L20.8 238.4c-3.5 2.7-8.5 1.9-11.2-1.6s-1.9-8.5 1.6-11.2l256-192c2.8-2.1 6.8-2.1 9.6 0zM248 200v56c0 4.4-3.6 8-8 8H184c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h56c4.4 0 8 3.6 8 8v56c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V320c0-4.4 3.6-8 8-8h56c4.4 0 8-3.6 8-8V272c0-4.4-3.6-8-8-8H304c-4.4 0-8-3.6-8-8V200c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8zm8-24h32c13.3 0 24 10.7 24 24v48h48c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H312v48c0 13.3-10.7 24-24 24H256c-13.3 0-24-10.7-24-24V328H184c-13.3 0-24-10.7-24-24V272c0-13.3 10.7-24 24-24h48V200c0-13.3 10.7-24 24-24z'
      
    ]
  };

  

  
  

  var faMobileButton = {
    prefix: 'fat',
    iconName: 'mobile-button',
    icon: [
      384,
      512,
      [],
      'f10b',
      
      'M96 16C69.5 16 48 37.5 48 64V448c0 26.5 21.5 48 48 48H288c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H96zM32 64C32 28.7 60.7 0 96 0H288c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V64zM176 432a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z'
      
    ]
  };

  

  
  

  var faTerminal = {
    prefix: 'fat',
    iconName: 'terminal',
    icon: [
      576,
      512,
      [],
      'f120',
      
      'M34.2 45.5c-3.1-3.2-3-8.2 .2-11.3s8.2-3 11.3 .2l208 216c3 3.1 3 8 0 11.1l-208 216c-3.1 3.2-8.1 3.3-11.3 .2s-3.3-8.1-.2-11.3L236.9 256 34.2 45.5zM232 464H568c4.4 0 8 3.6 8 8s-3.6 8-8 8H232c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faCircleSortUp = {
    prefix: 'fat',
    iconName: 'circle-sort-up',
    icon: [
      512,
      512,
      ["sort-circle-up"],
      'e032',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM267.3 411.3c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l96 96 96-96c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-96 96zm0-310.6l96 96c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9H160c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l96-96c6.2-6.2 16.4-6.2 22.6 0zM256 112l-96 96H352l-96-96z'
      
    ]
  };

  
    var faSortCircleUp = faCircleSortUp;
  

  
  

  var faBanSmoking = {
    prefix: 'fat',
    iconName: 'ban-smoking',
    icon: [
      512,
      512,
      [128685,"smoking-ban"],
      'f54d',
      
      'M80.7 92L420 431.3C377.1 471.4 319.4 496 256 496C123.5 496 16 388.5 16 256c0-63.4 24.6-121.1 64.7-164zM235.3 224L92 80.7C134.9 40.6 192.6 16 256 16c132.5 0 240 107.5 240 240c0 63.4-24.6 121.1-64.7 164l-100-100H384c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H235.3zm16 16H384c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H315.3l-64-64zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm8-408c-4.4 0-8 3.6-8 8c0 22.1 17.9 40 40 40h48c13.3 0 24 10.7 24 24c0 4.4 3.6 8 8 8s8-3.6 8-8c0-22.1-17.9-40-40-40H296c-13.3 0-24-10.7-24-24c0-4.4-3.6-8-8-8zM252.1 304H128c-8.8 0-16-7.2-16-16V256c0-8.8 7.2-16 16-16h60.1l-16-16H128c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32H268.1l-16-16z'
      
    ]
  };

  
    var faSmokingBan = faBanSmoking;
  

  
  

  var faCartFlatbed = {
    prefix: 'fat',
    iconName: 'cart-flatbed',
    icon: [
      640,
      512,
      ["dolly-flatbed"],
      'f474',
      
      'M0 8C0 3.6 3.6 0 8 0H88c22.1 0 40 17.9 40 40V392c0 13.3 10.7 24 24 24h72H512 632c4.4 0 8 3.6 8 8s-3.6 8-8 8H547.8c7.6 8.5 12.2 19.7 12.2 32c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-12.3 4.6-23.5 12.2-32H259.8c7.6 8.5 12.2 19.7 12.2 32c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-12.3 4.6-23.5 12.2-32H152c-22.1 0-40-17.9-40-40V40c0-13.3-10.7-24-24-24H8c-4.4 0-8-3.6-8-8zM512 432a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM192 464a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM336 80H240c-17.7 0-32 14.3-32 32V304c0 17.7 14.3 32 32 32H560c17.7 0 32-14.3 32-32V112c0-17.7-14.3-32-32-32H464V216c0 3.1-1.8 6-4.7 7.3s-6.2 .8-8.6-1.2L400 178.5l-50.8 43.5c-2.4 2-5.7 2.5-8.6 1.2s-4.7-4.1-4.7-7.3V80zm16 0V198.6l42.8-36.7c3-2.6 7.4-2.6 10.4 0L448 198.6V80H352zM240 64H560c26.5 0 48 21.5 48 48V304c0 26.5-21.5 48-48 48H240c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48z'
      
    ]
  };

  
    var faDollyFlatbed = faCartFlatbed;
  

  
  

  var faCircleR = {
    prefix: 'fat',
    iconName: 'circle-r',
    icon: [
      512,
      512,
      [],
      'e120',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128c-13.3 0-24 10.7-24 24V280v96c0 4.4 3.6 8 8 8s8-3.6 8-8V288h92.3l77.6 93.1c2.8 3.4 7.9 3.9 11.3 1s3.9-7.9 1-11.3l-70.4-84.4c36.6-7.3 64.2-39.7 64.2-78.4c0-44.2-35.8-80-80-80H184zm88 144H176V152c0-4.4 3.6-8 8-8h88c35.3 0 64 28.7 64 64s-28.7 64-64 64z'
      
    ]
  };

  

  
  

  var faArrowUpRight = {
    prefix: 'fat',
    iconName: 'arrow-up-right',
    icon: [
      384,
      512,
      [],
      'e09f',
      
      'M344 96c4.4 0 8 3.6 8 8V344c0 4.4-3.6 8-8 8s-8-3.6-8-8V123.3L45.7 413.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L324.7 112H104c-4.4 0-8-3.6-8-8s3.6-8 8-8H344z'
      
    ]
  };

  

  
  

  var faDolphin = {
    prefix: 'fat',
    iconName: 'dolphin',
    icon: [
      512,
      512,
      [],
      'e168',
      
      'M48 140C48 71.5 103.5 16 172 16h40.3c44.7 0 87 10.3 124.6 28.7c2 1 4.3 1.1 6.4 .3C378.9 31.5 427.9 16 464 16c.2 0 .3 0 .4 0c.1 .4 .2 1.1 .2 2.4c0 4.9-2.1 12.8-6.1 22.9c-7.9 19.9-21.5 44.6-32.6 63.3c-1.8 3-1.4 6.7 .8 9.3C469.9 163.7 496 228.7 496 299.7C496 381.6 429.6 448 347.7 448h-87c-2.9 0-5.5 1.5-6.9 4c-14.9 25.9-42.1 42.5-72.2 43.9l33.3-60c1.3-2.4 1.3-5.4 0-7.8l-33.3-60c30.1 1.4 57.2 18 72.2 43.9c1.4 2.5 4.1 4 6.9 4H332c42 0 76-34 76-76s-34-76-76-76h-4c-4.4 0-8 3.6-8 8v61c0 10.5-8.5 19-19 19c-5 0-9.7-1.9-13.3-5.4L213.6 274c-2.1-2-5.1-2.8-7.9-2H42.2C27.7 272 16 260.3 16 245.8c0-9.3 4.9-17.9 13-22.6l29.1-17c3.7-2.1 5-6.7 3.1-10.5C52.8 179 48 160.1 48 140zM42.2 288H205.1l71.5 70c6.5 6.4 15.3 10 24.5 10c19.3 0 35-15.7 35-35V280.1c31.3 2.1 56 28.1 56 59.9c0 33.1-26.9 60-60 60H265.3c-18.9-29.6-51.8-48-87.6-48H168c-2.8 0-5.5 1.5-6.9 3.9s-1.5 5.5-.1 7.9L198.8 432 161 500.1c-1.4 2.5-1.3 5.5 .1 7.9s4.1 3.9 6.9 3.9h9.6c35.8 0 68.7-18.4 87.6-48h82.5C438.5 464 512 390.5 512 299.7c0-73-26.1-139.9-69.5-191.9c10.6-18.2 23.2-41.3 30.8-60.7c4.1-10.3 7.2-20.6 7.2-28.7c0-4.1-.7-8.8-3.7-12.6c-3.3-4.2-8-5.9-13-5.9c-38.1 0-87.7 15.6-123.2 28.9C301.8 10.4 258.2 0 212.3 0H172C94.7 0 32 62.7 32 140c0 19.9 4.2 38.9 11.7 56.1L20.9 209.4C8 217 0 230.8 0 245.8C0 269.1 18.9 288 42.2 288zM144 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faArrowsToLine = {
    prefix: 'fat',
    iconName: 'arrows-to-line',
    icon: [
      448,
      512,
      [],
      'e0a7',
      
      'M229.7 189.7c-3.1 3.1-8.2 3.1-11.3 0l-88-88c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L216 164.7V8c0-4.4 3.6-8 8-8s8 3.6 8 8V164.7l74.3-74.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-88 88zm0 132.7l88 88c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L232 347.3V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V347.3l-74.3 74.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l88-88c3.1-3.1 8.2-3.1 11.3 0zM8 248H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faFaucetDrip = {
    prefix: 'fat',
    iconName: 'faucet-drip',
    icon: [
      512,
      512,
      [128688],
      'e006',
      
      'M232 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V54.6L112.8 38.3C87.2 34.3 64 54.1 64 80s23.2 45.7 48.8 41.7L216 105.4V144H189.3c-10.6 0-20.8 4.2-28.3 11.7L124.7 192H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H128c2.1 0 4.2-.8 5.7-2.3L172.3 167c4.5-4.5 10.6-7 17-7h69.5c6.4 0 12.5 2.5 17 7l38.6 38.6c1.5 1.5 3.5 2.3 5.7 2.3h56c66.3 0 120 53.7 120 120v16c0 13.3-10.7 24-24 24H424c-13.2 0-24-10.7-24-24c0-22.1-17.9-40-40-40l-44.2 .1c-2.6 0-5 1.3-6.5 3.4c-18.8 26.9-50 44.4-85.3 44.4s-66.4-17.5-85.3-44.4c-1.5-2.1-3.9-3.4-6.5-3.4L8 304c-4.4 0-8 3.6-8 8s3.6 8 8 8l120.1 .2C150 349.2 184.8 368 224 368s74-18.8 95.9-47.8l40.1-.1c13.3 0 24 10.7 24 24c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V328c0-75.1-60.9-136-136-136H323.3L287 155.7c-7.5-7.5-17.7-11.7-28.3-11.7H232V105.4l103.2 16.3c25.6 4 48.8-15.7 48.8-41.7s-23.2-45.7-48.8-41.7L232 54.6V8zM216 70.8V89.2L110.3 105.9C94.4 108.4 80 96.1 80 80s14.4-28.4 30.3-25.9L216 70.8zm16 0L337.7 54.1C353.6 51.6 368 63.9 368 80s-14.4 28.4-30.3 25.9L232 89.2V70.8zM433.4 472L448 438 462.6 472c.9 2.1 1.4 4.4 1.4 6.8V480c0 8.8-7.2 16-16 16s-16-7.2-16-16v-1.2c0-2.3 .5-4.6 1.4-6.8zm-14.7-6.3c-1.8 4.1-2.7 8.6-2.7 13.1V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-1.2c0-4.5-.9-8.9-2.7-13.1l-18.2-42.4c-1.9-4.5-6.3-7.4-11.2-7.4s-9.2 2.9-11.2 7.4l-18.2 42.4z'
      
    ]
  };

  

  
  

  var faBarsProgress = {
    prefix: 'fat',
    iconName: 'bars-progress',
    icon: [
      512,
      512,
      ["tasks-alt"],
      'f828',
      
      'M464 80c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H320V80H464zM48 80H304V208H48c-17.7 0-32-14.3-32-32V112c0-17.7 14.3-32 32-32zm0-16C21.5 64 0 85.5 0 112v64c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zM464 304c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H192V304H464zM48 304H176V432H48c-17.7 0-32-14.3-32-32V336c0-17.7 14.3-32 32-32zm0-16c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H48z'
      
    ]
  };

  
    var faTasksAlt = faBarsProgress;
  

  
  

  var faNfcSymbol = {
    prefix: 'fat',
    iconName: 'nfc-symbol',
    icon: [
      512,
      512,
      [],
      'e531',
      
      'M137.8 34.3c-2.6-2.5-6.5-3-9.6-1.2C51.5 77.1 0 161.7 0 256s51.5 178.9 128.3 222.9c3.8 2.2 8.7 .9 10.9-3s.9-8.7-3-10.9C64.4 423.8 16 344.5 16 256C16 169.7 62.1 92.1 131 50L314.4 229.7c3.2 3.1 8.2 3 11.3-.1s3-8.2-.1-11.3L137.8 34.3zm239 443.5c2.6 2.5 6.5 3 9.6 1.2C461.9 434.8 512.5 350.2 512.5 256s-50.6-178.8-126.1-222.9c-3.8-2.2-8.7-.9-10.9 2.9s-.9 8.7 2.9 10.9C448.9 88.2 496.5 167.5 496.5 256c0 86.3-45.3 163.9-113 206l-186-179.7c-3.2-3.1-8.2-3-11.3 .2s-3 8.2 .2 11.3l190.4 184z'
      
    ]
  };

  

  
  

  var faSquareChevronUp = {
    prefix: 'fat',
    iconName: 'square-chevron-up',
    icon: [
      448,
      512,
      ["chevron-square-up"],
      'f32c',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm229.7 74.3l120 120c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L224 187.3 109.7 301.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l120-120c3.1-3.1 8.2-3.1 11.3 0z'
      
    ]
  };

  
    var faChevronSquareUp = faSquareChevronUp;
  

  
  

  var faHouseSignal = {
    prefix: 'fat',
    iconName: 'house-signal',
    icon: [
      576,
      512,
      [],
      'e012',
      
      'M330.8 1.9c3-2.6 7.4-2.6 10.4 0l232 200c3.3 2.9 3.7 7.9 .8 11.3s-7.9 3.7-11.3 .8L512 170.3V360c0 30.9-25.1 56-56 56H278.1c-1.5-5.4-3.2-10.7-5.1-16H456c22.1 0 40-17.9 40-40V156.5L336 18.6 176 156.5V272.1c-5.2-3.7-10.5-7.2-16-10.4V170.3l-50.8 43.8c-3.3 2.9-8.4 2.5-11.3-.8s-2.5-8.4 .8-11.3l232-200zM296 176h80c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H296c-13.3 0-24-10.7-24-24V200c0-13.3 10.7-24 24-24zm-8 24v80c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V200c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8zM8 256c137 0 248 111 248 248c0 4.4-3.6 8-8 8s-8-3.6-8-8C240 375.9 136.1 272 8 272c-4.4 0-8-3.6-8-8s3.6-8 8-8zM48 480a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM0 480a32 32 0 1 1 64 0A32 32 0 1 1 0 480zM0 360c0-4.4 3.6-8 8-8c83.9 0 152 68.1 152 152c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-75.1-60.9-136-136-136c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faFaceRaisedEyebrow = {
    prefix: 'fat',
    iconName: 'face-raised-eyebrow',
    icon: [
      512,
      512,
      [],
      'e388',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192.4 240a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm144 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm36-115l4.9 7.4c2.5 3.7 7.4 4.7 11.1 2.2s4.7-7.4 2.2-11.1l-4.9-7.4c-16.8-25.2-52.5-28.7-73.9-7.3l-29.5 29.5c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l29.5-29.5c14.3-14.3 38.1-11.9 49.3 4.9zM120 160c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8s-3.6-8-8-8H128c-4.4 0-8 3.6-8 8zm48 184c-4.4 0-8 3.6-8 8s3.6 8 8 8H344c4.4 0 8-3.6 8-8s-3.6-8-8-8H168z'
      
    ]
  };

  

  
  

  var faFaceZipper = {
    prefix: 'fat',
    iconName: 'face-zipper',
    icon: [
      512,
      512,
      [],
      'e3a5',
      
      'M256 16C123.5 16 16 123.5 16 256s107.5 240 240 240c36.9 0 71.9-8.3 103.1-23.2c4-1.9 8.8-.2 10.7 3.8s.2 8.8-3.8 10.7C332.7 503.1 295.4 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 22.8-3 45-8.6 66.1c-1.1 4.3-5.5 6.8-9.8 5.7s-6.8-5.5-5.7-9.8c5.3-19.8 8.1-40.5 8.1-61.9C496 123.5 388.5 16 256 16zM160.4 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM200 320c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8s-8-3.6-8-8V328c0-4.4 3.6-8 8-8zm72 8v48c0 4.4-3.6 8-8 8s-8-3.6-8-8V328c0-4.4 3.6-8 8-8s8 3.6 8 8zm56-8c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8s-8-3.6-8-8V328c0-4.4 3.6-8 8-8zm-184 8v48c0 4.4-3.6 8-8 8s-8-3.6-8-8V328c0-4.4 3.6-8 8-8s8 3.6 8 8zm240.8 2.3c7.2-7.2 18.1-9.1 27.2-4.7l61.8 29.2c40.9 19.3 50.3 73.3 18.3 105.3s-86 22.6-105.3-18.3L357.6 380c-4.3-9.2-2.4-20.1 4.7-27.2l22.5-22.5zm20.4 9.7c-3.1-1.4-6.7-.8-9.1 1.6l-22.5 22.5c-2.4 2.4-3 6-1.6 9.1l29.2 61.8c14.6 30.9 55.4 38 79.5 13.8s17.1-64.9-13.8-79.5L405.2 340zm56.5 73.6l-16 16c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l16-16c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3z'
      
    ]
  };

  

  
  

  var faCardDiamond = {
    prefix: 'fat',
    iconName: 'card-diamond',
    icon: [
      384,
      512,
      [],
      'e3ea',
      
      'M64 16C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48H320c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm203.3 84.7l96 96c6.2 6.2 6.2 16.4 0 22.6l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0zM96 256l11.3 11.3 73.4 73.4L192 352l11.3-11.3 73.4-73.4L288 256l-11.3-11.3-73.4-73.4L192 160l-11.3 11.3-73.4 73.4L96 256z'
      
    ]
  };

  

  
  

  var faSquareParking = {
    prefix: 'fat',
    iconName: 'square-parking',
    icon: [
      448,
      512,
      [127359,"parking"],
      'f540',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 32h96c48.6 0 88 39.4 88 88s-39.4 88-88 88H160v72c0 4.4-3.6 8-8 8s-8-3.6-8-8V296 144c0-8.8 7.2-16 16-16zm96 160c39.8 0 72-32.2 72-72s-32.2-72-72-72l-96 0V288h96z'
      
    ]
  };

  
    var faParking = faSquareParking;
  

  
  

  var faUserRobot = {
    prefix: 'fat',
    iconName: 'user-robot',
    icon: [
      448,
      512,
      [],
      'e04b',
      
      'M232 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H144c-44.2 0-80 35.8-80 80v96c0 44.2 35.8 80 80 80H304c44.2 0 80-35.8 80-80V144c0-44.2-35.8-80-80-80H232V8zM80 144c0-35.3 28.7-64 64-64H304c35.3 0 64 28.7 64 64v96c0 35.3-28.7 64-64 64H144c-35.3 0-64-28.7-64-64V144zM24 128c-4.4 0-8 3.6-8 8V248c0 4.4 3.6 8 8 8s8-3.6 8-8V136c0-4.4-3.6-8-8-8zm408 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V248c0 4.4 3.6 8 8 8s8-3.6 8-8V136zM160 184a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-40-24a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm192 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-24-40a40 40 0 1 0 0 80 40 40 0 1 0 0-80zM96 368H352c44.2 0 80 35.8 80 80v16c0 17.7-14.3 32-32 32H368V448c0-17.7-14.3-32-32-32H112c-17.7 0-32 14.3-32 32v48H48c-17.7 0-32-14.3-32-32V448c0-44.2 35.8-80 80-80zM368 512h32c26.5 0 48-21.5 48-48V448c0-53-43-96-96-96H96c-53 0-96 43-96 96v16c0 26.5 21.5 48 48 48H80 96 352h16zm-16-16H296V432h40c8.8 0 16 7.2 16 16v48zm-72 0H232V432h48v64zm-64 0H168V432h48v64zm-64 0H96V448c0-8.8 7.2-16 16-16h40v64zm8-264c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8s8-3.6 8-8V240c0-4.4-3.6-8-8-8zm56 8v32c0 4.4 3.6 8 8 8s8-3.6 8-8V240c0-4.4-3.6-8-8-8s-8 3.6-8 8zm72-8c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8s8-3.6 8-8V240c0-4.4-3.6-8-8-8z'
      
    ]
  };

  

  
  

  var faFaceMehBlank = {
    prefix: 'fat',
    iconName: 'face-meh-blank',
    icon: [
      512,
      512,
      [128566,"meh-blank"],
      'f5a4',
      
      'M256 16a240 240 0 1 0 0 480 240 240 0 1 0 0-480zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM160.4 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  
    var faMehBlank = faFaceMehBlank;
  

  
  

  var faForwardFast = {
    prefix: 'fat',
    iconName: 'forward-fast',
    icon: [
      512,
      512,
      [9197,"fast-forward"],
      'f050',
      
      'M504 64c-4.4 0-8 3.6-8 8V234.4L304.2 71c-5.3-4.5-12-7-19-7C269.1 64 256 77.1 256 93.2V248L48.2 71c-5.3-4.5-12-7-19-7C13.1 64 0 77.1 0 93.2V418.8C0 434.9 13.1 448 29.2 448c6.9 0 13.7-2.5 19-7L256 264V418.8c0 16.1 13.1 29.2 29.2 29.2c6.9 0 13.7-2.5 19-7L496 277.6V440c0 4.4 3.6 8 8 8s8-3.6 8-8V256 72c0-4.4-3.6-8-8-8zm-8 192c0 .4-.2 .8-.5 1L293.8 428.8c-2.4 2-5.4 3.2-8.6 3.2c-7.3 0-13.2-5.9-13.2-13.2V93.2c0-7.3 5.9-13.2 13.2-13.2c3.1 0 6.2 1.1 8.6 3.2L495.5 255c.3 .3 .5 .6 .5 1zm-256 .6L37.8 428.8c-2.4 2-5.4 3.2-8.6 3.2c-7.3 0-13.2-5.9-13.2-13.2V93.2C16 85.9 21.9 80 29.2 80c3.1 0 6.2 1.1 8.6 3.2L240 255.4v1.2z'
      
    ]
  };

  
    var faFastForward = faForwardFast;
  

  
  

  var faWineGlass = {
    prefix: 'fat',
    iconName: 'wine-glass',
    icon: [
      320,
      512,
      [127863],
      'f4e3',
      
      'M44.5 144h231l7 51.6C292.7 269.9 234.9 336 160 336S27.3 269.9 37.5 195.6l7-51.6zm2.2-16L60.1 29.8C61.2 21.9 67.9 16 75.9 16H244.1c8 0 14.8 5.9 15.9 13.8L273.3 128H46.7zM44.2 27.7L21.6 193.5C10.5 274.7 71.3 347.3 152 351.8V496H72c-4.4 0-8 3.6-8 8s3.6 8 8 8h88 88c4.4 0 8-3.6 8-8s-3.6-8-8-8H168V351.8c80.7-4.5 141.5-77.1 130.4-158.3L275.8 27.7C273.6 11.8 260.1 0 244.1 0H75.9c-16 0-29.5 11.8-31.7 27.7z'
      
    ]
  };

  

  
  

  var faTags = {
    prefix: 'fat',
    iconName: 'tags',
    icon: [
      512,
      512,
      [],
      'f02c',
      
      'M322.3 34.3c-3.1 3.1-3.2 8.2-.1 11.3L466 190.8c40.1 40.5 40.1 105.8 0 146.3L338.1 466.4c-3.1 3.1-3.1 8.2 .1 11.3s8.2 3.1 11.3-.1L477.3 348.4c46.3-46.8 46.3-122.1 0-168.8L333.6 34.4c-3.1-3.1-8.2-3.2-11.3-.1zM16 80c0-17.7 14.3-32 32-32H197.5c12.7 0 24.9 5.1 33.9 14.1l168 168c18.7 18.7 18.7 49.1 0 67.9L265.9 431.4c-18.7 18.7-49.1 18.7-67.9 0l-168-168c-9-9-14.1-21.2-14.1-33.9V80zM0 80V229.5c0 17 6.7 33.3 18.7 45.3l168 168c25 25 65.5 25 90.5 0L410.7 309.3c25-25 25-65.5 0-90.5l-168-168c-12-12-28.3-18.7-45.3-18.7H48C21.5 32 0 53.5 0 80zm112 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 64a40 40 0 1 0 0-80 40 40 0 1 0 0 80z'
      
    ]
  };

  

  
  

  var faArrowTurnRight = {
    prefix: 'fat',
    iconName: 'arrow-turn-right',
    icon: [
      512,
      512,
      [],
      'e635',
      
      'M357.7 381.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L484.7 232H72c-30.9 0-56 25.1-56 56V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V288c0-39.8 32.2-72 72-72H484.7L346.3 77.7c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l152 152c3.1 3.1 3.1 8.2 0 11.3l-152 152z'
      
    ]
  };

  

  
  

  var faHeadSideMedical = {
    prefix: 'fat',
    iconName: 'head-side-medical',
    icon: [
      512,
      512,
      [],
      'f809',
      
      'M16 222.9C16 108.6 108.6 16 222.9 16h16.8c71.6 0 137.5 43.3 166.4 105c3.5 7.4 6.9 15.1 10.4 22.9c6.4 14.3 12.9 28.9 20.1 42.7c11.3 21.6 24.8 42.2 43.5 58.9l3.8 3.4c7.7 6.9 12.1 16.7 12.1 27c0 20-16.2 36.2-36.2 36.2H440c-4.4 0-8 3.6-8 8v72c0 22.1-17.9 40-40 40H312c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8s8-3.6 8-8V448h72c30.9 0 56-25.1 56-56V328h11.8c28.8 0 52.2-23.4 52.2-52.2c0-14.9-6.4-29.1-17.5-39l-3.8-3.4c-16.7-14.9-29.2-33.6-40-54.4c-7-13.4-13.1-27.1-19.3-41c-3.5-7.9-7.1-15.9-10.8-23.9C389.1 46.9 317.6 0 239.7 0H222.9C99.8 0 0 99.8 0 222.9c0 52.8 16.9 101.5 47.4 139.9C57.5 375.5 64 390.2 64 405.3V504c0 4.4 3.6 8 8 8s8-3.6 8-8V405.3c0-19.8-8.5-37.8-20.1-52.4C31.8 317.5 16 272.3 16 222.9zM216 120c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H272c-4.4 0-8 3.6-8 8v56c0 4.4-3.6 8-8 8H224c-4.4 0-8-3.6-8-8V240c0-4.4-3.6-8-8-8H152c-4.4 0-8-3.6-8-8V192c0-4.4 3.6-8 8-8h56c4.4 0 8-3.6 8-8V120zm8-24c-13.3 0-24 10.7-24 24v48H152c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h48v48c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V248h48c13.3 0 24-10.7 24-24V192c0-13.3-10.7-24-24-24H280V120c0-13.3-10.7-24-24-24H224z'
      
    ]
  };

  

  
  

  var faFileCircleMinus = {
    prefix: 'fat',
    iconName: 'file-circle-minus',
    icon: [
      576,
      512,
      [],
      'e4ed',
      
      'M64 496H311.2c5.8 5.5 12 10.6 18.5 15.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H204.1c12.7 0 24.9 5.1 33.9 14.1L369.9 145.9c9 9 14.1 21.2 14.1 33.9v18.7c-5.4 1.5-10.8 3.3-16 5.4V179.9c0-1.3-.1-2.6-.2-3.9H248c-22.1 0-40-17.9-40-40V16.2c-1.3-.2-2.6-.2-3.9-.2H64C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48zM361.1 160c-.8-1-1.6-1.9-2.4-2.7L226.7 25.4c-.9-.9-1.8-1.7-2.7-2.4V136c0 13.3 10.7 24 24 24H361.1zM432 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm80 144c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8s3.6-8 8-8H504c4.4 0 8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faUserTieHairLong = {
    prefix: 'fat',
    iconName: 'user-tie-hair-long',
    icon: [
      448,
      512,
      [],
      'e460',
      
      'M336 144v-8-8c0-5.4-.4-10.8-1.1-16H312c-22.1 0-43-10.2-56.6-27.5L251 89.9C231.2 114 201.7 128 170.5 128L112 128v8 8c0 61.9 50.1 112 112 112s112-50.1 112-112zM292.4 39.3L265.8 71.8l1.4 1.8C277.8 87.7 294.4 96 312 96h19.4c-6.8-22.8-20.6-42.5-39-56.7zM113.1 112h57.4c26.4 0 51.4-11.8 68.1-32.3L279 30.4C262.7 21.2 244 16 224 16c-56.4 0-103.1 41.7-110.9 96zM390.4 244.8c-20.6-15.4-36.1-36.2-45.2-59.6C328.1 235.7 280.3 272 224 272s-104.1-36.3-121.2-86.8c-9.1 23.4-24.6 44.1-45.2 59.6L53.3 248c-3.4 2.5-5.3 6.5-5.3 10.7C48 266 54 272 61.3 272H120c4.4 0 8 3.6 8 8s-3.6 8-8 8H61.3C45.1 288 32 274.9 32 258.7c0-9.2 4.3-17.9 11.7-23.5L48 232c30.2-22.7 48-58.2 48-96v-8C96 57.3 153.3 0 224 0s128 57.3 128 128v8c0 37.8 17.8 73.3 48 96l4.3 3.2c7.4 5.5 11.7 14.2 11.7 23.5c0 16.2-13.1 29.3-29.3 29.3H328c-4.4 0-8-3.6-8-8s3.6-8 8-8h58.7c7.4 0 13.3-6 13.3-13.3c0-4.2-2-8.1-5.3-10.7l-4.3-3.2zM176.9 308.3c1.4-2.7 4.1-4.3 7.1-4.3h80c3 0 5.7 1.7 7.1 4.3s1.1 5.9-.6 8.3l-37.2 52.1 23.2 46.3 47.1-94.2c81.2 8.4 144.4 77 144.4 160.4c0 17-13.8 30.7-30.7 30.7H225.9h-3.8H30.7C13.8 512 0 498.2 0 481.3c0-83.4 63.3-152 144.4-160.4l47.1 94.2 23.2-46.3-37.2-52.1c-1.7-2.4-2-5.6-.6-8.3zM199.5 320L224 354.2 248.5 320H199.5zm10.1 167.2L135.3 338.3C67.5 350.6 16 409.9 16 481.3c0 8.1 6.6 14.7 14.7 14.7H214.1l-4.4-8.8zm-9.2-54.2l14.6 29.2L224 480l8.9-17.9 14.6-29.2L224 385.9l-23.5 47.1zM432 481.3c0-71.4-51.5-130.7-119.3-143L238.3 487.2l-4.4 8.8H417.3c8.1 0 14.7-6.6 14.7-14.7z'
      
    ]
  };

  

  
  

  var faTeethOpen = {
    prefix: 'fat',
    iconName: 'teeth-open',
    icon: [
      576,
      512,
      [],
      'f62f',
      
      'M480 48c44.2 0 80 35.8 80 80v64c0 26.5-21.5 48-48 48V196c0-33.1-26.9-60-60-60c-17.9 0-34.1 7.9-45.1 20.4C401.5 126.6 375.4 104 344 104c-24.1 0-45.1 13.3-56 33c-10.9-19.7-31.9-33-56-33c-31.4 0-57.5 22.6-62.9 52.4c-11-12.5-27.1-20.4-45.1-20.4c-33.1 0-60 26.9-60 60l0 44c-26.5 0-48-21.5-48-48V128c0-44.2 35.8-80 80-80H480zM168 196v44H80V196c0-24.3 19.7-44 44-44s44 19.7 44 44zm112-28v72H184V196 168c0-26.5 21.5-48 48-48s48 21.5 48 48zm112 28v44H296V168c0-26.5 21.5-48 48-48s48 21.5 48 48v28zm104 0v44H408V196c0-24.3 19.7-44 44-44s44 19.7 44 44zM64 256h8H176 288 400 504h8c35.3 0 64-28.7 64-64V128c0-53-43-96-96-96H96C43 32 0 75 0 128v64c0 35.3 28.7 64 64 64zM560 384c0 44.2-35.8 80-80 80H96c-44.2 0-80-35.8-80-80V352c0-26.5 21.5-48 48-48l0 36c0 33.1 26.9 60 60 60c19.9 0 37.5-9.7 48.4-24.6c9.4 23.8 32.5 40.6 59.6 40.6c24.1 0 45.1-13.3 56-33c10.9 19.7 31.9 33 56 33c27.1 0 50.2-16.8 59.6-40.6C414.5 390.3 432.1 400 452 400c33.1 0 60-26.9 60-60V304c26.5 0 48 21.5 48 48v32zM168 340c0 24.3-19.7 44-44 44s-44-19.7-44-44V304h88v36zm112 12c0 26.5-21.5 48-48 48s-48-21.5-48-48V340 304h96v48zm112-12v12c0 26.5-21.5 48-48 48s-48-21.5-48-48V304h96v36zm104 0c0 24.3-19.7 44-44 44s-44-19.7-44-44V304h88v36zM64 288c-35.3 0-64 28.7-64 64v32c0 53 43 96 96 96H480c53 0 96-43 96-96V352c0-35.3-28.7-64-64-64h-8H400 288 176 72 64z'
      
    ]
  };

  

  
  

  var faCommentMedical = {
    prefix: 'fat',
    iconName: 'comment-medical',
    icon: [
      512,
      512,
      [],
      'f7f5',
      
      'M157.3 415c-5-1.8-10.6-1-14.9 2.1c-11 8-29.4 19.3-51.2 28.8C68.3 456 41.6 464 16 464l.1-.1 0 0 0 0 .3-.3 .1-.1c.4-.4 .9-.9 1.5-1.6c1.3-1.4 3.2-3.6 5.4-6.3l-12.2-10 12.2 10C28 450 34 442 40 432c10.7-17.9 21.4-42.1 23.6-69.9c.3-4.3-1.1-8.6-3.9-11.8C31.9 318.8 16 280.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-35.2 0-68.6-6.1-98.7-17zM4.7 452.7l0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0zM232 152c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H288c-4.4 0-8 3.6-8 8v56c0 4.4-3.6 8-8 8H240c-4.4 0-8-3.6-8-8V272c0-4.4-3.6-8-8-8H168c-4.4 0-8-3.6-8-8V224c0-4.4 3.6-8 8-8h56c4.4 0 8-3.6 8-8V152zm8-24c-13.3 0-24 10.7-24 24v48H168c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h48v48c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V280h48c13.3 0 24-10.7 24-24V224c0-13.3-10.7-24-24-24H296V152c0-13.3-10.7-24-24-24H240z'
      
    ]
  };

  

  
  

  var faPanorama = {
    prefix: 'fat',
    iconName: 'panorama',
    icon: [
      640,
      512,
      [],
      'e209',
      
      'M16 77.6C16 61.3 29.3 48 45.6 48c3.3 0 6.5 .5 9.6 1.6C70.5 54.7 175.2 88 320 88s249.5-33.3 264.7-38.4c3.1-1 6.3-1.6 9.6-1.6C610.7 48 624 61.3 624 77.6V434.4c0 16.4-13.3 29.6-29.6 29.6c-3.3 0-6.5-.5-9.6-1.6c-2.6-.9-7.9-2.6-15.5-4.8l-166-221.3c-9.6-12.8-28.8-12.8-38.4 0L280 349.3l-36.8-49.1c-9.6-12.8-28.8-12.8-38.4 0L90.9 452.1c-18.8 4.8-31.2 8.8-35.7 10.3c-3.1 1-6.3 1.6-9.6 1.6C29.3 464 16 450.7 16 434.4V77.6zm99.3 368.6L217.6 309.9c3.2-4.3 9.6-4.3 12.8 0L270 362.7l-49.9 66.6c-41.7 4.4-77.3 10.9-104.7 17zm126.3-19l44.8-59.8 91.2-121.6c3.2-4.3 9.6-4.3 12.8 0l153.7 205C498.2 439.4 418.4 424 320 424c-27.7 0-54 1.2-78.4 3.2zM45.6 32C20.4 32 0 52.4 0 77.6V434.4C0 459.6 20.4 480 45.6 480c5.1 0 10-.8 14.7-2.4C74.6 472.8 177.6 440 320 440s245.4 32.8 259.6 37.6c4.7 1.6 9.7 2.4 14.7 2.4c25.2 0 45.6-20.4 45.6-45.6V77.6C640 52.4 619.6 32 594.4 32c-5 0-10 .8-14.7 2.4C565.4 39.2 462.4 72 320 72S74.6 39.2 60.4 34.4C55.6 32.8 50.7 32 45.6 32zM176 192a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-48-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faClipboardQuestion = {
    prefix: 'fat',
    iconName: 'clipboard-question',
    icon: [
      384,
      512,
      [],
      'e4e3',
      
      'M192 0c-37.1 0-67.6 28-71.6 64H112C91.1 64 73.3 77.4 66.7 96H64C28.7 96 0 124.7 0 160V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64h-2.7c-6.6-18.6-24.4-32-45.3-32h-8.4c-4-36-34.5-64-71.6-64zM16 160c0-26.5 21.5-48 48-48v16c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V112c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V160zM136 72c0-30.9 25.1-56 56-56s56 25.1 56 56c0 4.4 3.6 8 8 8h16c17.7 0 32 14.3 32 32v16c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V112c0-17.7 14.3-32 32-32h16c4.4 0 8-3.6 8-8zm56 24a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM104 264l0 6.5c0 4.4 3.6 8 8 8s8-3.6 8-8l0-6.5c0-22.1 17.9-40 40-40h56.2c26.4 0 47.8 21.4 47.8 47.8c0 16.1-8.1 31.1-21.5 39.9l-54.9 36.2c-2.2 1.5-3.6 4-3.6 6.7V384c0 4.4 3.6 8 8 8s8-3.6 8-8V358.9L251.3 325c17.9-11.8 28.7-31.8 28.7-53.3c0-35.2-28.6-63.8-63.8-63.8H160c-30.9 0-56 25.1-56 56zM208 432a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faCartCircleCheck = {
    prefix: 'fat',
    iconName: 'cart-circle-check',
    icon: [
      640,
      512,
      [],
      'e3f1',
      
      'M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8H45.7C57.1 16 67 24.1 69.2 35.4l59.4 303.4c5.1 26.3 28.2 45.2 55 45.2H320.7c-.5-5.3-.7-10.6-.7-16H183.5c-19.1 0-35.6-13.5-39.3-32.3L134.9 288H339.2c2.8-5.5 5.9-10.8 9.3-16H131.8L88 48H527.7c15.5 0 26.9 14.4 23.4 29.5L523.8 194.2c5.3 .8 10.5 1.9 15.7 3.2L566.6 81.1C572.5 56 553.4 32 527.7 32H84.8C81 13.4 64.7 0 45.7 0H8zM144 464a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM496 240a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm69.7-189.7c-3.1-3.1-8.2-3.1-11.3 0L480 396.7l-42.3-42.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l48 48c3.1 3.1 8.2 3.1 11.3 0l80-80c3.1-3.1 3.1-8.2 0-11.3z'
      
    ]
  };

  

  
  

  var faRoute = {
    prefix: 'fat',
    iconName: 'route',
    icon: [
      512,
      512,
      [],
      'f4d7',
      
      'M465.7 172.6c-17 27.2-37.1 52.3-49.7 67.1c-12.6-14.8-32.7-39.8-49.7-67.1C348.4 144 336 116.2 336 96c0-44.2 35.8-80 80-80s80 35.8 80 80c0 20.2-12.4 48-30.3 76.6zM427.4 251C452.9 221.1 512 146.2 512 96c0-53-43-96-96-96s-96 43-96 96c0 44.9 47.2 109.4 75.4 144H328c-39.8 0-72 32.2-72 72s32.2 72 72 72H440c30.9 0 56 25.1 56 56s-25.1 56-56 56H160c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c39.8 0 72-32.2 72-72s-32.2-72-72-72H328c-30.9 0-56-25.1-56-56s25.1-56 56-56h84.9c5.1 1.1 10.7-.6 14.5-5zM145.6 426c-17.1 25.8-37.2 49.1-49.6 62.7C83.6 475.1 63.5 451.8 46.4 426C28.5 398.9 16 372.1 16 352c0-44.2 35.8-80 80-80s80 35.8 80 80c0 20.1-12.5 46.9-30.4 74zM107 500.4c25.2-27.4 85-97.9 85-148.4c0-53-43-96-96-96s-96 43-96 96c0 50.5 59.8 121 85 148.4c6 6.5 16 6.5 21.9 0zM416 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM80 352a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faTruckField = {
    prefix: 'fat',
    iconName: 'truck-field',
    icon: [
      640,
      512,
      [],
      'e58d',
      
      'M320 48c26.5 0 48 21.5 48 48v8V208v16V368H244.7c-10.4-36.9-44.4-64-84.7-64s-74.2 27.1-84.7 64H48V288 272 144 128 96c0-26.5 21.5-48 48-48H320zM32 288v80H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H32 48 72.4c-.2 2.6-.4 5.3-.4 8c0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8H368h16 8.4c-.2 2.6-.4 5.3-.4 8c0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8H592h16 24c4.4 0 8-3.6 8-8s-3.6-8-8-8H608V272c0-35.3-28.7-64-64-64H516.9L472 118.1C465.2 104.6 451.4 96 436.2 96H384c0-35.3-28.7-64-64-64H96C60.7 32 32 60.7 32 96v32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32zm0-16c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16V272zm467.1-64H384V112h52.2c9.1 0 17.4 5.1 21.5 13.3L499.1 208zM384 368V224H511.8h.3H544c26.5 0 48 21.5 48 48v96H564.7c-10.4-36.9-44.4-64-84.7-64s-74.2 27.1-84.7 64H384zM88 392a72 72 0 1 1 144 0A72 72 0 1 1 88 392zm392-72a72 72 0 1 1 0 144 72 72 0 1 1 0-144z'
      
    ]
  };

  

  
  

  var faBasketShoppingPlus = {
    prefix: 'fat',
    iconName: 'basket-shopping-plus',
    icon: [
      576,
      512,
      [],
      'e653',
      
      'M337 11.8c-2.1-3.9-.7-8.7 3.2-10.8s8.7-.7 10.8 3.2L452.8 192h74.7H544h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H540L476.1 463.5C469 492 443.4 512 414 512H162c-29.4 0-55-20-62.1-48.5L36 208H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H32 48.5h74.7L225 4.2c2.1-3.9 7-5.3 10.8-3.2s5.3 7 3.2 10.8L141.4 192H434.6L337 11.8zM523.5 208H52.5l62.9 251.6C120.7 481 139.9 496 162 496H414c22 0 41.2-15 46.6-36.4L523.5 208zM200 352c0-4.4 3.6-8 8-8h72V272c0-4.4 3.6-8 8-8s8 3.6 8 8v72h72c4.4 0 8 3.6 8 8s-3.6 8-8 8H296v72c0 4.4-3.6 8-8 8s-8-3.6-8-8V360H208c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faUserCrown = {
    prefix: 'fat',
    iconName: 'user-crown',
    icon: [
      448,
      512,
      [],
      'f6a4',
      
      'M176.9 45.3l41.3-27.6c1.7-1.1 3.7-1.8 5.8-1.8s4.1 .6 5.8 1.8l41.3 27.6c5 3.4 11.6 3.6 16.8 .6L336 18.4V112H112V18.4l48.1 27.5c5.3 3 11.8 2.8 16.8-.6zM336 128v16c0 61.9-50.1 112-112 112s-112-50.1-112-112V128H336zM280 32L238.7 4.4C234.3 1.5 229.2 0 224 0s-10.3 1.5-14.7 4.4L168 32 114.9 1.7C113 .6 110.8 0 108.6 0C101.7 0 96 5.7 96 12.6V144c0 70.7 57.3 128 128 128s128-57.3 128-128V12.6c0-7-5.7-12.6-12.6-12.6c-2.2 0-4.4 .6-6.3 1.7L280 32zM168 320H280c83.9 0 152 68.1 152 152v8c0 8.8-7.2 16-16 16H32c-8.8 0-16-7.2-16-16v-8c0-83.9 68.1-152 152-152zm0-16C75.2 304 0 379.2 0 472v8c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32v-8c0-92.8-75.2-168-168-168H168z'
      
    ]
  };

  

  
  

  var faFaceClouds = {
    prefix: 'fat',
    iconName: 'face-clouds',
    icon: [
      640,
      512,
      [],
      'e47d',
      
      'M136 0c20.3 0 38.6 8.4 51.6 21.8c8.7-3.7 18.3-5.8 28.4-5.8c39.8 0 72 32.2 72 72s-32.2 72-72 72H64C28.7 160 0 131.3 0 96S28.7 32 64 32H76.1C89 12.7 111 0 136 0zM80.3 48H64C37.5 48 16 69.5 16 96s21.5 48 48 48H216c30.9 0 56-25.1 56-56s-25.1-56-56-56c-9.1 0-17.6 2.2-25.2 6c-4.1 2.1-9.3 1-12.3-2.5C168.2 23.6 153 16 136 16c-20.5 0-38.5 11.1-48.2 27.5c-1.6 2.7-4.3 4.5-7.4 4.5zm208-46.1C298.7 .7 309.3 0 320 0C461.4 0 576 114.6 576 256c0 7.3-.3 14.5-.9 21.7c-4.9-3.1-10-5.7-15.5-7.8c.3-4.6 .4-9.2 .4-13.8C560 123.5 452.5 16 320 16c-6.6 0-13.1 .3-19.5 .8c-3.6-5.3-7.7-10.3-12.1-14.8zM80 256c0 102.6 64.4 190.2 155 224.5c3.7 7.6 8.2 14.8 13.4 21.3C141.9 470.9 64 372.6 64 256c0-22.1 2.8-43.5 8.1-64H88.6C83 212.4 80 233.8 80 256zm144.4-48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM583.9 355.6C616.4 365.8 640 396.1 640 432c0 44.2-35.8 80-80 80H336c-44.2 0-80-35.8-80-80c0-39.1 28-71.6 65.1-78.6c7-46.1 46.8-81.4 94.9-81.4c28.7 0 54.5 12.6 72 32.5c9.4-5.4 20.3-8.5 32-8.5c33.9 0 61.6 26.3 63.9 59.6zM568 360c0-26.5-21.5-48-48-48c-10 0-19.3 3.1-27 8.3c-4.4 3-10.8 2.3-14.1-1.9C464.2 299.9 441.5 288 416 288c-41.5 0-75.6 31.6-79.6 72c-.4 4.4-4 7.9-8.4 8.5c-31.6 3.9-56 30.9-56 63.5c0 35.3 28.7 64 64 64H560c35.3 0 64-28.7 64-64c0-30-20.6-55.1-48.4-62.1c-4.4-1.1-7.6-5.3-7.6-9.9z'
      
    ]
  };

  

  
  

  var faAnchorCircleExclamation = {
    prefix: 'fat',
    iconName: 'anchor-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e4ab',
      
      'M352 80A64 64 0 1 1 224 80a64 64 0 1 1 128 0zM288 0c-44.2 0-80 35.8-80 80c0 41.5 31.6 75.6 72 79.6c0 .1 0 .3 0 .4v48H200c-4.4 0-8 3.6-8 8s3.6 8 8 8h80V496h-8C170.4 496 88 413.6 88 312V284.8l58.1 64.5c3 3.3 8 3.6 11.3 .6s3.6-8 .6-11.3l-72-80C84.4 257 82.3 256 80 256s-4.4 1-5.9 2.6l-72 80c-3 3.3-2.7 8.3 .6 11.3s8.3 2.7 11.3-.6L72 284.8V312c0 110.5 89.5 200 200 200h16 16c25.9 0 50.7-4.9 73.4-13.9c-4.3-3.9-8.5-8.1-12.4-12.5C346 492.3 325.4 496 304 496h-8V224h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H296V160c0-.1 0-.3 0-.4c40.4-4 72-38.1 72-79.6c0-44.2-35.8-80-80-80zm80 368a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 448a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-168c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8s8-3.6 8-8V288c0-4.4-3.6-8-8-8z'
      
    ]
  };

  

  
  

  var faFiles = {
    prefix: 'fat',
    iconName: 'files',
    icon: [
      448,
      512,
      [],
      'e178',
      
      'M192 400H384c26.5 0 48-21.5 48-48V123.9c0-4.1-.8-8.1-2.3-11.9H360c-13.3 0-24-10.7-24-24V18.3c-3.7-1.5-7.8-2.3-11.9-2.3H192c-26.5 0-48 21.5-48 48V352c0 26.5 21.5 48 48 48zM433.9 89.9c1.9 1.9 3.6 3.9 5.1 6.1h.9v1.3c5.2 7.8 8 17 8 26.5V352c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64H324.1c12.7 0 24.9 5.1 33.9 14.1l75.9 75.9zM360 96h57.4L352 30.6V88c0 4.4 3.6 8 8 8zM64 96H96v16H64c-26.5 0-48 21.5-48 48V448c0 26.5 21.5 48 48 48H256c26.5 0 48-21.5 48-48h16c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64z'
      
    ]
  };

  

  
  

  var faCircleCaretLeft = {
    prefix: 'fat',
    iconName: 'circle-caret-left',
    icon: [
      512,
      512,
      ["caret-circle-left"],
      'f32e',
      
      'M16 256a240 240 0 1 1 480 0A240 240 0 1 1 16 256zm496 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zm-352 0c0 7.3 3 14.3 8.4 19.3L277.6 377.2c4.7 4.4 10.8 6.8 17.2 6.8c13.9 0 25.2-11.3 25.2-25.2l0-205.6c0-13.9-11.3-25.2-25.2-25.2c-6.4 0-12.5 2.4-17.2 6.8L168.4 236.7c-5.4 5-8.4 12-8.4 19.3zM304 358.8c0 5.1-4.1 9.2-9.2 9.2c-2.3 0-4.6-.9-6.3-2.5L179.3 263.6c-2.1-2-3.3-4.7-3.3-7.6s1.2-5.6 3.3-7.6L288.5 146.5c1.7-1.6 4-2.5 6.3-2.5c5.1 0 9.2 4.1 9.2 9.2l0 205.6z'
      
    ]
  };

  
    var faCaretCircleLeft = faCircleCaretLeft;
  

  
  

  var faTrashXmark = {
    prefix: 'fat',
    iconName: 'trash-xmark',
    icon: [
      448,
      512,
      [],
      'e2b4',
      
      'M157.4 27.3L134.4 64H313.6l-23-36.7c-4.4-7-12.1-11.3-20.4-11.3H177.7c-8.3 0-16 4.3-20.4 11.3zM115.6 64l28.2-45.2C151.1 7.1 163.9 0 177.7 0h92.5c13.8 0 26.6 7.1 33.9 18.8L332.4 64H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H115.6zM39.3 112c4.4-.4 8.3 2.9 8.6 7.3l28.3 340C78 480.1 95.4 496 116.2 496H331.8c20.8 0 38.1-15.9 39.9-36.7l28.3-340c.4-4.4 4.2-7.7 8.6-7.3s7.7 4.2 7.3 8.6l-28.3 340c-2.4 29-26.7 51.4-55.8 51.4H116.2c-29.1 0-53.4-22.3-55.8-51.4L32 120.7c-.4-4.4 2.9-8.3 7.3-8.6zm107 98.3c3.1-3.1 8.2-3.1 11.3 0L224 276.7l66.3-66.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L235.3 288l66.3 66.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L224 299.3l-66.3 66.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L212.7 288l-66.3-66.3c-3.1-3.1-3.1-8.2 0-11.3z'
      
    ]
  };

  

  
  

  var faCat = {
    prefix: 'fat',
    iconName: 'cat',
    icon: [
      576,
      512,
      [128008],
      'f6be',
      
      'M336 18.9V128c0 53 43 96 96 96s96-43 96-96V18.9c0-1.6-1.3-2.9-2.9-2.9c-.9 0-1.7 .4-2.2 1L490.9 55.4c-4.6 5.5-11.3 8.6-18.4 8.6h-81c-7.1 0-13.9-3.2-18.4-8.6L341.1 17c-.6-.7-1.4-1-2.2-1c-1.6 0-2.9 1.3-2.9 2.9zM338.9 0c5.6 0 10.9 2.5 14.5 6.8l31.9 38.3c1.5 1.8 3.8 2.9 6.1 2.9h81c2.4 0 4.6-1.1 6.1-2.9L510.6 6.8c3.6-4.3 8.9-6.8 14.5-6.8C535.5 0 544 8.5 544 18.9V128c0 61.9-50.1 112-112 112s-112-50.1-112-112V18.9C320 8.5 328.5 0 338.9 0zM112 334.7c29.5-79.5 97.5-141.2 183.5-160.8c1.7 5.2 3.8 10.2 6 15C191.3 212.8 112 310.5 112 424v16c0 30.9 25.1 56 56 56h16H328h26.7c7.4 0 13.3-6 13.3-13.3c0-19.1-15.5-34.7-34.7-34.7H288c-4.4 0-8-3.6-8-8l0 0V400c0-26.5-21.5-48-48-48H200c-4.4 0-8-3.6-8-8s3.6-8 8-8h32c35.3 0 64 28.7 64 64v12.9L404.4 306.3c2.3-2.3 5.7-2.9 8.7-1.7s4.9 4.2 4.9 7.4V473c0 12.7 10.3 23 23 23s23-10.3 23-23V268.4c5.5-1.2 10.8-2.8 16-4.6V473c0 21.5-17.5 39-39 39s-39-17.5-39-39V331.1L299.4 432h33.9c28 0 50.7 22.7 50.7 50.7c0 16.2-13.1 29.3-29.3 29.3H328 184 168c-39.8 0-72-32.2-72-72V424 168.5c0-28.2-21-52.1-49.1-55.6l-7.9-1c-4.4-.5-7.5-4.5-6.9-8.9s4.5-7.5 8.9-6.9l7.9 1c36 4.5 63.1 35.1 63.1 71.4V334.7zM384 128a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faTruckFront = {
    prefix: 'fat',
    iconName: 'truck-front',
    icon: [
      512,
      512,
      [],
      'e2b7',
      
      'M96 16C60.7 16 32 44.7 32 80V261.4c10.2-14.4 24.5-25.6 41.3-31.9l-.8-.3 36.3-96.9C117 110.5 137.9 96 161.3 96H350.7c23.3 0 44.2 14.5 52.4 36.3l36.3 96.9-.8 .3c16.8 6.2 31.2 17.5 41.3 31.9V80c0-35.3-28.7-64-64-64H96zM32 312v72c0 26.5 21.5 48 48 48h48 16H368h16 48c26.5 0 48-21.5 48-48V312c0-39.8-32.2-72-72-72H104c-39.8 0-72 32.2-72 72zm-16 0V80C16 35.8 51.8 0 96 0H416c44.2 0 80 35.8 80 80V312v72c0 23.7-12.9 44.4-32 55.4V448v32c0 17.7-14.3 32-32 32H400c-17.7 0-32-14.3-32-32V448H144v32c0 17.7-14.3 32-32 32H80c-17.7 0-32-14.3-32-32V448v-8.6C28.9 428.4 16 407.7 16 384V312zM80 448H64v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V448H80zm304 0v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V448H432 384zM91.2 224.9c4.2-.6 8.5-.9 12.8-.9H408c4.3 0 8.6 .3 12.8 .9l-32.6-87c-5.9-15.6-20.8-26-37.5-26H161.3c-16.7 0-31.6 10.3-37.5 26l-32.6 87zM112 320a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm240 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z'
      
    ]
  };

  

  
  

  var faSquareQuarters = {
    prefix: 'fat',
    iconName: 'square-quarters',
    icon: [
      448,
      512,
      [],
      'e44e',
      
      'M64 48c-10.4 0-20 3.3-27.8 8.9L224 244.7 411.8 56.9C404 51.3 394.4 48 384 48H64zM24.9 68.2C19.3 76 16 85.6 16 96V416c0 10.4 3.3 20 8.9 27.8L212.7 256 24.9 68.2zM36.2 455.1C44 460.7 53.6 464 64 464H384c10.4 0 20-3.3 27.8-8.9L224 267.3 36.2 455.1zm386.9-11.3c5.6-7.8 8.9-17.4 8.9-27.8V96c0-10.4-3.3-20-8.9-27.8L235.3 256 423.1 443.8zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z'
      
    ]
  };

  

  
  

  var faFileDoc = {
    prefix: 'fat',
    iconName: 'file-doc',
    icon: [
      512,
      512,
      [],
      'e5ed',
      
      'M64 496h48v16H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H204.1c12.7 0 24.9 5.1 33.9 14.1L369.9 145.9c9 9 14.1 21.2 14.1 33.9V304H368V179.9c0-1.3-.1-2.6-.2-3.9H248c-22.1 0-40-17.9-40-40V16.2c-1.3-.2-2.6-.2-3.9-.2H64C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48zM361.1 160c-.8-1-1.6-1.9-2.4-2.7L226.7 25.4c-.9-.9-1.8-1.7-2.7-2.4V136c0 13.3 10.7 24 24 24H361.1zM176 368h32c22.1 0 40 17.9 40 40v64c0 22.1-17.9 40-40 40H176c-4.4 0-8-3.6-8-8V376c0-4.4 3.6-8 8-8zm8 128h24c13.3 0 24-10.7 24-24V408c0-13.3-10.7-24-24-24H184V496zM456 368h16c17.7 0 32 14.3 32 32v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-8.8-7.2-16-16-16H456c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-8c0-4.4 3.6-8 8-8s8 3.6 8 8v8c0 17.7-14.3 32-32 32H456c-17.7 0-32-14.3-32-32V400c0-17.7 14.3-32 32-32zM296 400c0-17.7 14.3-32 32-32h16c17.7 0 32 14.3 32 32v80c0 17.7-14.3 32-32 32H328c-17.7 0-32-14.3-32-32V400zm32-16c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H328z'
      
    ]
  };

  

  
  

  var faArrowDownFromDottedLine = {
    prefix: 'fat',
    iconName: 'arrow-down-from-dotted-line',
    icon: [
      448,
      512,
      [],
      'e090',
      
      'M16 64a16 16 0 1 1 32 0A16 16 0 1 1 16 64zM128 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm96 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm96 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM365.7 341.7l-136 136c-3.1 3.1-8.2 3.1-11.3 0l-136-136c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L216 452.7V328 168c0-4.4 3.6-8 8-8s8 3.6 8 8V328 452.7L354.3 330.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3z'
      
    ]
  };

  

  
  

  var faPhoneFlip = {
    prefix: 'fat',
    iconName: 'phone-flip',
    icon: [
      512,
      512,
      [128381,"phone-alt"],
      'f879',
      
      'M195 378.1c4.7 5.7 12.6 7.5 19.2 4.3c73.8-34.8 133.5-94.5 168.3-168.3c3.1-6.6 1.3-14.6-4.3-19.2l-49.3-40.4c-8.2-6.7-11-18-7-27.8l40-96c4.6-11.1 16.8-17.1 28.5-13.9l88 24C488.8 43.7 496 53.2 496 64c0 238.6-193.4 432-432 432c-10.8 0-20.3-7.2-23.2-17.7l-24-88c-3.2-11.6 2.8-23.8 13.9-28.5l96-40c9.8-4.1 21.1-1.3 27.8 7L195 378.1zM207.3 368L167 318.7c-11.2-13.7-30-18.4-46.3-11.6l-96 40c-18.6 7.7-28.5 28-23.2 47.4l24 88C30.2 499.9 46 512 64 512c247.4 0 448-200.6 448-448c0-18-12.1-33.8-29.5-38.6l-88-24c-19.4-5.3-39.7 4.6-47.4 23.2l-40 96c-6.8 16.3-2.1 35.2 11.6 46.3L368 207.3C334.8 277.7 277.8 334.7 207.3 368z'
      
    ]
  };

  
    var faPhoneAlt = faPhoneFlip;
  

  
  

  var faBridge = {
    prefix: 'fat',
    iconName: 'bridge',
    icon: [
      576,
      512,
      [],
      'e4c8',
      
      'M8 32c-4.4 0-8 3.6-8 8s3.6 8 8 8H88v96H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H568c4.4 0 8-3.6 8-8s-3.6-8-8-8H488V48h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zM472 48v96H360V48H472zM344 48v96H232V48H344zM216 48v96H104V48H216zM8 256c-4.4 0-8 3.6-8 8s3.6 8 8 8H32c39.8 0 72 32.2 72 72v96c0 22.1 17.9 40 40 40h32c22.1 0 40-17.9 40-40V344c0-39.8 32.2-72 72-72s72 32.2 72 72v96c0 22.1 17.9 40 40 40h32c22.1 0 40-17.9 40-40V344c0-39.8 32.2-72 72-72h24c4.4 0 8-3.6 8-8s-3.6-8-8-8H544c-48.6 0-88 39.4-88 88v96c0 13.3-10.7 24-24 24H400c-13.3 0-24-10.7-24-24V344c0-48.6-39.4-88-88-88s-88 39.4-88 88v96c0 13.3-10.7 24-24 24H144c-13.3 0-24-10.7-24-24V344c0-48.6-39.4-88-88-88H8z'
      
    ]
  };

  

  
  

  var faHatCowboy = {
    prefix: 'fat',
    iconName: 'hat-cowboy',
    icon: [
      640,
      512,
      [],
      'f8c0',
      
      'M264.8 51.4c4.2 2 7.7 4.8 12.1 8.6c.6 .5 1.3 1.1 2 1.7C287.2 69.2 299.4 80 320 80s32.8-10.8 41.1-18.2l0 0 0 0c.7-.6 1.3-1.2 2-1.7c4.4-3.8 7.9-6.6 12.1-8.6c4-1.9 9.1-3.4 16.8-3.4c2.3 0 6.2 1.1 11.7 6.5s11.4 13.7 17.4 25c11.9 22.5 22.6 53.2 31.5 84.8c8.8 31.5 15.8 63 20.5 86.8c.6 3.1 1.2 6.1 1.7 9c5.2-2 10.3-4.1 15.1-6.2C476.4 184.2 441.4 32 392 32c-21.3 0-31.6 9.1-41.2 17.6C342.3 57 334.4 64 320 64s-22.3-7-30.8-14.4C279.6 41.1 269.3 32 248 32c-49.3 0-84.4 152.2-97.9 221.9c4.8 2.1 9.9 4.2 15.1 6.2c.5-2.8 1.1-5.8 1.7-8.9c4.7-23.8 11.6-55.3 20.5-86.8c8.9-31.6 19.5-62.3 31.5-84.8c6-11.3 11.9-19.7 17.4-25s9.4-6.5 11.7-6.5c7.7 0 12.9 1.5 16.8 3.4zM29.6 234.3l0 0 .2 .2C105.8 307 221.5 336 320.1 336c98.6 0 214.2-29 290.1-101.4l0 0 .2-.2c2.6-2.6 6.7-3.1 9.9-1.1c2.9 1.8 4.5 5.9 3.2 9.6C580 364.2 446.8 432 320 432C193.2 432 60.1 364.1 16.5 242.8c-1.3-3.8 .3-7.8 3.2-9.6c3.1-2 7.2-1.5 9.9 1.1zM320 448c131.3 0 272.2-70.2 318.7-199.9c3.6-10.6-.4-22.6-9.9-28.5c-9.5-5.9-21.7-4.5-29.6 3.3c-71.9 68.6-182.8 97-279.1 97c-96.3 0-207.3-28.4-279.2-97c-7.9-7.9-20.2-9.2-29.6-3.3c-9.5 5.9-13.5 17.9-9.9 28.5C47.9 377.7 188.7 448 320 448z'
      
    ]
  };

  

  
  

  var faWarehouseFull = {
    prefix: 'fat',
    iconName: 'warehouse-full',
    icon: [
      640,
      512,
      ["warehouse-alt"],
      'f495',
      
      'M329.1 20.4c-5.8-2.4-12.4-2.4-18.2 0L40.8 131.2c-15 6.2-24.8 20.8-24.8 37V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V168.2c0-22.7 13.7-43.2 34.7-51.8L304.8 5.6c9.7-4 20.6-4 30.4 0L605.3 116.4c21 8.6 34.7 29.1 34.7 51.8V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V168.2c0-16.2-9.8-30.8-24.8-37L329.1 20.4zM120 208c-4.4 0-8 3.6-8 8V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V216c0-13.3 10.7-24 24-24H520c13.3 0 24 10.7 24 24V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V216c0-4.4-3.6-8-8-8H120zM320 320c0-8.8-7.2-16-16-16H192c-8.8 0-16 7.2-16 16v64H320V368 320zm0 80H176v80c0 8.8 7.2 16 16 16H320V400zm16 96H448c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16H336v96zm0-112h16 96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V400 384 320c0-17.7 14.3-32 32-32H304c17.7 0 32 14.3 32 32v48 16z'
      
    ]
  };

  
    var faWarehouseAlt = faWarehouseFull;
  

  
  

  var faCodeBranch = {
    prefix: 'fat',
    iconName: 'code-branch',
    icon: [
      448,
      512,
      [],
      'f126',
      
      'M80 112a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm64-48c0 32.6-24.4 59.6-56 63.5v169c18.4-29.2 50.9-48.5 88-48.5h96c48.6 0 88-39.4 88-88V127.5c-31.6-3.9-56-30.9-56-63.5c0-35.3 28.7-64 64-64s64 28.7 64 64c0 32.6-24.4 59.6-56 63.5V160c0 57.4-46.6 104-104 104H176c-48.6 0-88 39.4-88 88v16 16.5c31.6 3.9 56 30.9 56 63.5c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-32.6 24.4-59.6 56-63.5V368 352 127.5C40.4 123.6 16 96.6 16 64C16 28.7 44.7 0 80 0s64 28.7 64 64zm272 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM80 496a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faObjectSubtract = {
    prefix: 'fat',
    iconName: 'object-subtract',
    icon: [
      512,
      512,
      [],
      'e49e',
      
      'M128 16l96 0V0H128V16zM96 16V0H64C28.7 0 0 28.7 0 64V96H16l0-32c0-26.5 21.5-48 48-48l32 0zM0 224H16l0-96H0v96zm0 32v32c0 35.3 28.7 64 64 64H96V336H64c-26.5 0-48-21.5-48-48l0-32H0zm128 80v16h32l16 0h48V336H176l-16 0H128zm48 48H160l0 64c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64l-64 0v16l64 0c26.5 0 48 21.5 48 48l0 224c0 26.5-21.5 48-48 48l-224 0c-26.5 0-48-21.5-48-48l0-64zM352 64c0-35.3-28.7-64-64-64H256V16l32 0c26.5 0 48 21.5 48 48V96h16V64zm0 112V160 128H336v32l0 16v48h16V176zM256 336v16h32c35.3 0 64-28.7 64-64V256H336v32c0 26.5-21.5 48-48 48H256z'
      
    ]
  };

  

  
  

  var faHouseWater = {
    prefix: 'fat',
    iconName: 'house-water',
    icon: [
      576,
      512,
      ["house-flood"],
      'f74f',
      
      'M293.3 2c-3-2.7-7.6-2.7-10.6 0L2.7 250c-3.3 2.9-3.6 8-.7 11.3s8 3.6 11.3 .7L64 217.1V393c5.1-2.9 10.5-5.1 16-6.5V202.9L288 18.7 496 202.9V386.5c5.5 1.4 10.9 3.6 16 6.5V217.1L562.7 262c3.3 2.9 8.4 2.6 11.3-.7s2.6-8.4-.7-11.3L293.3 2zM216 208v96c0 13.3 10.7 24 24 24h96c13.3 0 24-10.7 24-24V208c0-13.3-10.7-24-24-24H240c-13.3 0-24 10.7-24 24zm24-8h96c4.4 0 8 3.6 8 8v96c0 4.4-3.6 8-8 8H240c-4.4 0-8-3.6-8-8V208c0-4.4 3.6-8 8-8zm54.6 235.4c-3-4.3-10.2-4.3-13.2 0c-8 11.2-17.5 21.4-27.6 30.7C236.6 481.8 214.5 496 192 496s-44.6-14.2-61.8-29.9c-10.1-9.2-19.7-19.5-27.6-30.7c-1.5-2.1-3.9-3.4-6.6-3.4s-5.1 1.3-6.6 3.4c-7.3 10.3-15.9 19.6-25 28.3C48.7 478.5 28.3 492.9 7 495.6c-4.4 .6-7.5 4.6-6.9 8.9s4.6 7.5 8.9 6.9c26.5-3.3 50-20.7 66.4-36.1c8.8-8.3 15.9-16.4 20.6-22.2c5.2 6.4 13.2 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8l0 0 0 0c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c4.7 5.8 11.8 13.9 20.6 22.2c16.4 15.4 39.9 32.8 66.4 36.1c4.4 .6 8.4-2.6 8.9-6.9s-2.6-8.4-6.9-8.9c-21.3-2.7-41.7-17.1-57.4-31.9c-9.1-8.6-17.7-18-25-28.3c-1.5-2.1-3.9-3.4-6.6-3.4s-5.1 1.3-6.6 3.4c-7.9 11.2-17.5 21.5-27.6 30.7C428.6 481.8 406.5 496 384 496s-44.6-14.2-61.8-29.9c-10.1-9.2-19.6-19.5-27.6-30.7z'
      
    ]
  };

  
    var faHouseFlood = faHouseWater;
  

  
  

  var faPopcorn = {
    prefix: 'fat',
    iconName: 'popcorn',
    icon: [
      448,
      512,
      [127871],
      'f819',
      
      'M181.3 26C173.2 19.7 163 16 152 16c-23.8 0-43.5 17.3-47.3 40l-.7 0c-26.5 0-48 21.5-48 48c0 6.2 1.2 12.2 3.4 17.7c-17.9 4.9-31.6 19.8-34.7 38.3H41c3.6-13.8 16.1-24 31-24c3 0 5.8-1.7 7.2-4.4s1.1-6-.8-8.4c-4-5.3-6.4-12-6.4-19.2c0-17.7 14.3-32 32-32c2.2 0 4.3 .2 6.4 .6c2.4 .5 4.8-.1 6.7-1.7s2.9-3.8 2.9-6.2l0-.8c0-17.7 14.3-32 32-32c10.8 0 20.3 5.3 26.1 13.5c1.9 2.6 5.1 3.9 8.3 3.2s5.6-3.2 6.1-6.4C195.2 27.3 208.3 16 224 16s28.8 11.3 31.5 26.3c.6 3.2 3 5.7 6.1 6.4s6.4-.5 8.3-3.2C275.7 37.3 285.2 32 296 32c17.7 0 32 14.3 32 32l0 0 0 .7c0 2.4 1 4.7 2.9 6.2s4.3 2.2 6.7 1.7c2.1-.4 4.2-.6 6.4-.6c17.7 0 32 14.3 32 32c0 4.6-1 9-2.7 13c-1 2.3-.9 5 .4 7.2s3.5 3.7 6 4C395.6 130 408 143.6 408 160h16c0-21.3-13.9-39.4-33.1-45.6c.7-3.3 1.1-6.8 1.1-10.4c0-26.5-21.5-48-48-48l-.7 0c-3.8-22.7-23.6-40-47.3-40c-11 0-21.2 3.7-29.3 10c-8-15.4-24.1-26-42.7-26s-34.7 10.6-42.7 26zM16.4 223.4c-.3-1.1-.4-2.2-.4-3.3c0-6.7 5.4-12.2 12.2-12.2H104c0 .4 0 .8 .1 1.1l32 224c.6 4.4 4.7 7.4 9.1 6.8s7.4-4.7 6.8-9.1L120.1 208H216V432c0 4.4 3.6 8 8 8s8-3.6 8-8V208h95.9L296.1 430.9c-.6 4.4 2.4 8.4 6.8 9.1s8.4-2.4 9.1-6.8l32-224c.1-.4 .1-.8 .1-1.1h75.8c6.7 0 12.2 5.4 12.2 12.2c0 1.1-.2 2.2-.4 3.3L362.3 472.6c-3.8 13.9-16.5 23.4-30.8 23.4h-215c-14.4 0-27-9.6-30.8-23.4L16.4 223.4zM1 227.7L70.2 476.8C76 497.6 94.9 512 116.5 512h215c21.6 0 40.5-14.4 46.2-35.2L447 227.7c.7-2.5 1-5 1-7.5c0-15.6-12.6-28.2-28.2-28.2H28.2C12.6 192 0 204.6 0 220.2c0 2.5 .3 5.1 1 7.5z'
      
    ]
  };

  

  
  

  var faFaceHandOverMouth = {
    prefix: 'fat',
    iconName: 'face-hand-over-mouth',
    icon: [
      512,
      512,
      [129762],
      'e378',
      
      'M16 256C16 123.5 123.5 16 256 16s240 107.5 240 240c0 99.6-60.7 185-147.1 221.4c-4.1 1.7-6 6.4-4.3 10.5s6.4 6 10.5 4.3C447.3 453.4 512 362.3 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 86 42.4 162 107.3 208.4c3.6 2.6 8.6 1.7 11.2-1.9s1.7-8.6-1.9-11.2C55.7 407.9 16 336.6 16 256zm160.4-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm176-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-43.7 84.7l9.2-9.2 6.8-6.8c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-6.8 6.8-9.2 9.2-46.6 46.6-4.7 4.7c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l4.7-4.7 46.6-46.6c2.3-2.3 5.2-3.8 8.3-4.4c5-1 10.4 .5 14.3 4.4c6.2 6.2 6.2 16.4 0 22.6l-22.8 22.8-9.2 9.2-14.6 14.6-4.7 4.7c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l4.7-4.7 14.6-14.6c2.3-2.3 5.2-3.8 8.3-4.4c5-1 10.4 .5 14.3 4.4c6.2 6.2 6.2 16.4 0 22.6l-56.8 56.8C288.7 486 264.4 496 239.2 496c-52.6 0-95.2-42.6-95.2-95.2V368 314.4c0-11 9-20 20-20s20 9 20 20v19.7c0 7.1 8.6 10.7 13.7 5.7l79-79c6.2-6.2 16.4-6.2 22.6 0c3.9 3.9 5.4 9.3 4.4 14.3c-.6 3-2 5.9-4.4 8.3l-46.6 46.6-4.7 4.7c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l4.7-4.7 46.6-46.6zm1.9-43.3c-12.5-12.5-32.8-12.5-45.3 0L200 314.7v-.3c0-19.9-16.1-36-36-36s-36 16.1-36 36V368v32.8C128 462.2 177.8 512 239.2 512c29.5 0 57.8-11.7 78.6-32.6l56.8-56.8c12.5-12.5 12.5-32.8 0-45.3c-3.3-3.3-7.2-5.8-11.4-7.3l11.4-11.4c12.5-12.5 12.5-32.8 0-45.3c-3.5-3.5-7.6-6-12-7.6c8.3-12.4 7-29.4-4-40.4s-28-12.3-40.4-4c-1.5-4.4-4.1-8.5-7.6-12z'
      
    ]
  };

  

  
  

  var faCircleK = {
    prefix: 'fat',
    iconName: 'circle-k',
    icon: [
      512,
      512,
      [],
      'e113',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm93.4-370.1c3.2-3 3.4-8.1 .5-11.3s-8.1-3.4-11.3-.5L176 280.2V136c0-4.4-3.6-8-8-8s-8 3.6-8 8V298.5 376c0 4.4 3.6 8 8 8s8-3.6 8-8V302l59.4-54.8L337.6 380.9c2.7 3.5 7.7 4.2 11.2 1.5s4.2-7.7 1.5-11.2L247.2 236.3l102.2-94.4z'
      
    ]
  };

  

  
  

  var faArrowRightFromArc = {
    prefix: 'fat',
    iconName: 'arrow-right-from-arc',
    icon: [
      512,
      512,
      [],
      'e4b1',
      
      'M16 256C16 123.5 123.5 16 256 16c4.4 0 8-3.6 8-8s-3.6-8-8-8C114.6 0 0 114.6 0 256S114.6 512 256 512c4.4 0 8-3.6 8-8s-3.6-8-8-8C123.5 496 16 388.5 16 256zM357.2 121.9c-3.4-2.8-8.4-2.4-11.3 1s-2.4 8.4 1 11.3L482.1 248H168c-4.4 0-8 3.6-8 8s3.6 8 8 8H482.1L346.8 377.9c-3.4 2.8-3.8 7.9-1 11.3s7.9 3.8 11.3 1l152-128c1.8-1.5 2.8-3.8 2.8-6.1s-1-4.6-2.8-6.1l-152-128z'
      
    ]
  };

  

  
  

  var faTypewriter = {
    prefix: 'fat',
    iconName: 'typewriter',
    icon: [
      512,
      512,
      [],
      'f8e7',
      
      'M112 16C94.3 16 80 30.3 80 48V160H64V48C64 21.5 85.5 0 112 0H359.4c12.7 0 24.9 5.1 33.9 14.1l40.6 40.6c9 9 14.1 21.2 14.1 33.9V160H432V88.6c0-8.5-3.4-16.6-9.4-22.6L382.1 25.4c-6-6-14.1-9.4-22.6-9.4H112zM16 224v32c0 8.8 7.2 16 16 16H480c8.8 0 16-7.2 16-16V224c0-8.8-7.2-16-16-16H365.3c-4.2 0-8.3 1.7-11.3 4.7l-13.3 13.3c-9 9-21.2 14.1-33.9 14.1H205.3c-12.7 0-24.9-5.1-33.9-14.1l-13.3-13.3c-3-3-7.1-4.7-11.3-4.7H32c-8.8 0-16 7.2-16 16zm326.6-22.6c6-6 14.1-9.4 22.6-9.4H480c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V288c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32H146.7c8.5 0 16.6 3.4 22.6 9.4l13.3 13.3c6 6 14.1 9.4 22.6 9.4H306.7c8.5 0 16.6-3.4 22.6-9.4l13.3-13.3zM48 288V448c0 26.5 21.5 48 48 48H416c26.5 0 48-21.5 48-48V288H48zM160 448H352c4.4 0 8 3.6 8 8s-3.6 8-8 8H160c-4.4 0-8-3.6-8-8s3.6-8 8-8zM144 336a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm16 80a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm48-80a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm16 80a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm48-80a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm16 80a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm48-80a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm16 80a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm48-80a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z'
      
    ]
  };

  

  
  

  var faCanFood = {
    prefix: 'fat',
    iconName: 'can-food',
    icon: [
      384,
      512,
      [129387],
      'e3e6',
      
      'M343 456.5c-7 6.7-17.9 13.5-32.7 19.6C280.9 488.2 239 496 192 496s-88.9-7.8-118.4-19.9c-14.8-6-25.7-12.8-32.7-19.6c-6.9-6.7-9-12.3-9-16.5V279.9c15.1 9.6 34.6 17.6 56.9 23.6c7.4 2 15.2 3.8 23.2 5.3c2.5 41.9 37.3 75.2 79.9 75.2s77.4-33.2 79.9-75.2c8.1-1.5 15.8-3.3 23.2-5.3c22.3-6 41.9-13.9 56.9-23.6V440c0 4.3-2 9.8-9 16.5zM271.2 292.6C265.7 253.8 232.3 224 192 224s-73.7 29.8-79.2 68.6c-6.8-1.4-13.4-2.9-19.7-4.6c-26.6-7.1-47.6-16.8-61.1-27.8V107.4c9.5 8.8 22.6 16.5 38.2 22.7c31.6 12.6 74.6 20.3 121.8 20.3s90.2-7.6 121.8-20.3c15.6-6.2 28.8-13.9 38.2-22.7V260.3c-13.5 10.9-34.5 20.6-61.1 27.8c-6.3 1.7-12.9 3.2-19.7 4.6zM352 75.2c0 6.4-3.2 13.2-10.7 20.3c-7.5 7.1-18.8 13.9-33.5 19.7C278.6 127 237.6 134.4 192 134.4s-86.6-7.4-115.8-19.1c-14.6-5.9-26-12.6-33.5-19.7C35.2 88.4 32 81.6 32 75.2s3.2-13.2 10.7-20.3C50.2 47.7 61.5 41 76.2 35.1C105.4 23.4 146.4 16 192 16s86.6 7.4 115.8 19.1c14.6 5.9 26 12.6 33.5 19.7c7.5 7.1 10.7 14 10.7 20.3zm16 0V72c0-39.8-78.8-72-176-72S16 32.2 16 72v3.2V440c0 39.8 78.8 72 176 72s176-32.2 176-72V75.2zM128 304a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  

  
  

  var faBorderCenterH = {
    prefix: 'fat',
    iconName: 'border-center-h',
    icon: [
      448,
      512,
      [],
      'f89c',
      
      'M8 248c-4.4 0-8 3.6-8 8s3.6 8 8 8l432 0c4.4 0 8-3.6 8-8s-3.6-8-8-8L8 248zM32 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0 384a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM128 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0 384a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm192-32a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0-352a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM224 432a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0-352a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM416 432a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0-384a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM224 336a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm192 32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM32 336a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM416 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM32 144a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm192 32a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faBookBookmark = {
    prefix: 'fat',
    iconName: 'book-bookmark',
    icon: [
      448,
      512,
      [],
      'e0bb',
      
      'M0 56C0 25.1 25.1 0 56 0H168 344h64c22.1 0 40 17.9 40 40V376c0 19.4-13.7 35.5-32 39.2V496h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H56c-30.9 0-56-25.1-56-56V56zM336 16H176V231.1l74.9-61.3c2.9-2.4 7.2-2.4 10.1 0L336 231.1V16zM160 16H56C33.9 16 16 33.9 16 56V416.8C26.2 406.4 40.3 400 56 400H408c13.3 0 24-10.7 24-24V40c0-13.3-10.7-24-24-24H352V248c0 3.1-1.8 5.9-4.6 7.2s-6.1 .9-8.5-1L256 186.3l-82.9 67.9c-2.4 2-5.7 2.4-8.5 1s-4.6-4.1-4.6-7.2V16zM56 416c-22.1 0-40 17.9-40 40s17.9 40 40 40H400V416H56z'
      
    ]
  };

  

  
  

  var faHandshakeSlash = {
    prefix: 'fat',
    iconName: 'handshake-slash',
    icon: [
      640,
      512,
      [],
      'e060',
      
      'M13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7zM398.2 399.3l-20-15.8c2.1 11.7-1.1 24.2-9.6 33.7c-15.4 17.3-42.2 18.1-58.6 1.7l-11.1-11.1c-1.7-1.7-4-2.5-6.4-2.3s-4.5 1.5-5.9 3.5c-1.9 2.8-4.2 5.4-6.9 7.8c-16.9 15.1-42.7 14.4-58.8-1.6l-39.9-39.9-20.6-20.6c-12-12-28.3-18.7-45.3-18.7H112V173.3L96 160.7V368c0 8.8-7.2 16-16 16H32c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16H74.8L54.6 128H32c-17.7 0-32 14.3-32 32V368c0 17.7 14.3 32 32 32H80c17.7 0 32-14.3 32-32V352h3.4c12.7 0 24.9 5.1 33.9 14.1l20.6 20.6 15.4 15.4 .1 .1 24.4 24.4c22.1 22.1 57.5 23.1 80.8 2.2c1.2-1.1 2.3-2.2 3.4-3.3l4.8 4.8c22.9 22.9 60.3 21.8 81.9-2.4c7.9-8.8 12.4-19.5 13.8-30.4c1.3 .7 2.5 1.3 3.8 1.9zM211.3 88.6C225.4 83 240.5 80 255.9 80h21.2L294 64H255.9c-20.5 0-40.6 4.6-58.9 13.4l14.2 11.2zm56.4 44.5l12.7 10 36.5-34.6c19.3-18.3 45-28.5 71.6-28.5c24.5 0 48.2 8.6 67 24.4L496 138.5V117.6L465.8 92.2C444.1 74 416.7 64 388.5 64c-30.7 0-60.3 11.8-82.6 32.9l-38.2 36.2zm81.9 64.6l12.7 10L375 195.9c3.2-3 3.4-8.1 .5-11.3s-8.1-3.4-11.3-.5l-14.7 13.6zM605.7 400H608c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H544h-8-8v16V336h-3.4L544 351.3V144h64c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16H585.4l20.3 16z'
      
    ]
  };

  

  
  

  var faPlaneDeparture = {
    prefix: 'fat',
    iconName: 'plane-departure',
    icon: [
      640,
      512,
      [128747],
      'f5b0',
      
      'M387.5 134.4l-207-77.6c-12.5-4.7-26.4-4-38.3 2L96.3 81.7l154.9 99.6c4.8 3.1 7.6 8.6 7.3 14.3s-3.7 10.9-8.8 13.4L143.2 262.3c-4.7 2.4-10.3 2.2-14.9-.3L71 230.2c-4.6-2.6-10.2-2.7-14.9-.3L25.5 245.1l73.1 85.3c3 3.5 7.5 5.6 12.1 5.6H248.4c2.5 0 4.9-.6 7.2-1.7L530.3 196.9c41.7-20.9 74-56.7 90.4-100.4c5.5-14.7-5.9-30.1-21.5-29.2l-52 3.1c-15.1 .9-29.9 4.8-43.5 11.6L400.3 133.7c-4 2-8.6 2.2-12.8 .7zM136 248l89.9-44.9 16.6-8.3-15.7-10.1L87.6 95.2C77.2 88.5 78 73 89.1 67.4L135 44.5c15.9-8 34.4-8.9 51.1-2.7l207 77.6L496.5 67.7C512 60 528.9 55.5 546.2 54.5l52-3.1c27.2-1.6 47 25.3 37.5 50.8c-17.8 47.4-52.9 86.4-98.2 109.1L262.8 348.6c-4.4 2.2-9.3 3.4-14.3 3.4H110.7c-9.3 0-18.2-4.1-24.3-11.2L13.3 255.6c-6.8-7.9-4.3-20.1 5-24.7l30.6-15.3c9.4-4.7 20.6-4.5 29.9 .6L136 248zM8 496H632c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faBuoy = {
    prefix: 'fat',
    iconName: 'buoy',
    icon: [
      576,
      512,
      [],
      'e5b5',
      
      'M200 0c-4.4 0-8 3.6-8 8s3.6 8 8 8h14.1L153.5 304H96c-17.7 0-32 14.3-32 32v16c0 13.3 1.8 26.1 5.2 38.3c4.9-2.3 10-3.9 15.3-4.8C81.5 374.8 80 363.6 80 352V336c0-8.8 7.2-16 16-16H480c8.8 0 16 7.2 16 16v16c0 11.6-1.5 22.8-4.4 33.5c5.2 1 10.4 2.6 15.3 4.8c3.4-12.2 5.2-25.1 5.2-38.3V336c0-17.7-14.3-32-32-32H422.5L361.9 16H376c4.4 0 8-3.6 8-8s-3.6-8-8-8H200zM345.5 16l13.2 62.6-70.7 82-70.7-82L230.5 16h115zM213.2 98.3l64.3 74.5L171.6 295.5 213.2 98.3zM288 185.1L390.5 304H185.5L288 185.1zM404.4 295.5L298.6 172.8l64.3-74.5 41.5 197.3zM294.6 435.4c-3-4.3-10.2-4.3-13.2 0c-8 11.2-17.5 21.4-27.6 30.7C236.6 481.8 214.5 496 192 496s-44.6-14.2-61.8-29.9c-10.1-9.2-19.7-19.5-27.6-30.7c-1.5-2.1-3.9-3.4-6.6-3.4s-5.1 1.3-6.6 3.4c-7.3 10.3-15.9 19.6-25 28.3C48.7 478.5 28.3 492.9 7 495.6c-4.4 .6-7.5 4.6-6.9 8.9s4.6 7.5 8.9 6.9c26.5-3.3 50-20.7 66.4-36.1c8.8-8.3 15.9-16.4 20.6-22.2c5.2 6.4 13.2 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8l0 0 0 0c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c4.7 5.8 11.8 13.9 20.6 22.2c16.4 15.4 39.9 32.8 66.4 36.1c4.4 .6 8.4-2.6 8.9-6.9s-2.6-8.4-6.9-8.9c-21.3-2.7-41.7-17.1-57.4-31.9c-9.1-8.6-17.7-18-25-28.3c-1.5-2.1-3.9-3.4-6.6-3.4s-5.1 1.3-6.6 3.4c-7.9 11.2-17.5 21.5-27.6 30.7C428.6 481.8 406.5 496 384 496s-44.6-14.2-61.8-29.9c-10.1-9.2-19.6-19.5-27.6-30.7z'
      
    ]
  };

  

  
  

  var faImageUser = {
    prefix: 'fat',
    iconName: 'image-user',
    icon: [
      512,
      512,
      [],
      'e1b8',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm304 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM160 356.6c0 6.3 5.1 11.4 11.4 11.4H340.6c6.3 0 11.4-5.1 11.4-11.4c0-29-23.5-52.6-52.6-52.6H212.6c-29 0-52.6 23.5-52.6 52.6zM256 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM212.6 288h86.9c37.9 0 68.6 30.7 68.6 68.6c0 15.1-12.3 27.4-27.4 27.4H171.4c-15.1 0-27.4-12.3-27.4-27.4c0-37.9 30.7-68.6 68.6-68.6z'
      
    ]
  };

  

  
  

  var faTicketsPerforated = {
    prefix: 'fat',
    iconName: 'tickets-perforated',
    icon: [
      640,
      512,
      [],
      'e63f',
      
      'M160 48H576c26.5 0 48 21.5 48 48v49.9c-.3 .1-.6 .3-.9 .4C596 153.6 576 178.5 576 208s20 54.4 47.1 61.8c.3 .1 .6 .2 .9 .4V320c0 26.5-21.5 48-48 48H160c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48zM96 96V320c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V268.8c0-7.1-5.8-12.6-12.7-14.5C607 248.8 592 230.1 592 208s15-40.8 35.3-46.3c6.8-1.9 12.7-7.4 12.7-14.5V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zm400 32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM16 96c0-4.4-3.6-8-8-8s-8 3.6-8 8V376c0 57.4 46.6 104 104 104H552c4.4 0 8-3.6 8-8s-3.6-8-8-8H104c-48.6 0-88-39.4-88-88V96z'
      
    ]
  };

  

  
  

  var faCircleQuestion = {
    prefix: 'fat',
    iconName: 'circle-question',
    icon: [
      512,
      512,
      [62108,"question-circle"],
      'f059',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm168-56c0-30.9 25.1-56 56-56h56.2c35.2 0 63.8 28.6 63.8 63.8c0 21.4-10.8 41.5-28.7 53.3L264 294.9V320c0 4.4-3.6 8-8 8s-8-3.6-8-8V290.5c0-2.7 1.4-5.2 3.6-6.7l54.9-36.2c13.4-8.8 21.5-23.8 21.5-39.9c0-26.4-21.4-47.8-47.8-47.8H224c-22.1 0-40 17.9-40 40l0 6.5c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-6.5zm72 168a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  
    var faQuestionCircle = faCircleQuestion;
  

  
  

  var faFileImage = {
    prefix: 'fat',
    iconName: 'file-image',
    icon: [
      384,
      512,
      [128443],
      'f1c5',
      
      'M320 496c26.5 0 48-21.5 48-48V179.9c0-1.3-.1-2.6-.2-3.9H248c-22.1 0-40-17.9-40-40V16.2c-1.3-.2-2.6-.2-3.9-.2H64C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48H320zm41.1-336c-.8-1-1.6-1.9-2.4-2.7L226.7 25.4c-.9-.9-1.8-1.7-2.7-2.4V136c0 13.3 10.7 24 24 24H361.1zM0 64C0 28.7 28.7 0 64 0H204.1c12.7 0 24.9 5.1 33.9 14.1L369.9 145.9c9 9 14.1 21.2 14.1 33.9V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM56 224a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm40 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm78.6 116.6c-1.4 2.1-3.8 3.3-6.3 3.4s-4.9-1-6.5-3l-29.6-36.9c0 0-.1-.1-.1-.1s-.1 0-.1 .1L66 416c-1.3 1.7-2 3.8-2 6c0 5.5 4.5 10 10 10H309.8c5.6 0 10.2-4.6 10.2-10.2c0-2.1-.7-4.2-1.9-5.9L228 288.2l-53.5 76.4zM228 272c5.1 0 9.9 2.5 12.8 6.6l90.4 128c3.1 4.4 4.8 9.7 4.8 15.1c0 14.5-11.7 26.2-26.2 26.2H74c-14.4 0-26-11.6-26-26c0-5.6 1.8-11.1 5.2-15.6l66-87.9c3.1-4.1 7.8-6.5 12.9-6.5c4.9 0 9.6 2.2 12.6 6.1l22.9 28.6 47.6-68c2.9-4.2 7.7-6.7 12.9-6.7z'
      
    ]
  };

  

  
  

  var faRupeeSign = {
    prefix: 'fat',
    iconName: 'rupee-sign',
    icon: [
      448,
      512,
      [8360,"rupee"],
      'f156',
      
      'M0 72C0 49.9 17.9 32 40 32h80c75.1 0 136 60.9 136 136c0 68.7-50.9 125.5-117.1 134.7l60.6 166.6c1.5 4.2-.6 8.7-4.8 10.2s-8.7-.6-10.3-4.8L122.4 304c-.8 0-1.6 0-2.4 0H16V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V296 72zM16 288H120c66.3 0 120-53.7 120-120s-53.7-120-120-120H40C26.7 48 16 58.7 16 72V288zm363-78.1c-48.9-8.7-85.2 12.6-90.1 44.4c-1.8 11.7-.6 20.7 2.4 27.9c3 7.2 8.1 13.2 14.9 18.5c13.9 10.7 33.8 17.5 55.6 25l1.1 .4c21.4 7.3 44.7 15.4 61.2 29.1c8.5 7 15.4 15.6 19.6 26.5s5.3 23.5 3.1 38.2c-3.7 24-17.5 41.2-37.4 50.9c-19.6 9.5-44.7 11.6-71.3 6.9l-.1 0c-8.6-1.6-20.3-5.5-31.3-9.5c-7.3-2.7-14.7-5.5-21-7.9l0 0c-3.2-1.3-6.2-2.4-8.7-3.3c-4.1-1.6-6.2-6.2-4.7-10.3s6.2-6.2 10.3-4.7c2.7 1 5.8 2.2 9.1 3.5l0 0c6.2 2.4 13.2 5.1 20.4 7.7c11 4 21.5 7.4 28.7 8.8c24.3 4.3 45.7 2.1 61.4-5.5c15.4-7.5 25.8-20.3 28.6-38.9c1.9-12.5 .8-22.2-2.2-30.1c-3-7.8-8.1-14.3-14.8-19.9c-13.9-11.5-34.2-18.7-56.2-26.3l-2.5-.8c-20.6-7.1-42.7-14.6-58.7-26.9c-8.5-6.6-15.6-14.7-19.9-25c-4.3-10.4-5.6-22.4-3.5-36.5c6.8-44.8 55.7-67.2 108.7-57.8c8 1.4 32.1 6.7 40.5 9.2c4.2 1.3 6.6 5.7 5.3 10s-5.7 6.6-10 5.3c-7.6-2.3-31-7.5-38.7-8.8z'
      
    ]
  };

  
    var faRupee = faRupeeSign;
  

  
  

  var faDiagramNested = {
    prefix: 'fat',
    iconName: 'diagram-nested',
    icon: [
      448,
      512,
      [],
      'e157',
      
      'M144 48c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V80c0-17.7 14.3-32 32-32h96zM48 32C21.5 32 0 53.5 0 80v96c0 26.5 21.5 48 48 48H88v96c0 39.8 32.2 72 72 72h96v40c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48v40H160c-30.9 0-56-25.1-56-56V224h40c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zM400 304c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H304c-17.7 0-32-14.3-32-32V336c0-17.7 14.3-32 32-32h96z'
      
    ]
  };

  

  
  

  var faVectorPolygon = {
    prefix: 'fat',
    iconName: 'vector-polygon',
    icon: [
      448,
      512,
      [],
      'e2c7',
      
      'M416 48c8.8 0 16 7.2 16 16V96c0 8.8-7.2 16-16 16H384c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h32zM384 32c-17.7 0-32 14.3-32 32v8H96V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64V96c0 17.7 14.3 32 32 32h8l0 256H32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32v-8H352v8c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V416c0-17.7-14.3-32-32-32H384c-3.2 0-6.2 .5-9.1 1.3l-52.3-87.2c8.1-5.8 13.4-15.3 13.4-26.1V240c0-10.8-5.3-20.3-13.4-26.1l52.3-87.2c2.9 .9 5.9 1.3 9.1 1.3h32c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H384zM307.4 303.8l53.8 89.7c-5.7 5.8-9.2 13.7-9.2 22.5v8H96v-8c0-17.7-14.3-32-32-32H56l0-256h8c17.7 0 32-14.3 32-32V88H352v8c0 8.7 3.5 16.7 9.2 22.5l-53.8 89.7c-1.1-.1-2.2-.2-3.4-.2H272c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c1.1 0 2.3-.1 3.4-.2zM32 400H64c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H32c-8.8 0-16-7.2-16-16V416c0-8.8 7.2-16 16-16zm352 0h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H384c-8.8 0-16-7.2-16-16V416c0-8.8 7.2-16 16-16zM32 48H64c8.8 0 16 7.2 16 16V96c0 8.8-7.2 16-16 16H32c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16zM304 224c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16h32z'
      
    ]
  };

  

  
  

  var faBugs = {
    prefix: 'fat',
    iconName: 'bugs',
    icon: [
      576,
      512,
      [],
      'e4d0',
      
      'M153.2 101.2l38.2-90c1.7-4.1-.2-8.8-4.2-10.5s-8.8 .2-10.5 4.2L137.7 96.7c-3.2-.5-6.4-.7-9.7-.7s-6.5 .2-9.7 .7L79.4 4.9c-1.7-4.1-6.4-6-10.5-4.2s-6 6.4-4.2 10.5l38.2 90C84.8 108.9 71 124.7 66 144H36.9L15.2 100.4c-2-4-6.8-5.6-10.7-3.6s-5.6 6.8-3.6 10.7l24 48c1.4 2.7 4.1 4.4 7.2 4.4H64v0 59.4L12 249.1c-2.1 1.2-3.6 3.4-4 5.8l-8 56c-.6 4.4 2.4 8.4 6.8 9.1s8.4-2.4 9.1-6.8L23.4 261l42-24c6 29.1 31.8 51 62.7 51s56.7-21.9 62.7-51l42 24 7.4 52.1c.6 4.4 4.7 7.4 9.1 6.8s7.4-4.7 6.8-9.1l-8-56c-.3-2.4-1.8-4.6-4-5.8l-52-29.7V160v0h32c3 0 5.8-1.7 7.2-4.4l24-48c2-4 .4-8.8-3.6-10.7s-8.8-.4-10.7 3.6L219.1 144H190c-5-19.3-18.7-35.1-36.8-42.8zM80 223.8V160c0-26.5 21.5-48 48-48s48 21.5 48 48v63.8l0 .3c-.1 26.4-21.5 47.9-48 47.9s-47.9-21.4-48-47.9l0-.3zm365.6 167l-.2 .3c-13.3 22.8-42.6 30.6-65.5 17.4c-22.9-13.2-30.8-42.6-17.6-65.5l.1-.1 32-55.4c13.3-23 42.6-30.8 65.6-17.6s30.8 42.6 17.6 65.6l-31.9 55.3zm-73.7 31.6c26.7 15.4 60 9.4 79.8-12.8L476 451.4l-19.6 48.9c-1.6 4.1 .3 8.8 4.4 10.4s8.8-.3 10.4-4.4l21.1-52.5c.9-2.3 .7-4.9-.5-7L461.7 395l29.7-51.4 0 0 27.7 16c2.6 1.5 5.9 1.4 8.4-.2l44.8-29.6c3.7-2.4 4.7-7.4 2.3-11.1s-7.4-4.7-11.1-2.3l-40.7 26.8-25.2-14.5c5.4-19.2 1.3-39.8-10.4-55.5l78.1-58.9c3.5-2.7 4.2-7.7 1.6-11.2s-7.7-4.2-11.2-1.6L476 261.7c-2.5-2-5.2-3.8-8-5.5s-5.8-3.1-8.8-4.2l12.2-99c.5-4.4-2.6-8.4-7-8.9s-8.4 2.6-8.9 7l-12 97.1c-19.5-2.3-39.3 4.5-53.3 18.7l-25.2-14.5 2.9-48.6c.3-4.4-3.1-8.2-7.5-8.5s-8.2 3.1-8.5 7.5l-3.2 53.6c-.2 3 1.4 5.9 4 7.4l27.7 16 0 0L350.8 331l-59.9-.3c-2.5 0-4.8 1.1-6.3 3.1l-34.9 44.5c-2.7 3.5-2.1 8.5 1.4 11.2s8.5 2.1 11.2-1.4l32.5-41.4 48.3 .2c-9.3 28.2 2 60 28.8 75.5z'
      
    ]
  };

  

  
  

  var faWrench = {
    prefix: 'fat',
    iconName: 'wrench',
    icon: [
      512,
      512,
      [128295],
      'f0ad',
      
      'M320 118.6c0-8.5 3.4-16.6 9.4-22.6l71.5-71.5C385.6 19 369.2 16 352 16c-79.5 0-144 64.5-144 144c0 12.2 1.5 24 4.3 35.2c2.7 10.7 .2 22.9-8.4 31.5L32.9 397.8C22.1 408.6 16 423.2 16 438.5C16 470.2 41.8 496 73.5 496c15.3 0 29.9-6.1 40.7-16.9L285.3 308.1c8.6-8.6 20.7-11.1 31.5-8.4c11.3 2.8 23.1 4.3 35.2 4.3c79.5 0 144-64.5 144-144c0-17.2-3-33.6-8.5-48.9L416 182.6c-6 6-14.1 9.4-22.6 9.4H352c-17.7 0-32-14.3-32-32V118.6zm20.7-11.3c-3 3-4.7 7.1-4.7 11.3V160c0 8.8 7.2 16 16 16h41.4c4.2 0 8.3-1.7 11.3-4.7l72.7-72.7c7.6-7.6 20.3-5.7 24.1 4.3c6.8 17.7 10.5 37 10.5 57.1c0 88.4-71.6 160-160 160c-13.5 0-26.6-1.7-39.2-4.8c-5.8-1.5-12 0-16.2 4.2L125.5 490.5C111.7 504.3 93 512 73.5 512C32.9 512 0 479.1 0 438.5c0-19.5 7.7-38.2 21.5-52L192.6 215.4c4.2-4.2 5.7-10.4 4.2-16.2c-3.2-12.5-4.8-25.6-4.8-39.2C192 71.6 263.6 0 352 0c20.1 0 39.4 3.7 57.1 10.5c10 3.8 11.8 16.5 4.3 24.1l-72.7 72.7zM80 416a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faArrowTurnLeft = {
    prefix: 'fat',
    iconName: 'arrow-turn-left',
    icon: [
      512,
      512,
      [],
      'e632',
      
      'M154.3 381.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L27.3 232H440c30.9 0 56 25.1 56 56V472c0 4.4 3.6 8 8 8s8-3.6 8-8V288c0-39.8-32.2-72-72-72H27.3L165.7 77.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-152 152c-3.1 3.1-3.1 8.2 0 11.3l152 152z'
      
    ]
  };

  

  
  

  var faTransporter6 = {
    prefix: 'fat',
    iconName: 'transporter-6',
    icon: [
      512,
      512,
      [],
      'e2a7',
      
      'M56 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V40H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H40V88c0 4.4 3.6 8 8 8s8-3.6 8-8V56H88c4.4 0 8-3.6 8-8s-3.6-8-8-8H56V8zM472 360c0-4.4-3.6-8-8-8s-8 3.6-8 8v32H424c-4.4 0-8 3.6-8 8s3.6 8 8 8h32v32c0 4.4 3.6 8 8 8s8-3.6 8-8V408h32c4.4 0 8-3.6 8-8s-3.6-8-8-8H472V360zM112 496c0-17.7 14.3-32 32-32H368c17.7 0 32 14.3 32 32v8c0 4.4 3.6 8 8 8s8-3.6 8-8v-8c0-26.5-21.5-48-48-48H144c-26.5 0-48 21.5-48 48v8c0 4.4 3.6 8 8 8s8-3.6 8-8v-8zM96 264c0 4.4 3.6 8 8 8H408c4.4 0 8-3.6 8-8s-3.6-8-8-8H104c-4.4 0-8 3.6-8 8zM232 0c-4.4 0-8 3.6-8 8s3.6 8 8 8h48c4.4 0 8-3.6 8-8s-3.6-8-8-8H232z'
      
    ]
  };

  

  
  

  var faUtilityPole = {
    prefix: 'fat',
    iconName: 'utility-pole',
    icon: [
      512,
      512,
      [],
      'e2c3',
      
      'M248 16c-4.4 0-8 3.6-8 8V80h32V24c0-4.4-3.6-8-8-8H248zM224 80V24c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24V80H432V40c0-4.4 3.6-8 8-8s8 3.6 8 8V80h48V40c0-4.4 3.6-8 8-8s8 3.6 8 8V80 96v16c0 17.7-14.3 32-32 32H410.5L288 228.2V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V224.1c0-.1 0-.1 0-.2V144H240v79.9c0 .1 0 .1 0 .2V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V228.2L101.5 144H32c-17.7 0-32-14.3-32-32V96 80 40c0-4.4 3.6-8 8-8s8 3.6 8 8V80H64V40c0-4.4 3.6-8 8-8s8 3.6 8 8V80H224zM104.1 128H232h48H407.9c.1 0 .1 0 .2 0H480c8.8 0 16-7.2 16-16V96H288 272 240 224 16v16c0 8.8 7.2 16 16 16h71.9c.1 0 .1 0 .2 0zm25.6 16L224 208.8V144H129.8zm252.5 0H288v64.8L382.2 144z'
      
    ]
  };

  

  
  

  var faBurger = {
    prefix: 'fat',
    iconName: 'burger',
    icon: [
      512,
      512,
      ["hamburger"],
      'f805',
      
      'M450.9 208H61.1c-7.2 0-13.1-5.9-13.1-13.1c0-1 .1-1.4 .2-1.7c2.3-9.2 13-45.7 43.6-79.7C121.9 80 172.1 48 256 48s134.1 32 164.3 65.5c30.6 34 41.3 70.5 43.6 79.7c.1 .3 .2 .7 .2 1.7c0 7.2-5.9 13.1-13.1 13.1zM61.1 224H450.9c16.1 0 29.1-13 29.1-29.1c0-1.9-.2-3.7-.6-5.6C474.1 168.3 433.2 32 256 32S37.9 168.3 32.6 189.3c-.5 1.9-.6 3.7-.6 5.6C32 211 45 224 61.1 224zM448 272c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32s14.3-32 32-32H448zM16 304c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48s-21.5-48-48-48H64c-26.5 0-48 21.5-48 48zm436.6 96c6.3 0 11.4 5.1 11.4 11.4c0 29-23.5 52.6-52.6 52.6H100.6c-29 0-52.6-23.5-52.6-52.6c0-6.3 5.1-11.4 11.4-11.4H452.6zM32 411.4c0 37.9 30.7 68.6 68.6 68.6H411.4c37.9 0 68.6-30.7 68.6-68.6c0-15.1-12.3-27.4-27.4-27.4H59.4C44.3 384 32 396.3 32 411.4zM144 144a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm240-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM256 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  
    var faHamburger = faBurger;
  

  
  

  var faStaff = {
    prefix: 'fat',
    iconName: 'staff',
    icon: [
      512,
      512,
      [],
      'f71b',
      
      'M67.8 499.8L57 489c-9.4 9.4-24.6 9.4-33.9 0L11.9 500.1 23 489c-9.4-9.4-9.4-24.6 0-33.9l79.6-79.6c6-6 9.4-14.1 9.4-22.6V304h48.8c8.5 0 16.6-3.4 22.6-9.4l41.7-41.7c6.7-6.7 15.1-11.6 24.2-14.2l175.4-50.1c13.7-3.9 23.2-16.5 23.2-30.8V96c0-17.7-14.3-32-32-32H378.6c-12.1 0-23.2 6.8-28.6 17.7l-.5 1c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2L313.7 47c9.5-19 28.9-31 50.1-31H440c30.9 0 56 25.1 56 56V175.9c0 25-16.6 47-40.6 53.8l-15.2 4.3c-8.1 2.3-14.9 7.7-19.1 15l-21.5 38.1-37.2-21c-7.5-4.2-16.3-5.3-24.5-2.9l-69.3 19.8c-5.2 1.5-10 4.3-13.8 8.1L57 489l10.8 10.8zM363.8 0c-27.3 0-52.2 15.4-64.4 39.8l-7.2 14.3c-9.9 19.8-1.9 43.8 17.9 53.7s43.8 1.9 53.7-17.9l.5-1c2.7-5.4 8.3-8.8 14.3-8.8H416c8.8 0 16 7.2 16 16v61.8c0 7.1-4.7 13.4-11.6 15.4L245 223.3c-11.8 3.4-22.5 9.7-31.1 18.3l-41.7 41.7c-3 3-7.1 4.7-11.3 4.7H112c-8.8 0-16 7.2-16 16v48.8c0 4.2-1.7 8.3-4.7 11.3L11.7 443.7c-15.6 15.6-15.6 40.9 0 56.6s40.9 15.6 56.6 0L266 302.5c1.9-1.9 4.3-3.3 6.9-4.1l69.3-19.8c4.1-1.2 8.5-.7 12.3 1.5l37.2 21c7.7 4.3 17.5 1.6 21.8-6.1L435 257c2.1-3.7 5.5-6.4 9.5-7.5l15.2-4.3c30.9-8.8 52.2-37.1 52.2-69.2V72c0-39.8-32.2-72-72-72H363.8z'
      
    ]
  };

  

  
  

  var faChartRadar = {
    prefix: 'fat',
    iconName: 'chart-radar',
    icon: [
      512,
      512,
      [],
      'e0e7',
      
      'M400.8 450.8l0 0L497.1 284c2.5-4.3 4.4-8.9 5.6-13.6c2-7.7 2.4-15.7 1.1-23.6c-1.1-6.5-3.3-12.9-6.7-18.8L400.8 61.2c-10-17.3-28.5-28-48.5-28H159.7c-20 0-38.5 10.7-48.5 28L14.9 228c-3.9 6.7-6.3 14.1-7.1 21.6c-1.4 11.8 1 23.9 7.1 34.4l96.3 166.8c10 17.3 28.5 28 48.5 28H352.3c20 0 38.5-10.7 48.5-28zM483.2 236c2.7 4.6 4.4 9.7 5 14.8l-2.7 20.4c-.7 1.6-1.4 3.2-2.3 4.8L386.9 442.8c-7.1 12.4-20.4 20-34.6 20H159.7c-14.3 0-27.5-7.6-34.6-20L28.8 276c-3.6-6.2-5.4-13.1-5.4-20c0-3.4 .4-6.8 1.3-10.1c.9-3.4 2.2-6.8 4.1-9.9L125.1 69.2c7.1-12.4 20.4-20 34.6-20l192.6 0c14.3 0 27.5 7.6 34.6 20L483.2 236zM281 140a32 32 0 1 1 -50 40 32 32 0 1 1 50-40zm-73 20c0 12.8 5 24.5 13.2 33.1L182 245.3c-6.6-3.4-14.1-5.3-22-5.3c-26.5 0-48 21.5-48 48s21.5 48 48 48c20.5 0 38-12.8 44.9-30.9L272 318.6c0 .5 0 1 0 1.4c0 26.5 21.5 48 48 48s48-21.5 48-48s-21.5-48-48-48c-3.5 0-6.9 .4-10.2 1.1L281 201c13.8-8.4 23-23.6 23-41c0-26.5-21.5-48-48-48s-48 21.5-48 48zm0 128c0-12.8-5-24.5-13.2-33.1L234 202.7c6.6 3.4 14.1 5.3 22 5.3c3.5 0 6.9-.4 10.2-1.1L295 279c-9 5.5-16 13.9-19.8 23.8L208 289.4c0-.5 0-1 0-1.4zm80 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM160 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faLockHashtag = {
    prefix: 'fat',
    iconName: 'lock-hashtag',
    icon: [
      448,
      512,
      [],
      'e423',
      
      'M112 128v64H336V128c0-61.9-50.1-112-112-112s-112 50.1-112 112zM96 192V128C96 57.3 153.3 0 224 0s128 57.3 128 128v64h32c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H96zm0 16H64c-26.5 0-48 21.5-48 48V448c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V256c0-26.5-21.5-48-48-48H352 336 112 96zm80 40c4.4 0 8 3.6 8 8v40h80V256c0-4.4 3.6-8 8-8s8 3.6 8 8v40h40c4.4 0 8 3.6 8 8s-3.6 8-8 8H280v80h40c4.4 0 8 3.6 8 8s-3.6 8-8 8H280v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V408H184v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V408H128c-4.4 0-8-3.6-8-8s3.6-8 8-8h40V312H128c-4.4 0-8-3.6-8-8s3.6-8 8-8h40V256c0-4.4 3.6-8 8-8zm8 144h80V312H184v80z'
      
    ]
  };

  

  
  

  var faTurnDownLeft = {
    prefix: 'fat',
    iconName: 'turn-down-left',
    icon: [
      512,
      512,
      [],
      'e331',
      
      'M176 240l0-89.1c0-3.8-3.1-6.9-6.9-6.9c-1.8 0-3.5 .7-4.7 1.9L16.8 286.1c-.5 .5-.8 1.2-.8 1.9s.3 1.4 .8 1.9L164.4 430.1c1.3 1.2 3 1.9 4.7 1.9c3.8 0 6.9-3.1 6.9-6.9l0-89.1c0-8.8 7.2-16 16-16l208 0c53 0 96-43 96-96l0-152c0-13.3-10.7-24-24-24l-16 0c-13.3 0-24 10.7-24 24l0 152c0 17.7-14.3 32-32 32l-208 0c-8.8 0-16-7.2-16-16zM5.8 274.5L153.4 134.3c4.3-4 9.9-6.3 15.8-6.3c12.6 0 22.9 10.2 22.9 22.9l0 73.1 0 16 16 0 192 0c8.8 0 16-7.2 16-16l0-152c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 152c0 61.9-50.1 112-112 112l-192 0-16 0 0 16 0 73.1c0 12.6-10.2 22.9-22.9 22.9c-5.9 0-11.5-2.3-15.8-6.3L5.8 301.5C2.1 298 0 293.1 0 288s2.1-10 5.8-13.5z'
      
    ]
  };

  

  
  

  var faFileAudio = {
    prefix: 'fat',
    iconName: 'file-audio',
    icon: [
      384,
      512,
      [],
      'f1c7',
      
      'M16 448V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM261.9 233.1c-3.8-2.3-8.7-1.1-11 2.7s-1.1 8.7 2.7 11C283.8 265.1 304 298.2 304 336s-20.2 70.9-50.4 89.1c-3.8 2.3-5 7.2-2.7 11s7.2 5 11 2.7c34.8-21 58.1-59.2 58.1-102.9s-23.3-81.9-58.1-102.9zM132.5 371.7c-2.9-2.4-6.5-3.7-10.2-3.7H96V304h26.2c3.7 0 7.4-1.3 10.2-3.7L176 264V408l-43.5-36.3zm33.3 48.6c4.8 4 11.4 4.8 17 2.2s9.2-8.3 9.2-14.5V264c0-6.2-3.6-11.9-9.2-14.5s-12.3-1.8-17 2.2L122.2 288H96c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h26.2l43.6 36.3zm60.2-125.5c-2.9 3.3-2.6 8.4 .7 11.3c8.2 7.3 13.4 18 13.4 29.9s-5.2 22.5-13.4 29.9c-3.3 2.9-3.6 8-.7 11.3s8 3.6 11.3 .6C248.7 367.6 256 352.6 256 336s-7.3-31.6-18.8-41.8c-3.3-2.9-8.4-2.6-11.3 .7z'
      
    ]
  };

  

  
  

  var faPool8Ball = {
    prefix: 'fat',
    iconName: 'pool-8-ball',
    icon: [
      512,
      512,
      [],
      'e3c5',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm384-64a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-32a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm26 6.4c17.8 9.4 30 28.1 30 49.6c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-21.5 12.2-40.2 30-49.6c-8.6-7.3-14-18.2-14-30.4c0-22.1 17.9-40 40-40s40 17.9 40 40c0 12.2-5.4 23.1-14 30.4zM256 176a40 40 0 1 0 0 80 40 40 0 1 0 0-80z'
      
    ]
  };

  

  
  

  var faTruckClock = {
    prefix: 'fat',
    iconName: 'truck-clock',
    icon: [
      640,
      512,
      ["shipping-timed"],
      'f48c',
      
      'M64 16C37.5 16 16 37.5 16 64V352c0 26.5 21.5 48 48 48h3.3c10.4-36.9 44.4-64 84.7-64s74.2 27.1 84.7 64H400V64c0-26.5-21.5-48-48-48H64zm.4 400H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H352c35.3 0 64 28.7 64 64V96h58.7c10.6 0 20.8 4.2 28.3 11.7L596.3 201c7.5 7.5 11.7 17.7 11.7 28.3V400h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H575.6c.2 2.6 .4 5.3 .4 8c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-2.7 .1-5.4 .4-8H400 239.6c.2 2.6 .4 5.3 .4 8c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-2.7 .1-5.4 .4-8zM416 216H588c-.9-1.3-1.9-2.6-3-3.7L491.7 119c-4.5-4.5-10.6-7-17-7H416V216zm0 16V373.4c15.9-22.6 42.2-37.4 72-37.4c40.3 0 74.2 27.1 84.7 64H592V232H416zM224 424A72 72 0 1 0 80 424a72 72 0 1 0 144 0zm264 72a72 72 0 1 0 0-144 72 72 0 1 0 0 144zM208 272a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0-208a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 56v56h40c4.4 0 8 3.6 8 8s-3.6 8-8 8H200c-4.4 0-8-3.6-8-8V120c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  
    var faShippingTimed = faTruckClock;
  

  
  

  var faCartCirclePlus = {
    prefix: 'fat',
    iconName: 'cart-circle-plus',
    icon: [
      640,
      512,
      [],
      'e3f3',
      
      'M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8H45.7C57.1 16 67 24.1 69.2 35.4l59.4 303.4c5.1 26.3 28.2 45.2 55 45.2H320.7c-.5-5.3-.7-10.6-.7-16H183.5c-19.1 0-35.6-13.5-39.3-32.3L134.9 288H339.2c2.8-5.5 5.9-10.8 9.3-16H131.8L88 48H527.7c15.5 0 26.9 14.4 23.4 29.5L523.8 194.2c5.3 .8 10.5 1.9 15.7 3.2L566.6 81.1C572.5 56 553.4 32 527.7 32H84.8C81 13.4 64.7 0 45.7 0H8zM144 464a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm144-96a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM504 296c0-4.4-3.6-8-8-8s-8 3.6-8 8v64H424c-4.4 0-8 3.6-8 8s3.6 8 8 8h64v64c0 4.4 3.6 8 8 8s8-3.6 8-8V376h64c4.4 0 8-3.6 8-8s-3.6-8-8-8H504V296z'
      
    ]
  };

  

  
  

  var faClipboardCheck = {
    prefix: 'fat',
    iconName: 'clipboard-check',
    icon: [
      384,
      512,
      [],
      'f46c',
      
      'M192 0c-37.1 0-67.6 28-71.6 64H112C91.1 64 73.3 77.4 66.7 96H64C28.7 96 0 124.7 0 160V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64h-2.7c-6.6-18.6-24.4-32-45.3-32h-8.4c-4-36-34.5-64-71.6-64zM16 160c0-26.5 21.5-48 48-48v16c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V112c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V160zM136 72c0-30.9 25.1-56 56-56s56 25.1 56 56c0 4.4 3.6 8 8 8h16c17.7 0 32 14.3 32 32v16c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V112c0-17.7 14.3-32 32-32h16c4.4 0 8-3.6 8-8zm56 24a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM293.7 261.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L160 372.7l-58.3-58.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l64 64c3.1 3.1 8.2 3.1 11.3 0l128-128z'
      
    ]
  };

  

  
  

  var faFlatbreadStuffed = {
    prefix: 'fat',
    iconName: 'flatbread-stuffed',
    icon: [
      576,
      512,
      [129369],
      'e40c',
      
      'M441.7 38.3c-6.3-4.6-14.3-6.8-22.5-5.8l-67.9 8.1c-6.6 .8-13.3-.5-19.2-3.7L272.2 4c-12.8-7-28.7-4.5-38.7 6.1L186.6 59.9c-4.6 4.9-10.5 8.2-17.1 9.5L102.4 82.7c-14.3 2.8-24.9 15-25.7 29.6l-3.8 68.3c-.4 6.7-2.8 13-7 18.2L23.1 252.1c-9.1 11.4-9.4 27.5-.7 39.2l40.9 54.8c4 5.3 6.2 11.8 6.4 18.5l1 44.8 15.7-15.7-.6-29.5c-.2-10-3.6-19.7-9.5-27.7L35.2 281.7c-4.4-5.8-4.2-13.9 .3-19.6l42.8-53.3c6.3-7.8 9.9-17.4 10.5-27.4l3.8-68.3c.4-7.3 5.7-13.4 12.9-14.8l67.1-13.3c9.8-1.9 18.8-6.9 25.6-14.2L245.1 21c5-5.3 13-6.6 19.4-3.1l59.9 32.9c8.8 4.8 18.8 6.8 28.8 5.6l67.9-8.1c3.2-.4 6.3 .2 9 1.5l11.6-11.6zM464.5 80c2.3 .1 4.4 1.2 5.8 3c34.6 43.5 57.7 96.5 57.7 157c0 141.4-114.6 256-256 256c-60.4 0-113.5-23.2-157-57.7c-1.8-1.4-2.9-3.5-3-5.8s.7-4.5 2.3-6.1l344-344c1.6-1.6 3.8-2.5 6.1-2.3zm.9-16c-6.8-.4-13.5 2.2-18.3 7L103 415c-4.8 4.8-7.4 11.5-7 18.3s3.7 13.2 9 17.4C150.8 487.1 207.3 512 272 512c150.2 0 272-121.8 272-272c0-64.7-24.9-121.2-61.2-166.9c-4.3-5.4-10.6-8.6-17.4-9zM272 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM232 152c-61.9 0-112 50.1-112 112c0 26.9 9.5 51.5 25.2 70.8l11.4-11.4c-12.9-16.3-20.6-37-20.6-59.4c0-53 43-96 96-96c22.4 0 43.1 7.7 59.4 20.6l11.4-11.4C283.5 161.5 258.9 152 232 152z'
      
    ]
  };

  

  
  

  var faOctagonCheck = {
    prefix: 'fat',
    iconName: 'octagon-check',
    icon: [
      512,
      512,
      [],
      'e426',
      
      'M191.5 16.1c-14.9 0-29.1 5.9-39.6 16.4L32.5 151.9C22 162.4 16.1 176.7 16.1 191.5v129c0 14.9 5.9 29.1 16.4 39.6L151.9 479.5c10.5 10.5 24.7 16.4 39.6 16.4h129c14.9 0 29.1-5.9 39.6-16.4L479.5 360.1c10.5-10.5 16.4-24.7 16.4-39.6v-129c0-14.9-5.9-29.1-16.4-39.6L360.1 32.5C349.6 22 335.3 16.1 320.5 16.1h-129zm-50.9 5.1C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM357.7 197.7l-128 128c-3.1 3.1-8.2 3.1-11.3 0l-64-64c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L224 308.7 346.3 186.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3z'
      
    ]
  };

  

  
  

  var faWallet = {
    prefix: 'fat',
    iconName: 'wallet',
    icon: [
      512,
      512,
      [],
      'f555',
      
      'M72 32C32.2 32 0 64.2 0 104V408c0 39.8 32.2 72 72 72H440c39.8 0 72-32.2 72-72V184c0-39.8-32.2-72-72-72H72c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c30.9 0 56 25.1 56 56V408c0 30.9-25.1 56-56 56H72c-30.9 0-56-25.1-56-56V104c0-30.9 25.1-56 56-56H472c4.4 0 8-3.6 8-8s-3.6-8-8-8H72zM376 296a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm64 0a40 40 0 1 0 -80 0 40 40 0 1 0 80 0z'
      
    ]
  };

  

  
  

  var faUsersRays = {
    prefix: 'fat',
    iconName: 'users-rays',
    icon: [
      640,
      512,
      [],
      'e593',
      
      'M2.3 2.3c-3.1 3.1-3.1 8.2 0 11.3l80 80c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-80-80C10.5-.8 5.5-.8 2.3 2.3zm635.3 0c-3.1-3.1-8.2-3.1-11.3 0l-80 80c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l80-80c3.1-3.1 3.1-8.2 0-11.3zM13.7 509.7l80-80c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-80 80c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0zm624 0c3.1-3.1 3.1-8.2 0-11.3l-80-80c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l80 80c3.1 3.1 8.2 3.1 11.3 0zM272 192a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM224 360c0-30.9 25.1-56 56-56h80c30.9 0 56 25.1 56 56c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8zm96-104a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-40 32c-39.8 0-72 32.2-72 72c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-39.8-32.2-72-72-72H280zM152 272h64c4.4 0 8-3.6 8-8s-3.6-8-8-8H152c-30.9 0-56 25.1-56 56c0 17.7 14.3 32 32 32h32c4.4 0 8-3.6 8-8s-3.6-8-8-8H128c-8.8 0-16-7.2-16-16c0-22.1 17.9-40 40-40zm-8-96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm264 96c22.1 0 40 17.9 40 40c0 8.8-7.2 16-16 16H480c-4.4 0-8 3.6-8 8s3.6 8 8 8h32c17.7 0 32-14.3 32-32c0-30.9-25.1-56-56-56H424c-4.4 0-8 3.6-8 8s3.6 8 8 8h64zm8-96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-80 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z'
      
    ]
  };

  

  
  

  var faVolumeHigh = {
    prefix: 'fat',
    iconName: 'volume-high',
    icon: [
      640,
      512,
      [128266,"volume-up"],
      'f028',
      
      'M524.8 25.6c-3.5-2.7-8.5-1.9-11.2 1.6s-1.9 8.5 1.6 11.2C581.3 88 624 167 624 256s-42.7 168-108.8 217.6c-3.5 2.7-4.2 7.7-1.6 11.2s7.7 4.2 11.2 1.6C594.8 433.9 640 350.2 640 256s-45.2-177.9-115.2-230.4zM281 51.5c2.5-2.2 5.8-3.5 9.2-3.5c7.6 0 13.8 6.2 13.8 13.8V450.2c0 7.6-6.2 13.8-13.8 13.8c-3.4 0-6.6-1.2-9.2-3.5L143.2 338c-1.5-1.3-3.4-2-5.3-2H56c-22.1 0-40-17.9-40-40V216c0-22.1 17.9-40 40-40h81.9c2 0 3.9-.7 5.3-2L281 51.5zM290.2 32c-7.3 0-14.3 2.7-19.8 7.5L134.9 160H56c-30.9 0-56 25.1-56 56v80c0 30.9 25.1 56 56 56h78.9L270.4 472.5c5.5 4.8 12.5 7.5 19.8 7.5c16.5 0 29.8-13.3 29.8-29.8V61.8C320 45.3 306.7 32 290.2 32zM409.7 179.2c-3.5-2.7-8.5-1.9-11.2 1.6s-1.9 8.5 1.6 11.2c19.4 14.6 31.9 37.8 31.9 64s-12.5 49.4-31.9 64c-3.5 2.7-4.2 7.7-1.6 11.2s7.7 4.2 11.2 1.6C432.9 315.2 448 287.4 448 256s-15.1-59.2-38.3-76.8zm48-74.1c-2.7 3.5-2 8.5 1.5 11.2C501 148.5 528 199.1 528 256s-27 107.5-68.9 139.7c-3.5 2.7-4.2 7.7-1.5 11.2s7.7 4.2 11.2 1.5C514.5 373.3 544 318.1 544 256s-29.5-117.3-75.1-152.3c-3.5-2.7-8.5-2-11.2 1.5z'
      
    ]
  };

  
    var faVolumeUp = faVolumeHigh;
  

  
  

  var faCloudSlash = {
    prefix: 'fat',
    iconName: 'cloud-slash',
    icon: [
      640,
      512,
      [],
      'e137',
      
      'M13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7zM640 352c0-56.3-36.4-104.1-86.9-121.3c-5-1.7-10.2-3.1-15.5-4.2c1.9-5 3.4-10.1 4.5-15.4c1.3-6.2 1.9-12.6 1.9-19.2c0-53-43-96-96-96c-15.2 0-29.5 3.5-42.3 9.8c-3.8 1.9-7.5 4-11 6.4c-2.7-4.6-5.6-9.1-8.7-13.4C357 58.3 309.6 32 256 32c-28.3 0-54.9 7.3-77.9 20.2l13.7 10.8C211.1 53.4 232.9 48 256 48c53.3 0 99.9 29 124.8 72.2c2.2 3.8 5.9 6.6 10.2 7.6s8.8 .2 12.5-2.3c12.7-8.5 28-13.5 44.4-13.5c44.2 0 80 35.8 80 80c0 10.2-1.9 19.9-5.3 28.8c-1.7 4.4-1.4 9.3 .9 13.4s6.2 7.1 10.9 8C585.5 252.6 624 297.8 624 352c0 16-3.3 31.1-9.4 44.9l12.9 10.2c8-16.7 12.4-35.4 12.4-55.1zM97.3 171.9c-.8 6.6-1.3 13.3-1.3 20.1c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144H487.5l-20.3-16H144C73.3 464 16 406.7 16 336c0-55.8 35.7-103.3 85.5-120.8c6.7-2.4 11-8.8 10.7-15.9c-.1-2.4-.2-4.9-.2-7.3c0-2.8 .1-5.5 .2-8.3l-15-11.8z'
      
    ]
  };

  

  
  

  var faInboxOut = {
    prefix: 'fat',
    iconName: 'inbox-out',
    icon: [
      512,
      512,
      [128228,"inbox-arrow-up"],
      'f311',
      
      'M264 27.3L370.3 133.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-120-120c-3.1-3.1-8.2-3.1-11.3 0l-120 120c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L248 27.3V312c0 4.4 3.6 8 8 8s8-3.6 8-8V27.3zM48 336h74.3c12.1 0 23.2 6.8 28.6 17.7l9.9 19.8c8.1 16.3 24.8 26.5 42.9 26.5H308.2c18.2 0 34.8-10.3 42.9-26.5l9.9-19.8c5.4-10.8 16.5-17.7 28.6-17.7H464c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V368c0-17.7 14.3-32 32-32zm298.7 10.5l-9.9 19.8c-5.4 10.8-16.5 17.7-28.6 17.7H203.8c-12.1 0-23.2-6.8-28.6-17.7l-9.9-19.8c-8.1-16.3-24.8-26.5-42.9-26.5H48c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H389.7c-18.2 0-34.8 10.3-42.9 26.5z'
      
    ]
  };

  
    var faInboxArrowUp = faInboxOut;
  

  
  

  var faClockOneThirty = {
    prefix: 'fat',
    iconName: 'clock-one-thirty',
    icon: [
      512,
      512,
      [],
      'e34f',
      
      'M16 256a240 240 0 1 1 480 0A240 240 0 1 1 16 256zm496 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM264 408V258.4l62.7-94c2.5-3.7 1.5-8.6-2.2-11.1s-8.6-1.5-11.1 2.2l-64 96c-.9 1.3-1.3 2.9-1.3 4.4V408c0 4.4 3.6 8 8 8s8-3.6 8-8z'
      
    ]
  };

  

  
  

  var faMobileScreenButton = {
    prefix: 'fat',
    iconName: 'mobile-screen-button',
    icon: [
      384,
      512,
      ["mobile-alt"],
      'f3cd',
      
      'M288 16c26.5 0 48 21.5 48 48V352H48V64c0-26.5 21.5-48 48-48H288zm48 352v80c0 26.5-21.5 48-48 48H96c-26.5 0-48-21.5-48-48V368H336zM96 0C60.7 0 32 28.7 32 64V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H96zm96 448a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z'
      
    ]
  };

  
    var faMobileAlt = faMobileScreenButton;
  

  
  

  var faSlider = {
    prefix: 'fat',
    iconName: 'slider',
    icon: [
      512,
      512,
      [],
      'e252',
      
      'M352 112c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H320c-26.5 0-48-21.5-48-48V160c0-26.5 21.5-48 48-48h32zM320 96c-35.3 0-64 28.7-64 64V352c0 35.3 28.7 64 64 64h32c35.3 0 64-28.7 64-64V264h88c4.4 0 8-3.6 8-8s-3.6-8-8-8H416V160c0-35.3-28.7-64-64-64H320zM0 256c0 4.4 3.6 8 8 8H224V248H8c-4.4 0-8 3.6-8 8z'
      
    ]
  };

  

  
  

  var faCircleUp = {
    prefix: 'fat',
    iconName: 'circle-up',
    icon: [
      512,
      512,
      [61467,"arrow-alt-circle-up"],
      'f35b',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-400c-7.2 0-14.2 2.9-19.3 8L137 219.7c-5.7 5.7-9 13.5-9 21.7c0 16.9 13.7 30.6 30.6 30.6H208v88c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40V272h49.4c16.9 0 30.6-13.7 30.6-30.6c0-8.1-3.2-15.9-9-21.7L275.3 120c-5.1-5.1-12.1-8-19.3-8zm-8 19.3c2.1-2.1 5-3.3 8-3.3s5.9 1.2 8 3.3L363.7 231c2.7 2.7 4.3 6.5 4.3 10.3c0 8.1-6.6 14.6-14.6 14.6H296c-4.4 0-8 3.6-8 8v96c0 13.3-10.7 24-24 24H248c-13.3 0-24-10.7-24-24V264c0-4.4-3.6-8-8-8H158.6c-8.1 0-14.6-6.5-14.6-14.6c0-3.9 1.5-7.6 4.3-10.3L248 131.3z'
      
    ]
  };

  
    var faArrowAltCircleUp = faCircleUp;
  

  
  

  var faBadgeCheck = {
    prefix: 'fat',
    iconName: 'badge-check',
    icon: [
      512,
      512,
      [],
      'f336',
      
      'M180.8 61.2C195.1 34.3 223.4 16 256 16s60.9 18.3 75.2 45.2c1.8 3.4 5.7 5 9.4 3.9c29.1-8.9 62.1-1.9 85.1 21.1s30.1 56 21.1 85.1c-1.1 3.7 .5 7.6 3.9 9.4C477.7 195.1 496 223.4 496 256s-18.3 60.9-45.2 75.2c-3.4 1.8-5 5.8-3.9 9.4c8.9 29.1 1.9 62.1-21.1 85.1s-56 30.1-85.1 21.1c-3.7-1.1-7.6 .5-9.4 3.9C316.9 477.7 288.6 496 256 496s-60.9-18.3-75.2-45.2c-1.8-3.4-5.7-5-9.4-3.9c-29.1 8.9-62.1 1.9-85.1-21.1s-30.1-56-21.1-85.1c1.1-3.7-.5-7.6-3.9-9.4C34.3 316.9 16 288.6 16 256s18.3-60.9 45.2-75.2c3.4-1.8 5-5.7 3.9-9.4c-8.9-29.1-1.9-62.1 21.1-85.1s56-30.1 85.1-21.1c3.7 1.1 7.6-.5 9.4-3.9zM256 0c-36.4 0-68.3 19.3-86.1 48.2c-33-7.9-69.2 1.1-94.9 26.8s-34.7 61.9-26.8 94.9C19.3 187.7 0 219.6 0 256s19.3 68.3 48.2 86.1c-7.9 33 1.1 69.2 26.8 94.9s61.9 34.7 94.9 26.8C187.7 492.7 219.6 512 256 512s68.3-19.3 86.1-48.2c33 7.9 69.2-1.1 94.9-26.8s34.7-61.9 26.8-94.9C492.7 324.3 512 292.4 512 256s-19.3-68.3-48.2-86.1c7.9-33-1.1-69.2-26.8-94.9s-61.9-34.7-94.9-26.8C324.3 19.3 292.4 0 256 0zM357.7 197.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L224 308.7l-58.3-58.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l64 64c3.1 3.1 8.2 3.1 11.3 0l128-128z'
      
    ]
  };

  

  
  

  var faSatelliteDish = {
    prefix: 'fat',
    iconName: 'satellite-dish',
    icon: [
      512,
      512,
      [128225],
      'f7c0',
      
      'M200 0c-4.4 0-8 3.6-8 8s3.6 8 8 8c163.5 0 296 132.5 296 296c0 4.4 3.6 8 8 8s8-3.6 8-8C512 139.7 372.3 0 200 0zm0 96c-4.4 0-8 3.6-8 8s3.6 8 8 8c110.5 0 200 89.5 200 200c0 4.4 3.6 8 8 8s8-3.6 8-8c0-119.3-96.7-216-216-216zM16 304c0-29.3 6.6-57 18.3-81.8c1.7-3.5 4.5-5.4 8.1-5.8c3.8-.4 8.3 .9 11.9 4.4L291.2 457.8c3.6 3.6 4.9 8.1 4.4 11.9c-.4 3.6-2.2 6.4-5.8 8.1C265 489.4 237.3 496 208 496C102 496 16 410 16 304zm49.5-94.5c-14-14-37.3-12.1-45.7 5.8C7.1 242.2 0 272.3 0 304C0 418.9 93.1 512 208 512c31.7 0 61.8-7.1 88.7-19.8c17.9-8.4 19.8-31.8 5.8-45.7L189.7 333.7l20.3-20.3c6.3 4.2 13.9 6.6 22.1 6.6c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 8.2 2.4 15.7 6.6 22.1l-20.3 20.3L65.5 209.5zM208 280a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faForkKnife = {
    prefix: 'fat',
    iconName: 'fork-knife',
    icon: [
      576,
      512,
      ["utensils-alt"],
      'f2e6',
      
      'M51.3 7.3L262.9 233.9l-11.3 11.3L39.6 18.2c-1.3-1.4-3.1-2.2-5.1-2.2c-2.9 0-5 1.7-5.7 3.9C24.2 34.7 16 66.5 16 107.2c0 44.5 13.8 78.5 39.5 113.2c22.1 29.9 52.8 59.9 91.2 97.4l0 0 0 0c5.3 5.2 10.7 10.5 16.3 16l-11.3 11.3c-5.4-5.4-10.8-10.6-16-15.7l0 0c-38.3-37.5-70-68.5-93-99.5C15.3 193 0 155.8 0 107.2C0 64.5 8.6 30.9 13.6 15.1C16.6 5.7 25.3 0 34.6 0C40.9 0 47 2.6 51.3 7.3zM498.2 509.5L328 327.2l11.3-11.3L509.8 498.5c3 3.2 2.8 8.3-.4 11.3s-8.3 2.8-11.3-.4zM467 9.1c2.6 3.6 1.7 8.6-1.9 11.2L350.6 102c-2.5 1.8-4.9 3.8-7 6l-7.6 7.6c-21.9 21.9-21.9 57.3 0 79.2L381.3 240c21.9 21.9 57.3 21.9 79.2 0l7.6-7.6c2.2-2.2 4.2-4.5 6-7l81.8-114.5c2.6-3.6 7.6-4.4 11.2-1.9s4.4 7.6 1.9 11.2L487 234.7c-2.3 3.2-4.9 6.3-7.7 9.1l-7.6 7.6c-28.1 28.1-73.7 28.1-101.8 0l-17-17L78.3 509c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L341.7 223l-17-17c-28.1-28.1-28.1-73.7 0-101.8l7.6-7.6c2.8-2.8 5.8-5.4 9.1-7.7L455.8 7.2c3.6-2.6 8.6-1.7 11.2 1.9zm33.4 33.2c3 3.3 2.7 8.3-.6 11.3L381 161.1c-3.3 3-8.3 2.7-11.3-.6s-2.7-8.3 .6-11.3L489 41.7c3.3-3 8.3-2.7 11.3 .6zm33.4 33.4c3.3 3 3.5 8 .6 11.3L426.8 205.8c-3 3.3-8 3.5-11.3 .6s-3.5-8-.6-11.3L522.4 76.2c3-3.3 8-3.5 11.3-.6z'
      
    ]
  };

  
    var faUtensilsAlt = faForkKnife;
  

  
  

  var faBasketball = {
    prefix: 'fat',
    iconName: 'basketball',
    icon: [
      512,
      512,
      [127936,"basketball-ball"],
      'f434',
      
      'M286.4 494.1C282.2 479.4 280 464 280 448c0-43.5 16.5-83.2 43.7-113l94.7 94.7 1.6 1.6c-35.9 33.6-82.2 56.3-133.6 62.8zm-16.2 1.5c-4.7 .3-9.4 .4-14.2 .4c-63.4 0-121.1-24.6-164-64.7l1.6-1.6L256 267.3l56.4 56.4C282.3 356.4 264 400.1 264 448c0 16.5 2.2 32.4 6.2 47.6zm53.5-183.2L267.3 256 429.7 93.7l1.6-1.6C471.4 134.9 496 192.6 496 256c0 4.8-.1 9.5-.4 14.2c-15.2-4.1-31.1-6.2-47.6-6.2c-47.9 0-91.6 18.3-124.3 48.4zM335 323.7c29.8-27.1 69.5-43.7 113-43.7c16 0 31.4 2.2 46.1 6.4c-6.5 51.3-29.2 97.6-62.8 133.6l-1.6-1.6L335 323.7zM418.3 82.3L256 244.7l-56.4-56.4C229.7 155.6 248 111.9 248 64c0-16.5-2.2-32.4-6.2-47.6c4.7-.3 9.4-.4 14.2-.4c63.4 0 121.1 24.6 164 64.7l-1.6 1.6zM188.3 177L93.7 82.3 92 80.7C128 47.1 174.3 24.4 225.6 17.9C229.8 32.6 232 48 232 64c0 43.5-16.5 83.2-43.7 113zM177 188.3C147.2 215.5 107.5 232 64 232c-16 0-31.4-2.2-46.1-6.4C24.4 174.3 47.1 128 80.7 92l1.6 1.6L177 188.3zM16.4 241.8C31.6 245.8 47.5 248 64 248c47.9 0 91.6-18.3 124.3-48.4L244.7 256 82.3 418.3 80.7 420C40.6 377.1 16 319.4 16 256c0-4.8 .1-9.5 .4-14.2zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z'
      
    ]
  };

  
    var faBasketballBall = faBasketball;
  

  
  

  var faTrademark = {
    prefix: 'fat',
    iconName: 'trademark',
    icon: [
      640,
      512,
      [8482],
      'f25c',
      
      'M0 104c0 4.4 3.6 8 8 8H120V408c0 4.4 3.6 8 8 8s8-3.6 8-8V112H248c4.4 0 8-3.6 8-8s-3.6-8-8-8H8c-4.4 0-8 3.6-8 8zm302-5.3c-2.2-2.5-5.7-3.4-8.8-2.2s-5.2 4.2-5.2 7.5V408c0 4.4 3.6 8 8 8s8-3.6 8-8V125.3l154 176c1.5 1.7 3.7 2.7 6 2.7s4.5-1 6-2.7l154-176V408c0 4.4 3.6 8 8 8s8-3.6 8-8V104c0-3.3-2.1-6.3-5.2-7.5s-6.6-.3-8.8 2.2L464 283.8 302 98.7z'
      
    ]
  };

  

  
  

  var faCircleDashed = {
    prefix: 'fat',
    iconName: 'circle-dashed',
    icon: [
      512,
      512,
      [],
      'e105',
      
      'M9.9 232c4.1 0 7.6-3.1 8.1-7.2c5.6-42.9 22.5-82.3 47.6-115c2.5-3.3 2.3-7.9-.6-10.8c-3.3-3.3-8.8-3.1-11.7 .6C26.2 134.7 8 177.1 2.1 223.2c-.6 4.7 3.1 8.8 7.8 8.8zM109.8 65.7c32.7-25.2 72.1-42.1 115-47.6c4.1-.5 7.2-4 7.2-8.1c0-4.7-4.1-8.4-8.8-7.8C177.1 8 134.7 26.2 99.6 53.3c-3.7 2.9-4 8.4-.6 11.7c2.9 2.9 7.6 3.1 10.8 .6zM280 502.1c0 4.7 4.1 8.4 8.8 7.8c46.2-5.9 88.5-24.1 123.6-51.2c3.7-2.9 4-8.4 .6-11.7c-2.9-2.9-7.6-3.1-10.8-.6c-32.7 25.1-72.1 42.1-115 47.6c-4.1 .5-7.2 4-7.2 8.1zm166.3-99.9c-2.5 3.3-2.3 7.9 .6 10.8c3.3 3.3 8.8 3.1 11.7-.6c27.1-35.1 45.3-77.4 51.2-123.6c.6-4.7-3.1-8.8-7.8-8.8c-4.1 0-7.6 3.1-8.1 7.2c-5.6 42.9-22.5 82.3-47.6 115zM99 447c-3.3 3.3-3.1 8.8 .6 11.7c35.1 27.1 77.4 45.3 123.6 51.2c4.7 .6 8.8-3.1 8.8-7.8c0-4.1-3.1-7.6-7.2-8.1c-42.9-5.6-82.3-22.5-115-47.6c-3.3-2.5-7.9-2.3-10.8 .6zM53.3 412.4c2.9 3.7 8.4 4 11.7 .6c2.9-2.9 3.1-7.6 .6-10.8c-25.2-32.7-42.1-72.1-47.6-115c-.5-4.1-4-7.2-8.1-7.2c-4.7 0-8.4 4.1-7.8 8.8C8 334.9 26.2 377.3 53.3 412.4zM413 65c3.3-3.3 3.1-8.8-.6-11.7C377.3 26.2 334.9 8 288.8 2.1c-4.7-.6-8.8 3.1-8.8 7.8c0 4.1 3.1 7.6 7.2 8.1c42.9 5.6 82.3 22.5 115 47.6c3.3 2.5 7.9 2.3 10.8-.6zm33.3 44.8c25.2 32.7 42.1 72.1 47.6 115c.5 4.1 4 7.2 8.1 7.2c4.7 0 8.4-4.1 7.8-8.8c-5.9-46.2-24.1-88.5-51.2-123.6c-2.9-3.7-8.4-4-11.7-.6c-2.9 2.9-3.1 7.6-.6 10.8z'
      
    ]
  };

  

  
  

  var faPlaneSlash = {
    prefix: 'fat',
    iconName: 'plane-slash',
    icon: [
      640,
      512,
      [],
      'e069',
      
      'M351.4 372.5L290.1 483.6c-4.2 7.7-12.3 12.4-21 12.4L221 496c-5.3 0-9.1-5-7.7-10.1l47.4-171.7c.7-2.4 .2-5-1.3-7s-3.9-3.2-6.4-3.2H152c-2.3 0-4.5 1-6 2.7L94.8 365.3c-1.5 1.7-3.7 2.7-6 2.7H53.9c-3.3 0-5.9-2.6-5.9-5.9c0-.6 .1-1.2 .3-1.7L40.6 358l7.6 2.4 31.4-102c.5-1.5 .5-3.2 0-4.7l-31.4-102L40.6 154l7.6-2.4c-.2-.6-.3-1.1-.3-1.7c0-3.3 2.6-5.9 5.9-5.9h8L44.4 130.2C37.1 133.7 32 141.2 32 149.9c0 2.2 .3 4.4 1 6.4L63.6 256 33 355.6c-.6 2.1-1 4.3-1 6.4c0 12.1 9.8 21.9 21.9 21.9H88.7c6.9 0 13.5-3 18.1-8.2L155.6 320l86.8 0L197.9 481.6c-4.2 15.3 7.3 30.4 23.1 30.4l48.1 0c14.6 0 28-7.9 35-20.7l60-108.7-12.7-10zM197.9 30.4l13.2 47.9L232.3 95l-19-68.9C211.9 21 215.7 16 221 16l48.1 0c8.7 0 16.8 4.8 21 12.4l96.8 175.5c1.4 2.6 4.1 4.1 7 4.1l124.9 0c13 0 31.8 5.7 47.5 15.3c16.1 9.9 25.7 21.8 25.7 32.7c0 11.3-9.6 23.2-25.6 33c-15.6 9.5-34.5 15-47.5 15H497l20.3 16h1.5c16.6 0 38.3-6.7 55.8-17.3C591.8 292.3 608 276.2 608 256c0-19.8-16.2-35.8-33.3-46.3C557.2 199 535.4 192 518.8 192l-120.2 0L304.1 20.7C297.1 7.9 283.7 0 269.1 0H221c-15.9 0-27.4 15.1-23.1 30.4zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  

  
  

  var faInterrobang = {
    prefix: 'fat',
    iconName: 'interrobang',
    icon: [
      320,
      512,
      [8253],
      'e5ba',
      
      'M136 48C78.6 48 32 94.6 32 152v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8C16 85.7 69.7 32 136 32h48c66.3 0 120 53.7 120 120v6.3c0 33.8-16.4 65.5-44 85L195.1 289c-17 12-27.1 31.5-27.1 52.3V352v16c0 4.4-3.6 8-8 8s-8-3.6-8-8V352 341.3 128c0-4.4 3.6-8 8-8s8 3.6 8 8V293.3c5-6.6 11-12.5 17.9-17.4l64.9-45.8c23.4-16.5 37.3-43.3 37.3-71.9V152c0-57.4-46.6-104-104-104H136zm8 400a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faUserAstronaut = {
    prefix: 'fat',
    iconName: 'user-astronaut',
    icon: [
      448,
      512,
      [],
      'f4fb',
      
      'M224 16a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 336A176 176 0 1 0 224 0a176 176 0 1 0 0 352zM84.7 330.5C33.9 361.9 0 418.1 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7c0-64.2-33.9-120.4-84.7-151.8c-4.2 3.8-8.6 7.4-13.1 10.8c48.9 28 81.8 80.6 81.8 140.9c0 7.6-6.1 13.7-13.7 13.7H352v0V448c0-22.1-17.9-40-40-40H136c-22.1 0-40 17.9-40 40v48 0H29.7c-7.6 0-13.7-6.1-13.7-13.7c0-60.3 32.9-113 81.8-140.9c-4.5-3.4-8.9-7.1-13.1-10.8zM336 496v0H280v0V464c0-4.4-3.6-8-8-8s-8 3.6-8 8v32 0H184v0V464c0-4.4-3.6-8-8-8s-8 3.6-8 8v32 0H112v0V448c0-13.3 10.7-24 24-24H312c13.3 0 24 10.7 24 24v48zM112 176c0-26.5 21.5-48 48-48H288c26.5 0 48 21.5 48 48c0 53-43 96-96 96H208c-53 0-96-43-96-96zm-16 0c0 61.9 50.1 112 112 112h32c61.9 0 112-50.1 112-112c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zm80-32c-4.4 0-8 3.6-8 8v16H152c-4.4 0-8 3.6-8 8s3.6 8 8 8h16v16c0 4.4 3.6 8 8 8s8-3.6 8-8V184h16c4.4 0 8-3.6 8-8s-3.6-8-8-8H184V152c0-4.4-3.6-8-8-8zM16 120V232c0 4.4 3.6 8 8 8s8-3.6 8-8V120c0-4.4-3.6-8-8-8s-8 3.6-8 8zm408-8c-4.4 0-8 3.6-8 8V232c0 4.4 3.6 8 8 8s8-3.6 8-8V120c0-4.4-3.6-8-8-8z'
      
    ]
  };

  

  
  

  var faRecycle = {
    prefix: 'fat',
    iconName: 'recycle',
    icon: [
      512,
      512,
      [9842,9850,9851],
      'f1b8',
      
      'M200.6 31.3C212.3 11.9 233.3 0 256 0s43.7 11.9 55.4 31.3l88.2 146.1 15.4-75c.9-4.3 5.1-7.1 9.4-6.2s7.1 5.1 6.2 9.4L411.3 200c-.5 2.2-1.9 4.2-3.8 5.3s-4.4 1.4-6.5 .7l-91.4-30.4c-4.2-1.4-6.5-5.9-5.1-10.1s5.9-6.5 10.1-5.1l70.2 23.3-87-144.2C288.9 24.9 273.1 16 256 16s-32.9 8.9-41.7 23.5l-48.4 80.3c-2.3 3.8-7.2 5-11 2.7c-3.8-2.3-5-7.2-2.7-11l48.4-80.3zM428 239.9c3.8-2.3 8.7-1 11 2.7l65.3 108.3c5 8.2 7.6 17.6 7.7 27.2c.2 29.7-23.8 53.9-53.5 53.9l-213.5 0 56.3 50c3.3 2.9 3.6 8 .7 11.3s-8 3.6-11.3 .7l-72-64c-1.7-1.5-2.7-3.7-2.7-6s1-4.5 2.7-6l72-64c3.3-2.9 8.4-2.6 11.3 .7s2.6 8.4-.7 11.3L245 416l213.5 0c20.8 0 37.6-17 37.5-37.8c-.1-6.7-1.9-13.3-5.4-19L425.3 250.9c-2.3-3.8-1.1-8.7 2.7-11zM114.4 174.1L42.5 197.9c-4.2 1.4-8.7-.9-10.1-5.1s.9-8.7 5.1-10.1l91.4-30.4c2.2-.7 4.5-.5 6.5 .7s3.4 3.1 3.8 5.3l19.4 94.4c.9 4.3-1.9 8.6-6.2 9.4s-8.6-1.9-9.4-6.2l-15.1-73.3L21.4 359.2c-3.5 5.7-5.3 12.3-5.4 19C15.8 399 32.7 416 53.5 416L168 416c4.4 0 8 3.6 8 8s-3.6 8-8 8L53.5 432C23.8 432-.2 407.8 0 378.1c.1-9.6 2.7-19 7.7-27.2L114.4 174.1z'
      
    ]
  };

  

  
  

  var faBackwardFast = {
    prefix: 'fat',
    iconName: 'backward-fast',
    icon: [
      512,
      512,
      [9198,"fast-backward"],
      'f049',
      
      'M8 64c4.4 0 8 3.6 8 8V234.4L207.8 71c5.3-4.5 12-7 19-7C242.9 64 256 77.1 256 93.2V248L463.8 71c5.3-4.5 12-7 19-7C498.9 64 512 77.1 512 93.2V418.8c0 16.1-13.1 29.2-29.2 29.2c-6.9 0-13.7-2.5-19-7L256 264V418.8c0 16.1-13.1 29.2-29.2 29.2c-6.9 0-13.7-2.5-19-7L16 277.6V440c0 4.4-3.6 8-8 8s-8-3.6-8-8V256 72c0-4.4 3.6-8 8-8zm8 192c0 .4 .2 .8 .5 1L218.2 428.8c2.4 2 5.4 3.2 8.6 3.2c7.3 0 13.2-5.9 13.2-13.2V93.2c0-7.3-5.9-13.2-13.2-13.2c-3.1 0-6.2 1.1-8.6 3.2L16.5 255c-.3 .3-.5 .6-.5 1zm256 .6L474.2 428.8c2.4 2 5.4 3.2 8.6 3.2c7.3 0 13.2-5.9 13.2-13.2V93.2c0-7.3-5.9-13.2-13.2-13.2c-3.1 0-6.2 1.1-8.6 3.2L272 255.4v1.2z'
      
    ]
  };

  
    var faFastBackward = faBackwardFast;
  

  
  

  var faSword = {
    prefix: 'fat',
    iconName: 'sword',
    icon: [
      512,
      512,
      [128481],
      'f71c',
      
      'M509.7 2.3c1.8 1.8 2.7 4.4 2.2 7L499.3 85.1c-2.5 14.8-9.5 28.5-20.1 39.1L271.6 331.7l-11.3-11.3L467.8 112.8c8.3-8.3 13.7-18.9 15.6-30.4l10.8-64.7L429.5 28.5c-11.5 1.9-22.1 7.4-30.4 15.6L191.6 251.7l-11.3-11.3L387.8 32.8c10.6-10.6 24.3-17.6 39.1-20.1L502.7 .1c2.6-.4 5.1 .4 7 2.2zM121 237.7L274.3 391c9.4 9.4 9.4 24.6 0 33.9l-11.9 11.9c-7.8 7.8-19.9 9.3-29.3 3.6l-63.9-38.4L128 443.3v30.1c0 6.4-2.5 12.5-7 17l-8 8c-9.4 9.4-24.6 9.4-33.9 0L13.7 433c-9.4-9.4-9.4-24.6 0-33.9l8-8c4.5-4.5 10.6-7 17-7H68.7l41.2-41.2L71.6 278.8c-5.7-9.4-4.2-21.5 3.6-29.3L87 237.7c9.4-9.4 24.6-9.4 33.9 0zM98.3 249L86.5 260.8c-2.6 2.6-3.1 6.6-1.2 9.8l41.6 69.3c1.9 3.1 1.4 7.2-1.2 9.8l-48 48c-1.5 1.5-3.5 2.3-5.7 2.3H38.6c-2.1 0-4.2 .8-5.7 2.3l-8 8c-3.1 3.1-3.1 8.2 0 11.3L90.3 487c3.1 3.1 8.2 3.1 11.3 0l8-8c1.5-1.5 2.3-3.5 2.3-5.7V440c0-2.1 .8-4.2 2.3-5.7l48-48c2.6-2.6 6.6-3.1 9.8-1.2l69.3 41.6c3.1 1.9 7.2 1.4 9.8-1.2L263 413.7c3.1-3.1 3.1-8.2 0-11.3L109.7 249c-3.1-3.1-8.2-3.1-11.3 0z'
      
    ]
  };

  

  
  

  var faCartCircleExclamation = {
    prefix: 'fat',
    iconName: 'cart-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e3f2',
      
      'M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8H45.7C57.1 16 67 24.1 69.2 35.4l59.4 303.4c5.1 26.3 28.2 45.2 55 45.2H320.7c-.5-5.3-.7-10.6-.7-16H183.5c-19.1 0-35.6-13.5-39.3-32.3L134.9 288H339.2c2.8-5.5 5.9-10.8 9.3-16H131.8L88 48H527.7c15.5 0 26.9 14.4 23.4 29.5L523.8 194.2c5.3 .8 10.5 1.9 15.7 3.2L566.6 81.1C572.5 56 553.4 32 527.7 32H84.8C81 13.4 64.7 0 45.7 0H8zM144 464a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm144-96a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 448a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-168c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8s8-3.6 8-8V288c0-4.4-3.6-8-8-8z'
      
    ]
  };

  

  
  

  var faLeftToBracket = {
    prefix: 'fat',
    iconName: 'left-to-bracket',
    icon: [
      512,
      512,
      [],
      'e66d',
      
      'M179.3 264c-2.1-2.1-3.3-5-3.3-8s1.2-5.9 3.3-8L311.4 116.2c2.7-2.7 6.4-4.2 10.2-4.2c8 0 14.4 6.5 14.4 14.4l0 73.6c0 4.4 3.6 8 8 8l136 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-136 0c-4.4 0-8 3.6-8 8l0 73.6c0 8-6.5 14.4-14.4 14.4c-3.8 0-7.5-1.5-10.2-4.2L179.3 264zM160 256c0 7.2 2.9 14.2 8 19.3L300.1 407.1c5.7 5.7 13.4 8.9 21.5 8.9c16.8 0 30.4-13.6 30.4-30.4l0-65.6 128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-128 0 0-65.6c0-16.8-13.6-30.4-30.4-30.4c-8.1 0-15.8 3.2-21.5 8.9L168 236.7c-5.1 5.1-8 12.1-8 19.3zm24 208l-96 0c-39.8 0-72-32.2-72-72l0-272c0-39.8 32.2-72 72-72l96 0c4.4 0 8-3.6 8-8s-3.6-8-8-8L88 32C39.4 32 0 71.4 0 120L0 392c0 48.6 39.4 88 88 88l96 0c4.4 0 8-3.6 8-8s-3.6-8-8-8z'
      
    ]
  };

  

  
  

  var faCircle = {
    prefix: 'fat',
    iconName: 'circle',
    icon: [
      512,
      512,
      [9679,9898,9899,11044,61708,61915,128308,128309,128992,128993,128994,128995,128996],
      'f111',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  

  
  

  var faSquarePollHorizontal = {
    prefix: 'fat',
    iconName: 'square-poll-horizontal',
    icon: [
      448,
      512,
      ["poll-h"],
      'f682',
      
      'M432 96c0-26.5-21.5-48-48-48L64 48C37.5 48 16 69.5 16 96l0 320c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zM112 160c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-8.8 0-16 7.2-16 16zm16-224l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 96H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 96h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32z'
      
    ]
  };

  
    var faPollH = faSquarePollHorizontal;
  

  
  

  var faHouseFloodWaterCircleArrowRight = {
    prefix: 'fat',
    iconName: 'house-flood-water-circle-arrow-right',
    icon: [
      640,
      512,
      [],
      'e50f',
      
      'M305.2 73.2c-2.2-5-4.6-9.8-7.2-14.5L379.4 1.5c2.8-1.9 6.4-1.9 9.2 0l216 152c3.6 2.5 4.5 7.5 1.9 11.1s-7.5 4.5-11.1 1.9L560 141.6V276.6c-2.4-1.6-4.6-3.3-6.8-5.1c-2.9-2.5-6-4.6-9.2-6.5V130.4L384 17.8 305.2 73.2zm21.4 250.2c8 11.2 17.5 21.4 27.6 30.7C371.5 369.8 393.5 384 416 384s44.6-14.2 61.8-29.9c10.1-9.2 19.7-19.5 27.6-30.7c1.5-2.1 3.9-3.4 6.6-3.4s5.1 1.3 6.6 3.4c7.3 10.3 15.9 19.6 25 28.3c15.7 14.8 36.1 29.2 57.4 31.9c4.4 .6 7.5 4.6 6.9 8.9s-4.6 7.5-8.9 6.9c-26.5-3.3-50-20.7-66.4-36.1c-8.8-8.3-15.9-16.4-20.6-22.2c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8l0 0 0 0c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-4.7 5.8-11.8 13.9-20.6 22.2C91 378.7 67.5 396.1 41 399.4c-4.4 .6-8.4-2.6-8.9-6.9s2.6-8.4 6.9-8.9c21.3-2.7 41.7-17.1 57.4-31.9c9.1-8.6 17.7-18 25-28.3c1.5-2.1 3.9-3.4 6.6-3.4s5.1 1.3 6.6 3.4c7.9 11.2 17.5 21.5 27.6 30.7C179.4 369.8 201.5 384 224 384s44.6-14.2 61.8-29.9c10.1-9.2 19.6-19.5 27.6-30.7c3-4.3 10.2-4.3 13.2 0zm27.6 142.7C371.5 481.8 393.5 496 416 496s44.6-14.2 61.8-29.9c10.1-9.2 19.7-19.5 27.6-30.7c1.5-2.1 3.9-3.4 6.6-3.4s5.1 1.3 6.6 3.4c7.3 10.3 15.9 19.6 25 28.3c15.7 14.8 36.1 29.2 57.4 31.9c4.4 .6 7.5 4.6 6.9 8.9s-4.6 7.5-8.9 6.9c-26.5-3.3-50-20.7-66.4-36.1c-8.8-8.3-15.9-16.4-20.6-22.2c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8l0 0 0 0c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-4.7 5.8-11.8 13.9-20.6 22.2C91 490.7 67.5 508.1 41 511.4c-4.4 .6-8.4-2.6-8.9-6.9s2.6-8.4 6.9-8.9c21.3-2.7 41.7-17.1 57.4-31.9c9.1-8.6 17.7-18 25-28.3c1.5-2.1 3.9-3.4 6.6-3.4s5.1 1.3 6.6 3.4c7.9 11.2 17.5 21.5 27.6 30.7C179.4 481.8 201.5 496 224 496s44.6-14.2 61.8-29.9c10.1-9.2 19.6-19.5 27.6-30.7c3-4.3 10.2-4.3 13.2 0c8 11.2 17.5 21.4 27.6 30.7zM144 272a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM144 0a144 144 0 1 1 0 288A144 144 0 1 1 144 0zm2.3 74.3c3.1-3.1 8.2-3.1 11.3 0l64 64c3.1 3.1 3.1 8.2 0 11.3l-64 64c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L196.7 152H72c-4.4 0-8-3.6-8-8s3.6-8 8-8H196.7L146.3 85.7c-3.1-3.1-3.1-8.2 0-11.3z'
      
    ]
  };

  

  
  

  var faMoneyBillTrendUp = {
    prefix: 'fat',
    iconName: 'money-bill-trend-up',
    icon: [
      512,
      512,
      [],
      'e529',
      
      'M352 8c0 4.4 3.6 8 8 8h92.7L287.6 181.1 181.2 89.9c-3-2.6-7.5-2.6-10.5 .1L42.7 202c-3.3 2.9-3.7 8-.8 11.3s8 3.7 11.3 .8L176.1 106.6l106.7 91.5c3.2 2.7 7.9 2.5 10.9-.4L464 27.3V120c0 4.4 3.6 8 8 8s8-3.6 8-8V8c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8zM464 272c17.7 0 32 14.3 32 32v24c-30.9 0-56-25.1-56-56h24zM88 272H424c0 39.8 32.2 72 72 72v80c-39.8 0-72 32.2-72 72H88c0-39.8-32.2-72-72-72V344c39.8 0 72-32.2 72-72zM440 496c0-30.9 25.1-56 56-56v24c0 17.7-14.3 32-32 32H440zM16 440c30.9 0 56 25.1 56 56H48c-17.7 0-32-14.3-32-32V440zM72 272c0 30.9-25.1 56-56 56V304c0-17.7 14.3-32 32-32H72zM48 256c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48H48zM208 384a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z'
      
    ]
  };

  

  
  

  var faMoneyBillTransfer = {
    prefix: 'fat',
    iconName: 'money-bill-transfer',
    icon: [
      640,
      512,
      [],
      'e528',
      
      'M562.3 13.7L612.7 64l-56.6 0 0 0H80c-26.5 0-48 21.5-48 48V348.1l6.1-6.1 9.9-9.9V112c0-17.7 14.3-32 32-32H407.9l.1 0 204.7 0-50.3 50.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l64-64c1.5-1.5 2.3-3.5 2.3-5.7s-.8-4.2-2.3-5.7l-64-64c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3zM27.3 448l56.6 0h8.2H560c26.5 0 48-21.5 48-48V163.9l-6.1 6.1-9.9 9.9V400c0 17.7-14.3 32-32 32H232.2l-.2 0L91.2 432H83.9l-56.6 0 50.3-50.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-64 64C.8 435.8 0 437.9 0 440s.8 4.2 2.3 5.7l64 64c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L27.3 448zM480 408c0 4.4 3.6 8 8 8s8-3.6 8-8V392c0-30.9 25.1-56 56-56h8c4.4 0 8-3.6 8-8s-3.6-8-8-8h-8c-39.8 0-72 32.2-72 72v16zM152 96c-4.4 0-8 3.6-8 8v16c0 30.9-25.1 56-56 56H80c-4.4 0-8 3.6-8 8s3.6 8 8 8h8c39.8 0 72-32.2 72-72V104c0-4.4-3.6-8-8-8zm88 160a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm176 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z'
      
    ]
  };

  

  
  

  var faElevator = {
    prefix: 'fat',
    iconName: 'elevator',
    icon: [
      512,
      512,
      [],
      'e16d',
      
      'M301.9 2.6L368 76 434.1 2.6c3-3.3 8-3.6 11.3-.6s3.6 8 .6 11.3l-72 80C372.4 95 370.3 96 368 96s-4.4-1-5.9-2.6l-72-80c-3-3.3-2.7-8.3 .6-11.3s8.3-2.7 11.3 .6zm-152 0l72 80c3 3.3 2.7 8.3-.6 11.3s-8.3 2.7-11.3-.6L144 20 77.9 93.4c-3 3.3-8 3.6-11.3 .6s-3.6-8-.6-11.3l72-80C139.6 1 141.7 0 144 0s4.4 1 5.9 2.6zM64 144c-26.5 0-48 21.5-48 48V448c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V192c0-26.5-21.5-48-48-48H64zM0 192c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192zm200 72a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm-96 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm248 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm0-96a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM136 368c-22.1 0-40 17.9-40 40v32c0 4.4-3.6 8-8 8s-8-3.6-8-8V408c0-30.9 25.1-56 56-56h48c30.9 0 56 25.1 56 56v32c0 4.4-3.6 8-8 8s-8-3.6-8-8V408c0-22.1-17.9-40-40-40H136zm152 40v32c0 4.4-3.6 8-8 8s-8-3.6-8-8V408c0-30.9 25.1-56 56-56h48c30.9 0 56 25.1 56 56v32c0 4.4-3.6 8-8 8s-8-3.6-8-8V408c0-22.1-17.9-40-40-40H328c-22.1 0-40 17.9-40 40z'
      
    ]
  };

  

  
  

  var faTally3 = {
    prefix: 'fat',
    iconName: 'tally-3',
    icon: [
      640,
      512,
      [],
      'e296',
      
      'M128 32c4.4 0 8 3.6 8 8V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V40c0-4.4 3.6-8 8-8zm128 0c4.4 0 8 3.6 8 8V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V40c0-4.4 3.6-8 8-8zm136 8V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V40c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faHouseChimneyHeart = {
    prefix: 'fat',
    iconName: 'house-chimney-heart',
    icon: [
      576,
      512,
      [],
      'e1b2',
      
      'M282.7 2c3-2.7 7.6-2.7 10.6 0L384 82.3V56c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V195.7L573.3 250c3.3 2.9 3.6 8 .7 11.3s-8 3.6-11.3 .7L512 217.1V448c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V217.1L13.3 262c-3.3 2.9-8.4 2.6-11.3-.7S-.6 252.9 2.7 250L282.7 2zM496 181.5V56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8V96.5l96 85zM384 103.7l-96-85L80 202.9V448c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V202.9L384.3 104H384v-.3zM233.9 240c-23.2 0-41.9 18.8-41.9 41.9v.6c0 10.6 4 20.9 11.2 28.8l78.9 86.1c1.5 1.7 3.7 2.6 5.9 2.6s4.4-.9 5.9-2.6l78.9-86.1c7.2-7.8 11.2-18.1 11.2-28.8v-.6c0-23.2-18.8-41.9-41.9-41.9c-11.1 0-21.8 4.4-29.7 12.3L293.7 271c-1.5 1.5-3.5 2.3-5.7 2.3s-4.2-.8-5.7-2.3l-18.7-18.7c-7.9-7.9-18.5-12.3-29.7-12.3zM176 281.9c0-32 25.9-57.9 57.9-57.9c15.4 0 30.1 6.1 41 17L288 254.1 301.1 241c10.9-10.9 25.6-17 41-17c32 0 57.9 25.9 57.9 57.9v.6c0 14.7-5.5 28.8-15.4 39.6l-78.9 86.1c-4.5 5-11 7.8-17.7 7.8s-13.1-2.8-17.7-7.8l-78.9-86.1c-9.9-10.8-15.4-24.9-15.4-39.6v-.6z'
      
    ]
  };

  

  
  

  var faTableTree = {
    prefix: 'fat',
    iconName: 'table-tree',
    icon: [
      512,
      512,
      [],
      'e293',
      
      'M64 48C37.5 48 16 69.5 16 96v64H496V96c0-26.5-21.5-48-48-48H64zM16 176V416c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V176H112v72c0 13.3 10.7 24 24 24h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H136c-9 0-17.3-3-24-8v64c0 13.3 10.7 24 24 24H248c4.4 0 8 3.6 8 8s-3.6 8-8 8H136c-22.1 0-40-17.9-40-40V248 176H16zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM224 280c0-4.4 3.6-8 8-8H408c4.4 0 8 3.6 8 8s-3.6 8-8 8H232c-4.4 0-8-3.6-8-8zm72 88H408c4.4 0 8 3.6 8 8s-3.6 8-8 8H296c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faLockOpen = {
    prefix: 'fat',
    iconName: 'lock-open',
    icon: [
      576,
      512,
      [],
      'f3c1',
      
      'M336 128c0-61.9 50.1-112 112-112s112 50.1 112 112v88c0 4.4 3.6 8 8 8s8-3.6 8-8V128C576 57.3 518.7 0 448 0S320 57.3 320 128v64H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H336V128zm-16 80h16 48c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V256c0-26.5 21.5-48 48-48H320z'
      
    ]
  };

  

  
  

  var faSolarPanel = {
    prefix: 'fat',
    iconName: 'solar-panel',
    icon: [
      640,
      512,
      [],
      'f5ba',
      
      'M67.2 48.6l-50.5 267c-.5 2.5-.7 4.9-.7 7.4v5c0 22.1 17.9 40 40 40H584c22.1 0 40-17.9 40-40v-5c0-2.5-.2-5-.7-7.4l-50.5-267C569.2 29.7 552.7 16 533.5 16h-427C87.3 16 70.8 29.7 67.2 48.6zm-15.7-3C56.5 19.1 79.6 0 106.5 0h427c26.9 0 50 19.1 55 45.6l50.5 267c.6 3.4 1 6.9 1 10.4v5c0 30.9-25.1 56-56 56H328V496H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H200c-4.4 0-8-3.6-8-8s3.6-8 8-8H312V384H56c-30.9 0-56-25.1-56-56v-5c0-3.5 .3-7 1-10.4l50.5-267zM103.7 200L84 304H226.9l9-104H103.7zm3-16H237.3l9-104H126.4L106.7 184zM262.4 80l-9 104H386.6l-9-104H262.4zm131.3 0l9 104H533.3L513.6 80H393.7zM536.3 200H404.1l9 104H556L536.3 200zM397 304l-9-104H252l-9 104H397zM110.7 77c1.4-7.6 8-13 15.7-13H513.6c7.7 0 14.3 5.5 15.7 13l42.4 224c1.9 9.9-5.7 19-15.7 19H84c-10 0-17.6-9.1-15.7-19L110.7 77z'
      
    ]
  };

  

  
  

  var faShieldDog = {
    prefix: 'fat',
    iconName: 'shield-dog',
    icon: [
      512,
      512,
      [],
      'e573',
      
      'M237.3 22.6c12-5.1 25.5-5.1 37.5 0l176.7 75c16.6 7.1 28.6 23.2 28.5 42.4c-.5 96.6-40.3 270.2-204.5 348.8c-12.3 5.9-26.7 5.9-39 0C72.3 410.1 32.5 236.5 32 139.9c-.1-19.1 11.9-35.3 28.5-42.4l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM208 128H176c-26.5 0-48 21.5-48 48v40c0 22.3 15.2 41.1 35.8 46.4l-19 38c-2 4-.4 8.8 3.6 10.7s8.8 .4 10.7-3.6l21.9-43.8c24.1-2.5 42.9-22.9 42.9-47.7V144h68.2c9.1 0 17.4 5.1 21.5 13.3l7.2 14.3c1.4 2.7 4.1 4.4 7.2 4.4h64c4.4 0 8 3.6 8 8v24c0 39.8-32.2 72-72 72H280c-4.4 0-8 3.6-8 8v88c0 4.4 3.6 8 8 8s8-3.6 8-8V296h40c48.6 0 88-39.4 88-88V184c0-13.3-10.7-24-24-24H332.9l-4.9-9.9c-6.8-13.6-20.6-22.1-35.8-22.1H224h-8-8zm0 88c0 17.6-14.2 31.9-31.8 32l-.3 0c-17.6-.1-31.9-14.4-31.9-32V176c0-17.7 14.3-32 32-32h16 16v16 56zm64-8a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faShutters = {
    prefix: 'fat',
    iconName: 'shutters',
    icon: [
      512,
      512,
      [],
      'e449',
      
      'M496 48V80H16V48H496zM16 32C7.2 32 0 39.2 0 48V80c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H16zm2.5 192L1.8 260.1C.6 262.7 0 265.5 0 268.3C0 279.2 8.8 288 19.7 288H492.3c10.9 0 19.7-8.8 19.7-19.7c0-2.8-.6-5.7-1.8-8.2L493.5 224H475.9l19.7 42.8c.2 .5 .3 1 .3 1.5c0 2-1.6 3.7-3.7 3.7H19.7c-2 0-3.7-1.6-3.7-3.7c0-.5 .1-1.1 .3-1.5L36.1 224H18.5zM1.8 356.1C.6 358.7 0 361.5 0 364.3C0 375.2 8.8 384 19.7 384H492.3c10.9 0 19.7-8.8 19.7-19.7c0-2.8-.6-5.7-1.8-8.2L493.5 320H475.9l19.7 42.8c.2 .5 .3 1 .3 1.5c0 2-1.6 3.7-3.7 3.7H19.7c-2 0-3.7-1.6-3.7-3.7c0-.5 .1-1.1 .3-1.5L36.1 320H18.5L1.8 356.1zM18.5 416L1.8 452.1C.6 454.7 0 457.5 0 460.3C0 471.2 8.8 480 19.7 480H492.3c10.9 0 19.7-8.8 19.7-19.7c0-2.8-.6-5.7-1.8-8.2L493.5 416H475.9l19.7 42.8c.2 .5 .3 1 .3 1.5c0 2-1.6 3.7-3.7 3.7H19.7c-2 0-3.7-1.6-3.7-3.7c0-.5 .1-1.1 .3-1.5L36.1 416H18.5zM1.8 164.1C.6 166.7 0 169.5 0 172.3C0 183.2 8.8 192 19.7 192H492.3c10.9 0 19.7-8.8 19.7-19.7c0-2.8-.6-5.7-1.8-8.2L493.5 128H475.9l19.7 42.8c.2 .5 .3 1 .3 1.5c0 2-1.6 3.7-3.7 3.7H19.7c-2 0-3.7-1.6-3.7-3.7c0-.5 .1-1.1 .3-1.5L36.1 128H18.5L1.8 164.1z'
      
    ]
  };

  

  
  

  var faBitcoinSign = {
    prefix: 'fat',
    iconName: 'bitcoin-sign',
    icon: [
      320,
      512,
      [],
      'e0b4',
      
      'M80 8c0-4.4 3.6-8 8-8s8 3.6 8 8V64h64V8c0-4.4 3.6-8 8-8s8 3.6 8 8V64.1c53.4 2.1 96 46 96 99.9c0 36.5-19.5 68.4-48.7 85.9c46 9 80.7 49.5 80.7 98.1c0 55.2-44.8 100-100 100H176v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V448H96l0 56c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-56H53.6C32.8 448 16 431.2 16 410.4V264 248 97.4C16 78.9 30.9 64 49.4 64H80V8zM49.4 80C39.8 80 32 87.8 32 97.4V248H172c46.4 0 84-37.6 84-84s-37.6-84-84-84H49.4zM172 264H32V410.4c0 11.9 9.7 21.6 21.6 21.6H204c46.4 0 84-37.6 84-84s-37.6-84-84-84H172z'
      
    ]
  };

  

  
  

  var faArrowDownTriangleSquare = {
    prefix: 'fat',
    iconName: 'arrow-down-triangle-square',
    icon: [
      576,
      512,
      ["sort-shapes-down"],
      'f888',
      
      'M269.7 373.7l-104 104c-3.1 3.1-8.2 3.1-11.3 0l-104-104c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L152 452.7V40c0-4.4 3.6-8 8-8s8 3.6 8 8V452.7l90.3-90.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3zM416 32c9.9 0 19.1 5.2 24.2 13.7L524.4 186c2.3 3.9 3.6 8.4 3.6 12.9c0 13.8-11.2 25.1-25.1 25.1H329.1c-13.8 0-25.1-11.2-25.1-25.1c0-4.5 1.2-9 3.6-12.9L391.8 45.7C396.9 37.2 406.1 32 416 32zM336 432c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V336c0-17.7-14.3-32-32-32H368c-17.7 0-32 14.3-32 32v96zM321.3 194.3c-.8 1.4-1.3 3-1.3 4.7c0 5 4.1 9.1 9.1 9.1H502.9c5 0 9.1-4.1 9.1-9.1c0-1.6-.4-3.3-1.3-4.7L426.5 54c-2.2-3.7-6.2-6-10.5-6s-8.3 2.3-10.5 6L321.3 194.3zM320 432V336c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48z'
      
    ]
  };

  
    var faSortShapesDown = faArrowDownTriangleSquare;
  

  
  

  var faCube = {
    prefix: 'fat',
    iconName: 'cube',
    icon: [
      512,
      512,
      [],
      'f1b2',
      
      'M264 19.3c-5.2-1.8-10.9-1.8-16.1 0L32 96c-4.9 1.7-9 5-11.8 9.1L256 199.4l235.8-94.3C489 101 484.9 97.7 480 96L264 19.3zM16 393.4c0 10.2 6.4 19.2 16 22.6l216 76.6s0 0 0 0V213.4L16 120.6V393.4zm248 99.3s0 0 0 0L480 416c9.6-3.4 16-12.5 16-22.6V120.6L264 213.4V492.7zM242.6 4.3c8.7-3.1 18.1-3.1 26.8 0l216 76.6c16 5.7 26.6 20.8 26.6 37.7V393.4c0 16.9-10.7 32-26.6 37.7l-216 76.6c-8.7 3.1-18.1 3.1-26.8 0l-216-76.6C10.7 425.4 0 410.3 0 393.4V118.6c0-16.9 10.7-32 26.6-37.7l216-76.6z'
      
    ]
  };

  

  
  

  var faHandsHoldingDollar = {
    prefix: 'fat',
    iconName: 'hands-holding-dollar',
    icon: [
      640,
      512,
      ["hands-usd"],
      'f4c5',
      
      'M328 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V32.3c-11.4 .9-23.5 4.2-33.5 10.4c-12.8 7.9-22.5 20.9-22.4 39.4c.1 17 9.2 28.1 21.2 35.7c11.1 7 25.5 11.6 38.7 15.8l1.4 .5c14.2 4.5 27 8.7 36.4 14.9c8.9 5.9 14 13 14.2 23.8c.2 12.9-5.6 21.5-14.3 27.1c-9 5.9-21.4 8.6-33.4 8.2c-15.4-.5-29.8-5.7-45.6-11.3c-2.6-.9-5.3-1.9-8-2.9c-4.2-1.5-8.7 .7-10.2 4.9s.7 8.7 4.9 10.2c2.5 .9 5 1.8 7.6 2.7l0 0 0 0 0 0c13.4 4.8 27.8 10 43.1 11.8l0 24.6c0 4.4 3.6 8 8 8s8-3.6 8-8V223.8c12-.7 24.3-4 34.4-10.6c12.8-8.3 21.8-21.9 21.6-40.7c-.2-17.5-9.2-29-21.3-37c-11.6-7.7-26.7-12.4-40.4-16.8l-.2-.1c-14.2-4.5-26.9-8.5-36.2-14.4C277 98.6 272.1 92 272.1 82c-.1-11.9 5.8-20.1 14.8-25.7c9.3-5.8 21.7-8.5 33-8.3c13 .2 26.7 3.2 40 6.9c4.3 1.2 8.7-1.3 9.9-5.6s-1.3-8.7-5.6-9.9c-11.3-3.2-23.7-6-36.2-7V8zM96 112c0-26.5-21.5-48-48-48S0 85.5 0 112V344.2c0 27.6 11 54 30.5 73.5l91.9 91.9c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L41.8 406.5C25.3 390 16 367.6 16 344.2V112c0-17.7 14.3-32 32-32s32 14.3 32 32V259c0 20.7 8.2 40.6 22.9 55.2l19.5 19.5 55.9 55.9 0 0 8 8c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-8-8 0 0-55.9-55.9 0 0c-10.6-10.6-11.3-27.6-1.5-39.1c10.9-12.7 30.3-13.5 42.2-1.6l92.8 92.7c13.3 13.3 20.8 31.4 20.8 50.3V504c0 4.4 3.6 8 8 8s8-3.6 8-8V424.8c0-23.1-9.2-45.3-25.5-61.6l-92.8-92.8c-18.4-18.4-48.7-17.3-65.6 2.5c-6.2 7.2-9.7 15.9-10.6 24.7C100.8 286.7 96 273.1 96 259V112zM592 64c-26.5 0-48 21.5-48 48V259c0 14.1-4.8 27.8-13.5 38.7c-.9-8.8-4.4-17.5-10.6-24.7c-17-19.8-47.2-21-65.6-2.5l-92.7 92.8c-16.3 16.3-25.5 38.5-25.5 61.6V504c0 4.4 3.6 8 8 8s8-3.6 8-8V424.8c0-18.9 7.5-37 20.8-50.3l92.8-92.7c11.8-11.9 31.3-11.1 42.2 1.6c9.8 11.4 9.1 28.4-1.5 39.1l0 0-55.9 55.9 0 0-8 8c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l8-8 55.9-55.9 19.5-19.5C551.8 299.5 560 279.7 560 259V112c0-17.7 14.3-32 32-32s32 14.3 32 32V344.2c0 23.3-9.3 45.7-25.8 62.2l-91.9 91.9c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l91.9-91.9c19.5-19.5 30.5-46 30.5-73.5V112c0-26.5-21.5-48-48-48z'
      
    ]
  };

  
    var faHandsUsd = faHandsHoldingDollar;
  

  
  

  var faToiletPaperXmark = {
    prefix: 'fat',
    iconName: 'toilet-paper-xmark',
    icon: [
      512,
      512,
      [],
      'e5b3',
      
      'M16 192c0 49.7 11.4 94.3 29.4 126.2C63.6 350.3 87.4 368 112 368H354.8c-13.6-10.2-25.5-24.7-35.3-42C299.9 291.3 288 243.9 288 192s11.9-99.3 31.5-134c9.8-17.3 21.7-31.8 35.3-42H112C87.4 16 63.6 33.7 45.4 65.8C27.4 97.7 16 142.3 16 192zM333.4 65.8C315.4 97.7 304 142.3 304 192s11.4 94.3 29.4 126.2c18.2 32.1 42 49.8 66.6 49.8s48.4-17.7 66.6-49.8c18-31.9 29.4-76.5 29.4-126.2s-11.4-94.3-29.4-126.2C448.4 33.7 424.6 16 400 16s-48.4 17.7-66.6 49.8zM496 472V291.5c-4.4 12.5-9.6 24.1-15.5 34.6c-19.5 34.5-47.6 58-80.5 58H112c-32.9 0-61-23.5-80.5-58C11.9 291.3 0 243.9 0 192S11.9 92.7 31.5 58C51 23.5 79.1 0 112 0H400c32.9 0 61 23.5 80.5 58C500.1 92.7 512 140.1 512 192V472c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V416h16v56c0 13.3 10.7 24 24 24H472c13.3 0 24-10.7 24-24zM400 264c-8.7 0-15.7-4.2-20.6-9c-4.8-4.8-8.4-10.8-11.1-17.1c-5.4-12.6-8.3-28.8-8.3-45.9s2.9-33.3 8.3-45.9c2.7-6.3 6.3-12.3 11.1-17.1c4.9-4.8 11.9-9 20.6-9s15.7 4.2 20.6 9c4.8 4.8 8.4 10.8 11.1 17.1c5.4 12.6 8.3 28.8 8.3 45.9s-2.9 33.3-8.3 45.9c-2.7 6.3-6.3 12.3-11.1 17.1c-4.9 4.8-11.9 9-20.6 9zm24-72c0-30.9-10.7-56-24-56s-24 25.1-24 56s10.7 56 24 56s24-25.1 24-56zM229.7 253.7c-3.1 3.1-8.2 3.1-11.3 0L168 203.3l-50.3 50.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L156.7 192l-50.3-50.3c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L168 180.7l50.3-50.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L179.3 192l50.3 50.3c3.1 3.1 3.1 8.2 0 11.3z'
      
    ]
  };

  

  
  

  var faWifiSlash = {
    prefix: 'fat',
    iconName: 'wifi-slash',
    icon: [
      640,
      512,
      [],
      'f6ac',
      
      'M1.7 3C4.5-.4 9.5-1 13 1.7l624 496c3.5 2.7 4 7.8 1.3 11.2s-7.8 4-11.2 1.3L3 14.3C-.4 11.5-1 6.5 1.7 3zM385.4 215.9l-27.1-21.4c61.2 8.1 116.4 35.5 159.2 75.8c3.2 3 3.4 8.1 .3 11.3s-8.1 3.4-11.3 .3c-33.5-31.6-75-54.7-121.1-66.1zM187 242.7c-19.4 10.9-37.4 24.1-53.5 39.3c-3.2 3-8.3 2.9-11.3-.3s-2.9-8.3 .3-11.3C138 255.8 155 242.9 173.4 232L187 242.7zm8.8-176.6l-15.2-12C224.4 39.8 271.3 32 320 32c124.1 0 236.4 50.5 317.5 132c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0C548 96.6 439.7 48 320 48c-43.2 0-84.9 6.3-124.3 18.1zM42.3 128.5l12.9 10.2C40.6 150 26.8 162.2 13.8 175.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3c12.5-12.6 25.8-24.5 39.8-35.5zm217 307.8a64 64 0 1 1 121.4-40.7A64 64 0 1 1 259.3 436.3zM368 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  

  
  

  var faSquareInfo = {
    prefix: 'fat',
    iconName: 'square-info',
    icon: [
      448,
      512,
      [8505,"info-square"],
      'f30f',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm208 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-16 48h32c4.4 0 8 3.6 8 8V352h40c4.4 0 8 3.6 8 8s-3.6 8-8 8H176c-4.4 0-8-3.6-8-8s3.6-8 8-8h40V224H192c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  
    var faInfoSquare = faSquareInfo;
  

  
  

  var faTemperatureQuarter = {
    prefix: 'fat',
    iconName: 'temperature-quarter',
    icon: [
      320,
      512,
      ["temperature-1","thermometer-1","thermometer-quarter"],
      'f2ca',
      
      'M160 16c-35.3 0-64 28.7-64 64V243.8c0 8.4-4.4 15.7-10.7 20.3C53 287.3 32 325.2 32 368c0 70.7 57.3 128 128 128s128-57.3 128-128c0-42.8-21-80.7-53.3-104c-6.3-4.6-10.7-11.9-10.7-20.3V80c0-35.3-28.7-64-64-64zM80 80c0-44.2 35.8-80 80-80s80 35.8 80 80V243.8c0 2.7 1.4 5.4 4 7.3c36.3 26.1 60 68.8 60 117c0 79.5-64.5 144-144 144S16 447.5 16 368c0-48.2 23.7-90.8 60-117c2.6-1.9 4-4.6 4-7.3V80zm80 336a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 16c-35.3 0-64-28.7-64-64c0-32.6 24.4-59.6 56-63.5V264c0-4.4 3.6-8 8-8s8 3.6 8 8v40.5c31.6 3.9 56 30.9 56 63.5c0 35.3-28.7 64-64 64z'
      
    ]
  };

  
    var faTemperature1 = faTemperatureQuarter;
  
    var faThermometer1 = faTemperatureQuarter;
  
    var faThermometerQuarter = faTemperatureQuarter;
  

  
  

  var faR = {
    prefix: 'fat',
    iconName: 'r',
    icon: [
      320,
      512,
      [114],
      '52',
      
      'M24 32C10.7 32 0 42.7 0 56V280 472c0 4.4 3.6 8 8 8s8-3.6 8-8V288H176h6.4l2.9 4.4 120 184c2.4 3.7 7.4 4.7 11.1 2.3s4.7-7.4 2.3-11.1l-117.4-180C267.7 282.9 320 227.6 320 160c0-70.7-57.3-128-128-128H24zM176 272H16V56c0-4.4 3.6-8 8-8H192c61.9 0 112 50.1 112 112s-50.1 112-112 112H176z'
      
    ]
  };

  

  
  

  var faLockKeyhole = {
    prefix: 'fat',
    iconName: 'lock-keyhole',
    icon: [
      448,
      512,
      ["lock-alt"],
      'f30d',
      
      'M224 16c61.9 0 112 50.1 112 112v64H112V128c0-61.9 50.1-112 112-112zM96 128v64H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H352V128C352 57.3 294.7 0 224 0S96 57.3 96 128zM64 208H96h16H336h16 32c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V256c0-26.5 21.5-48 48-48zM240 320v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V320c0-8.8 7.2-16 16-16s16 7.2 16 16zm-48 0v64c0 17.7 14.3 32 32 32s32-14.3 32-32V320c0-17.7-14.3-32-32-32s-32 14.3-32 32z'
      
    ]
  };

  
    var faLockAlt = faLockKeyhole;
  

  
  

  var faDiamondHalf = {
    prefix: 'fat',
    iconName: 'diamond-half',
    icon: [
      512,
      512,
      [],
      'e5b7',
      
      'M227.7 11.7C235.5 3.9 245.8 0 256 0V16 496v16c-10.2 0-20.5-3.9-28.3-11.7l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zM240 489.9V22.1c-.3 .3-.7 .6-1 .9L23 239c-9.4 9.4-9.4 24.6 0 33.9L239 489c.3 .3 .6 .6 1 .9z'
      
    ]
  };

  

  
  

  var faKitchenSet = {
    prefix: 'fat',
    iconName: 'kitchen-set',
    icon: [
      576,
      512,
      [],
      'e51a',
      
      'M144 272a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM287.8 152c-4.2 75.8-66.9 136-143.8 136C64.5 288 0 223.5 0 144S64.5 0 144 0c76.8 0 139.6 60.2 143.8 136H353c3.6-13.8 16.1-24 31-24H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-14.9 0-27.4-10.2-31-24H287.8zm96.2 8H512c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-8.8 0-16 7.2-16 16s7.2 16 16 16zM264 320h8 16 48V296c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v24h48 16 8c4.4 0 8 3.6 8 8s-3.6 8-8 8h-8V464c0 26.5-21.5 48-48 48H320c-26.5 0-48-21.5-48-48V336h-8c-4.4 0-8-3.6-8-8s3.6-8 8-8zm88 0h96V296c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v24zm160 16H288V464c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V336zM224 144A80 80 0 1 0 64 144a80 80 0 1 0 160 0zM48 144a96 96 0 1 1 192 0A96 96 0 1 1 48 144zM0 504c0-4.4 3.6-8 8-8H216c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8zM160 336v64h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H160zm16 80H160v16c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V336c0-8.8 7.2-16 16-16h96 16 16c26.5 0 48 21.5 48 48s-21.5 48-48 48zM48 336v96c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V416 400 336H48z'
      
    ]
  };

  

  
  

  var faAppleWhole = {
    prefix: 'fat',
    iconName: 'apple-whole',
    icon: [
      448,
      512,
      [127822,127823,"apple-alt"],
      'f5d1',
      
      'M240 96H224V80c0-35.3 28.7-64 64-64h16V32c0 35.3-28.7 64-64 64zm0 16c44.2 0 80-35.8 80-80V16c0-8.8-7.2-16-16-16H288c-44.2 0-80 35.8-80 80V96c0 8.8 7.2 16 16 16h16zM16 288c0-36 8.5-72.9 25.1-100.3C57.4 160.7 80.8 144 112 144c24.1 0 54.2 9.4 76.9 18.2c22.5 8.8 47.8 8.8 70.3 0c22.7-8.8 52.7-18.2 76.9-18.2c31.2 0 54.6 16.7 70.9 43.7C423.5 215.1 432 252 432 288c0 60.7-19 113.3-46.8 150.4c-28 37.3-63.7 57.6-97.2 57.6c-9.5 0-22.2-2.8-34.1-6.4c-19.4-5.8-40.3-5.8-59.7 0c-11.9 3.6-24.7 6.4-34.1 6.4c-33.5 0-69.2-20.3-97.2-57.6C35 401.3 16 348.7 16 288zm96-160C35.7 128 0 211.7 0 288C0 416 80 512 160 512c11.9 0 26.5-3.4 38.8-7.1c16.4-4.9 34.1-4.9 50.5 0c12.2 3.7 26.8 7.1 38.8 7.1c80 0 160-96 160-224c0-76.3-35.7-160-112-160c-27.3 0-59.7 10.3-82.7 19.3c-18.8 7.3-39.9 7.3-58.7 0C171.7 138.3 139.3 128 112 128z'
      
    ]
  };

  
    var faAppleAlt = faAppleWhole;
  

  
  

  var faCircleEuro = {
    prefix: 'fat',
    iconName: 'circle-euro',
    icon: [
      512,
      512,
      [],
      'e5ce',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm128 24h33.5c-1.6-7.5-2.4-15.3-2.4-23.2c0-8.5 .9-16.8 2.7-24.8H128c-4.4 0-8-3.6-8-8s3.6-8 8-8h38.7c16.3-42.1 57.3-72 105.2-72H313c4.4 0 8 3.6 8 8s-3.6 8-8 8H271.9c-38.9 0-72.4 22.9-87.8 56H304c4.4 0 8 3.6 8 8s-3.6 8-8 8H178.3c-2.1 7.9-3.2 16.2-3.2 24.8c0 8 1 15.8 2.8 23.2H304c4.4 0 8 3.6 8 8s-3.6 8-8 8H183.4c15.1 33.9 49 57.5 88.5 57.5H313c4.4 0 8 3.6 8 8s-3.6 8-8 8H271.9c-48.5 0-89.8-30.6-105.7-73.5H128c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faToiletPaperSlash = {
    prefix: 'fat',
    iconName: 'toilet-paper-slash',
    icon: [
      640,
      512,
      [],
      'e072',
      
      'M577.9 324.1C596.8 289.5 608 242.8 608 192s-11.2-97.5-30.1-132.1C559.4 25.9 531.1 0 496 0H480 160c-11.7 0-22.8 4.2-33.2 11.8L140 22.2c6.8-4.2 13.6-6.2 20-6.2H450.4c-14.5 10.8-26.7 26.2-36.3 43.9C395.2 94.5 384 141.2 384 192c0 7.7-.1 15.3-.2 22.6l15.7 12.4c.3-11.3 .5-23 .5-35.1c0-97.2 43-176 96-176s96 78.8 96 176c0 63.8-18.5 119.6-46.2 150.5l12.6 9.9c7.4-8.4 13.9-18 19.6-28.3zM367.1 384.9c-8.2 40.9-17.8 68.6-24.6 84.9c-7.1 17.1-23.8 26.2-40.6 26.2H48c-5.8 0-11.1-3.1-13.9-8.1c-2.9-5-2.8-11.1 .2-16.1c.1-.2 .2-.3 .3-.5c22.9-41.5 34.2-90.5 39.8-138.9C79.9 283.8 80 234.5 80 192c0-11.2 .5-22.1 1.4-32.6L66.6 147.7C64.9 161.9 64 176.7 64 192c0 82.7-.4 187.2-39.7 264.5c-1.2 2.4-2.5 4.7-3.7 7.1l0 .1c-1.4 2.3-2.5 4.8-3.2 7.3c-2.4 8.2-1.5 17.1 2.9 24.8C25.8 505.8 36.5 512 48 512H301.9c22.3 0 45.4-12.1 55.4-36.1c6.7-16.2 15.8-42.3 23.8-79.9l-14-11.1zM516.6 255c4.8-4.8 8.4-10.8 11.1-17.1c5.4-12.6 8.3-28.8 8.3-45.9s-2.9-33.3-8.3-45.9c-2.7-6.3-6.3-12.3-11.1-17.1c-4.9-4.8-11.9-9-20.6-9s-15.7 4.2-20.6 9c-4.8 4.8-8.4 10.8-11.1 17.1c-5.4 12.6-8.3 28.8-8.3 45.9s2.9 33.3 8.3 45.9c2.7 6.3 6.3 12.3 11.1 17.1c4.9 4.8 11.9 9 20.6 9s15.7-4.2 20.6-9zM496 248c-13.3 0-24-25.1-24-56s10.7-56 24-56s24 25.1 24 56s-10.7 56-24 56zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  

  
  

  var faRabbit = {
    prefix: 'fat',
    iconName: 'rabbit',
    icon: [
      512,
      512,
      [128007],
      'f708',
      
      'M324.4 112c17.4 0 34.5 4.2 49.9 12c12.6-27.2 17.3-57.9 12.9-88.4l-.7-4.9c-1.2-8.4-8.4-14.6-16.8-14.6c-4.5 0-8.8 1.8-12 4.9L354.6 24c-10.5 10.4-19.1 22.1-25.9 34.7c-2.5-6-5.2-11.8-8.3-17.6c6.5-10.2 14.1-19.8 22.9-28.5l3.1-3.1C352.7 3.4 361 0 369.7 0c16.4 0 30.4 12.1 32.7 28.3l.7 4.9c4.9 34.2-.6 68.6-15 99c2 1.4 3.9 2.9 5.8 4.4l36.9 30.1c15.9 13 25.1 32.4 25.1 52.9c0 37.7-30.6 68.3-68.3 68.3H365.9l92.9 164.3c10.9 19.2 4.1 43.6-15.1 54.5s-43.6 4.1-54.5-15.1L327.7 382.9 283.6 432H304c22.1 0 40 17.9 40 40s-17.9 40-40 40H176h0l-.1 0h0H168c-29.9 0-55.5-18.2-66.4-44.2C91 475.5 78 480 64 480c-35.3 0-64-28.7-64-64s28.7-64 64-64c15.3 0 29.4 5.4 40.4 14.4c21-69.9 79.2-123.7 151.6-138.4V183.2c-40.3-38.7-59.6-94.5-51.7-149.9l.7-4.9C207.3 12.1 221.3 0 237.7 0c8.7 0 17.1 3.4 23.3 9.6l3.1 3.1c27.6 27.4 44 63.1 47.4 100.6c4.2-.8 8.6-1.2 13-1.2zM100 384.2C91.2 374.3 78.3 368 64 368c-26.5 0-48 21.5-48 48s21.5 48 48 48c12.7 0 24.3-4.9 32.8-13c-.6-3.6-.8-7.3-.8-11V424c0-13.6 1.4-26.9 4-39.8zM220.9 30.6l-.7 4.9C212.9 86.6 231 138 268.7 173.2l.8 .7c1.6 1.5 2.6 3.7 2.5 5.9l0 .6v54.2c0 3.9-2.8 7.2-6.7 7.9C178.3 257.1 112 332.8 112 424v16c0 30.9 25.1 56 56 56h7.9 0l.1 0h0H304c13.3 0 24-10.7 24-24s-10.7-24-24-24H265.6c-3.2 0-6-1.9-7.3-4.7s-.8-6.3 1.4-8.6L323.3 364c1.7-1.9 4.3-2.9 6.8-2.6s4.8 1.8 6.1 4l66.9 118.4c6.5 11.5 21.2 15.6 32.7 9.1s15.6-21.2 9.1-32.7L345.3 283.9c-1.4-2.5-1.4-5.5 .1-8s4.1-4 6.9-4h35.5c28.9 0 52.3-23.4 52.3-52.3c0-15.7-7.1-30.6-19.2-40.5l-36.9-30.1C367 135.5 346.1 128 324.4 128c-6.2 0-12.2 1.1-17.7 3.1c-2.4 .9-5.1 .5-7.2-.9s-3.4-3.8-3.5-6.4c-1.1-37-16.2-72.9-43.2-99.8l5.6-5.6L252.8 24l-3.1-3.1c-3.2-3.2-7.5-4.9-12-4.9c-8.5 0-15.6 6.2-16.8 14.6zM352 176a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faValueAbsolute = {
    prefix: 'fat',
    iconName: 'value-absolute',
    icon: [
      512,
      512,
      [],
      'f6a6',
      
      'M8 32c-4.4 0-8 3.6-8 8V472c0 4.4 3.6 8 8 8s8-3.6 8-8V40c0-4.4-3.6-8-8-8zM149.7 138.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L244.7 256 138.3 362.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L256 267.3 362.3 373.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L267.3 256 373.7 149.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L256 244.7 149.7 138.3zM512 40c0-4.4-3.6-8-8-8s-8 3.6-8 8V472c0 4.4 3.6 8 8 8s8-3.6 8-8V40z'
      
    ]
  };

  

  
  

  var faAngel = {
    prefix: 'fat',
    iconName: 'angel',
    icon: [
      576,
      512,
      [],
      'f779',
      
      'M181.1 90.3c3.4-2.8 3.9-7.9 1.1-11.3c-4.1-5-6.2-10-6.2-15c0-22.7 46-48 112-48s112 25.3 112 48c0 5-2.1 10.1-6.2 15c-2.8 3.4-2.3 8.4 1.1 11.3c1.5 1.2 3.3 1.8 5.1 1.8c2.3 0 4.6-1 6.2-2.9c6.5-7.9 9.8-16.4 9.8-25.2c0-35.9-56.2-64-128-64S160 28.1 160 64c0 8.9 3.3 17.4 9.8 25.2c2.8 3.4 7.9 3.8 11.2 1.1zM571.7 453.1l-38.2-78.6c-6.6-13.5-6.6-29.6 0-43.1c4.7-9.8 8.7-16.6 11.9-22.1C555 292.8 560 282.8 560 256c0-51.1-46.9-96-100.4-96c-24.9 0-49 10.2-66.3 28.1l-72.7 73.4c-12.7-4.2-24.3-5.5-32.6-5.5s-19.9 1.3-32.4 5.4L183 188.2c-17.5-18-41.7-28.2-66.4-28.2C63 160.1 16 204.9 16 256c0 26.8 5 36.8 14.5 53.2c3.2 5.5 7.1 12.3 11.9 22c6.6 13.5 6.6 29.6 0 43.1L4.3 453.1c-6.4 12.9-5.5 27.7 2 39.9c7.5 11.9 20.3 19 34.3 19h495c13.9 0 26.7-7.1 34.2-19c7.5-12.1 8.4-27.1 2-39.9zM40.5 496c-8.4 0-16.2-4.3-20.6-11.4c-4.6-7.5-5.1-16.6-1.2-24.5l38.1-78.7c8.8-17.9 8.8-39.3 0-57.2c-5-10.3-9.1-17.4-12.4-23C35.6 286 32 278.9 32 256c0-42.6 39.5-80 84.5-80c20.5 0 40.6 8.5 55.1 23.5l68.1 68.7c-18.8 9.9-34.5 25.3-44.3 45L104 496H40.5zm81.4 0l87.8-175.6C229.7 280.3 270 272 288 272c17.9 0 58.3 8.3 78.3 48.4L454.1 496H121.9zm434.3-11.5c-4.6 7.2-12.3 11.5-20.6 11.5H472L380.6 313.2c-9.8-19.6-25.5-35-44.2-45l68.3-69c14.4-14.8 34.4-23.3 54.9-23.3c44.9 0 84.4 37.4 84.4 80c0 22.9-3.6 30-12.3 45.1c-3.4 5.8-7.5 13-12.5 23.2c-8.8 17.9-8.8 39.3 0 57.2l38.2 78.8c3.8 7.7 3.4 16.8-1.2 24.2zM208 144a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zm16 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  

  
  

  var faFolders = {
    prefix: 'fat',
    iconName: 'folders',
    icon: [
      576,
      512,
      [],
      'f660',
      
      'M512 368H160c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H277.5c12.7 0 24.9 5.1 33.9 14.1l26.5 26.5c15 15 35.4 23.4 56.6 23.4H512c26.5 0 48 21.5 48 48V320c0 26.5-21.5 48-48 48zM160 384H512c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H394.5c-17 0-33.3-6.7-45.3-18.7L322.7 50.7c-12-12-28.3-18.7-45.3-18.7H160c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64zM0 192V416c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64H464c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V192c0-26.5 21.5-48 48-48V128c-35.3 0-64 28.7-64 64z'
      
    ]
  };

  

  
  

  var faGaugeCirclePlus = {
    prefix: 'fat',
    iconName: 'gauge-circle-plus',
    icon: [
      640,
      512,
      [],
      'e498',
      
      'M256 496c35.6 0 69.4-7.7 99.8-21.6c3.3 4.4 6.9 8.6 10.6 12.7C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-2.9 0-5.7 .1-8.6 .2C459.5 90.6 366.5 16 256 16C123.5 16 16 123.5 16 256s107.5 240 240 240zm0-96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 16c-35.3 0-64-28.7-64-64c0-32.6 24.4-59.6 56-63.5V80c0-4.4 3.6-8 8-8s8 3.6 8 8V288.5c31.6 3.9 56 30.9 56 63.5c0 35.3-28.7 64-64 64zM144 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM80 240a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM352 128a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM624 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm152-72v64h64c4.4 0 8 3.6 8 8s-3.6 8-8 8H504v64c0 4.4-3.6 8-8 8s-8-3.6-8-8V376H424c-4.4 0-8-3.6-8-8s3.6-8 8-8h64V296c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faCirclePause = {
    prefix: 'fat',
    iconName: 'circle-pause',
    icon: [
      512,
      512,
      [62092,"pause-circle"],
      'f28b',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208-88V344c0 4.4-3.6 8-8 8s-8-3.6-8-8V168c0-4.4 3.6-8 8-8s8 3.6 8 8zm112 0V344c0 4.4-3.6 8-8 8s-8-3.6-8-8V168c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  
    var faPauseCircle = faCirclePause;
  

  
  

  var faBottleWater = {
    prefix: 'fat',
    iconName: 'bottle-water',
    icon: [
      320,
      512,
      [],
      'e4c5',
      
      'M128 0C110.3 0 96 14.3 96 32l0 60c-4 1.2-8 2.8-11.8 4.6l-13.2 6.2C47.2 113.9 32 137.8 32 164.2c0 18.1 7.1 34.5 18.6 46.7C39.1 222.4 32 238.4 32 256c0 19.1 8.4 36.3 21.7 48C40.4 315.7 32 332.9 32 352s8.4 36.3 21.7 48C40.4 411.7 32 428.9 32 448c0 35.3 28.7 64 64 64l128 0c35.3 0 64-28.7 64-64c0-19.1-8.4-36.3-21.7-48c13.3-11.7 21.7-28.9 21.7-48s-8.4-36.3-21.7-48c13.3-11.7 21.7-28.9 21.7-48c0-17.6-7.1-33.6-18.6-45.1c11.5-12.2 18.6-28.6 18.6-46.7c0-26.3-15.2-50.3-39.1-61.4l-13.2-6.2C232 94.8 228 93.3 224 92l0-60c0-17.7-14.3-32-32-32L128 0zm69.3 104c11 0 21.8 2.4 31.7 7.1l13.2 6.2c18.2 8.5 29.8 26.8 29.8 46.9c0 16.4-7.6 31.1-19.6 40.6c-1.9 1.5-3.1 3.9-3 6.4s1.2 4.8 3.2 6.3c11.8 8.8 19.4 22.8 19.4 38.6c0 17.5-9.3 32.7-23.3 41.1c-2.4 1.4-3.9 4-3.9 6.9s1.5 5.4 3.9 6.9c14 8.4 23.3 23.7 23.3 41.1s-9.3 32.7-23.3 41.1c-2.4 1.4-3.9 4-3.9 6.9s1.5 5.4 3.9 6.9c14 8.4 23.3 23.7 23.3 41.1c0 26.5-21.5 48-48 48L96 496c-26.5 0-48-21.5-48-48c0-17.4 9.3-32.7 23.3-41.1c2.4-1.4 3.9-4 3.9-6.9s-1.5-5.4-3.9-6.9C57.3 384.7 48 369.4 48 352s9.3-32.7 23.3-41.1c2.4-1.4 3.9-4 3.9-6.9s-1.5-5.4-3.9-6.9C57.3 288.7 48 273.5 48 256c0-15.8 7.6-29.8 19.4-38.6c2-1.5 3.2-3.8 3.2-6.3s-1.1-4.8-3-6.4c-12-9.5-19.6-24.2-19.6-40.6c0-20.1 11.6-38.4 29.8-46.9L91 111.1c9.9-4.6 20.7-7.1 31.7-7.1l74.6 0zm0-16l-74.6 0L112 88l0-56c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 56-10.7 0zM96 216c0 4.4 3.6 8 8 8l112 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-112 0c-4.4 0-8 3.6-8 8zm8 152c-4.4 0-8 3.6-8 8s3.6 8 8 8l112 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-112 0z'
      
    ]
  };

  

  
  

  var faFaceSurprise = {
    prefix: 'fat',
    iconName: 'face-surprise',
    icon: [
      512,
      512,
      [128558,"surprise"],
      'f5c2',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm144 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM200 352a56 56 0 1 0 112 0 56 56 0 1 0 -112 0zm56 72a72 72 0 1 1 0-144 72 72 0 1 1 0 144z'
      
    ]
  };

  
    var faSurprise = faFaceSurprise;
  

  
  

  var faArrowRightToArc = {
    prefix: 'fat',
    iconName: 'arrow-right-to-arc',
    icon: [
      512,
      512,
      [],
      'e4b2',
      
      'M496 256C496 123.5 388.5 16 256 16c-4.4 0-8-3.6-8-8s3.6-8 8-8C397.4 0 512 114.6 512 256s-114.6 256-256 256c-4.4 0-8-3.6-8-8s3.6-8 8-8c132.5 0 240-107.5 240-240zM197.2 121.9l152 128c1.8 1.5 2.8 3.8 2.8 6.1s-1 4.6-2.8 6.1l-152 128c-3.4 2.8-8.4 2.4-11.3-1s-2.4-8.4 1-11.3L322.1 264H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H322.1L186.8 134.1c-3.4-2.8-3.8-7.9-1-11.3s7.9-3.8 11.3-1z'
      
    ]
  };

  

  
  

  var faUserShakespeare = {
    prefix: 'fat',
    iconName: 'user-shakespeare',
    icon: [
      448,
      512,
      [],
      'e2c2',
      
      'M312 168V104c0-48.6-39.4-88-88-88s-88 39.4-88 88v64c0 45.9 35.1 83.6 80 87.6V224c0-4.4 3.6-8 8-8s8 3.6 8 8v31.6c44.9-4 80-41.7 80-87.6zM120 106.8c-5 5.6-8 13.1-8 21.2v9.5c0 12.6-3.7 25-10.7 35.5L84.5 198c-3 4.4-4.5 9.6-4.5 15c0 14.9 12.1 27 27 27h14.5c3.5 5.8 7.7 11.2 12.4 16H107c-23.7 0-43-19.2-43-43c0-8.5 2.5-16.8 7.2-23.8l16.7-25.1c5.3-7.9 8.1-17.1 8.1-26.6V128c0-18.4 10.4-34.4 25.6-42.5C130.4 36.9 172.9 0 224 0s93.6 36.9 102.4 85.5c15.2 8 25.6 24 25.6 42.5v9.5c0 9.5 2.8 18.7 8.1 26.6l16.7 25.1c4.7 7.1 7.2 15.4 7.2 23.8c0 23.7-19.2 43-43 43H314.1c4.7-4.8 8.9-10.2 12.4-16H341c14.9 0 27-12.1 27-27c0-5.3-1.6-10.5-4.5-15L346.7 173c-7-10.5-10.7-22.9-10.7-35.5V128c0-8.1-3-15.5-8-21.2V168c0 57.4-46.6 104-104 104s-104-46.6-104-104V106.8zM352 376v32c0 3-1.7 5.8-4.4 7.1s-5.9 1.1-8.3-.7l0 0 0 0-.3-.2c-.3-.2-.7-.5-1.3-.9c-1.2-.8-3.1-2-5.6-3.4c-5-2.8-12.5-6.7-22.4-10.5C290 391.8 261 384 224 384s-66 7.8-85.7 15.5c-9.8 3.8-17.4 7.7-22.4 10.5c-2.5 1.4-4.4 2.6-5.6 3.4c-.6 .4-1.1 .7-1.3 .9l-.3 .2 0 0L104 408c4.7 6.5 4.7 6.5 4.7 6.5c-2.4 1.8-5.7 2-8.3 .7S96 411 96 408V376c0-9.6 1.9-18.7 5.3-27.1C51 371.8 16 422.4 16 481.3c0 8.1 6.6 14.7 14.7 14.7H417.3c8.1 0 14.7-6.6 14.7-14.7c0-58.8-35-109.5-85.3-132.3c3.4 8.4 5.3 17.5 5.3 27.1zM0 481.3C0 408 48.8 346.2 115.7 326.5C128.8 312.7 147.4 304 168 304H280c20.6 0 39.2 8.7 52.3 22.5C399.2 346.2 448 408 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3zM168 320c-30.9 0-56 25.1-56 56v17.9c5.3-2.8 12.1-6.1 20.5-9.4c19.8-7.7 48-15.4 83.5-16.4l0-.1V320H168zm64 0v48l0 .1c35.5 1 63.7 8.7 83.5 16.4c8.4 3.3 15.2 6.6 20.5 9.4V376c0-30.9-25.1-56-56-56H232zm-20 96a12 12 0 1 1 24 0 12 12 0 1 1 -24 0zm12 36a12 12 0 1 1 0 24 12 12 0 1 1 0-24zm5.7-281.7c2.9 2.9 8.3 7.4 14.9 11.2c6.6 3.9 13.5 6.4 19.5 6.4c4.4 0 8 3.6 8 8s-3.6 8-8 8c-10 0-19.8-4.1-27.5-8.6c-4.7-2.7-9-5.8-12.4-8.6C208.2 200.1 191.9 204 184 204c-4.4 0-8-3.6-8-8s3.6-8 8-8c4.5 0 19.8-3.1 34.3-17.7c3.1-3.1 8.2-3.1 11.3 0zM180 128a12 12 0 1 1 24 0 12 12 0 1 1 -24 0zm76-12a12 12 0 1 1 0 24 12 12 0 1 1 0-24z'
      
    ]
  };

  

  
  

  var faMartiniGlassCitrus = {
    prefix: 'fat',
    iconName: 'martini-glass-citrus',
    icon: [
      576,
      512,
      ["cocktail"],
      'f561',
      
      'M432 272c-27.6 0-53.2-8.8-74.1-23.6l-11.5 11.5C370.3 277.5 399.9 288 432 288c79.5 0 144-64.5 144-144S511.5 0 432 0C367.8 0 313.4 42 294.8 100h16.9c17.9-49 65-84 120.2-84c70.7 0 128 57.3 128 128s-57.3 128-128 128zM8 128c-3.2 0-6.2 1.9-7.4 4.9s-.6 6.4 1.7 8.7L200 339.3V496H104c-4.4 0-8 3.6-8 8s3.6 8 8 8H208 312c4.4 0 8-3.6 8-8s-3.6-8-8-8H216V339.3L413.7 141.7c2.3-2.3 3-5.7 1.7-8.7s-4.2-4.9-7.4-4.9H8zm380.7 16L208 324.7 27.3 144H388.7z'
      
    ]
  };

  
    var faCocktail = faMartiniGlassCitrus;
  

  
  

  var faBracketsRound = {
    prefix: 'fat',
    iconName: 'brackets-round',
    icon: [
      512,
      512,
      ["parentheses"],
      'e0c5',
      
      'M356.4 47.2c-4-2-5.6-6.8-3.6-10.7s6.8-5.6 10.7-3.6c24.9 12.5 61.8 38.3 92.6 75.9C487 146.3 512 196.1 512 256s-25 109.7-55.8 147.3c-30.8 37.5-67.7 63.4-92.6 75.9c-4 2-8.8 .4-10.7-3.6s-.4-8.8 3.6-10.7c23.1-11.5 58.2-36.1 87.4-71.7C473 357.5 496 311.3 496 256s-23-101.5-52.2-137.1c-29.2-35.7-64.3-60.2-87.4-71.7zm-200.8 0c-23.1 11.5-58.2 36.1-87.4 71.7C39 154.5 16 200.7 16 256s23 101.5 52.2 137.1c29.2 35.7 64.3 60.2 87.4 71.7c4 2 5.6 6.8 3.6 10.7s-6.8 5.6-10.7 3.6c-24.9-12.5-61.8-38.3-92.6-75.9C25 365.7 0 315.9 0 256s25-109.7 55.8-147.3c30.8-37.5 67.7-63.4 92.6-75.9c4-2 8.8-.4 10.7 3.6s.4 8.8-3.6 10.7z'
      
    ]
  };

  
    var faParentheses = faBracketsRound;
  

  
  

  var faArrowLeftLongToLine = {
    prefix: 'fat',
    iconName: 'arrow-left-long-to-line',
    icon: [
      640,
      512,
      [],
      'e3d4',
      
      'M0 72V440c0 4.4 3.6 8 8 8s8-3.6 8-8V72c0-4.4-3.6-8-8-8s-8 3.6-8 8zM130.3 250.3c-3.1 3.1-3.1 8.2 0 11.3l152 152c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L155.3 264 632 264c4.4 0 8-3.6 8-8s-3.6-8-8-8l-476.7 0L293.7 109.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-152 152z'
      
    ]
  };

  

  
  

  var faPawSimple = {
    prefix: 'fat',
    iconName: 'paw-simple',
    icon: [
      448,
      512,
      ["paw-alt"],
      'f701',
      
      'M144 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm24.8 82.1C179.3 189.2 200.6 176 224 176s44.7 13.2 55.2 34.1l33.8 67.5c5.9 11.7 16.5 18.7 27.1 21.8c34.7 10.3 60 42.5 60 80.5c0 46.4-37.6 84-84 84c-17.8 0-34.3-5.5-47.8-14.9c-12.3-8.6-29.2-11.9-44.2-11.9s-31.8 3.3-44.2 11.9c-13.6 9.4-30 14.9-47.8 14.9c-46.4 0-84-37.6-84-84c0-38 25.3-70.2 60-80.5c10.5-3.1 21.2-10.1 27.1-21.8l33.8-67.5zm-48.1 60.4c-3.4 6.9-10 11.5-17.3 13.7C62.1 296.4 32 334.7 32 380c0 55.2 44.8 100 100 100c21.2 0 40.8-6.6 56.9-17.8c17.4-12 52.8-12 70.1 0C275.2 473.4 294.8 480 316 480c55.2 0 100-44.8 100-100c0-45.3-30.1-83.6-71.4-95.9c-7.4-2.2-13.9-6.8-17.3-13.7l-33.8-67.5c-13.2-26.3-40-42.9-69.5-42.9s-56.3 16.6-69.5 42.9l-33.8 67.5zM272 80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm48 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM16 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0A48 48 0 1 0 0 192a48 48 0 1 0 96 0z'
      
    ]
  };

  
    var faPawAlt = faPawSimple;
  

  
  

  var faHouseCrack = {
    prefix: 'fat',
    iconName: 'house-crack',
    icon: [
      576,
      512,
      [],
      'e3b1',
      
      'M293.3 2c-3-2.7-7.6-2.7-10.6 0L2.7 250c-3.3 2.9-3.6 8-.7 11.3s8 3.6 11.3 .7L64 217.1V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V217.1L562.7 262c3.3 2.9 8.4 2.6 11.3-.7s2.6-8.4-.7-11.3L293.3 2zM80 448V202.9L288 18.7 496 202.9V448c0 26.5-21.5 48-48 48H300.3l-56.9-85.3L348 350.9c2.3-1.3 3.8-3.6 4-6.2s-.8-5.1-2.8-6.8l-112-96c-3.4-2.9-8.4-2.5-11.3 .9s-2.5 8.4 .9 11.3l103.4 88.6L228 401.1c-1.9 1.1-3.3 3-3.8 5.1s-.1 4.4 1.1 6.3L281.1 496H128c-26.5 0-48-21.5-48-48z'
      
    ]
  };

  

  
  

  var faLeftToLine = {
    prefix: 'fat',
    iconName: 'left-to-line',
    icon: [
      448,
      512,
      ["arrow-alt-to-left"],
      'f34b',
      
      'M16 440L16 72c0-4.4-3.6-8-8-8s-8 3.6-8 8L0 440c0 4.4 3.6 8 8 8s8-3.6 8-8zm99.3-176c-2.1-2.1-3.3-5-3.3-8s1.2-5.9 3.3-8L247.4 116.2c2.7-2.7 6.4-4.2 10.2-4.2c8 0 14.4 6.5 14.4 14.4l0 73.6c0 4.4 3.6 8 8 8l136 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-136 0c-4.4 0-8 3.6-8 8l0 73.6c0 8-6.5 14.4-14.4 14.4c-3.8 0-7.5-1.5-10.2-4.2L115.3 264zM96 256c0 7.2 2.9 14.2 8 19.3L236.1 407.1c5.7 5.7 13.4 8.9 21.5 8.9c16.8 0 30.4-13.6 30.4-30.4l0-65.6 128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-128 0 0-65.6c0-16.8-13.6-30.4-30.4-30.4c-8.1 0-15.8 3.2-21.5 8.9L104 236.7c-5.1 5.1-8 12.1-8 19.3z'
      
    ]
  };

  
    var faArrowAltToLeft = faLeftToLine;
  

  
  

  var faHexagonMinus = {
    prefix: 'fat',
    iconName: 'hexagon-minus',
    icon: [
      512,
      512,
      ["minus-hexagon"],
      'f307',
      
      'M400.8 450.8l0 0L497.1 284c2.5-4.3 4.4-8.9 5.6-13.6c2-7.7 2.4-15.7 1.1-23.6c-1.1-6.5-3.3-12.9-6.7-18.8L400.8 61.2c-10-17.3-28.5-28-48.5-28H159.7c-20 0-38.5 10.7-48.5 28L14.9 228c-3.9 6.7-6.3 14.1-7.1 21.6c-1.4 11.8 1 23.9 7.1 34.4l96.3 166.8c10 17.3 28.5 28 48.5 28H352.3c20 0 38.5-10.7 48.5-28zM483.2 236c2.7 4.6 4.4 9.7 5 14.8l-2.7 20.4c-.7 1.6-1.4 3.2-2.3 4.8L386.9 442.8c-7.1 12.4-20.4 20-34.6 20H159.7c-14.3 0-27.5-7.6-34.6-20L28.8 276c-3.6-6.2-5.4-13.1-5.4-20c0-3.4 .4-6.8 1.3-10.1c.9-3.4 2.2-6.8 4.1-9.9L125.1 69.2c7.1-12.4 20.4-20 34.6-20l192.6 0c14.3 0 27.5 7.6 34.6 20L483.2 236zM160 248c-4.4 0-8 3.6-8 8s3.6 8 8 8H352c4.4 0 8-3.6 8-8s-3.6-8-8-8H160z'
      
    ]
  };

  
    var faMinusHexagon = faHexagonMinus;
  

  
  

  var faDumpsterFire = {
    prefix: 'fat',
    iconName: 'dumpster-fire',
    icon: [
      640,
      512,
      [],
      'f794',
      
      'M39.9 58.9C42.1 52.4 48.2 48 55.1 48h92.7l-24 96H27.5c-6.4 0-11.5-5.2-11.5-11.5c0-1.2 .2-2.5 .6-3.6L39.9 58.9zM164.2 48H280v96H140.2l24-96zM296 48H411.8l13 52c5-2.2 10.2-3.5 15.5-3.8L428.2 48h92.7c6.9 0 13 4.4 15.2 10.9l22.3 67c1.6 .5 3.1 1 4.6 1.6c4.5 1.8 8.9 4.4 12.8 7.8c.1-.9 .1-1.9 .1-2.9c0-3-.5-5.9-1.4-8.7L551.3 53.9C546.9 40.8 534.7 32 520.9 32H55.1c-13.8 0-26 8.8-30.4 21.9L1.4 123.8c-.9 2.8-1.4 5.7-1.4 8.7C0 147.7 12.3 160 27.5 160H362c4.5-5.4 9.2-10.7 14-16H296V48zM104 416H78.9l-23-161 0-.3-8-55.9c-.6-4.4-4.7-7.4-9.1-6.8s-7.4 4.7-6.8 9.1L38.8 248H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H41.1l23 161.1c.6 3.9 3.9 6.9 7.9 6.9H96v40c0 4.4 3.6 8 8 8s8-3.6 8-8V432H324.8c-3.7-5.2-7.2-10.5-10.4-16H104zM445.5 144c1.5 0 2.9 .5 4 1.5c16.1 14.6 31.3 30.1 45.6 46.8c6.6 7.6 18.4 7.5 24.8-.3c5.8-7 11.9-13.9 18.2-19.6c2.3-2.1 5.9-2.1 8.2 0c18.9 17.4 38.4 41.2 53.2 67.2c14.8 26.1 24.5 54 24.5 79.7c0 49.7-25.1 93.7-63.4 119.8c9.7-14 15.4-30.7 15.4-48.7c0-57.4-63.8-110.5-87.4-128.2c-5.2-3.9-12.1-3.9-17.3 0C447.8 280.1 384 333.2 384 390.6c0 18.2 5.8 35 15.7 49.2c-38.7-26-63.7-70.3-63.7-120.3c0-32.3 14.1-64.9 34.7-95.2c20.5-30.2 47-57.4 70.8-78.7c1.1-1 2.6-1.5 4.1-1.5zM480 464c-2.7 0-5.5-.1-8.2-.2c-41.2-3.8-71.8-36-71.8-73.2c0-23 13-47 31.1-68.7c17.3-20.7 37.4-37.2 48.9-45.9c11.5 8.7 31.6 25.2 48.9 45.9C547 343.5 560 367.5 560 390.6c0 37.2-30.6 69.4-71.7 73.2c-2.7 .2-5.5 .2-8.3 .2zM320 319.4c0 85.1 65.5 155.6 150.8 160.3c3 .3 6.1 .4 9.2 .4c3.2 0 6.3-.1 9.4-.4C573.7 474.9 640 404.5 640 319.4c0-29.5-11-60.1-26.6-87.6c-15.6-27.6-36.2-52.6-56.3-71.1c-8.4-7.7-21.4-7.8-29.8-.1c-7.1 6.5-13.8 14-19.7 21.3c0 0-.1 0-.1 .1s-.1 0-.1 0s-.1 0-.1 0l0 0c0 0 0 0-.1 0c-14.8-17.2-30.5-33.2-47-48.3c-4.2-3.8-9.4-5.6-14.6-5.7c-5.3 0-10.6 1.8-14.9 5.6c-24.3 21.8-51.8 50-73.3 81.6C336 246.8 320 282.6 320 319.4z'
      
    ]
  };

  

  
  

  var faCircleArrowDownLeft = {
    prefix: 'fat',
    iconName: 'circle-arrow-down-left',
    icon: [
      512,
      512,
      [],
      'e0f9',
      
      'M256 16a240 240 0 1 0 0 480 240 240 0 1 0 0-480zm0 496A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm56-160H168c-4.4 0-8-3.6-8-8V200c0-4.4 3.6-8 8-8s8 3.6 8 8V324.7L338.3 162.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L187.3 336H312c4.4 0 8 3.6 8 8s-3.6 8-8 8z'
      
    ]
  };

  

  
  

  var faHouseUser = {
    prefix: 'fat',
    iconName: 'house-user',
    icon: [
      576,
      512,
      ["home-user"],
      'e1b0',
      
      'M282.7 2c3-2.7 7.6-2.7 10.6 0l280 248c3.3 2.9 3.6 8 .7 11.3s-8 3.6-11.3 .7L512 217.1V448c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V217.1L13.3 262c-3.3 2.9-8.4 2.6-11.3-.7S-.6 252.9 2.7 250L282.7 2zM80 202.9V448c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V202.9L288 18.7 80 202.9zM288 272a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-112a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM192 400H384c0-35.3-28.7-64-64-64H256c-35.3 0-64 28.7-64 64zm-16 0c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  
    var faHomeUser = faHouseUser;
  

  
  

  var faMarsAndVenus = {
    prefix: 'fat',
    iconName: 'mars-and-venus',
    icon: [
      512,
      512,
      [9893],
      'f224',
      
      'M368 8c0 4.4 3.6 8 8 8h92.7l-97.2 97.2C342.3 82.9 301.4 64 256 64C167.6 64 96 135.6 96 224c0 85.7 67.4 155.6 152 159.8V432H200c-4.4 0-8 3.6-8 8s3.6 8 8 8h48v56c0 4.4 3.6 8 8 8s8-3.6 8-8V448h48c4.4 0 8-3.6 8-8s-3.6-8-8-8H264V383.8c84.6-4.2 152-74.1 152-159.8c0-37.2-12.7-71.5-34-98.7l98-98V120c0 4.4 3.6 8 8 8s8-3.6 8-8V8c0-4.4-3.6-8-8-8H376c-4.4 0-8 3.6-8 8zM256 80a144 144 0 1 1 0 288 144 144 0 1 1 0-288z'
      
    ]
  };

  

  
  

  var faFileChartPie = {
    prefix: 'fat',
    iconName: 'file-chart-pie',
    icon: [
      384,
      512,
      [],
      'f65a',
      
      'M16 448V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM192 216v96c0 4.4 3.6 8 8 8h96c4.4 0 8-3.6 8-8c0-57.4-46.6-104-104-104c-4.4 0-8 3.6-8 8zm16 8.4c42.2 3.8 75.8 37.4 79.6 79.6H208V224.4zm-48 8.9C110.2 240.9 72 284 72 336c0 57.4 46.6 104 104 104c52 0 95.1-38.2 102.8-88H262.6c-7.5 41-43.4 72-86.6 72c-48.6 0-88-39.4-88-88c0-43.1 31-79 72-86.5V233.2z'
      
    ]
  };

  

  
  

  var faHeart = {
    prefix: 'fat',
    iconName: 'heart',
    icon: [
      512,
      512,
      [9829,10084,61578,128153,128154,128155,128156,128420,129293,129294,129505],
      'f004',
      
      'M393.6 57.7c-42.9-5.6-85.8 12.6-111.2 47.6l-20 27.5c-1.5 2.1-3.9 3.3-6.5 3.3s-5-1.2-6.5-3.3l-20-27.5c-25.4-34.9-68.3-53.2-111.2-47.6C60.1 65.3 16 114.9 16 173.5c0 30.3 11.8 59.4 32.9 81.2L248 460.4c2.2 2.3 5.2 3.6 8.4 3.6s6.2-1.3 8.4-3.6L463.2 254.7c21-21.8 32.8-50.9 32.8-81.1C496 115 451.9 65.3 393.6 57.7zM269.5 95.8c28.9-39.7 77.6-60.4 126.2-54c66.1 8.6 116.3 65 116.3 131.8c0 34.4-13.4 67.5-37.2 92.2L276.2 471.5c-5.2 5.4-12.4 8.5-19.9 8.5c-7.5 0-14.7-3-19.9-8.4L37.4 265.8C13.4 241.1 0 208 0 173.5C0 106.8 50.2 50.4 116.3 41.8c48.6-6.3 97.4 14.3 126.2 54L256 114.4l13.5-18.6z'
      
    ]
  };

  

  
  

  var faFaceNauseated = {
    prefix: 'fat',
    iconName: 'face-nauseated',
    icon: [
      512,
      512,
      [],
      'e381',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM181.7 109.7l-7.4 7.4c-22.4 22.4-51.2 37.2-82.5 42.5l-2.5 .4c-4.4 .7-8.5-2.2-9.2-6.6s2.2-8.5 6.6-9.2l2.5-.4c28-4.7 53.8-17.9 73.8-38l7.4-7.4c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3zm148.7 0c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l7.4 7.4c20 20 45.8 33.3 73.8 38l2.5 .4c4.4 .7 7.3 4.8 6.6 9.2s-4.8 7.3-9.2 6.6l-2.5-.4c-31.3-5.2-60.1-20.1-82.5-42.5l-7.4-7.4zM351.6 208a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-22.6 92.6c2.2-3.8 7.1-5.1 10.9-2.9c19.3 11.2 33 31.1 35.6 54.4H312.4c2.6-23.3 16.2-43.2 35.6-54.4c3.8-2.2 8.7-.9 10.9 2.9s.9 8.7-2.9 10.9c-16.8 9.7-28 27.8-28 48.5s11.2 38.8 28 48.5c3.8 2.2 5.1 7.1 2.9 10.9s-7.1 5.1-10.9 2.9c-19.3-11.2-33-31.1-35.6-54.4H199.6c-2.6 23.3-16.2 43.2-35.6 54.4c-3.8 2.2-8.7 .9-10.9-2.9s-.9-8.7 2.9-10.9c16.8-9.7 28-27.8 28-48.5s-11.2-38.8-28-48.5c-3.8-2.2-5.1-7.1-2.9-10.9z'
      
    ]
  };

  

  
  

  var faBookCircleArrowUp = {
    prefix: 'fat',
    iconName: 'book-circle-arrow-up',
    icon: [
      640,
      512,
      [],
      'e0bd',
      
      'M56 0C25.1 0 0 25.1 0 56V456c0 30.9 25.1 56 56 56H394.8c-6.9-4.9-13.4-10.2-19.6-16H56c-22.1 0-40-17.9-40-40s17.9-40 40-40H326.6c-1.5-5.2-2.7-10.6-3.7-16H56c-15.7 0-29.8 6.4-40 16.8V56c0-22.1 17.9-40 40-40H408c13.3 0 24 10.7 24 24V204c5.2-2 10.6-3.8 16-5.4V40c0-22.1-17.9-40-40-40H56zM368 368a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-213.7-2.3c3.1 3.1 8.2 3.1 11.3 0L488 315.3V440c0 4.4 3.6 8 8 8s8-3.6 8-8V315.3l50.3 50.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-64-64c-3.1-3.1-8.2-3.1-11.3 0l-64 64c-3.1 3.1-3.1 8.2 0 11.3z'
      
    ]
  };

  

  
  

  var faShirtRunning = {
    prefix: 'fat',
    iconName: 'shirt-running',
    icon: [
      384,
      512,
      [],
      'e3c8',
      
      'M63.9 24.2C64 19.6 67.7 16 72 16H88c4.4 0 8 3.6 8 8V80c0 53 43 96 96 96s96-43 96-96V24c0-4.4 3.6-8 8-8h16c4.3 0 8 3.6 8.1 8.2c.6 64.2 5.1 111.1 11.2 145.4l0 0L16 406V290.6c0-8.9 2.6-18.6 6.4-28.8c2.7-7.1 5.8-13.9 8.9-20.7c1.4-3.1 2.8-6.2 4.2-9.3c13.2-30.1 27.3-89.7 28.4-207.7zM16 426l4.8-3.6L334.7 187c3.6 16.4 7.6 29.3 11.6 39.3L18.4 476.1c-1.5-3.7-2.4-7.8-2.4-12.1V426zM352.8 241.4c3 6.7 6.1 13.4 8.7 20.4c3.9 10.2 6.4 19.9 6.4 28.8V464c0 17.7-14.3 32-32 32H48c-7.6 0-14.6-2.6-20-7.1L352.8 241.4zM72 0C58.7 0 48.1 10.9 47.9 24C46.7 141.2 32.8 198.2 20.8 225.5c-1.2 2.7-2.5 5.5-3.8 8.5c-3.2 7-6.6 14.6-9.5 22.2C3.4 267 0 278.8 0 290.6V464c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V290.6c0-11.8-3.4-23.6-7.5-34.5c-2.9-7.6-6.3-15.2-9.5-22.2l0 0c-1.3-3-2.6-5.8-3.8-8.5c-11.9-27.2-25.9-84.2-27.1-201.4C335.9 10.9 325.4 0 312 0H296c-13.3 0-24 10.7-24 24V80c0 44.2-35.8 80-80 80s-80-35.8-80-80V24c0-13.3-10.7-24-24-24H72z'
      
    ]
  };

  

  
  

  var faSignPostsWrench = {
    prefix: 'fat',
    iconName: 'sign-posts-wrench',
    icon: [
      640,
      512,
      [],
      'e626',
      
      'M80 32L80 8c0-4.4 3.6-8 8-8s8 3.6 8 8l0 24H480l0-24c0-4.4 3.6-8 8-8s8 3.6 8 8l0 24h32c26.5 0 48 21.5 48 48v83.2c-5.2-2.7-10.5-5.1-16-7.2V80c0-17.7-14.3-32-32-32H48C30.3 48 16 62.3 16 80V368c0 17.7 14.3 32 32 32H339.2c2.8 5.5 5.9 10.8 9.3 16H96l0 88c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-88H48c-26.5 0-48-21.5-48-48V80C0 53.5 21.5 32 48 32H80zM456 192.7V288c0 22.1 17.9 40 40 40s40-17.9 40-40V192.7c0-2.6 1.3-5.1 3.4-6.6s4.9-1.8 7.4-.9C601.3 205.8 640 258.3 640 320c0 46.4-21.9 87.7-56 114v70c0 4.4-3.6 8-8 8s-8-3.6-8-8V430c0-2.6 1.2-5 3.3-6.5c32-23.3 52.7-61 52.7-103.5c0-50.6-29.4-94.4-72-115.1V288c0 30.9-25.1 56-56 56s-56-25.1-56-56V204.9c-42.6 20.8-72 64.5-72 115.1c0 42.5 20.7 80.2 52.7 103.5c2.1 1.5 3.3 3.9 3.3 6.5v74c0 4.4-3.6 8-8 8s-8-3.6-8-8V434c-34.1-26.3-56-67.6-56-114c0-61.7 38.7-114.2 93.2-134.8c2.5-.9 5.2-.6 7.4 .9s3.4 4 3.4 6.6z'
      
    ]
  };

  

  
  

  var faGridRound4 = {
    prefix: 'fat',
    iconName: 'grid-round-4',
    icon: [
      448,
      512,
      [],
      'e5dd',
      
      'M44.8 48a28.8 28.8 0 1 1 0 57.6 28.8 28.8 0 1 1 0-57.6zM0 76.8a44.8 44.8 0 1 0 89.6 0A44.8 44.8 0 1 0 0 76.8zm44.8 90.7a28.8 28.8 0 1 1 0 57.6 28.8 28.8 0 1 1 0-57.6zM0 196.3a44.8 44.8 0 1 0 89.6 0A44.8 44.8 0 1 0 0 196.3zM73.6 315.7a28.8 28.8 0 1 1 -57.6 0 28.8 28.8 0 1 1 57.6 0zM44.8 270.9a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 135.5a28.8 28.8 0 1 1 0 57.6 28.8 28.8 0 1 1 0-57.6zM0 435.2a44.8 44.8 0 1 0 89.6 0A44.8 44.8 0 1 0 0 435.2zM193.1 76.8a28.8 28.8 0 1 1 -57.6 0 28.8 28.8 0 1 1 57.6 0zM164.3 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 135.5a28.8 28.8 0 1 1 0 57.6 28.8 28.8 0 1 1 0-57.6zm-44.8 28.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zm73.6 119.5a28.8 28.8 0 1 1 -57.6 0 28.8 28.8 0 1 1 57.6 0zm-28.8-44.8a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 135.5a28.8 28.8 0 1 1 0 57.6 28.8 28.8 0 1 1 0-57.6zm-44.8 28.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zM312.5 76.8a28.8 28.8 0 1 1 -57.6 0 28.8 28.8 0 1 1 57.6 0zM283.7 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 135.5a28.8 28.8 0 1 1 0 57.6 28.8 28.8 0 1 1 0-57.6zm-44.8 28.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zm73.6 119.5a28.8 28.8 0 1 1 -57.6 0 28.8 28.8 0 1 1 57.6 0zm-28.8-44.8a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 135.5a28.8 28.8 0 1 1 0 57.6 28.8 28.8 0 1 1 0-57.6zm-44.8 28.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zM432 76.8a28.8 28.8 0 1 1 -57.6 0 28.8 28.8 0 1 1 57.6 0zM403.2 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 135.5a28.8 28.8 0 1 1 0 57.6 28.8 28.8 0 1 1 0-57.6zm-44.8 28.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zM432 315.7a28.8 28.8 0 1 1 -57.6 0 28.8 28.8 0 1 1 57.6 0zm-28.8-44.8a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 135.5a28.8 28.8 0 1 1 0 57.6 28.8 28.8 0 1 1 0-57.6zm-44.8 28.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0z'
      
    ]
  };

  

  
  

  var faFaceThermometer = {
    prefix: 'fat',
    iconName: 'face-thermometer',
    icon: [
      576,
      512,
      [],
      'e39a',
      
      'M288 16C155.5 16 48 123.5 48 256s107.5 240 240 240c116.6 0 213.9-83.2 235.5-193.5c.9-4.3 5.1-7.2 9.4-6.3s7.2 5.1 6.3 9.4C516.1 423.2 412.4 512 288 512C146.6 512 32 397.4 32 256S146.6 0 288 0c93 0 174.5 49.7 219.3 123.9c2.3 3.8 1.1 8.7-2.7 11s-8.7 1.1-11-2.7C451.6 62.5 375.2 16 288 16zM404.6 398.6c-3.6 2.5-8.6 1.7-11.1-2C372.6 366.8 337.4 336 288 336s-84.6 30.8-105.4 60.6c-2.5 3.6-7.5 4.5-11.1 2s-4.5-7.5-2-11.1c22.4-32 61.9-67.4 118.6-67.4c16.7 0 31.9 3.1 45.6 8.2l148.9-143c16.4-15.8 42.5-15.5 58.6 .6c16.6 16.6 16.3 43.7-.7 59.9L400.5 379.3c2.1 2.7 4.1 5.4 6 8.1c2.5 3.6 1.7 8.6-2 11.1zm-55.3-63.2c16 8.5 29.7 19.8 40.8 31.8l15.2-14.5-11-11c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l11.2 11.2L438 321.4l-11.7-11.7c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l12 12 21.2-20.2-12.4-12.4c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l12.7 12.7 21.2-20.2-13.2-13.2c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l13.4 13.5 14.3-13.6c10.5-10 10.7-26.8 .4-37c-10-10-26.1-10.1-36.2-.4L349.3 335.3zM192.4 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faPlugCircleBolt = {
    prefix: 'fat',
    iconName: 'plug-circle-bolt',
    icon: [
      576,
      512,
      [],
      'e55b',
      
      'M112 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V112h16V8zM288 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V112h16V8zM8 144c-4.4 0-8 3.6-8 8s3.6 8 8 8H40v80c0 81.3 63.8 147.6 144 151.8V504c0 4.4 3.6 8 8 8s8-3.6 8-8V391.8c20-1 39-6 56.3-14c-.2-3.2-.3-6.5-.3-9.8c0-2.7 .1-5.4 .2-8.1c-19.1 10.3-41 16.1-64.2 16.1c-75.1 0-136-60.9-136-136V160H328v66c5.1-3.8 10.5-7.3 16-10.5V160h32c4.4 0 8-3.6 8-8s-3.6-8-8-8H344 328 56 40 8zm424 96a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm36.5-230.6c-3-2-6.9-1.8-9.7 .6l-112 96c-2.5 2.2-3.5 5.7-2.3 8.8s4.2 5.2 7.5 5.2h58.2l-17.8 53.5c-1.1 3.4 .1 7.2 3.1 9.2s6.9 1.8 9.7-.6l112-96c2.5-2.2 3.5-5.7 2.3-8.8s-4.2-5.2-7.5-5.2H453.8l17.8-53.5c1.1-3.4-.1-7.2-3.1-9.2zM373.6 376l73.7-63.1-12.2 36.6c-.8 2.4-.4 5.1 1.1 7.2s3.9 3.3 6.5 3.3h47.7l-73.7 63.1 12.2-36.6c.8-2.4 .4-5.1-1.1-7.2s-3.9-3.3-6.5-3.3H373.6z'
      
    ]
  };

  

  
  

  var faTrophyStar = {
    prefix: 'fat',
    iconName: 'trophy-star',
    icon: [
      576,
      512,
      ["trophy-alt"],
      'f2eb',
      
      'M400 16H176c-17.7 0-31.8 14.5-31.1 31.6c6.3 165.9 45.5 245.5 80.2 283.6c17.3 19 33.8 28.1 45.5 32.5c5.9 2.2 10.6 3.3 13.7 3.8c1.5 .2 2.7 .4 3.3 .4l.4 0 .4 0c.6-.1 1.8-.2 3.3-.4c3.1-.5 7.8-1.6 13.7-3.8c11.7-4.4 28.2-13.5 45.5-32.5c34.7-38.1 73.9-117.8 80.2-283.6C431.8 30.5 417.7 16 400 16zM176 0H400c26.5 0 48.1 21.8 47.1 48.2c-.2 5.3-.4 10.6-.7 15.8H536c21.8 0 40.7 18 38.2 40.9c-10.2 92-62.3 158.4-119 202.8c-56.5 44.3-118.4 67.5-149.8 73l0 0c-3.6 1.1-6.8 1.9-9.4 2.3V496H408c4.4 0 8 3.6 8 8s-3.6 8-8 8H288 168c-4.4 0-8-3.6-8-8s3.6-8 8-8H280V383c-2.6-.5-5.8-1.2-9.4-2.3l0 0c-31.5-5.5-93.3-28.7-149.8-73C64.1 263.3 12 196.9 1.8 104.9C-.7 82 18.2 64 40 64h89.6c-.3-5.2-.5-10.4-.7-15.8C127.9 21.8 149.5 0 176 0zM358.1 346.9c26.7-11.6 57.7-28.6 87.2-51.8c54.4-42.7 103.4-105.5 113-192C559.7 90.9 549.5 80 536 80H445.4c-10.3 153.2-50.3 229.2-87.3 266.9zM130.6 80H40c-13.5 0-23.7 10.9-22.3 23.1c9.6 86.5 58.5 149.3 113 192c29.5 23.2 60.5 40.2 87.2 51.8c-37.1-37.7-77-113.7-87.3-266.9zM302.3 99l14.5 29.3 32.4 4.7c13.1 1.9 18.4 18 8.9 27.3l-23.4 22.8 5.5 32.2c2.2 13.1-11.5 23-23.2 16.9L288 217l-29 15.2c-11.7 6.2-25.5-3.8-23.2-16.9l5.5-32.2-23.4-22.8c-9.5-9.3-4.3-25.4 8.9-27.3l32.4-4.7L273.7 99c5.9-11.9 22.8-11.9 28.7 0zm-28.8 36.4c-2.3 4.7-6.8 8-12 8.8l-32.4 4.7 23.4 22.8c3.8 3.7 5.5 9 4.6 14.2l-5.5 32.2 29-15.2c4.7-2.5 10.2-2.5 14.9 0l29 15.2-5.5-32.2c-.9-5.2 .8-10.5 4.6-14.2l23.4-22.8-32.4-4.7c-5.2-.8-9.7-4-12-8.8L288 106.1l-14.5 29.3z'
      
    ]
  };

  
    var faTrophyAlt = faTrophyStar;
  

  
  

  var faCircleThreeQuarters = {
    prefix: 'fat',
    iconName: 'circle-three-quarters',
    icon: [
      512,
      512,
      [],
      'e125',
      
      'M256 272c-8.8 0-16-7.2-16-16V32c0-9.4-7.3-15-14-14.1C107.6 32.6 16 133.6 16 256c0 132.5 107.5 240 240 240c122.4 0 223.4-91.6 238.2-210c.8-6.7-4.7-14-14.2-14H256zM224.1 2C241.6-.2 256 14.3 256 32V240v16h16H480c17.7 0 32.2 14.4 30 31.9C494.3 414.2 386.6 512 256 512C114.6 512 0 397.4 0 256C0 125.4 97.8 17.7 224.1 2z'
      
    ]
  };

  

  
  

  var faArrowsToEye = {
    prefix: 'fat',
    iconName: 'arrows-to-eye',
    icon: [
      640,
      512,
      [],
      'e4bf',
      
      'M37.7 26.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L132.7 144H56c-4.4 0-8 3.6-8 8s3.6 8 8 8h96c4.4 0 8-3.6 8-8V56c0-4.4-3.6-8-8-8s-8 3.6-8 8v76.7L37.7 26.3zm564.7 0L496 132.7V56c0-4.4-3.6-8-8-8s-8 3.6-8 8v96c0 4.4 3.6 8 8 8h96c4.4 0 8-3.6 8-8s-3.6-8-8-8H507.3L613.7 37.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0zM147.9 251.1C172.1 202.3 232.1 128 320 128s147.9 74.3 172.1 123.1c1.6 3.1 1.6 6.7 0 9.9C467.9 309.7 407.9 384 320 384s-147.9-74.3-172.1-123.1c-1.6-3.1-1.6-6.7 0-9.9zM320 112c-97.3 0-161.4 81.6-186.5 131.9c-3.8 7.6-3.8 16.5 0 24.2C158.6 318.4 222.7 400 320 400s161.4-81.6 186.5-131.9c3.8-7.6 3.8-16.5 0-24.2C481.4 193.6 417.3 112 320 112zM602.3 485.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L507.3 368H584c4.4 0 8-3.6 8-8s-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8s8-3.6 8-8V379.3L602.3 485.7zm-564.7 0L144 379.3V456c0 4.4 3.6 8 8 8s8-3.6 8-8V360c0-4.4-3.6-8-8-8H56c-4.4 0-8 3.6-8 8s3.6 8 8 8h76.7L26.3 474.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0zM256 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm144 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z'
      
    ]
  };

  

  
  

  var faScrewdriverWrench = {
    prefix: 'fat',
    iconName: 'screwdriver-wrench',
    icon: [
      512,
      512,
      ["tools"],
      'f7d9',
      
      'M7 47L47 7c8.5-8.5 22-9.4 31.6-2.1l104 80c5.9 4.5 9.4 11.6 9.4 19v64 8 4.7L287.3 276c30.3-24.7 75-22.9 103.3 5.4l112 112c12.5 12.5 12.5 32.8 0 45.3l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-112-112c-28.3-28.3-30-73-5.4-103.3L180.7 192H176h-8H104c-7.5 0-14.5-3.5-19-9.4L5 78.6C-2.4 69.1-1.5 55.6 7 47zM168 176h8v-8V104c0-2.5-1.2-4.8-3.1-6.3l-104-80c-3.2-2.4-7.7-2.2-10.5 .7l-40 40c-2.8 2.8-3.1 7.3-.7 10.5l80 104c1.5 2 3.9 3.1 6.3 3.1h64zM379.3 292.7c-23.9-23.9-62.7-23.9-86.6 0s-23.9 62.7 0 86.6l112 112c6.2 6.2 16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6l-112-112zM21.5 386.5L170.1 237.9l11.3 11.3L32.9 397.8C22.1 408.6 16 423.2 16 438.5C16 470.2 41.8 496 73.5 496c15.3 0 29.9-6.1 40.7-16.9L230.2 363.2c1.5 5.7 3.4 11.3 5.8 16.8L125.5 490.5C111.7 504.3 93 512 73.5 512C32.9 512 0 479.1 0 438.5c0-19.5 7.7-38.2 21.5-52zM496 160c0-17.2-3-33.6-8.5-48.9L416 182.6c-6 6-14.1 9.4-22.6 9.4H352c-17.7 0-32-14.3-32-32V118.6c0-8.5 3.4-16.6 9.4-22.6l71.5-71.5C385.6 19 369.2 16 352 16c-50.7 0-95.3 26.2-121 65.8l-12.7-9.8C246.9 28.6 296.1 0 352 0c20.1 0 39.4 3.7 57.1 10.5c10 3.8 11.8 16.5 4.3 24.1l-72.7 72.7c-3 3-4.7 7.1-4.7 11.3V160c0 8.8 7.2 16 16 16h41.4c4.2 0 8.3-1.7 11.3-4.7l72.7-72.7c7.6-7.6 20.3-5.7 24.1 4.3c6.8 17.7 10.5 37 10.5 57.1c0 53.8-26.5 101.3-67.2 130.3l-11.5-11.5C471.2 252.9 496 209.3 496 160zM80 416a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  
    var faTools = faScrewdriverWrench;
  

  
  

  var faHandHorns = {
    prefix: 'fat',
    iconName: 'hand-horns',
    icon: [
      384,
      512,
      [],
      'e1a9',
      
      'M64 48c0-17.7 14.3-32 32-32s32 14.3 32 32V200v56H72c-2.7 0-5.4 .1-8 .4V48zm64 224v0h16v0h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H104c-4.4 0-8 3.6-8 8s3.6 8 8 8h72c18.5 0 34.6-10.5 42.6-25.9C227.4 337 240.9 344 256 344c26.5 0 48-21.5 48-48V272 232 112c0-17.7 14.3-32 32-32s32 14.3 32 32V280v64 16c0 75.1-60.9 136-136 136H152C76.9 496 16 435.1 16 360V328c0-30.9 25.1-56 56-56h56zm16-16V200c0-17.7 14.3-32 32-32s32 14.3 32 32v31.9c0 0 0 0 0 .1v36.2c-8.5-7.6-19.7-12.2-32-12.2H144zm0-91.8V48c0-26.5-21.5-48-48-48S48 21.5 48 48V260.1C20 270 0 296.7 0 328v32c0 83.9 68.1 152 152 152h80c83.9 0 152-68.1 152-152V344 280 112c0-26.5-21.5-48-48-48s-48 21.5-48 48v84.2c-8.5-7.6-19.7-12.2-32-12.2c-12.4 0-23.6 4.7-32.1 12.3C222 171.5 201.3 152 176 152c-12.3 0-23.5 4.6-32 12.2zM224 272V232c0-17.7 14.3-32 32-32c17.7 0 32 14.3 32 32v40 24c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-24z'
      
    ]
  };

  

  
  

  var faFaceSleepy = {
    prefix: 'fat',
    iconName: 'face-sleepy',
    icon: [
      512,
      512,
      [],
      'e38e',
      
      'M256 16C123.5 16 16 123.5 16 256s107.5 240 240 240c36.9 0 71.9-8.3 103.1-23.2c4-1.9 8.8-.2 10.7 3.8s.2 8.8-3.8 10.7C332.7 503.1 295.4 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 28.9-4.8 56.7-13.6 82.6c-1.4 4.2-6 6.4-10.2 5s-6.4-6-5-10.2c8.3-24.3 12.8-50.3 12.8-77.4C496 123.5 388.5 16 256 16zm80.4 403c-6.5 5-16 6.6-24.7 3.3c-17.1-6.4-35.9-10-55.7-10c-19.8 0-38.6 3.6-55.7 9.9c-8.7 3.3-18.2 1.7-24.7-3.3c-3.3-2.6-6-6.2-7.1-10.7c-1.1-4.6-.4-9.4 2-13.8c16-30 48.3-50.4 85.4-50.4c37.1 0 69.5 20.4 85.5 50.5c2.4 4.5 3.1 9.3 2 13.8c-1.1 4.5-3.8 8.1-7.1 10.7zm-8.5-14.4c.1-.4 .2-1.2-.6-2.6c-13.2-24.9-40.1-42-71.3-42c-31.2 0-58.1 17.1-71.3 42c-.7 1.4-.7 2.2-.6 2.6c.1 .4 .4 1.1 1.3 1.8c1.9 1.5 5.5 2.4 9.3 1c18.9-7.1 39.6-11 61.3-11c21.7 0 42.5 3.9 61.3 11c3.8 1.4 7.4 .5 9.3-.9c.9-.7 1.2-1.4 1.3-1.8zM310.6 252.1c10.9 19.3 26.4 27.9 41 27.9s30.2-8.6 41-27.9c2.2-3.9 7-5.2 10.9-3.1s5.2 7 3.1 10.9c-13.1 23.4-33.6 36.1-55 36.1s-41.8-12.7-55-36.1c-2.2-3.9-.8-8.7 3.1-10.9s8.7-.8 10.9 3.1zM159.6 280c14.6 0 30.2-8.6 41-27.9c2.2-3.9 7-5.2 10.9-3.1s5.2 7 3.1 10.9c-13.1 23.4-33.6 36.1-55 36.1s-41.8-12.7-55-36.1c-2.2-3.9-.8-8.7 3.1-10.9s8.7-.8 10.9 3.1c10.9 19.3 26.4 27.9 41 27.9zM344 320c25.9 0 67.4 12.7 102.3 35.3C481.2 377.9 512 412 512 456c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-16.1 0-40.5-7.6-63.9c-7.5-23.1-22.1-44.9-51.4-56.6c-3.6-1.4-5.6-5.2-4.9-8.9s4-6.5 7.9-6.5zm63.6 67.1c8.4 26 8.4 52.6 8.4 68.6v.3c0 22.1 17.9 40 40 40s40-17.9 40-40c0-36-25.2-65.9-58.3-87.3c-18.5-11.9-38.6-20.7-56.6-26.2c13.2 13.1 21.5 28.8 26.6 44.6z'
      
    ]
  };

  

  
  

  var faTarp = {
    prefix: 'fat',
    iconName: 'tarp',
    icon: [
      576,
      512,
      [],
      'e57b',
      
      'M16 128c0-26.5 21.5-48 48-48l448 0c26.5 0 48 21.5 48 48V268.1c0 1.3-.1 2.6-.2 3.9H440c-22.1 0-40 17.9-40 40l0 119.8c-1.3 .2-2.6 .2-3.9 .2L64 432c-26.5 0-48-21.5-48-48l0-256zM418.7 422.6c-.9 .9-1.8 1.7-2.7 2.4L416 312c0-13.3 10.7-24 24-24H553.1c-.8 1-1.6 1.9-2.4 2.7L418.7 422.6zM576 128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64l332.1 0c12.7 0 24.9-5.1 33.9-14.1L561.9 302.1c9-9 14.1-21.2 14.1-33.9V128zM104 152a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM88 120a32 32 0 1 0 0 64 32 32 0 1 0 0-64z'
      
    ]
  };

  

  
  

  var faHammerBrush = {
    prefix: 'fat',
    iconName: 'hammer-brush',
    icon: [
      640,
      512,
      [],
      'e620',
      
      'M0 136C0 60.9 60.9 0 136 0h56c22.7 0 44 10.7 57.6 28.8L252 32h36c0-17.7 14.3-32 32-32s32 14.3 32 32V160c0 17.7-14.3 32-32 32s-32-14.3-32-32H251.3l-2.9 2.9c-9 9-20.1 15.3-32.1 18.6L222.5 448c.8 35.1-27.4 64-62.5 64s-63.3-28.9-62.5-64l6.2-267.1c-14.4-4.6-26.9-14.1-35.3-27L10.8 175.5c-2.5 .9-5.2 .6-7.4-.9s-3.4-4-3.4-6.6V136zm237.1 15.6l5.3-5.3c1.5-1.5 3.5-2.3 5.7-2.3h48c4.4 0 8 3.6 8 8v8c0 8.8 7.2 16 16 16s16-7.2 16-16V32c0-8.8-7.2-16-16-16s-16 7.2-16 16v8c0 4.4-3.6 8-8 8H248c-2.5 0-4.9-1.2-6.4-3.2l-4.8-6.4C226.2 24.3 209.6 16 192 16H136C69.7 16 16 69.7 16 136v20.5l53.2-19.9c3.8-1.4 8.1 .3 10 3.9c8.5 16.9 25.7 27.6 44.6 27.6h73.7c14.9 0 29.1-5.9 39.6-16.4zM119.6 184l-6.1 264.4c-.6 26.1 20.4 47.6 46.5 47.6s47.1-21.5 46.5-47.6L200.4 184h-2.9H123.8h-4.1zm421.1 27.3l-4.7-4.7V200 56c0-22.1-17.9-40-40-40s-40 17.9-40 40V200v6.6l-4.7 4.7-73.9 73.9c-.9 .9-1.7 1.8-2.4 2.7H617.1c-.8-1-1.6-1.9-2.4-2.7l-73.9-73.9zM368 307.9V352H624V307.9c0-1.3-.1-2.6-.2-3.9H368.2c-.2 1.3-.2 2.6-.2 3.9zm0 60.1v96c0 17.7 14.3 32 32 32h48V416c0-4.4 3.6-8 8-8s8 3.6 8 8v80H592c17.7 0 32-14.3 32-32V368H368zm257.9-94.1c9 9 14.1 21.2 14.1 33.9V464c0 26.5-21.5 48-48 48H400c-26.5 0-48-21.5-48-48V307.9c0-12.7 5.1-24.9 14.1-33.9L440 200V56c0-30.9 25.1-56 56-56s56 25.1 56 56V200l73.9 73.9zM496 80a16 16 0 1 1 0-32 16 16 0 1 1 0 32z'
      
    ]
  };

  

  
  

  var faClockNine = {
    prefix: 'fat',
    iconName: 'clock-nine',
    icon: [
      512,
      512,
      [],
      'e34c',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM264 104V256c0 4.4-3.6 8-8 8H136c-4.4 0-8-3.6-8-8s3.6-8 8-8H248V104c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faHandsHoldingHeart = {
    prefix: 'fat',
    iconName: 'hands-holding-heart',
    icon: [
      640,
      512,
      ["hands-heart"],
      'f4c3',
      
      'M320 46.9l-17.7-18c-29.4-29.8-77-29.8-106.4 0s-29.4 78.2 0 108L297.5 240.1c6.2 6.3 14.3 9.4 22.5 9.4s16.3-3.1 22.5-9.4L444.1 136.9c29.4-29.8 29.4-78.2 0-108s-77-29.8-106.4 0L320 46.9zm5.7 17l23.4-23.8c23.1-23.5 60.5-23.5 83.6 0c23.2 23.6 23.2 61.9 0 85.5L331.1 228.9c-3.1 3.1-7.1 4.7-11.1 4.7s-8-1.5-11.1-4.7L207.3 125.7c-23.2-23.6-23.2-61.9 0-85.5c23.1-23.5 60.5-23.5 83.6 0l23.4 23.8c3.1 3.2 8.3 3.2 11.4 0zM96 112c0-26.5-21.5-48-48-48S0 85.5 0 112V344.2c0 27.6 11 54 30.5 73.5l91.9 91.9c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L41.8 406.5C25.3 390 16 367.6 16 344.2V112c0-17.7 14.3-32 32-32s32 14.3 32 32V259c0 20.7 8.2 40.6 22.9 55.2l19.5 19.5 55.9 55.9 0 0 8 8c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-8-8 0 0-55.9-55.9 0 0c-10.6-10.6-11.3-27.6-1.5-39.1c10.9-12.7 30.3-13.5 42.2-1.6l92.8 92.7c13.3 13.3 20.8 31.4 20.8 50.3V504c0 4.4 3.6 8 8 8s8-3.6 8-8V424.8c0-23.1-9.2-45.3-25.5-61.6l-92.8-92.8c-18.4-18.4-48.7-17.3-65.6 2.5c-6.2 7.2-9.7 15.9-10.6 24.7C100.8 286.7 96 273.1 96 259V112zM592 64c-26.5 0-48 21.5-48 48V259c0 14.1-4.8 27.8-13.5 38.7c-.9-8.8-4.4-17.5-10.6-24.7c-17-19.8-47.2-21-65.6-2.5l-92.7 92.8c-16.3 16.3-25.5 38.5-25.5 61.6V504c0 4.4 3.6 8 8 8s8-3.6 8-8V424.8c0-18.9 7.5-37 20.8-50.3l92.8-92.7c11.8-11.9 31.3-11.1 42.2 1.6c9.8 11.4 9.1 28.4-1.5 39.1l0 0-55.9 55.9 0 0-8 8c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l8-8 55.9-55.9 19.5-19.5C551.8 299.5 560 279.7 560 259V112c0-17.7 14.3-32 32-32s32 14.3 32 32V344.2c0 23.3-9.3 45.7-25.8 62.2l-91.9 91.9c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l91.9-91.9c19.5-19.5 30.5-46 30.5-73.5V112c0-26.5-21.5-48-48-48z'
      
    ]
  };

  
    var faHandsHeart = faHandsHoldingHeart;
  

  
  

  var faBasketShoppingSimple = {
    prefix: 'fat',
    iconName: 'basket-shopping-simple',
    icon: [
      576,
      512,
      ["shopping-basket-alt"],
      'e0af',
      
      'M337 11.8c-2.1-3.9-.7-8.7 3.2-10.8s8.7-.7 10.8 3.2L452.8 192h74.7H544h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H540L476.1 463.5C469 492 443.4 512 414 512H162c-29.4 0-55-20-62.1-48.5L36 208H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H32 48.5h74.7L225 4.2c2.1-3.9 7-5.3 10.8-3.2s5.3 7 3.2 10.8L141.4 192H434.6L337 11.8zM523.5 208H52.5l62.9 251.6C120.7 481 139.9 496 162 496H414c22 0 41.2-15 46.6-36.4L523.5 208zM160 272a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm208 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z'
      
    ]
  };

  
    var faShoppingBasketAlt = faBasketShoppingSimple;
  

  
  

  var faH = {
    prefix: 'fat',
    iconName: 'h',
    icon: [
      384,
      512,
      [104],
      '48',
      
      'M368 240l0 232c0 4.4 3.6 8 8 8s8-3.6 8-8l0-432c0-4.4-3.6-8-8-8s-8 3.6-8 8V224L16 224V40c0-4.4-3.6-8-8-8s-8 3.6-8 8V472c0 4.4 3.6 8 8 8s8-3.6 8-8l0-232 352 0z'
      
    ]
  };

  

  
  

  var faLeftFromLine = {
    prefix: 'fat',
    iconName: 'left-from-line',
    icon: [
      448,
      512,
      ["arrow-alt-from-right"],
      'f348',
      
      'M19.3 264c-2.1-2.1-3.3-5-3.3-8s1.2-5.9 3.3-8L151.4 116.2c2.7-2.7 6.4-4.2 10.2-4.2c8 0 14.4 6.5 14.4 14.4l0 73.6c0 4.4 3.6 8 8 8l136 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-136 0c-4.4 0-8 3.6-8 8l0 73.6c0 8-6.5 14.4-14.4 14.4c-3.8 0-7.5-1.5-10.2-4.2L19.3 264zM0 256c0 7.2 2.9 14.2 8 19.3L140.1 407.1c5.7 5.7 13.4 8.9 21.5 8.9c16.8 0 30.4-13.6 30.4-30.4l0-65.6 128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-128 0 0-65.6c0-16.8-13.6-30.4-30.4-30.4c-8.1 0-15.8 3.2-21.5 8.9L8 236.7c-5.1 5.1-8 12.1-8 19.3zM448 440l0-368c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 368c0 4.4 3.6 8 8 8s8-3.6 8-8z'
      
    ]
  };

  
    var faArrowAltFromRight = faLeftFromLine;
  

  
  

  var faCupStraw = {
    prefix: 'fat',
    iconName: 'cup-straw',
    icon: [
      384,
      512,
      [129380],
      'e363',
      
      'M249 0c-18.4 0-34.4 12.5-38.8 30.3L185.8 128H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H191.8c.1 0 .2 0 .3 0H376c4.4 0 8-3.6 8-8s-3.6-8-8-8H202.2l23.5-93.8C228.4 23.5 238 16 249 16h31c4.4 0 8-3.6 8-8s-3.6-8-8-8H249zM36 176L60.3 468c2.1 24.9 22.9 44 47.8 44H275.8c25 0 45.8-19.1 47.8-44L348 176H331.9L307.7 466.7c-1.4 16.6-15.2 29.3-31.9 29.3H108.2c-16.6 0-30.5-12.8-31.9-29.3L52.1 176H36z'
      
    ]
  };

  

  
  

  var faMessageSmile = {
    prefix: 'fat',
    iconName: 'message-smile',
    icon: [
      512,
      512,
      ["comment-alt-smile"],
      'f4aa',
      
      'M176 416c0-8.8-7.2-16-16-16H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H309.3c-3.5 0-6.8 1.1-9.6 3.2L176 496V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h80 16v16 64c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM192 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm128 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM161.2 250c-3.3 2.9-3.6 8-.6 11.3C184 287.5 218.1 304 256 304s72-16.5 95.4-42.7c2.9-3.3 2.7-8.3-.6-11.3s-8.3-2.7-11.3 .6C319 273.6 289.2 288 256 288s-63-14.4-83.5-37.3c-2.9-3.3-8-3.6-11.3-.6z'
      
    ]
  };

  
    var faCommentAltSmile = faMessageSmile;
  

  
  

  var faSpaceStationMoon = {
    prefix: 'fat',
    iconName: 'space-station-moon',
    icon: [
      512,
      512,
      [],
      'e033',
      
      'M16 256C16 123.5 123.5 16 256 16s240 107.5 240 240c0 12.4-.9 24.5-2.7 36.4C419.6 320.6 339.6 336 256 336s-163.6-15.4-237.3-43.6c-1.8-11.9-2.7-24-2.7-36.4zm6.3 54.8C95.2 337.4 173.9 352 256 352s160.8-14.6 233.7-41.2C464.9 416.9 369.7 496 256 496S47.1 416.9 22.3 310.8zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM128 160a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm144 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-64 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faMelonSlice = {
    prefix: 'fat',
    iconName: 'melon-slice',
    icon: [
      512,
      512,
      [],
      'e311',
      
      'M427 2.3c-3.1-3.1-8.2-3.1-11.3 0L330.8 87.2c-1.8 1.8-2.6 4.3-2.3 6.8c1.4 9.7 2.1 19.6 2.1 29.7c0 114.3-92.6 206.9-206.9 206.9c-10.1 0-20-.7-29.7-2.1c-2.5-.4-5 .5-6.8 2.3L2.3 415.7c-3.1 3.1-3.1 8.2 0 11.3c54.4 54.4 128.3 85 205.2 85h4.2C377.6 512 512 377.6 512 211.7v-4.2c0-77-30.6-150.8-85-205.2zm-42.7 54l36.9-36.9C469.2 70.2 496 137.5 496 207.6v4.2C496 368.7 368.7 496 211.7 496h-4.2c-70.1 0-137.4-26.8-188.2-74.7l36.9-36.9C97.9 423.8 154.1 448 216 448c128.1 0 232-103.9 232-232c0-61.9-24.2-118.1-63.7-159.7zM373 67.6c36.6 38.7 59 90.9 59 148.4c0 119.3-96.7 216-216 216c-57.4 0-109.7-22.4-148.4-59l28.1-28.1c9.2 1.1 18.5 1.7 28 1.7c123.1 0 222.9-99.8 222.9-222.9c0-9.5-.6-18.8-1.7-28L373 67.6z'
      
    ]
  };

  

  
  

  var faPersonCircleQuestion = {
    prefix: 'fat',
    iconName: 'person-circle-question',
    icon: [
      576,
      512,
      [],
      'e542',
      
      'M160 96a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm0-96a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM141.1 144c-21.5 0-41.1 12.3-50.4 31.7L23.2 315.5c-1.9 4-6.7 5.6-10.7 3.7s-5.6-6.7-3.7-10.7L76.3 168.7c12-24.9 37.2-40.7 64.8-40.7h37.8c27.6 0 52.8 15.8 64.8 40.7l46.1 95.5c-3.7 5-7.1 10.2-10.2 15.6L229.3 175.7C220 156.3 200.4 144 178.9 144H141.1zM104 248V480c0 8.8 7.2 16 16 16s16-7.2 16-16V360c0-13.3 10.7-24 24-24s24 10.7 24 24V480c0 8.8 7.2 16 16 16s16-7.2 16-16V248c0-4.4 3.6-8 8-8s8 3.6 8 8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V360c0-4.4-3.6-8-8-8s-8 3.6-8 8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V248c0-4.4 3.6-8 8-8s8 3.6 8 8zM560 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-64-90.1c0-20.9 17-37.9 37.9-37.9H454c23.2 0 42 18.8 42 42v8h-.8c-2.6 13.2-11.4 24.6-24 30.3L440 382.4V392c0 4.4-3.6 8-8 8s-8-3.6-8-8V377.2c0-3.1 1.8-6 4.7-7.3l36-16.2C474 349.5 480 340.3 480 330c0-14.4-11.6-26-26-26H405.9c-12.1 0-21.9 9.8-21.9 21.9V328c0 4.4-3.6 8-8 8s-8-3.6-8-8v-2.1z'
      
    ]
  };

  

  
  

  var faCashRegister = {
    prefix: 'fat',
    iconName: 'cash-register',
    icon: [
      512,
      512,
      [],
      'f788',
      
      'M80 16C62.3 16 48 30.3 48 48V80c0 17.7 14.3 32 32 32h88 16 88c17.7 0 32-14.3 32-32V48c0-17.7-14.3-32-32-32H80zM272 128H184v32H424.5c31.8 0 58.9 23.4 63.4 54.9l23.5 164.5c.4 3 .6 6 .6 9V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V388.5c0-3 .2-6.1 .6-9L24.2 214.9C28.7 183.4 55.7 160 87.5 160H168V128H80c-26.5 0-48-21.5-48-48V48C32 21.5 53.5 0 80 0H272c26.5 0 48 21.5 48 48V80c0 26.5-21.5 48-48 48zM168 176H87.5c-23.9 0-44.1 17.6-47.5 41.2L16.5 381.8c-.1 .7-.2 1.5-.3 2.2H495.8c-.1-.7-.2-1.5-.3-2.2L472 217.2c-3.4-23.6-23.6-41.2-47.5-41.2H184 168zM16 400v48c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V400H16zM128 240a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm80 16a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm128-64a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm128-64a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM96 56H256c4.4 0 8 3.6 8 8s-3.6 8-8 8H96c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faOctagonPlus = {
    prefix: 'fat',
    iconName: 'octagon-plus',
    icon: [
      512,
      512,
      ["plus-octagon"],
      'f301',
      
      'M191.5 16.1c-14.9 0-29.1 5.9-39.6 16.4L32.5 151.9C22 162.4 16.1 176.7 16.1 191.5v129c0 14.9 5.9 29.1 16.4 39.6L151.9 479.5c10.5 10.5 24.7 16.4 39.6 16.4h129c14.9 0 29.1-5.9 39.6-16.4L479.5 360.1c10.5-10.5 16.4-24.7 16.4-39.6v-129c0-14.9-5.9-29.1-16.4-39.6L360.1 32.5C349.6 22 335.3 16.1 320.5 16.1h-129zm-50.9 5.1C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM248 352V264H160c-4.4 0-8-3.6-8-8s3.6-8 8-8h88V160c0-4.4 3.6-8 8-8s8 3.6 8 8v88h88c4.4 0 8 3.6 8 8s-3.6 8-8 8H264v88c0 4.4-3.6 8-8 8s-8-3.6-8-8z'
      
    ]
  };

  
    var faPlusOctagon = faOctagonPlus;
  

  
  

  var faSignsPost = {
    prefix: 'fat',
    iconName: 'signs-post',
    icon: [
      512,
      512,
      ["map-signs"],
      'f277',
      
      'M248 8c0-4.4 3.6-8 8-8s8 3.6 8 8V48H440.8c4.6 0 8.9 2 12 5.4l49.8 56c5.4 6.1 5.4 15.2 0 21.3l-49.8 56c-3 3.4-7.4 5.4-12 5.4H264v48H448c17.7 0 32 14.3 32 32v80c0 17.7-14.3 32-32 32H264V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V384H71.2c-4.6 0-8.9-2-12-5.4l-49.8-56c-5.4-6.1-5.4-15.2 0-21.3l49.8-56c3-3.4 7.4-5.4 12-5.4H248V192H64c-17.7 0-32-14.3-32-32V80c0-17.7 14.3-32 32-32H248V8zM440.8 64H64c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16H440.8l49.8-56L440.8 64zM71.2 256L21.4 312l49.8 56H448c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H71.2z'
      
    ]
  };

  
    var faMapSigns = faSignsPost;
  

  
  

  var faArrowRight = {
    prefix: 'fat',
    iconName: 'arrow-right',
    icon: [
      448,
      512,
      [8594],
      'f061',
      
      'M445.5 261.8c1.6-1.5 2.5-3.6 2.5-5.8s-.9-4.3-2.5-5.8l-192-184c-3.2-3.1-8.3-2.9-11.3 .2s-2.9 8.3 .2 11.3L420.1 248 8 248c-4.4 0-8 3.6-8 8s3.6 8 8 8l412.1 0L242.5 434.2c-3.2 3.1-3.3 8.1-.2 11.3s8.1 3.3 11.3 .2l192-184z'
      
    ]
  };

  

  
  

  var faSignatureLock = {
    prefix: 'fat',
    iconName: 'signature-lock',
    icon: [
      640,
      512,
      [],
      'e3ca',
      
      'M104 48c-39.8 0-72 32.2-72 72v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V120c0-48.6 39.4-88 88-88s88 39.4 88 88v15.9c0 25.1-1.8 50.2-5.4 75l171.2-50.6c3.2-.9 6.6 .2 8.6 2.8s2.2 6.3 .4 9.1L294.4 288H408c4.4 0 8 3.6 8 8s-3.6 8-8 8H280c-2.9 0-5.6-1.6-7-4.1s-1.3-5.7 .2-8.1L342 181.6 183.7 228.4c-1.2 6.7-2.6 13.4-4.1 20.1l-4.8 21.8c-10.1 45.5-26.3 89.3-48 130.5l-27 51C90.6 469.2 72.6 480 52.9 480C23.7 480 0 456.3 0 427.1V319.8c0-31.9 21-60 51.6-69l118-34.9c4.3-26.5 6.4-53.2 6.4-80V120c0-39.8-32.2-72-72-72zm62.4 185.5L56.1 266.1C32.3 273.2 16 295 16 319.8V427.1C16 447.5 32.5 464 52.9 464c13.7 0 26.2-7.6 32.6-19.7l27-51c21.1-39.9 36.8-82.4 46.6-126.5l4.8-21.8c.9-3.8 1.7-7.7 2.4-11.5zM208 376c0-4.4 3.6-8 8-8H376c4.4 0 8 3.6 8 8s-3.6 8-8 8H216c-4.4 0-8-3.6-8-8zM528 208c-26.5 0-48 21.5-48 48v64h96V256c0-26.5-21.5-48-48-48zm-64 48c0-35.3 28.7-64 64-64s64 28.7 64 64v64h16c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32h16V256zm-16 80c-8.8 0-16 7.2-16 16V480c0 8.8 7.2 16 16 16H608c8.8 0 16-7.2 16-16V352c0-8.8-7.2-16-16-16H592 576 480 464 448z'
      
    ]
  };

  

  
  

  var faTickets = {
    prefix: 'fat',
    iconName: 'tickets',
    icon: [
      640,
      512,
      [],
      'e658',
      
      'M160 48c-26.5 0-48 21.5-48 48v49.9c.3 .1 .6 .3 .9 .4C140 153.6 160 178.5 160 208s-20 54.4-47.1 61.8c-.3 .1-.6 .2-.9 .4V320c0 26.5 21.5 48 48 48H576c26.5 0 48-21.5 48-48V270.1c-.3-.1-.6-.3-.9-.4C596 262.4 576 237.5 576 208s20-54.4 47.1-61.8c.3-.1 .6-.2 .9-.4V96c0-26.5-21.5-48-48-48H160zm0-16H576c35.3 0 64 28.7 64 64v51.2c0 7.1-5.8 12.6-12.7 14.5C607 167.2 592 185.9 592 208s15 40.8 35.3 46.3c6.8 1.9 12.7 7.4 12.7 14.5V320c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V268.8c0-7.1 5.8-12.6 12.7-14.5C129 248.8 144 230.1 144 208s-15-40.8-35.3-46.3c-6.8-1.9-12.7-7.4-12.7-14.5V96c0-35.3 28.7-64 64-64zM8 88c4.4 0 8 3.6 8 8V376c0 48.6 39.4 88 88 88H552c4.4 0 8 3.6 8 8s-3.6 8-8 8H104C46.6 480 0 433.4 0 376V96c0-4.4 3.6-8 8-8zm232 40c-8.8 0-16 7.2-16 16V272c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H240zm-32 16c0-17.7 14.3-32 32-32H496c17.7 0 32 14.3 32 32V272c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V144z'
      
    ]
  };

  

  
  

  var faMaskVentilator = {
    prefix: 'fat',
    iconName: 'mask-ventilator',
    icon: [
      640,
      512,
      [],
      'e524',
      
      'M197.8 137.9C231.8 84.2 275.6 48 320 48c43.9 0 87.7 36.2 121.9 89.9C475.5 190.8 496 255.1 496 300.8c0 64.2-40.2 120-98.6 146.6c16.5-18.5 26.6-43 26.6-70.1c0-28.5-11.4-66.2-29.4-96.8c-9-15.4-20-29.3-32.3-39.5s-26.7-17-42.2-17c-15.7 0-30 6.8-42.4 17s-23.3 24.2-32.3 39.6c-17.9 30.6-29.2 68.3-29.2 96.8c0 27 10 51.7 26.7 70.3C183.6 421 144 364.8 144 300.8c0-45.8 20.2-110 53.8-162.9zM272 452c-24.2-15.8-40-43.3-40-74.6c0-25 10.2-60 27-88.7c8.4-14.3 18.1-26.6 28.7-35.3s21.4-13.4 32.3-13.4c10.7 0 21.5 4.7 32.1 13.4s20.3 21 28.7 35.3c16.9 28.7 27.2 63.7 27.2 88.7c0 31.4-16 58.7-40 74.5v22.5c56.6-13.6 103.4-50.8 127.2-100l68.7-19.1c45-12.5 76.2-53.5 76.2-100.2V168c0-22.1-17.9-40-40-40H456c-.5 0-.9 0-1.4 .1C419.8 73.9 372.1 32 320 32c-52.6 0-100.3 41.8-135 96.1c-.3 0-.7-.1-1-.1H40c-22.1 0-40 17.9-40 40v87c0 46.7 31.2 87.7 76.2 100.2l68.5 19c23.5 49.2 70.1 86.6 127.3 100.2V452zM559.6 339.8l-56.7 15.7c5.9-17.2 9.1-35.6 9.1-54.8c0-45.1-18.1-105-47.8-156.8H600c13.3 0 24 10.7 24 24v87c0 39.5-26.4 74.2-64.4 84.8zM128 300.8c0 19.1 3.2 37.5 9 54.7L80.4 339.8C42.4 329.2 16 294.6 16 255V168c0-13.3 10.7-24 24-24H175.4C145.9 195.8 128 255.7 128 300.8zM304 344c0-8.8 7.2-16 16-16s16 7.2 16 16V504c0 4.4 3.6 8 8 8s8-3.6 8-8V344c0-17.7-14.3-32-32-32s-32 14.3-32 32V504c0 4.4 3.6 8 8 8s8-3.6 8-8V344z'
      
    ]
  };

  

  
  

  var faSendBack = {
    prefix: 'fat',
    iconName: 'send-back',
    icon: [
      640,
      512,
      [],
      'f87e',
      
      'M192 16c26.5 0 48 21.5 48 48V192c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H192zM64 0C28.7 0 0 28.7 0 64V192c0 35.3 28.7 64 64 64H192c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM576 272c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H448c-26.5 0-48-21.5-48-48V320c0-26.5 21.5-48 48-48H576zM448 256c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H448zM160 288v64c0 35.3 28.7 64 64 64H352V400H224c-26.5 0-48-21.5-48-48V288H160zM416 96H288v16H416c26.5 0 48 21.5 48 48v64h16V160c0-35.3-28.7-64-64-64zM152 80c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24h48zM104 64c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V104c0-22.1-17.9-40-40-40H104zM488 336h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H488c-13.3 0-24-10.7-24-24V360c0-13.3 10.7-24 24-24zm-40 24v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V360c0-22.1-17.9-40-40-40H488c-22.1 0-40 17.9-40 40z'
      
    ]
  };

  

  
  

  var faCalendarArrowDown = {
    prefix: 'fat',
    iconName: 'calendar-arrow-down',
    icon: [
      448,
      512,
      ["calendar-download"],
      'e0d0',
      
      'M128 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H64C28.7 64 0 92.7 0 128v48 16V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 176 128c0-35.3-28.7-64-64-64H336V8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H128V8zM16 192H432V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V192zM112 80v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80H320v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80h48c26.5 0 48 21.5 48 48v48H16V128c0-26.5 21.5-48 48-48h48zM232 248c0-4.4-3.6-8-8-8s-8 3.6-8 8V404.7l-74.3-74.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l88 88c3.1 3.1 8.2 3.1 11.3 0l88-88c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L232 404.7V248z'
      
    ]
  };

  
    var faCalendarDownload = faCalendarArrowDown;
  

  
  

  var faChartLine = {
    prefix: 'fat',
    iconName: 'chart-line',
    icon: [
      512,
      512,
      ["line-chart"],
      'f201',
      
      'M16 40c0-4.4-3.6-8-8-8s-8 3.6-8 8V408c0 39.8 32.2 72 72 72H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H72c-30.9 0-56-25.1-56-56V40zM477.7 141.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L320 276.7l-90.3-90.3c-3.1-3.1-8.2-3.1-11.3 0l-128 128c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L224 203.3l90.3 90.3c3.1 3.1 8.2 3.1 11.3 0l152-152z'
      
    ]
  };

  
    var faLineChart = faChartLine;
  

  
  

  var faFrenchFries = {
    prefix: 'fat',
    iconName: 'french-fries',
    icon: [
      384,
      512,
      [127839],
      'f803',
      
      'M171 24.2c-5.3-2.1-11 1.8-11 7.4V269.8c-6-.9-11.3-2.1-16-3.4V31.6c0-17 17.1-28.6 32.9-22.3l48 19.2C234 32.2 240 41 240 50.8V266.4c-4.7 1.3-10 2.5-16 3.4V50.8c0-3.3-2-6.2-5-7.4L171 24.2zM73.8 58.3l26.5 163.4c-4.3-8.4-10.9-16.6-19.8-22.2L58 60.9c-1.7-10.4 3.6-20.6 13-25.3L112 15.1V32.9l-33.9 17c-3.1 1.6-4.9 5-4.3 8.4zM15.8 94.4L35.4 192H21.4c-.8 0-1.6 0-2.4 .1L.2 97.6c-.9-4.3 1.9-8.5 6.3-9.4s8.5 1.9 9.4 6.3zm368 3.1l-18.9 94.5c-.8 0-1.6-.1-2.4-.1H348.6l19.5-97.6c.9-4.3 5.1-7.1 9.4-6.3s7.1 5.1 6.3 9.4zM330.8 81.4L306.1 198c-9.1 5.1-16.1 12.8-20.8 20.9L315.1 78.1c1.2-5.6-3.8-10.6-9.4-9.5L272 75.4V59l30.6-6.1c16.9-3.4 31.8 11.6 28.2 28.5zM73.6 483.8c1.7 7.2 8.2 12.2 15.5 12.2H294.8c7.4 0 13.8-5.1 15.5-12.2l57.5-237c.1-.4 .2-.8 .2-1.3c0-3-2.4-5.4-5.4-5.4H329.7l0 0c0 0-.1 0-.2 .1c-.2 .1-.6 .3-1.2 .8c-1.1 1-2.1 2.7-2.5 4.4l-15.4-3.8 15.4 3.8c-3.6 14.7-12.6 33.9-34 49.2C270.6 309.8 238.9 320 192 320s-78.6-10.2-99.8-25.4c-21.4-15.3-30.4-34.6-34-49.2c-.4-1.7-1.4-3.4-2.5-4.4c-.5-.5-.9-.7-1.2-.8c-.1 0-.2-.1-.2-.1l0 0H21.4c-3 0-5.4 2.4-5.4 5.4c0 .4 .1 .9 .2 1.3l57.5 237zm-15.5 3.8L.6 250.5c-.4-1.7-.6-3.3-.6-5.1C0 233.6 9.6 224 21.4 224H54.3c9.5 0 17.2 8.3 19.5 17.5C79.6 265 102.7 304 192 304s112.4-39 118.2-62.5c2.3-9.2 10-17.5 19.5-17.5h32.9c11.8 0 21.4 9.6 21.4 21.4c0 1.7-.2 3.4-.6 5.1l-57.5 237c-3.5 14.4-16.3 24.5-31.1 24.5H89.2c-14.8 0-27.6-10.1-31.1-24.5z'
      
    ]
  };

  

  
  

  var faObjectGroup = {
    prefix: 'fat',
    iconName: 'object-group',
    icon: [
      576,
      512,
      [],
      'f247',
      
      'M112 80A32 32 0 1 0 48 80a32 32 0 1 0 64 0zM72 127.3C49.3 123.5 32 103.8 32 80c0-26.5 21.5-48 48-48c23.8 0 43.5 17.3 47.3 40H448.7c3.8-22.7 23.6-40 47.3-40c26.5 0 48 21.5 48 48c0 23.8-17.3 43.5-40 47.3V384.7c22.7 3.8 40 23.6 40 47.3c0 26.5-21.5 48-48 48c-23.8 0-43.5-17.3-47.3-40H127.3c-3.8 22.7-23.6 40-47.3 40c-26.5 0-48-21.5-48-48c0-23.8 17.3-43.5 40-47.3l0-257.3zM88 384.7c20.1 3.4 36 19.2 39.3 39.3H448.7c3.4-20.1 19.2-36 39.3-39.3V127.3c-20.1-3.4-36-19.2-39.3-39.3H127.3c-3.4 20.1-19.2 36-39.3 39.3l0 257.3zM80 400a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm384 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM528 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM136 176c0-22.1 17.9-40 40-40h96c22.1 0 40 17.9 40 40v64c0 22.1-17.9 40-40 40H176c-22.1 0-40-17.9-40-40V176zm40-24c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24h96c13.3 0 24-10.7 24-24V176c0-13.3-10.7-24-24-24H176zm184 80h40c22.1 0 40 17.9 40 40v64c0 22.1-17.9 40-40 40H304c-22.1 0-40-17.9-40-40v-8c0-4.4 3.6-8 8-8s8 3.6 8 8v8c0 13.3 10.7 24 24 24h96c13.3 0 24-10.7 24-24V272c0-13.3-10.7-24-24-24H360c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faRingsWedding = {
    prefix: 'fat',
    iconName: 'rings-wedding',
    icon: [
      512,
      512,
      [],
      'f81b',
      
      'M238.3 8.8C235.6 3.4 230.1 0 224 0H128c-6.1 0-11.6 3.4-14.3 8.8l-16 32c-2.6 5.1-2.2 11.3 1 16L129 102.3C54.6 122.9 0 191.1 0 272c0 97.2 78.8 176 176 176c7.8 0 15.5-.5 23-1.5c32.3 39.9 81.6 65.5 137 65.5c97.2 0 176-78.8 176-176c0-91.9-70.4-167.3-160.3-175.3c3.6 5.6 6.9 11.4 9.9 17.3C437.8 190.3 496 256.4 496 336c0 88.4-71.6 160-160 160c-47.2 0-89.5-20.4-118.8-52.8c0 0 0 0 0 0c-4-4.4-7.8-9.1-11.2-14c0 0 0 0 0 0C187.1 403 176 370.8 176 336c0-78.1 56-143.2 130.1-157.2C324.9 205 336 237.2 336 272c0 66.1-40.1 122.8-97.3 147.2c3.7 4.3 7.7 8.4 11.9 12.2C310.5 403.3 352 342.5 352 272c0-80.9-54.6-149.1-129-169.7l30.3-45.5c3.2-4.8 3.6-10.9 1-16l-16-32zm56.5 156C217.5 183.4 160 253 160 336c0 35.2 10.3 68 28.2 95.5c-4 .3-8.1 .5-12.2 .5C87.6 432 16 360.4 16 272s71.6-160 160-160c47.2 0 89.5 20.4 118.8 52.8zM208 96H176 144L112 48l16-32h96l16 32L208 96z'
      
    ]
  };

  

  
  

  var faBreadLoaf = {
    prefix: 'fat',
    iconName: 'bread-loaf',
    icon: [
      640,
      512,
      [127838],
      'f7eb',
      
      'M64 240c-26.5 0-48-21.5-48-48c0-54.9 37.2-90.6 86.7-113.5C152.2 55.7 209.8 48 240 48s87.8 7.7 137.3 30.5C426.8 101.4 464 137.1 464 192c0 26.5-21.5 48-48 48c-8.8 0-16 7.2-16 16V432c0 17.7-14.3 32-32 32H320 112c-17.7 0-32-14.3-32-32V256c0-8.8-7.2-16-16-16zm352 16H560V432c0 17.7-14.3 32-32 32H403.8c7.6-8.5 12.2-19.7 12.2-32V272 256zm160-16h-8H458.3c13.3-11.7 21.7-28.9 21.7-48c0-81.1-70.7-123.7-138.8-144H400c30.2 0 87.8 7.7 137.3 30.5C586.8 101.4 624 137.1 624 192c0 26.5-21.5 48-48 48c0 0 0 0 0 0zm0 16c35.3 0 64-28.7 64-64C640 64 464 32 400 32H256 240C176 32 0 64 0 192c0 35.3 28.7 64 64 64v16V432c0 26.5 21.5 48 48 48H320h48H528c26.5 0 48-21.5 48-48V272 256z'
      
    ]
  };

  

  
  

  var faFaceRollingEyes = {
    prefix: 'fat',
    iconName: 'face-rolling-eyes',
    icon: [
      512,
      512,
      [128580,"meh-rolling-eyes"],
      'f5a5',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM192 376H320c4.4 0 8 3.6 8 8s-3.6 8-8 8H192c-4.4 0-8-3.6-8-8s3.6-8 8-8zm-32-88c35.3 0 64-28.7 64-64c0-20.9-10-39.5-25.6-51.2c1 3.6 1.6 7.3 1.6 11.2c0 22.1-17.9 40-40 40s-40-17.9-40-40c0-3.9 .6-7.6 1.6-11.2C106 184.5 96 203.1 96 224c0 35.3 28.7 64 64 64zM80 224a80 80 0 1 1 160 0A80 80 0 1 1 80 224zm56-40a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm280 40c0-20.9-10.1-39.5-25.6-51.2c1 3.6 1.6 7.3 1.6 11.2c0 22.1-17.9 40-40 40s-40-17.9-40-40c0-3.9 .6-7.6 1.6-11.2C298 184.5 288 203.1 288 224c0 35.3 28.7 64 64 64s64-28.7 64-64zm-64 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160zm0-144a24 24 0 1 0 0 48 24 24 0 1 0 0-48z'
      
    ]
  };

  
    var faMehRollingEyes = faFaceRollingEyes;
  

  
  

  var faHexagonVerticalNft = {
    prefix: 'fat',
    iconName: 'hexagon-vertical-nft',
    icon: [
      448,
      512,
      [],
      'e505',
      
      'M196 505.1c17.3 10 38.7 10 56 0l166.8-96.3c17.3-10 28-28.5 28-48.5V167.7c0-20-10.7-38.5-28-48.5L252 22.9c-17.3-10-38.7-10-56 0L29.2 119.2c-17.3 10-28 28.5-28 48.5l0 192.6c0 20 10.7 38.5 28 48.5L196 505.1zm48-13.9c-12.4 7.1-27.6 7.1-40 0L37.2 394.9c-12.4-7.1-20-20.4-20-34.6l0-192.6c0-14.3 7.6-27.5 20-34.6L204 36.8c12.4-7.1 27.6-7.1 40 0l166.8 96.3c12.4 7.1 20 20.4 20 34.6V360.3c0 14.3-7.6 27.5-20 34.6L244 491.2zM79.3 164.7c-1.6-3.4-5.3-5.3-9-4.5s-6.3 4.1-6.3 7.8V344c0 4.4 3.6 8 8 8s8-3.6 8-8V204.9l64.7 142.4c1.6 3.4 5.3 5.3 9 4.5s6.3-4.1 6.3-7.8V168c0-4.4-3.6-8-8-8s-8 3.6-8 8V307.1L79.3 164.7zM200 160c-4.4 0-8 3.6-8 8v88 88c0 4.4 3.6 8 8 8s8-3.6 8-8V264h56c4.4 0 8-3.6 8-8s-3.6-8-8-8H208V176h56c4.4 0 8-3.6 8-8s-3.6-8-8-8H200zm96 0c-4.4 0-8 3.6-8 8s3.6 8 8 8h32V344c0 4.4 3.6 8 8 8s8-3.6 8-8V176h32c4.4 0 8-3.6 8-8s-3.6-8-8-8H336 296z'
      
    ]
  };

  

  
  

  var faUserCowboy = {
    prefix: 'fat',
    iconName: 'user-cowboy',
    icon: [
      448,
      512,
      [],
      'f8ea',
      
      'M196.8 21.4c.5 .3 1.1 .7 1.8 1.2l0 0 0 0c4.6 3.2 13.2 9.4 25.4 9.4s20.8-6.1 25.4-9.4c.7-.5 1.3-.9 1.8-1.2c3.9-2.6 8.9-5.4 20.9-5.4c5.2 0 11.5 2.7 18.9 11.2c7.4 8.4 14.5 21 20.9 36.3c7.9 18.8 14.2 40.3 19.1 60.5c-28.6 7.2-64.1 12-106.9 12s-78.3-4.8-106.9-12c4.9-20.2 11.2-41.7 19.1-60.5c6.4-15.3 13.5-27.9 20.9-36.3C164.5 18.7 170.8 16 176 16c11.9 0 16.9 2.8 20.9 5.4zm149.5 98.3C333 65.3 309.3 0 272 0c-18 0-25.9 5.4-32.5 9.9c-4.8 3.3-8.8 6.1-15.5 6.1s-10.8-2.8-15.5-6.1C201.9 5.4 194 0 176 0c-37.3 0-61 65.3-74.3 119.7c-7.5-2.3-14.4-4.7-20.7-7.2c-33.2-13-51.7-28.3-58.5-37.4c-2.4-3.1-6.6-4.1-10.1-2.3s-5.1 5.9-3.9 9.6c8.7 26 33.1 59.2 69.7 85.9C114.9 195.3 164.5 216 224 216s109.1-20.7 145.9-47.5c36.6-26.7 61-60 69.7-85.9c1.2-3.7-.4-7.8-3.9-9.6s-7.8-.9-10.1 2.3c-6.8 9.1-25.3 24.3-58.5 37.4c-6.4 2.5-13.3 4.9-20.8 7.2zM87.5 155.5c-18.7-13.7-33.8-29-44.8-43.6c9.1 5.3 19.9 10.6 32.3 15.5c35 13.7 84 24.6 148.9 24.6s113.9-10.8 148.9-24.6c12.5-4.9 23.2-10.2 32.3-15.5c-11 14.6-26 29.9-44.8 43.6C326.1 180.7 279.7 200 224 200s-102.1-19.3-136.5-44.5zM100.7 400H347.3c40.3 0 74.4 30 79.4 70.1l1 7.9c1.2 9.5-6.3 18-15.9 18H36.2c-9.6 0-17.1-8.4-15.9-18l1-7.9c5-40 39-70.1 79.4-70.1zm0-16c-48.4 0-89.3 36.1-95.3 84.1l-1 7.9C2.1 495.1 17 512 36.2 512H411.8c19.2 0 34.1-16.9 31.8-36l-1-7.9c-6-48-46.8-84.1-95.3-84.1H100.7zM224 352c70 0 126.9-56.2 128-126c-5.3 2.6-10.8 5.2-16.4 7.5C330.8 290.9 282.6 336 224 336s-106.8-45.1-111.6-102.5c-5.6-2.4-11.1-4.9-16.4-7.5c1.1 69.8 58 126 128 126z'
      
    ]
  };

  

  
  

  var faSeal = {
    prefix: 'fat',
    iconName: 'seal',
    icon: [
      512,
      512,
      [],
      'e241',
      
      'M187.8 75.3c-3 3-7.1 4.7-11.3 4.7H112c-17.7 0-32 14.3-32 32v64.5c0 4.2-1.7 8.3-4.7 11.3L29.7 233.4c-12.5 12.5-12.5 32.8 0 45.3l45.6 45.6c3 3 4.7 7.1 4.7 11.3V400c0 17.7 14.3 32 32 32h64.5c4.2 0 8.3 1.7 11.3 4.7l45.6 45.6c12.5 12.5 32.8 12.5 45.3 0l45.6-45.6c3-3 7.1-4.7 11.3-4.7H400c17.7 0 32-14.3 32-32V335.5c0-4.2 1.7-8.3 4.7-11.3l45.6-45.6c12.5-12.5 12.5-32.8 0-45.3l-45.6-45.6c-3-3-4.7-7.1-4.7-11.3V112c0-17.7-14.3-32-32-32H335.5c-4.2 0-8.3-1.7-11.3-4.7L278.6 29.7l11.3-11.3L335.5 64H400c26.5 0 48 21.5 48 48v64.5l45.6 45.6c18.7 18.7 18.7 49.1 0 67.9L448 335.5V400c0 26.5-21.5 48-48 48H335.5l-45.6 45.6c-18.7 18.7-49.1 18.7-67.9 0L176.5 448H112c-26.5 0-48-21.5-48-48V335.5L18.4 289.9c-18.7-18.7-18.7-49.1 0-67.9L64 176.5V112c0-26.5 21.5-48 48-48h64.5l45.6-45.6c18.7-18.7 49.1-18.7 67.9 0L278.6 29.7c-12.5-12.5-32.8-12.5-45.3 0L187.8 75.3z'
      
    ]
  };

  

  
  

  var faPlaneCircleCheck = {
    prefix: 'fat',
    iconName: 'plane-circle-check',
    icon: [
      640,
      512,
      [],
      'e555',
      
      'M256 0c-19.8 0-35.8 16.2-46.3 33.3C199 50.8 192 72.6 192 89.2l0 86.8 0 1.3L20.7 271.9C7.9 278.9 0 292.3 0 306.9V355c0 15.9 15.1 27.4 30.4 23.1L192 333.5V352l0 44-54.4 40.8c-6 4.5-9.6 11.6-9.6 19.2v34.1c0 12.1 9.8 21.9 21.9 21.9c2.2 0 4.4-.3 6.4-1L256 480.4 355.6 511c2.1 .6 4.3 1 6.4 1c2 0 4-.3 5.9-.8l0-21.1c0 3.3-2.6 5.9-5.9 5.9c-.6 0-1.2-.1-1.7-.3l-2.4 7.6 2.4-7.6-102-31.4c-1.5-.5-3.2-.5-4.7 0l-102 31.4c-.6 .2-1.1 .3-1.7 .3c-3.3 0-5.9-2.6-5.9-5.9V456c0-2.5 1.2-4.9 3.2-6.4l57.6-43.2c2-1.5 3.2-3.9 3.2-6.4l0-48V323l0-141 0-6.1 0-86.8c0-13 5.7-31.9 15.3-47.5C233.2 25.6 245.1 16 256 16c11.3 0 23.2 9.6 33 25.6c9.5 15.6 15 34.5 15 47.5l0 86.8 0 6.1 0 0V323v29l0 48c0 2.5 1.2 4.9 3.2 6.4l32.3 24.2c-3.2-8.3-5.7-16.9-7.6-25.7L320 396l0-44 0-18.5 10.8 3c1-5.3 2.1-10.5 3.6-15.6l-14.4-4V195.6l69.8 38.5c4.4-3.8 9-7.3 13.8-10.7L320 177.3l0-1.3 0-86.8c0-16.6-6.7-38.3-17.3-55.8C292.3 16.2 276.2 0 256 0zM28.4 285.9L192 195.6V316.9L26.1 362.7C21 364.1 16 360.3 16 355V306.9c0-8.7 4.8-16.8 12.4-21zM496 240a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm69.7-189.7c-3.1-3.1-8.2-3.1-11.3 0L480 396.7l-42.3-42.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l48 48c3.1 3.1 8.2 3.1 11.3 0l80-80c3.1-3.1 3.1-8.2 0-11.3z'
      
    ]
  };

  

  
  

  var faCircleRight = {
    prefix: 'fat',
    iconName: 'circle-right',
    icon: [
      512,
      512,
      [61838,"arrow-alt-circle-right"],
      'f35a',
      
      'M496 256A240 240 0 1 1 16 256a240 240 0 1 1 480 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm400 0c0-7.2-2.9-14.2-8-19.3L292.3 137c-5.7-5.7-13.5-9-21.7-9c-16.9 0-30.6 13.7-30.6 30.6l0 49.4-88 0c-22.1 0-40 17.9-40 40l0 16c0 22.1 17.9 40 40 40l88 0 0 49.4c0 16.9 13.7 30.6 30.6 30.6c8.1 0 15.9-3.2 21.7-9L392 275.3c5.1-5.1 8-12.1 8-19.3zm-19.3-8c2.1 2.1 3.3 5 3.3 8s-1.2 5.9-3.3 8L281 363.7c-2.7 2.7-6.5 4.3-10.3 4.3c-8.1 0-14.6-6.6-14.6-14.6l0-57.4c0-4.4-3.6-8-8-8l-96 0c-13.3 0-24-10.7-24-24l0-16c0-13.3 10.7-24 24-24l96 0c4.4 0 8-3.6 8-8l0-57.4c0-8.1 6.5-14.6 14.6-14.6c3.9 0 7.6 1.5 10.3 4.3L380.7 248z'
      
    ]
  };

  
    var faArrowAltCircleRight = faCircleRight;
  

  
  

  var faEject = {
    prefix: 'fat',
    iconName: 'eject',
    icon: [
      448,
      512,
      [9167],
      'f052',
      
      'M224 80c-9 0-17.5 3.8-23.6 10.4l-176 192c-8.6 9.4-10.8 22.9-5.7 34.5S35.3 336 48 336H400c12.7 0 24.2-7.5 29.3-19.1s2.9-25.2-5.7-34.5l-176-192C241.5 83.8 233 80 224 80zm0-16c13.5 0 26.3 5.6 35.4 15.6l176 192c12.9 14 16.2 34.3 8.6 51.8S419 352 400 352H48c-19 0-36.3-11.2-43.9-28.7s-4.3-37.7 8.6-51.8l176-192C197.7 69.6 210.5 64 224 64zM8 432H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faStarship = {
    prefix: 'fat',
    iconName: 'starship',
    icon: [
      640,
      512,
      [],
      'e039',
      
      'M624 256a176 176 0 1 0 -352 0 176 176 0 1 0 352 0zm16 0c0 106-86 192-192 192c-83.8 0-155.1-53.7-181.3-128.6L183.3 308l-1.7 1.7L139.3 352H200c22.1 0 40 17.9 40 40s-17.9 40-40 40H40c-22.1 0-40-17.9-40-40s17.9-40 40-40h76.7l46.7-46.7-36.8-5C104.5 297.2 88 278.3 88 256s16.5-41.2 38.6-44.3l36.8-5L116.7 160H40c-22.1 0-40-17.9-40-40S17.9 80 40 80H200c22.1 0 40 17.9 40 40s-17.9 40-40 40H139.3l42.3 42.3 1.7 1.7 83.4-11.4C292.9 117.7 364.2 64 448 64c106 0 192 86 192 192zM261.7 209.5L128.8 227.6C114.6 229.5 104 241.7 104 256s10.6 26.5 24.8 28.4l132.9 18.1C258 287.6 256 272 256 256s2-31.6 5.7-46.5zM16 120c0 13.3 10.7 24 24 24H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24s10.7 24 24 24H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H40zm408-48a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-144a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm16 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faSimCards = {
    prefix: 'fat',
    iconName: 'sim-cards',
    icon: [
      448,
      512,
      [],
      'e251',
      
      'M96 368V64c0-26.5 21.5-48 48-48H293.5c12.7 0 24.9 5.1 33.9 14.1l90.5 90.5c9 9 14.1 21.2 14.1 33.9V368c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48zM80 64V368c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L338.7 18.7C326.7 6.7 310.5 0 293.5 0H144C108.7 0 80 28.7 80 64zM48 82C20.4 89.1 0 114.2 0 144V448c0 35.3 28.7 64 64 64H304c29.8 0 54.9-20.4 62-48H349.3c-6.6 18.6-24.4 32-45.3 32H64c-26.5 0-48-21.5-48-48V144c0-20.9 13.4-38.7 32-45.3V82zM168 184c0-13.3 10.7-24 24-24h24v48H168V184zm128 24H232V160h64v48zm64-24v24H312V160h24c13.3 0 24 10.7 24 24zm-56 40h56v48H304 224 168V224h56 80zm32 112H312V288h48v24c0 13.3-10.7 24-24 24zM232 288h64v48H232V288zm-64 24V288h48v48H192c-13.3 0-24-10.7-24-24zm24-168c-22.1 0-40 17.9-40 40v32 64 32c0 22.1 17.9 40 40 40h32 80 32c22.1 0 40-17.9 40-40V280 216 184c0-22.1-17.9-40-40-40H304 224 192z'
      
    ]
  };

  

  
  

  var faCommentCode = {
    prefix: 'fat',
    iconName: 'comment-code',
    icon: [
      512,
      512,
      [],
      'e147',
      
      'M157.3 415c-5-1.8-10.6-1-14.9 2.1c-11 8-29.4 19.3-51.2 28.8C68.3 456 41.6 464 16 464l.1-.1 0 0 0 0 .3-.3 .1-.1c.4-.4 .9-.9 1.5-1.6c1.3-1.4 3.2-3.6 5.4-6.3l-12.2-10 12.2 10C28 450 34 442 40 432c10.7-17.9 21.4-42.1 23.6-69.9c.3-4.3-1.1-8.6-3.9-11.8C31.9 318.8 16 280.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-35.2 0-68.6-6.1-98.7-17zM4.7 452.7l0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0zm209-279c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-72 72c-3.1 3.1-3.1 8.2 0 11.3l72 72c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L147.3 240l66.3-66.3zm96-11.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L364.7 240l-66.3 66.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l72-72c3.1-3.1 3.1-8.2 0-11.3l-72-72z'
      
    ]
  };

  

  
  

  var faHelmetSafety = {
    prefix: 'fat',
    iconName: 'helmet-safety',
    icon: [
      576,
      512,
      ["hard-hat","hat-hard"],
      'f807',
      
      'M232 72V280c0 4.4-3.6 8-8 8s-8-3.6-8-8V72c0-22.1 17.9-40 40-40h64c22.1 0 40 17.9 40 40V280c0 4.4-3.6 8-8 8s-8-3.6-8-8V72c0-13.3-10.7-24-24-24H256c-13.3 0-24 10.7-24 24zm-40 1.3V90C108.4 117 48 195.5 48 288v32H32V288C32 186.5 99.5 100.8 192 73.3zM384 90V73.3c91.8 27.3 158.9 111.9 160 212.3l0 2.4 0 32H528l0-34.4C527 194.1 466.9 116.8 384 90zM537.3 368H38.7C26.2 368 16 378.2 16 390.7c0 6.6 2.7 11.4 6.6 13.9C50.7 422.7 131.9 464 288 464s237.3-41.3 265.4-59.4c3.8-2.5 6.6-7.3 6.6-13.9c0-12.6-10.2-22.7-22.7-22.7zM38.7 352H537.3c21.4 0 38.7 17.3 38.7 38.7c0 11-4.7 21.4-13.9 27.3C531.3 437.9 447.1 480 288 480s-243.3-42.1-274.1-61.9C4.7 412.1 0 401.7 0 390.7C0 369.3 17.3 352 38.7 352z'
      
    ]
  };

  
    var faHardHat = faHelmetSafety;
  
    var faHatHard = faHelmetSafety;
  

  
  

  var faToiletPaper = {
    prefix: 'fat',
    iconName: 'toilet-paper',
    icon: [
      640,
      512,
      [129531],
      'f71e',
      
      'M17.3 471c.7-2.5 1.8-5 3.2-7.3l0-.1c1.3-2.3 2.5-4.7 3.7-7.1C63.6 379.2 64 274.7 64 192C64 86 107 0 160 0H480h16c35.1 0 63.4 25.9 81.9 59.9C596.8 94.5 608 141.2 608 192s-11.2 97.5-30.1 132.1c-18.6 34-46.8 59.9-81.9 59.9c-29.8 0-54.6-18.6-72.8-45c1.1-8.4 2.1-17.1 3-26.1C443.7 346.8 468.5 368 496 368c53 0 96-78.8 96-176s-43-176-96-176s-96 78.8-96 176c0 32.3-1.1 61.6-3.1 88.2l-.2 2.1c-7.7 103.1-27.3 164.4-39.5 193.7c-10 24-33.2 36.1-55.4 36.1H48c-11.5 0-22.2-6.2-27.8-16.2c-4.3-7.7-5.3-16.6-2.9-24.8zM160 16c-17.2 0-37 14.3-53.6 47.4C90.4 95.5 80 140.9 80 192c0 42.5-.1 91.8-5.7 140.4c-5.6 48.5-16.8 97.4-39.8 138.9c-.1 .2-.2 .3-.3 .5c-2.9 4.9-3 11-.2 16.1c2.8 5 8.2 8.1 13.9 8.1H301.9c16.8 0 33.5-9.1 40.6-26.2C357 435 384 348.9 384 192c0-50.8 11.2-97.5 30.1-132.1c9.6-17.6 21.9-33.1 36.3-43.9H160zM496 264c-8.7 0-15.7-4.2-20.6-9c-4.8-4.8-8.4-10.8-11.1-17.1c-5.4-12.6-8.3-28.8-8.3-45.9s2.9-33.3 8.3-45.9c2.7-6.3 6.3-12.3 11.1-17.1c4.9-4.8 11.9-9 20.6-9s15.7 4.2 20.6 9c4.8 4.8 8.4 10.8 11.1 17.1c5.4 12.6 8.3 28.8 8.3 45.9s-2.9 33.3-8.3 45.9c-2.7 6.3-6.3 12.3-11.1 17.1c-4.9 4.8-11.9 9-20.6 9zm24-72c0-30.9-10.7-56-24-56s-24 25.1-24 56s10.7 56 24 56s24-25.1 24-56zM112 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faKaaba = {
    prefix: 'fat',
    iconName: 'kaaba',
    icon: [
      576,
      512,
      [128331],
      'f66b',
      
      'M292.8 16.7l256 80c.8 .3 1.6 .6 2.4 1c5.3 2.7 8.8 8.2 8.8 14.3l0 3.8L292.8 199.3c-3.1 1-6.4 1-9.5 0l-256-80L16 115.8V112c0-7 4.5-13.2 11.2-15.3l256-80c3.1-1 6.4-1 9.5 0l0 0zM0 112v15.5V400c0 14 9.1 26.4 22.5 30.5l256 80c6.2 1.9 12.9 1.9 19.1 0l256-80C566.9 426.4 576 414 576 400l0-272.5 0-15.5c0-12.2-7-23.3-17.7-28.6c-1.5-.8-3.1-1.4-4.8-1.9l-256-80c-6.2-1.9-12.9-1.9-19.1 0l-256 80C9.1 85.6 0 98 0 112zm560 90.6L295.2 285.4c-4.7 1.5-9.7 1.5-14.3 0L16 202.6V132.5l6.5 2 256 80c6.2 1.9 12.9 1.9 19.1 0l262.5-82v70.1zm0 16.8v39.2l-42.3 13.2c-4.2 1.3-6.6 5.8-5.2 10s5.8 6.6 10 5.2L560 275.4V400c0 7-4.5 13.2-11.2 15.3l-256 80c-3.1 1-6.4 1-9.5 0l-256-80C20.5 413.2 16 407 16 400V275.4l37.5 11.7c4.2 1.3 8.7-1 10-5.2s-1-8.7-5.2-10L16 258.6V219.4l260.1 81.3c7.8 2.4 16.1 2.4 23.9 0L560 219.4zM106.5 286.9c-4.2-1.3-8.7 1-10 5.2s1 8.7 5.2 10l79.8 24.9c4.2 1.3 8.7-1 10-5.3s-1-8.7-5.2-10l-79.8-24.9zm367.8 15.3c4.2-1.3 6.6-5.8 5.3-10s-5.8-6.6-10-5.2l-79.8 24.9c-4.2 1.3-6.6 5.8-5.3 10s5.8 6.6 10 5.3l79.8-24.9zm-240 24.7c-4.2-1.3-8.7 1-10 5.3s1 8.7 5.2 10l46.5 14.5c7.8 2.4 16.1 2.4 23.9 0l46.5-14.5c4.2-1.3 6.6-5.8 5.3-10s-5.8-6.6-10-5.3l-46.5 14.5c-4.7 1.5-9.7 1.5-14.3 0l-46.5-14.5z'
      
    ]
  };

  

  
  

  var faSquareList = {
    prefix: 'fat',
    iconName: 'square-list',
    icon: [
      448,
      512,
      [],
      'e489',
      
      'M384 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm96 128c0 4.4 3.6 8 8 8H360c4.4 0 8-3.6 8-8s-3.6-8-8-8H168c-4.4 0-8 3.6-8 8zm0 96c0 4.4 3.6 8 8 8H360c4.4 0 8-3.6 8-8s-3.6-8-8-8H168c-4.4 0-8 3.6-8 8zm0 96c0 4.4 3.6 8 8 8H360c4.4 0 8-3.6 8-8s-3.6-8-8-8H168c-4.4 0-8 3.6-8 8zM96 144a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm16 112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM96 336a16 16 0 1 0 0 32 16 16 0 1 0 0-32z'
      
    ]
  };

  

  
  

  var faLocationPin = {
    prefix: 'fat',
    iconName: 'location-pin',
    icon: [
      384,
      512,
      ["map-marker"],
      'f041',
      
      'M350.2 261.6c-11.3 26.9-27.1 55.8-44.7 84.3c-35.2 57-76.8 111.4-102.3 143.2c-5.9 7.3-16.6 7.3-22.4 0C155.3 457.3 113.7 403 78.5 345.9c-17.6-28.5-33.4-57.4-44.7-84.3C22.4 234.5 16 210.7 16 192C16 94.8 94.8 16 192 16s176 78.8 176 176c0 18.7-6.4 42.5-17.8 69.6zM215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0z'
      
    ]
  };

  
    var faMapMarker = faLocationPin;
  

  
  

  var faTelescope = {
    prefix: 'fat',
    iconName: 'telescope',
    icon: [
      576,
      512,
      [128301],
      'e03e',
      
      'M439.1 21.9c7.7-4.4 17.4-1.8 21.9 5.9L557 194c4.4 7.7 1.8 17.4-5.9 21.9l-89.2 51.5c-7.7 4.4-17.4 1.8-21.9-5.9L344 95.2c-4.4-7.7-1.8-17.4 5.9-21.9l89.2-51.5zM336.2 113.6l81.5 141.2-38.8 21C367.5 245.5 338.3 224 304 224c-44.2 0-80 35.8-80 80c0 17.7 5.7 34 15.4 47.2L141.9 404c-7.6 4.1-17.1 1.4-21.5-6.1L65.9 303.4c-4.3-7.4-2-16.9 5.3-21.5l265-168.3zm89.5 155l.5 .8c8.8 15.3 28.4 20.5 43.7 11.7l89.2-51.5c15.3-8.8 20.5-28.4 11.7-43.7l-96-166.3C466 4.4 446.4-.8 431.1 8L341.9 59.5c-14.1 8.2-19.7 25.5-13.5 40.1L62.6 268.4c-14.5 9.2-19.1 28.2-10.6 43l54.5 94.5c8.7 15 27.7 20.4 42.9 12.1l100.9-54.6c.9 .8 1.8 1.6 2.7 2.4L192.7 500.7c-1.8 4 0 8.8 4 10.6s8.8 0 10.6-4l59.4-132.5c11.1 5.9 23.8 9.2 37.3 9.2s26.2-3.3 37.3-9.2l59.4 132.5c1.8 4 6.5 5.8 10.6 4s5.8-6.5 4-10.6L354.8 365.8C372.6 351.1 384 328.9 384 304c0-4.2-.3-8.3-.9-12.3l42.6-23.1zM304 240a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM55.9 318.2L11.8 343.6C.4 350.3-3.6 364.9 3.1 376.4l25.9 44.9c6.6 11.5 21.3 15.4 32.8 8.8l44.1-25.5-8-13.9L53.7 416.2c-3.8 2.2-8.7 .9-10.9-2.9L16.9 368.4c-2.2-3.8-.9-8.7 2.9-10.9L63.9 332l-8-13.9z'
      
    ]
  };

  

  
  

  var faObjectExclude = {
    prefix: 'fat',
    iconName: 'object-exclude',
    icon: [
      512,
      512,
      [],
      'e49c',
      
      'M64 16H288c26.5 0 48 21.5 48 48v64h16V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V288c0 35.3 28.7 64 64 64h64V336H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48zm96 368v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64H384v16h64c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H224c-26.5 0-48-21.5-48-48V384H160zm128-32c35.3 0 64-28.7 64-64H336c0 26.5-21.5 48-48 48H256v16h32zm64-176V160H336 288v16h48v80h16V176zM224 352V336H176V256H160v80 16h16 48zM160 224h16c0-26.5 21.5-48 48-48h32V160H224c-35.3 0-64 28.7-64 64z'
      
    ]
  };

  

  
  

  var faPoop = {
    prefix: 'fat',
    iconName: 'poop',
    icon: [
      512,
      512,
      [],
      'f619',
      
      'M216.6 4.9c1.2-3 4.2-4.9 7.4-4.9h14.6C305.4 0 359.5 53.8 360 120.4c36 4 64 34.5 64 71.6c0 11.9-2.9 23.1-8 32.9c36.3 5.8 64 37.2 64 75.1c0 22-9.3 41.7-24.2 55.6C488.4 365.7 512 396.1 512 432c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80c0-35.9 23.6-66.3 56.2-76.4C41.3 341.7 32 322 32 300c0-37.9 27.7-69.3 64-75.1c-5.1-9.9-8-21.1-8-32.9c0-39.8 32.2-72 72-72h23.2 11.5c25 0 45.3-20.3 45.3-45.3V58.5c0-14.9-5.9-29.1-16.4-39.6l-5.3-5.3c-2.3-2.3-3-5.7-1.7-8.7zm25.5 11.1C251.1 28.3 256 43.2 256 58.5V74.7c0 33.9-27.5 61.3-61.3 61.3H183.2 160c-30.9 0-56 25.1-56 56c0 13.3 4.6 25.4 12.3 35c1.9 2.4 2.3 5.7 1 8.5s-4.1 4.5-7.2 4.5h-2c-33.1 0-60 26.9-60 60c0 23 12.9 42.9 31.9 53c3.2 1.7 4.8 5.3 4.1 8.8s-3.8 6.1-7.4 6.3C42.8 369.9 16 397.8 16 432c0 35.3 28.7 64 64 64H432c35.3 0 64-28.7 64-64c0-34.2-26.8-62.1-60.6-63.9c-3.6-.2-6.6-2.7-7.4-6.3s.9-7.1 4.1-8.8c19-10.1 31.9-30.1 31.9-53c0-33.1-26.9-60-60-60h-2c-3.1 0-5.9-1.8-7.2-4.5s-1-6.1 1-8.5c7.7-9.6 12.3-21.7 12.3-35c0-30.9-25.1-56-56-56h-.4c-2.3 0-4.5-1-6-2.7s-2.2-4-2-6.2c.2-1.9 .3-3.8 .3-5.7c0-57-45.3-103.5-101.8-105.3z'
      
    ]
  };

  

  
  

  var faHandPointRibbon = {
    prefix: 'fat',
    iconName: 'hand-point-ribbon',
    icon: [
      448,
      512,
      [],
      'e1a6',
      
      'M112 48V64h64V48c0-17.7-14.3-32-32-32s-32 14.3-32 32zM96 64V48c0-26.5 21.5-48 48-48s48 21.5 48 48V72v80 12.2c8.5-7.6 19.7-12.2 32-12.2c25.3 0 46 19.5 47.9 44.3c8.5-7.7 19.8-12.3 32.1-12.3c20.6 0 38.2 13 45 31.2c8.8-9.3 21.2-15.2 35-15.2c26.5 0 48 21.5 48 48v32 24 56c0 83.9-68.1 152-152 152H200c-83.9 0-152-68.1-152-152V328c0-31.3 20-58 48-67.9V160H24c-3.1 0-5.9-1.8-7.2-4.5s-1-6.1 1-8.5l28-35-28-35c-1.9-2.4-2.3-5.7-1-8.5S20.9 64 24 64H96zm16 96v96.4c2.6-.3 5.3-.4 8-.4h56V200 160H112zm64-16V80H40.6l21.6 27c2.3 2.9 2.3 7.1 0 10L40.6 144H176zm0 128H120c-30.9 0-56 25.1-56 56v32c0 75.1 60.9 136 136 136h80c75.1 0 136-60.9 136-136V339.8c-8.5 7.6-19.7 12.2-32 12.2c-18.5 0-34.6-10.5-42.6-25.9C332.6 337 319.1 344 304 344s-28.6-7-37.4-17.9c-8 15.4-24.1 25.9-42.6 25.9H152c-4.4 0-8-3.6-8-8s3.6-8 8-8h72c17.7 0 32-14.3 32-32s-14.3-32-32-32H192v0H176v0zm16-16h32c12.3 0 23.5 4.6 32 12.2V232l0-.1V200c0-17.7-14.3-32-32-32s-32 14.3-32 32v56zm80 16l0 24c0 17.7 14.3 32 32 32s32-14.3 32-32V248 232c0-17.7-14.3-32-32-32c-17.7 0-32 14.3-32 32v40zm144 8V248c0-17.7-14.3-32-32-32s-32 14.3-32 32v48 8c0 17.7 14.3 32 32 32s32-14.3 32-32V280z'
      
    ]
  };

  

  
  

  var faAlien8bit = {
    prefix: 'fat',
    iconName: 'alien-8bit',
    icon: [
      576,
      512,
      [128126,"alien-monster"],
      'f8f6',
      
      'M120 56V88c0 4.4 3.6 8 8 8h40V56c0-4.4-3.6-8-8-8H128c-4.4 0-8 3.6-8 8zm64 0V96h32c13.3 0 24 10.7 24 24v40h96V120c0-13.3 10.7-24 24-24h32V56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24V88c0 13.3-10.7 24-24 24H408v48h88V144c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24V296c0 13.3-10.7 24-24 24H512v40c0 13.3-10.7 24-24 24H448v72c0 13.3-10.7 24-24 24H344c-13.3 0-24-10.7-24-24V440c0-13.3 10.7-24 24-24h32V384H200v32h32c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24V384H88c-13.3 0-24-10.7-24-24V320H24c-13.3 0-24-10.7-24-24V144c0-13.3 10.7-24 24-24H56c13.3 0 24 10.7 24 24v16h88V112H128c-13.3 0-24-10.7-24-24V56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24zM80 176v64c0 4.4-3.6 8-8 8s-8-3.6-8-8V144c0-4.4-3.6-8-8-8H24c-4.4 0-8 3.6-8 8V296c0 4.4 3.6 8 8 8H72c4.4 0 8 3.6 8 8v48c0 4.4 3.6 8 8 8h48 56H384h56 48c4.4 0 8-3.6 8-8V312c0-4.4 3.6-8 8-8h48c4.4 0 8-3.6 8-8V144c0-4.4-3.6-8-8-8H520c-4.4 0-8 3.6-8 8v96c0 4.4-3.6 8-8 8s-8-3.6-8-8V176H400c-4.4 0-8-3.6-8-8V112H360c-4.4 0-8 3.6-8 8v48c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8V120c0-4.4-3.6-8-8-8H184v56c0 4.4-3.6 8-8 8H80zM448 96c4.4 0 8-3.6 8-8V56c0-4.4-3.6-8-8-8H416c-4.4 0-8 3.6-8 8V96h40zM144 456c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V440c0-4.4-3.6-8-8-8H192c-4.4 0-8-3.6-8-8V384H144v72zm248-32c0 4.4-3.6 8-8 8H344c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V384H392v40zM208 232v80c0 4.4-3.6 8-8 8s-8-3.6-8-8V232c0-4.4 3.6-8 8-8s8 3.6 8 8zm176 0v80c0 4.4-3.6 8-8 8s-8-3.6-8-8V232c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  
    var faAlienMonster = faAlien8bit;
  

  
  

  var faCircleArrowDownRight = {
    prefix: 'fat',
    iconName: 'circle-arrow-down-right',
    icon: [
      512,
      512,
      [],
      'e0fa',
      
      'M256 496a240 240 0 1 1 0-480 240 240 0 1 1 0 480zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM200 352H344c4.4 0 8-3.6 8-8V200c0-4.4-3.6-8-8-8s-8 3.6-8 8V324.7L173.7 162.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L324.7 336H200c-4.4 0-8 3.6-8 8s3.6 8 8 8z'
      
    ]
  };

  

  
  

  var faFaceDisguise = {
    prefix: 'fat',
    iconName: 'face-disguise',
    icon: [
      512,
      512,
      [],
      'e370',
      
      'M496 256c0 132.5-107.5 240-240 240S16 388.5 16 256c0-19.3 2.3-38 6.6-56H80.4c-.2 2.6-.4 5.3-.4 8c0 48.6 39.4 88 88 88c7 0 13.7-.8 20.2-2.3L186 298l-15.3 7.7C159.3 311.4 152 323.2 152 336s7.3 24.6 18.7 30.3l8.8 4.4L153.8 403c-2.8 3.4-2.2 8.5 1.2 11.2s8.5 2.2 11.2-1.2l28-35 19.6 9.8L200.6 421c-1.6 4.1 .4 8.8 4.5 10.4s8.8-.4 10.4-4.5l12.8-32.1c6.4 2.7 13 4.4 19.7 5.1v32c0 4.4 3.6 8 8 8s8-3.6 8-8V400c6.7-.8 13.4-2.5 19.7-5.1L296.6 427c1.6 4.1 6.3 6.1 10.4 4.5s6.1-6.3 4.5-10.4l-13.3-33.2 19.6-9.8 28 35c2.8 3.4 7.8 4 11.2 1.2s4-7.8 1.2-11.2l-25.8-32.3 8.8-4.4c11.5-5.7 18.7-17.5 18.7-30.3s-7.3-24.6-18.7-30.3L326 298l-2.2-4.4c6.5 1.5 13.3 2.3 20.2 2.3c48.6 0 88-39.4 88-88c0-2.7-.1-5.4-.4-8h57.8c4.3 18 6.6 36.7 6.6 56zM225.7 218.7l-27.3 54.7c-.3 .1-.7 .2-1 .4c-8.9 4-18.9 6.2-29.3 6.2c-39.8 0-72-32.2-72-72s32.2-72 72-72c38.4 0 69.9 30.1 71.9 68.1c-6 3.3-11 8.3-14.2 14.7zm-17.6-89.1l7-14.1c2-4 .4-8.8-3.6-10.7s-8.8-.4-10.7 3.6l-7.6 15.2c-8-2.4-16.5-3.7-25.2-3.7V96c0-4.4-3.6-8-8-8s-8 3.6-8 8v25.5c-9.2 1.7-17.8 4.8-25.8 9.1l-7.1-14.1c-2-4-6.8-5.6-10.7-3.6s-5.6 6.8-3.6 10.7l7.9 15.9c-14 11.3-24.5 26.8-29.5 44.5H27C57.6 86.6 148.5 16 256 16s198.4 70.6 229 168H428.7c-5-17.8-15.5-33.2-29.5-44.5l7.9-15.9c2-4 .4-8.8-3.6-10.7s-8.8-.4-10.7 3.6l-7.1 14.1c-7.9-4.3-16.6-7.4-25.8-9.1V96c0-4.4-3.6-8-8-8s-8 3.6-8 8v24c-8.8 0-17.2 1.3-25.2 3.7l-7.6-15.2c-2-4-6.8-5.6-10.7-3.6s-5.6 6.8-3.6 10.7l7 14.1c-26.2 13.4-44.8 39.6-47.5 70.3l-.4 0-.4 0c-2.8-30.7-21.3-56.9-47.5-70.3zM344 136c39.8 0 72 32.2 72 72s-32.2 72-72 72c-10.5 0-20.4-2.2-29.3-6.2c-.3-.2-.7-.3-1-.4l-27.3-54.7c-3.2-6.4-8.2-11.4-14.2-14.7c2-37.9 33.4-68.1 71.9-68.1zm158.8 51.8C473 79.5 373.8 0 256 0S39 79.5 9.2 187.8C8.4 189 8 190.5 8 192l0 .2C2.8 212.6 0 234 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256c0-22-2.8-43.4-8-63.8l0-.2c0-1.5-.4-3-1.2-4.2zM256 216c6.8 0 13 3.8 16 9.9l40.8 81.7L314 310l2.4 1.2 17.7 8.8c6.1 3 9.9 9.2 9.9 16s-3.8 13-9.9 16L281 378.5c-15.8 7.9-34.3 7.9-50.1 0L177.9 352c-6.1-3-9.9-9.2-9.9-16s3.8-13 9.9-16l17.7-8.8L198 310l1.2-2.4L240 225.9c3-6.1 9.2-9.9 16-9.9zm-64-8a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm144 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faObjectUngroup = {
    prefix: 'fat',
    iconName: 'object-ungroup',
    icon: [
      640,
      512,
      [],
      'f248',
      
      'M0 48C0 71.8 17.3 91.5 40 95.3V256.7C17.3 260.5 0 280.2 0 304c0 26.5 21.5 48 48 48c23.8 0 43.5-17.3 47.3-40H352.7c3.8 22.7 23.6 40 47.3 40c26.5 0 48-21.5 48-48c0-23.8-17.3-43.5-40-47.3V95.3c22.7-3.8 40-23.6 40-47.3c0-26.5-21.5-48-48-48c-23.8 0-43.5 17.3-47.3 40H95.3C91.5 17.3 71.8 0 48 0C21.5 0 0 21.5 0 48zm352.7 8C356 76.1 371.9 92 392 95.3V256.7c-20.1 3.4-36 19.2-39.3 39.3H95.3C92 275.9 76.1 260 56 256.7V95.3C76.1 92 92 76.1 95.3 56H352.7zM480 200h-8v16h8 64.7c3.4 20.1 19.2 36 39.3 39.3V416.7c-20.1 3.4-36 19.2-39.3 39.3H287.3c-3.4-20.1-19.2-36-39.3-39.3V352v-8H232v8 64.7c-22.7 3.8-40 23.6-40 47.3c0 26.5 21.5 48 48 48c23.8 0 43.5-17.3 47.3-40H544.7c3.8 22.7 23.6 40 47.3 40c26.5 0 48-21.5 48-48c0-23.8-17.3-43.5-40-47.3V255.3c22.7-3.8 40-23.6 40-47.3c0-26.5-21.5-48-48-48c-23.8 0-43.5 17.3-47.3 40H480zm112 40a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM560 464a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM240 496a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM368 304a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM48 336a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM368 48a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM48 80a32 32 0 1 1 0-64 32 32 0 1 1 0 64z'
      
    ]
  };

  

  
  

  var faFaceGrinBeam = {
    prefix: 'fat',
    iconName: 'face-grin-beam',
    icon: [
      512,
      512,
      [128516,"grin-beam"],
      'f582',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256.3 91.8c-43 0-84.1-5.5-121.5-15.4c-3.9-1-7.1 .3-8.7 1.8c-.7 .7-.9 1.2-.9 1.4l0 0c0 .1-.1 .7 .5 1.9c25 46.8 74.1 78.5 130.5 78.5s105.5-31.7 130.5-78.5c.7-1.2 .6-1.8 .5-1.9l0 0c0-.2-.2-.7-.9-1.4c-1.6-1.5-4.8-2.8-8.7-1.8c-37.4 9.9-78.4 15.4-121.5 15.4zm144.6-2.7C373.2 396.8 318.8 432 256.3 432s-116.9-35.2-144.6-86.9c-9.1-17 8.7-33.1 27.3-28.2c36 9.6 75.6 14.9 117.3 14.9s81.4-5.3 117.3-14.9c18.6-4.9 36.4 11.2 27.3 28.2zm-250-165.3c-7.4 11.4-12.7 26.3-15.2 39.8c-.8 4.3-5 7.2-9.3 6.4s-7.2-5-6.4-9.3c2.8-15 8.7-32 17.6-45.6c8.7-13.3 21.5-25 38.3-25s29.6 11.7 38.3 25c8.8 13.5 14.8 30.6 17.6 45.6c.8 4.3-2 8.5-6.4 9.3s-8.5-2-9.3-6.4c-2.5-13.5-7.8-28.4-15.2-39.8c-7.6-11.6-16.1-17.7-24.9-17.7s-17.3 6.1-24.9 17.7zm144.8 39.8c-.8 4.3-5 7.2-9.3 6.4s-7.2-5-6.4-9.3c2.8-15 8.7-32 17.6-45.6c8.7-13.3 21.5-25 38.3-25s29.6 11.7 38.3 25c8.8 13.5 14.8 30.6 17.6 45.6c.8 4.3-2 8.5-6.4 9.3s-8.5-2-9.3-6.4c-2.5-13.5-7.8-28.4-15.2-39.8c-7.6-11.6-16.1-17.7-24.9-17.7s-17.3 6.1-24.9 17.7c-7.4 11.4-12.7 26.3-15.2 39.8z'
      
    ]
  };

  
    var faGrinBeam = faFaceGrinBeam;
  

  
  

  var faBuildingFlag = {
    prefix: 'fat',
    iconName: 'building-flag',
    icon: [
      640,
      512,
      [],
      'e4d5',
      
      'M48 16C30.3 16 16 30.3 16 48V464c0 17.7 14.3 32 32 32h96V416c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c17.7 0 32-14.3 32-32V48c0-17.7-14.3-32-32-32H48zM224 496V416c0-17.7-14.3-32-32-32s-32 14.3-32 32v80h64zm-80 16H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H240 224 160 144zM104 232h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V256c0-13.3 10.7-24 24-24zm-8 24v32c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V256c0-4.4-3.6-8-8-8H104c-4.4 0-8 3.6-8 8zm128 0c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H248c-13.3 0-24-10.7-24-24V256zm24-8c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V256c0-4.4-3.6-8-8-8H248zM104 104h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V128c0-13.3 10.7-24 24-24zm-8 24v32c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V128c0-4.4-3.6-8-8-8H104c-4.4 0-8 3.6-8 8zm128 0c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H248c-13.3 0-24-10.7-24-24V128zm24-8c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V128c0-4.4-3.6-8-8-8H248zM424 0c4.4 0 8 3.6 8 8V32H616c13.3 0 24 10.7 24 24V184c0 13.3-10.7 24-24 24H432V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V208 192 48 32 8c0-4.4 3.6-8 8-8zm8 192H616c4.4 0 8-3.6 8-8V56c0-4.4-3.6-8-8-8H432V192z'
      
    ]
  };

  

  
  

  var faCircleQ = {
    prefix: 'fat',
    iconName: 'circle-q',
    icon: [
      512,
      512,
      [],
      'e11e',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM144 256c0-61.9 50.1-112 112-112s112 50.1 112 112c0 28-10.3 53.7-27.3 73.3l-61.9-61.9c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l61.9 61.9C309.7 357.7 284 368 256 368c-61.9 0-112-50.1-112-112zm240 0c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128c32.5 0 62.1-12.1 84.7-32l29.7 29.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L352 340.7c19.9-22.6 32-52.2 32-84.7z'
      
    ]
  };

  

  
  

  var faFishFins = {
    prefix: 'fat',
    iconName: 'fish-fins',
    icon: [
      576,
      512,
      [],
      'e4f2',
      
      'M243.2 132.5c-19 8.6-36.3 19.3-51.6 30.7c-14.6 10.9-27.5 22.7-38.8 34.5c-5.1 5.4-13.2 6.5-19.6 2.8L40.1 146.2c-6.3-3.6-14.2-2.6-19.3 2.5s-6.2 13-2.6 19.3l45.8 80.1c2.8 4.9 2.8 11 0 15.9L18.1 344.1c-3.6 6.3-2.5 14.2 2.6 19.3s13.1 6.1 19.3 2.5l93.1-54.3c6.4-3.7 14.5-2.6 19.6 2.8c11.2 11.8 24.2 23.6 38.8 34.5c15.9 11.9 34 23 54 31.8c7.2 3.2 11 11.1 9 18.7L240.3 454c-.9 3.3 .5 6.9 3.4 8.7s6.7 1.7 9.4-.5l73.4-58.7c2.8-2.3 6.3-3.5 10-3.5c57.7-.1 106.7-23.2 144-51.2c37.3-28 64-61.7 77.4-84.8c2.9-5 2.9-11.1 0-16.1c-13.4-23.1-40.1-56.7-77.4-84.8c-37.4-28-86.3-51.1-144-51.2c-3.6 0-7.1-1.2-10-3.5L253 49.8c-2.6-2.1-6.3-2.3-9.2-.6s-4.3 5.2-3.6 8.5l12.1 56.9c1.6 7.4-2.2 14.8-9.1 17.9zM263 474.7c-8.1 6.5-19.4 7-28.1 1.4s-12.8-16.2-10.1-26.2l14.3-54.7c-21.2-9.3-40.4-21.1-57.1-33.6c-15.3-11.5-29-23.9-40.7-36.3L48.1 379.6c-12.5 7.3-28.4 5.3-38.6-4.9S-3 348.7 4.2 336.1L50 256 4.2 175.9c-7.2-12.6-5-28.4 5.3-38.6s26.1-12.2 38.6-4.9l93.1 54.3c11.8-12.3 25.4-24.8 40.7-36.3c16.1-12.1 34.4-23.4 54.6-32.5L224.5 61c-2.1-9.9 2.2-20.1 10.9-25.4s19.7-4.6 27.6 1.7L336.4 96c62.1 .1 114.3 24.9 153.6 54.4c39.2 29.4 67.2 64.7 81.6 89.5c5.8 9.9 5.8 22.2 0 32.1c-14.4 24.8-42.5 60.1-81.6 89.5c-39.3 29.5-91.5 54.3-153.6 54.4L263 474.7zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm16 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faFileContract = {
    prefix: 'fat',
    iconName: 'file-contract',
    icon: [
      384,
      512,
      [],
      'f56c',
      
      'M64 496c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm8 64c-4.4 0-8 3.6-8 8s3.6 8 8 8h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H72zm0 64c-4.4 0-8 3.6-8 8s3.6 8 8 8h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H72zm53.6 185.8c.3-1.1 1.3-1.8 2.4-1.8s2.1 .7 2.4 1.8l20.7 75.9c1.7 6.1 7.2 10.3 13.5 10.3c5 0 9.6-2.7 12.1-7L201 350.4c2.3-3.9 6.5-6.4 11-6.4s8.8 2.4 11 6.4l16.8 29.5c7.1 12.5 20.4 20.2 34.7 20.2H320c4.4 0 8-3.6 8-8s-3.6-8-8-8H274.6c-8.6 0-16.6-4.6-20.8-12.1l-16.8-29.5c-5.1-8.9-14.6-14.5-24.9-14.5s-19.8 5.5-24.9 14.5l-21.9 38.3-19.4-71.1c-2.2-8-9.5-13.6-17.8-13.6s-15.6 5.6-17.8 13.6L94.7 366.3C91.9 376.8 82.4 384 71.6 384H64c-4.4 0-8 3.6-8 8s3.6 8 8 8h7.6c18 0 33.8-12.1 38.6-29.5l15.5-56.7z'
      
    ]
  };

  

  
  

  var faFileExcel = {
    prefix: 'fat',
    iconName: 'file-excel',
    icon: [
      384,
      512,
      [],
      'f1c3',
      
      'M16 448V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm70.7 227.6c-2.5-3.7-7.4-4.7-11.1-2.2s-4.7 7.4-2.2 11.1l61 91.6-61 91.6c-2.5 3.7-1.5 8.6 2.2 11.1s8.6 1.5 11.1-2.2l57.3-86 57.3 86c2.5 3.7 7.4 4.7 11.1 2.2s4.7-7.4 2.2-11.1l-61-91.6 61-91.6c2.5-3.7 1.5-8.6-2.2-11.1s-8.6-1.5-11.1 2.2l-57.3 86-57.3-86z'
      
    ]
  };

  

  
  

  var faFileXls = {
    prefix: 'fat',
    iconName: 'file-xls',
    icon: [
      512,
      512,
      [],
      'e64d',
      
      'M64 496h80v16H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H204.1c12.7 0 24.9 5.1 33.9 14.1L369.9 145.9c9 9 14.1 21.2 14.1 33.9V304H368V179.9c0-1.3-.1-2.6-.2-3.9H248c-22.1 0-40-17.9-40-40V16.2c-1.3-.2-2.6-.2-3.9-.2H64C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48zM361.1 160c-.8-1-1.6-1.9-2.4-2.7L226.7 25.4c-.9-.9-1.8-1.7-2.7-2.4V136c0 13.3 10.7 24 24 24H361.1zM216 376c0 8.9 2.6 17.5 7.5 24.9L240 425.6l16.5-24.7c4.9-7.4 7.5-16 7.5-24.9c0-4.4 3.6-8 8-8s8 3.6 8 8c0 12-3.6 23.8-10.2 33.8L249.6 440l20.2 30.2c6.7 10 10.2 21.7 10.2 33.8c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-8.9-2.6-17.5-7.5-24.9L240 454.4l-16.5 24.7c-4.9 7.4-7.5 16-7.5 24.9c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-12 3.6-23.8 10.2-33.8L230.4 440l-20.2-30.2C203.6 399.8 200 388 200 376c0-4.4 3.6-8 8-8s8 3.6 8 8zM328 504V376c0-4.4 3.6-8 8-8s8 3.6 8 8V496h40c4.4 0 8 3.6 8 8s-3.6 8-8 8H336c-4.4 0-8-3.6-8-8zm88-98.3c0-20.8 16.9-37.7 37.7-37.7H480c4.4 0 8 3.6 8 8s-3.6 8-8 8H453.7c-12 0-21.7 9.7-21.7 21.7c0 8.2 4.6 15.7 12 19.4l31.2 15.6c12.8 6.4 20.8 19.4 20.8 33.7c0 20.8-16.9 37.7-37.7 37.7H432c-4.4 0-8-3.6-8-8s3.6-8 8-8h26.3c12 0 21.7-9.7 21.7-21.7c0-8.2-4.6-15.7-12-19.4l-31.2-15.6C424.1 433 416 419.9 416 405.7z'
      
    ]
  };

  

  
  

  var faSackXmark = {
    prefix: 'fat',
    iconName: 'sack-xmark',
    icon: [
      512,
      512,
      [],
      'e56a',
      
      'M315.2 128H196.8l-9.2 5.9C131.8 169.6 16 259.6 16 416c0 44.2 35.8 80 80 80H416c44.2 0 80-35.8 80-80c0-156.4-115.8-246.4-171.6-282.1l-9.2-5.9zm4.6-16.7l57.1-82.8c3.7-5.3-.1-12.5-6.6-12.5H141.7c-6.4 0-10.2 7.2-6.6 12.5l57.1 82.8 .5 .7H319.3l.5-.7zM0 416C0 262.9 105.1 170.8 165.7 129.2c4.7-3.3 9.2-6.2 13.3-8.8l-9.1-13.2-48-69.6C111 21.7 122.4 0 141.7 0H370.3c19.3 0 30.7 21.7 19.8 37.6l-48 69.6L333 120.4c4.1 2.6 8.6 5.6 13.3 8.8C406.9 170.8 512 262.9 512 416c0 53-43 96-96 96H96c-53 0-96-43-96-96zM256 308.7l58.3-58.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L267.3 320l58.3 58.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L256 331.3l-58.3 58.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L244.7 320l-58.3-58.3c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L256 308.7z'
      
    ]
  };

  

  
  

  var faClockEight = {
    prefix: 'fat',
    iconName: 'clock-eight',
    icon: [
      512,
      512,
      [],
      'e345',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM264 104V256c0 2.7-1.3 5.2-3.6 6.7l-96 64c-3.7 2.5-8.6 1.5-11.1-2.2s-1.5-8.6 2.2-11.1L248 251.7V104c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faBoltLightning = {
    prefix: 'fat',
    iconName: 'bolt-lightning',
    icon: [
      384,
      512,
      [],
      'e0b7',
      
      'M28.3 34.5C31 14.7 47.9 0 67.9 0h153C240.3 0 256 15.7 256 35.1c0 4.2-.8 8.4-2.2 12.3L211.5 160H357.7c14.5 0 26.3 11.8 26.3 26.3c0 5.3-1.6 10.6-4.7 15L170.4 503c-3.9 5.7-10.4 9-17.2 9c-13.9 0-24-13.3-20.2-26.7L189.4 288H40c-22.1 0-40-17.9-40-40v-8c0-.4 0-.7 .1-1.1L28.3 34.5zM67.9 16c-12 0-22.1 8.8-23.8 20.7L16 240.5V248c0 13.3 10.7 24 24 24H200c2.5 0 4.9 1.2 6.4 3.2s2 4.6 1.3 7L148.4 489.7c-.9 3.2 1.5 6.3 4.8 6.3c1.6 0 3.2-.8 4.1-2.1L366.2 192.1c1.2-1.7 1.8-3.8 1.8-5.9c0-5.7-4.6-10.3-10.3-10.3H200c-2.6 0-5.1-1.3-6.6-3.4s-1.8-4.9-.9-7.4L238.8 41.8c.8-2.1 1.2-4.4 1.2-6.7c0-10.5-8.5-19.1-19.1-19.1H67.9z'
      
    ]
  };

  

  
  

  var faChartPie = {
    prefix: 'fat',
    iconName: 'chart-pie',
    icon: [
      576,
      512,
      ["pie-chart"],
      'f200',
      
      'M528 224H320V16c114.9 0 208 93.1 208 208zM320 240H528.5c8.4 0 15.4-6.5 15.5-14.9l0-1.1C544 100.3 443.7 0 320 0l-1.1 0C310.5 0 304 7.1 304 15.5V224c0 8.8 7.2 16 16 16zm-75.3 59.3l156 156C364.3 481 319.9 496 272 496C148.3 496 48 395.7 48 272C48 159.2 131.5 65.8 240 50.3V288c0 4.2 1.7 8.3 4.7 11.3zM239 34.3C122.1 50.3 32 150.7 32 272c0 132.5 107.5 240 240 240c51.8 0 99.8-16.4 139-44.3c7.7-5.5 8.2-16.5 1.5-23.1L256 288V49.6c0-9.2-7.8-16.6-17-15.4zM358.6 304H557.7c-7.3 51.3-32.1 97-68.1 131l-131-131zm215.1 1c1.3-9.2-6.1-17-15.4-17H358.6c-14.3 0-21.4 17.2-11.3 27.3L478.7 446.7c5.8 5.8 15.2 6.3 21.2 .7c39.3-36.7 66.2-86.5 73.9-142.3z'
      
    ]
  };

  
    var faPieChart = faChartPie;
  

  
  

  var faPersonCirclePlus = {
    prefix: 'fat',
    iconName: 'person-circle-plus',
    icon: [
      576,
      512,
      [],
      'e541',
      
      'M160 96a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm0-96a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM141.1 144c-21.5 0-41.1 12.3-50.4 31.7L23.2 315.5c-1.9 4-6.7 5.6-10.7 3.7s-5.6-6.7-3.7-10.7L76.3 168.7c12-24.9 37.2-40.7 64.8-40.7h37.8c27.6 0 52.8 15.8 64.8 40.7l46.1 95.5c-3.7 5-7.1 10.2-10.2 15.6L229.3 175.7C220 156.3 200.4 144 178.9 144H141.1zM104 248V480c0 8.8 7.2 16 16 16s16-7.2 16-16V360c0-13.3 10.7-24 24-24s24 10.7 24 24V480c0 8.8 7.2 16 16 16s16-7.2 16-16V248c0-4.4 3.6-8 8-8s8 3.6 8 8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V360c0-4.4-3.6-8-8-8s-8 3.6-8 8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V248c0-4.4 3.6-8 8-8s8 3.6 8 8zM560 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm152-72v64h64c4.4 0 8 3.6 8 8s-3.6 8-8 8H440v64c0 4.4-3.6 8-8 8s-8-3.6-8-8V376H360c-4.4 0-8-3.6-8-8s3.6-8 8-8h64V296c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faTaxi = {
    prefix: 'fat',
    iconName: 'taxi',
    icon: [
      512,
      512,
      [128662,"cab"],
      'f1ba',
      
      'M176 40V64H336V40c0-13.3-10.7-24-24-24H200c-13.3 0-24 10.7-24 24zM160 64V40c0-22.1 17.9-40 40-40H312c22.1 0 40 17.9 40 40V64c32 .1 60.1 21.4 69 52.2l33 115.6c34.1 14.7 58 48.7 58 88.2v96 16 48c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V432H96v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V432 416 320c0-39.5 23.9-73.5 58-88.2L91 116.2C99.9 85.4 128 64.1 160 64zM416 416h16 64V320c0-44.2-35.8-80-80-80H96c-44.2 0-80 35.8-80 80v96H80 96 416zm16 16v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V432H432zM16 432v48c0 8.8 7.2 16 16 16H64c8.8 0 16-7.2 16-16V432H16zM160.3 80c-25 0-47 16.6-53.8 40.6L76.3 226c6.4-1.3 12.9-2 19.7-2H416c6.7 0 13.3 .7 19.7 2L405.6 120.6c-6.9-24-28.8-40.6-53.8-40.6H160.3zM96 336a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm336 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  
    var faCab = faTaxi;
  

  
  

  var faRoad = {
    prefix: 'fat',
    iconName: 'road',
    icon: [
      576,
      512,
      [128739],
      'f018',
      
      'M185.4 32C162 32 141 46.6 132.9 68.6L8.4 404.6C-5.1 441.1 22 480 61 480H515c39 0 66.1-38.9 52.5-75.4L443.1 68.6C435 46.6 414 32 390.6 32H185.4zM147.9 74.1C153.7 58.4 168.7 48 185.4 48H280v56c0 4.4 3.6 8 8 8s8-3.6 8-8V48h94.6c16.7 0 31.7 10.4 37.5 26.1l124.4 336c9.7 26.1-9.6 53.9-37.5 53.9H296V408c0-4.4-3.6-8-8-8s-8 3.6-8 8v56H61c-27.9 0-47.2-27.8-37.5-53.9l124.4-336zM296 200c0-4.4-3.6-8-8-8s-8 3.6-8 8V312c0 4.4 3.6 8 8 8s8-3.6 8-8V200z'
      
    ]
  };

  

  
  

  var faBedBunk = {
    prefix: 'fat',
    iconName: 'bed-bunk',
    icon: [
      576,
      512,
      [],
      'f8f8',
      
      'M16 8c0-4.4-3.6-8-8-8S0 3.6 0 8V200 439.7 504c0 4.4 3.6 8 8 8s8-3.6 8-8V447.7H216 560V504c0 4.4 3.6 8 8 8s8-3.6 8-8V439.7 280 200 136c0-57.4-46.6-104-104-104H232c-13.3 0-24 10.7-24 24V192H16V8zM208 296V431.7H16V208H216 560v64H232c-13.3 0-24 10.7-24 24zM560 136v56H224V56c0-4.4 3.6-8 8-8H472c48.6 0 88 39.4 88 88zM232 288H560V431.7H224V296c0-4.4 3.6-8 8-8zM112 48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0 128a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  

  
  

  var faLeaf = {
    prefix: 'fat',
    iconName: 'leaf',
    icon: [
      512,
      512,
      [],
      'f06c',
      
      'M114.6 243.1C140.5 230.8 169.5 224 200 224H312c4.4 0 8 3.6 8 8s-3.6 8-8 8H200c-31.8 0-61.6 8-87.7 22.2c-.2 3.2-.3 6.5-.3 9.8c0 88.4 71.6 160 160 160h0l.9 0C393.5 431.4 496 311.3 496 156.6c0-35.1-5.3-68.5-15-99.3C457.8 90.3 419.5 112 376 112l-104 0c-78.5 0-143.8 56.5-157.4 131.1zm-17.5 9.4C106.8 164.5 181.4 96 272 96l104 0c42.7 0 79.9-23.9 98.8-59.1c3.5-6.5 13.6-6.8 16.2 .1c13.5 36.5 21.1 77 21.1 119.6C512 317.1 405.1 447.3 273 448l-1 0c-97.1 0-175.9-78.7-176-175.8C47.7 305.4 16 361 16 424v48c0 4.4-3.6 8-8 8s-8-3.6-8-8V424c0-72.8 38.9-136.5 97.1-171.5z'
      
    ]
  };

  

  
  

  var faF = {
    prefix: 'fat',
    iconName: 'f',
    icon: [
      320,
      512,
      [102],
      '46',
      
      'M32 32C14.3 32 0 46.3 0 64V248 472c0 4.4 3.6 8 8 8s8-3.6 8-8V256H248c4.4 0 8-3.6 8-8s-3.6-8-8-8H16V64c0-8.8 7.2-16 16-16H312c4.4 0 8-3.6 8-8s-3.6-8-8-8H32z'
      
    ]
  };

  

  
  

  var faCloudPlus = {
    prefix: 'fat',
    iconName: 'cloud-plus',
    icon: [
      640,
      512,
      [],
      'e35e',
      
      'M522.7 220.8c3.4-8.9 5.3-18.6 5.3-28.8c0-44.2-35.8-80-80-80c-16.5 0-31.7 5-44.4 13.5c-3.7 2.5-8.2 3.3-12.5 2.3s-8-3.8-10.2-7.6C355.9 77 309.3 48 256 48c-79.5 0-144 64.5-144 144c0 2.5 .1 4.9 .2 7.3c.4 7.1-4 13.5-10.7 15.9C51.7 232.7 16 280.2 16 336c0 70.7 57.3 128 128 128H512c61.9 0 112-50.1 112-112c0-54.2-38.5-99.4-89.6-109.8c-4.6-.9-8.6-3.9-10.9-8s-2.6-9.1-.9-13.4zM256 32c53.6 0 101 26.3 130 66.7c3.1 4.3 6 8.8 8.7 13.4c3.5-2.4 7.2-4.5 11-6.4C418.5 99.5 432.8 96 448 96c53 0 96 43 96 96c0 6.6-.7 13-1.9 19.2c-1.1 5.3-2.6 10.5-4.5 15.4c5.3 1.1 10.5 2.5 15.5 4.2C603.6 247.9 640 295.7 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160zm56 352V296H224c-4.4 0-8-3.6-8-8s3.6-8 8-8h88V192c0-4.4 3.6-8 8-8s8 3.6 8 8v88h88c4.4 0 8 3.6 8 8s-3.6 8-8 8H328v88c0 4.4-3.6 8-8 8s-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faAustralSign = {
    prefix: 'fat',
    iconName: 'austral-sign',
    icon: [
      448,
      512,
      [],
      'e0a9',
      
      'M231.4 36.9c-1.3-3-4.2-4.9-7.4-4.9s-6.1 1.9-7.4 4.9L130.1 240H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H123.3L89.2 336H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H82.4L32.6 468.9c-1.7 4.1 .2 8.8 4.2 10.5s8.8-.2 10.5-4.2L99.8 352H348.2l52.4 123.1c1.7 4.1 6.4 6 10.5 4.2s6-6.4 4.2-10.5L365.6 352H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H358.8l-34.1-80H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H317.9L231.4 36.9zM300.5 240h-153L224 60.4 300.5 240zM140.7 256H307.3l34.1 80H106.6l34.1-80z'
      
    ]
  };

  

  
  

  var faChessKnightPiece = {
    prefix: 'fat',
    iconName: 'chess-knight-piece',
    icon: [
      320,
      512,
      ["chess-knight-alt"],
      'f442',
      
      'M288 236.9c0-86.6-70.3-156.7-156.9-156.5l-93.1 .2c-3.1 0-5.7 2.6-5.7 5.7c0 1.6 .7 3.2 1.9 4.2l20.5 18.5c3.3 2.9 3.5 8 .6 11.2l-9 10.1c-9 10.2-14.1 23.4-14.1 37l-.2 70.7c0 14.1 8.3 26.9 21.2 32.7c11.2 5 24.2 3.9 34.3-2.9l60.7-40.6c.5-.3 1-.6 1.5-.8l13.8-9.2c3.7-2.5 8.6-1.5 11.1 2.2s1.5 8.6-2.2 11.1L89.1 286.5C73.3 298.1 64 316.4 64 336v0l-.2 48.1h-16L48 336l0 0c0-16.9 5.5-33 15.3-46.2c-5.7-.5-11.3-1.9-16.6-4.3C28 277.2 16 258.6 16.1 238.1l.2-70.7c.1-17.5 6.5-34.4 18.1-47.6l3.7-4.2L23.5 102.5c-4.6-4.1-7.2-10-7.2-16.1c0-12 9.7-21.7 21.6-21.7l93.1-.2C226.5 64.2 304 141.5 304 236.9c0 13.3-1.5 26.6-4.6 39.5L274.1 384.1H257.6l26.2-111.4c2.8-11.7 4.2-23.8 4.2-35.8zM84 160a12 12 0 1 1 0 24 12 12 0 1 1 0-24zM56.2 416H263.8c7.8 0 15 3.7 19.5 10.1l32.2 45.1c2.9 4.1 4.5 8.9 4.5 13.9V488c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24v-2.9c0-5 1.6-9.9 4.5-13.9l32.2-45.1c4.5-6.3 11.8-10.1 19.5-10.1zm-6.5 19.4L17.5 480.5c-1 1.4-1.5 3-1.5 4.6V488c0 4.4 3.6 8 8 8H296c4.4 0 8-3.6 8-8v-2.9c0-1.7-.5-3.3-1.5-4.6l-32.2-45.1c-1.5-2.1-3.9-3.4-6.5-3.4H56.2c-2.6 0-5 1.2-6.5 3.4z'
      
    ]
  };

  
    var faChessKnightAlt = faChessKnightPiece;
  

  
  

  var faPie = {
    prefix: 'fat',
    iconName: 'pie',
    icon: [
      576,
      512,
      [129383],
      'f705',
      
      'M288 64C180 64 88.1 133 54.1 229.4c-1.3 3.8-5 6.6-9.3 6.6c-15.5 0-28 12.5-28 28s12.5 28 28 28c26.5 0 47.3-8.8 62-18.3c5-3.2 11.5-3.6 16.9-.8c18.2 9.4 44.6 19.1 76.3 19.1s58.1-9.7 76.3-19.1c7.3-3.8 16-3.8 23.4 0c18.2 9.4 44.6 19.1 76.3 19.1s58.1-9.7 76.3-19.1c5.4-2.8 11.9-2.4 16.9 .8c14.7 9.5 35.5 18.3 62 18.3c15.5 0 28-12.5 28-28s-12.5-28-28-28c-4.3 0-7.9-2.8-9.3-6.6C487.9 133 396 64 288 64zM40.4 220.2C77.7 119.7 174.5 48 288 48s210.3 71.7 247.6 172.2c22.2 2.2 39.6 21 39.6 43.8c0 24.3-19.7 44-44 44c-30.2 0-54-10.1-70.7-20.8c-.3-.2-.6-.2-.9-.1C440 297.3 411 308 376 308s-64-10.7-83.7-20.9c-2.7-1.4-6-1.4-8.7 0C264 297.3 235 308 200 308s-64-10.7-83.7-20.9L120 280l-3.7 7.1c-.2-.1-.6-.1-.9 .1C98.8 297.9 75 308 44.8 308c-24.3 0-44-19.7-44-44c0-22.8 17.4-41.6 39.6-43.8zM58.5 335.4c5.6-.5 11-1.2 16.2-2.1l21.9 65.8c6.5 19.6 24.9 32.8 45.5 32.8H433.9c20.7 0 39-13.2 45.5-32.8l21.9-65.8c5.2 .9 10.6 1.7 16.2 2.1l-22.9 68.8c-8.7 26.1-33.2 43.8-60.7 43.8H142.1c-27.5 0-52-17.6-60.7-43.8L58.5 335.4zM199.2 139.6l-24 48c-2 4-6.8 5.6-10.7 3.6s-5.6-6.8-3.6-10.7l24-48c2-4 6.8-5.6 10.7-3.6s5.6 6.8 3.6 10.7zm192-7.2l24 48c2 4 .4 8.8-3.6 10.7s-8.8 .4-10.7-3.6l-24-48c-2-4-.4-8.8 3.6-10.7s8.8-.4 10.7 3.6zM296 136v48c0 4.4-3.6 8-8 8s-8-3.6-8-8V136c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faSquareEllipsis = {
    prefix: 'fat',
    iconName: 'square-ellipsis',
    icon: [
      448,
      512,
      [],
      'e26e',
      
      'M16 416c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-320c0-26.5-21.5-48-48-48L64 48C37.5 48 16 69.5 16 96l0 320zm48 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zM208 256a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-80 16a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm176-16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faVirusCovid = {
    prefix: 'fat',
    iconName: 'virus-covid',
    icon: [
      512,
      512,
      [],
      'e4a8',
      
      'M216 8c-4.4 0-8 3.6-8 8s3.6 8 8 8h32V72.2c-44.8 1.9-85.4 19.8-116.3 48.2L97.6 86.3l0 0 22.6-22.6c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L52.4 108.9c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L86.3 97.6l0 0 34.1 34.1C92 162.6 74.1 203.2 72.2 248H24l0-32c0-4.4-3.6-8-8-8s-8 3.6-8 8v80c0 4.4 3.6 8 8 8s8-3.6 8-8l0-32H72.2c1.9 44.8 19.8 85.4 48.2 116.3L86.3 414.4l0 0L63.7 391.8c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l56.6 56.6c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L97.6 425.7l0 0 34.1-34.1c30.9 28.4 71.5 46.3 116.3 48.2V488H216c-4.4 0-8 3.6-8 8s3.6 8 8 8h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H264V439.8c44.8-1.9 85.4-19.8 116.3-48.2l34.1 34.1 0 0-22.6 22.6c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l56.6-56.6c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-22.6 22.6 0 0-34.1-34.1c28.4-30.9 46.3-71.5 48.2-116.3H488v32c0 4.4 3.6 8 8 8s8-3.6 8-8V216c0-4.4-3.6-8-8-8s-8 3.6-8 8v32H439.8c-1.9-44.8-19.8-85.4-48.2-116.3l34.1-34.1 0 0 22.6 22.6c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L403.1 52.4c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l22.6 22.6 0 0-34.1 34.1C349.4 92 308.8 74.1 264 72.2V24l32 0c4.4 0 8-3.6 8-8s-3.6-8-8-8H216zm40 80a168 168 0 1 1 0 336 168 168 0 1 1 0-336zM192 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm112 48a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faImagePolaroidUser = {
    prefix: 'fat',
    iconName: 'image-polaroid-user',
    icon: [
      448,
      512,
      [],
      'e1b6',
      
      'M16 416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V352H336 320 128 112 16v64zm318.4-80H432V96c0-26.5-21.5-48-48-48H64C37.5 48 16 69.5 16 96V336h97.6c7.4-36.5 39.7-64 78.4-64h64c38.7 0 71 27.5 78.4 64zM130 336H318c-7.1-27.6-32.2-48-62-48H192c-29.8 0-54.9 20.4-62 48zM448 96V336v8 8 64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V352v-8-8V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64zM272 176a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-48-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
      
    ]
  };

  

  
  

  var faWonSign = {
    prefix: 'fat',
    iconName: 'won-sign',
    icon: [
      512,
      512,
      [8361,"krw","won"],
      'f159',
      
      'M39.7 38c-1.1-4.3-5.5-6.8-9.8-5.7s-6.8 5.5-5.7 9.8L83.9 272H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H88l48.2 186c.9 3.5 4.1 6 7.7 6s6.8-2.5 7.7-6L200 288H312l48.2 186c.9 3.5 4.1 6 7.7 6s6.8-2.5 7.7-6L424 288h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H428.1L487.7 42c1.1-4.3-1.5-8.6-5.7-9.8s-8.6 1.5-9.8 5.7L411.6 272H324.4L263.7 38c-.9-3.5-4.1-6-7.7-6s-6.8 2.5-7.7 6L187.6 272H100.4L39.7 38zm64.8 250h78.9L144 440.1 104.6 288zm99.6-16L256 71.9 307.9 272H204.1zm124.4 16h78.9L368 440.1 328.6 288z'
      
    ]
  };

  
    var faKrw = faWonSign;
  
    var faWon = faWonSign;
  

  
  

  var faImagesUser = {
    prefix: 'fat',
    iconName: 'images-user',
    icon: [
      576,
      512,
      [],
      'e1b9',
      
      'M512 48H160c-26.5 0-48 21.5-48 48V320c0 26.5 21.5 48 48 48h64V336c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80v32h64c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48zM448 384H432 240 224 160c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V320c0 35.3-28.7 64-64 64H448zm-16-16V336c0-35.3-28.7-64-64-64H304c-35.3 0-64 28.7-64 64v32H432zM64 128v16c-26.5 0-48 21.5-48 48V416c0 26.5 21.5 48 48 48H416c26.5 0 48-21.5 48-48h16c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64zm320 32a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM336 96a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
      
    ]
  };

  

  
  

  var faCubesStacked = {
    prefix: 'fat',
    iconName: 'cubes-stacked',
    icon: [
      448,
      512,
      [],
      'e4e6',
      
      'M288 48H224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16zM224 32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM90.7 220.8c-7.7 4.4-10.3 14.2-5.9 21.9l32 55.4c4.4 7.7 14.2 10.3 21.9 5.9l55.4-32c7.7-4.4 10.3-14.2 5.9-21.9l-32-55.4c-4.4-7.7-14.2-10.3-21.9-5.9l-55.4 32zM71 250.7c-8.8-15.3-3.6-34.9 11.7-43.7l55.4-32c15.3-8.8 34.9-3.6 43.7 11.7l32 55.4c8.8 15.3 3.6 34.9-11.7 43.7l-55.4 32c-15.3 8.8-34.9 3.6-43.7-11.7L71 250.7zM352 208H288c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V224c0-8.8-7.2-16-16-16zm-96 16c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V224zm80 160v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V384c0-8.8-7.2-16-16-16H352c-8.8 0-16 7.2-16 16zm-16 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V384zM192 368c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V384c0-8.8-7.2-16-16-16H192zm0-16h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32zM32 368c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V384c0-8.8-7.2-16-16-16H32zM0 384c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V384z'
      
    ]
  };

  

  
  

  var faArrowUpRightFromSquare = {
    prefix: 'fat',
    iconName: 'arrow-up-right-from-square',
    icon: [
      512,
      512,
      ["external-link"],
      'f08e',
      
      'M320 24c0 4.4 3.6 8 8 8H468.7L202.3 298.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L480 43.3V184c0 4.4 3.6 8 8 8s8-3.6 8-8V24c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8zM56 32C25.1 32 0 57.1 0 88V456c0 30.9 25.1 56 56 56H424c30.9 0 56-25.1 56-56V312c0-4.4-3.6-8-8-8s-8 3.6-8 8V456c0 22.1-17.9 40-40 40H56c-22.1 0-40-17.9-40-40V88c0-22.1 17.9-40 40-40H200c4.4 0 8-3.6 8-8s-3.6-8-8-8H56z'
      
    ]
  };

  
    var faExternalLink = faArrowUpRightFromSquare;
  

  
  

  var faMagnifyingGlassChart = {
    prefix: 'fat',
    iconName: 'magnifying-glass-chart',
    icon: [
      512,
      512,
      [],
      'e522',
      
      'M208 16a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 400c54.6 0 104.2-21 141.3-55.4l149 149c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-149-149C395 312.2 416 262.6 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM112 192c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32V224c0-17.7-14.3-32-32-32zm96-96c-17.7 0-32 14.3-32 32V288c0 17.7 14.3 32 32 32s32-14.3 32-32V128c0-17.7-14.3-32-32-32zm96 64c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V192c0-17.7-14.3-32-32-32zM112 208c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V224c0-8.8 7.2-16 16-16zm96-96c8.8 0 16 7.2 16 16V288c0 8.8-7.2 16-16 16s-16-7.2-16-16V128c0-8.8 7.2-16 16-16zm96 64c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faMobileNotch = {
    prefix: 'fat',
    iconName: 'mobile-notch',
    icon: [
      384,
      512,
      ["mobile-iphone"],
      'e1ee',
      
      'M256 16V40c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24V16H96C69.5 16 48 37.5 48 64V448c0 26.5 21.5 48 48 48H288c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H256zm-16 0H144V40c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V16zM32 64C32 28.7 60.7 0 96 0H288c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V64z'
      
    ]
  };

  
    var faMobileIphone = faMobileNotch;
  

  
  

  var faClothesHanger = {
    prefix: 'fat',
    iconName: 'clothes-hanger',
    icon: [
      640,
      512,
      [],
      'e136',
      
      'M224.8 87.1C229.3 37.7 271.4 0 320.9 0c52 0 95.1 42.1 95.1 94.3c0 38.8-18.6 75.3-49.9 98.1L334 215.7 613.2 401.9C630 413 640 431.8 640 451.9c0 33.2-26.9 60.1-60.1 60.1H60.1C26.9 512 0 485.1 0 451.9c0-20.1 10-38.9 26.8-50L315.4 209.4l41.2-30C383.9 159.6 400 128 400 94.3C400 51.2 364.3 16 320.9 16c-41.4 0-76.5 31.6-80.2 72.6l-.7 8.1c-.4 4.4-4.3 7.6-8.7 7.2s-7.6-4.3-7.2-8.7l.7-8.1zM320 225.6L35.6 415.2c-12.3 8.2-19.6 22-19.6 36.7C16 476.2 35.7 496 60.1 496H579.9c24.4 0 44.1-19.8 44.1-44.1c0-14.7-7.4-28.5-19.6-36.7L320 225.6z'
      
    ]
  };

  

  
  

  var faBuildingCircleExclamation = {
    prefix: 'fat',
    iconName: 'building-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e4d3',
      
      'M48 16H336c17.7 0 32 14.3 32 32V247.2c5-5.3 10.4-10.3 16-15V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96 16 64 16 96c15.1 0 28.5-6.9 37.3-17.8c-3.9-3.8-7.6-7.7-11.1-11.8c-5.8 8.2-15.4 13.6-26.2 13.6H240V416c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-17.7 0-32-14.3-32-32V48c0-17.7 14.3-32 32-32zM224 496H160V416c0-17.7 14.3-32 32-32s32 14.3 32 32v80zM104 232c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V256c0-13.3-10.7-24-24-24H104zm-8 24c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8V256zm128 0v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V256c0-13.3-10.7-24-24-24H248c-13.3 0-24 10.7-24 24zm24-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H248c-4.4 0-8-3.6-8-8V256c0-4.4 3.6-8 8-8zM104 104c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V128c0-13.3-10.7-24-24-24H104zm-8 24c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8V128zm128 0v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V128c0-13.3-10.7-24-24-24H248c-13.3 0-24 10.7-24 24zm24-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H248c-4.4 0-8-3.6-8-8V128c0-4.4 3.6-8 8-8zM368 368a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 448a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-168c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8s8-3.6 8-8V288c0-4.4-3.6-8-8-8z'
      
    ]
  };

  

  
  

  var faMoonStars = {
    prefix: 'fat',
    iconName: 'moon-stars',
    icon: [
      512,
      512,
      [],
      'f755',
      
      'M328 8V56h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H328v48c0 4.4-3.6 8-8 8s-8-3.6-8-8V72H264c-4.4 0-8-3.6-8-8s3.6-8 8-8h48V8c0-4.4 3.6-8 8-8s8 3.6 8 8zM191.8 144C94.7 144 16 222.9 16 320.2s78.7 176.2 175.8 176.2c47.6 0 90.8-19 122.5-49.8c-9 1.6-18.3 2.4-27.8 2.4c-89.6 0-162.2-72.8-162.2-162.6c0-60.8 33.3-113.8 82.5-141.7c-4.9-.4-9.9-.6-14.9-.6zM0 320.2C0 214.1 85.8 128 191.8 128c5.5 0 10.9 .2 16.3 .7c7 .6 12.8 5.7 14.3 12.5s-1.6 13.9-7.7 17.3c-44.4 25.2-74.4 73-74.4 127.8c0 81 65.5 146.6 146.2 146.6c8.6 0 17-.7 25.1-2.2c6.9-1.2 13.8 2.2 17 8.5s1.9 13.8-3.1 18.7c-34.5 33.6-81.7 54.4-133.6 54.4C85.8 512.4 0 426.3 0 320.2zM416 128c4.4 0 8 3.6 8 8v80h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H424v80c0 4.4-3.6 8-8 8s-8-3.6-8-8V232H328c-4.4 0-8-3.6-8-8s3.6-8 8-8h80V136c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faWhiskeyGlass = {
    prefix: 'fat',
    iconName: 'whiskey-glass',
    icon: [
      512,
      512,
      [129347,"glass-whiskey"],
      'f7a0',
      
      'M19.9 53.5c-3 3.5-4.4 8.2-3.7 12.8l30 205.9c.6-.1 1.2-.2 1.8-.2H464c.6 0 1.2 .1 1.8 .2l30-205.9c.7-4.6-.7-9.3-3.7-12.8s-7.5-5.5-12.1-5.5H32c-4.6 0-9.1 2-12.1 5.5zM48.5 288L66.2 409.2c4.6 31.4 31.6 54.8 63.3 54.8h253c31.8 0 58.7-23.3 63.3-54.8L463.5 288H48.5zM7.8 43.1C13.9 36 22.7 32 32 32H480c9.3 0 18.1 4 24.2 11.1s8.8 16.4 7.5 25.5l-50 342.9c-5.7 39.3-39.4 68.5-79.2 68.5h-253c-39.7 0-73.4-29.1-79.2-68.5L.3 68.6C-1 59.4 1.7 50.1 7.8 43.1z'
      
    ]
  };

  
    var faGlassWhiskey = faWhiskeyGlass;
  

  
  

  var faCode = {
    prefix: 'fat',
    iconName: 'code',
    icon: [
      640,
      512,
      [],
      'f121',
      
      'M410.7 .5c-4.2-1.5-8.7 .7-10.2 4.9l-176 496c-1.5 4.2 .7 8.7 4.9 10.2s8.7-.7 10.2-4.9l176-496c1.5-4.2-.7-8.7-4.9-10.2zm71.5 122.1c-3 3.2-2.9 8.3 .3 11.3L612.3 256 482.5 378.2c-3.2 3-3.4 8.1-.3 11.3s8.1 3.4 11.3 .3l136-128c1.6-1.5 2.5-3.6 2.5-5.8s-.9-4.3-2.5-5.8l-136-128c-3.2-3-8.3-2.9-11.3 .3zm-324.3 0c-3-3.2-8.1-3.4-11.3-.3l-136 128C8.9 251.7 8 253.8 8 256s.9 4.3 2.5 5.8l136 128c3.2 3 8.3 2.9 11.3-.3s2.9-8.3-.3-11.3L27.7 256 157.5 133.8c3.2-3 3.4-8.1 .3-11.3z'
      
    ]
  };

  

  
  

  var faFileExclamation = {
    prefix: 'fat',
    iconName: 'file-exclamation',
    icon: [
      384,
      512,
      [],
      'f31a',
      
      'M16 448V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM192 208c-4.4 0-8 3.6-8 8V360c0 4.4 3.6 8 8 8s8-3.6 8-8V216c0-4.4-3.6-8-8-8zm16 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faStarHalfStroke = {
    prefix: 'fat',
    iconName: 'star-half-stroke',
    icon: [
      576,
      512,
      ["star-half-alt"],
      'f5c0',
      
      'M200.1 170.7L46.8 193.3c-3 .4-5.5 2.5-6.4 5.4s-.2 6 2 8.2L31.2 218.1l11.2-11.3L153.5 317c3.7 3.7 5.4 8.9 4.5 14L131.8 486.6c-.5 3 .7 6 3.2 7.8s5.8 2 8.4 .6L280 422V22L212.1 161.8c-2.3 4.8-6.8 8.1-12.1 8.8zM296 422.1L432.4 495c2.7 1.4 6 1.2 8.4-.6s3.7-4.8 3.2-7.8L417.9 331c-.9-5.1 .8-10.4 4.5-14L533.5 206.9c2.2-2.1 2.9-5.3 2-8.2s-3.4-5-6.4-5.4L375.8 170.7c-5.2-.8-9.7-4.1-12.1-8.8L296 22.3V422.1zm154.2 85.3c-7.4 5.3-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0s17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5z'
      
    ]
  };

  
    var faStarHalfAlt = faStarHalfStroke;
  

  
  

  var faMoneyCheck = {
    prefix: 'fat',
    iconName: 'money-check',
    icon: [
      576,
      512,
      [],
      'f53c',
      
      'M64 80c-26.5 0-48 21.5-48 48V384c0 26.5 21.5 48 48 48H512c26.5 0 48-21.5 48-48V128c0-26.5-21.5-48-48-48H64zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM104 240H248c4.4 0 8 3.6 8 8s-3.6 8-8 8H104c-4.4 0-8-3.6-8-8s3.6-8 8-8zM96 344c0-4.4 3.6-8 8-8H472c4.4 0 8 3.6 8 8s-3.6 8-8 8H104c-4.4 0-8-3.6-8-8zM360 176c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V200c0-13.3-10.7-24-24-24H360zm-40 24c0-22.1 17.9-40 40-40h80c22.1 0 40 17.9 40 40v32c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V200z'
      
    ]
  };

  

  
  

  var faPuzzlePiece = {
    prefix: 'fat',
    iconName: 'puzzle-piece',
    icon: [
      512,
      512,
      [129513],
      'f12e',
      
      'M173.9 15.7C187 5.8 204.8 0 224 0s37 5.8 50.1 15.7S296 39.7 296 56c0 16.4-8.9 30.6-22 40.4c-6.3 4.7-10 10.6-10 16.4c0 8.4 6.8 15.2 15.2 15.2H344c22.1 0 40 17.9 40 40v64.8c0 8.4 6.8 15.2 15.2 15.2c5.8 0 11.7-3.7 16.4-10c9.8-13.2 24-22 40.4-22c16.3 0 30.5 8.8 40.3 21.9S512 268.8 512 288s-5.8 37-15.7 50.1s-24 21.9-40.3 21.9c-16.4 0-30.6-8.9-40.4-22c-4.7-6.3-10.6-10-16.4-10c-8.4 0-15.2 6.8-15.2 15.2V472c0 22.1-17.9 40-40 40H279.2C262 512 248 498 248 480.8c0-12.7 7.8-22.8 16.4-29.2C274.5 444 280 434.2 280 424c0-10.2-5.5-20-15.5-27.5S240.1 384 224 384s-30.4 4.9-40.5 12.5S168 413.8 168 424c0 10.2 5.5 20 15.6 27.6c8.5 6.4 16.4 16.5 16.4 29.2c0 17.2-14 31.2-31.2 31.2H40c-22.1 0-40-17.9-40-40V343.2C0 326 14 312 31.2 312c12.7 0 22.8 7.8 29.2 16.4C68 338.5 77.8 344 88 344c10.2 0 20-5.5 27.5-15.5s12.5-24.3 12.5-40.5s-4.9-30.4-12.5-40.5S98.2 232 88 232c-10.2 0-20 5.5-27.6 15.6C54 256.2 43.9 264 31.2 264C14 264 0 250 0 232.8V168c0-22.1 17.9-40 40-40H168.8c8.4 0 15.2-6.8 15.2-15.2c0-5.8-3.7-11.7-10-16.4c-13.2-9.8-22-24-22-40.4c0-16.3 8.8-30.5 21.9-40.3zm9.6 12.8C173.5 36 168 45.8 168 56c0 10.2 5.5 20 15.6 27.6c8.5 6.4 16.4 16.5 16.4 29.2c0 17.2-14 31.2-31.2 31.2H40c-13.3 0-24 10.7-24 24v64.8c0 8.4 6.8 15.2 15.2 15.2c5.8 0 11.7-3.7 16.4-10c9.8-13.2 24-22 40.4-22c16.3 0 30.5 8.8 40.3 21.9S144 268.8 144 288s-5.8 37-15.7 50.1s-24 21.9-40.3 21.9c-16.4 0-30.6-8.9-40.4-22c-4.7-6.3-10.6-10-16.4-10c-8.4 0-15.2 6.8-15.2 15.2V472c0 13.3 10.7 24 24 24H168.8c8.4 0 15.2-6.8 15.2-15.2c0-5.8-3.7-11.7-10-16.4c-13.2-9.8-22-24-22-40.4c0-16.3 8.8-30.5 21.9-40.3S204.8 368 224 368s37 5.8 50.1 15.7s21.9 24 21.9 40.3c0 16.4-8.9 30.6-22 40.4c-6.3 4.7-10 10.6-10 16.4c0 8.4 6.8 15.2 15.2 15.2H344c13.3 0 24-10.7 24-24V343.2c0-17.2 14-31.2 31.2-31.2c12.7 0 22.8 7.8 29.2 16.4C436 338.5 445.8 344 456 344c10.2 0 20-5.5 27.5-15.5s12.5-24.3 12.5-40.5s-4.9-30.4-12.5-40.5S466.2 232 456 232c-10.2 0-20 5.5-27.6 15.6c-6.4 8.5-16.5 16.4-29.2 16.4C382 264 368 250 368 232.8V168c0-13.3-10.7-24-24-24H279.2C262 144 248 130 248 112.8c0-12.7 7.8-22.8 16.4-29.2C274.5 76 280 66.2 280 56c0-10.2-5.5-20-15.5-27.5S240.1 16 224 16s-30.4 4.9-40.5 12.5z'
      
    ]
  };

  

  
  

  var faTrainTrack = {
    prefix: 'fat',
    iconName: 'train-track',
    icon: [
      576,
      512,
      [],
      'e453',
      
      'M191.6 42.5c1.4-4.2-.9-8.7-5.1-10.1s-8.7 .9-10.1 5.1L156.9 96H112c-4.4 0-8 3.6-8 8s3.6 8 8 8h39.6L114.2 224H72c-4.4 0-8 3.6-8 8s3.6 8 8 8h36.9L71.6 352H32c-4.4 0-8 3.6-8 8s3.6 8 8 8H66.2L32.4 469.5c-1.4 4.2 .9 8.7 5.1 10.1s8.7-.9 10.1-5.1L83.1 368H492.9l35.5 106.5c1.4 4.2 5.9 6.5 10.1 5.1s6.5-5.9 5.1-10.1L509.8 368H544c4.4 0 8-3.6 8-8s-3.6-8-8-8H504.4L467.1 240H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H461.8L424.4 112H464c4.4 0 8-3.6 8-8s-3.6-8-8-8H419.1L399.6 37.5c-1.4-4.2-5.9-6.5-10.1-5.1s-6.5 5.9-5.1 10.1L402.2 96H173.8l17.8-53.5zM168.4 112H407.6l37.3 112H131.1l37.3-112zM487.6 352H88.4l37.3-112H450.2l37.3 112z'
      
    ]
  };

  

  
  

  var faArrowUpSmallBig = {
    prefix: 'fat',
    iconName: 'arrow-up-small-big',
    icon: [
      576,
      512,
      ["sort-size-up-alt"],
      'f88f',
      
      'M154.3 34.3c3.1-3.1 8.2-3.1 11.3 0l104 104c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L168 59.3V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V59.3L61.7 149.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l104-104zM336 80v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32H368c-17.7 0-32 14.3-32 32zm-16 0c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V80zm16 352c0 17.7 14.3 32 32 32H496c17.7 0 32-14.3 32-32V304c0-17.7-14.3-32-32-32H368c-17.7 0-32 14.3-32 32V432zm-16 0V304c0-26.5 21.5-48 48-48H496c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48z'
      
    ]
  };

  
    var faSortSizeUpAlt = faArrowUpSmallBig;
  

  
  

  var faHandHoldingHeart = {
    prefix: 'fat',
    iconName: 'hand-holding-heart',
    icon: [
      576,
      512,
      [],
      'f4be',
      
      'M288 46.9l-17.7-18c-29.4-29.8-77-29.8-106.4 0s-29.4 78.2 0 108L265.5 240.1c6.2 6.3 14.3 9.4 22.5 9.4s16.3-3.1 22.5-9.4L412.1 136.9c29.4-29.8 29.4-78.2 0-108s-77-29.8-106.4 0L288 46.9zm5.7 17l23.4-23.8c23.1-23.5 60.5-23.5 83.6 0c23.2 23.6 23.2 61.9 0 85.5L299.1 228.9c-3.1 3.1-7.1 4.7-11.1 4.7s-8-1.5-11.1-4.7L175.3 125.7c-23.2-23.6-23.2-61.9 0-85.5c23.1-23.5 60.5-23.5 83.6 0l23.4 23.8c3.1 3.2 8.3 3.2 11.4 0zM521.8 340.7c10.7-7.9 25.7-5.6 33.6 5.1s5.6 25.7-5.1 33.6L423.6 472.6C403 487.8 378.1 496 352.5 496H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L394.7 414.4c-1.4 1-3 1.6-4.7 1.6H268c-6.6 0-12-5.4-12-12s5.4-12 12-12h80c19.9 0 36-16.1 36-36s-16.1-36-36-36H193.7c-29.1 0-57.3 9.9-80 28L71 382.2c-1.4 1.1-3.2 1.8-5 1.8H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H66c5.4 0 10.7-1.9 15-5.3l42.7-34.2c19.9-15.9 44.5-24.5 70-24.5H348c11 0 20 9 20 20s-9 20-20 20H268c-15.5 0-28 12.5-28 28s12.5 28 28 28H389.9c5.1 0 10.1-1.6 14.2-4.7l117.6-86.6z'
      
    ]
  };

  

  
  

  var faHouseChimneyUser = {
    prefix: 'fat',
    iconName: 'house-chimney-user',
    icon: [
      576,
      512,
      [],
      'e065',
      
      'M293.3 2c-3-2.7-7.6-2.7-10.6 0L2.7 250c-3.3 2.9-3.6 8-.7 11.3s8 3.6 11.3 .7L64 217.1V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V217.1L562.7 262c3.3 2.9 8.4 2.6 11.3-.7s2.6-8.4-.7-11.3L512 195.7V56c0-13.3-10.7-24-24-24H408c-13.3 0-24 10.7-24 24V82.3L293.3 2zM384 103.7v.3h.3L496 202.9V448c0 26.5-21.5 48-48 48H128c-26.5 0-48-21.5-48-48V202.9L288 18.7l96 85zm16-7.2V56c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8V181.5l-96-85zM240 224a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM256 336h64c35.3 0 64 28.7 64 64H192c0-35.3 28.7-64 64-64zm0-16c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H256z'
      
    ]
  };

  

  
  

  var faDryerHeat = {
    prefix: 'fat',
    iconName: 'dryer-heat',
    icon: [
      448,
      512,
      ["dryer-alt"],
      'f862',
      
      'M64 16C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H64zM0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM112 96A16 16 0 1 0 80 96a16 16 0 1 0 32 0zM64 96a32 32 0 1 1 64 0A32 32 0 1 1 64 96zm128 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM352 304A128 128 0 1 0 96 304a128 128 0 1 0 256 0zM80 304a144 144 0 1 1 288 0A144 144 0 1 1 80 304zm101.7-77.7L194.3 239c8.7 8.7 13.7 20.6 13.7 33s-4.9 24.2-13.7 33l-9.4 9.4c-5.7 5.7-9 13.5-9 21.7s3.2 15.9 9 21.7l12.7 12.7c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L173.7 369c-8.7-8.7-13.7-20.6-13.7-33s4.9-24.2 13.7-33l9.4-9.4c5.7-5.7 9-13.5 9-21.7s-3.2-15.9-9-21.7l-12.7-12.7c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0zm80 0L274.3 239c8.7 8.7 13.7 20.6 13.7 33s-4.9 24.2-13.7 33l-9.4 9.4c-5.7 5.7-9 13.5-9 21.7s3.2 15.9 9 21.7l12.7 12.7c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L253.7 369c-8.7-8.7-13.7-20.6-13.7-33s4.9-24.2 13.7-33l9.4-9.4c5.7-5.7 9-13.5 9-21.7s-3.2-15.9-9-21.7l-12.7-12.7c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0z'
      
    ]
  };

  
    var faDryerAlt = faDryerHeat;
  

  
  

  var faUpDownLeftRight = {
    prefix: 'fat',
    iconName: 'up-down-left-right',
    icon: [
      512,
      512,
      ["arrows-alt"],
      'f0b2',
      
      'M332.7 90.5L270.9 22.6c-3.8-4.2-9.2-6.6-14.9-6.6s-11.1 2.4-14.9 6.6L179.3 90.5c-2.1 2.4-3.3 5.4-3.3 8.6c0 7.1 5.8 12.8 12.8 12.8l134.3 0c7.1 0 12.8-5.8 12.8-12.8c0-3.2-1.2-6.3-3.3-8.6zM282.8 11.8l61.7 67.9c4.8 5.3 7.5 12.2 7.5 19.4c0 15.9-12.9 28.8-28.8 28.8H264V248H384v16H264V384h59.2c15.9 0 28.8 12.9 28.8 28.8c0 7.2-2.7 14.1-7.5 19.4l-61.7 67.9c-6.9 7.5-16.6 11.8-26.8 11.8s-19.9-4.3-26.8-11.8l-61.7-67.9c-4.8-5.3-7.5-12.2-7.5-19.4c0-15.9 12.9-28.8 28.8-28.8H248V264H128l0 59.2c0 15.9-12.9 28.8-28.8 28.8c-7.2 0-14.1-2.7-19.4-7.5L11.8 282.8C4.3 275.9 0 266.2 0 256s4.3-19.9 11.8-26.8l67.9-61.7c5.3-4.8 12.2-7.5 19.4-7.5c15.9 0 28.8 12.9 28.8 28.8l0 59.2H248V128l-59.2 0c-15.9 0-28.8-12.9-28.8-28.8c0-7.2 2.7-14.1 7.5-19.4l61.7-67.9C236.1 4.3 245.8 0 256 0s19.9 4.3 26.8 11.8zM270.9 489.4l61.7-67.9c2.2-2.4 3.3-5.4 3.3-8.6c0-7.1-5.8-12.8-12.8-12.8H188.8c-7.1 0-12.8 5.8-12.8 12.8c0 3.2 1.2 6.3 3.3 8.6l61.7 67.9c3.8 4.2 9.2 6.6 14.9 6.6s11.1-2.4 14.9-6.6zM489.4 270.9c4.2-3.8 6.6-9.2 6.6-14.9s-2.4-11.1-6.6-14.9l-67.9-61.7c-2.4-2.1-5.4-3.3-8.6-3.3c-7.1 0-12.8 5.8-12.8 12.8V323.2c0 7.1 5.8 12.8 12.8 12.8c3.2 0 6.3-1.2 8.6-3.3l67.9-61.7zm-57.1 73.6c-5.3 4.8-12.2 7.5-19.4 7.5c-15.9 0-28.8-12.9-28.8-28.8V188.8c0-15.9 12.9-28.8 28.8-28.8c7.2 0 14.1 2.7 19.4 7.5l67.9 61.7c7.5 6.9 11.8 16.6 11.8 26.8s-4.3 19.9-11.8 26.8l-67.9 61.7zM90.5 332.7c2.4 2.2 5.4 3.3 8.6 3.3c7.1 0 12.8-5.8 12.8-12.8l0-134.3c0-7.1-5.8-12.8-12.8-12.8c-3.2 0-6.3 1.2-8.6 3.3L22.6 241.1c-4.2 3.8-6.6 9.2-6.6 14.9s2.4 11.1 6.6 14.9l67.9 61.7z'
      
    ]
  };

  
    var faArrowsAlt = faUpDownLeftRight;
  

  
  

  var faToggleLargeOn = {
    prefix: 'fat',
    iconName: 'toggle-large-on',
    icon: [
      576,
      512,
      [],
      'e5b1',
      
      'M416 112a144 144 0 1 0 0 288 144 144 0 1 0 0-288zm0 304H160C71.6 416 0 344.4 0 256S71.6 96 160 96H416c88.4 0 160 71.6 160 160s-71.6 160-160 160zm-69.8-16C292.8 374.1 256 319.3 256 256s36.8-118.1 90.2-144H160C80.5 112 16 176.5 16 256s64.5 144 144 144H346.2z'
      
    ]
  };

  

  
  

  var faFileSignature = {
    prefix: 'fat',
    iconName: 'file-signature',
    icon: [
      576,
      512,
      [],
      'f573',
      
      'M64 496H320c26.5 0 48-21.5 48-48V433.3l7.5-1.9c2.9-.7 5.8-1.7 8.5-2.8V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H204.1c12.7 0 24.9 5.1 33.9 14.1L369.9 145.9c9 9 14.1 21.2 14.1 33.9v23.5l-16 16V179.9c0-1.3-.1-2.6-.2-3.9H248c-22.1 0-40-17.9-40-40V16.2c-1.3-.2-2.6-.2-3.9-.2H64C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48zM358.6 157.3L226.7 25.4c-.9-.9-1.8-1.7-2.7-2.4V136c0 13.3 10.7 24 24 24H361.1c-.8-1-1.6-1.9-2.4-2.7zM128 328c-1.1 0-2.1 .7-2.4 1.8l-15.5 56.7C105.4 403.9 89.6 416 71.6 416H64c-4.4 0-8-3.6-8-8s3.6-8 8-8h7.6c10.8 0 20.3-7.2 23.2-17.7l15.5-56.7c2.2-8 9.5-13.6 17.8-13.6s15.6 5.6 17.8 13.6l19.4 71.1 21.9-38.3c5.1-8.9 14.6-14.5 24.9-14.5s19.8 5.5 24.9 14.5l16.8 29.5C258 395.4 266 400 274.6 400H288c0-1.3 .1-2.7 .5-4l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9L493.2 139.7c15.6-15.6 40.9-15.6 56.6 0l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6L382.9 391.9c-4.1 4.1-9.2 7-14.9 8.4l-3.4-13.6 3.4 13.6-60.1 15c-.6 .1-1.1 .3-1.7 .3c-.7 .2-1.4 .3-2.2 .3H274.6c-14.4 0-27.6-7.7-34.7-20.2L223 366.4c-2.3-3.9-6.5-6.4-11-6.4s-8.8 2.4-11 6.4L176.7 409c-2.5 4.3-7.1 7-12.1 7c-6.3 0-11.8-4.2-13.5-10.3l-20.7-75.9c-.3-1.1-1.3-1.8-2.4-1.8zm180.4 54.3L304 399.8l17.6-4.4 42.5-10.6c2.8-.7 5.4-2.2 7.4-4.2L514.4 237.7l-48.3-48.3L323.2 332.3c-2 2.1-3.5 4.6-4.2 7.4l-10.6 42.5zM552.8 199.4c9.4-9.4 9.4-24.6 0-33.9L538.4 151c-9.4-9.4-24.6-9.4-33.9 0l-27.1 27.1 48.3 48.3 27.1-27.1z'
      
    ]
  };

  

  
  

  var faQuestion = {
    prefix: 'fat',
    iconName: 'question',
    icon: [
      320,
      512,
      [10067,10068,61736],
      '3f',
      
      'M32 152C32 94.6 78.6 48 136 48h48c57.4 0 104 46.6 104 104v6.3c0 28.6-13.9 55.4-37.3 71.9l-64.9 45.8c-21.2 15-33.9 39.4-33.9 65.4V368c0 4.4 3.6 8 8 8s8-3.6 8-8V341.3c0-20.8 10.1-40.3 27.1-52.3L260 243.2c27.6-19.5 44-51.2 44-85V152c0-66.3-53.7-120-120-120H136C69.7 32 16 85.7 16 152v8c0 4.4 3.6 8 8 8s8-3.6 8-8v-8zM160 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faUserNurseHair = {
    prefix: 'fat',
    iconName: 'user-nurse-hair',
    icon: [
      448,
      512,
      [],
      'e45d',
      
      'M112 76.9V144H336V76.9c0-6.4-3.8-12.1-9.6-14.7l-96-42c-4.1-1.8-8.7-1.8-12.8 0l-96 42c-5.8 2.5-9.6 8.3-9.6 14.7zM96 144V76.9c0-12.7 7.5-24.2 19.2-29.3l96-42c8.2-3.6 17.5-3.6 25.7 0l96 42C344.5 52.7 352 64.2 352 76.9V144v16 0 16c0 70.7-57.3 128-128 128s-128-57.3-128-128V160v0V144zm148.8 16c-16.8 29.6-48.2 48-82.5 48H116.6c13.8 46.3 56.6 80 107.4 80c61.9 0 112-50.1 112-112V160v0H244.8zM112 160v0 16c0 5.4 .4 10.8 1.1 16h49.2c25.3 0 48.7-12.1 63.4-32H112zm19.5 184.1c-4-4-8.9-5-12.5-3.9C59.4 358.2 16 413.7 16 479.2c0 8.1 6.6 14.7 14.7 14.7H417.3c8.1 0 14.7-6.6 14.7-14.7c0-65.5-43.4-121-103.1-139.1c-3.6-1.1-8.5-.1-12.5 3.9l-69.8 69.8c-12.5 12.5-32.8 12.5-45.3 0l-69.8-69.8zm-17.1-19.2c10.1-3.1 20.9 .4 28.4 7.9l69.8 69.8c6.2 6.2 16.4 6.2 22.6 0l69.8-69.8c7.5-7.5 18.3-11 28.4-7.9C399.8 344.9 448 406.4 448 479.2c0 17-13.8 30.7-30.7 30.7H30.7c-17 0-30.7-13.8-30.7-30.7c0-72.8 48.2-134.3 114.4-154.4zM224 40c4.4 0 8 3.6 8 8V72h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H232v24c0 4.4-3.6 8-8 8s-8-3.6-8-8V88H192c-4.4 0-8-3.6-8-8s3.6-8 8-8h24V48c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faClipboardPrescription = {
    prefix: 'fat',
    iconName: 'clipboard-prescription',
    icon: [
      384,
      512,
      [],
      'f5e8',
      
      'M192 0c-37.1 0-67.6 28-71.6 64H112C91.1 64 73.3 77.4 66.7 96H64C28.7 96 0 124.7 0 160V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64h-2.7c-6.6-18.6-24.4-32-45.3-32h-8.4c-4-36-34.5-64-71.6-64zM16 160c0-26.5 21.5-48 48-48v16c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V112c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V160zM136 72c0-30.9 25.1-56 56-56s56 25.1 56 56c0 4.4 3.6 8 8 8h16c17.7 0 32 14.3 32 32v16c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V112c0-17.7 14.3-32 32-32h16c4.4 0 8-3.6 8-8zm56 24a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM104 208c-4.4 0-8 3.6-8 8v80 80c0 4.4 3.6 8 8 8s8-3.6 8-8V304h52.7l64 64-42.3 42.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L240 379.3l42.3 42.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L251.3 368l42.3-42.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L240 356.7l-53.8-53.8C207.8 298.2 224 279 224 256c0-26.5-21.5-48-48-48H104zm64 80h0H112V224h64c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8z'
      
    ]
  };

  

  
  

  var faCirclePhone = {
    prefix: 'fat',
    iconName: 'circle-phone',
    icon: [
      512,
      512,
      ["phone-circle"],
      'e11b',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM188.8 136.4c5.8-1.6 11.9 1.4 14.2 7l20 48c2 4.9 .6 10.5-3.5 13.9l-24.7 20.2c-2.8 2.3-3.7 6.3-2.2 9.6c17.4 36.9 47.3 66.7 84.2 84.2c3.3 1.6 7.3 .7 9.6-2.2l20.2-24.7c3.4-4.1 9-5.5 13.9-3.5l48 20c5.6 2.3 8.6 8.4 7 14.2l-12 44c-1.4 5.2-6.2 8.8-11.6 8.8c-119.3 0-216-96.7-216-216c0-5.4 3.6-10.2 8.8-11.6l44-12zm29 .8c-5.4-13-19.6-19.9-33.2-16.2l-44 12c-12.2 3.3-20.6 14.4-20.6 27c0 128.1 103.9 232 232 232c12.6 0 23.7-8.5 27-20.6l12-44c3.7-13.6-3.3-27.8-16.2-33.2l-48-20c-11.4-4.8-24.6-1.5-32.4 8.1L278.2 302c-29.1-15.2-53-39.1-68.2-68.2l19.7-16.1c9.6-7.8 12.9-21 8.1-32.4l-20-48z'
      
    ]
  };

  
    var faPhoneCircle = faCirclePhone;
  

  
  

  var faSquareG = {
    prefix: 'fat',
    iconName: 'square-g',
    icon: [
      448,
      512,
      [],
      'e271',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM112 256c0 61.9 50.1 112 112 112c59.2 0 107.6-45.9 111.7-104H258.3c-4.4 0-8-3.6-8-8s3.6-8 8-8H336c8.7 0 16.3 7.2 15.7 16.5C347.3 331.2 291.8 384 224 384c-70.7 0-128-57.3-128-128s57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6c3.3 2.9 3.6 8 .6 11.3s-8 3.6-11.3 .6c-19.8-17.7-46-28.5-74.7-28.5c-61.9 0-112 50.1-112 112z'
      
    ]
  };

  

  
  

  var faFilter = {
    prefix: 'fat',
    iconName: 'filter',
    icon: [
      512,
      512,
      [],
      'f0b0',
      
      'M0 69.6C0 48.8 16.8 32 37.6 32H474.4C495.2 32 512 48.8 512 69.6c0 8.5-2.9 16.8-8.2 23.5L320 322.8V453.9c0 14.4-11.7 26.1-26.1 26.1c-5.5 0-10.9-1.7-15.4-5l-70.1-51c-10.3-7.5-16.5-19.6-16.5-32.3V322.8L8.2 93.1C2.9 86.4 0 78.2 0 69.6zM37.6 48C25.7 48 16 57.7 16 69.6c0 4.9 1.7 9.7 4.7 13.5L206.2 315c1.1 1.4 1.8 3.2 1.8 5v71.7c0 7.7 3.7 14.9 9.9 19.4l70.1 51c1.7 1.3 3.8 1.9 5.9 1.9c5.6 0 10.1-4.5 10.1-10.1V320c0-1.8 .6-3.6 1.8-5L491.3 83.1c3.1-3.8 4.7-8.6 4.7-13.5c0-11.9-9.7-21.6-21.6-21.6H37.6z'
      
    ]
  };

  

  
  

  var faDownToLine = {
    prefix: 'fat',
    iconName: 'down-to-line',
    icon: [
      384,
      512,
      ["arrow-alt-to-bottom"],
      'f34a',
      
      'M8 464l368 0c4.4 0 8 3.6 8 8s-3.6 8-8 8L8 480c-4.4 0-8-3.6-8-8s3.6-8 8-8zm176-99.3c2.1 2.1 5 3.3 8 3.3s5.9-1.2 8-3.3L331.8 232.6c2.7-2.7 4.2-6.4 4.2-10.2c0-8-6.5-14.4-14.4-14.4L248 208c-4.4 0-8-3.6-8-8l0-136c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16l0 136c0 4.4-3.6 8-8 8l-73.6 0c-8 0-14.4 6.5-14.4 14.4c0 3.8 1.5 7.5 4.2 10.2L184 364.7zm8 19.3c-7.2 0-14.2-2.9-19.3-8L40.9 243.9c-5.7-5.7-8.9-13.4-8.9-21.5C32 205.6 45.6 192 62.4 192l65.6 0 0-128c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 128 65.6 0c16.8 0 30.4 13.6 30.4 30.4c0 8.1-3.2 15.8-8.9 21.5L211.3 376c-5.1 5.1-12.1 8-19.3 8z'
      
    ]
  };

  
    var faArrowAltToBottom = faDownToLine;
  

  
  

  var faRouteHighway = {
    prefix: 'fat',
    iconName: 'route-highway',
    icon: [
      448,
      512,
      [],
      'f61a',
      
      'M228.1 1.1c-2.5-1.5-5.7-1.5-8.2 0l-16.5 9.9c-37.5 22.5-83.6 25.1-123.4 7c-15.5-7-33.7-2.4-43.9 11.2L12.9 60.1c-8.8 11.7-9.8 27.5-2.5 40.2C24.6 125.1 32 153.1 32 181.7V184v27c0 23.4-4.5 46.6-13.2 68.3L7.4 308C2.5 320.2 0 333.2 0 346.3c0 40.7 24 77.6 61.1 94.1l159.6 70.9c2.1 .9 4.4 .9 6.5 0l159.6-70.9C424 423.8 448 387 448 346.3c0-13.1-2.5-26.1-7.4-38.2l-11.5-28.7C420.5 257.6 416 234.4 416 211V184v-2.3c0-28.5 7.4-56.6 21.6-81.3c7.3-12.7 6.3-28.5-2.5-40.2L412 29.3c-10.2-13.6-28.5-18.3-43.9-11.2c-39.8 18.1-85.9 15.5-123.4-7L228.1 1.1zM400.1 176H47.9c-.9-29.4-9-58.1-23.6-83.6c-4.1-7.2-3.5-16.1 1.4-22.6L48.8 38.9c5.7-7.6 15.9-10.2 24.5-6.3c44.6 20.3 96.3 17.3 138.3-7.9L224 17.3l12.4 7.5c42 25.2 93.7 28.1 138.3 7.9c8.6-3.9 18.8-1.3 24.5 6.3l23.1 30.8c4.9 6.6 5.5 15.5 1.4 22.6c-14.6 25.5-22.7 54.3-23.6 83.6zM48 192H400v19c0 25.4 4.9 50.7 14.3 74.3L425.8 314c4.1 10.3 6.2 21.2 6.2 32.3c0 34.4-20.2 65.5-51.6 79.5L224 495.2 67.6 425.8C36.2 411.8 16 380.7 16 346.3c0-11.1 2.1-22 6.2-32.3l11.5-28.7C43.1 261.7 48 236.5 48 211V192z'
      
    ]
  };

  

  
  

  var faMemoCircleCheck = {
    prefix: 'fat',
    iconName: 'memo-circle-check',
    icon: [
      576,
      512,
      [],
      'e1d9',
      
      'M320 16H64C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48H311.2c5.8 5.5 12 10.6 18.5 15.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V198.6c-5.4 1.5-10.8 3.3-16 5.4V64c0-26.5-21.5-48-48-48zM64 136c0-4.4 3.6-8 8-8H312c4.4 0 8 3.6 8 8s-3.6 8-8 8H72c-4.4 0-8-3.6-8-8zm8 88H280c4.4 0 8 3.6 8 8s-3.6 8-8 8H72c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 96H216c4.4 0 8 3.6 8 8s-3.6 8-8 8H72c-4.4 0-8-3.6-8-8s3.6-8 8-8zM432 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm58.3 98.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-80 80c-3.1 3.1-8.2 3.1-11.3 0l-48-48c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L416 396.7l74.3-74.3z'
      
    ]
  };

  

  
  

  var faPodium = {
    prefix: 'fat',
    iconName: 'podium',
    icon: [
      448,
      512,
      [],
      'f680',
      
      'M288 16H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32zM176.7 56H168c-30.9 0-56 25.1-56 56v48H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H96V112c0-39.8 32.2-72 72-72h8.7C180.5 17.3 200.2 0 224 0h64c26.5 0 48 21.5 48 48s-21.5 48-48 48H224c-23.8 0-43.5-17.3-47.3-40zM73.6 455.2L45.5 208H61.6L89.4 453.4c2.8 24.3 23.3 42.6 47.7 42.6H310.9c24.4 0 44.9-18.3 47.7-42.6L386.4 208h16.1L374.5 455.2c-3.7 32.3-31 56.8-63.6 56.8H137.1c-32.6 0-59.9-24.4-63.6-56.8z'
      
    ]
  };

  

  
  

  var faDagger = {
    prefix: 'fat',
    iconName: 'dagger',
    icon: [
      384,
      512,
      [],
      'f6cb',
      
      'M200 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V128H72 40c-22.1 0-40 17.9-40 40s17.9 40 40 40s40-17.9 40-40V144H192 304v24c0 22.1 17.9 40 40 40s40-17.9 40-40s-17.9-40-40-40H312 200V8zM40 144H64v24c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24zm280 0h24c13.3 0 24 10.7 24 24s-10.7 24-24 24s-24-10.7-24-24V144zM144 176H128v8V413.9c0 8.2 2.5 16.2 7.2 22.9l50.2 71.7c1.5 2.1 3.9 3.4 6.6 3.4s5.1-1.3 6.6-3.4l50.2-71.7c4.7-6.7 7.2-14.7 7.2-22.9V184v-8H240v8V413.9c0 4.9-1.5 9.7-4.3 13.8L192 490.1l-43.7-62.4c-2.8-4-4.3-8.8-4.3-13.8V184v-8z'
      
    ]
  };

  

  
  

  var faFaceKissWinkHeart = {
    prefix: 'fat',
    iconName: 'face-kiss-wink-heart',
    icon: [
      512,
      512,
      [128536,"kiss-wink-heart"],
      'f598',
      
      'M344.8 479c-27.5 11-57.4 17-88.8 17C123.5 496 16 388.5 16 256S123.5 16 256 16s240 107.5 240 240c0 32.7-6.5 63.8-18.4 92.2c5.2 1.5 10.1 3.7 14.7 6.3C505 324.2 512 290.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c34.6 0 67.6-6.9 97.7-19.3c-3.6-3.9-6.7-8.5-8.8-13.7zM216.1 278.6c-.8 4.3 2.1 8.5 6.5 9.3c2.5 .5 5.1 1 9.4 2.1c5.8 1.5 13.4 3.7 21 6.7c7.6 3.1 14.8 6.8 19.8 11.1c5.1 4.3 7.2 8.3 7.2 12.2c0 2.6-1.6 5.7-6.6 9.2c-5 3.5-12 6.4-19.7 8.7c-7.6 2.3-15.2 3.8-21 4.8c-2.2 .4-4 .5-5.5 .7l0 0 0 0c-2.3 .2-4.1 .4-5.9 1.1c-3.1 1.1-5.3 4.2-5.3 7.5s2.2 6.4 5.3 7.5c1.8 .6 3.6 .8 5.9 1.1c1.6 .2 3.3 .3 5.5 .7c5.8 1 13.4 2.5 21 4.8c7.7 2.3 14.7 5.2 19.7 8.7c5 3.5 6.6 6.6 6.6 9.2c0 5-2.4 9.5-7.3 13.7c-5 4.3-12 7.9-19.5 10.8c-9.7 3.6-19.9 6.2-30.2 7.6c-4.4 .6-7.5 4.5-6.9 8.9s4.6 7.5 9 6.9l.1 0c11.5-1.6 22.9-4.4 33.7-8.4c8.4-3.2 17.4-7.6 24.5-13.7C290.4 403.5 296 395 296 384c0-10.2-6.4-17.5-13.4-22.4c-5.9-4.1-13.2-7.3-20.3-9.6c7.1-2.4 14.4-5.5 20.3-9.6c7-4.9 13.4-12.2 13.4-22.4c0-10.4-5.9-18.5-12.8-24.4c-6.9-5.9-15.8-10.4-24.2-13.7c-10.8-4.3-22.1-7.7-33.6-9.8c-4.3-.8-8.5 2.1-9.3 6.5zM176.4 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm159.3-24c14.6 0 30.2 8.6 41 27.9c2.2 3.9 7 5.2 10.9 3.1s5.2-7 3.1-10.9c-13.1-23.4-33.6-36.1-55-36.1s-41.8 12.7-55 36.1c-2.2 3.9-.8 8.7 3.1 10.9s8.7 .8 10.9-3.1c10.9-19.3 26.4-27.9 41-27.9zm97.9 163.1c-6.4-25-31.2-40.3-55.9-33.4c-24.5 6.9-38.5 32.9-32.1 57.7l20.2 78.8c3.3 13 16.8 20.8 29.7 17.1l74.9-21c24.5-6.9 38.5-32.9 32.1-57.7c-6.4-25-31.2-40.3-55.9-33.4L436.3 374l-2.8-11zM382 345c15.4-4.3 31.7 5.1 36.1 22l4.8 18.9c.5 2.1 1.9 3.9 3.8 4.9s4.1 1.4 6.2 .8l18.1-5.1c15.4-4.3 31.7 5.1 36.1 22c4.4 17-5.4 34-20.9 38.3l-74.9 21c-4.3 1.2-8.8-1.4-9.9-5.7L361 383.4c-4.4-17 5.4-34 20.9-38.3z'
      
    ]
  };

  
    var faKissWinkHeart = faFaceKissWinkHeart;
  

  
  

  var faWheatAwnSlash = {
    prefix: 'fat',
    iconName: 'wheat-awn-slash',
    icon: [
      640,
      512,
      [],
      'e338',
      
      'M477.7 13.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-48 48c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l48-48zm96 0c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-112 112-49.4 49.4c5.7-38.7-6.4-79.4-36.1-109.1L353.5 43.3c-6.2-6.2-16.4-6.2-22.6 0L319.5 54.6c-24.1 24.1-32.7 57.9-25.8 88.9L318.4 163c-18-30.7-13.9-70.7 12.5-97l11.3-11.3 11.3 11.3c32.5 32.5 40.9 80 25 120.2l-13.6 13.6 12.6 10 7.7-7.7c41.5-19.3 92.3-11.9 126.5 22.3l11.3 11.3L511.9 247c-15.8 15.8-36.7 23.7-57.4 23.4l18.3 14.4c18.5-3.4 36.2-12.2 50.5-26.5L534.5 247c6.2-6.2 6.2-16.4 0-22.6L523.2 213c-30.9-30.9-73.5-42.7-113.4-35.4l51.9-51.9 112-112zM197.3 367.4c5.7-38.7-6.4-79.4-36.1-109.1L149.8 247c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l27.4 27.4L66.3 498.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l76.9-76.9 29.2 29.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3C288.7 385.8 246 374 206.1 381.2l69-69-12.6-10-65.1 65.1zm-15.6 38.2c41.5-19.3 92.3-11.9 126.5 22.3l11.3 11.3-11.3 11.3c-31.2 31.2-81.9 31.2-113.1 0l-29.2-29.2 15.8-15.8zm-27.1 4.5l-27.4-27.4c-31.2-31.2-31.2-81.9 0-113.1l11.3-11.3 11.3 11.3c32.5 32.5 40.9 80 25 120.2l-20.3 20.3zM573.7 109.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-48 48c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l48-48zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  

  
  

  var faLanguage = {
    prefix: 'fat',
    iconName: 'language',
    icon: [
      640,
      512,
      [],
      'f1ab',
      
      'M312 80V432H64c-26.5 0-48-21.5-48-48V128c0-26.5 21.5-48 48-48H312zm16 0H576c26.5 0 48 21.5 48 48V384c0 26.5-21.5 48-48 48H328V80zm312 48c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128zM167.4 165c-1.2-3-4.2-5-7.4-5s-6.2 2-7.4 5l-72 176c-1.7 4.1 .3 8.8 4.4 10.4s8.8-.3 10.4-4.4L113 304h94l17.6 43c1.7 4.1 6.3 6 10.4 4.4s6-6.3 4.4-10.4l-72-176zM160 189.1L200.4 288H119.6L160 189.1zM488 168c0-4.4-3.6-8-8-8s-8 3.6-8 8v24H400c-4.4 0-8 3.6-8 8s3.6 8 8 8h80 52.9l-6.6 19.8c-9.2 27.6-25.4 52.2-46.6 71.4c-4.5-3.7-8.8-7.7-12.9-11.8l-29.1-29.1c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l29.1 29.1c3.8 3.8 7.7 7.4 11.7 10.8c-6.2 4.6-12.8 8.8-19.7 12.6L420.2 337c-3.9 2.1-5.3 7-3.2 10.9s7 5.3 10.9 3.2L455 336.2c8.8-4.8 17.2-10.3 25-16.4c6.2 4.5 12.6 8.7 19.2 12.5L532 350.9c3.8 2.2 8.7 .9 10.9-3s.9-8.7-3-10.9l-32.7-18.7c-5-2.9-9.9-6-14.6-9.3c22.2-20.8 39.1-46.9 48.9-76.2l8.3-24.8H560c4.4 0 8-3.6 8-8s-3.6-8-8-8H544 488V168z'
      
    ]
  };

  

  
  

  var faBreadSlice = {
    prefix: 'fat',
    iconName: 'bread-slice',
    icon: [
      512,
      512,
      [],
      'f7ec',
      
      'M64 240c-26.5 0-48-21.5-48-48c0-54.2 40.2-90.1 94.3-113.3C163.9 55.7 225.7 48 256 48s92.1 7.7 145.7 30.7C455.8 101.9 496 137.8 496 192c0 26.5-21.5 48-48 48c-8.8 0-16 7.2-16 16V432c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V256c0-8.8-7.2-16-16-16zm384 32V256c35.3 0 64-28.7 64-64C512 64 320 32 256 32S0 64 0 192c0 35.3 28.7 64 64 64v16V432c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V272z'
      
    ]
  };

  

  
  

  var faVectorSquare = {
    prefix: 'fat',
    iconName: 'vector-square',
    icon: [
      448,
      512,
      [],
      'f5cb',
      
      'M416 48c8.8 0 16 7.2 16 16V96c0 8.8-7.2 16-16 16H384c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h32zM384 32c-17.7 0-32 14.3-32 32v8H96V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64V96c0 17.7 14.3 32 32 32h8l0 256H32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32v-8H352v8c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V416c0-17.7-14.3-32-32-32h-8V128h8c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H384zM56 384l0-256h8c17.7 0 32-14.3 32-32V88H352v8c0 17.7 14.3 32 32 32h8V384h-8c-17.7 0-32 14.3-32 32v8H96v-8c0-17.7-14.3-32-32-32H56zM32 400H64c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H32c-8.8 0-16-7.2-16-16V416c0-8.8 7.2-16 16-16zm352 0h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H384c-8.8 0-16-7.2-16-16V416c0-8.8 7.2-16 16-16zM32 48H64c8.8 0 16 7.2 16 16V96c0 8.8-7.2 16-16 16H32c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faMoneyCheckDollar = {
    prefix: 'fat',
    iconName: 'money-check-dollar',
    icon: [
      576,
      512,
      ["money-check-alt"],
      'f53d',
      
      'M64 80c-26.5 0-48 21.5-48 48V384c0 26.5 21.5 48 48 48H512c26.5 0 48-21.5 48-48V128c0-26.5-21.5-48-48-48H64zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM264 304H472c4.4 0 8 3.6 8 8s-3.6 8-8 8H264c-4.4 0-8-3.6-8-8s3.6-8 8-8zm-8-88c0-4.4 3.6-8 8-8H472c4.4 0 8 3.6 8 8s-3.6 8-8 8H264c-4.4 0-8-3.6-8-8zM152 160v16.6c1.8 .2 3.6 .4 5.5 .7c4.8 .8 19.4 3.6 24.6 4.9c4.3 1.1 6.8 5.5 5.7 9.8s-5.5 6.8-9.8 5.7c-4.4-1.2-18.4-3.9-22.9-4.6c-14.1-2.2-26.5-.5-35.4 3.5c-8.9 4-13.9 10.1-15.1 17c-.9 5.4-.3 9.3 1.1 12.2c1.4 3 3.9 5.7 7.7 8.3c7.9 5.4 19.5 8.9 32.9 12.9l0 0 .3 .1c12.7 3.8 27.2 8.2 37.6 15.8c5.4 3.9 10.1 9 13 15.5c2.9 6.6 3.6 14.1 2.1 22.6c-2.5 14.4-11.9 24.3-24.5 29.7c-6.8 2.9-14.5 4.5-22.7 5l0 16.1c0 4.4-3.6 8-8 8s-8-3.6-8-8V335.4c-1.8-.2-3.6-.4-5.5-.7l0 0c-8.6-1.4-22.6-6.2-32-9.4l0 0 0 0c-1.9-.6-3.5-1.2-5-1.7c-4.2-1.4-6.5-5.9-5.1-10.1s5.9-6.5 10.1-5.1c1.7 .6 3.7 1.2 5.7 1.9l0 0 0 0 0 0c9.5 3.2 21.6 7.4 28.8 8.5c14.3 2.2 26.6 1 35.4-2.7c8.5-3.7 13.7-9.6 15.1-17.8c1-5.9 .4-10.2-1.1-13.5c-1.4-3.3-4-6.3-7.7-9c-7.8-5.7-19.5-9.4-32.9-13.5l-1.7-.5c-12.2-3.7-25.9-7.8-35.9-14.6c-5.4-3.7-10.2-8.4-13.2-14.7c-3-6.4-3.8-13.6-2.4-21.8c2.3-13.4 11.9-23.2 24.2-28.8c6.8-3.1 14.6-5 23-5.7V160c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  
    var faMoneyCheckAlt = faMoneyCheckDollar;
  

  
  

  var faDiceD4 = {
    prefix: 'fat',
    iconName: 'dice-d4',
    icon: [
      512,
      512,
      [],
      'f6d0',
      
      'M248.1 21.1L17.8 307c-1.4 1.7-2 3.8-1.7 6s1.4 4.1 3.1 5.4L248.1 492V21.1zm16 470.8L492.8 318.4c1.7-1.3 2.8-3.3 3.1-5.4s-.4-4.3-1.7-6L264.1 21.3V491.9zM256 0c7.3 0 14.1 3.3 18.7 8.9l232 288c4.1 5.1 5.9 11.5 5.1 18s-4.1 12.3-9.3 16.2l-232 176c-8.6 6.5-20.4 6.5-29 0l-232-176c-5.2-3.9-8.5-9.8-9.3-16.2s1.1-12.9 5.1-18l232-288C241.9 3.3 248.7 0 256 0z'
      
    ]
  };

  

  
  

  var faPersonDressBurst = {
    prefix: 'fat',
    iconName: 'person-dress-burst',
    icon: [
      640,
      512,
      [],
      'e544',
      
      'M440 56a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm96 0A56 56 0 1 0 424 56a56 56 0 1 0 112 0zM439.6 210.5c1.4-4.2-.9-8.7-5.1-10.1s-8.7 .9-10.1 5.1l-56 168c-.8 2.4-.4 5.1 1.1 7.2s3.9 3.3 6.5 3.3h32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h16v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h32c2.6 0 5-1.2 6.5-3.3s1.9-4.8 1.1-7.2l-56-168c-1.4-4.2-5.9-6.5-10.1-5.1s-6.5 5.9-5.1 10.1L572.9 368H544 496 464 416 387.1l52.5-157.5zM424 480V384h32v96c0 8.8-7.2 16-16 16s-16-7.2-16-16zm80-96h32v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V384zM476.2 144h7.7c30.7 0 58.7 17.6 72.1 45.2l60.9 126.2c1.9 4 6.7 5.6 10.7 3.7s5.6-6.7 3.7-10.7L570.3 182.3c-16-33.2-49.6-54.3-86.5-54.3h-7.7c-36.9 0-70.4 21.1-86.5 54.3L328.8 308.5c-1.9 4-.2 8.8 3.7 10.7s8.8 .3 10.7-3.7l60.9-126.2c13.3-27.7 41.3-45.2 72.1-45.2zM190.5 20.5c-5.7-12.4-23.4-12.4-29.1 0L130.1 88.7l-72.9-18C43.9 67.4 32.9 81.2 39.1 93.4L73 160.8l-53.7 46c-10 8.5-6 24.8 6.8 27.8l67.2 15.3L92 325c-.2 13.7 15.7 21.3 26.2 12.6L176 289.8l57.9 47.9c10.5 8.7 26.4 1.1 26.2-12.6l-1.4-75.2 67.2-15.3c12.8-2.9 16.8-19.2 6.8-27.8l-53.7-46 33.9-67.4c6.2-12.2-4.9-26-18.1-22.7l-72.9 18L190.5 20.5zM176 27.2l34.1 74.2c1.6 3.5 5.5 5.3 9.2 4.4l79.3-19.6-36.8 73c-1.7 3.3-.9 7.3 1.9 9.7l58.5 50.1-73.5 16.8c-3.7 .8-6.3 4.2-6.2 7.9l1.5 81.7-63-52.1c-3-2.4-7.2-2.4-10.2 0l-63 52.1 1.5-81.7c.1-3.8-2.5-7.1-6.2-7.9L29.7 218.9l58.5-50.1c2.8-2.4 3.6-6.4 1.9-9.7l-36.8-73 79.3 19.6c3.7 .9 7.6-.9 9.2-4.4L176 27.2z'
      
    ]
  };

  

  
  

  var faChartNetwork = {
    prefix: 'fat',
    iconName: 'chart-network',
    icon: [
      640,
      512,
      [],
      'f78a',
      
      'M224 16a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112c7.3 0 14.4-1.2 20.9-3.5l37.2 81.3C249.7 223.6 227 257 224.3 296H127.5c-3.9-31.6-30.9-56-63.5-56c-35.3 0-64 28.7-64 64s28.7 64 64 64c32.6 0 59.6-24.4 63.5-56h96.8c4.1 58.1 52.6 104 111.7 104c37.9 0 71.4-18.8 91.7-47.7l89.7 53.8c-3.5 7.9-5.4 16.6-5.4 25.8c0 35.3 28.7 64 64 64s64-28.7 64-64s-28.7-64-64-64c-20.4 0-38.6 9.6-50.3 24.5l-89.7-53.8c7.7-15.2 12.1-32.4 12.1-50.6c0-21.6-6.1-41.7-16.7-58.8L531 173.5c11.6 11.4 27.5 18.5 45 18.5c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64c0 12 3.3 23.3 9.1 32.9L422 232.2c-20.5-24.6-51.4-40.2-86-40.2c-13.8 0-27.1 2.5-39.3 7.1l-37.4-81.7C276.6 106 288 86.3 288 64c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64zM64 352a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm464 96c0-6.2 1.2-12.1 3.3-17.5l.6 .4 8.2-13.7-.6-.3c8.8-10.3 21.9-16.8 36.5-16.8c26.5 0 48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48zM576 80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM336 208a96 96 0 1 1 0 192 96 96 0 1 1 0-192z'
      
    ]
  };

  

  
  

  var faWifiExclamation = {
    prefix: 'fat',
    iconName: 'wifi-exclamation',
    icon: [
      640,
      512,
      [],
      'e2cf',
      
      'M289.2 81.1l14.9 208c.6 8.4 7.6 14.9 16 14.9s15.4-6.5 16-14.9l14.9-208C352.1 63.2 337.9 48 320 48s-32.1 15.2-30.8 33.1zm-16 1.1C271.3 55.1 292.8 32 320 32s48.7 23.1 46.8 50.2l-14.9 208C350.7 307 336.8 320 320 320s-30.7-13-31.9-29.7l-14.9-208zM122.5 270.4c35.2-33.1 78.7-57.5 127.1-69.7l1.2 16.2C206.2 228.6 166 251.3 133.5 282c-3.2 3-8.3 2.9-11.3-.3s-2.9-8.3 .3-11.3zm267.9-69.7c48.4 12.2 91.9 36.6 127.1 69.7c3.2 3 3.4 8.1 .3 11.3s-8.1 3.4-11.3 .3c-32.6-30.7-72.7-53.4-117.3-65.1l1.2-16.2zm235.8-25.4C564.7 113.5 484.6 70.2 395.1 54.5c-2-6.2-4.8-12.1-8.2-17.5c97.3 14.6 184.4 60.4 250.7 127c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0zM2.5 164C68.7 97.4 155.8 51.5 253.2 37c-3.4 5.4-6.2 11.3-8.2 17.5c-89.6 15.7-169.6 59-231.1 120.8c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3zM384 416a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zm-64 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faKidneys = {
    prefix: 'fat',
    iconName: 'kidneys',
    icon: [
      640,
      512,
      [],
      'f5fb',
      
      'M98.6 35.5C69 63 16 125.8 16 224c0 23.7 3.3 52.6 6.9 76.8c5.8 39.6 40.3 67.2 79.4 67.2c48.9 0 87.1-42.2 82.3-90.9l-4.1-41.2c-2.5-24.5 5.5-48.9 21.8-67.4L220.5 148c12.6-14.1 19.5-32.4 19.5-51.3c0-25.8-12.9-49.9-34.4-64.2l-3.4-2.3C188.3 21 171.9 16 155.2 16H152c-18.6 0-38.3 5.4-53.4 19.5zM488 16h-3.2c-16.8 0-33.1 5-47.1 14.2l-3.4 2.3-8.7-13.1 8.7 13.1C412.9 46.8 400 70.9 400 96.7c0 18.9 6.9 37.1 19.5 51.3l18.2 20.5c16.4 18.4 24.3 42.8 21.8 67.4l-4.1 41.2c-4.9 48.7 33.4 90.9 82.3 90.9c39.1 0 73.6-27.6 79.4-67.2c3.6-24.2 6.9-53.1 6.9-76.8c0-98.2-53-161-82.6-188.5C526.3 21.4 506.6 16 488 16zM87.7 23.8C106.5 6.3 130.5 0 152 0h3.2c19.9 0 39.4 5.9 55.9 16.9l3.4 2.3C240.4 36.5 256 65.6 256 96.7c0 22.8-8.4 44.8-23.5 61.9l-18.2 20.5c-5.4 6-9.6 12.9-12.7 20.2l41.7 17C270.3 227.4 288 253.7 288 283V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V283c0-22.7-13.8-43.2-34.8-51.8l-40.1-16.4c-1.1 6.4-1.4 13-.7 19.5l4.1 41.2c5.8 58.1-39.8 108.5-98.2 108.5c-46.5 0-88.2-32.9-95.3-80.9C3.5 278.7 0 248.9 0 224C0 119.6 56.4 52.8 87.7 23.8zm464.6 0C583.6 52.8 640 119.6 640 224c0 24.9-3.5 54.7-7.1 79.1c-7.1 48-48.8 80.9-95.3 80.9c-58.4 0-104-50.4-98.2-108.5l4.1-41.2c.5-5.4 .5-10.8-.2-16.1l-38.6 14c-22.1 8-36.9 29.1-36.9 52.6V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V284.8c0-30.3 18.9-57.3 47.4-67.7l40.3-14.6c-3.1-8.5-7.8-16.5-13.9-23.4l-18.2-20.5C392.4 141.6 384 119.6 384 96.7c0-31.2 15.6-60.2 41.5-77.5l3.4-2.3C445.5 5.9 464.9 0 484.8 0H488c21.5 0 45.5 6.3 64.3 23.8z'
      
    ]
  };

  

  
  

  var faFaceParty = {
    prefix: 'fat',
    iconName: 'face-party',
    icon: [
      640,
      512,
      [],
      'e383',
      
      'M10 .3C7.1-.5 4 .5 2 2.7S-.6 8.2 .6 11L73 188.6c-5.8 21.5-9 44-9 67.4c0 141.4 114.6 256 256 256c79.9 0 151.3-36.6 198.2-93.9c2.8-3.4 2.3-8.5-1.1-11.3s-8.5-2.3-11.3 1.1C461.8 461.7 394.9 496 320 496C187.5 496 80 388.5 80 256c0-14.1 1.2-27.9 3.5-41.4c1.6-9.2 3.7-18.2 6.3-26.9c15.3-51.7 47.6-96.1 90.3-126.8l0 0c5.9-4.2 11.9-8.2 18.1-11.8l0 0C234 28.1 275.6 16 320 16c99.6 0 185 60.7 221.4 147.1c1.7 4.1 6.4 6 10.5 4.3s6-6.4 4.3-10.5C517.4 64.7 426.3 0 320 0C267.1 0 217.9 16.1 177.1 43.6L10 .3zM160.4 55.8c-35.6 28.4-63.4 66-79.8 109.3L67.7 133.4c15.5-32.4 37.1-61.3 63.1-85.3l29.7 7.7zm-80.9-21l33 8.6C91.7 63.9 73.8 87.7 59.7 113.8l-13-31.9c9.7-16.6 20.7-32.3 32.8-47zm-17-4.4c-8.4 10.5-16.2 21.5-23.3 33L21.4 19.7 62.5 30.4zM198.6 219.9c10.9-19.3 26.4-27.9 41-27.9s30.2 8.6 41 27.9c2.2 3.9 7 5.2 10.9 3.1s5.2-7 3.1-10.9c-13.1-23.4-33.6-36.1-55-36.1s-41.8 12.7-55 36.1c-2.2 3.9-.8 8.7 3.1 10.9s8.7 .8 10.9-3.1zm160 0c10.9-19.3 26.4-27.9 41-27.9s30.2 8.6 41 27.9c2.2 3.9 7 5.2 10.9 3.1s5.2-7 3.1-10.9c-13.1-23.4-33.6-36.1-55-36.1s-41.8 12.7-55 36.1c-2.2 3.9-.8 8.7 3 10.9s8.7 .8 10.9-3.1zm-22.5 50.7c-.8 4.3 2.1 8.5 6.5 9.3c2.5 .5 5.1 1 9.4 2.1c5.8 1.5 13.4 3.7 21 6.7c7.6 3.1 14.8 6.8 19.8 11.1c5.1 4.3 7.2 8.3 7.2 12.2c0 2.6-1.6 5.7-6.6 9.2c-5 3.5-12 6.4-19.7 8.7c-7.6 2.3-15.2 3.8-21 4.8c-2.2 .4-4 .5-5.5 .7l0 0 0 0h0c-2.3 .2-4.1 .4-5.9 1.1c-3.1 1.1-5.3 4.2-5.3 7.5s2.2 6.4 5.3 7.5c1.8 .6 3.6 .8 5.9 1.1c1.6 .2 3.3 .3 5.5 .7c5.8 1 13.4 2.5 21 4.8c7.7 2.3 14.7 5.2 19.7 8.7c5 3.5 6.6 6.6 6.6 9.2c0 5-2.4 9.5-7.3 13.7c-5 4.3-12 7.9-19.5 10.8c-9.7 3.6-19.9 6.2-30.2 7.6c-4.4 .5-7.5 4.5-6.9 8.9s4.6 7.5 9 6.9l0 0c11.5-1.6 22.9-4.4 33.7-8.4c8.4-3.2 17.4-7.6 24.5-13.7C410.4 395.5 416 387 416 376c0-10.2-6.4-17.5-13.4-22.4c-.8-.6-1.6-1.1-2.5-1.6H584c30.9 0 56-25.1 56-56V264c0-30.9-25.1-56-56-56H560c-26.5 0-48 21.5-48 48s21.5 48 48 48h16c4.4 0 8-3.6 8-8s-3.6-8-8-8H560c-17.7 0-32-14.3-32-32s14.3-32 32-32h24c22.1 0 40 17.9 40 40v32c0 22.1-17.9 40-40 40H400.1c.9-.5 1.7-1.1 2.5-1.6c7-4.9 13.4-12.2 13.4-22.4c0-10.4-5.9-18.5-12.8-24.4c-6.9-5.9-15.8-10.4-24.2-13.7c-10.8-4.3-22.1-7.7-33.6-9.8c-4.3-.8-8.5 2.1-9.3 6.5z'
      
    ]
  };

  

  
  

  var faSparkle = {
    prefix: 'fat',
    iconName: 'sparkle',
    icon: [
      448,
      512,
      [],
      'e5d6',
      
      'M224 48c-1.6 0-3 1-3.6 2.4L163.2 190.8c-.8 2-2.4 3.6-4.4 4.4L18.4 252.4c-1.5 .6-2.4 2-2.4 3.6s1 3 2.4 3.6l140.4 57.2c2 .8 3.6 2.4 4.4 4.4l57.2 140.4c.6 1.5 2 2.4 3.6 2.4s3-1 3.6-2.4l57.2-140.4c.8-2 2.4-3.6 4.4-4.4l140.4-57.2c1.5-.6 2.4-2 2.4-3.6s-1-3-2.4-3.6L289.2 195.2c-2-.8-3.6-2.4-4.4-4.4L227.6 50.4c-.6-1.5-2-2.4-3.6-2.4zm-18.4-3.6C208.6 36.9 215.9 32 224 32s15.4 4.9 18.4 12.4l55.9 137.2 137.2 55.9c7.5 3.1 12.4 10.3 12.4 18.4s-4.9 15.4-12.4 18.4L298.4 330.4 242.4 467.6c-3.1 7.5-10.3 12.4-18.4 12.4s-15.4-4.9-18.4-12.4L149.6 330.4 12.4 274.4C4.9 271.4 0 264.1 0 256s4.9-15.4 12.4-18.4l137.2-55.9L205.6 44.4z'
      
    ]
  };

  

  
  

  var faChartWaterfall = {
    prefix: 'fat',
    iconName: 'chart-waterfall',
    icon: [
      512,
      512,
      [],
      'e0eb',
      
      'M16 40c0-4.4-3.6-8-8-8s-8 3.6-8 8V408c0 39.8 32.2 72 72 72H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H72c-30.9 0-56-25.1-56-56V40zM336 80c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V96c0-8.8 7.2-16 16-16zm-96 64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V160c0-8.8 7.2-16 16-16zm-96 96c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V256c0-8.8 7.2-16 16-16zM432 80c8.8 0 16 7.2 16 16V320c0 8.8-7.2 16-16 16s-16-7.2-16-16V96c0-8.8 7.2-16 16-16zM336 64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-64 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V160zm-96 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V256zM464 96c0-17.7-14.3-32-32-32s-32 14.3-32 32V320c0 17.7 14.3 32 32 32s32-14.3 32-32V96z'
      
    ]
  };

  

  
  

  var faListOl = {
    prefix: 'fat',
    iconName: 'list-ol',
    icon: [
      512,
      512,
      ["list-1-2","list-numeric"],
      'f0cb',
      
      'M40 48c0-4.4 3.6-8 8-8H80c4.4 0 8 3.6 8 8V208h40c4.4 0 8 3.6 8 8s-3.6 8-8 8H32c-4.4 0-8-3.6-8-8s3.6-8 8-8H72V56H48c-4.4 0-8-3.6-8-8zm71.2 270.7c-13.3-15.2-36.4-16.9-51.7-3.7L37.2 334.1c-3.4 2.9-8.4 2.5-11.3-.9s-2.5-8.4 .9-11.3l22.3-19.1c22-18.9 55.1-16.5 74.2 5.3c17.9 20.5 17.4 51.1-1.2 71L42.5 464H136c4.4 0 8 3.6 8 8s-3.6 8-8 8H24c-3.2 0-6.1-1.9-7.3-4.8s-.7-6.3 1.5-8.7l92.2-98.4c13-13.8 13.3-35.2 .8-49.5zM208 88H496c4.4 0 8 3.6 8 8s-3.6 8-8 8H208c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 160H496c4.4 0 8 3.6 8 8s-3.6 8-8 8H208c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 160H496c4.4 0 8 3.6 8 8s-3.6 8-8 8H208c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  
    var faList12 = faListOl;
  
    var faListNumeric = faListOl;
  

  
  

  var faSort = {
    prefix: 'fat',
    iconName: 'sort',
    icon: [
      320,
      512,
      ["unsorted"],
      'f0dc',
      
      'M19.5 186.7L144.6 54.6c4-4.2 9.6-6.6 15.4-6.6s11.4 2.4 15.4 6.6L300.5 186.7c2.2 2.3 3.5 5.4 3.5 8.7c0 7-5.6 12.6-12.6 12.6H28.6c-7 0-12.6-5.6-12.6-12.6c0-3.2 1.2-6.3 3.5-8.7zm-11.6-11C2.8 181 0 188.1 0 195.4C0 211.2 12.8 224 28.6 224H291.4c15.8 0 28.6-12.8 28.6-28.6c0-7.3-2.8-14.4-7.8-19.7L187 43.6C180 36.2 170.2 32 160 32s-20 4.2-27 11.6L7.8 175.7zM19.5 325.3c-2.2-2.3-3.5-5.4-3.5-8.7c0-7 5.6-12.6 12.6-12.6H291.4c7 0 12.6 5.6 12.6 12.6c0 3.2-1.2 6.3-3.5 8.7L175.4 457.4c-4 4.2-9.6 6.6-15.4 6.6s-11.4-2.4-15.4-6.6L19.5 325.3zm-11.6 11L133 468.4c7 7.4 16.8 11.6 27 11.6s20-4.2 27-11.6L312.2 336.3c5-5.3 7.8-12.4 7.8-19.7c0-15.8-12.8-28.6-28.6-28.6H28.6C12.8 288 0 300.8 0 316.6c0 7.3 2.8 14.4 7.8 19.7z'
      
    ]
  };

  
    var faUnsorted = faSort;
  

  
  

  var faLocust = {
    prefix: 'fat',
    iconName: 'locust',
    icon: [
      576,
      512,
      [],
      'e520',
      
      'M312 32c-4.4 0-8 3.6-8 8s3.6 8 8 8h32c119.3 0 216 96.7 216 216v2.9C542.8 241 513.4 224 480 224H444.6l-53.7-92c-1.4-2.4-3.9-3.9-6.7-4s-5.4 1.3-6.9 3.6l-56.7 86.9-58-86.9c-1.4-2.2-3.9-3.5-6.5-3.6s-5.1 1.1-6.6 3.2L181.1 224h-79C63.4 224 32 255.4 32 294.1c0 27.5 16 52.4 41 63.8l6.9 3.2L1.6 467.2c-2.6 3.6-1.9 8.6 1.7 11.2s8.6 1.9 11.2-1.7L94.8 367.9 136.6 387c13.2 6.1 26.8 11.2 40.7 15.4l-47.8 64.9c-2.6 3.6-1.9 8.6 1.7 11.2s8.6 1.9 11.2-1.7l48-65.1c1.1-1.6 1.6-3.4 1.5-5.2c25.3 6.3 51.4 9.6 77.7 9.6h19.9l-32.4 51.8c-2.3 3.7-1.2 8.7 2.5 11s8.7 1.2 11-2.5L308.4 416H480c6.2 0 12.3-.6 18.2-1.7l30.6 61.3c2 4 6.8 5.6 10.7 3.6s5.6-6.8 3.6-10.7l-29.3-58.6C550.2 396.2 576 361.1 576 320c0-2.1-.1-4.2-.2-6.2c.1-.6 .2-1.2 .2-1.8V264C576 135.9 472.1 32 344 32H312zM440.2 240H480c44.2 0 80 35.8 80 80s-35.8 80-80 80H304.1h-.3H269.7c-43.6 0-86.7-9.4-126.4-27.5l-38.8-17.7L189.2 240H319.9h.2H439.9h.3zm-56.5-88.8L426.1 224H336.1l47.5-72.8zm-127.9-1.3L305.1 224H201l54.7-74.1zM102.1 240h67.2L89.6 347.9l-10-4.6C60.4 334.6 48 315.3 48 294.1c0-29.9 24.2-54.1 54.1-54.1zM480 336a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faFilterCircleXmark = {
    prefix: 'fat',
    iconName: 'filter-circle-xmark',
    icon: [
      576,
      512,
      [],
      'e17b',
      
      'M0 37.6C0 16.8 16.8 0 37.6 0H474.4C495.2 0 512 16.8 512 37.6c0 8.5-2.9 16.8-8.2 23.5L396.1 195.7c-9.2 1.9-18.1 4.5-26.7 7.8L491.3 51.1c3.1-3.8 4.7-8.6 4.7-13.5c0-11.9-9.7-21.6-21.6-21.6H37.6C25.7 16 16 25.7 16 37.6c0 4.9 1.7 9.7 4.7 13.5L206.2 283c1.1 1.4 1.8 3.2 1.8 5v71.7c0 7.7 3.7 14.9 9.9 19.4l43.3 31.5c2.2 9 5.2 17.7 8.7 26.1l-61.5-44.7c-10.3-7.5-16.5-19.6-16.5-32.3V290.8L8.2 61.1C2.9 54.4 0 46.2 0 37.6zM560 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm205.7-50.3L443.3 368l50.3 50.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L432 379.3l-50.3 50.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L420.7 368l-50.3-50.3c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L432 356.7l50.3-50.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3z'
      
    ]
  };

  

  
  

  var faToiletPaperCheck = {
    prefix: 'fat',
    iconName: 'toilet-paper-check',
    icon: [
      640,
      512,
      [],
      'e5b2',
      
      'M17.3 471c.7-2.5 1.8-5 3.2-7.3l0-.1c1.3-2.3 2.5-4.7 3.7-7.1C63.6 379.2 64 274.7 64 192C64 86 107 0 160 0H480h16c35.1 0 63.4 25.9 81.9 59.9C596.8 94.5 608 141.2 608 192s-11.2 97.5-30.1 132.1c-18.6 34-46.8 59.9-81.9 59.9c-29.8 0-54.6-18.6-72.8-45c1.1-8.4 2.1-17.1 3-26.1C443.7 346.8 468.5 368 496 368c53 0 96-78.8 96-176s-43-176-96-176s-96 78.8-96 176c0 32.3-1.1 61.6-3.1 88.2l-.2 2.1c-7.7 103.1-27.3 164.4-39.5 193.7c-10 24-33.2 36.1-55.4 36.1H48c-11.5 0-22.2-6.2-27.8-16.2c-4.3-7.7-5.3-16.6-2.9-24.8zM160 16c-17.2 0-37 14.3-53.6 47.4C90.4 95.5 80 140.9 80 192c0 42.5-.1 91.8-5.7 140.4c-5.6 48.5-16.8 97.4-39.8 138.9c-.1 .2-.2 .3-.3 .5c-2.9 4.9-3 11-.2 16.1c2.8 5 8.2 8.1 13.9 8.1H301.9c16.8 0 33.5-9.1 40.6-26.2C357 435 384 348.9 384 192c0-50.8 11.2-97.5 30.1-132.1c9.6-17.6 21.9-33.1 36.3-43.9H160zM496 264c-8.7 0-15.7-4.2-20.6-9c-4.8-4.8-8.4-10.8-11.1-17.1c-5.4-12.6-8.3-28.8-8.3-45.9s2.9-33.3 8.3-45.9c2.7-6.3 6.3-12.3 11.1-17.1c4.9-4.8 11.9-9 20.6-9s15.7 4.2 20.6 9c4.8 4.8 8.4 10.8 11.1 17.1c5.4 12.6 8.3 28.8 8.3 45.9s-2.9 33.3-8.3 45.9c-2.7 6.3-6.3 12.3-11.1 17.1c-4.9 4.8-11.9 9-20.6 9zm24-72c0-30.9-10.7-56-24-56s-24 25.1-24 56s10.7 56 24 56s24-25.1 24-56zM301.7 173.7l-80 80c-3.1 3.1-8.2 3.1-11.3 0l-48-48c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L216 236.7l74.3-74.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3z'
      
    ]
  };

  

  
  

  var faCircleI = {
    prefix: 'fat',
    iconName: 'circle-i',
    icon: [
      512,
      512,
      [],
      'e111',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM168 128c-4.4 0-8 3.6-8 8s3.6 8 8 8h80V368H168c-4.4 0-8 3.6-8 8s3.6 8 8 8H344c4.4 0 8-3.6 8-8s-3.6-8-8-8H264V144h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H256 168z'
      
    ]
  };

  

  
  

  var faUserGroupCrown = {
    prefix: 'fat',
    iconName: 'user-group-crown',
    icon: [
      640,
      512,
      ["users-crown"],
      'f6a5',
      
      'M160.1 45.9L112 18.4V112H336V18.4L287.9 45.9c-5.3 3-11.8 2.8-16.8-.6L229.8 17.8c-1.7-1.1-3.7-1.8-5.8-1.8s-4.1 .6-5.8 1.8L176.9 45.3c-5 3.4-11.6 3.6-16.8 .6zM112 144c0 61.9 50.1 112 112 112s112-50.1 112-112V128H112v16zM238.7 4.4L280 32 333.1 1.7C335 .6 337.2 0 339.4 0c7 0 12.6 5.7 12.6 12.6V144c0 70.7-57.3 128-128 128s-128-57.3-128-128V12.6C96 5.7 101.7 0 108.6 0c2.2 0 4.4 .6 6.3 1.7L168 32 209.3 4.4C213.7 1.5 218.8 0 224 0s10.3 1.5 14.7 4.4zM16 472v8c0 8.8 7.2 16 16 16H416c8.8 0 16-7.2 16-16v-8c0-83.9-68.1-152-152-152H168C84.1 320 16 388.1 16 472zM0 472c0-92.8 75.2-168 168-168H280c92.8 0 168 75.2 168 168v8c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-8zM432 256c-27.7 0-53-10.1-72.6-26.7c1.5-2.4 3-4.8 4.4-7.3c1.3-2.3 2.5-4.6 3.7-6.9c17.1 15.5 39.7 25 64.6 25c53 0 96-43 96-96s-43-96-96-96c-17.5 0-33.9 4.7-48 12.8V42.8C398.5 35.9 414.8 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112zM609.3 512H471.4c2.9-5 5.1-10.3 6.5-16H609.3c8.1 0 14.7-6.6 14.7-14.7C624 401 559 336 478.7 336H426.6c-5.2-5.6-10.7-10.9-16.5-15.8c2.4-.1 4.7-.2 7.1-.2h61.4C567.8 320 640 392.2 640 481.3c0 17-13.8 30.7-30.7 30.7z'
      
    ]
  };

  
    var faUsersCrown = faUserGroupCrown;
  

  
  

  var faCircleArrowRight = {
    prefix: 'fat',
    iconName: 'circle-arrow-right',
    icon: [
      512,
      512,
      ["arrow-circle-right"],
      'f0a9',
      
      'M496 256A240 240 0 1 1 16 256a240 240 0 1 1 480 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM277.7 365.7l104-104c3.1-3.1 3.1-8.2 0-11.3l-104-104c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L356.7 248 136 248c-4.4 0-8 3.6-8 8s3.6 8 8 8l220.7 0-90.3 90.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0z'
      
    ]
  };

  
    var faArrowCircleRight = faCircleArrowRight;
  

  
  

  var faBreadSliceButter = {
    prefix: 'fat',
    iconName: 'bread-slice-butter',
    icon: [
      512,
      512,
      [],
      'e3e1',
      
      'M80 256V432c0 17.7 14.3 32 32 32H400c17.7 0 32-14.3 32-32V256c0-8.8 7.2-16 16-16c26.5 0 48-21.5 48-48c0-54.2-40.2-90.1-94.3-113.3C348.1 55.7 286.3 48 256 48s-92.1 7.7-145.7 30.7C56.2 101.9 16 137.8 16 192c0 26.5 21.5 48 48 48c8.8 0 16 7.2 16 16zm368 0v16V432c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V272 256c-35.3 0-64-28.7-64-64C0 64 192 32 256 32s256 32 256 160c0 35.3-28.7 64-64 64zM188.3 271c-9.4 9.4-9.4 24.6 0 33.9L239 355.7c9.4 9.4 24.6 9.4 33.9 0L323.7 305c9.4-9.4 9.4-24.6 0-33.9L273 220.3c-9.4-9.4-24.6-9.4-33.9 0L188.3 271zm96-62.1L335 259.7c15.6 15.6 15.6 40.9 0 56.6L284.3 367c-15.6 15.6-40.9 15.6-56.6 0L177 316.3c-15.6-15.6-15.6-40.9 0-56.6L227.7 209c15.6-15.6 40.9-15.6 56.6 0z'
      
    ]
  };

  

  
  

  var faMoonCloud = {
    prefix: 'fat',
    iconName: 'moon-cloud',
    icon: [
      640,
      512,
      [],
      'f754',
      
      'M479.5 48c-110.2 0-200.3 86.1-207.1 194.9c-5.2-1.2-10.5-2.1-15.9-2.5C264.5 124 361.2 32 479.5 32c6.4 0 12.7 .3 19 .8c7 .6 12.8 5.7 14.3 12.5s-1.6 13.9-7.7 17.3c-53.3 30.2-89.3 87.6-89.3 153.3c0 97.2 78.6 176 175.5 176c10.3 0 20.4-.9 30.1-2.6c6.9-1.2 13.8 2.2 17 8.5s1.9 13.8-3.1 18.7C595 455.8 540 480 479.5 480c-60.9 0-116.1-24.4-156.4-64c3.7-3.9 7.1-8 10.2-12.4c37.5 37.3 89.2 60.4 146.2 60.4c56.2 0 107.2-22.4 144.6-58.8c-10.7 1.9-21.7 2.8-32.9 2.8c-105.8 0-191.5-86-191.5-192c0-71.7 39.3-134.3 97.4-167.3c-5.8-.5-11.7-.7-17.6-.7zM80.3 297.4c-.2 2.2-1.3 4.2-3.1 5.5s-3.9 1.9-6.1 1.6c-2.3-.4-4.7-.5-7.2-.5c-26.5 0-48 21.5-48 48s21.5 48 48 48H248c30.9 0 56-25.1 56-56s-25.1-56-56-56c-10.7 0-20.8 3-29.3 8.3c-2.2 1.4-5 1.6-7.4 .5s-4.1-3.2-4.7-5.7c-6-29.1-31.8-51-62.7-51c-33.1 0-60.4 25.2-63.7 57.4zM144 224c35 0 64.8 22.5 75.6 53.8c8.7-3.7 18.3-5.8 28.4-5.8c39.8 0 72 32.2 72 72s-32.2 72-72 72H64c-35.3 0-64-28.7-64-64s28.7-64 64-64c.5 0 1.1 0 1.6 0c7.4-36.5 39.7-64 78.4-64z'
      
    ]
  };

  

  
  

  var faArrowTurnDownRight = {
    prefix: 'fat',
    iconName: 'arrow-turn-down-right',
    icon: [
      512,
      512,
      [],
      'e3d6',
      
      'M16 40c0-4.4-3.6-8-8-8s-8 3.6-8 8V224c0 39.8 32.2 72 72 72H484.7L346.3 434.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l152-152c3.1-3.1 3.1-8.2 0-11.3l-152-152c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L484.7 280H72c-30.9 0-56-25.1-56-56V40z'
      
    ]
  };

  

  
  

  var faGuitarElectric = {
    prefix: 'fat',
    iconName: 'guitar-electric',
    icon: [
      512,
      512,
      [127928],
      'f8be',
      
      'M458.1 16c6.8 0 13.2 2.7 18 7.5l2.8 2.8c12 12 12 31.5 0 43.5c-8.2 8.2-21.6 8.2-29.8 0l-3.4-3.4c-3.1-3.1-8.2-3.1-11.3 0L384 116.7V73.1c0-8 4-15.5 10.7-20L444 20.3c4.2-2.8 9.1-4.3 14.1-4.3zM368 132.7L258.7 242l-1.7-1.7c-31.9-32.2-20.7-64.5-10-82c4.8-7.9 4.8-18.7-1.7-25.3s-17.1-6.6-23.6 0l-29.9 30.2c-9.1 9.2-14.7 21.5-20.2 33.5c-1.2 2.6-2.3 5.1-3.5 7.6c-3.5 7.3-8.9 15.7-17.1 24c-24.7 25-64.7 40.2-89.6 47.7c-14.5 4.4-28.1 11.7-38.7 22.4c-30 30.4-30 79.6 0 110l79.9 80.8c30 30.4 78.7 30.4 108.8 0c10.7-10.8 17.9-24.5 22.2-39.1c7.5-25.2 22.5-65.6 47.2-90.6c10-10.1 20-16 28.3-19.3l1.1-.5c11.3-4.6 23-9.4 31.6-18l21.6-21.8c6.5-6.6 6.5-17.3 0-23.8s-17.3-6.6-25.8-3c-14.4 6.1-38.6 8.6-67.3-19.7L381.7 141.7l58.4-58.4c14.6 12.3 36.4 11.6 50.1-2.1c18.3-18.3 18.3-47.9 0-66.2l-2.8-2.8C479.7 4.4 469.1 0 458.1 0c-8.2 0-16.2 2.4-23 7L385.8 39.8C374.7 47.3 368 59.8 368 73.1v59.6zM218 445.5c-3.8 12.7-9.8 23.9-18.2 32.5c-23.8 24-62.2 24-86 0L33.9 397.2c-23.9-24.1-23.9-63.3 0-87.5c8.4-8.5 19.5-14.6 32-18.4c25.2-7.6 68.6-23.7 96.4-51.8c9.6-9.7 16-19.6 20.2-28.4c1.5-3.1 2.8-6 4.1-8.8c5.4-11.8 9.6-20.9 16.6-28L233 144.2c.1-.1 .2-.1 .2-.2c.1 0 .1 0 .2 0s.1 0 .2 0c0 0 .1 .1 .2 .2c.1 .1 .5 .5 .5 1.7c.1 1.3-.3 2.8-1.1 4.1c-6.1 10.1-13 25.4-13.2 43.6c-.2 18.8 6.8 38.9 25.6 57.9l11.8 11.9c16.4 16.6 32.6 25.3 48 28.3s28.5 .1 38.1-3.9c2.1-.9 4.4-1.3 6.1-1.1c1.6 .1 2.1 .6 2.1 .6c.2 .2 .3 .4 .3 .7s-.1 .5-.3 .7l-21.6 21.8c-6.1 6.2-15 9.9-27.4 14.9c-10 4.1-21.9 11.1-33.6 22.9c-27.7 28-43.6 71.9-51.2 97.3zM157.7 306.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l48 48c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-48-48zm-48 48c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l48 48c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-48-48z'
      
    ]
  };

  

  
  

  var faRectangleAd = {
    prefix: 'fat',
    iconName: 'rectangle-ad',
    icon: [
      576,
      512,
      ["ad"],
      'f641',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H512c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm199.3 68.7l80 176c1.8 4 0 8.8-4 10.6s-8.8 0-10.6-4L245 304H139l-19.7 43.3c-1.8 4-6.6 5.8-10.6 4s-5.8-6.6-4-10.6l80-176c1.3-2.9 4.1-4.7 7.3-4.7s6 1.8 7.3 4.7zM192 187.3L146.2 288h91.5L192 187.3zM376 224a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm56 10.7V168c0-4.4 3.6-8 8-8s8 3.6 8 8V280v64c0 4.4-3.6 8-8 8s-8-3.6-8-8V325.3c-13.2 16.3-33.4 26.7-56 26.7c-39.8 0-72-32.2-72-72s32.2-72 72-72c22.6 0 42.8 10.4 56 26.7z'
      
    ]
  };

  
    var faAd = faRectangleAd;
  

  
  

  var faNewspaper = {
    prefix: 'fat',
    iconName: 'newspaper',
    icon: [
      512,
      512,
      [128240],
      'f1ea',
      
      'M152 48c-22.1 0-40 17.9-40 40V424c0 15.7-6.4 29.8-16.8 40H440c30.9 0 56-25.1 56-56V88c0-22.1-17.9-40-40-40H152zM56 480c-30.9 0-56-25.1-56-56V192c0-35.3 28.7-64 64-64v16c-26.5 0-48 21.5-48 48V424c0 22.1 17.9 40 40 40s40-17.9 40-40V88c0-30.9 25.1-56 56-56H456c30.9 0 56 25.1 56 56V408c0 39.8-32.2 72-72 72H56zM352 104c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H360c-4.4 0-8-3.6-8-8zm0 64c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H360c-4.4 0-8-3.6-8-8zm0 64c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H360c-4.4 0-8-3.6-8-8zM160 296c0-4.4 3.6-8 8-8H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-4.4 0-8-3.6-8-8zm0 64c0-4.4 3.6-8 8-8H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-4.4 0-8-3.6-8-8zm24-248c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8H296c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8H184zm-24 8c0-13.3 10.7-24 24-24H296c13.3 0 24 10.7 24 24v96c0 13.3-10.7 24-24 24H184c-13.3 0-24-10.7-24-24V120z'
      
    ]
  };

  

  
  

  var faStomach = {
    prefix: 'fat',
    iconName: 'stomach',
    icon: [
      512,
      512,
      [],
      'f623',
      
      'M152 0c4.4 0 8 3.6 8 8V88c0 48.6 39.4 88 88 88h24c17.8-46.8 63-80 116-80c68.5 0 124 55.5 124 124V320c0 106-86 192-192 192c-71 0-134.9-48.8-173.4-86c-20.7-20-53.7-22.7-74.4-4.6c-10.3 9-16.2 22.1-16.2 35.8V484c0 15.5-12.5 28-28 28s-28-12.5-28-28V456c0-57.4 46.6-104 104-104h72c48.6 0 88-39.4 88-88V220c0-9.6 1.1-19 3.2-28H248c-57.4 0-104-46.6-104-104V8c0-4.4 3.6-8 8-8zM388 112c-59.6 0-108 48.4-108 108v44c0 9.1-1.2 17.9-3.3 26.2c24.6-8.8 44.7-10.3 62.2-7.5c20.4 3.3 36.6 12.5 51.2 20.8l.9 .5c15.1 8.6 28.6 16 45 17.9c15.3 1.8 34.2-1.2 60-14.7V220c0-59.6-48.4-108-108-108zM495.9 325.1c-24.4 11.6-44.2 14.7-61.8 12.7c-20.1-2.3-36.1-11.4-51-19.9l-.1-.1c-15.1-8.6-29.1-16.5-46.7-19.4c-17.1-2.8-38.2-.8-67.3 12C252 344.6 216.7 368 176 368H104c-48.6 0-88 39.4-88 88v28c0 6.6 5.4 12 12 12s12-5.4 12-12V457.2c0-18.3 7.9-35.7 21.7-47.8c27.9-24.4 70.3-19.7 96 5.1c38.1 36.8 98 81.5 162.3 81.5c95.5 0 173.2-76 175.9-170.9z'
      
    ]
  };

  

  
  

  var faSnowflake = {
    prefix: 'fat',
    iconName: 'snowflake',
    icon: [
      448,
      512,
      [10052,10054],
      'f2dc',
      
      'M232 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V108.7L165.7 58.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L216 131.3V242.1l-96-55.4L97.5 102.5c-1.1-4.3-5.5-6.8-9.8-5.7s-6.8 5.5-5.7 9.8l18.4 68.8L13.2 125.1c-3.8-2.2-8.7-.9-10.9 2.9s-.9 8.7 2.9 10.9l87.2 50.3L23.7 207.7c-4.3 1.1-6.8 5.5-5.7 9.8s5.5 6.8 9.8 5.7L112 200.6 208 256l-96 55.4L27.8 288.8c-4.3-1.1-8.7 1.4-9.8 5.7s1.4 8.7 5.7 9.8l68.8 18.4L5.2 373.1c-3.8 2.2-5.1 7.1-2.9 10.9s7.1 5.1 10.9 2.9l87.2-50.3L82 405.4c-1.1 4.3 1.4 8.7 5.7 9.8s8.7-1.4 9.8-5.7L120 325.3l96-55.4V380.7l-61.7 61.7c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L216 403.3V504c0 4.4 3.6 8 8 8s8-3.6 8-8V403.3l50.3 50.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L232 380.7V269.9l96 55.4 22.6 84.2c1.1 4.3 5.5 6.8 9.8 5.7s6.8-5.5 5.7-9.8l-18.4-68.8 87.2 50.3c3.8 2.2 8.7 .9 10.9-2.9s.9-8.7-2.9-10.9l-87.2-50.3 68.8-18.4c4.3-1.1 6.8-5.5 5.7-9.8s-5.5-6.8-9.8-5.7L336 311.4 240 256l96-55.4 84.2 22.6c4.3 1.1 8.7-1.4 9.8-5.7s-1.4-8.7-5.7-9.8l-68.8-18.4 87.2-50.3c3.8-2.2 5.1-7.1 2.9-10.9s-7.1-5.1-10.9-2.9l-87.2 50.3L366 106.6c1.1-4.3-1.4-8.7-5.7-9.8s-8.7 1.4-9.8 5.7L328 186.7l-96 55.4V131.3l61.7-61.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L232 108.7V8z'
      
    ]
  };

  

  
  

  var faBroomWide = {
    prefix: 'fat',
    iconName: 'broom-wide',
    icon: [
      512,
      512,
      [],
      'e5d1',
      
      'M509.7 13.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-152 152-24.2-24.2c-20.2-20.2-51.4-24.6-76.3-10.7L16.4 246.9C6.3 252.5 0 263.2 0 274.8c0 8.5 3.4 16.6 9.3 22.6L214.7 502.7c6 6 14.1 9.3 22.6 9.3c11.6 0 22.3-6.3 27.9-16.4L392.6 266.2c13.9-25 9.5-56.1-10.7-76.3l-24.2-24.2 152-152zM310.8 141.4l59.7 59.7c15.2 15.2 18.4 38.5 8 57.3l-27.4 49.4-147-146.9 49.4-27.4c18.7-10.4 42.1-7.1 57.3 8zM189.6 168.9L343 322.4 251.1 487.8c-2.8 5.1-8.1 8.2-13.9 8.2c-4.2 0-8.3-1.7-11.3-4.7L97 362.3l60.7-60.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L85.7 351l-65-65c-3-3-4.7-7-4.7-11.3c0-5.8 3.1-11.1 8.2-13.9l165.4-91.9z'
      
    ]
  };

  

  
  

  var faP = {
    prefix: 'fat',
    iconName: 'p',
    icon: [
      320,
      512,
      [112],
      '50',
      
      'M24 48H184c66.3 0 120 53.7 120 120s-53.7 120-120 120H16V56c0-4.4 3.6-8 8-8zM16 304H184c75.1 0 136-60.9 136-136s-60.9-136-136-136H24C10.7 32 0 42.7 0 56V296 472c0 4.4 3.6 8 8 8s8-3.6 8-8V304z'
      
    ]
  };

  

  
  

  var faTrashCanClock = {
    prefix: 'fat',
    iconName: 'trash-can-clock',
    icon: [
      576,
      512,
      [],
      'e2aa',
      
      'M157.4 27.3L134.4 64H313.6l-23-36.7c-4.4-7-12.1-11.3-20.4-11.3H177.7c-8.3 0-16 4.3-20.4 11.3zM115.6 64l28.2-45.2C151.1 7.1 163.9 0 177.7 0h92.5c13.8 0 26.6 7.1 33.9 18.8L332.4 64H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H115.6zM40 112c4.4 0 8 3.6 8 8V440c0 30.9 25.1 56 56 56H311.2c6.1 5.8 12.7 11.1 19.6 16H104c-39.8 0-72-32.2-72-72V120c0-4.4 3.6-8 8-8zM312 239.3V160c0-4.4 3.6-8 8-8s8 3.6 8 8v66c-5.6 4.1-10.9 8.5-16 13.3zm104-46.5c-5.4 .5-10.7 1.2-16 2.2V120c0-4.4 3.6-8 8-8s8 3.6 8 8v72.7zM136 160V416c0 4.4-3.6 8-8 8s-8-3.6-8-8V160c0-4.4 3.6-8 8-8s8 3.6 8 8zm96 0V416c0 4.4-3.6 8-8 8s-8-3.6-8-8V160c0-4.4 3.6-8 8-8s8 3.6 8 8zM432 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 64c4.4 0 8 3.6 8 8v64h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H432c-4.4 0-8-3.6-8-8V296c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faSausage = {
    prefix: 'fat',
    iconName: 'sausage',
    icon: [
      512,
      512,
      [],
      'f820',
      
      'M369.2 3.8c1.5-2.4 4-3.8 6.8-3.8h96c2.8 0 5.3 1.4 6.8 3.8s1.6 5.3 .3 7.8l-16 32c-2 4-6.8 5.6-10.7 3.6s-5.6-6.8-3.6-10.7L459.1 16H388.9l10.2 20.4c2 4 .4 8.8-3.6 10.7s-8.8 .4-10.7-3.6l-16-32c-1.2-2.5-1.1-5.4 .3-7.8zM16 400s0 0 0 0l0 59.1 20.4-10.2c4-2 8.8-.4 10.7 3.6s.4 8.8-3.6 10.7l-32 16c-2.5 1.2-5.4 1.1-7.8-.3s-3.8-4-3.8-6.8v-8V400 376c0-2.8 1.4-5.3 3.8-6.8s5.3-1.6 7.8-.3l32 16c4 2 5.6 6.8 3.6 10.7s-6.8 5.6-10.7 3.6L16 388.9v11zM424 80c-39.8 0-72 32.2-72 72c0 48.6-22.8 99-61.9 138.1S200.6 352 152 352c-39.8 0-72 32.2-72 72s32.2 72 72 72c92.8 0 178.4-42.5 239.9-104.1S496 244.8 496 152c0-39.8-32.2-72-72-72zm0-16c48.6 0 88 39.4 88 88c0 97.7-44.7 187.2-108.8 251.2S249.7 512 152 512c-48.6 0-88-39.4-88-88s39.4-88 88-88c43.7 0 90.2-20.6 126.8-57.2S336 195.7 336 152c0-48.6 39.4-88 88-88zM400 168c0 128.1-103.9 232-232 232c-4.4 0-8-3.6-8-8s3.6-8 8-8c119.3 0 216-96.7 216-216c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faFeatherPointed = {
    prefix: 'fat',
    iconName: 'feather-pointed',
    icon: [
      512,
      512,
      ["feather-alt"],
      'f56b',
      
      'M86.8 352.3c-13.5-49.9-13.3-134.2 61.9-209.3c43.1-43.1 104-73.2 165.4-93.5c61.2-20.2 121.7-30.1 162.4-33.4c5-.4 10.1 1.5 14 5.4s5.8 9.1 5.4 14c-3.3 40.8-13.2 101.2-33.4 162.4c-2.9 8.7-6 17.4-9.2 26.1h-154l51.2-51.2c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L110 390.7c-11.1-12.1-19.5-24.6-23.2-38.4zm23.2 61c13.2 12.3 28.1 22.7 45.5 27.4c54.1 14.6 144.7 14 224.8-66.1C471.5 283.5 505 120.5 511.9 36.8c.8-9.9-3-19.6-10-26.6s-16.7-10.8-26.6-10C391.5 7 228.5 40.5 137.4 131.6C57.3 211.7 56.7 302.3 71.3 356.4C76 373.8 86.4 388.8 98.7 402L2.3 498.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L110 413.3zM121.3 402l66-66H393c-7.5 9.7-15.4 18.8-23.9 27.3c-75.2 75.2-159.4 75.4-209.3 61.9c-13.8-3.7-26.3-12.1-38.4-23.2zm283.2-82H203.3l80-80H447c-11.7 28.2-25.7 55.5-42.4 80z'
      
    ]
  };

  
    var faFeatherAlt = faFeatherPointed;
  

  
  

  var faMace = {
    prefix: 'fat',
    iconName: 'mace',
    icon: [
      512,
      512,
      [],
      'f6f8',
      
      'M328.1 85.7L303.2 10.9C301 4.4 294.9 0 288 0s-13 4.4-15.2 10.9L247.9 85.7c-47.3 13.7-84.6 51-98.3 98.3L74.9 208.8C68.4 211 64 217.1 64 224s4.4 13 10.9 15.2l74.7 24.9c13.7 47.3 51 84.6 98.3 98.3l24.9 74.7c2.2 6.5 8.3 10.9 15.2 10.9s13-4.4 15.2-10.9l24.9-74.7c47.3-13.7 84.6-51 98.3-98.3l74.7-24.9c6.5-2.2 10.9-8.3 10.9-15.2s-4.4-13-10.9-15.2l-74.7-24.9c-13.7-47.3-51-84.6-98.3-98.3zm-65 5.1L288 16l24.9 74.7c1.7 5 5.7 8.8 10.7 10.3c42 12.2 75.2 45.3 87.3 87.3c1.5 5.1 5.3 9.1 10.3 10.7L496 224l-74.7 24.9c-5 1.7-8.9 5.7-10.3 10.7c-12.2 42-45.3 75.2-87.3 87.3c-5.1 1.5-9.1 5.3-10.7 10.3L288 432l-24.9-74.7c-1.7-5-5.7-8.8-10.7-10.3c-42-12.2-75.2-45.3-87.3-87.3c-1.5-5.1-5.3-9.1-10.3-10.7L80 224l74.7-24.9c5-1.7 8.8-5.7 10.3-10.7c12.2-42 45.3-75.2 87.3-87.3c5.1-1.5 9.1-5.3 10.7-10.3zM336 224a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-48-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM57.9 502.1L189.9 370.1c-4.5-3-8.8-6.2-13-9.6L46.6 490.7c-3.4 3.4-7.9 5.3-12.7 5.3C24 496 16 488 16 478.1c0-4.8 1.9-9.3 5.3-12.7L151.5 335.1c-3.4-4.2-6.6-8.5-9.6-13L9.9 454.1c-6.4 6.4-9.9 15-9.9 24C0 496.8 15.2 512 33.9 512c9 0 17.6-3.6 24-9.9z'
      
    ]
  };

  

  
  

  var faTemperatureArrowDown = {
    prefix: 'fat',
    iconName: 'temperature-arrow-down',
    icon: [
      576,
      512,
      ["temperature-down"],
      'e03f',
      
      'M112 80c0-35.3 28.7-64 64-64s64 28.7 64 64V243.8c0 8.4 4.4 15.7 10.7 20.3C283 287.3 304 325.2 304 368c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-42.8 21-80.7 53.3-104c6.3-4.6 10.7-11.9 10.7-20.3V80zM176 0C131.8 0 96 35.8 96 80V243.8c0 2.7-1.4 5.4-4 7.3c-36.3 26.1-60 68.8-60 117c0 79.5 64.5 144 144 144s144-64.5 144-144c0-48.2-23.7-90.8-60-117c-2.6-1.9-4-4.6-4-7.3V80c0-44.2-35.8-80-80-80zM128 368a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0c0-32.6-24.4-59.6-56-63.5V264c0-4.4-3.6-8-8-8s-8 3.6-8 8v40.5c-31.6 3.9-56 30.9-56 63.5c0 35.3 28.7 64 64 64s64-28.7 64-64zm130.3 29.6l80 80c3.1 3.1 8.2 3.1 11.3 0l80-80c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L464 452.7V40c0-4.4-3.6-8-8-8s-8 3.6-8 8V452.7l-66.3-66.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3z'
      
    ]
  };

  
    var faTemperatureDown = faTemperatureArrowDown;
  

  
  

  var faBookmarkSlash = {
    prefix: 'fat',
    iconName: 'bookmark-slash',
    icon: [
      640,
      512,
      [],
      'e0c2',
      
      'M512 56c0-30.9-25.1-56-56-56H184c-18.1 0-34.1 8.6-44.4 21.9l12.6 9.9C159.5 22.2 171 16 184 16H456c22.1 0 40 17.9 40 40V303.2l16 12.6V56zM144 485.8v-277l-16-12.6V485.8c0 14.5 11.8 26.2 26.2 26.2c5.4 0 10.6-1.7 15.1-4.7L320 401.8 470.7 507.3c4.4 3.1 9.7 4.7 15.1 4.7c10.4 0 19.4-6 23.6-14.8L496 486.6c-.5 5.2-4.9 9.4-10.2 9.4c-2.1 0-4.2-.6-5.9-1.9L324.6 385.4c-2.8-1.9-6.4-1.9-9.2 0L160.1 494.1c-1.7 1.2-3.8 1.9-5.9 1.9c-5.7 0-10.2-4.6-10.2-10.2zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  

  
  

  var faA = {
    prefix: 'fat',
    iconName: 'a',
    icon: [
      384,
      512,
      [97],
      '41',
      
      'M199.4 36.9c-1.3-3-4.2-4.9-7.4-4.9s-6.1 1.9-7.4 4.9L.6 468.9c-1.7 4.1 .2 8.8 4.2 10.5s8.8-.2 10.5-4.2L61 368H323l45.6 107.1c1.7 4.1 6.4 6 10.5 4.2s6-6.4 4.2-10.5l-184-432zM316.2 352H67.8L192 60.4 316.2 352z'
      
    ]
  };

  

  
  

  var faRoadLock = {
    prefix: 'fat',
    iconName: 'road-lock',
    icon: [
      640,
      512,
      [],
      'e567',
      
      'M217.4 32C194 32 173 46.6 164.9 68.6L40.4 404.6C26.9 441.1 54 480 93 480H384V464H328V408c0-4.4-3.6-8-8-8s-8 3.6-8 8v56H93c-27.9 0-47.2-27.8-37.5-53.9l124.4-336C185.7 58.4 200.7 48 217.4 48H312v56c0 4.4 3.6 8 8 8s8-3.6 8-8V48h94.6c16.7 0 31.7 10.4 37.5 26.1l33.8 91.2c5.1-1.6 10.3-2.9 15.7-3.8l-34.4-93C467 46.6 446 32 422.6 32H217.4zM328 200c0-4.4-3.6-8-8-8s-8 3.6-8 8V312c0 4.4 3.6 8 8 8s8-3.6 8-8V200zm200 8c26.5 0 48 21.5 48 48v64H480V256c0-26.5 21.5-48 48-48zm-64 48v64H448c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H592V256c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-16 80h16 16 96 16 16c8.8 0 16 7.2 16 16V480c0 8.8-7.2 16-16 16H448c-8.8 0-16-7.2-16-16V352c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faInputPipe = {
    prefix: 'fat',
    iconName: 'input-pipe',
    icon: [
      640,
      512,
      [],
      'e1be',
      
      'M64 80c-26.5 0-48 21.5-48 48V384c0 26.5 21.5 48 48 48H576c26.5 0 48-21.5 48-48V128c0-26.5-21.5-48-48-48H64zM0 128C0 92.7 28.7 64 64 64H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm128 40V344c0 4.4-3.6 8-8 8s-8-3.6-8-8V168c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faDeer = {
    prefix: 'fat',
    iconName: 'deer',
    icon: [
      512,
      512,
      [129420],
      'f78e',
      
      'M240 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V32c0 26.5 21.5 48 48 48h24 8 6.1l-41.5 20.7c-7.7 3.9-12.6 11.8-12.6 20.4c0 12.6 10.2 22.8 22.8 22.8H312h6.5l-11.3 32H112h0H88c-48.6 0-88 39.4-88 88v48c0 4.4 3.6 8 8 8s8-3.6 8-8V264c0-39.8 32.2-72 72-72h24 0H312.9c3.4 0 6.4-2.1 7.5-5.3l15-42.7h.6c4.4 0 8-3.6 8-8s-3.6-8-8-8h-6.2H312 278.8c-3.8 0-6.8-3.1-6.8-6.8c0-2.6 1.5-5 3.8-6.1l51-25.5c12.6-6.3 26.4-9.5 40.4-9.5c24 0 47 9.5 63.9 26.5l57.2 57.2c4.9 4.9 7.6 11.5 7.6 18.3c0 14.3-11.6 25.9-25.9 25.9H400c-3.6 0-6.8 2.4-7.7 5.9L370 295.7c-1.3 4.8-2 9.8-2 14.7V480c0 8.8-7.2 16-16 16H312c-8.8 0-16-7.2-16-16V352c0-4.4-3.6-8-8-8H263.7c-29.1 0-57.3-9.9-80-28l-2.7-2.2c-2.6-2.1-6.2-2.3-9-.7s-4.4 4.9-3.8 8.2l3.6 21.6c2.2 13-3.5 26-14.4 33.3c-18.2 12.1-26.3 34.8-19.8 55.7l13.4 43.4c3.2 10.3-4.5 20.7-15.3 20.7H97.7c-7 0-13.2-4.6-15.3-11.3L60.2 412.3c-2.5-8-2.4-16.5 .3-24.4l8.8-26.3c1.8-5.5 2.8-11.2 2.8-17c0-18-9-34.8-24-44.8l-4.2-2.8C39 293.7 35 289.5 32 284.7v23.4c1 .7 1.9 1.4 3 2.1l4.2 2.8c10.5 7 16.9 18.9 16.9 31.5c0 4.1-.7 8.1-1.9 12l-8.8 26.3c-3.7 11.1-3.8 23-.4 34.2l22.3 72.4C71.3 502.8 83.7 512 97.7 512h37.8c21.5 0 36.9-20.8 30.6-41.4l-13.4-43.4c-4.4-14.1 1.1-29.4 13.4-37.7c16.2-10.8 24.5-30.1 21.3-49.3l-.4-2.3C210 352.3 236.5 360 263.7 360H280V480c0 17.7 14.3 32 32 32h40c17.7 0 32-14.3 32-32V310.4c0-3.6 .5-7.1 1.4-10.5L406.1 224h63.9c23.2 0 41.9-18.8 41.9-41.9c0-11.1-4.4-21.8-12.3-29.7L442.5 95.2c-5.8-5.8-12.2-10.9-19.1-15.2h.6c26.5 0 48-21.5 48-48V8c0-4.4-3.6-8-8-8s-8 3.6-8 8V32c0 17.7-14.3 32-32 32h-8H367.2 339.8c7.6-8.5 12.2-19.7 12.2-32V8c0-4.4-3.6-8-8-8s-8 3.6-8 8V32c0 17.7-14.3 32-32 32h-8H272c-17.7 0-32-14.3-32-32V8zM416 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faPersonSkiing = {
    prefix: 'fat',
    iconName: 'person-skiing',
    icon: [
      512,
      512,
      [9975,"skiing"],
      'f7c9',
      
      'M290.1 280.8c5.4 5.4 6.2 13.8 2 20.2l-49.4 74.2c-4.9 7.4-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4L326 307.8c8.5-12.7 6.8-29.6-4-40.4l-53.8-53.8c-2-2-3.4-4.4-4.1-7L301 223.7l32.4 32.4c16.2 16.2 18.7 41.5 6 60.6l-56.7 85.1c-4.1 6.2-10 10.5-16.6 12.6l151.1 74.5c15.1 7.4 32.4 8.6 48.4 3.4l36-11.9c4.2-1.4 8.7 .9 10.1 5.1s-.9 8.7-5.1 10.1l-36 11.9c-19.9 6.6-41.6 5.1-60.5-4.2L4.5 303.2c-4-2-5.6-6.8-3.6-10.7s6.8-5.6 10.7-3.6L225.8 394.5c-3.2-9.1-2.2-19.6 3.6-28.3l49.4-74.2-75.1-75.1c-13.3-13.3-19.3-30.4-18.7-47.2l16.3 7.6c1.2 10.2 5.6 20.2 13.8 28.3l75.1 75.1zm15.8-107.7L337.6 159c4.1-1.8 8.8-1.8 13 0s7.3 5.3 8.7 9.6l7.4 22.2c2.2 6.7 6.6 12.5 12.4 16.4l4.7 2.2c.9 .4 1.7 1 2.3 1.6l54.7 27.4c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5L403 183.6c-3.8-1.9-6.7-5.2-8-9.3l-17.1-51.2c-8.7-26.2-37.7-39.6-63.4-29.4l-83.4 33.4c-4 1.6-7.7 3.7-10.9 6.1l85.7 39.9zm19.2 9L351 194l-1.7-5.2-5.1-15.2-14.7 6.5-4.3 1.9zm46.2 39.1L140.1 113.6l-13 25.9c-2 4-6.8 5.6-10.7 3.6s-5.6-6.8-3.6-10.7l12.8-25.5-25-11.6c-4-1.9-5.7-6.6-3.9-10.6s6.6-5.7 10.6-3.9l25.4 11.8 12.1-24.1c2-4 6.8-5.6 10.7-3.6s5.6 6.8 3.6 10.7L147.3 99.3l56.9 26.5c5.8-5.6 12.8-10.3 20.9-13.5l83.4-33.4c34.2-13.7 72.8 4.2 84.5 39.2l17.1 51.2 52.1 26.1c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-58.1-29c-1.5-.7-2.9-1.5-4.3-2.4zM428.7 80a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-48-32a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  
    var faSkiing = faPersonSkiing;
  

  
  

  var faZ = {
    prefix: 'fat',
    iconName: 'z',
    icon: [
      384,
      512,
      [122],
      '5a',
      
      'M0 40c0-4.4 3.6-8 8-8H376c3.1 0 6 1.8 7.3 4.6s.8 6.2-1.2 8.5L25.3 464H376c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-3.1 0-6-1.8-7.3-4.6s-.9-6.2 1.2-8.5L358.7 48H8c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faPinball = {
    prefix: 'fat',
    iconName: 'pinball',
    icon: [
      448,
      512,
      [],
      'e229',
      
      'M352 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-176a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm46 423.7l0 0c3.7-6.7 2.1-15.4-4.2-20.3l-.2-.2-.2-.2L147.4 226.7l0 0c-33.8-28.4-84.3-24-112.7 9.9s-24 84.4 9.9 112.8c7.6 6.4 16.6 11.4 26.6 14.7l0 0L379 463.2l0 0c7.4 2.4 15.4-.9 19-7.5zM34.3 361.6c-40.6-34.1-46-94.7-11.9-135.3s94.6-45.9 135.2-11.8l246 208.3c12.6 9.8 15.8 27.1 8.4 40.6c-7.2 13.2-23.1 19.9-37.9 15L66.3 379.3c-12.1-3.9-22.8-10-32-17.7zM80 288a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z'
      
    ]
  };

  

  
  

  var faFaceConfused = {
    prefix: 'fat',
    iconName: 'face-confused',
    icon: [
      512,
      512,
      [],
      'e36d',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM163 392.8l-5.6 5.1c-3.3 3-8.3 2.7-11.3-.5s-2.7-8.3 .5-11.3l5.6-5.1c54.5-49.5 125.5-77 199.1-77H360c4.4 0 8 3.6 8 8s-3.6 8-8 8h-8.7c-69.7 0-136.8 26-188.3 72.8zM160.4 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faDemocrat = {
    prefix: 'fat',
    iconName: 'democrat',
    icon: [
      640,
      512,
      [],
      'f747',
      
      'M84.6 16.1l0 0c-2.2 4-5.4 10.2-8.1 16.6C73.6 39.4 72 44.9 72 48c0 13 8.4 25.3 18.2 34.9c2.9 2.9 3.2 7.5 .6 10.7L27.3 172.8C20 181.8 16 193.3 16 205c0 27.9 22.7 51 50.4 51c12 0 23.7-4.3 32.8-12.1l39.6-33.9c2-1.7 4.7-2.3 7.3-1.7s4.6 2.6 5.5 5L189.6 320H560V216c0-30.9-25-55.9-55.8-56H456v0H269.5c-10.8 0-21.1-4.3-28.6-12.1L192.8 98.7c-1.5-1.6-2.4-3.7-2.3-5.9s1.1-4.3 2.7-5.7C204.5 77.3 216 63.2 216 48c0-3.1-1.6-8.6-4.5-15.4c-2.7-6.4-6-12.6-8.1-16.6l0 0 0 0 0 0c0 0-.1 0-.2 0c-.1 0-.2 0-.3 .1l-53.6 46c-3 2.6-7.4 2.6-10.4 0l-53.6-46c-.1-.1-.2-.1-.3-.1c-.1 0-.2 0-.2 0s0 0 0 0zM553.1 163.3C567.2 176.4 576 195.2 576 216V328 472c0 22.1-17.9 40-40 40H504c-22.1 0-40-17.9-40-40V400H288v72c0 22.1-17.9 40-40 40H216c-22.1 0-40-17.9-40-40V329.4l-35.6-99.7L109.6 256c-12 10.3-27.4 16-43.2 16C29.6 272 0 241.6 0 205c0-15.3 5.2-30.3 14.8-42.3L74 89C64.8 78.7 56 64.6 56 48c0-6.7 2.9-14.9 5.8-21.6c3-7.1 6.5-13.8 8.8-18C73.5 3.1 79 0 84.9 0c3.9 0 7.7 1.4 10.7 4L144 45.5 192.4 4c3-2.6 6.8-4 10.7-4c5.8 0 11.3 3.1 14.3 8.4c2.3 4.2 5.8 10.9 8.8 18c2.8 6.7 5.8 14.9 5.8 21.6c0 18.9-11.5 34.7-22 45.4l42.4 43.4c4.5 4.6 10.7 7.2 17.2 7.2H504c.1 0 .1 0 .2 0H528c61.9 0 112 50.1 112 112v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-44.3-30.1-81.7-70.9-92.7zM192 472c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V392c0-4.4 3.6-8 8-8H472c4.4 0 8 3.6 8 8v80c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V336H192V472zm72-264v24h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H264v24c0 4.4-3.6 8-8 8s-8-3.6-8-8V248H224c-4.4 0-8-3.6-8-8s3.6-8 8-8h24V208c0-4.4 3.6-8 8-8s8 3.6 8 8zm104-8c4.4 0 8 3.6 8 8v24h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H376v24c0 4.4-3.6 8-8 8s-8-3.6-8-8V248H336c-4.4 0-8-3.6-8-8s3.6-8 8-8h24V208c0-4.4 3.6-8 8-8zm120 8v24h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H488v24c0 4.4-3.6 8-8 8s-8-3.6-8-8V248H448c-4.4 0-8-3.6-8-8s3.6-8 8-8h24V208c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faLinkSimpleSlash = {
    prefix: 'fat',
    iconName: 'link-simple-slash',
    icon: [
      640,
      512,
      [],
      'e1ce',
      
      'M13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7zM608 256c0-88.4-71.6-160-160-160H360c-4.4 0-8 3.6-8 8s3.6 8 8 8h88c79.5 0 144 64.5 144 144c0 36.3-13.5 69.5-35.7 94.9l12.6 9.9C593.3 332.7 608 296.1 608 256zm-136 8c4.4 0 8-3.6 8-8s-3.6-8-8-8H426.1l20.3 16H472zM193.7 248H168c-4.4 0-8 3.6-8 8s3.6 8 8 8h45.9l-20.3-16zm-110-86.9l-12.6-9.9C46.7 179.3 32 215.9 32 256c0 88.4 71.6 160 160 160h88c4.4 0 8-3.6 8-8s-3.6-8-8-8H192c-79.5 0-144-64.5-144-144c0-36.3 13.5-69.5 35.7-94.9z'
      
    ]
  };

  

  
  

  var faPickaxe = {
    prefix: 'fat',
    iconName: 'pickaxe',
    icon: [
      512,
      512,
      [],
      'e5bf',
      
      'M477.3 367.8l.1 0 .1 0c38-94 15.3-205.3-56.8-277.1C348.9 19.1 238-3.3 144.2 34.5l0 .1 0 .1C219.1 62.8 288.7 112.7 344 168c55.6 55.6 104.7 125 133.3 199.8zM138.5 49.6c-13.4-5-13.7-24.5-.5-29.8C237.7-20.6 355.6 3.2 432 79.3C508.6 155.7 532.7 274 492.2 374c-5.4 13.3-24.9 13-29.8-.5C434.7 301.2 387 233.7 332.7 179.3C278.6 125.2 210.8 76.8 138.5 49.6zM20.5 468.9c-6 6.3-5.9 16.2 .2 22.4s16.1 6.3 22.4 .2L326.4 219.1c3.6 4 7.2 8 10.6 12L54.2 503.1c-12.6 12.1-32.5 11.9-44.8-.4S-3.1 470.4 8.9 457.8l272-282.9c4 3.4 8 7 12 10.6L20.5 468.9zM429.7 18.3l64 64c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-64-64c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0z'
      
    ]
  };

  

  
  

  var faTicketsSimple = {
    prefix: 'fat',
    iconName: 'tickets-simple',
    icon: [
      640,
      512,
      [],
      'e659',
      
      'M112 96c0-26.5 21.5-48 48-48H576c26.5 0 48 21.5 48 48v49.9c-.3 .1-.6 .3-.9 .4C596 153.6 576 178.5 576 208s20 54.4 47.1 61.8c.3 .1 .6 .2 .9 .4V320c0 26.5-21.5 48-48 48H160c-26.5 0-48-21.5-48-48V270.1c.3-.1 .6-.3 .9-.4C140 262.4 160 237.5 160 208s-20-54.4-47.1-61.8c-.3-.1-.6-.2-.9-.4V96zM96 96v51.2c0 7.1 5.8 12.6 12.7 14.5C129 167.2 144 185.9 144 208s-15 40.8-35.3 46.3c-6.8 1.9-12.7 7.4-12.7 14.5V320c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V268.8c0-7.1-5.8-12.6-12.7-14.5C607 248.8 592 230.1 592 208s15-40.8 35.3-46.3c6.8-1.9 12.7-7.4 12.7-14.5V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zM16 96c0-4.4-3.6-8-8-8s-8 3.6-8 8V376c0 57.4 46.6 104 104 104H552c4.4 0 8-3.6 8-8s-3.6-8-8-8H104c-48.6 0-88-39.4-88-88V96z'
      
    ]
  };

  

  
  

  var faCommentsDollar = {
    prefix: 'fat',
    iconName: 'comments-dollar',
    icon: [
      640,
      512,
      [],
      'f653',
      
      'M208 16C99.4 16 16 90 16 176c0 36.1 15.1 68.8 38.9 96.5c1.9 2.2 2.4 5.3 1.4 8c-8 21.5-21.4 41.2-40.2 55.4L16 336c28.8 0 57.3-10.1 83.4-23.9c2.3-1.2 5-1.2 7.3-.1c31.7 15.7 65.9 24 101.3 24c108.6 0 192-74 192-160s-83.4-160-192-160zM0 176C0 78.8 93.1 0 208 0S416 78.8 416 176s-93.1 176-208 176c-36.5 0-71.9-8.4-104.7-23.9C76.8 341.7 47 352 16 352c-6.9 0-13.1-4.5-15.2-11.1c-2.1-6.6 .2-13.7 5.7-17.8c14.7-11.2 25.9-26.6 33.1-43.9C15.7 250.1 0 215.2 0 176zm448 0c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 39.2-15.7 74.1-39.6 103.2c7.2 17.3 18.4 32.7 33.1 43.9c5.5 4.1 7.9 11.3 5.7 17.8c-2.1 6.6-8.3 11.1-15.2 11.1c-31 0-60.8-10.3-87.3-23.9C503.9 503.6 468.5 512 432 512c-95.7 0-176.2-54.6-200.5-129c5.5-.5 10.9-1.1 16.3-1.9C271 446.3 343 496 432 496c35.3 0 69.6-8.4 101.3-24c2.3-1.1 5-1.1 7.3 .1C566.7 485.9 595.2 496 624 496l-.1-.1c-18.7-14.2-32.2-33.9-40.2-55.4c-1-2.7-.5-5.8 1.4-8C608.9 404.9 624 372.1 624 336c0-81.7-75.3-152.6-176-159.5l0-.5zM215.1 90.7v14.8c1.7 .2 3.3 .4 5 .6c4.3 .7 17.5 3.2 22.1 4.4c3.8 1 6.1 4.9 5.1 8.7s-4.9 6.1-8.7 5.1c-4-1-16.6-3.5-20.7-4.1c-12.7-2-23.9-.5-32 3.1c-8.1 3.6-12.5 9-13.6 15.1c-.8 4.8-.2 8.2 1 10.8c1.3 2.7 3.5 5.1 7 7.4c7.2 4.8 17.6 7.9 29.6 11.5l.2 .1c11.4 3.4 24.4 7.3 33.8 14.1c4.9 3.5 9.1 8 11.7 13.8c2.6 5.9 3.3 12.6 1.9 20.1c-2.2 12.8-10.7 21.6-22.1 26.4c-6.1 2.6-13 4-20.5 4.4v14.3c0 3.9-3.2 7.1-7.1 7.1s-7.1-3.2-7.1-7.1V246.6c-1.7-.2-3.3-.4-5-.6l0 0c-7.7-1.2-20.3-5.5-28.8-8.3l0 0c-1.7-.6-3.2-1.1-4.5-1.5c-3.7-1.2-5.8-5.2-4.5-9s5.2-5.8 9-4.5c1.6 .5 3.3 1.1 5.1 1.7l0 0 0 0 0 0 0 0c8.6 2.9 19.5 6.6 25.9 7.6c12.9 2 24 .9 32-2.4c7.7-3.3 12.3-8.6 13.6-15.8c.9-5.3 .3-9.1-.9-12c-1.3-2.9-3.6-5.6-6.9-8c-7.1-5.1-17.5-8.4-29.6-12l-1.5-.4c-11-3.3-23.3-6.9-32.2-12.9c-4.9-3.3-9.2-7.5-11.9-13.1c-2.7-5.7-3.5-12.2-2.2-19.4c2.1-11.9 10.7-20.7 21.8-25.6c6.1-2.7 13.2-4.4 20.7-5V90.7c0-3.9 3.2-7.1 7.1-7.1s7.1 3.2 7.1 7.1z'
      
    ]
  };

  

  
  

  var faFaceHushed = {
    prefix: 'fat',
    iconName: 'face-hushed',
    icon: [
      512,
      512,
      [],
      'e37b',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm144 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM192.5 144c-32.5 2-61.6 16.5-82.7 38.7c-3 3.2-8.1 3.3-11.3 .3s-3.3-8.1-.3-11.3c23.7-25.1 56.6-41.4 93.3-43.7c4.4-.3 8.2 3.1 8.5 7.5s-3.1 8.2-7.5 8.5zM312 135.5c.3-4.4 4.1-7.8 8.5-7.5c36.7 2.3 69.6 18.6 93.3 43.7c3 3.2 2.9 8.3-.3 11.3s-8.3 2.9-11.3-.3C381.1 160.5 352 146 319.5 144c-4.4-.3-7.8-4.1-7.5-8.5zM304 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-112 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  

  
  

  var faPersonSnowmobiling = {
    prefix: 'fat',
    iconName: 'person-snowmobiling',
    icon: [
      640,
      512,
      ["snowmobile"],
      'f7d1',
      
      'M272 48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM340.4 80.8c4-2 8.8-.4 10.7 3.6l39.1 78.2 166.1 69.2c11.9 5 19.7 16.6 19.7 29.5v57.5c0 10.7-5.3 20.7-14.2 26.6l-76.2 50.8L563.9 496h16.8l45.7-45.7c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-48 48c-1.5 1.5-3.5 2.3-5.7 2.3H560.1h-.2H424c-4.4 0-8-3.6-8-8s3.6-8 8-8H543.5l-75.4-96h-129c-3.3-5.7-7.2-11.1-11.6-16H471.9h.2 3.1l77.7-51.8c4.4-3 7.1-8 7.1-13.3V261.3c0-6.5-3.9-12.3-9.8-14.8L388.6 179.2 300.1 282.4c-3 3.5-7.5 5.6-12.1 5.6H99.8c-6.1 0-11.6 3.4-14.3 8.8L57.8 352.2c-6.7 .4-13.3 1.5-19.5 3.3l32.9-65.8C76.6 278.8 87.7 272 99.8 272H288l54.9-64H288c-2.5 0-4.9-1.2-6.4-3.2l-26.5-35.4c-12-16-30.8-25.4-50.8-25.4c-24.1 0-46.1 13.6-56.8 35.1l-28.2 56.4c-2 4-6.8 5.6-10.7 3.6s-5.6-6.8-3.6-10.7L133.1 172c13.5-27 41-44 71.2-44c25 0 48.6 11.8 63.6 31.8L292 192h64.6l19.3-22.5-39-78c-2-4-.4-8.8 3.6-10.7zM256 400H64c-26.5 0-48 21.5-48 48s21.5 48 48 48H256c26.5 0 48-21.5 48-48s-21.5-48-48-48zM64 384H256c35.3 0 64 28.7 64 64s-28.7 64-64 64H64c-35.3 0-64-28.7-64-64s28.7-64 64-64z'
      
    ]
  };

  
    var faSnowmobile = faPersonSnowmobiling;
  

  
  

  var faChurch = {
    prefix: 'fat',
    iconName: 'church',
    icon: [
      640,
      512,
      [9962],
      'f51d',
      
      'M328 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V48H264c-4.4 0-8 3.6-8 8s3.6 8 8 8h48v59.6L186.1 203.1c-16.2 10.3-26.1 28.1-26.1 47.3V496H56c-22.1 0-40-17.9-40-40V385.7c0-13.4 6.7-25.9 17.8-33.3l98.6-65.7c3.7-2.5 4.7-7.4 2.2-11.1s-7.4-4.7-11.1-2.2L24.9 339.1C9.4 349.5 0 367 0 385.7V456c0 30.9 25.1 56 56 56H176c.1 0 .2 0 .3 0H256h16 96 16 88c.1 0 .2 0 .3 0H584c30.9 0 56-25.1 56-56V385.7c0-18.7-9.4-36.2-24.9-46.6l-98.6-65.7c-3.7-2.5-8.6-1.5-11.1 2.2s-1.5 8.6 2.2 11.1l98.6 65.8c11.1 7.4 17.8 19.9 17.8 33.3V456c0 22.1-17.9 40-40 40H480V250.5c0-19.2-9.8-37.1-26.1-47.3L328 123.6V64h48c4.4 0 8-3.6 8-8s-3.6-8-8-8H328V8zM464 496c-.1 0-.2 0-.3 0H384V384c0-35.3-28.7-64-64-64s-64 28.7-64 64V496H176V250.5c0-13.7 7-26.5 18.6-33.8L320 137.5l125.4 79.2C457 224 464 236.7 464 250.5V496zM368 384V496H272V384c0-26.5 21.5-48 48-48s48 21.5 48 48z'
      
    ]
  };

  

  
  

  var faTableCellsColumnLock = {
    prefix: 'fat',
    iconName: 'table-cells-column-lock',
    icon: [
      640,
      512,
      [],
      'e678',
      
      'M352 48l96 0c26.5 0 48 21.5 48 48l0 69.5c5.1-1.8 10.5-3.2 16-4.1L512 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0 0-16-32 0 0-128 34 0c1.5-5.7 3.7-11 6.5-16L352 320l0-128 104.4 0c5.4-6.1 11.7-11.5 18.5-16L352 176l0-128zm-16 0l0 128-160 0 0-128 160 0zM160 48l0 416-96 0c-26.5 0-48-21.5-48-48L16 96c0-26.5 21.5-48 48-48l96 0zm16 416l0-128 160 0 0 128-160 0zM336 320l-160 0 0-128 160 0 0 128zM528 208c26.5 0 48 21.5 48 48l0 64-96 0 0-64c0-26.5 21.5-48 48-48zm-64 48l0 64-16 0c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-16 0 0-64c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-16 80l16 0 16 0 96 0 16 0 16 0c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faCalendarLinesPen = {
    prefix: 'fat',
    iconName: 'calendar-lines-pen',
    icon: [
      576,
      512,
      [],
      'e472',
      
      'M128 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H64C28.7 64 0 92.7 0 128v48 16V448c0 35.3 28.7 64 64 64H258.8c-1.8-5.1-2.8-10.5-2.8-16H64c-26.5 0-48-21.5-48-48V192H384h48 16V176 128c0-35.3-28.7-64-64-64H336V8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H128V8zM112 80v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80H320v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80h48c26.5 0 48 21.5 48 48v48H16V128c0-26.5 21.5-48 48-48h48zm-8 304c-4.4 0-8 3.6-8 8s3.6 8 8 8H248c4.4 0 8-3.6 8-8s-3.6-8-8-8H104zm-8-88c0 4.4 3.6 8 8 8H344c4.4 0 8-3.6 8-8s-3.6-8-8-8H104c-4.4 0-8 3.6-8 8zM292.7 507.2c4 4 9.7 5.6 15.2 4.2l60.1-15-3.4-13.6 3.4 13.6c5.6-1.4 10.8-4.3 14.9-8.4L564.1 306.7c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4c-15.6-15.6-40.9-15.6-56.6 0L311.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2zm15.7-28.9L319 435.7c.7-2.8 2.2-5.4 4.2-7.4L466.1 285.4l48.3 48.3L371.6 476.6c-2.1 2.1-4.6 3.5-7.4 4.2l-42.5 10.6L304 495.8l4.4-17.6zM552.8 295.4l-27.1 27.1-48.3-48.3L504.5 247c9.4-9.4 24.6-9.4 33.9 0l14.4 14.4c9.4 9.4 9.4 24.6 0 33.9z'
      
    ]
  };

  

  
  

  var faGlassCitrus = {
    prefix: 'fat',
    iconName: 'glass-citrus',
    icon: [
      512,
      512,
      [],
      'f869',
      
      'M371.5 272C440.6 270.1 496 213.5 496 144c0-70.7-57.3-128-128-128c-53.7 0-99.7 33.1-118.7 80H232.2C252 40.1 305.3 0 368 0c79.5 0 144 64.5 144 144c0 79-63.6 143.1-142.3 144l1.8-16zM32.8 144c-9.5 0-16.9 8.3-15.9 17.7L27.2 256H324.7L335 161.7c1-9.5-6.4-17.7-15.9-17.7H32.8zM49.7 460.4C51.9 480.6 69 496 89.4 496h173c20.4 0 37.5-15.4 39.8-35.6L322.9 272H29L49.7 460.4zM1 163.5C-1.1 144.6 13.7 128 32.8 128H319.1c19.1 0 33.9 16.6 31.8 35.5L318.1 462.1C315 490.5 291 512 262.5 512H89.4c-28.6 0-52.5-21.5-55.7-49.9L1 163.5z'
      
    ]
  };

  

  
  

  var faItalic = {
    prefix: 'fat',
    iconName: 'italic',
    icon: [
      384,
      512,
      [],
      'f033',
      
      'M128 40c0-4.4 3.6-8 8-8H376c4.4 0 8 3.6 8 8s-3.6 8-8 8H285.4L115.9 464H248c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H98.6L268.1 48H136c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faCediSign = {
    prefix: 'fat',
    iconName: 'cedi-sign',
    icon: [
      384,
      512,
      [],
      'e0df',
      
      'M224 0c4.4 0 8 3.6 8 8V64c43.7 .4 84.1 14.6 116.7 38.3c3.6 2.6 4.4 7.6 1.8 11.2s-7.6 4.4-11.2 1.8C309.4 93.5 272.3 80.4 232 80V432c40.3-.4 77.4-13.5 107.3-35.3c3.6-2.6 8.6-1.8 11.2 1.8s1.8 8.6-1.8 11.2c-32.6 23.7-73 37.9-116.7 38.3v0 56c0 4.4-3.6 8-8 8s-8-3.6-8-8V448v-.5C113.4 440.6 32 357.7 32 256S113.4 71.4 216 64.5V8c0-4.4 3.6-8 8-8zM48 256c0 92.4 73.8 168.6 168 175.5V80.5C121.8 87.4 48 163.6 48 256z'
      
    ]
  };

  

  
  

  var faCouch = {
    prefix: 'fat',
    iconName: 'couch',
    icon: [
      640,
      512,
      [],
      'f4b8',
      
      'M448 48H192C130.1 48 80 98.1 80 160v33.3c-5.2-.9-10.5-1.3-16-1.3V160C64 89.3 121.3 32 192 32H448c70.7 0 128 57.3 128 128v32c-5.5 0-10.8 .5-16 1.3V160c0-61.9-50.1-112-112-112zM112 288c0-26.5-21.5-48-48-48s-48 21.5-48 48V432c0 17.7 14.3 32 32 32H80c17.7 0 32-14.3 32-32V288zM0 288c0-35.3 28.7-64 64-64s64 28.7 64 64H512c0-35.3 28.7-64 64-64s64 28.7 64 64V432c0 26.5-21.5 48-48 48H560c-26.5 0-48-21.5-48-48H128c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V288zM128 416H512V304H128V416zM624 288c0-26.5-21.5-48-48-48s-48 21.5-48 48V432c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V288z'
      
    ]
  };

  

  
  

  var faMartiniGlassEmpty = {
    prefix: 'fat',
    iconName: 'martini-glass-empty',
    icon: [
      512,
      512,
      ["glass-martini"],
      'f000',
      
      'M25.5 16c-5.3 0-9.5 4.3-9.5 9.5c0 2.5 1 5 2.8 6.7L256 269.5 493.2 32.3c1.8-1.8 2.8-4.2 2.8-6.7c0-5.3-4.3-9.5-9.5-9.5H25.5zM248 284.1L7.5 43.6C2.7 38.8 0 32.3 0 25.5C0 11.4 11.4 0 25.5 0H486.5C500.6 0 512 11.4 512 25.5c0 6.8-2.7 13.3-7.5 18.1L264 284.1V496H376c4.4 0 8 3.6 8 8s-3.6 8-8 8H256 136c-4.4 0-8-3.6-8-8s3.6-8 8-8H248V284.1z'
      
    ]
  };

  
    var faGlassMartini = faMartiniGlassEmpty;
  

  
  

  var faMemo = {
    prefix: 'fat',
    iconName: 'memo',
    icon: [
      384,
      512,
      [],
      'e1d8',
      
      'M64 16C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48H320c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm72 64H312c4.4 0 8 3.6 8 8s-3.6 8-8 8H72c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 96H312c4.4 0 8 3.6 8 8s-3.6 8-8 8H72c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 96H216c4.4 0 8 3.6 8 8s-3.6 8-8 8H72c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faSquare = {
    prefix: 'fat',
    iconName: 'square',
    icon: [
      448,
      512,
      [9632,9723,9724,61590],
      'f0c8',
      
      'M384 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z'
      
    ]
  };

  

  
  

  var faCommentCheck = {
    prefix: 'fat',
    iconName: 'comment-check',
    icon: [
      512,
      512,
      [],
      'f4ac',
      
      'M157.3 415c-5-1.8-10.6-1-14.9 2.1c-11 8-29.4 19.3-51.2 28.8C68.3 456 41.6 464 16 464l.1-.1 0 0 0 0 .3-.3 .1-.1c.4-.4 .9-.9 1.5-1.6c1.3-1.4 3.2-3.6 5.4-6.3l-12.2-10 12.2 10C28 450 34 442 40 432c10.7-17.9 21.4-42.1 23.6-69.9c.3-4.3-1.1-8.6-3.9-11.8C31.9 318.8 16 280.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-35.2 0-68.6-6.1-98.7-17zM4.7 452.7l0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0zm353-271c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L224 292.7l-58.3-58.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l64 64c3.1 3.1 8.2 3.1 11.3 0l128-128z'
      
    ]
  };

  

  
  

  var faHeartHalf = {
    prefix: 'fat',
    iconName: 'heart-half',
    icon: [
      512,
      512,
      [],
      'e1ab',
      
      'M240 458.1V102.6l-7.3-7.3c-29-29-70.2-42.2-110.6-35.5C60.9 70.1 16 123 16 185.1v5.8c0 37.1 15.4 72.5 42.5 97.8L240 458.1zm-3.3 18.8L47.6 300.4C17.2 272.1 0 232.4 0 190.9v-5.8c0-69.9 50.5-129.5 119.4-141C165 36.5 211.4 51.4 244 84l12 12V468.5c0 6.3-5.1 11.5-11.5 11.5c-2.9 0-5.7-1.1-7.8-3.1z'
      
    ]
  };

  

  
  

  var faTicketPerforated = {
    prefix: 'fat',
    iconName: 'ticket-perforated',
    icon: [
      640,
      512,
      [],
      'e63e',
      
      'M16 128c0-26.5 21.5-48 48-48H576c26.5 0 48 21.5 48 48v64c-35.3 0-64 28.7-64 64s28.7 64 64 64v64c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V128zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V317.6c0-8-8-13.6-16-13.6c-26.5 0-48-21.5-48-48s21.5-48 48-48c8 0 16-5.6 16-13.6V128c0-35.3-28.7-64-64-64H64zm416 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faFileZipper = {
    prefix: 'fat',
    iconName: 'file-zipper',
    icon: [
      384,
      512,
      ["file-archive"],
      'f1c6',
      
      'M64 496H320c26.5 0 48-21.5 48-48V179.9c0-1.3-.1-2.6-.2-3.9H248c-22.1 0-40-17.9-40-40V16.2c-1.3-.2-2.6-.2-3.9-.2H64C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48zM361.1 160c-.8-1-1.6-1.9-2.4-2.7L226.7 25.4c-.9-.9-1.8-1.7-2.7-2.4V136c0 13.3 10.7 24 24 24H361.1zM0 64C0 28.7 28.7 0 64 0H204.1c12.7 0 24.9 5.1 33.9 14.1L369.9 145.9c9 9 14.1 21.2 14.1 33.9V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM81.6 340.1c-1.1 4-1.6 8.1-1.6 12.3c0 26.2 21.6 47.7 48 47.7s48-21.4 48-47.7c0-4.1-.5-8.3-1.6-12.3l-23.5-88.2c-1.9-7-8.2-11.9-15.5-11.9H120.6c-7.2 0-13.6 4.9-15.5 11.9L81.6 340.1zm-15.5-4.1l23.5-88.2c3.7-14 16.4-23.8 30.9-23.8h14.8c14.5 0 27.2 9.7 30.9 23.8l23.5 88.2c1.4 5.4 2.1 10.9 2.1 16.4c0 35.2-28.8 63.7-64 63.7s-64-28.5-64-63.7c0-5.5 .7-11.1 2.1-16.4zM112 344h32c4.4 0 8 3.6 8 8s-3.6 8-8 8H112c-4.4 0-8-3.6-8-8s3.6-8 8-8zM104 32h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H104c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 32h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H104c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 32h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H104c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 32h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H104c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 32h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H104c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 32h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H104c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  
    var faFileArchive = faFileZipper;
  

  
  

  var faHouseChimneyCrack = {
    prefix: 'fat',
    iconName: 'house-chimney-crack',
    icon: [
      576,
      512,
      ["house-damage"],
      'f6f1',
      
      'M282.7 2c3-2.7 7.6-2.7 10.6 0L384 82.3V56c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V195.7L573.3 250c3.3 2.9 3.6 8 .7 11.3s-8 3.6-11.3 .7L512 217.1V448c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V217.1L13.3 262c-3.3 2.9-8.4 2.6-11.3-.7S-.6 252.9 2.7 250L282.7 2zM496 181.5V56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8V96.5l96 85zM384 103.7l-96-85L80 202.9V448c0 26.5 21.5 48 48 48H281.1l-55.7-83.6c-1.2-1.8-1.6-4.1-1.1-6.3s1.9-4 3.8-5.1l102.1-58.4L226.8 254.1c-3.4-2.9-3.7-7.9-.9-11.3s7.9-3.7 11.3-.9l112 96c2 1.7 3 4.2 2.8 6.8s-1.7 4.9-4 6.2L243.4 410.7 300.3 496H448c26.5 0 48-21.5 48-48V202.9L384.3 104H384v-.3z'
      
    ]
  };

  
    var faHouseDamage = faHouseChimneyCrack;
  

  
  

  var faHeartCircleCheck = {
    prefix: 'fat',
    iconName: 'heart-circle-check',
    icon: [
      576,
      512,
      [],
      'e4fd',
      
      'M393.6 57.7c-42.9-5.6-85.8 12.6-111.2 47.6l-20 27.5c-1.5 2.1-3.9 3.3-6.5 3.3s-5-1.2-6.5-3.3l-20-27.5c-25.4-34.9-68.3-53.2-111.2-47.6C60.1 65.3 16 114.9 16 173.5c0 30.3 11.8 59.4 32.9 81.2L248 460.4c2.2 2.3 5.2 3.6 8.4 3.6s6.2-1.3 8.4-3.6l11-11.4c2.6 4.9 5.4 9.7 8.4 14.4l-7.8 8.1c-5.2 5.4-12.4 8.5-19.9 8.5c-7.5 0-14.7-3-19.9-8.4L37.4 265.8C13.4 241.1 0 208 0 173.5C0 106.8 50.2 50.4 116.3 41.8c48.6-6.3 97.4 14.3 126.2 54L256 114.4l13.5-18.6c28.9-39.7 77.6-60.4 126.2-54c66.1 8.6 116.3 65 116.3 131.8c0 12-1.6 23.9-4.8 35.3c-4.9-2.3-9.8-4.4-14.9-6.2c2.4-9.4 3.7-19.2 3.7-29C496 115 451.9 65.3 393.6 57.7zM432 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm69.7 98.3c3.1 3.1 3.1 8.2 0 11.3l-80 80c-3.1 3.1-8.2 3.1-11.3 0l-48-48c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L416 396.7l74.3-74.3c3.1-3.1 8.2-3.1 11.3 0z'
      
    ]
  };

  

  
  

  var faArchway = {
    prefix: 'fat',
    iconName: 'archway',
    icon: [
      512,
      512,
      [],
      'f557',
      
      'M0 40c0-4.4 3.6-8 8-8H40 472h32c4.4 0 8 3.6 8 8s-3.6 8-8 8H480V464h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H472 432 360c-4.4 0-8-3.6-8-8V352c0-53-43-96-96-96s-96 43-96 96V472c0 4.4-3.6 8-8 8H80 40 8c-4.4 0-8-3.6-8-8s3.6-8 8-8H32V48H8c-4.4 0-8-3.6-8-8zm48 8V464H80h64V352c0-61.9 50.1-112 112-112s112 50.1 112 112V464h64 32V48H48zm56 96H408c4.4 0 8 3.6 8 8s-3.6 8-8 8H104c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faClockTwoThirty = {
    prefix: 'fat',
    iconName: 'clock-two-thirty',
    icon: [
      512,
      512,
      [],
      'e35b',
      
      'M16 256a240 240 0 1 0 480 0A240 240 0 1 0 16 256zm496 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM248 408V256c0-2.7 1.3-5.2 3.6-6.7l96-64c3.7-2.5 8.6-1.5 11.1 2.2s1.5 8.6-2.2 11.1L264 260.3V408c0 4.4-3.6 8-8 8s-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faHashtagLock = {
    prefix: 'fat',
    iconName: 'hashtag-lock',
    icon: [
      576,
      512,
      [],
      'e415',
      
      'M169.7 32.2c4.3 1 7 5.2 6.1 9.5L153.1 144H328.7L352.2 38.3c1-4.3 5.2-7 9.5-6.1s7 5.2 6.1 9.5L345.1 144H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H341.5L298.9 352H320v0 16H295.3L271.8 473.7c-1 4.3-5.2 7-9.5 6.1s-7-5.2-6.1-9.5L278.9 368H103.3L79.8 473.7c-1 4.3-5.2 7-9.5 6.1s-7-5.2-6.1-9.5L86.9 368H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H90.5l42.7-192H40c-4.4 0-8-3.6-8-8s3.6-8 8-8h96.7L160.2 38.3c1-4.3 5.2-7 9.5-6.1zM149.5 160L106.9 352H282.5l42.7-192H149.5zM464 208c-26.5 0-48 21.5-48 48v64h96V256c0-26.5-21.5-48-48-48zm-64 48c0-35.3 28.7-64 64-64s64 28.7 64 64v64h16c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32h16V256zm-16 80c-8.8 0-16 7.2-16 16V480c0 8.8 7.2 16 16 16H544c8.8 0 16-7.2 16-16V352c0-8.8-7.2-16-16-16H528 512 416 400 384z'
      
    ]
  };

  

  
  

  var faBorderOuter = {
    prefix: 'fat',
    iconName: 'border-outer',
    icon: [
      448,
      512,
      [],
      'f851',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 80a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-80 80a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm80 16a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm112-16a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM224 368a16 16 0 1 1 0-32 16 16 0 1 1 0 32z'
      
    ]
  };

  

  
  

  var faArrowsToDot = {
    prefix: 'fat',
    iconName: 'arrows-to-dot',
    icon: [
      512,
      512,
      [],
      'e4be',
      
      'M256 0c-4.4 0-8 3.6-8 8l0 156.7L173.7 90.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l88 88c3.1 3.1 8.2 3.1 11.3 0l88-88c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L264 164.7 264 8c0-4.4-3.6-8-8-8zM421.7 162.3c-3.1-3.1-8.2-3.1-11.3 0l-88 88c-3.1 3.1-3.1 8.2 0 11.3l88 88c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L347.3 264 504 264c4.4 0 8-3.6 8-8s-3.6-8-8-8l-156.7 0 74.3-74.3c3.1-3.1 3.1-8.2 0-11.3zM256 240a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM101.7 162.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L164.7 248 8 248c-4.4 0-8 3.6-8 8s3.6 8 8 8l156.7 0L90.3 338.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l88-88c3.1-3.1 3.1-8.2 0-11.3l-88-88zm60.7 248c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L248 347.3 248 504c0 4.4 3.6 8 8 8s8-3.6 8-8V347.3l74.3 74.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-88-88c-3.1-3.1-8.2-3.1-11.3 0l-88 88z'
      
    ]
  };

  

  
  

  var faRestroomSimple = {
    prefix: 'fat',
    iconName: 'restroom-simple',
    icon: [
      640,
      512,
      [],
      'e23a',
      
      'M80 64a48 48 0 1 1 96 0A48 48 0 1 1 80 64zm112 0A64 64 0 1 0 64 64a64 64 0 1 0 128 0zM41.8 234.7c2.8-33.2 30.5-58.7 63.8-58.7h44.8c33.3 0 61 25.5 63.8 58.7l4.1 49.3c2.3 28-19.8 52-47.8 52H144 112 85.6c-28.1 0-50.2-24-47.8-52l4.1-49.3zM136 352V480c0 17.7 14.3 32 32 32s32-14.3 32-32V344.8c22.1-11.5 36.4-35.4 34.2-62.1l-4.1-49.3C226.7 191.9 192 160 150.4 160H105.6c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3c-2.2 26.7 12.2 50.6 34.2 62.1V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16zm48-1.4V480c0 8.8-7.2 16-16 16s-16-7.2-16-16V352h18.4c4.7 0 9.2-.5 13.6-1.4zM85.6 352H104V480c0 8.8-7.2 16-16 16s-16-7.2-16-16V350.6c4.4 .9 8.9 1.4 13.6 1.4zM312 0c-4.4 0-8 3.6-8 8V504c0 4.4 3.6 8 8 8s8-3.6 8-8V8c0-4.4-3.6-8-8-8zM512 16a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112A64 64 0 1 0 512 0a64 64 0 1 0 0 128zm-15.7 48h31.4c21.4 0 40.3 14.2 46.2 34.8L613 347.6c2.9 10.2-4.8 20.4-15.4 20.4H576 528 496 448 426.4c-10.6 0-18.3-10.2-15.4-20.4l39.1-136.8c5.9-20.6 24.7-34.8 46.2-34.8zM504 384h16v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h13.6c21.3 0 36.6-20.3 30.8-40.8L589.3 206.4c-7.8-27.5-33-46.4-61.5-46.4H496.3c-28.6 0-53.7 18.9-61.5 46.4L395.7 343.2c-5.8 20.4 9.5 40.8 30.8 40.8H440v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384zm64 96c0 8.8-7.2 16-16 16s-16-7.2-16-16V384h32v96zm-80-96v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V384h32z'
      
    ]
  };

  

  
  

  var faLayerGroup = {
    prefix: 'fat',
    iconName: 'layer-group',
    icon: [
      576,
      512,
      [],
      'f5fd',
      
      'M288 0c-6.4 0-12.8 1.4-18.6 4.1L43.9 109.4C36.6 112.7 32 120 32 128s4.6 15.3 11.9 18.6L269.4 251.9c5.8 2.7 12.2 4.1 18.6 4.1s12.8-1.4 18.6-4.1L532.1 146.6C539.4 143.3 544 136 544 128s-4.6-15.3-11.9-18.6L306.6 4.1C300.8 1.4 294.4 0 288 0zM276.1 18.6c3.7-1.7 7.8-2.6 11.9-2.6s8.2 .9 11.9 2.6L525.4 123.9c1.6 .7 2.6 2.4 2.6 4.1s-1 3.4-2.6 4.1L299.9 237.4c-3.7 1.7-7.8 2.6-11.9 2.6s-8.2-.9-11.9-2.6L50.6 132.1c-1.6-.7-2.6-2.4-2.6-4.1s1-3.4 2.6-4.1L276.1 18.6zM43.9 237.4C36.6 240.7 32 248 32 256s4.6 15.3 11.9 18.6L269.4 379.9c5.8 2.7 12.2 4.1 18.6 4.1s12.8-1.4 18.6-4.1L532.1 274.6C539.4 271.3 544 264 544 256s-4.6-15.3-11.9-18.6l-59.4-27.7-18.9 8.8 71.5 33.4c1.6 .7 2.6 2.4 2.6 4.1s-1 3.4-2.6 4.1L299.9 365.4c-3.7 1.7-7.8 2.6-11.9 2.6s-8.2-.9-11.9-2.6L50.6 260.1c-1.6-.7-2.6-2.4-2.6-4.1s1-3.4 2.6-4.1l71.5-33.4-18.9-8.8L43.9 237.4zm0 128C36.6 368.7 32 376 32 384s4.6 15.3 11.9 18.6L269.4 507.9c5.8 2.7 12.2 4.1 18.6 4.1s12.8-1.4 18.6-4.1L532.1 402.6C539.4 399.3 544 392 544 384s-4.6-15.3-11.9-18.6l-59.4-27.7-18.9 8.8 71.5 33.4c1.6 .7 2.6 2.4 2.6 4.1s-1 3.4-2.6 4.1L299.9 493.4c-3.7 1.7-7.8 2.6-11.9 2.6s-8.2-.9-11.9-2.6L50.6 388.1c-1.6-.8-2.6-2.4-2.6-4.1s1-3.4 2.6-4.1l71.5-33.4-18.9-8.8L43.9 365.4z'
      
    ]
  };

  

  
  

  var faEnvelopeCircleCheck = {
    prefix: 'fat',
    iconName: 'envelope-circle-check',
    icon: [
      640,
      512,
      [],
      'e4e8',
      
      'M64 80H448c26.5 0 48 21.5 48 48v32c5.4 0 10.7 .2 16 .7V128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H360.2c-4.2-5.1-8.1-10.4-11.8-16H64c-26.5 0-48-21.5-48-48V176.7L210.8 333.8c26.4 21.3 64 21.3 90.4 0l19.7-15.9c.8-8.1 2.2-16.1 4.1-23.9l-33.9 27.3c-20.5 16.5-49.8 16.5-70.3 0L16 156.2V128c0-26.5 21.5-48 48-48zM496 208a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm69.7-189.7c-3.1-3.1-8.2-3.1-11.3 0L480 364.7l-42.3-42.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l48 48c3.1 3.1 8.2 3.1 11.3 0l80-80c3.1-3.1 3.1-8.2 0-11.3z'
      
    ]
  };

  

  
  

  var faWave = {
    prefix: 'fat',
    iconName: 'wave',
    icon: [
      576,
      512,
      [],
      'e65b',
      
      'M304 72c-92.8 0-168 75.2-168 168c0 57.4-46.6 104-104 104c-4.4 0-8-3.6-8-8s3.6-8 8-8c48.6 0 88-39.4 88-88c0-101.6 82.4-184 184-184c62.2 0 117.3 30.9 150.5 78.2c2.1 3 1.9 7-.4 9.8s-6.3 3.6-9.5 2.1c-13.5-6.4-28.6-10-44.6-10c-57.4 0-104 46.6-104 104c0 48.6 39.4 88 88 88h0c22.5 0 44.6-14.2 61.8-29.9c10.1-9.2 19.7-19.5 27.6-30.7c1.5-2.1 3.9-3.4 6.6-3.4s5.1 1.3 6.6 3.4c7.3 10.3 15.9 19.6 25 28.3c15.7 14.8 36.1 29.2 57.4 31.9c4.4 .6 7.5 4.6 6.9 8.9s-4.6 7.5-8.9 6.9c-26.5-3.3-50-20.7-66.4-36.1c-8.8-8.3-15.9-16.4-20.6-22.2c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1h0c-57.4 0-104-46.6-104-104c0-66.3 53.7-120 120-120c8.2 0 16.2 .8 24 2.4C393.5 91.3 351 72 304 72zm18.2 362.1C339.5 449.8 361.5 464 384 464s44.6-14.2 61.8-29.9c10.1-9.2 19.7-19.5 27.6-30.7c1.5-2.1 3.9-3.4 6.6-3.4s5.1 1.3 6.6 3.4c7.3 10.3 15.9 19.6 25 28.3c15.7 14.8 36.1 29.2 57.4 31.9c4.4 .6 7.5 4.6 6.9 8.9s-4.6 7.5-8.9 6.9c-26.5-3.3-50-20.7-66.4-36.1c-8.8-8.3-15.9-16.4-20.6-22.2c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8l0 0 0 0c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-4.7 5.8-11.8 13.9-20.6 22.2C59 458.7 35.5 476.1 9 479.4c-4.4 .6-8.4-2.6-8.9-6.9s2.6-8.4 6.9-8.9c21.3-2.7 41.7-17.1 57.4-31.9c9.1-8.6 17.7-18 25-28.3c1.5-2.1 3.9-3.4 6.6-3.4s5.1 1.3 6.6 3.4c7.9 11.2 17.5 21.5 27.6 30.7C147.4 449.8 169.5 464 192 464s44.6-14.2 61.8-29.9c10.1-9.2 19.6-19.5 27.6-30.7c3-4.3 10.2-4.3 13.2 0c8 11.2 17.5 21.4 27.6 30.7z'
      
    ]
  };

  

  
  

  var faCommentMiddleTop = {
    prefix: 'fat',
    iconName: 'comment-middle-top',
    icon: [
      512,
      512,
      [],
      'e14a',
      
      'M202.6 110.5l44.5-89c1.7-3.4 5.1-5.5 8.8-5.5s7.2 2.1 8.8 5.5l44.5 89c2.2 4.3 6.1 7.4 10.8 8.5C423.8 142 496 217.9 496 304c0 103.1-104.2 192-240 192S16 407.1 16 304c0-86.1 72.2-162 175.8-185c4.7-1 8.7-4.2 10.8-8.5zm121-7.2l-44.5-89C274.8 5.5 265.8 0 256 0s-18.8 5.5-23.2 14.3l-44.5 89C79.8 127.5 0 208.2 0 304C0 418.9 114.6 512 256 512s256-93.1 256-208c0-95.8-79.8-176.5-188.3-200.7z'
      
    ]
  };

  

  
  

  var faGridRound2 = {
    prefix: 'fat',
    iconName: 'grid-round-2',
    icon: [
      512,
      512,
      [],
      'e5db',
      
      'M128 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm96-80A96 96 0 1 1 32 128a96 96 0 1 1 192 0zM128 464a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm96-80A96 96 0 1 1 32 384a96 96 0 1 1 192 0zm80-256a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zm80 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192zm0 240a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm96-80a96 96 0 1 1 -192 0 96 96 0 1 1 192 0z'
      
    ]
  };

  

  
  

  var faVirus = {
    prefix: 'fat',
    iconName: 'virus',
    icon: [
      512,
      512,
      [],
      'e074',
      
      'M425.7 86.3c-6.2-6.2-16.4-6.2-22.6 0l-8.2 8.2C349.6 139.8 272 107.7 272 43.5V32c0-8.8-7.2-16-16-16s-16 7.2-16 16V43.5c0 64.1-77.6 96.3-122.9 50.9l-8.2-8.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l8.2 8.2C139.8 162.4 107.7 240 43.5 240H32c-8.8 0-16 7.2-16 16s7.2 16 16 16H43.5c64.1 0 96.3 77.6 50.9 122.9l-8.2 8.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l8.2-8.2C162.4 372.2 240 404.3 240 468.5V480c0 8.8 7.2 16 16 16s16-7.2 16-16V468.5c0-64.1 77.6-96.3 122.9-50.9l8.2 8.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-8.2-8.2C372.2 349.6 404.3 272 468.5 272H480c8.8 0 16-7.2 16-16s-7.2-16-16-16H468.5c-64.1 0-96.3-77.6-50.9-122.9l8.2-8.2c6.2-6.2 6.2-16.4 0-22.6L437 75c12.5 12.5 12.5 32.8 0 45.3l-8.2 8.2c-35.3 35.3-10.3 95.6 39.6 95.6H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H468.5c-49.9 0-74.9 60.3-39.6 95.6l8.2 8.2c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-8.2-8.2c-35.3-35.3-95.6-10.3-95.6 39.6V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V468.5c0-49.9-60.3-74.9-95.6-39.6l-8.2 8.2c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l8.2-8.2C118.4 348.3 93.4 288 43.5 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H43.5c49.9 0 74.9-60.3 39.6-95.6L75 120.2C62.5 107.7 62.5 87.5 75 75s32.8-12.5 45.3 0l8.2 8.2C163.7 118.4 224 93.4 224 43.5V32c0-17.7 14.3-32 32-32s32 14.3 32 32V43.5c0 49.9 60.3 74.9 95.6 39.6l8.2-8.2c12.5-12.5 32.8-12.5 45.3 0L425.7 86.3zM224 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm80 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faBookAtlas = {
    prefix: 'fat',
    iconName: 'book-atlas',
    icon: [
      448,
      512,
      ["atlas"],
      'f558',
      
      'M0 56C0 25.1 25.1 0 56 0H408c22.1 0 40 17.9 40 40V376c0 19.4-13.7 35.5-32 39.2V496h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H56c-30.9 0-56-25.1-56-56V56zM56 416c-22.1 0-40 17.9-40 40s17.9 40 40 40H400V416H56zm-40 .8C26.2 406.4 40.3 400 56 400H408c13.3 0 24-10.7 24-24V40c0-13.3-10.7-24-24-24H56C33.9 16 16 33.9 16 56V416.8zM240 328c7.8 0 19.8-7.4 30.8-30.6c9.6-20.4 16.2-48.9 17.1-81.4H192.1c.9 32.4 7.5 61 17.1 81.4c11 23.3 22.9 30.6 30.8 30.6zM192.1 200h95.8c-.9-32.4-7.5-61-17.1-81.4C259.8 95.4 247.8 88 240 88s-19.8 7.4-30.8 30.6c-9.6 20.4-16.2 48.9-17.1 81.4zm82 123.1c47.2-14 82.3-56.2 85.6-107.1H303.9c-1.2 45.1-12.8 84.3-29.8 107.1zM303.9 200h55.8c-3.4-50.9-38.4-93.1-85.6-107.1c17 22.8 28.5 62 29.8 107.1zm-98-107.1c-47.2 14-82.3 56.2-85.6 107.1h55.8c1.2-45.1 12.8-84.3 29.8-107.1zm0 230.2c-17-22.8-28.5-62-29.8-107.1H120.3c3.3 50.9 38.4 93.1 85.6 107.1zM240 344a136 136 0 1 1 0-272 136 136 0 1 1 0 272z'
      
    ]
  };

  
    var faAtlas = faBookAtlas;
  

  
  

  var faTruckPlow = {
    prefix: 'fat',
    iconName: 'truck-plow',
    icon: [
      640,
      512,
      [],
      'f7de',
      
      'M168 48H270.4c8.2 0 15.9 4.2 20.3 11.2L374.5 192H144v-8V72c0-13.3 10.7-24 24-24zM393.5 192l-2.7-4.3L304.2 50.6C296.9 39 284.1 32 270.4 32H168c-22.1 0-40 17.9-40 40V184v8H56c-30.9 0-56 25.1-56 56v96c0 19.4 13.7 35.5 32 39.2l0 .8c0 53 43 96 96 96s96-43 96-96h48c0 53 43 96 96 96s96-43 96-96h68.7l93.7 93.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L544 372.7V368 203.3l93.7-93.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-96 96c-1.5 1.5-2.3 3.5-2.3 5.7V368H488c5-6.7 8-15 8-24V248c0-30.9-25.1-56-56-56H393.5zm69.1 175.1c-8-45-47.3-79.1-94.5-79.1c-47.6 0-87.1 34.6-94.7 80H222.7c-7.6-45.4-47.1-80-94.7-80c-47.3 0-86.5 34.1-94.5 79.1C23.4 364.3 16 355 16 344V248c0-22.1 17.9-40 40-40H440c22.1 0 40 17.9 40 40v96c0 11-7.4 20.3-17.5 23.1zM48 384a80 80 0 1 1 160 0A80 80 0 1 1 48 384zm320-80a80 80 0 1 1 0 160 80 80 0 1 1 0-160z'
      
    ]
  };

  

  
  

  var faShieldHalved = {
    prefix: 'fat',
    iconName: 'shield-halved',
    icon: [
      512,
      512,
      ["shield-alt"],
      'f3ed',
      
      'M264 19.4c3.7 .6 7.3 1.7 10.8 3.1l176.7 75c16.6 7.1 28.6 23.2 28.5 42.4c-.5 96.6-40.3 270.2-204.5 348.8c-3.7 1.8-7.6 3-11.5 3.7V19.4zm-16 0v473c-3.9-.7-7.8-1.9-11.4-3.7C72.3 410.1 32.5 236.5 32 139.9c-.1-19.1 11.9-35.3 28.5-42.4l176.7-75c3.5-1.5 7.1-2.5 10.7-3.1zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8z'
      
    ]
  };

  
    var faShieldAlt = faShieldHalved;
  

  
  

  var faFaceConfounded = {
    prefix: 'fat',
    iconName: 'face-confounded',
    icon: [
      512,
      512,
      [],
      'e36c',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM212.4 361.3l43.6 29 43.6-29c2.7-1.8 6.2-1.8 8.9 0l44.1 29.4 27.8-13.9c4-2 8.8-.4 10.7 3.6s.4 8.8-3.6 10.7l-32 16c-2.6 1.3-5.6 1.1-8-.5l-43.6-29-43.6 29c-2.7 1.8-6.2 1.8-8.9 0l-43.6-29-43.6 29c-2.4 1.6-5.4 1.8-8 .5l-32-16c-4-2-5.6-6.8-3.6-10.7s6.8-5.6 10.7-3.6l27.8 13.9 44.1-29.4c2.7-1.8 6.2-1.8 8.9 0zM128.8 212.4c2-4 6.8-5.6 10.7-3.6l80 40c2.7 1.4 4.4 4.1 4.4 7.2s-1.7 5.8-4.4 7.2l-80 40c-4 2-8.8 .4-10.7-3.6s-.4-8.8 3.6-10.7L198.1 256l-65.7-32.8c-4-2-5.6-6.8-3.6-10.7zm243.6-3.6c4-2 8.8-.4 10.7 3.6s.4 8.8-3.6 10.7L313.9 256l65.7 32.8c4 2 5.6 6.8 3.6 10.7s-6.8 5.6-10.7 3.6l-80-40c-2.7-1.4-4.4-4.1-4.4-7.2s1.7-5.8 4.4-7.2l80-40z'
      
    ]
  };

  

  
  

  var faPalletBox = {
    prefix: 'fat',
    iconName: 'pallet-box',
    icon: [
      640,
      512,
      [],
      'e208',
      
      'M464 16c17.7 0 32 14.3 32 32V240c0 17.7-14.3 32-32 32H176c-17.7 0-32-14.3-32-32V48c0-17.7 14.3-32 32-32h80V136c0 3.1 1.8 6 4.7 7.3s6.2 .8 8.5-1.2L320 98.5l50.8 43.5c2.4 2 5.7 2.5 8.6 1.2s4.7-4.1 4.7-7.3V16h80zM272 16h96V118.6L325.2 81.9c-3-2.6-7.4-2.6-10.4 0L272 118.6V16zM176 0c-26.5 0-48 21.5-48 48V240c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H176zM0 360c0 4.4 3.6 8 8 8H80V496H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H88 320 552h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H560V368h72c4.4 0 8-3.6 8-8s-3.6-8-8-8H552 320 88 8c-4.4 0-8 3.6-8 8zM96 496V368H312V496H96zm232 0V368H544V496H328z'
      
    ]
  };

  

  
  

  var faGreaterThanEqual = {
    prefix: 'fat',
    iconName: 'greater-than-equal',
    icon: [
      448,
      512,
      [],
      'f532',
      
      'M36.9 47.4c-4.1-1.7-6-6.4-4.3-10.4s6.4-6 10.4-4.3l368 152c3 1.2 4.9 4.2 4.9 7.4s-2 6.2-4.9 7.4l-368 152c-4.1 1.7-8.8-.3-10.4-4.3s.3-8.8 4.3-10.4L387 192 36.9 47.4zM440 464c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H440z'
      
    ]
  };

  

  
  

  var faSquareArrowUp = {
    prefix: 'fat',
    iconName: 'square-arrow-up',
    icon: [
      448,
      512,
      ["arrow-square-up"],
      'f33c',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm229.7 34.3l104 104c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L232 155.3V376c0 4.4-3.6 8-8 8s-8-3.6-8-8V155.3l-90.3 90.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l104-104c3.1-3.1 8.2-3.1 11.3 0z'
      
    ]
  };

  
    var faArrowSquareUp = faSquareArrowUp;
  

  
  

  var faBurgerSoda = {
    prefix: 'fat',
    iconName: 'burger-soda',
    icon: [
      640,
      512,
      [],
      'f858',
      
      'M210.2 30.3L185.8 128H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H191.8h.3H376c4.4 0 8-3.6 8-8s-3.6-8-8-8H202.2l23.5-93.8C228.4 23.5 238 16 249 16h31c4.4 0 8-3.6 8-8s-3.6-8-8-8H249c-18.4 0-34.4 12.5-38.8 30.3zM60.3 468c2.1 24.9 22.9 44 47.8 44H275.8c5.8 0 11.4-1 16.6-2.9c-3.5-4.3-6.6-9-9.2-13.9c-2.4 .6-4.8 .8-7.3 .8H108.2c-16.6 0-30.5-12.8-31.9-29.3L52.1 176H36L60.3 468zM464 215.8c95.1 0 131.4 62.2 141.7 85.1c1.6 3.5 2.3 7.8 2.3 13.2c0 12-9.7 21.8-21.8 21.8H341.8c-12 0-21.8-9.7-21.8-21.8c0-5.3 .8-9.7 2.3-13.2c10.3-22.9 46.5-85.1 141.7-85.1zM304 314c0 10.4 4.2 19.8 11 26.6c-16 7.8-27 24.2-27 43.2c0 18.5 10.4 34.5 25.8 42.6c-6 6.2-9.8 14.7-9.8 24.1c0 33.9 27.5 61.3 61.3 61.3H562.7c33.9 0 61.3-27.5 61.3-61.3c0-9.4-3.7-17.9-9.8-24.1c15.3-8 25.8-24.1 25.8-42.6c0-19-11-35.4-27-43.2c6.8-6.8 11-16.2 11-26.6c0-6.8-1-13.5-3.8-19.7c-11.5-25.7-52.1-94.5-156.2-94.5s-144.7 68.8-156.2 94.5c-2.8 6.2-3.8 12.9-3.8 19.7zm32 37.8h5.8H586.2 592c17.7 0 32 14.3 32 32s-14.3 32-32 32h-2.7H338.7 336c-17.7 0-32-14.3-32-32s14.3-32 32-32zm2.7 80H589.3c10.3 0 18.7 8.4 18.7 18.7c0 25-20.3 45.3-45.3 45.3H365.3c-25 0-45.3-20.3-45.3-45.3c0-10.3 8.4-18.7 18.7-18.7zm35.3-168a10 10 0 1 0 20 0 10 10 0 1 0 -20 0zm90-26a10 10 0 1 0 0 20 10 10 0 1 0 0-20zm70 26a10 10 0 1 0 20 0 10 10 0 1 0 -20 0z'
      
    ]
  };

  

  
  

  var faCabinetFiling = {
    prefix: 'fat',
    iconName: 'cabinet-filing',
    icon: [
      448,
      512,
      [128452],
      'f64b',
      
      'M432 248H16V64c0-26.5 21.5-48 48-48H384c26.5 0 48 21.5 48 48V248zM0 256v8V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V264v-8-8V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V248v8zM432 448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V264H432V448zM144 120c0-4.4 3.6-8 8-8H296c4.4 0 8 3.6 8 8v16c0 4.4 3.6 8 8 8s8-3.6 8-8V120c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24v16c0 4.4 3.6 8 8 8s8-3.6 8-8V120zm8 232c-13.3 0-24 10.7-24 24v16c0 4.4 3.6 8 8 8s8-3.6 8-8V376c0-4.4 3.6-8 8-8H296c4.4 0 8 3.6 8 8v16c0 4.4 3.6 8 8 8s8-3.6 8-8V376c0-13.3-10.7-24-24-24H152z'
      
    ]
  };

  

  
  

  var faListDropdown = {
    prefix: 'fat',
    iconName: 'list-dropdown',
    icon: [
      512,
      512,
      [],
      'e1cf',
      
      'M64 48C37.5 48 16 69.5 16 96v80H496V96c0-26.5-21.5-48-48-48H64zM16 192V416c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V192H16zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM120 272H392c4.4 0 8 3.6 8 8s-3.6 8-8 8H120c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 96H392c4.4 0 8 3.6 8 8s-3.6 8-8 8H120c-4.4 0-8-3.6-8-8s3.6-8 8-8zM349 89.8l35 28 35-28c3.4-2.8 8.5-2.2 11.2 1.2s2.2 8.5-1.2 11.2l-40 32c-2.9 2.3-7.1 2.3-10 0l-40-32c-3.4-2.8-4-7.8-1.2-11.2s7.8-4 11.2-1.2z'
      
    ]
  };

  

  
  

  var faWatchCalculator = {
    prefix: 'fat',
    iconName: 'watch-calculator',
    icon: [
      384,
      512,
      [],
      'f8f0',
      
      'M80 40V64H304l0-24c0-13.3-10.7-24-24-24H104C90.7 16 80 26.7 80 40zM64 65.6V40C64 17.9 81.9 0 104 0H280c22.1 0 40 17.9 40 40V65.6c36.5 7.4 64 39.7 64 78.4V368c0 38.7-27.5 71-64 78.4V472c0 22.1-17.9 40-40 40l-176 0c-22.1 0-40-17.9-40-40l0-25.6C27.5 439 0 406.7 0 368V144c0-38.7 27.5-71 64-78.4zM80 472c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24V448H80l0 24zm0-40H304c35.3 0 64-28.7 64-64V144c0-35.3-28.7-64-64-64H80c-35.3 0-64 28.7-64 64V368c0 35.3 28.6 64 63.9 64l.1 0zm0-288v64H304V144H80zm-16 0c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V144zm72 136a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-32-16a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm88 48a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-16-32a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm136 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-32-16a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM104 392a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM88 360a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm136 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-32-16a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm88 48a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-16-32a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z'
      
    ]
  };

  

  
  

  var faWatchApple = {
    prefix: 'fat',
    iconName: 'watch-apple',
    icon: [
      384,
      512,
      [],
      'e2cb',
      
      'M80 40V64H304l0-24c0-13.3-10.7-24-24-24H104C90.7 16 80 26.7 80 40zM64 65.6V40C64 17.9 81.9 0 104 0H280c22.1 0 40 17.9 40 40V65.6c36.5 7.4 64 39.7 64 78.4V368c0 38.7-27.5 71-64 78.4V472c0 22.1-17.9 40-40 40l-176 0c-22.1 0-40-17.9-40-40l0-25.6C27.5 439 0 406.7 0 368V144c0-38.7 27.5-71 64-78.4zM304 448H80l0 24c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24V448zm64-80V144c0-35.3-28.7-64-64-64H80c-35.3 0-64 28.7-64 64V368c0 35.3 28.6 64 63.9 64l.1 0H304c35.3 0 64-28.7 64-64zM112 256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm16-160a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM240 368a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm16-160a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM192 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-64a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm112 40a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faCruzeiroSign = {
    prefix: 'fat',
    iconName: 'cruzeiro-sign',
    icon: [
      448,
      512,
      [],
      'e152',
      
      'M48 256C48 141.3 143.1 48 260.8 48c54.6 0 104.3 20.1 141.9 53c3.3 2.9 8.4 2.6 11.3-.7s2.6-8.4-.7-11.3c-40.5-35.4-93.9-57-152.5-57C134.6 32 32 132.1 32 256s102.6 224 228.8 224c58.5 0 112-21.5 152.5-57c3.3-2.9 3.7-8 .7-11.3s-8-3.7-11.3-.8c-37.6 33-87.4 53-141.9 53c-12.6 0-24.8-1.1-36.8-3.1V328c0-30.9 25.1-56 56-56c17.6 0 34.2 8.3 44.8 22.4l4.8 6.4c2.6 3.5 7.7 4.3 11.2 1.6s4.2-7.7 1.6-11.2l-4.8-6.4C324 266.7 302.7 256 280 256c-22.6 0-42.8 10.4-56 26.7V264c0-4.4-3.6-8-8-8s-8 3.6-8 8v64V457.6C115.9 434.6 48 352.9 48 256z'
      
    ]
  };

  

  
  

  var faShelvesEmpty = {
    prefix: 'fat',
    iconName: 'shelves-empty',
    icon: [
      640,
      512,
      [],
      'e246',
      
      'M16 8c0-4.4-3.6-8-8-8S0 3.6 0 8V184 440v64c0 4.4 3.6 8 8 8s8-3.6 8-8V448H624v56c0 4.4 3.6 8 8 8s8-3.6 8-8V440 184 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V176H16V8zm0 184H624V432H16V192z'
      
    ]
  };

  

  
  

  var faGarageOpen = {
    prefix: 'fat',
    iconName: 'garage-open',
    icon: [
      640,
      512,
      [],
      'e00b',
      
      'M310.9 20.4c5.8-2.4 12.4-2.4 18.2 0L599.2 131.2c15 6.2 24.8 20.8 24.8 37V504c0 4.4 3.6 8 8 8s8-3.6 8-8V168.2c0-22.7-13.7-43.2-34.7-51.8L335.2 5.6c-9.7-4-20.6-4-30.4 0L34.7 116.4C13.7 125 0 145.5 0 168.2V504c0 4.4 3.6 8 8 8s8-3.6 8-8V168.2c0-16.2 9.8-30.8 24.8-37L310.9 20.4zM112 216c0-4.4 3.6-8 8-8H520c4.4 0 8 3.6 8 8v56H112V216zm0 72H528V504c0 4.4 3.6 8 8 8s8-3.6 8-8V216c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24V504c0 4.4 3.6 8 8 8s8-3.6 8-8V288zm87.4 32l-5.9 18.2C174.1 344.4 160 362.6 160 384V504c0 4.4 3.6 8 8 8s8-3.6 8-8V464H464v40c0 4.4 3.6 8 8 8s8-3.6 8-8V384c0-21.4-14.1-39.6-33.5-45.8L440.6 320H423.8l5.2 16H211l5.2-16H199.4zM432 352c17.7 0 32 14.3 32 32v64H176V384c0-17.7 14.3-32 32-32H432zM224 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm208-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassArrowsRotate = {
    prefix: 'fat',
    iconName: 'magnifying-glass-arrows-rotate',
    icon: [
      512,
      512,
      [],
      'e65e',
      
      'M392 128H296c-3.2 0-6.2-1.9-7.4-4.9s-.6-6.4 1.7-8.7l96-96c2.3-2.3 5.7-3 8.7-1.7s4.9 4.2 4.9 7.4v96c0 4.4-3.6 8-8 8zm0 16c13.3 0 24-10.7 24-24V24c0-9.7-5.8-18.5-14.8-22.2S381.9 .2 375 7L337.1 44.9C301.7 16.8 256.8 0 208 0C95.9 0 4.5 88.7 .2 199.7c-.2 4.4 3.3 8.1 7.7 8.3s8.1-3.3 8.3-7.7C20.2 97.8 104.5 16 208 16c44.4 0 85.2 15 117.7 40.3L279 103c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8h96zM24 288h96c3.2 0 6.2 1.9 7.4 4.9s.6 6.4-1.7 8.7l-96 96c-2.3 2.3-5.7 3-8.7 1.7s-4.9-4.2-4.9-7.4V296c0-4.4 3.6-8 8-8zm0-16c-13.3 0-24 10.7-24 24v96c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l96-96c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8H24zm336.6 77.3c32.6-35.2 53.2-81.6 55.2-132.9c.2-4.4-3.3-8.1-7.7-8.3s-8.1 3.3-8.3 7.7C395.8 318.2 311.4 400 208 400c-44.4 0-85.2-15-117.7-40.3L78.9 371.1C114.3 399.2 159.2 416 208 416c54.6 0 104.2-21 141.3-55.4l149 149c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-149-149z'
      
    ]
  };

  

  
  

  var faFireExtinguisher = {
    prefix: 'fat',
    iconName: 'fire-extinguisher',
    icon: [
      512,
      512,
      [129519],
      'f134',
      
      'M490.1 19.6c3.7 3 5.9 7.6 5.9 12.4v96c0 4.8-2.2 9.3-5.9 12.4s-8.6 4.3-13.3 3.3l-160-32c-7.5-1.5-12.9-8.1-12.9-15.7V80 64c0-7.6 5.4-14.2 12.9-15.7l160-32c4.7-.9 9.6 .3 13.3 3.3zM288 88v8c0 15.3 10.8 28.4 25.7 31.4l160 32c9.4 1.9 19.1-.6 26.6-6.6s11.7-15.2 11.7-24.7V32c0-9.6-4.3-18.7-11.7-24.7s-17.2-8.5-26.6-6.6l-160 32c-15 3-25.7 16.1-25.7 31.4v8H224V32c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32V72H112C50.1 72 0 122.1 0 184c0 4.4 3.6 8 8 8s8-3.6 8-8c0-53 43-96 96-96h16v50.8c-37.8 18-64 56.5-64 101.2V448c0 35.3 28.7 64 64 64h96c35.3 0 64-28.7 64-64V240c0-44.7-26.2-83.2-64-101.2V88h64zM272 240V400H80V240c0-39.7 24.1-73.8 58.5-88.4c.4-.1 .8-.3 1.2-.5c11.2-4.6 23.5-7.1 36.3-7.1s25.1 2.5 36.3 7.1c.4 .2 .8 .4 1.2 .5C247.9 166.2 272 200.3 272 240zM144 32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V132.6c-10.1-3-20.9-4.6-32-4.6s-21.9 1.6-32 4.6V32zM272 416v32c0 26.5-21.5 48-48 48H128c-26.5 0-48-21.5-48-48V416H272z'
      
    ]
  };

  

  
  

  var faArrowsToDottedLine = {
    prefix: 'fat',
    iconName: 'arrows-to-dotted-line',
    icon: [
      448,
      512,
      [],
      'e0a6',
      
      'M317.7 101.7l-88 88c-3.1 3.1-8.2 3.1-11.3 0l-88-88c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L216 164.7V8c0-4.4 3.6-8 8-8s8 3.6 8 8V164.7l74.3-74.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3zM32 240a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm96 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm96 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm112-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM229.7 322.3l88 88c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L232 347.3V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V347.3l-74.3 74.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l88-88c3.1-3.1 8.2-3.1 11.3 0z'
      
    ]
  };

  

  
  

  var faCircleBookOpen = {
    prefix: 'fat',
    iconName: 'circle-book-open',
    icon: [
      512,
      512,
      ["book-circle"],
      'e0ff',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm128-82.5V334.4c3.9-.7 8.7-1.5 14.2-2.3c14-2 32.4-4.1 49.8-4.1c18.7 0 36 6.6 48.3 12.9c2.8 1.4 5.4 2.9 7.7 4.2V173c-.2-.1-.3-.2-.5-.2c-3.2-1.4-7.8-3.3-13.4-5.2c-11.3-3.8-26.4-7.6-42.1-7.6c-15.8 0-32.9 3.8-46.4 7.7c-6.7 1.9-12.3 3.9-16.3 5.3l-1.2 .5zm136-.4V345.1c2.3-1.4 4.9-2.8 7.7-4.2C284 334.6 301.3 328 320 328c17.4 0 35.9 2.1 49.8 4.1c2.7 .4 5.2 .8 7.6 1.2c2.4 .4 4.6 .8 6.6 1.1V173.5l-1.2-.5c-4-1.5-9.6-3.4-16.3-5.3c-13.5-3.9-30.6-7.7-46.4-7.7c-15.7 0-30.8 3.7-42.1 7.6c-5.2 1.8-9.5 3.5-12.6 4.9l-.8 .4c-.2 .1-.3 .2-.5 .2zm-8-13.9c.6-.3 1.3-.6 2-.9c3.5-1.6 8.6-3.7 14.8-5.8c12.3-4.2 29.2-8.4 47.2-8.4c18 0 36.8 4.2 50.9 8.3c7.1 2.1 13.1 4.1 17.3 5.7c2.1 .8 3.8 1.4 5 1.9l1.4 .5 .4 .1 .1 0 0 0 0 0 0 0s0 0-3.1 7.4l3.1-7.4c3 1.2 4.9 4.2 4.9 7.4V344c0 2.4-1.1 4.7-3 6.2s-4.3 2.1-6.7 1.6L392 344l-1.6 7.8 0 0 0 0 0 0-.1 0-.3-.1-1.2-.2c-1.1-.2-2.7-.5-4.7-.9c-4-.7-9.8-1.7-16.6-2.7c-13.6-2-31.2-3.9-47.5-3.9c-15.1 0-29.8 5.4-41 11.1c-5.6 2.8-10.1 5.7-13.3 7.8c-1.6 1.1-2.8 1.9-3.6 2.5c-.4 .3-.7 .5-.9 .7l-.2 .2 0 0-5-6.3c5 6.3 5 6.3 5 6.3c-2.9 2.3-7 2.3-9.9 0l0 0 0 0s0 0 5-6.3l-5 6.3 0 0-.2-.2c-.2-.1-.5-.4-.9-.7c-.8-.6-2-1.5-3.6-2.5c-3.2-2.1-7.7-4.9-13.3-7.8c-11.2-5.7-25.9-11.1-41-11.1c-16.3 0-33.9 1.9-47.5 3.9c-6.8 1-12.5 2-16.6 2.7c-2 .4-3.6 .7-4.7 .9l-1.2 .2-.3 .1-.1 0 0 0 0 0L120 344c1.6 7.8 1.6 7.8 1.6 7.8l0 0c-2.4 .5-4.8-.1-6.7-1.6s-3-3.8-3-6.2V168c0-3.2 1.9-6.1 4.9-7.4L120 168l-3.1-7.4 0 0 0 0 0 0 .1 0 .4-.1 1.4-.5c1.2-.5 2.9-1.1 5-1.9c4.2-1.5 10.3-3.6 17.3-5.7c14.1-4.1 32.9-8.3 50.9-8.3c18.1 0 35 4.3 47.2 8.4c6.2 2.1 11.2 4.2 14.8 5.8c.7 .3 1.4 .6 2 .9z'
      
    ]
  };

  
    var faBookCircle = faCircleBookOpen;
  

  
  

  var faArrowsRotate = {
    prefix: 'fat',
    iconName: 'arrows-rotate',
    icon: [
      512,
      512,
      [128472,"refresh","sync"],
      'f021',
      
      'M43.6 224c-4.9 0-8.7-4.3-7.8-9.2c9.7-51.8 37.5-100.4 82.3-135.3c97.5-76.2 238.3-58.9 314.4 38.6l.1 .1 0 0 0 0L464 160V72c0-4.4 3.6-8 8-8s8 3.6 8 8V184c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8s3.6-8 8-8h96l-36.1-48.1C349.1 37.4 218.4 21.4 127.9 92.1c-41.4 32.3-67.2 77.2-76.3 125.1c-.7 3.9-4.1 6.8-8.1 6.8zm-3.4 96h112c4.4 0 8 3.6 8 8s-3.6 8-8 8H54.9L91 384.1c70.7 90.5 201.4 106.5 291.9 35.8c41.4-32.4 67.2-77.3 76.3-125.1c.7-3.9 4.1-6.8 8.1-6.8c4.9 0 8.7 4.3 7.8 9.2c-9.7 51.8-37.5 100.4-82.3 135.4c-97.5 76.2-238.3 58.9-314.4-38.6l-.1-.1 0 0 0 0-30.1-40V440c0 4.4-3.6 8-8 8s-8-3.6-8-8V328c0-4.4 3.6-8 8-8z'
      
    ]
  };

  
    var faRefresh = faArrowsRotate;
  
    var faSync = faArrowsRotate;
  

  
  

  var faBorderTop = {
    prefix: 'fat',
    iconName: 'border-top',
    icon: [
      448,
      512,
      [],
      'f855',
      
      'M0 40c0-4.4 3.6-8 8-8H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8zM48 160a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm352 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-160 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM16 352a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm416 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-224 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM48 256a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm352 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-160 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM16 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm416 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-224 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM144 256a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM112 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm224 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM304 256a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faMugTea = {
    prefix: 'fat',
    iconName: 'mug-tea',
    icon: [
      576,
      512,
      [],
      'f875',
      
      'M152 80v37l-46.1 52.7C99.5 177 96 186.3 96 196v52c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V196c0-9.7-3.5-19-9.9-26.3L168 117V80H336h32V272v16 64c0 44.2-35.8 80-80 80H96c-44.2 0-80-35.8-80-80V96c0-8.8 7.2-16 16-16H152zM384 352V288h48c61.9 0 112-50.1 112-112s-50.1-112-112-112H384 368 336 32C14.3 64 0 78.3 0 96V352c0 53 43 96 96 96H288c53 0 96-43 96-96zm48-80H384V80h48c53 0 96 43 96 96s-43 96-96 96zM117.9 180.2L160 132.1l42.1 48.1c3.8 4.4 5.9 10 5.9 15.8v52c0 13.3-10.7 24-24 24H136c-13.3 0-24-10.7-24-24V196c0-5.8 2.1-11.4 5.9-15.8z'
      
    ]
  };

  

  
  

  var faBurgerFries = {
    prefix: 'fat',
    iconName: 'burger-fries',
    icon: [
      640,
      512,
      [],
      'e0cd',
      
      'M171 24.2l48 19.2c3 1.2 5 4.2 5 7.4V269.8c6-.9 11.3-2.1 16-3.4V50.8c0-9.8-6-18.6-15.1-22.3l-48-19.2C161.1 3 144 14.7 144 31.6V266.4c4.7 1.3 10 2.5 16 3.4V31.6c0-5.7 5.7-9.5 11-7.4zM73.8 58.3c-.6-3.5 1.2-6.9 4.3-8.4l33.9-17V15.1L70.9 35.6c-9.4 4.7-14.6 14.9-13 25.3L80.5 199.5c8.9 5.7 15.5 13.9 19.8 22.2L73.8 58.3zM15.8 94.4c-.9-4.3-5.1-7.1-9.4-6.3S-.7 93.2 .2 97.6L19 192.1c.8 0 1.6-.1 2.4-.1H35.4L15.8 94.4zm368 3.1c.9-4.3-1.9-8.5-6.3-9.4s-8.5 1.9-9.4 6.3L348.6 192h13.5c1.1-.6 2.1-1.1 3.2-1.7l18.6-92.8zM192 304c-89.3 0-112.4-39-118.2-62.5c-2.3-9.2-10-17.5-19.5-17.5H21.4C9.6 224 0 233.6 0 245.4c0 1.7 .2 3.4 .6 5.1l57.5 237C61.5 501.9 74.4 512 89.2 512H294.8h0c-4.3-4.9-8-10.3-11.2-16H89.2c-7.4 0-13.8-5.1-15.5-12.2l-57.5-237c-.1-.4-.2-.8-.2-1.3c0-3 2.4-5.4 5.4-5.4H54.3l0 0c0 0 .1 0 .2 .1c.2 .1 .6 .3 1.2 .8c1.1 1 2.1 2.7 2.5 4.4c3.6 14.7 12.6 33.9 34 49.2C113.4 309.8 145.1 320 192 320c34.3 0 60.5-5.5 80.4-14.4c.6-6.5 2-13.4 4.7-20.5C259.2 296 232.4 304 192 304zM330.8 81.4c3.6-16.9-11.3-31.9-28.2-28.5L272 59V75.4l33.7-6.7c5.6-1.1 10.6 3.9 9.4 9.5L285.3 218.9c4.7-8.1 11.6-15.8 20.8-20.9L330.8 81.4zM464 215.8c95.1 0 131.4 62.2 141.6 85.1c1.6 3.5 2.4 7.8 2.4 13.2c0 12-9.8 21.8-21.8 21.8H341.8c-12 0-21.8-9.8-21.8-21.8c0-5.3 .8-9.7 2.3-13.2c10.3-22.9 46.5-85.1 141.7-85.1zM304 314c0 10.4 4.2 19.8 11 26.6c-16 7.8-27 24.2-27 43.2c0 18.5 10.4 34.5 25.8 42.5c-6 6.2-9.8 14.7-9.8 24.1c0 33.9 27.5 61.3 61.3 61.3H562.7c33.9 0 61.3-27.5 61.3-61.3c0-9.4-3.7-17.9-9.8-24.1c15.3-8 25.8-24.1 25.8-42.5c0-19-11-35.4-27-43.2c6.8-6.8 11-16.2 11-26.6c0-6.8-1-13.5-3.8-19.7c-11.5-25.7-52.1-94.5-156.2-94.5s-144.7 68.8-156.2 94.5c-2.8 6.2-3.8 12.9-3.8 19.7zm32 37.8h5.8H586.2 592c17.7 0 32 14.3 32 32s-14.3 32-32 32h-2.7H338.7 336c-17.7 0-32-14.3-32-32s14.3-32 32-32zm2.7 80H589.3c10.3 0 18.7 8.4 18.7 18.7c0 25-20.3 45.3-45.3 45.3H365.3c-25 0-45.3-20.3-45.3-45.3c0-10.3 8.4-18.7 18.7-18.7zm35.3-168a10 10 0 1 0 20 0 10 10 0 1 0 -20 0zm90-26a10 10 0 1 0 0 20 10 10 0 1 0 0-20zm70 26a10 10 0 1 0 20 0 10 10 0 1 0 -20 0z'
      
    ]
  };

  

  
  

  var faGuaraniSign = {
    prefix: 'fat',
    iconName: 'guarani-sign',
    icon: [
      384,
      512,
      [],
      'e19a',
      
      'M184 0c-4.4 0-8 3.6-8 8V64.7C77.4 72.8 0 155.3 0 256S77.4 439.2 176 447.3V504c0 4.4 3.6 8 8 8s8-3.6 8-8V448c106 0 192-86 192-192c0-4.4-3.6-8-8-8H192V80c48 0 91.4 19.2 123.2 50.3c3.2 3.1 8.2 3 11.3-.1s3-8.2-.1-11.3C291.8 84.9 244.3 64 192 64V8c0-4.4-3.6-8-8-8zm-8 80.7V431.3C86.3 423.2 16 347.8 16 256S86.3 88.8 176 80.7zM192 432V264H367.8c-4.2 93.5-81.3 168-175.8 168z'
      
    ]
  };

  

  
  

  var faGingerbreadMan = {
    prefix: 'fat',
    iconName: 'gingerbread-man',
    icon: [
      448,
      512,
      [],
      'f79d',
      
      'M136 104c0-48.6 39.4-88 88-88s88 39.4 88 88c0 22.5-8.5 43.1-22.4 58.7c-2.1 2.4-2.6 5.7-1.3 8.6s4.1 4.7 7.3 4.7H360c30.9 0 56 25.1 56 56s-25.1 56-56 56h-8.3c-26.2 0-40.1 30.9-22.8 50.6l57 64.3c20.5 23.1 18.4 58.5-4.8 79s-58.5 18.4-79.1-4.8l-55.3-62.4c-12.1-13.7-33.4-13.7-45.5 0l-55.3 62.4c-20.5 23.1-55.9 25.3-79.1 4.8s-25.3-55.9-4.8-79l57-64.3c17.4-19.6 3.5-50.6-22.8-50.6H88c-30.9 0-56-25.1-56-56s25.1-56 56-56h64.4c3.2 0 6-1.9 7.3-4.7s.8-6.2-1.3-8.6C144.5 147.1 136 126.5 136 104zM224 0C166.6 0 120 46.6 120 104c0 20.6 6 39.8 16.4 56H88c-39.8 0-72 32.2-72 72s32.2 72 72 72h8.3c12.4 0 19 14.7 10.8 23.9l-57 64.3C23.7 422 26.5 467.5 56.3 493.9s75.3 23.6 101.6-6.1l55.3-62.4c5.7-6.5 15.8-6.5 21.6 0l55.3 62.4c26.4 29.8 71.9 32.5 101.6 6.1s32.5-71.9 6.1-101.6l-57-64.3c-8.2-9.3-1.6-23.9 10.8-23.9H360c39.8 0 72-32.2 72-72s-32.2-72-72-72H311.6C322 143.8 328 124.6 328 104C328 46.6 281.4 0 224 0zM192 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm32 128a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM272 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM224 368a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16-80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faCommentQuestion = {
    prefix: 'fat',
    iconName: 'comment-question',
    icon: [
      512,
      512,
      [],
      'e14b',
      
      'M157.3 415c-5-1.8-10.6-1-14.9 2.1c-11 8-29.4 19.3-51.2 28.8C68.3 456 41.6 464 16 464l.1-.1 0 0 0 0 .3-.3 .1-.1c.4-.4 .9-.9 1.5-1.6c1.3-1.4 3.2-3.6 5.4-6.3l-12.2-10 12.2 10C28 450 34 442 40 432c10.7-17.9 21.4-42.1 23.6-69.9c.3-4.3-1.1-8.6-3.9-11.8C31.9 318.8 16 280.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-35.2 0-68.6-6.1-98.7-17zM4.7 452.7l0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0zM168 168l0 6.5c0 4.4 3.6 8 8 8s8-3.6 8-8l0-6.5c0-22.1 17.9-40 40-40h56.2c26.4 0 47.8 21.4 47.8 47.8c0 16.1-8.1 31.1-21.5 39.9l-54.9 36.2c-2.2 1.5-3.6 4-3.6 6.7V288c0 4.4 3.6 8 8 8s8-3.6 8-8V262.9L315.3 229c17.9-11.8 28.7-31.8 28.7-53.3c0-35.2-28.6-63.8-63.8-63.8H224c-30.9 0-56 25.1-56 56zM272 336a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faAlicorn = {
    prefix: 'fat',
    iconName: 'alicorn',
    icon: [
      640,
      512,
      [],
      'f6b0',
      
      'M328 136c0-66.3 53.7-120 120-120h8 16 21.8c28.9 0 53 21.9 55.7 50.7l7 73.8c1.8 18.5-8.1 36.2-24.7 44.6c-22.3 11.1-49.3 2.1-60.5-20.2l-8.3-16.5c-1.4-2.7-4.1-4.4-7.2-4.4H440c-4.4 0-8 3.6-8 8v87.5 .4l0 .1c-.2 25.4-11.6 47.6-29.2 62.5c-1.8 1.5-2.8 3.8-2.8 6.1V480c0 8.8-7.2 16-16 16H344c-8.8 0-16-7.2-16-16V325.7c0-3.8-2.6-7-6.3-7.8L198.3 290.8c-2.7-.6-5.5 .2-7.4 2.2s-2.7 4.8-2.1 7.5c2.1 9 3.2 18.1 3.2 27.4c0 16.1-3.3 32.1-9.6 46.9l-6.5 15.3c-3.6 8.4-4.2 17.7-1.8 26.5l16.5 59.3c2.8 10.2-4.8 20.3-15.4 20.3H125.3c-7.2 0-13.5-4.8-15.4-11.7L97 437.8c-7.3-26.3-5.4-54.3 5.3-79.4l6.5-15.3c2.1-4.8 3.2-10.1 3.2-15.3c0-5.1-1-10.2-3-15L77.1 236.3c-3.4-8.1-5.1-16.8-5.1-25.6c0-28.2 17.6-52.4 42.4-62.1c-1.9-4.9-3.6-9.9-5.2-15.1c-14.3 5.4-26.6 14.7-35.8 26.6H72 64c-35.3 0-64 28.7-64 64v88c0 4.4 3.6 8 8 8s8-3.6 8-8V224c0-26.4 21.3-47.8 47.6-48c-4.9 10.5-7.6 22.3-7.6 34.7c0 10.9 2.2 21.7 6.4 31.8L94.2 319c1.2 2.8 1.8 5.8 1.8 8.8c0 3.1-.6 6.2-1.9 9l-6.5 15.3c-12.2 28.4-14.3 60.2-6 90l12.9 46.5c3.8 13.9 16.5 23.4 30.8 23.4h49.8c21.2 0 36.5-20.2 30.8-40.6l-16.5-59.3c-1.5-5.3-1.1-10.9 1.1-15.9l6.5-15.3c7.2-16.8 10.9-34.9 10.9-53.2c0-6.3-.4-12.6-1.3-18.8L312 332.1V480c0 17.7 14.3 32 32 32h40c17.7 0 32-14.3 32-32V312.1c19.3-17.7 31.8-43.1 32-71.9l0-.2v-.5V160h3.1l6.1 12.1c15.1 30.2 51.8 42.4 81.9 27.3c22.6-11.3 35.9-35.3 33.5-60.4l-5.1-53.6 65-28.9c4.6-2.1 7.6-6.7 7.6-11.7c0-7.1-5.8-12.8-12.8-12.8H553.7c-4.1-6.1-9-11.4-14.6-16H552c4.4 0 8-3.6 8-8s-3.6-8-8-8H493.8 472 456h-8C376.7 0 318.2 54.8 312.5 124.6L139.8 32.9c-2.5-1.3-5.5-1.2-7.9 .2s-3.9 4-3.9 6.9c0 34.4 4.9 63.5 13 88c1.8 5.6 3.8 10.9 6 16c14.3 34.2 35 58.4 56 75.2c18.8 15.1 37.6 24.3 51.7 29.6c7.1 2.7 13 4.4 17.2 5.5c2.1 .5 3.8 .9 4.9 1.2c.6 .1 1 .2 1.4 .3l.4 .1 .1 0 0 0 0 0s0 0 1.3-7.9l-1.3 7.9c4.4 .7 8.5-2.2 9.2-6.6s-2.2-8.5-6.6-9.2l0 0 0 0-.2 0c-.2 0-.6-.1-1-.2c-.9-.2-2.4-.5-4.2-1c-3.7-1-9-2.5-15.5-5c-12.9-4.9-30.1-13.3-47.3-27.1c-32.4-26.1-65.4-72.2-68.7-153.3L313 143.1c1.2 .6 2.4 .9 3.8 .9H320c2 0 3.8-.7 5.2-1.9c1.7-1.5 2.8-3.7 2.8-6.1zM561.7 48h50.6L565.8 68.7l-.3-3.5c-.6-6-1.9-11.7-3.8-17.2zM512 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faAlarmPlus = {
    prefix: 'fat',
    iconName: 'alarm-plus',
    icon: [
      512,
      512,
      [],
      'f844',
      
      'M93.7 0C42 0 0 42 0 93.7c0 18.5 5.4 35.8 14.6 50.3c2.4 3.7 7.3 4.8 11 2.4s4.8-7.3 2.4-11C20.4 123.4 16 109.1 16 93.7C16 50.8 50.8 16 93.7 16c20.4 0 39 7.9 52.8 20.7c3.2 3 8.3 2.8 11.3-.4s2.8-8.3-.4-11.3C140.7 9.5 118.3 0 93.7 0zM45.7 509.7l57.7-57.7C143.4 489.2 197 512 256 512s112.6-22.8 152.6-60.1l57.7 57.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-57.7-57.7C457.2 400.6 480 347 480 288C480 164.3 379.7 64 256 64S32 164.3 32 288c0 59 22.8 112.6 60.1 152.6L34.3 498.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0zM256 80a208 208 0 1 1 0 416 208 208 0 1 1 0-416zM418.3 0c-24.6 0-47 9.5-63.7 25c-3.2 3-3.4 8.1-.4 11.3s8.1 3.4 11.3 .4C379.3 23.9 397.9 16 418.3 16C461.2 16 496 50.8 496 93.7c0 15.4-4.4 29.7-12.1 41.7c-2.4 3.7-1.3 8.7 2.4 11s8.7 1.3 11-2.4c9.3-14.5 14.6-31.8 14.6-50.3C512 42 470 0 418.3 0zM256 184c-4.4 0-8 3.6-8 8v88H160c-4.4 0-8 3.6-8 8s3.6 8 8 8h88v88c0 4.4 3.6 8 8 8s8-3.6 8-8V296h88c4.4 0 8-3.6 8-8s-3.6-8-8-8H264V192c0-4.4-3.6-8-8-8z'
      
    ]
  };

  

  
  

  var faMattressPillow = {
    prefix: 'fat',
    iconName: 'mattress-pillow',
    icon: [
      640,
      512,
      [],
      'e525',
      
      'M256 80V432H64c-26.5 0-48-21.5-48-48V128c0-26.5 21.5-48 48-48H256zm16 0H576c26.5 0 48 21.5 48 48V384c0 26.5-21.5 48-48 48H272V80zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm112 80c17.7 0 32 14.3 32 32V336c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V176c0-17.7 14.3-32 32-32h64zm-64-16c-26.5 0-48 21.5-48 48V336c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H112z'
      
    ]
  };

  

  
  

  var faMemoPad = {
    prefix: 'fat',
    iconName: 'memo-pad',
    icon: [
      448,
      512,
      [],
      'e1da',
      
      'M16 128V448c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V128H16zm0-16H432V64c0-26.5-21.5-48-48-48H64C37.5 16 16 37.5 16 64v48zM448 64v48 8 8V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128v-8-8V64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64zM104 208H344c4.4 0 8 3.6 8 8s-3.6 8-8 8H104c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 96H344c4.4 0 8 3.6 8 8s-3.6 8-8 8H104c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 96H248c4.4 0 8 3.6 8 8s-3.6 8-8 8H104c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faRabbitRunning = {
    prefix: 'fat',
    iconName: 'rabbit-running',
    icon: [
      576,
      512,
      ["rabbit-fast"],
      'f709',
      
      'M498.1 173.6l-7.4-5.1c-15.7-10.7-34.3-16.5-53.4-16.5c-2.5 0-4.9 .1-7.4 .3l-.1-.4-3.7-14.6c-11.7-46.4-46.3-83.6-91.8-98.6c-7.7-2.6-16.2-1.7-23.3 2.4l-2.1 1.2c-13.5 7.8-20 23.7-15.8 38.6l10.2 37c4.9 17.9 13.4 34.3 24.7 48.5l-80-36.3c-14.7-6.7-30.7-10.1-46.8-10.1h-9c-30.4 0-57.8 13-76.8 33.8C103.7 138.1 85 128 64 128c-35.3 0-64 28.7-64 64s28.7 64 64 64c9.7 0 19-2.2 27.2-6.1c4.6 18 13.9 34.6 27.3 47.9L182 361.3l-68.2 45.4c-18.4 12.3-23.3 37.1-11.1 55.5s37.1 23.3 55.5 11.1L239.7 419l15.9 15.9c13.5 13.5 31.8 21.1 50.9 21.1H424c22.1 0 40-17.9 40-40s-17.9-40-40-40H353.1l40-48H509.8c36.6 0 66.2-29.6 66.2-66.2c0-21.9-10.8-42.3-28.8-54.6l-34.4-23.5c8.8-51.4-8-104.3-45.7-141.3l-1.4-1.4c-7.6-7.4-18.3-10.6-28.7-8.6l-1.6 .3c-11.1 2.1-20.1 10-23.9 20.5c4.5 4.2 8.9 8.6 13 13.3c.5-2.3 1.1-4.6 1.7-6.8c1.6-5.7 6.3-10.1 12.2-11.2L440 48c5.2-1 10.6 .6 14.5 4.4l1.4 1.4c32.2 31.5 47.4 75.9 42.2 119.8zM88 224.2c0 3.1 .1 6.1 .4 9.2C81.3 237.6 72.9 240 64 240c-26.5 0-48-21.5-48-48s21.5-48 48-48c17.4 0 32.6 9.2 41 23.1c-10.8 16.4-17 36-17 57.1zM193.5 372.8l34.6 34.6L149.3 460c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l70.8-47.2zM329.3 53.9c40.3 13.3 70.9 46.2 81.3 87.4l3.7 14.6c.4 1.7 .6 3.5 .5 5.2c-.2 2.5 .9 4.9 2.8 6.6s4.4 2.3 6.9 1.8c4.1-.9 8.4-1.3 12.8-1.3c15.8 0 31.3 4.8 44.3 13.7l56.6 38.7c13.7 9.4 21.9 24.9 21.9 41.4c0 27.7-22.5 50.2-50.2 50.2H389.3c-2.4 0-4.6 1.1-6.1 2.9L336 371.5V352c0-42-25.2-79.9-64-96l-36.9-15.4c-4.1-1.7-8.8 .2-10.5 4.3s.2 8.8 4.3 10.5l36.9 15.4C298.6 284.4 320 316.5 320 352v32c0 4.4 3.6 8 8 8h24l72 0c13.3 0 24 10.7 24 24s-10.7 24-24 24H306.5c-14.9 0-29.1-5.9-39.6-16.4L129.8 286.5c-16.5-16.5-25.8-39-25.8-62.3c0-48.7 39.5-88.2 88.2-88.2h9c13.9 0 27.6 3 40.2 8.7l131.2 59.6c3.9 1.8 8.4 .2 10.4-3.6c.2-.4 .5-.9 .7-1.3c1.2-2.1 1.3-4.6 .4-6.8s-2.7-3.9-5-4.7c-.7-.2-1.4-.5-2.1-.9c-28.6-15.5-49.6-42-58.3-73.4l-10.2-37c-2.2-8 1.3-16.4 8.4-20.5l2.1-1.2c3.1-1.8 6.8-2.2 10.3-1.1zM496 240a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  
    var faRabbitFast = faRabbitRunning;
  

  
  

  var faHandshakeSimpleSlash = {
    prefix: 'fat',
    iconName: 'handshake-simple-slash',
    icon: [
      640,
      512,
      ["handshake-alt-slash"],
      'e05f',
      
      'M13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7zM398.2 399.3l-20-15.8c2.1 11.7-1.1 24.2-9.6 33.7c-15.4 17.3-42.2 18.1-58.6 1.7l-11.1-11.1c-1.7-1.7-4-2.5-6.4-2.3s-4.5 1.5-5.9 3.5c-1.9 2.8-4.2 5.4-6.9 7.8c-16.9 15.1-42.7 14.4-58.8-1.6l-39.9-39.9-20.6-20.6c-12-12-28.3-18.7-45.3-18.7H48c-4.4 0-8 3.6-8 8s3.6 8 8 8h67.4c12.7 0 24.9 5.1 33.9 14.1l20.6 20.6 15.4 15.4 .1 .1 24.4 24.4c22.1 22.1 57.5 23.1 80.8 2.2c1.2-1.1 2.3-2.2 3.4-3.3l4.8 4.8c22.9 22.9 60.3 21.8 81.9-2.4c7.9-8.8 12.4-19.5 13.8-30.4c1.3 .7 2.5 1.3 3.8 1.9zM267.6 133.1l12.7 10 36.5-34.6c19.3-18.3 45-28.5 71.6-28.5c24.5 0 48.2 8.6 67 24.4l44.9 37.7c1.4 1.2 3.3 1.9 5.1 1.9H600c4.4 0 8-3.6 8-8s-3.6-8-8-8H508.4L465.8 92.2C444.1 74 416.7 64 388.5 64c-30.7 0-60.3 11.8-82.6 32.9l-38.2 36.2zm81.9 64.6l12.7 10L375 195.9c3.2-3 3.4-8.1 .5-11.3s-8.1-3.4-11.3-.5l-14.7 13.6zM211.3 88.6C225.4 83 240.5 80 255.9 80h21.2L294 64H255.9c-20.5 0-40.6 4.6-58.9 13.4l14.2 11.2zM54.6 128H40c-4.4 0-8 3.6-8 8s3.6 8 8 8H74.8L54.6 128zM544.9 352H600c4.4 0 8-3.6 8-8s-3.6-8-8-8H524.6l20.3 16z'
      
    ]
  };

  
    var faHandshakeAltSlash = faHandshakeSimpleSlash;
  

  
  

  var faCatSpace = {
    prefix: 'fat',
    iconName: 'cat-space',
    icon: [
      640,
      512,
      [],
      'e001',
      
      'M448 304a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0 16c-77.6 0-142.3-55.2-156.9-128.5C186.4 219.1 112 314.1 112 424v16c0 30.9 25.1 56 56 56h16H328h26.7c7.4 0 13.3-6 13.3-13.3c0-19.1-15.5-34.7-34.7-34.7H288c-4.4 0-8-3.6-8-8l0 0V400c0-26.5-21.5-48-48-48H200c-4.4 0-8-3.6-8-8s3.6-8 8-8h32c35.3 0 64 28.7 64 64v30.3l125.5-85c2.5-1.7 5.6-1.8 8.2-.4s4.2 4.1 4.2 7.1V473c0 12.7 10.3 23 23 23s23-10.3 23-23V316.8c-10.3 2.1-21 3.2-32 3.2zM608 160c0 71.6-47.1 132.3-112 152.7V473c0 21.5-17.5 39-39 39s-39-17.5-39-39V367.1L322.1 432h11.2c28 0 50.7 22.7 50.7 50.7c0 16.2-13.1 29.3-29.3 29.3H328 184 168c-39.8 0-72-32.2-72-72V424 168.5c0-28.2-21-52.1-49.1-55.6l-7.9-1c-4.4-.5-7.5-4.5-6.9-8.9s4.5-7.5 8.9-6.9l7.9 1c36 4.5 63.1 35.1 63.1 71.4V334.7c28.8-77.4 94-138 176.8-159.2c-.5-5.1-.8-10.3-.8-15.6C288 71.6 359.6 0 448 0s160 71.6 160 160zM373 65.8L410.8 96h74.4L523 65.8c2.4-1.9 5.7-2.3 8.5-1s4.5 4.1 4.5 7.2v96c0 48.6-39.4 88-88 88s-88-39.4-88-88V72c0-3.1 1.8-5.9 4.5-7.2s6.1-1 8.5 1zM376 168c0 39.8 32.2 72 72 72s72-32.2 72-72V88.6l-27 21.6c-1.4 1.1-3.2 1.8-5 1.8H408c-1.8 0-3.6-.6-5-1.8L376 88.6V168zm24-8a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM232 16V56h40c4.4 0 8 3.6 8 8s-3.6 8-8 8H232v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V72H176c-4.4 0-8-3.6-8-8s3.6-8 8-8h40V16c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faDrawCircle = {
    prefix: 'fat',
    iconName: 'draw-circle',
    icon: [
      512,
      512,
      [],
      'f5ed',
      
      'M256 80a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm46.1-18.7C296.3 81.4 277.9 96 256 96s-40.3-14.6-46.1-34.7C136.5 78.7 78.7 136.5 61.3 209.9C81.4 215.7 96 234.1 96 256s-14.6 40.3-34.7 46.1c17.3 73.4 75.1 131.2 148.5 148.5c5.8-20 24.2-34.7 46.1-34.7s40.3 14.6 46.1 34.7c73.4-17.3 131.2-75.1 148.5-148.5c-20-5.8-34.7-24.2-34.7-46.1s14.6-40.3 34.7-46.1C433.3 136.5 375.5 78.7 302.1 61.3zM466.7 208.1c25.3 1.4 45.3 22.3 45.3 47.9s-20.1 46.5-45.3 47.9c-18.3 80.8-81.9 144.4-162.7 162.7C302.5 491.9 281.6 512 256 512s-46.5-20.1-47.9-45.3C127.3 448.4 63.6 384.7 45.3 303.9C20.1 302.5 0 281.6 0 256s20.1-46.5 45.3-47.9C63.6 127.3 127.3 63.6 208.1 45.3C209.5 20.1 230.4 0 256 0s46.5 20.1 47.9 45.3c80.8 18.3 144.4 81.9 162.7 162.7zM256 496a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM80 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm384 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faEnvelopeOpen = {
    prefix: 'fat',
    iconName: 'envelope-open',
    icon: [
      512,
      512,
      [62135],
      'f2b6',
      
      'M232 23.9L35.4 169.5C23.2 178.6 16 192.9 16 208.1v8.4l1.6 1.3L232.7 394.5c6.6 5.4 14.8 8.3 23.3 8.3s16.7-2.9 23.3-8.3L494.4 217.8l1.6-1.3v-8.4c0-15.2-7.2-29.5-19.4-38.6L280 23.9C273 18.8 264.6 16 256 16s-17 2.8-24 7.9zM16 237.2V448c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V237.2L289.4 406.9c-9.4 7.7-21.2 12-33.4 12s-24-4.2-33.4-12L16 237.2zM222.5 11C232.2 3.9 243.9 0 256 0s23.8 3.9 33.5 11L486.1 156.7c16.3 12.1 25.9 31.1 25.9 51.4V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V208.1c0-20.3 9.6-39.4 25.9-51.4L222.5 11z'
      
    ]
  };

  

  
  

  var faListTree = {
    prefix: 'fat',
    iconName: 'list-tree',
    icon: [
      512,
      512,
      [],
      'e1d2',
      
      'M24 64c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8H40 56 72c4.4 0 8-3.6 8-8V72c0-4.4-3.6-8-8-8H24zm16 80H24c-13.3 0-24-10.7-24-24V72C0 58.7 10.7 48 24 48H72c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H56V256h72V232c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24v-8H56V392c0 13.3 10.7 24 24 24h48V392c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24v-8H80c-22.1 0-40-17.9-40-40V264 144zM144 416v16 8c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V392c0-4.4-3.6-8-8-8H152c-4.4 0-8 3.6-8 8v24zm0-136c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8H152c-4.4 0-8 3.6-8 8v24 16 8zM168 96c0-4.4 3.6-8 8-8H496c4.4 0 8 3.6 8 8s-3.6 8-8 8H176c-4.4 0-8-3.6-8-8zM296 256c0-4.4 3.6-8 8-8H496c4.4 0 8 3.6 8 8s-3.6 8-8 8H304c-4.4 0-8-3.6-8-8zm0 160c0-4.4 3.6-8 8-8H496c4.4 0 8 3.6 8 8s-3.6 8-8 8H304c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faLollipop = {
    prefix: 'fat',
    iconName: 'lollipop',
    icon: [
      512,
      512,
      [127853,"lollypop"],
      'e424',
      
      'M192 368c-51.8 0-98.4-22.4-130.6-58.1C84.8 326.4 113.3 336 144 336h16c70.7 0 128-57.3 128-128V192c0-53-43-96-96-96s-96 43-96 96c0 30.9 25.1 56 56 56s56-25.1 56-56v-8c0-4.4-3.6-8-8-8s-8 3.6-8 8v8c0 22.1-17.9 40-40 40s-40-17.9-40-40c0-44.2 35.8-80 80-80s80 35.8 80 80v16c0 61.9-50.1 112-112 112H144C73.3 320 16 262.7 16 192C16 94.8 94.8 16 192 16s176 78.8 176 176s-78.8 176-176 176zM0 192C0 298 86 384 192 384c50.1 0 95.8-19.2 130-50.7c.1 .1 .2 .2 .3 .4l176 176c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-176-176c-.1-.1-.2-.2-.4-.3c31.5-34.2 50.7-79.9 50.7-130C384 86 298 0 192 0S0 86 0 192z'
      
    ]
  };

  
    var faLollypop = faLollipop;
  

  
  

  var faSignalStrong = {
    prefix: 'fat',
    iconName: 'signal-strong',
    icon: [
      640,
      512,
      ["signal-4"],
      'f68f',
      
      'M456 104c0-4.4-3.6-8-8-8s-8 3.6-8 8V504c0 4.4 3.6 8 8 8s8-3.6 8-8V104zM320 192c-4.4 0-8 3.6-8 8V504c0 4.4 3.6 8 8 8s8-3.6 8-8V200c0-4.4-3.6-8-8-8zM200 296c0-4.4-3.6-8-8-8s-8 3.6-8 8V504c0 4.4 3.6 8 8 8s8-3.6 8-8V296zM72 392c0-4.4-3.6-8-8-8s-8 3.6-8 8V504c0 4.4 3.6 8 8 8s8-3.6 8-8V392z'
      
    ]
  };

  
    var faSignal4 = faSignalStrong;
  

  
  

  var faUserLargeSlash = {
    prefix: 'fat',
    iconName: 'user-large-slash',
    icon: [
      640,
      512,
      ["user-alt-slash"],
      'f4fa',
      
      'M528.1 512l-20.3-16H94.7c-8.1 0-14.7-6.6-14.7-14.7C80 401 145 336 225.3 336h79.9l-20.3-16H225.3C136.2 320 64 392.2 64 481.3c0 17 13.8 30.7 30.7 30.7H528.1zM456 136C456 60.9 395.1 0 320 0c-51.3 0-95.9 28.4-119.1 70.3l12.8 10.1C233.7 42.1 273.8 16 320 16c66.3 0 120 53.7 120 120c0 36.1-15.9 68.5-41.2 90.5l12.8 10.1C438.9 211.7 456 175.8 456 136zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  
    var faUserAltSlash = faUserLargeSlash;
  

  
  

  var faChalkboard = {
    prefix: 'fat',
    iconName: 'chalkboard',
    icon: [
      576,
      512,
      ["blackboard"],
      'f51b',
      
      'M80 48C62.3 48 48 62.3 48 80V432H32V80c0-26.5 21.5-48 48-48H496c26.5 0 48 21.5 48 48V432H528V80c0-17.7-14.3-32-32-32H80zM0 472c0-4.4 3.6-8 8-8H256V424c0-22.1 17.9-40 40-40h80c22.1 0 40 17.9 40 40v40H568c4.4 0 8 3.6 8 8s-3.6 8-8 8H416h-8H264h-8H8c-4.4 0-8-3.6-8-8zm400-8V424c0-13.3-10.7-24-24-24H296c-13.3 0-24 10.7-24 24v40H400z'
      
    ]
  };

  
    var faBlackboard = faChalkboard;
  

  
  

  var faMeterDroplet = {
    prefix: 'fat',
    iconName: 'meter-droplet',
    icon: [
      640,
      512,
      [],
      'e1ea',
      
      'M256 496c51.3 0 98.9-16.1 137.9-43.5c2 5.1 4.2 10 6.8 14.8C359.5 495.5 309.7 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C366.8 0 461.2 70.4 496.8 169c-4.9 3-9.3 6.8-13.1 11.2C452 84.8 362 16 256 16C123.5 16 16 123.5 16 256s107.5 240 240 240zM176 160c0-8.8-7.2-16-16-16s-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V160zm-48 0c0-17.7 14.3-32 32-32s32 14.3 32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160zm144 32V160c0-8.8-7.2-16-16-16s-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16zm-16-64c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32zm112 32c0-8.8-7.2-16-16-16s-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V160zm-48 0c0-17.7 14.3-32 32-32s32 14.3 32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160zm96 240c0-18.4 4.5-36.5 13.2-52.7l75.3-141.2c4.6-8.7 13.7-14.1 23.5-14.1s18.9 5.4 23.5 14.1l75.3 141.2c8.7 16.2 13.2 34.3 13.2 52.7c0 61.9-50.1 112-112 112s-112-50.1-112-112zm27.3-45.2C435.9 368.7 432 384.2 432 400c0 53 43 96 96 96s96-43 96-96c0-15.8-3.9-31.3-11.3-45.2L537.4 213.6c-1.9-3.5-5.5-5.6-9.4-5.6s-7.6 2.2-9.4 5.6L443.3 354.8z'
      
    ]
  };

  

  
  

  var faChildren = {
    prefix: 'fat',
    iconName: 'children',
    icon: [
      640,
      512,
      [],
      'e4e1',
      
      'M112 64a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0A64 64 0 1 0 96 64a64 64 0 1 0 128 0zM111.2 259.4c1.9-4 .2-8.8-3.8-10.6s-8.8-.2-10.6 3.8l-64 136c-1.2 2.5-1 5.4 .5 7.7s4 3.7 6.8 3.7H80v80c0 17.7 14.3 32 32 32s32-14.3 32-32V400h32v80c0 17.7 14.3 32 32 32s32-14.3 32-32V400h40c2.7 0 5.3-1.4 6.8-3.7s1.7-5.2 .5-7.7l-64-136c-1.9-4-6.6-5.7-10.6-3.8s-5.7 6.6-3.8 10.6L267.4 384H232 184 136 88 52.6l58.6-124.6zM96 480V400h32v80c0 8.8-7.2 16-16 16s-16-7.2-16-16zm96-80h32v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V400zM159.2 176h1.6c28.3 0 54.5 15 68.9 39.4l59.4 100.7c2.2 3.8 7.1 5.1 11 2.8s5.1-7.1 2.8-11L243.5 207.2C226.2 178 194.8 160 160.8 160h-1.6c-34 0-65.4 18-82.7 47.2L17.1 307.9c-2.2 3.8-1 8.7 2.8 11s8.7 1 11-2.8L90.3 215.4C104.7 191 130.9 176 159.2 176zM432 64a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0A64 64 0 1 0 416 64a64 64 0 1 0 128 0zM400.9 222.5C416.2 193.9 446 176 478.5 176h3c32.5 0 62.3 17.9 77.6 46.5l49.8 93.2c2.1 3.9 6.9 5.4 10.8 3.3s5.4-6.9 3.3-10.8L573.3 215c-18.1-33.9-53.4-55-91.7-55h-3c-38.4 0-73.6 21.1-91.7 55l-49.8 93.2c-2.1 3.9-.6 8.7 3.3 10.8s8.7 .6 10.8-3.3l49.8-93.2zM408 280c-4.4 0-8 3.6-8 8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V400c0-8.8 7.2-16 16-16s16 7.2 16 16v80c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-4.4-3.6-8-8-8s-8 3.6-8 8V480c0 8.8-7.2 16-16 16s-16-7.2-16-16V400c0-17.7-14.3-32-32-32s-32 14.3-32 32v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-4.4-3.6-8-8-8z'
      
    ]
  };

  

  
  

  var faWreath = {
    prefix: 'fat',
    iconName: 'wreath',
    icon: [
      448,
      512,
      [],
      'f7e2',
      
      'M330.3 58c-8.2 2.4-16.8-2-19.6-10c-6.6-18.7-24.4-32-45.3-32c-11.9 0-22.7 4.3-31.1 11.4c-6 5.1-14.7 5.1-20.7 0C205.3 20.3 194.4 16 182.6 16c-20.9 0-38.7 13.3-45.3 32c-2.8 8-11.5 12.4-19.6 10c-4.3-1.3-8.9-2-13.7-2c-26.5 0-48 21.5-48 48c0 4.8 .7 9.4 2 13.7c2.4 8.2-2 16.8-10 19.6c-18.7 6.6-32 24.4-32 45.3c0 11.9 4.3 22.7 11.4 31.1c5.1 6 5.1 14.7 0 20.7C20.3 242.7 16 253.6 16 265.4c0 20.9 13.3 38.7 32 45.3c8 2.8 12.4 11.5 10 19.6c-1.3 4.3-2 8.9-2 13.7c0 24.4 18.1 44.5 41.6 47.6c-1.1 4.2-1.6 8.6-1.6 13.1v2.9c-31.6-3.9-56-30.9-56-63.5c0-6.3 .9-12.5 2.6-18.2C17.8 317 0 293.3 0 265.4c0-15.8 5.7-30.2 15.2-41.4C5.7 212.8 0 198.4 0 182.6c0-27.9 17.8-51.6 42.6-60.3C40.9 116.5 40 110.3 40 104c0-35.3 28.7-64 64-64c6.3 0 12.5 .9 18.2 2.6C131 17.8 154.7 0 182.6 0c15.8 0 30.2 5.7 41.4 15.2C235.2 5.7 249.6 0 265.4 0c27.9 0 51.6 17.8 60.3 42.6c5.8-1.7 11.9-2.6 18.2-2.6c35.3 0 64 28.7 64 64c0 6.3-.9 12.5-2.6 18.2c24.8 8.8 42.6 32.5 42.6 60.3c0 15.8-5.7 30.2-15.2 41.4c9.5 11.2 15.2 25.6 15.2 41.4c0 27.9-17.8 51.6-42.6 60.3c1.7 5.8 2.6 11.9 2.6 18.2c0 32.6-24.4 59.6-56 63.5v-2.9c0-4.5-.6-8.9-1.6-13.1c23.5-3.1 41.6-23.2 41.6-47.6c0-4.8-.7-9.4-2-13.7c-2.4-8.2 2-16.8 10-19.6c18.7-6.6 32-24.4 32-45.3c0-11.9-4.3-22.7-11.4-31.1c-5.1-6-5.1-14.7 0-20.7c7.1-8.4 11.4-19.2 11.4-31.1c0-20.9-13.3-38.7-32-45.3c-8-2.8-12.4-11.5-10-19.6c1.3-4.3 2-8.9 2-13.7c0-26.5-21.5-48-48-48c-4.8 0-9.4 .7-13.7 2zM214.7 153.3c-8.8 9.4-21.3 14.6-34.2 14.1c-7.3-.2-13.3 5.8-13.1 13.1c.4 12.9-4.7 25.3-14.1 34.2c-5.4 5-5.4 13.5 0 18.5c9.4 8.8 14.6 21.3 14.1 34.2c-.2 7.3 5.8 13.3 13.1 13.1c12.9-.4 25.3 4.7 34.2 14.1c5 5.4 13.5 5.4 18.5 0c8.8-9.4 21.3-14.6 34.2-14.1c7.3 .2 13.3-5.8 13.1-13.1c-.4-12.9 4.7-25.3 14.1-34.2c5.4-5 5.4-13.5 0-18.5c-9.4-8.8-14.6-21.3-14.1-34.2c.2-7.3-5.8-13.3-13.1-13.1c-12.9 .4-25.3-4.7-34.2-14.1c-5-5.4-13.5-5.4-18.5 0zM245 142.4c5.7 6 13.6 9.4 21.9 9.1c16.6-.6 30.2 13 29.6 29.6c-.3 8.3 3 16.3 9.1 21.9c12.1 11.3 12.1 30.6 0 41.9c-6 5.7-9.4 13.6-9.1 21.9c.6 16.6-13 30.2-29.6 29.6c-8.3-.3-16.3 3-21.9 9.1c-11.3 12.1-30.6 12.1-41.9 0c-5.7-6-13.6-9.4-21.9-9.1c-16.6 .6-30.2-13-29.6-29.6c.3-8.3-3-16.3-9.1-21.9c-12.1-11.3-12.1-30.6 0-41.9c6-5.7 9.4-13.6 9.1-21.9c-.6-16.6 13-30.2 29.6-29.6c8.3 .3 16.3-3 21.9-9.1c11.3-12.1 30.6-12.1 41.9 0zM289 495.3c1.2 .5 2.6 .7 3.9 .7c6.1 0 11.1-5 11.1-11.1V411.1c0-6.1-5-11.1-11.1-11.1c-1.3 0-2.6 .2-3.9 .7L229.6 423c-3.6 1.4-7.6 1.4-11.2 0L159 400.7c-1.2-.5-2.6-.7-3.9-.7c-6.1 0-11.1 5-11.1 11.1v73.8c0 6.1 5 11.1 11.1 11.1c1.3 0 2.6-.2 3.9-.7L218.4 473c3.6-1.4 7.6-1.4 11.2 0L289 495.3zM128 484.9V411.1c0-15 12.1-27.1 27.1-27.1c3.2 0 6.5 .6 9.5 1.7L224 408l59.4-22.3c3-1.1 6.3-1.7 9.5-1.7c15 0 27.1 12.1 27.1 27.1v73.8c0 15-12.1 27.1-27.1 27.1c-3.2 0-6.5-.6-9.5-1.7L224 488l-59.4 22.3c-3 1.1-6.3 1.7-9.5 1.7c-15 0-27.1-12.1-27.1-27.1z'
      
    ]
  };

  

  
  

  var faCloudArrowDown = {
    prefix: 'fat',
    iconName: 'cloud-arrow-down',
    icon: [
      640,
      512,
      [62337,"cloud-download","cloud-download-alt"],
      'f0ed',
      
      'M522.7 220.8c3.4-8.9 5.3-18.6 5.3-28.8c0-44.2-35.8-80-80-80c-16.5 0-31.7 5-44.4 13.5c-3.7 2.5-8.2 3.3-12.5 2.3s-8-3.8-10.2-7.6C355.9 77 309.3 48 256 48c-79.5 0-144 64.5-144 144c0 2.5 .1 4.9 .2 7.3c.4 7.1-4 13.5-10.7 15.9C51.7 232.7 16 280.2 16 336c0 70.7 57.3 128 128 128H512c61.9 0 112-50.1 112-112c0-54.2-38.5-99.4-89.6-109.8c-4.6-.9-8.6-3.9-10.9-8s-2.6-9.1-.9-13.4zM256 32c53.6 0 101 26.3 130 66.7c3.1 4.3 6 8.8 8.7 13.4c3.5-2.4 7.2-4.5 11-6.4C418.5 99.5 432.8 96 448 96c53 0 96 43 96 96c0 6.6-.7 13-1.9 19.2c-1.1 5.3-2.6 10.5-4.5 15.4c5.3 1.1 10.5 2.5 15.5 4.2C603.6 247.9 640 295.7 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160zM226.3 309.7c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L312 372.7V176c0-4.4 3.6-8 8-8s8 3.6 8 8V372.7l74.3-74.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-88 88c-3.1 3.1-8.2 3.1-11.3 0l-88-88z'
      
    ]
  };

  
    var faCloudDownload = faCloudArrowDown;
  
    var faCloudDownloadAlt = faCloudArrowDown;
  

  
  

  var faHouseLock = {
    prefix: 'fat',
    iconName: 'house-lock',
    icon: [
      640,
      512,
      [],
      'e510',
      
      'M293.3 2c-3-2.7-7.6-2.7-10.6 0L2.7 250c-3.3 2.9-3.6 8-.7 11.3s8 3.6 11.3 .7L64 217.1V448c0 35.3 28.7 64 64 64H392.6c-2.9-5-5.1-10.3-6.5-16H368V328c0-13.3-10.7-24-24-24H232c-13.3 0-24 10.7-24 24V496H128c-26.5 0-48-21.5-48-48V202.9L288 18.7l181.8 161c4.4-3.4 9.1-6.4 14.1-8.9L293.3 2zM224 496V328c0-4.4 3.6-8 8-8H344c4.4 0 8 3.6 8 8V496H224zM528 208c26.5 0 48 21.5 48 48v64H480V256c0-26.5 21.5-48 48-48zm-64 48v64H448c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H592V256c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-16 80h16 16 96 16 16c8.8 0 16 7.2 16 16V480c0 8.8-7.2 16-16 16H448c-8.8 0-16-7.2-16-16V352c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faArrowsLeftRight = {
    prefix: 'fat',
    iconName: 'arrows-left-right',
    icon: [
      512,
      512,
      ["arrows-h"],
      'f07e',
      
      'M505.7 265.7c3-3 3.1-7.9 .2-11.1l-104-112c-3-3.2-8.1-3.4-11.3-.4s-3.4 8.1-.4 11.3L481.7 252 23.3 252l90.3-90.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-104 104c-3.1 3.1-3.1 8.2 0 11.3l104 104c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L23.3 268l457.4 0-90.3 90.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l104-104z'
      
    ]
  };

  
    var faArrowsH = faArrowsLeftRight;
  

  
  

  var faObjectsAlignCenterVertical = {
    prefix: 'fat',
    iconName: 'objects-align-center-vertical',
    icon: [
      512,
      512,
      [],
      'e3bd',
      
      'M176 48c17.7 0 32 14.3 32 32l0 176 0 176c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32L80 80c0-17.7 14.3-32 32-32l64 0zm48 200l0-168c0-26.5-21.5-48-48-48l-64 0C85.5 32 64 53.5 64 80l0 168H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H64l0 168c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48l0-168 64 0V368c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V264h56c4.4 0 8-3.6 8-8s-3.6-8-8-8H448l0-104c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48l0 104-64 0zm80 8l0-112c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 112V368c0 17.7-14.3 32-32 32H336c-17.7 0-32-14.3-32-32V256z'
      
    ]
  };

  

  
  

  var faSquareDown = {
    prefix: 'fat',
    iconName: 'square-down',
    icon: [
      448,
      512,
      [11015,"arrow-alt-square-down"],
      'f350',
      
      'M64 464c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H384c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64zM0 416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416zm224-16c7.2 0 14.2-2.9 19.3-8L343 292.3c5.7-5.7 9-13.5 9-21.7c0-16.9-13.7-30.6-30.6-30.6H272V152c0-22.1-17.9-40-40-40H216c-22.1 0-40 17.9-40 40v88H126.6C109.7 240 96 253.7 96 270.6c0 8.1 3.2 15.9 9 21.7L204.7 392c5.1 5.1 12.1 8 19.3 8zm-8-19.3L116.3 281c-2.7-2.7-4.3-6.5-4.3-10.3c0-8.1 6.5-14.6 14.6-14.6H184c4.4 0 8-3.6 8-8V152c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v96c0 4.4 3.6 8 8 8h57.4c8.1 0 14.6 6.5 14.6 14.6c0 3.9-1.5 7.6-4.3 10.3L232 380.7c-2.1 2.1-5 3.3-8 3.3s-5.9-1.2-8-3.3z'
      
    ]
  };

  
    var faArrowAltSquareDown = faSquareDown;
  

  
  

  var faFilePowerpoint = {
    prefix: 'fat',
    iconName: 'file-powerpoint',
    icon: [
      384,
      512,
      [],
      'f1c4',
      
      'M64 496c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm56 224c-4.4 0-8 3.6-8 8V360v80c0 4.4 3.6 8 8 8s8-3.6 8-8V368h72c39.8 0 72-32.2 72-72s-32.2-72-72-72H120zm80 128H128V240h72c30.9 0 56 25.1 56 56s-25.1 56-56 56z'
      
    ]
  };

  

  
  

  var faFileWord = {
    prefix: 'fat',
    iconName: 'file-word',
    icon: [
      384,
      512,
      [],
      'f1c2',
      
      'M16 448V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM87.7 245.8c-1.2-4.2-5.7-6.7-9.9-5.4s-6.7 5.7-5.4 9.9l56 192c1 3.4 4.1 5.8 7.7 5.8s6.7-2.3 7.7-5.8L192 276.6l48.3 165.7c1 3.4 4.1 5.8 7.7 5.8s6.7-2.3 7.7-5.8l56-192c1.2-4.2-1.2-8.7-5.4-9.9s-8.7 1.2-9.9 5.4L248 411.4 199.7 245.8c-1-3.4-4.1-5.8-7.7-5.8s-6.7 2.3-7.7 5.8L136 411.4 87.7 245.8z'
      
    ]
  };

  

  
  

  var faLeft = {
    prefix: 'fat',
    iconName: 'left',
    icon: [
      448,
      512,
      ["arrow-alt-left"],
      'f355',
      
      'M16 256c0-8.1 3.2-15.9 9-21.7L173.4 85.9c3.8-3.8 9-5.9 14.3-5.9c11.2 0 20.3 9.1 20.3 20.3l0 99.7c0 4.4 3.6 8 8 8l192 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-192 0c-4.4 0-8 3.6-8 8l0 99.7c0 11.2-9.1 20.3-20.3 20.3c-5.4 0-10.5-2.1-14.3-5.9L25 277.7c-5.7-5.7-9-13.5-9-21.7zM187.7 64c-9.6 0-18.9 3.8-25.7 10.6L13.6 223C4.9 231.8 0 243.6 0 256s4.9 24.2 13.7 33L162.1 437.4c6.8 6.8 16 10.6 25.7 10.6c20 0 36.3-16.2 36.3-36.3l0-91.7 184 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-184 0 0-91.7c0-20-16.2-36.3-36.3-36.3z'
      
    ]
  };

  
    var faArrowAltLeft = faLeft;
  

  
  

  var faWavesSine = {
    prefix: 'fat',
    iconName: 'waves-sine',
    icon: [
      640,
      512,
      [],
      'e65d',
      
      'M530.2 103.4C554.8 62 586.7 32 632 32c4.4 0 8 3.6 8 8s-3.6 8-8 8c-36.8 0-64.5 24-88.1 63.6c-16 26.9-29.6 60.1-42.4 95.6c-2.7-7.8-5.5-15.6-8.4-23.4c11.1-29.4 23.2-57 37.1-80.4zM421.8 408.6C397.2 450 365.3 480 320 480s-77.2-30-101.8-71.4c-24.5-41.2-43.2-95.9-61.5-149.4l-.2-.6c-18.6-54.2-36.8-107.4-60.4-147C72.5 72 44.8 48 8 48c-4.4 0-8-3.6-8-8s3.6-8 8-8c45.3 0 77.2 30 101.8 71.4c24.5 41.2 43.2 95.9 61.5 149.4l.2 .6c18.6 54.2 36.8 107.4 60.4 147C255.5 440 283.2 464 320 464s64.5-24 88.1-63.6c16-26.9 29.6-60.1 42.4-95.6c2.7 7.8 5.5 15.6 8.4 23.4c-11.1 29.4-23.2 57-37.1 80.4zm-189.9-297c-16 26.9-29.6 60.1-42.4 95.6c-2.7-7.8-5.5-15.6-8.4-23.4c11.1-29.4 23.2-57 37.1-80.4C242.8 62 274.7 32 320 32s77.2 30 101.8 71.4c24.5 41.2 43.2 95.9 61.5 149.4l0 0 0 0 .2 .6c18.6 54.2 36.8 107.4 60.4 147C567.5 440 595.2 464 632 464c4.4 0 8 3.6 8 8s-3.6 8-8 8c-45.3 0-77.2-30-101.8-71.4c-24.5-41.2-43.2-95.9-61.5-149.4l-.2-.6c-18.6-54.2-36.8-107.4-60.4-147C384.5 72 356.8 48 320 48s-64.5 24-88.1 63.6zm-122.1 297C85.2 450 53.3 480 8 480c-4.4 0-8-3.6-8-8s3.6-8 8-8c36.8 0 64.5-24 88.1-63.6c16-26.9 29.6-60.1 42.4-95.6c2.7 7.8 5.5 15.6 8.4 23.4c-11.1 29.4-23.2 57-37.1 80.4z'
      
    ]
  };

  

  
  

  var faCircle6 = {
    prefix: 'fat',
    iconName: 'circle-6',
    icon: [
      512,
      512,
      [],
      'e0f3',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm46-381.3c-2.9-3.3-8-3.7-11.3-.8l-97.9 85.7c-8.7 7.6-15.9 16.6-21.2 26.6C164.2 255.8 160 271.4 160 288c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-4.3 0-8.6 .3-12.8 .8L301.3 142c3.3-2.9 3.7-8 .8-11.3zM256.1 208A80 80 0 1 1 256 368a80 80 0 1 1 .1-160z'
      
    ]
  };

  

  
  

  var faChessKingPiece = {
    prefix: 'fat',
    iconName: 'chess-king-piece',
    icon: [
      256,
      512,
      ["chess-king-alt"],
      'f440',
      
      'M136 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V32H88c-4.4 0-8 3.6-8 8s3.6 8 8 8h32V96H72c-17.7 0-32 14.3-32 32v1.6c0 4.2 .8 8.4 2.5 12.3L76.7 224H64c-4.4 0-8 3.6-8 8s3.6 8 8 8H78.7l-23 144H71.9l23-144h66.2l23 144h16.2l-23-144H192c4.4 0 8-3.6 8-8s-3.6-8-8-8H179.3l34.2-82.1c1.6-3.9 2.5-8.1 2.5-12.3V128c0-17.7-14.3-32-32-32H136V48h32c4.4 0 8-3.6 8-8s-3.6-8-8-8H136V8zm62.8 127.8L162 224H94L57.2 135.8c-.8-2-1.2-4-1.2-6.2V128c0-8.8 7.2-16 16-16H184c8.8 0 16 7.2 16 16v1.6c0 2.1-.4 4.2-1.2 6.2zM56.2 416c-7.8 0-15 3.7-19.5 10.1L4.5 471.2C1.6 475.2 0 480.1 0 485.1V488c0 13.3 10.7 24 24 24H232c13.3 0 24-10.7 24-24v-2.9c0-5-1.6-9.9-4.5-13.9l-32.2-45.1c-4.5-6.3-11.8-10.1-19.5-10.1H56.2zm-6.5 19.4c1.5-2.1 3.9-3.4 6.5-3.4H199.8c2.6 0 5 1.2 6.5 3.4l32.2 45.1c1 1.4 1.5 3 1.5 4.6V488c0 4.4-3.6 8-8 8H24c-4.4 0-8-3.6-8-8v-2.9c0-1.7 .5-3.3 1.5-4.6l32.2-45.1z'
      
    ]
  };

  
    var faChessKingAlt = faChessKingPiece;
  

  
  

  var faTombstoneBlank = {
    prefix: 'fat',
    iconName: 'tombstone-blank',
    icon: [
      448,
      512,
      [129702,"tombstone-alt"],
      'f721',
      
      'M400 192V464h16V192C416 86 330 0 224 0S32 86 32 192V464H48V192C48 94.8 126.8 16 224 16s176 78.8 176 176zM8 496c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H8z'
      
    ]
  };

  
    var faTombstoneAlt = faTombstoneBlank;
  

  
  

  var faFaceSmileWink = {
    prefix: 'fat',
    iconName: 'face-smile-wink',
    icon: [
      512,
      512,
      [128521,"smile-wink"],
      'f4da',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm150.6 67.4C171.4 353.2 206.6 384 256 384s84.6-30.8 105.4-60.6c2.5-3.6 7.5-4.5 11.1-2s4.5 7.5 2 11.1C352.1 364.6 312.7 400 256 400s-96.1-35.4-118.6-67.4c-2.5-3.6-1.7-8.6 2-11.1s8.6-1.7 11.1 2zM160.4 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm134.2 19.9c-2.2 3.9-7 5.2-10.9 3.1s-5.2-7-3.1-10.9c13.1-23.4 33.6-36.1 55-36.1s41.8 12.7 55 36.1c2.2 3.9 .8 8.7-3.1 10.9s-8.7 .8-10.9-3.1c-10.9-19.3-26.4-27.9-41-27.9s-30.2 8.6-41 27.9z'
      
    ]
  };

  
    var faSmileWink = faFaceSmileWink;
  

  
  

  var faProjector = {
    prefix: 'fat',
    iconName: 'projector',
    icon: [
      640,
      512,
      [],
      'f8d6',
      
      'M424 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V120c0 4.4 3.6 8 8 8s8-3.6 8-8V8zM261.7 42.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l80 80c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-80-80zm320 11.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-80 80c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l80-80zM272 320a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm304 0c0-43.6-17.4-83.1-45.7-112H576c26.5 0 48 21.5 48 48V384c0 26.5-21.5 48-48 48h-8H530.3c28.3-28.9 45.7-68.4 45.7-112zM560 448v56c0 4.4 3.6 8 8 8s8-3.6 8-8V448c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H512c-26.7-20.1-60-32-96-32s-69.3 11.9-96 32H64c-35.3 0-64 28.7-64 64V384c0 35.3 28.7 64 64 64l0 56c0 4.4 3.6 8 8 8s8-3.6 8-8V448H320c26.7 20.1 60 32 96 32s69.3-11.9 96-32l0 0h48zM72 432H64c-26.5 0-48-21.5-48-48V256c0-26.5 21.5-48 48-48H301.7C273.4 236.9 256 276.4 256 320s17.4 83.1 45.7 112H72zm40-112a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM96 288a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 48a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z'
      
    ]
  };

  

  
  

  var faText = {
    prefix: 'fat',
    iconName: 'text',
    icon: [
      448,
      512,
      [],
      'f893',
      
      'M40 48c-4.4 0-8 3.6-8 8v48c0 4.4-3.6 8-8 8s-8-3.6-8-8V56c0-13.3 10.7-24 24-24H224 408c13.3 0 24 10.7 24 24v48c0 4.4-3.6 8-8 8s-8-3.6-8-8V56c0-4.4-3.6-8-8-8H232l0 416h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H224 136c-4.4 0-8-3.6-8-8s3.6-8 8-8h80l0-416H40z'
      
    ]
  };

  

  
  

  var faCircleDownLeft = {
    prefix: 'fat',
    iconName: 'circle-down-left',
    icon: [
      512,
      512,
      [],
      'e107',
      
      'M256 16a240 240 0 1 0 0 480 240 240 0 1 0 0-480zm0 496A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM160 344c0 4.4 3.6 8 8 8H295c5 0 9-4 9-9c0-2.4-.9-4.7-2.6-6.3l-35-35c-3.1-3.1-3.1-8.2 0-11.3L348.7 208c2.1-2.1 3.3-5 3.3-8s-1.2-5.9-3.3-8L320 163.3c-2.1-2.1-5-3.3-8-3.3s-5.9 1.2-8 3.3l-82.3 82.3c-3.1 3.1-8.2 3.1-11.3 0l-35-35c-1.7-1.7-4-2.6-6.3-2.6c-5 0-9 4-9 9V344zm8 24c-13.3 0-24-10.7-24-24V217c0-13.8 11.2-25 25-25c6.6 0 13 2.6 17.7 7.3L216 228.7 292.7 152c5.1-5.1 12.1-8 19.3-8s14.2 2.9 19.3 8L360 180.7c5.1 5.1 8 12.1 8 19.3s-2.9 14.2-8 19.3L283.3 296l29.4 29.4c4.7 4.7 7.3 11 7.3 17.7c0 13.8-11.2 25-25 25H168z'
      
    ]
  };

  

  
  

  var faWatch = {
    prefix: 'fat',
    iconName: 'watch',
    icon: [
      384,
      512,
      [8986],
      'f2e1',
      
      'M120 16H264c22.1 0 40 17.9 40 40v44c-31.5-22.7-70.2-36-112-36s-80.5 13.4-112 36V56c0-22.1 17.9-40 40-40zM64 112h1C25.1 147.2 0 198.7 0 256c0 56.9 24.7 108 64 143.1V456c0 30.9 25.1 56 56 56l144 0c30.9 0 56-25.1 56-56V399.1c39.3-35.2 64-86.2 64-143.1c0-57.3-25.1-108.8-65-144h1V56c0-30.9-25.1-56-56-56H120C89.1 0 64 25.1 64 56v56zM304 412v44c0 22.1-17.9 40-40 40l-144 0c-22.1 0-40-17.9-40-40V412c31.5 22.7 70.2 36 112 36s80.5-13.4 112-36zM16 256a176 176 0 1 1 352 0A176 176 0 1 1 16 256zm184-96c0-4.4-3.6-8-8-8s-8 3.6-8 8v96c0 2.5 1.2 4.9 3.2 6.4l64 48c3.5 2.7 8.5 1.9 11.2-1.6s1.9-8.5-1.6-11.2L200 252V160z'
      
    ]
  };

  

  
  

  var faTextSlash = {
    prefix: 'fat',
    iconName: 'text-slash',
    icon: [
      640,
      512,
      ["remove-format"],
      'f87d',
      
      'M13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7zM390 48H547.5c5.2 0 9 4.9 7.8 9.9l-11 44.1c-1.1 4.3 1.5 8.6 5.8 9.7s8.6-1.5 9.7-5.8l11-44.1c3.8-15.1-7.7-29.8-23.3-29.8H384.2h-.4H180.5c-7 0-13.5 3-17.9 8l12.6 10c1.4-1.2 3.3-2 5.3-2H373.3l-38 128.3L348.8 187 390 48zM291.2 325L250 464H168c-4.4 0-8 3.6-8 8s3.6 8 8 8h87.8 .4H344c4.4 0 8-3.6 8-8s-3.6-8-8-8H266.7l38-128.3L291.2 325z'
      
    ]
  };

  
    var faRemoveFormat = faTextSlash;
  

  
  

  var faChartLineUpDown = {
    prefix: 'fat',
    iconName: 'chart-line-up-down',
    icon: [
      512,
      512,
      [],
      'e5d7',
      
      'M8 32c4.4 0 8 3.6 8 8V408c0 30.9 25.1 56 56 56H504c4.4 0 8 3.6 8 8s-3.6 8-8 8H72c-39.8 0-72-32.2-72-72V40c0-4.4 3.6-8 8-8zM352 72c0-4.4 3.6-8 8-8H472c4.4 0 8 3.6 8 8V184c0 4.4-3.6 8-8 8s-8-3.6-8-8V91.3L293.7 261.7c-3.1 3.1-8.2 3.1-11.3 0L208 187.3l-98.3 98.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l104-104c3.1-3.1 8.2-3.1 11.3 0L288 244.7 452.7 80H360c-4.4 0-8-3.6-8-8zm8 312c-4.4 0-8-3.6-8-8s3.6-8 8-8h92.7l-90.3-90.3 11.3-11.3L464 356.7V264c0-4.4 3.6-8 8-8s8 3.6 8 8V376c0 4.4-3.6 8-8 8H360z'
      
    ]
  };

  

  
  

  var faCloudBolt = {
    prefix: 'fat',
    iconName: 'cloud-bolt',
    icon: [
      512,
      512,
      [127785,"thunderstorm"],
      'f76c',
      
      'M402.1 138.2c-3.1-3.7-4.3-8.7-3.4-13.4c.8-4.1 1.3-8.4 1.3-12.8c0-35.3-28.7-64-64-64c-19.5 0-36.9 8.7-48.6 22.4c-3.5 4-8.7 6.1-13.9 5.5s-9.9-3.8-12.4-8.5C245 36.8 212.9 16 176 16c-53 0-96 43-96 96c0 6.1 .6 12.1 1.7 17.9c1.5 7.9-3.1 15.6-10.7 18.1C39 158.5 16 188.6 16 224c0 44.2 35.8 80 80 80h67.2l-20 16H96c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c37.1 0 70 18.1 90.4 45.9c3.3 4.5 6.2 9.2 8.8 14.1c3.6-4.2 7.6-8 12-11.4C300.7 38.2 317.6 32 336 32c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c4.9 0 9.8 .4 14.5 1.1c46.2 7 81.5 46.8 81.5 94.9c0 53-43 96-96 96H352 333.7l8-16H416c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.4 0-.9 0-1.3 0c-4.8 .1-9.5-2-12.6-5.8zM267.6 344.8L320 240 160 368h70.1c5.5 0 10.7 2.9 13.6 7.6s3.2 10.6 .7 15.6L192 496 352 368H281.9c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6zm66.7-97.7L289.9 336l-8 16h17.9H352c6.8 0 12.9 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L222.1 400l8-16H212.2 160c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1s7.6 12.9 4.2 19.6z'
      
    ]
  };

  
    var faThunderstorm = faCloudBolt;
  

  
  

  var faMessageCheck = {
    prefix: 'fat',
    iconName: 'message-check',
    icon: [
      512,
      512,
      ["comment-alt-check"],
      'f4a2',
      
      'M176 416c0-8.8-7.2-16-16-16H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H309.3c-3.5 0-6.8 1.1-9.6 3.2L176 496V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h80 16v16 64c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM357.7 141.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L224 252.7l-58.3-58.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l64 64c3.1 3.1 8.2 3.1 11.3 0l128-128z'
      
    ]
  };

  
    var faCommentAltCheck = faMessageCheck;
  

  
  

  var faHandHoldingSeedling = {
    prefix: 'fat',
    iconName: 'hand-holding-seedling',
    icon: [
      576,
      512,
      [],
      'f4bf',
      
      'M96 24c0-13.3 10.7-24 24-24h24c83.9 0 152 68.1 152 152v16 96c0 4.4-3.6 8-8 8s-8-3.6-8-8V176H248C164.1 176 96 107.9 96 24zM280 160v-8c0-75.1-60.9-136-136-136H120c-4.4 0-8 3.6-8 8c0 75.1 60.9 136 136 136h32zM555.3 345.8c-7.9-10.7-22.9-12.9-33.6-5.1L404.2 427.3c-4.1 3-9.1 4.7-14.2 4.7H268c-15.5 0-28-12.5-28-28s12.5-28 28-28h80c11 0 20-9 20-20s-9-20-20-20H193.7c-25.4 0-50.1 8.7-70 24.5L81 394.7c-4.3 3.4-9.5 5.3-15 5.3H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H66c1.8 0 3.6-.6 5-1.8L113.7 348c22.7-18.2 50.9-28 80-28H348c19.9 0 36 16.1 36 36s-16.1 36-36 36H268c-6.6 0-12 5.4-12 12s5.4 12 12 12H389.9c1.7 0 3.4-.5 4.7-1.6l117.6-86.6c17.8-13.1 42.8-9.3 55.9 8.5s9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H352.5c25.6 0 50.6-8.2 71.2-23.4l126.6-93.3c10.7-7.9 12.9-22.9 5.1-33.6zM480 24c0 83.9-68.1 152-152 152v-8-8c75.1 0 136-60.9 136-136c0-4.4-3.6-8-8-8H432c-50 0-93.7 27-117.3 67.2c-2.4-5.9-5.1-11.6-8-17.2C334.1 26.1 380 0 432 0h24c13.3 0 24 10.7 24 24z'
      
    ]
  };

  

  
  

  var faPhoneArrowRight = {
    prefix: 'fat',
    iconName: 'phone-arrow-right',
    icon: [
      512,
      512,
      [],
      'e5be',
      
      'M413.7 2.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L484.7 96H296c-4.4 0-8 3.6-8 8s3.6 8 8 8H484.7l-82.3 82.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l96-96c3.1-3.1 3.1-8.2 0-11.3l-96-96zM297.8 382.5c6.6 3.1 14.6 1.3 19.2-4.3l40.4-49.3c6.7-8.2 18-11 27.8-7l96 40c11.1 4.6 17.1 16.8 13.9 28.5l-24 88C468.3 488.8 458.8 496 448 496C209.4 496 16 302.6 16 64c0-10.8 7.2-20.3 17.7-23.2l88-24c11.6-3.2 23.8 2.8 28.5 13.9l40 96c4.1 9.8 1.3 21.1-7 27.8l-49.3 40.4c-5.7 4.7-7.5 12.6-4.3 19.2c34.8 73.8 94.5 133.5 168.3 168.3zM345 318.7L304.7 368C234.2 334.7 177.2 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6z'
      
    ]
  };

  

  
  

  var faSquareDollar = {
    prefix: 'fat',
    iconName: 'square-dollar',
    icon: [
      448,
      512,
      ["dollar-square","usd-square"],
      'f2e9',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm223.5 0c4.4 0 8 3.6 8 8v35.2c6.5 .1 13.2 .6 20 1.6c9.6 1.4 19 4.1 28.4 6.8l0 0 0 0c2.8 .8 5.5 1.6 8.3 2.3c4.3 1.2 6.8 5.6 5.6 9.9s-5.6 6.8-9.8 5.6c-2.8-.8-5.5-1.6-8.3-2.4l0 0c-8.7-2.5-17.6-5.1-26.5-6.4c-22.9-3.4-44.4-.5-60.4 6.4c-16.2 7-25.8 17.5-27.9 29.1c-2.7 14.8 3.4 26.4 15.8 34.4c13.2 8.4 32.1 13.8 52.9 19.7l4.6 1.3c18.8 5.3 38.3 10.8 54.5 21.9c18.1 12.4 26.2 31.7 22.2 53.3c-3.7 20.1-17.5 33.9-36.2 41.4c-12.4 5-27.2 7.4-43.1 7.3l0 36.7c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-37.6c-2.7-.3-5.4-.6-8.1-1l0 0c-8.2-1.3-22.9-5.5-35.1-9.1c-7.6-2.3-15.3-4.7-22.9-7.2c-4.2-1.4-6.5-5.9-5.1-10.1s5.9-6.5 10.1-5.1c7.5 2.4 15 4.8 22.5 7.1c12.4 3.8 26 7.6 32.8 8.6c23.3 3.4 43.8 1.7 58.9-4.4c14.9-6 24-15.9 26.5-29.4c2.8-15.5-2.6-28.3-15.5-37.2c-14.5-9.9-32.1-14.8-49-19.5l0 0 0 0c-2.3-.6-4.6-1.3-6.8-1.9c-19.6-5.6-40.5-11.5-55.7-21.2c-17.9-11.4-26.8-29.6-22.9-50.7c3.4-18.7 18.3-32.7 37.3-40.9c9.8-4.2 21.1-7.1 33.1-8.4V104c0-4.4 3.6-8 8-8z'
      
    ]
  };

  
    var faDollarSquare = faSquareDollar;
  
    var faUsdSquare = faSquareDollar;
  

  
  

  var faArrowDownWideShort = {
    prefix: 'fat',
    iconName: 'arrow-down-wide-short',
    icon: [
      576,
      512,
      ["sort-amount-asc","sort-amount-down"],
      'f160',
      
      'M133.7 477.7c-3.1 3.1-8.2 3.1-11.3 0l-104-104c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L120 452.7V40c0-4.4 3.6-8 8-8s8 3.6 8 8V452.7l90.3-90.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-104 104zM296 464c-4.4 0-8-3.6-8-8s3.6-8 8-8h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H296zm0-144c-4.4 0-8-3.6-8-8s3.6-8 8-8H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H296zm0-128c-4.4 0-8-3.6-8-8s3.6-8 8-8H504c4.4 0 8 3.6 8 8s-3.6 8-8 8H296zm0-128c-4.4 0-8-3.6-8-8s3.6-8 8-8H568c4.4 0 8 3.6 8 8s-3.6 8-8 8H296z'
      
    ]
  };

  
    var faSortAmountAsc = faArrowDownWideShort;
  
    var faSortAmountDown = faArrowDownWideShort;
  

  
  

  var faCandyCane = {
    prefix: 'fat',
    iconName: 'candy-cane',
    icon: [
      512,
      512,
      [],
      'f786',
      
      'M331.4 123.5l-18 11.2c-22.5 14-52.1 7.2-66.1-15.3s-7.2-52.1 15.3-66.1l26.8-16.8c3.6-2.2 7.2-4.3 11-6.2l31 93.1zM315.1 24c14.6-5.3 30.1-8 45.9-8c34.4 0 65.8 12.9 89.7 34.1l-68.3 68.3c-6.1-4-13.5-6.4-21.4-6.4c-5.3 0-10.6 1.1-15.5 3.2L315.1 24zm33.6 107.5c.6-.4 1.2-.7 1.8-1l0 0c3.2-1.6 6.8-2.5 10.4-2.5c12.7 0 23 10.3 23 23v5.6c0 1.1-.1 2.2-.2 3.4c0 0 0 0 0 0c-.6 5-2.5 9.7-5.4 13.7c0 0 0 0 0 0c-2.1 2.8-4.7 5.3-7.8 7.2L292 230l-15.1 9.4L184.8 297l-15.1 9.4L81.6 361.5 66.5 371 30.1 393.7C.1 412.5-9 451.9 9.7 481.9s58.2 39.1 88.2 20.4l89.3-55.8 12.6-7.9L290.4 382l13.2-8.3 94-58.7 15.1-9.4 25.7-16c45.8-28.6 73.6-78.8 73.6-132.8V151C512 67.6 444.4 0 361 0c-28.3 0-56 8-80.1 23L254.1 39.7c-30 18.7-39.1 58.2-20.4 88.2s58.2 39.1 88.2 20.4l14.7-9.2 12.1-7.6zm48.9 164.6l-90.6-56.6 72-45c6.1-3.8 11-8.9 14.6-14.9l91.8 30.6c-11 26.7-30.2 49.9-55.5 65.7l-32.3 20.2zM292 248.9l90.6 56.6-92.1 57.6-90.6-56.6L292 248.9zM275.3 372.5l-88.1 55.1L96.7 371l88.1-55.1 90.6 56.6zM172.1 437L89.4 488.7c-22.5 14.1-52.1 7.2-66.1-15.3S16.1 421.3 38.6 407.3l43-26.9L172.1 437zM399.3 164.7c.5-2.6 .7-5.3 .7-8V151c0-7.9-2.3-15.2-6.4-21.4l68.3-68.3C483.1 85.2 496 116.6 496 151v5.6c0 13.2-1.8 26.1-5.4 38.5l-91.4-30.5z'
      
    ]
  };

  

  
  

  var faSquare9 = {
    prefix: 'fat',
    iconName: 'square-9',
    icon: [
      448,
      512,
      [],
      'e25e',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM178 381.3c-2.9-3.3-2.6-8.4 .8-11.3l58.1-50.8c-4.2 .6-8.5 .8-12.8 .8c-53 0-96-43-96-96s43-96 96-96s96 43 96 96c0 16.6-4.2 32.2-11.6 45.8c-5.4 9.9-12.5 19-21.2 26.6L189.3 382c-3.3 2.9-8.4 2.6-11.3-.8zM224 144a80 80 0 1 0 -.1 160 80 80 0 1 0 .1-160z'
      
    ]
  };

  

  
  

  var faBowlFood = {
    prefix: 'fat',
    iconName: 'bowl-food',
    icon: [
      512,
      512,
      [],
      'e4c6',
      
      'M194.3 86.8C205.9 63.7 229.3 48 256 48s50.1 15.7 61.7 38.8l3.9 7.8 7.4-4.6C339.4 83.7 351.5 80 364.5 80c33.4 0 61.6 24.5 68.1 57.6l1.3 6.6 6.8-.2c.4 0 .9 0 1.3 0c29.6 0 54 24.8 54 56c0 7.5-1.4 14.6-4 21.1c-1.6 4.1 .4 8.8 4.5 10.4s8.8-.4 10.4-4.5c3.3-8.3 5.1-17.4 5.1-26.9c0-37.9-28.6-69.3-65.2-71.8C436.8 91.3 403.9 64 364.5 64c-13.1 0-25.5 3-36.6 8.4C312.8 48.2 286.3 32 256 32s-56.8 16.2-71.9 40.4C173 67 160.6 64 147.5 64c-39.4 0-72.3 27.3-82.3 64.2C28.6 130.7 0 162.1 0 200c0 9.5 1.8 18.6 5.1 26.9c1.6 4.1 6.3 6.1 10.4 4.5s6.1-6.3 4.5-10.4c-2.5-6.5-4-13.6-4-21.1c0-31.2 24.4-56 54-56c.4 0 .9 0 1.3 0l6.8 .2 1.3-6.6c6.5-33 34.7-57.6 68.1-57.6c13 0 25.1 3.7 35.5 10.1l7.4 4.6 3.9-7.8zM112 432.7c-.1-6.1-3.8-11.6-9.3-14.2C51.5 395.1 16 343.4 16 283.4c0-6.3 5.1-11.4 11.4-11.4H484.6c6.3 0 11.4 5.1 11.4 11.4c0 59.9-35.5 111.6-86.7 135.1c-5.6 2.6-9.2 8.1-9.3 14.2c-.4 17.3-14.6 31.3-32 31.3H144c-17.4 0-31.6-13.9-32-31.3zM27.4 256C12.3 256 0 268.3 0 283.4c0 66.4 39.4 123.7 96 149.7c.6 26 21.8 46.9 48 46.9H368c26.1 0 47.4-20.9 48-46.9c56.7-26 96-83.2 96-149.7c0-15.1-12.3-27.4-27.4-27.4H27.4z'
      
    ]
  };

  

  
  

  var faGroupArrowsRotate = {
    prefix: 'fat',
    iconName: 'group-arrows-rotate',
    icon: [
      512,
      512,
      [],
      'e4f6',
      
      'M160 96c0 35.3-28.7 64-64 64c-10.7 0-20.9-2.6-29.7-7.3c-7.2 13.1-13 27-17.3 41.6c-1.3 4.2-5.7 6.6-9.9 5.4s-6.6-5.7-5.4-9.9C38.4 173.5 45 158 53.1 143.5C40.1 131.8 32 114.8 32 96c0-35.3 28.7-64 64-64c18.8 0 35.8 8.1 47.5 21.1c14.5-8.1 30-14.6 46.2-19.5c4.2-1.3 8.7 1.2 9.9 5.4s-1.2 8.7-5.4 9.9c-14.6 4.3-28.5 10.2-41.6 17.3c4.7 8.9 7.3 19 7.3 29.7zM312.3 39c1.3-4.2 5.7-6.6 10-5.4C338.5 38.4 354 45 368.5 53.1C380.2 40.1 397.2 32 416 32c35.3 0 64 28.7 64 64c0 18.8-8.1 35.8-21.1 47.5c8.1 14.5 14.6 30 19.5 46.2c1.3 4.2-1.2 8.7-5.4 9.9s-8.7-1.2-9.9-5.4c-4.3-14.6-10.2-28.5-17.3-41.6c-8.9 4.7-19 7.3-29.7 7.3c-35.3 0-64-28.7-64-64c0-10.7 2.6-20.9 7.3-29.7c-13.1-7.2-27-13-41.6-17.3c-4.2-1.3-6.6-5.7-5.4-9.9zM39 312.3c4.2-1.3 8.7 1.2 9.9 5.4c4.3 14.6 10.2 28.5 17.3 41.6c8.9-4.7 19-7.3 29.7-7.3c35.3 0 64 28.7 64 64c0 10.7-2.6 20.9-7.3 29.7c13.1 7.1 27 13 41.6 17.3c4.2 1.3 6.6 5.7 5.4 9.9s-5.7 6.6-9.9 5.4c-16.2-4.8-31.7-11.4-46.2-19.5C131.8 471.9 114.8 480 96 480c-35.3 0-64-28.7-64-64c0-18.8 8.1-35.8 21.1-47.5c-8.1-14.5-14.6-30-19.5-46.2c-1.3-4.2 1.2-8.7 5.4-10zm434 0c4.2 1.3 6.6 5.7 5.4 10c-4.8 16.2-11.4 31.7-19.5 46.2C471.9 380.2 480 397.2 480 416c0 35.3-28.7 64-64 64c-18.8 0-35.8-8.1-47.5-21.1c-14.5 8.1-30 14.6-46.2 19.5c-4.2 1.3-8.7-1.2-10-5.4s1.2-8.7 5.4-9.9c14.6-4.3 28.5-10.2 41.6-17.3c-4.7-8.9-7.3-19-7.3-29.7c0-35.3 28.7-64 64-64c10.7 0 20.9 2.6 29.7 7.3c7.1-13.1 13-27 17.3-41.6c1.3-4.2 5.7-6.6 9.9-5.4zM152.8 160.8c0-4.4 3.6-8 8-8h56c4.4 0 8 3.6 8 8v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V181.7C184.3 197.3 168 224.8 168 256c0 48.6 39.4 88 88 88c4.4 0 8 3.6 8 8s-3.6 8-8 8c-57.4 0-104-46.6-104-104c0-36.5 18.8-68.7 47.3-87.2H160.8c-4.4 0-8-3.6-8-8zM359.2 352c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8V296c0-4.4 3.6-8 8-8s8 3.6 8 8v35.1C327.7 315.4 344 288 344 256.8c0-48.6-39.4-88-88-88c-4.4 0-8-3.6-8-8s3.6-8 8-8c57.4 0 104 46.6 104 104c0 36.5-18.8 68.7-47.3 87.2h38.5c4.4 0 8 3.6 8 8zM464 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM96 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM464 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM96 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faFileJpg = {
    prefix: 'fat',
    iconName: 'file-jpg',
    icon: [
      512,
      512,
      [],
      'e646',
      
      'M64 496h48v16H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H204.1c12.7 0 24.9 5.1 33.9 14.1L369.9 145.9c9 9 14.1 21.2 14.1 33.9V304H368V179.9c0-1.3-.1-2.6-.2-3.9H248c-22.1 0-40-17.9-40-40V16.2c-1.3-.2-2.6-.2-3.9-.2H64C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48zM361.1 160c-.8-1-1.6-1.9-2.4-2.7L226.7 25.4c-.9-.9-1.8-1.7-2.7-2.4V136c0 13.3 10.7 24 24 24H361.1zM208 512c-22.1 0-40-17.9-40-40V456c0-4.4 3.6-8 8-8s8 3.6 8 8v16c0 13.3 10.7 24 24 24s24-10.7 24-24V376c0-4.4 3.6-8 8-8s8 3.6 8 8v96c0 22.1-17.9 40-40 40zm96-144h32c26.5 0 48 21.5 48 48s-21.5 48-48 48H312v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V456 376c0-4.4 3.6-8 8-8zm32 80c17.7 0 32-14.3 32-32s-14.3-32-32-32H312v64h24zm88-48c0-17.7 14.3-32 32-32h16c17.7 0 32 14.3 32 32v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-8.8-7.2-16-16-16H456c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V464h-8c-4.4 0-8-3.6-8-8s3.6-8 8-8h16c4.4 0 8 3.6 8 8v24c0 17.7-14.3 32-32 32H456c-17.7 0-32-14.3-32-32V400z'
      
    ]
  };

  

  
  

  var faFlashlight = {
    prefix: 'fat',
    iconName: 'flashlight',
    icon: [
      640,
      512,
      [128294],
      'f8b8',
      
      'M388.8 336H384 48c-17.7 0-32-14.3-32-32V208c0-17.7 14.3-32 32-32H384h4.8l4-2.7 31.5-21c31.2-20.8 66.7-33.9 103.6-38.5V398.2c-36.9-4.6-72.4-17.7-103.6-38.5l-31.5-21-4-2.7zm168.7 64c-4.5 0-9-.1-13.5-.4V112.4c4.5-.3 9-.4 13.5-.4H600c13.3 0 24 10.7 24 24V376c0 13.3-10.7 24-24 24H557.5zM0 208v96c0 26.5 21.5 48 48 48H384l31.5 21c42.1 28 91.5 43 142 43H600c22.1 0 40-17.9 40-40V136c0-22.1-17.9-40-40-40H557.5c-50.5 0-100 15-142 43L384 160H48c-26.5 0-48 21.5-48 48zm256 32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H256c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-32 16c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H256c-17.7 0-32 14.3-32 32z'
      
    ]
  };

  

  
  

  var faCircleArrowLeft = {
    prefix: 'fat',
    iconName: 'circle-arrow-left',
    icon: [
      512,
      512,
      ["arrow-circle-left"],
      'f0a8',
      
      'M16 256a240 240 0 1 1 480 0A240 240 0 1 1 16 256zm496 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM234.3 146.3l-104 104c-3.1 3.1-3.1 8.2 0 11.3l104 104c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L155.3 264 376 264c4.4 0 8-3.6 8-8s-3.6-8-8-8l-220.7 0 90.3-90.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0z'
      
    ]
  };

  
    var faArrowCircleLeft = faCircleArrowLeft;
  

  
  

  var faBoxesPacking = {
    prefix: 'fat',
    iconName: 'boxes-packing',
    icon: [
      640,
      512,
      [],
      'e4c7',
      
      'M592 16H304c-17.7 0-32 14.3-32 32v80H256V48c0-26.5 21.5-48 48-48H592c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H381.3c1.8-5 2.7-10.4 2.7-16H592c17.7 0 32-14.3 32-32V48c0-17.7-14.3-32-32-32zM549.7 322.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L488 283.3V440c0 4.4-3.6 8-8 8s-8-3.6-8-8V283.3l-50.3 50.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l64-64c3.1-3.1 8.2-3.1 11.3 0l64 64zM32 176c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H48 336h16c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16H32zm0 112c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32V480c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32l0-192zm304 0H272v24c0 13.3-10.7 24-24 24H136c-13.3 0-24-10.7-24-24V288H48V480c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V288zm-208 0v24c0 4.4 3.6 8 8 8H248c4.4 0 8-3.6 8-8V288H128z'
      
    ]
  };

  

  
  

  var faLeftRight = {
    prefix: 'fat',
    iconName: 'left-right',
    icon: [
      512,
      512,
      [8596,"arrows-alt-h"],
      'f337',
      
      'M504 236.7c5.1 5.1 8 12.1 8 19.3s-2.9 14.2-8 19.3L404.3 375c-5.7 5.7-13.5 9-21.7 9c-16.9 0-30.6-13.7-30.6-30.6l0-49.4-192 0 0 49.4c0 16.9-13.7 30.6-30.6 30.6c-8.1 0-15.9-3.2-21.7-9L8 275.3c-5.1-5.1-8-12.1-8-19.3s2.9-14.2 8-19.3L107.7 137c5.7-5.7 13.5-9 21.7-9c16.9 0 30.6 13.7 30.6 30.6l0 49.4 192 0 0-49.4c0-16.9 13.7-30.6 30.6-30.6c8.1 0 15.9 3.2 21.7 9L504 236.7zM496 256c0-3-1.2-5.9-3.3-8L393 148.3c-2.7-2.7-6.5-4.3-10.3-4.3c-8.1 0-14.6 6.5-14.6 14.6l0 57.4c0 4.4-3.6 8-8 8l-208 0c-4.4 0-8-3.6-8-8l0-57.4c0-8.1-6.5-14.6-14.6-14.6c-3.9 0-7.6 1.5-10.3 4.3L19.3 248l-5.7-5.7 5.7 5.7c-2.1 2.1-3.3 5-3.3 8s1.2 5.9 3.3 8l-5.7 5.7 5.7-5.7L119 363.7c2.7 2.7 6.5 4.3 10.3 4.3c8.1 0 14.6-6.6 14.6-14.6l0-57.4c0-4.4 3.6-8 8-8l208 0c4.4 0 8 3.6 8 8l0 57.4c0 8.1 6.6 14.6 14.6 14.6c3.9 0 7.6-1.5 10.3-4.3L492.7 264c2.1-2.1 3.3-5 3.3-8z'
      
    ]
  };

  
    var faArrowsAltH = faLeftRight;
  

  
  

  var faClockSeven = {
    prefix: 'fat',
    iconName: 'clock-seven',
    icon: [
      512,
      512,
      [],
      'e350',
      
      'M496 256A240 240 0 1 1 16 256a240 240 0 1 1 480 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM248 104V253.6l-62.7 94c-2.5 3.7-1.5 8.6 2.2 11.1s8.6 1.5 11.1-2.2l64-96c.9-1.3 1.3-2.9 1.3-4.4V104c0-4.4-3.6-8-8-8s-8 3.6-8 8z'
      
    ]
  };

  

  
  

  var faSeedling = {
    prefix: 'fat',
    iconName: 'seedling',
    icon: [
      512,
      512,
      [127793,"sprout"],
      'f4d8',
      
      'M480 16c8.8 0 16 7.2 16 16c0 102.9-74.7 188.4-172.9 205.1c1 5.2 1.9 10.5 2.6 15.8C431.4 234.9 512 142.9 512 32c0-17.7-14.3-32-32-32H448C367 0 296 43 256.6 107.5c3.8 4.1 7.5 8.3 11.1 12.6C303.7 57.9 371 16 448 16h32zM64 80c114.9 0 208 93.1 208 208v16H224C109.1 304 16 210.9 16 96c0-8.8 7.2-16 16-16H64zM32 64C14.3 64 0 78.3 0 96C0 219.7 100.3 320 224 320h48V504c0 4.4 3.6 8 8 8s8-3.6 8-8V320v-8-8V288C288 164.3 187.7 64 64 64H32z'
      
    ]
  };

  
    var faSprout = faSeedling;
  

  
  

  var faArrowsDownToPeople = {
    prefix: 'fat',
    iconName: 'arrows-down-to-people',
    icon: [
      640,
      512,
      [],
      'e4b9',
      
      'M136 8c0-4.4 3.6-8 8-8s8 3.6 8 8V164.7l50.3-50.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-64 64c-3.1 3.1-8.2 3.1-11.3 0l-64-64c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L136 164.7V8zM426.3 114.3c3.1-3.1 8.2-3.1 11.3 0L488 164.7V8c0-4.4 3.6-8 8-8s8 3.6 8 8V164.7l50.3-50.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-64 64c-3.1 3.1-8.2 3.1-11.3 0l-64-64c-3.1-3.1-3.1-8.2 0-11.3zM496 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-64a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm-5.1 112c-32.5 0-62.4 17.9-77.6 46.6l-28 52.6c-2.7 5.1-.7 11.5 4.5 14.1c4.8 2.4 10.7 .7 13.5-3.9l39.3-65.4c1.9-3.1 5.5-4.6 9-3.6s5.9 4.1 5.9 7.7v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16l0-64c0-3.6 2.4-6.7 5.9-7.7s7.1 .5 9 3.6l39.3 65.4c2.8 4.6 8.6 6.3 13.5 3.9c5.2-2.6 7.2-9 4.5-14.1l-28-52.6c-15.3-28.7-45.1-46.6-77.6-46.6H490.9zm-91.8 39.1c18.1-33.9 53.4-55.1 91.8-55.1h12.8c38.4 0 73.7 21.2 91.8 55.1l28 52.6c7 13.1 1.8 29.3-11.5 35.9c-12.3 6.2-27.3 1.8-34.3-10l-24.4-40.7 0 35.1c0 17.7-14.3 32-32 32h-48c-17.7 0-32-14.3-32-32V444.9l-24.4 40.7c-7.1 11.8-22 16.2-34.3 10c-13.2-6.6-18.4-22.9-11.5-35.9l28-52.6zM168 296a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-64 0a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM61.3 414.6l-28 52.6c-2.7 5.1-.7 11.5 4.5 14.1c4.8 2.4 10.7 .7 13.5-3.9l39.3-65.4c1.8-3.1 5.5-4.6 9-3.6s5.9 4.1 5.9 7.7v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16l0-64c0-3.6 2.4-6.7 5.9-7.7s7.1 .5 9 3.6l39.3 65.4c2.8 4.6 8.6 6.3 13.5 3.9c5.2-2.6 7.2-9 4.5-14.1l-28-52.6c-15.3-28.7-45.1-46.6-77.6-46.6H138.9c-32.5 0-62.4 17.9-77.6 46.6zM138.9 352h12.8c38.4 0 73.7 21.2 91.8 55.1l28 52.6c7 13.1 1.8 29.3-11.5 35.9c-12.3 6.2-27.3 1.8-34.3-10l-24.4-40.7 0 35.1c0 17.7-14.3 32-32 32h-48c-17.7 0-32-14.3-32-32V444.9L64.9 485.6c-7.1 11.8-22 16.2-34.3 10c-13.2-6.6-18.4-22.9-11.5-35.9l28-52.6c18.1-33.9 53.4-55.1 91.8-55.1zM320 208a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-64a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm-5.1 112c-32.5 0-62.4 17.9-77.6 46.6l0 .1 0 0-20 36.6c-2.1 3.9-7 5.3-10.9 3.2s-5.3-7-3.2-10.9l20-36.5c18.1-33.9 53.3-55 91.7-55h12.8c38.4 0 73.7 21.2 91.7 55l20 36.5c2.1 3.9 .7 8.7-3.2 10.9s-8.7 .7-10.9-3.2l-20-36.6 0-.1 0 0c-15.3-28.7-45.1-46.6-77.6-46.6H314.9zm-39.4 40.3c3.4 1 5.8 4.1 5.8 7.7v88c0 4.4-3.6 8-8 8s-8-3.6-8-8V331.6l-16.5 26.1c-2.4 3.7-7.3 4.8-11 2.5s-4.8-7.3-2.5-11l31.3-49.5c1.9-3 5.6-4.4 9-3.4zm91.5 0c3.4-1 7.1 .4 9 3.4l31.3 49.5c2.4 3.7 1.2 8.7-2.5 11s-8.7 1.3-11-2.5l-16.5-26.1 0 60.4c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-88c0-3.6 2.4-6.7 5.8-7.7z'
      
    ]
  };

  

  
  

  var faBullseyeArrow = {
    prefix: 'fat',
    iconName: 'bullseye-arrow',
    icon: [
      512,
      512,
      [127919],
      'f648',
      
      'M332 11.5C308 4 282.5 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-26.5-4-52-11.5-76l-12.9 12.9c5.5 20.1 8.4 41.2 8.4 63.1c0 132.5-107.5 240-240 240S16 388.5 16 256S123.5 16 256 16c21.8 0 43 2.9 63.1 8.4L332 11.5zm90 218.3c-4.2 .1-8.5-.3-12.8-1l-3.7-.6c1.7 9 2.6 18.4 2.6 27.9c0 83.9-68.1 152-152 152s-152-68.1-152-152s68.1-152 152-152c9.5 0 18.8 .9 27.9 2.6l-.6-3.7c-.7-4.3-1-8.5-1-12.8c-8.6-1.3-17.3-2-26.3-2C163.2 88 88 163.2 88 256s75.2 168 168 168s168-75.2 168-168c0-8.9-.7-17.7-2-26.3zM256 184c-39.8 0-72 32.2-72 72s32.2 72 72 72s72-32.2 72-72c0-4.8-.5-9.5-1.4-14.1L312 256.6c-.3 30.7-25.3 55.4-56 55.4c-30.9 0-56-25.1-56-56c0-30.7 24.8-55.7 55.4-56l14.6-14.6c-4.5-.9-9.2-1.4-14.1-1.4zM407.1 93.6l-65.7 65.7L330.6 94.9c-1.3-7.6 1.2-15.4 6.7-20.9l50.6-50.6 19.1 70.2zm-68.3 90.9l75.7 12.6c12.7 2.1 25.7-2 34.9-11.2l50.6-50.6c8.7-8.7 4.7-23.5-7.1-26.7L422.5 89.5 403.3 19.2c-3.2-11.9-18.1-15.8-26.7-7.1L326 62.7c-9.1 9.1-13.3 22.1-11.2 34.9l12.6 75.7-77.1 77.1c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l77.1-77.1zm13.9-13.9l65.7-65.7 70.2 19.2L438 174.7c-5.5 5.5-13.3 8-20.9 6.7l-64.4-10.7z'
      
    ]
  };

  

  
  

  var faFerry = {
    prefix: 'fat',
    iconName: 'ferry',
    icon: [
      576,
      512,
      [],
      'e4ea',
      
      'M352 16c8.8 0 16 7.2 16 16V48H208V32c0-8.8 7.2-16 16-16H352zM192 32V48H124c-17.1 0-28.7 17.4-22.2 33.2L121.3 128H104c-22.1 0-40 17.9-40 40V295.9c0 6.6 1.6 13.1 4.8 19L121 411.8c2.1 3.9 6.9 5.3 10.8 3.3s5.3-6.9 3.3-10.8L82.9 307.3c-.6-1.1-1.1-2.2-1.5-3.3H494.6c-.4 1.1-.9 2.2-1.5 3.3L441 404.2c-2.1 3.9-.6 8.7 3.3 10.8s8.7 .6 10.8-3.3l52.2-96.9c3.1-5.8 4.8-12.3 4.8-19V168c0-22.1-17.9-40-40-40H454.7l19.5-46.8c6.6-15.8-5-33.2-22.2-33.2H384V32c0-17.7-14.3-32-32-32H224c-17.7 0-32 14.3-32 32zM496 288H80V168c0-13.3 10.7-24 24-24h24H448h24c13.3 0 24 10.7 24 24V288zM368 64h16 68c5.7 0 9.6 5.8 7.4 11.1L437.3 128H138.7L116.6 75.1C114.4 69.8 118.3 64 124 64h68 16H368zM112 184v72c0 4.4 3.6 8 8 8s8-3.6 8-8V192H448v64c0 4.4 3.6 8 8 8s8-3.6 8-8V184c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8zM294.6 435.4c-3-4.3-10.2-4.3-13.2 0c-8 11.2-17.5 21.4-27.6 30.7C236.6 481.8 214.5 496 192 496s-44.6-14.2-61.8-29.9c-10.1-9.2-19.7-19.5-27.6-30.7c-1.5-2.1-3.9-3.4-6.6-3.4s-5.1 1.3-6.6 3.4c-7.3 10.3-15.9 19.6-25 28.3C48.7 478.5 28.3 492.9 7 495.6c-4.4 .6-7.5 4.6-6.9 8.9s4.6 7.5 8.9 6.9c26.5-3.3 50-20.7 66.4-36.1c8.8-8.3 15.9-16.4 20.6-22.2c5.2 6.4 13.2 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8l0 0 0 0c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c4.7 5.8 11.8 13.9 20.6 22.2c16.4 15.4 39.9 32.8 66.4 36.1c4.4 .6 8.4-2.6 8.9-6.9s-2.6-8.4-6.9-8.9c-21.3-2.7-41.7-17.1-57.4-31.9c-9.1-8.6-17.7-18-25-28.3c-1.5-2.1-3.9-3.4-6.6-3.4s-5.1 1.3-6.6 3.4c-7.9 11.2-17.5 21.5-27.6 30.7C428.6 481.8 406.5 496 384 496s-44.6-14.2-61.8-29.9c-10.1-9.2-19.6-19.5-27.6-30.7z'
      
    ]
  };

  

  
  

  var faTrianglePersonDigging = {
    prefix: 'fat',
    iconName: 'triangle-person-digging',
    icon: [
      640,
      512,
      ["construction"],
      'f85d',
      
      'M340.5 27.5C336.1 20.3 328.3 16 320 16s-16.1 4.4-20.5 11.5l-264 432c-4.5 7.4-4.7 16.7-.5 24.3S47.3 496 56 496H584.5c8.7 0 16.7-4.7 20.9-12.3l14 7.8C612.3 504.2 599 512 584.5 512H56c-14.5 0-27.8-7.8-34.9-20.4s-6.8-28.1 .8-40.4l264-432C293.1 7.3 306.1 0 320 0s26.9 7.2 34.1 19.1l264.5 432c7.6 12.3 7.9 27.8 .8 40.4l-14-7.8c4.2-7.6 4.1-16.9-.5-24.3L340.5 27.5zM432 334.2L380.9 416H483.1L432 334.2zm-39.5 33.1l26-41.6c6.3-10 20.9-10 27.1 0l51.1 81.8c6.7 10.7-1 24.5-13.6 24.5H380.9c-12.6 0-20.2-13.8-13.6-24.5l16.6-26.6L214.5 295.1c-8.9-4.5-14.5-13.6-14.5-23.5c0-7 2.8-13.7 7.7-18.6l6.6-6.6C223.5 237.2 236 232 249 232h4.1c24.4 0 46.2 15 54.9 37.7l26.2 68 58.3 29.5zM304 192a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM211.5 324.9l8 3.9 63 30.8c8.2 4 13.5 12.4 13.5 21.6V424c0 4.4-3.6 8-8 8s-8-3.6-8-8V381.2c0-3.1-1.7-5.8-4.5-7.2l-55-26.9-29 79.6c-1.5 4.2-6.1 6.3-10.3 4.8s-6.3-6.1-4.8-10.2l32-88 3-8.4zm14.1-67.2l-6.6 6.6c-1.9 1.9-3 4.6-3 7.3c0 3.9 2.2 7.5 5.7 9.3L312.9 327l-19.8-51.5c-6.4-16.6-22.3-27.5-40-27.5H249c-8.7 0-17.1 3.5-23.3 9.7z'
      
    ]
  };

  
    var faConstruction = faTrianglePersonDigging;
  

  
  

  var faCircleEnvelope = {
    prefix: 'fat',
    iconName: 'circle-envelope',
    icon: [
      512,
      512,
      ["envelope-circle"],
      'e10c',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm160-80c-8.8 0-16 7.2-16 16v7.3l4.2 2.5L245.3 261c3.2 2 6.9 3 10.7 3s7.5-1 10.7-3l97.2-59.2 4.2-2.5V192c0-8.8-7.2-16-16-16H160zm208 42l-93 56.6c-5.7 3.5-12.3 5.3-19 5.3s-13.3-1.8-19-5.3L144 218V320c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16V218zM160 160H352c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32z'
      
    ]
  };

  
    var faEnvelopeCircle = faCircleEnvelope;
  

  
  

  var faInboxFull = {
    prefix: 'fat',
    iconName: 'inbox-full',
    icon: [
      512,
      512,
      [],
      'e1ba',
      
      'M16 327.9V416c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V327.9c0-2.6-.2-5.3-.6-7.9H393.9c-3 0-5.8 1.7-7.2 4.4l-23.2 46.3c-4.1 8.1-12.4 13.3-21.5 13.3H169.9c-9.1 0-17.4-5.1-21.5-13.3l-23.2-46.3c-1.4-2.7-4.1-4.4-7.2-4.4H16.7c-.4 2.6-.7 5.2-.7 7.9zM436.6 84.4C431.3 63 412.1 48 390 48H122c-22 0-41.2 15-46.6 36.4L20.5 304h97.6c9.1 0 17.4 5.1 21.5 13.3l23.2 46.3c1.4 2.7 4.1 4.4 7.2 4.4H342.1c3 0 5.8-1.7 7.2-4.4l23.2-46.3c4.1-8.1 12.4-13.3 21.5-13.3h97.6L436.6 84.4zM0 416V327.9c0-5.2 .6-10.4 1.9-15.5l58-231.9C67 52 92.6 32 122 32H390c29.4 0 55 20 62.1 48.5l58 231.9c1.3 5.1 1.9 10.3 1.9 15.5V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zM152 112H368c4.4 0 8 3.6 8 8s-3.6 8-8 8H152c-4.4 0-8-3.6-8-8s3.6-8 8-8zm-24 64H384c4.4 0 8 3.6 8 8s-3.6 8-8 8H128c-4.4 0-8-3.6-8-8s3.6-8 8-8zm-16 64H392c4.4 0 8 3.6 8 8s-3.6 8-8 8H112c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faPig = {
    prefix: 'fat',
    iconName: 'pig',
    icon: [
      640,
      512,
      [128022],
      'f706',
      
      'M483.8 32c-3.5 0-6.9 .6-10.1 1.9L415.4 56.3c-12.9 5-23.8 13.3-31.9 23.7c-.8 0-1.5 0-2.3 0H240C157 80 88.8 143.1 80.8 224H45.2C29.1 224 16 210.9 16 194.8v-1.5c0-11.7 7.5-22 18.5-25.7l24-8c4.2-1.4 6.5-5.9 5.1-10.1s-5.9-6.5-10.1-5.1l-24 8C11.9 158.3 0 174.7 0 193.3v1.5c0 25 20.2 45.2 45.2 45.2H80v16c0 52.1 27.7 97.8 69.2 123l30.4 85c3.4 9.5 12.5 15.9 22.6 15.9H248c13.3 0 24-10.7 24-24V416h48 64v40c0 13.3 10.7 24 24 24h45.9c10.1 0 19.2-6.4 22.6-15.9l18.4-51.5c32.5-7.7 60.9-27.7 79.1-56c1.9-3 4.9-4.6 7.7-4.6H608c17.7 0 32-14.3 32-32V240c0-17.7-14.3-32-32-32H588.1c-1.1 0-2.1-.2-2.8-.6c-12.6-5.9-23.6-14.9-31.7-26.3c27.9-10.7 46.4-37.5 46.4-67.6C600 99.4 588.6 88 574.4 88H512V60.2C512 44.6 499.4 32 483.8 32zm27.5 72h63.1c5.3 0 9.6 4.3 9.6 9.6c0 24.3-15.5 45.8-38.6 53.5l-.8 .3c-11-16.5-24.3-31-39.3-43.2c2.9-6.3 4.9-13.1 5.9-20.2zM479.4 48.8c1.4-.5 2.9-.8 4.4-.8c6.8 0 12.2 5.5 12.2 12.2V94c0 10.2-2.8 19.9-7.7 28.3c-2 3.5-1.2 8 2.1 10.4c18.1 13.7 33.7 30.9 45.7 51c10.1 16.8 24.9 30 42.4 38.2c3.1 1.5 6.4 2.1 9.6 2.1H608c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16H581.7c-9 0-16.7 5-21.2 11.9c-16.6 25.9-43.1 43.9-73.2 49.9c-2.8 .6-5 2.5-6 5.2l-19.9 55.7c-1.1 3.2-4.2 5.3-7.5 5.3H408c-4.4 0-8-3.6-8-8V408c0-4.4-3.6-8-8-8H320 264c-4.4 0-8 3.6-8 8v48c0 4.4-3.6 8-8 8H202.1c-3.4 0-6.4-2.1-7.5-5.3L163.3 371c-.6-1.8-1.9-3.3-3.5-4.2C121.6 344.6 96 303.3 96 256V240c0-79.5 64.5-144 144-144H381.2c2 0 4 0 6 .1c2.7 .1 5.3-1.2 6.9-3.5c6.5-9.5 15.8-17.1 27.1-21.4l58.2-22.4zM464 256a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faVest = {
    prefix: 'fat',
    iconName: 'vest',
    icon: [
      448,
      512,
      [],
      'e085',
      
      'M120.4 0h-1.1H104 88C65.9 0 48 17.9 48 40V186.7c0 7.2-2 14.4-5.7 20.6L8 264.5c-5.2 8.7-8 18.7-8 28.8V464c0 0 0 0 0 0v8c0 22.1 17.9 40 40 40H176c-3.7-4.9-6.8-10.3-9.3-16H40c-13.3 0-24-10.7-24-24v-4.5L125.4 365.9c3.2-3 3.4-8.1 .4-11.3s-8.1-3.4-11.3-.4L16 445.7V293.3c0-7.2 2-14.4 5.7-20.6L56 215.5c5.2-8.7 8-18.7 8-28.8V40c0-13.3 10.7-24 24-24h16 15.3c6.7 0 12.7 4.2 15 10.4l60.3 162.3 8.7-22.6-46.8-126C170.2 52.5 191.7 64 224 64c31.1 0 52.2-10.7 66-22.5l-94 235c-2.6 6.6-4 13.7-4 20.8V472c0 22.1 17.9 40 40 40H408c22.1 0 40-17.9 40-40v-8c0 0 0 0 0 0V293.3c0-10.1-2.8-20.1-8-28.8l-34.3-57.2c-3.7-6.2-5.7-13.3-5.7-20.6V40c0-22.1-17.9-40-40-40H344 328.2h-.7c-17 0-31.2 10.9-40.6 21.9C276.8 33.8 257.7 48 224 48s-52.8-14.2-63-26.1C151.6 10.9 137.4 0 120.4 0zM432 445.7l-98.6-91.5c-3.2-3-8.3-2.8-11.3 .4s-2.8 8.3 .4 11.3L432 467.5V472c0 13.3-10.7 24-24 24H232c-13.3 0-24-10.7-24-24V297.2c0-5.1 1-10.1 2.9-14.9L313.4 26.1C315.8 20 321.7 16 328.2 16H344h16c13.3 0 24 10.7 24 24V186.7c0 10.1 2.8 20.1 8 28.8l34.3 57.2c3.7 6.2 5.7 13.3 5.7 20.6V445.7z'
      
    ]
  };

  

  
  

  var faArrowsTurnRight = {
    prefix: 'fat',
    iconName: 'arrows-turn-right',
    icon: [
      448,
      512,
      [],
      'e4c0',
      
      'M306 10.7c2.9-3.3 8-3.7 11.3-.8l128 112c1.7 1.5 2.7 3.7 2.7 6s-1 4.5-2.7 6l-128 112c-3.3 2.9-8.4 2.6-11.3-.8s-2.6-8.4 .8-11.3l112-98H104c-48.6 0-88 39.4-88 88v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V224c0-57.4 46.6-104 104-104H418.7l-112-98c-3.3-2.9-3.7-8-.8-11.3zm-96 256c2.9-3.3 8-3.7 11.3-.8l128 112c1.7 1.5 2.7 3.7 2.7 6s-1 4.5-2.7 6l-128 112c-3.3 2.9-8.4 2.6-11.3-.8s-2.6-8.4 .8-11.3l112-98H72c-30.9 0-56 25.1-56 56v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V448c0-39.8 32.2-72 72-72H322.7l-112-98c-3.3-2.9-3.7-8-.8-11.3z'
      
    ]
  };

  

  
  

  var faObjectsAlignRight = {
    prefix: 'fat',
    iconName: 'objects-align-right',
    icon: [
      512,
      512,
      [],
      'e3bf',
      
      'M512 8c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 496c0 4.4 3.6 8 8 8s8-3.6 8-8L512 8zM400 176c0 17.7-14.3 32-32 32L48 208c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32l0 64zm16-64c0-26.5-21.5-48-48-48L48 64C21.5 64 0 85.5 0 112l0 64c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-64zM400 400c0 17.7-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32l0 64zm16-64c0-26.5-21.5-48-48-48l-192 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l192 0c26.5 0 48-21.5 48-48l0-64z'
      
    ]
  };

  

  
  

  var faChartMixedUpCircleCurrency = {
    prefix: 'fat',
    iconName: 'chart-mixed-up-circle-currency',
    icon: [
      576,
      512,
      [],
      'e5d8',
      
      'M416 8c0-4.4 3.6-8 8-8H536c4.4 0 8 3.6 8 8V120c0 4.4-3.6 8-8 8s-8-3.6-8-8V26.7L325.3 206c-3.2 2.8-8 2.7-11-.3l-123-123L12.9 222.3c-3.5 2.7-8.5 2.1-11.2-1.4s-2.1-8.5 1.4-11.2l184-144c3.2-2.5 7.7-2.2 10.6 .6L320.3 189 515.9 16H424c-4.4 0-8-3.6-8-8zm16 488a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 200a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm56.3-11.1l13.4 13.4c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-13.4-13.4C464.6 434.1 449 440 432 440s-32.6-5.9-44.9-15.7l-13.4 13.4c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l13.4-13.4C365.9 400.6 360 385 360 368s5.9-32.6 15.7-44.9l-13.4-13.4c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l13.4 13.4C399.4 301.9 415 296 432 296s32.6 5.9 44.9 15.7l13.4-13.4c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-13.4 13.4C498.1 335.4 504 351 504 368s-5.9 32.6-15.7 44.9zM192 240c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16s16-7.2 16-16V256c0-8.8-7.2-16-16-16zm-32 16c0-17.7 14.3-32 32-32s32 14.3 32 32V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V256zM80 352c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V352zm-48 0c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352z'
      
    ]
  };

  

  
  

  var faTransporter4 = {
    prefix: 'fat',
    iconName: 'transporter-4',
    icon: [
      512,
      512,
      [],
      'e2a5',
      
      'M224 8c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H232c-4.4 0-8-3.6-8-8zM464 128c4.4 0 8 3.6 8 8v32h32c4.4 0 8 3.6 8 8s-3.6 8-8 8H472v32c0 4.4-3.6 8-8 8s-8-3.6-8-8V184H424c-4.4 0-8-3.6-8-8s3.6-8 8-8h32V136c0-4.4 3.6-8 8-8zM48 352c4.4 0 8 3.6 8 8v32H88c4.4 0 8 3.6 8 8s-3.6 8-8 8H56v32c0 4.4-3.6 8-8 8s-8-3.6-8-8V408H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H40V360c0-4.4 3.6-8 8-8zm96 112c-17.7 0-32 14.3-32 32v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-26.5 21.5-48 48-48H368c26.5 0 48 21.5 48 48v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-17.7-14.3-32-32-32H144zm24-80H344c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-4.4 0-8-3.6-8-8s3.6-8 8-8zm-8-56c0-4.4 3.6-8 8-8H344c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-4.4 0-8-3.6-8-8zm-56-72H408c4.4 0 8 3.6 8 8s-3.6 8-8 8H104c-4.4 0-8-3.6-8-8s3.6-8 8-8zm24-56c0-4.4 3.6-8 8-8H376c4.4 0 8 3.6 8 8s-3.6 8-8 8H136c-4.4 0-8-3.6-8-8zm72-72H312c4.4 0 8 3.6 8 8s-3.6 8-8 8H200c-4.4 0-8-3.6-8-8s3.6-8 8-8zm24-64h64c4.4 0 8 3.6 8 8s-3.6 8-8 8H224c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faPalette = {
    prefix: 'fat',
    iconName: 'palette',
    icon: [
      512,
      512,
      [127912],
      'f53f',
      
      'M496 258.5c-.3 25.3-23.7 45.5-54.1 45.5H344c-35.3 0-64 28.7-64 64c0 4.5 .5 9 1.4 13.2c2.5 12 7.7 23.6 12 33.4l0 0c.8 1.8 1.6 3.6 2.3 5.3c5.1 11.7 8.2 20.9 8.2 29.8c0 25.5-16.9 45.1-38.1 46c-3.3 .1-6.6 .2-9.9 .2C123.5 496 16 388.5 16 256S123.5 16 256 16s240 107.5 240 240c0 .8 0 1.7 0 2.5zm16 .2c0-.9 0-1.8 0-2.7C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c3.5 0 7.1-.1 10.6-.2c31.8-1.3 53.4-30.1 53.4-62c0-14.5-6.1-28.3-12.1-42c-4.3-9.8-8.7-19.7-10.8-29.9c-.7-3.2-1-6.5-1-9.9c0-26.5 21.5-48 48-48h97.9c36.5 0 69.7-24.8 70.1-61.3zM104 272a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 64a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm8-168a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm64 0a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm88-88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 64a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm104 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm64 0a40 40 0 1 0 -80 0 40 40 0 1 0 80 0z'
      
    ]
  };

  

  
  

  var faCloudArrowUp = {
    prefix: 'fat',
    iconName: 'cloud-arrow-up',
    icon: [
      640,
      512,
      [62338,"cloud-upload","cloud-upload-alt"],
      'f0ee',
      
      'M522.7 220.8c3.4-8.9 5.3-18.6 5.3-28.8c0-44.2-35.8-80-80-80c-16.5 0-31.7 5-44.4 13.5c-3.7 2.5-8.2 3.3-12.5 2.3s-8-3.8-10.2-7.6C355.9 77 309.3 48 256 48c-79.5 0-144 64.5-144 144c0 2.5 .1 4.9 .2 7.3c.4 7.1-4 13.5-10.7 15.9C51.7 232.7 16 280.2 16 336c0 70.7 57.3 128 128 128H512c61.9 0 112-50.1 112-112c0-54.2-38.5-99.4-89.6-109.8c-4.6-.9-8.6-3.9-10.9-8s-2.6-9.1-.9-13.4zM256 32c53.6 0 101 26.3 130 66.7c3.1 4.3 6 8.8 8.7 13.4c3.5-2.4 7.2-4.5 11-6.4C418.5 99.5 432.8 96 448 96c53 0 96 43 96 96c0 6.6-.7 13-1.9 19.2c-1.1 5.3-2.6 10.5-4.5 15.4c5.3 1.1 10.5 2.5 15.5 4.2C603.6 247.9 640 295.7 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160zM226.3 274.3l88-88c3.1-3.1 8.2-3.1 11.3 0l88 88c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L328 211.3V408c0 4.4-3.6 8-8 8s-8-3.6-8-8V211.3l-74.3 74.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3z'
      
    ]
  };

  
    var faCloudUpload = faCloudArrowUp;
  
    var faCloudUploadAlt = faCloudArrowUp;
  

  
  

  var faFontAwesome = {
    prefix: 'fat',
    iconName: 'font-awesome',
    icon: [
      512,
      512,
      [62501,62694,"font-awesome-flag","font-awesome-logo-full"],
      'f2b4',
      
      'M102.8 56A38.8 38.8 0 1 0 25.2 56a38.8 38.8 0 1 0 77.5 0zM64 112s0 0 0 0s0 0 0 0l-16 0 0 320 421.6 0c5.7 0 10.4-4.7 10.4-10.4c0-1.5-.3-2.9-.9-4.2L417.4 278.5c-1.8-4.1-1.8-8.9 0-13l61.7-138.9c.6-1.3 .9-2.8 .9-4.2c0-5.7-4.7-10.4-10.4-10.4L64 112zM32 102C17.5 91.8 8 75 8 56C8 25.1 33.1 0 64 0s56 25.1 56 56c0 15.7-6.4 29.8-16.8 40l366.4 0c14.6 0 26.4 11.8 26.4 26.4c0 3.7-.8 7.3-2.3 10.7L432 272l61.7 138.9c1.5 3.4 2.3 7 2.3 10.7c0 14.6-11.8 26.4-26.4 26.4L48 448l0 64-16 0 0-64 0-16 0-320 0-10z'
      
    ]
  };

  
    var faFontAwesomeFlag = faFontAwesome;
  
    var faFontAwesomeLogoFull = faFontAwesome;
  

  
  

  var faGasPumpSlash = {
    prefix: 'fat',
    iconName: 'gas-pump-slash',
    icon: [
      640,
      512,
      [],
      'f5f4',
      
      'M368 375.4V416H112V173.3L96 160.7V496l-24 0c-4.4 0-8 3.6-8 8s3.6 8 8 8H96h16H368h16 24c4.4 0 8-3.6 8-8s-3.6-8-8-8l-24 0V388.1l-16-12.6zM131.3 25.5c8-6 17.9-9.5 28.7-9.5H320c26.5 0 48 21.5 48 48V212.4L384 225V64c0-35.3-28.7-64-64-64H160c-15.9 0-30.4 5.8-41.6 15.3l12.9 10.2zM576 149.1c0-15.7-6.6-30.7-18.2-41.3L477.4 34.1c-3.3-3-8.3-2.8-11.3 .5s-2.8 8.3 .5 11.3l29.4 27V168c0 30.9 25.1 56 56 56h8V363.9l16 12.6V149.1zM368 432v64H112V432H368zM560 208h-8c-22.1 0-40-17.9-40-40V87.5l35 32.1c8.3 7.6 13 18.3 13 29.5V208zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  

  
  

  var faCrutch = {
    prefix: 'fat',
    iconName: 'crutch',
    icon: [
      512,
      512,
      [],
      'f7f7',
      
      'M308.7 20.7c-6.2 6.2-6.2 16.4 0 22.6l160 160c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-160-160c-6.2-6.2-16.4-6.2-22.6 0zM297.4 9.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3zm-95 160.9l82.7-82.7 11.3 11.3L219.3 176 336 292.7l77.1-77.1 11.3 11.3-82.7 82.7L307.4 344c-10.1 10.1-22.9 16.9-36.8 19.7L148.6 388c-10.8 2.2-20.8 7.5-28.6 15.3L21.7 501.7l-8 8c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l8-8L108.6 392c7.8-7.8 13.1-17.8 15.3-28.6l24.4-122c2.8-13.9 9.6-26.7 19.7-36.8l34.2-34.2 .1-.1 .1-.1zm5.6 17L179.4 216c-7.8 7.8-13.1 17.8-15.3 28.6l-24.4 122c-.5 2.6-1.2 5.3-2 7.8c2.6-.8 5.2-1.5 7.8-2l122-24.4c10.8-2.2 20.8-7.5 28.6-15.3L324.7 304 208 187.3z'
      
    ]
  };

  

  
  

  var faSquareALock = {
    prefix: 'fat',
    iconName: 'square-a-lock',
    icon: [
      576,
      512,
      [],
      'e44d',
      
      'M64 48H384c26.5 0 48 21.5 48 48v68.6c5.2-1.5 10.5-2.7 16-3.5V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H320V464H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48zm167.2 84.4c-1.4-2.7-4.1-4.4-7.2-4.4s-5.8 1.7-7.2 4.4l-120 240c-2 4-.4 8.8 3.6 10.7s8.8 .4 10.7-3.6L136.9 328H311.1l9.2 18.4c.7-8.2 3-15.9 6.4-22.9L231.2 132.4zM224 153.9L303.1 312H144.9L224 153.9zM464 208c26.5 0 48 21.5 48 48v64H416V256c0-26.5 21.5-48 48-48zm-64 48v64H384c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H528V256c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-16 80h16 16 96 16 16c8.8 0 16 7.2 16 16V480c0 8.8-7.2 16-16 16H384c-8.8 0-16-7.2-16-16V352c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faUserVneckHairLong = {
    prefix: 'fat',
    iconName: 'user-vneck-hair-long',
    icon: [
      448,
      512,
      [],
      'e463',
      
      'M336 144v-8-8c0-5.4-.4-10.8-1.1-16H312c-22.1 0-43-10.2-56.6-27.5L251 89.9C231.2 114 201.7 128 170.5 128L112 128v8 8c0 61.9 50.1 112 112 112s112-50.1 112-112zM292.4 39.3L265.8 71.8l1.4 1.8C277.8 87.7 294.4 96 312 96h19.4c-6.8-22.8-20.6-42.5-39-56.7zM113.1 112h57.4c26.4 0 51.4-11.8 68.1-32.3L279 30.4C262.7 21.2 244 16 224 16c-56.4 0-103.1 41.7-110.9 96zM390.4 244.8c-20.6-15.4-36.1-36.2-45.2-59.6C328.1 235.7 280.3 272 224 272s-104.1-36.3-121.2-86.8c-9.1 23.4-24.6 44.1-45.2 59.6L53.3 248c-3.4 2.5-5.3 6.5-5.3 10.7C48 266 54 272 61.3 272H120c4.4 0 8 3.6 8 8s-3.6 8-8 8H61.3C45.1 288 32 274.9 32 258.7c0-9.2 4.3-17.9 11.7-23.5L48 232c30.2-22.7 48-58.2 48-96v-8C96 57.3 153.3 0 224 0s128 57.3 128 128v8c0 37.8 17.8 73.3 48 96l4.3 3.2c7.4 5.5 11.7 14.2 11.7 23.5c0 16.2-13.1 29.3-29.3 29.3H328c-4.4 0-8-3.6-8-8s3.6-8 8-8h58.7c7.4 0 13.3-6 13.3-13.3c0-4.2-2-8.1-5.3-10.7l-4.3-3.2zm-192 163.7l-53.7-71.6C72.3 345.2 16 406.7 16 481.3c0 8.1 6.6 14.7 14.7 14.7H417.3c8.1 0 14.7-6.6 14.7-14.7c0-74.6-56.3-136.1-128.7-144.3l-53.7 71.6c-12.8 17.1-38.4 17.1-51.2 0zM143.7 321c5.3-.6 10.5 1.9 13.7 6.2l53.9 71.8c6.4 8.5 19.2 8.5 25.6 0l53.9-71.8c3.2-4.3 8.4-6.7 13.7-6.2C385.1 329.7 448 398.2 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3C0 398.2 62.9 329.7 143.7 321z'
      
    ]
  };

  

  
  

  var faCircleCaretUp = {
    prefix: 'fat',
    iconName: 'circle-caret-up',
    icon: [
      512,
      512,
      ["caret-circle-up"],
      'f331',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-352c-7.3 0-14.3 3-19.3 8.4L134.8 277.6c-4.4 4.7-6.8 10.8-6.8 17.2c0 13.9 11.3 25.2 25.2 25.2H358.8c13.9 0 25.2-11.3 25.2-25.2c0-6.4-2.4-12.5-6.8-17.2L275.3 168.4c-5-5.4-12-8.4-19.3-8.4zM153.2 304c-5.1 0-9.2-4.1-9.2-9.2c0-2.3 .9-4.6 2.5-6.3L248.4 179.3c2-2.1 4.7-3.3 7.6-3.3s5.6 1.2 7.6 3.3L365.5 288.5c1.6 1.7 2.5 4 2.5 6.3c0 5.1-4.1 9.2-9.2 9.2H153.2z'
      
    ]
  };

  
    var faCaretCircleUp = faCircleCaretUp;
  

  
  

  var faUfoBeam = {
    prefix: 'fat',
    iconName: 'ufo-beam',
    icon: [
      576,
      512,
      [],
      'e048',
      
      'M138.8 165.6c-1.3-1.3-2.1-3-2.2-4.9c-1.4-15.9-.3-31.1 2.9-45.5c-36 9.1-65.8 21.3-87.2 35.4C27.8 166.8 16 184.2 16 201.1c0 12.4 6.3 25 19.5 37.3c13.2 12.4 32.7 23.8 57.5 33.7C142.5 291.7 211.4 304 288 304s145.5-12.3 195-31.9c24.8-9.8 44.3-21.3 57.5-33.7c13.2-12.3 19.5-25 19.5-37.3c0-16.9-11.8-34.3-36.3-50.4c-21.4-14.1-51.3-26.3-87.2-35.4c3.2 14.3 4.3 29.6 2.9 45.5c-.2 1.8-1 3.6-2.2 4.9l-5.7-5.6c5.7 5.6 5.7 5.6 5.7 5.6l0 0 0 0-.1 .1-.1 .1-.5 .5c-.4 .4-1 .9-1.7 1.5c-1.5 1.3-3.6 3-6.4 5c-5.7 4-14.3 9.3-26.3 14.5C378.2 197.8 341.2 208 288 208s-90.2-10.2-114-20.7c-11.9-5.2-20.5-10.5-26.3-14.5c-2.9-2-5-3.7-6.4-5c-.7-.6-1.3-1.1-1.7-1.5l-.5-.5-.1-.1-.1-.1 0 0 0 0s0 0 5.7-5.6l-5.7 5.6zM431.3 97.5c41.1 9.5 76 23.2 101.2 39.8c26.2 17.2 43.5 38.9 43.5 63.8c0 18.3-9.4 34.8-24.5 49c-15.2 14.2-36.6 26.6-62.5 36.9C437.1 307.5 366.1 320 288 320s-149.1-12.5-200.9-33.1c-25.9-10.3-47.4-22.7-62.5-36.9C9.4 235.9 0 219.3 0 201.1c0-24.9 17.3-46.5 43.5-63.8c25.2-16.6 60.2-30.2 101.2-39.8C166 39.5 223.6 0 288 0s122 39.5 143.3 97.5zM288 16c-76.4 0-140.9 61.3-135.7 140.2c1.1 .9 2.6 2.1 4.6 3.5c4.9 3.5 12.6 8.2 23.4 13C202.1 182.2 236.9 192 288 192s85.9-9.8 107.6-19.3c10.9-4.8 18.6-9.5 23.4-13c2-1.4 3.5-2.6 4.6-3.5C428.9 77.3 364.4 16 288 16zM272 256a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM96 176a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm368 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM102.9 356l-88 152c-2.2 3.8-7.1 5.1-10.9 2.9s-5.1-7.1-2.9-10.9l88-152c2.2-3.8 7.1-5.1 10.9-2.9s5.1 7.1 2.9 10.9zm384-8l88 152c2.2 3.8 .9 8.7-2.9 10.9s-8.7 .9-10.9-2.9l-88-152c-2.2-3.8-.9-8.7 2.9-10.9s8.7-.9 10.9 2.9z'
      
    ]
  };

  

  
  

  var faSmog = {
    prefix: 'fat',
    iconName: 'smog',
    icon: [
      640,
      512,
      [],
      'f75f',
      
      'M176 0C96.5 0 32 64.5 32 144s64.5 144 144 144H299.3c22.6 19.9 52.2 32 84.7 32s62.1-12.1 84.7-32H496c61.9 0 112-50.1 112-112s-50.1-112-112-112c-10.7 0-21 1.5-30.8 4.3C443.8 27.7 401.1 0 352 0c-32.6 0-62.5 12.2-85.1 32.3C242.2 12.1 210.5 0 176 0zM48 144C48 73.3 105.3 16 176 16c33 0 63.1 12.5 85.8 33c3.2 2.9 8 2.7 11-.3C293.1 28.5 321.1 16 352 16c45.2 0 84.1 26.8 101.8 65.3c1.7 3.8 6 5.6 10 4.2C473.9 82 484.7 80 496 80c53 0 96 43 96 96s-43 96-96 96H465.6c-2 0-4 .8-5.4 2.1c-20 18.5-46.7 29.9-76.1 29.9s-56.2-11.3-76.1-29.9c-1.5-1.4-3.4-2.1-5.4-2.1H176c-70.7 0-128-57.3-128-128zM72 384c-4.4 0-8 3.6-8 8s3.6 8 8 8H216c4.4 0 8-3.6 8-8s-3.6-8-8-8H72zm192 0c-4.4 0-8 3.6-8 8s3.6 8 8 8H632c4.4 0 8-3.6 8-8s-3.6-8-8-8H264zM8 496c-4.4 0-8 3.6-8 8s3.6 8 8 8H376c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zm416 0c-4.4 0-8 3.6-8 8s3.6 8 8 8H568c4.4 0 8-3.6 8-8s-3.6-8-8-8H424z'
      
    ]
  };

  

  
  

  var faBlindsRaised = {
    prefix: 'fat',
    iconName: 'blinds-raised',
    icon: [
      512,
      512,
      [],
      'f8fd',
      
      'M32 16c-8.8 0-16 7.2-16 16V64c0 8.8 7.2 16 16 16H480c8.8 0 16-7.2 16-16V32c0-8.8-7.2-16-16-16H32zM0 32C0 14.3 14.3 0 32 0H480c17.7 0 32 14.3 32 32V64c0 17.7-14.3 32-32 32H152v80 16 80 16V416c0 .2 0 .4 0 .7c22.7 3.8 40 23.5 40 47.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-23.8 17.3-43.5 40-47.3c0-.2 0-.4 0-.7V288 272 192 176 96H32C14.3 96 0 81.7 0 64V32zM176 464a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM104 176v16H19.7C8.8 192 0 183.2 0 172.3c0-2.8 .6-5.7 1.8-8.2L18.5 128H36.1L16.3 170.8c-.2 .5-.3 1-.3 1.5c0 2 1.6 3.7 3.7 3.7H104zm80 16V176H492.3c2 0 3.7-1.6 3.7-3.7c0-.5-.1-1.1-.3-1.5L475.9 128h17.6l16.6 36.1c1.2 2.6 1.8 5.4 1.8 8.2c0 10.9-8.8 19.7-19.7 19.7H184zm308.3 80c2 0 3.7-1.6 3.7-3.7c0-.5-.1-1.1-.3-1.5L475.9 224h17.6l16.6 36.1c1.2 2.6 1.8 5.4 1.8 8.2c0 10.9-8.8 19.7-19.7 19.7H184V272H492.3zM104 272v16H19.7C8.8 288 0 279.2 0 268.3c0-2.8 .6-5.7 1.8-8.2L18.5 224H36.1L16.3 266.8c-.2 .5-.3 1-.3 1.5c0 2 1.6 3.7 3.7 3.7H104z'
      
    ]
  };

  

  
  

  var faMoneyBills = {
    prefix: 'fat',
    iconName: 'money-bills',
    icon: [
      640,
      512,
      [],
      'e1f3',
      
      'M576 48c26.5 0 48 21.5 48 48V320c0 26.5-21.5 48-48 48H160c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H576zM160 32c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zM64 128c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H480c35.3 0 64-28.7 64-64H528c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V192c0-26.5 21.5-48 48-48V128zm224 80a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm176 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm136-56c0-4.4-3.6-8-8-8h-8c-30.9 0-56-25.1-56-56V80c0-4.4-3.6-8-8-8s-8 3.6-8 8v8c0 39.8 32.2 72 72 72h8c4.4 0 8-3.6 8-8zm-456 8h8c39.8 0 72-32.2 72-72V80c0-4.4-3.6-8-8-8s-8 3.6-8 8v8c0 30.9-25.1 56-56 56h-8c-4.4 0-8 3.6-8 8s3.6 8 8 8zM600 264c0-4.4-3.6-8-8-8h-8c-39.8 0-72 32.2-72 72v8c0 4.4 3.6 8 8 8s8-3.6 8-8v-8c0-30.9 25.1-56 56-56h8c4.4 0 8-3.6 8-8zm-456-8c-4.4 0-8 3.6-8 8s3.6 8 8 8h8c30.9 0 56 25.1 56 56v8c0 4.4 3.6 8 8 8s8-3.6 8-8v-8c0-39.8-32.2-72-72-72h-8z'
      
    ]
  };

  

  
  

  var faFaceTired = {
    prefix: 'fat',
    iconName: 'face-tired',
    icon: [
      512,
      512,
      [128555,"tired"],
      'f5c8',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176 84c-10 10-18 21-23.5 31.5S144 392 144 400l20.5-7.7c28.7-10.8 59.2-16.3 89.9-16.3h3.2c30.7 0 61.1 5.5 89.9 16.3L368 400c0-8-3-18-8.5-28.5S346 350 336 340c-20-20-48-36-80-36s-60 16-80 36zm80-52c37.4 0 69.3 18.7 91.3 40.7c11.1 11.1 20.1 23.4 26.4 35.4c6.2 11.7 10.3 24.4 10.3 35.9c0 5.2-2.6 10.2-6.9 13.2s-9.8 3.7-14.7 1.8l-20.5-7.7c-26.9-10.1-55.5-15.3-84.3-15.3h-3.2c-28.8 0-57.3 5.2-84.3 15.3L149.6 415c-4.9 1.8-10.4 1.2-14.7-1.8s-6.9-7.9-6.9-13.2c0-11.6 4.2-24.2 10.3-35.9c6.3-12 15.3-24.3 26.4-35.4c22-22 53.9-40.7 91.3-40.7zM128.8 164.4c2-4 6.8-5.6 10.7-3.6l80 40c2.7 1.4 4.4 4.1 4.4 7.2s-1.7 5.8-4.4 7.2l-80 40c-4 2-8.8 .4-10.7-3.6s-.4-8.8 3.6-10.7L198.1 208l-65.7-32.8c-4-2-5.6-6.8-3.6-10.7zm243.6-3.6c4-2 8.8-.4 10.7 3.6s.4 8.8-3.6 10.7L313.9 208l65.7 32.8c4 2 5.6 6.8 3.6 10.7s-6.8 5.6-10.7 3.6l-80-40c-2.7-1.4-4.4-4.1-4.4-7.2s1.7-5.8 4.4-7.2l80-40z'
      
    ]
  };

  
    var faTired = faFaceTired;
  

  
  

  var faHouseLaptop = {
    prefix: 'fat',
    iconName: 'house-laptop',
    icon: [
      640,
      512,
      ["laptop-house"],
      'e066',
      
      'M234.8 1.9c3-2.6 7.4-2.6 10.4 0l232 200c3.3 2.9 3.7 7.9 .8 11.3s-7.9 3.7-11.3 .8L416 170.3V224H400V156.5L240 18.6 80 156.5V360c0 22.1 17.9 40 40 40H272v16H120c-30.9 0-56-25.1-56-56V170.3L13.2 214.1c-3.3 2.9-8.4 2.5-11.3-.8s-2.5-8.4 .8-11.3l232-200zM304 200v26.7c-6 2.1-11.4 5.4-16 9.5V200c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h72v16H200c-13.3 0-24-10.7-24-24V200c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24zm256 72H336c-8.8 0-16 7.2-16 16V448H576V288c0-8.8-7.2-16-16-16zM304 288c0-17.7 14.3-32 32-32H560c17.7 0 32 14.3 32 32V448h32c8.8 0 16 7.2 16 16c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48c0-8.8 7.2-16 16-16h32V288zM576 464H320 304 272c0 17.7 14.3 32 32 32H592c17.7 0 32-14.3 32-32H592 576z'
      
    ]
  };

  
    var faLaptopHouse = faHouseLaptop;
  

  
  

  var faBurst = {
    prefix: 'fat',
    iconName: 'burst',
    icon: [
      512,
      512,
      [],
      'e4dc',
      
      'M256 8c6.9 0 13.1 4.5 15.2 11.1l37.1 114.4L386.5 105c5.8-2.1 12.4-.7 16.8 3.7s5.8 10.9 3.7 16.8l-28.5 78.2 114.4 37.1c6.6 2.1 11.1 8.3 11.1 15.2s-4.5 13.1-11.1 15.2L380.8 307.5l57.3 109c3.3 6.2 2.1 13.8-2.8 18.8s-12.6 6.1-18.8 2.8l-109-57.3L271.2 492.9c-2.1 6.6-8.3 11.1-15.2 11.1s-13.1-4.5-15.2-11.1L204.5 380.8l-109 57.3c-6.2 3.3-13.8 2.1-18.8-2.8s-6.1-12.6-2.8-18.8l57.3-109L19.1 271.2C12.5 269.1 8 262.9 8 256s4.5-13.1 11.1-15.2l109.8-35.6L10.8 33c-4.4-6.4-3.6-14.9 1.9-20.4s14-6.2 20.4-1.9L205.2 128.9 240.8 19.1C242.9 12.5 249.1 8 256 8zm0 16l-8.4 26-27.2 83.8c-3.3 10.2-15.5 14.3-24.3 8.3L60.6 49.1 24 24 49.1 60.6l92.9 135.5c6 8.8 1.9 21-8.3 24.3L50 247.6 24 256l26 8.4 86.2 27.9c9.4 3.1 13.8 13.9 9.2 22.7l-44.2 84L88 424l25-13.1 84-44.2c8.8-4.6 19.6-.2 22.7 9.2L247.6 462l8.4 26 8.4-26 27.9-86.2c3.1-9.4 13.9-13.8 22.7-9.2l84 44.2L424 424l-13.1-25-44.2-84c-4.6-8.8-.2-19.6 9.2-22.7L462 264.4l26-8.4-26-8.4-88.4-28.7c-8.6-2.8-13.2-12.2-10.1-20.7l21.4-58.6L392 120l-19.6 7.2-58.6 21.4c-8.5 3.1-17.9-1.5-20.7-10.1L264.4 50 256 24z'
      
    ]
  };

  

  
  

  var faIntegral = {
    prefix: 'fat',
    iconName: 'integral',
    icon: [
      320,
      512,
      [],
      'f667',
      
      'M220 16c-28.7 0-52 23.3-52 52V444c0 37.6-30.4 68-68 68s-68-30.4-68-68V424c0-4.4 3.6-8 8-8s8 3.6 8 8v20c0 28.7 23.3 52 52 52s52-23.3 52-52V68c0-37.6 30.4-68 68-68s68 30.4 68 68V88c0 4.4-3.6 8-8 8s-8-3.6-8-8V68c0-28.7-23.3-52-52-52z'
      
    ]
  };

  

  
  

  var faDiamondTurnRight = {
    prefix: 'fat',
    iconName: 'diamond-turn-right',
    icon: [
      512,
      512,
      ["directions"],
      'f5eb',
      
      'M273 23c-9.4-9.4-24.6-9.4-33.9 0L23 239c-9.4 9.4-9.4 24.6 0 33.9L239 489c9.4 9.4 24.6 9.4 33.9 0L489 273c9.4-9.4 9.4-24.6 0-33.9L273 23zM227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zm81.9 134.6l72 72c3.1 3.1 3.1 8.2 0 11.3l-72 72c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L356.7 232H232c-17.7 0-32 14.3-32 32v64c0 4.4-3.6 8-8 8s-8-3.6-8-8V264c0-26.5 21.5-48 48-48H356.7l-58.3-58.3c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0z'
      
    ]
  };

  
    var faDirections = faDiamondTurnRight;
  

  
  

  var faSubscript = {
    prefix: 'fat',
    iconName: 'subscript',
    icon: [
      512,
      512,
      [],
      'f12c',
      
      'M8 64c-4.4 0-8 3.6-8 8s3.6 8 8 8H36L166.1 256 36 432H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H40c2.5 0 4.9-1.2 6.4-3.2L176 269.5 305.6 444.8c1.5 2 3.9 3.2 6.4 3.2h32c4.4 0 8-3.6 8-8s-3.6-8-8-8H316L185.9 256 316 80h28c4.4 0 8-3.6 8-8s-3.6-8-8-8H312c-2.5 0-4.9 1.2-6.4 3.2L176 242.5 46.4 67.2c-1.5-2-3.9-3.2-6.4-3.2H8zM464 360c0-2.7-1.3-5.1-3.5-6.6s-5-1.8-7.5-.8l-40 16c-4.1 1.6-6.1 6.3-4.5 10.4s6.3 6.1 10.4 4.5l29-11.6V496H416c-4.4 0-8 3.6-8 8s3.6 8 8 8h40 40c4.4 0 8-3.6 8-8s-3.6-8-8-8H464V360z'
      
    ]
  };

  

  
  

  var faGlobeSnow = {
    prefix: 'fat',
    iconName: 'globe-snow',
    icon: [
      448,
      512,
      [],
      'f7a3',
      
      'M432 224c0 55.9-22 106.6-57.9 144h21.5c32.7-38.9 52.4-89.2 52.4-144C448 100.3 347.7 0 224 0S0 100.3 0 224c0 54.8 19.7 105.1 52.4 144H73.9C38 330.6 16 279.9 16 224C16 109.1 109.1 16 224 16s208 93.1 208 208zM240 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-10.3 66.3c-3.1-3.1-8.2-3.1-11.3 0l-72 72c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L216 187.3v41.4l-77.7 77.7c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L216 251.3V368h16V251.3l66.3 66.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L232 228.7V187.3l58.3 58.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-72-72zM352 176a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM80 256a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM73.3 403.6L28.4 470.9c-2.9 4.3-4.4 9.4-4.4 14.7C24 500.2 35.8 512 50.4 512H397.6c14.6 0 26.4-11.8 26.4-26.4c0-5.2-1.5-10.3-4.4-14.7l-44.9-67.4c-1.5-2.2-4-3.6-6.7-3.6H80c-2.7 0-5.2 1.3-6.7 3.6zM84.3 416H363.7l42.5 63.8c1.1 1.7 1.8 3.7 1.8 5.8c0 5.8-4.7 10.4-10.4 10.4H50.4c-5.8 0-10.4-4.7-10.4-10.4c0-2.1 .6-4.1 1.8-5.8L84.3 416z'
      
    ]
  };

  

  
  

  var faScaleUnbalancedFlip = {
    prefix: 'fat',
    iconName: 'scale-unbalanced-flip',
    icon: [
      640,
      512,
      ["balance-scale-right"],
      'f516',
      
      'M95.8 5.5c-1.4 4.2 .9 8.7 5.1 10.1L255.4 67.1c1.5 31.2 25.4 56.6 55.9 60.4V496h-208c-4.4 0-8 3.6-8 8s3.6 8 8 8h216c4.4 0 8-3.6 8-8V127.5c16.5-2.1 31.1-10.4 41.3-22.7l164.2 54.7c4.2 1.4 8.7-.9 10.1-5.1s-.9-8.7-5.1-10.1L377.4 90.9c3.8-8.2 5.9-17.3 5.9-26.9c0-35.3-28.7-64-64-64c-30.8 0-56.5 21.7-62.6 50.7L105.9 .4c-4.2-1.4-8.7 .9-10.1 5.1zM587.3 464c-20.5 19.2-47.1 32-75.7 32s-55.2-12.8-75.7-32c-20.3-19-33.1-43.1-35.8-64h223c-2.7 20.9-15.5 44.9-35.8 64zM511.6 209.8L616.2 384H407.1L511.6 209.8zM388.2 384.4c-3 5-4.7 10.7-4.1 16.4C390 452.2 444.8 512 511.6 512s121.7-59.8 127.5-111.2c.7-5.8-1.1-11.5-4-16.4L523.7 198.9c-2.6-4.3-7.2-6.9-12.1-6.9s-9.6 2.6-12.1 6.9L388.2 384.4zM239.1 272c-2.7 20.9-15.5 44.9-35.8 64c-20.5 19.2-47.1 32-75.7 32s-55.2-12.8-75.7-32c-20.3-19-33.1-43.1-35.8-64h223zm-6.9-16H23.1L127.6 81.8 232.2 256zM115.5 70.9L4.2 256.4c-3 5-4.7 10.7-4.1 16.4C6 324.2 60.8 384 127.6 384s121.7-59.8 127.5-111.2c.7-5.8-1.1-11.5-4.1-16.4L139.7 70.9c-2.6-4.3-7.2-6.9-12.1-6.9s-9.6 2.6-12.1 6.9zM319.3 16a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  
    var faBalanceScaleRight = faScaleUnbalancedFlip;
  

  
  

  var faAddressCard = {
    prefix: 'fat',
    iconName: 'address-card',
    icon: [
      576,
      512,
      [62140,"contact-card","vcard"],
      'f2bb',
      
      'M512 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 160a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM96 360c0-30.9 25.1-56 56-56h80c30.9 0 56 25.1 56 56c0 4.4 3.6 8 8 8s8-3.6 8-8c0-39.8-32.2-72-72-72H152c-39.8 0-72 32.2-72 72c0 4.4 3.6 8 8 8s8-3.6 8-8zM360 176c-4.4 0-8 3.6-8 8s3.6 8 8 8H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H360zm0 64c-4.4 0-8 3.6-8 8s3.6 8 8 8H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H360zm0 64c-4.4 0-8 3.6-8 8s3.6 8 8 8H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H360z'
      
    ]
  };

  
    var faContactCard = faAddressCard;
  
    var faVcard = faAddressCard;
  

  
  

  var faTrashCanPlus = {
    prefix: 'fat',
    iconName: 'trash-can-plus',
    icon: [
      448,
      512,
      [],
      'e2ac',
      
      'M157.4 27.3L134.4 64H313.6l-23-36.7c-4.4-7-12.1-11.3-20.4-11.3H177.7c-8.3 0-16 4.3-20.4 11.3zM115.6 64l28.2-45.2C151.1 7.1 163.9 0 177.7 0h92.5c13.8 0 26.6 7.1 33.9 18.8L332.4 64H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H115.6zM40 112c4.4 0 8 3.6 8 8V440c0 30.9 25.1 56 56 56H344c30.9 0 56-25.1 56-56V120c0-4.4 3.6-8 8-8s8 3.6 8 8V440c0 39.8-32.2 72-72 72H104c-39.8 0-72-32.2-72-72V120c0-4.4 3.6-8 8-8zM216 384V296H128c-4.4 0-8-3.6-8-8s3.6-8 8-8h88V192c0-4.4 3.6-8 8-8s8 3.6 8 8v88h88c4.4 0 8 3.6 8 8s-3.6 8-8 8H232v88c0 4.4-3.6 8-8 8s-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faRegistered = {
    prefix: 'fat',
    iconName: 'registered',
    icon: [
      512,
      512,
      [174],
      'f25d',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 152V280v96c0 4.4 3.6 8 8 8s8-3.6 8-8V288h96c3.8 0 7.5-.3 11.2-.8l62.1 93.2c2.5 3.7 7.4 4.7 11.1 2.2s4.7-7.4 2.2-11.1l-59-88.5C330.2 271.8 352 242.5 352 208c0-44.2-35.8-80-80-80H184c-13.3 0-24 10.7-24 24zm16 120V152c0-4.4 3.6-8 8-8h88c35.3 0 64 28.7 64 64s-28.7 64-64 64H176z'
      
    ]
  };

  

  
  

  var faGaugeLow = {
    prefix: 'fat',
    iconName: 'gauge-low',
    icon: [
      512,
      512,
      ["tachometer-alt-slow"],
      'f627',
      
      'M256 496a240 240 0 1 0 0-480 240 240 0 1 0 0 480zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm16 80a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM208 352a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm-16 0c0-22.2 11.3-41.7 28.4-53.2L136.8 131.6c-2-4-.4-8.8 3.6-10.7s8.8-.4 10.7 3.6l83.6 167.2c6.6-2.3 13.8-3.6 21.2-3.6c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64zM384 128a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm32 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM112 240a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z'
      
    ]
  };

  
    var faTachometerAltSlow = faGaugeLow;
  

  
  

  var faBomb = {
    prefix: 'fat',
    iconName: 'bomb',
    icon: [
      512,
      512,
      [128163],
      'f1e2',
      
      'M456 16V56h40c4.4 0 8 3.6 8 8s-3.6 8-8 8H456v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V72H400c-4.4 0-8-3.6-8-8s3.6-8 8-8h40V16c0-4.4 3.6-8 8-8s8 3.6 8 8zM289.8 119.6c-4.4 4.4-10.9 5.8-16.7 3.7C252.8 116 230.9 112 208 112C102 112 16 198 16 304s86 192 192 192s192-86 192-192c0-22.9-4-44.8-11.3-65.1c-2.1-5.8-.6-12.4 3.7-16.7l2.9-2.9c6.2-6.2 6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0l-2.9 2.9zM406.6 230.6l-2.9 2.9c7.9 22 12.2 45.7 12.2 70.5c0 114.9-93.1 208-208 208S0 418.9 0 304S93.1 96 208 96c24.7 0 48.5 4.3 70.5 12.3l2.9-2.9c12.5-12.5 32.8-12.5 45.3 0L361 139.7l33.4-33.4c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L372.3 151l34.3 34.3c12.5 12.5 12.5 32.8 0 45.3zM200 184c-61.9 0-112 50.1-112 112v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-70.7 57.3-128 128-128h8c4.4 0 8 3.6 8 8s-3.6 8-8 8h-8z'
      
    ]
  };

  

  
  

  var faTemperatureEmpty = {
    prefix: 'fat',
    iconName: 'temperature-empty',
    icon: [
      320,
      512,
      ["temperature-0","thermometer-0","thermometer-empty"],
      'f2cb',
      
      'M96 80c0-35.3 28.7-64 64-64s64 28.7 64 64V243.8c0 8.4 4.4 15.7 10.7 20.3C267 287.3 288 325.2 288 368c0 70.7-57.3 128-128 128S32 438.7 32 368c0-42.8 21-80.7 53.3-104c6.3-4.6 10.7-11.9 10.7-20.3V80zM160 0C115.8 0 80 35.8 80 80V243.8c0 2.7-1.4 5.4-4 7.3c-36.3 26.1-60 68.8-60 117c0 79.5 64.5 144 144 144s144-64.5 144-144c0-48.2-23.7-90.8-60-117c-2.6-1.9-4-4.6-4-7.3V80c0-44.2-35.8-80-80-80zM112 368a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0A64 64 0 1 0 96 368a64 64 0 1 0 128 0z'
      
    ]
  };

  
    var faTemperature0 = faTemperatureEmpty;
  
    var faThermometer0 = faTemperatureEmpty;
  
    var faThermometerEmpty = faTemperatureEmpty;
  

  
  

  var faHillAvalanche = {
    prefix: 'fat',
    iconName: 'hill-avalanche',
    icon: [
      576,
      512,
      [],
      'e507',
      
      'M191.7 40c15.3 0 29.1 6.1 39.2 16.1c2.9 2.9 7.6 3.1 10.7 .5C254.1 46.2 270.1 40 287.5 40c39.7 0 71.9 32.2 71.9 72c0 6.7-.9 13.2-2.6 19.3c-1.1 4 1 8.1 4.8 9.6c26.8 10.5 45.7 36.6 45.7 67.1c0 16.2-5.3 31.2-14.4 43.2c-2.6 3.5-1.9 8.5 1.6 11.2s8.5 1.9 11.2-1.6c11-14.7 17.6-33 17.6-52.8c0-34.8-20.2-64.9-49.5-79.2c1-5.4 1.6-11.1 1.6-16.8c0-48.6-39.3-88-87.9-88c-18.8 0-36.3 5.9-50.6 16c-12.3-10-28.1-16-45.2-16c-39.5 0-71.5 31.9-71.9 71.3c-.2 2.3 .6 4.6 2.3 6.3L431 411.2c26.8 26.9 69.8 28.3 98.4 3.3l4.2-3.7c30.2-26.5 30.5-73.4 .8-100.4c-22.2-20.1-55.1-23-80.5-7.1l-3 1.9c-3.7 2.3-4.9 7.3-2.5 11s7.3 4.9 11 2.5l3-1.9c19.3-12.1 44.4-9.9 61.3 5.4c22.7 20.5 22.4 56.3-.6 76.4l-4.2 3.7c-22.2 19.5-55.7 18.4-76.6-2.5L135.9 92.8c1.7-29.5 26-52.8 55.8-52.8zm255.5 8a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm31.9 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM16 102.6c0-7.1 8.6-10.7 13.7-5.7L415 482.3c5 5 1.5 13.7-5.7 13.7H56c-22.1 0-40-17.9-40-40V102.6zm25-17c-15.1-15.1-41-4.4-41 17V456c0 30.9 25.1 56 56 56H409.4c21.4 0 32.1-25.9 17-41L41 85.7z'
      
    ]
  };

  

  
  

  var faPlaneEngines = {
    prefix: 'fat',
    iconName: 'plane-engines',
    icon: [
      576,
      512,
      [9992,"plane-alt"],
      'f3de',
      
      'M542.7 209.7C559.8 220.2 576 236.2 576 256c0 20.2-16.2 36.3-33.3 46.7c-17.6 10.7-39.3 17.3-55.8 17.3L368 320l-1.3 0-35.4 64.2C343 385.8 352 395.8 352 408v16c0 13.3-10.7 24-24 24H296l-23.9 43.3c-7 12.8-20.5 20.7-35 20.7L189 512c-15.9 0-27.4-15.1-23.1-30.4L210.5 320 192 320H116L75.2 374.4c-4.5 6-11.6 9.6-19.2 9.6H21.9C9.8 384 0 374.2 0 362.1c0-2.2 .3-4.4 1-6.4l21.3-69.2C9.3 282.4 0 270.3 0 256s9.3-26.4 22.2-30.5L1 156.4c-.6-2.1-1-4.3-1-6.4C0 137.8 9.8 128 21.9 128L56 128c7.6 0 14.7 3.6 19.2 9.6L116 192l76 0h18.5L165.9 30.4C161.7 15.1 173.2 0 189 0h48.1c14.6 0 28 7.9 35 20.7L296 64h32c13.3 0 24 10.7 24 24v16c0 12.2-9 22.2-20.8 23.8L366.7 192l1.3 0H486.8c16.6 0 38.3 7 55.9 17.7zM27 271.2L31.6 256 27 240.8c-6.4 2.1-11 8.1-11 15.2s4.6 13.1 11 15.2zM304.9 432H328c4.4 0 8-3.6 8-8V408c0-4.4-3.6-8-8-8h-5.5l-17.7 32zm17.7-320H328c4.4 0 8-3.6 8-8V88c0-4.4-3.6-8-8-8H304.9l17.7 32zM368 208l-6.1 0-141 0H192l-80 0c-2.5 0-4.9-1.2-6.4-3.2L62.4 147.2c-1.5-2-3.9-3.2-6.4-3.2l-34.1 0c-3.3 0-5.9 2.6-5.9 5.9c0 .6 .1 1.2 .3 1.7L8.6 154l7.6-2.4 31.4 102c.5 1.5 .5 3.2 0 4.7l-31.4 102L8.6 358l7.6 2.4c-.2 .6-.3 1.1-.3 1.7c0 3.3 2.6 5.9 5.9 5.9H56c2.5 0 4.9-1.2 6.4-3.2l43.2-57.6c1.5-2 3.9-3.2 6.4-3.2h80 29H361.9l0 0 6.1 0 118.8 0c13 0 31.9-5.6 47.5-15c16-9.7 25.6-21.6 25.6-33c0-10.9-9.6-22.8-25.7-32.7c-15.7-9.6-34.5-15.3-47.5-15.3H368zm-19.6-16L258.1 28.4c-4.2-7.7-12.3-12.4-21-12.4L189 16c-5.3 0-9.1 5-7.7 10.1L227.1 192H348.4zM227.1 320L181.3 485.9c-1.4 5.1 2.4 10.1 7.7 10.1l48.1 0c8.7 0 16.8-4.8 21-12.4L348.4 320H227.1z'
      
    ]
  };

  
    var faPlaneAlt = faPlaneEngines;
  

  
  

  var faClockEightThirty = {
    prefix: 'fat',
    iconName: 'clock-eight-thirty',
    icon: [
      512,
      512,
      [],
      'e346',
      
      'M16 256a240 240 0 1 0 480 0A240 240 0 1 0 16 256zm496 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM248 408V270.9l-83.6 55.7c-3.7 2.5-8.6 1.5-11.1-2.2s-1.5-8.6 2.2-11.1l96-64c2.5-1.6 5.6-1.8 8.2-.4s4.2 4.1 4.2 7.1V408c0 4.4-3.6 8-8 8s-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faPause = {
    prefix: 'fat',
    iconName: 'pause',
    icon: [
      320,
      512,
      [9208],
      'f04c',
      
      'M48 80c-17.7 0-32 14.3-32 32V400c0 17.7 14.3 32 32 32H80c17.7 0 32-14.3 32-32V112c0-17.7-14.3-32-32-32H48zM0 112C0 85.5 21.5 64 48 64H80c26.5 0 48 21.5 48 48V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112zM240 80c-17.7 0-32 14.3-32 32V400c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V112c0-17.7-14.3-32-32-32H240zm-48 32c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48V400c0 26.5-21.5 48-48 48H240c-26.5 0-48-21.5-48-48V112z'
      
    ]
  };

  

  
  

  var faLocationPinLock = {
    prefix: 'fat',
    iconName: 'location-pin-lock',
    icon: [
      512,
      512,
      [],
      'e51f',
      
      'M203.2 489.2c14-17.5 32.8-41.7 52.8-69.5v27.1c-15.3 20.6-29.3 38.6-40.3 52.3c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0c95.7 0 175 70 189.6 161.5c-5.3 .9-10.6 2.1-15.6 3.8C353.1 80.7 280.1 16 192 16C94.8 16 16 94.8 16 192c0 18.7 6.4 42.5 17.8 69.6c11.3 26.9 27.1 55.8 44.7 84.3c35.2 57 76.8 111.4 102.3 143.2c5.9 7.3 16.6 7.3 22.4 0zM192 112a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm64 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm144 16c-26.5 0-48 21.5-48 48v64h96V256c0-26.5-21.5-48-48-48zm-64 48c0-35.3 28.7-64 64-64s64 28.7 64 64v64h16c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32h16V256zm-16 80c-8.8 0-16 7.2-16 16V480c0 8.8 7.2 16 16 16H480c8.8 0 16-7.2 16-16V352c0-8.8-7.2-16-16-16H464 448 352 336 320z'
      
    ]
  };

  

  
  

  var faStrawberry = {
    prefix: 'fat',
    iconName: 'strawberry',
    icon: [
      512,
      512,
      [],
      'e32b',
      
      'M482.2 .3c4.2 1.2 6.7 5.6 5.5 9.9c-14.6 51.1-48.9 83.5-83.2 111.6c3.9-.3 8.1-.4 12.8-.4c41.3 0 72.1 20.4 85.1 30.7c6.5 5.2 9.6 13 9.6 20.6s-3 15.3-9.4 20.6c-9.9 8.1-30.5 22.9-56.3 28.5c-3.8-4.9-8-9.6-12.5-14.2c25.9-2.7 48-18 58.6-26.7c2.2-1.8 3.6-4.7 3.6-8.2s-1.4-6.4-3.5-8.1c-11.7-9.3-39.1-27.3-75.2-27.3c-16.7 0-26.6 2.1-32.1 3.9c-2.7 .9-4.4 1.8-5.2 2.2c-.3 .2-.6 .4-.6 .4c-2 1.9-4.8 2.5-7.4 1.8l-5.8-5.8c-.6-2.5 0-5.3 1.8-7.4c.1-.1 .2-.3 .4-.6c.5-.8 1.3-2.4 2.2-5.2c1.8-5.5 3.9-15.4 3.9-32.1c0-36.1-17.9-63.4-27.3-75.2c-1.7-2.2-4.6-3.5-8.1-3.5s-6.4 1.4-8.2 3.6c-8.7 10.6-24 32.7-26.7 58.6c-4.5-4.5-9.3-8.6-14.2-12.5c5.6-25.8 20.4-46.4 28.5-56.3C324 3 331.7 0 339.3 0s15.4 3 20.6 9.6c10.3 13 30.7 43.8 30.7 85.1c0 7.1-.3 13.2-.9 18.5c35.5-28.8 68.7-59 82.6-107.3c1.2-4.2 5.6-6.7 9.9-5.5zM289.7 108.7L318 137l57 57 28.3 28.3 7.2 7.2c25 25 37.5 57.8 37.5 90.5c0 96-96 192-272 192C48 512 0 464 0 336C0 160 96.2 64 192.2 64c32.7 .1 65.3 12.6 90.3 37.5l7.2 7.2zm16 38.6l-34.5-34.5C249.4 91 220.8 80.1 192.2 80C108.5 80 16 165 16 336c0 62.7 11.9 101.3 35.3 124.7S113.3 496 176 496c171 0 256-92.3 256-176c0-28.7-10.9-57.3-32.8-79.2l-34.5-34.5c-10.5-7.5-20-17-30.5-27.5l-.5-.5-.5-.5 0 0c-10.5-10.5-20-20-27.5-30.5zM213.7 309.7l-32 32c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l32-32c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3zm96-43.3c3.1 3.1 3.1 8.2 0 11.3l-32 32c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l32-32c3.1-3.1 8.2-3.1 11.3 0zm-32 107.3l-32 32c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l32-32c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3zm96-32l-32 32c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l32-32c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3zm-224-96l-32 32c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l32-32c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3zm96-43.3c3.1 3.1 3.1 8.2 0 11.3l-32 32c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l32-32c3.1-3.1 8.2-3.1 11.3 0zm-64-52.7l-32 32c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l32-32c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3zm-64 180.7c3.1 3.1 3.1 8.2 0 11.3l-32 32c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l32-32c3.1-3.1 8.2-3.1 11.3 0zm64 75.3l-32 32c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l32-32c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3z'
      
    ]
  };

  

  
  

  var faArrowLeftFromLine = {
    prefix: 'fat',
    iconName: 'arrow-left-from-line',
    icon: [
      448,
      512,
      [8612,"arrow-from-right"],
      'f344',
      
      'M2.3 250.3c-3.1 3.1-3.1 8.2 0 11.3l136 136c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L27.3 264 344 264c4.4 0 8-3.6 8-8s-3.6-8-8-8L27.3 248 149.7 125.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-136 136zM432 440c0 4.4 3.6 8 8 8s8-3.6 8-8l0-368c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 368z'
      
    ]
  };

  
    var faArrowFromRight = faArrowLeftFromLine;
  

  
  

  var faSpa = {
    prefix: 'fat',
    iconName: 'spa',
    icon: [
      576,
      512,
      [],
      'f5bb',
      
      'M182.7 244.9c-4.7-3.4-9.5-6.7-14.4-9.8c-2.7-1.7-5.5-3.4-8.3-5.1c-41-24.2-88.9-38-139.9-38C9 192 0 201 0 212.1c0 96.7 51.2 181.4 128 228.5c40.7 25 88.6 39.4 139.9 39.4h40.2c51.8 0 100.2-14.7 141.2-40.2C525.4 392.5 576 308.2 576 212.1c0-11.1-9-20.1-20.1-20.1c-51 0-98.8 13.9-139.9 38c-63 37.1-110 98.5-128 171.3c-15.8-63.8-53.8-118.8-105.3-156.4zm7.7-33.6C215.9 118.6 268.2 64.5 284.9 49c.5-.5 1.4-1 3.1-1s2.6 .5 3.1 1l10.5-11.3L291.1 49c16.8 15.5 69 69.6 94.6 162.3c4.6-3.1 9.3-6 14.1-8.8c-27-93.7-80.1-148.8-97.8-165.2c-3.8-3.5-8.8-5.2-13.9-5.2s-10.1 1.7-13.9 5.2c-17.8 16.4-70.8 71.5-97.8 165.2c4.8 2.8 9.5 5.8 14.1 8.8zM267.9 464c-38.6 0-75.2-8.7-107.9-24.2C74.9 399.4 16 312.6 16 212.1c0-2.2 1.8-4.1 4.1-4.1c56.1 0 108 17.8 150.5 48C235.9 302.4 278.9 378.2 280 464H267.9zm40.2 0H296c1.1-85.8 44-161.6 109.3-208c42.5-30.2 94.5-48 150.5-48c2.3 0 4.1 1.9 4.1 4.1c0 100.5-58.9 187.3-144 227.7C383.3 455.3 346.7 464 308.1 464z'
      
    ]
  };

  

  
  

  var faScroll = {
    prefix: 'fat',
    iconName: 'scroll',
    icon: [
      576,
      512,
      [128220],
      'f70e',
      
      'M16 104c0-30.9 25.1-56 56-56s56 25.1 56 56V400c0 44.2 35.8 80 80 80H496c44.2 0 80-35.8 80-80V368c0-17.7-14.4-32-32-32h-.6-.6-.6-.6-.5-.6-.5-.5H539h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H532h-.5H531h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H521h-.5H520h-.5H519h-.5H518h-.5H517h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H507h-.5H506h-.5H505h-.5H504h-.5H503h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H493h-.5H492h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H485h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H479h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H474h-.5-.5-.5-.5-.4-.5-.4-.4H470h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H462h-.4-.4-.4-.4-.4-.4-.4-.4H458h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H451h-.4-.4-.4-.4-.4-.4H448h-.4-.4-.4-.4-.4-.4H445h-.4-.4-.4-.4-.4-.4H442h-.4-.4-.4-.4-.4-.4H439h-.4-.4-.4-.4-.4-.4H436h-.4-.4-.4-.4-.4-.4H433h-.4-.4-.4-.4-.4-.4H430h-.4-.4-.4-.4-.4-.4H427h-.4-.4-.4-.4-.4-.4H424h-.4-.4-.4-.4-.4-.4H421h-.4-.4-.4-.4-.4-.4H418h-.4-.4-.4-.4-.4-.4H415h-.4-.4-.4-.4-.4-.4H412h-.4-.4-.4-.4-.4-.4H409h-.4-.4-.4-.4-.4-.4H406h-.4-.4-.4-.4-.4-.4H403h-.4-.4-.4-.4-.4-.4H400h-.4-.4-.4-.4-.4-.4H397h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H390h-.4-.4-.4-.4-.4-.4-.4-.4H386h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H378h-.4-.4-.4-.5-.4-.5-.5-.5H374h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H369h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H363h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H356h-.5H355h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H345h-.5H344h-.5H343h-.5H342h-.5H341h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H331h-.5H330h-.5H329h-.5H328h-.5H327h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H317h-.5H316h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H309h-.5-.5-.5-.5-.5-.5-.6-.6H304c-17.7 0-32 14.3-32 32v32c0 35.3-28.7 64-64 64s-64-28.7-64-64V104c0-22.6-10.4-42.8-26.7-56H408c30.9 0 56 25.1 56 56V304h16V104c0-39.8-32.2-72-72-72H72C32.2 32 0 64.2 0 104v72c0 17.7 14.3 32 32 32H96V192H32c-8.8 0-16-7.2-16-16V104zM496 464H256c19.4-14.6 32-37.8 32-64V368c0-8.8 7.2-16 16-16h.6 .6 .6 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .4 .5 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .5 .4 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .6 .5 .6 .6 .6 .6c8.9 0 16 7.2 16 16v32c0 35.3-28.7 64-64 64z'
      
    ]
  };

  

  
  

  var faSquareF = {
    prefix: 'fat',
    iconName: 'square-f',
    icon: [
      448,
      512,
      [],
      'e270',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm152 32H312c4.4 0 8 3.6 8 8s-3.6 8-8 8H152c-4.4 0-8 3.6-8 8v88H280c4.4 0 8 3.6 8 8s-3.6 8-8 8H144V376c0 4.4-3.6 8-8 8s-8-3.6-8-8V248 152c0-13.3 10.7-24 24-24z'
      
    ]
  };

  

  
  

  var faBoxOpen = {
    prefix: 'fat',
    iconName: 'box-open',
    icon: [
      640,
      512,
      [],
      'f49e',
      
      'M61.4 54.6l-33.2 83c-3.6 9 1.5 19 10.8 21.4l167.7 43.5c9.9 2.6 20.2-1.4 25.9-9.8L306.2 83.4 70 49.7c-3.7-.5-7.2 1.5-8.6 4.9zM72.2 33.9L320 69.3 567.8 33.9c11-1.6 21.6 4.6 25.7 14.8l33.2 83c7.2 17.9-3 38-21.7 42.9L437.3 218.1c-16.4 4.3-33.7-2.3-43.2-16.4l-74-110-74 110c-9.5 14.1-26.8 20.6-43.2 16.4L35 174.6c-18.7-4.8-28.8-25-21.7-42.9l33.2-83c4.1-10.3 14.7-16.4 25.7-14.8zM560 216.1l16-4.6v167c0 22-15 41.2-36.4 46.6l-208 52c-7.6 1.9-15.6 1.9-23.3 0l-208-52C79 419.7 64 400.5 64 378.5v-167l16 4.6V378.5c0 14.7 10 27.5 24.2 31L312 461.5V200c0-4.4 3.6-8 8-8s8 3.6 8 8V461.5l207.8-51.9c14.2-3.6 24.2-16.4 24.2-31V216.1zM570 49.7L333.8 83.4l73.6 109.3c5.7 8.4 16.1 12.4 25.9 9.8l167.7-43.5c9.3-2.4 14.4-12.5 10.8-21.4l-33.2-83c-1.4-3.4-4.9-5.5-8.6-4.9z'
      
    ]
  };

  

  
  

  var faKerning = {
    prefix: 'fat',
    iconName: 'kerning',
    icon: [
      640,
      512,
      [],
      'f86f',
      
      'M447.2 11.5c1.9-4 .3-8.8-3.7-10.7s-8.8-.3-10.7 3.7l-240 496c-1.9 4-.3 8.8 3.7 10.7s8.8 .3 10.7-3.7l240-496zm-432 88.9c-2-4-6.8-5.6-10.7-3.6s-5.6 6.8-3.6 10.7l152 304c1.4 2.7 4.1 4.4 7.2 4.4s5.8-1.7 7.2-4.4l152-304c2-4 .4-8.8-3.6-10.7s-8.8-.4-10.7 3.6L160 390.1 15.2 100.4zm320 311.2L372.9 336H587.1l37.8 75.6c2 4 6.8 5.6 10.7 3.6s5.6-6.8 3.6-10.7l-152-304C485.8 97.7 483 96 480 96s-5.8 1.7-7.2 4.4l-152 304c-2 4-.4 8.8 3.6 10.7s8.8 .4 10.7-3.6zM480 121.9L579.1 320H380.9L480 121.9z'
      
    ]
  };

  

  
  

  var faLightEmergencyOn = {
    prefix: 'fat',
    iconName: 'light-emergency-on',
    icon: [
      640,
      512,
      [],
      'e420',
      
      'M44.1 33.1c-3.8-2.3-8.7-1-11 2.7s-1 8.7 2.7 11l80 48c3.8 2.3 8.7 1 11-2.7s1-8.7-2.7-11l-80-48zm560 13.7c3.8-2.3 5-7.2 2.7-11s-7.2-5-11-2.7l-80 48c-3.8 2.3-5 7.2-2.7 11s7.2 5 11 2.7l80-48zM8 192c-4.4 0-8 3.6-8 8s3.6 8 8 8H88c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zm544 0c-4.4 0-8 3.6-8 8s3.6 8 8 8h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H552zm-88 0V320h16V192c0-88.4-71.6-160-160-160s-160 71.6-160 160V320h16V192c0-79.5 64.5-144 144-144s144 64.5 144 144zM112 400c0-17.7 14.3-32 32-32H496c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32V400zm-16 0v32c0 26.5 21.5 48 48 48H496c26.5 0 48-21.5 48-48V400c0-26.5-21.5-48-48-48H144c-26.5 0-48 21.5-48 48zM312 112.4c4.4-.4 8-4 8-8.4s-3.6-8-8-7.7c-46.6 3.8-83.8 41-87.7 87.7c-.4 4.4 3.3 8 7.7 8s8-3.6 8.4-8c3.7-37.8 33.8-67.9 71.6-71.6z'
      
    ]
  };

  

  
  

  var faSquareArrowUpRight = {
    prefix: 'fat',
    iconName: 'square-arrow-up-right',
    icon: [
      448,
      512,
      ["external-link-square"],
      'f14c',
      
      'M384 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H384zm64 48c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM168 160c-4.4 0-8 3.6-8 8s3.6 8 8 8H292.7L130.3 338.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L304 187.3V312c0 4.4 3.6 8 8 8s8-3.6 8-8V168c0-4.4-3.6-8-8-8H168z'
      
    ]
  };

  
    var faExternalLinkSquare = faSquareArrowUpRight;
  

  
  

  var faBanjo = {
    prefix: 'fat',
    iconName: 'banjo',
    icon: [
      512,
      512,
      [129685],
      'f8a3',
      
      'M448 16c-3 0-5.9 1.2-8 3.3L393.1 66.2c-1.1 1.1-1.9 2.5-2.2 4.1l-12.7 63.5 63.5-12.7c1.5-.3 3-1.1 4.1-2.2L492.7 72c2.1-2.1 3.3-5 3.3-8s-1.2-5.9-3.3-8L456 19.3c-2.1-2.1-5-3.3-8-3.3zM360.6 140.1l14.6-72.9c.9-4.6 3.2-8.9 6.6-12.3L428.7 8c5.1-5.1 12.1-8 19.3-8s14.2 2.9 19.3 8L504 44.7c5.1 5.1 8 12.1 8 19.3s-2.9 14.2-8 19.3l-46.9 46.9c-3.4 3.4-7.6 5.6-12.3 6.6l-72.9 14.6-77.3 77.3c24 26.5 39.3 61.2 41.2 99.3H344c4.4 0 8 3.6 8 8s-3.6 8-8 8h-8.2c-1.9 38.2-17.1 72.8-41.2 99.3l5.8 5.8c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-5.8-5.8c-26.5 24-61.2 39.3-99.3 41.2V504c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8.2c-38.2-1.9-72.8-17.1-99.3-41.2l-5.8 5.8c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l5.8-5.8c-24-26.5-39.3-61.2-41.2-99.3H8c-4.4 0-8-3.6-8-8s3.6-8 8-8h8.2c1.9-38.2 17.1-72.8 41.2-99.3l-5.8-5.8c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l5.8 5.8c26.5-24 61.2-39.3 99.3-41.2V168c0-4.4 3.6-8 8-8s8 3.6 8 8v8.2c38.2 1.9 72.8 17.1 99.3 41.2l77.3-77.3zM72.4 235.5C47.7 261 32.3 295.6 31.7 333.8c.2 .7 .3 1.4 .3 2.2s-.1 1.5-.3 2.2c.6 38.2 16 72.8 40.7 98.3c.6 .4 1.2 .8 1.8 1.3s1 1.1 1.3 1.8c25.5 24.7 60.1 40.1 98.3 40.7c.7-.2 1.4-.3 2.2-.3s1.5 .1 2.2 .3c38.2-.6 72.8-16 98.3-40.7c.4-.6 .8-1.2 1.3-1.8s1.1-1 1.8-1.3c24.7-25.5 40.1-60.1 40.7-98.3c-.2-.7-.3-1.4-.3-2.2s.1-1.5 .3-2.2c-1.2-78-64.1-141-142.1-142.1c-.7 .2-1.4 .3-2.2 .3s-1.5-.1-2.2-.3c-38.2 .6-72.8 16-98.3 40.7c-.4 .6-.8 1.2-1.3 1.8s-1.1 1-1.8 1.3zm45.2 94.8l64 64c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-64-64c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0z'
      
    ]
  };

  

  
  

  var faFileImport = {
    prefix: 'fat',
    iconName: 'file-import',
    icon: [
      512,
      512,
      ["arrow-right-to-file"],
      'f56f',
      
      'M448 496H192c-26.5 0-48-21.5-48-48V352H128v96c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-35.3 0-64 28.7-64 64V256h16V64c0-26.5 21.5-48 48-48H332.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H495.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48zm41.1-336H376c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L486.6 157.3c.9 .9 1.7 1.8 2.4 2.7zM269.7 186.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L356.7 296H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H356.7l-98.3 98.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l112-112c3.1-3.1 3.1-8.2 0-11.3l-112-112z'
      
    ]
  };

  
    var faArrowRightToFile = faFileImport;
  

  
  

  var faCommentPen = {
    prefix: 'fat',
    iconName: 'comment-pen',
    icon: [
      512,
      512,
      ["comment-edit"],
      'f4ae',
      
      'M157.3 415c-5-1.8-10.6-1-14.9 2.1c-11 8-29.4 19.3-51.2 28.8C68.3 456 41.6 464 16 464l.1-.1 0 0 0 0 .3-.3 .1-.1c.4-.4 .9-.9 1.5-1.6c1.3-1.4 3.2-3.6 5.4-6.3l-12.2-10 12.2 10C28 450 34 442 40 432c10.7-17.9 21.4-42.1 23.6-69.9c.3-4.3-1.1-8.6-3.9-11.8C31.9 318.8 16 280.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-35.2 0-68.6-6.1-98.7-17zM4.7 452.7l0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0zM164.6 331.4c4 4 9.7 5.6 15.2 4.2l36.7-9.2c5.6-1.4 10.8-4.3 14.9-8.4L341 208.4c14.7-14.7 14.7-38.6 0-53.4s-38.6-14.7-53.4 0L178 264.6c-4.1 4.1-7 9.2-8.4 14.9l-9.2 36.7c-1.4 5.5 .2 11.2 4.2 15.2zm15.7-28.9l4.8-19.1c.7-2.8 2.2-5.4 4.2-7.4L275 190.3 305.7 221 220 306.7c-2.1 2.1-4.6 3.5-7.4 4.2l-19.1 4.8-17.6 4.4 4.4-17.6zM329.7 197.1L317 209.7 286.3 179l12.6-12.6c8.5-8.5 22.3-8.5 30.7 0s8.5 22.3 0 30.7z'
      
    ]
  };

  
    var faCommentEdit = faCommentPen;
  

  
  

  var faCircleArrowDown = {
    prefix: 'fat',
    iconName: 'circle-arrow-down',
    icon: [
      512,
      512,
      ["arrow-circle-down"],
      'f0ab',
      
      'M256 16a240 240 0 1 0 0 480 240 240 0 1 0 0-480zm0 496A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM365.7 277.7l-104 104c-3.1 3.1-8.2 3.1-11.3 0l-104-104c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L248 356.7V136c0-4.4 3.6-8 8-8s8 3.6 8 8V356.7l90.3-90.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3z'
      
    ]
  };

  
    var faArrowCircleDown = faCircleArrowDown;
  

  
  

  var faCameraRetro = {
    prefix: 'fat',
    iconName: 'camera-retro',
    icon: [
      512,
      512,
      [128247],
      'f083',
      
      'M192 96H64c-26.5 0-48 21.5-48 48v88H146c18.5-42.4 60.8-72 110-72s91.5 29.6 110 72H496V96c0-26.5-21.5-48-48-48H277.3c-10.4 0-20.5 3.4-28.8 9.6L201.6 92.8c-2.8 2.1-6.1 3.2-9.6 3.2zM16 248V416c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V248H371.7c2.8 10.2 4.3 20.9 4.3 32c0 66.3-53.7 120-120 120s-120-53.7-120-120c0-11.1 1.5-21.8 4.3-32H16zM0 416V144c0-35.3 28.7-64 64-64H192l46.9-35.2C250 36.5 263.5 32 277.3 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zM360 280a104 104 0 1 0 -208 0 104 104 0 1 0 208 0zM64 40c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H72c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faFilterCircleDollar = {
    prefix: 'fat',
    iconName: 'filter-circle-dollar',
    icon: [
      576,
      512,
      ["funnel-dollar"],
      'f662',
      
      'M0 37.6C0 16.8 16.8 0 37.6 0H474.4C495.2 0 512 16.8 512 37.6c0 8.5-2.9 16.8-8.2 23.5L396.1 195.7c-9.2 1.9-18.1 4.5-26.7 7.8L491.3 51.1c3.1-3.8 4.7-8.6 4.7-13.5c0-11.9-9.7-21.6-21.6-21.6H37.6C25.7 16 16 25.7 16 37.6c0 4.9 1.7 9.7 4.7 13.5L206.2 283c1.1 1.4 1.8 3.2 1.8 5v71.7c0 7.7 3.7 14.9 9.9 19.4l43.3 31.5c2.2 9 5.2 17.7 8.7 26.1l-61.5-44.7c-10.3-7.5-16.5-19.6-16.5-32.3V290.8L8.2 61.1C2.9 54.4 0 46.2 0 37.6zM432 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm-28.2 93.9c-8 4.1-12.3 9.7-11.7 17.6c.4 5.2 3.6 9.5 11.5 13.5c7.9 4 18.3 6.8 30 10l1 .3c11.5 3.1 24.3 6.6 34.1 12.1c10.2 5.7 18.8 14.5 19.2 28.4c.5 16.4-8.9 27-20.4 33c-8.5 4.4-18.5 6.5-27.6 7.1v17.7c0 4.4-3.6 8-8 8s-8-3.6-8-8V439.4c-12.6-1.4-24.7-5.1-35.9-8.5l0 0c-2.1-.7-4.3-1.3-6.3-1.9c-4.2-1.3-6.7-5.7-5.4-9.9s5.7-6.7 9.9-5.4c2.3 .7 4.5 1.3 6.7 2l0 0 0 0c13.6 4.1 26.1 7.9 39.2 8.3c9.4 .3 20.1-1.4 28-5.5c7.6-3.9 12-9.6 11.7-18.3c-.2-6.2-3.6-10.7-11.1-14.9c-7.8-4.4-18.5-7.4-30.5-10.6l-1.8-.5c-11-2.9-22.9-6.1-32.3-11c-10.1-5.2-19.3-13.3-20.2-26.7c-1.1-16.5 8.9-27.1 20.4-32.9c8.5-4.3 18.5-6.5 27.4-7.3V280c0-4.4 3.6-8 8-8s8 3.6 8 8v16.4c10.2 .8 20.4 2.8 29.8 5c4.3 1 7 5.3 5.9 9.6s-5.3 7-9.6 5.9c-11.4-2.7-23.1-4.8-34.3-5c-8.8-.1-19.8 1.6-28.1 5.8z'
      
    ]
  };

  
    var faFunnelDollar = faFilterCircleDollar;
  

  
  

  var faBinaryLock = {
    prefix: 'fat',
    iconName: 'binary-lock',
    icon: [
      640,
      512,
      [],
      'e33d',
      
      'M308.6 1.4c-2.2-1.5-4.9-1.8-7.4-.9l-64 24c-4.1 1.6-6.2 6.2-4.7 10.3s6.2 6.2 10.3 4.7L296 19.5V208H232c-4.4 0-8 3.6-8 8s3.6 8 8 8h72 72c4.4 0 8-3.6 8-8s-3.6-8-8-8H312V8c0-2.6-1.3-5.1-3.4-6.6zm-224 288c-2.2-1.5-4.9-1.8-7.4-.9l-64 24c-4.1 1.6-6.2 6.2-4.7 10.3s6.2 6.2 10.3 4.7L72 307.5V496H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H80h72c4.4 0 8-3.6 8-8s-3.6-8-8-8H88V296c0-2.6-1.3-5.1-3.4-6.6zM80 0C44.7 0 16 28.7 16 64v96c0 35.3 28.7 64 64 64h32c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H80zM32 64c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V64zM208 352v96c0 35.3 28.7 64 64 64h32c35.3 0 64-28.7 64-64V352c0-35.3-28.7-64-64-64H272c-35.3 0-64 28.7-64 64zm64-48h32c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V352c0-26.5 21.5-48 48-48zm256-96c26.5 0 48 21.5 48 48v64H480V256c0-26.5 21.5-48 48-48zm-64 48v64H448c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H592V256c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-16 80h16 16 96 16 16c8.8 0 16 7.2 16 16V480c0 8.8-7.2 16-16 16H448c-8.8 0-16-7.2-16-16V352c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faStarShooting = {
    prefix: 'fat',
    iconName: 'star-shooting',
    icon: [
      512,
      512,
      [127776],
      'e036',
      
      'M317.7 13.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-80 80c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l80-80zm192 0c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-176 176c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l176-176zm0 192c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-80 80c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l80-80zM126.4 267.2c5.2-.8 9.7-4 12-8.8l46.3-94c2.9-6 11.4-6 14.4 0l46.3 94c2.3 4.7 6.8 8 12 8.8L361 282.3c6.6 1 9.2 9 4.4 13.6l-74.9 73.2c-3.8 3.7-5.5 9-4.6 14.1l17.7 103.3c1.1 6.5-5.7 11.5-11.6 8.4l-92.6-48.8c-4.7-2.5-10.2-2.5-14.9 0L91.9 495c-5.9 3.1-12.7-1.9-11.6-8.4L98 383.3c.9-5.2-.8-10.5-4.6-14.1L18.4 295.9c-4.7-4.6-2.1-12.7 4.4-13.6l103.5-15.1zm-105.8-.8C.9 269.3-7 293.5 7.2 307.4l74.9 73.2L64.5 483.9c-3.4 19.6 17.2 34.6 34.8 25.3l92.6-48.8 92.6 48.8c17.6 9.3 38.2-5.7 34.8-25.3L301.6 380.6l74.9-73.2c14.2-13.9 6.4-38.1-13.3-40.9L259.7 251.4l-46.3-94c-8.8-17.9-34.3-17.9-43.1 0l-46.3 94L20.5 266.5z'
      
    ]
  };

  

  
  

  var faPersonSkating = {
    prefix: 'fat',
    iconName: 'person-skating',
    icon: [
      448,
      512,
      ["skating"],
      'f7c5',
      
      'M249.9 154.6c-2.3-6.3-8.3-10.6-15-10.6H160c-8.8 0-16-7.2-16-16s7.2-16 16-16H319.4c29 0 43.1 35.6 21.8 55.4l-74.4 69.4c-3.2 3-5 7.1-5.1 11.4s1.6 8.5 4.7 11.6L326.6 320c6 6 9.4 14.1 9.4 22.6V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V349.3c0-4.2-1.7-8.3-4.7-11.3l-77.9-77.9c-20-20-18.5-52.7 3.2-70.8l20.4-17c5.2-4.3 7.1-11.4 4.8-17.7zM400 16a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM209.8 160h25l-19.2 16-1.2 1c-28.9 24.1-30.9 67.8-4.3 94.4L288 349.3V432c0 17.7 14.3 32 32 32s32-14.3 32-32V342.6c0-12.7-5.1-24.9-14.1-33.9l-48.8-48.8-11.3-11.3 11.7-10.9 62.7-58.5C384 149.4 363 96 319.4 96H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h49.8zM448 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM148.4 468.3c3.6-2.6 4.4-7.6 1.9-11.2s-7.6-4.4-11.2-1.9l-12 8.6c-12.7 9.1-30.2 7.6-41.2-3.4L13.7 388.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l72.2 72.2c16.6 16.6 42.7 18.8 61.8 5.1l12-8.6zm267.5-11c.7-4.4-2.2-8.5-6.6-9.2s-8.5 2.2-9.2 6.6l-2.4 14.6c-2.6 15.4-15.9 26.7-31.6 26.7H264c-4.4 0-8 3.6-8 8s3.6 8 8 8H366.1c23.5 0 43.5-17 47.3-40.1l2.4-14.6zM73.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l90.7-90.7-11.3-11.3-90.7 90.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l91.8-91.8c-3.2-4.6-6-9.4-8.2-14.4L73.4 361.4z'
      
    ]
  };

  
    var faSkating = faPersonSkating;
  

  
  

  var faSuitcase = {
    prefix: 'fat',
    iconName: 'suitcase',
    icon: [
      512,
      512,
      [129523],
      'f0f2',
      
      'M144 40V96H368V40c0-13.3-10.7-24-24-24H168c-13.3 0-24 10.7-24 24zM128 96V40c0-22.1 17.9-40 40-40H344c22.1 0 40 17.9 40 40V96h64c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64zm248 16H136 104V464H408V112H376zM88 112H64c-26.5 0-48 21.5-48 48V416c0 26.5 21.5 48 48 48H88V112zM424 464h24c26.5 0 48-21.5 48-48V160c0-26.5-21.5-48-48-48H424V464z'
      
    ]
  };

  

  
  

  var faReplyAll = {
    prefix: 'fat',
    iconName: 'reply-all',
    icon: [
      576,
      512,
      ["mail-reply-all"],
      'f122',
      
      'M304 128c0 8.8 7.2 16 16 16h80c88.4 0 160 71.6 160 160c0 104.2-74.6 150.7-91.8 160c-.1 0-.2 0-.6 0c-2 0-3.7-1.6-3.7-3.7c0-1.4 1-4.4 4.7-7.8C480.8 441.1 496 419.5 496 384c0-61.9-50.1-112-112-112H320c-8.8 0-16 7.2-16 16v64c0 6.3-3.7 12-9.5 14.6s-12.5 1.5-17.2-2.7l-160-144c-3.4-3-5.3-7.4-5.3-11.9s1.9-8.9 5.3-11.9l160-144c4.7-4.2 11.4-5.3 17.2-2.7S304 57.7 304 64v64zm16 224V304 288h16 48c53 0 96 43 96 96c0 30.4-12.8 47.9-22.2 56.7c-5.5 5.1-9.8 12-9.8 19.5c0 10.9 8.8 19.7 19.7 19.7c2.8 0 5.6-.6 8.1-1.9C494.5 467.9 576 417.3 576 304c0-97.2-78.8-176-176-176H336 320V112 64c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144C99.9 190.3 96 198.9 96 208s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2zM197.4 53.9c3.3-3 3.5-8 .5-11.3s-8-3.5-11.3-.5L30.2 184.3c-14 12.7-14 34.7 0 47.4L186.6 373.9c3.3 3 8.3 2.7 11.3-.5s2.7-8.3-.5-11.3L40.9 219.8c-7-6.3-7-17.3 0-23.7L197.4 53.9z'
      
    ]
  };

  
    var faMailReplyAll = faReplyAll;
  

  
  

  var faCrystalBall = {
    prefix: 'fat',
    iconName: 'crystal-ball',
    icon: [
      448,
      512,
      [],
      'e362',
      
      'M432 224c0 55.9-22 106.6-57.9 144h21.5c32.7-38.9 52.4-89.2 52.4-144C448 100.3 347.7 0 224 0S0 100.3 0 224c0 54.8 19.7 105.1 52.4 144H73.9C38 330.6 16 279.9 16 224C16 109.1 109.1 16 224 16s208 93.1 208 208zM80 400c-2.7 0-5.2 1.3-6.7 3.6L28.4 470.9c-2.9 4.3-4.4 9.4-4.4 14.7C24 500.2 35.8 512 50.4 512H397.6c14.6 0 26.4-11.8 26.4-26.4c0-5.2-1.5-10.3-4.4-14.7l-44.9-67.4c-1.5-2.2-4-3.6-6.7-3.6H80zM41.8 479.8L84.3 416H363.7l42.5 63.8c1.1 1.7 1.8 3.7 1.8 5.8c0 5.8-4.7 10.4-10.4 10.4H50.4c-5.8 0-10.4-4.7-10.4-10.4c0-2.1 .6-4.1 1.8-5.8zM288 152c-4.4 0-8 3.6-8 8v56H224c-4.4 0-8 3.6-8 8s3.6 8 8 8h56v56c0 4.4 3.6 8 8 8s8-3.6 8-8V232h56c4.4 0 8-3.6 8-8s-3.6-8-8-8H296V160c0-4.4-3.6-8-8-8zM144 104c-4.4 0-8 3.6-8 8v24H112c-4.4 0-8 3.6-8 8s3.6 8 8 8h24v24c0 4.4 3.6 8 8 8s8-3.6 8-8V152h24c4.4 0 8-3.6 8-8s-3.6-8-8-8H152V112c0-4.4-3.6-8-8-8z'
      
    ]
  };

  

  
  

  var faCertificate = {
    prefix: 'fat',
    iconName: 'certificate',
    icon: [
      512,
      512,
      [],
      'f0a3',
      
      'M162.7 94.5c3.7-2.2 6.4-5.7 7.5-9.9L186.1 22c.7-2.8 2.9-5 5.7-5.8s5.8 .1 7.8 2.1l45 46.2c3 3.1 7.1 4.8 11.5 4.8s8.5-1.7 11.5-4.8l45-46.2c2-2.1 5-2.9 7.8-2.1s5 3 5.7 5.8l15.8 62.5c1.1 4.2 3.8 7.8 7.5 9.9s8.2 2.7 12.3 1.5l62-17.5c2.8-.8 5.8 0 7.8 2s2.8 5 2 7.8l-17.5 62c-1.2 4.2-.6 8.6 1.5 12.3s5.7 6.4 9.9 7.5L490 186.1c2.8 .7 5 2.9 5.8 5.7s-.1 5.8-2.1 7.8l-46.2 45c-3.1 3-4.8 7.1-4.8 11.5s1.7 8.5 4.8 11.5l46.2 45c2.1 2 2.9 5 2.1 7.8s-3 5-5.8 5.7l-62.5 15.8c-4.2 1.1-7.8 3.8-9.9 7.5s-2.7 8.2-1.5 12.3l17.5 62c.8 2.8 0 5.8-2 7.8s-5 2.8-7.8 2l-62-17.5c-4.2-1.2-8.6-.6-12.3 1.5s-6.4 5.7-7.5 9.9L325.9 490c-.7 2.8-2.9 5-5.7 5.8s-5.8-.1-7.8-2.1l-45-46.2c-3-3.1-7.1-4.8-11.5-4.8s-8.5 1.7-11.5 4.8l-45 46.2c-2 2.1-5 2.9-7.8 2.1s-5-3-5.7-5.8l-15.8-62.5c-1.1-4.2-3.8-7.8-7.5-9.9s-8.2-2.7-12.3-1.5l-62 17.5c-2.8 .8-5.8 0-7.8-2s-2.8-5-2-7.8l17.5-62c1.2-4.2 .6-8.6-1.5-12.3s-5.7-6.4-9.9-7.5L22 325.9c-2.8-.7-5-2.9-5.8-5.7s.1-5.8 2.1-7.8l46.2-45c3.1-3 4.8-7.1 4.8-11.5s-1.7-8.5-4.8-11.5l-46.2-45c-2.1-2-2.9-5-2.1-7.8s3-5 5.8-5.7l62.5-15.8c4.2-1.1 7.8-3.8 9.9-7.5s2.7-8.2 1.5-12.3l-17.5-62c-.8-2.8 0-5.8 2-7.8s5-2.8 7.8-2l62 17.5c4.2 1.2 8.6 .6 12.4-1.5zM244.8 42L211 7.3C205 1 196-1.4 187.6 .8s-14.9 8.9-17.1 17.3l-11.9 47-3.9 15.5-15.4-4.4L92.7 63.1c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l13.2 46.6 4.4 15.4-15.5 3.9-47 11.9c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211L42 244.8 53.5 256 42 267.2 7.3 301C1 307-1.4 316 .8 324.4s8.9 14.9 17.3 17.1l47 11.9 15.5 3.9-4.4 15.4L63.1 419.3c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l46.6-13.2 15.4-4.4 3.9 15.5 11.9 47c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4L244.8 470 256 458.5 267.2 470 301 504.7c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l11.9-47 3.9-15.5 15.4 4.4 46.6 13.2c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-13.2-46.6-4.4-15.4 15.5-3.9 47-11.9c8.4-2.1 15-8.7 17.3-17.1s-.2-17.4-6.4-23.4L470 267.2 458.5 256 470 244.8 504.7 211c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-47-11.9-15.5-3.9 4.4-15.4 13.2-46.6c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1L372.7 76.2l-15.4 4.4-3.9-15.5-11.9-47c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3L267.2 42 256 53.5 244.8 42z'
      
    ]
  };

  

  
  

  var faTentArrowDownToLine = {
    prefix: 'fat',
    iconName: 'tent-arrow-down-to-line',
    icon: [
      640,
      512,
      [],
      'e57e',
      
      'M245.9 122.6c-3-3.3-8-3.5-11.3-.5L152 197.8 152 8c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 189.8L53.4 122.1c-3.3-3-8.3-2.8-11.3 .5s-2.8 8.3 .5 11.3l96 88c3.1 2.8 7.8 2.8 10.8 0l96-88c3.3-3 3.5-8 .5-11.3zM0 504c0 4.4 3.6 8 8 8H632c4.4 0 8-3.6 8-8s-3.6-8-8-8H8c-4.4 0-8 3.6-8 8zM388.6 129.5c-2.8-2-6.5-2-9.2 0L198.8 257.4c-9.1 6.4-15.1 16.4-16.5 27.5L160.1 455c-.6 4.4 2.5 8.4 6.9 9s8.4-2.5 9-6.9l22.2-170.1c.9-6.6 4.5-12.6 9.9-16.5l168-119V287.9c0 .1 0 .2 0 .3V456c0 4.4 3.6 8 8 8s8-3.6 8-8V316.1l89.2 144.1c2.3 3.8 7.3 4.9 11 2.6s4.9-7.3 2.6-11L392 285.7V151.5l168 119c5.5 3.9 9.1 9.8 9.9 16.5L592.1 457c.6 4.4 4.6 7.5 9 6.9s7.5-4.6 6.9-9L585.7 284.8c-1.4-11.1-7.4-21-16.5-27.5L388.6 129.5z'
      
    ]
  };

  

  
  

  var faArrowDownLong = {
    prefix: 'fat',
    iconName: 'arrow-down-long',
    icon: [
      384,
      512,
      ["long-arrow-down"],
      'f175',
      
      'M186.3 509.7c3.1 3.1 8.2 3.1 11.3 0l152-152c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L200 484.7 200 8c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 476.7L45.7 346.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l152 152z'
      
    ]
  };

  
    var faLongArrowDown = faArrowDownLong;
  

  
  

  var faUpToBracket = {
    prefix: 'fat',
    iconName: 'up-to-bracket',
    icon: [
      448,
      512,
      [],
      'e66e',
      
      'M216 179.3c2.1-2.1 5-3.3 8-3.3s5.9 1.2 8 3.3L363.8 311.4c2.7 2.7 4.2 6.4 4.2 10.2c0 8-6.5 14.4-14.4 14.4L280 336c-4.4 0-8 3.6-8 8l0 136c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-136c0-4.4-3.6-8-8-8l-73.6 0c-8 0-14.4-6.5-14.4-14.4c0-3.8 1.5-7.5 4.2-10.2L216 179.3zm8-19.3c-7.2 0-14.2 2.9-19.3 8L72.9 300.1c-5.7 5.7-8.9 13.4-8.9 21.5C64 338.4 77.6 352 94.4 352l65.6 0 0 128c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-128 65.6 0c16.8 0 30.4-13.6 30.4-30.4c0-8.1-3.2-15.8-8.9-21.5L243.3 168c-5.1-5.1-12.1-8-19.3-8zM16 184l0-96c0-39.8 32.2-72 72-72l272 0c39.8 0 72 32.2 72 72l0 96c0 4.4 3.6 8 8 8s8-3.6 8-8l0-96c0-48.6-39.4-88-88-88L88 0C39.4 0 0 39.4 0 88l0 96c0 4.4 3.6 8 8 8s8-3.6 8-8z'
      
    ]
  };

  

  
  

  var faUserTie = {
    prefix: 'fat',
    iconName: 'user-tie',
    icon: [
      448,
      512,
      [],
      'f508',
      
      'M224 240a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM352 128A128 128 0 1 1 96 128a128 128 0 1 1 256 0zM176.9 308.3c1.4-2.7 4.1-4.3 7.1-4.3h80c3 0 5.7 1.7 7.1 4.3s1.1 5.9-.6 8.3l-37.2 52.1 23.2 46.3 47.1-94.2c81.2 8.4 144.4 77 144.4 160.4c0 17-13.8 30.7-30.7 30.7H225.9h-3.8H30.7C13.8 512 0 498.2 0 481.3c0-83.4 63.3-152 144.4-160.4l47.1 94.2 23.2-46.3-37.2-52.1c-1.7-2.4-2-5.6-.6-8.3zM199.5 320L224 354.2 248.5 320H199.5zm10.1 167.2L135.3 338.3C67.5 350.6 16 409.9 16 481.3c0 8.1 6.6 14.7 14.7 14.7H214.1l-4.4-8.8zm-9.2-54.2l14.6 29.2L224 480l8.9-17.9 14.6-29.2L224 385.9l-23.5 47.1zM432 481.3c0-71.4-51.5-130.7-119.3-143L238.3 487.2l-4.4 8.8H417.3c8.1 0 14.7-6.6 14.7-14.7z'
      
    ]
  };

  

  
  

  var faSquarePersonConfined = {
    prefix: 'fat',
    iconName: 'square-person-confined',
    icon: [
      448,
      512,
      [],
      'e577',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM228.7 318.1l-41.4-41.4c-3.6-3.6-8.8-5.3-13.9-4.5s-9.4 4-11.7 8.6l-48 96c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l28.1-56.3c2.3-4.6 6.7-7.8 11.7-8.6s10.2 .8 13.9 4.5l54.7 54.7c9.4 9.4 22.1 14.6 35.3 14.6c27.6 0 49.9-22.4 49.9-49.9V248c0-22.1-17.9-40-40-40s-40 17.9-40 40v58.7c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5zM240 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-.6 252.7l-42.7-42.7L184.8 342l-7.5 15.1-20.6 41.2c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l48-96c4.6-9.2 13.3-15.6 23.5-17.3s20.5 1.7 27.8 9L224 290.7l16 16V284.1 248c0-30.9 25.1-56 56-56s56 25.1 56 56V350.1c0 36.4-29.5 65.9-65.9 65.9c-17.5 0-34.3-6.9-46.6-19.3zM208 96a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  

  
  

  var faViruses = {
    prefix: 'fat',
    iconName: 'viruses',
    icon: [
      640,
      512,
      [],
      'e076',
      
      'M200 24c0-4.4-3.6-8-8-8s-8 3.6-8 8V37.5c0 49.9-60.3 74.9-95.6 39.6l-9.5-9.5c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l9.5 9.5C112.4 123.7 87.4 184 37.5 184H24c-4.4 0-8 3.6-8 8s3.6 8 8 8H37.5c49.9 0 74.9 60.3 39.6 95.6l-9.5 9.5c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l9.5-9.5c35.3-35.3 95.6-10.3 95.6 39.6V360c0 4.4 3.6 8 8 8s8-3.6 8-8V346.5c0-49.9 60.3-74.9 95.6-39.6l9.5 9.5c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-9.5-9.5c-35.3-35.3-10.3-95.6 39.6-95.6H360c4.4 0 8-3.6 8-8s-3.6-8-8-8H346.5c-49.9 0-74.9-60.3-39.6-95.6l9.5-9.5c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-9.5 9.5C260.3 112.4 200 87.4 200 37.5V24zM192 0c13.3 0 24 10.7 24 24V37.5c0 35.6 43.1 53.5 68.3 28.3l9.5-9.5c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-9.5 9.5C293 124.9 310.9 168 346.5 168H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H346.5c-35.6 0-53.5 43.1-28.3 68.3l9.5 9.5c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-9.5-9.5C259.1 293 216 310.9 216 346.5V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V346.5c0-35.6-43.1-53.5-68.3-28.3l-9.5 9.5c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l9.5-9.5C91 259.1 73.1 216 37.5 216H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H37.5c35.6 0 53.5-43.1 28.3-68.3l-9.5-9.5c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l9.5 9.5C124.9 91 168 73.1 168 37.5V24c0-13.3 10.7-24 24-24zM480 368a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM240 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-80-56a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm40 24a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zM575.2 266.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C574.5 312.1 591 352 624 352c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C551.9 446.5 512 463 512 496c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C417.5 423.9 401 384 368 384c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C440.1 289.5 480 273 480 240c0-8.8 7.2-16 16-16s16 7.2 16 16c0 33 39.9 49.5 63.2 26.2zM405.5 277.5c33.4 33.4 9.7 90.5-37.5 90.5c47.2 0 70.9 57.1 37.5 90.5c33.4-33.4 90.5-9.7 90.5 37.5c0-47.2 57.1-70.9 90.5-37.5C553.1 425.1 576.8 368 624 368c-47.2 0-70.9-57.1-37.5-90.5c-17.6 17.6-41.9 19.4-60.8 10.1c-17-8.3-29.7-25.3-29.7-47.6c0 47.2-57.1 70.9-90.5 37.5z'
      
    ]
  };

  

  
  

  var faBatteryExclamation = {
    prefix: 'fat',
    iconName: 'battery-exclamation',
    icon: [
      576,
      512,
      [],
      'e0b0',
      
      'M448 112c35.3 0 64 28.7 64 64v16 16 96 16 16c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V176c0-35.3 28.7-64 64-64H448zm80 224V320h16c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H528V176c0-44.2-35.8-80-80-80H80C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H448c44.2 0 80-35.8 80-80zm0-32V208h16c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H528zM272 144c-4.4 0-8 3.6-8 8V296c0 4.4 3.6 8 8 8s8-3.6 8-8V152c0-4.4-3.6-8-8-8zm16 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faSterlingSign = {
    prefix: 'fat',
    iconName: 'sterling-sign',
    icon: [
      320,
      512,
      [163,"gbp","pound-sign"],
      'f154',
      
      'M80 143.2C80 90.6 122.6 48 175.2 48c10.2 0 20.4 1.7 30.1 4.9l80.1 26.7c4.2 1.4 8.7-.9 10.1-5.1s-.9-8.7-5.1-10.1L210.4 37.7c-11.3-3.8-23.2-5.7-35.2-5.7C113.8 32 64 81.8 64 143.2V256H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H63.8C61.7 341.6 40.1 409.4 1.4 467.5C.5 468.8 0 470.3 0 472c0 4.4 3.6 8 8 8H312c4.4 0 8-3.6 8-8s-3.6-8-8-8H22.6c35.5-57.9 55.2-124.1 57.2-192H248c4.4 0 8-3.6 8-8s-3.6-8-8-8H80V143.2z'
      
    ]
  };

  
    var faGbp = faSterlingSign;
  
    var faPoundSign = faSterlingSign;
  

  
  

  var faSmoke = {
    prefix: 'fat',
    iconName: 'smoke',
    icon: [
      640,
      512,
      [],
      'f760',
      
      'M48 128c0 32.8 14.1 62.3 36.6 82.8c-5.4 2-10.7 4.4-15.8 6.9C46 194.7 32 163 32 128C32 57.3 89.3 0 160 0c40.1 0 75.9 18.4 99.3 47.3C277.4 37.5 298.1 32 320 32c47.2 0 88.4 25.6 110.6 63.6c-4.5 2.9-8.9 6-13.1 9.3C398.3 70.9 361.8 48 320 48c-21.5 0-41.5 6-58.6 16.5c-3.6 2.2-8.2 1.3-10.7-2.1C230.4 34.3 197.3 16 160 16C98.1 16 48 66.1 48 128zm464-16c-44 0-82.1 25.4-100.4 62.3c-1.1 2.3-3.3 3.9-5.9 4.3s-5.1-.4-6.9-2.2C378.6 156.4 350.7 144 320 144c-47.7 0-88.5 29.8-104.6 71.9c-4.8-2.3-9.7-4.3-14.8-6.1c18.5-47.9 65-81.8 119.4-81.8c31.3 0 60.1 11.3 82.3 30c22.4-37.1 63.1-62 109.7-62c70.7 0 128 57.3 128 128c0 45.1-23.3 84.7-58.5 107.5c-2.7-4.6-5.7-9.1-8.9-13.3C603.5 298.2 624 263.5 624 224c0-61.9-50.1-112-112-112zM144 240C73.3 240 16 297.3 16 368s57.3 128 128 128H464c53 0 96-43 96-96s-43-96-96-96c-11.3 0-22.1 2-32.2 5.5c-3.9 1.4-8.2-.4-10-4.2C404.1 266.8 365.2 240 320 240c-30.9 0-58.9 12.5-79.2 32.8c-3 3-7.9 3.1-11 .3c-22.7-20.5-52.8-33-85.8-33zM0 368c0-79.5 64.5-144 144-144c34.5 0 66.2 12.1 90.9 32.3C257.5 236.2 287.4 224 320 224c49.1 0 91.8 27.7 113.2 68.3c9.8-2.8 20.1-4.3 30.8-4.3c61.9 0 112 50.1 112 112s-50.1 112-112 112H144C64.5 512 0 447.5 0 368z'
      
    ]
  };

  

  
  

  var faMaskSnorkel = {
    prefix: 'fat',
    iconName: 'mask-snorkel',
    icon: [
      576,
      512,
      [],
      'e3b7',
      
      'M536 48c-13.3 0-24 10.7-24 24v72h48V72c0-13.3-10.7-24-24-24zM512 160v32h48V160H512zm0 207.3c0 44.5-36.1 80.7-80.7 80.7c-39 0-72.4-27.9-79.4-66.2l-.4-2.1c-2.4-13-14.9-21.7-27.9-19.3s-21.7 14.9-19.3 27.9l.4 2.1C315.9 451.5 369.2 496 431.3 496C502.4 496 560 438.4 560 367.3V208H512V367.3zM536 32c22.1 0 40 17.9 40 40V367.3C576 447.2 511.2 512 431.3 512c-69.9 0-129.8-50-142.3-118.8l-.4-2.1c-4-21.7 10.5-42.6 32.2-46.5s42.6 10.5 46.5 32.2l.4 2.1c5.6 30.7 32.4 53.1 63.6 53.1c35.7 0 64.7-28.9 64.7-64.7V72c0-22.1 17.9-40 40-40zM64 80c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h79.7c21.4 0 40.3-14.2 46.2-34.8l3.4-11.7c8.8-30.9 52.7-30.9 61.5 0l3.4 11.7c5.9 20.6 24.7 34.8 46.2 34.8H384c26.5 0 48-21.5 48-48V128c0-26.5-21.5-48-48-48H64zM0 128C0 92.7 28.7 64 64 64H384c35.3 0 64 28.7 64 64v96c0 35.3-28.7 64-64 64H304.3c-28.6 0-53.7-18.9-61.5-46.4l-3.4-11.7c-4.4-15.5-26.3-15.5-30.8 0l-3.4 11.7c-7.9 27.5-33 46.4-61.5 46.4H64c-35.3 0-64-28.7-64-64V128z'
      
    ]
  };

  

  
  

  var faImageSlash = {
    prefix: 'fat',
    iconName: 'image-slash',
    icon: [
      640,
      512,
      [],
      'e1b7',
      
      'M13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7zM467.3 464h-280L310.8 340.5l-12.6-10L288 340.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0L80 356.7V158.3L64 145.6V416c0 35.3 28.7 64 64 64H487.5l-20.3-16zM512 32H152.5l20.3 16H512c26.5 0 48 21.5 48 48V292.7l-89.4-89.4c-12.5-12.5-32.8-12.5-45.3 0L400.7 228l12.6 10 23.3-23.3c6.2-6.2 16.4-6.2 22.6 0L560 315.3v38.4l16 12.6V96c0-35.3-28.7-64-64-64zM80 379.3L180.7 278.6c6.2-6.2 16.4-6.2 22.6 0L276.7 352l-112 112H128c-26.5 0-48-21.5-48-48V379.3z'
      
    ]
  };

  

  
  

  var faPersonWalkingDashedLineArrowRight = {
    prefix: 'fat',
    iconName: 'person-walking-dashed-line-arrow-right',
    icon: [
      640,
      512,
      [],
      'e553',
      
      'M137.1 187.3c-4.6-4-11-5.1-16.6-2.8c-1.1 .5-2.2 .9-3.4 1.4l0 0-5.7 2.5c-21.6 9.6-37.9 28.3-44.4 51.1l-3.7 12.9c-2.4 8.5-11.3 13.4-19.8 11s-13.4-11.3-11-19.8l3.7-12.9c9.1-31.9 31.9-58.1 62.2-71.6l5.7-2.5c18.8-8.3 39-12.6 59.6-12.6c38.1 0 72.5 22.9 87.1 58.1l16.5 39.7c1.1 2.6 2.9 4.9 5.2 6.6l25 18.8c7.1 5.3 8.5 15.3 3.2 22.4s-15.3 8.5-22.4 3.2l-28.5-21.4c-4.6-3.4-8.1-8-10.3-13.3l-10.2-24.5c-2.6-6.3-8.9-10.2-15.6-9.8s-12.6 5-14.5 11.5L180 300.8c-1.6 5.4-.2 11.2 3.6 15.3l49.5 54c3.6 3.9 6.2 8.7 7.5 13.9l23 92.1c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6l-22-88.1c-.6-2.6-1.9-5-3.7-6.9l-70.7-77.1c-11.1-12.1-15.2-29-11-44.8L142 203.4c1.6-5.9-.3-12.1-4.9-16.1zM208 16a36 36 0 1 1 0 72 36 36 0 1 1 0-72zM107.4 209c3.3-2.3 6.8-4.3 10.6-6l5.7-2.5c1-.4 1.9-.8 2.9-1.2l-1.3 4.8-2.5 9.6-1.5 5.6-11.6 43.6c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 12.1-41.2 7.2-24.4 9.8 23.5 .4 1c3.3 7.9 8.7 14.8 15.5 19.9l28.5 21.4c14.1 10.6 34.2 7.7 44.8-6.4s7.7-34.2-6.4-44.8l-25-18.8-16.5-39.7C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14L92 144.5c-34.6 15.4-60.7 45.3-71.1 81.8l-3.7 12.9c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l3.7-12.9c4.1-14.3 13-26.6 24.9-34.9zM260 52A52 52 0 1 0 156 52a52 52 0 1 0 104 0zM99 343.9c-4.1-1.6-8.8 .4-10.4 4.5L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l61.7-61.7c4.6-4.6 8.2-10.1 10.6-16.1L142.1 387c1.6-4.1-.4-8.8-4.5-10.4s-8.8 .4-10.4 4.5l-15.1 37.9c-1.6 4-4 7.7-7.1 10.7L43.3 491.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l60.5-60.5 1.2-1.2 .6-1.5 20.5-51.1c1.6-4.1-.4-8.8-4.5-10.4zM400 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V88c0 4.4 3.6 8 8 8s8-3.6 8-8V8zM541.1 169.9c-3.4-2.8-8.4-2.4-11.3 1s-2.4 8.4 1 11.3l79 65.9H392c-4.4 0-8 3.6-8 8s3.6 8 8 8H609.9l-79 65.9c-3.4 2.8-3.9 7.9-1 11.3s7.9 3.9 11.3 1l96-80c1.8-1.5 2.9-3.8 2.9-6.1s-1.1-4.6-2.9-6.1l-96-80zM392 128c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8s8-3.6 8-8V136c0-4.4-3.6-8-8-8zm8 200c0-4.4-3.6-8-8-8s-8 3.6-8 8v48c0 4.4 3.6 8 8 8s8-3.6 8-8V328zm-8 88c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8s8-3.6 8-8V424c0-4.4-3.6-8-8-8z'
      
    ]
  };

  

  
  

  var faStocking = {
    prefix: 'fat',
    iconName: 'stocking',
    icon: [
      384,
      512,
      [],
      'f7d5',
      
      'M96 16H352c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V32c0-8.8 7.2-16 16-16zM64 32V80c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H96C78.3 0 64 14.3 64 32zm48 206.9V144H96v94.9c0 10.7-5.3 20.7-14.2 26.6L55.7 282.9C20.9 306.1 0 345.1 0 386.9v2.2C0 457 55 512 122.8 512c24.2 0 48-7.2 68.1-20.6L295 422c35.6-23.7 57-63.7 57-106.5V144H336V315.5c0 37.4-18.7 72.4-49.9 93.2L182.1 478.1c-17.5 11.7-38.2 17.9-59.3 17.9C63.8 496 16 448.2 16 389.2v-2.2c0-36.5 18.2-70.5 48.6-90.7l26.1-17.4c13.4-8.9 21.4-23.9 21.4-39.9z'
      
    ]
  };

  

  
  

  var faTeddyBear = {
    prefix: 'fat',
    iconName: 'teddy-bear',
    icon: [
      576,
      512,
      [],
      'e3cf',
      
      'M144 64c0 16.8 8.6 31.6 21.7 40.2c2.7 1.8 4 4.9 3.5 8.1c-.8 4.5-1.2 9.3-1.2 14.4C168 188 220.4 240 288 240s120-52 120-113.3c0-5.2-.4-10-1.2-14.4c-.6-3.1 .8-6.3 3.5-8.1C423.4 95.6 432 80.8 432 64c0-26.5-21.5-48-48-48c-20.3 0-37.8 12.7-44.7 30.6c-1.4 3.6-5.1 5.6-8.9 5C316.3 49 301.7 48 288 48s-28.3 1-42.4 3.5c-3.8 .7-7.5-1.4-8.9-5C229.8 28.7 212.3 16 192 16c-26.5 0-48 21.5-48 48zM192 0c24.8 0 46.3 14.1 56.9 34.8c13.2-2 26.5-2.8 39.1-2.8s25.8 .8 39.1 2.8C337.7 14.1 359.2 0 384 0c35.3 0 64 28.7 64 64c0 20.5-9.7 38.8-24.7 50.5c.5 3.9 .7 7.9 .7 12.1C424 197.4 363.8 256 288 256s-136-58.6-136-129.3c0-4.2 .2-8.2 .7-12.1c-15-11.7-24.7-30-24.7-50.5c0-35.3 28.7-64 64-64zm72 168c0 3.5 1.9 7.4 6.2 10.6s10.6 5.4 17.8 5.4s13.5-2.2 17.8-5.4s6.2-7 6.2-10.6s-1.9-7.4-6.2-10.6s-10.6-5.4-17.8-5.4s-13.5 2.2-17.8 5.4s-6.2 7-6.2 10.6zm24-32c10.4 0 20.1 3.2 27.4 8.6s12.6 13.7 12.6 23.4s-5.3 17.9-12.6 23.4s-17 8.6-27.4 8.6s-20.1-3.2-27.4-8.6s-12.6-13.7-12.6-23.4s5.3-17.9 12.6-23.4s17-8.6 27.4-8.6zM61 196.3c24.2-19.3 59.4-15.4 78.7 8.7l10.8 13.5c70.5 88.1 204.4 88.1 274.9 0L436.3 205c19.3-24.2 54.6-28.1 78.7-8.7s28.1 54.6 8.7 78.7l-10.8 13.5c-27.4 34.2-60.6 60.3-96.9 78.3V400h48.6c3.9-27.1 27.2-48 55.4-48c30.9 0 56 25.1 56 56c0 33.7-14.7 66.8-24.3 85c-6.6 12.4-19.5 19-32.8 19H472l-.1 0H104.1l-.1 0H57.1c-13.3 0-26.2-6.7-32.8-19C14.7 474.8 0 441.7 0 408c0-30.9 25.1-56 56-56c28.2 0 51.6 20.9 55.4 48H160V366.8c-36.3-18-69.5-44.1-96.9-78.3L52.3 275C33 250.8 36.9 215.6 61 196.3zM103.9 496l.1 0H216V472c0-30.9-25.1-56-56-56v0H104c-4.4 0-8-3.6-8-8c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 29.7 13.2 59.9 22.5 77.5C41.9 492 49 496 57.1 496h46.8zM176 401.8c9.1 2.1 17.5 5.8 24.9 10.9c5.4-34.4 35.2-60.7 71.1-60.7h32c35.9 0 65.7 26.3 71.1 60.7c7.4-5.1 15.8-8.9 24.9-10.9v-40c0-3.1 1.8-5.9 4.6-7.2c35.9-17 68.9-42.3 95.8-76L511.2 265c13.8-17.3 11-42.4-6.2-56.2s-42.4-11-56.2 6.2l-10.8 13.5c-76.9 96.1-223 96.1-299.9 0L127.2 215c-13.8-17.3-39-20-56.2-6.2s-20 39-6.2 56.2l10.8 13.5c26.9 33.7 59.9 59 95.8 76c2.8 1.3 4.6 4.1 4.6 7.2v40zm40 25c10 12.4 16 28.1 16 45.3v24H344V472c0-17.1 6-32.9 16-45.3V424c0-30.9-25.1-56-56-56H272c-30.9 0-56 25.1-56 56v2.7zM416 416c-30.9 0-56 25.1-56 56v24H472l.1 0h46.8c8.1 0 15.2-4 18.7-10.5c9.3-17.6 22.5-47.8 22.5-77.5c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 4.4-3.6 8-8 8H416v0zM240 100a12 12 0 1 1 0 24 12 12 0 1 1 0-24zm84 12a12 12 0 1 1 24 0 12 12 0 1 1 -24 0z'
      
    ]
  };

  

  
  

  var faVolcano = {
    prefix: 'fat',
    iconName: 'volcano',
    icon: [
      512,
      512,
      [127755],
      'f770',
      
      'M210.9 47.4c-1 2.7-3.4 4.7-6.2 5.1s-5.7-.6-7.5-2.8C188.4 38.9 175 32 160 32c-26.5 0-48 21.5-48 48s21.5 48 48 48c13.1 0 25-5.2 33.6-13.8c1.7-1.7 4.1-2.5 6.5-2.2s4.5 1.6 5.8 3.7l32.2 50.6c3.9 6.1 10.6 9.8 17.8 9.8s14-3.7 17.8-9.8L306 115.7c1.3-2 3.4-3.4 5.8-3.7s4.8 .5 6.5 2.2C327 122.8 338.9 128 352 128c26.5 0 48-21.5 48-48s-21.5-48-48-48c-15 0-28.4 6.9-37.2 17.7c-1.8 2.2-4.7 3.3-7.5 2.8s-5.2-2.4-6.2-5.1C294.3 29.1 276.7 16 256 16s-38.3 13.1-45.1 31.4zM256 0c23.3 0 43.6 12.4 54.8 31C322 21.6 336.3 16 352 16c35.3 0 64 28.7 64 64s-28.7 64-64 64c-14 0-26.9-4.5-37.4-12.1l-27.3 42.9C280.5 185.5 268.7 192 256 192s-24.5-6.5-31.3-17.2l-27.3-42.9C186.9 139.5 174 144 160 144c-35.3 0-64-28.7-64-64s28.7-64 64-64c15.7 0 30 5.6 41.2 15C212.4 12.4 232.7 0 256 0zM16 459.8c0 20 16.2 36.2 36.2 36.2H459.8c20 0 36.2-16.2 36.2-36.2c0-8.9-3.3-17.4-9.1-24L390.1 326.9 362 369c-6.3 9.4-16.8 15-28 15c-8.9 0-17.5-3.6-23.8-9.9l-34.5-34.5C263.1 327.1 246 320 228.3 320c-13.2 0-26.1 3.9-37.1 11.2l-17.8 11.9c-8.7 5.8-18.9 8.9-29.3 8.9s-20.6-3.1-29.3-8.9l-4.5-3L25.1 435.8c-5.9 6.6-9.1 15.2-9.1 24zm332.7-99.7l30.4-45.6-42.4-47.7c-15.2-17.1-36.9-26.9-59.8-26.9H235.1c-22.9 0-44.6 9.8-59.8 26.9L120.9 328l2.6 1.8c6.1 4 13.2 6.2 20.4 6.2s14.4-2.2 20.4-6.2l17.8-11.9c13.6-9.1 29.6-13.9 46-13.9c22 0 43.1 8.7 58.7 24.3l34.5 34.5c3.3 3.3 7.8 5.2 12.5 5.2c5.9 0 11.4-3 14.7-7.9zm-.1-103.9l39.6 44.6 0 0 11 12.4 0 0 99.6 112c8.5 9.5 13.2 21.9 13.2 34.7c0 28.8-23.4 52.2-52.2 52.2H52.2C23.4 512 0 488.6 0 459.8c0-12.8 4.7-25.1 13.2-34.7l83.6-94 0 0 10.7-12.1 0 0 55.9-62.9c18.2-20.5 44.3-32.2 71.8-32.2h41.8c27.4 0 53.5 11.7 71.8 32.2z'
      
    ]
  };

  

  
  

  var faLariSign = {
    prefix: 'fat',
    iconName: 'lari-sign',
    icon: [
      384,
      512,
      [],
      'e1c8',
      
      'M136 32c4.4 0 8 3.6 8 8v62.4c15.9-4.2 32.6-6.4 49.9-6.4c10.3 0 20.3 .8 30.1 2.3V40c0-4.4 3.6-8 8-8s8 3.6 8 8v61.5c72.4 17.5 128.9 75.3 143.8 148.1c.9 4.3-1.9 8.6-6.2 9.4s-8.6-1.9-9.4-6.2C354.8 187.4 304.7 135.1 240 118l0 162c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-165.5c-9.8-1.7-19.9-2.5-30.1-2.5c-17.3 0-34 2.4-49.9 7l0 161c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-155.5C62.3 150.4 16 213.9 16 288c0 97.1 79.6 176 177.9 176H376c4.4 0 8 3.6 8 8s-3.6 8-8 8H193.9 8c-4.4 0-8-3.6-8-8s3.6-8 8-8H116.3C47.9 434.4 0 366.8 0 288c0-83.2 53.4-153.9 128-180.6V40c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faUserPolice = {
    prefix: 'fat',
    iconName: 'user-police',
    icon: [
      448,
      512,
      [],
      'e333',
      
      'M222.1 16.2L62.2 52.1c-2.8 .6-5.1 2.8-5.9 5.6s-.1 5.8 2 7.9L87.5 95.1c1.5 1.5 2.3 3.5 2.3 5.6v26.9c15.7 10.2 46.4 27 105.5 31.3C173.9 138.5 168 110.1 168 91.2c0-3.3 2-6.2 5-7.4l48-19.2c1.9-.8 4-.8 5.9 0l48 19.2c3 1.2 5 4.2 5 7.4c0 18.9-5.9 47.3-27.2 67.6c59-4.3 89.6-21.1 105.2-31.2V100.7c0-2.1 .8-4.1 2.3-5.6l29.1-29.5c2-2.1 2.8-5.1 2-7.9s-3.1-4.9-5.9-5.6l-159.9-36c-1.2-.3-2.4-.3-3.5 0zM366.8 140.9c-20.3 13.2-60.7 34.6-141.1 34.9c-1.1 .2-2.3 .2-3.4 0c-80.6-.3-121-21.7-141.3-34.9c-4.6-3-7.2-8-7.2-13.3V104L46.9 76.8c-6.1-6.2-8.4-15.2-6-23.6s9.3-14.8 17.8-16.7L218.6 .6c3.5-.8 7.1-.8 10.5 0L389 36.5c8.5 1.9 15.3 8.3 17.8 16.7s.2 17.4-6 23.6L374 104v23.6c0 5.3-2.6 10.3-7.2 13.3zM96.3 183.3c4.8 2.3 10.1 4.5 15.7 6.7c0 .7 0 1.3 0 2c0 61.9 50.1 112 112 112s112-50.1 112-112c0-.7 0-1.3 0-2c5.7-2.2 10.9-4.4 15.7-6.7c.2 2.9 .3 5.8 .3 8.7c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-2.9 .1-5.8 .3-8.7zm87.9-86.8c1.3 20.9 10.8 49 39.8 62.7c29-13.7 38.5-41.8 39.8-62.7L224 80.6 184.2 96.5zM213.5 444l-86.6-75.8C65 372.1 16 423.5 16 486.4c0 5.3 4.3 9.6 9.6 9.6H216V446.3l-2.5-2.2zM232 496H422.4c5.3 0 9.6-4.3 9.6-9.6c0-62.8-49-114.3-110.8-118.2L234.5 444l-2.5 2.2V496zm190.4 16H224.2l-.2 0-.2 0H25.6C11.5 512 0 500.5 0 486.4C0 412.8 59.2 353 132.6 352L224 432l91.4-80C388.8 353 448 412.8 448 486.4c0 14.1-11.5 25.6-25.6 25.6zM360 424v16h16c4.4 0 8 3.6 8 8s-3.6 8-8 8H360v16c0 4.4-3.6 8-8 8s-8-3.6-8-8V456H328c-4.4 0-8-3.6-8-8s3.6-8 8-8h16V424c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faCircleChevronUp = {
    prefix: 'fat',
    iconName: 'circle-chevron-up',
    icon: [
      512,
      512,
      ["chevron-circle-up"],
      'f139',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM381.7 290.3l-120-120c-3.1-3.1-8.2-3.1-11.3 0l-120 120c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L256 187.3 370.3 301.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3z'
      
    ]
  };

  
    var faChevronCircleUp = faCircleChevronUp;
  

  
  

  var faUpRight = {
    prefix: 'fat',
    iconName: 'up-right',
    icon: [
      384,
      512,
      [],
      'e2be',
      
      'M336 96c8.8 0 16 7.2 16 16V347.7c0 11.2-9.1 20.3-20.3 20.3c-5.4 0-10.5-2.1-14.3-5.9l-75.7-75.7c-3.1-3.1-8.2-3.1-11.3 0L93.7 423c-5.7 5.7-13.5 9-21.7 9s-15.9-3.2-21.7-9L25 397.6c-5.7-5.7-9-13.5-9-21.7s3.2-15.9 9-21.7L161.7 217.7c1.5-1.5 2.3-3.5 2.3-5.7s-.8-4.2-2.3-5.7L85.9 130.6c-3.8-3.8-5.9-9-5.9-14.3C80 105.1 89.1 96 100.3 96H336zm32 16c0-17.7-14.3-32-32-32H100.3C80.2 80 64 96.2 64 116.3c0 9.6 3.8 18.9 10.6 25.7L144.7 212 13.7 343C4.9 351.8 0 363.6 0 376s4.9 24.2 13.7 33L39 434.3c8.7 8.7 20.6 13.7 33 13.7s24.2-4.9 33-13.7l131-131 70.1 70.1c6.8 6.8 16 10.6 25.7 10.6c20 0 36.3-16.2 36.3-36.3V112z'
      
    ]
  };

  

  
  

  var faFileMagnifyingGlass = {
    prefix: 'fat',
    iconName: 'file-magnifying-glass',
    icon: [
      384,
      512,
      ["file-search"],
      'f865',
      
      'M64 496c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM176 240a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 176c23.6 0 45.3-8.5 62-22.7l52.4 52.4c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L249.3 382c14.2-16.7 22.7-38.4 22.7-62c0-53-43-96-96-96s-96 43-96 96s43 96 96 96z'
      
    ]
  };

  
    var faFileSearch = faFileMagnifyingGlass;
  

  
  

  var faGearComplex = {
    prefix: 'fat',
    iconName: 'gear-complex',
    icon: [
      512,
      512,
      [],
      'e5e9',
      
      'M436.6 74.5l0 0C425.6 63.6 413.7 53.7 401 45c-8.2-5.6-18.8-5.4-26.7-.1L341.8 66.5c-4.1-1.8-8.2-3.6-12.4-5.1l-7.7-38.3c-1.9-9.4-9.2-17-19-18.8C287.6 1.5 271.9 0 256 0s-31.6 1.5-46.7 4.3c-9.8 1.8-17.1 9.4-19 18.8l-7.7 38.3c-4.2 1.6-8.3 3.3-12.4 5.1L137.8 44.8c-7.9-5.3-18.5-5.5-26.7 .1C98.3 53.7 86.4 63.7 75.4 74.5l0 0-.8 .8 0 0C63.7 86.4 53.7 98.3 45 111c-5.6 8.2-5.4 18.8-.1 26.7l21.6 32.5c-1.8 4.1-3.6 8.2-5.1 12.4l-38.3 7.7c-9.4 1.9-17 9.2-18.8 19C1.5 224.4 0 240.1 0 256s1.5 31.6 4.3 46.7c1.8 9.8 9.4 17.1 18.8 19l38.3 7.7c1.6 4.2 3.3 8.3 5.1 12.4L44.8 374.2c-5.3 7.9-5.5 18.5 .1 26.7C62.8 426.8 85.2 449.2 111 467c8.2 5.6 18.8 5.4 26.7 .2l32.5-21.6c4.1 1.8 8.2 3.6 12.4 5.1l7.7 38.3c1.9 9.4 9.2 17 19 18.8c15.2 2.8 30.8 4.3 46.7 4.3s31.6-1.5 46.7-4.3c9.8-1.8 17.1-9.4 19-18.8l7.7-38.3c4.2-1.6 8.3-3.3 12.4-5.1l32.5 21.6c7.9 5.3 18.5 5.5 26.7-.2c25.9-17.8 48.3-40.2 66.1-66.1c5.6-8.2 5.4-18.8 .2-26.7l-21.6-32.5c1.8-4.1 3.6-8.2 5.1-12.4l38.3-7.7c9.4-1.9 17-9.2 18.8-19c2.8-15.1 4.2-30.6 4.3-46.5v0-.4 0c0-15.9-1.5-31.4-4.3-46.5c-1.8-9.8-9.4-17.1-18.8-19l-38.3-7.7c-1.6-4.2-3.3-8.3-5.1-12.4l21.6-32.5c5.3-7.9 5.5-18.5-.1-26.7c-8.8-12.7-18.7-24.6-29.5-35.6l0 0-.9-.9zm17.3 45.6c1.8 2.6 1.8 6.1 0 8.8L429.8 165c-1.6 2.4-1.8 5.5-.5 8.1c2.9 6.1 5.6 12.5 7.9 18.9c1 2.7 3.3 4.8 6.1 5.4l42.6 8.5c3.1 .6 5.6 3.1 6.2 6.2c2.6 14.1 4 28.7 4 43.6v.4c0 14.9-1.4 29.5-4 43.6c-.6 3.2-3.1 5.6-6.2 6.2l-42.6 8.5c-2.8 .6-5.1 2.6-6.1 5.4c-2.3 6.5-4.9 12.8-7.9 18.9c-1.3 2.6-1.1 5.7 .5 8.1l24.1 36.1c1.8 2.7 1.8 6.2 0 8.8c-16.7 24.2-37.7 45.3-62 62c-2.6 1.8-6.1 1.8-8.8 0L347 429.8c-2.4-1.6-5.5-1.8-8.1-.5c-6.1 2.9-12.5 5.6-18.9 7.9c-2.7 1-4.8 3.3-5.4 6.1L306 485.8c-.6 3.1-3.1 5.6-6.2 6.2c-14.2 2.6-28.8 4-43.8 4s-29.6-1.4-43.8-4c-3.2-.6-5.6-3.1-6.2-6.2l-8.5-42.6c-.6-2.8-2.6-5.1-5.4-6.1c-6.5-2.3-12.8-4.9-18.9-7.9c-2.6-1.3-5.7-1.1-8.1 .5l-36.1 24.1c-2.7 1.8-6.2 1.8-8.8 0c-24.2-16.7-45.3-37.7-62-62c-1.8-2.6-1.8-6.1 0-8.8L82.2 347c1.6-2.4 1.8-5.5 .5-8.1c-2.9-6.1-5.6-12.5-7.9-18.9c-1-2.7-3.3-4.8-6.1-5.4L26.2 306c-3.1-.6-5.6-3.1-6.2-6.2c-2.6-14.2-4-28.8-4-43.8s1.4-29.6 4-43.8c.6-3.2 3.1-5.6 6.2-6.2l42.6-8.5c2.8-.6 5.1-2.6 6.1-5.4c2.3-6.5 4.9-12.8 7.9-18.9c1.2-2.6 1.1-5.7-.5-8.1L58.1 128.9c-1.8-2.7-1.8-6.2 0-8.8c8.2-12 17.5-23.1 27.7-33.4l.8-.8C97 75.7 108.1 66.4 120.1 58.2c2.6-1.8 6.1-1.8 8.8 0L165 82.2c2.4 1.6 5.5 1.8 8.1 .5c6.1-2.9 12.5-5.6 18.9-7.9c2.7-1 4.8-3.3 5.4-6.1L206 26.2c.6-3.1 3.1-5.6 6.2-6.2c14.2-2.6 28.8-4 43.8-4s29.6 1.4 43.8 4c3.2 .6 5.6 3.1 6.2 6.2l8.5 42.6c.6 2.8 2.6 5.1 5.4 6.1c6.5 2.3 12.8 4.9 18.9 7.9c2.6 1.2 5.7 1.1 8.1-.5l36.1-24.1c2.7-1.8 6.2-1.8 8.8 0c11.9 8.2 23.1 17.5 33.4 27.7l.9 .9c10.2 10.2 19.5 21.4 27.7 33.4zM176 256a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm176 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z'
      
    ]
  };

  

  
  

  var faUniversalAccess = {
    prefix: 'fat',
    iconName: 'universal-access',
    icon: [
      512,
      512,
      [],
      'f29a',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM224 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM128.7 188.8c-1.8 4 0 8.8 4.1 10.6l28.1 12.5c15.2 6.7 31 11.8 47.1 15.2v99.8l-23.7 78.9c-1.3 4.2 1.1 8.7 5.4 10s8.7-1.1 10-5.4L222 336H290l22.3 74.3c1.3 4.2 5.7 6.6 10 5.4s6.6-5.7 5.4-10L304 326.8V227c16.2-3.4 31.9-8.5 47.1-15.2l28.1-12.5c4-1.8 5.9-6.5 4.1-10.6s-6.5-5.9-10.6-4.1l-28.1 12.5C316.7 209.6 286.5 216 256 216s-60.7-6.4-88.6-18.8l-28.1-12.5c-4-1.8-8.8 0-10.6 4.1zM224 229.8c10.6 1.5 21.3 2.2 32 2.2s21.4-.7 32-2.2V320H224V229.8z'
      
    ]
  };

  

  
  

  var faAperture = {
    prefix: 'fat',
    iconName: 'aperture',
    icon: [
      512,
      512,
      [],
      'e2df',
      
      'M256 496c-9.1 0-18-.5-26.9-1.5L316 344l9.5-16.5c.8-1.1 1.5-2.3 2.2-3.5l23.1-40c.7-1.2 1.3-2.4 1.9-3.6l4.8-8.4 79.7 138 1.1 2c-44 51.4-109.4 84-182.4 84zm23.3-144H293L213.3 490l-1.2 2C132.9 477.4 67.4 423.9 36 352H209.8h23.3 46.2zM233.1 160H219L298.7 22l1.2-2C379.1 34.6 444.6 88.1 476 160H302.2 279.3 233.1zm92.5 24.5l-4.9-8.5H480h2.3c8.8 25 13.7 51.9 13.7 80c0 53.4-17.4 102.7-46.9 142.5L362.2 248l-9.4-16.4c-.6-1.2-1.2-2.4-1.9-3.6l-23.1-40c-.7-1.2-1.4-2.4-2.2-3.5zM312 193.1l26.6 46c5 10.7 5 23.1 0 33.8l-26.6 46c-7.4 10.6-19.7 17.1-32.8 17.1H233.1c-14.3 0-27.5-7.6-34.6-20l-23.1-40c-7.1-12.4-7.1-27.6 0-40l23.1-40c7.1-12.4 20.4-20 34.6-20h46.2c13.1 0 25.3 6.4 32.8 17.1zM149.8 264l41.6 72H32 29.7C20.8 311 16 284.1 16 256c0-53.4 17.4-102.7 46.9-142.5L149.8 264zm-75-162l-1.1-2C117.6 48.6 183 16 256 16c9.1 0 18 .5 26.9 1.5L196 168l-41.6 72L74.7 102zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z'
      
    ]
  };

  

  
  

  var faHelicopterSymbol = {
    prefix: 'fat',
    iconName: 'helicopter-symbol',
    icon: [
      512,
      512,
      [],
      'e502',
      
      'M493.9 224H510C495.6 108.2 403.8 16.4 288 2V18.1C395 32.4 479.6 117.1 493.9 224zM510 288H493.9C479.6 395 395 479.6 288 493.9V510c115.8-14.4 207.6-106.2 222-222zM2 288C16.4 403.8 108.2 495.6 224 510V493.9C117 479.6 32.4 395 18.1 288H2zm0-64H18.1C32.4 117 117.1 32.4 224 18.1V2C108.2 16.4 16.4 108.2 2 224zm166-80c0-4.4-3.6-8-8-8s-8 3.6-8 8V368c0 4.4 3.6 8 8 8s8-3.6 8-8V264H344V368c0 4.4 3.6 8 8 8s8-3.6 8-8V144c0-4.4-3.6-8-8-8s-8 3.6-8 8V248H168V144z'
      
    ]
  };

  

  
  

  var faTreeLarge = {
    prefix: 'fat',
    iconName: 'tree-large',
    icon: [
      448,
      512,
      [],
      'f7dd',
      
      'M224 0c2.2 0 4.3 .9 5.8 2.5L375.5 155.9c5.4 5.7 8.5 13.3 8.5 21.3c0 17-13.8 30.9-30.9 30.9H322.3l85.4 91.9c5.3 5.7 8.3 13.3 8.3 21.1c0 17.1-13.9 31-31 31H352.8l88.1 108.4c4.6 5.6 7.1 12.7 7.1 19.9c0 17.5-14.2 31.6-31.6 31.6H288 160 31.6C14.2 512 0 497.8 0 480.4c0-7.3 2.5-14.3 7.1-19.9L95.2 352H63c-17.1 0-31-13.9-31-31c0-7.8 3-15.3 8.3-21.1L125.7 208H94.9c-17 0-30.9-13.8-30.9-30.9c0-7.9 3-15.5 8.5-21.3L218.2 2.5C219.7 .9 221.8 0 224 0zM160 496H288 416.4c8.6 0 15.6-7 15.6-15.6c0-3.6-1.2-7.1-3.5-9.8L329.8 349c-1.9-2.4-2.3-5.7-1-8.5s4.1-4.6 7.2-4.6h49c8.3 0 15-6.7 15-15c0-3.8-1.4-7.4-4-10.2L298.1 205.4c-2.2-2.3-2.7-5.7-1.5-8.6s4.2-4.8 7.3-4.8h49.1c8.2 0 14.9-6.7 14.9-14.9c0-3.8-1.5-7.5-4.1-10.2L224 19.6 84.1 166.9c-2.6 2.8-4.1 6.4-4.1 10.2c0 8.2 6.7 14.9 14.9 14.9H144c3.2 0 6.1 1.9 7.3 4.8s.7 6.3-1.5 8.6L52 310.8c-2.6 2.8-4 6.4-4 10.2c0 8.3 6.7 15 15 15h49c3.1 0 5.9 1.8 7.2 4.6s.9 6.1-1 8.5L19.5 470.5c-2.3 2.8-3.5 6.3-3.5 9.8C16 489 23 496 31.6 496H160z'
      
    ]
  };

  

  
  

  var faBatteryBolt = {
    prefix: 'fat',
    iconName: 'battery-bolt',
    icon: [
      576,
      512,
      [],
      'f376',
      
      'M80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80h92.2c-4.2-4.7-7.4-10.2-9.5-16H80c-35.3 0-64-28.7-64-64V176c0-35.3 28.7-64 64-64H279.2l20-16H80zM448 400H264.8l-20 16H448c44.2 0 80-35.8 80-80V320h16c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H528V176c0-44.2-35.8-80-80-80H371.8c4.2 4.7 7.4 10.2 9.5 16H448c35.3 0 64 28.7 64 64v16 16 96 16 16c0 35.3-28.7 64-64 64zm96-192c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H528V208h16zM283.6 232.8c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6H368L208 384l52.4-104.8c2.5-5 2.2-10.9-.7-15.6s-8.1-7.6-13.6-7.6H176L336 128 283.6 232.8zm66.7-97.7c3.4-6.7 1.6-14.9-4.2-19.6s-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7h52.2 17.9l-8 16-44.4 88.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7H315.8 297.9l8-16 44.4-88.8z'
      
    ]
  };

  

  
  

  var faSquareArrowDownLeft = {
    prefix: 'fat',
    iconName: 'square-arrow-down-left',
    icon: [
      448,
      512,
      [],
      'e261',
      
      'M64 464c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H384c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64zM0 416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416zm280-64c4.4 0 8-3.6 8-8s-3.6-8-8-8H155.3L317.7 173.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L144 324.7V200c0-4.4-3.6-8-8-8s-8 3.6-8 8V344c0 4.4 3.6 8 8 8H280z'
      
    ]
  };

  

  
  

  var faFaceLaughBeam = {
    prefix: 'fat',
    iconName: 'face-laugh-beam',
    icon: [
      512,
      512,
      [128513,"laugh-beam"],
      'f59a',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 416c64.7 0 119.5-44.8 135.8-106.1c.4-1.4 .1-2.5-.9-3.6c-1.1-1.2-3-2.3-5.4-2.3H126.5c-2.4 0-4.4 1.1-5.4 2.3c-1 1.1-1.2 2.2-.9 3.6C136.5 371.2 191.3 416 256 416zM126.5 288H385.5c14.2 0 25.4 12.3 21.8 26c-18.1 68-79 118-151.3 118s-133.2-50-151.3-118c-3.6-13.7 7.6-26 21.8-26zm24.5-108.3c-7.4 11.4-12.7 26.3-15.2 39.8c-.8 4.3-5 7.2-9.3 6.4s-7.2-5-6.4-9.3c2.8-15 8.7-32 17.6-45.6c8.7-13.3 21.5-25 38.3-25s29.6 11.7 38.3 25c8.8 13.5 14.8 30.6 17.6 45.6c.8 4.3-2 8.5-6.4 9.3s-8.5-2-9.3-6.4c-2.5-13.5-7.8-28.4-15.2-39.8c-7.6-11.6-16.1-17.7-24.9-17.7s-17.3 6.1-24.9 17.7zm144.8 39.8c-.8 4.3-5 7.2-9.3 6.4s-7.2-5-6.4-9.3c2.8-15 8.7-32 17.6-45.6c8.7-13.3 21.5-25 38.3-25s29.6 11.7 38.3 25c8.8 13.5 14.8 30.6 17.6 45.6c.8 4.3-2 8.5-6.4 9.3s-8.5-2-9.3-6.4c-2.5-13.5-7.8-28.4-15.2-39.8c-7.6-11.6-16.1-17.7-24.9-17.7s-17.3 6.1-24.9 17.7c-7.4 11.4-12.7 26.3-15.2 39.8z'
      
    ]
  };

  
    var faLaughBeam = faFaceLaughBeam;
  

  
  

  var faBinBottles = {
    prefix: 'fat',
    iconName: 'bin-bottles',
    icon: [
      640,
      512,
      [],
      'e5f5',
      
      'M384 24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v8H496V24c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v8H384V24zM352 192H336c0-44.2-35.8-80-80-80H128c-44.2 0-80 35.8-80 80H32c0-53 43-96 96-96H256c53 0 96 43 96 96zm223.1 0H558.9c-1.1-6.5-3.5-12.6-6.9-17.9c-3.4-5.4-3.4-12.3 .2-17.6c4.7-7 7.4-15.3 7.4-24.4c0-17-9.8-32.5-25.2-39.7l-13.2-6.2c-8.9-4.1-18.5-6.3-28.3-6.3H402.3c-9.8 0-19.4 2.2-28.3 6.3l-13.2 6.2c-5.2 2.4-9.7 5.8-13.5 9.9c-3.7-3.8-7.7-7.4-11.9-10.7c5.2-5.6 11.5-10.3 18.6-13.6l13.1-6.2c11-5.1 23-7.8 35.1-7.8h90.6C505 64 517 66.7 528 71.8L541.2 78c21 9.9 34.5 31 34.5 54.2c0 12.3-3.7 23.8-10.1 33.3c5 7.8 8.4 16.9 9.6 26.5zM32 224H47.2h.9H591.9h.9H608h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H606.2L583.9 440.8c-4.5 40.5-38.7 71.2-79.5 71.2H135.6c-40.8 0-75-30.6-79.5-71.2L33.8 240H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H32zm558.1 16H49.9L72 439.1c3.6 32.4 31 56.9 63.6 56.9H504.4c32.6 0 60-24.5 63.6-56.9L590.1 240zM144 32V56c0 4.4-3.6 8-8 8H120c-4.4 0-8-3.6-8-8s3.6-8 8-8h8V32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V48h8c4.4 0 8 3.6 8 8s-3.6 8-8 8H248c-4.4 0-8-3.6-8-8V32c0-8.8-7.2-16-16-16H160c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faMarker = {
    prefix: 'fat',
    iconName: 'marker',
    icon: [
      512,
      512,
      [],
      'f5a1',
      
      'M469.7 42.3C440 12.7 392 12.7 362.3 42.3L192 212.7 299.3 320 469.7 149.7c29.6-29.6 29.6-77.7 0-107.3zM288 331.3L180.7 224l-69.8 69.8c-45.8 45.8-77 104.1-89.7 167.6l-5 25c-.5 2.6 .3 5.3 2.2 7.2s4.6 2.7 7.2 2.2l25-5c63.5-12.7 121.8-43.9 167.6-89.7L288 331.3zM351 31C386.9-4.8 445.1-4.8 481 31s35.9 94.1 0 129.9L229.5 412.5c-48 48-109.2 80.8-175.8 94.1l-25 5c-7.9 1.6-16-.9-21.7-6.6s-8.1-13.8-6.6-21.7l5-25c13.3-66.6 46.1-127.8 94.1-175.8L313.4 68.7 300.3 55.6c-15.6-15.6-40.9-15.6-56.6 0l-94.1 94.1c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l94.1-94.1c21.9-21.9 57.3-21.9 79.2 0l13.1 13.1L351 31z'
      
    ]
  };

  

  
  

  var faKazoo = {
    prefix: 'fat',
    iconName: 'kazoo',
    icon: [
      640,
      512,
      [],
      'f8c7',
      
      'M448 128a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272c23.8 0 46.3-5.8 66-16h94c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H514c-19.8-10.2-42.2-16-66-16s-46.3 5.8-66 16H224c-3 0-6 .4-9 1.3l-192 56C9.4 189.3 0 201.8 0 216v80c0 14.2 9.4 26.7 23 30.7l192 56c2.9 .8 5.9 1.3 9 1.3H382c19.8 10.2 42.2 16 66 16zm160-32H538.5c32.6-26.4 53.5-66.8 53.5-112s-20.9-85.6-53.5-112H608c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16zM224 144H357.5C324.9 170.4 304 210.8 304 256s20.9 85.6 53.5 112H224c-1.5 0-3-.2-4.5-.6l-192-56c-6.8-2-11.5-8.2-11.5-15.4V216c0-7.1 4.7-13.4 11.5-15.4l192-56c1.5-.4 3-.6 4.5-.6zm189.7 66.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L436.7 256l-34.3 34.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L448 267.3l34.3 34.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L459.3 256l34.3-34.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L448 244.7l-34.3-34.3z'
      
    ]
  };

  

  
  

  var faIdBadge = {
    prefix: 'fat',
    iconName: 'id-badge',
    icon: [
      384,
      512,
      [],
      'f2c1',
      
      'M64 16C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48H320c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM240 224a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-112 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm0-152c0-4.4 3.6-8 8-8H248c4.4 0 8 3.6 8 8s-3.6 8-8 8H136c-4.4 0-8-3.6-8-8zM96 392c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-39.8 32.2-72 72-72h80c39.8 0 72 32.2 72 72c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-30.9-25.1-56-56-56H152c-30.9 0-56 25.1-56 56z'
      
    ]
  };

  

  
  

  var faNeuter = {
    prefix: 'fat',
    iconName: 'neuter',
    icon: [
      384,
      512,
      [9906],
      'f22c',
      
      'M32 176a160 160 0 1 1 320 0A160 160 0 1 1 32 176zM200 351.8c93.5-4.2 168-81.3 168-175.8C368 78.8 289.2 0 192 0S16 78.8 16 176c0 94.5 74.5 171.6 168 175.8V504c0 4.4 3.6 8 8 8s8-3.6 8-8V351.8z'
      
    ]
  };

  

  
  

  var faPersonShelter = {
    prefix: 'fat',
    iconName: 'person-shelter',
    icon: [
      512,
      512,
      [],
      'e54f',
      
      'M260.2 1.2c-2.6-1.6-5.8-1.6-8.4 0l-248 152c-2.4 1.5-3.8 4-3.8 6.8V504c0 4.4 3.6 8 8 8s8-3.6 8-8V164.5L256 17.4 496 164.5V504c0 4.4 3.6 8 8 8s8-3.6 8-8V160c0-2.8-1.4-5.4-3.8-6.8l-248-152zM232 168a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm64 0a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM216 296c0-4.4-3.6-8-8-8s-8 3.6-8 8V480c0 17.7 14.3 32 32 32c9.6 0 18.1-4.2 24-10.8c5.9 6.6 14.4 10.8 24 10.8c17.7 0 32-14.3 32-32V296c0-4.4-3.6-8-8-8s-8 3.6-8 8V480c0 8.8-7.2 16-16 16s-16-7.2-16-16V384c0-4.4-3.6-8-8-8h0 0c-4.4 0-8 3.6-8 8v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V296zm-21.7-25.4c9.5-18.8 28.8-30.6 49.9-30.6h23.6c21.1 0 40.4 11.8 49.9 30.6l43.1 85c2 3.9 6.8 5.5 10.8 3.5s5.5-6.8 3.5-10.8l-43.1-85c-12.3-24.2-37.1-39.4-64.2-39.4H244.2c-27.1 0-51.9 15.2-64.2 39.4l-43.1 85c-2 3.9-.4 8.8 3.5 10.8s8.8 .4 10.8-3.5l43.1-85z'
      
    ]
  };

  

  
  

  var faIcicles = {
    prefix: 'fat',
    iconName: 'icicles',
    icon: [
      512,
      512,
      [],
      'f7ad',
      
      'M0 28.8C0 12.9 12.9 0 28.8 0H482c16.6 0 30 13.4 30 30c0 1.8-.2 3.7-.5 5.5l-87.6 470c-.7 3.8-4 6.5-7.9 6.5s-7.2-2.7-7.9-6.5L342.3 154.4 295.7 314.2c-1 3.4-4 5.7-7.5 5.8s-6.6-2.1-7.7-5.5l-39-117L199.8 377.8c-.8 3.6-4.1 6.2-7.8 6.2s-7-2.6-7.8-6.2L142.6 197.5l-39 117c-1.1 3.3-4.2 5.5-7.7 5.5s-6.5-2.3-7.6-5.6l-87-277C.4 34.6 0 31.7 0 28.8zM28.8 16C21.7 16 16 21.7 16 28.8c0 1.3 .2 2.6 .6 3.8L96.2 286l40.2-120.6c1.1-3.4 4.4-5.6 8-5.5s6.6 2.7 7.4 6.2L192 340.4l40.2-174.2c.8-3.5 3.8-6 7.4-6.2s6.8 2.1 8 5.5l39.9 119.7 48.8-167.4c1-3.6 4.4-5.9 8.1-5.8s6.8 2.9 7.5 6.5L416 460.5 495.8 32.5c.2-.8 .2-1.7 .2-2.6c0-7.7-6.3-14-14-14H28.8z'
      
    ]
  };

  

  
  

  var faCarWrench = {
    prefix: 'fat',
    iconName: 'car-wrench',
    icon: [
      512,
      512,
      ["car-mechanic"],
      'f5e3',
      
      'M134.8 113c-11.2 18.6-31.6 31-54.8 31c-23.7 0-44.4-12.8-55.4-32H59.2c6.3 0 12.5-1.9 17.8-5.4c19-12.7 19-40.6 0-53.3C71.6 49.9 65.5 48 59.2 48H24.6C35.6 28.8 56.3 16 80 16c23.2 0 43.6 12.4 54.8 31c5.6 9.2 15.9 17 29 17H348.2c13.1 0 23.4-7.8 29-17c11.2-18.6 31.6-31 54.8-31c23.7 0 44.4 12.8 55.4 32H452.8c-6.3 0-12.5 1.9-17.8 5.4c-19 12.7-19 40.6 0 53.3c5.3 3.5 11.4 5.4 17.8 5.4h34.6c-11.1 19.2-31.8 32-55.4 32c-23.2 0-43.6-12.4-54.8-31c-5.6-9.2-15.9-17-29-17H163.8c-13.1 0-23.4 7.8-29 17zm29-1H348.2c6.4 0 12 3.8 15.3 9.3c14 23.2 39.5 38.7 68.5 38.7c31.8 0 59.3-18.6 72.2-45.5c4.4-9.1-3.3-18.5-13.4-18.5h-38c-3.2 0-6.2-.9-8.9-2.7c-9.5-6.3-9.5-20.3 0-26.6c2.6-1.8 5.7-2.7 8.9-2.7h38c10.1 0 17.7-9.4 13.4-18.5C491.3 18.6 463.8 0 432 0c-29.1 0-54.5 15.5-68.5 38.7c-3.3 5.4-8.9 9.3-15.3 9.3H163.8c-6.4 0-12-3.8-15.3-9.3C134.5 15.5 109.1 0 80 0C48.2 0 20.7 18.6 7.8 45.5C3.4 54.6 11.1 64 21.2 64h38c3.2 0 6.2 .9 8.9 2.7C77.5 73 77.5 87 68 93.3c-2.6 1.8-5.7 2.7-8.9 2.7h-38c-10.1 0-17.7 9.4-13.4 18.5C20.7 141.4 48.2 160 80 160c29.1 0 54.5-15.5 68.5-38.7c3.3-5.4 8.9-9.3 15.3-9.3zm24.4 80H323.8c17.9 0 33.6 11.8 38.5 29l19.5 68.2c-4.5-.8-9-1.2-13.7-1.2H144c-4.7 0-9.3 .4-13.7 1.2L149.7 221c4.9-17.2 20.6-29 38.5-29zM112.3 293.8l-.2 .8C83.8 307 64 335.2 64 368v64 16 32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V448H368v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V448 432 368c0-32.8-19.8-61-48.1-73.4l-.2-.8-22.1-77.2c-6.9-24-28.8-40.6-53.8-40.6H188.2c-25 0-47 16.6-53.8 40.6l-22.1 77.2zM384 432H368 144 128 80V368c0-35.3 28.7-64 64-64H368c35.3 0 64 28.7 64 64v64H384zm0 48V448h48v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16zM128 448v32c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V448h48zm32-80a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm224 48a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z'
      
    ]
  };

  
    var faCarMechanic = faCarWrench;
  

  
  

  var faChopsticks = {
    prefix: 'fat',
    iconName: 'chopsticks',
    icon: [
      640,
      512,
      [],
      'e3f7',
      
      'M17.7 484.3L335.3 29.9C342 21.4 352.2 16 363.7 16C383.6 16 400 32.4 400 53c0 8.6-2.9 16.5-7.7 22.7L28.4 493l-.2 .2-.1 .2c-2.3 3-6.5 3.5-9.4 1.2c-3-2.4-3.5-6.8-1.2-9.9l0 0 .2-.3zM363.7 0c-16.7 0-31.6 8-41.2 20.3l0 0-.2 .3L4.7 475c-7.5 9.9-5.8 24.2 4 32c9.9 7.9 24.1 6.2 31.9-3.7l364-417.3 .2-.2 .1-.2c7-9 11.1-20.4 11.1-32.7c0-29.2-23.3-53-52.3-53zM146.7 483.7l416.3-395c6.5-5.4 14.8-8.7 23.9-8.7c20.5 0 37 16.4 37 36.6c0 11-4.9 20.9-12.8 27.6L155.9 494.1l0 0-.3 .3c-3 2.5-7.4 2.2-9.9-.7c-2.5-2.9-2.2-7.1 .8-9.6l0 0 .3-.3zM587 64c-13.1 0-25.2 4.8-34.5 12.6l0 0-.3 .3-416.3 395c-9.5 8.2-10.6 22.6-2.3 32.1c8.2 9.5 22.6 10.6 32.2 2.6L621.2 156.8l0 0 .3-.3c11.3-9.6 18.5-23.9 18.5-39.9C640 87.5 616.2 64 587 64z'
      
    ]
  };

  

  
  

  var faCalendarCircleMinus = {
    prefix: 'fat',
    iconName: 'calendar-circle-minus',
    icon: [
      576,
      512,
      [],
      'e46f',
      
      'M128 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H64C28.7 64 0 92.7 0 128v48 16V448c0 35.3 28.7 64 64 64H330.8c-6.9-4.9-13.5-10.2-19.6-16H64c-26.5 0-48-21.5-48-48V192H352h80 16V176 128c0-35.3-28.7-64-64-64H336V8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H128V8zM112 80v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80H320v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80h48c26.5 0 48 21.5 48 48v48H16V128c0-26.5 21.5-48 48-48h48zM432 240a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm80-144c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8s3.6 8 8 8H504c4.4 0 8-3.6 8-8z'
      
    ]
  };

  

  
  

  var faPlateWheat = {
    prefix: 'fat',
    iconName: 'plate-wheat',
    icon: [
      512,
      512,
      [],
      'e55a',
      
      'M240 112v24c-35.3 0-64-28.7-64-64V48c35.3 0 64 28.7 64 64zM160 48V72c0 44.2 35.8 80 80 80c8.8 0 16-7.2 16-16V112c0-44.2-35.8-80-80-80c-8.8 0-16 7.2-16 16zm192 64v24c-35.3 0-64-28.7-64-64V48c35.3 0 64 28.7 64 64zM272 48V72c0 44.2 35.8 80 80 80c8.8 0 16-7.2 16-16V112c0-44.2-35.8-80-80-80c-8.8 0-16 7.2-16 16zm192 88c-35.3 0-64-28.7-64-64V48c35.3 0 64 28.7 64 64v24zM400 32c-8.8 0-16 7.2-16 16V72c0 44.2 35.8 80 80 80c8.8 0 16-7.2 16-16V112c0-44.2-35.8-80-80-80zM288 248c0-35.3 28.7-64 64-64v24c0 35.3-28.7 64-64 64V248zm80-64c0-8.8-7.2-16-16-16c-44.2 0-80 35.8-80 80v24c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80V184zM176 272V248c0-35.3 28.7-64 64-64v24c0 35.3-28.7 64-64 64zm64-104c-44.2 0-80 35.8-80 80v24c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80V184c0-8.8-7.2-16-16-16zm160 80c0-35.3 28.7-64 64-64v24c0 35.3-28.7 64-64 64V248zm80-64c0-8.8-7.2-16-16-16c-44.2 0-80 35.8-80 80v24c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80V184zM0 160c0 4.4 3.6 8 8 8H152c4.4 0 8-3.6 8-8s-3.6-8-8-8H8c-4.4 0-8 3.6-8 8zM40 80c-4.4 0-8 3.6-8 8s3.6 8 8 8h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H40zM32 232c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H40c-4.4 0-8 3.6-8 8zm81.8 210.6c-2.2-6.2-7.9-10.4-14.5-10.7C53 430.3 16 392.3 16 345.6c0-5.3 4.3-9.6 9.6-9.6H144 368 486.4c5.3 0 9.6 4.3 9.6 9.6c0 46.7-37 84.7-83.3 86.3c-6.6 .2-12.3 4.5-14.5 10.7C393.8 455.1 381.9 464 368 464H144c-13.9 0-25.8-8.9-30.2-21.4zM25.6 320C11.5 320 0 331.5 0 345.6C0 400.9 43.9 446 98.7 447.9c6.6 18.7 24.4 32.1 45.3 32.1H368c20.9 0 38.7-13.4 45.3-32.1c54.8-1.9 98.7-47 98.7-102.3c0-14.1-11.5-25.6-25.6-25.6H368 144 25.6z'
      
    ]
  };

  

  
  

  var faCompassDrafting = {
    prefix: 'fat',
    iconName: 'compass-drafting',
    icon: [
      512,
      512,
      ["drafting-compass"],
      'f568',
      
      'M320 80A64 64 0 1 0 192 80a64 64 0 1 0 128 0zm-22.7 68.5C285.3 155.8 271.1 160 256 160s-29.3-4.2-41.3-11.5l-88.9 160c37.4 22.6 81.2 35.5 128 35.5c91.8 0 171.9-49.9 214.8-124c2.2-3.8 7.1-5.1 10.9-2.9s5.1 7.1 2.9 10.9c-45.6 78.9-130.9 132-228.7 132c-49.6 0-96.1-13.7-135.8-37.5L15 507.9c-2.1 3.9-7 5.3-10.9 3.1s-5.3-7-3.1-10.9L104.5 313.8C72.1 291.5 44.8 262.2 25.1 228c-2.2-3.8-.9-8.7 2.9-10.9s8.7-.9 10.9 2.9c18.3 31.7 43.5 58.9 73.4 79.8L201 140.1l.7-1.3C185.9 124.2 176 103.2 176 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 23.2-9.9 44.2-25.7 58.8l.7 1.3 62.2 112c2.1 3.9 .8 8.7-3.1 10.9s-8.7 .8-10.9-3.1L297.4 148.5zM421.5 371.9c-2.1-3.9-.8-8.7 3.1-10.9s8.7-.8 10.9 3.1l75.6 136c2.1 3.9 .8 8.7-3.1 10.9s-8.7 .8-10.9-3.1l-75.6-136z'
      
    ]
  };

  
    var faDraftingCompass = faCompassDrafting;
  

  
  

  var faArrowUpToBracket = {
    prefix: 'fat',
    iconName: 'arrow-up-to-bracket',
    icon: [
      448,
      512,
      [],
      'e66a',
      
      'M365.7 298.3l-136-136c-3.1-3.1-8.2-3.1-11.3 0l-136 136c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L216 187.3 216 504c0 4.4 3.6 8 8 8s8-3.6 8-8l0-316.7L354.3 309.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3zM16 184l0-96c0-39.8 32.2-72 72-72l272 0c39.8 0 72 32.2 72 72l0 96c0 4.4 3.6 8 8 8s8-3.6 8-8l0-96c0-48.6-39.4-88-88-88L88 0C39.4 0 0 39.4 0 88l0 96c0 4.4 3.6 8 8 8s8-3.6 8-8z'
      
    ]
  };

  

  
  

  var faPhoneRotary = {
    prefix: 'fat',
    iconName: 'phone-rotary',
    icon: [
      512,
      512,
      [9742],
      'f8d3',
      
      'M256 48c124.8 0 209 60.9 235.8 83.4l7.9-9.4-7.9 9.4c2.5 2.1 4.2 5.5 4.2 9.8V192c0 8.8-7.2 16-16 16H437.7c-6.5 0-12.4-4-14.9-10.1l-19.4-48.6c-4.3-10.8-12.8-20.5-25-25c-20-7.5-62.8-20.3-122.4-20.3s-102.4 12.8-122.4 20.3c-12.1 4.6-20.6 14.2-25 25L89.2 197.9C86.8 204 80.9 208 74.3 208H32c-8.8 0-16-7.2-16-16V141.3c0-4.3 1.7-7.8 4.2-9.8C47 108.9 131.2 48 256 48zM0 192c0 17.7 14.3 32 32 32H74.3c13.1 0 24.9-8 29.7-20.1l19.4-48.6c2.9-7.3 8.4-13.2 15.7-16c18.6-7 59.5-19.3 116.8-19.3s98.2 12.3 116.8 19.3c7.3 2.8 12.8 8.7 15.7 16L408 203.9c4.9 12.1 16.6 20.1 29.7 20.1H480c17.7 0 32-14.3 32-32V141.3c0-8.5-3.4-16.6-9.9-22.1C473.8 95.4 386.1 32 256 32S38.2 95.4 9.9 119.2C3.4 124.6 0 132.8 0 141.3V192zM48 401c0-8.4 2.2-16.6 6.3-23.8l101.1-177c8.5-15 24.5-24.2 41.7-24.2H314.9c17.2 0 33.1 9.2 41.7 24.2l101.1 177c4.1 7.3 6.3 15.5 6.3 23.8v31c0 17.7-14.3 32-32 32H80c-17.7 0-32-14.3-32-32V401zm-16 0v31c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V401c0-11.1-2.9-22.1-8.4-31.8l-101.1-177C359 172.3 337.8 160 314.9 160H197.1c-23 0-44.2 12.3-55.6 32.2L40.4 369.2C34.9 378.9 32 389.9 32 401zm224-33a56 56 0 1 1 0-112 56 56 0 1 1 0 112zm-72-56a72 72 0 1 0 144 0 72 72 0 1 0 -144 0z'
      
    ]
  };

  

  
  

  var faHeadSideHeadphones = {
    prefix: 'fat',
    iconName: 'head-side-headphones',
    icon: [
      512,
      512,
      [],
      'f8c2',
      
      'M168 23.4v80c12.4-4.8 25.9-7.4 40-7.4s27.6 2.6 40 7.4V16.2c-2.7-.1-5.5-.2-8.3-.2H222.9c-19 0-37.4 2.6-54.9 7.4zm-16 5.1C72.7 57.4 16 133.6 16 222.9c0 49.4 15.8 94.6 43.9 130C71.5 367.5 80 385.5 80 405.3V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V405.3c0-15.1-6.5-29.8-16.6-42.5C16.9 324.5 0 275.8 0 222.9C0 99.8 99.8 0 222.9 0h16.8c77.9 0 149.4 46.9 180.9 114.2c3.8 8 7.3 16 10.8 23.9c6.2 13.9 12.3 27.6 19.3 41c10.8 20.7 23.3 39.5 40 54.4l3.8 3.4c11.1 9.9 17.5 24.1 17.5 39c0 28.8-23.4 52.2-52.2 52.2H448v64c0 30.9-25.1 56-56 56H320v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V440c0-4.4 3.6-8 8-8h80c22.1 0 40-17.9 40-40V320c0-4.4 3.6-8 8-8h19.8c20 0 36.2-16.2 36.2-36.2c0-10.3-4.4-20.2-12.1-27l-3.8-3.4c-18.8-16.7-32.3-37.3-43.5-58.9c-7.2-13.8-13.7-28.4-20.1-42.7c-3.5-7.8-6.9-15.5-10.4-22.9C380.5 66.3 325.9 26.1 264 17.6V111c33.5 19.4 56 55.6 56 97c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-41.5 22.5-77.7 56-97V28.5zM304 208a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm-96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  

  
  

  var faCircleStop = {
    prefix: 'fat',
    iconName: 'circle-stop',
    icon: [
      512,
      512,
      [62094,"stop-circle"],
      'f28d',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176-64V320c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16H192c-8.8 0-16 7.2-16 16zm-16 0c0-17.7 14.3-32 32-32H320c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192z'
      
    ]
  };

  
    var faStopCircle = faCircleStop;
  

  
  

  var faBat = {
    prefix: 'fat',
    iconName: 'bat',
    icon: [
      576,
      512,
      [],
      'f6b5',
      
      'M372.2 166.1c4.4 2.3 9.6 2.3 14.1 .2l73.2-34.8c9.6-4.6 21.1-2.1 28.1 5.9c46.7 54.5 72.4 124 72.4 195.8v40.9l-59.6-29.8c-15-7.5-33.1-2.2-41.8 12.2l-29.8 49.7-36.6-36.6c-13.7-13.7-36.2-12.2-48 3.1L288 445.8l-56.2-73.1c-11.8-15.3-34.3-16.8-48-3.1l-36.6 36.6-29.8-49.7c-8.6-14.3-26.8-19.6-41.8-12.2L16 374.1V333.2c0-71.8 25.7-141.3 72.4-195.8c6.9-8.1 18.4-10.5 28.1-5.9l73.2 34.8c4.5 2.1 9.7 2.1 14.1-.2s7.6-6.4 8.5-11.3L229 65.3l35.4 23.6c7 4.6 15.2 7.1 23.5 7.1s16.6-2.5 23.5-7.1L347 65.3l16.8 89.6c.9 4.9 4 9.1 8.5 11.3zM181.6 144.8L123.4 117c-16.2-7.7-35.5-3.6-47.1 10C27.1 184.4 0 257.6 0 333.2v44.7c0 10.2 10.7 16.8 19.8 12.2l63-31.5c7.5-3.7 16.6-1.1 20.9 6.1l29.8 49.7c5.4 8.9 17.7 10.4 25 3.1l36.6-36.6c6.8-6.8 18.1-6.1 24 1.6l56.2 73.1c6.4 8.3 19 8.3 25.4 0l56.2-73.1c5.9-7.7 17.2-8.4 24-1.6l36.6 36.6c7.4 7.4 19.7 5.8 25-3.1l29.8-49.7c4.3-7.2 13.4-9.8 20.9-6.1l63 31.5c9.1 4.5 19.8-2.1 19.8-12.2V333.2c0-75.6-27.1-148.8-76.3-206.2c-11.6-13.6-30.9-17.7-47.1-10l-58.2 27.7-14.9 7.1-3-16.3L362.2 59.5c-1.3-6.7-7.1-11.5-13.9-11.5c-2.8 0-5.5 .8-7.8 2.4L302.7 75.6c-4.3 2.9-9.4 4.4-14.7 4.4s-10.3-1.5-14.7-4.4L235.6 50.4c-2.3-1.5-5-2.4-7.8-2.4c-6.8 0-12.6 4.8-13.9 11.5l-14.3 76.1-3.1 16.3-14.9-7.1z'
      
    ]
  };

  

  
  

  var faMoneySimpleFromBracket = {
    prefix: 'fat',
    iconName: 'money-simple-from-bracket',
    icon: [
      640,
      512,
      [],
      'e313',
      
      'M72 16C41.1 16 16 41.1 16 72v80c0 4.4-3.6 8-8 8s-8-3.6-8-8V72C0 32.2 32.2 0 72 0H568c39.8 0 72 32.2 72 72v80c0 4.4-3.6 8-8 8s-8-3.6-8-8V72c0-30.9-25.1-56-56-56H72zM504 80c4.4 0 8 3.6 8 8l0 376c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48l0-376c0-4.4 3.6-8 8-8s8 3.6 8 8l0 376c0 17.7 14.3 32 32 32H464c17.7 0 32-14.3 32-32l0-376c0-4.4 3.6-8 8-8zM320 200c-50 0-88 33.5-88 72s38 72 88 72s88-33.5 88-72s-38-72-88-72zm104 72c0 49.9-48 88-104 88s-104-38.1-104-88s48-88 104-88s104 38.1 104 88z'
      
    ]
  };

  

  
  

  var faHandHoldingCircleDollar = {
    prefix: 'fat',
    iconName: 'hand-holding-circle-dollar',
    icon: [
      576,
      512,
      [],
      'e621',
      
      'M272 16a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272A144 144 0 1 0 272 0a144 144 0 1 0 0 288zM243.8 93.9c8.3-4.2 19.3-6 28.1-5.8c11.2 .2 22.8 2.3 34.3 5c4.3 1 8.6-1.6 9.6-5.9s-1.6-8.6-5.9-9.6c-9.4-2.2-19.6-4.2-29.8-5V56c0-4.4-3.6-8-8-8s-8 3.6-8 8V72.3c-8.9 .7-18.9 2.9-27.4 7.3C225.1 85.4 215 96 216.1 112.5c.9 13.4 10.1 21.5 20.2 26.7c9.4 4.8 21.4 8 32.3 11l1.8 .5c12 3.2 22.7 6.2 30.5 10.6c7.5 4.2 10.9 8.8 11.1 14.9c.3 8.7-4.2 14.3-11.7 18.3c-7.9 4.1-18.7 5.7-28 5.5c-13.1-.4-25.6-4.2-39.2-8.3l0 0 0 0c-2.2-.7-4.4-1.3-6.7-2c-4.2-1.3-8.7 1.2-9.9 5.4s1.2 8.7 5.4 9.9c2.1 .6 4.2 1.3 6.3 1.9l0 0c11.2 3.4 23.3 7.1 35.9 8.5v18.1c0 4.4 3.6 8 8 8s8-3.6 8-8V215.8c9.2-.6 19.1-2.7 27.6-7.1c11.5-5.9 20.9-16.6 20.4-33c-.4-13.9-9-22.7-19.2-28.4c-9.9-5.5-22.6-9-34.1-12.1l-1-.3c-11.7-3.1-22.1-6-30-10c-7.9-4.1-11.2-8.3-11.5-13.5c-.5-8 3.7-13.5 11.7-17.6zM521.8 340.7c10.7-7.9 25.7-5.6 33.6 5.1s5.6 25.7-5.1 33.6L423.6 472.6C403 487.8 378.1 496 352.5 496H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L394.7 414.4c-1.4 1-3 1.6-4.7 1.6H268c-6.6 0-12-5.4-12-12s5.4-12 12-12h80c19.9 0 36-16.1 36-36s-16.1-36-36-36H193.7c-29.1 0-57.3 9.9-80 28L71 382.2c-1.4 1.1-3.2 1.8-5 1.8H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H66c5.4 0 10.7-1.9 15-5.3l42.7-34.2c19.9-15.9 44.5-24.5 70-24.5H348c11 0 20 9 20 20s-9 20-20 20H268c-15.5 0-28 12.5-28 28s12.5 28 28 28H389.9c5.1 0 10.1-1.6 14.2-4.7l117.6-86.6z'
      
    ]
  };

  

  
  

  var faSquareDashedCirclePlus = {
    prefix: 'fat',
    iconName: 'square-dashed-circle-plus',
    icon: [
      576,
      512,
      [],
      'e5c2',
      
      'M120 32c4.4 0 8 3.6 8 8s-3.6 8-8 8H88c-39.8 0-72 32.2-72 72v32c0 4.4-3.6 8-8 8s-8-3.6-8-8V120C0 71.4 39.4 32 88 32h32zM0 312V200c0-4.4 3.6-8 8-8s8 3.6 8 8V312c0 4.4-3.6 8-8 8s-8-3.6-8-8zm8 40c4.4 0 8 3.6 8 8v32c0 39.8 32.2 72 72 72h32c4.4 0 8 3.6 8 8s-3.6 8-8 8H88c-48.6 0-88-39.4-88-88V360c0-4.4 3.6-8 8-8zM439.7 192.2c-4.2-.2-7.7-3.6-7.7-7.8V120c0-39.8-32.2-72-72-72H328c-4.4 0-8-3.6-8-8s3.6-8 8-8h32c48.6 0 88 39.4 88 88v64.3c0 4.5-3.8 8-8.3 7.8zm-153 275.1c.9 1.2 1.3 2.7 1.3 4.2v.3c0 4.5-3.7 8.2-8.2 8.2H168c-4.4 0-8-3.6-8-8s3.6-8 8-8H280.5c2.5 0 4.8 1.3 6.2 3.3zM280 48H168c-4.4 0-8-3.6-8-8s3.6-8 8-8H280c4.4 0 8 3.6 8 8s-3.6 8-8 8zM560 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm152-72v64h64c4.4 0 8 3.6 8 8s-3.6 8-8 8H440v64c0 4.4-3.6 8-8 8s-8-3.6-8-8V376H360c-4.4 0-8-3.6-8-8s3.6-8 8-8h64V296c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faCircleCheck = {
    prefix: 'fat',
    iconName: 'circle-check',
    icon: [
      512,
      512,
      [61533,"check-circle"],
      'f058',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM357.7 197.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L224 308.7l-58.3-58.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l64 64c3.1 3.1 8.2 3.1 11.3 0l128-128z'
      
    ]
  };

  
    var faCheckCircle = faCircleCheck;
  

  
  

  var faChair = {
    prefix: 'fat',
    iconName: 'chair',
    icon: [
      448,
      512,
      [129681],
      'f6c0',
      
      'M232 16V256H216V16H192c-11.1 0-21.9 1.6-32 4.6V256H144V26.8C106.2 44.8 80 83.3 80 128V256H64V128C64 57.3 121.3 0 192 0h64c70.7 0 128 57.3 128 128V256H368V128c0-44.7-26.2-83.2-64-101.2V256H288V20.6c-10.1-3-20.9-4.6-32-4.6H232zM33.7 312.8l-16 32c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6H416c5.5 0 10.7-2.9 13.6-7.6s3.2-10.6 .7-15.6l-16-32c-2.7-5.4-8.2-8.8-14.3-8.8H48c-6.1 0-11.6 3.4-14.3 8.8zm-14.3-7.2C24.8 294.8 35.9 288 48 288H400c12.1 0 23.2 6.8 28.6 17.7l16 32c5 9.9 4.4 21.7-1.4 31.1s-16.1 15.2-27.2 15.2H400V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V384H64V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V384H32c-11.1 0-21.4-5.7-27.2-15.2s-6.4-21.2-1.4-31.1l16-32z'
      
    ]
  };

  

  
  

  var faEuroSign = {
    prefix: 'fat',
    iconName: 'euro-sign',
    icon: [
      320,
      512,
      [8364,"eur","euro"],
      'f153',
      
      'M35.7 208c-2.4 13-3.7 26.3-3.7 40v16c0 13.7 1.3 27 3.7 40H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H39.3C64 412.1 148.1 480 248 480h65c4.4 0 8-3.6 8-8s-3.6-8-8-8H248c-91 0-167.8-60.8-192.1-144H280c4.4 0 8-3.6 8-8s-3.6-8-8-8H52c-2.6-12.9-4-26.3-4-40V248c0-13.7 1.4-27.1 4-40H280c4.4 0 8-3.6 8-8s-3.6-8-8-8H55.9C80.2 108.8 157 48 248 48h65c4.4 0 8-3.6 8-8s-3.6-8-8-8H248C148.1 32 64 99.9 39.3 192H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H35.7z'
      
    ]
  };

  
    var faEur = faEuroSign;
  
    var faEuro = faEuroSign;
  

  
  

  var faEthernet = {
    prefix: 'fat',
    iconName: 'ethernet',
    icon: [
      512,
      512,
      [],
      'f796',
      
      'M128 96c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32v32h32c17.7 0 32 14.3 32 32v32h32c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H400 304 208 112 32c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32H64V160c0-17.7 14.3-32 32-32h32V96zm32-16c-8.8 0-16 7.2-16 16v40c0 4.4-3.6 8-8 8H96c-8.8 0-16 7.2-16 16v40c0 4.4-3.6 8-8 8H32c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16h72V328c0-4.4 3.6-8 8-8s8 3.6 8 8V432h80V328c0-4.4 3.6-8 8-8s8 3.6 8 8V432h80V328c0-4.4 3.6-8 8-8s8 3.6 8 8V432h80V328c0-4.4 3.6-8 8-8s8 3.6 8 8V432h72c8.8 0 16-7.2 16-16V224c0-8.8-7.2-16-16-16H440c-4.4 0-8-3.6-8-8V160c0-8.8-7.2-16-16-16H376c-4.4 0-8-3.6-8-8V96c0-8.8-7.2-16-16-16H160z'
      
    ]
  };

  

  
  

  var fa360Degrees = {
    prefix: 'fat',
    iconName: '360-degrees',
    icon: [
      640,
      512,
      [],
      'e2dc',
      
      'M592 32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM8 64c-4.4 0-8 3.6-8 8s3.6 8 8 8H142.9L33.9 210.9c-2 2.4-2.4 5.7-1.1 8.5s4.1 4.6 7.2 4.6H72c57.4 0 104 46.6 104 104v19.4c0 46.7-37.9 84.6-84.6 84.6c-25.1 0-48.9-11.2-65-30.4L14.1 386.9c-2.8-3.4-7.9-3.9-11.3-1s-3.9 7.9-1 11.3l12.2 14.7C33.2 434.7 61.5 448 91.4 448C147 448 192 403 192 347.4V328c0-66.3-53.7-120-120-120H57.1L166.1 77.1c2-2.4 2.4-5.7 1.1-8.5s-4.1-4.6-7.2-4.6H8zm424 80c0-35.3 28.7-64 64-64s64 28.7 64 64V368c0 35.3-28.7 64-64 64s-64-28.7-64-64V144zM576 368V144c0-44.2-35.8-80-80-80s-80 35.8-80 80V368c0 44.2 35.8 80 80 80s80-35.8 80-80zM344 80c4.4 0 8-3.6 8-8s-3.6-8-8-8c-66.3 0-120 53.7-120 120V288c0 0 0 .1 0 .1V368c0 44.2 35.8 80 80 80s80-35.8 80-80V288c0-44.2-35.8-80-80-80c-26.2 0-49.4 12.6-64 32V184c0-57.4 46.6-104 104-104zM240 288c0-35.3 28.7-64 64-64s64 28.7 64 64v80c0 35.3-28.7 64-64 64s-64-28.7-64-64V288z'
      
    ]
  };

  

  
  

  var faTablets = {
    prefix: 'fat',
    iconName: 'tablets',
    icon: [
      640,
      512,
      [],
      'f490',
      
      'M576 267.3L372.7 64C349.9 89.5 336 123.1 336 160c0 79.5 64.5 144 144 144c36.9 0 70.5-13.9 96-36.7zM587.3 256c22.8-25.5 36.7-59.1 36.7-96c0-79.5-64.5-144-144-144c-36.9 0-70.5 13.9-96 36.7L587.3 256zM320 160a160 160 0 1 1 320 0 160 160 0 1 1 -320 0zM303.8 360H16.2C20.4 435.8 83.2 496 160 496s139.6-60.2 143.8-136zm0-16c-4.2-75.8-66.9-136-143.8-136S20.4 268.2 16.2 344H303.8zM160 192a160 160 0 1 1 0 320 160 160 0 1 1 0-320z'
      
    ]
  };

  

  
  

  var faLocationArrowUp = {
    prefix: 'fat',
    iconName: 'location-arrow-up',
    icon: [
      448,
      512,
      [],
      'e63a',
      
      'M224 48c-6.5 0-12.3 3.9-14.8 9.8L49.5 438.2c-1 2.3-1.5 4.7-1.5 7.2v2.9c0 8.7 7.1 15.8 15.8 15.8c3.5 0 7-1.2 9.8-3.4L219 345.7c2.9-2.3 7-2.3 9.9 0L374.5 460.6c2.8 2.2 6.2 3.4 9.8 3.4c8.7 0 15.8-7.1 15.8-15.8v-2.9c0-2.5-.5-4.9-1.5-7.2L238.8 57.8c-2.5-6-8.3-9.8-14.8-9.8zm-29.6 3.7C199.4 39.7 211.1 32 224 32s24.6 7.7 29.6 19.7L413.3 432c1.8 4.2 2.7 8.8 2.7 13.4v2.9c0 17.5-14.2 31.8-31.8 31.8c-7.1 0-14.1-2.4-19.7-6.8L224 362.2 83.4 473.2c-5.6 4.4-12.5 6.8-19.7 6.8C46.2 480 32 465.8 32 448.2v-2.9c0-4.6 .9-9.2 2.7-13.4L194.4 51.7z'
      
    ]
  };

  

  
  

  var faArrowUpRightAndArrowDownLeftFromCenter = {
    prefix: 'fat',
    iconName: 'arrow-up-right-and-arrow-down-left-from-center',
    icon: [
      512,
      512,
      [],
      'e0a0',
      
      'M290.3 210.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L496 27.3V168c0 4.4 3.6 8 8 8s8-3.6 8-8V8c0-4.4-3.6-8-8-8H344c-4.4 0-8 3.6-8 8s3.6 8 8 8H484.7L290.3 210.3zm-68.7 91.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L16 484.7V344c0-4.4-3.6-8-8-8s-8 3.6-8 8V504c0 4.4 3.6 8 8 8H168c4.4 0 8-3.6 8-8s-3.6-8-8-8H27.3L221.7 301.7z'
      
    ]
  };

  

  
  

  var faCirclePlay = {
    prefix: 'fat',
    iconName: 'circle-play',
    icon: [
      512,
      512,
      [61469,"play-circle"],
      'f144',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM196.1 161c2.5-1.4 5.6-1.4 8.1 .2l144 88c2.4 1.5 3.8 4 3.8 6.8s-1.4 5.4-3.8 6.8l-144 88c-2.5 1.5-5.6 1.6-8.1 .2s-4.1-4.1-4.1-7V168c0-2.9 1.6-5.6 4.1-7zm16.4-13.5c-7.4-4.5-16.7-4.7-24.3-.5s-12.3 12.3-12.3 20.9V344c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88z'
      
    ]
  };

  
    var faPlayCircle = faCirclePlay;
  

  
  

  var faCannabis = {
    prefix: 'fat',
    iconName: 'cannabis',
    icon: [
      512,
      512,
      [],
      'f55f',
      
      'M262.6 3.6c-1.5-2.2-4-3.6-6.6-3.6s-5.2 1.3-6.6 3.6c-14.2 21.2-34.1 60.7-48.7 105.6c-12.3 38-20.9 80.6-18.5 119.8c-53.8-43-126.5-66.2-164.6-73.8c-2.6-.5-5.3 .3-7.2 2.2s-2.7 4.6-2.2 7.2c7.7 38.1 31.1 110.9 74.4 164.5c-25.8 9.5-49 22.6-64.2 31.2c-2.3 1.3-4.4 2.5-6.3 3.5c-2.5 1.4-4.1 4.1-4.1 7s1.6 5.6 4.1 7c14.5 8.1 42.2 23.1 73.3 33.7c25.4 8.7 54.3 14.7 80.4 10.5l-18.2 47.1c-1.2 3-.4 6.5 2 8.7s5.9 2.8 8.8 1.4l89.6-41V504c0 4.4 3.6 8 8 8s8-3.6 8-8V438.3l89.6 41c3 1.4 6.4 .8 8.8-1.4s3.2-5.7 2-8.7L346.3 422c26 4.2 54.9-1.8 80.4-10.5c31-10.6 58.7-25.6 73.3-33.7c2.5-1.4 4.1-4.1 4.1-7s-1.6-5.6-4.1-7c-15.3-8.5-42.6-22.6-73.3-31.3c45.2-53.9 69.4-129 77.2-167.9c.5-2.6-.3-5.3-2.2-7.2s-4.6-2.7-7.2-2.2C456.4 162.8 383.6 186 329.8 229c2.4-39.2-6.3-81.8-18.5-119.8C296.8 64.3 276.8 24.8 262.6 3.6zM264 420.7V328c0-4.4-3.6-8-8-8s-8 3.6-8 8v92.7l-78.4 35.9 16.7-43.2c1.1-2.9 .4-6.2-1.7-8.5s-5.5-3-8.4-1.9c-24.4 8.7-55.6 3.6-85.5-6.6c-22.3-7.6-43-17.7-58-25.6c17.2-9.6 40.9-22.3 66.1-30.2c2.6-.8 4.6-2.9 5.3-5.5s.1-5.4-1.7-7.5C61 281.3 36.6 214.7 26.6 173.6c43.1 10.5 113.9 36.4 160.4 80.8c2.5 2.4 6.3 2.9 9.3 1.3s4.7-5 4.1-8.4c-7.2-40.8 1.4-89.2 15.6-133.1c11.9-36.9 27.5-69.7 40.1-91c12.6 21.3 28.2 54.2 40.1 91c14.2 43.8 22.7 92.3 15.6 133.1c-.6 3.4 1.1 6.8 4.1 8.4s6.8 1.1 9.3-1.3c46.5-44.4 117.3-70.3 160.4-80.8c-10.4 42.4-35.9 111.6-79.4 158c-2 2.1-2.7 5.1-1.8 7.8s3.1 4.8 5.9 5.5c26.2 5.9 51.2 16.9 69 26c-15 7.9-35.5 17.9-57.7 25.5c-29.9 10.2-61.2 15.3-85.5 6.6c-2.9-1.1-6.2-.3-8.4 1.9s-2.9 5.5-1.7 8.5l16.7 43.2L264 420.7z'
      
    ]
  };

  

  
  

  var faTruckRampCouch = {
    prefix: 'fat',
    iconName: 'truck-ramp-couch',
    icon: [
      640,
      512,
      ["truck-couch"],
      'f4dd',
      
      'M352 72c0-39.8 32.2-72 72-72H632c4.4 0 8 3.6 8 8s-3.6 8-8 8H424c-30.9 0-56 25.1-56 56V392.5l50.1-14.4C428.3 326.8 473.6 288 528 288c61.9 0 112 50.1 112 112s-50.1 112-112 112s-112-50.1-112-112c0-1.5 0-3.1 .1-4.6L10.2 511.7c-4.2 1.2-8.7-1.2-9.9-5.5s1.2-8.7 5.5-9.9L352 397.1V72zM624 400a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM318.4 194.5l1.6 6v19.4c-2.6 .1-5.3 .4-8 1.2c-18.2 4.9-29 23.6-24.2 41.8l2.3 8.5c2.3 8.5-2.8 17.3-11.3 19.6L112.9 335.4c-8.5 2.3-17.3-2.8-19.6-11.3l-2.8-10.6c-4.6-17.1-22.1-27.2-39.2-22.6S24.2 313 28.7 330l15.5 58c3.4 12.8 16.6 20.4 29.4 17l24.8-6.6c.9-.2 1.7-.4 2.6-.5l192.6-51.6c.5-.1 1-.3 1.6-.3l24.8-6.7v16.6l-6.8 1.8-15.5 4.1 0-.1-15.5 4.1-164.2 44L102.6 414l-.1-.2L87.1 418l-9.3 2.5c-21.3 5.7-43.3-6.9-49-28.3l-15.5-58c-5.4-20 2.8-40.5 18.8-51.8l-2.8-10.5C16.7 225 44.6 176.7 91.5 164.1l119.1-31.9c46.9-12.6 95.2 15.3 107.8 62.2zM214.8 147.7L95.7 179.6c-38.4 10.3-61.2 49.8-50.9 88.2l2.1 7.7 .4-.1c25.6-6.9 51.9 8.3 58.8 33.9l2.8 10.6 15.5-4.1 134.9-36.2 15.5-4.1-2.3-8.5c-6.9-25.8 7.6-52.3 32.7-60.6l-2.1-7.8c-10.3-38.4-49.8-61.2-88.2-50.9z'
      
    ]
  };

  
    var faTruckCouch = faTruckRampCouch;
  

  
  

  var faAnglesRight = {
    prefix: 'fat',
    iconName: 'angles-right',
    icon: [
      512,
      512,
      [187,"angle-double-right"],
      'f101',
      
      'M93.7 437.7l176-176c3.1-3.1 3.1-8.2 0-11.3l-176-176c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L252.7 256 82.3 426.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0zm192 0l176-176c3.1-3.1 3.1-8.2 0-11.3l-176-176c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L444.7 256 274.3 426.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0z'
      
    ]
  };

  
    var faAngleDoubleRight = faAnglesRight;
  

  
  

  var faSnowplow = {
    prefix: 'fat',
    iconName: 'snowplow',
    icon: [
      640,
      512,
      [],
      'f7d2',
      
      'M152 16c-4.4 0-8 3.6-8 8v80c0 4.4-3.6 8-8 8s-8-3.6-8-8V24c0-13.3 10.7-24 24-24H300.6c14.9 0 28.6 8.3 35.5 21.5l87 166.8c2 3.9 .5 8.7-3.4 10.8s-8.7 .5-10.8-3.4l-87-166.8C317.7 21 309.5 16 300.6 16H152zM637.2 129.9c3.4 2.9 3.8 7.9 .9 11.3L552 242.9V397.1l86.1 101.8c2.9 3.4 2.4 8.4-.9 11.3s-8.4 2.4-11.3-.9l-88-104c-1.2-1.4-1.9-3.3-1.9-5.2V320H446.4c20.7 20.3 33.6 48.7 33.6 80c0 61.9-50.1 112-112 112H112C50.1 512 0 461.9 0 400c0-44.7 26.2-83.2 64-101.2V176c0-17.7 14.3-32 32-32h29.3c9.1 0 17.7 3.9 23.8 10.6L211.6 224H400c17.7 0 32 14.3 32 32v48H536V240c0-1.9 .7-3.7 1.9-5.2l88-104c2.9-3.4 7.9-3.8 11.3-.9zM80 176V292.6c10.1-3 20.9-4.6 32-4.6H368c17.2 0 33.5 3.9 48 10.8V256c0-8.8-7.2-16-16-16H208c-2.3 0-4.4-1-5.9-2.6l-64.8-72.1c-3-3.4-7.4-5.3-11.9-5.3H96c-8.8 0-16 7.2-16 16zM368 304H112c-53 0-96 43-96 96s43 96 96 96H368c53 0 96-43 96-96s-43-96-96-96zm16 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM80 400a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm112-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faAlignSlash = {
    prefix: 'fat',
    iconName: 'align-slash',
    icon: [
      640,
      512,
      [],
      'f846',
      
      'M13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7zM274.7 312H104c-4.4 0-8 3.6-8 8s3.6 8 8 8H295l-20.3-16zm252.7 16H536c4.4 0 8-3.6 8-8s-3.6-8-8-8H507.1l20.3 16zM536 200c4.4 0 8-3.6 8-8s-3.6-8-8-8H345l20.3 16H536zm-403.1 0l-20.3-16H104c-4.4 0-8 3.6-8 8s3.6 8 8 8h28.9zM536 56H182.9l20.3 16H536c4.4 0 8-3.6 8-8s-3.6-8-8-8zM457.1 456l-20.3-16H104c-4.4 0-8 3.6-8 8s3.6 8 8 8H457.1z'
      
    ]
  };

  

  
  

  var faOctagonXmark = {
    prefix: 'fat',
    iconName: 'octagon-xmark',
    icon: [
      512,
      512,
      ["times-octagon","xmark-octagon"],
      'f2f0',
      
      'M191.5 16.1c-14.9 0-29.1 5.9-39.6 16.4L32.5 151.9C22 162.4 16.1 176.7 16.1 191.5v129c0 14.9 5.9 29.1 16.4 39.6L151.9 479.5c10.5 10.5 24.7 16.4 39.6 16.4h129c14.9 0 29.1-5.9 39.6-16.4L479.5 360.1c10.5-10.5 16.4-24.7 16.4-39.6v-129c0-14.9-5.9-29.1-16.4-39.6L360.1 32.5C349.6 22 335.3 16.1 320.5 16.1h-129zm-50.9 5.1C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zm37.7 157.2c3.1-3.1 8.2-3.1 11.3 0L256 244.7l66.3-66.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L267.3 256l66.3 66.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L256 267.3l-66.3 66.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L244.7 256l-66.3-66.3c-3.1-3.1-3.1-8.2 0-11.3z'
      
    ]
  };

  
    var faTimesOctagon = faOctagonXmark;
  
    var faXmarkOctagon = faOctagonXmark;
  

  
  

  var faMonument = {
    prefix: 'fat',
    iconName: 'monument',
    icon: [
      384,
      512,
      [],
      'f5a6',
      
      'M197.7 25c-3.1-3.1-8.2-3.1-11.3 0l-61 61c-3.7 3.7-6.1 8.6-6.8 13.8L79.9 393c-.6 4.4-4.6 7.5-9 6.9s-7.5-4.6-6.9-9L102.7 97.7c1.1-8.7 5.1-16.8 11.4-23.1l61-61c9.4-9.4 24.6-9.4 33.9 0l61 61c6.2 6.2 10.2 14.3 11.4 23.1L319.9 391c.6 4.4-2.5 8.4-6.9 9s-8.4-2.5-9-6.9L265.5 99.8c-.7-5.2-3.1-10.1-6.8-13.8l-61-61zM232 272H152c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8zm-80-16h80c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24V280c0-13.3 10.7-24 24-24zM32 432H352c17.7 0 32 14.3 32 32v16c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V464c0-17.7 14.3-32 32-32zM16 464v16c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16V464c0-8.8-7.2-16-16-16H32c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faRefrigerator = {
    prefix: 'fat',
    iconName: 'refrigerator',
    icon: [
      384,
      512,
      [],
      'e026',
      
      'M288 16c44.2 0 80 35.8 80 80v80H272V104c0-4.4-3.6-8-8-8s-8 3.6-8 8v72H16V96c0-44.2 35.8-80 80-80H288zM256 192V376c0 4.4 3.6 8 8 8s8-3.6 8-8V192h96V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V192H256zM0 96v88V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V184 96c0-53-43-96-96-96H96C43 0 0 43 0 96z'
      
    ]
  };

  

  
  

  var faMinimize = {
    prefix: 'fat',
    iconName: 'minimize',
    icon: [
      512,
      512,
      ["compress-arrows-alt"],
      'f78c',
      
      'M509.7 13.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-116 116L329.6 65.6c-6-6-14.6-8.4-22.8-6.3l-.6 .2C295.5 62.1 288 71.7 288 82.7V200c0 13.3 10.7 24 24 24H429.3c11 0 20.6-7.5 23.3-18.2l.2-.6c2-8.2-.4-16.8-6.3-22.8l-52.7-52.7 116-116zM2.3 13.7l116 116L65.6 182.4c-6 6-8.4 14.6-6.3 22.8l.2 .6C62.1 216.5 71.7 224 82.7 224H200c13.3 0 24-10.7 24-24V82.7c0-11-7.5-20.6-18.2-23.3l-.6-.2c-8.2-2-16.8 .4-22.8 6.3l-52.7 52.7L13.7 2.3C10.5-.8 5.5-.8 2.3 2.3s-3.1 8.2 0 11.3zm507.3 496c3.1-3.1 3.1-8.2 0-11.3l-116-116 52.7-52.7c6-6 8.4-14.6 6.3-22.8l-.2-.6c-2.7-10.7-12.3-18.2-23.3-18.2H312c-13.3 0-24 10.7-24 24V429.3c0 11 7.5 20.6 18.2 23.3l.6 .2c8.2 2 16.8-.4 22.8-6.3l52.7-52.7 116 116c3.1 3.1 8.2 3.1 11.3 0zM2.3 498.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l116-116 52.7 52.7c6 6 14.6 8.4 22.8 6.3l.6-.2c10.7-2.7 18.2-12.3 18.2-23.3V312c0-13.3-10.7-24-24-24H82.7c-11 0-20.6 7.5-23.3 18.2l-.2 .6c-2 8.2 .4 16.8 6.3 22.8l52.7 52.7-116 116zM310.7 74.8c2.7-.7 5.6 .1 7.6 2.1L435.1 193.7c2 2 2.8 4.9 2.1 7.6l-.2 .6c-.9 3.6-4.1 6.1-7.8 6.1H312c-4.4 0-8-3.6-8-8V82.7c0-3.7 2.5-6.9 6.1-7.8l.6-.2zm-109.4 0l.6 .2 0 0c3.6 .9 6.1 4.1 6.1 7.8V200c0 4.4-3.6 8-8 8H82.7c-3.7 0-6.9-2.5-7.8-6.1l-.2-.6c-.7-2.7 .1-5.6 2.1-7.6L193.7 76.9c2-2 4.9-2.8 7.6-2.1l0 0zM310.7 437.2l-.6-.2c-3.6-.9-6.1-4.1-6.1-7.8V312c0-4.4 3.6-8 8-8H429.3c3.7 0 6.9 2.5 7.8 6.1l.2 .6c.7 2.7-.1 5.6-2.1 7.6L318.3 435.1c-2 2-4.9 2.8-7.6 2.1zM201.9 437l-.6 .2c-2.7 .7-5.6-.1-7.6-2.1L76.9 318.3c-2-2-2.8-4.9-2.1-7.6l.2-.6c.9-3.6 4.1-6.1 7.8-6.1H200c4.4 0 8 3.6 8 8V429.3c0 3.7-2.5 6.9-6.1 7.8z'
      
    ]
  };

  
    var faCompressArrowsAlt = faMinimize;
  

  
  

  var faSmoking = {
    prefix: 'fat',
    iconName: 'smoking',
    icon: [
      640,
      512,
      [128684],
      'f48d',
      
      'M456 0c-4.4 0-8 3.6-8 8V43c0 46.7 18.5 91.4 51.5 124.5l21 21c15 15 23.4 35.4 23.4 56.6v35c0 4.4 3.6 8 8 8s8-3.6 8-8V245c0-25.5-10.1-49.9-28.1-67.9l-21-21C480.9 126.1 464 85.4 464 43V8c0-4.4-3.6-8-8-8zM632 288c4.4 0 8-3.6 8-8V245c0-46.7-18.5-91.4-51.5-124.5l-21-21C552.4 84.5 544 64.2 544 43V8c0-4.4-3.6-8-8-8s-8 3.6-8 8V43c0 25.5 10.1 49.9 28.1 67.9l21 21c30 30 46.9 70.7 46.9 113.1v35c0 4.4 3.6 8 8 8zM48 368H224V496H48c-17.7 0-32-14.3-32-32V400c0-17.7 14.3-32 32-32zm192-16H224 48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H224h16H480c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H240zM480 496H240V368H480c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16zM640 360c0-4.4-3.6-8-8-8s-8 3.6-8 8V504c0 4.4 3.6 8 8 8s8-3.6 8-8V360zm-88-8c-4.4 0-8 3.6-8 8V504c0 4.4 3.6 8 8 8s8-3.6 8-8V360c0-4.4-3.6-8-8-8zm48 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V504c0 4.4 3.6 8 8 8s8-3.6 8-8V360z'
      
    ]
  };

  

  
  

  var faDolly = {
    prefix: 'fat',
    iconName: 'dolly',
    icon: [
      576,
      512,
      ["dolly-box"],
      'f472',
      
      'M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8H96.5c10.5 0 19.7 6.8 22.9 16.8L231.5 388.9C208.3 398.5 192 421.3 192 448c0 35.3 28.7 64 64 64s64-28.7 64-64c0-6.4-.9-12.6-2.7-18.5l253.1-77.9c4.2-1.3 6.6-5.8 5.3-10s-5.8-6.6-10-5.3L310.7 414.8C299.5 396.3 279.2 384 256 384c-3.1 0-6.1 .2-9 .6L134.7 28C129.4 11.3 114 0 96.5 0H8zM256 400a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM356.7 164.1c1.3 4.2 5.8 6.6 10 5.3s6.6-5.8 5.3-10l-16.4-53.5 68.9-21.1c8.5-2.6 17.4 2.2 20 10.6l46.8 153c2.6 8.5-2.2 17.4-10.6 20l-153 46.8c-8.5 2.6-17.4-2.2-20-10.6l-46.8-153c-2.6-8.5 2.2-17.4 10.6-20l68.9-21 16.4 53.5zm-111.1-7.8l46.8 153c5.2 16.9 23.1 26.4 40 21.2l153-46.8c16.9-5.2 26.4-23.1 21.2-40l-46.8-153c-5.2-16.9-23.1-26.4-40-21.2l-153 46.8c-16.9 5.2-26.4 23.1-21.2 40z'
      
    ]
  };

  
    var faDollyBox = faDolly;
  

  
  

  var faGem = {
    prefix: 'fat',
    iconName: 'gem',
    icon: [
      512,
      512,
      [128142],
      'f3a5',
      
      'M128 32c-2.5 0-4.9 1.2-6.4 3.2l-120 160c-2.3 3.1-2.1 7.4 .5 10.2l248 272c1.5 1.7 3.7 2.6 5.9 2.6s4.4-.9 5.9-2.6l248-272c2.6-2.8 2.8-7.1 .5-10.2l-120-160c-1.5-2-3.9-3.2-6.4-3.2H128zm.2 21.1L239.4 192H24L128.2 53.1zM26.1 208H256 485.9L256 460.1 26.1 208zM488 192H272.6L383.8 53.1 488 192zM367.4 48L256 187.2 144.6 48H367.4z'
      
    ]
  };

  

  
  

  var faHandshake = {
    prefix: 'fat',
    iconName: 'handshake',
    icon: [
      640,
      512,
      [],
      'f2b5',
      
      'M255.9 64c-32 0-63 11.3-87.5 31.9L144 116.4v20.9l34.7-29.2C200.3 90 227.7 80 255.9 80h21.2L294 64H255.9zM112 336V144 128h-8H96 32c-17.7 0-32 14.3-32 32V368c0 17.7 14.3 32 32 32H80c17.7 0 32-14.3 32-32V352h3.4c12.7 0 24.9 5.1 33.9 14.1l20.6 20.6 15.4 15.4 .1 .1 24.4 24.4c22.1 22.1 57.5 23.1 80.8 2.2c1.2-1.1 2.3-2.2 3.4-3.3l4.8 4.8c22.9 22.9 60.3 21.8 81.9-2.4c7.9-8.8 12.4-19.5 13.8-30.4c20.2 10.8 45.6 8.4 63.6-7.5c11.4-10.1 17.7-23.8 18.6-37.9H528v16c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H544h-8-8v16V336H475.4c-2.2-10.1-7.2-19.6-15.1-27.5L360.8 209 375 195.9c3.2-3 3.4-8.1 .5-11.3s-8.1-3.4-11.3-.5l-76 70.2c-16.3 15-41.3 15.3-57.8 .5c-18.9-16.8-19.3-46.1-1-63.5l87.5-82.9c19.3-18.3 45-28.5 71.6-28.5c24.5 0 48.2 8.6 67 24.4L496 138.5V117.6L465.8 92.2C444.1 74 416.7 64 388.5 64c-30.7 0-60.3 11.8-82.6 32.9l-87.5 82.9c-25.1 23.8-24.5 64 1.4 87c22.7 20.2 57 19.9 79.3-.7l50.1-46.2L449 319.8c16.3 16.3 15.5 42.8-1.7 58.1c-15.8 14-39.8 13.3-54.8-1.6l-1-1c-2.5-2.5-6.3-3.1-9.4-1.4s-4.8 5.2-4.1 8.6c2.4 12-.7 24.9-9.4 34.7c-15.4 17.3-42.2 18.1-58.6 1.7l-11.1-11.1c-1.7-1.7-4-2.5-6.4-2.3s-4.5 1.5-5.9 3.5c-1.9 2.8-4.2 5.4-6.9 7.8c-16.9 15.1-42.7 14.4-58.8-1.6l-39.9-39.9-20.6-20.6c-12-12-28.3-18.7-45.3-18.7H112zM96 144V368c0 8.8-7.2 16-16 16H32c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16H96zm512 0c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16H560c-8.8 0-16-7.2-16-16V144h64z'
      
    ]
  };

  

  
  

  var faHeadSideMask = {
    prefix: 'fat',
    iconName: 'head-side-mask',
    icon: [
      576,
      512,
      [],
      'e063',
      
      'M48 222.9c0-21.2 3.2-41.6 9.1-60.8L256 287.4v.6V480c0 17.7 14.3 32 32 32H431.7c28.6 0 53.7-18.9 61.5-46.4l46.3-162.2c1.4-5.1 2.5-10.2 3.3-15.4c.7-5.3 1.1-10.6 1.1-16h-.1c-1-13.5-7.2-26.1-17.4-35.2l-3.8-3.4c-16.7-14.9-29.2-33.6-40-54.4c-7-13.4-13.1-27.1-19.3-41c-3.5-7.9-7.1-15.9-10.8-23.9C421.1 46.9 349.6 0 271.7 0H254.9C131.8 0 32 99.8 32 222.9c0 52.8 16.9 101.5 47.4 139.9C89.5 375.5 96 390.2 96 405.3V504c0 4.4 3.6 8 8 8s8-3.6 8-8V405.3c0-19.8-8.5-37.8-20.1-52.4C63.8 317.5 48 272.3 48 222.9zM261.6 272L62.5 146.6C92.9 70.1 167.6 16 254.9 16h16.8c71.6 0 137.5 43.3 166.4 105c3.5 7.4 6.9 15.1 10.4 22.9c6.4 14.3 12.9 28.9 20.1 42.7c11.3 21.6 24.8 42.2 43.5 58.9l3.8 3.4c6.8 6 11 14.3 11.9 23.2H272 261.6zM272 480V288H526.7c-.6 3.7-1.4 7.4-2.5 11l-15.1 53H368c-4.4 0-8 3.6-8 8s3.6 8 8 8H504.5l-13.7 48H368c-4.4 0-8 3.6-8 8s3.6 8 8 8H486.2l-8.3 29.2C472 481.8 453.2 496 431.7 496H288c-8.8 0-16-7.2-16-16zm96-256a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faLemon = {
    prefix: 'fat',
    iconName: 'lemon',
    icon: [
      448,
      512,
      [127819],
      'f094',
      
      'M368 48c-7.6 0-14.9 1.3-21.6 3.7c-17.8 6.4-39.6 11.3-61.3 6.5c-67.2-15-140.6 12.3-193.5 65.3s-80.2 126.4-65.3 193.5c4.8 21.7-.1 43.4-6.5 61.3c-2.4 6.7-3.7 14-3.7 21.6c0 35.3 28.7 64 64 64c7.6 0 14.9-1.3 21.6-3.7c17.8-6.4 39.6-11.3 61.3-6.5c67.2 15 140.6-12.3 193.5-65.3s80.2-126.4 65.3-193.5c-4.8-21.7 .1-43.4 6.5-61.3c2.4-6.7 3.7-14 3.7-21.6c0-35.3-28.7-64-64-64zm0-16c44.2 0 80 35.8 80 80c0 9.5-1.7 18.6-4.7 27.1c-6 16.7-9.8 35-5.9 52.4c16.4 73.7-13.7 152.4-69.6 208.3s-134.7 86-208.3 69.6c-17.3-3.9-35.7-.1-52.4 5.9c-8.4 3-17.6 4.7-27.1 4.7c-44.2 0-80-35.8-80-80c0-9.5 1.7-18.6 4.7-27.1c6-16.7 9.8-35 5.9-52.4C-5.8 246.9 24.3 168.2 80.2 112.2s134.7-86 208.3-69.6c17.3 3.9 35.7 .1 52.4-5.9c8.4-3 17.6-4.7 27.1-4.7zM219.1 119.4l-16.9 7.1c-48.7 20.3-87.4 59-107.7 107.7l-7.1 16.9c-1.7 4.1-6.4 6-10.5 4.3s-6-6.4-4.3-10.5L79.7 228c21.9-52.6 63.7-94.4 116.3-116.3l16.9-7.1c4.1-1.7 8.8 .2 10.5 4.3s-.2 8.8-4.3 10.5z'
      
    ]
  };

  

  
  

  var faTick = {
    prefix: 'fat',
    iconName: 'tick',
    icon: [
      192,
      512,
      [],
      'e32f',
      
      'M48 96c0-26.5 21.5-48 48-48s48 21.5 48 48l0 7.9c0 4.2-.5 8.3-1.4 12.4L109.7 261.1c-1.5 6.4-7.1 10.9-13.7 10.9s-12.3-4.5-13.7-10.9L49.4 116.3c-.9-4.1-1.4-8.2-1.4-12.4L48 96zM32 96l0 7.9c0 5.4 .6 10.7 1.8 15.9L66.7 264.6C69.8 278.3 82 288 96 288s26.2-9.7 29.3-23.4l32.9-144.7c1.2-5.2 1.8-10.6 1.8-15.9l0-7.9c0-35.3-28.7-64-64-64S32 60.7 32 96z'
      
    ]
  };

  

  
  

  var faSquareA = {
    prefix: 'fat',
    iconName: 'square-a',
    icon: [
      448,
      512,
      [],
      'e25f',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 32c3 0 5.8 1.7 7.2 4.4l120 240c2 4 .4 8.8-3.6 10.7s-8.8 .4-10.7-3.6L307.1 320H140.9l-29.8 59.6c-2 4-6.8 5.6-10.7 3.6s-5.6-6.8-3.6-10.7l120-240c1.4-2.7 4.1-4.4 7.2-4.4zm0 25.9L148.9 304H299.1L224 153.9z'
      
    ]
  };

  

  
  

  var faTableColumns = {
    prefix: 'fat',
    iconName: 'table-columns',
    icon: [
      512,
      512,
      ["columns"],
      'f0db',
      
      'M16 96c0-26.5 21.5-48 48-48l384 0c26.5 0 48 21.5 48 48l0 64L16 160l0-64zm0 320l0-240 232 0 0 288L64 464c-26.5 0-48-21.5-48-48zm248 48l0-288 232 0 0 240c0 26.5-21.5 48-48 48l-184 0zM0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416z'
      
    ]
  };

  
    var faColumns = faTableColumns;
  

  
  

  var faRotateLeft = {
    prefix: 'fat',
    iconName: 'rotate-left',
    icon: [
      512,
      512,
      ["rotate-back","rotate-backward","undo-alt"],
      'f2ea',
      
      'M419.9 384.1c-70.7 90.5-201.4 106.6-292 35.8C105 402 86.9 380.2 73.7 356.3c-2.1-3.9-7-5.3-10.9-3.2s-5.3 7-3.2 10.9c14.2 25.8 33.7 49.3 58.4 68.6c97.5 76.2 238.3 58.9 314.4-38.6s58.9-238.3-38.6-314.4C304.1 9.3 177.5 18.5 98.6 96.6l11.3 11.3c73.3-72.5 190.8-81 274.2-15.8c90.5 70.7 106.6 201.4 35.8 292zM32 192c-4.4 0-8-3.6-8-8V64c0-3.2 1.9-6.2 4.9-7.4s6.4-.6 8.7 1.7l120 120c2.3 2.3 3 5.7 1.7 8.7s-4.2 4.9-7.4 4.9H32zm120 16c9.7 0 18.5-5.8 22.2-14.8s1.7-19.3-5.2-26.2L49 47c-6.9-6.9-17.2-8.9-26.2-5.2S8 54.3 8 64V184c0 13.3 10.7 24 24 24H152z'
      
    ]
  };

  
    var faRotateBack = faRotateLeft;
  
    var faRotateBackward = faRotateLeft;
  
    var faUndoAlt = faRotateLeft;
  

  
  

  var faMartiniGlass = {
    prefix: 'fat',
    iconName: 'martini-glass',
    icon: [
      512,
      512,
      [127864,"glass-martini-alt"],
      'f57b',
      
      'M16 25.5c0-5.3 4.3-9.5 9.5-9.5H486.5c5.3 0 9.5 4.3 9.5 9.5c0 2.5-1 5-2.8 6.7L397.5 128h-283L18.8 32.3C17 30.5 16 28.1 16 25.5zM130.5 144h251L256 269.5 130.5 144zM7.5 43.6L248 284.1V496H136c-4.4 0-8 3.6-8 8s3.6 8 8 8H256 376c4.4 0 8-3.6 8-8s-3.6-8-8-8H264V284.1L504.5 43.6c4.8-4.8 7.5-11.3 7.5-18.1C512 11.4 500.6 0 486.5 0H25.5C11.4 0 0 11.4 0 25.5c0 6.8 2.7 13.3 7.5 18.1z'
      
    ]
  };

  
    var faGlassMartiniAlt = faMartiniGlass;
  

  
  

  var faBracketSquareRight = {
    prefix: 'fat',
    iconName: 'bracket-square-right',
    icon: [
      192,
      512,
      [],
      '5d',
      
      'M192 72c0-22.1-17.9-40-40-40H40c-4.4 0-8 3.6-8 8s3.6 8 8 8H152c13.3 0 24 10.7 24 24V440c0 13.3-10.7 24-24 24H40c-4.4 0-8 3.6-8 8s3.6 8 8 8H152c22.1 0 40-17.9 40-40V72z'
      
    ]
  };

  

  
  

  var faArrowUpFromGroundWater = {
    prefix: 'fat',
    iconName: 'arrow-up-from-ground-water',
    icon: [
      576,
      512,
      [],
      'e4b5',
      
      'M288 352c4.4 0 8-3.6 8-8V27.3l82.3 82.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-96-96c-3.1-3.1-8.2-3.1-11.3 0l-96 96c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L280 27.3V344c0 4.4 3.6 8 8 8zM64 192c-35.3 0-64 28.7-64 64V425c4.9-2.8 10.3-5 16-6.5V256c0-26.5 21.5-48 48-48H192V192H64zM576 425V256c0-35.3-28.7-64-64-64H384v16H512c26.5 0 48 21.5 48 48V418.5c5.7 1.5 11.1 3.7 16 6.5zM294.6 435.4c-3-4.3-10.2-4.3-13.2 0c-8 11.2-17.5 21.4-27.6 30.7C236.6 481.8 214.5 496 192 496s-44.6-14.2-61.8-29.9c-10.1-9.2-19.7-19.5-27.6-30.7c-1.5-2.1-3.9-3.4-6.6-3.4s-5.1 1.3-6.6 3.4c-7.3 10.3-15.9 19.6-25 28.3C48.7 478.5 28.3 492.9 7 495.6c-4.4 .6-7.5 4.6-6.9 8.9s4.6 7.5 8.9 6.9c26.5-3.3 50-20.7 66.4-36.1c8.8-8.3 15.9-16.4 20.6-22.2c5.2 6.4 13.2 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8l0 0 0 0c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c4.7 5.8 11.8 13.9 20.6 22.2c16.4 15.4 39.9 32.8 66.4 36.1c4.4 .6 8.4-2.6 8.9-6.9s-2.6-8.4-6.9-8.9c-21.3-2.7-41.7-17.1-57.4-31.9c-9.1-8.6-17.7-18-25-28.3c-1.5-2.1-3.9-3.4-6.6-3.4s-5.1 1.3-6.6 3.4c-7.9 11.2-17.5 21.5-27.6 30.7C428.6 481.8 406.5 496 384 496s-44.6-14.2-61.8-29.9c-10.1-9.2-19.6-19.5-27.6-30.7z'
      
    ]
  };

  

  
  

  var faForklift = {
    prefix: 'fat',
    iconName: 'forklift',
    icon: [
      640,
      512,
      [],
      'f47a',
      
      'M144 40c0-13.3 10.7-24 24-24H268.5c9 0 17.2 5 21.3 13l103 198.7c2 3.9 6.9 5.5 10.8 3.4s5.5-6.9 3.4-10.8L304.1 21.6C297.2 8.3 283.5 0 268.5 0H168c-22.1 0-40 17.9-40 40v88c0 4.4 3.6 8 8 8s8-3.6 8-8V40zM96 336a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 176c53 0 96-43 96-96h64c0 53 43 96 96 96s96-43 96-96c0-28.4-12.4-54-32-71.6V296c0-22.1-17.9-40-40-40H264L159.3 172.3c-9.9-7.9-22.3-12.3-35-12.3H64c-35.3 0-64 28.7-64 64V400v16c0 53 43 96 96 96zm0-192c-33.4 0-62.8 17-80 42.9V224c0-26.5 21.5-48 48-48h60.4c9.1 0 17.9 3.1 25 8.8L254 268.5c2.8 2.3 6.4 3.5 10 3.5H376c13.3 0 24 10.7 24 24v36.8l0 0c-14.1-8.2-30.5-12.8-48-12.8c-47.6 0-87.1 34.6-94.7 80H190.7c-7.6-45.4-47.1-80-94.7-80zm256 16a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM496 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V440c0 4.4 3.6 8 8 8H632c4.4 0 8-3.6 8-8s-3.6-8-8-8H496V8z'
      
    ]
  };

  

  
  

  var faSquareNfi = {
    prefix: 'fat',
    iconName: 'square-nfi',
    icon: [
      448,
      512,
      [],
      'e576',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm79 68.2l81 148.5V168c0-4.4 3.6-8 8-8s8 3.6 8 8V344c0 3.7-2.5 6.8-6 7.8s-7.2-.7-9-3.9L80 199.4V344c0 4.4-3.6 8-8 8s-8-3.6-8-8V168c0-3.7 2.5-6.8 6-7.8s7.2 .7 9 3.9zM240 160h72c4.4 0 8 3.6 8 8s-3.6 8-8 8H248v48h64c4.4 0 8 3.6 8 8s-3.6 8-8 8H248V344c0 4.4-3.6 8-8 8s-8-3.6-8-8V232 168c0-4.4 3.6-8 8-8zm144 8V344c0 4.4-3.6 8-8 8s-8-3.6-8-8V168c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faHouseTsunami = {
    prefix: 'fat',
    iconName: 'house-tsunami',
    icon: [
      576,
      512,
      [],
      'e515',
      
      'M16 200C16 98.8 102.6 16 210.3 16c22.4 0 44 3.6 64 10.2c4.2 1.4 8.7-.9 10.1-5.1s-.9-8.7-5.1-10.1c-21.6-7.1-44.9-11-69-11C94.6 0 0 89.2 0 200C0 309.8 74 400 190.9 400c.4 0 .8 0 1.1-.1v.1c28.7 0 54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8l0 0 0 0c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c4.7 5.8 11.8 13.9 20.6 22.2c16.4 15.4 39.9 32.8 66.4 36.1c4.4 .6 8.4-2.6 8.9-6.9s-2.6-8.4-6.9-8.9c-21.3-2.7-41.7-17.1-57.4-31.9c-9.1-8.6-17.7-18-25-28.3c-1.5-2.1-3.9-3.4-6.6-3.4s-5.1 1.3-6.6 3.4c-7.9 11.2-17.5 21.5-27.6 30.7C428.6 369.8 406.5 384 384 384s-44.6-14.2-61.8-29.9c-10.1-9.2-19.6-19.5-27.6-30.7c-3-4.3-10.2-4.3-13.2 0c-8 11.2-17.5 21.4-27.6 30.7C236.6 369.8 214.5 384 192 384v.1c-.4-.1-.8-.1-1.1-.1C84.2 384 16 302.3 16 200zm326.4-68.8l96-72c5.7-4.3 13.5-4.3 19.2 0l95.5 71.9c4 3 6.4 7.7 6.4 12.7l.3 146.5c5.7 1.5 11.1 3.6 16 6.5l-.3-153c0-10-4.7-19.5-12.7-25.5L467.2 46.5c-11.4-8.6-27.1-8.6-38.5 0l-96 72c-8.1 6-12.8 15.5-12.8 25.6V265c1.6 1 3.3 2 4.8 3.1c3.6 2.5 7.4 4.8 11.2 6.9V144c0-5 2.4-9.8 6.4-12.8zM294.6 435.4c-3-4.3-10.2-4.3-13.2 0c-8 11.2-17.5 21.4-27.6 30.7C236.6 481.8 214.5 496 192 496s-44.6-14.2-61.8-29.9c-10.1-9.2-19.7-19.5-27.6-30.7c-1.5-2.1-3.9-3.4-6.6-3.4s-5.1 1.3-6.6 3.4c-7.3 10.3-15.9 19.6-25 28.3C48.7 478.5 28.3 492.9 7 495.6c-4.4 .6-7.5 4.6-6.9 8.9s4.6 7.5 8.9 6.9c26.5-3.3 50-20.7 66.4-36.1c8.8-8.3 15.9-16.4 20.6-22.2c5.2 6.4 13.2 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8l0 0 0 0c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c4.7 5.8 11.8 13.9 20.6 22.2c16.4 15.4 39.9 32.8 66.4 36.1c4.4 .6 8.4-2.6 8.9-6.9s-2.6-8.4-6.9-8.9c-21.3-2.7-41.7-17.1-57.4-31.9c-9.1-8.6-17.7-18-25-28.3c-1.5-2.1-3.9-3.4-6.6-3.4s-5.1 1.3-6.6 3.4c-7.9 11.2-17.5 21.5-27.6 30.7C428.6 481.8 406.5 496 384 496s-44.6-14.2-61.8-29.9c-10.1-9.2-19.6-19.5-27.6-30.7zM190 112c16.7 0 32.6 3.5 46.7 9.8c4 1.8 8.8 0 10.6-4.1s0-8.8-4.1-10.6C227.1 100 209 96 190 96C120.8 96 64 149.3 64 216s56.8 120 126 120c4.4 0 8-3.6 8-8s-3.6-8-8-8c-61.2 0-110-47-110-104s48.9-104 110-104z'
      
    ]
  };

  

  
  

  var faFolderClosed = {
    prefix: 'fat',
    iconName: 'folder-closed',
    icon: [
      512,
      512,
      [],
      'e185',
      
      'M448 464H64c-26.5 0-48-21.5-48-48V192H496V416c0 26.5-21.5 48-48 48zm48-288H16V96c0-26.5 21.5-48 48-48H197.5c12.7 0 24.9 5.1 33.9 14.1l35.9 35.9c9 9 21.2 14.1 33.9 14.1H448c26.5 0 48 21.5 48 48v16zM64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H301.3c-8.5 0-16.6-3.4-22.6-9.4L242.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64z'
      
    ]
  };

  

  
  

  var faCircleSortDown = {
    prefix: 'fat',
    iconName: 'circle-sort-down',
    icon: [
      512,
      512,
      ["sort-circle-down"],
      'e031',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM267.3 411.3c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9H352c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-96 96zM352 304H160l96 96 96-96zM267.3 100.7l96 96c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-96-96-96 96c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l96-96c6.2-6.2 16.4-6.2 22.6 0z'
      
    ]
  };

  
    var faSortCircleDown = faCircleSortDown;
  

  
  

  var faScrewdriver = {
    prefix: 'fat',
    iconName: 'screwdriver',
    icon: [
      512,
      512,
      [129691],
      'f54a',
      
      'M465 7l40 40c8.5 8.5 9.4 22 2.1 31.6l-80 104c-4.5 5.9-11.6 9.4-19 9.4H344h-8-4.7l-72.6 72.6c-1.7-2-3.6-4-5.5-5.9s-3.9-3.7-5.9-5.5L320 180.7V176v-8V104c0-7.5 3.5-14.5 9.4-19l104-80C442.9-2.4 456.4-1.5 465 7zM336 176h8 64c2.5 0 4.8-1.2 6.3-3.1l80-104c2.4-3.2 2.2-7.7-.7-10.5l-40-40c-2.8-2.8-7.4-3.1-10.5-.7l-104 80c-2 1.5-3.1 3.9-3.1 6.3v64 8zM219.3 292.7c-23.9-23.9-62.7-23.9-86.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l112-112c23.9-23.9 23.9-62.7 0-86.6zM9.4 438.6c-12.5-12.5-12.5-32.8 0-45.3l112-112c30.2-30.2 79.1-30.2 109.3 0s30.2 79.1 0 109.3l-112 112c-12.5 12.5-32.8 12.5-45.3 0l-64-64z'
      
    ]
  };

  

  
  

  var faShieldXmark = {
    prefix: 'fat',
    iconName: 'shield-xmark',
    icon: [
      512,
      512,
      ["shield-times"],
      'e24c',
      
      'M237.3 22.6c12-5.1 25.5-5.1 37.5 0l176.7 75c16.6 7.1 28.6 23.2 28.5 42.4c-.5 96.6-40.3 270.2-204.5 348.8c-12.3 5.9-26.7 5.9-39 0C72.3 410.1 32.5 236.5 32 139.9c-.1-19.1 11.9-35.3 28.5-42.4l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM178.3 178.3c-3.1 3.1-3.1 8.2 0 11.3L244.7 256l-66.3 66.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L256 267.3l66.3 66.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L267.3 256l66.3-66.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L256 244.7l-66.3-66.3c-3.1-3.1-8.2-3.1-11.3 0z'
      
    ]
  };

  
    var faShieldTimes = faShieldXmark;
  

  
  

  var faCaretUp = {
    prefix: 'fat',
    iconName: 'caret-up',
    icon: [
      320,
      512,
      [],
      'f0d8',
      
      'M144.6 150.6c4-4.2 9.6-6.6 15.4-6.6s11.4 2.4 15.4 6.6L300.5 282.7c2.2 2.3 3.5 5.4 3.5 8.7c0 7-5.6 12.6-12.6 12.6H28.6c-7 0-12.6-5.6-12.6-12.6c0-3.2 1.2-6.3 3.5-8.7L144.6 150.6zm-11.6-11L7.8 271.7C2.8 277 0 284.1 0 291.4C0 307.2 12.8 320 28.6 320H291.4c15.8 0 28.6-12.8 28.6-28.6c0-7.3-2.8-14.4-7.8-19.7L187 139.6c-7-7.4-16.8-11.6-27-11.6s-20 4.2-27 11.6z'
      
    ]
  };

  

  
  

  var faDownFromLine = {
    prefix: 'fat',
    iconName: 'down-from-line',
    icon: [
      384,
      512,
      ["arrow-alt-from-top"],
      'f349',
      
      'M184 460.7c2.1 2.1 5 3.3 8 3.3s5.9-1.2 8-3.3L331.8 328.6c2.7-2.7 4.2-6.4 4.2-10.2c0-8-6.5-14.4-14.4-14.4L248 304c-4.4 0-8-3.6-8-8l0-136c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16l0 136c0 4.4-3.6 8-8 8l-73.6 0c-8 0-14.4 6.5-14.4 14.4c0 3.8 1.5 7.5 4.2 10.2L184 460.7zm8 19.3c-7.2 0-14.2-2.9-19.3-8L40.9 339.9c-5.7-5.7-8.9-13.4-8.9-21.5C32 301.6 45.6 288 62.4 288l65.6 0 0-128c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 128 65.6 0c16.8 0 30.4 13.6 30.4 30.4c0 8.1-3.2 15.8-8.9 21.5L211.3 472c-5.1 5.1-12.1 8-19.3 8zM8 32l368 0c4.4 0 8 3.6 8 8s-3.6 8-8 8L8 48c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  
    var faArrowAltFromTop = faDownFromLine;
  

  
  

  var faSquareRing = {
    prefix: 'fat',
    iconName: 'square-ring',
    icon: [
      448,
      512,
      [],
      'e44f',
      
      'M384 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm160 80a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 304a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM144 256a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm176 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z'
      
    ]
  };

  

  
  

  var fa3 = {
    prefix: 'fat',
    iconName: '3',
    icon: [
      320,
      512,
      [],
      '33',
      
      'M0 40c0-4.4 3.6-8 8-8H288c3.3 0 6.3 2.1 7.5 5.2s.3 6.6-2.2 8.8L93 224h99c70.7 0 128 57.3 128 128s-57.3 128-128 128H90c-38.4 0-73.1-22.9-88.2-58.2L.6 419.2c-1.7-4.1 .1-8.8 4.2-10.5s8.8 .1 10.5 4.2l1.1 2.7C29.1 444.9 58 464 90 464H192c61.9 0 112-50.1 112-112s-50.1-112-112-112H72c-3.3 0-6.3-2.1-7.5-5.2s-.3-6.6 2.2-8.8L267 48H8c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faFileZip = {
    prefix: 'fat',
    iconName: 'file-zip',
    icon: [
      512,
      512,
      [],
      'e5ee',
      
      'M176 496H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V304h16V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H176V496zM361.1 160H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3c.9 .9 1.7 1.8 2.4 2.7zM240 368c-4.4 0-8 3.6-8 8s3.6 8 8 8h51.1L232.8 500.4c-1.2 2.5-1.1 5.4 .4 7.8s4 3.8 6.8 3.8h64c4.4 0 8-3.6 8-8s-3.6-8-8-8H252.9l58.2-116.4c1.2-2.5 1.1-5.4-.4-7.8s-4-3.8-6.8-3.8H240zm136 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V504c0 4.4 3.6 8 8 8s8-3.6 8-8V376zm48 0v80 48c0 4.4 3.6 8 8 8s8-3.6 8-8V464h16c26.5 0 48-21.5 48-48s-21.5-48-48-48H432c-4.4 0-8 3.6-8 8zm16 72V384h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H440z'
      
    ]
  };

  

  
  

  var faCow = {
    prefix: 'fat',
    iconName: 'cow',
    icon: [
      640,
      512,
      [128004],
      'f6c8',
      
      'M120 80c-30.9 0-56 25.1-56 56v88 8 8 28.8C64 297.1 41.1 320 12.8 320C5.7 320 0 314.3 0 307.2V288c0-29.8 20.4-54.9 48-62V136c0-39.8 32.2-72 72-72h48 16H423.6c33 0 64 15.6 83.6 42.1l60.3 81.4c5.9-7 14.7-11.4 24.5-11.4c17.7 0 32 14.3 32 32v55.8l8.1 11c5.1 6.9 7.9 15.2 7.9 23.8V392c0 30.9-25.1 56-56 56c-17.6 0-34.2-8.3-44.8-22.4L488 357.3c-5.2-6.9-8-15.3-8-24V284.3l-32-21.3V416c0 17.7-14.3 32-32 32H368c-17.7 0-32-14.3-32-32V362l-6.7 1.5c-8.4 1.9-16.8 3.3-25.3 4.3c0 .1 0 .1 0 .2v16c0 4.4-3.6 8-8 8s-8-3.6-8-8V369.3c-10.7 .6-21.3 .6-32 0V384c0 4.4-3.6 8-8 8s-8-3.6-8-8V368c0-.1 0-.1 0-.2c-8.5-1-16.9-2.5-25.3-4.3L208 362v54c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V136c0-22.6 10.4-42.8 26.7-56H120zm88 265.6l10.2 2.3c35.4 7.9 72.2 7.9 107.6 0l10.2-2.3V328c0-35.3-28.7-64-64-64s-64 28.7-64 64v17.6zm-48-265c.1 23.2 9.3 45.5 25.8 61.9l3.1 3.1c19.5 19.5 46 30.5 73.5 30.5h3.2c27.6 0 54-11 73.5-30.5l3.1-3.1C358.7 126 368 103.6 368 80.2V80H184 168c-2.7 0-5.4 .2-8 .6zm-15.9 4.8c-19 9-32.1 28.3-32.1 50.7V416c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V328c0-44.2 35.8-80 80-80s80 35.8 80 80v88c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V248c0-3 1.6-5.7 4.2-7.1s5.8-1.2 8.2 .4l48 32c2.2 1.5 3.6 4 3.6 6.7v53.3c0 5.2 1.7 10.2 4.8 14.4L552 416c7.6 10.1 19.4 16 32 16c22.1 0 40-17.9 40-40V298.6c0-5.1-1.7-10.2-4.7-14.3l-9.7-13.1c-1-1.4-1.6-3-1.6-4.8V208c0-8.8-7.2-16-16-16c-7.6 0-13.9 5.2-15.6 12.3c-.7 3-3.1 5.4-6.2 6s-6.2-.6-8-3.1l-67.9-91.6C477.8 93.2 451.5 80 423.6 80H384v.2c0 27.6-11 54-30.5 73.5l-3.1 3.1c-22.5 22.5-53 35.1-84.9 35.1h-3.2c-31.8 0-62.3-12.6-84.9-35.1l-3.1-3.1c-18.3-18.3-29.1-42.7-30.3-68.4zM16 288v15.9c17.9-1.6 32-16.7 32-35.1V242.7c-18.6 6.6-32 24.4-32 45.3zm536 32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faMicrophone = {
    prefix: 'fat',
    iconName: 'microphone',
    icon: [
      384,
      512,
      [],
      'f130',
      
      'M272 96V256c0 44.2-35.8 80-80 80s-80-35.8-80-80V96c0-44.2 35.8-80 80-80s80 35.8 80 80zM96 96V256c0 53 43 96 96 96s96-43 96-96V96c0-53-43-96-96-96S96 43 96 96zM48 200c0-4.4-3.6-8-8-8s-8 3.6-8 8v56c0 85.7 67.4 155.6 152 159.8V496H104c-4.4 0-8 3.6-8 8s3.6 8 8 8h88 88c4.4 0 8-3.6 8-8s-3.6-8-8-8H200V415.8c84.6-4.2 152-74.1 152-159.8V200c0-4.4-3.6-8-8-8s-8 3.6-8 8v56c0 79.5-64.5 144-144 144s-144-64.5-144-144V200z'
      
    ]
  };

  

  
  

  var faWindowFrame = {
    prefix: 'fat',
    iconName: 'window-frame',
    icon: [
      512,
      512,
      [129695],
      'e04f',
      
      'M248 256V496H48V256H248zm16 240V256H464V496H264zm216 0V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64V496H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H32 48 464h16 24c4.4 0 8-3.6 8-8s-3.6-8-8-8H480zM464 240H264V16H416c26.5 0 48 21.5 48 48V240zM96 16H248V240H48V64c0-26.5 21.5-48 48-48z'
      
    ]
  };

  

  
  

  var faImage = {
    prefix: 'fat',
    iconName: 'image',
    icon: [
      512,
      512,
      [],
      'f03e',
      
      'M64 48C37.5 48 16 69.5 16 96V356.7l89.4-89.4c12.5-12.5 32.8-12.5 45.3 0L224 340.7 361.4 203.3c12.5-12.5 32.8-12.5 45.3 0L496 292.7V96c0-26.5-21.5-48-48-48H64zM16 379.3V416c0 26.5 21.5 48 48 48h36.7l112-112-73.4-73.4c-6.2-6.2-16.4-6.2-22.6 0L16 379.3zM395.3 214.6c-6.2-6.2-16.4-6.2-22.6 0L123.3 464H448c26.5 0 48-21.5 48-48V315.3L395.3 214.6zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm168 64a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm-96 0a56 56 0 1 1 112 0A56 56 0 1 1 72 160z'
      
    ]
  };

  

  
  

  var faFloppyDiskPen = {
    prefix: 'fat',
    iconName: 'floppy-disk-pen',
    icon: [
      576,
      512,
      [],
      'e182',
      
      'M16 96V416c0 26.5 21.5 48 48 48H262.2l-4 16H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H309.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3v64.8l-16 16V170.5c0-12.7-5.1-24.9-14.1-33.9L343.4 62.1C337 55.6 328.8 51.1 320 49.2V160c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32L64 48C37.5 48 16 69.5 16 96zM80 48V160c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16V48H80zm72 280a72 72 0 1 0 144 0 72 72 0 1 0 -144 0zm72 88a88 88 0 1 1 0-176 88 88 0 1 1 0 176zm68.7 91.3c-4-4-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9L493.2 235.8c15.6-15.6 40.9-15.6 56.6 0l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6L382.9 488.1c-4.1 4.1-9.2 7-14.9 8.4l-3.4-13.6 3.4 13.6-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2zm15.7-28.9L304 496l17.6-4.4L364.1 481c2.8-.7 5.4-2.2 7.4-4.2L514.4 333.9l-48.3-48.3L323.2 428.4c-2 2-3.5 4.6-4.2 7.4l-10.6 42.5zM552.8 295.5c9.4-9.4 9.4-24.6 0-33.9l-14.4-14.4c-9.4-9.4-24.6-9.4-33.9 0l-27.1 27.1 48.3 48.3 27.1-27.1z'
      
    ]
  };

  

  
  

  var faBucket = {
    prefix: 'fat',
    iconName: 'bucket',
    icon: [
      448,
      512,
      [],
      'e4cf',
      
      'M80 136v24c0 4.4-3.6 8-8 8s-8-3.6-8-8V136C64 60.9 124.9 0 200 0h48c75.1 0 136 60.9 136 136v16c0 4.4-3.6 8-8 8s-8-3.6-8-8V136c0-66.3-53.7-120-120-120H200C133.7 16 80 69.7 80 136zM0 200c0-4.4 3.6-8 8-8H24 40.1 407.9 424h16c4.4 0 8 3.6 8 8s-3.6 8-8 8H422L389.3 470c-3 24-23.4 42-47.6 42H106.4c-24.2 0-44.6-18-47.6-42L26 208H8c-4.4 0-8-3.6-8-8zm42.1 8L74.6 468c2 16 15.6 28 31.8 28H341.6c16.1 0 29.8-12 31.8-28l32.5-260H42.1z'
      
    ]
  };

  

  
  

  var faFrog = {
    prefix: 'fat',
    iconName: 'frog',
    icon: [
      576,
      512,
      [],
      'f52e',
      
      'M368 48c-30.9 0-56 25.1-56 56c0 .1 0 .3 0 .4c-.2 3.7-2.9 6.8-6.5 7.4L241.3 124C110.6 148.7 16 262.9 16 396v28c0 22.1 17.9 40 40 40H344c13.3 0 24-10.7 24-24s-10.7-24-24-24H304.1c-1.8 0-3.6-.6-5.1-1.8c-3.5-2.8-4-7.8-1.2-11.2l6.9-8.6 7-8.7c10.6-13.3 16.4-29.8 16.4-46.8v-3.7c0-19.5-7.9-37.2-20.6-50.1c-12.9-13-30.8-21.1-50.6-21.1c-18.9 0-37 7.5-50.3 20.9l-40.8 40.8c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l40.8-40.8c16.4-16.4 38.5-25.5 61.7-25.5c19.1 0 36.8 6.1 51.1 16.5c21.9 15.8 36.1 41.6 36.1 70.7v3.7c0 20.6-7 40.7-19.9 56.8l-3.4 4.3H344c22.1 0 40 17.9 40 40s-17.9 40-40 40H56c-30.9 0-56-25.1-56-56V396C0 255.3 100.1 134.4 238.4 108.3l57.9-11C299.7 60.7 330.5 32 368 32c39.2 0 71.1 31.4 72 70.4c39.6 7 74 18.4 97.6 27.6c24.3 9.5 38.4 33.2 38.4 58.5c0 24.9-13.6 47.7-35.4 59.6L404.2 322.5 515.9 464H568c4.4 0 8 3.6 8 8s-3.6 8-8 8H512c-2.4 0-4.8-1.1-6.3-3l-120-152c-1.5-1.8-2-4.2-1.6-6.6s1.9-4.3 4-5.4l144.8-79c16.7-9.1 27.1-26.6 27.1-45.6c0-19.5-10.8-36.8-28.2-43.6c-24.3-9.5-60.1-21.3-101.2-27.8c-4.1-.7-7-4.4-6.7-8.5c.1-1.5 .2-3 .2-4.5c0-30.9-25.1-56-56-56zm0 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faMessageLines = {
    prefix: 'fat',
    iconName: 'message-lines',
    icon: [
      512,
      512,
      ["comment-alt-lines"],
      'f4a6',
      
      'M176 416c0-8.8-7.2-16-16-16H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H309.3c-3.5 0-6.8 1.1-9.6 3.2L176 496V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h80 16v16 64c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm72 152c-4.4 0-8 3.6-8 8s3.6 8 8 8H376c4.4 0 8-3.6 8-8s-3.6-8-8-8H136zm0 96c-4.4 0-8 3.6-8 8s3.6 8 8 8H280c4.4 0 8-3.6 8-8s-3.6-8-8-8H136z'
      
    ]
  };

  
    var faCommentAltLines = faMessageLines;
  

  
  

  var faCloudExclamation = {
    prefix: 'fat',
    iconName: 'cloud-exclamation',
    icon: [
      640,
      512,
      [],
      'e491',
      
      'M522.7 220.8c3.4-8.9 5.3-18.6 5.3-28.8c0-44.2-35.8-80-80-80c-16.5 0-31.7 5-44.4 13.5c-3.7 2.5-8.2 3.3-12.5 2.3s-8-3.8-10.2-7.6C355.9 77 309.3 48 256 48c-79.5 0-144 64.5-144 144c0 2.5 .1 4.9 .2 7.3c.4 7.1-4 13.5-10.7 15.9C51.7 232.7 16 280.2 16 336c0 70.7 57.3 128 128 128H512c61.9 0 112-50.1 112-112c0-54.2-38.5-99.4-89.6-109.8c-4.6-.9-8.6-3.9-10.9-8s-2.6-9.1-.9-13.4zM256 32c53.6 0 101 26.3 130 66.7c3.1 4.3 6 8.8 8.7 13.4c3.5-2.4 7.2-4.5 11-6.4C418.5 99.5 432.8 96 448 96c53 0 96 43 96 96c0 6.6-.7 13-1.9 19.2c-1.1 5.3-2.6 10.5-4.5 15.4c5.3 1.1 10.5 2.5 15.5 4.2C603.6 247.9 640 295.7 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160zm64 128c4.4 0 8 3.6 8 8V328c0 4.4-3.6 8-8 8s-8-3.6-8-8V168c0-4.4 3.6-8 8-8zM304 384a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faToriiGate = {
    prefix: 'fat',
    iconName: 'torii-gate',
    icon: [
      512,
      512,
      [9961],
      'f6a1',
      
      'M16 96c0 26.5 21.5 48 48 48H88 424h24c26.5 0 48-21.5 48-48V17.2L450.6 35.4c-20.8 8.3-43 12.6-65.4 12.6H126.8c-22.4 0-44.6-4.3-65.4-12.6L16 17.2V96zm64 64H64C28.7 160 0 131.3 0 96V13.4C0 6 6 0 13.4 0c1.7 0 3.4 .3 5 1l49 19.6C86.3 28.1 106.5 32 126.8 32H385.2c20.4 0 40.5-3.9 59.4-11.4L493.6 1c1.6-.6 3.3-1 5-1C506 0 512 6 512 13.4V96c0 35.3-28.7 64-64 64H432v80h72c4.4 0 8 3.6 8 8s-3.6 8-8 8H432V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V256l-160 0L96 256V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V256H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H80V160zm336 0H264v80l152 0V160zm-168 0H96v80l152 0V160z'
      
    ]
  };

  

  
  

  var faPanelEws = {
    prefix: 'fat',
    iconName: 'panel-ews',
    icon: [
      512,
      512,
      [],
      'e42e',
      
      'M64 16H448c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V304c30.9 0 56 25.1 56 56v32c0 30.9 25.1 56 56 56s56-25.1 56-56V352h24c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H144c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h24v40c0 22.1-17.9 40-40 40s-40-17.9-40-40V360c0-39.8-32.2-72-72-72V64c0-26.5 21.5-48 48-48zM0 296V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V296zM96 80c-4.4 0-8 3.6-8 8s3.6 8 8 8H224c4.4 0 8-3.6 8-8s-3.6-8-8-8H96zm192 0c-4.4 0-8 3.6-8 8s3.6 8 8 8H416c4.4 0 8-3.6 8-8s-3.6-8-8-8H288zM96 144c-4.4 0-8 3.6-8 8s3.6 8 8 8H224c4.4 0 8-3.6 8-8s-3.6-8-8-8H96zm192 0c-4.4 0-8 3.6-8 8s3.6 8 8 8H416c4.4 0 8-3.6 8-8s-3.6-8-8-8H288zM208 336H176 144c-8.8 0-16-7.2-16-16V256c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16zm112-96h64c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H320c-8.8 0-16-7.2-16-16V256c0-8.8 7.2-16 16-16zm-32 16V416c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32z'
      
    ]
  };

  

  
  

  var faSubtitles = {
    prefix: 'fat',
    iconName: 'subtitles',
    icon: [
      576,
      512,
      [],
      'e60f',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H512c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM112 272H304c4.4 0 8 3.6 8 8s-3.6 8-8 8H112c-4.4 0-8-3.6-8-8s3.6-8 8-8zm256 0h96c4.4 0 8 3.6 8 8s-3.6 8-8 8H368c-4.4 0-8-3.6-8-8s3.6-8 8-8zM112 368h96c4.4 0 8 3.6 8 8s-3.6 8-8 8H112c-4.4 0-8-3.6-8-8s3.6-8 8-8zm160 0H464c4.4 0 8 3.6 8 8s-3.6 8-8 8H272c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faSunrise = {
    prefix: 'fat',
    iconName: 'sunrise',
    icon: [
      576,
      512,
      [127749],
      'f766',
      
      'M282.3 2.3c3.1-3.1 8.2-3.1 11.3 0l88 88c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L296 27.3V216c0 4.4-3.6 8-8 8s-8-3.6-8-8V27.3l-74.3 74.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l88-88zM182.5 225.2c5-2.1 10.7-1.5 15.2 1.6L288 289.1l90.3-62.3c4.5-3.1 10.2-3.7 15.2-1.6s8.6 6.6 9.6 11.9L423 345l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6l-7.4 3.1 7.4-3.1c2.1 5 1.5 10.7-1.6 15.2L489.9 464H470.5L528 380.6 414.7 359.8c-3.3-.6-5.8-3.2-6.4-6.4L387.4 240l-94.9 65.4c-2.7 1.9-6.3 1.9-9.1 0L188.6 240 167.8 353.3c-.6 3.3-3.2 5.8-6.4 6.4L48 380.6 105.5 464H86.1L34.8 389.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L153 345l19.8-107.9c1-5.3 4.6-9.8 9.6-11.9zM398.9 464H382.7c-7.6-45.4-47.1-80-94.7-80s-87.1 34.6-94.7 80H177.1c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96zM8 496H568c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faHockeyMask = {
    prefix: 'fat',
    iconName: 'hockey-mask',
    icon: [
      448,
      512,
      [],
      'f6ee',
      
      'M16 240c0-62.1 15.4-118.1 48.4-158.2C96.9 42.1 148 16 224 16s127.1 26.1 159.6 65.8C416.6 121.9 432 177.9 432 240c0 95.7-12.2 158.8-42.7 198.2C359.8 476.4 310 496 224 496s-135.8-19.6-165.3-57.8C28.2 398.8 16 335.7 16 240zM224 0C64 0 0 111 0 240C0 432 48 512 224 512s224-80 224-272C448 111 384 0 224 0zM176 224c0 26.5-21.5 48-48 48s-48-21.5-48-48V208c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v16zm-48 64c35.3 0 64-28.7 64-64V208c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v16c0 35.3 28.7 64 64 64zm192-16c-26.5 0-48-21.5-48-48V208c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v16c0 26.5-21.5 48-48 48zm64-48V208c0-17.7-14.3-32-32-32H288c-17.7 0-32 14.3-32 32v16c0 35.3 28.7 64 64 64s64-28.7 64-64zM160 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80 16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM208 320a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM304 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faLacrosseStick = {
    prefix: 'fat',
    iconName: 'lacrosse-stick',
    icon: [
      512,
      512,
      [],
      'e3b5',
      
      'M344 16c-51.2 0-96.7 32.8-112.9 81.4l-.6 1.8c-6.4 19.2-13.6 40.9-29 59.7l-34.4 42c-15 18.3-23.1 41.2-23.1 64.8C144 322.2 189.8 368 246.3 368c23.6 0 46.5-8.2 64.8-23.1l42-34.4c18.8-15.4 40.5-22.6 59.6-29l1.1-.4 0 0 .8-.3C463.2 264.7 496 219.2 496 168v0l0-.2 0-.1c0-34.8-21.6-72.7-50.3-101.4C417 37.6 379.2 16 344.4 16l-.3 0-.1 0zm0-16l.3 0C385.1 0 426.8 24.8 457 55s55 71.9 55 112.7l0 .3c0 58.1-37.2 109.7-92.3 128.1l-.8 .3c-19.8 6.6-39.1 13-55.6 26.5l-42 34.4c-21.1 17.3-47.6 26.7-74.9 26.7c-29.8 0-57-11-77.8-29.2L13.7 509.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L157.2 343.5c-18.2-20.8-29.2-48-29.2-77.8c0-27.3 9.5-53.8 26.7-74.9l34.4-42c13.5-16.5 19.9-35.8 26.5-55.6l0 0 .3-.8C234.3 37.2 285.9 0 344 0z'
      
    ]
  };

  

  
  

  var faCustard = {
    prefix: 'fat',
    iconName: 'custard',
    icon: [
      576,
      512,
      [127854],
      'e403',
      
      'M57.8 384l66.3-271.2c7-28.6 32.7-48.8 62.2-48.8H389.8c29.5 0 55.2 20.2 62.2 48.8L518.2 384H501.8L459.7 211.9C439.9 205.4 418 200 400 200c-20.7 0-35.9 7.2-52.5 15.2l-.4 .2C330.6 223.3 312.6 232 288 232s-42.6-8.7-59.1-16.6l-.4-.2c-16.7-8-31.8-15.2-52.5-15.2c-18 0-39.9 5.4-59.7 11.9L74.2 384H57.8zm63-190.3c18.1-5.4 37.9-9.7 55.2-9.7c24.6 0 42.6 8.7 59.1 16.6l.4 .2c16.7 8 31.8 15.2 52.5 15.2s35.9-7.2 52.5-15.2l.4-.2c16.5-7.9 34.5-16.6 59.1-16.6c17.3 0 37.1 4.3 55.2 9.7l-18.8-77.1C431.1 95.1 411.9 80 389.8 80H186.2c-22.1 0-41.4 15.1-46.6 36.6l-18.9 77.1zM0 440c0-4.4 3.6-8 8-8H568c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faMistletoe = {
    prefix: 'fat',
    iconName: 'mistletoe',
    icon: [
      576,
      512,
      [],
      'f7b4',
      
      'M288 0c4.4 0 8 3.6 8 8V92.7l86 86 2.9 .6 99.8 19.2C537.7 208.6 576 255 576 309c0 41.4-33.6 75-75 75c-54 0-100.3-38.3-110.5-91.3l-19.2-99.8-.6-2.9L296 115.3V266.7l2 2.7 66.8 89.1C377.3 375 384 395.2 384 416c0 53-43 96-96 96s-96-43-96-96c0-20.8 6.7-41 19.2-57.6L278 269.3l2-2.7V115.3L205.3 190l-.6 2.9-6.7 35c-4.9-1.8-10.2-3-15.6-3.6l5-25.8c-.4-.3-.7-.5-1-.9s-.6-.7-.9-1L94.3 214.2C48.9 222.9 16 262.7 16 309c0 32.6 26.4 59 59 59c25.4 0 48.8-9.9 66.2-26.3c4.7 3.1 9.9 5.5 15.4 7.3c-20.7 21.7-49.8 35-81.6 35c-41.4 0-75-33.6-75-75c0-54 38.3-100.3 91.3-110.5l99.8-19.2 2.9-.6 86-86V8c0-4.4 3.6-8 8-8zM389.7 197.7c-.3 .3-.7 .6-1 .9l17.5 91.2c8.7 45.5 48.5 78.3 94.8 78.3c32.6 0 59-26.4 59-59c0-46.3-32.9-86.1-78.3-94.8l-91.2-17.5c-.3 .4-.5 .7-.9 1zM224 368c-10.4 13.8-16 30.7-16 48c0 44.2 35.8 80 80 80s80-35.8 80-80c0-17.3-5.6-34.2-16-48l-64-85.3L224 368zM360 64a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 40a40 40 0 1 1 0-80 40 40 0 1 1 0 80zM176 264a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm40 24a40 40 0 1 1 -80 0 40 40 0 1 1 80 0z'
      
    ]
  };

  

  
  

  var faBowlScoops = {
    prefix: 'fat',
    iconName: 'bowl-scoops',
    icon: [
      448,
      512,
      [127813],
      'e3df',
      
      'M335.3 64.7C313.3 26.1 271.7 0 224 0s-89.3 26.1-111.3 64.7c5-.5 10.1-.7 15.3-.7c1.4 0 2.7 0 4 0c20.2-29 53.9-48 92-48s71.7 19 92 48c1.3 0 2.7 0 4 0c5.2 0 10.3 .2 15.3 .7zM200 118.2c-20.5-14-45.3-22.2-72-22.2C57.3 96 0 153.3 0 224H16c0-61.9 50.1-112 112-112c22.9 0 44.2 6.9 62 18.7c3.1-4.4 6.5-8.5 10-12.6zM448 224c0-70.7-57.3-128-128-128s-128 57.3-128 128h16c0-61.9 50.1-112 112-112s112 50.1 112 112h16zM17.9 280.7c-.5-4.6 3.1-8.7 7.7-8.7H422.4c4.6 0 8.3 4 7.7 8.7c-7.5 67.9-65 119.3-133.3 119.3H264c-3.2 0-6.2 1.9-7.4 4.9s-.6 6.4 1.7 8.7L335 490.3c.6 .6 1 1.5 1 2.3c0 1.8-1.5 3.3-3.3 3.3H115.3c-1.8 0-3.3-1.5-3.3-3.3c0-.9 .3-1.7 1-2.3l76.7-76.7c2.3-2.3 3-5.7 1.7-8.7s-4.2-4.9-7.4-4.9H151.2C82.9 400 25.4 348.6 17.9 280.7zM25.6 256C11.5 256 .4 268.3 2 282.4C10.4 358.5 74.7 416 151.2 416h13.4l-63 63c-3.6 3.6-5.7 8.5-5.7 13.7c0 10.7 8.6 19.3 19.3 19.3H332.7c10.7 0 19.3-8.6 19.3-19.3c0-5.1-2-10-5.7-13.7l-63-63h13.4c76.5 0 140.8-57.5 149.2-133.6c1.6-14.1-9.5-26.4-23.7-26.4H25.6z'
      
    ]
  };

  

  
  

  var faSquarePlus = {
    prefix: 'fat',
    iconName: 'square-plus',
    icon: [
      448,
      512,
      [61846,"plus-square"],
      'f0fe',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM216 352V264H128c-4.4 0-8-3.6-8-8s3.6-8 8-8h88V160c0-4.4 3.6-8 8-8s8 3.6 8 8v88h88c4.4 0 8 3.6 8 8s-3.6 8-8 8H232v88c0 4.4-3.6 8-8 8s-8-3.6-8-8z'
      
    ]
  };

  
    var faPlusSquare = faSquarePlus;
  

  
  

  var faCircleV = {
    prefix: 'fat',
    iconName: 'circle-v',
    icon: [
      512,
      512,
      [],
      'e12a',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM143.2 148.4c-2-4-6.8-5.6-10.7-3.6s-5.6 6.8-3.6 10.7l120 240c1.4 2.7 4.1 4.4 7.2 4.4s5.8-1.7 7.2-4.4l120-240c2-4 .4-8.8-3.6-10.7s-8.8-.4-10.7 3.6L256 374.1 143.2 148.4z'
      
    ]
  };

  

  
  

  var faFileBinary = {
    prefix: 'fat',
    iconName: 'file-binary',
    icon: [
      384,
      512,
      [],
      'e175',
      
      'M64 496c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm48 256c-22.1 0-40 17.9-40 40v80c0 22.1 17.9 40 40 40h32c22.1 0 40-17.9 40-40V296c0-22.1-17.9-40-40-40H112zM88 296c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H112c-13.3 0-24-10.7-24-24V296zm152-40c-4.4 0-8 3.6-8 8s3.6 8 8 8h24V400H240c-4.4 0-8 3.6-8 8s3.6 8 8 8h32 32c4.4 0 8-3.6 8-8s-3.6-8-8-8H280V264c0-4.4-3.6-8-8-8H240z'
      
    ]
  };

  

  
  

  var faNfcMagnifyingGlass = {
    prefix: 'fat',
    iconName: 'nfc-magnifying-glass',
    icon: [
      640,
      512,
      [],
      'e1f9',
      
      'M384 48H64C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H378.2c9.6 4.7 19.8 8.4 30.4 11.1c-7.6 3.2-15.9 4.9-24.6 4.9H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64v64c-5.4 0-10.7 .3-16 .8V96c0-26.5-21.5-48-48-48zm-16 88v45.4c-5.6 3.2-10.9 6.7-16 10.6V136c0-4.4-3.6-8-8-8H240c-4.4 0-8 3.6-8 8v80.8c18.3 3.7 32 19.8 32 39.2c0 22.1-17.9 40-40 40s-40-17.9-40-40c0-19.4 13.7-35.5 32-39.2V136c0-13.3 10.7-24 24-24H344c13.3 0 24 10.7 24 24zM309.4 400H104c-13.3 0-24-10.7-24-24V136c0-13.3 10.7-24 24-24h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H104c-4.4 0-8 3.6-8 8V376c0 4.4 3.6 8 8 8H301.3c2.4 5.5 5.1 10.8 8.1 16zM224 232a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM448 432.2a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0 16c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 32.5-12.1 62.1-32 84.7l93.7 93.7c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-93.7-93.7c-22.6 19.9-52.2 32-84.7 32z'
      
    ]
  };

  

  
  

  var faWindowRestore = {
    prefix: 'fat',
    iconName: 'window-restore',
    icon: [
      512,
      512,
      [],
      'f2d2',
      
      'M432 16H208c-35.3 0-64 28.7-64 64V96H128V80c0-44.2 35.8-80 80-80H432c44.2 0 80 35.8 80 80V304c0 44.2-35.8 80-80 80H416V368h16c35.3 0 64-28.7 64-64V80c0-35.3-28.7-64-64-64zM320 144H64c-26.5 0-48 21.5-48 48v64H368V192c0-26.5-21.5-48-48-48zM16 448c0 26.5 21.5 48 48 48H320c26.5 0 48-21.5 48-48V272H16V448zM64 128H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64z'
      
    ]
  };

  

  
  

  var faSailboat = {
    prefix: 'fat',
    iconName: 'sailboat',
    icon: [
      576,
      512,
      [],
      'e445',
      
      'M270.5 3.3c-2-2.8-5.6-4-9-3S256 4.5 256 8V344c0 4.4 3.6 8 8 8H504c3 0 5.7-1.7 7.1-4.3s1.1-5.9-.6-8.3l-240-336zM272 336V33L488.5 336H272zM218.1 96.3c-3.5-1-7.1 .5-9 3.6l-144 240c-1.5 2.5-1.5 5.5-.1 8.1s4.1 4.1 7 4.1H216c4.4 0 8-3.6 8-8V104c0-3.6-2.4-6.8-5.9-7.7zM86.1 336L208 132.9V336H86.1zm468.7 64l-4 14.3C537.3 462.6 493.2 496 443 496H133c-50.2 0-94.2-33.4-107.8-81.7l-4-14.3H554.9zM21.1 384c-10.6 0-18.3 10.1-15.4 20.3l4 14.3C25.3 473.9 75.6 512 133 512H443c57.3 0 107.7-38.1 123.2-93.3l4-14.3c2.9-10.2-4.8-20.3-15.4-20.3H21.1z'
      
    ]
  };

  

  
  

  var faCassetteBetamax = {
    prefix: 'fat',
    iconName: 'cassette-betamax',
    icon: [
      576,
      512,
      ["betamax"],
      'f8a4',
      
      'M16 144V416c0 26.5 21.5 48 48 48H512c26.5 0 48-21.5 48-48V144H16zm0-16H560V96c0-26.5-21.5-48-48-48H64C37.5 48 16 69.5 16 96v32zM576 96v32 8 8V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V144v-8-8V96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64zM240 304A80 80 0 1 0 80 304a80 80 0 1 0 160 0zM64 304a96 96 0 1 1 192 0A96 96 0 1 1 64 304zm96-16a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm160-80c-8.8 0-16 7.2-16 16V368c0 8.8 7.2 16 16 16H480c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H352zm-32 16c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32V368c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V240z'
      
    ]
  };

  
    var faBetamax = faCassetteBetamax;
  

  
  

  var faCrow = {
    prefix: 'fat',
    iconName: 'crow',
    icon: [
      640,
      512,
      [],
      'f520',
      
      'M352 88c0-48.6 39.4-88 88-88c34.2 0 63.8 19.5 78.4 48H568c39.8 0 72 32.2 72 72L528 148v44c0 85.3-55.6 157.6-132.6 182.6l52 126.3c1.7 4.1-.3 8.8-4.4 10.4s-8.8-.3-10.4-4.4L379.9 379c-14.1 3.3-28.8 5-43.9 5H303.2l48.2 117c1.7 4.1-.3 8.8-4.4 10.4s-8.8-.3-10.4-4.3L285.9 384H137L10.1 415.7c-3.1 .9-6.6-.2-8.6-3c-2.6-3.6-1.8-8.6 1.8-11.2L352 147.9V88zm176 43.5l94.7-23.7C617.1 82.8 594.8 64 568 64H524.7c2.2 7.6 3.3 15.7 3.3 24v43.5zM336 368c97.2 0 176-78.8 176-176V88c0-39.8-32.2-72-72-72s-72 32.2-72 72v64 .1 24c0 88.3-60.1 165.3-145.8 186.7L201 368H336zM46 390.3l172.4-43.1C296.9 327.5 352 257 352 176v-8.3L46 390.3zM440 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var fa00 = {
    prefix: 'fat',
    iconName: '00',
    icon: [
      640,
      512,
      [],
      'e467',
      
      'M144 32C64.5 32 0 96.5 0 176V336c0 79.5 64.5 144 144 144s144-64.5 144-144V176c0-79.5-64.5-144-144-144zM16 176C16 105.3 73.3 48 144 48s128 57.3 128 128V336c0 70.7-57.3 128-128 128S16 406.7 16 336V176zM496 32c-79.5 0-144 64.5-144 144V336c0 79.5 64.5 144 144 144s144-64.5 144-144V176c0-79.5-64.5-144-144-144zM368 176c0-70.7 57.3-128 128-128s128 57.3 128 128V336c0 70.7-57.3 128-128 128s-128-57.3-128-128V176z'
      
    ]
  };

  

  
  

  var faHexagonDivide = {
    prefix: 'fat',
    iconName: 'hexagon-divide',
    icon: [
      512,
      512,
      [],
      'e1ad',
      
      'M400.8 450.8l0 0L497.1 284c2.5-4.3 4.4-8.9 5.6-13.6c2-7.7 2.4-15.7 1.1-23.6c-1.1-6.5-3.3-12.9-6.7-18.8L400.8 61.2c-10-17.3-28.5-28-48.5-28H159.7c-20 0-38.5 10.7-48.5 28L14.9 228c-3.9 6.7-6.3 14.1-7.1 21.6c-1.4 11.8 1 23.9 7.1 34.4l96.3 166.8c10 17.3 28.5 28 48.5 28H352.3c20 0 38.5-10.7 48.5-28zM483.2 236c2.7 4.6 4.4 9.7 5 14.8l-2.7 20.4c-.7 1.6-1.4 3.2-2.3 4.8L386.9 442.8c-7.1 12.4-20.4 20-34.6 20H159.7c-14.3 0-27.5-7.6-34.6-20L28.8 276c-3.6-6.2-5.4-13.1-5.4-20c0-3.4 .4-6.8 1.3-10.1c.9-3.4 2.2-6.8 4.1-9.9L125.1 69.2c7.1-12.4 20.4-20 34.6-20l192.6 0c14.3 0 27.5 7.6 34.6 20L483.2 236zM240 160a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM152 248c-4.4 0-8 3.6-8 8s3.6 8 8 8H360c4.4 0 8-3.6 8-8s-3.6-8-8-8H152zm104 88a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faUserUnlock = {
    prefix: 'fat',
    iconName: 'user-unlock',
    icon: [
      640,
      512,
      [],
      'e058',
      
      'M224 240a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM178.3 320C88.7 320 16 392.7 16 482.3c0 7.6 6.1 13.7 13.7 13.7H386c1.5 5.7 3.7 11 6.5 16H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304h91.4c43.6 0 83.6 15.7 114.6 41.7c-.2 2.1-.3 4.2-.3 6.3v15.1C354.7 338 314.3 320 269.7 320H178.3zM480 256v64h32 64 16 16c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32h16V256c0-35.3 28.7-64 64-64s64 28.7 64 64v16H576V256c0-26.5-21.5-48-48-48s-48 21.5-48 48zm-16 80H448c-8.8 0-16 7.2-16 16V480c0 8.8 7.2 16 16 16H608c8.8 0 16-7.2 16-16V352c0-8.8-7.2-16-16-16H592 576 480 464z'
      
    ]
  };

  

  
  

  var faSensorFire = {
    prefix: 'fat',
    iconName: 'sensor-fire',
    icon: [
      640,
      512,
      [],
      'e02a',
      
      'M64 48H384c26.5 0 48 21.5 48 48v33.5c5.2-1.3 10.6-1.8 16-1.3V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H337.6c-4.5-5.1-8.8-10.4-12.8-16H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48zm32 56c0-4.4-3.6-8-8-8s-8 3.6-8 8V280c0 4.4 3.6 8 8 8s8-3.6 8-8V104zm64 0c0-4.4-3.6-8-8-8s-8 3.6-8 8V280c0 4.4 3.6 8 8 8s8-3.6 8-8V104zm285.5 71.9c1.5 0 2.9 .5 4 1.5c16.1 14.6 31.3 30.1 45.6 46.8c6.6 7.6 18.4 7.5 24.8-.3c5.8-7 11.9-13.9 18.2-19.6c2.3-2.1 5.9-2.1 8.2 0c18.9 17.4 38.4 41.2 53.2 67.2c14.8 26.1 24.5 54 24.5 79.7c0 49.7-25.1 93.8-63.4 119.8c9.7-14 15.4-30.7 15.4-48.7c0-57.4-63.8-110.5-87.4-128.2c-5.2-3.9-12.1-3.9-17.3 0C447.8 311.9 384 365 384 422.4c0 18.2 5.8 35 15.7 49.2c-38.7-26-63.7-70.3-63.7-120.3c0-32.3 14.1-64.9 34.7-95.2c20.5-30.2 47-57.4 70.8-78.7c1.1-1 2.6-1.5 4.1-1.5zm34.5 320c-2.7 0-5.5-.1-8.2-.2c-41.2-3.8-71.8-36-71.8-73.2c0-23 13-47 31.1-68.7c17.3-20.7 37.4-37.2 48.9-45.9c11.5 8.7 31.6 25.2 48.9 45.9C547 375.4 560 399.4 560 422.4c0 37.2-30.6 69.4-71.7 73.2c-2.7 .2-5.5 .2-8.3 .2zM320 351.3c0 85.1 65.5 155.6 150.8 160.3c3 .3 6.1 .4 9.2 .4c3.2 0 6.3-.1 9.4-.4C573.7 506.7 640 436.3 640 351.3c0-29.5-11-60.1-26.6-87.6c-15.6-27.6-36.2-52.6-56.3-71.1c-8.4-7.7-21.4-7.8-29.8-.1c-7.1 6.5-13.8 14-19.7 21.3c0 0 0 0 0 0s0 0 0 0c0 0-.1 0-.1 0s-.1 0-.1 0l0 0c0 0 0 0-.1 0c-14.8-17.2-30.5-33.2-47-48.3c-4.2-3.8-9.4-5.6-14.6-5.7c-5.3 0-10.6 1.8-14.9 5.6c-24.3 21.8-51.8 50-73.3 81.6C336 278.7 320 314.4 320 351.3z'
      
    ]
  };

  

  
  

  var faFaceExhaling = {
    prefix: 'fat',
    iconName: 'face-exhaling',
    icon: [
      576,
      512,
      [],
      'e480',
      
      'M256 16C123.5 16 16 123.5 16 256s107.5 240 240 240c43.7 0 84.6-11.6 119.8-32c3.8-2.2 8.7-.9 10.9 2.9s.9 8.7-2.9 10.9C346.2 499.6 302.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C391.7 0 502.7 105.5 511.4 238.9c.3 4.4-3 8.2-7.5 8.5s-8.2-3-8.5-7.5C487.2 114.9 383.2 16 256 16zm0 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm54.6-91.9c10.9 19.3 26.4 27.9 41 27.9s30.2-8.6 41-27.9c2.2-3.9 7-5.2 10.9-3.1s5.2 7 3 10.9c-13.1 23.4-33.6 36.1-55 36.1s-41.8-12.7-55-36.1c-2.2-3.9-.8-8.7 3.1-10.9s8.7-.8 10.9 3.1zM159.6 272c14.6 0 30.2-8.6 41-27.9c2.2-3.9 7-5.2 10.9-3.1s5.2 7 3.1 10.9c-13.1 23.4-33.6 36.1-55 36.1s-41.8-12.7-55-36.1c-2.2-3.9-.8-8.7 3.1-10.9s8.7-.8 10.9 3.1c10.9 19.3 26.4 27.9 41 27.9zm335.2 24c23.3 0 42.3 18.3 43.8 41.3C556 345.5 568 363.4 568 384s-12 38.5-29.4 46.7c-1.6 23-20.5 41.3-43.8 41.3c-13.4 0-25.4-6.1-33.4-15.6c-3.1 .7-6.2 1-9.5 1c-24.4 0-44-19.9-44-44.4c0-.4 0-.9 0-1.3l-66.2-20.1c-3.4-1-5.7-4.1-5.7-7.7s2.3-6.6 5.7-7.7l66.6-20.2c2.9-21.6 21.2-38.3 43.5-38.3c1.7 0 3.3 .1 4.9 .3c7.6-13.2 21.7-22.1 38-22.1zm-26 34c-1.5 3.8-5.6 5.9-9.6 4.8c-2.3-.6-4.8-1-7.3-1c-15.4 0-27.9 12.6-27.9 28.4c0 3.5-2.3 6.6-5.7 7.7L371.6 384l47.3 14.4c3.9 1.2 6.3 5.2 5.5 9.2c-.3 1.8-.5 3.6-.5 5.5c0 15.8 12.6 28.4 28 28.4c3.4 0 6.7-.6 9.8-1.8c3.6-1.3 7.6 0 9.6 3.2c5 7.9 13.7 13.1 23.6 13.1c15.4 0 27.9-12.6 27.9-28.4c0-.6 0-1.2-.1-1.8c-.2-3.6 2-6.9 5.4-8.1c13.9-4.7 23.9-18 23.9-33.8s-10.1-29-23.9-33.8c-3.4-1.2-5.6-4.5-5.4-8.1c0-.6 .1-1.2 .1-1.8c0-15.8-12.6-28.4-27.9-28.4c-11.8 0-21.9 7.4-26 18z'
      
    ]
  };

  

  
  

  var faTrafficLightGo = {
    prefix: 'fat',
    iconName: 'traffic-light-go',
    icon: [
      320,
      512,
      [],
      'f638',
      
      'M256 16c26.5 0 48 21.5 48 48V352c0 79.5-64.5 144-144 144S16 431.5 16 352V64c0-26.5 21.5-48 48-48H256zM64 0C28.7 0 0 28.7 0 64V352c0 88.4 71.6 160 160 160s160-71.6 160-160V64c0-35.3-28.7-64-64-64H64zm96 432a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm0-96a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm40-80a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zm-96 0a56 56 0 1 0 112 0 56 56 0 1 0 -112 0zm56-96a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm0-96a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0 312a16 16 0 1 0 0 32 16 16 0 1 0 0-32z'
      
    ]
  };

  

  
  

  var faEyeLowVision = {
    prefix: 'fat',
    iconName: 'eye-low-vision',
    icon: [
      640,
      512,
      ["low-vision"],
      'f2a8',
      
      'M1.7 3C4.5-.4 9.5-1 13 1.7l624 496c3.5 2.7 4 7.8 1.3 11.2s-7.8 4-11.2 1.3L3 14.3C-.4 11.5-1 6.5 1.7 3zM605.5 268.3c-9.6 23-26 52.8-49 82.7L544 341.1c22-28.7 37.7-57.1 46.8-78.9c1.6-3.9 1.6-8.4 0-12.3C576.7 216 546.6 166 501.7 124.3C456.6 82.4 395.6 48 320 48c-42.1 0-79.7 10.7-112.6 27.4L193.7 64.5C229.9 44.9 272.2 32 320 32c80.8 0 145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6zM320 144c60.7 0 110.2 48.3 112 108.6l-17.5-13.8C406.4 194 367.2 160 320 160c-1.8 0-3.5 0-5.2 .1l-17.5-13.8c7.3-1.5 15-2.3 22.7-2.3zM101 169.8l320 256c3.4 2.8 4 7.8 1.2 11.2s-7.8 4-11.2 1.2L91 182.2c-3.5-2.8-4-7.8-1.2-11.2s7.8-4 11.2-1.2zM73.8 243c2.8-3.5 7.8-4 11.2-1.2l250 200c3.4 2.8 4 7.8 1.2 11.2s-7.8 4-11.2 1.2L75 254.2c-3.5-2.8-4-7.8-1.2-11.2zM101 342.6l124 99.2c3.4 2.8 4 7.8 1.2 11.2s-7.8 4-11.2 1.2L91 355c-3.5-2.8-4-7.8-1.2-11.2s7.8-4 11.2-1.2z'
      
    ]
  };

  
    var faLowVision = faEyeLowVision;
  

  
  

  var faUpFromDottedLine = {
    prefix: 'fat',
    iconName: 'up-from-dotted-line',
    icon: [
      448,
      512,
      [],
      'e456',
      
      'M216 51.3c2.1-2.1 5-3.3 8-3.3s5.9 1.2 8 3.3L363.8 183.4c2.7 2.7 4.2 6.4 4.2 10.2c0 8-6.5 14.4-14.4 14.4H280c-4.4 0-8 3.6-8 8V352c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16V216c0-4.4-3.6-8-8-8H94.4c-8 0-14.4-6.5-14.4-14.4c0-3.8 1.5-7.5 4.2-10.2L216 51.3zM224 32c-7.2 0-14.2 2.9-19.3 8L72.9 172.1c-5.7 5.7-8.9 13.4-8.9 21.5C64 210.4 77.6 224 94.4 224H160V352c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V224h65.6c16.8 0 30.4-13.6 30.4-30.4c0-8.1-3.2-15.8-8.9-21.5L243.3 40c-5.1-5.1-12.1-8-19.3-8zM32 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm96 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm112-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm112-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faTrain = {
    prefix: 'fat',
    iconName: 'train',
    icon: [
      448,
      512,
      [128646],
      'f238',
      
      'M352 16c44.2 0 80 35.8 80 80V352c0 44.2-35.8 80-80 80H96c-44.2 0-80-35.8-80-80V96c0-44.2 35.8-80 80-80H352zM96 0C43 0 0 43 0 96V352c0 49.4 37.3 90.1 85.3 95.4L34.3 498.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L107.3 448H340.7l61.7 61.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-50.9-50.9c48-5.3 85.3-46 85.3-95.4V96c0-53-43-96-96-96H96zM272 320a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-48-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM96 80H352c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16zM64 96v96c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H96C78.3 64 64 78.3 64 96z'
      
    ]
  };

  

  
  

  var faLessThanEqual = {
    prefix: 'fat',
    iconName: 'less-than-equal',
    icon: [
      448,
      512,
      [],
      'f537',
      
      'M411.1 47.4c4.1-1.7 6-6.4 4.3-10.4s-6.4-6-10.4-4.3l-368 152c-3 1.2-4.9 4.2-4.9 7.4s2 6.2 4.9 7.4l368 152c4.1 1.7 8.8-.3 10.4-4.3s-.3-8.8-4.3-10.4L61 192 411.1 47.4zM8 464c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H8z'
      
    ]
  };

  

  
  

  var faHandsBubbles = {
    prefix: 'fat',
    iconName: 'hands-bubbles',
    icon: [
      576,
      512,
      ["hands-wash"],
      'e05e',
      
      'M392 64a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-64a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM16 136l0 90.5C16 283 45.9 335.3 94.6 364l1.4 .8c-5.1 2.9-9.8 6.3-14.3 10.1C31 342.8 0 286.8 0 226.5L0 136c0-22.1 17.9-40 40-40s40 17.9 40 40l0 25.7L160.4 22.4C171.5 3.2 196-3.3 215.1 7.7c7.8 4.5 13.5 11.2 16.8 18.9C242.9 7.5 267.4 1 286.5 12s25.7 35.5 14.6 54.6c8.3-1 17 .6 24.8 5.1c19.1 11 25.7 35.5 14.6 54.6l-1.6 2.8c-5 .9-10 2.4-14.9 4.5l-8.1 3.4 10.8-18.7c6.6-11.5 2.7-26.2-8.8-32.8c-11.5-6.6-26.1-2.7-32.8 8.8l0 0-42.5 73.7c-9.6 4.4-18.7 9.5-27.3 15.3l56-97 0 0 16-27.7c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8l-16 27.7 0 0-64 110.9c-2.2 3.8-7.1 5.1-10.9 2.9s-5.1-7.1-2.9-10.9l64-110.8 0 0c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8L78.9 195.5c-1.8 3.1-5.5 4.7-9 3.7s-5.9-4.1-5.9-7.7L64 136c0-13.3-10.7-24-24-24s-24 10.7-24 24zM325 512c-34.1 0-65.7-10.3-92-28c2.1-5.2 3.7-10.5 4.9-16.1C262.4 485.6 292.5 496 325 496H472c13.3 0 24-10.7 24-24c0-13.2-10.7-24-24-24l0 0-96 0c-4.4 0-8-3.6-8-8s3.6-8 8-8h96l0 0h32c13.3 0 24-10.7 24-24c0-13.2-10.7-24-24-24l0 0H376c-4.4 0-8-3.6-8-8s3.6-8 8-8H504l0 0h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H504l0 0H376c-4.4 0-8-3.6-8-8s3.6-8 8-8H504l0 0c13.3 0 24-10.7 24-24s-10.7-24-24-24H320.5c-3.8 0-7.1-2.7-7.8-6.4s1.2-7.5 4.7-9l44-18.5c12.2-5.1 18-19.2 12.8-31.4s-19.2-17.9-31.4-12.8l-75.5 31.8C211.9 232.9 176 287 176 347c0 3.6 .1 7.1 .4 10.6c-5.2-1.9-10.7-3.3-16.3-4.2c-.1-2.1-.1-4.2-.1-6.3c0-66.4 39.8-126.3 101-152.1l75.5-31.8c20.4-8.6 43.8 1 52.4 21.3s-1 43.8-21.3 52.4l-7.4 3.1H504c22.1 0 40 17.9 40 40c0 9-3 17.3-8 24c22.1 0 40 17.9 40 40s-17.9 40-40 40c5 6.7 8 15 8 24c0 22.1-17.9 40-40 40c5 6.7 8 15 8 24c0 22.1-17.9 40-40 40H325zM192 448a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM80 448a64 64 0 1 1 128 0A64 64 0 1 1 80 448zM528 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  
    var faHandsWash = faHandsBubbles;
  

  
  

  var faChartBar = {
    prefix: 'fat',
    iconName: 'chart-bar',
    icon: [
      512,
      512,
      ["bar-chart"],
      'f080',
      
      'M16 40c0-4.4-3.6-8-8-8s-8 3.6-8 8V408c0 39.8 32.2 72 72 72H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H72c-30.9 0-56-25.1-56-56V40zm96 104c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16H256c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16H384c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16zm16-224c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-192 0zm0 96c-17.7 0-32 14.3-32 32s14.3 32 32 32H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H128zm0 96c-17.7 0-32 14.3-32 32s14.3 32 32 32H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H128z'
      
    ]
  };

  
    var faBarChart = faChartBar;
  

  
  

  var faCloudShowersWater = {
    prefix: 'fat',
    iconName: 'cloud-showers-water',
    icon: [
      576,
      512,
      [],
      'e4e4',
      
      'M224 0c-53 0-96 43-96 96c-35.3 0-64 28.7-64 64s28.7 64 64 64H448c35.3 0 64-28.7 64-64s-28.7-64-64-64h-1.6C439 59.5 406.7 32 368 32c-22.2 0-42.4 9.1-56.8 23.7C295.9 22.8 262.6 0 224 0zM144 96c0-44.2 35.8-80 80-80c36.4 0 67.2 24.3 76.8 57.6c.9 3 3.4 5.2 6.4 5.7s6.1-.8 7.9-3.4C326.7 59.1 346 48 368 48c32.9 0 60.1 24.9 63.6 56.9c.4 4.1 3.9 7.1 8 7.1H448c26.5 0 48 21.5 48 48s-21.5 48-48 48H128c-26.5 0-48-21.5-48-48s21.5-48 48-48h8.4c2.2 0 4.4-.9 5.9-2.6s2.3-3.9 2.1-6.1c-.2-2.4-.3-4.8-.3-7.3zm-1.5 172.6c2.6-3.6 1.7-8.6-1.9-11.2s-8.6-1.7-11.2 1.9l-80 112c-2.6 3.6-1.7 8.6 1.9 11.2s8.6 1.7 11.2-1.9l80-112zm334.1-11.2c-3.6-2.6-8.6-1.7-11.2 1.9l-80 112c-2.6 3.6-1.7 8.6 1.9 11.2s8.6 1.7 11.2-1.9l80-112c2.6-3.6 1.7-8.6-1.9-11.2zM254.5 268.6c2.6-3.6 1.7-8.6-1.9-11.2s-8.6-1.7-11.2 1.9l-80 112c-2.6 3.6-1.7 8.6 1.9 11.2s8.6 1.7 11.2-1.9l80-112zm110.1-11.2c-3.6-2.6-8.6-1.7-11.2 1.9l-80 112c-2.6 3.6-1.7 8.6 1.9 11.2s8.6 1.7 11.2-1.9l80-112c2.6-3.6 1.7-8.6-1.9-11.2zM294.6 435.4c-3-4.3-10.2-4.3-13.2 0c-8 11.2-17.5 21.4-27.6 30.7C236.6 481.8 214.5 496 192 496s-44.6-14.2-61.8-29.9c-10.1-9.2-19.7-19.5-27.6-30.7c-1.5-2.1-3.9-3.4-6.6-3.4s-5.1 1.3-6.6 3.4c-7.3 10.3-15.9 19.6-25 28.3C48.7 478.5 28.3 492.9 7 495.6c-4.4 .6-7.5 4.6-6.9 8.9s4.6 7.5 8.9 6.9c26.5-3.3 50-20.7 66.4-36.1c8.8-8.3 15.9-16.4 20.6-22.2c5.2 6.4 13.2 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8l0 0 0 0c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c4.7 5.8 11.8 13.9 20.6 22.2c16.4 15.4 39.9 32.8 66.4 36.1c4.4 .6 8.4-2.6 8.9-6.9s-2.6-8.4-6.9-8.9c-21.3-2.7-41.7-17.1-57.4-31.9c-9.1-8.6-17.7-18-25-28.3c-1.5-2.1-3.9-3.4-6.6-3.4s-5.1 1.3-6.6 3.4c-7.9 11.2-17.5 21.5-27.6 30.7C428.6 481.8 406.5 496 384 496s-44.6-14.2-61.8-29.9c-10.1-9.2-19.6-19.5-27.6-30.7z'
      
    ]
  };

  

  
  

  var faSquareCaretUp = {
    prefix: 'fat',
    iconName: 'square-caret-up',
    icon: [
      448,
      512,
      ["caret-square-up"],
      'f151',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 64c7.3 0 14.3 3 19.3 8.4L345.2 277.6c4.4 4.7 6.8 10.8 6.8 17.2c0 13.9-11.3 25.2-25.2 25.2H121.2C107.3 320 96 308.7 96 294.8c0-6.4 2.4-12.5 6.8-17.2L204.7 168.4c5-5.4 12-8.4 19.3-8.4zM121.2 304H326.8c5.1 0 9.2-4.1 9.2-9.2c0-2.3-.9-4.6-2.5-6.3L231.6 179.3c-2-2.1-4.7-3.3-7.6-3.3s-5.6 1.2-7.6 3.3L114.5 288.5c-1.6 1.7-2.5 4-2.5 6.3c0 5.1 4.1 9.2 9.2 9.2z'
      
    ]
  };

  
    var faCaretSquareUp = faSquareCaretUp;
  

  
  

  var faTally = {
    prefix: 'fat',
    iconName: 'tally',
    icon: [
      640,
      512,
      ["tally-5"],
      'f69c',
      
      'M128 32c4.4 0 8 3.6 8 8V308.9l112-37.3V40c0-4.4 3.6-8 8-8s8 3.6 8 8V266.2l112-37.3V40c0-4.4 3.6-8 8-8s8 3.6 8 8V223.6l112-37.3V40c0-4.4 3.6-8 8-8s8 3.6 8 8V180.9l85.5-28.5c4.2-1.4 8.7 .9 10.1 5.1s-.9 8.7-5.1 10.1L520 197.8V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V203.1L392 240.4V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V245.8L264 283.1V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V288.4L136 325.8V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V331.1L34.5 359.6c-4.2 1.4-8.7-.9-10.1-5.1s.9-8.7 5.1-10.1L120 314.2V40c0-4.4 3.6-8 8-8z'
      
    ]
  };

  
    var faTally5 = faTally;
  

  
  

  var faGridRound5 = {
    prefix: 'fat',
    iconName: 'grid-round-5',
    icon: [
      448,
      512,
      [],
      'e5de',
      
      'M51.2 64A19.2 19.2 0 1 1 12.8 64a19.2 19.2 0 1 1 38.4 0zM32 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM51.2 160a19.2 19.2 0 1 1 -38.4 0 19.2 19.2 0 1 1 38.4 0zM32 128a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 108.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM0 256a32 32 0 1 0 64 0A32 32 0 1 0 0 256zm51.2 96a19.2 19.2 0 1 1 -38.4 0 19.2 19.2 0 1 1 38.4 0zM32 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 108.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM0 448a32 32 0 1 0 64 0A32 32 0 1 0 0 448zM147.2 64a19.2 19.2 0 1 1 -38.4 0 19.2 19.2 0 1 1 38.4 0zM128 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 108.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM96 160a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm51.2 96a19.2 19.2 0 1 1 -38.4 0 19.2 19.2 0 1 1 38.4 0zM128 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 108.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM96 352a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm51.2 96a19.2 19.2 0 1 1 -38.4 0 19.2 19.2 0 1 1 38.4 0zM128 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM224 44.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM192 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm51.2 96a19.2 19.2 0 1 1 -38.4 0 19.2 19.2 0 1 1 38.4 0zM224 128a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 108.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM192 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm51.2 96a19.2 19.2 0 1 1 -38.4 0 19.2 19.2 0 1 1 38.4 0zM224 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 108.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM192 448a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM339.2 64a19.2 19.2 0 1 1 -38.4 0 19.2 19.2 0 1 1 38.4 0zM320 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 108.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM288 160a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm51.2 96a19.2 19.2 0 1 1 -38.4 0 19.2 19.2 0 1 1 38.4 0zM320 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 108.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM288 352a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm51.2 96a19.2 19.2 0 1 1 -38.4 0 19.2 19.2 0 1 1 38.4 0zM320 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM416 44.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM384 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm51.2 96a19.2 19.2 0 1 1 -38.4 0 19.2 19.2 0 1 1 38.4 0zM416 128a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 108.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM384 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm51.2 96a19.2 19.2 0 1 1 -38.4 0 19.2 19.2 0 1 1 38.4 0zM416 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 108.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM384 448a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z'
      
    ]
  };

  

  
  

  var faHandBackFist = {
    prefix: 'fat',
    iconName: 'hand-back-fist',
    icon: [
      448,
      512,
      ["hand-rock"],
      'f255',
      
      'M112 56c0-30.9 25.1-56 56-56c22.9 0 42.6 13.8 51.3 33.5c4.1-1 8.4-1.5 12.7-1.5c22.9 0 42.6 13.8 51.3 33.5c4.1-1 8.4-1.5 12.7-1.5c22.9 0 42.6 13.8 51.3 33.5c4.1-1 8.4-1.5 12.7-1.5c30.9 0 56 25.1 56 56V256c0 46.8-23.7 88.1-59.7 112.6c-2.8 1.9-4.3 4.8-4.3 7.5V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V376.1c0-8.7 4.7-16.2 11.3-20.8c31.8-21.6 52.7-58 52.7-99.4V152c0-22.1-17.9-40-40-40c-5.2 0-10.2 1-14.7 2.8c-2.1 .8-4.5 .7-6.5-.3s-3.5-2.9-4.1-5.1C330 92.5 314.4 80 296 80c-5.2 0-10.2 1-14.7 2.8c-2.1 .8-4.5 .7-6.5-.3s-3.5-2.9-4.1-5.1C266 60.5 250.4 48 232 48c-5.2 0-10.2 1-14.7 2.8c-2.1 .8-4.5 .7-6.5-.3s-3.5-2.9-4.1-5.1C202 28.5 186.4 16 168 16c-22.1 0-40 17.9-40 40v64s0 0 0 0v96c0 4.4-3.6 8-8 8s-8-3.6-8-8V139.3L80.4 170.9C69.9 181.4 64 195.7 64 210.5V256c0 47.9 32.4 88.3 76.5 100.3c10.6 2.9 19.5 12.3 19.5 24.4V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V380.7c0-3.8-2.9-7.7-7.7-9C85.4 357.9 48 311.3 48 256V210.5c0-19.1 7.6-37.4 21.1-50.9L112 116.7V56z'
      
    ]
  };

  
    var faHandRock = faHandBackFist;
  

  
  

  var faMarsStrokeRight = {
    prefix: 'fat',
    iconName: 'mars-stroke-right',
    icon: [
      640,
      512,
      [9897,"mars-stroke-h"],
      'f22b',
      
      'M48 256a160 160 0 1 1 320 0A160 160 0 1 1 48 256zm335.8-8C379.6 154.5 302.5 80 208 80C110.8 80 32 158.8 32 256s78.8 176 176 176c94.5 0 171.6-74.5 175.8-168H448v56c0 4.4 3.6 8 8 8s8-3.6 8-8V264H580.7l-74.3 74.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l88-88c3.1-3.1 3.1-8.2 0-11.3l-88-88c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L580.7 248H464V192c0-4.4-3.6-8-8-8s-8 3.6-8 8v56H383.8z'
      
    ]
  };

  
    var faMarsStrokeH = faMarsStrokeRight;
  

  
  

  var faPersonChalkboard = {
    prefix: 'fat',
    iconName: 'person-chalkboard',
    icon: [
      640,
      512,
      [],
      'e53d',
      
      'M152 56a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm96 0A56 56 0 1 0 136 56a56 56 0 1 0 112 0zM122 173.9c9.7-18.4 28.8-29.9 49.5-29.9h79.6H384c8.8 0 16 7.2 16 16s-7.2 16-16 16H264c-8.8 0-16 7.2-16 16v55.8l0 .2V480c0 8.8-7.2 16-16 16s-16-7.2-16-16V360c0-13.3-10.7-24-24-24s-24 10.7-24 24V480c0 8.8-7.2 16-16 16s-16-7.2-16-16V248c0-4.4-3.6-8-8-8s-8 3.6-8 8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V360c0-4.4 3.6-8 8-8s8 3.6 8 8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V256.2l0-.2V192H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H336V48c0-17.7 14.3-32 32-32H592c17.7 0 32 14.3 32 32V272c0 17.7-14.3 32-32 32H368c-17.7 0-32-14.3-32-32V224H320v48c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48v80H251.1 171.5c-26.7 0-51.2 14.8-63.7 38.4L32.9 308.3c-2.1 3.9-.6 8.7 3.3 10.8s8.7 .6 10.8-3.3L122 173.9z'
      
    ]
  };

  

  
  

  var faRightLongToLine = {
    prefix: 'fat',
    iconName: 'right-long-to-line',
    icon: [
      640,
      512,
      [],
      'e444',
      
      'M640 72V440c0 4.4-3.6 8-8 8s-8-3.6-8-8V72c0-4.4 3.6-8 8-8s8 3.6 8 8zM320 216H40c-13.3 0-24 10.7-24 24l0 32c0 13.3 10.7 24 24 24H320c8.8 0 16 7.2 16 16v81.1c0 3.8 3.1 6.9 6.9 6.9c1.8 0 3.5-.7 4.7-1.9L495.2 257.9c.5-.5 .8-1.2 .8-1.9s-.3-1.4-.8-1.9L347.6 113.9c-1.3-1.2-3-1.9-4.7-1.9c-3.8 0-6.9 3.1-6.9 6.9V200c0 8.8-7.2 16-16 16zm38.6-113.7L506.2 242.5c3.7 3.5 5.8 8.4 5.8 13.5s-2.1 10-5.8 13.5L358.6 409.7c-4.2 4-9.9 6.3-15.8 6.3c-12.6 0-22.9-10.2-22.9-22.9V328 312H304 40c-22.1 0-40-17.9-40-40l0-32c0-22.1 17.9-40 40-40H304h16V184 118.9c0-12.6 10.2-22.9 22.9-22.9c5.9 0 11.5 2.3 15.8 6.3z'
      
    ]
  };

  

  
  

  var faSwapArrows = {
    prefix: 'fat',
    iconName: 'swap-arrows',
    icon: [
      640,
      512,
      [],
      'e60a',
      
      'M106.3 18.3c3.1-3.1 8.2-3.1 11.3 0l96 96c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L120 43.3 120 368c0 53 43 96 96 96s96-43 96-96V144c0-61.9 50.1-112 112-112s112 50.1 112 112V468.7l82.3-82.4c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-96 96c-3.1 3.1-8.2 3.1-11.3 0l-96-96c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L520 468.7 520 144c0-53-43-96-96-96s-96 43-96 96V368c0 61.9-50.1 112-112 112s-112-50.1-112-112l0-324.7L21.7 125.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l96-96z'
      
    ]
  };

  

  
  

  var faGrid5 = {
    prefix: 'fat',
    iconName: 'grid-5',
    icon: [
      448,
      512,
      [],
      'e199',
      
      'M48 44.8c1.8 0 3.2 1.4 3.2 3.2V80c0 1.8-1.4 3.2-3.2 3.2H16c-1.8 0-3.2-1.4-3.2-3.2V48c0-1.8 1.4-3.2 3.2-3.2H48zM16 32C7.2 32 0 39.2 0 48V80c0 8.8 7.2 16 16 16H48c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H16zM48 140.8c1.8 0 3.2 1.4 3.2 3.2v32c0 1.8-1.4 3.2-3.2 3.2H16c-1.8 0-3.2-1.4-3.2-3.2V144c0-1.8 1.4-3.2 3.2-3.2H48zM16 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16H48c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H16zm0 108.8H48c1.8 0 3.2 1.4 3.2 3.2v32c0 1.8-1.4 3.2-3.2 3.2H16c-1.8 0-3.2-1.4-3.2-3.2V240c0-1.8 1.4-3.2 3.2-3.2zM0 240v32c0 8.8 7.2 16 16 16H48c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zm48 92.8c1.8 0 3.2 1.4 3.2 3.2v32c0 1.8-1.4 3.2-3.2 3.2H16c-1.8 0-3.2-1.4-3.2-3.2V336c0-1.8 1.4-3.2 3.2-3.2H48zM16 320c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16H48c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H16zm0 108.8H48c1.8 0 3.2 1.4 3.2 3.2v32c0 1.8-1.4 3.2-3.2 3.2H16c-1.8 0-3.2-1.4-3.2-3.2V432c0-1.8 1.4-3.2 3.2-3.2zM0 432v32c0 8.8 7.2 16 16 16H48c8.8 0 16-7.2 16-16V432c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zM144 44.8c1.8 0 3.2 1.4 3.2 3.2V80c0 1.8-1.4 3.2-3.2 3.2H112c-1.8 0-3.2-1.4-3.2-3.2V48c0-1.8 1.4-3.2 3.2-3.2h32zM112 32c-8.8 0-16 7.2-16 16V80c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H112zm0 108.8h32c1.8 0 3.2 1.4 3.2 3.2v32c0 1.8-1.4 3.2-3.2 3.2H112c-1.8 0-3.2-1.4-3.2-3.2V144c0-1.8 1.4-3.2 3.2-3.2zM96 144v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm48 92.8c1.8 0 3.2 1.4 3.2 3.2v32c0 1.8-1.4 3.2-3.2 3.2H112c-1.8 0-3.2-1.4-3.2-3.2V240c0-1.8 1.4-3.2 3.2-3.2h32zM112 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H112zm0 108.8h32c1.8 0 3.2 1.4 3.2 3.2v32c0 1.8-1.4 3.2-3.2 3.2H112c-1.8 0-3.2-1.4-3.2-3.2V336c0-1.8 1.4-3.2 3.2-3.2zM96 336v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm48 92.8c1.8 0 3.2 1.4 3.2 3.2v32c0 1.8-1.4 3.2-3.2 3.2H112c-1.8 0-3.2-1.4-3.2-3.2V432c0-1.8 1.4-3.2 3.2-3.2h32zM112 416c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V432c0-8.8-7.2-16-16-16H112zM208 44.8h32c1.8 0 3.2 1.4 3.2 3.2V80c0 1.8-1.4 3.2-3.2 3.2H208c-1.8 0-3.2-1.4-3.2-3.2V48c0-1.8 1.4-3.2 3.2-3.2zM192 48V80c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm48 92.8c1.8 0 3.2 1.4 3.2 3.2v32c0 1.8-1.4 3.2-3.2 3.2H208c-1.8 0-3.2-1.4-3.2-3.2V144c0-1.8 1.4-3.2 3.2-3.2h32zM208 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H208zm0 108.8h32c1.8 0 3.2 1.4 3.2 3.2v32c0 1.8-1.4 3.2-3.2 3.2H208c-1.8 0-3.2-1.4-3.2-3.2V240c0-1.8 1.4-3.2 3.2-3.2zM192 240v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm48 92.8c1.8 0 3.2 1.4 3.2 3.2v32c0 1.8-1.4 3.2-3.2 3.2H208c-1.8 0-3.2-1.4-3.2-3.2V336c0-1.8 1.4-3.2 3.2-3.2h32zM208 320c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H208zm0 108.8h32c1.8 0 3.2 1.4 3.2 3.2v32c0 1.8-1.4 3.2-3.2 3.2H208c-1.8 0-3.2-1.4-3.2-3.2V432c0-1.8 1.4-3.2 3.2-3.2zM192 432v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V432c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zM336 44.8c1.8 0 3.2 1.4 3.2 3.2V80c0 1.8-1.4 3.2-3.2 3.2H304c-1.8 0-3.2-1.4-3.2-3.2V48c0-1.8 1.4-3.2 3.2-3.2h32zM304 32c-8.8 0-16 7.2-16 16V80c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H304zm0 108.8h32c1.8 0 3.2 1.4 3.2 3.2v32c0 1.8-1.4 3.2-3.2 3.2H304c-1.8 0-3.2-1.4-3.2-3.2V144c0-1.8 1.4-3.2 3.2-3.2zM288 144v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H304c-8.8 0-16 7.2-16 16zm48 92.8c1.8 0 3.2 1.4 3.2 3.2v32c0 1.8-1.4 3.2-3.2 3.2H304c-1.8 0-3.2-1.4-3.2-3.2V240c0-1.8 1.4-3.2 3.2-3.2h32zM304 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H304zm0 108.8h32c1.8 0 3.2 1.4 3.2 3.2v32c0 1.8-1.4 3.2-3.2 3.2H304c-1.8 0-3.2-1.4-3.2-3.2V336c0-1.8 1.4-3.2 3.2-3.2zM288 336v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H304c-8.8 0-16 7.2-16 16zm48 92.8c1.8 0 3.2 1.4 3.2 3.2v32c0 1.8-1.4 3.2-3.2 3.2H304c-1.8 0-3.2-1.4-3.2-3.2V432c0-1.8 1.4-3.2 3.2-3.2h32zM304 416c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V432c0-8.8-7.2-16-16-16H304zM400 44.8h32c1.8 0 3.2 1.4 3.2 3.2V80c0 1.8-1.4 3.2-3.2 3.2H400c-1.8 0-3.2-1.4-3.2-3.2V48c0-1.8 1.4-3.2 3.2-3.2zM384 48V80c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H400c-8.8 0-16 7.2-16 16zm48 92.8c1.8 0 3.2 1.4 3.2 3.2v32c0 1.8-1.4 3.2-3.2 3.2H400c-1.8 0-3.2-1.4-3.2-3.2V144c0-1.8 1.4-3.2 3.2-3.2h32zM400 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H400zm0 108.8h32c1.8 0 3.2 1.4 3.2 3.2v32c0 1.8-1.4 3.2-3.2 3.2H400c-1.8 0-3.2-1.4-3.2-3.2V240c0-1.8 1.4-3.2 3.2-3.2zM384 240v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H400c-8.8 0-16 7.2-16 16zm48 92.8c1.8 0 3.2 1.4 3.2 3.2v32c0 1.8-1.4 3.2-3.2 3.2H400c-1.8 0-3.2-1.4-3.2-3.2V336c0-1.8 1.4-3.2 3.2-3.2h32zM400 320c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H400zm0 108.8h32c1.8 0 3.2 1.4 3.2 3.2v32c0 1.8-1.4 3.2-3.2 3.2H400c-1.8 0-3.2-1.4-3.2-3.2V432c0-1.8 1.4-3.2 3.2-3.2zM384 432v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V432c0-8.8-7.2-16-16-16H400c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faArrowDownToLine = {
    prefix: 'fat',
    iconName: 'arrow-down-to-line',
    icon: [
      384,
      512,
      ["arrow-to-bottom"],
      'f33d',
      
      'M8 480c-4.4 0-8-3.6-8-8s3.6-8 8-8l368 0c4.4 0 8 3.6 8 8s-3.6 8-8 8L8 480zm189.7-98.3c-3.1 3.1-8.2 3.1-11.3 0l-136-136c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L184 356.7 184 40c0-4.4 3.6-8 8-8s8 3.6 8 8l0 316.7L322.3 234.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-136 136z'
      
    ]
  };

  
    var faArrowToBottom = faArrowDownToLine;
  

  
  

  var faRepeat1 = {
    prefix: 'fat',
    iconName: 'repeat-1',
    icon: [
      512,
      512,
      [128258],
      'f365',
      
      'M355.3 172.7c-2.1 2.1-5 3.3-8 3.3c-6.2 0-11.3-5.1-11.3-11.3V96l0-68.7c0-6.2 5.1-11.3 11.3-11.3c3 0 5.9 1.2 8 3.3L432 96l-76.7 76.7zM320 104v60.7c0 15.1 12.2 27.3 27.3 27.3c7.2 0 14.2-2.9 19.3-8l76.7-76.7c3-3 4.7-7.1 4.7-11.3s-1.7-8.3-4.7-11.3L366.6 8c-5.1-5.1-12.1-8-19.3-8C332.2 0 320 12.2 320 27.3V88H168C75.2 88 0 163.2 0 256v8c0 4.4 3.6 8 8 8s8-3.6 8-8v-8c0-83.9 68.1-152 152-152H320zM156.7 339.3c2.1-2.1 5-3.3 8-3.3c6.2 0 11.3 5.1 11.3 11.3V416l0 68.7c0 6.2-5.1 11.3-11.3 11.3c-3 0-5.9-1.2-8-3.3L80 416l76.7-76.7zM192 408V347.3c0-15.1-12.2-27.3-27.3-27.3c-7.2 0-14.2 2.9-19.3 8L68.7 404.7c-3 3-4.7 7.1-4.7 11.3s1.7 8.3 4.7 11.3L145.4 504c5.1 5.1 12.1 8 19.3 8c15.1 0 27.3-12.2 27.3-27.3V424H344c92.8 0 168-75.2 168-168v-8c0-4.4-3.6-8-8-8s-8 3.6-8 8v8c0 83.9-68.1 152-152 152H192zm88-208c0-2.9-1.6-5.5-4.1-7s-5.6-1.4-8.1 .1l-40 24c-3.8 2.3-5 7.2-2.7 11s7.2 5 11 2.7L264 214.1V312c0 4.4 3.6 8 8 8s8-3.6 8-8V200z'
      
    ]
  };

  

  
  

  var faBuildingCircleCheck = {
    prefix: 'fat',
    iconName: 'building-circle-check',
    icon: [
      640,
      512,
      [],
      'e4d2',
      
      'M48 16H336c17.7 0 32 14.3 32 32V247.2c5-5.3 10.4-10.3 16-15V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96 16 64 16 96c15.1 0 28.5-6.9 37.3-17.8c-3.9-3.8-7.6-7.7-11.1-11.8c-5.8 8.2-15.4 13.6-26.2 13.6H240V416c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-17.7 0-32-14.3-32-32V48c0-17.7 14.3-32 32-32zM224 496H160V416c0-17.7 14.3-32 32-32s32 14.3 32 32v80zM104 232c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V256c0-13.3-10.7-24-24-24H104zm-8 24c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8V256zm128 0v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V256c0-13.3-10.7-24-24-24H248c-13.3 0-24 10.7-24 24zm24-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H248c-4.4 0-8-3.6-8-8V256c0-4.4 3.6-8 8-8zM104 104c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V128c0-13.3-10.7-24-24-24H104zm-8 24c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8V128zm128 0v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V128c0-13.3-10.7-24-24-24H248c-13.3 0-24 10.7-24 24zm24-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H248c-4.4 0-8-3.6-8-8V128c0-4.4 3.6-8 8-8zM496 240a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm69.7-189.7c-3.1-3.1-8.2-3.1-11.3 0L480 396.7l-42.3-42.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l48 48c3.1 3.1 8.2 3.1 11.3 0l80-80c3.1-3.1 3.1-8.2 0-11.3z'
      
    ]
  };

  

  
  

  var faBurgerCheese = {
    prefix: 'fat',
    iconName: 'burger-cheese',
    icon: [
      512,
      512,
      [127828,"cheeseburger"],
      'f7f1',
      
      'M450.9 208H61.1c-7.2 0-13.1-5.9-13.1-13.1c0-1 .1-1.4 .2-1.7c2.3-9.2 13-45.7 43.6-79.7C121.9 80 172.1 48 256 48s134.1 32 164.3 65.5c30.6 34 41.3 70.5 43.6 79.7c.1 .3 .2 .7 .2 1.7c0 7.2-5.9 13.1-13.1 13.1zM61.1 224H450.9c16.1 0 29.1-13 29.1-29.1c0-1.9-.2-3.7-.6-5.6C474.1 168.3 433.2 32 256 32S37.9 168.3 32.6 189.3c-.5 1.9-.6 3.7-.6 5.6C32 211 45 224 61.1 224zM59.4 400H452.6c6.3 0 11.4 5.1 11.4 11.4c0 29-23.5 52.6-52.6 52.6H100.6c-29 0-52.6-23.5-52.6-52.6c0-6.3 5.1-11.4 11.4-11.4zm0-16C44.3 384 32 396.3 32 411.4c0 37.9 30.7 68.6 68.6 68.6H411.4c37.9 0 68.6-30.7 68.6-68.6c0-15.1-12.3-27.4-27.4-27.4H59.4zM144 144a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm240-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM256 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm46.2 215.4c10.7 7.2 24.8 7.2 35.5 0L414.8 276c3.9-2.6 8.5-4 13.2-4H432h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H370.4l-24 16H448c26.5 0 48-21.5 48-48s-21.5-48-48-48H432h-3.9H211.9 208 192 64c-26.5 0-48 21.5-48 48s21.5 48 48 48H293.6l-24-16H64c-17.7 0-32-14.3-32-32s14.3-32 32-32H192h16 3.9c4.7 0 9.3 1.4 13.2 4l77.1 51.4zM392 272l-63.1 42.1c-5.4 3.6-12.4 3.6-17.8 0L248 272H392z'
      
    ]
  };

  
    var faCheeseburger = faBurgerCheese;
  

  
  

  var faChessBoard = {
    prefix: 'fat',
    iconName: 'chess-board',
    icon: [
      448,
      512,
      [],
      'f43c',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm80-8h48 64 64 64 48c13.3 0 24 10.7 24 24v48 64 64 64 48c0 13.3-10.7 24-24 24H320 256 192 128 80c-13.3 0-24-10.7-24-24V352 288 224 160 112c0-13.3 10.7-24 24-24zm-8 24v40h48V104H80c-4.4 0-8 3.6-8 8zm64 40h48V104H136v48zm64 0h48V104H200v48zm64 0h48V104H264v48zm64 0h48V112c0-4.4-3.6-8-8-8H328v48zm0 16v48h48V168H328zm0 64v48h48V232H328zm0 64v48h48V296H328zm0 64v48h40c4.4 0 8-3.6 8-8V360H328zm-16 0H264v48h48V360zm-64 0H200v48h48V360zm-64 0H136v48h48V360zm-64 0H72v40c0 4.4 3.6 8 8 8h40V360zm0-16V296H72v48h48zm0-64V232H72v48h48zm0-64V168H72v48h48zm16 0h48V168H136v48zm64 0h48V168H200v48zm64 0h48V168H264v48zm0 16v48h48V232H264zm0 64v48h48V296H264zm-16 0H200v48h48V296zm-64 0H136v48h48V296zm0-16V232H136v48h48zm16 0h48V232H200v48z'
      
    ]
  };

  

  
  

  var faBringFront = {
    prefix: 'fat',
    iconName: 'bring-front',
    icon: [
      640,
      512,
      [],
      'f857',
      
      'M64 16H192c26.5 0 48 21.5 48 48h16c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V192c0 35.3 28.7 64 64 64h64V240H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48zM448 512H576c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H512v16h64c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H448c-26.5 0-48-21.5-48-48H384c0 35.3 28.7 64 64 64zM416 112c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H224c-26.5 0-48-21.5-48-48V160c0-26.5 21.5-48 48-48H416zM224 96c-35.3 0-64 28.7-64 64V352c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H224zm32 80H384c8.8 0 16 7.2 16 16V320c0 8.8-7.2 16-16 16H256c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16zm-32 16V320c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32z'
      
    ]
  };

  

  
  

  var faUpLeft = {
    prefix: 'fat',
    iconName: 'up-left',
    icon: [
      384,
      512,
      [],
      'e2bd',
      
      'M48 96c-8.8 0-16 7.2-16 16V347.7c0 11.2 9.1 20.3 20.3 20.3c5.4 0 10.5-2.1 14.3-5.9l75.7-75.7c3.1-3.1 8.2-3.1 11.3 0L290.3 423c5.7 5.7 13.5 9 21.7 9s15.9-3.2 21.7-9L359 397.6c5.7-5.7 9-13.5 9-21.7s-3.2-15.9-9-21.7L222.3 217.7c-1.5-1.5-2.3-3.5-2.3-5.7s.8-4.2 2.3-5.7l75.7-75.7c3.8-3.8 5.9-9 5.9-14.3c0-11.2-9.1-20.3-20.3-20.3H48zM16 112c0-17.7 14.3-32 32-32H283.7c20 0 36.3 16.2 36.3 36.3c0 9.6-3.8 18.9-10.6 25.7L239.3 212l131 131c8.7 8.7 13.7 20.6 13.7 33s-4.9 24.2-13.7 33L345 434.3c-8.7 8.7-20.6 13.7-33 13.7s-24.2-4.9-33-13.7l-131-131L77.9 373.4c-6.8 6.8-16 10.6-25.7 10.6c-20 0-36.3-16.2-36.3-36.3V112z'
      
    ]
  };

  

  
  

  var faSquareQuote = {
    prefix: 'fat',
    iconName: 'square-quote',
    icon: [
      448,
      512,
      [],
      'e329',
      
      'M384 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 224c-17.7 0-32-14.3-32-32V208c0-17.7 14.3-32 32-32h16c17.7 0 32 14.3 32 32v8 8c0 17.7-14.3 32-32 32H144zm64-40v-8c0-26.5-21.5-48-48-48H144c-26.5 0-48 21.5-48 48v16c0 26.5 21.5 48 48 48h16c12.3 0 23.5-4.6 32-12.2v26.6c0 19.9-14.6 36.8-34.3 39.6l-14.8 2.1c-4.4 .6-7.4 4.7-6.8 9s4.7 7.4 9.1 6.8l14.8-2.1c27.6-3.9 48.1-27.6 48.1-55.4V224v-8zm80 40c-17.7 0-32-14.3-32-32V208c0-17.7 14.3-32 32-32h16c17.7 0 32 14.3 32 32v8 8c0 17.7-14.3 32-32 32H288zm64-40v-8c0-26.5-21.5-48-48-48H288c-26.5 0-48 21.5-48 48v16c0 26.5 21.5 48 48 48h16c12.3 0 23.5-4.6 32-12.2v26.6c0 19.9-14.6 36.8-34.3 39.6l-14.8 2.1c-4.4 .6-7.4 4.7-6.8 9s4.7 7.4 9.1 6.8l14.8-2.1c27.6-3.9 48.1-27.6 48.1-55.4V224v-8z'
      
    ]
  };

  

  
  

  var faHoodCloak = {
    prefix: 'fat',
    iconName: 'hood-cloak',
    icon: [
      576,
      512,
      [],
      'f6ef',
      
      'M20.6 468.8l0 0 .2-.2 .2-.2 0 0 .1-.1C65.9 420.5 80 346.7 80 288V256C80 123.5 187.5 16 320 16H432c3.3 0 6.3 2 7.5 5.1c1 2.5 .6 5.4-1 7.6c-3.4 4.7-8.1 9.3-14.1 14.4c-1.9 1.6-4.1 3.4-6.5 5.4l0 0c-4.2 3.4-8.7 7.2-12.5 10.6c-3.3 3-5.3 7.4-5.2 11.9s1.9 8.8 5.3 11.9C452.2 124.7 496 190.3 496 288c0 58.6 14 132.4 59 180.3l0 0 .1 .1 .3 .3 0 0 0 0c4.5 4.6 5.8 11.4 3.4 17.3c-2.5 6-8.3 9.9-14.8 9.9H416V320c0-70.7-57.3-128-128-128s-128 57.3-128 128V496H32c-6.5 0-12.3-3.9-14.8-9.9c-2.5-5.9-1.1-12.8 3.4-17.4zM176 496V320c0-61.9 50.1-112 112-112s112 50.1 112 112V496H176zm397.6-3.8c4.9-11.9 2.2-25.6-6.8-34.7l0 0-.1-.1C525.8 413.8 512 345 512 288c0-94.9-39.4-161.6-84.2-206.2c-3.9-3.8-7.7-7.5-11.7-11c3.5-3.2 7.4-6.3 11.3-9.5l1.1-.9c8.4-6.9 17-14 23-22.4c4.7-6.5 5.9-15 2.9-22.7C450.8 6.1 441.9 0 432 0H320C178.6 0 64 114.6 64 256v32c0 57.1-13.9 125.9-54.6 169.4l-.2 .2c-9 9.1-11.7 22.8-6.8 34.7c5 12 16.6 19.8 29.6 19.8H544c12.9 0 24.6-7.8 29.6-19.8z'
      
    ]
  };

  

  
  

  var faGlasses = {
    prefix: 'fat',
    iconName: 'glasses',
    icon: [
      576,
      512,
      [],
      'f530',
      
      'M70.8 77.7c4.4-17.5 20-29.7 38-29.7c6.1 0 12.1 1.4 17.5 4.1l22 11c4 2 8.8 .4 10.7-3.6s.4-8.8-3.6-10.7l-22-11C125.9 34 117.4 32 108.9 32C83.5 32 61.4 49.2 55.3 73.8L6 271.1C3 282.9 1.2 294.9 .4 306.9c-.3 1.7-.4 3.4-.4 5.1v7.6V336v32c0 61.9 50.1 112 112 112h44.3c59.4 0 108.5-46.4 111.8-105.8l3.8-60.4c.2-3.3-.2-6.6-1-9.8h34c-.8 3.1-1.2 6.4-1 9.8l3.8 60.4C311.1 433.6 360.2 480 419.7 480H464c61.9 0 112-50.1 112-112V336 319.6 312c0-1.7-.1-3.4-.4-5.1c-.8-12.1-2.6-24-5.6-35.8L520.7 73.8C514.6 49.2 492.5 32 467.1 32c-8.6 0-17 2-24.7 5.8l-22 11c-4 2-5.6 6.8-3.6 10.7s6.8 5.6 10.7 3.6l22-11c5.4-2.7 11.4-4.1 17.5-4.1c18 0 33.7 12.2 38 29.7L554.5 275c.6 2.4 1.2 4.9 1.7 7.3C520.6 265.2 479.5 256 440.3 256c-40.1 0-82.2 9.6-118.5 27.3c-2.7 1.4-5.2 3.1-7.4 5.1c-.8-.2-1.6-.4-2.4-.4H264c-.8 0-1.7 .1-2.4 .4c-2.2-2-4.7-3.7-7.4-5.1C217.9 265.6 175.8 256 135.7 256c-39.1 0-80.3 9.2-115.9 26.3c.5-2.5 1.1-4.9 1.7-7.3L70.8 77.7zM16 319.6c0-3.6 .1-7.2 .3-10.8c1-4.7 4-8.9 8.5-11.1C58.5 281 98.1 272 135.7 272c37.7 0 77.4 9 111.4 25.7c5.7 2.9 9.2 8.9 8.9 15.2l-3.8 60.4 0 0 0 .1c-2.8 50.9-44.9 90.7-95.9 90.7H112c-53 0-96-43-96-96V336 319.6zm535.2-21.9c4.4 2.2 7.5 6.4 8.5 11.1c.2 3.6 .3 7.2 .3 10.8V336v32c0 53-43 96-96 96H419.7c-51 0-93-39.8-95.9-90.7l0-.1 0 0L320 312.8c-.3-6.3 3.2-12.3 8.9-15.2c34-16.6 73.7-25.7 111.4-25.7c37.5 0 77.2 9 110.9 25.7z'
      
    ]
  };

  

  
  

  var faPaintbrushFine = {
    prefix: 'fat',
    iconName: 'paintbrush-fine',
    icon: [
      576,
      512,
      ["paint-brush-alt","paint-brush-fine","paintbrush-alt"],
      'f5a9',
      
      'M548.2 27.7c-15.6-15.6-40.9-15.6-56.6 0L297.3 222l56.6 56.6L548.2 84.3c15.6-15.6 15.6-40.9 0-56.6zM286 233.3l-26.3 26.3 0 0L205.3 314l56.6 56.6 2.3-2.3 0 0 52.1-52.1 26.3-26.3L286 233.3zm-94 90c-7.6-2.2-15.7-3.3-24-3.3c-48.6 0-88 39.4-88 88c0 1.4 0 2.9 .1 4.3c.6 12.3-3.3 24.7-10.6 34.3C62.2 456.3 50.5 464 36 464H32c-8.8 0-16 7.2-16 16s7.2 16 16 16H168h5c.6-.1 1.3-.2 1.9-.3c45.4-3.5 81.1-41.5 81.1-87.7c0-8.3-1.2-16.4-3.3-24L192 323.3zM559.5 95.6L269.6 385.5c1.6 7.2 2.4 14.7 2.4 22.5c0 54.7-42.2 99.5-95.9 103.7c-.1 0-.1 .1-.1 .2s-.1 .2-.2 .2H168 32c-17.7 0-32-14.3-32-32s14.3-32 32-32h4c17.1 0 29-17.8 28.2-35c-.1-1.7-.1-3.4-.1-5c0-57.4 46.6-104 104-104c7.7 0 15.1 .8 22.3 2.4l290-290c21.9-21.9 57.3-21.9 79.2 0s21.9 57.3 0 79.2z'
      
    ]
  };

  
    var faPaintBrushAlt = faPaintbrushFine;
  
    var faPaintBrushFine = faPaintbrushFine;
  
    var faPaintbrushAlt = faPaintbrushFine;
  

  
  

  var faChessQueen = {
    prefix: 'fat',
    iconName: 'chess-queen',
    icon: [
      512,
      512,
      [9819],
      'f445',
      
      'M256 16a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm0 96A56 56 0 1 0 256 0a56 56 0 1 0 0 112zm-95.2 8c-10 0-17.7 7.1-20.3 15.6c-10 32.7-40.5 56.5-76.5 56.5c-14.2 0-27.5-3.7-39.1-10.2c-4.4-2.4-9.9-2.8-14.6-.2c-7.3 3.9-10 12.9-6.1 20.2L101.3 384h18.1L20 197.4c13.2 6.8 28.2 10.7 44 10.7c43.2 0 79.7-28.5 91.8-67.8c.9-2.9 3.1-4.3 5-4.3c1.6 0 3.4 1 4.5 2.9C183.1 170.6 217.1 192 256 192s72.9-21.4 90.7-53.1c1.1-2 2.9-2.9 4.5-2.9c1.9 0 4.2 1.4 5 4.3c12.1 39.2 48.6 67.8 91.8 67.8c15.9 0 30.8-3.9 44-10.7L392.5 384h18.1l97.1-182.1c3.9-7.3 1.1-16.3-6.1-20.2c-4.8-2.5-10.3-2.2-14.6 .2c-11.5 6.5-24.9 10.2-39.1 10.2c-36 0-66.4-23.8-76.5-56.5c-2.6-8.5-10.3-15.6-20.3-15.6c-8.1 0-14.8 4.7-18.4 11.1C317.6 157.9 288.9 176 256 176s-61.6-18.1-76.7-44.9c-3.6-6.4-10.4-11.1-18.4-11.1zM126.3 432H385.7c4.5 0 8.9 1.9 11.9 5.3l30.6 33.9c2.5 2.7 3.8 6.3 3.8 9.9c0 8.2-6.6 14.8-14.8 14.8H94.8c-8.2 0-14.8-6.6-14.8-14.8c0-3.7 1.4-7.2 3.8-9.9l30.6-33.9c3-3.4 7.4-5.3 11.9-5.3zm313.8 28.5l-30.6-33.9c-6.1-6.7-14.7-10.6-23.8-10.6H126.3c-9.1 0-17.7 3.8-23.8 10.6L71.9 460.5c-5.1 5.7-7.9 13-7.9 20.6c0 17 13.8 30.8 30.8 30.8H417.2c17 0 30.8-13.8 30.8-30.8c0-7.6-2.8-15-7.9-20.6z'
      
    ]
  };

  

  
  

  var faTreasureChest = {
    prefix: 'fat',
    iconName: 'treasure-chest',
    icon: [
      576,
      512,
      [],
      'f723',
      
      'M136 48V272h80V224c0-26.5 21.5-48 48-48h48c26.5 0 48 21.5 48 48v48h80V48H136zM312 368H264c-26.5 0-48-21.5-48-48V288H136V464H440V288H360v32c0 26.5-21.5 48-48 48zM120 48.3C61.9 52.4 16 100.8 16 160V272H120V48.3zM16 288V432c0 17.7 14.3 32 32 32h72V288H16zM456 464h72c17.7 0 32-14.3 32-32V288H456V464zM560 272V160c0-59.2-45.9-107.6-104-111.7V272H560zM0 160C0 89.3 57.3 32 128 32H448c70.7 0 128 57.3 128 128V432c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V160zm312 32H264c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zm-16 48v64c0 4.4-3.6 8-8 8s-8-3.6-8-8V240c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faMessageArrowUpRight = {
    prefix: 'fat',
    iconName: 'message-arrow-up-right',
    icon: [
      512,
      512,
      [],
      'e1dd',
      
      'M176 416c0-8.8-7.2-16-16-16H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H309.3c-3.5 0-6.8 1.1-9.6 3.2L176 496V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h80 16v16 64c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM200 120c-4.4 0-8 3.6-8 8s3.6 8 8 8H308.7L170.3 274.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L320 147.3V256c0 4.4 3.6 8 8 8s8-3.6 8-8V128c0-4.4-3.6-8-8-8H200z'
      
    ]
  };

  

  
  

  var faFileSlash = {
    prefix: 'fat',
    iconName: 'file-slash',
    icon: [
      640,
      512,
      [],
      'e3a7',
      
      'M512 179.9c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-20.1 0-38.1 9.3-49.8 23.9l12.6 9.9C163.5 22.9 176.9 16 192 16H332.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H495.8c.2 1.3 .2 2.6 .2 3.9V303.2l16 12.6v-136zM144 448V208.8l-16-12.6V448c0 35.3 28.7 64 64 64H448c20.1 0 38.1-9.3 49.8-23.9l-12.6-9.9C476.5 489.1 463.1 496 448 496H192c-26.5 0-48-21.5-48-48zM489.1 160H376c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L486.6 157.3c.9 .9 1.7 1.8 2.4 2.7zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  

  
  

  var faCoinFront = {
    prefix: 'fat',
    iconName: 'coin-front',
    icon: [
      512,
      512,
      [],
      'e3fc',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-432a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 368a192 192 0 1 0 0-384 192 192 0 1 0 0 384zm8-280c0-4.4-3.6-8-8-8s-8 3.6-8 8V344c0 4.4 3.6 8 8 8s8-3.6 8-8V168z'
      
    ]
  };

  

  
  

  var faGaugeCircleBolt = {
    prefix: 'fat',
    iconName: 'gauge-circle-bolt',
    icon: [
      640,
      512,
      [],
      'e496',
      
      'M256 496c35.6 0 69.4-7.7 99.8-21.6c3.3 4.4 6.9 8.6 10.6 12.7C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-2.9 0-5.7 .1-8.6 .2C459.5 90.6 366.5 16 256 16C123.5 16 16 123.5 16 256s107.5 240 240 240zm0-96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 16c-35.3 0-64-28.7-64-64c0-32.6 24.4-59.6 56-63.5V80c0-4.4 3.6-8 8-8s8 3.6 8 8V288.5c31.6 3.9 56 30.9 56 63.5c0 35.3-28.7 64-64 64zM144 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM80 240a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM352 128a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM496 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm36.5 57.4c3 2 4.3 5.8 3.1 9.2L517.8 344H576c3.3 0 6.3 2.1 7.5 5.2s.2 6.7-2.3 8.8l-112 96c-2.7 2.3-6.7 2.6-9.7 .6s-4.3-5.8-3.1-9.2L474.2 392H416c-3.3 0-6.3-2.1-7.5-5.2s-.2-6.7 2.3-8.8l112-96c2.7-2.3 6.7-2.6 9.7-.6zM437.6 376h47.7c2.6 0 5 1.2 6.5 3.3s1.9 4.8 1.1 7.2l-12.2 36.6L554.4 360H506.7c-2.6 0-5-1.2-6.5-3.3s-1.9-4.8-1.1-7.2l12.2-36.6L437.6 376z'
      
    ]
  };

  

  
  

  var faTransporter5 = {
    prefix: 'fat',
    iconName: 'transporter-5',
    icon: [
      512,
      512,
      [],
      'e2a6',
      
      'M464 0c4.4 0 8 3.6 8 8V40h32c4.4 0 8 3.6 8 8s-3.6 8-8 8H472V88c0 4.4-3.6 8-8 8s-8-3.6-8-8V56H424c-4.4 0-8-3.6-8-8s3.6-8 8-8h32V8c0-4.4 3.6-8 8-8zM48 128c4.4 0 8 3.6 8 8v32H88c4.4 0 8 3.6 8 8s-3.6 8-8 8H56v32c0 4.4-3.6 8-8 8s-8-3.6-8-8V184H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H40V136c0-4.4 3.6-8 8-8zm96 336c-17.7 0-32 14.3-32 32v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-26.5 21.5-48 48-48H368c26.5 0 48 21.5 48 48v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-17.7-14.3-32-32-32H144zm24-80H344c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-4.4 0-8-3.6-8-8s3.6-8 8-8zm-8-56c0-4.4 3.6-8 8-8H344c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-4.4 0-8-3.6-8-8zm-56-72H408c4.4 0 8 3.6 8 8s-3.6 8-8 8H104c-4.4 0-8-3.6-8-8s3.6-8 8-8zm24-56c0-4.4 3.6-8 8-8H376c4.4 0 8 3.6 8 8s-3.6 8-8 8H136c-4.4 0-8-3.6-8-8zm72-72H312c4.4 0 8 3.6 8 8s-3.6 8-8 8H200c-4.4 0-8-3.6-8-8s3.6-8 8-8zM224 8c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H232c-4.4 0-8-3.6-8-8zm0 56h64c4.4 0 8 3.6 8 8s-3.6 8-8 8H224c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faVolume = {
    prefix: 'fat',
    iconName: 'volume',
    icon: [
      576,
      512,
      [128265,"volume-medium"],
      'f6a8',
      
      'M322.2 48c-3.4 0-6.6 1.2-9.2 3.5L175.2 174c-1.5 1.3-3.4 2-5.3 2H88c-22.1 0-40 17.9-40 40v80c0 22.1 17.9 40 40 40h81.9c2 0 3.9 .7 5.3 2L313 460.5c2.5 2.2 5.8 3.5 9.2 3.5c7.6 0 13.8-6.2 13.8-13.8V61.8c0-7.6-6.2-13.8-13.8-13.8zm-19.8-8.5c5.5-4.8 12.5-7.5 19.8-7.5C338.7 32 352 45.3 352 61.8V450.2c0 16.5-13.3 29.8-29.8 29.8c-7.3 0-14.3-2.7-19.8-7.5L166.9 352H88c-30.9 0-56-25.1-56-56V216c0-30.9 25.1-56 56-56h78.9L302.4 39.5zM430.5 180.8c2.7-3.5 7.7-4.2 11.2-1.6C464.9 196.8 480 224.6 480 256s-15.1 59.2-38.3 76.7c-3.5 2.7-8.5 1.9-11.2-1.6s-1.9-8.5 1.6-11.2c19.4-14.6 31.9-37.8 31.9-64s-12.5-49.4-31.9-64c-3.5-2.7-4.2-7.7-1.6-11.2zm70.4-77.2C546.5 138.7 576 193.9 576 256s-29.5 117.3-75.1 152.3c-3.5 2.7-8.5 2-11.2-1.5s-2-8.5 1.5-11.2C533 363.5 560 312.9 560 256s-27-107.5-68.9-139.7c-3.5-2.7-4.2-7.7-1.5-11.2s7.7-4.2 11.2-1.5z'
      
    ]
  };

  
    var faVolumeMedium = faVolume;
  

  
  

  var faDiceTwo = {
    prefix: 'fat',
    iconName: 'dice-two',
    icon: [
      448,
      512,
      [9857],
      'f528',
      
      'M384 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM320 336a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM112 160a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faGift = {
    prefix: 'fat',
    iconName: 'gift',
    icon: [
      512,
      512,
      [127873],
      'f06b',
      
      'M373.1 16c-20.3 0-39.2 10.5-50 27.7L270.4 128H296h80c30.9 0 56-25.1 56-56s-25.1-56-56-56h-2.9zM241.6 128L188.9 43.7C178.1 26.5 159.2 16 138.9 16H136c-30.9 0-56 25.1-56 56s25.1 56 56 56h80 25.6zm14.4-7.1l53.6-85.7C323.3 13.3 347.3 0 373.1 0H376c39.8 0 72 32.2 72 72c0 22.6-10.4 42.8-26.7 56H464c26.5 0 48 21.5 48 48v32c0 20.9-13.4 38.7-32 45.3V256 448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V256v-2.7C13.4 246.7 0 228.9 0 208V176c0-26.5 21.5-48 48-48H90.7C74.4 114.8 64 94.6 64 72C64 32.2 96.2 0 136 0h2.9c25.8 0 49.8 13.3 63.5 35.2L256 120.9zM136 144H48c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32H248V144H216 136zm128 0v96H464c17.7 0 32-14.3 32-32V176c0-17.7-14.3-32-32-32H376 296 264zM248 256H48V448c0 26.5 21.5 48 48 48H248V256zm16 240H416c26.5 0 48-21.5 48-48V256H264V496z'
      
    ]
  };

  

  
  

  var faMemoCircleInfo = {
    prefix: 'fat',
    iconName: 'memo-circle-info',
    icon: [
      576,
      512,
      [],
      'e49a',
      
      'M320 16H64C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48H311.2c5.8 5.5 12 10.6 18.5 15.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V198.6c-5.4 1.5-10.8 3.3-16 5.4V64c0-26.5-21.5-48-48-48zM64 136c0-4.4 3.6-8 8-8H312c4.4 0 8 3.6 8 8s-3.6 8-8 8H72c-4.4 0-8-3.6-8-8zm8 88H280c4.4 0 8 3.6 8 8s-3.6 8-8 8H72c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 96H216c4.4 0 8 3.6 8 8s-3.6 8-8 8H72c-4.4 0-8-3.6-8-8s3.6-8 8-8zm488 48a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-48a16 16 0 1 1 0-32 16 16 0 1 1 0 32zM408 440c0-4.4 3.6-8 8-8h8V360h-8c-4.4 0-8-3.6-8-8s3.6-8 8-8h16c4.4 0 8 3.6 8 8v80h8c4.4 0 8 3.6 8 8s-3.6 8-8 8H432 416c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faMailboxFlagUp = {
    prefix: 'fat',
    iconName: 'mailbox-flag-up',
    icon: [
      576,
      512,
      [],
      'e5bb',
      
      'M352 200V104 56c0-13.3 10.7-24 24-24h64c13.3 0 24 10.7 24 24V88c0 13.3-10.7 24-24 24H368v88c0 4.4-3.6 8-8 8s-8-3.6-8-8zM440 96c4.4 0 8-3.6 8-8V56c0-4.4-3.6-8-8-8l-64 0c-4.4 0-8 3.6-8 8V96l72 0zM560 208c0-47.7-26-89.2-64.7-111.3c.4-2.8 .7-5.8 .7-8.7V79c47.4 23.6 80 72.5 80 129V384c0 35.3-28.7 64-64 64H224 64c-35.3 0-64-28.7-64-64V208C0 128.5 64.5 64 144 64H320V80H210c46.3 23.9 78 72.3 78 128V384c0 19.1-8.4 36.3-21.7 48H512c26.5 0 48-21.5 48-48V208zM224 432c26.5 0 48-21.5 48-48V208c0-70.7-57.3-128-128-128S16 137.3 16 208V384c0 26.5 21.5 48 48 48H224zM64 200c0-4.4 3.6-8 8-8H216c4.4 0 8 3.6 8 8s-3.6 8-8 8H72c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faFaceDowncastSweat = {
    prefix: 'fat',
    iconName: 'face-downcast-sweat',
    icon: [
      512,
      512,
      [],
      'e371',
      
      'M93.3 60c5.6 8.9 10.5 17.5 13.9 25.1c3.6 8 4.8 13.3 4.8 16.2c0 22.4-20.2 42.7-48 42.7s-48-20.4-48-42.7c0-2.8 1.2-8.1 4.8-16.1c3.4-7.6 8.3-16.2 13.9-25.1C44.4 44.8 55.6 29.8 64 19.1C72.4 29.7 83.7 44.8 93.3 60zM72.5 4.1c-4.3-5.5-12.8-5.5-17.1 0C38.1 25.8 0 76.3 0 101.3C0 133.8 28.7 160 64 160s64-26.2 64-58.7c0-25-37.9-75.5-55.5-97.2zM256 16c132.5 0 240 107.5 240 240s-107.5 240-240 240S16 388.6 16 256c0-22.2 3-43.6 8.6-64c1.2-4.3-1.3-8.7-5.6-9.8s-8.7 1.3-9.8 5.6C3.2 209.5 0 232.4 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0c-43.1 0-83.8 10.7-119.5 29.5c-3.9 2.1-5.4 6.9-3.3 10.8s6.9 5.4 10.8 3.3C177.4 26 215.5 16 256 16zM178.6 413.9c3.3 3 8.3 2.7 11.3-.6C202.7 399.1 224.7 384 256 384s53.3 15.1 66.1 29.4c3 3.3 8 3.5 11.3 .6s3.6-8 .6-11.3C318.9 386 292.9 368 256 368s-62.9 18-77.9 34.6c-3 3.3-2.7 8.3 .6 11.3zM400 272H304c-4.4 0-8 3.6-8 8s3.6 8 8 8h96c4.4 0 8-3.6 8-8s-3.6-8-8-8zm-184 8c0-4.4-3.6-8-8-8H112c-4.4 0-8 3.6-8 8s3.6 8 8 8h96c4.4 0 8-3.6 8-8z'
      
    ]
  };

  

  
  

  var faCarBattery = {
    prefix: 'fat',
    iconName: 'car-battery',
    icon: [
      512,
      512,
      ["battery-car"],
      'f5df',
      
      'M168 80c4.4 0 8 3.6 8 8v40H80V88c0-4.4 3.6-8 8-8h80zm24 48V88c0-13.3-10.7-24-24-24H88C74.7 64 64 74.7 64 88v40c-35.3 0-64 28.7-64 64V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64V88c0-13.3-10.7-24-24-24H344c-13.3 0-24 10.7-24 24v40H192zm144 0V88c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v40H336zm-16 16h16 96 16c26.5 0 48 21.5 48 48V384c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V192c0-26.5 21.5-48 48-48H80h96 16H320zm48 72c-4.4 0-8 3.6-8 8v40H320c-4.4 0-8 3.6-8 8s3.6 8 8 8h40v40c0 4.4 3.6 8 8 8s8-3.6 8-8V280h40c4.4 0 8-3.6 8-8s-3.6-8-8-8H376V224c0-4.4-3.6-8-8-8zM96 264c-4.4 0-8 3.6-8 8s3.6 8 8 8h96c4.4 0 8-3.6 8-8s-3.6-8-8-8H96z'
      
    ]
  };

  
    var faBatteryCar = faCarBattery;
  

  
  

  var faDogLeashed = {
    prefix: 'fat',
    iconName: 'dog-leashed',
    icon: [
      576,
      512,
      [129454],
      'f6d4',
      
      'M65.6 3.2C68.3-.4 73.3-1 76.8 1.6L306.7 176h8l26-156.2 15.8 2.6-26 156.2c-.1 .7-.3 1.3-.4 1.9l88.4 51.6 7.1-42.8c1.3-7.7 8-13.4 15.8-13.4H464h40c30.9 0 56-25.1 56-56V96c0-8.8-7.2-16-16-16H496c-4.2 0-8.3-1.7-11.3-4.7L466.7 57.4c-6-6-14.1-9.4-22.6-9.4H400c-5 0-9.8-2.4-12.8-6.4L370.3 19.1l12.5-9.4-12.5 9.4c-1.5-2-3.8-3.1-6.2-3.1c-3.8 0-7 2.7-7.6 6.5l-15.8-2.6C342.6 8.4 352.5 0 364.1 0c7.5 0 14.5 3.5 19 9.5L400 32h44.1c12.7 0 24.9 5.1 33.9 14.1L496 64h48c17.7 0 32 14.3 32 32v24c0 39.8-32.2 72-72 72H464 441.3L432 248V464c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V386.6 369.4c-5.2 2.2-10.6 4.2-16 5.9c-17.7 5.6-36.5 8.7-56 8.7s-38.3-3-56-8.7c-5.4-1.7-10.8-3.7-16-5.9v17.3V464c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V233.8c-28.8-10.9-51.4-35.3-59.2-66.5L1 151.8c-4.3-17.1 6.1-34.5 23.3-38.8s34.5 6.1 38.8 23.3l3.9 15.5C70.5 166 83.3 176 98 176h46 8H280.2L67.2 14.4C63.6 11.7 63 6.7 65.6 3.2zM412 246.9l-94.5-55.1c-.9 .2-1.8 .2-2.8 .2H288V363.2c8.9-2.2 17.5-5 25.7-8.6c4.9-2.1 10.6-1.6 15.1 1.4s7.2 8 7.2 13.3V464c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V249.3l-4-2.4zM272 192H152h-8H98c-22 0-41.2-15-46.6-36.4l-3.9-15.5c-2.1-8.6-10.8-13.8-19.4-11.6s-13.8 10.8-11.6 19.4l3.9 15.5c6.5 26 25.3 46.3 49.3 55.4c6.2 2.4 10.3 8.3 10.3 15V464c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V369.4c0-5.4 2.7-10.4 7.2-13.3s10.1-3.5 15.1-1.4c20.2 8.6 42.4 13.3 65.7 13.3c8.2 0 16.2-.6 24-1.7V192zM444 80a12 12 0 1 1 0 24 12 12 0 1 1 0-24z'
      
    ]
  };

  

  
  

  var faMugHot = {
    prefix: 'fat',
    iconName: 'mug-hot',
    icon: [
      512,
      512,
      [9749],
      'f7b6',
      
      'M80 8c0-4.4-3.6-8-8-8s-8 3.6-8 8c0 27.3 5.1 45.2 13.6 57.9C86 78.4 97.1 85 106.7 90.6l.4 .3c9.9 5.9 18.2 10.9 24.4 20.1c6.2 9.2 10.9 23.5 10.9 49c0 4.4 3.6 8 8 8s8-3.6 8-8c0-27.3-5.1-45.2-13.6-57.9c-8.4-12.5-19.5-19.1-29.1-24.7l-.4-.3C105.4 71.2 97.1 66.2 90.9 57C84.7 47.8 80 33.5 80 8zM209.6 8c0-4.4-3.6-8-8-8s-8 3.6-8 8c0 27.3 5.1 45.2 13.6 57.9c8.4 12.5 19.5 19.1 29.1 24.7l.4 .3c9.9 5.9 18.2 10.9 24.4 20.1c6.2 9.2 10.9 23.5 10.9 49c0 4.4 3.6 8 8 8s8-3.6 8-8c0-27.3-5.1-45.2-13.6-57.9C266 89.6 254.9 83 245.3 77.4l-.4-.3C235 71.2 226.7 66.2 220.5 57c-6.2-9.2-10.9-23.5-10.9-49zM344 208h24V416c0 44.2-35.8 80-80 80H96c-44.2 0-80-35.8-80-80V224c0-8.8 7.2-16 16-16H344zm40 176V208h24c48.6 0 88 39.4 88 88s-39.4 88-88 88H384zm0 32V400h24c57.4 0 104-46.6 104-104s-46.6-104-104-104H384 368 344 32c-17.7 0-32 14.3-32 32V416c0 53 43 96 96 96H288c53 0 96-43 96-96z'
      
    ]
  };

  

  
  

  var faArrowDownSquareTriangle = {
    prefix: 'fat',
    iconName: 'arrow-down-square-triangle',
    icon: [
      576,
      512,
      ["sort-shapes-down-alt"],
      'f889',
      
      'M165.7 477.7l104-104c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L168 452.7V40c0-4.4-3.6-8-8-8s-8 3.6-8 8V452.7L61.7 362.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l104 104c3.1 3.1 8.2 3.1 11.3 0zM440.2 301.7c-5.1-8.5-14.3-13.7-24.2-13.7s-19.1 5.2-24.2 13.7L307.6 442c-2.3 3.9-3.6 8.4-3.6 12.9c0 13.8 11.2 25.1 25.1 25.1H502.9c13.8 0 25.1-11.2 25.1-25.1c0-4.5-1.2-9-3.6-12.9L440.2 301.7zM405.5 310c2.2-3.7 6.2-6 10.5-6s8.3 2.3 10.5 6l84.2 140.3c.8 1.4 1.3 3 1.3 4.7c0 5-4.1 9.1-9.1 9.1H329.1c-5 0-9.1-4.1-9.1-9.1c0-1.6 .4-3.3 1.3-4.7L405.5 310zM336 176V80c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H368c-17.7 0-32-14.3-32-32zm-16 0c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48v96z'
      
    ]
  };

  
    var faSortShapesDownAlt = faArrowDownSquareTriangle;
  

  
  

  var faSquarePollVertical = {
    prefix: 'fat',
    iconName: 'square-poll-vertical',
    icon: [
      448,
      512,
      ["poll"],
      'f681',
      
      'M64 48C37.5 48 16 69.5 16 96l0 320c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-320c0-26.5-21.5-48-48-48L64 48zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM128 368c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16zm96 0c8.8 0 16-7.2 16-16l0-192c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 192c0 8.8 7.2 16 16 16zm96 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16zM96 352l0-96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32zm96 0l0-192c0-17.7 14.3-32 32-32s32 14.3 32 32l0 192c0 17.7-14.3 32-32 32s-32-14.3-32-32zm96 0l0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32z'
      
    ]
  };

  
    var faPoll = faSquarePollVertical;
  

  
  

  var faJedi = {
    prefix: 'fat',
    iconName: 'jedi',
    icon: [
      576,
      512,
      [],
      'f669',
      
      'M288 0c4.4 0 8 3.6 8 8V308.7l42.9-42.9c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L307.3 320H368c4.4 0 8 3.6 8 8s-3.6 8-8 8H307.3l42.9 42.9c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L296 347.3v84.4c58.1-4.1 104-52.6 104-111.7c0-37.3-18.2-70.4-46.3-90.7c-2.2-1.6-3.5-4.3-3.3-7.1s1.8-5.2 4.3-6.5C400.6 191.6 432 143.5 432 88c0-26.8-7.3-51.8-20-73.2c-1.8-3.1-1.4-7.1 1.2-9.7s6.5-3.1 9.7-1.3C504.8 50.6 560 138.8 560 240c0 150.2-121.8 272-272 272S16 390.2 16 240C16 138.8 71.2 50.6 153.1 3.7c3.2-1.8 7.1-1.3 9.7 1.3s3 6.6 1.2 9.7C151.3 36.2 144 61.2 144 88c0 55.5 31.4 103.6 77.4 127.7c2.5 1.3 4.1 3.7 4.3 6.5s-1 5.4-3.3 7.1C194.2 249.6 176 282.7 176 320c0 59.2 45.9 107.6 104 111.7V347.3l-42.9 42.9c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L268.7 336H208c-4.4 0-8-3.6-8-8s3.6-8 8-8h60.7l-42.9-42.9c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L280 308.7V8c0-4.4 3.6-8 8-8zM160 320c0-38.3 16.8-72.7 43.5-96.1C158.2 195.6 128 145.3 128 88c0-19.5 3.5-38.1 9.8-55.4C101 59.4 71.6 95.7 53.2 137.9l.5 .5 80 80c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L46.8 154.1c-6.8 19-11.4 39.1-13.5 59.9l4.4 4.4 64 64c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L32 235.4c0 1.5 0 3.1 0 4.6c0 141.4 114.6 256 256 256s256-114.6 256-256c0-1.6 0-3.1 0-4.6l-58.3 58.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l64-64 4.4-4.4c-2.1-20.8-6.7-40.9-13.5-59.9l-75.6 75.6c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l80-80 .5-.5C504.4 95.7 475 59.4 438.2 32.6C444.5 49.9 448 68.5 448 88c0 57.3-30.2 107.6-75.5 135.9C399.2 247.3 416 281.7 416 320c0 70.7-57.3 128-128 128s-128-57.3-128-128z'
      
    ]
  };

  

  
  

  var faTilde = {
    prefix: 'fat',
    iconName: 'tilde',
    icon: [
      448,
      512,
      [63135],
      '7e',
      
      'M91.5 160C49.8 160 16 193.8 16 235.5V320c0 4.4-3.6 8-8 8s-8-3.6-8-8V235.5C0 184.9 40.9 144 91.5 144c25.5 0 49.9 10.7 67.2 29.4L301.1 327.7c14.3 15.5 34.4 24.3 55.4 24.3c41.7 0 75.5-33.8 75.5-75.5V192c0-4.4 3.6-8 8-8s8 3.6 8 8v84.5c0 50.5-40.9 91.5-91.5 91.5c-25.5 0-49.9-10.7-67.2-29.4L146.9 184.3C132.6 168.8 112.5 160 91.5 160z'
      
    ]
  };

  

  
  

  var faMapLocationDot = {
    prefix: 'fat',
    iconName: 'map-location-dot',
    icon: [
      576,
      512,
      ["map-marked-alt"],
      'f5a0',
      
      'M381.3 161.2c-6.9 16.4-16.6 34.2-27.5 51.9c-21.8 35.4-47.6 69.1-63.5 88.9c-1.3 1.6-3.4 1.6-4.6 0c-15.9-19.8-41.7-53.6-63.5-88.9c-10.9-17.7-20.6-35.5-27.5-51.9c-7-16.7-10.7-30.7-10.7-41.2c0-57.4 46.6-104 104-104s104 46.6 104 104c0 10.5-3.6 24.5-10.7 41.2zM302.8 312C334.9 271.9 408 174.6 408 120C408 53.7 354.3 0 288 0S168 53.7 168 120c0 54.6 73.1 151.9 105.2 192c7.7 9.6 22 9.6 29.6 0zm118.3-122l117.4-42.7c10.4-3.8 21.5 3.9 21.5 15V423.2c0 6.7-4.2 12.7-10.5 15L400 492.6V296c0-4.4-3.6-8-8-8s-8 3.6-8 8V493.2L192 434.1V296c0-4.4-3.6-8-8-8s-8 3.6-8 8V434.4L37.5 484.8C27 488.6 16 480.8 16 469.7V208.8c0-6.7 4.2-12.7 10.5-15l114.2-41.5c-1.4-5.2-2.6-10.5-3.4-15.8L21.1 178.7C8.4 183.3 0 195.4 0 208.8V469.7c0 22.2 22.1 37.7 42.9 30.1l141.3-51.4 205.4 63.2c1.7 .5 3.4 .5 5.1-.1l160.2-58.3c12.6-4.6 21.1-16.6 21.1-30.1V162.3c0-22.2-22.1-37.7-42.9-30.1L429.6 169.8c-1.3 3.4-2.6 6.7-4 10c-1.4 3.3-2.9 6.7-4.5 10.1zM256 112a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  
    var faMapMarkedAlt = faMapLocationDot;
  

  
  

  var faBorderTopLeft = {
    prefix: 'fat',
    iconName: 'border-top-left',
    icon: [
      448,
      512,
      ["border-style"],
      'f853',
      
      'M0 456c0 4.4 3.6 8 8 8s8-3.6 8-8L16 88c0-22.1 17.9-40 40-40l368 0c4.4 0 8-3.6 8-8s-3.6-8-8-8L56 32C25.1 32 0 57.1 0 88L0 456zm128-24a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm192 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-96 32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm192-32a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0-160a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0-160a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  
    var faBorderStyle = faBorderTopLeft;
  

  
  

  var faNotEqual = {
    prefix: 'fat',
    iconName: 'not-equal',
    icon: [
      448,
      512,
      [],
      'f53e',
      
      'M380.6 33.5c3.6 2.5 4.5 7.5 1.9 11.1L301.3 160H424c4.4 0 8 3.6 8 8s-3.6 8-8 8H290.1L177.5 336H424c4.4 0 8 3.6 8 8s-3.6 8-8 8H166.2L78.5 476.6c-2.5 3.6-7.5 4.5-11.1 1.9s-4.5-7.5-1.9-11.1L146.7 352H24c-4.4 0-8-3.6-8-8s3.6-8 8-8H157.9L270.5 176H24c-4.4 0-8-3.6-8-8s3.6-8 8-8H281.8L369.5 35.4c2.5-3.6 7.5-4.5 11.1-1.9z'
      
    ]
  };

  

  
  

  var faMoneyCheckPen = {
    prefix: 'fat',
    iconName: 'money-check-pen',
    icon: [
      640,
      512,
      ["money-check-edit"],
      'f872',
      
      'M64 80H512c26.5 0 48 21.5 48 48v68.6c5.2-2 10.6-3.3 16-4V128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H330.5l4-16H64c-26.5 0-48-21.5-48-48V128c0-26.5 21.5-48 48-48zm40 224c-4.4 0-8 3.6-8 8s3.6 8 8 8H376c4.4 0 8-3.6 8-8s-3.6-8-8-8H104zm-8-88c0 4.4 3.6 8 8 8H472c4.4 0 8-3.6 8-8s-3.6-8-8-8H104c-4.4 0-8 3.6-8 8zM356.7 507.2c4 4 9.7 5.6 15.2 4.2l60.1-15-3.4-13.6 3.4 13.6c5.6-1.4 10.8-4.3 14.9-8.4L628.1 306.7c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4c-15.6-15.6-40.9-15.6-56.6 0L375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2zm15.7-28.9L383 435.7c.7-2.8 2.2-5.4 4.2-7.4L530.1 285.4l48.3 48.3L435.6 476.6c-2.1 2.1-4.6 3.5-7.4 4.2l-42.5 10.6L368 495.8l4.4-17.6zM616.8 295.4l-27.1 27.1-48.3-48.3L568.5 247c9.4-9.4 24.6-9.4 33.9 0l14.4 14.4c9.4 9.4 9.4 24.6 0 33.9z'
      
    ]
  };

  
    var faMoneyCheckEdit = faMoneyCheckPen;
  

  
  

  var faManatSign = {
    prefix: 'fat',
    iconName: 'manat-sign',
    icon: [
      384,
      512,
      [],
      'e1d5',
      
      'M192 32c-4.4 0-8 3.6-8 8V96.2C81.7 100.4 0 184.6 0 288V472c0 4.4 3.6 8 8 8s8-3.6 8-8V288c0-94.5 74.5-171.6 168-175.8V472c0 4.4 3.6 8 8 8s8-3.6 8-8V112.2c93.5 4.2 168 81.3 168 175.8V472c0 4.4 3.6 8 8 8s8-3.6 8-8V288c0-103.4-81.7-187.6-184-191.8V40c0-4.4-3.6-8-8-8z'
      
    ]
  };

  

  
  

  var faSquareK = {
    prefix: 'fat',
    iconName: 'square-k',
    icon: [
      448,
      512,
      [],
      'e274',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm317.4 45.9L215.2 236.3 318.4 371.1c2.7 3.5 2 8.5-1.5 11.2s-8.5 2-11.2-1.5L203.4 247.2 144 302v74c0 4.4-3.6 8-8 8s-8-3.6-8-8V298.5 136c0-4.4 3.6-8 8-8s8 3.6 8 8V280.2L306.6 130.1c3.2-3 8.3-2.8 11.3 .5s2.8 8.3-.5 11.3z'
      
    ]
  };

  

  
  

  var faCircleDownRight = {
    prefix: 'fat',
    iconName: 'circle-down-right',
    icon: [
      512,
      512,
      [],
      'e108',
      
      'M256 496a240 240 0 1 1 0-480 240 240 0 1 1 0 480zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zm96 344c0 4.4-3.6 8-8 8H217c-5 0-9-4-9-9c0-2.4 .9-4.7 2.6-6.3l35-35c3.1-3.1 3.1-8.2 0-11.3L163.3 208c-2.1-2.1-3.3-5-3.3-8s1.2-5.9 3.3-8L192 163.3c2.1-2.1 5-3.3 8-3.3s5.9 1.2 8 3.3l82.3 82.3c3.1 3.1 8.2 3.1 11.3 0l35-35c1.7-1.7 4-2.6 6.3-2.6c5 0 9 4 9 9V344zm-8 24c13.3 0 24-10.7 24-24V217c0-13.8-11.2-25-25-25c-6.6 0-13 2.6-17.7 7.3L296 228.7 219.3 152c-5.1-5.1-12.1-8-19.3-8s-14.2 2.9-19.3 8L152 180.7c-5.1 5.1-8 12.1-8 19.3s2.9 14.2 8 19.3L228.7 296l-29.4 29.4c-4.7 4.7-7.3 11-7.3 17.7c0 13.8 11.2 25 25 25H344z'
      
    ]
  };

  

  
  

  var faEngineWarning = {
    prefix: 'fat',
    iconName: 'engine-warning',
    icon: [
      640,
      512,
      ["engine-exclamation"],
      'f5f2',
      
      'M408 80c4.4 0 8-3.6 8-8s-3.6-8-8-8H304 200c-4.4 0-8 3.6-8 8s3.6 8 8 8l96 0v48H160 112c-26.5 0-48 21.5-48 48v72H16V168c0-4.4-3.6-8-8-8s-8 3.6-8 8V344c0 4.4 3.6 8 8 8s8-3.6 8-8V264H64v72c0 26.5 21.5 48 48 48h67.2l59 49.2c11.5 9.6 26 14.8 41 14.8H448c35.3 0 64-28.7 64-64V226.3c0-21.4-10.7-41.4-28.5-53.3l-51.4-34.3c-10.5-7-22.9-10.7-35.5-10.7H336 312V80l96 0zM80 264V248 176c0-17.7 14.3-32 32-32h48H304h32 60.6c9.5 0 18.7 2.8 26.6 8.1l51.4 34.3c13.4 8.9 21.4 23.9 21.4 39.9V384c0 26.5-21.5 48-48 48H279.2c-11.2 0-22.1-3.9-30.7-11.1l-59-49.2c-2.9-2.4-6.5-3.7-10.2-3.7H112c-17.7 0-32-14.3-32-32V264zm496-56h32c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H576c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16zm-32 16V416c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H576c-17.7 0-32 14.3-32 32zM320 352a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-8-168c0-4.4-3.6-8-8-8s-8 3.6-8 8V304c0 4.4 3.6 8 8 8s8-3.6 8-8V184z'
      
    ]
  };

  
    var faEngineExclamation = faEngineWarning;
  

  
  

  var faTransporter3 = {
    prefix: 'fat',
    iconName: 'transporter-3',
    icon: [
      512,
      512,
      [],
      'e045',
      
      'M464 0c4.4 0 8 3.6 8 8V40h32c4.4 0 8 3.6 8 8s-3.6 8-8 8H472V88c0 4.4-3.6 8-8 8s-8-3.6-8-8V56H424c-4.4 0-8-3.6-8-8s3.6-8 8-8h32V8c0-4.4 3.6-8 8-8zM48 96c4.4 0 8 3.6 8 8v32H88c4.4 0 8 3.6 8 8s-3.6 8-8 8H56v32c0 4.4-3.6 8-8 8s-8-3.6-8-8V152H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H40V104c0-4.4 3.6-8 8-8zm96 368c-17.7 0-32 14.3-32 32v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-26.5 21.5-48 48-48H368c26.5 0 48 21.5 48 48v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-17.7-14.3-32-32-32H144zM288 48c0-17.7-14.3-32-32-32l-.4 0c-.3 0-.6 0-.9 0c-17 .7-30.6 14.8-30.6 32c0 17.7 14.3 32 32 32s32-14.3 32-32zm16 0c0 26.5-21.5 48-48 48h0c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM168 384H344c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-4.4 0-8-3.6-8-8s3.6-8 8-8zm-8-56c0-4.4 3.6-8 8-8H344c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-4.4 0-8-3.6-8-8zm-56-72H408c4.4 0 8 3.6 8 8s-3.6 8-8 8H104c-4.4 0-8-3.6-8-8s3.6-8 8-8zm24-56c0-4.4 3.6-8 8-8H376c4.4 0 8 3.6 8 8s-3.6 8-8 8H136c-4.4 0-8-3.6-8-8zm72-72H312c4.4 0 8 3.6 8 8s-3.6 8-8 8H200c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faBuildingNgo = {
    prefix: 'fat',
    iconName: 'building-ngo',
    icon: [
      384,
      512,
      [],
      'e4d7',
      
      'M48 16C30.3 16 16 30.3 16 48V464c0 17.7 14.3 32 32 32h96V416c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c17.7 0 32-14.3 32-32V48c0-17.7-14.3-32-32-32H48zM224 496V416c0-17.7-14.3-32-32-32s-32 14.3-32 32v80h64zm-80 16H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H240 224 160 144zM104 232h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V256c0-13.3 10.7-24 24-24zm-8 24v32c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V256c0-4.4-3.6-8-8-8H104c-4.4 0-8 3.6-8 8zm128 0c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H248c-13.3 0-24-10.7-24-24V256zm24-8c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V256c0-4.4-3.6-8-8-8H248zM176 56h40c4.4 0 8 3.6 8 8s-3.6 8-8 8H176v80h32V128c0-4.4 3.6-8 8-8s8 3.6 8 8v24c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V72c0-8.8 7.2-16 16-16zM296 72c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24s24-10.7 24-24V96c0-13.3-10.7-24-24-24zM256 96c0-22.1 17.9-40 40-40s40 17.9 40 40v32c0 22.1-17.9 40-40 40s-40-17.9-40-40V96zM62.7 59.6l49.3 74V64c0-4.4 3.6-8 8-8s8 3.6 8 8v96c0 3.5-2.3 6.6-5.7 7.7s-7-.3-9-3.2L64 90.4V160c0 4.4-3.6 8-8 8s-8-3.6-8-8V64c0-3.5 2.3-6.6 5.7-7.7s7 .3 9 3.2z'
      
    ]
  };

  

  
  

  var faAnchorLock = {
    prefix: 'fat',
    iconName: 'anchor-lock',
    icon: [
      640,
      512,
      [],
      'e4ad',
      
      'M352 80A64 64 0 1 1 224 80a64 64 0 1 1 128 0zM288 0c-44.2 0-80 35.8-80 80c0 41.5 31.6 75.6 72 79.6c0 .1 0 .3 0 .4v48H200c-4.4 0-8 3.6-8 8s3.6 8 8 8h80V496h-8C170.4 496 88 413.6 88 312V284.8l58.1 64.5c3 3.3 8 3.6 11.3 .6s3.6-8 .6-11.3l-72-80C84.4 257 82.3 256 80 256s-4.4 1-5.9 2.6l-72 80c-3 3.3-2.7 8.3 .6 11.3s8.3 2.7 11.3-.6L72 284.8V312c0 110.5 89.5 200 200 200h16 16c29.1 0 56.7-6.2 81.7-17.4c-1.1-4.7-1.7-9.6-1.7-14.6v-2.3c-24.2 11.7-51.3 18.3-80 18.3h-8V224h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H296V160c0-.1 0-.3 0-.4c40.4-4 72-38.1 72-79.6c0-44.2-35.8-80-80-80zM528 208c26.5 0 48 21.5 48 48v64H480V256c0-26.5 21.5-48 48-48zm-64 48v64H448c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H592V256c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-16 80h16 16 96 16 16c8.8 0 16 7.2 16 16V480c0 8.8-7.2 16-16 16H448c-8.8 0-16-7.2-16-16V352c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faBold = {
    prefix: 'fat',
    iconName: 'bold',
    icon: [
      384,
      512,
      [],
      'f032',
      
      'M0 40c0-4.4 3.6-8 8-8H40 72 224c61.9 0 112 50.1 112 112c0 43.1-24.4 80.5-60.1 99.3C328.7 255.8 368 303.3 368 360c0 66.3-53.7 120-120 120H72 40 8c-4.4 0-8-3.6-8-8s3.6-8 8-8H32V248 48H8c-4.4 0-8-3.6-8-8zM48 464H72 248c57.4 0 104-46.6 104-104s-46.6-104-104-104H224 48V464zm0-224H224c53 0 96-43 96-96s-43-96-96-96H72 48V240z'
      
    ]
  };

  

  
  

  var faStroopwafel = {
    prefix: 'fat',
    iconName: 'stroopwafel',
    icon: [
      512,
      512,
      [],
      'f551',
      
      'M256 16a240 240 0 1 0 0 480 240 240 0 1 0 0-480zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM131.5 120.2l56.6 56.6 56.6-56.6L210.7 86.3c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L256 108.9 289.9 75c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-33.9 33.9 56.6 56.6 56.6-56.6c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-56.6 56.6 56.6 56.6 33.9-33.9c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L403.1 256 437 289.9c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-33.9-33.9-56.6 56.6 56.6 56.6c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-56.6-56.6-56.6 56.6 33.9 33.9c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L256 403.1 222.1 437c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l33.9-33.9-56.6-56.6-56.6 56.6c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l56.6-56.6-56.6-56.6L86.3 301.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L108.9 256 75 222.1c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l33.9 33.9 56.6-56.6-56.6-56.6c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0zm0 135.8l56.6 56.6L244.7 256l-56.6-56.6L131.5 256zm67.9 67.9L256 380.5l56.6-56.6L256 267.3l-56.6 56.6zM267.3 256l56.6 56.6L380.5 256l-56.6-56.6L267.3 256zM256 244.7l56.6-56.6L256 131.5l-56.6 56.6L256 244.7z'
      
    ]
  };

  

  
  

  var faSignature = {
    prefix: 'fat',
    iconName: 'signature',
    icon: [
      640,
      512,
      [],
      'f5b7',
      
      'M144 120c0-39.8 32.2-72 72-72s72 32.2 72 72v15.9c0 26.8-2.1 53.6-6.4 80l-118 34.9c-30.6 9-51.6 37.1-51.6 69V427.1c0 29.2 23.7 52.9 52.9 52.9c19.6 0 37.6-10.8 46.8-28.2l27-51c21.8-41.2 37.9-85 48-130.5l4.8-21.8c1.5-6.7 2.8-13.4 4.1-20.1L454 181.6 385.2 291.8c-1.5 2.5-1.6 5.6-.2 8.1s4.1 4.1 7 4.1H568c4.4 0 8-3.6 8-8s-3.6-8-8-8H406.4l72.3-115.8c1.8-2.8 1.6-6.4-.4-9.1s-5.4-3.8-8.6-2.8L298.6 210.9c3.6-24.8 5.4-49.9 5.4-75V120c0-48.6-39.4-88-88-88s-88 39.4-88 88v40c0 4.4 3.6 8 8 8s8-3.6 8-8V120zm24.1 146.1l110.3-32.6c-.8 3.8-1.6 7.7-2.4 11.5l-4.8 21.8c-9.8 44.1-25.5 86.6-46.6 126.5l-27 51c-6.4 12.1-19 19.7-32.6 19.7c-20.4 0-36.9-16.5-36.9-36.9V319.8c0-24.8 16.3-46.7 40.1-53.7zM8 368c-4.4 0-8 3.6-8 8s3.6 8 8 8H56c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zm320 0c-4.4 0-8 3.6-8 8s3.6 8 8 8H632c4.4 0 8-3.6 8-8s-3.6-8-8-8H328z'
      
    ]
  };

  

  
  

  var faCaduceus = {
    prefix: 'fat',
    iconName: 'caduceus',
    icon: [
      512,
      512,
      [],
      'e681',
      
      'M256 16a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM208 48c0 23.8 17.3 43.5 40 47.3l0 41.7L176.4 89.3c-9.1-6.1-19.8-9.3-30.7-9.3c-13.3 0-26.2 4.8-36.3 13.5L8.4 181C3.1 185.7 0 192.4 0 199.5C0 213 11 224 24.5 224l121.6 0c31.5 0 62.3-8.8 89-25.5l12.8-8 0 172.8-58.8-32.1c-18-9.8-29.2-28.7-29.2-49.2l0-18c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 18c0 26.3 14.4 50.6 37.5 63.2l57.8 31.5-25.8 14.1C190.4 403.4 176 427.6 176 454l0 18c0 4.4 3.6 8 8 8s8-3.6 8-8l0-18c0-20.5 11.2-39.4 29.2-49.2L248 390.2l0 58.4 0 55.4c0 4.4 3.6 8 8 8s8-3.6 8-8l0-55.4 0-58.4 26.8 14.6c18 9.8 29.2 28.7 29.2 49.2l0 18c0 4.4 3.6 8 8 8s8-3.6 8-8l0-18c0-26.3-14.4-50.6-37.5-63.2l-25.8-14.1 57.8-31.5C353.6 332.6 368 308.4 368 282l0-18c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 18c0 20.5-11.2 39.3-29.2 49.2L264 363.3l0-172.8 12.8 8c26.7 16.7 57.6 25.5 89 25.5l121.6 0c13.5 0 24.5-11 24.5-24.5c0-7.1-3.1-13.8-8.4-18.5l-101-87.5C392.5 84.8 379.7 80 366.3 80c-10.9 0-21.6 3.2-30.7 9.3L264 137.1l0-41.7c22.7-3.8 40-23.6 40-47.3c0-26.5-21.5-48-48-48s-48 21.5-48 48zm40 108.3l0 15.3-21.3 13.3C202.5 200 174.6 208 146.1 208L24.5 208c-4.7 0-8.5-3.8-8.5-8.5c0-2.5 1.1-4.8 2.9-6.4l101-87.5c7.2-6.2 16.3-9.6 25.8-9.6c7.8 0 15.4 2.3 21.8 6.6L248 156.3zm16 0l80.5-53.7c6.5-4.3 14.1-6.6 21.8-6.6c9.5 0 18.6 3.4 25.8 9.6l101 87.5c1.9 1.6 2.9 3.9 2.9 6.4c0 4.7-3.8 8.5-8.5 8.5l-121.6 0c-28.5 0-56.4-8-80.6-23.1L264 171.6l0-15.3z'
      
    ]
  };

  

  
  

  var faSquareO = {
    prefix: 'fat',
    iconName: 'square-o',
    icon: [
      448,
      512,
      [],
      'e278',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM112 256a112 112 0 1 0 224 0 112 112 0 1 0 -224 0zM224 384a128 128 0 1 1 0-256 128 128 0 1 1 0 256z'
      
    ]
  };

  

  
  

  var faBinarySlash = {
    prefix: 'fat',
    iconName: 'binary-slash',
    icon: [
      640,
      512,
      [],
      'e33e',
      
      'M432 224h72c4.4 0 8-3.6 8-8s-3.6-8-8-8H440V8c0-2.6-1.3-5.1-3.4-6.6s-4.9-1.8-7.4-.9l-64 24c-4.1 1.6-6.2 6.2-4.7 10.3s6.2 6.2 10.3 4.7L424 19.5V208H375.4l20.3 16H432zM304 64c0-35.3-28.7-64-64-64H208c-23.7 0-44.4 12.9-55.5 32.1l12.7 10.1C173.2 26.6 189.4 16 208 16h32c26.5 0 48 21.5 48 48v75l16 12.6V64zm32 384c0 35.3 28.7 64 64 64h32c23.7 0 44.4-12.9 55.5-32.1l-12.7-10.1c-8 15.5-24.1 26.1-42.7 26.1H400c-26.5 0-48-21.5-48-48V373l-16-12.6V448zM216 296c0-2.6-1.3-5.1-3.4-6.6s-4.9-1.8-7.4-.9l-64 24c-4.1 1.6-6.2 6.2-4.7 10.3s6.2 6.2 10.3 4.7L200 307.5V496H136c-4.4 0-8 3.6-8 8s3.6 8 8 8h72 72c4.4 0 8-3.6 8-8s-3.6-8-8-8H216V296zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  

  
  

  var faUserPen = {
    prefix: 'fat',
    iconName: 'user-pen',
    icon: [
      640,
      512,
      ["user-edit"],
      'f4ff',
      
      'M336 128a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM16 482.3c0 7.6 6.1 13.7 13.7 13.7h290c0 5.5 1 10.9 2.8 16H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304h91.4c48 0 91.7 19 123.7 49.9l-11.3 11.3C353 337.2 313.3 320 269.7 320H178.3C88.7 320 16 392.7 16 482.3zm340.7 24.9c-4-4-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9L557.2 235.7c15.6-15.6 40.9-15.6 56.6 0l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6L446.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-3.4-13.6 3.4 13.6-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2zm15.7-28.9L368 495.8l17.6-4.4 42.5-10.6c2.8-.7 5.4-2.2 7.4-4.2L578.4 333.7l-48.3-48.3L387.2 428.3c-2 2.1-3.5 4.6-4.2 7.4l-10.6 42.5zM616.8 295.4c9.4-9.4 9.4-24.6 0-33.9L602.4 247c-9.4-9.4-24.6-9.4-33.9 0l-27.1 27.1 48.3 48.3 27.1-27.1z'
      
    ]
  };

  
    var faUserEdit = faUserPen;
  

  
  

  var faPrescriptionBottlePill = {
    prefix: 'fat',
    iconName: 'prescription-bottle-pill',
    icon: [
      576,
      512,
      [],
      'e5c0',
      
      'M344 16c13.3 0 24 10.7 24 24V88c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24V40c0-13.3 10.7-24 24-24H344zM40 0C17.9 0 0 17.9 0 40V88c0 22.1 17.9 40 40 40H344c22.1 0 40-17.9 40-40V40c0-22.1-17.9-40-40-40H40zM32 408v40c0 35.3 28.7 64 64 64H288c11.6 0 22.4-3.1 31.8-8.4c-4.4-3.6-8.6-7.5-12.6-11.5c-5.9 2.6-12.3 4-19.1 4H96c-26.5 0-48-21.5-48-48V416H152c4.4 0 8-3.6 8-8s-3.6-8-8-8H48V320H152c4.4 0 8-3.6 8-8s-3.6-8-8-8H48V224H152c4.4 0 8-3.6 8-8s-3.6-8-8-8H48V160H32v56 96 96zM352 160H336v60.5c5.2-3.4 10.5-6.5 16-9.3V160zm80 80a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM370.3 306.3c-3.1 3.1-3.1 8.2 0 11.3l112 112c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-112-112c-3.1-3.1-8.2-3.1-11.3 0z'
      
    ]
  };

  

  
  

  var faUnderline = {
    prefix: 'fat',
    iconName: 'underline',
    icon: [
      448,
      512,
      [],
      'f0cd',
      
      'M0 40c0-4.4 3.6-8 8-8H136c4.4 0 8 3.6 8 8s-3.6 8-8 8H80V240c0 79.5 64.5 144 144 144s144-64.5 144-144V48H312c-4.4 0-8-3.6-8-8s3.6-8 8-8H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H384V240c0 88.4-71.6 160-160 160s-160-71.6-160-160V48H8c-4.4 0-8-3.6-8-8zM0 472c0-4.4 3.6-8 8-8H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faRectangleHistoryCirclePlus = {
    prefix: 'fat',
    iconName: 'rectangle-history-circle-plus',
    icon: [
      640,
      512,
      [],
      'e4a3',
      
      'M448 144c26.5 0 48 21.5 48 48c5.4 0 10.7 .2 16 .7V192c0-35.3-28.7-64-64-64L64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64l330.8 0c-6.9-4.9-13.4-10.2-19.6-16L64 496c-26.5 0-48-21.5-48-48l0-256c0-26.5 21.5-48 48-48l384 0zm8-80L56 64c-4.4 0-8 3.6-8 8s3.6 8 8 8l400 0c4.4 0 8-3.6 8-8s-3.6-8-8-8zM408 0H104c-4.4 0-8 3.6-8 8s3.6 8 8 8l304 0c4.4 0 8-3.6 8-8s-3.6-8-8-8zM368 368a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM504 296c0-4.4-3.6-8-8-8s-8 3.6-8 8v64H424c-4.4 0-8 3.6-8 8s3.6 8 8 8h64v64c0 4.4 3.6 8 8 8s8-3.6 8-8V376h64c4.4 0 8-3.6 8-8s-3.6-8-8-8H504V296z'
      
    ]
  };

  

  
  

  var faUmbrellaSimple = {
    prefix: 'fat',
    iconName: 'umbrella-simple',
    icon: [
      512,
      512,
      ["umbrella-alt"],
      'e2bc',
      
      'M264 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V32.1C121.1 36 17.4 132.3 2 256.1C-.2 273.6 14.3 288 32 288H480c17.7 0 32.2-14.4 30-31.9C494.6 132.3 391 36 264 32.1V8zm0 454.2V320H248V462.2c0 18.7-15.2 33.8-33.8 33.8c-14.6 0-27.5-9.3-32.1-23.1l-6.5-19.4c-1.4-4.2-5.9-6.5-10.1-5.1s-6.5 5.9-5.1 10.1l6.5 19.4c6.8 20.4 25.8 34.1 47.3 34.1c27.5 0 49.8-22.3 49.8-49.8zM17.9 258C32.6 139.6 133.6 48 256 48s223.4 91.6 238.2 210c.8 6.7-4.7 14-14.2 14H32c-9.4 0-15-7.3-14.1-14z'
      
    ]
  };

  
    var faUmbrellaAlt = faUmbrellaSimple;
  

  
  

  var faBath = {
    prefix: 'fat',
    iconName: 'bath',
    icon: [
      512,
      512,
      [128705,"bathtub"],
      'f2cd',
      
      'M85.3 16C64.7 16 48 32.7 48 53.3V272H464h16 24c4.4 0 8 3.6 8 8s-3.6 8-8 8H480 464 48 32 8c-4.4 0-8-3.6-8-8s3.6-8 8-8H32V53.3C32 23.8 55.8 0 85.3 0c14.1 0 27.7 5.6 37.7 15.6l32.1 32.1C167.4 37.9 183 32 200 32c23.1 0 43.7 10.9 56.9 27.8l1.5-1.5c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-104 104c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l1.5-1.5C138.9 147.7 128 127.1 128 104c0-17 5.9-32.6 15.7-44.9L111.6 26.9c-7-7-16.5-10.9-26.3-10.9zM32 320H48v48c0 53 43 96 96 96H368c53 0 96-43 96-96V320h16v48c0 38.1-19 71.7-48 91.9V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V469.2c-14.5 6.9-30.8 10.8-48 10.8H144c-17.2 0-33.5-3.9-48-10.8V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V459.9C51 439.7 32 406.1 32 368V320zM200 48c-30.9 0-56 25.1-56 56c0 18.7 9.2 35.3 23.3 45.4l78.2-78.2C235.3 57.2 218.7 48 200 48z'
      
    ]
  };

  
    var faBathtub = faBath;
  

  
  

  var faMessages = {
    prefix: 'fat',
    iconName: 'messages',
    icon: [
      640,
      512,
      ["comments-alt"],
      'f4b6',
      
      'M202.7 304H352c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H64C37.5 16 16 37.5 16 64V256c0 26.5 21.5 48 48 48H96c8.8 0 16 7.2 16 16v48l81.1-60.8c2.8-2.1 6.1-3.2 9.6-3.2zM352 320H202.7l-81.1 60.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V336 320H80 64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H352c35.3 0 64 28.7 64 64V256c0 35.3-28.7 64-64 64zM320 448c-35.3 0-64-28.7-64-64V352h16v32c0 26.5 21.5 48 48 48H437.3c3.5 0 6.8 1.1 9.6 3.2L528 496V448c0-8.8 7.2-16 16-16h32c26.5 0 48-21.5 48-48V192c0-26.5-21.5-48-48-48H448V128H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H560 544v16 32c0 6.1-3.4 11.6-8.8 14.3s-11.9 2.1-16.8-1.5L437.3 448H320z'
      
    ]
  };

  
    var faCommentsAlt = faMessages;
  

  
  

  var faWifi = {
    prefix: 'fat',
    iconName: 'wifi',
    icon: [
      640,
      512,
      ["wifi-3","wifi-strong"],
      'f1eb',
      
      'M13.8 175.3C92 96.6 200.3 48 320 48s228 48.6 306.2 127.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3C556.4 82.5 444.1 32 320 32S83.6 82.5 2.5 164c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0zM320 208c72.2 0 137.8 28.1 186.5 74c3.2 3 8.3 2.9 11.3-.3s2.9-8.3-.3-11.3C465.9 221.8 396.4 192 320 192s-145.9 29.8-197.5 78.4c-3.2 3-3.4 8.1-.3 11.3s8.1 3.4 11.3 .3c48.7-45.9 114.3-74 186.5-74zm0 160a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  
    var faWifi3 = faWifi;
  
    var faWifiStrong = faWifi;
  

  
  

  var faFileArrowUp = {
    prefix: 'fat',
    iconName: 'file-arrow-up',
    icon: [
      384,
      512,
      ["file-upload"],
      'f574',
      
      'M16 448V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM200 440V251.3l74.3 74.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-88-88c-3.1-3.1-8.2-3.1-11.3 0l-88 88c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L184 251.3V440c0 4.4 3.6 8 8 8s8-3.6 8-8z'
      
    ]
  };

  
    var faFileUpload = faFileArrowUp;
  

  
  

  var faHouseCircleExclamation = {
    prefix: 'fat',
    iconName: 'house-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e50a',
      
      'M282.7 2c3-2.7 7.6-2.7 10.6 0l215 190.4c-4.1-.3-8.2-.4-12.3-.4c-4 0-8 .1-11.9 .4L288 18.7 80 202.9V448c0 26.5 21.5 48 48 48h80V328c0-13.3 10.7-24 24-24H332c-2 5.2-3.8 10.6-5.4 16H256 232c-4.4 0-8 3.6-8 8V496h32 96 16 7.2c6.1 5.8 12.7 11.1 19.6 16H128c-35.3 0-64-28.7-64-64V217.1L13.3 262c-3.3 2.9-8.4 2.6-11.3-.7S-.6 252.9 2.7 250L282.7 2zM624 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0-136c4.4 0 8 3.6 8 8v96c0 4.4-3.6 8-8 8s-8-3.6-8-8V288c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faClipboard = {
    prefix: 'fat',
    iconName: 'clipboard',
    icon: [
      384,
      512,
      [128203],
      'f328',
      
      'M120.4 64c4-36 34.5-64 71.6-64s67.6 28 71.6 64H272c20.9 0 38.7 13.4 45.3 32H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h2.7C73.3 77.4 91.1 64 112 64h8.4zM64 112c-26.5 0-48 21.5-48 48V448c0 26.5 21.5 48 48 48H320c26.5 0 48-21.5 48-48V160c0-26.5-21.5-48-48-48v16c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V112zM192 16c-30.9 0-56 25.1-56 56c0 4.4-3.6 8-8 8H112c-17.7 0-32 14.3-32 32v16c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16V112c0-17.7-14.3-32-32-32H256c-4.4 0-8-3.6-8-8c0-30.9-25.1-56-56-56zM176 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faHexagonPlus = {
    prefix: 'fat',
    iconName: 'hexagon-plus',
    icon: [
      512,
      512,
      ["plus-hexagon"],
      'f300',
      
      'M400.8 450.8l0 0L497.1 284c2.5-4.3 4.4-8.9 5.6-13.6c2-7.7 2.4-15.7 1.1-23.6c-1.1-6.5-3.3-12.9-6.7-18.8L400.8 61.2c-10-17.3-28.5-28-48.5-28H159.7c-20 0-38.5 10.7-48.5 28L14.9 228c-3.9 6.7-6.3 14.1-7.1 21.6c-1.4 11.8 1 23.9 7.1 34.4l96.3 166.8c10 17.3 28.5 28 48.5 28H352.3c20 0 38.5-10.7 48.5-28zM483.2 236c2.7 4.6 4.4 9.7 5 14.8l-2.7 20.4c-.7 1.6-1.4 3.2-2.3 4.8L386.9 442.8c-7.1 12.4-20.4 20-34.6 20H159.7c-14.3 0-27.5-7.6-34.6-20L28.8 276c-3.6-6.2-5.4-13.1-5.4-20c0-3.4 .4-6.8 1.3-10.1c.9-3.4 2.2-6.8 4.1-9.9L125.1 69.2c7.1-12.4 20.4-20 34.6-20l192.6 0c14.3 0 27.5 7.6 34.6 20L483.2 236zM248 352c0 4.4 3.6 8 8 8s8-3.6 8-8V264h88c4.4 0 8-3.6 8-8s-3.6-8-8-8H264V160c0-4.4-3.6-8-8-8s-8 3.6-8 8v88H160c-4.4 0-8 3.6-8 8s3.6 8 8 8h88v88z'
      
    ]
  };

  
    var faPlusHexagon = faHexagonPlus;
  

  
  

  var faTaco = {
    prefix: 'fat',
    iconName: 'taco',
    icon: [
      512,
      512,
      [127790],
      'f826',
      
      'M265 51.1l44.1 34.2 9.8-12.6-9.8 12.6c8.6 6.6 19.2 10.1 30 9.7l55.8-1.7c6.7-.2 12.6 4.1 14.5 10.5l15.6 53.6c3 10.4 9.6 19.4 18.5 25.5l46.1 31.4c5.5 3.8 7.8 10.8 5.5 17c-1.5 4.3-3.8 9.3-6.6 15.5l0 0-.1 .2c-2.7 6-5.8 12.9-8.4 20c4.1 5.1 8 10.3 11.8 15.6c2.7-10 7.3-20.3 11.5-29.7c2.6-5.8 5.1-11.3 6.8-16.2c4.7-13.1 0-27.8-11.6-35.7l-46.1-31.4c-5.9-4-10.2-9.9-12.2-16.8L424.7 99.3c-3.9-13.4-16.4-22.5-30.4-22.1L338.6 79c-7.1 .2-14.1-2-19.7-6.4L274.8 38.4c-11-8.6-26.5-8.6-37.5 0L193.1 72.6c-5.6 4.4-12.6 6.6-19.7 6.4l-55.8-1.7c-14-.4-26.5 8.6-30.4 22.1L71.7 152.9c-2 6.8-6.3 12.8-12.2 16.8L13.4 201C1.9 208.9-2.9 223.6 1.8 236.7C3.6 241.6 6 247.1 8.7 253c4.2 9.4 8.8 19.6 11.5 29.7c3.7-5.3 7.7-10.5 11.8-15.6c-2.6-7.1-5.7-14-8.4-20l-.1-.2c-2.8-6.2-5-11.2-6.6-15.5c-2.3-6.3 0-13.3 5.5-17l46.1-31.4c9-6.1 15.5-15.1 18.5-25.5l15.6-53.6c1.9-6.4 7.8-10.7 14.5-10.5L172.9 95c10.8 .3 21.4-3.1 30-9.7L247 51.1c5.3-4.1 12.7-4.1 17.9 0zM256 208c132.5 0 240 107.5 240 240c0 8.8-7.2 16-16 16H32c-8.8 0-16-7.2-16-16c0-132.5 107.5-240 240-240zM32 480H480c17.7 0 32-14.3 32-32c0-141.4-114.6-256-256-256S0 306.6 0 448c0 17.7 14.3 32 32 32zm80-96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faChampagneGlasses = {
    prefix: 'fat',
    iconName: 'champagne-glasses',
    icon: [
      640,
      512,
      [129346,"glass-cheers"],
      'f79f',
      
      'M344 40.5c3.5 4.2 6.4 8.9 8.5 13.9L455.3 17c7.3-2.6 15.4 .3 19.3 7L522 105.1 341.6 170.7l-9.5 55.4 2.6 15c12.9 75.6 88.9 122.1 161.3 100.6L543 470.6l-71.3 25.9c-4.2 1.5-6.3 6.1-4.8 10.3s6.1 6.3 10.3 4.8l78.8-28.7 78.8-28.7c4.2-1.5 6.3-6.1 4.8-10.3s-6.1-6.3-10.3-4.8L558 465.1 511.1 336.3c69.2-30.1 97.6-114.6 58.9-180.8L488.4 15.9c-7.8-13.4-24-19.2-38.6-13.9L344 40.5zM556.2 163.6c35 59.9 7.2 136.9-58 160.7s-136-17.4-147.7-85.8l-8.7-50.8 188.4-68.6 26 44.5zm-472.4 0l26-44.5 188.4 68.6-8.7 50.8C277.8 306.8 207 348 141.8 324.2s-93-100.7-58-160.7zm217.1 8.1L118 105.1l47.4-81.1c3.9-6.7 12-9.6 19.3-7L306.4 61.3c7.3 2.6 11.6 10.1 10.3 17.7l-15.8 92.6zm4.4 69.5L332.5 81.7c2.6-15.2-6.1-30.2-20.6-35.5L190.2 1.9c-14.5-5.3-30.8 .6-38.6 13.9L70 155.5c-38.7 66.2-10.3 150.7 58.9 180.8L82 465.1 10.7 439.2c-4.2-1.5-8.7 .6-10.3 4.8s.6 8.7 4.8 10.3l78.8 28.7 78.8 28.7c4.2 1.5 8.7-.6 10.3-4.8s-.6-8.7-4.8-10.3L97 470.6l46.9-128.8c72.4 21.4 148.4-25 161.3-100.6z'
      
    ]
  };

  
    var faGlassCheers = faChampagneGlasses;
  

  
  

  var faMarsStrokeUp = {
    prefix: 'fat',
    iconName: 'mars-stroke-up',
    icon: [
      320,
      512,
      [9896,"mars-stroke-v"],
      'f22a',
      
      'M165.7 2.3c-3.1-3.1-8.2-3.1-11.3 0l-64 64c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L152 27.3V128H96c-4.4 0-8 3.6-8 8s3.6 8 8 8h56v48.2C67.4 196.4 0 266.3 0 352c0 88.4 71.6 160 160 160s160-71.6 160-160c0-85.7-67.4-155.6-152-159.8V144h56c4.4 0 8-3.6 8-8s-3.6-8-8-8H168V27.3l50.3 50.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-64-64zM160 496a144 144 0 1 1 0-288 144 144 0 1 1 0 288z'
      
    ]
  };

  
    var faMarsStrokeV = faMarsStrokeUp;
  

  
  

  var faUserMinus = {
    prefix: 'fat',
    iconName: 'user-minus',
    icon: [
      640,
      512,
      [],
      'f503',
      
      'M224 16a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 240A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 64h91.4C359.3 320 432 392.7 432 482.3c0 7.6-6.1 13.7-13.7 13.7H29.7c-7.6 0-13.7-6.1-13.7-13.7C16 392.7 88.7 320 178.3 320zm0-16C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3zM432 200c-4.4 0-8 3.6-8 8s3.6 8 8 8H624c4.4 0 8-3.6 8-8s-3.6-8-8-8H432z'
      
    ]
  };

  

  
  

  var faSignalSlash = {
    prefix: 'fat',
    iconName: 'signal-slash',
    icon: [
      640,
      512,
      [],
      'f695',
      
      'M584 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V360.1l16 12.6V8zM440 504c0 4.4 3.6 8 8 8s8-3.6 8-8V455.1l-16-12.6V504zm16-400c0-4.4-3.6-8-8-8s-8 3.6-8 8V259l16 12.6V104zM312 341.4V504c0 4.4 3.6 8 8 8s8-3.6 8-8V354l-16-12.6zM192 288c-4.4 0-8 3.6-8 8V504c0 4.4 3.6 8 8 8s8-3.6 8-8V296c0-4.4-3.6-8-8-8zM64 384c-4.4 0-8 3.6-8 8V504c0 4.4 3.6 8 8 8s8-3.6 8-8V392c0-4.4-3.6-8-8-8zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  

  
  

  var faRoadCircleXmark = {
    prefix: 'fat',
    iconName: 'road-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e566',
      
      'M217.4 32C194 32 173 46.6 164.9 68.6L40.4 404.6C26.9 441.1 54 480 93 480H360.2c-4.2-5.1-8.1-10.4-11.8-16H328V420.6c-2-6.5-3.7-13.2-5-20c-.9-.4-1.9-.6-3-.6c-4.4 0-8 3.6-8 8v56H93c-27.9 0-47.2-27.8-37.5-53.9l124.4-336C185.7 58.4 200.7 48 217.4 48H312v56c0 4.4 3.6 8 8 8s8-3.6 8-8V48h94.6c16.7 0 31.7 10.4 37.5 26.1l43.7 118.1c6 .3 11.9 .8 17.7 1.7L475.1 68.6C467 46.6 446 32 422.6 32H217.4zM328 200c0-4.4-3.6-8-8-8s-8 3.6-8 8V312c0 4.4 3.6 8 8 8s8-3.6 8-8V200zm40 168a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-132.7 0l50.3-50.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L496 356.7l-50.3-50.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L484.7 368l-50.3 50.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L496 379.3l50.3 50.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L507.3 368z'
      
    ]
  };

  

  
  

  var faStoreSlash = {
    prefix: 'fat',
    iconName: 'store-slash',
    icon: [
      640,
      512,
      [],
      'e071',
      
      'M499 489.1c-8 4.4-17.2 6.9-27 6.9H168c-30.9 0-56-25.1-56-56V376 264 223.2l.2 0c4 .5 8.1 .8 12.1 .8c11.2 0 21.8-2.1 31.5-5.8l-15.2-12c-5.2 1.2-10.7 1.9-16.3 1.9c-3.3 0-6.7-.2-10-.7c-30.7-4.1-50.8-32.1-50.4-61.8L49 133.8c-5.7 35.5 13 72.4 47 85.3V264 376v64c0 39.8 32.2 72 72 72H472c15 0 28.9-4.6 40.4-12.4L499 489.1zM141.6 0c-7.4 0-14.5 2.9-19.7 7.9L134.8 18c2-1.3 4.3-2 6.8-2H498.4c4.3 0 8.2 2.2 10.4 5.6l0 .1 57.3 90.7 0 0c24.2 38.3 1.8 89.3-40.7 95c-3.3 .4-6.6 .7-10 .7c-21.3 0-40.2-9.3-53.3-23.7c-3-3.3-7.3-5.2-11.9-5.2s-8.8 1.9-11.8 5.3c-13 14.4-31.9 23.7-53.3 23.7c-3.6 0-7.2-.3-10.7-.8L395 223.5c16.4-1.8 31.3-8.2 43.5-17.6c4.3-3.3 8.2-6.9 11.8-10.9c3.6 3.9 7.5 7.6 11.8 10.8c14.7 11.3 33.2 18.1 53.4 18.1c4.1 0 8.1-.3 12.1-.8l.5-.1V264v64.5l16 12.6V264 219.1c43.9-16.7 62.2-73.3 35.6-115.3L522.3 13.1C517.2 5 508.1 0 498.4 0H141.6zM184 368c-4.4 0-8-3.6-8-8V256c0-4.4-3.6-8-8-8s-8 3.6-8 8V360c0 13.3 10.7 24 24 24H365.9l-20.3-16H184zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  

  
  

  var faH4 = {
    prefix: 'fat',
    iconName: 'h4',
    icon: [
      640,
      512,
      [],
      'f86a',
      
      'M433.5 64.1c-4.3-.8-8.5 2-9.4 6.3l-40 208c-.5 2.3 .2 4.8 1.7 6.6s3.8 2.9 6.2 2.9H624V440c0 4.4 3.6 8 8 8s8-3.6 8-8V72c0-4.4-3.6-8-8-8s-8 3.6-8 8V272H401.7L439.9 73.5c.8-4.3-2-8.5-6.3-9.4zM16 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V248 440c0 4.4 3.6 8 8 8s8-3.6 8-8V256H304V440c0 4.4 3.6 8 8 8s8-3.6 8-8V248 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V240H16V72z'
      
    ]
  };

  

  
  

  var faBadgerHoney = {
    prefix: 'fat',
    iconName: 'badger-honey',
    icon: [
      640,
      512,
      [129441],
      'f6b4',
      
      'M395.9 95c-22.1 11.1-46.9 17-71.7 17H124c-6.8 0-13.5 .6-20 1.8v14C104 189.8 154.2 240 216.1 240c19.5 0 38.7-5.1 55.6-14.8L353 178.8C392.9 156 438 144 484 144H610.3c-3.3-3.3-7.1-6.2-11.4-8.5L524.9 96.3C504.6 85.6 482 80 459.1 80c-21.8 0-43.7 5.2-63.2 15zM88 118.1C46.1 133 16 173 16 220c0 1.1 0 2.1 0 3.1c0 .3 0 .6 0 .9v57 39c0 4.4-3.6 8-8 8s-8-3.6-8-8V224c0-.3 0-.5 0-.8c0-1.1 0-2.1 0-3.2C0 151.5 55.5 96 124 96H324.2c22.3 0 44.6-5.3 64.5-15.3c21.7-10.9 46-16.7 70.3-16.7c25.5 0 50.7 6.2 73.3 18.2l74.1 39.2c20.7 10.9 33.6 32.5 33.6 55.9c0 16.6-6.6 32.6-18.3 44.4c-11.8 11.8-27.6 17.9-43.5 19.4c-6.5 .6-13 1.4-19.5 2.5c.9 1.3 1.4 2.8 1.4 4.5v32c0 4.4-3.6 8-8 8s-8-3.6-8-8V248c0-.6 .1-1.2 .2-1.8c-57.3 12.3-111.2 40.8-146.6 66.9l20 120.3c4.1 24.4-14.7 46.6-39.5 46.6H347.1c-19.6 0-36.2-14.1-39.5-33.4L290.6 344H197.3l-17.3 40.5c-2.2 5.2-2.5 11-.9 16.3l8.3 27.7C195 454.2 175.8 480 149 480H119.8c-17.7 0-33.2-11.6-38.3-28.5L68.4 407.8c-3.1-10.3-3.1-21.2-.2-31.5l11.6-40.4c-18.4-7-34.7-18.4-47.7-32.7V276.6c13.5 22 34.7 38.7 59.9 46.5c4.1 1.3 6.5 5.7 5.3 9.8L83.6 380.7c-2.1 7.4-2 15.2 .1 22.5l13.1 43.7c3 10.2 12.4 17.1 23 17.1H149c16.1 0 27.6-15.5 23-30.9l-8.3-27.7c-2.7-9-2.1-18.6 1.5-27.3l19.4-45.3c1.3-2.9 4.2-4.8 7.4-4.8H297.3c3.9 0 7.2 2.8 7.9 6.7l18.2 109.3c1.9 11.6 11.9 20.1 23.7 20.1h31.1c14.8 0 26.1-13.3 23.7-27.9L381.1 311c-.5-2.9 .7-5.9 3-7.7c43.4-33.2 117.1-71.4 192.6-78.2c13-1.2 25-6.1 33.7-14.7c8.7-8.7 13.7-20.7 13.7-33.1c0-6-1.1-11.9-3.3-17.3H509.9c1.4 2.4 2.1 5.1 2.1 8c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-2.9 .8-5.6 2.1-8c-42.5 .3-84.3 11.6-121.2 32.7l-81.3 46.4c-19.4 11.1-41.3 16.9-63.6 16.9C145.4 256 88 198.6 88 127.9v-9.8z'
      
    ]
  };

  

  
  

  var faHeadset = {
    prefix: 'fat',
    iconName: 'headset',
    icon: [
      512,
      512,
      [],
      'f590',
      
      'M16 256C16 123.5 123.5 16 256 16s240 107.5 240 240V400.1c0 30.9-25.1 56-56 56L319.3 456c-3.8-22.7-23.6-40-47.3-40H240c-26.5 0-48 21.5-48 48s21.5 48 48 48h32c23.8 0 43.5-17.3 47.3-40l120.6 .1c39.8 0 72-32.2 72-72V256C512 114.6 397.4 0 256 0S0 114.6 0 256v56c0 4.4 3.6 8 8 8s8-3.6 8-8V256zm144-32V352c0 8.8-7.2 16-16 16c-35.3 0-64-28.7-64-64V272c0-35.3 28.7-64 64-64c8.8 0 16 7.2 16 16zM64 272v32c0 44.2 35.8 80 80 80c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32c-44.2 0-80 35.8-80 80zm288-48c0-8.8 7.2-16 16-16c35.3 0 64 28.7 64 64v32c0 35.3-28.7 64-64 64c-8.8 0-16-7.2-16-16V224zm96 48c0-44.2-35.8-80-80-80c-17.7 0-32 14.3-32 32V352c0 17.7 14.3 32 32 32c44.2 0 80-35.8 80-80V272zM304 464c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32z'
      
    ]
  };

  

  
  

  var faColonSign = {
    prefix: 'fat',
    iconName: 'colon-sign',
    icon: [
      384,
      512,
      [],
      'e140',
      
      'M247.8 9.8c1-4.3-1.7-8.6-6-9.6s-8.6 1.7-9.6 6l-13.1 58C115 69.8 32 153.3 32 256c0 73.8 42.8 137.6 105.5 169.8l-17.3 76.5c-1 4.3 1.7 8.6 6 9.6s8.6-1.7 9.6-6l16.5-73.1c18.8 7.8 39.1 12.8 60.3 14.6l-12.4 55c-1 4.3 1.7 8.6 6 9.6s8.6-1.7 9.6-6l13-57.8c.4 0 .8 0 1.1 0c44.5 0 85.6-14.2 118.7-38.3c3.6-2.6 4.4-7.6 1.8-11.2s-7.6-4.4-11.2-1.8c-29.8 21.7-66.7 34.7-106.8 35.3L308.1 97c11.1 5.1 21.5 11.2 31.2 18.3c3.6 2.6 8.6 1.8 11.2-1.8s1.8-8.6-1.8-11.2c-11.4-8.3-23.8-15.5-37-21.3L327.8 9.8c1-4.3-1.7-8.6-6-9.6s-8.6 1.7-9.6 6L296.6 75.2c-19.2-6.6-39.7-10.5-61.1-11.1L247.8 9.8zM215.4 80.6L141.1 409.6C85.5 379.5 48 321.9 48 256c0-92.2 73.5-168.3 167.4-175.4zM155.9 416.8L231.9 80c21.5 .2 42.1 4 61.1 10.9L216.2 431.5c-21.3-1.5-41.6-6.6-60.3-14.7z'
      
    ]
  };

  

  
  

  var faUnlock = {
    prefix: 'fat',
    iconName: 'unlock',
    icon: [
      448,
      512,
      [128275],
      'f09c',
      
      'M112 128c0-61.9 50.1-112 112-112c51.5 0 94.9 34.8 108 82.1c1.2 4.3 5.6 6.8 9.8 5.6s6.8-5.6 5.6-9.8C332.5 39.8 282.9 0 224 0C153.3 0 96 57.3 96 128v64H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H112V128zM96 208h16H384c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V256c0-26.5 21.5-48 48-48H96z'
      
    ]
  };

  

  
  

  var faSheep = {
    prefix: 'fat',
    iconName: 'sheep',
    icon: [
      640,
      512,
      [128017],
      'f711',
      
      'M560 132c0-46.4-37.6-84-84-84s-84 37.6-84 84v76c0 44.2 35.8 80 80 80h8c44.2 0 80-35.8 80-80V132zM384.6 91.4C400.2 56.4 435.2 32 476 32s75.8 24.4 91.4 59.4L618.3 126c8.6 5.8 13.7 15.5 13.7 25.9c0 24-26 39.1-46.8 27.2l-9.2-5.3V208c0 53-43 96-96 96h-8c-53 0-96-43-96-96V173.8l-9.2 5.3C346 191 320 175.9 320 151.9c0-10.4 5.1-20 13.7-25.9l50.9-34.7zM576 132v23.4l17.1 9.8c10.2 5.8 22.9-1.5 22.9-13.3c0-5.1-2.5-9.8-6.7-12.6l-34.6-23.6c.9 5.3 1.3 10.8 1.3 16.3zM377.3 115.7l-34.6 23.6c-4.2 2.8-6.7 7.6-6.7 12.6c0 11.7 12.7 19.1 22.9 13.3l17.1-9.8V132c0-5.6 .5-11 1.3-16.3zM448 144a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM416 360c18.3 0 34.1-10.2 42.2-25.2c5.6 .8 11.3 1.2 17.1 1.2c-8.7 21.6-28.9 37.3-52.9 39.7L397.6 481.2c-4.3 18.1-20.4 30.8-38.9 30.8H344c-22.1 0-40-17.9-40-40V448c0-4.4 3.6-8 8-8s8 3.6 8 8v24c0 13.3 10.7 24 24 24h14.7c11.1 0 20.8-7.7 23.4-18.5l23.4-99.4C397.6 404.6 373.1 424 344 424c-15 0-28.9-5.2-39.8-13.9c-11.7 13.4-29 21.9-48.2 21.9s-36.5-8.5-48.2-21.9C196.9 418.8 183 424 168 424c-29.1 0-53.6-19.4-61.4-45.9L130 477.5c2.6 10.8 12.2 18.5 23.4 18.5H168c13.3 0 24-10.7 24-24V448c0-4.4 3.6-8 8-8s8 3.6 8 8v24c0 22.1-17.9 40-40 40H153.3c-18.6 0-34.7-12.8-38.9-30.8L89.6 375.7C57.3 372.5 32 345.2 32 312c0-5.3 .7-10.5 1.9-15.5C13.7 285.7 0 264.5 0 240s13.7-45.7 33.9-56.5c-1.2-5-1.9-10.2-1.9-15.5c0-35.3 28.7-64 64-64c3.3 0 6.6 .3 9.8 .8C112.7 76.8 137.9 56 168 56c15 0 28.9 5.2 39.8 13.9C219.5 56.5 236.8 48 256 48s36.5 8.5 48.2 21.9C315.1 61.2 329 56 344 56c7.6 0 14.8 1.3 21.5 3.7c-3 4.5-5.7 9.3-8.1 14.2c-4.3-1.2-8.8-1.9-13.4-1.9c-11.3 0-21.7 3.9-29.8 10.4c-6.7 5.3-16.4 4.4-22-2C283.3 70.3 270.4 64 256 64s-27.3 6.3-36.1 16.4c-5.6 6.4-15.3 7.3-22 2C189.7 75.9 179.3 72 168 72c-22.5 0-41.5 15.6-46.6 36.5c-2 8.1-9.8 13.3-18 12c-2.4-.4-4.9-.6-7.4-.6c-26.5 0-48 21.5-48 48c0 4 .5 7.9 1.4 11.6c1.8 7.1-1.5 14.5-8 18C26.3 205.7 16 221.7 16 240s10.3 34.3 25.4 42.4c6.5 3.5 9.8 10.9 8 18C48.5 304.1 48 308 48 312c0 26.5 21.5 48 48 48c2.5 0 5-.2 7.4-.6c8.2-1.3 16 4 18 12c5.1 21 24.1 36.6 46.6 36.6c11.3 0 21.7-3.9 29.8-10.4c6.7-5.3 16.4-4.4 22 2c8.8 10.1 21.7 16.4 36.1 16.4s27.3-6.3 36.1-16.4c5.6-6.4 15.3-7.3 22-2c8.2 6.5 18.5 10.4 29.8 10.4c22.5 0 41.5-15.6 46.6-36.6c2-8.1 9.8-13.3 18-12c2.4 .4 4.9 .6 7.4 .6z'
      
    ]
  };

  

  
  

  var faCitrusSlice = {
    prefix: 'fat',
    iconName: 'citrus-slice',
    icon: [
      512,
      512,
      [],
      'e2f5',
      
      'M421.7 2.3c-3.1-3.1-8.2-3.1-11.3 0l-408 408c-3.1 3.1-3.1 8.2 0 11.3l3.5 3.5c55.6 55.6 131 86.8 209.7 86.8C379.3 512 512 379.3 512 215.5c0-78.6-31.2-154.1-86.8-209.7l-3.5-3.5zM215.5 496c-73.4 0-143.8-28.7-196.2-80l34.3-34.3C95.5 422.7 152.8 448 216 448c128.1 0 232-103.9 232-232c0-63.2-25.3-120.5-66.3-162.4L416 19.3c51.3 52.4 80 122.8 80 196.2C496 370.4 370.4 496 215.5 496zM431.4 200c.4 5.3 .6 10.6 .6 16c0 56.8-21.9 108.4-57.7 147L269.9 258.6C281.2 244.8 288 227.2 288 208c0-2.7-.1-5.4-.4-8H431.4zm-1.8-16H284.3c-2.5-8-6.2-15.4-10.9-22.1l97-97c31.1 31.7 52.4 73 59.3 119.1zm-171 85.9L363 374.3C324.4 410.1 272.8 432 216 432c-5.4 0-10.7-.2-16-.6V287.6c2.6 .3 5.3 .4 8 .4c19.2 0 36.8-6.8 50.6-18.1zM184 429.6c-46-6.8-87.3-28.2-119.1-59.3l97-97c6.7 4.7 14.1 8.4 22.1 10.9V429.6zM208 272c-12.7 0-24.6-3.7-34.6-10.1l88.4-88.4c6.4 10 10.1 21.8 10.1 34.6c0 35.3-28.7 64-64 64z'
      
    ]
  };

  

  
  

  var faPepperHot = {
    prefix: 'fat',
    iconName: 'pepper-hot',
    icon: [
      512,
      512,
      [127798],
      'f816',
      
      'M441.6 127.3l5.8 4.6 5.3 5.2c26.8 26.2 43.4 62.6 43.4 103c0 16.7-2.8 32.7-8 47.5c-.4 1.2-.9 1.6-1 1.6l0 0c-.1 .1-.5 .3-1.2 .3c-1.4 0-3.7-.9-5.2-3.9l-11.7-23.4c-6.8-13.6-20.6-22.1-35.8-22.1H360c-4.4 0-8-3.6-8-8V152c0-22.1-17.9-40-40-40l-17.1 0c-3.1 0-4.6-1.1-5.1-1.8c.3-.2 .6-.4 1.1-.6C309.4 100.9 330.1 96 352 96c33.9 0 65 11.7 89.6 31.3zM512 240c0-44.8-18.4-85.3-48.1-114.4l0 0c.5-1 1.1-1.9 1.6-2.9c12-22.3 16.6-48 13.2-73c-1.1-8.1-3-16.1-5.8-23.9c-1.6-4.6-3.5-9.1-5.8-13.5l-3.9-7.8 0 0c-2-4-6.8-5.6-10.7-3.6s-5.6 6.8-3.6 10.7l3.9 7.8c5.9 11.9 9.4 24.5 10.6 37.2c1.3 14.6-.5 29.2-5.2 43c-1.8 5.2-4 10.3-6.6 15.2c-4.2-3.4-8.6-6.5-13.1-9.4C413.5 89.3 383.8 80 352 80c-24.3 0-47.3 5.4-67.9 15.1c-19.3 9-10.5 32.9 10.8 32.9l17.1 0c13.3 0 24 10.7 24 24v80c0 13.3 10.7 24 24 24h73.2c9.1 0 17.4 5.1 21.5 13.3l11.7 23.4c8.2 16.4 30.7 17.5 36.8 .1c5.8-16.5 8.9-34.3 8.9-52.8zM289.2 110.7a0 0 0 1 0 0 0 0 0 0 1 0 0 0zM261.7 160L172.4 305.7c-18.1 29.6-47.5 50.5-81.4 58.1l-35.4 7.9C23.1 378.9 0 407.7 0 441c0 39.2 31.8 71 71 71h32.1c141.1 0 269.1-68.1 348.9-176.2L444 319.6C367.6 427.6 241.9 496 103.2 496H71c-30.4 0-55-24.6-55-55c0-25.8 17.9-48.1 43.1-53.7l35.4-7.9c38.1-8.5 71.1-32 91.5-65.3L280.4 160H261.7z'
      
    ]
  };

  

  
  

  var faClockTwelve = {
    prefix: 'fat',
    iconName: 'clock-twelve',
    icon: [
      512,
      512,
      [],
      'e358',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM264 104V256c0 4.4-3.6 8-8 8s-8-3.6-8-8V104c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faMicrophoneLines = {
    prefix: 'fat',
    iconName: 'microphone-lines',
    icon: [
      384,
      512,
      [127897,"microphone-alt"],
      'f3c9',
      
      'M272 112V96c0-44.2-35.8-80-80-80s-80 35.8-80 80V256c0 44.2 35.8 80 80 80s80-35.8 80-80H200c-4.4 0-8-3.6-8-8s3.6-8 8-8h72V192H200c-4.4 0-8-3.6-8-8s3.6-8 8-8h72V128H200c-4.4 0-8-3.6-8-8s3.6-8 8-8h72zm16 8v64 64 8c0 53-43 96-96 96s-96-43-96-96V96c0-53 43-96 96-96s96 43 96 96v24zM40 192c4.4 0 8 3.6 8 8v56c0 79.5 64.5 144 144 144s144-64.5 144-144V200c0-4.4 3.6-8 8-8s8 3.6 8 8v56c0 85.7-67.4 155.6-152 159.8V496h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H192 104c-4.4 0-8-3.6-8-8s3.6-8 8-8h80V415.8C99.4 411.6 32 341.7 32 256V200c0-4.4 3.6-8 8-8z'
      
    ]
  };

  
    var faMicrophoneAlt = faMicrophoneLines;
  

  
  

  var faSignalBarsWeak = {
    prefix: 'fat',
    iconName: 'signal-bars-weak',
    icon: [
      640,
      512,
      ["signal-alt-1"],
      'f691',
      
      'M112 464c0 17.7-14.3 32-32 32s-32-14.3-32-32V432c0-17.7 14.3-32 32-32s32 14.3 32 32v32zM80 384c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48s48-21.5 48-48V432c0-26.5-21.5-48-48-48z'
      
    ]
  };

  
    var faSignalAlt1 = faSignalBarsWeak;
  

  
  

  var faCity = {
    prefix: 'fat',
    iconName: 'city',
    icon: [
      640,
      512,
      [127961],
      'f64f',
      
      'M80 8V64h80V8c0-4.4 3.6-8 8-8s8 3.6 8 8V64h48V80H176 160 80 64 56c-22.1 0-40 17.9-40 40V456c0 22.1 17.9 40 40 40H236.8c3.3 5.7 7.2 11.1 11.6 16H56c-30.9 0-56-25.1-56-56V120C0 89.1 25.1 64 56 64h8V8c0-4.4 3.6-8 8-8s8 3.6 8 8zM480 176c-8.8 0-16-7.2-16-16V64c0-26.5-21.5-48-48-48H320c-26.5 0-48 21.5-48 48V224 448c0 26.5 21.5 48 48 48h96H576c26.5 0 48-21.5 48-48V224c0-26.5-21.5-48-48-48H480zm0-112v80 16h16 80c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H416 320c-35.3 0-64-28.7-64-64V224 64c0-35.3 28.7-64 64-64h96c35.3 0 64 28.7 64 64zM328 384V352c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H352c-13.3 0-24-10.7-24-24zm24 8h32c4.4 0 8-3.6 8-8V352c0-4.4-3.6-8-8-8H352c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8zm0-320h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H352c-13.3 0-24-10.7-24-24V96c0-13.3 10.7-24 24-24zm-8 24v32c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V96c0-4.4-3.6-8-8-8H352c-4.4 0-8 3.6-8 8zM328 256V224c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H352c-13.3 0-24-10.7-24-24zm24 8h32c4.4 0 8-3.6 8-8V224c0-4.4-3.6-8-8-8H352c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8zM512 440c-13.3 0-24-10.7-24-24V384c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H512zm-8-24c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V384c0-4.4-3.6-8-8-8H512c-4.4 0-8 3.6-8 8v32zM488 288V256c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H512c-13.3 0-24-10.7-24-24zm24 8h32c4.4 0 8-3.6 8-8V256c0-4.4-3.6-8-8-8H512c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8zM96 344c-13.3 0-24-10.7-24-24V288c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H96zm-8-24c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V288c0-4.4-3.6-8-8-8H96c-4.4 0-8 3.6-8 8v32zM72 192V160c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H96c-13.3 0-24-10.7-24-24zm24 8h32c4.4 0 8-3.6 8-8V160c0-4.4-3.6-8-8-8H96c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8z'
      
    ]
  };

  

  
  

  var faCodeFork = {
    prefix: 'fat',
    iconName: 'code-fork',
    icon: [
      448,
      512,
      [],
      'e13b',
      
      'M64 112a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm64-48c0 32.6-24.4 59.6-56 63.5V192c0 30.9 25.1 56 56 56H320c30.9 0 56-25.1 56-56V127.5c-31.6-3.9-56-30.9-56-63.5c0-35.3 28.7-64 64-64s64 28.7 64 64c0 32.6-24.4 59.6-56 63.5V192c0 39.8-32.2 72-72 72H232V384h-8-8V264H128c-39.8 0-72-32.2-72-72V127.5C24.4 123.6 0 96.6 0 64C0 28.7 28.7 0 64 0s64 28.7 64 64zm96 448a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM384 112a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM272 448a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  

  
  

  var faHeartCirclePlus = {
    prefix: 'fat',
    iconName: 'heart-circle-plus',
    icon: [
      576,
      512,
      [],
      'e500',
      
      'M393.6 57.7c-42.9-5.6-85.8 12.6-111.2 47.6l-20 27.5c-1.5 2.1-3.9 3.3-6.5 3.3s-5-1.2-6.5-3.3l-20-27.5c-25.4-34.9-68.3-53.2-111.2-47.6C60.1 65.3 16 114.9 16 173.5c0 30.3 11.8 59.4 32.9 81.2L248 460.4c2.2 2.3 5.2 3.6 8.4 3.6s6.2-1.3 8.4-3.6l11-11.4c2.6 4.9 5.4 9.7 8.4 14.4l-7.8 8.1c-5.2 5.4-12.4 8.5-19.9 8.5c-7.5 0-14.7-3-19.9-8.4L37.4 265.8C13.4 241.1 0 208 0 173.5C0 106.8 50.2 50.4 116.3 41.8c48.6-6.3 97.4 14.3 126.2 54L256 114.4l13.5-18.6c28.9-39.7 77.6-60.4 126.2-54c66.1 8.6 116.3 65 116.3 131.8c0 12-1.6 23.9-4.8 35.3c-4.9-2.3-9.8-4.4-14.9-6.2c2.4-9.4 3.7-19.2 3.7-29C496 115 451.9 65.3 393.6 57.7zM560 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm152-72v64h64c4.4 0 8 3.6 8 8s-3.6 8-8 8H440v64c0 4.4-3.6 8-8 8s-8-3.6-8-8V376H360c-4.4 0-8-3.6-8-8s3.6-8 8-8h64V296c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faFlatbread = {
    prefix: 'fat',
    iconName: 'flatbread',
    icon: [
      512,
      512,
      [129747],
      'e40b',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm357.7-90.3l-192 192c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l192-192c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3zm-112-59.3c3.1 3.1 3.1 8.2 0 11.3l-128 128c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l128-128c3.1-3.1 8.2-3.1 11.3 0zm160 171.3l-128 128c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l128-128c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3z'
      
    ]
  };

  

  
  

  var faBowlHot = {
    prefix: 'fat',
    iconName: 'bowl-hot',
    icon: [
      512,
      512,
      ["soup"],
      'f823',
      
      'M136 0c4.4 0 8 3.6 8 8V25.4c0 26.1 13.7 50.3 36.1 63.8c27.2 16.3 43.9 45.8 43.9 77.5V184c0 4.4-3.6 8-8 8s-8-3.6-8-8V166.6c0-26.1-13.7-50.3-36.1-63.8C144.7 86.5 128 57.1 128 25.4V8c0-4.4 3.6-8 8-8zm-.1 458.9c4.5 2.2 7.7 6.4 8.7 11.3c2.9 14.7 15.9 25.8 31.4 25.8H336c15.5 0 28.5-11.1 31.4-25.8c1-4.9 4.2-9.1 8.7-11.3c65.5-32 111.8-97.4 116.4-174.7l1.6-27.3c.5-9.2-6.8-16.9-16-16.9H33.9c-9.2 0-16.5 7.7-16 16.9l1.6 27.3c4.5 77.3 50.9 142.7 116.4 174.7zM2 257.9C.9 239.5 15.5 224 33.9 224H478.1c18.4 0 33 15.5 31.9 33.9l-1.6 27.3c-4.9 83.3-54.8 153.7-125.3 188.2c-4.3 22-23.8 38.7-47.1 38.7H176c-23.3 0-42.8-16.6-47.1-38.7C58.4 438.9 8.5 368.4 3.6 285.2L2 257.9zM272 8V25.4c0 26.1 13.7 50.3 36.1 63.8c27.2 16.3 43.9 45.8 43.9 77.5V184c0 4.4-3.6 8-8 8s-8-3.6-8-8V166.6c0-26.1-13.7-50.3-36.1-63.8C272.7 86.5 256 57.1 256 25.4V8c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  
    var faSoup = faBowlHot;
  

  
  

  var faCandy = {
    prefix: 'fat',
    iconName: 'candy',
    icon: [
      640,
      512,
      [127852],
      'e3e7',
      
      'M391.5 416.9L234.2 102.3c-26.1 14.6-48 35.6-63.7 60.8L304.6 431.3c7 .6 14.1 .8 21.3 .6c23.4-.8 45.5-6.1 65.6-15zm14.3-7.2c26.1-14.6 48-35.6 63.7-60.8L335.4 80.7c-7-.6-14.1-.8-21.3-.6c-23.3 .8-45.5 6.1-65.6 15L405.8 409.7zm73.1-77.9c11.8-24.7 18-52.5 17-81.7c-2.8-83.2-63-151-141.3-166.7L478.9 331.8zM345.8 65.7c76 10.2 138.5 65.1 159 138.1l91.9-49c10.5-5.6 23.5-2.7 30.6 6.9c13 17.5-3.4 34.9-18.4 48.6c-1.6 1.5-3.3 2.9-4.9 4.3l0 0c-3.2 2.9-6.3 5.6-8.7 8c2.8 1 5.8 2 9 3l0 0c2.7 .9 5.5 1.8 8.3 2.7c13.8 4.9 27.4 11.9 27.4 27.6s-13.6 22.7-27.4 27.6c-2.8 1-5.6 1.9-8.3 2.7l0 0 0 0c-3.2 1-6.3 2-9 3c2.4 2.4 5.4 5.1 8.7 8l0 0 0 0 0 0c1.6 1.4 3.2 2.8 4.9 4.3c15 13.6 31.4 31.1 18.4 48.6c-7.1 9.6-20.1 12.5-30.6 6.9l-91.9-49C482.7 386.5 412.1 445 326.4 447.9c-90.2 3-167.9-56.6-191.3-139.7l-91.9 49c-10.5 5.6-23.5 2.7-30.6-6.9c-13-17.5 3.4-34.9 18.4-48.6c1.6-1.5 3.3-2.9 4.8-4.3l0 0 0 0 0 0 0 0c3.2-2.9 6.3-5.6 8.7-8c-2.8-1-5.8-2-9-3l0 0 0 0c-2.7-.9-5.5-1.8-8.3-2.7C13.6 278.7 0 271.7 0 256s13.6-22.7 27.4-27.6c2.8-1 5.6-1.9 8.3-2.7l0 0 0 0c3.2-1 6.3-2 9-3c-2.4-2.4-5.4-5.1-8.7-8l0 0 0 0c-1.6-1.4-3.2-2.8-4.8-4.3C16.1 196.7-.3 179.2 12.7 161.7c7.1-9.6 20.1-12.5 30.6-6.9l91.9 49c4.1-14.5 9.9-28.4 17.1-41.4l0 0c3.1-5.5 6.4-10.8 9.9-15.9l0 0C179 122.4 201.2 102.3 227 88l0 0c4.7-2.6 9.4-5 14.3-7.2l0 0c22.1-9.9 46.5-15.8 72.2-16.7c4.6-.2 9.1-.1 13.6 0l0 0c6.3 .2 12.5 .8 18.7 1.6l0 0zM161.1 180.2c-11.8 24.7-18 52.5-17 81.7c2.8 83.2 63 151 141.3 166.7L161.1 180.2zm350.8 69.4c.5 14.6-.7 28.8-3.3 42.5l95.6 51c3.5 1.9 7.8 .9 10.2-2.3c1.7-2.3 1.7-3.7 1.5-4.9c-.4-2-1.8-5.1-5.2-9.5c-3.3-4.2-7.7-8.5-12.6-12.9c-1.3-1.2-2.7-2.5-4.2-3.8l0 0c-3.4-3.1-7.1-6.3-9.8-9.1c-3.8-3.8-5.5-9.4-4.3-14.7s4.9-9.7 10-11.6c3.1-1.2 6.8-2.4 10.3-3.5l0 0c1.5-.5 3-1 4.3-1.4c4.8-1.6 8.9-3.1 12.2-4.9c6.6-3.5 7.5-5.9 7.5-8.7s-.9-5.2-7.5-8.7c-3.4-1.8-7.5-3.3-12.2-4.9c-1.3-.4-2.8-.9-4.3-1.4c-3.4-1.1-7.2-2.3-10.3-3.5c-5.1-1.9-8.9-6.3-10-11.6s.5-10.9 4.3-14.7c2.8-2.8 6.4-6 9.8-9.1l0 0c1.5-1.3 2.9-2.6 4.2-3.8c4.9-4.4 9.3-8.7 12.6-12.9c3.4-4.3 4.9-7.4 5.2-9.5c.2-1.3 .3-2.6-1.5-4.9c-2.4-3.2-6.7-4.2-10.2-2.3l-95.6 51c1.8 9.6 2.9 19.5 3.3 29.6zM131.4 219.9l-95.6-51c-3.5-1.9-7.8-.9-10.2 2.3c-1.7 2.3-1.7 3.7-1.5 4.9c.4 2 1.8 5.1 5.2 9.5c3.3 4.2 7.7 8.5 12.6 12.9c1.3 1.2 2.7 2.5 4.2 3.8l0 0 0 0c3.4 3.1 7.1 6.3 9.8 9.1c3.8 3.8 5.5 9.4 4.3 14.7s-4.9 9.7-10 11.6c-3.1 1.2-6.8 2.4-10.3 3.5l0 0 0 0 0 0c-1.5 .5-3 1-4.3 1.4c-4.8 1.6-8.9 3.1-12.2 4.9c-6.6 3.5-7.5 5.9-7.5 8.7s.9 5.2 7.5 8.7c3.4 1.8 7.5 3.3 12.2 4.9c1.3 .4 2.8 .9 4.3 1.4l0 0c3.4 1.1 7.2 2.3 10.3 3.5c5.1 1.9 8.9 6.3 10 11.6s-.5 10.9-4.3 14.7c-2.8 2.8-6.4 6-9.8 9.1c-1.5 1.3-2.9 2.6-4.2 3.8c-4.9 4.4-9.3 8.7-12.6 12.9c-3.4 4.3-4.9 7.4-5.2 9.5c-.2 1.3-.3 2.6 1.5 4.9c2.4 3.2 6.7 4.2 10.2 2.3l95.6-51c-1.8-9.6-2.9-19.5-3.3-29.6c-.5-14.6 .7-28.8 3.3-42.5z'
      
    ]
  };

  

  
  

  var faAlbumCollectionCircleUser = {
    prefix: 'fat',
    iconName: 'album-collection-circle-user',
    icon: [
      640,
      512,
      [],
      'e48f',
      
      'M64 0H448c17.7 0 32 14.3 32 32v8c0 4.4-3.6 8-8 8s-8-3.6-8-8V32c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16v8c0 4.4-3.6 8-8 8s-8-3.6-8-8V32C32 14.3 46.3 0 64 0zM16 112c0-17.7 14.3-32 32-32H464c17.7 0 32 14.3 32 32v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8zM4.2 212.6C1.5 184.4 23.7 160 52 160H460c21.2 0 38.9 13.6 45.4 32.2c-3.1-.2-6.2-.2-9.4-.2c-2.7 0-5.5 .1-8.2 .2C482.4 182.6 472 176 460 176H52c-18.9 0-33.6 16.2-31.9 35L44.5 467c1.6 16.4 15.4 29 31.9 29H375.2c6.1 5.8 12.7 11.1 19.6 16H76.4c-24.7 0-45.4-18.8-47.8-43.4L4.2 212.6zM256 208c45.1 0 86.3 12.7 117.4 33.7c-3.9 3.8-7.6 7.7-11.1 11.8C334.3 235.3 297.2 224 256 224c-45.5 0-86 13.8-114.9 35.5S96 309.7 96 340s16.3 58.9 45.1 80.5S210.5 456 256 456c29.2 0 56.3-5.7 79.6-15.5c2.2 4.9 4.6 9.7 7.3 14.3C317.2 465.8 287.6 472 256 472c-97.2 0-176-59.1-176-132s78.8-132 176-132zm25.8 160.6c-7.3 4.9-16.5 7.4-25.8 7.4s-18.5-2.5-25.8-7.4C223 363.8 216 355.4 216 344s7-19.8 14.2-24.6c7.3-4.9 16.5-7.4 25.8-7.4s18.5 2.5 25.8 7.4c7.2 4.8 14.2 13.2 14.2 24.6s-7 19.8-14.2 24.6zM256 360c13.3 0 24-7.2 24-16s-10.7-16-24-16s-24 7.2-24 16s10.7 16 24 16zM573.9 469.6l-3.3-6.6c-9.5-19-28.9-31-50.1-31H471.6c-21.2 0-40.6 12-50.1 31l-3.3 6.6C439.7 486.2 466.7 496 496 496s56.3-9.8 77.9-26.4zm12.4-10.9C609.6 435.5 624 403.5 624 368c0-70.7-57.3-128-128-128s-128 57.3-128 128c0 35.5 14.4 67.5 37.7 90.7l1.5-2.9c12.2-24.4 37.1-39.8 64.4-39.8h48.9c27.3 0 52.2 15.4 64.4 39.8l1.5 2.9zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  

  
  

  var faFolderOpen = {
    prefix: 'fat',
    iconName: 'folder-open',
    icon: [
      576,
      512,
      [61717,128194,128449],
      'f07c',
      
      'M64 464c-10.6 0-20.5-5.3-26.5-14.1s-7.2-20-3.2-29.8l64-160C103.1 248 114.9 240 128 240H528c10.6 0 20.5 5.3 26.5 14.1s7.2 20 3.2 29.8l-64 160C488.9 456 477.1 464 464 464H384 64zm320 16h80c19.6 0 37.3-11.9 44.6-30.2l64-160c5.9-14.8 4.1-31.5-4.8-44.7S543.9 224 528 224H128c-19.6 0-37.3 11.9-44.6 30.2l-64 160c-1.3 3.2-2.2 6.5-2.8 9.8c-.4-2.6-.7-5.3-.7-8V96c0-26.5 21.5-48 48-48H181.5c12.7 0 24.9 5.1 33.9 14.1l26.5 26.5c15 15 35.4 23.4 56.6 23.4H416c26.5 0 48 21.5 48 48v32h16V160c0-35.3-28.7-64-64-64H298.5c-17 0-33.3-6.7-45.3-18.7L226.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384z'
      
    ]
  };

  

  
  

  var faFaceLaugh = {
    prefix: 'fat',
    iconName: 'face-laugh',
    icon: [
      512,
      512,
      ["laugh"],
      'f599',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 416c64.7 0 119.5-44.8 135.8-106.1c.4-1.4 .1-2.5-.9-3.6c-1.1-1.2-3-2.3-5.4-2.3H126.5c-2.4 0-4.4 1.1-5.4 2.3c-1 1.1-1.2 2.2-.9 3.6C136.5 371.2 191.3 416 256 416zM126.5 288H385.5c14.2 0 25.4 12.3 21.8 26c-18.1 68-79 118-151.3 118s-133.2-50-151.3-118c-3.6-13.7 7.6-26 21.8-26zm33.9-96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  
    var faLaugh = faFaceLaugh;
  

  
  

  var faChartPieSimple = {
    prefix: 'fat',
    iconName: 'chart-pie-simple',
    icon: [
      512,
      512,
      ["chart-pie-alt"],
      'f64e',
      
      'M259 7.6c-1.9 2.9-3 6.3-3 10V240c0 8.8 7.2 16 16 16H494.3c9.6 0 17.7-7.4 17.7-17.1C512 107 405 0 273.1 0c-5.9 0-11 3.1-14.1 7.6zM494.3 240H272V17.7c0-.7 .2-1.1 .5-1.4c.1-.1 .2-.2 .3-.2c0 0 .1 0 .3 0C396.2 16 496 115.8 496 238.9c0 .1 0 .2 0 .3c0 .1-.1 .2-.2 .3c-.3 .3-.8 .5-1.4 .5zM208 288c0 8.8 7.2 16 16 16H445.3c10 0 15.3 8 13.9 14.5C437.8 419.9 347.7 496 240 496C116.3 496 16 395.7 16 272C16 164.3 92.1 74.2 193.5 52.8C200 51.4 208 56.7 208 66.7V288zM224 66.7c0-18.5-15.7-33.3-33.8-29.5C81.5 60.1 0 156.5 0 272C0 404.5 107.5 512 240 512c115.5 0 211.9-81.5 234.8-190.2c3.8-18.1-11-33.8-29.5-33.8H240 224V272 66.7z'
      
    ]
  };

  
    var faChartPieAlt = faChartPieSimple;
  

  
  

  var faShirtLongSleeve = {
    prefix: 'fat',
    iconName: 'shirt-long-sleeve',
    icon: [
      640,
      512,
      [],
      'e3c7',
      
      'M95.3 61.6c15.5-28.1 45-45.6 77.1-45.6H192h16c.9 0 1.8 .1 2.7 .2c.5 .1 1.1 .1 1.6 0c1.2-.1 2.4-.2 3.7-.2h9.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H424c1.2 0 2.5 .1 3.7 .2c.5 0 1.1 0 1.6 0c.9-.1 1.8-.2 2.7-.2h16 19.6c32.1 0 61.6 17.5 77.1 45.6l66.4 120.7c8.4 15.4 12.9 32.6 12.9 50.1V376c0 13.3-10.7 24-24 24H568c-13.3 0-24-10.7-24-24V232.4c0-4-1-8-3-11.6l-7 3.9 7-3.9L483.7 116.7c-1.6-3-3.6-5.7-5.9-8.1c-2.2-2.4-5.7-3.2-8.8-2s-5 4.2-5 7.4V464c0 17.7-14.3 32-32 32H208c-17.7 0-32-14.3-32-32V114.1c0-3.3-2-6.2-5.1-7.4s-6.5-.4-8.8 2c-2.3 2.4-4.3 5.2-5.9 8.1L99 220.9c-1.9 3.5-3 7.5-3 11.6V376c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24V232.4c0-17.5 4.4-34.8 12.9-50.1L95.3 61.6zM398.4 16C391 52.5 358.7 80 320 80s-71-27.5-78.4-64H398.4zM172.4 0C134.5 0 99.5 20.6 81.3 53.9L14.9 174.6C5.1 192.3 0 212.2 0 232.4V376c0 22.1 17.9 40 40 40H72c22.1 0 40-17.9 40-40V232.4c0-1.3 .3-2.7 1-3.9l47-85.5V464c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V143.1l47 85.5c.6 1.2 1 2.5 1 3.9V376c0 22.1 17.9 40 40 40h32c22.1 0 40-17.9 40-40V232.4c0-20.2-5.1-40.1-14.9-57.8L558.7 53.9C540.5 20.6 505.5 0 467.6 0H448 432c-1.2 0-2.5 .1-3.7 .2c-1.4-.1-2.9-.2-4.3-.2H216c-1.5 0-2.9 .1-4.3 .2c-1.2-.1-2.4-.2-3.7-.2H192 172.4z'
      
    ]
  };

  

  
  

  var faShuttleSpace = {
    prefix: 'fat',
    iconName: 'shuttle-space',
    icon: [
      640,
      512,
      ["space-shuttle"],
      'f197',
      
      'M405.3 352L245.2 448.1C210.4 469 170.6 480 130 480H80c-26.5 0-48-21.5-48-48V384c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32V80c0-26.5 21.5-48 48-48h50c40.6 0 80.4 11 115.2 31.9L405.3 160H456c60.5 0 128.5 31.4 170.4 76.8c10 10.9 10 27.6 0 38.5C584.5 320.6 516.5 352 456 352H405.3zm-31.1 0h-185c-5.5 0-11.2 3.1-16.1 8.5c-9.7 10.6-22.6 18.4-37.2 21.7v81.7c35.6-1 70.4-11.2 101-29.6L374.2 352zM48 384v48c0 17.7 14.3 32 32 32h40V384H48zM374.2 160L237 77.6c-30.6-18.4-65.4-28.5-101-29.6v81.7c14.6 3.3 27.5 11 37.2 21.7c4.9 5.4 10.6 8.5 16.1 8.5h185zM80 48C62.3 48 48 62.3 48 80v48h72V48H80zM16 160v88H184c4.4 0 8 3.6 8 8s-3.6 8-8 8H16v88c0 8.8 7.2 16 16 16h88c16.4 0 31.1-7 41.4-18.2c6.6-7.3 16.3-13.8 27.9-13.8H456c55.7 0 119.6-29.3 158.6-71.6c4.4-4.8 4.4-12 0-16.8C575.6 205.3 511.7 176 456 176H189.3c-11.6 0-21.3-6.5-27.9-13.8C151.1 151 136.4 144 120 144H32c-8.8 0-16 7.2-16 16zm472 56c4.4 0 8 3.6 8 8v64c0 4.4-3.6 8-8 8s-8-3.6-8-8V224c0-4.4 3.6-8 8-8z'
      
    ]
  };

  
    var faSpaceShuttle = faShuttleSpace;
  

  
  

  var faHouseDay = {
    prefix: 'fat',
    iconName: 'house-day',
    icon: [
      640,
      512,
      [],
      'e00e',
      
      'M161.2 8.4L130.1 66.2 67.3 47.4c-12.2-3.7-23.6 7.7-19.9 19.9l18.8 62.9L8.4 161.3c-11.2 6-11.2 22.1 0 28.2l57.8 31.1L47.3 283.5c-3.7 12.2 7.7 23.6 19.9 19.9l69.1-20.7c4.2-1.3 6.6-5.7 5.4-10s-5.7-6.6-10-5.4L62.7 288.1 83.4 219c1.1-3.6-.5-7.5-3.9-9.3L16 175.4l63.5-34.2c3.3-1.8 5-5.7 3.9-9.3L62.7 62.7l69.1 20.7c3.6 1.1 7.5-.5 9.3-3.9L175.3 16l34.2 63.5c1.8 3.3 5.7 5 9.3 3.9L288 62.7l-20.7 69.1c-1.3 4.2 1.1 8.7 5.4 10s8.7-1.1 10-5.4l20.7-69.1c3.7-12.2-7.7-23.6-19.9-19.9L220.5 66.2 189.4 8.4c-6-11.2-22.1-11.2-28.2 0zm12.8 213.4a47.7 47.7 0 1 1 0-95.3 47.7 47.7 0 1 1 0 95.3zm-63.6-47.7a63.6 63.6 0 1 0 127.3 0 63.6 63.6 0 1 0 -127.3 0zM405.2 97.9c-3-2.6-7.4-2.6-10.4 0l-232 200c-3.3 2.9-3.7 7.9-.8 11.3s7.9 3.7 11.3 .8L224 266.3V456c0 30.9 25.1 56 56 56H520c30.9 0 56-25.1 56-56V266.3l50.8 43.8c3.3 2.9 8.4 2.5 11.3-.8s2.5-8.4-.8-11.3l-232-200zM560 252.5V456c0 22.1-17.9 40-40 40H280c-22.1 0-40-17.9-40-40V252.5L400 114.6 560 252.5zM336 296v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V296c0-13.3-10.7-24-24-24H360c-13.3 0-24 10.7-24 24zm24-8h80c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8V296c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faBedPulse = {
    prefix: 'fat',
    iconName: 'bed-pulse',
    icon: [
      640,
      512,
      ["procedures"],
      'f487',
      
      'M471.2 4.4L500.9 64H632c4.4 0 8 3.6 8 8s-3.6 8-8 8H496c-3 0-5.8-1.7-7.2-4.4l-24-48.1L407.4 171c-1.2 2.9-3.9 4.9-7.1 5s-6.1-1.6-7.5-4.4L347.1 80H200c-4.4 0-8-3.6-8-8s3.6-8 8-8H352c3 0 5.8 1.7 7.2 4.4l40 80.1L456.6 5c1.2-2.9 3.9-4.9 7.1-5s6.1 1.6 7.5 4.4zM312 160h39.3l8 16H312c-13.3 0-24 10.7-24 24V352H624V264c0-48.6-39.4-88-88-88H439.9l6.4-16H536c57.4 0 104 46.6 104 104v96 80 64c0 4.4-3.6 8-8 8s-8-3.6-8-8V448H16v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V440 360 72c0-4.4 3.6-8 8-8s8 3.6 8 8V352H272V200c0-22.1 17.9-40 40-40zM624 432V368H280 16v64H624zM208 240A64 64 0 1 0 80 240a64 64 0 1 0 128 0zM64 240a80 80 0 1 1 160 0A80 80 0 1 1 64 240z'
      
    ]
  };

  
    var faProcedures = faBedPulse;
  

  
  

  var faFire = {
    prefix: 'fat',
    iconName: 'fire',
    icon: [
      448,
      512,
      [128293],
      'f06d',
      
      'M252.2 99.4c3.1 3.8 7.7 6.1 12.7 6s9.5-2.4 12.5-6.3c11-14.3 22.8-29.2 35.3-41c1.7-1.6 4.3-1.6 5.9 0c32.9 31.4 61.2 73.4 81.3 113.6c20 40.1 32.1 79.1 32.1 104.7C432 396.3 338.5 496 224 496C108.2 496 16 396.3 16 276.5c0-34.1 16.1-78 43.1-123.6c27.1-45.7 65.6-93.6 111-135.8c1.7-1.5 4.2-1.5 5.9 0c27.1 25.3 52.4 52.7 76.1 82.3zm12.5-10c-3.4-4.3-6.9-8.5-10.4-12.7c-21.2-25.3-43.6-49-67.3-71.2c-7.8-7.3-19.9-7.3-27.7-.1c-46.5 43.2-86 92.3-113.9 139.3C17.8 191.2 0 238.1 0 276.5C0 404.1 98.4 512 224 512c124.2 0 224-107.8 224-235.5c0-29.3-13.5-71.1-33.8-111.9c-20.7-41.4-49.9-85-84.5-118c-7.8-7.5-20.1-7.5-28-.1c-9.5 9-18.6 19.5-26.9 30c-3.5 4.4-6.9 8.7-10.1 13zm38.8 318.9l0 0 .3-.2c54.6-38.1 60-113.2 28.3-164.5c-8.9-14.5-28.2-13.9-37.8-2.7l-31.4 36.5 0 0c-18.8-23.9-54.4-69.2-68.9-87.6c-9.6-12.2-27.9-11.9-37.4-.1C119.3 235.8 96 268.3 96 306.8s14.3 70.2 38.4 92.1c23.9 21.8 56.4 33.1 91.3 33.1c28.5 0 54.1-8 77.7-23.7zm15-156.3c28.2 45.7 22.3 110.8-23.9 143c-21.1 14-43.5 21-68.8 21C162.6 416 112 375.4 112 306.8c0-31.9 19-60 56.9-107.1c3.2-4 9.2-4 12.4 0c14.5 18.4 50.2 63.8 69 87.6c6.2 7.9 18.1 8.1 24.7 .5l31.4-36.5c3.3-3.9 9.4-3.7 12.1 .7z'
      
    ]
  };

  

  
  

  var faStars = {
    prefix: 'fat',
    iconName: 'stars',
    icon: [
      512,
      512,
      [],
      'f762',
      
      'M344 0c4.4 0 8 3.6 8 8V72h64c4.4 0 8 3.6 8 8s-3.6 8-8 8H352v64c0 4.4-3.6 8-8 8s-8-3.6-8-8V88H272c-4.4 0-8-3.6-8-8s3.6-8 8-8h64V8c0-4.4 3.6-8 8-8zM138.4 258.5c-2.3 4.7-6.8 8-12 8.8L22.9 282.3c-6.6 1-9.2 9-4.4 13.6l74.9 73.2c3.8 3.7 5.5 9 4.6 14.1L80.3 486.6c-1.1 6.5 5.7 11.5 11.6 8.4l92.6-48.8c4.7-2.5 10.2-2.5 14.9 0L291.9 495c5.9 3.1 12.7-1.9 11.6-8.4L285.9 383.3c-.9-5.2 .8-10.5 4.6-14.1l74.9-73.2c4.7-4.6 2.1-12.7-4.4-13.6L257.4 267.2c-5.2-.8-9.7-4-12-8.8l-46.3-94c-2.9-6-11.4-6-14.4 0l-46.3 94zM7.2 307.4C-7 293.5 .9 269.3 20.5 266.5l103.5-15.1 46.3-94c8.8-17.9 34.3-17.9 43.1 0l46.3 94 103.5 15.1c19.7 2.9 27.5 27 13.3 40.9l-74.9 73.2 17.7 103.3c3.4 19.6-17.2 34.6-34.8 25.3l-92.6-48.8L99.3 509.2c-17.6 9.3-38.2-5.7-34.8-25.3L82.2 380.6 7.2 307.4zM464 160v48h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H464v48c0 4.4-3.6 8-8 8s-8-3.6-8-8V224H400c-4.4 0-8-3.6-8-8s3.6-8 8-8h48V160c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faCircleZ = {
    prefix: 'fat',
    iconName: 'circle-z',
    icon: [
      512,
      512,
      [],
      'e130',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 128c-4.4 0-8 3.6-8 8s3.6 8 8 8H335.4L153.8 371c-1.9 2.4-2.3 5.7-1 8.5s4.1 4.5 7.2 4.5H352c4.4 0 8-3.6 8-8s-3.6-8-8-8H176.6L358.2 141c1.9-2.4 2.3-5.7 1-8.5s-4.1-4.5-7.2-4.5H160z'
      
    ]
  };

  

  
  

  var faDownToBracket = {
    prefix: 'fat',
    iconName: 'down-to-bracket',
    icon: [
      448,
      512,
      [],
      'e4e7',
      
      'M216 332.7c2.1 2.1 5 3.3 8 3.3s5.9-1.2 8-3.3L363.8 200.6c2.7-2.7 4.2-6.4 4.2-10.2c0-8-6.5-14.4-14.4-14.4L280 176c-4.4 0-8-3.6-8-8l0-136c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16l0 136c0 4.4-3.6 8-8 8l-73.6 0c-8 0-14.4 6.5-14.4 14.4c0 3.8 1.5 7.5 4.2 10.2L216 332.7zm8 19.3c-7.2 0-14.2-2.9-19.3-8L72.9 211.9c-5.7-5.7-8.9-13.4-8.9-21.5C64 173.6 77.6 160 94.4 160l65.6 0 0-128c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 128 65.6 0c16.8 0 30.4 13.6 30.4 30.4c0 8.1-3.2 15.8-8.9 21.5L243.3 344c-5.1 5.1-12.1 8-19.3 8zM16 328l0 96c0 39.8 32.2 72 72 72l272 0c39.8 0 72-32.2 72-72l0-96c0-4.4 3.6-8 8-8s8 3.6 8 8l0 96c0 48.6-39.4 88-88 88L88 512c-48.6 0-88-39.4-88-88l0-96c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faSignalStream = {
    prefix: 'fat',
    iconName: 'signal-stream',
    icon: [
      576,
      512,
      [],
      'f8dd',
      
      'M82.3 65.9c3.3 2.9 3.7 8 .8 11.3C41.3 125 16 187.5 16 256s25.3 131 67 178.8c2.9 3.3 2.6 8.4-.8 11.3s-8.4 2.6-11.3-.8C26.8 394.7 0 328.5 0 256S26.8 117.3 71 66.7c2.9-3.3 8-3.7 11.3-.8zm411.5 0c3.3-2.9 8.4-2.6 11.3 .8c44.2 50.6 71 116.9 71 189.3s-26.8 138.7-71 189.3c-2.9 3.3-8 3.7-11.3 .8s-3.7-8-.8-11.3C534.7 387 560 324.5 560 256s-25.3-131-67-178.8c-2.9-3.3-2.6-8.4 .8-11.3zM240 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM154.6 141.1C128.1 172 112 212.1 112 256s16.1 84 42.6 114.9c2.9 3.3 2.5 8.4-.8 11.3s-8.4 2.5-11.3-.8C113.5 347.7 96 303.9 96 256s17.5-91.7 46.5-125.3c2.9-3.3 7.9-3.7 11.3-.8s3.7 7.9 .8 11.3zm278.9-10.4c29 33.6 46.5 77.4 46.5 125.3s-17.5 91.7-46.5 125.3c-2.9 3.3-7.9 3.7-11.3 .8s-3.7-7.9-.8-11.3C447.9 340 464 299.9 464 256s-16.1-84-42.6-114.9c-2.9-3.3-2.5-8.4 .8-11.3s8.4-2.5 11.3 .8z'
      
    ]
  };

  

  
  

  var faL = {
    prefix: 'fat',
    iconName: 'l',
    icon: [
      320,
      512,
      [108],
      '4c',
      
      'M40 32c4.4 0 8 3.6 8 8V464H312c4.4 0 8 3.6 8 8s-3.6 8-8 8H48c-8.8 0-16-7.2-16-16V40c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faPersonWalking = {
    prefix: 'fat',
    iconName: 'person-walking',
    icon: [
      320,
      512,
      [128694,"walking"],
      'f554',
      
      'M142 203.4l-16.9 63.5c-4.2 15.8-.1 32.7 11 44.8l70.7 77.1c1.8 2 3.1 4.3 3.7 6.9l22 88.1c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4l-23-92.1c-1.3-5.2-3.9-9.9-7.5-13.9l-49.5-54c-3.8-4.1-5.1-9.9-3.6-15.3l19.3-65.5c1.9-6.5 7.7-11.1 14.5-11.5s13 3.6 15.6 9.8l10.2 24.5c2.2 5.3 5.8 9.9 10.3 13.3l28.5 21.4c7.1 5.3 17.1 3.9 22.4-3.2s3.9-17.1-3.2-22.4l-25-18.8c-2.3-1.7-4.1-4-5.2-6.6l-16.5-39.7c-14.7-35.2-49-58.1-87.1-58.1c-20.5 0-40.8 4.3-59.6 12.6l-5.7 2.5c-30.3 13.5-53.1 39.7-62.2 71.6l-3.7 12.9c-2.4 8.5 2.5 17.4 11 19.8s17.4-2.5 19.8-11l3.7-12.9c6.5-22.8 22.8-41.5 44.4-51.1l5.7-2.5 0 0c1.1-.5 2.2-1 3.4-1.4c5.6-2.3 12.1-1.2 16.6 2.8s6.4 10.3 4.9 16.1zM244 52a36 36 0 1 0 -72 0 36 36 0 1 0 72 0zM118 203c-3.7 1.7-7.3 3.7-10.6 6c-12 8.3-20.9 20.6-24.9 34.9l-3.7 12.9c-4.9 17-22.6 26.8-39.6 22s-26.8-22.6-22-39.6l3.7-12.9c10.4-36.4 36.4-66.4 71.1-81.8l5.7-2.5c20.8-9.2 43.3-14 66.1-14c44.6 0 84.8 26.8 101.9 67.9l16.5 39.7 25 18.8c14.1 10.6 17 30.7 6.4 44.8s-30.7 17-44.8 6.4l-28.5-21.4c-6.9-5.1-12.2-12-15.5-19.9l-.4-1-9.8-23.5-7.2 24.4-12.1 41.2 49.5 54c5.4 5.9 9.2 13 11.2 20.8l23 92.1c4.3 17.1-6.1 34.5-23.3 38.8s-34.5-6.1-38.8-23.3l-22-88.1-70.7-77.1c-14.8-16.1-20.3-38.6-14.7-59.7l11.6-43.6 1.5-5.6 2.5-9.6 1.3-4.8c-1 .4-1.9 .8-2.9 1.2L118 203zM208 0a52 52 0 1 1 0 104A52 52 0 1 1 208 0zM103.4 354.3L83 405.5l-.6 1.5-1.2 1.2L20.7 468.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L105 429.6c3.1-3.1 5.5-6.7 7.1-10.7L127.2 381c1.6-4.1 6.3-6.1 10.4-4.5s6.1 6.3 4.5 10.4l-15.1 37.9c-2.4 6-6 11.5-10.6 16.1L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L68.7 398l19.8-49.6c1.6-4.1 6.3-6.1 10.4-4.5s6.1 6.3 4.5 10.4z'
      
    ]
  };

  
    var faWalking = faPersonWalking;
  

  
  

  var faRectangleVertical = {
    prefix: 'fat',
    iconName: 'rectangle-vertical',
    icon: [
      384,
      512,
      ["rectangle-portrait"],
      'f2fb',
      
      'M368 448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48L16 64c0-26.5 21.5-48 48-48l256 0c26.5 0 48 21.5 48 48l0 384zM384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64l0-384z'
      
    ]
  };

  
    var faRectanglePortrait = faRectangleVertical;
  

  
  

  var faToggleOn = {
    prefix: 'fat',
    iconName: 'toggle-on',
    icon: [
      576,
      512,
      [],
      'f205',
      
      'M160 112C80.5 112 16 176.5 16 256s64.5 144 144 144H416c79.5 0 144-64.5 144-144s-64.5-144-144-144H160zM0 256C0 167.6 71.6 96 160 96H416c88.4 0 160 71.6 160 160s-71.6 160-160 160H160C71.6 416 0 344.4 0 256zm496 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-176 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z'
      
    ]
  };

  

  
  

  var faCircleArrowUp = {
    prefix: 'fat',
    iconName: 'circle-arrow-up',
    icon: [
      512,
      512,
      ["arrow-circle-up"],
      'f0aa',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM365.7 234.3l-104-104c-3.1-3.1-8.2-3.1-11.3 0l-104 104c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L248 155.3V376c0 4.4 3.6 8 8 8s8-3.6 8-8V155.3l90.3 90.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3z'
      
    ]
  };

  
    var faArrowCircleUp = faCircleArrowUp;
  

  
  

  var faBedEmpty = {
    prefix: 'fat',
    iconName: 'bed-empty',
    icon: [
      640,
      512,
      [128719],
      'f8f9',
      
      'M16 40c0-4.4-3.6-8-8-8s-8 3.6-8 8V200 328v80 64c0 4.4 3.6 8 8 8s8-3.6 8-8V416H624v56c0 4.4 3.6 8 8 8s8-3.6 8-8V408 328 296c0-57.4-46.6-104-104-104H16V40zM624 320H16V208H536c48.6 0 88 39.4 88 88v24zM16 336H624v64H16V336z'
      
    ]
  };

  

  
  

  var faPianoKeyboard = {
    prefix: 'fat',
    iconName: 'piano-keyboard',
    icon: [
      576,
      512,
      [127929],
      'f8d5',
      
      'M448 224v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V224h48zM416 335.2V432H296V335.2c18.3-3.7 32-19.8 32-39.2V224h56v72c0 19.4 13.7 35.5 32 39.2zM432 432V335.2c18.3-3.7 32-19.8 32-39.2V224h96V384c0 26.5-21.5 48-48 48H432zm-152 0H160V335.2c18.3-3.7 32-19.8 32-39.2V224h56v72c0 19.4 13.7 35.5 32 39.2V432zm-136 0H64c-26.5 0-48-21.5-48-48V224h96v72c0 19.4 13.7 35.5 32 39.2V432zm8-112c-13.3 0-24-10.7-24-24V224h48v72c0 13.3-10.7 24-24 24zm136 0c-13.3 0-24-10.7-24-24V224h48v72c0 13.3-10.7 24-24 24zM456 208H392 320 256 184 120 16V128c0-26.5 21.5-48 48-48H512c26.5 0 48 21.5 48 48v80H456zm120 0V128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128v80 8 8V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V224v-8-8z'
      
    ]
  };

  

  
  

  var faUserPilotTie = {
    prefix: 'fat',
    iconName: 'user-pilot-tie',
    icon: [
      448,
      512,
      [],
      'e2c1',
      
      'M225.6 16.2c-1.2-.3-2.4-.3-3.5 0L62.2 52.1c-2.8 .6-5.1 2.8-5.9 5.6s-.1 5.8 2 7.9L87.5 95.1c1.5 1.5 2.3 3.5 2.3 5.6v26.9c18.1 11.7 55.9 32.2 134.1 32.2s116.1-20.5 134.1-32.2V100.7c0-2.1 .8-4.1 2.3-5.6l29.1-29.5c2-2.1 2.8-5.1 2-7.9s-3.1-4.9-5.9-5.6l-159.9-36zm-7-15.6c3.5-.8 7.1-.8 10.5 0L389 36.5c8.5 1.9 15.3 8.3 17.8 16.7s.2 17.4-6 23.6L374 104v23.6c0 5.3-2.6 10.3-7.2 13.3c-20.4 13.3-61.3 34.9-142.9 34.9s-122.5-21.6-142.9-34.9c-4.6-3-7.2-8-7.2-13.3V104L46.9 76.8c-6.1-6.2-8.4-15.2-6-23.6s9.3-14.8 17.8-16.7L218.6 .6zM214 466.7L224 480l10-13.3 6.2-8.2L224 431.6l-16.2 26.9 6.2 8.2zM128.1 352.1l69.4 92.5 17-28.3-37-51.7c-1.7-2.4-2-5.6-.6-8.3s4.1-4.3 7.1-4.3h80c3 0 5.7 1.7 7.1 4.3s1.1 5.9-.6 8.3l-37 51.7 17 28.3 69.4-92.5C391.2 355.4 448 414.3 448 486.4c0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4c0-72.1 56.8-131 128.1-134.3zm199.3 16.7L236.8 489.6 232 496H422.4c5.3 0 9.6-4.3 9.6-9.6c0-60.7-45.7-110.8-104.6-117.6zM216 496l-4.8-6.4L120.6 368.8C61.7 375.6 16 425.7 16 486.4c0 5.3 4.3 9.6 9.6 9.6H216zM96.3 183.3c4.8 2.3 10.1 4.5 15.7 6.7c0 .7 0 1.3 0 2c0 61.9 50.1 112 112 112s112-50.1 112-112c0-.7 0-1.3 0-2c5.7-2.2 10.9-4.4 15.7-6.7c.2 2.9 .3 5.8 .3 8.7c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-2.9 .1-5.8 .3-8.7zM224 402.2L248.5 368H199.5L224 402.2zM320 440c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H328c-4.4 0-8-3.6-8-8zM163.6 64.8L224 95.1l60.4-30.2c4-2 8.8-.4 10.7 3.6s.4 8.8-3.6 10.7l-64 32c-2.3 1.1-4.9 1.1-7.2 0l-64-32c-4-2-5.6-6.8-3.6-10.7s6.8-5.6 10.7-3.6z'
      
    ]
  };

  

  
  

  var faWheelchair = {
    prefix: 'fat',
    iconName: 'wheelchair',
    icon: [
      512,
      512,
      [],
      'f193',
      
      'M192 80a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM143.9 200.6c.7 4.4-2.3 8.5-6.6 9.2C68.5 220.7 16 280.2 16 352c0 79.5 64.5 144 144 144c66.4 0 122.4-45 139-106.2c1.2-4.3 5.6-6.8 9.8-5.6s6.8 5.6 5.6 9.8C296 462 233.8 512 160 512C71.6 512 0 440.4 0 352c0-79.8 58.4-145.9 134.8-158c4.4-.7 8.5 2.3 9.2 6.6zm122.6 90.5l-9.6-48c-.9-4.7 .3-9.6 3.3-13.3s7.6-5.9 12.4-5.9H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H259.8c-7.6 0-14.2-5.4-15.7-12.9l-1.9-9.7c-3-14.8-16-25.5-31.1-25.5c-20 0-35 18.3-31.1 37.9l23.1 115.5c4.5 22.4 24.2 38.6 47.1 38.6h5.1 .3l0 0c.1 0 .2 0 .3 0c.1 0 .2 0 .4 0l.3 0v0h94.1c13.3 0 25.3 8.3 30 20.8L417 453.6c3 8.1 11.9 12.3 20 9.6l48-16c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-18.7 6.2c-8.2 2.7-17-1.5-20-9.6l-25.5-68c-9.4-25-33.2-41.5-59.9-41.5H282.2c-7.6 0-14.2-5.4-15.7-12.9zm159.1 48.8l25.5 68 18.7-6.2c16.8-5.6 34.9 3.5 40.5 20.2s-3.5 34.9-20.2 40.5l-48 16c-16.3 5.4-34-3-40.1-19.1l-36.3-96.9c-2.3-6.2-8.3-10.4-15-10.4H256.6c-.4 0-.8 0-1.3 0h-5.1c-30.5 0-56.8-21.5-62.8-51.4L164.4 185c-5.9-29.5 16.7-57 46.8-57c22.7 0 42.3 16 46.8 38.3l1.9 9.7H336c17.7 0 32 14.3 32 32s-14.3 32-32 32H288.9 272.6l3.2 16 6.4 32h68.5c33.3 0 63.2 20.7 74.9 51.9z'
      
    ]
  };

  

  
  

  var faTriangleInstrument = {
    prefix: 'fat',
    iconName: 'triangle-instrument',
    icon: [
      576,
      512,
      ["triangle-music"],
      'f8e2',
      
      'M296 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64.4c-27.8 2.5-53.1 17.8-68.1 41.6L46.5 367.7C37 382.8 32 400.2 32 418c0 51.9 42.1 94 94 94H450c51.9 0 94-42.1 94-94c0-17.8-5-35.2-14.5-50.2L439.4 225.2l-11.6 11.6 88.1 139.5c7.9 12.5 12.1 26.9 12.1 41.7c0 43.1-34.9 78-78 78H126c-43.1 0-78-34.9-78-78c0-14.8 4.2-29.2 12.1-41.7L225.4 114.5C239 93 262.6 80 288 80s49 13 62.6 34.5l50.9 80.6-74.3 74.3C316.4 261 302.8 256 288 256c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64c0-14.8-5-28.4-13.4-39.2L410.3 209l11.6-11.6L541.7 77.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L413.1 183.5l-49-77.6C349.1 82.1 323.8 66.8 296 64.4V8zm40 312a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z'
      
    ]
  };

  
    var faTriangleMusic = faTriangleInstrument;
  

  
  

  var faCommentPlus = {
    prefix: 'fat',
    iconName: 'comment-plus',
    icon: [
      512,
      512,
      [],
      'f4b2',
      
      'M157.3 415c-5-1.8-10.6-1-14.9 2.1c-11 8-29.4 19.3-51.2 28.8C68.3 456 41.6 464 16 464l.1-.1 0 0 0 0 .3-.3 .1-.1c.4-.4 .9-.9 1.5-1.6c1.3-1.4 3.2-3.6 5.4-6.3l-12.2-10 12.2 10C28 450 34 442 40 432c10.7-17.9 21.4-42.1 23.6-69.9c.3-4.3-1.1-8.6-3.9-11.8C31.9 318.8 16 280.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-35.2 0-68.6-6.1-98.7-17zM4.7 452.7l0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0zM248 336c0 4.4 3.6 8 8 8s8-3.6 8-8V248h88c4.4 0 8-3.6 8-8s-3.6-8-8-8H264V144c0-4.4-3.6-8-8-8s-8 3.6-8 8v88H160c-4.4 0-8 3.6-8 8s3.6 8 8 8h88v88z'
      
    ]
  };

  

  
  

  var faSquareChevronDown = {
    prefix: 'fat',
    iconName: 'square-chevron-down',
    icon: [
      448,
      512,
      ["chevron-square-down"],
      'f329',
      
      'M64 464c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H384c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64zM0 416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416zm229.7-74.3l120-120c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L224 324.7 109.7 210.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l120 120c3.1 3.1 8.2 3.1 11.3 0z'
      
    ]
  };

  
    var faChevronSquareDown = faSquareChevronDown;
  

  
  

  var faObjectsColumn = {
    prefix: 'fat',
    iconName: 'objects-column',
    icon: [
      448,
      512,
      [],
      'e3c1',
      
      'M48 48C30.3 48 16 62.3 16 80V240c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32H48zM0 80C0 53.5 21.5 32 48 32h96c26.5 0 48 21.5 48 48V240c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80zM304 240c-17.7 0-32 14.3-32 32V432c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32H304zm-48 32c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V272zM144 336H48c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V368c0-17.7-14.3-32-32-32zM48 320h96c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48zM304 48c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32H304zM256 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V80z'
      
    ]
  };

  

  
  

  var faViolin = {
    prefix: 'fat',
    iconName: 'violin',
    icon: [
      640,
      512,
      [127931],
      'f8ed',
      
      'M349.7 2.3c3.1 3.1 3.1 8.2 0 11.3l-336 336c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l336-336c3.1-3.1 8.2-3.1 11.3 0zm288 0c3.1 3.1 3.1 8.2 0 11.3L448 203.3c19.9 22.6 32 52.2 32 84.7c0 20.8-5 40.4-13.8 57.8c-3.4 6.7-11.4 9.1-18.8 7.7c-5-1-10.2-1.5-15.4-1.5c-44.2 0-80 35.8-80 80c0 11.6 2.5 22.7 7 32.7c3.3 7.4 2.4 16.6-4.3 21.3C331.3 502.4 302.8 512 272 512c-17.6 0-34.5-3.2-50.1-8.9c-4.5 5.6-11.3 8.9-18.7 8.9c-6.3 0-12.4-2.5-16.9-7L135 453.6c-4.5-4.5-7-10.6-7-16.9c0-7.3 3.3-14.2 8.9-18.7c-5.8-15.6-8.9-32.5-8.9-50.1c0-30.8 9.6-59.3 26.1-82.6c4.7-6.7 13.8-7.6 21.3-4.3c10 4.5 21 7 32.7 7c44.2 0 80-35.8 80-80c0-5.3-.5-10.4-1.5-15.4c-1.4-7.4 1-15.4 7.7-18.8c17.4-8.8 37-13.8 57.8-13.8c32.5 0 62.1 12.1 84.7 32L626.3 2.3c3.1-3.1 8.2-3.1 11.3 0zM272 496c27.1 0 52.1-8.4 72.8-22.7c0-.2 0-.4 0-.6c-.1-.5-.2-1-.4-1.5c-5.4-12-8.3-25.3-8.3-39.2c0-53 43-96 96-96c6.3 0 12.5 .6 18.5 1.8c.5 .1 1 .1 1.4 .1c.2 0 .3 0 .4-.1c7.5-15 11.7-31.9 11.7-49.8c0-28-10.3-53.7-27.3-73.3l-71 71c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l71-71C405.7 186.3 380 176 352 176c-17.9 0-34.8 4.2-49.8 11.7c0 .1 0 .3-.1 .4c0 .4 0 .9 .1 1.4c1.2 6 1.8 12.2 1.8 18.5c0 53-43 96-96 96c-13.9 0-27.2-3-39.2-8.3c-.5-.2-1-.4-1.5-.4c-.2 0-.5 0-.6 0C152.4 315.9 144 340.9 144 368c0 14.7 2.5 28.8 7 41.9l68.1-37.1c9.3-5.1 20.9-3.4 28.5 4.1l15.5 15.5c7.5 7.5 9.2 19.1 4.1 28.5L230.1 489c13.1 4.6 27.3 7 41.9 7zM236.2 388.2c-2.5-2.5-6.4-3.1-9.5-1.4l-78.6 42.9c-2.6 1.4-4.1 4.1-4.1 7c0 2.1 .8 4.1 2.3 5.6l51.4 51.4c1.5 1.5 3.5 2.3 5.6 2.3c2.9 0 5.6-1.6 7-4.1l42.9-78.6c1.7-3.1 1.1-7-1.4-9.5l-15.5-15.5zM528 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM448 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm96 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64-64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faBurrito = {
    prefix: 'fat',
    iconName: 'burrito',
    icon: [
      512,
      512,
      [127791],
      'f7ed',
      
      'M262.1 43c-2.5 1.8-4.9 3.8-7.1 6L33.9 270.1C12.2 291.8 0 321.3 0 352s12.2 60.2 33.9 81.9l44.1 44.1C99.8 499.8 129.3 512 160 512s60.2-12.2 81.9-33.9L463 257c.7-.7 1.4-1.4 2-2.1l0 0c1.4-1.6 2.8-3.2 4-4.9c25.3-11.2 43-36.5 43-65.9c0-11.5-2.7-22.4-7.5-32c4.8-9.6 7.5-20.5 7.5-32c0-32.5-21.5-60-51.1-68.9C452 21.5 424.5 0 392 0c-11.5 0-22.4 2.7-32 7.5C350.4 2.7 339.5 0 328 0c-29.4 0-54.7 17.7-65.9 43zm15.4 4.8C286.6 28.9 305.8 16 328 16c10.2 0 19.8 2.7 28 7.5c2.5 1.4 5.5 1.4 8 0c8.2-4.8 17.8-7.5 28-7.5c26.6 0 48.9 18.5 54.6 43.4c.7 3 3 5.3 6 6c24.9 5.7 43.4 28 43.4 54.6c0 10.2-2.7 19.8-7.5 28c-1.4 2.5-1.4 5.5 0 8c4.8 8.2 7.5 17.8 7.5 28c0 22.2-12.9 41.4-31.7 50.5C432.3 212.7 393.6 200 352 200c-15.5 0-30.6 1.8-45.1 5.1c3.3-14.5 5.1-29.6 5.1-45.1c0-41.6-12.7-80.3-34.5-112.3zM16 352c0-5.3 .4-10.6 1.3-15.8C45.5 351.4 77.7 360 112 360c88.5 0 163.5-57.5 189.9-137.1c15.9-4.5 32.7-6.9 50.1-6.9c36.8 0 71.1 10.8 99.9 29.5l-.2 .2L230.6 466.7C211.9 485.5 186.5 496 160 496s-51.9-10.5-70.6-29.3L45.3 422.6C26.5 403.9 16 378.5 16 352zM266.3 60.3l.2-.2C285.2 88.9 296 123.2 296 160c0 18.8-2.8 37-8.1 54.1C264.8 289.3 194.8 344 112 344c-33 0-64-8.7-90.8-23.9c4.9-14.5 13-27.7 24-38.7L266.3 60.3z'
      
    ]
  };

  

  
  

  var faCommentMinus = {
    prefix: 'fat',
    iconName: 'comment-minus',
    icon: [
      512,
      512,
      [],
      'f4b1',
      
      'M157.3 415c-5-1.8-10.6-1-14.9 2.1c-11 8-29.4 19.3-51.2 28.8C68.3 456 41.6 464 16 464l.1-.1 0 0 0 0 .3-.3 .1-.1c.4-.4 .9-.9 1.5-1.6c1.3-1.4 3.2-3.6 5.4-6.3l-12.2-10 12.2 10C28 450 34 442 40 432c10.7-17.9 21.4-42.1 23.6-69.9c.3-4.3-1.1-8.6-3.9-11.8C31.9 318.8 16 280.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-35.2 0-68.6-6.1-98.7-17zM4.7 452.7l0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0zM160 232c-4.4 0-8 3.6-8 8s3.6 8 8 8H352c4.4 0 8-3.6 8-8s-3.6-8-8-8H160z'
      
    ]
  };

  

  
  

  var faBinaryCircleCheck = {
    prefix: 'fat',
    iconName: 'binary-circle-check',
    icon: [
      640,
      512,
      [],
      'e33c',
      
      'M312 8c0-2.6-1.3-5.1-3.4-6.6s-4.9-1.8-7.4-.9l-64 24c-4.1 1.6-6.2 6.2-4.7 10.3s6.2 6.2 10.3 4.7L296 19.5V208H232c-4.4 0-8 3.6-8 8s3.6 8 8 8h72 72c4.4 0 8-3.6 8-8s-3.6-8-8-8H312V8zM88 296c0-2.6-1.3-5.1-3.4-6.6s-4.9-1.8-7.4-.9l-64 24c-4.1 1.6-6.2 6.2-4.7 10.3s6.2 6.2 10.3 4.7L72 307.5V496H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H80h72c4.4 0 8-3.6 8-8s-3.6-8-8-8H88V296zM16 64v96c0 35.3 28.7 64 64 64h32c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H80C44.7 0 16 28.7 16 64zM80 16h32c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48zM272 288c-35.3 0-64 28.7-64 64v96c0 35.3 28.7 64 64 64h32c23.9 0 44.8-13.1 55.8-32.6c-3.8-4.7-7.4-9.6-10.8-14.6C342.2 483 324.6 496 304 496H272c-26.5 0-48-21.5-48-48V352c0-26.5 21.5-48 48-48h32c9.3 0 18 2.6 25.4 7.2c1.8-5.1 3.7-10.2 5.9-15.1C326 291 315.4 288 304 288H272zm224-48a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm69.7-189.7c-3.1-3.1-8.2-3.1-11.3 0L480 396.7l-42.3-42.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l48 48c3.1 3.1 8.2 3.1 11.3 0l80-80c3.1-3.1 3.1-8.2 0-11.3z'
      
    ]
  };

  

  
  

  var faPanelFire = {
    prefix: 'fat',
    iconName: 'panel-fire',
    icon: [
      640,
      512,
      [],
      'e42f',
      
      'M384 48H64C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H324.8c4 5.6 8.3 10.9 12.8 16H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64v32.2c-5.4-.5-10.8-.1-16 1.3V96c0-26.5-21.5-48-48-48zM349.1 208H96c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32v39.4c-12.6 13.2-24.3 26.8-34.9 40.6zm2.9-96H96c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16zM112 256a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm205.5-80.1c-1.5 0-3 .5-4.1 1.5c-23.7 21.3-50.3 48.5-70.8 78.7C350.1 286.4 336 319 336 351.3c0 50 25.1 94.3 63.7 120.3c-9.9-14.1-15.7-31-15.7-49.2c0-57.4 63.8-110.5 87.4-128.2c5.2-3.9 12.1-3.9 17.3 0C512.2 311.9 576 365 576 422.4c0 17.9-5.7 34.7-15.4 48.7C598.9 445 624 400.9 624 351.3c0-25.8-9.7-53.6-24.5-79.7c-14.8-26.1-34.3-49.8-53.2-67.2c-2.3-2.1-5.9-2.1-8.2 0c-6.3 5.8-12.4 12.6-18.2 19.6c-6.4 7.8-18.2 7.9-24.8 .3c-14.3-16.7-29.5-32.3-45.6-46.8c-1.1-1-2.5-1.5-4-1.5zm34.5 320c2.8 0 5.6-.1 8.3-.2c41.1-3.9 71.7-36 71.7-73.2c0-23-13-47-31.1-68.7c-17.3-20.7-37.4-37.2-48.9-45.9c-11.5 8.7-31.6 25.2-48.9 45.9C413 375.4 400 399.4 400 422.4c0 37.2 30.6 69.4 71.8 73.2c2.7 .1 5.4 .2 8.2 .2zM320 351.3c0-36.8 16-72.6 37.4-104.2c21.5-31.7 49-59.8 73.3-81.6c4.2-3.8 9.6-5.6 14.9-5.6c5.2 0 10.5 1.9 14.6 5.7c16.6 15 32.3 31.1 47 48.3c0 0 0 0 .1 0l0 0c0 0 .1 0 .1 0s.1 0 .1 0c0 0 0 0 0 0s0 0 0 0c6-7.2 12.6-14.8 19.7-21.3c8.4-7.7 21.4-7.7 29.8 .1c20.1 18.5 40.7 43.5 56.3 71.1C629 291.1 640 321.8 640 351.3c0 85.1-66.3 155.4-150.6 160.3c-3.1 .3-6.2 .4-9.4 .4c-3.1 0-6.2-.1-9.2-.4C385.5 506.8 320 436.3 320 351.3z'
      
    ]
  };

  

  
  

  var faBoltSlash = {
    prefix: 'fat',
    iconName: 'bolt-slash',
    icon: [
      640,
      512,
      [],
      'e0b8',
      
      'M356.1 376.3L223.5 493.8c-1.6 1.4-3.7 2.2-5.9 2.2c-6.4 0-10.7-6.5-8.2-12.4l71.5-166.8-13-10.3L194.7 477.3c-7 16.4 5 34.7 22.9 34.7c6.1 0 11.9-2.2 16.5-6.3L368.9 386.3l-12.8-10.1zM224.1 272H151.3c-4.1 0-7.3-3.3-7.3-7.3c0-2.1 .9-4.1 2.5-5.5l28.8-25.7-12.8-10.1-26.7 23.8c-5 4.4-7.8 10.8-7.8 17.4c0 12.9 10.5 23.3 23.3 23.3h93l-20.3-16zm60.3-135.9L416.5 18.2c1.6-1.4 3.7-2.2 5.9-2.2c6.4 0 10.6 6.5 8.1 12.4L359.1 195.1l13 10.3L445.3 34.7c7-16.4-5-34.7-22.9-34.7c-6.1 0-12 2.2-16.6 6.3L271.6 126.1l12.8 10.1zM487.4 224H395.7l20.3 16h71.5c4.7 0 8.6 3.8 8.6 8.6c0 2.4-1 4.8-2.9 6.4l-27.5 24.3 12.8 10.1 25.3-22.4c5.3-4.7 8.3-11.4 8.3-18.4c0-13.6-11-24.6-24.6-24.6zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  

  
  

  var faCodeSimple = {
    prefix: 'fat',
    iconName: 'code-simple',
    icon: [
      576,
      512,
      [],
      'e13d',
      
      'M205.5 77.8c3.2-3.1 3.3-8.1 .2-11.3s-8.1-3.3-11.3-.2l-192 184C.9 251.7 0 253.8 0 256s.9 4.3 2.5 5.8l192 184c3.2 3.1 8.3 3 11.3-.2s2.9-8.3-.2-11.3L19.6 256l186-178.2zm164.9 0L556.4 256l-186 178.2c-3.2 3.1-3.3 8.1-.2 11.3s8.1 3.3 11.3 .2l192-184c1.6-1.5 2.5-3.6 2.5-5.8s-.9-4.3-2.5-5.8l-192-184c-3.2-3.1-8.3-2.9-11.3 .2s-3 8.3 .2 11.3z'
      
    ]
  };

  

  
  

  var faFaceLaughSquint = {
    prefix: 'fat',
    iconName: 'face-laugh-squint',
    icon: [
      512,
      512,
      ["laugh-squint"],
      'f59b',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM120.2 309.9c-.4-1.4-.1-2.5 .9-3.6c1.1-1.2 3-2.3 5.4-2.3H385.5c2.4 0 4.4 1.1 5.4 2.3c1 1.1 1.2 2.2 .9 3.6C375.5 371.2 320.7 416 256 416s-119.5-44.8-135.8-106.1zM104.7 314c18.1 68 79 118 151.3 118s133.2-50 151.3-118c3.6-13.7-7.6-26-21.8-26H126.5c-14.2 0-25.4 12.3-21.8 26zM372.4 144.8l-80 40c-2.7 1.4-4.4 4.1-4.4 7.2s1.7 5.8 4.4 7.2l80 40c4 2 8.8 .4 10.7-3.6s.4-8.8-3.6-10.7L313.9 192l65.7-32.8c4-2 5.6-6.8 3.6-10.7s-6.8-5.6-10.7-3.6zm-232.8 0c-4-2-8.8-.4-10.7 3.6s-.4 8.8 3.6 10.7L198.1 192l-65.7 32.8c-4 2-5.6 6.8-3.6 10.7s6.8 5.6 10.7 3.6l80-40c2.7-1.4 4.4-4.1 4.4-7.2s-1.7-5.8-4.4-7.2l-80-40z'
      
    ]
  };

  
    var faLaughSquint = faFaceLaughSquint;
  

  
  

  var faPalletBoxes = {
    prefix: 'fat',
    iconName: 'pallet-boxes',
    icon: [
      640,
      512,
      [57863,"palette-boxes","pallet-alt"],
      'f483',
      
      'M272 16H112C94.3 16 80 30.3 80 48V240c0 17.7 14.3 32 32 32H272c17.7 0 32-14.3 32-32V48c0-17.7-14.3-32-32-32zM112 0H272c26.5 0 48 21.5 48 48V240c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V48C64 21.5 85.5 0 112 0zM528 112H432c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM432 96h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H432c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48zM0 360c0-4.4 3.6-8 8-8H88 320 552h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H560V496h72c4.4 0 8 3.6 8 8s-3.6 8-8 8H552 320 88 8c-4.4 0-8-3.6-8-8s3.6-8 8-8H80V368H8c-4.4 0-8-3.6-8-8zM96 496H312V368H96V496zm232 0H544V368H328V496z'
      
    ]
  };

  
    var faPaletteBoxes = faPalletBoxes;
  
    var faPalletAlt = faPalletBoxes;
  

  
  

  var faBarsSort = {
    prefix: 'fat',
    iconName: 'bars-sort',
    icon: [
      448,
      512,
      [],
      'e0ae',
      
      'M0 88c0-4.4 3.6-8 8-8H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8zM0 248c0-4.4 3.6-8 8-8H312c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8zM192 408c0 4.4-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H184c4.4 0 8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faChessKnight = {
    prefix: 'fat',
    iconName: 'chess-knight',
    icon: [
      448,
      512,
      [9822],
      'f441',
      
      'M91.8 16C85.3 16 80 21.3 80 27.8c0 4.5 2.5 8.5 6.5 10.5l21.1 10.5c2.3 1.2 3.9 3.3 4.3 5.9s-.4 5.1-2.2 6.9L96.3 75C85.9 85.4 80 99.6 79.9 114.4l-.3 104.4c0 15.4 7.4 29.9 19.9 38.9l1.9 1.4c15.6 11.1 36.5 11 51.9-.2l89.9-65.4c3.6-2.6 8.6-1.8 11.2 1.8s1.8 8.6-1.8 11.2l-89.9 65.4-53.8 39.1C90.8 324.2 80 345.4 80 368v16H64V368c0-27.7 13.2-53.7 35.6-70l20.7-15c-9.9-1.2-19.6-4.8-28.1-10.8l-1.9-1.4c-16.8-12-26.7-31.3-26.6-51.9l.3-104.4c0-19 7.6-37.3 21.1-50.7l5.5-5.5L79.4 52.6C69.9 47.9 64 38.3 64 27.8C64 12.4 76.4 0 91.8 0H234.6C334.8 0 416 81.2 416 181.4c0 10.2-.9 20.4-2.6 30.4L383.9 385.3l-15.8-2.7 29.5-173.6c1.6-9.2 2.3-18.4 2.3-27.7C400 90 326 16 234.6 16H91.8zM128 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM78.3 432c-4.5 0-8.9 1.9-11.9 5.3L35.8 471.2c-2.5 2.7-3.8 6.3-3.8 9.9c0 8.2 6.6 14.8 14.8 14.8H401.2c8.2 0 14.8-6.6 14.8-14.8c0-3.7-1.4-7.2-3.8-9.9l-30.6-33.9c-3-3.4-7.4-5.3-11.9-5.3H78.3zm345.8 28.5c5.1 5.7 7.9 13 7.9 20.6c0 17-13.8 30.8-30.8 30.8H46.8c-17 0-30.8-13.8-30.8-30.8c0-7.6 2.8-15 7.9-20.6l30.6-33.9c6.1-6.7 14.7-10.6 23.8-10.6H369.7c9.1 0 17.7 3.8 23.8 10.6l30.6 33.9z'
      
    ]
  };

  

  
  

  var faFarm = {
    prefix: 'fat',
    iconName: 'farm',
    icon: [
      576,
      512,
      ["barn-silo"],
      'f864',
      
      'M0 104V456c0 30.9 25.1 56 56 56h72c4.4 0 8-3.6 8-8s-3.6-8-8-8H56c-22.1 0-40-17.9-40-40V192H144c4.4 0 8-3.6 8-8s-3.6-8-8-8H16V104c0-48.6 39.4-88 88-88s88 39.4 88 88v8c0 4.4 3.6 8 8 8s8-3.6 8-8v-8C208 46.6 161.4 0 104 0S0 46.6 0 104zM365.1 81.7c1.9-.7 3.9-.7 5.8 0l132 51.3c2 .8 3.6 2.3 4.4 4.2l52 118.8c.4 1 .7 2.1 .7 3.2V472c0 13.3-10.7 24-24 24H448V424c0-22.1-17.9-40-40-40H328c-22.1 0-40 17.9-40 40v72H200c-13.3 0-24-10.7-24-24V259.3c0-1.1 .2-2.2 .7-3.2l52-118.8c.9-1.9 2.4-3.5 4.4-4.2l132-51.3zM304 496V424c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v72H304zM376.7 66.8c-5.6-2.2-11.8-2.2-17.4 0l-132 51.3c-5.9 2.3-10.7 6.9-13.3 12.7L162 249.7c-1.3 3-2 6.3-2 9.6V472c0 22.1 17.9 40 40 40H536c22.1 0 40-17.9 40-40V259.3c0-3.3-.7-6.6-2-9.6L522 130.9c-2.6-5.8-7.3-10.4-13.3-12.7l-132-51.3zM400 208c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16h64zm-64-16c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H336z'
      
    ]
  };

  
    var faBarnSilo = faFarm;
  

  
  

  var faSquareT = {
    prefix: 'fat',
    iconName: 'square-t',
    icon: [
      448,
      512,
      [],
      'e280',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm104 48H224 344c4.4 0 8 3.6 8 8s-3.6 8-8 8H232V392c0 4.4-3.6 8-8 8s-8-3.6-8-8V160H104c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faTvRetro = {
    prefix: 'fat',
    iconName: 'tv-retro',
    icon: [
      512,
      512,
      [128250],
      'f401',
      
      'M141 1.8C137.5-1 132.5-.4 129.8 3s-2.2 8.5 1.2 11.2L233.2 96H80C35.8 96 0 131.8 0 176V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V176c0-44.2-35.8-80-80-80H278.8L381 14.2c3.4-2.8 4-7.8 1.2-11.2s-7.8-4-11.2-1.2l-115 92L141 1.8zM256 112H432c35.3 0 64 28.7 64 64V432c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V176c0-35.3 28.7-64 64-64H256zm80 64c17.7 0 32 14.3 32 32V400c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V208c0-17.7 14.3-32 32-32H336zM112 160c-26.5 0-48 21.5-48 48V400c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V208c0-26.5-21.5-48-48-48H112zm312 48a8 8 0 1 1 16 0 8 8 0 1 1 -16 0zm32 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-24 56a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm0 32a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faScannerImage = {
    prefix: 'fat',
    iconName: 'scanner-image',
    icon: [
      576,
      512,
      [],
      'f8f3',
      
      'M43.7 32.9c-3.9-2-8.8-.5-10.8 3.4s-.5 8.8 3.4 10.8L503.9 288H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64v-8V352v-1c0-27-15.1-51.7-39-64L43.7 32.9zM560 352v56 8c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V352c0-26.5 21.5-48 48-48H512c26.5 0 48 21.5 48 48zM208 384a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM96 400a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faSnooze = {
    prefix: 'fat',
    iconName: 'snooze',
    icon: [
      448,
      512,
      [128164,"zzz"],
      'f880',
      
      'M160 8c0-4.4 3.6-8 8-8H312c3.3 0 6.3 2.1 7.5 5.2s.3 6.6-2.2 8.8L189 128H312c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-3.3 0-6.3-2.1-7.5-5.2s-.3-6.6 2.2-8.8L291 16H168c-4.4 0-8-3.6-8-8zM0 264c0-4.4 3.6-8 8-8H216c3.1 0 6 1.8 7.3 4.7s.8 6.2-1.2 8.6L25.5 496H216c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-3.1 0-6-1.8-7.3-4.7s-.8-6.2 1.2-8.6L198.5 272H8c-4.4 0-8-3.6-8-8zm296-40H440c3.2 0 6 1.9 7.3 4.7s.8 6.3-1.4 8.6L314 384H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H296c-3.2 0-6-1.9-7.3-4.7s-.8-6.3 1.4-8.6L422 240H296c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  
    var faZzz = faSnooze;
  

  
  

  var faBlockQuestion = {
    prefix: 'fat',
    iconName: 'block-question',
    icon: [
      448,
      512,
      [],
      'e3dd',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm136 96c0-30.9 25.1-56 56-56h56.2c35.2 0 63.8 28.6 63.8 63.8c0 21.4-10.8 41.5-28.7 53.3L232 286.9V312c0 4.4-3.6 8-8 8s-8-3.6-8-8V282.5c0-2.7 1.4-5.2 3.6-6.7l54.9-36.2c13.4-8.8 21.5-23.8 21.5-39.9c0-26.4-21.4-47.8-47.8-47.8H192c-22.1 0-40 17.9-40 40l0 6.5c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-6.5zm72 168a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM64 112a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM368 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM64 400a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm304-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faPlayPause = {
    prefix: 'fat',
    iconName: 'play-pause',
    icon: [
      640,
      512,
      [],
      'e22f',
      
      'M80 412.9c0 10.6 8.6 19.1 19.1 19.1c4.5 0 8.9-1.6 12.4-4.5l186-157.4c4.2-3.5 6.5-8.7 6.5-14.1s-2.4-10.6-6.5-14.1L111.5 84.5C108 81.6 103.7 80 99.1 80C88.6 80 80 88.6 80 99.1V412.9zm-16 0V99.1C64 79.7 79.7 64 99.1 64c8.3 0 16.3 2.9 22.7 8.3l186 157.4c7.7 6.6 12.2 16.2 12.2 26.3s-4.5 19.8-12.2 26.3l-186 157.4c-6.3 5.4-14.4 8.3-22.7 8.3C79.7 448 64 432.3 64 412.9zM432 72V440c0 4.4-3.6 8-8 8s-8-3.6-8-8V72c0-4.4 3.6-8 8-8s8 3.6 8 8zm144 0V440c0 4.4-3.6 8-8 8s-8-3.6-8-8V72c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faLayerPlus = {
    prefix: 'fat',
    iconName: 'layer-plus',
    icon: [
      576,
      512,
      ["layer-group-plus"],
      'f5ff',
      
      'M472 24c0-4.4-3.6-8-8-8s-8 3.6-8 8V72H408c-4.4 0-8 3.6-8 8s3.6 8 8 8h48v48c0 4.4 3.6 8 8 8s8-3.6 8-8V88h48c4.4 0 8-3.6 8-8s-3.6-8-8-8H472V24zM288 128c-6.4 0-12.8 1.4-18.6 4.1L43.9 237.4C36.6 240.7 32 248 32 256s4.6 15.3 11.9 18.6L269.4 379.9c5.8 2.7 12.2 4.1 18.6 4.1s12.8-1.4 18.6-4.1L532.1 274.6C539.4 271.3 544 264 544 256s-4.6-15.3-11.9-18.6L306.6 132.1c-5.8-2.7-12.2-4.1-18.6-4.1zm-11.9 18.6c3.7-1.7 7.8-2.6 11.9-2.6s8.2 .9 11.9 2.6L525.4 251.9c1.6 .7 2.6 2.4 2.6 4.1s-1 3.4-2.6 4.1L299.9 365.4c-3.7 1.7-7.8 2.6-11.9 2.6s-8.2-.9-11.9-2.6L50.6 260.1c-1.6-.7-2.6-2.4-2.6-4.1s1-3.4 2.6-4.1L276.1 146.6zm-172.9 191L43.9 365.4C36.6 368.7 32 376 32 384s4.6 15.3 11.9 18.6L269.4 507.9c5.8 2.7 12.2 4.1 18.6 4.1s12.8-1.4 18.6-4.1L532.1 402.6C539.4 399.3 544 392 544 384s-4.6-15.3-11.9-18.6l-59.4-27.7-18.9 8.8 71.5 33.4c1.6 .7 2.6 2.4 2.6 4.1s-1 3.4-2.6 4.1L299.9 493.4c-3.7 1.7-7.8 2.6-11.9 2.6s-8.2-.9-11.9-2.6L50.6 388.1c-1.6-.7-2.6-2.4-2.6-4.1s1-3.4 2.6-4.1l71.5-33.4-18.9-8.8z'
      
    ]
  };

  
    var faLayerGroupPlus = faLayerPlus;
  

  
  

  var faArrowUpAZ = {
    prefix: 'fat',
    iconName: 'arrow-up-a-z',
    icon: [
      576,
      512,
      ["sort-alpha-up"],
      'f15e',
      
      'M154.3 34.3c3.1-3.1 8.2-3.1 11.3 0l112 112c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L168 59.3V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V59.3L53.7 157.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l112-112zM336 296c0-4.4 3.6-8 8-8H488c3.1 0 5.9 1.8 7.2 4.6s.9 6.1-1 8.5L360.9 464H488c4.4 0 8 3.6 8 8s-3.6 8-8 8H344c-3.1 0-5.9-1.8-7.2-4.6s-.9-6.1 1-8.5L471.1 304H344c-4.4 0-8-3.6-8-8zM416 32c3 0 5.8 1.7 7.2 4.4l63.9 127.9 .1 .3 23.9 47.8c2 4 .4 8.8-3.6 10.7s-8.8 .4-10.7-3.6L475.1 176H356.9l-21.8 43.6c-2 4-6.8 5.6-10.7 3.6s-5.6-6.8-3.6-10.7l23.9-47.8 .1-.3L408.8 36.4c1.4-2.7 4.1-4.4 7.2-4.4zm0 25.9L364.9 160H467.1L416 57.9z'
      
    ]
  };

  
    var faSortAlphaUp = faArrowUpAZ;
  

  
  

  var faUserGroup = {
    prefix: 'fat',
    iconName: 'user-group',
    icon: [
      640,
      512,
      [128101,"user-friends"],
      'f500',
      
      'M112 128a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zM16 482.3C16 392.7 88.7 320 178.3 320h91.4C359.3 320 432 392.7 432 482.3c0 7.6-6.1 13.7-13.7 13.7H29.7c-7.6 0-13.7-6.1-13.7-13.7zM224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3zm431 208c17 0 30.7-13.8 30.7-30.7C640 392.2 567.8 320 478.7 320H417.3c-4.4 0-8.8 .2-13.2 .5c5.8 4.9 11.4 10 16.7 15.5h57.9C559 336 624 401 624 481.3c0 8.1-6.6 14.7-14.7 14.7H478.5c-1.3 5.7-3.4 11-6.1 16H609.3zM432 256c61.9 0 112-50.1 112-112s-50.1-112-112-112c-24.8 0-47.7 8.1-66.3 21.7c2.5 4.8 4.8 9.8 6.9 14.9C388.9 55.7 409.6 48 432 48c53 0 96 43 96 96s-43 96-96 96c-27.7 0-52.7-11.8-70.2-30.6c-2.8 4.7-5.8 9.3-9.1 13.7C373 243.4 401 256 432 256z'
      
    ]
  };

  
    var faUserFriends = faUserGroup;
  

  
  

  var faBooks = {
    prefix: 'fat',
    iconName: 'books',
    icon: [
      512,
      512,
      [128218],
      'f5db',
      
      'M128 416v48c0 17.7-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V416H128zM96 512c16.7 0 31.4-8.5 40-21.5c8.6 12.9 23.3 21.5 40 21.5h48c26.5 0 48-21.5 48-48V416v-8-8V132.2l1.5 6 2 7.7 65.9 253.8 2 7.7 18 69.2c6.6 25.5 32 40.6 56.7 33.8l59.6-16.5c24.7-6.8 39.3-33 32.7-58.5l-16-61.5-2-7.7L426.6 112.4l-2-7.7-18-69.2C400 9.9 374.6-5.2 349.9 1.6L290.3 18.1c-8.4 2.3-15.7 6.9-21.4 13C262.1 12.9 244.6 0 224 0H176c-16.7 0-31.4 8.5-40 21.5C127.4 8.5 112.7 0 96 0H48C21.5 0 0 21.5 0 48V96v8 8V400v8 8 48c0 26.5 21.5 48 48 48H96zM272 64.8V63.6c.3-14 9.5-26.4 22.6-30l59.6-16.5c15.7-4.3 32.5 5.1 36.9 22.4l16 61.7L289 133.8 273.1 72.6c-.7-2.6-1-5.2-1.1-7.8zm-16-.6c0 0 0 0 0 0V96H144V48c0-17.7 14.3-32 32-32h48c17.7 0 32 14.3 32 32V64.2zM176 496c-17.7 0-32-14.3-32-32V416H256v48c0 17.7-14.3 32-32 32H176zM128 112V400H16V112H128zm0-64V96H16V48c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32zM256 400H144V112H256V400zM411.2 116.7l63.9 246L356.8 395.3 293 149.3l118.2-32.7zM479 378.2l15.9 61.2c4.5 17.4-5.6 34.7-21.5 39.1l-59.6 16.5c-15.7 4.3-32.5-5.1-36.9-22.4l-16-61.7L479 378.2z'
      
    ]
  };

  

  
  

  var faStarExclamation = {
    prefix: 'fat',
    iconName: 'star-exclamation',
    icon: [
      576,
      512,
      [],
      'f2f3',
      
      'M200.1 170.7L46.8 193.3c-3 .4-5.5 2.5-6.4 5.4s-.2 6 2 8.2L31.2 218.1l11.2-11.3L153.5 317c3.7 3.7 5.4 8.9 4.5 14L131.8 486.6c-.5 3 .7 6 3.2 7.8s5.8 2 8.4 .6l137-73.2c4.7-2.5 10.4-2.5 15.1 0l137 73.2c2.7 1.4 6 1.2 8.4-.6s3.7-4.8 3.2-7.8L417.9 331c-.9-5.1 .8-10.4 4.5-14L533.5 206.9c2.2-2.1 2.9-5.3 2-8.2s-3.4-5-6.4-5.4L375.8 170.7c-5.2-.8-9.7-4.1-12.1-8.8L295.1 20.5c-1.3-2.8-4.1-4.5-7.2-4.5s-5.9 1.7-7.2 4.5L212.1 161.8c-2.3 4.8-6.8 8.1-12.1 8.8zM450.2 507.4c-7.4 5.3-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0s17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5zM288 128c4.4 0 8 3.6 8 8V296c0 4.4-3.6 8-8 8s-8-3.6-8-8V136c0-4.4 3.6-8 8-8zM272 352a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faArrowUpToArc = {
    prefix: 'fat',
    iconName: 'arrow-up-to-arc',
    icon: [
      512,
      512,
      [],
      'e617',
      
      'M256 16c132.5 0 240 107.5 240 240c0 4.4 3.6 8 8 8s8-3.6 8-8C512 114.6 397.4 0 256 0S0 114.6 0 256c0 4.4 3.6 8 8 8s8-3.6 8-8C16 123.5 123.5 16 256 16zM390.1 314.8l-128-152c-1.5-1.8-3.8-2.8-6.1-2.8s-4.6 1-6.1 2.8l-128 152c-2.8 3.4-2.4 8.4 1 11.3s8.4 2.4 11.3-1L248 189.9 248 504c0 4.4 3.6 8 8 8s8-3.6 8-8l0-314.1L377.9 325.2c2.8 3.4 7.9 3.8 11.3 1s3.8-7.9 1-11.3z'
      
    ]
  };

  

  
  

  var faWeightScale = {
    prefix: 'fat',
    iconName: 'weight-scale',
    icon: [
      512,
      512,
      ["weight"],
      'f496',
      
      'M416 176c0-36-11.9-69.3-32-96c-4.2-5.5-8.7-10.8-13.5-15.8C341.4 34.5 300.9 16 256 16c-44.8 0-85.2 18.4-114.3 48c-4.6 4.6-8.8 9.6-12.8 14.7L128 80c-20.1 26.7-32 60-32 96c0 88.4 71.6 160 160 160s160-71.6 160-160zM403.5 80c18 27.6 28.5 60.6 28.5 96c0 97.2-78.8 176-176 176s-176-78.8-176-176c0-35.4 10.5-68.4 28.5-96H64c-26.5 0-48 21.5-48 48V448c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V128c0-26.5-21.5-48-48-48H403.5zM120.2 64C152.5 24.9 201.3 0 256 0s103.5 24.9 135.8 64H448c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64h56.2zM304 224c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48c4.4 0 8.7 .6 12.8 1.7l36-77.1c1.9-4 6.6-5.7 10.6-3.9s5.7 6.6 3.9 10.6l-36 77.1c12.5 8.7 20.7 23.1 20.7 39.5zm-48 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  
    var faWeight = faWeightScale;
  

  
  

  var faHandBackPointUp = {
    prefix: 'fat',
    iconName: 'hand-back-point-up',
    icon: [
      448,
      512,
      [],
      'e1a2',
      
      'M140 0C111.3 0 88 23.3 88 52V240v9.6c-6 3.7-11.8 7.8-17.3 12.5L41.5 286.7C25.3 300.4 16 320.5 16 341.7v24c0 48.8 26.2 93.9 68.5 118.1l18 10.3C123.1 505.8 146.3 512 170 512H312c57.4 0 104-46.6 104-104V392 308v-4c0-.8-.1-1.5-.3-2.2C412.5 271.5 387 248 356 248c-3.6 0-7.1 .3-10.5 .9C335.7 229.4 315.4 216 292 216c-6.1 0-12 .9-17.6 2.6C264.8 198.2 244.1 184 220 184c-10.1 0-19.6 2.5-28 6.9V52c0-28.7-23.3-52-52-52zM88 268.8V344c0 4.4 3.6 8 8 8s8-3.6 8-8V254.2 240 52c0-19.9 16.1-36 36-36s36 16.1 36 36V206.5c0 3.2 1.9 6.1 4.9 7.4s6.4 .6 8.7-1.6c7.9-7.6 18.6-12.2 30.5-12.2c19.9 0 36.7 13.2 42.1 31.3c.7 2.2 2.3 4.1 4.4 5s4.6 .9 6.7-.1c5.7-2.7 12-4.2 18.8-4.2c19 0 35.2 12.1 41.4 29c1.5 4 5.8 6.2 9.8 4.9c4-1.2 8.3-1.9 12.8-1.9c23.1 0 42.1 17.9 43.9 40.6c0 .3 .1 .6 .1 1V308v84 16c0 48.6-39.4 88-88 88H170c-20.9 0-41.4-5.4-59.5-15.8l-18-10.3C55.1 448.5 32 408.8 32 365.7v-24c0-16.5 7.3-32.1 19.8-42.7L81 274.2c2.3-1.9 4.6-3.7 7-5.5z'
      
    ]
  };

  

  
  

  var faFlowerDaffodil = {
    prefix: 'fat',
    iconName: 'flower-daffodil',
    icon: [
      512,
      512,
      [9880],
      'f800',
      
      'M192 0c-44.2 0-80 35.8-80 80c0 26.2 12.6 49.4 32 64c-19.4 14.6-32 37.8-32 64c0 44.2 35.8 80 80 80c21.8 0 41.6-8.7 56-22.9V422.6C220.2 362 159 320 88 320H29.5C13.2 320 0 333.2 0 349.5C0 439.3 72.7 512 162.5 512H248h16 85.5C439.3 512 512 439.3 512 349.5c0-16.3-13.2-29.5-29.5-29.5H424c-71 0-132.2 42-160 102.6V265.1c14.4 14.1 34.2 22.9 56 22.9c44.2 0 80-35.8 80-80c0-26.2-12.6-49.4-32-64c19.4-14.6 32-37.8 32-64c0-44.2-35.8-80-80-80c-26.2 0-49.4 12.6-64 32C241.4 12.6 218.2 0 192 0zm56 496H162.5C81.6 496 16 430.4 16 349.5c0-7.5 6.1-13.5 13.5-13.5H88c88.4 0 160 71.6 160 160zM128 80c0-35.3 28.7-64 64-64c24.8 0 46.2 14.1 56.9 34.7c1.4 2.7 4.1 4.3 7.1 4.3s5.7-1.7 7.1-4.3C273.8 30.1 295.2 16 320 16c35.3 0 64 28.7 64 64c0 24.8-14.1 46.2-34.7 56.9c-2.7 1.4-4.3 4.1-4.3 7.1s1.7 5.7 4.3 7.1C369.9 161.8 384 183.2 384 208c0 35.3-28.7 64-64 64c-24.8 0-46.2-14.1-56.9-34.7c-1.4-2.7-4.1-4.3-7.1-4.3s-5.7 1.7-7.1 4.3C238.2 257.9 216.8 272 192 272c-35.3 0-64-28.7-64-64c0-24.8 14.1-46.2 34.7-56.9c2.7-1.4 4.3-4.1 4.3-7.1s-1.7-5.7-4.3-7.1C142.1 126.2 128 104.8 128 80zM349.5 496H264c0-88.4 71.6-160 160-160h58.5c7.5 0 13.5 6.1 13.5 13.5C496 430.4 430.4 496 349.5 496zM256 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faCalendarRange = {
    prefix: 'fat',
    iconName: 'calendar-range',
    icon: [
      448,
      512,
      [],
      'e0d6',
      
      'M120 0c4.4 0 8 3.6 8 8V64H320V8c0-4.4 3.6-8 8-8s8 3.6 8 8V64h48c35.3 0 64 28.7 64 64v48 16V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 176 128C0 92.7 28.7 64 64 64h48V8c0-4.4 3.6-8 8-8zM432 192H16V448c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V192zM112 120V80H64c-26.5 0-48 21.5-48 48v48H432V128c0-26.5-21.5-48-48-48H336v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V80H128v40c0 4.4-3.6 8-8 8s-8-3.6-8-8zM376 280c0 4.4-3.6 8-8 8H176c-4.4 0-8-3.6-8-8s3.6-8 8-8H368c4.4 0 8 3.6 8 8zM272 416H80c-4.4 0-8-3.6-8-8s3.6-8 8-8H272c4.4 0 8 3.6 8 8s-3.6 8-8 8zM72 288a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 40a40 40 0 1 1 0-80 40 40 0 1 1 0 80zM352 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm40-24a40 40 0 1 1 -80 0 40 40 0 1 1 80 0z'
      
    ]
  };

  

  
  

  var faTableCellsLock = {
    prefix: 'fat',
    iconName: 'table-cells-lock',
    icon: [
      640,
      512,
      [],
      'e679',
      
      'M352 48l96 0c26.5 0 48 21.5 48 48l0 69.5c5.1-1.8 10.5-3.2 16-4.1L512 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0 0-16-32 0 0-128 34 0c1.5-5.7 3.7-11 6.5-16L352 320l0-128 104.4 0c5.4-6.1 11.7-11.5 18.5-16L352 176l0-128zm-16 0l0 128-160 0 0-128 160 0zM160 48l0 128L16 176l0-80c0-26.5 21.5-48 48-48l96 0zM16 192l144 0 0 128L16 320l0-128zm0 144l144 0 0 128-96 0c-26.5 0-48-21.5-48-48l0-80zM176 464l0-128 160 0 0 128-160 0zm0-144l0-128 160 0 0 128-160 0zM528 208c26.5 0 48 21.5 48 48l0 64-96 0 0-64c0-26.5 21.5-48 48-48zm-64 48l0 64-16 0c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-16 0 0-64c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-16 80l16 0 16 0 96 0 16 0 16 0c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faFilePrescription = {
    prefix: 'fat',
    iconName: 'file-prescription',
    icon: [
      384,
      512,
      [],
      'f572',
      
      'M64 496c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm40 224c-4.4 0-8 3.6-8 8v80 80c0 4.4 3.6 8 8 8s8-3.6 8-8V320h52.7l64 64-42.3 42.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L240 395.3l42.3 42.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L251.3 384l42.3-42.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L240 372.7l-53.8-53.8C207.8 314.2 224 295 224 272c0-26.5-21.5-48-48-48H104zm64 80h0H112V240h64c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8z'
      
    ]
  };

  

  
  

  var faXmarksLines = {
    prefix: 'fat',
    iconName: 'xmarks-lines',
    icon: [
      640,
      512,
      [],
      'e59a',
      
      'M8 32H632c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8zM8 464H632c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8zm99.3-208l82.3 82.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L96 267.3 13.7 349.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L84.7 256 2.3 173.7c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L96 244.7l82.3-82.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L107.3 256zm130.3-93.7L320 244.7l82.3-82.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L331.3 256l82.3 82.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L320 267.3l-82.3 82.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L308.7 256l-82.3-82.3c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0zm212.7 0c3.1-3.1 8.2-3.1 11.3 0L544 244.7l82.3-82.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L555.3 256l82.3 82.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L544 267.3l-82.3 82.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L532.7 256l-82.3-82.3c-3.1-3.1-3.1-8.2 0-11.3zM0 424c0-4.4 3.6-8 8-8H632c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8zM8 80H632c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faWeightHanging = {
    prefix: 'fat',
    iconName: 'weight-hanging',
    icon: [
      512,
      512,
      [],
      'f5cd',
      
      'M200 72a56 56 0 1 1 112 0A56 56 0 1 1 200 72zm101.3 56C317.6 114.8 328 94.6 328 72c0-39.8-32.2-72-72-72s-72 32.2-72 72c0 22.6 10.4 42.8 26.7 56H120c-22 0-41.2 15-46.6 36.4l-72 288c-3.6 14.3-.4 29.5 8.7 41.2S33.2 512 48 512H464c14.8 0 28.7-6.8 37.8-18.5s12.3-26.8 8.7-41.2l-72-288C433.2 143 414 128 392 128H301.3zM256 144H392c14.7 0 27.5 10 31 24.2l72 288c2.4 9.6 .2 19.7-5.8 27.5s-15.4 12.3-25.2 12.3H48c-9.9 0-19.2-4.5-25.2-12.3s-8.2-17.9-5.8-27.5l72-288C92.5 154 105.3 144 120 144H256z'
      
    ]
  };

  

  
  

  var faCrown = {
    prefix: 'fat',
    iconName: 'crown',
    icon: [
      576,
      512,
      [128081],
      'f521',
      
      'M264 72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm29.9 39.6L352 227.8c13.7 27.3 49.1 35.1 72.9 16l91.3-73c1.1 .6 2.3 1.2 3.5 1.8L473.8 424.6c-4.2 22.8-24 39.4-47.2 39.4H149.4c-23.2 0-43.1-16.6-47.2-39.4L56.4 172.5c1.2-.5 2.3-1.1 3.5-1.8l91.3 73c23.9 19.1 59.3 11.3 72.9-16l58.1-116.2c1.9 .3 3.9 .4 5.9 .4s4-.1 5.9-.4zM309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0L86.4 427.4c5.5 30.4 32 52.6 63 52.6H426.6c30.9 0 57.4-22.1 63-52.6L535.3 176c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7L309 106zM16 136a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm520-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faLeftLongToLine = {
    prefix: 'fat',
    iconName: 'left-long-to-line',
    icon: [
      640,
      512,
      [],
      'e41e',
      
      'M0 72c0-4.4 3.6-8 8-8s8 3.6 8 8V440c0 4.4-3.6 8-8 8s-8-3.6-8-8V72zM320 296H600c13.3 0 24-10.7 24-24l0-32c0-13.3-10.7-24-24-24H320c-8.8 0-16-7.2-16-16V118.9c0-3.8-3.1-6.9-6.9-6.9c-1.8 0-3.5 .7-4.7 1.9L144.8 254.1c-.5 .5-.8 1.2-.8 1.9s.3 1.4 .8 1.9L292.4 398.1c1.3 1.2 3 1.9 4.7 1.9c3.8 0 6.9-3.1 6.9-6.9V312c0-8.8 7.2-16 16-16zM281.4 409.7L133.8 269.5c-3.7-3.5-5.8-8.4-5.8-13.5s2.1-10 5.8-13.5L281.4 102.3c4.3-4 9.9-6.3 15.8-6.3c12.6 0 22.9 10.2 22.9 22.9V184v16h16H600c22.1 0 40 17.9 40 40l0 32c0 22.1-17.9 40-40 40H336 320v16 65.1c0 12.6-10.2 22.9-22.9 22.9c-5.9 0-11.5-2.3-15.8-6.3z'
      
    ]
  };

  

  
  

  var faMicrochip = {
    prefix: 'fat',
    iconName: 'microchip',
    icon: [
      512,
      512,
      [],
      'f2db',
      
      'M168 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H128c-35.3 0-64 28.7-64 64v24H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H64v80H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H64v80H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H64v24c0 35.3 28.7 64 64 64h24v56c0 4.4 3.6 8 8 8s8-3.6 8-8V448h80v56c0 4.4 3.6 8 8 8s8-3.6 8-8V448h80v56c0 4.4 3.6 8 8 8s8-3.6 8-8V448h24c35.3 0 64-28.7 64-64V360h56c4.4 0 8-3.6 8-8s-3.6-8-8-8H448V264h56c4.4 0 8-3.6 8-8s-3.6-8-8-8H448V168h56c4.4 0 8-3.6 8-8s-3.6-8-8-8H448V128c0-35.3-28.7-64-64-64H360V8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H264V8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H168V8zm88 72h96 32c26.5 0 48 21.5 48 48v32 96 96 32c0 26.5-21.5 48-48 48H352 256 160 128c-26.5 0-48-21.5-48-48V352 256 160 128c0-26.5 21.5-48 48-48h32 96zm112 80V352c0 8.8-7.2 16-16 16H160c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16H352c8.8 0 16 7.2 16 16zM160 128c-17.7 0-32 14.3-32 32V352c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H160z'
      
    ]
  };

  

  
  

  var faTemperatureHigh = {
    prefix: 'fat',
    iconName: 'temperature-high',
    icon: [
      512,
      512,
      [],
      'f769',
      
      'M416 16a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112A64 64 0 1 0 416 0a64 64 0 1 0 0 128zM112 80c0-35.3 28.7-64 64-64s64 28.7 64 64V243.8c0 8.4 4.4 15.7 10.7 20.3C283 287.3 304 325.2 304 368c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-42.8 21-80.7 53.3-104c6.3-4.6 10.7-11.9 10.7-20.3V80zM176 0C131.8 0 96 35.8 96 80V243.8c0 2.7-1.4 5.4-4 7.3c-36.3 26.1-60 68.8-60 117c0 79.5 64.5 144 144 144s144-64.5 144-144c0-48.2-23.7-90.8-60-117c-2.6-1.9-4-4.6-4-7.3V80c0-44.2-35.8-80-80-80zM128 368a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0c0-32.6-24.4-59.6-56-63.5V72c0-4.4-3.6-8-8-8s-8 3.6-8 8V304.5c-31.6 3.9-56 30.9-56 63.5c0 35.3 28.7 64 64 64s64-28.7 64-64z'
      
    ]
  };

  

  
  

  var faTrashCanXmark = {
    prefix: 'fat',
    iconName: 'trash-can-xmark',
    icon: [
      448,
      512,
      [],
      'e2ae',
      
      'M157.4 27.3L134.4 64H313.6l-23-36.7c-4.4-7-12.1-11.3-20.4-11.3H177.7c-8.3 0-16 4.3-20.4 11.3zM115.6 64l28.2-45.2C151.1 7.1 163.9 0 177.7 0h92.5c13.8 0 26.6 7.1 33.9 18.8L332.4 64H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H115.6zM40 112c4.4 0 8 3.6 8 8V440c0 30.9 25.1 56 56 56H344c30.9 0 56-25.1 56-56V120c0-4.4 3.6-8 8-8s8 3.6 8 8V440c0 39.8-32.2 72-72 72H104c-39.8 0-72-32.2-72-72V120c0-4.4 3.6-8 8-8zm106.3 98.3c3.1-3.1 8.2-3.1 11.3 0L224 276.7l66.3-66.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L235.3 288l66.3 66.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L224 299.3l-66.3 66.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L212.7 288l-66.3-66.3c-3.1-3.1-3.1-8.2 0-11.3z'
      
    ]
  };

  

  
  

  var faFolderUser = {
    prefix: 'fat',
    iconName: 'folder-user',
    icon: [
      512,
      512,
      [],
      'e18e',
      
      'M496 416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H197.5c12.7 0 24.9 5.1 33.9 14.1l35.9 35.9c9 9 21.2 14.1 33.9 14.1H448c26.5 0 48 21.5 48 48V416zM64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H301.3c-8.5 0-16.6-3.4-22.6-9.4L242.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64zM256 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-40 48h80c30.9 0 56 25.1 56 56c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8c0-30.9 25.1-56 56-56zm-72 56c0 13.3 10.7 24 24 24H344c13.3 0 24-10.7 24-24c0-39.8-32.2-72-72-72H216c-39.8 0-72 32.2-72 72z'
      
    ]
  };

  

  
  

  var faPeopleCarryBox = {
    prefix: 'fat',
    iconName: 'people-carry-box',
    icon: [
      640,
      512,
      ["people-carry"],
      'f4ce',
      
      'M128 16a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm48 32A48 48 0 1 1 80 48a48 48 0 1 1 96 0zm-69.4 96C83.1 144 64 163.1 64 186.6v88.1c0 12.7 5.1 24.9 14.1 33.9l81.2 81.2c1.2 1.2 2 2.7 2.2 4.3l14.7 88.4c1.5 8.7 9.7 14.6 18.4 13.2s14.6-9.7 13.2-18.4l-15.2-90.9c-1.1-6.6-4.2-12.7-8.9-17.4l-53.3-53.3c-1.5-1.5-2.3-3.5-2.3-5.7V215.3c0-3.5 2.3-6.6 5.7-7.7s7 .3 9 3.2l33.7 50.5c3.1 4.6 7.3 8.4 12.3 10.9l60.2 30.1c2.3 1.2 4.7 1.7 7.2 1.7v0h.3c5.7-.1 11.2-3.3 14-8.8c4-7.9 .7-17.5-7.2-21.5l-58.3-29.1c-1.2-.6-2.3-1.6-3.1-2.7l-48.6-72.9c-10.4-15.6-27.8-24.9-46.5-24.9zm150 176c-5 .1-10.1-1-15-3.4l-60.2-30.1c-7.5-3.7-13.8-9.4-18.5-16.3l-19-28.5v65.1l51 51c7.1 7.1 11.8 16.2 13.4 26.1l15.2 90.9c2.9 17.4-8.9 33.9-26.3 36.8s-33.9-8.9-36.8-26.3l-14.3-85.9L66.7 320C54.7 308 48 291.7 48 274.7V186.6c0-32.4 26.2-58.6 58.6-58.6c24.1 0 46.5 12 59.9 32l47.4 71.1 10.1 5V160c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32v76.2l10.1-5L473.5 160c13.3-20 35.8-32 59.9-32c32.4 0 58.6 26.2 58.6 58.6v88.1c0 17-6.7 33.3-18.7 45.3l-79.4 79.4-14.3 85.9c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l15.2-90.9c1.6-9.9 6.3-19 13.4-26.1l51-51V241.7l-19 28.5c-4.6 7-11 12.6-18.5 16.3l-60.2 30.1c-4.8 2.4-9.9 3.5-15 3.4H256.6zm99.6-16c-.3-.6-.6-1.1-.9-1.7c-7.9-15.8-1.5-35 14.3-42.9L400 244.2V160c0-8.8-7.2-16-16-16H256c-8.8 0-16 7.2-16 16v84.2l30.3 15.2c15.8 7.9 22.2 27.1 14.3 42.9c-.3 .6-.6 1.1-.9 1.7h72.6zm27.7 0c2.4 0 4.9-.5 7.2-1.7l60.2-30.1c5-2.5 9.2-6.2 12.3-10.9l33.7-50.5c2-2.9 5.6-4.2 9-3.2s5.7 4.1 5.7 7.7v94.8c0 2.1-.8 4.2-2.3 5.7l-53.3 53.3c-4.7 4.7-7.8 10.8-8.9 17.4l-15.2 90.9c-1.5 8.7 4.4 17 13.2 18.4s17-4.4 18.4-13.2l14.7-88.4c.3-1.6 1.1-3.2 2.2-4.3l81.2-81.2c9-9 14.1-21.2 14.1-33.9V186.6c0-23.5-19.1-42.6-42.6-42.6c-18.7 0-36.2 9.3-46.5 24.9l-48.6 72.9c-.8 1.2-1.8 2.1-3.1 2.7l-58.3 29.1c-7.9 4-11.1 13.6-7.2 21.5c2.8 5.5 8.2 8.7 14 8.8h.3v0zM512 16a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM464 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM2.3 468.1L50.1 348.6l12.3 12.3L17.1 474.1c-3.3 8.2 .7 17.5 8.9 20.8s17.5-.7 20.8-8.9L87 385.5l12.3 12.3-37.6 94c-6.6 16.4-25.2 24.4-41.6 17.8S-4.3 484.5 2.3 468.1zM590.5 348.6l47.8 119.5c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8l-37.6-94 12.3-12.3 40.2 100.4c3.3 8.2 12.6 12.2 20.8 8.9s12.2-12.6 8.9-20.8L578.2 360.9l12.3-12.3z'
      
    ]
  };

  
    var faPeopleCarry = faPeopleCarryBox;
  

  
  

  var faClockTenThirty = {
    prefix: 'fat',
    iconName: 'clock-ten-thirty',
    icon: [
      512,
      512,
      [],
      'e355',
      
      'M16 256a240 240 0 1 1 480 0A240 240 0 1 1 16 256zm496 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM264 408V256c0-2.7-1.3-5.2-3.6-6.7l-96-64c-3.7-2.5-8.6-1.5-11.1 2.2s-1.5 8.6 2.2 11.1L248 260.3V408c0 4.4 3.6 8 8 8s8-3.6 8-8z'
      
    ]
  };

  

  
  

  var faCloudsMoon = {
    prefix: 'fat',
    iconName: 'clouds-moon',
    icon: [
      640,
      512,
      [],
      'f745',
      
      'M368 160c0-79.5 64.3-144 143.5-144c4.1 0 8.2 .2 12.2 .5c-40.2 22.8-67.4 66.1-67.4 115.8c0 73.4 59.3 132.9 132.5 132.9c7.8 0 15.3-.7 22.7-1.9c-25.8 25.2-61.1 40.7-100 40.7c-17.6 0-34.4-3.2-49.9-9l.3 1.3c14.2 5.5 27.2 13.4 38.5 23.2c3.7 .3 7.4 .4 11.2 .4c43.2 0 82.5-17.3 111.2-45.3c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-6.5 1.1-13.2 1.7-20 1.7c-64.3 0-116.5-52.3-116.5-116.9c0-43.7 23.9-81.8 59.3-101.9c6.1-3.5 9.2-10.5 7.7-17.3S532 1.2 525.1 .6c-4.5-.4-9-.6-13.5-.6C423.4 0 352 71.7 352 160c0 11.5 1.2 22.7 3.5 33.4c5.9 .9 11.7 2.2 17.4 3.9c-3.2-11.9-4.9-24.4-4.9-37.4zm-32.1 80c44.2 0 80 35.8 80 80c0 2.5-.1 5.1-.4 7.6c-.2 2.1 .5 4.2 1.8 5.9s3.3 2.7 5.5 2.8c40.9 3.5 73 37.9 73 79.7c0 44.2-35.8 80-80 80c-.9 0-1.8 0-2.8 0l-.3 0v0H146.5h-.3l0 0c-.7 0-1.5 0-2.2 0c-35.3 0-64-28.7-64-64c0-34.2 26.8-62.1 60.5-63.9c2.5-.1 4.8-1.4 6.2-3.5s1.7-4.7 .9-7.1c-2.4-6.7-3.7-13.9-3.7-21.4c0-35.3 28.7-64 64-64c16.5 0 31.6 6.2 42.9 16.5c1.9 1.7 4.5 2.4 6.9 1.9s4.6-2.1 5.7-4.4c12.8-27.2 40.4-46 72.4-46zm96 80c0-53-43-96-96-96c-34.9 0-65.4 18.6-82.2 46.4c-13-9.1-28.8-14.4-45.8-14.4c-44.2 0-80 35.8-80 80c0 5.9 .6 11.7 1.9 17.2C92.4 359.9 64 392.6 64 432c0 44.2 35.8 80 80 80c.9 0 1.8 0 2.6 0H412.7c1.1 0 2.1 .1 3.2 .1c53 0 96-43 96-96c0-47.6-34.6-87-80-94.7l0-1.3zM320 192.1h0c0-35.3-28.6-64-64-64c-7.4 0-14.6 1.3-21.2 3.6c-11.5-30.1-40.6-51.6-74.8-51.6c-38.9 0-71.3 27.8-78.5 64.6c-3.1-.4-6.3-.6-9.5-.6c-39.8 0-72 32.2-72 72s32.2 72 72 72l0 0h34.8c2.7-5.6 5.8-11 9.3-16h-43c-.3 0-.7 0-1 0c-30.9 0-56-25.1-56-56s25.1-56 56-56c2.5 0 5 .2 7.4 .5c8.4 1.1 16.2-4.5 17.8-12.8c5.7-29.4 31.7-51.7 62.8-51.7c27.3 0 50.7 17.1 59.8 41.3c3.1 8.1 12.1 12.3 20.3 9.4c5-1.7 10.3-2.7 15.9-2.7c26.5 0 48 21.5 48 48c0 .2 0 .5 0 .7c0 1.1 0 2.2-.1 3.3c5.2-1.4 10.6-2.4 16.1-3.1l0-.9z'
      
    ]
  };

  

  
  

  var faCircle8 = {
    prefix: 'fat',
    iconName: 'circle-8',
    icon: [
      512,
      512,
      [],
      'e0f5',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM264 128c35.3 0 64 28.7 64 64c0 22.3-11.4 41.9-28.7 53.4C325.5 256.1 344 281.9 344 312c0 39.8-32.2 72-72 72H240c-39.8 0-72-32.2-72-72c0-30.1 18.5-55.9 44.7-66.6C195.4 233.9 184 214.3 184 192c0-35.3 28.7-64 64-64h16zM248 240c0 0 0 0 0 0h16c0 0 0 0 0 0c26.5 0 48-21.5 48-48c0-26.5-21.5-48-48-48H248c-26.5 0-48 21.5-48 48c0 26.5 21.5 48 48 48zm16 16H248h-8c-30.9 0-56 25.1-56 56s25.1 56 56 56h32c30.9 0 56-25.1 56-56s-25.1-56-56-56h-8z'
      
    ]
  };

  

  
  

  var faHeartPulse = {
    prefix: 'fat',
    iconName: 'heart-pulse',
    icon: [
      512,
      512,
      ["heartbeat"],
      'f21e',
      
      'M393.6 57.7C451.9 65.3 496 115 496 173.6c0 30.3-11.7 59.3-32.8 81.1L462 256H371.8c-9.1 0-17.4-5.1-21.5-13.3l-23.2-46.3c-1.4-2.7-4.1-4.4-7.2-4.4s-5.8 1.7-7.2 4.4L256.4 309.4 191.3 164.7c-1.3-2.9-4.2-4.8-7.4-4.7s-6 2-7.3 4.9l-31.8 76.3c-3.7 8.9-12.5 14.8-22.2 14.8H50.1l-1.3-1.3C27.8 232.9 16 203.8 16 173.5C16 114.9 60.1 65.3 118.3 57.7c42.9-5.6 85.8 12.6 111.2 47.6l20 27.5c1.5 2.1 3.9 3.3 6.5 3.3s5-1.2 6.5-3.3l20-27.5c25.4-34.9 68.3-53.2 111.2-47.6zM464 272h4.8l6-6.2C498.6 241.1 512 208 512 173.6c0-66.8-50.2-123.2-116.3-131.8c-48.6-6.3-97.3 14.3-126.2 54L256 114.4 242.5 95.8c-28.9-39.7-77.6-60.4-126.2-54C50.2 50.4 0 106.8 0 173.5c0 34.5 13.4 67.6 37.4 92.3l6 6.2H47c0 0 0 0 0 0h75.7c16.1 0 30.7-9.7 36.9-24.6l24.7-59.3 64.4 143.2c1.3 2.8 4 4.7 7.1 4.7s5.9-1.7 7.3-4.4L320 217.9l16 32c6.8 13.6 20.6 22.1 35.8 22.1H464s0 0 0 0zM74.3 304L236.5 471.6c5.2 5.4 12.4 8.4 19.9 8.4c7.5 0 14.7-3.1 19.9-8.5L437.9 304H415.7l-151 156.4c-2.2 2.3-5.2 3.6-8.4 3.6s-6.2-1.3-8.4-3.6L96.6 304H74.3z'
      
    ]
  };

  
    var faHeartbeat = faHeartPulse;
  

  
  

  var faInboxIn = {
    prefix: 'fat',
    iconName: 'inbox-in',
    icon: [
      512,
      512,
      [128229,"inbox-arrow-down"],
      'f310',
      
      'M264 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V292.7L141.7 186.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l120 120c3.1 3.1 8.2 3.1 11.3 0l120-120c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L264 292.7V8zM48 336h74.3c12.1 0 23.2 6.8 28.6 17.7l9.9 19.8c8.1 16.3 24.8 26.5 42.9 26.5H308.2c18.2 0 34.8-10.3 42.9-26.5l9.9-19.8c5.4-10.8 16.5-17.7 28.6-17.7H464c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V368c0-17.7 14.3-32 32-32zm298.7 10.5l-9.9 19.8c-5.4 10.8-16.5 17.7-28.6 17.7H203.8c-12.1 0-23.2-6.8-28.6-17.7l-9.9-19.8c-8.1-16.3-24.8-26.5-42.9-26.5H48c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H389.7c-18.2 0-34.8 10.3-42.9 26.5z'
      
    ]
  };

  
    var faInboxArrowDown = faInboxIn;
  

  
  

  var faPassport = {
    prefix: 'fat',
    iconName: 'passport',
    icon: [
      448,
      512,
      [],
      'f5ab',
      
      'M384 16c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H384zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM96 392c0 4.4 3.6 8 8 8H344c4.4 0 8-3.6 8-8s-3.6-8-8-8H104c-4.4 0-8 3.6-8 8zm.2-208c-.2 2.6-.2 5.3-.2 8s.1 5.4 .2 8C100.4 267 156 320 224 320s123.6-53 127.8-120c.2-2.6 .2-5.3 .2-8s-.1-5.4-.2-8C347.6 117 292 64 224 64s-123.6 53-127.8 120zm16 16h55.8c1.4 41.3 13.1 70.2 25.1 89.3c3.1 4.9 6.1 9 9.1 12.6c-48.9-9.6-86.4-51.1-90-101.9zm223.4 0c-3.6 50.8-41.1 92.3-90 101.9c2.9-3.6 6-7.8 9.1-12.6c12-19 23.8-48 25.1-89.3h55.8zm0-16H279.9c-1.4-41.3-13.1-70.2-25.1-89.3c-3.1-4.9-6.1-9-9.1-12.6c48.9 9.6 86.4 51.1 90 101.9zm-223.4 0c3.6-50.8 41.1-92.3 90-101.9c-2.9 3.6-6 7.8-9.1 12.6c-12 19-23.8 48-25.1 89.3H112.3zm94.5-80.7c5.6-8.9 11.2-15.2 15.3-19.2c.7-.7 1.3-1.3 1.9-1.8c.6 .5 1.2 1.1 1.9 1.8c4.1 4 9.7 10.3 15.3 19.2c10.5 16.6 21.3 42.7 22.6 80.7H184.1c1.3-38.1 12.1-64.1 22.6-80.7zM263.9 200c-1.3 38.1-12.1 64.1-22.6 80.7c-5.6 8.9-11.2 15.2-15.3 19.2c-.7 .7-1.3 1.3-1.9 1.8c-.6-.5-1.2-1.1-1.9-1.8c-4.1-4-9.7-10.3-15.3-19.2c-10.5-16.6-21.3-42.7-22.6-80.7h79.7z'
      
    ]
  };

  

  
  

  var faVenus = {
    prefix: 'fat',
    iconName: 'venus',
    icon: [
      384,
      512,
      [9792],
      'f221',
      
      'M32 176a160 160 0 1 1 320 0A160 160 0 1 1 32 176zM200 351.8c93.5-4.2 168-81.3 168-175.8C368 78.8 289.2 0 192 0S16 78.8 16 176c0 94.5 74.5 171.6 168 175.8V416H104c-4.4 0-8 3.6-8 8s3.6 8 8 8h80v72c0 4.4 3.6 8 8 8s8-3.6 8-8V432h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H200V351.8z'
      
    ]
  };

  

  
  

  var faCommentSmile = {
    prefix: 'fat',
    iconName: 'comment-smile',
    icon: [
      512,
      512,
      [],
      'f4b4',
      
      'M157.3 415c-5-1.8-10.6-1-14.9 2.1c-11 8-29.4 19.3-51.2 28.8C68.3 456 41.6 464 16 464l.1-.1 0 0 0 0 .3-.3 .1-.1c.4-.4 .9-.9 1.5-1.6c1.3-1.4 3.2-3.6 5.4-6.3l-12.2-10 12.2 10C28 450 34 442 40 432c10.7-17.9 21.4-42.1 23.6-69.9c.3-4.3-1.1-8.6-3.9-11.8C31.9 318.8 16 280.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-35.2 0-68.6-6.1-98.7-17zM4.7 452.7l0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0zM192 208a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm128 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM161.2 282c-3.3 2.9-3.6 8-.6 11.3C184 319.5 218.1 336 256 336s72-16.5 95.4-42.7c2.9-3.3 2.7-8.3-.6-11.3s-8.3-2.7-11.3 .6C319 305.6 289.2 320 256 320s-63-14.4-83.5-37.3c-2.9-3.3-8-3.6-11.3-.6z'
      
    ]
  };

  

  
  

  var faSquareRight = {
    prefix: 'fat',
    iconName: 'square-right',
    icon: [
      448,
      512,
      [10145,"arrow-alt-square-right"],
      'f352',
      
      'M432 96c0-26.5-21.5-48-48-48L64 48C37.5 48 16 69.5 16 96l0 320c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM368 256c0 7.2-2.9 14.2-8 19.3L260.3 375c-5.7 5.7-13.5 9-21.7 9c-16.9 0-30.6-13.7-30.6-30.6l0-49.4-88 0c-22.1 0-40-17.9-40-40l0-16c0-22.1 17.9-40 40-40l88 0 0-49.4c0-16.9 13.7-30.6 30.6-30.6c8.1 0 15.9 3.2 21.7 9L360 236.7c5.1 5.1 8 12.1 8 19.3zm-19.3-8L249 148.3c-2.7-2.7-6.5-4.3-10.3-4.3c-8.1 0-14.6 6.5-14.6 14.6l0 57.4c0 4.4-3.6 8-8 8l-96 0c-13.3 0-24 10.7-24 24l0 16c0 13.3 10.7 24 24 24l96 0c4.4 0 8 3.6 8 8l0 57.4c0 8.1 6.5 14.6 14.6 14.6c3.9 0 7.6-1.5 10.3-4.3L348.7 264c2.1-2.1 3.3-5 3.3-8s-1.2-5.9-3.3-8z'
      
    ]
  };

  
    var faArrowAltSquareRight = faSquareRight;
  

  
  

  var faVideoPlus = {
    prefix: 'fat',
    iconName: 'video-plus',
    icon: [
      576,
      512,
      [],
      'f4e1',
      
      'M320 80c26.5 0 48 21.5 48 48v74.9V309.1 384c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V128c0-26.5 21.5-48 48-48H320zm64 304V336.8 309.1 202.9 175.2 128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64zm32-29.6l103.4 56.9c5.6 3.1 12 4.7 18.4 4.7c21.1 0 38.2-17.1 38.2-38.2V134.2c0-21.1-17.1-38.2-38.2-38.2c-6.4 0-12.8 1.6-18.4 4.7L416 157.6v18.3l111.1-61.1c3.3-1.8 7-2.7 10.7-2.7c12.3 0 22.2 9.9 22.2 22.2V377.8c0 12.3-9.9 22.2-22.2 22.2c-3.7 0-7.4-.9-10.7-2.7L416 336.1v18.3zM200 168c0-4.4-3.6-8-8-8s-8 3.6-8 8v80H104c-4.4 0-8 3.6-8 8s3.6 8 8 8h80v80c0 4.4 3.6 8 8 8s8-3.6 8-8V264h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H200V168z'
      
    ]
  };

  

  
  

  var faRightToBracket = {
    prefix: 'fat',
    iconName: 'right-to-bracket',
    icon: [
      512,
      512,
      ["sign-in-alt"],
      'f2f6',
      
      'M332.7 264c2.1-2.1 3.3-5 3.3-8s-1.2-5.9-3.3-8L200.6 116.2c-2.7-2.7-6.4-4.2-10.2-4.2c-8 0-14.4 6.5-14.4 14.4l0 73.6c0 4.4-3.6 8-8 8L32 208c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l136 0c4.4 0 8 3.6 8 8l0 73.6c0 8 6.5 14.4 14.4 14.4c3.8 0 7.5-1.5 10.2-4.2L332.7 264zm19.3-8c0 7.2-2.9 14.2-8 19.3L211.9 407.1c-5.7 5.7-13.4 8.9-21.5 8.9c-16.8 0-30.4-13.6-30.4-30.4l0-65.6L32 320c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-65.6c0-16.8 13.6-30.4 30.4-30.4c8.1 0 15.8 3.2 21.5 8.9L344 236.7c5.1 5.1 8 12.1 8 19.3zM328 464l96 0c39.8 0 72-32.2 72-72l0-272c0-39.8-32.2-72-72-72l-96 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l96 0c48.6 0 88 39.4 88 88l0 272c0 48.6-39.4 88-88 88l-96 0c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  
    var faSignInAlt = faRightToBracket;
  

  
  

  var faFireHydrant = {
    prefix: 'fat',
    iconName: 'fire-hydrant',
    icon: [
      384,
      512,
      [],
      'e17f',
      
      'M192 0c-4.4 0-8 3.6-8 8V32l0 .2C122.4 36 72.5 83.5 65 144H40c-4.4 0-8 3.6-8 8s3.6 8 8 8H64 80 304h16 24c4.4 0 8-3.6 8-8s-3.6-8-8-8H319C311.5 83.5 261.6 36 200 32.2l0-.2V8c0-4.4-3.6-8-8-8zm0 48c56.4 0 103.1 41.7 110.9 96H81.1C88.9 89.7 135.6 48 192 48zm80 272a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-80-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM40 496c-4.4 0-8 3.6-8 8s3.6 8 8 8H72 312h32c4.4 0 8-3.6 8-8s-3.6-8-8-8H320V392h24c22.1 0 40-17.9 40-40V288c0-22.1-17.9-40-40-40H320V192H304v64V384 496H80V384 256 192H64v56H40c-22.1 0-40 17.9-40 40v64c0 22.1 17.9 40 40 40H64V496H40zM64 376H40c-13.3 0-24-10.7-24-24V288c0-13.3 10.7-24 24-24H64V376zm256 0V264h24c13.3 0 24 10.7 24 24v64c0 13.3-10.7 24-24 24H320z'
      
    ]
  };

  

  
  

  var faFilePng = {
    prefix: 'fat',
    iconName: 'file-png',
    icon: [
      512,
      512,
      [],
      'e666',
      
      'M64 496l48 0 0 16-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L204.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 145.9c9 9 14.1 21.2 14.1 33.9L384 304l-16 0 0-124.1c0-1.3-.1-2.6-.2-3.9L248 176c-22.1 0-40-17.9-40-40l0-119.8c-1.3-.2-2.6-.2-3.9-.2L64 16C37.5 16 16 37.5 16 64l0 384c0 26.5 21.5 48 48 48zM361.1 160c-.8-1-1.6-1.9-2.4-2.7L226.7 25.4c-.9-.9-1.8-1.7-2.7-2.4L224 136c0 13.3 10.7 24 24 24l113.1 0zM311.2 372.4L360 470.1l0-94.1c0-4.4 3.6-8 8-8s8 3.6 8 8l0 128c0 3.7-2.6 6.9-6.2 7.8s-7.3-.9-9-4.2L312 409.9l0 94.1c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-128c0-3.7 2.6-6.9 6.2-7.8s7.3 .9 9 4.2zM176 368l32 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-24 0 0 40c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-48 0-80c0-4.4 3.6-8 8-8zm32 80c17.7 0 32-14.3 32-32s-14.3-32-32-32l-24 0 0 64 24 0zm216-48c0-17.7 14.3-32 32-32l16 0c17.7 0 32 14.3 32 32l0 8c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-8c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16-8 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 24c0 17.7-14.3 32-32 32l-16 0c-17.7 0-32-14.3-32-32l0-80z'
      
    ]
  };

  

  
  

  var faApostrophe = {
    prefix: 'fat',
    iconName: 'apostrophe',
    icon: [
      192,
      512,
      [],
      '27',
      
      'M80 352c61.9 0 112-50.1 112-112V152 136 104c0-39.8-32.2-72-72-72H72C32.2 32 0 64.2 0 104v48c0 39.8 32.2 72 72 72h48c22.6 0 42.8-10.4 56-26.7V240c0 53-43 96-96 96H72c-4.4 0-8 3.6-8 8s3.6 8 8 8h8zm96-200c0 30.9-25.1 56-56 56H72c-30.9 0-56-25.1-56-56V104c0-30.9 25.1-56 56-56h48c30.9 0 56 25.1 56 56v32 16z'
      
    ]
  };

  

  
  

  var faPersonBreastfeeding = {
    prefix: 'fat',
    iconName: 'person-breastfeeding',
    icon: [
      448,
      512,
      [],
      'e53a',
      
      'M424.6 372.5l0 0-.2 .3L361 452c-11 13.8-31.2 16-45 5c-9.5-7.6-13.5-19.5-11.5-30.8l0-.1L366.2 349c2.8-3.4 2.2-8.5-1.2-11.2s-8.5-2.2-11.2 1.2l-55.6 69.6-7-1c-37-5.6-70.7-24.1-95.2-52.2V320c0-19.9-16.1-36-36-36s-36 16.1-36 36v48c0 6 1.5 11.9 4.4 17.2l2.4 4.4 4.5 2.3 87 43.5c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L34.4 413l0 0-.2-.1c-.7-.4-1.5-.7-2.2-1.2l0 0c-3.3-1.9-6.1-4.3-8.4-7l0 0c-3-3.6-5.2-7.8-6.4-12.2c-2.2-8-1.2-16.8 3.2-24.4l0 0c.4-.7 .9-1.5 1.4-2.1l0 0 .1-.2L88.9 265c23.7-35.6 63.7-57 106.5-57h75.2c41.3 0 80.1 20 104.2 53.6l50.7 70.9 0 0 .2 .3c1.5 2 2.7 4.1 3.7 6.3l0 0c1.9 4.4 2.8 9.1 2.7 13.8c-.2 7.1-2.8 14-7.4 19.6zM180 320v41.1c24.9 30.7 59.5 51.9 98 60.2c3.5 .8 7.1 1.4 10.7 2c-.2 1-.3 2-.4 3c-1.9 15.9 4.2 32.4 17.7 43.2c20.7 16.6 50.9 13.2 67.5-7.5l63.3-79.2c7-8.4 10.8-18.8 11.2-29.4c.2-7-1.1-14.1-4-20.8c-1.5-3.3-3.3-6.5-5.5-9.4l-50.7-70.9c-27-37.8-70.7-60.3-117.2-60.3H195.4c-48.1 0-93.1 24.1-119.8 64.1L8.5 356.7c-.7 1-1.4 2.1-2 3.2c-6.6 11.4-8 24.6-4.8 36.6c1.8 6.7 5 12.9 9.6 18.4c3.5 4.1 7.7 7.7 12.6 10.6c1.1 .6 2.2 1.2 3.3 1.7l159.3 79.7c23.7 11.9 52.5 2.2 64.4-21.5s2.2-52.5-21.5-64.4l-87-43.5c-1.6-2.9-2.4-6.2-2.4-9.5V320c0-11 9-20 20-20s20 9 20 20zM160 80a64 64 0 1 1 128 0A64 64 0 1 1 160 80zM272 376a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM224 160A80 80 0 1 0 224 0a80 80 0 1 0 0 160zm16 168a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faGaugeMax = {
    prefix: 'fat',
    iconName: 'gauge-max',
    icon: [
      512,
      512,
      ["tachometer-alt-fastest"],
      'f626',
      
      'M256 496a240 240 0 1 0 0-480 240 240 0 1 0 0 480zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm16 80a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM208 352a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm-16 0c0-35.3 28.7-64 64-64c18.8 0 35.7 8.1 47.4 21l108-75.6c3.6-2.5 8.6-1.7 11.1 2s1.7 8.6-2 11.1l-108 75.6c4.7 8.9 7.4 19.1 7.4 29.9c0 35.3-28.7 64-64 64s-64-28.7-64-64zM384 128a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM96 224a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64-96a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z'
      
    ]
  };

  
    var faTachometerAltFastest = faGaugeMax;
  

  
  

  var faBuildingWheat = {
    prefix: 'fat',
    iconName: 'building-wheat',
    icon: [
      640,
      512,
      [],
      'e4db',
      
      'M336 16c17.7 0 32 14.3 32 32V464c0 17.7-14.3 32-32 32H240V416c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-17.7 0-32-14.3-32-32V48c0-17.7 14.3-32 32-32H336zM224 416v80H160V416c0-17.7 14.3-32 32-32s32 14.3 32 32zM48 512h96 16 64 16 96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48zM80 256v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V256c0-13.3-10.7-24-24-24H104c-13.3 0-24 10.7-24 24zm24-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8V256c0-4.4 3.6-8 8-8zm144-16c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V256c0-13.3-10.7-24-24-24H248zm-8 24c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H248c-4.4 0-8-3.6-8-8V256zM80 128v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V128c0-13.3-10.7-24-24-24H104c-13.3 0-24 10.7-24 24zm24-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8V128c0-4.4 3.6-8 8-8zm144-16c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V128c0-13.3-10.7-24-24-24H248zm-8 24c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H248c-4.4 0-8-3.6-8-8V128zM624 240c0 35.3-28.7 64-64 64H536V288c0-35.3 28.7-64 64-64h24v16zm-96 77.9c2.4 1.4 5.1 2.1 8 2.1h16c-10.1 7.6-18.4 17.6-24 29.1c-5.6-11.5-13.9-21.5-24-29.1l16 0c2.9 0 5.6-.8 8-2.1zM448 304H432c-8.8 0-16 7.2-16 16v16c0 26.2 12.6 49.4 32 64H432c-8.8 0-16 7.2-16 16v16c0 44.2 35.8 80 80 80l24 0c2.9 0 5.6-.8 8-2.1c2.4 1.4 5.1 2.1 8 2.1h24c44.2 0 80-35.8 80-80V416c0-8.8-7.2-16-16-16H608c19.4-14.6 32-37.8 32-64V320c0-8.8-7.2-16-16-16H608c19.4-14.6 32-37.8 32-64V224c0-8.8-7.2-16-16-16H600c-31.7 0-59 18.4-72 45.1c-13-26.7-40.3-45.1-72-45.1H432c-8.8 0-16 7.2-16 16v16c0 26.2 12.6 49.4 32 64zm72-16v16l-24 0c-35.3 0-64-28.7-64-64V224h24c35.3 0 64 28.7 64 64zm104 48c0 35.3-28.7 64-64 64H536V384c0-35.3 28.7-64 64-64h24v16zm-96 77.9c2.4 1.4 5.1 2.1 8 2.1h16c-10.1 7.6-18.4 17.6-24 29.1c-5.6-11.5-13.9-21.5-24-29.1l16 0c2.9 0 5.6-.8 8-2.1zM520 384v16l-24 0c-35.3 0-64-28.7-64-64V320h24c35.3 0 64 28.7 64 64zm104 32v16c0 35.3-28.7 64-64 64H536V480c0-35.3 28.7-64 64-64h24zM520 496l-24 0c-35.3 0-64-28.7-64-64V416h24c35.3 0 64 28.7 64 64v16zm8-464c-4.4 0-8 3.6-8 8V184c0 4.4 3.6 8 8 8s8-3.6 8-8V40c0-4.4-3.6-8-8-8zm80 40c0-4.4-3.6-8-8-8s-8 3.6-8 8v80c0 4.4 3.6 8 8 8s8-3.6 8-8V72zM456 64c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8s8-3.6 8-8V72c0-4.4-3.6-8-8-8z'
      
    ]
  };

  

  
  

  var faCircleE = {
    prefix: 'fat',
    iconName: 'circle-e',
    icon: [
      512,
      512,
      [],
      'e109',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128c-13.3 0-24 10.7-24 24V256 360c0 13.3 10.7 24 24 24H344c4.4 0 8-3.6 8-8s-3.6-8-8-8H184c-4.4 0-8-3.6-8-8V264H304c4.4 0 8-3.6 8-8s-3.6-8-8-8H176V152c0-4.4 3.6-8 8-8H344c4.4 0 8-3.6 8-8s-3.6-8-8-8H184z'
      
    ]
  };

  

  
  

  var faChartPieSimpleCircleCurrency = {
    prefix: 'fat',
    iconName: 'chart-pie-simple-circle-currency',
    icon: [
      640,
      512,
      [],
      'e604',
      
      'M272 240H375.2c-5.3 5-10.3 10.4-15 16H272c-8.8 0-16-7.2-16-16V17.7C256 8.1 263.4 0 273.1 0c116 0 212.7 82.7 234.4 192.4c-3.8-.2-7.6-.4-11.5-.4c-1.7 0-3.3 0-4.9 .1C469.5 91.4 380.1 16 273.1 16c-.1 0-.2 0-.3 0c-.1 0-.2 .1-.3 .2c-.3 .3-.5 .8-.5 1.4V240zm-32 48h99.2c-2.7 5.2-5.1 10.5-7.2 16H224c-8.8 0-16-7.2-16-16V66.7c0-10-8-15.3-14.5-13.9C92.1 74.2 16 164.3 16 272c0 123.7 100.3 224 224 224c40.1 0 77.8-10.6 110.4-29.1c3 4.5 6.3 8.8 9.7 12.9C324.8 500.3 283.8 512 240 512C107.5 512 0 404.5 0 272C0 156.5 81.5 60.1 190.2 37.2c18.1-3.8 33.8 11 33.8 29.5V272v16h16zM496 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 200a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm56.3-11.1l13.4 13.4c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-13.4-13.4C528.6 434.1 513 440 496 440s-32.6-5.9-44.9-15.7l-13.4 13.4c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l13.4-13.4C429.9 400.6 424 385 424 368s5.9-32.6 15.7-44.9l-13.4-13.4c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l13.4 13.4C463.4 301.9 479 296 496 296s32.6 5.9 44.9 15.7l13.4-13.4c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-13.4 13.4C562.1 335.4 568 351 568 368s-5.9 32.6-15.7 44.9z'
      
    ]
  };

  

  
  

  var faLayerMinus = {
    prefix: 'fat',
    iconName: 'layer-minus',
    icon: [
      576,
      512,
      ["layer-group-minus"],
      'f5fe',
      
      'M408 72H520c4.4 0 8 3.6 8 8s-3.6 8-8 8H408c-4.4 0-8-3.6-8-8s3.6-8 8-8zM269.4 132.1c5.8-2.7 12.2-4.1 18.6-4.1s12.8 1.4 18.6 4.1L532.1 237.4C539.4 240.7 544 248 544 256s-4.6 15.3-11.9 18.6L306.6 379.9c-5.8 2.7-12.2 4.1-18.6 4.1s-12.8-1.4-18.6-4.1L43.9 274.6C36.6 271.3 32 264 32 256s4.6-15.3 11.9-18.6L269.4 132.1zM288 144c-4.1 0-8.2 .9-11.9 2.6L50.6 251.9c-1.6 .7-2.6 2.4-2.6 4.1s1 3.4 2.6 4.1L276.1 365.4c3.7 1.7 7.8 2.6 11.9 2.6s8.2-.9 11.9-2.6L525.4 260.1c1.6-.7 2.6-2.4 2.6-4.1s-1-3.4-2.6-4.1L299.9 146.6c-3.7-1.7-7.8-2.6-11.9-2.6zM43.9 365.4l59.4-27.7 18.9 8.8L50.6 379.9c-1.6 .7-2.6 2.4-2.6 4.1s1 3.4 2.6 4.1L276.1 493.4c3.7 1.7 7.8 2.6 11.9 2.6s8.2-.9 11.9-2.6L525.4 388.1c1.6-.7 2.6-2.4 2.6-4.1s-1-3.4-2.6-4.1l-71.5-33.4 18.9-8.8 59.4 27.7C539.4 368.7 544 376 544 384s-4.6 15.3-11.9 18.6L306.6 507.9c-5.8 2.7-12.2 4.1-18.6 4.1s-12.8-1.4-18.6-4.1L43.9 402.6C36.6 399.3 32 392 32 384s4.6-15.3 11.9-18.6z'
      
    ]
  };

  
    var faLayerGroupMinus = faLayerMinus;
  

  
  

  var faLightbulbExclamation = {
    prefix: 'fat',
    iconName: 'lightbulb-exclamation',
    icon: [
      384,
      512,
      [],
      'f671',
      
      'M352 176c0 33.9-10.5 65.3-28.5 91.2c-4.5 6.5-9.5 13.3-14.5 20.2c-12.5 17.2-25.9 35.5-36.3 54.4c-7.4 13.5-11.6 27.8-14 42.2H275c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8l0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0 0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5h16.2c-2.4-14.4-6.6-28.7-14-42.2c-10.4-19-23.7-37.3-36.3-54.4l0 0 0 0c-5-6.9-10-13.7-14.5-20.2C42.5 241.3 32 209.9 32 176C32 87.6 103.6 16 192 16s160 71.6 160 160zM128 432H256c0 35.3-28.7 64-64 64s-64-28.7-64-64zm-16 0c0 44.2 35.8 80 80 80s80-35.8 80-80v-5.3c0-5.9-4.8-10.7-10.7-10.7H122.7c-5.9 0-10.7 4.8-10.7 10.7V432zM192 96c-4.4 0-8 3.6-8 8V264c0 4.4 3.6 8 8 8s8-3.6 8-8V104c0-4.4-3.6-8-8-8zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faMessageArrowUp = {
    prefix: 'fat',
    iconName: 'message-arrow-up',
    icon: [
      512,
      512,
      ["comment-alt-arrow-up"],
      'e1dc',
      
      'M176 416c0-8.8-7.2-16-16-16H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H309.3c-3.5 0-6.8 1.1-9.6 3.2L176 496V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h80 16v16 64c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM264 123.3l74.3 74.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-88-88c-3.1-3.1-8.2-3.1-11.3 0l-88 88c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L248 123.3V296c0 4.4 3.6 8 8 8s8-3.6 8-8V123.3z'
      
    ]
  };

  
    var faCommentAltArrowUp = faMessageArrowUp;
  

  
  

  var faPaperPlaneTop = {
    prefix: 'fat',
    iconName: 'paper-plane-top',
    icon: [
      512,
      512,
      ["paper-plane-alt","send"],
      'e20a',
      
      'M20.4 53c-4.6 4.9-5.7 12.1-2.7 18.1L106.1 248H493.9c-1.7-2.9-4.3-5.3-7.6-6.7l-448-192C32.1 46.6 25 48.1 20.4 53zm85.8 211L17.7 440.8c-3 6-1.9 13.2 2.7 18.1s11.8 6.4 17.9 3.7l6.3 14.7c-12.3 5.3-26.7 2.3-35.9-7.5s-11.3-24.3-5.3-36.3L92.2 256 3.4 78.3c-6-12-3.9-26.5 5.3-36.3s23.5-12.7 35.9-7.5l448 192c11.8 5 19.4 16.6 19.4 29.4s-7.6 24.4-19.4 29.4l-448 192-6.3-14.7 448-192c3.2-1.4 5.9-3.8 7.6-6.7H106.1z'
      
    ]
  };

  
    var faPaperPlaneAlt = faPaperPlaneTop;
  
    var faSend = faPaperPlaneTop;
  

  
  

  var faPersonSeatReclined = {
    prefix: 'fat',
    iconName: 'person-seat-reclined',
    icon: [
      512,
      512,
      [],
      'e21f',
      
      'M241 240c-4.9 0-9.6 2.3-12.6 6.2s-4.1 8.9-2.9 13.7l8 32c1.8 7.1 8.2 12.1 15.5 12.1h69.8c26.7 0 50.6 16.5 59.9 41.5l25.5 68c3 8.1 11.9 12.3 20 9.6l18.7-6.2c8.4-2.8 17.4 1.7 20.2 10.1s-1.7 17.4-10.1 20.2l-48 16c-8.2 2.7-17-1.5-20-9.6l-36.3-96.9c-4.7-12.5-16.6-20.8-30-20.8H224.7v0l-.3 0c-.2 0-.5 0-.7 0l0 0h-.3H217c-22 0-41.2-15-46.6-36.4l-21.1-84.5c-5-19.9 10.1-39.2 30.6-39.2c13.5 0 25.4 8.6 29.8 21.2c2.2 6.5 8.3 10.8 15.1 10.8H320c8.8 0 16 7.2 16 16s-7.2 16-16 16H241zM128 80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM249 288l-4-16-4-16h16.5H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H224.8c-6.6-19-24.5-32-44.9-32c-30.9 0-53.6 29.1-46.1 59l21.1 84.5C162 332 187.6 352 217 352h6.3c.5 0 .9 0 1.4 0h94.1c6.7 0 12.6 4.1 15 10.4L370 459.2c6 16.1 23.8 24.6 40.1 19.1l48-16c16.8-5.6 25.8-23.7 20.2-40.5s-23.7-25.8-40.5-20.2l-18.7 6.2-25.5-68c-11.7-31.2-41.6-51.9-74.9-51.9H249zM208 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM47.8 134.4c-.9-4.3-5.1-7.1-9.4-6.2s-7.1 5.1-6.2 9.4L72.4 333c10 48.3 52.5 83 101.9 83H296c4.4 0 8-3.6 8-8s-3.6-8-8-8H174.2c-41.8 0-77.8-29.4-86.2-70.3L47.8 134.4z'
      
    ]
  };

  

  
  

  var faHourglassClock = {
    prefix: 'fat',
    iconName: 'hourglass-clock',
    icon: [
      576,
      512,
      [],
      'e41b',
      
      'M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8H32V71.2c0 48.3 23 93.7 61.8 122.4L178.5 256 93.8 318.4C55 347 32 392.5 32 440.8V496H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H330.8c-6.9-4.9-13.5-10.2-19.6-16H48V440.8c0-43.2 20.5-83.9 55.3-109.5L192 265.9l71.1 52.4c1.6-5.4 3.4-10.7 5.5-15.8L205.5 256l84.7-62.4C329 165 352 119.5 352 71.2V16h24c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zM336 16V71.2c0 43.2-20.5 83.9-55.3 109.5L192 246.1l-88.7-65.3C68.5 155.1 48 114.4 48 71.2V16H336zm96 224a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-224c-4.4 0-8 3.6-8 8v72c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8s-3.6-8-8-8H440V296c0-4.4-3.6-8-8-8z'
      
    ]
  };

  

  
  

  var faBlenderPhone = {
    prefix: 'fat',
    iconName: 'blender-phone',
    icon: [
      576,
      512,
      [],
      'f6b6',
      
      'M156.5 53.6l.1 0c3.1 2 4.2 5.7 2.9 8.8l-26.9 66.1c-1.2 3-4.4 5.1-8.1 4.7l-31-3c-7.8-.8-15 4.2-17 11.7c-8.9 32.8-8.9 67.4 0 100.2c2 7.5 9.2 12.5 17 11.7l31.1-3c3.7-.4 6.9 1.7 8.1 4.7l26.9 66.1c1.3 3.1 .2 6.8-2.9 8.8l-.1 0L99.8 366.7l0 0c-3.2 2-8 1.5-10.5-1c-97.8-96-97.8-251.5 0-347.5c2.5-2.5 7.3-3.1 10.5-1l0 0 56.6 36.3zM78.1 377.2c7.9 7.8 20.9 9.1 30.3 3.1l56.7-36.4c9.6-6.1 13.4-17.9 9.2-28.3l-26.9-66.1c-3.9-9.7-13.9-15.6-24.5-14.6l-31.1 3c-8.2-30-8.2-61.8 0-91.8l31 3c10.6 1 20.5-4.9 24.5-14.6l26.9-66.1c4.2-10.4 .4-22.2-9.2-28.3L108.4 3.8C99-2.2 86-.9 78.1 6.8C-26 109.1-26 274.9 78.1 377.2zm393.3-24.8c-2.4-.2-4.9-.3-7.4-.3H240c-.9 0-1.7 0-2.6 0L210.8 33.3C210.1 24 217.4 16 226.8 16H535c10.4 0 18 9.8 15.5 19.9L535.5 96H360c-4.4 0-8 3.6-8 8s3.6 8 8 8H531.5l-20 80H360c-4.4 0-8 3.6-8 8s3.6 8 8 8H507.5L471.4 352.3zm15.7 3.1L566.1 39.8C571.1 19.6 555.8 0 535 0H226.8c-18.7 0-33.4 16-31.9 34.7l26.6 319.5c-35.3 8.3-61.5 40-61.5 77.9v32c0 26.5 21.5 48 48 48H496c26.5 0 48-21.5 48-48V432c0-36.1-24-66.7-56.9-76.6zM176 432c0-35.3 28.7-64 64-64H464c35.3 0 64 28.7 64 64v32c0 17.7-14.3 32-32 32H208c-17.7 0-32-14.3-32-32V432zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faUserHairBuns = {
    prefix: 'fat',
    iconName: 'user-hair-buns',
    icon: [
      448,
      512,
      [],
      'e3d3',
      
      'M333.4 104H282.5c-14.9 0-29.1-5.9-39.6-16.4L229.7 74.3c-3.1-3.1-8.2-3.1-11.3 0L205.1 87.6C194.6 98.1 180.3 104 165.5 104H114.6c11-50.3 55.8-88 109.4-88s98.4 37.7 109.4 88zm2.3 16c.2 2.6 .3 5.3 .3 8v16c0 61.9-50.1 112-112 112s-112-50.1-112-112V128c0-2.7 .1-5.4 .3-8h53.2c19.1 0 37.4-7.6 50.9-21.1l7.6-7.6 7.6 7.6c13.5 13.5 31.8 21.1 50.9 21.1h53.2zM224 272c50.7 0 94.5-29.5 115.2-72.2C345.4 214 359.5 224 376 224c22.1 0 40-17.9 40-40V104c0-22.1-17.9-40-40-40c-13.6 0-25.6 6.8-32.8 17.2C324.5 33.6 278.2 0 224 0S123.5 33.6 104.8 81.2C97.6 70.8 85.6 64 72 64c-22.1 0-40 17.9-40 40v80c0 22.1 17.9 40 40 40c16.5 0 30.6-10 36.8-24.2C129.5 242.5 173.3 272 224 272zm128-88V144 128 104c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24zM168 320H280c83.9 0 152 68.1 152 152v8c0 8.8-7.2 16-16 16H32c-8.8 0-16-7.2-16-16v-8c0-83.9 68.1-152 152-152zm0-16C75.2 304 0 379.2 0 472v8c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32v-8c0-92.8-75.2-168-168-168H168zM96 144v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V104c0-13.3 10.7-24 24-24s24 10.7 24 24v24 16z'
      
    ]
  };

  

  
  

  var faHourglassStart = {
    prefix: 'fat',
    iconName: 'hourglass-start',
    icon: [
      384,
      512,
      ["hourglass-1"],
      'f251',
      
      'M0 8C0 3.6 3.6 0 8 0H376c4.4 0 8 3.6 8 8s-3.6 8-8 8H352V71.2c0 48.3-23 93.7-61.8 122.4L205.5 256l84.7 62.4C329 347 352 392.5 352 440.8V496h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H32V440.8c0-48.3 23-93.7 61.8-122.4L178.5 256 93.8 193.6C55 165 32 119.5 32 71.2V16H8c-4.4 0-8-3.6-8-8zm48 8V64H336V16H48zm.3 64c2.6 39.9 22.6 76.8 55 100.7L192 246.1l88.7-65.3c32.4-23.9 52.5-60.8 55-100.7H48.3zm55 251.3C68.5 356.9 48 397.6 48 440.8V496H336V440.8c0-43.2-20.5-83.9-55.3-109.5L192 265.9l-88.7 65.3z'
      
    ]
  };

  
    var faHourglass1 = faHourglassStart;
  

  
  

  var faFamily = {
    prefix: 'fat',
    iconName: 'family',
    icon: [
      512,
      512,
      [],
      'e300',
      
      'M176 64A48 48 0 1 0 80 64a48 48 0 1 0 96 0zM64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM41.8 234.7L37.7 284c-2.3 28 19.8 52 47.8 52H112h32 16v16h-8V480c0 8.8 7.2 16 16 16c2.9 0 5.6-.8 8-2.1V511c-2.6 .7-5.2 1-8 1c-17.7 0-32-14.3-32-32V352H120V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V344.8c-22.1-11.5-36.4-35.4-34.2-62.1l4.1-49.3C29.3 191.9 64 160 105.6 160h44.8c7 0 13.8 .9 20.2 2.6c-1.3 5.1-2.1 10.5-2.5 15.9c-5.7-1.6-11.6-2.5-17.8-2.5H105.6c-33.3 0-61 25.5-63.8 58.7zM344 512c-2.8 0-5.4-.3-8-1V493.9c2.4 1.4 5.1 2.1 8 2.1c8.8 0 16-7.2 16-16V384h-8V368h16 32 48 21.6c10.6 0 18.3-10.2 15.4-20.4L445.9 210.8C440 190.2 421.2 176 399.7 176H368.3c-8.8 0-17.1 2.4-24.3 6.6c-.1-5.8-.7-11.5-1.9-17c8.1-3.6 17-5.6 26.2-5.6h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H456v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H376v96c0 17.7-14.3 32-32 32zM85.6 352c-4.7 0-9.2-.5-13.6-1.4V480c0 8.8 7.2 16 16 16s16-7.2 16-16V352H85.6zM432 64a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM320 64a64 64 0 1 1 128 0A64 64 0 1 1 320 64zM440 384H408v96c0 8.8 7.2 16 16 16s16-7.2 16-16V384zM296 184a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm-96 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm56 88c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V336c0-35.3-28.7-64-64-64zm-80 64c0-44.2 35.8-80 80-80s80 35.8 80 80v32c0 20.9-13.4 38.7-32 45.3V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V416H224v88c0 4.4-3.6 8-8 8s-8-3.6-8-8V413.3c-18.6-6.6-32-24.4-32-45.3V336z'
      
    ]
  };

  

  
  

  var faShopLock = {
    prefix: 'fat',
    iconName: 'shop-lock',
    icon: [
      640,
      512,
      [],
      'e4a5',
      
      'M0 185.8c0-6.4 1.6-12.7 4.7-18.3L82.4 25C90.8 9.6 106.9 0 124.5 0h391c17.6 0 33.7 9.6 42.1 25l77.7 142.4c3.1 5.6 4.7 11.9 4.7 18.3c0 12.4-5.9 23.3-14.9 30.3c-2.7-4.7-5.7-9.1-9-13.3c4.9-4.1 7.9-10.2 7.9-17c0-3.7-.9-7.4-2.7-10.7L543.6 32.7C538 22.4 527.2 16 515.5 16h-391c-11.7 0-22.5 6.4-28.1 16.7L18.7 175.1c-1.8 3.3-2.7 6.9-2.7 10.7C16 198 26 208 38.2 208H72 436.1c-3.5 5-6.6 10.4-9.3 16H80V464c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V256c0-4.4 3.6-8 8-8s8 3.6 8 8V464c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V224H38.2C17.1 224 0 206.9 0 185.8zM136 248c4.4 0 8 3.6 8 8V360c0 4.4 3.6 8 8 8H296c4.4 0 8-3.6 8-8V256c0-4.4 3.6-8 8-8s8 3.6 8 8V360c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24V256c0-4.4 3.6-8 8-8zm392-40c-26.5 0-48 21.5-48 48v64h96V256c0-26.5-21.5-48-48-48zm-64 48c0-35.3 28.7-64 64-64s64 28.7 64 64v64h16c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32h16V256zm-16 80c-8.8 0-16 7.2-16 16V480c0 8.8 7.2 16 16 16H608c8.8 0 16-7.2 16-16V352c0-8.8-7.2-16-16-16H592 576 480 464 448z'
      
    ]
  };

  

  
  

  var faIntersection = {
    prefix: 'fat',
    iconName: 'intersection',
    icon: [
      384,
      512,
      [8898],
      'f668',
      
      'M24 480c4.4 0 8-3.6 8-8V208c0-88.4 71.6-160 160-160s160 71.6 160 160V472c0 4.4 3.6 8 8 8s8-3.6 8-8V208c0-97.2-78.8-176-176-176S16 110.8 16 208V472c0 4.4 3.6 8 8 8z'
      
    ]
  };

  

  
  

  var faVirusCovidSlash = {
    prefix: 'fat',
    iconName: 'virus-covid-slash',
    icon: [
      640,
      512,
      [],
      'e4a9',
      
      'M13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7zM503.8 264H552v32c0 4.4 3.6 8 8 8s8-3.6 8-8V216c0-4.4-3.6-8-8-8s-8 3.6-8 8v32H503.8c-1.9-44.8-19.8-85.4-48.2-116.3l34.1-34.1 0 0 22.6 22.6c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L467.1 52.4c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l22.6 22.6 0 0-34.1 34.1C413.4 92 372.8 74.1 328 72.2V24l32 0c4.4 0 8-3.6 8-8s-3.6-8-8-8H280c-4.4 0-8 3.6-8 8s3.6 8 8 8h32V72.2c-29 1.2-56.3 9.2-80.3 22.4l13.8 10.9C267.9 94.3 293.2 88 320 88c92.8 0 168 75.2 168 168c0 12.9-1.5 25.5-4.2 37.6l13.8 10.9c3.5-13 5.7-26.5 6.3-40.4zM142.4 207.6c-3.5 13-5.7 26.5-6.3 40.4H88l0-32c0-4.4-3.6-8-8-8s-8 3.6-8 8v80c0 4.4 3.6 8 8 8s8-3.6 8-8V264h48.2c1.9 44.8 19.8 85.4 48.2 116.3l-34.1 34.1 0 0-22.6-22.6c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l56.6 56.6c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-22.6-22.6 0 0 34.1-34.1c30.9 28.4 71.5 46.3 116.3 48.2V488H280c-4.4 0-8 3.6-8 8s3.6 8 8 8h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H328V439.8c29-1.2 56.3-9.2 80.3-22.4l-13.8-10.9C372.1 417.7 346.8 424 320 424c-92.8 0-168-75.2-168-168c0-12.9 1.5-25.5 4.2-37.6l-13.8-10.9z'
      
    ]
  };

  

  
  

  var faServer = {
    prefix: 'fat',
    iconName: 'server',
    icon: [
      512,
      512,
      [],
      'f233',
      
      'M64 48C37.5 48 16 69.5 16 96v64c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM64 304c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V352c0-26.5-21.5-48-48-48H64zM0 352c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V352zm336 32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16-272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 272a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16-272a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faBadgeSheriff = {
    prefix: 'fat',
    iconName: 'badge-sheriff',
    icon: [
      448,
      512,
      [],
      'f8a2',
      
      'M224 0c-30.9 0-56 25.1-56 56c0 16.3 7 31 18.1 41.2l-24.7 42.4c-1.4 2.4-4 4-6.9 4l-44.9 .2c-4-13.1-12.8-24.8-25.6-32.2C57.2 96 23 105.2 7.5 132S1.2 193 28 208.5c13.3 7.7 28.4 9.3 42.2 5.7L91.9 252c1.4 2.5 1.4 5.5 0 7.9L70.2 297.8c-13.8-3.6-28.9-2-42.2 5.7C1.2 319-8 353.2 7.5 380S57.2 416 84 400.5c12.8-7.4 21.6-19.1 25.6-32.2l44.9 .2c2.8 0 5.5 1.5 6.9 4l24.7 42.4C175 425 168 439.7 168 456c0 30.9 25.1 56 56 56s56-25.1 56-56c0-16.3-7-31-18.1-41.2l24.7-42.4c1.4-2.4 4-4 6.9-4l44.9-.2c4 13.1 12.8 24.8 25.6 32.2c26.8 15.5 61 6.3 76.5-20.5s6.3-61-20.5-76.5c-13.3-7.7-28.5-9.3-42.2-5.7L356.1 260c-1.4-2.5-1.4-5.5 0-7.9l21.7-37.9c13.8 3.6 28.9 2 42.2-5.7c26.8-15.5 36-49.7 20.5-76.5S390.8 96 364 111.5c-12.8 7.4-21.6 19.1-25.6 32.2l-44.9-.2c-2.8 0-5.5-1.5-6.9-4l-6.9 4 6.9-4L261.9 97.2C273 87 280 72.3 280 56c0-30.9-25.1-56-56-56zM184 56c0-22.1 17.9-40 40-40s40 17.9 40 40c0 13.5-6.7 25.5-17 32.8c-3.4 2.4-4.4 7-2.3 10.6l28.2 48.3c4.3 7.3 12.1 11.9 20.6 11.9l51.2 .2c3.9 0 7.2-2.8 7.9-6.6c2-11.3 8.7-21.6 19.4-27.8c19.1-11 43.6-4.5 54.6 14.6s4.5 43.6-14.6 54.6c-11.1 6.4-23.9 6.9-34.9 2.5c-3.7-1.5-7.9 0-9.9 3.5l-24.9 43.5c-4.2 7.4-4.2 16.5 0 23.8l24.9 43.5c2 3.5 6.2 4.9 9.9 3.5c11-4.4 23.9-3.9 34.9 2.5c19.1 11 25.7 35.5 14.6 54.6s-35.5 25.7-54.6 14.6c-10.7-6.2-17.4-16.5-19.4-27.8c-.7-3.8-4-6.6-7.9-6.6l-51.2 .2c-8.5 0-16.4 4.6-20.6 11.9l-28.2 48.3c-2.1 3.6-1.1 8.2 2.3 10.6c10.3 7.3 17 19.2 17 32.8c0 22.1-17.9 40-40 40s-40-17.9-40-40c0-13.5 6.7-25.5 17-32.8c3.4-2.4 4.4-7 2.3-10.6l-28.1-48.3c-4.3-7.4-12.1-11.9-20.6-11.9l-51.2-.2c-3.9 0-7.2 2.8-7.9 6.6c-2 11.3-8.7 21.6-19.4 27.8c-19.1 11-43.6 4.5-54.6-14.6s-4.5-43.6 14.6-54.6c11.1-6.4 23.9-6.9 34.9-2.5c3.7 1.5 7.9 0 9.9-3.5l24.9-43.5c4.2-7.4 4.2-16.5 0-23.8L80.9 200.6c-2-3.5-6.2-4.9-9.9-3.5c-11 4.4-23.9 3.9-34.9-2.5c-19.1-11-25.7-35.5-14.6-54.6s35.5-25.7 54.6-14.6c10.7 6.2 17.4 16.5 19.4 27.8c.7 3.8 4 6.6 7.9 6.6l51.2-.2c8.5 0 16.4-4.6 20.6-11.9l28.1-48.3c2.1-3.6 1.1-8.2-2.3-10.6c-10.3-7.2-17-19.2-17-32.8zm40 264a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-48-64a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  

  
  

  var faGridRound = {
    prefix: 'fat',
    iconName: 'grid-round',
    icon: [
      448,
      512,
      [],
      'e5da',
      
      'M112 96A48 48 0 1 1 16 96a48 48 0 1 1 96 0zM64 32a64 64 0 1 0 0 128A64 64 0 1 0 64 32zm48 224a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM64 192a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM0 416a64 64 0 1 0 128 0A64 64 0 1 0 0 416zM272 96a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM224 32a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-64 48a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zM272 416a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM384 48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM320 96a64 64 0 1 0 128 0A64 64 0 1 0 320 96zM432 256a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-64 48a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z'
      
    ]
  };

  

  
  

  var faSlidersSimple = {
    prefix: 'fat',
    iconName: 'sliders-simple',
    icon: [
      512,
      512,
      [],
      'e253',
      
      'M80 304a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm79.6 56L504 360c4.4 0 8 3.6 8 8s-3.6 8-8 8l-344.4 0c-4 40.4-38.1 72-79.6 72c-44.2 0-80-35.8-80-80s35.8-80 80-80c41.5 0 75.6 31.6 79.6 72zM368 144a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm-15.6-8c4-40.4 38.1-72 79.6-72c44.2 0 80 35.8 80 80s-35.8 80-80 80c-41.5 0-75.6-31.6-79.6-72L8 152c-4.4 0-8-3.6-8-8s3.6-8 8-8l344.4 0z'
      
    ]
  };

  

  
  

  var faWindTurbine = {
    prefix: 'fat',
    iconName: 'wind-turbine',
    icon: [
      512,
      512,
      [],
      'f89b',
      
      'M301 214.3c-1-6.8 .2-13.8 3.5-19.9L396.9 23.6 244.7 144.2c-5.4 4.3-12.1 6.7-19 6.9L31.6 156.5l180.6 71.5c6.4 2.5 11.9 7.1 15.5 13L329.4 406.5 301 214.3zm44.2 189.8c2.5 17.2-20.3 25.5-29.5 10.7L288 369.7l-16-26-32-52-16-26-10-16.3c-1.8-2.9-4.5-5.2-7.7-6.5L25.7 171.4C9.5 165 13.7 141 31.1 140.6l194.1-5.4c3.5-.1 6.8-1.3 9.5-3.5L387 11c13.6-10.8 32.3 4.8 24 20.1L318.6 202c-1.6 3-2.3 6.5-1.8 9.9l28.4 192.1zM240 352.8V496h32V404.8l16 26V496h88c4.4 0 8 3.6 8 8s-3.6 8-8 8H280 232 136c-4.4 0-8-3.6-8-8s3.6-8 8-8h88V326.8l16 26zM256 184a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faShopSlash = {
    prefix: 'fat',
    iconName: 'shop-slash',
    icon: [
      640,
      512,
      ["store-alt-slash"],
      'e070',
      
      'M4.7 167.4C1.6 173.1 0 179.4 0 185.8C0 206.9 17.1 224 38.2 224H64V464c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V398.3l-16-12.6V464c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V224h83.3L143 208H72 38.2C26 208 16 198 16 185.8c0-3.7 .9-7.4 2.7-10.7l24.9-45.6L30.8 119.5l-26.2 48zM113.5 1.3L132.2 16H515.5c11.7 0 22.5 6.4 28.1 16.7l77.7 142.4c1.8 3.3 2.7 6.9 2.7 10.7c0 12.3-10 22.2-22.2 22.2H568 375.4l20.3 16H560V353.7l16 12.6V224h25.8c21.1 0 38.2-17.1 38.2-38.2c0-6.4-1.6-12.7-4.7-18.3L557.6 25C549.2 9.6 533.1 0 515.5 0h-391c-3.7 0-7.4 .4-11 1.3zM512 315.8V256c0-4.4-3.6-8-8-8s-8 3.6-8 8v47.2l16 12.6zM304 335.1V360c0 4.4-3.6 8-8 8H152c-4.4 0-8-3.6-8-8V256c0-4.4-3.6-8-8-8s-8 3.6-8 8V360c0 13.3 10.7 24 24 24H296c13.3 0 24-10.7 24-24V347.7l-16-12.6zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  
    var faStoreAltSlash = faShopSlash;
  

  
  

  var faSquare6 = {
    prefix: 'fat',
    iconName: 'square-6',
    icon: [
      448,
      512,
      [],
      'e25b',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm270 34.7c2.9 3.3 2.6 8.4-.8 11.3l-58.1 50.8c4.2-.6 8.5-.8 12.8-.8c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96c0-16.6 4.2-32.2 11.6-45.8c5.4-9.9 12.5-19 21.2-26.6L258.7 130c3.3-2.9 8.4-2.6 11.3 .8zM224 368a80 80 0 1 0 .1-160A80 80 0 1 0 224 368z'
      
    ]
  };

  

  
  

  var faPersonSkiLift = {
    prefix: 'fat',
    iconName: 'person-ski-lift',
    icon: [
      512,
      512,
      ["ski-lift"],
      'f7c8',
      
      'M248 0c4.4 0 8 3.6 8 8V198.3l-16 4.3V8c0-4.4 3.6-8 8-8zm24 297.7v134l32-12.2v-153c0-15.8-14.9-27.3-30.2-23.2l-55.9 14.9c-7.6 2-15.5-1.7-18.7-8.8l-28.8-63.4C165.5 175 154.6 168 142.7 168c-22.3 0-37 23.1-27.7 43.3l32.9 71.2c6.5 14.1 22.3 21.5 37.3 17.5l66.7-17.8c4.8-1.3 9.9-.3 13.9 2.8s6.3 7.7 6.3 12.7zm48-31.2v147l145-55.1c18.6-7.1 31-24.9 31-44.9V296c0-4.4 3.6-8 8-8s8 3.6 8 8v17.4c0 26.6-16.4 50.4-41.3 59.8L106.8 511.5c-4.1 1.6-8.8-.5-10.3-4.6s.5-8.8 4.6-10.3L256 437.7V432 314.2 297.7l-16 4.3-50.7 13.5c-22.6 6-46.2-5.1-55.9-26.3L100.4 218c-14.2-30.8 8.3-66 42.2-66c18.2 0 34.8 10.7 42.3 27.3l28.8 63.4 55.9-14.9c25.4-6.8 50.3 12.4 50.3 38.6zM144 80A32 32 0 1 0 80 80a32 32 0 1 0 64 0zM112 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM15.4 164.8L87.1 332.2c11.9 27.7 43.5 41 71.6 30.2l46.5-17.9c4.1-1.6 8.8 .5 10.3 4.6s-.5 8.8-4.6 10.3l-46.5 17.9c-36.1 13.9-76.8-3.3-92-38.8L.6 171.2c-1.7-4.1 .1-8.8 4.2-10.5s8.8 .1 10.5 4.2z'
      
    ]
  };

  
    var faSkiLift = faPersonSkiLift;
  

  
  

  var faNfcLock = {
    prefix: 'fat',
    iconName: 'nfc-lock',
    icon: [
      576,
      512,
      [],
      'e1f8',
      
      'M384 48H64C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H320v16H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64v65.3c-5.5 .9-10.9 2.3-16 4.1V96c0-26.5-21.5-48-48-48zM368 256v34c-5.7 1.5-11 3.7-16 6.5V136c0-4.4-3.6-8-8-8H240c-4.4 0-8 3.6-8 8v80.8c18.3 3.7 32 19.8 32 39.2c0 22.1-17.9 40-40 40s-40-17.9-40-40c0-19.4 13.7-35.5 32-39.2V136c0-13.3 10.7-24 24-24H344c13.3 0 24 10.7 24 24V256zM320 400H104c-13.3 0-24-10.7-24-24V136c0-13.3 10.7-24 24-24h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H104c-4.4 0-8 3.6-8 8V376c0 4.4 3.6 8 8 8H320v16zM224 232a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm240-24c-26.5 0-48 21.5-48 48v64h96V256c0-26.5-21.5-48-48-48zm-64 48c0-35.3 28.7-64 64-64s64 28.7 64 64v64h16c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32h16V256zm-16 80c-8.8 0-16 7.2-16 16V480c0 8.8 7.2 16 16 16H544c8.8 0 16-7.2 16-16V352c0-8.8-7.2-16-16-16H528 512 416 400 384z'
      
    ]
  };

  

  
  

  var faCannon = {
    prefix: 'fat',
    iconName: 'cannon',
    icon: [
      640,
      512,
      [],
      'e642',
      
      'M281.8 450.3c-10.6 6.4-19.3 11.3-25.4 14.5c-56.1 28.1-121.8 16-164.5-25.2c0 0 .1 .1 .1 .1L69.5 450.9c-23.7 11.9-52.5 2.2-64.4-21.5s-2.2-52.5 21.5-64.4l22.5-11.3s0 0 0 0c-7.3-58.9 22.5-118.6 78.5-146.6c49.5-24 287.2-107.9 394.6-145.5c30.3-10.6 63.6 3.1 78 31.8L630.9 155c14.4 28.7 5.3 63.6-21.4 81.5c-23.1 15.5-53.1 35.6-86 57.4c-2.8-4.6-5.8-9-9-13.2c32.9-21.9 63-42 86.1-57.5c19.9-13.4 26.8-39.4 16-61l-30.7-61.4C575 79.1 550.1 68.9 527.4 76.8C473.8 95.6 387.6 126 308.6 154.6c-79.3 28.8-150.1 55.4-174 67C71.5 253.2 45.9 330.1 77.5 393.3s108.4 88.8 171.6 57.3c5.8-3 14.1-7.7 24.2-13.8c2.6 4.7 5.4 9.2 8.4 13.6zM52 369.7c0 .2 .1 .3 .1 .5l-18.4 9.2c-15.8 7.9-22.2 27.1-14.3 42.9s27.1 22.2 42.9 14.3l18.4-9.2s0 0 0 0c-6.7-8.2-12.6-17.2-17.5-27c-5-10-8.7-20.3-11.2-30.7zM496 368a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm-208 0a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm136 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-64 0a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z'
      
    ]
  };

  

  
  

  var faFilesMedical = {
    prefix: 'fat',
    iconName: 'files-medical',
    icon: [
      448,
      512,
      [],
      'f7fd',
      
      'M384 400H192c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H324.1c4.1 0 8.1 .8 11.9 2.3V88c0 13.3 10.7 24 24 24h69.7c1.5 3.7 2.3 7.8 2.3 11.9V352c0 26.5-21.5 48-48 48zM439.1 96c-1.5-2.1-3.2-4.2-5.1-6.1L358.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-35.3 0-64 28.7-64 64V352c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V123.9c0-9.5-2.8-18.7-8-26.5V96h-.9zm-21.7 0H360c-4.4 0-8-3.6-8-8V30.6L417.4 96zM96 96H64C28.7 96 0 124.7 0 160V448c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64H304c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V160c0-26.5 21.5-48 48-48H96V96zm173.3 89.3c0-4.4 3.6-8 8-8h21.3c4.4 0 8 3.6 8 8v44c0 4.4 3.6 8 8 8h44c4.4 0 8 3.6 8 8v21.3c0 4.4-3.6 8-8 8h-44c-4.4 0-8 3.6-8 8v44c0 4.4-3.6 8-8 8H277.3c-4.4 0-8-3.6-8-8v-44c0-4.4-3.6-8-8-8h-44c-4.4 0-8-3.6-8-8V245.3c0-4.4 3.6-8 8-8h44c2.1 0 4.2-.8 5.7-2.3s2.3-3.5 2.3-5.7v-44zm8-24c-13.3 0-24 10.7-24 24v36h-36c-13.3 0-24 10.7-24 24v21.3c0 13.3 10.7 24 24 24h36v36c0 13.3 10.7 24 24 24h21.3c13.3 0 24-10.7 24-24v-36h36c13.3 0 24-10.7 24-24V245.3c0-13.3-10.7-24-24-24h-36v-36c0-13.3-10.7-24-24-24H277.3z'
      
    ]
  };

  

  
  

  var faPegasus = {
    prefix: 'fat',
    iconName: 'pegasus',
    icon: [
      576,
      512,
      [],
      'f703',
      
      'M448 16c-66.3 0-120 53.7-120 120c0 2.4-1.1 4.6-2.8 6.1c-1.4 1.2-3.2 1.9-5.2 1.9h-3.2c-1.3 0-2.6-.3-3.8-.9L144.3 53.4c3.3 81.1 36.4 127.2 68.7 153.3c17.2 13.9 34.4 22.2 47.3 27.1c6.4 2.4 11.8 4 15.5 5c1.8 .5 3.3 .8 4.2 1c.5 .1 .8 .2 1 .2l.2 0 0 0 0 0c4.4 .7 7.3 4.8 6.6 9.2s-4.8 7.3-9.2 6.6L280 248c-1.3 7.9-1.3 7.9-1.3 7.9l0 0 0 0-.1 0-.4-.1c-.3-.1-.8-.2-1.4-.3c-1.2-.2-2.8-.6-4.9-1.2c-4.2-1.1-10.1-2.8-17.2-5.5c-14.1-5.4-32.9-14.5-51.7-29.6c-21-16.9-41.7-41-56-75.2c-2.1-5.1-4.1-10.4-6-16c-8.1-24.5-13-53.6-13-88c0-2.8 1.5-5.4 3.9-6.9s5.4-1.5 7.9-.2l172.7 91.7C318.2 54.8 376.7 0 448 0h8 16 21.8H552c4.4 0 8 3.6 8 8s-3.6 8-8 8H539.1c14.6 11.8 24.5 29.2 26.4 49.2l7 73.8c2.4 25.1-10.9 49.1-33.5 60.4c-30.2 15.1-66.8 2.9-81.9-27.3L451.1 160H448v79.5 .5l0 .2c-.2 28.8-12.7 54.2-32 71.9V480c0 17.7-14.3 32-32 32H344c-17.7 0-32-14.3-32-32V332.1L206.7 309c.9 6.2 1.3 12.5 1.3 18.8c0 18.3-3.7 36.4-10.9 53.2l-6.5 15.3c-2.2 5-2.5 10.6-1.1 15.9L206 471.4c5.7 20.4-9.7 40.6-30.8 40.6H125.3c-14.4 0-27-9.6-30.8-23.4L81.6 442.1c-8.3-29.8-6.2-61.5 6-90l6.5-15.3c1.2-2.9 1.9-5.9 1.9-9c0-3-.6-6-1.8-8.8L62.4 242.5c-4.2-10.1-6.4-20.9-6.4-31.8c0-12.4 2.7-24.1 7.6-34.7C37.3 176.2 16 197.6 16 224v88c0 4.4-3.6 8-8 8s-8-3.6-8-8V224c0-35.3 28.7-64 64-64h8 1.3c9.2-11.8 21.6-21.1 35.8-26.6c1.6 5.2 3.3 10.3 5.2 15.1C89.6 158.3 72 182.4 72 210.7c0 8.8 1.7 17.5 5.1 25.6L109 312.8c2 4.7 3 9.8 3 15c0 5.3-1.1 10.5-3.2 15.3l-6.5 15.3c-10.8 25.1-12.6 53.1-5.3 79.4l12.9 46.5c1.9 6.9 8.2 11.7 15.4 11.7h49.8c10.6 0 18.2-10.1 15.4-20.3l-16.5-59.3c-2.4-8.8-1.8-18.1 1.8-26.5l6.5-15.3c6.3-14.8 9.6-30.7 9.6-46.9c0-9.2-1.1-18.4-3.2-27.4c-.6-2.7 .2-5.5 2.1-7.5s4.7-2.8 7.4-2.2l123.4 27.1c3.7 .8 6.3 4.1 6.3 7.8V480c0 8.8 7.2 16 16 16h40c8.8 0 16-7.2 16-16V308.5c0-2.4 1-4.6 2.8-6.1c17.6-14.9 29-37.1 29.2-62.5l0-.1v-.4V152c0-4.4 3.6-8 8-8h16c3 0 5.8 1.7 7.2 4.4l8.3 16.5c11.1 22.3 38.2 31.3 60.5 20.2c16.7-8.3 26.5-26 24.7-44.6l-7-73.8C546.8 37.9 522.7 16 493.8 16H472 456h-8zm48 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faArrowRightToBracket = {
    prefix: 'fat',
    iconName: 'arrow-right-to-bracket',
    icon: [
      512,
      512,
      ["sign-in"],
      'f090',
      
      'M213.7 114.3l136 136c3.1 3.1 3.1 8.2 0 11.3l-136 136c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L324.7 264 8 264c-4.4 0-8-3.6-8-8s3.6-8 8-8l316.7 0L202.3 125.7c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0zM328 464l96 0c39.8 0 72-32.2 72-72l0-272c0-39.8-32.2-72-72-72l-96 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l96 0c48.6 0 88 39.4 88 88l0 272c0 48.6-39.4 88-88 88l-96 0c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  
    var faSignIn = faArrowRightToBracket;
  

  
  

  var faComputerMouse = {
    prefix: 'fat',
    iconName: 'computer-mouse',
    icon: [
      384,
      512,
      [128433,"mouse"],
      'f8cc',
      
      'M16 192H184V16H160C80.5 16 16 80.5 16 160v32zM184 0h8 8 24c88.4 0 160 71.6 160 160v32 8 8V352c0 88.4-71.6 160-160 160H160C71.6 512 0 440.4 0 352V208v-8-8V160C0 71.6 71.6 0 160 0h24zM16 208V352c0 79.5 64.5 144 144 144h64c79.5 0 144-64.5 144-144V208H192 16zm352-16V160c0-79.5-64.5-144-144-144H200V192H368z'
      
    ]
  };

  
    var faMouse = faComputerMouse;
  

  
  

  var faCalendarStar = {
    prefix: 'fat',
    iconName: 'calendar-star',
    icon: [
      448,
      512,
      [],
      'f736',
      
      'M128 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H64C28.7 64 0 92.7 0 128v48 16V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 176 128c0-35.3-28.7-64-64-64H336V8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H128V8zM16 192H432V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V192zM112 80v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80H320v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80h48c26.5 0 48 21.5 48 48v48H16V128c0-26.5 21.5-48 48-48h48zM238.3 251c-5.9-11.9-22.8-11.9-28.7 0l-23.9 48.4-53.4 7.8c-13.1 1.9-18.4 18-8.9 27.3l38.6 37.7L153 425.3c-2.2 13.1 11.5 23 23.2 16.9L224 417l47.8 25.1c11.7 6.2 25.5-3.8 23.2-16.9l-9.1-53.2 38.6-37.7c9.5-9.3 4.3-25.4-8.9-27.3l-53.4-7.8L238.3 251zM224 258.1l25.7 52.2 1.9 3.8 4.2 .6 57.6 8.4-41.7 40.6-3 2.9 .7 4.1 9.8 57.3-51.5-27.1-3.7-2-3.7 2L168.8 428l9.8-57.3 .7-4.1-3-2.9L134.7 323l57.6-8.4 4.2-.6 1.9-3.8L224 258.1z'
      
    ]
  };

  

  
  

  var faPersonToPortal = {
    prefix: 'fat',
    iconName: 'person-to-portal',
    icon: [
      512,
      512,
      ["portal-enter"],
      'e022',
      
      'M172.2 148.1c4.2 1.2 7.7 4.1 9.8 7.9s2.4 8.4 1 12.5L152.8 259c-7 21 1.3 44.1 20.1 55.9l86.2 53.9c6 3.8 8.9 11.1 6.9 18l-25.4 88.8c-2.4 8.5 2.5 17.4 11 19.8s17.4-2.5 19.8-11l25.4-88.8c5.9-20.6-2.6-42.6-20.7-53.9l-47.9-30c-6.5-4.1-9.2-12.2-6.4-19.4l30-77.3c2.3-5.9 7.8-9.9 14.2-10.2s12.2 3.2 15.1 8.8l15.9 31.7c8.1 16.3 24.8 26.5 42.9 26.5H384c8.8 0 16-7.2 16-16s-7.2-16-16-16H339.8c-6.1 0-11.6-3.4-14.3-8.8l-32.9-65.7c-6-12-16.8-21-29.7-24.7l-90.7-25.9c-6.6-1.9-13.4-2.8-20.3-2.8c-19.6 0-38.3 7.8-52.1 21.6L68.7 164.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l31.1-31.1c7.8-7.8 18.4-12.2 29.5-12.2c3.9 0 7.7 .5 11.5 1.6l8.8 2.5zM57.4 153.4l31.1-31.1C105.3 105.5 128.1 96 151.9 96c8.3 0 16.6 1.2 24.7 3.5l90.7 25.9c17.2 4.9 31.6 16.9 39.7 32.9L339.8 224H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H339.8c-24.2 0-46.4-13.7-57.2-35.4l-6.2-12.4-9.7-19.3L258.8 241l-22.2 57.1 47.9 30c24.2 15.1 35.5 44.4 27.6 71.9l-25.4 88.8c-4.9 17-22.6 26.8-39.6 22s-26.8-22.6-22-39.6l25.4-88.8-86.2-53.9c-25.1-15.7-36.1-46.5-26.8-74.5l25.1-75.3 5.1-15.2L159 161c-2.2-.6-4.6-1-6.9-1l-.2 0c-6.8 0-13.4 2.7-18.2 7.5l-31.1 31.1c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3zM272 80a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM224 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM111.3 314.8c2.9 6.2 6.4 12.1 10.6 17.6l-9.2 25.2L108.8 368H97.6 32c-8.8 0-16 7.2-16 16s7.2 16 16 16H97.6c20.1 0 38.1-12.6 45.1-31.5l4.7-12.9 0 0 13.9 8.7-3.6 9.7c-9.2 25.2-33.2 42-60.1 42H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H97.6l13.7-37.2zM473.5 449.6C459.8 487.7 443.8 496 432 496s-27.8-8.3-41.5-46.4c-10.2-28.4-17.8-70.4-20.9-129.6h-16c7.3 140.7 39.7 192 78.4 192c44.2 0 80-66.6 80-256S476.2 0 432 0c-38.8 0-71.1 51.3-78.4 192h16c3.1-59.2 10.7-101.2 20.9-129.6C404.2 24.3 420.2 16 432 16s27.8 8.3 41.5 46.4C487.1 100.1 496 161.9 496 256s-8.9 155.9-22.5 193.6z'
      
    ]
  };

  
    var faPortalEnter = faPersonToPortal;
  

  
  

  var faSlash = {
    prefix: 'fat',
    iconName: 'slash',
    icon: [
      640,
      512,
      [],
      'f715',
      
      'M1.7 3C4.5-.4 9.5-1 13 1.7l624 496c3.5 2.7 4 7.8 1.3 11.2s-7.8 4-11.2 1.3L3 14.3C-.4 11.5-1 6.5 1.7 3z'
      
    ]
  };

  

  
  

  var faLasso = {
    prefix: 'fat',
    iconName: 'lasso',
    icon: [
      576,
      512,
      [],
      'f8c8',
      
      'M576 176c0 97.2-128.9 176-288 176c-30.4 0-59.6-2.9-87.1-8.2C220.4 361.9 232 387.6 232 415c0 53.6-43.4 97-97 97H40c-4.4 0-8-3.6-8-8s3.6-8 8-8h95c44.7 0 81-36.3 81-81c0-30.7-17.3-58.7-44.8-72.4l-30.7-15.4C56.4 296.5 0 240.3 0 176C0 78.8 128.9 0 288 0S576 78.8 576 176zM288 336c150.2 0 272-71.6 272-160S438.2 16 288 16S16 87.6 16 176s121.8 160 272 160z'
      
    ]
  };

  

  
  

  var faCircleQuarterStroke = {
    prefix: 'fat',
    iconName: 'circle-quarter-stroke',
    icon: [
      512,
      512,
      [],
      'e5d3',
      
      'M496 256C496 123.5 388.5 16 256 16V200c0 22.1-17.9 40-40 40H16.5c-.3 5.3-.5 10.6-.5 16c0 132.5 107.5 240 240 240s240-107.5 240-240zM240 16.5C125.6 24.1 33.1 111.8 18.1 224H216c13.3 0 24-10.7 24-24V16.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  

  
  

  var faLocationXmark = {
    prefix: 'fat',
    iconName: 'location-xmark',
    icon: [
      384,
      512,
      ["map-marker-times","map-marker-xmark"],
      'f60e',
      
      'M368 192c0-97.2-78.8-176-176-176S16 94.8 16 192c0 18.7 6.4 42.5 17.8 69.6c11.3 26.9 27.1 55.8 44.7 84.3c35.2 57 76.8 111.4 102.3 143.2c5.9 7.3 16.6 7.3 22.4 0c25.5-31.8 67.1-86.2 102.3-143.2c17.6-28.5 33.4-57.4 44.7-84.3C361.6 234.5 368 210.7 368 192zm16 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM114.3 114.3c3.1-3.1 8.2-3.1 11.3 0L192 180.7l66.3-66.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L203.3 192l66.3 66.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L192 203.3l-66.3 66.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L180.7 192l-66.3-66.3c-3.1-3.1-3.1-8.2 0-11.3z'
      
    ]
  };

  
    var faMapMarkerTimes = faLocationXmark;
  
    var faMapMarkerXmark = faLocationXmark;
  

  
  

  var faSpellCheck = {
    prefix: 'fat',
    iconName: 'spell-check',
    icon: [
      576,
      512,
      [],
      'f891',
      
      'M119.3 4.8C118.1 1.9 115.2 0 112 0s-6.1 1.9-7.3 4.8L.7 244.8c-1.8 4.1 .1 8.8 4.2 10.5s8.8-.1 10.5-4.2L48 175.8v.2H176v-.2l32.7 75.4c1.8 4.1 6.5 5.9 10.5 4.2s5.9-6.5 4.2-10.5l-104-240zM169.1 160H54.9L112 28.1 169.1 160zM256 16V120 240c0 8.8 7.2 16 16 16H376c39.8 0 72-32.2 72-72c0-34.2-23.8-62.8-55.8-70.2C406.7 102.1 416 84.1 416 64c0-35.3-28.7-64-64-64H272c-8.8 0-16 7.2-16 16zm96 96H272V16h80c26.5 0 48 21.5 48 48s-21.5 48-48 48zm-80 16h80 24c30.9 0 56 25.1 56 56s-25.1 56-56 56H272V128zM565.7 301.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L351.8 492.9 237.5 386.2c-3.2-3-8.3-2.8-11.3 .4s-2.8 8.3 .4 11.3l120 112c3.2 2.9 8.1 2.9 11.1-.2l208-208z'
      
    ]
  };

  

  
  

  var faCoffinCross = {
    prefix: 'fat',
    iconName: 'coffin-cross',
    icon: [
      384,
      512,
      [],
      'e051',
      
      'M23.5 125.4c-4.8 5.5-7.5 12.7-7.5 20c0 2.9 .4 5.7 1.2 8.4l95.5 330.6c2 6.8 8.2 11.6 15.4 11.6H255.9c7.1 0 13.4-4.7 15.4-11.6l95.5-330.6c.8-2.7 1.2-5.6 1.2-8.4c0-7.4-2.7-14.5-7.5-20l-91-104c-3-3.5-7.4-5.5-12-5.5h-131c-4.6 0-9 2-12 5.5l-91 104zm-12-10.5l91-104C108.5 4 117.3 0 126.5 0h131c9.2 0 18 4 24.1 10.9l91 104c7.4 8.5 11.5 19.3 11.5 30.6c0 4.4-.6 8.7-1.8 12.9L286.7 488.9c-4 13.7-16.5 23.1-30.7 23.1H128.1c-14.3 0-26.8-9.4-30.7-23.1L1.8 158.3C.6 154.1 0 149.8 0 145.4c0-11.2 4.1-22.1 11.5-30.6zM200 104v72h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H200V344c0 4.4-3.6 8-8 8s-8-3.6-8-8V192H104c-4.4 0-8-3.6-8-8s3.6-8 8-8h80V104c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faGoalNet = {
    prefix: 'fat',
    iconName: 'goal-net',
    icon: [
      640,
      512,
      [],
      'e3ab',
      
      'M16 104c0-30.9 25.1-56 56-56H568c30.9 0 56 25.1 56 56V472c0 4.4 3.6 8 8 8s8-3.6 8-8V104c0-39.8-32.2-72-72-72H72C32.2 32 0 64.2 0 104V472c0 4.4 3.6 8 8 8s8-3.6 8-8V104zm136-8c-4.4 0-8 3.6-8 8v56H72c-4.4 0-8 3.6-8 8s3.6 8 8 8h72v96H72c-4.4 0-8 3.6-8 8s3.6 8 8 8h72v96H72c-4.4 0-8 3.6-8 8s3.6 8 8 8h72v72c0 4.4 3.6 8 8 8s8-3.6 8-8V400h96v72c0 4.4 3.6 8 8 8s8-3.6 8-8V400h96v72c0 4.4 3.6 8 8 8s8-3.6 8-8V400h96v72c0 4.4 3.6 8 8 8s8-3.6 8-8V400h72c4.4 0 8-3.6 8-8s-3.6-8-8-8H496V288h72c4.4 0 8-3.6 8-8s-3.6-8-8-8H496V176h72c4.4 0 8-3.6 8-8s-3.6-8-8-8H496V104c0-4.4-3.6-8-8-8s-8 3.6-8 8v56H384V104c0-4.4-3.6-8-8-8s-8 3.6-8 8v56H272V104c0-4.4-3.6-8-8-8s-8 3.6-8 8v56H160V104c0-4.4-3.6-8-8-8zm8 80h96v96H160V176zm112 0h96v96H272V176zm112 0h96v96H384V176zM160 384V288h96v96H160zm112 0V288h96v96H272zm112 0V288h96v96H384z'
      
    ]
  };

  

  
  

  var faXRay = {
    prefix: 'fat',
    iconName: 'x-ray',
    icon: [
      512,
      512,
      [],
      'f497',
      
      'M0 40c0-4.4 3.6-8 8-8H40 472h32c4.4 0 8 3.6 8 8s-3.6 8-8 8H480V464h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H472 40 8c-4.4 0-8-3.6-8-8s3.6-8 8-8H32V48H8c-4.4 0-8-3.6-8-8zm48 8V464H464V48H48zM256 96c4.4 0 8 3.6 8 8v40h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H264v48H376c4.4 0 8 3.6 8 8s-3.6 8-8 8H264v80c0 .5-.1 1.1-.2 1.6l.1 0L328.7 283c5.7-2 11.6-3 17.6-3c29.6 0 53.6 24 53.6 53.6v3.1c0 12.7-4.3 25-12.1 35L371 393.3c-11.2 14.3-28.4 22.7-46.6 22.7H187.6c-18.2 0-35.4-8.4-46.6-22.7l-16.9-21.5c-7.8-10-12.1-22.3-12.1-35v-3.1c0-29.6 24-53.6 53.6-53.6c6 0 12 1 17.6 3l64.8 22.6 .1 0c-.1-.5-.2-1-.2-1.6V224H144c-4.4 0-8-3.6-8-8s3.6-8 8-8H248V160H176c-4.4 0-8-3.6-8-8s3.6-8 8-8h72V104c0-4.4 3.6-8 8-8zM128 333.6v3.1c0 9.1 3.1 18 8.7 25.2l16.9 21.5c8.2 10.4 20.7 16.5 34 16.5H324.4c13.3 0 25.8-6.1 34-16.5l16.9-21.5c5.6-7.2 8.7-16 8.7-25.2v-3.1c0-20.8-16.8-37.6-37.6-37.6c-4.2 0-8.4 .7-12.4 2.1l-64.8 22.6c-8.5 3-17.8 3-26.3 0L178 298.1c-4-1.4-8.2-2.1-12.4-2.1c-20.8 0-37.6 16.8-37.6 37.6zM192 352a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm112-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faArrowDownFromBracket = {
    prefix: 'fat',
    iconName: 'arrow-down-from-bracket',
    icon: [
      448,
      512,
      [],
      'e667',
      
      'M229.7 509.7c-3.1 3.1-8.2 3.1-11.3 0l-136-136c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L216 484.7 216 168c0-4.4 3.6-8 8-8s8 3.6 8 8l0 316.7L354.3 362.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-136 136zM16 184c0 4.4-3.6 8-8 8s-8-3.6-8-8L0 88C0 39.4 39.4 0 88 0L360 0c48.6 0 88 39.4 88 88l0 96c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-96c0-39.8-32.2-72-72-72L88 16C48.2 16 16 48.2 16 88l0 96z'
      
    ]
  };

  

  
  

  var faDiagramVenn = {
    prefix: 'fat',
    iconName: 'diagram-venn',
    icon: [
      640,
      512,
      [],
      'e15a',
      
      'M224 464C109.1 464 16 370.9 16 256S109.1 48 224 48c27.6 0 53.9 5.4 78 15.1c-65.9 39-110 110.8-110 192.9s44.2 153.9 110 192.9c-24.1 9.8-50.4 15.1-78 15.1zM431.8 248H208.2c1-25.4 6.5-49.7 15.8-72H416.1c9.3 22.3 14.8 46.6 15.8 72zM416 336.1V336H224v.1c-9.3-22.3-14.9-46.7-15.8-72.1H431.8c-1 25.5-6.5 49.8-15.8 72.1zM408.6 352c-19.7 37.8-50.7 68.8-88.6 88.6c-37.8-19.7-68.8-50.7-88.6-88.6H408.6zM231.4 160c19.7-37.8 50.7-68.8 88.6-88.6c37.8 19.7 68.8 50.7 88.6 88.6H231.4zM224 480c34.4 0 66.9-7.7 96-21.6c29.1 13.8 61.6 21.6 96 21.6c123.7 0 224-100.3 224-224S539.7 32 416 32c-34.4 0-66.9 7.7-96 21.6C290.9 39.7 258.4 32 224 32C100.3 32 0 132.3 0 256S100.3 480 224 480zM416 48c114.9 0 208 93.1 208 208s-93.1 208-208 208c-27.6 0-53.9-5.4-78-15.1c65.9-39 110-110.8 110-192.9s-44.2-153.9-110-192.9C362.1 53.4 388.4 48 416 48z'
      
    ]
  };

  

  
  

  var faFileLock = {
    prefix: 'fat',
    iconName: 'file-lock',
    icon: [
      576,
      512,
      [],
      'e3a6',
      
      'M64 496H320c.7 0 1.3 0 2 0c1.4 5.5 3.5 10.7 6.3 15.5c-2.7 .3-5.5 .5-8.3 .5H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H204.1c12.7 0 24.9 5.1 33.9 14.1L369.9 145.9c8.1 8.1 13 18.7 13.9 30.1H367.8 320 248c-22.1 0-40-17.9-40-40V16.2c-1.3-.2-2.6-.2-3.9-.2H64C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48zM358.6 157.3L226.7 25.4c-.9-.9-1.8-1.7-2.7-2.4V136c0 13.3 10.7 24 24 24H361.1c-.8-1-1.6-1.9-2.4-2.7zM464 208c-26.5 0-48 21.5-48 48v64h96V256c0-26.5-21.5-48-48-48zm-64 48c0-35.3 28.7-64 64-64s64 28.7 64 64v64h16c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32h16V256zm-16 80c-8.8 0-16 7.2-16 16V480c0 8.8 7.2 16 16 16H544c8.8 0 16-7.2 16-16V352c0-8.8-7.2-16-16-16H528 512 416 400 384z'
      
    ]
  };

  

  
  

  var faEar = {
    prefix: 'fat',
    iconName: 'ear',
    icon: [
      384,
      512,
      [128066],
      'f5f0',
      
      'M368 192c0-97.2-78.8-176-176-176S16 94.8 16 192V368c0 70.7 57.3 128 128 128s128-57.3 128-128c0-11.1 5.6-21.7 15.2-27.9c48.7-31.3 80.8-86 80.8-148.1zm16 0c0 67.8-35.1 127.4-88.2 161.5c-4.9 3.2-7.8 8.6-7.8 14.5c0 79.5-64.5 144-144 144S0 447.5 0 368V192C0 86 86 0 192 0S384 86 384 192zM80 192v14.3c0 13.4 6.7 25.9 17.8 33.3l8.9 5.9c13.3 8.9 21.3 23.8 21.3 39.8c0 14.2-6.3 27.7-17.2 36.8L77.1 350.1c-3.4 2.8-8.4 2.4-11.3-1s-2.4-8.4 1-11.3l33.7-28c7.3-6.1 11.5-15 11.5-24.5c0-10.7-5.3-20.6-14.2-26.5l-8.9-5.9C73.4 242.5 64 225 64 206.3V192c0-70.7 57.3-128 128-128s128 57.3 128 128v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-61.9-50.1-112-112-112S80 130.1 80 192z'
      
    ]
  };

  

  
  

  var faPlaneCircleExclamation = {
    prefix: 'fat',
    iconName: 'plane-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e556',
      
      'M256 0c-19.8 0-35.8 16.2-46.3 33.3C199 50.8 192 72.6 192 89.2l0 86.8 0 1.3L20.7 271.9C7.9 278.9 0 292.3 0 306.9V355c0 15.9 15.1 27.4 30.4 23.1L192 333.5V352l0 44-54.4 40.8c-6 4.5-9.6 11.6-9.6 19.2v34.1c0 12.1 9.8 21.9 21.9 21.9c2.2 0 4.4-.3 6.4-1L256 480.4 355.6 511c2.1 .6 4.3 1 6.4 1c2 0 4-.3 5.9-.8l0-21.1c0 3.3-2.6 5.9-5.9 5.9c-.6 0-1.2-.1-1.7-.3l-2.4 7.6 2.4-7.6-102-31.4c-1.5-.5-3.2-.5-4.7 0l-102 31.4c-.6 .2-1.1 .3-1.7 .3c-3.3 0-5.9-2.6-5.9-5.9V456c0-2.5 1.2-4.9 3.2-6.4l57.6-43.2c2-1.5 3.2-3.9 3.2-6.4l0-48V323l0-141 0-6.1 0-86.8c0-13 5.7-31.9 15.3-47.5C233.2 25.6 245.1 16 256 16c11.3 0 23.2 9.6 33 25.6c9.5 15.6 15 34.5 15 47.5l0 86.8 0 6.1 0 0V323v29l0 48c0 2.5 1.2 4.9 3.2 6.4l32.3 24.2c-3.2-8.3-5.7-16.9-7.6-25.7L320 396l0-44 0-18.5 10.8 3c1-5.3 2.1-10.5 3.6-15.6l-14.4-4V195.6l69.8 38.5c4.4-3.8 9-7.3 13.8-10.7L320 177.3l0-1.3 0-86.8c0-16.6-6.7-38.3-17.3-55.8C292.3 16.2 276.2 0 256 0zM28.4 285.9L192 195.6V316.9L26.1 362.7C21 364.1 16 360.3 16 355V306.9c0-8.7 4.8-16.8 12.4-21zM368 368a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 448a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-168c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8s8-3.6 8-8V288c0-4.4-3.6-8-8-8z'
      
    ]
  };

  

  
  

  var faWindow = {
    prefix: 'fat',
    iconName: 'window',
    icon: [
      512,
      512,
      [],
      'f40e',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm112-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faFaceAstonished = {
    prefix: 'fat',
    iconName: 'face-astonished',
    icon: [
      512,
      512,
      [],
      'e36b',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm304 96c0-26.5-21.5-48-48-48s-48 21.5-48 48v32c0 26.5 21.5 48 48 48s48-21.5 48-48V352zm-112 0c0-35.3 28.7-64 64-64s64 28.7 64 64v32c0 35.3-28.7 64-64 64s-64-28.7-64-64V352zM160.4 224a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM200 119.5c.3 4.4-3.1 8.2-7.5 8.5c-32.5 2-61.6 16.5-82.7 38.7c-3 3.2-8.1 3.3-11.3 .3s-3.3-8.1-.3-11.3c23.7-25.1 56.6-41.4 93.3-43.7c4.4-.3 8.2 3.1 8.5 7.5zM319.5 128c-4.4-.3-7.8-4.1-7.5-8.5s4.1-7.8 8.5-7.5c36.7 2.3 69.6 18.6 93.3 43.7c3 3.2 2.9 8.3-.3 11.3s-8.3 2.9-11.3-.3C381.1 144.5 352 130 319.5 128z'
      
    ]
  };

  

  
  

  var faPipeSmoking = {
    prefix: 'fat',
    iconName: 'pipe-smoking',
    icon: [
      640,
      512,
      [],
      'e3c4',
      
      'M573.8 0C524 0 477 23.2 446.7 62.8L270.4 293.6c-4.6 6.1-14.4 2.8-14.4-4.9V264c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40v96c0 83.9 68.1 152 152 152h9.8c51.5 0 99.5-26.1 127.5-69.3L509 104.1c16.2-25 44-40.1 73.8-40.1H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H573.8zM459.4 72.6C486.6 36.9 528.9 16 573.8 16H608c8.8 0 16 7.2 16 16s-7.2 16-16 16H582.8c-35.2 0-68.1 17.8-87.2 47.4L410.8 226.1l-43.7-32.8L459.4 72.6zM357.4 206l44.7 33.5L275.9 434c-25.1 38.7-68 62-114.1 62H152C76.9 496 16 435.1 16 360V264c0-13.3 10.7-24 24-24H216c13.3 0 24 10.7 24 24v24.7c0 23 29.1 32.8 43.1 14.6L357.4 206z'
      
    ]
  };

  

  
  

  var faFileInvoiceDollar = {
    prefix: 'fat',
    iconName: 'file-invoice-dollar',
    icon: [
      384,
      512,
      [],
      'f571',
      
      'M64 496c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm0 72c0 4.4 3.6 8 8 8h96c4.4 0 8-3.6 8-8s-3.6-8-8-8H72c-4.4 0-8 3.6-8 8zm0 64c0 4.4 3.6 8 8 8h96c4.4 0 8-3.6 8-8s-3.6-8-8-8H72c-4.4 0-8 3.6-8 8zM192 242.7c-4.4 0-8 3.6-8 8v13.7c-8.3 .6-16 2.3-22.7 5c-12.1 4.9-22.1 13.6-24.5 26.2c-1.5 7.6-.6 14.4 2.6 20.4c3.1 5.8 8 10.1 13.4 13.3c10 6 23.5 9.6 35.7 12.9l1.7 .4c13.4 3.6 25.1 6.9 33 12c3.8 2.4 6.2 5 7.5 7.7c1.3 2.6 1.9 6 .9 11c-1.3 6.6-6 11.8-14.8 15.2c-9 3.4-21.4 4.5-35.8 2.5c-7.2-1-19.4-4.7-28.9-7.6c-2.1-.6-4-1.2-5.7-1.7c-4.2-1.3-8.7 1.2-9.9 5.4s1.2 8.7 5.4 9.9c1.4 .4 3.1 .9 5 1.5c9.4 2.9 23.3 7.1 31.9 8.3l0 0c1.8 .2 3.6 .5 5.3 .6v13.9c0 4.4 3.6 8 8 8s8-3.6 8-8l0-13.5c8.2-.4 15.8-1.9 22.4-4.4c12.4-4.7 22.2-13.6 24.8-27.1c1.5-7.8 .8-14.9-2.3-21.1c-3-6.1-7.8-10.6-13.2-14.1c-10.4-6.7-24.8-10.6-37.5-14l-.3-.1c-13.4-3.6-25-6.7-33-11.5c-3.9-2.3-6.2-4.7-7.5-7.1c-1.2-2.3-1.9-5.3-1-9.8c1-5.4 5.6-10.8 14.8-14.5c9.1-3.7 21.7-5.1 35.9-3.2c4.6 .6 18.6 3.1 23 4.1c4.3 1 8.6-1.6 9.6-5.9s-1.6-8.6-5.9-9.6c-5.1-1.2-19.7-3.7-24.5-4.4c-1.8-.2-3.6-.5-5.3-.6V250.7c0-4.4-3.6-8-8-8z'
      
    ]
  };

  

  
  

  var faScalpelLineDashed = {
    prefix: 'fat',
    iconName: 'scalpel-line-dashed',
    icon: [
      576,
      512,
      ["scalpel-path"],
      'f61e',
      
      'M441.4 16c-16.1 0-31.4 7.1-41.7 19.4L200 272H332.6c9.4 0 18.4-4.2 24.5-11.4L482.2 112.4c8.9-10.6 13.8-24 13.8-37.8v-4C496 40.5 471.5 16 441.4 16zM185.5 278.7c-2.6-5.6-1.7-12.3 2.3-17.1L387.4 25.1C400.8 9.2 420.6 0 441.4 0c39 0 70.6 31.6 70.6 70.6v4c0 17.6-6.2 34.6-17.6 48.1L369.3 271c-9.1 10.8-22.5 17-36.7 17H200c-6.2 0-11.9-3.6-14.5-9.3zM176.1 320h22.3L28.5 494.4c30.8-3.6 87.1-14 141-36.8c63.8-27 121.4-70 132.5-137.6h16.2C307 397.3 241.7 444.5 175.8 472.4C103 503.1 25.9 512 8 512c-3.2 0-6.1-1.9-7.4-4.9s-.6-6.4 1.6-8.7L176.1 320zM232 496h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H232c-4.4 0-8-3.6-8-8s3.6-8 8-8zm128 0h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H360c-4.4 0-8-3.6-8-8s3.6-8 8-8zm128 0h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H488c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  
    var faScalpelPath = faScalpelLineDashed;
  

  
  

  var faHandsBound = {
    prefix: 'fat',
    iconName: 'hands-bound',
    icon: [
      640,
      512,
      [],
      'e4f9',
      
      'M272 368V352v-8V258.1c0-20.7-7.6-40.7-21.4-56.2L204 149.4c-5.8-6.5-15.6-7.2-22.3-1.6s-7.6 15.5-2.2 22.2l27.6 34.5c13.1 16.4 8.7 40.6-9.4 51.3c-15.2 8.9-34.6 5.1-45.2-9L83.2 154.4 80 150.1v-5.3V96 32c0-8.8-7.2-16-16-16s-16 7.2-16 16V96v59.1 .7V192v21.9c0 10.4 3.7 20.4 10.5 28.3L161.6 362.4c1.5 1.7 3.3 3.1 5.3 4l3.3 1.5H272zm16-16v16h64V352v-8V258.1c0-24.6 9-48.4 25.4-66.8l46.7-52.5c11.5-13 31.3-14.4 44.5-3.2s15.2 30.9 4.4 44.5l-27.6 34.5c-7 8.8-4.7 21.8 5.1 27.5c8.1 4.8 18.6 2.7 24.2-4.8L544 144.8V96 32c0-17.7 14.3-32 32-32s32 14.3 32 32V96v59.1 .7V192v21.9c0 14.2-5.1 27.9-14.3 38.7L494.7 368H512c4.4 0 8 3.6 8 8s-3.6 8-8 8H480 464 368 352 288 272 176 160 128c-4.4 0-8-3.6-8-8s3.6-8 8-8h17.3l-99-115.5C37.1 241.8 32 228 32 213.9V192 155.8v-.7V96 32C32 14.3 46.3 0 64 0S96 14.3 96 32V96v48.8l69.3 92.4c5.7 7.6 16.1 9.6 24.2 4.8c9.7-5.7 12.1-18.7 5.1-27.5L167 180c-10.8-13.5-8.9-33.3 4.4-44.5s33-9.8 44.5 3.2l46.7 52.5C279 209.7 288 233.4 288 258.1V344v8zm181.9 16l3.3-1.5c2-1 3.8-2.3 5.3-4L581.5 242.1c6.7-7.9 10.5-17.9 10.5-28.3V192 155.8v-.7V96 32c0-8.8-7.2-16-16-16s-16 7.2-16 16V96v48.8 5.3l-3.2 4.3-69.3 92.4c-10.6 14.1-30 18-45.2 9c-18.1-10.7-22.6-34.9-9.4-51.3L460.5 170c5.4-6.8 4.5-16.6-2.2-22.2s-16.5-4.9-22.3 1.6l-46.7 52.5c-13.8 15.5-21.4 35.5-21.4 56.2V344v8 16H469.9zM176 464v24c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V464h16v24c0 13.3-10.7 24-24 24H184c-13.3 0-24-10.7-24-24V464h16zm176 0h16v24c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V464h16v24c0 13.3-10.7 24-24 24H376c-13.3 0-24-10.7-24-24V464zM128 416H512c4.4 0 8 3.6 8 8s-3.6 8-8 8H128c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faClockThree = {
    prefix: 'fat',
    iconName: 'clock-three',
    icon: [
      512,
      512,
      [],
      'e356',
      
      'M496 256A240 240 0 1 1 16 256a240 240 0 1 1 480 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM248 104V256c0 4.4 3.6 8 8 8H376c4.4 0 8-3.6 8-8s-3.6-8-8-8H264V104c0-4.4-3.6-8-8-8s-8 3.6-8 8z'
      
    ]
  };

  

  
  

  var faSpider = {
    prefix: 'fat',
    iconName: 'spider',
    icon: [
      512,
      512,
      [128375],
      'f717',
      
      'M372.4 .8c-4 2-5.6 6.8-3.6 10.7l46.4 92.8c4.4 8.7 3 19.2-3.4 26.5L328 226.7V144c0-27.4-15.3-51.2-37.9-63.4c-1.9-1-4.1-1.2-6.1-.6s-3.7 2-4.7 3.9L256 127.1 232.7 83.8c-1-1.9-2.7-3.3-4.7-3.9s-4.2-.4-6.1 .6C199.3 92.7 184 116.6 184 144v82.7l-83.8-95.8c-6.4-7.3-7.8-17.8-3.4-26.5l46.4-92.8c2-4 .4-8.8-3.6-10.7s-8.8-.4-10.7 3.6L82.5 97.2c-7.3 14.5-5 32 5.7 44.2l83.1 94.9L50.8 204.7c-7.8-2.1-14.1-7.9-16.7-15.6L15.6 133.5c-1.4-4.2-5.9-6.5-10.1-5.1s-6.5 5.9-5.1 10.1l18.5 55.6c4.3 12.8 14.7 22.6 27.8 26L167.8 252 46.7 283.9c-13.1 3.4-23.5 13.2-27.8 26L.4 365.5c-1.4 4.2 .9 8.7 5.1 10.1s8.7-.9 10.1-5.1L34.1 315c2.6-7.7 8.8-13.6 16.7-15.6l103.1-27.1L83.7 365.8c-7.9 10.5-10.1 24.2-5.9 36.6l34.7 104.1c1.4 4.2 5.9 6.5 10.1 5.1s6.5-5.9 5.1-10.1L92.9 397.4c-2.5-7.5-1.2-15.7 3.6-22l50.2-66.9c-1.7 7.5-2.6 15.3-2.6 23.3v8.3C144 400 194.5 448 256 448s112-48 112-107.8v-8.3c0-8-.9-15.8-2.6-23.3l50.2 66.9c4.7 6.3 6.1 14.5 3.6 22L384.4 501.5c-1.4 4.2 .9 8.7 5.1 10.1s8.7-.9 10.1-5.1l34.7-104.1c4.2-12.5 1.9-26.1-5.9-36.6l-70.2-93.6 103.1 27.1c7.8 2.1 14.1 7.9 16.7 15.6l18.5 55.6c1.4 4.2 5.9 6.5 10.1 5.1s6.5-5.9 5.1-10.1l-18.5-55.6c-4.3-12.8-14.7-22.6-27.8-26L344.2 252l121.1-31.9c13.1-3.4 23.5-13.2 27.8-26l18.5-55.6c1.4-4.2-.9-8.7-5.1-10.1s-8.7 .9-10.1 5.1L477.9 189c-2.6 7.7-8.8 13.6-16.7 15.6L340.8 236.4l83.1-94.9c10.7-12.2 12.9-29.7 5.7-44.2L383.2 4.4c-2-4-6.8-5.6-10.7-3.6zM222.7 99L249 147.8c1.4 2.6 4.1 4.2 7 4.2s5.6-1.6 7-4.2L289.3 99c13.8 10.2 22.7 26.6 22.7 45V253.1c0 2.5 1.2 4.9 3.2 6.4c22.5 16.9 36.8 43 36.8 72.3v8.3c0 50.4-42.7 91.8-96 91.8s-96-41.4-96-91.8v-8.3c0-29.3 14.3-55.4 36.8-72.3c2-1.5 3.2-3.9 3.2-6.4V144c0-18.4 8.9-34.8 22.7-45z'
      
    ]
  };

  

  
  

  var faBracketCurlyRight = {
    prefix: 'fat',
    iconName: 'bracket-curly-right',
    icon: [
      256,
      512,
      [],
      '7d',
      
      'M192 88c0-30.9-25.1-56-56-56H56c-4.4 0-8 3.6-8 8s3.6 8 8 8h80c22.1 0 40 17.9 40 40v77.5c0 19.1 7.6 37.4 21.1 50.9L236.7 256l-39.6 39.6c-13.5 13.5-21.1 31.8-21.1 50.9V424c0 22.1-17.9 40-40 40H56c-4.4 0-8 3.6-8 8s3.6 8 8 8h80c30.9 0 56-25.1 56-56V346.5c0-14.9 5.9-29.1 16.4-39.6l45.3-45.3c3.1-3.1 3.1-8.2 0-11.3l-45.3-45.3c-10.5-10.5-16.4-24.7-16.4-39.6V88z'
      
    ]
  };

  

  
  

  var faFileDashedLine = {
    prefix: 'fat',
    iconName: 'file-dashed-line',
    icon: [
      640,
      512,
      ["page-break"],
      'f877',
      
      'M448 496H192c-26.5 0-48-21.5-48-48V352H128v96c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V352H496v96c0 26.5-21.5 48-48 48zm48-316.1V240h16V179.9c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-35.3 0-64 28.7-64 64V240h16V64c0-26.5 21.5-48 48-48H332.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H495.8c.2 1.3 .2 2.6 .2 3.9zM489.1 160H376c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L486.6 157.3c.9 .9 1.7 1.8 2.4 2.7zM40 288c-4.4 0-8 3.6-8 8s3.6 8 8 8H184c4.4 0 8-3.6 8-8s-3.6-8-8-8H40zm224 0c-4.4 0-8 3.6-8 8s3.6 8 8 8H376c4.4 0 8-3.6 8-8s-3.6-8-8-8H264zm192 0c-4.4 0-8 3.6-8 8s3.6 8 8 8H600c4.4 0 8-3.6 8-8s-3.6-8-8-8H456z'
      
    ]
  };

  
    var faPageBreak = faFileDashedLine;
  

  
  

  var faArrowUpFromSquare = {
    prefix: 'fat',
    iconName: 'arrow-up-from-square',
    icon: [
      512,
      512,
      [],
      'e09c',
      
      'M261.7 2.3c-3.1-3.1-8.2-3.1-11.3 0l-112 112c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L248 27.3V328c0 4.4 3.6 8 8 8s8-3.6 8-8V27.3l98.3 98.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-112-112zM56 32C25.1 32 0 57.1 0 88V456c0 30.9 25.1 56 56 56H456c30.9 0 56-25.1 56-56V88c0-30.9-25.1-56-56-56H408c-4.4 0-8 3.6-8 8s3.6 8 8 8h48c22.1 0 40 17.9 40 40V456c0 22.1-17.9 40-40 40H56c-22.1 0-40-17.9-40-40V88c0-22.1 17.9-40 40-40h48c4.4 0 8-3.6 8-8s-3.6-8-8-8H56z'
      
    ]
  };

  

  
  

  var faBinBottlesRecycle = {
    prefix: 'fat',
    iconName: 'bin-bottles-recycle',
    icon: [
      640,
      512,
      [],
      'e5f6',
      
      'M384 24v8h16V24c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v8h16V24c0-13.3-10.7-24-24-24H408c-13.3 0-24 10.7-24 24zM352 192c0-53-43-96-96-96H128c-53 0-96 43-96 96H48c0-44.2 35.8-80 80-80H256c44.2 0 80 35.8 80 80h16zm223.1 0c-1.2-9.7-4.6-18.7-9.6-26.5c6.4-9.5 10.1-21 10.1-33.3c0-23.2-13.4-44.3-34.5-54.2L528 71.8c-11-5.1-23-7.8-35.1-7.8H402.3c-12.1 0-24.1 2.7-35.1 7.8L354.1 78c-7.2 3.4-13.5 8-18.6 13.6c4.2 3.3 8.2 6.9 11.9 10.7c3.8-4.1 8.3-7.4 13.5-9.9L374 86.3c8.9-4.1 18.5-6.3 28.3-6.3h90.6c9.8 0 19.4 2.2 28.3 6.3l13.2 6.2c15.4 7.2 25.2 22.7 25.2 39.7c0 9.1-2.7 17.4-7.4 24.4c-3.6 5.3-3.6 12.2-.2 17.6c3.4 5.3 5.8 11.4 6.9 17.9h16.2zM47.2 224H32 8c-4.4 0-8 3.6-8 8s3.6 8 8 8H33.8L56.1 440.8c4.5 40.5 38.7 71.2 79.5 71.2H504.4c40.8 0 75-30.6 79.5-71.2L606.2 240H632c4.4 0 8-3.6 8-8s-3.6-8-8-8H608 592.8h-.9H48.1h-.9zm2.7 16H590.1L568 439.1c-3.6 32.4-31 56.9-63.6 56.9H135.6c-32.6 0-60-24.5-63.6-56.9L49.9 240zM320 304c7.3 0 14 3.7 17.9 9.8l16.2 25.5c2.4 3.7 7.3 4.8 11 2.5c3.8-2.4 4.9-7.3 2.5-11.1l-16.2-25.5C344.5 294.5 332.7 288 320 288c-12.7 0-24.5 6.4-31.3 17.1l-15.4 24c-2.4 3.8-1.3 8.7 2.5 11.1c3.7 2.3 8.6 1.2 11-2.5l15.4-24c3.9-6.1 10.6-9.7 17.9-9.7zm-61.7 63c-3.7-2.3-8.6-1.2-11 2.5l-18.1 28.1c-3.4 5.3-5.2 11.4-5.2 17.7c0 18.1 14.7 32.7 32.7 32.7h41c4.4 0 8-3.6 8-8s-3.6-8-8-8h-41c-9.2 0-16.7-7.5-16.7-16.7c0-3.2 .9-6.3 2.7-9l18.1-28.1c2.4-3.8 1.3-8.7-2.5-11.1zm79.5 73c0 4.4 3.6 8 8 8h36.8c18.1 0 32.8-14.7 32.8-32.8c0-6.2-1.8-12.3-5.1-17.6l-16.8-26.4c-2.4-3.7-7.3-4.8-11-2.5c-3.8 2.4-4.9 7.3-2.5 11.1l16.8 26.4c1.7 2.7 2.6 5.8 2.6 9c0 9.3-7.5 16.8-16.8 16.8H345.7c-4.4 0-8 3.6-8 8zM144 32c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V56c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8s-3.6-8-8-8h-8V32c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32V48h-8c-4.4 0-8 3.6-8 8s3.6 8 8 8h16c4.4 0 8-3.6 8-8V32z'
      
    ]
  };

  

  
  

  var faGripLinesVertical = {
    prefix: 'fat',
    iconName: 'grip-lines-vertical',
    icon: [
      192,
      512,
      [],
      'f7a5',
      
      'M32 32c-4.4 0-8 3.6-8 8l0 432c0 4.4 3.6 8 8 8s8-3.6 8-8L40 40c0-4.4-3.6-8-8-8zm128 0c-4.4 0-8 3.6-8 8l0 432c0 4.4 3.6 8 8 8s8-3.6 8-8l0-432c0-4.4-3.6-8-8-8z'
      
    ]
  };

  

  
  

  var faMobileRetro = {
    prefix: 'fat',
    iconName: 'mobile-retro',
    icon: [
      320,
      512,
      [],
      'e527',
      
      'M240 16c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H240zM80 0C44.7 0 16 28.7 16 64V448c0 35.3 28.7 64 64 64H240c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H80zM224 144c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16H224zM96 128c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96zM72 328a8 8 0 1 1 16 0 8 8 0 1 1 -16 0zm32 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM80 400a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm0 32a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72-104a8 8 0 1 1 16 0 8 8 0 1 1 -16 0zm32 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-24 72a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm0 32a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72-104a8 8 0 1 1 16 0 8 8 0 1 1 -16 0zm32 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-24 72a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm0 32a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM104 64c-4.4 0-8 3.6-8 8s3.6 8 8 8H216c4.4 0 8-3.6 8-8s-3.6-8-8-8H104z'
      
    ]
  };

  

  
  

  var faPersonRunning = {
    prefix: 'fat',
    iconName: 'person-running',
    icon: [
      448,
      512,
      [127939,"running"],
      'f70c',
      
      'M181.9 156c-2-3.9-5.6-6.7-9.8-7.9l-8.8-2.5c-3.7-1.1-7.6-1.6-11.5-1.6c-11.1 0-21.7 4.4-29.5 12.2L91.3 187.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l31.1-31.1c13.8-13.8 32.6-21.6 52.1-21.6c6.9 0 13.7 1 20.3 2.8l90.7 25.9c12.9 3.7 23.7 12.7 29.7 24.7l32.9 65.7c2.7 5.4 8.2 8.8 14.3 8.8H384c8.8 0 16 7.2 16 16s-7.2 16-16 16H339.8c-18.2 0-34.8-10.3-42.9-26.5L281 213.7c-2.8-5.7-8.7-9.1-15.1-8.8s-11.9 4.3-14.2 10.2l-30 77.3c-2.8 7.2-.1 15.3 6.4 19.4l47.9 30c18.1 11.3 26.6 33.3 20.7 53.9l-25.4 88.8c-2.4 8.5-11.3 13.4-19.8 11s-13.4-11.3-11-19.8L266 386.8c2-6.9-.9-14.2-6.9-18l-86.2-53.9c-18.8-11.8-27.1-34.8-20.1-55.9l30.2-90.5c1.4-4.1 1-8.7-1-12.5zM88.5 122.3L57.4 153.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l31.1-31.1c4.8-4.8 11.4-7.5 18.2-7.5l.2 0c2.3 0 4.7 .3 6.9 1l8.8 2.5-5.1 15.2L137.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-25.4 88.8c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22L312.2 400c7.8-27.4-3.4-56.7-27.6-71.9l-47.9-30L258.8 241l7.8-20.1 9.7 19.3 6.2 12.4c10.8 21.7 33 35.4 57.2 35.4H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H339.8l-32.9-65.7c-8-16-22.4-28-39.7-32.9L176.6 99.5c-8-2.3-16.3-3.5-24.7-3.5c-23.8 0-46.6 9.5-63.5 26.3zM240 48a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM97.6 352H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H97.6c26.8 0 50.8-16.8 60.1-42l3.6-9.7-13.9-8.7 0 0-4.7 12.9c-6.9 18.9-24.9 31.5-45.1 31.5H32c-8.8 0-16-7.2-16-16s7.2-16 16-16H97.6h11.2l3.8-10.5 9.2-25.2c-4.2-5.5-7.7-11.4-10.6-17.6L97.6 352z'
      
    ]
  };

  
    var faRunning = faPersonRunning;
  

  
  

  var faShuffle = {
    prefix: 'fat',
    iconName: 'shuffle',
    icon: [
      512,
      512,
      [128256,"random"],
      'f074',
      
      'M410.3 466.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l88-88c3.1-3.1 3.1-8.2 0-11.3l-88-88c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L484.7 376H344c-12.6 0-24.4-5.9-32-16L144 136c-7.6-10.1-19.4-16-32-16H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H112c7.6 0 14.7 3.6 19.2 9.6l168 224C309.8 383.7 326.4 392 344 392H484.7l-74.3 74.3zM144 376l60-80-10-13.3-62.8 83.7c-4.5 6-11.6 9.6-19.2 9.6H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H112c12.6 0 24.4-5.9 32-16zM254 229.3L312 152c7.6-10.1 19.4-16 32-16H484.7l-74.3 74.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l88-88c3.1-3.1 3.1-8.2 0-11.3l-88-88c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L484.7 120H344c-17.6 0-34.2 8.3-44.8 22.4L244 216l10 13.3z'
      
    ]
  };

  
    var faRandom = faShuffle;
  

  
  

  var faPeanuts = {
    prefix: 'fat',
    iconName: 'peanuts',
    icon: [
      640,
      512,
      [129372],
      'e431',
      
      'M314.5 117.8c-1.5-7.3-3.8-14.5-7-21.6L284.8 45.3C273.6 20.1 244.1 8.8 219 20L168.1 42.7c-13.1 5.8-24.4 14-33.7 23.8l0 0c-9.2 9.7-16.8 21.4-21.9 34.7l-.2 .4 0 0c-5.1 13.3-7.3 27-6.9 40.4l0 0c.2 7.4 1.2 14.8 3 22.1l.1 .2 0 0c4.7 20.6 8 45.5-1.1 69.1s-28.2 39.9-45.5 52.1l-.2 .1 0 0c-6.2 4.3-11.9 9.1-17 14.4l0 0c-9.3 9.8-16.8 21.5-22 34.9c-5.1 13.4-7.4 27.2-7 40.6l0 0c.3 13.5 3.3 27.1 9.1 40.2l22.7 50.9c11.2 25.2 40.7 36.5 65.9 25.3l0 0c2.9 4.5 6.1 8.8 9.6 12.9l-3.2 1.4c-33.1 14.7-71.8-.2-86.6-33.2L10.5 422.2C3.8 407.2 .4 391.5 0 376c-.4-15.5 2.2-31.3 8-46.6C14 314 22.7 300.5 33.4 289.3c5.8-6.1 12.3-11.7 19.5-16.6c16.7-11.8 32.5-25.8 39.8-44.9s5-40.1 .4-60c-2.1-8.4-3.2-17-3.4-25.4c-.4-15.4 2.1-31.1 7.9-46.4l.2-.5c5.9-15.3 14.5-28.7 25.2-39.9c10.7-11.2 23.6-20.6 38.7-27.3L212.6 5.7c33.1-14.7 71.8 .1 86.6 33.2l22.5 50.6c-2.9 8.4-5.1 17.1-6.7 26c-.2 .8-.3 1.6-.5 2.3zM252.3 234.1l0 0c-9.3 1.7-18.2 4.3-26.7 7.9l0 0c-15.6 6.4-30.2 16-42.9 28.7c-12.7 12.7-22.2 27.3-28.6 42.8l0 0c-6.4 15.5-10 32.6-10 50.5v68c0 35.3 28.7 64 64 64h68c36.8 0 70.1-15.1 94.1-39.4l0 0c12.3-12.5 21.6-26.8 27.9-42.1l0 0c3.5-8.5 6.2-17.5 7.9-26.8l0-.2 0 0c5-25.2 13.5-53.8 34.6-74.9s49.7-29.7 74.9-34.6l.2 0 0 0c9.3-1.7 18.2-4.3 26.7-7.9l0 0c15.6-6.4 30.2-16 42.9-28.7c12.7-12.7 22.2-27.3 28.6-42.8l0 0c6.4-15.5 10-32.6 10-50.5V80c0-35.3-28.7-64-64-64H492c-36.8 0-70.1 15.1-94.1 39.4l0 0C385.6 67.9 376.3 82.3 370 97.5l0 0c-3.5 8.5-6.2 17.5-7.9 26.8l0 .2 0 0c-5 25.2-13.5 53.8-34.6 74.9s-49.7 29.7-74.9 34.6l-.2 0zm-113 73.2c7.2-17.5 17.9-33.8 32.1-48c14.2-14.2 30.6-24.9 48.1-32.1c9.5-4 19.6-6.9 30-8.8c24.5-4.8 49.1-12.6 66.7-30.3s25.4-42.2 30.3-66.7c1.9-10.4 4.9-20.5 8.8-30c7.1-17.1 17.5-33.2 31.3-47.2C413.3 16.9 450.7 0 492 0h68c44.2 0 80 35.8 80 80v68c0 20.1-4 39.2-11.2 56.7c-7.2 17.5-17.9 33.8-32.1 48c-14.2 14.2-30.6 24.9-48.1 32.1c-9.5 4-19.6 6.9-30 8.8c-24.5 4.8-49.1 12.6-66.7 30.3s-25.4 42.2-30.3 66.7c-1.9 10.4-4.9 20.5-8.8 30c-7.1 17.1-17.5 33.2-31.3 47.2C354.7 495.1 317.3 512 276 512H208c-44.2 0-80-35.8-80-80V364c0-20.1 4-39.2 11.2-56.7zM544 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-64 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM320 336a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-80 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM528 192a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faTransporter1 = {
    prefix: 'fat',
    iconName: 'transporter-1',
    icon: [
      512,
      512,
      [],
      'e043',
      
      'M256 16l-.4 0c-.3 0-.6 0-.9 0c-17 .7-30.6 14.8-30.6 32c0 17.7 14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32zm0 80h0c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48zm216 40v32h32c4.4 0 8 3.6 8 8s-3.6 8-8 8H472v32c0 4.4-3.6 8-8 8s-8-3.6-8-8V184H424c-4.4 0-8-3.6-8-8s3.6-8 8-8h32V136c0-4.4 3.6-8 8-8s8 3.6 8 8zM56 328v32H88c4.4 0 8 3.6 8 8s-3.6 8-8 8H56v32c0 4.4-3.6 8-8 8s-8-3.6-8-8V376H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H40V328c0-4.4 3.6-8 8-8s8 3.6 8 8zm56 168v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-26.5 21.5-48 48-48H368c26.5 0 48 21.5 48 48v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-17.7-14.3-32-32-32H144c-17.7 0-32 14.3-32 32zM235.6 144c-24.3 0-47.2 11-62.4 30l-57.7 72c-5.5 6.9-4.4 17 2.5 22.5s17 4.4 22.5-2.5l45.3-56.5c2.1-2.7 5.7-3.7 8.9-2.5s5.3 4.2 5.3 7.5V288H184V237.3L153 276c-6.3 7.8-15.4 11.9-24.7 12h-.5c-6.9-.1-13.9-2.4-19.7-7c-13.8-11.1-16-31.2-5-45l57.7-72c18.2-22.7 45.8-36 74.9-36h40.7c29.1 0 56.7 13.2 74.9 36L409 236c11 13.8 8.8 33.9-5 45c-5.8 4.7-12.8 7-19.7 7h-.5c-9.3-.1-18.5-4.2-24.7-12l-31-38.7V288H312V214.5c0-3.4 2.1-6.4 5.3-7.5s6.8-.1 8.9 2.5L371.5 266c5.5 6.9 15.6 8 22.5 2.5s8-15.6 2.5-22.5l-57.7-72c-15.2-18.9-38.1-30-62.4-30H235.6zM160 392c0-4.4 3.6-8 8-8H344c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-4.4 0-8-3.6-8-8zm8-72H344c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faArrowUpLeft = {
    prefix: 'fat',
    iconName: 'arrow-up-left',
    icon: [
      384,
      512,
      [],
      'e09d',
      
      'M40 96c-4.4 0-8 3.6-8 8V344c0 4.4 3.6 8 8 8s8-3.6 8-8V123.3L338.3 413.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L59.3 112H280c4.4 0 8-3.6 8-8s-3.6-8-8-8H40z'
      
    ]
  };

  

  
  

  var faSquarePhoneHangup = {
    prefix: 'fat',
    iconName: 'square-phone-hangup',
    icon: [
      448,
      512,
      ["phone-square-down"],
      'e27a',
      
      'M384 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H384zm64 48c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM75.7 240.8c81.8-75.8 214.8-75.8 296.6 0c4.1 3.8 4.8 9.3 2.1 13.7l-21.7 35.2c-3.2 5.1-10.4 7.7-17 5.2l-46.2-17.6c-5.7-2.2-8.5-7.2-8-11.9l2.9-26.7c.4-3.8-1.9-7.3-5.5-8.5c-35.4-11.4-74.1-11.4-109.4 0c-3.6 1.2-5.9 4.7-5.5 8.5l2.9 26.7c.5 4.8-2.4 9.8-8 11.9L112.4 295c-6.6 2.5-13.9-.1-17-5.2L73.6 254.6c-2.7-4.4-2-10 2.1-13.7zm307.5-11.7c-88-81.5-230.4-81.5-318.3 0c-9.5 8.8-11.7 22.8-4.8 33.9l21.7 35.2c7.5 12.1 23.1 16.8 36.4 11.8l46.2-17.6c11.8-4.5 19.6-16 18.2-28.6l-2.2-20c28.4-7.9 58.8-7.9 87.2 0l-2.2 20c-1.4 12.7 6.4 24.1 18.2 28.6L329.9 310c13.3 5.1 28.9 .4 36.4-11.8L388 263c6.9-11.1 4.7-25.1-4.8-33.9z'
      
    ]
  };

  
    var faPhoneSquareDown = faSquarePhoneHangup;
  

  
  

  var faShieldSlash = {
    prefix: 'fat',
    iconName: 'shield-slash',
    icon: [
      640,
      512,
      [],
      'e24b',
      
      'M13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7zM424.9 430.5c-23.8 22.4-52 42.2-85.4 58.2c-12.3 5.9-26.7 5.9-39 0C153.3 418.2 106 271.3 97.5 172.1l-17-13.4c5.3 101.9 51.1 266.9 213.1 344.5c16.7 8 36.1 8 52.8 0c35.8-17.1 65.9-38.5 91.2-62.6l-12.7-10zM295 7.8L182.4 55.6l14.3 11.3L301.3 22.6c12-5.1 25.5-5.1 37.5 0l176.7 75c16.6 7.1 28.6 23.2 28.5 42.4c-.2 46.1-9.4 109.7-36.8 172.2l13 10.2C550 256 559.8 188.2 560 140c.1-26.2-16.3-47.9-38.3-57.2L345 7.8c-16-6.8-34-6.8-50 0z'
      
    ]
  };

  

  
  

  var faCircleU = {
    prefix: 'fat',
    iconName: 'circle-u',
    icon: [
      512,
      512,
      [],
      'e127',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 152c0-4.4-3.6-8-8-8s-8 3.6-8 8V288c0 61.9 50.1 112 112 112s112-50.1 112-112V152c0-4.4-3.6-8-8-8s-8 3.6-8 8V288c0 53-43 96-96 96s-96-43-96-96V152z'
      
    ]
  };

  

  
  

  var faGaugeSimpleMax = {
    prefix: 'fat',
    iconName: 'gauge-simple-max',
    icon: [
      512,
      512,
      ["tachometer-fastest"],
      'f62b',
      
      'M256 496a240 240 0 1 0 0-480 240 240 0 1 0 0 480zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm0 400a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 16c-35.3 0-64-28.7-64-64s28.7-64 64-64c18.8 0 35.7 8.1 47.4 21l108-75.6c3.6-2.5 8.6-1.7 11.1 2s1.7 8.6-2 11.1l-108 75.6c4.7 8.9 7.4 19.1 7.4 29.9c0 35.3-28.7 64-64 64z'
      
    ]
  };

  
    var faTachometerFastest = faGaugeSimpleMax;
  

  
  

  var faPlaneTail = {
    prefix: 'fat',
    iconName: 'plane-tail',
    icon: [
      512,
      512,
      [],
      'e22c',
      
      'M39.4 16h62.1c14.9 0 29.1 5.9 39.6 16.4L364.7 256H264.1c-6.1 0-12.1 .8-18 2.3L70.4 303.6 16 44.9C12.8 30 24.2 16 39.4 16zM.3 48.2L54.9 307.6l-4.3 1.1C20.8 316.4 0 343.3 0 374c0 28.5 18 54 44.9 63.5l198.1 70.3c7.7 2.7 15.9 4.1 24.1 4.1H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H267c-6.4 0-12.7-1.1-18.7-3.2L50.2 422.5C29.7 415.2 16 395.8 16 374c0-23.4 15.9-43.9 38.6-49.8l195.6-50.5c4.6-1.2 9.3-1.8 14-1.8H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H387.3l-5.7-5.7L152.4 21.1C138.9 7.6 120.6 0 101.5 0H39.4C14 0-4.9 23.4 .3 48.2zM200 368c-4.4 0-8 3.6-8 8s3.6 8 8 8H376c4.4 0 8-3.6 8-8s-3.6-8-8-8H200z'
      
    ]
  };

  

  
  

  var faShapes = {
    prefix: 'fat',
    iconName: 'shapes',
    icon: [
      512,
      512,
      ["triangle-circle-square"],
      'f61f',
      
      'M301.7 23.8c-2.9-4.8-8.1-7.8-13.7-7.8s-10.8 2.9-13.7 7.8l-96 160c-3 4.9-3 11.1-.2 16.1s8.2 8.1 13.9 8.1H384c5.8 0 11.1-3.1 13.9-8.1s2.8-11.2-.2-16.1l-96-160zM288 0c11.2 0 21.7 5.9 27.4 15.5l96 160c5.9 9.9 6.1 22.2 .4 32.2s-16.3 16.2-27.8 16.2H192c-11.5 0-22.2-6.2-27.8-16.2s-5.5-22.3 .4-32.2l96-160C266.3 5.9 276.8 0 288 0zM472 288H328c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24H472c13.3 0 24-10.7 24-24V312c0-13.3-10.7-24-24-24zM328 272H472c22.1 0 40 17.9 40 40V456c0 22.1-17.9 40-40 40H328c-22.1 0-40-17.9-40-40V312c0-22.1 17.9-40 40-40zM240 384A112 112 0 1 0 16 384a112 112 0 1 0 224 0zM0 384a128 128 0 1 1 256 0A128 128 0 1 1 0 384z'
      
    ]
  };

  
    var faTriangleCircleSquare = faShapes;
  

  
  

  var faChargingStation = {
    prefix: 'fat',
    iconName: 'charging-station',
    icon: [
      576,
      512,
      [],
      'f5e7',
      
      'M96 16C69.5 16 48 37.5 48 64V416H304V64c0-26.5-21.5-48-48-48H96zM48 432v64H304V432H48zM32 496V64C32 28.7 60.7 0 96 0H256c35.3 0 64 28.7 64 64V272h8c39.8 0 72 32.2 72 72v44c0 24.3 19.7 44 44 44s44-19.7 44-44V255.6c-40.4-4-72-38.1-72-79.6V152c0-13.3 10.7-24 24-24h8V72c0-4.4 3.6-8 8-8s8 3.6 8 8v56h64V72c0-4.4 3.6-8 8-8s8 3.6 8 8v56h8c13.3 0 24 10.7 24 24v24c0 41.5-31.6 75.6-72 79.6V388c0 33.1-26.9 60-60 60s-60-26.9-60-60V344c0-30.9-25.1-56-56-56h-8V496l24 0c4.4 0 8 3.6 8 8s-3.6 8-8 8H320 304 48 32 8c-4.4 0-8-3.6-8-8s3.6-8 8-8l24 0zM536 144H456 440c-4.4 0-8 3.6-8 8v24c0 35.3 28.7 64 64 64s64-28.7 64-64V152c0-4.4-3.6-8-8-8H536zM196.8 105.6c3.5 2.7 4.3 7.7 1.6 11.2L136 200h96c3 0 5.8 1.7 7.2 4.4s1.1 6-.8 8.4l-72 96c-2.7 3.5-7.7 4.3-11.2 1.6s-4.3-7.7-1.6-11.2L216 216H120c-3 0-5.8-1.7-7.2-4.4s-1.1-6 .8-8.4l72-96c2.7-3.5 7.7-4.3 11.2-1.6z'
      
    ]
  };

  

  
  

  var faMaximize = {
    prefix: 'fat',
    iconName: 'maximize',
    icon: [
      512,
      512,
      ["expand-arrows-alt"],
      'f31e',
      
      'M54.7 181.2l-.6-.2 0 0c-3.6-.9-6.1-4.1-6.1-7.8L48 56c0-4.4 3.6-8 8-8l117.3 0c3.7 0 6.9 2.5 7.8 6.1l.2 .6c.7 2.7-.1 5.6-2.1 7.6L62.3 179.1c-2 2-4.9 2.8-7.6 2.1l0 0zM32 173.3c0 11 7.5 20.6 18.2 23.3l.6 .2c8.2 2 16.8-.4 22.8-6.3l52.7-52.7L244.7 256 126.3 374.3 73.6 321.6c-6-6-14.6-8.4-22.8-6.3l-.6 .2C39.5 318.1 32 327.7 32 338.7V456c0 13.3 10.7 24 24 24l117.3 0c11 0 20.6-7.5 23.3-18.2l.2-.6c2-8.2-.4-16.8-6.3-22.8l-52.7-52.7L256 267.3 374.3 385.7l-52.7 52.7c-6 6-8.4 14.6-6.3 22.8l.2 .6c2.7 10.7 12.3 18.2 23.3 18.2L456 480c13.3 0 24-10.7 24-24l0-117.3c0-11-7.5-20.6-18.2-23.3l-.6-.2c-8.2-2-16.8 .4-22.8 6.3l-52.7 52.7L267.3 256 385.7 137.7l52.7 52.7c6 6 14.6 8.4 22.8 6.3l.6-.2c10.7-2.7 18.2-12.3 18.2-23.3L480 56c0-13.3-10.7-24-24-24H338.7c-11 0-20.6 7.5-23.3 18.2l-.2 .6c-2 8.2 .4 16.8 6.3 22.8l52.7 52.7L256 244.7 137.7 126.3l52.7-52.7c6-6 8.4-14.6 6.3-22.8l-.2-.6C193.9 39.5 184.3 32 173.3 32H56C42.7 32 32 42.7 32 56V173.3zM54.7 330.8c2.7-.7 5.6 .1 7.6 2.1L179.1 449.7c2 2 2.8 4.9 2.1 7.6l-.2 .6c-.9 3.6-4.1 6.1-7.8 6.1L56 464c-4.4 0-8-3.6-8-8l0-117.3c0-3.7 2.5-6.9 6.1-7.8l.6-.2zM457.9 181l-.6 .2c-2.7 .7-5.6-.1-7.6-2.1L332.9 62.3c-2-2-2.8-4.9-2.1-7.6l.2-.6c.9-3.6 4.1-6.1 7.8-6.1L456 48c4.4 0 8 3.6 8 8l0 117.3c0 3.7-2.5 6.9-6.1 7.8zm-.6 149.8l.6 .2c3.6 .9 6.1 4.1 6.1 7.8L464 456c0 4.4-3.6 8-8 8l-117.3 0c-3.7 0-6.9-2.5-7.8-6.1l-.2-.6c-.7-2.7 .1-5.6 2.1-7.6L449.7 332.9c2-2 4.9-2.8 7.6-2.1z'
      
    ]
  };

  
    var faExpandArrowsAlt = faMaximize;
  

  
  

  var faLightbulbGear = {
    prefix: 'fat',
    iconName: 'lightbulb-gear',
    icon: [
      576,
      512,
      [],
      'e5fd',
      
      'M192 0c97 0 175.6 78.4 176 175.3c-6.5 2.8-12 7-16.4 12.1c.3-3.8 .4-7.5 .4-11.4c0-88.4-71.6-160-160-160S32 87.6 32 176c0 33.9 10.5 65.3 28.5 91.2c4.5 6.5 9.5 13.3 14.5 20.2l0 0 0 0c12.5 17.2 25.9 35.5 36.3 54.4c7.4 13.5 11.6 27.8 14 42.2H109c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8l0 0 0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0zM122.7 416h123c2 5.4 4.3 10.7 6.9 16H128c0 35.3 28.7 64 64 64c33.3 0 60.6-25.4 63.7-57.9c.9 1.7 1.8 3.3 2.7 4.9c2.9 5 6 9.9 9.4 14.6C257.1 489.2 227.2 512 192 512c-44.2 0-80-35.8-80-80v-5.3c0-5.9 4.8-10.7 10.7-10.7zM184 80c-48.6 0-88 39.4-88 88c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-57.4 46.6-104 104-104c4.4 0 8 3.6 8 8s-3.6 8-8 8zM388 218.5v17.8c0 13.9-8.4 25.7-19.6 32.1c-11.1 6.3-25.3 7.7-37.3 .8l-13.9-8c-6.4 7-12.2 14.9-17.2 23.5s-8.9 17.5-11.8 26.6l14.3 8.3c11.8 6.8 17.3 19.6 17.3 32c0 12.4-5.5 25.2-17.3 32l-14.3 8.2c2.9 9.1 6.8 18 11.8 26.6s10.8 16.5 17.2 23.5l13.9-8c11.9-6.9 26.2-5.5 37.3 .8c11.2 6.4 19.6 18.1 19.6 32.1v17.8c9 2 18.4 3 28.1 3s19-1 28.1-3l0-18.1c0-13.8 8.3-25.5 19.4-31.8c11-6.3 25.2-7.7 37.1-.8l14.1 8.2c6.4-7 12.2-14.9 17.2-23.5c5-8.6 8.9-17.5 11.8-26.6l-14.6-8.4c-11.8-6.8-17.2-19.5-17.2-31.8s5.5-25 17.2-31.8l14.6-8.4c-2.9-9.1-6.8-18-11.8-26.6c-5-8.6-10.8-16.5-17.2-23.5l-14.1 8.1c-11.9 6.9-26.1 5.5-37.1-.8c-11.1-6.4-19.4-18-19.4-31.8V218.5c-9-2-18.4-3-28.1-3s-19 1-28.1 3zm-4.7-15.4c10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.7 1.5 11.3 7.7 11.3 14.8v18.7c0 7.1 4.3 13.9 11.4 18c7 4 15.1 4.4 21.2 .8l14.6-8.4c6.1-3.5 13.8-2.6 18.5 2.4c7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2 6.6-1 13.7-7.2 17.2l-15.1 8.7c-5.8 3.3-9.2 10.1-9.2 18s3.5 14.6 9.2 18l15.1 8.7c6.1 3.5 9.2 10.6 7.2 17.2c-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.7 5.1-12.4 5.9-18.5 2.4l-14.6-8.4c-6.1-3.5-14.2-3.2-21.2 .8c-7 4-11.4 10.9-11.4 18l0 18.7c0 7.1-4.6 13.3-11.3 14.8c-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.7-1.5-11.3-7.7-11.3-14.8V466.7c0-7.2-4.4-14.1-11.5-18.2c-7.1-4-15.2-4.4-21.3-.8L324.8 456c-6.1 3.5-13.8 2.6-18.5-2.4c-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2-6.6 1-13.7 7.2-17.2l14.8-8.5c5.8-3.4 9.3-10.2 9.3-18.2c0-8-3.5-14.8-9.3-18.1l-14.8-8.5c-6.1-3.5-9.2-10.6-7.2-17.2c3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.7-5.1 12.4-5.9 18.5-2.4l14.4 8.3c6.2 3.6 14.3 3.2 21.4-.8c7.1-4.1 11.5-11 11.5-18.2V218c0-7.1 4.6-13.3 11.3-14.8zM416 383.7a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  

  
  

  var faCactus = {
    prefix: 'fat',
    iconName: 'cactus',
    icon: [
      512,
      512,
      [127797],
      'f8a7',
      
      'M336 464c0 17.7-14.3 32-32 32H208c-17.7 0-32-14.3-32-32V320 304 240 224 96c0-44.2 35.8-80 80-80s80 35.8 80 80V352v16 64 16 16zm16-112V96c0-53-43-96-96-96s-96 43-96 96V224H112c-8.8 0-16-7.2-16-16V144c0-26.5-21.5-48-48-48S0 117.5 0 144v64c0 61.9 50.1 112 112 112h48V464c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V448h48c61.9 0 112-50.1 112-112V272c0-26.5-21.5-48-48-48s-48 21.5-48 48v64c0 8.8-7.2 16-16 16H352zm0 16h48c17.7 0 32-14.3 32-32V272c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 53-43 96-96 96H352V368zM112 304c-53 0-96-43-96-96V144c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7 14.3 32 32 32h48v64H112zM256 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm16 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faSignalBarsGood = {
    prefix: 'fat',
    iconName: 'signal-bars-good',
    icon: [
      640,
      512,
      ["signal-alt-3"],
      'f693',
      
      'M432 176c0-17.7-14.3-32-32-32s-32 14.3-32 32V464c0 17.7 14.3 32 32 32s32-14.3 32-32V176zm-80 0c0-26.5 21.5-48 48-48s48 21.5 48 48V464c0 26.5-21.5 48-48 48s-48-21.5-48-48V176zM272 304c0-17.7-14.3-32-32-32s-32 14.3-32 32V464c0 17.7 14.3 32 32 32s32-14.3 32-32V304zm-32-48c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48s-48-21.5-48-48V304c0-26.5 21.5-48 48-48zM112 464V432c0-17.7-14.3-32-32-32s-32 14.3-32 32v32c0 17.7 14.3 32 32 32s32-14.3 32-32zM80 384c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V432c0-26.5 21.5-48 48-48z'
      
    ]
  };

  
    var faSignalAlt3 = faSignalBarsGood;
  

  
  

  var faClockFourThirty = {
    prefix: 'fat',
    iconName: 'clock-four-thirty',
    icon: [
      512,
      512,
      [],
      'e34b',
      
      'M16 256a240 240 0 1 1 480 0A240 240 0 1 1 16 256zm496 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM264 408V270.9l83.6 55.7c3.7 2.5 8.6 1.5 11.1-2.2s1.5-8.6-2.2-11.1l-96-64c-2.5-1.6-5.6-1.8-8.2-.4s-4.2 4.1-4.2 7.1V408c0 4.4 3.6 8 8 8s8-3.6 8-8z'
      
    ]
  };

  

  
  

  var faArrowPointer = {
    prefix: 'fat',
    iconName: 'arrow-pointer',
    icon: [
      320,
      512,
      ["mouse-pointer"],
      'f245',
      
      'M144 304H297.9c3.4 0 6.1-2.7 6.1-6.1c0-1.7-.7-3.4-2-4.5L28 49.8c-1.3-1.2-3-1.8-4.8-1.8c-4 0-7.2 3.2-7.2 7.2V426c0 3.3 2.7 6 6 6c1.7 0 3.4-.7 4.5-2.1L132 309.5c3-3.5 7.4-5.5 12-5.5zM0 426V55.2C0 42.4 10.4 32 23.2 32c5.7 0 11.2 2.1 15.4 5.9l274 243.6c4.7 4.2 7.4 10.2 7.4 16.5c0 12.2-9.9 22.1-22.1 22.1H152.9l70.4 148.6c1.9 4 .2 8.8-3.8 10.7s-8.8 .2-10.7-3.8L138.3 326.6 38.6 440.5C34.4 445.3 28.4 448 22 448c-12.2 0-22-9.9-22-22z'
      
    ]
  };

  
    var faMousePointer = faArrowPointer;
  

  
  

  var faClockSevenThirty = {
    prefix: 'fat',
    iconName: 'clock-seven-thirty',
    icon: [
      512,
      512,
      [],
      'e351',
      
      'M16 256a240 240 0 1 0 480 0A240 240 0 1 0 16 256zm496 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM248 408V282.4l-49.3 74c-2.5 3.7-7.4 4.7-11.1 2.2s-4.7-7.4-2.2-11.1l64-96c2-2.9 5.6-4.2 9-3.2s5.7 4.1 5.7 7.7V408c0 4.4-3.6 8-8 8s-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faVenusMars = {
    prefix: 'fat',
    iconName: 'venus-mars',
    icon: [
      640,
      512,
      [9892],
      'f228',
      
      'M176 336a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM352 176c0 94.5-74.5 171.6-168 175.8V416h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H184v72c0 4.4-3.6 8-8 8s-8-3.6-8-8V432H88c-4.4 0-8-3.6-8-8s3.6-8 8-8h80V351.8C74.5 347.6 0 270.5 0 176C0 78.8 78.8 0 176 0s176 78.8 176 176zM286.2 352.5c29 29.4 69.3 47.5 113.8 47.5c88.4 0 160-71.6 160-160s-71.6-160-160-160c-12.8 0-25.3 1.5-37.2 4.4c-2.4-5-5.1-9.8-7.9-14.5C369.3 66 384.4 64 400 64c45.7 0 87.4 17.4 118.7 46l94-94H488c-4.4 0-8-3.6-8-8s3.6-8 8-8H632c4.4 0 8 3.6 8 8V152c0 4.4-3.6 8-8 8s-8-3.6-8-8V27.3l-94 94c28.6 31.3 46 72.9 46 118.7c0 97.2-78.8 176-176 176c-50.5 0-96-21.3-128.1-55.4c4.9-2.5 9.7-5.3 14.3-8.2z'
      
    ]
  };

  

  
  

  var faBox = {
    prefix: 'fat',
    iconName: 'box',
    icon: [
      448,
      512,
      [128230],
      'f466',
      
      'M342.4 48H232V176H430c-.6-2-1.3-4-2.2-5.9L386.3 76.5C378.6 59.2 361.4 48 342.4 48zM432 192H16V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V192zM18 176H216V48H105.6c-19 0-36.2 11.2-43.9 28.5L20.1 170.1c-.9 1.9-1.6 3.9-2.2 5.9zM342.4 32c25.3 0 48.2 14.9 58.5 38l41.6 93.6c3.6 8.2 5.5 17 5.5 26V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V189.6c0-9 1.9-17.8 5.5-26L47.1 70c10.3-23.1 33.2-38 58.5-38H342.4z'
      
    ]
  };

  

  
  

  var faPageCaretDown = {
    prefix: 'fat',
    iconName: 'page-caret-down',
    icon: [
      384,
      512,
      ["file-caret-down"],
      'e429',
      
      'M320 496H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H245.5c12.7 0 24.9 5.1 33.9 14.1l74.5 74.5c9 9 14.1 21.2 14.1 33.9V448c0 26.5-21.5 48-48 48zM64 512H320c35.3 0 64-28.7 64-64V138.5c0-17-6.7-33.3-18.7-45.3L290.7 18.7C278.7 6.7 262.5 0 245.5 0H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64zM267.7 253.4L192 336l-75.7-82.6c-4.7-5.1-1.1-13.4 5.9-13.4l139.6 0c7 0 10.6 8.3 5.9 13.4zm-87.5 93.4c3 3.3 7.3 5.2 11.8 5.2s8.8-1.9 11.8-5.2l75.7-82.6c14.1-15.4 3.2-40.2-17.7-40.2l-139.6 0c-20.9 0-31.8 24.8-17.7 40.2l75.7 82.6z'
      
    ]
  };

  
    var faFileCaretDown = faPageCaretDown;
  

  
  

  var faCross = {
    prefix: 'fat',
    iconName: 'cross',
    icon: [
      384,
      512,
      [10013,128327],
      'f654',
      
      'M128 32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v96h96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H256V480c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V256H32c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96V32zm32-16c-8.8 0-16 7.2-16 16V136c0 4.4-3.6 8-8 8H32c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H136c4.4 0 8 3.6 8 8V480c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V248c0-4.4 3.6-8 8-8H352c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16H248c-4.4 0-8-3.6-8-8V32c0-8.8-7.2-16-16-16H160z'
      
    ]
  };

  

  
  

  var faRepeat = {
    prefix: 'fat',
    iconName: 'repeat',
    icon: [
      512,
      512,
      [128257],
      'f363',
      
      'M347.3 176c3 0 5.9-1.2 8-3.3L432 96 355.3 19.3c-2.1-2.1-5-3.3-8-3.3c-6.2 0-11.3 5.1-11.3 11.3L336 96v68.7c0 6.2 5.1 11.3 11.3 11.3zM320 164.7V104H168C84.1 104 16 172.1 16 256v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8C0 163.2 75.2 88 168 88H320V27.3C320 12.2 332.2 0 347.3 0c7.2 0 14.2 2.9 19.3 8l76.7 76.7c3 3 4.7 7.1 4.7 11.3s-1.7 8.3-4.7 11.3L366.6 184c-5.1 5.1-12.1 8-19.3 8c-15.1 0-27.3-12.2-27.3-27.3zM164.7 336c-3 0-5.9 1.2-8 3.3L80 416l76.7 76.7c2.1 2.1 5 3.3 8 3.3c6.2 0 11.3-5.1 11.3-11.3l0-68.7V347.3c0-6.2-5.1-11.3-11.3-11.3zM192 347.3V408H344c83.9 0 152-68.1 152-152v-8c0-4.4 3.6-8 8-8s8 3.6 8 8v8c0 92.8-75.2 168-168 168H192v60.7c0 15.1-12.2 27.3-27.3 27.3c-7.2 0-14.2-2.9-19.3-8L68.7 427.3c-3-3-4.7-7.1-4.7-11.3s1.7-8.3 4.7-11.3L145.4 328c5.1-5.1 12.1-8 19.3-8c15.1 0 27.3 12.2 27.3 27.3z'
      
    ]
  };

  

  
  

  var faDialMin = {
    prefix: 'fat',
    iconName: 'dial-min',
    icon: [
      576,
      512,
      [],
      'e161',
      
      'M272 32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM282.3 282.3L180.7 384c-50.7-56.5-48.8-143.5 5.5-197.8c56.2-56.2 147.4-56.2 203.6 0s56.2 147.4 0 203.6C335.5 444.2 248.5 446 192 395.3L293.7 293.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0zM174.9 401.1A160 160 0 1 0 401.1 174.9 160 160 0 1 0 174.9 401.1zM544 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM16 288a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0A32 32 0 1 0 0 288a32 32 0 1 0 64 0zM96 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM464 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 464a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm368-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faStar = {
    prefix: 'fat',
    iconName: 'star',
    icon: [
      576,
      512,
      [11088,61446],
      'f005',
      
      'M212.1 161.8L280.7 20.5c1.3-2.8 4.1-4.5 7.2-4.5s5.9 1.7 7.2 4.5l68.6 141.3c2.3 4.8 6.8 8.1 12.1 8.8L529 193.3c3 .4 5.5 2.5 6.4 5.4s.2 6-2 8.2L422.4 317c-3.7 3.7-5.4 8.9-4.5 14l26.2 155.6c.5 3-.7 6-3.2 7.8s-5.8 2-8.4 .6l-137-73.2c-4.7-2.5-10.4-2.5-15.1 0L143.4 495c-2.7 1.4-6 1.2-8.4-.6s-3.7-4.8-3.2-7.8L158 331c.9-5.1-.8-10.4-4.5-14L42.4 206.9 31.2 218.1l11.2-11.3c-2.2-2.1-2.9-5.3-2-8.2s3.4-5 6.4-5.4l153.2-22.6c5.2-.8 9.7-4.1 12.1-8.8zM424.9 509.1c8.1 4.3 17.9 3.7 25.3-1.7s11.2-14.5 9.7-23.5L433.6 328.4 544.8 218.2c6.5-6.4 8.7-15.9 5.9-24.5s-10.3-14.9-19.3-16.3L378.1 154.8 309.5 13.5C305.5 5.2 297.1 0 287.9 0s-17.6 5.2-21.6 13.5L197.7 154.8 44.5 177.5c-9 1.3-16.5 7.6-19.3 16.3s-.5 18.1 5.9 24.5L142.2 328.4 116 483.9c-1.5 9 2.2 18.1 9.7 23.5s17.3 6 25.3 1.7l137-73.2 137 73.2z'
      
    ]
  };

  

  
  

  var faDiamondExclamation = {
    prefix: 'fat',
    iconName: 'diamond-exclamation',
    icon: [
      512,
      512,
      [],
      'e405',
      
      'M273 23c-9.4-9.4-24.6-9.4-33.9 0L23 239c-9.4 9.4-9.4 24.6 0 33.9L239 489c9.4 9.4 24.6 9.4 33.9 0L489 273c9.4-9.4 9.4-24.6 0-33.9L273 23zM227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zM256 128c4.4 0 8 3.6 8 8V296c0 4.4-3.6 8-8 8s-8-3.6-8-8V136c0-4.4 3.6-8 8-8zM240 352a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faSignalBars = {
    prefix: 'fat',
    iconName: 'signal-bars',
    icon: [
      640,
      512,
      ["signal-alt","signal-alt-4","signal-bars-strong"],
      'f690',
      
      'M560 16c-17.7 0-32 14.3-32 32V464c0 17.7 14.3 32 32 32s32-14.3 32-32V48c0-17.7-14.3-32-32-32zM512 48c0-26.5 21.5-48 48-48s48 21.5 48 48V464c0 26.5-21.5 48-48 48s-48-21.5-48-48V48zM432 464V176c0-17.7-14.3-32-32-32s-32 14.3-32 32V464c0 17.7 14.3 32 32 32s32-14.3 32-32zM400 128c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48s-48-21.5-48-48V176c0-26.5 21.5-48 48-48zM240 272c-17.7 0-32 14.3-32 32V464c0 17.7 14.3 32 32 32s32-14.3 32-32V304c0-17.7-14.3-32-32-32zm-48 32c0-26.5 21.5-48 48-48s48 21.5 48 48V464c0 26.5-21.5 48-48 48s-48-21.5-48-48V304zM112 432c0-17.7-14.3-32-32-32s-32 14.3-32 32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V432zm-80 0c0-26.5 21.5-48 48-48s48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V432z'
      
    ]
  };

  
    var faSignalAlt = faSignalBars;
  
    var faSignalAlt4 = faSignalBars;
  
    var faSignalBarsStrong = faSignalBars;
  

  
  

  var faSprayCanSparkles = {
    prefix: 'fat',
    iconName: 'spray-can-sparkles',
    icon: [
      512,
      512,
      ["air-freshener"],
      'f5d0',
      
      'M136 0h48c22.1 0 40 17.9 40 40v80c0 4.4-3.6 8-8 8s-8-3.6-8-8V40c0-13.3-10.7-24-24-24H136c-13.3 0-24 10.7-24 24v80c0 4.4-3.6 8-8 8s-8-3.6-8-8V40c0-22.1 17.9-40 40-40zM96 176c-44.2 0-80 35.8-80 80V448c0 26.5 21.5 48 48 48H256c26.5 0 48-21.5 48-48V256c0-44.2-35.8-80-80-80H96zM0 256c0-53 43-96 96-96H224c53 0 96 43 96 96V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256zm160 8a72 72 0 1 0 0 144 72 72 0 1 0 0-144zm88 72A88 88 0 1 1 72 336a88 88 0 1 1 176 0zM336 0c4.4 0 8 3.6 8 8V40h32c4.4 0 8 3.6 8 8s-3.6 8-8 8H344V88c0 4.4-3.6 8-8 8s-8-3.6-8-8V56H296c-4.4 0-8-3.6-8-8s3.6-8 8-8h32V8c0-4.4 3.6-8 8-8zM472 8V40h32c4.4 0 8 3.6 8 8s-3.6 8-8 8H472V88c0 4.4-3.6 8-8 8s-8-3.6-8-8V56H424c-4.4 0-8-3.6-8-8s3.6-8 8-8h32V8c0-4.4 3.6-8 8-8s8 3.6 8 8zm-8 184c4.4 0 8 3.6 8 8v32h32c4.4 0 8 3.6 8 8s-3.6 8-8 8H472v32c0 4.4-3.6 8-8 8s-8-3.6-8-8V248H424c-4.4 0-8-3.6-8-8s3.6-8 8-8h32V200c0-4.4 3.6-8 8-8zm-56-88v32h32c4.4 0 8 3.6 8 8s-3.6 8-8 8H408v32c0 4.4-3.6 8-8 8s-8-3.6-8-8V152H360c-4.4 0-8-3.6-8-8s3.6-8 8-8h32V104c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  
    var faAirFreshener = faSprayCanSparkles;
  

  
  

  var faCommentText = {
    prefix: 'fat',
    iconName: 'comment-text',
    icon: [
      512,
      512,
      [],
      'e14d',
      
      'M157.3 415c-5-1.8-10.6-1-14.9 2.1c-11 8-29.4 19.3-51.2 28.8C68.3 456 41.6 464 16 464l.1-.1 0 0 0 0 .3-.3 .1-.1c.4-.4 .9-.9 1.5-1.6c1.3-1.4 3.2-3.6 5.4-6.3l-12.2-10 12.2 10C28 450 34 442 40 432c10.7-17.9 21.4-42.1 23.6-69.9c.3-4.3-1.1-8.6-3.9-11.8C31.9 318.8 16 280.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-35.2 0-68.6-6.1-98.7-17zM4.7 452.7l0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0zM168 176c-4.4 0-8 3.6-8 8s3.6 8 8 8h80V328c0 4.4 3.6 8 8 8s8-3.6 8-8V192h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H256 168z'
      
    ]
  };

  

  
  

  var faSunDust = {
    prefix: 'fat',
    iconName: 'sun-dust',
    icon: [
      512,
      512,
      [],
      'f764',
      
      'M165.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L121 121 13.1 140.8c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L65.1 256 2.8 346.3c-3.1 4.5-3.7 10.2-1.6 15.2s6.6 8.6 11.9 9.6L121 391l0 0 12.5-12.5c-1.1-1.1-2.6-1.9-4.2-2.2L16 355.4l65.4-94.9c1.9-2.7 1.9-6.3 0-9.1L16 156.6l113.3-20.8c3.3-.6 5.8-3.2 6.4-6.4L156.6 16l94.9 65.4c2.7 1.9 6.3 1.9 9.1 0L355.4 16l20.8 113.3c.3 1.6 1.1 3.1 2.2 4.2L391 121l0 0L371.1 13.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L256 65.1 165.7 2.8zM256 144c-61.9 0-112 50.1-112 112c0 30.9 12.5 58.9 32.8 79.2l11.3-11.3C170.7 306.5 160 282.5 160 256c0-53 43-96 96-96c26.5 0 50.5 10.7 67.9 28.1l11.3-11.3C314.9 156.5 286.9 144 256 144zm240 16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-96 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm96 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-96 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM160 496a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm160 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm176-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM240 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm96-96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faCameraRotate = {
    prefix: 'fat',
    iconName: 'camera-rotate',
    icon: [
      640,
      512,
      [],
      'e0d8',
      
      'M260.8 32c-20.7 0-39 13.2-45.5 32.8L204.9 96H128c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H435.1L424.7 64.8C418.2 45.2 399.8 32 379.2 32H260.8zM230.5 69.9C234.8 56.8 247.1 48 260.8 48H379.2c13.8 0 26 8.8 30.4 21.9l12.2 36.6c1.1 3.3 4.1 5.5 7.6 5.5H512c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H128c-26.5 0-48-21.5-48-48V160c0-26.5 21.5-48 48-48h82.7c3.4 0 6.5-2.2 7.6-5.5l12.2-36.6zM224 312c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8s8-3.6 8-8V339.3L259.7 367c16 16 37.7 25 60.3 25c36.2 0 68-18.5 86.7-46.5c2.4-3.7 1.4-8.6-2.2-11.1s-8.6-1.4-11.1 2.2C377.6 360.4 350.6 376 320 376c-18.4 0-36-7.3-49-20.3L243.3 328H288c4.4 0 8-3.6 8-8s-3.6-8-8-8H224zm200-56V192c0-4.4-3.6-8-8-8s-8 3.6-8 8v44.7L380.3 209c-16-16-37.7-25-60.3-25c-36.2 0-68 18.5-86.7 46.5c-2.4 3.7-1.4 8.6 2.2 11.1s8.6 1.4 11.1-2.2C262.4 215.6 289.4 200 320 200c18.4 0 36 7.3 49 20.3L396.7 248H352c-4.4 0-8 3.6-8 8s3.6 8 8 8h64c4.4 0 8-3.6 8-8z'
      
    ]
  };

  

  
  

  var faUniformMartialArts = {
    prefix: 'fat',
    iconName: 'uniform-martial-arts',
    icon: [
      640,
      512,
      [],
      'e3d1',
      
      'M235.1 16H216c-1.2 0-2.5 .1-3.7 .2c-.5 0-1.1 0-1.6 0c-.9-.1-1.8-.2-2.7-.2H192 172.4c-32.1 0-61.6 17.5-77.1 45.6L28.9 182.3C20.4 197.7 16 214.9 16 232.4V376c0 13.3 10.7 24 24 24H72c13.3 0 24-10.7 24-24V232.4c0-4 1-8 3-11.6l57.3-104.1c1.6-3 3.6-5.7 5.9-8.1c2.2-2.4 5.7-3.2 8.8-2s5.1 4.2 5.1 7.4V304H160V143.1l-47 85.5c-.6 1.2-1 2.5-1 3.9V376c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V232.4c0-20.2 5.1-40.1 14.9-57.8L81.3 53.9C99.5 20.6 134.5 0 172.4 0H192h16c1.2 0 2.5 .1 3.7 .2c1.4-.1 2.9-.2 4.3-.2h23.8 .3H399.8h.3H424c1.5 0 2.9 .1 4.3 .2c1.2-.1 2.4-.2 3.7-.2h16 19.6c37.9 0 72.8 20.6 91.1 53.9l66.4 120.7c9.7 17.7 14.9 37.6 14.9 57.8V376c0 22.1-17.9 40-40 40H568c-22.1 0-40-17.9-40-40V232.4c0-1.3-.3-2.7-1-3.9l-47-85.5V304H464V114.1c0-3.3 2-6.2 5-7.4s6.5-.4 8.8 2c2.3 2.4 4.3 5.2 5.9 8.1L541 220.9l-7 3.9 7-3.9c1.9 3.5 3 7.5 3 11.6V376c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V232.4c0-17.5-4.4-34.8-12.9-50.1L544.7 61.6C529.3 33.5 499.7 16 467.6 16H448 432c-.9 0-1.8 .1-2.7 .2c-.5 .1-1.1 .1-1.6 0c-1.2-.1-2.4-.2-3.7-.2H404.9L327.2 171.5 264.1 304H246.4l64.7-135.9L235.1 16zM160 384h16v80c0 17.7 14.3 32 32 32H432c17.7 0 32-14.3 32-32V384h16v80c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V384zM387.1 16H252.9L320 150.1 387.1 16zM160 336H320 480c4.4 0 8 3.6 8 8s-3.6 8-8 8H334.9l55.7 83.6c2.5 3.7 1.5 8.6-2.2 11.1s-8.6 1.5-11.1-2.2l-57.3-86-57.3 86c-2.5 3.7-7.4 4.7-11.1 2.2s-4.7-7.4-2.2-11.1L305.1 352H160c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faFaceWeary = {
    prefix: 'fat',
    iconName: 'face-weary',
    icon: [
      512,
      512,
      [],
      'e3a1',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176 84c-10 10-18 21-23.5 31.5S144 392 144 400l20.5-7.7c28.7-10.8 59.2-16.3 89.9-16.3h3.2c30.7 0 61.1 5.5 89.9 16.3L368 400c0-8-3-18-8.5-28.5S346 350 336 340c-20-20-48-36-80-36s-60 16-80 36zm80-52c37.4 0 69.3 18.7 91.3 40.7c11.1 11.1 20.1 23.4 26.4 35.4c6.2 11.7 10.3 24.4 10.3 35.9c0 5.2-2.6 10.2-6.9 13.2s-9.8 3.7-14.7 1.8l-20.5-7.7c-26.9-10.1-55.5-15.3-84.3-15.3h-3.2c-28.8 0-57.3 5.2-84.3 15.3L149.6 415c-4.9 1.8-10.4 1.2-14.7-1.8s-6.9-7.9-6.9-13.2c0-11.6 4.2-24.2 10.3-35.9c6.3-12 15.3-24.3 26.4-35.4c22-22 53.9-40.7 91.3-40.7zM205.7 170.3c3.1 3.1 3.1 8.2 0 11.3l-7.4 7.4c-22.4 22.4-51.2 37.2-82.5 42.5l-2.5 .4c-4.4 .7-8.5-2.2-9.2-6.6s2.2-8.5 6.6-9.2l2.5-.4c28-4.7 53.8-17.9 73.8-38l7.4-7.4c3.1-3.1 8.2-3.1 11.3 0zm100.7 11.3c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l7.4 7.4c20 20 45.8 33.3 73.8 38l2.5 .4c4.4 .7 7.3 4.8 6.6 9.2s-4.8 7.3-9.2 6.6l-2.5-.4c-31.3-5.2-60.1-20.1-82.5-42.5l-7.4-7.4z'
      
    ]
  };

  

  
  

  var faEggFried = {
    prefix: 'fat',
    iconName: 'egg-fried',
    icon: [
      512,
      512,
      [],
      'f7fc',
      
      'M474 173.3C510.8 223 500.4 293.1 450.7 330c-15.6 11.6-33.2 18.5-51.1 21c-21.2 3-44.4 12.1-64.7 24.6c-20.2 12.4-39.1 29.2-50.2 48.5C244.9 492.9 156.9 516.5 88 476.7S-4.5 348.9 35.3 280C61.7 234.3 76 168.6 80.4 118.2c2.3-26 13.6-51.4 34-70.9C159 4.4 229.9 5.8 272.7 50.4c16.5 17.2 40.1 34.5 64.7 48.9s51.3 26.4 74.4 32.3c24.1 6.2 46.2 20.3 62.1 41.8zM415.8 116c-42.4-10.9-101.2-45.1-131.5-76.7c-49-51-130-52.6-181-3.6C80.1 58 67.1 87 64.5 116.8C60.2 166.1 46.2 229.1 21.4 272C-22.7 348.5 3.5 446.4 80 490.6s174.4 18 218.6-58.6c18.8-32.5 66.1-60 103.3-65.2c20.5-2.9 40.6-10.8 58.4-24c56.8-42.1 68.7-122.3 26.6-179.1c-18.2-24.6-43.5-40.7-71-47.8zM224 144a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 208a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM176 240c0-26.5 21.5-48 48-48c4.4 0 8-3.6 8-8s-3.6-8-8-8c-35.3 0-64 28.7-64 64c0 4.4 3.6 8 8 8s8-3.6 8-8z'
      
    ]
  };

  

  
  

  var faCircleBookmark = {
    prefix: 'fat',
    iconName: 'circle-bookmark',
    icon: [
      512,
      512,
      ["bookmark-circle"],
      'e100',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm80-144l-70-56c-5.8-4.7-14.1-4.7-20 0l-70 56V176c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32V368zm-10 12.5c4.8 3.8 11.4 4.6 16.9 1.9s9.1-8.3 9.1-14.4V176c0-26.5-21.5-48-48-48H208c-26.5 0-48 21.5-48 48V368c0 6.2 3.5 11.8 9.1 14.4s12.1 1.9 16.9-1.9l70-56 70 56z'
      
    ]
  };

  
    var faBookmarkCircle = faCircleBookmark;
  

  
  

  var faBellExclamation = {
    prefix: 'fat',
    iconName: 'bell-exclamation',
    icon: [
      448,
      512,
      [],
      'f848',
      
      'M216 8c0-4.4 3.6-8 8-8s8 3.6 8 8V32l0 .2c84.6 4.2 152 74.1 152 159.8v36.6c0 41.8 14.2 82.3 40.3 114.9l16.7 20.9c4.5 5.6 6.9 12.6 6.9 19.8c0 17.5-14.2 31.7-31.7 31.7H31.7C14.2 416 0 401.8 0 384.3c0-7.2 2.4-14.2 6.9-19.8l16.7-20.9C49.8 311 64 270.4 64 228.6V192c0-85.7 67.4-155.6 152-159.8l0-.2V8zm8 40C144.5 48 80 112.5 80 192v36.6c0 45.4-15.5 89.5-43.8 124.9L19.4 374.5c-2.2 2.8-3.4 6.2-3.4 9.8C16 393 23 400 31.7 400H416.3c8.7 0 15.7-7 15.7-15.7c0-3.6-1.2-7-3.4-9.8l-16.7-20.9C383.5 318.1 368 274.1 368 228.6V192c0-79.5-64.5-144-144-144zM176 448c0 12.7 5.1 24.9 14.1 33.9s21.2 14.1 33.9 14.1s24.9-5.1 33.9-14.1s14.1-21.2 14.1-33.9c0-4.4 3.6-8 8-8s8 3.6 8 8c0 17-6.7 33.3-18.7 45.3s-28.3 18.7-45.3 18.7s-33.3-6.7-45.3-18.7s-18.7-28.3-18.7-45.3c0-4.4 3.6-8 8-8s8 3.6 8 8zm32-128a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm24-184V264c0 4.4-3.6 8-8 8s-8-3.6-8-8V136c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faBan = {
    prefix: 'fat',
    iconName: 'ban',
    icon: [
      512,
      512,
      [128683,"cancel"],
      'f05e',
      
      'M420 431.3L80.7 92C40.6 134.9 16 192.6 16 256c0 132.5 107.5 240 240 240c63.4 0 121.1-24.6 164-64.7zM431.3 420C471.4 377.1 496 319.4 496 256C496 123.5 388.5 16 256 16C192.6 16 134.9 40.6 92 80.7L431.3 420zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  
    var faCancel = faBan;
  

  
  

  var faScalpel = {
    prefix: 'fat',
    iconName: 'scalpel',
    icon: [
      512,
      512,
      [],
      'f61d',
      
      'M399.6 35.4C410 23.1 425.3 16 441.4 16C471.5 16 496 40.5 496 70.6v4c0 13.8-4.9 27.2-13.8 37.8L357.1 260.6c-6.1 7.2-15 11.4-24.5 11.4H200L399.6 35.4zM441.4 0c-20.8 0-40.6 9.2-54 25.1L187.8 261.7c-4 4.8-4.9 11.4-2.3 17.1s8.3 9.3 14.5 9.3H332.6c14.1 0 27.6-6.2 36.7-17L494.4 122.7C505.8 109.2 512 92.2 512 74.6v-4C512 31.6 480.4 0 441.4 0zM2.3 498.4c-2.2 2.3-2.9 5.7-1.6 8.7s4.2 4.9 7.4 4.9c17.9 0 95-8.9 167.8-39.6c66-27.9 131.2-75 142.5-152.4H302.1C291 387.6 233.3 430.7 169.6 457.6c-53.9 22.8-110.2 33.1-141 36.8L198.5 320H176.1L2.3 498.4z'
      
    ]
  };

  

  
  

  var faPersonCircleMinus = {
    prefix: 'fat',
    iconName: 'person-circle-minus',
    icon: [
      576,
      512,
      [],
      'e540',
      
      'M160 16a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm0 96A56 56 0 1 0 160 0a56 56 0 1 0 0 112zm-18.9 32h37.8c21.5 0 41.1 12.3 50.4 31.7l50.3 104.2c3.1-5.4 6.5-10.6 10.2-15.6l-46.1-95.5c-12-24.9-37.2-40.7-64.8-40.7H141.1c-27.6 0-52.8 15.8-64.8 40.7L8.8 308.5c-1.9 4-.3 8.8 3.7 10.7s8.8 .3 10.7-3.7L90.7 175.7c9.3-19.4 28.9-31.7 50.4-31.7zM104 248c0-4.4-3.6-8-8-8s-8 3.6-8 8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V360c0-4.4 3.6-8 8-8s8 3.6 8 8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V248c0-4.4-3.6-8-8-8s-8 3.6-8 8V480c0 8.8-7.2 16-16 16s-16-7.2-16-16V360c0-13.3-10.7-24-24-24s-24 10.7-24 24V480c0 8.8-7.2 16-16 16s-16-7.2-16-16V248zm328-8a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm80-144c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8s3.6 8 8 8H504c4.4 0 8-3.6 8-8z'
      
    ]
  };

  

  
  

  var faCircleThreeQuartersStroke = {
    prefix: 'fat',
    iconName: 'circle-three-quarters-stroke',
    icon: [
      512,
      512,
      [],
      'e5d4',
      
      'M495.5 272H280c-22.1 0-40-17.9-40-40V16.5C114.9 24.8 16 128.8 16 256c0 132.5 107.5 240 240 240c127.2 0 231.2-98.9 239.5-224zm.5-16C496 123.5 388.5 16 256 16V232c0 13.3 10.7 24 24 24H496zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  

  
  

  var faHouseFlag = {
    prefix: 'fat',
    iconName: 'house-flag',
    icon: [
      640,
      512,
      [],
      'e50d',
      
      'M456 0c-4.4 0-8 3.6-8 8V32h0V48 176v16h0V512h16V192H624c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H464V8c0-4.4-3.6-8-8-8zm8 176V48H624V176H464zm-48-38L276.8 33.6c-2.8-2.1-6.8-2.1-9.6 0l-256 192c-3.5 2.7-4.3 7.7-1.6 11.2s7.7 4.3 11.2 1.6L64 206V448c0 35.3 28.7 64 64 64H416V496H352V344c0-13.3-10.7-24-24-24H216c-13.3 0-24 10.7-24 24V496H128c-26.5 0-48-21.5-48-48V194L272 50 416 158V138zM336 344V496l-128 0V344c0-4.4 3.6-8 8-8H328c4.4 0 8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faChartArea = {
    prefix: 'fat',
    iconName: 'chart-area',
    icon: [
      512,
      512,
      ["area-chart"],
      'f1fe',
      
      'M16 40c0-4.4-3.6-8-8-8s-8 3.6-8 8V408c0 39.8 32.2 72 72 72H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H72c-30.9 0-56-25.1-56-56V40zM308.7 203.3c3 3 7.1 4.7 11.3 4.7s8.3-1.7 11.3-4.7l39.6-39.6c6.6-6.6 17.4-6.2 23.5 .9l62 72.3c5 5.8 7.7 13.2 7.7 20.8V352c0 8.8-7.2 16-16 16H128c-8.8 0-16-7.2-16-16V243.9c0-8.5 3.4-16.6 9.4-22.6l91.3-91.3c6.2-6.2 16.4-6.2 22.6 0l73.4 73.4zM320 192l-11.3-11.3-62.1-62.1c-12.5-12.5-32.8-12.5-45.3 0l-91.3 91.3c-9 9-14.1 21.2-14.1 33.9V352c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V257.8c0-11.5-4.1-22.5-11.6-31.2l-62-72.3c-12.1-14.2-33.7-15-46.9-1.8l-28.2 28.3L320 192z'
      
    ]
  };

  
    var faAreaChart = faChartArea;
  

  
  

  var faMoneyBillWave = {
    prefix: 'fat',
    iconName: 'money-bill-wave',
    icon: [
      576,
      512,
      [],
      'f53a',
      
      'M16 422.3c0 12.4 6.9 22.7 16.6 26.3c78.1 29.1 156.8 11.7 240.7-9.6c4-1 8-2 12-3.1c78.7-20.1 162.3-41.4 246.3-18.5c15.2 4.2 28.4-6.9 28.4-17.9V89.7c0-12.4-6.9-22.7-16.6-26.3C465.3 34.2 386.7 51.7 302.8 73c-4 1-8 2-12 3l0 0 0 0 0 0C212 96.2 128.4 117.5 44.4 94.6C29.2 90.4 16 101.5 16 112.5V422.3zm-16 0V112.5C0 88.6 25.6 72.8 48.7 79.1c79.8 21.8 159.6 1.5 239.3-18.9c87-22.2 174-44.4 261-11.9c16.9 6.3 27 23.2 27 41.3V399.5c0 23.9-25.6 39.7-48.7 33.4c-79.8-21.8-159.6-1.5-239.3 18.9c-87 22.2-174 44.4-261 11.9c-16.9-6.3-27-23.2-27-41.3zM216 256c0 50 33.5 88 72 88s72-38 72-88s-33.5-88-72-88s-72 38-72 88zm72-104c49.9 0 88 48 88 104s-38.1 104-88 104s-88-48-88-104s38.1-104 88-104zm256 0c0 4.4-3.6 8-8 8h-8c-39.8 0-72-32.2-72-72V80c0-4.4 3.6-8 8-8s8 3.6 8 8v8c0 30.9 25.1 56 56 56h8c4.4 0 8 3.6 8 8zM40 216c-4.4 0-8-3.6-8-8s3.6-8 8-8h8c30.9 0 56-25.1 56-56v-8c0-4.4 3.6-8 8-8s8 3.6 8 8v8c0 39.8-32.2 72-72 72H40zm504 88c0 4.4-3.6 8-8 8h-8c-30.9 0-56 25.1-56 56v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-39.8 32.2-72 72-72h8c4.4 0 8 3.6 8 8zM40 352h8c39.8 0 72 32.2 72 72v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-30.9-25.1-56-56-56H40c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faPizzaSlice = {
    prefix: 'fat',
    iconName: 'pizza-slice',
    icon: [
      512,
      512,
      [],
      'f818',
      
      'M168.6 16.8c-14.4-1-27.2 8.9-30.9 22.9L124.7 88.3c162.2 6.5 292.5 136.8 299 299l48.5-12.9c14.1-3.7 23.9-16.5 22.9-30.9C483.1 168.6 343.4 28.9 168.6 16.8zM16 496L407.9 391.5c-4.4-156.7-130.7-283-287.4-287.4L16 496zM122.2 35.6C127.7 14.9 146.9-.7 169.7 .9C352.5 13.5 498.5 159.5 511.1 342.3c1.6 22.8-14 41.9-34.7 47.5L20.1 511.5c-5.5 1.5-11.4-.1-15.4-4.1s-5.6-9.9-4.1-15.4L122.2 35.6zM176 200a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm32 96a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm40 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM144 328a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faTruckBolt = {
    prefix: 'fat',
    iconName: 'truck-bolt',
    icon: [
      640,
      512,
      [],
      'e3d0',
      
      'M352 16c26.5 0 48 21.5 48 48V400H236.7c-10.4-36.9-44.4-64-84.7-64s-74.2 27.1-84.7 64H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H352zM64 416h.4c-.2 2.6-.4 5.3-.4 8c0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8H400h.4c-.2 2.6-.4 5.3-.4 8c0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8H632c4.4 0 8-3.6 8-8s-3.6-8-8-8H608V229.3c0-10.6-4.2-20.8-11.7-28.3L503 107.7c-7.5-7.5-17.7-11.7-28.3-11.7H416V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64zM416 112h58.7c6.4 0 12.5 2.5 17 7L585 212.3c1.1 1.1 2.2 2.4 3 3.7H416V112zm0 261.4V232H592V400H572.7c-10.4-36.9-44.4-64-84.7-64c-29.8 0-56.1 14.8-72 37.4zM152 352a72 72 0 1 1 0 144 72 72 0 1 1 0-144zm264 72a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zM270.9 104.1c8.3-14.5-8.4-30.4-22.5-21.4L122.9 162.5c-13.5 8.6-7.4 29.5 8.6 29.5h45.6l-32 55.9c-8.3 14.5 8.4 30.4 22.5 21.4l125.5-79.9c13.5-8.6 7.4-29.5-8.6-29.5H238.9l32-55.9zM131.5 176L257 96.1 218.2 164c-1.4 2.5-1.4 5.5 0 8s4.1 4 6.9 4h59.4L159 255.9 197.8 188c1.4-2.5 1.4-5.5 0-8s-4.1-4-6.9-4l-59.4 0z'
      
    ]
  };

  

  
  

  var faSignPosts = {
    prefix: 'fat',
    iconName: 'sign-posts',
    icon: [
      576,
      512,
      [],
      'e625',
      
      'M80 32L80 8c0-4.4 3.6-8 8-8s8 3.6 8 8l0 24H480l0-24c0-4.4 3.6-8 8-8s8 3.6 8 8l0 24h32c26.5 0 48 21.5 48 48V368c0 26.5-21.5 48-48 48H496l0 88c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-88H96l0 88c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-88H48c-26.5 0-48-21.5-48-48V80C0 53.5 21.5 32 48 32H80zM528 48H48C30.3 48 16 62.3 16 80V368c0 17.7 14.3 32 32 32H528c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32z'
      
    ]
  };

  

  
  

  var faMailbox = {
    prefix: 'fat',
    iconName: 'mailbox',
    icon: [
      576,
      512,
      [128234],
      'f813',
      
      'M272 384c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V208C16 137.3 73.3 80 144 80s128 57.3 128 128V384zm16-176c0-55.7-31.7-104.1-78-128H432c70.7 0 128 57.3 128 128V384c0 26.5-21.5 48-48 48H266.3c13.3-11.7 21.7-28.9 21.7-48V208zM64 448H224 512c35.3 0 64-28.7 64-64V208c0-79.5-64.5-144-144-144H144C64.5 64 0 128.5 0 208V384c0 35.3 28.7 64 64 64zm8-256c-4.4 0-8 3.6-8 8s3.6 8 8 8H216c4.4 0 8-3.6 8-8s-3.6-8-8-8H72zm304 0c-4.4 0-8 3.6-8 8s3.6 8 8 8h56v64c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V216c0-13.3-10.7-24-24-24H440 376zm72 80V208h40c4.4 0 8 3.6 8 8v56c0 4.4-3.6 8-8 8H456c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faChartLineUp = {
    prefix: 'fat',
    iconName: 'chart-line-up',
    icon: [
      512,
      512,
      [],
      'e0e5',
      
      'M16 40c0-4.4-3.6-8-8-8s-8 3.6-8 8V408c0 39.8 32.2 72 72 72H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H72c-30.9 0-56-25.1-56-56V40zm336 88c-4.4 0-8 3.6-8 8s3.6 8 8 8H452.7L288 308.7l-90.3-90.3c-3.1-3.1-8.2-3.1-11.3 0l-96 96c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L192 235.3l90.3 90.3c3.1 3.1 8.2 3.1 11.3 0L464 155.3V256c0 4.4 3.6 8 8 8s8-3.6 8-8V136c0-4.4-3.6-8-8-8H352z'
      
    ]
  };

  

  
  

  var faBuildingLock = {
    prefix: 'fat',
    iconName: 'building-lock',
    icon: [
      576,
      512,
      [],
      'e4d6',
      
      'M48 16H336c17.7 0 32 14.3 32 32V256c0-19.6 5.9-37.9 16-53.1V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96 16 64 16 88.6c-2.9-5-5.1-10.3-6.5-16H240V416c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-17.7 0-32-14.3-32-32V48c0-17.7 14.3-32 32-32zM224 496H160V416c0-17.7 14.3-32 32-32s32 14.3 32 32v80zM104 232c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V256c0-13.3-10.7-24-24-24H104zm-8 24c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8V256zm128 0v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V256c0-13.3-10.7-24-24-24H248c-13.3 0-24 10.7-24 24zm24-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H248c-4.4 0-8-3.6-8-8V256c0-4.4 3.6-8 8-8zM104 104c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V128c0-13.3-10.7-24-24-24H104zm-8 24c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8V128zm128 0v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V128c0-13.3-10.7-24-24-24H248c-13.3 0-24 10.7-24 24zm24-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H248c-4.4 0-8-3.6-8-8V128c0-4.4 3.6-8 8-8zm216 88c26.5 0 48 21.5 48 48v64H416V256c0-26.5 21.5-48 48-48zm-64 48v64H384c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H528V256c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-16 80h16 16 96 16 16c8.8 0 16 7.2 16 16V480c0 8.8-7.2 16-16 16H384c-8.8 0-16-7.2-16-16V352c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faRectangleHistoryCircleUser = {
    prefix: 'fat',
    iconName: 'rectangle-history-circle-user',
    icon: [
      640,
      512,
      [],
      'e4a4',
      
      'M448 144c26.5 0 48 21.5 48 48c5.4 0 10.7 .2 16 .7V192c0-35.3-28.7-64-64-64L64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64l330.8 0c-6.9-4.9-13.4-10.2-19.6-16L64 496c-26.5 0-48-21.5-48-48l0-256c0-26.5 21.5-48 48-48l384 0zm8-80L56 64c-4.4 0-8 3.6-8 8s3.6 8 8 8l400 0c4.4 0 8-3.6 8-8s-3.6-8-8-8zM408 0H104c-4.4 0-8 3.6-8 8s3.6 8 8 8l304 0c4.4 0 8-3.6 8-8s-3.6-8-8-8zM573.9 469.6C552.3 486.2 525.3 496 496 496s-56.3-9.8-77.9-26.4l3.3-6.6c9.5-19 28.9-31 50.1-31h48.9c21.2 0 40.6 12 50.1 31l3.3 6.6zm12.4-10.9l-1.5-2.9c-12.2-24.4-37.1-39.8-64.4-39.8H471.6c-27.3 0-52.2 15.4-64.4 39.8l-1.5 2.9C382.4 435.5 368 403.5 368 368c0-70.7 57.3-128 128-128s128 57.3 128 128c0 35.5-14.4 67.5-37.7 90.7zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 304a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faPersonDressFairy = {
    prefix: 'fat',
    iconName: 'person-dress-fairy',
    icon: [
      640,
      512,
      [],
      'e607',
      
      'M320 112a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM320 0a64 64 0 1 1 0 128A64 64 0 1 1 320 0zM304.3 176c-21.4 0-40.3 14.2-46.2 34.8L219 347.6c-2.9 10.2 4.8 20.4 15.4 20.4H256h48 32 48 21.6c10.6 0 18.3-10.2 15.4-20.4L381.9 210.8C376 190.2 357.2 176 335.7 176H304.3zM312 384v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H234.4c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8c7.8-27.5 33-46.4 61.5-46.4h31.5c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H392v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H312zm64 96V384H344v96c0 8.8 7.2 16 16 16s16-7.2 16-16zm-80-96H264v96c0 8.8 7.2 16 16 16s16-7.2 16-16V384zm-80 49.4v18.7C185.4 469.9 149.9 480 112 480H96c-17.7 0-32-14.3-32-32c0-45.7 14.7-88 39.7-122.3C40.6 275.9 0 198.7 0 112V64C0 46.3 14.3 32 32 32c91.1 0 172.4 42.3 225.1 108.4c-4.7 2.6-9.1 5.7-13.3 9C194 87.6 117.6 48 32 48c-8.8 0-16 7.2-16 16v48c0 81.6 38.1 154.2 97.6 201.2l6 4.8c3.4 2.7 4 7.5 1.5 11l-4.5 6.2C93.6 366.8 80 405.8 80 448c0 8.8 7.2 16 16 16h16c38.3 0 74-11.2 104-30.6zM528 480c-37.9 0-73.4-10.1-104-27.8V433.4c30 19.4 65.7 30.6 104 30.6h16c8.8 0 16-7.2 16-16c0-42.2-13.6-81.2-36.7-112.9l-4.5-6.2c-2.5-3.5-1.9-8.3 1.5-11l6-4.8C585.9 266.2 624 193.6 624 112V64c0-8.8-7.2-16-16-16c-85.6 0-162 39.6-211.9 101.4c-4.2-3.4-8.6-6.4-13.3-9C435.6 74.3 516.9 32 608 32c17.7 0 32 14.3 32 32v48c0 86.7-40.6 163.9-103.7 213.7C561.3 360 576 402.3 576 448c0 17.7-14.3 32-32 32H528z'
      
    ]
  };

  

  
  

  var faTabletButton = {
    prefix: 'fat',
    iconName: 'tablet-button',
    icon: [
      448,
      512,
      [],
      'f10a',
      
      'M64 16C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H64zM0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM208 432a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z'
      
    ]
  };

  

  
  

  var faC = {
    prefix: 'fat',
    iconName: 'c',
    icon: [
      384,
      512,
      [99],
      '43',
      
      'M76.9 108.9c-81.2 81.2-81.2 212.9 0 294.2s212.9 81.2 294.2 0c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3c-87.5 87.5-229.3 87.5-316.8 0s-87.5-229.3 0-316.8s229.3-87.5 316.8 0c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0c-81.2-81.2-212.9-81.2-294.2 0z'
      
    ]
  };

  

  
  

  var faLocationArrow = {
    prefix: 'fat',
    iconName: 'location-arrow',
    icon: [
      448,
      512,
      [],
      'f124',
      
      'M224 240H48c-7.6 0-14.2-5.4-15.7-12.9s2.6-15 9.6-17.9l352-144c6-2.4 12.8-1.1 17.4 3.5s5.9 11.4 3.5 17.4l-144 352c-2.9 7.1-10.4 11.1-17.9 9.6s-12.9-8.1-12.9-15.7V256c0-8.8-7.2-16-16-16zm-16 16h16v16V432c0 15.3 10.8 28.4 25.8 31.4s30-5.1 35.8-19.3l144-352c4.9-11.9 2.1-25.6-7-34.7s-22.8-11.9-34.7-7l-352 144c-14.2 5.8-22.2 20.8-19.3 35.8s16.1 25.8 31.4 25.8H208z'
      
    ]
  };

  

  
  

  var faMessagePlus = {
    prefix: 'fat',
    iconName: 'message-plus',
    icon: [
      512,
      512,
      ["comment-alt-plus"],
      'f4a8',
      
      'M176 416c0-8.8-7.2-16-16-16H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H309.3c-3.5 0-6.8 1.1-9.6 3.2L176 496V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h80 16v16 64c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM248 304c0 4.4 3.6 8 8 8s8-3.6 8-8V216h88c4.4 0 8-3.6 8-8s-3.6-8-8-8H264V112c0-4.4-3.6-8-8-8s-8 3.6-8 8v88H160c-4.4 0-8 3.6-8 8s3.6 8 8 8h88v88z'
      
    ]
  };

  
    var faCommentAltPlus = faMessagePlus;
  

  
  

  var faFaceSmileTear = {
    prefix: 'fat',
    iconName: 'face-smile-tear',
    icon: [
      512,
      512,
      [],
      'e393',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm80-202.7c5.9 7.7 12.6 16.6 18.5 26.1c8.6 13.8 13.5 25.5 13.5 33.6c0 16.8-14 31-32 31s-32-14.2-32-31c0-8.1 4.8-19.9 13.4-33.6c6-9.5 12.7-18.5 18.5-26.1zm6.4-18c-3.2-4.4-9.6-4.4-12.8 0c-1.2 1.6-2.5 3.3-3.9 5.1c-14.2 18.4-37.7 49-37.7 72.7c0 26 21.5 47 48 47s48-21 48-47c0-23.4-23.1-53.5-37.2-72c-1.6-2.1-3.1-4-4.4-5.8zM176.4 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm176-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM150.6 323.4c-2.5-3.6-7.5-4.5-11.1-2s-4.5 7.5-2 11.1c22.4 32 61.9 67.4 118.6 67.4c4.4 0 8-3.6 8-8s-3.6-8-8-8c-49.4 0-84.6-30.8-105.4-60.6z'
      
    ]
  };

  

  
  

  var faRoadBridge = {
    prefix: 'fat',
    iconName: 'road-bridge',
    icon: [
      640,
      512,
      [],
      'e563',
      
      'M576 16H488V96c0 4.4-3.6 8-8 8s-8-3.6-8-8V16H384c-26.5 0-48 21.5-48 48V448c0 26.5 21.5 48 48 48h88V416c0-4.4 3.6-8 8-8s8 3.6 8 8v80h88c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48zM384 0h96 96c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H384c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64zm96 192c4.4 0 8 3.6 8 8V312c0 4.4-3.6 8-8 8s-8-3.6-8-8V200c0-4.4 3.6-8 8-8zM8 96H288v16H232v80h56v16H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H88V112H8c-4.4 0-8-3.6-8-8s3.6-8 8-8zM272 304h16v16H272c-39.8 0-72 32.2-72 72v80c0 22.1-17.9 40-40 40H128c-22.1 0-40-17.9-40-40V392c0-39.8-32.2-72-72-72H8c-4.4 0-8-3.6-8-8s3.6-8 8-8h8c48.6 0 88 39.4 88 88v80c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V392c0-48.6 39.4-88 88-88zM216 112H104v80H216V112z'
      
    ]
  };

  

  
  

  var faCalendarPen = {
    prefix: 'fat',
    iconName: 'calendar-pen',
    icon: [
      448,
      512,
      ["calendar-edit"],
      'f333',
      
      'M128 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H64C28.7 64 0 92.7 0 128v48 16V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 176 128c0-35.3-28.7-64-64-64H336V8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H128V8zM16 192H432V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V192zM112 80v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80H320v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80h48c26.5 0 48 21.5 48 48v48H16V128c0-26.5 21.5-48 48-48h48zM301.3 252.3l6.4 6.4c9.4 9.4 9.4 24.6 0 33.9l-17.9 17.9-40.4-40.4 17.9-17.9c9.4-9.4 24.6-9.4 33.9 0zm-157 123l93.9-93.9 40.4 40.4-93.9 93.9c-1.1 1.1-2.4 1.8-3.9 2.1l-50.2 11.5 11.5-50.2c.3-1.5 1.1-2.8 2.1-3.9zM256 241L133 364c-3.2 3.2-5.4 7.2-6.4 11.6l-11.5 50.2c-2.6 11.5 7.7 21.8 19.2 19.2l50.2-11.5c4.4-1 8.4-3.2 11.6-6.4L319 304c15.6-15.6 15.6-40.9 0-56.6l-6.4-6.4c-15.6-15.6-40.9-15.6-56.6 0z'
      
    ]
  };

  
    var faCalendarEdit = faCalendarPen;
  

  
  

  var faFolderImage = {
    prefix: 'fat',
    iconName: 'folder-image',
    icon: [
      512,
      512,
      [],
      'e18a',
      
      'M448 464H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H197.5c12.7 0 24.9 5.1 33.9 14.1l35.9 35.9c9 9 21.2 14.1 33.9 14.1H448c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48zM64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H301.3c-8.5 0-16.6-3.4-22.6-9.4L242.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64zM168 208a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm-40-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm167.9 40c2.3 0 4.5 1.2 5.7 3.1L407.3 393.3c.5 .7 .7 1.5 .7 2.4c0 2.4-2 4.4-4.4 4.4H108.3c-2.4 0-4.3-1.9-4.3-4.3c0-.8 .3-1.7 .7-2.4L162 307.5c1.4-2.2 3.9-3.5 6.4-3.5c2.4 0 4.6 1.1 6.1 2.9L201.8 341c1.6 2 4 3.1 6.6 3s4.9-1.4 6.3-3.6L290.3 227c1.3-1.9 3.4-3 5.6-3zM277 218.1L207.4 322.5 187 296.9c-4.5-5.6-11.3-8.9-18.5-8.9c-7.9 0-15.4 4-19.8 10.6L91.4 384.5c-2.2 3.3-3.4 7.2-3.4 11.3c0 11.2 9.1 20.3 20.3 20.3H403.6c11.3 0 20.4-9.1 20.4-20.4c0-3.9-1.1-7.7-3.2-11L315.1 218.5c-4.2-6.6-11.4-10.5-19.2-10.5c-7.6 0-14.7 3.8-18.9 10.1z'
      
    ]
  };

  

  
  

  var faPersonHalfDress = {
    prefix: 'fat',
    iconName: 'person-half-dress',
    icon: [
      320,
      512,
      [],
      'e548',
      
      'M160 16a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm0 96A56 56 0 1 0 160 0a56 56 0 1 0 0 112zM90.7 175.7c9.3-19.4 28.9-31.7 50.4-31.7H152V368h-8H96 67.1l52.5-157.5c1.4-4.2-.9-8.7-5.1-10.1s-8.7 .9-10.1 5.1l-56 168c-.8 2.4-.4 5.1 1.1 7.2s3.9 3.3 6.5 3.3H88v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h16v96c0 17.7 14.3 32 32 32s32-14.3 32-32V248c0-4.4-3.6-8-8-8s-8 3.6-8 8V480c0 8.8-7.2 16-16 16s-16-7.2-16-16V376c0-4.4-3.6-8-8-8h-8V144h10.9c21.5 0 41.1 12.3 50.4 31.7l67.5 139.8c1.9 4 6.7 5.6 10.7 3.7s5.6-6.7 3.7-10.7L243.7 168.7c-12-24.9-37.2-40.7-64.8-40.7H141.1c-27.6 0-52.8 15.8-64.8 40.7L8.8 308.5c-1.9 4-.3 8.8 3.7 10.7s8.8 .3 10.7-3.7L90.7 175.7zM104 480V384h32v96c0 8.8-7.2 16-16 16s-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faFileChartColumn = {
    prefix: 'fat',
    iconName: 'file-chart-column',
    icon: [
      384,
      512,
      ["file-chart-line"],
      'f659',
      
      'M16 448V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM192 224c-17.7 0-32 14.3-32 32V416c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-16 32c0-8.8 7.2-16 16-16s16 7.2 16 16V416c0 8.8-7.2 16-16 16s-16-7.2-16-16V256zm112 32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V320c0-17.7-14.3-32-32-32zm-16 32c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V320zM96 352c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V384c0-17.7-14.3-32-32-32zM80 384c0-8.8 7.2-16 16-16s16 7.2 16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V384z'
      
    ]
  };

  
    var faFileChartLine = faFileChartColumn;
  

  
  

  var faSynagogue = {
    prefix: 'fat',
    iconName: 'synagogue',
    icon: [
      640,
      512,
      [128333],
      'f69b',
      
      'M325 1.7c-2.9-2.3-7-2.3-9.9 0L187.4 102.5C170.1 116.2 160 137 160 159V260.7L93.7 194.3c-3.1-3.1-8.2-3.1-11.3 0L11.7 265C4.2 272.5 0 282.6 0 293.3V472c0 22.1 17.9 40 40 40H168h88 16 96 16 88H600c22.1 0 40-17.9 40-40V293.3c0-10.6-4.2-20.8-11.7-28.3l-70.6-70.6c-3.1-3.1-8.2-3.1-11.3 0L480 260.7V159c0-22-10.1-42.9-27.4-56.5L325 1.7zM480 293.3c0-6.4 2.5-12.5 7-17l65-65 65 65c4.5 4.5 7 10.6 7 17V472c0 13.3-10.7 24-24 24H480V293.3zm-16 0V496H384V384c0-35.3-28.7-64-64-64s-64 28.7-64 64V496H176V293.3 159c0-17.1 7.8-33.3 21.3-44L320 18.2l122.7 96.9c13.4 10.6 21.3 26.8 21.3 44V293.3zM368 496H272V384c0-26.5 21.5-48 48-48s48 21.5 48 48V496zm-208 0H40c-13.3 0-24-10.7-24-24V293.3c0-6.4 2.5-12.5 7-17l65-65 65 65c4.5 4.5 7 10.6 7 17V496zm77.9-340.8L258.3 191l-20.5 35.8c-4 6.9 1 15.6 9 15.6h40.8L311 283.1c4 7 14.1 7 18.1 0l23.3-40.7h40.8c8 0 13-8.6 9-15.6L381.7 191l20.5-35.8c4-6.9-1-15.6-9-15.6H352.3L329 98.9c-4-7-14.1-7-18.1 0l-23.3 40.7H246.9c-8 0-13 8.6-9 15.6zm27.9 48.7l14.7 25.7H251l14.7-25.7zm29.4 25.7L273.1 191l22.1-38.6h49.7L366.9 191l-22.1 38.6H295.1zm7.3 12.8h35.1L320 273.1l-17.5-30.7zm57.1-12.8l14.7-25.7L389 229.6H359.6zm14.7-51.5l-14.7-25.7H389l-14.7 25.7zm-36.7-38.5H302.5L320 108.9l17.5 30.7zm-57.1 12.8l-14.7 25.7L251 152.4h29.4z'
      
    ]
  };

  

  
  

  var faGlobe = {
    prefix: 'fat',
    iconName: 'globe',
    icon: [
      512,
      512,
      [127760],
      'f0ac',
      
      'M256 496c26 0 53.9-21.5 76.2-66.1c11-21.9 19.9-48.3 26.2-77.9H153.6c6.2 29.5 15.2 55.9 26.2 77.9C202.1 474.5 230 496 256 496zM150.6 336H361.4c4.3-25 6.6-51.9 6.6-80s-2.3-55-6.6-80H150.6c-4.3 25-6.6 51.9-6.6 80s2.3 55 6.6 80zm3-176H358.4c-6.2-29.6-15.2-55.9-26.2-77.9C309.9 37.5 282 16 256 16s-53.9 21.5-76.2 66.1c-11 21.9-19.9 48.3-26.2 77.9zm224 16c4.1 25.2 6.4 52.1 6.4 80s-2.2 54.8-6.4 80H482.3c8.8-25 13.7-51.9 13.7-80s-4.8-55-13.7-80H377.6zM476 160C445.6 90.5 383.2 38.1 307.5 21.5c30.5 26.8 54.7 76.6 67.2 138.5H476zm-338.7 0c12.5-61.8 36.8-111.7 67.2-138.5C128.8 38.1 66.4 90.5 36 160H137.3zM29.7 176C20.8 201 16 227.9 16 256s4.8 55 13.7 80H134.4c-4.1-25.2-6.4-52.1-6.4-80s2.2-54.8 6.4-80H29.7zM307.5 490.5C383.2 473.9 445.6 421.5 476 352H374.7c-12.5 61.8-36.8 111.7-67.2 138.5zm-102.9 0c-30.5-26.8-54.7-76.6-67.2-138.5H36c30.4 69.5 92.8 121.9 168.6 138.5zM256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512z'
      
    ]
  };

  

  
  

  var faPersonDolly = {
    prefix: 'fat',
    iconName: 'person-dolly',
    icon: [
      512,
      512,
      [],
      'f4d0',
      
      'M91.4 226.4c-6.7 2-11.4 8.3-11.4 15.3v65.1c0 4.2 1.7 8.3 4.7 11.3l51 51c4.7 4.7 7.8 10.8 8.9 17.4l15.2 90.9c1.5 8.7-4.4 17-13.2 18.4s-17-4.4-18.4-13.2l-14.3-85.9c-.5-3.3-2.1-6.3-4.5-8.7L30.1 308.7c-9-9-14.1-21.2-14.1-33.9V186.6C16 163.1 35.1 144 58.6 144c18.7 0 36.2 9.3 46.5 24.9l42.6 64c3 4.5 8 7.1 13.3 7.1h57.3l7.4 31.9c-.6 .1-1.3 .1-1.9 .1H152.6c-10.7 0-20.7-5.3-26.6-14.3l-16.6-24.9c-3.9-5.9-11.2-8.5-17.9-6.4zM224 288c1.9 0 3.7-.2 5.5-.5l24.7 106.1C236.1 404.9 224 425 224 448c0 35.3 28.7 64 64 64c33.8 0 61.6-26.3 63.8-59.5l154-36.7c4.3-1 7-5.3 5.9-9.6s-5.3-7-9.6-5.9l-151.2 36C345.4 406.5 319.3 384 288 384c-6.6 0-12.9 1-18.9 2.8L215.8 158.2c-1-4.3-5.3-7-9.6-6s-7 5.3-6 9.6L214.7 224H161.1l-42.6-64c-13.3-20-35.8-32-59.9-32C26.2 128 0 154.2 0 186.6v88.1c0 17 6.7 33.3 18.7 45.3l79.4 79.4 14.3 85.9c2.9 17.4 19.4 29.2 36.8 26.3s29.2-19.4 26.3-36.8l-15.2-90.9c-1.6-9.9-6.3-19-13.4-26.1l-51-51V270.5 241.7l16 24 .6 .9c8.9 13.4 23.9 21.4 39.9 21.4H224zM80 16a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm48 32A48 48 0 1 0 32 48a48 48 0 1 0 96 0zM0 346.5L0 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-69.5-16-16L48 480c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-117.5-16-16zM240 448a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM445.1 337.8l-91.5 22.9c-8.6 2.1-17.3-3.1-19.4-11.6l-22.9-91.5c-2.1-8.6 3.1-17.3 11.6-19.4l91.5-22.9c8.6-2.1 17.3 3.1 19.4 11.6l22.9 91.5c2.1 8.6-3.1 17.3-11.6 19.4zm3.9 15.5c17.1-4.3 27.6-21.7 23.3-38.8L449.4 223c-4.3-17.1-21.7-27.6-38.8-23.3L319 222.6c-17.1 4.3-27.6 21.7-23.3 38.8L318.6 353c4.3 17.1 21.7 27.6 38.8 23.3L449 353.4z'
      
    ]
  };

  

  
  

  var faLocationCrosshairsSlash = {
    prefix: 'fat',
    iconName: 'location-crosshairs-slash',
    icon: [
      640,
      512,
      ["location-slash"],
      'f603',
      
      'M401.5 412.1C377.1 424.8 349.4 432 320 432c-97.2 0-176-78.8-176-176c0-14.8 1.8-29.3 5.3-43l-13.7-10.8c-4.3 14.6-6.8 30-7.5 45.8H72c-4.4 0-8 3.6-8 8s3.6 8 8 8h56.2c4.1 99.7 84.2 179.8 183.8 183.8V504c0 4.4 3.6 8 8 8s8-3.6 8-8V447.8c31.6-1.3 61.2-10.2 87.1-25l-13.6-10.8zM312 64.2c-31.6 1.3-61.2 10.2-87.1 25l13.6 10.8C262.9 87.2 290.6 80 320 80c97.2 0 176 78.8 176 176c0 14.8-1.8 29.3-5.3 43l13.7 10.8c4.3-14.6 6.8-30 7.5-45.8H568c4.4 0 8-3.6 8-8s-3.6-8-8-8H511.8C507.8 148.3 427.7 68.2 328 64.2V8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64.2zM320 352c1.8 0 3.5 0 5.2-.1l-22.4-17.7c-24.2-5.3-44.3-21.5-54.8-43.3l-22.5-17.7C233.6 318 272.8 352 320 352zm-5.2-191.9l22.4 17.7c24.2 5.3 44.3 21.5 54.8 43.3l22.5 17.7C406.4 194 367.2 160 320 160c-1.8 0-3.5 0-5.2 .1zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  
    var faLocationSlash = faLocationCrosshairsSlash;
  

  
  

  var faSteak = {
    prefix: 'fat',
    iconName: 'steak',
    icon: [
      576,
      512,
      [129385],
      'f824',
      
      'M368 16c58.3 0 106.9 35.2 138 74c31.9 39.9 54 93.7 54 150c0 76.7-50.6 141.4-106.9 183.3C395 466.6 317.8 496 240 496c-35.8 0-83.6-4.3-124.8-18.5C79.2 465.2 16 432.9 16 360c0-33.1 15.1-58.4 36.5-75.6c18.2-14.6 38.5-24.9 60.5-36c2.7-1.4 5.5-2.8 8.2-4.2c24.6-12.6 50.8-26.8 73.5-49.5c16.1-16.1 23-32.8 32.9-56.6l.6-1.6c3.2-7.7 6.8-16.3 11.1-26.3c7.6-17.3 19.3-41.7 40.3-61.2C303.3 27.1 333.3 16 368 16zm0-16c-38.3 0-72.3 12.4-99.2 37.4c-23.5 21.9-36.3 48.9-44.1 66.5c-4.4 10.1-8 18.9-11.2 26.6c-10.4 25.1-16.2 39.1-30 52.9c-23.1 23.1-50.4 36.9-77.7 50.7c-21.8 11-43.6 22.1-63.3 37.8C17.8 291.7 0 321.4 0 360c0 84.3 73.4 120.1 110 132.7c43.5 15 93.3 19.3 130 19.3c81.7 0 162.1-30.8 222.6-75.8C520.9 392.8 576 323.9 576 240c0-60.4-23.6-117.6-57.5-160C485.7 39 433 0 368 0zm16 248a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-40-24a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zM121.7 316l0 0-1.3 .6 0 0c-15 6.4-27.2 11.7-35.6 18.8c-3.4 2.9-7 6.8-9.5 12.4C72.9 353.1 72 359 72 365.2c0 28.6 24.3 47.4 57.8 59.1C163.1 435.8 204.7 440 238 440c65 0 131.5-25.2 181.8-62.9c50.3-37.8 84.2-88 84.2-137.9c0-41.8-16.6-83.6-41.5-115C437.6 92.8 404.4 72 371.3 72c-20.7 0-35.2 6.3-46.2 16.6C314 99 306.3 113.6 299 130.4c-2.5 5.7-5 11.9-7.5 18.2l0 0 0 .1c-12 29.8-25.8 63.7-53 91.2C193 285.6 151.7 303.2 121.7 316zm128.1-64.9c29.8-30.1 44.6-66.9 56.5-96.5c2.6-6.3 5-12.4 7.4-17.9c7.1-16.5 13.8-28.4 22.4-36.4C343.9 93 354.3 88 371.3 88c26.5 0 55.5 17 78.7 46.2c22.9 28.9 38 67.3 38 105c0 42.9-29.5 88.9-77.8 125.1C362.3 400.2 299.1 424 238 424c-32.3 0-72-4.1-102.9-14.8c-32.4-11.2-47.1-26.4-47.1-44c0-9.5 2.7-13.8 7.2-17.7c6.1-5.2 15.6-9.5 31.4-16.2l1.3-.6c30.5-13 74.1-31.5 121.9-79.6z'
      
    ]
  };

  

  
  

  var faBullhorn = {
    prefix: 'fat',
    iconName: 'bullhorn',
    icon: [
      512,
      512,
      [128226,128363],
      'f0a1',
      
      'M464 32c0-28.1-33.7-42.6-54.1-23.2l-44 41.9C326.4 88.4 277 113.4 224 123.3v16.3c57.1-10 110.4-36.7 152.9-77.2l44-41.9c10.2-9.7 27-2.5 27 11.6V448c0 14.1-16.8 21.3-27 11.6l-44-41.9c-42.5-40.5-95.8-67.2-152.9-77.2v16.3c53 9.9 102.4 34.9 141.9 72.5l44 41.9c20.4 19.4 54.1 5 54.1-23.2V313.3c28.3-12.3 48-40.5 48-73.3s-19.7-61-48-73.3V32zM192 416V352.7v-16V143.4v-16c-6.4 .4-12.8 .7-19.2 .7H160l-96 0c-35.3 0-64 28.7-64 64v96c0 35.3 28.7 64 64 64l0 120c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V416zM464 295.4V184.6c19.1 11.1 32 31.7 32 55.4s-12.9 44.4-32 55.4zM176 352V472c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V352h80 12.8c1.1 0 2.1 0 3.2 0zm-3.2-16H160 64c-26.5 0-48-21.5-48-48V192c0-26.5 21.5-48 48-48l96 0h12.8c1.1 0 2.1 0 3.2 0V336c-1.1 0-2.1 0-3.2 0z'
      
    ]
  };

  

  
  

  var faBoxCheck = {
    prefix: 'fat',
    iconName: 'box-check',
    icon: [
      448,
      512,
      [],
      'f467',
      
      'M232 48H342.4c19 0 36.2 11.2 43.9 28.5l41.6 93.6c.9 1.9 1.6 3.9 2.2 5.9H232V48zM16 192H432V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V192zm200-16H18c.6-2 1.3-4 2.2-5.9L61.7 76.5C69.4 59.2 86.6 48 105.6 48H216V176zM400.9 70c-10.3-23.1-33.2-38-58.5-38H105.6C80.3 32 57.4 46.9 47.1 70L5.5 163.6c-3.6 8.2-5.5 17-5.5 26V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V189.6c0-9-1.9-17.8-5.5-26L400.9 70zM325.7 261.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L192 372.7l-58.3-58.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l64 64c3.1 3.1 8.2 3.1 11.3 0l128-128z'
      
    ]
  };

  

  
  

  var faTamale = {
    prefix: 'fat',
    iconName: 'tamale',
    icon: [
      320,
      512,
      [129748],
      'e451',
      
      'M295.1 296l24.5 146.7c1.7 10.2-1.7 20.6-9 27.9C274 507 207.7 512 160 512s-114-5-150.6-41.3c-7.3-7.3-10.7-17.7-9-27.9L24.9 296H41.1L16.2 445.4c-.8 5.1 .8 10.3 4.5 14c15.2 15.1 37.6 24.5 63.2 30c25.5 5.4 52.7 6.7 76.1 6.7s50.6-1.2 76.1-6.7c25.6-5.5 48-14.9 63.2-30c3.7-3.7 5.3-8.9 4.5-14L278.9 296h16.2zM319.6 69.3L295.1 216H278.9L303.8 66.6c.8-5.1-.8-10.3-4.5-14c-15.2-15.1-37.6-24.5-63.2-30C210.6 17.2 183.4 16 160 16s-50.6 1.2-76.1 6.7c-25.6 5.5-48 14.9-63.2 30c-3.7 3.7-5.3 8.9-4.5 14L41.1 216H24.9L.4 69.3c-1.7-10.2 1.7-20.6 9-27.9C46 5 112.3 0 160 0s114 5 150.6 41.3c7.3 7.3 10.7 17.7 9 27.9zM8 256c0-4.4 3.6-8 8-8H160 304c4.4 0 8 3.6 8 8s-3.6 8-8 8H176.4l46 59.1c2.7 3.5 2.1 8.5-1.4 11.2s-8.5 2.1-11.2-1.4L160 269l-49.7 63.9c-2.7 3.5-7.7 4.1-11.2 1.4s-4.1-7.7-1.4-11.2l46-59.1H16c-4.4 0-8-3.6-8-8zM160 64c4.4 0 8 3.6 8 8V216h-8-8V72c0-4.4 3.6-8 8-8zm0 258.7l8 10.7V440c0 4.4-3.6 8-8 8s-8-3.6-8-8V333.3l8-10.7zM88 79.3L100.4 216H84.3L72 80.7c-.4-4.4 2.8-8.3 7.2-8.7s8.3 2.8 8.7 7.2zM88 352c2.2 1.7 4.5 3 6.9 4.2l-7 76.5c-.4 4.4-4.3 7.6-8.7 7.2s-7.6-4.3-7.2-8.7L80 344c2.2 3 4.9 5.7 8 8zm144 0c3.1-2.3 5.8-5 8-8l7.9 87.3c.4 4.4-2.8 8.3-7.2 8.7s-8.3-2.8-8.7-7.2l-7-76.5c2.4-1.1 4.7-2.5 6.9-4.2zM219.6 216L232 79.3c.4-4.4 4.3-7.6 8.7-7.2s7.6 4.3 7.2 8.7L235.7 216H219.6z'
      
    ]
  };

  

  
  

  var faHatSanta = {
    prefix: 'fat',
    iconName: 'hat-santa',
    icon: [
      640,
      512,
      [],
      'f7a7',
      
      'M371.4 226.8c-2.2-4.7-3.4-9.9-3.4-15.2c0-19.7 15.9-35.6 35.6-35.6h1.2c3.8 0 7.5 .6 11.1 1.7l49 15.5c-.3 2.4-.5 4.8-.5 7.2c-2.3 2.3-4.4 4.8-6.3 7.4L411.1 193c-2-.6-4.1-1-6.3-1h-1.2c-10.8 0-19.6 8.8-19.6 19.6c0 2.9 .6 5.7 1.9 8.4l54.6 116H422.8L371.4 226.8zm104.9-60.9l-54.1-63.9C393.3 67.7 350.7 48 305.9 48c-62.3 0-118.3 37.9-141.4 95.7L87.6 336H70.4l79.3-198.2C175.2 73.9 237.1 32 305.9 32c49.5 0 96.5 21.8 128.5 59.6l53.5 63.2c-2.5 1.8-4.9 3.8-7.1 6c-1.6 1.6-3.1 3.3-4.5 5.1zM456 384H56c-22.1 0-40 17.9-40 40s17.9 40 40 40H456c22.1 0 40-17.9 40-40s-17.9-40-40-40zM56 368H456c30.9 0 56 25.1 56 56s-25.1 56-56 56H56c-30.9 0-56-25.1-56-56s25.1-56 56-56zM573.5 183.4c-2.9-4.5-7.9-7.4-13.5-7.4s-10.6 2.9-13.5 7.4c-3.6 5.7-10.4 8.5-16.9 7c-5.2-1.2-10.8 .3-14.8 4.3s-5.5 9.6-4.3 14.8c1.5 6.6-1.4 13.3-7 16.9c-4.5 2.9-7.4 7.9-7.4 13.5s2.9 10.6 7.4 13.5c5.7 3.6 8.5 10.4 7 16.9c-1.2 5.2 .3 10.8 4.3 14.8s9.6 5.5 14.8 4.3c6.6-1.5 13.3 1.4 16.9 7c2.9 4.5 7.9 7.4 13.5 7.4s10.6-2.9 13.5-7.4c3.6-5.7 10.4-8.5 16.9-7c5.2 1.2 10.8-.3 14.8-4.3s5.5-9.6 4.3-14.8c-1.5-6.6 1.4-13.3 7-16.9c4.5-2.9 7.4-7.9 7.4-13.5s-2.9-10.6-7.4-13.5c-5.7-3.6-8.5-10.4-7-16.9c1.2-5.2-.3-10.8-4.3-14.8s-9.6-5.5-14.8-4.3c-6.6 1.5-13.3-1.4-16.9-7zM640 240c0 11.3-5.9 21.3-14.8 27c2.3 10.3-.6 21.5-8.6 29.6s-19.3 10.9-29.6 8.6c-5.7 8.9-15.6 14.8-27 14.8s-21.3-5.9-27-14.8c-10.3 2.3-21.5-.6-29.6-8.6s-10.9-19.3-8.6-29.6c-8.9-5.7-14.8-15.7-14.8-27s5.9-21.3 14.8-27c-2.3-10.3 .6-21.5 8.6-29.6s19.3-10.9 29.6-8.6c5.7-8.9 15.6-14.8 27-14.8s21.3 5.9 27 14.8c10.3-2.3 21.5 .6 29.6 8.6s10.9 19.3 8.6 29.6c8.9 5.7 14.8 15.7 14.8 27z'
      
    ]
  };

  

  
  

  var faArrowLeftToBracket = {
    prefix: 'fat',
    iconName: 'arrow-left-to-bracket',
    icon: [
      512,
      512,
      [],
      'e669',
      
      'M298.3 114.3l-136 136c-3.1 3.1-3.1 8.2 0 11.3l136 136c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L187.3 264 504 264c4.4 0 8-3.6 8-8s-3.6-8-8-8l-316.7 0L309.7 125.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0zM184 464l-96 0c-39.8 0-72-32.2-72-72l0-272c0-39.8 32.2-72 72-72l96 0c4.4 0 8-3.6 8-8s-3.6-8-8-8L88 32C39.4 32 0 71.4 0 120L0 392c0 48.6 39.4 88 88 88l96 0c4.4 0 8-3.6 8-8s-3.6-8-8-8z'
      
    ]
  };

  

  
  

  var faKey = {
    prefix: 'fat',
    iconName: 'key',
    icon: [
      512,
      512,
      [128273],
      'f084',
      
      'M287.2 328.4c15.4 4.9 31.8 7.6 48.8 7.6c88.4 0 160-71.6 160-160s-71.6-160-160-160s-160 71.6-160 160c0 17.1 2.7 33.5 7.6 48.8c1.8 5.7 .3 12-3.9 16.2L18.3 402.3c-1.5 1.5-2.3 3.5-2.3 5.7v80c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V448c0-8.8 7.2-16 16-16h40c4.4 0 8-3.6 8-8V384c0-8.8 7.2-16 16-16h40c2.1 0 4.2-.8 5.7-2.3L271 332.3c4.2-4.2 10.5-5.8 16.2-3.9zM336 352c-18.7 0-36.8-2.9-53.7-8.3L249 377c-4.5 4.5-10.6 7-17 7H208 192v16 24c0 13.3-10.7 24-24 24H144 128v16 24c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V408c0-6.4 2.5-12.5 7-17L168.3 229.7c-5.4-16.9-8.3-35-8.3-53.7C160 78.8 238.8 0 336 0s176 78.8 176 176s-78.8 176-176 176zm32-248a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faWavePulse = {
    prefix: 'fat',
    iconName: 'wave-pulse',
    icon: [
      640,
      512,
      ["heart-rate"],
      'f5f8',
      
      'M319.8 0c3.8-.1 7.1 2.5 8 6.1l90.1 375.6 46.6-116.5c6.1-15.2 20.8-25.1 37.1-25.1H632c4.4 0 8 3.6 8 8s-3.6 8-8 8H501.7c-9.8 0-18.6 6-22.3 15.1L423.4 411c-1.3 3.2-4.5 5.3-8 5s-6.4-2.7-7.2-6.1L320.8 45.8l-89 459.7c-.7 3.7-3.9 6.4-7.6 6.5s-7.1-2.4-8-6.1L158.3 274.2C155.6 263.5 146 256 135 256H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H135c18.4 0 34.4 12.5 38.8 30.3L223 467 312.1 6.5c.7-3.7 3.9-6.4 7.7-6.5z'
      
    ]
  };

  
    var faHeartRate = faWavePulse;
  

  
  

  var faHighlighter = {
    prefix: 'fat',
    iconName: 'highlighter',
    icon: [
      576,
      512,
      [],
      'f591',
      
      'M144 312.6v-64c0-10.3 5-20 13.3-26l31.4-22.6L343.9 355.2l-22.6 31.4c-6 8.4-15.7 13.3-26 13.3h-64c-4.2 0-8.3 1.7-11.3 4.7l-35.7 35.7c-9.4 9.4-24.6 9.4-33.9 0l-46.8-46.8c-9.4-9.4-9.4-24.6 0-33.9l35.7-35.7c3-3 4.7-7.1 4.7-11.3zM520.8 108.9L353.4 342.1 201.9 190.6 435.1 23.2c6.5-4.7 14.3-7.2 22.4-7.2c10.2 0 19.9 4 27.1 11.2l32.2 32.2C524 66.6 528 76.3 528 86.5c0 8-2.5 15.8-7.2 22.4zM231.4 416h64c15.5 0 30-7.4 39-20L533.8 118.2C540.4 109 544 97.9 544 86.5c0-14.4-5.7-28.2-15.9-38.4L495.9 15.9C485.7 5.7 471.9 0 457.5 0C446.1 0 435 3.6 425.8 10.2L148 209.6c-12.6 9-20 23.5-20 39v64L92.3 348.3c-15.6 15.6-15.6 41 0 56.6l46.8 46.8c15.6 15.6 40.9 15.6 56.6 0L231.4 416zm-172 1.3L7.3 469.4C2.6 474.1 0 480.4 0 487c0 13.8 11.2 25 25 25H82.7c10.6 0 20.8-4.2 28.3-11.7l15.7-15.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L99.7 489c-4.5 4.5-10.6 7-17 7H25c-5 0-9-4-9-9c0-2.4 .9-4.7 2.6-6.3l52.1-52.1c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0z'
      
    ]
  };

  

  
  

  var faSquareCaretLeft = {
    prefix: 'fat',
    iconName: 'square-caret-left',
    icon: [
      448,
      512,
      ["caret-square-left"],
      'f191',
      
      'M16 416c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-320c0-26.5-21.5-48-48-48L64 48C37.5 48 16 69.5 16 96l0 320zm48 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zm64-224c0-7.3 3-14.3 8.4-19.3L245.6 134.8c4.7-4.4 10.8-6.8 17.2-6.8c13.9 0 25.2 11.3 25.2 25.2l0 205.6c0 13.9-11.3 25.2-25.2 25.2c-6.4 0-12.5-2.4-17.2-6.8L136.4 275.3c-5.4-5-8.4-12-8.4-19.3zM272 358.8l0-205.6c0-5.1-4.1-9.2-9.2-9.2c-2.3 0-4.6 .9-6.3 2.5L147.3 248.4c-2.1 2-3.3 4.7-3.3 7.6s1.2 5.6 3.3 7.6L256.5 365.5c1.7 1.6 4 2.5 6.3 2.5c5.1 0 9.2-4.1 9.2-9.2z'
      
    ]
  };

  
    var faCaretSquareLeft = faSquareCaretLeft;
  

  
  

  var faLightSwitch = {
    prefix: 'fat',
    iconName: 'light-switch',
    icon: [
      384,
      512,
      [],
      'e017',
      
      'M320 16c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H320zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM272 368c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32V264H272V368zM112 144c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32V248H112V144zm32-48c-26.5 0-48 21.5-48 48V368c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H144zm64-40a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 400a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faBuildingUser = {
    prefix: 'fat',
    iconName: 'building-user',
    icon: [
      640,
      512,
      [],
      'e4da',
      
      'M48 16H336c17.7 0 32 14.3 32 32V378.4c5-3.9 10.4-7.5 16-10.7V271.8 48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96 16 64 16 89.9c-3-4.9-5.5-10.3-7.2-16H240V416c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-17.7 0-32-14.3-32-32V48c0-17.7 14.3-32 32-32zM224 496H160V416c0-17.7 14.3-32 32-32s32 14.3 32 32v80zM104 232c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V256c0-13.3-10.7-24-24-24H104zm-8 24c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8V256zm128 0v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V256c0-13.3-10.7-24-24-24H248c-13.3 0-24 10.7-24 24zm24-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H248c-4.4 0-8-3.6-8-8V256c0-4.4 3.6-8 8-8zM104 104c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V128c0-13.3-10.7-24-24-24H104zm-8 24c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8V128zm128 0v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V128c0-13.3-10.7-24-24-24H248c-13.3 0-24 10.7-24 24zm24-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H248c-4.4 0-8-3.6-8-8V128c0-4.4 3.6-8 8-8zM432 272a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM368 477.1c0-42.6 34.5-77.1 77.1-77.1H546.9c42.6 0 77.1 34.5 77.1 77.1c0 10.4-8.5 18.9-18.9 18.9H386.9c-10.4 0-18.9-8.5-18.9-18.9zM496 352a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm-50.9 32c-51.4 0-93.1 41.7-93.1 93.1c0 19.3 15.6 34.9 34.9 34.9H605.1c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1H445.1z'
      
    ]
  };

  

  
  

  var faVanShuttle = {
    prefix: 'fat',
    iconName: 'van-shuttle',
    icon: [
      640,
      512,
      [128656,"shuttle-van"],
      'f5b6',
      
      'M16 80V192H160V48H48C30.3 48 16 62.3 16 80zm0 128V336c0 17.7 14.3 32 32 32H65.3c7.6-45.4 47.1-80 94.7-80s87.1 34.6 94.7 80H385.3c7.6-45.4 47.1-80 94.7-80s87.1 34.6 94.7 80H592c17.7 0 32-14.3 32-32V212.8c0-1.6-.2-3.2-.5-4.8H376 168 16zm160-16H368V48H176V192zm208 0H613.4L483.7 55.5c-4.5-4.8-10.8-7.5-17.4-7.5H384V192zM592 384H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V80C0 53.5 21.5 32 48 32H168 376h90.3c11 0 21.4 4.5 29 12.4L629 185.2c7.1 7.4 11 17.3 11 27.6V336c0 26.5-21.5 48-48 48zm-32 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM160 464a80 80 0 1 0 0-160 80 80 0 1 0 0 160z'
      
    ]
  };

  
    var faShuttleVan = faVanShuttle;
  

  
  

  var faDumpster = {
    prefix: 'fat',
    iconName: 'dumpster',
    icon: [
      576,
      512,
      [],
      'f793',
      
      'M39.9 58.9C42.1 52.4 48.2 48 55.1 48h92.7l-24 96H27.5c-6.4 0-11.5-5.2-11.5-11.5c0-1.2 .2-2.5 .6-3.6L39.9 58.9zM164.2 48H280v96H140.2l24-96zM296 48H411.8l24 96H296V48zm132.2 0h92.7c6.9 0 13 4.4 15.2 10.9l23.3 69.9 15.2-5.1L551.3 53.9C546.9 40.8 534.7 32 520.9 32H55.1c-13.8 0-26 8.8-30.4 21.9L1.4 123.8c-.9 2.8-1.4 5.7-1.4 8.7C0 147.7 12.3 160 27.5 160H548.5c15.2 0 27.5-12.3 27.5-27.5c0-3-.5-5.9-1.4-8.7l-15.2 5.1c.4 1.2 .6 2.4 .6 3.6c0 6.4-5.2 11.5-11.5 11.5H452.2l-24-96zM47.9 198.9c-.6-4.4-4.7-7.4-9.1-6.8s-7.4 4.7-6.8 9.1L38.8 248H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H41.1l23 161.1c.6 3.9 3.9 6.9 7.9 6.9H96v40c0 4.4 3.6 8 8 8s8-3.6 8-8V432H464v40c0 4.4 3.6 8 8 8s8-3.6 8-8V432h24c4 0 7.4-2.9 7.9-6.9l23-161.1H568c4.4 0 8-3.6 8-8s-3.6-8-8-8H537.2l6.7-46.9c.6-4.4-2.4-8.4-6.8-9.1s-8.4 2.4-9.1 6.8l-8 55.9 0 .3-23 161H472 104 78.9l-23-161 0-.3-8-55.9z'
      
    ]
  };

  

  
  

  var faArrowDownToArc = {
    prefix: 'fat',
    iconName: 'arrow-down-to-arc',
    icon: [
      512,
      512,
      [],
      'e4ae',
      
      'M256 496c132.5 0 240-107.5 240-240c0-4.4 3.6-8 8-8s8 3.6 8 8c0 141.4-114.6 256-256 256S0 397.4 0 256c0-4.4 3.6-8 8-8s8 3.6 8 8c0 132.5 107.5 240 240 240zM390.1 197.2l-128 152c-1.5 1.8-3.8 2.8-6.1 2.8s-4.6-1-6.1-2.8l-128-152c-2.8-3.4-2.4-8.4 1-11.3s8.4-2.4 11.3 1L248 322.1 248 8c0-4.4 3.6-8 8-8s8 3.6 8 8l0 314.1L377.9 186.8c2.8-3.4 7.9-3.8 11.3-1s3.8 7.9 1 11.3z'
      
    ]
  };

  

  
  

  var faLightEmergency = {
    prefix: 'fat',
    iconName: 'light-emergency',
    icon: [
      448,
      512,
      [],
      'e41f',
      
      'M368 320V192c0-79.5-64.5-144-144-144S80 112.5 80 192V320H64V192c0-88.4 71.6-160 160-160s160 71.6 160 160V320H368zM48 368c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32H400c17.7 0 32-14.3 32-32V400c0-17.7-14.3-32-32-32H48zm0-16H400c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V400c0-26.5 21.5-48 48-48zm96.4-168c-.4 4.4-4 8-8.4 8s-8-3.6-7.7-8c3.8-46.6 41-83.8 87.7-87.7c4.4-.4 8 3.3 8 7.7s-3.6 8-8 8.4c-37.8 3.7-67.9 33.8-71.6 71.6z'
      
    ]
  };

  

  
  

  var faToiletPaperUnder = {
    prefix: 'fat',
    iconName: 'toilet-paper-under',
    icon: [
      512,
      512,
      ["toilet-paper-reverse"],
      'e2a0',
      
      'M16 192c0 49.7 11.4 94.3 29.4 126.2C63.6 350.3 87.4 368 112 368H354.8c-13.6-10.2-25.5-24.7-35.3-42C299.9 291.3 288 243.9 288 192s11.9-99.3 31.5-134c9.8-17.3 21.7-31.8 35.3-42H112C87.4 16 63.6 33.7 45.4 65.8C27.4 97.7 16 142.3 16 192zM333.4 65.8C315.4 97.7 304 142.3 304 192s11.4 94.3 29.4 126.2c18.2 32.1 42 49.8 66.6 49.8s48.4-17.7 66.6-49.8c18-31.9 29.4-76.5 29.4-126.2s-11.4-94.3-29.4-126.2C448.4 33.7 424.6 16 400 16s-48.4 17.7-66.6 49.8zM496 472V291.5c-4.4 12.5-9.6 24.1-15.5 34.6c-19.5 34.5-47.6 58-80.5 58H112c-32.9 0-61-23.5-80.5-58C11.9 291.3 0 243.9 0 192S11.9 92.7 31.5 58C51 23.5 79.1 0 112 0H400c32.9 0 61 23.5 80.5 58C500.1 92.7 512 140.1 512 192V472c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V416h16v56c0 13.3 10.7 24 24 24H472c13.3 0 24-10.7 24-24zM400 264c-8.7 0-15.7-4.2-20.6-9c-4.8-4.8-8.4-10.8-11.1-17.1c-5.4-12.6-8.3-28.8-8.3-45.9s2.9-33.3 8.3-45.9c2.7-6.3 6.3-12.3 11.1-17.1c4.9-4.8 11.9-9 20.6-9s15.7 4.2 20.6 9c4.8 4.8 8.4 10.8 11.1 17.1c5.4 12.6 8.3 28.8 8.3 45.9s-2.9 33.3-8.3 45.9c-2.7 6.3-6.3 12.3-11.1 17.1c-4.9 4.8-11.9 9-20.6 9zm24-72c0-30.9-10.7-56-24-56s-24 25.1-24 56s10.7 56 24 56s24-25.1 24-56zM64 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  
    var faToiletPaperReverse = faToiletPaperUnder;
  

  
  

  var faSchoolCircleCheck = {
    prefix: 'fat',
    iconName: 'school-circle-check',
    icon: [
      640,
      512,
      [],
      'e56b',
      
      'M315.4 1.4c2.8-1.9 6.4-1.9 9.2 0L482.5 112H584c30.9 0 56 25.1 56 56v98.8c-4.9-6.9-10.2-13.5-16-19.6V168c0-22.1-17.9-40-40-40H480c-1.6 0-3.2-.5-4.6-1.4L320 17.8 164.6 126.6c-1.3 .9-2.9 1.4-4.6 1.4H56c-22.1 0-40 17.9-40 40V456c0 22.1 17.9 40 40 40H256V384c0-35.3 28.7-64 64-64c2.2 0 4.4 .1 6.5 .3c-1.4 5.2-2.7 10.4-3.6 15.8c-1-.1-1.9-.1-2.9-.1c-26.5 0-48 21.5-48 48V496h32 64 7.2c6.1 5.8 12.7 11.1 19.6 16H384 368 272 256 56c-30.9 0-56-25.1-56-56V168c0-30.9 25.1-56 56-56H157.5L315.4 1.4zM88 192h32c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V216c0-13.3 10.7-24 24-24zm-8 24v48c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V216c0-4.4-3.6-8-8-8H88c-4.4 0-8 3.6-8 8zm240 24a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-144a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm8 48v24h16c4.4 0 8 3.6 8 8s-3.6 8-8 8H320c-4.4 0-8-3.6-8-8V144c0-4.4 3.6-8 8-8s8 3.6 8 8zM64 344c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V344zm24-8c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V344c0-4.4-3.6-8-8-8H88zM496 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm69.7 98.3c3.1 3.1 3.1 8.2 0 11.3l-80 80c-3.1 3.1-8.2 3.1-11.3 0l-48-48c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L480 396.7l74.3-74.3c3.1-3.1 8.2-3.1 11.3 0z'
      
    ]
  };

  

  
  

  var faComma = {
    prefix: 'fat',
    iconName: 'comma',
    icon: [
      192,
      512,
      [],
      '2c',
      
      'M138 374.6c5-7.4 7.6-16.3 7.6-25.3c0-24.9-20.2-45.3-45-45.3c-21.8 0-40.4 15.6-44.3 37.1L32.2 476.7c-1.8 10 5.9 19.3 16.1 19.3c5.5 0 10.6-2.7 13.6-7.3L138 374.6zm13.3 8.9L75.3 497.6c-6 9-16.1 14.4-26.9 14.4c-20.2 0-35.4-18.2-31.9-38.1L40.7 338.2c5.2-29.1 30.5-50.2 60-50.2c33.7 0 61 27.6 61 61.3c0 12.1-3.6 24.1-10.3 34.2z'
      
    ]
  };

  

  
  

  var faSensor = {
    prefix: 'fat',
    iconName: 'sensor',
    icon: [
      448,
      512,
      [],
      'e028',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 8V280c0 4.4-3.6 8-8 8s-8-3.6-8-8V104c0-4.4 3.6-8 8-8s8 3.6 8 8zm64 0V280c0 4.4-3.6 8-8 8s-8-3.6-8-8V104c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faUser = {
    prefix: 'fat',
    iconName: 'user',
    icon: [
      448,
      512,
      [62144,128100],
      'f007',
      
      'M336 128a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM16 482.3c0 7.6 6.1 13.7 13.7 13.7H418.3c7.6 0 13.7-6.1 13.7-13.7C432 392.7 359.3 320 269.7 320H178.3C88.7 320 16 392.7 16 482.3zm-16 0C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3z'
      
    ]
  };

  

  
  

  var faRotateReverse = {
    prefix: 'fat',
    iconName: 'rotate-reverse',
    icon: [
      512,
      512,
      [],
      'e631',
      
      'M468.4 224c4.9 0 8.7-4.3 7.8-9.2c-9.7-51.8-37.5-100.4-82.3-135.3c-88.3-69-212.1-61.3-291.3 13.2L114 104c73.5-68.9 188.2-75.9 270.1-11.9c41.4 32.3 67.2 77.2 76.3 125.1c.7 3.9 4.1 6.8 8.1 6.8zM44.7 288c-4.9 0-8.7 4.3-7.8 9.2c9.7 51.8 37.5 100.4 82.3 135.4c88.1 68.8 211.5 61.3 290.7-12.7L455 465c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V344c0-13.3-10.7-24-24-24H368c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l47.6 47.6c-73.5 68.4-187.9 75.1-269.5 11.4c-41.4-32.4-67.2-77.3-76.3-125.1c-.7-3.9-4.1-6.8-8.1-6.8zM144 176H40c-4.4 0-8-3.6-8-8V64c0-3.2 1.9-6.2 4.9-7.4s6.4-.6 8.7 1.7l104 104c2.3 2.3 3 5.7 1.7 8.7s-4.2 4.9-7.4 4.9zM40 192H144c9.7 0 18.5-5.8 22.2-14.8s1.7-19.3-5.2-26.2L57 47c-6.9-6.9-17.2-8.9-26.2-5.2S16 54.3 16 64V168c0 13.3 10.7 24 24 24zM368 336H472c4.4 0 8 3.6 8 8V448c0 3.2-1.9 6.2-4.9 7.4s-6.4 .6-8.7-1.7l-104-104c-2.3-2.3-3-5.7-1.7-8.7s4.2-4.9 7.4-4.9z'
      
    ]
  };

  

  
  

  var faBadgePercent = {
    prefix: 'fat',
    iconName: 'badge-percent',
    icon: [
      512,
      512,
      [],
      'f646',
      
      'M180.8 61.2C195.1 34.3 223.4 16 256 16s60.9 18.3 75.2 45.2c1.8 3.4 5.7 5 9.4 3.9c29.1-8.9 62.1-1.9 85.1 21.1s30.1 56 21.1 85.1c-1.1 3.7 .5 7.6 3.9 9.4C477.7 195.1 496 223.4 496 256s-18.3 60.9-45.2 75.2c-3.4 1.8-5 5.8-3.9 9.4c8.9 29.1 1.9 62.1-21.1 85.1s-56 30.1-85.1 21.1c-3.7-1.1-7.6 .5-9.4 3.9C316.9 477.7 288.6 496 256 496s-60.9-18.3-75.2-45.2c-1.8-3.4-5.7-5-9.4-3.9c-29.1 8.9-62.1 1.9-85.1-21.1s-30.1-56-21.1-85.1c1.1-3.7-.5-7.6-3.9-9.4C34.3 316.9 16 288.6 16 256s18.3-60.9 45.2-75.2c3.4-1.8 5-5.7 3.9-9.4c-8.9-29.1-1.9-62.1 21.1-85.1s56-30.1 85.1-21.1c3.7 1.1 7.6-.5 9.4-3.9zM256 0c-36.4 0-68.3 19.3-86.1 48.2c-33-7.9-69.2 1.1-94.9 26.8s-34.7 61.9-26.8 94.9C19.3 187.7 0 219.6 0 256s19.3 68.3 48.2 86.1c-7.9 33 1.1 69.2 26.8 94.9s61.9 34.7 94.9 26.8C187.7 492.7 219.6 512 256 512s68.3-19.3 86.1-48.2c33 7.9 69.2-1.1 94.9-26.8s34.7-61.9 26.8-94.9C492.7 324.3 512 292.4 512 256s-19.3-68.3-48.2-86.1c7.9-33-1.1-69.2-26.8-94.9s-62-34.7-94.9-26.8C324.3 19.3 292.4 0 256 0zM176 192a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm21.7-170.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-160 160c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l160-160z'
      
    ]
  };

  

  
  

  var faBridgeCircleExclamation = {
    prefix: 'fat',
    iconName: 'bridge-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e4ca',
      
      'M40 32H600c4.4 0 8 3.6 8 8s-3.6 8-8 8H520v96h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H40c-4.4 0-8-3.6-8-8s3.6-8 8-8h80V48H40c-4.4 0-8-3.6-8-8s3.6-8 8-8zM504 48H392v96H504V48zM376 48H264v96H376V48zM248 48H136v96H248V48zM40 256H64c48.6 0 88 39.4 88 88v96c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V344c0-48.6 39.4-88 88-88c12.3 0 24 2.5 34.7 7.1c-3.2 4.4-6.3 8.9-9.1 13.6c-7.9-3-16.5-4.7-25.5-4.7c-39.8 0-72 32.2-72 72v96c0 22.1-17.9 40-40 40H176c-22.1 0-40-17.9-40-40V344c0-39.8-32.2-72-72-72H40c-4.4 0-8-3.6-8-8s3.6-8 8-8zM624 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0-136c4.4 0 8 3.6 8 8v96c0 4.4-3.6 8-8 8s-8-3.6-8-8V288c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faPenClip = {
    prefix: 'fat',
    iconName: 'pen-clip',
    icon: [
      512,
      512,
      ["pen-alt"],
      'f305',
      
      'M374.1 30.6c18.7-18.7 49.1-18.7 67.9 0l39.4 39.4c18.7 18.7 18.7 49.1 0 67.9L427.3 192 320 84.7l54.1-54.1zM297.4 84.7L99.5 282.5c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9 .9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1L492.7 149.3c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0L308.7 73.4 295.6 60.3c-21.9-21.9-57.3-21.9-79.2 0L98.3 178.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L227.7 71.6c15.6-15.6 40.9-15.6 56.6 0l13.1 13.1zM308.7 96L416 203.3 218.2 401.1c-45.8 45.8-104.1 77-167.6 89.7l-25 5c-2.6 .5-5.3-.3-7.2-2.2s-2.7-4.6-2.2-7.2l5-25c12.7-63.5 43.9-121.8 89.7-167.6L308.7 96z'
      
    ]
  };

  
    var faPenAlt = faPenClip;
  

  
  

  var faH3 = {
    prefix: 'fat',
    iconName: 'h3',
    icon: [
      640,
      512,
      [],
      'f315',
      
      'M16 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V248 440c0 4.4 3.6 8 8 8s8-3.6 8-8V256H304V440c0 4.4 3.6 8 8 8s8-3.6 8-8V248 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V240H16V72zm376-8c-4.4 0-8 3.6-8 8s3.6 8 8 8H580.7L418.3 242.3c-2.3 2.3-3 5.7-1.7 8.7s4.2 4.9 7.4 4.9h96c48.6 0 88 39.4 88 88s-39.4 88-88 88H447.4c-23.5 0-43.5-17-47.3-40.1l-.2-1.2c-.7-4.4-4.8-7.3-9.2-6.6s-7.3 4.8-6.6 9.2l.2 1.2c5.1 30.9 31.8 53.5 63.1 53.5H520c57.4 0 104-46.6 104-104s-46.6-104-104-104H443.3L605.7 77.7c2.3-2.3 3-5.7 1.7-8.7s-4.2-4.9-7.4-4.9H392z'
      
    ]
  };

  

  
  

  var faBowlChopsticksNoodles = {
    prefix: 'fat',
    iconName: 'bowl-chopsticks-noodles',
    icon: [
      512,
      512,
      [],
      'e2ea',
      
      'M160 32c0-4.4-3.6-8-8-8s-8 3.6-8 8V75.3 91.7v51.5 16V224H112V161.3v-16V98.4 82 48c0-4.4-3.6-8-8-8s-8 3.6-8 8V85.4L6.4 104.2c-4.3 .9-7.1 5.1-6.2 9.5s5.1 7.1 9.5 6.2L96 101.7v44.6L7.5 152c-4.4 .3-7.8 4.1-7.5 8.5s4.1 7.8 8.5 7.5L96 162.3V224H33.9C15.5 224 .9 239.5 2 257.9l1.6 27.3c4.9 83.3 54.8 153.7 125.3 188.2c4.3 22 23.8 38.7 47.1 38.7H336c23.3 0 42.8-16.6 47.1-38.7c70.5-34.5 120.4-104.9 125.3-188.2l1.6-27.3c1.1-18.4-13.5-33.9-31.9-33.9H192 160V158.2v-16V88.3 72 32zm32 33.2V81.6L505.6 15.8c4.3-.9 7.1-5.1 6.2-9.5s-5.1-7.1-9.5-6.2L192 65.2zm0 74.9v16L504.5 136c4.4-.3 7.8-4.1 7.5-8.5s-4.1-7.8-8.5-7.5L192 140.1zM104 240h48H478.1c9.2 0 16.5 7.7 16 16.9l-1.6 27.3c-4.5 77.3-50.9 142.7-116.4 174.7c-4.5 2.2-7.7 6.4-8.7 11.3C364.5 484.9 351.5 496 336 496H176c-15.5 0-28.5-11.1-31.4-25.8c-1-4.9-4.2-9.1-8.7-11.3c-65.5-32-111.8-97.4-116.4-174.7L18 256.9c-.5-9.2 6.8-16.9 16-16.9H104z'
      
    ]
  };

  

  
  

  var faPizza = {
    prefix: 'fat',
    iconName: 'pizza',
    icon: [
      576,
      512,
      [127829],
      'f817',
      
      'M256 278.6c-12.5-12.5-12.5-32.8 0-45.3L368.6 120.7C338.1 95.3 298.8 80 256 80C158.8 80 80 158.8 80 256s78.8 176 176 176c42.8 0 82.1-15.3 112.6-40.7L256 278.6zm11.3-11.3L380.5 380.5l11.3 11.3 33.9 33.9c6.2 6.2 6.3 16.4-.3 22.3c-45.1 39.8-104.4 64-169.4 64C114.6 512 0 397.4 0 256S114.6 0 256 0c64.9 0 124.2 24.2 169.4 64c6.6 5.8 6.6 16 .3 22.3l-33.9 33.9-11.3 11.3L267.3 244.7c-6.2 6.2-6.2 16.4 0 22.6zM414 436.6l-34-34C346.5 430.9 303.3 448 256 448C150 448 64 362 64 256S150 64 256 64c47.3 0 90.5 17.1 124 45.4l34-34C371.8 38.4 316.5 16 256 16C123.5 16 16 123.5 16 256s107.5 240 240 240c60.5 0 115.8-22.4 158-59.4zM560 256c0-60.5-22.4-115.8-59.4-158l-34 34c28.3 33.5 45.4 76.7 45.4 124s-17.1 90.5-45.4 124l34 34c37-42.2 59.4-97.5 59.4-158zM455.3 143.4L342.6 256 455.3 368.6C480.7 338.1 496 298.8 496 256s-15.3-82.1-40.7-112.6zm34.5 282.3l-33.9-33.9-11.3-11.3L331.3 267.3c-6.2-6.2-6.2-16.4 0-22.6L489.7 86.3C496 80 506.1 80 512 86.6c39.8 45.1 64 104.4 64 169.4s-24.2 124.2-64 169.4c-5.8 6.6-16 6.6-22.3 .3zM144 256a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM208 352a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM448 240a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faE = {
    prefix: 'fat',
    iconName: 'e',
    icon: [
      320,
      512,
      [101],
      '45',
      
      'M32 32C14.3 32 0 46.3 0 64V256 448c0 17.7 14.3 32 32 32H312c4.4 0 8-3.6 8-8s-3.6-8-8-8H32c-8.8 0-16-7.2-16-16V256H248c4.4 0 8-3.6 8-8s-3.6-8-8-8H16V64c0-8.8 7.2-16 16-16H312c4.4 0 8-3.6 8-8s-3.6-8-8-8H32z'
      
    ]
  };

  

  
  

  var faLambda = {
    prefix: 'fat',
    iconName: 'lambda',
    icon: [
      448,
      512,
      [],
      'f66e',
      
      'M8 32c-4.4 0-8 3.6-8 8s3.6 8 8 8H131.9c9.2 0 17.6 5.3 21.6 13.6l21.1 43.9L16.7 468.8c-1.8 4.1 .1 8.8 4.1 10.5s8.8-.1 10.5-4.1L183.8 124.5 344.1 457.4c6.7 13.8 20.7 22.6 36 22.6H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H380.1c-9.2 0-17.6-5.3-21.6-13.6L167.9 54.6c-6.7-13.8-20.7-22.6-36-22.6H8z'
      
    ]
  };

  

  
  

  var faWandMagicSparkles = {
    prefix: 'fat',
    iconName: 'wand-magic-sparkles',
    icon: [
      576,
      512,
      ["magic-wand-sparkles"],
      'e2ca',
      
      'M455 23.6c9.4-9.4 24.6-9.4 33.9 0L520.4 55c9.4 9.4 9.4 24.6 0 33.9L390.3 219.1c-.2-.3-.4-.5-.6-.7l-64-64c-.2-.2-.5-.4-.7-.6L455 23.6zM55.6 423L313.7 164.9c.2 .3 .4 .5 .6 .7l64 64c.2 .2 .5 .4 .7 .6L121 488.4c-9.4 9.4-24.6 9.4-33.9 0L55.6 457c-9.4-9.4-9.4-24.6 0-33.9zM443.7 12.3L44.3 411.7c-15.6 15.6-15.6 40.9 0 56.6l31.4 31.4c15.6 15.6 40.9 15.6 56.6 0L531.7 100.3c15.6-15.6 15.6-40.9 0-56.6L500.3 12.3c-15.6-15.6-40.9-15.6-56.6 0zM104 64c0-4.4-3.6-8-8-8s-8 3.6-8 8v56H32c-4.4 0-8 3.6-8 8s3.6 8 8 8H88v56c0 4.4 3.6 8 8 8s8-3.6 8-8V136h56c4.4 0 8-3.6 8-8s-3.6-8-8-8H104V64zM480 312c-4.4 0-8 3.6-8 8v56H416c-4.4 0-8 3.6-8 8s3.6 8 8 8h56v56c0 4.4 3.6 8 8 8s8-3.6 8-8V392h56c4.4 0 8-3.6 8-8s-3.6-8-8-8H488V320c0-4.4-3.6-8-8-8zM232 32c0-4.4-3.6-8-8-8s-8 3.6-8 8V56H192c-4.4 0-8 3.6-8 8s3.6 8 8 8h24V96c0 4.4 3.6 8 8 8s8-3.6 8-8V72h24c4.4 0 8-3.6 8-8s-3.6-8-8-8H232V32z'
      
    ]
  };

  
    var faMagicWandSparkles = faWandMagicSparkles;
  

  
  

  var faGauge = {
    prefix: 'fat',
    iconName: 'gauge',
    icon: [
      512,
      512,
      ["dashboard","gauge-med","tachometer-alt-average"],
      'f624',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-208a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112c35.3 0 64-28.7 64-64c0-32.6-24.4-59.6-56-63.5V80c0-4.4-3.6-8-8-8s-8 3.6-8 8V288.5c-31.6 3.9-56 30.9-56 63.5c0 35.3 28.7 64 64 64zM144 144a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-32 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm304 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM384 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  
    var faDashboard = faGauge;
  
    var faGaugeMed = faGauge;
  
    var faTachometerAltAverage = faGauge;
  

  
  

  var faVial = {
    prefix: 'fat',
    iconName: 'vial',
    icon: [
      512,
      512,
      [129514],
      'f492',
      
      'M322.3 2.3c3.1-3.1 8.2-3.1 11.3 0l24 24 128 128 24 24c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L480 171.3l-98.3 98.3L168.2 483.1C149.7 501.6 124.6 512 98.5 512C44.1 512 0 467.9 0 413.5c0-26.1 10.4-51.2 28.9-69.7l85.5-85.5L340.7 32 322.3 13.7c-3.1-3.1-3.1-8.2 0-11.3zm29.7 41L139.3 256H372.7l96-96L352 43.3zM356.7 272H123.3L40.2 355.1C24.7 370.6 16 391.6 16 413.5C16 459.1 52.9 496 98.5 496c21.9 0 42.9-8.7 58.3-24.2L356.7 272z'
      
    ]
  };

  

  
  

  var faSquareBolt = {
    prefix: 'fat',
    iconName: 'square-bolt',
    icon: [
      448,
      512,
      [],
      'e265',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM235.6 232.8L288 128 128 256h70.1c5.5 0 10.7 2.9 13.6 7.6s3.2 10.6 .7 15.6L160 384 320 256H249.9c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6zm66.7-97.7L257.9 224l-8 16h17.9H320c6.8 0 12.9 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L190.1 288l8-16H180.2 128c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1s7.6 12.9 4.3 19.6z'
      
    ]
  };

  

  
  

  var faLeafOak = {
    prefix: 'fat',
    iconName: 'leaf-oak',
    icon: [
      512,
      512,
      [],
      'f6f7',
      
      'M309.3 0c-29.6 0-55 21.3-60 50.5L245.6 72 221.3 53.7C200.4 38 171 40 152.5 58.5c-11.7 11.7-17.2 28.2-14.9 44.6l8.8 61.3C124.9 153 98 157.6 81.6 176.3L75 183.8c-17.3 19.7-20.9 47.9-9.2 71.3l12.7 25.4c8.3 16.7 12.7 35 12.7 53.7v75.3L2.3 498.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l88.8-88.8h75.3c18.6 0 37 4.3 53.7 12.7l25.4 12.7c23.4 11.7 51.6 8.1 71.3-9.2l7.6-6.6c18.7-16.4 23.3-43.3 11.8-64.7l61.3 8.8c16.4 2.3 32.9-3.2 44.6-14.9c18.5-18.5 20.6-47.9 4.8-68.8L440 266.4l21.5-3.7c29.2-5 50.5-30.4 50.5-60c0-20.4-10.2-39.4-27.1-50.7l-10.5-7c-2.7-1.8-4.1-5.2-3.4-8.4l5.5-25.2c4.7-21.2-1.8-43.4-17.2-58.8s-37.5-21.9-58.8-17.2L375.3 41c-3.2 .7-6.5-.6-8.4-3.4l-7-10.5C348.6 10.2 329.6 0 309.3 0zM118.5 404.8L317.7 205.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L107.2 393.5V334.2c0-21.1-4.9-41.9-14.4-60.8L80.1 247.9c-8.8-17.6-6.1-38.8 6.9-53.6l6.6-7.6c12.2-13.9 32.8-16.6 48.2-6.4c9.8 6.5 22.7-1.6 21-13.3l-9.5-66.3c-1.6-11.4 2.2-22.9 10.4-31.1c12.9-12.9 33.3-14.3 47.9-3.3l24.2 18.3c9.6 7.2 23.4 1.7 25.4-10.1L265 53.3C268.7 31.7 287.4 16 309.3 16c15 0 29 7.5 37.4 20l7 10.5c5.5 8.2 15.4 12.2 25.1 10.1l25.2-5.5c15.9-3.5 32.5 1.4 44 12.9s16.4 28.1 12.9 44l-5.5 25.2c-2.1 9.7 1.9 19.6 10.1 25.1l10.5 7c12.5 8.3 20 22.3 20 37.4c0 21.8-15.7 40.5-37.3 44.2l-21.5 3.7c-11.8 2-17.3 15.8-10.1 25.4l18.3 24.2c11 14.6 9.6 35-3.3 47.9c-8.1 8.1-19.6 12-31.1 10.3l-66.3-9.5c-11.7-1.7-19.8 11.2-13.3 21c10.3 15.4 7.5 36-6.4 48.2l-7.6 6.6c-14.8 13-36 15.7-53.6 6.9l-25.4-12.7c-18.9-9.4-39.7-14.4-60.8-14.4H118.5z'
      
    ]
  };

  

  
  

  var faMarsStroke = {
    prefix: 'fat',
    iconName: 'mars-stroke',
    icon: [
      512,
      512,
      [9894],
      'f229',
      
      'M376 0c-4.4 0-8 3.6-8 8s3.6 8 8 8H484.7L392 108.7 349.7 66.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L380.7 120l-50.3 50.3c-1.4 1.4-2.1 3.1-2.3 4.9C296.6 145.9 254.4 128 208 128c-97.2 0-176 78.8-176 176s78.8 176 176 176s176-78.8 176-176c0-46.4-17.9-88.6-47.3-120c1.8-.2 3.6-.9 4.9-2.3L392 131.3l42.3 42.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L403.3 120 496 27.3V136c0 4.4 3.6 8 8 8s8-3.6 8-8V8c0-4.4-3.6-8-8-8H376zM48 304a160 160 0 1 1 320 0A160 160 0 1 1 48 304z'
      
    ]
  };

  

  
  

  var faCircleParking = {
    prefix: 'fat',
    iconName: 'circle-parking',
    icon: [
      512,
      512,
      ["parking-circle"],
      'f615',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM192 128h96c48.6 0 88 39.4 88 88s-39.4 88-88 88H192v72c0 4.4-3.6 8-8 8s-8-3.6-8-8V296 144c0-8.8 7.2-16 16-16zm96 160c39.8 0 72-32.2 72-72s-32.2-72-72-72H192V288h96z'
      
    ]
  };

  
    var faParkingCircle = faCircleParking;
  

  
  

  var faCrutches = {
    prefix: 'fat',
    iconName: 'crutches',
    icon: [
      640,
      512,
      [],
      'f7f8',
      
      'M203.3 20.7c6.2 6.2 6.2 16.4 0 22.6l-160 160c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l160-160c6.2-6.2 16.4-6.2 22.6 0zM214.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3zm12.3 78.2L215.6 98.9l70.5 70.5 11.3-11.3L226.9 87.6zM406.1 394.8l-1.2 .3-18.1 3.6c1.9 1.4 3.7 3 5.3 4.7l98.3 98.3 8 8c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-8-8-95.6-95.6zM216 332.6l-117-117L87.6 226.9l117 117c4.8 4.8 10.3 8.9 16.1 12.1l3.3-16.7c-2.9-2-5.7-4.2-8.2-6.8zm243.4-312l160 160c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-160-160c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM470.6 9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160zM413.1 87.6l-82.7 82.7-.1 .1-.1 .1L296 204.6c-10.1 10.1-16.9 22.9-19.7 36.8L252 363.4c-2.2 10.8-7.5 20.8-15.3 28.6l-98.3 98.3-8 8c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l8-8L248 403.4c7.8-7.8 17.8-13.1 28.6-15.3l122-24.4c13.9-2.8 26.7-9.6 36.8-19.7l34.3-34.3 82.7-82.7-11.3-11.3L464 292.7 347.3 176l77.1-77.1L413.1 87.6zM307.4 216L336 187.3 452.7 304 424 332.6c-7.8 7.8-17.8 13.1-28.6 15.3l-122 24.4c-2.6 .5-5.3 1.2-7.8 2c.8-2.6 1.5-5.2 2-7.8l24.4-122c2.2-10.8 7.5-20.8 15.3-28.6z'
      
    ]
  };

  

  
  

  var faChartSimple = {
    prefix: 'fat',
    iconName: 'chart-simple',
    icon: [
      448,
      512,
      [],
      'e473',
      
      'M240 48c17.7 0 32 14.3 32 32V432c0 17.7-14.3 32-32 32H208c-17.7 0-32-14.3-32-32V80c0-17.7 14.3-32 32-32h32zM208 32c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H208zM80 240c17.7 0 32 14.3 32 32V432c0 17.7-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V272c0-17.7 14.3-32 32-32H80zM48 224c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H48zM368 112h32c17.7 0 32 14.3 32 32V432c0 17.7-14.3 32-32 32H368c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32zm-48 32V432c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48z'
      
    ]
  };

  

  
  

  var faBagSeedling = {
    prefix: 'fat',
    iconName: 'bag-seedling',
    icon: [
      512,
      512,
      [],
      'e5f2',
      
      'M76.5 80l0 .1L60.9 142.4C52.3 176.6 48 211.8 48 247.2v17.7c0 35.3 4.3 70.5 12.9 104.8l15.6 62.3 0 .1h359l0-.1 15.6-62.3c8.6-34.3 12.9-69.5 12.9-104.8V247.2c0-35.3-4.3-70.5-12.9-104.8L435.5 80.1l0-.1H76.5zM440.3 64L461 38.1c1.9-2.4 3-5.4 3-8.5c0-7.5-6.1-13.6-13.6-13.6H61.6C54.1 16 48 22.1 48 29.6c0 3.1 1.1 6.1 3 8.5L71.7 64H440.3zM71.7 448L51 473.9l-12.4-9.9L51 473.9c-1.9 2.4-3 5.4-3 8.5c0 7.5 6.1 13.6 13.6 13.6H450.4c7.5 0 13.6-6.1 13.6-13.6c0-3.1-1.1-6.1-3-8.5L440.3 448H71.7zM480 29.6c0 6.7-2.3 13.2-6.5 18.5L451 76.2l15.6 62.3c8.9 35.5 13.4 72 13.4 108.7v17.7c0 36.6-4.5 73.1-13.4 108.7L451 435.8l22.5 28.1c4.2 5.3 6.5 11.8 6.5 18.5c0 16.4-13.3 29.6-29.6 29.6H61.6C45.3 512 32 498.7 32 482.4c0-6.7 2.3-13.2 6.5-18.5L61 435.8 45.4 373.5C36.5 338 32 301.5 32 264.8V247.2c0-36.6 4.5-73.1 13.4-108.7L61 76.2 38.5 48.1C34.3 42.9 32 36.3 32 29.6C32 13.3 45.3 0 61.6 0H450.4C466.7 0 480 13.3 480 29.6zM151.1 176c-3.9 0-7.1 3.2-7.1 7.2C144 240.7 190.6 288 248 288V230.9c-12.5-31.5-43-54.9-80.7-54.9H151.1zM264 230.9V288c57.4 0 104-47.3 104-104.8c0-4-3.3-7.2-7.1-7.2H344.7c-37.7 0-68.2 23.4-80.7 54.9zM248 304c-66.3 0-120-54.6-120-120.8c0-12.7 10.3-23.2 23.1-23.2h16.2c38.8 0 71.2 21 88.7 50.9C273.5 181 305.9 160 344.7 160h16.2c12.8 0 23.1 10.5 23.1 23.2C384 249.4 330.3 304 264 304v64c0 4.4-3.6 8-8 8s-8-3.6-8-8V304z'
      
    ]
  };

  

  
  

  var faPenCircle = {
    prefix: 'fat',
    iconName: 'pen-circle',
    icon: [
      512,
      512,
      [],
      'e20e',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM132.7 379.2c-4-4-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9L307.4 133.5c15.6-15.6 40.9-15.6 56.6 0l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6L222.9 359.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2zM367 193.1c9.4-9.4 9.4-24.6 0-33.9l-14.4-14.4c-9.4-9.4-24.6-9.4-33.9 0l-25.3 25.3 48.3 48.3L367 193.1zM211.6 348.6L330.4 229.7l-48.3-48.3L163.2 300.3c-2.1 2.1-3.5 4.6-4.2 7.4l-10.6 42.5L144 367.9l17.6-4.4 42.5-10.6c2.8-.7 5.4-2.2 7.4-4.2z'
      
    ]
  };

  

  
  

  var faRadiation = {
    prefix: 'fat',
    iconName: 'radiation',
    icon: [
      512,
      512,
      [],
      'f7b9',
      
      'M192.4 184c-15.3 13.6-26.3 32-30.6 52.9c-.2 1.2-.8 2.2-1.4 2.7c-.3 .2-.4 .3-.5 .3l0 0L32 240c-9.5 0-15-7.3-14.2-14C26 160.4 60.7 102.9 111 64.7c5.3-4 14.4-2.9 19.1 5.3l64 110.9 0 0c0 .1 0 .3-.1 .6c-.2 .8-.7 1.8-1.6 2.6zm33 163c9.6 3.2 19.9 5 30.5 5s20.9-1.7 30.5-5c1.2-.4 2.3-.4 3.1-.1c.3 .1 .5 .2 .5 .2l0 0 64 110.9c4.7 8.2 1.2 16.6-5 19.2C320.6 489.3 289.1 496 256 496s-64.6-6.7-93.2-18.8c-6.1-2.6-9.7-11-5-19.2l64-110.9 0 0c0 0 .2-.1 .5-.2c.7-.2 1.9-.3 3.1 .1zM480 240l-128 0 0 0c0 0-.2-.1-.5-.3c-.6-.5-1.2-1.5-1.4-2.7c-4.2-20.9-15.2-39.3-30.6-52.9c-.9-.8-1.5-1.8-1.6-2.6c-.1-.3-.1-.5-.1-.6l0 0L381.9 70c4.7-8.2 13.8-9.3 19.1-5.3c50.3 38.2 85 95.6 93.2 161.3c.8 6.7-4.7 14-14.2 14zM160 256c8.8 0 15.8-7.2 17.6-15.9c3.5-17.4 12.7-32.8 25.5-44.1c6.6-5.8 9.4-15.5 5-23.2L144 62c-8.8-15.3-28.6-20.7-42.7-10C47.8 92.7 10.7 154 2 224.1C-.2 241.6 14.3 256 32 256l128 0zm48 83.2L144 450.1c-8.8 15.3-3.7 35.1 12.6 41.9c30.6 12.9 64.2 20 99.4 20s68.9-7.1 99.4-20c16.3-6.9 21.4-26.6 12.6-41.9L304 339.2c-4.4-7.7-14.2-10.1-22.6-7.3c-8 2.7-16.5 4.1-25.4 4.1s-17.4-1.4-25.4-4.1c-8.4-2.8-18.2-.4-22.6 7.3zm126.4-99.1c1.7 8.7 8.7 15.9 17.6 15.9l128 0c17.7 0 32.2-14.4 30-31.9C501.3 154 464.2 92.7 410.7 52c-14.1-10.7-33.8-5.3-42.7 10L304 172.9c-4.4 7.6-1.7 17.3 5 23.2c12.8 11.3 22 26.7 25.5 44.1zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  

  
  

  var faPlaneUpSlash = {
    prefix: 'fat',
    iconName: 'plane-up-slash',
    icon: [
      640,
      512,
      [],
      'e22e',
      
      'M368 385.6V400c0 2.5 1.2 4.9 3.2 6.4l57.6 43.2c2 1.5 3.2 3.9 3.2 6.4v34.1c0 3.3-2.6 5.9-5.9 5.9c-.6 0-1.2-.1-1.7-.3l-2.4 7.6 2.4-7.6-102-31.4c-1.5-.5-3.2-.5-4.7 0l-102 31.4c-.6 .2-1.1 .3-1.7 .3c-3.3 0-5.9-2.6-5.9-5.9V456c0-2.5 1.2-4.9 3.2-6.4l57.6-43.2c2-1.5 3.2-3.9 3.2-6.4V323c0-2.5-1.2-4.9-3.2-6.4s-4.6-2-7-1.3L90.1 362.7C85 364.1 80 360.3 80 355V306.9c0-8.7 4.8-16.8 12.4-21l87.8-48.5-13.6-10.8-82 45.2c-12.8 7-20.7 20.5-20.7 35V355c0 15.9 15.1 27.4 30.4 23.1L256 333.5V396l-54.4 40.8c-6 4.5-9.6 11.6-9.6 19.2v34.1c0 12.1 9.8 21.9 21.9 21.9c2.2 0 4.4-.3 6.4-1L320 480.4 419.6 511c2.1 .6 4.3 1 6.4 1c12.1 0 21.9-9.8 21.9-21.9V456c0-2.9-.5-5.8-1.5-8.4l-78.5-62zM256 89.2v24.6l16 12.6V89.2c0-13 5.7-31.9 15.3-47.5C297.2 25.6 309.1 16 320 16c11.3 0 23.2 9.6 33 25.6c9.5 15.6 15 34.5 15 47.5v92.9c0 2.9 1.6 5.6 4.1 7l175.5 96.8c7.7 4.2 12.4 12.3 12.4 21v46.8l13.9 11c1.3-3 2.1-6.3 2.1-9.8V306.9c0-14.6-7.9-28-20.7-35L384 177.3V89.2c0-16.6-6.7-38.3-17.3-55.8C356.2 16.2 340.2 0 320 0c-19.8 0-35.8 16.2-46.3 33.3C263 50.8 256 72.6 256 89.2zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  

  
  

  var faMug = {
    prefix: 'fat',
    iconName: 'mug',
    icon: [
      576,
      512,
      [],
      'f874',
      
      'M64 80c-8.8 0-16 7.2-16 16V352c0 44.2 35.8 80 80 80H320c44.2 0 80-35.8 80-80V288 272 80H368 64zM416 288v64c0 53-43 96-96 96H128c-53 0-96-43-96-96V96c0-17.7 14.3-32 32-32H368h32 16 48c61.9 0 112 50.1 112 112s-50.1 112-112 112H416zm0-16h48c53 0 96-43 96-96s-43-96-96-96H416V272z'
      
    ]
  };

  

  
  

  var faMicrochipAi = {
    prefix: 'fat',
    iconName: 'microchip-ai',
    icon: [
      512,
      512,
      [],
      'e1ec',
      
      'M160 0c4.4 0 8 3.6 8 8V64h80V8c0-4.4 3.6-8 8-8s8 3.6 8 8V64h80V8c0-4.4 3.6-8 8-8s8 3.6 8 8V64h24c35.3 0 64 28.7 64 64v24h56c4.4 0 8 3.6 8 8s-3.6 8-8 8H448v80h56c4.4 0 8 3.6 8 8s-3.6 8-8 8H448v80h56c4.4 0 8 3.6 8 8s-3.6 8-8 8H448v24c0 35.3-28.7 64-64 64H360v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V448H264v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V448H168v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V448H128c-35.3 0-64-28.7-64-64V360H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H64V264H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H64V168H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H64V128c0-35.3 28.7-64 64-64h24V8c0-4.4 3.6-8 8-8zm0 80H128c-26.5 0-48 21.5-48 48v32 96 96 32c0 26.5 21.5 48 48 48h32 96 96 32c26.5 0 48-21.5 48-48V352 256 160 128c0-26.5-21.5-48-48-48H352 256 160zm55.3 100.8l64 144c1.8 4 0 8.8-4.1 10.6s-8.8 0-10.6-4.1L252.6 304H163.4l-12.1 27.2c-1.8 4-6.5 5.9-10.6 4.1s-5.9-6.5-4.1-10.6l64-144c1.3-2.9 4.1-4.8 7.3-4.8s6 1.9 7.3 4.8zM208 203.7L170.5 288h74.9L208 203.7zM344 184V328c0 4.4-3.6 8-8 8s-8-3.6-8-8V184c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faFileWaveform = {
    prefix: 'fat',
    iconName: 'file-waveform',
    icon: [
      448,
      512,
      ["file-medical-alt"],
      'f478',
      
      'M384 496H128c-26.5 0-48-21.5-48-48V336H64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L302.1 14.1c-9-9-21.2-14.1-33.9-14.1H128C92.7 0 64 28.7 64 64V256H80V64c0-26.5 21.5-48 48-48H268.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H431.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48zm41.1-336H312c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L422.6 157.3c.9 .9 1.7 1.8 2.4 2.7zM263.2 228.4c-1.4-2.8-4.2-4.5-7.3-4.4s-5.9 1.9-7.1 4.7L190.9 358.7l-40.1-66.8c-1.4-2.4-4-3.9-6.9-3.9H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H139.5l45.7 76.1c1.5 2.6 4.4 4.1 7.3 3.9s5.6-2 6.8-4.7l57.1-128.5 24.4 48.8c1.4 2.7 4.1 4.4 7.2 4.4h64c4.4 0 8-3.6 8-8s-3.6-8-8-8H292.9l-29.8-59.6z'
      
    ]
  };

  
    var faFileMedicalAlt = faFileWaveform;
  

  
  

  var faCreditCardBlank = {
    prefix: 'fat',
    iconName: 'credit-card-blank',
    icon: [
      576,
      512,
      [],
      'f389',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H512c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM96 360c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H104c-4.4 0-8-3.6-8-8zm128 0c0-4.4 3.6-8 8-8H376c4.4 0 8 3.6 8 8s-3.6 8-8 8H232c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faFaceAnxiousSweat = {
    prefix: 'fat',
    iconName: 'face-anxious-sweat',
    icon: [
      576,
      512,
      [],
      'e36a',
      
      'M288 16C166 16 65.2 107.1 50 225c-.6 4.4-4.6 7.5-9 6.9s-7.5-4.6-6.9-9C50.3 97.2 157.8 0 288 0C429.4 0 544 114.6 544 256s-114.6 256-256 256c-70.4 0-134.1-28.4-180.4-74.3c-3.1-3.1-3.2-8.2 0-11.3s8.2-3.2 11.3 0C162.3 469.4 222 496 288 496c132.5 0 240-107.5 240-240S420.5 16 288 16zM197.7 162.3c3.1 3.1 3.1 8.2 0 11.3l-7.4 7.4c-22.4 22.4-51.2 37.2-82.5 42.5l-2.5 .4c-4.4 .7-8.5-2.2-9.2-6.6s2.2-8.5 6.6-9.2l2.5-.4c28-4.7 53.8-17.9 73.8-38l7.4-7.4c3.1-3.1 8.2-3.1 11.3 0zm180.7 11.3c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l7.4 7.4c20 20 45.8 33.3 73.8 38l2.5 .4c4.4 .7 7.3 4.8 6.6 9.2s-4.8 7.3-9.2 6.6l-2.5-.4c-31.3-5.2-60.1-20.1-82.5-42.5l-7.4-7.4zM64 275.1c-8.4 10.7-19.7 25.7-29.3 40.9c-5.6 8.9-10.5 17.5-13.9 25.1c-3.6 8-4.8 13.3-4.8 16.1C16 379.6 36.2 400 64 400s48-20.4 48-42.7c0-2.8-1.2-8.2-4.8-16.2c-3.4-7.6-8.2-16.2-13.9-25.1c-9.6-15.2-20.9-30.3-29.3-40.9zm-8.5-15c4.3-5.5 12.8-5.5 17.1 0c17.6 21.7 55.5 72.2 55.5 97.2c0 32.5-28.7 58.7-64 58.7s-64-26.2-64-58.7c0-25 38.1-75.5 55.5-97.2zM367.6 256a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-144 16a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm60.2 48h8.4c46.3 0 83.8 37.5 83.8 83.8c0 6.7-5.5 12.2-12.2 12.2H212.2c-6.7 0-12.2-5.5-12.2-12.2c0-46.3 37.5-83.8 83.8-83.8zm76.1 80c-2-35.7-31.5-64-67.7-64h-8.4c-36.2 0-65.7 28.3-67.7 64H359.9z'
      
    ]
  };

  

  
  

  var faFolder = {
    prefix: 'fat',
    iconName: 'folder',
    icon: [
      512,
      512,
      [61716,128193,128447,"folder-blank"],
      'f07b',
      
      'M64 464H448c26.5 0 48-21.5 48-48V160c0-26.5-21.5-48-48-48H301.3c-12.7 0-24.9-5.1-33.9-14.1L231.4 62.1c-9-9-21.2-14.1-33.9-14.1H64C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48zm384 16H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H197.5c17 0 33.3 6.7 45.3 18.7l35.9 35.9c6 6 14.1 9.4 22.6 9.4H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64z'
      
    ]
  };

  
    var faFolderBlank = faFolder;
  

  
  

  var faObjectsAlignTop = {
    prefix: 'fat',
    iconName: 'objects-align-top',
    icon: [
      512,
      512,
      [],
      'e3c0',
      
      'M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8l496 0c4.4 0 8-3.6 8-8s-3.6-8-8-8L8 0zM176 112c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32l0-320c0-17.7 14.3-32 32-32l64 0zM112 96c-26.5 0-48 21.5-48 48l0 320c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48l0-320c0-26.5-21.5-48-48-48l-64 0zm288 16c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32H336c-17.7 0-32-14.3-32-32l0-192c0-17.7 14.3-32 32-32l64 0zM336 96c-26.5 0-48 21.5-48 48l0 192c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48l0-192c0-26.5-21.5-48-48-48l-64 0z'
      
    ]
  };

  

  
  

  var faFileCad = {
    prefix: 'fat',
    iconName: 'file-cad',
    icon: [
      512,
      512,
      [],
      'e672',
      
      'M64 496l48 0 0 16-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L204.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 145.9c9 9 14.1 21.2 14.1 33.9L384 304l-16 0 0-124.1c0-1.3-.1-2.6-.2-3.9L248 176c-22.1 0-40-17.9-40-40l0-119.8c-1.3-.2-2.6-.2-3.9-.2L64 16C37.5 16 16 37.5 16 64l0 384c0 26.5 21.5 48 48 48zM361.1 160c-.8-1-1.6-1.9-2.4-2.7L226.7 25.4c-.9-.9-1.8-1.7-2.7-2.4L224 136c0 13.3 10.7 24 24 24l113.1 0zM200 368l16 0c17.7 0 32 14.3 32 32l0 8c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-8c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-8c0-4.4 3.6-8 8-8s8 3.6 8 8l0 8c0 17.7-14.3 32-32 32l-16 0c-17.7 0-32-14.3-32-32l0-80c0-17.7 14.3-32 32-32zm128 0l16 0c17.7 0 32 14.3 32 32l0 40 0 64c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-56-48 0 0 56c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-64 0-40c0-17.7 14.3-32 32-32zm32 64l0-32c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16l0 32 48 0zm64-56c0-4.4 3.6-8 8-8l32 0c22.1 0 40 17.9 40 40l0 64c0 22.1-17.9 40-40 40l-32 0c-4.4 0-8-3.6-8-8l0-128zm16 120l24 0c13.3 0 24-10.7 24-24l0-64c0-13.3-10.7-24-24-24l-24 0 0 112z'
      
    ]
  };

  

  
  

  var faTrashPlus = {
    prefix: 'fat',
    iconName: 'trash-plus',
    icon: [
      448,
      512,
      [],
      'e2b2',
      
      'M157.4 27.3L134.4 64H313.6l-23-36.7c-4.4-7-12.1-11.3-20.4-11.3H177.7c-8.3 0-16 4.3-20.4 11.3zM115.6 64l28.2-45.2C151.1 7.1 163.9 0 177.7 0h92.5c13.8 0 26.6 7.1 33.9 18.8L332.4 64H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H115.6zM39.3 112c4.4-.4 8.3 2.9 8.6 7.3l28.3 340C78 480.1 95.4 496 116.2 496H331.8c20.8 0 38.1-15.9 39.9-36.7l28.3-340c.4-4.4 4.2-7.7 8.6-7.3s7.7 4.2 7.3 8.6l-28.3 340c-2.4 29-26.7 51.4-55.8 51.4H116.2c-29.1 0-53.4-22.3-55.8-51.4L32 120.7c-.4-4.4 2.9-8.3 7.3-8.6zM216 384V296H128c-4.4 0-8-3.6-8-8s3.6-8 8-8h88V192c0-4.4 3.6-8 8-8s8 3.6 8 8v88h88c4.4 0 8 3.6 8 8s-3.6 8-8 8H232v88c0 4.4-3.6 8-8 8s-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faHeadSideGear = {
    prefix: 'fat',
    iconName: 'head-side-gear',
    icon: [
      512,
      512,
      [],
      'e611',
      
      'M16 222.9C16 108.6 108.6 16 222.9 16h16.8c71.6 0 137.5 43.3 166.4 105c3.5 7.4 6.9 15.1 10.4 22.9c6.4 14.3 12.9 28.9 20.1 42.7c11.3 21.6 24.8 42.2 43.5 58.9l3.8 3.4c7.7 6.9 12.1 16.7 12.1 27c0 20-16.2 36.2-36.2 36.2H440c-4.4 0-8 3.6-8 8v72c0 22.1-17.9 40-40 40H312c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8s8-3.6 8-8V448h72c30.9 0 56-25.1 56-56V328h11.8c28.8 0 52.2-23.4 52.2-52.2c0-14.9-6.4-29.1-17.5-39l-3.8-3.4c-16.7-14.9-29.2-33.6-40-54.4c-7-13.4-13.1-27.1-19.3-41c-3.5-7.9-7.1-15.9-10.8-23.9C389.1 46.9 317.6 0 239.7 0H222.9C99.8 0 0 99.8 0 222.9c0 52.8 16.9 101.5 47.4 139.9C57.5 375.5 64 390.2 64 405.3V504c0 4.4 3.6 8 8 8s8-3.6 8-8V405.3c0-19.8-8.5-37.8-20.1-52.4C31.8 317.5 16 272.3 16 222.9zM208 113.1c5.2-.7 10.6-1.1 16-1.1s10.8 .4 16 1.1v4.2c0 16.7 10.8 30.2 23.8 37.8c13 7.5 30.1 10.1 44.6 1.7l3.7-2.1c2.9 3.7 5.6 7.5 8 11.5l2.2 3.7c2.2 4 4.2 8.2 5.9 12.4l-3.6 2.1C309.8 192.9 304 209.1 304 224s5.8 31.1 20.4 39.5l3.6 2.1c-1.7 4.3-3.7 8.4-5.9 12.4l-2.2 3.9c-2.4 4-5.1 7.8-7.9 11.4l-3.7-2.1c-14.5-8.3-31.6-5.8-44.6 1.7c-13 7.5-23.8 21.1-23.8 37.8v4.2c-5.2 .7-10.6 1.1-16 1.1s-10.8-.4-16-1.1v-4.2c0-16.7-10.8-30.2-23.8-37.8c-13-7.5-30.1-10.1-44.6-1.7l-3.7 2.1c-2.9-3.6-5.5-7.5-7.9-11.5l-2.2-3.8c-2.2-4-4.2-8.1-5.9-12.4l3.6-2.1c14.6-8.4 20.4-24.6 20.4-39.5s-5.8-31.1-20.4-39.5l-3.6-2.1c1.7-4.3 3.7-8.5 5.9-12.5l2.1-3.7c2.4-4 5.1-7.9 8-11.5l3.7 2.1c14.5 8.3 31.6 5.8 44.6-1.7c13-7.5 23.8-21.1 23.8-37.8v-4.2zm-3.9-15.6c-7.1 1.1-12.1 7.5-12.1 14.9v4.9c0 9.4-6.2 18.4-15.8 23.9s-20.4 6.4-28.6 1.7l-4.3-2.5c-6.4-3.7-14.5-2.5-19 3c-3.7 4.6-7.1 9.4-10.2 14.5l0 0-.1 .1L112 162l0 0-.1 .1c-2.8 5.1-5.3 10.4-7.4 15.8c-2.6 6.7 .4 14.2 6.8 18l4.2 2.4c8 4.6 12.4 14.3 12.4 25.6s-4.4 21-12.4 25.6l-4.2 2.4c-6.4 3.7-9.4 11.3-6.8 18c2.1 5.4 4.6 10.7 7.3 15.7l0 0 .1 .1 2.3 4 0 0 .1 .1c3 5 6.4 9.9 10.1 14.4c4.5 5.6 12.5 6.8 19 3l4.3-2.5c8.2-4.7 19-3.8 28.6 1.7s15.8 14.5 15.8 23.9v4.9c0 7.4 5.1 13.8 12.1 14.9c6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.1-1.1 12.1-7.5 12.1-14.9v-4.9c0-9.4 6.2-18.4 15.8-23.9s20.4-6.4 28.6-1.7l4.3 2.5c6.4 3.7 14.5 2.5 19-3c3.7-4.5 7.1-9.4 10.1-14.4l0 0 .1-.1 2.3-4 0 0 .1-.1c2.8-5 5.2-10.3 7.3-15.7c2.6-6.7-.4-14.2-6.8-18l-4.2-2.4c-8-4.6-12.4-14.3-12.4-25.6s4.4-21 12.4-25.6l4.2-2.4c6.4-3.7 9.4-11.3 6.8-18c-2.1-5.5-4.6-10.7-7.4-15.8l0 0-.1-.1-2.2-3.9 0 0-.1-.1c-3.1-5.1-6.4-9.9-10.1-14.5c-4.5-5.6-12.5-6.8-19-3l-4.3 2.5c-8.1 4.7-19 3.8-28.6-1.7s-15.8-14.5-15.8-23.9v-4.9c0-7.4-5.1-13.8-12.1-14.9c-6.5-1-13.1-1.5-19.9-1.5s-13.4 .5-19.9 1.5zM224 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 64a40 40 0 1 0 0-80 40 40 0 1 0 0 80z'
      
    ]
  };

  

  
  

  var faArrowUpFromBracket = {
    prefix: 'fat',
    iconName: 'arrow-up-from-bracket',
    icon: [
      448,
      512,
      [],
      'e09a',
      
      'M229.7 2.3c-3.1-3.1-8.2-3.1-11.3 0l-136 136c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L216 27.3 216 344c0 4.4 3.6 8 8 8s8-3.6 8-8l0-316.7L354.3 149.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-136-136zM16 328c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 96c0 48.6 39.4 88 88 88l272 0c48.6 0 88-39.4 88-88l0-96c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 96c0 39.8-32.2 72-72 72L88 496c-39.8 0-72-32.2-72-72l0-96z'
      
    ]
  };

  

  
  

  var faHandPointDown = {
    prefix: 'fat',
    iconName: 'hand-point-down',
    icon: [
      384,
      512,
      [],
      'f0a7',
      
      'M64 464c0 17.7 14.3 32 32 32s32-14.3 32-32V312 256H72c-2.7 0-5.4-.1-8-.4V464zm64-224v0h16v0h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H104c-4.4 0-8-3.6-8-8s3.6-8 8-8h72c18.5 0 34.6 10.5 42.6 25.9C227.4 175 240.9 168 256 168s28.6 7 37.4 17.9c8-15.4 24.1-25.9 42.6-25.9c12.3 0 23.5 4.6 32 12.2V152c0-75.1-60.9-136-136-136H152C76.9 16 16 76.9 16 152v32c0 30.9 25.1 56 56 56h56zm16 16v56c0 17.7 14.3 32 32 32s32-14.3 32-32V280.1c0 0 0 0 0-.1V243.8c-8.5 7.6-19.7 12.2-32 12.2H144zm0 91.8V464c0 26.5-21.5 48-48 48s-48-21.5-48-48V251.9C20 242 0 215.3 0 184V152C0 68.1 68.1 0 152 0h80c83.9 0 152 68.1 152 152v56 24 32c0 26.5-21.5 48-48 48c-13.8 0-26.3-5.8-35-15.2C294.2 315 276.6 328 256 328c-12.4 0-23.6-4.7-32.1-12.3C222 340.5 201.3 360 176 360c-12.3 0-23.5-4.6-32-12.2zM224 240v40c0 17.7 14.3 32 32 32c17.7 0 32-14.3 32-32V264 216c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 24zm144-8V208c0-17.7-14.3-32-32-32s-32 14.3-32 32v8 48c0 17.7 14.3 32 32 32s32-14.3 32-32V232z'
      
    ]
  };

  

  
  

  var faRaccoon = {
    prefix: 'fat',
    iconName: 'raccoon',
    icon: [
      512,
      512,
      [],
      'e613',
      
      'M276.7 44l-54 65.6 44-24.7c26.1-14.7 58.2-2.7 69.2 23.6c11.1-26.2 43.2-38.2 69.2-23.6l44 24.7L395.3 44C380.7 26.3 358.9 16 336 16s-44.7 10.3-59.3 28zM336 146.7c-3.1 7.4-8 14-14.5 19.2l-51.6 41.3c6.7 3 13.2 6.6 19.4 10.7l15 10c-.2-1.3-.2-2.6-.2-3.9c0-17.7 14.3-32 32-32s32 14.3 32 32c0 1.3-.1 2.6-.2 3.9l15-10c6.2-4.1 12.6-7.7 19.4-10.7l-51.6-41.3c-6.5-5.2-11.4-11.8-14.5-19.2zm0 93.3a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0 16c-12 0-23.8-3.6-33.8-10.2l-21.9-14.6c-8-5.3-16.6-9.7-25.6-12.9l-48.7-17.7C188 194 176 176.8 176 157.5c0-10.6 3.7-20.9 10.4-29.1l28.1-34.2L194.8 48.2c-1.8-4.3-2.8-8.9-2.8-13.6C192 15.5 207.5 0 226.6 0h1c3.8 0 7.6 .6 11.2 1.8l44.3 14.8C298.4 5.9 316.9 0 336 0s37.6 5.9 52.9 16.6L433.2 1.8C436.9 .6 440.6 0 444.5 0h1C464.5 0 480 15.5 480 34.6c0 4.7-1 9.3-2.8 13.6L457.4 94.3l28.1 34.2c6.7 8.2 10.4 18.5 10.4 29.1c0 19.2-12 36.4-30.1 43l-48.7 17.7c-9 3.3-17.6 7.6-25.6 12.9l-21.9 14.6C359.8 252.4 348 256 336 256zm83.4-55.6l41-14.9c11.8-4.3 19.6-15.5 19.6-28c0-5.2-1.3-10.2-3.9-14.7l-.1 .1L397.4 98.7c-19.6-11-44.2 .3-48.6 22.3c-2.4 12.1 2.1 24.6 11.8 32.3l58.8 47.1zM311.5 153.4c9.7-7.7 14.2-20.2 11.8-32.3c-4.4-22-29.1-33.4-48.6-22.3L195.9 143l-.1-.1c-2.5 4.4-3.9 9.5-3.9 14.7c0 12.5 7.8 23.7 19.6 28l41 14.9 58.8-47.1zM233.7 17c-2-.7-4.1-1-6.2-1h-1C216.3 16 208 24.3 208 34.6c0 2.5 .5 5 1.5 7.3L226 80.4l38.4-46.6c1.4-1.7 2.9-3.4 4.5-5.1L233.7 17zM407.6 33.8L446 80.4l16.5-38.5c1-2.3 1.5-4.8 1.5-7.3c0-10.2-8.3-18.6-18.6-18.6h-1c-2.1 0-4.2 .3-6.2 1L403.1 28.7c1.6 1.6 3 3.3 4.5 5.1zM128 274.7c17.5-22.6 39.9-41.2 65.7-54.2c4.4 2.4 9 4.3 13.9 5.8l7.3 2.2C149.9 254.3 104 317.8 104 392v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-19.5 2.9-38.3 8.3-56H16v72c0 48.6 39.4 88 88 88H336V472c0-22.1-17.9-40-40-40H248c-4.4 0-8-3.6-8-8s3.6-8 8-8h48c30.9 0 56 25.1 56 56v24H464V472c0-22.1-17.9-40-40-40H408c-4.4 0-8-3.6-8-8s3.6-8 8-8h16c30.9 0 56 25.1 56 56v32c0 4.4-3.6 8-8 8H104C46.6 512 0 465.4 0 408V96C0 60.7 28.7 32 64 32s64 28.7 64 64V274.7zm336 16c0-22.4-11.4-43.2-30-55.3l18.8-5.7c17.1 15.4 27.2 37.5 27.2 61c0 26-12.3 50.4-33.2 65.9l-30.6 22.7c-15.9 11.8-38.1 10.1-52.1-3.9c-17-17-15.4-45.1 3.7-59.9l43.4-33.7c3.5-2.7 8.5-2.1 11.2 1.4s2.1 8.5-1.4 11.2l-43.4 33.7c-11.4 8.8-12.4 25.8-2.2 36c8.4 8.4 21.8 9.4 31.3 2.4l30.6-22.7c16.8-12.4 26.7-32.1 26.7-53zM102 320c2.9-7.2 6.3-14.3 10-21V240H16v80h86zm10-176H16v80h96V144zm0-16V96c0-26.5-21.5-48-48-48S16 69.5 16 96v32h96zM308 375.3l-.5 .5c-13.8 13.8-35.6 15.6-51.5 4.3l-52.7-37.5c-3.6-2.6-4.4-7.6-1.9-11.2s7.6-4.4 11.2-1.9L265.3 367c9.5 6.8 22.6 5.7 30.9-2.6l.5-.5c10.2-10.2 9.2-27.1-2.2-35.9l-43.4-33.7c-3.5-2.7-4.1-7.7-1.4-11.2s7.7-4.1 11.2-1.4l43.4 33.7c19 14.8 20.7 42.8 3.7 59.9zM272 128a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm112-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faOption = {
    prefix: 'fat',
    iconName: 'option',
    icon: [
      640,
      512,
      [],
      'e318',
      
      'M463.8 417.5c7.6 9.2 18.9 14.5 30.8 14.5H632c4.4 0 8 3.6 8 8s-3.6 8-8 8H494.6c-16.7 0-32.5-7.5-43.2-20.3L176.2 94.5C168.6 85.3 157.3 80 145.4 80H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H145.4c16.7 0 32.5 7.5 43.2 20.3L463.8 417.5zM424 80c-4.4 0-8-3.6-8-8s3.6-8 8-8H632c4.4 0 8 3.6 8 8s-3.6 8-8 8H424z'
      
    ]
  };

  

  
  

  var faBacon = {
    prefix: 'fat',
    iconName: 'bacon',
    icon: [
      576,
      512,
      [129363],
      'f7e5',
      
      'M441.7 216c-26.1 23-45.1 49.9-67.3 82.1l-2.2 3.2C327.8 365.9 275.5 442 142.3 508.6c-12.3 6.2-27.2 3.7-36.9-6l-96-96c-7.3-7.3-10.6-17.6-9-27.8s8.1-18.9 17.3-23.5C136.1 296.2 180.9 231 223.3 169.3l2.3-3.4c21.8-31.8 44.9-64.9 77.7-93.9c33.4-29.5 75.8-53.6 135.9-70.8c11.2-3.2 23.2-.1 31.4 8.1l96 96c8 8 11.2 19.7 8.3 30.7s-11.3 19.6-22.2 22.7c-51.9 14.8-85.6 34.7-111.1 57.2zM236.5 178.3l0 0c-42.9 62.5-89.6 130.3-211.6 191.4c-4.6 2.3-7.8 6.7-8.6 11.7s.8 10.2 4.5 13.9l32.9 32.9 22.8-11.4c124-62 171.5-131.2 214.7-194l2.3-3.3c22-31.9 43.5-62.7 73.8-89.5c30.5-26.9 69.5-49.4 126.5-65.7l7.1-2.1L459.3 20.7c-4.1-4.1-10.1-5.7-15.7-4.1c-58 16.6-98.2 39.7-129.7 67.4c-31.2 27.5-53.2 59.1-75.1 90.9l0 0-2.3 3.4zM65.5 440.2l51.1 51.1-8.5 8.5 8.5-8.5c4.9 4.9 12.3 6.1 18.5 3c129.5-64.7 179.9-138.1 223.7-201.9l.1-.1 0 0 2.2-3.2 0 0c22.1-32.1 42.1-60.5 69.9-85.1c27.5-24.3 63.4-45.2 117.3-60.6c5.4-1.6 9.7-5.9 11.1-11.4s-.2-11.3-4.2-15.3L513.7 75l-15.4 4.6-.1 0 0 0c-55 15.7-91.9 37.2-120.4 62.3c-28.7 25.3-49.2 54.5-71.2 86.5l-2.3 3.3c-43.6 63.5-93.1 135.5-220.8 199.3l-18 9z'
      
    ]
  };

  

  
  

  var faTrashList = {
    prefix: 'fat',
    iconName: 'trash-list',
    icon: [
      640,
      512,
      [],
      'e2b1',
      
      'M157.4 27.3L134.4 64H281.6l-23-36.7c-4.4-7-12.1-11.3-20.4-11.3H177.7c-8.3 0-16 4.3-20.4 11.3zM115.6 64l28.2-45.2C151.1 7.1 163.9 0 177.7 0h60.5c13.8 0 26.6 7.1 33.9 18.8L300.4 64H408c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H115.6zM39.3 112c4.4-.4 8.3 2.9 8.6 7.3l28.3 340C78 480.1 95.4 496 116.2 496H299.8c20.8 0 38.1-15.9 39.9-36.7l28.3-340c.4-4.4 4.2-7.7 8.6-7.3s7.7 4.2 7.3 8.6l-28.3 340c-2.4 29-26.7 51.4-55.8 51.4H116.2c-29.1 0-53.4-22.3-55.8-51.4L32 120.7c-.4-4.4 2.9-8.3 7.3-8.6zM456 128H632c4.4 0 8 3.6 8 8s-3.6 8-8 8H456c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 128H600c4.4 0 8 3.6 8 8s-3.6 8-8 8H456c-4.4 0-8-3.6-8-8s3.6-8 8-8zm-8 136c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H456c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faMessageCaptions = {
    prefix: 'fat',
    iconName: 'message-captions',
    icon: [
      512,
      512,
      ["comment-alt-captions"],
      'e1de',
      
      'M176 416c0-8.8-7.2-16-16-16H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H309.3c-3.5 0-6.8 1.1-9.6 3.2L176 496V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h80 16v16 64c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm8 240c-4.4 0-8 3.6-8 8s3.6 8 8 8H312c4.4 0 8-3.6 8-8s-3.6-8-8-8H72zm304 0c-4.4 0-8 3.6-8 8s3.6 8 8 8h64c4.4 0 8-3.6 8-8s-3.6-8-8-8H376zM72 304c-4.4 0-8 3.6-8 8s3.6 8 8 8h96c4.4 0 8-3.6 8-8s-3.6-8-8-8H72zm160 0c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H232z'
      
    ]
  };

  
    var faCommentAltCaptions = faMessageCaptions;
  

  
  

  var faSushi = {
    prefix: 'fat',
    iconName: 'sushi',
    icon: [
      576,
      512,
      [127843,"nigiri"],
      'e48a',
      
      'M328.2 64h38.7c93.2 0 172.9 66.9 189.1 158.6l6 34.1c6.3 35.8-27.9 65.4-62.4 53.9L323.1 252c-26.7-8.9-55.6-8.7-82.3 .5L77.2 309.3c-34.6 12-69.4-17.6-63-53.7L20 222.6C36.2 130.9 115.9 64 209.1 64H327.8c.1 0 .3 0 .4 0zM271.1 195.8c-2.1 3.9-6.9 5.4-10.8 3.3s-5.4-6.9-3.3-10.8L314.7 80H209.1c-1.6 0-3.1 0-4.7 .1L110.8 228.3c-2.4 3.7-7.3 4.9-11 2.5s-4.9-7.3-2.5-11l87.2-138C109.9 92.2 49.2 149.5 35.8 225.4L30 258.3c-4.2 24 18.9 43.8 42 35.8l163.7-56.7c29.9-10.4 62.5-10.6 92.5-.6l176.5 58.6c23 7.6 45.8-12.1 41.6-35.9l-6-34.1c-7.6-43.3-30.7-80.6-63-106.5L414.9 228c-2.2 3.8-7.1 5.2-10.9 3s-5.2-7.1-3-10.9l63.2-110.6C436.2 90.7 402.6 80 366.9 80H332.8L271.1 195.8zM32 352V338.3c5.1 2.1 10.5 3.6 16 4.5V352c0 44.2 35.8 80 80 80c16 0 30.8-4.7 43.3-12.7c5.3-3.4 12.1-3.4 17.4 0C201.2 427.3 216 432 232 432c17.4 0 33.5-5.6 46.7-15c5.6-4 13.1-4 18.7 0c13.1 9.4 29.2 15 46.7 15c16 0 30.8-4.7 43.3-12.7c5.3-3.4 12.1-3.4 17.4 0C417.2 427.3 432 432 448 432c44.2 0 80-35.8 80-80v-7.9c5.5-.9 10.9-2.4 16-4.5V352c0 53-43 96-96 96c-19.2 0-37-5.6-52-15.3c-15 9.7-32.8 15.3-52 15.3c-20.9 0-40.2-6.7-56-18c-15.8 11.3-35.1 18-56 18c-19.2 0-37-5.6-52-15.3c-15 9.7-32.8 15.3-52 15.3c-53 0-96-43-96-96z'
      
    ]
  };

  
    var faNigiri = faSushi;
  

  
  

  var faBullseye = {
    prefix: 'fat',
    iconName: 'bullseye',
    icon: [
      512,
      512,
      [],
      'f140',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-408a152 152 0 1 1 0 304 152 152 0 1 1 0-304zm0 320a168 168 0 1 0 0-336 168 168 0 1 0 0 336zM200 256a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm128 0a72 72 0 1 0 -144 0 72 72 0 1 0 144 0z'
      
    ]
  };

  

  
  

  var faArrowLeftToLine = {
    prefix: 'fat',
    iconName: 'arrow-left-to-line',
    icon: [
      448,
      512,
      [8676,"arrow-to-left"],
      'f33e',
      
      'M0 440c0 4.4 3.6 8 8 8s8-3.6 8-8L16 72c0-4.4-3.6-8-8-8s-8 3.6-8 8L0 440zM98.3 250.3c-3.1 3.1-3.1 8.2 0 11.3l136 136c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L123.3 264 440 264c4.4 0 8-3.6 8-8s-3.6-8-8-8l-316.7 0L245.7 125.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-136 136z'
      
    ]
  };

  
    var faArrowToLeft = faArrowLeftToLine;
  

  
  

  var faLocationSmile = {
    prefix: 'fat',
    iconName: 'location-smile',
    icon: [
      384,
      512,
      ["map-marker-smile"],
      'f60d',
      
      'M368 192c0-97.2-78.8-176-176-176S16 94.8 16 192c0 18.7 6.4 42.5 17.8 69.6c11.3 26.9 27.1 55.8 44.7 84.3c35.2 57 76.8 111.4 102.3 143.2c5.9 7.3 16.6 7.3 22.4 0c25.5-31.8 67.1-86.2 102.3-143.2c17.6-28.5 33.4-57.4 44.7-84.3C361.6 234.5 368 210.7 368 192zm16 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM128 144a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm112 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM102.7 259.6C112.3 274 144.2 304 192 304s79.7-30 89.3-44.4c2.5-3.7 7.4-4.7 11.1-2.2s4.7 7.4 2.2 11.1C282.9 286 246.6 320 192 320s-90.9-34-102.7-51.6c-2.5-3.7-1.5-8.6 2.2-11.1s8.6-1.5 11.1 2.2z'
      
    ]
  };

  
    var faMapMarkerSmile = faLocationSmile;
  

  
  

  var faHelmetUn = {
    prefix: 'fat',
    iconName: 'helmet-un',
    icon: [
      512,
      512,
      [],
      'e503',
      
      'M16 240v72c0 30.9 25.1 56 56 56H218.2l30.2-90.5c1.1-3.3 4.1-5.5 7.6-5.5H464V240C464 116.3 363.7 16 240 16S16 116.3 16 240zm464 0v32h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H472 368V496H472c4.4 0 8 3.6 8 8s-3.6 8-8 8H360c-2 0-4-.8-5.5-2.2L220.8 384H72c-39.8 0-72-32.2-72-72V240C0 107.5 107.5 0 240 0S480 107.5 480 240zM261.8 288l-28.6 85.7L352 485.5V288H261.8zm8.7-188.6L336 191V104c0-4.4 3.6-8 8-8s8 3.6 8 8V216c0 3.5-2.2 6.6-5.6 7.6s-6.9-.1-9-3L272 129v87c0 4.4-3.6 8-8 8s-8-3.6-8-8V104c0-3.5 2.2-6.6 5.6-7.6s6.9 .1 9 3zM144 104v72c0 17.7 14.3 32 32 32s32-14.3 32-32V104c0-4.4 3.6-8 8-8s8 3.6 8 8v72c0 26.5-21.5 48-48 48s-48-21.5-48-48V104c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faUmbrellaBeach = {
    prefix: 'fat',
    iconName: 'umbrella-beach',
    icon: [
      576,
      512,
      [127958],
      'f5ca',
      
      'M462.6 70.6c64.2 49.4 99.6 128.8 92.9 210c-.6 7-8.4 13.2-18.2 9.7l-89.1-32.4 4.1-11.4c16.1-44.3 23-91.4 20.2-138.4c-.8-13.3-4.2-25.9-9.9-37.4zM409.3 39.6c27.1 12.6 45.4 39.1 47.2 69.3c2.7 44.9-3.9 89.8-19.3 132l-4.2 11.4L235.4 180.3l4.1-11.4c15.4-42.2 39.2-80.8 70.1-113.5c21.8-23.1 55-31.4 85-21.5c1.2 .4 2.4 .9 3.6 1.3c3.7 1.4 7.4 2.8 11 4.3zM331.8 21.3c-12.5 5.2-24.1 13-33.7 23.2c-32.4 34.2-57.4 74.7-73.5 119l-4.1 11.4L128 141.2c-9.8-3.6-11.8-13.4-7.7-19.1c48.1-68 128.6-106.3 211.5-100.9zm68-2.4c-109.8-38-228.4 3.2-292.6 94c-11.1 15.7-2.8 36.8 15.3 43.4l92.4 33.6 0 0 15 5.5 197.7 71.9 15 5.5 0 0 89.1 32.4c18.1 6.6 38-4.2 39.6-23.4c9-108.1-52-213.2-155.6-256.9c-2.4-1.1-4.9-2.1-7.4-3l-5.9-2.1c-.9-.3-1.8-.6-2.7-.9zM8 496c-4.4 0-8 3.6-8 8s3.6 8 8 8H568c4.4 0 8-3.6 8-8s-3.6-8-8-8H239.1l84.6-232.4-15-5.5-84.8 233-1.8 4.9H8z'
      
    ]
  };

  

  
  

  var faBrainArrowCurvedRight = {
    prefix: 'fat',
    iconName: 'brain-arrow-curved-right',
    icon: [
      640,
      512,
      ["mind-share"],
      'f677',
      
      'M200 0c-29.9 0-55 20.5-62.1 48.3C105.4 51.3 80 78.7 80 112c0 6.7 1 13.1 2.9 19.1C53.4 140.2 32 167.6 32 200c0 12.4 3.1 24.1 8.7 34.3C16.4 248 0 274.1 0 304c0 33.3 20.4 61.9 49.4 73.9c-.9 4.6-1.4 9.3-1.4 14.1c0 39.8 32.2 72 72 72c3.7 0 7.2-.3 10.8-.8C139 491.4 165.1 512 196 512c26 0 48.5-14.6 60-36c11.5 21.4 34 36 60 36c7 0 13.7-1 20-3c-3.3-4.2-6.6-8.9-9.7-14c-3.3 .7-6.7 1-10.3 1c-27.6 0-50.1-21.4-51.9-48.5c0-.3-.1-.6-.1-.9V444 64c0-26.5 21.5-48 48-48c24.2 0 44.2 17.9 47.5 41.1c.6 4 4 6.9 8 6.9l.5 0c26.5 0 48 21.5 48 48c0 7.7-1.8 14.9-5 21.3c-1.1 2.3-1.1 5 .1 7.2s3.3 3.8 5.8 4.2c26.7 4.3 47 27.4 47 55.3c0 12.3-4 23.6-10.7 32.9c-1.4 2-1.9 4.5-1.2 6.9s2.4 4.3 4.6 5.2c9 3.8 16.9 9.5 23.3 16.7v-5.9c0-4.9 .7-9.6 2.1-14.1c-3.4-2.7-7-5.2-10.8-7.3c5.5-10.2 8.7-21.9 8.7-34.3c0-32.4-21.4-59.8-50.9-68.9c1.9-6 2.9-12.5 2.9-19.1c0-33.3-25.4-60.7-57.9-63.7C367 20.5 341.9 0 312 0c-24.1 0-45.1 13.3-56 33C245.1 13.3 224.1 0 200 0zm48 64V444v2.6c-.1 .3-.1 .6-.1 .9C246.1 474.6 223.6 496 196 496c-25.8 0-47.3-18.8-51.3-43.5c-.4-2.2-1.7-4.2-3.6-5.4s-4.2-1.6-6.4-1c-4.7 1.3-9.6 1.9-14.7 1.9c-30.9 0-56-25.1-56-56c0-5.8 .9-11.5 2.5-16.7c.6-2 .4-4.2-.6-6.1s-2.7-3.3-4.7-3.9C35 357.2 16 332.8 16 304c0-26.6 16.2-49.4 39.3-59.1c2.3-.9 4-2.9 4.6-5.2s.2-4.9-1.2-6.9C52 223.6 48 212.3 48 200c0-27.9 20.4-51 47-55.3c2.5-.4 4.7-2 5.8-4.2s1.2-4.9 .1-7.2c-3.2-6.4-5-13.6-5-21.3c0-26.5 21.5-48 48-48l.5 0c4 0 7.4-2.9 8-6.9C155.8 33.9 175.8 16 200 16c26.5 0 48 21.5 48 48zM528 400c0-8.8-7.2-16-16-16H464c-44.2 0-80 35.8-80 80v27.1c-12.2-11.8-32-36.9-32-75.1c0-53 43-96 96-96h64c8.8 0 16-7.2 16-16V256l96 96-96 96V400zM512 256v32 16H496 448c-61.9 0-112 50.1-112 112c0 54.3 34.6 85.6 45 93.8c1.9 1.5 4.3 2.2 6.7 2.2c6.8 0 12.3-5.5 12.3-12.3V464c0-35.3 28.7-64 64-64h32 16v16 32c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l96-96c6.2-6.2 6.2-16.4 0-22.6l-96-96c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8z'
      
    ]
  };

  
    var faMindShare = faBrainArrowCurvedRight;
  

  
  

  var fa6 = {
    prefix: 'fat',
    iconName: '6',
    icon: [
      320,
      512,
      [],
      '36',
      
      'M16 320a144 144 0 1 1 288 0A144 144 0 1 1 16 320zm84.6-148.6L221.8 45.5c3.1-3.2 3-8.2-.2-11.3s-8.2-3-11.3 .2L46.6 204.4C16.7 235.4 0 276.9 0 320c0 88.4 71.6 160 160 160s160-71.6 160-160s-71.6-160-160-160c-21 0-41.1 4-59.4 11.4z'
      
    ]
  };

  

  
  

  var faCreditCardFront = {
    prefix: 'fat',
    iconName: 'credit-card-front',
    icon: [
      576,
      512,
      [],
      'f38a',
      
      'M512 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM96 296c0 4.4 3.6 8 8 8H472c4.4 0 8-3.6 8-8s-3.6-8-8-8H104c-4.4 0-8 3.6-8 8zm0 64c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H104c-4.4 0-8 3.6-8 8zm136-8c-4.4 0-8 3.6-8 8s3.6 8 8 8H376c4.4 0 8-3.6 8-8s-3.6-8-8-8H232zM424 112h48c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H424c-13.3 0-24-10.7-24-24V136c0-13.3 10.7-24 24-24zm-40 24v32c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V136c0-22.1-17.9-40-40-40H424c-22.1 0-40 17.9-40 40z'
      
    ]
  };

  

  
  

  var faBatteryLow = {
    prefix: 'fat',
    iconName: 'battery-low',
    icon: [
      576,
      512,
      ["battery-1"],
      'e0b1',
      
      'M448 112c35.3 0 64 28.7 64 64v16 16 96 16 16c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V176c0-35.3 28.7-64 64-64H448zm80 224V320h16c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H528V176c0-44.2-35.8-80-80-80H80C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H448c44.2 0 80-35.8 80-80zm0-32V208h16c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H528zM144 208v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V208c0-17.7 14.3-32 32-32s32 14.3 32 32zm-80 0v96c0 26.5 21.5 48 48 48s48-21.5 48-48V208c0-26.5-21.5-48-48-48s-48 21.5-48 48z'
      
    ]
  };

  
    var faBattery1 = faBatteryLow;
  

  
  

  var faAlignJustify = {
    prefix: 'fat',
    iconName: 'align-justify',
    icon: [
      448,
      512,
      [],
      'f039',
      
      'M8 56c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zM0 192c0 4.4 3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H8c-4.4 0-8 3.6-8 8zM8 312c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zM8 440c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H8z'
      
    ]
  };

  

  
  

  var faFanTable = {
    prefix: 'fat',
    iconName: 'fan-table',
    icon: [
      448,
      512,
      [],
      'e004',
      
      'M432 224A208 208 0 1 0 16 224a208 208 0 1 0 416 0zm16 0c0 121-96 219.6-216 223.9V496H376c4.4 0 8 3.6 8 8s-3.6 8-8 8H224 72c-4.4 0-8-3.6-8-8s3.6-8 8-8H216V447.9C96 443.6 0 345 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224zM192.3 81.5l34.5 85.3c20.6-21 50.5-32.2 81.9-27.8c52.5 7.4 89.1 55.9 81.7 108.4c-1.8 13.1-14 22.3-27.1 20.4L272.2 255c7.9 28.3 2.7 59.9-16.8 84.8c-32.6 41.8-93 49.2-134.8 16.5l4.9-6.3-4.9 6.3c-10.4-8.2-12.3-23.2-4.1-33.7l56.6-72.5c-28.5-7.4-53.2-27.6-65-57c-19.9-49.2 3.9-105.1 53-125c12.3-5 26.3 1 31.2 13.3zm-25.2 1.6c-41 16.6-60.8 63.2-44.2 104.1c11.4 28.3 37.2 46.5 65.5 49.6c2.9 .3 5.4 2.2 6.5 4.8s.7 5.7-1.1 8L129 332.5c-2.7 3.5-2.1 8.5 1.4 11.2c34.8 27.2 85.1 21 112.3-13.8c18.8-24 21.7-55.4 10.2-81.5c-1.2-2.7-.8-5.7 .9-8s4.6-3.5 7.5-3.1L365.5 252c4.4 .6 8.4-2.4 9-6.8c6.1-43.8-24.3-84.2-68.1-90.4c-30.2-4.2-58.8 8.9-75.7 31.9c-1.7 2.3-4.6 3.6-7.4 3.2s-5.3-2.3-6.4-4.9L177.5 87.5c-1.7-4.1-6.3-6.1-10.4-4.4zM224 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faBookmark = {
    prefix: 'fat',
    iconName: 'bookmark',
    icon: [
      384,
      512,
      [61591,128278],
      'f02e',
      
      'M0 56C0 25.1 25.1 0 56 0H328c30.9 0 56 25.1 56 56V485.8c0 14.5-11.8 26.2-26.2 26.2c-5.4 0-10.6-1.7-15.1-4.7L192 401.8 41.3 507.3c-4.4 3.1-9.7 4.7-15.1 4.7C11.8 512 0 500.2 0 485.8V56zM56 16C33.9 16 16 33.9 16 56V485.8c0 5.7 4.6 10.2 10.2 10.2c2.1 0 4.2-.6 5.9-1.9L187.4 385.4c2.8-1.9 6.4-1.9 9.2 0L351.9 494.1c1.7 1.2 3.8 1.9 5.9 1.9c5.7 0 10.2-4.6 10.2-10.2V56c0-22.1-17.9-40-40-40H56z'
      
    ]
  };

  

  
  

  var faSemicolon = {
    prefix: 'fat',
    iconName: 'semicolon',
    icon: [
      192,
      512,
      [],
      '3b',
      
      'M48 128a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0A64 64 0 1 0 32 128a64 64 0 1 0 128 0zM144 350.4c0 8.5-2.4 16.9-6.8 24.2L69 486.2c-3.7 6.1-10.3 9.8-17.5 9.8c-12.7 0-22.4-11.5-20.1-24.1L54.8 341.1C58.6 319.6 77.3 304 99 304c24.8 0 45 20.1 45 45v1.5zm16 0V349c0-33.7-27.3-61-61-61c-29.5 0-54.8 21.2-60 50.2L15.7 469.1c-4 22.3 13.2 42.9 35.9 42.9c12.7 0 24.5-6.6 31.1-17.4L150.8 383c6-9.8 9.2-21.1 9.2-32.6z'
      
    ]
  };

  

  
  

  var faSquareExclamation = {
    prefix: 'fat',
    iconName: 'square-exclamation',
    icon: [
      448,
      512,
      ["exclamation-square"],
      'f321',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 32c4.4 0 8 3.6 8 8V296c0 4.4-3.6 8-8 8s-8-3.6-8-8V136c0-4.4 3.6-8 8-8zM208 352a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  
    var faExclamationSquare = faSquareExclamation;
  

  
  

  var faTrainSubwayTunnel = {
    prefix: 'fat',
    iconName: 'train-subway-tunnel',
    icon: [
      512,
      512,
      ["subway-tunnel"],
      'e2a3',
      
      'M16 256C16 123.5 123.5 16 256 16s240 107.5 240 240V504c0 4.4 3.6 8 8 8s8-3.6 8-8V256C512 114.6 397.4 0 256 0S0 114.6 0 256V504c0 4.4 3.6 8 8 8s8-3.6 8-8V256zM192 144H320c35.3 0 64 28.7 64 64V368c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64V208c0-35.3 28.7-64 64-64zm-80 64V368c0 38.2 26.8 70.2 62.6 78.1l-52.2 52.2c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L195.3 448H316.7l61.7 61.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-52.2-52.2c35.8-7.9 62.6-39.9 62.6-78.1V208c0-44.2-35.8-80-80-80H192c-44.2 0-80 35.8-80 80zm64 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm176-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM248 208l0 96H192c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16h56zm16 0h56c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H264l0-96zm-72-16c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H192z'
      
    ]
  };

  
    var faSubwayTunnel = faTrainSubwayTunnel;
  

  
  

  var faSquareUp = {
    prefix: 'fat',
    iconName: 'square-up',
    icon: [
      448,
      512,
      [11014,"arrow-alt-square-up"],
      'f353',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 16c7.2 0 14.2 2.9 19.3 8L343 219.7c5.7 5.7 9 13.5 9 21.7c0 16.9-13.7 30.6-30.6 30.6H272v88c0 22.1-17.9 40-40 40H216c-22.1 0-40-17.9-40-40V272H126.6C109.7 272 96 258.3 96 241.4c0-8.1 3.2-15.9 9-21.7L204.7 120c5.1-5.1 12.1-8 19.3-8zm-8 19.3L116.3 231c-2.7 2.7-4.3 6.5-4.3 10.3c0 8.1 6.5 14.6 14.6 14.6H184c4.4 0 8 3.6 8 8v96c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V264c0-4.4 3.6-8 8-8h57.4c8.1 0 14.6-6.5 14.6-14.6c0-3.9-1.5-7.6-4.3-10.3L232 131.3c-2.1-2.1-5-3.3-8-3.3s-5.9 1.2-8 3.3z'
      
    ]
  };

  
    var faArrowAltSquareUp = faSquareUp;
  

  
  

  var faFaceHoldingBackTears = {
    prefix: 'fat',
    iconName: 'face-holding-back-tears',
    icon: [
      512,
      512,
      [129401],
      'e482',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM320.5 106.8c-1.6-4.1 .5-8.7 4.7-10.3s8.7 .5 10.3 4.7l1.2 3.1c13.3 35.5 43.6 61.8 80.6 70l8.5 1.9c4.3 1 7 5.2 6.1 9.5s-5.2 7-9.5 6.1l-7.7-1.7c10.9 13.7 17.5 31 17.5 49.9c0 44.2-35.8 80-80 80s-80-35.8-80-80s35.8-80 80-80c1.3 0 2.6 0 3.9 .1c-15-13.5-26.9-30.6-34.2-50.2l-1.2-3.1zM186.8 96.5c4.1 1.6 6.2 6.2 4.7 10.3l-1.2 3.1c-7.3 19.5-19.2 36.6-34.2 50.2c1.3-.1 2.6-.1 3.9-.1c44.2 0 80 35.8 80 80s-35.8 80-80 80s-80-35.8-80-80c0-18.9 6.5-36.2 17.5-49.9l-7.7 1.7c-4.3 1-8.6-1.8-9.5-6.1s1.8-8.6 6.1-9.5l8.5-1.9c37-8.2 67.3-34.6 80.6-70l1.2-3.1c1.6-4.1 6.2-6.2 10.3-4.7zM224 240A64 64 0 1 0 96 240a64 64 0 1 0 128 0zm128 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM192 240c0-12-6.6-22.4-16.3-27.9c-2 15.7-15.5 27.9-31.7 27.9c-5.7 0-11.1-1.5-15.7-4.1c-.2 1.4-.3 2.7-.3 4.1c0 17.7 14.3 32 32 32s32-14.3 32-32zm-80 0c0-6.2 1.2-12.2 3.4-17.7c2.1-5.3 5.1-10.1 8.9-14.3c1.4-1.5 2.8-3 4.4-4.3c-.4 1.4-.6 2.8-.6 4.3c0 5.2 2.5 9.9 6.4 12.8c2.7 2 6 3.2 9.6 3.2c8.8 0 16-7.2 16-16l0-.1c0-6.7-4.3-12.5-10.2-14.8c3.3-.7 6.7-1.1 10.2-1.1c4.4 0 8.6 .6 12.6 1.7C193 199.2 208 217.9 208 240c0 26.5-21.5 48-48 48s-48-21.5-48-48zm240 32c17.7 0 32-14.3 32-32c0-12-6.6-22.4-16.3-27.9c-2 15.7-15.5 27.9-31.7 27.9c-5.7 0-11.1-1.5-15.7-4.1c-.2 1.4-.3 2.7-.3 4.1c0 17.7 14.3 32 32 32zm-44.6-49.7c2.1-5.3 5.1-10.1 8.9-14.3c1.4-1.5 2.8-3 4.4-4.3c-.4 1.4-.6 2.8-.6 4.3c0 5.2 2.5 9.9 6.4 12.8c2.7 2 6 3.2 9.6 3.2c8.8 0 16-7.2 16-16c0-6.8-4.2-12.6-10.2-14.9c3.3-.7 6.7-1.1 10.2-1.1c4.4 0 8.6 .6 12.6 1.7C385 199.2 400 217.9 400 240c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-6.2 1.2-12.2 3.4-17.7zm26.1 147.1c2.5-3.6 7.5-4.5 11.1-2s4.5 7.5 2 11.1c-17 24.3-47.1 51.4-90.6 51.4s-73.5-27.1-90.6-51.4c-2.5-3.6-1.7-8.6 2-11.1s8.6-1.7 11.1 2C194 391.5 219.9 414 256 414s62-22.5 77.4-44.6z'
      
    ]
  };

  

  
  

  var faBowlSoftServe = {
    prefix: 'fat',
    iconName: 'bowl-soft-serve',
    icon: [
      512,
      512,
      [],
      'e46b',
      
      'M264 0c-3 0-5.7 1.6-7.1 4.2s-1.2 5.8 .4 8.2l10.8 16.3c2.5 3.7 3.8 8.1 3.8 12.6C272 53.8 261.8 64 249.3 64H176c-35.3 0-64 28.7-64 64c0 8.5 1.7 16.6 4.7 24H108c-42 0-76 34-76 76s34 76 76 76H404c42 0 76-34 76-76s-34-76-76-76H391.7c5.3-10.2 8.3-21.7 8.3-34C400 52.8 347.2 0 282 0H264zm17.5 19.8L278.9 16H282c56.3 0 102 45.7 102 102c0 12.7-4.1 24.4-11 34H296c-4.4 0-8 3.6-8 8s3.6 8 8 8h80.9H384h20c33.1 0 60 26.9 60 60s-26.9 60-60 60H108c-33.1 0-60-26.9-60-60s26.9-60 60-60h20 2 38c4.4 0 8-3.6 8-8s-3.6-8-8-8H134.4c-4.1-7.1-6.4-15.2-6.4-24c0-26.5 21.5-48 48-48h73.3C270.7 80 288 62.7 288 41.3c0-7.6-2.3-15.1-6.5-21.5zM64 336c0-4.4-3.6-8-8-8s-8 3.6-8 8v16c0 53 43 96 96 96h43.1l-26.2 52.4c-1.2 2.5-1.1 5.4 .4 7.8s4 3.8 6.8 3.8H344c2.8 0 5.3-1.4 6.8-3.8s1.6-5.3 .3-7.8L324.9 448H368c53 0 96-43 96-96V336c0-4.4-3.6-8-8-8s-8 3.6-8 8v16c0 44.2-35.8 80-80 80H312c-2.8 0-5.3 1.4-6.8 3.8s-1.6 5.3-.4 7.8L331.1 496H180.9l26.2-52.4c1.2-2.5 1.1-5.4-.4-7.8s-4-3.8-6.8-3.8H144c-44.2 0-80-35.8-80-80V336z'
      
    ]
  };

  

  
  

  var faBaguette = {
    prefix: 'fat',
    iconName: 'baguette',
    icon: [
      640,
      512,
      [129366],
      'e3d8',
      
      'M605.2 65.9C570.9 14.4 501.3 .5 449.9 34.8L361.2 93.9l60.4 60.4c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L347.6 103 246 170.7l63.6 63.6c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-65.9-65.9L130.8 247.5l66.8 66.8c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-69.1-69.1L65.9 290.8C14.4 325.1 .5 394.7 34.8 446.1s103.8 65.4 155.3 31.1l384-256c51.5-34.3 65.4-103.8 31.1-155.3zM618.5 57c39.2 58.8 23.3 138.3-35.5 177.5l-384 256C140.2 529.7 60.7 513.8 21.5 455S-1.8 316.7 57 277.5l384-256C499.8-17.7 579.3-1.8 618.5 57z'
      
    ]
  };

  

  
  

  var faBarcodeRead = {
    prefix: 'fat',
    iconName: 'barcode-read',
    icon: [
      576,
      512,
      [],
      'f464',
      
      'M40 16C26.7 16 16 26.7 16 40V152c0 4.4-3.6 8-8 8s-8-3.6-8-8V40C0 17.9 17.9 0 40 0H152c4.4 0 8 3.6 8 8s-3.6 8-8 8H40zm96 112c4.4 0 8 3.6 8 8V376c0 4.4-3.6 8-8 8s-8-3.6-8-8V136c0-4.4 3.6-8 8-8zm48 0c4.4 0 8 3.6 8 8V376c0 4.4-3.6 8-8 8s-8-3.6-8-8V136c0-4.4 3.6-8 8-8zm56 8c0-4.4 3.6-8 8-8s8 3.6 8 8V376c0 4.4-3.6 8-8 8s-8-3.6-8-8V136zm88-8c4.4 0 8 3.6 8 8V376c0 4.4-3.6 8-8 8s-8-3.6-8-8V136c0-4.4 3.6-8 8-8zm40 8c0-4.4 3.6-8 8-8s8 3.6 8 8V376c0 4.4-3.6 8-8 8s-8-3.6-8-8V136zm72-8c4.4 0 8 3.6 8 8V376c0 4.4-3.6 8-8 8s-8-3.6-8-8V136c0-4.4 3.6-8 8-8zM560 40c0-13.3-10.7-24-24-24H424c-4.4 0-8-3.6-8-8s3.6-8 8-8H536c22.1 0 40 17.9 40 40V152c0 4.4-3.6 8-8 8s-8-3.6-8-8V40zM40 496H152c4.4 0 8 3.6 8 8s-3.6 8-8 8H40c-22.1 0-40-17.9-40-40V360c0-4.4 3.6-8 8-8s8 3.6 8 8V472c0 13.3 10.7 24 24 24zm520-24V360c0-4.4 3.6-8 8-8s8 3.6 8 8V472c0 22.1-17.9 40-40 40H424c-4.4 0-8-3.6-8-8s3.6-8 8-8H536c13.3 0 24-10.7 24-24z'
      
    ]
  };

  

  
  

  var faArrowUpBigSmall = {
    prefix: 'fat',
    iconName: 'arrow-up-big-small',
    icon: [
      576,
      512,
      ["sort-size-up"],
      'f88e',
      
      'M154.3 34.3c3.1-3.1 8.2-3.1 11.3 0l104 104c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L168 59.3V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V59.3L61.7 149.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l104-104zM336 432c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V368c0-17.7-14.3-32-32-32H368c-17.7 0-32 14.3-32 32v64zm-16 0V368c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48zM336 80V208c0 17.7 14.3 32 32 32H496c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32H368c-17.7 0-32 14.3-32 32zm-16 0c0-26.5 21.5-48 48-48H496c26.5 0 48 21.5 48 48V208c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V80z'
      
    ]
  };

  
    var faSortSizeUp = faArrowUpBigSmall;
  

  
  

  var faMoneyBill = {
    prefix: 'fat',
    iconName: 'money-bill',
    icon: [
      576,
      512,
      [],
      'f0d6',
      
      'M64 80c-26.5 0-48 21.5-48 48V384c0 26.5 21.5 48 48 48H512c26.5 0 48-21.5 48-48V128c0-26.5-21.5-48-48-48H64zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm536 56h-8c-39.8 0-72-32.2-72-72v-8c0-4.4 3.6-8 8-8s8 3.6 8 8v8c0 30.9 25.1 56 56 56h8c4.4 0 8 3.6 8 8s-3.6 8-8 8zM32 176c0-4.4 3.6-8 8-8h8c30.9 0 56-25.1 56-56v-8c0-4.4 3.6-8 8-8s8 3.6 8 8v8c0 39.8-32.2 72-72 72H40c-4.4 0-8-3.6-8-8zM536 328c4.4 0 8 3.6 8 8s-3.6 8-8 8h-8c-30.9 0-56 25.1-56 56v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-39.8 32.2-72 72-72h8zM32 336c0-4.4 3.6-8 8-8h8c39.8 0 72 32.2 72 72v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-30.9-25.1-56-56-56H40c-4.4 0-8-3.6-8-8zm336-80a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-176 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z'
      
    ]
  };

  

  
  

  var faHandPointUp = {
    prefix: 'fat',
    iconName: 'hand-point-up',
    icon: [
      384,
      512,
      [9757],
      'f0a6',
      
      'M64 48c0-17.7 14.3-32 32-32s32 14.3 32 32V200v56H72c-2.7 0-5.4 .1-8 .4V48zm64 224v0h16v0h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H104c-4.4 0-8 3.6-8 8s3.6 8 8 8h72c18.5 0 34.6-10.5 42.6-25.9C227.4 337 240.9 344 256 344s28.6-7 37.4-17.9c8 15.4 24.1 25.9 42.6 25.9c12.3 0 23.5-4.6 32-12.2V360c0 75.1-60.9 136-136 136H152C76.9 496 16 435.1 16 360V328c0-30.9 25.1-56 56-56h56zm16-16V200c0-17.7 14.3-32 32-32s32 14.3 32 32v31.9c0 0 0 0 0 .1v36.2c-8.5-7.6-19.7-12.2-32-12.2H144zm0-91.8V48c0-26.5-21.5-48-48-48S48 21.5 48 48V260.1C20 270 0 296.7 0 328v32c0 83.9 68.1 152 152 152h80c83.9 0 152-68.1 152-152V304 280 248c0-26.5-21.5-48-48-48c-13.8 0-26.3 5.8-35 15.2C294.2 197 276.6 184 256 184c-12.4 0-23.6 4.7-32.1 12.3C222 171.5 201.3 152 176 152c-12.3 0-23.5 4.6-32 12.2zM224 272V232c0-17.7 14.3-32 32-32c17.7 0 32 14.3 32 32v16 48c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-24zm144 8v24c0 17.7-14.3 32-32 32s-32-14.3-32-32v-8V248c0-17.7 14.3-32 32-32s32 14.3 32 32v32z'
      
    ]
  };

  

  
  

  var faSquareJ = {
    prefix: 'fat',
    iconName: 'square-j',
    icon: [
      448,
      512,
      [],
      'e273',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm304 40V296c0 48.6-39.4 88-88 88s-88-39.4-88-88V280c0-4.4 3.6-8 8-8s8 3.6 8 8v16c0 39.8 32.2 72 72 72s72-32.2 72-72V136c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faBagShoppingPlus = {
    prefix: 'fat',
    iconName: 'bag-shopping-plus',
    icon: [
      448,
      512,
      [],
      'e651',
      
      'M144 96v32H304V96c0-44.2-35.8-80-80-80s-80 35.8-80 80zm-16 32V96c0-53 43-96 96-96s96 43 96 96v32h80c26.5 0 48 21.5 48 48V416c0 53-43 96-96 96H96c-53 0-96-43-96-96V176c0-26.5 21.5-48 48-48h80zm8 16H48c-17.7 0-32 14.3-32 32V416c0 44.2 35.8 80 80 80H352c44.2 0 80-35.8 80-80V176c0-17.7-14.3-32-32-32H312 136zm0 176c0-4.4 3.6-8 8-8h72V240c0-4.4 3.6-8 8-8s8 3.6 8 8v72h72c4.4 0 8 3.6 8 8s-3.6 8-8 8H232v72c0 4.4-3.6 8-8 8s-8-3.6-8-8V328H144c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faSquareDashed = {
    prefix: 'fat',
    iconName: 'square-dashed',
    icon: [
      448,
      512,
      [],
      'e269',
      
      'M88 32h32c4.4 0 8 3.6 8 8s-3.6 8-8 8H88c-39.8 0-72 32.2-72 72v32c0 4.4-3.6 8-8 8s-8-3.6-8-8V120C0 71.4 39.4 32 88 32zM8 192c4.4 0 8 3.6 8 8V312c0 4.4-3.6 8-8 8s-8-3.6-8-8V200c0-4.4 3.6-8 8-8zm432 0c4.4 0 8 3.6 8 8V312c0 4.4-3.6 8-8 8s-8-3.6-8-8V200c0-4.4 3.6-8 8-8zm0-32c-4.4 0-8-3.6-8-8V120c0-39.8-32.2-72-72-72H328c-4.4 0-8-3.6-8-8s3.6-8 8-8h32c48.6 0 88 39.4 88 88v32c0 4.4-3.6 8-8 8zm8 200v32c0 48.6-39.4 88-88 88H328c-4.4 0-8-3.6-8-8s3.6-8 8-8h32c39.8 0 72-32.2 72-72V360c0-4.4 3.6-8 8-8s8 3.6 8 8zM16 360v32c0 39.8 32.2 72 72 72h32c4.4 0 8 3.6 8 8s-3.6 8-8 8H88c-48.6 0-88-39.4-88-88V360c0-4.4 3.6-8 8-8s8 3.6 8 8zM168 480c-4.4 0-8-3.6-8-8s3.6-8 8-8H280c4.4 0 8 3.6 8 8s-3.6 8-8 8H168zM160 40c0-4.4 3.6-8 8-8H280c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faFaceFrownOpen = {
    prefix: 'fat',
    iconName: 'face-frown-open',
    icon: [
      512,
      512,
      [128550,"frown-open"],
      'f57a',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm144 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm17.1 184.7c-23.4-9.9-49.7-15.5-77.6-15.5c-27.8 0-54.1 5.6-77.5 15.4c-8.7 3.7-18.2 2.3-24.9-2.6c-7-5.2-10.7-14.5-6.4-24.3c17.9-41.2 60-69.9 108.8-69.9c48.8 0 90.9 28.7 108.8 69.9c4.3 9.9 .6 19.1-6.4 24.3c-6.7 4.9-16.2 6.3-24.9 2.6zm16.6-20.5c-15.4-35.3-51.7-60.3-94.2-60.3c-42.5 0-78.8 25-94.2 60.3c-.6 1.5-.5 2.4-.4 3c.2 .6 .7 1.4 1.6 2.1c2 1.5 5.6 2.2 9.1 .7c25.4-10.7 53.8-16.7 83.7-16.7c30 0 58.4 6 83.8 16.7c3.6 1.5 7.1 .8 9.1-.7c1-.7 1.4-1.5 1.6-2.1c.2-.6 .3-1.5-.4-3z'
      
    ]
  };

  
    var faFrownOpen = faFaceFrownOpen;
  

  
  

  var faFileVector = {
    prefix: 'fat',
    iconName: 'file-vector',
    icon: [
      384,
      512,
      [],
      'e64c',
      
      'M64 496c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM96 240h32v8 16 8h-8H104 96V240zm8 48v96H96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-8h96v8c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16h-8V288h8c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H256c-8.8 0-16 7.2-16 16v8H144v-8c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h8zm160 0v96h-8c-8.8 0-16 7.2-16 16v8H144v-8c0-8.8-7.2-16-16-16h-8V288h8c8.8 0 16-7.2 16-16v-8h96v8c0 8.8 7.2 16 16 16h8zm-8 144v-8V408v-8h8 16 8v32H256zm-128-8v8H96V400h8 16 8v8 16zM288 272h-8H264h-8v-8V248v-8h32v32z'
      
    ]
  };

  

  
  

  var faTally1 = {
    prefix: 'fat',
    iconName: 'tally-1',
    icon: [
      640,
      512,
      [],
      'e294',
      
      'M128 32c4.4 0 8 3.6 8 8V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V40c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faPooStorm = {
    prefix: 'fat',
    iconName: 'poo-storm',
    icon: [
      448,
      512,
      ["poo-bolt"],
      'f75a',
      
      'M172.3 3.4c1.5-2.1 3.9-3.4 6.5-3.4c42.1 0 79.7 11.3 107.8 32.7c27 20.6 44.6 50.2 48.6 87C364 133 384 162.1 384 196c0 3.5-.2 7-.6 10.4C421.1 220.7 448 257.2 448 300c0 52.5-40.5 95.6-91.9 99.7c4.5-5.2 7.8-11.2 9.8-17.6c37.8-8.2 66.1-41.8 66.1-82.1c0-38-25.3-70.2-59.9-80.5c-4-1.2-6.4-5.2-5.5-9.3c1-4.6 1.5-9.3 1.5-14.2c0-28.8-17.9-53.5-43.3-63.4c-2.9-1.1-4.8-3.8-5.1-6.9c-2.5-34.4-18.2-61.6-42.8-80.3c-22.3-17-52.1-27.3-86.6-29.1C194.5 28.3 200 46 200 63.4c0 27.5-13.8 43.9-27.5 53.1c-6.7 4.5-13.4 7.3-18.4 9c-2.5 .8-4.6 1.4-6.1 1.8l-.2 0c-1 .5-2 .8-3.1 .8C108.6 129.9 80 159.6 80 196c0 4.9 .5 9.6 1.5 14.2c.9 4.1-1.5 8.1-5.5 9.3C41.3 229.8 16 262 16 300c0 40.3 28.3 73.9 66.1 82.1c.2 .6 .4 1.2 .6 1.8c2.1 5.9 5.2 11.3 9.2 15.8C40.5 395.6 0 352.5 0 300c0-42.8 26.9-79.3 64.6-93.6c-.4-3.4-.6-6.9-.6-10.4c0-44.2 34.2-80.5 77.6-83.8c.3-.1 .7-.2 1.1-.3l0 0 0 0 0 0 0 0 0 0 .3-.1c.3-.1 .7-.1 1.2-.3c1.1-.3 2.8-.7 4.8-1.4c4-1.3 9.3-3.6 14.6-7.1C173.8 96.3 184 84.5 184 63.4c0-17.5-6.7-36.1-11-47.8l0-.1 0 0 0 0c-.7-1.8-1.3-3.5-1.8-5c-.8-2.4-.4-5.1 1.1-7.2zm63.3 341.5L288 240 128 368h70.1c5.5 0 10.7 2.9 13.6 7.6s3.2 10.6 .7 15.6L160 496 320 368H249.9c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6zm66.7-97.7L257.9 336l-8 16h17.9H320c6.8 0 12.9 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L190.1 400l8-16H180.2 128c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1s7.6 12.9 4.3 19.6z'
      
    ]
  };

  
    var faPooBolt = faPooStorm;
  

  
  

  var faCapsules = {
    prefix: 'fat',
    iconName: 'capsules',
    icon: [
      576,
      512,
      [],
      'f46b',
      
      'M112 48c-53 0-96 43-96 96V256H208V144c0-53-43-96-96-96zM16 368c0 53 43 96 96 96s96-43 96-96V272H16v96zM0 144C0 82.1 50.1 32 112 32s112 50.1 112 112v24.2c3-32.2 19.3-63 47.3-83c50.7-36.2 120.5-23.6 156 28.1L555.7 300.6c35.5 51.7 23.2 123-27.5 159.2s-120.5 23.6-156-28.1L243.8 244.4c-11.5-16.8-18-35.7-19.8-54.8V368c0 61.9-50.1 112-112 112S0 429.9 0 368V144zm257 91.4l62.8 91.6L474.1 209.8l-60-87.5c-30.5-44.4-90.2-55.1-133.5-24.1c-43.5 31.1-54.2 92.5-23.6 137.2zM385.4 422.7c30.5 44.4 90.2 55.1 133.5 24.1c43.5-31.1 54.2-92.5 23.6-137.2L483.1 223 328.8 340.1l56.6 82.5z'
      
    ]
  };

  

  
  

  var faDonut = {
    prefix: 'fat',
    iconName: 'donut',
    icon: [
      512,
      512,
      [127849,"doughnut"],
      'e406',
      
      'M16 208c0-36.7 23.8-72.3 67.5-99.6C126.9 81.3 187.8 64 256 64c9.4 0 18.6 .3 27.7 1L250.3 98.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l40-40c.8-.8 1.4-1.8 1.8-2.8c48.8 6 92 20.9 125.1 41.6C472.2 135.7 496 171.3 496 208v23.3c-.7 10.5-4.5 20.6-10.9 28.9c-6.5 8.4-15.3 14.6-25.4 17.9l0 0-.3 .1c-10.7 4-19.8 11.3-26.1 20.9c-9.2 12.9-21.6 23.1-36 29.7c-14.4 6.7-30.3 9.5-46.1 8.2l-.3 0-.3 0c-15.3-.1-30.4 2.8-44.6 8.7l0 0c-15.8 6.7-32.8 10.1-50 9.9v0l-.2 0c-17.2 .2-34.2-3.2-50-9.9l0 0c-14.1-5.9-29.3-8.8-44.6-8.7l-.3 0-.3 0c-15.8 1.3-31.7-1.5-46.1-8.2c-14.3-6.7-26.7-16.9-36-29.8c-6.2-9.5-15.4-16.8-26-20.9l0 0-.4-.1c-10.1-3.3-18.9-9.5-25.4-17.9c-6.4-8.3-10.2-18.4-10.9-29V208zm0 64.1c8.2 9.8 19 17.1 31.2 21.1c7.5 2.8 13.8 8 18.2 14.7l0 0 .2 .3c10.8 15.2 25.4 27.3 42.3 35.2c16.8 7.8 35.4 11.2 53.8 9.7c13-.1 25.9 2.4 37.9 7.5c17.8 7.6 37 11.4 56.3 11.2c19.3 .2 38.5-3.6 56.3-11.2c12-5 24.9-7.5 37.9-7.5c18.5 1.5 37-1.8 53.8-9.6c16.9-7.8 31.5-19.9 42.4-35.1l0 0 .2-.3c4.3-6.7 10.7-11.9 18.2-14.7c12.2-4 23-11.3 31.2-21.1V304c0 36.7-23.8 72.3-67.5 99.6C385.1 430.7 324.2 448 256 448s-129.1-17.3-172.5-44.4C39.8 376.3 16 340.7 16 304V272.1zM256 48C114.6 48 0 119.6 0 208v96c0 88.4 114.6 160 256 160s256-71.6 256-160V208c0-88.4-114.6-160-256-160zM209 170.7c11.6-6.5 28.2-10.7 47-10.7s35.4 4.2 47 10.7c11.9 6.6 17 14.5 17 21.3s-5.1 14.7-17 21.3c-11.6 6.5-28.2 10.7-47 10.7s-35.4-4.2-47-10.7c-11.9-6.6-17-14.5-17-21.3s5.1-14.7 17-21.3zm-7.8-14C187 164.6 176 176.7 176 192s11 27.4 25.2 35.3c14.4 8 33.8 12.7 54.8 12.7s40.4-4.7 54.8-12.7c14.2-7.9 25.2-20 25.2-35.3s-11-27.4-25.2-35.3C296.4 148.7 277 144 256 144s-40.4 4.7-54.8 12.7zm-35.5-23.1c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-32 32c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l32-32zm224 4.7c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l32 32c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-32-32zM64 200c-4.4 0-8 3.6-8 8s3.6 8 8 8H96c4.4 0 8-3.6 8-8s-3.6-8-8-8H64zm325.7 34.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l32 32c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-32-32zm-240 16c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l32 32c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-32-32zm176 27.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-32 32c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l32-32z'
      
    ]
  };

  
    var faDoughnut = faDonut;
  

  
  

  var faDongSign = {
    prefix: 'fat',
    iconName: 'dong-sign',
    icon: [
      384,
      512,
      [],
      'e169',
      
      'M312 32c-4.4 0-8 3.6-8 8V80H200c-4.4 0-8 3.6-8 8s3.6 8 8 8H304V226c-21.8-39.4-63.8-66-112-66c-70.7 0-128 57.3-128 128s57.3 128 128 128c48.2 0 90.2-26.6 112-66v58c0 4.4 3.6 8 8 8s8-3.6 8-8V288 96h24c4.4 0 8-3.6 8-8s-3.6-8-8-8H320V40c0-4.4-3.6-8-8-8zM80 288a112 112 0 1 1 224 0A112 112 0 1 1 80 288zM8 464c-4.4 0-8 3.6-8 8s3.6 8 8 8H376c4.4 0 8-3.6 8-8s-3.6-8-8-8H8z'
      
    ]
  };

  

  
  

  var faTemperatureHalf = {
    prefix: 'fat',
    iconName: 'temperature-half',
    icon: [
      320,
      512,
      [127777,"temperature-2","thermometer-2","thermometer-half"],
      'f2c9',
      
      'M160 16c-35.3 0-64 28.7-64 64V243.8c0 8.4-4.4 15.7-10.7 20.3C53 287.3 32 325.2 32 368c0 70.7 57.3 128 128 128s128-57.3 128-128c0-42.8-21-80.7-53.3-104c-6.3-4.6-10.7-11.9-10.7-20.3V80c0-35.3-28.7-64-64-64zM80 80c0-44.2 35.8-80 80-80s80 35.8 80 80V243.8c0 2.7 1.4 5.4 4 7.3c36.3 26.1 60 68.8 60 117c0 79.5-64.5 144-144 144S16 447.5 16 368c0-48.2 23.7-90.8 60-117c2.6-1.9 4-4.6 4-7.3V80zm80 336a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 16c-35.3 0-64-28.7-64-64c0-32.6 24.4-59.6 56-63.5V200c0-4.4 3.6-8 8-8s8 3.6 8 8V304.5c31.6 3.9 56 30.9 56 63.5c0 35.3-28.7 64-64 64z'
      
    ]
  };

  
    var faTemperature2 = faTemperatureHalf;
  
    var faThermometer2 = faTemperatureHalf;
  
    var faThermometerHalf = faTemperatureHalf;
  

  
  

  var faCommentImage = {
    prefix: 'fat',
    iconName: 'comment-image',
    icon: [
      512,
      512,
      [],
      'e148',
      
      'M157.3 415c-5-1.8-10.6-1-14.9 2.1c-11 8-29.4 19.3-51.2 28.8C68.3 456 41.6 464 16 464l.1-.1 0 0 0 0 .3-.3 .1-.1c.4-.4 .9-.9 1.5-1.6c1.3-1.4 3.2-3.6 5.4-6.3l-12.2-10 12.2 10C28 450 34 442 40 432c10.7-17.9 21.4-42.1 23.6-69.9c.3-4.3-1.1-8.6-3.9-11.8C31.9 318.8 16 280.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-35.2 0-68.6-6.1-98.7-17zM4.7 452.7l0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0zM200 160a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm-40-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm135.7 24c2.6 0 5 1.3 6.5 3.4L407.2 313.4c.5 .7 .8 1.5 .8 2.4c0 2.3-1.9 4.2-4.2 4.2h-296c-2.1 0-3.8-1.7-3.8-3.8c0-.9 .3-1.7 .8-2.4l56.5-70.6c1.6-2 4-3.1 6.5-3.1c2.6 0 5.1 1.2 6.7 3.3l19.1 25.5c1.5 2 3.8 3.2 6.3 3.2s4.8-1.1 6.4-3.1L289.5 163c1.5-1.9 3.8-3 6.2-3zm-18.8-6.9l-76.8 97.7-12.9-17.1c-4.6-6.1-11.8-9.7-19.5-9.7c-7.4 0-14.4 3.4-19 9.1L92.3 303.8c-2.8 3.5-4.3 7.9-4.3 12.4c0 11 8.9 19.8 19.8 19.8h296c11.1 0 20.2-9 20.2-20.2c0-4.1-1.3-8.2-3.6-11.6L315.3 154.2c-4.5-6.4-11.8-10.2-19.6-10.2c-7.3 0-14.3 3.4-18.8 9.1z'
      
    ]
  };

  

  
  

  var faEscalator = {
    prefix: 'fat',
    iconName: 'escalator',
    icon: [
      640,
      512,
      [],
      'e171',
      
      'M280 56a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm-96 0a56 56 0 1 1 112 0A56 56 0 1 1 184 56zM400.6 161.8c13.1-11.5 30-17.8 47.4-17.8H568c39.8 0 72 32.2 72 72s-32.2 72-72 72H475.1L239.4 494.2c-13.1 11.5-30 17.8-47.4 17.8H72c-39.8 0-72-32.2-72-72s32.2-72 72-72h92.9L400.6 161.8zM448 160c-13.6 0-26.7 4.9-36.9 13.9L173.2 382c-1.5 1.3-3.3 2-5.3 2H72c-30.9 0-56 25.1-56 56s25.1 56 56 56H192c13.6 0 26.7-4.9 36.9-13.9L466.8 274c1.5-1.3 3.3-2 5.3-2h96c30.9 0 56-25.1 56-56s-25.1-56-56-56H448zM312.8 190.8l-12.7 11.1c-9-24.5-32.5-41.9-60.1-41.9c-35.3 0-64 28.7-64 64v86.5l-16 14V224c0-44.2 35.8-80 80-80c32.3 0 60.2 19.2 72.8 46.8z'
      
    ]
  };

  

  
  

  var faCarWash = {
    prefix: 'fat',
    iconName: 'car-wash',
    icon: [
      448,
      512,
      [],
      'f5e6',
      
      'M87.1 104.2C82 109 74.1 112 64 112c-17.7 0-32-14.3-32-32c0-6.4 3.7-16.2 10.9-28C49.4 41.5 57.4 31.4 64 23.7C70.6 31.4 78.6 41.5 85.1 52C92.3 63.8 96 73.6 96 80c0 12.2-4 19.7-8.9 24.2zM64 128c26.5 0 48-16 48-48c0-22.2-23-52-37.2-68.2C69 5.1 59 5.1 53.2 11.8C39 28 16 57.8 16 80c0 26.5 21.5 48 48 48zM256 80c0 12.2-4 19.7-8.9 24.2c-5.1 4.7-13 7.8-23.1 7.8c-17.7 0-32-14.3-32-32c0-6.4 3.7-16.2 10.9-28c6.5-10.5 14.5-20.7 21.1-28.3c6.6 7.7 14.6 17.8 21.1 28.3C252.3 63.8 256 73.6 256 80zm16 0c0-22.2-23-52-37.2-68.2c-5.8-6.7-15.9-6.7-21.7 0C199 28 176 57.8 176 80c0 26.5 21.5 48 48 48s48-16 48-48zM156.2 192H291.8c17.9 0 33.6 11.8 38.5 29l19.5 68.2c-4.5-.8-9-1.2-13.7-1.2H112c-4.7 0-9.3 .4-13.7 1.2L117.7 221c4.9-17.2 20.6-29 38.5-29zM80.3 293.8l-.2 .8C51.8 307 32 335.2 32 368v64 16 32c0 17.7 14.3 32 32 32H80c17.7 0 32-14.3 32-32V448H336v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V448 432 368c0-32.8-19.8-61-48.1-73.4l-.2-.8-22.1-77.2c-6.9-24-28.8-40.6-53.8-40.6H156.2c-25 0-47 16.6-53.8 40.6L80.3 293.8zM352 432H336 112 96 48V368c0-35.3 28.7-64 64-64H336c35.3 0 64 28.7 64 64v64H352zm0 48V448h48v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zM96 448v32c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V448H96zm32-80a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm224 48a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM416 80c0 12.2-4 19.7-8.9 24.2c-5.1 4.7-13 7.8-23.1 7.8c-17.7 0-32-14.3-32-32c0-6.4 3.7-16.2 10.9-28c6.5-10.5 14.5-20.7 21.1-28.3c6.6 7.7 14.6 17.8 21.1 28.3C412.3 63.8 416 73.6 416 80zm16 0c0-22.2-23-52-37.2-68.2c-5.8-6.7-15.9-6.7-21.7 0C359 28 336 57.8 336 80c0 26.5 21.5 48 48 48s48-16 48-48z'
      
    ]
  };

  

  
  

  var faNotesMedical = {
    prefix: 'fat',
    iconName: 'notes-medical',
    icon: [
      512,
      512,
      [],
      'f481',
      
      'M112 96c0-26.5 21.5-48 48-48H416c26.5 0 48 21.5 48 48V293.5c0 12.7-5.1 24.9-14.1 33.9l-58.5 58.5c-9 9-21.2 14.1-33.9 14.1H160c-26.5 0-48-21.5-48-48V96zM96 96V352c0 35.3 28.7 64 64 64H357.5c17 0 33.3-6.7 45.3-18.7l58.5-58.5c12-12 18.7-28.3 18.7-45.3V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zm176 32h32c4.4 0 8 3.6 8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H320c-4.4 0-8 3.6-8 8v56c0 4.4-3.6 8-8 8H272c-4.4 0-8-3.6-8-8V256c0-4.4-3.6-8-8-8H200c-4.4 0-8-3.6-8-8V208c0-4.4 3.6-8 8-8h56c4.4 0 8-3.6 8-8V136c0-4.4 3.6-8 8-8zm-24 8v48H200c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h48v48c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V264h48c13.3 0 24-10.7 24-24V208c0-13.3-10.7-24-24-24H328V136c0-13.3-10.7-24-24-24H272c-13.3 0-24 10.7-24 24zM0 192V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64H368c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V192c0-26.5 21.5-48 48-48V128c-35.3 0-64 28.7-64 64z'
      
    ]
  };

  

  
  

  var faSlotMachine = {
    prefix: 'fat',
    iconName: 'slot-machine',
    icon: [
      640,
      512,
      [],
      'e3ce',
      
      'M432 416v32c0 26.5-21.5 48-48 48H128c-26.5 0-48-21.5-48-48V416H432zm-5.7 80c13.3-11.7 21.7-28.9 21.7-48V416c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64V64c0-35.3-28.7-64-64-64H128C92.7 0 64 28.7 64 64V96C28.7 96 0 124.7 0 160V352c0 35.3 28.7 64 64 64v32c0 35.3 28.7 64 64 64H384 528c39.8 0 72-32.2 72-72V223.3c22.7-3.8 40-23.6 40-47.3c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 23.8 17.3 43.5 40 47.3V440c0 30.9-25.1 56-56 56H426.3zM560 176a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM432 64V96H80V64c0-26.5 21.5-48 48-48l256 0c26.5 0 48 21.5 48 48zm16 48c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V160c0-26.5 21.5-48 48-48H448zM96 176c-4.4 0-8 3.6-8 8s3.6 8 8 8h60.3L104.5 325.1c-1.6 4.1 .4 8.8 4.6 10.4s8.8-.4 10.4-4.6l56-144c1-2.5 .6-5.2-.9-7.4s-4-3.5-6.6-3.5H96zm128 0c-4.4 0-8 3.6-8 8s3.6 8 8 8h60.3L232.5 325.1c-1.6 4.1 .4 8.8 4.6 10.4s8.8-.4 10.4-4.6l56-144c1-2.5 .6-5.2-.9-7.4s-4-3.5-6.6-3.5H224zm128 0c-4.4 0-8 3.6-8 8s3.6 8 8 8h60.3L360.5 325.1c-1.6 4.1 .4 8.8 4.6 10.4s8.8-.4 10.4-4.6l56-144c1-2.5 .6-5.2-.9-7.4s-4-3.5-6.6-3.5H352z'
      
    ]
  };

  

  
  

  var faWineGlassCrack = {
    prefix: 'fat',
    iconName: 'wine-glass-crack',
    icon: [
      320,
      512,
      ["fragile"],
      'f4bb',
      
      'M60.1 29.8C61.2 21.9 67.9 16 75.9 16h75.5l1.2 3 29.3 73.2-57.4 28.7c-2.3 1.2-3.9 3.3-4.3 5.9s.4 5.1 2.2 6.9l64 64c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-56.2-56.2 54.1-27c3.7-1.9 5.4-6.3 3.8-10.1L168.6 16h75.5c8 0 14.8 5.9 15.9 13.8l22.6 165.8C292.7 269.9 234.9 336 160 336S27.3 269.9 37.5 195.6L60.1 29.8zM44.2 27.7L21.6 193.5C10.5 274.7 71.3 347.3 152 351.8V496H72c-4.4 0-8 3.6-8 8s3.6 8 8 8h88 88c4.4 0 8-3.6 8-8s-3.6-8-8-8H168V351.8c80.7-4.5 141.5-77.1 130.4-158.3L275.8 27.7C273.6 11.8 260.1 0 244.1 0H75.9c-16 0-29.5 11.8-31.7 27.7z'
      
    ]
  };

  
    var faFragile = faWineGlassCrack;
  

  
  

  var faG = {
    prefix: 'fat',
    iconName: 'g',
    icon: [
      448,
      512,
      [103],
      '47',
      
      'M224 48C109.1 48 16 141.1 16 256s93.1 208 208 208c109.7 0 199.6-84.9 207.4-192.6c.3-3.8-2.9-7.4-7.4-7.4H232c-4.4 0-8-3.6-8-8s3.6-8 8-8H424c13.1 0 24.4 10.8 23.4 24.6C438.9 388.6 342.1 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32c57.4 0 109.7 21.6 149.3 57c3.3 2.9 3.6 8 .6 11.3s-8 3.6-11.3 .6C325.9 68 277.3 48 224 48z'
      
    ]
  };

  

  
  

  var faWhistle = {
    prefix: 'fat',
    iconName: 'whistle',
    icon: [
      640,
      512,
      [],
      'f460',
      
      'M105.9 104.6C82.4 123 63.2 146.7 50.3 174C30.5 168.1 16 149.8 16 128c0-26.5 21.5-48 48-48c18 0 33.7 9.9 41.9 24.6zM0 128c0 28.4 18.5 52.5 44.1 60.8C36.3 209.7 32 232.4 32 256c0 106 86 192 192 192c64.7 0 121.9-32 156.7-81L529 444.4c4.6 2.4 9.6 3.6 14.8 3.6h2c9 0 17.6-3.8 23.7-10.5l63.3-69.6c4.6-5.1 7.2-11.7 7.2-18.5c0-8.4-3.9-16.4-10.5-21.6l-127-100.4c-5.2-4.1-12.4-4.6-18.2-1.2l-19.3 11.6c-10.3 6.2-23.4 5.5-33-1.7c-9.7-7.3-14-19.8-10.8-31.5l6.5-24c1.7-6.2-.5-12.8-5.5-16.8l-69.8-55.2C322.4 84.8 286.4 70 248.6 65.5c-.6-.1-1.1-.1-1.7-.1c-7.5-.9-15.2-1.4-22.9-1.4c-38.8 0-74.8 11.5-105 31.2C107.8 76.5 87.4 64 64 64C28.7 64 0 92.7 0 128zM367.7 357.7C335.7 402.7 283.3 432 224 432c-97.2 0-176-78.8-176-176s78.8-176 176-176c7.1 0 14.1 .4 21 1.2c.6 .1 1.1 .1 1.7 .1c34.9 4.2 68.1 17.9 95.9 39.9l69.8 55.2-6.5 24c-4.9 18 1.7 37.2 16.6 48.5c14.8 11.1 34.9 12.2 50.8 2.6l19.3-11.6 127 100.4c2.8 2.2 4.4 5.5 4.4 9.1c0 2.9-1.1 5.7-3 7.8l-63.3 69.6c-3 3.3-7.3 5.2-11.8 5.2h-2c-2.6 0-5.1-.6-7.4-1.8L388.1 352.8c-7.1-3.7-15.8-1.6-20.4 4.9zM176 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z'
      
    ]
  };

  

  
  

  var faLinkSimple = {
    prefix: 'fat',
    iconName: 'link-simple',
    icon: [
      576,
      512,
      [],
      'e1cd',
      
      'M0 256C0 167.6 71.6 96 160 96h88c4.4 0 8 3.6 8 8s-3.6 8-8 8H160C80.5 112 16 176.5 16 256s64.5 144 144 144h88c4.4 0 8 3.6 8 8s-3.6 8-8 8H160C71.6 416 0 344.4 0 256zm576 0c0 88.4-71.6 160-160 160H328c-4.4 0-8-3.6-8-8s3.6-8 8-8h88c79.5 0 144-64.5 144-144s-64.5-144-144-144H328c-4.4 0-8-3.6-8-8s3.6-8 8-8h88c88.4 0 160 71.6 160 160zm-440-8H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H136c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faMonitorWaveform = {
    prefix: 'fat',
    iconName: 'monitor-waveform',
    icon: [
      576,
      512,
      ["monitor-heart-rate"],
      'f611',
      
      'M512 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM279.6 160c-3.2 .2-5.9 2.2-7.1 5.1L214 318.7l-39.4-59.1c-1.5-2.2-4-3.6-6.7-3.6H80V128c0-8.8 7.2-16 16-16H480c8.8 0 16 7.2 16 16V384c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V272h83.7l45.6 68.4c1.7 2.5 4.6 3.8 7.6 3.5s5.5-2.3 6.6-5.1l57.5-151 39.9 79.7c1.4 2.7 4.1 4.4 7.2 4.4h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H332.9l-45.8-91.6c-1.4-2.8-4.4-4.6-7.6-4.4zM64 128V384c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32z'
      
    ]
  };

  
    var faMonitorHeartRate = faMonitorWaveform;
  

  
  

  var faQ = {
    prefix: 'fat',
    iconName: 'q',
    icon: [
      448,
      512,
      [113],
      '51',
      
      'M16 256c0 114.9 93.1 208 208 208c49.5 0 95-17.3 130.7-46.2L226 269.2c-2.9-3.3-2.5-8.4 .8-11.3s8.4-2.5 11.3 .8L366.8 407.3C406.9 369.4 432 315.6 432 256c0-114.9-93.1-208-208-208S16 141.1 16 256zM365.2 429.9C326.7 461.2 277.5 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32s224 100.3 224 224c0 64.4-27.2 122.5-70.8 163.4L446 498.8c2.9 3.3 2.5 8.4-.8 11.3s-8.4 2.5-11.3-.8l-68.8-79.3z'
      
    ]
  };

  

  
  

  var faHorse = {
    prefix: 'fat',
    iconName: 'horse',
    icon: [
      576,
      512,
      [128014],
      'f6f0',
      
      'M328 136c0 4.4-3.6 8-8 8H224 191.8 138.7C101.8 144 72 173.8 72 210.7c0 8.8 1.7 17.5 5.1 25.6L109 312.8c2 4.7 3 9.8 3 15c0 5.3-1.1 10.5-3.2 15.3l-6.5 15.3c-10.8 25.1-12.6 53.1-5.3 79.4l12.9 46.5c1.9 6.9 8.2 11.7 15.4 11.7h49.8c10.6 0 18.2-10.1 15.4-20.3l-16.5-59.3c-2.4-8.8-1.8-18.1 1.8-26.5l6.5-15.3c6.3-14.8 9.6-30.7 9.6-46.9c0-9.2-1.1-18.4-3.2-27.4c-.6-2.7 .2-5.5 2.1-7.5s4.7-2.8 7.4-2.2l123.4 27.1c3.7 .8 6.3 4.1 6.3 7.8V480c0 8.8 7.2 16 16 16h40c8.8 0 16-7.2 16-16V308.5c0-2.4 1-4.6 2.8-6.1c17.6-14.9 29-37.1 29.2-62.5l0-.1v-.4V152c0-4.4 3.6-8 8-8h16c3 0 5.8 1.7 7.2 4.4l8.3 16.5c11.1 22.3 38.2 31.3 60.5 20.2c16.7-8.3 26.5-26 24.7-44.6l-7-73.8C546.8 37.9 522.7 16 493.8 16H472 456h-8c-66.3 0-120 53.7-120 120zM539.1 16c14.6 11.8 24.5 29.2 26.4 49.2l7 73.8c2.4 25.1-10.9 49.1-33.5 60.4c-30.2 15.1-66.8 2.9-81.9-27.3L451.1 160H448v79.5 .5l0 .2c-.2 28.8-12.7 54.2-32 71.9V480c0 17.7-14.3 32-32 32H344c-17.7 0-32-14.3-32-32V332.1L206.7 309c.9 6.2 1.3 12.5 1.3 18.8c0 18.3-3.7 36.4-10.9 53.2l-6.5 15.3c-2.2 5-2.5 10.6-1.1 15.9L206 471.4c5.7 20.4-9.7 40.6-30.8 40.6H125.3c-14.4 0-27-9.6-30.8-23.4L81.6 442.1c-8.3-29.8-6.2-61.5 6-90l6.5-15.3c1.2-2.9 1.9-5.9 1.9-9c0-3-.6-6-1.8-8.8L62.4 242.5c-4.2-10.1-6.4-20.9-6.4-31.8c0-12.4 2.7-24.1 7.6-34.7C37.3 176.2 16 197.6 16 224v88c0 4.4-3.6 8-8 8s-8-3.6-8-8V224c0-35.3 28.7-64 64-64h8 1.3c15.1-19.5 38.8-32 65.3-32h53.1H224h88.2C316.4 56.6 375.6 0 448 0h8 16 21.8H552c4.4 0 8 3.6 8 8s-3.6 8-8 8H539.1zM480 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faDialMed = {
    prefix: 'fat',
    iconName: 'dial-med',
    icon: [
      576,
      512,
      [],
      'e15f',
      
      'M272 32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM296 288V144.2c75.8 4.2 136 66.9 136 143.8c0 79.5-64.5 144-144 144s-144-64.5-144-144c0-76.8 60.2-139.6 136-143.8V288c0 4.4 3.6 8 8 8s8-3.6 8-8zm-8-160a160 160 0 1 0 0 320 160 160 0 1 0 0-320zM544 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM16 288a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0A32 32 0 1 0 0 288a32 32 0 1 0 64 0zM96 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM464 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 464a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm368-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faAngleRight = {
    prefix: 'fat',
    iconName: 'angle-right',
    icon: [
      320,
      512,
      [8250],
      'f105',
      
      'M269.7 250.3c3.1 3.1 3.1 8.2 0 11.3l-176 176c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L252.7 256 82.3 85.7c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l176 176z'
      
    ]
  };

  

  
  

  var faBellOn = {
    prefix: 'fat',
    iconName: 'bell-on',
    icon: [
      640,
      512,
      [128365],
      'f8fa',
      
      'M312 8c0-4.4 3.6-8 8-8s8 3.6 8 8V32l0 .2c84.6 4.2 152 74.1 152 159.8v36.6c0 41.8 14.2 82.3 40.3 114.9l16.7 20.9c4.5 5.6 6.9 12.6 6.9 19.8c0 17.5-14.2 31.7-31.7 31.7H127.7C110.2 416 96 401.8 96 384.3c0-7.2 2.4-14.2 6.9-19.8l16.7-20.9C145.8 311 160 270.4 160 228.6V192c0-85.7 67.4-155.6 152-159.8l0-.2V8zm8 40c-79.5 0-144 64.5-144 144v36.6c0 45.4-15.5 89.5-43.8 124.9l-16.7 20.9c-2.2 2.8-3.4 6.2-3.4 9.8c0 8.7 7 15.7 15.7 15.7H512.3c8.7 0 15.7-7 15.7-15.7c0-3.6-1.2-7-3.4-9.8l-16.7-20.9C479.5 318.1 464 274.1 464 228.6V192c0-79.5-64.5-144-144-144zM272 448c0 12.7 5.1 24.9 14.1 33.9s21.2 14.1 33.9 14.1s24.9-5.1 33.9-14.1s14.1-21.2 14.1-33.9c0-4.4 3.6-8 8-8s8 3.6 8 8c0 17-6.7 33.3-18.7 45.3s-28.3 18.7-45.3 18.7s-33.3-6.7-45.3-18.7s-18.7-28.3-18.7-45.3c0-4.4 3.6-8 8-8s8 3.6 8 8zM0 184c0-4.4 3.6-8 8-8h96c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8zm536-8h96c4.4 0 8 3.6 8 8s-3.6 8-8 8H536c-4.4 0-8-3.6-8-8s3.6-8 8-8zM607.2 36.4c2 4 .4 8.8-3.6 10.7l-80 40c-4 2-8.8 .4-10.7-3.6s-.4-8.8 3.6-10.7l80-40c4-2 8.8-.4 10.7 3.6zM36.4 47.2c-4-2-5.6-6.8-3.6-10.7s6.8-5.6 10.7-3.6l80 40c4 2 5.6 6.8 3.6 10.7s-6.8 5.6-10.7 3.6l-80-40z'
      
    ]
  };

  

  
  

  var faFilters = {
    prefix: 'fat',
    iconName: 'filters',
    icon: [
      640,
      512,
      [],
      'e17e',
      
      'M223.3 32C206 32 192 46 192 63.3c0 7.5 2.7 14.8 7.7 20.5L352 259V367.9c0 7.7 3.7 14.9 9.9 19.4L438.5 443c4.5 3.2 9.8 5 15.4 5c14.4 0 26.1-11.7 26.1-26.1V259L632.3 83.8c5-5.7 7.7-13 7.7-20.5C640 46 626 32 608.7 32H223.3zM208 63.3c0-8.4 6.8-15.3 15.3-15.3H608.7c8.4 0 15.3 6.8 15.3 15.3c0 3.7-1.3 7.3-3.8 10L466 250.8c-1.3 1.5-2 3.3-2 5.2V421.9c0 5.6-4.5 10.1-10.1 10.1c-2.1 0-4.2-.7-5.9-1.9l-76.6-55.7c-2.1-1.5-3.3-3.9-3.3-6.5V256c0-1.9-.7-3.8-2-5.2L211.8 73.3c-2.4-2.8-3.8-6.3-3.8-10zM31.3 96C14 96 0 110 0 127.3c0 7.5 2.7 14.8 7.7 20.5L160 323v76.9c0 7.7 3.7 14.9 9.9 19.4L246.5 475c4.5 3.2 9.8 5 15.4 5c14.4 0 26.1-11.7 26.1-26.1V323l32-36.6V271l-3.8-4.4L274 314.7c-1.3 1.5-2 3.3-2 5.3V453.9c0 5.6-4.5 10.1-10.1 10.1c-2.1 0-4.2-.7-5.9-1.9l-76.6-55.7c-2.1-1.5-3.3-3.9-3.3-6.5V320c0-1.9-.7-3.8-2-5.2L19.8 137.3c-2.4-2.8-3.8-6.3-3.8-10c0-8.4 6.8-15.3 15.3-15.3H181.8l-6.2-7.2c-2.4-2.8-4.6-5.7-6.4-8.8H31.3z'
      
    ]
  };

  

  
  

  var faMugMarshmallows = {
    prefix: 'fat',
    iconName: 'mug-marshmallows',
    icon: [
      512,
      512,
      [],
      'f7b7',
      
      'M203.5 40.6L191.9 52.2C187.2 49.5 181.8 48 176 48H80C62.3 48 48 62.3 48 80v48H32V80c0-26.5 21.5-48 48-48h96c10.2 0 19.7 3.2 27.5 8.6zM360 128H344c0-.3 0-.6 0-.9v-6.3c0-6.4-2.5-12.5-7-17L287.5 54.4c-4.1-4.1-9.7-6.4-15.5-6.4s-11.4 2.3-15.5 6.4L207 103.9c-4.5 4.5-7 10.6-7 17v5.2c0 .6 0 1.3 .1 1.9H184c0-.6 0-1.3 0-1.9v-5.2c0-10.6 4.2-20.8 11.7-28.3l49.5-49.5C252.3 36 261.9 32 272 32s19.7 4 26.8 11.1l49.5 49.5c7.5 7.5 11.7 17.7 11.7 28.3v6.3l0 .9zM176 176v72c0 4.4-3.6 8-8 8s-8-3.6-8-8V176H112V280c0 4.4-3.6 8-8 8s-8-3.6-8-8V176H32c-8.8 0-16 7.2-16 16V384c0 44.2 35.8 80 80 80H288c44.2 0 80-35.8 80-80V176H344 176zm208 0V352h24c48.6 0 88-39.4 88-88s-39.4-88-88-88H384zm0 192v16c0 53-43 96-96 96H96c-53 0-96-43-96-96V192c0-17.7 14.3-32 32-32H344h24 16 24c57.4 0 104 46.6 104 104s-46.6 104-104 104H384z'
      
    ]
  };

  

  
  

  var faHorseSaddle = {
    prefix: 'fat',
    iconName: 'horse-saddle',
    icon: [
      576,
      512,
      [],
      'f8c3',
      
      'M328 136c0-66.3 53.7-120 120-120h8 16 21.8c28.9 0 53 21.9 55.7 50.7l7 73.8c1.8 18.5-8.1 36.2-24.7 44.6c-22.3 11.1-49.3 2.1-60.5-20.2l-8.3-16.5c-1.4-2.7-4.1-4.4-7.2-4.4H440c-4.4 0-8 3.6-8 8v87.5 .4l0 .1c-.2 25.4-11.6 47.6-29.2 62.5c-1.8 1.5-2.8 3.8-2.8 6.1V480c0 8.8-7.2 16-16 16H344c-8.8 0-16-7.2-16-16V325.7c0-3.8-2.6-7-6.3-7.8L248 301.7v-54c44.9-4 80-41.7 80-87.6V136zm-88 96c-39.8 0-72-32.2-72-72V144h23.8H224h88v16c0 39.8-32.2 72-72 72zm-8 15.6v50.5l-33.7-7.4c-2.7-.6-5.5 .2-7.4 2.2s-2.7 4.8-2.1 7.5c2.1 9 3.2 18.1 3.2 27.4c0 16.1-3.3 32.1-9.6 46.9l-6.5 15.3c-3.6 8.4-4.2 17.7-1.8 26.5l16.5 59.3c2.8 10.2-4.8 20.3-15.4 20.3H125.3c-7.2 0-13.5-4.8-15.4-11.7L97 437.8c-7.3-26.3-5.4-54.3 5.3-79.4l6.5-15.3c2.1-4.8 3.2-10.1 3.2-15.3c0-5.1-1-10.2-3-15L77.1 236.3c-3.4-8.1-5.1-16.8-5.1-25.6c0-36.8 29.8-66.7 66.7-66.7H152v16c0 45.9 35.1 83.6 80 87.6zM191.8 128H160 138.7c-26.6 0-50.2 12.5-65.3 32H72 64c-35.3 0-64 28.7-64 64v88c0 4.4 3.6 8 8 8s8-3.6 8-8V224c0-26.4 21.3-47.8 47.6-48c-4.9 10.5-7.6 22.3-7.6 34.7c0 10.9 2.2 21.7 6.4 31.8L94.2 319c1.2 2.8 1.8 5.8 1.8 8.8c0 3.1-.6 6.2-1.9 9l-6.5 15.3c-12.2 28.4-14.3 60.2-6 90l12.9 46.5c3.8 13.9 16.5 23.4 30.8 23.4h49.8c21.2 0 36.5-20.2 30.8-40.6l-16.5-59.3c-1.5-5.3-1.1-10.9 1.1-15.9l6.5-15.3c7.2-16.8 10.9-34.9 10.9-53.2c0-6.3-.4-12.6-1.3-18.8L312 332.1V480c0 17.7 14.3 32 32 32h40c17.7 0 32-14.3 32-32V312.1c19.3-17.7 31.8-43.1 32-71.9l0-.2v-.5V160h3.1l6.1 12.1c15.1 30.2 51.8 42.4 81.9 27.3c22.6-11.3 35.9-35.3 33.5-60.4l-7-73.8c-1.9-20-11.8-37.4-26.4-49.2H552c4.4 0 8-3.6 8-8s-3.6-8-8-8H493.8 472 456h-8C375.6 0 316.4 56.6 312.2 128H224 191.8zM512 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faJoint = {
    prefix: 'fat',
    iconName: 'joint',
    icon: [
      640,
      512,
      [],
      'f595',
      
      'M448 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V43c0 48.8 19.4 95.6 53.9 130.1l21 21C520.4 207.6 528 225.9 528 245v35c0 4.4 3.6 8 8 8s8-3.6 8-8V245c0-23.3-9.3-45.7-25.8-62.2l-21-21C465.7 130.3 448 87.5 448 43V8zM624 280c0 4.4 3.6 8 8 8s8-3.6 8-8V245c0-48.8-19.4-95.6-53.9-130.1l-21-21C551.6 80.4 544 62.1 544 43V8c0-4.4-3.6-8-8-8s-8 3.6-8 8V43c0 23.3 9.3 45.7 25.8 62.2l21 21C606.3 157.7 624 200.5 624 245v35zM266 368H406l3.6 4.8L502 496H362l-3.6-4.8L266 368zm160 0H592c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H522l-3.6-4.8L426 368zM342 496H258.6c-63.1 0-125.6-12-184.2-35.5L20.8 439.1c-2.9-1.2-4.8-4-4.8-7.1s1.9-5.9 4.8-7.1l53.6-21.4c54.7-21.9 112.9-33.8 171.7-35.3l3.5 4.6L342 496zM592 352H258.6c-65.1 0-129.7 12.4-190.2 36.6L14.9 410.1C5.9 413.6 0 422.3 0 432s5.9 18.4 14.9 21.9l53.6 21.4c60.5 24.2 125 36.6 190.2 36.6H592c26.5 0 48-21.5 48-48V400c0-26.5-21.5-48-48-48z'
      
    ]
  };

  

  
  

  var faBracketRound = {
    prefix: 'fat',
    iconName: 'bracket-round',
    icon: [
      192,
      512,
      ["parenthesis"],
      '28',
      
      'M159.2 36.4c2 4 .4 8.8-3.6 10.7c-23.1 11.5-58.2 36.1-87.4 71.7C39 154.5 16 200.7 16 256s23 101.5 52.2 137.1c29.2 35.7 64.3 60.2 87.4 71.7c4 2 5.6 6.8 3.6 10.7s-6.8 5.6-10.7 3.6c-24.9-12.5-61.8-38.3-92.6-75.9C25 365.7 0 315.9 0 256s25-109.7 55.8-147.3c30.8-37.5 67.7-63.4 92.6-75.9c4-2 8.8-.4 10.7 3.6z'
      
    ]
  };

  
    var faParenthesis = faBracketRound;
  

  
  

  var faIgloo = {
    prefix: 'fat',
    iconName: 'igloo',
    icon: [
      576,
      512,
      [],
      'f7ae',
      
      'M560 320v16H464V192h64.1c20.4 38.1 31.9 81.7 31.9 128zM448 336H378.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H128V192H320h16H448V336zm-65.3 16H448h16 96v64c0 26.5-21.5 48-48 48H384V368c0-5.5-.5-10.8-1.3-16zM128 352h65.3c-.9 5.2-1.3 10.5-1.3 16v96H64c-26.5 0-48-21.5-48-48V352h96 16zm-16-16H16V320c0-46.3 11.6-89.9 32-128.1v.1h64V336zM518.8 176H336V52.2C413 65.9 478.8 112.1 518.8 176zM288 48c10.8 0 21.5 .6 32 1.9V176H57.2C105.3 99.1 190.7 48 288 48zM64 480H192 384 512c35.3 0 64-28.7 64-64V320C576 160.9 447.1 32 288 32S0 160.9 0 320v96c0 35.3 28.7 64 64 64zM288 288c44.2 0 80 35.8 80 80v96H208V368c0-44.2 35.8-80 80-80z'
      
    ]
  };

  

  
  

  var faSchool = {
    prefix: 'fat',
    iconName: 'school',
    icon: [
      640,
      512,
      [127979],
      'f549',
      
      'M324.6 1.4c-2.8-1.9-6.4-1.9-9.2 0L157.5 112H56c-30.9 0-56 25.1-56 56V456c0 30.9 25.1 56 56 56H256h16 96 16H584c30.9 0 56-25.1 56-56V168c0-30.9-25.1-56-56-56H482.5L324.6 1.4zM384 496V384c0-35.3-28.7-64-64-64s-64 28.7-64 64V496H56c-22.1 0-40-17.9-40-40V168c0-22.1 17.9-40 40-40H160c1.6 0 3.2-.5 4.6-1.4L320 17.8 475.4 126.6c1.3 .9 2.9 1.4 4.6 1.4H584c22.1 0 40 17.9 40 40V456c0 22.1-17.9 40-40 40H384zm-16 0H272V384c0-26.5 21.5-48 48-48s48 21.5 48 48V496zM64 216v48c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V216c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm24-8h32c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H88c-4.4 0-8-3.6-8-8V216c0-4.4 3.6-8 8-8zm432-16c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V216c0-13.3-10.7-24-24-24H520zm-8 24c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H520c-4.4 0-8-3.6-8-8V216zM320 112a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 144a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm8-112c0-4.4-3.6-8-8-8s-8 3.6-8 8v32c0 4.4 3.6 8 8 8h24c4.4 0 8-3.6 8-8s-3.6-8-8-8H328V144zM64 344v48c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V344c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm24-8h32c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H88c-4.4 0-8-3.6-8-8V344c0-4.4 3.6-8 8-8zm432-16c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V344c0-13.3-10.7-24-24-24H520zm-8 24c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H520c-4.4 0-8-3.6-8-8V344z'
      
    ]
  };

  

  
  

  var faBriefcaseBlank = {
    prefix: 'fat',
    iconName: 'briefcase-blank',
    icon: [
      512,
      512,
      [],
      'e0c8',
      
      'M144 40V96H368V40c0-13.3-10.7-24-24-24H168c-13.3 0-24 10.7-24 24zM128 96V40c0-22.1 17.9-40 40-40H344c22.1 0 40 17.9 40 40V96h64c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64zm248 16H136 64c-26.5 0-48 21.5-48 48V416c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V160c0-26.5-21.5-48-48-48H376z'
      
    ]
  };

  

  
  

  var faChartCandlestick = {
    prefix: 'fat',
    iconName: 'chart-candlestick',
    icon: [
      512,
      512,
      [],
      'e0e2',
      
      'M8 32c4.4 0 8 3.6 8 8V408c0 30.9 25.1 56 56 56H504c4.4 0 8 3.6 8 8s-3.6 8-8 8H72c-39.8 0-72-32.2-72-72V40c0-4.4 3.6-8 8-8zm280 80c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h16 16c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H304 288zm8 200V256h-8c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32h8V40c0-4.4 3.6-8 8-8s8 3.6 8 8V96h8c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32h-8v56c0 4.4-3.6 8-8 8s-8-3.6-8-8zm104-88v64c0 8.8 7.2 16 16 16h16 16c8.8 0 16-7.2 16-16V224c0-8.8-7.2-16-16-16H432 416c-8.8 0-16 7.2-16 16zm24 96h-8c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32h8V136c0-4.4 3.6-8 8-8s8 3.6 8 8v56h8c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-8v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V320zM208 160c0-8.8-7.2-16-16-16H176 160c-8.8 0-16 7.2-16 16V288c0 8.8 7.2 16 16 16h16 16c8.8 0 16-7.2 16-16V160zM184 320v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V320h-8c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h8V72c0-4.4 3.6-8 8-8s8 3.6 8 8v56h8c17.7 0 32 14.3 32 32V288c0 17.7-14.3 32-32 32h-8z'
      
    ]
  };

  

  
  

  var faRoadBarrier = {
    prefix: 'fat',
    iconName: 'road-barrier',
    icon: [
      640,
      512,
      [],
      'e562',
      
      'M8 32c4.4 0 8 3.6 8 8V80H624V40c0-4.4 3.6-8 8-8s8 3.6 8 8V80 96 288v16V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V304H16V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V304 288 96 80 40c0-4.4 3.6-8 8-8zM624 288V96h-7.1l-1.8 3.6L520.9 288H624zM16 288h7.1l1.8-3.6L119.1 96H16V288zM599.1 96H456.9l-1.8 3.6L360.9 288H503.1l1.8-3.6L599.1 96zM136.9 96l-1.8 3.6L40.9 288H183.1l1.8-3.6L279.1 96H136.9zm158.2 3.6L200.9 288H343.1l1.8-3.6L439.1 96H296.9l-1.8 3.6z'
      
    ]
  };

  

  
  

  var faMortarPestle = {
    prefix: 'fat',
    iconName: 'mortar-pestle',
    icon: [
      512,
      512,
      [],
      'f5a7',
      
      'M464 208v48c0 76-39.4 134.9-113.2 161.2c-4.9 1.7-8.6 5.7-10 10.7s-.3 10.3 2.9 14.4c9.7 12.2 17 26.5 20.9 42.1c.7 2.8 0 5.3-2 7.4c-2.2 2.4-6 4.3-10.5 4.3H160c-4.5 0-8.3-1.9-10.5-4.3c-2-2.2-2.7-4.6-2-7.4c4-15.6 11.2-29.8 20.9-42.1c3.2-4 4.3-9.4 2.9-14.4s-5.2-9-10-10.7C87.4 390.9 48 332 48 256V208H464zM371.6 426.1C442.1 395 480 333.1 480 256V224 208h16 8c4.4 0 8-3.6 8-8s-3.6-8-8-8H480 32 8c-4.4 0-8 3.6-8 8s3.6 8 8 8h8H32v16 32c0 77.1 37.9 139 108.4 170.1c5 2.2 10.1 4.2 15.5 6.1c-3.4 4.3-6.6 8.8-9.5 13.6c-6.4 10.6-11.3 22.2-14.5 34.5C127.6 497.4 142.3 512 160 512H352c17.7 0 32.4-14.6 28.1-31.7c-3.1-12.3-8.1-23.9-14.5-34.5c-2.9-4.7-6-9.3-9.5-13.6c5.3-1.9 10.5-3.9 15.5-6.1z'
      
    ]
  };

  

  
  

  var faShieldCheck = {
    prefix: 'fat',
    iconName: 'shield-check',
    icon: [
      512,
      512,
      [],
      'f2f7',
      
      'M237.3 22.6c12-5.1 25.5-5.1 37.5 0l176.7 75c16.6 7.1 28.6 23.2 28.5 42.4c-.5 96.6-40.3 270.2-204.5 348.8c-12.3 5.9-26.7 5.9-39 0C72.3 410.1 32.5 236.5 32 139.9c-.1-19.1 11.9-35.3 28.5-42.4l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zm76.6 189.8c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L224 308.7l-58.3-58.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l64 64c3.1 3.1 8.2 3.1 11.3 0l128-128z'
      
    ]
  };

  

  
  

  var faUserAlien = {
    prefix: 'fat',
    iconName: 'user-alien',
    icon: [
      448,
      512,
      [],
      'e04a',
      
      'M80 167C80 83 145.1 16 224 16s144 67 144 151c0 45-23.9 87.6-53.6 123c-29.5 35.1-63.1 61-78.9 72.3c-3.1 2.2-7.1 3.5-11.5 3.5s-8.4-1.3-11.5-3.5c-15.8-11.3-49.4-37.2-78.9-72.3C103.9 254.6 80 212 80 167zM224 0C135.6 0 64 74.8 64 167c0 101 106.6 185 139.2 208.3c6.1 4.3 13.4 6.5 20.8 6.5s14.7-2.1 20.8-6.5C277.4 352 384 268.1 384 167C384 74.8 312.4 0 224 0zM0 486.4C0 500.5 11.5 512 25.6 512H422.4c14.1 0 25.6-11.5 25.6-25.6c0-71.4-55.7-129.8-126.1-134.1c-5.8 5.6-11.4 10.9-16.9 15.7h8.6C379 368 432 421 432 486.4c0 5.3-4.3 9.6-9.6 9.6H25.6c-5.3 0-9.6-4.3-9.6-9.6C16 421 69 368 134.4 368H143c-5.5-4.9-11.1-10.1-16.9-15.7C55.7 356.6 0 415 0 486.4zM208 238.9c0-34.7-28.1-62.9-62.9-62.9h-16c-9.5 0-17.1 7.7-17.1 17.1c0 34.7 28.1 62.9 62.9 62.9h16c9.5 0 17.1-7.7 17.1-17.1zM145.1 192c25.9 0 46.9 21 46.9 46.9c0 .6-.5 1.1-1.1 1.1h-16C149 240 128 219 128 193.1c0-.6 .5-1.1 1.1-1.1h16zm157.7-16c-34.7 0-62.9 28.1-62.9 62.9c0 9.5 7.7 17.1 17.1 17.1h16c34.7 0 62.9-28.1 62.9-62.9c0-9.5-7.7-17.1-17.1-17.1h-16zM256 238.9c0-25.9 21-46.9 46.9-46.9h16c.6 0 1.1 .5 1.1 1.1c0 25.9-21 46.9-46.9 46.9h-16c-.6 0-1.1-.5-1.1-1.1z'
      
    ]
  };

  

  
  

  var faSnowman = {
    prefix: 'fat',
    iconName: 'snowman',
    icon: [
      512,
      512,
      [9731,9924],
      'f7d0',
      
      'M256 0C198.6 0 152 46.6 152 104c0 18.1 4.6 35.2 12.8 50c-10.8 12.6-19 27.4-23.8 43.7L79.9 169c0-.3 .1-.7 .1-1V104c0-4.4-3.6-8-8-8s-8 3.6-8 8v57.5L11.4 136.8c-4-1.9-8.8-.2-10.6 3.8s-.2 8.8 3.8 10.6l132.8 62.5c-.9 6-1.4 12.1-1.4 18.3c0 18.9 4.4 36.9 12.2 52.8C120.9 312.3 104 350.2 104 392c0 39.1 14.8 74.9 39.1 101.8c11.8 13 28.8 18.2 45 18.2H323.9c16.2 0 33.3-5.2 45-18.2C393.2 466.9 408 431.1 408 392c0-41.8-16.9-79.7-44.2-107.2c7.8-15.9 12.2-33.9 12.2-52.8c0-6.2-.5-12.3-1.4-18.3l132.8-62.5c4-1.9 5.7-6.6 3.8-10.6s-6.6-5.7-10.6-3.8L448 161.5V104c0-4.4-3.6-8-8-8s-8 3.6-8 8v64c0 .3 0 .7 .1 1l-61 28.7c-4.8-16.3-13.1-31.1-23.8-43.7c8.2-14.8 12.8-31.9 12.8-50C360 46.6 313.4 0 256 0zM168 104c0-48.6 39.4-88 88-88s88 39.4 88 88c0 17.2-4.9 33.2-13.4 46.8c-1.9 3.1-1.5 7.1 1 9.8C349.2 179.2 360 204.3 360 232c0 18.4-4.7 35.6-13.1 50.5c-1.8 3.2-1.2 7.2 1.5 9.8C375.3 317.1 392 352.6 392 392c0 35-13.2 67-35 91.1c-7.9 8.7-20 12.9-33.1 12.9H188.1c-13.1 0-25.3-4.2-33.1-12.9c-21.8-24.1-35-56-35-91.1c0-39.4 16.7-74.9 43.5-99.7c2.7-2.5 3.3-6.5 1.5-9.8c-8.3-15-13.1-32.2-13.1-50.5c0-27.7 10.8-52.8 28.5-71.5c2.5-2.7 2.9-6.7 1-9.8C172.9 137.2 168 121.2 168 104zM272 240a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM224 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-61.3 88.9c3 4.5 8 7.1 13.3 7.1s10.3-2.7 13.3-7.1l12.9-19.4c3.8-5.7 5.8-12.3 5.8-19.1V144c0-17.7-14.3-32-32-32s-32 14.3-32 32v2.4c0 6.8 2 13.4 5.8 19.1l12.9 19.4zm3.7-23.3l-3.3-4.9c-2-3-3.1-6.6-3.1-10.2V144c0-8.8 7.2-16 16-16s16 7.2 16 16v2.4c0 3.6-1.1 7.2-3.1 10.2l-3.3 4.9L256 176l-9.6-14.4z'
      
    ]
  };

  

  
  

  var faWheatAwnCircleExclamation = {
    prefix: 'fat',
    iconName: 'wheat-awn-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e598',
      
      'M413.7 13.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-48 48c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l48-48zm96 0c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-112 112-49.4 49.4c5.7-38.7-6.4-79.4-36.1-109.1L289.5 43.3c-6.2-6.2-16.4-6.2-22.6 0L255.5 54.6c-37.5 37.5-37.5 98.3 0 135.8l27.4 27.4-47.8 47.8c5.7-38.7-6.4-79.4-36.1-109.1l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l27.4 27.4-47.8 47.8c5.7-38.7-6.4-79.4-36.1-109.1L85.8 247c-6.2-6.2-16.4-6.2-22.6 0L51.9 258.3c-37.5 37.5-37.5 98.3 0 135.8l27.4 27.4L2.3 498.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l76.9-76.9 29.2 29.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3C224.7 385.8 182 374 142.1 381.2l50.3-50.3 29.2 29.2c26.8 26.8 65.5 34.4 99 22.9c-.4-5-.6-10-.6-15l0-1.8c-29 12-63.6 6.2-87.1-17.4l-29.2-29.2 15.8-15.8c35-16.3 76.8-13.5 109.5 8.4c1.7-5.2 3.7-10.3 5.9-15.2c-27.5-17.3-60.1-23.1-91-17.5l50.3-50.3 29.2 29.2c7 7 14.7 12.6 23 17c2.8-4.6 5.9-9 9.1-13.3c-7.5-3.8-14.5-8.8-20.8-15l-29.2-29.2L321.3 202c33.1-15.4 72.1-13.8 103.9 4.8c6-2.7 12.2-5 18.6-6.9c-28.8-21-64.4-28.4-98.1-22.3l51.9-51.9 112-112zm-392 392c41.5-19.3 92.3-11.9 126.5 22.3l11.3 11.3-11.3 11.3c-31.2 31.2-81.9 31.2-113.1 0l-29.2-29.2 15.8-15.8zm-27.1 4.5L63.2 382.7C32 351.5 32 300.8 63.2 269.6l11.3-11.3 11.3 11.3c32.5 32.5 40.9 80 25 120.2L90.6 410.1zM192.4 308.3L165 280.9c-31.2-31.2-31.2-81.9 0-113.1l11.3-11.3 11.3 11.3c32.5 32.5 40.9 80 25 120.2l-20.3 20.3zM294.2 206.5l-27.4-27.4c-31.2-31.2-31.2-81.9 0-113.1l11.3-11.3 11.3 11.3c32.5 32.5 40.9 80 25 120.2l-20.3 20.3zm215.4-96.8c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-48 48c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l48-48zM368 368a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 448a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-168c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8s8-3.6 8-8V288c0-4.4-3.6-8-8-8z'
      
    ]
  };

  

  
  

  var faGunSquirt = {
    prefix: 'fat',
    iconName: 'gun-squirt',
    icon: [
      576,
      512,
      [],
      'e19d',
      
      'M104 32c4.4 0 8 3.6 8 8V64H448c38.8 0 72.1 23 87.3 56H552c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H535.3c-15.2 33-48.5 56-87.3 56H249l-16 64h55V296c0-4.4 3.6-8 8-8s8 3.6 8 8v32 32c0 4.4-3.6 8-8 8s-8-3.6-8-8V336H229L199 455.8C195.5 470 182.7 480 168 480H64c-9.9 0-19.2-4.5-25.2-12.3s-8.2-17.9-5.8-27.5L79.4 254.6C34.3 246.7 0 207.3 0 160c0-53 43-96 96-96V40c0-4.4 3.6-8 8-8zM16 160c0 44.2 35.8 80 80 80H448c33.9 0 62.9-21.1 74.6-50.9c1.2-3.1 4.2-5.1 7.4-5.1h22c4.4 0 8-3.6 8-8V144c0-4.4-3.6-8-8-8H530c-3.3 0-6.3-2-7.4-5.1C510.9 101.1 481.9 80 448 80H96c-44.2 0-80 35.8-80 80zm216.5 96H96l-.5 0-47 188.1c-1.2 4.8-.1 9.8 2.9 13.7s7.7 6.2 12.6 6.2H168c7.3 0 13.7-5 15.5-12.1l49-195.9zM96 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H448c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zM64 160c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32z'
      
    ]
  };

  

  
  

  var faPiano = {
    prefix: 'fat',
    iconName: 'piano',
    icon: [
      512,
      512,
      [],
      'f8d4',
      
      'M112 352v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H16v96c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V352H464v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H384v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H272v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H192v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H112zm336 0H416v48c0 8.8 7.2 16 16 16s16-7.2 16-16V352zm16-16h32v-8.4c0-18.2-10.3-34.8-26.5-42.9l-58.4-29.2c-26.4-13.2-43.1-40.2-43.1-69.7C368 92 292 16 198.3 16H192C94.8 16 16 94.8 16 192V336H48 64 96h16 16 16 32 16 16 16 32 16 48 16 32 16 16 16 32 16zM336 400c0 8.8 7.2 16 16 16s16-7.2 16-16V352H336v48zm-80-48H224v48c0 8.8 7.2 16 16 16s16-7.2 16-16V352zM144 400c0 8.8 7.2 16 16 16s16-7.2 16-16V352H144v48zM96 352H64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V352zm416-24.4V336v8 8 96c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V352v-8-8V192C0 86 86 0 192 0h6.3C300.8 0 384 83.2 384 185.7c0 23.5 13.2 44.9 34.2 55.4l58.4 29.2c21.7 10.8 35.4 33 35.4 57.2z'
      
    ]
  };

  

  
  

  var faPepper = {
    prefix: 'fat',
    iconName: 'pepper',
    icon: [
      512,
      512,
      [129745],
      'e432',
      
      'M202.8 1.9c3.4-2.9 8.4-2.5 11.3 .9L208 8c6.1-5.2 6.1-5.2 6.1-5.2l0 0 0 0 0 0 .1 .1 .4 .5c.4 .5 .9 1.1 1.6 2c1.4 1.7 3.3 4.3 5.7 7.5c4.7 6.5 10.8 15.7 17 27.1c10.9 20 22.1 46.9 24.5 76.3c21.2-17.7 50.4-25.2 79.1-17.5c10.9 2.9 20.8 7.7 29.3 14c20-14.6 46-20.8 72-14.7c47.3 11 76.7 58.4 65.7 105.7l-56 240c-11 47.3-58.4 76.7-105.7 65.7c-13.7-3.2-25.9-9.4-36-17.8c-21.2 17.4-50.1 24.7-78.7 17.1c-12.6-3.4-23.9-9.3-33.3-17.1c-10.1 8.4-22.3 14.6-36 17.8c-47.3 11-94.7-18.4-105.7-65.7L2.3 204C-8.7 156.7 20.7 109.3 68 98.3c26-6.1 52 .1 72 14.7c8.3-6.1 17.9-10.8 28.4-13.8c.1 0 .1 0 .2-.1c28.4-7.8 57.5-.8 78.8 16.4C244.9 90.1 235 66.3 225 47.8c-5.8-10.7-11.6-19.4-16-25.4c-2.2-3-4-5.4-5.2-6.9c-.6-.8-1.1-1.4-1.4-1.8l-.4-.4-.1-.1 0 0 0 0c-2.9-3.4-2.5-8.4 .9-11.3zM172.4 114.7c-37.3 10.5-59.8 48.9-50.3 86.8l37.6 150.4c1.1 4.3-1.5 8.6-5.8 9.7s-8.6-1.5-9.7-5.8L106.6 205.3c-7.5-30 1.4-60.3 21.1-81.4c-15.9-10.5-36-14.7-56-10c-38.7 9-62.8 47.8-53.8 86.5l56 240c9 38.7 47.8 62.8 86.5 53.8c13.3-3.1 24.9-9.7 34-18.7c3.1-3.1 8.1-3.1 11.2 0c8.6 8.4 19.4 14.8 31.8 18.1c25.5 6.8 51.4-.9 69-18.1c3.1-3 8.1-3 11.2 0c9.1 8.9 20.7 15.6 34 18.7c38.7 9 77.4-15 86.5-53.8l56-240c9-38.7-15-77.4-53.8-86.5c-23.2-5.4-46.3 1-63.2 15.4c-3 2.6-7.4 2.6-10.4 0c-7.9-6.8-17.5-12-28.3-14.8c-29.2-7.8-59 3.5-76.2 26.3c-1.5 2-3.9 3.2-6.4 3.2s-4.9-1.2-6.4-3.2c-16.9-22.5-46.2-33.8-75.1-26.6l0 0c-.7 .2-1.4 .4-2.1 .6z'
      
    ]
  };

  

  
  

  var faTruckMedical = {
    prefix: 'fat',
    iconName: 'truck-medical',
    icon: [
      640,
      512,
      [128657,"ambulance"],
      'f0f9',
      
      'M352 16c26.5 0 48 21.5 48 48V400H236.7c-10.4-36.9-44.4-64-84.7-64s-74.2 27.1-84.7 64H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H352zM64 416h.4c-.2 2.6-.4 5.3-.4 8c0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8H400h.4c-.2 2.6-.4 5.3-.4 8c0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8H632c4.4 0 8-3.6 8-8s-3.6-8-8-8H608V229.3c0-10.6-4.2-20.8-11.7-28.3L503 107.7c-7.5-7.5-17.7-11.7-28.3-11.7H416V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64zM416 112h58.7c6.4 0 12.5 2.5 17 7L585 212.3c1.1 1.1 2.2 2.4 3 3.7H416V112zm0 261.4V232H592V400H572.7c-10.4-36.9-44.4-64-84.7-64c-29.8 0-56.1 14.8-72 37.4zM152 352a72 72 0 1 1 0 144 72 72 0 1 1 0-144zm264 72a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zM184 96c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H240c-4.4 0-8 3.6-8 8v56c0 4.4-3.6 8-8 8H192c-4.4 0-8-3.6-8-8V216c0-4.4-3.6-8-8-8H120c-4.4 0-8-3.6-8-8V168c0-4.4 3.6-8 8-8h56c4.4 0 8-3.6 8-8V96zm8-24c-13.3 0-24 10.7-24 24v48H120c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h48v48c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V224h48c13.3 0 24-10.7 24-24V168c0-13.3-10.7-24-24-24H248V96c0-13.3-10.7-24-24-24H192z'
      
    ]
  };

  
    var faAmbulance = faTruckMedical;
  

  
  

  var faApartment = {
    prefix: 'fat',
    iconName: 'apartment',
    icon: [
      576,
      512,
      [],
      'e468',
      
      'M144 112H80c-26.5 0-48 21.5-48 48V448c0 26.5 21.5 48 48 48H208h24 8V432c0-26.5 21.5-48 48-48s48 21.5 48 48v64h16 16H496c26.5 0 48-21.5 48-48V256c0-26.5-21.5-48-48-48H432c-8.8 0-16-7.2-16-16V64c0-26.5-21.5-48-48-48H208c-26.5 0-48 21.5-48 48V96c0 8.8-7.2 16-16 16zM320 496V432c0-17.7-14.3-32-32-32s-32 14.3-32 32v64h64zm-80 16h-8H208 80c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h48 16V80 64c0-35.3 28.7-64 64-64H368c35.3 0 64 28.7 64 64V176v16h16 48c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H368 352 336h-8H248h-8zM488 400c0 13.3-10.7 24-24 24H432c-13.3 0-24-10.7-24-24V368c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v32zm-24 8c4.4 0 8-3.6 8-8V368c0-4.4-3.6-8-8-8H432c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h32zM144 328H112c-13.3 0-24-10.7-24-24V272c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24zm8-24V272c0-4.4-3.6-8-8-8H112c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8zm16 96c0 13.3-10.7 24-24 24H112c-13.3 0-24-10.7-24-24V368c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v32zm-24 8c4.4 0 8-3.6 8-8V368c0-4.4-3.6-8-8-8H112c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h32zm160-80H272c-13.3 0-24-10.7-24-24V272c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24zm8-24V272c0-4.4-3.6-8-8-8H272c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8zM328 80v32c0 13.3-10.7 24-24 24H272c-13.3 0-24-10.7-24-24V80c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24zm-24-8H272c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V80c0-4.4-3.6-8-8-8zM464 328H432c-13.3 0-24-10.7-24-24V272c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24zm8-24V272c0-4.4-3.6-8-8-8H432c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8zM168 208c0 13.3-10.7 24-24 24H112c-13.3 0-24-10.7-24-24V176c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v32zm-24 8c4.4 0 8-3.6 8-8V176c0-4.4-3.6-8-8-8H112c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h32zm160 16H272c-13.3 0-24-10.7-24-24V176c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24zm8-24V176c0-4.4-3.6-8-8-8H272c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8z'
      
    ]
  };

  

  
  

  var faTriangle = {
    prefix: 'fat',
    iconName: 'triangle',
    icon: [
      512,
      512,
      [9650],
      'f2ec',
      
      'M221.7 67.7C228.8 55.5 241.9 48 256 48s27.2 7.5 34.3 19.7l201 344.6c3.1 5.3 4.7 11.2 4.7 17.3c0 19-15.4 34.4-34.4 34.4H50.4c-19 0-34.4-15.4-34.4-34.4c0-6.1 1.6-12.1 4.7-17.3l201-344.6zm-13.8-8.1L6.9 404.2C2.4 411.9 0 420.7 0 429.6C0 457.4 22.6 480 50.4 480H461.6c27.8 0 50.4-22.6 50.4-50.4c0-8.9-2.4-17.7-6.9-25.4L304.1 59.6C294.1 42.5 275.8 32 256 32s-38.1 10.5-48.1 27.6z'
      
    ]
  };

  

  
  

  var faFileMov = {
    prefix: 'fat',
    iconName: 'file-mov',
    icon: [
      512,
      512,
      [],
      'e647',
      
      'M64 496H80v16H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H204.1c12.7 0 24.9 5.1 33.9 14.1L369.9 145.9c9 9 14.1 21.2 14.1 33.9V304H368V179.9c0-1.3-.1-2.6-.2-3.9H248c-22.1 0-40-17.9-40-40V16.2c-1.3-.2-2.6-.2-3.9-.2H64C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48zM361.1 160c-.8-1-1.6-1.9-2.4-2.7L226.7 25.4c-.9-.9-1.8-1.7-2.7-2.4V136c0 13.3 10.7 24 24 24H361.1zM150.7 371.6l41.3 62 41.3-62c2-2.9 5.6-4.2 9-3.2s5.7 4.1 5.7 7.7V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V402.4l-33.3 50c-1.5 2.2-4 3.6-6.7 3.6s-5.2-1.3-6.7-3.6l-33.3-50V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V376c0-3.5 2.3-6.6 5.7-7.7s7 .3 9 3.2zM440 376v31.6c0 29.1 8.3 57.5 24 82c15.7-24.5 24-52.9 24-82V376c0-4.4 3.6-8 8-8s8 3.6 8 8v31.6c0 33.2-9.8 65.6-28.2 93.2l-5.1 7.7c-1.5 2.2-4 3.6-6.7 3.6s-5.2-1.3-6.7-3.6l-5.1-7.7c-18.4-27.6-28.2-60-28.2-93.2V376c0-4.4 3.6-8 8-8s8 3.6 8 8zM296 400c0-17.7 14.3-32 32-32h16c17.7 0 32 14.3 32 32v80c0 17.7-14.3 32-32 32H328c-17.7 0-32-14.3-32-32V400zm32-16c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H328z'
      
    ]
  };

  

  
  

  var faHeadSideCoughSlash = {
    prefix: 'fat',
    iconName: 'head-side-cough-slash',
    icon: [
      640,
      512,
      [],
      'e062',
      
      'M222.9 16h16.8c71.6 0 137.5 43.3 166.4 105c3.5 7.4 6.9 15.1 10.4 22.9c6.4 14.3 12.9 28.9 20.1 42.7c11.3 21.6 24.8 42.2 43.5 58.9l3.8 3.4c7.7 6.9 12.1 16.7 12.1 27c0 8.1-2.7 15.6-7.2 21.7l12.6 9.9c6.7-8.8 10.7-19.7 10.7-31.6c0-14.9-6.4-29.1-17.5-39l-3.8-3.4c-16.7-14.9-29.2-33.6-40-54.4c-7-13.4-13.1-27.1-19.3-41c-3.5-7.9-7.1-15.9-10.8-23.9C389.1 46.9 317.6 0 239.7 0H222.9c-31.3 0-61.1 6.4-88.1 18.1l14.4 11.4C172.2 20.8 197 16 222.9 16zM27 116.4C9.8 148.1 0 184.4 0 222.9c0 52.8 16.9 101.5 47.4 139.9C57.5 375.5 64 390.2 64 405.3V504c0 4.4 3.6 8 8 8s8-3.6 8-8V405.3c0-19.8-8.5-37.8-20.1-52.4C31.8 317.5 16 272.3 16 222.9c0-34.8 8.6-67.6 23.8-96.4L27 116.4zM546.6 343.2l25 19.8c2.7-2.9 4.3-6.7 4.3-11c0-8.8-7.2-16-16-16c-5.6 0-10.5 2.9-13.4 7.2zm63 49.7l24.6 19.4c3.5-2.9 5.8-7.4 5.8-12.3c0-8.8-7.2-16-16-16c-6.3 0-11.7 3.6-14.4 8.9zM431.8 436l-27.5-21.7-55.2-4.6c-7.5-.6-13.2-6.9-13.2-14.3c0-7.2 5.3-13.2 12.3-14.2l11.9-1.7L343 365.9c-13.4 3.3-23 15.4-23 29.5c0 15.8 12.1 29 27.9 30.3l68.1 5.7v.6c0 17.7-14.3 32-32 32H312c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8s8-3.6 8-8V480h64c25.2 0 45.8-19.4 47.8-44zM624 320a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  

  
  

  var faPear = {
    prefix: 'fat',
    iconName: 'pear',
    icon: [
      512,
      512,
      [],
      'e20c',
      
      'M509.7 2.3c3.1 3.1 3.1 8.2 0 11.3L448 75.3c19.9 22.6 32 52.2 32 84.7c0 30.7-10.8 58.9-28.9 81c-29.9 36.5-61.4 81.8-73.3 127.4c-8.3 32-25 62.3-50.1 87.3c-75 75-196.5 75-271.5 0s-75-196.5 0-271.5c25.1-25.1 55.3-41.8 87.3-50.1c45.7-11.8 90.9-43.4 127.4-73.3c22.1-18 50.3-28.9 81-28.9c32.5 0 62.1 12.1 84.7 32L498.3 2.3c3.1-3.1 8.2-3.1 11.3 0zm-107.3 96l23-23C405.7 58.3 380 48 352 48c-26.9 0-51.6 9.5-70.9 25.3c-36.8 30.1-84.3 63.6-133.5 76.4c-29.3 7.6-57.1 22.9-80.1 45.9c-68.7 68.7-68.7 180.2 0 248.9s180.2 68.7 248.9 0c23-23 38.3-50.7 45.9-80.1c12.8-49.2 46.3-96.8 76.4-133.5c15.8-19.3 25.3-44 25.3-70.9c0-28-10.3-53.7-27.3-73.3l-23 23c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3zM304 328c0 57.4-46.6 104-104 104c-4.4 0-8-3.6-8-8s3.6-8 8-8c48.6 0 88-39.4 88-88c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faStaffSnake = {
    prefix: 'fat',
    iconName: 'staff-snake',
    icon: [
      384,
      512,
      ["rod-asclepius","rod-snake","staff-aesculapius"],
      'e579',
      
      'M236.9 48c1.4-26-19.3-48-45.4-48s-46.9 22-45.4 48H56C25.1 48 0 73.1 0 104s25.1 56 56 56H71.7c22.6 0 43.8-10.6 57.3-28.7l2.5-3.3h19.7l2.1 32c-49.7 .9-89.8 41.5-89.8 91.5V256c0 53 43 96 96 96h6.2c0 .2 0 .3 0 .5l2 31.5H127.5c-17.7 0-32 14.3-32 32s14.3 32 32 32h44.4l3.1 48.5c.6 8.7 7.8 15.5 16.5 15.5s15.9-6.8 16.5-15.5l9.3-144c0-.2 0-.3 0-.5h54.2c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-4.4 0-8 3.6-8 8s3.6 8 8 8h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-112c-44.2 0-80-35.8-80-80v-4.5c0-41.5 33.4-75.1 74.8-75.5l2.1 32.1c-25.1 1.6-44.9 22.4-44.9 47.9c0 26.5 21.5 48 48 48h112c35.3 0 64 28.7 64 64s-28.7 64-64 64h-40c-4.4 0-8 3.6-8 8s3.6 8 8 8h40c44.2 0 80-35.8 80-80s-35.8-80-80-80h-112c-17.7 0-32-14.3-32-32c0-17 13.2-30.9 29.9-31.9l2.1 32.4c.3 4.4 4.1 7.8 8.5 7.5s7.8-4.1 7.5-8.5L167.3 128h48.5l-8.2 127.5c-.3 4.4 3.1 8.2 7.5 8.5s8.2-3.1 8.5-7.5L231.8 128h55.7c8.8 0 16 7.2 16 16s-7.2 16-16 16h-24c-4.4 0-8 3.6-8 8s3.6 8 8 8h24c17.7 0 32-14.3 32-32s-14.3-32-32-32h-160c-2.5 0-4.9 1.2-6.4 3.2l-4.9 6.5c-10.5 14-27 22.3-44.5 22.3H56c-22.1 0-40-17.9-40-40s17.9-40 40-40H287.5c44.2 0 80 35.8 80 80s-35.8 80-80 80h-40c-4.4 0-8 3.6-8 8s3.6 8 8 8h40c53 0 96-43 96-96s-43-96-96-96H236.9zM170.8 432H127.5c-8.8 0-16-7.2-16-16s7.2-16 16-16h41.3l2.1 32zm30.5-80L192 495.5c0 .3-.3 .5-.5 .5s-.5-.2-.5-.5L181.7 352h19.6zM162.1 48c0-.2 0-.4 0-.6C161 30.4 174.5 16 191.5 16s30.5 14.4 29.4 31.4c0 .2 0 .4 0 .6H162.1zM47.5 96a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z'
      
    ]
  };

  
    var faRodAsclepius = faStaffSnake;
  
    var faRodSnake = faStaffSnake;
  
    var faStaffAesculapius = faStaffSnake;
  

  
  

  var faSpiderBlackWidow = {
    prefix: 'fat',
    iconName: 'spider-black-widow',
    icon: [
      512,
      512,
      [],
      'f718',
      
      'M368.8 11.6c-2-4-.4-8.8 3.6-10.7s8.8-.4 10.7 3.6l46.4 92.8c7.3 14.5 5 32-5.7 44.2l-83.1 94.9 120.4-31.7c7.8-2.1 14.1-7.9 16.7-15.6l18.5-55.6c1.4-4.2 5.9-6.5 10.1-5.1s6.5 5.9 5.1 10.1l-18.5 55.6c-4.3 12.8-14.7 22.6-27.8 26L344.2 252l121.1 31.9c13.1 3.4 23.5 13.2 27.8 26l18.5 55.6c1.4 4.2-.9 8.7-5.1 10.1s-8.7-.9-10.1-5.1L477.9 315c-2.6-7.7-8.8-13.6-16.7-15.6L358.2 272.2l70.2 93.6c7.9 10.5 10.1 24.2 5.9 36.6L399.6 506.5c-1.4 4.2-5.9 6.5-10.1 5.1s-6.5-5.9-5.1-10.1l34.7-104.1c2.5-7.5 1.2-15.7-3.6-22l-50.2-66.9c1.7 7.5 2.6 15.3 2.6 23.3v8.3C368 400 317.5 448 256 448s-112-48-112-107.8v-8.3c0-8 .9-15.8 2.6-23.3L96.5 375.4c-4.7 6.3-6.1 14.5-3.6 22l34.7 104.1c1.4 4.2-.9 8.7-5.1 10.1s-8.7-.9-10.1-5.1L77.7 402.4c-4.2-12.5-1.9-26.1 5.9-36.6l70.2-93.6L50.8 299.3c-7.8 2.1-14.1 7.9-16.7 15.6L15.6 370.5c-1.4 4.2-5.9 6.5-10.1 5.1s-6.5-5.9-5.1-10.1l18.5-55.6c4.3-12.8 14.7-22.6 27.8-26L167.8 252 46.7 220.1c-13.1-3.4-23.5-13.2-27.8-26L.4 138.5c-1.4-4.2 .9-8.7 5.1-10.1s8.7 .9 10.1 5.1L34.1 189c2.6 7.7 8.8 13.6 16.7 15.6l120.4 31.7L88.1 141.4c-10.7-12.2-12.9-29.7-5.7-44.2L128.8 4.4c2-4 6.8-5.6 10.7-3.6s5.6 6.8 3.6 10.7L96.8 104.4c-4.4 8.7-3 19.2 3.4 26.5L184 226.7V144c0-27.4 15.3-51.2 37.9-63.4c1.9-1 4.1-1.2 6.1-.6s3.7 2 4.7 3.9L256 127.1l23.3-43.3c1-1.9 2.7-3.3 4.7-3.9s4.2-.4 6.1 .6c22.5 12.2 37.9 36 37.9 63.4v82.7l83.8-95.8c6.4-7.3 7.8-17.8 3.4-26.5L368.8 11.6zM200 144V253.1c0 2.5-1.2 4.9-3.2 6.4c-22.5 16.9-36.8 43-36.8 72.3v8.3c0 50.4 42.7 91.8 96 91.8s96-41.4 96-91.8v-8.3c0-29.3-14.3-55.4-36.8-72.3c-2-1.5-3.2-3.9-3.2-6.4V144c0-18.4-8.9-34.8-22.7-45L263 147.8c-1.4 2.6-4.1 4.2-7 4.2s-5.6-1.6-7-4.2L222.7 99c-13.8 10.2-22.7 26.6-22.7 45zm24 156c0 .9 .3 1.7 .8 2.4l21.6 28.8c2.1 2.8 2.1 6.8 0 9.6l-21.6 28.8c-.5 .7-.8 1.5-.8 2.4c0 2.2 1.8 4 4 4h56c2.2 0 4-1.8 4-4c0-.9-.3-1.7-.8-2.4l-21.6-28.8c-2.1-2.8-2.1-6.8 0-9.6l21.6-28.8c.5-.7 .8-1.5 .8-2.4c0-2.2-1.8-4-4-4H228c-2.2 0-4 1.8-4 4zm4-20h56c11 0 20 9 20 20c0 4.3-1.4 8.5-4 12l-18 24 18 24c2.6 3.5 4 7.7 4 12c0 11-9 20-20 20H228c-11 0-20-9-20-20c0-4.3 1.4-8.5 4-12l18-24-18-24c-2.6-3.5-4-7.7-4-12c0-11 9-20 20-20z'
      
    ]
  };

  

  
  

  var faCircleD = {
    prefix: 'fat',
    iconName: 'circle-d',
    icon: [
      512,
      512,
      [],
      'e104',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 150.9c0-3.8 3.1-6.9 6.9-6.9H256c61.9 0 112 50.1 112 112s-50.1 112-112 112H182.9c-3.8 0-6.9-3.1-6.9-6.9V150.9zm6.9-22.9c-12.6 0-22.9 10.2-22.9 22.9V361.1c0 12.6 10.2 22.9 22.9 22.9H256c70.7 0 128-57.3 128-128s-57.3-128-128-128H182.9z'
      
    ]
  };

  

  
  

  var faHammerWar = {
    prefix: 'fat',
    iconName: 'hammer-war',
    icon: [
      384,
      512,
      [],
      'f6e4',
      
      'M192 16c-8.8 0-16 7.2-16 16V53.2l11.3 1.7c3.1 .5 6.3 .5 9.5 0L208 53.2V32c0-8.8-7.2-16-16-16zM160 50.8V32c0-17.7 14.3-32 32-32s32 14.3 32 32V50.8L347.3 32.4C366.3 29.5 384 44.7 384 64V256c0 19.3-17.7 34.5-36.7 31.6L196.7 265.1c-3.1-.5-6.3-.5-9.5 0L36.7 287.6C17.7 290.5 0 275.3 0 256V64C0 44.7 17.7 29.5 36.7 32.4L160 50.8zM176 291V480c0 8.8 7.2 16 16 16s16-7.2 16-16V291l16 2.4V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V293.4l16-2.4zM16 256c0 9.5 9 17.2 18.4 15.8l150.5-22.6c4.7-.7 9.5-.7 14.2 0l150.5 22.6c9.4 1.4 18.4-6.3 18.4-15.8V64c0-9.5-9-17.2-18.4-15.8L199.1 70.8c-4.7 .7-9.5 .7-14.2 0L34.4 48.2C25 46.8 16 54.5 16 64V256z'
      
    ]
  };

  

  
  

  var faBicycle = {
    prefix: 'fat',
    iconName: 'bicycle',
    icon: [
      640,
      512,
      [128690],
      'f206',
      
      'M296 32c-4.4 0-8 3.6-8 8s3.6 8 8 8h51.1l57.5 112.1c-.6-.1-1.2-.1-1.8-.1H205.6L166.7 99.7c-1.5-2.3-4-3.7-6.7-3.7H104c-4.4 0-8 3.6-8 8s3.6 8 8 8h51.6l36.4 56.5-26.9 61c-11.8-3.6-24.3-5.5-37.2-5.5C57.3 224 0 281.3 0 352s57.3 128 128 128c68 0 123.6-53 127.8-120H320c3 0 5.7-1.7 7.1-4.3l89.7-171.9L446.6 242C409.1 264.3 384 305.2 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-18.2 0-35.5 3.8-51.2 10.6L361.4 40.7c-2.7-5.3-8.2-8.7-14.2-8.7H296zM453.9 256.2l51 99.4c2 3.9 6.8 5.5 10.8 3.5s5.5-6.8 3.5-10.8l-51-99.4c13.5-5.7 28.3-8.9 43.9-8.9c61.9 0 112 50.1 112 112s-50.1 112-112 112s-112-50.1-112-112c0-40.6 21.6-76.1 53.9-95.8zm-295.2-12l-44 100c-3.3 7.4 2.2 15.7 10.3 15.7H239.7c-4.1 58.1-52.6 104-111.7 104C66.1 464 16 413.9 16 352s50.1-112 112-112c10.7 0 20.9 1.5 30.7 4.3zM132.3 344l70.2-159.4L305.3 344H132.3zM216 176H402.8L319.3 336.1 216 176z'
      
    ]
  };

  

  
  

  var faBangladeshiTakaSign = {
    prefix: 'fat',
    iconName: 'bangladeshi-taka-sign',
    icon: [
      384,
      512,
      [],
      'e2e6',
      
      'M41 32.1c-4.4-.5-8.4 2.6-8.9 6.9s2.6 8.4 6.9 8.9l7.9 1C75 52.4 96 76.3 96 104.5V192H40c-4.4 0-8 3.6-8 8s3.6 8 8 8H96V408c0 39.8 32.2 72 72 72h16c110.5 0 200-89.5 200-200V264c0-39.8-32.2-72-72-72H264c-4.4 0-8 3.6-8 8s3.6 8 8 8h48c30.9 0 56 25.1 56 56v16c0 101.6-82.4 184-184 184H168c-30.9 0-56-25.1-56-56V208h72c4.4 0 8-3.6 8-8s-3.6-8-8-8H112V104.5c0-36.3-27-66.9-63.1-71.4l-7.9-1z'
      
    ]
  };

  

  
  

  var faCalendars = {
    prefix: 'fat',
    iconName: 'calendars',
    icon: [
      512,
      512,
      [],
      'e0d7',
      
      'M216 0c4.4 0 8 3.6 8 8V64H384V8c0-4.4 3.6-8 8-8s8 3.6 8 8V64h48c35.3 0 64 28.7 64 64v48 16V352c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V192 176 128c0-35.3 28.7-64 64-64h48V8c0-4.4 3.6-8 8-8zm-8 120V80H160c-26.5 0-48 21.5-48 48v48H496V128c0-26.5-21.5-48-48-48H400v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V80H224v40c0 4.4-3.6 8-8 8s-8-3.6-8-8zm288 72H112V352c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V192zM0 224c0-29.8 20.4-54.9 48-62v16.7c-18.6 6.6-32 24.4-32 45.3V448c0 26.5 21.5 48 48 48H352c20.9 0 38.7-13.4 45.3-32H414c-7.1 27.6-32.2 48-62 48H64c-35.3 0-64-28.7-64-64V224z'
      
    ]
  };

  

  
  

  var faCircleArrowUpRight = {
    prefix: 'fat',
    iconName: 'circle-arrow-up-right',
    icon: [
      512,
      512,
      [],
      'e0fc',
      
      'M256 496a240 240 0 1 0 0-480 240 240 0 1 0 0 480zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM200 160H344c4.4 0 8 3.6 8 8V312c0 4.4-3.6 8-8 8s-8-3.6-8-8V187.3L173.7 349.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L324.7 176H200c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faLeafyGreen = {
    prefix: 'fat',
    iconName: 'leafy-green',
    icon: [
      576,
      512,
      [129388],
      'e41d',
      
      'M233.8 27c-3.3 4.3-6.3 8.9-9 13.6l-.8-.9c-31.7-31.7-83-31.7-114.7 0c-5 5-9.1 10.4-12.5 16.1c-14.2 24-35 45.7-55.7 62.5c-1.8 1.5-3.6 3.1-5.3 4.8c-20.8 20.8-25.2 52-12.9 77.1c5.8 11.8 12.6 27.1 12.6 44.2v35.7c0 10.5 4.2 20.5 11.6 27.9l26.3 26.3c13.4 13.4 20.9 31.6 20.9 50.5v1.6c-1.6 4.6-4.2 8.9-7.7 12.4L79 406.5c-.5-2.9-.7-5.8-.7-8.7l0-12.9c0-14.7-5.8-28.8-16.3-39.2L35.7 319.3c-10.4-10.4-16.3-24.5-16.3-39.2V244.4c0-13.1-5.3-25.4-11-37.1c-15.2-31.1-9.9-69.6 15.9-95.4c2.1-2.1 4.3-4.1 6.5-5.9C50.6 89.9 70 69.6 83 47.7c4.1-6.9 9.1-13.4 15-19.3C135.4-9 195.7-9.5 233.8 27zM557 136c2-7.6 3-15.7 3-24c0-53-43-96-96-96c-8.3 0-16.3 1-24 3c-30.7 7.9-65.1 8.6-95.6 5.4c-2.8-.3-5.6-.4-8.5-.4c-35.1 0-64.9 22.6-75.7 54c-4.9 14.3-11.6 31.9-25.1 45.4l-29.1 29.1c-9 9-14.1 21.2-14.1 33.9v43c0 21.2-8.4 41.6-23.4 56.6l-10.5 10.5c-9 9-14.1 21.2-14.1 33.9v79.7c0 3.8-.3 7.6-.8 11.3L256 308.7V200c0-4.4 3.6-8 8-8s8 3.6 8 8v92.7L434.3 130.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L347.3 240H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H331.3L154.5 432.8c3.7-.5 7.5-.8 11.3-.8h79.7c12.7 0 24.9-5.1 33.9-14.1l10.5-10.5c15-15 35.4-23.4 56.6-23.4h43c12.7 0 24.9-5.1 33.9-14.1l29.1-29.1c13.5-13.5 31.1-20.2 45.4-25.1c31.5-10.8 54-40.6 54-75.7c0-2.9-.2-5.7-.4-8.5c-3.2-30.4-2.5-64.8 5.4-95.6zM120.6 466.7L77.7 509.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l42.9-42.9c12-12 18.7-28.3 18.7-45.3V330.5c0-17 6.7-33.3 18.7-45.3l10.5-10.5c12-12 18.7-28.3 18.7-45.3v-43c0-17 6.7-33.3 18.7-45.3l29.1-29.1c10.7-10.7 16.4-25 21.3-39.3C258.1 35.1 293.9 8 336 8c3.4 0 6.8 .2 10.1 .5c29.1 3.1 61.5 2.3 89.9-5C445 1.2 454.3 0 464 0c61.9 0 112 50.1 112 112c0 9.7-1.2 19-3.5 28c-7.3 28.4-8.1 60.8-5 89.9c.3 3.3 .5 6.7 .5 10.1c0 42.1-27.1 77.9-64.9 90.8c-14.3 4.9-28.6 10.6-39.3 21.3l-29.1 29.1c-12 12-28.3 18.7-45.3 18.7h-43c-17 0-33.3 6.7-45.3 18.7l-10.5 10.5c-12 12-28.3 18.7-45.3 18.7H165.8c-17 0-33.3 6.7-45.3 18.7z'
      
    ]
  };

  

  
  

  var faSquid = {
    prefix: 'fat',
    iconName: 'squid',
    icon: [
      512,
      512,
      [129425],
      'e450',
      
      'M122.7 2c3.2-2.8 7.9-2.6 10.9 .4l34.2 34.2c15.2 15.2 15.7 39.7 1 55.5l-62 66.8c-8.8 9.5-8.5 24.2 .6 33.3L153 237.7c4.5-41.1 24.4-92.3 73.3-137c11-10.1 23.5-19.8 37.6-29L257 8.9c-.3-2.4 .6-4.8 2.3-6.6s4.2-2.6 6.6-2.3L400.4 16c25.4-6 53.2-10.8 83.7-14.1c15-1.6 27.6 11 26 26c-3.3 30.4-8.1 58.3-14.1 83.7L512.8 247c.3 2.4-.5 4.9-2.3 6.6s-4.2 2.6-6.6 2.3l-63.6-7.8c-9.2 14.1-18.9 26.6-29 37.6c-44.7 48.9-96 68.8-137 73.3l45.6 45.6c9.1 9.1 23.8 9.4 33.3 .6l66.8-62c15.8-14.6 40.3-14.2 55.5 1l34.2 34.2c3 3 3.1 7.8 .4 10.9l-11 12.5c-27.4 31.3-75.6 33-105.1 3.5l-8.4-8.4-21.5 20c-15.8 14.6-40.3 14.2-55.5-1L255.7 363c-2 .9-3.9 2.1-5.6 3.4l-46 34.5L247 443.7c15.6 15.6 15.6 40.9 0 56.6l-9.4 9.4c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l9.4-9.4c9.4-9.4 9.4-24.6 0-33.9l-44.5-44.5-43.2 32.4c-7.6 5.7-11.9 14.6-11.8 24.1c.3 16.1 13.4 29 29.5 29h19.1c4.4 0 8 3.6 8 8s-3.6 8-8 8H165.8c-24.8 0-45.1-19.9-45.5-44.8c-.2-14.6 6.5-28.4 18.2-37.1l41.3-31-67-67L81.4 374.1C73 385.4 59.7 392 45.6 392C20.9 392 .9 372 .9 347.3V328c0-4.4 3.6-8 8-8s8 3.6 8 8v19.3c0 15.9 12.9 28.7 28.7 28.7c9 0 17.6-4.3 23-11.5l32.8-43.8L57 276.3c-9.4-9.4-24.6-9.4-33.9 0l-9.4 9.4c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l9.4-9.4c15.6-15.6 40.9-15.6 56.6 0l42.9 42.9 34.5-46c1.3-1.7 2.4-3.6 3.4-5.6L96.1 203.5c-15.2-15.2-15.7-39.7-1-55.5l20-21.5-8.4-8.4C77.3 88.6 78.9 40.4 110.2 12.9L122.7 2zm-.2 317.3l70.2 70.2 47.8-35.8c8.4-6.3 18.3-9.3 28.1-10.1c38-3.2 87.5-21.1 130.9-68.6c43.4-47.5 81.2-125.2 94.7-248.7c.5-4.8-3.6-8.9-8.4-8.4C362.3 31.3 284.6 69.1 237.1 112.5c-47.5 43.4-65.4 92.9-68.6 130.9c-.8 9.8-3.9 19.7-10.1 28.1l-35.8 47.8zm327-86.1l46.2 5.7-10.8-86.9c-10 31.2-22 58.2-35.4 81.3zM359.6 27.3L274 17.1l5 45.3c22.9-13.3 49.7-25.2 80.6-35.1zM126 114.7l31.1-33.5c8.8-9.5 8.5-24.2-.6-33.3L127.6 18.9l-6.9 6C96.4 46.3 95.1 83.8 118 106.7l8 8zM397.3 386l8 8c22.9 22.9 60.4 21.7 81.7-2.7l6-6.9-28.9-28.9c-9.1-9.1-23.8-9.4-33.3-.6L397.3 386zM208.9 320a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-16-48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faSparkles = {
    prefix: 'fat',
    iconName: 'sparkles',
    icon: [
      512,
      512,
      [10024],
      'f890',
      
      'M432 40c-4.4 0-8 3.6-8 8v56H368c-4.4 0-8 3.6-8 8s3.6 8 8 8h56v56c0 4.4 3.6 8 8 8s8-3.6 8-8V120h56c4.4 0 8-3.6 8-8s-3.6-8-8-8H440V48c0-4.4-3.6-8-8-8zm0 288c-4.4 0-8 3.6-8 8v56H368c-4.4 0-8 3.6-8 8s3.6 8 8 8h56v56c0 4.4 3.6 8 8 8s8-3.6 8-8V408h56c4.4 0 8-3.6 8-8s-3.6-8-8-8H440V336c0-4.4-3.6-8-8-8zM130.1 201.9c3.5-1.6 6.2-4.4 7.8-7.8L190.6 80l52.7 114.1c1.6 3.5 4.4 6.2 7.8 7.8l114.1 52.7L251 307.2c-3.5 1.6-6.2 4.4-7.8 7.8L190.6 429.1 137.9 315c-1.6-3.5-4.4-6.2-7.8-7.8L16 254.6l114.1-52.7zm75-128.6c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3L123.3 187.4 9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5l114.1 52.7L176 435.8c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l52.7-114.1 114.1-52.7c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5L257.8 187.4 205.1 73.3z'
      
    ]
  };

  

  
  

  var faV = {
    prefix: 'fat',
    iconName: 'v',
    icon: [
      384,
      512,
      [118],
      '56',
      
      'M4.9 32.6c4.1-1.7 8.8 .2 10.5 4.2L192 451.6 368.6 36.9c1.7-4.1 6.4-6 10.5-4.2s6 6.4 4.2 10.5l-184 432c-1.3 3-4.2 4.9-7.4 4.9s-6.1-1.9-7.4-4.9L.6 43.1c-1.7-4.1 .2-8.8 4.2-10.5z'
      
    ]
  };

  

  
  

  var faObjectsAlignBottom = {
    prefix: 'fat',
    iconName: 'objects-align-bottom',
    icon: [
      512,
      512,
      [],
      'e3bb',
      
      'M8 512c-4.4 0-8-3.6-8-8s3.6-8 8-8l496 0c4.4 0 8 3.6 8 8s-3.6 8-8 8L8 512zM176 400c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32H112C94.3 16 80 30.3 80 48l0 320c0 17.7 14.3 32 32 32h64zm-64 16c-26.5 0-48-21.5-48-48L64 48C64 21.5 85.5 0 112 0h64c26.5 0 48 21.5 48 48l0 320c0 26.5-21.5 48-48 48H112zm288-16c17.7 0 32-14.3 32-32l0-192c0-17.7-14.3-32-32-32H336c-17.7 0-32 14.3-32 32l0 192c0 17.7 14.3 32 32 32h64zm-64 16c-26.5 0-48-21.5-48-48l0-192c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48l0 192c0 26.5-21.5 48-48 48H336z'
      
    ]
  };

  

  
  

  var faBasketballHoop = {
    prefix: 'fat',
    iconName: 'basketball-hoop',
    icon: [
      640,
      512,
      [],
      'f435',
      
      'M20.9 194.4C38.1 162 126 16 320 16s281.9 146 299.1 178.4c3.5 6.7 4.9 13.8 4.9 20.5V331.2c0 19-11.2 36.2-28.5 43.9l-95.6 42.5-2.5 18.6L602 389.7c23.1-10.3 38-33.2 38-58.5V214.9c0-8.9-1.8-18.6-6.8-28C615.3 153.1 523.3 0 320 0S24.7 153.1 6.8 187C1.8 196.3 0 206 0 214.9V331.2c0 25.3 14.9 48.2 38 58.5l104.6 46.5-2.5-18.6L44.5 375.1C27.2 367.4 16 350.2 16 331.2V214.9c0-6.8 1.4-13.8 4.9-20.5zM176 184c0-13.3 10.7-24 24-24H440c13.3 0 24 10.7 24 24v40h16V184c0-22.1-17.9-40-40-40H200c-22.1 0-40 17.9-40 40v40h16V184zm-32 72H128c-4.4 0-8 3.6-8 8s3.6 8 8 8h25l31.1 233.1c.4 3.2 2.7 5.8 5.8 6.7s6.4-.2 8.4-2.7l51.4-64.2 64.7 64.9c1.5 1.5 3.5 2.4 5.7 2.4s4.2-.8 5.7-2.4l64.7-64.9L441.8 509c2 2.5 5.3 3.6 8.4 2.7s5.4-3.5 5.8-6.7L487 272h25c4.4 0 8-3.6 8-8s-3.6-8-8-8H496 480.1c-.1 0-.2 0-.2 0H464 176 160.1c-.1 0-.2 0-.2 0H144zm25.1 16h70.8l-60.2 79.7L169.1 272zm103.5 0h94.7L320 331.2 272.6 272zm127.4 0h70.8l-10.6 79.7L400.1 272zM320 492.7l-60.3-60.5L320 356.8l60.3 75.4L320 492.7zm-71.7-71.9L191 363.3 256.2 277l53.6 67-61.4 76.8zm-10.1 12.6l-40.8 51L183.3 378.2l55 55.2zm153.4-12.6L330.2 344l53.6-67L449 363.3l-57.3 57.5zm10.1 12.6l55-55.2L442.5 484.4l-40.8-51z'
      
    ]
  };

  

  
  

  var faTooth = {
    prefix: 'fat',
    iconName: 'tooth',
    icon: [
      448,
      512,
      [129463],
      'f5c9',
      
      'M130 48c17.7 0 35 5.8 49.2 16.4l40 30 21.3 16c3.5 2.7 8.5 1.9 11.2-1.6s1.9-8.5-1.6-11.2l-13.4-10 22.2-19C274.4 55.3 294.2 48 314.6 48c47.2 0 85.4 38.3 85.4 85.4v3.6c0 13.8-3.2 27.5-9.4 39.8l-21.3 42.6c-5.9 11.9-10.1 24.6-12.4 37.7L323 453.8c-1 5.9-6.1 10.2-12.1 10.2c-5.4 0-10.1-3.5-11.7-8.6L259.7 331c-5.1-16.1-20-27-36.9-27c-17.1 0-32.2 11.2-37.1 27.6L148.6 455.3c-1.5 5.1-6.3 8.7-11.7 8.7c-5.9 0-11-4.3-12-10.1L91.1 257.2c-2.3-13.1-6.4-25.8-12.4-37.7L57.4 176.9c-6.2-12.4-9.4-26-9.4-39.8V130c0-45.3 36.7-82 82-82zm93.7 29.7L188.8 51.6C171.8 38.9 151.2 32 130 32c-54.1 0-98 43.9-98 98v7.1c0 16.3 3.8 32.4 11.1 47l21.3 42.6c5.2 10.5 8.9 21.7 10.9 33.3l33.9 196.6c2.3 13.5 14.1 23.4 27.8 23.4c12.4 0 23.4-8.2 27-20.1l37.1-123.7c2.9-9.6 11.7-16.2 21.7-16.2c9.9 0 18.7 6.4 21.6 15.9l39.4 124.4c3.7 11.8 14.7 19.8 27 19.8c13.8 0 25.6-9.9 27.9-23.5L372.7 260c2-11.6 5.7-22.8 10.9-33.3l21.3-42.6c7.3-14.6 11.1-30.7 11.1-47v-3.6C416 77.4 370.6 32 314.6 32c-24.2 0-47.6 8.7-66 24.4L223.7 77.7z'
      
    ]
  };

  

  
  

  var faFaceGrinWide = {
    prefix: 'fat',
    iconName: 'face-grin-wide',
    icon: [
      512,
      512,
      [128515,"grin-alt"],
      'f581',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256.3 91.8c-43 0-84.1-5.5-121.5-15.4c-3.9-1-7.1 .3-8.7 1.8c-.7 .7-.9 1.2-.9 1.4l0 0c0 .1-.1 .7 .5 1.9c25 46.8 74.1 78.5 130.5 78.5s105.5-31.7 130.5-78.5c.7-1.2 .6-1.8 .5-1.9l0 0c0-.2-.2-.7-.9-1.4c-1.6-1.5-4.8-2.8-8.7-1.8c-37.4 9.9-78.4 15.4-121.5 15.4zm144.6-2.7C373.2 396.8 318.8 432 256.3 432s-116.9-35.2-144.6-86.9c-9.1-17 8.7-33.1 27.3-28.2c36 9.6 75.6 14.9 117.3 14.9s81.4-5.3 117.3-14.9c18.6-4.9 36.4 11.2 27.3 28.2zM160.5 150.3c-5.1 10.3-8.5 25-8.5 41.7s3.4 31.4 8.5 41.7c5.4 10.7 11.3 14.3 15.5 14.3s10.1-3.6 15.5-14.3c5.1-10.3 8.5-25 8.5-41.7s-3.4-31.4-8.5-41.7C186.1 139.6 180.2 136 176 136s-10.1 3.6-15.5 14.3zm-14.3-7.2c6.2-12.4 16.3-23.2 29.8-23.2s23.6 10.7 29.8 23.2c6.5 12.9 10.2 30.2 10.2 48.8s-3.8 35.9-10.2 48.8C199.6 253.3 189.5 264 176 264s-23.6-10.7-29.8-23.2C139.8 227.9 136 210.6 136 192s3.8-35.9 10.2-48.8zM312 192c0 16.7 3.4 31.4 8.5 41.7c5.4 10.7 11.3 14.3 15.5 14.3s10.1-3.6 15.5-14.3c5.1-10.3 8.5-25 8.5-41.7s-3.4-31.4-8.5-41.7C346.1 139.6 340.2 136 336 136s-10.1 3.6-15.5 14.3c-5.1 10.3-8.5 25-8.5 41.7zm24-72c13.5 0 23.6 10.7 29.8 23.2c6.5 12.9 10.2 30.2 10.2 48.8s-3.8 35.9-10.2 48.8C359.6 253.3 349.5 264 336 264s-23.6-10.7-29.8-23.2C299.8 227.9 296 210.6 296 192s3.8-35.9 10.2-48.8c6.2-12.4 16.3-23.2 29.8-23.2z'
      
    ]
  };

  
    var faGrinAlt = faFaceGrinWide;
  

  
  

  var faPills = {
    prefix: 'fat',
    iconName: 'pills',
    icon: [
      576,
      512,
      [],
      'f484',
      
      'M112 48c53 0 96 43 96 96V256H16V144c0-53 43-96 96-96zM16 368V272H208v96c0 53-43 96-96 96s-96-43-96-96zM0 144V368c0 61.9 50.1 112 112 112s112-50.1 112-112V144c0-61.9-50.1-112-112-112S0 82.1 0 144zM416 464c-79.5 0-144-64.5-144-144c0-36.9 13.9-70.5 36.7-96L512 427.3c-25.5 22.8-59.1 36.7-96 36.7zM320 212.7c25.5-22.8 59.1-36.7 96-36.7c79.5 0 144 64.5 144 144c0 36.9-13.9 70.5-36.7 96L320 212.7zM416 480a160 160 0 1 0 0-320 160 160 0 1 0 0 320z'
      
    ]
  };

  

  
  

  var faArrowDownLeftAndArrowUpRightToCenter = {
    prefix: 'fat',
    iconName: 'arrow-down-left-and-arrow-up-right-to-center',
    icon: [
      512,
      512,
      [],
      'e092',
      
      'M456 224c4.4 0 8-3.6 8-8s-3.6-8-8-8H315.3L509.7 13.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L304 196.7V56c0-4.4-3.6-8-8-8s-8 3.6-8 8V216c0 4.4 3.6 8 8 8H456zM56 288c-4.4 0-8 3.6-8 8s3.6 8 8 8H196.7L2.3 498.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L208 315.3V456c0 4.4 3.6 8 8 8s8-3.6 8-8V296c0-4.4-3.6-8-8-8H56z'
      
    ]
  };

  

  
  

  var faHryvniaSign = {
    prefix: 'fat',
    iconName: 'hryvnia-sign',
    icon: [
      384,
      512,
      [8372,"hryvnia"],
      'f6f2',
      
      'M84.2 73.5C109.1 56.9 138.4 48 168.3 48H235c46.9 0 85 38.1 85 85c0 22.4-8.8 43.4-23.8 59H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H275c-1.2 .7-2.5 1.3-3.8 1.9L106 287.6c-.3 .1-.5 .2-.8 .4H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H81.4C60.5 322.9 48 350 48 379c0 55.8 45.2 101 101 101h66.7c33.1 0 65.5-9.8 93-28.2l7.8-5.2c3.7-2.5 4.7-7.4 2.2-11.1s-7.4-4.7-11.1-2.2l-7.8 5.2c-24.9 16.6-54.2 25.5-84.1 25.5H149c-46.9 0-85-38.1-85-85c0-31.5 17.4-60.3 45-75H376c4.4 0 8-3.6 8-8s-3.6-8-8-8H142.8L278 224.4c9.1-4.3 17.4-9.8 24.6-16.4H376c4.4 0 8-3.6 8-8s-3.6-8-8-8H317c12.1-16.9 19-37.4 19-59c0-55.8-45.2-101-101-101H168.3c-33.1 0-65.5 9.8-93 28.2l-7.8 5.2c-3.7 2.5-4.7 7.4-2.2 11.1s7.4 4.7 11.1 2.2l7.8-5.2z'
      
    ]
  };

  
    var faHryvnia = faHryvniaSign;
  

  
  

  var faI = {
    prefix: 'fat',
    iconName: 'i',
    icon: [
      320,
      512,
      [105],
      '49',
      
      'M8 32c-4.4 0-8 3.6-8 8s3.6 8 8 8H152V464H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H312c4.4 0 8-3.6 8-8s-3.6-8-8-8H168V48H312c4.4 0 8-3.6 8-8s-3.6-8-8-8H160 8z'
      
    ]
  };

  

  
  

  var faUserHelmetSafety = {
    prefix: 'fat',
    iconName: 'user-helmet-safety',
    icon: [
      448,
      512,
      [128119,"user-construction","user-hard-hat"],
      'f82c',
      
      'M200 24V88c0 4.4-3.6 8-8 8s-8-3.6-8-8V38.8C137.4 55.3 104 99.8 104 152v8H344v-8c0-52.2-33.4-96.7-80-113.2V88c0 4.4-3.6 8-8 8s-8-3.6-8-8V24c0-4.4-3.6-8-8-8H208c-4.4 0-8 3.6-8 8zm-16 0c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24V22c55.6 17.1 96 68.8 96 130v8l16 0c4.4 0 8 3.6 8 8s-3.6 8-8 8H72c-4.4 0-8-3.6-8-8s3.6-8 8-8l16 0v-8c0-61.2 40.4-112.9 96-130v2zm40 296c-65.3 0-119.1-48.9-127-112h16.1c7.8 54.3 54.4 96 110.9 96s103.1-41.7 110.9-96H351c-7.9 63.1-61.7 112-127 112zm-89.6 48C69 368 16 421 16 486.4c0 5.3 4.3 9.6 9.6 9.6H422.4c5.3 0 9.6-4.3 9.6-9.6C432 421 379 368 313.6 368H134.4zM0 486.4C0 412.2 60.2 352 134.4 352H313.6C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4z'
      
    ]
  };

  
    var faUserConstruction = faUserHelmetSafety;
  
    var faUserHardHat = faUserHelmetSafety;
  

  
  

  var faDialHigh = {
    prefix: 'fat',
    iconName: 'dial-high',
    icon: [
      576,
      512,
      [],
      'e15c',
      
      'M272 32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM288 296H431.8c-4.2 75.8-66.9 136-143.8 136c-79.5 0-144-64.5-144-144s64.5-144 144-144c76.8 0 139.6 60.2 143.8 136H288c-4.4 0-8 3.6-8 8s3.6 8 8 8zm160-8a160 160 0 1 0 -320 0 160 160 0 1 0 320 0zm96-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM16 288a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0A32 32 0 1 0 0 288a32 32 0 1 0 64 0zM96 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM464 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 464a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm368-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faGlassEmpty = {
    prefix: 'fat',
    iconName: 'glass-empty',
    icon: [
      384,
      512,
      [],
      'e191',
      
      'M32.1 16c-9.3 0-16.7 8-15.9 17.3L50.9 459.2C52.6 480 69.9 496 90.7 496H293.3c20.8 0 38.2-16 39.9-36.8L367.9 33.3C368.7 24 361.3 16 352 16H32.1zM.2 34.6C-1.3 16 13.4 0 32.1 0H352c18.7 0 33.4 16 31.9 34.6l-34.7 426c-2.4 29.1-26.7 51.4-55.8 51.4H90.7c-29.2 0-53.4-22.4-55.8-51.4L.2 34.6z'
      
    ]
  };

  

  
  

  var faDroneFront = {
    prefix: 'fat',
    iconName: 'drone-front',
    icon: [
      640,
      512,
      ["drone-alt"],
      'f860',
      
      'M152 104c0-4.4-3.6-8-8-8s-8 3.6-8 8v24H16c-4.4 0-8 3.6-8 8s3.6 8 8 8H136V296c0 4.4 3.6 8 8 8h53.6l0 0-13.5 16.2c-15.6 18.7-24.1 42.2-24.1 66.6V408c0 4.4 3.6 8 8 8s8-3.6 8-8V386.8c0-20.6 7.2-40.5 20.4-56.3L211 312.9l56.6 37.7c1.3 .9 2.9 1.3 4.4 1.3h96c1.6 0 3.1-.5 4.4-1.3L429 312.9l14.6 17.5c13.2 15.8 20.4 35.8 20.4 56.3V408c0 4.4 3.6 8 8 8s8-3.6 8-8V386.8c0-24.3-8.5-47.9-24.1-66.6L442.4 304l0 0H496c4.4 0 8-3.6 8-8V144H624c4.4 0 8-3.6 8-8s-3.6-8-8-8H504V104c0-4.4-3.6-8-8-8s-8 3.6-8 8v24H368c-4.4 0-8 3.6-8 8s3.6 8 8 8H488v99.8l-80-35c-25.3-11.1-52.6-16.8-80.2-16.8H312.2c-27.6 0-54.9 5.7-80.2 16.8l-80 35V144H272c4.4 0 8-3.6 8-8s-3.6-8-8-8H152V104zm0 157.2l86.4-37.8c23.3-10.2 48.4-15.4 73.8-15.4h15.7c25.4 0 50.5 5.3 73.8 15.4L488 261.2V288H440c-1.6 0-3.1 .5-4.4 1.3l-70 46.7H274.4l-70-46.7c-1.3-.9-2.9-1.3-4.4-1.3H152V261.2z'
      
    ]
  };

  
    var faDroneAlt = faDroneFront;
  

  
  

  var faStairs = {
    prefix: 'fat',
    iconName: 'stairs',
    icon: [
      576,
      512,
      [],
      'e289',
      
      'M424 40c0-4.4 3.6-8 8-8H568c4.4 0 8 3.6 8 8s-3.6 8-8 8H440V184c0 4.4-3.6 8-8 8H296V328c0 4.4-3.6 8-8 8H152V472c0 4.4-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H136V328c0-4.4 3.6-8 8-8H280V184c0-4.4 3.6-8 8-8H424V40z'
      
    ]
  };

  

  
  

  var faToiletPaperUnderSlash = {
    prefix: 'fat',
    iconName: 'toilet-paper-under-slash',
    icon: [
      640,
      512,
      ["toilet-paper-reverse-slash"],
      'e2a1',
      
      'M528.1 512l-20.3-16H264c-13.3 0-24-10.7-24-24V416H224v56c0 22.1 17.9 40 40 40H528.1zM560 291.5v62.3l16 12.6V192c0-51.9-11.9-99.3-31.5-134C525 23.5 496.9 0 464 0H176c-16.1 0-31.1 5.6-44.5 15.5l13.1 10.4c10-6.5 20.6-9.8 31.3-9.8H418.8c-13.6 10.2-25.5 24.7-35.3 42c-19.3 34.2-31.1 80.6-31.5 131.6l16.2 12.8c-.1-3.4-.2-6.8-.2-10.3c0-49.7 11.4-94.3 29.4-126.2C415.6 33.7 439.4 16 464 16s48.4 17.7 66.6 49.8C548.6 97.7 560 142.3 560 192s-11.4 94.3-29.4 126.2c-1.6 2.9-3.3 5.7-5.1 8.3l12.6 9.9c2.2-3.3 4.3-6.8 6.4-10.4c5.9-10.4 11.1-22 15.5-34.6zM64 192c0 51.9 11.9 99.3 31.5 134c19.5 34.5 47.6 58 80.5 58H365.9l-20.3-16H176c-24.6 0-48.4-17.7-66.6-49.8C91.4 286.3 80 241.7 80 192c0-11.1 .6-21.9 1.7-32.4L66.9 147.9C65 162.1 64 176.9 64 192zm420.6 63c4.8-4.8 8.4-10.8 11.1-17.1c5.4-12.6 8.3-28.8 8.3-45.9s-2.9-33.3-8.3-45.9c-2.7-6.3-6.3-12.3-11.1-17.1c-4.9-4.8-11.9-9-20.6-9s-15.7 4.2-20.6 9c-4.8 4.8-8.4 10.8-11.1 17.1c-5.4 12.6-8.3 28.8-8.3 45.9s2.9 33.3 8.3 45.9c2.7 6.3 6.3 12.3 11.1 17.1c4.9 4.8 11.9 9 20.6 9s15.7-4.2 20.6-9zM464 248c-13.3 0-24-25.1-24-56s10.7-56 24-56s24 25.1 24 56s-10.7 56-24 56zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  
    var faToiletPaperReverseSlash = faToiletPaperUnderSlash;
  

  
  

  var faDrawSquare = {
    prefix: 'fat',
    iconName: 'draw-square',
    icon: [
      448,
      512,
      [],
      'f5ef',
      
      'M48 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm8 15.3V384.7C76.1 388 92 403.9 95.3 424H352.7c3.4-20.1 19.2-36 39.3-39.3V127.3c-20.1-3.4-36-19.2-39.3-39.3H95.3C92 108.1 76.1 124 56 127.3zM95.3 440c-3.8 22.7-23.6 40-47.3 40c-26.5 0-48-21.5-48-48c0-23.8 17.3-43.5 40-47.3V127.3C17.3 123.5 0 103.8 0 80C0 53.5 21.5 32 48 32c23.8 0 43.5 17.3 47.3 40H352.7c3.8-22.7 23.6-40 47.3-40c26.5 0 48 21.5 48 48c0 23.8-17.3 43.5-40 47.3V384.7c22.7 3.8 40 23.6 40 47.3c0 26.5-21.5 48-48 48c-23.8 0-43.5-17.3-47.3-40H95.3zM80 432a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm352 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faFilePlus = {
    prefix: 'fat',
    iconName: 'file-plus',
    icon: [
      384,
      512,
      [],
      'f319',
      
      'M16 448V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM192 240c-4.4 0-8 3.6-8 8v72H112c-4.4 0-8 3.6-8 8s3.6 8 8 8h72v72c0 4.4 3.6 8 8 8s8-3.6 8-8V336h72c4.4 0 8-3.6 8-8s-3.6-8-8-8H200V248c0-4.4-3.6-8-8-8z'
      
    ]
  };

  

  
  

  var faStamp = {
    prefix: 'fat',
    iconName: 'stamp',
    icon: [
      512,
      512,
      [],
      'f5bf',
      
      'M336 96c0 14.1-3.6 27.2-10 38.7c-9.6 17.4-22 39.8-22 65.1c0 48.7 39.5 88.2 88.2 88.2H400c53 0 96 43 96 96c0 8.8-7.2 16-16 16H32c-8.8 0-16-7.2-16-16c0-53 43-96 96-96h7.8c48.7 0 88.2-39.5 88.2-88.2c0-25.3-12.4-47.7-22-65.1c-6.3-11.5-10-24.6-10-38.7c0-44.2 35.8-80 80-80s80 35.8 80 80zM320 199.8c0-20.5 10.1-39.4 20-57.4c7.6-13.8 12-29.6 12-46.5c0-53-43-96-96-96s-96 43-96 96c0 16.9 4.3 32.7 12 46.5c9.9 18 20 36.8 20 57.4c0 39.9-32.3 72.2-72.2 72.2H112C50.1 272 0 322.1 0 384c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32c0-61.9-50.1-112-112-112h-7.8c-39.9 0-72.2-32.3-72.2-72.2zM48 456c0-4.4-3.6-8-8-8s-8 3.6-8 8v16c0 22.1 17.9 40 40 40H440c22.1 0 40-17.9 40-40V456c0-4.4-3.6-8-8-8s-8 3.6-8 8v16c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V456z'
      
    ]
  };

  

  
  

  var faSaltShaker = {
    prefix: 'fat',
    iconName: 'salt-shaker',
    icon: [
      384,
      512,
      [129474],
      'e446',
      
      'M368 453.2c0-2.5-.2-5-.7-7.5L319.2 176H64.8L16.7 445.7c-.4 2.5-.7 5-.7 7.5C16 476.8 35.2 496 58.8 496H325.2c23.6 0 42.8-19.2 42.8-42.8zM316.3 160l-8.4-46.9C297.9 56.9 249.1 16 192 16S86.1 56.9 76.1 113.1L67.7 160H316.3zm8.9 352H58.8C26.3 512 0 485.7 0 453.2c0-3.5 .3-6.9 .9-10.3L60.3 110.3C71.7 46.5 127.2 0 192 0s120.3 46.5 131.7 110.3l59.4 332.6c.6 3.4 .9 6.9 .9 10.3c0 32.5-26.3 58.8-58.8 58.8zM176 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM144 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM138.3 233L111.9 441c-.6 4.4-4.6 7.5-8.9 6.9s-7.5-4.6-6.9-8.9l26.4-208c.6-4.4 4.6-7.5 8.9-6.9s7.5 4.6 6.9 8.9zm123.2-2l26.4 208c.6 4.4-2.5 8.4-6.9 8.9s-8.4-2.5-8.9-6.9L245.7 233c-.6-4.4 2.5-8.4 6.9-8.9s8.4 2.5 8.9 6.9z'
      
    ]
  };

  

  
  

  var faChartMixedUpCircleDollar = {
    prefix: 'fat',
    iconName: 'chart-mixed-up-circle-dollar',
    icon: [
      576,
      512,
      [],
      'e5d9',
      
      'M416 8c0-4.4 3.6-8 8-8H536c4.4 0 8 3.6 8 8V120c0 4.4-3.6 8-8 8s-8-3.6-8-8V26.7L325.3 206c-3.2 2.8-8 2.7-11-.3l-123-123L12.9 222.3c-3.5 2.7-8.5 2.1-11.2-1.4s-2.1-8.5 1.4-11.2l184-144c3.2-2.5 7.7-2.2 10.6 .6L320.3 189 515.9 16H424c-4.4 0-8-3.6-8-8zM192 240c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16s16-7.2 16-16V256c0-8.8-7.2-16-16-16zm-32 16c0-17.7 14.3-32 32-32s32 14.3 32 32V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V256zM80 352c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V352zm-48 0c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352zM432 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm-28.2 93.9c-8 4.1-12.3 9.7-11.7 17.6c.4 5.2 3.6 9.5 11.5 13.5c7.9 4 18.3 6.8 30 10l1 .3c11.5 3.1 24.3 6.6 34.1 12.1c10.2 5.7 18.8 14.5 19.2 28.4c.5 16.4-8.9 27-20.4 33c-8.5 4.4-18.5 6.5-27.6 7.1v17.7c0 4.4-3.6 8-8 8s-8-3.6-8-8V439.4c-12.6-1.4-24.7-5.1-35.9-8.5l0 0c-2.1-.7-4.3-1.3-6.3-1.9c-4.2-1.3-6.7-5.7-5.4-9.9s5.7-6.7 9.9-5.4c2.3 .7 4.5 1.3 6.7 2l0 0 0 0c13.6 4.1 26.1 7.9 39.2 8.3c9.4 .3 20.1-1.4 28-5.5c7.6-3.9 12-9.6 11.7-18.3c-.2-6.2-3.6-10.7-11.1-14.9c-7.8-4.4-18.5-7.4-30.5-10.6l-1.8-.5c-11-2.9-22.9-6.1-32.3-11c-10.1-5.2-19.3-13.3-20.2-26.7c-1.1-16.5 8.9-27.1 20.4-32.9c8.5-4.3 18.5-6.5 27.4-7.3V280c0-4.4 3.6-8 8-8s8 3.6 8 8v16.4c10.2 .8 20.4 2.8 29.8 5c4.3 1 7 5.3 5.9 9.6s-5.3 7-9.6 5.9c-11.4-2.7-23.1-4.8-34.3-5c-8.8-.1-19.8 1.6-28.1 5.8z'
      
    ]
  };

  

  
  

  var faICursor = {
    prefix: 'fat',
    iconName: 'i-cursor',
    icon: [
      256,
      512,
      [],
      'f246',
      
      'M0 7.5c-.3 4.4 3 8.2 7.5 8.5l15.5 1C77.5 20.7 120 66 120 120.8V248H64c-4.4 0-8 3.6-8 8s3.6 8 8 8h56V391.2C120 446 77.5 491.3 22.9 495L7.5 496c-4.4 .3-7.7 4.1-7.5 8.5s4.1 7.7 8.5 7.5L24 511c47.9-3.2 87.7-34.2 104-76.6c16.4 42.4 56.1 73.4 104 76.6l15.5 1c4.4 .3 8.2-3 8.5-7.5s-3-8.2-7.5-8.5l-15.5-1c-54.6-3.6-97.1-49-97.1-103.8V264h56c4.4 0 8-3.6 8-8s-3.6-8-8-8H136V120.8C136 66 178.5 20.7 233.1 17l15.5-1c4.4-.3 7.7-4.1 7.5-8.5s-4.1-7.7-8.5-7.5L232 1c-47.9 3.2-87.7 34.2-104 76.6C111.6 35.2 71.9 4.2 24 1L8.5 0C4.1-.3 .3 3.1 0 7.5z'
      
    ]
  };

  

  
  

  var faSquareArrowUpLeft = {
    prefix: 'fat',
    iconName: 'square-arrow-up-left',
    icon: [
      448,
      512,
      [],
      'e263',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm280 64c4.4 0 8 3.6 8 8s-3.6 8-8 8H155.3L317.7 338.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L144 187.3V312c0 4.4-3.6 8-8 8s-8-3.6-8-8V168c0-4.4 3.6-8 8-8H280z'
      
    ]
  };

  

  
  

  var fa5 = {
    prefix: 'fat',
    iconName: '5',
    icon: [
      320,
      512,
      [],
      '35',
      
      'M48.2 38.1c.9-3.6 4.1-6.1 7.8-6.1H280c4.4 0 8 3.6 8 8s-3.6 8-8 8H62.2l-44 176H192c70.7 0 128 57.3 128 128s-57.3 128-128 128H95.7c-37.3 0-71.8-20-90.3-52.4L1.1 420c-2.2-3.8-.9-8.7 3-10.9s8.7-.9 10.9 3l4.4 7.6C35 447.1 64.1 464 95.7 464H192c61.9 0 112-50.1 112-112s-50.1-112-112-112H8c-2.5 0-4.8-1.1-6.3-3.1S-.4 232.4 .2 230.1l48-192z'
      
    ]
  };

  

  
  

  var faLandMineOn = {
    prefix: 'fat',
    iconName: 'land-mine-on',
    icon: [
      640,
      512,
      [],
      'e51b',
      
      'M320 0c4.4 0 8 3.6 8 8V184c0 4.4-3.6 8-8 8s-8-3.6-8-8V8c0-4.4 3.6-8 8-8zM192 384h0H159.2c-12.6 0-24.1 7.4-29.2 19L98.6 473.5c-4.7 10.6 3 22.5 14.6 22.5H526.8c11.6 0 19.3-11.9 14.6-22.5L510 403c-5.1-11.6-16.6-19-29.2-19H448h0H432 208 192zm16-16H432V320c0-8.8-7.2-16-16-16H224c-8.8 0-16 7.2-16 16v48zm240 0h0 16 16.8c19 0 36.2 11.2 43.9 28.5L556 467c9.4 21.2-6.1 45-29.2 45H113.2c-23.2 0-38.6-23.8-29.2-45l31.3-70.5c7.7-17.3 24.9-28.5 43.9-28.5H176h16V352 320c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32v32 16zM44.9 129.6l136 104c3.5 2.7 4.2 7.7 1.5 11.2s-7.7 4.2-11.2 1.5l-136-104c-3.5-2.7-4.2-7.7-1.5-11.2s7.7-4.2 11.2-1.5zm561.5 1.5c2.7 3.5 2 8.5-1.5 11.2l-136 104c-3.5 2.7-8.5 2-11.2-1.5s-2-8.5 1.5-11.2l136-104c3.5-2.7 8.5-2 11.2 1.5z'
      
    ]
  };

  

  
  

  var faTricycle = {
    prefix: 'fat',
    iconName: 'tricycle',
    icon: [
      512,
      512,
      [],
      'e5c3',
      
      'M264 32c-4.4 0-8 3.6-8 8s3.6 8 8 8h97.1C382.6 48 400 65.4 400 86.9c0 13-6.5 25.2-17.3 32.4L333.6 152H299.3c-59.1 0-114.5 26.1-152.2 70.2L94.9 144H120c4.4 0 8-3.6 8-8s-3.6-8-8-8H40c-4.4 0-8 3.6-8 8s3.6 8 8 8H75.7l61 91.5c-2.7 3.8-5.3 7.7-7.8 11.7l-5.8 9.4c-3.7-.4-7.4-.6-11.2-.6C50.1 256 0 306.1 0 368s50.1 112 112 112s112-50.1 112-112c0-52.1-35.6-96-83.9-108.4l2.5-4c33.5-54.4 92.8-87.6 156.7-87.6h30.5l15.5 62C293.5 246.4 256 294.8 256 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-7.9 0-15.7 .7-23.2 2.1l-15.6-62.6 46.4-30.9c15.3-10.2 24.4-27.3 24.4-45.7C416 56.6 391.4 32 361.1 32H264zm85.1 213.5l27.1 108.4c1.1 4.3 5.4 6.9 9.7 5.8s6.9-5.4 5.8-9.7L364.7 241.7c6.3-1.1 12.7-1.7 19.3-1.7c61.9 0 112 50.1 112 112s-50.1 112-112 112s-112-50.1-112-112c0-49.7 32.4-91.8 77.1-106.5zM112 272a96 96 0 1 1 0 192 96 96 0 1 1 0-192z'
      
    ]
  };

  

  
  

  var faFaceZany = {
    prefix: 'fat',
    iconName: 'face-zany',
    icon: [
      512,
      512,
      [],
      'e3a4',
      
      'M256 16C123.5 16 16 123.5 16 256c0 99.6 60.7 185 147.1 221.4c4.1 1.7 6 6.4 4.3 10.5s-6.4 6-10.5 4.3C64.7 453.4 0 362.3 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 106.3-64.7 197.4-156.9 236.1c-4.1 1.7-8.8-.2-10.5-4.3s.2-8.8 4.3-10.5C435.3 441 496 355.6 496 256C496 123.5 388.5 16 256 16zM184 409.9c0-23.2 18.8-41.9 41.9-41.9c11.1 0 21.8 4.4 29.7 12.3l.4 .4 .4-.4c7.9-7.9 18.5-12.3 29.7-12.3c23.2 0 41.9 18.8 41.9 41.9V440c0 39.8-32.2 72-72 72s-72-32.2-72-72V409.9zm64-14.6l-3.7-3.7c-4.9-4.9-11.5-7.6-18.3-7.6c-14.3 0-25.9 11.6-25.9 25.9V440c0 30.9 25.1 56 56 56s56-25.1 56-56V409.9c0-14.3-11.6-25.9-25.9-25.9c-6.9 0-13.5 2.7-18.3 7.6l-3.7 3.7V424c0 4.4-3.6 8-8 8s-8-3.6-8-8V395.3zM368 152c0-27.9-20.4-51-47.1-55.3C330.1 104 336 115.3 336 128c0 22.1-17.9 40-40 40c-18.3 0-33.7-12.3-38.5-29c-1 4.2-1.5 8.5-1.5 13c0 30.9 25.1 56 56 56s56-25.1 56-56zm-128 0a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zM128 272a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-112a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm192-32a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM112 224a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm289 35.6c4.5 14 7 28.9 7 44.4c0 43.8-19.6 83.1-50.5 109.5c-3.4 2.9-8.4 2.5-11.3-.9s-2.5-8.4 .9-11.3C374.6 377.8 392 343 392 304c0-13.8-2.2-27.1-6.2-39.5c-2.2-6.9-10.9-10.5-19.2-6.2L168.9 363.8c-8.2 4.4-10.1 13.6-5.5 19.4c.7 .9 1.5 1.9 2.3 2.8c2.8 3.4 2.4 8.4-1 11.3s-8.4 2.4-11.3-1c-.9-1-1.7-2.1-2.6-3.2c-11.9-15.1-4.6-35.3 10.6-43.4L359.1 244.2c15.2-8.1 36-2.9 41.9 15.3z'
      
    ]
  };

  

  
  

  var faSquareRss = {
    prefix: 'fat',
    iconName: 'square-rss',
    icon: [
      448,
      512,
      ["rss-square"],
      'f143',
      
      'M384 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm48 304a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM72 96c-4.4 0-8 3.6-8 8s3.6 8 8 8c163.5 0 296 132.5 296 296c0 4.4 3.6 8 8 8s8-3.6 8-8C384 235.7 244.3 96 72 96zm0 96c-4.4 0-8 3.6-8 8s3.6 8 8 8c110.5 0 200 89.5 200 200c0 4.4 3.6 8 8 8s8-3.6 8-8c0-119.3-96.7-216-216-216z'
      
    ]
  };

  
    var faRssSquare = faSquareRss;
  

  
  

  var faOctagonMinus = {
    prefix: 'fat',
    iconName: 'octagon-minus',
    icon: [
      512,
      512,
      ["minus-octagon"],
      'f308',
      
      'M191.5 16.1c-14.9 0-29.1 5.9-39.6 16.4L32.5 151.9C22 162.4 16.1 176.7 16.1 191.5v129c0 14.9 5.9 29.1 16.4 39.6L151.9 479.5c10.5 10.5 24.7 16.4 39.6 16.4h129c14.9 0 29.1-5.9 39.6-16.4L479.5 360.1c10.5-10.5 16.4-24.7 16.4-39.6v-129c0-14.9-5.9-29.1-16.4-39.6L360.1 32.5C349.6 22 335.3 16.1 320.5 16.1h-129zm-50.9 5.1C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM160 248H352c4.4 0 8 3.6 8 8s-3.6 8-8 8H160c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  
    var faMinusOctagon = faOctagonMinus;
  

  
  

  var faDiceFive = {
    prefix: 'fat',
    iconName: 'dice-five',
    icon: [
      448,
      512,
      [9860],
      'f523',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 208a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm112-64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faRoadCircleCheck = {
    prefix: 'fat',
    iconName: 'road-circle-check',
    icon: [
      640,
      512,
      [],
      'e564',
      
      'M217.4 32C194 32 173 46.6 164.9 68.6L40.4 404.6C26.9 441.1 54 480 93 480H360.2c-4.2-5.1-8.1-10.4-11.8-16H328V420.6c-2-6.5-3.7-13.2-5-20c-.9-.4-1.9-.6-3-.6c-4.4 0-8 3.6-8 8v56H93c-27.9 0-47.2-27.8-37.5-53.9l124.4-336C185.7 58.4 200.7 48 217.4 48H312v56c0 4.4 3.6 8 8 8s8-3.6 8-8V48h94.6c16.7 0 31.7 10.4 37.5 26.1l43.7 118.1c6 .3 11.9 .8 17.7 1.7L475.1 68.6C467 46.6 446 32 422.6 32H217.4zM328 200c0-4.4-3.6-8-8-8s-8 3.6-8 8V312c0 4.4 3.6 8 8 8s8-3.6 8-8V200zm168 40a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm69.7-189.7c-3.1-3.1-8.2-3.1-11.3 0L480 396.7l-42.3-42.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l48 48c3.1 3.1 8.2 3.1 11.3 0l80-80c3.1-3.1 3.1-8.2 0-11.3z'
      
    ]
  };

  

  
  

  var faFaceRelieved = {
    prefix: 'fat',
    iconName: 'face-relieved',
    icon: [
      512,
      512,
      [],
      'e389',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM181.7 370.3c14.3 14.3 39 29.7 74.3 29.7s60.1-15.4 74.3-29.7c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3C325 398.3 296.4 416 256 416s-69-17.7-85.7-34.3c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0zm170-98.3c14.6 0 30.2-8.6 41-27.9c2.2-3.9 7-5.2 10.9-3.1s5.2 7 3.1 10.9c-13.1 23.4-33.6 36.1-55 36.1s-41.8-12.7-55-36.1c-2.2-3.9-.8-8.7 3.1-10.9s8.7-.8 10.9 3.1c10.9 19.3 26.4 27.9 41 27.9zm-233-27.9c10.9 19.3 26.4 27.9 41 27.9s30.2-8.6 41-27.9c2.2-3.9 7-5.2 10.9-3.1s5.2 7 3.1 10.9c-13.1 23.4-33.6 36.1-55 36.1s-41.8-12.7-55-36.1c-2.2-3.9-.8-8.7 3.1-10.9s8.7-.8 10.9 3.1zm81-150.6c1.4 4.2-.9 8.7-5.1 10.1l-6.3 2.1c-25.3 8.4-47.1 25.1-61.9 47.3l-7.6 11.5c-2.5 3.7-7.4 4.7-11.1 2.2s-4.7-7.4-2.2-11.1l7.6-11.5c16.8-25.2 41.5-44 70.2-53.6l6.3-2.1c4.2-1.4 8.7 .9 10.1 5.1zm117.9 10.1c-4.2-1.4-6.5-5.9-5.1-10.1s5.9-6.5 10.1-5.1l6.3 2.1c28.7 9.6 53.4 28.4 70.2 53.6l7.6 11.5c2.5 3.7 1.5 8.6-2.2 11.1s-8.6 1.5-11.1-2.2L385.7 153c-14.8-22.2-36.6-38.8-61.9-47.3l-6.3-2.1z'
      
    ]
  };

  

  
  

  var faEclipse = {
    prefix: 'fat',
    iconName: 'eclipse',
    icon: [
      640,
      512,
      [],
      'f749',
      
      'M165.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L121 121 13.1 140.8c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L65.1 256 2.8 346.3c-3.1 4.5-3.7 10.2-1.6 15.2s6.6 8.6 11.9 9.6L121 391l19.8 107.9c1 5.3 4.6 9.8 9.6 11.9l3.1-7.4-3.1 7.4c5 2.1 10.7 1.5 15.2-1.6L256 446.9l90.3 62.3c4.5 3.1 10.2 3.7 15.2 1.6s8.6-6.6 9.6-11.9l9.6-52.2c-5.1-2.2-10.1-4.6-14.9-7.3L355.4 496l-94.9-65.4c-2.7-1.9-6.3-1.9-9.1 0L156.6 496 135.8 382.7c-.6-3.3-3.2-5.8-6.4-6.4L16 355.4l65.4-94.9c1.9-2.7 1.9-6.3 0-9.1L16 156.6l113.3-20.8c3.3-.6 5.8-3.2 6.4-6.4L156.6 16l94.9 65.4c2.7 1.9 6.3 1.9 9.1 0L355.4 16l10.4 56.6c4.9-2.6 9.8-5 14.9-7.3l-9.6-52.2c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L256 65.1 165.7 2.8zM256 144c-61.9 0-112 50.1-112 112s50.1 112 112 112c10.4 0 20.5-1.4 30.1-4.1c-2.9-4.7-5.5-9.5-8-14.5c-7.1 1.7-14.5 2.6-22.1 2.6c-53 0-96-43-96-96s43-96 96-96c7.6 0 15 .9 22.1 2.6c2.5-4.9 5.2-9.8 8-14.5c-9.6-2.7-19.7-4.1-30.1-4.1zm48 112a160 160 0 1 1 320 0 160 160 0 1 1 -320 0zm336 0a176 176 0 1 0 -352 0 176 176 0 1 0 352 0z'
      
    ]
  };

  

  
  

  var faAlarmClock = {
    prefix: 'fat',
    iconName: 'alarm-clock',
    icon: [
      512,
      512,
      [9200],
      'f34e',
      
      'M93.7 0C42 0 0 42 0 93.7c0 18.5 5.4 35.8 14.6 50.3c2.4 3.7 7.3 4.8 11 2.4s4.8-7.3 2.4-11C20.4 123.4 16 109.1 16 93.7C16 50.8 50.8 16 93.7 16c20.4 0 39 7.9 52.8 20.7c3.2 3 8.3 2.8 11.3-.4s2.8-8.3-.4-11.3C140.7 9.5 118.3 0 93.7 0zM45.7 509.7l57.7-57.7C143.4 489.2 197 512 256 512s112.6-22.8 152.6-60.1l57.7 57.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-57.7-57.7C457.2 400.6 480 347 480 288C480 164.3 379.7 64 256 64S32 164.3 32 288c0 59 22.8 112.6 60.1 152.6L34.3 498.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0zM256 80a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm8 88c0-4.4-3.6-8-8-8s-8 3.6-8 8V304c0 2.4 1.1 4.7 3 6.2l80 64c3.4 2.8 8.5 2.2 11.2-1.2s2.2-8.5-1.2-11.2l-77-61.6V168zM354.6 25c-3.2 3-3.4 8.1-.4 11.3s8.1 3.4 11.3 .4C379.3 23.9 397.9 16 418.3 16C461.2 16 496 50.8 496 93.7c0 15.4-4.4 29.7-12.1 41.7c-2.4 3.7-1.3 8.7 2.4 11s8.7 1.3 11-2.4c9.3-14.5 14.6-31.8 14.6-50.3C512 42 470 0 418.3 0c-24.6 0-47 9.5-63.7 25z'
      
    ]
  };

  

  
  

  var faEarDeaf = {
    prefix: 'fat',
    iconName: 'ear-deaf',
    icon: [
      512,
      512,
      ["deaf","deafness","hard-of-hearing"],
      'f2a4',
      
      'M509.7 13.7l-80 80c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l80-80c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3zm-320 320l-176 176c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l176-176c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3zM240 80C151.6 80 80 150.9 80 238.2c0 4.4-3.6 8-8 8s-8-3.6-8-8C64 141.9 142.9 64 240 64s176 77.9 176 174.2c0 51-22.2 96.8-57.4 128.7c-6.1 5.6-9.8 12.9-9.8 20.4V392c0 66.3-53.7 120-120 120H206.4c-4.4 0-8-3.6-8-8s3.6-8 8-8h22.4c57.4 0 104-46.6 104-104v-4.8c0-12.8 6.2-24.2 15.1-32.2C379.9 326 400 284.4 400 238.2C400 150.9 328.4 80 240 80zm0 64c-53 0-96 43-96 96c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-61.9 50.1-112 112-112s112 50.1 112 112c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-53-43-96-96-96z'
      
    ]
  };

  
    var faDeaf = faEarDeaf;
  
    var faDeafness = faEarDeaf;
  
    var faHardOfHearing = faEarDeaf;
  

  
  

  var faClockThreeThirty = {
    prefix: 'fat',
    iconName: 'clock-three-thirty',
    icon: [
      512,
      512,
      [],
      'e357',
      
      'M16 256a240 240 0 1 0 480 0A240 240 0 1 0 16 256zm496 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM248 408V256c0-4.4 3.6-8 8-8H376c4.4 0 8 3.6 8 8s-3.6 8-8 8H264V408c0 4.4-3.6 8-8 8s-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faFaceGrinWink = {
    prefix: 'fat',
    iconName: 'face-grin-wink',
    icon: [
      512,
      512,
      ["grin-wink"],
      'f58c',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256.3 91.8c-43 0-84.1-5.5-121.5-15.4c-3.9-1-7.1 .3-8.7 1.8c-.7 .7-.9 1.2-.9 1.4l0 0c0 .1-.1 .7 .5 1.9c25 46.8 74.1 78.5 130.5 78.5s105.5-31.7 130.5-78.5c.7-1.2 .6-1.8 .5-1.9l0 0c0-.2-.2-.7-.9-1.4c-1.6-1.5-4.8-2.8-8.7-1.8c-37.4 9.9-78.4 15.4-121.5 15.4zm144.6-2.7C373.2 396.8 318.8 432 256.3 432s-116.9-35.2-144.6-86.9c-9.1-17 8.7-33.1 27.3-28.2c36 9.6 75.6 14.9 117.3 14.9s81.4-5.3 117.3-14.9c18.6-4.9 36.4 11.2 27.3 28.2zM160.4 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm134.2 19.9c-2.2 3.9-7 5.2-10.9 3.1s-5.2-7-3.1-10.9c13.1-23.4 33.6-36.1 55-36.1s41.8 12.7 55 36.1c2.2 3.9 .8 8.7-3.1 10.9s-8.7 .8-10.9-3.1c-10.9-19.3-26.4-27.9-41-27.9s-30.2 8.6-41 27.9z'
      
    ]
  };

  
    var faGrinWink = faFaceGrinWink;
  

  
  

  var faHatWitch = {
    prefix: 'fat',
    iconName: 'hat-witch',
    icon: [
      576,
      512,
      [],
      'f6e7',
      
      'M96 384h17.5l83.1-189.9c15.5-35.5 42.3-64.8 76.2-83.6L442 17.2c1.4-.8 2.9-1.2 4.5-1.2c2.3 0 4.4 .8 6.1 2.3l105.1 91 10.5-12.1-10.5 12.1c1.4 1.2 2.3 3.1 2.3 5c0 1.1-.3 2.2-.8 3.1l-46 85.5-11.9-31.6c-6.2-16.4-21.8-27.3-39.4-27.3c-14.1 0-27.2 7-35 18.7l-13.8 20.7c-8.6 12.8-13.1 27.9-13.1 43.3c0 10.9 2.3 21.7 6.7 31.7L462.5 384H480L421.4 252c-3.5-7.9-5.4-16.5-5.4-25.2c0-12.3 3.6-24.3 10.4-34.5l13.8-20.7c4.8-7.2 13-11.6 21.7-11.6c10.9 0 20.6 6.7 24.4 16.9L501 216c1.8 4.8 6.4 8 11.6 8c4.6 0 8.8-2.5 10.9-6.5L573.3 125c1.8-3.3 2.7-7 2.7-10.7c0-6.5-2.8-12.8-7.8-17.1L463.2 6.2c-4.6-4-10.5-6.2-16.6-6.2c-4.3 0-8.5 1.1-12.3 3.2L265 96.5c-37 20.4-66.2 52.4-83.2 91.2L96 384zm457.4 48c3.7 0 6.6 3 6.6 6.6c0 1.9-.7 2.9-1.3 3.4c-17.9 15.2-70.9 54-142.7 54H160c-71.8 0-124.8-38.8-142.7-54c-.6-.5-1.3-1.6-1.3-3.4c0-3.7 3-6.6 6.6-6.6H553.4zM22.6 416C10.1 416 0 426.1 0 438.6c0 6 2.4 11.7 6.9 15.6C25.9 470.3 82.6 512 160 512H416c77.4 0 134.1-41.7 153.1-57.8c4.6-3.9 6.9-9.6 6.9-15.6c0-12.5-10.1-22.6-22.6-22.6H22.6zM304 336c17.7 0 32 14.3 32 32v16h16V368c0-26.5-21.5-48-48-48H272c-26.5 0-48 21.5-48 48v16h16V368c0-17.7 14.3-32 32-32h32z'
      
    ]
  };

  

  
  

  var faCoffeeBeans = {
    prefix: 'fat',
    iconName: 'coffee-beans',
    icon: [
      512,
      512,
      [],
      'e13f',
      
      'M442.4 203.7c9.3 11 18.1 27 25.5 42.6c-41.6 39.9-120.8 34-178.5-23.7C240.7 174 228.9 110.2 250.2 66.4c6.6 12.9 14.2 25.7 22.5 35.5c26.4 31.1 58 42.5 87.7 53.1l.5 .2c30 10.7 58 20.9 81.4 48.5zm4.2-138.4c53 53 62.3 124.2 32.6 167.6c-7-14.2-15.4-28.8-24.6-39.6c-26.4-31.1-58-42.5-87.7-53.1l-.5-.2c-30-10.7-58-20.9-81.4-48.5c-9-10.6-17.6-26-24.8-41.1c2.1-2.7 4.3-5.2 6.7-7.6C308.1 1.7 388.3 7 446.6 65.4zm33.8 191.1C530.1 206.8 520.1 116.1 458 54S305.2-18.1 255.6 31.6S215.9 171.9 278 234s152.7 72.2 202.4 22.5zM128 496C69.3 496 16 435 16 352c0-72.7 40.8-128.4 90.4-141.2c-5 14.8-9.2 30.7-10.3 44.6c-3.4 40.7 11 71.1 24.5 99.6l.2 .5c13.6 28.8 26.3 55.8 23.3 91.9c-1.2 14.5-6.4 32.2-12.3 48.6c-1.2 .1-2.5 .1-3.8 .1zm32-47.3c3.4-40.7-11-71.1-24.5-99.6l-.2-.5c-13.6-28.8-26.3-55.8-23.3-91.9c1.2-14.5 6.4-32.2 12.3-48.6c1.2-.1 2.5-.1 3.8-.1c58.7 0 112 61 112 144c0 72.7-40.8 128.4-90.4 141.2c5-14.8 9.2-30.7 10.3-44.6zM128 512c70.7 0 128-71.6 128-160s-57.3-160-128-160S0 263.6 0 352s57.3 160 128 160z'
      
    ]
  };

  

  
  

  var faMessageSms = {
    prefix: 'fat',
    iconName: 'message-sms',
    icon: [
      512,
      512,
      [],
      'e1e5',
      
      'M176 416c0-8.8-7.2-16-16-16H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H309.3c-3.5 0-6.8 1.1-9.6 3.2L176 496V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h80 16v16 64c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm40 180.8c0 9.6 4.8 18.7 12.8 24l29.4 19.6c3.6 2.4 5.7 6.4 5.7 10.7c0 7.1-5.8 12.8-12.8 12.8H112c-4.4 0-8 3.6-8 8s3.6 8 8 8h27.2c15.9 0 28.8-12.9 28.8-28.8c0-9.6-4.8-18.7-12.8-24l-29.4-19.6c-3.6-2.4-5.7-6.4-5.7-10.7c0-7.1 5.8-12.8 12.8-12.8H152c4.4 0 8-3.6 8-8s-3.6-8-8-8H132.8c-15.9 0-28.8 12.9-28.8 28.8zM372.8 152c-15.9 0-28.8 12.9-28.8 28.8c0 9.6 4.8 18.7 12.8 24l29.4 19.6c3.6 2.4 5.7 6.4 5.7 10.7c0 7.1-5.8 12.8-12.8 12.8H352c-4.4 0-8 3.6-8 8s3.6 8 8 8h27.2c15.9 0 28.8-12.9 28.8-28.8c0-9.6-4.8-18.7-12.8-24l-29.4-19.6c-3.6-2.4-5.7-6.4-5.7-10.7c0-7.1 5.8-12.8 12.8-12.8H392c4.4 0 8-3.6 8-8s-3.6-8-8-8H372.8zm-158.4 3.2c-2.1-2.8-5.7-3.9-8.9-2.8s-5.5 4.1-5.5 7.6v96c0 4.4 3.6 8 8 8s8-3.6 8-8V184l33.6 44.8c1.5 2 3.9 3.2 6.4 3.2s4.9-1.2 6.4-3.2L296 184v72c0 4.4 3.6 8 8 8s8-3.6 8-8V160c0-3.4-2.2-6.5-5.5-7.6s-6.9 0-8.9 2.8L256 210.7l-41.6-55.5z'
      
    ]
  };

  

  
  

  var faChessBishop = {
    prefix: 'fat',
    iconName: 'chess-bishop',
    icon: [
      320,
      512,
      [9821],
      'f43a',
      
      'M124 16c-11 0-20 9-20 20c0 8.5 5.2 15.7 12.7 18.6c2.5 1 4.3 3.2 4.9 5.8s-.2 5.4-2.1 7.3C95 92.5 69 125.4 49.2 159.9C29.2 194.5 16 229.9 16 259.9c0 30.6 11.9 74.5 52.4 100.9c2.3 1.5 3.6 4 3.6 6.7V384H56V371.7C12.4 341.2 0 293 0 259.9c0-34.1 14.8-72.4 35.3-108C54 119.4 77.9 88.4 101 63.7c-8-6.6-13-16.6-13-27.7c0-19.9 16.1-36 36-36h72c19.9 0 36 16.1 36 36c0 11.2-5.1 21.1-13 27.7c23.2 24.6 47.1 55.6 65.8 88.1c20.5 35.6 35.3 73.9 35.3 108c0 33.1-12.4 81.3-56 111.8V384H248V367.5c0-2.7 1.4-5.2 3.6-6.7c40.5-26.4 52.4-70.2 52.4-100.9c0-24.6-8.9-52.9-23.1-81.4L173.7 285.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L273 163.7c-.7-1.3-1.4-2.5-2.2-3.8C251 125.4 225 92.5 200.5 67.7c-1.9-1.9-2.7-4.6-2.1-7.3s2.4-4.8 4.9-5.8C210.8 51.7 216 44.5 216 36c0-11-9-20-20-20H124zM62.3 432c-4.5 0-8.9 1.9-11.9 5.3L19.8 471.2c-2.5 2.7-3.8 6.3-3.8 9.9c0 8.2 6.6 14.8 14.8 14.8H289.2c8.2 0 14.8-6.6 14.8-14.8c0-3.7-1.4-7.2-3.8-9.9l-30.6-33.9c-3-3.4-7.4-5.3-11.9-5.3H62.3zm249.8 28.5c5.1 5.7 7.9 13 7.9 20.6c0 17-13.8 30.8-30.8 30.8H30.8C13.8 512 0 498.2 0 481.2c0-7.6 2.8-15 7.9-20.6l30.6-33.9c6.1-6.7 14.7-10.6 23.8-10.6H257.7c9.1 0 17.7 3.8 23.8 10.6l30.6 33.9z'
      
    ]
  };

  

  
  

  var faSealExclamation = {
    prefix: 'fat',
    iconName: 'seal-exclamation',
    icon: [
      512,
      512,
      [],
      'e242',
      
      'M75.3 187.3c3-3 4.7-7.1 4.7-11.3l0-64c0-17.7 14.3-32 32-32l64 0c4.2 0 8.3-1.7 11.3-4.7L240 22.6c4.2-4.2 10-6.6 16-6.6s11.8 2.4 16 6.6l52.7 52.7c3 3 7.1 4.7 11.3 4.7l64 0c17.7 0 32 14.3 32 32l0 64c0 4.2 1.7 8.3 4.7 11.3L489.4 240c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16l-52.7 52.7c-3 3-4.7 7.1-4.7 11.3l0 64c0 17.7-14.3 32-32 32l-64 0c-4.2 0-8.3 1.7-11.3 4.7L272 489.4c-4.2 4.2-10 6.6-16 6.6s-11.8-2.4-16-6.6l-52.7-52.7c-3-3-7.1-4.7-11.3-4.7l-64 0c-17.7 0-32-14.3-32-32l0-64c0-4.2-1.7-8.3-4.7-11.3L22.6 272c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16l52.7-52.7zM64 112l0 64L11.3 228.7C4.1 235.9 0 245.8 0 256s4.1 20.1 11.3 27.3L64 336l0 64c0 26.5 21.5 48 48 48l64 0 52.7 52.7c7.2 7.2 17.1 11.3 27.3 11.3s20.1-4.1 27.3-11.3L336 448l64 0c26.5 0 48-21.5 48-48l0-64 52.7-52.7c7.2-7.2 11.3-17.1 11.3-27.3s-4.1-20.1-11.3-27.3L448 176l0-64c0-26.5-21.5-48-48-48l-64 0L283.3 11.3C276.1 4.1 266.2 0 256 0s-20.1 4.1-27.3 11.3L176 64l-64 0c-26.5 0-48 21.5-48 48zm192 16c-4.4 0-8 3.6-8 8l0 160c0 4.4 3.6 8 8 8s8-3.6 8-8l0-160c0-4.4-3.6-8-8-8zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faGrateDroplet = {
    prefix: 'fat',
    iconName: 'grate-droplet',
    icon: [
      576,
      512,
      [],
      'e194',
      
      'M64 48H384c26.5 0 48 21.5 48 48v73.5c4.9-3.2 10.3-5.7 16-7.3V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H344.2c-3.4-5.1-6.5-10.5-9.3-16H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48zm320 72c0-13.3-10.7-24-24-24H296 224 152 88c-13.3 0-24 10.7-24 24V256 392c0 13.3 10.7 24 24 24h64 72 72 24.9c-.6-5.3-.9-10.6-.9-16H304V264h64v10l16-30V120zM80 120c0-4.4 3.6-8 8-8h56V248H80V120zm80 128V112h56V248H160zm72 0V112h56V248H232zm72 0V112h56c4.4 0 8 3.6 8 8V248H304zm-16 16V400H232V264h56zm-72 0V400H160V264h56zm-72 0V400H88c-4.4 0-8-3.6-8-8V264h64zM352 400c0 61.9 50.1 112 112 112s112-50.1 112-112c0-18.4-4.5-36.5-13.2-52.7L487.5 206.1c-4.6-8.7-13.7-14.1-23.5-14.1s-18.9 5.4-23.5 14.1L365.2 347.3C356.5 363.5 352 381.6 352 400zm27.3-45.2l75.3-141.2c1.9-3.5 5.5-5.6 9.4-5.6s7.6 2.2 9.4 5.6l75.3 141.2c7.4 13.9 11.3 29.4 11.3 45.2c0 53-43 96-96 96s-96-43-96-96c0-15.8 3.9-31.3 11.3-45.2z'
      
    ]
  };

  

  
  

  var faVideoArrowUpRight = {
    prefix: 'fat',
    iconName: 'video-arrow-up-right',
    icon: [
      576,
      512,
      [],
      'e2c9',
      
      'M320 80c26.5 0 48 21.5 48 48v74.9V309.1 384c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V128c0-26.5 21.5-48 48-48H320zm64 304V336.8 309.1 202.9 175.2 128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64zm32-29.6l103.4 56.9c5.6 3.1 12 4.7 18.4 4.7c21.1 0 38.2-17.1 38.2-38.2V134.2c0-21.1-17.1-38.2-38.2-38.2c-6.4 0-12.8 1.6-18.4 4.7L416 157.6v18.3l111.1-61.1c3.3-1.8 7-2.7 10.7-2.7c12.3 0 22.2 9.9 22.2 22.2V377.8c0 12.3-9.9 22.2-22.2 22.2c-3.7 0-7.4-.9-10.7-2.7L416 336.1v18.3zM152 160c-4.4 0-8 3.6-8 8s3.6 8 8 8H260.7L98.3 338.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L272 187.3V296c0 4.4 3.6 8 8 8s8-3.6 8-8V168c0-4.4-3.6-8-8-8H152z'
      
    ]
  };

  

  
  

  var faAcorn = {
    prefix: 'fat',
    iconName: 'acorn',
    icon: [
      448,
      512,
      [],
      'f6ae',
      
      'M261.7 13.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L241 11.7C226.9 25.8 218.2 44.3 216.4 64H96C43 64 0 107 0 160v16c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V160c0-53-43-96-96-96H232.5c1.8-15.4 8.7-29.9 19.8-41l9.4-9.4zM352 80c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16H32c-8.8 0-16-7.2-16-16V160c0-44.2 35.8-80 80-80H352zM48.4 240c4.1 78.1 39 189.3 165.5 236.4c6.5 2.4 13.7 2.4 20.2 0C360.6 429.3 395.5 318.1 399.6 240h-16c-4 74.5-37.4 177.6-155.1 221.4c-2.9 1.1-6.1 1.1-9 0C101.8 417.5 68.5 314.5 64.4 240h-16z'
      
    ]
  };

  

  
  

  var faFlute = {
    prefix: 'fat',
    iconName: 'flute',
    icon: [
      640,
      512,
      [],
      'f8b9',
      
      'M128 336H576c26.5 0 48-21.5 48-48V224c0-26.5-21.5-48-48-48H128V336zm-16 0V176H64c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h48zM64 160h48 8 8H576c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H128h-8-8H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64zm272 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm112 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faRaygun = {
    prefix: 'fat',
    iconName: 'raygun',
    icon: [
      576,
      512,
      [],
      'e025',
      
      'M51.6 1.3c2.3-1.5 5.1-1.7 7.6-.6L201.7 64H280c22.6 0 42.8 10.4 56 26.7V48c0-4.4 3.6-8 8-8s8 3.6 8 8v88 32h48V80c0-4.4 3.6-8 8-8s8 3.6 8 8v88h48V152c0-3.2 1.9-6.1 4.9-7.4l96-40c2.5-1 5.3-.8 7.5 .7s3.6 4 3.6 6.7V240c0 2.7-1.3 5.2-3.6 6.7s-5 1.8-7.5 .7l-96-40c-3-1.2-4.9-4.2-4.9-7.4V184H416v88c0 4.4-3.6 8-8 8s-8-3.6-8-8V184H352v32 88c0 4.4-3.6 8-8 8s-8-3.6-8-8V261.3c-13.2 16.3-33.4 26.7-56 26.7h-4.2L172.6 494.3c-7.9 15.8-27.1 22.2-42.9 14.3l-80-40c-15.8-7.9-22.2-27.1-14.3-42.9l69-137.9C46.1 283.8 0 235.3 0 176c0-38.1 19-71.7 48-91.9V8c0-2.7 1.4-5.2 3.6-6.7zM480 176v18.7L560 228V124l-80 33.3V176zM200.2 80h-.4H112c-53 0-96 43-96 96s43 96 96 96H280c30.9 0 56-25.1 56-56V176 136c0-30.9-25.1-56-56-56H200.2zM64 20.3V74.8C78.5 67.9 94.8 64 112 64h50.3L64 20.3zM122.1 288L49.7 432.8c-4 7.9-.7 17.5 7.2 21.5l80 40c7.9 4 17.5 .7 21.5-7.2L257.9 288H122.1zM112 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faSkeletonRibs = {
    prefix: 'fat',
    iconName: 'skeleton-ribs',
    icon: [
      640,
      512,
      [],
      'e5cb',
      
      'M328 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H267.3c-39.3 0-75.6 22.2-91.5 58.6c-15.4 35.3-35.4 84.3-51.4 135.5C108.4 309.2 96 363.1 96 408v10.8c0 33.8 27.4 61.2 61.2 61.2c8.2 0 16.2-1.6 23.8-4.8l117.3-49.4c4.4-1.9 9.1-3.1 13.7-3.8v82c0 4.4 3.6 8 8 8s8-3.6 8-8V422c4.7 .7 9.3 1.9 13.7 3.8L459 475.2c7.5 3.2 15.6 4.8 23.8 4.8c33.8 0 61.2-27.4 61.2-61.2V408c0-44.9-12.4-98.8-28.4-149.8c-16.1-51.2-36-100.2-51.4-135.5C448.3 86.2 412 64 372.7 64H328V8zM312 80v89.9L157 212.2c11.5-31.3 23.4-60.1 33.5-83.1c13.2-30.2 43.5-49 76.9-49H312zM150.4 230.5L312 186.5v95.6L119.3 341.4c5-25.5 12.1-52.2 20.3-78.4c3.4-10.9 7-21.8 10.7-32.4zM116.2 359.1L312 298.8V405.9c-6.8 .8-13.5 2.5-19.9 5.2L174.8 460.5c-5.6 2.3-11.5 3.5-17.6 3.5c-25 0-45.2-20.3-45.2-45.2V408c0-15.2 1.5-31.7 4.2-48.9zM328 405.9V298.8l195.8 60.2c2.7 17.2 4.2 33.7 4.2 48.9v10.8c0 25-20.3 45.2-45.2 45.2c-6 0-12-1.2-17.6-3.5L347.9 411.1c-6.4-2.7-13.1-4.4-19.9-5.2zm192.7-64.5L328 282.1V186.5l161.6 44.1c3.7 10.6 7.3 21.5 10.7 32.4c8.2 26.3 15.4 52.9 20.3 78.4zM483 212.2L328 169.9V80h44.7c33.4 0 63.6 18.8 76.9 49c10.1 23 22 51.8 33.5 83.1zM0 124V232 504c0 4.4 3.6 8 8 8s8-3.6 8-8V232c0-11.5 6.7-22 17.1-26.8l51-23.6c21.8-10.1 35.8-31.9 35.8-56V124c0-33.1-26.9-60-60-60S0 90.9 0 124zm16 73.4V124c0-24.3 19.7-44 44-44s44 19.7 44 44v1.7c0 17.8-10.4 34-26.5 41.5l-51 23.6c-3.8 1.8-7.3 4-10.4 6.7zM580 64c-33.1 0-60 26.9-60 60v1.7c0 24.1 14 45.9 35.8 56l51 23.6C617.3 210 624 220.5 624 232V504c0 4.4 3.6 8 8 8s8-3.6 8-8V232 124c0-33.1-26.9-60-60-60zm33.6 126.7l-51-23.6c-16.2-7.5-26.5-23.6-26.5-41.5V124c0-24.3 19.7-44 44-44s44 19.7 44 44v73.4c-3.1-2.7-6.6-4.9-10.4-6.7z'
      
    ]
  };

  

  
  

  var faThoughtBubble = {
    prefix: 'fat',
    iconName: 'thought-bubble',
    icon: [
      512,
      512,
      [],
      'e32e',
      
      'M137.2 80.3C156.1 33.3 202.1 0 256 0s99.9 33.3 118.8 80.3c3-.2 6.1-.3 9.2-.3c70.7 0 128 57.3 128 128s-57.3 128-128 128c-12.9 0-25.3-1.9-37.1-5.5C329.2 362.4 295.1 384 256 384s-73.2-21.6-90.9-53.5c-11.7 3.6-24.2 5.5-37.1 5.5C57.3 336 0 278.7 0 208S57.3 80 128 80c3.1 0 6.1 .1 9.2 .3zM256 16c-49.1 0-90.8 31.5-105.9 75.5c-1.2 3.6-4.8 5.8-8.5 5.3c-4.4-.5-9-.8-13.6-.8C66.1 96 16 146.1 16 208s50.1 112 112 112c13.5 0 26.4-2.4 38.3-6.7c3.9-1.4 8.2 .4 10 4.1C190.4 347.3 220.8 368 256 368s65.6-20.7 79.7-50.6c1.8-3.7 6.1-5.5 10-4.1c11.9 4.4 24.9 6.7 38.3 6.7c61.9 0 112-50.1 112-112s-50.1-112-112-112c-4.6 0-9.1 .3-13.6 .8c-3.7 .5-7.3-1.8-8.5-5.3C346.8 47.5 305.1 16 256 16zM32 496a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm144-16a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  

  
  

  var faUpToDottedLine = {
    prefix: 'fat',
    iconName: 'up-to-dotted-line',
    icon: [
      448,
      512,
      [],
      'e457',
      
      'M216 147.3c2.1-2.1 5-3.3 8-3.3s5.9 1.2 8 3.3L363.8 279.4c2.7 2.7 4.2 6.4 4.2 10.2c0 8-6.5 14.4-14.4 14.4L280 304c-4.4 0-8 3.6-8 8l0 136c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-136c0-4.4-3.6-8-8-8l-73.6 0c-8 0-14.4-6.5-14.4-14.4c0-3.8 1.5-7.5 4.2-10.2L216 147.3zm8-19.3c-7.2 0-14.2 2.9-19.3 8L72.9 268.1c-5.7 5.7-8.9 13.4-8.9 21.5C64 306.4 77.6 320 94.4 320l65.6 0 0 128c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-128 65.6 0c16.8 0 30.4-13.6 30.4-30.4c0-8.1-3.2-15.8-8.9-21.5L243.3 136c-5.1-5.1-12.1-8-19.3-8zm0-92.4a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm192 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-384 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm272 16a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm-192 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z'
      
    ]
  };

  

  
  

  var faFaceGrinTongue = {
    prefix: 'fat',
    iconName: 'face-grin-tongue',
    icon: [
      512,
      512,
      [128539,"grin-tongue"],
      'f589',
      
      'M256 16C123.5 16 16 123.5 16 256c0 99.6 60.7 185 147.1 221.4c4.1 1.7 6 6.4 4.3 10.5s-6.4 6-10.5 4.3C64.7 453.4 0 362.3 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 106.3-64.7 197.4-156.9 236.1c-4.1 1.7-8.8-.2-10.5-4.3s.2-8.8 4.3-10.5C435.3 441 496 355.6 496 256C496 123.5 388.5 16 256 16zM160.4 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM184 409.9c0-23.2 18.8-41.9 41.9-41.9c11.1 0 21.8 4.4 29.7 12.3l.4 .4 .4-.4c7.9-7.9 18.5-12.3 29.7-12.3c23.2 0 41.9 18.8 41.9 41.9V440c0 39.8-32.2 72-72 72s-72-32.2-72-72V409.9zm64-14.6l-3.7-3.7c-4.9-4.9-11.5-7.6-18.3-7.6c-14.3 0-25.9 11.6-25.9 25.9V440c0 30.9 25.1 56 56 56s56-25.1 56-56V409.9c0-14.3-11.6-25.9-25.9-25.9c-6.9 0-13.5 2.7-18.3 7.6l-3.7 3.7V424c0 4.4-3.6 8-8 8s-8-3.6-8-8V395.3zM336.4 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM149.4 321c32.6 8.1 68.6 12.6 106.6 12.6s74-4.5 106.6-12.6c11.1-2.8 22.3 .3 29.6 6.9c3.7 3.4 6.5 7.8 7.5 13.1c1 5.3 0 10.9-2.9 16.1c-10 17.5-23.6 32.9-39.8 45.3c-3.5 2.7-8.5 2-11.2-1.5s-2-8.5 1.5-11.2c14.6-11.2 26.7-25 35.7-40.6c1.2-2.1 1.3-3.8 1.1-5.1c-.3-1.4-1.1-2.9-2.6-4.3c-3.1-2.9-8.8-4.7-14.9-3.2c-33.9 8.4-71.2 13.1-110.4 13.1s-76.5-4.7-110.4-13.1c-6.1-1.5-11.7 .3-14.9 3.2c-1.5 1.4-2.3 2.9-2.6 4.3c-.2 1.3-.1 3 1.1 5.1c8.9 15.6 21.1 29.4 35.7 40.6c3.5 2.7 4.2 7.7 1.5 11.2s-7.7 4.2-11.2 1.5c-16.2-12.4-29.8-27.8-39.8-45.3c-3-5.2-3.9-10.7-2.9-16.1c1-5.2 3.8-9.7 7.5-13.1c7.3-6.7 18.5-9.7 29.6-6.9z'
      
    ]
  };

  
    var faGrinTongue = faFaceGrinTongue;
  

  
  

  var faPeriod = {
    prefix: 'fat',
    iconName: 'period',
    icon: [
      192,
      512,
      [],
      '2e',
      
      'M96 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  

  
  

  var faBridgeCircleXmark = {
    prefix: 'fat',
    iconName: 'bridge-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e4cb',
      
      'M40 32H600c4.4 0 8 3.6 8 8s-3.6 8-8 8H520v96h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H40c-4.4 0-8-3.6-8-8s3.6-8 8-8h80V48H40c-4.4 0-8-3.6-8-8s3.6-8 8-8zM504 48H392v96H504V48zM376 48H264v96H376V48zM248 48H136v96H248V48zM40 256H64c48.6 0 88 39.4 88 88v96c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V344c0-48.6 39.4-88 88-88c12.3 0 24 2.5 34.7 7.1c-3.2 4.4-6.3 8.9-9.1 13.6c-7.9-3-16.5-4.7-25.5-4.7c-39.8 0-72 32.2-72 72v96c0 22.1-17.9 40-40 40H176c-22.1 0-40-17.9-40-40V344c0-39.8-32.2-72-72-72H40c-4.4 0-8-3.6-8-8s3.6-8 8-8zM624 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm205.7-50.3L507.3 368l50.3 50.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L496 379.3l-50.3 50.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L484.7 368l-50.3-50.3c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L496 356.7l50.3-50.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3z'
      
    ]
  };

  

  
  

  var faFaceKiss = {
    prefix: 'fat',
    iconName: 'face-kiss',
    icon: [
      512,
      512,
      [128535,"kiss"],
      'f596',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm241.4 16.1c11.4 2.1 22.8 5.4 33.6 9.8c8.4 3.4 17.2 7.9 24.2 13.7c6.9 5.9 12.8 14 12.8 24.4c0 10.2-6.4 17.5-13.4 22.4c-5.9 4.1-13.2 7.3-20.3 9.6c7.1 2.4 14.4 5.5 20.3 9.6c7 4.9 13.4 12.2 13.4 22.4c0 11-5.6 19.5-12.7 25.8c-7 6.2-16 10.6-24.5 13.7c-10.8 4.1-22.3 6.9-33.7 8.4l-.1 0c-4.4 .5-8.4-2.6-9-6.9s2.6-8.4 6.9-8.9c10.3-1.4 20.5-3.9 30.2-7.6c7.6-2.8 14.6-6.4 19.5-10.8c4.9-4.3 7.3-8.7 7.3-13.7c0-2.6-1.6-5.7-6.6-9.2c-5-3.5-12-6.4-19.7-8.7c-7.6-2.3-15.2-3.8-21-4.8c-2.2-.4-4-.5-5.5-.7c-2.3-.2-4.1-.4-5.9-1.1c-3.1-1.1-5.3-4.2-5.3-7.5s2.2-6.4 5.3-7.5c1.8-.6 3.6-.8 5.9-1.1l0 0 0 0c1.6-.2 3.3-.3 5.5-.7c5.8-1 13.4-2.5 21-4.8c7.7-2.3 14.7-5.2 19.7-8.7c5-3.5 6.6-6.6 6.6-9.2c0-3.8-2.1-7.9-7.2-12.2c-5.1-4.3-12.2-8-19.8-11.1c-7.6-3-15.2-5.3-21-6.7c-4.3-1.1-6.9-1.7-9.4-2.1c-4.3-.8-7.3-4.9-6.5-9.3s4.9-7.2 9.3-6.5zm-81-64.1a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  
    var faKiss = faFaceKiss;
  

  
  

  var faWindowFrameOpen = {
    prefix: 'fat',
    iconName: 'window-frame-open',
    icon: [
      512,
      512,
      [],
      'e050',
      
      'M264 16V272H464V64c0-26.5-21.5-48-48-48H264zM480 64V272v16H464 48 32V272 64C32 28.7 60.7 0 96 0H416c35.3 0 64 28.7 64 64zM248 272V16H96C69.5 16 48 37.5 48 64V272H248zM8 496H32V320H48V496H464V320h16V496h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H472 40 8c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faLightbulbCfl = {
    prefix: 'fat',
    iconName: 'lightbulb-cfl',
    icon: [
      320,
      512,
      [],
      'e5a6',
      
      'M160 47.7c0 14.1-9.6 26.4-23.2 29.9l-.1 0L54.4 98.2l0 0C34.9 103 16.1 88.3 16.1 68.3c0-14.1 9.6-26.5 23.3-29.9l82.2-20.6C141.1 13 160 27.7 160 47.7zM.1 68.3c0 17.2 9.2 31.9 22.5 40C8.9 116.6 .1 131.6 .1 148.3c0 17.2 9.2 31.9 22.5 40C8.9 196.6 .1 211.6 .1 228.3c0 30.5 28.6 52.8 58.2 45.4l95.6-23.9 0 0 111.7-27.9 .1 0c19.4-4.8 38.2 9.9 38.2 29.9c0 14.1-9.6 26.5-23.3 29.9l-70.5 17.6c-10.7 2.7-18.2 12.3-18.2 23.3V352H128V285.2l-16 4V352H96c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32h16c0 26.5 21.5 48 48 48s48-21.5 48-48h16c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H207.9V322.5c0-3.7 2.5-6.9 6.1-7.8l70.5-17.6c20.8-5.2 35.5-23.9 35.5-45.4c0-17.2-9.2-31.9-22.5-40c13.7-8.3 22.5-23.3 22.5-40c0-17.2-9.2-31.9-22.5-40c13.7-8.3 22.5-23.3 22.5-40c0-30.5-28.6-52.8-58.2-45.4L170.8 69.1c3.3-6.4 5.1-13.7 5.1-21.3c0-30.5-28.6-52.8-58.2-45.4L35.6 22.9C14.7 28.1 .1 46.8 .1 68.3zm39.3 50.1l18.8-4.7 .1 0 82.2-20.6 .1 0 125-31.3c19.4-4.9 38.3 9.8 38.3 29.9c0 14.1-9.6 26.5-23.3 29.9l-18.8 4.7L54.4 178.2c-19.4 4.9-38.3-9.8-38.3-29.9c0-14.1 9.6-26.5 23.3-29.9zM199.9 368l0 0 0 0H224c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H200 120 96c-8.8 0-16-7.2-16-16V384c0-8.8 7.2-16 16-16H199.9zm62-161.7l-.1 0L150 234.2 54.4 258.2c-19.4 4.9-38.3-9.8-38.3-29.9c0-14.1 9.6-26.5 23.3-29.9l18.8-4.7 207.4-51.8c19.4-4.9 38.3 9.8 38.3 29.9c0 14.1-9.6 26.5-23.3 29.9l-18.7 4.7zM160 496c-17.7 0-32-14.3-32-32h64c0 17.7-14.3 32-32 32z'
      
    ]
  };

  

  
  

  var faCommentArrowDown = {
    prefix: 'fat',
    iconName: 'comment-arrow-down',
    icon: [
      512,
      512,
      [],
      'e143',
      
      'M157.3 415c-5-1.8-10.6-1-14.9 2.1c-11 8-29.4 19.3-51.2 28.8C68.3 456 41.6 464 16 464l.1-.1 0 0 0 0 .3-.3 .1-.1c.4-.4 .9-.9 1.5-1.6c1.3-1.4 3.2-3.6 5.4-6.3l-12.2-10 12.2 10C28 450 34 442 40 432c10.7-17.9 21.4-42.1 23.6-69.9c.3-4.3-1.1-8.6-3.9-11.8C31.9 318.8 16 280.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-35.2 0-68.6-6.1-98.7-17zM4.7 452.7l0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0zM264 136c0-4.4-3.6-8-8-8s-8 3.6-8 8V308.7l-74.3-74.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l88 88c3.1 3.1 8.2 3.1 11.3 0l88-88c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L264 308.7V136z'
      
    ]
  };

  

  
  

  var faCameraWeb = {
    prefix: 'fat',
    iconName: 'camera-web',
    icon: [
      448,
      512,
      ["webcam"],
      'f832',
      
      'M432 224A208 208 0 1 0 16 224a208 208 0 1 0 416 0zm16 0c0 73.7-35.6 139-90.5 179.9L411 473.4c5.6 7.2 6.5 17 2.5 25.2s-12.4 13.4-21.5 13.4H56c-9.1 0-17.5-5.2-21.5-13.4s-3.1-18 2.5-25.2l53.5-69.5C35.6 363 0 297.7 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224zM224 448c-44.3 0-85.6-12.9-120.4-35.1l-54 70.2c-1.9 2.4-2.2 5.7-.8 8.4s4.1 4.5 7.2 4.5H392c3 0 5.8-1.7 7.2-4.5s1-6-.8-8.4l-54-70.2C309.6 435.1 268.3 448 224 448zM352 224A128 128 0 1 0 96 224a128 128 0 1 0 256 0zM80 224a144 144 0 1 1 288 0A144 144 0 1 1 80 224zm88 0c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-39.8 32.2-72 72-72c4.4 0 8 3.6 8 8s-3.6 8-8 8c-30.9 0-56 25.1-56 56z'
      
    ]
  };

  
    var faWebcam = faCameraWeb;
  

  
  

  var faSquareM = {
    prefix: 'fat',
    iconName: 'square-m',
    icon: [
      448,
      512,
      [],
      'e276',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm110.5 35.4L224 290.2 337.5 131.4c2-2.8 5.6-4 9-3s5.6 4.1 5.6 7.6V376c0 4.4-3.6 8-8 8s-8-3.6-8-8V161L230.5 308.6c-1.5 2.1-3.9 3.4-6.5 3.4s-5-1.2-6.5-3.4L112 161V376c0 4.4-3.6 8-8 8s-8-3.6-8-8V136c0-3.5 2.2-6.6 5.6-7.6s6.9 .1 9 3z'
      
    ]
  };

  

  
  

  var faFaceScream = {
    prefix: 'fat',
    iconName: 'face-scream',
    icon: [
      640,
      512,
      [],
      'e38b',
      
      'M80 256C80 123.5 187.5 16 320 16s240 107.5 240 240c0 4.4 3.6 8 8 8s8-3.6 8-8C576 114.6 461.4 0 320 0S64 114.6 64 256c0 4.4 3.6 8 8 8s8-3.6 8-8zM258.1 487.9c-4.3-1.1-8.7 1.4-9.8 5.7s1.4 8.7 5.7 9.8C275 509 297.2 512 320 512s45-3 66.1-8.6c4.3-1.1 6.8-5.5 5.7-9.8s-5.5-6.8-9.8-5.7c-19.8 5.3-40.5 8.1-61.9 8.1s-42.2-2.8-61.9-8.1zM181.5 193.2c10.5-17.2 25-29.7 39.7-36.1c14.7-6.5 28.9-6.7 39.8-.8c10.8 5.9 17.5 17.3 18.9 32.3c1.4 15-2.7 33-13.2 50.2s-25 29.7-39.7 36.1c-14.7 6.5-28.9 6.7-39.8 .8c-10.8-5.9-17.5-17.3-18.9-32.3c-1.4-15 2.7-33 13.2-50.2zm87.1-51c-16.4-9-36-7.7-53.9 .2c-17.9 7.9-34.8 22.7-46.9 42.4s-17.2 41.1-15.5 60c1.7 18.9 10.6 35.9 27.1 44.9c16.4 9 36 7.7 53.9-.2c17.9-7.9 34.8-22.7 46.9-42.4s17.2-41.1 15.5-60c-1.7-18.9-10.6-35.9-27.1-44.9zm150.3 14.8c14.7 6.5 29.2 19 39.7 36.1s14.6 35.2 13.2 50.2c-1.4 15-8.1 26.5-18.9 32.3c-10.9 5.9-25 5.7-39.8-.8c-14.7-6.5-29.2-19-39.7-36.1s-14.6-35.2-13.2-50.2c1.4-15 8.1-26.5 18.9-32.3c10.9-5.9 25-5.7 39.8 .8zm6.5-14.6c-17.9-7.9-37.5-9.1-53.9-.2c-16.5 9-25.4 26-27.1 44.9c-1.7 18.9 3.5 40.3 15.5 60s28.9 34.5 46.9 42.4c17.9 7.9 37.5 9.1 53.9 .2c16.5-9 25.4-26 27.1-44.9c1.7-18.9-3.5-40.3-15.5-60s-28.9-34.5-46.9-42.4zM368 368v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V368c0-26.5 21.5-48 48-48s48 21.5 48 48zm-112 0v32c0 35.3 28.7 64 64 64s64-28.7 64-64V368c0-35.3-28.7-64-64-64s-64 28.7-64 64zM55.9 325.7c7.7-5 16.6-6.6 25.1-5.3c6.3 1 12.3 3.7 17.3 7.8c24.7 20.6 46.2 51 61.5 84.3s24.2 68.9 24.1 99.4l16 0c.1-33.4-9.5-71.3-25.6-106.2s-38.8-67.4-65.8-89.9l0 0c-7.2-6-16-9.9-25-11.3c-12.2-1.9-25.1 .4-36.3 7.6l0 0c-23.7 15.4-30.4 46.9-14.8 70.4C56.8 419.6 74.2 465.9 74.2 512h16c0-49.9-18.7-99.3-44.4-138.2l0 0c-10.7-16-6.2-37.6 10.1-48.1zm503-5.3c8.5-1.3 17.4 .3 25.1 5.3c16.3 10.6 20.8 32.1 10.1 48.1l0 0c-25.7 38.9-44.4 88.2-44.4 138.2h16c0-46.1 17.4-92.4 41.8-129.3c15.6-23.5 9-55-14.8-70.4c-11.1-7.2-24.1-9.6-36.3-7.6c-9.1 1.4-17.8 5.3-25 11.3l0 0c-26.9 22.5-49.7 55-65.8 89.9s-25.6 72.8-25.6 106.2l16 0c-.1-30.6 8.8-66.2 24.1-99.4s36.8-63.7 61.5-84.3c5-4.1 11-6.8 17.3-7.8z'
      
    ]
  };

  

  
  

  var faArrowUpSquareTriangle = {
    prefix: 'fat',
    iconName: 'arrow-up-square-triangle',
    icon: [
      576,
      512,
      ["sort-shapes-up-alt"],
      'f88b',
      
      'M154.3 34.3c3.1-3.1 8.2-3.1 11.3 0l104 104c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L168 59.3V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V59.3L61.7 149.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l104-104zM440.2 301.7L524.4 442c2.3 3.9 3.6 8.4 3.6 12.9c0 13.8-11.2 25.1-25.1 25.1H329.1c-13.8 0-25.1-11.2-25.1-25.1c0-4.5 1.2-9 3.6-12.9l84.2-140.3c5.1-8.5 14.3-13.7 24.2-13.7s19.1 5.2 24.2 13.7zM405.5 310L321.3 450.3c-.8 1.4-1.3 3-1.3 4.7c0 5 4.1 9.1 9.1 9.1H502.9c5 0 9.1-4.1 9.1-9.1c0-1.6-.4-3.3-1.3-4.7L426.5 310c-2.2-3.7-6.2-6-10.5-6s-8.3 2.3-10.5 6zM336 176c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32H368c-17.7 0-32 14.3-32 32v96zm-16 0V80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48z'
      
    ]
  };

  
    var faSortShapesUpAlt = faArrowUpSquareTriangle;
  

  
  

  var faFieldHockeyStickBall = {
    prefix: 'fat',
    iconName: 'field-hockey-stick-ball',
    icon: [
      512,
      512,
      [127953,"field-hockey"],
      'f44c',
      
      'M502.8 76.2c15.6-21.4 10.8-51.5-10.6-67.1S440.8-1.7 425.2 19.8L145.3 404.7c-5 6.9-13.1 11.1-21.7 11.1c-14.9 0-27.1-12.2-27-27.2c0-3.7 .8-7.3 2.3-10.7l17-38.5c10.7-24.2-.3-52.6-24.5-63.3s-52.6 .3-63.3 24.5l-17 38.5C4.3 354.4 .7 371 .6 387.8C.1 456.2 55.4 512 123.9 511.8c39.2-.1 76-18.9 99.1-50.6L502.8 76.2zm-12.9-9.4l-70.3 96.6-53.3-35.5 71.8-98.7c10.4-14.3 30.4-17.5 44.7-7.1s17.5 30.4 7.1 44.7zM410.2 176.4L210 451.7c-20.1 27.6-52.1 43.9-86.2 44C64.3 496 16.1 447.4 16.6 388c.1-14.6 3.2-29 9.1-42.4l17-38.5c7.1-16.2 26-23.5 42.2-16.3s23.5 26 16.3 42.2l-17 38.5c-2.4 5.4-3.6 11.2-3.7 17c-.2 23.9 19.2 43.4 43 43.3c13.7 0 26.5-6.6 34.6-17.7L356.9 140.9l53.3 35.5zM432 368a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 144a80 80 0 1 0 0-160 80 80 0 1 0 0 160z'
      
    ]
  };

  
    var faFieldHockey = faFieldHockeyStickBall;
  

  
  

  var faSquare2 = {
    prefix: 'fat',
    iconName: 'square-2',
    icon: [
      448,
      512,
      [],
      'e257',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm187.4 61.9L157 182.2c-3.4 2.8-8.5 2.2-11.2-1.2s-2.2-8.5 1.2-11.2l30.4-24.3c14.1-11.3 31.7-17.3 49.8-17.1l2.3 0C270.8 129 304 162.7 304 204c0 20.1-8 39.3-22.1 53.5L171.3 368H312c4.4 0 8 3.6 8 8s-3.6 8-8 8H152c-3.2 0-6.2-1.9-7.4-4.9s-.6-6.4 1.7-8.7L270.5 246.1C281.7 235 288 219.8 288 204c0-32.6-26.2-59.1-58.8-59.6l-2.3 0c-14.4-.2-28.3 4.6-39.6 13.6z'
      
    ]
  };

  

  
  

  var faSaxophone = {
    prefix: 'fat',
    iconName: 'saxophone',
    icon: [
      640,
      512,
      [127927],
      'f8dc',
      
      'M487.6 53.1C501.1 39.6 519.4 32 538.5 32h27c19.1 0 37.4 7.6 50.9 21.1l16.3 16.3c4.7 4.7 7.3 11 7.3 17.7c0 13.8-11.2 25-25 25h-64c-7.2 0-13.9 3.2-18.5 8.7L283.8 421.8C253.4 458.7 208.1 480 160.3 480C71.8 480 0 408.2 0 319.7v-7.9c0-11.1 1.1-22.1 3.3-33L30.2 144H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H40 248h32c4.4 0 8 3.6 8 8s-3.6 8-8 8H253.3L194 284.9c-1.3 3.1-2 6.4-2 9.8v4.9c0 11.2 9.1 20.3 20.3 20.3c5.4 0 10.5-2.1 14.3-5.9L344.6 196l-22.3-22.3c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L356 184.6 392.7 148l-22.3-22.3c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L404 136.7 440.7 100 418.3 77.7c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L452 88.7l35.6-35.6zM19 282c-2 9.8-3 19.8-3 29.8v7.9C16 399.4 80.6 464 160.3 464c43 0 83.8-19.2 111.2-52.4L520.2 110.5c7.6-9.2 18.9-14.5 30.8-14.5h64c5 0 9-4 9-9c0-2.4-.9-4.7-2.6-6.3L605.1 64.4C594.6 53.9 580.3 48 565.5 48h-27c-14.8 0-29.1 5.9-39.6 16.4l-261 260.8c-6.8 6.8-16 10.6-25.7 10.6c-20 0-36.3-16.2-36.3-36.3v-4.9c0-5.5 1.1-10.9 3.2-16L236 144H46.6L19 282zm93-58a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM96 304a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faStopwatch = {
    prefix: 'fat',
    iconName: 'stopwatch',
    icon: [
      448,
      512,
      [9201],
      'f2f2',
      
      'M144 8c0-4.4 3.6-8 8-8H296c4.4 0 8 3.6 8 8s-3.6 8-8 8H232V96.2c55.4 2.1 105.3 25.9 141.4 63.1l36.9-36.9c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-37.6 37.6C414 207.2 432 253.5 432 304c0 114.9-93.1 208-208 208S16 418.9 16 304c0-112.2 88.8-203.6 200-207.8V16H152c-4.4 0-8-3.6-8-8zm80 488a192 192 0 1 0 0-384 192 192 0 1 0 0 384zm8-312V320c0 4.4-3.6 8-8 8s-8-3.6-8-8V184c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faBlinds = {
    prefix: 'fat',
    iconName: 'blinds',
    icon: [
      512,
      512,
      [],
      'f8fb',
      
      'M480 16c8.8 0 16 7.2 16 16V64c0 8.8-7.2 16-16 16H152 136 32c-8.8 0-16-7.2-16-16V32c0-8.8 7.2-16 16-16H480zM152 96H480c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32C14.3 0 0 14.3 0 32V64C0 81.7 14.3 96 32 96H136V256.7c-22.7 3.8-40 23.6-40 47.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-23.8-17.3-43.5-40-47.3V96zm32 128H492.3c10.9 0 19.7-8.8 19.7-19.7c0-2.8-.6-5.7-1.8-8.2L478.8 128H461.1l34.5 74.8c.2 .5 .3 1 .3 1.5c0 2-1.6 3.7-3.7 3.7H184v16zm-80-16H19.7c-2 0-3.7-1.6-3.7-3.7c0-.5 .1-1.1 .3-1.5L50.9 128H33.2L1.8 196.1C.6 198.7 0 201.5 0 204.3C0 215.2 8.8 224 19.7 224H104V208zM64 304H19.7c-2 0-3.7-1.6-3.7-3.7c0-.5 .1-1.1 .3-1.5L36.1 256H18.5L1.8 292.1C.6 294.7 0 297.5 0 300.3C0 311.2 8.8 320 19.7 320H65.6c-1-5.2-1.6-10.5-1.6-16zm158.4 16H492.3c10.9 0 19.7-8.8 19.7-19.7c0-2.8-.6-5.7-1.8-8.2L493.5 256H475.9l19.7 42.8c.2 .5 .3 1 .3 1.5c0 2-1.6 3.7-3.7 3.7H224c0 5.5-.6 10.8-1.6 16zM18.5 352L1.8 388.1C.6 390.7 0 393.5 0 396.3C0 407.2 8.8 416 19.7 416H492.3c10.9 0 19.7-8.8 19.7-19.7c0-2.8-.6-5.7-1.8-8.2L493.5 352H475.9l19.7 42.8c.2 .5 .3 1 .3 1.5c0 2-1.6 3.7-3.7 3.7H19.7c-2 0-3.7-1.6-3.7-3.7c0-.5 .1-1.1 .3-1.5L36.1 352H18.5zM1.8 484.1C.6 486.7 0 489.5 0 492.3C0 503.2 8.8 512 19.7 512H492.3c10.9 0 19.7-8.8 19.7-19.7c0-2.8-.6-5.7-1.8-8.2L493.5 448H475.9l19.7 42.8c.2 .5 .3 1 .3 1.5c0 2-1.6 3.7-3.7 3.7H19.7c-2 0-3.7-1.6-3.7-3.7c0-.5 .1-1.1 .3-1.5L36.1 448H18.5L1.8 484.1zM176 304a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z'
      
    ]
  };

  

  
  

  var faCommand = {
    prefix: 'fat',
    iconName: 'command',
    icon: [
      512,
      512,
      [],
      'e142',
      
      'M0 80C0 35.8 35.8 0 80 0s80 35.8 80 80v64H352V80c0-44.2 35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80H368V352h64c44.2 0 80 35.8 80 80s-35.8 80-80 80s-80-35.8-80-80V368H160v64c0 44.2-35.8 80-80 80s-80-35.8-80-80s35.8-80 80-80h64V160H80C35.8 160 0 124.2 0 80zm144 64V80c0-35.3-28.7-64-64-64S16 44.7 16 80s28.7 64 64 64h64zm16 208H352V160H160V352zm-16 16H80c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64V368zm224 0v64c0 35.3 28.7 64 64 64s64-28.7 64-64s-28.7-64-64-64H368zm0-224h64c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64v64z'
      
    ]
  };

  

  
  

  var faPopsicle = {
    prefix: 'fat',
    iconName: 'popsicle',
    icon: [
      320,
      512,
      [],
      'e43e',
      
      'M304 160c0-79.5-64.5-144-144-144S16 80.5 16 160V336c0 17.7 14.3 32 32 32H152V168c0-4.4 3.6-8 8-8s8 3.6 8 8V368H272c17.7 0 32-14.3 32-32V160zM152 384H48c-26.5 0-48-21.5-48-48V160C0 71.6 71.6 0 160 0s160 71.6 160 160V336c0 26.5-21.5 48-48 48H168V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V384z'
      
    ]
  };

  

  
  

  var faBookArrowUp = {
    prefix: 'fat',
    iconName: 'book-arrow-up',
    icon: [
      448,
      512,
      [],
      'e0ba',
      
      'M56 0C25.1 0 0 25.1 0 56V456c0 30.9 25.1 56 56 56H192V496H56c-22.1 0-40-17.9-40-40s17.9-40 40-40H192V400H56c-15.7 0-29.8 6.4-40 16.8V56c0-22.1 17.9-40 40-40H408c13.3 0 24 10.7 24 24V376c0 13.3-10.7 24-24 24H288v16H400v80H288v16H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H416V415.2c18.3-3.7 32-19.8 32-39.2V40c0-22.1-17.9-40-40-40H56zm74.3 234.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L232 155.3 232 504c0 4.4 3.6 8 8 8s8-3.6 8-8l0-348.7 90.3 90.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-104-104c-3.1-3.1-8.2-3.1-11.3 0l-104 104z'
      
    ]
  };

  

  
  

  var faCircleMicrophone = {
    prefix: 'fat',
    iconName: 'circle-microphone',
    icon: [
      512,
      512,
      ["microphone-circle"],
      'e116',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 160v96c0 35.3 28.7 64 64 64s64-28.7 64-64V160c0-35.3-28.7-64-64-64s-64 28.7-64 64zm64-48c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48s-48-21.5-48-48V160c0-26.5 21.5-48 48-48zM144 232c0-4.4-3.6-8-8-8s-8 3.6-8 8v24c0 68 53 123.6 120 127.8V408c0 4.4 3.6 8 8 8s8-3.6 8-8V383.8C331 379.6 384 324 384 256V232c0-4.4-3.6-8-8-8s-8 3.6-8 8v24c0 61.9-50.1 112-112 112s-112-50.1-112-112V232z'
      
    ]
  };

  
    var faMicrophoneCircle = faCircleMicrophone;
  

  
  

  var faSpiderWeb = {
    prefix: 'fat',
    iconName: 'spider-web',
    icon: [
      576,
      512,
      [128376],
      'f719',
      
      'M145.7 13.2c1.4-3.6 5.1-5.8 9-5.1l78.2 14.7c38 7.1 77 7.1 115 0L426 8.1c3.8-.7 7.6 1.4 9 5.1l32.4 86.3c12.3 32.8 30 63.3 52.5 90.2l51 61.2c2.5 3 2.5 7.3 0 10.2l-51 61.2c-22.4 26.9-40.2 57.4-52.5 90.2l-32.4 86.3c-1.4 3.6-5.1 5.8-9 5.1l-78.2-14.7c-38-7.1-77-7.1-115 0l-78.2 14.7c-3.8 .7-7.6-1.4-9-5.1l-32.4-86.3c-12.3-32.8-30-63.3-52.4-90.2l-51-61.2c-2.5-3-2.5-7.3 0-10.2l51-61.2c22.4-26.9 40.2-57.4 52.4-90.2l32.4-86.3zM154.2 36l-25.9 69.2c-12.9 34.5-31.6 66.5-55.1 94.8l-40 48h91.1l7.8-8.9c26.1-29.8 46.3-64.3 59.4-101.7l7.9-22.4L154.2 36zm13.2-9.2l44.4 77.7c50.5 14.5 103.9 14.6 154.5 .4l44.4-77.7L350.7 38.5c-40 7.5-80.9 7.5-120.9 0L167.4 26.8zm258.1 6.7l-45.7 80 8.4 23.8c13.2 37.4 33.3 71.9 59.4 101.7l7.8 8.9h92.1l-40-48c-23.6-28.3-42.2-60.3-55.1-94.8L425.5 33.6zM547.5 264H455l-6.2 7.1c-26.9 30.8-47.5 66.5-60.7 105.2l-7.9 23.2 45.1 79 26.8-71.6c12.9-34.5 31.6-66.5 55.1-94.8l40-48zM410.6 484.7l-42.3-74.1c0 0-.1 0-.1 0l-.9-.3C317 393.6 262.9 392.5 212 407l-44.7 78.1 62.4-11.7c39.9-7.5 80.9-7.5 120.9 0l59.9 11.2zM154.2 476l45.2-79.2-8-22.6c-13.2-37.4-33.3-71.9-59.4-101.7l-7.5-8.6H33.1l40 48c23.6 28.3 42.2 60.3 55.1 94.8L154.2 476zm-8.4-212c26.6 30.9 47.2 66.5 60.8 104.9l3.4 9.6L275.4 264H145.8zm77.3 123.7c44.1-9.9 90-9 133.7 2.7L289.1 272.1 223.1 387.7zm146.6-6.8l3.3-9.8c13.3-39.2 33.9-75.6 60.8-107.1H302.9l66.8 116.9zM434.1 248c-26.8-31-47.5-66.7-61.1-105.3L369.2 132 302.9 248H434.1zM355.2 124.2c-43.6 9.8-88.8 9.7-132.4-.3l66.3 116 66.1-115.6zm-145.4 9.1l-3.3 9.3C192.9 181.3 172.2 217 145.5 248H275.4L209.8 133.4z'
      
    ]
  };

  

  
  

  var faHandSpock = {
    prefix: 'fat',
    iconName: 'hand-spock',
    icon: [
      543,
      512,
      [128406],
      'f259',
      
      'M198.7 1.8c24-6.9 49 6.9 56 30.8l59.8 206.7 41-174.4c5.7-24.3 30-39.3 54.3-33.6s39.3 30 33.6 54.3l-3.2 13.7c10.6-7.9 24.4-11.1 38.2-7.6c24.2 6.2 38.8 30.8 32.6 55L451.7 378.9c-15.4 60.4-69.4 102.9-131.5 104c-.2 0-.4 0-.6 0h-1.5 0l-.3 0h0l-.3 0h0H300.1c-53.6 0-105.5-19.1-146.3-53.8l-105.8-90c-19-16.2-21.3-44.7-5.2-63.7s44.7-21.3 63.7-5.2l59.3 50.4L107.9 133.8c-7.4-23.8 6-49.1 29.8-56.5c13-4 26.5-1.9 37.3 4.8l-7.1-24.4c-6.9-24 6.9-49 30.8-56zm41.5 35c-4.6-16-21.3-25.2-37.3-20.6s-25.2 21.3-20.6 37.3l58.4 201.8c1.5 5-2.3 10-7.5 10c-3.4 0-6.5-2.2-7.5-5.5L179.8 111.6c-4.9-15.9-21.8-24.8-37.7-19.9s-24.8 21.8-19.9 37.7l57.9 186.9c4.5 14.4-12.7 25.7-24.1 15.9L96.7 281.8C84 271 65 272.6 54.2 285.3s-9.2 31.7 3.4 42.5l105.8 90c38.1 32.4 86.5 50.2 136.5 50.2h17.4 0l.3 0h0l.3 0h0 1.1c.1 0 .2 0 .3 0c55.5-.8 103.8-38.7 117.6-92.6L496.4 143c4.1-16.1-5.6-32.5-21.7-36.6s-32.5 5.6-36.6 21.7L404.7 259c-1 3.8-4.3 6.4-8.2 6.4c-5.5 0-9.5-5.1-8.3-10.4L428.8 82.2c3.8-16.2-6.2-32.4-22.4-36.2s-32.4 6.2-36.2 22.4L325.9 256.6c-1.2 5.1-5.8 8.7-11 8.7c-5 0-9.5-3.3-10.9-8.2L240.2 36.8z'
      
    ]
  };

  

  
  

  var faCircleCamera = {
    prefix: 'fat',
    iconName: 'circle-camera',
    icon: [
      512,
      512,
      ["camera-circle"],
      'e103',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM206.6 136.8L195.1 160H168c-22.1 0-40 17.9-40 40V312c0 22.1 17.9 40 40 40H344c22.1 0 40-17.9 40-40V200c0-22.1-17.9-40-40-40H316.9l-11.6-23.2c-2.7-5.4-8.3-8.8-14.3-8.8H220.9c-6.1 0-11.6 3.4-14.3 8.8zm14.3 7.2h70.1l13.8 27.6c1.4 2.7 4.1 4.4 7.2 4.4h32c13.3 0 24 10.7 24 24V312c0 13.3-10.7 24-24 24H168c-13.3 0-24-10.7-24-24V200c0-13.3 10.7-24 24-24h32c3 0 5.8-1.7 7.2-4.4L220.9 144zM256 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-32-48a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  
    var faCameraCircle = faCircleCamera;
  

  
  

  var faFacePersevering = {
    prefix: 'fat',
    iconName: 'face-persevering',
    icon: [
      512,
      512,
      [],
      'e385',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM322.1 413.4C309.3 399.1 287.3 384 256 384s-53.3 15.1-66.1 29.4c-3 3.3-8 3.6-11.3 .6s-3.6-8-.6-11.3C193.1 386 219.1 368 256 368s62.9 18 77.9 34.6c3 3.3 2.7 8.3-.6 11.3s-8.3 2.7-11.3-.6zM205.7 98.3c3.1 3.1 3.1 8.2 0 11.3l-7.4 7.4c-22.4 22.4-51.2 37.2-82.5 42.5l-2.5 .4c-4.4 .7-8.5-2.2-9.2-6.6s2.2-8.5 6.6-9.2l2.5-.4c28-4.7 53.8-17.9 73.8-38l7.4-7.4c3.1-3.1 8.2-3.1 11.3 0zm100.7 11.3c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l7.4 7.4c20 20 45.8 33.3 73.8 38l2.5 .4c4.4 .7 7.3 4.8 6.6 9.2s-4.8 7.3-9.2 6.6l-2.5-.4c-31.3-5.2-60.1-20.1-82.5-42.5l-7.4-7.4zM128.8 228.4c2-4 6.8-5.6 10.7-3.6l80 40c2.7 1.4 4.4 4.1 4.4 7.2s-1.7 5.8-4.4 7.2l-80 40c-4 2-8.8 .4-10.7-3.6s-.4-8.8 3.6-10.7L198.1 272l-65.7-32.8c-4-2-5.6-6.8-3.6-10.7zm243.6-3.6c4-2 8.8-.4 10.7 3.6s.4 8.8-3.6 10.7L313.9 272l65.7 32.8c4 2 5.6 6.8 3.6 10.7s-6.8 5.6-10.7 3.6l-80-40c-2.7-1.4-4.4-4.1-4.4-7.2s1.7-5.8 4.4-7.2l80-40z'
      
    ]
  };

  

  
  

  var faGaugeSimpleLow = {
    prefix: 'fat',
    iconName: 'gauge-simple-low',
    icon: [
      512,
      512,
      ["tachometer-slow"],
      'f62c',
      
      'M256 496a240 240 0 1 0 0-480 240 240 0 1 0 0 480zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm0 400a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 16c-35.3 0-64-28.7-64-64c0-22.2 11.3-41.7 28.4-53.2L136.8 131.6c-2-4-.4-8.8 3.6-10.7s8.8-.4 10.7 3.6l83.6 167.2c6.6-2.3 13.8-3.6 21.2-3.6c35.3 0 64 28.7 64 64s-28.7 64-64 64z'
      
    ]
  };

  
    var faTachometerSlow = faGaugeSimpleLow;
  

  
  

  var faFaceSaluting = {
    prefix: 'fat',
    iconName: 'face-saluting',
    icon: [
      640,
      512,
      [129761],
      'e484',
      
      'M234.8 20L56.7 138.6c-39.1 26-30.1 85.8 14.8 99.2c15.5 4.6 32.2 2.3 45.8-6.5l96.9-62.2c11.2-7.2 14.4-22 7.2-33.2s-22-14.4-33.2-7.2l-38.4 24.7c-3.7 2.4-8.6 1.3-11-2.4s-1.4-8.6 2.3-11L261.4 60c11-7.3 14-22.2 6.7-33.3s-22.2-14-33.3-6.7zm46.6-2.2c12.2 18.4 7.3 43.2-11.1 55.5l-56.5 37.6c8.5 2.8 16 8.3 21.2 16.4c11.9 18.6 6.5 43.3-12.1 55.3L126 244.8c-17.5 11.3-39.1 14.3-59.1 8.3C9 235.8-2.5 158.8 47.9 125.2L225.9 6.7c18.4-12.2 43.2-7.3 55.5 11.1zM352 16c-10.5 0-20.8 .7-31 2c-4.4 .6-8.4-2.5-9-6.9s2.5-8.4 6.9-9C329.8 .7 340.8 0 352 0C493.4 0 608 114.6 608 256s-114.6 256-256 256c-117 0-215.6-78.4-246.2-185.5c-1.2-4.2 1.2-8.7 5.5-9.9s8.7 1.2 9.9 5.5C149.9 422.5 242.4 496 352 496c132.5 0 240-107.5 240-240S484.5 16 352 16zM234 343.7c2.9-3.3 8-3.6 11.3-.6c20.4 18.2 55.9 38 106.7 38s86.3-19.8 106.7-38c3.3-2.9 8.4-2.7 11.3 .6s2.7 8.4-.6 11.3c-22.9 20.5-62.1 42-117.3 42s-94.4-21.6-117.3-42c-3.3-2.9-3.6-8-.6-11.3zM272.4 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm144 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faChevronUp = {
    prefix: 'fat',
    iconName: 'chevron-up',
    icon: [
      512,
      512,
      [],
      'f077',
      
      'M250.3 114.3c3.1-3.1 8.2-3.1 11.3 0l216 216c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L256 131.3 45.7 341.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l216-216z'
      
    ]
  };

  

  
  

  var faSquareI = {
    prefix: 'fat',
    iconName: 'square-i',
    icon: [
      448,
      512,
      [],
      'e272',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm136 32h88 88c4.4 0 8 3.6 8 8s-3.6 8-8 8H232V368h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H136c-4.4 0-8-3.6-8-8s3.6-8 8-8h80V144H136c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faCalendarCircleExclamation = {
    prefix: 'fat',
    iconName: 'calendar-circle-exclamation',
    icon: [
      576,
      512,
      [],
      'e46e',
      
      'M128 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H64C28.7 64 0 92.7 0 128v48 16V448c0 35.3 28.7 64 64 64H330.8c-6.9-4.9-13.5-10.2-19.6-16H64c-26.5 0-48-21.5-48-48V192H352h80 16V176 128c0-35.3-28.7-64-64-64H336V8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H128V8zM112 80v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80H320v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80h48c26.5 0 48 21.5 48 48v48H16V128c0-26.5 21.5-48 48-48h48zM304 368a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM432 448a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-168c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8s8-3.6 8-8V288c0-4.4-3.6-8-8-8z'
      
    ]
  };

  

  
  

  var faPlug = {
    prefix: 'fat',
    iconName: 'plug',
    icon: [
      384,
      512,
      [128268],
      'f1e6',
      
      'M112 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V112h16V8zM288 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V112h16V8zM8 144c-4.4 0-8 3.6-8 8s3.6 8 8 8H40v80c0 81.3 63.8 147.6 144 151.8V504c0 4.4 3.6 8 8 8s8-3.6 8-8V391.8c80.2-4.2 144-70.5 144-151.8V160h32c4.4 0 8-3.6 8-8s-3.6-8-8-8H344 328 56 40 8zM192 376c-75.1 0-136-60.9-136-136V160H328v80c0 75.1-60.9 136-136 136z'
      
    ]
  };

  

  
  

  var faHouseCircleXmark = {
    prefix: 'fat',
    iconName: 'house-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e50b',
      
      'M282.7 2c3-2.7 7.6-2.7 10.6 0l215 190.4c-4.1-.3-8.2-.4-12.3-.4c-4 0-8 .1-11.9 .4L288 18.7 80 202.9V448c0 26.5 21.5 48 48 48h80V328c0-13.3 10.7-24 24-24H332c-2 5.2-3.8 10.6-5.4 16H256 232c-4.4 0-8 3.6-8 8V496h32 96 16 7.2c6.1 5.8 12.7 11.1 19.6 16H128c-35.3 0-64-28.7-64-64V217.1L13.3 262c-3.3 2.9-8.4 2.6-11.3-.7S-.6 252.9 2.7 250L282.7 2zM624 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm205.7-50.3L507.3 368l50.3 50.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L496 379.3l-50.3 50.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L484.7 368l-50.3-50.3c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L496 356.7l50.3-50.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3z'
      
    ]
  };

  

  
  

  var faWorm = {
    prefix: 'fat',
    iconName: 'worm',
    icon: [
      512,
      512,
      [],
      'e599',
      
      'M432 178.3V164.4l-13.7-2-54.4-7.8c-34.3-4.9-59.8-34.3-59.8-69C304 47.2 335.2 16 373.7 16h48.7C463 16 496 49 496 89.6V176v16V360c0 75.1-60.9 136-136 136s-136-60.9-136-136V312c0-39.8-32.2-72-72-72s-72 32.2-72 72V464c0 17.7-14.3 32-32 32s-32-14.3-32-32V312c0-75.1 60.9-136 136-136s136 60.9 136 136v48c0 39.8 32.2 72 72 72s72-32.2 72-72V178.3zM373.7 0C326.4 0 288 38.4 288 85.7c0 42.6 31.4 78.8 73.6 84.8l54.4 7.8V360c0 30.9-25.1 56-56 56s-56-25.1-56-56V312c0-83.9-68.1-152-152-152S0 228.1 0 312V464c0 26.5 21.5 48 48 48s48-21.5 48-48V312c0-30.9 25.1-56 56-56s56 25.1 56 56v48c0 83.9 68.1 152 152 152s152-68.1 152-152V192 176 89.6C512 40.1 471.9 0 422.4 0H373.7zM400 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faFaceShush = {
    prefix: 'fat',
    iconName: 'face-shush',
    icon: [
      512,
      512,
      [],
      'e38c',
      
      'M256 16C123.5 16 16 123.5 16 256c0 87.2 46.5 163.6 116.1 205.6c3.8 2.3 5 7.2 2.7 11s-7.2 5-11 2.7C49.7 430.5 0 349 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 78.4-35.3 148.7-90.8 195.6c-3.4 2.9-8.4 2.4-11.3-.9s-2.4-8.4 .9-11.3C462.9 395.3 496 329.5 496 256C496 123.5 388.5 16 256 16zM160.4 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm160 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-155 74c12.7 11.3 32.2 23.3 58.7 29v-7c0-17.7 14.3-32 32-32s32 14.3 32 32v7c26.5-5.6 46-17.7 58.7-29c3.3-2.9 8.4-2.7 11.3 .6s2.7 8.4-.6 11.3c-15 13.4-38.2 27.4-69.3 33.3v61.3c23.5 9.5 40 32.5 40 59.3v8c0 17.7-14.3 32-32 32s-32-14.3-32-32v-8H232v15.7l64.3 46.8c2.1-1 4-2.4 5.5-4.2l25.6-30.7c11.3-13.6 31.5-15.4 45.1-4.1s15.4 31.5 4.1 45.1L351 483.2c-15.2 18.2-37.7 28.8-61.5 28.8H288 232c-35.3 0-64-28.7-64-64V416 384c0-32.6 24.4-59.6 56-63.5V263.3c-31.2-5.9-54.3-19.9-69.3-33.3c-3.3-2.9-3.6-8-.6-11.3s8-3.6 11.3-.6zm90.7 6c-8.8 0-16 7.2-16 16v80h32V240c0-8.8-7.2-16-16-16zM232 368h32c8.8 0 16 7.2 16 16v8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8c0-26.5-21.5-48-48-48H232c-26.5 0-48 21.5-48 48v32 32c0 26.5 21.5 48 48 48h56 1.5c19 0 37-8.4 49.2-23l25.6-30.7c5.7-6.8 4.7-16.9-2-22.5s-16.9-4.7-22.5 2l-25.6 30.7c-5.3 6.4-12.9 10.4-21.2 11.3l-76.9-56V384c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faFlaskRoundPotion = {
    prefix: 'fat',
    iconName: 'flask-round-potion',
    icon: [
      448,
      512,
      ["flask-potion"],
      'f6e1',
      
      'M160 16H288V149.3c0 13.1 7.9 24.2 18.8 29.5C371.4 209.7 416 275.6 416 352c0 5.4-.2 10.7-.6 15.9c-62.6-1.3-98.7-16.1-130.3-31.1c-3.1-1.5-6.2-3-9.3-4.5C245.9 317.9 217.1 304 171.8 304c-49.2 0-87.3 12.4-113.2 24.8c-11.1 5.3-19.9 10.6-26.4 15c3.1-72.9 46.7-135.2 109-165.1c10.9-5.2 18.8-16.4 18.8-29.5V16zM413.4 383.9c-6.5 39-24.8 74-51 101.3c-6.7 7-17 10.8-28.5 10.8H114.2c-11.6 0-21.8-3.9-28.5-10.8c-30.8-32-50.6-74.5-53.3-121.7c1.4-1.1 3.4-2.7 5.9-4.4c6.1-4.3 15.2-10 27.3-15.8C89.6 331.6 125.4 320 171.8 320c41.5 0 67.2 12.4 97 26.8c3.1 1.5 6.1 3 9.3 4.5c32.6 15.5 70.6 31.1 135.2 32.6zM304 149.3V16h24c4.4 0 8-3.6 8-8s-3.6-8-8-8H288 160 120c-4.4 0-8 3.6-8 8s3.6 8 8 8l24 0V149.3c0 6.5-3.9 12.2-9.7 15C64.3 197.8 16 269.3 16 352c0 56 22.1 106.9 58.2 144.3C84.5 507 99.3 512 114.2 512H333.8c15 0 29.7-5 40.1-15.7C409.9 458.9 432 408 432 352c0-82.7-48.3-154.2-118.3-187.7c-5.8-2.8-9.7-8.6-9.7-15z'
      
    ]
  };

  
    var faFlaskPotion = faFlaskRoundPotion;
  

  
  

  var faPi = {
    prefix: 'fat',
    iconName: 'pi',
    icon: [
      448,
      512,
      [],
      'f67e',
      
      'M8 64c-4.4 0-8 3.6-8 8s3.6 8 8 8H128V259c0 63.6-21.6 125.3-61.4 174.9l-.9 1.1c-2.8 3.4-2.2 8.5 1.2 11.2s8.5 2.2 11.2-1.2l.9-1.1C121.1 391.4 144 326.2 144 259V80H304V390.6c0 31.7 25.7 57.4 57.4 57.4c21.8 0 41.6-12.3 51.4-31.8l2.3-4.7c2-4 .4-8.8-3.6-10.7s-8.8-.4-10.7 3.6l-2.3 4.7c-7 14-21.4 22.9-37.1 22.9c-22.9 0-41.4-18.6-41.4-41.4V80H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H8z'
      
    ]
  };

  

  
  

  var faOm = {
    prefix: 'fat',
    iconName: 'om',
    icon: [
      512,
      512,
      [128329],
      'f679',
      
      'M351 13.7c9.4-9.4 24.6-9.4 33.9 0L402.3 31c9.4 9.4 9.4 24.6 0 33.9L385 82.3c-9.4 9.4-24.6 9.4-33.9 0L333.7 65c-9.4-9.4-9.4-24.6 0-33.9L351 13.7zM373.7 25c-3.1-3.1-8.2-3.1-11.3 0L345 42.3c-3.1 3.1-3.1 8.2 0 11.3L362.3 71c3.1 3.1 8.2 3.1 11.3 0L391 53.7c3.1-3.1 3.1-8.2 0-11.3L373.7 25zM140.8 112c-18 0-34.6 5.9-48 16c-3.5 2.7-8.5 1.9-11.2-1.6s-1.9-8.5 1.6-11.2c16-12.1 36-19.2 57.6-19.2c53 0 96 43 96 96c0 33.4-17 62.8-42.9 80h0 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2c19.1 0 37.4-7.6 50.9-21.1l17.4-17.4c16.4-16.4 38.5-25.5 61.7-25.5c48.2 0 87.2 39 87.2 87.2V400c0 44.2-35.8 80-80 80H416c-44.2 0-80-35.8-80-80v-8c0-4.4 3.6-8 8-8s8 3.6 8 8v8c0 35.3 28.7 64 64 64h16c35.3 0 64-28.7 64-64V295.2c0-39.3-31.9-71.2-71.2-71.2c-18.9 0-37 7.5-50.3 20.9l-17.4 17.4c-16.5 16.5-38.8 25.8-62.2 25.8h-.2-.2-.2-.2-.2-.2-.2H293h-.2-.2-.2H292h-.2-.2-.3H291h-.3-.3-.3H290h-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3H285h-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3H282h-.3-.3-.3H281h-.3-.3-.3-.3-.3-.3H279h-.3-.3-.3-.3-.3-.3H277h-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3H273h-.3-.3-.3-.3-.3-.3H271h-.3-.3-.3-.3-.3-.3-.3-.3-.3H268h-.3-.3-.3-.3-.3-.3-.3-.3-.3H265h-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3H261h-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3H257h-.3-.3H256h-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3H249h-.3-.3H248h-.3-.3H247h-.3-.3H246h-.3-.3H245h-.3-.3H244h-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3H236h-.3-.3H235h-.3-.3H234h-.3-.3H233h-.3-.3H232h-.3-.3H231h-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3H222h-.3-.3H221h-.3-.3H220h-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3H214h-.4-.4H213h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H207h-.4-.4-.4-.4-.4-.4-.4-.4-.3c40.5 20.6 68.1 59 68.1 104c0 67.2-61.9 120-136 120S0 459.2 0 392c0-4.4 3.6-8 8-8s8 3.6 8 8c0 56.5 52.7 104 120 104s120-47.5 120-104s-52.7-104-120-104l-.2 0h-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3H129h-.3-.3H128c-4.4 0-8-3.6-8-8s3.6-8 8-8h.3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3l.1 0 .1 0c44.2 0 79.9-35.8 79.9-80c0-44.2-35.8-80-80-80zm145.5-5c17.5 22.1 47.4 37 81.7 37s64.2-14.9 81.7-37c2.7-3.5 7.8-4 11.2-1.3s4 7.8 1.3 11.2c-20.8 26.2-55.4 43-94.3 43s-73.5-16.8-94.3-43c-2.7-3.5-2.2-8.5 1.3-11.2s8.5-2.2 11.2 1.3z'
      
    ]
  };

  

  
  

  var faArrowTurnLeftDown = {
    prefix: 'fat',
    iconName: 'arrow-turn-left-down',
    icon: [
      384,
      512,
      [],
      'e633',
      
      'M349.7 357.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L200 484.7 200 72c0-30.9 25.1-56 56-56l120 0c4.4 0 8-3.6 8-8s-3.6-8-8-8L256 0c-39.8 0-72 32.2-72 72l0 412.7L45.7 346.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l152 152c3.1 3.1 8.2 3.1 11.3 0l152-152z'
      
    ]
  };

  

  
  

  var faFolderBookmark = {
    prefix: 'fat',
    iconName: 'folder-bookmark',
    icon: [
      512,
      512,
      [],
      'e186',
      
      'M448 464c26.5 0 48-21.5 48-48V160c0-26.5-21.5-48-48-48h-8V344c0 3.1-1.8 5.9-4.5 7.2s-6.1 1-8.5-1l-75-60-75 60c-2.4 1.9-5.7 2.3-8.5 1s-4.5-4.1-4.5-7.2V96c0-.4 0-.9 .1-1.3L231.4 62.1c-9-9-21.2-14.1-33.9-14.1H64C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H448zM424 112H301.3c-7.4 0-14.7-1.7-21.3-5V327.4l67-53.6c2.9-2.3 7.1-2.3 10 0l67 53.6V112zm8-16h16c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H197.5c17 0 33.3 6.7 45.3 18.7l35.9 35.9c6 6 14.1 9.4 22.6 9.4H432z'
      
    ]
  };

  

  
  

  var faTurnRight = {
    prefix: 'fat',
    iconName: 'turn-right',
    icon: [
      512,
      512,
      [],
      'e639',
      
      'M336 272l0 89.1c0 3.8 3.1 6.9 6.9 6.9c1.8 0 3.5-.7 4.7-1.9L495.2 225.9c.5-.5 .8-1.2 .8-1.9s-.3-1.4-.8-1.9L347.6 81.9c-1.3-1.2-3-1.9-4.7-1.9c-3.8 0-6.9 3.1-6.9 6.9l0 89.1c0 8.8-7.2 16-16 16l-208 0c-53 0-96 43-96 96l0 152c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-152c0-17.7 14.3-32 32-32l208 0c8.8 0 16 7.2 16 16zm170.2-34.5L358.6 377.7c-4.2 4-9.9 6.3-15.8 6.3c-12.6 0-22.9-10.2-22.9-22.9l0-73.1 0-16-16 0-192 0c-8.8 0-16 7.2-16 16l0 152c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40L0 288c0-61.9 50.1-112 112-112l192 0 16 0 0-16 0-73.1C320 74.2 330.2 64 342.9 64c5.9 0 11.5 2.3 15.8 6.3L506.2 210.5c3.7 3.5 5.8 8.4 5.8 13.5s-2.1 10-5.8 13.5z'
      
    ]
  };

  

  
  

  var faPrintMagnifyingGlass = {
    prefix: 'fat',
    iconName: 'print-magnifying-glass',
    icon: [
      640,
      512,
      ["print-search"],
      'f81a',
      
      'M144 160V64c0-26.5 21.5-48 48-48H421.5c12.7 0 24.9 5.1 33.9 14.1l26.5 26.5c9 9 14.1 21.2 14.1 33.9V160h16V90.5c0-17-6.7-33.3-18.7-45.3L466.7 18.7C454.7 6.7 438.5 0 421.5 0H192c-35.3 0-64 28.7-64 64v96h16zm-16 48H333.7c5.7-5.8 11.8-11.1 18.2-16H128c-35.3 0-64 28.7-64 64V384c0 17.7 14.3 32 32 32h32v64c0 17.7 14.3 32 32 32H480c15.8 0 29-11.5 31.6-26.6L498.2 472c-.7 .2-1.4 .5-2.2 .7V480c0 8.8-7.2 16-16 16H160c-8.8 0-16-7.2-16-16V352c0-8.8 7.2-16 16-16H288.8c-.5-5.3-.8-10.6-.8-16H160c-17.7 0-32 14.3-32 32v48H96c-8.8 0-16-7.2-16-16V256c0-26.5 21.5-48 48-48zm320 .1a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 240c32.5 0 62.1-12.1 84.7-32l93.7 93.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L544 404.8c19.9-22.6 32-52.2 32-84.7c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128z'
      
    ]
  };

  
    var faPrintSearch = faPrintMagnifyingGlass;
  

  
  

  var faUtensilsSlash = {
    prefix: 'fat',
    iconName: 'utensils-slash',
    icon: [
      640,
      512,
      [],
      'e464',
      
      'M143.9 9.3c.7-4.4-2.2-8.5-6.6-9.2s-8.5 2.2-9.2 6.6l-.9 5.4 14.3 11.3 2.3-14.1zm45.5 51.8L192 8.4c.2-4.4-3.2-8.2-7.6-8.4s-8.2 3.2-8.4 7.6L173.9 49l15.4 12.2zm55.5 43.8L240 7.6c-.2-4.4-4-7.8-8.4-7.6s-7.8 4-7.6 8.4l4.2 83.4 16.7 13.2zM127.2 195.6l-22.6-17.8c4.7 35.2 34.9 62.3 71.3 62.3h7.5l-23-18.2c-14.2-4.1-26.1-13.7-33.3-26.3zM200 253V504c0 4.4 3.6 8 8 8s8-3.6 8-8V265.6L200 253zm112-95v-.7c0-4-.3-7.9-1-11.8L287.9 6.7c-.7-4.4-4.8-7.3-9.2-6.6s-7.3 4.8-6.6 9.2l22.5 134.9L312 158zM528 328.5V24c0-13.3-10.7-24-24-24C488 0 384 32 384 176v38.8l16 12.6V176c0-67.7 24.2-107.4 48.9-130.3c12.5-11.6 25.5-19.2 36-23.8c5.3-2.3 9.9-3.8 13.4-4.8c3.7-1 5.6-1.1 5.7-1.1l0 0c4.4 0 8 3.6 8 8V315.8l16 12.6zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  

  
  

  var faPersonBikingMountain = {
    prefix: 'fat',
    iconName: 'person-biking-mountain',
    icon: [
      640,
      512,
      [128693,"biking-mountain"],
      'f84b',
      
      'M392 96a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm0-96a56 56 0 1 1 0 112A56 56 0 1 1 392 0zM335.7 151.2c-9-7.4-22-7.2-30.8 .4l-59.1 50.7c-12.2 10.4-10.9 29.7 2.6 38.4l100 64.7c2.3 1.5 3.7 4 3.7 6.7V416c0 4.4-3.6 8-8 8s-8-3.6-8-8V316.4L239.6 254c-22.4-14.5-24.6-46.6-4.3-64l59.1-50.7c14.7-12.6 36.4-12.9 51.4-.6l65 53.2H488c4.4 0 8 3.6 8 8s-3.6 8-8 8H408c-1.8 0-3.6-.6-5.1-1.8l-67.3-55zM490.3 284.8c-.6 2.9-2.7 5.3-5.6 6.1c-6.8 2-13.2 4.7-19.3 8c-2.6 1.4-5.8 1.3-8.3-.3c-6.2-4.1-14.7-3.4-20.1 2l-8.5 8.5c-5.5 5.5-6.2 13.9-2 20.1c1.6 2.5 1.8 5.7 .3 8.3c-3.3 6.1-6 12.5-8 19.3c-.8 2.9-3.2 5-6.1 5.6c-7.3 1.5-12.8 7.9-12.8 15.7v12c0 7.7 5.5 14.2 12.8 15.7c2.9 .6 5.3 2.7 6.1 5.6c2 6.8 4.7 13.2 8 19.3c1.4 2.6 1.3 5.8-.3 8.3c-4.1 6.2-3.4 14.7 2 20.1l8.5 8.5c5.5 5.5 13.9 6.2 20.1 2c2.5-1.6 5.7-1.8 8.3-.3c6.1 3.3 12.5 6 19.3 8c2.9 .8 5 3.2 5.6 6.1c1.5 7.3 7.9 12.8 15.7 12.8h12c7.7 0 14.2-5.5 15.7-12.8c.6-2.9 2.7-5.3 5.6-6.1c6.8-2 13.2-4.7 19.3-8c2.6-1.4 5.8-1.3 8.3 .3c6.2 4.1 14.7 3.4 20.1-2l8.5-8.5c5.5-5.5 6.2-13.9 2-20.1c-1.6-2.5-1.8-5.7-.3-8.3c3.3-6.1 6-12.5 8-19.3c.8-2.9 3.2-5 6.1-5.6c7.3-1.5 12.8-7.9 12.8-15.7V378c0-7.7-5.5-14.2-12.8-15.7c-2.9-.6-5.3-2.7-6.1-5.6c-2-6.8-4.7-13.2-8-19.3c-1.4-2.6-1.3-5.8 .3-8.3c4.1-6.2 3.4-14.7-2-20.1l-8.5-8.5c-5.5-5.5-13.9-6.2-20.1-2c-2.5 1.6-5.7 1.8-8.3 .3c-6.1-3.3-12.5-6-19.3-8c-2.9-.8-5-3.2-5.6-6.1c-1.5-7.3-7.9-12.8-15.7-12.8H506c-7.7 0-14.2 5.5-15.7 12.8zM506 256h12c13.8 0 25.5 8.7 30 20.9c4.9 1.7 9.7 3.6 14.3 5.9c11.8-5.4 26.2-3.3 36 6.5l8.5 8.5c9.7 9.7 11.9 24.2 6.5 36c2.3 4.6 4.3 9.4 5.9 14.3c12.2 4.5 20.9 16.2 20.9 30v12c0 13.8-8.7 25.5-20.9 30c-1.7 4.9-3.6 9.7-5.9 14.3c5.4 11.8 3.3 26.2-6.5 36l-8.5 8.5c-9.7 9.7-24.2 11.9-36 6.5c-4.6 2.3-9.4 4.3-14.3 5.9c-4.5 12.2-16.2 20.9-30 20.9H506c-13.8 0-25.5-8.7-30-20.9c-4.9-1.7-9.7-3.6-14.3-5.9c-11.8 5.4-26.2 3.3-36-6.5l-8.5-8.5c-9.7-9.7-11.9-24.2-6.5-36c-2.3-4.6-4.3-9.4-5.9-14.3c-12.2-4.5-20.9-16.2-20.9-30V378c0-13.8 8.7-25.5 20.9-30c1.7-4.9 3.6-9.7 5.9-14.3c-5.4-11.8-3.3-26.2 6.5-36l8.5-8.5c9.7-9.7 24.2-11.9 36-6.5c4.6-2.3 9.4-4.3 14.3-5.9c4.5-12.2 16.2-20.9 30-20.9zM472 384a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm40 56a56 56 0 1 1 0-112 56 56 0 1 1 0 112zM122 272c-7.7 0-14.2 5.5-15.7 12.8c-.6 2.9-2.7 5.3-5.6 6.1c-6.8 2-13.2 4.7-19.3 8c-2.6 1.4-5.8 1.3-8.3-.3c-6.2-4.1-14.7-3.4-20.1 2L44.6 309c-5.5 5.5-6.2 13.9-2 20.1c1.6 2.5 1.8 5.7 .3 8.3c-3.3 6.1-6 12.5-8 19.3c-.8 2.9-3.2 5-6.1 5.6C21.5 363.8 16 370.3 16 378v12c0 7.7 5.5 14.2 12.8 15.7c2.9 .6 5.3 2.7 6.1 5.6c2 6.8 4.7 13.2 8 19.3c1.4 2.6 1.3 5.8-.3 8.3c-4.1 6.2-3.4 14.7 2 20.1l8.5 8.5c5.5 5.5 13.9 6.2 20.1 2c2.5-1.6 5.7-1.8 8.3-.3c6.1 3.3 12.5 6 19.3 8c2.9 .8 5 3.2 5.6 6.1c1.5 7.3 7.9 12.8 15.7 12.8h12c7.7 0 14.2-5.5 15.7-12.8c.6-2.9 2.7-5.3 5.6-6.1c6.8-2 13.2-4.7 19.3-8c2.6-1.4 5.8-1.3 8.3 .3c6.2 4.1 14.7 3.4 20.1-2l8.5-8.5c5.5-5.5 6.2-13.9 2-20.1c-1.6-2.5-1.8-5.7-.3-8.3c3.3-6.1 6-12.5 8-19.3c.8-2.9 3.2-5 6.1-5.6c7.3-1.5 12.8-7.9 12.8-15.7V378c0-7.7-5.5-14.2-12.8-15.7c-2.9-.6-5.3-2.7-6.1-5.6c-2-6.8-4.7-13.2-8-19.3c-1.4-2.6-1.3-5.8 .3-8.3c4.1-6.2 3.4-14.7-2-20.1l-8.5-8.5c-5.5-5.5-13.9-6.2-20.1-2c-2.5 1.6-5.7 1.8-8.3 .3c-6.1-3.3-12.5-6-19.3-8c-2.9-.8-5-3.2-5.6-6.1c-1.5-7.3-7.9-12.8-15.7-12.8H122zm-30 4.9c4.5-12.2 16.2-20.9 30-20.9h12c13.8 0 25.5 8.7 30 20.9c4.9 1.7 9.7 3.6 14.3 5.9c11.8-5.4 26.2-3.3 36 6.5l8.5 8.5c9.7 9.7 11.9 24.2 6.5 36c2.3 4.6 4.3 9.4 5.9 14.3c12.2 4.5 20.9 16.2 20.9 30v12c0 13.8-8.7 25.5-20.9 30c-1.7 4.9-3.6 9.7-5.9 14.3c5.4 11.8 3.3 26.2-6.5 36l-8.5 8.5c-9.7 9.7-24.2 11.9-36 6.5c-4.6 2.3-9.4 4.3-14.3 5.9c-4.5 12.2-16.2 20.9-30 20.9H122c-13.8 0-25.5-8.7-30-20.9c-4.9-1.7-9.7-3.6-14.3-5.9c-11.8 5.4-26.2 3.3-36-6.5l-8.5-8.5c-9.7-9.7-11.9-24.2-6.5-36c-2.3-4.6-4.3-9.4-5.9-14.3C8.7 415.5 0 403.8 0 390V378c0-13.8 8.7-25.5 20.9-30c1.7-4.9 3.6-9.7 5.9-14.3c-5.4-11.8-3.3-26.2 6.5-36l8.5-8.5c9.7-9.7 24.2-11.9 36-6.5c4.6-2.3 9.4-4.3 14.3-5.9zM128 344a40 40 0 1 0 0 80 40 40 0 1 0 0-80zm56 40A56 56 0 1 1 72 384a56 56 0 1 1 112 0zm82.1-282l-4.5-6.1c-16.3-22.2-47.8-26.2-69.1-8.8L149.9 122l34.4 46.9 81.9-67zm10.1 12.4l-81.9 67c-7.1 5.8-17.6 4.5-23-2.9L137 131.5c-5-6.9-3.8-16.5 2.8-21.8l42.7-34.9c28.4-23.2 70.4-17.9 92.1 11.7l4.5 6.1c5 6.9 3.8 16.5-2.8 21.8z'
      
    ]
  };

  
    var faBikingMountain = faPersonBikingMountain;
  

  
  

  var faHand = {
    prefix: 'fat',
    iconName: 'hand',
    icon: [
      512,
      512,
      [9995,129306,"hand-paper"],
      'f256',
      
      'M232 48V72l0 0V248c0 4.4-3.6 8-8 8s-8-3.6-8-8V80l0 0c0-17.7-14.3-32-32-32s-32 14.3-32 32V335.4c0 3.2-1.9 6.2-4.9 7.4s-6.4 .6-8.7-1.7L70.6 273.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L137.1 430.4c42 42 99 65.6 158.4 65.6H304c83.9 0 152-68.1 152-152V144c0-17.7-14.3-32-32-32s-32 14.3-32 32v56 48c0 4.4-3.6 8-8 8s-8-3.6-8-8V200 144v-8V80c0-17.7-14.3-32-32-32s-32 14.3-32 32V248c0 4.4-3.6 8-8 8s-8-3.6-8-8V80 72l0-24c0-17.7-14.3-32-32-32s-32 14.3-32 32zM264 0c25.3 0 46 19.5 47.9 44.3C320.4 36.7 331.6 32 344 32c26.5 0 48 21.5 48 48v28.2c8.5-7.6 19.7-12.2 32-12.2c26.5 0 48 21.5 48 48V344c0 92.8-75.2 168-168 168h-8.5c-63.7 0-124.7-25.3-169.7-70.3L14.1 329.9c-18.7-18.7-18.7-49.1 0-67.9s49.1-18.7 67.9 0L136 316.1V80c0-26.5 21.5-48 48-48c12.4 0 23.6 4.7 32.1 12.3C218 19.5 238.7 0 264 0z'
      
    ]
  };

  
    var faHandPaper = faHand;
  

  
  

  var faHeadSideBrain = {
    prefix: 'fat',
    iconName: 'head-side-brain',
    icon: [
      512,
      512,
      [],
      'f808',
      
      'M16 222.9C16 108.6 108.6 16 222.9 16h16.8c71.6 0 137.5 43.3 166.4 105c3.5 7.4 6.9 15.1 10.4 22.9c6.4 14.3 12.9 28.9 20.1 42.7c11.3 21.6 24.8 42.2 43.5 58.9l3.8 3.4c7.7 6.9 12.1 16.7 12.1 27c0 20-16.2 36.2-36.2 36.2H440c-4.4 0-8 3.6-8 8v72c0 22.1-17.9 40-40 40H312c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8s8-3.6 8-8V448h72c30.9 0 56-25.1 56-56V328h11.8c28.8 0 52.2-23.4 52.2-52.2c0-14.9-6.4-29.1-17.5-39l-3.8-3.4c-16.7-14.9-29.2-33.6-40-54.4c-7-13.4-13.1-27.1-19.3-41c-3.5-7.9-7.1-15.9-10.8-23.9C389.1 46.9 317.6 0 239.7 0H222.9C99.8 0 0 99.8 0 222.9c0 52.8 16.9 101.5 47.4 139.9C57.5 375.5 64 390.2 64 405.3V504c0 4.4 3.6 8 8 8s8-3.6 8-8V405.3c0-19.8-8.5-37.8-20.1-52.4C31.8 317.5 16 272.3 16 222.9zM194 113.8c6-10.7 17.2-17.8 30-17.8s24.1 7.1 30 17.8c2.1 3.8 7 5.2 10.8 3.1c4.3-2.4 9.2-3.7 14.4-3.7c10.6 0 19.9 5.5 25.4 14c1.7 2.6 4.8 4.1 7.9 3.6c1.6-.2 3.3-.4 5-.4c19 0 34.5 15.6 34.5 35.1s-15.5 35.1-34.5 35.1h-46c-2.7 0-5.2 1.4-6.7 3.6s-1.7 5.1-.7 7.6c1.9 4.3 2.9 9 2.9 14.1c0 17-11.9 31.2-27.6 34.4c-4.3 .9-7.1 5.1-6.2 9.4s5.1 7.1 9.4 6.2c23.1-4.8 40.4-25.4 40.4-50.1c0-3.1-.3-6.2-.8-9.2h35.3c28 0 50.5-23 50.5-51.1s-22.5-51.1-50.5-51.1c-.8 0-1.6 0-2.3 .1c-8.5-10.5-21.4-17.3-35.9-17.3c-5.4 0-10.5 .9-15.3 2.6c-9.2-12-23.7-19.8-40-19.8s-30.7 7.8-40 19.8c-4.8-1.7-9.9-2.6-15.3-2.6c-21.6 0-39.5 14.9-44.7 34.9c-24.9 3.2-44 24.8-44 50.7c0 19 10.3 35.6 25.5 44.4c.7 27.5 22.9 49.8 50.5 49.8c3.1 0 6.1-.3 9-.8V312c0 4.4 3.6 8 8 8s8-3.6 8-8V265.3c0-2.7-1.4-5.2-3.6-6.7s-5.1-1.7-7.6-.6c-4.2 1.9-8.9 2.9-13.8 2.9c-19 0-34.5-15.6-34.5-35.1c0-1 0-1.9 .1-2.9c.3-3.4-1.6-6.6-4.8-8C104.6 209.6 96 197.2 96 182.8c0-19.5 15.5-35.1 34.5-35.1l.2 0c4.1 0 7.5-3.1 8-7.1c1.7-15.5 14.6-27.3 30.1-27.3c5.2 0 10.1 1.3 14.4 3.7c3.9 2.1 8.7 .7 10.8-3.1z'
      
    ]
  };

  

  
  

  var faCucumber = {
    prefix: 'fat',
    iconName: 'cucumber',
    icon: [
      512,
      512,
      [129362],
      'e401',
      
      'M219.2 463.3c5.6 1.8 11.8 .4 16.2-3.9c4.3-4.3 5.7-10.6 4-16.1c-1.8-5.7-.2-11.9 4-16.1L427.2 243.2c4.2-4.2 10.4-5.7 16.1-4c5.5 1.7 11.8 .4 16.1-4c4.4-4.4 5.7-10.6 3.9-16.2c-1.7-5.4-.4-11.4 3.4-15.6c40.2-43.9 39-112.2-3.5-154.7c-43.7-43.7-114.7-43.7-158.4 0l-124 124c-4.2 4.2-10.4 5.7-16.1 4c-5.5-1.7-11.8-.4-16.1 4s-5.7 10.6-4 16.1c1.8 5.7 .2 11.9-4 16.1l-92 92c-43.7 43.7-43.7 114.7 0 158.4c42.5 42.5 110.8 43.7 154.7 3.5c4.2-3.9 10.2-5.2 15.6-3.4zM474.5 37.5c48.6 48.6 49.9 126.6 4 176.8c3.5 11 .9 23.6-7.9 32.3c-8.7 8.7-21.2 11.3-32.2 7.9L254.6 438.5c3.4 11 .8 23.5-7.9 32.2c-8.7 8.7-21.3 11.4-32.3 7.9c-50.2 45.9-128.2 44.6-176.8-4c-50-50-50-131 0-181l92-92c-3.4-11-.8-23.5 7.9-32.2s21.2-11.3 32.2-7.9l124-124c50-50 131-50 181 0zM336 128a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM160 304a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faPoliceBox = {
    prefix: 'fat',
    iconName: 'police-box',
    icon: [
      384,
      512,
      [],
      'e021',
      
      'M200 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V32H88C74.7 32 64 42.7 64 56v8C46.3 64 32 78.3 32 96V496H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H376c4.4 0 8-3.6 8-8s-3.6-8-8-8H352V96c0-17.7-14.3-32-32-32V56c0-13.3-10.7-24-24-24H200V8zM336 96V496H48V96c0-8.8 7.2-16 16-16h6.5H72 312h2.8H320c8.8 0 16 7.2 16 16zM192 48H296c4.4 0 8 3.6 8 8v8H80V56c0-4.4 3.6-8 8-8H192zM96 272h64v64H96V272zm-16 0v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zM288 144v24H264V144h24zm-64 0h24v24H224V144zm0 40h24v24H224V184zm64 24H264V184h24v24zm-64-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H224zm-88 16h24v24H136V144zm-16 0v24H96V144h24zm0 40v24H96V184h24zm16 24V184h24v24H136zM80 144v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faFlaskVial = {
    prefix: 'fat',
    iconName: 'flask-vial',
    icon: [
      640,
      512,
      [],
      'e4f3',
      
      'M224 16V327.1l-16 23.1V176H48V352c0 44.2 35.8 80 80 80c12.7 0 24.8-3 35.5-8.3c-1.7 6.1-2.8 12.4-3.2 18.7C150.2 446 139.3 448 128 448c-53 0-96-43-96-96V16H8c-4.4 0-8-3.6-8-8S3.6 0 8 0H40 216h32c4.4 0 8 3.6 8 8s-3.6 8-8 8H224zM48 160H208V16H48V160zM344 0H488h32c4.4 0 8 3.6 8 8s-3.6 8-8 8H496V221.5L628.8 413.4c7.3 10.5 11.2 23 11.2 35.8c0 34.7-28.1 62.9-62.9 62.9H254.9c-34.7 0-62.9-28.1-62.9-62.9c0-12.8 3.9-25.3 11.2-35.8L336 221.5V16H312c-4.4 0-8-3.6-8-8s3.6-8 8-8h32zm8 16V224c0 1.6-.5 3.2-1.4 4.6L287.3 320H544.7l-63.3-91.4c-.9-1.3-1.4-2.9-1.4-4.6V16H352zM216.3 422.5c-5.4 7.8-8.3 17.1-8.3 26.7c0 25.9 21 46.9 46.9 46.9H577.1c25.9 0 46.9-21 46.9-46.9c0-9.5-2.9-18.8-8.3-26.7L555.8 336H276.2l-59.9 86.5z'
      
    ]
  };

  

  
  

  var faEyeSlash = {
    prefix: 'fat',
    iconName: 'eye-slash',
    icon: [
      640,
      512,
      [],
      'f070',
      
      'M13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7zM605.5 268.3c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-47.8 0-90.1 12.9-126.3 32.5l13.7 10.9C240.3 58.7 277.9 48 320 48c75.6 0 136.6 34.4 181.7 76.3c44.9 41.7 75 91.7 89.1 125.6c1.6 3.9 1.6 8.4 0 12.3C581.7 284 566 312.4 544 341.1l12.6 9.9c23-29.9 39.4-59.7 49-82.7zM83.5 161c-23 29.9-39.4 59.7-49 82.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 90.1-12.9 126.3-32.5l-13.7-10.9C399.7 453.3 362.1 464 320 464c-75.6 0-136.6-34.4-181.7-76.3C93.4 346 63.3 296 49.2 262.2c-1.6-3.9-1.6-8.4 0-12.3C58.3 228 74 199.6 96 170.9L83.5 161zM320 368c7.8 0 15.4-.8 22.7-2.3l-17.5-13.8c-1.7 .1-3.5 .1-5.2 .1c-47.2 0-86.4-34-94.5-78.9L208 259.4C209.8 319.7 259.3 368 320 368zm0-224c-7.8 0-15.4 .8-22.7 2.3l17.5 13.8c1.7-.1 3.5-.1 5.2-.1c47.2 0 86.4 34 94.5 78.9L432 252.6C430.2 192.3 380.7 144 320 144z'
      
    ]
  };

  

  
  

  var faFacePleading = {
    prefix: 'fat',
    iconName: 'face-pleading',
    icon: [
      512,
      512,
      [],
      'e386',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM295.1 420.4c-7.6-8.4-20.6-17.4-39.1-17.4s-31.5 8.9-39.1 17.4c-3 3.3-8 3.5-11.3 .6s-3.6-8-.6-11.3c9.8-10.9 26.8-22.6 50.9-22.6s41.1 11.7 50.9 22.6c3 3.3 2.7 8.3-.6 11.3s-8.3 2.7-11.3-.6zM325.2 96.5c4.1-1.6 8.7 .5 10.3 4.7l1.2 3.1c13.3 35.5 43.6 61.8 80.6 70l8.5 1.9c4.3 1 7 5.2 6.1 9.5s-5.2 7-9.5 6.1l-7.7-1.7c10.9 13.7 17.5 31 17.5 49.9c0 44.2-35.8 80-80 80s-80-35.8-80-80s35.8-80 80-80c1.3 0 2.6 0 3.9 .1c-15-13.5-26.9-30.6-34.2-50.2l-1.2-3.1c-1.6-4.1 .5-8.7 4.7-10.3zM191.5 106.8l-1.2 3.1c-7.3 19.5-19.2 36.6-34.2 50.2c1.3-.1 2.6-.1 3.9-.1c44.2 0 80 35.8 80 80s-35.8 80-80 80s-80-35.8-80-80c0-18.9 6.5-36.2 17.5-49.9l-7.7 1.7c-4.3 1-8.6-1.8-9.5-6.1s1.8-8.6 6.1-9.5l8.5-1.9c37-8.2 67.3-34.6 80.6-70l1.2-3.1c1.6-4.1 6.2-6.2 10.3-4.7s6.2 6.2 4.7 10.3zM160 304a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm256-64a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM160 272c17.7 0 32-14.3 32-32c0-12-6.6-22.4-16.3-27.9c-2 15.7-15.5 27.9-31.7 27.9c-5.7 0-11.1-1.5-15.7-4.1c-.2 1.4-.3 2.7-.3 4.1c0 17.7 14.3 32 32 32zm-44.6-49.7c2.1-5.3 5.1-10.1 8.9-14.3c1.4-1.5 2.8-3 4.4-4.3c-.4 1.4-.6 2.8-.6 4.3c0 5.2 2.5 9.9 6.4 12.8c2.7 2 6 3.2 9.6 3.2c8.8 0 16-7.2 16-16l0-.1c0-6.7-4.3-12.5-10.2-14.8c3.3-.7 6.7-1.1 10.2-1.1c4.4 0 8.6 .6 12.6 1.7C193 199.2 208 217.9 208 240c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-6.2 1.2-12.2 3.4-17.7zM384 240c0-12-6.6-22.4-16.3-27.9c-2 15.7-15.5 27.9-31.7 27.9c-5.7 0-11.1-1.5-15.7-4.1c-.2 1.4-.3 2.7-.3 4.1c0 17.7 14.3 32 32 32s32-14.3 32-32zm-80 0c0-6.2 1.2-12.2 3.4-17.7c2.1-5.3 5.1-10.1 8.9-14.3c1.4-1.5 2.8-3 4.4-4.3c-.4 1.4-.6 2.8-.6 4.3c0 5.2 2.5 9.9 6.4 12.8c2.7 2 6 3.2 9.6 3.2c8.8 0 16-7.2 16-16c0-6.8-4.2-12.6-10.2-14.9c3.3-.7 6.7-1.1 10.2-1.1c4.4 0 8.6 .6 12.6 1.7C385 199.2 400 217.9 400 240c0 26.5-21.5 48-48 48s-48-21.5-48-48z'
      
    ]
  };

  

  
  

  var faUsers = {
    prefix: 'fat',
    iconName: 'users',
    icon: [
      640,
      512,
      [],
      'f0c0',
      
      'M80 80a64 64 0 1 1 128 0A64 64 0 1 1 80 80zm144 0A80 80 0 1 0 64 80a80 80 0 1 0 160 0zm96 64a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 176a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-58.7 48H378.7C443.5 368 496 420.5 496 485.3c0 5.9-4.8 10.7-10.7 10.7H154.7c-5.9 0-10.7-4.8-10.7-10.7C144 420.5 196.5 368 261.3 368zm0-16C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H485.3c14.7 0 26.7-11.9 26.7-26.7C512 411.7 452.3 352 378.7 352H261.3zM512 16a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 144A80 80 0 1 0 512 0a80 80 0 1 0 0 160zm24 48c48.6 0 88 39.4 88 88c0 4.4 3.6 8 8 8s8-3.6 8-8c0-57.4-46.6-104-104-104H444c1.3 5.2 2.4 10.6 3 16h89zm-343 0c.7-5.4 1.7-10.8 3-16H104C46.6 192 0 238.6 0 296c0 4.4 3.6 8 8 8s8-3.6 8-8c0-48.6 39.4-88 88-88h89z'
      
    ]
  };

  

  
  

  var faCircleF = {
    prefix: 'fat',
    iconName: 'circle-f',
    icon: [
      512,
      512,
      [],
      'e10e',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128c-13.3 0-24 10.7-24 24v96V376c0 4.4 3.6 8 8 8s8-3.6 8-8V256H312c4.4 0 8-3.6 8-8s-3.6-8-8-8H176V152c0-4.4 3.6-8 8-8H344c4.4 0 8-3.6 8-8s-3.6-8-8-8H184z'
      
    ]
  };

  

  
  

  var faRight = {
    prefix: 'fat',
    iconName: 'right',
    icon: [
      448,
      512,
      [11157,"arrow-alt-right"],
      'f356',
      
      'M432 256c0 8.1-3.2 15.9-9 21.7L274.6 426.1c-3.8 3.8-9 5.9-14.3 5.9c-11.2 0-20.3-9.1-20.3-20.3l0-99.7c0-4.4-3.6-8-8-8L40 304c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24l192 0c4.4 0 8-3.6 8-8l0-99.7c0-11.2 9.1-20.3 20.3-20.3c5.4 0 10.5 2.1 14.3 5.9L423 234.3c5.7 5.7 9 13.5 9 21.7zM260.3 448c9.6 0 18.9-3.8 25.7-10.6L434.4 289c8.7-8.7 13.7-20.6 13.7-33s-4.9-24.2-13.7-33L285.9 74.6c-6.8-6.8-16-10.6-25.7-10.6c-20 0-36.3 16.2-36.3 36.3l0 91.7L40 192c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l184 0 0 91.7c0 20 16.2 36.3 36.3 36.3z'
      
    ]
  };

  
    var faArrowAltRight = faRight;
  

  
  

  var faPersonRays = {
    prefix: 'fat',
    iconName: 'person-rays',
    icon: [
      512,
      512,
      [],
      'e54d',
      
      'M2.3 2.3c-3.1 3.1-3.1 8.2 0 11.3l104 104c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L13.7 2.3C10.5-.8 5.5-.8 2.3 2.3zm507.3 0c-3.1-3.1-8.2-3.1-11.3 0l-104 104c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l104-104c3.1-3.1 3.1-8.2 0-11.3zM13.7 509.7l104-104c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-104 104c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0zm496 0c3.1-3.1 3.1-8.2 0-11.3l-104-104c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l104 104c3.1 3.1 8.2 3.1 11.3 0zM216 56a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm96 0A56 56 0 1 0 200 56a56 56 0 1 0 112 0zM186.7 175.7c9.3-19.4 28.9-31.7 50.4-31.7h37.8c21.5 0 41.1 12.3 50.4 31.7l67.5 139.8c1.9 4 6.7 5.6 10.7 3.7s5.6-6.7 3.7-10.7L339.7 168.7c-12-24.9-37.2-40.7-64.8-40.7H237.1c-27.6 0-52.8 15.8-64.8 40.7L104.8 308.5c-1.9 4-.3 8.8 3.7 10.7s8.8 .3 10.7-3.7l67.5-139.8zM192 240c-4.4 0-8 3.6-8 8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V360c0-4.4 3.6-8 8-8s8 3.6 8 8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V248c0-4.4-3.6-8-8-8s-8 3.6-8 8V480c0 8.8-7.2 16-16 16s-16-7.2-16-16V360c0-13.3-10.7-24-24-24s-24 10.7-24 24V480c0 8.8-7.2 16-16 16s-16-7.2-16-16V248c0-4.4-3.6-8-8-8z'
      
    ]
  };

  

  
  

  var faReplyClock = {
    prefix: 'fat',
    iconName: 'reply-clock',
    icon: [
      640,
      512,
      ["reply-time"],
      'e239',
      
      'M496 16a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272A144 144 0 1 0 496 0a144 144 0 1 0 0 288zm0-224c-4.4 0-8 3.6-8 8v72c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8s-3.6-8-8-8H504V72c0-4.4-3.6-8-8-8zm16 272c0-5.6-.3-11.2-.8-16.6c-5 .4-10.1 .6-15.2 .6l-.8 0c.5 5.3 .8 10.6 .8 16c0 104.2-74.6 150.7-91.8 160c-.1 0-.2 0-.6 0c-2 0-3.7-1.6-3.7-3.7c0-1.4 1-4.4 4.7-7.8C416.8 473.1 432 451.5 432 416c0-61.9-50.1-112-112-112H224c-8.8 0-16 7.2-16 16v64c0 6.3-3.7 12-9.5 14.6s-12.5 1.5-17.2-2.7l-160-144c-3.4-3-5.3-7.4-5.3-11.9s1.9-8.9 5.3-11.9l160-144c4.7-4.2 11.4-5.3 17.2-2.7S208 89.7 208 96v64c0 8.8 7.2 16 16 16h98.9c-1-5.3-1.7-10.6-2.2-16H240 224V144 96c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144C3.9 222.3 0 230.9 0 240s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2V336 320h16 80c53 0 96 43 96 96c0 30.4-12.8 47.9-22.2 56.7c-5.5 5.1-9.8 12-9.8 19.5c0 10.9 8.8 19.7 19.7 19.7c2.8 0 5.6-.6 8.1-1.9C430.5 499.9 512 449.3 512 336z'
      
    ]
  };

  
    var faReplyTime = faReplyClock;
  

  
  

  var faMitten = {
    prefix: 'fat',
    iconName: 'mitten',
    icon: [
      448,
      512,
      [],
      'f7b5',
      
      'M0 136C0 60.9 60.9 0 136 0h16.3c60.3 0 113.3 39.7 130.4 97.5l33.3 112.8 2.5-3.7C331.9 187.4 353.7 176 377 176c39.2 0 71 31.8 71 71v1c0 17.4-6.3 34.3-17.8 47.4L366.6 368H345.4l72.8-83.2c8.9-10.2 13.8-23.3 13.8-36.9v-1c0-30.4-24.6-55-55-55c-18 0-34.9 8.9-45.2 23.7l-12.1 17.4c-1.8 2.5-4.8 3.8-7.8 3.3s-5.5-2.7-6.4-5.6L267.4 102c-15.1-51-61.9-86-115.1-86H136C69.7 16 16 69.7 16 136v8.2c0 9.8 1.2 19.6 3.6 29.1L68.2 368H51.8L4.1 177.2C1.4 166.4 0 155.4 0 144.2V136zM64 416c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16V432c0-8.8-7.2-16-16-16H64zM32 432c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V432z'
      
    ]
  };

  

  
  

  var faArrowDownZA = {
    prefix: 'fat',
    iconName: 'arrow-down-z-a',
    icon: [
      576,
      512,
      ["sort-alpha-desc","sort-alpha-down-alt"],
      'f881',
      
      'M277.7 365.7l-112 112c-3.1 3.1-8.2 3.1-11.3 0l-112-112c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L152 452.7V40c0-4.4 3.6-8 8-8s8 3.6 8 8V452.7l98.3-98.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3zM336 40c0-4.4 3.6-8 8-8H488c3.1 0 5.9 1.8 7.2 4.6s.9 6.1-1 8.5L360.9 208H488c4.4 0 8 3.6 8 8s-3.6 8-8 8H344c-3.1 0-5.9-1.8-7.2-4.6s-.9-6.1 1-8.5L471.1 48H344c-4.4 0-8-3.6-8-8zm87.2 252.4l63.9 127.9 .2 .3 23.9 47.8c2 4 .4 8.8-3.6 10.7s-8.8 .4-10.7-3.6L475.1 432H356.9l-21.8 43.6c-2 4-6.8 5.6-10.7 3.6s-5.6-6.8-3.6-10.7l23.9-47.8 .1-.3 63.9-127.9c1.4-2.7 4.1-4.4 7.2-4.4s5.8 1.7 7.2 4.4zM467.1 416L416 313.9 364.9 416H467.1z'
      
    ]
  };

  
    var faSortAlphaDesc = faArrowDownZA;
  
    var faSortAlphaDownAlt = faArrowDownZA;
  

  
  

  var faBagShopping = {
    prefix: 'fat',
    iconName: 'bag-shopping',
    icon: [
      448,
      512,
      ["shopping-bag"],
      'f290',
      
      'M144 96v32H304V96c0-44.2-35.8-80-80-80s-80 35.8-80 80zm-16 48H48c-17.7 0-32 14.3-32 32V416c0 44.2 35.8 80 80 80H352c44.2 0 80-35.8 80-80V176c0-17.7-14.3-32-32-32H320v88c0 4.4-3.6 8-8 8s-8-3.6-8-8V144H144v88c0 4.4-3.6 8-8 8s-8-3.6-8-8V144zm0-16V96c0-53 43-96 96-96s96 43 96 96v32h80c26.5 0 48 21.5 48 48V416c0 53-43 96-96 96H96c-53 0-96-43-96-96V176c0-26.5 21.5-48 48-48h80z'
      
    ]
  };

  
    var faShoppingBag = faBagShopping;
  

  
  

  var faHandHeart = {
    prefix: 'fat',
    iconName: 'hand-heart',
    icon: [
      512,
      512,
      [],
      'f4bc',
      
      'M264 16c17.7 0 32 14.3 32 32l0 24v8V248c0 4.4 3.6 8 8 8s8-3.6 8-8V80c0-17.7 14.3-32 32-32s32 14.3 32 32v56 8 56 48c0 4.4 3.6 8 8 8s8-3.6 8-8V200 144c0-17.7 14.3-32 32-32s32 14.3 32 32V344c0 83.9-68.1 152-152 152h-8.5c-59.4 0-116.4-23.6-158.4-65.6L25.4 318.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l67.7 67.7c2.3 2.3 5.7 3 8.7 1.7s4.9-4.2 4.9-7.4V80c0-17.7 14.3-32 32-32s32 14.3 32 32l0 0V248c0 4.4 3.6 8 8 8s8-3.6 8-8V72l0 0V48c0-17.7 14.3-32 32-32zm47.9 28.3C310 19.5 289.3 0 264 0s-46 19.5-47.9 44.3C207.6 36.7 196.4 32 184 32c-26.5 0-48 21.5-48 48V316.1L81.9 262.1c-18.7-18.7-49.1-18.7-67.9 0s-18.7 49.1 0 67.9L125.8 441.7c45 45 106.1 70.3 169.7 70.3H304c92.8 0 168-75.2 168-168V144c0-26.5-21.5-48-48-48c-12.3 0-23.5 4.6-32 12.2V80c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3zM204.6 336.6c0-20.2 16.4-36.6 36.6-36.6h.6c9.7 0 19 3.8 26 10.5l14.6 14.2c3.1 3 8 3 11.2 0l14.6-14.2c7-6.8 16.3-10.5 26-10.5h.6c20.2 0 36.6 16.4 36.6 36.6c0 9.3-3.6 18.3-10 25.1l-67.6 71.7c-1.5 1.6-3.6 2.5-5.8 2.5s-4.3-.9-5.8-2.5l-67.6-71.7c-6.4-6.8-10-15.8-10-25.1zM241.2 284c-29.1 0-52.6 23.6-52.6 52.6c0 13.4 5.1 26.3 14.3 36.1l67.6 71.7c4.5 4.8 10.9 7.5 17.5 7.5s12.9-2.7 17.5-7.5l67.6-71.7c9.2-9.8 14.3-22.7 14.3-36.1c0-29.1-23.6-52.6-52.6-52.6h-.6c-13.9 0-27.2 5.4-37.1 15.1l-9 8.8-9-8.8c-9.9-9.7-23.3-15.1-37.1-15.1h-.6z'
      
    ]
  };

  

  
  

  var faTruckContainerEmpty = {
    prefix: 'fat',
    iconName: 'truck-container-empty',
    icon: [
      640,
      512,
      [],
      'e2b5',
      
      'M448 160c0-13.3 10.7-24 24-24h72c12.6 0 24.4 5.9 32 16l56 74.7c5.2 6.9 8 15.3 8 24V304v72c0 17.7-14.3 32-32 32h-.4c-4 40.4-38.1 72-79.6 72c-44.2 0-80-35.8-80-80H304c0 44.2-35.8 80-80 80c-31.7 0-59-18.4-72-45.1C139 461.6 111.7 480 80 480c-44.2 0-80-35.8-80-80s35.8-80 80-80c31.7 0 59 18.4 72 45.1c13-26.7 40.3-45.1 72-45.1c38.7 0 71 27.5 78.4 64H448V352 160zM608 392c8.8 0 16-7.2 16-16V304 256H464v96c14.6-19.4 37.8-32 64-32c41.5 0 75.6 31.6 79.6 72h.4zm13.5-152c-.6-1.3-1.4-2.6-2.3-3.7l-56-74.7c-4.5-6-11.6-9.6-19.2-9.6H472c-4.4 0-8 3.6-8 8v80H621.5zM528 464a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM288 400a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM80 464a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  

  
  

  var faCalendarExclamation = {
    prefix: 'fat',
    iconName: 'calendar-exclamation',
    icon: [
      448,
      512,
      [],
      'f334',
      
      'M120 0c4.4 0 8 3.6 8 8V64H320V8c0-4.4 3.6-8 8-8s8 3.6 8 8V64h48c35.3 0 64 28.7 64 64v48 16V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 176 128C0 92.7 28.7 64 64 64h48V8c0-4.4 3.6-8 8-8zM432 192H16V448c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V192zM112 120V80H64c-26.5 0-48 21.5-48 48v48H432V128c0-26.5-21.5-48-48-48H336v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V80H128v40c0 4.4-3.6 8-8 8s-8-3.6-8-8zm96 296a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm24-168V360c0 4.4-3.6 8-8 8s-8-3.6-8-8V248c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faSink = {
    prefix: 'fat',
    iconName: 'sink',
    icon: [
      512,
      512,
      [],
      'e06d',
      
      'M264 72c0-30.9 25.1-56 56-56s56 25.1 56 56v48c0 4.4 3.6 8 8 8s8-3.6 8-8V72c0-39.8-32.2-72-72-72s-72 32.2-72 72V288H144V264c0-22.1-17.9-40-40-40H40c-4.4 0-8 3.6-8 8s3.6 8 8 8h64c13.3 0 24 10.7 24 24v24H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H384V264c0-13.3 10.7-24 24-24h64c4.4 0 8-3.6 8-8s-3.6-8-8-8H408c-22.1 0-40 17.9-40 40v24H264V72zM32 304H136 256 376 480c8.8 0 16 7.2 16 16s-7.2 16-16 16H32c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 80v24c0 57.4 46.6 104 104 104H376c57.4 0 104-46.6 104-104V384H464v24c0 48.6-39.4 88-88 88H136c-48.6 0-88-39.4-88-88V384H32z'
      
    ]
  };

  

  
  

  var faSunset = {
    prefix: 'fat',
    iconName: 'sunset',
    icon: [
      576,
      512,
      [127751],
      'f767',
      
      'M293.7 221.7c-3.1 3.1-8.2 3.1-11.3 0l-88-88c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L280 196.7V8c0-4.4 3.6-8 8-8s8 3.6 8 8V196.7l74.3-74.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-88 88zm-111.2 3.6c5-2.1 10.7-1.5 15.2 1.6L288 289.1l90.3-62.3c4.5-3.1 10.2-3.7 15.2-1.6s8.6 6.6 9.6 11.9L423 345l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6l-7.4 3.1 7.4-3.1c2.1 5 1.5 10.7-1.6 15.2L489.9 464H470.5L528 380.6 414.7 359.8c-3.3-.6-5.8-3.2-6.4-6.4L387.4 240l-94.9 65.4c-2.7 1.9-6.3 1.9-9.1 0L188.6 240 167.8 353.3c-.6 3.3-3.2 5.8-6.4 6.4L48 380.6 105.5 464H86.1L34.8 389.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L153 345l19.8-107.9c1-5.3 4.6-9.8 9.6-11.9zM398.9 464H382.7c-7.6-45.4-47.1-80-94.7-80s-87.1 34.6-94.7 80H177.1c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96zM8 496H568c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faMicroscope = {
    prefix: 'fat',
    iconName: 'microscope',
    icon: [
      512,
      512,
      [128300],
      'f610',
      
      'M176 24V40c0 4.4-3.6 8-8 8h-8c-8.8 0-16 7.2-16 16V288c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V144 128 64c0-8.8-7.2-16-16-16h-8c-4.4 0-8-3.6-8-8V24c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zM288 144V288c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32V24c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v8c17.7 0 32 14.3 32 32v64c106 0 192 86 192 192c0 78.7-47.4 146.4-115.1 176H504c4.4 0 8 3.6 8 8s-3.6 8-8 8H288 208 8c-4.4 0-8-3.6-8-8s3.6-8 8-8H208h80c97.2 0 176-78.8 176-176s-78.8-176-176-176zM160 360c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-4.4 0-8-3.6-8-8zM96 424c0-4.4 3.6-8 8-8H312c4.4 0 8 3.6 8 8s-3.6 8-8 8H104c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faHourglassHalf = {
    prefix: 'fat',
    iconName: 'hourglass-half',
    icon: [
      384,
      512,
      ["hourglass-2"],
      'f252',
      
      'M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8H32V71.2c0 48.3 23 93.7 61.8 122.4L178.5 256 93.8 318.4C55 347 32 392.5 32 440.8V496H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H376c4.4 0 8-3.6 8-8s-3.6-8-8-8H352V440.8c0-48.3-23-93.7-61.8-122.4L205.5 256l84.7-62.4C329 165 352 119.5 352 71.2V16h24c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zM336 16V71.2c0 19.9-4.3 39.2-12.4 56.8H60.4C52.3 110.4 48 91.1 48 71.2V16H336zM314.9 144c-8.9 14.1-20.5 26.6-34.2 36.7L192 246.1l-88.7-65.3C89.6 170.6 78 158.1 69.1 144H314.9zM192 265.9l88.7 65.3c28 20.7 46.8 51.1 53.1 84.7H50.3c6.2-33.7 25-64.1 53.1-84.7L192 265.9zM48 440.8c0-2.9 .1-5.9 .3-8.8H335.7c.2 2.9 .3 5.8 .3 8.8V496H48V440.8z'
      
    ]
  };

  
    var faHourglass2 = faHourglassHalf;
  

  
  

  var faCircleCalendar = {
    prefix: 'fat',
    iconName: 'circle-calendar',
    icon: [
      512,
      512,
      ["calendar-circle"],
      'e102',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM200 96c4.4 0 8 3.6 8 8v24h96V104c0-4.4 3.6-8 8-8s8 3.6 8 8v24h16c26.5 0 48 21.5 48 48v32 16V336c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48V224 208 176c0-26.5 21.5-48 48-48h16V104c0-4.4 3.6-8 8-8zm-8 72V144H176c-17.7 0-32 14.3-32 32v32H368V176c0-17.7-14.3-32-32-32H320v24c0 4.4-3.6 8-8 8s-8-3.6-8-8V144H208v24c0 4.4-3.6 8-8 8s-8-3.6-8-8zm176 56H144V336c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V224z'
      
    ]
  };

  
    var faCalendarCircle = faCircleCalendar;
  

  
  

  var faCircleW = {
    prefix: 'fat',
    iconName: 'circle-w',
    icon: [
      512,
      512,
      [],
      'e12c',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM127.7 149.7c-1.3-4.2-5.7-6.6-10-5.4s-6.6 5.7-5.4 10l72 240c1 3.4 4.1 5.7 7.7 5.7s6.7-2.3 7.7-5.7L256 204.2l56.3 190.1c1 3.4 4.1 5.7 7.7 5.7s6.7-2.3 7.7-5.7l72-240c1.3-4.2-1.1-8.7-5.4-10s-8.7 1.1-10 5.4L320 364 263.7 173.7c-1-3.4-4.1-5.7-7.7-5.7s-6.7 2.3-7.7 5.7L192 364 127.7 149.7z'
      
    ]
  };

  

  
  

  var faHeartCircleMinus = {
    prefix: 'fat',
    iconName: 'heart-circle-minus',
    icon: [
      576,
      512,
      [],
      'e4ff',
      
      'M393.6 57.7c-42.9-5.6-85.8 12.6-111.2 47.6l-20 27.5c-1.5 2.1-3.9 3.3-6.5 3.3s-5-1.2-6.5-3.3l-20-27.5c-25.4-34.9-68.3-53.2-111.2-47.6C60.1 65.3 16 114.9 16 173.5c0 30.3 11.8 59.4 32.9 81.2L248 460.4c2.2 2.3 5.2 3.6 8.4 3.6s6.2-1.3 8.4-3.6l11-11.4c2.6 4.9 5.4 9.7 8.4 14.4l-7.8 8.1c-5.2 5.4-12.4 8.5-19.9 8.5c-7.5 0-14.7-3-19.9-8.4L37.4 265.8C13.4 241.1 0 208 0 173.5C0 106.8 50.2 50.4 116.3 41.8c48.6-6.3 97.4 14.3 126.2 54L256 114.4l13.5-18.6c28.9-39.7 77.6-60.4 126.2-54c66.1 8.6 116.3 65 116.3 131.8c0 12-1.6 23.9-4.8 35.3c-4.9-2.3-9.8-4.4-14.9-6.2c2.4-9.4 3.7-19.2 3.7-29C496 115 451.9 65.3 393.6 57.7zM432 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm80 144c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8s3.6-8 8-8H504c4.4 0 8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faWaveSine = {
    prefix: 'fat',
    iconName: 'wave-sine',
    icon: [
      640,
      512,
      [8767],
      'f899',
      
      'M15.8 249.8l0 0 0 0c-1 4.3-5.3 7-9.6 6s-7-5.3-6-9.6L8 248c-7.8-1.8-7.8-1.8-7.8-1.8l0 0 0 0 0-.1 .1-.5c.1-.4 .2-1 .4-1.8c.4-1.6 1-3.9 1.8-6.8c1.6-5.8 4-14.1 7.2-23.9c6.5-19.8 16.4-46.2 30.1-72.7C53.6 113.9 71.4 87 93.7 66.6C116.1 46.1 143.5 32 176 32c48.2 0 79.4 30 101.6 71.7c21.9 41.3 36.1 96.1 50 149.6l.2 .7c0 .1 0 .1 0 .2c14.1 54.2 27.8 107.1 48.8 146.6C397.4 440 424.2 464 464 464c27.5 0 51.1-11.9 71.5-30.4c20.4-18.6 37.1-43.7 50.4-69.3c13.2-25.5 22.8-51.1 29.1-70.3c3.1-9.6 5.4-17.6 7-23.2c.8-2.8 1.3-5 1.7-6.4l.4-1.7 .1-.4 0-.1 0 0 0 0 0 0c1-4.3 5.3-7 9.6-6s7 5.3 6 9.6L632 264c7.8 1.8 7.8 1.8 7.8 1.8l0 0 0 0 0 .1-.1 .5c-.1 .4-.2 1-.4 1.8c-.4 1.6-1 3.9-1.8 6.8c-1.6 5.8-4 14.1-7.2 23.9c-6.5 19.8-16.4 46.2-30.1 72.7c-13.7 26.4-31.5 53.3-53.8 73.7C523.9 465.8 496.5 480 464 480c-48.2 0-79.4-30-101.6-71.7c-21.9-41.3-36.1-96.1-50-149.6l-.2-.7c0-.1 0-.1 0-.2c-14.1-54.2-27.8-107.1-48.8-146.6C242.6 72 215.8 48 176 48c-27.5 0-51.1 11.9-71.5 30.4C84.1 97 67.4 122.1 54.1 147.7C40.9 173.2 31.3 198.7 25 218c-3.1 9.6-5.4 17.6-7 23.2c-.8 2.8-1.3 5-1.7 6.4l-.4 1.7-.1 .4 0 .1 0 0z'
      
    ]
  };

  

  
  

  var faDisplayChartUpCircleDollar = {
    prefix: 'fat',
    iconName: 'display-chart-up-circle-dollar',
    icon: [
      640,
      512,
      [],
      'e5e6',
      
      'M512 16H64C37.5 16 16 37.5 16 64V352c0 26.5 21.5 48 48 48H231.8h.3 90.8c1 5.4 2.2 10.8 3.7 16H238.8l-13.3 80H288h62.6 16.2 8.4c6.1 5.8 12.7 11.1 19.6 16H360 216 136c-4.4 0-8-3.6-8-8s3.6-8 8-8h73.2l13.3-80H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V211.2c-5.2-2.7-10.5-5.1-16-7.2V64c0-26.5-21.5-48-48-48zm0 176.7c-5.3-.5-10.6-.7-16-.7V80H80l0 256H322.9c-1 5.3-1.7 10.6-2.2 16H80c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16V192.7zm-64 5.9c-5.4 1.5-10.8 3.3-16 5.4V155.3L325.7 261.7c-1.5 1.5-3.5 2.3-5.7 2.3s-4.2-.8-5.7-2.3L240 187.3 133.7 293.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l112-112c3.1-3.1 8.2-3.1 11.3 0L320 244.7 420.7 144H352c-4.4 0-8-3.6-8-8s3.6-8 8-8h88c4.4 0 8 3.6 8 8v62.6zM496 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm-28.2 93.9c-8 4.1-12.3 9.7-11.7 17.6c.4 5.2 3.6 9.5 11.5 13.5c7.9 4 18.3 6.8 30 10l1 .3c11.5 3.1 24.3 6.6 34.1 12.1c10.2 5.7 18.8 14.5 19.2 28.4c.5 16.4-8.9 27-20.4 33c-8.5 4.4-18.5 6.5-27.6 7.1v17.7 8H488v-8V439.4c-12.6-1.4-24.7-5.1-35.9-8.5l0 0c-2.1-.7-4.3-1.3-6.3-1.9l-7.7-2.3 4.5-15.3 7.7 2.3c2.3 .7 4.5 1.3 6.7 2l0 0 0 0c13.6 4.1 26.1 7.9 39.2 8.3c9.4 .3 20.1-1.4 28-5.5c7.6-3.9 12-9.6 11.7-18.3c-.2-6.2-3.6-10.7-11.1-14.9c-7.8-4.4-18.5-7.4-30.5-10.6l-1.8-.5c-11-2.9-22.9-6.1-32.3-11c-10.1-5.2-19.3-13.3-20.2-26.7c-1.1-16.5 8.9-27.1 20.4-32.9c8.5-4.3 18.5-6.5 27.4-7.3V280v-8h16v8 16.4c10.2 .8 20.4 2.8 29.8 5l7.8 1.8-3.7 15.6-7.8-1.8c-11.4-2.7-23.1-4.8-34.3-5c-8.8-.1-19.8 1.6-28.1 5.8z'
      
    ]
  };

  

  
  

  var faShareNodes = {
    prefix: 'fat',
    iconName: 'share-nodes',
    icon: [
      448,
      512,
      ["share-alt"],
      'f1e0',
      
      'M448 112c0 44.2-35.8 80-80 80c-25.9 0-48.9-12.3-63.5-31.3L157.1 234.4c1.9 6.9 2.9 14.1 2.9 21.6s-1 14.7-2.9 21.6l147.5 73.7c14.6-19 37.6-31.3 63.5-31.3c44.2 0 80 35.8 80 80s-35.8 80-80 80s-80-35.8-80-80c0-12.6 2.9-24.5 8.1-35L151.2 292.5C137.9 318.3 111 336 80 336c-44.2 0-80-35.8-80-80s35.8-80 80-80c31 0 57.9 17.7 71.2 43.5L296.1 147c-5.2-10.6-8.1-22.5-8.1-35c0-44.2 35.8-80 80-80s80 35.8 80 80zM80 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM432 112a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM368 464a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  
    var faShareAlt = faShareNodes;
  

  
  

  var faKnife = {
    prefix: 'fat',
    iconName: 'knife',
    icon: [
      512,
      512,
      ["utensil-knife"],
      'f2e4',
      
      'M460.7 7.3C465 2.6 471.1 0 477.4 0c9.3 0 18 5.7 21 15.1c5 15.8 13.6 49.4 13.6 92.1c0 48.6-15.3 85.8-42.7 122.7c-23 31-54.7 62.1-93 99.5c-6.7 6.6-13.7 13.4-20.8 20.4c0 0 0 0 0 0L345.3 360c-12.7 12.7-30 19.9-48 19.9s-35.3-7.1-48-19.9l-49.7-49.7L13.8 509.5c-3 3.2-8.1 3.4-11.3 .4s-3.4-8.1-.4-11.3L193.6 293.4 460.7 7.3zM210.6 298.6l50 50c9.7 9.7 22.9 15.2 36.7 15.2s27-5.5 36.7-15.2l10.2-10.2 0 0c7.3-7.1 14.3-14 21.1-20.7c38.4-37.5 69-67.6 91.2-97.4c25.7-34.7 39.5-68.7 39.5-113.2c0-40.7-8.2-72.5-12.9-87.3c-.7-2.2-2.8-3.9-5.7-3.9c-1.9 0-3.8 .8-5.1 2.2L210.6 298.6z'
      
    ]
  };

  
    var faUtensilKnife = faKnife;
  

  
  

  var faLightbulbOn = {
    prefix: 'fat',
    iconName: 'lightbulb-on',
    icon: [
      640,
      512,
      [],
      'f672',
      
      'M44.1 1.1c-3.8-2.3-8.7-1-11 2.7s-1 8.7 2.7 11l80 48c3.8 2.3 8.7 1 11-2.7s1-8.7-2.7-11l-80-48zm560 13.7c3.8-2.3 5-7.2 2.7-11s-7.2-5-11-2.7l-80 48c-3.8 2.3-5 7.2-2.7 11s7.2 5 11 2.7l80-48zM8 160c-4.4 0-8 3.6-8 8s3.6 8 8 8H88c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zm544 0c-4.4 0-8 3.6-8 8s3.6 8 8 8h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H552zM124.1 270.9c3.8-2.3 5-7.2 2.7-11s-7.2-5-11-2.7l-80 48c-3.8 2.3-5 7.2-2.7 11s7.2 5 11 2.7l80-48zm400-13.7c-3.8-2.3-8.7-1-11 2.7s-1 8.7 2.7 11l80 48c3.8 2.3 8.7 1 11-2.7s1-8.7-2.7-11l-80-48zM480 176c0 33.9-10.5 65.3-28.5 91.2c-4.5 6.5-9.5 13.3-14.5 20.2c-12.5 17.2-25.9 35.5-36.3 54.4c-7.4 13.5-11.6 27.8-14 42.2H403c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8l0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0S144 78.8 144 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0 0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5h16.2c-2.4-14.4-6.6-28.7-14-42.2c-10.4-19-23.7-37.3-36.3-54.4l0 0 0 0c-5-6.9-10-13.7-14.5-20.2c-18-25.9-28.5-57.3-28.5-91.2c0-88.4 71.6-160 160-160s160 71.6 160 160zm-256-8c0-48.6 39.4-88 88-88c4.4 0 8-3.6 8-8s-3.6-8-8-8c-57.4 0-104 46.6-104 104c0 4.4 3.6 8 8 8s8-3.6 8-8zm96 328c-35.3 0-64-28.7-64-64H384c0 35.3-28.7 64-64 64zm-80-69.3V432c0 44.2 35.8 80 80 80s80-35.8 80-80v-5.3c0-5.9-4.8-10.7-10.7-10.7H250.7c-5.9 0-10.7 4.8-10.7 10.7z'
      
    ]
  };

  

  
  

  var faMessageMiddleTop = {
    prefix: 'fat',
    iconName: 'message-middle-top',
    icon: [
      512,
      512,
      ["comment-middle-top-alt"],
      'e1e2',
      
      'M343.5 112H448c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V160c0-26.5 21.5-48 48-48H168.5c4.7 0 9.3-2.1 12.3-5.8L256 16l75.2 90.2c3 3.6 7.5 5.8 12.3 5.8zm-175-16H64C28.7 96 0 124.7 0 160V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H343.5L268.3 5.8C265.3 2.1 260.7 0 256 0s-9.3 2.1-12.3 5.8L168.5 96z'
      
    ]
  };

  
    var faCommentMiddleTopAlt = faMessageMiddleTop;
  

  
  

  var faCarSide = {
    prefix: 'fat',
    iconName: 'car-side',
    icon: [
      640,
      512,
      [128663],
      'f5e4',
      
      'M171.3 48H240V80v96 16H75.8L119.3 83.2c8.5-21.3 29.1-35.2 52-35.2zM256 208H512c61.9 0 112 50.1 112 112v48c0 8.8-7.2 16-16 16H576c0-53-43-96-96-96s-96 43-96 96H256c0-53-43-96-96-96s-96 43-96 96H32c-8.8 0-16-7.2-16-16V256c0-26.5 21.5-48 48-48H240h16zM574.7 400H608c17.7 0 32-14.3 32-32V320c0-69.4-55.2-125.9-124.1-127.9L409.5 59c-13.7-17.1-34.3-27-56.2-27H171.3c-29.4 0-55.9 17.9-66.9 45.3l-46 115C25.7 195 0 222.5 0 256V368c0 17.7 14.3 32 32 32H65.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H385.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80zM495.4 192H256V176 80 48h97.2c17 0 33.1 7.7 43.7 21l98.4 123zM160 304a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm240 80a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z'
      
    ]
  };

  

  
  

  var faSquareSliders = {
    prefix: 'fat',
    iconName: 'square-sliders',
    icon: [
      448,
      512,
      ["sliders-h-square"],
      'f3f0',
      
      'M16 416c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-320c0-26.5-21.5-48-48-48L64 48C37.5 48 16 69.5 16 96l0 320zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm64 72c0-4.4 3.6-8 8-8l56 0 0-24c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-24-56 0c-4.4 0-8-3.6-8-8zm80 0l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32zm80 0c0-4.4 3.6-8 8-8l144 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-144 0c-4.4 0-8-3.6-8-8zM72 352c-4.4 0-8-3.6-8-8s3.6-8 8-8l152 0 0-24c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-24L72 352zm168-40l0 32 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16s-16 7.2-16 16zm88 40c-4.4 0-8-3.6-8-8s3.6-8 8-8l48 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-48 0z'
      
    ]
  };

  
    var faSlidersHSquare = faSquareSliders;
  

  
  

  var faPenToSquare = {
    prefix: 'fat',
    iconName: 'pen-to-square',
    icon: [
      512,
      512,
      ["edit"],
      'f044',
      
      'M460.3 39.6l12.1 12.1c15.6 15.6 15.6 40.9 0 56.6L440 140.7 371.3 72l32.4-32.4c15.6-15.6 40.9-15.6 56.6 0zM175.4 267.9L360 83.3 428.7 152 244.1 336.6c-5.3 5.3-12 9-19.3 10.7l-78.1 18 18-78.1c1.7-7.3 5.4-14 10.7-19.3zm217-239.6L164.1 256.6c-7.4 7.4-12.6 16.8-15 27l-20.9 90.6c-.6 2.7 .2 5.5 2.1 7.5s4.8 2.8 7.5 2.1l90.6-20.9c10.2-2.4 19.6-7.5 27-15L483.7 119.6c21.9-21.9 21.9-57.3 0-79.2L471.6 28.3c-21.9-21.9-57.3-21.9-79.2 0zM72 64C32.2 64 0 96.2 0 136V440c0 39.8 32.2 72 72 72H376c39.8 0 72-32.2 72-72V296c0-4.4-3.6-8-8-8s-8 3.6-8 8V440c0 30.9-25.1 56-56 56H72c-30.9 0-56-25.1-56-56V136c0-30.9 25.1-56 56-56H216c4.4 0 8-3.6 8-8s-3.6-8-8-8H72z'
      
    ]
  };

  
    var faEdit = faPenToSquare;
  

  
  

  var faSackDollar = {
    prefix: 'fat',
    iconName: 'sack-dollar',
    icon: [
      512,
      512,
      [128176],
      'f81d',
      
      'M196.8 128H315.2l9.2 5.9C380.2 169.6 496 259.6 496 416c0 44.2-35.8 80-80 80H96c-44.2 0-80-35.8-80-80c0-156.4 115.8-246.4 171.6-282.1l9.2-5.9zm122.5-16H192.7l-.5-.7L135.1 28.5c-3.7-5.3 .1-12.5 6.6-12.5H370.3c6.4 0 10.2 7.2 6.6 12.5l-57.1 82.8-.5 .7zM165.7 129.2C105.1 170.8 0 262.9 0 416c0 53 43 96 96 96H416c53 0 96-43 96-96c0-153.1-105.1-245.2-165.7-286.8c-4.7-3.3-9.2-6.2-13.3-8.8l9.1-13.2 48-69.6C401 21.7 389.6 0 370.3 0H141.7C122.4 0 111 21.7 121.9 37.6l48 69.6 9.1 13.2c-4.1 2.6-8.6 5.6-13.3 8.8zM264 224c0-4.4-3.6-8-8-8s-8 3.6-8 8v16.4c-8.4 .7-16.2 2.6-23 5.7c-12.4 5.6-21.9 15.4-24.2 28.8c-1.4 8.2-.6 15.4 2.4 21.8c3 6.3 7.8 11 13.2 14.7c10 6.8 23.7 10.9 35.9 14.6l1.7 .5c13.4 4 25 7.8 32.9 13.5c3.7 2.7 6.3 5.7 7.7 9c1.4 3.3 2.1 7.6 1.1 13.5c-1.4 8.2-6.5 14.1-15.1 17.8c-8.8 3.8-21.1 5-35.4 2.7c-7.1-1.2-19.2-5.3-28.8-8.5l0 0 0 0c-2.1-.7-4-1.4-5.7-1.9c-4.2-1.4-8.7 .9-10.1 5.1s.9 8.7 5.1 10.1c1.4 .5 3.1 1 5 1.7l0 0 0 0c9.4 3.2 23.4 8 32 9.4l0 0c1.8 .3 3.7 .5 5.5 .7V416c0 4.4 3.6 8 8 8s8-3.6 8-8V399.9c8.3-.5 16-2.1 22.7-5c12.6-5.4 22.1-15.4 24.5-29.7c1.5-8.5 .7-16-2.1-22.6c-2.9-6.6-7.5-11.6-13-15.5c-10.5-7.6-24.9-12-37.6-15.8l-.3-.1 0 0c-13.4-4-25-7.5-32.9-12.9c-3.8-2.6-6.3-5.3-7.7-8.3c-1.4-2.9-2.1-6.8-1.1-12.2c1.2-6.8 6.2-12.9 15.1-17c9-4.1 21.4-5.7 35.4-3.5c4.5 .7 18.5 3.4 22.9 4.6c4.3 1.1 8.7-1.4 9.8-5.7s-1.4-8.7-5.7-9.8c-5.2-1.4-19.8-4.2-24.6-4.9c-1.8-.3-3.7-.5-5.5-.7V224z'
      
    ]
  };

  

  
  

  var faCrosshairsSimple = {
    prefix: 'fat',
    iconName: 'crosshairs-simple',
    icon: [
      512,
      512,
      [],
      'e59f',
      
      'M495.9 248H392c-4.4 0-8 3.6-8 8s3.6 8 8 8H495.9C491.7 390.2 390.2 491.7 264 495.9V392c0-4.4-3.6-8-8-8s-8 3.6-8 8V495.9C121.8 491.7 20.3 390.2 16.1 264H120c4.4 0 8-3.6 8-8s-3.6-8-8-8H16.1C20.3 121.8 121.8 20.3 248 16.1V120c0 4.4 3.6 8 8 8s8-3.6 8-8V16.1C390.2 20.3 491.7 121.8 495.9 248zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256z'
      
    ]
  };

  

  
  

  var faBridgeLock = {
    prefix: 'fat',
    iconName: 'bridge-lock',
    icon: [
      640,
      512,
      [],
      'e4cc',
      
      'M40 32c-4.4 0-8 3.6-8 8s3.6 8 8 8h80v96H40c-4.4 0-8 3.6-8 8s3.6 8 8 8H528h72c4.4 0 8-3.6 8-8s-3.6-8-8-8H520V48h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H40zM389.6 325.7c2.8-6.2 6.5-11.9 11.1-16.8C387.1 277.8 356.1 256 320 256c-48.6 0-88 39.4-88 88v96c0 13.3-10.7 24-24 24H176c-13.3 0-24-10.7-24-24V344c0-48.6-39.4-88-88-88H40c-4.4 0-8 3.6-8 8s3.6 8 8 8H64c39.8 0 72 32.2 72 72v96c0 22.1 17.9 40 40 40h32c22.1 0 40-17.9 40-40V344c0-39.8 32.2-72 72-72c33.4 0 61.5 22.8 69.6 53.7zM504 48v96H392V48H504zM376 48v96H264V48H376zM248 48v96H136V48H248zM528 208c26.5 0 48 21.5 48 48v64H480V256c0-26.5 21.5-48 48-48zm-64 48v64H448c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H592V256c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-16 80h16 16 96 16 16c8.8 0 16 7.2 16 16V480c0 8.8-7.2 16-16 16H448c-8.8 0-16-7.2-16-16V352c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faFolderArrowUp = {
    prefix: 'fat',
    iconName: 'folder-arrow-up',
    icon: [
      512,
      512,
      ["folder-upload"],
      'e054',
      
      'M496 416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H197.5c12.7 0 24.9 5.1 33.9 14.1l35.9 35.9c9 9 21.2 14.1 33.9 14.1H448c26.5 0 48 21.5 48 48V416zM64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H301.3c-8.5 0-16.6-3.4-22.6-9.4L242.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64zm200-88V203.3l74.3 74.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-88-88c-3.1-3.1-8.2-3.1-11.3 0l-88 88c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L248 203.3V392c0 4.4 3.6 8 8 8s8-3.6 8-8z'
      
    ]
  };

  
    var faFolderUpload = faFolderArrowUp;
  

  
  

  var faSquareSmall = {
    prefix: 'fat',
    iconName: 'square-small',
    icon: [
      320,
      512,
      [],
      'e27e',
      
      'M256 112c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V160c0-26.5 21.5-48 48-48H256zM64 96C28.7 96 0 124.7 0 160V352c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H64z'
      
    ]
  };

  

  
  

  var faBackpack = {
    prefix: 'fat',
    iconName: 'backpack',
    icon: [
      448,
      512,
      [127890],
      'f5d4',
      
      'M184 16h80c13.3 0 24 10.7 24 24V80H160V40c0-13.3 10.7-24 24-24zM144 40V80H128C57.3 80 0 137.3 0 208V448c0 35.3 28.7 64 64 64H88 360h24c35.3 0 64-28.7 64-64V208c0-70.7-57.3-128-128-128H304V40c0-22.1-17.9-40-40-40H184c-22.1 0-40 17.9-40 40zM368 496V384 344c0-30.9-25.1-56-56-56H136c-30.9 0-56 25.1-56 56v40V496H64c-26.5 0-48-21.5-48-48V208C16 146.1 66.1 96 128 96H320c61.9 0 112 50.1 112 112V448c0 26.5-21.5 48-48 48H368zM96 496V392H352V496H96zm40-304c-4.4 0-8 3.6-8 8s3.6 8 8 8H312c4.4 0 8-3.6 8-8s-3.6-8-8-8H136zM352 376H96V344c0-22.1 17.9-40 40-40H312c22.1 0 40 17.9 40 40v32z'
      
    ]
  };

  

  
  

  var faArrowsCross = {
    prefix: 'fat',
    iconName: 'arrows-cross',
    icon: [
      448,
      512,
      [],
      'e0a2',
      
      'M280 32c-4.4 0-8 3.6-8 8s3.6 8 8 8H420.7L2.3 466.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L432 59.3V200c0 4.4 3.6 8 8 8s8-3.6 8-8V40c0-4.4-3.6-8-8-8H280zM13.7 34.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L190.1 233.4l11.3-11.3L13.7 34.3zM420.7 464H280c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8V312c0-4.4-3.6-8-8-8s-8 3.6-8 8V452.7L257.9 278.6l-11.3 11.3L420.7 464z'
      
    ]
  };

  

  
  

  var faTree = {
    prefix: 'fat',
    iconName: 'tree',
    icon: [
      448,
      512,
      [127794],
      'f1bb',
      
      'M229.7 2.3c-3.1-3.1-8.2-3.1-11.3 0l-147 147c-4.7 4.7-7.3 11-7.3 17.7c0 13.8 11.2 25 25 25h35.7L39.3 277.4c-4.7 4.7-7.3 11-7.3 17.7c0 13.8 11.2 25 25 25H92.7L7.3 405.4C2.6 410.1 0 416.4 0 423c0 13.8 11.2 25 25 25H160h56v56c0 4.4 3.6 8 8 8s8-3.6 8-8V448h56H423c13.8 0 25-11.2 25-25c0-6.6-2.6-13-7.3-17.7L355.3 320H391c13.8 0 25-11.2 25-25c0-6.6-2.6-13-7.3-17.7L323.3 192H359c13.8 0 25-11.2 25-25c0-6.6-2.6-13-7.3-17.7l-147-147zM232 432V200c0-4.4-3.6-8-8-8s-8 3.6-8 8V432H160 25c-5 0-9-4-9-9c0-2.4 .9-4.7 2.6-6.3l99-99c2.3-2.3 3-5.7 1.7-8.7s-4.2-4.9-7.4-4.9H57c-5 0-9-4-9-9c0-2.4 .9-4.7 2.6-6.3l99-99c2.3-2.3 3-5.7 1.7-8.7s-4.2-4.9-7.4-4.9H89c-5 0-9-4-9-9c0-2.4 .9-4.7 2.6-6.3L224 19.3 365.4 160.7c1.7 1.7 2.6 4 2.6 6.3c0 5-4 9-9 9H304c-3.2 0-6.2 1.9-7.4 4.9s-.6 6.4 1.7 8.7l99 99c1.7 1.7 2.6 4 2.6 6.3c0 5-4 9-9 9H336c-3.2 0-6.2 1.9-7.4 4.9s-.6 6.4 1.7 8.7l99 99c1.7 1.7 2.6 4 2.6 6.3c0 5-4 9-9 9H288 232z'
      
    ]
  };

  

  
  

  var faCommentsQuestionCheck = {
    prefix: 'fat',
    iconName: 'comments-question-check',
    icon: [
      640,
      512,
      [],
      'e14f',
      
      'M208 16C99.4 16 16 90 16 176c0 36.1 15.1 68.8 38.9 96.5c1.9 2.2 2.4 5.3 1.4 8c-8 21.5-21.4 41.2-40.2 55.4L16 336c28.8 0 57.3-10.1 83.4-23.9c2.3-1.2 5-1.2 7.3-.1c31.7 15.7 65.9 24 101.3 24c108.6 0 192-74 192-160s-83.4-160-192-160zM0 176C0 78.8 93.1 0 208 0S416 78.8 416 176s-93.1 176-208 176c-36.5 0-71.9-8.4-104.7-23.9C76.8 341.7 47 352 16 352c-6.9 0-13.1-4.5-15.2-11.1c-2.1-6.6 .2-13.7 5.7-17.8c14.7-11.2 25.9-26.6 33.1-43.9C15.7 250.1 0 215.2 0 176zm448 0c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 39.2-15.7 74.1-39.6 103.2c7.2 17.3 18.4 32.7 33.1 43.9c5.5 4.1 7.9 11.3 5.7 17.8c-2.1 6.6-8.3 11.1-15.2 11.1c-31 0-60.8-10.3-87.3-23.9C503.9 503.6 468.5 512 432 512c-95.7 0-176.2-54.6-200.5-129c5.5-.5 10.9-1.1 16.3-1.9C271 446.3 343 496 432 496c35.3 0 69.6-8.4 101.3-24c2.3-1.1 5-1.1 7.3 .1C566.7 485.9 595.2 496 624 496l-.1-.1c-18.7-14.2-32.2-33.9-40.2-55.4c-1-2.7-.5-5.8 1.4-8C608.9 404.9 624 372.1 624 336c0-81.7-75.3-152.6-176-159.5l0-.5zM185.3 83h39.8c26.2 0 47.5 21.3 47.5 47.5c0 16-8 30.9-21.4 39.7L216 193.4V210c0 4.4-3.6 8-8 8s-8-3.6-8-8V189.1c0-2.7 1.4-5.2 3.6-6.7l38.9-25.6c8.8-5.8 14.2-15.7 14.2-26.3c0-17.4-14.1-31.5-31.5-31.5H185.3c-14.4 0-26 11.6-26 26l0 4.6c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-4.6c0-23.2 18.8-42 42-42zM208 232.7a11.3 11.3 0 1 1 0 22.7 11.3 11.3 0 1 1 0-22.7zm309.7 63c3.1 3.1 3.1 8.2 0 11.3l-85.3 85.3c-3.1 3.1-8.2 3.1-11.3 0l-42.7-42.7c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l37 37 79.7-79.7c3.1-3.1 8.2-3.1 11.3 0z'
      
    ]
  };

  

  
  

  var faHouseFloodWater = {
    prefix: 'fat',
    iconName: 'house-flood-water',
    icon: [
      576,
      512,
      [],
      'e50e',
      
      'M292.6 1.5c-2.8-1.9-6.4-1.9-9.2 0l-216 152c-3.6 2.5-4.5 7.5-1.9 11.1s7.5 4.5 11.1 1.9L112 141.6V258.5c5.5 1.4 10.9 3.6 16 6.5V130.4L288 17.8 448 130.4V265c5.1-2.9 10.5-5.1 16-6.5V141.6l35.4 24.9c3.6 2.5 8.6 1.7 11.1-1.9s1.7-8.6-1.9-11.1l-216-152zm29.6 352.6c-10.1-9.2-19.6-19.5-27.6-30.7c-3-4.3-10.2-4.3-13.2 0c-8 11.2-17.5 21.4-27.6 30.7C236.6 369.8 214.5 384 192 384s-44.6-14.2-61.8-29.9c-10.1-9.2-19.7-19.5-27.6-30.7c-1.5-2.1-3.9-3.4-6.6-3.4s-5.1 1.3-6.6 3.4c-7.3 10.3-15.9 19.6-25 28.3C48.7 366.5 28.3 380.9 7 383.6c-4.4 .6-7.5 4.6-6.9 8.9s4.6 7.5 8.9 6.9c26.5-3.3 50-20.7 66.4-36.1c8.8-8.3 15.9-16.4 20.6-22.2c5.2 6.4 13.2 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8l0 0 0 0c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c4.7 5.8 11.8 13.9 20.6 22.2c16.4 15.4 39.9 32.8 66.4 36.1c4.4 .6 8.4-2.6 8.9-6.9s-2.6-8.4-6.9-8.9c-21.3-2.7-41.7-17.1-57.4-31.9c-9.1-8.6-17.7-18-25-28.3c-1.5-2.1-3.9-3.4-6.6-3.4s-5.1 1.3-6.6 3.4c-7.9 11.2-17.5 21.5-27.6 30.7C428.6 369.8 406.5 384 384 384s-44.6-14.2-61.8-29.9zm-27.6 81.3c-3-4.3-10.2-4.3-13.2 0c-8 11.2-17.5 21.4-27.6 30.7C236.6 481.8 214.5 496 192 496s-44.6-14.2-61.8-29.9c-10.1-9.2-19.7-19.5-27.6-30.7c-1.5-2.1-3.9-3.4-6.6-3.4s-5.1 1.3-6.6 3.4c-7.3 10.3-15.9 19.6-25 28.3C48.7 478.5 28.3 492.9 7 495.6c-4.4 .6-7.5 4.6-6.9 8.9s4.6 7.5 8.9 6.9c26.5-3.3 50-20.7 66.4-36.1c8.8-8.3 15.9-16.4 20.6-22.2c5.2 6.4 13.2 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8l0 0 0 0c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c4.7 5.8 11.8 13.9 20.6 22.2c16.4 15.4 39.9 32.8 66.4 36.1c4.4 .6 8.4-2.6 8.9-6.9s-2.6-8.4-6.9-8.9c-21.3-2.7-41.7-17.1-57.4-31.9c-9.1-8.6-17.7-18-25-28.3c-1.5-2.1-3.9-3.4-6.6-3.4s-5.1 1.3-6.6 3.4c-7.9 11.2-17.5 21.5-27.6 30.7C428.6 481.8 406.5 496 384 496s-44.6-14.2-61.8-29.9c-10.1-9.2-19.6-19.5-27.6-30.7z'
      
    ]
  };

  

  
  

  var faMapLocation = {
    prefix: 'fat',
    iconName: 'map-location',
    icon: [
      576,
      512,
      ["map-marked"],
      'f59f',
      
      'M392 120c0-57.4-46.6-104-104-104s-104 46.6-104 104c0 10.5 3.6 24.5 10.7 41.2c6.9 16.4 16.6 34.2 27.5 51.9c21.8 35.4 47.6 69.1 63.5 88.9c1.3 1.6 3.4 1.6 4.6 0c15.9-19.8 41.7-53.6 63.5-88.9c10.9-17.7 20.6-35.5 27.5-51.9c7-16.7 10.7-30.7 10.7-41.2zm16 0c0 54.6-73.1 151.9-105.2 192c-7.7 9.6-22 9.6-29.6 0C241.1 271.9 168 174.6 168 120C168 53.7 221.7 0 288 0s120 53.7 120 120zm130.5 27.2L421.1 189.9c1.6-3.4 3.1-6.7 4.5-10.1c1.4-3.3 2.7-6.6 4-10l103.5-37.6c20.9-7.6 42.9 7.9 42.9 30.1V423.2c0 13.5-8.4 25.5-21.1 30.1L394.7 511.5c-1.6 .6-3.4 .6-5.1 .1L184.2 448.4 42.9 499.8C22.1 507.4 0 491.9 0 469.7V208.8c0-13.5 8.4-25.5 21.1-30.1l116.3-42.3c.8 5.3 2 10.5 3.4 15.8L26.5 193.8c-6.3 2.3-10.5 8.3-10.5 15V469.7c0 11.1 11 18.8 21.5 15L176 434.4V296c0-4.4 3.6-8 8-8s8 3.6 8 8V434.1l192 59.1V296c0-4.4 3.6-8 8-8s8 3.6 8 8V492.6l149.5-54.4c6.3-2.3 10.5-8.3 10.5-15V162.3c0-11.1-11-18.8-21.5-15z'
      
    ]
  };

  
    var faMapMarked = faMapLocation;
  

  
  

  var faBlanket = {
    prefix: 'fat',
    iconName: 'blanket',
    icon: [
      448,
      512,
      [],
      'f498',
      
      'M16 120V341.4C31.9 318.8 58.2 304 88 304H400c12.3 0 23.5 4.6 32 12.2V120c0-39.8-32.2-72-72-72H88c-39.8 0-72 32.2-72 72zM.4 384H0V120C0 71.4 39.4 32 88 32H360c48.6 0 88 39.4 88 88V352c0 26.5-21.5 48-48 48H88c-4.4 0-8-3.6-8-8s3.6-8 8-8H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H88c-39.8 0-72 32.2-72 72s32.2 72 72 72H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H88c-48.6 0-88-39.4-88-88c0-2.7 .1-5.4 .4-8z'
      
    ]
  };

  

  
  

  var faGlobePointer = {
    prefix: 'fat',
    iconName: 'globe-pointer',
    icon: [
      512,
      512,
      [],
      'e60e',
      
      'M332.2 429.9C309.9 474.5 282 496 256 496c-8.3 0-16.7-2.2-25.1-6.6l-.4 1.5c-2.1 7.2-6 13.5-11.3 18.4c12 1.7 24.3 2.6 36.8 2.6c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256c0 12.5 .9 24.8 2.6 36.8c4-4.4 9.1-7.9 14.8-10.1C16.5 274 16 265 16 256c0-28.1 4.8-55 13.7-80H134.4c-3.9 23.7-6.1 48.8-6.3 75l16.1-4.6c.5-24.6 2.7-48.3 6.5-70.4H361.4c4.3 25 6.6 51.9 6.6 80s-2.3 55-6.6 80H274.7l-4.6 16h88.2c-6.2 29.5-15.2 55.9-26.2 77.9zM179.8 82.1C202.1 37.5 230 16 256 16s53.9 21.5 76.2 66.1c11 21.9 19.9 48.3 26.2 77.9H153.6c6.2-29.6 15.2-55.9 26.2-77.9zM384 256c0-27.9-2.2-54.8-6.4-80H482.3c8.8 25 13.7 51.9 13.7 80s-4.8 55-13.7 80H377.6c4.1-25.2 6.4-52.1 6.4-80zm-9.3-96C362.2 98.2 337.9 48.3 307.5 21.5C383.2 38.1 445.6 90.5 476 160H374.7zM36 160C66.4 90.5 128.8 38.1 204.5 21.5C174.1 48.3 149.8 98.2 137.3 160H36zM374.7 352H476c-30.4 69.5-92.8 121.9-168.6 138.5c30.5-26.8 54.7-76.6 67.2-138.5zm-111-93.8c.8-2.8 0-5.8-2-7.9s-5.1-2.8-7.9-2l-224 64c-3.4 1-5.7 4-5.8 7.6s2.2 6.7 5.6 7.7l108.7 34.8L2.3 498.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L149.6 373.7l34.8 108.7c1.1 3.4 4.2 5.6 7.7 5.6s6.6-2.4 7.6-5.8l64-224zM59.6 320.4l184.8-52.8L191.6 452.4l-30.7-96c-.8-2.5-2.7-4.4-5.2-5.2l-96-30.7z'
      
    ]
  };

  

  
  

  var faHotTubPerson = {
    prefix: 'fat',
    iconName: 'hot-tub-person',
    icon: [
      512,
      512,
      ["hot-tub"],
      'f593',
      
      'M248 0c4.4 0 8 3.6 8 8c0 30.6 13.9 59 36.7 75.6l16.1 11.8C336 115.4 352 148.7 352 184c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-30.6-13.9-59-36.7-75.6L283.2 96.5C256 76.6 240 43.3 240 8c0-4.4 3.6-8 8-8zM16 336V448c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V320c0-26.5-21.5-48-48-48H277.3c-1.4 0-2.7 0-4-.1c-.4 .1-.8 .1-1.3 .1H16v48 16zm213.3-80L144 192c-13.8-10.4-30.7-16-48-16c-44.2 0-80 35.8-80 80H229.3zM0 336V320 256c0-53 43-96 96-96c20.8 0 41 6.7 57.6 19.2l85.3 64c11.1 8.3 24.6 12.8 38.4 12.8H448c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V336zM384 8c0 30.6 13.9 59 36.7 75.6l16.1 11.8C464 115.4 480 148.7 480 184c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-30.6-13.9-59-36.7-75.6L411.2 96.5C384 76.6 368 43.3 368 8c0-4.4 3.6-8 8-8s8 3.6 8 8zM112 320c4.4 0 8 3.6 8 8V440c0 4.4-3.6 8-8 8s-8-3.6-8-8V328c0-4.4 3.6-8 8-8zm96 0c4.4 0 8 3.6 8 8V440c0 4.4-3.6 8-8 8s-8-3.6-8-8V328c0-4.4 3.6-8 8-8zm96 0c4.4 0 8 3.6 8 8V440c0 4.4-3.6 8-8 8s-8-3.6-8-8V328c0-4.4 3.6-8 8-8zm96 0c4.4 0 8 3.6 8 8V440c0 4.4-3.6 8-8 8s-8-3.6-8-8V328c0-4.4 3.6-8 8-8zM112 64A48 48 0 1 0 16 64a48 48 0 1 0 96 0zM0 64a64 64 0 1 1 128 0A64 64 0 1 1 0 64z'
      
    ]
  };

  
    var faHotTub = faHotTubPerson;
  

  
  

  var faHouseNight = {
    prefix: 'fat',
    iconName: 'house-night',
    icon: [
      640,
      512,
      [],
      'e010',
      
      'M88 88c0 48.6 39.4 88 88 88c2.6 0 5.3-.1 7.9-.3C166.3 195.5 140.6 208 112 208c-53 0-96-43-96-96s43-96 96-96c4.2 0 8.3 .3 12.3 .8C102.3 32.8 88 58.7 88 88zM147.8 5.8C136.6 2.1 124.5 0 112 0C50.1 0 0 50.1 0 112s50.1 112 112 112c41.3 0 77.3-22.3 96.8-55.6c3.9-6.7-4.5-13.7-11.9-11.5c-6.6 2-13.6 3.1-20.8 3.1c-39.8 0-72-32.2-72-72c0-29.2 17.4-54.3 42.3-65.6c7.1-3.2 8.8-14.1 1.5-16.5zM405.2 97.9c-3-2.6-7.4-2.6-10.4 0l-232 200c-3.3 2.9-3.7 7.9-.8 11.3s7.9 3.7 11.3 .8L224 266.3V456c0 30.9 25.1 56 56 56H520c30.9 0 56-25.1 56-56V266.3l50.8 43.8c3.3 2.9 8.4 2.5 11.3-.8s2.5-8.4-.8-11.3l-232-200zM560 252.5V456c0 22.1-17.9 40-40 40H280c-22.1 0-40-17.9-40-40V252.5L400 114.6 560 252.5zM336 296v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V296c0-13.3-10.7-24-24-24H360c-13.3 0-24 10.7-24 24zm24-8h80c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8V296c0-4.4 3.6-8 8-8zM256 0c-4.4 0-8 3.6-8 8V56H200c-4.4 0-8 3.6-8 8s3.6 8 8 8h48v48c0 4.4 3.6 8 8 8s8-3.6 8-8V72h48c4.4 0 8-3.6 8-8s-3.6-8-8-8H264V8c0-4.4-3.6-8-8-8zM96 320c-4.4 0-8 3.6-8 8v48H40c-4.4 0-8 3.6-8 8s3.6 8 8 8H88v48c0 4.4 3.6 8 8 8s8-3.6 8-8V392h48c4.4 0 8-3.6 8-8s-3.6-8-8-8H104V328c0-4.4-3.6-8-8-8z'
      
    ]
  };

  

  
  

  var faRectanglePro = {
    prefix: 'fat',
    iconName: 'rectangle-pro',
    icon: [
      640,
      512,
      ["pro"],
      'e235',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H576c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H576c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm88 64h56c30.9 0 56 25.1 56 56s-25.1 56-56 56H96v72c0 4.4-3.6 8-8 8s-8-3.6-8-8V264 168c0-4.4 3.6-8 8-8zm56 96c22.1 0 40-17.9 40-40s-17.9-40-40-40H96v80h48zm264-24c0-39.8 32.2-72 72-72s72 32.2 72 72v48c0 39.8-32.2 72-72 72s-72-32.2-72-72V232zm72-56c-30.9 0-56 25.1-56 56v48c0 30.9 25.1 56 56 56s56-25.1 56-56V232c0-30.9-25.1-56-56-56zM248 160h56c30.9 0 56 25.1 56 56c0 24.2-15.3 44.8-36.8 52.6l35.9 71.8c2 4 .4 8.8-3.6 10.7s-8.8 .4-10.7-3.6L307 271.9c-1 .1-2 .1-3 .1H256v72c0 4.4-3.6 8-8 8s-8-3.6-8-8V264 168c0-4.4 3.6-8 8-8zm56 96c22.1 0 40-17.9 40-40s-17.9-40-40-40H256v80h48z'
      
    ]
  };

  
    var faPro = faRectanglePro;
  

  
  

  var faMonkey = {
    prefix: 'fat',
    iconName: 'monkey',
    icon: [
      576,
      512,
      [128018],
      'f6fb',
      
      'M104 16c-48.6 0-88 39.4-88 88V376c0 66.3 53.7 120 120 120h40V431c0-97.8 61-184.5 151.8-218c-10.2-13.1-17.6-28.5-21.2-45.3C278.2 165 256 141.1 256 112c0-30.9 25.1-56 56-56h7c19.4-33.5 55.6-56 97-56s77.7 22.5 97 56h7c30.9 0 56 25.1 56 56c0 29.1-22.2 53-50.5 55.7C514.6 218.2 469.7 256 416 256c-29.6 0-56.5-11.5-76.5-30.2C251.6 255.3 192 337.8 192 431v65H480c8.8 0 16-7.2 16-16s-7.2-16-16-16H440c-4.2 0-7.6-3.2-8-7.3l-.7-8c-3.8-45.6-41.9-80.7-87.7-80.7H328c-4.4 0-8-3.6-8-8s3.6-8 8-8h15.7c37.1 0 69.9 19.5 88.3 49.1V296c0-3.3 2-6.2 5-7.4s6.5-.4 8.8 2l93.2 99c23.7 25.2 37 58.6 37 93.2V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V482.8c0-30.6-11.7-60-32.6-82.2L448 316.2V448h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H136C60.9 512 0 451.1 0 376V104C0 46.6 46.6 0 104 0h32c48.6 0 88 39.4 88 88s-39.4 88-88 88H104c-4.4 0-8-3.6-8-8s3.6-8 8-8h32c39.8 0 72-32.2 72-72s-32.2-72-72-72H104zM512 144V112c0-53-43-96-96-96s-96 43-96 96v32c0 53 43 96 96 96s96-43 96-96zM311.4 72c-21.8 .3-39.4 18.1-39.4 40c0 19.4 13.9 35.6 32.2 39.2c-.2-2.4-.2-4.8-.2-7.2V112c0-14.1 2.6-27.6 7.4-40zM528 112v32c0 2.4-.1 4.9-.2 7.2c18.4-3.6 32.2-19.8 32.2-39.2c0-21.9-17.6-39.6-39.4-40c4.7 12.4 7.4 25.9 7.4 40zm-160 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-96 16c0 17.4 11.1 32.2 26.7 37.7c3.2 1.1 5.3 4.2 5.3 7.5V168c0 17.7 14.3 32 32 32s32-14.3 32-32V157.3c0-3.4 2.1-6.4 5.3-7.5c15.5-5.5 26.7-20.3 26.7-37.7c0-22.1-17.9-40-40-40H392c-22.1 0-40 17.9-40 40zm40-56h48c30.9 0 56 25.1 56 56c0 22.3-13.1 41.6-32 50.6V168c0 26.5-21.5 48-48 48s-48-21.5-48-48v-5.4c-18.9-9-32-28.3-32-50.6c0-30.9 25.1-56 56-56z'
      
    ]
  };

  

  
  

  var faSignalBarsSlash = {
    prefix: 'fat',
    iconName: 'signal-bars-slash',
    icon: [
      640,
      512,
      ["signal-alt-slash"],
      'f694',
      
      'M448 176c0-26.5-21.5-48-48-48s-48 21.5-48 48v13.5l16 12.6V176c0-17.7 14.3-32 32-32s32 14.3 32 32v76.7l16 12.6V176zM368 464V385.6L352 373v91c0 26.5 21.5 48 48 48s48-21.5 48-48V448.8l-16-12.6V464c0 17.7-14.3 32-32 32s-32-14.3-32-32zM192 304V464c0 26.5 21.5 48 48 48s48-21.5 48-48V322.5l-16-12.6V464c0 17.7-14.3 32-32 32s-32-14.3-32-32V304c0-13.2 8-24.5 19.4-29.4l-13.6-10.8C200.6 272.4 192 287.2 192 304zm336 24.5V48c0-17.7 14.3-32 32-32s32 14.3 32 32V379l16 12.6V48c0-26.5-21.5-48-48-48s-48 21.5-48 48V315.8l16 12.6zM112 432v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V432c0-17.7 14.3-32 32-32s32 14.3 32 32zm-80 0v32c0 26.5 21.5 48 48 48s48-21.5 48-48V432c0-26.5-21.5-48-48-48s-48 21.5-48 48zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  
    var faSignalAltSlash = faSignalBarsSlash;
  

  
  

  var faGasPump = {
    prefix: 'fat',
    iconName: 'gas-pump',
    icon: [
      512,
      512,
      [9981],
      'f52f',
      
      'M256 16H96C69.5 16 48 37.5 48 64V416H304V64c0-26.5-21.5-48-48-48zM48 496H304V432H48v64zm296 16H320 304 48 32 8c-4.4 0-8-3.6-8-8s3.6-8 8-8H32V64C32 28.7 60.7 0 96 0H256c35.3 0 64 28.7 64 64V272h8c39.8 0 72 32.2 72 72v40c0 26.5 21.5 48 48 48s48-21.5 48-48V224h-8c-30.9 0-56-25.1-56-56V72.9l-29.4-27c-3.3-3-3.5-8-.5-11.3s8-3.5 11.3-.5l80.4 73.7c11.6 10.6 18.2 25.6 18.2 41.3V384c0 35.3-28.7 64-64 64s-64-28.7-64-64V344c0-30.9-25.1-56-56-56h-8V496h24c4.4 0 8 3.6 8 8s-3.6 8-8 8zM496 149.1c0-11.2-4.7-21.9-13-29.5L448 87.5V168c0 22.1 17.9 40 40 40h8V149.1zM128 80c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H128zM96 96c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V96z'
      
    ]
  };

  

  
  

  var faArrowDownFromLine = {
    prefix: 'fat',
    iconName: 'arrow-down-from-line',
    icon: [
      384,
      512,
      [8615,"arrow-from-top"],
      'f345',
      
      'M197.7 477.7c-3.1 3.1-8.2 3.1-11.3 0l-136-136c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L184 452.7 184 136c0-4.4 3.6-8 8-8s8 3.6 8 8l0 316.7L322.3 330.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-136 136zM8 48c-4.4 0-8-3.6-8-8s3.6-8 8-8l368 0c4.4 0 8 3.6 8 8s-3.6 8-8 8L8 48z'
      
    ]
  };

  
    var faArrowFromTop = faArrowDownFromLine;
  

  
  

  var faLock = {
    prefix: 'fat',
    iconName: 'lock',
    icon: [
      448,
      512,
      [128274],
      'f023',
      
      'M112 128v64H336V128c0-61.9-50.1-112-112-112s-112 50.1-112 112zM96 192V128C96 57.3 153.3 0 224 0s128 57.3 128 128v64h32c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H96zm0 16H64c-26.5 0-48 21.5-48 48V448c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V256c0-26.5-21.5-48-48-48H352 336 112 96z'
      
    ]
  };

  

  
  

  var faPaintbrush = {
    prefix: 'fat',
    iconName: 'paintbrush',
    icon: [
      576,
      512,
      [128396,"paint-brush"],
      'f1fc',
      
      'M295.7 376c-10.6 0-20.9-1.7-30.5-4.9l0-.1c-1.6-.5-3.1-1.1-4.6-1.7l-53.8-53.8c-.6-1.5-1.2-3.1-1.7-4.6l-.1 0c-3.2-9.6-5-19.8-5-30.5c0-30.6 14.6-59.4 39.4-77.4L483.7 25.2c19.1-13.9 45.5-11.8 62.2 4.9s18.8 43.1 4.9 62.2L373.1 336.6c-18 24.8-46.8 39.4-77.4 39.4zm-43 8c2.2 7.6 3.3 15.7 3.3 24c0 46.3-35.7 84.2-81.1 87.7c-.7 .1-1.3 .1-1.9 .3h-5H32c-8.8 0-16-7.2-16-16s7.2-16 16-16h4c14.6 0 26.2-7.7 33.6-17.4c7.3-9.6 11.2-22 10.6-34.3c-.1-1.4-.1-2.8-.1-4.3c0-48.6 39.4-88 88-88c8.3 0 16.4 1.2 24 3.3L252.7 384zm17.6 5.1c8.2 1.9 16.7 2.9 25.4 2.9c35.7 0 69.3-17.1 90.4-46L563.7 101.6c18.5-25.5 15.8-60.6-6.5-82.9s-57.4-25-82.9-6.5L230 190c-28.9 21-46 54.6-46 90.3c0 8.7 1 17.3 2.9 25.4c-6.1-1.1-12.4-1.7-18.9-1.7c-57.4 0-104 46.6-104 104c0 1.7 0 3.4 .1 5c.8 17.1-11 35-28.2 35H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H168h7.8c.1 0 .2-.1 .2-.2s.1-.2 .1-.2c53.6-4.2 95.9-49 95.9-103.7c0-6.5-.6-12.8-1.7-18.9z'
      
    ]
  };

  
    var faPaintBrush = faPaintbrush;
  

  
  

  var faSnowBlowing = {
    prefix: 'fat',
    iconName: 'snow-blowing',
    icon: [
      640,
      512,
      [],
      'f761',
      
      'M184 72c0-4.4-3.6-8-8-8s-8 3.6-8 8v52.7L133.7 90.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L168 147.3v94.8L85.9 194.7 69.2 132.4c-1.1-4.3-5.5-6.8-9.8-5.7s-6.8 5.5-5.7 9.8l12.6 46.9L20.7 157.1c-3.8-2.2-8.7-.9-10.9 2.9s-.9 8.7 2.9 10.9l45.6 26.3L11.4 209.8c-4.3 1.1-6.8 5.5-5.7 9.8s5.5 6.8 9.8 5.7l62.4-16.7L160 256 77.9 303.4 15.5 286.7c-4.3-1.1-8.7 1.4-9.8 5.7s1.4 8.7 5.7 9.8l46.9 12.6L12.7 341.1c-3.8 2.2-5.1 7.1-2.9 10.9s7.1 5.1 10.9 2.9l45.6-26.3L53.7 375.5c-1.1 4.3 1.4 8.7 5.7 9.8s8.7-1.4 9.8-5.7l16.7-62.4L168 269.9v94.8l-45.7 45.7c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L168 387.3V440c0 4.4 3.6 8 8 8s8-3.6 8-8V387.3l34.3 34.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L184 364.7V269.9l82.1 47.4 16.7 62.4c1.1 4.3 5.5 6.8 9.8 5.7s6.8-5.5 5.7-9.8l-12.6-46.9 45.6 26.3c3.8 2.2 8.7 .9 10.9-2.9s.9-8.7-2.9-10.9l-45.6-26.3 46.9-12.6c4.3-1.1 6.8-5.5 5.7-9.8s-5.5-6.8-9.8-5.7l-62.4 16.7L192 256l82.1-47.4 62.4 16.7c4.3 1.1 8.7-1.4 9.8-5.7s-1.4-8.7-5.7-9.8l-46.9-12.6 45.6-26.3c3.8-2.2 5.1-7.1 2.9-10.9s-7.1-5.1-10.9-2.9l-45.6 26.3 12.6-46.9c1.1-4.3-1.4-8.7-5.7-9.8s-8.7 1.4-9.8 5.7l-16.7 62.4L184 242.1V147.3l45.7-45.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L184 124.7V72zm296 0c0 4.4 3.6 8 8 8h72c35.3 0 64 28.7 64 64s-28.7 64-64 64H392c-4.4 0-8 3.6-8 8s3.6 8 8 8H560c44.2 0 80-35.8 80-80s-35.8-80-80-80H488c-4.4 0-8 3.6-8 8zm0 368c0 4.4 3.6 8 8 8h72c44.2 0 80-35.8 80-80s-35.8-80-80-80H392c-4.4 0-8 3.6-8 8s3.6 8 8 8H560c35.3 0 64 28.7 64 64s-28.7 64-64 64H488c-4.4 0-8 3.6-8 8z'
      
    ]
  };

  

  
  

  var faFutbol = {
    prefix: 'fat',
    iconName: 'futbol',
    icon: [
      512,
      512,
      [9917,"futbol-ball","soccer-ball"],
      'f1e3',
      
      'M307.2 490.5c0 0 0-.1 0-.1l24.5-96.7c.1-.3 .2-.7 .3-1c2-7 2.7-14.9-1.6-20.7l-22.7-31.2c-1.5-2-4.1-4-6.6-3.6c-1.1 .2-2.3 .2-3.4 .2H214.3c-1.2 0-2.3-.1-3.4-.2c-2.5-.4-5.1 1.6-6.6 3.6L181.6 372c-4.3 5.9-3.6 13.8-1.6 20.7c.1 .3 .2 .7 .3 1l24.5 96.7c0 .1 0 .1 0 .1c16.5 3.6 33.6 5.5 51.2 5.5s34.7-1.9 51.2-5.5zm17.7-4.5c52.8-15.8 97.9-49.2 128.6-93.4l-90.9-6c-3.4-.2-6.8 .7-9.5 2.7l-.1 .1-.1 .1c-2.7 2-4.7 4.9-5.5 8.2L324.8 486zM463.2 377.2c17.1-29.1 28.2-62.1 31.6-97.4c0 0-.1 0-.1-.1l-84.4-53.1c-.3-.2-.6-.4-.9-.6c-6-4.1-13.3-7.1-20.2-4.9L352.6 233c-2.4 .8-5.1 2.7-5.5 5.2c-.2 1.1-.5 2.2-.8 3.3l-25.8 79.3c-.4 1.1-.8 2.2-1.3 3.2c-1.1 2.2-.1 5.4 1.4 7.4l22.7 31.2c4.3 5.9 12 7.7 19.2 7.9c.3 0 .7 0 1 .1l99.5 6.6c0 0 .1 0 .1 0zm32.7-115.6c0-1.8 .1-3.7 .1-5.5c0-54.7-18.3-105.2-49.1-145.5L413 195c-1.3 3.2-1.4 6.8-.3 10.1s3.3 6.1 6.2 7.9l77.1 48.5zM435.2 96.4c-22.8-25.6-51-46.3-82.8-60.2c0 0-.1 .1-.1 .1l-76.6 63.8c-.3 .2-.5 .4-.8 .6c-5.7 4.4-10.9 10.5-10.9 17.7V157c0 2.5 1 5.6 3.2 6.8c1 .5 2 1.1 2.9 1.8l67.5 49c.9 .7 1.8 1.4 2.6 2.2c1.8 1.7 5.1 1.7 7.5 1l36.7-11.9c6.9-2.2 11-9 13.5-15.8c.1-.3 .2-.6 .4-1l37-92.6c0 0 0-.1 0-.1zM335.5 29.5C310.6 20.7 283.9 16 256 16s-54.6 4.7-79.5 13.5l70 58.3c2.7 2.2 6 3.4 9.5 3.4s6.8-1.2 9.5-3.4l70-58.3zM159.6 36.2c-31.8 14-60 34.6-82.8 60.2c0 0 0 .1 0 .1l37 92.6c.1 .3 .3 .6 .4 1c2.5 6.8 6.6 13.6 13.5 15.8l36.7 11.9c2.4 .8 5.7 .8 7.5-1c.8-.8 1.7-1.5 2.6-2.2l67.5-49c.9-.7 1.9-1.3 2.9-1.8c2.2-1.2 3.2-4.3 3.2-6.8V118.5c0-7.2-5.2-13.3-10.9-17.7c-.3-.2-.5-.4-.8-.6L159.7 36.3c0 0-.1-.1-.1-.1zM65.1 110.5C34.3 150.8 16 201.3 16 256c0 1.9 0 3.7 .1 5.5L93.1 213c2.9-1.8 5.1-4.7 6.2-7.9s1-6.9-.3-10.1L65.1 110.5zm-48 169.3C20.6 315 31.7 348 48.8 377.2c0 0 .1 0 .1 0l99.5-6.6c.3 0 .7 0 1-.1c7.2-.2 15-2.1 19.2-7.9l22.7-31.2c1.5-2 2.5-5.1 1.4-7.4c-.5-1-.9-2.1-1.3-3.2l-25.8-79.3c-.4-1.1-.6-2.2-.8-3.3c-.4-2.5-3.1-4.4-5.5-5.2l-36.7-11.9c-6.9-2.2-14.2 .8-20.2 4.9c-.3 .2-.6 .4-.9 .6L17.3 279.7c0 0-.1 0-.1 .1zM58.6 392.5c30.7 44.2 75.8 77.7 128.6 93.4l-22.3-88.4c-.8-3.3-2.8-6.2-5.5-8.3l-.1-.1-.1-.1c-2.8-2-6.2-2.9-9.6-2.7l-90.9 6zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm251.3-77.4l-67.5 49c-2.8 2-4 5.6-2.9 8.9l25.8 79.4c1.1 3.3 4.1 5.5 7.6 5.5l83.4 0c3.5 0 6.5-2.2 7.6-5.5l25.8-79.4c1.1-3.3-.1-6.9-2.9-8.9l-67.5-49c-2.8-2-6.6-2-9.4 0z'
      
    ]
  };

  
    var faFutbolBall = faFutbol;
  
    var faSoccerBall = faFutbol;
  

  
  

  var faJug = {
    prefix: 'fat',
    iconName: 'jug',
    icon: [
      448,
      512,
      [],
      'f8c6',
      
      'M288 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16H288zM128 32c0 11.8 6.4 22.2 16 27.7V64 85c0 7.1-2.4 14-6.7 19.6L59 205.3c-17.5 22.5-27 50.1-27 78.6V448c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V283.9c0-21.8-5.6-43.1-16-61.9c27.6-7.1 48-32.2 48-62c0-35.3-28.7-64-64-64c-23.6 0-44.2 12.8-55.3 31.8l-18-23.1C306.4 99 304 92.1 304 85V64 59.7c9.6-5.5 16-15.9 16-27.7c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zm32 32H288V85c0 10.7 3.6 21 10.1 29.5l78.3 100.7C391.7 234.8 400 259 400 283.9V448c0 26.5-21.5 48-48 48H96c-26.5 0-48-21.5-48-48V283.9c0-24.9 8.3-49.1 23.6-68.8l78.3-100.7C156.4 106.1 160 95.7 160 85V64zM390.7 207.5c-.5-.7-1.1-1.5-1.7-2.2l-49.4-63.6c7.2-17.5 24.4-29.8 44.4-29.8c26.5 0 48 21.5 48 48c0 24.2-18 44.3-41.3 47.5zM128 304H320c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H128c-8.8 0-16-7.2-16-16V320c0-8.8 7.2-16 16-16zM96 320v64c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32z'
      
    ]
  };

  

  
  

  var faFolderPlus = {
    prefix: 'fat',
    iconName: 'folder-plus',
    icon: [
      512,
      512,
      [],
      'f65e',
      
      'M496 416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H197.5c12.7 0 24.9 5.1 33.9 14.1l35.9 35.9c9 9 21.2 14.1 33.9 14.1H448c26.5 0 48 21.5 48 48V416zM64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H301.3c-8.5 0-16.6-3.4-22.6-9.4L242.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64zm184-96c0 4.4 3.6 8 8 8s8-3.6 8-8V296h88c4.4 0 8-3.6 8-8s-3.6-8-8-8H264V192c0-4.4-3.6-8-8-8s-8 3.6-8 8v88H160c-4.4 0-8 3.6-8 8s3.6 8 8 8h88v88z'
      
    ]
  };

  

  
  

  var faCampground = {
    prefix: 'fat',
    iconName: 'campground',
    icon: [
      576,
      512,
      [9978],
      'f6bb',
      
      'M397.2 1.9c3.4 2.9 3.8 7.9 .9 11.3L298.5 131 530.8 405.8c8.5 10.1 13.2 22.9 13.2 36.2V472c0 22.1-17.9 40-40 40H288 72c-22.1 0-40-17.9-40-40V441.9c0-13.2 4.7-26 13.2-36.2L277.5 131 177.9 13.2c-2.9-3.4-2.4-8.4 .9-11.3s8.4-2.4 11.3 .9L288 118.6 385.9 2.8c2.9-3.4 7.9-3.8 11.3-.9zM57.5 416.1c-6.1 7.2-9.5 16.4-9.5 25.8V472c0 13.3 10.7 24 24 24h68.1L281.7 315.1c1.5-1.9 3.8-3.1 6.3-3.1s4.8 1.1 6.3 3.1L435.9 496H504c13.3 0 24-10.7 24-24V441.9c0-9.5-3.4-18.6-9.5-25.8L288 143.4 57.5 416.1zm103 79.9H288 415.6L288 333 160.4 496z'
      
    ]
  };

  

  
  

  var faClockNineThirty = {
    prefix: 'fat',
    iconName: 'clock-nine-thirty',
    icon: [
      512,
      512,
      [],
      'e34d',
      
      'M16 256a240 240 0 1 1 480 0A240 240 0 1 1 16 256zm496 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM264 408V256c0-4.4-3.6-8-8-8H136c-4.4 0-8 3.6-8 8s3.6 8 8 8H248V408c0 4.4 3.6 8 8 8s8-3.6 8-8z'
      
    ]
  };

  

  
  

  var faWatchFitness = {
    prefix: 'fat',
    iconName: 'watch-fitness',
    icon: [
      384,
      512,
      [],
      'f63e',
      
      'M80 40V64H304l0-24c0-13.3-10.7-24-24-24H104C90.7 16 80 26.7 80 40zM64 65.6V40C64 17.9 81.9 0 104 0H280c22.1 0 40 17.9 40 40V65.6c36.5 7.4 64 39.7 64 78.4V368c0 38.7-27.5 71-64 78.4V472c0 22.1-17.9 40-40 40l-176 0c-22.1 0-40-17.9-40-40l0-25.6C27.5 439 0 406.7 0 368V144c0-38.7 27.5-71 64-78.4zM80 472c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24V448H80l0 24zm224-40c35.3 0 64-28.7 64-64V144c0-35.3-28.7-64-64-64H80c-35.3 0-64 28.7-64 64V368c0 35.3 28.6 64 63.9 64l.1 0H304zM96 217.9v.6c0 10.6 4 20.9 11.2 28.8l78.9 86.1c1.5 1.7 3.7 2.6 5.9 2.6s4.4-.9 5.9-2.6l78.9-86.1c7.2-7.8 11.2-18.1 11.2-28.8v-.6c0-23.2-18.8-41.9-41.9-41.9c-11.1 0-21.8 4.4-29.7 12.3L197.7 207c-1.5 1.5-3.5 2.3-5.7 2.3s-4.2-.8-5.7-2.3l-18.7-18.7c-7.9-7.9-18.5-12.3-29.7-12.3C114.8 176 96 194.8 96 217.9zM137.9 160c15.4 0 30.1 6.1 41 17L192 190.1 205.1 177c10.9-10.9 25.6-17 41-17c32 0 57.9 25.9 57.9 57.9v.6c0 14.7-5.5 28.8-15.4 39.6l-78.9 86.1c-4.5 5-11 7.8-17.7 7.8s-13.1-2.8-17.7-7.8L95.4 258.1C85.5 247.3 80 233.2 80 218.6v-.6c0-32 25.9-57.9 57.9-57.9z'
      
    ]
  };

  

  
  

  var faHouseMedicalCircleXmark = {
    prefix: 'fat',
    iconName: 'house-medical-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e513',
      
      'M282.7 2c3-2.7 7.6-2.7 10.6 0l215 190.4c-4.1-.3-8.2-.4-12.3-.4c-4 0-8 .1-11.9 .4L288 18.7 80 202.9V448c0 26.5 21.5 48 48 48H375.2c6.1 5.8 12.7 11.1 19.6 16H128c-35.3 0-64-28.7-64-64V217.1L13.3 262c-3.3 2.9-8.4 2.6-11.3-.7S-.6 252.9 2.7 250L282.7 2zm84.6 246c-4.7 5.1-9.1 10.4-13.3 16H320c-4.4 0-8-3.6-8-8V200c0-4.4-3.6-8-8-8H272c-4.4 0-8 3.6-8 8v56c0 4.4-3.6 8-8 8H200c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h56c4.4 0 8 3.6 8 8v56c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8h8.2c.2 5.5 .7 10.9 1.5 16.3C317.3 397 311 400 304 400H272c-13.3 0-24-10.7-24-24V328H200c-13.3 0-24-10.7-24-24V272c0-13.3 10.7-24 24-24h48V200c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v48h39.3zM624 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm155.3 0l50.3 50.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L496 379.3l-50.3 50.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L484.7 368l-50.3-50.3c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L496 356.7l50.3-50.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L507.3 368z'
      
    ]
  };

  

  
  

  var faUpToLine = {
    prefix: 'fat',
    iconName: 'up-to-line',
    icon: [
      384,
      512,
      ["arrow-alt-to-top"],
      'f34d',
      
      'M8 48l368 0c4.4 0 8-3.6 8-8s-3.6-8-8-8L8 32c-4.4 0-8 3.6-8 8s3.6 8 8 8zm176 99.3c2.1-2.1 5-3.3 8-3.3s5.9 1.2 8 3.3L331.8 279.4c2.7 2.7 4.2 6.4 4.2 10.2c0 8-6.5 14.4-14.4 14.4L248 304c-4.4 0-8 3.6-8 8l0 136c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-136c0-4.4-3.6-8-8-8l-73.6 0c-8 0-14.4-6.5-14.4-14.4c0-3.8 1.5-7.5 4.2-10.2L184 147.3zm8-19.3c-7.2 0-14.2 2.9-19.3 8L40.9 268.1c-5.7 5.7-8.9 13.4-8.9 21.5C32 306.4 45.6 320 62.4 320l65.6 0 0 128c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-128 65.6 0c16.8 0 30.4-13.6 30.4-30.4c0-8.1-3.2-15.8-8.9-21.5L211.3 136c-5.1-5.1-12.1-8-19.3-8z'
      
    ]
  };

  
    var faArrowAltToTop = faUpToLine;
  

  
  

  var faEgg = {
    prefix: 'fat',
    iconName: 'egg',
    icon: [
      384,
      512,
      [129370],
      'f7fb',
      
      'M192 480C96.4 480 16 386.9 16 288c0-53.4 15.4-118.6 45.8-169.8C92.1 66.9 135.7 32 192 32s99.9 34.9 130.2 86.2C352.6 169.4 368 234.6 368 288c0 98.9-80.4 192-176 192zM0 288C0 394 86 496 192 496s192-102 192-208c0-112-64-272-192-272S0 176 0 288zM141.4 120.1c3.3-3 3.5-8 .5-11.3s-8-3.5-11.3-.5c-22.6 20.6-39.2 50.2-50.1 80.9C69.5 220 64 252.6 64 280c0 4.4 3.6 8 8 8s8-3.6 8-8c0-25.4 5.2-56.3 15.5-85.4c10.4-29.2 25.8-56.2 45.9-74.5z'
      
    ]
  };

  

  
  

  var faFaceDizzy = {
    prefix: 'fat',
    iconName: 'face-dizzy',
    icon: [
      512,
      512,
      ["dizzy"],
      'f567',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm200 96a56 56 0 1 0 112 0 56 56 0 1 0 -112 0zm56 72a72 72 0 1 1 0-144 72 72 0 1 1 0 144zM106.3 138.3c3.1-3.1 8.2-3.1 11.3 0L160 180.7l42.3-42.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L171.3 192l42.3 42.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L160 203.3l-42.3 42.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L148.7 192l-42.3-42.3c-3.1-3.1-3.1-8.2 0-11.3zm192 0c3.1-3.1 8.2-3.1 11.3 0L352 180.7l42.3-42.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L363.3 192l42.3 42.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L352 203.3l-42.3 42.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L340.7 192l-42.3-42.3c-3.1-3.1-3.1-8.2 0-11.3z'
      
    ]
  };

  
    var faDizzy = faFaceDizzy;
  

  
  

  var faClipboardMedical = {
    prefix: 'fat',
    iconName: 'clipboard-medical',
    icon: [
      384,
      512,
      [],
      'e133',
      
      'M192 0c-37.1 0-67.6 28-71.6 64H112C91.1 64 73.3 77.4 66.7 96H64C28.7 96 0 124.7 0 160V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64h-2.7c-6.6-18.6-24.4-32-45.3-32h-8.4c-4-36-34.5-64-71.6-64zM16 160c0-26.5 21.5-48 48-48v16c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V112c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V160zM136 72c0-30.9 25.1-56 56-56s56 25.1 56 56c0 4.4 3.6 8 8 8h16c17.7 0 32 14.3 32 32v16c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V112c0-17.7 14.3-32 32-32h16c4.4 0 8-3.6 8-8zm56 24a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM168 232c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H224c-4.4 0-8 3.6-8 8v56c0 4.4-3.6 8-8 8H176c-4.4 0-8-3.6-8-8V352c0-4.4-3.6-8-8-8H104c-4.4 0-8-3.6-8-8V304c0-4.4 3.6-8 8-8h56c4.4 0 8-3.6 8-8V232zm8-24c-13.3 0-24 10.7-24 24v48H104c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h48v48c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V360h48c13.3 0 24-10.7 24-24V304c0-13.3-10.7-24-24-24H232V232c0-13.3-10.7-24-24-24H176z'
      
    ]
  };

  

  
  

  var faCircleDot = {
    prefix: 'fat',
    iconName: 'circle-dot',
    icon: [
      512,
      512,
      [128280,"dot-circle"],
      'f192',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm336 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-176 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z'
      
    ]
  };

  
    var faDotCircle = faCircleDot;
  

  
  

  var faBorderCenterV = {
    prefix: 'fat',
    iconName: 'border-center-v',
    icon: [
      448,
      512,
      [],
      'f89d',
      
      'M216 472c0 4.4 3.6 8 8 8s8-3.6 8-8l0-432c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 432zM48 448a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm384 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM48 352a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm384 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM400 160a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zM48 160a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm352 96a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zM48 256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM400 64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zM16 64a16 16 0 1 0 32 0A16 16 0 1 0 16 64zM304 256a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zM336 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM304 448a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zM144 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM112 448a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm32-192a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faGamepad = {
    prefix: 'fat',
    iconName: 'gamepad',
    icon: [
      640,
      512,
      [],
      'f11b',
      
      'M192 80C94.8 80 16 158.8 16 256s78.8 176 176 176H448c97.2 0 176-78.8 176-176s-78.8-176-176-176H192zM0 256C0 150 86 64 192 64H448c106 0 192 86 192 192s-86 192-192 192H192C86 448 0 362 0 256zm200-64v56h56c4.4 0 8 3.6 8 8s-3.6 8-8 8H200v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V264H128c-4.4 0-8-3.6-8-8s3.6-8 8-8h56V192c0-4.4 3.6-8 8-8s8 3.6 8 8zM392 304a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm40 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm64-160a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faCartPlus = {
    prefix: 'fat',
    iconName: 'cart-plus',
    icon: [
      576,
      512,
      [],
      'f217',
      
      'M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8H45.7C57.1 16 67 24.1 69.2 35.4l59.4 303.4c5.1 26.3 28.2 45.2 55 45.2H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H183.5c-19.1 0-35.6-13.5-39.3-32.3L134.9 288h339c26 0 48.6-17.9 54.5-43.3L575.8 41.8c1-4.3-1.7-8.6-6-9.6s-8.6 1.7-9.6 6L512.9 241.1c-4.2 18.1-20.4 30.9-39 30.9H131.8L84.9 32.3C81.2 13.5 64.8 0 45.7 0H8zM144 464a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm240-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM232 144c0 4.4 3.6 8 8 8h72v72c0 4.4 3.6 8 8 8s8-3.6 8-8V152h72c4.4 0 8-3.6 8-8s-3.6-8-8-8H328V64c0-4.4-3.6-8-8-8s-8 3.6-8 8v72H240c-4.4 0-8 3.6-8 8z'
      
    ]
  };

  

  
  

  var faSquarePhoneFlip = {
    prefix: 'fat',
    iconName: 'square-phone-flip',
    icon: [
      448,
      512,
      ["phone-square-alt"],
      'f87b',
      
      'M384 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H384zm64 48c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM291.2 136.4l44 12c5.2 1.4 8.8 6.2 8.8 11.6c0 119.3-96.7 216-216 216c-5.4 0-10.2-3.6-11.6-8.8l-12-44c-1.6-5.8 1.4-11.9 7-14.2l48-20c4.9-2 10.5-.6 13.9 3.5l20.2 24.7c2.3 2.8 6.3 3.7 9.6 2.2c36.9-17.4 66.7-47.3 84.2-84.2c1.6-3.3 .7-7.3-2.2-9.6l-24.7-20.2c-4.1-3.4-5.5-9-3.5-13.9l20-48c2.3-5.6 8.4-8.5 14.2-7zm-29 .8l-20 48c-4.8 11.4-1.5 24.6 8.1 32.4L270 233.8c-15.2 29.1-39.1 53-68.2 68.2l-16.1-19.7c-7.8-9.6-21-12.9-32.4-8.1l-48 20c-13 5.4-19.9 19.6-16.2 33.2l12 44c3.3 12.2 14.4 20.6 27 20.6c128.1 0 232-103.9 232-232c0-12.6-8.5-23.7-20.6-27l-44-12c-13.6-3.7-27.8 3.3-33.2 16.2z'
      
    ]
  };

  
    var faPhoneSquareAlt = faSquarePhoneFlip;
  

  
  

  var faTreePalm = {
    prefix: 'fat',
    iconName: 'tree-palm',
    icon: [
      576,
      512,
      [127796],
      'f82b',
      
      'M168 16c77.7 0 122.4 37.2 141.2 73.1c1 1.9 2.7 3.3 4.8 3.9s4.3 .4 6.1-.6C342.6 80.2 371.7 72 408 72c96 0 141.6 56.9 150.4 97.8c.3 1.6-.1 2.9-1.1 4c-1.1 1.2-3 2.1-5.3 2.1H492.5l-21.7-36.1c-1.4-2.4-4-3.9-6.9-3.9s-5.4 1.5-6.9 3.9L435.5 176H328 265.1c-2.1 0-4.2 .9-5.7 2.4L107.2 333.7c-1.6 1.6-3.5 2.3-5.1 2.2c-1.4-.1-2.7-.7-3.6-2.1c-21.9-34.1-30.7-101.7 29-162.6c.6-.6 1.2-1.3 1.9-1.9c32-31.7 65.6-43.6 94.8-44.5c4.4-.1 7.8-3.9 7.7-8.3s-3.8-8-8.1-7.8c-16.2 .5-33.3 3.9-50.7 11.3H116.5L94.9 83.9c-1.4-2.4-4-3.9-6.9-3.9s-5.4 1.5-6.9 3.9L59.5 120H24c-2.3 0-4.1-.9-5.3-2.1c-1-1.1-1.5-2.5-1.1-4C26.4 72.9 72 16 168 16zM112 136h32.3c-9.1 6.3-18.2 13.9-27.1 22.9l-1 1C50.9 226.5 59.4 302.4 85.1 342.4c8.2 12.7 24.6 11.6 33.5 2.4l121.6-124c2.4 10.9 4.3 23.7 5.3 38.4c3.5 49.4-2.3 119.6-27.9 211.3c-5.7 20.5 9.4 41.5 31.1 41.5h82.2c16 0 30-12 31.3-28.5c7.5-98.1-14.3-210.3-46.3-291.5H298.5c32.3 79.2 55.1 192.2 47.6 290.3c-.6 7.7-7.2 13.7-15.3 13.7H248.6C238 496 230 485.5 233 474.8c26-93 32.2-165.1 28.5-216.7c-1.4-19.8-4.3-36.7-8.1-50.7L268.5 192H328 440c2.8 0 5.4-1.5 6.9-3.9L464 159.5l17.1 28.6c1.4 2.4 4 3.9 6.9 3.9h64c12.7 0 25.2-10.8 22-25.5C563.6 117.8 511.3 56 408 56c-35.3 0-64.7 7.2-88.5 18.7C296 36 246.8 0 168 0C64.8 0 12.4 61.8 2 110.5C-1.2 125.2 11.3 136 24 136H64c2.8 0 5.4-1.5 6.9-3.9L88 103.5l17.1 28.6c1.4 2.4 4 3.9 6.9 3.9z'
      
    ]
  };

  

  
  

  var faList = {
    prefix: 'fat',
    iconName: 'list',
    icon: [
      512,
      512,
      ["list-squares"],
      'f03a',
      
      'M40 64c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8H88c4.4 0 8-3.6 8-8V72c0-4.4-3.6-8-8-8H40zM16 72c0-13.3 10.7-24 24-24H88c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24V72zM176 88H496c4.4 0 8 3.6 8 8s-3.6 8-8 8H176c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 160H496c4.4 0 8 3.6 8 8s-3.6 8-8 8H176c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 160H496c4.4 0 8 3.6 8 8s-3.6 8-8 8H176c-4.4 0-8-3.6-8-8s3.6-8 8-8zM88 224H40c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8H88c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zM40 208H88c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24V232c0-13.3 10.7-24 24-24zm0 176c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8H88c4.4 0 8-3.6 8-8V392c0-4.4-3.6-8-8-8H40zm-24 8c0-13.3 10.7-24 24-24H88c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24V392z'
      
    ]
  };

  
    var faListSquares = faList;
  

  
  

  var faFilmSimple = {
    prefix: 'fat',
    iconName: 'film-simple',
    icon: [
      512,
      512,
      ["film-alt"],
      'f3a0',
      
      'M112 104V48H64C37.5 48 16 69.5 16 96v8h96zM16 120v80h96V120H16zM0 216v-8-8V120v-8-8V96C0 60.7 28.7 32 64 32h48 8 8H384h8 8 48c35.3 0 64 28.7 64 64v8 8 8 80 8 8 80 8 8 80 8 8 8c0 35.3-28.7 64-64 64H400h-8-8H128h-8-8H64c-35.3 0-64-28.7-64-64v-8-8-8V312v-8-8V216zm16 80h96V216H16v80zm0 16v80h96V312H16zm96 96H16v8c0 26.5 21.5 48 48 48h48V408zm16 56H384V400 304 208 112 48H128v64 96 96 96 64zM400 48v56h96V96c0-26.5-21.5-48-48-48H400zm96 72H400v80h96V120zm0 96H400v80h96V216zm0 96H400v80h96V312zm0 96H400v56h48c26.5 0 48-21.5 48-48v-8z'
      
    ]
  };

  
    var faFilmAlt = faFilmSimple;
  

  
  

  var faAbacus = {
    prefix: 'fat',
    iconName: 'abacus',
    icon: [
      576,
      512,
      [129518],
      'f640',
      
      'M440 48V96h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8v40H560V96c0-26.5-21.5-48-48-48H440zM416 160c-17.7 0-32-14.3-32-32s14.3-32 32-32h8V48H280V96h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8v40H424V160h-8zM264 96V48H152V96h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8v40H264V160h-8c-17.7 0-32-14.3-32-32s14.3-32 32-32h8zM128 160c-17.7 0-32-14.3-32-32s14.3-32 32-32h8V48H64C37.5 48 16 69.5 16 96V200H136V160h-8zM144 32H272 432h80c35.3 0 64 28.7 64 64V208 416c0 35.3-28.7 64-64 64H432 272 144 64c-35.3 0-64-28.7-64-64V208 96C0 60.7 28.7 32 64 32h80zM16 216V416c0 26.5 21.5 48 48 48h72V416h-8c-17.7 0-32-14.3-32-32s14.3-32 32-32h8V320h-8c-17.7 0-32-14.3-32-32s14.3-32 32-32h8V216H16zM152 464H264V416h-8c-17.7 0-32-14.3-32-32s14.3-32 32-32h8V320h-8c-17.7 0-32-14.3-32-32s14.3-32 32-32h8V216H152v40h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8v32h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8v48zm128-48v48H424V416h-8c-17.7 0-32-14.3-32-32s14.3-32 32-32h8V216H280v40h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8v32h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8zm160-64h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8v48h72c26.5 0 48-21.5 48-48V216H440V352zM128 112c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H128zM112 288c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H128zM240 128c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H256c-8.8 0-16 7.2-16 16zm16 144c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H256zM240 384c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H256c-8.8 0-16 7.2-16 16zM416 112c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H416zM400 384c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H416c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faHockeySticks = {
    prefix: 'fat',
    iconName: 'hockey-sticks',
    icon: [
      640,
      512,
      [],
      'f454',
      
      'M511.1 11.7c2-3.9 .5-8.8-3.4-10.8s-8.8-.5-10.8 3.4L328.3 330.7H48c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H218.5c20.9 0 40.1-11.7 49.8-30.3l242.9-470zM112 346.7H320L254 474.4c-6.9 13.3-20.6 21.6-35.5 21.6H112V346.7zm-16 0V496H48c-17.7 0-32-14.3-32-32V378.7c0-17.7 14.3-32 32-32H96zm199.2-48L143.1 4.3c-2-3.9-6.9-5.5-10.8-3.4s-5.5 6.9-3.4 10.8l148.3 287h18zM338 416.4l33.7 65.3c9.6 18.6 28.8 30.3 49.8 30.3H592c26.5 0 48-21.5 48-48V378.7c0-26.5-21.5-48-48-48H382.3l-8.3 16H528V496H421.5c-15 0-28.7-8.3-35.5-21.6L347 399l-9 17.4zm254-69.7c17.7 0 32 14.3 32 32V464c0 17.7-14.3 32-32 32H544V346.7h48z'
      
    ]
  };

  

  
  

  var faFaceAnguished = {
    prefix: 'fat',
    iconName: 'face-anguished',
    icon: [
      512,
      512,
      [],
      'e369',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm251.8 64h8.4c46.3 0 83.8 37.5 83.8 83.8c0 6.7-5.5 12.2-12.2 12.2H180.2c-6.7 0-12.2-5.5-12.2-12.2c0-46.3 37.5-83.8 83.8-83.8zm8.4 16h-8.4c-36.2 0-65.7 28.3-67.7 64H327.9c-2-35.7-31.5-64-67.7-64zM160.4 224a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM200 103.5c.3 4.4-3.1 8.2-7.5 8.5c-32.5 2-61.6 16.5-82.7 38.7c-3 3.2-8.1 3.3-11.3 .3s-3.3-8.1-.3-11.3c23.7-25.1 56.6-41.4 93.3-43.7c4.4-.3 8.2 3.1 8.5 7.5zM319.5 112c-4.4-.3-7.8-4.1-7.5-8.5s4.1-7.8 8.5-7.5c36.7 2.3 69.6 18.6 93.3 43.7c3 3.2 2.9 8.3-.3 11.3s-8.3 2.9-11.3-.3C381.1 128.5 352 114 319.5 112z'
      
    ]
  };

  

  
  

  var faGhost = {
    prefix: 'fat',
    iconName: 'ghost',
    icon: [
      384,
      512,
      [128123],
      'f6e2',
      
      'M242.7 506c3.3 3.8 8.2 6 13.3 6s9.9-2.2 13.3-6l29.3-33.4c11.6-13.3 32.1-14 44.5-1.5l2.3 2.3c4.2 4.2 10 6.6 16 6.6c12.5 0 22.6-10.1 22.6-22.6V192C384 86 298 0 192 0S0 86 0 192V457.4C0 469.9 10.1 480 22.6 480c6 0 11.8-2.4 16-6.6l2.3-2.3c12.5-12.5 32.9-11.8 44.5 1.5L114.7 506c3.3 3.8 8.2 6 13.3 6s9.9-2.2 13.3-6l26.6-30.5c12.7-14.6 35.4-14.6 48.2 0L242.7 506zM27.3 462.1c-1.2 1.2-2.9 1.9-4.7 1.9c-3.7 0-6.6-3-6.6-6.6V192C16 94.8 94.8 16 192 16s176 78.8 176 176V457.4c0 3.7-3 6.6-6.6 6.6c-1.8 0-3.4-.7-4.7-1.9l-2.3-2.3c-19-19-50.2-18-67.9 2.3l-29.3 33.4c-.3 .4-.8 .6-1.2 .6s-.9-.2-1.2-.6L228.1 465c-19.1-21.9-53.1-21.9-72.2 0l-26.6 30.5c-.3 .4-.8 .6-1.2 .6s-.9-.2-1.2-.6L97.5 462c-17.7-20.2-48.9-21.3-67.9-2.3l-2.3 2.3zM128 216a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM88 192a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm192 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-24-40a40 40 0 1 0 0 80 40 40 0 1 0 0-80z'
      
    ]
  };

  

  
  

  var faHeading = {
    prefix: 'fat',
    iconName: 'heading',
    icon: [
      448,
      512,
      ["header"],
      'f1dc',
      
      'M0 40c0-4.4 3.6-8 8-8H72h64c4.4 0 8 3.6 8 8s-3.6 8-8 8H80V240H368V48H312c-4.4 0-8-3.6-8-8s3.6-8 8-8h64 64c4.4 0 8 3.6 8 8s-3.6 8-8 8H384V248 464h56c4.4 0 8 3.6 8 8s-3.6 8-8 8H376 312c-4.4 0-8-3.6-8-8s3.6-8 8-8h56V256H80V464h56c4.4 0 8 3.6 8 8s-3.6 8-8 8H72 8c-4.4 0-8-3.6-8-8s3.6-8 8-8H64V248 48H8c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  
    var faHeader = faHeading;
  

  
  

  var faTrainTunnel = {
    prefix: 'fat',
    iconName: 'train-tunnel',
    icon: [
      512,
      512,
      [],
      'e454',
      
      'M256 16C123.5 16 16 123.5 16 256V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V256C0 114.6 114.6 0 256 0S512 114.6 512 256V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V256C496 123.5 388.5 16 256 16zM192 144c-35.3 0-64 28.7-64 64V368c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V208c0-35.3-28.7-64-64-64H192zm0-16H320c44.2 0 80 35.8 80 80V368c0 38.2-26.8 70.2-62.6 78.1l52.2 52.2c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L316.7 448H195.3l-61.7 61.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l52.2-52.2C138.8 438.2 112 406.2 112 368V208c0-44.2 35.8-80 80-80zm80 248a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM192 208c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V224c0-8.8-7.2-16-16-16H192zm-32 16c0-17.7 14.3-32 32-32H320c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V224z'
      
    ]
  };

  

  
  

  var faSquareParkingSlash = {
    prefix: 'fat',
    iconName: 'square-parking-slash',
    icon: [
      640,
      512,
      ["parking-slash"],
      'f617',
      
      'M13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7zM487.1 479.6L467.3 464H160c-26.5 0-48-21.5-48-48V183.5L96 170.9V416c0 35.3 28.7 64 64 64H480c2.4 0 4.7-.1 7.1-.4zM152.9 32.4L172.7 48H480c26.5 0 48 21.5 48 48V328.5l16 12.6V96c0-35.3-28.7-64-64-64H160c-2.4 0-4.7 .1-7.1 .4zM240 284.6V296v80c0 4.4 3.6 8 8 8s8-3.6 8-8V352 304v-6.8l-16-12.6zm192-31.9c5.1-11.2 8-23.6 8-36.7c0-48.6-39.4-88-88-88H274.1l20.3 16 57.7 0c39.8 0 72 32.2 72 72c0 9.3-1.8 18.2-5 26.4l13 10.3z'
      
    ]
  };

  
    var faParkingSlash = faSquareParkingSlash;
  

  
  

  var faPesetaSign = {
    prefix: 'fat',
    iconName: 'peseta-sign',
    icon: [
      384,
      512,
      [],
      'e221',
      
      'M79.3 32C62 32 48 46 48 63.3V176H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H48V312 472c0 4.4 3.6 8 8 8s8-3.6 8-8V320H192c74.1 0 135.2-56 143.1-128H376c4.4 0 8-3.6 8-8s-3.6-8-8-8H336c0-79.5-64.5-144-144-144H79.3zM320 176H64V63.3C64 54.9 70.9 48 79.3 48H192c70.7 0 128 57.3 128 128zM64 192H319c-7.9 63.1-61.7 112-127 112H64V192z'
      
    ]
  };

  

  
  

  var faSandwich = {
    prefix: 'fat',
    iconName: 'sandwich',
    icon: [
      512,
      512,
      [129386],
      'f81f',
      
      'M480 80c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H32c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H480zM32 64C14.3 64 0 78.3 0 96v64c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H32zm0 272H245.6l70 46.7c2.7 1.8 6.2 1.8 8.9 0l70-46.7H480c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H32c-8.8 0-16-7.2-16-16V352c0-8.8 7.2-16 16-16zM0 352v64c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H392c-1.6 0-3.1 .5-4.4 1.3l-67.6 45-67.6-45c-1.3-.9-2.9-1.3-4.4-1.3H32c-17.7 0-32 14.3-32 32zm8-64c10.1 0 20.2-3.6 29.7-8.3c8.5-4.2 17.3-9.6 25.9-14.9l3.3-2c20-12.2 38.8-22.8 56.8-22.8c22.1 0 40 10.6 60.4 22.7l.3 .2C204.5 274.8 226.9 288 256 288s51.5-13.2 71.6-25.1l.3-.2c20.5-12.1 38.3-22.7 60.4-22.7c18 0 36.8 10.6 56.8 22.8l3.3 2c8.6 5.3 17.4 10.7 25.9 14.9c9.6 4.7 19.7 8.3 29.7 8.3c4.4 0 8-3.6 8-8s-3.6-8-8-8c-6.4 0-13.9-2.4-22.7-6.7c-7.8-3.8-15.9-8.8-24.6-14.1l-3.3-2c-19.2-11.8-41.8-25.2-65.1-25.2c-26.6 0-47.8 12.6-67.2 24.1l-1.7 1C299.1 261.2 280.2 272 256 272s-43.1-10.8-63.4-22.9l-1.7-1c-19.4-11.5-40.6-24.1-67.2-24.1c-23.3 0-45.9 13.4-65.1 25.2l-3.3 2c-8.7 5.3-16.8 10.3-24.6 14.1C21.9 269.6 14.4 272 8 272c-4.4 0-8 3.6-8 8s3.6 8 8 8z'
      
    ]
  };

  

  
  

  var faBookOpenCover = {
    prefix: 'fat',
    iconName: 'book-open-cover',
    icon: [
      640,
      512,
      ["book-open-alt"],
      'e0c0',
      
      'M329.4 433l217.7-43.5c7.5-1.5 12.9-8.1 12.9-15.7V33.5c0-9.7-8.6-17.2-18.2-15.9L328 47.1V433.3c.5-.1 .9-.2 1.4-.3zm-17.4 .3V47.1L98.2 17.7C88.6 16.3 80 23.8 80 33.5V373.8c0 7.6 5.4 14.2 12.9 15.7L310.6 433c.5 .1 .9 .2 1.4 .3zM539.6 1.8C558.9-.8 576 14.1 576 33.5V373.8c0 15.3-10.8 28.4-25.7 31.4L332.6 448.7c-8.3 1.7-16.8 1.7-25.1 0L89.7 405.1c-15-3-25.7-16.1-25.7-31.4V33.5C64 14.1 81.1-.8 100.4 1.8L320 32 539.6 1.8zM0 65.5c0-17.9 14.6-32 32-32v16c-8.7 0-16 7-16 16V418.6c0 7.6 5.4 14.2 12.9 15.7l281.7 56.3c6.2 1.2 12.6 1.2 18.8 0l281.7-56.3c7.5-1.5 12.9-8.1 12.9-15.7V65.5c0-9-7.3-16-16-16v-16c17.4 0 32 14.1 32 32V418.6c0 15.3-10.8 28.4-25.7 31.4L332.6 506.3c-8.3 1.7-16.8 1.7-25.1 0L25.7 449.9C10.8 447 0 433.8 0 418.6V65.5z'
      
    ]
  };

  
    var faBookOpenAlt = faBookOpenCover;
  

  
  

  var faShredder = {
    prefix: 'fat',
    iconName: 'shredder',
    icon: [
      512,
      512,
      [],
      'f68a',
      
      'M80 64V192H432V90.5c0-12.7-5.1-24.9-14.1-33.9L391.4 30.1c-9-9-21.2-14.1-33.9-14.1H128c-26.5 0-48 21.5-48 48zM64 192V64C64 28.7 92.7 0 128 0H357.5c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 18.7 28.3 18.7 45.3V192c35.3 0 64 28.7 64 64v96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V256c0-35.3 28.7-64 64-64zm0 16c-26.5 0-48 21.5-48 48v96c0 8.8 7.2 16 16 16H480c8.8 0 16-7.2 16-16V256c0-26.5-21.5-48-48-48H64zm352 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM56 504V416H72v88c0 4.4-3.6 8-8 8s-8-3.6-8-8zm96 0V416h16v88c0 4.4-3.6 8-8 8s-8-3.6-8-8zm96 0V416h16v88c0 4.4-3.6 8-8 8s-8-3.6-8-8zm96 0V416h16v88c0 4.4-3.6 8-8 8s-8-3.6-8-8zm96 0V416h16v88c0 4.4-3.6 8-8 8s-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faSquareCheck = {
    prefix: 'fat',
    iconName: 'square-check',
    icon: [
      448,
      512,
      [9745,9989,61510,"check-square"],
      'f14a',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM325.7 197.7l-128 128c-3.1 3.1-8.2 3.1-11.3 0l-64-64c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L192 308.7 314.3 186.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3z'
      
    ]
  };

  
    var faCheckSquare = faSquareCheck;
  

  
  

  var faLuchadorMask = {
    prefix: 'fat',
    iconName: 'luchador-mask',
    icon: [
      448,
      512,
      ["luchador","mask-luchador"],
      'f455',
      
      'M432 352c0 79.5-64.5 144-144 144H160C80.5 496 16 431.5 16 352V224C16 109.1 109.1 16 224 16s208 93.1 208 208V352zM224 0C100.3 0 0 100.3 0 224V352c0 88.4 71.6 160 160 160H288c88.4 0 160-71.6 160-160V224C448 100.3 347.7 0 224 0zM56 184v24c0 48.6 39.4 88 88 88h27.1l-8 16H152c-39.8 0-72 32.2-72 72s32.2 72 72 72h72 72c39.8 0 72-32.2 72-72s-32.2-72-72-72H284.9l-8-16h30.2c50.6 0 90.8-42.6 87.8-93.2l-1.2-21.2C392.5 160.5 375 144 353.8 144H290.3c-24.1 0-46.6 12-59.9 32.1l-6.3 9.5-6.3-9.5c-13.4-20-35.8-32.1-59.9-32.1H96c-22.1 0-40 17.9-40 40zm40-24h61.7c18.7 0 36.2 9.4 46.6 24.9l13 19.5c1.5 2.2 4 3.6 6.7 3.6s5.2-1.3 6.7-3.6l13-19.5C254 169.4 271.5 160 290.3 160h63.6c12.7 0 23.2 9.9 24 22.6l1.2 21.2c2.4 41.4-30.4 76.2-71.9 76.2H264c-2.8 0-5.3 1.4-6.8 3.8s-1.6 5.3-.4 7.8l16 32c1.4 2.7 4.1 4.4 7.2 4.4h16c30.9 0 56 25.1 56 56s-25.1 56-56 56H224 152c-30.9 0-56-25.1-56-56s25.1-56 56-56h16c3 0 5.8-1.7 7.2-4.4l16-32c1.2-2.5 1.1-5.4-.4-7.8s-4-3.8-6.8-3.8H144c-39.8 0-72-32.2-72-72V184c0-13.3 10.7-24 24-24zm96 80H152c-22.1 0-40-17.9-40-40h40c22.1 0 40 17.9 40 40zm0 16c8.8 0 16-7.2 16-16c0-30.9-25.1-56-56-56H112c-8.8 0-16 7.2-16 16c0 30.9 25.1 56 56 56h40zm104-16H256c0-22.1 17.9-40 40-40h40c0 22.1-17.9 40-40 40zm0 16c30.9 0 56-25.1 56-56c0-8.8-7.2-16-16-16H296c-30.9 0-56 25.1-56 56c0 8.8 7.2 16 16 16h40zM136 384c0-8.8 7.2-16 16-16H296c8.8 0 16 7.2 16 16s-7.2 16-16 16H152c-8.8 0-16-7.2-16-16zm-16 0c0 17.7 14.3 32 32 32H296c17.7 0 32-14.3 32-32s-14.3-32-32-32H152c-17.7 0-32 14.3-32 32z'
      
    ]
  };

  
    var faLuchador = faLuchadorMask;
  
    var faMaskLuchador = faLuchadorMask;
  

  
  

  var faCommentLines = {
    prefix: 'fat',
    iconName: 'comment-lines',
    icon: [
      512,
      512,
      [],
      'f4b0',
      
      'M157.3 415c-5-1.8-10.6-1-14.9 2.1c-11 8-29.4 19.3-51.2 28.8C68.3 456 41.6 464 16 464l.1-.1 0 0 0 0 .3-.3 .1-.1c.4-.4 .9-.9 1.5-1.6c1.3-1.4 3.2-3.6 5.4-6.3l-12.2-10 12.2 10C28 450 34 442 40 432c10.7-17.9 21.4-42.1 23.6-69.9c.3-4.3-1.1-8.6-3.9-11.8C31.9 318.8 16 280.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-35.2 0-68.6-6.1-98.7-17zM4.7 452.7l0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0zM136 184c-4.4 0-8 3.6-8 8s3.6 8 8 8H376c4.4 0 8-3.6 8-8s-3.6-8-8-8H136zm0 96c-4.4 0-8 3.6-8 8s3.6 8 8 8H280c4.4 0 8-3.6 8-8s-3.6-8-8-8H136z'
      
    ]
  };

  

  
  

  var faKeySkeletonLeftRight = {
    prefix: 'fat',
    iconName: 'key-skeleton-left-right',
    icon: [
      640,
      512,
      [],
      'e3b4',
      
      'M624 112a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm16 0c0 61.9-50.1 112-112 112s-112-50.1-112-112l-144 0v72c0 4.4-3.6 8-8 8s-8-3.6-8-8V112l-80 0 0 72c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l249.1 0C424.9 41.7 471.6 0 528 0c61.9 0 112 50.1 112 112zM16 400a96 96 0 1 0 192 0A96 96 0 1 0 16 400zM0 400c0-61.9 50.1-112 112-112s112 50.1 112 112l144 0V328c0-4.4 3.6-8 8-8s8 3.6 8 8v72l80 0 0-72c0-4.4 3.6-8 8-8s8 3.6 8 8l0 80c0 4.4-3.6 8-8 8l-249.1 0c-7.8 54.3-54.4 96-110.9 96C50.1 512 0 461.9 0 400z'
      
    ]
  };

  

  
  

  var faAsterisk = {
    prefix: 'fat',
    iconName: 'asterisk',
    icon: [
      384,
      512,
      [10033,61545],
      '2a',
      
      'M192 32c4.4 0 8 3.6 8 8V241.2L371.6 129.3c3.7-2.4 8.7-1.4 11.1 2.3s1.4 8.7-2.3 11.1L206.6 256 380.4 369.3c3.7 2.4 4.7 7.4 2.3 11.1s-7.4 4.7-11.1 2.3L200 270.8V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V270.8L12.4 382.7c-3.7 2.4-8.7 1.4-11.1-2.3s-1.4-8.7 2.3-11.1L177.4 256 3.6 142.7c-3.7-2.4-4.7-7.4-2.3-11.1s7.4-4.7 11.1-2.3L184 241.2V40c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faHandsHoldingChild = {
    prefix: 'fat',
    iconName: 'hands-holding-child',
    icon: [
      640,
      512,
      [],
      'e4fa',
      
      'M375 152c-5-4.3-12.2-5-18-1.8s-9.1 9.5-8.3 16.1L359.9 255c.5 4.4-2.6 8.4-6.9 8.9s-8.4-2.6-8.9-6.9l-4.4-35c-1-8-7.8-14-15.9-14h-7.6c-8.1 0-14.9 6-15.9 14l-4.4 35c-.5 4.4-4.5 7.5-8.9 6.9s-7.5-4.5-6.9-8.9l11.1-88.8c.8-6.5-2.5-12.9-8.3-16.1s-12.9-2.4-18 1.8l-19.8 16.7c-3.4 2.9-8.4 2.4-11.3-.9s-2.4-8.4 .9-11.3l41.5-35.1c7.2-6.1 16.4-9.5 25.8-9.5h35.6c9.5 0 18.6 3.3 25.8 9.5l41.5 35.1c3.4 2.9 3.8 7.9 .9 11.3s-7.9 3.8-11.3 .9L375 152zM360 40a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm24.5 141c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8L374 109.2C363.9 100.7 351.1 96 337.8 96H320 302.2c-13.2 0-26 4.7-36.2 13.2l-41.5 35.1c-10.1 8.6-11.4 23.7-2.8 33.8s23.7 11.4 33.8 2.8l1.8-1.5 18-15.2-2.9 23.4L264.2 253c-1.6 13.2 7.7 25.1 20.8 26.8s25.1-7.7 26.8-20.8l.1-1 4.1-33 .1-1h7.6l.1 1 4.1 33 .1 1c1.6 13.2 13.6 22.5 26.8 20.8s22.5-13.6 20.8-26.8l-8.2-65.3-2.9-23.4 18 15.2 1.8 1.5zM296 40a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM96 112c0-26.5-21.5-48-48-48S0 85.5 0 112V344.2c0 27.6 11 54 30.5 73.5l91.9 91.9c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L41.8 406.5C25.3 390 16 367.6 16 344.2V112c0-17.7 14.3-32 32-32s32 14.3 32 32V259c0 20.7 8.2 40.6 22.9 55.2l19.5 19.5 55.9 55.9 0 0 8 8c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-8-8 0 0-55.9-55.9 0 0c-10.6-10.6-11.3-27.6-1.5-39.1c10.9-12.7 30.3-13.5 42.2-1.6l92.8 92.7c13.3 13.3 20.8 31.4 20.8 50.3V504c0 4.4 3.6 8 8 8s8-3.6 8-8V424.8c0-23.1-9.2-45.3-25.5-61.6l-92.8-92.8c-18.4-18.4-48.7-17.3-65.6 2.5c-6.2 7.2-9.7 15.9-10.6 24.7C100.8 286.7 96 273.1 96 259V112zM592 64c-26.5 0-48 21.5-48 48V259c0 14.1-4.8 27.8-13.5 38.7c-.9-8.8-4.4-17.5-10.6-24.7c-17-19.8-47.2-21-65.6-2.5l-92.7 92.8c-16.3 16.3-25.5 38.5-25.5 61.6V504c0 4.4 3.6 8 8 8s8-3.6 8-8V424.8c0-18.9 7.5-37 20.8-50.3l92.8-92.7c11.8-11.9 31.3-11.1 42.2 1.6c9.8 11.4 9.1 28.4-1.5 39.1l0 0-55.9 55.9 0 0-8 8c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l8-8 55.9-55.9 19.5-19.5C551.8 299.5 560 279.7 560 259V112c0-17.7 14.3-32 32-32s32 14.3 32 32V344.2c0 23.3-9.3 45.7-25.8 62.2l-91.9 91.9c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l91.9-91.9c19.5-19.5 30.5-46 30.5-73.5V112c0-26.5-21.5-48-48-48z'
      
    ]
  };

  

  
  

  var faAnkh = {
    prefix: 'fat',
    iconName: 'ankh',
    icon: [
      320,
      512,
      [9765],
      'f644',
      
      'M48 128c0 54.1 28.9 98.3 59.5 129.9c15.2 15.7 30.4 27.8 41.9 36c4.1 3 7.7 5.4 10.7 7.3c2.9-1.9 6.5-4.3 10.7-7.3c11.4-8.2 26.7-20.4 41.9-36C243.1 226.3 272 182.1 272 128c0-61.9-50.1-112-112-112S48 66.1 48 128zm88.1 176C99 276.5 32 214.8 32 128C32 57.3 89.3 0 160 0s128 57.3 128 128c0 86.8-67 148.5-104.1 176H312c4.4 0 8 3.6 8 8s-3.6 8-8 8H168V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V320H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H136.1z'
      
    ]
  };

  

  
  

  var faWheatAwn = {
    prefix: 'fat',
    iconName: 'wheat-awn',
    icon: [
      512,
      512,
      ["wheat-alt"],
      'e2cd',
      
      'M413.7 13.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-48 48c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l48-48zm96 0c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-112 112-49.4 49.4c5.7-38.7-6.4-79.4-36.1-109.1L289.5 43.3c-6.2-6.2-16.4-6.2-22.6 0L255.5 54.6c-37.5 37.5-37.5 98.3 0 135.8l27.4 27.4-47.8 47.8c5.7-38.7-6.4-79.4-36.1-109.1l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l27.4 27.4-47.8 47.8c5.7-38.7-6.4-79.4-36.1-109.1L85.8 247c-6.2-6.2-16.4-6.2-22.6 0L51.9 258.3c-37.5 37.5-37.5 98.3 0 135.8l27.4 27.4L2.3 498.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l76.9-76.9 29.2 29.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3C224.7 385.8 182 374 142.1 381.2l50.3-50.3 29.2 29.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-30.9-30.9-73.5-42.7-113.4-35.4l50.3-50.3 29.2 29.2c37.5 37.5 98.3 37.5 135.8 0L470.5 247c6.2-6.2 6.2-16.4 0-22.6L459.2 213c-30.9-30.9-73.5-42.7-113.4-35.4l51.9-51.9 112-112zM321.3 202c41.5-19.3 92.3-11.9 126.5 22.3l11.3 11.3L447.9 247c-31.2 31.2-81.9 31.2-113.1 0l-29.2-29.2L321.3 202zM219.5 303.8c41.5-19.3 92.3-11.9 126.5 22.3l11.3 11.3L346 348.8c-31.2 31.2-81.9 31.2-113.1 0l-29.2-29.2 15.8-15.8zM117.7 405.6c41.5-19.3 92.3-11.9 126.5 22.3l11.3 11.3-11.3 11.3c-31.2 31.2-81.9 31.2-113.1 0l-29.2-29.2 15.8-15.8zm-27.1 4.5L63.2 382.7C32 351.5 32 300.8 63.2 269.6l11.3-11.3 11.3 11.3c32.5 32.5 40.9 80 25 120.2L90.6 410.1zM192.4 308.3L165 280.9c-31.2-31.2-31.2-81.9 0-113.1l11.3-11.3 11.3 11.3c32.5 32.5 40.9 80 25 120.2l-20.3 20.3zM294.2 206.5l-27.4-27.4c-31.2-31.2-31.2-81.9 0-113.1l11.3-11.3 11.3 11.3c32.5 32.5 40.9 80 25 120.2l-20.3 20.3zm215.4-96.8c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-48 48c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l48-48z'
      
    ]
  };

  
    var faWheatAlt = faWheatAwn;
  

  
  

  var faCompress = {
    prefix: 'fat',
    iconName: 'compress',
    icon: [
      448,
      512,
      [],
      'f066',
      
      'M152 32c4.4 0 8 3.6 8 8V184c0 4.4-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H144V40c0-4.4 3.6-8 8-8zm144 0c4.4 0 8 3.6 8 8V176H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H296c-4.4 0-8-3.6-8-8V40c0-4.4 3.6-8 8-8zM0 328c0-4.4 3.6-8 8-8H152c4.4 0 8 3.6 8 8V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V336H8c-4.4 0-8-3.6-8-8zm288 0c0-4.4 3.6-8 8-8H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H304V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V328z'
      
    ]
  };

  

  
  

  var faCircleN = {
    prefix: 'fat',
    iconName: 'circle-n',
    icon: [
      512,
      512,
      [],
      'e118',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM158 130.8c-2.2-2.5-5.7-3.4-8.8-2.3s-5.2 4.2-5.2 7.5V376c0 4.4 3.6 8 8 8s8-3.6 8-8V157.4L354 381.2c2.2 2.5 5.7 3.4 8.8 2.3s5.2-4.2 5.2-7.5V136c0-4.4-3.6-8-8-8s-8 3.6-8 8V354.6L158 130.8z'
      
    ]
  };

  

  
  

  var faAlbum = {
    prefix: 'fat',
    iconName: 'album',
    icon: [
      448,
      512,
      [128189],
      'f89f',
      
      'M384 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm160 80a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 304a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM208 256a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faCloudSunRain = {
    prefix: 'fat',
    iconName: 'cloud-sun-rain',
    icon: [
      640,
      512,
      [127782],
      'f743',
      
      'M137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1 13.4 112.2c-5.4 .9-10 4.5-12.1 9.6s-1.5 10.9 1.6 15.4L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6l56-39.2c-3.6-4-6.9-8.1-10-12.5l-40.6 28.4L128 400l-2.9-17.5-11.2-67.2c-1.1-6.7-6.4-12-13.2-13.2L33.5 290.9 16 288l10.2-14.5 39.4-56.3c3.9-5.5 3.9-12.8 0-18.4L26.2 142.5 16 128l17.5-2.9 67.2-11.2c6.7-1.1 12-6.4 13.2-13.2l11.2-67.2L128 16l14.5 10.2 56.3 39.4c5.5 3.9 12.8 3.9 18.4 0l56.3-39.4L288 16l2.9 17.5 8.4 50.4c4.8-3 9.7-5.7 14.9-8.1L303.8 13.4c-.9-5.4-4.5-10-9.6-12.1s-10.9-1.5-15.4 1.6L208 52.5 137.2 2.9zM208 112c-53 0-96 43-96 96c0 35.6 19.3 66.6 48 83.2c0-1.1 0-2.2 0-3.2c0-5.2 .3-10.3 .9-15.3C141 258.1 128 234.6 128 208c0-44.2 35.8-80 80-80c15.7 0 30.4 4.5 42.8 12.4c2.2-4.9 4.6-9.7 7.4-14.3c-14.6-9-31.8-14.1-50.2-14.1zm60.2 305.2c-3.8-2.3-8.7-1-11 2.7l-48 80c-2.3 3.8-1 8.7 2.7 11s8.7 1 11-2.7l48-80c2.3-3.8 1-8.7-2.7-11zm96 0c-3.8-2.3-8.7-1-11 2.7l-48 80c-2.3 3.8-1 8.7 2.7 11s8.7 1 11-2.7l48-80c2.3-3.8 1-8.7-2.7-11zm96 0c-3.8-2.3-8.7-1-11 2.7l-48 80c-2.3 3.8-1 8.7 2.7 11s8.7 1 11-2.7l48-80c2.3-3.8 1-8.7-2.7-11zm96 0c-3.8-2.3-8.7-1-11 2.7l-48 80c-2.3 3.8-1 8.7 2.7 11s8.7 1 11-2.7l48-80c2.3-3.8 1-8.7-2.7-11zM288 192c0-44.2 35.8-80 80-80c32 0 59.6 18.8 72.4 46c1.1 2.3 3.2 3.9 5.7 4.4s5.1-.2 6.9-1.9c11.4-10.3 26.4-16.5 42.9-16.5c35.3 0 64 28.7 64 64c0 7.5-1.3 14.7-3.7 21.4c-.8 2.4-.5 5 .9 7.1s3.7 3.4 6.2 3.5c33.7 1.8 60.5 29.7 60.5 63.9c0 35.3-28.7 64-64 64c-.7 0-1.5 0-2.2 0l0 0h-.3H291v0l-.3 0c-.9 0-1.8 0-2.8 0c-44.2 0-80-35.8-80-80c0-41.8 32.1-76.2 73.1-79.7c2.1-.2 4.1-1.2 5.5-2.8s2-3.8 1.8-5.9c-.2-2.5-.4-5-.4-7.6zm80-96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.7c0 53 43 96 96 96c1.1 0 2.1 0 3.2-.1H557.3c.9 0 1.8 0 2.6 0c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C433.4 114.6 402.8 96 368 96z'
      
    ]
  };

  

  
  

  var faSwords = {
    prefix: 'fat',
    iconName: 'swords',
    icon: [
      512,
      512,
      [9876],
      'f71d',
      
      'M142.1 278.6l11.3 11.3L119.3 324 188 392.7l34.1-34.1 11.3 11.3L199.3 404l19 19c9.4 9.4 9.4 24.6 0 33.9l-12.9 12.9c-7 7-17.6 9-26.7 5l-56.9-25.3L67.3 504c-5.1 5.1-12.1 8-19.3 8s-14.2-2.9-19.3-8L8 483.3c-5.1-5.1-8-12.1-8-19.3s2.9-14.2 8-19.3l54.5-54.5L37.2 333.3c-4-9.1-2.1-19.7 5-26.7L55 293.7c9.4-9.4 24.6-9.4 33.9 0l19 19 34.1-34.1zm216.6-56.6L467.8 112.8c8.3-8.3 13.7-18.9 15.6-30.4l10.8-64.7L429.5 28.5c-11.5 1.9-22.1 7.4-30.4 15.6L289.9 153.4l-11.3-11.3L387.8 32.8c10.6-10.6 24.3-17.6 39.1-20.1L502.7 .1c2.6-.4 5.1 .4 7 2.2s2.7 4.4 2.2 7L499.3 85.1c-2.5 14.8-9.5 28.5-20.1 39.1L369.9 233.4l-11.3-11.3zM77.7 305c-3.1-3.1-8.2-3.1-11.3 0L53.4 317.9c-2.3 2.3-3 5.9-1.7 8.9l27.5 62c1.3 3 .7 6.6-1.7 8.9L19.3 456c-2.1 2.1-3.3 5-3.3 8s1.2 5.9 3.3 8L40 492.7c2.1 2.1 5 3.3 8 3.3s5.9-1.2 8-3.3l58.3-58.3c2.3-2.3 5.9-3 8.9-1.7l62 27.5c3 1.3 6.6 .7 8.9-1.7L207 445.7c3.1-3.1 3.1-8.2 0-11.3L77.7 305zM.1 9.3c-.4-2.5 .4-5.1 2.2-7S6.8-.3 9.3 .1L85.1 12.7c14.8 2.5 28.5 9.5 39.1 20.1L381.4 290.1l-11.3 11.3L112.8 44.2C104.6 35.9 94 30.4 82.5 28.5L17.7 17.7 28.5 82.5c1.9 11.5 7.4 22.1 15.6 30.4L301.4 370.1l-11.3 11.3L32.8 124.2C22.2 113.5 15.2 99.9 12.7 85.1L.1 9.3zM457 293.7l12.9 12.9c7 7 9 17.6 5 26.7l-25.3 56.9L504 444.7c5.1 5.1 8 12.1 8 19.3s-2.9 14.2-8 19.3L483.3 504c-5.1 5.1-12.1 8-19.3 8s-14.2-2.9-19.3-8l-54.5-54.5-56.9 25.3c-9.1 4-19.7 2.1-26.7-5L293.7 457c-9.4-9.4-9.4-24.6 0-33.9L423 293.7c9.4-9.4 24.6-9.4 33.9 0zM434.3 305L305 434.3c-3.1 3.1-3.1 8.2 0 11.3l12.9 12.9c2.3 2.3 5.9 3 8.9 1.7l62-27.5c3-1.3 6.6-.7 8.9 1.7L456 492.7c2.1 2.1 5 3.3 8 3.3s5.9-1.2 8-3.3L492.7 472c2.1-2.1 3.3-5 3.3-8s-1.2-5.9-3.3-8l-58.3-58.3c-2.3-2.3-3-5.9-1.7-8.9l27.5-62c1.3-3 .7-6.6-1.7-8.9L445.7 305c-3.1-3.1-8.2-3.1-11.3 0z'
      
    ]
  };

  

  
  

  var faCommentSlash = {
    prefix: 'fat',
    iconName: 'comment-slash',
    icon: [
      640,
      512,
      [],
      'f4b3',
      
      'M13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7zM409.4 418.3C382 427.1 351.8 432 320 432c-35.2 0-68.6-6.1-98.7-17c-5-1.8-10.6-1-14.9 2.1c-11 8-29.4 19.3-51.2 28.8c-22.9 10-49.6 18-75.2 18l.1-.1 0 0 0 0 .3-.3 .1-.1c.4-.4 .9-.9 1.5-1.6c1.3-1.4 3.2-3.6 5.4-6.3l-12.2-10 12.2 10C92 450 98 442 104 432c10.7-17.9 21.4-42.1 23.6-69.9c.3-4.3-1.1-8.6-3.9-11.8C95.9 318.8 80 280.7 80 240c0-24.1 5.7-47.4 16.1-69L83.2 160.8C70.8 185.2 64 212 64 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c37.1 0 72.4-6.4 104.2-18l-14.9-11.7zM320 32c-47.7 0-92.4 10.6-130.7 29.1l14 11C237.6 56.8 277.2 48 320 48c135.8 0 240 88.9 240 192c0 32.5-10.4 63.6-28.8 91l12.7 10c20.5-29.9 32.1-64.3 32.1-101C576 125.1 461.4 32 320 32z'
      
    ]
  };

  

  
  

  var faBoxTaped = {
    prefix: 'fat',
    iconName: 'box-taped',
    icon: [
      448,
      512,
      ["box-alt"],
      'f49a',
      
      'M240 48h3L270 176H178L205 48h3 8 16 8zM160 192v80c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V192h16H432V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V192H144h16zm112 0v80c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16V192h96zm32-16H286.3L259.4 48h83c19 0 36.2 11.2 43.9 28.5l41.6 93.6c.9 1.9 1.6 3.9 2.2 5.9H304zm-160 0H18c.6-2 1.3-4 2.2-5.9L61.7 76.5C69.4 59.2 86.6 48 105.6 48h83L161.7 176H144zM256 32H192 105.6C80.3 32 57.4 46.9 47.1 70L5.5 163.6c-3.6 8.2-5.5 17-5.5 26V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V189.6c0-9-1.9-17.8-5.5-26L400.9 70c-10.3-23.1-33.2-38-58.5-38H256z'
      
    ]
  };

  
    var faBoxAlt = faBoxTaped;
  

  
  

  var faXmarkToSlot = {
    prefix: 'fat',
    iconName: 'xmark-to-slot',
    icon: [
      576,
      512,
      ["times-to-slot","vote-nay"],
      'f771',
      
      'M144 48c-17.7 0-32 14.3-32 32V408H464V80c0-17.7-14.3-32-32-32H144zM480 80V408h32c4.4 0 8 3.6 8 8s-3.6 8-8 8H480 464 112 96 64c-4.4 0-8-3.6-8-8s3.6-8 8-8H96V80c0-26.5 21.5-48 48-48H432c26.5 0 48 21.5 48 48zM48 352H64v16H48c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32H528c17.7 0 32-14.3 32-32V400c0-17.7-14.3-32-32-32H512V352h16c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V400c0-26.5 21.5-48 48-48zM210.3 146.3c3.1-3.1 8.2-3.1 11.3 0L288 212.7l66.3-66.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L299.3 224l66.3 66.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L288 235.3l-66.3 66.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L276.7 224l-66.3-66.3c-3.1-3.1-3.1-8.2 0-11.3z'
      
    ]
  };

  
    var faTimesToSlot = faXmarkToSlot;
  
    var faVoteNay = faXmarkToSlot;
  

  
  

  var faVolumeLow = {
    prefix: 'fat',
    iconName: 'volume-low',
    icon: [
      448,
      512,
      [128264,"volume-down"],
      'f027',
      
      'M281 51.5c2.5-2.2 5.8-3.5 9.2-3.5c7.6 0 13.8 6.2 13.8 13.8V450.2c0 7.6-6.2 13.8-13.8 13.8c-3.4 0-6.6-1.2-9.2-3.5L143.2 338c-1.5-1.3-3.4-2-5.3-2H56c-22.1 0-40-17.9-40-40V216c0-22.1 17.9-40 40-40h81.9c2 0 3.9-.7 5.3-2L281 51.5zM290.2 32c-7.3 0-14.3 2.7-19.8 7.5L134.9 160H56c-30.9 0-56 25.1-56 56v80c0 30.9 25.1 56 56 56h78.9L270.4 472.5c5.5 4.8 12.5 7.5 19.8 7.5c16.5 0 29.8-13.3 29.8-29.8V61.8C320 45.3 306.7 32 290.2 32zM409.7 179.2c-3.5-2.7-8.5-1.9-11.2 1.6s-1.9 8.5 1.6 11.2c19.4 14.6 31.9 37.8 31.9 64s-12.5 49.4-31.9 64c-3.5 2.7-4.2 7.7-1.6 11.2s7.7 4.2 11.2 1.6C432.9 315.2 448 287.4 448 256s-15.1-59.2-38.3-76.8z'
      
    ]
  };

  
    var faVolumeDown = faVolumeLow;
  

  
  

  var faFeather = {
    prefix: 'fat',
    iconName: 'feather',
    icon: [
      512,
      512,
      [129718],
      'f52d',
      
      'M339.2 161.4c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L299.3 224h181c10.2-19.6 15.7-41.5 15.7-64c0-36.7-14.6-72-40.6-97.9l-5.5-5.5C424 30.6 388.7 16 352 16s-72 14.6-97.9 40.6L150.3 160.3C105.3 205.3 80 266.4 80 330v90.6L339.2 161.4zM283.3 240l-80 80H393.4l62.1-62.1c5.6-5.6 10.6-11.6 15.1-17.9H283.3zM400 336l-37 37c-48 48-113.1 75-181 75H75.3L13.7 509.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L64 436.7V330c0-67.9 27-133 75-181L242.7 45.3C271.7 16.3 311 0 352 0s80.3 16.3 109.3 45.3l5.5 5.5C495.7 79.7 512 119 512 160s-16.3 80.3-45.3 109.3L400 336zm-22.6 0H187.3l-96 96H182c63.7 0 124.7-25.3 169.7-70.3L377.4 336z'
      
    ]
  };

  

  
  

  var faSquareCode = {
    prefix: 'fat',
    iconName: 'square-code',
    icon: [
      448,
      512,
      [],
      'e267',
      
      'M384 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM266.3 170.3c-3.1 3.1-3.1 8.2 0 11.3L340.7 256l-74.3 74.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l80-80c3.1-3.1 3.1-8.2 0-11.3l-80-80c-3.1-3.1-8.2-3.1-11.3 0zm-84.7 11.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-80 80c-3.1 3.1-3.1 8.2 0 11.3l80 80c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L107.3 256l74.3-74.3z'
      
    ]
  };

  

  
  

  var faDisplayChartUp = {
    prefix: 'fat',
    iconName: 'display-chart-up',
    icon: [
      576,
      512,
      [],
      'e5e3',
      
      'M64 16C37.5 16 16 37.5 16 64V352c0 26.5 21.5 48 48 48H231.8h.3H343.9h.3H512c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H64zM222.6 416H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H353.4l13.3 80H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H360 216 136c-4.4 0-8-3.6-8-8s3.6-8 8-8h73.2l13.3-80zm16.2 0l-13.3 80H350.6l-13.3-80H238.8zM496 80H80l0 256H496V80zM80 64H496c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm272 64h88c4.4 0 8 3.6 8 8v88c0 4.4-3.6 8-8 8s-8-3.6-8-8V155.3L325.7 261.7c-1.5 1.5-3.5 2.3-5.7 2.3s-4.2-.8-5.7-2.3L240 187.3 133.7 293.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l112-112c3.1-3.1 8.2-3.1 11.3 0L320 244.7 420.7 144H352c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faChartScatter3d = {
    prefix: 'fat',
    iconName: 'chart-scatter-3d',
    icon: [
      512,
      512,
      [],
      'e0e8',
      
      'M48 64A16 16 0 1 1 16 64a16 16 0 1 1 32 0zM32 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm232 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V284.3L34.8 465.9c-3.4 2.9-3.8 7.9-.9 11.3s7.9 3.8 11.3 .9L256 298.5 466.8 478.1c3.4 2.9 8.4 2.5 11.3-.9s2.5-8.4-.9-11.3L264 284.3V40zM400 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM384 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 240a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm144-96a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM128 176a16 16 0 1 1 0-32 16 16 0 1 1 0 32zM96 160a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM32 272a16 16 0 1 1 0-32 16 16 0 1 1 0 32zM0 256a32 32 0 1 0 64 0A32 32 0 1 0 0 256zM272 448a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64z'
      
    ]
  };

  

  
  

  var faHanukiah = {
    prefix: 'fat',
    iconName: 'hanukiah',
    icon: [
      640,
      512,
      [128334],
      'f6e6',
      
      'M336 64c0-9.5-3.5-20-8.5-29.8c-2.4-4.7-5-9-7.5-12.6c-2.4 3.6-5 7.9-7.5 12.6C307.5 44 304 54.5 304 64c0 8.8 7.2 16 16 16s16-7.2 16-16zM320 96c-17.7 0-32-14.3-32-32c0-26.2 18.9-52.4 25.7-61c1.5-1.9 3.8-3 6.3-3s4.8 1 6.3 3c6.8 8.6 25.7 34.8 25.7 61c0 17.7-14.3 32-32 32zm-80 0c0-9.5-3.5-20-8.5-29.8c-2.4-4.7-5.1-9-7.5-12.6c-2.4 3.6-5 7.9-7.5 12.6C211.5 76 208 86.5 208 96c0 8.8 7.2 16 16 16s16-7.2 16-16zm-16 32c-17.7 0-32-14.3-32-32c0 17.7-14.3 32-32 32s-32-14.3-32-32c0 17.7-14.3 32-32 32s-32-14.3-32-32c0 17.7-14.3 32-32 32S0 113.7 0 96C0 69.8 18.9 43.6 25.7 35c1.5-1.9 3.8-3 6.3-3s4.8 1 6.3 3C45.1 43.6 64 69.8 64 96c0-26.2 18.9-52.4 25.7-61c1.5-1.9 3.8-3 6.3-3s4.8 1 6.3 3c6.8 8.6 25.7 34.8 25.7 61c0-26.2 18.9-52.4 25.7-61c1.5-1.9 3.8-3 6.3-3s4.8 1 6.3 3c6.8 8.6 25.7 34.8 25.7 61c0-26.2 18.9-52.4 25.7-61c1.5-1.9 3.8-3 6.3-3s4.8 1 6.3 3c6.8 8.6 25.7 34.8 25.7 61c0 17.7-14.3 32-32 32zm192-16c8.8 0 16-7.2 16-16c0-9.5-3.5-20-8.5-29.8c-2.4-4.7-5-9-7.5-12.6c-2.4 3.6-5 7.9-7.5 12.6C403.5 76 400 86.5 400 96c0 8.8 7.2 16 16 16zm32-16c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-26.2 18.9-52.4 25.7-61c1.5-1.9 3.8-3 6.3-3s4.8 1 6.3 3c6.8 8.6 25.7 34.8 25.7 61zm64 0c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-26.2 18.9-52.4 25.7-61c1.5-1.9 3.8-3 6.3-3s4.8 1 6.3 3c6.8 8.6 25.7 34.8 25.7 61zm64 0c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-26.2 18.9-52.4 25.7-61c1.5-1.9 3.8-3 6.3-3s4.8 1 6.3 3c6.8 8.6 25.7 34.8 25.7 61zm0 0c0-26.2 18.9-52.4 25.7-61c1.5-1.9 3.8-3 6.3-3s4.8 1 6.3 3c6.8 8.6 25.7 34.8 25.7 61c0 17.7-14.3 32-32 32s-32-14.3-32-32zm48 0c0-9.5-3.5-20-8.5-29.8c-2.4-4.7-5-9-7.5-12.6c-2.4 3.6-5 7.9-7.5 12.6C595.5 76 592 86.5 592 96c0 8.8 7.2 16 16 16s16-7.2 16-16zm-80 16c8.8 0 16-7.2 16-16c0-9.5-3.5-20-8.5-29.8c-2.4-4.7-5-9-7.5-12.6c-2.4 3.6-5 7.9-7.5 12.6C531.5 76 528 86.5 528 96c0 8.8 7.2 16 16 16zM496 96c0-9.5-3.5-20-8.5-29.8c-2.4-4.7-5-9-7.5-12.6c-2.4 3.6-5 7.9-7.5 12.6C467.5 76 464 86.5 464 96c0 8.8 7.2 16 16 16s16-7.2 16-16zM160 112c8.8 0 16-7.2 16-16c0-9.5-3.5-20-8.5-29.8c-2.4-4.7-5.1-9-7.5-12.6c-2.4 3.6-5 7.9-7.5 12.6C147.5 76 144 86.5 144 96c0 8.8 7.2 16 16 16zM112 96c0-9.5-3.5-20-8.5-29.8c-2.4-4.7-5.1-9-7.5-12.6c-2.4 3.6-5 7.9-7.5 12.6C83.5 76 80 86.5 80 96c0 8.8 7.2 16 16 16s16-7.2 16-16zM32 112c8.8 0 16-7.2 16-16c0-9.5-3.5-20-8.5-29.8c-2.4-4.7-5.1-9-7.5-12.6c-2.4 3.6-5 7.9-7.5 12.6C19.5 76 16 86.5 16 96c0 8.8 7.2 16 16 16zm288 16c4.4 0 8 3.6 8 8l0 232h80V168c0-4.4 3.6-8 8-8s8 3.6 8 8V368h48V168c0-4.4 3.6-8 8-8s8 3.6 8 8V368h48V168c0-4.4 3.6-8 8-8s8 3.6 8 8V367.4c27.1-3.9 48-27.2 48-55.4l0-144c0-4.4 3.6-8 8-8s8 3.6 8 8l0 144c0 39.8-32.2 72-72 72H328V496H504c4.4 0 8 3.6 8 8s-3.6 8-8 8H320 136c-4.4 0-8-3.6-8-8s3.6-8 8-8H312V384H96c-39.8 0-72-32.2-72-72l0-144c0-4.4 3.6-8 8-8s8 3.6 8 8l0 144c0 28.2 20.9 51.6 48 55.4V168c0-4.4 3.6-8 8-8s8 3.6 8 8V368h48V168c0-4.4 3.6-8 8-8s8 3.6 8 8V368h48V168c0-4.4 3.6-8 8-8s8 3.6 8 8V368h80l0-232c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faFaceCowboyHat = {
    prefix: 'fat',
    iconName: 'face-cowboy-hat',
    icon: [
      512,
      512,
      [],
      'e36e',
      
      'M375 110.9C359 62.1 330.2 0 296 0c-8.9 0-17.4 4.2-25.4 11.2c-8.2 7.2-21.1 7.2-29.3 0C233.4 4.2 224.9 0 216 0c-34.2 0-63 62.1-79 110.9c-34.9-10.6-66.1-25.7-91.9-44.2C42.6 65 39.7 64 36.7 64C27.7 64 21 72.3 23.8 80.7C50.8 163.2 144.5 224 256 224s205.2-60.8 232.2-143.3C491 72.3 484.3 64 475.3 64c-3 0-6 1-8.4 2.8c-25.8 18.5-57 33.6-91.9 44.2zm-15.4 4.3c-32.1 8.3-67 12.8-103.5 12.8s-71.4-4.5-103.5-12.8c6-18.2 13.8-38.1 22.9-55.6c7.2-13.9 14.9-25.4 22.5-33.2c7.8-8 13.9-10.4 18.1-10.4c3.6 0 8.5 1.7 14.8 7.2c14.2 12.5 36.2 12.5 50.4 0c6.3-5.5 11.2-7.2 14.8-7.2c4.3 0 10.3 2.4 18.1 10.4c7.7 7.8 15.3 19.3 22.5 33.2c9.1 17.5 16.9 37.4 22.9 55.6zM42 84.1c55.2 37.3 131 59.9 214 59.9s158.7-22.6 214-59.9C442.2 154.3 358.4 208 256 208S69.8 154.3 42 84.1zM75.8 200C58.1 230.6 48 266.1 48 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-37.9-10.1-73.4-27.8-104c-4.3 3.1-8.7 6.1-13.3 9c16 28 25.1 60.4 25.1 94.9c0 106-86 192-192 192S64 410 64 304c0-34.5 9.1-66.9 25.1-94.9c-4.5-2.9-9-5.9-13.3-9zM256.2 378.3c35.6 0 69.8-4.3 101.1-12.1c4-1 7.3 .4 8.7 1.9c.7 .7 .7 1.1 .7 1.1s0 .1 0 .3s-.2 .6-.5 1.3C344 408.7 303 434 256.2 434s-87.8-25.3-110-63.2c-.4-.7-.5-1.1-.5-1.3s0-.3 0-.3s.1-.4 .7-1.1c1.5-1.5 4.7-2.9 8.7-1.9c31.3 7.8 65.4 12.1 101.1 12.1zm123.8 .5c9.7-16.6-7.9-32.8-26.6-28.2c-30 7.5-62.8 11.6-97.2 11.6s-67.2-4.1-97.2-11.6c-18.7-4.7-36.3 11.6-26.6 28.2c25 42.6 71.1 71.1 123.8 71.1s98.8-28.6 123.8-71.1zM192 272a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm144 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faFlag = {
    prefix: 'fat',
    iconName: 'flag',
    icon: [
      448,
      512,
      [61725,127988],
      'f024',
      
      'M16 8c0-4.4-3.6-8-8-8S0 3.6 0 8V64 383.5 400 504c0 4.4 3.6 8 8 8s8-3.6 8-8V396l112.3-28.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30V54.8c0-17.8-18.8-29.4-34.7-21.5l-19.7 9.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L16 60V8zm0 68.5L136.8 46.3c34.4-8.6 70.7-4.6 102.4 11.2c50.8 25.4 110.6 25.4 161.5 0l19.7-9.8c5.3-2.7 11.6 1.2 11.6 7.2v291c0 6.7-4.1 12.6-10.4 15l-34.7 13c-42.1 15.8-88.8 13.3-129-6.8c-41.3-20.7-88.7-25.9-133.5-14.7L16 379.5V76.5z'
      
    ]
  };

  

  
  

  var faArrowUpToLine = {
    prefix: 'fat',
    iconName: 'arrow-up-to-line',
    icon: [
      384,
      512,
      ["arrow-to-top"],
      'f341',
      
      'M8 32c-4.4 0-8 3.6-8 8s3.6 8 8 8l368 0c4.4 0 8-3.6 8-8s-3.6-8-8-8L8 32zm189.7 98.3c-3.1-3.1-8.2-3.1-11.3 0l-136 136c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L184 155.3 184 472c0 4.4 3.6 8 8 8s8-3.6 8-8l0-316.7L322.3 277.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-136-136z'
      
    ]
  };

  
    var faArrowToTop = faArrowUpToLine;
  

  
  

  var faSquirrel = {
    prefix: 'fat',
    iconName: 'squirrel',
    icon: [
      512,
      512,
      [],
      'f71a',
      
      'M140.3 16C71.6 16 16 71.6 16 140.3s55.6 124.3 124.3 124.3c13.1 0 25.2 7.1 31.5 18.6c7.9 14.3 4.5 31.1-4 43.2c-12.3 17.5-19.6 38.9-19.6 61.9C148.3 447.8 196.5 496 256 496H361.2c42 0 76-34 76-76s-34-76-76-76c-8 0-15.6 1.2-22.8 3.5c-4.2 1.3-8.7-1-10-5.2s1-8.7 5.2-10c8.7-2.7 18-4.2 27.6-4.2c17.1 0 33.1 4.7 46.8 12.8V240c0-4.4 3.6-8 8-8h16.5c25.6 0 48.7-15.3 58.8-38.8l4.5-10.5-.6-5.9C491.6 140 460.6 112 423.6 112H408c-4.4 0-8-3.6-8-8V80c-13.3 0-24 10.7-24 24c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-13.3-10.7-24-24-24V96v8 44.2c0 37.9-6.8 64.1-20.2 87.9c-11.4 20.4-27.6 39-47.2 61.6c-2.8 3.2-5.7 6.6-8.7 10l-11.2 13C233 338.9 224 367.1 224 392c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-28.1 10-60.2 28.6-81.8l11.2-13c3-3.5 5.9-6.8 8.7-10l0 0c19.8-22.8 34.8-40 45.3-58.9c11.8-21.1 18.1-44.4 18.1-80.1V104 96 80c0-8.8 7.2-16 16-16c13.1 0 24.7 6.3 32 16c7.3-9.7 18.9-16 32-16c8.8 0 16 7.2 16 16V96h7.6c45.2 0 83.1 34.3 87.6 79.2l.8 8c.1 1.3-.1 2.7-.6 3.9l-5.3 12.4c-12.6 29.4-41.5 48.5-73.5 48.5H424V352h-.8c18.5 16.8 30 41.1 30 68c0 31.6-15.9 59.4-40.1 76H472c4.4 0 8 3.6 8 8s-3.6 8-8 8H361.2 256c-68.3 0-123.7-55.4-123.7-123.7c0-26.5 8.3-51 22.5-71.1c6-8.5 7.2-18.6 3-26.3c-3.5-6.4-10.2-10.3-17.5-10.3C62.8 280.5 0 217.7 0 140.3S62.8 0 140.3 0s140.3 62.8 140.3 140.3v33.1c0 4.4-3.6 8-8 8s-8-3.6-8-8V140.3C264.5 71.6 208.9 16 140.3 16zM416 144a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faFireBurner = {
    prefix: 'fat',
    iconName: 'fire-burner',
    icon: [
      640,
      512,
      [],
      'e4f1',
      
      'M285.5 16c-1.5 0-3 .5-4.1 1.5C257.7 38.8 231.2 66 210.7 96.2c-20.6 30.3-34.7 62.9-34.7 95.2c0 50 25.1 94.3 63.7 120.3c-9.9-14.1-15.7-31-15.7-49.2c0-57.4 63.8-110.5 87.4-128.2c5.2-3.9 12.1-3.9 17.3 0c23.6 17.7 87.4 70.8 87.4 128.2c0 17.9-5.7 34.7-15.4 48.7c38.3-26.1 63.4-70.1 63.4-119.8c0-25.8-9.7-53.6-24.5-79.7c-14.8-26.1-34.3-49.8-53.2-67.2c-2.3-2.1-5.9-2.1-8.2 0c-6.3 5.8-12.4 12.6-18.2 19.6c-6.4 7.8-18.2 7.9-24.8 .3c-14.3-16.7-29.5-32.3-45.6-46.8c-1.1-1-2.5-1.5-4-1.5zM320 336c2.8 0 5.6-.1 8.3-.2c41.1-3.9 71.7-36 71.7-73.2c0-23-13-47-31.1-68.7c-17.3-20.7-37.4-37.2-48.9-45.9c-11.5 8.7-31.6 25.2-48.9 45.9C253 215.5 240 239.5 240 262.6c0 37.2 30.6 69.4 71.8 73.2c2.7 .1 5.4 .2 8.2 .2zM160 191.4c0-36.8 16-72.6 37.4-104.2c21.5-31.7 49.1-59.8 73.3-81.6C275 1.8 280.3 0 285.6 0c5.2 0 10.5 1.9 14.6 5.7c16.6 15 32.3 31.1 47 48.3c0 0 0 0 .1 0l0 0c0 0 .1 0 .1 0s.1 0 .1 0s0 0 .1-.1c6-7.2 12.6-14.8 19.7-21.3c8.4-7.7 21.4-7.7 29.8 .1c20.1 18.5 40.7 43.5 56.3 71.1C469 131.3 480 161.9 480 191.4c0 85.1-66.3 155.4-150.6 160.3c-3.1 .3-6.2 .4-9.4 .4c-3.1 0-6.2-.1-9.2-.4C225.5 347 160 276.5 160 191.4zM32 264c0-4.4 3.6-8 8-8H88c4.4 0 8 3.6 8 8s-3.6 8-8 8H48V384H592V272H552c-4.4 0-8-3.6-8-8s3.6-8 8-8h48c4.4 0 8 3.6 8 8V384c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32V264zm0 136c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H608c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16h-8H40 32zm288 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm112 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM192 432a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faRoadSpikes = {
    prefix: 'fat',
    iconName: 'road-spikes',
    icon: [
      640,
      512,
      [],
      'e568',
      
      'M580.2 336c12.8 0 20.4-14.2 13.3-24.9L464 116.8V280v56H580.2zM448 256V116.8c0-15.8 20.5-22 29.3-8.9L606.8 302.2c14.2 21.3-1.1 49.7-26.6 49.7H464v0H448 336v0H320 208 192 80 64V336 116.8c0-15.8 20.5-22 29.3-8.9L192 256V116.8c0-15.8 20.5-22 29.3-8.9L320 256V116.8c0-15.8 20.5-22 29.3-8.9L448 256zm0 28.8l-112-168V280v56H448v0V284.8zM320 336v0V284.8l-112-168V280v56H320zM80 116.8V336H192V284.8L80 116.8zM0 440c0-4.4 3.6-8 8-8H632c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faFaceSleeping = {
    prefix: 'fat',
    iconName: 'face-sleeping',
    icon: [
      512,
      512,
      [],
      'e38d',
      
      'M16 256C16 123.5 123.5 16 256 16c35.4 0 69.1 7.7 99.3 21.4c4 1.8 8.8 .1 10.6-4s.1-8.8-4-10.6C329.6 8.2 293.8 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-37.8-8.2-73.6-22.9-105.9c-1.8-4-6.6-5.8-10.6-4s-5.8 6.6-4 10.6C488.3 186.9 496 220.6 496 256c0 132.5-107.5 240-240 240S16 388.5 16 256zM224 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM424 16h60.7L418.3 82.3c-2.3 2.3-3 5.7-1.7 8.7s4.2 4.9 7.4 4.9h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H443.3l66.3-66.3c2.3-2.3 3-5.7 1.7-8.7s-4.2-4.9-7.4-4.9H424c-4.4 0-8 3.6-8 8s3.6 8 8 8zM288 104c0 4.4 3.6 8 8 8h60.7l-66.3 66.3c-2.3 2.3-3 5.7-1.7 8.7s4.2 4.9 7.4 4.9h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H315.3l66.3-66.3c2.3-2.3 3-5.7 1.7-8.7s-4.2-4.9-7.4-4.9H296c-4.4 0-8 3.6-8 8zm63.6 168c-14.6 0-30.2-8.6-41-27.9c-2.2-3.9-7-5.2-10.9-3.1s-5.2 7-3.1 10.9c13.1 23.4 33.6 36.1 55 36.1s41.8-12.7 55-36.1c2.2-3.9 .8-8.7-3.1-10.9s-8.7-.8-10.9 3.1c-10.9 19.3-26.4 27.9-41 27.9zm-233-27.9c-2.2-3.9-7-5.2-10.9-3.1s-5.2 7-3.1 10.9c13.1 23.4 33.6 36.1 55 36.1s41.8-12.7 55-36.1c2.2-3.9 .8-8.7-3.1-10.9s-8.7-.8-10.9 3.1c-10.9 19.3-26.4 27.9-41 27.9s-30.2-8.6-41-27.9z'
      
    ]
  };

  

  
  

  var faMemory = {
    prefix: 'fat',
    iconName: 'memory',
    icon: [
      576,
      512,
      [],
      'f538',
      
      'M16 128c0-26.5 21.5-48 48-48H512c26.5 0 48 21.5 48 48v7.4c0 .1-.1 .3-.3 .6c-.4 .7-1.3 1.5-2.5 2.4C539.6 149.7 528 169.5 528 192s11.6 42.3 29.2 53.7c1.3 .8 2.1 1.7 2.5 2.4c.2 .3 .3 .5 .3 .6V320H16V248.6c0-.1 .1-.3 .3-.6c.4-.7 1.3-1.5 2.5-2.4C36.4 234.3 48 214.5 48 192s-11.6-42.3-29.2-53.7c-1.3-.8-2.1-1.7-2.5-2.4c-.2-.3-.3-.5-.3-.6V128zm0 208H560v80c0 8.8-7.2 16-16 16H480V400c0-4.4-3.6-8-8-8s-8 3.6-8 8v32H352V400c0-4.4-3.6-8-8-8s-8 3.6-8 8v32H240V400c0-4.4-3.6-8-8-8s-8 3.6-8 8v32H112V400c0-4.4-3.6-8-8-8s-8 3.6-8 8v32H32c-8.8 0-16-7.2-16-16V336zM32 448h72H232 344 472h72c17.7 0 32-14.3 32-32V248.6c0-6.8-4.4-12.6-10.1-16.3C552.7 223.7 544 208.9 544 192s8.7-31.7 21.9-40.3c5.7-3.7 10.1-9.5 10.1-16.3V128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128v7.4c0 6.8 4.4 12.6 10.1 16.3C23.3 160.3 32 175.1 32 192s-8.7 31.7-21.9 40.3C4.4 236 0 241.8 0 248.6V416c0 17.7 14.3 32 32 32zM160 144c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V160c0-8.8 7.2-16 16-16zm128 0c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V160c0-8.8 7.2-16 16-16zm128 0c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V160c0-8.8 7.2-16 16-16zM160 128c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-17.7-14.3-32-32-32zm128 0c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-17.7-14.3-32-32-32zm128 0c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-17.7-14.3-32-32-32z'
      
    ]
  };

  

  
  

  var faCircleDollarToSlot = {
    prefix: 'fat',
    iconName: 'circle-dollar-to-slot',
    icon: [
      512,
      512,
      ["donate"],
      'f4b9',
      
      'M448 208A192 192 0 1 0 64 208a192 192 0 1 0 384 0zM48 208a208 208 0 1 1 416 0A208 208 0 1 1 48 208zm0 160H77.1c5 5.6 10.2 10.9 15.7 16H48c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32H464c17.7 0 32-14.3 32-32V416c0-17.7-14.3-32-32-32H419.2c5.5-5.1 10.7-10.4 15.7-16H464c26.5 0 48 21.5 48 48v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V416c0-26.5 21.5-48 48-48zM256.9 93.3c4.4 0 8 3.6 8 8v19.3c2.3 .2 4.5 .5 6.8 .9c5.3 .8 21.5 4 27.2 5.5c4.3 1.1 6.8 5.5 5.7 9.8s-5.5 6.8-9.8 5.7c-4.9-1.3-20.5-4.3-25.6-5.1c-15.8-2.5-29.7-.6-39.9 4c-10.1 4.6-15.9 11.5-17.3 19.5c-1.1 6.2-.3 10.7 1.3 14.1c1.7 3.5 4.6 6.7 8.9 9.6c8.9 6.1 21.9 10 36.7 14.4l.4 .1c14.2 4.3 30.1 9.1 41.6 17.5c5.9 4.3 11 9.8 14.1 16.9c3.1 7.2 3.9 15.4 2.3 24.6c-2.7 15.6-12.9 26.5-26.7 32.4c-7.6 3.3-16.4 5.1-25.8 5.5v18.8c0 4.4-3.6 8-8 8s-8-3.6-8-8V295.4c-2.3-.2-4.5-.5-6.8-.9l0 0c-9.5-1.5-25-6.8-35.4-10.4l0 0 0 0c-2.1-.7-4-1.4-5.6-1.9c-4.2-1.4-6.5-5.9-5.1-10.1s5.9-6.5 10.1-5.1c1.9 .6 4.1 1.4 6.3 2.1l0 0c10.6 3.6 24.1 8.2 32.1 9.5c16 2.5 29.9 1.2 39.8-3.1c9.7-4.2 15.6-11 17.3-20.4c1.2-6.7 .4-11.7-1.2-15.5c-1.7-3.9-4.6-7.2-8.8-10.3c-8.9-6.4-21.9-10.6-36.8-15.1l-1.8-.5c-13.6-4.1-28.7-8.6-39.6-16.1c-5.9-4-11.1-9.2-14.4-16c-3.3-6.9-4.2-14.8-2.6-23.7c2.5-14.5 12.9-25.2 26.4-31.4c7.7-3.5 16.5-5.6 26.1-6.3V101.3c0-4.4 3.6-8 8-8zM64 440H448c4.4 0 8 3.6 8 8s-3.6 8-8 8H64c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  
    var faDonate = faCircleDollarToSlot;
  

  
  

  var faSpaceStationMoonConstruction = {
    prefix: 'fat',
    iconName: 'space-station-moon-construction',
    icon: [
      512,
      512,
      ["space-station-moon-alt"],
      'e034',
      
      'M256 16C123.5 16 16 123.5 16 256c0 12.4 .9 24.5 2.7 36.4C92.4 320.6 172.4 336 256 336s163.6-15.4 237.3-43.6c1.4-9.3 2.3-18.7 2.6-28.4H416c-4.4 0-8-3.6-8-8s3.6-8 8-8h88c4.4 0 8 3.6 8 8c0 14.8-1.3 29.2-3.7 43.3c-.4 2.5-2 4.7-4.3 5.8l-1.4 .7c-.2 .1-.5 .2-.7 .3C425.7 335.8 342.7 352 256 352c-82.1 0-160.8-14.6-233.7-41.2C47.1 416.9 142.3 496 256 496c82 0 154.5-41.2 197.8-104H400c-4.4 0-8-3.6-8-8s3.6-8 8-8h68.5c2.9 0 5.5 1.6 7 4.1s1.4 5.6-.1 8.1C430.5 462.3 349 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0c78.4 0 148.7 35.3 195.6 90.8c2 2.4 2.5 5.7 1.1 8.5s-4.1 4.6-7.3 4.6H360c-4.4 0-8-3.6-8-8s3.6-8 8-8h67.4C383.8 43.6 323.1 16 256 16zm88 136c0-4.4 3.6-8 8-8h96c4.4 0 8 3.6 8 8s-3.6 8-8 8H352c-4.4 0-8-3.6-8-8zm0 48c0-4.4 3.6-8 8-8h96c4.4 0 8 3.6 8 8s-3.6 8-8 8H352c-4.4 0-8-3.6-8-8zM192 224a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-144a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  
    var faSpaceStationMoonAlt = faSpaceStationMoonConstruction;
  

  
  

  var faPipeSection = {
    prefix: 'fat',
    iconName: 'pipe-section',
    icon: [
      640,
      512,
      [],
      'e438',
      
      'M48 384c0 8.8-7.2 16-16 16s-16-7.2-16-16V128c0-8.8 7.2-16 16-16s16 7.2 16 16V384zM32 96C14.3 96 0 110.3 0 128V384c0 17.7 14.3 32 32 32s32-14.3 32-32H576c0 17.7 14.3 32 32 32s32-14.3 32-32V128c0-17.7-14.3-32-32-32s-32 14.3-32 32L64 128c0-17.7-14.3-32-32-32zm544 48V368H64V144H576zm48-16V384c0 8.8-7.2 16-16 16s-16-7.2-16-16V128c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faSitemap = {
    prefix: 'fat',
    iconName: 'sitemap',
    icon: [
      576,
      512,
      [],
      'f0e8',
      
      'M320 48c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V80c0-17.7 14.3-32 32-32h64zM256 32c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h24v56H112c-22.1 0-40 17.9-40 40v32H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H88V288c0-13.3 10.7-24 24-24H280v56H256c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H296V264H464c13.3 0 24 10.7 24 24v32H464c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H504V288c0-22.1-17.9-40-40-40H296V192h24c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H256zM48 336h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V368c0-17.7 14.3-32 32-32zm208 0h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V368c0-17.7 14.3-32 32-32zm208 0h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H464c-17.7 0-32-14.3-32-32V368c0-17.7 14.3-32 32-32z'
      
    ]
  };

  

  
  

  var faHeadphonesSimple = {
    prefix: 'fat',
    iconName: 'headphones-simple',
    icon: [
      512,
      512,
      ["headphones-alt"],
      'f58f',
      
      'M16 288C16 155.5 123.5 48 256 48s240 107.5 240 240v88c0 4.4 3.6 8 8 8s8-3.6 8-8V288C512 146.6 397.4 32 256 32S0 146.6 0 288v88c0 4.4 3.6 8 8 8s8-3.6 8-8V288zm128-16c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H128c-35.3 0-64-28.7-64-64V336c0-35.3 28.7-64 64-64h16zm-16-16c-44.2 0-80 35.8-80 80v64c0 44.2 35.8 80 80 80h16c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H128zm240 16h16c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H368c-8.8 0-16-7.2-16-16V288c0-8.8 7.2-16 16-16zm16-16H368c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32h16c44.2 0 80-35.8 80-80V336c0-44.2-35.8-80-80-80z'
      
    ]
  };

  
    var faHeadphonesAlt = faHeadphonesSimple;
  

  
  

  var faCloudShowersHeavy = {
    prefix: 'fat',
    iconName: 'cloud-showers-heavy',
    icon: [
      512,
      512,
      [],
      'f740',
      
      'M398.7 124.8c.8-4.1 1.3-8.4 1.3-12.8c0-35.3-28.7-64-64-64c-19.5 0-36.9 8.7-48.6 22.4c-3.5 4-8.7 6.1-13.9 5.5s-9.9-3.8-12.4-8.5C245 36.8 212.9 16 176 16c-53 0-96 43-96 96c0 6.1 .6 12.1 1.7 17.9c1.5 7.9-3.1 15.6-10.7 18.1C39 158.5 16 188.6 16 224c0 44.2 35.8 80 80 80H416c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.5 0-.9 0-1.3 0c-4.8 .1-9.5-2-12.6-5.8s-4.3-8.7-3.4-13.4zM176 0c37.1 0 70 18.1 90.4 45.9c3.3 4.5 6.2 9.2 8.8 14.1c3.6-4.2 7.6-8 12-11.4C300.7 38.2 317.6 32 336 32c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c4.9 0 9.8 .4 14.5 1.1c46.1 7 81.5 46.8 81.5 94.9c0 53-43 96-96 96H96c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0zM87.2 363.6l-72 144c-2 4-6.8 5.6-10.7 3.6s-5.6-6.8-3.6-10.7l72-144c2-4 6.8-5.6 10.7-3.6s5.6 6.8 3.6 10.7zm120 0l-72 144c-2 4-6.8 5.6-10.7 3.6s-5.6-6.8-3.6-10.7l72-144c2-4 6.8-5.6 10.7-3.6s5.6 6.8 3.6 10.7zm112 0l-72 144c-2 4-6.8 5.6-10.7 3.6s-5.6-6.8-3.6-10.7l72-144c2-4 6.8-5.6 10.7-3.6s5.6 6.8 3.6 10.7zm120 0l-72 144c-2 4-6.8 5.6-10.7 3.6s-5.6-6.8-3.6-10.7l72-144c2-4 6.8-5.6 10.7-3.6s5.6 6.8 3.6 10.7z'
      
    ]
  };

  

  
  

  var faTemperatureList = {
    prefix: 'fat',
    iconName: 'temperature-list',
    icon: [
      512,
      512,
      [],
      'e299',
      
      'M160 16c-35.3 0-64 28.7-64 64V243.8c0 8.4-4.4 15.7-10.7 20.3C53 287.3 32 325.2 32 368c0 70.7 57.3 128 128 128s128-57.3 128-128c0-42.8-21-80.7-53.3-104c-6.3-4.6-10.7-11.9-10.7-20.3V80c0-35.3-28.7-64-64-64zM80 80c0-44.2 35.8-80 80-80s80 35.8 80 80V243.8c0 2.7 1.4 5.4 4 7.3c36.3 26.1 60 68.8 60 117c0 79.5-64.5 144-144 144S16 447.5 16 368c0-48.2 23.7-90.8 60-117c2.6-1.9 4-4.6 4-7.3V80zm80 336a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-112a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM328 32H504c4.4 0 8 3.6 8 8s-3.6 8-8 8H328c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 128H504c4.4 0 8 3.6 8 8s-3.6 8-8 8H328c-4.4 0-8-3.6-8-8s3.6-8 8-8zm32 128H504c4.4 0 8 3.6 8 8s-3.6 8-8 8H360c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faUnlockKeyhole = {
    prefix: 'fat',
    iconName: 'unlock-keyhole',
    icon: [
      448,
      512,
      ["unlock-alt"],
      'f13e',
      
      'M224 16c-61.9 0-112 50.1-112 112v64H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H96V128C96 57.3 153.3 0 224 0c58.9 0 108.5 39.8 123.4 93.9c1.2 4.3-1.3 8.7-5.6 9.8s-8.7-1.3-9.8-5.6C318.9 50.8 275.5 16 224 16zM64 208c-26.5 0-48 21.5-48 48V448c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V256c0-26.5-21.5-48-48-48H112 96 64zM272 352c0-8.8-7.2-16-16-16H192c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16zm-16-32c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32h64z'
      
    ]
  };

  
    var faUnlockAlt = faUnlockKeyhole;
  

  
  

  var faSidebarFlip = {
    prefix: 'fat',
    iconName: 'sidebar-flip',
    icon: [
      512,
      512,
      [],
      'e24f',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H288V48H64zm384 0H304V464H448c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48zm0-16c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H448zm-8 64c4.4 0 8 3.6 8 8s-3.6 8-8 8H360c-4.4 0-8-3.6-8-8s3.6-8 8-8h80zm8 72c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8s3.6-8 8-8h80c4.4 0 8 3.6 8 8zm-8 56c4.4 0 8 3.6 8 8s-3.6 8-8 8H360c-4.4 0-8-3.6-8-8s3.6-8 8-8h80z'
      
    ]
  };

  

  
  

  var faCircleChevronDown = {
    prefix: 'fat',
    iconName: 'circle-chevron-down',
    icon: [
      512,
      512,
      ["chevron-circle-down"],
      'f13a',
      
      'M256 16a240 240 0 1 0 0 480 240 240 0 1 0 0-480zm0 496A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM381.7 221.7l-120 120c-3.1 3.1-8.2 3.1-11.3 0l-120-120c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L256 324.7 370.3 210.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3z'
      
    ]
  };

  
    var faChevronCircleDown = faCircleChevronDown;
  

  
  

  var faFaceFrownSlight = {
    prefix: 'fat',
    iconName: 'face-frown-slight',
    icon: [
      512,
      512,
      [],
      'e376',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM361.4 396.6C340.6 366.8 305.4 336 256 336s-84.6 30.8-105.4 60.6c-2.5 3.6-7.5 4.5-11.1 2s-4.5-7.5-2-11.1c22.4-32 61.9-67.4 118.6-67.4s96.1 35.4 118.6 67.4c2.5 3.6 1.7 8.6-2 11.1s-8.6 1.7-11.1-2zM160.4 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faArrowRightFromBracket = {
    prefix: 'fat',
    iconName: 'arrow-right-from-bracket',
    icon: [
      512,
      512,
      ["sign-out"],
      'f08b',
      
      'M509.7 261.7c3.1-3.1 3.1-8.2 0-11.3l-136-136c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L484.7 248 168 248c-4.4 0-8 3.6-8 8s3.6 8 8 8l316.7 0L362.3 386.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l136-136zM184 48c4.4 0 8-3.6 8-8s-3.6-8-8-8L88 32C39.4 32 0 71.4 0 120L0 392c0 48.6 39.4 88 88 88l96 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-96 0c-39.8 0-72-32.2-72-72l0-272c0-39.8 32.2-72 72-72l96 0z'
      
    ]
  };

  
    var faSignOut = faArrowRightFromBracket;
  

  
  

  var faSchoolCircleXmark = {
    prefix: 'fat',
    iconName: 'school-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e56d',
      
      'M315.4 1.4c2.8-1.9 6.4-1.9 9.2 0L482.5 112H584c30.9 0 56 25.1 56 56v98.8c-4.9-6.9-10.2-13.5-16-19.6V168c0-22.1-17.9-40-40-40H480c-1.6 0-3.2-.5-4.6-1.4L320 17.8 164.6 126.6c-1.3 .9-2.9 1.4-4.6 1.4H56c-22.1 0-40 17.9-40 40V456c0 22.1 17.9 40 40 40H256V384c0-35.3 28.7-64 64-64c2.2 0 4.4 .1 6.5 .3c-1.4 5.2-2.7 10.4-3.6 15.8c-1-.1-1.9-.1-2.9-.1c-26.5 0-48 21.5-48 48V496h32 64 7.2c6.1 5.8 12.7 11.1 19.6 16H384 368 272 256 56c-30.9 0-56-25.1-56-56V168c0-30.9 25.1-56 56-56H157.5L315.4 1.4zM88 192h32c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V216c0-13.3 10.7-24 24-24zm-8 24v48c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V216c0-4.4-3.6-8-8-8H88c-4.4 0-8 3.6-8 8zm240 24a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-144a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm8 48v24h16c4.4 0 8 3.6 8 8s-3.6 8-8 8H320c-4.4 0-8-3.6-8-8V144c0-4.4 3.6-8 8-8s8 3.6 8 8zM64 344c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V344zm24-8c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V344c0-4.4-3.6-8-8-8H88zm536 32a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm205.7-50.3L507.3 368l50.3 50.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L496 379.3l-50.3 50.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L484.7 368l-50.3-50.3c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L496 356.7l50.3-50.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3z'
      
    ]
  };

  

  
  

  var faCircleExclamation = {
    prefix: 'fat',
    iconName: 'circle-exclamation',
    icon: [
      512,
      512,
      ["exclamation-circle"],
      'f06a',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-4.4 0-8 3.6-8 8V296c0 4.4 3.6 8 8 8s8-3.6 8-8V136c0-4.4-3.6-8-8-8zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  
    var faExclamationCircle = faCircleExclamation;
  

  
  

  var faBlock = {
    prefix: 'fat',
    iconName: 'block',
    icon: [
      448,
      512,
      [],
      'e46a',
      
      'M384 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm32 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm272 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM96 400a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm272 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faTrashCanList = {
    prefix: 'fat',
    iconName: 'trash-can-list',
    icon: [
      640,
      512,
      [],
      'e2ab',
      
      'M169.7 16h76.5c8.3 0 16 4.3 20.4 11.3l23 36.7H126.4l23-36.7c4.4-7 12.1-11.3 20.4-11.3zm-33.9 2.8L107.6 64H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H408c4.4 0 8-3.6 8-8s-3.6-8-8-8H308.4L280.2 18.8C272.9 7.1 260.1 0 246.3 0H169.7c-13.8 0-26.6 7.1-33.9 18.8zM48 120c0-4.4-3.6-8-8-8s-8 3.6-8 8V440c0 39.8 32.2 72 72 72H312c39.8 0 72-32.2 72-72V120c0-4.4-3.6-8-8-8s-8 3.6-8 8V440c0 30.9-25.1 56-56 56H104c-30.9 0-56-25.1-56-56V120zm112 32c-4.4 0-8 3.6-8 8V416c0 4.4 3.6 8 8 8s8-3.6 8-8V160c0-4.4-3.6-8-8-8zm96 0c-4.4 0-8 3.6-8 8V416c0 4.4 3.6 8 8 8s8-3.6 8-8V160c0-4.4-3.6-8-8-8zm200-24c-4.4 0-8 3.6-8 8s3.6 8 8 8H632c4.4 0 8-3.6 8-8s-3.6-8-8-8H456zm0 128c-4.4 0-8 3.6-8 8s3.6 8 8 8H600c4.4 0 8-3.6 8-8s-3.6-8-8-8H456zm-8 136c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H456c-4.4 0-8 3.6-8 8z'
      
    ]
  };

  

  
  

  var faCommentMiddle = {
    prefix: 'fat',
    iconName: 'comment-middle',
    icon: [
      512,
      512,
      [],
      'e149',
      
      'M202.6 401.5l44.5 89c1.7 3.4 5.1 5.5 8.8 5.5s7.2-2.1 8.8-5.5l44.5-89c2.2-4.3 6.1-7.4 10.8-8.5C423.8 370 496 294.1 496 208C496 104.9 391.8 16 256 16S16 104.9 16 208c0 86.1 72.2 162 175.8 185c4.7 1 8.7 4.2 10.8 8.5zm121 7.2l-44.5 89c-4.4 8.8-13.3 14.3-23.2 14.3s-18.8-5.5-23.2-14.3l-44.5-89C79.8 384.5 0 303.8 0 208C0 93.1 114.6 0 256 0S512 93.1 512 208c0 95.8-79.8 176.5-188.3 200.7z'
      
    ]
  };

  

  
  

  var faCaretLeft = {
    prefix: 'fat',
    iconName: 'caret-left',
    icon: [
      256,
      512,
      [],
      'f0d9',
      
      'M22.6 271.4c-4.2-4-6.6-9.6-6.6-15.4s2.4-11.4 6.6-15.4L154.7 115.5c2.3-2.2 5.4-3.5 8.7-3.5c7 0 12.6 5.6 12.6 12.6l0 262.8c0 7-5.6 12.6-12.6 12.6c-3.2 0-6.3-1.2-8.7-3.5L22.6 271.4zM11.6 283L143.7 408.2c5.3 5 12.4 7.8 19.7 7.8c15.8 0 28.6-12.8 28.6-28.6l0-262.8c0-15.8-12.8-28.6-28.6-28.6c-7.3 0-14.4 2.8-19.7 7.8L11.6 229C4.2 236 0 245.8 0 256s4.2 20 11.6 27z'
      
    ]
  };

  

  
  

  var faLightbulb = {
    prefix: 'fat',
    iconName: 'lightbulb',
    icon: [
      384,
      512,
      [128161],
      'f0eb',
      
      'M323.5 267.2c18-25.9 28.5-57.3 28.5-91.2c0-88.4-71.6-160-160-160S32 87.6 32 176c0 33.9 10.5 65.3 28.5 91.2c4.5 6.5 9.5 13.3 14.5 20.2l0 0 0 0c12.5 17.2 25.9 35.5 36.3 54.4c7.4 13.5 11.6 27.8 14 42.2H109c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8l0 0 0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4l0 0 0 0c-12.3 16.8-24.6 33.7-34.5 51.8c-5.9 10.8-9.6 22.5-11.8 34.5H258.7c2.4-14.4 6.6-28.7 14-42.2c10.4-19 23.7-37.3 36.3-54.4c5-6.9 10-13.7 14.5-20.2zM184 80c-48.6 0-88 39.4-88 88c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-57.4 46.6-104 104-104c4.4 0 8 3.6 8 8s-3.6 8-8 8zM128 432c0 35.3 28.7 64 64 64s64-28.7 64-64H128zm-16 0v-5.3c0-5.9 4.8-10.7 10.7-10.7H261.3c5.9 0 10.7 4.8 10.7 10.7V432c0 44.2-35.8 80-80 80s-80-35.8-80-80z'
      
    ]
  };

  

  
  

  var faPeopleRobbery = {
    prefix: 'fat',
    iconName: 'people-robbery',
    icon: [
      576,
      512,
      [],
      'e536',
      
      'M464.6 160.1c34.2-18 60.4-49.9 70.2-89.3l8.7-34.9c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6L503.8 63c-11.9 47.6-54.7 81-103.8 81s-91.9-33.4-103.8-81l-8.7-34.9c-2.1-8.6-10.8-13.8-19.4-11.6s-13.8 10.8-11.6 19.4l8.7 34.9c9.9 39.4 36 71.4 70.2 89.4c5.3 2.8 8.6 8.2 8.6 14.2V480c0 8.8 7.2 16 16 16s16-7.2 16-16V352c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16V480c0 8.8 7.2 16 16 16s16-7.2 16-16V174.3c0-5.9 3.3-11.4 8.6-14.2zm85.8-85.5c-11 44-40.2 79.6-78.3 99.6V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V368 352H392v16V480v0c0 17.7-14.3 32-32 32s-32-14.3-32-32V174.3c-38.1-20-67.3-55.7-78.3-99.6L241 39.8C236.7 22.6 247.1 5.2 264.2 1s34.5 6.1 38.8 23.3l8.7 34.9C321.9 99.6 358.3 128 400 128h0l.4 0c41.6-.2 77.8-28.5 87.9-68.9L497 24.2C501.2 7.1 518.6-3.3 535.8 1s27.6 21.7 23.3 38.8l-8.7 34.9zM344 56c0-30.9 25.1-56 56-56s56 25.1 56 56c0 30.8-24.9 55.8-55.7 56l-.3 0 0 0-.3 0c-30.8-.2-55.7-25.2-55.7-56zm96 0a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM196.1 232.6l-37.4-58.9c-11.7-18.5-32.1-29.7-54-29.7H72c-26.5 0-48 21.5-48 48v95.9l0 .5 0 .1h0V480c0 8.8 7.2 16 16 16s16-7.2 16-16V352c0-8.8 7.2-16 16-16H88c8.8 0 16 7.2 16 16V480c0 8.8 7.2 16 16 16s16-7.2 16-16V252.7c0-7.1 4.7-13.4 11.5-15.4s14.2 .8 18 6.8l13 20.5c2.9 4.6 8 7.4 13.5 7.4h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H209.6c-5.5 0-10.6-2.8-13.5-7.4zM8 192c0-35.3 28.7-64 64-64h8 24.7c27.4 0 52.9 14 67.5 37.1L209.6 224H240c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-9.3 0-18-4-24-10.8c-1.1-1.2-2.1-2.6-3-4l-13-20.5v28.7 1.1V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V368 352H72v16l0 112c0 17.7-14.3 32-32 32s-32-14.3-32-32V288.6l0-.6V192zM120 56A40 40 0 1 0 40 56a40 40 0 1 0 80 0zM24 56a56 56 0 1 1 112 0A56 56 0 1 1 24 56z'
      
    ]
  };

  

  
  

  var faSquareTerminal = {
    prefix: 'fat',
    iconName: 'square-terminal',
    icon: [
      448,
      512,
      [],
      'e32a',
      
      'M384 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM97.9 154.8c-2.9 3.4-2.5 8.4 .9 11.3L203.7 256 98.8 345.9c-3.4 2.9-3.7 7.9-.9 11.3s7.9 3.7 11.3 .9l112-96c1.8-1.5 2.8-3.7 2.8-6.1s-1-4.6-2.8-6.1l-112-96c-3.4-2.9-8.4-2.5-11.3 .9zM200 368c-4.4 0-8 3.6-8 8s3.6 8 8 8H376c4.4 0 8-3.6 8-8s-3.6-8-8-8H200z'
      
    ]
  };

  

  
  

  var faCassetteTape = {
    prefix: 'fat',
    iconName: 'cassette-tape',
    icon: [
      576,
      512,
      [128429],
      'f8ab',
      
      'M512 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H470l-23.7-83c-4.9-17.2-20.6-29-38.5-29H168.1c-17.9 0-33.6 11.8-38.5 29L106 464H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H512zM453.4 464H122.6l22.5-78.6c2.9-10.3 12.4-17.4 23.1-17.4H407.9c10.7 0 20.1 7.1 23.1 17.4L453.4 464zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm96 144a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm42.3 96c13.3-11.7 21.7-28.9 21.7-48s-8.4-36.3-21.7-48H373.7c-13.3 11.7-21.7 28.9-21.7 48s8.4 36.3 21.7 48H202.3zM160 288H416c35.3 0 64-28.7 64-64s-28.7-64-64-64H160c-35.3 0-64 28.7-64 64s28.7 64 64 64zM416 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  

  
  

  var faShieldCross = {
    prefix: 'fat',
    iconName: 'shield-cross',
    icon: [
      512,
      512,
      [9960],
      'f712',
      
      'M237.3 22.6c12-5.1 25.5-5.1 37.5 0l176.7 75c16.6 7.1 28.6 23.2 28.5 42.4c-.5 96.6-40.3 270.2-204.5 348.8c-12.3 5.9-26.7 5.9-39 0C72.3 410.1 32.5 236.5 32 139.9c-.1-19.1 11.9-35.3 28.5-42.4l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM264 104c0-4.4-3.6-8-8-8s-8 3.6-8 8v80H104c-4.4 0-8 3.6-8 8s3.6 8 8 8H248V408c0 4.4 3.6 8 8 8s8-3.6 8-8V200H408c4.4 0 8-3.6 8-8s-3.6-8-8-8H264V104z'
      
    ]
  };

  

  
  

  var fa8 = {
    prefix: 'fat',
    iconName: '8',
    icon: [
      320,
      512,
      [],
      '38',
      
      'M296 148c0-64.1-51.9-116-116-116H140C75.9 32 24 83.9 24 148c0 45.2 25.9 84.4 63.6 103.5C37.3 264.2 0 309.7 0 364c0 64.1 51.9 116 116 116h88c64.1 0 116-51.9 116-116c0-54.3-37.3-99.8-87.6-112.5C270.1 232.4 296 193.2 296 148zM180.1 264H204c55.2 0 100 44.8 100 100s-44.8 100-100 100H116C60.8 464 16 419.2 16 364s44.8-100 100-100h23.9c0 0 0 0 .1 0h40c0 0 0 0 .1 0zm0-16c0 0 0 0-.1 0H140c0 0 0 0-.1 0C84.7 248 40 203.2 40 148C40 92.8 84.8 48 140 48l40 0c55.2 0 100 44.8 100 100c0 55.2-44.7 100-99.9 100z'
      
    ]
  };

  

  
  

  var faRulerHorizontal = {
    prefix: 'fat',
    iconName: 'ruler-horizontal',
    icon: [
      640,
      512,
      [],
      'f547',
      
      'M16 320c0 26.5 21.5 48 48 48l512 0c26.5 0 48-21.5 48-48V192c0-26.5-21.5-48-48-48H520v80c0 4.4-3.6 8-8 8s-8-3.6-8-8V144l-80 0v48 32c0 4.4-3.6 8-8 8s-8-3.6-8-8V192 144H328v80c0 4.4-3.6 8-8 8s-8-3.6-8-8V144H232v80c0 4.4-3.6 8-8 8s-8-3.6-8-8V144l-80 0v80c0 4.4-3.6 8-8 8s-8-3.6-8-8V144l-56 0c-26.5 0-48 21.5-48 48l0 128zM512 128h64c35.3 0 64 28.7 64 64V320c0 35.3-28.7 64-64 64L64 384c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64H224h96 96 96z'
      
    ]
  };

  

  
  

  var faCoconut = {
    prefix: 'fat',
    iconName: 'coconut',
    icon: [
      512,
      512,
      [],
      'e2f6',
      
      'M270.6 24.6C318.6 9.8 358.2 14.2 381 37s27.2 62.3 12.4 110.4c-14.7 47.7-47.8 101.5-96.1 149.8s-102.2 81.4-149.8 96.1C99.3 408.2 59.8 403.8 37 381S9.8 318.6 24.6 270.6c14.7-47.7 47.8-101.5 96.1-149.8s102.2-81.4 149.8-96.1zm121.7 1C363.2-3.4 316.1-6.2 265.9 9.3C215.2 24.9 159.2 59.7 109.4 109.4S24.9 215.2 9.3 265.9C-6.2 316.1-3.4 363.2 25.7 392.3l43.8 43.8C118.1 484.7 184 512 252.8 512C395.9 512 512 395.9 512 252.8c0-68.8-27.3-134.7-75.9-183.3L392.3 25.7zm23.5 46.1l9 9c45.6 45.6 71.2 107.5 71.2 172c0 12.6-1 25-2.8 37.1l-47.5-47.5c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l55.2 55.2c-9.9 42-30.7 79.8-59.2 110.2c-.2-.2-.4-.5-.6-.7l-64-64c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l64 64c.2 .2 .5 .4 .7 .6c-30.4 28.5-68.2 49.3-110.2 59.2l-55.2-55.2c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l47.5 47.5c-12.1 1.9-24.5 2.8-37.1 2.8c-64.5 0-126.4-25.6-172-71.2l-9-9c23.9 4.6 51.6 1.7 80.3-7.2c50.6-15.6 106.6-50.3 156.4-100.1s84.5-105.8 100.1-156.4c8.9-28.7 11.7-56.4 7.2-80.3zm-86.3 8.8c3.9 3.9 6.7 10.4 6.7 21.3c-.1 10.9-3.2 24.9-9.9 41.1c-13.3 32.4-39.6 71-75.9 107.3S175.4 312.9 143 326.3c-16.2 6.7-30.2 9.8-41.1 9.9c-10.8 .1-17.4-2.8-21.3-6.7s-6.7-10.4-6.7-21.3c.1-10.9 3.2-24.9 9.9-41.1c13.3-32.4 39.6-71 76-107.3s74.9-62.6 107.3-76c16.2-6.7 30.2-9.8 41.1-9.9c10.8-.1 17.4 2.8 21.3 6.7zm11.3-11.3c-31.2-31.2-117.4 4.2-192.3 79.2s-110.4 161.1-79.2 192.3s117.4-4.2 192.3-79.2s110.4-161.1 79.2-192.3z'
      
    ]
  };

  

  
  

  var faFilm = {
    prefix: 'fat',
    iconName: 'film',
    icon: [
      512,
      512,
      [127902],
      'f008',
      
      'M112 48v56H16V96c0-26.5 21.5-48 48-48h48zm0 152H16V120h96v80zM0 208v8 80 8 8 80 8 8 8c0 35.3 28.7 64 64 64h48 8 8H384h8 8 48c35.3 0 64-28.7 64-64v-8-8-8V312v-8-8V216v-8-8V120v-8-8V96c0-35.3-28.7-64-64-64H400h-8-8H128h-8-8H64C28.7 32 0 60.7 0 96v8 8 8 80 8zm16 8h96v40 40H16V216zm112 48H384v40 96 64H128V400 304 264zm256-16H128V208 112 48H384v64 96 40zm16 8V216h96v80H400V256zM16 392V312h96v80H16zm0 24v-8h96v56H64c-26.5 0-48-21.5-48-48zM400 104V48h48c26.5 0 48 21.5 48 48v8H400zm0 96V120h96v80H400zm0 192V312h96v80H400zm0 72V408h96v8c0 26.5-21.5 48-48 48H400z'
      
    ]
  };

  

  
  

  var faSickle = {
    prefix: 'fat',
    iconName: 'sickle',
    icon: [
      512,
      512,
      [],
      'f822',
      
      'M320 0C214 0 128 86 128 192c0 68 35.3 127.7 88.6 161.8c3.2 2 7.3 1.6 10-1.1l37.9-37.9c2.6-2.6 3.1-6.6 1.2-9.7C254.5 286 248 263.8 248 240c0-70.7 57.3-128 128-128c55.5 0 102.7 35.3 120.5 84.6c1.3 3.6 5 5.8 8.9 5.2s6.6-3.9 6.7-7.8c0-.7 0-1.3 0-2C512 86 426 0 320 0zM144 192c0-97.2 78.8-176 176-176c84.4 0 154.9 59.4 172 138.7C465.8 119.1 423.6 96 376 96c-79.5 0-144 64.5-144 144c0 24.5 6.1 47.6 16.9 67.8l-29 29C174 305 144 252 144 192zM117.7 298.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L116.7 320 10.8 425.9C3.9 432.8 0 442.2 0 452s3.9 19.2 10.8 26.1l23 23C40.8 508.1 50.2 512 60 512s19.2-3.9 26.1-10.8L192 395.3l10.3 10.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-16-16-64-64-16-16zM22.1 437.2L128 331.3 180.7 384 74.8 489.9c-3.9 3.9-9.3 6.1-14.8 6.1s-10.9-2.2-14.8-6.1l-23-23c-3.9-3.9-6.1-9.3-6.1-14.8s2.2-10.9 6.1-14.8z'
      
    ]
  };

  

  
  

  var faRadar = {
    prefix: 'fat',
    iconName: 'radar',
    icon: [
      512,
      512,
      [],
      'e024',
      
      'M256 16C123.5 16 16 123.5 16 256s107.5 240 240 240s240-107.5 240-240c0-4.4 3.6-8 8-8s8 3.6 8 8c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0c67.8 0 129.5 26.4 175.3 69.4l43.1-43.1c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-224 224c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l33.5-33.5c-7.8-5.6-17.4-8.9-27.8-8.9c-26.5 0-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48c0-4.4 3.6-8 8-8s8 3.6 8 8c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c14.8 0 28.4 5 39.2 13.4L352 148.7c-25.5-22.8-59.1-36.7-96-36.7c-57.9 0-107.8 34.1-130.7 83.4c-1.9 4-6.6 5.7-10.6 3.9s-5.7-6.6-3.9-10.6C136.3 133.9 191.7 96 256 96c41.3 0 79 15.7 107.3 41.3L420 80.7C377 40.6 319.4 16 256 16zM96 216a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm96 160a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm40 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM416 256c0 64.3-37.9 119.7-92.6 145.2c-4 1.9-8.8 .1-10.6-3.9s-.1-8.8 3.9-10.6C365.9 363.8 400 313.9 400 256c0-4.4 3.6-8 8-8s8 3.6 8 8zM125.3 316.6c14.3 30.8 39.2 55.7 70 70c4 1.9 5.7 6.6 3.9 10.6s-6.6 5.7-10.6 3.9c-34.2-15.9-61.9-43.6-77.8-77.8c-1.9-4-.1-8.8 3.9-10.6s8.8-.1 10.6 3.9z'
      
    ]
  };

  

  
  

  var faPhotoFilmMusic = {
    prefix: 'fat',
    iconName: 'photo-film-music',
    icon: [
      640,
      512,
      [],
      'e228',
      
      'M544 16H224c-26.5 0-48 21.5-48 48V288c0 18.6 10.6 34.7 26 42.7l.1-.2 .2-.2L431 101.7c9.4-9.4 24.6-9.4 33.9 0l59.8 59.8-17 5.7L453.7 113c-3.1-3.1-8.2-3.1-11.3 0L219.5 335.8c1.5 .1 3 .2 4.5 .2H400v16H224c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64H544c35.3 0 64 28.7 64 64v70.7c-3.2 .5-6.5 1.2-9.7 2.3l-6.3 2.1V64c0-26.5-21.5-48-48-48zM264 96a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 40a40 40 0 1 1 0-80 40 40 0 1 1 0 80zM128 96v16 80 80 72 40 48H295.8c-2.6 5-4.6 10.3-6 16H128h-8-8H64c-35.3 0-64-28.7-64-64V352v-8-8V280v-8-8V200v-8-8V160c0-35.3 28.7-64 64-64h48 8 8zM112 280H16v56h96V280zm0 152V352H16v32c0 26.5 21.5 48 48 48h48zM64 112c-26.5 0-48 21.5-48 48v24h96V112H64zM16 264h96V200H16v64zm608-73.8c0-5.5-5.4-9.3-10.5-7.6l-160 53.3c-3.3 1.1-5.5 4.1-5.5 7.6v49.4l176-58.7v-44zm0 60.9L448 309.8V464c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c19.1 0 36.3 6.3 48 16.2V304 243.5c0-10.3 6.6-19.5 16.4-22.8l160-53.3c15.5-5.2 31.6 6.4 31.6 22.8V240 392c0 .9-.1 1.7-.4 2.5c.3 1.8 .4 3.6 .4 5.5c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c19.1 0 36.3 6.3 48 16.2V251.1zM624 400c0-7.1-3.8-14.7-12.3-21.1s-21.1-10.9-35.7-10.9s-27.1 4.4-35.7 10.9s-12.3 14.1-12.3 21.1s3.8 14.7 12.3 21.1s21.1 10.9 35.7 10.9s27.1-4.4 35.7-10.9s12.3-14.1 12.3-21.1zM432 464c0-7.1-3.8-14.7-12.3-21.1s-21.1-10.9-35.7-10.9s-27.1 4.4-35.7 10.9s-12.3 14.1-12.3 21.1s3.8 14.7 12.3 21.1s21.1 10.9 35.7 10.9s27.1-4.4 35.7-10.9s12.3-14.1 12.3-21.1z'
      
    ]
  };

  

  
  

  var faRollerCoaster = {
    prefix: 'fat',
    iconName: 'roller-coaster',
    icon: [
      640,
      512,
      [],
      'e324',
      
      'M136 48c-8.2 0-16.2 .8-24 2.4V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V54.8C49.4 71.3 16 115.8 16 168V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V168C0 92.9 60.9 32 136 32h6.5c43.1 0 83.7 20.4 109.3 55.1l140.6 190c27.4 37 70.8 58.9 116.9 58.9H512c61.9 0 112-50.1 112-112c0-50.7-33.7-93.6-80-107.4V280c0 4.4-3.6 8-8 8s-8-3.6-8-8V113.1c-5.2-.7-10.6-1.1-16-1.1H494.2c-15.8 0-31.5 2.9-46.2 8.5V248c0 4.4-3.6 8-8 8s-8-3.6-8-8V127.9c-1.6 .8-3.1 1.7-4.6 2.6l-47.3 28.4c-3.8 2.3-8.7 1-11-2.7s-1-8.7 2.7-11l47.3-28.4c22.7-13.6 48.6-20.8 75-20.8H512c70.7 0 128 57.3 128 128V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V286c-19.4 34.9-54.6 59.8-96 65V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V352h-2.7c-33.8 0-66.4-10.6-93.3-29.7V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V309.4c-7.4-6.9-14.3-14.4-20.4-22.7L304 184.5V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V162.9L238.9 96.6C230.3 85 219.8 75.2 208 67.5V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V58.7c-15.4-7-32.2-10.7-49.5-10.7H136z'
      
    ]
  };

  

  
  

  var faCorn = {
    prefix: 'fat',
    iconName: 'corn',
    icon: [
      512,
      512,
      [127805],
      'f6c7',
      
      'M453.9 0c-15.1 0-29 5.8-39.3 15.3C406.4 10.9 397 8.4 387 8.4c-20.2 0-38 10.3-48.4 25.9c-3.3-.6-6.6-.9-10.1-.9c-20.2 0-38 10.3-48.4 25.9c-3.3-.6-6.6-.9-10.1-.9c-20.8 0-39 10.9-49.3 27.3c3.6 4.9 7 9.8 10.3 14.9c6.3-15.3 21.4-26.1 39-26.1c4.1 0 8 .6 11.8 1.7c3.7 1.1 7.6-.6 9.3-4c7-13.5 21.2-22.7 37.4-22.7c4.1 0 8 .6 11.8 1.7c3.7 1.1 7.6-.6 9.3-4c7-13.5 21.2-22.7 37.4-22.7c9 0 17.4 2.8 24.2 7.6c3.4 2.4 8 1.8 10.7-1.3c7.7-9 19.2-14.7 32-14.7C477.1 16 496 34.9 496 58.1c0 12.8-5.7 24.2-14.7 32c-3.1 2.7-3.7 7.3-1.3 10.7c4.8 6.8 7.6 15.2 7.6 24.2c0 16.3-9.2 30.4-22.7 37.4c-3.4 1.8-5.1 5.7-4 9.3c1.1 3.7 1.7 7.7 1.7 11.8c0 16.3-9.2 30.4-22.7 37.4c-3.4 1.8-5.1 5.7-4 9.3c1.1 3.7 1.7 7.7 1.7 11.8c0 13.4-6.2 25.3-16 33c4.1 3.4 8.2 7 12.1 10.8c12.2-10.7 19.9-26.3 19.9-43.8c0-3.4-.3-6.8-.9-10.1c15.6-10.4 25.9-28.2 25.9-48.4c0-3.4-.3-6.8-.9-10.1c15.6-10.4 25.9-28.2 25.9-48.4c0-10-2.5-19.3-6.9-27.6C506.2 87.1 512 73.3 512 58.1C512 26 486 0 453.9 0zm-299 66.3c-2-2-4.8-2.8-7.5-2.1s-4.9 2.6-5.8 5.3l-22.9 68.7c-1 3-2.6 5.8-4.7 8.2L33.6 238.2C12 263 0 294.8 0 327.8V346c0 34.2 12.9 67.1 36.1 92.2l27.7 30c25.7 27.9 62 43.8 99.9 43.8h15.6c36.1 0 70.7-14.3 96.2-39.8l73.8-73.8c2.5-2.5 5.5-4.4 8.8-5.6L442.7 362c2.6-.9 4.5-3.1 5.1-5.8s-.2-5.5-2.2-7.4l-30.2-30.2c-35.4-35.4-83.3-55.2-133.3-55.2c-14.2 0-28.2 1.6-41.8 4.7v-7c0-70-27.8-137.2-77.3-186.7l-8.1-8.1zm69.4 205h3.5c-29.6 8.9-56.7 25-79 47.2L44.2 423.2C26 401.7 16 374.3 16 346V327.8c0-29.1 10.6-57.1 29.7-79l80.4-91.9c3.5-4 6.2-8.7 7.8-13.7l18.8-56.4c45.8 46.4 71.6 109 71.6 174.3v10.3zM75.6 457.4L49.8 429.5l5.4 5.4 105-105c32.4-32.4 76.2-50.5 122-50.5s89.6 18.2 122 50.5l21.3 21.3-72.9 26.5c-5.5 2-10.5 5.2-14.6 9.3l-73.8 73.8c-22.5 22.5-53 35.1-84.9 35.1H163.7c-33.5 0-65.5-14-88.2-38.6z'
      
    ]
  };

  

  
  

  var faFaceKissBeam = {
    prefix: 'fat',
    iconName: 'face-kiss-beam',
    icon: [
      512,
      512,
      [128537,"kiss-beam"],
      'f597',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm241.4 16.1c11.4 2.1 22.8 5.4 33.6 9.8c8.4 3.4 17.2 7.9 24.2 13.7c6.9 5.9 12.8 14 12.8 24.4c0 10.2-6.4 17.5-13.4 22.4c-5.9 4.1-13.2 7.3-20.3 9.6c7.1 2.4 14.4 5.5 20.3 9.6c7 4.9 13.4 12.2 13.4 22.4c0 11-5.6 19.5-12.7 25.8c-7 6.2-16 10.6-24.5 13.7c-10.8 4.1-22.3 6.9-33.7 8.4l-.1 0c-4.4 .5-8.4-2.6-9-6.9s2.6-8.4 6.9-8.9c10.3-1.4 20.5-3.9 30.2-7.6c7.6-2.8 14.6-6.4 19.5-10.8c4.9-4.3 7.3-8.7 7.3-13.7c0-2.6-1.6-5.7-6.6-9.2c-5-3.5-12-6.4-19.7-8.7c-7.6-2.3-15.2-3.8-21-4.8c-2.2-.4-4-.5-5.5-.7c-2.3-.2-4.1-.4-5.9-1.1c-3.1-1.1-5.3-4.2-5.3-7.5s2.2-6.4 5.3-7.5c1.8-.6 3.6-.8 5.9-1.1l0 0 0 0c1.6-.2 3.3-.3 5.5-.7c5.8-1 13.4-2.5 21-4.8c7.7-2.3 14.7-5.2 19.7-8.7c5-3.5 6.6-6.6 6.6-9.2c0-3.8-2.1-7.9-7.2-12.2c-5.1-4.3-12.2-8-19.8-11.1c-7.6-3-15.2-5.3-21-6.7c-4.3-1.1-6.9-1.7-9.4-2.1c-4.3-.8-7.3-4.9-6.5-9.3s4.9-7.2 9.3-6.5zm-90.5-86.4c-7.4 11.4-12.7 26.3-15.2 39.8c-.8 4.3-5 7.2-9.3 6.4s-7.2-5-6.4-9.3c2.8-15 8.7-32 17.6-45.6c8.7-13.3 21.5-25 38.3-25s29.6 11.7 38.3 25c8.8 13.5 14.8 30.6 17.6 45.6c.8 4.3-2 8.5-6.4 9.3s-8.5-2-9.3-6.4c-2.5-13.5-7.8-28.4-15.2-39.8c-7.6-11.6-16.1-17.7-24.9-17.7s-17.3 6.1-24.9 17.7zm144.8 39.8c-.8 4.3-5 7.2-9.3 6.4s-7.2-5-6.4-9.3c2.8-15 8.7-32 17.6-45.6c8.7-13.3 21.5-25 38.3-25s29.6 11.7 38.3 25c8.8 13.5 14.8 30.6 17.6 45.6c.8 4.3-2 8.5-6.4 9.3s-8.5-2-9.3-6.4c-2.5-13.5-7.8-28.4-15.2-39.8c-7.6-11.6-16.1-17.7-24.9-17.7s-17.3 6.1-24.9 17.7c-7.4 11.4-12.7 26.3-15.2 39.8z'
      
    ]
  };

  
    var faKissBeam = faFaceKissBeam;
  

  
  

  var faSquareUpRight = {
    prefix: 'fat',
    iconName: 'square-up-right',
    icon: [
      448,
      512,
      [8599,"external-link-square-alt"],
      'f360',
      
      'M384 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H384zm64 48c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM320 168V295c0 5-4 9-9 9c-2.4 0-4.7-.9-6.3-2.6l-35-35c-3.1-3.1-8.2-3.1-11.3 0L176 348.7c-2.1 2.1-5 3.3-8 3.3s-5.9-1.2-8-3.3L131.3 320c-2.1-2.1-3.3-5-3.3-8s1.2-5.9 3.3-8l82.3-82.3c3.1-3.1 3.1-8.2 0-11.3l-35-35c-1.7-1.7-2.6-4-2.6-6.3c0-5 4-9 9-9H312c4.4 0 8 3.6 8 8zm-8-24H185c-13.8 0-25 11.2-25 25c0 6.6 2.6 13 7.3 17.7L196.7 216 120 292.7c-5.1 5.1-8 12.1-8 19.3s2.9 14.2 8 19.3L148.7 360c5.1 5.1 12.1 8 19.3 8s14.2-2.9 19.3-8L264 283.3l29.4 29.4c4.7 4.7 11 7.3 17.7 7.3c13.8 0 25-11.2 25-25V168c0-13.3-10.7-24-24-24z'
      
    ]
  };

  
    var faExternalLinkSquareAlt = faSquareUpRight;
  

  
  

  var faDropletPercent = {
    prefix: 'fat',
    iconName: 'droplet-percent',
    icon: [
      384,
      512,
      ["humidity"],
      'f750',
      
      'M192 496C94.8 496 16 417.2 16 320c0-19.5 7.1-44.9 19.6-73.8c12.4-28.6 29.3-59.2 47.7-88.8c36.6-59.2 77.9-112.9 95.9-135.7c2.8-3.5 7-5.6 11.9-5.6h1.8c4.9 0 9.1 2.1 11.9 5.6c18.1 22.8 59.3 76.6 95.9 135.7c18.3 29.6 35.3 60.2 47.7 88.8C360.9 275.1 368 300.5 368 320c0 97.2-78.8 176-176 176zM0 320C0 426 86 512 192 512s192-86 192-192c0-91.2-130.2-262.3-166.6-308.3C211.4 4.2 202.5 0 192.9 0h-1.8c-9.6 0-18.5 4.2-24.5 11.7C130.2 57.7 0 228.8 0 320zm269.7-66.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-144 144c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l144-144zM176 272a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-32-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm96 144a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  
    var faHumidity = faDropletPercent;
  

  
  

  var faFaceBeamHandOverMouth = {
    prefix: 'fat',
    iconName: 'face-beam-hand-over-mouth',
    icon: [
      512,
      512,
      [129325],
      'e47c',
      
      'M16 256C16 123.5 123.5 16 256 16s240 107.5 240 240c0 99.6-60.7 185-147.1 221.4c-4.1 1.7-6 6.4-4.3 10.5s6.4 6 10.5 4.3C447.3 453.4 512 362.3 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 86 42.4 162 107.3 208.4c3.6 2.6 8.6 1.7 11.2-1.9s1.7-8.6-1.9-11.2C55.7 407.9 16 336.6 16 256zm119.7-46.5c2.5-13.5 7.8-28.4 15.2-39.8c7.6-11.6 16.1-17.7 24.9-17.7s17.3 6.1 24.9 17.7c7.4 11.4 12.7 26.3 15.2 39.8c.8 4.3 5 7.2 9.3 6.4s7.2-5 6.4-9.3c-2.8-15-8.7-32-17.6-45.6c-8.7-13.3-21.5-25-38.3-25s-29.6 11.7-38.3 25c-8.8 13.5-14.8 30.6-17.6 45.6c-.8 4.3 2 8.5 6.4 9.3s8.5-2 9.3-6.4zm175.2-39.8c7.6-11.6 16.1-17.7 24.9-17.7s17.3 6.1 24.9 17.7c7.4 11.4 12.7 26.3 15.2 39.8c.8 4.3 5 7.2 9.3 6.4s7.2-5 6.4-9.3c-2.8-15-8.7-32-17.6-45.6c-8.7-13.3-21.5-25-38.3-25s-29.6 11.7-38.3 25c-8.8 13.5-14.8 30.6-17.6 45.6c-.8 4.3 2 8.5 6.4 9.3s8.5-2 9.3-6.4c2.5-13.5 7.8-28.4 15.2-39.8zm-2.2 123l9.2-9.2 6.8-6.8c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-6.8 6.8-9.2 9.2-46.6 46.6-4.7 4.7c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l4.7-4.7 46.6-46.6c2.3-2.3 5.2-3.8 8.3-4.4c5-1 10.4 .5 14.3 4.4c6.2 6.2 6.2 16.4 0 22.6l-22.8 22.8-9.2 9.2-14.6 14.6-4.7 4.7c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l4.7-4.7 14.6-14.6c2.3-2.3 5.2-3.8 8.3-4.4c5-1 10.4 .5 14.3 4.4c6.2 6.2 6.2 16.4 0 22.6l-56.8 56.8C288.7 486 264.4 496 239.2 496c-52.6 0-95.2-42.6-95.2-95.2V368 314.4c0-11 9-20 20-20s20 9 20 20v19.7c0 7.1 8.6 10.7 13.7 5.7l79-79c6.2-6.2 16.4-6.2 22.6 0c3.9 3.9 5.4 9.3 4.4 14.3c-.6 3-2 5.9-4.4 8.3l-46.6 46.6-4.7 4.7c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l4.7-4.7 46.6-46.6zm1.9-43.3c-12.5-12.5-32.8-12.5-45.3 0L200 314.7v-.3c0-19.9-16.1-36-36-36s-36 16.1-36 36V368v32.8C128 462.2 177.8 512 239.2 512c29.5 0 57.8-11.7 78.6-32.6l56.8-56.8c12.5-12.5 12.5-32.8 0-45.3c-3.3-3.3-7.2-5.8-11.4-7.3l11.4-11.4c12.5-12.5 12.5-32.8 0-45.3c-3.5-3.5-7.6-6-12-7.6c8.3-12.4 7-29.4-4-40.4s-28-12.3-40.4-4c-1.5-4.4-4.1-8.5-7.6-12z'
      
    ]
  };

  

  
  

  var faHeartCrack = {
    prefix: 'fat',
    iconName: 'heart-crack',
    icon: [
      512,
      512,
      [128148,"heart-broken"],
      'f7a9',
      
      'M282.4 105.2c25.4-34.9 68.3-53.2 111.2-47.6C451.9 65.3 496 115 496 173.6c0 30.3-11.7 59.3-32.8 81.1L264.7 460.4c-2.2 2.3-5.2 3.6-8.4 3.6s-6.2-1.3-8.4-3.6L48.9 254.7C27.8 232.9 16 203.8 16 173.5C16 114.9 60.1 65.3 118.3 57.7c42.9-5.6 85.8 12.6 111.2 47.6L248 130.6V144c0 2.1 .8 4.2 2.3 5.7l41.1 41.1-87.9 58.6c-1.9 1.2-3.1 3.2-3.5 5.4s.3 4.5 1.7 6.2l64 80c2.8 3.4 7.8 4 11.2 1.2s4-7.8 1.2-11.2l-58.5-73.2 88.7-59.2c2-1.3 3.3-3.5 3.5-5.9s-.6-4.8-2.3-6.4L264 140.7V130.6l18.4-25.4zM395.7 41.8c-48.6-6.3-97.3 14.3-126.2 54L256 114.4 242.5 95.8c-28.9-39.7-77.6-60.4-126.2-54C50.2 50.4 0 106.8 0 173.5c0 34.5 13.4 67.6 37.4 92.3L236.5 471.6c5.2 5.4 12.4 8.4 19.9 8.4c7.5 0 14.7-3 19.9-8.5L474.8 265.8C498.6 241.1 512 208 512 173.6c0-66.8-50.2-123.2-116.3-131.8z'
      
    ]
  };

  
    var faHeartBroken = faHeartCrack;
  

  
  

  var faHourglassEnd = {
    prefix: 'fat',
    iconName: 'hourglass-end',
    icon: [
      384,
      512,
      [8987,"hourglass-3"],
      'f253',
      
      'M0 8C0 3.6 3.6 0 8 0H376c4.4 0 8 3.6 8 8s-3.6 8-8 8H352V71.2c0 48.3-23 93.7-61.8 122.4L205.5 256l84.7 62.4C329 347 352 392.5 352 440.8V496h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H32V440.8c0-48.3 23-93.7 61.8-122.4L178.5 256 93.8 193.6C55 165 32 119.5 32 71.2V16H8c-4.4 0-8-3.6-8-8zm48 8V71.2c0 43.2 20.5 83.9 55.3 109.5L192 246.1l88.7-65.3C315.5 155.1 336 114.4 336 71.2V16H48zm55.3 315.3C95 337.4 87.5 344.4 81 352h.2 .6 .6H83h.6 .6 .6 .6H86h.6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6H93h.6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .2c-6.6-7.6-14.1-14.6-22.4-20.7L192 265.9l-88.7 65.3zM69.1 368C55.5 389.5 48 414.7 48 440.8V496H336V440.8c0-26.1-7.5-51.3-21.1-72.8h-.1-.6-.6-.6-.6-.6H311h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H301h-.6-.6-.6-.6H298h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H291h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H283h-.6-.6-.6-.6-.6-.6-.6-.5H278h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H271h-.5H270h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H246h-.5H245h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H238h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H233h-.5-.5-.5-.5-.5-.4-.4-.4-.4-.4H228h-.4-.4-.4-.4-.4-.4-.4-.4H224h-.4-.4-.4-.4-.4-.4H221h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H214h-.4-.4-.4-.4-.4-.4H211h-.4-.4-.4-.4-.4-.4H208h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H203h-.4-.4-.4-.4-.4-.4H200h-.4-.4-.4-.4-.4-.4H197h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H192h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H187h-.4-.4-.4-.4-.4-.4H184h-.4-.4-.4-.4-.4-.4H181h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H176h-.4-.4-.4-.4-.4-.4H173h-.4-.4-.4-.4-.4-.4H170h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H163h-.4-.4-.4-.4-.4-.4H160h-.4-.4-.4-.4-.4-.4-.4-.4H156h-.4-.4-.4-.4-.4-.4-.5-.5-.5-.5H151h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H146h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H139h-.5H138h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H114h-.5H113h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H106h-.5-.5-.6-.6-.6-.6-.6-.6H101h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H93h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H86h-.6-.6-.6-.6H83h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H73h-.6-.6-.6-.6-.6-.6-.1z'
      
    ]
  };

  
    var faHourglass3 = faHourglassEnd;
  

  
  

  var faPeopleGroup = {
    prefix: 'fat',
    iconName: 'people-group',
    icon: [
      640,
      512,
      [],
      'e533',
      
      'M88 88a40 40 0 1 1 80 0A40 40 0 1 1 88 88zm96 0A56 56 0 1 0 72 88a56 56 0 1 0 112 0zm288 0a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm96 0A56 56 0 1 0 456 88a56 56 0 1 0 112 0zM64 256c-4.4 0-8 3.6-8 8v98.2c-24.2-16.9-40-45-40-76.7c0-51.7 41.9-93.5 93.5-93.5h36.9c18.8 0 36.3 5.6 51 15.1c3.7-4 7.6-7.8 11.7-11.4c-17.8-12.4-39.4-19.7-62.7-19.7H109.5C49 176 0 225 0 285.5c0 41.1 22.6 76.8 56 95.6V432c0 17.7 14.3 32 32 32h80c17.7 0 32-14.3 32-32V403.6c-5.9-6.2-11.3-12.8-16-20V432c0 8.8-7.2 16-16 16H88c-8.8 0-16-7.2-16-16V264c0-4.4-3.6-8-8-8zM440 432c0 17.7 14.3 32 32 32h80c17.7 0 32-14.3 32-32V381.1c33.4-18.7 56-54.5 56-95.6C640 225 591 176 530.5 176H493.5c-23.3 0-44.9 7.3-62.7 19.7c4.1 3.6 8 7.4 11.7 11.4c14.7-9.6 32.2-15.1 51-15.1h36.9c51.7 0 93.5 41.9 93.5 93.5c0 31.7-15.8 59.8-40 76.7V264c0-4.4-3.6-8-8-8s-8 3.6-8 8V432c0 8.8-7.2 16-16 16H472c-8.8 0-16-7.2-16-16V383.6c-4.7 7.1-10.1 13.8-16 20V432zM272 96a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0A64 64 0 1 0 256 96a64 64 0 1 0 128 0zM256 272c-4.4 0-8 3.6-8 8v98.2c-24.2-16.9-40-45-40-76.7c0-51.7 41.9-93.5 93.5-93.5h36.9c51.7 0 93.5 41.9 93.5 93.5c0 31.7-15.8 59.8-40 76.7V280c0-4.4-3.6-8-8-8s-8 3.6-8 8V448c0 8.8-7.2 16-16 16H280c-8.8 0-16-7.2-16-16V280c0-4.4-3.6-8-8-8zm-8 125.1V448c0 17.7 14.3 32 32 32h80c17.7 0 32-14.3 32-32V397.1c33.4-18.7 56-54.5 56-95.6C448 241 399 192 338.5 192H301.5C241 192 192 241 192 301.5c0 41.1 22.6 76.8 56 95.6z'
      
    ]
  };

  

  
  

  var faKeyboardLeft = {
    prefix: 'fat',
    iconName: 'keyboard-left',
    icon: [
      640,
      512,
      [],
      'e1c3',
      
      'M576 80c26.5 0 48 21.5 48 48V384c0 26.5-21.5 48-48 48H224c-26.5 0-48-21.5-48-48V128c0-26.5 21.5-48 48-48H576zM224 64c-35.3 0-64 28.7-64 64V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H224zm40 272c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H248c-4.4 0-8-3.6-8-8V344c0-4.4 3.6-8 8-8h16zm-16-16c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V344c0-13.3-10.7-24-24-24H248zm96 16H456c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H344c-4.4 0-8-3.6-8-8V344c0-4.4 3.6-8 8-8zm-24 8v16c0 13.3 10.7 24 24 24H456c13.3 0 24-10.7 24-24V344c0-13.3-10.7-24-24-24H344c-13.3 0-24 10.7-24 24zM264 240c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H248c-4.4 0-8-3.6-8-8V248c0-4.4 3.6-8 8-8h16zm-16-16c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H248zm96 16h16c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H344c-4.4 0-8-3.6-8-8V248c0-4.4 3.6-8 8-8zm-24 8v16c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H344c-13.3 0-24 10.7-24 24zm136-8c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H440c-4.4 0-8-3.6-8-8V248c0-4.4 3.6-8 8-8h16zm-16-16c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H440zm96 16h16c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H536c-4.4 0-8-3.6-8-8V248c0-4.4 3.6-8 8-8zm-24 8v16c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H536c-13.3 0-24 10.7-24 24zm40 88c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H536c-4.4 0-8-3.6-8-8V344c0-4.4 3.6-8 8-8h16zm-16-16c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V344c0-13.3-10.7-24-24-24H536zM248 144h16c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H248c-4.4 0-8-3.6-8-8V152c0-4.4 3.6-8 8-8zm-24 8v16c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V152c0-13.3-10.7-24-24-24H248c-13.3 0-24 10.7-24 24zm136-8c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H344c-4.4 0-8-3.6-8-8V152c0-4.4 3.6-8 8-8h16zm-16-16c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V152c0-13.3-10.7-24-24-24H344zm96 16h16c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H440c-4.4 0-8-3.6-8-8V152c0-4.4 3.6-8 8-8zm-24 8v16c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V152c0-13.3-10.7-24-24-24H440c-13.3 0-24 10.7-24 24zm136-8c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H536c-4.4 0-8-3.6-8-8V152c0-4.4 3.6-8 8-8h16zm-16-16c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V152c0-13.3-10.7-24-24-24H536zM101.7 173.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-88 88c-3.1 3.1-3.1 8.2 0 11.3l88 88c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L19.3 256l82.3-82.3z'
      
    ]
  };

  

  
  

  var faBars = {
    prefix: 'fat',
    iconName: 'bars',
    icon: [
      448,
      512,
      ["navicon"],
      'f0c9',
      
      'M0 88c0-4.4 3.6-8 8-8H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8zM0 248c0-4.4 3.6-8 8-8H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8zM448 408c0 4.4-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H440c4.4 0 8 3.6 8 8z'
      
    ]
  };

  
    var faNavicon = faBars;
  

  
  

  var faPrescriptionBottle = {
    prefix: 'fat',
    iconName: 'prescription-bottle',
    icon: [
      384,
      512,
      [],
      'f485',
      
      'M344 16c13.3 0 24 10.7 24 24V88c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24V40c0-13.3 10.7-24 24-24H344zM40 0C17.9 0 0 17.9 0 40V88c0 22.1 17.9 40 40 40H344c22.1 0 40-17.9 40-40V40c0-22.1-17.9-40-40-40H40zM32 408v40c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V160H336V448c0 26.5-21.5 48-48 48H96c-26.5 0-48-21.5-48-48V416H152c4.4 0 8-3.6 8-8s-3.6-8-8-8H48V320H152c4.4 0 8-3.6 8-8s-3.6-8-8-8H48V224H152c4.4 0 8-3.6 8-8s-3.6-8-8-8H48V160H32v56 96 96z'
      
    ]
  };

  

  
  

  var faSwatchbook = {
    prefix: 'fat',
    iconName: 'swatchbook',
    icon: [
      512,
      512,
      [],
      'f5c3',
      
      'M0 416c0 53 43 96 96 96s96-43 96-96V40c0-22.1-17.9-40-40-40H40C17.9 0 0 17.9 0 40V416zm96 80c-44.2 0-80-35.8-80-80L16 40c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24V416c0 44.2-35.8 80-80 80zm376 16c22.1 0 40-17.9 40-40V360c0-22.1-17.9-40-40-40H357.9l-16 16H472c13.3 0 24 10.7 24 24V472c0 13.3-10.7 24-24 24H195.9c-4.6 5.8-9.7 11.1-15.3 16H472zM223.8 423.3L430.3 216.7c15.6-15.6 15.6-40.9 0-56.6L351.1 81c-15.6-15.6-40.9-15.6-56.6 0L224 151.5v22.6l81.9-81.9c9.4-9.4 24.6-9.4 33.9 0L419 171.5c9.4 9.4 9.4 24.6 0 33.9l-195 195V416c0 2.4-.1 4.9-.2 7.3zM120 48H72C58.7 48 48 58.7 48 72v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24zM64 72c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8V72zm8 104c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V200c0-13.3-10.7-24-24-24H72zm0 16h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8V200c0-4.4 3.6-8 8-8zm40 224a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM96 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64z'
      
    ]
  };

  

  
  

  var faRectangleVerticalHistory = {
    prefix: 'fat',
    iconName: 'rectangle-vertical-history',
    icon: [
      576,
      512,
      [],
      'e237',
      
      'M256 16c-26.5 0-48 21.5-48 48V448c0 26.5 21.5 48 48 48H512c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H256zM192 64c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V64zM96 56c0-4.4 3.6-8 8-8s8 3.6 8 8V456c0 4.4-3.6 8-8 8s-8-3.6-8-8V56zM0 104c0-4.4 3.6-8 8-8s8 3.6 8 8V408c0 4.4-3.6 8-8 8s-8-3.6-8-8V104z'
      
    ]
  };

  

  
  

  var faGrillFire = {
    prefix: 'fat',
    iconName: 'grill-fire',
    icon: [
      576,
      512,
      [],
      'e5a4',
      
      'M408 48L40 48C26.7 48 16 58.7 16 72l0 24c0 114.9 93.1 208 208 208c2.7 0 5.4-.1 8-.2c-1.7 5.4-3.2 10.8-4.4 16.1c-1.2 0-2.4 0-3.6 0c-24.1 0-47.4-3.8-69.2-10.9l-24.1 53.1c8.5 5.5 15.7 13 20.7 21.8l75.5 0c1 5.4 2.1 10.7 3.5 16L158 400c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c7.1 0 13.9 1.2 20.3 3.3l23.5-51.7C57.8 270.3 0 189.9 0 96L0 72C0 49.9 17.9 32 40 32l368 0c22.1 0 40 17.9 40 40l0 24c0 24.1-3.8 47.3-10.9 69.1c-4.2-4.3-8.5-8.5-12.9-12.7c5-17.9 7.7-36.8 7.7-56.4l0-24c0-13.3-10.7-24-24-24zM96 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM381.5 176c-1.5 0-3 .5-4.1 1.5c-23.7 21.3-50.3 48.5-70.8 78.7c-20.6 30.3-34.7 62.9-34.7 95.2c0 50 25.1 94.3 63.7 120.3c-9.9-14.1-15.7-31-15.7-49.2c0-57.4 63.8-110.5 87.4-128.2c5.2-3.9 12.1-3.9 17.3 0c23.6 17.7 87.4 70.8 87.4 128.2c0 17.9-5.7 34.7-15.4 48.7c38.3-26.1 63.4-70.1 63.4-119.8c0-25.8-9.7-53.6-24.5-79.7c-14.8-26.1-34.3-49.8-53.2-67.2c-2.3-2.1-5.9-2.1-8.2 0c-6.3 5.8-12.4 12.6-18.2 19.6c-6.4 7.8-18.2 7.9-24.8 .3c-14.3-16.7-29.5-32.3-45.6-46.8c-1.1-1-2.5-1.5-4-1.5zM416 496c2.8 0 5.6-.1 8.3-.2c41.1-3.9 71.7-36 71.7-73.2c0-23-13-47-31.1-68.7c-17.3-20.7-37.4-37.2-48.9-45.9c-11.5 8.7-31.6 25.2-48.9 45.9C349 375.5 336 399.5 336 422.6c0 37.2 30.6 69.4 71.8 73.2c2.7 .1 5.4 .2 8.2 .2zM256 351.4c0-36.8 16-72.6 37.4-104.2c21.5-31.7 49.1-59.8 73.3-81.6c4.2-3.8 9.6-5.6 14.9-5.6c5.2 0 10.5 1.9 14.6 5.7c16.6 15 32.3 31.1 47 48.3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c0 0 .1 0 .1 0s.1 0 .1 0l.1-.1c6-7.2 12.6-14.8 19.7-21.3c8.4-7.7 21.4-7.7 29.8 .1c20.1 18.5 40.7 43.5 56.3 71.1C565 291.3 576 321.9 576 351.4c0 85.1-66.3 155.4-150.6 160.3c-3.1 .3-6.2 .4-9.4 .4c-3.1 0-6.2-.1-9.2-.4C321.5 507 256 436.5 256 351.4z'
      
    ]
  };

  

  
  

  var faJoystick = {
    prefix: 'fat',
    iconName: 'joystick',
    icon: [
      448,
      512,
      [128377],
      'f8c5',
      
      'M320 112a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm16 0c0 59.2-45.9 107.6-104 111.7V352H384c35.3 0 64 28.7 64 64v32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V416c0-35.3 28.7-64 64-64H216V223.7c-58.1-4.1-104-52.6-104-111.7C112 50.1 162.1 0 224 0s112 50.1 112 112zM64 312c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H72c-4.4 0-8-3.6-8-8zM432 416c0-26.5-21.5-48-48-48H64c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V416zM192 80a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z'
      
    ]
  };

  

  
  

  var faLaptopCode = {
    prefix: 'fat',
    iconName: 'laptop-code',
    icon: [
      640,
      512,
      [],
      'f5fc',
      
      'M128 48H512c26.5 0 48 21.5 48 48V352h16V96c0-35.3-28.7-64-64-64H128C92.7 32 64 60.7 64 96V352H80V96c0-26.5 21.5-48 48-48zM620.8 400c1.8 0 3.2 1.4 3.2 3.2c0 33.6-27.2 60.8-60.8 60.8H76.8C43.2 464 16 436.8 16 403.2c0-1.8 1.4-3.2 3.2-3.2H620.8zM19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480H563.2c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2H19.2zM269.7 157.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-64 64c-3.1 3.1-3.1 8.2 0 11.3l64 64c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L211.3 216l58.3-58.3zm112-11.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L428.7 216l-58.3 58.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l64-64c3.1-3.1 3.1-8.2 0-11.3l-64-64z'
      
    ]
  };

  

  
  

  var faTruckUtensils = {
    prefix: 'fat',
    iconName: 'truck-utensils',
    icon: [
      640,
      512,
      [],
      'e628',
      
      'M64 16C37.5 16 16 37.5 16 64V352c0 26.5 21.5 48 48 48h3.3c10.4-36.9 44.4-64 84.7-64s74.2 27.1 84.7 64H400V64c0-26.5-21.5-48-48-48H64zm.4 400H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H352c35.3 0 64 28.7 64 64V96h58.7c10.6 0 20.8 4.2 28.3 11.7L596.3 201c7.5 7.5 11.7 17.7 11.7 28.3V400h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H575.6c.2 2.6 .4 5.3 .4 8c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-2.7 .1-5.4 .4-8H400 239.6c.2 2.6 .4 5.3 .4 8c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-2.7 .1-5.4 .4-8zM416 216H588c-.9-1.3-1.9-2.6-3-3.7L491.7 119c-4.5-4.5-10.6-7-17-7H416V216zm0 16V373.4c15.9-22.6 42.2-37.4 72-37.4c40.3 0 74.2 27.1 84.7 64H592V232H416zM224 424A72 72 0 1 0 80 424a72 72 0 1 0 144 0zm264 72a72 72 0 1 0 0-144 72 72 0 1 0 0 144zM304 240V136 81.8c0-1-.8-1.8-1.8-1.8c-25.5 0-46.2 20.7-46.2 46.2V224c0 8.8 7.2 16 16 16h32zm0 72V256H272c-17.7 0-32-14.3-32-32V126.2C240 91.9 267.9 64 302.2 64C312 64 320 72 320 81.8V136 240v16 56c0 4.4-3.6 8-8 8s-8-3.6-8-8zM152 199.5c0 .2 0 .4 0 .5v96c0 4.4-3.6 8-8 8s-8-3.6-8-8V200c0-.2 0-.4 0-.5c-31-4.1-54.3-31.8-52-63.9l4-56.1c.3-4.4 4.1-7.7 8.5-7.4s7.7 4.1 7.4 8.5l-4 56.1c-1.8 25.6 18.4 47.3 44 47.3s45.9-21.7 44-47.3l-4-56.1c-.3-4.4 3-8.2 7.4-8.5s8.2 3 8.5 7.4l4 56.1c2.3 32.1-21 59.8-52 63.9zM152 80v64c0 4.4-3.6 8-8 8s-8-3.6-8-8V80c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faFileCircleQuestion = {
    prefix: 'fat',
    iconName: 'file-circle-question',
    icon: [
      576,
      512,
      [],
      'e4ef',
      
      'M64 496H311.2c5.8 5.5 12 10.6 18.5 15.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H204.1c12.7 0 24.9 5.1 33.9 14.1L369.9 145.9c9 9 14.1 21.2 14.1 33.9v18.7c-5.4 1.5-10.8 3.3-16 5.4V179.9c0-1.3-.1-2.6-.2-3.9H248c-22.1 0-40-17.9-40-40V16.2c-1.3-.2-2.6-.2-3.9-.2H64C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48zM361.1 160c-.8-1-1.6-1.9-2.4-2.7L226.7 25.4c-.9-.9-1.8-1.7-2.7-2.4V136c0 13.3 10.7 24 24 24H361.1zM560 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-64-90.1c0-20.9 17-37.9 37.9-37.9H454c23.2 0 42 18.8 42 42v8h-.8c-2.6 13.2-11.4 24.6-24 30.3L440 382.4V392c0 4.4-3.6 8-8 8s-8-3.6-8-8V377.2c0-3.1 1.8-6 4.7-7.3l36-16.2C474 349.5 480 340.3 480 330c0-14.4-11.6-26-26-26H405.9c-12.1 0-21.9 9.8-21.9 21.9V328c0 4.4-3.6 8-8 8s-8-3.6-8-8v-2.1z'
      
    ]
  };

  

  
  

  var faHeartHalfStroke = {
    prefix: 'fat',
    iconName: 'heart-half-stroke',
    icon: [
      512,
      512,
      ["heart-half-alt"],
      'e1ac',
      
      'M282.4 105.2c25.4-34.9 68.3-53.2 111.2-47.6C451.9 65.3 496 115 496 173.6c0 30.3-11.7 59.3-32.8 81.1L264.7 460.4c-.2 .2-.5 .5-.7 .7V130.6l18.4-25.4zM248 130.6V460.5c0 0 0 0 0 0L48.9 254.7C27.8 232.9 16 203.8 16 173.5C16 114.9 60.1 65.3 118.3 57.7c42.9-5.6 85.8 12.6 111.2 47.6L248 130.6zM395.7 41.8c-48.6-6.3-97.3 14.3-126.2 54L256 114.4 242.5 95.8c-28.9-39.7-77.6-60.4-126.2-54C50.2 50.4 0 106.8 0 173.5c0 34.5 13.4 67.6 37.4 92.3L236.5 471.6c5.2 5.4 12.4 8.4 19.9 8.4c7.5 0 14.7-3 19.9-8.5L474.8 265.8C498.6 241.1 512 208 512 173.6c0-66.8-50.2-123.2-116.3-131.8z'
      
    ]
  };

  
    var faHeartHalfAlt = faHeartHalfStroke;
  

  
  

  var faSquareCaretDown = {
    prefix: 'fat',
    iconName: 'square-caret-down',
    icon: [
      448,
      512,
      ["caret-square-down"],
      'f150',
      
      'M64 464c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H384c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64zM0 416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416zm224-64c7.3 0 14.3-3 19.3-8.4L345.2 234.4c4.4-4.7 6.8-10.8 6.8-17.2c0-13.9-11.3-25.2-25.2-25.2H121.2C107.3 192 96 203.3 96 217.2c0 6.4 2.4 12.5 6.8 17.2L204.7 343.6c5 5.4 12 8.4 19.3 8.4zM121.2 208H326.8c5.1 0 9.2 4.1 9.2 9.2c0 2.3-.9 4.6-2.5 6.3L231.6 332.7c-2 2.1-4.7 3.3-7.6 3.3s-5.6-1.2-7.6-3.3L114.5 223.5c-1.6-1.7-2.5-4-2.5-6.3c0-5.1 4.1-9.2 9.2-9.2z'
      
    ]
  };

  
    var faCaretSquareDown = faSquareCaretDown;
  

  
  

  var faCompass = {
    prefix: 'fat',
    iconName: 'compass',
    icon: [
      512,
      512,
      [129517],
      'f14e',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm95.1-381.5L204.6 179.4c-11.9 4-21.3 13.4-25.3 25.3L130.5 351.1c-6.3 18.8 11.6 36.6 30.4 30.4l146.5-48.8c11.9-4 21.3-13.4 25.3-25.3l48.8-146.5c6.3-18.8-11.6-36.6-30.4-30.4zm15.2 25.3L317.5 302.3c-2.4 7.2-8 12.8-15.2 15.2L155.8 366.3c-6.3 2.1-12.2-3.9-10.1-10.1l48.8-146.5c2.4-7.2 8-12.8 15.2-15.2l146.5-48.8c6.3-2.1 12.2 3.9 10.1 10.1zM240 256a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faBird = {
    prefix: 'fat',
    iconName: 'bird',
    icon: [
      512,
      512,
      [],
      'e469',
      
      'M240 104c0-48.6 39.4-88 88-88c41.1 0 75.6 28.2 85.3 66.3l-.3 .5 .5 .3c1.6 6.7 2.5 13.8 2.5 21v80c0 110.3-90.8 200-201.3 200C105.5 384 16 295.5 16 186.7c0-5.9 4.8-10.7 10.7-10.7H192c26.5 0 48-21.5 48-48V104zm192 0c0-3.4-.2-6.8-.5-10.2L488.5 128 432 161.9V104zm0 80v-3.5l76.1-45.7c2.4-1.4 3.9-4 3.9-6.9s-1.5-5.4-3.9-6.9l-80-48-.9-.6C413.8 30.5 374.5 0 328 0C270.6 0 224 46.6 224 104v24c0 17.7-14.3 32-32 32H26.7C11.9 160 0 171.9 0 186.7C0 292.2 77.7 379.8 178.6 397l62.5 111c2.2 3.8 7 5.2 10.9 3s5.2-7 3-10.9L198.3 399.4c5.4 .4 10.9 .6 16.4 .6c18.8 0 37-2.4 54.4-6.9l68.1 115c2.2 3.8 7.2 5.1 11 2.8s5.1-7.2 2.8-11l-66-111.5C370.1 359.3 432 278.8 432 184zm-96-56a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faHelicopter = {
    prefix: 'fat',
    iconName: 'helicopter',
    icon: [
      640,
      512,
      [128641],
      'f533',
      
      'M136 0c-4.4 0-8 3.6-8 8s3.6 8 8 8H352V144H132.5L96.2 83.4C89 71.4 75.9 64 61.9 64H36.5C20.9 64 9.4 78.7 13.2 93.8l23.2 93c3 11.9 11.3 21.9 22.6 26.9l123.3 54.8c3.2 1.4 6 3.5 8.3 6.1l97.8 111.8C296 395 307 400 318.5 400h.5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .4 .4 .5 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .5 .4 .5 .4 .5 .5 .5 .5 .5 .5 .5 .5c22.1 0 40-17.9 40-40V280c0-75.1-60.9-136-136-136H368V16H568c4.4 0 8-3.6 8-8s-3.6-8-8-8H136zM36.5 80H61.9c8.4 0 16.2 4.4 20.6 11.7l38.7 64.5c1.4 2.4 4 3.9 6.9 3.9H352V384h-.3-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H341h-.4-.4-.5-.5-.5-.5-.5-.5H337h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H332h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H326h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H319h-.5c-6.9 0-13.5-3-18.1-8.2L202.7 264c-3.8-4.4-8.6-7.9-13.9-10.2L65.5 199c-6.8-3-11.7-8.9-13.5-16.1l-23.2-93c-1.3-5 2.6-9.9 7.8-9.9zM368.2 384H368V160h72c66.3 0 120 53.7 120 120v80c0 13.2-10.8 24-24 24h-.5-.5-.5-.5-.5-.5-.5-.5-.4-.5H531h-.5-.4-.4-.4-.4-.4-.4-.4H527h-.4-.4-.4-.4-.4-.4-.4-.4H523h-.4-.4-.4-.4-.4-.4-.4-.4H519h-.4-.4-.4-.4-.4-.4H516h-.4-.4-.4-.4-.4-.4-.4-.4H512h-.4-.4-.4-.4-.4-.4H509h-.4-.4-.4-.4-.4-.4H506h-.4-.4-.4-.4-.4-.4H503h-.4-.4-.4-.4-.4-.4H500h-.4-.4-.4-.4-.4-.4H497h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H489h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H484h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H479h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H474h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H467h-.4-.4-.4-.4H465h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H460h-.4-.4-.4-.4H458h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H449h-.4-.4-.4-.4H447h-.4-.4-.4-.4H445h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H436h-.4-.4-.4-.4H434h-.4-.4-.4-.4H432h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H423h-.4-.4-.4-.4H421h-.4-.4-.4-.4H419h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H412h-.4-.4-.4-.4H410h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H405h-.4-.4-.4-.4H403h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H398h-.4-.4-.4-.4H396h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H391h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H386h-.4-.4-.4-.4-.4-.4H383h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H378h-.4-.4-.4-.4-.4-.4H375h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4zm269.9 77.1c2.8-3.4 2.4-8.4-1-11.3s-8.4-2.4-11.3 1l-20.8 25c-10.6 12.8-26.4 20.2-43 20.2H232c-4.4 0-8 3.6-8 8s3.6 8 8 8H562c21.4 0 41.6-9.5 55.3-25.9l20.8-25z'
      
    ]
  };

  

  
  

  var faSquareMinus = {
    prefix: 'fat',
    iconName: 'square-minus',
    icon: [
      448,
      512,
      [61767,"minus-square"],
      'f146',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM128 248H320c4.4 0 8 3.6 8 8s-3.6 8-8 8H128c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  
    var faMinusSquare = faSquareMinus;
  

  
  

  var faHouseFire = {
    prefix: 'fat',
    iconName: 'house-fire',
    icon: [
      640,
      512,
      [],
      'e50c',
      
      'M293.3 2c-3-2.7-7.6-2.7-10.6 0L2.7 250c-3.3 2.9-3.6 8-.7 11.3s8 3.6 11.3 .7L64 217.1V448c0 35.3 28.7 64 64 64H374.3c-7.9-5.3-15.3-11.1-22.3-17.5V496H224V328c0-4.4 3.6-8 8-8h59.6c1.2-5.3 2.7-10.7 4.4-16H232c-13.3 0-24 10.7-24 24V496H128c-26.5 0-48-21.5-48-48V202.9L288 18.7 419.2 134.9c5.3-3.2 11.1-5.3 17-6.3L293.3 2zM445.5 176c1.5 0 2.9 .5 4 1.5c16.1 14.6 31.3 30.1 45.6 46.8c6.6 7.6 18.4 7.5 24.8-.3c5.8-7 11.9-13.9 18.2-19.6c2.3-2.1 5.9-2.1 8.2 0c18.9 17.4 38.4 41.2 53.2 67.2c14.8 26.1 24.5 54 24.5 79.7c0 49.7-25.1 93.7-63.4 119.8c9.7-14 15.4-30.7 15.4-48.7c0-57.4-63.8-110.5-87.4-128.2c-5.2-3.9-12.1-3.9-17.3 0C447.8 312.1 384 365.2 384 422.6c0 18.2 5.8 35 15.7 49.2c-38.7-26-63.7-70.3-63.7-120.3c0-32.3 14.1-64.9 34.7-95.2c20.5-30.2 47-57.4 70.8-78.7c1.1-1 2.6-1.5 4.1-1.5zM480 496c-2.7 0-5.5-.1-8.2-.2c-41.2-3.8-71.8-36-71.8-73.2c0-23 13-47 31.1-68.7c17.3-20.7 37.4-37.2 48.9-45.9c11.5 8.7 31.6 25.2 48.9 45.9C547 375.5 560 399.5 560 422.6c0 37.2-30.6 69.4-71.7 73.2c-2.7 .2-5.5 .2-8.3 .2zM320 351.4c0 85.1 65.5 155.6 150.8 160.3c3 .3 6.1 .4 9.2 .4c3.2 0 6.3-.1 9.4-.4C573.7 506.9 640 436.5 640 351.4c0-29.5-11-60.1-26.6-87.6c-15.6-27.6-36.2-52.6-56.3-71.1c-8.4-7.7-21.4-7.8-29.8-.1c-7.1 6.5-13.8 14-19.7 21.3c0 0-.1 0-.1 .1s-.1 0-.1 0s-.1 0-.1 0l0 0s0 0 0 0s0 0 0 0c-14.8-17.2-30.5-33.2-47-48.3c-4.2-3.8-9.4-5.6-14.6-5.7c-5.3 0-10.6 1.8-14.9 5.6c-24.3 21.8-51.8 50-73.3 81.6C336 278.8 320 314.6 320 351.4z'
      
    ]
  };

  

  
  

  var faEmptySet = {
    prefix: 'fat',
    iconName: 'empty-set',
    icon: [
      512,
      512,
      [216,8709],
      'f656',
      
      'M485.7 37.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L408.6 92.1C368.6 54.8 315 32 256 32C132.3 32 32 132.3 32 256c0 59 22.8 112.6 60.1 152.6L26.3 474.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l65.7-65.7C143.4 457.2 197 480 256 480c123.7 0 224-100.3 224-224c0-59-22.8-112.6-60.1-152.6l65.7-65.7zm-88.3 65.7L103.4 397.3C69 360.2 48 310.6 48 256C48 141.1 141.1 48 256 48c54.6 0 104.2 21 141.3 55.4zM114.7 408.6L408.6 114.7C443 151.8 464 201.4 464 256c0 114.9-93.1 208-208 208c-54.6 0-104.2-21-141.3-55.4z'
      
    ]
  };

  

  
  

  var faStarAndCrescent = {
    prefix: 'fat',
    iconName: 'star-and-crescent',
    icon: [
      512,
      512,
      [9770],
      'f699',
      
      'M16 256C16 123.5 123.5 16 256 16c31 0 60.6 5.9 87.7 16.5c-5.2-.4-10.4-.5-15.7-.5C204.3 32 104 132.3 104 256s100.3 224 224 224c5.3 0 10.5-.2 15.7-.5C316.6 490.1 287 496 256 496C123.5 496 16 388.5 16 256zM256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c33 0 64.6-6.3 93.6-17.7c7.4-2.9 11.5-10.7 9.8-18.4s-8.8-13-16.7-12.4c-4.8 .3-9.7 .5-14.6 .5c-114.9 0-208-93.1-208-208s93.1-208 208-208c4.9 0 9.8 .2 14.6 .5c7.9 .5 15-4.7 16.7-12.4s-2.4-15.5-9.8-18.4C320.6 6.3 289 0 256 0zM358.3 208.3L384 156.2l25.7 52.2c3.7 7.6 10.9 12.8 19.3 14l57.6 8.4-41.6 40.6c-6 5.9-8.8 14.4-7.4 22.7l9.8 57.3-51.5-27.1c-7.5-3.9-16.4-3.9-23.8 0l-51.5 27.1 9.8-57.3c1.4-8.3-1.3-16.8-7.4-22.7l-41.6-40.6 57.6-8.4c8.3-1.2 15.5-6.4 19.3-14zm17.1-70.9l-31.5 63.8c-1.4 2.8-4.1 4.8-7.2 5.3l-70.4 10.2c-7.9 1.1-11 10.8-5.3 16.4l50.9 49.6c2.3 2.2 3.3 5.4 2.8 8.5l-12 70.1c-1.3 7.8 6.9 13.8 13.9 10.1l63-33.1c2.8-1.5 6.1-1.5 8.9 0l63 33.1c7 3.7 15.3-2.3 13.9-10.1l-12-70.1c-.5-3.1 .5-6.3 2.8-8.5L507 233.1c5.7-5.6 2.6-15.2-5.3-16.4l-70.4-10.2c-3.1-.5-5.8-2.4-7.2-5.3l-31.5-63.8c-3.5-7.1-13.7-7.1-17.2 0z'
      
    ]
  };

  

  
  

  var faReply = {
    prefix: 'fat',
    iconName: 'reply',
    icon: [
      512,
      512,
      [61714,"mail-reply"],
      'f3e5',
      
      'M224 144c-8.8 0-16-7.2-16-16V64c0-6.3-3.7-12-9.5-14.6s-12.5-1.5-17.2 2.7l-160 144c-3.4 3-5.3 7.4-5.3 11.9s1.9 8.9 5.3 11.9l160 144c4.7 4.2 11.4 5.3 17.2 2.7s9.5-8.3 9.5-14.6V288c0-8.8 7.2-16 16-16h96c61.9 0 112 50.1 112 112c0 35.5-15.2 57.1-27.3 68.4c-3.7 3.5-4.7 6.5-4.7 7.8c0 2.1 1.7 3.7 3.7 3.7c.3 0 .5 0 .6 0c17.1-9.3 91.8-55.7 91.8-160c0-88.4-71.6-160-160-160H224zm0 160v48c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 225.7 0 217.1 0 208s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4s19 16.6 19 29.2v48 16h16 96c97.2 0 176 78.8 176 176c0 113.3-81.5 163.9-100.2 174.1c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-7.5 4.3-14.4 9.8-19.5c9.4-8.8 22.2-26.4 22.2-56.7c0-53-43-96-96-96H240 224v16z'
      
    ]
  };

  
    var faMailReply = faReply;
  

  
  

  var faMeat = {
    prefix: 'fat',
    iconName: 'meat',
    icon: [
      512,
      512,
      [127830],
      'f814',
      
      'M271.1 31.1c-15 15-19.1 40-11.1 70.3c7.9 30.1 27.5 63.7 57.2 93.4s63.4 49.3 93.4 57.2c30.3 8 55.3 3.8 70.3-11.1c9.6-9.6 14.7-23.3 15.1-40c-.2-10.9-1.9-21.6-4.5-31.6c-1.4-5.4-3.1-10.7-5.1-16.1c-9.9-25.3-27.4-52-51.5-76.1c-23.7-23.7-50-41-75-51c-5.7-2.2-11.5-4.1-17.2-5.6c-10.4-2.7-21.5-4.4-32.8-4.5c-16.1 .6-29.4 5.7-38.7 15.1zM406.5 267.5c-33.3-8.8-69.3-30-100.7-61.4s-52.6-67.4-61.4-100.7c-6.2-23.7-6.3-46.8 1.8-65.6l-.9 .9L197.9 88.2C163.4 122.7 144 169.5 144 218.3V296c0 39.8 32.2 72 72 72h77.7c48.8 0 95.6-19.4 130.1-53.8l47.6-47.6 0 0c.3-.3 .7-.7 1-1c-18.9 8.2-42.1 8.2-65.9 1.9zM446.8 65.3c24.4 24.4 43.4 52.9 54.5 82.3c2.5 6.4 4.6 12.7 6.2 19c3.1 11.8 4.7 23.4 4.5 34.5c.4 26.4-6.9 54.5-29.3 77l0 0-47.6 47.6C397.6 363 346.8 384 293.7 384H216c-6.4 0-12.7-.7-18.7-2c-.4 .3-.7 .6-1 1l-14.7 14.7c-3.1 3.1-3.6 9.6 .3 15.7c6.4 10 10.1 21.9 10.1 34.6c0 35.3-28.7 64-64 64s-64-28.7-64-64c-35.3 0-64-28.7-64-64s28.7-64 64-64c12.7 0 24.6 3.7 34.6 10.1c6.1 3.9 12.6 3.4 15.7 .3L129 315.7c.3-.3 .7-.7 1-1.1c-1.3-6-2-12.2-2-18.6V218.3c0-53 21.1-103.9 58.6-141.4l47.5-47.5c22-22 49.5-29.4 75.5-29.4c11.5-.4 23.6 1.2 35.9 4.4c6.7 1.8 13.4 4 20.3 6.7c28.9 11.1 57 30 81 54zM135.6 331.8l-10 10c-10.3 10.3-25.8 8.2-35.6 1.8C82.5 338.8 73.6 336 64 336c-26.5 0-48 21.5-48 48s21.5 48 48 48c8.7 0 16 7.3 16 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-9.6-2.8-18.5-7.6-25.9c-6.3-9.8-8.5-25.3 1.8-35.6l10-10c-19.9-8.8-35.8-24.8-44.7-44.7zM354 114c-1.6 1.6-2.9 5.3-1.2 11.8c1.7 6.3 5.9 13.8 12.7 20.6s14.3 11.1 20.6 12.7c6.5 1.7 10.2 .4 11.8-1.2s2.9-5.3 1.2-11.8c-1.7-6.3-5.9-13.8-12.7-20.6s-14.3-11.1-20.6-12.7c-6.5-1.7-10.2-.4-11.8 1.2zm43.8 .2c8.5 8.5 14.4 18.4 16.9 27.9c2.4 9.3 1.9 19.9-5.4 27.2s-17.9 7.8-27.2 5.4c-9.5-2.5-19.4-8.4-27.9-16.9s-14.4-18.4-16.9-27.9c-2.4-9.3-1.9-19.9 5.4-27.2s17.9-7.8 27.2-5.4c9.5 2.5 19.4 8.4 27.9 16.9z'
      
    ]
  };

  

  
  

  var faClover = {
    prefix: 'fat',
    iconName: 'clover',
    icon: [
      448,
      512,
      [],
      'e139',
      
      'M171.3 48c-21.5 0-39 17.5-39 39v4.1c0 8.8 2.1 17.5 6.1 25.4l44.7 87.9c1.6 3.1 1 6.8-1.5 9.3s-6.2 3-9.3 1.5L84.5 170.4c-7.9-4-16.5-6.1-25.4-6.1H55c-21.5 0-39 17.5-39 39c0 10.3 4.1 20.3 11.4 27.6l19.5 19.5c3.1 3.1 3.1 8.2 0 11.3L27.4 281.1C20.1 288.4 16 298.4 16 308.7c0 21.5 17.5 39 39 39h4.1c8.8 0 17.5-2.1 25.4-6.1l87.9-44.7c3.1-1.6 6.8-1 9.3 1.5s3 6.2 1.5 9.3l-44.7 87.9c-4 7.9-6.1 16.6-6.1 25.4V425c0 21.5 17.5 39 39 39c10.3 0 20.3-4.1 27.6-11.4l19.5-19.5c1.5-1.5 3.5-2.3 5.7-2.3s4.2 .8 5.7 2.3l19.5 19.5c7.3 7.3 17.2 11.4 27.6 11.4c21.5 0 39-17.5 39-39v-4.1c0-8.8-2.1-17.5-6.1-25.4l-44.7-87.9c-1.6-3.1-1-6.8 1.5-9.3s6.2-3 9.3-1.5l87.9 44.7c7.9 4 16.6 6.1 25.4 6.1H393c21.5 0 39-17.5 39-39c0-10.3-4.1-20.3-11.4-27.6l-19.5-19.5c-1.5-1.5-2.3-3.5-2.3-5.7s.8-4.2 2.3-5.7l19.5-19.5c7.3-7.3 11.4-17.2 11.4-27.6c0-21.5-17.5-39-39-39h-4c-8.9 0-17.6 2.1-25.5 6.2l-86.6 44.6c-3.1 1.6-6.8 1-9.3-1.4s-3.1-6.2-1.5-9.3l43.8-88c3.9-7.8 5.9-16.3 5.9-25V87c0-21.5-17.5-39-39-39c-10.3 0-20.3 4.1-27.6 11.4L229.7 78.9c-1.5 1.5-3.5 2.3-5.7 2.3s-4.2-.8-5.7-2.3L198.9 59.4C191.6 52.1 181.6 48 171.3 48zm0-16c14.6 0 28.6 5.8 38.9 16.1L224 61.9l13.8-13.8C248.1 37.8 262.1 32 276.7 32c30.4 0 55 24.6 55 55v4.4c0 11.2-2.6 22.2-7.5 32.1l-32.9 66.2 64.9-33.4c10.2-5.2 21.4-8 32.9-8h4c30.4 0 55 24.6 55 55c0 14.6-5.8 28.6-16.1 38.9L418.1 256l13.8 13.8c10.3 10.3 16.1 24.3 16.1 38.9c0 30.4-24.6 55-55 55h-4.1c-11.3 0-22.5-2.7-32.6-7.8l-66-33.6 33.6 66c5.1 10.1 7.8 21.3 7.8 32.6V425c0 30.4-24.6 55-55 55c-14.6 0-28.6-5.8-38.9-16.1L224 450.1l-13.8 13.8c-10.3 10.3-24.3 16.1-38.9 16.1c-30.4 0-55-24.6-55-55v-4.1c0-11.3 2.7-22.5 7.8-32.6l33.6-66-66 33.6c-10.1 5.1-21.3 7.8-32.6 7.8H55c-30.4 0-55-24.6-55-55c0-14.6 5.8-28.6 16.1-38.9L29.9 256 16.1 242.2C5.8 231.9 0 217.9 0 203.3c0-30.4 24.6-55 55-55h4.1c11.3 0 22.5 2.7 32.6 7.8l66 33.6-33.6-66c-5.1-10.1-7.8-21.3-7.8-32.6V87c0-30.4 24.6-55 55-55z'
      
    ]
  };

  

  
  

  var faUsersSlash = {
    prefix: 'fat',
    iconName: 'users-slash',
    icon: [
      640,
      512,
      [],
      'e073',
      
      'M144 16c33.9 0 61.7 26.4 63.9 59.7l15.7 12.4c.3-2.7 .4-5.4 .4-8.2c0-44.2-35.8-80-80-80c-9.3 0-18.1 1.6-26.4 4.5l15.7 12.4c3.5-.6 7-.9 10.7-.9zM104 192C46.6 192 0 238.6 0 296c0 4.4 3.6 8 8 8s8-3.6 8-8c0-48.6 39.4-88 88-88h39l-20.3-16H104zM261.3 352C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H485.3c10.5 0 19.6-6.1 23.9-14.9l-13.3-10.5c-.6 5.3-5.1 9.4-10.6 9.4H154.7c-5.9 0-10.7-4.8-10.7-10.7C144 420.5 196.5 368 261.3 368h84.3l-20.3-16H261.3zM416 224c0-53-43-96-96-96c-13 0-25.4 2.6-36.7 7.3L298.2 147c6.9-2 14.3-3 21.8-3c44.2 0 80 35.8 80 80c0 1.1 0 2.3-.1 3.4l14.9 11.8c.8-4.9 1.2-10 1.2-15.1zM512 16a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 144A80 80 0 1 0 512 0a80 80 0 1 0 0 160zm24 48c48.6 0 88 39.4 88 88c0 4.4 3.6 8 8 8s8-3.6 8-8c0-57.4-46.6-104-104-104H444c1.3 5.2 2.4 10.6 3 16h89zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  

  
  

  var faStarSharpHalf = {
    prefix: 'fat',
    iconName: 'star-sharp-half',
    icon: [
      576,
      512,
      [],
      'e28c',
      
      'M280 34.4l-48.4 152c-1.1 3.3-4.1 5.6-7.6 5.6H50.9c-1.6 0-2.9 1.3-2.9 2.9c0 .9 .4 1.7 1 2.2L189.1 313.9c2.5 2.1 3.5 5.4 2.5 8.5L139.4 494.1c-.3 .9 .4 1.9 1.4 1.9c.3 0 .6-.1 .9-.3L280 388.1V34.4zM271.4 8.8c1.7-5.2 6.5-8.8 12-8.8c7 0 12.6 5.7 12.6 12.6V392c0 2.5-1.1 4.8-3.1 6.3l-141.4 110c-3.1 2.4-6.8 3.7-10.7 3.7c-11.7 0-20.1-11.3-16.7-22.5l50.7-166.7L38.8 209.4c-4.3-3.6-6.8-8.9-6.8-14.5c0-10.4 8.5-18.9 18.9-18.9H218.2L271.4 8.8z'
      
    ]
  };

  

  
  

  var faPickleball = {
    prefix: 'fat',
    iconName: 'pickleball',
    icon: [
      576,
      512,
      [],
      'e435',
      
      'M374.9 39.4c-31.3-31.2-82-31.2-113.3 0L103.7 196.8c-18.4 18.3-23.8 45.8-13.9 69.7l28.3 67.8c7.5 17.9 3.4 38.6-10.4 52.3L39.1 455.1c-9.4 9.4-9.4 24.5 0 33.9s24.6 9.4 34 0L142 420.4c13.7-13.7 34.3-17.8 52.2-10.4l66.5 27.3c7.1 2.9 14.6 4.5 22 4.7c2.1 5.4 4.5 10.7 7.2 15.9c-11.8 .7-23.9-1.2-35.3-5.8l-66.5-27.3c-12-4.9-25.7-2.2-34.8 7L84.4 500.3c-15.6 15.6-41 15.6-56.7 0s-15.6-40.9 0-56.5l68.7-68.5c9.2-9.2 11.9-22.9 6.9-34.9L75.1 272.7c-12.5-29.9-5.6-64.3 17.3-87.2L250.3 28.1c37.5-37.4 98.4-37.4 135.9 0L499.8 141.3c29.4 29.3 35.8 72.9 19.1 108.4c-4.5-2.9-9.1-5.6-13.9-8.1c13.1-29.3 7.6-65-16.5-89L374.9 39.4zM280.4 332.6c-2 5.8-3.6 11.7-4.9 17.7L138.6 213.9c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L280.4 332.6zM431.9 496.1a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-240a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm-64 128a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm64 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0-48a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm80 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-64-64a16 16 0 1 1 0-32 16 16 0 1 1 0 32z'
      
    ]
  };

  

  
  

  var faFaceMask = {
    prefix: 'fat',
    iconName: 'face-mask',
    icon: [
      576,
      512,
      [],
      'e37f',
      
      'M480 400c-43.8 58.3-113.5 96-192 96s-148.2-37.7-192-96h48.6c3.9 27.1 27.2 48 55.4 48H376c28.2 0 51.6-20.9 55.4-48H480zm11-16H488 432V312c0-6.2-1-12.1-2.8-17.7l98.4-52.5c.3 4.7 .4 9.4 .4 14.2c0 47.1-13.5 91-36.9 128zM526 224.6L422 280c-10.1-14.5-26.9-24-46-24H200c-19 0-35.9 9.5-46 24L50 224.6C65.4 106.9 166.1 16 288 16s222.6 90.9 238 208.6zm15-8C522 93.9 416 0 288 0S54 93.9 35 216.6c-3.8-1.5-8.1 0-10.1 3.6c-2.1 3.9-.6 8.7 3.3 10.8l4.7 2.5c-.6 7.4-1 14.9-1 22.4c0 141.4 114.6 256 256 256s256-114.6 256-256c0-7.6-.3-15-1-22.4l4.7-2.5c3.9-2.1 5.4-6.9 3.3-10.8c-1.9-3.7-6.3-5.2-10.1-3.6zM48.4 241.8l98.4 52.5c-1.8 5.6-2.8 11.5-2.8 17.7v72H88 84.9C61.5 347 48 303.1 48 256c0-4.8 .1-9.5 .4-14.2zM376 272c22.1 0 40 17.9 40 40v80c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V312c0-22.1 17.9-40 40-40H376zM184 320c0 4.4 3.6 8 8 8H384c4.4 0 8-3.6 8-8s-3.6-8-8-8H192c-4.4 0-8 3.6-8 8zm0 64c0 4.4 3.6 8 8 8H384c4.4 0 8-3.6 8-8s-3.6-8-8-8H192c-4.4 0-8 3.6-8 8zm56-216c4.4 0 8-3.6 8-8s-3.6-8-8-8c-53.3 0-89.5 22.1-101.7 34.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0c9.1-9.1 41.2-29.7 90.3-29.7zm186.3 29.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3C425.5 174.1 389.3 152 336 152c-4.4 0-8 3.6-8 8s3.6 8 8 8c49.1 0 81.2 20.5 90.3 29.7z'
      
    ]
  };

  

  
  

  var faTachographDigital = {
    prefix: 'fat',
    iconName: 'tachograph-digital',
    icon: [
      640,
      512,
      ["digital-tachograph"],
      'f566',
      
      'M64 80c-26.5 0-48 21.5-48 48V384c0 26.5 21.5 48 48 48H576c26.5 0 48-21.5 48-48V128c0-26.5-21.5-48-48-48H64zM0 128C0 92.7 28.7 64 64 64H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm96 16c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16H96zM64 160c0-17.7 14.3-32 32-32H320c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160zm0 216c0-4.4 3.6-8 8-8H344c4.4 0 8 3.6 8 8s-3.6 8-8 8H72c-4.4 0-8-3.6-8-8zm320 0c0-4.4 3.6-8 8-8H568c4.4 0 8 3.6 8 8s-3.6 8-8 8H392c-4.4 0-8-3.6-8-8zM80 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  
    var faDigitalTachograph = faTachographDigital;
  

  
  

  var faMagnifyingGlassArrowRight = {
    prefix: 'fat',
    iconName: 'magnifying-glass-arrow-right',
    icon: [
      512,
      512,
      [],
      'e521',
      
      'M208 16a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 400c54.6 0 104.2-21 141.3-55.4l149 149c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-149-149C395 312.2 416 262.6 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm29.7-293.7c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L292.7 200H104c-4.4 0-8 3.6-8 8s3.6 8 8 8H292.7l-66.3 66.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l80-80c3.1-3.1 3.1-8.2 0-11.3l-80-80z'
      
    ]
  };

  

  
  

  var faSensorTriangleExclamation = {
    prefix: 'fat',
    iconName: 'sensor-triangle-exclamation',
    icon: [
      640,
      512,
      ["sensor-alert"],
      'e029',
      
      'M64 48H384c26.5 0 48 21.5 48 48v33.8c5.2-1.2 10.6-1.8 16-1.8V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H225c-.6-4-1-8.1-1-12.3c0-1.2 0-2.5 .1-3.7H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48zm32 56c0-4.4-3.6-8-8-8s-8 3.6-8 8V280c0 4.4 3.6 8 8 8s8-3.6 8-8V104zm64 0c0-4.4-3.6-8-8-8s-8 3.6-8 8V280c0 4.4 3.6 8 8 8s8-3.6 8-8V104zM275.7 453.7l150.4-265c4.5-7.9 12.9-12.8 21.9-12.8s17.5 4.9 21.9 12.8l150.4 265c2.4 4.3 3.7 9.1 3.7 14c0 15.6-12.7 28.3-28.3 28.3H300.3c-15.6 0-28.3-12.7-28.3-28.3c0-4.9 1.3-9.7 3.7-14zM412.2 180.9l-150.4 265c-3.8 6.7-5.8 14.2-5.8 21.9c0 24.5 19.8 44.3 44.3 44.3H595.7c24.5 0 44.3-19.8 44.3-44.3c0-7.7-2-15.2-5.8-21.9l-150.4-265C476.5 168 462.8 160 448 160s-28.5 8-35.8 20.9zM456 288c0-4.4-3.6-8-8-8s-8 3.6-8 8v96c0 4.4 3.6 8 8 8s8-3.6 8-8V288zm-8 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  
    var faSensorAlert = faSensorTriangleExclamation;
  

  
  

  var faUsersMedical = {
    prefix: 'fat',
    iconName: 'users-medical',
    icon: [
      640,
      512,
      [],
      'f830',
      
      'M208 80A64 64 0 1 0 80 80a64 64 0 1 0 128 0zM64 80a80 80 0 1 1 160 0A80 80 0 1 1 64 80zM320 304a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-176a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM261.3 368C196.5 368 144 420.5 144 485.3c0 5.9 4.8 10.7 10.7 10.7h310c1 5.7 2.9 11.1 5.8 16H154.7c-14.7 0-26.7-11.9-26.7-26.7C128 411.7 187.7 352 261.3 352H378.7c8.1 0 16.1 .7 23.8 2.1c-3.5 4.4-6.3 9.5-8.1 14.9c-5.1-.7-10.4-1-15.7-1H261.3zM512 144a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zm24 208H447c-.7-5.4-1.7-10.8-3-16h92c57.4 0 104 46.6 104 104c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-48.6-39.4-88-88-88zm-343 0H104c-48.6 0-88 39.4-88 88c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-57.4 46.6-104 104-104h92c-1.3 5.2-2.4 10.6-3 16zM504 312v56c0 4.4-3.6 8-8 8H440c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h56c4.4 0 8 3.6 8 8v56c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V432c0-4.4 3.6-8 8-8h56c4.4 0 8-3.6 8-8V384c0-4.4-3.6-8-8-8H560c-4.4 0-8-3.6-8-8V312c0-4.4-3.6-8-8-8H512c-4.4 0-8 3.6-8 8zm8-24h32c13.3 0 24 10.7 24 24v48h48c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H568v48c0 13.3-10.7 24-24 24H512c-13.3 0-24-10.7-24-24V440H440c-13.3 0-24-10.7-24-24V384c0-13.3 10.7-24 24-24h48V312c0-13.3 10.7-24 24-24z'
      
    ]
  };

  

  
  

  var faMessageImage = {
    prefix: 'fat',
    iconName: 'message-image',
    icon: [
      512,
      512,
      ["comment-alt-image"],
      'e1e0',
      
      'M176 416c0-8.8-7.2-16-16-16H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H309.3c-3.5 0-6.8 1.1-9.6 3.2L176 496V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h80 16v16 64c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM168 128a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm-40-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm167.7 40c2.6 0 5 1.3 6.5 3.4L407.2 297.4c.5 .7 .8 1.5 .8 2.4c0 2.3-1.9 4.2-4.2 4.2h-296c-2.1 0-3.8-1.7-3.8-3.8c0-.9 .3-1.7 .8-2.4l56.5-70.6c1.6-2 4-3.1 6.5-3.1c2.6 0 5.1 1.2 6.7 3.3l19.1 25.5c1.5 2 3.8 3.2 6.3 3.2s4.8-1.1 6.4-3.1L289.5 147c1.5-1.9 3.8-3 6.2-3zm-18.8-6.9l-76.8 97.7-12.9-17.1c-4.6-6.1-11.8-9.7-19.5-9.7c-7.4 0-14.4 3.4-19 9.1L92.3 287.8c-2.8 3.5-4.3 7.9-4.3 12.4c0 11 8.9 19.8 19.8 19.8h296c11.1 0 20.2-9 20.2-20.2c0-4.1-1.3-8.2-3.6-11.6L315.3 138.2c-4.5-6.4-11.8-10.2-19.6-10.2c-7.3 0-14.3 3.4-18.8 9.1z'
      
    ]
  };

  
    var faCommentAltImage = faMessageImage;
  

  
  

  var faUserChef = {
    prefix: 'fat',
    iconName: 'user-chef',
    icon: [
      448,
      512,
      [],
      'e3d2',
      
      'M124 0C90.9 0 64 26.9 64 60c0 23 13 43 32 53.1V152v24c0 70.7 57.3 128 128 128s128-57.3 128-128V152 113.1C371 103 384 83 384 60c0-33.1-26.9-60-60-60c-21.4 0-40.2 11.2-50.8 28.1C262.6 11.2 243.8 0 222.4 0C202 0 184 10.1 173.2 25.7C162.4 10.1 144.4 0 124 0zM112 176V160H336v16c0 61.9-50.1 112-112 112s-112-50.1-112-112zM80 60c0-24.3 19.7-44 44-44c19.3 0 35.7 12.4 41.6 29.7c1.1 3.2 4.1 5.4 7.6 5.4s6.5-2.2 7.6-5.4C186.7 28.4 203.1 16 222.4 16c21 0 38.7 14.8 43 34.6c.8 3.7 4.1 6.3 7.8 6.3s7-2.6 7.8-6.3C285.3 30.8 303 16 324 16c24.3 0 44 19.7 44 44c0 18.3-11.2 34-27.1 40.6c-3 1.2-4.9 4.2-4.9 7.4v36H112V108c0-3.2-1.9-6.1-4.9-7.4C91.2 94 80 78.3 80 60zm32 272.8c0-2.6 2.1-4.8 4.8-4.8c.8 0 1.6 .2 2.3 .6l88.4 47.6-58.5 31.7c-12.9 7-20.9 20.5-20.9 35.2V496H25c-5 0-9-4-9-9c0-54 38.5-98.9 89.5-108.9c3.8-.7 6.5-4 6.5-7.8V332.8zM144 496V443.1c0-8.8 4.8-16.9 12.6-21.1l172.6-93.5c.6-.3 1.3-.5 2-.5c2.6 0 4.8 2.1 4.8 4.8v37.4c0 3.8 2.7 7.1 6.5 7.8c51 10 89.5 55 89.5 108.9c0 5-4 9-9 9H144zM324.3 313.2l-.1-.2-2.4 1.3c-.2 .1-.3 .2-.5 .2L224 366.9l-97.4-52.4c-3-1.6-6.4-2.5-9.9-2.5c-11.5 0-20.8 9.3-20.8 20.8v31C40.8 377.7 0 427.5 0 487c0 13.8 11.2 25 25 25H423c13.8 0 25-11.2 25-25c0-59.5-40.8-109.4-96-123.2v-31c0-11.5-9.3-20.8-20.8-20.8c-2.4 0-4.7 .4-6.9 1.2zM240 444a12 12 0 1 0 0-24 12 12 0 1 0 0 24zm76-12a12 12 0 1 0 -24 0 12 12 0 1 0 24 0z'
      
    ]
  };

  

  
  

  var faTable = {
    prefix: 'fat',
    iconName: 'table',
    icon: [
      512,
      512,
      [],
      'f0ce',
      
      'M16 96c0-26.5 21.5-48 48-48l384 0c26.5 0 48 21.5 48 48l0 64L16 160l0-64zm232 80l0 128L16 304l0-128 232 0zm16 0l232 0 0 128-232 0 0-128zM248 320l0 144L64 464c-26.5 0-48-21.5-48-48l0-96 232 0zm16 144l0-144 232 0 0 96c0 26.5-21.5 48-48 48l-184 0zM0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416z'
      
    ]
  };

  

  
  

  var faHyphen = {
    prefix: 'fat',
    iconName: 'hyphen',
    icon: [
      320,
      512,
      [],
      '2d',
      
      'M0 256c0-4.4 3.6-8 8-8H312c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faMustache = {
    prefix: 'fat',
    iconName: 'mustache',
    icon: [
      640,
      512,
      [],
      'e5bc',
      
      'M235.8 112c-30.2 0-59.2 12.9-79.6 35c-34 36.8-91.2 41.3-129.9 9.6L13.1 145.8c-3.4-2.8-8.5-2.3-11.3 1.1C.6 148.4 0 150.2 0 152H0v8 43.7C0 307.7 84.3 392 188.3 392c45.6 0 89.7-16.6 124-46.6l7.8-6.8 7.8 6.8c34.3 30 78.4 46.6 124 46.6c104 0 188.3-84.3 188.3-188.3V160v-8h0c0-1.8-.6-3.6-1.8-5.1c-2.8-3.4-7.8-3.9-11.3-1.1l-13.2 10.8c-38.7 31.6-95.9 27.2-129.9-9.6c-20.4-22.1-49.4-35-79.6-35c-25.3 0-49.7 8.9-69.1 25L320 149.6 304.9 137c-19.4-16.2-43.9-25-69.2-25zM624 168.9v34.9C624 298.9 546.9 376 451.7 376c-41.7 0-82-15.1-113.4-42.6l-13-11.4c-3-2.6-7.5-2.6-10.5 0l-13 11.4C270.3 360.9 230 376 188.3 376C93.1 376 16 298.9 16 203.7V168.9l.2 .1c45.3 37.1 112.2 31.8 151.8-11.1C185.4 139 210.1 128 235.8 128c21.5 0 42.4 7.5 58.9 21.3l20.2 16.8c3 2.5 7.3 2.5 10.2 0l20.2-16.8c16.5-13.8 37.4-21.3 58.9-21.3c25.7 0 50.4 11 67.8 29.9c39.6 42.9 106.5 48.2 151.8 11.1l.2-.1z'
      
    ]
  };

  

  
  

  var faHockeyPuck = {
    prefix: 'fat',
    iconName: 'hockey-puck',
    icon: [
      512,
      512,
      [],
      'f453',
      
      'M16 179.5c0 12.2 5.7 24.4 17.2 36.2c11.6 11.9 28.8 22.9 50.6 32.4C127.5 267 188.3 278.9 256 278.9s128.5-11.9 172.2-30.8c21.8-9.5 39-20.5 50.6-32.4c9.5-9.8 15.1-19.8 16.7-29.9V184h.3c.2-1.5 .3-3 .3-4.5c0-12.2-5.7-24.4-17.2-36.2c-11.6-11.9-28.8-22.9-50.6-32.4C384.5 91.9 323.7 80 256 80s-128.5 11.9-172.2 30.8c-21.8 9.5-39 20.5-50.6 32.4C21.7 155.1 16 167.3 16 179.5zm479.5 41.6c-1.6 2-3.4 3.9-5.2 5.8c-13.5 13.8-32.7 25.9-55.7 35.9c-46.1 20-109.2 32.1-178.5 32.1s-132.4-12.2-178.5-32.1c-23-10-42.2-22.1-55.7-35.9c-2-2.1-4-4.2-5.8-6.4V332.6c0 12.1 5.6 24.4 17.2 36.2c11.6 11.9 28.7 22.9 50.5 32.4c43.6 18.9 104.4 30.8 172 30.8s128.4-11.9 172-30.8c21.8-9.5 39-20.5 50.6-32.4c11.5-11.8 17.2-24.1 17.2-36.2V221.1zM.2 184c-.1-1.5-.2-3-.2-4.5C0 162 8.2 145.9 21.8 132c13.5-13.8 32.7-25.9 55.7-35.9C123.6 76.2 186.7 64 256 64s132.4 12.2 178.5 32.1c23 10 42.2 22.1 55.7 35.9C503.8 145.9 512 162 512 179.5c0 2.6-.2 5.1-.5 7.6V332.6c0 17.5-8.2 33.5-21.7 47.4c-13.5 13.8-32.6 25.9-55.6 35.9C388 435.9 325 448 255.7 448s-132.3-12.1-178.4-32.1c-23-10-42.1-22.1-55.6-35.9C8.2 366.2 0 350.1 0 332.6V184H.2z'
      
    ]
  };

  

  
  

  var faToiletsPortable = {
    prefix: 'fat',
    iconName: 'toilets-portable',
    icon: [
      576,
      512,
      [],
      'e584',
      
      'M56 16H200c22.1 0 40 17.9 40 40V96H16V56c0-22.1 17.9-40 40-40zm184 96V448H16V112H240zM16 504V464H240v40c0 4.4 3.6 8 8 8s8-3.6 8-8V56c0-30.9-25.1-56-56-56H56C25.1 0 0 25.1 0 56V504c0 4.4 3.6 8 8 8s8-3.6 8-8zM176 240v64c0 13.3 10.7 24 24 24h16c4.4 0 8-3.6 8-8s-3.6-8-8-8H200c-4.4 0-8-3.6-8-8V240c0-4.4 3.6-8 8-8h16c4.4 0 8-3.6 8-8s-3.6-8-8-8H200c-13.3 0-24 10.7-24 24zM376 16H520c22.1 0 40 17.9 40 40V96H336V56c0-22.1 17.9-40 40-40zm184 96V448H336V112H560zM336 504V464H560v40c0 4.4 3.6 8 8 8s8-3.6 8-8V56c0-30.9-25.1-56-56-56H376c-30.9 0-56 25.1-56 56V504c0 4.4 3.6 8 8 8s8-3.6 8-8zM496 240v64c0 13.3 10.7 24 24 24h16c4.4 0 8-3.6 8-8s-3.6-8-8-8H520c-4.4 0-8-3.6-8-8V240c0-4.4 3.6-8 8-8h16c4.4 0 8-3.6 8-8s-3.6-8-8-8H520c-13.3 0-24 10.7-24 24z'
      
    ]
  };

  

  
  

  var faSunPlantWilt = {
    prefix: 'fat',
    iconName: 'sun-plant-wilt',
    icon: [
      640,
      512,
      [],
      'e57a',
      
      'M160 0c-2.9 0-5.6 1.6-7 4.2L120.5 64.5 54.8 44.9c-2.8-.8-5.9-.1-8 2s-2.9 5.1-2 8l19.7 65.6L4.2 153c-2.6 1.4-4.2 4.1-4.2 7s1.6 5.6 4.2 7l60.3 32.5L44.9 265.2c-.8 2.8-.1 5.9 2 8s5.1 2.9 8 2l65.6-19.7L153 315.8c1.4 2.6 4.1 4.2 7 4.2s5.6-1.6 7-4.2l32.5-60.3 65.6 19.7c2.8 .8 5.9 .1 8-2s2.9-5.1 2-8l-19.7-65.6L315.8 167c2.6-1.4 4.2-4.1 4.2-7s-1.6-5.6-4.2-7l-60.3-32.5 19.7-65.6c.8-2.8 .1-5.9-2-8s-5.1-2.9-8-2L199.5 64.5 167 4.2c-1.4-2.6-4.1-4.2-7-4.2zm0 24.9l28.6 53c1.8 3.3 5.7 5 9.3 3.9l57.7-17.3-17.3 57.7c-1.1 3.6 .5 7.5 3.9 9.3l53 28.6-53 28.6c-3.3 1.8-5 5.7-3.9 9.3l17.3 57.7-57.7-17.3c-3.6-1.1-7.5 .5-9.3 3.9l-28.6 53-28.6-53c-1.8-3.3-5.7-5-9.3-3.9L64.4 255.6l17.3-57.7c1.1-3.6-.5-7.5-3.9-9.3L24.9 160l53-28.6c3.3-1.8 5-5.7 3.9-9.3L64.4 64.4l57.7 17.3c3.6 1.1 7.5-.5 9.3-3.9l28.6-53zm48.6 136.3a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-48-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM496 160c0-22.1 17.9-40 40-40s40 17.9 40 40v56.5c-12.6 1.5-23.8 6.6-32.3 15.1c-10.2 10.3-15.7 25-15.7 42.5c0 12.1 6.4 26.9 15.3 41.1c9.1 14.5 21.5 29.7 35.2 42.6c3.1 2.9 7.9 2.9 11 0c13.7-13 26.2-28.2 35.2-42.7c8.9-14.2 15.3-29.1 15.3-41c0-17.5-5.5-32.1-15.7-42.5c-8.5-8.6-19.6-13.6-32.3-15.1V160c0-30.9-25.1-56-56-56s-56 25.1-56 56v56.2c-12.5-14.8-31.1-24.2-52-24.2c-37.6 0-68 30.4-68 68v20.5c-12.6 1.5-23.8 6.6-32.3 15.1c-10.2 10.3-15.7 25-15.7 42.5c0 12.1 6.4 26.9 15.3 41.1c9.1 14.5 21.5 29.7 35.2 42.6c3.1 2.9 7.9 2.9 11 0c13.7-13 26.2-28.2 35.2-42.7c8.9-14.2 15.3-29.1 15.3-41c0-17.5-5.5-32.1-15.7-42.5c-8.5-8.6-19.6-13.6-32.3-15.1V260c0-28.7 23.3-52 52-52s52 23.3 52 52v20V496H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H488 632c4.4 0 8-3.6 8-8s-3.6-8-8-8H496V280 260 160zm88 72c12.3 0 22.2 4 28.9 10.8S624 260 624 274c0 7.3-4.3 18.9-12.9 32.6C604 318 594.6 330 584 340.8c-10.6-10.8-20.1-22.7-27.1-34.1C548.3 293.1 544 281.5 544 274c0-14.1 4.4-24.4 11.1-31.2S571.7 232 584 232zM395.1 370.6C388 382 378.6 394 368 404.8c-10.6-10.8-20.1-22.7-27.1-34.1c-8.5-13.6-12.8-25.3-12.8-32.7c0-14.1 4.4-24.4 11.1-31.2S355.7 296 368 296s22.2 4 28.9 10.8s11.1 17.2 11.1 31.2c0 7.3-4.3 18.9-12.9 32.6z'
      
    ]
  };

  

  
  

  var faListMusic = {
    prefix: 'fat',
    iconName: 'list-music',
    icon: [
      512,
      512,
      [],
      'f8c9',
      
      'M496 16.4L389.5 51.9c-3.3 1.1-5.5 4.1-5.5 7.6V174.3L490.5 140c3.3-1.1 5.5-4.1 5.5-7.6V16.4zM384 190.7V432c0 44.2-50.1 80-112 80s-112-35.8-112-80s50.1-80 112-80c40.7 0 76.4 15.5 96 38.8V59.5c0-10.3 6.6-19.5 16.4-22.8l108-36c1.5-.5 3.1-.8 4.7-.8C505.3 0 512 6.7 512 14.9V132.3c0 10.4-6.7 19.6-16.6 22.8L386.5 190.3c-.8 .3-1.6 .4-2.5 .4zM341.9 388.5C324.6 376.1 300 368 272 368s-52.6 8.1-69.9 20.5c-17.3 12.3-26.1 28-26.1 43.5s8.8 31.2 26.1 43.5C219.4 487.9 244 496 272 496s52.6-8.1 69.9-20.5c17.3-12.3 26.1-28 26.1-43.5s-8.8-31.2-26.1-43.5zM8 64H280c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8zM8 192H280c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8zM8 320H152c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faScissors = {
    prefix: 'fat',
    iconName: 'scissors',
    icon: [
      512,
      512,
      [9984,9986,9988,"cut"],
      'f0c4',
      
      'M510.1 445.2c2.9-3.4 2.4-8.4-.9-11.3l-179.6-152c-3.4-2.9-8.4-2.4-11.3 .9s-2.4 8.4 .9 11.3l179.6 152c3.4 2.9 8.4 2.4 11.3-.9zM286.5 245.5l-82.5-69.8C216.6 157.7 224 135.7 224 112C224 50.1 173.9 0 112 0S0 50.1 0 112s50.1 112 112 112c32.4 0 61.6-13.8 82.1-35.8L274.2 256l-80.1 67.8c-20.5-22-49.6-35.8-82.1-35.8C50.1 288 0 338.1 0 400s50.1 112 112 112s112-50.1 112-112c0-23.7-7.4-45.7-19.9-63.8L509.2 78.1c3.4-2.9 3.8-7.9 .9-11.3s-7.9-3.8-11.3-.9L286.5 245.5zM112 208a96 96 0 1 1 0-192 96 96 0 1 1 0 192zm0 96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z'
      
    ]
  };

  
    var faCut = faScissors;
  

  
  

  var faSquareCaretRight = {
    prefix: 'fat',
    iconName: 'square-caret-right',
    icon: [
      448,
      512,
      ["caret-square-right"],
      'f152',
      
      'M432 96c0-26.5-21.5-48-48-48L64 48C37.5 48 16 69.5 16 96l0 320c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM320 256c0 7.3-3 14.3-8.4 19.3L202.4 377.2c-4.7 4.4-10.8 6.8-17.2 6.8c-13.9 0-25.2-11.3-25.2-25.2l0-205.6c0-13.9 11.3-25.2 25.2-25.2c6.4 0 12.5 2.4 17.2 6.8L311.6 236.7c5.4 5 8.4 12 8.4 19.3zM176 153.2l0 205.6c0 5.1 4.1 9.2 9.2 9.2c2.3 0 4.6-.9 6.3-2.5L300.7 263.6c2.1-2 3.3-4.7 3.3-7.6s-1.2-5.6-3.3-7.6L191.5 146.5c-1.7-1.6-4-2.5-6.3-2.5c-5.1 0-9.2 4.1-9.2 9.2z'
      
    ]
  };

  
    var faCaretSquareRight = faSquareCaretRight;
  

  
  

  var faTombstone = {
    prefix: 'fat',
    iconName: 'tombstone',
    icon: [
      448,
      512,
      [],
      'f720',
      
      'M400 464V192c0-97.2-78.8-176-176-176S48 94.8 48 192V464H32V192C32 86 118 0 224 0S416 86 416 192V464H400zM0 504c0-4.4 3.6-8 8-8H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8zM232 136v72h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H232V376c0 4.4-3.6 8-8 8s-8-3.6-8-8V224H136c-4.4 0-8-3.6-8-8s3.6-8 8-8h80V136c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faMarsAndVenusBurst = {
    prefix: 'fat',
    iconName: 'mars-and-venus-burst',
    icon: [
      640,
      512,
      [],
      'e523',
      
      'M512 8c0 4.4 3.6 8 8 8h92.7l-97.2 97.2C486.3 82.9 445.4 64 400 64c-88.4 0-160 71.6-160 160c0 85.7 67.4 155.6 152 159.8l0 .2v48H344c-4.4 0-8 3.6-8 8s3.6 8 8 8h48v56c0 4.4 3.6 8 8 8s8-3.6 8-8V448h48c4.4 0 8-3.6 8-8s-3.6-8-8-8H408V384l0-.2c84.6-4.2 152-74.1 152-159.8c0-37.2-12.7-71.5-34-98.7l98-98V120c0 4.4 3.6 8 8 8s8-3.6 8-8V8c0-4.4-3.6-8-8-8H520c-4.4 0-8 3.6-8 8zM256 224a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zM161.5 20.5L130.1 88.7l-72.9-18C43.9 67.4 32.9 81.2 39.1 93.4L73 160.8l-53.7 46c-10 8.5-6 24.8 6.8 27.8l67.2 15.3L92 325c-.2 13.7 15.7 21.3 26.2 12.6L176 289.8l57.9 47.9c4.2 3.5 9.3 4.4 13.8 3.3c-6.5-8.5-12.3-17.5-17.3-26.9l-49.2-40.7c-3-2.4-7.2-2.4-10.2 0l-63 52.1 1.5-81.7c.1-3.8-2.5-7.1-6.2-7.9L29.7 218.9l58.5-50.1c2.8-2.4 3.6-6.4 1.9-9.7l-36.8-73 79.3 19.6c3.7 .9 7.6-.9 9.2-4.4L176 27.2l34.1 74.2c1.6 3.5 5.5 5.3 9.2 4.4l37-9.1c7.1-8 14.9-15.5 23.3-22.2L221.9 88.7 190.5 20.5c-5.7-12.4-23.4-12.4-29.1 0z'
      
    ]
  };

  

  
  

  var faFaceAngryHorns = {
    prefix: 'fat',
    iconName: 'face-angry-horns',
    icon: [
      640,
      512,
      [],
      'e368',
      
      'M320 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496c141.4 0 256-114.6 256-256c0-27.9-4.5-54.8-12.7-79.9C616.4 111.7 634 38.9 639.8 9.6c.6-3.2-.7-6.4-3.4-8.2s-6.2-1.8-8.9 0C607.3 14.9 577.1 26.5 547 35.4c-27.3 8.2-53.8 14-71.6 17.2C432.4 19.6 378.5 0 320 0S207.6 19.6 164.5 52.6c-17.7-3.2-44.3-9-71.6-17.2c-30-9-60.2-20.6-80.5-34.1C9.7-.5 6.2-.4 3.5 1.4S-.5 6.4 .2 9.6C6 38.9 23.6 111.7 76.7 176.1C68.5 201.2 64 228.1 64 256c0 141.4 114.6 256 256 256zM556.8 158.6c-14.7-35.7-37.2-67.3-65.4-92.7c17-3.5 38.4-8.5 60.2-15.1c23.6-7.1 48.3-16 68.6-26.6c-8 32.4-25.5 85.4-63.4 134.4zM88.4 50.8c21.8 6.5 43.2 11.6 60.2 15.1c-28.2 25.4-50.7 57.1-65.4 92.7C45.3 109.6 27.8 56.6 19.8 24.2C40.1 34.8 64.7 43.7 88.4 50.8zm309 363.2c3.3-3 3.5-8 .6-11.3c-15-16.7-41-34.6-77.9-34.6s-62.9 18-77.9 34.6c-3 3.3-2.7 8.3 .6 11.3s8.3 2.7 11.3-.6C266.7 399.1 288.7 384 320 384s53.3 15.1 66.1 29.4c3 3.3 8 3.6 11.3 .6zM240.4 288a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm176-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM194.5 200.4c-4.2-1.4-8.7 .9-10.1 5.1s.9 8.7 5.1 10.1l96 32c4.2 1.4 8.7-.9 10.1-5.1s-.9-8.7-5.1-10.1l-96-32zm256 15.2c4.2-1.4 6.5-5.9 5.1-10.1s-5.9-6.5-10.1-5.1l-96 32c-4.2 1.4-6.5 5.9-5.1 10.1s5.9 6.5 10.1 5.1l96-32z'
      
    ]
  };

  

  
  

  var faSignPost = {
    prefix: 'fat',
    iconName: 'sign-post',
    icon: [
      512,
      512,
      [],
      'e624',
      
      'M248 8c0-4.4 3.6-8 8-8s8 3.6 8 8V64H417c9.5 0 18.5 4.2 24.6 11.5l61.9 74.2c4.9 5.9 4.9 14.6 0 20.5l-61.9 74.2c-6.1 7.3-15.1 11.5-24.6 11.5H264V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V256H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H248V8zM429.3 85.8c-3-3.6-7.5-5.8-12.3-5.8H64c-8.8 0-16 7.2-16 16V224c0 8.8 7.2 16 16 16H417c4.7 0 9.3-2.1 12.3-5.8L491.2 160 429.3 85.8z'
      
    ]
  };

  

  
  

  var faPeopleArrows = {
    prefix: 'fat',
    iconName: 'people-arrows',
    icon: [
      640,
      512,
      ["people-arrows-left-right"],
      'e068',
      
      'M128 112a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM128 0a64 64 0 1 1 0 128A64 64 0 1 1 128 0zM105.6 176c-33.3 0-61 25.5-63.8 58.7L37.7 284c-2.3 28 19.8 52 47.8 52H112h31.4l16 16H152V480c0 8.8 7.2 16 16 16s16-7.2 16-16V376.6l16 16V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H120V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V344.8c-22.1-11.5-36.4-35.4-34.2-62.1l4.1-49.3C29.3 191.9 64 160 105.6 160h44.8c28.7 0 54.1 15.2 68.2 38.2c-2.4 1.6-4.8 3.4-6.9 5.5l-5.3 5.3c-11-19.8-32-33-56-33H105.6zM440 480V392.6l16-16V480c0 8.8 7.2 16 16 16s16-7.2 16-16V352h-7.4l16-16H528h26.4c28.1 0 50.2-24 47.8-52l-4.1-49.3c-2.8-33.2-30.5-58.7-63.8-58.7H489.6c-24 0-45.1 13.2-56 33l-5.3-5.3c-2.1-2.1-4.4-4-6.9-5.5c14.1-23 39.5-38.2 68.2-38.2h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.2 26.7-12.2 50.6-34.2 62.1V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H504V480c0 17.7-14.3 32-32 32s-32-14.3-32-32zM104 352H85.6c-4.7 0-9.2-.5-13.6-1.4V480c0 8.8 7.2 16 16 16s16-7.2 16-16V352zM512 112a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM512 0a64 64 0 1 1 0 128A64 64 0 1 1 512 0zm56 480V350.6c-4.4 .9-8.9 1.4-13.6 1.4H536V480c0 8.8 7.2 16 16 16s16-7.2 16-16zM245.7 237.7L187.3 296H452.7l-58.3-58.3c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l72 72c3.1 3.1 3.1 8.2 0 11.3l-72 72c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L452.7 312H187.3l58.3 58.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-72-72c-3.1-3.1-3.1-8.2 0-11.3l72-72c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3z'
      
    ]
  };

  
    var faPeopleArrowsLeftRight = faPeopleArrows;
  

  
  

  var faAlbumCollectionCirclePlus = {
    prefix: 'fat',
    iconName: 'album-collection-circle-plus',
    icon: [
      640,
      512,
      [],
      'e48e',
      
      'M64 0H448c17.7 0 32 14.3 32 32v8c0 4.4-3.6 8-8 8s-8-3.6-8-8V32c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16v8c0 4.4-3.6 8-8 8s-8-3.6-8-8V32C32 14.3 46.3 0 64 0zM16 112c0-17.7 14.3-32 32-32H464c17.7 0 32 14.3 32 32v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8zM4.2 212.6C1.5 184.4 23.7 160 52 160H460c21.2 0 38.9 13.6 45.4 32.2c-3.1-.2-6.2-.2-9.4-.2c-2.7 0-5.5 .1-8.2 .2C482.4 182.6 472 176 460 176H52c-18.9 0-33.6 16.2-31.9 35L44.5 467c1.6 16.4 15.4 29 31.9 29H375.2c6.1 5.8 12.7 11.1 19.6 16H76.4c-24.7 0-45.4-18.8-47.8-43.4L4.2 212.6zM256 208c45.1 0 86.3 12.7 117.4 33.7c-3.9 3.8-7.6 7.7-11.1 11.8C334.3 235.3 297.2 224 256 224c-45.5 0-86 13.8-114.9 35.5S96 309.7 96 340s16.3 58.9 45.1 80.5S210.5 456 256 456c29.2 0 56.3-5.7 79.6-15.5c2.2 4.9 4.6 9.7 7.3 14.3C317.2 465.8 287.6 472 256 472c-97.2 0-176-59.1-176-132s78.8-132 176-132zm25.8 160.6c-7.3 4.9-16.5 7.4-25.8 7.4s-18.5-2.5-25.8-7.4C223 363.8 216 355.4 216 344s7-19.8 14.2-24.6c7.3-4.9 16.5-7.4 25.8-7.4s18.5 2.5 25.8 7.4c7.2 4.8 14.2 13.2 14.2 24.6s-7 19.8-14.2 24.6zM256 360c13.3 0 24-7.2 24-16s-10.7-16-24-16s-24 7.2-24 16s10.7 16 24 16zm368 8a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm152-72v64h64c4.4 0 8 3.6 8 8s-3.6 8-8 8H504v64c0 4.4-3.6 8-8 8s-8-3.6-8-8V376H424c-4.4 0-8-3.6-8-8s3.6-8 8-8h64V296c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faSquareRoot = {
    prefix: 'fat',
    iconName: 'square-root',
    icon: [
      576,
      512,
      [8730],
      'f697',
      
      'M386.6 48c-17.2 0-32.5 11-37.9 27.4L215.6 474.5c-1 3.1-3.8 5.2-7 5.4s-6.3-1.5-7.7-4.4L89.7 253.3C85.6 245.1 77.3 240 68.2 240H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H68.2c15.2 0 29 8.6 35.8 22.1l102.5 205 127-380.9c7.6-22.9 29-38.3 53.1-38.3H568c4.4 0 8 3.6 8 8s-3.6 8-8 8H386.6z'
      
    ]
  };

  

  
  

  var faChessRookPiece = {
    prefix: 'fat',
    iconName: 'chess-rook-piece',
    icon: [
      320,
      512,
      ["chess-rook-alt"],
      'f448',
      
      'M32 120c0-4.4 3.6-8 8-8H64c4.4 0 8 3.6 8 8v16c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V120c0-4.4 3.6-8 8-8h31.5c4.4 0 8 3.6 8 8v16c0 13.3 10.7 24 24 24H224c13.3 0 24-10.7 24-24V120c0-4.4 3.6-8 8-8h24c4.4 0 8 3.6 8 8V226.2c0 1.9-.7 3.7-1.9 5.1l-36.3 43.5c-1.3 1.6-2 3.6-1.8 5.6L254.5 384h16l-6.3-101.3 34.3-41.1c3.6-4.3 5.6-9.7 5.6-15.4V120c0-13.3-10.7-24-24-24H256c-13.3 0-24 10.7-24 24v16c0 4.4-3.6 8-8 8H207.5c-4.4 0-8-3.6-8-8V120c0-13.3-10.7-24-24-24H144c-13.3 0-24 10.7-24 24v16c0 4.4-3.6 8-8 8H96c-4.4 0-8-3.6-8-8V120c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24V226.2c0 5.6 2 11.1 5.6 15.4l34.3 41.1L49.5 384h16L72 280.5c.1-2-.5-4.1-1.8-5.6L33.9 231.3c-1.2-1.4-1.9-3.2-1.9-5.1V120zm4.7 306.1L4.5 471.2C1.6 475.2 0 480.1 0 485.1V488c0 13.3 10.7 24 24 24H296c13.3 0 24-10.7 24-24v-2.9c0-5-1.6-9.9-4.5-13.9l-32.2-45.1c-4.5-6.3-11.8-10.1-19.5-10.1H56.2c-7.8 0-15 3.7-19.5 10.1zM56.2 432H263.8c2.6 0 5 1.2 6.5 3.4l32.2 45.1c1 1.4 1.5 3 1.5 4.6V488c0 4.4-3.6 8-8 8H24c-4.4 0-8-3.6-8-8v-2.9c0-1.7 .5-3.3 1.5-4.6l32.2-45.1c1.5-2.1 3.9-3.4 6.5-3.4zM160 224c-17.7 0-32 14.3-32 32v40c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V256c0-17.7-14.3-32-32-32zm-16 32c0-8.8 7.2-16 16-16s16 7.2 16 16v32H144V256z'
      
    ]
  };

  
    var faChessRookAlt = faChessRookPiece;
  

  
  

  var faArrowProgress = {
    prefix: 'fat',
    iconName: 'arrow-progress',
    icon: [
      512,
      512,
      [],
      'e5df',
      
      'M448 16a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112A64 64 0 1 0 448 0a64 64 0 1 0 0 128zM104 56C46.6 56 0 102.6 0 160s46.6 104 104 104H408c48.6 0 88 39.4 88 88c0 46.1-35.4 83.9-80.5 87.7C411.4 408.3 384.5 384 352 384c-35.3 0-64 28.7-64 64s28.7 64 64 64c32.7 0 59.7-24.6 63.5-56.3C469.5 451.9 512 406.9 512 352c0-57.4-46.6-104-104-104H104c-48.6 0-88-39.4-88-88s39.4-88 88-88H320l-44.8 33.6c-3.5 2.7-4.3 7.7-1.6 11.2s7.7 4.3 11.2 1.6l64-48c2-1.5 3.2-3.9 3.2-6.4s-1.2-4.9-3.2-6.4l-64-48c-3.5-2.7-8.5-1.9-11.2 1.6s-1.9 8.5 1.6 11.2L320 56H104zm23.5 384c-3.9-31.6-30.9-56-63.5-56c-35.3 0-64 28.7-64 64s28.7 64 64 64c32.6 0 59.6-24.4 63.5-56H224l-44.8 33.6c-3.5 2.6-4.3 7.7-1.6 11.2s7.7 4.2 11.2 1.6l64-48c2-1.5 3.2-3.9 3.2-6.4s-1.2-4.9-3.2-6.4l-64-48c-3.5-2.6-8.5-1.9-11.2 1.6s-1.9 8.6 1.6 11.2L224 440H127.5zM16 448a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  

  
  

  var faFileMp3 = {
    prefix: 'fat',
    iconName: 'file-mp3',
    icon: [
      512,
      512,
      [],
      'e648',
      
      'M64 496H80v16H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H204.1c12.7 0 24.9 5.1 33.9 14.1L369.9 145.9c9 9 14.1 21.2 14.1 33.9V304H368V179.9c0-1.3-.1-2.6-.2-3.9H248c-22.1 0-40-17.9-40-40V16.2c-1.3-.2-2.6-.2-3.9-.2H64C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48zM361.1 160c-.8-1-1.6-1.9-2.4-2.7L226.7 25.4c-.9-.9-1.8-1.7-2.7-2.4V136c0 13.3 10.7 24 24 24H361.1zM141.7 368.3c3.4-1 7 .3 9 3.2l41.3 62 41.3-62c2-2.9 5.6-4.2 9-3.2s5.7 4.1 5.7 7.7V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V402.4l-33.3 50c-1.5 2.2-4 3.6-6.7 3.6s-5.2-1.3-6.7-3.6l-33.3-50V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V376c0-3.5 2.3-6.6 5.7-7.7zM296 376c0-4.4 3.6-8 8-8h32c26.5 0 48 21.5 48 48s-21.5 48-48 48H312v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V456 376zm16 72h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H312v64zm152 64H432c-4.4 0-8-3.6-8-8s3.6-8 8-8h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H440c-4.4 0-8-3.6-8-8s3.6-8 8-8h24c13.3 0 24-10.7 24-24s-10.7-24-24-24H432c-4.4 0-8-3.6-8-8s3.6-8 8-8h32c22.1 0 40 17.9 40 40c0 13.1-6.3 24.7-16 32c9.7 7.3 16 18.9 16 32c0 22.1-17.9 40-40 40z'
      
    ]
  };

  

  
  

  var faPenRuler = {
    prefix: 'fat',
    iconName: 'pen-ruler',
    icon: [
      512,
      512,
      ["pencil-ruler"],
      'f5ae',
      
      'M440.2 25.9c-12.5-12.5-32.8-12.5-45.3 0L328.1 92.8l91.1 91.1L486.1 117c12.5-12.5 12.5-32.8 0-45.3L440.2 25.9zM73.6 347.3c-10.4 10.4-18 23.3-22.2 37.4L19.8 492.2l107.5-31.6c14.1-4.2 27-11.8 37.4-22.2L407.9 195.2l-91.1-91.1L73.6 347.3zm310-332.7c18.7-18.7 49.1-18.7 67.9 0l45.8 45.8c18.7 18.7 18.7 49.1 0 67.9L176 449.7c-12.3 12.3-27.5 21.3-44.2 26.2L10.3 511.7c-2.8 .8-5.8 .1-7.9-2s-2.8-5.1-2-7.9L36.1 380.2C41 363.5 50 348.3 62.3 336L383.7 14.6zM156.3 33c-15.6-15.6-40.9-15.6-56.6 0L33 99.7c-15.6 15.6-15.6 40.9 0 56.6l76.5 76.5L98.2 244.1 21.7 167.6c-21.9-21.9-21.9-57.3 0-79.2L88.4 21.7c21.9-21.9 57.3-21.9 79.2 0l76.5 76.5-11.3 11.3L195.3 72l-53.7 53.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L184 60.7 156.3 33zM267.9 413.8l11.3-11.3L355.7 479c15.6 15.6 40.9 15.6 56.6 0L479 412.3c15.6-15.6 15.6-40.9 0-56.6L451.3 328l-53.7 53.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L440 316.7l-37.5-37.5 11.3-11.3 76.5 76.5c21.9 21.9 21.9 57.3 0 79.2l-66.7 66.7c-21.9 21.9-57.3 21.9-79.2 0l-76.5-76.5z'
      
    ]
  };

  
    var faPencilRuler = faPenRuler;
  

  
  

  var faBellConcierge = {
    prefix: 'fat',
    iconName: 'bell-concierge',
    icon: [
      512,
      512,
      [128718,"concierge-bell"],
      'f562',
      
      'M200 64c-4.4 0-8 3.6-8 8s3.6 8 8 8h48v64.1C128 148.4 32 247 32 368v32H48V368c0-114.9 93.1-208 208-208s208 93.1 208 208v32h16V368c0-121-96-219.6-216-223.9V80h48c4.4 0 8-3.6 8-8s-3.6-8-8-8H256 200zM8 432c-4.4 0-8 3.6-8 8s3.6 8 8 8H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H8z'
      
    ]
  };

  
    var faConciergeBell = faBellConcierge;
  

  
  

  var faMessagePen = {
    prefix: 'fat',
    iconName: 'message-pen',
    icon: [
      512,
      512,
      ["comment-alt-edit","message-edit"],
      'f4a4',
      
      'M176 416c0-8.8-7.2-16-16-16H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H309.3c-3.5 0-6.8 1.1-9.6 3.2L176 496V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h80 16v16 64c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM164.6 299.4c4 4 9.7 5.6 15.2 4.2l36.7-9.2c5.6-1.4 10.8-4.3 14.9-8.4L341 176.4c14.7-14.7 14.7-38.6 0-53.4s-38.6-14.7-53.4 0L178 232.6c-4.1 4.1-7 9.2-8.4 14.9l-9.2 36.7c-1.4 5.5 .2 11.2 4.2 15.2zm15.7-28.9l4.8-19.1c.7-2.8 2.2-5.4 4.2-7.4L275 158.3 305.7 189 220 274.7c-2.1 2.1-4.6 3.5-7.4 4.2l-19.1 4.8-17.6 4.4 4.4-17.6zM329.7 165.1L317 177.7 286.3 147l12.6-12.6c8.5-8.5 22.3-8.5 30.7 0s8.5 22.3 0 30.7z'
      
    ]
  };

  
    var faCommentAltEdit = faMessagePen;
  
    var faMessageEdit = faMessagePen;
  

  
  

  var faBadge = {
    prefix: 'fat',
    iconName: 'badge',
    icon: [
      512,
      512,
      [],
      'f335',
      
      'M256 16c-32.6 0-60.9 18.3-75.2 45.2c-1.8 3.4-5.7 5-9.4 3.9c-29.1-8.9-62.1-1.9-85.1 21.1s-30.1 56-21.1 85.1c1.1 3.7-.5 7.6-3.9 9.4C34.3 195.1 16 223.4 16 256s18.3 60.9 45.2 75.2c3.4 1.8 5 5.8 3.9 9.4c-8.9 29.1-1.9 62.1 21.1 85.1s56 30.1 85.1 21.1c3.7-1.1 7.6 .5 9.4 3.9C195.1 477.7 223.4 496 256 496s60.9-18.3 75.2-45.2c1.8-3.4 5.8-5 9.4-3.9c29.1 8.9 62.1 1.9 85.1-21.1s30.1-56 21.1-85.1c-1.1-3.7 .5-7.6 3.9-9.4C477.7 316.9 496 288.6 496 256s-18.3-60.9-45.2-75.2c-3.4-1.8-5-5.7-3.9-9.4c8.9-29.1 1.9-62.1-21.1-85.1s-56-30.1-85.1-21.1c-3.7 1.1-7.6-.5-9.4-3.9C316.9 34.3 288.6 16 256 16zM169.9 48.2C187.7 19.3 219.6 0 256 0s68.3 19.3 86.1 48.2c33-7.9 69.2 1.1 94.9 26.8s34.7 62 26.8 94.9C492.7 187.7 512 219.6 512 256s-19.3 68.3-48.2 86.1c7.9 33-1.1 69.2-26.8 94.9s-61.9 34.7-94.9 26.8C324.3 492.7 292.4 512 256 512s-68.3-19.3-86.1-48.2c-33 7.9-69.2-1.1-94.9-26.8s-34.7-61.9-26.8-94.9C19.3 324.3 0 292.4 0 256s19.3-68.3 48.2-86.1c-7.9-33 1.1-69.2 26.8-94.9s61.9-34.7 94.9-26.8z'
      
    ]
  };

  

  
  

  var faSunglasses = {
    prefix: 'fat',
    iconName: 'sunglasses',
    icon: [
      576,
      512,
      [128374],
      'f892',
      
      'M70.8 77.7c4.4-17.5 20-29.7 38-29.7c6.1 0 12.1 1.4 17.5 4.1l22 11c4 2 8.8 .4 10.7-3.6s.4-8.8-3.6-10.7l-22-11C125.9 34 117.4 32 108.9 32C83.5 32 61.4 49.2 55.3 73.8L6 271.1C3 282.9 1.2 294.9 .4 306.9c-.3 1.7-.4 3.4-.4 5.1v7.6V336v32c0 61.9 50.1 112 112 112h44.3c59.4 0 108.5-46.4 111.8-105.8l3.8-60.4c.2-3.3-.2-6.6-1-9.8h34c-.8 3.1-1.2 6.4-1 9.8l3.8 60.4C311.1 433.6 360.2 480 419.7 480H464c61.9 0 112-50.1 112-112V336 319.6 312c0-1.7-.1-3.4-.4-5.1c-.8-12.1-2.6-24-5.6-35.8L520.7 73.8C514.6 49.2 492.5 32 467.1 32c-8.6 0-17 2-24.7 5.8l-22 11c-4 2-5.6 6.8-3.6 10.7s6.8 5.6 10.7 3.6l22-11c5.4-2.7 11.4-4.1 17.5-4.1c18 0 33.7 12.2 38 29.7L554.5 275c.6 2.4 1.2 4.9 1.7 7.3C520.6 265.2 479.5 256 440.3 256c-40.1 0-82.2 9.6-118.5 27.3c-2.7 1.4-5.2 3.1-7.4 5.1c-.8-.2-1.6-.4-2.4-.4H264c-.8 0-1.7 .1-2.4 .4c-2.2-2-4.7-3.7-7.4-5.1C217.9 265.6 175.8 256 135.7 256c-39.1 0-80.3 9.2-115.9 26.3c.5-2.5 1.1-4.9 1.7-7.3L70.8 77.7zM16 319.6c0-3.6 .1-7.2 .3-10.8c1-4.7 4-8.9 8.5-11.1C58.5 281 98.1 272 135.7 272c37.7 0 77.4 9 111.4 25.7c5.7 2.9 9.2 8.9 8.9 15.2l-3.8 60.4 0 0 0 .1c-2.8 50.9-44.9 90.7-95.9 90.7H112c-16.8 0-32.6-4.3-46.4-11.9l114.2-61c3.9-2.1 5.4-6.9 3.3-10.8s-6.9-5.4-10.8-3.3l-116 62-5.5 3c-13.6-11.3-24-26.3-29.8-43.4l110.6-55.3c4-2 5.6-6.8 3.6-10.7s-6.8-5.6-10.7-3.6L17.1 382.5c-.7-4.7-1.1-9.6-1.1-14.5V336 319.6zm535.2-21.9c4.4 2.2 7.5 6.4 8.5 11.1c.2 3.6 .3 7.2 .3 10.8V336v32c0 53-43 96-96 96H419.7c-17.5 0-34-4.7-48.2-12.9l112.3-60c3.9-2.1 5.4-6.9 3.3-10.8s-6.9-5.4-10.8-3.3l-116 62-3.3 1.7c-13.3-11.5-23.4-26.6-28.9-43.8l107.5-53.7c4-2 5.6-6.8 3.6-10.7s-6.8-5.6-10.7-3.6L324.5 380.8c-.3-2.5-.6-4.9-.7-7.5l0-.1 0 0L320 312.8c-.3-6.3 3.2-12.3 8.9-15.2c34-16.6 73.7-25.7 111.4-25.7c37.5 0 77.2 9 110.9 25.7z'
      
    ]
  };

  

  
  

  var faTireFlat = {
    prefix: 'fat',
    iconName: 'tire-flat',
    icon: [
      512,
      512,
      [],
      'f632',
      
      'M496 288C496 155.5 388.5 48 256 48S16 155.5 16 288c0 42.4 11 82.2 30.3 116.8c6 10.8 2.5 23.4-5.8 30.3L25.9 447.2c-6.3 5.2-9.9 13-9.9 21.2C16 483.6 28.4 496 43.6 496H132 380h88.4c15.2 0 27.6-12.4 27.6-27.6c0-8.2-3.6-15.9-9.9-21.2l-14.5-12.1c-8.3-6.9-11.9-19.5-5.8-30.3C485 370.2 496 330.4 496 288zm16 0c0 45.2-11.7 87.7-32.3 124.6c-1.9 3.4-.9 7.7 2.1 10.2l14.5 12.1c9.9 8.3 15.7 20.5 15.7 33.5c0 24.1-19.5 43.6-43.6 43.6H380 132 43.6C19.5 512 0 492.5 0 468.4c0-12.9 5.7-25.2 15.7-33.5l14.5-12.1c3-2.5 4-6.8 2.1-10.2C11.7 375.7 0 333.2 0 288C0 146.6 114.6 32 256 32s256 114.6 256 256zm-112 0c0-45-20.6-85.2-52.9-111.6l-47.2 65C312.3 253.1 320 269.6 320 288c0 4.1-.4 8.2-1.1 12.1L395.2 325c3.1-11.8 4.8-24.2 4.8-37zm-86.1 27.3c-9.2 19.4-27.8 33.5-50 36.2l0 80.3c57.7-3.2 106.3-40.2 126.3-91.6l-76.4-24.9zm-66 36.2c-22.1-2.8-40.7-16.8-49.8-36.2l-76.4 24.9c20 51.4 68.6 88.4 126.2 91.6l0-80.3zM112 288c0 12.8 1.7 25.2 4.8 37l76.4-24.9c-.8-3.9-1.1-8-1.1-12.1c0-18.4 7.7-34.9 20.1-46.6l-9.2-12.7-38-52.3C132.6 202.8 112 243 112 288zm144-64c11.2 0 21.8 2.9 31 8l47.1-65c-22.5-14.6-49.3-23-78.1-23s-55.6 8.5-78.1 23l38 52.3L225 232c9.2-5.1 19.7-8 31-8zM96 288a160 160 0 1 1 320 0A160 160 0 1 1 96 288zm208 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  

  
  

  var faTreeChristmas = {
    prefix: 'fat',
    iconName: 'tree-christmas',
    icon: [
      448,
      512,
      [127876],
      'f7db',
      
      'M222 17.3L204.7 56.6c-.8 1.8-2.3 3.3-4.1 4.1L161.3 78c-.8 .4-1.3 1.2-1.3 2s.5 1.7 1.3 2l39.2 17.3c1.8 .8 3.3 2.3 4.1 4.1L222 142.7c.4 .8 1.2 1.3 2 1.3s1.7-.5 2-1.3l17.3-39.2c.8-1.8 2.3-3.3 4.1-4.1L286.7 82c.8-.4 1.3-1.2 1.3-2s-.5-1.7-1.3-2L247.4 60.7c-1.8-.8-3.3-2.3-4.1-4.1L226 17.3c-.4-.8-1.2-1.3-2-1.3s-1.7 .5-2 1.3zM224 0c7.2 0 13.8 4.3 16.7 10.9l16.1 36.4 36.4 16.1C299.7 66.2 304 72.8 304 80s-4.3 13.8-10.9 16.7l-36.4 16.1-16.1 36.4c-2.9 6.6-9.5 10.9-16.7 10.9s-13.8-4.3-16.7-10.9l-16.1-36.4L154.9 96.7C148.3 93.8 144 87.2 144 80s4.3-13.8 10.9-16.7l36.4-16.1 16.1-36.4C210.2 4.3 216.8 0 224 0zM167 137l2.1 4.7L42.7 313.5c-1.8 2.4-2.7 5.4-2.7 8.4c0 7.8 6.3 14.1 14.1 14.1H94.9c3 0 5.7 1.6 7.1 4.2s1.2 5.8-.4 8.2L18.5 473.1c-1.6 2.4-2.5 5.3-2.5 8.2c0 8.1 6.6 14.7 14.7 14.7H417.3c8.1 0 14.7-6.6 14.7-14.7c0-2.9-.9-5.7-2.5-8.2L346.4 348.4c-1.6-2.5-1.8-5.6-.4-8.2s4.1-4.2 7.1-4.2h40.8c7.8 0 14.1-6.3 14.1-14.1c0-3-1-5.9-2.7-8.4L278.9 141.7 281 137l10.8-4.8L418.1 304c3.8 5.2 5.9 11.4 5.9 17.8c0 16.6-13.5 30.1-30.1 30.1H368l74.8 112.3c3.4 5 5.2 11 5.2 17c0 17-13.7 30.7-30.7 30.7H30.7C13.7 512 0 498.3 0 481.3c0-6.1 1.8-12 5.2-17L80 352H54.1C37.5 352 24 338.5 24 321.9c0-6.4 2.1-12.7 5.9-17.8L156.2 132.2 167 137zm-7 135a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM272 384a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faMotorcycle = {
    prefix: 'fat',
    iconName: 'motorcycle',
    icon: [
      640,
      512,
      [127949],
      'f21c',
      
      'M455.6 48H480c8.8 0 16 7.2 16 16V96c0 8.8-7.2 16-16 16H397.9L387.9 92.4l58.5-41.5c2.7-1.9 5.9-2.9 9.2-2.9zm-49.5 80H480c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H455.6c-6.6 0-13.1 2.1-18.5 5.9L380.5 78 363.6 45c-4.1-8-12.4-13-21.4-13H264c-4.4 0-8 3.6-8 8s3.6 8 8 8h78.2c3 0 5.8 1.7 7.1 4.3l18 35-111.6 79-30.3-18.9c-20.3-12.7-43.9-19.5-67.8-19.5H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h47.8c94.2 0 171.7 74.2 175.8 168.4l.3 8c.2 4.3 3.7 7.7 8 7.7h48c4.4 0 8-3.6 8-8V352c0-59.2 32.2-110.9 79.9-138.6L446.6 242C409.1 264.3 384 305.2 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-18.2 0-35.5 3.8-51.2 10.6L406.1 128zM216.9 161l34.7 21.7c2.7 1.7 6.2 1.8 9-.2l114-80.8 50 97.4C371.7 229.5 336 286.6 336 352v8H303.7l0-.3C299.2 257 214.6 176 111.8 176H64c-8.8 0-16-7.2-16-16s7.2-16 16-16h93.6c21 0 41.6 5.9 59.4 17zm237 95.2l51 99.4c2 3.9 6.8 5.5 10.8 3.5s5.5-6.8 3.5-10.8l-51-99.4c13.5-5.7 28.3-8.9 43.9-8.9c61.9 0 112 50.1 112 112s-50.1 112-112 112s-112-50.1-112-112c0-40.6 21.6-76.1 53.9-95.8zM239.7 360c-4.1 58.1-52.6 104-111.7 104C66.1 464 16 413.9 16 352s50.1-112 112-112c59.2 0 107.6 45.9 111.7 104H191.5c-3.9-31.6-30.9-56-63.5-56c-35.3 0-64 28.7-64 64s28.7 64 64 64c32.6 0 59.6-24.4 63.5-56h48.2zm-64.4 0c-3.8 22.7-23.6 40-47.3 40c-26.5 0-48-21.5-48-48s21.5-48 48-48c23.8 0 43.5 17.3 47.3 40H128c-4.4 0-8 3.6-8 8s3.6 8 8 8h47.3zm80.7-8A128 128 0 1 0 0 352a128 128 0 1 0 256 0z'
      
    ]
  };

  

  
  

  var faChartBullet = {
    prefix: 'fat',
    iconName: 'chart-bullet',
    icon: [
      512,
      512,
      [],
      'e0e1',
      
      'M280 32c4.4 0 8 3.6 8 8V64H464c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H288v24c0 4.4-3.6 8-8 8s-8-3.6-8-8V224H48c-26.5 0-48-21.5-48-48V112C0 85.5 21.5 64 48 64H272V40c0-4.4 3.6-8 8-8zM160 80V208H272V80H160zm128 0V208H464c17.7 0 32-14.3 32-32V112c0-17.7-14.3-32-32-32H288zM144 80H48c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h96V80zM376 256c4.4 0 8 3.6 8 8v24h80c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H384v24c0 4.4-3.6 8-8 8s-8-3.6-8-8V448H48c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48H368V264c0-4.4 3.6-8 8-8zM224 304V432H368V304H224zm160 0V432h80c17.7 0 32-14.3 32-32V336c0-17.7-14.3-32-32-32H384zm-176 0H48c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H208V304z'
      
    ]
  };

  

  
  

  var faStarChristmas = {
    prefix: 'fat',
    iconName: 'star-christmas',
    icon: [
      512,
      512,
      [],
      'f7d4',
      
      'M256 16c-3.6 0-6.8 2.5-7.7 6L202.6 196.9c-.7 2.8-2.9 5-5.7 5.7L22 248.3c-3.5 .9-6 4.1-6 7.7s2.5 6.8 6 7.7l174.9 45.6c2.8 .7 5 2.9 5.7 5.7L248.3 490c.9 3.5 4.1 6 7.7 6s6.8-2.5 7.7-6l45.6-174.9c.7-2.8 2.9-5 5.7-5.7L490 263.7c3.5-.9 6-4.1 6-7.7s-2.5-6.8-6-7.7L315.1 202.6c-2.8-.7-5-2.9-5.7-5.7L263.7 22c-.9-3.5-4.1-6-7.7-6zm-23.2 1.9C235.5 7.4 245.1 0 256 0s20.5 7.4 23.2 17.9l44.4 170.4 170.4 44.4c10.6 2.8 17.9 12.3 17.9 23.2s-7.4 20.5-17.9 23.2L323.7 323.7 279.2 494.1C276.5 504.6 266.9 512 256 512s-20.5-7.4-23.2-17.9L188.3 323.7 17.9 279.2C7.4 276.5 0 266.9 0 256s7.4-20.5 17.9-23.2l170.4-44.4L232.8 17.9zM354.3 354.3c3.1-3.1 8.2-3.1 11.3 0l80 80c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-80-80c-3.1-3.1-3.1-8.2 0-11.3zm0-208l80-80c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-80 80c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3zm-288-80c3.1-3.1 8.2-3.1 11.3 0l80 80c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-80-80c-3.1-3.1-3.1-8.2 0-11.3zm0 368l80-80c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-80 80c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3z'
      
    ]
  };

  

  
  

  var faCircleC = {
    prefix: 'fat',
    iconName: 'circle-c',
    icon: [
      512,
      512,
      [],
      'e101',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.8 335.2c-43.7-43.7-43.7-114.7 0-158.4s114.7-43.7 158.4 0c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3c-50-50-131-50-181 0s-50 131 0 181s131 50 181 0c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0c-43.7 43.7-114.7 43.7-158.4 0z'
      
    ]
  };

  

  
  

  var faBoxTissue = {
    prefix: 'fat',
    iconName: 'box-tissue',
    icon: [
      512,
      512,
      [],
      'e05b',
      
      'M92.5 16H208c16.3 0 25.3 4.7 31.5 10.6c7.1 6.7 11.9 16 18.2 28.5l.5 1c5.7 11.3 12.8 25.5 24.3 36.5C295.3 104.7 312.3 112 336 112h85.2c6 0 10.8 4.8 10.8 10.8c0 1.4-.3 2.7-.8 4L369.1 282.1 360.4 304H148.5l-5-19.9L80.4 31.5c-.2-1-.4-2-.4-3C80 21.6 85.6 16 92.5 16zM408 304H377.6l6.4-16 62.1-155.2c1.3-3.2 1.9-6.6 1.9-10C448 108 436 96 421.2 96H336c-40 0-52-24-64-48S248 0 208 0H92.5C76.8 0 64 12.8 64 28.5c0 2.3 .3 4.7 .9 6.9L128 288l4 16H104c-4.4 0-8 3.6-8 8s3.6 8 8 8H408c4.4 0 8-3.6 8-8s-3.6-8-8-8zm29.7-64H464c17.7 0 32 14.3 32 32V384H16V272c0-17.7 14.3-32 32-32H83l-4-16H48c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H444.1l-6.4 16zM16 400H496v64c0 17.7-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V400z'
      
    ]
  };

  

  
  

  var faMicrophoneSlash = {
    prefix: 'fat',
    iconName: 'microphone-slash',
    icon: [
      640,
      512,
      [],
      'f131',
      
      'M387.6 401.1l-14.3-11.3C356.8 396.4 338.8 400 320 400c-79.5 0-144-64.5-144-144V234l-16-12.6V256c0 85.7 67.4 155.6 152 159.8V496H232c-4.4 0-8 3.6-8 8s3.6 8 8 8h88 88c4.4 0 8-3.6 8-8s-3.6-8-8-8H328V415.8c21.2-1 41.3-6.2 59.6-14.7zM240 101.1V96c0-44.2 35.8-80 80-80s80 35.8 80 80V227.4l16 12.6V96c0-53-43-96-96-96c-50.6 0-92 39.1-95.7 88.7L240 101.1zM476.8 288c2.1-10.4 3.2-21.1 3.2-32V200c0-4.4-3.6-8-8-8s-8 3.6-8 8v56c0 7.1-.5 14-1.5 20.8L476.8 288zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  

  
  

  var faBinoculars = {
    prefix: 'fat',
    iconName: 'binoculars',
    icon: [
      512,
      512,
      [],
      'f1e5',
      
      'M128 48c-8.8 0-16 7.2-16 16V96h80V64c0-8.8-7.2-16-16-16H128zM96 97.1V64c0-17.7 14.3-32 32-32h48c17.7 0 32 14.3 32 32V97.4c9.3 3.3 16 12.2 16 22.6v8h64v-8c0-10.4 6.7-19.3 16-22.6V64c0-17.7 14.3-32 32-32h48c17.7 0 32 14.3 32 32V97.1c19.5 4.3 34.7 20.4 37.3 40.9L459 184c3.3 26.4 12.1 51.8 25.8 74.6c17.8 29.7 27.2 63.7 27.2 98.3V432c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V288H224V432c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V356.9c0-34.6 9.4-68.6 27.2-98.3C40.9 235.8 49.7 210.4 53 184L58.7 138c2.6-20.5 17.8-36.6 37.3-40.9zM106.4 112c-16.1 0-29.8 12-31.8 28l-5.7 45.9c-3.6 28.6-13.1 56.2-27.9 80.9c-16.3 27.2-25 58.4-25 90.1V432c0 17.7 14.3 32 32 32H176c17.7 0 32-14.3 32-32V280 136 120c0-4.4-3.6-8-8-8h-8H112h-5.6zm299.3 0H400 320h-8c-4.4 0-8 3.6-8 8v16V280 432c0 17.7 14.3 32 32 32H464c17.7 0 32-14.3 32-32V356.9c0-31.7-8.6-62.9-25-90.1c-14.8-24.7-24.3-52.3-27.9-80.9L437.4 140c-2-16-15.6-28-31.8-28zM320 96h80V64c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16V96zM224 272h64V144H224V272z'
      
    ]
  };

  

  
  

  var faTruckRamp = {
    prefix: 'fat',
    iconName: 'truck-ramp',
    icon: [
      640,
      512,
      [],
      'f4e0',
      
      'M424 0c-39.8 0-72 32.2-72 72V397.1L5.8 496.3c-4.2 1.2-6.7 5.6-5.5 9.9s5.6 6.7 9.9 5.5L416.1 395.4c-.1 1.5-.1 3-.1 4.6c0 61.9 50.1 112 112 112s112-50.1 112-112s-50.1-112-112-112c-54.4 0-99.7 38.8-109.9 90.2L368 392.5V72c0-30.9 25.1-56 56-56H632c4.4 0 8-3.6 8-8s-3.6-8-8-8H424zM528 304a96 96 0 1 1 0 192 96 96 0 1 1 0-192z'
      
    ]
  };

  

  
  

  var faMusicSlash = {
    prefix: 'fat',
    iconName: 'music-slash',
    icon: [
      640,
      512,
      [],
      'f8d1',
      
      'M364.1 199.1L560 138.8V323.8c-17.2-21.6-46.6-35.8-80-35.8c-1.1 0-2.1 0-3.2 0l22.5 17.8c29.2 5.7 50.6 24.2 57.9 45.7L576 366.4V128.2v-.4V15c0-8.3-6.7-15-15-15c-1.5 0-3 .2-4.4 .7L256.9 92.9c-5.9 1.8-10.7 5.8-13.7 10.8l12.9 10.2c.7-2.7 2.7-4.9 5.4-5.7L560 16.4V122.1l-211.1 65 15.3 12zM240 284.6V387.8c-17.2-21.6-46.6-35.8-80-35.8c-53 0-96 35.8-96 80s43 80 96 80s96-35.8 96-80V297.2l-16-12.6zM160 368c47 0 80 31.3 80 64s-33 64-80 64s-80-31.3-80-64s33-64 80-64zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  

  
  

  var faTrillium = {
    prefix: 'fat',
    iconName: 'trillium',
    icon: [
      448,
      512,
      [],
      'e588',
      
      'M207.5 11.1c8.7-8.2 22-8.2 30.7 0c12.1 11.4 33.2 32.8 51.3 59.3c18 26.3 33.7 58.6 33.7 91.7c0 12.2-2.2 23.8-6.1 34.6c13 1.6 26 5.8 38 12.7l-2.5 4.4 2.5-4.4c28.6 16.5 48.8 46.3 62.6 75.1c13.9 28.9 21.9 57.9 25.7 74.1c2.7 11.6-3.9 23.1-15.4 26.6c-15.9 4.8-45 12.4-77 14.8c-31.8 2.4-67.6-.1-96.3-16.6c-13.1-7.6-23.8-17.6-32-29.2c-8.1 11.6-18.9 21.7-32 29.2c-28.6 16.5-64.5 19.1-96.3 16.6c-32-2.4-61.1-10-77-14.8c-11.4-3.4-18.1-15-15.3-26.6c3.8-16.2 11.8-45.2 25.7-74.1c13.8-28.8 33.9-58.5 62.6-75.1l0 0c12.1-7 25.1-11.2 38.2-12.8c-4-10.8-6.1-22.5-6.1-34.6c0-33.1 15.7-65.4 33.7-91.7c18.1-26.5 39.2-47.9 51.3-59.3zm19.7 11.7c-2.6-2.4-6.2-2.4-8.8 0c-11.7 11-31.9 31.5-49.1 56.6c-17.3 25.3-30.9 54.4-30.9 82.7c0 13.8 3.3 26.8 9.1 38.3c1.3 2.5 1.1 5.4-.3 7.8s-4 3.8-6.8 3.8c-14.3 0-28.8 3.7-42.1 11.3c-2.6 1.5-5.1 3.1-7.5 4.8l0 0s0 0 0 0c-20.8 14.9-36.7 38.5-48.6 63.3C29.1 319 21.4 346.7 17.7 362.3c-.8 3.4 1 6.6 4.4 7.6l-2.3 7.7 2.3-7.7c15.4 4.6 43.2 11.9 73.6 14.2c30.6 2.3 62.6-.4 87.1-14.6c14.6-8.4 25.7-20.5 32.9-34.5c1.4-2.7 4.1-4.3 7.1-4.3s5.7 1.7 7.1 4.3c7.2 13.9 18.3 26 32.9 34.5c24.5 14.2 56.5 16.9 87.1 14.6c30.4-2.3 58.2-9.5 73.6-14.2c3.4-1 5.2-4.2 4.4-7.6c-3.7-15.6-11.3-43.3-24.5-70.8c-13.3-27.7-31.6-54-56.1-68.1c-13.2-7.6-27.7-11.3-41.9-11.3c-2.8 0-5.4-1.5-6.8-3.8s-1.6-5.3-.3-7.8c5.8-11.5 9.1-24.5 9.1-38.3c0-28.3-13.6-57.4-30.9-82.7c-17.2-25.2-37.4-45.7-49.1-56.6zM224 208a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm48 32a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM433.1 129c-13.9-1.5-43.5-1.8-82.2 13.6c-.7-5.4-1.7-10.8-2.9-16c42.1-16.1 74.3-15 89.2-13.2c9.6 1.2 15.3 11 11.5 19.9c-5.7 13.7-20.7 41.6-55 69.8c-4.2-3.5-8.6-6.8-13.2-9.9c32.4-25.8 46.9-51.4 52.6-64.2zM10.9 113.3c14.9-1.9 47.1-2.9 89.2 13.2c-1.2 5.3-2.2 10.6-2.9 16c-38.7-15.3-68.2-15-82.2-13.6c5.7 12.8 20.1 38.4 52.5 64.1c-4.6 3.1-9 6.4-13.2 9.9C20.1 174.8 5.1 146.9-.6 133.2c-3.8-9 1.9-18.7 11.5-19.9zM211.7 500.7c-8.6-12.9-24.2-40.6-31.6-79.9c5.1-1.9 10.2-4 15.1-6.5c6.4 36.9 20.5 63.1 28.8 75.9c8.2-12.8 22.4-39 28.7-75.8c4.9 2.5 10 4.6 15.1 6.4c-7.4 39.3-23 66.9-31.6 79.9c-5.9 8.9-18.6 8.9-24.5 0z'
      
    ]
  };

  

  
  

  var faBrowsers = {
    prefix: 'fat',
    iconName: 'browsers',
    icon: [
      576,
      512,
      [],
      'e0cb',
      
      'M512 16c26.5 0 48 21.5 48 48V96H200V48 16H512zM160 16h24V48 96H112V64c0-26.5 21.5-48 48-48zM112 352V112h80H560V352c0 26.5-21.5 48-48 48H160c-26.5 0-48-21.5-48-48zM160 0C124.7 0 96 28.7 96 64V352c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H160zM16 104c0-4.4-3.6-8-8-8s-8 3.6-8 8V392c0 66.3 53.7 120 120 120H472c4.4 0 8-3.6 8-8s-3.6-8-8-8H120C62.6 496 16 449.4 16 392V104z'
      
    ]
  };

  

  
  

  var faSprinklerCeiling = {
    prefix: 'fat',
    iconName: 'sprinkler-ceiling',
    icon: [
      384,
      512,
      [],
      'e44c',
      
      'M0 0V96c0 3.6 2.5 6.8 6 7.7l122 31.8V119L16 89.8V0H0zM256 119v16.5l122-31.8c3.5-.9 6-4.1 6-7.7V0H368V89.8L256 119zM192 48c8.8 0 16 7.2 16 16V240H176V64c0-8.8 7.2-16 16-16zm32 192V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V240H72c-4.4 0-8 3.6-8 8s3.6 8 8 8h96 48 96c4.4 0 8-3.6 8-8s-3.6-8-8-8H224zM144 352a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM80 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm176-80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-32 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm144-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM32 464A16 16 0 1 0 0 464a16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faGavel = {
    prefix: 'fat',
    iconName: 'gavel',
    icon: [
      512,
      512,
      ["legal"],
      'f0e3',
      
      'M301.7 2.3c3.1 3.1 3.1 8.2 0 11.3L291.3 24 488 220.7l10.3-10.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-16 16-112 112-16 16c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L364.7 344 168 147.3l-10.3 10.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l16-16 112-112 16-16c3.1-3.1 8.2-3.1 11.3 0zM179.3 136L376 332.7 476.7 232 280 35.3 179.3 136zm-24 172.7c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6l48 48c6.2 6.2 16.4 6.2 22.6 0l112-112c6.2-6.2 6.2-16.4 0-22.6l-48-48zm-33.9-11.3c12.5-12.5 32.8-12.5 45.3 0L185 315.7l53.1-53.1 11.3 11.3L196.3 327l18.3 18.3c12.5 12.5 12.5 32.8 0 45.3l-112 112c-12.5 12.5-32.8 12.5-45.3 0l-48-48c-12.5-12.5-12.5-32.8 0-45.3l112-112z'
      
    ]
  };

  
    var faLegal = faGavel;
  

  
  

  var faReflectBoth = {
    prefix: 'fat',
    iconName: 'reflect-both',
    icon: [
      512,
      512,
      [],
      'e66f',
      
      'M113.2 25.9c-2.5 6-1.1 12.9 3.5 17.4l128 128c6.2 6.2 16.4 6.2 22.6 0l128-128c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9L128 16c-6.5 0-12.3 3.9-14.8 9.9zM233.4 182.6l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9S115.1 0 128 0L384 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128c-12.5 12.5-32.8 12.5-45.3 0zM25.9 113.2c-6 2.5-9.9 8.3-9.9 14.8l0 256c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l128-128c6.2-6.2 6.2-16.4 0-22.6l-128-128c-4.6-4.6-11.5-5.9-17.4-3.5zM182.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-128 128c-9.2 9.2-22.9 11.9-34.9 6.9S0 396.9 0 384L0 128c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l128 128zM486.1 113.2c-6-2.5-12.9-1.1-17.4 3.5l-128 128c-6.2 6.2-6.2 16.4 0 22.6l128 128c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8l0-256c0-6.5-3.9-12.3-9.9-14.8zM329.4 233.4l128-128c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128c-12.5-12.5-12.5-32.8 0-45.3zM128 496l256 0c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-128-128c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9zM278.6 329.4l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8l-256 0c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128c12.5-12.5 32.8-12.5 45.3 0z'
      
    ]
  };

  

  
  

  var faTrashClock = {
    prefix: 'fat',
    iconName: 'trash-clock',
    icon: [
      576,
      512,
      [],
      'e2b0',
      
      'M177.7 16h92.5c8.3 0 16 4.3 20.4 11.3l23 36.7H134.4l23-36.7c4.4-7 12.1-11.3 20.4-11.3zm-33.9 2.8L115.6 64H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H332.4L304.2 18.8C296.9 7.1 284.1 0 270.3 0H177.7c-13.8 0-26.6 7.1-33.9 18.8zM48 119.3c-.4-4.4-4.2-7.7-8.6-7.3s-7.7 4.2-7.3 8.6l28.3 340c2.4 29 26.7 51.4 55.8 51.4H330.8c-6.9-4.9-13.5-10.2-19.6-16h-195c-20.8 0-38.1-15.9-39.9-36.7L48 119.3zm368 1.3c.4-4.4-2.9-8.3-7.3-8.6s-8.3 2.9-8.6 7.3l-6.4 76.9c5.3-1.2 10.8-2.1 16.3-2.8l6.1-72.7zM432 240a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-224c-4.4 0-8 3.6-8 8v72c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8s-3.6-8-8-8H440V296c0-4.4-3.6-8-8-8z'
      
    ]
  };

  

  
  

  var faCartCircleArrowUp = {
    prefix: 'fat',
    iconName: 'cart-circle-arrow-up',
    icon: [
      640,
      512,
      [],
      'e3f0',
      
      'M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8H45.7C57.1 16 67 24.1 69.2 35.4l59.4 303.4c5.1 26.3 28.2 45.2 55 45.2H320.7c-.5-5.3-.7-10.6-.7-16H183.5c-19.1 0-35.6-13.5-39.3-32.3L134.9 288H339.2c2.8-5.5 5.9-10.8 9.3-16H131.8L88 48H527.7c15.5 0 26.9 14.4 23.4 29.5L523.8 194.2c5.3 .8 10.5 1.9 15.7 3.2L566.6 81.1C572.5 56 553.4 32 527.7 32H84.8C81 13.4 64.7 0 45.7 0H8zM144 464a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm144-96a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-213.7-2.3c3.1 3.1 8.2 3.1 11.3 0L488 315.3V440c0 4.4 3.6 8 8 8s8-3.6 8-8V315.3l50.3 50.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-64-64c-3.1-3.1-8.2-3.1-11.3 0l-64 64c-3.1 3.1-3.1 8.2 0 11.3z'
      
    ]
  };

  

  
  

  var faTentArrowLeftRight = {
    prefix: 'fat',
    iconName: 'tent-arrow-left-right',
    icon: [
      576,
      512,
      [],
      'e57f',
      
      'M477.4 2.1c-3.3-3-8.3-2.8-11.3 .5s-2.8 8.3 .5 11.3L547.4 88 28.6 88l80.8-74.1c3.3-3 3.5-8 .5-11.3s-8-3.5-11.3-.5l-96 88C.9 91.6 0 93.8 0 96s.9 4.4 2.6 5.9l96 88c3.3 3 8.3 2.8 11.3-.5s2.8-8.3-.5-11.3L28.6 104l518.9 0-80.8 74.1c-3.3 3-3.5 8-.5 11.3s8 3.5 11.3 .5l96-88c1.7-1.5 2.6-3.7 2.6-5.9s-.9-4.4-2.6-5.9l-96-88zM292.6 161.5c-2.8-2-6.5-2-9.2 0L103 289.3c-9.2 6.5-15.2 16.7-16.6 27.9l-18 150.1C65.5 491 84.1 512 108.1 512H399.9h.3 67.8c24 0 42.6-21 39.7-44.8l-18-150.1c-1.3-11.2-7.4-21.3-16.6-27.9L292.6 161.5zM296 317.8V183.5L463.8 302.3c5.5 3.9 9.1 10 10 16.7l18 150.1c1.7 14.3-9.4 26.9-23.8 26.9H404.5L296 317.8zm0 30.8L385.8 496H296V348.5zm-16-28.4V496H108.1c-14.4 0-25.5-12.6-23.8-26.9l18-150.1c.8-6.7 4.4-12.8 10-16.7L280 183.5V319.9c0 .1 0 .2 0 .3z'
      
    ]
  };

  

  
  

  var faChfSign = {
    prefix: 'fat',
    iconName: 'chf-sign',
    icon: [
      640,
      512,
      [],
      'e602',
      
      'M0 114.4C0 68.9 36.9 32 82.4 32h3c33.7 0 63.5 21.5 74.2 53.5c1.4 4.2-.9 8.7-5.1 10.1s-8.7-.9-10.1-5.1C135.9 65.1 112.2 48 85.4 48h-3C45.7 48 16 77.7 16 114.4V397.6C16 434.3 45.7 464 82.4 464h3c26.8 0 50.5-17.1 59-42.5c1.4-4.2 5.9-6.5 10.1-5.1s6.5 5.9 5.1 10.1C148.9 458.5 119.1 480 85.4 480h-3C36.9 480 0 443.1 0 397.6V114.4zM216 32c4.4 0 8 3.6 8 8V240H384V40c0-4.4 3.6-8 8-8s8 3.6 8 8V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V256H224V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V40c0-4.4 3.6-8 8-8zm232 8c0-4.4 3.6-8 8-8H632c4.4 0 8 3.6 8 8s-3.6 8-8 8H464V240H600c4.4 0 8 3.6 8 8s-3.6 8-8 8H464V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V40z'
      
    ]
  };

  

  
  

  var faMicrowave = {
    prefix: 'fat',
    iconName: 'microwave',
    icon: [
      576,
      512,
      [],
      'e01b',
      
      'M512 48c26.5 0 48 21.5 48 48V384c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H512zM64 32C28.7 32 0 60.7 0 96V384c0 35.3 28.7 64 64 64l0 24c0 4.4 3.6 8 8 8s8-3.6 8-8V448H496v24c0 4.4 3.6 8 8 8s8-3.6 8-8V448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm432 72V376c0 4.4 3.6 8 8 8s8-3.6 8-8V104c0-4.4-3.6-8-8-8s-8 3.6-8 8zM104 128H408c4.4 0 8 3.6 8 8V344c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8V136c0-4.4 3.6-8 8-8zm-24 8V344c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24V136c0-13.3-10.7-24-24-24H104c-13.3 0-24 10.7-24 24z'
      
    ]
  };

  

  
  

  var faHospitalUser = {
    prefix: 'fat',
    iconName: 'hospital-user',
    icon: [
      576,
      512,
      [],
      'f80d',
      
      'M0 56C0 25.1 25.1 0 56 0H264c30.9 0 56 25.1 56 56V271.8 336v31.8c-5.6 3.1-11 6.7-16 10.7V336 56c0-22.1-17.9-40-40-40H56C33.9 16 16 33.9 16 56V272H152c4.4 0 8 3.6 8 8s-3.6 8-8 8H16v80H152c4.4 0 8 3.6 8 8s-3.6 8-8 8H16v72c0 22.1 17.9 40 40 40H258.8c1.7 5.7 4.1 11.1 7.2 16H56c-30.9 0-56-25.1-56-56V56zm152 0h16c13.3 0 24 10.7 24 24V96h16c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H192v16c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24V160H112c-13.3 0-24-10.7-24-24V120c0-13.3 10.7-24 24-24h16V80c0-13.3 10.7-24 24-24zm-8 24v24c0 4.4-3.6 8-8 8H112c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h24c4.4 0 8 3.6 8 8v24c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V152c0-4.4 3.6-8 8-8h24c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8H184c-4.4 0-8-3.6-8-8V80c0-4.4-3.6-8-8-8H152c-4.4 0-8 3.6-8 8zM496 272a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM304 477.1c0 10.4 8.5 18.9 18.9 18.9H541.1c10.4 0 18.9-8.5 18.9-18.9c0-42.6-34.5-77.1-77.1-77.1H381.1c-42.6 0-77.1 34.5-77.1 77.1zM432 192a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM381.1 384H482.9c51.4 0 93.1 41.7 93.1 93.1c0 19.3-15.6 34.9-34.9 34.9H322.9c-19.3 0-34.9-15.6-34.9-34.9c0-51.4 41.7-93.1 93.1-93.1z'
      
    ]
  };

  

  
  

  var faFaceFlushed = {
    prefix: 'fat',
    iconName: 'face-flushed',
    icon: [
      512,
      512,
      [128563,"flushed"],
      'f579',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM192 368H320c4.4 0 8 3.6 8 8s-3.6 8-8 8H192c-4.4 0-8-3.6-8-8s3.6-8 8-8zm-32-80a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-144a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm256 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-144 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM160.4 208a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm192 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32z'
      
    ]
  };

  
    var faFlushed = faFaceFlushed;
  

  
  

  var faSquare3 = {
    prefix: 'fat',
    iconName: 'square-3',
    icon: [
      448,
      512,
      [],
      'e258',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm136 32H296c3.3 0 6.3 2.1 7.5 5.2s.3 6.6-2.2 8.8L189.4 239.9l58.1-.3c40-.2 72.5 32.2 72.5 72.2c0 39.9-32.3 72.2-72.2 72.2H176.7c-18.2 0-34.8-10.3-42.9-26.5l-4.9-9.9c-2-4-.4-8.8 3.6-10.7s8.8-.4 10.7 3.6l4.9 9.9c5.4 10.8 16.5 17.7 28.6 17.7h71.1c31 0 56.2-25.2 56.2-56.2c0-31.1-25.3-56.3-56.4-56.2L168 256c-3.3 0-6.3-2-7.5-5.2s-.3-6.7 2.2-8.9l112-98H136c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faTrowelBricks = {
    prefix: 'fat',
    iconName: 'trowel-bricks',
    icon: [
      512,
      512,
      [],
      'e58a',
      
      'M232.4 18.4c-4.7-2.9-10.6-3.2-15.6-.7l-192 96c-5.4 2.7-8.8 8.3-8.8 14.3s3.4 11.6 8.8 14.3l192 96c5 2.5 10.9 2.2 15.6-.7s7.6-8.1 7.6-13.6V32c0-5.5-2.9-10.7-7.6-13.6zM256 32v88h88v-8c0-17.7 14.3-32 32-32h88c26.5 0 48 21.5 48 48s-21.5 48-48 48H376c-17.7 0-32-14.3-32-32v-8H256v88c0 11.1-5.7 21.4-15.2 27.2s-21.2 6.4-31.1 1.4l-192-96C6.8 151.2 0 140.1 0 128s6.8-23.2 17.7-28.6l192-96c9.9-5 21.7-4.4 31.1 1.4S256 20.9 256 32zM360 144c0 8.8 7.2 16 16 16h88c17.7 0 32-14.3 32-32s-14.3-32-32-32H376c-8.8 0-16 7.2-16 16v16 16zM288 384H240V496H480c8.8 0 16-7.2 16-16V408v-8V384H304 288zm-64-16h16 32 16V352 272c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32V400v8 72c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V400c0-17.7 14.3-32 32-32H224zm0 16H32c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16H224V384zm272-16V272c0-8.8-7.2-16-16-16H320c-8.8 0-16 7.2-16 16v96H496z'
      
    ]
  };

  

  
  

  var faCloud = {
    prefix: 'fat',
    iconName: 'cloud',
    icon: [
      640,
      512,
      [9729],
      'f0c2',
      
      'M523.6 234.2c2.3 4.1 6.2 7.1 10.9 8C585.5 252.6 624 297.8 624 352c0 61.9-50.1 112-112 112H144C73.3 464 16 406.7 16 336c0-55.8 35.7-103.3 85.5-120.8c6.7-2.4 11-8.8 10.7-15.9c-.1-2.4-.2-4.9-.2-7.3c0-79.5 64.5-144 144-144c53.3 0 99.9 29 124.8 72.2c2.2 3.8 5.9 6.6 10.2 7.6s8.8 .2 12.5-2.3c12.7-8.5 28-13.5 44.4-13.5c44.2 0 80 35.8 80 80c0 10.2-1.9 19.9-5.3 28.8c-1.7 4.4-1.4 9.3 .9 13.4zM386 98.7C357 58.3 309.6 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144H512c70.7 0 128-57.3 128-128c0-56.3-36.4-104.1-86.9-121.3c-5-1.7-10.2-3.1-15.5-4.2c1.9-5 3.4-10.1 4.5-15.4c1.3-6.2 1.9-12.6 1.9-19.2c0-53-43-96-96-96c-15.2 0-29.5 3.5-42.3 9.8c-3.8 1.9-7.5 4-11 6.4c-2.7-4.6-5.6-9.1-8.7-13.4z'
      
    ]
  };

  

  
  

  var faMessageQuestion = {
    prefix: 'fat',
    iconName: 'message-question',
    icon: [
      512,
      512,
      [],
      'e1e3',
      
      'M176 416c0-8.8-7.2-16-16-16H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H309.3c-3.5 0-6.8 1.1-9.6 3.2L176 496V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h80 16v16 64c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM168 136l0 6.5c0 4.4 3.6 8 8 8s8-3.6 8-8l0-6.5c0-22.1 17.9-40 40-40h56.2c26.4 0 47.8 21.4 47.8 47.8c0 16.1-8.1 31.1-21.5 39.9l-54.9 36.2c-2.2 1.5-3.6 4-3.6 6.7V256c0 4.4 3.6 8 8 8s8-3.6 8-8V230.9L315.3 197c17.9-11.8 28.7-31.8 28.7-53.3c0-35.2-28.6-63.8-63.8-63.8H224c-30.9 0-56 25.1-56 56zM272 304a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faPaw = {
    prefix: 'fat',
    iconName: 'paw',
    icon: [
      512,
      512,
      [],
      'f1b0',
      
      'M212.5 148.3c-4.7 13.9-13.3 22.8-23.6 26.2c-10.3 3.4-22.7 1.3-34.9-7.1s-23.2-22.7-29.4-41.2s-5.9-36.4-1.2-50.3c4.7-13.9 13.3-22.8 23.6-26.2c10.3-3.4 22.7-1.3 34.9 7.1s23.2 22.7 29.4 41.2s5.9 36.4 1.2 50.3zm-18.6 41.4c32.3-10.6 46.9-53.9 32.6-96.8S174.4 23.8 142.1 34.3s-46.9 53.9-32.6 96.8s52.1 69.1 84.4 58.5zm-98.3 56c-1.4 11.4-6.5 19.3-13.4 23.2c-6.9 4-16.4 4.5-27.2-.1s-21.7-13.9-29.6-27.4s-10.5-27.6-9.1-39c1.4-11.4 6.5-19.3 13.4-23.2c6.9-4 16.4-4.5 27.2 .1s21.7 13.9 29.6 27.4s10.5 27.6 9.1 39zm-5.5 37.1c24.5-14 29.1-51.7 10.2-84.1s-54-47.3-78.5-33.3s-29.1 51.7-10.2 84.1s54 47.3 78.5 33.3zM256 240c33.5 0 121.3 30.7 171.8 166.8c2.9 7.7 4.2 16.2 4.2 24.9v4.4c0 15.4-12.5 27.9-27.9 27.9c-11.7 0-23.3-1.8-34.5-5.3l-80.2-25.1c-21.8-6.8-45.1-6.8-66.8 0l-80.2 25.1c-11.2 3.5-22.8 5.3-34.5 5.3C92.5 464 80 451.5 80 436.1v-4.4c0-8.8 1.3-17.2 4.2-24.9C134.7 270.7 222.5 240 256 240zm0-16c-41.3 0-134.4 35.9-186.8 177.2c-3.6 9.7-5.2 20.1-5.2 30.5v4.4c0 24.2 19.7 43.9 43.9 43.9c13.3 0 26.6-2 39.3-6l80.2-25.1c18.6-5.8 38.6-5.8 57.3 0L364.8 474c12.7 4 26 6 39.3 6c24.2 0 43.9-19.7 43.9-43.9v-4.4c0-10.4-1.6-20.8-5.2-30.5C390.4 259.9 297.3 224 256 224zm169.5-17.4c7.9-13.5 18.8-22.8 29.6-27.4s20.2-4 27.2-.1c6.9 4 12.1 11.8 13.4 23.2c1.4 11.4-1.2 25.5-9.1 39s-18.8 22.8-29.6 27.4s-20.2 4-27.2 .1c-6.9-4-12.1-11.8-13.4-23.2c-1.4-11.4 1.2-25.5 9.1-39zm-13.8-8c-18.9 32.4-14.3 70.1 10.2 84.1s59.7-.9 78.5-33.3s14.3-70.1-10.2-84.1s-59.7 .9-78.5 33.3zM292.7 97.9c6.2-18.5 17.2-32.8 29.4-41.2s24.5-10.5 34.9-7.1c10.3 3.4 18.9 12.3 23.6 26.2c4.7 13.9 5 31.9-1.2 50.3s-17.2 32.8-29.4 41.2s-24.5 10.5-34.9 7.1c-10.3-3.4-18.9-12.3-23.6-26.2c-4.7-13.9-5-31.9 1.2-50.3zm-15.2-5.1c-14.3 42.9 .3 86.2 32.6 96.8s70.1-15.6 84.4-58.5s-.3-86.2-32.6-96.8S291.8 50 277.5 92.9z'
      
    ]
  };

  

  
  

  var faTabletScreenButton = {
    prefix: 'fat',
    iconName: 'tablet-screen-button',
    icon: [
      448,
      512,
      ["tablet-alt"],
      'f3fa',
      
      'M384 16c26.5 0 48 21.5 48 48V352H16V64c0-26.5 21.5-48 48-48H384zm48 352v80c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V368H432zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM224 448a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z'
      
    ]
  };

  
    var faTabletAlt = faTabletScreenButton;
  

  
  

  var faCircleNotch = {
    prefix: 'fat',
    iconName: 'circle-notch',
    icon: [
      512,
      512,
      [],
      'f1ce',
      
      'M199.7 14.3c1.1 4.3-1.4 8.7-5.7 9.8C91.5 51.4 16 144.9 16 256c0 132.5 107.5 240 240 240s240-107.5 240-240c0-111.1-75.5-204.6-178.1-231.9c-4.3-1.1-6.8-5.5-5.7-9.8s5.5-6.8 9.8-5.7C431.4 37.7 512 137.4 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 137.4 80.6 37.7 189.9 8.6c4.3-1.1 8.7 1.4 9.8 5.7z'
      
    ]
  };

  

  
  

  var faRainbow = {
    prefix: 'fat',
    iconName: 'rainbow',
    icon: [
      640,
      512,
      [127752],
      'f75b',
      
      'M320 48C152.1 48 16 184.1 16 352V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V352C0 175.3 143.3 32 320 32s320 143.3 320 320V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V352C624 184.1 487.9 48 320 48zm0 192c-61.9 0-112 50.1-112 112V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V352c0-70.7 57.3-128 128-128s128 57.3 128 128V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V352c0-61.9-50.1-112-112-112zM104 360V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V360c0-128.1 103.9-232 232-232s232 103.9 232 232V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V360c0-119.3-96.7-216-216-216s-216 96.7-216 216z'
      
    ]
  };

  

  
  

  var faEarthAfrica = {
    prefix: 'fat',
    iconName: 'earth-africa',
    icon: [
      512,
      512,
      [127757,"globe-africa"],
      'f57c',
      
      'M496 256c0-13.8-1.2-27.3-3.4-40.5l-65.2-13c-4.1-.8-8.3 1.2-10.2 5c-7.6 15.1-25.1 22.4-41.2 17L362 219.8c-4.8-1.6-10-.3-13.6 3.2c-.6 .6-.6 1.5 0 2.1l33.5 33.5c6.5 6.5 10.2 15.4 10.2 24.6c0 16-10.9 29.9-26.3 33.7l-5.3 1.3c-.2 0-.3 .2-.3 .4v12.1c0 15.6-5.1 30.7-14.4 43.2L320 408c-7.6 10.1-19.4 16-32 16c-22.1 0-40-17.9-40-40V336c0-4.4-3.6-8-8-8H208c-30.9 0-56-25.1-56-56V244c0-15.1 7.1-29.3 19.2-38.4l39.4-29.5c7-5.2 15.5-8.1 24.2-8.1c4.3 0 8.6 .7 12.7 2.1l32 10.7c5.8 1.9 12 2.2 17.9 .7l35.4-8.8c6.6-1.7 11.3-7.6 11.3-14.4c0-5.6-3.2-10.8-8.2-13.3l-29.2-14.6c-.6-.3-1.3-.2-1.8 .3l-3.9 3.9c-6.1 6.1-14.4 9.5-23.1 9.5c-5.1 0-10.1-1.2-14.6-3.4L248 132.9c-3.4-1.7-7.5-.8-9.8 2.2l-13.6 17c-8.5 10.6-24.3 11.5-33.9 1.9c-4.3-4.3-6.7-10.1-6.7-16.1V96.5c0-4.2-1.1-8.3-3.2-11.9L154.5 38.5C72.7 76.7 16 159.7 16 256c0 132.5 107.5 240 240 240s240-107.5 240-240zm-6.9-57.5C463.3 93.7 368.7 16 256 16c-30.6 0-59.8 5.7-86.7 16.1l25.4 44.5c3.5 6 5.3 12.9 5.3 19.8v41.4c0 1.8 .7 3.5 2 4.8c2.9 2.9 7.6 2.6 10.1-.6l13.6-17c7.1-8.8 19.4-11.5 29.5-6.5l15.2 7.6c2.3 1.2 4.8 1.8 7.4 1.8c4.4 0 8.6-1.7 11.7-4.9l3.9-3.9c5.3-5.3 13.5-6.7 20.2-3.3l29.2 14.6c10.5 5.2 17.1 15.9 17.1 27.6c0 14.2-9.6 26.5-23.4 30l-35.4 8.8c-8.9 2.2-18.2 1.9-26.8-1l-32-10.7c-2.5-.8-5.1-1.2-7.7-1.2c-5.3 0-10.4 1.7-14.6 4.9l-39.4 29.5c-8.1 6-12.8 15.5-12.8 25.6v28c0 22.1 17.9 40 40 40h32c13.3 0 24 10.7 24 24v48c0 13.3 10.7 24 24 24c7.6 0 14.7-3.6 19.2-9.6l25.6-34.1c7.3-9.7 11.2-21.5 11.2-33.6V318.6c0-7.5 5.1-14.1 12.5-16l5.3-1.3c8.4-2.1 14.2-9.6 14.2-18.2c0-5-2-9.8-5.5-13.3L337 236.3c-6.8-6.8-6.8-17.9 0-24.7c7.8-7.8 19.5-10.6 30-7.1l14.1 4.7c8.5 2.8 17.8-1 21.8-9c5.1-10.2 16.4-15.7 27.6-13.5l58.5 11.7zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  
    var faGlobeAfrica = faEarthAfrica;
  

  
  

  var faElephant = {
    prefix: 'fat',
    iconName: 'elephant',
    icon: [
      640,
      512,
      [128024],
      'f6da',
      
      'M208 111.8C208 58.9 250.9 16 303.8 16c50.1 0 91.7 38.6 95.6 88.5l.6 8.1c.3 4.4 4.2 7.7 8.6 7.4s7.7-4.2 7.4-8.6l-.6-8.1c-1.6-20.5-8.6-39.4-19.6-55.2C469.1 50 528 110.1 528 184V328c0 4.4 3.6 8 8 8s8-3.6 8-8V184c0-83.9-68.1-152-152-152h-9.8C361.9 12.2 334.2 0 303.8 0c-30.6 0-58.2 12.3-78.4 32.1C118 35.6 32 123.7 32 232v32c0 25.9-7.6 52.9-15.5 73.7c-3.9 10.3-7.8 19-10.7 25c-1.5 3-2.7 5.4-3.5 7c-.4 .8-.7 1.4-1 1.8l-.2 .4-.1 .1 0 0 0 0 0 0c-2.2 3.9-.8 8.7 3.1 10.9s8.7 .8 10.9-3.1L8 376c7 3.9 7 3.9 7 3.9l0 0 0 0 0 0 .1-.1 .3-.5c.3-.5 .6-1.1 1.1-2c.9-1.7 2.2-4.3 3.7-7.5c3.1-6.4 7.2-15.5 11.3-26.3C39.6 321.8 48 292.7 48 264V232c0-94.6 71.4-172.5 163.2-182.8C199.1 67 192 88.6 192 111.8c0 58.4 45 107 103.3 111.5l8.1 .6c4.4 .3 8.3-3 8.6-7.4s-3-8.3-7.4-8.6l-8.1-.6c-49.9-3.8-88.5-45.5-88.5-95.6zM416 304c0-4.4-3.6-8-8-8s-8 3.6-8 8V472c0 13.3-10.7 24-24 24H328c-13.3 0-24-10.7-24-24V397.5c1.6-1 3.1-2 4.6-3c3.6-2.5 4.5-7.5 2-11.1s-7.5-4.5-11.1-2C282.6 393.1 262.1 400 240 400s-42.6-6.9-59.4-18.6c-3.6-2.5-8.6-1.6-11.1 2s-1.6 8.6 2 11.1c1.5 1 3 2.1 4.6 3V472c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V336c0-4.4-3.6-8-8-8s-8 3.6-8 8V472c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V406c14.7 6.4 30.9 10 48 10s33.3-3.6 48-10v66c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V341.3c16.8 18.6 38.9 32.3 64 38.7v18.5c0 45 36.5 81.4 81.4 81.4c30.9 0 59-17.4 72.8-45l2.3-4.7c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3l-2.3 4.7c-3 5.9-9 9.6-15.6 9.6c-9.6 0-17.4-7.8-17.4-17.4V380c23.3-5.9 44.1-18.2 60.4-34.8c3.1-3.2 3-8.2-.1-11.3s-8.2-3-11.3 .1c-20.6 21-49.2 34-81 34c-40.4 0-75.9-21.2-96-53.1V304zm112 79v15.5c0 18.5 15 33.4 33.4 33.4c12.7 0 24.2-7.2 29.9-18.5l2.3-4.7c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-2.3 4.7C608.9 450 586.2 464 561.4 464c-36.1 0-65.4-29.3-65.4-65.4V383c5.2 .6 10.6 1 16 1s10.8-.3 16-1zM480 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faSquareB = {
    prefix: 'fat',
    iconName: 'square-b',
    icon: [
      448,
      512,
      [],
      'e264',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 56c0-13.3 10.7-24 24-24h84c37.6 0 68 30.4 68 68c0 22.1-10.6 41.8-26.9 54.2c29.3 7.6 50.9 34.2 50.9 65.8c0 37.6-30.4 68-68 68H152c-13.3 0-24-10.7-24-24V256 152zm160 44c0-28.7-23.3-52-52-52H152c-4.4 0-8 3.6-8 8v96h92c28.7 0 52-23.3 52-52zM144 360c0 4.4 3.6 8 8 8H260c28.7 0 52-23.3 52-52s-23.3-52-52-52H236 144v96z'
      
    ]
  };

  

  
  

  var faCodePullRequestDraft = {
    prefix: 'fat',
    iconName: 'code-pull-request-draft',
    icon: [
      448,
      512,
      [],
      'e3fa',
      
      'M32 64a48 48 0 1 1 96 0A48 48 0 1 1 32 64zm56 63.5c31.6-3.9 56-30.9 56-63.5c0-35.3-28.7-64-64-64S16 28.7 16 64c0 32.6 24.4 59.6 56 63.5v257c-31.6 3.9-56 30.9-56 63.5c0 35.3 28.7 64 64 64s64-28.7 64-64c0-32.6-24.4-59.6-56-63.5v-257zM32 448a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-456a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 64a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM344 240a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm64 0a40 40 0 1 0 -80 0 40 40 0 1 0 80 0z'
      
    ]
  };

  

  
  

  var faW = {
    prefix: 'fat',
    iconName: 'w',
    icon: [
      576,
      512,
      [119],
      '57',
      
      'M5.4 32.5c4.2-1.5 8.7 .7 10.2 4.9L159.4 446l121-408.3c1-3.4 4.1-5.7 7.7-5.7s6.7 2.3 7.7 5.7L416.7 446 560.5 37.3c1.5-4.2 6-6.4 10.2-4.9s6.4 6 4.9 10.2l-152 432c-1.2 3.3-4.3 5.4-7.7 5.3s-6.5-2.4-7.5-5.7L288 68.2 167.7 474.3c-1 3.3-4 5.6-7.5 5.7s-6.6-2.1-7.7-5.3L.5 42.7c-1.5-4.2 .7-8.7 4.9-10.2z'
      
    ]
  };

  

  
  

  var faGiftCard = {
    prefix: 'fat',
    iconName: 'gift-card',
    icon: [
      576,
      512,
      [],
      'f663',
      
      'M405.1 16c-20.3 0-39.2 10.5-50 27.7L302.4 128H328h80c30.9 0 56-25.1 56-56s-25.1-56-56-56h-2.9zM273.6 128L220.9 43.7C210.1 26.5 191.2 16 170.9 16H168c-30.9 0-56 25.1-56 56s25.1 56 56 56h80 25.6zm14.4-7.1l53.6-85.7C355.3 13.3 379.3 0 405.1 0H408c39.8 0 72 32.2 72 72c0 22.6-10.4 42.8-26.7 56H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64h58.7C106.4 114.8 96 94.6 96 72c0-39.8 32.2-72 72-72h2.9c25.8 0 49.8 13.3 63.5 35.2L288 120.9zM168 144H64c-26.5 0-48 21.5-48 48v96H560V192c0-26.5-21.5-48-48-48H408 328 305.1l69.1 82.9c2.8 3.4 2.4 8.4-1 11.3s-8.4 2.4-11.3-1L288 148.5l-73.9 88.6c-2.8 3.4-7.9 3.9-11.3 1s-3.9-7.9-1-11.3L270.9 144H248 168zM16 304v96H560V304H16zM560 448V416H16v32c0 26.5 21.5 48 48 48H512c26.5 0 48-21.5 48-48z'
      
    ]
  };

  

  
  

  var faTruckMonster = {
    prefix: 'fat',
    iconName: 'truck-monster',
    icon: [
      640,
      512,
      [],
      'f63b',
      
      'M256 16c-8.8 0-16 7.2-16 16v96H471.2L387.4 24.9C382.8 19.3 376 16 368.8 16H256zM88 128H224V32c0-17.7 14.3-32 32-32H368.8c12 0 23.4 5.4 31 14.8l92 113.2H552c30.9 0 56 25.1 56 56v67.8c2 1.9 3.9 3.9 5.8 5.9c3 3.2 2.9 8.3-.3 11.3s-8.3 2.9-11.3-.3C571.5 236.2 528.1 216 480 216c-59 0-110.8 30.4-140.8 76.4c-1.5 2.3-4 3.6-6.7 3.6H307.5c-2.7 0-5.2-1.4-6.7-3.6C270.8 246.4 219 216 160 216c-48.1 0-91.5 20.2-122.2 52.7c-3 3.2-8.1 3.4-11.3 .3s-3.4-8.1-.3-11.3c1.9-2 3.8-4 5.8-5.9V184c0-30.9 25.1-56 56-56zM48 238c31-23.8 69.9-38 112-38c63 0 118.7 31.7 151.8 80h16.4c33.1-48.3 88.8-80 151.8-80c42.1 0 81 14.2 112 38V184c0-22.1-17.9-40-40-40H488.1h-.1H232 88c-22.1 0-40 17.9-40 40v54zm106 26c-7.7 0-14.2 5.5-15.7 12.8c-.6 2.9-2.7 5.3-5.6 6.1c-6.8 2-13.2 4.7-19.3 8c-2.6 1.4-5.8 1.3-8.3-.3c-6.2-4.1-14.7-3.4-20.1 2L76.6 301c-5.5 5.5-6.2 13.9-2 20.1c1.6 2.5 1.8 5.7 .3 8.3c-3.3 6.1-6 12.5-8 19.3c-.8 2.9-3.2 5-6.1 5.6C53.5 355.8 48 362.3 48 370v12c0 7.7 5.5 14.2 12.8 15.7c2.9 .6 5.3 2.7 6.1 5.6c2 6.8 4.7 13.2 8 19.3c1.4 2.6 1.3 5.8-.3 8.3c-4.1 6.2-3.4 14.7 2 20.1l8.5 8.5c5.5 5.5 13.9 6.2 20.1 2c2.5-1.6 5.7-1.8 8.3-.3c6.1 3.3 12.5 6 19.3 8c2.9 .8 5 3.2 5.6 6.1c1.5 7.3 7.9 12.8 15.7 12.8h12c7.7 0 14.2-5.5 15.7-12.8c.6-2.9 2.7-5.3 5.6-6.1c6.8-2 13.2-4.7 19.3-8c2.6-1.4 5.8-1.3 8.3 .3c6.2 4.1 14.7 3.4 20.1-2l8.5-8.5c5.5-5.5 6.2-13.9 2-20.1c-1.6-2.5-1.8-5.7-.3-8.3c3.3-6.1 6-12.5 8-19.3c.8-2.9 3.2-5 6.1-5.6c7.3-1.5 12.8-7.9 12.8-15.7V370c0-7.7-5.5-14.2-12.8-15.7c-2.9-.6-5.3-2.7-6.1-5.6c-2-6.8-4.7-13.2-8-19.3c-1.4-2.6-1.3-5.8 .3-8.3c4.1-6.2 3.4-14.7-2-20.1l-8.5-8.5c-5.5-5.5-13.9-6.2-20.1-2c-2.5 1.6-5.7 1.8-8.3 .3c-6.1-3.3-12.5-6-19.3-8c-2.9-.8-5-3.2-5.6-6.1c-1.5-7.3-7.9-12.8-15.7-12.8H154zm-30 4.9c4.5-12.2 16.2-20.9 30-20.9h12c13.8 0 25.5 8.7 30 20.9c4.9 1.7 9.7 3.6 14.3 5.9c11.8-5.4 26.2-3.3 36 6.5l8.5 8.5c9.7 9.7 11.9 24.2 6.5 36c2.3 4.6 4.3 9.4 5.9 14.3c12.2 4.5 20.9 16.2 20.9 30v12c0 13.8-8.7 25.5-20.9 30c-1.7 4.9-3.6 9.7-5.9 14.3c5.4 11.8 3.3 26.2-6.5 36l-8.5 8.5c-9.7 9.7-24.2 11.9-36 6.5c-4.6 2.3-9.4 4.3-14.3 5.9c-4.5 12.2-16.2 20.9-30 20.9H154c-13.8 0-25.5-8.7-30-20.9c-4.9-1.7-9.7-3.6-14.3-5.9c-11.8 5.4-26.2 3.3-36-6.5l-8.5-8.5c-9.7-9.7-11.9-24.2-6.5-36c-2.3-4.6-4.3-9.4-5.9-14.3C40.7 407.5 32 395.8 32 382V370c0-13.8 8.7-25.5 20.9-30c1.7-4.9 3.6-9.7 5.9-14.3c-5.4-11.8-3.3-26.2 6.5-36l8.5-8.5c9.7-9.7 24.2-11.9 36-6.5c4.6-2.3 9.4-4.3 14.3-5.9zM160 336a40 40 0 1 0 0 80 40 40 0 1 0 0-80zm56 40a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zm242.3-99.2c-.6 2.9-2.7 5.3-5.6 6.1c-6.8 2-13.2 4.7-19.3 8c-2.6 1.4-5.8 1.3-8.3-.3c-6.2-4.1-14.7-3.4-20.1 2l-8.5 8.5c-5.5 5.5-6.2 13.9-2 20.1c1.6 2.5 1.8 5.7 .3 8.3c-3.3 6.1-6 12.5-8 19.3c-.8 2.9-3.2 5-6.1 5.6c-7.3 1.5-12.8 7.9-12.8 15.7v12c0 7.7 5.5 14.2 12.8 15.7c2.9 .6 5.3 2.7 6.1 5.6c2 6.8 4.7 13.2 8 19.3c1.4 2.6 1.3 5.8-.3 8.3c-4.1 6.2-3.4 14.7 2 20.1l8.5 8.5c5.5 5.5 13.9 6.2 20.1 2c2.5-1.6 5.7-1.8 8.3-.3c6.1 3.3 12.5 6 19.3 8c2.9 .8 5 3.2 5.6 6.1c1.5 7.3 7.9 12.8 15.7 12.8h12c7.7 0 14.2-5.5 15.7-12.8c.6-2.9 2.7-5.3 5.6-6.1c6.8-2 13.2-4.7 19.3-8c2.6-1.4 5.8-1.3 8.3 .3c6.2 4.1 14.7 3.4 20.1-2l8.5-8.5c5.5-5.5 6.2-13.9 2-20.1c-1.6-2.5-1.8-5.7-.3-8.3c3.3-6.1 6-12.5 8-19.3c.8-2.9 3.2-5 6.1-5.6c7.3-1.5 12.8-7.9 12.8-15.7V370c0-7.7-5.5-14.2-12.8-15.7c-2.9-.6-5.3-2.7-6.1-5.6c-2-6.8-4.7-13.2-8-19.3c-1.4-2.6-1.3-5.8 .3-8.3c4.1-6.2 3.4-14.7-2-20.1l-8.5-8.5c-5.5-5.5-13.9-6.2-20.1-2c-2.5 1.6-5.7 1.8-8.3 .3c-6.1-3.3-12.5-6-19.3-8c-2.9-.8-5-3.2-5.6-6.1c-1.5-7.3-7.9-12.8-15.7-12.8H474c-7.7 0-14.2 5.5-15.7 12.8zM474 248h12c13.8 0 25.5 8.7 30 20.9c4.9 1.7 9.7 3.6 14.3 5.9c11.8-5.4 26.2-3.3 36 6.5l8.5 8.5c9.7 9.7 11.9 24.2 6.5 36c2.3 4.6 4.3 9.4 5.9 14.3c12.2 4.5 20.9 16.2 20.9 30v12c0 13.8-8.7 25.5-20.9 30c-1.7 4.9-3.6 9.7-5.9 14.3c5.4 11.8 3.3 26.2-6.5 36l-8.5 8.5c-9.7 9.7-24.2 11.9-36 6.5c-4.6 2.3-9.4 4.3-14.3 5.9c-4.5 12.2-16.2 20.9-30 20.9H474c-13.8 0-25.5-8.7-30-20.9c-4.9-1.7-9.7-3.6-14.3-5.9c-11.8 5.4-26.2 3.3-36-6.5l-8.5-8.5c-9.7-9.7-11.9-24.2-6.5-36c-2.3-4.6-4.3-9.4-5.9-14.3c-12.2-4.5-20.9-16.2-20.9-30V370c0-13.8 8.7-25.5 20.9-30c1.7-4.9 3.6-9.7 5.9-14.3c-5.4-11.8-3.3-26.2 6.5-36l8.5-8.5c9.7-9.7 24.2-11.9 36-6.5c4.6-2.3 9.4-4.3 14.3-5.9c4.5-12.2 16.2-20.9 30-20.9zM440 376a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm40 56a56 56 0 1 1 0-112 56 56 0 1 1 0 112z'
      
    ]
  };

  

  
  

  var faScarecrow = {
    prefix: 'fat',
    iconName: 'scarecrow',
    icon: [
      448,
      512,
      [],
      'f70d',
      
      'M224 16a88 88 0 1 1 0 176 88 88 0 1 1 0-176zm0 192c43.3 0 80.4-26.4 96-64h91l-10.2 20.4c-1.7 3.5-.7 7.7 2.4 10L426.7 192l-23.5 17.6c-3.1 2.3-4.1 6.5-2.4 10L411.1 240H331.5c-15.1 0-26.5 13.9-23.5 28.7l25 124.8-49.4-24.7c-2.4-1.2-5.2-1.1-7.5 .2l-52 29.7-52-29.7c-2.3-1.3-5.2-1.4-7.5-.2l-49.4 24.7 25-124.8c3-14.9-8.4-28.7-23.5-28.7H36.9l10.2-20.4c1.7-3.5 .7-7.7-2.4-10L21.3 192l23.5-17.6c3.1-2.3 4.1-6.5 2.4-10L36.9 144h91c15.7 37.6 52.8 64 96 64zm200-80H325.2c1.8-7.7 2.8-15.7 2.8-24C328 46.6 281.4 0 224 0S120 46.6 120 104c0 8.3 1 16.3 2.8 24H24c-2.8 0-5.3 1.4-6.8 3.8s-1.6 5.3-.4 7.8l13 26-26.7 20c-2 1.5-3.2 3.9-3.2 6.4s1.2 4.9 3.2 6.4l26.7 20-13 26c-1.2 2.5-1.1 5.4 .4 7.8s4 3.8 6.8 3.8h92.5c5 0 8.8 4.6 7.8 9.6L96.2 406.4c-.6 3 .6 6.1 3 7.9s5.7 2.2 8.4 .8l60.2-30.1L220 414.9c2.5 1.4 5.5 1.4 7.9 0l52.3-29.9 60.2 30.1c2.7 1.4 6 1.1 8.4-.8s3.6-4.9 3-7.9L323.7 265.6c-1-5 2.8-9.6 7.8-9.6H424c2.8 0 5.3-1.4 6.8-3.8s1.6-5.3 .3-7.8l-13-26 26.7-20c2-1.5 3.2-3.9 3.2-6.4s-1.2-4.9-3.2-6.4l-26.7-20 13-26c1.2-2.5 1.1-5.4-.3-7.8s-4-3.8-6.8-3.8zM208 88a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM216 504c0 4.4 3.6 8 8 8s8-3.6 8-8V435.1c-5.3 1.2-10.7 1.2-16 0V504z'
      
    ]
  };

  

  
  

  var faAlarmSnooze = {
    prefix: 'fat',
    iconName: 'alarm-snooze',
    icon: [
      512,
      512,
      [],
      'f845',
      
      'M157.4 25c3.2 3 3.4 8.1 .4 11.3s-8.1 3.4-11.3 .4C132.7 23.9 114.1 16 93.7 16C50.8 16 16 50.8 16 93.7c0 15.4 4.4 29.7 12.1 41.7c2.4 3.7 1.3 8.7-2.4 11s-8.7 1.3-11-2.4C5.4 129.5 0 112.2 0 93.7C0 42 42 0 93.7 0c24.6 0 47 9.5 63.7 25zm-54.1 427L45.7 509.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l57.7-57.7C54.8 400.6 32 347 32 288C32 164.3 132.3 64 256 64s224 100.3 224 224c0 59-22.8 112.6-60.1 152.6l57.7 57.7c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-57.7-57.7C368.6 489.2 315 512 256 512s-112.6-22.8-152.6-60.1zM464 288A208 208 0 1 0 48 288a208 208 0 1 0 416 0zM354.6 25C371.3 9.5 393.7 0 418.3 0C470 0 512 42 512 93.7c0 18.5-5.4 35.8-14.6 50.3c-2.4 3.7-7.3 4.8-11 2.4s-4.8-7.3-2.4-11c7.7-12 12.1-26.3 12.1-41.7C496 50.8 461.2 16 418.3 16c-20.4 0-39 7.9-52.8 20.7c-3.2 3-8.3 2.8-11.3-.4s-2.8-8.3 .4-11.3zM192 192H320c3 0 5.8 1.7 7.1 4.4s1.1 5.9-.7 8.3L207.7 368H320c4.4 0 8 3.6 8 8s-3.6 8-8 8H192c-3 0-5.8-1.7-7.1-4.4s-1.1-5.9 .7-8.3L304.3 208H192c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faSprayCan = {
    prefix: 'fat',
    iconName: 'spray-can',
    icon: [
      512,
      512,
      [],
      'f5bd',
      
      'M96 40v80 8h16v-8V40c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v80 8h16v-8V40c0-22.1-17.9-40-40-40H136C113.9 0 96 17.9 96 40zM224 176c44.2 0 80 35.8 80 80V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V256c0-44.2 35.8-80 80-80H224zM96 160c-53 0-96 43-96 96V448c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V256c0-53-43-96-96-96H96zM232 336A72 72 0 1 1 88 336a72 72 0 1 1 144 0zm-72-88a88 88 0 1 0 0 176 88 88 0 1 0 0-176zM320 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM512 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM496 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM400 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faShishKebab = {
    prefix: 'fat',
    iconName: 'shish-kebab',
    icon: [
      512,
      512,
      [],
      'f821',
      
      'M352 88c0-39.8 32.2-72 72-72s72 32.2 72 72c0 16.2-5.4 31.2-14.4 43.2c-2.7 3.5-1.9 8.5 1.6 11.2s8.5 1.9 11.2-1.6c11-14.7 17.6-33 17.6-52.8c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 11.7 2.3 22.9 6.4 33.1c6.2 15.2 5.8 31.3-3.3 40.4l-24.8 24.8L264 136c-17.7-17.7-46.3-17.7-64 0l-32 32c-17.7 17.7-17.7 46.3 0 64L280 344c17.7 17.7 46.3 17.7 64 0l32-32c17.7-17.7 17.7-46.3 0-64l-50.3-50.3 24.8-24.8c15.9-15.9 13.9-40.2 6.8-57.8c-3.4-8.3-5.3-17.5-5.3-27.1zM101.7 421.7L152 472c17.7 17.7 46.3 17.7 64 0l40-40c17.7-17.7 17.7-46.3 0-64L144 256c-17.7-17.7-46.3-17.7-64 0L40 296c-17.7 17.7-17.7 46.3 0 64l50.3 50.3-88 88c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l88-88zm77.7-201c-11.4-11.4-11.4-29.9 0-41.4l32-32c11.4-11.4 29.9-11.4 41.4 0l112 112c11.4 11.4 11.4 29.9 0 41.4l-32 32c-11.4 11.4-29.9 11.4-41.4 0l-112-112zm-128 128c-11.4-11.4-11.4-29.9 0-41.4l40-40c11.4-11.4 29.9-11.4 41.4 0l112 112c11.4 11.4 11.4 29.9 0 41.4l-40 40c-11.4 11.4-29.9 11.4-41.4 0l-112-112z'
      
    ]
  };

  

  
  

  var faFaceGrinTongueSquint = {
    prefix: 'fat',
    iconName: 'face-grin-tongue-squint',
    icon: [
      512,
      512,
      [128541,"grin-tongue-squint"],
      'f58a',
      
      'M256 16C123.5 16 16 123.5 16 256c0 99.6 60.7 185 147.1 221.4c4.1 1.7 6 6.4 4.3 10.5s-6.4 6-10.5 4.3C64.7 453.4 0 362.3 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 106.3-64.7 197.4-156.9 236.1c-4.1 1.7-8.8-.2-10.5-4.3s.2-8.8 4.3-10.5C435.3 441 496 355.6 496 256C496 123.5 388.5 16 256 16zM128.8 164.4c2-4 6.8-5.6 10.7-3.6l80 40c2.7 1.4 4.4 4.1 4.4 7.2s-1.7 5.8-4.4 7.2l-80 40c-4 2-8.8 .4-10.7-3.6s-.4-8.8 3.6-10.7L198.1 208l-65.7-32.8c-4-2-5.6-6.8-3.6-10.7zM184 409.9c0-23.2 18.8-41.9 41.9-41.9c11.1 0 21.8 4.4 29.7 12.3l.4 .4 .4-.4c7.9-7.9 18.5-12.3 29.7-12.3c23.2 0 41.9 18.8 41.9 41.9V440c0 39.8-32.2 72-72 72s-72-32.2-72-72V409.9zm64-14.6l-3.7-3.7c-4.9-4.9-11.5-7.6-18.3-7.6c-14.3 0-25.9 11.6-25.9 25.9V440c0 30.9 25.1 56 56 56s56-25.1 56-56V409.9c0-14.3-11.6-25.9-25.9-25.9c-6.9 0-13.5 2.7-18.3 7.6l-3.7 3.7V424c0 4.4-3.6 8-8 8s-8-3.6-8-8V395.3zM372.4 160.8c4-2 8.8-.4 10.7 3.6s.4 8.8-3.6 10.7L313.9 208l65.7 32.8c4 2 5.6 6.8 3.6 10.7s-6.8 5.6-10.7 3.6l-80-40c-2.7-1.4-4.4-4.1-4.4-7.2s1.7-5.8 4.4-7.2l80-40zM149.4 321c32.6 8.1 68.6 12.6 106.6 12.6s74-4.5 106.6-12.6c11.1-2.8 22.3 .3 29.6 6.9c3.7 3.4 6.5 7.8 7.5 13.1c1 5.3 0 10.9-2.9 16.1c-10 17.5-23.6 32.9-39.8 45.3c-3.5 2.7-8.5 2-11.2-1.5s-2-8.5 1.5-11.2c14.6-11.2 26.7-25 35.7-40.6c1.2-2.1 1.3-3.8 1.1-5.1c-.3-1.4-1.1-2.9-2.6-4.3c-3.1-2.9-8.8-4.7-14.9-3.2c-33.9 8.4-71.2 13.1-110.4 13.1s-76.5-4.7-110.4-13.1c-6.1-1.5-11.7 .3-14.9 3.2c-1.5 1.4-2.3 2.9-2.6 4.3c-.2 1.3-.1 3 1.1 5.1c8.9 15.6 21.1 29.4 35.7 40.6c3.5 2.7 4.2 7.7 1.5 11.2s-7.7 4.2-11.2 1.5c-16.2-12.4-29.8-27.8-39.8-45.3c-3-5.2-3.9-10.7-2.9-16.1c1-5.2 3.8-9.7 7.5-13.1c7.3-6.7 18.5-9.7 29.6-6.9z'
      
    ]
  };

  
    var faGrinTongueSquint = faFaceGrinTongueSquint;
  

  
  

  var faArrowDown91 = {
    prefix: 'fat',
    iconName: 'arrow-down-9-1',
    icon: [
      576,
      512,
      ["sort-numeric-desc","sort-numeric-down-alt"],
      'f886',
      
      'M427.9 184.1A68 68 0 1 1 428 48a68 68 0 1 1 -.1 136.1zM428 200c7.5 0 14.8-1 21.7-2.8L410 242.7c-2.9 3.3-2.6 8.4 .8 11.3s8.4 2.6 11.3-.8l65-74.6c6.3-7.3 11.6-15.4 15.6-24c6-11.6 9.4-24.7 9.4-38.7c0-.6 0-1.3 0-1.9c0-.7 0-1.4 0-2.1h-.1C509.8 67.5 473 32 428 32c-46.4 0-84 37.6-84 84s37.6 84 84 84zM165.7 477.7l112-112c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L168 452.7V40c0-4.4-3.6-8-8-8s-8 3.6-8 8V452.7L53.7 354.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l112 112c3.1 3.1 8.2 3.1 11.3 0zM436.4 289.3c-2.2-1.5-5.1-1.7-7.6-.7l-56 24c-4.1 1.7-5.9 6.4-4.2 10.5s6.4 5.9 10.5 4.2L424 308.1V464H376c-4.4 0-8 3.6-8 8s3.6 8 8 8h56 56c4.4 0 8-3.6 8-8s-3.6-8-8-8H440V296c0-2.7-1.4-5.2-3.6-6.7z'
      
    ]
  };

  
    var faSortNumericDesc = faArrowDown91;
  
    var faSortNumericDownAlt = faArrowDown91;
  

  
  

  var faCircleCaretDown = {
    prefix: 'fat',
    iconName: 'circle-caret-down',
    icon: [
      512,
      512,
      ["caret-circle-down"],
      'f32d',
      
      'M256 16a240 240 0 1 0 0 480 240 240 0 1 0 0-480zm0 496A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm0-160c-7.3 0-14.3-3-19.3-8.4L134.8 234.4c-4.4-4.7-6.8-10.8-6.8-17.2c0-13.9 11.3-25.2 25.2-25.2H358.8c13.9 0 25.2 11.3 25.2 25.2c0 6.4-2.4 12.5-6.8 17.2L275.3 343.6c-5 5.4-12 8.4-19.3 8.4zM153.2 208c-5.1 0-9.2 4.1-9.2 9.2c0 2.3 .9 4.6 2.5 6.3L248.4 332.7c2 2.1 4.7 3.3 7.6 3.3s5.6-1.2 7.6-3.3L365.5 223.5c1.6-1.7 2.5-4 2.5-6.3c0-5.1-4.1-9.2-9.2-9.2H153.2z'
      
    ]
  };

  
    var faCaretCircleDown = faCircleCaretDown;
  

  
  

  var faCalendarImage = {
    prefix: 'fat',
    iconName: 'calendar-image',
    icon: [
      448,
      512,
      [],
      'e0d4',
      
      'M120 0c4.4 0 8 3.6 8 8V64H320V8c0-4.4 3.6-8 8-8s8 3.6 8 8V64h48c35.3 0 64 28.7 64 64v48 16V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 176 128C0 92.7 28.7 64 64 64h48V8c0-4.4 3.6-8 8-8zM432 192H16V448c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V192zM112 120V80H64c-26.5 0-48 21.5-48 48v48H432V128c0-26.5-21.5-48-48-48H336v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V80H128v40c0 4.4-3.6 8-8 8s-8-3.6-8-8zM262.8 286.9c-3.2-4.5-9.9-4.4-13 .2l-59.2 85.5c-1.4 2-3.5 3.2-5.9 3.4s-4.7-.6-6.4-2.3L151.7 347c-3.5-3.5-9.3-3-12.2 1l-51 71.3c-3.8 5.3 0 12.6 6.5 12.6H352.6c6.5 0 10.3-7.4 6.5-12.7L262.8 286.9zm-26.2-9c9.4-13.6 29.4-13.8 39.1-.5L372 409.9c11.5 15.9 .2 38.1-19.4 38.1H95.1c-19.5 0-30.9-22.1-19.5-37.9l51-71.3c8.6-12.1 26-13.5 36.5-3l19.9 19.9L236.6 278zM96 272a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z'
      
    ]
  };

  

  
  

  var faCircleM = {
    prefix: 'fat',
    iconName: 'circle-m',
    icon: [
      512,
      512,
      [],
      'e115',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM142.5 131.4c-2-2.8-5.6-4-9-3s-5.6 4.1-5.6 7.6V376c0 4.4 3.6 8 8 8s8-3.6 8-8V161L249.5 308.6c1.5 2.1 3.9 3.4 6.5 3.4s5-1.2 6.5-3.4L368 161V376c0 4.4 3.6 8 8 8s8-3.6 8-8V136c0-3.5-2.2-6.6-5.6-7.6s-6.9 .1-9 3L256 290.2 142.5 131.4z'
      
    ]
  };

  

  
  

  var faDialMax = {
    prefix: 'fat',
    iconName: 'dial-max',
    icon: [
      576,
      512,
      [],
      'e15e',
      
      'M272 32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM282.3 293.7L384 395.3c-56.5 50.7-143.5 48.8-197.8-5.5c-56.2-56.2-56.2-147.4 0-203.6s147.4-56.2 203.6 0c54.3 54.3 56.2 141.3 5.5 197.8L293.7 282.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3zM401.1 401.1A160 160 0 1 0 174.9 174.9 160 160 0 1 0 401.1 401.1zM544 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM16 288a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0A32 32 0 1 0 0 288a32 32 0 1 0 64 0zM96 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM464 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 464a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm368-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faPersonDrowning = {
    prefix: 'fat',
    iconName: 'person-drowning',
    icon: [
      576,
      512,
      [],
      'e545',
      
      'M197.3 241.8c4.5 3.5 6.7 9.2 5.9 14.8L185 384.1c-5.1-.5-10.4-1.5-15.7-2.9l18.1-126.9C140.8 217.5 112 160.7 112 98.7V72c0-22.1 17.9-40 40-40s40 17.9 40 40V98.7c0 52.1 34 98 83.8 113.2c40.2 12.2 83 13.6 123.9 3.8l95-22.6c21.5-5.1 43.1 8.2 48.2 29.6s-8.2 43.1-29.6 48.2l-95 22.6c-12.9 3.1-25.8 5.3-38.9 6.7l-14.9 81.8c-5.1-1.2-10.3-2.8-15.4-4.9l14.5-79.8c1.3-7 7-12.3 14-13c12.4-1.4 24.7-3.5 36.9-6.4l95-22.6c12.9-3.1 20.9-16 17.8-28.9s-16-20.9-28.9-17.8l-95 22.6c-43.7 10.4-89.3 9-132.3-4.1C214.6 210 176 157.8 176 98.7V72c0-13.3-10.7-24-24-24s-24 10.7-24 24V98.7c0 57 26.4 109.2 69.3 143zM320 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-64-48a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm38.6 275.4c8 11.2 17.5 21.4 27.6 30.7C339.5 449.8 361.5 464 384 464s44.6-14.2 61.8-29.9c10.1-9.2 19.7-19.5 27.6-30.7c1.5-2.1 3.9-3.4 6.6-3.4s5.1 1.3 6.6 3.4c7.3 10.3 15.9 19.6 25 28.3c15.7 14.8 36.1 29.2 57.4 31.9c4.4 .6 7.5 4.6 6.9 8.9s-4.6 7.5-8.9 6.9c-26.5-3.3-50-20.7-66.4-36.1c-8.8-8.3-15.9-16.4-20.6-22.2c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8l0 0 0 0c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-4.7 5.8-11.8 13.9-20.6 22.2C59 458.7 35.5 476.1 9 479.4c-4.4 .6-8.4-2.6-8.9-6.9s2.6-8.4 6.9-8.9c21.3-2.7 41.7-17.1 57.4-31.9c9.1-8.6 17.7-18 25-28.3c1.5-2.1 3.9-3.4 6.6-3.4s5.1 1.3 6.6 3.4c7.9 11.2 17.5 21.5 27.6 30.7C147.4 449.8 169.5 464 192 464s44.6-14.2 61.8-29.9c10.1-9.2 19.6-19.5 27.6-30.7c3-4.3 10.2-4.3 13.2 0z'
      
    ]
  };

  

  
  

  var faGrapes = {
    prefix: 'fat',
    iconName: 'grapes',
    icon: [
      512,
      512,
      [],
      'e306',
      
      'M358.7 18.6c1.3-1.5 3.4-2.6 6-2.6s4.7 1 5.9 2.5c7.8 9.8 22.8 32.7 22.8 62.8c0 14-1.8 22.3-3.3 26.8c-.7 2.2-1.4 3.5-1.8 4.1c-.1 .2-.2 .3-.2 .4c-2.8 3.1-2.7 8 .3 11s7.8 3.1 11 .3c.1 0 .2-.1 .4-.3c.6-.4 1.9-1 4.1-1.8c4.5-1.5 12.8-3.3 26.8-3.3c30.1 0 53 15 62.8 22.8c1.5 1.2 2.5 3.2 2.5 5.9s-1 4.7-2.6 6c-9.8 8.1-31.1 22.7-55.4 22.7c-17.2 0-28.4-3.3-37.9-8.8c-9.8-5.7-18.3-14.1-29.8-25.6s-19.8-19.9-25.6-29.8c-5.5-9.5-8.8-20.7-8.8-37.9c0-24.3 14.6-45.6 22.7-55.4zm24.4-10C378.4 2.7 371.4 0 364.7 0s-13.7 2.7-18.4 8.4C337.7 18.9 320 43.9 320 74c0 19.5 3.8 33.6 10.9 45.9c6.9 11.8 16.7 21.6 27.6 32.6l0 0 .5 .5 .5 .5c10.9 10.9 20.8 20.8 32.6 27.6c12.4 7.2 26.5 10.9 45.9 10.9c30.1 0 55.1-17.7 65.6-26.3c5.7-4.7 8.4-11.6 8.4-18.4s-2.7-13.7-8.6-18.4c-11.1-8.8-37.4-26.3-72.8-26.3c-9.7 0-17.3 .8-23.2 1.9c1.1-5.9 1.9-13.5 1.9-23.2c0-35.3-17.5-61.7-26.3-72.8zM208 152a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM72 176a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM48 312a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM16 456a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm144-32a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm136-24a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM184 288a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm136-24a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm-72-56a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm-80-32A56 56 0 1 0 56 176a56 56 0 1 0 112 0zM88 368a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM56 512a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm144-32a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm192-80a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zM224 344a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm192-80a56 56 0 1 0 -112 0 56 56 0 1 0 112 0z'
      
    ]
  };

  

  
  

  var faBoxArchive = {
    prefix: 'fat',
    iconName: 'box-archive',
    icon: [
      512,
      512,
      ["archive"],
      'f187',
      
      'M480 48H32c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16H48 464h16c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16zm0 96H464 48 32c-17.7 0-32-14.3-32-32V64C0 46.3 14.3 32 32 32H480c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32zM160 232c0-4.4 3.6-8 8-8H344c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-4.4 0-8-3.6-8-8zm304-56h16V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V176H48V416c0 26.5 21.5 48 48 48H416c26.5 0 48-21.5 48-48V176z'
      
    ]
  };

  
    var faArchive = faBoxArchive;
  

  
  

  var faFaceSmileHorns = {
    prefix: 'fat',
    iconName: 'face-smile-horns',
    icon: [
      640,
      512,
      [],
      'e391',
      
      'M320 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496c141.4 0 256-114.6 256-256c0-27.9-4.5-54.8-12.7-79.9C616.4 111.7 634 38.9 639.8 9.6c.6-3.2-.7-6.4-3.4-8.2s-6.2-1.8-8.9 0C607.3 14.9 577.1 26.5 547 35.4c-27.3 8.2-53.8 14-71.6 17.2C432.4 19.6 378.5 0 320 0S207.6 19.6 164.5 52.6c-17.7-3.2-44.3-9-71.6-17.2c-30-9-60.2-20.6-80.5-34.1C9.7-.5 6.2-.4 3.5 1.4S-.5 6.4 .2 9.6C6 38.9 23.6 111.7 76.7 176.1C68.5 201.2 64 228.1 64 256c0 141.4 114.6 256 256 256zM556.8 158.6c-14.7-35.7-37.2-67.3-65.4-92.7c17-3.5 38.4-8.5 60.2-15.1c23.6-7.1 48.3-16 68.6-26.6c-8 32.4-25.5 85.4-63.4 134.4zM88.4 50.8c21.8 6.5 43.2 11.6 60.2 15.1c-28.2 25.4-50.7 57.1-65.4 92.7C45.3 109.6 27.8 56.6 19.8 24.2C40.1 34.8 64.7 43.7 88.4 50.8zm115 302.7c-3.6 2.5-4.5 7.5-2 11.1c22.4 32 61.9 67.4 118.6 67.4s96.1-35.4 118.6-67.4c2.5-3.6 1.7-8.6-2-11.1s-8.6-1.7-11.1 2C404.6 385.2 369.4 416 320 416s-84.6-30.8-105.4-60.6c-2.5-3.6-7.5-4.5-11.1-2zm37-65.4a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm176-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM194.5 200.4c-4.2-1.4-8.7 .9-10.1 5.1s.9 8.7 5.1 10.1l96 32c4.2 1.4 8.7-.9 10.1-5.1s-.9-8.7-5.1-10.1l-96-32zm256 15.2c4.2-1.4 6.5-5.9 5.1-10.1s-5.9-6.5-10.1-5.1l-96 32c-4.2 1.4-6.5 5.9-5.1 10.1s5.9 6.5 10.1 5.1l96-32z'
      
    ]
  };

  

  
  

  var faToggleOff = {
    prefix: 'fat',
    iconName: 'toggle-off',
    icon: [
      576,
      512,
      [],
      'f204',
      
      'M416 112c79.5 0 144 64.5 144 144s-64.5 144-144 144H160C80.5 400 16 335.5 16 256s64.5-144 144-144H416zM576 256c0-88.4-71.6-160-160-160H160C71.6 96 0 167.6 0 256s71.6 160 160 160H416c88.4 0 160-71.6 160-160zm-336 0A80 80 0 1 1 80 256a80 80 0 1 1 160 0zM64 256a96 96 0 1 0 192 0A96 96 0 1 0 64 256z'
      
    ]
  };

  

  
  

  var faDialOff = {
    prefix: 'fat',
    iconName: 'dial-off',
    icon: [
      576,
      512,
      [],
      'e162',
      
      'M272 32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM280 288V431.8c-75.8-4.2-136-66.9-136-143.8c0-79.5 64.5-144 144-144s144 64.5 144 144c0 76.8-60.2 139.6-136 143.8V288c0-4.4-3.6-8-8-8s-8 3.6-8 8zm8 160a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM544 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM16 288a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0A32 32 0 1 0 0 288a32 32 0 1 0 64 0zM96 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM464 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 464a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm368-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faFaceAwesome = {
    prefix: 'fat',
    iconName: 'face-awesome',
    icon: [
      512,
      512,
      ["gave-dandy"],
      'e409',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 208c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V192c0-30.9 25.1-56 56-56c.9 0 1.8 0 2.8 .1c-6.6 5.9-10.8 14.4-10.8 23.9c0 17.7 14.3 32 32 32c12.8 0 23.8-7.5 28.9-18.3c2 5.7 3.1 11.9 3.1 18.3v16zm-56-88c-39.8 0-72 32.2-72 72v16c0 17.7 14.3 32 32 32h80c17.7 0 32-14.3 32-32V192c0-39.8-32.2-72-72-72zm40 40a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm184 8a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-21.2-39.9c-6.6 5.9-10.8 14.4-10.8 23.9c0 17.7 14.3 32 32 32c15.1 0 27.8-10.5 31.1-24.5c5.6 9.5 8.9 20.7 8.9 32.5v17.9c0 7.8-6.3 14.1-14.1 14.1H286.1c-7.8 0-14.1-6.3-14.1-14.1V192c0-35.3 28.7-64 64-64c.9 0 1.8 0 2.8 .1zM256 192v17.9c0 16.6 13.5 30.1 30.1 30.1h99.8c16.6 0 30.1-13.5 30.1-30.1V192c0-44.2-35.8-80-80-80s-80 35.8-80 80zm4.7 240H248c-2.1 0-4.3 0-6.4-.1c7.5-36.4 39.7-63.9 78.4-63.9c17.7 0 34.1 5.8 47.3 15.5c-6.1 7.5-13.1 14.3-20.7 20.3c-24.2 17.7-53.9 28.2-86 28.2zm-35.1-1.6C154 420.2 96.9 361.8 89.5 288h305c6.4 0 11.4 5.5 10.8 11.9c-2.4 26.9-12.1 51.5-26.9 72C362.3 359.4 342 352 320 352c-47 0-86.1 33.8-94.4 78.4zm130.7-13.8c36-26.5 60.7-67.7 65-115.3c1.4-15.7-11-29.3-26.8-29.3H88.1c-8.6 0-15.4 7.5-14.6 16c8.2 90.2 83.9 160 174.5 160h12.7 4.7c34.2 0 65.8-11.7 90.9-31.4z'
      
    ]
  };

  
    var faGaveDandy = faFaceAwesome;
  

  
  

  var faSquareV = {
    prefix: 'fat',
    iconName: 'square-v',
    icon: [
      448,
      512,
      [],
      'e284',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm111.2 52.4L224 374.1 336.8 148.4c2-4 6.8-5.6 10.7-3.6s5.6 6.8 3.6 10.7l-120 240c-1.4 2.7-4.1 4.4-7.2 4.4s-5.8-1.7-7.2-4.4l-120-240c-2-4-.4-8.8 3.6-10.7s8.8-.4 10.7 3.6z'
      
    ]
  };

  

  
  

  var faDrumstick = {
    prefix: 'fat',
    iconName: 'drumstick',
    icon: [
      512,
      512,
      [127831],
      'f6d6',
      
      'M176 185.9C176 92.1 252.1 16 345.9 16C428.8 16 496 83.2 496 166.1C496 259.9 419.9 336 326.1 336h-97c-29.3 0-53.1-23.8-53.1-53.1v-97zM345.9 0C243.2 0 160 83.2 160 185.9v97c0 .6 0 1.2 0 1.8l-45.8 45.8c-3.1 3.1-9.6 3.6-15.7-.3C88.6 323.7 76.7 320 64 320c-35.3 0-64 28.7-64 64s28.7 64 64 64c0 35.3 28.7 64 64 64s64-28.7 64-64c0-12.7-3.7-24.6-10.1-34.6c-3.9-6.1-3.4-12.6-.3-15.7L227.3 352c.6 0 1.2 0 1.8 0h97C428.8 352 512 268.8 512 166.1C512 74.4 437.6 0 345.9 0zM208 348.7l-37.7 37.7c-10.3 10.3-8.2 25.8-1.8 35.6c4.8 7.5 7.6 16.4 7.6 25.9c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-8.7-7.3-16-16-16c-26.5 0-48-21.5-48-48s21.5-48 48-48c9.6 0 18.5 2.8 25.9 7.6c9.8 6.3 25.3 8.5 35.6-1.8L163.3 304c6.8 21.2 23.5 37.9 44.7 44.7z'
      
    ]
  };

  

  
  

  var faBroomBall = {
    prefix: 'fat',
    iconName: 'broom-ball',
    icon: [
      576,
      512,
      ["quidditch","quidditch-broom-ball"],
      'f458',
      
      'M573.7 2.3c3.1 3.1 3.1 8.2 0 11.3L343.3 244 386 286.7c3.8 3.8 6 9 6 14.4c0 10.3-7.6 18.9-17.8 20.2L336.5 326l2.5 32.7c3.2 41.4-11.9 82.2-41.3 111.6C271 497 234.8 512 197 512L21.9 512C9.8 512 0 502.2 0 490.1c0-6.4 2.8-12.5 7.7-16.6L93.3 400 112 384l-24.6 0-6.1 0c-9.6 0-17.3-7.8-17.3-17.3c0-29.9 11.9-58.5 33-79.7l8.7-8.7c29.4-29.4 70.2-44.5 111.6-41.3l32.7 2.5 4.7-37.7c1.3-10.2 9.9-17.8 20.2-17.8c5.4 0 10.6 2.1 14.4 6L332 232.7 562.3 2.3c3.1-3.1 8.2-3.1 11.3 0zM270.6 203.8l-5.6 45.1 62.1 62.1 45.1-5.6c2.2-.3 3.8-2.1 3.8-4.3c0-1.2-.5-2.3-1.3-3.1L278 201.3c-.8-.8-1.9-1.3-3.1-1.3c-2.2 0-4 1.6-4.3 3.8zM216.1 253c-36.8-2.8-73 10.6-99 36.6l-8.7 8.7C90.2 316.4 80 341 80 366.7c0 .7 .6 1.3 1.3 1.3H112c6.7 0 12.7 4.2 15 10.4s.5 13.3-4.6 17.7L18.1 485.6c-1.3 1.1-2.1 2.8-2.1 4.5c0 3.3 2.6 5.9 5.9 5.9L197 496c33.5 0 65.7-13.3 89.4-37c26.1-26.1 39.5-62.3 36.6-99l-2.5-32.8-71.6-71.6L216.1 253zM528 432a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-144 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z'
      
    ]
  };

  
    var faQuidditch = faBroomBall;
  
    var faQuidditchBroomBall = faBroomBall;
  

  
  

  var faUp = {
    prefix: 'fat',
    iconName: 'up',
    icon: [
      384,
      512,
      ["arrow-alt-up"],
      'f357',
      
      'M192 48c8.1 0 15.9 3.2 21.7 9L362.1 205.4c3.8 3.8 5.9 9 5.9 14.3c0 11.2-9.1 20.3-20.3 20.3H248c-4.4 0-8 3.6-8 8V440c0 13.3-10.7 24-24 24H168c-13.3 0-24-10.7-24-24V248c0-4.4-3.6-8-8-8H36.3C25.1 240 16 230.9 16 219.7c0-5.4 2.1-10.5 5.9-14.3L170.3 57c5.7-5.7 13.5-9 21.7-9zM384 219.7c0-9.6-3.8-18.9-10.6-25.7L225 45.6C216.2 36.9 204.4 32 192 32s-24.2 4.9-33 13.7L10.6 194.1C3.8 200.9 0 210.1 0 219.7c0 20 16.2 36.3 36.3 36.3H128V440c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V256h91.7c20 0 36.3-16.2 36.3-36.3z'
      
    ]
  };

  
    var faArrowAltUp = faUp;
  

  
  

  var faFence = {
    prefix: 'fat',
    iconName: 'fence',
    icon: [
      512,
      512,
      [],
      'e303',
      
      'M72 32c2.5 0 4.9 1.2 6.4 3.2l44.8 59.7c3.1 4.2 4.8 9.2 4.8 14.4V160h72V109.3c0-5.2 1.7-10.2 4.8-14.4l44.8-59.7c1.5-2 3.9-3.2 6.4-3.2s4.9 1.2 6.4 3.2l44.8 59.7c3.1 4.2 4.8 9.2 4.8 14.4V160h72V109.3c0-5.2 1.7-10.2 4.8-14.4l44.8-59.7c1.5-2 3.9-3.2 6.4-3.2s4.9 1.2 6.4 3.2l44.8 59.7c3.1 4.2 4.8 9.2 4.8 14.4V456c0 13.3-10.7 24-24 24H408c-13.3 0-24-10.7-24-24V368H312v88c0 13.3-10.7 24-24 24H224c-13.3 0-24-10.7-24-24V368H128v88c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24V109.3c0-5.2 1.7-10.2 4.8-14.4L65.6 35.2c1.5-2 3.9-3.2 6.4-3.2zM312 352h72V176H312V352zM200 176H128V352h72V176zM72 53.3L33.6 104.5c-1 1.4-1.6 3.1-1.6 4.8V456c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V109.3c0-1.7-.6-3.4-1.6-4.8L72 53.3zm368 0l-38.4 51.2c-1 1.4-1.6 3.1-1.6 4.8V456c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V109.3c0-1.7-.6-3.4-1.6-4.8L440 53.3zM217.6 104.5c-1 1.4-1.6 3.1-1.6 4.8V456c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V109.3c0-1.7-.6-3.4-1.6-4.8L256 53.3l-38.4 51.2z'
      
    ]
  };

  

  
  

  var faBlindsOpen = {
    prefix: 'fat',
    iconName: 'blinds-open',
    icon: [
      512,
      512,
      [],
      'f8fc',
      
      'M480 16c8.8 0 16 7.2 16 16V64c0 8.8-7.2 16-16 16H152 136 32c-8.8 0-16-7.2-16-16V32c0-8.8 7.2-16 16-16H480zM32 96H136v80 16 64.7c-22.7 3.8-40 23.6-40 47.3c0 12.3 4.6 23.5 12.2 32c.6 .7 1.2 1.3 1.8 1.9c8.7 8.7 20.7 14.1 33.9 14.1c14.2 0 27-6.2 35.8-16c7.6-8.5 12.2-19.7 12.2-32c0-23.8-17.3-43.5-40-47.3V192 176 96H480c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32C14.3 0 0 14.3 0 32V64C0 81.7 14.3 96 32 96zM144 272a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM8 176c-4.4 0-8 3.6-8 8s3.6 8 8 8h96V176H8zM8 336c-4.4 0-8 3.6-8 8s3.6 8 8 8H80c-3.7-4.9-6.8-10.3-9.3-16H8zm496 16c4.4 0 8-3.6 8-8s-3.6-8-8-8H217.3c-2.5 5.7-5.6 11.1-9.3 16H504zm0-160c4.4 0 8-3.6 8-8s-3.6-8-8-8H184v16H504zM0 504c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H8c-4.4 0-8 3.6-8 8z'
      
    ]
  };

  

  
  

  var faWebhook = {
    prefix: 'fat',
    iconName: 'webhook',
    icon: [
      576,
      512,
      [],
      'e5d5',
      
      'M176 128c0-61.9 50.1-112 112-112s112 50.1 112 112c0 4.4 3.6 8 8 8s8-3.6 8-8C416 57.3 358.7 0 288 0S160 57.3 160 128c0 42.7 20.9 80.6 53.1 103.8c.2 .1 .3 .3 .3 .4c0 .1 0 .1 0 .1l0 0-58.5 93.6c-8.2-3.8-17.3-5.9-26.9-5.9c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64c0-20-9.2-37.9-23.6-49.6l58.5-93.6c4.7-7.6 2.2-17.1-4.5-22C194.3 198.5 176 165.4 176 128zm0 256.1a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM288 176a48 48 0 1 1 0-96 48 48 0 1 1 0 96zM224 128c0 35.3 28.7 64 64 64c9.6 0 18.7-2.1 26.9-5.9l58.5 93.6c4.8 7.6 14.4 9.5 21.7 5.6c15.7-8.5 33.8-13.3 52.9-13.3c61.9 0 112 50.1 112 112s-50.1 112-112 112c-21.8 0-42.2-6.2-59.4-17c-3.7-2.3-8.7-1.2-11 2.5s-1.2 8.7 2.5 11C399.8 504.9 423.1 512 448 512c70.7 0 128-57.3 128-128s-57.3-128-128-128c-21.9 0-42.5 5.5-60.5 15.2c-.2 .1-.4 .1-.5 .1l-.1 0 0 0 0 0-58.5-93.6C342.8 165.9 352 148 352 128c0-35.3-28.7-64-64-64s-64 28.7-64 64zM68.3 289.2c3.7-2.4 4.9-7.3 2.5-11s-7.3-4.9-11-2.5C23.9 298.4 0 338.4 0 384c0 70.7 57.3 128 128 128c67.8 0 123.3-52.8 127.7-119.5c0-.2 .1-.4 .2-.5c0 0 .1-.1 .1-.1h0H384.5c3.9 31.6 30.9 56 63.5 56c35.3 0 64-28.7 64-64s-28.7-64-64-64c-32.6 0-59.6 24.4-63.5 56H256c-9 0-15.7 7.2-16.2 15.5C235.9 449.8 187.3 496 128 496C66.1 496 16 445.9 16 384c0-39.9 20.8-74.9 52.3-94.8zM496 384a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z'
      
    ]
  };

  

  
  

  var faScrollTorah = {
    prefix: 'fat',
    iconName: 'scroll-torah',
    icon: [
      640,
      512,
      ["torah"],
      'f6a0',
      
      'M96 56c0-22.1-17.9-40-40-40S16 33.9 16 56V456c0 22.1 17.9 40 40 40s40-17.9 40-40V56zM0 56C0 25.1 25.1 0 56 0c22.3 0 41.6 13.1 50.6 32H533.4c9-18.9 28.3-32 50.6-32c30.9 0 56 25.1 56 56V456c0 30.9-25.1 56-56 56c-22.3 0-41.6-13.1-50.6-32H106.6c-9 18.9-28.3 32-50.6 32c-30.9 0-56-25.1-56-56V56zM111.4 464H528.6c-.4-2.6-.6-5.3-.6-8V56c0-2.7 .2-5.4 .6-8H111.4c.4 2.6 .6 5.3 .6 8V456c0 2.7-.2 5.4-.6 8zM200 313.7c0-2.5 .7-5 1.9-7.2L231.4 256l-29.4-50.5c-1.3-2.2-1.9-4.7-1.9-7.2c0-7.9 6.4-14.3 14.3-14.3h59l32.6-55.9c2.9-5 8.3-8.1 14.1-8.1s11.2 3.1 14.1 8.1L366.7 184h59c7.9 0 14.3 6.4 14.3 14.3c0 2.5-.7 5-1.9 7.2L408.6 256l29.4 50.5c1.3 2.2 1.9 4.7 1.9 7.2c0 7.9-6.4 14.3-14.3 14.3h-59l-32.6 55.9c-2.9 5-8.3 8.1-14.1 8.1s-11.2-3.1-14.1-8.1L273.3 328h-59c-7.9 0-14.3-6.4-14.3-14.3zm119.7 62.1c.1 .1 .2 .2 .3 .2s.2-.1 .3-.2L348.2 328H291.8l27.9 47.8zM249.9 256l32.6 56h75l32.6-56-32.6-56h-75l-32.6 56zm149.5 15.9L376 312h46.7l-23.4-40.1zM422.7 200H376l23.4 40.1L422.7 200zM320.3 136.2c-.1-.1-.2-.2-.3-.2s-.2 .1-.3 .2L291.8 184h56.3l-27.9-47.8zM217.3 200l23.4 40.1L264 200H217.3zM264 312l-23.4-40.1L217.3 312H264zM624 56c0-22.1-17.9-40-40-40s-40 17.9-40 40V456c0 22.1 17.9 40 40 40s40-17.9 40-40V56z'
      
    ]
  };

  
    var faTorah = faScrollTorah;
  

  
  

  var faDownRight = {
    prefix: 'fat',
    iconName: 'down-right',
    icon: [
      384,
      512,
      [],
      'e16b',
      
      'M336 416c8.8 0 16-7.2 16-16V164.3c0-11.2-9.1-20.3-20.3-20.3c-5.4 0-10.5 2.1-14.3 5.9l-75.7 75.7c-3.1 3.1-8.2 3.1-11.3 0L93.7 89c-5.7-5.7-13.5-9-21.7-9s-15.9 3.2-21.7 9L25 114.4c-5.7 5.7-9 13.5-9 21.7s3.2 15.9 9 21.7L161.7 294.3c1.5 1.5 2.3 3.5 2.3 5.7s-.8 4.2-2.3 5.7L85.9 381.4c-3.8 3.8-5.9 9-5.9 14.3c0 11.2 9.1 20.3 20.3 20.3H336zm32-16c0 17.7-14.3 32-32 32H100.3c-20 0-36.3-16.2-36.3-36.3c0-9.6 3.8-18.9 10.6-25.7L144.7 300 13.7 169C4.9 160.2 0 148.4 0 136s4.9-24.2 13.7-33L39 77.7C47.8 68.9 59.6 64 72 64s24.2 4.9 33 13.7l131 131 70.1-70.1c6.8-6.8 16-10.6 25.7-10.6c20 0 36.3 16.2 36.3 36.3V400z'
      
    ]
  };

  

  
  

  var faPersonArrowUpFromLine = {
    prefix: 'fat',
    iconName: 'person-arrow-up-from-line',
    icon: [
      640,
      512,
      [],
      'e539',
      
      'M232 56a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm-96 0a56 56 0 1 1 112 0A56 56 0 1 1 136 56zM122.7 175.7L55.2 315.5c-1.9 4-6.7 5.6-10.7 3.7s-5.6-6.7-3.7-10.7l67.5-139.8c12-24.9 37.2-40.7 64.8-40.7h37.8c27.6 0 52.8 15.8 64.8 40.7l67.5 139.8c1.9 4 .3 8.8-3.7 10.7s-8.8 .3-10.7-3.7L261.3 175.7C252 156.3 232.4 144 210.9 144H173.1c-21.5 0-41.1 12.3-50.4 31.7zM128 240c4.4 0 8 3.6 8 8V480c0 8.8 7.2 16 16 16s16-7.2 16-16V360c0-13.3 10.7-24 24-24s24 10.7 24 24V480c0 8.8 7.2 16 16 16s16-7.2 16-16V248c0-4.4 3.6-8 8-8s8 3.6 8 8V480c0 5.8-1.6 11.3-4.3 16H632c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H124.3c-2.7-4.7-4.3-10.2-4.3-16V248c0-4.4 3.6-8 8-8zm51.7 256h24.6c-2.7-4.7-4.3-10.2-4.3-16V360c0-4.4-3.6-8-8-8s-8 3.6-8 8V480c0 5.8-1.6 11.3-4.3 16zM597.9 138.6c3 3.2 2.8 8.3-.5 11.3s-8.3 2.8-11.3-.5L504 60.5 504 408c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-347.5-82.1 89c-3 3.2-8.1 3.4-11.3 .5s-3.4-8.1-.5-11.3l96-104c1.5-1.6 3.6-2.6 5.9-2.6s4.4 .9 5.9 2.6l96 104z'
      
    ]
  };

  

  
  

  var faBowlingPins = {
    prefix: 'fat',
    iconName: 'bowling-pins',
    icon: [
      512,
      512,
      [],
      'f437',
      
      'M88 64c0-26.5 21.5-48 48-48s48 21.5 48 48v.9c0 14.4-2.3 28.8-6.9 42.5l-7.2 21.7c-3.3 10-5.3 20.4-6 30.9H108.1c-.6-10.5-2.6-20.9-6-30.9l-7.2-21.7C90.3 93.7 88 79.3 88 64.9V64zm20 112h56c.4 5 1 9.9 2 14.9c1.5 7.6 3.8 15.1 6.7 22.3l38.5 93.6c8.4 20.4 12.7 42.2 12.7 64.2c0 28.2-7.1 56-20.6 80.8L179.3 496H92.7L68.6 451.7C55.1 426.9 48 399.2 48 371c0-22 4.3-43.8 12.7-64.2l38.5-93.6c3-7.2 5.2-14.6 6.7-22.3c1-4.9 1.7-9.9 2-14.9zM136 0C100.7 0 72 28.7 72 64v.9c0 16.2 2.6 32.2 7.7 47.5L87 134.2c5.8 17.3 6.9 35.7 3.3 53.6C89 194.3 87 200.8 84.5 207L45.9 300.6C36.7 322.9 32 346.8 32 371c0 30.9 7.8 61.3 22.5 88.4l24.2 44.3c2.8 5.1 8.2 8.3 14 8.3h86.5c5.9 0 11.2-3.2 14-8.3l24.2-44.3C232.2 432.3 240 401.8 240 371c0-24.1-4.7-48-13.9-70.3L187.5 207c-2.6-6.2-4.5-12.7-5.8-19.3c-3.6-17.8-2.4-36.3 3.3-53.6l7.2-21.7c5.1-15.3 7.7-31.4 7.7-47.5V64c0-35.3-28.7-64-64-64zM328 64c0-26.5 21.5-48 48-48s48 21.5 48 48v.9c0 14.4-2.3 28.8-6.9 42.5l-7.2 21.7c-3.3 10-5.3 20.4-6 30.9H348.1c-.6-10.5-2.6-20.9-6-30.9l-7.2-21.7c-4.6-13.7-6.9-28-6.9-42.5V64zm20 112h56c.4 5 1 9.9 2 14.9c1.5 7.6 3.8 15.1 6.7 22.3l38.5 93.6c8.4 20.4 12.7 42.2 12.7 64.2c0 28.2-7.1 56-20.6 80.8L419.3 496H332.7l-24.2-44.3C295.1 426.9 288 399.2 288 371c0-22 4.3-43.8 12.7-64.2l38.5-93.6c3-7.2 5.2-14.6 6.7-22.3c1-4.9 1.7-9.9 2-14.9zM376 0c-35.3 0-64 28.7-64 64v.9c0 16.2 2.6 32.2 7.7 47.5l7.2 21.7c5.8 17.3 6.9 35.7 3.3 53.6c-1.3 6.6-3.3 13.1-5.8 19.3l-38.5 93.6C276.7 322.9 272 346.8 272 371c0 30.9 7.8 61.3 22.5 88.4l24.2 44.3c2.8 5.1 8.2 8.3 14 8.3h86.5c5.9 0 11.2-3.2 14-8.3l24.2-44.3C472.2 432.3 480 401.8 480 371c0-24.1-4.7-48-13.9-70.3L427.5 207c-2.6-6.2-4.5-12.7-5.8-19.3c-3.6-17.8-2.4-36.3 3.3-53.6l7.2-21.7c5.1-15.3 7.7-31.4 7.7-47.5V64c0-35.3-28.7-64-64-64z'
      
    ]
  };

  

  
  

  var faPencilSlash = {
    prefix: 'fat',
    iconName: 'pencil-slash',
    icon: [
      640,
      512,
      [],
      'e215',
      
      'M13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7zM319.6 347.4l-90.9 90.9c-1.5 1.5-3.1 3-4.7 4.4V408c0-4.4-3.6-8-8-8H176V360c0-4.4-3.6-8-8-8H133.2c1.4-1.6 2.9-3.2 4.4-4.7l80.2-80.2-12.6-10L126.3 336c-12.3 12.3-21.3 27.5-26.2 44.2L64.3 501.7c-.8 2.8-.1 5.8 2 7.9s5.1 2.8 7.9 2l121.6-35.8c16.7-4.9 31.9-13.9 44.2-26.2l92.2-92.2-12.6-10zm128-332.8L307.7 154.6l12.6 10 60.4-60.4 91.1 91.1-49.7 49.7 12.6 10L561.4 128.3c18.7-18.7 18.7-49.1 0-67.9L515.5 14.6c-18.7-18.7-49.1-18.7-67.9 0zm56.6 11.3l45.8 45.8c12.5 12.5 12.5 32.8 0 45.3l-66.9 66.9L392.1 92.8 459 25.9c12.5-12.5 32.8-12.5 45.3 0zM122.3 368H160v40c0 4.4 3.6 8 8 8h40v37.7c-5.3 2.8-10.9 5.1-16.7 6.8L83.8 492.2l31.6-107.5c1.7-5.8 4-11.4 6.8-16.7z'
      
    ]
  };

  

  
  

  var faUserNinja = {
    prefix: 'fat',
    iconName: 'user-ninja',
    icon: [
      448,
      512,
      [129399],
      'f504',
      
      'M336 128a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm16 0c0 70.7-57.3 128-128 128c-69.6 0-126.2-55.5-128-124.7L45.7 181.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L92.7 112 34.3 53.7c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L99.9 96.6C113.9 41.1 164.2 0 224 0c70.7 0 128 57.3 128 128zM298 317.2c6.7-8.8 18.6-11.9 28.7-7.4l13.4 5.9C405.6 344.2 448 409 448 480.5c0 17.4-14.1 31.5-31.5 31.5H31.5C14.1 512 0 497.9 0 480.5c0-71.5 42.4-136.3 107.9-165l13.4-5.8c10.1-4.4 22-1.4 28.7 7.5l73.9 97.2L298 317.2zM234 427.6L286 496H416.5c8.5 0 15.5-6.9 15.5-15.5c0-65.2-38.6-124.2-98.3-150.3l-13.4-5.9c-3.4-1.5-7.3-.5-9.6 2.5L234 427.6zM265.9 496L137.3 326.9c-2.2-2.9-6.2-4-9.6-2.5l-13.4 5.8C54.6 356.3 16 415.4 16 480.5c0 8.5 6.9 15.5 15.5 15.5H265.9zM160 112c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm-16 0c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H176c-17.7 0-32-14.3-32-32z'
      
    ]
  };

  

  
  

  var fa7 = {
    prefix: 'fat',
    iconName: '7',
    icon: [
      320,
      512,
      [],
      '37',
      
      'M0 40c0-4.4 3.6-8 8-8H312c2.9 0 5.6 1.6 7 4.1s1.3 5.7-.2 8.1l-272 432c-2.4 3.7-7.3 4.9-11 2.5s-4.9-7.3-2.5-11L297.5 48H8c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faBlog = {
    prefix: 'fat',
    iconName: 'blog',
    icon: [
      512,
      512,
      [],
      'f781',
      
      'M200 32c-4.4 0-8 3.6-8 8s3.6 8 8 8c145.8 0 264 118.2 264 264c0 4.4 3.6 8 8 8s8-3.6 8-8C480 157.4 354.6 32 200 32zm0 96c-4.4 0-8 3.6-8 8s3.6 8 8 8c92.8 0 168 75.2 168 168c0 4.4 3.6 8 8 8s8-3.6 8-8c0-101.6-82.4-184-184-184zM16 104c0-4.4-3.6-8-8-8s-8 3.6-8 8V368c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144h-8c-4.4 0-8 3.6-8 8s3.6 8 8 8h8c70.7 0 128 57.3 128 128s-57.3 128-128 128S16 438.7 16 368V104z'
      
    ]
  };

  

  
  

  var faCircle9 = {
    prefix: 'fat',
    iconName: 'circle-9',
    icon: [
      512,
      512,
      [],
      'e0f6',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM210 381.3c2.9 3.3 8 3.7 11.3 .8l97.9-85.7c8.7-7.6 15.9-16.6 21.2-26.6c7.4-13.6 11.6-29.2 11.6-45.8c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c4.3 0 8.6-.3 12.8-.8L210.7 370c-3.3 2.9-3.7 8-.8 11.3zM255.9 304a80 80 0 1 1 .1-160 80 80 0 1 1 -.1 160z'
      
    ]
  };

  

  
  

  var faSheetPlastic = {
    prefix: 'fat',
    iconName: 'sheet-plastic',
    icon: [
      384,
      512,
      [],
      'e571',
      
      'M320 16c26.5 0 48 21.5 48 48V332.1c0 1.3-.1 2.6-.2 3.9H248c-22.1 0-40 17.9-40 40V495.8c-1.3 .2-2.6 .2-3.9 .2H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H320zm41.1 336c-.8 1-1.6 1.9-2.4 2.7L226.7 486.6c-.9 .9-1.8 1.7-2.7 2.4V376c0-13.3 10.7-24 24-24H361.1zM0 448c0 35.3 28.7 64 64 64H204.1c12.7 0 24.9-5.1 33.9-14.1L369.9 366.1c9-9 14.1-21.2 14.1-33.9V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448zM173.7 66.3c-3.1-3.1-8.2-3.1-11.3 0l-96 96c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l96-96c3.1-3.1 3.1-8.2 0-11.3zm96 43.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-160 160c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l160-160z'
      
    ]
  };

  

  
  

  var faFaceUnamused = {
    prefix: 'fat',
    iconName: 'face-unamused',
    icon: [
      512,
      512,
      [],
      'e39f',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM322.1 397.4C309.3 383.1 287.3 368 256 368s-53.3 15.1-66.1 29.4c-3 3.3-8 3.6-11.3 .6s-3.6-8-.6-11.3C193.1 370 219.1 352 256 352s62.9 18 77.9 34.6c3 3.3 2.7 8.3-.6 11.3s-8.3 2.7-11.3-.6zM104 192h72c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32c0-5.8 1.6-11.3 4.3-16H104c-4.4 0-8-3.6-8-8s3.6-8 8-8zm72 16a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm112-8c0-4.4 3.6-8 8-8h72c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32c0-5.8 1.6-11.3 4.3-16H296c-4.4 0-8-3.6-8-8zm64 24a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z'
      
    ]
  };

  

  
  

  var faMessageArrowDown = {
    prefix: 'fat',
    iconName: 'message-arrow-down',
    icon: [
      512,
      512,
      ["comment-alt-arrow-down"],
      'e1db',
      
      'M176 416c0-8.8-7.2-16-16-16H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H309.3c-3.5 0-6.8 1.1-9.6 3.2L176 496V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h80 16v16 64c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM264 104c0-4.4-3.6-8-8-8s-8 3.6-8 8V276.7l-74.3-74.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l88 88c3.1 3.1 8.2 3.1 11.3 0l88-88c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L264 276.7V104z'
      
    ]
  };

  
    var faCommentAltArrowDown = faMessageArrowDown;
  

  
  

  var faGolfFlagHole = {
    prefix: 'fat',
    iconName: 'golf-flag-hole',
    icon: [
      512,
      512,
      [],
      'e3ac',
      
      'M131.8 1.2c2.4-1.5 5.3-1.6 7.8-.4l240 120c2.7 1.4 4.4 4.1 4.4 7.2s-1.7 5.8-4.4 7.2L144 252.9v61.5c33.8-6.7 71.8-10.5 112-10.5c141.4 0 256 46.6 256 104s-114.6 104-256 104S0 465.4 0 408c0-32.8 37.5-62.1 96-81.2v16.9c-5.2 1.8-10.2 3.7-15 5.6c-22 9-38.8 19.2-49.8 29.8C20.2 389.6 16 399.4 16 408s4.2 18.4 15.2 28.9c11 10.6 27.8 20.8 49.8 29.8C125 484.6 186.8 496 256 496s131-11.4 175-29.3c22-9 38.8-19.2 49.8-29.8c11-10.5 15.2-20.3 15.2-28.9s-4.2-18.4-15.2-28.9c-11-10.6-27.8-20.8-49.8-29.8C387 331.4 325.2 320 256 320c-40.6 0-78.6 3.9-112 10.8v50.7c17.2-12.9 46.6-21.5 80-21.5c53 0 96 21.5 96 48s-43 48-96 48s-96-21.5-96-48V334.4 317.9 248 8c0-2.8 1.4-5.3 3.8-6.8zM144 408c0 3.9 3.6 11.8 19.3 19.6C178 435 199.4 440 224 440s46-5 60.7-12.4c15.7-7.8 19.3-15.7 19.3-19.6s-3.6-11.8-19.3-19.6C270 381 248.6 376 224 376s-46 5-60.7 12.4C147.6 396.2 144 404.1 144 408zm0-172.9L358.1 128 144 20.9V235.1z'
      
    ]
  };

  

  
  

  var faBookBlank = {
    prefix: 'fat',
    iconName: 'book-blank',
    icon: [
      448,
      512,
      [128213,128215,128216,128217,"book-alt"],
      'f5d9',
      
      'M0 56C0 25.1 25.1 0 56 0H408c22.1 0 40 17.9 40 40V376c0 19.4-13.7 35.5-32 39.2V496h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H56c-30.9 0-56-25.1-56-56V56zM56 416c-22.1 0-40 17.9-40 40s17.9 40 40 40H400V416H56zm-40 .8C26.2 406.4 40.3 400 56 400h56V16H56C33.9 16 16 33.9 16 56V416.8zM128 16V400H408c13.3 0 24-10.7 24-24V40c0-13.3-10.7-24-24-24H128z'
      
    ]
  };

  
    var faBookAlt = faBookBlank;
  

  
  

  var faVialVirus = {
    prefix: 'fat',
    iconName: 'vial-virus',
    icon: [
      512,
      512,
      [],
      'e597',
      
      'M0 40c0-4.4 3.6-8 8-8H248c4.4 0 8 3.6 8 8s-3.6 8-8 8H224V224c0 4.4-3.6 8-8 8s-8-3.6-8-8V208H48V384c0 44.2 35.8 80 80 80c22.9 0 43.6-9.6 58.2-25.1c3-3.2 8.1-3.4 11.3-.3s3.4 8.1 .3 11.3C180.3 468.4 155.5 480 128 480c-53 0-96-43-96-96V48H8c-4.4 0-8-3.6-8-8zM48 192H208V48H48V192zM472.5 324.2c4.5 2.4 9.7 3.9 15.5 3.9c13.3 0 24 10.7 24 24s-10.7 24-24 24c-28.8 0-43.2 34.8-22.9 55.2c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-20.4-20.4-55.2-5.9-55.2 22.9c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-28.8-34.8-43.2-55.2-22.9c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c20.4-20.4 5.9-55.2-22.9-55.2c-13.3 0-24-10.7-24-24s10.7-24 24-24c28.8 0 43.2-34.8 22.9-55.2c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0c20.4 20.4 55.2 5.9 55.2-22.9c0-13.3 10.7-24 24-24s24 10.7 24 24c0 28.8 34.8 43.3 55.2 22.9c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-16.3 16.3-10.4 41.7 7.3 51.4zM352 208c-4.4 0-8 3.6-8 8c0 43.1-52.1 64.6-82.5 34.2c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3C280.6 292 259.1 344 216 344c-4.4 0-8 3.6-8 8s3.6 8 8 8c43.1 0 64.6 52.1 34.2 82.5c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0c30.5-30.5 82.5-8.9 82.5 34.2c0 4.4 3.6 8 8 8s8-3.6 8-8c0-43.1 52.1-64.6 82.5-34.2c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3C423.4 412.1 445 360 488.1 360c4.4 0 8-3.6 8-8s-3.6-8-8-8c-43.1 0-64.6-52.1-34.2-82.5c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0C412.1 280.6 360 259.1 360 216c0-4.4-3.6-8-8-8zM336 320a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faCloudXmark = {
    prefix: 'fat',
    iconName: 'cloud-xmark',
    icon: [
      640,
      512,
      [],
      'e35f',
      
      'M522.7 220.8c3.4-8.9 5.3-18.6 5.3-28.8c0-44.2-35.8-80-80-80c-16.5 0-31.7 5-44.4 13.5c-3.7 2.5-8.2 3.3-12.5 2.3s-8-3.8-10.2-7.6C355.9 77 309.3 48 256 48c-79.5 0-144 64.5-144 144c0 2.5 .1 4.9 .2 7.3c.4 7.1-4 13.5-10.7 15.9C51.7 232.7 16 280.2 16 336c0 70.7 57.3 128 128 128H512c61.9 0 112-50.1 112-112c0-54.2-38.5-99.4-89.6-109.8c-4.6-.9-8.6-3.9-10.9-8s-2.6-9.1-.9-13.4zM256 32c53.6 0 101 26.3 130 66.7c3.1 4.3 6 8.8 8.7 13.4c3.5-2.4 7.2-4.5 11-6.4C418.5 99.5 432.8 96 448 96c53 0 96 43 96 96c0 6.6-.7 13-1.9 19.2c-1.1 5.3-2.6 10.5-4.5 15.4c5.3 1.1 10.5 2.5 15.5 4.2C603.6 247.9 640 295.7 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160zM242.3 210.3c3.1-3.1 8.2-3.1 11.3 0L320 276.7l66.3-66.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L331.3 288l66.3 66.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L320 299.3l-66.3 66.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L308.7 288l-66.3-66.3c-3.1-3.1-3.1-8.2 0-11.3z'
      
    ]
  };

  

  
  

  var faUserCheck = {
    prefix: 'fat',
    iconName: 'user-check',
    icon: [
      640,
      512,
      [],
      'f4fc',
      
      'M224 16a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 240A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 64h91.4C359.3 320 432 392.7 432 482.3c0 7.6-6.1 13.7-13.7 13.7H29.7c-7.6 0-13.7-6.1-13.7-13.7C16 392.7 88.7 320 178.3 320zm0-16C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3zM629.7 149.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L496 260.7l-58.3-58.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l64 64c3.1 3.1 8.2 3.1 11.3 0l128-128z'
      
    ]
  };

  

  
  

  var faArrowDownToSquare = {
    prefix: 'fat',
    iconName: 'arrow-down-to-square',
    icon: [
      512,
      512,
      [],
      'e096',
      
      'M373.7 221.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L264 308.7V8c0-4.4-3.6-8-8-8s-8 3.6-8 8V308.7l-98.3-98.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l112 112c3.1 3.1 8.2 3.1 11.3 0l112-112zM56 32C25.1 32 0 57.1 0 88V456c0 30.9 25.1 56 56 56H456c30.9 0 56-25.1 56-56V88c0-30.9-25.1-56-56-56H408c-4.4 0-8 3.6-8 8s3.6 8 8 8h48c22.1 0 40 17.9 40 40V456c0 22.1-17.9 40-40 40H56c-22.1 0-40-17.9-40-40V88c0-22.1 17.9-40 40-40h48c4.4 0 8-3.6 8-8s-3.6-8-8-8H56z'
      
    ]
  };

  

  
  

  var faNote = {
    prefix: 'fat',
    iconName: 'note',
    icon: [
      448,
      512,
      [],
      'e1ff',
      
      'M384 48c26.5 0 48 21.5 48 48V316.1c0 1.3-.1 2.6-.2 3.9H336c-26.5 0-48 21.5-48 48v95.8c-1.3 .2-2.6 .2-3.9 .2H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H384zM306.7 454.6c-.9 .9-1.8 1.7-2.7 2.4V368c0-17.7 14.3-32 32-32h89.1c-.8 1-1.6 1.9-2.4 2.7L306.7 454.6zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H284.1c12.7 0 24.9-5.1 33.9-14.1L433.9 350.1c9-9 14.1-21.2 14.1-33.9V96c0-35.3-28.7-64-64-64H64zM96 400a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm0-48a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM80 128a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 272a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm0-48a32 32 0 1 0 0 64 32 32 0 1 0 0-64z'
      
    ]
  };

  

  
  

  var faTruckRampBox = {
    prefix: 'fat',
    iconName: 'truck-ramp-box',
    icon: [
      640,
      512,
      ["truck-loading"],
      'f4de',
      
      'M352 72c0-39.8 32.2-72 72-72H632c4.4 0 8 3.6 8 8s-3.6 8-8 8H424c-30.9 0-56 25.1-56 56V392.5l50.1-14.4C428.3 326.8 473.6 288 528 288c61.9 0 112 50.1 112 112s-50.1 112-112 112s-112-50.1-112-112c0-1.5 0-3.1 .1-4.6L10.2 511.7c-4.2 1.2-8.7-1.2-9.9-5.5s1.2-8.7 5.5-9.9L352 397.1V72zM624 400a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM204.4 142.6l-38.6 10.4 18.6 69.5c2.3 8.5-2.8 17.3-11.3 19.6l-46.4 12.4c-8.5 2.3-17.3-2.8-19.6-11.3L88.5 173.6 49.9 184c-8.5 2.3-13.6 11.1-11.3 19.6L80 358.1c2.3 8.5 11.1 13.6 19.6 11.3L254.1 328c8.5-2.3 13.6-11.1 11.3-19.6L224 153.9c-2.3-8.5-11.1-13.6-19.6-11.3zM104 169.5L122.6 239 169 226.6l-18.6-69.5L104 169.5zm-58.2-1l154.5-41.4c17.1-4.6 34.6 5.6 39.2 22.6l41.4 154.5c4.6 17.1-5.6 34.6-22.6 39.2L103.7 384.9c-17.1 4.6-34.6-5.6-39.2-22.6L23.1 207.7c-4.6-17.1 5.6-34.6 22.6-39.2z'
      
    ]
  };

  
    var faTruckLoading = faTruckRampBox;
  

  
  

  var faBlueberries = {
    prefix: 'fat',
    iconName: 'blueberries',
    icon: [
      512,
      512,
      [],
      'e2e8',
      
      'M383.9 328.7c65-20.3 112.1-81 112.1-152.7c0-88.4-71.6-160-160-160c-71.7 0-132.4 47.1-152.7 112.1c-2.4-.1-4.8-.1-7.3-.1c-3.2 0-6.3 .1-9.4 .2C187.4 54.2 255.4 0 336 0c97.2 0 176 78.8 176 176c0 80.6-54.2 148.6-128.2 169.4c.1-3.1 .2-6.3 .2-9.4c0-2.4 0-4.9-.1-7.3zM336 336A160 160 0 1 0 16 336a160 160 0 1 0 320 0zM0 336a176 176 0 1 1 352 0A176 176 0 1 1 0 336zm168-96v40h40c4.4 0 8 3.6 8 8s-3.6 8-8 8H168v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V296H112c-4.4 0-8-3.6-8-8s3.6-8 8-8h40V240c0-4.4 3.6-8 8-8s8 3.6 8 8zM360 80v40h40c4.4 0 8 3.6 8 8s-3.6 8-8 8H360v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V136H304c-4.4 0-8-3.6-8-8s3.6-8 8-8h40V80c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faPenField = {
    prefix: 'fat',
    iconName: 'pen-field',
    icon: [
      640,
      512,
      [],
      'e211',
      
      'M596.5 31.8l11.9 11.9c15.6 15.6 15.6 40.9 0 56.6L568 140.7 499.7 72.4l40-40.5c15.6-15.8 41-15.8 56.7-.2zm-264 209.8l156-157.8L556.7 152 399.9 308.9c-5.5 5.5-12.5 9.3-20.1 10.9l-73.5 15.4 15.5-73.7c1.6-7.5 5.3-14.4 10.7-19.9zM528.4 20.7L321.1 230.3c-7.6 7.7-12.8 17.3-15 27.9l-18 85.6c-.6 2.6 .3 5.4 2.2 7.3s4.7 2.7 7.3 2.2l85.5-17.9c10.6-2.2 20.4-7.5 28.1-15.2L619.7 111.6c21.9-21.9 21.9-57.3 0-79.2L607.8 20.5c-22-22-57.6-21.9-79.4 .2zM56 128c-30.9 0-56 25.1-56 56V456c0 30.9 25.1 56 56 56H520c30.9 0 56-25.1 56-56V264c0-4.4-3.6-8-8-8s-8 3.6-8 8V456c0 22.1-17.9 40-40 40H56c-22.1 0-40-17.9-40-40V184c0-22.1 17.9-40 40-40H312c4.4 0 8-3.6 8-8s-3.6-8-8-8H56zm72 208a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm112-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faClipboardList = {
    prefix: 'fat',
    iconName: 'clipboard-list',
    icon: [
      384,
      512,
      [],
      'f46d',
      
      'M120.4 64c4-36 34.5-64 71.6-64s67.6 28 71.6 64H272c20.9 0 38.7 13.4 45.3 32H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h2.7C73.3 77.4 91.1 64 112 64h8.4zM64 112c-26.5 0-48 21.5-48 48V448c0 26.5 21.5 48 48 48H320c26.5 0 48-21.5 48-48V160c0-26.5-21.5-48-48-48v16c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V112zM192 16c-30.9 0-56 25.1-56 56c0 4.4-3.6 8-8 8H112c-17.7 0-32 14.3-32 32v16c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16V112c0-17.7-14.3-32-32-32H256c-4.4 0-8-3.6-8-8c0-30.9-25.1-56-56-56zM176 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM160 224c0-4.4 3.6-8 8-8H312c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-4.4 0-8-3.6-8-8zm0 96c0-4.4 3.6-8 8-8H312c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-4.4 0-8-3.6-8-8zm0 96c0-4.4 3.6-8 8-8H312c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-4.4 0-8-3.6-8-8zM96 400a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM80 320a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM96 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faPumpkin = {
    prefix: 'fat',
    iconName: 'pumpkin',
    icon: [
      576,
      512,
      [],
      'f707',
      
      'M292.5 16c.2 0 .3 0 .5 .1l42.3 18.1c.5 .2 .8 .7 .8 1.2V111c5.5 1.6 10.8 3.5 16 5.7V35.4c0-6.9-4.1-13.2-10.5-15.9L299.3 1.4c-2.2-.9-4.5-1.4-6.8-1.4h-1.2c-6.9 0-13.1 4.1-15.8 10.4l14.7 6.4c.2-.5 .7-.8 1.2-.8h1.2zm-17-5.6L230 114.3c6.5-2.4 13.2-4.4 20.1-6l40-91.5-14.7-6.4zM188.3 136.8c5-3.7 10.1-7.1 15.5-10.2C186.6 117.2 167.8 112 148 112c-41.8 0-79 23.3-105.5 59.5S0 257.5 0 312s16.1 104.2 42.5 140.5S106.2 512 148 512c25.5 0 49.3-8.7 70-23.6c20.7 15 44.5 23.6 70 23.6s49.3-8.7 70-23.6c20.7 15 44.5 23.6 70 23.6c41.8 0 79-23.3 105.5-59.5S576 366.5 576 312s-16.1-104.2-42.5-140.5S469.8 112 428 112c-19.8 0-38.6 5.2-55.8 14.6c5.4 3.1 10.5 6.5 15.5 10.2c12.8-5.7 26.3-8.8 40.3-8.8c35.5 0 68.3 19.7 92.5 52.9S560 260.5 560 312s-15.2 97.8-39.5 131c-24.2 33.2-57.1 53-92.5 53c-23.5 0-45.7-8.6-65-24c-2.9-2.3-7-2.3-9.9 0c-19.4 15.4-41.6 24-65 24s-45.7-8.6-65-24c-2.9-2.3-7-2.3-9.9 0c-19.4 15.4-41.6 24-65 24c-35.5 0-68.3-19.7-92.5-53C31.2 409.8 16 363.5 16 312s15.2-97.8 39.5-131.1S112.5 128 148 128c14 0 27.5 3.1 40.3 8.8zM288 152c41.2 0 77.6 20.8 99.2 52.5c2.5 3.7 7.5 4.6 11.1 2.1s4.6-7.5 2.1-11.1C376 159.6 334.7 136 288 136s-88 23.6-112.4 59.5c-2.5 3.7-1.5 8.6 2.1 11.1s8.6 1.5 11.1-2.1c21.6-31.7 58-52.5 99.2-52.5z'
      
    ]
  };

  

  
  

  var faCodePullRequest = {
    prefix: 'fat',
    iconName: 'code-pull-request',
    icon: [
      512,
      512,
      [],
      'e13c',
      
      'M32 64a48 48 0 1 1 96 0A48 48 0 1 1 32 64zm56 63.5c31.6-3.9 56-30.9 56-63.5c0-35.3-28.7-64-64-64S16 28.7 16 64c0 32.6 24.4 59.6 56 63.5v257c-31.6 3.9-56 30.9-56 63.5c0 35.3 28.7 64 64 64s64-28.7 64-64c0-32.6-24.4-59.6-56-63.5v-257zM32 448a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm400-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112c35.3 0 64-28.7 64-64c0-32.6-24.4-59.6-56-63.5V192c0-57.4-46.6-104-104-104H244.7l72.7-66.1c3.3-3 3.5-8 .5-11.3s-8-3.5-11.3-.5l-88 80C217 91.6 216 93.7 216 96s1 4.4 2.6 5.9l88 80c3.3 3 8.3 2.7 11.3-.5s2.7-8.3-.5-11.3L244.7 104H336c48.6 0 88 39.4 88 88V384.5c-31.6 3.9-56 30.9-56 63.5c0 35.3 28.7 64 64 64z'
      
    ]
  };

  

  
  

  var faDesktopArrowDown = {
    prefix: 'fat',
    iconName: 'desktop-arrow-down',
    icon: [
      576,
      512,
      [],
      'e155',
      
      'M64 0H248V16H64C37.5 16 16 37.5 16 64V352c0 26.5 21.5 48 48 48H231.8h.3H343.9h.3H512c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H328V0H512c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H353.4l13.3 80H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H360 216 136c-4.4 0-8-3.6-8-8s3.6-8 8-8h73.2l13.3-80H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0zM80 64H248V80H80l0 192H496V80H328V64H496c8.8 0 16 7.2 16 16V272c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zM225.4 496H350.6l-13.3-80H238.8l-13.3 80zM296 8V212.7l74.3-74.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-88 88c-3.1 3.1-8.2 3.1-11.3 0l-88-88c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L280 212.7V8c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faPaste = {
    prefix: 'fat',
    iconName: 'paste',
    icon: [
      512,
      512,
      ["file-clipboard"],
      'f0ea',
      
      'M128.6 41.6C131.6 27 144.5 16 160 16s28.4 11 31.4 25.6c.8 3.7 4 6.4 7.8 6.4H216c13.3 0 24 10.7 24 24V88c0 4.4-3.6 8-8 8H88c-4.4 0-8-3.6-8-8V72c0-13.3 10.7-24 24-24h16.8c3.8 0 7.1-2.7 7.8-6.4zM160 0c-20.9 0-38.7 13.4-45.3 32H104c-13.1 0-24.7 6.3-32 16H64C28.7 48 0 76.7 0 112V384c0 35.3 28.7 64 64 64H192V432H64c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h.8c-.5 2.6-.8 5.3-.8 8V88c0 13.3 10.7 24 24 24H232c13.3 0 24-10.7 24-24V72c0-2.7-.3-5.4-.8-8h.8c20.9 0 38.7 13.4 45.3 32H318c-7.1-27.6-32.2-48-62-48h-8c-7.3-9.7-18.9-16-32-16H205.3C198.7 13.4 180.9 0 160 0zM448 496H288c-26.5 0-48-21.5-48-48V192c0-26.5 21.5-48 48-48H396.1c8.5 0 16.6 3.4 22.6 9.4l67.9 67.9c6 6 9.4 14.1 9.4 22.6V448c0 26.5-21.5 48-48 48zM288 512H448c35.3 0 64-28.7 64-64V243.9c0-12.7-5.1-24.9-14.1-33.9l-67.9-67.9c-9-9-21.2-14.1-33.9-14.1H288c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64z'
      
    ]
  };

  
    var faFileClipboard = faPaste;
  

  
  

  var faComments = {
    prefix: 'fat',
    iconName: 'comments',
    icon: [
      640,
      512,
      [61670,128490],
      'f086',
      
      'M16 176C16 90 99.4 16 208 16s192 74 192 160s-83.4 160-192 160c-35.3 0-69.6-8.4-101.3-24c-2.3-1.1-5-1.1-7.3 .1C73.3 325.9 44.8 336 16 336l.1-.1c18.7-14.2 32.2-33.9 40.2-55.4c1-2.7 .5-5.8-1.4-8C31.1 244.8 16 212.1 16 176zM208 0C93.1 0 0 78.8 0 176c0 39.2 15.7 74.1 39.6 103.2C32.4 296.5 21.2 312 6.5 323.1C1 327.2-1.3 334.4 .8 340.9C2.9 347.5 9.1 352 16 352c31 0 60.8-10.3 87.3-23.9C136.1 343.6 171.5 352 208 352c114.9 0 208-78.8 208-176S322.9 0 208 0zM448 176.5c100.7 6.8 176 77.8 176 159.5c0 36.1-15.1 68.9-38.9 96.5c-1.9 2.2-2.4 5.3-1.4 8c8 21.5 21.4 41.2 40.2 55.4l.1 .1c-28.8 0-57.3-10.1-83.4-23.9c-2.3-1.2-5-1.2-7.3-.1c-31.7 15.7-65.9 24-101.3 24c-89 0-161-49.7-184.2-114.9c-5.4 .8-10.8 1.4-16.3 1.9C255.8 457.4 336.3 512 432 512c36.5 0 71.9-8.4 104.7-23.9C563.2 501.7 593 512 624 512c6.9 0 13.1-4.5 15.2-11.1c2.1-6.6-.2-13.7-5.7-17.8c-14.7-11.2-25.9-26.6-33.1-43.9C624.3 410.1 640 375.2 640 336c0-92.8-84.9-168.9-192.6-175.5c.4 5.1 .6 10.3 .6 15.5l0 .5z'
      
    ]
  };

  

  
  

  var faCaretRight = {
    prefix: 'fat',
    iconName: 'caret-right',
    icon: [
      256,
      512,
      [],
      'f0da',
      
      'M233.4 240.6c4.2 4 6.6 9.6 6.6 15.4s-2.4 11.4-6.6 15.4L101.3 396.5c-2.3 2.2-5.4 3.5-8.7 3.5c-7 0-12.6-5.6-12.6-12.6l0-262.8c0-7 5.6-12.6 12.6-12.6c3.2 0 6.3 1.2 8.7 3.5L233.4 240.6zm11-11.6L112.3 103.8C107 98.8 99.9 96 92.6 96C76.8 96 64 108.8 64 124.6l0 262.8C64 403.2 76.8 416 92.6 416c7.3 0 14.4-2.8 19.7-7.8L244.4 283c7.4-7 11.6-16.8 11.6-27s-4.2-20-11.6-27z'
      
    ]
  };

  

  
  

  var faBackward = {
    prefix: 'fat',
    iconName: 'backward',
    icon: [
      512,
      512,
      [9194],
      'f04a',
      
      'M258 80c-3 0-5.8 .9-8.2 2.7L19.3 249.5C17.2 251 16 253.4 16 256s1.2 5 3.3 6.5L249.7 429.3c2.4 1.7 5.3 2.7 8.2 2.7c7.8 0 14-6.3 14-14V94c0-7.8-6.3-14-14-14zm0-16c16.6 0 30 13.5 30 30V197.4L464.3 69.7C469.5 66 475.6 64 482 64c16.6 0 30 13.5 30 30V418c0 16.6-13.4 30-30 30c-6.3 0-12.5-2-17.6-5.7L288 314.6V418c0 16.6-13.5 30-30 30c-6.3 0-12.5-2-17.6-5.7L9.9 275.4C3.7 270.9 0 263.7 0 256s3.7-14.9 9.9-19.4L240.3 69.7C245.5 66 251.6 64 258 64zm30 230.8L473.7 429.3c2.4 1.7 5.3 2.7 8.2 2.7c7.8 0 14-6.3 14-14V94c0-7.8-6.3-14-14-14c-3 0-5.8 .9-8.2 2.7L288 217.2v77.7z'
      
    ]
  };

  

  
  

  var faPencil = {
    prefix: 'fat',
    iconName: 'pencil',
    icon: [
      512,
      512,
      [9999,61504,"pencil-alt"],
      'f303',
      
      'M395 25.9c12.5-12.5 32.8-12.5 45.3 0l45.8 45.8c12.5 12.5 12.5 32.8 0 45.3l-66.9 66.9L328.1 92.8 395 25.9zm-78.2 78.2l91.1 91.1L164.7 438.4c-1.5 1.5-3.1 3-4.7 4.4V408c0-4.4-3.6-8-8-8H112V360c0-4.4-3.6-8-8-8H69.2c1.4-1.6 2.9-3.2 4.4-4.7L316.8 104.1zM51.4 384.7c1.7-5.8 4-11.4 6.8-16.7H96v40c0 4.4 3.6 8 8 8h40v37.7c-5.3 2.8-10.9 5.1-16.7 6.8L19.8 492.2 51.4 384.7zm400.1-370c-18.7-18.7-49.1-18.7-67.9 0L62.3 336C50 348.3 41 363.5 36.1 380.2L.3 501.7c-.8 2.8-.1 5.8 2 7.9s5.1 2.8 7.9 2l121.6-35.8c16.7-4.9 31.9-13.9 44.2-26.2L497.4 128.3c18.7-18.7 18.7-49.1 0-67.9L451.5 14.6zM317.7 173.1c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-144 144c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l144-144z'
      
    ]
  };

  
    var faPencilAlt = faPencil;
  

  
  

  var faLips = {
    prefix: 'fat',
    iconName: 'lips',
    icon: [
      576,
      512,
      [128068,128482],
      'f600',
      
      'M278.1 113.8C253.9 94.7 227.2 80 200 80c-11.1 0-28.4 4.4-49.1 13.5c-20.3 8.9-42.5 21.5-63.1 36.3c-20.6 14.9-38.9 31.6-52 48.4C22.6 195.3 16 211 16 224c0 19.5 7.7 40.5 19.9 61.5c12.1 20.9 27.8 40.5 42 56.9c39.7 46 99.8 89.5 178.1 89.5h64c78.4 0 138.4-43.6 178.1-89.5c13.9-16 29.6-35.9 41.7-57.1C552.2 264 560 242.9 560 224c0-13-6.6-28.7-19.8-45.8c-13.1-16.8-31.4-33.6-52-48.4c-20.5-14.8-42.7-27.5-63.1-36.3c-20.8-9-38-13.5-49.1-13.5c-27.2 0-53.9 14.7-78.1 33.8c-5.8 4.6-14 4.6-19.8 0zM510.2 352.9C468.8 400.9 404.7 448 320 448H256c-84.7 0-148.8-47.1-190.2-95.1C36.9 319.5 0 271 0 224C0 151.5 142.5 64 200 64c32.7 0 63 17.5 88 37.3C313 81.5 343.3 64 376 64c57.5 0 200 87.5 200 160c0 45.8-37.5 96.2-65.8 128.9zM214.2 208c-38.5 .6-67.2 7.4-86.1 14c-9.3 3.2-16.3 6.4-20.9 8.8c1.8 2.1 4.1 4.6 7 7.5c7.9 7.8 19.9 17.7 35.7 27.5C181.4 285.3 228 304 288 304s106.6-18.7 138.1-38.2c15.8-9.8 27.7-19.7 35.7-27.5c2.9-2.9 5.3-5.4 7-7.5c-4.6-2.4-11.6-5.6-20.9-8.8c-18.9-6.6-47.6-13.4-86.1-14c-2.5 0-5.2 .4-7.8 1.2c-11.7 3.6-43 12.7-65.9 12.7s-54.2-9.1-65.9-12.7c-2.7-.8-5.3-1.2-7.8-1.2zm270.3 13.3c2.2 1.5 3.5 4 3.5 6.6c0 1.7-.5 3-.7 3.7c-.3 .8-.7 1.6-1.1 2.3c-.8 1.4-1.8 2.9-3 4.4c-2.4 3.1-5.8 7-10.2 11.3c-8.8 8.6-21.7 19.3-38.5 29.6C400.9 300.2 351.4 320 288 320s-112.9-19.8-146.5-40.6c-16.8-10.4-29.7-21-38.5-29.6c-4.4-4.3-7.8-8.2-10.2-11.3c-1.2-1.6-2.2-3.1-3-4.4c-.4-.7-.8-1.5-1.1-2.3c-.3-.7-.7-2.1-.7-3.7c0-2.6 1.3-5.1 3.5-6.6L96 228c-4.5-6.6-4.5-6.6-4.5-6.6l0 0 0 0 0 0 .1-.1 .4-.3c.4-.2 .9-.6 1.6-1c1.4-.8 3.4-2 6-3.3c5.2-2.7 13-6.2 23.2-9.8c20.4-7.1 50.8-14.3 91.1-14.9c4.5-.1 8.8 .7 12.8 1.9c11.9 3.7 41 12 61.2 12s49.2-8.3 61.2-12c4-1.3 8.4-2 12.8-1.9c40.3 .6 70.7 7.8 91.1 14.9c10.2 3.6 17.9 7.1 23.2 9.8c2.6 1.3 4.6 2.5 6 3.3c.7 .4 1.2 .7 1.6 1l.4 .3 .1 .1 0 0 0 0 0 0s0 0-4.5 6.6l4.5-6.6z'
      
    ]
  };

  

  
  

  var faLandmarkFlag = {
    prefix: 'fat',
    iconName: 'landmark-flag',
    icon: [
      512,
      512,
      [],
      'e51c',
      
      'M352 16V80H256V40 16h96zM256 96h96c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H256c-8.8 0-16 7.2-16 16V56 80 96v48H40c-4.4 0-8 3.6-8 8s3.6 8 8 8H472c4.4 0 8-3.6 8-8s-3.6-8-8-8H256V96zM80 200c0-4.4-3.6-8-8-8s-8 3.6-8 8V376c0 4.4 3.6 8 8 8H440c4.4 0 8-3.6 8-8V200c0-4.4-3.6-8-8-8s-8 3.6-8 8V368H328V200c0-4.4-3.6-8-8-8s-8 3.6-8 8V368H200V200c0-4.4-3.6-8-8-8s-8 3.6-8 8V368H80V200zM40 432c-4.4 0-8 3.6-8 8s3.6 8 8 8H472c4.4 0 8-3.6 8-8s-3.6-8-8-8H40zM8 496c-4.4 0-8 3.6-8 8s3.6 8 8 8H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H8z'
      
    ]
  };

  

  
  

  var faRam = {
    prefix: 'fat',
    iconName: 'ram',
    icon: [
      640,
      512,
      [128015],
      'f70a',
      
      'M352 48c0-26.5 21.5-48 48-48s48 21.5 48 48V68c8.9-2.6 18.3-4 28-4c12.7 0 24.8 2.4 36 6.7V48c0-26.5 21.5-48 48-48s48 21.5 48 48v8c0 4.4-3.6 8-8 8s-8-3.6-8-8V48c0-17.7-14.3-32-32-32s-32 14.3-32 32V78.6c17.3 10.5 31.1 26.2 39.4 44.8L618.3 158c8.6 5.8 13.7 15.5 13.7 25.9c0 24-26 39.1-46.8 27.2l-9.2-5.3V240c0 53-43 96-96 96h-8c-53 0-96-43-96-96V205.8l-9.2 5.3C346 223 320 207.9 320 183.9c0-10.4 5.1-20 13.7-25.9l50.9-34.7c9.5-21.4 26.4-38.9 47.4-49.2V48c0-17.7-14.3-32-32-32s-32 14.3-32 32v8c0 4.4-3.6 8-8 8s-8-3.6-8-8V48zM304.2 69.9c6.9-5.5 15-9.6 23.9-11.9c.3 5.6 2.1 10.8 5 15.3c-7 1.6-13.4 4.8-18.9 9.2c-6.7 5.3-16.4 4.4-22-2C283.3 70.3 270.4 64 256 64s-27.3 6.3-36.1 16.4c-5.6 6.4-15.3 7.3-22 2C189.7 75.9 179.3 72 168 72c-22.5 0-41.5 15.6-46.6 36.5c-2 8.1-9.8 13.3-18 12c-2.4-.4-4.9-.6-7.4-.6c-26.5 0-48 21.5-48 48c0 4 .5 7.9 1.4 11.6c1.8 7.1-1.5 14.5-8 18C26.3 205.7 16 221.7 16 240s10.3 34.3 25.4 42.4c6.5 3.5 9.8 10.9 8 18C48.5 304.1 48 308 48 312c0 26.5 21.5 48 48 48c2.5 0 5-.2 7.4-.6c8.2-1.3 16 4 18 12c5.1 21 24.1 36.6 46.6 36.6c11.3 0 21.7-3.9 29.8-10.4c6.7-5.3 16.4-4.4 22 2c8.8 10.1 21.7 16.4 36.1 16.4s27.3-6.3 36.1-16.4c5.6-6.4 15.3-7.3 22-2c8.2 6.5 18.5 10.4 29.8 10.4c22.5 0 41.5-15.6 46.6-36.6c2-8.1 9.8-13.3 18-12c2.4 .4 4.9 .6 7.4 .6c3.9 0 7.6-.5 11.2-1.3c7.6 3 15.5 5.4 23.7 6.9c-8.4 5.5-18.1 9-28.5 10.1L397.6 481.2c-4.3 18.1-20.4 30.8-38.9 30.8H344c-22.1 0-40-17.9-40-40V448c0-4.4 3.6-8 8-8s8 3.6 8 8v24c0 13.3 10.7 24 24 24h14.7c11.1 0 20.8-7.7 23.4-18.5l23.4-99.4C397.6 404.6 373.1 424 344 424c-15 0-28.9-5.2-39.8-13.9c-11.7 13.4-29 21.9-48.2 21.9s-36.5-8.5-48.2-21.9C196.9 418.8 183 424 168 424c-29.1 0-53.6-19.4-61.4-45.9L130 477.5c2.6 10.8 12.2 18.5 23.4 18.5H168c13.3 0 24-10.7 24-24V448c0-4.4 3.6-8 8-8s8 3.6 8 8v24c0 22.1-17.9 40-40 40H153.3c-18.6 0-34.7-12.8-38.9-30.8L89.6 375.7C57.3 372.5 32 345.2 32 312c0-5.3 .7-10.5 1.9-15.5C13.7 285.7 0 264.5 0 240s13.7-45.7 33.9-56.5c-1.2-5-1.9-10.2-1.9-15.5c0-35.3 28.7-64 64-64c3.3 0 6.6 .3 9.8 .8C112.7 76.8 137.9 56 168 56c15 0 28.9 5.2 39.8 13.9C219.5 56.5 236.8 48 256 48s36.5 8.5 48.2 21.9zM560 164c0-46.4-37.6-84-84-84s-84 37.6-84 84v76c0 44.2 35.8 80 80 80h8c44.2 0 80-35.8 80-80V164zm16 0v23.4l17.1 9.8c10.2 5.8 22.9-1.5 22.9-13.3c0-5.1-2.5-9.8-6.7-12.6l-34.6-23.6c.9 5.3 1.3 10.8 1.3 16.3zM377.3 147.7l-34.6 23.6c-4.2 2.8-6.7 7.6-6.7 12.6c0 11.7 12.7 19.1 22.9 13.3l17.1-9.8V164c0-5.6 .5-11 1.3-16.3zM448 176a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faExcavator = {
    prefix: 'fat',
    iconName: 'excavator',
    icon: [
      640,
      512,
      [],
      'e656',
      
      'M136 16H253.3c8.7 0 16.6 4.7 20.9 12.2L349.9 162c-4.4-1.3-9-2-13.9-2H128V24c0-4.4 3.6-8 8-8zm-24 8V160H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V224 208v-3.4c0-9.7-2.5-19.1-7.2-27.6L288.2 20.3C281.1 7.8 267.8 0 253.3 0H136c-13.3 0-24 10.7-24 24zM336 176c17.7 0 32 14.3 32 32v16 48c0 17.7-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V208c0-17.7 14.3-32 32-32h72H336zM80 368H336c35.3 0 64 28.7 64 64s-28.7 64-64 64H80c-35.3 0-64-28.7-64-64s28.7-64 64-64zM0 432c0 44.2 35.8 80 80 80H336c44.2 0 80-35.8 80-80s-35.8-80-80-80H80c-44.2 0-80 35.8-80 80zm128 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm112-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM576 161.5V318.9L450.2 450.2C443.6 457 440 466 440 475.5c0 20.2 16.4 36.5 36.5 36.5H552c48.6 0 88-39.4 88-88V384 320 272 43.2C640 19.4 620.6 0 596.8 0c-10.1 0-19.9 3.5-27.7 10L416 137.6v20.8L579.3 22.3c4.9-4.1 11.1-6.3 17.4-6.3c15 0 27.2 12.2 27.2 27.2V272v48 64 40c0 39.8-32.2 72-72 72H476.5c-11.3 0-20.5-9.2-20.5-20.5c0-5.3 2-10.4 5.7-14.2L589.8 327.6c1.4-1.5 2.2-3.5 2.2-5.5V144c0-3.1-1.8-6-4.7-7.3s-6.2-.8-8.6 1.2L416 279v21.2L576 161.5z'
      
    ]
  };

  

  
  

  var faEggplant = {
    prefix: 'fat',
    iconName: 'eggplant',
    icon: [
      512,
      512,
      [],
      'e16c',
      
      'M509.7 13.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L460.9 39.7C448.6 29.9 433 24 416 24H304c-13.3 0-24 10.7-24 24v5.8c0 21.3 17.3 38.5 38.5 38.5h10.9c6.4 0 11.6 5.2 11.6 11.6c0 37 30 66.9 66.9 66.9c6.4 0 11.6 5.2 11.6 11.6v10.9c0 21.3 17.3 38.5 38.5 38.5H464c13.3 0 24-10.7 24-24V96c0-17-5.9-32.6-15.7-44.9l37.4-37.4zM304 40H416c30.9 0 56 25.1 56 56V208c0 4.4-3.6 8-8 8h-5.8c-12.5 0-22.5-10.1-22.5-22.5V182.5c0-15.3-12.4-27.6-27.6-27.6c-28.1 0-50.9-22.8-50.9-50.9c0-15.3-12.4-27.6-27.6-27.6H318.5c-12.5 0-22.5-10.1-22.5-22.5V48c0-4.4 3.6-8 8-8zM169.9 139.3c32.9-16 66-32 94.7-52.2c2.5 4.8 5.5 9.2 8.8 13.3c-10.1 7.1-20.5 13.6-31.2 19.7c-20.9 12-44 23.2-66.4 34.1l0 0 0 0 0 0c-14.2 6.9-28.1 13.7-41 20.4c-34.5 18-64.4 37.1-85.7 62.2C28.5 261.2 15.4 292.2 16 335.8C17.3 422.6 88.9 495.9 176.4 496c74.3 .1 139-50.1 189.8-120.2c28-38.6 50.9-82.2 68.2-124.3c5 1.8 10.3 3.1 15.7 3.8C400.8 377 304.5 512.2 176.4 512C79.9 511.9 1.4 431.3 0 336C-1.6 222.5 83.4 181.3 169.9 139.3z'
      
    ]
  };

  

  
  

  var faFolderGrid = {
    prefix: 'fat',
    iconName: 'folder-grid',
    icon: [
      512,
      512,
      [],
      'e188',
      
      'M448 464H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H197.5c12.7 0 24.9 5.1 33.9 14.1l35.9 35.9c9 9 21.2 14.1 33.9 14.1H448c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48zM64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H301.3c-8.5 0-16.6-3.4-22.6-9.4L242.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64zm40-224h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8V264c0-4.4 3.6-8 8-8zm-24 8v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V264c0-13.3-10.7-24-24-24H104c-13.3 0-24 10.7-24 24zm152-8h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8V264c0-4.4 3.6-8 8-8zm-24 8v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V264c0-13.3-10.7-24-24-24H232c-13.3 0-24 10.7-24 24zm200-8c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8V264c0-4.4 3.6-8 8-8h48zm-48-16c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V264c0-13.3-10.7-24-24-24H360z'
      
    ]
  };

  

  
  

  var faGaugeMin = {
    prefix: 'fat',
    iconName: 'gauge-min',
    icon: [
      512,
      512,
      ["tachometer-alt-slowest"],
      'f628',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM272 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM208 352a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0c0-35.3-28.7-64-64-64c-18.8 0-35.7 8.1-47.4 21l-108-75.6c-3.6-2.5-8.6-1.7-11.1 2s-1.7 8.6 2 11.1l108 75.6c-4.7 8.9-7.4 19.1-7.4 29.9c0 35.3 28.7 64 64 64s64-28.7 64-64zM160 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM416 256a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM384 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  
    var faTachometerAltSlowest = faGaugeMin;
  

  
  

  var faDiagramPrevious = {
    prefix: 'fat',
    iconName: 'diagram-previous',
    icon: [
      512,
      512,
      [],
      'e478',
      
      'M496 352c0-26.5-21.5-48-48-48L64 304c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l384 0c26.5 0 48-21.5 48-48V352zm-48-64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V352c0-35.3 28.7-64 64-64H248V163.3l-50.3 50.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l64-64c3.1-3.1 8.2-3.1 11.3 0l64 64c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L264 163.3V288H448zM512 96v64c0 35.3-28.7 64-64 64H400c-4.4 0-8-3.6-8-8s3.6-8 8-8h48c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48L64 48C37.5 48 16 69.5 16 96l0 64c0 26.5 21.5 48 48 48h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64z'
      
    ]
  };

  

  
  

  var faK = {
    prefix: 'fat',
    iconName: 'k',
    icon: [
      320,
      512,
      [107],
      '4b',
      
      'M317.6 45.7c3.2-3.1 3.2-8.1 .2-11.3s-8.1-3.2-11.3-.2L16 317V40c0-4.4-3.6-8-8-8s-8 3.6-8 8V336 472c0 4.4 3.6 8 8 8s8-3.6 8-8V339.4L124.9 233.3 305.6 476.8c2.6 3.5 7.6 4.3 11.2 1.7s4.3-7.6 1.7-11.2L136.5 222 317.6 45.7z'
      
    ]
  };

  

  
  

  var faPage = {
    prefix: 'fat',
    iconName: 'page',
    icon: [
      384,
      512,
      [],
      'e428',
      
      'M64 496H320c26.5 0 48-21.5 48-48V138.5c0-12.7-5.1-24.9-14.1-33.9L279.4 30.1c-9-9-21.2-14.1-33.9-14.1H64C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48zm256 16H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H245.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64z'
      
    ]
  };

  

  
  

  var faStrikethrough = {
    prefix: 'fat',
    iconName: 'strikethrough',
    icon: [
      512,
      512,
      [],
      'f0cc',
      
      'M113.9 125.9c5.6-30.4 26.3-52.3 57.8-65c31.8-12.9 74.4-16.3 121.9-9.3C308.2 53.8 353.2 62 368 65.8c4.3 1.1 8.6-1.5 9.7-5.8s-1.5-8.6-5.8-9.7c-15.5-3.9-61.1-12.3-76-14.5c-49.3-7.3-95-4-130.3 10.3c-35.5 14.4-60.8 40.2-67.6 77.2l0 0-.1 .4c-2.8 22.3 .6 41.1 9.1 57c8.4 15.8 21.5 28.1 37.1 38.1c25.8 16.5 59.7 27.4 93.8 37.2H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H295.4c-11-3.4-22.2-6.6-33.3-9.7l-2.2-.6c-40.4-11.5-79.3-22.5-107.2-40.4c-14-9-24.8-19.4-31.6-32.1c-6.7-12.5-9.7-27.9-7.3-47.2zM394 336.5c5.8 13 7.8 29 4.1 49.3c-5.6 30.5-26.2 52.4-57.9 65.3c-31.8 12.9-74.4 16.3-121.9 9.3c-24.2-3.7-64.7-16.8-94.7-26.5l0 0 0 0c-6.3-2-12.2-3.9-17.3-5.5c-4.2-1.3-8.7 1-10 5.2s1 8.7 5.2 10c4.8 1.5 10.4 3.3 16.6 5.3l0 0c29.9 9.7 72.2 23.3 97.8 27.3l0 0c49.3 7.3 95 4 130.3-10.3c35.5-14.4 60.8-40.2 67.6-77.2c4.2-22.9 2.1-42.2-5.3-58.7c-1.6-3.5-3.3-6.8-5.3-10H383.5c4.3 5.1 7.8 10.6 10.5 16.5z'
      
    ]
  };

  

  
  

  var faTrees = {
    prefix: 'fat',
    iconName: 'trees',
    icon: [
      640,
      512,
      [],
      'f724',
      
      'M198 19L310 146.5c1.3 1.5 2 3.4 2 5.4c0 4.5-3.6 8.1-8.1 8.1H248c-3.3 0-6.2 2-7.4 5.1s-.4 6.5 2 8.8L341.6 267c1.5 1.4 2.4 3.4 2.4 5.5c0 4.2-3.4 7.5-7.5 7.5H272c-3.3 0-6.2 2-7.4 5.1s-.4 6.5 2 8.8L365.6 387c1.5 1.4 2.4 3.4 2.4 5.5c0 4.2-3.4 7.5-7.5 7.5H235.3 200V200c0-4.4-3.6-8-8-8s-8 3.6-8 8V400H148.7 23.5c-4.1 0-7.5-3.4-7.5-7.5c0-2.1 .9-4.1 2.4-5.5l99.1-93.2c2.4-2.2 3.2-5.7 2-8.8s-4.2-5.1-7.4-5.1H47.5c-4.2 0-7.5-3.4-7.5-7.5c0-2.1 .9-4.1 2.4-5.5l99.1-93.2c2.4-2.2 3.2-5.7 2-8.8s-4.2-5.1-7.4-5.1H80.1c-4.5 0-8.1-3.6-8.1-8.1c0-2 .7-3.9 2-5.4L186 19c3.2-3.6 8.8-3.6 12 0zM148.7 416H184v88c0 4.4 3.6 8 8 8s8-3.6 8-8V416h35.3H360.5c13 0 23.5-10.5 23.5-23.5c0-6.5-2.7-12.7-7.4-17.1L292.2 296h44.3c13 0 23.5-10.5 23.5-23.5c0-6.5-2.7-12.7-7.4-17.1L268.2 176h35.7c13.3 0 24.1-10.8 24.1-24.1c0-5.9-2.1-11.5-6-15.9L210 8.4c-9.6-10.9-26.5-10.9-36.1 0L62 135.9c-3.9 4.4-6 10.1-6 15.9C56 165.2 66.8 176 80.1 176h35.7L31.4 255.4C26.7 259.8 24 266 24 272.5c0 13 10.5 23.5 23.5 23.5H91.8L7.4 375.4C2.7 379.8 0 386 0 392.5c0 13 10.5 23.5 23.5 23.5H148.7zM429.9 8.7l-84 97.4c-2.9 3.3-2.5 8.4 .8 11.3s8.4 2.5 11.3-.8l84-97.4c3.2-3.7 8.9-3.7 12.1-.1L566 146.5c1.3 1.5 2 3.4 2 5.4c0 4.5-3.6 8.1-8.1 8.1H504c-3.3 0-6.2 2-7.4 5.1s-.4 6.5 2 8.8L597.6 267c1.5 1.4 2.4 3.4 2.4 5.5c0 4.2-3.4 7.5-7.5 7.5H528c-3.3 0-6.2 2-7.4 5.1s-.4 6.5 2 8.8L621.6 387c1.5 1.4 2.4 3.4 2.4 5.5c0 4.2-3.4 7.5-7.5 7.5H456V200c0-4.4-3.6-8-8-8s-8 3.6-8 8V504c0 4.4 3.6 8 8 8s8-3.6 8-8V416H616.5c13 0 23.5-10.5 23.5-23.5c0-6.5-2.7-12.7-7.4-17.1L548.2 296h44.3c13 0 23.5-10.5 23.5-23.5c0-6.5-2.7-12.7-7.4-17.1L524.2 176h35.7c13.3 0 24.1-10.8 24.1-24.1c0-5.9-2.1-11.5-6-15.9L466.1 8.5c-9.6-11-26.7-10.9-36.2 .2z'
      
    ]
  };

  

  
  

  var faHandLove = {
    prefix: 'fat',
    iconName: 'hand-love',
    icon: [
      512,
      512,
      [],
      'e1a5',
      
      'M192 16c-17.7 0-32 14.3-32 32V335.4c0 3.2-1.9 6.2-4.9 7.4s-6.4 .6-8.7-1.7L86.6 281.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L145.1 430.4c42 42 99 65.6 158.4 65.6H312c81.4 0 147.9-64 151.8-144.4c0-.5 .1-.9 .2-1.4V344 112c0-17.7-14.3-32-32-32s-32 14.3-32 32v72 56 64c0 26.5-21.5 48-48 48c-16.7 0-31.4-8.5-40-21.5c-8.6 12.9-23.3 21.5-40 21.5c-26.5 0-48-21.5-48-48l0-96.1L224 88l0 0V48c0-17.7-14.3-32-32-32zM304 304V240 216l0-8c0-17.7-14.3-32-32-32c-17.6 0-32 14.3-32 31.9V304c0 17.7 14.3 32 32 32s32-14.3 32-32zm16-64v64c0 17.7 14.3 32 32 32s32-14.3 32-32V240c0-17.7-14.3-32-32-32s-32 14.3-32 32zm64-35.8V184 112c0-26.5 21.5-48 48-48s48 21.5 48 48V344v8c0 .8-.1 1.5-.3 2.2C474.4 442.2 401.4 512 312 512h-8.5c-63.7 0-124.7-25.3-169.7-70.3L30.1 337.9c-18.7-18.7-18.7-49.1 0-67.9s49.1-18.7 67.9 0L144 316.1V48c0-26.5 21.5-48 48-48s48 21.5 48 48l0 40 0 84.2c8.5-7.6 19.7-12.2 32-12.2c25.3 0 46 19.5 47.9 44.3c8.5-7.7 19.8-12.3 32.1-12.3c12.3 0 23.5 4.6 32 12.2z'
      
    ]
  };

  

  
  

  var faFootballHelmet = {
    prefix: 'fat',
    iconName: 'football-helmet',
    icon: [
      512,
      512,
      [],
      'f44f',
      
      'M279.1 237c-22.3 2.8-39.1 21.8-39.1 44.3c0 6.9 1.6 13.8 4.7 19.9l38.2 76.4c3.3 6.7 5.1 14 5.1 21.5v.9c0 26.5-21.5 48-48 48h-2.9c-6.5 0-12.9-1.3-18.9-3.9l-93.9-40.2c-6-2.6-12.4-3.9-18.9-3.9h-14c-4.7 0-8.7-2-11-4.9C50.1 356.9 32 308.6 32 256C32 132.3 132.3 32 256 32c104 0 191.4 70.8 216.7 166.9c1.7 6.3-2.8 14.2-12.2 15.4L279.1 237zm183.4-6.8c17.5-2.2 30.2-18.3 25.7-35.3C461.1 91.9 367.4 16 256 16C123.5 16 16 123.5 16 256c0 56.3 19.4 108.1 51.9 149.1c5.7 7.1 14.4 10.9 23.5 10.9h14c4.3 0 8.6 .9 12.6 2.6l93.9 40.2c8 3.4 16.5 5.2 25.2 5.2H240c35.3 0 64-28.7 64-64v-.9c0-9.9-2.3-19.7-6.8-28.6L280 336h52l12.1 57.5C354.1 452.7 405.3 496 465.3 496H473c21.5 0 39-17.5 39-39V392 360c0-22.1-17.9-40-40-40H345l-15.4-73.2 132.9-16.6zM313.7 248.8l15 71.2H272l-13-26c-2-4-3-8.4-3-12.8c0-14.4 10.7-26.6 25.1-28.4l32.6-4.1zM176 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm182.5 16l-10.1-48H472c13.3 0 24 10.7 24 24v24H358.5zm3.4 16H496v57c0 12.7-10.3 23-23 23h-7.7c-49 0-91.4-33.3-103.5-80z'
      
    ]
  };

  

  
  

  var faGrid = {
    prefix: 'fat',
    iconName: 'grid',
    icon: [
      448,
      512,
      ["grid-3"],
      'e195',
      
      'M88 48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24V72c0-13.3 10.7-24 24-24H88zM40 32C17.9 32 0 49.9 0 72v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H40zM88 208c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24V232c0-13.3 10.7-24 24-24H88zM40 192c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H40zm0 176H88c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24V392c0-13.3 10.7-24 24-24zM0 392v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40zM248 48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V72c0-13.3 10.7-24 24-24h48zM200 32c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H200zm0 176h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V232c0-13.3 10.7-24 24-24zm-40 24v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H200c-22.1 0-40 17.9-40 40zm88 136c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V392c0-13.3 10.7-24 24-24h48zm-48-16c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H200zM360 48h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H360c-13.3 0-24-10.7-24-24V72c0-13.3 10.7-24 24-24zM320 72v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H360c-22.1 0-40 17.9-40 40zm88 136c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H360c-13.3 0-24-10.7-24-24V232c0-13.3 10.7-24 24-24h48zm-48-16c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H360zm0 176h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H360c-13.3 0-24-10.7-24-24V392c0-13.3 10.7-24 24-24zm-40 24v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H360c-22.1 0-40 17.9-40 40z'
      
    ]
  };

  
    var faGrid3 = faGrid;
  

  
  

  var faPanFrying = {
    prefix: 'fat',
    iconName: 'pan-frying',
    icon: [
      576,
      512,
      [127859],
      'e42c',
      
      'M224 432C109.1 432 16 338.9 16 224S109.1 16 224 16s208 93.1 208 208c0 28.4-5.7 55.4-16 80l0 0c-2.1 5-4.3 9.9-6.8 14.6c-9.9 19.3-22.7 36.8-37.8 52.1l-.3 .3c-3.7 3.7-7.5 7.2-11.4 10.6C323.3 413 275.8 432 224 432zm0 16c56 0 107.3-20.6 146.5-54.6l89.6 97.1c12.6 13.7 30.4 21.5 49.1 21.5c36.9 0 66.8-30.3 66.8-67.2c0-22.8-11.5-44.3-30.7-56.8L429.7 312.9C441.5 285.6 448 255.6 448 224C448 100.3 347.7 0 224 0S0 100.3 0 224S100.3 448 224 448zm247.9 31.7l-89.7-97.1c16.1-16.1 29.8-34.7 40.5-55.1l113.9 74c14.5 9.5 23.4 25.9 23.4 43.3c0 28.2-22.9 51.2-50.8 51.2c-14.2 0-27.7-5.9-37.3-16.3zM496 448a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM323.9 138.5c-8.7-2.2-20-7.1-31-13.6s-20.9-13.8-27.1-20.3c-30.6-31.9-81.3-32.9-113.1-2.2c-14.5 13.9-22.6 32.1-24.3 50.7c-2.1 23.5-8.7 52.4-19.4 71C82.4 269.9 98.1 328.6 144 355.1s104.6 10.8 131.1-35.1c2.9-5.1 8.9-10.9 16.9-15.8c7.9-4.9 16.4-8 23.1-9c12.8-1.8 25.4-6.7 36.5-15c35.5-26.3 42.9-76.4 16.6-111.9c-11.4-15.3-27.2-25.5-44.4-29.8zm-4 15.5c13.7 3.5 26.4 11.6 35.5 23.9c21 28.4 15.1 68.5-13.3 89.5c-8.9 6.6-18.9 10.5-29.2 12c-18.6 2.6-42.2 16.3-51.6 32.6c-22.1 38.3-71 51.4-109.3 29.3s-51.4-71-29.3-109.3c12.4-21.4 19.4-53 21.5-77.6c1.3-14.9 7.8-29.4 19.4-40.5c25.5-24.5 66-23.7 90.5 1.8c15.2 15.8 44.5 32.9 65.8 38.4zM184 224a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm96 0a56 56 0 1 0 -112 0 56 56 0 1 0 112 0z'
      
    ]
  };

  

  
  

  var faAddressBook = {
    prefix: 'fat',
    iconName: 'address-book',
    icon: [
      512,
      512,
      [62138,"contact-book"],
      'f2b9',
      
      'M96 16C69.5 16 48 37.5 48 64V448c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H96zM32 64C32 28.7 60.7 0 96 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V64zM288 192a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-112 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm24 112c-30.9 0-56 25.1-56 56c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-39.8 32.2-72 72-72h80c39.8 0 72 32.2 72 72c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-30.9-25.1-56-56-56H200zM504 80v64c0 4.4-3.6 8-8 8s-8-3.6-8-8V80c0-4.4 3.6-8 8-8s8 3.6 8 8zm-8 120c4.4 0 8 3.6 8 8v64c0 4.4-3.6 8-8 8s-8-3.6-8-8V208c0-4.4 3.6-8 8-8zm8 136v64c0 4.4-3.6 8-8 8s-8-3.6-8-8V336c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  
    var faContactBook = faAddressBook;
  

  
  

  var faCartMinus = {
    prefix: 'fat',
    iconName: 'cart-minus',
    icon: [
      576,
      512,
      [],
      'e0db',
      
      'M0 8C0 3.6 3.6 0 8 0H45.7C64.8 0 81.2 13.5 84.9 32.3L131.8 272H473.9c18.6 0 34.7-12.8 39-30.9L560.2 38.2c1-4.3 5.3-7 9.6-6s7 5.3 6 9.6L528.4 244.7c-5.9 25.3-28.5 43.3-54.5 43.3h-339l9.3 47.7c3.7 18.8 20.1 32.3 39.3 32.3H504c4.4 0 8 3.6 8 8s-3.6 8-8 8H183.5c-26.8 0-49.8-19-55-45.2L69.2 35.4C67 24.1 57.1 16 45.7 16H8c-4.4 0-8-3.6-8-8zM176 496a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm320 48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM240 128H400c4.4 0 8 3.6 8 8s-3.6 8-8 8H240c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faPager = {
    prefix: 'fat',
    iconName: 'pager',
    icon: [
      512,
      512,
      [128223],
      'f815',
      
      'M448 80c26.5 0 48 21.5 48 48V384c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V128c0-26.5 21.5-48 48-48H448zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm0 264c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H72c-4.4 0-8 3.6-8 8zm128 0c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H200c-4.4 0-8 3.6-8 8zM96 144H416c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16zM64 160v64c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32z'
      
    ]
  };

  

  
  

  var faMerge = {
    prefix: 'fat',
    iconName: 'merge',
    icon: [
      512,
      512,
      [],
      'e526',
      
      'M0 72c0-4.4 3.6-8 8-8H96h47.3c13.1 0 25.4 6.4 32.8 17.2L285 237.7c4.5 6.4 11.8 10.3 19.7 10.3H480h4.7l-66.3-66.3c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l80 80c3.1 3.1 3.1 8.2 0 11.3l-80 80c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L484.7 264H480 304.7c-7.9 0-15.2 3.8-19.7 10.3L176.1 430.8c-7.5 10.7-19.7 17.2-32.8 17.2H96 8c-4.4 0-8-3.6-8-8s3.6-8 8-8H96h47.3c7.9 0 15.2-3.8 19.7-10.3L271.9 265.2c2.5-3.6 5.5-6.6 8.8-9.2c-3.4-2.5-6.4-5.6-8.8-9.2L163 90.3C158.5 83.8 151.1 80 143.3 80H96 8c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faCircleH = {
    prefix: 'fat',
    iconName: 'circle-h',
    icon: [
      512,
      512,
      [9405,"hospital-symbol"],
      'f47e',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm80-376V248H176V136c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 240c0 4.4 3.6 8 8 8s8-3.6 8-8l0-112H336V376c0 4.4 3.6 8 8 8s8-3.6 8-8V256 136c0-4.4-3.6-8-8-8s-8 3.6-8 8z'
      
    ]
  };

  
    var faHospitalSymbol = faCircleH;
  

  
  

  var faHexagonXmark = {
    prefix: 'fat',
    iconName: 'hexagon-xmark',
    icon: [
      512,
      512,
      ["times-hexagon","xmark-hexagon"],
      'f2ee',
      
      'M400.8 450.8l0 0L497.1 284c2.5-4.3 4.4-8.9 5.6-13.6c2-7.7 2.4-15.7 1.1-23.6c-1.1-6.5-3.3-12.9-6.7-18.8L400.8 61.2c-10-17.3-28.5-28-48.5-28H159.7c-20 0-38.5 10.7-48.5 28L14.9 228c-3.9 6.7-6.3 14.1-7.1 21.6c-1.4 11.8 1 23.9 7.1 34.4l96.3 166.8c10 17.3 28.5 28 48.5 28H352.3c20 0 38.5-10.7 48.5-28zM483.2 236c2.7 4.6 4.4 9.7 5 14.8l-2.7 20.4c-.7 1.6-1.4 3.2-2.3 4.8L386.9 442.8c-7.1 12.4-20.4 20-34.6 20H159.7c-14.3 0-27.5-7.6-34.6-20L28.8 276c-3.6-6.2-5.4-13.1-5.4-20c0-3.4 .4-6.8 1.3-10.1c.9-3.4 2.2-6.8 4.1-9.9L125.1 69.2c7.1-12.4 20.4-20 34.6-20l192.6 0c14.3 0 27.5 7.6 34.6 20L483.2 236zM178.3 178.3c-3.1 3.1-3.1 8.2 0 11.3L244.7 256l-66.3 66.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L256 267.3l66.3 66.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L267.3 256l66.3-66.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L256 244.7l-66.3-66.3c-3.1-3.1-8.2-3.1-11.3 0z'
      
    ]
  };

  
    var faTimesHexagon = faHexagonXmark;
  
    var faXmarkHexagon = faHexagonXmark;
  

  
  

  var faCartXmark = {
    prefix: 'fat',
    iconName: 'cart-xmark',
    icon: [
      576,
      512,
      [],
      'e0dd',
      
      'M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8H45.7C57.1 16 67 24.1 69.2 35.4l59.4 303.4c5.1 26.3 28.2 45.2 55 45.2H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H183.5c-19.1 0-35.6-13.5-39.3-32.3L134.9 288h339c26 0 48.6-17.9 54.5-43.3L575.8 41.8c1-4.3-1.7-8.6-6-9.6s-8.6 1.7-9.6 6L512.9 241.1c-4.2 18.1-20.4 30.9-39 30.9H131.8L84.9 32.3C81.2 13.5 64.8 0 45.7 0H8zM144 464a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm240-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM257.8 81.8c-3.1 3.1-3.1 8.2 0 11.3L308.7 144l-50.9 50.9c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L320 155.3l50.9 50.9c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L331.3 144l50.9-50.9c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L320 132.7 269.1 81.8c-3.1-3.1-8.2-3.1-11.3 0z'
      
    ]
  };

  

  
  

  var faBowArrow = {
    prefix: 'fat',
    iconName: 'bow-arrow',
    icon: [
      512,
      512,
      [127993],
      'f6b9',
      
      'M511.9 9.3c.4-2.5-.4-5.1-2.2-7s-4.4-2.7-7-2.2l-144 24c-3 .5-5.4 2.6-6.3 5.4s-.2 6 2 8.1L408.7 92 162.3 338.3c-1.4-.7-2.9-1.2-4.5-1.6l-64-16c-8.2-2-16.8 .4-22.8 6.3L7 391c-6.1 6.1-8.5 15-6.2 23.4s8.9 14.8 17.3 16.9l50 12.5 12.5 50c2.1 8.4 8.5 15 16.9 17.3s17.3 0 23.4-6.2l64-64c6-6 8.4-14.6 6.3-22.8l-16-64c-.4-1.6-.9-3.1-1.6-4.5L420 103.3l54.3 54.3c2.1 2.1 5.2 2.9 8.1 2s5-3.3 5.4-6.3l24-144zm-37.2 126l-98-98L494.3 17.7 474.7 135.4zM192 64C132.3 64 77.5 84.4 33.9 118.6L21.7 106.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L174.1 281.4l11.3-11.3L45.3 130C85.9 98.7 136.8 80 192 80c51.8 0 99.8 16.4 139.1 44.4l11.5-11.5C300.3 82.1 248.3 64 192 64zM387.6 180.9C415.6 220.2 432 268.2 432 320c0 55.2-18.7 106.1-50 146.7l-140-140-11.3 11.3L394.3 501.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-12.3-12.3C427.6 434.5 448 379.7 448 320c0-56.3-18.1-108.3-48.9-150.5l-11.5 11.5zM83.7 439.9c-1.4-5.7-5.9-10.2-11.6-11.6l-50-12.5c-2.8-.7-5-2.8-5.8-5.6s0-5.8 2.1-7.8l64-64c2-2 4.9-2.8 7.6-2.1l64 16c2.9 .7 5.1 3 5.8 5.8l16 64c.7 2.7-.1 5.6-2.1 7.6l-64 64c-2 2-5 2.8-7.8 2.1s-4.9-3-5.6-5.8l-12.5-50z'
      
    ]
  };

  

  
  

  var faFileCircleExclamation = {
    prefix: 'fat',
    iconName: 'file-circle-exclamation',
    icon: [
      576,
      512,
      [],
      'e4eb',
      
      'M64 496H311.2c5.8 5.5 12 10.6 18.5 15.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H204.1c12.7 0 24.9 5.1 33.9 14.1L369.9 145.9c9 9 14.1 21.2 14.1 33.9v18.7c-5.4 1.5-10.8 3.3-16 5.4V179.9c0-1.3-.1-2.6-.2-3.9H248c-22.1 0-40-17.9-40-40V16.2c-1.3-.2-2.6-.2-3.9-.2H64C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48zM361.1 160c-.8-1-1.6-1.9-2.4-2.7L226.7 25.4c-.9-.9-1.8-1.7-2.7-2.4V136c0 13.3 10.7 24 24 24H361.1zM560 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0-136c4.4 0 8 3.6 8 8v96c0 4.4-3.6 8-8 8s-8-3.6-8-8V288c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faEnvelopesBulk = {
    prefix: 'fat',
    iconName: 'envelopes-bulk',
    icon: [
      640,
      512,
      ["mail-bulk"],
      'f674',
      
      'M432 16c17.7 0 32 14.3 32 32V80h16V48c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48V192H80V48c0-17.7 14.3-32 32-32H432zM240 128H592c17.7 0 32 14.3 32 32V368c0 17.7-14.3 32-32 32H416v16H592c26.5 0 48-21.5 48-48V160c0-26.5-21.5-48-48-48H240c-26.5 0-48 21.5-48 48v32h16V160c0-17.7 14.3-32 32-32zM16 272c0-17.7 14.3-32 32-32H336c17.7 0 32 14.3 32 32v19.1l-4.8 3.5L201.7 414.3c-2.8 2.1-6.2 3.2-9.7 3.2s-6.9-1.1-9.7-3.2L20.8 294.6 16 291.1V272zM211.2 427.1L368 311V464c0 17.7-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V311L172.8 427.1c5.6 4.1 12.3 6.3 19.2 6.3s13.6-2.2 19.2-6.3zM0 272V464c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H48c-26.5 0-48 21.5-48 48zm528-96c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V200c0-13.3-10.7-24-24-24H528zm-8 24c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H528c-4.4 0-8-3.6-8-8V200z'
      
    ]
  };

  
    var faMailBulk = faEnvelopesBulk;
  

  
  

  var faJarWheat = {
    prefix: 'fat',
    iconName: 'jar-wheat',
    icon: [
      320,
      512,
      [],
      'e517',
      
      'M240 16c8.8 0 16 7.2 16 16V64H64V32c0-8.8 7.2-16 16-16H240zM48 64v2C20.4 73.1 0 98.2 0 128V448c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V128c0-29.8-20.4-54.9-48-62V64 32c0-17.7-14.3-32-32-32H80C62.3 0 48 14.3 48 32V64zM64 80H256c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V128c0-26.5 21.5-48 48-48zM192 208H168c0-35.3 28.7-64 64-64h24c0 35.3-28.7 64-64 64zm-32-34.9C147 146.4 119.7 128 88 128l-24 0c-8.8 0-16 7.2-16 16c0 44.2 35.8 80 80 80h24 16 24c44.2 0 80-35.8 80-80c0-8.8-7.2-16-16-16H232c-31.7 0-59 18.4-72 45.1zM152 208H128c-35.3 0-64-28.7-64-64H88c35.3 0 64 28.7 64 64zm16 104c0-35.3 28.7-64 64-64h24c0 35.3-28.7 64-64 64H168zM88 232H64c-8.8 0-16 7.2-16 16c0 44.2 35.8 80 80 80h24 16 24c44.2 0 80-35.8 80-80c0-8.8-7.2-16-16-16H232c-31.7 0-59 18.4-72 45.1C147 250.4 119.7 232 88 232zm40 80c-35.3 0-64-28.7-64-64H88c35.3 0 64 28.7 64 64H128zm64 104H168c0-35.3 28.7-64 64-64h24c0 35.3-28.7 64-64 64zm-24 16h24c44.2 0 80-35.8 80-80c0-8.8-7.2-16-16-16H232c-31.7 0-59 18.4-72 45.1C147 354.4 119.7 336 88 336H64c-8.8 0-16 7.2-16 16c0 44.2 35.8 80 80 80h24v24c0 4.4 3.6 8 8 8s8-3.6 8-8V432zM88 352c35.3 0 64 28.7 64 64H128c-35.3 0-64-28.7-64-64H88z'
      
    ]
  };

  

  
  

  var faSpoon = {
    prefix: 'fat',
    iconName: 'spoon',
    icon: [
      512,
      512,
      [61873,129348,"utensil-spoon"],
      'f2e5',
      
      'M263.4 216.6l32 32c15.6 15.6 36 23.4 56.4 23.4c33.8 0 69.7-20.5 97.8-54.2c28-33.5 46.3-78 46.3-121.8c0-44.2-35.8-80-80-80c-43.7 0-88.2 18.3-121.8 46.3C260.5 90.5 240 126.4 240 160.2c0 20.4 7.8 40.8 23.4 56.4zm-11.3 11.3c-18.7-18.7-28.1-43.2-28.1-67.7C224 80 320 0 416 0c53 0 96 43 96 96c0 96-80 192-160.2 192c-24.5 0-49-9.4-67.7-28.1l-10.3-10.3L13.7 509.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L262.5 238.2l-10.3-10.3z'
      
    ]
  };

  
    var faUtensilSpoon = faSpoon;
  

  
  

  var faCheeseSwiss = {
    prefix: 'fat',
    iconName: 'cheese-swiss',
    icon: [
      512,
      512,
      [129472],
      'f7f0',
      
      'M495.9 240H403.8c-8.8-9.8-21.6-16-35.8-16s-27 6.2-35.8 16H27.3l141-101.9c-.2 1.9-.4 3.9-.4 5.9c0 26.5 21.5 48 48 48s48-21.5 48-48c0-23.3-16.6-42.7-38.6-47.1l64.9-46.9c1.9-1.3 4.1-2.1 6.4-2.1C404.3 48 492 133.3 495.9 240zM16 256H322.7c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H496V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V256.4l0-.4zm320 16a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm176-16v-8.7C512 128.4 415.6 32 296.7 32c-5.7 0-11.2 1.8-15.8 5.1L13.3 230.4C4.9 236.4 0 246.1 0 256.4V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V256zM176 336a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm8-272a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faHouseBuilding = {
    prefix: 'fat',
    iconName: 'house-building',
    icon: [
      640,
      512,
      [],
      'e1b1',
      
      'M384 16H576c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H409.3c-2.5 5.7-5.6 11.1-9.3 16H576c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H384c-35.3 0-64 28.7-64 64v89.9l16 14.7V64c0-26.5 21.5-48 48-48zm32 272h24c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H408c-7.7 0-14.5 3.6-18.9 9.2l1 .9c3.8 3.5 7.3 7.3 10.3 11.5c1-3.2 4.1-5.6 7.6-5.6h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H415.8c.1 1.7 .2 3.4 .2 5.1V288zm0 112h24c13.3 0 24-10.7 24-24V344c0-13.3-10.7-24-24-24H416v16h24c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H416v16zM520 208c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H520zm-8 24c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H520c-4.4 0-8-3.6-8-8V232zM496 344v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V344c0-13.3-10.7-24-24-24H520c-13.3 0-24 10.7-24 24zm24-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H520c-4.4 0-8-3.6-8-8V344c0-4.4 3.6-8 8-8zM408 96c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H408zm-8 24c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H408c-4.4 0-8-3.6-8-8V120zm96 0v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H520c-13.3 0-24 10.7-24 24zm24-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H520c-4.4 0-8-3.6-8-8V120c0-4.4 3.6-8 8-8zM16 280.6c0-11.2 4.7-21.9 13-29.5L165 126.5c15.3-14 38.8-14 54.1 0L355 251.1c8.3 7.6 13 18.3 13 29.5V456c0 22.1-17.9 40-40 40H56c-22.1 0-40-17.9-40-40V280.6zM0 456c0 30.9 25.1 56 56 56H328c30.9 0 56-25.1 56-56V280.6c0-15.7-6.6-30.7-18.2-41.3l-136-124.7c-21.4-19.6-54.3-19.6-75.7 0L18.2 239.4C6.6 250 0 264.9 0 280.6V456zM224 280c4.4 0 8 3.6 8 8v64c0 4.4-3.6 8-8 8H160c-4.4 0-8-3.6-8-8V288c0-4.4 3.6-8 8-8h64zm-64-16c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24h64c13.3 0 24-10.7 24-24V288c0-13.3-10.7-24-24-24H160z'
      
    ]
  };

  

  
  

  var faLeafHeart = {
    prefix: 'fat',
    iconName: 'leaf-heart',
    icon: [
      512,
      512,
      [],
      'f4cb',
      
      'M272 112c-88.4 0-160 71.6-160 160s71.6 160 160 160h0l.9 0C393.5 431.4 496 311.3 496 156.6c0-35.1-5.3-68.5-15-99.3C457.8 90.3 419.5 112 376 112l-104 0zm1 336l-1 0c-97.1 0-175.9-78.7-176-175.8C47.7 305.4 16 361 16 424v48c0 4.4-3.6 8-8 8s-8-3.6-8-8V424c0-72.8 38.9-136.5 97.1-171.5C106.8 164.5 181.4 96 272 96l104 0c42.7 0 79.9-23.9 98.8-59.1c3.5-6.5 13.6-6.8 16.2 .1c13.5 36.5 21.1 77 21.1 119.6C512 317.1 405.1 447.3 273 448zM204.6 240.6c0 9.3 3.6 18.3 10 25.1l67.6 71.7c1.5 1.6 3.6 2.5 5.8 2.5s4.3-.9 5.8-2.5l67.6-71.7c6.4-6.8 10-15.8 10-25.1c0-20.2-16.4-36.6-36.6-36.6h-.6c-9.7 0-19 3.8-26 10.5l-14.6 14.2c-3.1 3-8 3-11.2 0l-14.6-14.2c-7-6.8-16.3-10.5-26-10.5h-.6c-20.2 0-36.6 16.4-36.6 36.6zM241.2 188h.6c13.9 0 27.2 5.4 37.1 15.1l9 8.8 9-8.8c9.9-9.7 23.3-15.1 37.1-15.1h.6c29.1 0 52.6 23.6 52.6 52.6c0 13.4-5.1 26.3-14.3 36.1l-67.6 71.7c-4.5 4.8-10.9 7.5-17.5 7.5s-12.9-2.7-17.5-7.5l-67.6-71.7c-9.2-9.8-14.3-22.7-14.3-36.1c0-29.1 23.6-52.6 52.6-52.6z'
      
    ]
  };

  

  
  

  var faArrowsRotateReverse = {
    prefix: 'fat',
    iconName: 'arrows-rotate-reverse',
    icon: [
      512,
      512,
      [],
      'e630',
      
      'M467.3 224c4.9 0 8.7-4.3 7.8-9.2c-9.7-51.8-37.5-100.4-82.3-135.3C295.3 3.3 154.5 20.6 78.3 118.1l-.1 .1 0 0 0 0L46.9 160V72c0-4.4-3.6-8-8-8s-8 3.6-8 8V184c0 4.4 3.6 8 8 8h112c4.4 0 8-3.6 8-8s-3.6-8-8-8h-96L91 127.9C161.7 37.4 292.4 21.4 382.9 92.1c41.4 32.3 67.2 77.2 76.3 125.1c.7 3.9 4.1 6.8 8.1 6.8zm3.4 96h-112c-4.4 0-8 3.6-8 8s3.6 8 8 8H456l-36.1 48.1c-70.7 90.5-201.4 106.5-291.9 35.8c-41.4-32.4-67.2-77.3-76.3-125.1c-.7-3.9-4.1-6.8-8.1-6.8c-4.9 0-8.7 4.3-7.8 9.2c9.7 51.8 37.5 100.4 82.3 135.4c97.5 76.2 238.3 58.9 314.4-38.6l.1-.1 0 0 0 0 30.1-40V440c0 4.4 3.6 8 8 8s8-3.6 8-8V328c0-4.4-3.6-8-8-8z'
      
    ]
  };

  

  
  

  var faArrowDownUpAcrossLine = {
    prefix: 'fat',
    iconName: 'arrow-down-up-across-line',
    icon: [
      576,
      512,
      [],
      'e4af',
      
      'M154.3 509.7c3.1 3.1 8.2 3.1 11.3 0l96-96c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L168 484.7V264H568c4.4 0 8-3.6 8-8s-3.6-8-8-8H424V27.3l82.3 82.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-96-96c-3.1-3.1-8.2-3.1-11.3 0l-96 96c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L408 27.3V248H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H152V484.7L69.7 402.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l96 96zM152 192h16V40c0-4.4-3.6-8-8-8s-8 3.6-8 8V192zM424 320H408V472c0 4.4 3.6 8 8 8s8-3.6 8-8V320z'
      
    ]
  };

  

  
  

  var faSpaghettiMonsterFlying = {
    prefix: 'fat',
    iconName: 'spaghetti-monster-flying',
    icon: [
      640,
      512,
      ["pastafarianism"],
      'f67b',
      
      'M192 16a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm32.5 103.1C243.4 108 256 87.5 256 64c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64c6.2 0 12.2-.9 17.8-2.5l12.9 25.9c-25.5 14.1-44.8 32.8-60.7 51.4c-7.7 9-14.6 17.9-20.9 26.1l0 0 0 0-.5 .6c-6.5 8.5-12.5 16.1-18.3 22.6C110.6 265.4 100.8 272 90.1 272c-15.5 0-23.5-11.5-34.3-28.3l-.7-1.1C45.4 227.5 32.9 208 8 208c-4.4 0-8 3.6-8 8s3.6 8 8 8c15.5 0 23.5 11.5 34.3 28.3l.7 1.1c9.6 15 22.1 34.5 47.1 34.5c18 0 31.9-11.4 44.2-25.2l.3-.3c1.6 2.8 3.5 6.1 5.7 9.7c6.6 10.7 16.1 24.4 28.7 38.5c-3.6 9.6-6.5 19.4-9.3 28.6l0 0 0 0 0 0 0 0 0 0-1.3 4.3c-3.4 11.1-6.6 21.2-10.6 29.9c-4 8.6-8.5 15.1-14 19.5c-5.3 4.3-12.1 6.9-21.7 6.9c-13.3 0-26.8-6.4-43.5-14.3l-2.1-1C49.5 376.8 30 368 8 368c-4.4 0-8 3.6-8 8s3.6 8 8 8c18 0 34.5 7.2 51.6 15.2l3.3 1.6C78.3 408.1 95 416 112 416c12.9 0 23.3-3.7 31.7-10.4c8.2-6.6 14-15.6 18.5-25.3c4.5-9.7 8-20.8 11.4-31.9L175 344l0 0c2-6.8 4.1-13.5 6.4-20.2c21.5 21.2 50 41.8 85.8 52.5c-5.6 17.9-17.3 47.4-33.3 72.9c-8.4 13.4-17.8 25.3-27.8 33.7s-20.1 13-30.1 13c-4.4 0-8 3.6-8 8s3.6 8 8 8c15.1 0 28.7-6.9 40.4-16.8s22.1-23.3 31-37.4c17.1-27.3 29.5-58.7 35.3-77.5c11.7 2.4 24.2 3.8 37.3 3.8s25.6-1.3 37.3-3.8c5.8 18.8 18.1 50.2 35.3 77.5c8.9 14.1 19.3 27.5 31 37.4s25.3 16.8 40.4 16.8c4.4 0 8-3.6 8-8s-3.6-8-8-8c-10 0-20.1-4.6-30.1-13s-19.4-20.4-27.8-33.7c-16-25.5-27.7-55-33.3-72.9c35.8-10.7 64.3-31.3 85.8-52.5c2.3 6.7 4.3 13.4 6.4 20.2l0 0 1.3 4.4c3.4 11.1 6.9 22.2 11.4 31.9c4.5 9.8 10.3 18.8 18.5 25.3c8.4 6.7 18.8 10.4 31.7 10.4c17 0 33.7-7.9 49.1-15.2l3.3-1.6C597.5 391.2 614 384 632 384c4.4 0 8-3.6 8-8s-3.6-8-8-8c-22 0-41.5 8.8-58.4 16.8l-2.1 1C554.8 393.6 541.3 400 528 400c-9.6 0-16.4-2.7-21.7-6.9c-5.5-4.4-10-10.9-14-19.5c-4-8.6-7.2-18.7-10.6-29.9l-1.3-4.3 0 0c-2.8-9.2-5.8-19-9.3-28.6c12.5-14.2 22-27.9 28.7-38.5c2.2-3.6 4.2-6.9 5.7-9.7l.3 .3C518 276.6 531.9 288 549.9 288c24.9 0 37.4-19.5 47.1-34.5l.7-1.1C608.5 235.5 616.5 224 632 224c4.4 0 8-3.6 8-8s-3.6-8-8-8c-24.9 0-37.4 19.5-47 34.5l-.7 1.1c-10.8 16.8-18.8 28.3-34.3 28.3c-10.7 0-20.5-6.6-32.3-19.8c-5.8-6.5-11.7-14.1-18.3-22.6l-.5-.6 0 0 0 0 0 0c-6.4-8.2-13.3-17.2-20.9-26.1c-15.9-18.6-35.2-37.4-60.7-51.4l12.9-25.9c5.7 1.6 11.6 2.5 17.8 2.5c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64c0 23.5 12.6 44 31.5 55.1l-12.6 25.1c-22.7-10-49.8-16.3-82.9-16.3s-60.3 6.3-82.9 16.3l-12.6-25.1zM448 16a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM145.8 249.8l-.3-.5c2.6-3.2 5.1-6.6 7.7-9.9l.4-.5 0 0 0 0c6.4-8.3 13.1-17 20.5-25.6c29.9-34.9 71-69.2 145.8-69.2s115.9 34.3 145.8 69.2c7.4 8.6 14.1 17.3 20.5 25.6l.4 .5c2.6 3.4 5.2 6.7 7.7 9.9l-.3 .5c-1.8 3.4-4.5 8.2-8.1 14c-7.2 11.7-18.2 27.2-32.9 42.7C423.8 337.6 379.8 368 320 368s-103.8-30.4-133.2-61.5c-14.7-15.5-25.6-31.1-32.9-42.7c-3.6-5.8-6.3-10.7-8.1-14zM208 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM448 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  
    var faPastafarianism = faSpaghettiMonsterFlying;
  

  
  

  var faTruckFlatbed = {
    prefix: 'fat',
    iconName: 'truck-flatbed',
    icon: [
      640,
      512,
      [],
      'e2b6',
      
      'M400 120c0-13.3 10.7-24 24-24h50.7c10.6 0 20.8 4.2 28.3 11.7L596.3 201c7.5 7.5 11.7 17.7 11.7 28.3V400h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H575.6c.2 2.6 .4 5.3 .4 8c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-2.7 .1-5.4 .4-8H239.6c.2 2.6 .4 5.3 .4 8c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-2.7 .1-5.4 .4-8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H67.3c10.4-36.9 44.4-64 84.7-64s74.2 27.1 84.7 64H400V120zm16 253.4c15.9-22.6 42.2-37.4 72-37.4c40.3 0 74.2 27.1 84.7 64H592V232H416V373.4zM416 216H588c-.9-1.3-1.9-2.6-3-3.7L491.7 119c-4.5-4.5-10.6-7-17-7H424c-4.4 0-8 3.6-8 8v96zM152 496a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm408-72a72 72 0 1 0 -144 0 72 72 0 1 0 144 0z'
      
    ]
  };

  

  
  

  var faClarinet = {
    prefix: 'fat',
    iconName: 'clarinet',
    icon: [
      640,
      512,
      [],
      'f8ad',
      
      'M224 136c0-4.4 3.6-8 8-8h32H368 472h32c4.4 0 8 3.6 8 8s-3.6 8-8 8H480v48h79.5c4.2 0 8.3-1.1 11.9-3.2l47.2-27c2.2-1.2 4.6-1.9 7.1-1.9c7.9 0 14.3 6.4 14.3 14.3V369.7c0 7.9-6.4 14.3-14.3 14.3c-2.5 0-4.9-.6-7.1-1.9l-47.2-27c-3.6-2.1-7.7-3.2-11.9-3.2H101.6c-4.7 0-9.3-.8-13.7-2.4L5.3 319.5C2.1 318.4 0 315.4 0 312V232c0-3.4 2.1-6.4 5.3-7.5L88 194.4c4.4-1.6 9-2.4 13.7-2.4H256V144H232c-4.4 0-8-3.6-8-8zm240 8H376v48h88V144zm-104 0H272v48h88V144zM101.6 208c-2.8 0-5.6 .5-8.2 1.4L16 237.6v68.8l77.4 28.2c2.6 1 5.4 1.4 8.2 1.4H559.5c7 0 13.8 1.8 19.8 5.3L624 366.8V177.2l-44.7 25.5c-6 3.5-12.9 5.3-19.8 5.3H472 368 264 101.6zM272 256a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm112-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faBong = {
    prefix: 'fat',
    iconName: 'bong',
    icon: [
      448,
      512,
      [],
      'f55c',
      
      'M128 199.1c0 12.7-7.4 23.5-17.8 29C72.9 247.7 43.5 280.4 28 320H356c-15.5-39.6-44.9-72.3-82.2-91.9c-10.4-5.4-17.8-16.3-17.8-29V16H128V199.1zM272 16V199.1c0 6.3 3.7 11.9 9.2 14.8c21.6 11.4 40.8 26.7 56.5 45.1c.2-.2 .4-.5 .6-.7L396.7 200l-26.3-26.3c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l32 32 32 32c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L408 211.3l-58.3 58.3c-.7 .7-1.4 1.2-2.2 1.6c23 31.7 36.6 70.6 36.6 112.8c0 39.4-11.9 76.1-32.2 106.5c-9.6 14.4-26.5 21.5-43.8 21.5H76.1c-17.3 0-34.2-7.1-43.8-21.5l13.3-8.9c6 9 17.3 14.3 30.5 14.3H307.9c13.3 0 24.5-5.4 30.5-14.3C357.1 453.7 368 420.2 368 384c0-16.7-2.3-32.8-6.7-48.1c-.4 .1-.9 .1-1.3 .1H24c-.5 0-.9 0-1.3-.1C18.3 351.2 16 367.3 16 384c0 36.2 10.9 69.7 29.6 97.7l-13.3 8.9C11.9 460.1 0 423.4 0 384c0-73.8 41.7-137.9 102.8-170.1c5.5-2.9 9.2-8.5 9.2-14.8V16L88 16c-4.4 0-8-3.6-8-8s3.6-8 8-8h40H256h40c4.4 0 8 3.6 8 8s-3.6 8-8 8H272z'
      
    ]
  };

  

  
  

  var faCameraMovie = {
    prefix: 'fat',
    iconName: 'camera-movie',
    icon: [
      576,
      512,
      [127909,127910],
      'f8a9',
      
      'M16 128C16 66.1 66.1 16 128 16c47.6 0 88.4 29.7 104.5 71.7c1.2 3.1 4.2 5.1 7.5 5.1s6.3-2 7.5-5.1C263.6 45.7 304.4 16 352 16c61.9 0 112 50.1 112 112s-50.1 112-112 112H128C66.1 240 16 189.9 16 128zM128 0C57.3 0 0 57.3 0 128s57.3 128 128 128H352c70.7 0 128-57.3 128-128S422.7 0 352 0c-48.2 0-90.2 26.6-112 66C218.2 26.6 176.2 0 128 0zM536.5 512c21.8 0 39.5-17.7 39.5-39.5V291.9c0-23-20.6-40.4-43.3-36.6c-3.2 .5-6.2 1.5-9.1 2.8L448 292v17.5l82.2-37c1.7-.7 3.4-1.3 5.2-1.6c12.9-2.1 24.6 7.8 24.6 20.9V472.5c0 13-10.5 23.5-23.5 23.5c-3.3 0-6.6-.7-9.7-2.1L448 458.5V476l72.3 32.5c5.1 2.3 10.6 3.5 16.2 3.5zM64 336H32c-8.8 0-16-7.2-16-16s7.2-16 16-16H64h64H352c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H128c-26.5 0-48-21.5-48-48V352c0-8.8-7.2-16-16-16zM48 352H64v16 80c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V352c0-35.3-28.7-64-64-64H128 64 32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48zM128 80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm176-64a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z'
      
    ]
  };

  

  
  

  var faSigma = {
    prefix: 'fat',
    iconName: 'sigma',
    icon: [
      384,
      512,
      [8721],
      'f68b',
      
      'M.7 36.7C2 33.8 4.8 32 8 32H352c17.7 0 32 14.3 32 32v64c0 4.4-3.6 8-8 8s-8-3.6-8-8V64c0-8.8-7.2-16-16-16H25.8L206 250.7c2.7 3 2.7 7.6 0 10.6L25.8 464H352c8.8 0 16-7.2 16-16V384c0-4.4 3.6-8 8-8s8 3.6 8 8v64c0 17.7-14.3 32-32 32H8c-3.2 0-6-1.8-7.3-4.7s-.8-6.2 1.3-8.6L189.3 256 2 45.3C-.1 43-.6 39.6 .7 36.7z'
      
    ]
  };

  

  
  

  var faFaceGrinStars = {
    prefix: 'fat',
    iconName: 'face-grin-stars',
    icon: [
      512,
      512,
      [129321,"grin-stars"],
      'f587',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256.3 91.8c-43 0-84.1-5.5-121.5-15.4c-3.9-1-7.1 .3-8.7 1.8c-.7 .7-.9 1.2-.9 1.4l0 0c0 .1-.1 .7 .5 1.9c25 46.8 74.1 78.5 130.5 78.5s105.5-31.7 130.5-78.5c.7-1.2 .6-1.8 .5-1.9l0 0c0-.2-.2-.7-.9-1.4c-1.6-1.5-4.8-2.8-8.7-1.8c-37.4 9.9-78.4 15.4-121.5 15.4zm144.6-2.7C373.2 396.8 318.8 432 256.3 432s-116.9-35.2-144.6-86.9c-9.1-17 8.7-33.1 27.3-28.2c36 9.6 75.6 14.9 117.3 14.9s81.4-5.3 117.3-14.9c18.6-4.9 36.4 11.2 27.3 28.2zM160 112c3.1 0 5.9 1.8 7.2 4.6l21.2 44.4 48.7 6.4c3.1 .4 5.6 2.5 6.6 5.5s.1 6.2-2.1 8.3l-35.7 33.8 9 48.3c.6 3-.7 6.1-3.2 7.9s-5.8 2-8.5 .6L160 248.3l-43.2 23.5c-2.7 1.5-6 1.3-8.5-.6s-3.7-4.9-3.2-7.9l9-48.3L78.4 181.1c-2.2-2.1-3.1-5.3-2.1-8.3s3.5-5.1 6.6-5.5l48.7-6.4 21.2-44.4c1.3-2.8 4.1-4.6 7.2-4.6zm0 26.6l-15.8 33.2c-1.2 2.4-3.5 4.1-6.2 4.5L101.6 181l26.6 25.3c2 1.9 2.9 4.6 2.4 7.3l-6.7 36.1 32.3-17.5c2.4-1.3 5.3-1.3 7.6 0l32.3 17.5-6.7-36.1c-.5-2.7 .4-5.4 2.4-7.3L218.4 181 182 176.2c-2.7-.4-5-2-6.2-4.5L160 138.6zm199.2-22l21.2 44.4 48.7 6.4c3.1 .4 5.6 2.5 6.6 5.5s.1 6.2-2.1 8.3l-35.7 33.8 9 48.3c.6 3-.7 6.1-3.2 7.9s-5.8 2-8.5 .6L352 248.3l-43.2 23.5c-2.7 1.5-6 1.3-8.5-.6s-3.7-4.9-3.2-7.9l9-48.3-35.7-33.8c-2.2-2.1-3.1-5.3-2.1-8.3s3.5-5.1 6.6-5.5l48.7-6.4 21.2-44.4c1.3-2.8 4.1-4.6 7.2-4.6s5.9 1.8 7.2 4.6zm-23 55.2c-1.2 2.4-3.5 4.1-6.2 4.5L293.6 181l26.6 25.3c2 1.9 2.9 4.6 2.4 7.3l-6.7 36.1 32.3-17.5c2.4-1.3 5.3-1.3 7.6 0l32.3 17.5-6.7-36.1c-.5-2.7 .4-5.4 2.4-7.3L410.4 181 374 176.2c-2.7-.4-5-2-6.2-4.5L352 138.6l-15.8 33.2z'
      
    ]
  };

  
    var faGrinStars = faFaceGrinStars;
  

  
  

  var faSquareP = {
    prefix: 'fat',
    iconName: 'square-p',
    icon: [
      448,
      512,
      [],
      'e279',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm152 32h88c48.6 0 88 39.4 88 88s-39.4 88-88 88H144v72c0 4.4-3.6 8-8 8s-8-3.6-8-8V296 152c0-13.3 10.7-24 24-24zm88 160c39.8 0 72-32.2 72-72s-32.2-72-72-72H152c-4.4 0-8 3.6-8 8V288h96z'
      
    ]
  };

  

  
  

  var faBringForward = {
    prefix: 'fat',
    iconName: 'bring-forward',
    icon: [
      512,
      512,
      [],
      'f856',
      
      'M224 496H448c26.5 0 48-21.5 48-48V224c0-26.5-21.5-48-48-48H384V160h64c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V384h16v64c0 26.5 21.5 48 48 48zm64-160c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H64C37.5 16 16 37.5 16 64V288c0 26.5 21.5 48 48 48H288zm0 16H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H288c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64zm-16-96V96c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16V256c0 8.8 7.2 16 16 16H256c8.8 0 16-7.2 16-16zm16 0c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H256c17.7 0 32 14.3 32 32V256z'
      
    ]
  };

  

  
  

  var faRecordVinyl = {
    prefix: 'fat',
    iconName: 'record-vinyl',
    icon: [
      512,
      512,
      [],
      'f8d9',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM384 256a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zM256 144a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 128a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faTruckPlane = {
    prefix: 'fat',
    iconName: 'truck-plane',
    icon: [
      640,
      512,
      [],
      'e58f',
      
      'M177.7 33.3C188.2 16.2 204.2 0 224 0c20.2 0 36.3 16.2 46.7 33.3C281.3 50.9 288 72.6 288 89.2l0 22.8c-6.1 4.6-11.4 9.9-16 16l0-38.8c0-13-5.6-31.9-15-47.5c-9.7-16-21.6-25.6-33-25.6c-10.9 0-22.8 9.6-32.7 25.7C181.7 57.3 176 76.2 176 89.2V176l0 7.7 0 132.1 0 36.1 0 48c0 2.5-1.2 4.9-3.2 6.4l-57.6 43.2c-2 1.5-3.2 3.9-3.2 6.4v34.1c0 3.3 2.6 5.9 5.9 5.9c.6 0 1.2-.1 1.7-.3l102-31.4c1.5-.5 3.2-.5 4.7 0l71.6 22c2 1.1 4 2.1 6.1 3V504c0 .3 0 .7 0 1l-80-24.6L124.4 511c-2.1 .6-4.3 1-6.4 1c-12.1 0-21.9-9.8-21.9-21.9V456c0-7.6 3.6-14.7 9.6-19.2L160 396l0-44 0-25.6L30.4 362.1C15.1 366.3 0 354.8 0 339V290.9c0-14.6 7.9-28 20.7-35L160 179v-3V89.2c0-16.6 7-38.3 17.7-55.9zM160 197.3L28.4 269.9c-7.7 4.2-12.4 12.3-12.4 21L16 339c0 5.3 5 9.1 10.1 7.7L160 309.8V197.3zM592 144H336c-17.7 0-32 14.3-32 32V416c0 13 7.7 24.2 18.8 29.2c-1.8-4-2.8-8.5-2.8-13.2V376c0-21.2 11.8-39.7 29.3-49.2l3.4-11.4L365 274.2c6.1-20.3 24.8-34.2 46-34.2H517c21.2 0 39.9 13.9 46 34.2l12.4 41.2 3.4 11.4c17.4 9.5 29.3 28 29.3 49.2v56c0 4.7-1 9.2-2.8 13.2c11.1-5 18.8-16.2 18.8-29.2V176c0-17.7-14.3-32-32-32zM576 464H352v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V464c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48H592c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V464zm0-16c8.8 0 16-7.2 16-16V376c0-22.1-17.9-40-40-40H376c-22.1 0-40 17.9-40 40v56c0 8.8 7.2 16 16 16H576zM552 320h8l-4.8-16-7.6-25.2C543.6 265.3 531.1 256 517 256H411c-14.1 0-26.6 9.3-30.6 22.8L372.8 304 368 320h8 8.7H543.3 552zM400 396a12 12 0 1 0 -24 0 12 12 0 1 0 24 0zm-40 0a28 28 0 1 1 56 0 28 28 0 1 1 -56 0zm180 12a12 12 0 1 0 0-24 12 12 0 1 0 0 24zm0-40a28 28 0 1 1 0 56 28 28 0 1 1 0-56z'
      
    ]
  };

  

  
  

  var faCircleHeart = {
    prefix: 'fat',
    iconName: 'circle-heart',
    icon: [
      512,
      512,
      ["heart-circle"],
      'f4c7',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-329.1l-17.7-18c-29.4-29.8-77-29.8-106.4 0s-29.4 78.2 0 108L233.5 376.1c6.2 6.3 14.3 9.4 22.5 9.4s16.3-3.1 22.5-9.4L380.1 272.9c29.4-29.8 29.4-78.2 0-108s-77-29.8-106.4 0l-17.7 18zm5.7 17l23.4-23.8c23.1-23.5 60.5-23.5 83.6 0c23.2 23.6 23.2 61.9 0 85.5L267.1 364.9c-3.1 3.1-7.1 4.7-11.1 4.7s-8-1.5-11.1-4.7L143.3 261.7c-23.2-23.6-23.2-61.9 0-85.5c23.1-23.5 60.5-23.5 83.6 0l23.4 23.8c3.1 3.2 8.3 3.2 11.4 0z'
      
    ]
  };

  
    var faHeartCircle = faCircleHeart;
  

  
  

  var faChevronsLeft = {
    prefix: 'fat',
    iconName: 'chevrons-left',
    icon: [
      512,
      512,
      ["chevron-double-left"],
      'f323',
      
      'M50.3 250.3c-3.1 3.1-3.1 8.2 0 11.3l216 216c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L67.3 256 277.7 45.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-216 216zm408-216l-216 216c-3.1 3.1-3.1 8.2 0 11.3l216 216c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L259.3 256 469.7 45.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0z'
      
    ]
  };

  
    var faChevronDoubleLeft = faChevronsLeft;
  

  
  

  var faUnion = {
    prefix: 'fat',
    iconName: 'union',
    icon: [
      384,
      512,
      [8899],
      'f6a2',
      
      'M24 32c4.4 0 8 3.6 8 8V304c0 88.4 71.6 160 160 160s160-71.6 160-160V40c0-4.4 3.6-8 8-8s8 3.6 8 8V304c0 97.2-78.8 176-176 176S16 401.2 16 304V40c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faMenorah = {
    prefix: 'fat',
    iconName: 'menorah',
    icon: [
      640,
      512,
      [],
      'f676',
      
      'M17.4 56c-.9 2.1-1.4 4.4-1.4 6.8V64c0 8.8 7.2 16 16 16s16-7.2 16-16V62.8c0-2.3-.5-4.6-1.4-6.8L32 22 17.4 56zM2.7 49.7L20.8 7.4C22.8 2.9 27.1 0 32 0s9.2 2.9 11.2 7.4L61.3 49.7c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32S0 81.7 0 64V62.8c0-4.5 .9-8.9 2.7-13.1zM32 128c4.4 0 8 3.6 8 8l0 176c0 30.9 25.1 56 56 56h24V136c0-4.4 3.6-8 8-8s8 3.6 8 8V368h80V136c0-4.4 3.6-8 8-8s8 3.6 8 8V368h80l0-232c0-4.4 3.6-8 8-8s8 3.6 8 8l0 232h80V136c0-4.4 3.6-8 8-8s8 3.6 8 8V368h80V136c0-4.4 3.6-8 8-8s8 3.6 8 8V368h24c30.9 0 56-25.1 56-56l0-176c0-4.4 3.6-8 8-8s8 3.6 8 8l0 176c0 39.8-32.2 72-72 72H328V496H504c4.4 0 8 3.6 8 8s-3.6 8-8 8H320 136c-4.4 0-8-3.6-8-8s3.6-8 8-8H312V384H96c-39.8 0-72-32.2-72-72l0-176c0-4.4 3.6-8 8-8zM128 22L113.4 56c-.9 2.1-1.4 4.4-1.4 6.8V64c0 8.8 7.2 16 16 16s16-7.2 16-16V62.8c0-2.3-.5-4.6-1.4-6.8L128 22zM116.8 7.4C118.8 2.9 123.1 0 128 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L116.8 7.4zM209.4 56c-.9 2.1-1.4 4.4-1.4 6.8V64c0 8.8 7.2 16 16 16s16-7.2 16-16V62.8c0-2.3-.5-4.6-1.4-6.8L224 22 209.4 56zm-14.7-6.3L212.8 7.4C214.8 2.9 219.1 0 224 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM320 22L305.4 56c-.9 2.1-1.4 4.4-1.4 6.8V64c0 8.8 7.2 16 16 16s16-7.2 16-16V62.8c0-2.3-.5-4.6-1.4-6.8L320 22zM308.8 7.4C310.8 2.9 315.1 0 320 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L308.8 7.4zM401.4 56c-.9 2.1-1.4 4.4-1.4 6.8V64c0 8.8 7.2 16 16 16s16-7.2 16-16V62.8c0-2.3-.5-4.6-1.4-6.8L416 22 401.4 56zm-14.7-6.3L404.8 7.4C406.8 2.9 411.1 0 416 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM512 22L497.4 56c-.9 2.1-1.4 4.4-1.4 6.8V64c0 8.8 7.2 16 16 16s16-7.2 16-16V62.8c0-2.3-.5-4.6-1.4-6.8L512 22zM500.8 7.4C502.8 2.9 507.1 0 512 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L500.8 7.4zM593.4 56c-.9 2.1-1.4 4.4-1.4 6.8V64c0 8.8 7.2 16 16 16s16-7.2 16-16V62.8c0-2.3-.5-4.6-1.4-6.8L608 22 593.4 56zm-14.7-6.3L596.8 7.4C598.8 2.9 603.1 0 608 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1z'
      
    ]
  };

  

  
  

  var faFileCsv = {
    prefix: 'fat',
    iconName: 'file-csv',
    icon: [
      512,
      512,
      [],
      'f6dd',
      
      'M64 496h48v16H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H204.1c12.7 0 24.9 5.1 33.9 14.1L369.9 145.9c9 9 14.1 21.2 14.1 33.9V304H368V179.9c0-1.3-.1-2.6-.2-3.9H248c-22.1 0-40-17.9-40-40V16.2c-1.3-.2-2.6-.2-3.9-.2H64C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48zM361.1 160c-.8-1-1.6-1.9-2.4-2.7L226.7 25.4c-.9-.9-1.8-1.7-2.7-2.4V136c0 13.3 10.7 24 24 24H361.1zM200 368h16c17.7 0 32 14.3 32 32v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-8.8-7.2-16-16-16H200c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-8c0-4.4 3.6-8 8-8s8 3.6 8 8v8c0 17.7-14.3 32-32 32H200c-17.7 0-32-14.3-32-32V400c0-17.7 14.3-32 32-32zm133.1 0H368c4.4 0 8 3.6 8 8s-3.6 8-8 8H333.1c-11.7 0-21.1 9.4-21.1 21.1c0 8.3 4.9 15.9 12.5 19.3L362 441c13.4 6 22 19.2 22 33.9c0 20.5-16.6 37.1-37.1 37.1H304c-4.4 0-8-3.6-8-8s3.6-8 8-8h42.9c11.7 0 21.1-9.4 21.1-21.1c0-8.3-4.9-15.9-12.5-19.3L318 439c-13.4-6-22-19.2-22-33.9c0-20.5 16.6-37.1 37.1-37.1zm98.9 0c4.4 0 8 3.6 8 8v31.6c0 29.1 8.3 57.5 24 82c15.7-24.5 24-52.9 24-82V376c0-4.4 3.6-8 8-8s8 3.6 8 8v31.6c0 33.2-9.8 65.6-28.2 93.2l-5.1 7.7c-1.5 2.2-4 3.6-6.7 3.6s-5.2-1.3-6.7-3.6l-5.1-7.7c-18.4-27.6-28.2-60-28.2-93.2V376c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faLaptop = {
    prefix: 'fat',
    iconName: 'laptop',
    icon: [
      640,
      512,
      [128187],
      'f109',
      
      'M512 48H128c-26.5 0-48 21.5-48 48V352H64V96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V352H560V96c0-26.5-21.5-48-48-48zM19.2 400c-1.8 0-3.2 1.4-3.2 3.2C16 436.8 43.2 464 76.8 464H563.2c33.6 0 60.8-27.2 60.8-60.8c0-1.8-1.4-3.2-3.2-3.2H19.2zM0 403.2C0 392.6 8.6 384 19.2 384H620.8c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2z'
      
    ]
  };

  

  
  

  var faPerson = {
    prefix: 'fat',
    iconName: 'person',
    icon: [
      320,
      512,
      [129485,"male"],
      'f183',
      
      'M160 96a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm0-96a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM141.1 144c-21.5 0-41.1 12.3-50.4 31.7L23.2 315.5c-1.9 4-6.7 5.6-10.7 3.7s-5.6-6.7-3.7-10.7L76.3 168.7c12-24.9 37.2-40.7 64.8-40.7h37.8c27.6 0 52.8 15.8 64.8 40.7l67.5 139.8c1.9 4 .3 8.8-3.7 10.7s-8.8 .3-10.7-3.7L229.3 175.7C220 156.3 200.4 144 178.9 144H141.1zM104 248V480c0 8.8 7.2 16 16 16s16-7.2 16-16V360c0-13.3 10.7-24 24-24s24 10.7 24 24V480c0 8.8 7.2 16 16 16s16-7.2 16-16V248c0-4.4 3.6-8 8-8s8 3.6 8 8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V360c0-4.4-3.6-8-8-8s-8 3.6-8 8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V248c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  
    var faMale = faPerson;
  

  
  

  var faFireFlameSimple = {
    prefix: 'fat',
    iconName: 'fire-flame-simple',
    icon: [
      384,
      512,
      ["burn"],
      'f46a',
      
      'M209.1 8.5c72.9 68 128.7 152.4 162.7 246.1l.7 1.9c7.6 20.9 11.5 42.9 11.5 65.1C384 426.7 297.2 512 192 512S0 426.7 0 321.6c0-22.2 3.9-44.2 11.5-65.1l.7-1.9C46.2 160.8 102 76.5 174.9 8.5l3.3-3C181.9 2 186.9 0 192 0s10.1 2 13.8 5.5l3.3 3zM356.8 260C323.6 168.7 269.2 86.5 198.2 20.2l-3.3-3c-.8-.7-1.8-1.2-2.9-1.2s-2.1 .4-2.9 1.2l-3.3 3C114.8 86.5 60.4 168.7 27.2 260l-.7 1.9C19.6 281 16 301.2 16 321.6C16 417.7 95.5 496 192 496s176-78.3 176-174.4c0-20.3-3.6-40.5-10.5-59.6l-.7-1.9zm-60.4 23.4c5 11.3 7.6 23.7 7.6 36C304 381.2 254 432 192 432s-112-50.8-112-112.5c0-12.4 2.6-24.7 7.6-36l1.9-4.3c16.5-37.2 39.8-71.1 68.6-99.9l8.9-8.9c6.6-6.6 15.6-10.3 24.9-10.3s18.3 3.7 24.9 10.3l8.9 8.9c28.8 28.8 52.1 62.7 68.6 99.9l1.9 4.3zM205.6 181.6C202 178 197.1 176 192 176s-10 2-13.6 5.6l-8.9 8.9c-27.4 27.4-49.6 59.7-65.3 95.1l-1.9 4.3c-4.1 9.3-6.2 19.4-6.2 29.5c0 53 43 96.5 96 96.5s96-43.5 96-96.5c0-10.1-2.1-20.3-6.2-29.5l-1.9-4.3c-15.8-35.4-37.9-67.7-65.3-95.1l-8.9-8.9z'
      
    ]
  };

  
    var faBurn = faFireFlameSimple;
  

  
  

  var faPersonCarryBox = {
    prefix: 'fat',
    iconName: 'person-carry-box',
    icon: [
      384,
      512,
      ["person-carry"],
      'f4cf',
      
      'M91.4 226.4c-6.7 2-11.4 8.3-11.4 15.3v65.1c0 4.2 1.7 8.3 4.7 11.3l51 51c4.7 4.7 7.8 10.8 8.9 17.4l15.2 90.9c1.5 8.7-4.4 17-13.2 18.4s-17-4.4-18.4-13.2l-14.3-85.9c-.5-3.3-2.1-6.3-4.5-8.7L30.1 308.7c-9-9-14.1-21.2-14.1-33.9V186.6C16 163.1 35.1 144 58.6 144c18.7 0 36.2 9.3 46.5 24.9l42.6 64c3 4.5 8 7.1 13.3 7.1H224c8.8 0 16 7.2 16 16s-7.2 16-16 16H196.3 152.6c-10.7 0-20.7-5.3-26.6-14.3l-16.6-24.9c-3.9-5.9-11.2-8.5-17.9-6.4zM251.7 272c2.7-4.7 4.3-10.2 4.3-16c0-17.7-14.3-32-32-32H161.1l-42.6-64c-13.3-20-35.8-32-59.9-32C26.2 128 0 154.2 0 186.6v88.1c0 17 6.7 33.3 18.7 45.3l79.4 79.4 14.3 85.9c2.9 17.4 19.4 29.2 36.8 26.3s29.2-19.4 26.3-36.8l-15.2-90.9c-1.6-9.9-6.3-19-13.4-26.1l-51-51V270.5 241.7l16 24 .6 .9c8.9 13.4 23.9 21.4 39.9 21.4H224 352c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H224c-17.7 0-32 14.3-32 32v64h16V128c0-8.8 7.2-16 16-16H352c8.8 0 16 7.2 16 16V256c0 8.8-7.2 16-16 16H288 251.7zM80 16a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm48 32A48 48 0 1 0 32 48a48 48 0 1 0 96 0zM0 346.5L0 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-69.5-16-16L48 480c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-117.5-16-16z'
      
    ]
  };

  
    var faPersonCarry = faPersonCarryBox;
  

  
  

  var faArrowUpLong = {
    prefix: 'fat',
    iconName: 'arrow-up-long',
    icon: [
      384,
      512,
      ["long-arrow-up"],
      'f176',
      
      'M197.7 2.3c-3.1-3.1-8.2-3.1-11.3 0l-152 152c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L184 27.3V504c0 4.4 3.6 8 8 8s8-3.6 8-8V27.3L338.3 165.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-152-152z'
      
    ]
  };

  
    var faLongArrowUp = faArrowUpLong;
  

  
  

  var faCalendarCircleUser = {
    prefix: 'fat',
    iconName: 'calendar-circle-user',
    icon: [
      576,
      512,
      [],
      'e471',
      
      'M128 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H64C28.7 64 0 92.7 0 128v48 16V448c0 35.3 28.7 64 64 64H330.8c-6.9-4.9-13.5-10.2-19.6-16H64c-26.5 0-48-21.5-48-48V192H352h80 16V176 128c0-35.3-28.7-64-64-64H336V8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H128V8zM112 80v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80H320v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80h48c26.5 0 48 21.5 48 48v48H16V128c0-26.5 21.5-48 48-48h48zM509.9 469.6C488.3 486.2 461.3 496 432 496s-56.3-9.8-77.9-26.4l3.3-6.6c9.5-19 28.9-31 50.1-31h48.9c21.2 0 40.6 12 50.1 31l3.3 6.6zm12.4-10.9l-1.5-2.9c-12.2-24.4-37.1-39.8-64.4-39.8H407.6c-27.3 0-52.2 15.4-64.4 39.8l-1.5 2.9C318.4 435.5 304 403.5 304 368c0-70.7 57.3-128 128-128s128 57.3 128 128c0 35.5-14.4 67.5-37.7 90.7zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM432 304a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faTransporter = {
    prefix: 'fat',
    iconName: 'transporter',
    icon: [
      512,
      512,
      [],
      'e042',
      
      'M472 8V40h32c4.4 0 8 3.6 8 8s-3.6 8-8 8H472V88c0 4.4-3.6 8-8 8s-8-3.6-8-8V56H424c-4.4 0-8-3.6-8-8s3.6-8 8-8h32V8c0-4.4 3.6-8 8-8s8 3.6 8 8zM56 72v32H88c4.4 0 8 3.6 8 8s-3.6 8-8 8H56v32c0 4.4-3.6 8-8 8s-8-3.6-8-8V120H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H40V72c0-4.4 3.6-8 8-8s8 3.6 8 8zm56 424v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-26.5 21.5-48 48-48H368c26.5 0 48 21.5 48 48v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-17.7-14.3-32-32-32H144c-17.7 0-32 14.3-32 32zM256 16a32 32 0 1 0 0 64.1A32 32 0 1 0 256 16zm0 80c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48m-20.4 48c-24.3 0-47.2 11-62.4 30l-57.7 72c-5.5 6.9-4.4 17 2.5 22.5s17 4.4 22.5-2.5l45.3-56.5c2.1-2.7 5.7-3.7 8.9-2.5s5.3 4.2 5.3 7.5V416H184V237.3L153 276c-11.1 13.8-31.2 16-45 5s-16-31.2-5-45l57.7-72c18.2-22.7 45.8-36 74.9-36h40.7c29.1 0 56.7 13.2 74.9 36L409 236c11 13.8 8.8 33.9-5 45s-33.9 8.8-45-5l-31-38.7V416H312V214.5c0-3.4 2.1-6.4 5.3-7.5s6.8-.1 8.9 2.5L371.5 266c5.5 6.9 15.6 8 22.5 2.5s8-15.6 2.5-22.5l-57.7-72c-15.2-18.9-38.1-30-62.4-30H235.6zM248 416H232V328c0-13.3 10.7-24 24-24s24 10.7 24 24v88H264V328c0-4.4-3.6-8-8-8s-8 3.6-8 8v88z'
      
    ]
  };

  

  
  

  var faDiagramPredecessor = {
    prefix: 'fat',
    iconName: 'diagram-predecessor',
    icon: [
      512,
      512,
      [],
      'e477',
      
      'M496 416c0 26.5-21.5 48-48 48L64 464c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48l384 0c26.5 0 48 21.5 48 48l0 64zm-48 64c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64L64 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l384 0zM272 160c0 26.5-21.5 48-48 48L64 208c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48l128 0 32 0c26.5 0 48 21.5 48 48l0 64zm16-64c0-19.1-8.4-36.3-21.7-48L368 48c22.1 0 40 17.9 40 40l0 116.7-50.3-50.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l64 64c3.1 3.1 8.2 3.1 11.3 0l64-64c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L424 204.7 424 88c0-30.9-25.1-56-56-56L224 32l-32 0L64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64l0-64zM72 384c0 4.4 3.6 8 8 8l352 0c4.4 0 8-3.6 8-8s-3.6-8-8-8L80 376c-4.4 0-8 3.6-8 8zm8-264c-4.4 0-8 3.6-8 8s3.6 8 8 8l128 0c4.4 0 8-3.6 8-8s-3.6-8-8-8L80 120z'
      
    ]
  };

  

  
  

  var faCrateEmpty = {
    prefix: 'fat',
    iconName: 'crate-empty',
    icon: [
      512,
      512,
      [],
      'e151',
      
      'M496 376v80c0 22.1-17.9 40-40 40H56c-22.1 0-40-17.9-40-40V376H496zm0-16H16V280c0-22.1 17.9-40 40-40H456c22.1 0 40 17.9 40 40v80zm16 0V280c0-30.9-25.1-56-56-56H56c-30.9 0-56 25.1-56 56v80 8 8 80c0 30.9 25.1 56 56 56H456c30.9 0 56-25.1 56-56V376v-8-8zM96 304a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm336 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM96 432a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm336 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faBeerMugEmpty = {
    prefix: 'fat',
    iconName: 'beer-mug-empty',
    icon: [
      512,
      512,
      ["beer"],
      'f0fc',
      
      'M352 48c8.8 0 16 7.2 16 16v40V367.8v.4V416c0 26.5-21.5 48-48 48H96c-26.5 0-48-21.5-48-48V64c0-8.8 7.2-16 16-16H352zm32 368V373.2l84.9-37.1c26.2-11.5 43.1-37.4 43.1-66V152c0-30.9-25.1-56-56-56H384V64c0-17.7-14.3-32-32-32H64C46.3 32 32 46.3 32 64V416c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64zm78.4-94.6L384 355.8V112h72c22.1 0 40 17.9 40 40V270.1c0 22.2-13.2 42.4-33.6 51.3zM144 136c0-4.4-3.6-8-8-8s-8 3.6-8 8V376c0 4.4 3.6 8 8 8s8-3.6 8-8V136zm72 0c0-4.4-3.6-8-8-8s-8 3.6-8 8V376c0 4.4 3.6 8 8 8s8-3.6 8-8V136zm72 0c0-4.4-3.6-8-8-8s-8 3.6-8 8V376c0 4.4 3.6 8 8 8s8-3.6 8-8V136z'
      
    ]
  };

  
    var faBeer = faBeerMugEmpty;
  

  
  

  var faPeopleLine = {
    prefix: 'fat',
    iconName: 'people-line',
    icon: [
      640,
      512,
      [],
      'e534',
      
      'M320 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-64a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm-5.1 112c-32.5 0-62.4 17.9-77.6 46.6l0 .1 0 0-20 36.6c-2.1 3.9-7 5.3-10.9 3.2s-5.3-7-3.2-10.9l20-36.5c18.1-33.9 53.3-55 91.7-55h12.8c38.4 0 73.7 21.2 91.7 55l20 36.5c2.1 3.9 .7 8.7-3.2 10.9s-8.7 .7-10.9-3.2l-20-36.6 0-.1 0 0c-15.3-28.7-45.1-46.6-77.6-46.6H314.9zm-39.4 40.3c3.4 1 5.8 4.1 5.8 7.7v88c0 4.4-3.6 8-8 8s-8-3.6-8-8V219.6l-16.5 26.1c-2.4 3.7-7.3 4.8-11 2.5s-4.8-7.3-2.5-11l31.3-49.5c1.9-3 5.6-4.4 9-3.4zm91.5 0c3.4-1 7.1 .4 9 3.4l31.3 49.5c2.4 3.7 1.2 8.7-2.5 11s-8.7 1.2-11-2.5l-16.5-26.1 0 60.4c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-88c0-3.6 2.4-6.7 5.8-7.7zM496 208a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-64a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm-5.1 112c-32.5 0-62.4 17.9-77.6 46.6l-28 52.6c-2.7 5.1-.7 11.5 4.5 14.1c4.8 2.4 10.7 .7 13.5-3.9l39.3-65.5c1.9-3.1 5.5-4.6 9-3.6s5.9 4.1 5.9 7.7v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16l0-64c0-3.6 2.4-6.7 5.9-7.7s7.1 .5 9 3.6l39.3 65.5c2.8 4.6 8.6 6.3 13.5 3.9c5.2-2.6 7.2-9 4.5-14.1l-28-52.6c-15.3-28.7-45.1-46.6-77.6-46.6H490.9zm-91.8 39.1c18.1-33.9 53.4-55.1 91.8-55.1h12.8c38.4 0 73.7 21.2 91.8 55.1l28 52.6c7 13.1 1.8 29.3-11.5 35.9c-12.3 6.2-27.3 1.8-34.3-10l-24.4-40.7 0 35.1c0 17.7-14.3 32-32 32h-48c-17.7 0-32-14.3-32-32V332.9l-24.4 40.7c-7.1 11.8-22 16.2-34.3 10c-13.2-6.6-18.4-22.9-11.5-35.9l28-52.6zM8 464H632c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8zM168 184a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-64 0a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM61.3 302.6l-28 52.6c-2.7 5.1-.7 11.5 4.5 14.1c4.8 2.4 10.7 .7 13.5-3.9l39.3-65.5c1.8-3.1 5.5-4.6 9-3.6s5.9 4.1 5.9 7.7v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16l0-64c0-3.6 2.4-6.7 5.9-7.7s7.1 .5 9 3.6l39.3 65.5c2.8 4.6 8.6 6.3 13.5 3.9c5.2-2.6 7.2-9 4.5-14.1l-28-52.6c-15.3-28.7-45.1-46.6-77.6-46.6H138.9c-32.5 0-62.4 17.9-77.6 46.6zM138.9 240h12.8c38.4 0 73.7 21.2 91.8 55.1l28 52.6c7 13.1 1.8 29.3-11.5 35.9c-12.3 6.2-27.3 1.8-34.3-10l-24.4-40.7 0 35.1c0 17.7-14.3 32-32 32h-48c-17.7 0-32-14.3-32-32V332.9L64.9 373.6c-7.1 11.8-22 16.2-34.3 10c-13.2-6.6-18.4-22.9-11.5-35.9l28-52.6c18.1-33.9 53.4-55.1 91.8-55.1z'
      
    ]
  };

  

  
  

  var faLightbulbExclamationOn = {
    prefix: 'fat',
    iconName: 'lightbulb-exclamation-on',
    icon: [
      640,
      512,
      [],
      'e1ca',
      
      'M44.1 1.1l80 48c3.8 2.3 5 7.2 2.7 11s-7.2 5-11 2.7l-80-48c-3.8-2.3-5-7.2-2.7-11s7.2-5 11-2.7zm560 13.7l-80 48c-3.8 2.3-8.7 1-11-2.7s-1-8.7 2.7-11l80-48c3.8-2.3 8.7-1 11 2.7s1 8.7-2.7 11zM8 160H88c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8zm544 0h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H552c-4.4 0-8-3.6-8-8s3.6-8 8-8zM124.1 270.9l-80 48c-3.8 2.3-8.7 1-11-2.7s-1-8.7 2.7-11l80-48c3.8-2.3 8.7-1 11 2.7s1 8.7-2.7 11zm400-13.7l80 48c3.8 2.3 5 7.2 2.7 11s-7.2 5-11 2.7l-80-48c-3.8-2.3-5-7.2-2.7-11s7.2-5 11-2.7zm-72.6 10.1c18-25.9 28.5-57.3 28.5-91.2c0-88.4-71.6-160-160-160s-160 71.6-160 160c0 33.9 10.5 65.3 28.5 91.2c4.5 6.5 9.5 13.3 14.5 20.2l0 0 0 0c12.5 17.2 25.9 35.5 36.3 54.4c7.4 13.5 11.6 27.8 14 42.2H237c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8l0 0 0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C155.6 247.9 144 213.3 144 176C144 78.8 222.8 0 320 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4l0 0 0 0 0 0 0 0c-12.3 16.8-24.6 33.7-34.5 51.8c-5.9 10.8-9.6 22.5-11.8 34.5H386.7c2.4-14.4 6.6-28.7 14-42.2c10.4-19 23.7-37.3 36.3-54.4c5-6.9 10-13.7 14.5-20.2zM320 496c35.3 0 64-28.7 64-64H256c0 35.3 28.7 64 64 64zm-80-69.3c0-5.9 4.8-10.7 10.7-10.7H389.3c5.9 0 10.7 4.8 10.7 10.7V432c0 44.2-35.8 80-80 80s-80-35.8-80-80v-5.3zM328 104V264c0 4.4-3.6 8-8 8s-8-3.6-8-8V104c0-4.4 3.6-8 8-8s8 3.6 8 8zm-8 200a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faLocationPlus = {
    prefix: 'fat',
    iconName: 'location-plus',
    icon: [
      384,
      512,
      ["map-marker-plus"],
      'f60a',
      
      'M368 192c0-97.2-78.8-176-176-176S16 94.8 16 192c0 18.7 6.4 42.5 17.8 69.6c11.3 26.9 27.1 55.8 44.7 84.3c35.2 57 76.8 111.4 102.3 143.2c5.9 7.3 16.6 7.3 22.4 0c25.5-31.8 67.1-86.2 102.3-143.2c17.6-28.5 33.4-57.4 44.7-84.3C361.6 234.5 368 210.7 368 192zm16 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM184 288V200H96c-4.4 0-8-3.6-8-8s3.6-8 8-8h88V96c0-4.4 3.6-8 8-8s8 3.6 8 8v88h88c4.4 0 8 3.6 8 8s-3.6 8-8 8H200v88c0 4.4-3.6 8-8 8s-8-3.6-8-8z'
      
    ]
  };

  
    var faMapMarkerPlus = faLocationPlus;
  

  
  

  var faSquareArrowRight = {
    prefix: 'fat',
    iconName: 'square-arrow-right',
    icon: [
      448,
      512,
      ["arrow-square-right"],
      'f33b',
      
      'M432 96c0-26.5-21.5-48-48-48L64 48C37.5 48 16 69.5 16 96l0 320c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM349.7 261.7l-104 104c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L324.7 264 104 264c-4.4 0-8-3.6-8-8s3.6-8 8-8l220.7 0-90.3-90.3c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l104 104c3.1 3.1 3.1 8.2 0 11.3z'
      
    ]
  };

  
    var faArrowSquareRight = faSquareArrowRight;
  

  
  

  var faPeopleRoof = {
    prefix: 'fat',
    iconName: 'people-roof',
    icon: [
      640,
      512,
      [],
      'e537',
      
      'M324.4 1.3c-2.7-1.8-6.2-1.8-8.9 0l-312 208c-3.7 2.5-4.7 7.4-2.2 11.1s7.4 4.7 11.1 2.2L320 17.6l307.6 205c3.7 2.5 8.6 1.5 11.1-2.2s1.5-8.6-2.2-11.1l-312-208zM496 272a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 64a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm-5.1 32h12.8c32.5 0 62.4 17.9 77.6 46.6l28 52.6c2.7 5.1 .7 11.5-4.5 14.1c-4.8 2.4-10.7 .7-13.5-3.9l-39.3-65.4c-1.8-3.1-5.5-4.6-9-3.6s-5.9 4.1-5.9 7.7l0 64c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V416c0-3.6-2.4-6.7-5.9-7.7s-7.1 .5-9 3.6l-39.3 65.4c-2.8 4.6-8.6 6.3-13.5 3.9c-5.2-2.6-7.2-9-4.5-14.1l28-52.6c15.3-28.7 45.1-46.6 77.6-46.6zm-91.8 39.1l-28 52.6c-7 13.1-1.8 29.3 11.5 35.9c12.3 6.2 27.3 1.8 34.3-10l24.4-40.7V480c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32l0-35.1 24.4 40.7c7.1 11.8 22 16.2 34.3 10c13.2-6.6 18.4-22.9 11.5-35.9l-28-52.6c-18.1-33.9-53.4-55.1-91.8-55.1H490.9c-38.4 0-73.7 21.2-91.8 55.1zM120 296a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm64 0a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM61.3 414.6c15.3-28.7 45.1-46.6 77.6-46.6h12.8c32.5 0 62.4 17.9 77.6 46.6l28 52.6c2.7 5.1 .7 11.5-4.5 14.1c-4.8 2.4-10.7 .7-13.5-3.9l-39.3-65.4c-1.8-3.1-5.5-4.6-9-3.6s-5.9 4.1-5.9 7.7l0 64c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V416c0-3.6-2.4-6.7-5.9-7.7s-7.1 .5-9 3.6L51.2 477.3c-2.8 4.6-8.6 6.3-13.5 3.9c-5.2-2.6-7.2-9-4.5-14.1l28-52.6zM138.9 352c-38.4 0-73.7 21.2-91.8 55.1l-28 52.6c-7 13.1-1.8 29.3 11.5 35.9c12.3 6.2 27.3 1.8 34.3-10l24.4-40.7V480c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32l0-35.1 24.4 40.7c7.1 11.8 22 16.2 34.3 10c13.2-6.6 18.4-22.9 11.5-35.9l-28-52.6c-18.1-33.9-53.4-55.1-91.8-55.1H138.9zM320 160a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 64a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm-5.1 32h12.8c32.5 0 62.4 17.9 77.6 46.6l0 0 0 .1 20 36.6c2.1 3.9 7 5.3 10.9 3.2s5.3-7 3.2-10.9l-20-36.5c-18.1-33.9-53.4-55-91.7-55H314.9c-38.4 0-73.7 21.2-91.7 55l-20 36.5c-2.1 3.9-.7 8.7 3.2 10.9s8.7 .7 10.9-3.2l20-36.6 0 0 0-.1c15.3-28.7 45.1-46.6 77.6-46.6zm-39.4 40.3c-3.4-1-7.1 .4-9 3.4l-31.3 49.5c-2.4 3.7-1.2 8.7 2.5 11s8.7 1.3 11-2.5l16.5-26.1V392c0 4.4 3.6 8 8 8s8-3.6 8-8V304c0-3.6-2.4-6.7-5.8-7.7zm91.5 0c-3.4 1-5.8 4.1-5.8 7.7l0 88c0 4.4 3.6 8 8 8s8-3.6 8-8l0-60.4 16.5 26.1c2.4 3.7 7.3 4.8 11 2.5s4.8-7.3 2.5-11l-31.3-49.5c-1.9-3-5.6-4.4-9-3.4z'
      
    ]
  };

  

  
  

  var faUsersRectangle = {
    prefix: 'fat',
    iconName: 'users-rectangle',
    icon: [
      640,
      512,
      [],
      'e594',
      
      'M72 0C32.2 0 0 32.2 0 72V440c0 39.8 32.2 72 72 72H568c39.8 0 72-32.2 72-72V72c0-39.8-32.2-72-72-72H72zM16 72c0-30.9 25.1-56 56-56H568c30.9 0 56 25.1 56 56V440c0 30.9-25.1 56-56 56H72c-30.9 0-56-25.1-56-56V72zM272 192a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM224 360c0-30.9 25.1-56 56-56h80c30.9 0 56 25.1 56 56c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8zm96-104a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-40 32c-39.8 0-72 32.2-72 72c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-39.8-32.2-72-72-72H280zM152 272h64c4.4 0 8-3.6 8-8s-3.6-8-8-8H152c-30.9 0-56 25.1-56 56c0 17.7 14.3 32 32 32h32c4.4 0 8-3.6 8-8s-3.6-8-8-8H128c-8.8 0-16-7.2-16-16c0-22.1 17.9-40 40-40zm-8-96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm264 96c22.1 0 40 17.9 40 40c0 8.8-7.2 16-16 16H480c-4.4 0-8 3.6-8 8s3.6 8 8 8h32c17.7 0 32-14.3 32-32c0-30.9-25.1-56-56-56H424c-4.4 0-8 3.6-8 8s3.6 8 8 8h64zm8-96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-80 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z'
      
    ]
  };

  

  
  

  var faAnglesDown = {
    prefix: 'fat',
    iconName: 'angles-down',
    icon: [
      448,
      512,
      ["angle-double-down"],
      'f103',
      
      'M405.7 93.7l-176 176c-3.1 3.1-8.2 3.1-11.3 0l-176-176c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L224 252.7 394.3 82.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3zm0 192l-176 176c-3.1 3.1-8.2 3.1-11.3 0l-176-176c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L224 444.7 394.3 274.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3z'
      
    ]
  };

  
    var faAngleDoubleDown = faAnglesDown;
  

  
  

  var faCrop = {
    prefix: 'fat',
    iconName: 'crop',
    icon: [
      512,
      512,
      [],
      'f125',
      
      'M416 107.3l93.7-93.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L404.7 96 160 96c-4.4 0-8 3.6-8 8s3.6 8 8 8l228.7 0L112 388.7V8c0-4.4-3.6-8-8-8s-8 3.6-8 8V96H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H96V392c0 13.3 10.7 24 24 24H352c4.4 0 8-3.6 8-8s-3.6-8-8-8H123.3L400 123.3 400 504c0 4.4 3.6 8 8 8s8-3.6 8-8V416h88c4.4 0 8-3.6 8-8s-3.6-8-8-8H416l0-292.7z'
      
    ]
  };

  

  
  

  var faSchoolCircleExclamation = {
    prefix: 'fat',
    iconName: 'school-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e56c',
      
      'M496 240a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-8-144c0-4.4-3.6-8-8-8s-8 3.6-8 8v96c0 4.4 3.6 8 8 8s8-3.6 8-8V288zM324.6 1.4c-2.8-1.9-6.4-1.9-9.2 0L157.5 112H56c-30.9 0-56 25.1-56 56V456c0 30.9 25.1 56 56 56H256h16 96 16 10.8c-6.9-4.9-13.4-10.2-19.6-16H368 304 272V384c0-26.5 21.5-48 48-48c1 0 1.9 0 2.9 .1c1-5.3 2.2-10.6 3.6-15.8c-2.1-.2-4.3-.3-6.5-.3c-35.3 0-64 28.7-64 64V496H56c-22.1 0-40-17.9-40-40V168c0-22.1 17.9-40 40-40H160c1.6 0 3.2-.5 4.6-1.4L320 17.8 475.4 126.6c1.3 .9 2.9 1.4 4.6 1.4H584c22.1 0 40 17.9 40 40v79.2c5.8 6.1 11.1 12.7 16 19.6V168c0-30.9-25.1-56-56-56H482.5L324.6 1.4zM64 216v48c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V216c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm24-8h32c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H88c-4.4 0-8-3.6-8-8V216c0-4.4 3.6-8 8-8zm168-32a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm144 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-80-40c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h24c4.4 0 8-3.6 8-8s-3.6-8-8-8H328V144c0-4.4-3.6-8-8-8zM88 320c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V344c0-13.3-10.7-24-24-24H88zm-8 24c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H88c-4.4 0-8-3.6-8-8V344z'
      
    ]
  };

  

  
  

  var faUserVneck = {
    prefix: 'fat',
    iconName: 'user-vneck',
    icon: [
      448,
      512,
      [],
      'e461',
      
      'M224 240a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM352 128A128 128 0 1 1 96 128a128 128 0 1 1 256 0zM198.4 408.5l-63.7-84.9C66.8 338.8 16 399.5 16 472v8c0 8.8 7.2 16 16 16H416c8.8 0 16-7.2 16-16v-8c0-72.5-50.8-133.2-118.7-148.4l-63.7 84.9c-12.8 17.1-38.4 17.1-51.2 0zM132.1 307.8c5.8-1.3 11.7 1.2 15.3 5.9l63.9 85.2c6.4 8.5 19.2 8.5 25.6 0l63.9-85.2c3.6-4.7 9.5-7.2 15.3-5.9C391.4 324.3 448 391.5 448 472v8c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-8c0-80.5 56.6-147.7 132.1-164.1z'
      
    ]
  };

  

  
  

  var faFootball = {
    prefix: 'fat',
    iconName: 'football',
    icon: [
      512,
      512,
      [127944,"football-ball"],
      'f44e',
      
      'M441.3 36.9c-53.1-7.6-100-8.7-141.4-4.2L478.4 211.1c6.3-50.2 3.7-99.9-3.4-141.8c-1.3-7.9-5.4-15.4-11.7-21.4c-6.2-6-13.9-9.8-22.1-11zM214.5 52.1C152 75.3 108.6 114.9 79.7 162c-22.5 36.7-36.1 77.8-43.2 119.2l1.2 1.2 192 192 2.4 2.4c23.8-3.8 45.6-9.5 65.5-16.9C360 436.7 403.4 397.1 432.3 350c22.5-36.7 36.1-77.8 43.2-119.2l-1.2-1.2-192-192L280 35.3c-23.8 3.8-45.6 9.5-65.5 16.9zM33.6 300.9c-6.3 50.2-3.7 99.8 3.4 141.8c1.3 7.9 5.4 15.4 11.7 21.4c6.2 6 13.9 9.8 22.1 11c53.1 7.6 100 8.7 141.4 4.2L33.6 300.9zM443.6 21c11.7 1.7 22.4 7.2 30.9 15.3s14.4 18.7 16.4 30.3c14.1 84 11.2 200.1-44.9 291.7c-30.6 50-76.8 92-142.9 116.5C241.4 497.8 164 504.7 68.4 490.9c-11.7-1.7-22.4-7.2-30.9-15.3s-14.4-18.7-16.4-30.3C7.1 361.3 9.9 245.2 66 153.6c30.6-50 76.8-92 142.9-116.5C270.6 14.2 348 7.3 443.6 21zM285.7 162.3l64 64c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-64-64c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0zm-56 56l64 64c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-64-64c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0zm-56 56l64 64c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-64-64c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0z'
      
    ]
  };

  
    var faFootballBall = faFootball;
  

  
  

  var faChevronsUp = {
    prefix: 'fat',
    iconName: 'chevrons-up',
    icon: [
      512,
      512,
      ["chevron-double-up"],
      'f325',
      
      'M261.7 50.3c-3.1-3.1-8.2-3.1-11.3 0l-216 216c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L256 67.3 466.3 277.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-216-216zm216 408l-216-216c-3.1-3.1-8.2-3.1-11.3 0l-216 216c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L256 259.3 466.3 469.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3z'
      
    ]
  };

  
    var faChevronDoubleUp = faChevronsUp;
  

  
  

  var faFlagCheckered = {
    prefix: 'fat',
    iconName: 'flag-checkered',
    icon: [
      448,
      512,
      [127937],
      'f11e',
      
      'M16 8c0-4.4-3.6-8-8-8S0 3.6 0 8V64 383.5 400 504c0 4.4 3.6 8 8 8s8-3.6 8-8V396l112.3-28.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30V54.8c0-17.8-18.8-29.4-34.7-21.5l-19.7 9.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L16 60V8zm0 68.5l112-28v93.2L16 166.1V76.5zm0 106l112-24.3v87.6L16 270.1V182.4zm128-27.8l17.8-3.9c19.7-4.3 40.1-3.5 59.4 2.1l65.7 19.3c5.7 1.7 11.4 3 17.2 4.1V264c-4.3-.9-8.5-1.9-12.7-3.1l-65.7-19.3c-21.9-6.4-45-7.3-67.3-2.4L144 242.2V154.6zm176 23.8c16.5 1.4 33.1 .4 49.4-3.1L432 161.9v87.6l-66 14.1c-15.2 3.3-30.7 4.1-46 2.7V178.4zM304 280.3V382c-15.9-2.6-31.4-7.6-46.1-14.9c-35.3-17.7-75.1-24-113.9-18.5V258.6l17.8-3.9c19.7-4.3 40.1-3.5 59.4 2.1l65.7 19.3c5.7 1.7 11.4 3 17.2 4.1zm16 103.5V282.4c16.5 1.4 33.1 .4 49.4-3.1L432 265.9v79.9c0 6.7-4.1 12.6-10.4 15l-34.7 13c-21.6 8.1-44.4 11.4-66.9 10zm0-221.4V76.6c27.7 0 55.3-6.4 80.7-19.1l19.7-9.8c5.3-2.7 11.6 1.2 11.6 7.2v90.7l-66 14.1c-15.2 3.3-30.7 4.1-46 2.7zM304 75.9V160c-4.3-.9-8.5-1.9-12.7-3.1l-65.7-19.3c-21.9-6.4-45-7.3-67.3-2.4L144 138.2V44.7c32.2-6.4 65.8-1.9 95.3 12.8c20.5 10.3 42.5 16.4 64.7 18.3zM16 286.4l112-24.3v89.4c-1.2 .3-2.4 .6-3.6 .9L16 379.5V286.4z'
      
    ]
  };

  

  
  

  var faUtilityPoleDouble = {
    prefix: 'fat',
    iconName: 'utility-pole-double',
    icon: [
      512,
      512,
      [],
      'e2c4',
      
      'M264 16c4.4 0 8 3.6 8 8V80H240V24c0-4.4 3.6-8 8-8h16zm-40 8V80H80V40c0-4.4-3.6-8-8-8s-8 3.6-8 8V80H16V40c0-4.4-3.6-8-8-8s-8 3.6-8 8V80 96v16c0 17.7 14.3 32 32 32h69.5L224 228.2V272H80V232c0-4.4-3.6-8-8-8s-8 3.6-8 8v40H16V232c0-4.4-3.6-8-8-8s-8 3.6-8 8v40 16 16c0 17.7 14.3 32 32 32h69.5L224 420.2V504c0 4.4 3.6 8 8 8s8-3.6 8-8V416.1c0-.1 0-.1 0-.2V336h32v79.9c0 .1 0 .1 0 .2V504c0 4.4 3.6 8 8 8s8-3.6 8-8V420.2L410.5 336H480c17.7 0 32-14.3 32-32V288 272 232c0-4.4-3.6-8-8-8s-8 3.6-8 8v40H448V232c0-4.4-3.6-8-8-8s-8 3.6-8 8v40H288V228.2L410.5 144H480c17.7 0 32-14.3 32-32V96 80 40c0-4.4-3.6-8-8-8s-8 3.6-8 8V80H448V40c0-4.4-3.6-8-8-8s-8 3.6-8 8V80H288V24c0-13.3-10.7-24-24-24H248c-13.3 0-24 10.7-24 24zM408.1 128c-.1 0-.1 0-.2 0H288 272 240 224 104.1c-.1 0-.1 0-.2 0H32c-8.8 0-16-7.2-16-16V96H224h16 32 16H496v16c0 8.8-7.2 16-16 16H408.1zM129.8 144H224v64.8L129.8 144zM240 224.1c0-.1 0-.1 0-.2V144h32v79.9c0 .1 0 .1 0 .2V272H240V224.1zm48-15.3V144h94.2L288 208.8zM408.1 320c-.1 0-.1 0-.2 0H280 232 104.1c-.1 0-.1 0-.2 0H32c-8.8 0-16-7.2-16-16V288H224h16 32 16H496v16c0 8.8-7.2 16-16 16H408.1zM129.8 336H224v64.8L129.8 336zm252.5 0L288 400.8V336h94.2z'
      
    ]
  };

  

  
  

  var faBuildingMemo = {
    prefix: 'fat',
    iconName: 'building-memo',
    icon: [
      640,
      512,
      [],
      'e61e',
      
      'M336 16H48C30.3 16 16 30.3 16 48V464c0 17.7 14.3 32 32 32h96V416c0-26.5 21.5-48 48-48s48 21.5 48 48v80h57.6c2.9 5.7 6.5 11.1 10.5 16H240 224 160 144 48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V64h-8c-2.7 0-5.4 .1-8 .4V48c0-17.7-14.3-32-32-32zm-38.3 95.8c-1.4 2.7-2.6 5.4-3.7 8.2H280 256h-8c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h8 24 8v14.6c-2.5 .9-5.2 1.4-8 1.4H248c-13.3 0-24-10.7-24-24V128c0-13.3 10.7-24 24-24h32c7 0 13.3 3 17.7 7.8zM288 233.4V248h-8H256h-8c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h8 24 8v14.6c-2.5 .9-5.2 1.4-8 1.4H248c-13.3 0-24-10.7-24-24V256c0-13.3 10.7-24 24-24h32c2.8 0 5.5 .5 8 1.4zM224 416c0-17.7-14.3-32-32-32s-32 14.3-32 32v80h64V416zM80 256c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V256zm24-8c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V256c0-4.4-3.6-8-8-8H104zM80 128c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V128zm24-8c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V128c0-4.4-3.6-8-8-8H104zm280-8c-26.5 0-48 21.5-48 48V448c0 26.5 21.5 48 48 48H576c26.5 0 48-21.5 48-48V160c0-26.5-21.5-48-48-48H384zm-64 48c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H384c-35.3 0-64-28.7-64-64V160zm64 48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM384 400a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm72-200H576c4.4 0 8 3.6 8 8s-3.6 8-8 8H456c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 96H576c4.4 0 8 3.6 8 8s-3.6 8-8 8H456c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 96H576c4.4 0 8 3.6 8 8s-3.6 8-8 8H456c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faSquareX = {
    prefix: 'fat',
    iconName: 'square-x',
    icon: [
      448,
      512,
      [],
      'e286',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm126 34.8l98 113 98-113c2.9-3.3 7.9-3.7 11.3-.8s3.7 7.9 .8 11.3L234.6 256 334 370.8c2.9 3.3 2.5 8.4-.8 11.3s-8.4 2.5-11.3-.8l-98-113-98 113c-2.9 3.3-7.9 3.7-11.3 .8s-3.7-7.9-.8-11.3L213.4 256 114 141.2c-2.9-3.3-2.5-8.4 .8-11.3s8.4-2.5 11.3 .8z'
      
    ]
  };

  

  
  

  var faBowlScoop = {
    prefix: 'fat',
    iconName: 'bowl-scoop',
    icon: [
      448,
      512,
      [127847,"bowl-shaved-ice"],
      'e3de',
      
      'M416 224c0-106-86-192-192-192S32 118 32 224H48c0-97.2 78.8-176 176-176s176 78.8 176 176h16zM17.9 280.7c-.5-4.6 3.1-8.7 7.7-8.7H422.4c4.6 0 8.3 4 7.7 8.7c-7.5 67.9-65 119.3-133.3 119.3H264c-3.2 0-6.2 1.9-7.4 4.9s-.6 6.4 1.7 8.7L335 490.3c.6 .6 1 1.5 1 2.3c0 1.8-1.5 3.3-3.3 3.3H115.3c-1.8 0-3.3-1.5-3.3-3.3c0-.9 .3-1.7 1-2.3l76.7-76.7c2.3-2.3 3-5.7 1.7-8.7s-4.2-4.9-7.4-4.9H151.2C82.9 400 25.4 348.6 17.9 280.7zM25.6 256C11.5 256 .4 268.3 2 282.4C10.4 358.5 74.7 416 151.2 416h13.4l-63 63c-3.6 3.6-5.7 8.5-5.7 13.7c0 10.7 8.6 19.3 19.3 19.3H332.7c10.7 0 19.3-8.6 19.3-19.3c0-5.1-2-10-5.7-13.7l-63-63h13.4c76.5 0 140.8-57.5 149.2-133.6c1.6-14.1-9.5-26.4-23.7-26.4H25.6z'
      
    ]
  };

  
    var faBowlShavedIce = faBowlScoop;
  

  
  

  var faMessageExclamation = {
    prefix: 'fat',
    iconName: 'message-exclamation',
    icon: [
      512,
      512,
      ["comment-alt-exclamation"],
      'f4a5',
      
      'M176 416c0-8.8-7.2-16-16-16H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H309.3c-3.5 0-6.8 1.1-9.6 3.2L176 496V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h80 16v16 64c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM256 80c-4.4 0-8 3.6-8 8V248c0 4.4 3.6 8 8 8s8-3.6 8-8V88c0-4.4-3.6-8-8-8zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  
    var faCommentAltExclamation = faMessageExclamation;
  

  
  

  var faLightCeiling = {
    prefix: 'fat',
    iconName: 'light-ceiling',
    icon: [
      512,
      512,
      [],
      'e016',
      
      'M256 0c4.4 0 8 3.6 8 8V160.1C390.9 164 494.6 260.3 510 384.1c2.2 17.5-12.4 31.9-30 31.9H32C14.3 416-.2 401.6 2 384.1C17.4 260.3 121.1 164 248 160.1V8c0-4.4 3.6-8 8-8zM17.9 386c-.8 6.7 4.7 14 14.1 14H480c9.4 0 15-7.3 14.2-14C479.4 267.6 378.4 176 256 176S32.6 267.6 17.9 386zM256 512c-35.3 0-64-28.7-64-64h16c0 26.5 21.5 48 48 48s48-21.5 48-48h16c0 35.3-28.7 64-64 64z'
      
    ]
  };

  

  
  

  var faFaceSmileBeam = {
    prefix: 'fat',
    iconName: 'face-smile-beam',
    icon: [
      512,
      512,
      [128522,"smile-beam"],
      'f5b8',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm150.6 67.4C171.4 353.2 206.6 384 256 384s84.6-30.8 105.4-60.6c2.5-3.6 7.5-4.5 11.1-2s4.5 7.5 2 11.1C352.1 364.6 312.7 400 256 400s-96.1-35.4-118.6-67.4c-2.5-3.6-1.7-8.6 2-11.1s8.6-1.7 11.1 2zm.4-137.7c-7.4 11.4-12.7 26.3-15.2 39.8c-.8 4.3-5 7.2-9.3 6.4s-7.2-5-6.4-9.3c2.8-15 8.7-32 17.6-45.6c8.7-13.3 21.5-25 38.3-25s29.6 11.7 38.3 25c8.8 13.5 14.8 30.6 17.6 45.6c.8 4.3-2 8.5-6.4 9.3s-8.5-2-9.3-6.4c-2.5-13.5-7.8-28.4-15.2-39.8c-7.6-11.6-16.1-17.7-24.9-17.7s-17.3 6.1-24.9 17.7zm144.8 39.8c-.8 4.3-5 7.2-9.3 6.4s-7.2-5-6.4-9.3c2.8-15 8.7-32 17.6-45.6c8.7-13.3 21.5-25 38.3-25s29.6 11.7 38.3 25c8.8 13.5 14.8 30.6 17.6 45.6c.8 4.3-2 8.5-6.4 9.3s-8.5-2-9.3-6.4c-2.5-13.5-7.8-28.4-15.2-39.8c-7.6-11.6-16.1-17.7-24.9-17.7s-17.3 6.1-24.9 17.7c-7.4 11.4-12.7 26.3-15.2 39.8z'
      
    ]
  };

  
    var faSmileBeam = faFaceSmileBeam;
  

  
  

  var faForwardStep = {
    prefix: 'fat',
    iconName: 'forward-step',
    icon: [
      320,
      512,
      ["step-forward"],
      'f051',
      
      'M272 72c0-4.4 3.6-8 8-8s8 3.6 8 8V256 440c0 4.4-3.6 8-8 8s-8-3.6-8-8V277.6L80.2 441c-5.3 4.5-12 7-19 7C45.1 448 32 434.9 32 418.8V93.2C32 77.1 45.1 64 61.2 64c6.9 0 13.7 2.5 19 7L272 234.4V72zm0 184c0-.4-.2-.8-.5-1L69.8 83.2c-2.4-2-5.4-3.2-8.6-3.2C53.9 80 48 85.9 48 93.2V418.8c0 7.3 5.9 13.2 13.2 13.2c3.1 0 6.2-1.1 8.6-3.2L271.5 257c.3-.3 .5-.6 .5-1z'
      
    ]
  };

  
    var faStepForward = faForwardStep;
  

  
  

  var faMessageBot = {
    prefix: 'fat',
    iconName: 'message-bot',
    icon: [
      640,
      512,
      [],
      'e3b8',
      
      'M224 400c8.8 0 16 7.2 16 16v80l123.7-92.8c2.8-2.1 6.1-3.2 9.6-3.2H480c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H160c-26.5 0-48 21.5-48 48V352c0 26.5 21.5 48 48 48h64zM96 64c0-35.3 28.7-64 64-64H480c35.3 0 64 28.7 64 64V184h33c3.6-13.8 16.1-24 31-24c17.7 0 32 14.3 32 32s-14.3 32-32 32c-14.9 0-27.4-10.2-31-24H544V352c0 35.3-28.7 64-64 64H373.3L249.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V432 416H208 160c-35.3 0-64-28.7-64-64V200H63c-3.6 13.8-16.1 24-31 24c-17.7 0-32-14.3-32-32s14.3-32 32-32c14.9 0 27.4 10.2 31 24H96V64zM32 208a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm592-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM176 96c-8.8 0-16 7.2-16 16V272c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm-32 16c0-17.7 14.3-32 32-32H464c17.7 0 32 14.3 32 32V272c0 17.7-14.3 32-32 32H176c-17.7 0-32-14.3-32-32V112zm80 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm40 24a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zm128 0a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 40a40 40 0 1 1 0-80 40 40 0 1 1 0 80z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassLocation = {
    prefix: 'fat',
    iconName: 'magnifying-glass-location',
    icon: [
      512,
      512,
      ["search-location"],
      'f689',
      
      'M208 16a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 400c54.6 0 104.2-21 141.3-55.4l149 149c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-149-149C395 312.2 416 262.6 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm40.1-170.5c-13.4 23.4-29.3 44.4-40.1 57.7c-10.8-13.3-26.7-34.4-40.1-57.7C153.9 220.9 144 196.1 144 176c0-35.3 28.7-64 64-64s64 28.7 64 64c0 20.1-9.9 44.9-23.9 69.5zm-28.7 69.1c22.1-27 68.6-89.8 68.6-138.6c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 48.8 46.5 111.6 68.6 138.6c6 7.3 16.8 7.3 22.7 0zM224 176a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  
    var faSearchLocation = faMagnifyingGlassLocation;
  

  
  

  var faHandPointRight = {
    prefix: 'fat',
    iconName: 'hand-point-right',
    icon: [
      512,
      512,
      [],
      'f0a4',
      
      'M464 128c17.7 0 32 14.3 32 32s-14.3 32-32 32l-152 0-56 0 0-56c0-2.7-.1-5.4-.4-8L464 128zM240 192l0 0 0 16 0 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-72c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 72c0 18.5 10.5 34.6 25.9 42.6C175 291.4 168 304.9 168 320s7 28.6 17.9 37.4c-15.4 8-25.9 24.1-25.9 42.6c0 12.3 4.6 23.5 12.2 32L152 432C76.9 432 16 371.1 16 296l0-80C16 140.9 76.9 80 152 80l32 0c30.9 0 56 25.1 56 56l0 56zm16 16l56 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-31.9 0c0 0 0 0-.1 0l-36.2 0c7.6-8.5 12.2-19.7 12.2-32l0-32zm91.8 0L464 208c26.5 0 48-21.5 48-48s-21.5-48-48-48l-212.1 0C242 84 215.3 64 184 64l-32 0C68.1 64 0 132.1 0 216l0 80c0 83.9 68.1 152 152 152l56 0 24 0 32 0c26.5 0 48-21.5 48-48c0-13.8-5.8-26.3-15.2-35c18.2-6.8 31.2-24.4 31.2-45c0-12.4-4.7-23.6-12.3-32.1C340.5 286 360 265.3 360 240c0-12.3-4.6-23.5-12.2-32zM240 288l40 0c17.7 0 32 14.3 32 32c0 17.7-14.3 32-32 32l-16 0-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l24 0zm-8 144l-24 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l8 0 48 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0z'
      
    ]
  };

  

  
  

  var faH1 = {
    prefix: 'fat',
    iconName: 'h1',
    icon: [
      576,
      512,
      [],
      'f313',
      
      'M496 72c0-2.9-1.6-5.6-4.1-7s-5.7-1.3-8.1 .2l-64 40c-3.7 2.3-4.9 7.3-2.5 11s7.3 4.9 11 2.5L480 86.4V432H424c-4.4 0-8 3.6-8 8s3.6 8 8 8h64 64c4.4 0 8-3.6 8-8s-3.6-8-8-8H496V72zM16 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V248 440c0 4.4 3.6 8 8 8s8-3.6 8-8V256H304V440c0 4.4 3.6 8 8 8s8-3.6 8-8V248 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V240H16V72z'
      
    ]
  };

  

  
  

  var faStandardDefinition = {
    prefix: 'fat',
    iconName: 'standard-definition',
    icon: [
      576,
      512,
      ["rectangle-sd"],
      'e28a',
      
      'M512 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM312 168V344c0 4.4 3.6 8 8 8h64c53 0 96-43 96-96s-43-96-96-96H320c-4.4 0-8 3.6-8 8zm16 8h56c44.2 0 80 35.8 80 80s-35.8 80-80 80H328V176zm-176.2 3.1c13.2-4.3 31.2-4.5 52.5-1.6c6.5 .9 26.5 4.2 33 5.7c4.3 1 8.6-1.7 9.6-6s-1.7-8.6-6-9.6c-7.1-1.6-27.6-5-34.4-5.9c-22.1-3-43-3.1-59.6 2.2c-17.2 5.6-29.9 17.3-33.9 36.9l0 0-.1 .4c-1.5 10.5-.1 19.6 4 27.4c4.1 7.7 10.5 13.4 17.8 17.7c14 8.3 33.1 12.8 50.6 16.9l.8 .2c18.5 4.3 35.3 8.3 46.9 15.2c5.6 3.4 9.5 7.1 11.9 11.5c2.3 4.3 3.4 9.8 2.3 17.5c-1 6.8-3.5 11.8-7.1 15.6c-3.6 3.8-8.7 6.8-15.3 8.9c-13.4 4.3-31.9 4.4-53.2 1.5c-10.5-1.5-28.2-6.6-41.7-10.6l0 0c-2.9-.8-5.5-1.6-7.9-2.3c-4.2-1.2-8.7 1.3-9.9 5.5s1.2 8.7 5.5 9.9c2.1 .6 4.6 1.3 7.2 2.1c13.4 3.9 32.7 9.6 44.5 11.2l0 0c22 3 43.4 3.2 60.2-2.1c8.5-2.7 16.2-6.9 22.1-13.2c6-6.4 9.8-14.5 11.2-24.2c1.5-10.5 .1-19.6-4-27.4c-4.1-7.7-10.5-13.4-17.8-17.7c-14-8.3-33.1-12.8-50.6-16.9l-.8-.2c-18.5-4.3-35.3-8.3-46.9-15.2c-5.6-3.4-9.6-7.1-11.9-11.5c-2.3-4.2-3.4-9.7-2.3-17.3c2.7-13 10.6-20.6 23.1-24.7z'
      
    ]
  };

  
    var faRectangleSd = faStandardDefinition;
  

  
  

  var faSkiBoot = {
    prefix: 'fat',
    iconName: 'ski-boot',
    icon: [
      512,
      512,
      [],
      'e3cc',
      
      'M391.8 9.9c1.1-4.3-1.5-8.6-5.8-9.7s-8.6 1.5-9.7 5.8L369.8 32H122.5c-19.2 0-35.7 13.7-39.3 32.5L7.3 464.5C2.7 489.2 21.6 512 46.6 512H472h32c4.4 0 8-3.6 8-8s-3.6-8-8-8H480V392.5c0-22.9-13.9-43.5-35.2-52L321.5 291.2 383.7 42.1l.1-.3 8-31.8zM235.4 48H365.8l-36 144H256c-4.4 0-8 3.6-8 8s3.6 8 8 8h69.8l-20 80H224c-4.4 0-8 3.6-8 8s3.6 8 8 8h86.5l128.4 51.4c15.2 6.1 25.1 20.8 25.1 37.1V496H46.6c-15 0-26.4-13.7-23.6-28.5L55.6 296c1.2 .1 2.3-.1 3.5-.6c56.4-23.4 140.3-85 176.2-245.6c.1-.6 .2-1.2 .2-1.7zm-16.2 0C185.6 196.2 110.5 254.7 59 278L98.9 67.5C101.1 56.2 111 48 122.5 48h96.7z'
      
    ]
  };

  

  
  

  var faFingerprint = {
    prefix: 'fat',
    iconName: 'fingerprint',
    icon: [
      512,
      512,
      [],
      'f577',
      
      'M16 256C16 123.5 123.5 16 256 16c77.9 0 147.2 37.1 191 94.7c2.7 3.5 7.7 4.2 11.2 1.5s4.2-7.7 1.5-11.2C413 39.6 339.1 0 256 0C114.6 0 0 114.6 0 256v56c0 4.4 3.6 8 8 8s8-3.6 8-8V256zm484.8-75c-1.3-4.2-5.8-6.6-10-5.3s-6.6 5.8-5.3 10c6.8 22.2 10.5 45.9 10.5 70.4v56c0 4.4 3.6 8 8 8s8-3.6 8-8V256c0-26.1-3.9-51.3-11.2-75zM256 80c-26.5 0-51.6 5.8-74.1 16.3c-4.7 2.2-5.8 8.2-2.4 12.1c2.4 2.8 6.5 3.6 9.9 2.1C209.6 101.2 232.2 96 256 96c88.4 0 160 71.6 160 160v24.9c0 31.5-2.2 62.8-6.6 93.8c-.7 4.9 3.1 9.2 8 9.2c3.9 0 7.3-2.9 7.9-6.8c4.5-31.8 6.8-64 6.8-96.3V256c0-97.2-78.8-176-176-176zM139.5 135.6c-3-3.5-8.3-3.8-11.5-.4c-29.8 31.5-48 74-48 120.8v24.9c0 31.4-4.4 62.6-13 92.6c-1.5 5.2 2.3 10.4 7.7 10.4c3.5 0 6.6-2.3 7.5-5.6C91.4 346.7 96 313.9 96 280.9V256c0-42.3 16.4-80.7 43.1-109.3c2.9-3.1 3.1-7.9 .4-11.1zM256 160c-53 0-96 43-96 96v24.9c0 42.3-6.4 84.3-19.1 124.5c-1.6 5.2 2.2 10.6 7.7 10.6c3.4 0 6.5-2.2 7.5-5.5c13.2-41.9 19.9-85.6 19.9-129.6V256c0-44.2 35.8-80 80-80s80 35.8 80 80v24.9c0 42.2-4.5 84.2-13.4 125.3c-1.1 5 2.7 9.8 7.8 9.8c3.7 0 7-2.6 7.7-6.2c9.2-42.2 13.8-85.4 13.8-128.9V256c0-53-43-96-96-96zm8 96c0-4.4-3.6-8-8-8s-8 3.6-8 8v24.9c0 61.9-11.4 123.2-33.6 180.9l-5.9 15.3c-1.6 4.1 .5 8.8 4.6 10.3s8.8-.5 10.3-4.6l5.9-15.3C252.3 408 264 344.8 264 280.9V256z'
      
    ]
  };

  

  
  

  var faPumpMedical = {
    prefix: 'fat',
    iconName: 'pump-medical',
    icon: [
      448,
      512,
      [],
      'e06a',
      
      'M168 0h48c22.1 0 40 17.9 40 40V56h60.1c14.9 0 29.1 5.9 39.6 16.4l41.9 41.9c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L344.4 83.7C336.9 76.2 326.7 72 316.1 72H256v56H240V40c0-13.3-10.7-24-24-24H168c-13.3 0-24 10.7-24 24v88H128V40c0-22.1 17.9-40 40-40zM69.6 220L50.9 444c-2.3 28 19.8 52 47.8 52H285.2c28.1 0 50.2-24 47.8-52L314.4 220c-2.1-24.9-22.9-44-47.8-44H117.4c-25 0-45.8 19.1-47.8 44zm-15.9-1.3c2.8-33.2 30.5-58.7 63.8-58.7H266.6c33.3 0 61 25.5 63.8 58.7l18.7 224c3.1 37.3-26.3 69.3-63.8 69.3H98.8c-37.4 0-66.9-32-63.8-69.3l18.7-224zM168 256h48c4.4 0 8 3.6 8 8v40h40c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H224v40c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8V368H120c-4.4 0-8-3.6-8-8V312c0-4.4 3.6-8 8-8h40V264c0-4.4 3.6-8 8-8zm8 56v8h-8H128v32h40 8v8 40h32V360v-8h8 40V320H216h-8v-8V272H176v40z'
      
    ]
  };

  

  
  

  var faLocationMinus = {
    prefix: 'fat',
    iconName: 'location-minus',
    icon: [
      384,
      512,
      ["map-marker-minus"],
      'f609',
      
      'M368 192c0-97.2-78.8-176-176-176S16 94.8 16 192c0 18.7 6.4 42.5 17.8 69.6c11.3 26.9 27.1 55.8 44.7 84.3c35.2 57 76.8 111.4 102.3 143.2c5.9 7.3 16.6 7.3 22.4 0c25.5-31.8 67.1-86.2 102.3-143.2c17.6-28.5 33.4-57.4 44.7-84.3C361.6 234.5 368 210.7 368 192zm16 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM96 184H288c4.4 0 8 3.6 8 8s-3.6 8-8 8H96c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  
    var faMapMarkerMinus = faLocationMinus;
  

  
  

  var faSlidersUp = {
    prefix: 'fat',
    iconName: 'sliders-up',
    icon: [
      512,
      512,
      ["sliders-v"],
      'f3f1',
      
      'M96 0c4.4 0 8 3.6 8 8V96.5c31.6 3.9 56 30.9 56 63.5s-24.4 59.6-56 63.5V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V223.5c-31.6-3.9-56-30.9-56-63.5s24.4-59.6 56-63.5V8c0-4.4 3.6-8 8-8zm0 208a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM256 400a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm64-48c0 32.6-24.4 59.6-56 63.5V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V415.5c-31.6-3.9-56-30.9-56-63.5s24.4-59.6 56-63.5V8c0-4.4 3.6-8 8-8s8 3.6 8 8V288.5c31.6 3.9 56 30.9 56 63.5zM464 192a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-40 63.5V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V255.5c-31.6-3.9-56-30.9-56-63.5s24.4-59.6 56-63.5V8c0-4.4 3.6-8 8-8s8 3.6 8 8V128.5c31.6 3.9 56 30.9 56 63.5s-24.4 59.6-56 63.5z'
      
    ]
  };

  
    var faSlidersV = faSlidersUp;
  

  
  

  var faBridgeCircleCheck = {
    prefix: 'fat',
    iconName: 'bridge-circle-check',
    icon: [
      640,
      512,
      [],
      'e4c9',
      
      'M40 32c-4.4 0-8 3.6-8 8s3.6 8 8 8h80v96H40c-4.4 0-8 3.6-8 8s3.6 8 8 8H600c4.4 0 8-3.6 8-8s-3.6-8-8-8H520V48h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H40zM504 48v96H392V48H504zM376 48v96H264V48H376zM248 48v96H136V48H248zM40 256c-4.4 0-8 3.6-8 8s3.6 8 8 8H64c39.8 0 72 32.2 72 72v96c0 22.1 17.9 40 40 40h32c22.1 0 40-17.9 40-40V344c0-39.8 32.2-72 72-72c9 0 17.6 1.6 25.5 4.7c2.8-4.7 5.9-9.2 9.1-13.6C344 258.5 332.3 256 320 256c-48.6 0-88 39.4-88 88v96c0 13.3-10.7 24-24 24H176c-13.3 0-24-10.7-24-24V344c0-48.6-39.4-88-88-88H40zm456-16a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm69.7-189.7c-3.1-3.1-8.2-3.1-11.3 0L480 396.7l-42.3-42.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l48 48c3.1 3.1 8.2 3.1 11.3 0l80-80c3.1-3.1 3.1-8.2 0-11.3z'
      
    ]
  };

  

  
  

  var faCalculatorSimple = {
    prefix: 'fat',
    iconName: 'calculator-simple',
    icon: [
      512,
      512,
      ["calculator-alt"],
      'f64c',
      
      'M256 0c4.4 0 8 3.6 8 8V248H504c4.4 0 8 3.6 8 8s-3.6 8-8 8H264V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V264H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H248V8c0-4.4 3.6-8 8-8zm88 104h48V56 40c0-4.4 3.6-8 8-8s8 3.6 8 8V56v48h48 16c4.4 0 8 3.6 8 8s-3.6 8-8 8H456 408v48 16c0 4.4-3.6 8-8 8s-8-3.6-8-8V168 120H344 328c-4.4 0-8-3.6-8-8s3.6-8 8-8h16zM50.7 338.7c3.1-3.1 8.2-3.1 11.3 0L112 388.7l49.9-49.9c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L123.3 400l49.9 49.9c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L112 411.3 62.1 461.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L100.7 400 50.7 350.1c-3.1-3.1-3.1-8.2 0-11.3zM40 104H184c4.4 0 8 3.6 8 8s-3.6 8-8 8H40c-4.4 0-8-3.6-8-8s3.6-8 8-8zM328 360H472c4.4 0 8 3.6 8 8s-3.6 8-8 8H328c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 64H472c4.4 0 8 3.6 8 8s-3.6 8-8 8H328c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  
    var faCalculatorAlt = faCalculatorSimple;
  

  
  

  var faClosedCaptioningSlash = {
    prefix: 'fat',
    iconName: 'closed-captioning-slash',
    icon: [
      640,
      512,
      [],
      'e135',
      
      'M13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7zM608 391.6V96c0-35.3-28.7-64-64-64H152.5l20.3 16H544c26.5 0 48 21.5 48 48V379l16 12.6zM370.9 204.4C385.5 187 407.5 176 432 176c24.8 0 47 11.3 61.6 29c2.8 3.4 7.9 3.9 11.3 1.1s3.9-7.9 1.1-11.3c-17.6-21.2-44.2-34.8-74-34.8c-29.6 0-56.1 13.4-73.7 34.5l12.6 9.9zM48 133L32 120.4V416c0 35.3 28.7 64 64 64H487.5l-20.3-16H96c-26.5 0-48-21.5-48-48V133zM278.3 314.8C264 328 244.9 336 224 336c-44.2 0-80-35.8-80-80c0-14.2 3.7-27.6 10.2-39.1l-12.7-10C132.9 221.2 128 238 128 256c0 53 43 96 96 96c26 0 49.7-10.4 67-27.2l-12.7-10z'
      
    ]
  };

  

  
  

  var faMicrophoneLinesSlash = {
    prefix: 'fat',
    iconName: 'microphone-lines-slash',
    icon: [
      640,
      512,
      ["microphone-alt-slash"],
      'f539',
      
      'M387.6 401.1l-14.3-11.3C356.8 396.4 338.8 400 320 400c-79.5 0-144-64.5-144-144V234l-16-12.6V256c0 85.7 67.4 155.6 152 159.8V496H232c-4.4 0-8 3.6-8 8s3.6 8 8 8h88 88c4.4 0 8-3.6 8-8s-3.6-8-8-8H328V415.8c21.2-1 41.3-6.2 59.6-14.7zM240 101.1V96c0-44.2 35.8-80 80-80s80 35.8 80 80v16H328c-4.4 0-8 3.6-8 8s3.6 8 8 8h72v48H334.9l20.3 16H400v35.4l16 12.6V184 120 96c0-53-43-96-96-96c-50.6 0-92 39.1-95.7 88.7L240 101.1zM476.8 288c2.1-10.4 3.2-21.1 3.2-32V200c0-4.4-3.6-8-8-8s-8 3.6-8 8v56c0 7.1-.5 14-1.5 20.8L476.8 288zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  
    var faMicrophoneAltSlash = faMicrophoneLinesSlash;
  

  
  

  var faIcons = {
    prefix: 'fat',
    iconName: 'icons',
    icon: [
      512,
      512,
      ["heart-music-camera-bolt"],
      'f86d',
      
      'M496 27.5c0-5-4.6-8.8-9.6-7.8l-128 25.6c-3.7 .7-6.4 4-6.4 7.8V208v0c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c19.1 0 36.3 6.3 48 16.3V53.1c0-11.4 8.1-21.3 19.3-23.5L483.3 4C498.1 1 512 12.4 512 27.5V176v0c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c19.1 0 36.3 6.3 48 16.3V27.5zM323.7 186.9c-8.6-6.4-21.1-10.9-35.7-10.9s-27.1 4.4-35.7 10.9s-12.3 14.1-12.3 21.1s3.8 14.7 12.3 21.1s21.1 10.9 35.7 10.9s27.1-4.4 35.7-10.9s12.3-14.1 12.3-21.1v0c0-7.1-3.8-14.7-12.3-21.1zm160-32c-8.6-6.4-21.1-10.9-35.7-10.9s-27.1 4.4-35.7 10.9s-12.3 14.1-12.3 21.1s3.8 14.7 12.3 21.1s21.1 10.9 35.7 10.9s27.1-4.4 35.7-10.9s12.3-14.1 12.3-21.1v0c0-7.1-3.8-14.7-12.3-21.1zM473.6 256c8.7 0 14.7 8.6 11.8 16.8l-34 95.2h41.9c10.4 0 18.7 8.4 18.7 18.7c0 5.8-2.7 11.2-7.2 14.8L366.1 509.4c-2.2 1.7-4.9 2.6-7.7 2.6c-8.7 0-14.7-8.6-11.8-16.8l34-95.2H338.2c-10 0-18.2-8.1-18.2-18.2c0-5.6 2.6-10.9 7-14.3L465.8 258.7c2.2-1.7 4.9-2.7 7.7-2.7zM336.8 380.1c-.5 .4-.8 1-.8 1.7c0 1.2 1 2.2 2.2 2.2H392c2.6 0 5 1.3 6.5 3.4s1.9 4.8 1 7.3l-33.8 94.7L494.9 388.9c.7-.5 1.1-1.3 1.1-2.2c0-1.5-1.2-2.7-2.7-2.7H440c-2.6 0-5-1.3-6.5-3.4s-1.9-4.8-1-7.3l33.8-94.7L336.8 380.1zM72 320H48c-17.7 0-32 14.3-32 32V464c0 17.7 14.3 32 32 32H240c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H216c-6.1 0-11.6-3.4-14.3-8.8l-7.2-14.3c-2.7-5.4-8.3-8.8-14.3-8.8H107.8c-6.1 0-11.6 3.4-14.3 8.8l-7.2 14.3c-2.7 5.4-8.3 8.8-14.3 8.8zm136.8-30.3L216 304h24c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V352c0-26.5 21.5-48 48-48H72l7.2-14.3c5.4-10.8 16.5-17.7 28.6-17.7h72.4c12.1 0 23.2 6.8 28.6 17.7zM104 408a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm40 56a56 56 0 1 1 0-112 56 56 0 1 1 0 112zM116.7 43.3l-6-6C98 24.7 80 18.9 62.4 21.8C35.6 26.3 16 49.4 16 76.5v2.9c0 16.3 6.8 31.9 18.7 43.1l90.4 84.3c.8 .7 1.8 1.2 2.9 1.2s2.1-.4 2.9-1.2l90.4-84.3C233.2 111.4 240 95.8 240 79.5V76.5c0-27.1-19.6-50.3-46.4-54.7C176 18.9 158 24.7 145.3 37.3l-6 6L128 54.6 116.7 43.3zM59.7 6c22.8-3.8 46 3.6 62.3 20l6 6 6-6C150.3 9.7 173.5 2.3 196.3 6C230.7 11.8 256 41.6 256 76.5v2.9c0 20.8-8.6 40.6-23.8 54.8l-90.4 84.3c-3.8 3.5-8.7 5.5-13.8 5.5s-10.1-2-13.8-5.5L23.8 134.2C8.6 120 0 100.2 0 79.5V76.5C0 41.6 25.3 11.8 59.7 6z'
      
    ]
  };

  
    var faHeartMusicCameraBolt = faIcons;
  

  
  

  var faSoap = {
    prefix: 'fat',
    iconName: 'soap',
    icon: [
      512,
      512,
      [129532],
      'e06e',
      
      'M240 48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM96 192H225.3c.9 5.5 2.3 10.9 4.1 16H96c-44.2 0-80 35.8-80 80V416c0 44.2 35.8 80 80 80H416c44.2 0 80-35.8 80-80V288c0-44.2-35.8-80-80-80h-5.5c1.8-5.1 3.2-10.5 4.1-16H416c53 0 96 43 96 96V416c0 53-43 96-96 96H96c-53 0-96-43-96-96V288c0-53 43-96 96-96zM80 352c0-44.2 35.8-80 80-80H320h32c44.2 0 80 35.8 80 80s-35.8 80-80 80H160c-44.2 0-80-35.8-80-80zm16 0c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64s-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zM384 48a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM368 176a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-112 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  

  
  

  var faAtom = {
    prefix: 'fat',
    iconName: 'atom',
    icon: [
      512,
      512,
      [9883],
      'f5d2',
      
      'M338 424.7c-25.7-4.7-53.5-13.5-82-25.9c-28.6 12.5-56.3 21.3-82 25.9c.8 1.8 1.6 3.6 2.5 5.4C197.3 474 225 496 256 496s58.7-22 79.5-65.8c.8-1.8 1.7-3.6 2.5-5.4zM256 512c-42.8 0-76.4-32.7-98.4-84.8c-52.7 6.1-95-6.8-115.2-43.2C21.7 346.9 33 301.2 66 256c-33-45.2-44.3-90.9-23.6-128c20.2-36.3 62.5-49.3 115.2-43.2C179.6 32.7 213.2 0 256 0s76.4 32.7 98.4 84.8c52.7-6.1 95 6.8 115.2 43.2c20.7 37.1 9.4 82.8-23.6 128c33 45.2 44.3 90.9 23.6 128c-20.2 36.3-62.5 49.3-115.2 43.2c-22 52.1-55.6 84.8-98.4 84.8zM236.3 389.7c-13.9-6.8-27.9-14.4-42-22.8c-15.7-9.4-30.6-19.3-44.5-29.5c4 26.6 10.1 51 18 72.3c21.3-3.6 44.4-10.3 68.5-19.9zm107.9 19.9c7.8-21.2 13.9-45.6 18-72.3c-13.9 10.3-28.8 20.2-44.5 29.5c-14 8.4-28.1 16-42 22.8c24.1 9.6 47.2 16.3 68.5 19.9zm-34.7-56.4c20.1-12 38.7-24.8 55.6-38.1c2-18.8 3-38.6 3-59s-1-40.2-3-59c-16.9-13.3-35.5-26.1-55.6-38.1c-18-10.8-35.9-20.2-53.4-28.2c-17.5 8-35.4 17.4-53.4 28.2c-20.1 12-38.7 24.8-55.6 38.1c-2 18.8-3 38.6-3 59s1 40.2 3 59c16.9 13.3 35.5 26.1 55.6 38.1c18 10.8 35.9 20.2 53.4 28.2c17.5-8 35.4-17.4 53.4-28.2zm51 58.6c.9 .1 1.8 .2 2.7 .2c46.3 3.9 77.6-9 92.5-35.8c15.1-27.1 9.9-62.3-16.6-102.3c-1.1-1.6-2.1-3.2-3.3-4.8c-15.3 18.5-34 36.8-55.6 54.2c-3.8 32.5-10.5 62.4-19.7 88.3zm21.9-111.1C399.2 286 413.8 271 425.8 256c-12-15-26.7-30-43.5-44.7c1.1 14.5 1.7 29.4 1.7 44.7s-.6 30.2-1.7 44.7zM439 238c26.6-40 31.7-75.2 16.6-102.3C440.7 109 409.3 96.2 363.1 100c-.9 .1-1.8 .2-2.7 .2c9.2 26 15.9 55.9 19.7 88.3c21.6 17.5 40.3 35.7 55.6 54.2c1.1-1.6 2.2-3.2 3.3-4.8zM335.5 81.8C314.7 38 287 16 256 16s-58.7 22-79.5 65.8c-.8 1.8-1.7 3.6-2.5 5.4c25.7 4.7 53.5 13.5 82 25.9c28.6-12.5 56.3-21.3 82-25.9c-.8-1.8-1.6-3.6-2.5-5.4zm8.6 20.6c-21.3 3.6-44.4 10.3-68.5 19.9c13.9 6.8 27.9 14.4 42 22.8c15.7 9.4 30.6 19.3 44.5 29.5c-4-26.6-10.1-51-18-72.3zm-176.4 0c-7.8 21.2-13.9 45.6-18 72.3c13.9-10.3 28.8-20.1 44.5-29.5c14-8.4 28.1-16 42-22.8c-24.1-9.6-47.2-16.3-68.5-19.9zm-16.2-2.2c-.9-.1-1.8-.2-2.7-.2c-46.3-3.9-77.6 9-92.5 35.7C41.3 162.8 46.5 198.1 73 238c1.1 1.6 2.1 3.2 3.3 4.8c15.3-18.5 34-36.8 55.6-54.2c3.8-32.5 10.5-62.4 19.7-88.3zM131.8 323.4c-21.6-17.5-40.3-35.7-55.6-54.2c-1.1 1.6-2.2 3.2-3.3 4.8c-26.6 40-31.7 75.2-16.6 102.3c14.9 26.8 46.3 39.6 92.5 35.8c.9-.1 1.8-.2 2.7-.2c-9.2-26-15.9-55.9-19.7-88.3zm-2.2-112.1C112.8 226 98.2 241 86.2 256c12 15 26.7 30 43.5 44.7c-1.1-14.5-1.7-29.4-1.7-44.7s.6-30.2 1.7-44.7zM256 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm32 48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faNfc = {
    prefix: 'fat',
    iconName: 'nfc',
    icon: [
      448,
      512,
      [],
      'e1f7',
      
      'M384 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm40 96h48c4.4 0 8-3.6 8-8s-3.6-8-8-8H104c-13.3 0-24 10.7-24 24V376c0 13.3 10.7 24 24 24H344c13.3 0 24-10.7 24-24V136c0-13.3-10.7-24-24-24H240c-13.3 0-24 10.7-24 24v80.8c-18.3 3.7-32 19.8-32 39.2c0 22.1 17.9 40 40 40s40-17.9 40-40c0-19.4-13.7-35.5-32-39.2V136c0-4.4 3.6-8 8-8H344c4.4 0 8 3.6 8 8V376c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8V136c0-4.4 3.6-8 8-8zM224 280a24 24 0 1 1 0-48 24 24 0 1 1 0 48z'
      
    ]
  };

  

  
  

  var faFaceGlasses = {
    prefix: 'fat',
    iconName: 'face-glasses',
    icon: [
      512,
      512,
      [],
      'e377',
      
      'M256 496C123.5 496 16 388.5 16 256c0-28.1 4.8-55 13.7-80H50.7C49 181 48 186.4 48 192v64c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V192c0-5.6-1-11-2.7-16h37.5c-1.8 5-2.7 10.4-2.7 16v64c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V192c0-5.6-1-11-2.7-16h21.1c8.8 25 13.7 51.9 13.7 80c0 132.5-107.5 240-240 240zM227.8 160c-8.8-9.8-21.6-16-35.8-16H96c-14.2 0-27 6.2-35.8 16H36C73 75.2 157.6 16 256 16s183 59.2 220 144H451.8c-8.8-9.8-21.6-16-35.8-16H320c-14.2 0-27 6.2-35.8 16H227.8zM256 0C148.6 0 56.6 66.2 18.6 160H8c-4.4 0-8 3.6-8 8s3.6 8 8 8h4.7C4.5 201.2 0 228.1 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256c0-27.9-4.5-54.8-12.7-80H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H493.4C455.4 66.2 363.4 0 256 0zM139.4 337.4c-3.6 2.5-4.5 7.5-2 11.1c22.4 32 61.9 67.4 118.6 67.4s96.1-35.4 118.6-67.4c2.5-3.6 1.7-8.6-2-11.1s-8.6-1.7-11.1 2C340.6 369.2 305.4 400 256 400s-84.6-30.8-105.4-60.6c-2.5-3.6-7.5-4.5-11.1-2zM64 192c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V192zm256-32h96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32zM192.4 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm144 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faRightFromBracket = {
    prefix: 'fat',
    iconName: 'right-from-bracket',
    icon: [
      512,
      512,
      ["sign-out-alt"],
      'f2f5',
      
      'M492.7 248c2.1 2.1 3.3 5 3.3 8s-1.2 5.9-3.3 8L360.6 395.8c-2.7 2.7-6.4 4.2-10.2 4.2c-8 0-14.4-6.5-14.4-14.4l0-73.6c0-4.4-3.6-8-8-8l-136 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16l136 0c4.4 0 8-3.6 8-8l0-73.6c0-8 6.5-14.4 14.4-14.4c3.8 0 7.5 1.5 10.2 4.2L492.7 248zm19.3 8c0-7.2-2.9-14.2-8-19.3L371.9 104.9c-5.7-5.7-13.4-8.9-21.5-8.9c-16.8 0-30.4 13.6-30.4 30.4l0 65.6-128 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l128 0 0 65.6c0 16.8 13.6 30.4 30.4 30.4c8.1 0 15.8-3.2 21.5-8.9L504 275.3c5.1-5.1 8-12.1 8-19.3zM184 48c4.4 0 8-3.6 8-8s-3.6-8-8-8L88 32C39.4 32 0 71.4 0 120L0 392c0 48.6 39.4 88 88 88l96 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-96 0c-39.8 0-72-32.2-72-72l0-272c0-39.8 32.2-72 72-72l96 0z'
      
    ]
  };

  
    var faSignOutAlt = faRightFromBracket;
  

  
  

  var faFilms = {
    prefix: 'fat',
    iconName: 'films',
    icon: [
      576,
      512,
      [],
      'e17a',
      
      'M224 288V216H448v72 80H224V288zm0-88V128 48H448v80 72H224zm240 80V216h96v64H464zm0-144h96v64H464V136zm112 72v-8V136v-8-8V96c0-35.3-28.7-64-64-64H464h-8-8H224h-8-8H160c-35.3 0-64 28.7-64 64v24 8 8 64 8 8 64 8 8 24c0 35.3 28.7 64 64 64h48 8 8H448h8 8 48c35.3 0 64-28.7 64-64V296v-8-8V216v-8zM560 96v24H464V48h48c26.5 0 48 21.5 48 48zM160 48h48v72H112V96c0-26.5 21.5-48 48-48zm-48 88h96v64H112V136zm96 80v64H112V216h96zM112 320V296h96v72H160c-26.5 0-48-21.5-48-48zm400 48H464V296h96v24c0 26.5-21.5 48-48 48zM0 192V416c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64H464c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V192c0-26.5 21.5-48 48-48V128c-35.3 0-64 28.7-64 64z'
      
    ]
  };

  

  
  

  var faDoorOpen = {
    prefix: 'fat',
    iconName: 'door-open',
    icon: [
      576,
      512,
      [],
      'f52b',
      
      'M304 496H96 80V86.2C80 71.3 90.3 58.4 104.8 55l166-38.3c2-.5 4-.7 6.1-.7c15 0 27.1 12.1 27.1 27.1V496zM64 86.2V496H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H64 80 96 304h16V496 43.1C320 19.3 300.7 0 276.9 0c-3.3 0-6.5 .4-9.7 1.1l-166 38.3C79.4 44.4 64 63.8 64 86.2zM472 80c13.3 0 24 10.7 24 24V504c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8s-3.6-8-8-8H512V104c0-22.1-17.9-40-40-40H352V80H472zM232 216c-9.7 0-17.9 5.3-23.4 12.6s-8.6 17-8.6 27.4s3.2 20.1 8.6 27.4s13.7 12.6 23.4 12.6s17.9-5.3 23.4-12.6s8.6-17 8.6-27.4s-3.2-20.1-8.6-27.4s-13.7-12.6-23.4-12.6zm-16 40c0-7.2 2.2-13.5 5.4-17.8s7-6.2 10.6-6.2s7.4 1.9 10.6 6.2s5.4 10.6 5.4 17.8s-2.2 13.5-5.4 17.8s-7 6.2-10.6 6.2s-7.4-1.9-10.6-6.2s-5.4-10.6-5.4-17.8z'
      
    ]
  };

  

  
  

  var faShovel = {
    prefix: 'fat',
    iconName: 'shovel',
    icon: [
      512,
      512,
      [],
      'f713',
      
      'M410.3 2.3c3.1-3.1 8.2-3.1 11.3 0l88 88c3.1 3.1 3.1 8.2 0 11.3l-37.8 37.8c-13.2 13.2-31 20.6-49.7 20.6c-16.5 0-31.7-5.7-43.7-15.2L229.7 293.7l67.7 67.7c12.5 12.5 12.5 32.8 0 45.3l-58.5 58.5c-30 30-70.7 46.9-113.1 46.9H32c-17.7 0-32-14.3-32-32V386.3c0-42.4 16.9-83.1 46.9-113.1l58.5-58.5c12.5-12.5 32.8-12.5 45.3 0l67.7 67.7L367.2 133.5c-9.5-12-15.2-27.2-15.2-43.7c0-18.6 7.4-36.5 20.6-49.7L410.3 2.3zm5.7 17L383.9 51.4C373.7 61.6 368 75.4 368 89.8c0 29.9 24.3 54.2 54.2 54.2c14.4 0 28.2-5.7 38.3-15.9L492.7 96 416 19.3zM16 480c0 8.8 7.2 16 16 16h93.7c38.2 0 74.8-15.2 101.8-42.2l58.5-58.5c6.2-6.2 6.2-16.4 0-22.6L139.3 225.9c-6.2-6.2-16.4-6.2-22.6 0L58.2 284.5c-27 27-42.2 63.6-42.2 101.8V480z'
      
    ]
  };

  

  
  

  var faFaceIcicles = {
    prefix: 'fat',
    iconName: 'face-icicles',
    icon: [
      512,
      512,
      [],
      'e37c',
      
      'M256 16C123.5 16 16 123.5 16 256V401l8.6-20.2c1.7-4.1 6.4-5.9 10.5-4.2s5.9 6.4 4.2 10.5l-24 56c-1.5 3.5-5.2 5.4-9 4.7s-6.4-4-6.4-7.8V256C0 114.6 114.6 0 256 0S512 114.6 512 256V504c0 3.8-2.7 7.1-6.4 7.8s-7.5-1.2-9-4.7l-24-56c-1.7-4.1 .1-8.8 4.2-10.5s8.8 .1 10.5 4.2L496 465V256C496 123.5 388.5 16 256 16zM168 304c-22.1 0-40 17.9-40 40s17.9 40 40 40h8V304h-8zm24 80h56V304H192v80zm96 0h16 16V304H264v80h24zm0 16H168c-30.9 0-56-25.1-56-56s25.1-56 56-56H344c30.9 0 56 25.1 56 56c0 15.3-6.1 29.1-16 39.2V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V394.6c-7.3 3.5-15.4 5.4-24 5.4H304v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V400zm96-56c0-22.1-17.9-40-40-40h-8v80h8c9 0 17.3-3 24-8v0h0c9.7-7.3 16-18.9 16-32zM160.4 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-3 291.2c4.2-1.4 8.7 .8 10.2 5s-.8 8.7-5 10.2C312.7 507.2 284.9 512 256 512c-78.4 0-148.7-35.3-195.6-90.8c-2.9-3.4-2.4-8.4 .9-11.3s8.4-2.4 11.3 .9C116.7 462.9 182.5 496 256 496c27.1 0 53.1-4.5 77.4-12.8zm74.5-41.4c21.2-17.4 39.4-38.3 53.7-61.9c2.3-3.8 7.2-5 11-2.7s5 7.2 2.7 11c-15.2 25.2-34.6 47.5-57.3 66.1c-3.4 2.8-8.5 2.3-11.3-1.1s-2.3-8.5 1.1-11.3zM106.1 192.3c4.3 1.2 6.8 5.6 5.6 9.8l-24 88c-.9 3.3-3.8 5.6-7.2 5.9s-6.6-1.7-7.9-4.8l-24-56c-1.7-4.1 .1-8.8 4.2-10.5s8.8 .1 10.5 4.2l15 34.9 18-65.9c1.2-4.3 5.6-6.8 9.8-5.6zM352.3 74.1c-1.2-4.3 1.4-8.7 5.6-9.8s8.7 1.4 9.8 5.6l18 65.9 15-34.9c1.7-4.1 6.4-5.9 10.5-4.2s5.9 6.4 4.2 10.5l-24 56c-1.3 3.1-4.5 5.1-7.9 4.8s-6.3-2.6-7.2-5.9l-24-88z'
      
    ]
  };

  

  
  

  var faCircleMinus = {
    prefix: 'fat',
    iconName: 'circle-minus',
    icon: [
      512,
      512,
      ["minus-circle"],
      'f056',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 248c-4.4 0-8 3.6-8 8s3.6 8 8 8H352c4.4 0 8-3.6 8-8s-3.6-8-8-8H160z'
      
    ]
  };

  
    var faMinusCircle = faCircleMinus;
  

  
  

  var faFolderArrowDown = {
    prefix: 'fat',
    iconName: 'folder-arrow-down',
    icon: [
      512,
      512,
      ["folder-download"],
      'e053',
      
      'M496 416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H197.5c12.7 0 24.9 5.1 33.9 14.1l35.9 35.9c9 9 21.2 14.1 33.9 14.1H448c26.5 0 48 21.5 48 48V416zM64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H301.3c-8.5 0-16.6-3.4-22.6-9.4L242.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64zM264 184c0-4.4-3.6-8-8-8s-8 3.6-8 8V372.7l-74.3-74.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l88 88c3.1 3.1 8.2 3.1 11.3 0l88-88c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L264 372.7V184z'
      
    ]
  };

  
    var faFolderDownload = faFolderArrowDown;
  

  
  

  var faSortDown = {
    prefix: 'fat',
    iconName: 'sort-down',
    icon: [
      320,
      512,
      ["sort-desc"],
      'f0dd',
      
      'M144.6 457.4c4 4.2 9.6 6.6 15.4 6.6s11.4-2.4 15.4-6.6L300.6 325.3c2.2-2.3 3.5-5.4 3.5-8.7c0-7-5.6-12.6-12.6-12.6H28.6c-7 0-12.6 5.6-12.6 12.6c0 3.2 1.2 6.3 3.5 8.7L144.6 457.4zm-11.6 11L7.8 336.3C2.8 331 0 323.9 0 316.6C0 300.8 12.8 288 28.6 288H291.4c15.8 0 28.6 12.8 28.6 28.6c0 7.3-2.8 14.4-7.8 19.7L187 468.4c-7 7.4-16.8 11.6-27 11.6s-20-4.2-27-11.6z'
      
    ]
  };

  
    var faSortDesc = faSortDown;
  

  
  

  var faBarcodeScan = {
    prefix: 'fat',
    iconName: 'barcode-scan',
    icon: [
      640,
      512,
      [],
      'f465',
      
      'M64 40V192H80V40c0-4.4-3.6-8-8-8s-8 3.6-8 8zm0 432c0 4.4 3.6 8 8 8s8-3.6 8-8V320H64V472zm64 0V320H112V472c0 4.4 3.6 8 8 8s8-3.6 8-8zM112 40V192h16V40c0-4.4-3.6-8-8-8s-8 3.6-8 8zm64 432c0 4.4 3.6 8 8 8s8-3.6 8-8V320H176V472zm0-432V192h16V40c0-4.4-3.6-8-8-8s-8 3.6-8 8zm72 432c0 4.4 3.6 8 8 8s8-3.6 8-8V320H248V472zm0-432V192h16V40c0-4.4-3.6-8-8-8s-8 3.6-8 8zm72 432c0 4.4 3.6 8 8 8s8-3.6 8-8V320H320V472zm0-432V192h16V40c0-4.4-3.6-8-8-8s-8 3.6-8 8zm48 432c0 4.4 3.6 8 8 8s8-3.6 8-8V320H368V472zm0-432V192h16V40c0-4.4-3.6-8-8-8s-8 3.6-8 8zm80 432c0 4.4 3.6 8 8 8s8-3.6 8-8V320H448V472zm0-432V192h16V40c0-4.4-3.6-8-8-8s-8 3.6-8 8zm64 432c0 4.4 3.6 8 8 8s8-3.6 8-8V320H512V472zm0-432V192h16V40c0-4.4-3.6-8-8-8s-8 3.6-8 8zm48 432c0 4.4 3.6 8 8 8s8-3.6 8-8V320H560V472zm0-432V192h16V40c0-4.4-3.6-8-8-8s-8 3.6-8 8zM0 256c0 4.4 3.6 8 8 8l624 0c4.4 0 8-3.6 8-8s-3.6-8-8-8L8 248c-4.4 0-8 3.6-8 8z'
      
    ]
  };

  

  
  

  var faMobileSignal = {
    prefix: 'fat',
    iconName: 'mobile-signal',
    icon: [
      512,
      512,
      [],
      'e1ef',
      
      'M96 16H288c26.5 0 48 21.5 48 48V272.1c5.2-3.7 10.5-7.2 16-10.4V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64V448c0 35.3 28.7 64 64 64H224V496H96c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48zm48 416c-4.4 0-8 3.6-8 8s3.6 8 8 8h83c.8-5.4 1.8-10.7 2.9-16H144zM504 256c-137 0-248 111-248 248c0 4.4 3.6 8 8 8s8-3.6 8-8c0-128.1 103.9-232 232-232c4.4 0 8-3.6 8-8s-3.6-8-8-8zm-8 224a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-48 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm64-120c0-4.4-3.6-8-8-8c-83.9 0-152 68.1-152 152c0 4.4 3.6 8 8 8s8-3.6 8-8c0-75.1 60.9-136 136-136c4.4 0 8-3.6 8-8z'
      
    ]
  };

  

  
  

  var faArrowsUpToLine = {
    prefix: 'fat',
    iconName: 'arrows-up-to-line',
    icon: [
      576,
      512,
      [],
      'e4c2',
      
      'M8 48l560 0c4.4 0 8-3.6 8-8s-3.6-8-8-8L8 32c-4.4 0-8 3.6-8 8s3.6 8 8 8zM2.3 242.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L120 147.3 120 472c0 4.4 3.6 8 8 8s8-3.6 8-8l0-324.7L242.3 253.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-120-120c-3.1-3.1-8.2-3.1-11.3 0l-120 120zm320 11.3c3.1 3.1 8.2 3.1 11.3 0L440 147.3 440 472c0 4.4 3.6 8 8 8s8-3.6 8-8l0-324.7L562.3 253.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-120-120c-3.1-3.1-8.2-3.1-11.3 0l-120 120c-3.1 3.1-3.1 8.2 0 11.3z'
      
    ]
  };

  

  
  

  var faFork = {
    prefix: 'fat',
    iconName: 'fork',
    icon: [
      512,
      512,
      ["utensil-fork"],
      'f2e3',
      
      'M401.1 20.2c3.6-2.6 4.4-7.6 1.9-11.2s-7.6-4.4-11.2-1.9L277.3 89c-3.2 2.3-6.3 4.9-9.1 7.7l-7.6 7.6c-28.1 28.1-28.1 73.7 0 101.8l17 17L3 497.7c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L289 234.3l17 17c28.1 28.1 73.7 28.1 101.8 0l7.6-7.6c2.8-2.8 5.4-5.8 7.7-9.1l81.8-114.5c2.6-3.6 1.7-8.6-1.9-11.2s-8.6-1.7-11.2 1.9L410 225.4c-1.8 2.5-3.8 4.9-6 7l-7.6 7.6c-21.9 21.9-57.3 21.9-79.2 0L272 194.7c-21.9-21.9-21.9-57.3 0-79.2l7.6-7.6c2.2-2.2 4.5-4.2 7-6L401.1 20.2zm34.7 33.4c3.3-3 3.5-8 .6-11.3s-8-3.5-11.3-.6L306.2 149.2c-3.3 3-3.5 8-.6 11.3s8 3.5 11.3 .6L435.8 53.6zM470.3 87c3-3.3 2.7-8.3-.6-11.3s-8.3-2.7-11.3 .6L350.9 195c-3 3.3-2.7 8.3 .6 11.3s8.3 2.7 11.3-.6L470.3 87z'
      
    ]
  };

  
    var faUtensilFork = faFork;
  

  
  

  var faUfo = {
    prefix: 'fat',
    iconName: 'ufo',
    icon: [
      640,
      512,
      [128760],
      'e047',
      
      'M168 236.7c-5.8 5.5-5.8 5.5-5.8 5.5l0 0 0 0 .1 .1 .2 .2 .5 .5c.4 .4 1 .9 1.8 1.6c1.5 1.3 3.8 3.2 6.8 5.4c6 4.4 15.1 10.1 27.8 15.7C224.5 276.9 263.6 288 320 288s95.5-11.1 120.7-22.4c12.6-5.7 21.7-11.3 27.8-15.7c3-2.2 5.3-4 6.8-5.4c.8-.7 1.4-1.2 1.8-1.6l.5-.5 .2-.2 .1-.1 0 0 0 0s0 0-5.8-5.5l5.8 5.5c1.3-1.3 2-3 2.2-4.8C488.4 139.7 410.9 64 320 64s-168.4 75.7-160 173.4c.2 1.8 .9 3.5 2.2 4.8l5.8-5.5zm296.3-3.7c-1.2 1-2.9 2.4-5.2 4c-5.2 3.8-13.4 8.9-24.9 14.1c-23.1 10.4-60 21-114.2 21s-91.1-10.6-114.2-21c-11.6-5.2-19.7-10.3-24.9-14.1c-2.3-1.6-4-3-5.2-4C170 146.7 238.9 80 320 80s150 66.7 144.3 152.9zM128 328a16 16 0 1 1 0-32 16 16 0 1 1 0 32zM96 312a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm224 64a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm240-48a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM130.6 204.4c4.2-1.4 6.4-6 5-10.2s-6-6.4-10.2-5c-37.1 12.7-68.2 29-90.1 48.2S0 279.1 0 304c0 21.4 10 41.2 26.8 58.5c16.7 17.3 40.6 32.4 69.4 45C153.9 432.6 233 448 320 448s166.1-15.4 223.8-40.5c28.8-12.6 52.7-27.7 69.4-45C630 345.2 640 325.4 640 304c0-24.9-13.4-47.5-35.3-66.6s-52.9-35.5-90.1-48.2c-4.2-1.4-8.7 .8-10.2 5s.8 8.7 5 10.2c35.9 12.2 64.9 27.7 84.7 45.1C614 266.8 624 285.3 624 304c0 16.1-7.5 32.1-22.3 47.4c-14.8 15.3-36.7 29.4-64.3 41.5C482.2 416.9 405.3 432 320 432s-162.2-15.1-217.4-39.2c-27.6-12-49.5-26.2-64.3-41.5C23.5 336.1 16 320.1 16 304c0-18.7 10-37.2 29.9-54.6s48.8-32.8 84.7-45.1z'
      
    ]
  };

  

  
  

  var faTextSize = {
    prefix: 'fat',
    iconName: 'text-size',
    icon: [
      640,
      512,
      [],
      'f894',
      
      'M16 56c0-4.4 3.6-8 8-8H184l0 416H104c-4.4 0-8 3.6-8 8s3.6 8 8 8h88 88c4.4 0 8-3.6 8-8s-3.6-8-8-8H200l0-416H360c4.4 0 8 3.6 8 8v48c0 4.4 3.6 8 8 8s8-3.6 8-8V56c0-13.3-10.7-24-24-24H192 24C10.7 32 0 42.7 0 56v48c0 4.4 3.6 8 8 8s8-3.6 8-8V56zM336 248c0-4.4 3.6-8 8-8H472l0 224H392c-4.4 0-8 3.6-8 8s3.6 8 8 8h88 88c4.4 0 8-3.6 8-8s-3.6-8-8-8H488l0-224H616c4.4 0 8 3.6 8 8v48c0 4.4 3.6 8 8 8s8-3.6 8-8V248c0-13.3-10.7-24-24-24H480 344c-13.3 0-24 10.7-24 24v48c0 4.4 3.6 8 8 8s8-3.6 8-8V248z'
      
    ]
  };

  

  
  

  var faSunHaze = {
    prefix: 'fat',
    iconName: 'sun-haze',
    icon: [
      640,
      512,
      [],
      'f765',
      
      'M229.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L185 121 77.1 140.8c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L129.1 256 107 288h19.4l18.9-27.5c1.9-2.7 1.9-6.3 0-9.1L80 156.6l113.3-20.8c3.3-.6 5.8-3.2 6.4-6.4L220.6 16l94.9 65.4c2.7 1.9 6.3 1.9 9.1 0L419.4 16l20.8 113.3c.6 3.3 3.2 5.8 6.4 6.4L560 156.6l-65.4 94.9c-1.9 2.7-1.9 6.3 0 9.1L513.5 288H533l-22.1-32 62.3-90.3c3.1-4.5 3.7-10.2 1.6-15.2l-7.4 3.1 7.4-3.1c-2.1-5-6.6-8.6-11.9-9.6L455 121 435.1 13.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L320 65.1 229.7 2.8zM432 256c0-61.9-50.1-112-112-112s-112 50.1-112 112c0 11.1 1.6 21.9 4.6 32h16.8c-3.5-10-5.5-20.8-5.5-32c0-53 43-96 96-96s96 43 96 96c0 11.2-1.9 22-5.5 32h16.8c3-10.1 4.6-20.9 4.6-32zM72 320c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H72zm416 0c-4.4 0-8 3.6-8 8s3.6 8 8 8H632c4.4 0 8-3.6 8-8s-3.6-8-8-8H488zM8 408c-4.4 0-8 3.6-8 8s3.6 8 8 8H568c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zm64 88c-4.4 0-8 3.6-8 8s3.6 8 8 8H216c4.4 0 8-3.6 8-8s-3.6-8-8-8H72zm192 0c-4.4 0-8 3.6-8 8s3.6 8 8 8H632c4.4 0 8-3.6 8-8s-3.6-8-8-8H264z'
      
    ]
  };

  

  
  

  var faVolleyball = {
    prefix: 'fat',
    iconName: 'volleyball',
    icon: [
      512,
      512,
      [127952,"volleyball-ball"],
      'f45f',
      
      'M452.3 394.2c-95.6 35.4-205.8 25.6-295.8-34.3c-18.6 27.9-32.5 58.5-41.3 90.6C154.7 479.1 203.4 496 256 496c81.1 0 152.8-40.2 196.3-101.8zm14.5-23.2c12.3-22.4 21-47 25.6-73.1C415 316.4 330.8 307 256.1 265.2c-36.3 21.6-66.6 49.5-90.4 81.5c91.9 61 205.9 67.2 301 24.2zm28-90.2c.8-8.1 1.3-16.4 1.3-24.8c0-119.9-88-219.3-202.9-237.2c69.8 68.2 108.5 166.8 96.9 271c35.4 2.9 70.8-.2 104.7-9.1zM266.5 16.2c-3.5-.2-7-.2-10.5-.2c-28.8 0-56.4 5.1-81.9 14.4c54.8 57.7 88.7 135.4 89.9 221c35.1 19.6 72.5 31.7 110.1 36.8C386 181.5 342.6 81.2 266.5 16.2zM158.1 36.8C74.3 74.3 16 158.3 16 256c0 22.5 3.1 44.4 8.9 65.1c30.2-90.9 96.9-169.8 187.9-208.4l.3-.1c-14.5-28-33.1-53.5-55.1-75.7zM33.9 347.1c14.8 36.2 38.2 67.9 67.7 92.7c10.1-34 25.6-66.3 46.3-95.7c25.7-36.5 59.3-68.3 100.1-92.6c-.6-44.4-10.5-86.5-27.8-124.5l-1 .4C125.5 167.1 58.9 251.8 33.9 347.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  
    var faVolleyballBall = faVolleyball;
  

  
  

  var faBuildingCircleArrowRight = {
    prefix: 'fat',
    iconName: 'building-circle-arrow-right',
    icon: [
      640,
      512,
      [],
      'e4d1',
      
      'M48 16H336c17.7 0 32 14.3 32 32V247.2c5-5.3 10.4-10.3 16-15V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96 16 64 16 96c15.1 0 28.5-6.9 37.3-17.8c-3.9-3.8-7.6-7.7-11.1-11.8c-5.8 8.2-15.4 13.6-26.2 13.6H240V416c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-17.7 0-32-14.3-32-32V48c0-17.7 14.3-32 32-32zM224 496H160V416c0-17.7 14.3-32 32-32s32 14.3 32 32v80zM104 232c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V256c0-13.3-10.7-24-24-24H104zm-8 24c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8V256zm128 0v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V256c0-13.3-10.7-24-24-24H248c-13.3 0-24 10.7-24 24zm24-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H248c-4.4 0-8-3.6-8-8V256c0-4.4 3.6-8 8-8zM104 104c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V128c0-13.3-10.7-24-24-24H104zm-8 24c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8V128zm128 0v32c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V128c0-13.3-10.7-24-24-24H248c-13.3 0-24 10.7-24 24zm24-8h32c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H248c-4.4 0-8-3.6-8-8V128c0-4.4 3.6-8 8-8zM496 240a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm2.3-213.7c-3.1 3.1-3.1 8.2 0 11.3L548.7 360H424c-4.4 0-8 3.6-8 8s3.6 8 8 8H548.7l-50.3 50.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l64-64c3.1-3.1 3.1-8.2 0-11.3l-64-64c-3.1-3.1-8.2-3.1-11.3 0z'
      
    ]
  };

  

  
  

  var faRectangleHistory = {
    prefix: 'fat',
    iconName: 'rectangle-history',
    icon: [
      512,
      512,
      [],
      'e4a2',
      
      'M496 192c0-26.5-21.5-48-48-48L64 144c-26.5 0-48 21.5-48 48l0 256c0 26.5 21.5 48 48 48l384 0c26.5 0 48-21.5 48-48l0-256zm-48-64c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64l384 0zm8-64c4.4 0 8 3.6 8 8s-3.6 8-8 8L56 80c-4.4 0-8-3.6-8-8s3.6-8 8-8l400 0zM408 0c4.4 0 8 3.6 8 8s-3.6 8-8 8L104 16c-4.4 0-8-3.6-8-8s3.6-8 8-8L408 0z'
      
    ]
  };

  

  
  

  var faTally4 = {
    prefix: 'fat',
    iconName: 'tally-4',
    icon: [
      640,
      512,
      [],
      'e297',
      
      'M136 40c0-4.4-3.6-8-8-8s-8 3.6-8 8V472c0 4.4 3.6 8 8 8s8-3.6 8-8V40zm128 0c0-4.4-3.6-8-8-8s-8 3.6-8 8V472c0 4.4 3.6 8 8 8s8-3.6 8-8V40zm120-8c-4.4 0-8 3.6-8 8V472c0 4.4 3.6 8 8 8s8-3.6 8-8V40c0-4.4-3.6-8-8-8zm136 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V472c0 4.4 3.6 8 8 8s8-3.6 8-8V40z'
      
    ]
  };

  

  
  

  var faAnchorCircleCheck = {
    prefix: 'fat',
    iconName: 'anchor-circle-check',
    icon: [
      640,
      512,
      [],
      'e4aa',
      
      'M352 80A64 64 0 1 1 224 80a64 64 0 1 1 128 0zM288 0c-44.2 0-80 35.8-80 80c0 41.5 31.6 75.6 72 79.6c0 .1 0 .3 0 .4v48H200c-4.4 0-8 3.6-8 8s3.6 8 8 8h80V496h-8C170.4 496 88 413.6 88 312V284.8l58.1 64.5c3 3.3 8 3.6 11.3 .6s3.6-8 .6-11.3l-72-80C84.4 257 82.3 256 80 256s-4.4 1-5.9 2.6l-72 80c-3 3.3-2.7 8.3 .6 11.3s8.3 2.7 11.3-.6L72 284.8V312c0 110.5 89.5 200 200 200h16 16c25.9 0 50.7-4.9 73.4-13.9c-4.3-3.9-8.5-8.1-12.4-12.5C346 492.3 325.4 496 304 496h-8V224h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H296V160c0-.1 0-.3 0-.4c40.4-4 72-38.1 72-79.6c0-44.2-35.8-80-80-80zM496 240a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm69.7-189.7c-3.1-3.1-8.2-3.1-11.3 0L480 396.7l-42.3-42.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l48 48c3.1 3.1 8.2 3.1 11.3 0l80-80c3.1-3.1 3.1-8.2 0-11.3z'
      
    ]
  };

  

  
  

  var faMp3Player = {
    prefix: 'fat',
    iconName: 'mp3-player',
    icon: [
      384,
      512,
      [],
      'f8ce',
      
      'M64 16C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48H320c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM96 80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H96zM64 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96zM192 432a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0-208a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm16 112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faCalendarDays = {
    prefix: 'fat',
    iconName: 'calendar-days',
    icon: [
      448,
      512,
      ["calendar-alt"],
      'f073',
      
      'M128 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H64C28.7 64 0 92.7 0 128v48 16 96 16 96 16 32c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V416 400 304 288 192 176 128c0-35.3-28.7-64-64-64H336V8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H128V8zM432 288H304V192H432v96zM288 192v96H160V192H288zm-144 0v96H16V192H144zM16 304H144v96H16V304zm0 112H144v80H64c-26.5 0-48-21.5-48-48V416zm144 80V416H288v80H160zm144 0V416H432v32c0 26.5-21.5 48-48 48H304zm128-96H304V304H432v96zM112 80v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80H320v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80h48c26.5 0 48 21.5 48 48v48H16V128c0-26.5 21.5-48 48-48h48zM288 400H160V304H288v96z'
      
    ]
  };

  
    var faCalendarAlt = faCalendarDays;
  

  
  

  var faWifiFair = {
    prefix: 'fat',
    iconName: 'wifi-fair',
    icon: [
      640,
      512,
      ["wifi-2"],
      'f6ab',
      
      'M133.5 282c48.7-45.9 114.3-74 186.5-74s137.8 28.1 186.5 74c3.2 3 8.3 2.9 11.3-.3s2.9-8.3-.3-11.3C465.9 221.8 396.4 192 320 192s-145.9 29.8-197.5 78.4c-3.2 3-3.4 8.1-.3 11.3s8.1 3.4 11.3 .3zM272 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z'
      
    ]
  };

  
    var faWifi2 = faWifiFair;
  

  
  

  var faTirePressureWarning = {
    prefix: 'fat',
    iconName: 'tire-pressure-warning',
    icon: [
      512,
      512,
      [],
      'f633',
      
      'M424 0c-4.4 0-8 3.6-8 8V35.6c0 41 9.5 81.4 27.9 118.1l5 9.9c.1 .2 .2 .3 .2 .5c18.3 31.4 37.6 75.1 36.9 124.7c-.6 48.6-20.4 103.7-81.1 159.3H107.1C46.4 392.4 26.6 337.2 26 288.7c-.6-49.5 18.6-93.2 36.9-124.7c.1-.1 .2-.3 .2-.5l5-9.9C86.5 117 96 76.6 96 35.6V8c0-4.4-3.6-8-8-8s-8 3.6-8 8V35.6c0 38.5-9 76.5-26.2 110.9L49 156.2C30 188.8 9.3 235.3 10 288.9c.7 53.3 22.6 112.5 86 170.6V504c0 4.4 3.6 8 8 8s8-3.6 8-8V464h88v40c0 4.4 3.6 8 8 8s8-3.6 8-8V464h80v40c0 4.4 3.6 8 8 8s8-3.6 8-8V464h88v40c0 4.4 3.6 8 8 8s8-3.6 8-8V459.5c63.4-58.2 85.3-117.3 86-170.6c.7-53.6-20-100.2-39-132.7l-4.9-9.7C441 112 432 74.1 432 35.6V8c0-4.4-3.6-8-8-8zM256 96c-4.4 0-8 3.6-8 8V264c0 4.4 3.6 8 8 8s8-3.6 8-8V104c0-4.4-3.6-8-8-8zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faDiceThree = {
    prefix: 'fat',
    iconName: 'dice-three',
    icon: [
      448,
      512,
      [9858],
      'f527',
      
      'M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM224 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM336 352a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faBuildingUn = {
    prefix: 'fat',
    iconName: 'building-un',
    icon: [
      384,
      512,
      [],
      'e4d9',
      
      'M48 16C30.3 16 16 30.3 16 48V464c0 17.7 14.3 32 32 32h96V416c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c17.7 0 32-14.3 32-32V48c0-17.7-14.3-32-32-32H48zM224 496V416c0-17.7-14.3-32-32-32s-32 14.3-32 32v80h64zm-80 16H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H240 224 160 144zM104 232h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V256c0-13.3 10.7-24 24-24zm-8 24v32c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V256c0-4.4-3.6-8-8-8H104c-4.4 0-8 3.6-8 8zm128 0c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H248c-13.3 0-24-10.7-24-24V256zm24-8c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V256c0-4.4-3.6-8-8-8H248zM230.7 59.6l49.3 74V64c0-4.4 3.6-8 8-8s8 3.6 8 8v96c0 3.5-2.3 6.6-5.7 7.7s-7-.3-9-3.2L232 90.4V160c0 4.4-3.6 8-8 8s-8-3.6-8-8V64c0-3.5 2.3-6.6 5.7-7.7s7 .3 9 3.2zM104 64v64c0 13.3 10.7 24 24 24s24-10.7 24-24V64c0-4.4 3.6-8 8-8s8 3.6 8 8v64c0 22.1-17.9 40-40 40s-40-17.9-40-40V64c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faRing = {
    prefix: 'fat',
    iconName: 'ring',
    icon: [
      512,
      512,
      [],
      'f70b',
      
      'M84.1 114.3C127.7 93.3 188.5 80 256 80s128.3 13.3 171.9 34.3C472 135.7 496 163.7 496 192c0 18.7-10.5 37.3-30.4 53.9c-9.2-6.6-19.6-12.6-30.8-18C388.7 205.6 325.4 192 256 192s-132.7 13.6-178.8 35.9c-11.2 5.4-21.5 11.4-30.8 18C26.5 229.3 16 210.7 16 192c0-28.3 24-56.3 68.1-77.7zM511.5 184c-4.1-34.4-34.3-63.5-76.7-84.1C388.7 77.6 325.4 64 256 64S123.3 77.6 77.2 99.9C34.8 120.5 4.6 149.6 .5 184H0v8V320.5c0 37.8 31.6 69.7 77.2 91.7C123.3 434.5 186.6 448 256 448s132.7-13.5 178.8-35.8c45.6-22 77.2-53.9 77.2-91.7V192v-8h-.5zM496 237.2v83.3c0 28.2-24 56-68.1 77.3C384.3 418.8 323.6 432 256 432s-128.3-13.2-171.9-34.2C40 376.5 16 348.7 16 320.5V237.2c13.6 18.4 35.1 34.2 61.2 46.8C123.3 306.4 186.6 320 256 320s132.7-13.6 178.8-35.9c26.1-12.6 47.5-28.5 61.2-46.8zM84.1 269.7c-8.9-4.3-17-8.9-24.2-13.7c7.2-4.8 15.3-9.4 24.2-13.7C127.7 221.3 188.5 208 256 208s128.3 13.3 171.9 34.3c8.9 4.3 17 8.9 24.2 13.7c-7.2 4.8-15.3 9.4-24.2 13.7C384.3 290.7 323.5 304 256 304s-128.3-13.3-171.9-34.3z'
      
    ]
  };

  

  
  

  var faWaveSquare = {
    prefix: 'fat',
    iconName: 'wave-square',
    icon: [
      640,
      512,
      [],
      'f83e',
      
      'M184 48c-13.3 0-24 10.7-24 24V224c0 22.1-17.9 40-40 40H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H120c13.3 0 24-10.7 24-24V72c0-22.1 17.9-40 40-40H288c22.1 0 40 17.9 40 40V440c0 13.3 10.7 24 24 24H456c13.3 0 24-10.7 24-24V288c0-22.1 17.9-40 40-40H632c4.4 0 8 3.6 8 8s-3.6 8-8 8H520c-13.3 0-24 10.7-24 24V440c0 22.1-17.9 40-40 40H352c-22.1 0-40-17.9-40-40V72c0-13.3-10.7-24-24-24H184z'
      
    ]
  };

  

  
  

  var faFileLines = {
    prefix: 'fat',
    iconName: 'file-lines',
    icon: [
      384,
      512,
      [61686,128441,128462,"file-alt","file-text"],
      'f15c',
      
      'M64 496c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm40 256c-4.4 0-8 3.6-8 8s3.6 8 8 8H280c4.4 0 8-3.6 8-8s-3.6-8-8-8H104zm0 64c-4.4 0-8 3.6-8 8s3.6 8 8 8H280c4.4 0 8-3.6 8-8s-3.6-8-8-8H104zm0 64c-4.4 0-8 3.6-8 8s3.6 8 8 8H280c4.4 0 8-3.6 8-8s-3.6-8-8-8H104z'
      
    ]
  };

  
    var faFileAlt = faFileLines;
  
    var faFileText = faFileLines;
  

  
  

  var faExplosion = {
    prefix: 'fat',
    iconName: 'explosion',
    icon: [
      576,
      512,
      [],
      'e4e9',
      
      'M543.7 10.1c1-3.8-.9-7.9-4.6-9.4s-7.9-.2-10 3.2L339.3 315.3 295.8 134.1c-.9-3.6-4.1-6.1-7.8-6.1s-6.9 2.5-7.8 6.1L235.6 320.2 109.7 194.3c-2.6-2.6-6.6-3.1-9.7-1.2s-4.6 5.6-3.6 9.1L141 358.5 33.1 344.1c-3.3-.4-6.6 1.2-8.1 4.2s-1.1 6.6 1.2 9.1l80 88L123 464h21.6l-26.7-29.4L52.7 362.8l98.3 13.1c2.7 .4 5.3-.7 7.1-2.7s2.4-4.8 1.6-7.4L120.2 227.5 234.3 341.7c2 2 5 2.8 7.8 2s4.9-3 5.6-5.8L288 170.3l40.2 167.6c.8 3.1 3.3 5.5 6.5 6s6.4-1 8.1-3.7L514 59.4 432.3 365.9c-.7 2.6 0 5.4 1.8 7.4s4.5 3 7.2 2.6l81.7-12.6-64.8 71.3L431.4 464H453l16.9-18.6 80-88c2.3-2.5 2.7-6.2 1.1-9.2s-4.9-4.6-8.3-4.1l-91.9 14.1L543.7 10.1zM296 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V88c0 4.4 3.6 8 8 8s8-3.6 8-8V8zM8 496c-4.4 0-8 3.6-8 8s3.6 8 8 8H199.9c0 0 0 0 .1 0s0 0 .1 0H375.9c0 0 0 0 .1 0s0 0 .1 0H568c4.4 0 8-3.6 8-8s-3.6-8-8-8H383.7c-4.1-49.3-45.3-88-95.7-88s-91.6 38.7-95.7 88H8zm200.4 0c4-40.4 38.1-72 79.6-72s75.6 31.6 79.6 72H208.4z'
      
    ]
  };

  

  
  

  var faDownLeftAndUpRightToCenter = {
    prefix: 'fat',
    iconName: 'down-left-and-up-right-to-center',
    icon: [
      512,
      512,
      ["compress-alt"],
      'f422',
      
      'M470.6 11.3c-12.5-12.5-32.8-12.5-45.3 0L352 84.7 326.6 59.3c-12.5-12.5-32.8-12.5-45.3 0c-6 6-9.4 14.1-9.4 22.6V208c0 17.7 14.3 32 32 32H430.1c8.5 0 16.6-3.4 22.6-9.4c12.5-12.5 12.5-32.8 0-45.3L427.3 160l73.4-73.4c12.5-12.5 12.5-32.8 0-45.3L470.6 11.3zM436.7 22.6c6.2-6.2 16.4-6.2 22.6 0l30.1 30.1c6.2 6.2 6.2 16.4 0 22.6l-79 79c-3.1 3.1-3.1 8.2 0 11.3l31 31c6.2 6.2 6.2 16.4 0 22.6c-3 3-7.1 4.7-11.3 4.7H304c-8.8 0-16-7.2-16-16V82c0-4.2 1.7-8.3 4.7-11.3c6.2-6.2 16.4-6.2 22.6 0l31 31c3.1 3.1 8.2 3.1 11.3 0l79-79zM41.4 500.7c12.5 12.5 32.8 12.5 45.3 0L160 427.3l25.4 25.4c12.5 12.5 32.8 12.5 45.3 0c6-6 9.4-14.1 9.4-22.6V304c0-17.7-14.3-32-32-32H81.9c-8.5 0-16.6 3.4-22.6 9.4c-12.5 12.5-12.5 32.8 0 45.3L84.7 352 11.3 425.4c-12.5 12.5-12.5 32.8 0 45.3l30.1 30.1zm33.9-11.3c-6.2 6.2-16.4 6.2-22.6 0L22.6 459.3c-6.2-6.2-6.2-16.4 0-22.6l79-79c3.1-3.1 3.1-8.2 0-11.3l-31-31c-6.2-6.2-6.2-16.4 0-22.6c3-3 7.1-4.7 11.3-4.7H208c8.8 0 16 7.2 16 16V430.1c0 4.2-1.7 8.3-4.7 11.3c-6.2 6.2-16.4 6.2-22.6 0l-31-31c-3.1-3.1-8.2-3.1-11.3 0l-79 79z'
      
    ]
  };

  
    var faCompressAlt = faDownLeftAndUpRightToCenter;
  

  
  

  var faSquareUser = {
    prefix: 'fat',
    iconName: 'square-user',
    icon: [
      448,
      512,
      [],
      'e283',
      
      'M384 48c26.5 0 48 21.5 48 48V416c0 26.5-21.5 48-48 48V448c0-70.7-57.3-128-128-128H192c-70.7 0-128 57.3-128 128l0 16c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H384zM368 464H80V448c0-61.9 50.1-112 112-112h64c61.9 0 112 50.1 112 112v16zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM304 208a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-80-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
      
    ]
  };

  

  
  

  var faFaceHandPeeking = {
    prefix: 'fat',
    iconName: 'face-hand-peeking',
    icon: [
      640,
      512,
      [129763],
      'e481',
      
      'M320 16c-57.7 0-110.5 20.3-151.9 54.2c-3.4 2.8-8.5 2.3-11.3-1.1s-2.3-8.5 1.1-11.3C202.1 21.7 258.5 0 320 0c79.9 0 151.3 36.6 198.2 93.9c2.8 3.4 2.3 8.5-1.1 11.3s-8.5 2.3-11.3-1.1C461.8 50.3 394.9 16 320 16zM92.6 355.3c4-1.9 8.8-.2 10.7 3.8C141.8 440.1 224.4 496 320 496c74.9 0 141.8-34.3 185.8-88.1c2.8-3.4 7.8-3.9 11.3-1.1s3.9 7.8 1.1 11.3C471.3 475.4 399.9 512 320 512c-102 0-190.1-59.7-231.2-146c-1.9-4-.2-8.8 3.8-10.7zm-52-200.3L101.7 94c14.1-14.1 36.9-14.1 50.9 0s14.1 36.9 0 50.9L137.5 160H232c17.7 0 32 14.3 32 32c0 3.9-.7 7.7-2 11.2c10.7 5.2 18 16.1 18 28.8s-7.4 23.6-18 28.8c1.3 3.5 2 7.3 2 11.2c0 17.7-14.3 32-32 32H214.7c.8 2.8 1.3 5.8 1.3 8.9c0 17.7-14.3 32-32 32H119.2c-29.5 0-57.8-11.7-78.6-32.6C-2.5 269.2-2.9 199.5 39.6 156l.1-.1 0 0 .8-.8 0 0zM197.3 304c-2.9-4.3-7.8-7.1-13.3-7.1h-3.3H170c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5h10.7H184h20.1H232c8.8 0 16-7.2 16-16c0-2.9-.8-5.6-2.1-8c-2.8-4.8-7.9-8-13.9-8H180.9 169.6c-2.2 0-4-1.8-4-4s1.8-4 4-4h11.3l51.1 0h16c1.5 0 3-.2 4.4-.6c6.7-1.9 11.6-8.1 11.6-15.4s-4.9-13.5-11.6-15.4c-1.4-.4-2.9-.6-4.4-.6H232 180.9 169.6c-2.2 0-4-1.8-4-4s1.8-4 4-4h11.3l51.1 0c5.9 0 11.1-3.2 13.9-8c1.4-2.4 2.1-5.1 2.1-8c0-8.8-7.2-16-16-16H118.2c-7.1 0-10.7-8.6-5.7-13.7l28.8-28.8c7.8-7.8 7.8-20.5 0-28.3s-20.5-7.8-28.3 0L51.9 166.4l-.8 .8C14.7 204.4 15 264.1 51.9 301c17.9 17.9 42.1 27.9 67.3 27.9H184c8.8 0 16-7.2 16-16c0-3.3-1-6.4-2.7-8.9zM599.4 195.1l0 0 .8 .8 .1 .1 0 0c42.5 43.5 42.2 113.2-.9 156.3c-20.9 20.9-49.1 32.6-78.6 32.6H456c-17.7 0-32-14.3-32-32c0-3.1 .4-6.1 1.3-8.9H408c-17.7 0-32-14.3-32-32c0-3.9 .7-7.7 2-11.2c-10.7-5.2-18-16.1-18-28.8c0-17.7 14.3-32 32-32l66.5 0-53.1-38c-14.4-10.3-17.7-30.3-7.4-44.6s30.3-17.7 44.6-7.4l52.3 37.3c-4.4-12.6-1.6-27.2 8.5-37.3c14.1-14.1 36.9-14.1 50.9 0l45.1 45.1zM387.6 287.4c1.4 .4 2.9 .6 4.4 .6h16 56.7H476c2.2 0 4 1.8 4 4s-1.8 4-4 4H464.7 408c-5.9 0-11.1 3.2-13.9 8c-1.4 2.4-2.1 5.1-2.1 8c0 8.8 7.2 16 16 16h27.9l20.1 0h8.9 10.7c2.5 0 4.5 2 4.5 4.5s-2 4.5-4.5 4.5H464.9 456c-5.5 0-10.4 2.8-13.3 7.1c-1.7 2.5-2.7 5.6-2.7 8.9c0 8.8 7.2 16 16 16h64.8c25.2 0 49.5-10 67.3-27.9c36.9-36.9 37.2-96.6 .8-133.8l-.8-.8L543 161.3c-7.8-7.8-20.5-7.8-28.3 0s-7.8 20.5 0 28.3l14.8 14.8c6.6 6.6 2.7 18-6.6 19c-2.8 .3-5.6-.4-7.8-2L433.3 163c-7.2-5.1-17.2-3.5-22.3 3.7s-3.5 17.2 3.7 22.3l59.7 42.6c3.5 2.5 5.6 6.6 5.6 10.9c0 7.4-6 13.4-13.4 13.4H392c-8.8 0-16 7.2-16 16c0 7.3 4.9 13.5 11.6 15.4zM264 400c0 7.3 4.8 15.1 15 21.5c10.1 6.3 24.6 10.5 41 10.5s30.9-4.2 41-10.5c10.2-6.4 15-14.2 15-21.5s-4.8-15.1-15-21.5c-10.1-6.3-24.6-10.5-41-10.5s-30.9 4.2-41 10.5c-10.2 6.4-15 14.2-15 21.5zm56-48c18.9 0 36.5 4.8 49.5 12.9C382.4 373 392 385.2 392 400s-9.6 27-22.5 35.1c-13 8.2-30.6 12.9-49.5 12.9s-36.5-4.8-49.5-12.9C257.6 427 248 414.8 248 400s9.6-27 22.5-35.1c13-8.2 30.6-12.9 49.5-12.9zm38.9-187.4c2.2 3.8 .9 8.7-2.9 10.9c-16.8 9.7-28 27.8-28 48.5c0 7.4 1.4 14.5 4 21c1.7 4.1-.3 8.8-4.4 10.4s-8.8-.3-10.4-4.4c-3.4-8.3-5.2-17.4-5.2-26.9c0-26.7 14.5-49.9 36-62.4c3.8-2.2 8.7-.9 10.9 2.9zM384 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faTheta = {
    prefix: 'fat',
    iconName: 'theta',
    icon: [
      384,
      512,
      [],
      'f69e',
      
      'M40 256c0-62.7 17.5-119 45.4-159.5C113.4 56 151.2 32 192 32s78.6 24 106.6 64.5C326.5 137 344 193.3 344 256s-17.5 119-45.4 159.5C270.6 456 232.8 480 192 480s-78.6-24-106.6-64.5C57.5 375 40 318.7 40 256zM192 16c-47.6 0-89.8 28-119.7 71.4C42.3 130.9 24 190.5 24 256s18.3 125.1 48.3 168.6C102.2 468 144.4 496 192 496s89.8-28 119.7-71.4C341.7 381.1 360 321.5 360 256s-18.3-125.1-48.3-168.6C281.8 44 239.6 16 192 16zM96 248c-4.4 0-8 3.6-8 8s3.6 8 8 8H288c4.4 0 8-3.6 8-8s-3.6-8-8-8H96z'
      
    ]
  };

  

  
  

  var faFonduePot = {
    prefix: 'fat',
    iconName: 'fondue-pot',
    icon: [
      512,
      512,
      [129749],
      'e40d',
      
      'M292.2 16.6c-8.5-2.3-17.3 2.7-19.6 11.2l-24 88c-2.3 8.5 2.7 17.3 11.2 19.6s17.3-2.7 19.6-11.2l24-88c2.3-8.5-2.7-17.3-11.2-19.6zm164.4 1.9c-7.5-4.7-17.3-2.5-22.1 4.9l-56 88c-4.7 7.5-2.5 17.3 4.9 22.1s17.3 2.5 22.1-4.9l56-88c4.7-7.5 2.5-17.3-4.9-22.1zM318.9 40.4l-24 88c-4.1 15-18.2 24.6-33.1 23.5L248.4 192H231.6l15-45.1c-11.4-7.4-17.2-21.5-13.5-35.3l24-88c4.6-17.1 22.2-27.1 39.3-22.5s27.1 22.2 22.5 39.3zm62.6 109.8L353.6 192H334.4l33.8-50.7c-9.3-10.4-11-26.1-3.1-38.5l56-88C430.5-.1 450.3-4.5 465.2 5s19.3 29.3 9.8 44.2l-56 88c-8.1 12.8-23.8 17.8-37.5 13zM32 240c-8.8 0-16 7.2-16 16v64c0 79.5 64.5 144 144 144H288c79.5 0 144-64.5 144-144V240H168v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V277.5c0-3.1-2.5-5.5-5.5-5.5h-4.3c-3.4 0-6.2 2.8-6.2 6.2V320c0 13.3-10.7 24-24 24s-24-10.7-24-24V240H32zm0-16H56 72h80 16H432h16 56c4.4 0 8 3.6 8 8s-3.6 8-8 8H448v80c0 52.3-25.1 98.8-64 128v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V458.6c-23.5 13.6-50.9 21.4-80 21.4H160c-29.1 0-56.5-7.8-80-21.4V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V448C25.1 418.8 0 372.3 0 320V256c0-17.7 14.3-32 32-32zm40 32v22.2V320c0 4.4 3.6 8 8 8s8-3.6 8-8V278.1c0-12.2 9.9-22.2 22.2-22.2h4.3c11.9 0 21.5 9.6 21.5 21.5V288c0 4.4 3.6 8 8 8s8-3.6 8-8V277.5 256 240H136 114.5h-4.3H88 72v16z'
      
    ]
  };

  

  
  

  var faRingDiamond = {
    prefix: 'fat',
    iconName: 'ring-diamond',
    icon: [
      384,
      512,
      [],
      'e5ab',
      
      'M132.7 10.1C137.2 3.7 144.5 0 152.2 0h79.5c7.8 0 15 3.7 19.5 10.1l32 44.8c3.9 5.4 4 12.6 .3 18.2l-41.1 61.7C324 156.9 384 231.4 384 320c0 106-86 192-192 192S0 426 0 320c0-88.6 60-163.1 141.5-185.3L100.4 73c-3.7-5.5-3.6-12.8 .3-18.2l32-44.8zM265.1 72H118.9l39.3 59c11-1.9 22.2-3 33.7-3s22.8 1 33.7 3l39.3-59zm-.6-16L238.3 19.4c-1.5-2.1-3.9-3.4-6.5-3.4H152.2c-2.6 0-5 1.2-6.5 3.4L119.5 56H264.5zM192 496a176 176 0 1 0 0-352 176 176 0 1 0 0 352z'
      
    ]
  };

  

  
  

  var faRobotAstromech = {
    prefix: 'fat',
    iconName: 'robot-astromech',
    icon: [
      512,
      512,
      [],
      'e2d2',
      
      'M256 0C176.5 0 112 64.5 112 144v32H88c-30.9 0-56 25.1-56 56V422.1L2.2 481.7C.8 484.6 0 487.8 0 491.1C0 502.6 9.4 512 20.9 512H104c13.3 0 24-10.7 24-24V389l50 56.3c1.5 1.7 3.7 2.7 6 2.7H328c2.3 0 4.5-1 6-2.7L384 389v99c0 13.3 10.7 24 24 24h83.1c11.6 0 20.9-9.4 20.9-20.9c0-3.3-.8-6.5-2.2-9.4L480 422.1V232c0-30.9-25.1-56-56-56H400V144C400 64.5 335.5 0 256 0zM400 192h24c22.1 0 40 17.9 40 40V424c0 1.2 .3 2.5 .8 3.6l30.6 61.3c.3 .7 .5 1.4 .5 2.2c0 2.7-2.2 4.9-4.9 4.9H408c-4.4 0-8-3.6-8-8V368 192zm-16 0V365l-59.6 67H187.6L128 365V192H384zm-272 0V368 488c0 4.4-3.6 8-8 8H20.9c-2.7 0-4.9-2.2-4.9-4.9c0-.8 .2-1.5 .5-2.2l30.6-61.3c.6-1.1 .8-2.3 .8-3.6V232c0-22.1 17.9-40 40-40h24zm16-48c0-70.7 57.3-128 128-128s128 57.3 128 128v32H128V144zm72-48a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm64 0a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm40 32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM192 248c0 4.4 3.6 8 8 8H312c4.4 0 8-3.6 8-8s-3.6-8-8-8H200c-4.4 0-8 3.6-8 8zm0 64c0 4.4 3.6 8 8 8H312c4.4 0 8-3.6 8-8s-3.6-8-8-8H200c-4.4 0-8 3.6-8 8z'
      
    ]
  };

  

  
  

  var faInfo = {
    prefix: 'fat',
    iconName: 'info',
    icon: [
      192,
      512,
      [],
      'f129',
      
      'M80 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-64a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM32 184c0-4.4 3.6-8 8-8H96c4.4 0 8 3.6 8 8V464h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H88V192H40c-4.4 0-8-3.6-8-8z'
      
    ]
  };

  

  
  

  var faSalad = {
    prefix: 'fat',
    iconName: 'salad',
    icon: [
      512,
      512,
      [129367,"bowl-salad"],
      'f81e',
      
      'M240 16c-41.6 0-77.6 24.5-94.2 59.9c-1.4 3-4.6 4.9-7.9 4.6c-3.2-.3-6.5-.4-9.9-.4C66.1 80 16 130.1 16 192c0 23.8 7.4 45.9 20.1 64h-19C6.2 237.2 0 215.3 0 192C0 121.3 57.3 64 128 64c1.9 0 3.9 0 5.8 .1C153.9 26 193.9 0 240 0c46.7 0 87.2 26.7 107 65.7c6.8-1.1 13.8-1.7 21-1.7c41.2 0 77.9 19.5 101.3 49.7c-11.9-6.5-24.8-11.4-38.4-14.4C413 87.1 391.3 80 368 80c-8.2 0-16.2 .9-23.8 2.5c-3.7 .8-7.5-1.1-9-4.6C319 41.4 282.5 16 240 16zM400 144c-53 0-96 43-96 96c0 5.5 .5 10.8 1.3 16H289.1c-.7-5.2-1.1-10.6-1.1-16c0-61.9 50.1-112 112-112s112 50.1 112 112c0 5.4-.4 10.8-1.1 16H494.7c.9-5.2 1.3-10.5 1.3-16c0-53-43-96-96-96zM112 464.7c.4 17.3 14.6 31.3 32 31.3H368c17.4 0 31.6-13.9 32-31.3c.1-6.1 3.8-11.6 9.3-14.2c51.2-23.5 86.7-75.2 86.7-135.1c0-6.3-5.1-11.4-11.4-11.4H27.4c-6.3 0-11.4 5.1-11.4 11.4c0 59.9 35.5 111.6 86.7 135.1c5.6 2.6 9.2 8.1 9.3 14.2zM27.4 288H484.6c15.1 0 27.4 12.3 27.4 27.4c0 66.4-39.4 123.7-96 149.7c-.6 26-21.8 46.9-48 46.9H144c-26.1 0-47.4-20.9-48-46.9c-56.7-26-96-83.2-96-149.7C0 300.3 12.3 288 27.4 288zM248 104V248c0 4.4-3.6 8-8 8s-8-3.6-8-8V104c0-4.4 3.6-8 8-8s8 3.6 8 8zM93.7 146.3l96 96c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-96-96c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0z'
      
    ]
  };

  
    var faBowlSalad = faSalad;
  

  
  

  var faMessage = {
    prefix: 'fat',
    iconName: 'message',
    icon: [
      512,
      512,
      ["comment-alt"],
      'f27a',
      
      'M160 400c8.8 0 16 7.2 16 16v80l123.7-92.8c2.8-2.1 6.1-3.2 9.6-3.2H448c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H64C37.5 16 16 37.5 16 64V352c0 26.5 21.5 48 48 48h96zM0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V432 416H144 64c-35.3 0-64-28.7-64-64V64z'
      
    ]
  };

  
    var faCommentAlt = faMessage;
  

  
  

  var faCoffin = {
    prefix: 'fat',
    iconName: 'coffin',
    icon: [
      384,
      512,
      [9904],
      'f6c6',
      
      'M114.5 21.5c3-3.5 7.4-5.5 12-5.5h131c4.6 0 9 2 12 5.5l91 104c4.8 5.5 7.5 12.7 7.5 20c0 2.9-.4 5.7-1.2 8.4L271.3 484.4c-2 6.8-8.2 11.6-15.4 11.6H128.1c-7.1 0-13.4-4.7-15.4-11.6L17.2 153.9c-.8-2.7-1.2-5.6-1.2-8.4c0-7.4 2.7-14.5 7.5-20l91-104zm-12-10.5l-91 104C4.1 123.3 0 134.2 0 145.4c0 4.4 .6 8.7 1.8 12.9L97.3 488.9c4 13.7 16.5 23.1 30.7 23.1H255.9c14.3 0 26.8-9.4 30.7-23.1l95.5-330.6c1.2-4.2 1.8-8.5 1.8-12.9c0-11.2-4.1-22.1-11.5-30.6l-91-104C275.5 4 266.7 0 257.5 0h-131c-9.2 0-18 4-24.1 10.9z'
      
    ]
  };

  

  
  

  var faStethoscope = {
    prefix: 'fat',
    iconName: 'stethoscope',
    icon: [
      576,
      512,
      [129658],
      'f0f1',
      
      'M127.5 5.2c1.6 4.1-.5 8.7-4.7 10.3L79.6 31.7C70.2 35.2 64 44.2 64 54.2V192c0 70.7 57.3 128 128 128s128-57.3 128-128V54.2c0-10-6.2-19-15.6-22.5L261.2 15.5c-4.1-1.6-6.2-6.2-4.7-10.3s6.2-6.2 10.3-4.7L310 16.7c15.6 5.9 26 20.8 26 37.5V192c0 76.8-60.2 139.6-136 143.8c0 .1 0 .1 0 .2v24c0 75.1 60.9 136 136 136s136-60.9 136-136V255.5c-31.6-3.9-56-30.9-56-63.5c0-35.3 28.7-64 64-64s64 28.7 64 64c0 32.6-24.4 59.6-56 63.5V360c0 83.9-68.1 152-152 152s-152-68.1-152-152V336c0-.1 0-.1 0-.2C108.2 331.6 48 268.8 48 192V54.2c0-16.7 10.3-31.6 26-37.5L117.2 .5c4.1-1.6 8.7 .5 10.3 4.7zM480 144a48 48 0 1 0 0 96 48 48 0 1 0 0-96z'
      
    ]
  };

  

  
  

  var faGaugeSimpleMin = {
    prefix: 'fat',
    iconName: 'gauge-simple-min',
    icon: [
      512,
      512,
      ["tachometer-slowest"],
      'f62d',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-208a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112c35.3 0 64-28.7 64-64s-28.7-64-64-64c-18.8 0-35.7 8.1-47.4 21l-108-75.6c-3.6-2.5-8.6-1.7-11.1 2s-1.7 8.6 2 11.1l108 75.6c-4.7 8.9-7.4 19.1-7.4 29.9c0 35.3 28.7 64 64 64z'
      
    ]
  };

  
    var faTachometerSlowest = faGaugeSimpleMin;
  

  
  

  var faFaceHandYawn = {
    prefix: 'fat',
    iconName: 'face-hand-yawn',
    icon: [
      512,
      512,
      [],
      'e379',
      
      'M256 16C123.5 16 16 123.5 16 256c0 80.6 39.7 151.9 100.7 195.4c3.6 2.6 4.4 7.6 1.9 11.2s-7.6 4.4-11.2 1.9C42.4 418 0 342 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 106.3-64.7 197.4-156.9 236.1c-4.1 1.7-8.8-.2-10.5-4.3s.2-8.8 4.3-10.5C435.3 441 496 355.6 496 256C496 123.5 388.5 16 256 16zm6.1 323.3l-4.7 4.7c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l4.7-4.7 46.6-46.6c2.3-2.3 3.8-5.2 4.4-8.3c1-5-.5-10.4-4.4-14.3c-6.2-6.2-16.4-6.2-22.6 0l-79 79c-5 5-13.7 1.5-13.7-5.7V314.4c0-11-9-20-20-20s-20 9-20 20V368v32.8c0 52.6 42.6 95.2 95.2 95.2c25.2 0 49.5-10 67.3-27.9l56.8-56.8c6.2-6.2 6.2-16.4 0-22.6c-3.9-3.9-9.3-5.4-14.3-4.4c-3 .6-5.9 2-8.3 4.4l-14.6 14.6-4.7 4.7c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l4.7-4.7 14.6-14.6 9.2-9.2 22.8-22.8c6.2-6.2 6.2-16.4 0-22.6c-3.9-3.9-9.3-5.4-14.3-4.4c-3 .6-5.9 2-8.3 4.4l-46.6 46.6-4.7 4.7c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l4.7-4.7 46.6-46.6 9.2-9.2 6.8-6.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-6.8 6.8-9.2 9.2-46.6 46.6zm56.1-77.9c12.4-8.3 29.4-7 40.4 4s12.3 28 4 40.4c4.4 1.5 8.5 4.1 12 7.6c12.5 12.5 12.5 32.8 0 45.3L363.2 370c4.2 1.6 8.1 4 11.4 7.3c12.5 12.5 12.5 32.8 0 45.3l-56.8 56.8C297 500.3 268.7 512 239.2 512C177.8 512 128 462.2 128 400.8V368 314.4c0-19.9 16.1-36 36-36s36 16.1 36 36v.3l65.4-65.4c12.5-12.5 32.8-12.5 45.3 0c3.5 3.5 6 7.6 7.6 12zm-143.3 .5c-1.7 4.1-6.4 6-10.5 4.3s-6-6.4-4.3-10.5C175.9 218.3 212.8 192 256 192c30.8 0 58.5 13.4 77.5 34.7c2.9 3.3 2.7 8.3-.6 11.3s-8.3 2.7-11.3-.6c-16.1-18-39.5-29.3-65.6-29.3c-36.5 0-67.8 22.2-81.1 53.9zM206.2 107c2.8 3.4 2.2 8.5-1.2 11.2l-80 64c-3.4 2.8-8.5 2.2-11.2-1.2s-2.2-8.5 1.2-11.2l80-64c3.4-2.8 8.5-2.2 11.2 1.2zM307 118.2c-3.5-2.8-4-7.8-1.2-11.2s7.8-4 11.2-1.2l80 64c3.4 2.8 4 7.8 1.2 11.2s-7.8 4-11.2 1.2l-80-64z'
      
    ]
  };

  

  
  

  var faUserXmark = {
    prefix: 'fat',
    iconName: 'user-xmark',
    icon: [
      640,
      512,
      ["user-times"],
      'f235',
      
      'M224 16a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 240A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 64h91.4C359.3 320 432 392.7 432 482.3c0 7.6-6.1 13.7-13.7 13.7H29.7c-7.6 0-13.7-6.1-13.7-13.7C16 392.7 88.7 320 178.3 320zm0-16C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3zM450.3 130.3c-3.1 3.1-3.1 8.2 0 11.3L516.7 208l-66.3 66.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L528 219.3l66.3 66.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L539.3 208l66.3-66.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L528 196.7l-66.3-66.3c-3.1-3.1-8.2-3.1-11.3 0z'
      
    ]
  };

  
    var faUserTimes = faUserXmark;
  

  
  

  var faTextHeight = {
    prefix: 'fat',
    iconName: 'text-height',
    icon: [
      576,
      512,
      [],
      'f034',
      
      'M485.7 34.3c-3.1-3.1-8.2-3.1-11.3 0l-80 80c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L472 59.3l0 393.4-66.3-66.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l80 80c3.1 3.1 8.2 3.1 11.3 0l80-80c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L488 452.7l0-393.4 66.3 66.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-80-80zM16 56c0-4.4 3.6-8 8-8H152l0 416H72c-4.4 0-8 3.6-8 8s3.6 8 8 8h88 88c4.4 0 8-3.6 8-8s-3.6-8-8-8H168l0-416H296c4.4 0 8 3.6 8 8v48c0 4.4 3.6 8 8 8s8-3.6 8-8V56c0-13.3-10.7-24-24-24H160 24C10.7 32 0 42.7 0 56v48c0 4.4 3.6 8 8 8s8-3.6 8-8V56z'
      
    ]
  };

  

  
  

  var faHeadSideGoggles = {
    prefix: 'fat',
    iconName: 'head-side-goggles',
    icon: [
      512,
      512,
      ["head-vr"],
      'f6ea',
      
      'M16 224H0c.2 52.4 17.1 100.7 47.4 138.8C57.5 375.5 64 390.2 64 405.3V504c0 4.4 3.6 8 8 8s8-3.6 8-8V405.3c0-19.8-8.5-37.8-20.1-52.4C32 317.7 16.2 273 16 224zM39.1 96.8C16.8 101 0 120.5 0 144c0 26.5 21.5 48 48 48H222.2c15.7 24.1 42.9 40 73.8 40H408h64c22.1 0 40-17.9 40-40V96c0-22.1-17.9-40-40-40H408 378.4C342 21.4 292.3 0 239.7 0H222.9C146.6 0 79.2 38.3 39.1 96.8zM59.5 96c37.9-48.7 97-80 163.5-80h16.8C282 16 322.2 31 354 56H296c-30.9 0-58.1 15.9-73.8 40H59.5zM490.1 256c3.8 5.8 5.9 12.7 5.9 19.8c0 20-16.2 36.2-36.2 36.2H440c-4.4 0-8 3.6-8 8v72c0 22.1-17.9 40-40 40H312c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8s8-3.6 8-8V448h72c30.9 0 56-25.1 56-56V328h11.8c28.8 0 52.2-23.4 52.2-52.2c0-6.9-1.4-13.6-3.9-19.8h-18zM296 72H400V216H296c-39.8 0-72-32.2-72-72s32.2-72 72-72zM416 216V72h56c13.3 0 24 10.7 24 24v96c0 13.3-10.7 24-24 24H416zM208 144c0 11.3 2.1 22.1 6 32H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H214c-3.9 9.9-6 20.7-6 32z'
      
    ]
  };

  
    var faHeadVr = faHeadSideGoggles;
  

  
  

  var faCircleL = {
    prefix: 'fat',
    iconName: 'circle-l',
    icon: [
      512,
      512,
      [],
      'e114',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 136c0-4.4-3.6-8-8-8s-8 3.6-8 8V360c0 13.3 10.7 24 24 24H344c4.4 0 8-3.6 8-8s-3.6-8-8-8H184c-4.4 0-8-3.6-8-8V136z'
      
    ]
  };

  

  
  

  var faTrashCan = {
    prefix: 'fat',
    iconName: 'trash-can',
    icon: [
      448,
      512,
      [61460,"trash-alt"],
      'f2ed',
      
      'M157.4 27.3L134.4 64H313.6l-23-36.7c-4.4-7-12.1-11.3-20.4-11.3H177.7c-8.3 0-16 4.3-20.4 11.3zM115.6 64l28.2-45.2C151.1 7.1 163.9 0 177.7 0h92.5c13.8 0 26.6 7.1 33.9 18.8L332.4 64H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H115.6zM40 112c4.4 0 8 3.6 8 8V440c0 30.9 25.1 56 56 56H344c30.9 0 56-25.1 56-56V120c0-4.4 3.6-8 8-8s8 3.6 8 8V440c0 39.8-32.2 72-72 72H104c-39.8 0-72-32.2-72-72V120c0-4.4 3.6-8 8-8zm96 48V416c0 4.4-3.6 8-8 8s-8-3.6-8-8V160c0-4.4 3.6-8 8-8s8 3.6 8 8zm96 0V416c0 4.4-3.6 8-8 8s-8-3.6-8-8V160c0-4.4 3.6-8 8-8s8 3.6 8 8zm96 0V416c0 4.4-3.6 8-8 8s-8-3.6-8-8V160c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  
    var faTrashAlt = faTrashCan;
  

  
  

  var faPhoneArrowUpRight = {
    prefix: 'fat',
    iconName: 'phone-arrow-up-right',
    icon: [
      512,
      512,
      ["phone-arrow-up","phone-outgoing"],
      'e224',
      
      'M290.3 210.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L496 27.3V152c0 4.4 3.6 8 8 8s8-3.6 8-8V8c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8s3.6 8 8 8H484.7L290.3 210.3zm7.5 172.1c6.6 3.1 14.6 1.3 19.2-4.3l40.4-49.3c6.7-8.2 18-11 27.8-7l96 40c11.1 4.6 17.1 16.8 13.9 28.5l-24 88C468.3 488.8 458.8 496 448 496C209.4 496 16 302.6 16 64c0-10.8 7.2-20.3 17.7-23.2l88-24c11.6-3.2 23.8 2.8 28.5 13.9l40 96c4.1 9.8 1.3 21.1-7 27.8l-49.3 40.4c-5.7 4.7-7.5 12.6-4.3 19.2c34.8 73.8 94.5 133.5 168.3 168.3zM345 318.7L304.7 368C234.2 334.7 177.2 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6z'
      
    ]
  };

  
    var faPhoneArrowUp = faPhoneArrowUpRight;
  
    var faPhoneOutgoing = faPhoneArrowUpRight;
  

  
  

  var faRectanglesMixed = {
    prefix: 'fat',
    iconName: 'rectangles-mixed',
    icon: [
      576,
      512,
      [],
      'e323',
      
      'M272 48c17.7 0 32 14.3 32 32V208c0 17.7-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V80c0-17.7 14.3-32 32-32H272zM48 32C21.5 32 0 53.5 0 80V208c0 26.5 21.5 48 48 48H272c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zM528 48c17.7 0 32 14.3 32 32V336c0 17.7-14.3 32-32 32H432c-17.7 0-32-14.3-32-32V80c0-17.7 14.3-32 32-32h96zM432 32c-26.5 0-48 21.5-48 48V336c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H432zM112 320H288c17.7 0 32 14.3 32 32v80c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32zM64 352v80c0 26.5 21.5 48 48 48H288c26.5 0 48-21.5 48-48V352c0-26.5-21.5-48-48-48H112c-26.5 0-48 21.5-48 48z'
      
    ]
  };

  

  
  

  var faAt = {
    prefix: 'fat',
    iconName: 'at',
    icon: [
      512,
      512,
      [61946],
      '40',
      
      'M256 16C123.5 16 16 123.5 16 256s107.5 240 240 240c4.4 0 8 3.6 8 8s-3.6 8-8 8C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256l0 20c0 46.4-37.6 84-84 84c-36.8 0-68.1-23.6-79.4-56.6C331.3 337 296.4 360 256 360c-57.4 0-104-46.6-104-104s46.6-104 104-104c37.1 0 69.6 19.4 88 48.5V168c0-4.4 3.6-8 8-8s8 3.6 8 8v88 20c0 37.6 30.4 68 68 68s68-30.4 68-68l0-20C496 123.5 388.5 16 256 16zm88 240a88 88 0 1 0 -176 0 88 88 0 1 0 176 0z'
      
    ]
  };

  

  
  

  var faTransporter7 = {
    prefix: 'fat',
    iconName: 'transporter-7',
    icon: [
      512,
      512,
      [],
      'e2a8',
      
      'M472 40c0-4.4-3.6-8-8-8s-8 3.6-8 8V72H424c-4.4 0-8 3.6-8 8s3.6 8 8 8h32v32c0 4.4 3.6 8 8 8s8-3.6 8-8V88h32c4.4 0 8-3.6 8-8s-3.6-8-8-8H472V40zM56 264c0-4.4-3.6-8-8-8s-8 3.6-8 8v32H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H40v32c0 4.4 3.6 8 8 8s8-3.6 8-8V312H88c4.4 0 8-3.6 8-8s-3.6-8-8-8H56V264zm56 232c0-17.7 14.3-32 32-32H368c17.7 0 32 14.3 32 32v8c0 4.4 3.6 8 8 8s8-3.6 8-8v-8c0-26.5-21.5-48-48-48H144c-26.5 0-48 21.5-48 48v8c0 4.4 3.6 8 8 8s8-3.6 8-8v-8z'
      
    ]
  };

  

  
  

  var faBagel = {
    prefix: 'fat',
    iconName: 'bagel',
    icon: [
      640,
      512,
      [129391],
      'e3d7',
      
      'M432 400c106 0 192-86 192-192s-86-192-192-192c-56.1 0-106.6 24.1-141.7 62.5c-5.4-2-11-3.8-16.6-5.4C311.8 28.4 368.6 0 432 0C546.9 0 640 93.1 640 208s-93.1 208-208 208c-3.9 0-7.7-.1-11.5-.3c2.7-5.1 5.2-10.4 7.6-15.7c1.3 0 2.6 0 4 0zM325.9 92.7c4.4-12.5 16.1-20.9 29.3-21.3l22.8-.6c6.2-.2 12.1-2.1 17.2-5.6l18.8-12.9c10.9-7.5 25.3-7.5 36.2 0l18.8 12.9c5.1 3.5 11 5.4 17.2 5.6l22.8 .6c13.2 .4 24.8 8.8 29.3 21.3l7.6 21.4c2.1 5.8 5.8 10.9 10.6 14.6l18 13.9c10.5 8.1 14.9 21.7 11.2 34.4L579.1 199c-1.7 5.9-1.7 12.2 0 18.1l6.4 21.8c3.7 12.7-.7 26.3-11.2 34.4l-18 13.9c-4.9 3.8-8.6 8.8-10.6 14.6l-7.6 21.5c-4.4 12.5-16.1 20.9-29.3 21.3l-22.8 .6c-6.2 .2-12.1 2.1-17.2 5.6l-18.8 12.9c-3.3 2.3-7 3.9-10.8 4.8c1.8-6.5 3.4-13.2 4.6-19.9l15.9-10.9c7.6-5.2 16.6-8.1 25.8-8.4l22.8-.6c6.6-.2 12.4-4.4 14.6-10.6l7.6-21.4c3.1-8.7 8.6-16.3 15.9-22l18-13.9c5.2-4 7.5-10.9 5.6-17.2l-6.4-21.8c-2.6-8.9-2.6-18.3 0-27.1l6.4-21.8c1.9-6.3-.4-13.2-5.6-17.2l-18-13.9c-7.3-5.6-12.9-13.3-15.9-22L523 98.1c-2.2-6.2-8-10.4-14.6-10.6l-22.8-.6c-9.2-.3-18.2-3.2-25.8-8.4L441 65.6c-5.4-3.7-12.6-3.7-18.1 0L404.2 78.5c-7.6 5.2-16.6 8.1-25.8 8.4l-22.8 .6c-6.6 .2-12.4 4.4-14.6 10.6l-1.8 4.9c-4.6-3-9.2-5.8-14-8.5l.6-1.8zM496 208c0 30.6-21.5 56.3-50.3 62.5c-.7-5.3-1.7-10.6-2.7-15.8c21.2-5 37.1-24 37.1-46.7c0-26.5-21.5-48-48-48c-9.7 0-18.8 2.9-26.3 7.9c-3-4.4-6.2-8.7-9.5-12.9c10.2-6.9 22.6-11 35.9-11c35.3 0 64 28.7 64 64zm-96 96A192 192 0 1 0 16 304a192 192 0 1 0 384 0zM0 304a208 208 0 1 1 416 0A208 208 0 1 1 0 304zm208-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm48 64a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM128 192a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm192 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM112 384a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm128 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48-16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM80 256a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faLineHeight = {
    prefix: 'fat',
    iconName: 'line-height',
    icon: [
      576,
      512,
      [],
      'f871',
      
      'M101.4 34.1c-3.1-2.8-7.7-2.8-10.8 0l-88 80c-3.3 3-3.5 8-.5 11.3s8 3.5 11.3 .5L88 58.1V453.9L13.4 386.1c-3.3-3-8.3-2.7-11.3 .5s-2.7 8.3 .5 11.3l88 80c3.1 2.8 7.7 2.8 10.8 0l88-80c3.3-3 3.5-8 .5-11.3s-8-3.5-11.3-.5L104 453.9V58.1l74.6 67.8c3.3 3 8.3 2.7 11.3-.5s2.7-8.3-.5-11.3l-88-80zM264 88c-4.4 0-8 3.6-8 8s3.6 8 8 8H568c4.4 0 8-3.6 8-8s-3.6-8-8-8H264zm-8 160c-4.4 0-8 3.6-8 8s3.6 8 8 8H568c4.4 0 8-3.6 8-8s-3.6-8-8-8H256zm0 168c0 4.4 3.6 8 8 8H568c4.4 0 8-3.6 8-8s-3.6-8-8-8H264c-4.4 0-8 3.6-8 8z'
      
    ]
  };

  

  
  

  var faWagonCovered = {
    prefix: 'fat',
    iconName: 'wagon-covered',
    icon: [
      640,
      512,
      [],
      'f8ee',
      
      'M631.9 69.7C645 37 619.6 1.8 584.4 4L451.5 12.3c-23.1 1.4-43.1 13.7-55.2 31.6C388.2 22.9 367.8 8 344 8H296c-23.8 0-44.2 14.9-52.3 35.9C231.6 26 211.6 13.7 188.5 12.3L55.6 4C20.4 1.8-5 37 8.1 69.7L76.2 240H72c-4.4 0-8 3.6-8 8v40c0 4.4 3.6 8 8 8s8-3.6 8-8V256h2.6H88 248h8l128 0h8H552h5.4l2.6 0v32c0 4.4 3.6 8 8 8s8-3.6 8-8V248c0-4.4-3.6-8-8-8h-4.2L631.9 69.7zM546.6 240H400V84.1c0-29.6 23-54 52.5-55.9l132.9-8.3c23.5-1.5 40.4 22 31.7 43.8L546.6 240zM240 240H93.4L22.9 63.8c-8.7-21.8 8.3-45.3 31.7-43.8l132.9 8.3C217 30.1 240 54.6 240 84.1V240zm16 0V84.1 64c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40V240H256zm-80 48c-61.9 0-112 50.1-112 112s50.1 112 112 112c56.4 0 103.1-41.7 110.9-96h66.3c7.8 54.3 54.4 96 110.9 96c61.9 0 112-50.1 112-112s-50.1-112-112-112s-112 50.1-112 112H288c0-61.9-50.1-112-112-112zM368 400.4V400h0c0-53 43-96 96-96s96 43 96 96s-43 96-96 96c-52.9 0-95.8-42.8-96-95.6zM80 400a96 96 0 1 1 192 0A96 96 0 1 1 80 400zm104-72c0-4.4-3.6-8-8-8s-8 3.6-8 8v64H104c-4.4 0-8 3.6-8 8s3.6 8 8 8h64v64c0 4.4 3.6 8 8 8s8-3.6 8-8V408h64c4.4 0 8-3.6 8-8s-3.6-8-8-8H184V328zm280-8c-4.4 0-8 3.6-8 8v64H392c-4.4 0-8 3.6-8 8s3.6 8 8 8h64v64c0 4.4 3.6 8 8 8s8-3.6 8-8V408h64c4.4 0 8-3.6 8-8s-3.6-8-8-8H472V328c0-4.4-3.6-8-8-8z'
      
    ]
  };

  

  
  

  var faCircleChevronRight = {
    prefix: 'fat',
    iconName: 'circle-chevron-right',
    icon: [
      512,
      512,
      ["chevron-circle-right"],
      'f138',
      
      'M496 256A240 240 0 1 1 16 256a240 240 0 1 1 480 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM221.7 381.7l120-120c3.1-3.1 3.1-8.2 0-11.3l-120-120c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L324.7 256 210.3 370.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0z'
      
    ]
  };

  
    var faChevronCircleRight = faCircleChevronRight;
  

  
  

  var faArrowsToCircle = {
    prefix: 'fat',
    iconName: 'arrows-to-circle',
    icon: [
      640,
      512,
      [],
      'e4bd',
      
      'M13.7 2.3C10.5-.8 5.5-.8 2.3 2.3s-3.1 8.2 0 11.3L164.7 176H72c-4.4 0-8 3.6-8 8s3.6 8 8 8H184c4.4 0 8-3.6 8-8V72c0-4.4-3.6-8-8-8s-8 3.6-8 8v92.7L13.7 2.3zm612.7 0L464 164.7V72c0-4.4-3.6-8-8-8s-8 3.6-8 8V184c0 4.4 3.6 8 8 8H568c4.4 0 8-3.6 8-8s-3.6-8-8-8H475.3L637.7 13.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0zM320 176a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 176a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm136 96c4.4 0 8-3.6 8-8V347.3L626.3 509.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L475.3 336H568c4.4 0 8-3.6 8-8s-3.6-8-8-8H456c-4.4 0-8 3.6-8 8V440c0 4.4 3.6 8 8 8zm-272 0c4.4 0 8-3.6 8-8V328c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8s3.6 8 8 8h92.7L2.3 498.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L176 347.3V440c0 4.4 3.6 8 8 8z'
      
    ]
  };

  

  
  

  var faFillDrip = {
    prefix: 'fat',
    iconName: 'fill-drip',
    icon: [
      576,
      512,
      [],
      'f576',
      
      'M34.3 2.3c3.1-3.1 8.2-3.1 11.3 0L151 107.7l81.4-81.4c21.9-21.9 57.3-21.9 79.2 0L485.7 200.4c21.9 21.9 21.9 57.3 0 79.2L283.9 481.4c-37.5 37.5-98.3 37.5-135.8 0L30.6 363.9c-37.5-37.5-37.5-98.3 0-135.8L139.7 119 34.3 13.7c-3.1-3.1-3.1-8.2 0-11.3zm208 219.3L151 130.3 41.9 239.4C28.4 253 20.7 270.3 18.9 288H454.6l19.7-19.7c15.6-15.6 15.6-40.9 0-56.6L300.3 37.7c-15.6-15.6-40.9-15.6-56.6 0L162.3 119l91.3 91.3c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0zM18.9 304c1.8 17.7 9.4 35 23 48.6L159.4 470.1c31.2 31.2 81.9 31.2 113.1 0L438.6 304H18.9zM560 448c0-3.4-1.2-9.4-4.4-18c-3-8.3-7.4-17.7-12.5-27.6c-9.9-19.2-22-39.1-31.2-53.4c-9.1 14.3-21.3 34.1-31.2 53.4c-5.1 9.9-9.4 19.3-12.5 27.6c-3.2 8.6-4.4 14.6-4.4 18c0 26.5 21.5 48 48 48s48-21.5 48-48zm16 0c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-25.2 32.6-79.6 51.2-108.7c6-9.4 19.5-9.4 25.5 0C543.4 368.4 576 422.8 576 448z'
      
    ]
  };

  



export {

  faTurnUp,
  
  faLevelUpAlt,
  

  faMessageText,
  
  faCommentAltText,
  

  faSquareZ,
  

  faPersonCircleCheck,
  

  faHandHoldingMedical,
  

  faGraduationCap,
  
  faMortarBoard,
  

  faMessageMiddle,
  
  faCommentMiddleAlt,
  

  faVideo,
  
  faVideoCamera,
  

  faSquareSlidersVertical,
  
  faSlidersVSquare,
  

  faPlusMinus,
  

  faBulldozer,
  

  faBarcode,
  

  faFileMp4,
  

  faShieldKeyhole,
  

  faReflectVertical,
  

  faSquareShareNodes,
  
  faShareAltSquare,
  

  faComet,
  

  faJetFighter,
  
  faFighterJet,
  

  faPageCaretUp,
  
  faFileCaretUp,
  

  faHandshakeSimple,
  
  faHandshakeAlt,
  

  faEyes,
  

  faCircleJ,
  

  faGalleryThumbnails,
  

  faHandPointLeft,
  

  faPineapple,
  

  faCloudQuestion,
  

  faFaceWoozy,
  

  faKipSign,
  

  faFileGif,
  

  faMasksTheater,
  
  faTheaterMasks,
  

  faStapler,
  

  faD,
  

  faBedFront,
  
  faBedAlt,
  

  faHorizontalRule,
  

  faTrowel,
  

  faUmbrella,
  

  faCameraCctv,
  
  faCctv,
  

  faGrid2,
  

  faSack,
  

  faCircleT,
  

  faBuildingColumns,
  
  faBank,
  
  faInstitution,
  
  faMuseum,
  
  faUniversity,
  

  faPersonMilitaryPointing,
  

  faUsersGear,
  
  faUsersCog,
  

  faMagnifyingGlassDollar,
  
  faSearchDollar,
  

  faX,
  

  faSkullCow,
  

  faComputerSpeaker,
  

  faFerrisWheel,
  

  faDollarSign,
  
  faDollar,
  
  faUsd,
  

  faCircleWaveformLines,
  
  faWaveformCircle,
  

  faFaceNoseSteam,
  

  faTurkishLiraSign,
  
  faTry,
  
  faTurkishLira,
  

  faPrint,
  

  faCommentXmark,
  
  faCommentTimes,
  

  faFaceSmileRelaxed,
  

  faArrowsSpin,
  

  faExclamation,
  

  faTentArrowsDown,
  

  faPlane,
  

  faFaceSadTear,
  
  faSadTear,
  

  faBlockBrickFire,
  
  faFirewall,
  

  faUserInjured,
  

  faBrainCircuit,
  

  faSkiBootSki,
  

  faKeyboardBrightnessLow,
  

  faBenchTree,
  

  faCircle3,
  

  faCardsBlank,
  

  faBone,
  

  faFileCheck,
  

  faArrowUpFromWaterPump,
  

  faBoot,
  

  faTruckContainer,
  

  faPenFancySlash,
  

  faToggleLargeOff,
  

  faLightSwitchOff,
  

  faCupcake,
  

  faBugSlash,
  

  faFaceSadSweat,
  

  faLocationPinSlash,
  
  faMapMarkerSlash,
  

  faWindWarning,
  
  faWindCircleExclamation,
  

  faPaperclipVertical,
  

  faHundredPoints,
  
  fa100,
  

  faDown,
  
  faArrowAltDown,
  

  faNoteSticky,
  
  faStickyNote,
  

  faDiceD12,
  

  faGramophone,
  

  faJar,
  

  faMagnet,
  

  faCircle2,
  

  fa1,
  

  faFalafel,
  

  faPenSwirl,
  

  faCommentExclamation,
  

  faGripDots,
  

  faSquareFull,
  

  faStopwatch20,
  

  faShieldExclamation,
  

  faCloudSun,
  

  faSyringe,
  

  faBoombox,
  

  faUserNurse,
  

  faTrashCheck,
  

  faBridgeSuspension,
  

  faTrainTram,
  

  faStarshipFreighter,
  

  faUserLarge,
  
  faUserAlt,
  

  faCirclesOverlap,
  

  faRulerVertical,
  

  faRightLeftLarge,
  

  faArrowDownFromArc,
  

  faFlower,
  

  faMagnifyingGlassMinus,
  
  faSearchMinus,
  

  faCalendarHeart,
  

  faMask,
  

  faTreeDecorated,
  

  faBrush,
  

  faMugSaucer,
  
  faCoffee,
  

  faGarlic,
  

  faCommentArrowUp,
  

  faRectangleWide,
  

  faWindowMinimize,
  

  faFileInvoice,
  

  faHandDots,
  
  faAllergies,
  

  faArrowDownToDottedLine,
  

  faClockTwelveThirty,
  

  faOnion,
  

  faUserClock,
  

  faCloudShowers,
  

  faThumbsUp,
  

  faMagnifyingGlassPlus,
  
  faSearchPlus,
  

  faIdCardClip,
  
  faIdCardAlt,
  

  faEarthAsia,
  
  faGlobeAsia,
  

  faHotel,
  

  fa9,
  

  faAlbumCollection,
  

  faGifts,
  

  faCircle4,
  

  faCircleXmark,
  
  faTimesCircle,
  
  faXmarkCircle,
  

  faCalendarMinus,
  

  faBandage,
  
  faBandAid,
  

  faClapperboardPlay,
  

  faSensorCloud,
  
  faSensorSmoke,
  

  faBookUser,
  

  faWatchSmart,
  

  faBrain,
  

  faPompebled,
  

  faBowlingBall,
  

  faUnicorn,
  

  faDice,
  

  faSquareEnvelope,
  
  faEnvelopeSquare,
  

  faPersonWalkingArrowRight,
  

  faRectangleBarcode,
  
  faBarcodeAlt,
  

  faSquareS,
  

  faTurnDown,
  
  faLevelDownAlt,
  

  faWheelchairMove,
  
  faWheelchairAlt,
  

  faFaceGrimace,
  
  faGrimace,
  

  faChessPawnPiece,
  
  faChessPawnAlt,
  

  faArrowsUpDown,
  
  faArrowsV,
  

  faWaterLadder,
  
  faLadderWater,
  
  faSwimmingPool,
  

  faCalendarDay,
  

  faBellRing,
  

  faAudioDescriptionSlash,
  

  faFileSpreadsheet,
  

  faWheat,
  

  faTurnLeft,
  

  faCircleCaretRight,
  
  faCaretCircleRight,
  

  faHands,
  
  faSignLanguage,
  
  faSigning,
  

  faLifeRing,
  

  faMoneyBill1Wave,
  
  faMoneyBillWaveAlt,
  

  faEngine,
  

  faTire,
  

  faScannerGun,
  
  faScanner,
  

  faAlignRight,
  

  faWindowFlip,
  
  faWindowAlt,
  

  faInputText,
  

  faHandHoldingBox,
  

  faDungeon,
  

  faRoadCircleExclamation,
  

  faPaperPlane,
  

  faColumns3,
  

  faRightLeft,
  
  faExchangeAlt,
  

  faMessageDollar,
  
  faCommentAltDollar,
  

  faGridHorizontal,
  

  faCircleO,
  

  faScannerKeyboard,
  

  faHillRockslide,
  

  faMaskFace,
  

  faBottleDroplet,
  

  faTurnDownRight,
  

  faFaceThinking,
  

  faShare,
  
  faMailForward,
  

  faDownLeft,
  

  faDatabase,
  

  faNoteMedical,
  

  faTriangleExclamation,
  
  faExclamationTriangle,
  
  faWarning,
  

  faSnake,
  

  faHandcuffs,
  

  faInhaler,
  

  faBookJournalWhills,
  
  faJournalWhills,
  

  faBookOpen,
  

  faChevronsRight,
  
  faChevronDoubleRight,
  

  faCorner,
  

  faBahtSign,
  

  faCowbell,
  

  faLightbulbDollar,
  

  faTireRugged,
  

  faRectangleXmark,
  
  faRectangleTimes,
  
  faTimesRectangle,
  
  faWindowClose,
  

  faHandBackPointRibbon,
  

  faCartFlatbedSuitcase,
  
  faLuggageCart,
  

  faEarthEurope,
  
  faGlobeEurope,
  

  faPrintSlash,
  

  faRug,
  

  faUserTag,
  

  faImagePortrait,
  
  faPortrait,
  

  faPersonFalling,
  

  faBriefcase,
  

  faPotFood,
  

  faCloudMoon,
  

  faLocationPen,
  
  faMapMarkerEdit,
  

  faSlashForward,
  

  faShieldQuartered,
  

  faHandFist,
  
  faFistRaised,
  

  faAirplay,
  

  faLamp,
  

  faArrowsSplitUpAndLeft,
  

  faSquareW,
  

  faTruckArrowRight,
  

  faDiagramSuccessor,
  

  faCartFlatbedBoxes,
  
  faDollyFlatbedAlt,
  

  faAngleLeft,
  

  faBuildings,
  

  faHouseCircleCheck,
  

  faSwordLaser,
  

  faTomato,
  

  faBatteryThreeQuarters,
  
  faBattery4,
  

  faCheck,
  

  faIceSkate,
  

  faUserPlus,
  

  faBook,
  

  faTurkey,
  

  faClipboardListCheck,
  

  faRectangle,
  
  faRectangleLandscape,
  

  faCommentSms,
  
  faSms,
  

  faBasketShoppingMinus,
  

  faTableList,
  
  faThList,
  

  faHandBackPointDown,
  

  faH5,
  

  fa4,
  

  faSoftServe,
  
  faCreemee,
  

  faFaceViewfinder,
  

  faGripDotsVertical,
  

  faSpinnerScale,
  

  faM,
  

  faDesktop,
  
  faDesktopAlt,
  

  faDiceD8,
  

  faShower,
  

  faDoNotEnter,
  

  faGaugeSimpleHigh,
  
  faTachometer,
  
  faTachometerFast,
  

  faArrowDownBigSmall,
  
  faSortSizeDown,
  

  faCalendarLines,
  
  faCalendarNote,
  

  faScaleBalanced,
  
  faBalanceScale,
  

  faDrawPolygon,
  

  faFaceMonocle,
  

  faRss,
  
  faFeed,
  

  faArrowTrendDown,
  

  faCookieBite,
  

  faPeopleSimple,
  

  faFaceAngry,
  
  faAngry,
  

  faFunction,
  

  faBorderAll,
  

  faAnchor,
  

  faCircleQuarter,
  

  faBookQuran,
  
  faQuran,
  

  faDeleteRight,
  

  faFileCirclePlus,
  

  faTornado,
  

  faFireFlameCurved,
  
  faFireAlt,
  

  faArrowUpZA,
  
  faSortAlphaUpAlt,
  

  faPersonWalkingArrowLoopLeft,
  

  faClone,
  

  faLinkSlash,
  
  faChainBroken,
  
  faChainSlash,
  
  faUnlink,
  

  faPlugCircleExclamation,
  

  faHandHolding,
  

  faFaceGrinTongueWink,
  
  faGrinTongueWink,
  

  faCirclePlus,
  
  faPlusCircle,
  

  faShoePrints,
  

  faDragon,
  

  faWifiWeak,
  
  faWifi1,
  

  faBorderBottom,
  

  faVolumeSlash,
  

  faSdCard,
  

  faAmpGuitar,
  

  faLighthouse,
  

  faBahai,
  
  faHaykal,
  

  faUserDoctorMessage,
  
  faUserMdChat,
  

  faTrailer,
  

  faBoxHeart,
  

  faCalendar,
  

  faBoothCurtain,
  

  faCloudMoonRain,
  

  faUpDown,
  
  faArrowsAltV,
  

  faPencilMechanical,
  

  faTurtle,
  

  faCaravanSimple,
  
  faCaravanAlt,
  

  faPersonWalkingLuggage,
  

  faParagraphLeft,
  
  faParagraphRtl,
  

  faBagsShopping,
  

  faFan,
  

  faBlockBrick,
  
  faWallBrick,
  

  faVoicemail,
  

  faPersonArrowDownToLine,
  

  faObjectIntersect,
  

  faChimney,
  

  faVialCircleCheck,
  

  faInfinity,
  

  faCassetteVhs,
  
  faVhs,
  

  faChartColumn,
  

  faHippo,
  

  faTransformerBolt,
  

  faT,
  

  faOilCan,
  

  faUpRightAndDownLeftFromCenter,
  
  faExpandAlt,
  

  faHashtag,
  

  faFaceExplode,
  
  faExplodingHead,
  

  faSquareXmark,
  
  faTimesSquare,
  
  faXmarkSquare,
  

  faFacePouting,
  

  faContainerStorage,
  

  faEarthOceania,
  
  faGlobeOceania,
  

  faGopuram,
  

  faMelon,
  

  faLightbulbCflOn,
  

  faCardHeart,
  

  faShieldHeart,
  

  faVacuum,
  

  faBroom,
  

  faCoinBlank,
  

  faCircleArrowUpLeft,
  

  faCircleG,
  

  faSkeleton,
  

  faDisplayChartUpCircleCurrency,
  

  faPersonBiking,
  
  faBiking,
  

  faTemperatureLow,
  

  faCodeCommit,
  

  faFileMusic,
  

  faClockOne,
  

  faCompassSlash,
  

  faMusic,
  

  faYinYang,
  

  faSendBackward,
  

  faCheese,
  

  faSquareStar,
  

  faWineGlassEmpty,
  
  faWineGlassAlt,
  

  faPenSlash,
  

  faMoon,
  

  faArrowUpFromLine,
  
  faArrowFromBottom,
  

  faCarrot,
  

  faAmpersand,
  

  faAtomSimple,
  
  faAtomAlt,
  

  faPenLine,
  

  faDog,
  

  faWandMagic,
  
  faMagic,
  

  faTents,
  

  faCricketBatBall,
  
  faCricket,
  

  faDiagramCells,
  

  faFaceDiagonalMouth,
  

  faTentArrowTurnLeft,
  

  faBanParking,
  
  faParkingCircleSlash,
  

  faPenNib,
  

  faScythe,
  

  faHouseChimneyWindow,
  

  faCircleChevronLeft,
  
  faChevronCircleLeft,
  

  faGolfBallTee,
  
  faGolfBall,
  

  faHouseMedical,
  

  faPersonSeat,
  

  faDitto,
  

  faPhonePlus,
  

  faGlassesRound,
  
  faGlassesAlt,
  

  faBinary,
  

  faAvocado,
  

  faGunSlash,
  

  faArrowsRepeat1,
  
  faRepeat1Alt,
  

  faArrowUpShortWide,
  
  faSortAmountUpAlt,
  

  faShield,
  
  faShieldBlank,
  

  faFileExport,
  
  faArrowRightFromFile,
  

  faPhoneMissed,
  

  faFireSmoke,
  

  faFaceGrinBeamSweat,
  
  faGrinBeamSweat,
  

  faTrumpet,
  

  faClockRotateLeft,
  
  faHistory,
  

  faNestingDolls,
  

  faMagnifyingGlassMusic,
  

  faChairOffice,
  

  faFishCooked,
  

  faPenPaintbrush,
  
  faPencilPaintbrush,
  

  faBrowser,
  

  faFireplace,
  

  faDiceD10,
  

  faQrcode,
  

  faSubtitlesSlash,
  

  faAlbumCircleUser,
  

  faPancakes,
  

  faCamcorder,
  
  faVideoHandheld,
  

  faAnglesLeft,
  
  faAngleDoubleLeft,
  

  faBuilding,
  

  faTicketSimple,
  
  faTicketAlt,
  

  faAward,
  

  faUserGroupSimple,
  

  faConveyorBeltEmpty,
  

  faFlagPennant,
  
  faPennant,
  

  faPersonFallingBurst,
  

  faArrowRightToLine,
  
  faArrowToRight,
  

  faAnt,
  

  faLineColumns,
  

  faCardSpade,
  

  faSpade,
  

  faArrowTurnDown,
  
  faLevelDown,
  

  faBorderRight,
  

  faKnifeKitchen,
  

  faUpFromBracket,
  

  faMercury,
  

  faTransgender,
  
  faTransgenderAlt,
  

  faSimCard,
  

  faDiceFour,
  

  faMandolin,
  

  faMeter,
  

  faFaceGrinHearts,
  
  faGrinHearts,
  

  faSplotch,
  

  faSquareN,
  

  faArrowUpRightDots,
  

  faSquareFragile,
  
  faBoxFragile,
  
  faSquareWineGlassCrack,
  

  faLockKeyholeOpen,
  
  faLockOpenAlt,
  

  faConveyorBeltArm,
  

  faWarehouse,
  

  faSunBright,
  
  faSunAlt,
  

  faGears,
  
  faCogs,
  

  faPartyHorn,
  

  faPeace,
  

  faRobot,
  

  faWhale,
  

  faArrowUpTriangleSquare,
  
  faSortShapesUp,
  

  faTowerControl,
  

  faSpinner,
  

  faCircleQuarters,
  

  faRotate,
  
  faSyncAlt,
  

  faCircleTrash,
  
  faTrashCircle,
  

  faHandPeace,
  

  faDial,
  
  faDialMedHigh,
  

  faAlt,
  

  faDiagramLeanCanvas,
  

  faMugTeaSaucer,
  

  faTtyAnswer,
  
  faTeletypeAnswer,
  

  faSpeakers,
  

  faFaceVomit,
  

  faHammer,
  

  faPersonPraying,
  
  faPray,
  

  faCloudsSun,
  

  faTrophy,
  

  faWheatSlash,
  

  faThumbtack,
  
  faThumbTack,
  

  faSignatureSlash,
  

  faPhoneHangup,
  

  faFaceSmile,
  
  faSmile,
  

  faPersonSign,
  

  faDisplay,
  

  faCoinVertical,
  

  faLocationCheck,
  
  faMapMarkerCheck,
  

  faConveyorBelt,
  

  faGlassWaterDroplet,
  

  faTruckMoving,
  

  faPercent,
  
  faPercentage,
  

  faHandMiddleFinger,
  

  faBrightnessLow,
  

  faGaugeCircleMinus,
  

  faCarTilt,
  

  faVrCardboard,
  

  faShieldMinus,
  

  faThermometer,
  

  faCloudMinus,
  

  faTrafficLight,
  

  faCloudMusic,
  

  faDownToDottedLine,
  

  faFaceExpressionless,
  

  faBabyCarriage,
  
  faCarriageBaby,
  

  faRadio,
  

  faEllipsisStroke,
  
  faEllipsisHAlt,
  

  faBatteryQuarter,
  
  faBattery2,
  

  faVideoSlash,
  

  faFrame,
  

  faComputerClassic,
  

  faPumpSoap,
  

  faCarRear,
  
  faCarAlt,
  

  faRetweet,
  

  faClockFive,
  

  faSignalWeak,
  
  faSignal1,
  

  faChevronRight,
  

  faGenderless,
  

  faBriefcaseMedical,
  

  faTurntable,
  

  faPersonToDoor,
  

  faDisease,
  

  faNotdef,
  

  faTrashCanUndo,
  
  faTrashCanArrowTurnLeft,
  
  faTrashUndoAlt,
  

  faFilterSlash,
  

  faTablePivot,
  

  faHandLizard,
  

  faMoneyBillSimple,
  

  faClouds,
  

  faBacteria,
  

  faChevronLeft,
  

  faArrowLeftToArc,
  

  faNose,
  

  faHollyBerry,
  

  faLinkHorizontalSlash,
  
  faChainHorizontalSlash,
  

  faDrumstickBite,
  

  faDinosaur,
  

  faAngleUp,
  

  faMessageMinus,
  
  faCommentAltMinus,
  

  faFill,
  

  faGlassHalf,
  
  faGlassHalfEmpty,
  
  faGlassHalfFull,
  

  faMessageCode,
  

  faSchoolFlag,
  

  faTablet,
  
  faTabletAndroid,
  

  faCommentQuote,
  

  faCameraSlash,
  

  faCloudBoltSun,
  
  faThunderstormSun,
  

  faBellSlash,
  

  faStoreLock,
  

  faEyeDropperHalf,
  

  faBezierCurve,
  

  faSignalStreamSlash,
  

  faFolderCheck,
  

  faSquareDivide,
  

  faSignHanging,
  
  faSign,
  

  faVacuumRobot,
  

  faAngle,
  

  faOliveBranch,
  

  faPlugCircleMinus,
  

  faArrowTrendUp,
  

  faStore,
  

  faDisplayArrowDown,
  

  faCircleGf,
  

  faChartScatter,
  

  faFaceEyesXmarks,
  

  faPlanetMoon,
  

  faFolderMinus,
  

  faFloppyDiskCircleArrowRight,
  
  faSaveCircleArrowRight,
  

  faPhotoFilm,
  
  faPhotoVideo,
  

  faVideoArrowDownLeft,
  

  faCandleHolder,
  

  faClockTen,
  

  faSirenOn,
  

  faRocket,
  

  faClockEleven,
  

  faLassoSparkles,
  

  faFaceDisappointed,
  

  faFileCircleInfo,
  

  faArrowLeftFromArc,
  

  faMap,
  

  faUserHairLong,
  

  faAxeBattle,
  

  faCars,
  

  faShekelSign,
  
  faIls,
  
  faShekel,
  
  faSheqel,
  
  faSheqelSign,
  

  faTally2,
  

  faTeeth,
  

  faBlender,
  

  faWrenchSimple,
  

  faPeanut,
  

  faBuildingMagnifyingGlass,
  

  faCakeSlice,
  
  faShortcake,
  

  faEquals,
  

  faH2,
  

  faArrowRightFromLine,
  
  faArrowFromLeft,
  

  faIslandTropical,
  
  faIslandTreePalm,
  

  faBracketSquare,
  
  faBracket,
  
  faBracketLeft,
  

  faHighlighterLine,
  

  faFlaskGear,
  

  faCopyright,
  

  faSymbols,
  
  faIconsAlt,
  

  faRulerCombined,
  

  faSquareQ,
  

  faLinesLeaning,
  

  faArrowDownToBracket,
  

  faArrowDownUpLock,
  

  faTrashArrowUp,
  
  faTrashRestore,
  

  faKeySkeleton,
  

  faDownFromBracket,
  

  faTractor,
  

  faQuoteLeft,
  
  faQuoteLeftAlt,
  

  faUsersLine,
  

  faBaby,
  

  faCirclePhoneFlip,
  
  faPhoneCircleAlt,
  

  faBuildingShield,
  

  faCartCircleXmark,
  

  faFaceSmileTongue,
  

  faPesoSign,
  

  faClawMarks,
  

  faRhombus,
  

  faChalkboardUser,
  
  faChalkboardTeacher,
  

  faArrowsUpDownLeftRight,
  
  faArrows,
  

  faFaceSmirking,
  

  faXmark,
  
  faClose,
  
  faMultiply,
  
  faRemove,
  
  faTimes,
  

  faCloudCheck,
  

  faFort,
  

  faComputer,
  

  faExpand,
  

  faPlus,
  
  faAdd,
  

  faHatBeach,
  

  faSquarePhone,
  
  faPhoneSquare,
  

  fa2,
  

  faGun,
  

  faChildCombatant,
  
  faChildRifle,
  

  faKeynote,
  

  faShareFromSquare,
  
  faShareSquare,
  

  faGrip,
  
  faGripHorizontal,
  

  faJackOLantern,
  

  faUserVneckHair,
  

  faPartyBell,
  

  faPaintbrushPencil,
  

  faBarsFilter,
  

  faHandSparkles,
  

  faVolumeXmark,
  
  faVolumeMute,
  
  faVolumeTimes,
  

  faBurgerGlass,
  

  faCopy,
  

  faSnowmanHead,
  
  faFrostyHead,
  

  faSidebar,
  

  faChartPyramid,
  

  faPedestal,
  

  faDiagramProject,
  
  faProjectDiagram,
  

  faJetFighterUp,
  

  faAwardSimple,
  

  faCircleP,
  

  faBaseball,
  
  faBaseballBall,
  

  faGlobeStand,
  

  faFaceTongueSweat,
  

  faCircleRadiation,
  
  faRadiationAlt,
  

  faMusicNoteSlash,
  
  faMusicAltSlash,
  

  faMango,
  

  faLinkHorizontal,
  
  faChainHorizontal,
  

  faPhoneIntercom,
  

  faSquareChevronLeft,
  
  faChevronSquareLeft,
  

  faClapperboard,
  

  faDiamondHalfStroke,
  

  faSquareArrowDown,
  
  faArrowSquareDown,
  

  faArrowRightLongToLine,
  

  faCircleHalfStroke,
  
  faAdjust,
  

  faStarfighter,
  

  faUserGraduate,
  

  faObjectUnion,
  

  faCartShoppingFast,
  

  faHexagonExclamation,
  

  faMusicNote,
  
  faMusicAlt,
  

  faWaffle,
  

  faCloudFog,
  
  faFog,
  

  faFish,
  

  faCircleStar,
  
  faStarCircle,
  

  faCircle1,
  

  faCommentHeart,
  

  faStarSharp,
  

  faUserMagnifyingGlass,
  

  faTruckFast,
  
  faShippingFast,
  

  faLacrosseStickBall,
  

  faSquareChevronRight,
  
  faChevronSquareRight,
  

  faPersonSnowboarding,
  
  faSnowboarding,
  

  faArrowsRetweet,
  
  faRetweetAlt,
  

  faUserHeadset,
  

  faY,
  

  faCarBurst,
  
  faCarCrash,
  

  faBoxDollar,
  
  faBoxUsd,
  

  faWind,
  

  faCircleExclamationCheck,
  

  faWreathLaurel,
  

  faMegaphone,
  

  faUserShield,
  

  faMushroom,
  

  faPlanetRinged,
  

  faUserDoctorHair,
  

  faSquareY,
  

  faCircleUser,
  
  faUserCircle,
  

  faJugDetergent,
  

  faDiagramSubtask,
  

  faListCheck,
  
  faTasks,
  

  faShrimp,
  

  faCircleDivide,
  

  faBorderLeft,
  

  faTv,
  
  faTelevision,
  
  faTvAlt,
  

  faDownFromDottedLine,
  

  faArrowUp,
  

  faBoneBreak,
  

  faLandmarkDome,
  
  faLandmarkAlt,
  

  faBrazilianRealSign,
  

  faHatWinter,
  

  faMagnifyingGlassPlay,
  

  faPersonHarassing,
  

  faNfcPen,
  

  faChessKing,
  

  faRankingStar,
  

  faPhoneOffice,
  

  faEnvelopes,
  

  faDownLong,
  
  faLongArrowAltDown,
  

  faJugBottle,
  

  faSdCards,
  

  faTowerCell,
  

  faSchoolLock,
  

  faCircleEllipsis,
  

  faWatermelonSlice,
  

  faHandHoldingMagic,
  

  faListUl,
  
  faListDots,
  

  faCodeCompare,
  

  faDropletDegree,
  
  faDewpoint,
  

  faSkullCrossbones,
  

  faClub,
  

  faHospitals,
  

  faBookArrowRight,
  

  faBellPlus,
  

  faBatteryFull,
  
  faBattery,
  
  faBattery5,
  

  faChevronDown,
  

  faMoneyBillSimpleWave,
  

  faHandsHoldingDiamond,
  
  faHandReceiving,
  

  faTransporter2,
  

  faPersonCircleExclamation,
  

  faSuitcaseRolling,
  

  faDisplaySlash,
  
  faDesktopSlash,
  

  faCircleMicrophoneLines,
  
  faMicrophoneCircleAlt,
  

  faSquarePen,
  
  faPenSquare,
  
  faPencilSquare,
  

  faTablePicnic,
  

  faReceipt,
  

  faFilePen,
  
  faFileEdit,
  

  faWalkieTalkie,
  

  faWand,
  

  faCartArrowDown,
  

  faColon,
  

  faCartFlatbedEmpty,
  
  faDollyFlatbedEmpty,
  

  faLobster,
  

  faBracketCurly,
  
  faBracketCurlyLeft,
  

  faTaxiBus,
  

  faPeach,
  

  faNairaSign,
  

  faFloppyDiskCircleXmark,
  
  faFloppyDiskTimes,
  
  faSaveCircleXmark,
  
  faSaveTimes,
  

  faLocationQuestion,
  
  faMapMarkerQuestion,
  

  faSignalGood,
  
  faSignal3,
  

  faTrashCanArrowUp,
  
  faTrashRestoreAlt,
  

  faChevronsDown,
  
  faChevronDoubleDown,
  

  faPersonDotsFromLine,
  
  faDiagnoses,
  

  faTableTennisPaddleBall,
  
  faPingPongPaddleBall,
  
  faTableTennis,
  

  faMagnifyingGlass,
  
  faSearch,
  

  faRupiahSign,
  

  faTableCellsRowLock,
  

  faBurgerLettuce,
  

  faSquareDownLeft,
  

  faCupTogo,
  
  faCoffeeTogo,
  

  faFont,
  

  faPlay,
  

  faTreeCity,
  

  faFileMinus,
  

  faEarListen,
  
  faAssistiveListeningSystems,
  

  faLink,
  
  faChain,
  

  faBallotCheck,
  

  faGrillHot,
  

  faLandmarkMagnifyingGlass,
  

  faBoxesStacked,
  
  faBoxes,
  
  faBoxesAlt,
  

  faTimer,
  

  faSpeaker,
  

  faCarBus,
  

  faStarHalf,
  

  faMoneyFromBracket,
  

  faCheckToSlot,
  
  faVoteYea,
  

  faCloudHail,
  

  faMeterFire,
  

  faSquareE,
  

  faHeadSideHeart,
  

  faParagraph,
  

  faFax,
  

  faDeerRudolph,
  

  faFishBones,
  

  faHeartCircleBolt,
  

  faIceCream,
  

  faScrubber,
  

  faDrum,
  

  faKite,
  

  faRectangleTerminal,
  

  faAngle90,
  

  faPersonWalkingWithCane,
  
  faBlind,
  

  faTransporterEmpty,
  

  faHotdog,
  

  faEarMuffs,
  

  faRouteInterstate,
  

  faBroccoli,
  

  faFaceSmilingHands,
  

  faOilCanDrip,
  

  faObjectsAlignLeft,
  

  faDharmachakra,
  

  faCircleUpLeft,
  

  faCloudHailMixed,
  

  faDiagramSankey,
  

  faBarsStaggered,
  
  faReorder,
  
  faStream,
  

  faUserBountyHunter,
  

  faChessRook,
  

  faWineBottle,
  

  faWhiskeyGlassIce,
  
  faGlassWhiskeyRocks,
  

  faPollPeople,
  

  faHospital,
  
  faHospitalAlt,
  
  faHospitalWide,
  

  faLampDesk,
  

  faEnvelopeOpenText,
  

  faSquareAmpersand,
  

  faGaugeHigh,
  
  faTachometerAlt,
  
  faTachometerAltFast,
  

  faSquareThisWayUp,
  
  faBoxUp,
  

  faSection,
  

  faSquare0,
  

  faInbox,
  

  faFaceSunglasses,
  

  faSocks,
  

  faGrid4,
  

  faBatteryEmpty,
  
  faBattery0,
  

  faSnowflakeDroplets,
  

  faDove,
  

  faHandBackPointRight,
  

  faHatChef,
  

  faGameBoard,
  

  faPersonBurst,
  

  faCrateApple,
  
  faAppleCrate,
  

  faFileSvg,
  

  faEarthAmericas,
  
  faEarth,
  
  faEarthAmerica,
  
  faGlobeAmericas,
  

  faHexagonImage,
  

  faEraser,
  

  faBullseyePointer,
  

  faDroplet,
  
  faTint,
  

  faCircleWifi,
  

  faNotebook,
  

  faFolderMagnifyingGlass,
  
  faFolderSearch,
  

  faCandyCorn,
  

  faMessageQuote,
  
  faCommentAltQuote,
  

  faUserRobotXmarks,
  

  faArrowDown,
  

  faPersonSwimming,
  
  faSwimmer,
  

  faTRex,
  

  faPretzel,
  

  faQuotes,
  

  faGreaterThan,
  

  faFile,
  

  faBoxOpenFull,
  
  faBoxFull,
  

  faCrab,
  

  faLocationDot,
  
  faMapMarkerAlt,
  

  faDialMedLow,
  

  faCircle0,
  

  faHandshakeAngle,
  
  faHandsHelping,
  

  faAccentGrave,
  

  faPaintRoller,
  

  faTrafficLightStop,
  

  faPhoneSlash,
  

  faStarOfLife,
  

  faPlugCircleXmark,
  

  faHexagonCheck,
  

  faBowlSpoon,
  

  faSuperscript,
  

  faArrowsFromLine,
  

  faFilePpt,
  

  faPinata,
  

  faXmarkLarge,
  

  faCandyBar,
  
  faChocolateBar,
  

  faBell,
  

  faTemperatureFull,
  
  faTemperature4,
  
  faThermometer4,
  
  faThermometerFull,
  

  faBee,
  

  faPodcast,
  

  faCalendarUsers,
  

  faSquareEllipsisVertical,
  

  faClockTwo,
  

  faSquareC,
  

  faSquareH,
  
  faHSquare,
  

  faBookCopy,
  

  faBed,
  

  faPersonFairy,
  

  faMedal,
  

  faTemperatureArrowUp,
  
  faTemperatureUp,
  

  faFileCircleXmark,
  

  faTruckDroplet,
  

  faDrone,
  

  faDiceD20,
  

  faBeerMug,
  
  faBeerFoam,
  

  faFileHeart,
  

  faMessageDots,
  
  faCommentAltDots,
  
  faMessaging,
  

  faHandBackPointLeft,
  

  faArrowsLeftRightToLine,
  

  faBluetooth,
  

  faChartSimpleHorizontal,
  

  faMountainSun,
  

  faCabin,
  

  faCircleX,
  

  faFamilyDress,
  

  faBookOpenReader,
  
  faBookReader,
  

  faMicrophoneStand,
  

  faUserHairMullet,
  
  faBusinessFront,
  
  faPartyBack,
  
  faTrianBalbot,
  

  faPodiumStar,
  

  faUserTieHair,
  

  faHandHoldingHand,
  

  faCar,
  
  faAutomobile,
  

  faBoxBallot,
  

  faCircleS,
  

  faCreditCard,
  
  faCreditCardAlt,
  

  faBowlChopsticks,
  

  faBug,
  

  faHandsHoldingCircle,
  

  faMagnifyingGlassWaveform,
  

  faEnvelopeDot,
  
  faEnvelopeBadge,
  

  faToolbox,
  

  faPersonThroughWindow,
  

  faBells,
  

  faGrid2Plus,
  

  faKitMedical,
  
  faFirstAid,
  

  faChessPawn,
  

  faNfcSlash,
  

  faEllipsis,
  
  faEllipsisH,
  

  faAnchorCircleXmark,
  

  faTentDoublePeak,
  

  faTicketsAirline,
  
  faTicketsPerforatedPlane,
  
  faTicketsPlane,
  

  faArrowRightLong,
  
  faLongArrowRight,
  

  faUserLock,
  

  faThumbsDown,
  

  faGripLines,
  

  faHeadSideCough,
  

  faPanFood,
  

  faPersonDollyEmpty,
  

  faCarTunnel,
  

  faOmega,
  

  faMountains,
  

  faAngleDown,
  

  faAirConditioner,
  

  faSquareQuestion,
  
  faQuestionSquare,
  

  faOilTemperature,
  
  faOilTemp,
  

  faFaceDrooling,
  

  faDisplayCode,
  
  faDesktopCode,
  

  faLessThan,
  

  faArrowDownShortWide,
  
  faSortAmountDesc,
  
  faSortAmountDownAlt,
  

  faFlorinSign,
  

  faChartMixed,
  
  faAnalytics,
  

  faArrowsTurnToDots,
  

  faGrill,
  

  faCircleDown,
  
  faArrowAltCircleDown,
  

  faPersonRunningFast,
  

  faTurnLeftDown,
  

  faWaveTriangle,
  

  faImagePolaroid,
  

  faIndustry,
  

  faBoreHole,
  

  faArrowsRepeat,
  
  faRepeatAlt,
  

  faHorseHead,
  

  faCircleDollar,
  
  faDollarCircle,
  
  faUsdCircle,
  

  faFaceLaughWink,
  
  faLaughWink,
  

  faSignalFair,
  
  faSignal2,
  

  faHouseTree,
  

  faHockeyStickPuck,
  

  faLaptopArrowDown,
  

  faBracketsSquare,
  
  faBrackets,
  

  faFaceSmileHearts,
  

  faSquare8,
  

  faSquareArrowLeft,
  
  faArrowSquareLeft,
  

  faGuitar,
  

  faScreenUsers,
  
  faUsersClass,
  

  faTrashCanSlash,
  
  faTrashAltSlash,
  

  faSun,
  

  faObjectsAlignCenterHorizontal,
  

  faChampagneGlass,
  
  faGlassChampagne,
  

  faTrashUndo,
  
  faTrashArrowTurnLeft,
  

  faRubleSign,
  
  faRouble,
  
  faRub,
  
  faRuble,
  

  faNotes,
  

  faGearCode,
  

  faYenSign,
  
  faCny,
  
  faJpy,
  
  faRmb,
  
  faYen,
  

  faPlaneCircleXmark,
  

  faToilet,
  

  faMars,
  

  faVault,
  

  faArrowTurnLeftUp,
  

  faPersonSimple,
  

  faOilWell,
  

  faGlassWater,
  

  faTrashCanCheck,
  

  faBolt,
  
  faZap,
  

  faMessageSlash,
  
  faCommentAltSlash,
  

  faShieldCat,
  

  faCaravan,
  

  faArrowUpArrowDown,
  
  faSortUpDown,
  

  faHandWave,
  

  faFolderGear,
  
  faFolderCog,
  

  faFolderMedical,
  

  faCameraWebSlash,
  
  faWebcamSlash,
  

  faSaxophoneFire,
  
  faSaxHot,
  

  faFileArrowDown,
  
  faFileDownload,
  

  faCompactDisc,
  

  faToiletPortable,
  

  faBrakeWarning,
  

  faCircleHalf,
  

  faWindsock,
  

  faMound,
  

  faPeoplePants,
  

  faGridRound2Plus,
  

  faHurricane,
  

  faUpload,
  

  faUpFromLine,
  
  faArrowAltFromBottom,
  

  faMoneyCheckDollarPen,
  
  faMoneyCheckEditAlt,
  

  faCodeMerge,
  

  faStop,
  

  faUpLong,
  
  faLongArrowAltUp,
  

  faBlockQuote,
  

  faTruckPickup,
  

  faTowerBroadcast,
  
  faBroadcastTower,
  

  faLoveseat,
  
  faCouchSmall,
  

  faPeopleDress,
  

  faHandHoldingSkull,
  

  faBanana,
  

  faHouseTurret,
  

  faChartScatterBubble,
  

  faCircleVideo,
  
  faVideoCircle,
  

  faGameBoardSimple,
  
  faGameBoardAlt,
  

  faSkull,
  

  faTimelineArrow,
  

  faBowlRice,
  

  faMillSign,
  

  faBalloons,
  

  faChartPieSimpleCircleDollar,
  

  faArrowUpWideShort,
  
  faSortAmountUp,
  

  faUtensils,
  
  faCutlery,
  

  faRotateRight,
  
  faRedoAlt,
  
  faRotateForward,
  

  faArrowRightArrowLeft,
  
  faExchange,
  

  faGolfClub,
  

  faCastle,
  

  faKiwiBird,
  

  faBlanketFire,
  

  faButter,
  

  faHelmetBattle,
  

  faCircleA,
  

  faDiceOne,
  

  faPotato,
  

  faFileMedical,
  

  faPipe,
  

  faMoonOverSun,
  
  faEclipseAlt,
  

  faSeatAirline,
  

  faB,
  

  faSquareDownRight,
  

  faLaptopMedical,
  

  faFlyingDisc,
  

  faCalendarWeek,
  

  faCarCircleBolt,
  

  faVectorCircle,
  

  faHouse,
  
  faHome,
  
  faHomeAlt,
  
  faHomeLgAlt,
  

  faHeartCircleExclamation,
  

  faCourtSport,
  

  faOutdent,
  
  faDedent,
  

  faFaceWorried,
  

  faFaceDotted,
  

  faIdCard,
  
  faDriversLicense,
  

  faBookSkull,
  
  faBookDead,
  

  faAlignCenter,
  

  faFaceMeh,
  
  faMeh,
  

  faCodePullRequestClosed,
  

  faMobile,
  
  faMobileAndroid,
  
  faMobilePhone,
  

  faUserPilot,
  

  faForward,
  

  faLoader,
  

  faGlass,
  

  faFileCircleCheck,
  

  faRotateExclamation,
  

  faScribble,
  

  faCommentsQuestion,
  

  faCommentCaptions,
  

  faEyeDropper,
  
  faEyeDropperEmpty,
  
  faEyedropper,
  

  faCloudBinary,
  

  faOven,
  

  faDeleteLeft,
  
  faBackspace,
  

  faFaceGrin,
  
  faGrin,
  

  faCloudSnow,
  

  faShelves,
  
  faInventory,
  

  faAnglesUpDown,
  

  faDownload,
  

  faArrowsDownToLine,
  

  faTugrikSign,
  

  faBatterySlash,
  

  faClockSixThirty,
  

  faShip,
  

  faGameConsoleHandheld,
  

  faPersonSledding,
  
  faSledding,
  

  faBuildingCircleXmark,
  

  faSprinkler,
  

  faFaceLying,
  

  faCloudRain,
  

  faShovelSnow,
  

  faCableCar,
  
  faTram,
  

  faGarage,
  

  faSwap,
  

  faN,
  

  faPeoplePulling,
  

  faEyeEvil,
  

  faUserHair,
  

  faShuttlecock,
  

  faCalculator,
  

  faImages,
  

  faVenusDouble,
  

  faRightFromLine,
  
  faArrowAltFromLeft,
  

  faPersonHiking,
  
  faHiking,
  

  faClosedCaptioning,
  

  faBadminton,
  

  faHouseMedicalCircleExclamation,
  

  faGearComplexCode,
  

  faCirclePhoneHangup,
  
  faPhoneCircleDown,
  

  faCompressWide,
  

  faFaceSpiralEyes,
  

  faArrowUpFromArc,
  

  faPipeValve,
  

  faClockFiveThirty,
  

  faPersonRifle,
  

  faDiagramNext,
  

  faChartTreeMap,
  

  faTty,
  
  faTeletype,
  

  faLaptopFile,
  

  faFlagUsa,
  

  faCitrus,
  

  faLightsHoliday,
  

  faPipeCollar,
  

  faPersonDressSimple,
  

  faCircleB,
  

  faRightLong,
  
  faLongArrowAltRight,
  

  faLaptopSlash,
  

  faCoin,
  

  faPowerOff,
  

  faTicket,
  

  faSwordLaserAlt,
  

  faEllipsisVertical,
  
  faEllipsisV,
  

  faRouter,
  

  faWandSparkles,
  

  faSquareU,
  

  faPersonPregnant,
  

  faFlask,
  

  faSwordsLaser,
  

  faCentSign,
  

  faHamsa,
  

  faMapPin,
  

  faCroissant,
  

  faNetworkWired,
  

  faFolderTree,
  

  faPeople,
  

  faCauldron,
  

  faSliders,
  
  faSlidersH,
  

  faOutlet,
  

  faFilterList,
  

  faKhanda,
  

  faOlive,
  

  faHoneyPot,
  

  faCoins,
  

  faMountainCity,
  

  faFluxCapacitor,
  

  faBatteryHalf,
  
  faBattery3,
  

  faBoltAuto,
  

  faIndustryWindows,
  
  faIndustryAlt,
  

  faCarMirrors,
  

  faRacquet,
  

  faPiggyBank,
  

  faCarBump,
  

  faSushiRoll,
  
  faMakiRoll,
  
  faMakizushi,
  

  faFaceHeadBandage,
  

  faCircleLocationArrow,
  
  faLocationCircle,
  

  faFolderHeart,
  

  faPlaneUp,
  

  faMobileScreen,
  
  faMobileAndroidAlt,
  

  faBellSchool,
  

  faTemperatureThreeQuarters,
  
  faTemperature3,
  
  faThermometer3,
  
  faThermometerThreeQuarters,
  

  faBoxingGlove,
  
  faGloveBoxing,
  

  faHouseChimneyMedical,
  
  faClinicMedical,
  

  faCards,
  

  faLocationDotSlash,
  
  faMapMarkerAltSlash,
  

  faCaretDown,
  

  faBallot,
  

  faUsbDrive,
  

  faArrowsFromDottedLine,
  

  faKeyboard,
  

  faTimeline,
  

  faS,
  

  faOverline,
  

  faSquareUpLeft,
  

  faBaseballBatBall,
  

  faPenNibSlash,
  

  faListRadio,
  

  faLampStreet,
  

  faCloudSleet,
  

  faFaucet,
  

  faArrowsMaximize,
  
  faExpandArrows,
  

  faCarBolt,
  

  faPallet,
  

  faBackwardStep,
  
  faStepBackward,
  

  faTruckTow,
  

  faInputNumeric,
  

  faClock,
  
  faClockFour,
  

  faDash,
  
  faMinusLarge,
  

  faRaindrops,
  

  faArrowDownArrowUp,
  
  faSortAlt,
  

  faLightSwitchOn,
  

  faSquareRootVariable,
  
  faSquareRootAlt,
  

  faArrowUpFromDottedLine,
  

  faU,
  

  faArrowTurnUp,
  
  faLevelUp,
  

  faMobileSignalOut,
  

  faGripVertical,
  

  faSquareD,
  

  faAxe,
  

  faChessClock,
  

  faPeapod,
  

  faShareAll,
  

  faDisplayMedical,
  
  faDesktopMedical,
  

  faFolderMusic,
  

  faHexagonVerticalNftSlanted,
  

  faTabletScreen,
  
  faTabletAndroidAlt,
  

  faToiletPaperBlank,
  
  faToiletPaperAlt,
  

  faFolderXmark,
  
  faFolderTimes,
  

  faFilmCanister,
  
  faFilmCannister,
  

  faSplit,
  

  faWaveformLines,
  
  faWaveformPath,
  

  faWaterArrowUp,
  
  faWaterRise,
  

  faPlaceOfWorship,
  

  faPersonSkiJumping,
  
  faSkiJump,
  

  faPlugCirclePlus,
  

  faCircle7,
  

  faScannerTouchscreen,
  

  faWaterArrowDown,
  
  faWaterLower,
  

  faFaceSwear,
  

  faRadioTuner,
  
  faRadioAlt,
  

  faFaceSmilePlus,
  
  faSmilePlus,
  

  faMoped,
  

  faTemperatureSnow,
  
  faTemperatureFrigid,
  

  faTabletRugged,
  

  faDistributeSpacingHorizontal,
  

  faEyeDropperFull,
  

  faVials,
  

  faShieldPlus,
  

  faBookFont,
  

  faCartShopping,
  
  faShoppingCart,
  

  faCarGarage,
  

  faPersonMilitaryRifle,
  

  faFlagSwallowtail,
  
  faFlagAlt,
  

  faStarOfDavid,
  

  faMosquito,
  

  faDuck,
  

  faMosque,
  

  faBookHeart,
  

  faDropletSlash,
  
  faTintSlash,
  

  faGear,
  
  faCog,
  

  faCameraSecurity,
  
  faCameraHome,
  

  faUserDoctorHairLong,
  

  faFileCertificate,
  
  faFileAward,
  

  faMessageXmark,
  
  faCommentAltTimes,
  
  faMessageTimes,
  

  faHousePersonReturn,
  
  faHousePersonArrive,
  
  faHouseReturn,
  

  faCartCircleArrowDown,
  

  faFaceSmileHalo,
  

  faCircleBolt,
  

  faPresentationScreen,
  
  faPresentation,
  

  faHandsAslInterpreting,
  
  faAmericanSignLanguageInterpreting,
  
  faAslInterpreting,
  
  faHandsAmericanSignLanguageInterpreting,
  

  faChartUser,
  
  faUserChart,
  

  faBookCircleArrowRight,
  

  faVolumeOff,
  

  faFlaskRoundPoison,
  
  faFlaskPoison,
  

  faFrancSign,
  

  faArrowDownLeft,
  

  faStreetView,
  

  faFontCase,
  

  faPlugCircleCheck,
  

  faArrowLeftLong,
  
  faLongArrowLeft,
  

  faTrashSlash,
  

  faChess,
  

  faGif,
  

  faRightToLine,
  
  faArrowAltToRight,
  

  faFireFlame,
  
  faFlame,
  

  faMinus,
  
  faSubtract,
  

  faCircle5,
  

  faCircleSterling,
  

  faBracketRoundRight,
  

  faVirusSlash,
  

  faDna,
  

  faTurnLeftUp,
  

  faCloudBoltMoon,
  
  faThunderstormMoon,
  

  faCircleUpRight,
  

  faKeyboardDown,
  

  faLeftLong,
  
  faLongArrowAltLeft,
  

  faMoneyBill1,
  
  faMoneyBillAlt,
  

  faCropSimple,
  
  faCropAlt,
  

  faIndianRupeeSign,
  
  faIndianRupee,
  
  faInr,
  

  faListTimeline,
  

  faMoneyBillsSimple,
  
  faMoneyBillsAlt,
  

  faBadgeDollar,
  

  faBallPile,
  

  faFaceSmileUpsideDown,
  

  faChartGantt,
  

  faTrainSubway,
  
  faSubway,
  

  faGameConsoleHandheldCrank,
  

  faSportsball,
  

  faSignalBarsFair,
  
  faSignalAlt2,
  

  faDistributeSpacingVertical,
  

  faCircleLeft,
  
  faArrowAltCircleLeft,
  

  faCowbellCirclePlus,
  
  faCowbellMore,
  

  faPlaneArrival,
  

  faPersonFromPortal,
  
  faPortalExit,
  

  faCalendarPlus,
  

  faPersonSkiingNordic,
  
  faSkiingNordic,
  

  faArrowDownRight,
  

  faGrate,
  

  faTrafficCone,
  

  faHouseMedicalCircleCheck,
  

  faAlarmExclamation,
  

  faTarpDroplet,
  

  faRectangleList,
  
  faListAlt,
  

  faDumbbell,
  

  faFaceGrinSquintTears,
  
  faGrinSquintTears,
  

  faReel,
  

  faHardDrive,
  
  faHdd,
  

  faTvMusic,
  

  faArrowRotateLeft,
  
  faArrowLeftRotate,
  
  faArrowRotateBack,
  
  faArrowRotateBackward,
  
  faUndo,
  

  faCookie,
  

  faOctagonDivide,
  

  faCommentArrowUpRight,
  

  faOctagon,
  

  faBorderBottomRight,
  
  faBorderStyleAlt,
  

  faCarBuilding,
  

  faMessageMusic,
  
  faCommentAltMusic,
  

  faCameraViewfinder,
  
  faScreenshot,
  

  faMoneyBillWheat,
  

  faPlusLarge,
  

  faBellSchoolSlash,
  

  faBowlingBallPin,
  

  faArrowDownAZ,
  
  faSortAlphaAsc,
  
  faSortAlphaDown,
  

  faCheckDouble,
  

  faPeopleDressSimple,
  

  faVestPatches,
  

  faLaptopBinary,
  

  faTent,
  

  faAlien,
  

  faPersonCane,
  

  faCloudRainbow,
  

  faCrosshairs,
  

  faMusicMagnifyingGlass,
  

  faTruck,
  

  faLandmark,
  

  faHouseWindow,
  

  faHoseReel,
  

  faFamilyPants,
  

  faPlateUtensils,
  

  faPrescriptionBottleMedical,
  
  faPrescriptionBottleAlt,
  

  faBraille,
  

  faCalendarClock,
  
  faCalendarTime,
  

  faClockDesk,
  

  faCalendarCheck,
  

  faPlaneProp,
  

  faNfcSignal,
  

  faStarSharpHalfStroke,
  
  faStarSharpHalfAlt,
  

  faWater,
  

  faWaveform,
  

  faTricycleAdult,
  

  faFileEps,
  

  faHandHoldingDroplet,
  
  faHandHoldingWater,
  

  faSquare4,
  

  faBuoyMooring,
  

  faArrowDown19,
  
  faSortNumericAsc,
  
  faSortNumericDown,
  

  faSleigh,
  

  faCarOn,
  

  faMeteor,
  

  faCartArrowUp,
  

  faSquareVirus,
  

  faCamera,
  
  faCameraAlt,
  

  faCameraPolaroid,
  

  faCloudMeatball,
  

  faMessageHeart,
  

  faHammerCrash,
  

  faFishingRod,
  

  faCircleInfo,
  
  faInfoCircle,
  

  faSlashBack,
  

  faUserDoctor,
  
  faUserMd,
  

  faMeterBolt,
  

  faHouseChimneyBlank,
  

  faHouseHeart,
  
  faHomeHeart,
  

  faFileXmark,
  
  faFileTimes,
  

  faMountain,
  

  faHourglass,
  
  faHourglassEmpty,
  

  faNfcTrash,
  

  faTruckFieldUn,
  

  faPuzzlePieceSimple,
  
  faPuzzlePieceAlt,
  

  faTreeDeciduous,
  
  faTreeAlt,
  

  faIndent,
  

  faCommentMusic,
  

  faRugbyBall,
  

  faMessageMedical,
  
  faCommentAltMedical,
  

  faReflectHorizontal,
  

  faParachuteBox,
  

  faCircleNodes,
  

  faCircleWifiCircleWifi,
  
  faCircleWifiGroup,
  

  faArrowTurnDownLeft,
  

  faBorderNone,
  

  faCircleSmall,
  

  faBottleBaby,
  

  faLitecoinSign,
  

  faH6,
  

  faCircleY,
  

  faAppleCore,
  

  faArrowUp91,
  
  faSortNumericUpAlt,
  

  faPersonPinball,
  

  faLungs,
  

  faRibbon,
  

  faLockA,
  

  faArrowRightToCity,
  

  faChartLineDown,
  

  faPaperclip,
  

  faBinRecycle,
  

  faAnglesUp,
  
  faAngleDoubleUp,
  

  faFaceTissue,
  

  faDollyEmpty,
  

  faEnvelope,
  

  faTruckLadder,
  

  faHeadSide,
  

  faCakeCandles,
  
  faBirthdayCake,
  
  faCake,
  

  faSquare1,
  

  faComment,
  

  faEllipsisStrokeVertical,
  
  faEllipsisVAlt,
  

  faBracketsCurly,
  

  faCircleYen,
  

  faCoffeeBean,
  

  faInboxes,
  

  faBookSection,
  
  faBookLaw,
  

  faStretcher,
  

  faTag,
  

  faSteeringWheel,
  

  faPlaneLock,
  

  faTruckFire,
  

  faSatellite,
  

  faChessClockFlip,
  
  faChessClockAlt,
  

  faFilePlusMinus,
  

  faUserVisor,
  

  faLiraSign,
  

  faChild,
  

  faWashingMachine,
  
  faWasher,
  

  faBookSparkles,
  
  faBookSpells,
  

  faSquareArrowDownRight,
  

  faFilmSlash,
  

  faBusSchool,
  

  faClipboardUser,
  

  faFaceFearful,
  

  faLocationExclamation,
  
  faMapMarkerExclamation,
  

  faTableRows,
  
  faRows,
  

  faHatCowboySide,
  

  faDiscDrive,
  

  faPhoneVolume,
  
  faVolumeControlPhone,
  

  faSealQuestion,
  

  faSolarSystem,
  

  faBookTanakh,
  
  faTanakh,
  

  faTableCellsLarge,
  
  faThLarge,
  

  faCloudDrizzle,
  

  faPeoplePantsSimple,
  

  faFlowerTulip,
  

  faBusinessTime,
  
  faBriefcaseClock,
  

  faCommentDollar,
  

  faPersonDress,
  
  faFemale,
  

  faDreidel,
  

  faOtter,
  

  faUserSecret,
  

  faRv,
  

  faClockElevenThirty,
  

  faExpandWide,
  

  faBriefcaseArrowRight,
  

  faSuitcaseMedical,
  
  faMedkit,
  

  faO,
  

  faBookBible,
  
  faBible,
  

  faMessagesQuestion,
  

  faGamepadModern,
  
  faGamepadAlt,
  

  faCurlingStone,
  
  faCurling,
  

  faTankWater,
  

  faImageLandscape,
  
  faLandscape,
  

  faArrowUpToDottedLine,
  

  faSiren,
  

  faFilePdf,
  

  faBagShoppingMinus,
  

  faTableCells,
  
  faTh,
  

  faCircleSort,
  
  faSortCircle,
  

  faUpRightFromSquare,
  
  faExternalLinkAlt,
  

  faCherries,
  

  faFileVideo,
  

  faUsersViewfinder,
  

  faGalaxy,
  

  faJ,
  

  faHighDefinition,
  
  faRectangleHd,
  

  faRestroom,
  

  faDiceD6,
  

  faAlignLeft,
  

  faTemperatureSun,
  
  faTemperatureHot,
  

  faCupStrawSwoosh,
  

  faArrowLeftFromBracket,
  

  faRuler,
  

  faPersonCircleXmark,
  

  faArrowLeft,
  

  faLeafMaple,
  

  faRepublican,
  

  faHandsClapping,
  

  faSnowflakes,
  

  faCircleAmpersand,
  

  faCampfire,
  

  faHandsHolding,
  

  faHeadphones,
  

  faTengeSign,
  
  faTenge,
  

  faSquare7,
  

  faLampFloor,
  

  faSunCloud,
  

  faDivide,
  

  faEnvelopeOpenDollar,
  

  faCubes,
  

  faSquareR,
  

  faBillboard,
  

  fa0,
  

  faShirt,
  
  faTShirt,
  
  faTshirt,
  

  faClockSix,
  

  faHose,
  

  faPhoneXmark,
  

  faGuitars,
  

  faScrollOld,
  

  faQuoteRight,
  
  faQuoteRightAlt,
  

  faPenClipSlash,
  
  faPenAltSlash,
  

  faPoo,
  

  faFaceMelting,
  

  faBookMedical,
  

  faArrowDownSmallBig,
  
  faSortSizeDownAlt,
  

  faGaugeSimple,
  
  faGaugeSimpleMed,
  
  faTachometerAverage,
  

  faTrash,
  

  faHandFingersCrossed,
  

  faCloudWord,
  

  faPhoneArrowDownLeft,
  
  faPhoneArrowDown,
  
  faPhoneIncoming,
  

  faOrnament,
  

  faFileXml,
  

  faCarSideBolt,
  

  faBrightness,
  

  faBoxCircleCheck,
  

  faShowerDown,
  
  faShowerAlt,
  

  faPersonDigging,
  
  faDigging,
  

  faMouseField,
  

  faCoffeePot,
  

  faPenFancy,
  

  faChartKanban,
  

  faHatWizard,
  

  faSquareKanban,
  

  faGarageCar,
  

  faTextWidth,
  

  faPersonBooth,
  

  faBanBug,
  
  faDebug,
  

  faBridgeWater,
  

  faVentDamper,
  

  faMosquitoNet,
  

  faRocketLaunch,
  

  faStarfighterTwinIonEngine,
  
  faStarfighterAlt,
  

  faDiceSix,
  

  faStarfighterTwinIonEngineAdvanced,
  
  faStarfighterAltAdvanced,
  

  faShieldVirus,
  

  faConveyorBeltBoxes,
  
  faConveyorBeltAlt,
  

  faLaptopMobile,
  
  faPhoneLaptop,
  

  faDoorClosed,
  

  faDialLow,
  

  faOctagonExclamation,
  

  faArrowUp19,
  
  faSortNumericUp,
  

  faPipeCircleCheck,
  

  faUserGear,
  
  faUserCog,
  

  faPuzzle,
  

  faSquareHeart,
  
  faHeartSquare,
  

  faSquare5,
  

  faHouseBlank,
  
  faHomeBlank,
  

  faLightbulbSlash,
  

  faBooksMedical,
  

  faKeyboardBrightness,
  

  faHeadSideVirus,
  

  faRectangleCode,
  

  faTrafficLightSlow,
  

  faKiwiFruit,
  

  faPawClaws,
  

  faBorderInner,
  

  faToothbrush,
  

  faCalendarCirclePlus,
  

  faRampLoading,
  

  faNarwhal,
  

  faTableLayout,
  

  faChildReaching,
  

  faCalendarXmark,
  
  faCalendarTimes,
  

  faComputerMouseScrollwheel,
  
  faMouseAlt,
  

  faPhone,
  

  faFaceGrinTears,
  
  faGrinTears,
  

  faSpinnerThird,
  

  faLungsVirus,
  

  faUsersBetweenLines,
  

  faChildDress,
  

  faCardClub,
  

  faRulerTriangle,
  

  faHousePersonLeave,
  
  faHouseLeave,
  
  faHousePersonDepart,
  

  faLeftFromBracket,
  

  faMarsDouble,
  

  faLocationCrosshairs,
  
  faLocation,
  

  faChessQueenPiece,
  
  faChessQueenAlt,
  

  faBiohazard,
  

  faWebAwesome,
  

  faBalloon,
  

  faSensorOn,
  

  faMessagesDollar,
  
  faCommentsAltDollar,
  

  faArrowRotateRight,
  
  faArrowRightRotate,
  
  faArrowRotateForward,
  
  faRedo,
  

  faUserMusic,
  

  faFacePensive,
  

  faHandsPraying,
  
  faPrayingHands,
  

  faHandScissors,
  

  faDrumSteelpan,
  

  faHandPointer,
  

  faBacterium,
  

  faGridDividers,
  

  faHandHoldingDollar,
  
  faHandHoldingUsd,
  

  faCircleEllipsisVertical,
  

  faFaceGrinSquint,
  
  faGrinSquint,
  

  faSquareLeft,
  
  faArrowAltSquareLeft,
  

  faDiamond,
  

  faUserNurseHairLong,
  

  faAlbumCirclePlus,
  

  faScarf,
  

  faPlantWilt,
  

  faCommentDots,
  
  faCommenting,
  

  faCalendarArrowUp,
  
  faCalendarUpload,
  

  faSortUp,
  
  faSortAsc,
  

  faSquareL,
  

  faTennisBall,
  

  faFaceTongueMoney,
  

  faUserPoliceTie,
  

  faFileUser,
  

  faScaleUnbalanced,
  
  faBalanceScaleLeft,
  

  faFaceKissClosedEyes,
  

  faVihara,
  

  faFloppyDisk,
  
  faSave,
  

  faShop,
  
  faStoreAlt,
  

  faPrescription,
  

  faWalker,
  

  faScreencast,
  

  faDiploma,
  
  faScrollRibbon,
  

  faShirtTankTop,
  

  faChessBishopPiece,
  
  faChessBishopAlt,
  

  faFaceFrown,
  
  faFrown,
  

  faDryer,
  

  faWindowMaximize,
  

  faHouseChimney,
  
  faHomeLg,
  

  faArrowUpLeftFromCircle,
  

  faHeartCircleXmark,
  

  faBus,
  

  faPump,
  

  faSignal,
  
  faSignal5,
  
  faSignalPerfect,
  

  faFileCode,
  

  faToiletPaperBlankUnder,
  
  faToiletPaperReverseAlt,
  

  faFloppyDisks,
  

  faTowerObservation,
  

  faPen,
  

  faUserSlash,
  

  faManhole,
  

  faHexagon,
  

  faFileShield,
  

  faPersonMilitaryToPerson,
  

  faAudioDescription,
  

  faArrowsMinimize,
  
  faCompressArrows,
  

  faBootHeeled,
  

  faTicketAirline,
  
  faTicketPerforatedPlane,
  
  faTicketPlane,
  

  faHeat,
  

  faFaceSadCry,
  
  faSadCry,
  

  faEye,
  

  faBusSimple,
  
  faBusAlt,
  

  faChestnut,
  

  faTape,
  

  faBasketShopping,
  
  faShoppingBasket,
  

  faHouseMedicalFlag,
  

  faMobileButton,
  

  faTerminal,
  

  faCircleSortUp,
  
  faSortCircleUp,
  

  faBanSmoking,
  
  faSmokingBan,
  

  faCartFlatbed,
  
  faDollyFlatbed,
  

  faCircleR,
  

  faArrowUpRight,
  

  faDolphin,
  

  faArrowsToLine,
  

  faFaucetDrip,
  

  faBarsProgress,
  
  faTasksAlt,
  

  faNfcSymbol,
  

  faSquareChevronUp,
  
  faChevronSquareUp,
  

  faHouseSignal,
  

  faFaceRaisedEyebrow,
  

  faFaceZipper,
  

  faCardDiamond,
  

  faSquareParking,
  
  faParking,
  

  faUserRobot,
  

  faFaceMehBlank,
  
  faMehBlank,
  

  faForwardFast,
  
  faFastForward,
  

  faWineGlass,
  

  faTags,
  

  faArrowTurnRight,
  

  faHeadSideMedical,
  

  faFileCircleMinus,
  

  faUserTieHairLong,
  

  faTeethOpen,
  

  faCommentMedical,
  

  faPanorama,
  

  faClipboardQuestion,
  

  faCartCircleCheck,
  

  faRoute,
  

  faTruckField,
  

  faBasketShoppingPlus,
  

  faUserCrown,
  

  faFaceClouds,
  

  faAnchorCircleExclamation,
  

  faFiles,
  

  faCircleCaretLeft,
  
  faCaretCircleLeft,
  

  faTrashXmark,
  

  faCat,
  

  faTruckFront,
  

  faSquareQuarters,
  

  faFileDoc,
  

  faArrowDownFromDottedLine,
  

  faPhoneFlip,
  
  faPhoneAlt,
  

  faBridge,
  

  faHatCowboy,
  

  faWarehouseFull,
  
  faWarehouseAlt,
  

  faCodeBranch,
  

  faObjectSubtract,
  

  faHouseWater,
  
  faHouseFlood,
  

  faPopcorn,
  

  faFaceHandOverMouth,
  

  faCircleK,
  

  faArrowRightFromArc,
  

  faTypewriter,
  

  faCanFood,
  

  faBorderCenterH,
  

  faBookBookmark,
  

  faHandshakeSlash,
  

  faPlaneDeparture,
  

  faBuoy,
  

  faImageUser,
  

  faTicketsPerforated,
  

  faCircleQuestion,
  
  faQuestionCircle,
  

  faFileImage,
  

  faRupeeSign,
  
  faRupee,
  

  faDiagramNested,
  

  faVectorPolygon,
  

  faBugs,
  

  faWrench,
  

  faArrowTurnLeft,
  

  faTransporter6,
  

  faUtilityPole,
  

  faBurger,
  
  faHamburger,
  

  faStaff,
  

  faChartRadar,
  

  faLockHashtag,
  

  faTurnDownLeft,
  

  faFileAudio,
  

  faPool8Ball,
  

  faTruckClock,
  
  faShippingTimed,
  

  faCartCirclePlus,
  

  faClipboardCheck,
  

  faFlatbreadStuffed,
  

  faOctagonCheck,
  

  faWallet,
  

  faUsersRays,
  

  faVolumeHigh,
  
  faVolumeUp,
  

  faCloudSlash,
  

  faInboxOut,
  
  faInboxArrowUp,
  

  faClockOneThirty,
  

  faMobileScreenButton,
  
  faMobileAlt,
  

  faSlider,
  

  faCircleUp,
  
  faArrowAltCircleUp,
  

  faBadgeCheck,
  

  faSatelliteDish,
  

  faForkKnife,
  
  faUtensilsAlt,
  

  faBasketball,
  
  faBasketballBall,
  

  faTrademark,
  

  faCircleDashed,
  

  faPlaneSlash,
  

  faInterrobang,
  

  faUserAstronaut,
  

  faRecycle,
  

  faBackwardFast,
  
  faFastBackward,
  

  faSword,
  

  faCartCircleExclamation,
  

  faLeftToBracket,
  

  faCircle,
  

  faSquarePollHorizontal,
  
  faPollH,
  

  faHouseFloodWaterCircleArrowRight,
  

  faMoneyBillTrendUp,
  

  faMoneyBillTransfer,
  

  faElevator,
  

  faTally3,
  

  faHouseChimneyHeart,
  

  faTableTree,
  

  faLockOpen,
  

  faSolarPanel,
  

  faShieldDog,
  

  faShutters,
  

  faBitcoinSign,
  

  faArrowDownTriangleSquare,
  
  faSortShapesDown,
  

  faCube,
  

  faHandsHoldingDollar,
  
  faHandsUsd,
  

  faToiletPaperXmark,
  

  faWifiSlash,
  

  faSquareInfo,
  
  faInfoSquare,
  

  faTemperatureQuarter,
  
  faTemperature1,
  
  faThermometer1,
  
  faThermometerQuarter,
  

  faR,
  

  faLockKeyhole,
  
  faLockAlt,
  

  faDiamondHalf,
  

  faKitchenSet,
  

  faAppleWhole,
  
  faAppleAlt,
  

  faCircleEuro,
  

  faToiletPaperSlash,
  

  faRabbit,
  

  faValueAbsolute,
  

  faAngel,
  

  faFolders,
  

  faGaugeCirclePlus,
  

  faCirclePause,
  
  faPauseCircle,
  

  faBottleWater,
  

  faFaceSurprise,
  
  faSurprise,
  

  faArrowRightToArc,
  

  faUserShakespeare,
  

  faMartiniGlassCitrus,
  
  faCocktail,
  

  faBracketsRound,
  
  faParentheses,
  

  faArrowLeftLongToLine,
  

  faPawSimple,
  
  faPawAlt,
  

  faHouseCrack,
  

  faLeftToLine,
  
  faArrowAltToLeft,
  

  faHexagonMinus,
  
  faMinusHexagon,
  

  faDumpsterFire,
  

  faCircleArrowDownLeft,
  

  faHouseUser,
  
  faHomeUser,
  

  faMarsAndVenus,
  

  faFileChartPie,
  

  faHeart,
  

  faFaceNauseated,
  

  faBookCircleArrowUp,
  

  faShirtRunning,
  

  faSignPostsWrench,
  

  faGridRound4,
  

  faFaceThermometer,
  

  faPlugCircleBolt,
  

  faTrophyStar,
  
  faTrophyAlt,
  

  faCircleThreeQuarters,
  

  faArrowsToEye,
  

  faScrewdriverWrench,
  
  faTools,
  

  faHandHorns,
  

  faFaceSleepy,
  

  faTarp,
  

  faHammerBrush,
  

  faClockNine,
  

  faHandsHoldingHeart,
  
  faHandsHeart,
  

  faBasketShoppingSimple,
  
  faShoppingBasketAlt,
  

  faH,
  

  faLeftFromLine,
  
  faArrowAltFromRight,
  

  faCupStraw,
  

  faMessageSmile,
  
  faCommentAltSmile,
  

  faSpaceStationMoon,
  

  faMelonSlice,
  

  faPersonCircleQuestion,
  

  faCashRegister,
  

  faOctagonPlus,
  
  faPlusOctagon,
  

  faSignsPost,
  
  faMapSigns,
  

  faArrowRight,
  

  faSignatureLock,
  

  faTickets,
  

  faMaskVentilator,
  

  faSendBack,
  

  faCalendarArrowDown,
  
  faCalendarDownload,
  

  faChartLine,
  
  faLineChart,
  

  faFrenchFries,
  

  faObjectGroup,
  

  faRingsWedding,
  

  faBreadLoaf,
  

  faFaceRollingEyes,
  
  faMehRollingEyes,
  

  faHexagonVerticalNft,
  

  faUserCowboy,
  

  faSeal,
  

  faPlaneCircleCheck,
  

  faCircleRight,
  
  faArrowAltCircleRight,
  

  faEject,
  

  faStarship,
  

  faSimCards,
  

  faCommentCode,
  

  faHelmetSafety,
  
  faHardHat,
  
  faHatHard,
  

  faToiletPaper,
  

  faKaaba,
  

  faSquareList,
  

  faLocationPin,
  
  faMapMarker,
  

  faTelescope,
  

  faObjectExclude,
  

  faPoop,
  

  faHandPointRibbon,
  

  faAlien8bit,
  
  faAlienMonster,
  

  faCircleArrowDownRight,
  

  faFaceDisguise,
  

  faObjectUngroup,
  

  faFaceGrinBeam,
  
  faGrinBeam,
  

  faBuildingFlag,
  

  faCircleQ,
  

  faFishFins,
  

  faFileContract,
  

  faFileExcel,
  

  faFileXls,
  

  faSackXmark,
  

  faClockEight,
  

  faBoltLightning,
  

  faChartPie,
  
  faPieChart,
  

  faPersonCirclePlus,
  

  faTaxi,
  
  faCab,
  

  faRoad,
  

  faBedBunk,
  

  faLeaf,
  

  faF,
  

  faCloudPlus,
  

  faAustralSign,
  

  faChessKnightPiece,
  
  faChessKnightAlt,
  

  faPie,
  

  faSquareEllipsis,
  

  faVirusCovid,
  

  faImagePolaroidUser,
  

  faWonSign,
  
  faKrw,
  
  faWon,
  

  faImagesUser,
  

  faCubesStacked,
  

  faArrowUpRightFromSquare,
  
  faExternalLink,
  

  faMagnifyingGlassChart,
  

  faMobileNotch,
  
  faMobileIphone,
  

  faClothesHanger,
  

  faBuildingCircleExclamation,
  

  faMoonStars,
  

  faWhiskeyGlass,
  
  faGlassWhiskey,
  

  faCode,
  

  faFileExclamation,
  

  faStarHalfStroke,
  
  faStarHalfAlt,
  

  faMoneyCheck,
  

  faPuzzlePiece,
  

  faTrainTrack,
  

  faArrowUpSmallBig,
  
  faSortSizeUpAlt,
  

  faHandHoldingHeart,
  

  faHouseChimneyUser,
  

  faDryerHeat,
  
  faDryerAlt,
  

  faUpDownLeftRight,
  
  faArrowsAlt,
  

  faToggleLargeOn,
  

  faFileSignature,
  

  faQuestion,
  

  faUserNurseHair,
  

  faClipboardPrescription,
  

  faCirclePhone,
  
  faPhoneCircle,
  

  faSquareG,
  

  faFilter,
  

  faDownToLine,
  
  faArrowAltToBottom,
  

  faRouteHighway,
  

  faMemoCircleCheck,
  

  faPodium,
  

  faDagger,
  

  faFaceKissWinkHeart,
  
  faKissWinkHeart,
  

  faWheatAwnSlash,
  

  faLanguage,
  

  faBreadSlice,
  

  faVectorSquare,
  

  faMoneyCheckDollar,
  
  faMoneyCheckAlt,
  

  faDiceD4,
  

  faPersonDressBurst,
  

  faChartNetwork,
  

  faWifiExclamation,
  

  faKidneys,
  

  faFaceParty,
  

  faSparkle,
  

  faChartWaterfall,
  

  faListOl,
  
  faList12,
  
  faListNumeric,
  

  faSort,
  
  faUnsorted,
  

  faLocust,
  

  faFilterCircleXmark,
  

  faToiletPaperCheck,
  

  faCircleI,
  

  faUserGroupCrown,
  
  faUsersCrown,
  

  faCircleArrowRight,
  
  faArrowCircleRight,
  

  faBreadSliceButter,
  

  faMoonCloud,
  

  faArrowTurnDownRight,
  

  faGuitarElectric,
  

  faRectangleAd,
  
  faAd,
  

  faNewspaper,
  

  faStomach,
  

  faSnowflake,
  

  faBroomWide,
  

  faP,
  

  faTrashCanClock,
  

  faSausage,
  

  faFeatherPointed,
  
  faFeatherAlt,
  

  faMace,
  

  faTemperatureArrowDown,
  
  faTemperatureDown,
  

  faBookmarkSlash,
  

  faA,
  

  faRoadLock,
  

  faInputPipe,
  

  faDeer,
  

  faPersonSkiing,
  
  faSkiing,
  

  faZ,
  

  faPinball,
  

  faFaceConfused,
  

  faDemocrat,
  

  faLinkSimpleSlash,
  

  faPickaxe,
  

  faTicketsSimple,
  

  faCommentsDollar,
  

  faFaceHushed,
  

  faPersonSnowmobiling,
  
  faSnowmobile,
  

  faChurch,
  

  faTableCellsColumnLock,
  

  faCalendarLinesPen,
  

  faGlassCitrus,
  

  faItalic,
  

  faCediSign,
  

  faCouch,
  

  faMartiniGlassEmpty,
  
  faGlassMartini,
  

  faMemo,
  

  faSquare,
  

  faCommentCheck,
  

  faHeartHalf,
  

  faTicketPerforated,
  

  faFileZipper,
  
  faFileArchive,
  

  faHouseChimneyCrack,
  
  faHouseDamage,
  

  faHeartCircleCheck,
  

  faArchway,
  

  faClockTwoThirty,
  

  faHashtagLock,
  

  faBorderOuter,
  

  faArrowsToDot,
  

  faRestroomSimple,
  

  faLayerGroup,
  

  faEnvelopeCircleCheck,
  

  faWave,
  

  faCommentMiddleTop,
  

  faGridRound2,
  

  faVirus,
  

  faBookAtlas,
  
  faAtlas,
  

  faTruckPlow,
  

  faShieldHalved,
  
  faShieldAlt,
  

  faFaceConfounded,
  

  faPalletBox,
  

  faGreaterThanEqual,
  

  faSquareArrowUp,
  
  faArrowSquareUp,
  

  faBurgerSoda,
  

  faCabinetFiling,
  

  faListDropdown,
  

  faWatchCalculator,
  

  faWatchApple,
  

  faCruzeiroSign,
  

  faShelvesEmpty,
  

  faGarageOpen,
  

  faMagnifyingGlassArrowsRotate,
  

  faFireExtinguisher,
  

  faArrowsToDottedLine,
  

  faCircleBookOpen,
  
  faBookCircle,
  

  faArrowsRotate,
  
  faRefresh,
  
  faSync,
  

  faBorderTop,
  

  faMugTea,
  

  faBurgerFries,
  

  faGuaraniSign,
  

  faGingerbreadMan,
  

  faCommentQuestion,
  

  faAlicorn,
  

  faAlarmPlus,
  

  faMattressPillow,
  

  faMemoPad,
  

  faRabbitRunning,
  
  faRabbitFast,
  

  faHandshakeSimpleSlash,
  
  faHandshakeAltSlash,
  

  faCatSpace,
  

  faDrawCircle,
  

  faEnvelopeOpen,
  

  faListTree,
  

  faLollipop,
  
  faLollypop,
  

  faSignalStrong,
  
  faSignal4,
  

  faUserLargeSlash,
  
  faUserAltSlash,
  

  faChalkboard,
  
  faBlackboard,
  

  faMeterDroplet,
  

  faChildren,
  

  faWreath,
  

  faCloudArrowDown,
  
  faCloudDownload,
  
  faCloudDownloadAlt,
  

  faHouseLock,
  

  faArrowsLeftRight,
  
  faArrowsH,
  

  faObjectsAlignCenterVertical,
  

  faSquareDown,
  
  faArrowAltSquareDown,
  

  faFilePowerpoint,
  

  faFileWord,
  

  faLeft,
  
  faArrowAltLeft,
  

  faWavesSine,
  

  faCircle6,
  

  faChessKingPiece,
  
  faChessKingAlt,
  

  faTombstoneBlank,
  
  faTombstoneAlt,
  

  faFaceSmileWink,
  
  faSmileWink,
  

  faProjector,
  

  faText,
  

  faCircleDownLeft,
  

  faWatch,
  

  faTextSlash,
  
  faRemoveFormat,
  

  faChartLineUpDown,
  

  faCloudBolt,
  
  faThunderstorm,
  

  faMessageCheck,
  
  faCommentAltCheck,
  

  faHandHoldingSeedling,
  

  faPhoneArrowRight,
  

  faSquareDollar,
  
  faDollarSquare,
  
  faUsdSquare,
  

  faArrowDownWideShort,
  
  faSortAmountAsc,
  
  faSortAmountDown,
  

  faCandyCane,
  

  faSquare9,
  

  faBowlFood,
  

  faGroupArrowsRotate,
  

  faFileJpg,
  

  faFlashlight,
  

  faCircleArrowLeft,
  
  faArrowCircleLeft,
  

  faBoxesPacking,
  

  faLeftRight,
  
  faArrowsAltH,
  

  faClockSeven,
  

  faSeedling,
  
  faSprout,
  

  faArrowsDownToPeople,
  

  faBullseyeArrow,
  

  faFerry,
  

  faTrianglePersonDigging,
  
  faConstruction,
  

  faCircleEnvelope,
  
  faEnvelopeCircle,
  

  faInboxFull,
  

  faPig,
  

  faVest,
  

  faArrowsTurnRight,
  

  faObjectsAlignRight,
  

  faChartMixedUpCircleCurrency,
  

  faTransporter4,
  

  faPalette,
  

  faCloudArrowUp,
  
  faCloudUpload,
  
  faCloudUploadAlt,
  

  faFontAwesome,
  
  faFontAwesomeFlag,
  
  faFontAwesomeLogoFull,
  

  faGasPumpSlash,
  

  faCrutch,
  

  faSquareALock,
  

  faUserVneckHairLong,
  

  faCircleCaretUp,
  
  faCaretCircleUp,
  

  faUfoBeam,
  

  faSmog,
  

  faBlindsRaised,
  

  faMoneyBills,
  

  faFaceTired,
  
  faTired,
  

  faHouseLaptop,
  
  faLaptopHouse,
  

  faBurst,
  

  faIntegral,
  

  faDiamondTurnRight,
  
  faDirections,
  

  faSubscript,
  

  faGlobeSnow,
  

  faScaleUnbalancedFlip,
  
  faBalanceScaleRight,
  

  faAddressCard,
  
  faContactCard,
  
  faVcard,
  

  faTrashCanPlus,
  

  faRegistered,
  

  faGaugeLow,
  
  faTachometerAltSlow,
  

  faBomb,
  

  faTemperatureEmpty,
  
  faTemperature0,
  
  faThermometer0,
  
  faThermometerEmpty,
  

  faHillAvalanche,
  

  faPlaneEngines,
  
  faPlaneAlt,
  

  faClockEightThirty,
  

  faPause,
  

  faLocationPinLock,
  

  faStrawberry,
  

  faArrowLeftFromLine,
  
  faArrowFromRight,
  

  faSpa,
  

  faScroll,
  

  faSquareF,
  

  faBoxOpen,
  

  faKerning,
  

  faLightEmergencyOn,
  

  faSquareArrowUpRight,
  
  faExternalLinkSquare,
  

  faBanjo,
  

  faFileImport,
  
  faArrowRightToFile,
  

  faCommentPen,
  
  faCommentEdit,
  

  faCircleArrowDown,
  
  faArrowCircleDown,
  

  faCameraRetro,
  

  faFilterCircleDollar,
  
  faFunnelDollar,
  

  faBinaryLock,
  

  faStarShooting,
  

  faPersonSkating,
  
  faSkating,
  

  faSuitcase,
  

  faReplyAll,
  
  faMailReplyAll,
  

  faCrystalBall,
  

  faCertificate,
  

  faTentArrowDownToLine,
  

  faArrowDownLong,
  
  faLongArrowDown,
  

  faUpToBracket,
  

  faUserTie,
  

  faSquarePersonConfined,
  

  faViruses,
  

  faBatteryExclamation,
  

  faSterlingSign,
  
  faGbp,
  
  faPoundSign,
  

  faSmoke,
  

  faMaskSnorkel,
  

  faImageSlash,
  

  faPersonWalkingDashedLineArrowRight,
  

  faStocking,
  

  faTeddyBear,
  

  faVolcano,
  

  faLariSign,
  

  faUserPolice,
  

  faCircleChevronUp,
  
  faChevronCircleUp,
  

  faUpRight,
  

  faFileMagnifyingGlass,
  
  faFileSearch,
  

  faGearComplex,
  

  faUniversalAccess,
  

  faAperture,
  

  faHelicopterSymbol,
  

  faTreeLarge,
  

  faBatteryBolt,
  

  faSquareArrowDownLeft,
  

  faFaceLaughBeam,
  
  faLaughBeam,
  

  faBinBottles,
  

  faMarker,
  

  faKazoo,
  

  faIdBadge,
  

  faNeuter,
  

  faPersonShelter,
  

  faIcicles,
  

  faCarWrench,
  
  faCarMechanic,
  

  faChopsticks,
  

  faCalendarCircleMinus,
  

  faPlateWheat,
  

  faCompassDrafting,
  
  faDraftingCompass,
  

  faArrowUpToBracket,
  

  faPhoneRotary,
  

  faHeadSideHeadphones,
  

  faCircleStop,
  
  faStopCircle,
  

  faBat,
  

  faMoneySimpleFromBracket,
  

  faHandHoldingCircleDollar,
  

  faSquareDashedCirclePlus,
  

  faCircleCheck,
  
  faCheckCircle,
  

  faChair,
  

  faEuroSign,
  
  faEur,
  
  faEuro,
  

  faEthernet,
  

  fa360Degrees,
  

  faTablets,
  

  faLocationArrowUp,
  

  faArrowUpRightAndArrowDownLeftFromCenter,
  

  faCirclePlay,
  
  faPlayCircle,
  

  faCannabis,
  

  faTruckRampCouch,
  
  faTruckCouch,
  

  faAnglesRight,
  
  faAngleDoubleRight,
  

  faSnowplow,
  

  faAlignSlash,
  

  faOctagonXmark,
  
  faTimesOctagon,
  
  faXmarkOctagon,
  

  faMonument,
  

  faRefrigerator,
  

  faMinimize,
  
  faCompressArrowsAlt,
  

  faSmoking,
  

  faDolly,
  
  faDollyBox,
  

  faGem,
  

  faHandshake,
  

  faHeadSideMask,
  

  faLemon,
  

  faTick,
  

  faSquareA,
  

  faTableColumns,
  
  faColumns,
  

  faRotateLeft,
  
  faRotateBack,
  
  faRotateBackward,
  
  faUndoAlt,
  

  faMartiniGlass,
  
  faGlassMartiniAlt,
  

  faBracketSquareRight,
  

  faArrowUpFromGroundWater,
  

  faForklift,
  

  faSquareNfi,
  

  faHouseTsunami,
  

  faFolderClosed,
  

  faCircleSortDown,
  
  faSortCircleDown,
  

  faScrewdriver,
  

  faShieldXmark,
  
  faShieldTimes,
  

  faCaretUp,
  

  faDownFromLine,
  
  faArrowAltFromTop,
  

  faSquareRing,
  

  fa3,
  

  faFileZip,
  

  faCow,
  

  faMicrophone,
  

  faWindowFrame,
  

  faImage,
  

  faFloppyDiskPen,
  

  faBucket,
  

  faFrog,
  

  faMessageLines,
  
  faCommentAltLines,
  

  faCloudExclamation,
  

  faToriiGate,
  

  faPanelEws,
  

  faSubtitles,
  

  faSunrise,
  

  faHockeyMask,
  

  faLacrosseStick,
  

  faCustard,
  

  faMistletoe,
  

  faBowlScoops,
  

  faSquarePlus,
  
  faPlusSquare,
  

  faCircleV,
  

  faFileBinary,
  

  faNfcMagnifyingGlass,
  

  faWindowRestore,
  

  faSailboat,
  

  faCassetteBetamax,
  
  faBetamax,
  

  faCrow,
  

  fa00,
  

  faHexagonDivide,
  

  faUserUnlock,
  

  faSensorFire,
  

  faFaceExhaling,
  

  faTrafficLightGo,
  

  faEyeLowVision,
  
  faLowVision,
  

  faUpFromDottedLine,
  

  faTrain,
  

  faLessThanEqual,
  

  faHandsBubbles,
  
  faHandsWash,
  

  faChartBar,
  
  faBarChart,
  

  faCloudShowersWater,
  

  faSquareCaretUp,
  
  faCaretSquareUp,
  

  faTally,
  
  faTally5,
  

  faGridRound5,
  

  faHandBackFist,
  
  faHandRock,
  

  faMarsStrokeRight,
  
  faMarsStrokeH,
  

  faPersonChalkboard,
  

  faRightLongToLine,
  

  faSwapArrows,
  

  faGrid5,
  

  faArrowDownToLine,
  
  faArrowToBottom,
  

  faRepeat1,
  

  faBuildingCircleCheck,
  

  faBurgerCheese,
  
  faCheeseburger,
  

  faChessBoard,
  

  faBringFront,
  

  faUpLeft,
  

  faSquareQuote,
  

  faHoodCloak,
  

  faGlasses,
  

  faPaintbrushFine,
  
  faPaintBrushAlt,
  
  faPaintBrushFine,
  
  faPaintbrushAlt,
  

  faChessQueen,
  

  faTreasureChest,
  

  faMessageArrowUpRight,
  

  faFileSlash,
  

  faCoinFront,
  

  faGaugeCircleBolt,
  

  faTransporter5,
  

  faVolume,
  
  faVolumeMedium,
  

  faDiceTwo,
  

  faGift,
  

  faMemoCircleInfo,
  

  faMailboxFlagUp,
  

  faFaceDowncastSweat,
  

  faCarBattery,
  
  faBatteryCar,
  

  faDogLeashed,
  

  faMugHot,
  

  faArrowDownSquareTriangle,
  
  faSortShapesDownAlt,
  

  faSquarePollVertical,
  
  faPoll,
  

  faJedi,
  

  faTilde,
  

  faMapLocationDot,
  
  faMapMarkedAlt,
  

  faBorderTopLeft,
  
  faBorderStyle,
  

  faNotEqual,
  

  faMoneyCheckPen,
  
  faMoneyCheckEdit,
  

  faManatSign,
  

  faSquareK,
  

  faCircleDownRight,
  

  faEngineWarning,
  
  faEngineExclamation,
  

  faTransporter3,
  

  faBuildingNgo,
  

  faAnchorLock,
  

  faBold,
  

  faStroopwafel,
  

  faSignature,
  

  faCaduceus,
  

  faSquareO,
  

  faBinarySlash,
  

  faUserPen,
  
  faUserEdit,
  

  faPrescriptionBottlePill,
  

  faUnderline,
  

  faRectangleHistoryCirclePlus,
  

  faUmbrellaSimple,
  
  faUmbrellaAlt,
  

  faBath,
  
  faBathtub,
  

  faMessages,
  
  faCommentsAlt,
  

  faWifi,
  
  faWifi3,
  
  faWifiStrong,
  

  faFileArrowUp,
  
  faFileUpload,
  

  faHouseCircleExclamation,
  

  faClipboard,
  

  faHexagonPlus,
  
  faPlusHexagon,
  

  faTaco,
  

  faChampagneGlasses,
  
  faGlassCheers,
  

  faMarsStrokeUp,
  
  faMarsStrokeV,
  

  faUserMinus,
  

  faSignalSlash,
  

  faRoadCircleXmark,
  

  faStoreSlash,
  

  faH4,
  

  faBadgerHoney,
  

  faHeadset,
  

  faColonSign,
  

  faUnlock,
  

  faSheep,
  

  faCitrusSlice,
  

  faPepperHot,
  

  faClockTwelve,
  

  faMicrophoneLines,
  
  faMicrophoneAlt,
  

  faSignalBarsWeak,
  
  faSignalAlt1,
  

  faCity,
  

  faCodeFork,
  

  faHeartCirclePlus,
  

  faFlatbread,
  

  faBowlHot,
  
  faSoup,
  

  faCandy,
  

  faAlbumCollectionCircleUser,
  

  faFolderOpen,
  

  faFaceLaugh,
  
  faLaugh,
  

  faChartPieSimple,
  
  faChartPieAlt,
  

  faShirtLongSleeve,
  

  faShuttleSpace,
  
  faSpaceShuttle,
  

  faHouseDay,
  

  faBedPulse,
  
  faProcedures,
  

  faFire,
  

  faStars,
  

  faCircleZ,
  

  faDownToBracket,
  

  faSignalStream,
  

  faL,
  

  faPersonWalking,
  
  faWalking,
  

  faRectangleVertical,
  
  faRectanglePortrait,
  

  faToggleOn,
  

  faCircleArrowUp,
  
  faArrowCircleUp,
  

  faBedEmpty,
  

  faPianoKeyboard,
  

  faUserPilotTie,
  

  faWheelchair,
  

  faTriangleInstrument,
  
  faTriangleMusic,
  

  faCommentPlus,
  

  faSquareChevronDown,
  
  faChevronSquareDown,
  

  faObjectsColumn,
  

  faViolin,
  

  faBurrito,
  

  faCommentMinus,
  

  faBinaryCircleCheck,
  

  faPanelFire,
  

  faBoltSlash,
  

  faCodeSimple,
  

  faFaceLaughSquint,
  
  faLaughSquint,
  

  faPalletBoxes,
  
  faPaletteBoxes,
  
  faPalletAlt,
  

  faBarsSort,
  

  faChessKnight,
  

  faFarm,
  
  faBarnSilo,
  

  faSquareT,
  

  faTvRetro,
  

  faScannerImage,
  

  faSnooze,
  
  faZzz,
  

  faBlockQuestion,
  

  faPlayPause,
  

  faLayerPlus,
  
  faLayerGroupPlus,
  

  faArrowUpAZ,
  
  faSortAlphaUp,
  

  faUserGroup,
  
  faUserFriends,
  

  faBooks,
  

  faStarExclamation,
  

  faArrowUpToArc,
  

  faWeightScale,
  
  faWeight,
  

  faHandBackPointUp,
  

  faFlowerDaffodil,
  

  faCalendarRange,
  

  faTableCellsLock,
  

  faFilePrescription,
  

  faXmarksLines,
  

  faWeightHanging,
  

  faCrown,
  

  faLeftLongToLine,
  

  faMicrochip,
  

  faTemperatureHigh,
  

  faTrashCanXmark,
  

  faFolderUser,
  

  faPeopleCarryBox,
  
  faPeopleCarry,
  

  faClockTenThirty,
  

  faCloudsMoon,
  

  faCircle8,
  

  faHeartPulse,
  
  faHeartbeat,
  

  faInboxIn,
  
  faInboxArrowDown,
  

  faPassport,
  

  faVenus,
  

  faCommentSmile,
  

  faSquareRight,
  
  faArrowAltSquareRight,
  

  faVideoPlus,
  

  faRightToBracket,
  
  faSignInAlt,
  

  faFireHydrant,
  

  faFilePng,
  

  faApostrophe,
  

  faPersonBreastfeeding,
  

  faGaugeMax,
  
  faTachometerAltFastest,
  

  faBuildingWheat,
  

  faCircleE,
  

  faChartPieSimpleCircleCurrency,
  

  faLayerMinus,
  
  faLayerGroupMinus,
  

  faLightbulbExclamation,
  

  faMessageArrowUp,
  
  faCommentAltArrowUp,
  

  faPaperPlaneTop,
  
  faPaperPlaneAlt,
  
  faSend,
  

  faPersonSeatReclined,
  

  faHourglassClock,
  

  faBlenderPhone,
  

  faUserHairBuns,
  

  faHourglassStart,
  
  faHourglass1,
  

  faFamily,
  

  faShopLock,
  

  faIntersection,
  

  faVirusCovidSlash,
  

  faServer,
  

  faBadgeSheriff,
  

  faGridRound,
  

  faSlidersSimple,
  

  faWindTurbine,
  

  faShopSlash,
  
  faStoreAltSlash,
  

  faSquare6,
  

  faPersonSkiLift,
  
  faSkiLift,
  

  faNfcLock,
  

  faCannon,
  

  faFilesMedical,
  

  faPegasus,
  

  faArrowRightToBracket,
  
  faSignIn,
  

  faComputerMouse,
  
  faMouse,
  

  faCalendarStar,
  

  faPersonToPortal,
  
  faPortalEnter,
  

  faSlash,
  

  faLasso,
  

  faCircleQuarterStroke,
  

  faLocationXmark,
  
  faMapMarkerTimes,
  
  faMapMarkerXmark,
  

  faSpellCheck,
  

  faCoffinCross,
  

  faGoalNet,
  

  faXRay,
  

  faArrowDownFromBracket,
  

  faDiagramVenn,
  

  faFileLock,
  

  faEar,
  

  faPlaneCircleExclamation,
  

  faWindow,
  

  faFaceAstonished,
  

  faPipeSmoking,
  

  faFileInvoiceDollar,
  

  faScalpelLineDashed,
  
  faScalpelPath,
  

  faHandsBound,
  

  faClockThree,
  

  faSpider,
  

  faBracketCurlyRight,
  

  faFileDashedLine,
  
  faPageBreak,
  

  faArrowUpFromSquare,
  

  faBinBottlesRecycle,
  

  faGripLinesVertical,
  

  faMobileRetro,
  

  faPersonRunning,
  
  faRunning,
  

  faShuffle,
  
  faRandom,
  

  faPeanuts,
  

  faTransporter1,
  

  faArrowUpLeft,
  

  faSquarePhoneHangup,
  
  faPhoneSquareDown,
  

  faShieldSlash,
  

  faCircleU,
  

  faGaugeSimpleMax,
  
  faTachometerFastest,
  

  faPlaneTail,
  

  faShapes,
  
  faTriangleCircleSquare,
  

  faChargingStation,
  

  faMaximize,
  
  faExpandArrowsAlt,
  

  faLightbulbGear,
  

  faCactus,
  

  faSignalBarsGood,
  
  faSignalAlt3,
  

  faClockFourThirty,
  

  faArrowPointer,
  
  faMousePointer,
  

  faClockSevenThirty,
  

  faVenusMars,
  

  faBox,
  

  faPageCaretDown,
  
  faFileCaretDown,
  

  faCross,
  

  faRepeat,
  

  faDialMin,
  

  faStar,
  

  faDiamondExclamation,
  

  faSignalBars,
  
  faSignalAlt,
  
  faSignalAlt4,
  
  faSignalBarsStrong,
  

  faSprayCanSparkles,
  
  faAirFreshener,
  

  faCommentText,
  

  faSunDust,
  

  faCameraRotate,
  

  faUniformMartialArts,
  

  faFaceWeary,
  

  faEggFried,
  

  faCircleBookmark,
  
  faBookmarkCircle,
  

  faBellExclamation,
  

  faBan,
  
  faCancel,
  

  faScalpel,
  

  faPersonCircleMinus,
  

  faCircleThreeQuartersStroke,
  

  faHouseFlag,
  

  faChartArea,
  
  faAreaChart,
  

  faMoneyBillWave,
  

  faPizzaSlice,
  

  faTruckBolt,
  

  faSignPosts,
  

  faMailbox,
  

  faChartLineUp,
  

  faBuildingLock,
  

  faRectangleHistoryCircleUser,
  

  faPersonDressFairy,
  

  faTabletButton,
  

  faC,
  

  faLocationArrow,
  

  faMessagePlus,
  
  faCommentAltPlus,
  

  faFaceSmileTear,
  

  faRoadBridge,
  

  faCalendarPen,
  
  faCalendarEdit,
  

  faFolderImage,
  

  faPersonHalfDress,
  

  faFileChartColumn,
  
  faFileChartLine,
  

  faSynagogue,
  

  faGlobe,
  

  faPersonDolly,
  

  faLocationCrosshairsSlash,
  
  faLocationSlash,
  

  faSteak,
  

  faBullhorn,
  

  faBoxCheck,
  

  faTamale,
  

  faHatSanta,
  

  faArrowLeftToBracket,
  

  faKey,
  

  faWavePulse,
  
  faHeartRate,
  

  faHighlighter,
  

  faSquareCaretLeft,
  
  faCaretSquareLeft,
  

  faLightSwitch,
  

  faBuildingUser,
  

  faVanShuttle,
  
  faShuttleVan,
  

  faDumpster,
  

  faArrowDownToArc,
  

  faLightEmergency,
  

  faToiletPaperUnder,
  
  faToiletPaperReverse,
  

  faSchoolCircleCheck,
  

  faComma,
  

  faSensor,
  

  faUser,
  

  faRotateReverse,
  

  faBadgePercent,
  

  faBridgeCircleExclamation,
  

  faPenClip,
  
  faPenAlt,
  

  faH3,
  

  faBowlChopsticksNoodles,
  

  faPizza,
  

  faE,
  

  faLambda,
  

  faWandMagicSparkles,
  
  faMagicWandSparkles,
  

  faGauge,
  
  faDashboard,
  
  faGaugeMed,
  
  faTachometerAltAverage,
  

  faVial,
  

  faSquareBolt,
  

  faLeafOak,
  

  faMarsStroke,
  

  faCircleParking,
  
  faParkingCircle,
  

  faCrutches,
  

  faChartSimple,
  

  faBagSeedling,
  

  faPenCircle,
  

  faRadiation,
  

  faPlaneUpSlash,
  

  faMug,
  

  faMicrochipAi,
  

  faFileWaveform,
  
  faFileMedicalAlt,
  

  faCreditCardBlank,
  

  faFaceAnxiousSweat,
  

  faFolder,
  
  faFolderBlank,
  

  faObjectsAlignTop,
  

  faFileCad,
  

  faTrashPlus,
  

  faHeadSideGear,
  

  faArrowUpFromBracket,
  

  faHandPointDown,
  

  faRaccoon,
  

  faOption,
  

  faBacon,
  

  faTrashList,
  

  faMessageCaptions,
  
  faCommentAltCaptions,
  

  faSushi,
  
  faNigiri,
  

  faBullseye,
  

  faArrowLeftToLine,
  
  faArrowToLeft,
  

  faLocationSmile,
  
  faMapMarkerSmile,
  

  faHelmetUn,
  

  faUmbrellaBeach,
  

  faBrainArrowCurvedRight,
  
  faMindShare,
  

  fa6,
  

  faCreditCardFront,
  

  faBatteryLow,
  
  faBattery1,
  

  faAlignJustify,
  

  faFanTable,
  

  faBookmark,
  

  faSemicolon,
  

  faSquareExclamation,
  
  faExclamationSquare,
  

  faTrainSubwayTunnel,
  
  faSubwayTunnel,
  

  faSquareUp,
  
  faArrowAltSquareUp,
  

  faFaceHoldingBackTears,
  

  faBowlSoftServe,
  

  faBaguette,
  

  faBarcodeRead,
  

  faArrowUpBigSmall,
  
  faSortSizeUp,
  

  faMoneyBill,
  

  faHandPointUp,
  

  faSquareJ,
  

  faBagShoppingPlus,
  

  faSquareDashed,
  

  faFaceFrownOpen,
  
  faFrownOpen,
  

  faFileVector,
  

  faTally1,
  

  faPooStorm,
  
  faPooBolt,
  

  faCapsules,
  

  faDonut,
  
  faDoughnut,
  

  faDongSign,
  

  faTemperatureHalf,
  
  faTemperature2,
  
  faThermometer2,
  
  faThermometerHalf,
  

  faCommentImage,
  

  faEscalator,
  

  faCarWash,
  

  faNotesMedical,
  

  faSlotMachine,
  

  faWineGlassCrack,
  
  faFragile,
  

  faG,
  

  faWhistle,
  

  faLinkSimple,
  

  faMonitorWaveform,
  
  faMonitorHeartRate,
  

  faQ,
  

  faHorse,
  

  faDialMed,
  

  faAngleRight,
  

  faBellOn,
  

  faFilters,
  

  faMugMarshmallows,
  

  faHorseSaddle,
  

  faJoint,
  

  faBracketRound,
  
  faParenthesis,
  

  faIgloo,
  

  faSchool,
  

  faBriefcaseBlank,
  

  faChartCandlestick,
  

  faRoadBarrier,
  

  faMortarPestle,
  

  faShieldCheck,
  

  faUserAlien,
  

  faSnowman,
  

  faWheatAwnCircleExclamation,
  

  faGunSquirt,
  

  faPiano,
  

  faPepper,
  

  faTruckMedical,
  
  faAmbulance,
  

  faApartment,
  

  faTriangle,
  

  faFileMov,
  

  faHeadSideCoughSlash,
  

  faPear,
  

  faStaffSnake,
  
  faRodAsclepius,
  
  faRodSnake,
  
  faStaffAesculapius,
  

  faSpiderBlackWidow,
  

  faCircleD,
  

  faHammerWar,
  

  faBicycle,
  

  faBangladeshiTakaSign,
  

  faCalendars,
  

  faCircleArrowUpRight,
  

  faLeafyGreen,
  

  faSquid,
  

  faSparkles,
  

  faV,
  

  faObjectsAlignBottom,
  

  faBasketballHoop,
  

  faTooth,
  

  faFaceGrinWide,
  
  faGrinAlt,
  

  faPills,
  

  faArrowDownLeftAndArrowUpRightToCenter,
  

  faHryvniaSign,
  
  faHryvnia,
  

  faI,
  

  faUserHelmetSafety,
  
  faUserConstruction,
  
  faUserHardHat,
  

  faDialHigh,
  

  faGlassEmpty,
  

  faDroneFront,
  
  faDroneAlt,
  

  faStairs,
  

  faToiletPaperUnderSlash,
  
  faToiletPaperReverseSlash,
  

  faDrawSquare,
  

  faFilePlus,
  

  faStamp,
  

  faSaltShaker,
  

  faChartMixedUpCircleDollar,
  

  faICursor,
  

  faSquareArrowUpLeft,
  

  fa5,
  

  faLandMineOn,
  

  faTricycle,
  

  faFaceZany,
  

  faSquareRss,
  
  faRssSquare,
  

  faOctagonMinus,
  
  faMinusOctagon,
  

  faDiceFive,
  

  faRoadCircleCheck,
  

  faFaceRelieved,
  

  faEclipse,
  

  faAlarmClock,
  

  faEarDeaf,
  
  faDeaf,
  
  faDeafness,
  
  faHardOfHearing,
  

  faClockThreeThirty,
  

  faFaceGrinWink,
  
  faGrinWink,
  

  faHatWitch,
  

  faCoffeeBeans,
  

  faMessageSms,
  

  faChessBishop,
  

  faSealExclamation,
  

  faGrateDroplet,
  

  faVideoArrowUpRight,
  

  faAcorn,
  

  faFlute,
  

  faRaygun,
  

  faSkeletonRibs,
  

  faThoughtBubble,
  

  faUpToDottedLine,
  

  faFaceGrinTongue,
  
  faGrinTongue,
  

  faPeriod,
  

  faBridgeCircleXmark,
  

  faFaceKiss,
  
  faKiss,
  

  faWindowFrameOpen,
  

  faLightbulbCfl,
  

  faCommentArrowDown,
  

  faCameraWeb,
  
  faWebcam,
  

  faSquareM,
  

  faFaceScream,
  

  faArrowUpSquareTriangle,
  
  faSortShapesUpAlt,
  

  faFieldHockeyStickBall,
  
  faFieldHockey,
  

  faSquare2,
  

  faSaxophone,
  

  faStopwatch,
  

  faBlinds,
  

  faCommand,
  

  faPopsicle,
  

  faBookArrowUp,
  

  faCircleMicrophone,
  
  faMicrophoneCircle,
  

  faSpiderWeb,
  

  faHandSpock,
  

  faCircleCamera,
  
  faCameraCircle,
  

  faFacePersevering,
  

  faGaugeSimpleLow,
  
  faTachometerSlow,
  

  faFaceSaluting,
  

  faChevronUp,
  

  faSquareI,
  

  faCalendarCircleExclamation,
  

  faPlug,
  

  faHouseCircleXmark,
  

  faWorm,
  

  faFaceShush,
  

  faFlaskRoundPotion,
  
  faFlaskPotion,
  

  faPi,
  

  faOm,
  

  faArrowTurnLeftDown,
  

  faFolderBookmark,
  

  faTurnRight,
  

  faPrintMagnifyingGlass,
  
  faPrintSearch,
  

  faUtensilsSlash,
  

  faPersonBikingMountain,
  
  faBikingMountain,
  

  faHand,
  
  faHandPaper,
  

  faHeadSideBrain,
  

  faCucumber,
  

  faPoliceBox,
  

  faFlaskVial,
  

  faEyeSlash,
  

  faFacePleading,
  

  faUsers,
  

  faCircleF,
  

  faRight,
  
  faArrowAltRight,
  

  faPersonRays,
  

  faReplyClock,
  
  faReplyTime,
  

  faMitten,
  

  faArrowDownZA,
  
  faSortAlphaDesc,
  
  faSortAlphaDownAlt,
  

  faBagShopping,
  
  faShoppingBag,
  

  faHandHeart,
  

  faTruckContainerEmpty,
  

  faCalendarExclamation,
  

  faSink,
  

  faSunset,
  

  faMicroscope,
  

  faHourglassHalf,
  
  faHourglass2,
  

  faCircleCalendar,
  
  faCalendarCircle,
  

  faCircleW,
  

  faHeartCircleMinus,
  

  faWaveSine,
  

  faDisplayChartUpCircleDollar,
  

  faShareNodes,
  
  faShareAlt,
  

  faKnife,
  
  faUtensilKnife,
  

  faLightbulbOn,
  

  faMessageMiddleTop,
  
  faCommentMiddleTopAlt,
  

  faCarSide,
  

  faSquareSliders,
  
  faSlidersHSquare,
  

  faPenToSquare,
  
  faEdit,
  

  faSackDollar,
  

  faCrosshairsSimple,
  

  faBridgeLock,
  

  faFolderArrowUp,
  
  faFolderUpload,
  

  faSquareSmall,
  

  faBackpack,
  

  faArrowsCross,
  

  faTree,
  

  faCommentsQuestionCheck,
  

  faHouseFloodWater,
  

  faMapLocation,
  
  faMapMarked,
  

  faBlanket,
  

  faGlobePointer,
  

  faHotTubPerson,
  
  faHotTub,
  

  faHouseNight,
  

  faRectanglePro,
  
  faPro,
  

  faMonkey,
  

  faSignalBarsSlash,
  
  faSignalAltSlash,
  

  faGasPump,
  

  faArrowDownFromLine,
  
  faArrowFromTop,
  

  faLock,
  

  faPaintbrush,
  
  faPaintBrush,
  

  faSnowBlowing,
  

  faFutbol,
  
  faFutbolBall,
  
  faSoccerBall,
  

  faJug,
  

  faFolderPlus,
  

  faCampground,
  

  faClockNineThirty,
  

  faWatchFitness,
  

  faHouseMedicalCircleXmark,
  

  faUpToLine,
  
  faArrowAltToTop,
  

  faEgg,
  

  faFaceDizzy,
  
  faDizzy,
  

  faClipboardMedical,
  

  faCircleDot,
  
  faDotCircle,
  

  faBorderCenterV,
  

  faGamepad,
  

  faCartPlus,
  

  faSquarePhoneFlip,
  
  faPhoneSquareAlt,
  

  faTreePalm,
  

  faList,
  
  faListSquares,
  

  faFilmSimple,
  
  faFilmAlt,
  

  faAbacus,
  

  faHockeySticks,
  

  faFaceAnguished,
  

  faGhost,
  

  faHeading,
  
  faHeader,
  

  faTrainTunnel,
  

  faSquareParkingSlash,
  
  faParkingSlash,
  

  faPesetaSign,
  

  faSandwich,
  

  faBookOpenCover,
  
  faBookOpenAlt,
  

  faShredder,
  

  faSquareCheck,
  
  faCheckSquare,
  

  faLuchadorMask,
  
  faLuchador,
  
  faMaskLuchador,
  

  faCommentLines,
  

  faKeySkeletonLeftRight,
  

  faAsterisk,
  

  faHandsHoldingChild,
  

  faAnkh,
  

  faWheatAwn,
  
  faWheatAlt,
  

  faCompress,
  

  faCircleN,
  

  faAlbum,
  

  faCloudSunRain,
  

  faSwords,
  

  faCommentSlash,
  

  faBoxTaped,
  
  faBoxAlt,
  

  faXmarkToSlot,
  
  faTimesToSlot,
  
  faVoteNay,
  

  faVolumeLow,
  
  faVolumeDown,
  

  faFeather,
  

  faSquareCode,
  

  faDisplayChartUp,
  

  faChartScatter3d,
  

  faHanukiah,
  

  faFaceCowboyHat,
  

  faFlag,
  

  faArrowUpToLine,
  
  faArrowToTop,
  

  faSquirrel,
  

  faFireBurner,
  

  faRoadSpikes,
  

  faFaceSleeping,
  

  faMemory,
  

  faCircleDollarToSlot,
  
  faDonate,
  

  faSpaceStationMoonConstruction,
  
  faSpaceStationMoonAlt,
  

  faPipeSection,
  

  faSitemap,
  

  faHeadphonesSimple,
  
  faHeadphonesAlt,
  

  faCloudShowersHeavy,
  

  faTemperatureList,
  

  faUnlockKeyhole,
  
  faUnlockAlt,
  

  faSidebarFlip,
  

  faCircleChevronDown,
  
  faChevronCircleDown,
  

  faFaceFrownSlight,
  

  faArrowRightFromBracket,
  
  faSignOut,
  

  faSchoolCircleXmark,
  

  faCircleExclamation,
  
  faExclamationCircle,
  

  faBlock,
  

  faTrashCanList,
  

  faCommentMiddle,
  

  faCaretLeft,
  

  faLightbulb,
  

  faPeopleRobbery,
  

  faSquareTerminal,
  

  faCassetteTape,
  

  faShieldCross,
  

  fa8,
  

  faRulerHorizontal,
  

  faCoconut,
  

  faFilm,
  

  faSickle,
  

  faRadar,
  

  faPhotoFilmMusic,
  

  faRollerCoaster,
  

  faCorn,
  

  faFaceKissBeam,
  
  faKissBeam,
  

  faSquareUpRight,
  
  faExternalLinkSquareAlt,
  

  faDropletPercent,
  
  faHumidity,
  

  faFaceBeamHandOverMouth,
  

  faHeartCrack,
  
  faHeartBroken,
  

  faHourglassEnd,
  
  faHourglass3,
  

  faPeopleGroup,
  

  faKeyboardLeft,
  

  faBars,
  
  faNavicon,
  

  faPrescriptionBottle,
  

  faSwatchbook,
  

  faRectangleVerticalHistory,
  

  faGrillFire,
  

  faJoystick,
  

  faLaptopCode,
  

  faTruckUtensils,
  

  faFileCircleQuestion,
  

  faHeartHalfStroke,
  
  faHeartHalfAlt,
  

  faSquareCaretDown,
  
  faCaretSquareDown,
  

  faCompass,
  

  faBird,
  

  faHelicopter,
  

  faSquareMinus,
  
  faMinusSquare,
  

  faHouseFire,
  

  faEmptySet,
  

  faStarAndCrescent,
  

  faReply,
  
  faMailReply,
  

  faMeat,
  

  faClover,
  

  faUsersSlash,
  

  faStarSharpHalf,
  

  faPickleball,
  

  faFaceMask,
  

  faTachographDigital,
  
  faDigitalTachograph,
  

  faMagnifyingGlassArrowRight,
  

  faSensorTriangleExclamation,
  
  faSensorAlert,
  

  faUsersMedical,
  

  faMessageImage,
  
  faCommentAltImage,
  

  faUserChef,
  

  faTable,
  

  faHyphen,
  

  faMustache,
  

  faHockeyPuck,
  

  faToiletsPortable,
  

  faSunPlantWilt,
  

  faListMusic,
  

  faScissors,
  
  faCut,
  

  faSquareCaretRight,
  
  faCaretSquareRight,
  

  faTombstone,
  

  faMarsAndVenusBurst,
  

  faFaceAngryHorns,
  

  faSignPost,
  

  faPeopleArrows,
  
  faPeopleArrowsLeftRight,
  

  faAlbumCollectionCirclePlus,
  

  faSquareRoot,
  

  faChessRookPiece,
  
  faChessRookAlt,
  

  faArrowProgress,
  

  faFileMp3,
  

  faPenRuler,
  
  faPencilRuler,
  

  faBellConcierge,
  
  faConciergeBell,
  

  faMessagePen,
  
  faCommentAltEdit,
  
  faMessageEdit,
  

  faBadge,
  

  faSunglasses,
  

  faTireFlat,
  

  faTreeChristmas,
  

  faMotorcycle,
  

  faChartBullet,
  

  faStarChristmas,
  

  faCircleC,
  

  faBoxTissue,
  

  faMicrophoneSlash,
  

  faBinoculars,
  

  faTruckRamp,
  

  faMusicSlash,
  

  faTrillium,
  

  faBrowsers,
  

  faSprinklerCeiling,
  

  faGavel,
  
  faLegal,
  

  faReflectBoth,
  

  faTrashClock,
  

  faCartCircleArrowUp,
  

  faTentArrowLeftRight,
  

  faChfSign,
  

  faMicrowave,
  

  faHospitalUser,
  

  faFaceFlushed,
  
  faFlushed,
  

  faSquare3,
  

  faTrowelBricks,
  

  faCloud,
  

  faMessageQuestion,
  

  faPaw,
  

  faTabletScreenButton,
  
  faTabletAlt,
  

  faCircleNotch,
  

  faRainbow,
  

  faEarthAfrica,
  
  faGlobeAfrica,
  

  faElephant,
  

  faSquareB,
  

  faCodePullRequestDraft,
  

  faW,
  

  faGiftCard,
  

  faTruckMonster,
  

  faScarecrow,
  

  faAlarmSnooze,
  

  faSprayCan,
  

  faShishKebab,
  

  faFaceGrinTongueSquint,
  
  faGrinTongueSquint,
  

  faArrowDown91,
  
  faSortNumericDesc,
  
  faSortNumericDownAlt,
  

  faCircleCaretDown,
  
  faCaretCircleDown,
  

  faCalendarImage,
  

  faCircleM,
  

  faDialMax,
  

  faPersonDrowning,
  

  faGrapes,
  

  faBoxArchive,
  
  faArchive,
  

  faFaceSmileHorns,
  

  faToggleOff,
  

  faDialOff,
  

  faFaceAwesome,
  
  faGaveDandy,
  

  faSquareV,
  

  faDrumstick,
  

  faBroomBall,
  
  faQuidditch,
  
  faQuidditchBroomBall,
  

  faUp,
  
  faArrowAltUp,
  

  faFence,
  

  faBlindsOpen,
  

  faWebhook,
  

  faScrollTorah,
  
  faTorah,
  

  faDownRight,
  

  faPersonArrowUpFromLine,
  

  faBowlingPins,
  

  faPencilSlash,
  

  faUserNinja,
  

  fa7,
  

  faBlog,
  

  faCircle9,
  

  faSheetPlastic,
  

  faFaceUnamused,
  

  faMessageArrowDown,
  
  faCommentAltArrowDown,
  

  faGolfFlagHole,
  

  faBookBlank,
  
  faBookAlt,
  

  faVialVirus,
  

  faCloudXmark,
  

  faUserCheck,
  

  faArrowDownToSquare,
  

  faNote,
  

  faTruckRampBox,
  
  faTruckLoading,
  

  faBlueberries,
  

  faPenField,
  

  faClipboardList,
  

  faPumpkin,
  

  faCodePullRequest,
  

  faDesktopArrowDown,
  

  faPaste,
  
  faFileClipboard,
  

  faComments,
  

  faCaretRight,
  

  faBackward,
  

  faPencil,
  
  faPencilAlt,
  

  faLips,
  

  faLandmarkFlag,
  

  faRam,
  

  faExcavator,
  

  faEggplant,
  

  faFolderGrid,
  

  faGaugeMin,
  
  faTachometerAltSlowest,
  

  faDiagramPrevious,
  

  faK,
  

  faPage,
  

  faStrikethrough,
  

  faTrees,
  

  faHandLove,
  

  faFootballHelmet,
  

  faGrid,
  
  faGrid3,
  

  faPanFrying,
  

  faAddressBook,
  
  faContactBook,
  

  faCartMinus,
  

  faPager,
  

  faMerge,
  

  faCircleH,
  
  faHospitalSymbol,
  

  faHexagonXmark,
  
  faTimesHexagon,
  
  faXmarkHexagon,
  

  faCartXmark,
  

  faBowArrow,
  

  faFileCircleExclamation,
  

  faEnvelopesBulk,
  
  faMailBulk,
  

  faJarWheat,
  

  faSpoon,
  
  faUtensilSpoon,
  

  faCheeseSwiss,
  

  faHouseBuilding,
  

  faLeafHeart,
  

  faArrowsRotateReverse,
  

  faArrowDownUpAcrossLine,
  

  faSpaghettiMonsterFlying,
  
  faPastafarianism,
  

  faTruckFlatbed,
  

  faClarinet,
  

  faBong,
  

  faCameraMovie,
  

  faSigma,
  

  faFaceGrinStars,
  
  faGrinStars,
  

  faSquareP,
  

  faBringForward,
  

  faRecordVinyl,
  

  faTruckPlane,
  

  faCircleHeart,
  
  faHeartCircle,
  

  faChevronsLeft,
  
  faChevronDoubleLeft,
  

  faUnion,
  

  faMenorah,
  

  faFileCsv,
  

  faLaptop,
  

  faPerson,
  
  faMale,
  

  faFireFlameSimple,
  
  faBurn,
  

  faPersonCarryBox,
  
  faPersonCarry,
  

  faArrowUpLong,
  
  faLongArrowUp,
  

  faCalendarCircleUser,
  

  faTransporter,
  

  faDiagramPredecessor,
  

  faCrateEmpty,
  

  faBeerMugEmpty,
  
  faBeer,
  

  faPeopleLine,
  

  faLightbulbExclamationOn,
  

  faLocationPlus,
  
  faMapMarkerPlus,
  

  faSquareArrowRight,
  
  faArrowSquareRight,
  

  faPeopleRoof,
  

  faUsersRectangle,
  

  faAnglesDown,
  
  faAngleDoubleDown,
  

  faCrop,
  

  faSchoolCircleExclamation,
  

  faUserVneck,
  

  faFootball,
  
  faFootballBall,
  

  faChevronsUp,
  
  faChevronDoubleUp,
  

  faFlagCheckered,
  

  faUtilityPoleDouble,
  

  faBuildingMemo,
  

  faSquareX,
  

  faBowlScoop,
  
  faBowlShavedIce,
  

  faMessageExclamation,
  
  faCommentAltExclamation,
  

  faLightCeiling,
  

  faFaceSmileBeam,
  
  faSmileBeam,
  

  faForwardStep,
  
  faStepForward,
  

  faMessageBot,
  

  faMagnifyingGlassLocation,
  
  faSearchLocation,
  

  faHandPointRight,
  

  faH1,
  

  faStandardDefinition,
  
  faRectangleSd,
  

  faSkiBoot,
  

  faFingerprint,
  

  faPumpMedical,
  

  faLocationMinus,
  
  faMapMarkerMinus,
  

  faSlidersUp,
  
  faSlidersV,
  

  faBridgeCircleCheck,
  

  faCalculatorSimple,
  
  faCalculatorAlt,
  

  faClosedCaptioningSlash,
  

  faMicrophoneLinesSlash,
  
  faMicrophoneAltSlash,
  

  faIcons,
  
  faHeartMusicCameraBolt,
  

  faSoap,
  

  faAtom,
  

  faNfc,
  

  faFaceGlasses,
  

  faRightFromBracket,
  
  faSignOutAlt,
  

  faFilms,
  

  faDoorOpen,
  

  faShovel,
  

  faFaceIcicles,
  

  faCircleMinus,
  
  faMinusCircle,
  

  faFolderArrowDown,
  
  faFolderDownload,
  

  faSortDown,
  
  faSortDesc,
  

  faBarcodeScan,
  

  faMobileSignal,
  

  faArrowsUpToLine,
  

  faFork,
  
  faUtensilFork,
  

  faUfo,
  

  faTextSize,
  

  faSunHaze,
  

  faVolleyball,
  
  faVolleyballBall,
  

  faBuildingCircleArrowRight,
  

  faRectangleHistory,
  

  faTally4,
  

  faAnchorCircleCheck,
  

  faMp3Player,
  

  faCalendarDays,
  
  faCalendarAlt,
  

  faWifiFair,
  
  faWifi2,
  

  faTirePressureWarning,
  

  faDiceThree,
  

  faBuildingUn,
  

  faRing,
  

  faWaveSquare,
  

  faFileLines,
  
  faFileAlt,
  
  faFileText,
  

  faExplosion,
  

  faDownLeftAndUpRightToCenter,
  
  faCompressAlt,
  

  faSquareUser,
  

  faFaceHandPeeking,
  

  faTheta,
  

  faFonduePot,
  

  faRingDiamond,
  

  faRobotAstromech,
  

  faInfo,
  

  faSalad,
  
  faBowlSalad,
  

  faMessage,
  
  faCommentAlt,
  

  faCoffin,
  

  faStethoscope,
  

  faGaugeSimpleMin,
  
  faTachometerSlowest,
  

  faFaceHandYawn,
  

  faUserXmark,
  
  faUserTimes,
  

  faTextHeight,
  

  faHeadSideGoggles,
  
  faHeadVr,
  

  faCircleL,
  

  faTrashCan,
  
  faTrashAlt,
  

  faPhoneArrowUpRight,
  
  faPhoneArrowUp,
  
  faPhoneOutgoing,
  

  faRectanglesMixed,
  

  faAt,
  

  faTransporter7,
  

  faBagel,
  

  faLineHeight,
  

  faWagonCovered,
  

  faCircleChevronRight,
  
  faChevronCircleRight,
  

  faArrowsToCircle,
  

  faFillDrip,
  

};
